
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9099"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9099"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("denZA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6Kyqa"));

});
parcelRegister("6Kyqa", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4ea1bd448ef42807$export$dca3b0875bd9a954; }, function (v) { return $4ea1bd448ef42807$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4ea1bd448ef42807$export$16fa2f45be04daa8; }, function (v) { return $4ea1bd448ef42807$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4ea1bd448ef42807$export$ffb0004e005737fa; }, function (v) { return $4ea1bd448ef42807$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4ea1bd448ef42807$export$e2c29f18771995cb; }, function (v) { return $4ea1bd448ef42807$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4ea1bd448ef42807$export$221d75b3f55bb0bd; }, function (v) { return $4ea1bd448ef42807$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4ea1bd448ef42807$export$5f8d39834fd61797; }, function (v) { return $4ea1bd448ef42807$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4ea1bd448ef42807$export$74bf444e3cd11ea5; }, function (v) { return $4ea1bd448ef42807$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4ea1bd448ef42807$export$ae55be85d98224ed; }, function (v) { return $4ea1bd448ef42807$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4ea1bd448ef42807$export$e530037191fcd5d7; }, function (v) { return $4ea1bd448ef42807$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4ea1bd448ef42807$export$fd42f52fd3ae1109; }, function (v) { return $4ea1bd448ef42807$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4ea1bd448ef42807$export$c8a8987d4410bf2d; }, function (v) { return $4ea1bd448ef42807$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4ea1bd448ef42807$export$d38cd72104c1f0e9; }, function (v) { return $4ea1bd448ef42807$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4ea1bd448ef42807$export$7d1e3a5e95ceca43; }, function (v) { return $4ea1bd448ef42807$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4ea1bd448ef42807$export$257a8862b851cb5b; }, function (v) { return $4ea1bd448ef42807$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4ea1bd448ef42807$export$a8257692ac88316c; }, function (v) { return $4ea1bd448ef42807$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4ea1bd448ef42807$export$488013bae63b21da; }, function (v) { return $4ea1bd448ef42807$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4ea1bd448ef42807$export$7c73462e0d25e514; }, function (v) { return $4ea1bd448ef42807$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4ea1bd448ef42807$export$35808ee640e87ca7; }, function (v) { return $4ea1bd448ef42807$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4ea1bd448ef42807$export$fae74005e78b1a27; }, function (v) { return $4ea1bd448ef42807$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4ea1bd448ef42807$export$dc8fbce3eb94dc1e; }, function (v) { return $4ea1bd448ef42807$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $4ea1bd448ef42807$export$6d9c69b0de29b591; }, function (v) { return $4ea1bd448ef42807$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4ea1bd448ef42807$export$d5a552a76deda3c2; }, function (v) { return $4ea1bd448ef42807$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4ea1bd448ef42807$export$e5c5a5f917a5871c; }, function (v) { return $4ea1bd448ef42807$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4ea1bd448ef42807$export$1538c33de8887b59; }, function (v) { return $4ea1bd448ef42807$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4ea1bd448ef42807$export$13e3392192263954; }, function (v) { return $4ea1bd448ef42807$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4ea1bd448ef42807$export$b8f5890fc79d6aca; }, function (v) { return $4ea1bd448ef42807$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4ea1bd448ef42807$export$60241385465d0a34; }, function (v) { return $4ea1bd448ef42807$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $4ea1bd448ef42807$export$83d89fbfd8236492; }, function (v) { return $4ea1bd448ef42807$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ea1bd448ef42807$export$dca3b0875bd9a954;
var $4ea1bd448ef42807$export$16fa2f45be04daa8;
var $4ea1bd448ef42807$export$ffb0004e005737fa;
var $4ea1bd448ef42807$export$e2c29f18771995cb;
var $4ea1bd448ef42807$export$221d75b3f55bb0bd;
var $4ea1bd448ef42807$export$5f8d39834fd61797;
var $4ea1bd448ef42807$export$74bf444e3cd11ea5;
var $4ea1bd448ef42807$export$ae55be85d98224ed;
var $4ea1bd448ef42807$export$e530037191fcd5d7;
var $4ea1bd448ef42807$export$fd42f52fd3ae1109;
var $4ea1bd448ef42807$export$c8a8987d4410bf2d;
var $4ea1bd448ef42807$export$d38cd72104c1f0e9;
var $4ea1bd448ef42807$export$7d1e3a5e95ceca43;
var $4ea1bd448ef42807$export$257a8862b851cb5b;
var $4ea1bd448ef42807$export$a8257692ac88316c;
var $4ea1bd448ef42807$export$488013bae63b21da;
var $4ea1bd448ef42807$export$7c73462e0d25e514;
var $4ea1bd448ef42807$export$35808ee640e87ca7;
var $4ea1bd448ef42807$export$fae74005e78b1a27;
var $4ea1bd448ef42807$export$dc8fbce3eb94dc1e;
var $4ea1bd448ef42807$export$6d9c69b0de29b591;
var $4ea1bd448ef42807$export$d5a552a76deda3c2;
var $4ea1bd448ef42807$export$e5c5a5f917a5871c;
var $4ea1bd448ef42807$export$1538c33de8887b59;
var $4ea1bd448ef42807$export$13e3392192263954;
var $4ea1bd448ef42807$export$b8f5890fc79d6aca;
var $4ea1bd448ef42807$export$60241385465d0a34;
var $4ea1bd448ef42807$export$83d89fbfd8236492;
'use strict';

var $cYrgI = parcelRequire("cYrgI");
var $4ea1bd448ef42807$var$n = "function" === typeof Symbol && Symbol.for, $4ea1bd448ef42807$var$p = $4ea1bd448ef42807$var$n ? Symbol.for("react.element") : 60103, $4ea1bd448ef42807$var$q = $4ea1bd448ef42807$var$n ? Symbol.for("react.portal") : 60106, $4ea1bd448ef42807$var$r = $4ea1bd448ef42807$var$n ? Symbol.for("react.fragment") : 60107, $4ea1bd448ef42807$var$t = $4ea1bd448ef42807$var$n ? Symbol.for("react.strict_mode") : 60108, $4ea1bd448ef42807$var$u = $4ea1bd448ef42807$var$n ? Symbol.for("react.profiler") : 60114, $4ea1bd448ef42807$var$v = $4ea1bd448ef42807$var$n ? Symbol.for("react.provider") : 60109, $4ea1bd448ef42807$var$w = $4ea1bd448ef42807$var$n ? Symbol.for("react.context") : 60110, $4ea1bd448ef42807$var$x = $4ea1bd448ef42807$var$n ? Symbol.for("react.forward_ref") : 60112, $4ea1bd448ef42807$var$y = $4ea1bd448ef42807$var$n ? Symbol.for("react.suspense") : 60113, $4ea1bd448ef42807$var$z = $4ea1bd448ef42807$var$n ? Symbol.for("react.memo") : 60115, $4ea1bd448ef42807$var$A = $4ea1bd448ef42807$var$n ? Symbol.for("react.lazy") : 60116, $4ea1bd448ef42807$var$B = "function" === typeof Symbol && Symbol.iterator;
function $4ea1bd448ef42807$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4ea1bd448ef42807$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4ea1bd448ef42807$var$E = {};
function $4ea1bd448ef42807$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4ea1bd448ef42807$var$E;
    this.updater = c || $4ea1bd448ef42807$var$D;
}
$4ea1bd448ef42807$var$F.prototype.isReactComponent = {};
$4ea1bd448ef42807$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($4ea1bd448ef42807$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4ea1bd448ef42807$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4ea1bd448ef42807$var$G() {}
$4ea1bd448ef42807$var$G.prototype = $4ea1bd448ef42807$var$F.prototype;
function $4ea1bd448ef42807$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $4ea1bd448ef42807$var$E;
    this.updater = c || $4ea1bd448ef42807$var$D;
}
var $4ea1bd448ef42807$var$I = $4ea1bd448ef42807$var$H.prototype = new $4ea1bd448ef42807$var$G;
$4ea1bd448ef42807$var$I.constructor = $4ea1bd448ef42807$var$H;
$cYrgI($4ea1bd448ef42807$var$I, $4ea1bd448ef42807$var$F.prototype);
$4ea1bd448ef42807$var$I.isPureReactComponent = !0;
var $4ea1bd448ef42807$var$J = {
    current: null
}, $4ea1bd448ef42807$var$K = Object.prototype.hasOwnProperty, $4ea1bd448ef42807$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4ea1bd448ef42807$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$4ea1bd448ef42807$var$K.call(b, e) && !$4ea1bd448ef42807$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $4ea1bd448ef42807$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $4ea1bd448ef42807$var$J.current
    };
}
function $4ea1bd448ef42807$var$N(a, b) {
    return {
        $$typeof: $4ea1bd448ef42807$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4ea1bd448ef42807$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4ea1bd448ef42807$var$p;
}
function $4ea1bd448ef42807$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4ea1bd448ef42807$var$P = /\/+/g, $4ea1bd448ef42807$var$Q = [];
function $4ea1bd448ef42807$var$R(a, b, c, e) {
    if ($4ea1bd448ef42807$var$Q.length) {
        var d = $4ea1bd448ef42807$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $4ea1bd448ef42807$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $4ea1bd448ef42807$var$Q.length && $4ea1bd448ef42807$var$Q.push(a);
}
function $4ea1bd448ef42807$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4ea1bd448ef42807$var$p:
                case $4ea1bd448ef42807$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $4ea1bd448ef42807$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $4ea1bd448ef42807$var$U(d, k);
        g += $4ea1bd448ef42807$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $4ea1bd448ef42807$var$B && a[$4ea1bd448ef42807$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $4ea1bd448ef42807$var$U(d, k++), g += $4ea1bd448ef42807$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($4ea1bd448ef42807$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $4ea1bd448ef42807$var$V(a, b, c) {
    return null == a ? 0 : $4ea1bd448ef42807$var$T(a, "", b, c);
}
function $4ea1bd448ef42807$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4ea1bd448ef42807$var$escape(a.key) : b.toString(36);
}
function $4ea1bd448ef42807$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $4ea1bd448ef42807$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $4ea1bd448ef42807$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($4ea1bd448ef42807$var$O(a) && (a = $4ea1bd448ef42807$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($4ea1bd448ef42807$var$P, "$&/") + "/") + c)), e.push(a));
}
function $4ea1bd448ef42807$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($4ea1bd448ef42807$var$P, "$&/") + "/");
    b = $4ea1bd448ef42807$var$R(b, g, e, d);
    $4ea1bd448ef42807$var$V(a, $4ea1bd448ef42807$var$aa, b);
    $4ea1bd448ef42807$var$S(b);
}
var $4ea1bd448ef42807$var$Y = {
    current: null
};
function $4ea1bd448ef42807$var$Z() {
    var a = $4ea1bd448ef42807$var$Y.current;
    if (null === a) throw Error($4ea1bd448ef42807$var$C(321));
    return a;
}
var $4ea1bd448ef42807$var$ba = {
    ReactCurrentDispatcher: $4ea1bd448ef42807$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $4ea1bd448ef42807$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $cYrgI
};
$4ea1bd448ef42807$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $4ea1bd448ef42807$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $4ea1bd448ef42807$var$R(null, null, b, c);
        $4ea1bd448ef42807$var$V(a, $4ea1bd448ef42807$var$W, b);
        $4ea1bd448ef42807$var$S(b);
    },
    count: function(a) {
        return $4ea1bd448ef42807$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $4ea1bd448ef42807$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$4ea1bd448ef42807$var$O(a)) throw Error($4ea1bd448ef42807$var$C(143));
        return a;
    }
};
$4ea1bd448ef42807$export$16fa2f45be04daa8 = $4ea1bd448ef42807$var$F;
$4ea1bd448ef42807$export$ffb0004e005737fa = $4ea1bd448ef42807$var$r;
$4ea1bd448ef42807$export$e2c29f18771995cb = $4ea1bd448ef42807$var$u;
$4ea1bd448ef42807$export$221d75b3f55bb0bd = $4ea1bd448ef42807$var$H;
$4ea1bd448ef42807$export$5f8d39834fd61797 = $4ea1bd448ef42807$var$t;
$4ea1bd448ef42807$export$74bf444e3cd11ea5 = $4ea1bd448ef42807$var$y;
$4ea1bd448ef42807$export$ae55be85d98224ed = $4ea1bd448ef42807$var$ba;
$4ea1bd448ef42807$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($4ea1bd448ef42807$var$C(267, a));
    var e = $cYrgI({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $4ea1bd448ef42807$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$4ea1bd448ef42807$var$K.call(b, h) && !$4ea1bd448ef42807$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $4ea1bd448ef42807$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$4ea1bd448ef42807$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $4ea1bd448ef42807$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $4ea1bd448ef42807$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$4ea1bd448ef42807$export$c8a8987d4410bf2d = $4ea1bd448ef42807$var$M;
$4ea1bd448ef42807$export$d38cd72104c1f0e9 = function(a) {
    var b = $4ea1bd448ef42807$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4ea1bd448ef42807$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4ea1bd448ef42807$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4ea1bd448ef42807$var$x,
        render: a
    };
};
$4ea1bd448ef42807$export$a8257692ac88316c = $4ea1bd448ef42807$var$O;
$4ea1bd448ef42807$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4ea1bd448ef42807$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$4ea1bd448ef42807$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4ea1bd448ef42807$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4ea1bd448ef42807$export$35808ee640e87ca7 = function(a, b) {
    return $4ea1bd448ef42807$var$Z().useCallback(a, b);
};
$4ea1bd448ef42807$export$fae74005e78b1a27 = function(a, b) {
    return $4ea1bd448ef42807$var$Z().useContext(a, b);
};
$4ea1bd448ef42807$export$dc8fbce3eb94dc1e = function() {};
$4ea1bd448ef42807$export$6d9c69b0de29b591 = function(a, b) {
    return $4ea1bd448ef42807$var$Z().useEffect(a, b);
};
$4ea1bd448ef42807$export$d5a552a76deda3c2 = function(a, b, c) {
    return $4ea1bd448ef42807$var$Z().useImperativeHandle(a, b, c);
};
$4ea1bd448ef42807$export$e5c5a5f917a5871c = function(a, b) {
    return $4ea1bd448ef42807$var$Z().useLayoutEffect(a, b);
};
$4ea1bd448ef42807$export$1538c33de8887b59 = function(a, b) {
    return $4ea1bd448ef42807$var$Z().useMemo(a, b);
};
$4ea1bd448ef42807$export$13e3392192263954 = function(a, b, c) {
    return $4ea1bd448ef42807$var$Z().useReducer(a, b, c);
};
$4ea1bd448ef42807$export$b8f5890fc79d6aca = function(a) {
    return $4ea1bd448ef42807$var$Z().useRef(a);
};
$4ea1bd448ef42807$export$60241385465d0a34 = function(a) {
    return $4ea1bd448ef42807$var$Z().useState(a);
};
$4ea1bd448ef42807$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("cYrgI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $97203d9ef05f927d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $97203d9ef05f927d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $97203d9ef05f927d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $97203d9ef05f927d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $97203d9ef05f927d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $97203d9ef05f927d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $97203d9ef05f927d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($97203d9ef05f927d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($97203d9ef05f927d$var$getOwnPropertySymbols) {
            symbols = $97203d9ef05f927d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($97203d9ef05f927d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("kzTA8", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $efb230e77335f835$export$2b8d127b894957b9; }, function (v) { return $efb230e77335f835$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $efb230e77335f835$export$cea3a54a6425200c; }, function (v) { return $efb230e77335f835$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $efb230e77335f835$export$a7c73072b1a182ae; }, function (v) { return $efb230e77335f835$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $efb230e77335f835$export$9f27bc3417b4524d; }, function (v) { return $efb230e77335f835$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $efb230e77335f835$export$db77ccec0bb4ccac; }, function (v) { return $efb230e77335f835$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $efb230e77335f835$export$8392c0c9d3dcbd35; }, function (v) { return $efb230e77335f835$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $efb230e77335f835$export$ffb0004e005737fa; }, function (v) { return $efb230e77335f835$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $efb230e77335f835$export$b624eff549462981; }, function (v) { return $efb230e77335f835$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $efb230e77335f835$export$7897aa7841a5380c; }, function (v) { return $efb230e77335f835$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $efb230e77335f835$export$602eac185826482c; }, function (v) { return $efb230e77335f835$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $efb230e77335f835$export$e2c29f18771995cb; }, function (v) { return $efb230e77335f835$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $efb230e77335f835$export$5f8d39834fd61797; }, function (v) { return $efb230e77335f835$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $efb230e77335f835$export$74bf444e3cd11ea5; }, function (v) { return $efb230e77335f835$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $efb230e77335f835$export$92387174baf9b227; }, function (v) { return $efb230e77335f835$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $efb230e77335f835$export$ec112efeb987d9c6; }, function (v) { return $efb230e77335f835$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $efb230e77335f835$export$b706b080d889d2c9; }, function (v) { return $efb230e77335f835$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $efb230e77335f835$export$5be5a87408f70ddc; }, function (v) { return $efb230e77335f835$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $efb230e77335f835$export$45a5e7f76e0caa8d; }, function (v) { return $efb230e77335f835$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $efb230e77335f835$export$455c2e768291efa6; }, function (v) { return $efb230e77335f835$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $efb230e77335f835$export$9522e17588c12572; }, function (v) { return $efb230e77335f835$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $efb230e77335f835$export$2110ac352bb060b9; }, function (v) { return $efb230e77335f835$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $efb230e77335f835$export$56885ab8b9c456ab; }, function (v) { return $efb230e77335f835$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $efb230e77335f835$export$d927fcb6adf8f9de; }, function (v) { return $efb230e77335f835$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $efb230e77335f835$export$b82d16f27459e05a; }, function (v) { return $efb230e77335f835$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $efb230e77335f835$export$522c17b4f5e123e8; }, function (v) { return $efb230e77335f835$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $efb230e77335f835$export$1aabd8a0274ecfd6; }, function (v) { return $efb230e77335f835$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $efb230e77335f835$export$9b621391a187a31a; }, function (v) { return $efb230e77335f835$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $efb230e77335f835$export$f5bbd400c2f4426f; }, function (v) { return $efb230e77335f835$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $efb230e77335f835$export$2b8d127b894957b9;
var $efb230e77335f835$export$cea3a54a6425200c;
var $efb230e77335f835$export$a7c73072b1a182ae;
var $efb230e77335f835$export$9f27bc3417b4524d;
var $efb230e77335f835$export$db77ccec0bb4ccac;
var $efb230e77335f835$export$8392c0c9d3dcbd35;
var $efb230e77335f835$export$ffb0004e005737fa;
var $efb230e77335f835$export$b624eff549462981;
var $efb230e77335f835$export$7897aa7841a5380c;
var $efb230e77335f835$export$602eac185826482c;
var $efb230e77335f835$export$e2c29f18771995cb;
var $efb230e77335f835$export$5f8d39834fd61797;
var $efb230e77335f835$export$74bf444e3cd11ea5;
var $efb230e77335f835$export$92387174baf9b227;
var $efb230e77335f835$export$ec112efeb987d9c6;
var $efb230e77335f835$export$b706b080d889d2c9;
var $efb230e77335f835$export$5be5a87408f70ddc;
var $efb230e77335f835$export$45a5e7f76e0caa8d;
var $efb230e77335f835$export$455c2e768291efa6;
var $efb230e77335f835$export$9522e17588c12572;
var $efb230e77335f835$export$2110ac352bb060b9;
var $efb230e77335f835$export$56885ab8b9c456ab;
var $efb230e77335f835$export$d927fcb6adf8f9de;
var $efb230e77335f835$export$b82d16f27459e05a;
var $efb230e77335f835$export$522c17b4f5e123e8;
var $efb230e77335f835$export$1aabd8a0274ecfd6;
var $efb230e77335f835$export$9b621391a187a31a;
var $efb230e77335f835$export$f5bbd400c2f4426f;
'use strict';
var $efb230e77335f835$var$b = "function" === typeof Symbol && Symbol.for, $efb230e77335f835$var$c = $efb230e77335f835$var$b ? Symbol.for("react.element") : 60103, $efb230e77335f835$var$d = $efb230e77335f835$var$b ? Symbol.for("react.portal") : 60106, $efb230e77335f835$var$e = $efb230e77335f835$var$b ? Symbol.for("react.fragment") : 60107, $efb230e77335f835$var$f = $efb230e77335f835$var$b ? Symbol.for("react.strict_mode") : 60108, $efb230e77335f835$var$g = $efb230e77335f835$var$b ? Symbol.for("react.profiler") : 60114, $efb230e77335f835$var$h = $efb230e77335f835$var$b ? Symbol.for("react.provider") : 60109, $efb230e77335f835$var$k = $efb230e77335f835$var$b ? Symbol.for("react.context") : 60110, $efb230e77335f835$var$l = $efb230e77335f835$var$b ? Symbol.for("react.async_mode") : 60111, $efb230e77335f835$var$m = $efb230e77335f835$var$b ? Symbol.for("react.concurrent_mode") : 60111, $efb230e77335f835$var$n = $efb230e77335f835$var$b ? Symbol.for("react.forward_ref") : 60112, $efb230e77335f835$var$p = $efb230e77335f835$var$b ? Symbol.for("react.suspense") : 60113, $efb230e77335f835$var$q = $efb230e77335f835$var$b ? Symbol.for("react.suspense_list") : 60120, $efb230e77335f835$var$r = $efb230e77335f835$var$b ? Symbol.for("react.memo") : 60115, $efb230e77335f835$var$t = $efb230e77335f835$var$b ? Symbol.for("react.lazy") : 60116, $efb230e77335f835$var$v = $efb230e77335f835$var$b ? Symbol.for("react.block") : 60121, $efb230e77335f835$var$w = $efb230e77335f835$var$b ? Symbol.for("react.fundamental") : 60117, $efb230e77335f835$var$x = $efb230e77335f835$var$b ? Symbol.for("react.responder") : 60118, $efb230e77335f835$var$y = $efb230e77335f835$var$b ? Symbol.for("react.scope") : 60119;
function $efb230e77335f835$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $efb230e77335f835$var$c:
                switch(a = a.type, a){
                    case $efb230e77335f835$var$l:
                    case $efb230e77335f835$var$m:
                    case $efb230e77335f835$var$e:
                    case $efb230e77335f835$var$g:
                    case $efb230e77335f835$var$f:
                    case $efb230e77335f835$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $efb230e77335f835$var$k:
                            case $efb230e77335f835$var$n:
                            case $efb230e77335f835$var$t:
                            case $efb230e77335f835$var$r:
                            case $efb230e77335f835$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $efb230e77335f835$var$d:
                return u;
        }
    }
}
function $efb230e77335f835$var$A(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$m;
}
$efb230e77335f835$export$2b8d127b894957b9 = $efb230e77335f835$var$l;
$efb230e77335f835$export$cea3a54a6425200c = $efb230e77335f835$var$m;
$efb230e77335f835$export$a7c73072b1a182ae = $efb230e77335f835$var$k;
$efb230e77335f835$export$9f27bc3417b4524d = $efb230e77335f835$var$h;
$efb230e77335f835$export$db77ccec0bb4ccac = $efb230e77335f835$var$c;
$efb230e77335f835$export$8392c0c9d3dcbd35 = $efb230e77335f835$var$n;
$efb230e77335f835$export$ffb0004e005737fa = $efb230e77335f835$var$e;
$efb230e77335f835$export$b624eff549462981 = $efb230e77335f835$var$t;
$efb230e77335f835$export$7897aa7841a5380c = $efb230e77335f835$var$r;
$efb230e77335f835$export$602eac185826482c = $efb230e77335f835$var$d;
$efb230e77335f835$export$e2c29f18771995cb = $efb230e77335f835$var$g;
$efb230e77335f835$export$5f8d39834fd61797 = $efb230e77335f835$var$f;
$efb230e77335f835$export$74bf444e3cd11ea5 = $efb230e77335f835$var$p;
$efb230e77335f835$export$92387174baf9b227 = function(a) {
    return $efb230e77335f835$var$A(a) || $efb230e77335f835$var$z(a) === $efb230e77335f835$var$l;
};
$efb230e77335f835$export$ec112efeb987d9c6 = $efb230e77335f835$var$A;
$efb230e77335f835$export$b706b080d889d2c9 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$k;
};
$efb230e77335f835$export$5be5a87408f70ddc = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$h;
};
$efb230e77335f835$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $efb230e77335f835$var$c;
};
$efb230e77335f835$export$455c2e768291efa6 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$n;
};
$efb230e77335f835$export$9522e17588c12572 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$e;
};
$efb230e77335f835$export$2110ac352bb060b9 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$t;
};
$efb230e77335f835$export$56885ab8b9c456ab = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$r;
};
$efb230e77335f835$export$d927fcb6adf8f9de = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$d;
};
$efb230e77335f835$export$b82d16f27459e05a = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$g;
};
$efb230e77335f835$export$522c17b4f5e123e8 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$f;
};
$efb230e77335f835$export$1aabd8a0274ecfd6 = function(a) {
    return $efb230e77335f835$var$z(a) === $efb230e77335f835$var$p;
};
$efb230e77335f835$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $efb230e77335f835$var$e || a === $efb230e77335f835$var$m || a === $efb230e77335f835$var$g || a === $efb230e77335f835$var$f || a === $efb230e77335f835$var$p || a === $efb230e77335f835$var$q || "object" === typeof a && null !== a && (a.$$typeof === $efb230e77335f835$var$t || a.$$typeof === $efb230e77335f835$var$r || a.$$typeof === $efb230e77335f835$var$h || a.$$typeof === $efb230e77335f835$var$k || a.$$typeof === $efb230e77335f835$var$n || a.$$typeof === $efb230e77335f835$var$w || a.$$typeof === $efb230e77335f835$var$x || a.$$typeof === $efb230e77335f835$var$y || a.$$typeof === $efb230e77335f835$var$v);
};
$efb230e77335f835$export$f5bbd400c2f4426f = $efb230e77335f835$var$z;

});

parcelRegister("1Gy4F", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $13a425228cff73d7$export$ffb0004e005737fa; }, function (v) { return $13a425228cff73d7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $13a425228cff73d7$export$34b9dba7ce09269b; }, function (v) { return $13a425228cff73d7$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $13a425228cff73d7$export$25062201e9e25d76; }, function (v) { return $13a425228cff73d7$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $13a425228cff73d7$export$ffb0004e005737fa;
var $13a425228cff73d7$export$34b9dba7ce09269b;
var $13a425228cff73d7$export$25062201e9e25d76;
'use strict';

var $denZA = parcelRequire("denZA");
var $13a425228cff73d7$var$g = 60103;
$13a425228cff73d7$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $13a425228cff73d7$var$h = Symbol.for;
    $13a425228cff73d7$var$g = $13a425228cff73d7$var$h("react.element");
    $13a425228cff73d7$export$ffb0004e005737fa = $13a425228cff73d7$var$h("react.fragment");
}
var $13a425228cff73d7$var$m = $denZA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $13a425228cff73d7$var$n = Object.prototype.hasOwnProperty, $13a425228cff73d7$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $13a425228cff73d7$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$13a425228cff73d7$var$n.call(a, b) && !$13a425228cff73d7$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $13a425228cff73d7$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $13a425228cff73d7$var$m.current
    };
}
$13a425228cff73d7$export$34b9dba7ce09269b = $13a425228cff73d7$var$q;
$13a425228cff73d7$export$25062201e9e25d76 = $13a425228cff73d7$var$q;

});

parcelRegister("hguJr", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $denZA = parcelRequire("denZA");

var $cYrgI = parcelRequire("cYrgI");

var $6YFtO = parcelRequire("6YFtO");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$denZA) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $denZA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $cYrgI({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $denZA.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $cYrgI({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $cYrgI({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $6YFtO.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $6YFtO.unstable_scheduleCallback($6YFtO.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $6YFtO.unstable_UserBlockingPriority, ed = $6YFtO.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $cYrgI({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$cYrgI(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $cYrgI(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $cYrgI({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $cYrgI({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $6YFtO.unstable_runWithPriority, Jf = $6YFtO.unstable_scheduleCallback, Kf = $6YFtO.unstable_cancelCallback, Lf = $6YFtO.unstable_requestPaint, Mf = $6YFtO.unstable_now, Nf = $6YFtO.unstable_getCurrentPriorityLevel, Of = $6YFtO.unstable_ImmediatePriority, Pf = $6YFtO.unstable_UserBlockingPriority, Qf = $6YFtO.unstable_NormalPriority, Rf = $6YFtO.unstable_LowPriority, Sf = $6YFtO.unstable_IdlePriority, Tf = {}, Uf = $6YFtO.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $cYrgI({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $cYrgI({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $denZA.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $cYrgI({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $cYrgI({}, f, {
                    value: void 0
                });
                d = $cYrgI({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $cYrgI({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($cYrgI({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("6YFtO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ipbjp"));

});
parcelRegister("ipbjp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d663562512cc6eb5$export$c4744153514ff05d; }, function (v) { return $d663562512cc6eb5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d663562512cc6eb5$export$d66a1c1c77bd778b; }, function (v) { return $d663562512cc6eb5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d663562512cc6eb5$export$3e506c1ccc9cc1a7; }, function (v) { return $d663562512cc6eb5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d663562512cc6eb5$export$e26fe2ed2fa76875; }, function (v) { return $d663562512cc6eb5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d663562512cc6eb5$export$502329bbf4b505b1; }, function (v) { return $d663562512cc6eb5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d663562512cc6eb5$export$6e3807111c4874c4; }, function (v) { return $d663562512cc6eb5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d663562512cc6eb5$export$c27134553091fb3a; }, function (v) { return $d663562512cc6eb5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d663562512cc6eb5$export$33ee1acdc04fd2a2; }, function (v) { return $d663562512cc6eb5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d663562512cc6eb5$export$b00a404bbd5edef2; }, function (v) { return $d663562512cc6eb5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d663562512cc6eb5$export$8352ce38b91d0c62; }, function (v) { return $d663562512cc6eb5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d663562512cc6eb5$export$d3dfb8e4810cb555; }, function (v) { return $d663562512cc6eb5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d663562512cc6eb5$export$839f9183b0465a69; }, function (v) { return $d663562512cc6eb5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d663562512cc6eb5$export$72fdf0e06517287b; }, function (v) { return $d663562512cc6eb5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d663562512cc6eb5$export$4b844e58a3e414b4; }, function (v) { return $d663562512cc6eb5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d663562512cc6eb5$export$816d2913ae6b83b1; }, function (v) { return $d663562512cc6eb5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d663562512cc6eb5$export$61bcfe829111a1d0; }, function (v) { return $d663562512cc6eb5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d663562512cc6eb5$export$7ee8c9beb337bc3f; }, function (v) { return $d663562512cc6eb5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d663562512cc6eb5$export$b5836b71941fa3ed; }, function (v) { return $d663562512cc6eb5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d663562512cc6eb5$export$cf845f2c119da08a; }, function (v) { return $d663562512cc6eb5$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d663562512cc6eb5$export$c4744153514ff05d;
var $d663562512cc6eb5$export$d66a1c1c77bd778b;
var $d663562512cc6eb5$export$3e506c1ccc9cc1a7;
var $d663562512cc6eb5$export$e26fe2ed2fa76875;
var $d663562512cc6eb5$export$502329bbf4b505b1;
var $d663562512cc6eb5$export$6e3807111c4874c4;
var $d663562512cc6eb5$export$c27134553091fb3a;
var $d663562512cc6eb5$export$33ee1acdc04fd2a2;
var $d663562512cc6eb5$export$b00a404bbd5edef2;
var $d663562512cc6eb5$export$8352ce38b91d0c62;
var $d663562512cc6eb5$export$d3dfb8e4810cb555;
var $d663562512cc6eb5$export$839f9183b0465a69;
var $d663562512cc6eb5$export$72fdf0e06517287b;
var $d663562512cc6eb5$export$4b844e58a3e414b4;
var $d663562512cc6eb5$export$816d2913ae6b83b1;
var $d663562512cc6eb5$export$61bcfe829111a1d0;
var $d663562512cc6eb5$export$7ee8c9beb337bc3f;
var $d663562512cc6eb5$export$b5836b71941fa3ed;
var $d663562512cc6eb5$export$cf845f2c119da08a;
'use strict';
var $d663562512cc6eb5$var$f, $d663562512cc6eb5$var$g, $d663562512cc6eb5$var$h, $d663562512cc6eb5$var$k, $d663562512cc6eb5$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $d663562512cc6eb5$var$p = null, $d663562512cc6eb5$var$q = null, $d663562512cc6eb5$var$t = function() {
        if (null !== $d663562512cc6eb5$var$p) try {
            var a = $d663562512cc6eb5$export$c4744153514ff05d();
            $d663562512cc6eb5$var$p(!0, a);
            $d663562512cc6eb5$var$p = null;
        } catch (b) {
            throw setTimeout($d663562512cc6eb5$var$t, 0), b;
        }
    }, $d663562512cc6eb5$var$u = Date.now();
    $d663562512cc6eb5$export$c4744153514ff05d = function() {
        return Date.now() - $d663562512cc6eb5$var$u;
    };
    $d663562512cc6eb5$var$f = function(a) {
        null !== $d663562512cc6eb5$var$p ? setTimeout($d663562512cc6eb5$var$f, 0, a) : ($d663562512cc6eb5$var$p = a, setTimeout($d663562512cc6eb5$var$t, 0));
    };
    $d663562512cc6eb5$var$g = function(a, b) {
        $d663562512cc6eb5$var$q = setTimeout(a, b);
    };
    $d663562512cc6eb5$var$h = function() {
        clearTimeout($d663562512cc6eb5$var$q);
    };
    $d663562512cc6eb5$var$k = function() {
        return !1;
    };
    $d663562512cc6eb5$var$l = $d663562512cc6eb5$export$d66a1c1c77bd778b = function() {};
} else {
    var $d663562512cc6eb5$var$w = window.performance, $d663562512cc6eb5$var$x = window.Date, $d663562512cc6eb5$var$y = window.setTimeout, $d663562512cc6eb5$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $d663562512cc6eb5$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $d663562512cc6eb5$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $d663562512cc6eb5$var$w && "function" === typeof $d663562512cc6eb5$var$w.now) $d663562512cc6eb5$export$c4744153514ff05d = function() {
        return $d663562512cc6eb5$var$w.now();
    };
    else {
        var $d663562512cc6eb5$var$B = $d663562512cc6eb5$var$x.now();
        $d663562512cc6eb5$export$c4744153514ff05d = function() {
            return $d663562512cc6eb5$var$x.now() - $d663562512cc6eb5$var$B;
        };
    }
    var $d663562512cc6eb5$var$C = !1, $d663562512cc6eb5$var$D = null, $d663562512cc6eb5$var$E = -1, $d663562512cc6eb5$var$F = 5, $d663562512cc6eb5$var$G = 0;
    $d663562512cc6eb5$var$k = function() {
        return $d663562512cc6eb5$export$c4744153514ff05d() >= $d663562512cc6eb5$var$G;
    };
    $d663562512cc6eb5$var$l = function() {};
    $d663562512cc6eb5$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $d663562512cc6eb5$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $d663562512cc6eb5$var$H = new MessageChannel, $d663562512cc6eb5$var$I = $d663562512cc6eb5$var$H.port2;
    $d663562512cc6eb5$var$H.port1.onmessage = function() {
        if (null !== $d663562512cc6eb5$var$D) {
            var a = $d663562512cc6eb5$export$c4744153514ff05d();
            $d663562512cc6eb5$var$G = a + $d663562512cc6eb5$var$F;
            try {
                $d663562512cc6eb5$var$D(!0, a) ? $d663562512cc6eb5$var$I.postMessage(null) : ($d663562512cc6eb5$var$C = !1, $d663562512cc6eb5$var$D = null);
            } catch (b) {
                throw $d663562512cc6eb5$var$I.postMessage(null), b;
            }
        } else $d663562512cc6eb5$var$C = !1;
    };
    $d663562512cc6eb5$var$f = function(a) {
        $d663562512cc6eb5$var$D = a;
        $d663562512cc6eb5$var$C || ($d663562512cc6eb5$var$C = !0, $d663562512cc6eb5$var$I.postMessage(null));
    };
    $d663562512cc6eb5$var$g = function(a, b) {
        $d663562512cc6eb5$var$E = $d663562512cc6eb5$var$y(function() {
            a($d663562512cc6eb5$export$c4744153514ff05d());
        }, b);
    };
    $d663562512cc6eb5$var$h = function() {
        $d663562512cc6eb5$var$z($d663562512cc6eb5$var$E);
        $d663562512cc6eb5$var$E = -1;
    };
}
function $d663562512cc6eb5$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $d663562512cc6eb5$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d663562512cc6eb5$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $d663562512cc6eb5$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $d663562512cc6eb5$var$K(n, c)) void 0 !== r && 0 > $d663562512cc6eb5$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $d663562512cc6eb5$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $d663562512cc6eb5$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $d663562512cc6eb5$var$N = [], $d663562512cc6eb5$var$O = [], $d663562512cc6eb5$var$P = 1, $d663562512cc6eb5$var$Q = null, $d663562512cc6eb5$var$R = 3, $d663562512cc6eb5$var$S = !1, $d663562512cc6eb5$var$T = !1, $d663562512cc6eb5$var$U = !1;
function $d663562512cc6eb5$var$V(a) {
    for(var b = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$O); null !== b;){
        if (null === b.callback) $d663562512cc6eb5$var$M($d663562512cc6eb5$var$O);
        else if (b.startTime <= a) $d663562512cc6eb5$var$M($d663562512cc6eb5$var$O), b.sortIndex = b.expirationTime, $d663562512cc6eb5$var$J($d663562512cc6eb5$var$N, b);
        else break;
        b = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$O);
    }
}
function $d663562512cc6eb5$var$W(a) {
    $d663562512cc6eb5$var$U = !1;
    $d663562512cc6eb5$var$V(a);
    if (!$d663562512cc6eb5$var$T) {
        if (null !== $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N)) $d663562512cc6eb5$var$T = !0, $d663562512cc6eb5$var$f($d663562512cc6eb5$var$X);
        else {
            var b = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$O);
            null !== b && $d663562512cc6eb5$var$g($d663562512cc6eb5$var$W, b.startTime - a);
        }
    }
}
function $d663562512cc6eb5$var$X(a, b) {
    $d663562512cc6eb5$var$T = !1;
    $d663562512cc6eb5$var$U && ($d663562512cc6eb5$var$U = !1, $d663562512cc6eb5$var$h());
    $d663562512cc6eb5$var$S = !0;
    var c = $d663562512cc6eb5$var$R;
    try {
        $d663562512cc6eb5$var$V(b);
        for($d663562512cc6eb5$var$Q = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N); null !== $d663562512cc6eb5$var$Q && (!($d663562512cc6eb5$var$Q.expirationTime > b) || a && !$d663562512cc6eb5$var$k());){
            var d = $d663562512cc6eb5$var$Q.callback;
            if (null !== d) {
                $d663562512cc6eb5$var$Q.callback = null;
                $d663562512cc6eb5$var$R = $d663562512cc6eb5$var$Q.priorityLevel;
                var e = d($d663562512cc6eb5$var$Q.expirationTime <= b);
                b = $d663562512cc6eb5$export$c4744153514ff05d();
                "function" === typeof e ? $d663562512cc6eb5$var$Q.callback = e : $d663562512cc6eb5$var$Q === $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N) && $d663562512cc6eb5$var$M($d663562512cc6eb5$var$N);
                $d663562512cc6eb5$var$V(b);
            } else $d663562512cc6eb5$var$M($d663562512cc6eb5$var$N);
            $d663562512cc6eb5$var$Q = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N);
        }
        if (null !== $d663562512cc6eb5$var$Q) var m = !0;
        else {
            var n = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$O);
            null !== n && $d663562512cc6eb5$var$g($d663562512cc6eb5$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $d663562512cc6eb5$var$Q = null, $d663562512cc6eb5$var$R = c, $d663562512cc6eb5$var$S = !1;
    }
}
function $d663562512cc6eb5$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $d663562512cc6eb5$var$Z = $d663562512cc6eb5$var$l;
$d663562512cc6eb5$export$3e506c1ccc9cc1a7 = 5;
$d663562512cc6eb5$export$e26fe2ed2fa76875 = 1;
$d663562512cc6eb5$export$502329bbf4b505b1 = 4;
$d663562512cc6eb5$export$6e3807111c4874c4 = 3;
$d663562512cc6eb5$export$c27134553091fb3a = null;
$d663562512cc6eb5$export$33ee1acdc04fd2a2 = 2;
$d663562512cc6eb5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d663562512cc6eb5$export$8352ce38b91d0c62 = function() {
    $d663562512cc6eb5$var$T || $d663562512cc6eb5$var$S || ($d663562512cc6eb5$var$T = !0, $d663562512cc6eb5$var$f($d663562512cc6eb5$var$X));
};
$d663562512cc6eb5$export$d3dfb8e4810cb555 = function() {
    return $d663562512cc6eb5$var$R;
};
$d663562512cc6eb5$export$839f9183b0465a69 = function() {
    return $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N);
};
$d663562512cc6eb5$export$72fdf0e06517287b = function(a) {
    switch($d663562512cc6eb5$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d663562512cc6eb5$var$R;
    }
    var c = $d663562512cc6eb5$var$R;
    $d663562512cc6eb5$var$R = b;
    try {
        return a();
    } finally{
        $d663562512cc6eb5$var$R = c;
    }
};
$d663562512cc6eb5$export$4b844e58a3e414b4 = function() {};
$d663562512cc6eb5$export$816d2913ae6b83b1 = $d663562512cc6eb5$var$Z;
$d663562512cc6eb5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d663562512cc6eb5$var$R;
    $d663562512cc6eb5$var$R = a;
    try {
        return b();
    } finally{
        $d663562512cc6eb5$var$R = c;
    }
};
$d663562512cc6eb5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d663562512cc6eb5$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $d663562512cc6eb5$var$Y(a);
    } else c = $d663562512cc6eb5$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $d663562512cc6eb5$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $d663562512cc6eb5$var$J($d663562512cc6eb5$var$O, a), null === $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N) && a === $d663562512cc6eb5$var$L($d663562512cc6eb5$var$O) && ($d663562512cc6eb5$var$U ? $d663562512cc6eb5$var$h() : $d663562512cc6eb5$var$U = !0, $d663562512cc6eb5$var$g($d663562512cc6eb5$var$W, e - d))) : (a.sortIndex = c, $d663562512cc6eb5$var$J($d663562512cc6eb5$var$N, a), $d663562512cc6eb5$var$T || $d663562512cc6eb5$var$S || ($d663562512cc6eb5$var$T = !0, $d663562512cc6eb5$var$f($d663562512cc6eb5$var$X)));
    return a;
};
$d663562512cc6eb5$export$b5836b71941fa3ed = function() {
    var a = $d663562512cc6eb5$export$c4744153514ff05d();
    $d663562512cc6eb5$var$V(a);
    var b = $d663562512cc6eb5$var$L($d663562512cc6eb5$var$N);
    return b !== $d663562512cc6eb5$var$Q && null !== $d663562512cc6eb5$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $d663562512cc6eb5$var$Q.expirationTime || $d663562512cc6eb5$var$k();
};
$d663562512cc6eb5$export$cf845f2c119da08a = function(a) {
    var b = $d663562512cc6eb5$var$R;
    return function() {
        var c = $d663562512cc6eb5$var$R;
        $d663562512cc6eb5$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d663562512cc6eb5$var$R = c;
        }
    };
};

});



parcelRegister("eUCV2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aCCvg = parcelRequire("aCCvg");
function $adb47c27c1b2dc23$var$emptyFunction() {}
function $adb47c27c1b2dc23$var$emptyFunctionWithReset() {}
$adb47c27c1b2dc23$var$emptyFunctionWithReset.resetWarningCache = $adb47c27c1b2dc23$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aCCvg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $adb47c27c1b2dc23$var$emptyFunctionWithReset,
        resetWarningCache: $adb47c27c1b2dc23$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aCCvg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7bbb51f0d0721995$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7bbb51f0d0721995$var$ReactPropTypesSecret;

});


parcelRegister("d9GOM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d8IY1 = parcelRequire("d8IY1");

var $aFRoX = parcelRequire("aFRoX");

var $uy91t = parcelRequire("uy91t");

var $jlLCl = parcelRequire("jlLCl");
var $993d5464da226f03$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $uy91t.RawSha256();
        if (secret) {
            this.outer = new $uy91t.RawSha256();
            var inner = $993d5464da226f03$var$bufferFromSecret(secret);
            var outer = new Uint8Array($aFRoX.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $aFRoX.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ($993d5464da226f03$var$isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update($993d5464da226f03$var$convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $d8IY1.__awaiter(this, void 0, void 0, function() {
            return $d8IY1.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $993d5464da226f03$var$Sha256;
function $993d5464da226f03$var$bufferFromSecret(secret) {
    var input = $993d5464da226f03$var$convertToBuffer(secret);
    if (input.byteLength > $aFRoX.BLOCK_SIZE) {
        var bufferHash = new $uy91t.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($aFRoX.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function $993d5464da226f03$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $993d5464da226f03$var$convertToBuffer(data) {
    if (typeof data === "string") return $jlLCl.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("d8IY1", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $990ee739c4113409$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $990ee739c4113409$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $990ee739c4113409$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $990ee739c4113409$var$extendStatics = function(d, b) {
    $990ee739c4113409$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $990ee739c4113409$var$extendStatics(d, b);
};
function $990ee739c4113409$export$a8ba968b8961cb8a(d, b) {
    $990ee739c4113409$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $990ee739c4113409$export$18ce0697a983be9b = function() {
    $990ee739c4113409$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $990ee739c4113409$export$18ce0697a983be9b.apply(this, arguments);
};
function $990ee739c4113409$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $990ee739c4113409$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $990ee739c4113409$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $990ee739c4113409$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $990ee739c4113409$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $990ee739c4113409$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $990ee739c4113409$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $990ee739c4113409$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $990ee739c4113409$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $990ee739c4113409$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $990ee739c4113409$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($990ee739c4113409$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $990ee739c4113409$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $990ee739c4113409$export$10c90e4f7922046c(v) {
    return this instanceof $990ee739c4113409$export$10c90e4f7922046c ? (this.v = v, this) : new $990ee739c4113409$export$10c90e4f7922046c(v);
}
function $990ee739c4113409$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $990ee739c4113409$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $990ee739c4113409$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $990ee739c4113409$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $990ee739c4113409$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $990ee739c4113409$export$19a8beecd37a4c45 === "function" ? $990ee739c4113409$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $990ee739c4113409$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $990ee739c4113409$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $990ee739c4113409$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $990ee739c4113409$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $990ee739c4113409$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("aFRoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("uy91t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aFRoX = parcelRequire("aFRoX");
/**
 * @internal
 */ var $05bd49d950c867e8$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($aFRoX.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $aFRoX.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $aFRoX.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $aFRoX.BLOCK_SIZE >= $aFRoX.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $aFRoX.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $aFRoX.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($aFRoX.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($aFRoX.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($aFRoX.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $aFRoX.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($aFRoX.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $05bd49d950c867e8$var$RawSha256;

});

parcelRegister("jlLCl", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $e164ea4cd10bfb9c$export$c7c5cef950a4d2fc; });

var $91tgz = parcelRequire("91tgz");

var $8TroS = parcelRequire("8TroS");
var $e164ea4cd10bfb9c$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $8TroS.fromUtf8)(input) : (0, $91tgz.fromUtf8)(input);
};
var $e164ea4cd10bfb9c$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $8TroS.toUtf8)(input) : (0, $91tgz.toUtf8)(input);
};

});
parcelRegister("91tgz", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $691ae8b5079fc574$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $691ae8b5079fc574$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $691ae8b5079fc574$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $691ae8b5079fc574$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("8TroS", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $6798b6e7500d3374$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $6798b6e7500d3374$export$b4b216764bb846eb; });
function $6798b6e7500d3374$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $6798b6e7500d3374$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("adm0U", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $3Bdyt = parcelRequire("3Bdyt");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $b4nE4 = parcelRequire("b4nE4");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $b4nE4.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $3Bdyt.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $b4nE4.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $b4nE4.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("3Bdyt", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("b4nE4", function(module, exports) {
'use strict';

var $hBjny = parcelRequire("hBjny");

var $gUFwp = parcelRequire("gUFwp");

var $1iIoE = parcelRequire("1iIoE");
module.exports = {
    formats: $1iIoE,
    parse: $gUFwp,
    stringify: $hBjny
};

});
parcelRegister("hBjny", function(module, exports) {
'use strict';

var $anUN1 = parcelRequire("anUN1");

var $eE7jC = parcelRequire("eE7jC");

var $1iIoE = parcelRequire("1iIoE");
var $cd04eca3e8fa9d19$var$has = Object.prototype.hasOwnProperty;
var $cd04eca3e8fa9d19$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $cd04eca3e8fa9d19$var$isArray = Array.isArray;
var $cd04eca3e8fa9d19$var$push = Array.prototype.push;
var $cd04eca3e8fa9d19$var$pushToArray = function(arr, valueOrArray) {
    $cd04eca3e8fa9d19$var$push.apply(arr, $cd04eca3e8fa9d19$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $cd04eca3e8fa9d19$var$toISO = Date.prototype.toISOString;
var $cd04eca3e8fa9d19$var$defaultFormat = $1iIoE.default;
var $cd04eca3e8fa9d19$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $eE7jC.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $cd04eca3e8fa9d19$var$defaultFormat,
    formatter: $1iIoE.formatters[$cd04eca3e8fa9d19$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $cd04eca3e8fa9d19$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $cd04eca3e8fa9d19$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $cd04eca3e8fa9d19$var$sentinel = {};
var $cd04eca3e8fa9d19$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($cd04eca3e8fa9d19$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($cd04eca3e8fa9d19$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $cd04eca3e8fa9d19$var$isArray(obj)) obj = $eE7jC.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $cd04eca3e8fa9d19$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($cd04eca3e8fa9d19$var$isNonNullishPrimitive(obj) || $eE7jC.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $cd04eca3e8fa9d19$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $cd04eca3e8fa9d19$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $cd04eca3e8fa9d19$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $eE7jC.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($cd04eca3e8fa9d19$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $cd04eca3e8fa9d19$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $cd04eca3e8fa9d19$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $cd04eca3e8fa9d19$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $anUN1();
        valueSideChannel.set($cd04eca3e8fa9d19$var$sentinel, sideChannel);
        $cd04eca3e8fa9d19$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $cd04eca3e8fa9d19$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $cd04eca3e8fa9d19$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $cd04eca3e8fa9d19$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $cd04eca3e8fa9d19$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $1iIoE.default;
    if (typeof opts.format !== 'undefined') {
        if (!$cd04eca3e8fa9d19$var$has.call($1iIoE.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $1iIoE.formatters[format];
    var filter = $cd04eca3e8fa9d19$var$defaults.filter;
    if (typeof opts.filter === 'function' || $cd04eca3e8fa9d19$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $cd04eca3e8fa9d19$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $cd04eca3e8fa9d19$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $cd04eca3e8fa9d19$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $cd04eca3e8fa9d19$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $cd04eca3e8fa9d19$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $cd04eca3e8fa9d19$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $cd04eca3e8fa9d19$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $cd04eca3e8fa9d19$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $cd04eca3e8fa9d19$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $cd04eca3e8fa9d19$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $cd04eca3e8fa9d19$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $cd04eca3e8fa9d19$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $cd04eca3e8fa9d19$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $cd04eca3e8fa9d19$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $cd04eca3e8fa9d19$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($cd04eca3e8fa9d19$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $cd04eca3e8fa9d19$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $anUN1();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $cd04eca3e8fa9d19$var$pushToArray(keys, $cd04eca3e8fa9d19$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("anUN1", function(module, exports) {
'use strict';

var $bBDQA = parcelRequire("bBDQA");

var $1dP5s = parcelRequire("1dP5s");

var $l82ZL = parcelRequire("l82ZL");

var $4C8NJ = parcelRequire("4C8NJ");

var $gchlo = parcelRequire("gchlo");
var $78f81a9a2c4d3467$var$makeChannel = $gchlo || $4C8NJ || $l82ZL;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $1dP5s(key);
                throw new $bBDQA('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $78f81a9a2c4d3467$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("bBDQA", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("1dP5s", function(module, exports) {
var $0e3ea22f7180ec56$var$hasMap = typeof Map === 'function' && Map.prototype;
var $0e3ea22f7180ec56$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $0e3ea22f7180ec56$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $0e3ea22f7180ec56$var$mapSize = $0e3ea22f7180ec56$var$hasMap && $0e3ea22f7180ec56$var$mapSizeDescriptor && typeof $0e3ea22f7180ec56$var$mapSizeDescriptor.get === 'function' ? $0e3ea22f7180ec56$var$mapSizeDescriptor.get : null;
var $0e3ea22f7180ec56$var$mapForEach = $0e3ea22f7180ec56$var$hasMap && Map.prototype.forEach;
var $0e3ea22f7180ec56$var$hasSet = typeof Set === 'function' && Set.prototype;
var $0e3ea22f7180ec56$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $0e3ea22f7180ec56$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $0e3ea22f7180ec56$var$setSize = $0e3ea22f7180ec56$var$hasSet && $0e3ea22f7180ec56$var$setSizeDescriptor && typeof $0e3ea22f7180ec56$var$setSizeDescriptor.get === 'function' ? $0e3ea22f7180ec56$var$setSizeDescriptor.get : null;
var $0e3ea22f7180ec56$var$setForEach = $0e3ea22f7180ec56$var$hasSet && Set.prototype.forEach;
var $0e3ea22f7180ec56$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $0e3ea22f7180ec56$var$weakMapHas = $0e3ea22f7180ec56$var$hasWeakMap ? WeakMap.prototype.has : null;
var $0e3ea22f7180ec56$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $0e3ea22f7180ec56$var$weakSetHas = $0e3ea22f7180ec56$var$hasWeakSet ? WeakSet.prototype.has : null;
var $0e3ea22f7180ec56$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $0e3ea22f7180ec56$var$weakRefDeref = $0e3ea22f7180ec56$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $0e3ea22f7180ec56$var$booleanValueOf = Boolean.prototype.valueOf;
var $0e3ea22f7180ec56$var$objectToString = Object.prototype.toString;
var $0e3ea22f7180ec56$var$functionToString = Function.prototype.toString;
var $0e3ea22f7180ec56$var$$match = String.prototype.match;
var $0e3ea22f7180ec56$var$$slice = String.prototype.slice;
var $0e3ea22f7180ec56$var$$replace = String.prototype.replace;
var $0e3ea22f7180ec56$var$$toUpperCase = String.prototype.toUpperCase;
var $0e3ea22f7180ec56$var$$toLowerCase = String.prototype.toLowerCase;
var $0e3ea22f7180ec56$var$$test = RegExp.prototype.test;
var $0e3ea22f7180ec56$var$$concat = Array.prototype.concat;
var $0e3ea22f7180ec56$var$$join = Array.prototype.join;
var $0e3ea22f7180ec56$var$$arrSlice = Array.prototype.slice;
var $0e3ea22f7180ec56$var$$floor = Math.floor;
var $0e3ea22f7180ec56$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $0e3ea22f7180ec56$var$gOPS = Object.getOwnPropertySymbols;
var $0e3ea22f7180ec56$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $0e3ea22f7180ec56$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $0e3ea22f7180ec56$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $0e3ea22f7180ec56$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $0e3ea22f7180ec56$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $0e3ea22f7180ec56$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $0e3ea22f7180ec56$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $0e3ea22f7180ec56$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$0e3ea22f7180ec56$var$$floor(-num) : $0e3ea22f7180ec56$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $0e3ea22f7180ec56$var$$slice.call(str, intStr.length + 1);
            return $0e3ea22f7180ec56$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $0e3ea22f7180ec56$var$$replace.call($0e3ea22f7180ec56$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $0e3ea22f7180ec56$var$$replace.call(str, sepRegex, '$&_');
}

var $dluwd = parcelRequire("dluwd");
var $0e3ea22f7180ec56$var$inspectCustom = $dluwd.custom;
var $0e3ea22f7180ec56$var$inspectSymbol = $0e3ea22f7180ec56$var$isSymbol($0e3ea22f7180ec56$var$inspectCustom) ? $0e3ea22f7180ec56$var$inspectCustom : null;
var $0e3ea22f7180ec56$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $0e3ea22f7180ec56$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($0e3ea22f7180ec56$var$has(opts, 'quoteStyle') && !$0e3ea22f7180ec56$var$has($0e3ea22f7180ec56$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($0e3ea22f7180ec56$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $0e3ea22f7180ec56$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($0e3ea22f7180ec56$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($0e3ea22f7180ec56$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $0e3ea22f7180ec56$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $0e3ea22f7180ec56$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $0e3ea22f7180ec56$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $0e3ea22f7180ec56$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $0e3ea22f7180ec56$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($0e3ea22f7180ec56$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $0e3ea22f7180ec56$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($0e3ea22f7180ec56$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$0e3ea22f7180ec56$var$isRegExp(obj)) {
        var name = $0e3ea22f7180ec56$var$nameOf(obj);
        var keys = $0e3ea22f7180ec56$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $0e3ea22f7180ec56$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($0e3ea22f7180ec56$var$isSymbol(obj)) {
        var symString = $0e3ea22f7180ec56$var$hasShammedSymbols ? $0e3ea22f7180ec56$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $0e3ea22f7180ec56$var$symToString.call(obj);
        return typeof obj === 'object' && !$0e3ea22f7180ec56$var$hasShammedSymbols ? $0e3ea22f7180ec56$var$markBoxed(symString) : symString;
    }
    if ($0e3ea22f7180ec56$var$isElement(obj)) {
        var s = '<' + $0e3ea22f7180ec56$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $0e3ea22f7180ec56$var$wrapQuotes($0e3ea22f7180ec56$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $0e3ea22f7180ec56$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($0e3ea22f7180ec56$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $0e3ea22f7180ec56$var$arrObjKeys(obj, inspect);
        if (indent && !$0e3ea22f7180ec56$var$singleLineValues(xs)) return '[' + $0e3ea22f7180ec56$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $0e3ea22f7180ec56$var$$join.call(xs, ', ') + ' ]';
    }
    if ($0e3ea22f7180ec56$var$isError(obj)) {
        var parts = $0e3ea22f7180ec56$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$0e3ea22f7180ec56$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $0e3ea22f7180ec56$var$$join.call($0e3ea22f7180ec56$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $0e3ea22f7180ec56$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($0e3ea22f7180ec56$var$inspectSymbol && typeof obj[$0e3ea22f7180ec56$var$inspectSymbol] === 'function' && $dluwd) return $dluwd(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($0e3ea22f7180ec56$var$isMap(obj)) {
        var mapParts = [];
        if ($0e3ea22f7180ec56$var$mapForEach) $0e3ea22f7180ec56$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $0e3ea22f7180ec56$var$collectionOf('Map', $0e3ea22f7180ec56$var$mapSize.call(obj), mapParts, indent);
    }
    if ($0e3ea22f7180ec56$var$isSet(obj)) {
        var setParts = [];
        if ($0e3ea22f7180ec56$var$setForEach) $0e3ea22f7180ec56$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $0e3ea22f7180ec56$var$collectionOf('Set', $0e3ea22f7180ec56$var$setSize.call(obj), setParts, indent);
    }
    if ($0e3ea22f7180ec56$var$isWeakMap(obj)) return $0e3ea22f7180ec56$var$weakCollectionOf('WeakMap');
    if ($0e3ea22f7180ec56$var$isWeakSet(obj)) return $0e3ea22f7180ec56$var$weakCollectionOf('WeakSet');
    if ($0e3ea22f7180ec56$var$isWeakRef(obj)) return $0e3ea22f7180ec56$var$weakCollectionOf('WeakRef');
    if ($0e3ea22f7180ec56$var$isNumber(obj)) return $0e3ea22f7180ec56$var$markBoxed(inspect(Number(obj)));
    if ($0e3ea22f7180ec56$var$isBigInt(obj)) return $0e3ea22f7180ec56$var$markBoxed(inspect($0e3ea22f7180ec56$var$bigIntValueOf.call(obj)));
    if ($0e3ea22f7180ec56$var$isBoolean(obj)) return $0e3ea22f7180ec56$var$markBoxed($0e3ea22f7180ec56$var$booleanValueOf.call(obj));
    if ($0e3ea22f7180ec56$var$isString(obj)) return $0e3ea22f7180ec56$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$0e3ea22f7180ec56$var$isDate(obj) && !$0e3ea22f7180ec56$var$isRegExp(obj)) {
        var ys = $0e3ea22f7180ec56$var$arrObjKeys(obj, inspect);
        var isPlainObject = $0e3ea22f7180ec56$var$gPO ? $0e3ea22f7180ec56$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $0e3ea22f7180ec56$var$toStringTag && Object(obj) === obj && $0e3ea22f7180ec56$var$toStringTag in obj ? $0e3ea22f7180ec56$var$$slice.call($0e3ea22f7180ec56$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $0e3ea22f7180ec56$var$$join.call($0e3ea22f7180ec56$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $0e3ea22f7180ec56$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $0e3ea22f7180ec56$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $0e3ea22f7180ec56$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $0e3ea22f7180ec56$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $0e3ea22f7180ec56$var$quote(s) {
    return $0e3ea22f7180ec56$var$$replace.call(String(s), /"/g, '&quot;');
}
function $0e3ea22f7180ec56$var$canTrustToString(obj) {
    return !$0e3ea22f7180ec56$var$toStringTag || !(typeof obj === 'object' && ($0e3ea22f7180ec56$var$toStringTag in obj || typeof obj[$0e3ea22f7180ec56$var$toStringTag] !== 'undefined'));
}
function $0e3ea22f7180ec56$var$isArray(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object Array]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isDate(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object Date]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isRegExp(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object RegExp]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isError(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object Error]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isString(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object String]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isNumber(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object Number]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
function $0e3ea22f7180ec56$var$isBoolean(obj) {
    return $0e3ea22f7180ec56$var$toStr(obj) === '[object Boolean]' && $0e3ea22f7180ec56$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $0e3ea22f7180ec56$var$isSymbol(obj) {
    if ($0e3ea22f7180ec56$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$0e3ea22f7180ec56$var$symToString) return false;
    try {
        $0e3ea22f7180ec56$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$0e3ea22f7180ec56$var$bigIntValueOf) return false;
    try {
        $0e3ea22f7180ec56$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $0e3ea22f7180ec56$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $0e3ea22f7180ec56$var$has(obj, key) {
    return $0e3ea22f7180ec56$var$hasOwn.call(obj, key);
}
function $0e3ea22f7180ec56$var$toStr(obj) {
    return $0e3ea22f7180ec56$var$objectToString.call(obj);
}
function $0e3ea22f7180ec56$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $0e3ea22f7180ec56$var$$match.call($0e3ea22f7180ec56$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $0e3ea22f7180ec56$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $0e3ea22f7180ec56$var$isMap(x) {
    if (!$0e3ea22f7180ec56$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $0e3ea22f7180ec56$var$mapSize.call(x);
        try {
            $0e3ea22f7180ec56$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isWeakMap(x) {
    if (!$0e3ea22f7180ec56$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $0e3ea22f7180ec56$var$weakMapHas.call(x, $0e3ea22f7180ec56$var$weakMapHas);
        try {
            $0e3ea22f7180ec56$var$weakSetHas.call(x, $0e3ea22f7180ec56$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isWeakRef(x) {
    if (!$0e3ea22f7180ec56$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $0e3ea22f7180ec56$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isSet(x) {
    if (!$0e3ea22f7180ec56$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $0e3ea22f7180ec56$var$setSize.call(x);
        try {
            $0e3ea22f7180ec56$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isWeakSet(x) {
    if (!$0e3ea22f7180ec56$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $0e3ea22f7180ec56$var$weakSetHas.call(x, $0e3ea22f7180ec56$var$weakSetHas);
        try {
            $0e3ea22f7180ec56$var$weakMapHas.call(x, $0e3ea22f7180ec56$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $0e3ea22f7180ec56$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $0e3ea22f7180ec56$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $0e3ea22f7180ec56$var$inspectString($0e3ea22f7180ec56$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $0e3ea22f7180ec56$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $0e3ea22f7180ec56$var$$replace.call($0e3ea22f7180ec56$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $0e3ea22f7180ec56$var$lowbyte);
    return $0e3ea22f7180ec56$var$wrapQuotes(s, 'single', opts);
}
function $0e3ea22f7180ec56$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $0e3ea22f7180ec56$var$$toUpperCase.call(n.toString(16));
}
function $0e3ea22f7180ec56$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $0e3ea22f7180ec56$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $0e3ea22f7180ec56$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $0e3ea22f7180ec56$var$indentedJoin(entries, indent) : $0e3ea22f7180ec56$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $0e3ea22f7180ec56$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($0e3ea22f7180ec56$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $0e3ea22f7180ec56$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $0e3ea22f7180ec56$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $0e3ea22f7180ec56$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $0e3ea22f7180ec56$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $0e3ea22f7180ec56$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $0e3ea22f7180ec56$var$arrObjKeys(obj, inspect) {
    var isArr = $0e3ea22f7180ec56$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $0e3ea22f7180ec56$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $0e3ea22f7180ec56$var$gOPS === 'function' ? $0e3ea22f7180ec56$var$gOPS(obj) : [];
    var symMap;
    if ($0e3ea22f7180ec56$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$0e3ea22f7180ec56$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($0e3ea22f7180ec56$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($0e3ea22f7180ec56$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $0e3ea22f7180ec56$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($0e3ea22f7180ec56$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("dluwd", function(module, exports) {
"use strict";

});


parcelRegister("l82ZL", function(module, exports) {
'use strict';

var $1dP5s = parcelRequire("1dP5s");

var $bBDQA = parcelRequire("bBDQA");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $f61cab169ada7a69$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $f61cab169ada7a69$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $f61cab169ada7a69$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $f61cab169ada7a69$var$listSet = function(objects, key, value) {
    var node = $f61cab169ada7a69$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $f61cab169ada7a69$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$f61cab169ada7a69$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $f61cab169ada7a69$var$listDelete = function(objects, key) {
    if (objects) return $f61cab169ada7a69$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bBDQA('Side channel does not contain ' + $1dP5s(key));
        },
        'delete': function(key) {
            var deletedNode = $f61cab169ada7a69$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $f61cab169ada7a69$var$listGet($o, key);
        },
        has: function(key) {
            return $f61cab169ada7a69$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $f61cab169ada7a69$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("4C8NJ", function(module, exports) {
'use strict';

var $i30Sx = parcelRequire("i30Sx");

var $a8i6o = parcelRequire("a8i6o");

var $1dP5s = parcelRequire("1dP5s");

var $bBDQA = parcelRequire("bBDQA");
var $35c189bfa19b0817$var$$Map = $i30Sx('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $35c189bfa19b0817$var$$mapGet = $a8i6o('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $35c189bfa19b0817$var$$mapSet = $a8i6o('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $35c189bfa19b0817$var$$mapHas = $a8i6o('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $35c189bfa19b0817$var$$mapDelete = $a8i6o('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $35c189bfa19b0817$var$$mapSize = $a8i6o('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$35c189bfa19b0817$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bBDQA('Side channel does not contain ' + $1dP5s(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $35c189bfa19b0817$var$$mapDelete($m, key);
                if ($35c189bfa19b0817$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $35c189bfa19b0817$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $35c189bfa19b0817$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $35c189bfa19b0817$var$$Map();
            $35c189bfa19b0817$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("i30Sx", function(module, exports) {
'use strict';
var $d239304a528c3c69$var$undefined1;

var $b00nT = parcelRequire("b00nT");

var $f80ag = parcelRequire("f80ag");

var $b5Lcv = parcelRequire("b5Lcv");

var $6oZph = parcelRequire("6oZph");

var $h3cuB = parcelRequire("h3cuB");

var $egsoO = parcelRequire("egsoO");

var $bBDQA = parcelRequire("bBDQA");

var $4i8R0 = parcelRequire("4i8R0");

var $gtKzJ = parcelRequire("gtKzJ");

var $3I68o = parcelRequire("3I68o");

var $cuAQz = parcelRequire("cuAQz");

var $bZN0X = parcelRequire("bZN0X");

var $d6PRZ = parcelRequire("d6PRZ");

var $fvrCB = parcelRequire("fvrCB");

var $3mOik = parcelRequire("3mOik");
var $d239304a528c3c69$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $d239304a528c3c69$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $d239304a528c3c69$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $eXqlJ = parcelRequire("eXqlJ");

var $hXpA9 = parcelRequire("hXpA9");
var $d239304a528c3c69$var$throwTypeError = function() {
    throw new $bBDQA();
};
var $d239304a528c3c69$var$ThrowTypeError = $eXqlJ ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $d239304a528c3c69$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $eXqlJ(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $d239304a528c3c69$var$throwTypeError;
        }
    }
}() : $d239304a528c3c69$var$throwTypeError;

var $d239304a528c3c69$var$hasSymbols = (parcelRequire("kgHHR"))();

var $ehyg4 = parcelRequire("ehyg4");

var $cWE9j = parcelRequire("cWE9j");

var $3LB6C = parcelRequire("3LB6C");

var $6sFt5 = parcelRequire("6sFt5");

var $9HUCy = parcelRequire("9HUCy");
var $d239304a528c3c69$var$needsEval = {};
var $d239304a528c3c69$var$TypedArray = typeof Uint8Array === 'undefined' || !$ehyg4 ? undefined : $ehyg4(Uint8Array);
var $d239304a528c3c69$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $d239304a528c3c69$var$hasSymbols && $ehyg4 ? $ehyg4([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $d239304a528c3c69$var$needsEval,
    '%AsyncGenerator%': $d239304a528c3c69$var$needsEval,
    '%AsyncGeneratorFunction%': $d239304a528c3c69$var$needsEval,
    '%AsyncIteratorPrototype%': $d239304a528c3c69$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $f80ag,
    '%eval%': eval,
    '%EvalError%': $b5Lcv,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $d239304a528c3c69$var$$Function,
    '%GeneratorFunction%': $d239304a528c3c69$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $d239304a528c3c69$var$hasSymbols && $ehyg4 ? $ehyg4($ehyg4([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$d239304a528c3c69$var$hasSymbols || !$ehyg4 ? undefined : $ehyg4(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $b00nT,
    '%Object.getOwnPropertyDescriptor%': $eXqlJ,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6oZph,
    '%ReferenceError%': $h3cuB,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$d239304a528c3c69$var$hasSymbols || !$ehyg4 ? undefined : $ehyg4(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $d239304a528c3c69$var$hasSymbols && $ehyg4 ? $ehyg4(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $d239304a528c3c69$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $egsoO,
    '%ThrowTypeError%': $d239304a528c3c69$var$ThrowTypeError,
    '%TypedArray%': $d239304a528c3c69$var$TypedArray,
    '%TypeError%': $bBDQA,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $4i8R0,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9HUCy,
    '%Function.prototype.apply%': $6sFt5,
    '%Object.defineProperty%': $hXpA9,
    '%Object.getPrototypeOf%': $cWE9j,
    '%Math.abs%': $gtKzJ,
    '%Math.floor%': $3I68o,
    '%Math.max%': $cuAQz,
    '%Math.min%': $bZN0X,
    '%Math.pow%': $d6PRZ,
    '%Math.round%': $fvrCB,
    '%Math.sign%': $3mOik,
    '%Reflect.getPrototypeOf%': $3LB6C
};
if ($ehyg4) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $d239304a528c3c69$var$errorProto = $ehyg4($ehyg4(e));
    $d239304a528c3c69$var$INTRINSICS['%Error.prototype%'] = $d239304a528c3c69$var$errorProto;
}
var $d239304a528c3c69$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $d239304a528c3c69$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $d239304a528c3c69$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $d239304a528c3c69$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $ehyg4) value = $ehyg4(gen.prototype);
    }
    $d239304a528c3c69$var$INTRINSICS[name] = value;
    return value;
};
var $d239304a528c3c69$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $4sdmt = parcelRequire("4sdmt");

var $dHVYz = parcelRequire("dHVYz");
var $d239304a528c3c69$var$$concat = $4sdmt.call($9HUCy, Array.prototype.concat);
var $d239304a528c3c69$var$$spliceApply = $4sdmt.call($6sFt5, Array.prototype.splice);
var $d239304a528c3c69$var$$replace = $4sdmt.call($9HUCy, String.prototype.replace);
var $d239304a528c3c69$var$$strSlice = $4sdmt.call($9HUCy, String.prototype.slice);
var $d239304a528c3c69$var$$exec = $4sdmt.call($9HUCy, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $d239304a528c3c69$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $d239304a528c3c69$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $d239304a528c3c69$var$stringToPath = function stringToPath(string) {
    var first = $d239304a528c3c69$var$$strSlice(string, 0, 1);
    var last = $d239304a528c3c69$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $egsoO('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $egsoO('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $d239304a528c3c69$var$$replace(string, $d239304a528c3c69$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $d239304a528c3c69$var$$replace(subString, $d239304a528c3c69$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $d239304a528c3c69$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($dHVYz($d239304a528c3c69$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $d239304a528c3c69$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($dHVYz($d239304a528c3c69$var$INTRINSICS, intrinsicName)) {
        var value = $d239304a528c3c69$var$INTRINSICS[intrinsicName];
        if (value === $d239304a528c3c69$var$needsEval) value = $d239304a528c3c69$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bBDQA('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $egsoO('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bBDQA('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bBDQA('"allowMissing" argument must be a boolean');
    if ($d239304a528c3c69$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $egsoO('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $d239304a528c3c69$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $d239304a528c3c69$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $d239304a528c3c69$var$$spliceApply(parts, $d239304a528c3c69$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $d239304a528c3c69$var$$strSlice(part, 0, 1);
        var last = $d239304a528c3c69$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $egsoO('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($dHVYz($d239304a528c3c69$var$INTRINSICS, intrinsicRealName)) value = $d239304a528c3c69$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bBDQA('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($eXqlJ && i + 1 >= parts.length) {
                var desc = $eXqlJ(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $dHVYz(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $d239304a528c3c69$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("b00nT", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("f80ag", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("b5Lcv", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6oZph", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("h3cuB", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("egsoO", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("4i8R0", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("gtKzJ", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("3I68o", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("cuAQz", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("bZN0X", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("d6PRZ", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("fvrCB", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("3mOik", function(module, exports) {
'use strict';

var $lTCOH = parcelRequire("lTCOH");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($lTCOH(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("lTCOH", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("eXqlJ", function(module, exports) {
'use strict';

var $bJeQU = parcelRequire("bJeQU");
var $ae3b03d8bb2b9e62$require$$gOPD = $bJeQU;
if ($ae3b03d8bb2b9e62$require$$gOPD) try {
    $ae3b03d8bb2b9e62$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ae3b03d8bb2b9e62$require$$gOPD = null;
}
module.exports = $ae3b03d8bb2b9e62$require$$gOPD;

});
parcelRegister("bJeQU", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("hXpA9", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $d12bca684ea4f78b$var$$defineProperty = Object.defineProperty || false;
if ($d12bca684ea4f78b$var$$defineProperty) try {
    $d12bca684ea4f78b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $d12bca684ea4f78b$var$$defineProperty = false;
}
module.exports = $d12bca684ea4f78b$var$$defineProperty;

});

parcelRegister("kgHHR", function(module, exports) {
'use strict';
var $ec17347044d622b5$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $02qGK = parcelRequire("02qGK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $ec17347044d622b5$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ec17347044d622b5$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $02qGK();
};

});
parcelRegister("02qGK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("ehyg4", function(module, exports) {
'use strict';

var $3LB6C = parcelRequire("3LB6C");

var $cWE9j = parcelRequire("cWE9j");

var $gfE2b = parcelRequire("gfE2b");
/** @type {import('.')} */ module.exports = $3LB6C ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $3LB6C(O);
} : $cWE9j ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $cWE9j(O);
} : $gfE2b ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gfE2b(O);
} : null;

});
parcelRegister("3LB6C", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("cWE9j", function(module, exports) {
'use strict';

var $b00nT = parcelRequire("b00nT");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $b00nT.getPrototypeOf || null;

});

parcelRegister("gfE2b", function(module, exports) {
'use strict';

var $iauJN = parcelRequire("iauJN");

var $eXqlJ = parcelRequire("eXqlJ");
var $bd4d1a055c23bbd5$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $bd4d1a055c23bbd5$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $bd4d1a055c23bbd5$var$desc = !!$bd4d1a055c23bbd5$var$hasProtoAccessor && $eXqlJ && $eXqlJ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $bd4d1a055c23bbd5$var$$Object = Object;
var $bd4d1a055c23bbd5$var$$getPrototypeOf = $bd4d1a055c23bbd5$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $bd4d1a055c23bbd5$var$desc && typeof $bd4d1a055c23bbd5$var$desc.get === 'function' ? $iauJN([
    $bd4d1a055c23bbd5$var$desc.get
]) : typeof $bd4d1a055c23bbd5$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $bd4d1a055c23bbd5$var$$getPrototypeOf(value == null ? value : $bd4d1a055c23bbd5$var$$Object(value));
} : false;

});
parcelRegister("iauJN", function(module, exports) {
'use strict';

var $4sdmt = parcelRequire("4sdmt");

var $bBDQA = parcelRequire("bBDQA");

var $9HUCy = parcelRequire("9HUCy");

var $1EfmA = parcelRequire("1EfmA");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bBDQA('a function is required');
    return $1EfmA($4sdmt, $9HUCy, args);
};

});
parcelRegister("4sdmt", function(module, exports) {
'use strict';

var $168ru = parcelRequire("168ru");
module.exports = Function.prototype.bind || $168ru;

});
parcelRegister("168ru", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $0ccce67b558716d5$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $0ccce67b558716d5$var$toStr = Object.prototype.toString;
var $0ccce67b558716d5$var$max = Math.max;
var $0ccce67b558716d5$var$funcType = '[object Function]';
var $0ccce67b558716d5$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $0ccce67b558716d5$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $0ccce67b558716d5$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $0ccce67b558716d5$var$toStr.apply(target) !== $0ccce67b558716d5$var$funcType) throw new TypeError($0ccce67b558716d5$var$ERROR_MESSAGE + target);
    var args = $0ccce67b558716d5$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $0ccce67b558716d5$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $0ccce67b558716d5$var$concatty(args, arguments));
    };
    var boundLength = $0ccce67b558716d5$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $0ccce67b558716d5$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9HUCy", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("1EfmA", function(module, exports) {
'use strict';

var $4sdmt = parcelRequire("4sdmt");

var $6sFt5 = parcelRequire("6sFt5");

var $9HUCy = parcelRequire("9HUCy");

var $bqq71 = parcelRequire("bqq71");
/** @type {import('./actualApply')} */ module.exports = $bqq71 || $4sdmt.call($9HUCy, $6sFt5);

});
parcelRegister("6sFt5", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("bqq71", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("dHVYz", function(module, exports) {
'use strict';
var $9fac4351cb955a9f$var$call = Function.prototype.call;
var $9fac4351cb955a9f$var$$hasOwn = Object.prototype.hasOwnProperty;

var $4sdmt = parcelRequire("4sdmt");
/** @type {import('.')} */ module.exports = $4sdmt.call($9fac4351cb955a9f$var$call, $9fac4351cb955a9f$var$$hasOwn);

});


parcelRegister("a8i6o", function(module, exports) {
'use strict';

var $i30Sx = parcelRequire("i30Sx");

var $iauJN = parcelRequire("iauJN");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $01e75db347f30b44$var$$indexOf = $iauJN([
    $i30Sx('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $i30Sx(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $01e75db347f30b44$var$$indexOf(name, '.prototype.') > -1) return $iauJN(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("gchlo", function(module, exports) {
'use strict';

var $i30Sx = parcelRequire("i30Sx");

var $a8i6o = parcelRequire("a8i6o");

var $1dP5s = parcelRequire("1dP5s");

var $4C8NJ = parcelRequire("4C8NJ");

var $bBDQA = parcelRequire("bBDQA");
var $bcab388487efabd7$var$$WeakMap = $i30Sx('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $bcab388487efabd7$var$$weakMapGet = $a8i6o('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $bcab388487efabd7$var$$weakMapSet = $a8i6o('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $bcab388487efabd7$var$$weakMapHas = $a8i6o('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $bcab388487efabd7$var$$weakMapDelete = $a8i6o('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $bcab388487efabd7$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bBDQA('Side channel does not contain ' + $1dP5s(key));
        },
        'delete': function(key) {
            if ($bcab388487efabd7$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $bcab388487efabd7$var$$weakMapDelete($wm, key);
            } else if ($4C8NJ) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($bcab388487efabd7$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $bcab388487efabd7$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($bcab388487efabd7$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $bcab388487efabd7$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($bcab388487efabd7$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $bcab388487efabd7$var$$WeakMap();
                $bcab388487efabd7$var$$weakMapSet($wm, key, value);
            } else if ($4C8NJ) {
                if (!$m) $m = $4C8NJ();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $4C8NJ;

});


parcelRegister("eE7jC", function(module, exports) {
'use strict';

var $1iIoE = parcelRequire("1iIoE");

var $anUN1 = parcelRequire("anUN1");

var $hXpA9 = parcelRequire("hXpA9");
var $aa9a79c8d538045d$var$has = Object.prototype.hasOwnProperty;
var $aa9a79c8d538045d$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $aa9a79c8d538045d$var$overflowChannel = $anUN1();
var $aa9a79c8d538045d$var$markOverflow = function markOverflow(obj, maxIndex) {
    $aa9a79c8d538045d$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $aa9a79c8d538045d$var$isOverflow = function isOverflow(obj) {
    return $aa9a79c8d538045d$var$overflowChannel.has(obj);
};
var $aa9a79c8d538045d$var$getMaxIndex = function getMaxIndex(obj) {
    return $aa9a79c8d538045d$var$overflowChannel.get(obj);
};
var $aa9a79c8d538045d$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $aa9a79c8d538045d$var$overflowChannel.set(obj, maxIndex);
};
var $aa9a79c8d538045d$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $aa9a79c8d538045d$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($aa9a79c8d538045d$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $aa9a79c8d538045d$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $aa9a79c8d538045d$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $hXpA9) $hXpA9(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $aa9a79c8d538045d$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($aa9a79c8d538045d$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $aa9a79c8d538045d$var$markOverflow($aa9a79c8d538045d$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($aa9a79c8d538045d$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $aa9a79c8d538045d$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $aa9a79c8d538045d$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$aa9a79c8d538045d$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($aa9a79c8d538045d$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $aa9a79c8d538045d$var$markOverflow(result, $aa9a79c8d538045d$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $aa9a79c8d538045d$var$markOverflow($aa9a79c8d538045d$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($aa9a79c8d538045d$var$isArray(target) && !$aa9a79c8d538045d$var$isArray(source)) mergeTarget = $aa9a79c8d538045d$var$arrayToObject(target, options);
    if ($aa9a79c8d538045d$var$isArray(target) && $aa9a79c8d538045d$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($aa9a79c8d538045d$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $aa9a79c8d538045d$var$markOverflow($aa9a79c8d538045d$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($aa9a79c8d538045d$var$has.call(acc, key)) $aa9a79c8d538045d$var$setProperty(acc, key, merge(acc[key], value, options));
        else $aa9a79c8d538045d$var$setProperty(acc, key, value);
        if ($aa9a79c8d538045d$var$isOverflow(source) && !$aa9a79c8d538045d$var$isOverflow(acc)) $aa9a79c8d538045d$var$markOverflow(acc, $aa9a79c8d538045d$var$getMaxIndex(source));
        if ($aa9a79c8d538045d$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $aa9a79c8d538045d$var$getMaxIndex(acc)) $aa9a79c8d538045d$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $aa9a79c8d538045d$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $aa9a79c8d538045d$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $aa9a79c8d538045d$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $aa9a79c8d538045d$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $aa9a79c8d538045d$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $aa9a79c8d538045d$var$limit){
        var segment = string.length >= $aa9a79c8d538045d$var$limit ? string.slice(j, j + $aa9a79c8d538045d$var$limit) : string;
        if (j + $aa9a79c8d538045d$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $1iIoE.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $aa9a79c8d538045d$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $aa9a79c8d538045d$var$hexTable[0xC0 | c >> 6] + $aa9a79c8d538045d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $aa9a79c8d538045d$var$hexTable[0xE0 | c >> 12] + $aa9a79c8d538045d$var$hexTable[0x80 | c >> 6 & 0x3F] + $aa9a79c8d538045d$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $aa9a79c8d538045d$var$hexTable[0xF0 | c >> 18] + $aa9a79c8d538045d$var$hexTable[0x80 | c >> 12 & 0x3F] + $aa9a79c8d538045d$var$hexTable[0x80 | c >> 6 & 0x3F] + $aa9a79c8d538045d$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $aa9a79c8d538045d$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $anUN1();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $aa9a79c8d538045d$var$compactQueue(queue);
    return value;
};
var $aa9a79c8d538045d$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $aa9a79c8d538045d$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $aa9a79c8d538045d$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($aa9a79c8d538045d$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        var newIndex = $aa9a79c8d538045d$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $aa9a79c8d538045d$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $aa9a79c8d538045d$var$markOverflow($aa9a79c8d538045d$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $aa9a79c8d538045d$var$maybeMap = function maybeMap(val, fn) {
    if ($aa9a79c8d538045d$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $aa9a79c8d538045d$var$arrayToObject,
    assign: $aa9a79c8d538045d$var$assign,
    combine: $aa9a79c8d538045d$var$combine,
    compact: $aa9a79c8d538045d$var$compact,
    decode: $aa9a79c8d538045d$var$decode,
    encode: $aa9a79c8d538045d$var$encode,
    isBuffer: $aa9a79c8d538045d$var$isBuffer,
    isOverflow: $aa9a79c8d538045d$var$isOverflow,
    isRegExp: $aa9a79c8d538045d$var$isRegExp,
    markOverflow: $aa9a79c8d538045d$var$markOverflow,
    maybeMap: $aa9a79c8d538045d$var$maybeMap,
    merge: $aa9a79c8d538045d$var$merge
};

});
parcelRegister("1iIoE", function(module, exports) {
'use strict';
var $0f29e91e6748c790$var$replace = String.prototype.replace;
var $0f29e91e6748c790$var$percentTwenties = /%20/g;
var $0f29e91e6748c790$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $0f29e91e6748c790$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $0f29e91e6748c790$var$replace.call(value, $0f29e91e6748c790$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $0f29e91e6748c790$var$Format.RFC1738,
    RFC3986: $0f29e91e6748c790$var$Format.RFC3986
};

});



parcelRegister("gUFwp", function(module, exports) {
'use strict';

var $eE7jC = parcelRequire("eE7jC");
var $c50215a38fc4db1e$var$has = Object.prototype.hasOwnProperty;
var $c50215a38fc4db1e$var$isArray = Array.isArray;
var $c50215a38fc4db1e$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $eE7jC.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $c50215a38fc4db1e$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $c50215a38fc4db1e$var$parseArrayValue = function(val, options, currentArrayLength, isFlatArrayValue) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (isFlatArrayValue && options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $c50215a38fc4db1e$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $c50215a38fc4db1e$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $c50215a38fc4db1e$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $c50215a38fc4db1e$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $c50215a38fc4db1e$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $c50215a38fc4db1e$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $c50215a38fc4db1e$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $eE7jC.maybeMap($c50215a38fc4db1e$var$parseArrayValue(part.slice(pos + 1), options, $c50215a38fc4db1e$var$isArray(obj[key]) ? obj[key].length : 0, part.indexOf('[]=') === -1), function(encodedVal) {
                return options.decoder(encodedVal, $c50215a38fc4db1e$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $c50215a38fc4db1e$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $c50215a38fc4db1e$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $c50215a38fc4db1e$var$isArray(val) && val.length > options.arrayLimit) val = $eE7jC.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $c50215a38fc4db1e$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $eE7jC.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $c50215a38fc4db1e$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $c50215a38fc4db1e$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($eE7jC.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $eE7jC.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $eE7jC.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $c50215a38fc4db1e$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $c50215a38fc4db1e$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $c50215a38fc4db1e$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $c50215a38fc4db1e$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $c50215a38fc4db1e$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $c50215a38fc4db1e$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $c50215a38fc4db1e$var$parseObject(keys, val, options, valuesParsed);
};
var $c50215a38fc4db1e$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $c50215a38fc4db1e$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $c50215a38fc4db1e$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $c50215a38fc4db1e$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $c50215a38fc4db1e$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $c50215a38fc4db1e$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $c50215a38fc4db1e$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $c50215a38fc4db1e$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $c50215a38fc4db1e$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $c50215a38fc4db1e$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $c50215a38fc4db1e$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $c50215a38fc4db1e$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $c50215a38fc4db1e$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $eE7jC.isRegExp(opts.delimiter) ? opts.delimiter : $c50215a38fc4db1e$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $c50215a38fc4db1e$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $c50215a38fc4db1e$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $c50215a38fc4db1e$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $c50215a38fc4db1e$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $c50215a38fc4db1e$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $c50215a38fc4db1e$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $c50215a38fc4db1e$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $c50215a38fc4db1e$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $c50215a38fc4db1e$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $c50215a38fc4db1e$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $eE7jC.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $eE7jC.compact(obj);
};

});



parcelRegister("7Zaqq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $1MmVL = parcelRequire("1MmVL");

var $eNCbH = parcelRequire("eNCbH");

var $aR7W6 = parcelRequire("aR7W6");

var $jWBlL = parcelRequire("jWBlL");

var $5k8Bf = parcelRequire("5k8Bf");

var $93C9Y = parcelRequire("93C9Y");
var $5d065129d8e95f9b$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $jWBlL.supportsWebCrypto)((0, $93C9Y.locateWindow)())) this.hash = new $eNCbH.Sha256(secret);
        else if ((0, $5k8Bf.isMsWindow)((0, $93C9Y.locateWindow)())) this.hash = new $1MmVL.Sha256(secret);
        else this.hash = new $aR7W6.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
module.exports.Sha256 = $5d065129d8e95f9b$var$Sha256;

});
parcelRegister("1MmVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $dINTt = parcelRequire("dINTt");

var $2GtXj = parcelRequire("2GtXj");

var $QxOwh = parcelRequire("QxOwh");

var $93C9Y = parcelRequire("93C9Y");
var $14bc0fb7d18a7a45$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = $14bc0fb7d18a7a45$var$getKeyPromise(secret).then(function(keyData) {
                return (0, $93C9Y.locateWindow)().msCrypto.subtle.sign($2GtXj.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $93C9Y.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $dINTt.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($14bc0fb7d18a7a45$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $14bc0fb7d18a7a45$var$Sha256;
function $14bc0fb7d18a7a45$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $93C9Y.locateWindow)().msCrypto.subtle.importKey("raw", $14bc0fb7d18a7a45$var$toArrayBufferView(secret), $2GtXj.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $14bc0fb7d18a7a45$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $QxOwh.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("dINTt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $9fd616435a426fcd$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $9fd616435a426fcd$var$isEmptyData;

});

parcelRegister("2GtXj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("QxOwh", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $09df162aaadbed10$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $09df162aaadbed10$export$b4b216764bb846eb; });

var $jGPBP = parcelRequire("jGPBP");

var $iFZon = parcelRequire("iFZon");
var $09df162aaadbed10$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $iFZon.fromUtf8)(input) : (0, $jGPBP.fromUtf8)(input);
};
var $09df162aaadbed10$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $iFZon.toUtf8)(input) : (0, $jGPBP.toUtf8)(input);
};

});
parcelRegister("jGPBP", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $e559f913fe9e0b72$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $e559f913fe9e0b72$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $e559f913fe9e0b72$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $e559f913fe9e0b72$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("iFZon", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $d98bad8f47216edd$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $d98bad8f47216edd$export$b4b216764bb846eb; });
function $d98bad8f47216edd$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $d98bad8f47216edd$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("93C9Y", function(module, exports) {

$parcel$export(module.exports, "locateWindow", function () { return $6981fe9ae8159946$export$2a77db4d0e0dd1ff; });
const $6981fe9ae8159946$var$fallbackWindow = {};
function $6981fe9ae8159946$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $6981fe9ae8159946$var$fallbackWindow;
}

});


parcelRegister("eNCbH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hMh1g = parcelRequire("hMh1g");

var $2GtXj = parcelRequire("2GtXj");

var $93C9Y = parcelRequire("93C9Y");
var $ac634390db0402c1$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $93C9Y.locateWindow)().crypto.subtle.importKey("raw", (0, $hMh1g.convertToBuffer)(secret), $2GtXj.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, $hMh1g.isEmptyData)(data)) return;
        var update = (0, $hMh1g.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $93C9Y.locateWindow)().crypto.subtle.sign($2GtXj.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $hMh1g.isEmptyData)(this.toHash)) return Promise.resolve($2GtXj.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $93C9Y.locateWindow)().crypto.subtle.digest($2GtXj.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $ac634390db0402c1$var$Sha256;

});
parcelRegister("hMh1g", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $jfr61 = parcelRequire("jfr61");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $jfr61.convertToBuffer;
    }
});

var $eevDU = parcelRequire("eevDU");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $eevDU.isEmptyData;
    }
});

var $af4hG = parcelRequire("af4hG");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $af4hG.numToUint8;
    }
});

var $lu7pN = parcelRequire("lu7pN");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $lu7pN.uint32ArrayFrom;
    }
});

});
parcelRegister("jfr61", function(module, exports) {

var $38gB7 = parcelRequire("38gB7");
var $e0346fc90598e117$require$Buffer = $38gB7.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $9n2qp = parcelRequire("9n2qp");
// Quick polyfill
var $e0346fc90598e117$var$fromUtf8 = typeof $e0346fc90598e117$require$Buffer !== "undefined" && $e0346fc90598e117$require$Buffer.from ? function(input) {
    return $e0346fc90598e117$require$Buffer.from(input, "utf8");
} : $9n2qp.fromUtf8;
function $e0346fc90598e117$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $e0346fc90598e117$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $e0346fc90598e117$var$convertToBuffer;

});
parcelRegister("38gB7", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $247efe64d56c519d$export$a143d493d941bafc; }, function (v) { return $247efe64d56c519d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $247efe64d56c519d$export$e4cf37d7f6fb9e0a; }, function (v) { return $247efe64d56c519d$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $247efe64d56c519d$export$f99ded8fe4b79145; }, function (v) { return $247efe64d56c519d$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $247efe64d56c519d$export$599f31c3813fae4d; }, function (v) { return $247efe64d56c519d$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $247efe64d56c519d$export$a143d493d941bafc;
var $247efe64d56c519d$export$e4cf37d7f6fb9e0a;
var $247efe64d56c519d$export$f99ded8fe4b79145;
var $247efe64d56c519d$export$599f31c3813fae4d;
'use strict';

var $9TmCM = parcelRequire("9TmCM");

var $9Hytc = parcelRequire("9Hytc");
const $247efe64d56c519d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$247efe64d56c519d$export$a143d493d941bafc = $247efe64d56c519d$var$Buffer;
$247efe64d56c519d$export$e4cf37d7f6fb9e0a = $247efe64d56c519d$var$SlowBuffer;
$247efe64d56c519d$export$f99ded8fe4b79145 = 50;
const $247efe64d56c519d$var$K_MAX_LENGTH = 0x7fffffff;
$247efe64d56c519d$export$599f31c3813fae4d = $247efe64d56c519d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $247efe64d56c519d$var$Buffer.TYPED_ARRAY_SUPPORT = $247efe64d56c519d$var$typedArraySupport();
if (!$247efe64d56c519d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $247efe64d56c519d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($247efe64d56c519d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$247efe64d56c519d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($247efe64d56c519d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$247efe64d56c519d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $247efe64d56c519d$var$createBuffer(length) {
    if (length > $247efe64d56c519d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $247efe64d56c519d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $247efe64d56c519d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $247efe64d56c519d$var$allocUnsafe(arg);
    }
    return $247efe64d56c519d$var$from(arg, encodingOrOffset, length);
}
$247efe64d56c519d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $247efe64d56c519d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $247efe64d56c519d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $247efe64d56c519d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($247efe64d56c519d$var$isInstance(value, ArrayBuffer) || value && $247efe64d56c519d$var$isInstance(value.buffer, ArrayBuffer)) return $247efe64d56c519d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($247efe64d56c519d$var$isInstance(value, SharedArrayBuffer) || value && $247efe64d56c519d$var$isInstance(value.buffer, SharedArrayBuffer))) return $247efe64d56c519d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $247efe64d56c519d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $247efe64d56c519d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $247efe64d56c519d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $247efe64d56c519d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $247efe64d56c519d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($247efe64d56c519d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($247efe64d56c519d$var$Buffer, Uint8Array);
function $247efe64d56c519d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $247efe64d56c519d$var$alloc(size, fill, encoding) {
    $247efe64d56c519d$var$assertSize(size);
    if (size <= 0) return $247efe64d56c519d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $247efe64d56c519d$var$createBuffer(size).fill(fill, encoding) : $247efe64d56c519d$var$createBuffer(size).fill(fill);
    return $247efe64d56c519d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $247efe64d56c519d$var$Buffer.alloc = function(size, fill, encoding) {
    return $247efe64d56c519d$var$alloc(size, fill, encoding);
};
function $247efe64d56c519d$var$allocUnsafe(size) {
    $247efe64d56c519d$var$assertSize(size);
    return $247efe64d56c519d$var$createBuffer(size < 0 ? 0 : $247efe64d56c519d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $247efe64d56c519d$var$Buffer.allocUnsafe = function(size) {
    return $247efe64d56c519d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $247efe64d56c519d$var$Buffer.allocUnsafeSlow = function(size) {
    return $247efe64d56c519d$var$allocUnsafe(size);
};
function $247efe64d56c519d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$247efe64d56c519d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $247efe64d56c519d$var$byteLength(string, encoding) | 0;
    let buf = $247efe64d56c519d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $247efe64d56c519d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $247efe64d56c519d$var$checked(array.length) | 0;
    const buf = $247efe64d56c519d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $247efe64d56c519d$var$fromArrayView(arrayView) {
    if ($247efe64d56c519d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $247efe64d56c519d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $247efe64d56c519d$var$fromArrayLike(arrayView);
}
function $247efe64d56c519d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $247efe64d56c519d$var$Buffer.prototype);
    return buf;
}
function $247efe64d56c519d$var$fromObject(obj) {
    if ($247efe64d56c519d$var$Buffer.isBuffer(obj)) {
        const len = $247efe64d56c519d$var$checked(obj.length) | 0;
        const buf = $247efe64d56c519d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $247efe64d56c519d$var$numberIsNaN(obj.length)) return $247efe64d56c519d$var$createBuffer(0);
        return $247efe64d56c519d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $247efe64d56c519d$var$fromArrayLike(obj.data);
}
function $247efe64d56c519d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $247efe64d56c519d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $247efe64d56c519d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $247efe64d56c519d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $247efe64d56c519d$var$Buffer.alloc(+length);
}
$247efe64d56c519d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $247efe64d56c519d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$247efe64d56c519d$var$Buffer.compare = function compare(a, b) {
    if ($247efe64d56c519d$var$isInstance(a, Uint8Array)) a = $247efe64d56c519d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($247efe64d56c519d$var$isInstance(b, Uint8Array)) b = $247efe64d56c519d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$247efe64d56c519d$var$Buffer.isBuffer(a) || !$247efe64d56c519d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$247efe64d56c519d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$247efe64d56c519d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $247efe64d56c519d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $247efe64d56c519d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($247efe64d56c519d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$247efe64d56c519d$var$Buffer.isBuffer(buf)) buf = $247efe64d56c519d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$247efe64d56c519d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $247efe64d56c519d$var$byteLength(string, encoding) {
    if ($247efe64d56c519d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $247efe64d56c519d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $247efe64d56c519d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $247efe64d56c519d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $247efe64d56c519d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$247efe64d56c519d$var$Buffer.byteLength = $247efe64d56c519d$var$byteLength;
function $247efe64d56c519d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $247efe64d56c519d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $247efe64d56c519d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $247efe64d56c519d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $247efe64d56c519d$var$latin1Slice(this, start, end);
        case 'base64':
            return $247efe64d56c519d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $247efe64d56c519d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$247efe64d56c519d$var$Buffer.prototype._isBuffer = true;
function $247efe64d56c519d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$247efe64d56c519d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$247efe64d56c519d$var$swap(this, i, i + 1);
    return this;
};
$247efe64d56c519d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $247efe64d56c519d$var$swap(this, i, i + 3);
        $247efe64d56c519d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$247efe64d56c519d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $247efe64d56c519d$var$swap(this, i, i + 7);
        $247efe64d56c519d$var$swap(this, i + 1, i + 6);
        $247efe64d56c519d$var$swap(this, i + 2, i + 5);
        $247efe64d56c519d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$247efe64d56c519d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $247efe64d56c519d$var$utf8Slice(this, 0, length);
    return $247efe64d56c519d$var$slowToString.apply(this, arguments);
};
$247efe64d56c519d$var$Buffer.prototype.toLocaleString = $247efe64d56c519d$var$Buffer.prototype.toString;
$247efe64d56c519d$var$Buffer.prototype.equals = function equals(b) {
    if (!$247efe64d56c519d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $247efe64d56c519d$var$Buffer.compare(this, b) === 0;
};
$247efe64d56c519d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $247efe64d56c519d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($247efe64d56c519d$var$customInspectSymbol) $247efe64d56c519d$var$Buffer.prototype[$247efe64d56c519d$var$customInspectSymbol] = $247efe64d56c519d$var$Buffer.prototype.inspect;
$247efe64d56c519d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($247efe64d56c519d$var$isInstance(target, Uint8Array)) target = $247efe64d56c519d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$247efe64d56c519d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $247efe64d56c519d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($247efe64d56c519d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $247efe64d56c519d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($247efe64d56c519d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $247efe64d56c519d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $247efe64d56c519d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $247efe64d56c519d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$247efe64d56c519d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$247efe64d56c519d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $247efe64d56c519d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$247efe64d56c519d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $247efe64d56c519d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $247efe64d56c519d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($247efe64d56c519d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $247efe64d56c519d$var$utf8Write(buf, string, offset, length) {
    return $247efe64d56c519d$var$blitBuffer($247efe64d56c519d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $247efe64d56c519d$var$asciiWrite(buf, string, offset, length) {
    return $247efe64d56c519d$var$blitBuffer($247efe64d56c519d$var$asciiToBytes(string), buf, offset, length);
}
function $247efe64d56c519d$var$base64Write(buf, string, offset, length) {
    return $247efe64d56c519d$var$blitBuffer($247efe64d56c519d$var$base64ToBytes(string), buf, offset, length);
}
function $247efe64d56c519d$var$ucs2Write(buf, string, offset, length) {
    return $247efe64d56c519d$var$blitBuffer($247efe64d56c519d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$247efe64d56c519d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $247efe64d56c519d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $247efe64d56c519d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $247efe64d56c519d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $247efe64d56c519d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $247efe64d56c519d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$247efe64d56c519d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $247efe64d56c519d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9TmCM.fromByteArray(buf);
    else return $9TmCM.fromByteArray(buf.slice(start, end));
}
function $247efe64d56c519d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $247efe64d56c519d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $247efe64d56c519d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $247efe64d56c519d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $247efe64d56c519d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $247efe64d56c519d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $247efe64d56c519d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $247efe64d56c519d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $247efe64d56c519d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $247efe64d56c519d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $247efe64d56c519d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$247efe64d56c519d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $247efe64d56c519d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $247efe64d56c519d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$247efe64d56c519d$var$Buffer.prototype.readUintLE = $247efe64d56c519d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$247efe64d56c519d$var$Buffer.prototype.readUintBE = $247efe64d56c519d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$247efe64d56c519d$var$Buffer.prototype.readUint8 = $247efe64d56c519d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$247efe64d56c519d$var$Buffer.prototype.readUint16LE = $247efe64d56c519d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$247efe64d56c519d$var$Buffer.prototype.readUint16BE = $247efe64d56c519d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$247efe64d56c519d$var$Buffer.prototype.readUint32LE = $247efe64d56c519d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$247efe64d56c519d$var$Buffer.prototype.readUint32BE = $247efe64d56c519d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$247efe64d56c519d$var$Buffer.prototype.readBigUInt64LE = $247efe64d56c519d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $247efe64d56c519d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $247efe64d56c519d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$247efe64d56c519d$var$Buffer.prototype.readBigUInt64BE = $247efe64d56c519d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $247efe64d56c519d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $247efe64d56c519d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$247efe64d56c519d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$247efe64d56c519d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$247efe64d56c519d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$247efe64d56c519d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$247efe64d56c519d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$247efe64d56c519d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$247efe64d56c519d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$247efe64d56c519d$var$Buffer.prototype.readBigInt64LE = $247efe64d56c519d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $247efe64d56c519d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $247efe64d56c519d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$247efe64d56c519d$var$Buffer.prototype.readBigInt64BE = $247efe64d56c519d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $247efe64d56c519d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $247efe64d56c519d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$247efe64d56c519d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return $9Hytc.read(this, offset, true, 23, 4);
};
$247efe64d56c519d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 4, this.length);
    return $9Hytc.read(this, offset, false, 23, 4);
};
$247efe64d56c519d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 8, this.length);
    return $9Hytc.read(this, offset, true, 52, 8);
};
$247efe64d56c519d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkOffset(offset, 8, this.length);
    return $9Hytc.read(this, offset, false, 52, 8);
};
function $247efe64d56c519d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$247efe64d56c519d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$247efe64d56c519d$var$Buffer.prototype.writeUintLE = $247efe64d56c519d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $247efe64d56c519d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$247efe64d56c519d$var$Buffer.prototype.writeUintBE = $247efe64d56c519d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $247efe64d56c519d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$247efe64d56c519d$var$Buffer.prototype.writeUint8 = $247efe64d56c519d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$247efe64d56c519d$var$Buffer.prototype.writeUint16LE = $247efe64d56c519d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$247efe64d56c519d$var$Buffer.prototype.writeUint16BE = $247efe64d56c519d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$247efe64d56c519d$var$Buffer.prototype.writeUint32LE = $247efe64d56c519d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$247efe64d56c519d$var$Buffer.prototype.writeUint32BE = $247efe64d56c519d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $247efe64d56c519d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $247efe64d56c519d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $247efe64d56c519d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $247efe64d56c519d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$247efe64d56c519d$var$Buffer.prototype.writeBigUInt64LE = $247efe64d56c519d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $247efe64d56c519d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$247efe64d56c519d$var$Buffer.prototype.writeBigUInt64BE = $247efe64d56c519d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $247efe64d56c519d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$247efe64d56c519d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $247efe64d56c519d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$247efe64d56c519d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $247efe64d56c519d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$247efe64d56c519d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$247efe64d56c519d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$247efe64d56c519d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$247efe64d56c519d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$247efe64d56c519d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$247efe64d56c519d$var$Buffer.prototype.writeBigInt64LE = $247efe64d56c519d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $247efe64d56c519d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$247efe64d56c519d$var$Buffer.prototype.writeBigInt64BE = $247efe64d56c519d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $247efe64d56c519d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $247efe64d56c519d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $247efe64d56c519d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9Hytc.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$247efe64d56c519d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $247efe64d56c519d$var$writeFloat(this, value, offset, true, noAssert);
};
$247efe64d56c519d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $247efe64d56c519d$var$writeFloat(this, value, offset, false, noAssert);
};
function $247efe64d56c519d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $247efe64d56c519d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9Hytc.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$247efe64d56c519d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $247efe64d56c519d$var$writeDouble(this, value, offset, true, noAssert);
};
$247efe64d56c519d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $247efe64d56c519d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$247efe64d56c519d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$247efe64d56c519d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$247efe64d56c519d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$247efe64d56c519d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $247efe64d56c519d$var$Buffer.isBuffer(val) ? val : $247efe64d56c519d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $247efe64d56c519d$var$errors = {};
function $247efe64d56c519d$var$E(sym, getMessage, Base) {
    $247efe64d56c519d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$247efe64d56c519d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$247efe64d56c519d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$247efe64d56c519d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $247efe64d56c519d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $247efe64d56c519d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $247efe64d56c519d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $247efe64d56c519d$var$checkBounds(buf, offset, byteLength) {
    $247efe64d56c519d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $247efe64d56c519d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $247efe64d56c519d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $247efe64d56c519d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $247efe64d56c519d$var$checkBounds(buf, offset, byteLength);
}
function $247efe64d56c519d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $247efe64d56c519d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $247efe64d56c519d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $247efe64d56c519d$var$validateNumber(value, type);
        throw new $247efe64d56c519d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $247efe64d56c519d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $247efe64d56c519d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $247efe64d56c519d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $247efe64d56c519d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($247efe64d56c519d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $247efe64d56c519d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $247efe64d56c519d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $247efe64d56c519d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $247efe64d56c519d$var$base64ToBytes(str) {
    return $9TmCM.toByteArray($247efe64d56c519d$var$base64clean(str));
}
function $247efe64d56c519d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $247efe64d56c519d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $247efe64d56c519d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $247efe64d56c519d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $247efe64d56c519d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $247efe64d56c519d$var$BufferBigIntNotDefined : fn;
}
function $247efe64d56c519d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("9TmCM", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $733accdb2879f866$export$d622b2ad8d90c771; }, function (v) { return $733accdb2879f866$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $733accdb2879f866$export$6100ba28696e12de; }, function (v) { return $733accdb2879f866$export$6100ba28696e12de = v; });
var $733accdb2879f866$export$a48f0734ac7c2329;
var $733accdb2879f866$export$d622b2ad8d90c771;
var $733accdb2879f866$export$6100ba28696e12de;
'use strict';
$733accdb2879f866$export$a48f0734ac7c2329 = $733accdb2879f866$var$byteLength;
$733accdb2879f866$export$d622b2ad8d90c771 = $733accdb2879f866$var$toByteArray;
$733accdb2879f866$export$6100ba28696e12de = $733accdb2879f866$var$fromByteArray;
var $733accdb2879f866$var$lookup = [];
var $733accdb2879f866$var$revLookup = [];
var $733accdb2879f866$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $733accdb2879f866$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $733accdb2879f866$var$i = 0, $733accdb2879f866$var$len = $733accdb2879f866$var$code.length; $733accdb2879f866$var$i < $733accdb2879f866$var$len; ++$733accdb2879f866$var$i){
    $733accdb2879f866$var$lookup[$733accdb2879f866$var$i] = $733accdb2879f866$var$code[$733accdb2879f866$var$i];
    $733accdb2879f866$var$revLookup[$733accdb2879f866$var$code.charCodeAt($733accdb2879f866$var$i)] = $733accdb2879f866$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$733accdb2879f866$var$revLookup['-'.charCodeAt(0)] = 62;
$733accdb2879f866$var$revLookup['_'.charCodeAt(0)] = 63;
function $733accdb2879f866$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $733accdb2879f866$var$byteLength(b64) {
    var lens = $733accdb2879f866$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $733accdb2879f866$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $733accdb2879f866$var$toByteArray(b64) {
    var tmp;
    var lens = $733accdb2879f866$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $733accdb2879f866$var$Arr($733accdb2879f866$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $733accdb2879f866$var$revLookup[b64.charCodeAt(i)] << 18 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $733accdb2879f866$var$revLookup[b64.charCodeAt(i)] << 2 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $733accdb2879f866$var$revLookup[b64.charCodeAt(i)] << 10 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $733accdb2879f866$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $733accdb2879f866$var$tripletToBase64(num) {
    return $733accdb2879f866$var$lookup[num >> 18 & 0x3F] + $733accdb2879f866$var$lookup[num >> 12 & 0x3F] + $733accdb2879f866$var$lookup[num >> 6 & 0x3F] + $733accdb2879f866$var$lookup[num & 0x3F];
}
function $733accdb2879f866$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($733accdb2879f866$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $733accdb2879f866$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($733accdb2879f866$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($733accdb2879f866$var$lookup[tmp >> 2] + $733accdb2879f866$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($733accdb2879f866$var$lookup[tmp >> 10] + $733accdb2879f866$var$lookup[tmp >> 4 & 0x3F] + $733accdb2879f866$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9Hytc", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $01d2a07ccfa677fa$export$aafa59e2e03f2942; }, function (v) { return $01d2a07ccfa677fa$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $01d2a07ccfa677fa$export$68d8715fc104d294; }, function (v) { return $01d2a07ccfa677fa$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $01d2a07ccfa677fa$export$aafa59e2e03f2942;
var $01d2a07ccfa677fa$export$68d8715fc104d294;
$01d2a07ccfa677fa$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$01d2a07ccfa677fa$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("9n2qp", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $6d28249726394428$export$c7c5cef950a4d2fc; });

var $ePCV8 = parcelRequire("ePCV8");

var $dleGh = parcelRequire("dleGh");
const $6d28249726394428$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $dleGh.fromUtf8)(input) : (0, $ePCV8.fromUtf8)(input);
const $6d28249726394428$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $dleGh.toUtf8)(input) : (0, $ePCV8.toUtf8)(input);

});
parcelRegister("ePCV8", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $acc404ed5febd1ca$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $acc404ed5febd1ca$export$b4b216764bb846eb; });
const $acc404ed5febd1ca$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $acc404ed5febd1ca$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("dleGh", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $9b689fd672cb78dd$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $9b689fd672cb78dd$export$b4b216764bb846eb; });
function $9b689fd672cb78dd$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $9b689fd672cb78dd$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("eevDU", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $a5caeb0ddb04369f$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $a5caeb0ddb04369f$var$isEmptyData;

});

parcelRegister("af4hG", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $774ea0d859f31e23$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $774ea0d859f31e23$var$numToUint8;

});

parcelRegister("lu7pN", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $fa4226ce00fe06a4$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $fa4226ce00fe06a4$var$uint32ArrayFrom;

});



parcelRegister("aR7W6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iigpp = parcelRequire("iigpp");

(0, $iigpp.__exportStar)((parcelRequire("jXxWH")), module.exports);

});
parcelRegister("iigpp", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $d516a2e37d9a8174$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $d516a2e37d9a8174$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $d516a2e37d9a8174$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d516a2e37d9a8174$var$extendStatics = function(d, b) {
    $d516a2e37d9a8174$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d516a2e37d9a8174$var$extendStatics(d, b);
};
function $d516a2e37d9a8174$export$a8ba968b8961cb8a(d, b) {
    $d516a2e37d9a8174$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d516a2e37d9a8174$export$18ce0697a983be9b = function() {
    $d516a2e37d9a8174$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d516a2e37d9a8174$export$18ce0697a983be9b.apply(this, arguments);
};
function $d516a2e37d9a8174$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d516a2e37d9a8174$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d516a2e37d9a8174$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d516a2e37d9a8174$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d516a2e37d9a8174$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d516a2e37d9a8174$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d516a2e37d9a8174$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d516a2e37d9a8174$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d516a2e37d9a8174$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d516a2e37d9a8174$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d516a2e37d9a8174$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d516a2e37d9a8174$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d516a2e37d9a8174$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d516a2e37d9a8174$export$10c90e4f7922046c(v) {
    return this instanceof $d516a2e37d9a8174$export$10c90e4f7922046c ? (this.v = v, this) : new $d516a2e37d9a8174$export$10c90e4f7922046c(v);
}
function $d516a2e37d9a8174$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d516a2e37d9a8174$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d516a2e37d9a8174$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d516a2e37d9a8174$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d516a2e37d9a8174$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d516a2e37d9a8174$export$19a8beecd37a4c45 === "function" ? $d516a2e37d9a8174$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d516a2e37d9a8174$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d516a2e37d9a8174$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d516a2e37d9a8174$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d516a2e37d9a8174$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d516a2e37d9a8174$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jXxWH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $iigpp = parcelRequire("iigpp");

var $9qusB = parcelRequire("9qusB");

var $gJIic = parcelRequire("gJIic");

var $hMh1g = parcelRequire("hMh1g");
var $e87ddbec3e36b6e9$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $gJIic.RawSha256();
        if (secret) {
            this.outer = new $gJIic.RawSha256();
            var inner = $e87ddbec3e36b6e9$var$bufferFromSecret(secret);
            var outer = new Uint8Array($9qusB.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $9qusB.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $hMh1g.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $hMh1g.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $iigpp.__awaiter)(this, void 0, void 0, function() {
            return (0, $iigpp.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $e87ddbec3e36b6e9$var$Sha256;
function $e87ddbec3e36b6e9$var$bufferFromSecret(secret) {
    var input = (0, $hMh1g.convertToBuffer)(secret);
    if (input.byteLength > $9qusB.BLOCK_SIZE) {
        var bufferHash = new $gJIic.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($9qusB.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("9qusB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("gJIic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $9qusB = parcelRequire("9qusB");
/**
 * @internal
 */ var $c2f334df9af526fe$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($9qusB.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $9qusB.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $9qusB.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $9qusB.BLOCK_SIZE >= $9qusB.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $9qusB.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $9qusB.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($9qusB.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($9qusB.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($9qusB.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $9qusB.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($9qusB.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $c2f334df9af526fe$var$RawSha256;

});



parcelRegister("jWBlL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i256b = parcelRequire("i256b");

$i256b.__exportStar((parcelRequire("lh6lv")), module.exports);

});
parcelRegister("i256b", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $d20c5e6384af1f04$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $d20c5e6384af1f04$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $d20c5e6384af1f04$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d20c5e6384af1f04$var$extendStatics = function(d, b) {
    $d20c5e6384af1f04$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d20c5e6384af1f04$var$extendStatics(d, b);
};
function $d20c5e6384af1f04$export$a8ba968b8961cb8a(d, b) {
    $d20c5e6384af1f04$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d20c5e6384af1f04$export$18ce0697a983be9b = function() {
    $d20c5e6384af1f04$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d20c5e6384af1f04$export$18ce0697a983be9b.apply(this, arguments);
};
function $d20c5e6384af1f04$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d20c5e6384af1f04$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d20c5e6384af1f04$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d20c5e6384af1f04$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d20c5e6384af1f04$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d20c5e6384af1f04$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d20c5e6384af1f04$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d20c5e6384af1f04$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d20c5e6384af1f04$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d20c5e6384af1f04$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d20c5e6384af1f04$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d20c5e6384af1f04$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d20c5e6384af1f04$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d20c5e6384af1f04$export$10c90e4f7922046c(v) {
    return this instanceof $d20c5e6384af1f04$export$10c90e4f7922046c ? (this.v = v, this) : new $d20c5e6384af1f04$export$10c90e4f7922046c(v);
}
function $d20c5e6384af1f04$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d20c5e6384af1f04$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d20c5e6384af1f04$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d20c5e6384af1f04$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d20c5e6384af1f04$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d20c5e6384af1f04$export$19a8beecd37a4c45 === "function" ? $d20c5e6384af1f04$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d20c5e6384af1f04$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d20c5e6384af1f04$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d20c5e6384af1f04$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d20c5e6384af1f04$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d20c5e6384af1f04$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("lh6lv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $i256b = parcelRequire("i256b");
var $f7d01ba6dd381a9d$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $f7d01ba6dd381a9d$var$supportsWebCrypto(window) {
    if ($f7d01ba6dd381a9d$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $f7d01ba6dd381a9d$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $f7d01ba6dd381a9d$var$supportsWebCrypto;
function $f7d01ba6dd381a9d$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $f7d01ba6dd381a9d$var$supportsSecureRandom;
function $f7d01ba6dd381a9d$var$supportsSubtleCrypto(subtle) {
    return subtle && $f7d01ba6dd381a9d$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $f7d01ba6dd381a9d$var$supportsSubtleCrypto;
function $f7d01ba6dd381a9d$var$supportsZeroByteGCM(subtle) {
    return $i256b.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $i256b.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$f7d01ba6dd381a9d$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $f7d01ba6dd381a9d$var$supportsZeroByteGCM;

});


parcelRegister("5k8Bf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eKknJ = parcelRequire("eKknJ");

$eKknJ.__exportStar((parcelRequire("2RWj7")), module.exports);

$eKknJ.__exportStar((parcelRequire("gO7QZ")), module.exports);

$eKknJ.__exportStar((parcelRequire("gHv4J")), module.exports);

$eKknJ.__exportStar((parcelRequire("7HXDj")), module.exports);

$eKknJ.__exportStar((parcelRequire("4mUHK")), module.exports);

});
parcelRegister("eKknJ", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $abc52bfa88b0b004$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $abc52bfa88b0b004$var$extendStatics = function(d, b) {
    $abc52bfa88b0b004$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $abc52bfa88b0b004$var$extendStatics(d, b);
};
function $abc52bfa88b0b004$export$a8ba968b8961cb8a(d, b) {
    $abc52bfa88b0b004$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $abc52bfa88b0b004$export$18ce0697a983be9b = function() {
    $abc52bfa88b0b004$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $abc52bfa88b0b004$export$18ce0697a983be9b.apply(this, arguments);
};
function $abc52bfa88b0b004$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $abc52bfa88b0b004$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $abc52bfa88b0b004$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $abc52bfa88b0b004$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $abc52bfa88b0b004$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $abc52bfa88b0b004$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $abc52bfa88b0b004$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $abc52bfa88b0b004$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $abc52bfa88b0b004$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $abc52bfa88b0b004$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $abc52bfa88b0b004$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($abc52bfa88b0b004$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $abc52bfa88b0b004$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $abc52bfa88b0b004$export$10c90e4f7922046c(v) {
    return this instanceof $abc52bfa88b0b004$export$10c90e4f7922046c ? (this.v = v, this) : new $abc52bfa88b0b004$export$10c90e4f7922046c(v);
}
function $abc52bfa88b0b004$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $abc52bfa88b0b004$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $abc52bfa88b0b004$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $abc52bfa88b0b004$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $abc52bfa88b0b004$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $abc52bfa88b0b004$export$19a8beecd37a4c45 === "function" ? $abc52bfa88b0b004$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $abc52bfa88b0b004$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $abc52bfa88b0b004$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $abc52bfa88b0b004$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $abc52bfa88b0b004$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $abc52bfa88b0b004$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("2RWj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gO7QZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gHv4J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7HXDj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4mUHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $32e533d8c883c161$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $32e533d8c883c161$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $32e533d8c883c161$var$isMsWindow(window) {
    if ($32e533d8c883c161$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $32e533d8c883c161$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $32e533d8c883c161$var$isMsWindow;

});



parcelRegister("7A0Cm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $584c5fd9ba4ee231$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $584c5fd9ba4ee231$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $584c5fd9ba4ee231$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $584c5fd9ba4ee231$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $584c5fd9ba4ee231$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $584c5fd9ba4ee231$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $584c5fd9ba4ee231$var$hasSymbol = function(name) {
    return $584c5fd9ba4ee231$var$hasSymbols() && Boolean(Symbol[name]);
};
var $584c5fd9ba4ee231$var$getSymbol = function(name) {
    return $584c5fd9ba4ee231$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($584c5fd9ba4ee231$var$hasSymbols() && !$584c5fd9ba4ee231$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $584c5fd9ba4ee231$var$SymbolIterator = $584c5fd9ba4ee231$var$getSymbol('iterator');
var $584c5fd9ba4ee231$var$SymbolObservable = $584c5fd9ba4ee231$var$getSymbol('observable');
var $584c5fd9ba4ee231$var$SymbolSpecies = $584c5fd9ba4ee231$var$getSymbol('species'); // === Abstract Operations ===
function $584c5fd9ba4ee231$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $584c5fd9ba4ee231$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$584c5fd9ba4ee231$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $584c5fd9ba4ee231$var$Observable;
}
function $584c5fd9ba4ee231$var$isObservable(x) {
    return x instanceof $584c5fd9ba4ee231$var$Observable; // SPEC: Brand check
}
function $584c5fd9ba4ee231$var$hostReportError(e) {
    if ($584c5fd9ba4ee231$var$hostReportError.log) $584c5fd9ba4ee231$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $584c5fd9ba4ee231$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $584c5fd9ba4ee231$var$hostReportError(e);
        }
    });
}
function $584c5fd9ba4ee231$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $584c5fd9ba4ee231$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $584c5fd9ba4ee231$var$hostReportError(e);
    }
}
function $584c5fd9ba4ee231$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $584c5fd9ba4ee231$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $584c5fd9ba4ee231$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $584c5fd9ba4ee231$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $584c5fd9ba4ee231$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $584c5fd9ba4ee231$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $584c5fd9ba4ee231$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $584c5fd9ba4ee231$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $584c5fd9ba4ee231$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $584c5fd9ba4ee231$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $584c5fd9ba4ee231$var$enqueue(function() {
            return $584c5fd9ba4ee231$var$flushSubscription(subscription);
        });
        return;
    }
    $584c5fd9ba4ee231$var$notifySubscription(subscription, type, value);
}
var $584c5fd9ba4ee231$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $584c5fd9ba4ee231$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $584c5fd9ba4ee231$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $584c5fd9ba4ee231$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $584c5fd9ba4ee231$var$closeSubscription(this);
                    $584c5fd9ba4ee231$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $584c5fd9ba4ee231$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $584c5fd9ba4ee231$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $584c5fd9ba4ee231$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $584c5fd9ba4ee231$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $584c5fd9ba4ee231$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $584c5fd9ba4ee231$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $584c5fd9ba4ee231$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $584c5fd9ba4ee231$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $584c5fd9ba4ee231$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $584c5fd9ba4ee231$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $584c5fd9ba4ee231$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $584c5fd9ba4ee231$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $584c5fd9ba4ee231$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $584c5fd9ba4ee231$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $584c5fd9ba4ee231$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $584c5fd9ba4ee231$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $584c5fd9ba4ee231$var$getMethod(x, $584c5fd9ba4ee231$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($584c5fd9ba4ee231$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($584c5fd9ba4ee231$var$hasSymbol('iterator')) {
                    method = $584c5fd9ba4ee231$var$getMethod(x, $584c5fd9ba4ee231$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $584c5fd9ba4ee231$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $584c5fd9ba4ee231$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $584c5fd9ba4ee231$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $584c5fd9ba4ee231$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $584c5fd9ba4ee231$var$Observable;
if ($584c5fd9ba4ee231$var$hasSymbols()) Object.defineProperty($584c5fd9ba4ee231$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $584c5fd9ba4ee231$var$SymbolObservable,
        hostReportError: $584c5fd9ba4ee231$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("asSBv", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("dluwd"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("ewqgP", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("asSBv")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("kVxtB", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("asSBv")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("hlHlW", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("asSBv")), (parcelRequire("kVxtB")), (parcelRequire("fhpxK")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("fhpxK", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("asSBv")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("3uOnC", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $28bb40dbee9f82cf$export$5f828d93ff035aa8; }, function (v) { return $28bb40dbee9f82cf$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $28bb40dbee9f82cf$export$cd94982b18c6332c; }, function (v) { return $28bb40dbee9f82cf$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $28bb40dbee9f82cf$export$1d518568e4f529b0; }, function (v) { return $28bb40dbee9f82cf$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $28bb40dbee9f82cf$export$5285b6d41c912b41; }, function (v) { return $28bb40dbee9f82cf$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $28bb40dbee9f82cf$export$2fb37efbf6ae0c0e; }, function (v) { return $28bb40dbee9f82cf$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $28bb40dbee9f82cf$export$ab85ecd77ce6a5cd; }, function (v) { return $28bb40dbee9f82cf$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $28bb40dbee9f82cf$export$da39cf97e1eb7c91; }, function (v) { return $28bb40dbee9f82cf$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $28bb40dbee9f82cf$export$52a9039d7177394f; }, function (v) { return $28bb40dbee9f82cf$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $28bb40dbee9f82cf$export$f7201db400317331; }, function (v) { return $28bb40dbee9f82cf$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $28bb40dbee9f82cf$export$448fa22aedc9dbca; }, function (v) { return $28bb40dbee9f82cf$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $28bb40dbee9f82cf$export$b80c7ba289c8fa56; }, function (v) { return $28bb40dbee9f82cf$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $28bb40dbee9f82cf$export$26e5786e8ac8e530; }, function (v) { return $28bb40dbee9f82cf$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $28bb40dbee9f82cf$export$bdd223f16383713e; }, function (v) { return $28bb40dbee9f82cf$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $28bb40dbee9f82cf$export$20533d26f07f1ee0; }, function (v) { return $28bb40dbee9f82cf$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $28bb40dbee9f82cf$export$2f64596b8cbf08b4; }, function (v) { return $28bb40dbee9f82cf$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $28bb40dbee9f82cf$export$2ce6d8d0e8b04e1a; }, function (v) { return $28bb40dbee9f82cf$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $28bb40dbee9f82cf$export$12ada9414fbc594c; }, function (v) { return $28bb40dbee9f82cf$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $28bb40dbee9f82cf$export$f5e7e39d57cd9700; }, function (v) { return $28bb40dbee9f82cf$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $28bb40dbee9f82cf$export$36b6d6ef312eab39; }, function (v) { return $28bb40dbee9f82cf$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $28bb40dbee9f82cf$export$58a258485f1e49f6; }, function (v) { return $28bb40dbee9f82cf$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $28bb40dbee9f82cf$export$dedd8dc3dc62b370; }, function (v) { return $28bb40dbee9f82cf$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $28bb40dbee9f82cf$export$971862a2fcb1bb40; }, function (v) { return $28bb40dbee9f82cf$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $28bb40dbee9f82cf$export$c6ff6a88acbeaf40; }, function (v) { return $28bb40dbee9f82cf$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $28bb40dbee9f82cf$export$fdc27893e98845cc; }, function (v) { return $28bb40dbee9f82cf$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $28bb40dbee9f82cf$export$6671fb9a1323bed; }, function (v) { return $28bb40dbee9f82cf$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $28bb40dbee9f82cf$export$d74daf141a551db; }, function (v) { return $28bb40dbee9f82cf$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $28bb40dbee9f82cf$export$45df7cae684751af; }, function (v) { return $28bb40dbee9f82cf$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $28bb40dbee9f82cf$export$1db683ad541682f6; }, function (v) { return $28bb40dbee9f82cf$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $28bb40dbee9f82cf$export$6f65485f87568e37; }, function (v) { return $28bb40dbee9f82cf$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $28bb40dbee9f82cf$export$91a8e56769aeb334; }, function (v) { return $28bb40dbee9f82cf$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $28bb40dbee9f82cf$export$2d4117e99c2179e4; }, function (v) { return $28bb40dbee9f82cf$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $28bb40dbee9f82cf$export$512823e338ddb1b7; }, function (v) { return $28bb40dbee9f82cf$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $28bb40dbee9f82cf$export$9d0e0c0c4a8d30f3; }, function (v) { return $28bb40dbee9f82cf$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $28bb40dbee9f82cf$export$b9d55ff329113abd; }, function (v) { return $28bb40dbee9f82cf$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $28bb40dbee9f82cf$export$7efb24e2fddf99b9; }, function (v) { return $28bb40dbee9f82cf$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $28bb40dbee9f82cf$export$bb1abf2ce84fc7e8; }, function (v) { return $28bb40dbee9f82cf$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $28bb40dbee9f82cf$export$2f7171e78e524d5e; }, function (v) { return $28bb40dbee9f82cf$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $28bb40dbee9f82cf$export$e1d879b482f37d98; }, function (v) { return $28bb40dbee9f82cf$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $28bb40dbee9f82cf$export$1a988e7317c65621; }, function (v) { return $28bb40dbee9f82cf$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $28bb40dbee9f82cf$export$5f828d93ff035aa8;
var $28bb40dbee9f82cf$export$cd94982b18c6332c;
var $28bb40dbee9f82cf$export$1d518568e4f529b0;
var $28bb40dbee9f82cf$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $28bb40dbee9f82cf$export$2fb37efbf6ae0c0e;
var $28bb40dbee9f82cf$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $28bb40dbee9f82cf$export$da39cf97e1eb7c91;
var $28bb40dbee9f82cf$export$52a9039d7177394f;
var $28bb40dbee9f82cf$export$f7201db400317331;
var $28bb40dbee9f82cf$export$448fa22aedc9dbca;
var $28bb40dbee9f82cf$export$b80c7ba289c8fa56;
var $28bb40dbee9f82cf$export$26e5786e8ac8e530;
var $28bb40dbee9f82cf$export$bdd223f16383713e;
var $28bb40dbee9f82cf$export$20533d26f07f1ee0;
var $28bb40dbee9f82cf$export$2f64596b8cbf08b4;
var $28bb40dbee9f82cf$export$2ce6d8d0e8b04e1a;
var $28bb40dbee9f82cf$export$12ada9414fbc594c;
var $28bb40dbee9f82cf$export$f5e7e39d57cd9700;
var $28bb40dbee9f82cf$export$36b6d6ef312eab39;
var $28bb40dbee9f82cf$export$58a258485f1e49f6;
var $28bb40dbee9f82cf$export$dedd8dc3dc62b370;
var $28bb40dbee9f82cf$export$971862a2fcb1bb40;
var $28bb40dbee9f82cf$export$c6ff6a88acbeaf40;
var $28bb40dbee9f82cf$export$fdc27893e98845cc;
var $28bb40dbee9f82cf$export$6671fb9a1323bed;
var $28bb40dbee9f82cf$export$d74daf141a551db;
var $28bb40dbee9f82cf$export$45df7cae684751af;
var $28bb40dbee9f82cf$export$1db683ad541682f6;
var $28bb40dbee9f82cf$export$6f65485f87568e37;
var $28bb40dbee9f82cf$export$91a8e56769aeb334;
var $28bb40dbee9f82cf$export$2d4117e99c2179e4;
var $28bb40dbee9f82cf$export$512823e338ddb1b7;
var $28bb40dbee9f82cf$export$9d0e0c0c4a8d30f3;
var $28bb40dbee9f82cf$export$b9d55ff329113abd;
var $28bb40dbee9f82cf$export$7efb24e2fddf99b9;
var $28bb40dbee9f82cf$export$bb1abf2ce84fc7e8;
var $28bb40dbee9f82cf$export$2f7171e78e524d5e;
var $28bb40dbee9f82cf$export$e1d879b482f37d98;
var $28bb40dbee9f82cf$export$1a988e7317c65621;
'use strict';

$28bb40dbee9f82cf$export$5f828d93ff035aa8 = $28bb40dbee9f82cf$export$cd94982b18c6332c = $28bb40dbee9f82cf$export$1d518568e4f529b0 = $28bb40dbee9f82cf$export$5285b6d41c912b41 = (parcelRequire("gYWQI"));

$28bb40dbee9f82cf$export$2fb37efbf6ae0c0e = $28bb40dbee9f82cf$export$ab85ecd77ce6a5cd = (parcelRequire("jIYxV"));

$28bb40dbee9f82cf$export$da39cf97e1eb7c91 = $28bb40dbee9f82cf$export$52a9039d7177394f = (parcelRequire("16AOW"));

var $cjBTf = parcelRequire("cjBTf");
var $28bb40dbee9f82cf$var$algoKeys = Object.keys($cjBTf);
var $28bb40dbee9f82cf$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($28bb40dbee9f82cf$var$algoKeys);
$28bb40dbee9f82cf$export$f7201db400317331 = function() {
    return $28bb40dbee9f82cf$var$hashes;
};

var $9ztwK = parcelRequire("9ztwK");
$28bb40dbee9f82cf$export$448fa22aedc9dbca = $9ztwK.pbkdf2;
$28bb40dbee9f82cf$export$b80c7ba289c8fa56 = $9ztwK.pbkdf2Sync;

var $frS5g = parcelRequire("frS5g");
$28bb40dbee9f82cf$export$26e5786e8ac8e530 = $frS5g.Cipher;
$28bb40dbee9f82cf$export$bdd223f16383713e = $frS5g.createCipher;
$28bb40dbee9f82cf$export$20533d26f07f1ee0 = $frS5g.Cipheriv;
$28bb40dbee9f82cf$export$2f64596b8cbf08b4 = $frS5g.createCipheriv;
$28bb40dbee9f82cf$export$2ce6d8d0e8b04e1a = $frS5g.Decipher;
$28bb40dbee9f82cf$export$12ada9414fbc594c = $frS5g.createDecipher;
$28bb40dbee9f82cf$export$f5e7e39d57cd9700 = $frS5g.Decipheriv;
$28bb40dbee9f82cf$export$36b6d6ef312eab39 = $frS5g.createDecipheriv;
$28bb40dbee9f82cf$export$58a258485f1e49f6 = $frS5g.getCiphers;
$28bb40dbee9f82cf$export$dedd8dc3dc62b370 = $frS5g.listCiphers;

var $dJrbL = parcelRequire("dJrbL");
$28bb40dbee9f82cf$export$971862a2fcb1bb40 = $dJrbL.DiffieHellmanGroup;
$28bb40dbee9f82cf$export$c6ff6a88acbeaf40 = $dJrbL.createDiffieHellmanGroup;
$28bb40dbee9f82cf$export$fdc27893e98845cc = $dJrbL.getDiffieHellman;
$28bb40dbee9f82cf$export$6671fb9a1323bed = $dJrbL.createDiffieHellman;
$28bb40dbee9f82cf$export$d74daf141a551db = $dJrbL.DiffieHellman;

var $dqvLe = parcelRequire("dqvLe");
$28bb40dbee9f82cf$export$45df7cae684751af = $dqvLe.createSign;
$28bb40dbee9f82cf$export$1db683ad541682f6 = $dqvLe.Sign;
$28bb40dbee9f82cf$export$6f65485f87568e37 = $dqvLe.createVerify;
$28bb40dbee9f82cf$export$91a8e56769aeb334 = $dqvLe.Verify;

$28bb40dbee9f82cf$export$2d4117e99c2179e4 = (parcelRequire("8JN1X"));

var $2edFl = parcelRequire("2edFl");
$28bb40dbee9f82cf$export$512823e338ddb1b7 = $2edFl.publicEncrypt;
$28bb40dbee9f82cf$export$9d0e0c0c4a8d30f3 = $2edFl.privateEncrypt;
$28bb40dbee9f82cf$export$b9d55ff329113abd = $2edFl.publicDecrypt;
$28bb40dbee9f82cf$export$7efb24e2fddf99b9 = $2edFl.privateDecrypt;

var $kdv2S = parcelRequire("kdv2S");
$28bb40dbee9f82cf$export$bb1abf2ce84fc7e8 = $kdv2S.randomFill;
$28bb40dbee9f82cf$export$2f7171e78e524d5e = $kdv2S.randomFillSync;
$28bb40dbee9f82cf$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$28bb40dbee9f82cf$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("gYWQI", function(module, exports) {

var $89WEd = parcelRequire("89WEd");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c5cfe62b86bbe694$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c5cfe62b86bbe694$var$MAX_UINT32 = 4294967295;
function $c5cfe62b86bbe694$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $btvME = parcelRequire("btvME");
var $c5cfe62b86bbe694$require$Buffer = $btvME.Buffer;
var $c5cfe62b86bbe694$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c5cfe62b86bbe694$var$crypto && $c5cfe62b86bbe694$var$crypto.getRandomValues) module.exports = $c5cfe62b86bbe694$var$randomBytes;
else module.exports = $c5cfe62b86bbe694$var$oldBrowser;
function $c5cfe62b86bbe694$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c5cfe62b86bbe694$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $c5cfe62b86bbe694$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c5cfe62b86bbe694$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c5cfe62b86bbe694$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c5cfe62b86bbe694$var$crypto.getRandomValues(bytes.slice(generated, generated + $c5cfe62b86bbe694$var$MAX_BYTES));
        else $c5cfe62b86bbe694$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $89WEd.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("89WEd", function(module, exports) {
// shim for using process in browser
var $5f0ca82dd44aae1a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5f0ca82dd44aae1a$var$cachedSetTimeout;
var $5f0ca82dd44aae1a$var$cachedClearTimeout;
function $5f0ca82dd44aae1a$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $5f0ca82dd44aae1a$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $5f0ca82dd44aae1a$var$cachedSetTimeout = setTimeout;
        else $5f0ca82dd44aae1a$var$cachedSetTimeout = $5f0ca82dd44aae1a$var$defaultSetTimout;
    } catch (e) {
        $5f0ca82dd44aae1a$var$cachedSetTimeout = $5f0ca82dd44aae1a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $5f0ca82dd44aae1a$var$cachedClearTimeout = clearTimeout;
        else $5f0ca82dd44aae1a$var$cachedClearTimeout = $5f0ca82dd44aae1a$var$defaultClearTimeout;
    } catch (e) {
        $5f0ca82dd44aae1a$var$cachedClearTimeout = $5f0ca82dd44aae1a$var$defaultClearTimeout;
    }
})();
function $5f0ca82dd44aae1a$var$runTimeout(fun) {
    if ($5f0ca82dd44aae1a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5f0ca82dd44aae1a$var$cachedSetTimeout === $5f0ca82dd44aae1a$var$defaultSetTimout || !$5f0ca82dd44aae1a$var$cachedSetTimeout) && setTimeout) {
        $5f0ca82dd44aae1a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5f0ca82dd44aae1a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5f0ca82dd44aae1a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5f0ca82dd44aae1a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5f0ca82dd44aae1a$var$runClearTimeout(marker) {
    if ($5f0ca82dd44aae1a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5f0ca82dd44aae1a$var$cachedClearTimeout === $5f0ca82dd44aae1a$var$defaultClearTimeout || !$5f0ca82dd44aae1a$var$cachedClearTimeout) && clearTimeout) {
        $5f0ca82dd44aae1a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5f0ca82dd44aae1a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5f0ca82dd44aae1a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5f0ca82dd44aae1a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5f0ca82dd44aae1a$var$queue = [];
var $5f0ca82dd44aae1a$var$draining = false;
var $5f0ca82dd44aae1a$var$currentQueue;
var $5f0ca82dd44aae1a$var$queueIndex = -1;
function $5f0ca82dd44aae1a$var$cleanUpNextTick() {
    if (!$5f0ca82dd44aae1a$var$draining || !$5f0ca82dd44aae1a$var$currentQueue) return;
    $5f0ca82dd44aae1a$var$draining = false;
    if ($5f0ca82dd44aae1a$var$currentQueue.length) $5f0ca82dd44aae1a$var$queue = $5f0ca82dd44aae1a$var$currentQueue.concat($5f0ca82dd44aae1a$var$queue);
    else $5f0ca82dd44aae1a$var$queueIndex = -1;
    if ($5f0ca82dd44aae1a$var$queue.length) $5f0ca82dd44aae1a$var$drainQueue();
}
function $5f0ca82dd44aae1a$var$drainQueue() {
    if ($5f0ca82dd44aae1a$var$draining) return;
    var timeout = $5f0ca82dd44aae1a$var$runTimeout($5f0ca82dd44aae1a$var$cleanUpNextTick);
    $5f0ca82dd44aae1a$var$draining = true;
    var len = $5f0ca82dd44aae1a$var$queue.length;
    while(len){
        $5f0ca82dd44aae1a$var$currentQueue = $5f0ca82dd44aae1a$var$queue;
        $5f0ca82dd44aae1a$var$queue = [];
        while(++$5f0ca82dd44aae1a$var$queueIndex < len)if ($5f0ca82dd44aae1a$var$currentQueue) $5f0ca82dd44aae1a$var$currentQueue[$5f0ca82dd44aae1a$var$queueIndex].run();
        $5f0ca82dd44aae1a$var$queueIndex = -1;
        len = $5f0ca82dd44aae1a$var$queue.length;
    }
    $5f0ca82dd44aae1a$var$currentQueue = null;
    $5f0ca82dd44aae1a$var$draining = false;
    $5f0ca82dd44aae1a$var$runClearTimeout(timeout);
}
$5f0ca82dd44aae1a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5f0ca82dd44aae1a$var$queue.push(new $5f0ca82dd44aae1a$var$Item(fun, args));
    if ($5f0ca82dd44aae1a$var$queue.length === 1 && !$5f0ca82dd44aae1a$var$draining) $5f0ca82dd44aae1a$var$runTimeout($5f0ca82dd44aae1a$var$drainQueue);
};
// v8 likes predictible objects
function $5f0ca82dd44aae1a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5f0ca82dd44aae1a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5f0ca82dd44aae1a$var$process.title = 'browser';
$5f0ca82dd44aae1a$var$process.browser = true;
$5f0ca82dd44aae1a$var$process.env = {};
$5f0ca82dd44aae1a$var$process.argv = [];
$5f0ca82dd44aae1a$var$process.version = ''; // empty string to avoid regexp issues
$5f0ca82dd44aae1a$var$process.versions = {};
function $5f0ca82dd44aae1a$var$noop() {}
$5f0ca82dd44aae1a$var$process.on = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.addListener = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.once = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.off = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.removeListener = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.removeAllListeners = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.emit = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.prependListener = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.prependOnceListener = $5f0ca82dd44aae1a$var$noop;
$5f0ca82dd44aae1a$var$process.listeners = function(name) {
    return [];
};
$5f0ca82dd44aae1a$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$5f0ca82dd44aae1a$var$process.cwd = function() {
    return '/';
};
$5f0ca82dd44aae1a$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$5f0ca82dd44aae1a$var$process.umask = function() {
    return 0;
};

});

parcelRegister("btvME", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $38gB7 = parcelRequire("38gB7");
var $85ab0ebea6541ec2$var$Buffer = $38gB7.Buffer;
// alternative to using Object.keys for old browsers
function $85ab0ebea6541ec2$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($85ab0ebea6541ec2$var$Buffer.from && $85ab0ebea6541ec2$var$Buffer.alloc && $85ab0ebea6541ec2$var$Buffer.allocUnsafe && $85ab0ebea6541ec2$var$Buffer.allocUnsafeSlow) module.exports = $38gB7;
else {
    // Copy properties from require('buffer')
    $85ab0ebea6541ec2$var$copyProps($38gB7, module.exports);
    module.exports.Buffer = $85ab0ebea6541ec2$var$SafeBuffer;
}
function $85ab0ebea6541ec2$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $85ab0ebea6541ec2$var$Buffer(arg, encodingOrOffset, length);
}
$85ab0ebea6541ec2$var$SafeBuffer.prototype = Object.create($85ab0ebea6541ec2$var$Buffer.prototype);
// Copy static methods from Buffer
$85ab0ebea6541ec2$var$copyProps($85ab0ebea6541ec2$var$Buffer, $85ab0ebea6541ec2$var$SafeBuffer);
$85ab0ebea6541ec2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $85ab0ebea6541ec2$var$Buffer(arg, encodingOrOffset, length);
};
$85ab0ebea6541ec2$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $85ab0ebea6541ec2$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$85ab0ebea6541ec2$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $85ab0ebea6541ec2$var$Buffer(size);
};
$85ab0ebea6541ec2$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $38gB7.SlowBuffer(size);
};

});


parcelRegister("jIYxV", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $7Ge75 = parcelRequire("7Ge75");

var $a8JxD = parcelRequire("a8JxD");

var $816Zj = parcelRequire("816Zj");

var $51Mbu = parcelRequire("51Mbu");
function $e5c11797fa09a527$var$Hash(hash) {
    $51Mbu.call(this, 'digest');
    this._hash = hash;
}
$h7THt($e5c11797fa09a527$var$Hash, $51Mbu);
$e5c11797fa09a527$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$e5c11797fa09a527$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $7Ge75();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $a8JxD();
    return new $e5c11797fa09a527$var$Hash($816Zj(alg));
};

});
parcelRegister("h7THt", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("7Ge75", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $7cUdb = parcelRequire("7cUdb");

var $btvME = parcelRequire("btvME");
var $59776743e702cec0$require$Buffer = $btvME.Buffer;
var $59776743e702cec0$var$ARRAY16 = new Array(16);
function $59776743e702cec0$var$MD5() {
    $7cUdb.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$h7THt($59776743e702cec0$var$MD5, $7cUdb);
$59776743e702cec0$var$MD5.prototype._update = function() {
    var M = $59776743e702cec0$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $59776743e702cec0$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $59776743e702cec0$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $59776743e702cec0$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $59776743e702cec0$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $59776743e702cec0$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $59776743e702cec0$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $59776743e702cec0$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $59776743e702cec0$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $59776743e702cec0$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $59776743e702cec0$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $59776743e702cec0$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $59776743e702cec0$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $59776743e702cec0$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $59776743e702cec0$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $59776743e702cec0$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $59776743e702cec0$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $59776743e702cec0$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $59776743e702cec0$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $59776743e702cec0$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $59776743e702cec0$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $59776743e702cec0$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $59776743e702cec0$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $59776743e702cec0$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $59776743e702cec0$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $59776743e702cec0$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $59776743e702cec0$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $59776743e702cec0$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $59776743e702cec0$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $59776743e702cec0$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $59776743e702cec0$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $59776743e702cec0$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $59776743e702cec0$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $59776743e702cec0$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $59776743e702cec0$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $59776743e702cec0$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $59776743e702cec0$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $59776743e702cec0$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $59776743e702cec0$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $59776743e702cec0$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $59776743e702cec0$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $59776743e702cec0$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $59776743e702cec0$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $59776743e702cec0$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $59776743e702cec0$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $59776743e702cec0$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $59776743e702cec0$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $59776743e702cec0$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $59776743e702cec0$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $59776743e702cec0$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $59776743e702cec0$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $59776743e702cec0$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $59776743e702cec0$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $59776743e702cec0$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $59776743e702cec0$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $59776743e702cec0$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $59776743e702cec0$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $59776743e702cec0$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $59776743e702cec0$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $59776743e702cec0$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $59776743e702cec0$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $59776743e702cec0$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $59776743e702cec0$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $59776743e702cec0$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $59776743e702cec0$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$59776743e702cec0$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $59776743e702cec0$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $59776743e702cec0$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $59776743e702cec0$var$fnF(a, b, c, d, m, k, s) {
    return $59776743e702cec0$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $59776743e702cec0$var$fnG(a, b, c, d, m, k, s) {
    return $59776743e702cec0$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $59776743e702cec0$var$fnH(a, b, c, d, m, k, s) {
    return $59776743e702cec0$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $59776743e702cec0$var$fnI(a, b, c, d, m, k, s) {
    return $59776743e702cec0$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $59776743e702cec0$var$MD5;

});
parcelRegister("7cUdb", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $53f541d4f7179e6c$require$Buffer = $btvME.Buffer;

var $8FfJf = parcelRequire("8FfJf");

var $g9mEL = parcelRequire("g9mEL");
var $53f541d4f7179e6c$require$Transform = $g9mEL.Transform;

var $h7THt = parcelRequire("h7THt");
function $53f541d4f7179e6c$var$HashBase(blockSize) {
    $53f541d4f7179e6c$require$Transform.call(this);
    this._block = $53f541d4f7179e6c$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$h7THt($53f541d4f7179e6c$var$HashBase, $53f541d4f7179e6c$require$Transform);
$53f541d4f7179e6c$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$53f541d4f7179e6c$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$53f541d4f7179e6c$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $8FfJf(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$53f541d4f7179e6c$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$53f541d4f7179e6c$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$53f541d4f7179e6c$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $53f541d4f7179e6c$var$HashBase;

});
parcelRegister("8FfJf", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $64ee5a7e43ea8744$require$Buffer = $btvME.Buffer;

var $ik3RQ = parcelRequire("ik3RQ");
var $64ee5a7e43ea8744$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $64ee5a7e43ea8744$var$useArrayBuffer = $64ee5a7e43ea8744$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $64ee5a7e43ea8744$var$isView = $64ee5a7e43ea8744$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $64ee5a7e43ea8744$require$Buffer.isBuffer(thing) || $64ee5a7e43ea8744$var$useUint8Array && thing instanceof Uint8Array || $64ee5a7e43ea8744$var$isView && $64ee5a7e43ea8744$var$isView(thing)) return $ik3RQ(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("ik3RQ", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $d56d1842bd06cee7$require$Buffer = $btvME.Buffer;

var $8q7gf = parcelRequire("8q7gf");

var $5sJhQ = parcelRequire("5sJhQ");
var $d56d1842bd06cee7$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $5sJhQ(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $d56d1842bd06cee7$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $d56d1842bd06cee7$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $d56d1842bd06cee7$var$useFromArrayBuffer = $d56d1842bd06cee7$var$useArrayBuffer && ($d56d1842bd06cee7$require$Buffer.prototype instanceof Uint8Array || $d56d1842bd06cee7$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($d56d1842bd06cee7$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $d56d1842bd06cee7$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $d56d1842bd06cee7$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($d56d1842bd06cee7$var$useArrayBuffer && $d56d1842bd06cee7$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $d56d1842bd06cee7$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($d56d1842bd06cee7$var$useFromArrayBuffer) {
            var res = $d56d1842bd06cee7$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $d56d1842bd06cee7$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($d56d1842bd06cee7$var$useUint8Array && data instanceof Uint8Array) return $d56d1842bd06cee7$require$Buffer.from(data);
    var isArr = $8q7gf(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $d56d1842bd06cee7$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $d56d1842bd06cee7$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("8q7gf", function(module, exports) {
var $62166250c95b4c0b$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $62166250c95b4c0b$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("5sJhQ", function(module, exports) {
'use strict';

var $bBDQA = parcelRequire("bBDQA");

var $a8i6o = parcelRequire("a8i6o");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $3fa2b24a38ceca19$var$$typedArrayBuffer = $a8i6o('TypedArray.prototype.buffer', true);

var $cCmuD = parcelRequire("cCmuD");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $3fa2b24a38ceca19$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$cCmuD(x)) throw new $bBDQA('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("cCmuD", function(module, exports) {
'use strict';

var $kES0E = parcelRequire("kES0E");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$kES0E(value);
};

});
parcelRegister("kES0E", function(module, exports) {
'use strict';

var $4ceO0 = parcelRequire("4ceO0");

var $j5j4W = parcelRequire("j5j4W");

var $1l2Ih = parcelRequire("1l2Ih");

var $a8i6o = parcelRequire("a8i6o");

var $eXqlJ = parcelRequire("eXqlJ");

var $ehyg4 = parcelRequire("ehyg4");
var $f0a1703b47182ef4$var$$toString = $a8i6o('Object.prototype.toString');

var $f0a1703b47182ef4$var$hasToStringTag = (parcelRequire("g1tzO"))();
var $f0a1703b47182ef4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $f0a1703b47182ef4$var$typedArrays = $j5j4W();
var $f0a1703b47182ef4$var$$slice = $a8i6o('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $f0a1703b47182ef4$var$$indexOf = $a8i6o('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $f0a1703b47182ef4$var$cache = {
    __proto__: null
};
if ($f0a1703b47182ef4$var$hasToStringTag && $eXqlJ && $ehyg4) $4ceO0($f0a1703b47182ef4$var$typedArrays, function(typedArray) {
    var arr = new $f0a1703b47182ef4$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $ehyg4) {
        var proto = $ehyg4(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $eXqlJ(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $ehyg4(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $eXqlJ(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $1l2Ih(descriptor.get);
            $f0a1703b47182ef4$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $4ceO0($f0a1703b47182ef4$var$typedArrays, function(typedArray) {
    var arr = new $f0a1703b47182ef4$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        $1l2Ih(fn);
        $f0a1703b47182ef4$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $f0a1703b47182ef4$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $4ceO0(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $f0a1703b47182ef4$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $f0a1703b47182ef4$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $f0a1703b47182ef4$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $4ceO0(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $f0a1703b47182ef4$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $f0a1703b47182ef4$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $f0a1703b47182ef4$var$isTATag(tag) {
    return $f0a1703b47182ef4$var$$indexOf($f0a1703b47182ef4$var$typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$f0a1703b47182ef4$var$hasToStringTag) {
        var tag = $f0a1703b47182ef4$var$$slice($f0a1703b47182ef4$var$$toString(value), 8, -1);
        if ($f0a1703b47182ef4$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $f0a1703b47182ef4$var$trySlices(value);
    }
    if (!$eXqlJ) return null;
     // unknown engine
    return $f0a1703b47182ef4$var$tryTypedArrays(value);
};

});
parcelRegister("4ceO0", function(module, exports) {
'use strict';

var $2sP9f = parcelRequire("2sP9f");
var $30e3c481793c809f$var$toStr = Object.prototype.toString;
var $30e3c481793c809f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $30e3c481793c809f$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($30e3c481793c809f$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $30e3c481793c809f$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $30e3c481793c809f$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($30e3c481793c809f$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $30e3c481793c809f$var$isArray(x) {
    return $30e3c481793c809f$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$2sP9f(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($30e3c481793c809f$var$isArray(list)) $30e3c481793c809f$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $30e3c481793c809f$var$forEachString(list, iterator, receiver);
    else $30e3c481793c809f$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("2sP9f", function(module, exports) {
'use strict';
var $1cb5df4110547fd1$var$fnToStr = Function.prototype.toString;
var $1cb5df4110547fd1$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1cb5df4110547fd1$var$badArrayLike;
var $1cb5df4110547fd1$var$isCallableMarker;
if (typeof $1cb5df4110547fd1$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1cb5df4110547fd1$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1cb5df4110547fd1$var$isCallableMarker;
        }
    });
    $1cb5df4110547fd1$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1cb5df4110547fd1$var$reflectApply(function() {
        throw 42;
    }, null, $1cb5df4110547fd1$var$badArrayLike);
} catch (_) {
    if (_ !== $1cb5df4110547fd1$var$isCallableMarker) $1cb5df4110547fd1$var$reflectApply = null;
}
else $1cb5df4110547fd1$var$reflectApply = null;
var $1cb5df4110547fd1$var$constructorRegex = /^\s*class\b/;
var $1cb5df4110547fd1$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1cb5df4110547fd1$var$fnToStr.call(value);
        return $1cb5df4110547fd1$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1cb5df4110547fd1$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1cb5df4110547fd1$var$isES6ClassFn(value)) return false;
        $1cb5df4110547fd1$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1cb5df4110547fd1$var$toStr = Object.prototype.toString;
var $1cb5df4110547fd1$var$objectClass = '[object Object]';
var $1cb5df4110547fd1$var$fnClass = '[object Function]';
var $1cb5df4110547fd1$var$genClass = '[object GeneratorFunction]';
var $1cb5df4110547fd1$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1cb5df4110547fd1$var$ddaClass2 = '[object HTML document.all class]';
var $1cb5df4110547fd1$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1cb5df4110547fd1$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1cb5df4110547fd1$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1cb5df4110547fd1$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1cb5df4110547fd1$var$all = document.all;
    if ($1cb5df4110547fd1$var$toStr.call($1cb5df4110547fd1$var$all) === $1cb5df4110547fd1$var$toStr.call(document.all)) $1cb5df4110547fd1$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1cb5df4110547fd1$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1cb5df4110547fd1$var$toStr.call(value);
            return (str === $1cb5df4110547fd1$var$ddaClass || str === $1cb5df4110547fd1$var$ddaClass2 || str === $1cb5df4110547fd1$var$ddaClass3 // opera 12.16
             || str === $1cb5df4110547fd1$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1cb5df4110547fd1$var$reflectApply ? function isCallable(value) {
    if ($1cb5df4110547fd1$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1cb5df4110547fd1$var$reflectApply(value, null, $1cb5df4110547fd1$var$badArrayLike);
    } catch (e) {
        if (e !== $1cb5df4110547fd1$var$isCallableMarker) return false;
    }
    return !$1cb5df4110547fd1$var$isES6ClassFn(value) && $1cb5df4110547fd1$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1cb5df4110547fd1$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1cb5df4110547fd1$var$hasToStringTag) return $1cb5df4110547fd1$var$tryFunctionObject(value);
    if ($1cb5df4110547fd1$var$isES6ClassFn(value)) return false;
    var strClass = $1cb5df4110547fd1$var$toStr.call(value);
    if (strClass !== $1cb5df4110547fd1$var$fnClass && strClass !== $1cb5df4110547fd1$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1cb5df4110547fd1$var$tryFunctionObject(value);
};

});


parcelRegister("j5j4W", function(module, exports) {
'use strict';

var $esPPb = parcelRequire("esPPb");
var $de4d489bbb4fb9e4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $esPPb.length; i++)if (typeof $de4d489bbb4fb9e4$var$g[$esPPb[i]] === 'function') // @ts-expect-error
    out[out.length] = $esPPb[i];
    return out;
};

});
parcelRegister("esPPb", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("1l2Ih", function(module, exports) {
'use strict';

var $3c1ph = parcelRequire("3c1ph");

var $hXpA9 = parcelRequire("hXpA9");

var $iauJN = parcelRequire("iauJN");

var $2CtfS = parcelRequire("2CtfS");
module.exports = function callBind(originalFunction) {
    var func = $iauJN(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $3c1ph(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($hXpA9) $hXpA9(module.exports, 'apply', {
    value: $2CtfS
});
else module.exports.apply = $2CtfS;

});
parcelRegister("3c1ph", function(module, exports) {
'use strict';

var $i30Sx = parcelRequire("i30Sx");

var $cy8Ta = parcelRequire("cy8Ta");

var $2533956e03096871$var$hasDescriptors = (parcelRequire("3nc8y"))();

var $eXqlJ = parcelRequire("eXqlJ");

var $bBDQA = parcelRequire("bBDQA");
var $2533956e03096871$var$$floor = $i30Sx('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $bBDQA('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $2533956e03096871$var$$floor(length) !== length) throw new $bBDQA('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $eXqlJ) {
        var desc = $eXqlJ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($2533956e03096871$var$hasDescriptors) $cy8Ta(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $cy8Ta(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("cy8Ta", function(module, exports) {
'use strict';

var $hXpA9 = parcelRequire("hXpA9");

var $egsoO = parcelRequire("egsoO");

var $bBDQA = parcelRequire("bBDQA");

var $eXqlJ = parcelRequire("eXqlJ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $bBDQA('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $bBDQA('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $bBDQA('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $bBDQA('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $bBDQA('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $bBDQA('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$eXqlJ && $eXqlJ(obj, property);
    if ($hXpA9) $hXpA9(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $egsoO('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("3nc8y", function(module, exports) {
'use strict';

var $hXpA9 = parcelRequire("hXpA9");
var $274cef37ca1a9a82$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$hXpA9;
};
$274cef37ca1a9a82$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$hXpA9) return null;
    try {
        return $hXpA9([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $274cef37ca1a9a82$var$hasPropertyDescriptors;

});


parcelRegister("2CtfS", function(module, exports) {
'use strict';

var $4sdmt = parcelRequire("4sdmt");

var $6sFt5 = parcelRequire("6sFt5");

var $1EfmA = parcelRequire("1EfmA");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $1EfmA($4sdmt, $6sFt5, arguments);
};

});


parcelRegister("g1tzO", function(module, exports) {
'use strict';

var $02qGK = parcelRequire("02qGK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $02qGK() && !!Symbol.toStringTag;
};

});






parcelRegister("g9mEL", function(module, exports) {

exports = module.exports = (parcelRequire("3qDbA"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("gctkR"));

exports.Duplex = (parcelRequire("bTHtj"));

exports.Transform = (parcelRequire("iiWq8"));

exports.PassThrough = (parcelRequire("gpuhl"));

});
parcelRegister("3qDbA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $89WEd = parcelRequire("89WEd");
'use strict';

var $9osaO = parcelRequire("9osaO");
/*</replacement>*/ module.exports = $27f23253f3aeffde$var$Readable;

var $gU3Ij = parcelRequire("gU3Ij");
/*</replacement>*/ /*<replacement>*/ var $27f23253f3aeffde$var$Duplex;
/*</replacement>*/ $27f23253f3aeffde$var$Readable.ReadableState = $27f23253f3aeffde$var$ReadableState;

var $hFRVt = parcelRequire("hFRVt");
var $27f23253f3aeffde$require$EE = $hFRVt.EventEmitter;
var $27f23253f3aeffde$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jZcxK = parcelRequire("jZcxK");

var $hVB8i = parcelRequire("hVB8i");
var $27f23253f3aeffde$require$Buffer = $hVB8i.Buffer;
var $27f23253f3aeffde$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $27f23253f3aeffde$var$_uint8ArrayToBuffer(chunk) {
    return $27f23253f3aeffde$require$Buffer.from(chunk);
}
function $27f23253f3aeffde$var$_isUint8Array(obj) {
    return $27f23253f3aeffde$require$Buffer.isBuffer(obj) || obj instanceof $27f23253f3aeffde$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $27f23253f3aeffde$var$util = Object.create((parcelRequire("bug1w")));

$27f23253f3aeffde$var$util.inherits = (parcelRequire("h7THt"));

var $dluwd = parcelRequire("dluwd");
var $27f23253f3aeffde$var$debug = void 0;
if ($dluwd && $dluwd.debuglog) $27f23253f3aeffde$var$debug = $dluwd.debuglog('stream');
else $27f23253f3aeffde$var$debug = function() {};

var $bhMGZ = parcelRequire("bhMGZ");

var $1OWNy = parcelRequire("1OWNy");
var $27f23253f3aeffde$var$StringDecoder;
$27f23253f3aeffde$var$util.inherits($27f23253f3aeffde$var$Readable, $jZcxK);
var $27f23253f3aeffde$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $27f23253f3aeffde$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($gU3Ij(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $27f23253f3aeffde$var$ReadableState(options, stream) {
    $27f23253f3aeffde$var$Duplex = $27f23253f3aeffde$var$Duplex || (parcelRequire("bTHtj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $27f23253f3aeffde$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bhMGZ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$27f23253f3aeffde$var$StringDecoder) $27f23253f3aeffde$var$StringDecoder = (parcelRequire("keqio")).StringDecoder;
        this.decoder = new $27f23253f3aeffde$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $27f23253f3aeffde$var$Readable(options) {
    $27f23253f3aeffde$var$Duplex = $27f23253f3aeffde$var$Duplex || (parcelRequire("bTHtj"));
    if (!(this instanceof $27f23253f3aeffde$var$Readable)) return new $27f23253f3aeffde$var$Readable(options);
    this._readableState = new $27f23253f3aeffde$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $jZcxK.call(this);
}
Object.defineProperty($27f23253f3aeffde$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$27f23253f3aeffde$var$Readable.prototype.destroy = $1OWNy.destroy;
$27f23253f3aeffde$var$Readable.prototype._undestroy = $1OWNy.undestroy;
$27f23253f3aeffde$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$27f23253f3aeffde$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $27f23253f3aeffde$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $27f23253f3aeffde$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$27f23253f3aeffde$var$Readable.prototype.unshift = function(chunk) {
    return $27f23253f3aeffde$var$readableAddChunk(this, chunk, null, true, false);
};
function $27f23253f3aeffde$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $27f23253f3aeffde$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $27f23253f3aeffde$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $27f23253f3aeffde$require$Buffer.prototype) chunk = $27f23253f3aeffde$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $27f23253f3aeffde$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $27f23253f3aeffde$var$addChunk(stream, state, chunk, false);
                    else $27f23253f3aeffde$var$maybeReadMore(stream, state);
                } else $27f23253f3aeffde$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $27f23253f3aeffde$var$needMoreData(state);
}
function $27f23253f3aeffde$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $27f23253f3aeffde$var$emitReadable(stream);
    }
    $27f23253f3aeffde$var$maybeReadMore(stream, state);
}
function $27f23253f3aeffde$var$chunkInvalid(state, chunk) {
    var er;
    if (!$27f23253f3aeffde$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $27f23253f3aeffde$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$27f23253f3aeffde$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$27f23253f3aeffde$var$Readable.prototype.setEncoding = function(enc) {
    if (!$27f23253f3aeffde$var$StringDecoder) $27f23253f3aeffde$var$StringDecoder = (parcelRequire("keqio")).StringDecoder;
    this._readableState.decoder = new $27f23253f3aeffde$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $27f23253f3aeffde$var$MAX_HWM = 0x800000;
function $27f23253f3aeffde$var$computeNewHighWaterMark(n) {
    if (n >= $27f23253f3aeffde$var$MAX_HWM) n = $27f23253f3aeffde$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $27f23253f3aeffde$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $27f23253f3aeffde$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$27f23253f3aeffde$var$Readable.prototype.read = function(n) {
    $27f23253f3aeffde$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $27f23253f3aeffde$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $27f23253f3aeffde$var$endReadable(this);
        else $27f23253f3aeffde$var$emitReadable(this);
        return null;
    }
    n = $27f23253f3aeffde$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $27f23253f3aeffde$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $27f23253f3aeffde$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $27f23253f3aeffde$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $27f23253f3aeffde$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $27f23253f3aeffde$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $27f23253f3aeffde$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $27f23253f3aeffde$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $27f23253f3aeffde$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $27f23253f3aeffde$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $27f23253f3aeffde$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $27f23253f3aeffde$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $27f23253f3aeffde$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $9osaO.nextTick($27f23253f3aeffde$var$emitReadable_, stream);
        else $27f23253f3aeffde$var$emitReadable_(stream);
    }
}
function $27f23253f3aeffde$var$emitReadable_(stream) {
    $27f23253f3aeffde$var$debug('emit readable');
    stream.emit('readable');
    $27f23253f3aeffde$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $27f23253f3aeffde$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $9osaO.nextTick($27f23253f3aeffde$var$maybeReadMore_, stream, state);
    }
}
function $27f23253f3aeffde$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $27f23253f3aeffde$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$27f23253f3aeffde$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$27f23253f3aeffde$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $27f23253f3aeffde$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $89WEd.stdout && dest !== $89WEd.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $9osaO.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $27f23253f3aeffde$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $27f23253f3aeffde$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $27f23253f3aeffde$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $27f23253f3aeffde$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $27f23253f3aeffde$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $27f23253f3aeffde$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $27f23253f3aeffde$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $27f23253f3aeffde$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($27f23253f3aeffde$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $27f23253f3aeffde$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $27f23253f3aeffde$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $27f23253f3aeffde$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $27f23253f3aeffde$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $27f23253f3aeffde$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $27f23253f3aeffde$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $27f23253f3aeffde$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $27f23253f3aeffde$var$flow(src);
        }
    };
}
$27f23253f3aeffde$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $27f23253f3aeffde$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$27f23253f3aeffde$var$Readable.prototype.on = function(ev, fn) {
    var res = $jZcxK.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $9osaO.nextTick($27f23253f3aeffde$var$nReadingNextTick, this);
            else if (state.length) $27f23253f3aeffde$var$emitReadable(this);
        }
    }
    return res;
};
$27f23253f3aeffde$var$Readable.prototype.addListener = $27f23253f3aeffde$var$Readable.prototype.on;
function $27f23253f3aeffde$var$nReadingNextTick(self1) {
    $27f23253f3aeffde$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$27f23253f3aeffde$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $27f23253f3aeffde$var$debug('resume');
        state.flowing = true;
        $27f23253f3aeffde$var$resume(this, state);
    }
    return this;
};
function $27f23253f3aeffde$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $9osaO.nextTick($27f23253f3aeffde$var$resume_, stream, state);
    }
}
function $27f23253f3aeffde$var$resume_(stream, state) {
    if (!state.reading) {
        $27f23253f3aeffde$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $27f23253f3aeffde$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$27f23253f3aeffde$var$Readable.prototype.pause = function() {
    $27f23253f3aeffde$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $27f23253f3aeffde$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $27f23253f3aeffde$var$flow(stream) {
    var state = stream._readableState;
    $27f23253f3aeffde$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$27f23253f3aeffde$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $27f23253f3aeffde$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $27f23253f3aeffde$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $27f23253f3aeffde$var$kProxyEvents.length; n++)stream.on($27f23253f3aeffde$var$kProxyEvents[n], this.emit.bind(this, $27f23253f3aeffde$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $27f23253f3aeffde$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($27f23253f3aeffde$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$27f23253f3aeffde$var$Readable._fromList = $27f23253f3aeffde$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $27f23253f3aeffde$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $27f23253f3aeffde$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $27f23253f3aeffde$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $27f23253f3aeffde$var$copyFromBufferString(n, list) : $27f23253f3aeffde$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $27f23253f3aeffde$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $27f23253f3aeffde$var$copyFromBuffer(n, list) {
    var ret = $27f23253f3aeffde$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $27f23253f3aeffde$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $9osaO.nextTick($27f23253f3aeffde$var$endReadableNT, state, stream);
    }
}
function $27f23253f3aeffde$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $27f23253f3aeffde$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("9osaO", function(module, exports) {

var $89WEd = parcelRequire("89WEd");
'use strict';
module.exports = {
    nextTick: $6d6c359304733285$var$nextTick
};
function $6d6c359304733285$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $89WEd.nextTick(fn);
        case 2:
            return $89WEd.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $89WEd.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $89WEd.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $89WEd.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("gU3Ij", function(module, exports) {
var $c4e4c1c311ac83ef$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $c4e4c1c311ac83ef$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("hFRVt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $cde018939be5f9a2$var$R = typeof Reflect === 'object' ? Reflect : null;
var $cde018939be5f9a2$var$ReflectApply = $cde018939be5f9a2$var$R && typeof $cde018939be5f9a2$var$R.apply === 'function' ? $cde018939be5f9a2$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $cde018939be5f9a2$var$ReflectOwnKeys;
if ($cde018939be5f9a2$var$R && typeof $cde018939be5f9a2$var$R.ownKeys === 'function') $cde018939be5f9a2$var$ReflectOwnKeys = $cde018939be5f9a2$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $cde018939be5f9a2$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $cde018939be5f9a2$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $cde018939be5f9a2$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $cde018939be5f9a2$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $cde018939be5f9a2$var$EventEmitter() {
    $cde018939be5f9a2$var$EventEmitter.init.call(this);
}
module.exports = $cde018939be5f9a2$var$EventEmitter;
module.exports.once = $cde018939be5f9a2$var$once;
// Backwards-compat with node 0.10.x
$cde018939be5f9a2$var$EventEmitter.EventEmitter = $cde018939be5f9a2$var$EventEmitter;
$cde018939be5f9a2$var$EventEmitter.prototype._events = undefined;
$cde018939be5f9a2$var$EventEmitter.prototype._eventsCount = 0;
$cde018939be5f9a2$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $cde018939be5f9a2$var$defaultMaxListeners = 10;
function $cde018939be5f9a2$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($cde018939be5f9a2$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $cde018939be5f9a2$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $cde018939be5f9a2$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $cde018939be5f9a2$var$defaultMaxListeners = arg;
    }
});
$cde018939be5f9a2$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$cde018939be5f9a2$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $cde018939be5f9a2$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $cde018939be5f9a2$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $cde018939be5f9a2$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$cde018939be5f9a2$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $cde018939be5f9a2$var$_getMaxListeners(this);
};
$cde018939be5f9a2$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $cde018939be5f9a2$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $cde018939be5f9a2$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$cde018939be5f9a2$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $cde018939be5f9a2$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $cde018939be5f9a2$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $cde018939be5f9a2$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $cde018939be5f9a2$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$cde018939be5f9a2$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $cde018939be5f9a2$var$_addListener(this, type, listener, false);
};
$cde018939be5f9a2$var$EventEmitter.prototype.on = $cde018939be5f9a2$var$EventEmitter.prototype.addListener;
$cde018939be5f9a2$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $cde018939be5f9a2$var$_addListener(this, type, listener, true);
};
function $cde018939be5f9a2$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $cde018939be5f9a2$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $cde018939be5f9a2$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$cde018939be5f9a2$var$EventEmitter.prototype.once = function once(type, listener) {
    $cde018939be5f9a2$var$checkListener(listener);
    this.on(type, $cde018939be5f9a2$var$_onceWrap(this, type, listener));
    return this;
};
$cde018939be5f9a2$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $cde018939be5f9a2$var$checkListener(listener);
    this.prependListener(type, $cde018939be5f9a2$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$cde018939be5f9a2$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $cde018939be5f9a2$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $cde018939be5f9a2$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$cde018939be5f9a2$var$EventEmitter.prototype.off = $cde018939be5f9a2$var$EventEmitter.prototype.removeListener;
$cde018939be5f9a2$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $cde018939be5f9a2$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $cde018939be5f9a2$var$unwrapListeners(evlistener) : $cde018939be5f9a2$var$arrayClone(evlistener, evlistener.length);
}
$cde018939be5f9a2$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $cde018939be5f9a2$var$_listeners(this, type, true);
};
$cde018939be5f9a2$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $cde018939be5f9a2$var$_listeners(this, type, false);
};
$cde018939be5f9a2$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $cde018939be5f9a2$var$listenerCount.call(emitter, type);
};
$cde018939be5f9a2$var$EventEmitter.prototype.listenerCount = $cde018939be5f9a2$var$listenerCount;
function $cde018939be5f9a2$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$cde018939be5f9a2$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $cde018939be5f9a2$var$ReflectOwnKeys(this._events) : [];
};
function $cde018939be5f9a2$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $cde018939be5f9a2$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $cde018939be5f9a2$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $cde018939be5f9a2$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $cde018939be5f9a2$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $cde018939be5f9a2$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $cde018939be5f9a2$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $cde018939be5f9a2$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $cde018939be5f9a2$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("jZcxK", function(module, exports) {

module.exports = (parcelRequire("hFRVt")).EventEmitter;

});

parcelRegister("hVB8i", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $38gB7 = parcelRequire("38gB7");
var $d0d4905d562ccdb0$var$Buffer = $38gB7.Buffer;
// alternative to using Object.keys for old browsers
function $d0d4905d562ccdb0$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d0d4905d562ccdb0$var$Buffer.from && $d0d4905d562ccdb0$var$Buffer.alloc && $d0d4905d562ccdb0$var$Buffer.allocUnsafe && $d0d4905d562ccdb0$var$Buffer.allocUnsafeSlow) module.exports = $38gB7;
else {
    // Copy properties from require('buffer')
    $d0d4905d562ccdb0$var$copyProps($38gB7, module.exports);
    module.exports.Buffer = $d0d4905d562ccdb0$var$SafeBuffer;
}
function $d0d4905d562ccdb0$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d0d4905d562ccdb0$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$d0d4905d562ccdb0$var$copyProps($d0d4905d562ccdb0$var$Buffer, $d0d4905d562ccdb0$var$SafeBuffer);
$d0d4905d562ccdb0$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d0d4905d562ccdb0$var$Buffer(arg, encodingOrOffset, length);
};
$d0d4905d562ccdb0$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d0d4905d562ccdb0$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d0d4905d562ccdb0$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d0d4905d562ccdb0$var$Buffer(size);
};
$d0d4905d562ccdb0$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $38gB7.SlowBuffer(size);
};

});

parcelRegister("bug1w", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $85ceecf841e548e5$export$43bee75e5e14138e; }, function (v) { return $85ceecf841e548e5$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $85ceecf841e548e5$export$f9ce7b637dfbe238; }, function (v) { return $85ceecf841e548e5$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $85ceecf841e548e5$export$630801d484da15df; }, function (v) { return $85ceecf841e548e5$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $85ceecf841e548e5$export$bedb7023a7733221; }, function (v) { return $85ceecf841e548e5$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $85ceecf841e548e5$export$7e4aa119212bc614; }, function (v) { return $85ceecf841e548e5$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $85ceecf841e548e5$export$844ec244b1367d54; }, function (v) { return $85ceecf841e548e5$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $85ceecf841e548e5$export$a244864fd9645c7f; }, function (v) { return $85ceecf841e548e5$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $85ceecf841e548e5$export$fce6876652108ab; }, function (v) { return $85ceecf841e548e5$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $85ceecf841e548e5$export$49841c62b9eff15; }, function (v) { return $85ceecf841e548e5$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $85ceecf841e548e5$export$a6cdc56e425d0d0a; }, function (v) { return $85ceecf841e548e5$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $85ceecf841e548e5$export$871608497c498473; }, function (v) { return $85ceecf841e548e5$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $85ceecf841e548e5$export$e6127cc7fe7395c3; }, function (v) { return $85ceecf841e548e5$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $85ceecf841e548e5$export$f6e2535fb5126e54; }, function (v) { return $85ceecf841e548e5$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $85ceecf841e548e5$export$c3825b437cbdea5c; }, function (v) { return $85ceecf841e548e5$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $85ceecf841e548e5$export$a7884ebc965f8f54; }, function (v) { return $85ceecf841e548e5$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $85ceecf841e548e5$export$43bee75e5e14138e;
var $85ceecf841e548e5$export$f9ce7b637dfbe238;
var $85ceecf841e548e5$export$630801d484da15df;
var $85ceecf841e548e5$export$bedb7023a7733221;
var $85ceecf841e548e5$export$7e4aa119212bc614;
var $85ceecf841e548e5$export$844ec244b1367d54;
var $85ceecf841e548e5$export$a244864fd9645c7f;
var $85ceecf841e548e5$export$fce6876652108ab;
var $85ceecf841e548e5$export$49841c62b9eff15;
var $85ceecf841e548e5$export$a6cdc56e425d0d0a;
var $85ceecf841e548e5$export$871608497c498473;
var $85ceecf841e548e5$export$e6127cc7fe7395c3;
var $85ceecf841e548e5$export$f6e2535fb5126e54;
var $85ceecf841e548e5$export$c3825b437cbdea5c;
var $85ceecf841e548e5$export$a7884ebc965f8f54;
function $85ceecf841e548e5$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $85ceecf841e548e5$var$objectToString(arg) === '[object Array]';
}
$85ceecf841e548e5$export$43bee75e5e14138e = $85ceecf841e548e5$var$isArray;
function $85ceecf841e548e5$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$85ceecf841e548e5$export$f9ce7b637dfbe238 = $85ceecf841e548e5$var$isBoolean;
function $85ceecf841e548e5$var$isNull(arg) {
    return arg === null;
}
$85ceecf841e548e5$export$630801d484da15df = $85ceecf841e548e5$var$isNull;
function $85ceecf841e548e5$var$isNullOrUndefined(arg) {
    return arg == null;
}
$85ceecf841e548e5$export$bedb7023a7733221 = $85ceecf841e548e5$var$isNullOrUndefined;
function $85ceecf841e548e5$var$isNumber(arg) {
    return typeof arg === 'number';
}
$85ceecf841e548e5$export$7e4aa119212bc614 = $85ceecf841e548e5$var$isNumber;
function $85ceecf841e548e5$var$isString(arg) {
    return typeof arg === 'string';
}
$85ceecf841e548e5$export$844ec244b1367d54 = $85ceecf841e548e5$var$isString;
function $85ceecf841e548e5$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$85ceecf841e548e5$export$a244864fd9645c7f = $85ceecf841e548e5$var$isSymbol;
function $85ceecf841e548e5$var$isUndefined(arg) {
    return arg === void 0;
}
$85ceecf841e548e5$export$fce6876652108ab = $85ceecf841e548e5$var$isUndefined;
function $85ceecf841e548e5$var$isRegExp(re) {
    return $85ceecf841e548e5$var$objectToString(re) === '[object RegExp]';
}
$85ceecf841e548e5$export$49841c62b9eff15 = $85ceecf841e548e5$var$isRegExp;
function $85ceecf841e548e5$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$85ceecf841e548e5$export$a6cdc56e425d0d0a = $85ceecf841e548e5$var$isObject;
function $85ceecf841e548e5$var$isDate(d) {
    return $85ceecf841e548e5$var$objectToString(d) === '[object Date]';
}
$85ceecf841e548e5$export$871608497c498473 = $85ceecf841e548e5$var$isDate;
function $85ceecf841e548e5$var$isError(e) {
    return $85ceecf841e548e5$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$85ceecf841e548e5$export$e6127cc7fe7395c3 = $85ceecf841e548e5$var$isError;
function $85ceecf841e548e5$var$isFunction(arg) {
    return typeof arg === 'function';
}
$85ceecf841e548e5$export$f6e2535fb5126e54 = $85ceecf841e548e5$var$isFunction;
function $85ceecf841e548e5$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$85ceecf841e548e5$export$c3825b437cbdea5c = $85ceecf841e548e5$var$isPrimitive;

$85ceecf841e548e5$export$a7884ebc965f8f54 = (parcelRequire("38gB7")).Buffer.isBuffer;
function $85ceecf841e548e5$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("bhMGZ", function(module, exports) {
'use strict';
function $83770d879c2120a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $hVB8i = parcelRequire("hVB8i");
var $83770d879c2120a4$require$Buffer = $hVB8i.Buffer;

var $dluwd = parcelRequire("dluwd");
function $83770d879c2120a4$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $83770d879c2120a4$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $83770d879c2120a4$require$Buffer.alloc(0);
        var ret = $83770d879c2120a4$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $83770d879c2120a4$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($dluwd && $dluwd.inspect && $dluwd.inspect.custom) module.exports.prototype[$dluwd.inspect.custom] = function() {
    var obj = $dluwd.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("1OWNy", function(module, exports) {
'use strict';

var $9osaO = parcelRequire("9osaO");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $153812128a64035a$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $9osaO.nextTick($153812128a64035a$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $9osaO.nextTick($153812128a64035a$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $9osaO.nextTick($153812128a64035a$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $9osaO.nextTick($153812128a64035a$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $153812128a64035a$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $153812128a64035a$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $153812128a64035a$var$destroy,
    undestroy: $153812128a64035a$var$undestroy
};

});

parcelRegister("bTHtj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $9osaO = parcelRequire("9osaO");
/*</replacement>*/ /*<replacement>*/ var $8a968d6004769992$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $8a968d6004769992$var$Duplex;

/*<replacement>*/ var $8a968d6004769992$var$util = Object.create((parcelRequire("bug1w")));

$8a968d6004769992$var$util.inherits = (parcelRequire("h7THt"));

var $3qDbA = parcelRequire("3qDbA");

var $gctkR = parcelRequire("gctkR");
$8a968d6004769992$var$util.inherits($8a968d6004769992$var$Duplex, $3qDbA);
// avoid scope creep, the keys array can then be collected
var $8a968d6004769992$var$keys = $8a968d6004769992$var$objectKeys($gctkR.prototype);
for(var $8a968d6004769992$var$v = 0; $8a968d6004769992$var$v < $8a968d6004769992$var$keys.length; $8a968d6004769992$var$v++){
    var $8a968d6004769992$var$method = $8a968d6004769992$var$keys[$8a968d6004769992$var$v];
    if (!$8a968d6004769992$var$Duplex.prototype[$8a968d6004769992$var$method]) $8a968d6004769992$var$Duplex.prototype[$8a968d6004769992$var$method] = $gctkR.prototype[$8a968d6004769992$var$method];
}
function $8a968d6004769992$var$Duplex(options) {
    if (!(this instanceof $8a968d6004769992$var$Duplex)) return new $8a968d6004769992$var$Duplex(options);
    $3qDbA.call(this, options);
    $gctkR.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $8a968d6004769992$var$onend);
}
Object.defineProperty($8a968d6004769992$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $8a968d6004769992$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $9osaO.nextTick($8a968d6004769992$var$onEndNT, this);
}
function $8a968d6004769992$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($8a968d6004769992$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$8a968d6004769992$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $9osaO.nextTick(cb, err);
};

});
parcelRegister("gctkR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $9osaO = parcelRequire("9osaO");
/*</replacement>*/ module.exports = $bcb485c20c95f590$var$Writable;
/* <replacement> */ function $bcb485c20c95f590$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bcb485c20c95f590$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bcb485c20c95f590$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bcb485c20c95f590$var$asyncWrite = (0, $9osaO.nextTick);
/*</replacement>*/ /*<replacement>*/ var $bcb485c20c95f590$var$Duplex;
/*</replacement>*/ $bcb485c20c95f590$var$Writable.WritableState = $bcb485c20c95f590$var$WritableState;

/*<replacement>*/ var $bcb485c20c95f590$var$util = Object.create((parcelRequire("bug1w")));

$bcb485c20c95f590$var$util.inherits = (parcelRequire("h7THt"));

/*</replacement>*/ /*<replacement>*/ var $bcb485c20c95f590$var$internalUtil = {
    deprecate: (parcelRequire("2kq0b"))
};

var $jZcxK = parcelRequire("jZcxK");

var $hVB8i = parcelRequire("hVB8i");
var $bcb485c20c95f590$require$Buffer = $hVB8i.Buffer;
var $bcb485c20c95f590$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bcb485c20c95f590$var$_uint8ArrayToBuffer(chunk) {
    return $bcb485c20c95f590$require$Buffer.from(chunk);
}
function $bcb485c20c95f590$var$_isUint8Array(obj) {
    return $bcb485c20c95f590$require$Buffer.isBuffer(obj) || obj instanceof $bcb485c20c95f590$var$OurUint8Array;
}

var $1OWNy = parcelRequire("1OWNy");
$bcb485c20c95f590$var$util.inherits($bcb485c20c95f590$var$Writable, $jZcxK);
function $bcb485c20c95f590$var$nop() {}

function $bcb485c20c95f590$var$WritableState(options, stream) {
    $bcb485c20c95f590$var$Duplex = $bcb485c20c95f590$var$Duplex || (parcelRequire("bTHtj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $bcb485c20c95f590$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bcb485c20c95f590$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bcb485c20c95f590$var$CorkedRequest(this);
}
$bcb485c20c95f590$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bcb485c20c95f590$var$WritableState.prototype, 'buffer', {
            get: $bcb485c20c95f590$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bcb485c20c95f590$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $bcb485c20c95f590$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bcb485c20c95f590$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($bcb485c20c95f590$var$realHasInstance.call(this, object)) return true;
            if (this !== $bcb485c20c95f590$var$Writable) return false;
            return object && object._writableState instanceof $bcb485c20c95f590$var$WritableState;
        }
    });
} else $bcb485c20c95f590$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $bcb485c20c95f590$var$Writable(options) {
    $bcb485c20c95f590$var$Duplex = $bcb485c20c95f590$var$Duplex || (parcelRequire("bTHtj"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$bcb485c20c95f590$var$realHasInstance.call($bcb485c20c95f590$var$Writable, this) && !(this instanceof $bcb485c20c95f590$var$Duplex)) return new $bcb485c20c95f590$var$Writable(options);
    this._writableState = new $bcb485c20c95f590$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $jZcxK.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bcb485c20c95f590$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $bcb485c20c95f590$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $9osaO.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bcb485c20c95f590$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $9osaO.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$bcb485c20c95f590$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bcb485c20c95f590$var$_isUint8Array(chunk);
    if (isBuf && !$bcb485c20c95f590$require$Buffer.isBuffer(chunk)) chunk = $bcb485c20c95f590$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $bcb485c20c95f590$var$nop;
    if (state.ended) $bcb485c20c95f590$var$writeAfterEnd(this, cb);
    else if (isBuf || $bcb485c20c95f590$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bcb485c20c95f590$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bcb485c20c95f590$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$bcb485c20c95f590$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bcb485c20c95f590$var$clearBuffer(this, state);
    }
};
$bcb485c20c95f590$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $bcb485c20c95f590$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $bcb485c20c95f590$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bcb485c20c95f590$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bcb485c20c95f590$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bcb485c20c95f590$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bcb485c20c95f590$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bcb485c20c95f590$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bcb485c20c95f590$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $9osaO.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $9osaO.nextTick($bcb485c20c95f590$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $bcb485c20c95f590$var$finishMaybe(stream, state);
    }
}
function $bcb485c20c95f590$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bcb485c20c95f590$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $bcb485c20c95f590$var$onwriteStateUpdate(state);
    if (er) $bcb485c20c95f590$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bcb485c20c95f590$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bcb485c20c95f590$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $bcb485c20c95f590$var$asyncWrite($bcb485c20c95f590$var$afterWrite, stream, state, finished, cb);
        else $bcb485c20c95f590$var$afterWrite(stream, state, finished, cb);
    }
}
function $bcb485c20c95f590$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bcb485c20c95f590$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bcb485c20c95f590$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bcb485c20c95f590$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $bcb485c20c95f590$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bcb485c20c95f590$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bcb485c20c95f590$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bcb485c20c95f590$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bcb485c20c95f590$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$bcb485c20c95f590$var$Writable.prototype._writev = null;
$bcb485c20c95f590$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bcb485c20c95f590$var$endWritable(this, state, cb);
};
function $bcb485c20c95f590$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bcb485c20c95f590$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $bcb485c20c95f590$var$finishMaybe(stream, state);
    });
}
function $bcb485c20c95f590$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $9osaO.nextTick($bcb485c20c95f590$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bcb485c20c95f590$var$finishMaybe(stream, state) {
    var need = $bcb485c20c95f590$var$needFinish(state);
    if (need) {
        $bcb485c20c95f590$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $bcb485c20c95f590$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bcb485c20c95f590$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $9osaO.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bcb485c20c95f590$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bcb485c20c95f590$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bcb485c20c95f590$var$Writable.prototype.destroy = $1OWNy.destroy;
$bcb485c20c95f590$var$Writable.prototype._undestroy = $1OWNy.undestroy;
$bcb485c20c95f590$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});
parcelRegister("2kq0b", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $1b219e74f5726236$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $1b219e74f5726236$var$deprecate(fn, msg) {
    if ($1b219e74f5726236$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1b219e74f5726236$var$config('throwDeprecation')) throw new Error(msg);
            else if ($1b219e74f5726236$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $1b219e74f5726236$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("keqio", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $eba9833f210a5921$export$63a7aa211a91ed69; }, function (v) { return $eba9833f210a5921$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $eba9833f210a5921$export$63a7aa211a91ed69;
'use strict';

var $hVB8i = parcelRequire("hVB8i");
var $eba9833f210a5921$require$Buffer = $hVB8i.Buffer;
/*</replacement>*/ var $eba9833f210a5921$var$isEncoding = $eba9833f210a5921$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $eba9833f210a5921$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $eba9833f210a5921$var$normalizeEncoding(enc) {
    var nenc = $eba9833f210a5921$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($eba9833f210a5921$require$Buffer.isEncoding === $eba9833f210a5921$var$isEncoding || !$eba9833f210a5921$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$eba9833f210a5921$export$63a7aa211a91ed69 = $eba9833f210a5921$var$StringDecoder;
function $eba9833f210a5921$var$StringDecoder(encoding) {
    this.encoding = $eba9833f210a5921$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $eba9833f210a5921$var$utf16Text;
            this.end = $eba9833f210a5921$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $eba9833f210a5921$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $eba9833f210a5921$var$base64Text;
            this.end = $eba9833f210a5921$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $eba9833f210a5921$var$simpleWrite;
            this.end = $eba9833f210a5921$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $eba9833f210a5921$require$Buffer.allocUnsafe(nb);
}
$eba9833f210a5921$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$eba9833f210a5921$var$StringDecoder.prototype.end = $eba9833f210a5921$var$utf8End;
// Returns only complete characters in a Buffer
$eba9833f210a5921$var$StringDecoder.prototype.text = $eba9833f210a5921$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$eba9833f210a5921$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $eba9833f210a5921$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $eba9833f210a5921$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $eba9833f210a5921$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $eba9833f210a5921$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $eba9833f210a5921$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $eba9833f210a5921$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $eba9833f210a5921$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $eba9833f210a5921$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $eba9833f210a5921$var$utf8Text(buf, i) {
    var total = $eba9833f210a5921$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $eba9833f210a5921$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $eba9833f210a5921$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $eba9833f210a5921$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $eba9833f210a5921$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $eba9833f210a5921$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $eba9833f210a5921$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $eba9833f210a5921$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("iiWq8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $d537398ea4663d10$var$Transform;

var $bTHtj = parcelRequire("bTHtj");

/*<replacement>*/ var $d537398ea4663d10$var$util = Object.create((parcelRequire("bug1w")));

$d537398ea4663d10$var$util.inherits = (parcelRequire("h7THt"));
/*</replacement>*/ $d537398ea4663d10$var$util.inherits($d537398ea4663d10$var$Transform, $bTHtj);
function $d537398ea4663d10$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $d537398ea4663d10$var$Transform(options) {
    if (!(this instanceof $d537398ea4663d10$var$Transform)) return new $d537398ea4663d10$var$Transform(options);
    $bTHtj.call(this, options);
    this._transformState = {
        afterTransform: $d537398ea4663d10$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $d537398ea4663d10$var$prefinish);
}
function $d537398ea4663d10$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $d537398ea4663d10$var$done(_this, er, data);
    });
    else $d537398ea4663d10$var$done(this, null, null);
}
$d537398ea4663d10$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $bTHtj.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$d537398ea4663d10$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$d537398ea4663d10$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$d537398ea4663d10$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$d537398ea4663d10$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $bTHtj.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $d537398ea4663d10$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("gpuhl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $bf2677d91ac12868$var$PassThrough;

var $iiWq8 = parcelRequire("iiWq8");

/*<replacement>*/ var $bf2677d91ac12868$var$util = Object.create((parcelRequire("bug1w")));

$bf2677d91ac12868$var$util.inherits = (parcelRequire("h7THt"));
/*</replacement>*/ $bf2677d91ac12868$var$util.inherits($bf2677d91ac12868$var$PassThrough, $iiWq8);
function $bf2677d91ac12868$var$PassThrough(options) {
    if (!(this instanceof $bf2677d91ac12868$var$PassThrough)) return new $bf2677d91ac12868$var$PassThrough(options);
    $iiWq8.call(this, options);
}
$bf2677d91ac12868$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("a8JxD", function(module, exports) {
'use strict';

var $38gB7 = parcelRequire("38gB7");
var $761dfa5a312aa94f$require$Buffer = $38gB7.Buffer;

var $h7THt = parcelRequire("h7THt");

var $7cUdb = parcelRequire("7cUdb");
var $761dfa5a312aa94f$var$ARRAY16 = new Array(16);
var $761dfa5a312aa94f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $761dfa5a312aa94f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $761dfa5a312aa94f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $761dfa5a312aa94f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $761dfa5a312aa94f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $761dfa5a312aa94f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $761dfa5a312aa94f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $761dfa5a312aa94f$var$fn1(a, b, c, d, e, m, k, s) {
    return $761dfa5a312aa94f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $761dfa5a312aa94f$var$fn2(a, b, c, d, e, m, k, s) {
    return $761dfa5a312aa94f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $761dfa5a312aa94f$var$fn3(a, b, c, d, e, m, k, s) {
    return $761dfa5a312aa94f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $761dfa5a312aa94f$var$fn4(a, b, c, d, e, m, k, s) {
    return $761dfa5a312aa94f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $761dfa5a312aa94f$var$fn5(a, b, c, d, e, m, k, s) {
    return $761dfa5a312aa94f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $761dfa5a312aa94f$var$RIPEMD160() {
    $7cUdb.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$h7THt($761dfa5a312aa94f$var$RIPEMD160, $7cUdb);
$761dfa5a312aa94f$var$RIPEMD160.prototype._update = function() {
    var words = $761dfa5a312aa94f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $761dfa5a312aa94f$var$fn1(al, bl, cl, dl, el, words[$761dfa5a312aa94f$var$zl[i]], $761dfa5a312aa94f$var$hl[0], $761dfa5a312aa94f$var$sl[i]);
            tr = $761dfa5a312aa94f$var$fn5(ar, br, cr, dr, er, words[$761dfa5a312aa94f$var$zr[i]], $761dfa5a312aa94f$var$hr[0], $761dfa5a312aa94f$var$sr[i]);
        } else if (i < 32) {
            tl = $761dfa5a312aa94f$var$fn2(al, bl, cl, dl, el, words[$761dfa5a312aa94f$var$zl[i]], $761dfa5a312aa94f$var$hl[1], $761dfa5a312aa94f$var$sl[i]);
            tr = $761dfa5a312aa94f$var$fn4(ar, br, cr, dr, er, words[$761dfa5a312aa94f$var$zr[i]], $761dfa5a312aa94f$var$hr[1], $761dfa5a312aa94f$var$sr[i]);
        } else if (i < 48) {
            tl = $761dfa5a312aa94f$var$fn3(al, bl, cl, dl, el, words[$761dfa5a312aa94f$var$zl[i]], $761dfa5a312aa94f$var$hl[2], $761dfa5a312aa94f$var$sl[i]);
            tr = $761dfa5a312aa94f$var$fn3(ar, br, cr, dr, er, words[$761dfa5a312aa94f$var$zr[i]], $761dfa5a312aa94f$var$hr[2], $761dfa5a312aa94f$var$sr[i]);
        } else if (i < 64) {
            tl = $761dfa5a312aa94f$var$fn4(al, bl, cl, dl, el, words[$761dfa5a312aa94f$var$zl[i]], $761dfa5a312aa94f$var$hl[3], $761dfa5a312aa94f$var$sl[i]);
            tr = $761dfa5a312aa94f$var$fn2(ar, br, cr, dr, er, words[$761dfa5a312aa94f$var$zr[i]], $761dfa5a312aa94f$var$hr[3], $761dfa5a312aa94f$var$sr[i]);
        } else {
            tl = $761dfa5a312aa94f$var$fn5(al, bl, cl, dl, el, words[$761dfa5a312aa94f$var$zl[i]], $761dfa5a312aa94f$var$hl[4], $761dfa5a312aa94f$var$sl[i]);
            tr = $761dfa5a312aa94f$var$fn1(ar, br, cr, dr, er, words[$761dfa5a312aa94f$var$zr[i]], $761dfa5a312aa94f$var$hr[4], $761dfa5a312aa94f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $761dfa5a312aa94f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $761dfa5a312aa94f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$761dfa5a312aa94f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $761dfa5a312aa94f$require$Buffer.alloc ? $761dfa5a312aa94f$require$Buffer.alloc(20) : new $761dfa5a312aa94f$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $761dfa5a312aa94f$var$RIPEMD160;

});

parcelRegister("816Zj", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("l9jBR"));

module.exports.sha1 = (parcelRequire("l4Jqb"));

module.exports.sha224 = (parcelRequire("cgveh"));

module.exports.sha256 = (parcelRequire("j0tt2"));

module.exports.sha384 = (parcelRequire("hT6rk"));

module.exports.sha512 = (parcelRequire("4Z3wW"));

});
parcelRegister("l9jBR", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $f659a64d7ee72882$require$Buffer = $btvME.Buffer;
var $f659a64d7ee72882$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $f659a64d7ee72882$var$W = new Array(80);
function $f659a64d7ee72882$var$Sha() {
    this.init();
    this._w = $f659a64d7ee72882$var$W;
    $9JjcS.call(this, 64, 56);
}
$h7THt($f659a64d7ee72882$var$Sha, $9JjcS);
$f659a64d7ee72882$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $f659a64d7ee72882$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $f659a64d7ee72882$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $f659a64d7ee72882$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$f659a64d7ee72882$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $f659a64d7ee72882$var$rotl5(a) + $f659a64d7ee72882$var$ft(s, b, c, d) + e + w[j] + $f659a64d7ee72882$var$K[s] | 0;
        e = d;
        d = c;
        c = $f659a64d7ee72882$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$f659a64d7ee72882$var$Sha.prototype._hash = function() {
    var H = $f659a64d7ee72882$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $f659a64d7ee72882$var$Sha;

});
parcelRegister("9JjcS", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $715737144e171008$require$Buffer = $btvME.Buffer;

var $ik3RQ = parcelRequire("ik3RQ");
// prototype class for hash functions
function $715737144e171008$var$Hash(blockSize, finalSize) {
    this._block = $715737144e171008$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$715737144e171008$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $ik3RQ(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$715737144e171008$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$715737144e171008$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $715737144e171008$var$Hash;

});


parcelRegister("l4Jqb", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $f57d346d54b1e44b$require$Buffer = $btvME.Buffer;
var $f57d346d54b1e44b$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $f57d346d54b1e44b$var$W = new Array(80);
function $f57d346d54b1e44b$var$Sha1() {
    this.init();
    this._w = $f57d346d54b1e44b$var$W;
    $9JjcS.call(this, 64, 56);
}
$h7THt($f57d346d54b1e44b$var$Sha1, $9JjcS);
$f57d346d54b1e44b$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $f57d346d54b1e44b$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $f57d346d54b1e44b$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $f57d346d54b1e44b$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $f57d346d54b1e44b$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$f57d346d54b1e44b$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $f57d346d54b1e44b$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $f57d346d54b1e44b$var$rotl5(a) + $f57d346d54b1e44b$var$ft(s, b, c, d) + e + w[j] + $f57d346d54b1e44b$var$K[s] | 0;
        e = d;
        d = c;
        c = $f57d346d54b1e44b$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$f57d346d54b1e44b$var$Sha1.prototype._hash = function() {
    var H = $f57d346d54b1e44b$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $f57d346d54b1e44b$var$Sha1;

});

parcelRegister("cgveh", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $j0tt2 = parcelRequire("j0tt2");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $8edf3424fb8a2c2a$require$Buffer = $btvME.Buffer;
var $8edf3424fb8a2c2a$var$W = new Array(64);
function $8edf3424fb8a2c2a$var$Sha224() {
    this.init();
    this._w = $8edf3424fb8a2c2a$var$W; // new Array(64)
    $9JjcS.call(this, 64, 56);
}
$h7THt($8edf3424fb8a2c2a$var$Sha224, $j0tt2);
$8edf3424fb8a2c2a$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$8edf3424fb8a2c2a$var$Sha224.prototype._hash = function() {
    var H = $8edf3424fb8a2c2a$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $8edf3424fb8a2c2a$var$Sha224;

});
parcelRegister("j0tt2", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $dd64dfff13965cc6$require$Buffer = $btvME.Buffer;
var $dd64dfff13965cc6$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $dd64dfff13965cc6$var$W = new Array(64);
function $dd64dfff13965cc6$var$Sha256() {
    this.init();
    this._w = $dd64dfff13965cc6$var$W; // new Array(64)
    $9JjcS.call(this, 64, 56);
}
$h7THt($dd64dfff13965cc6$var$Sha256, $9JjcS);
$dd64dfff13965cc6$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $dd64dfff13965cc6$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $dd64dfff13965cc6$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $dd64dfff13965cc6$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $dd64dfff13965cc6$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $dd64dfff13965cc6$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $dd64dfff13965cc6$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$dd64dfff13965cc6$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $dd64dfff13965cc6$var$gamma1(w[i - 2]) + w[i - 7] + $dd64dfff13965cc6$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $dd64dfff13965cc6$var$sigma1(e) + $dd64dfff13965cc6$var$ch(e, f, g) + $dd64dfff13965cc6$var$K[j] + w[j] | 0;
        var T2 = $dd64dfff13965cc6$var$sigma0(a) + $dd64dfff13965cc6$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$dd64dfff13965cc6$var$Sha256.prototype._hash = function() {
    var H = $dd64dfff13965cc6$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $dd64dfff13965cc6$var$Sha256;

});


parcelRegister("hT6rk", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $4Z3wW = parcelRequire("4Z3wW");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $d05c91867381df8f$require$Buffer = $btvME.Buffer;
var $d05c91867381df8f$var$W = new Array(160);
function $d05c91867381df8f$var$Sha384() {
    this.init();
    this._w = $d05c91867381df8f$var$W;
    $9JjcS.call(this, 128, 112);
}
$h7THt($d05c91867381df8f$var$Sha384, $4Z3wW);
$d05c91867381df8f$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$d05c91867381df8f$var$Sha384.prototype._hash = function() {
    var H = $d05c91867381df8f$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $d05c91867381df8f$var$Sha384;

});
parcelRegister("4Z3wW", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $9JjcS = parcelRequire("9JjcS");

var $btvME = parcelRequire("btvME");
var $3a0f98f88fb1c134$require$Buffer = $btvME.Buffer;
var $3a0f98f88fb1c134$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $3a0f98f88fb1c134$var$W = new Array(160);
function $3a0f98f88fb1c134$var$Sha512() {
    this.init();
    this._w = $3a0f98f88fb1c134$var$W;
    $9JjcS.call(this, 128, 112);
}
$h7THt($3a0f98f88fb1c134$var$Sha512, $9JjcS);
$3a0f98f88fb1c134$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $3a0f98f88fb1c134$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $3a0f98f88fb1c134$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $3a0f98f88fb1c134$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $3a0f98f88fb1c134$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $3a0f98f88fb1c134$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $3a0f98f88fb1c134$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $3a0f98f88fb1c134$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $3a0f98f88fb1c134$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $3a0f98f88fb1c134$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$3a0f98f88fb1c134$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $3a0f98f88fb1c134$var$Gamma0(xh, xl);
        var gamma0l = $3a0f98f88fb1c134$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $3a0f98f88fb1c134$var$Gamma1(xh, xl);
        var gamma1l = $3a0f98f88fb1c134$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $3a0f98f88fb1c134$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $3a0f98f88fb1c134$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $3a0f98f88fb1c134$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $3a0f98f88fb1c134$var$maj(ah, bh, ch);
        var majl = $3a0f98f88fb1c134$var$maj(al, bl, cl);
        var sigma0h = $3a0f98f88fb1c134$var$sigma0(ah, al);
        var sigma0l = $3a0f98f88fb1c134$var$sigma0(al, ah);
        var sigma1h = $3a0f98f88fb1c134$var$sigma1(eh, el);
        var sigma1l = $3a0f98f88fb1c134$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $3a0f98f88fb1c134$var$K[j];
        var Kil = $3a0f98f88fb1c134$var$K[j + 1];
        var chh = $3a0f98f88fb1c134$var$Ch(eh, fh, gh);
        var chl = $3a0f98f88fb1c134$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $3a0f98f88fb1c134$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $3a0f98f88fb1c134$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $3a0f98f88fb1c134$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $3a0f98f88fb1c134$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $3a0f98f88fb1c134$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $3a0f98f88fb1c134$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $3a0f98f88fb1c134$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $3a0f98f88fb1c134$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $3a0f98f88fb1c134$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $3a0f98f88fb1c134$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $3a0f98f88fb1c134$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $3a0f98f88fb1c134$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $3a0f98f88fb1c134$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $3a0f98f88fb1c134$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $3a0f98f88fb1c134$var$getCarry(this._hl, hl) | 0;
};
$3a0f98f88fb1c134$var$Sha512.prototype._hash = function() {
    var H = $3a0f98f88fb1c134$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $3a0f98f88fb1c134$var$Sha512;

});



parcelRegister("51Mbu", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $3a926c2549a02ebf$require$Buffer = $btvME.Buffer;

var $2u1Mw = parcelRequire("2u1Mw");
var $3a926c2549a02ebf$require$Transform = $2u1Mw.Transform;

var $gcIpI = parcelRequire("gcIpI");
var $3a926c2549a02ebf$require$StringDecoder = $gcIpI.StringDecoder;

var $h7THt = parcelRequire("h7THt");

var $ik3RQ = parcelRequire("ik3RQ");
function $3a926c2549a02ebf$var$CipherBase(hashMode) {
    $3a926c2549a02ebf$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$h7THt($3a926c2549a02ebf$var$CipherBase, $3a926c2549a02ebf$require$Transform);
$3a926c2549a02ebf$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $ik3RQ(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$3a926c2549a02ebf$var$CipherBase.prototype.setAutoPadding = function() {};
$3a926c2549a02ebf$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$3a926c2549a02ebf$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$3a926c2549a02ebf$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$3a926c2549a02ebf$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$3a926c2549a02ebf$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$3a926c2549a02ebf$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $3a926c2549a02ebf$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$3a926c2549a02ebf$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $3a926c2549a02ebf$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $3a926c2549a02ebf$var$CipherBase;

});
parcelRegister("2u1Mw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $1cefc3ecacf938cf$var$Stream;

var $hFRVt = parcelRequire("hFRVt");
var $1cefc3ecacf938cf$require$EE = $hFRVt.EventEmitter;

var $h7THt = parcelRequire("h7THt");
$h7THt($1cefc3ecacf938cf$var$Stream, $1cefc3ecacf938cf$require$EE);

$1cefc3ecacf938cf$var$Stream.Readable = (parcelRequire("5xzYw"));

$1cefc3ecacf938cf$var$Stream.Writable = (parcelRequire("aYwq4"));

$1cefc3ecacf938cf$var$Stream.Duplex = (parcelRequire("9UfBk"));

$1cefc3ecacf938cf$var$Stream.Transform = (parcelRequire("2Zcgi"));

$1cefc3ecacf938cf$var$Stream.PassThrough = (parcelRequire("aDLvt"));

$1cefc3ecacf938cf$var$Stream.finished = (parcelRequire("ffp7O"));

$1cefc3ecacf938cf$var$Stream.pipeline = (parcelRequire("k6Zq3"));
// Backwards-compat with node 0.4.x
$1cefc3ecacf938cf$var$Stream.Stream = $1cefc3ecacf938cf$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $1cefc3ecacf938cf$var$Stream() {
    $1cefc3ecacf938cf$require$EE.call(this);
}
$1cefc3ecacf938cf$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1cefc3ecacf938cf$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("5xzYw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $89WEd = parcelRequire("89WEd");
'use strict';
module.exports = $408bf0b7b15dae35$var$Readable;
/*<replacement>*/ var $408bf0b7b15dae35$var$Duplex;
/*</replacement>*/ $408bf0b7b15dae35$var$Readable.ReadableState = $408bf0b7b15dae35$var$ReadableState;

var $hFRVt = parcelRequire("hFRVt");
var $408bf0b7b15dae35$require$EE = $hFRVt.EventEmitter;
var $408bf0b7b15dae35$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $6BZs0 = parcelRequire("6BZs0");

var $38gB7 = parcelRequire("38gB7");
var $408bf0b7b15dae35$require$Buffer = $38gB7.Buffer;
var $408bf0b7b15dae35$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $408bf0b7b15dae35$var$_uint8ArrayToBuffer(chunk) {
    return $408bf0b7b15dae35$require$Buffer.from(chunk);
}
function $408bf0b7b15dae35$var$_isUint8Array(obj) {
    return $408bf0b7b15dae35$require$Buffer.isBuffer(obj) || obj instanceof $408bf0b7b15dae35$var$OurUint8Array;
}

var $dluwd = parcelRequire("dluwd");
var $408bf0b7b15dae35$var$debug;
if ($dluwd && $dluwd.debuglog) $408bf0b7b15dae35$var$debug = $dluwd.debuglog('stream');
else $408bf0b7b15dae35$var$debug = function debug() {};

var $bmp5H = parcelRequire("bmp5H");

var $iVtj6 = parcelRequire("iVtj6");

var $gYVRJ = parcelRequire("gYVRJ");
var $408bf0b7b15dae35$var$getHighWaterMark = $gYVRJ.getHighWaterMark;

var $65TCv = parcelRequire("65TCv");
var $408bf0b7b15dae35$require$_require$codes = $65TCv.codes;
var $408bf0b7b15dae35$var$ERR_INVALID_ARG_TYPE = $408bf0b7b15dae35$require$_require$codes.ERR_INVALID_ARG_TYPE, $408bf0b7b15dae35$var$ERR_STREAM_PUSH_AFTER_EOF = $408bf0b7b15dae35$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $408bf0b7b15dae35$var$ERR_METHOD_NOT_IMPLEMENTED = $408bf0b7b15dae35$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $408bf0b7b15dae35$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $408bf0b7b15dae35$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $408bf0b7b15dae35$var$StringDecoder;
var $408bf0b7b15dae35$var$createReadableStreamAsyncIterator;
var $408bf0b7b15dae35$var$from;

(parcelRequire("h7THt"))($408bf0b7b15dae35$var$Readable, $6BZs0);
var $408bf0b7b15dae35$var$errorOrDestroy = $iVtj6.errorOrDestroy;
var $408bf0b7b15dae35$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $408bf0b7b15dae35$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $408bf0b7b15dae35$var$ReadableState(options, stream, isDuplex) {
    $408bf0b7b15dae35$var$Duplex = $408bf0b7b15dae35$var$Duplex || (parcelRequire("9UfBk"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $408bf0b7b15dae35$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $408bf0b7b15dae35$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bmp5H();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$408bf0b7b15dae35$var$StringDecoder) $408bf0b7b15dae35$var$StringDecoder = (parcelRequire("gcIpI")).StringDecoder;
        this.decoder = new $408bf0b7b15dae35$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $408bf0b7b15dae35$var$Readable(options) {
    $408bf0b7b15dae35$var$Duplex = $408bf0b7b15dae35$var$Duplex || (parcelRequire("9UfBk"));
    if (!(this instanceof $408bf0b7b15dae35$var$Readable)) return new $408bf0b7b15dae35$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $408bf0b7b15dae35$var$Duplex;
    this._readableState = new $408bf0b7b15dae35$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $6BZs0.call(this);
}
Object.defineProperty($408bf0b7b15dae35$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$408bf0b7b15dae35$var$Readable.prototype.destroy = $iVtj6.destroy;
$408bf0b7b15dae35$var$Readable.prototype._undestroy = $iVtj6.undestroy;
$408bf0b7b15dae35$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$408bf0b7b15dae35$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $408bf0b7b15dae35$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $408bf0b7b15dae35$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$408bf0b7b15dae35$var$Readable.prototype.unshift = function(chunk) {
    return $408bf0b7b15dae35$var$readableAddChunk(this, chunk, null, true, false);
};
function $408bf0b7b15dae35$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $408bf0b7b15dae35$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $408bf0b7b15dae35$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $408bf0b7b15dae35$var$chunkInvalid(state, chunk);
        if (er) $408bf0b7b15dae35$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $408bf0b7b15dae35$require$Buffer.prototype) chunk = $408bf0b7b15dae35$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $408bf0b7b15dae35$var$errorOrDestroy(stream, new $408bf0b7b15dae35$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $408bf0b7b15dae35$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $408bf0b7b15dae35$var$errorOrDestroy(stream, new $408bf0b7b15dae35$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $408bf0b7b15dae35$var$addChunk(stream, state, chunk, false);
                    else $408bf0b7b15dae35$var$maybeReadMore(stream, state);
                } else $408bf0b7b15dae35$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $408bf0b7b15dae35$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $408bf0b7b15dae35$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $408bf0b7b15dae35$var$emitReadable(stream);
    }
    $408bf0b7b15dae35$var$maybeReadMore(stream, state);
}
function $408bf0b7b15dae35$var$chunkInvalid(state, chunk) {
    var er;
    if (!$408bf0b7b15dae35$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $408bf0b7b15dae35$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$408bf0b7b15dae35$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$408bf0b7b15dae35$var$Readable.prototype.setEncoding = function(enc) {
    if (!$408bf0b7b15dae35$var$StringDecoder) $408bf0b7b15dae35$var$StringDecoder = (parcelRequire("gcIpI")).StringDecoder;
    var decoder = new $408bf0b7b15dae35$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $408bf0b7b15dae35$var$MAX_HWM = 0x40000000;
function $408bf0b7b15dae35$var$computeNewHighWaterMark(n) {
    if (n >= $408bf0b7b15dae35$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $408bf0b7b15dae35$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $408bf0b7b15dae35$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $408bf0b7b15dae35$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$408bf0b7b15dae35$var$Readable.prototype.read = function(n) {
    $408bf0b7b15dae35$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $408bf0b7b15dae35$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $408bf0b7b15dae35$var$endReadable(this);
        else $408bf0b7b15dae35$var$emitReadable(this);
        return null;
    }
    n = $408bf0b7b15dae35$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $408bf0b7b15dae35$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $408bf0b7b15dae35$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $408bf0b7b15dae35$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $408bf0b7b15dae35$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $408bf0b7b15dae35$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $408bf0b7b15dae35$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $408bf0b7b15dae35$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $408bf0b7b15dae35$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $408bf0b7b15dae35$var$onEofChunk(stream, state) {
    $408bf0b7b15dae35$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $408bf0b7b15dae35$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $408bf0b7b15dae35$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $408bf0b7b15dae35$var$emitReadable(stream) {
    var state = stream._readableState;
    $408bf0b7b15dae35$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $408bf0b7b15dae35$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $89WEd.nextTick($408bf0b7b15dae35$var$emitReadable_, stream);
    }
}
function $408bf0b7b15dae35$var$emitReadable_(stream) {
    var state = stream._readableState;
    $408bf0b7b15dae35$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $408bf0b7b15dae35$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $408bf0b7b15dae35$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $89WEd.nextTick($408bf0b7b15dae35$var$maybeReadMore_, stream, state);
    }
}
function $408bf0b7b15dae35$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $408bf0b7b15dae35$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$408bf0b7b15dae35$var$Readable.prototype._read = function(n) {
    $408bf0b7b15dae35$var$errorOrDestroy(this, new $408bf0b7b15dae35$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$408bf0b7b15dae35$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $408bf0b7b15dae35$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $89WEd.stdout && dest !== $89WEd.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $89WEd.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $408bf0b7b15dae35$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $408bf0b7b15dae35$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $408bf0b7b15dae35$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $408bf0b7b15dae35$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $408bf0b7b15dae35$var$debug('ondata');
        var ret = dest.write(chunk);
        $408bf0b7b15dae35$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $408bf0b7b15dae35$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $408bf0b7b15dae35$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $408bf0b7b15dae35$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($408bf0b7b15dae35$var$EElistenerCount(dest, 'error') === 0) $408bf0b7b15dae35$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $408bf0b7b15dae35$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $408bf0b7b15dae35$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $408bf0b7b15dae35$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $408bf0b7b15dae35$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $408bf0b7b15dae35$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $408bf0b7b15dae35$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $408bf0b7b15dae35$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $408bf0b7b15dae35$var$flow(src);
        }
    };
}
$408bf0b7b15dae35$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $408bf0b7b15dae35$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$408bf0b7b15dae35$var$Readable.prototype.on = function(ev, fn) {
    var res = $6BZs0.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $408bf0b7b15dae35$var$debug('on readable', state.length, state.reading);
            if (state.length) $408bf0b7b15dae35$var$emitReadable(this);
            else if (!state.reading) $89WEd.nextTick($408bf0b7b15dae35$var$nReadingNextTick, this);
        }
    }
    return res;
};
$408bf0b7b15dae35$var$Readable.prototype.addListener = $408bf0b7b15dae35$var$Readable.prototype.on;
$408bf0b7b15dae35$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $6BZs0.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $89WEd.nextTick($408bf0b7b15dae35$var$updateReadableListening, this);
    return res;
};
$408bf0b7b15dae35$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $6BZs0.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $89WEd.nextTick($408bf0b7b15dae35$var$updateReadableListening, this);
    return res;
};
function $408bf0b7b15dae35$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $408bf0b7b15dae35$var$nReadingNextTick(self1) {
    $408bf0b7b15dae35$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$408bf0b7b15dae35$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $408bf0b7b15dae35$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $408bf0b7b15dae35$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $408bf0b7b15dae35$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $89WEd.nextTick($408bf0b7b15dae35$var$resume_, stream, state);
    }
}
function $408bf0b7b15dae35$var$resume_(stream, state) {
    $408bf0b7b15dae35$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $408bf0b7b15dae35$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$408bf0b7b15dae35$var$Readable.prototype.pause = function() {
    $408bf0b7b15dae35$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $408bf0b7b15dae35$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $408bf0b7b15dae35$var$flow(stream) {
    var state = stream._readableState;
    $408bf0b7b15dae35$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$408bf0b7b15dae35$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $408bf0b7b15dae35$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $408bf0b7b15dae35$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $408bf0b7b15dae35$var$kProxyEvents.length; n++)stream.on($408bf0b7b15dae35$var$kProxyEvents[n], this.emit.bind(this, $408bf0b7b15dae35$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $408bf0b7b15dae35$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $408bf0b7b15dae35$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($408bf0b7b15dae35$var$createReadableStreamAsyncIterator === undefined) $408bf0b7b15dae35$var$createReadableStreamAsyncIterator = (parcelRequire("9fsjZ"));
    return $408bf0b7b15dae35$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($408bf0b7b15dae35$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($408bf0b7b15dae35$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($408bf0b7b15dae35$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$408bf0b7b15dae35$var$Readable._fromList = $408bf0b7b15dae35$var$fromList;
Object.defineProperty($408bf0b7b15dae35$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $408bf0b7b15dae35$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $408bf0b7b15dae35$var$endReadable(stream) {
    var state = stream._readableState;
    $408bf0b7b15dae35$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $89WEd.nextTick($408bf0b7b15dae35$var$endReadableNT, state, stream);
    }
}
function $408bf0b7b15dae35$var$endReadableNT(state, stream) {
    $408bf0b7b15dae35$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $408bf0b7b15dae35$var$Readable.from = function(iterable, opts) {
    if ($408bf0b7b15dae35$var$from === undefined) $408bf0b7b15dae35$var$from = (parcelRequire("b4IFv"));
    return $408bf0b7b15dae35$var$from($408bf0b7b15dae35$var$Readable, iterable, opts);
};
function $408bf0b7b15dae35$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("6BZs0", function(module, exports) {

module.exports = (parcelRequire("hFRVt")).EventEmitter;

});

parcelRegister("bmp5H", function(module, exports) {
'use strict';
function $8455364f72acf151$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8455364f72acf151$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8455364f72acf151$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8455364f72acf151$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8455364f72acf151$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8455364f72acf151$var$_defineProperty(obj, key, value) {
    key = $8455364f72acf151$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8455364f72acf151$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8455364f72acf151$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8455364f72acf151$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8455364f72acf151$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8455364f72acf151$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8455364f72acf151$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8455364f72acf151$var$_toPropertyKey(arg) {
    var key = $8455364f72acf151$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8455364f72acf151$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $38gB7 = parcelRequire("38gB7");
var $8455364f72acf151$var$Buffer = $38gB7.Buffer;

var $dluwd = parcelRequire("dluwd");
var $8455364f72acf151$var$inspect = $dluwd.inspect;
var $8455364f72acf151$var$custom = $8455364f72acf151$var$inspect && $8455364f72acf151$var$inspect.custom || 'inspect';
function $8455364f72acf151$var$copyBuffer(src, target, offset) {
    $8455364f72acf151$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $8455364f72acf151$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $8455364f72acf151$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $8455364f72acf151$var$Buffer.alloc(0);
                var ret = $8455364f72acf151$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $8455364f72acf151$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $8455364f72acf151$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $8455364f72acf151$var$custom,
            value: function value(_, options) {
                return $8455364f72acf151$var$inspect(this, $8455364f72acf151$var$_objectSpread($8455364f72acf151$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("iVtj6", function(module, exports) {

var $89WEd = parcelRequire("89WEd");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $dc7448abcf7ff5ff$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $89WEd.nextTick($dc7448abcf7ff5ff$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $89WEd.nextTick($dc7448abcf7ff5ff$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $89WEd.nextTick($dc7448abcf7ff5ff$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $89WEd.nextTick($dc7448abcf7ff5ff$var$emitErrorAndCloseNT, _this, err);
            } else $89WEd.nextTick($dc7448abcf7ff5ff$var$emitCloseNT, _this);
        } else if (cb) {
            $89WEd.nextTick($dc7448abcf7ff5ff$var$emitCloseNT, _this);
            cb(err);
        } else $89WEd.nextTick($dc7448abcf7ff5ff$var$emitCloseNT, _this);
    });
    return this;
}
function $dc7448abcf7ff5ff$var$emitErrorAndCloseNT(self, err) {
    $dc7448abcf7ff5ff$var$emitErrorNT(self, err);
    $dc7448abcf7ff5ff$var$emitCloseNT(self);
}
function $dc7448abcf7ff5ff$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $dc7448abcf7ff5ff$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $dc7448abcf7ff5ff$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $dc7448abcf7ff5ff$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $dc7448abcf7ff5ff$var$destroy,
    undestroy: $dc7448abcf7ff5ff$var$undestroy,
    errorOrDestroy: $dc7448abcf7ff5ff$var$errorOrDestroy
};

});

parcelRegister("gYVRJ", function(module, exports) {
'use strict';

var $c5cf22dac7538e2e$var$ERR_INVALID_OPT_VALUE = (parcelRequire("65TCv")).codes.ERR_INVALID_OPT_VALUE;
function $c5cf22dac7538e2e$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c5cf22dac7538e2e$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c5cf22dac7538e2e$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $c5cf22dac7538e2e$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $c5cf22dac7538e2e$var$getHighWaterMark
};

});
parcelRegister("65TCv", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $46fe5aaf16b554d6$export$e45cb6485273080e; }, function (v) { return $46fe5aaf16b554d6$export$e45cb6485273080e = v; });
var $46fe5aaf16b554d6$export$e45cb6485273080e;
'use strict';
function $46fe5aaf16b554d6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $46fe5aaf16b554d6$var$codes = {};
function $46fe5aaf16b554d6$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $46fe5aaf16b554d6$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $46fe5aaf16b554d6$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $46fe5aaf16b554d6$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $46fe5aaf16b554d6$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $46fe5aaf16b554d6$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $46fe5aaf16b554d6$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$46fe5aaf16b554d6$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$46fe5aaf16b554d6$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $46fe5aaf16b554d6$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($46fe5aaf16b554d6$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($46fe5aaf16b554d6$var$oneOf(expected, 'type'));
    else {
        var type = $46fe5aaf16b554d6$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($46fe5aaf16b554d6$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$46fe5aaf16b554d6$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$46fe5aaf16b554d6$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$46fe5aaf16b554d6$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$46fe5aaf16b554d6$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$46fe5aaf16b554d6$export$e45cb6485273080e = $46fe5aaf16b554d6$var$codes;

});


parcelRegister("9UfBk", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $89WEd = parcelRequire("89WEd");
'use strict';
/*<replacement>*/ var $7365721403ae4799$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $7365721403ae4799$var$Duplex;

var $5xzYw = parcelRequire("5xzYw");

var $aYwq4 = parcelRequire("aYwq4");

(parcelRequire("h7THt"))($7365721403ae4799$var$Duplex, $5xzYw);
// Allow the keys array to be GC'ed.
var $7365721403ae4799$var$keys = $7365721403ae4799$var$objectKeys($aYwq4.prototype);
for(var $7365721403ae4799$var$v = 0; $7365721403ae4799$var$v < $7365721403ae4799$var$keys.length; $7365721403ae4799$var$v++){
    var $7365721403ae4799$var$method = $7365721403ae4799$var$keys[$7365721403ae4799$var$v];
    if (!$7365721403ae4799$var$Duplex.prototype[$7365721403ae4799$var$method]) $7365721403ae4799$var$Duplex.prototype[$7365721403ae4799$var$method] = $aYwq4.prototype[$7365721403ae4799$var$method];
}
function $7365721403ae4799$var$Duplex(options) {
    if (!(this instanceof $7365721403ae4799$var$Duplex)) return new $7365721403ae4799$var$Duplex(options);
    $5xzYw.call(this, options);
    $aYwq4.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $7365721403ae4799$var$onend);
        }
    }
}
Object.defineProperty($7365721403ae4799$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($7365721403ae4799$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($7365721403ae4799$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $7365721403ae4799$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $89WEd.nextTick($7365721403ae4799$var$onEndNT, this);
}
function $7365721403ae4799$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($7365721403ae4799$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("aYwq4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $89WEd = parcelRequire("89WEd");
'use strict';
module.exports = $7fd8a7ce63a3f14f$var$Writable;
/* <replacement> */ function $7fd8a7ce63a3f14f$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $7fd8a7ce63a3f14f$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $7fd8a7ce63a3f14f$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $7fd8a7ce63a3f14f$var$Duplex;
/*</replacement>*/ $7fd8a7ce63a3f14f$var$Writable.WritableState = $7fd8a7ce63a3f14f$var$WritableState;

/*<replacement>*/ var $7fd8a7ce63a3f14f$var$internalUtil = {
    deprecate: (parcelRequire("2kq0b"))
};

var $6BZs0 = parcelRequire("6BZs0");

var $38gB7 = parcelRequire("38gB7");
var $7fd8a7ce63a3f14f$require$Buffer = $38gB7.Buffer;
var $7fd8a7ce63a3f14f$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $7fd8a7ce63a3f14f$var$_uint8ArrayToBuffer(chunk) {
    return $7fd8a7ce63a3f14f$require$Buffer.from(chunk);
}
function $7fd8a7ce63a3f14f$var$_isUint8Array(obj) {
    return $7fd8a7ce63a3f14f$require$Buffer.isBuffer(obj) || obj instanceof $7fd8a7ce63a3f14f$var$OurUint8Array;
}

var $iVtj6 = parcelRequire("iVtj6");

var $gYVRJ = parcelRequire("gYVRJ");
var $7fd8a7ce63a3f14f$var$getHighWaterMark = $gYVRJ.getHighWaterMark;

var $65TCv = parcelRequire("65TCv");
var $7fd8a7ce63a3f14f$require$_require$codes = $65TCv.codes;
var $7fd8a7ce63a3f14f$var$ERR_INVALID_ARG_TYPE = $7fd8a7ce63a3f14f$require$_require$codes.ERR_INVALID_ARG_TYPE, $7fd8a7ce63a3f14f$var$ERR_METHOD_NOT_IMPLEMENTED = $7fd8a7ce63a3f14f$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7fd8a7ce63a3f14f$var$ERR_MULTIPLE_CALLBACK = $7fd8a7ce63a3f14f$require$_require$codes.ERR_MULTIPLE_CALLBACK, $7fd8a7ce63a3f14f$var$ERR_STREAM_CANNOT_PIPE = $7fd8a7ce63a3f14f$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $7fd8a7ce63a3f14f$var$ERR_STREAM_DESTROYED = $7fd8a7ce63a3f14f$require$_require$codes.ERR_STREAM_DESTROYED, $7fd8a7ce63a3f14f$var$ERR_STREAM_NULL_VALUES = $7fd8a7ce63a3f14f$require$_require$codes.ERR_STREAM_NULL_VALUES, $7fd8a7ce63a3f14f$var$ERR_STREAM_WRITE_AFTER_END = $7fd8a7ce63a3f14f$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $7fd8a7ce63a3f14f$var$ERR_UNKNOWN_ENCODING = $7fd8a7ce63a3f14f$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $7fd8a7ce63a3f14f$var$errorOrDestroy = $iVtj6.errorOrDestroy;

(parcelRequire("h7THt"))($7fd8a7ce63a3f14f$var$Writable, $6BZs0);
function $7fd8a7ce63a3f14f$var$nop() {}

function $7fd8a7ce63a3f14f$var$WritableState(options, stream, isDuplex) {
    $7fd8a7ce63a3f14f$var$Duplex = $7fd8a7ce63a3f14f$var$Duplex || (parcelRequire("9UfBk"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $7fd8a7ce63a3f14f$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $7fd8a7ce63a3f14f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $7fd8a7ce63a3f14f$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $7fd8a7ce63a3f14f$var$CorkedRequest(this);
}
$7fd8a7ce63a3f14f$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($7fd8a7ce63a3f14f$var$WritableState.prototype, 'buffer', {
            get: $7fd8a7ce63a3f14f$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $7fd8a7ce63a3f14f$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $7fd8a7ce63a3f14f$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($7fd8a7ce63a3f14f$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($7fd8a7ce63a3f14f$var$realHasInstance.call(this, object)) return true;
            if (this !== $7fd8a7ce63a3f14f$var$Writable) return false;
            return object && object._writableState instanceof $7fd8a7ce63a3f14f$var$WritableState;
        }
    });
} else $7fd8a7ce63a3f14f$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $7fd8a7ce63a3f14f$var$Writable(options) {
    $7fd8a7ce63a3f14f$var$Duplex = $7fd8a7ce63a3f14f$var$Duplex || (parcelRequire("9UfBk"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7fd8a7ce63a3f14f$var$Duplex;
    if (!isDuplex && !$7fd8a7ce63a3f14f$var$realHasInstance.call($7fd8a7ce63a3f14f$var$Writable, this)) return new $7fd8a7ce63a3f14f$var$Writable(options);
    this._writableState = new $7fd8a7ce63a3f14f$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $6BZs0.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$7fd8a7ce63a3f14f$var$Writable.prototype.pipe = function() {
    $7fd8a7ce63a3f14f$var$errorOrDestroy(this, new $7fd8a7ce63a3f14f$var$ERR_STREAM_CANNOT_PIPE());
};
function $7fd8a7ce63a3f14f$var$writeAfterEnd(stream, cb) {
    var er = new $7fd8a7ce63a3f14f$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $7fd8a7ce63a3f14f$var$errorOrDestroy(stream, er);
    $89WEd.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $7fd8a7ce63a3f14f$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $7fd8a7ce63a3f14f$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $7fd8a7ce63a3f14f$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $7fd8a7ce63a3f14f$var$errorOrDestroy(stream, er);
        $89WEd.nextTick(cb, er);
        return false;
    }
    return true;
}
$7fd8a7ce63a3f14f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $7fd8a7ce63a3f14f$var$_isUint8Array(chunk);
    if (isBuf && !$7fd8a7ce63a3f14f$require$Buffer.isBuffer(chunk)) chunk = $7fd8a7ce63a3f14f$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $7fd8a7ce63a3f14f$var$nop;
    if (state.ending) $7fd8a7ce63a3f14f$var$writeAfterEnd(this, cb);
    else if (isBuf || $7fd8a7ce63a3f14f$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $7fd8a7ce63a3f14f$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$7fd8a7ce63a3f14f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$7fd8a7ce63a3f14f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $7fd8a7ce63a3f14f$var$clearBuffer(this, state);
    }
};
$7fd8a7ce63a3f14f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $7fd8a7ce63a3f14f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($7fd8a7ce63a3f14f$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $7fd8a7ce63a3f14f$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $7fd8a7ce63a3f14f$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($7fd8a7ce63a3f14f$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $7fd8a7ce63a3f14f$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $7fd8a7ce63a3f14f$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $7fd8a7ce63a3f14f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $7fd8a7ce63a3f14f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $7fd8a7ce63a3f14f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $7fd8a7ce63a3f14f$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $89WEd.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $89WEd.nextTick($7fd8a7ce63a3f14f$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $7fd8a7ce63a3f14f$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $7fd8a7ce63a3f14f$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $7fd8a7ce63a3f14f$var$finishMaybe(stream, state);
    }
}
function $7fd8a7ce63a3f14f$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $7fd8a7ce63a3f14f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $7fd8a7ce63a3f14f$var$ERR_MULTIPLE_CALLBACK();
    $7fd8a7ce63a3f14f$var$onwriteStateUpdate(state);
    if (er) $7fd8a7ce63a3f14f$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $7fd8a7ce63a3f14f$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $7fd8a7ce63a3f14f$var$clearBuffer(stream, state);
        if (sync) $89WEd.nextTick($7fd8a7ce63a3f14f$var$afterWrite, stream, state, finished, cb);
        else $7fd8a7ce63a3f14f$var$afterWrite(stream, state, finished, cb);
    }
}
function $7fd8a7ce63a3f14f$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $7fd8a7ce63a3f14f$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $7fd8a7ce63a3f14f$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $7fd8a7ce63a3f14f$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $7fd8a7ce63a3f14f$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $7fd8a7ce63a3f14f$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $7fd8a7ce63a3f14f$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $7fd8a7ce63a3f14f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$7fd8a7ce63a3f14f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $7fd8a7ce63a3f14f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$7fd8a7ce63a3f14f$var$Writable.prototype._writev = null;
$7fd8a7ce63a3f14f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $7fd8a7ce63a3f14f$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($7fd8a7ce63a3f14f$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $7fd8a7ce63a3f14f$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $7fd8a7ce63a3f14f$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $7fd8a7ce63a3f14f$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $7fd8a7ce63a3f14f$var$finishMaybe(stream, state);
    });
}
function $7fd8a7ce63a3f14f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $89WEd.nextTick($7fd8a7ce63a3f14f$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $7fd8a7ce63a3f14f$var$finishMaybe(stream, state) {
    var need = $7fd8a7ce63a3f14f$var$needFinish(state);
    if (need) {
        $7fd8a7ce63a3f14f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $7fd8a7ce63a3f14f$var$endWritable(stream, state, cb) {
    state.ending = true;
    $7fd8a7ce63a3f14f$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $89WEd.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $7fd8a7ce63a3f14f$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($7fd8a7ce63a3f14f$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$7fd8a7ce63a3f14f$var$Writable.prototype.destroy = $iVtj6.destroy;
$7fd8a7ce63a3f14f$var$Writable.prototype._undestroy = $iVtj6.undestroy;
$7fd8a7ce63a3f14f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("gcIpI", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $bcc037ff786ab17e$export$63a7aa211a91ed69; }, function (v) { return $bcc037ff786ab17e$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $bcc037ff786ab17e$export$63a7aa211a91ed69;
'use strict';

var $btvME = parcelRequire("btvME");
var $bcc037ff786ab17e$require$Buffer = $btvME.Buffer;
/*</replacement>*/ var $bcc037ff786ab17e$var$isEncoding = $bcc037ff786ab17e$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $bcc037ff786ab17e$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $bcc037ff786ab17e$var$normalizeEncoding(enc) {
    var nenc = $bcc037ff786ab17e$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($bcc037ff786ab17e$require$Buffer.isEncoding === $bcc037ff786ab17e$var$isEncoding || !$bcc037ff786ab17e$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$bcc037ff786ab17e$export$63a7aa211a91ed69 = $bcc037ff786ab17e$var$StringDecoder;
function $bcc037ff786ab17e$var$StringDecoder(encoding) {
    this.encoding = $bcc037ff786ab17e$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $bcc037ff786ab17e$var$utf16Text;
            this.end = $bcc037ff786ab17e$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $bcc037ff786ab17e$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $bcc037ff786ab17e$var$base64Text;
            this.end = $bcc037ff786ab17e$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $bcc037ff786ab17e$var$simpleWrite;
            this.end = $bcc037ff786ab17e$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $bcc037ff786ab17e$require$Buffer.allocUnsafe(nb);
}
$bcc037ff786ab17e$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$bcc037ff786ab17e$var$StringDecoder.prototype.end = $bcc037ff786ab17e$var$utf8End;
// Returns only complete characters in a Buffer
$bcc037ff786ab17e$var$StringDecoder.prototype.text = $bcc037ff786ab17e$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$bcc037ff786ab17e$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $bcc037ff786ab17e$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $bcc037ff786ab17e$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $bcc037ff786ab17e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bcc037ff786ab17e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bcc037ff786ab17e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $bcc037ff786ab17e$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $bcc037ff786ab17e$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $bcc037ff786ab17e$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $bcc037ff786ab17e$var$utf8Text(buf, i) {
    var total = $bcc037ff786ab17e$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $bcc037ff786ab17e$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $bcc037ff786ab17e$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $bcc037ff786ab17e$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $bcc037ff786ab17e$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $bcc037ff786ab17e$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $bcc037ff786ab17e$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $bcc037ff786ab17e$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("9fsjZ", function(module, exports) {

var $89WEd = parcelRequire("89WEd");
'use strict';
var $6bbb7bcfb12e0b97$var$_Object$setPrototypeO;
function $6bbb7bcfb12e0b97$var$_defineProperty(obj, key, value) {
    key = $6bbb7bcfb12e0b97$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6bbb7bcfb12e0b97$var$_toPropertyKey(arg) {
    var key = $6bbb7bcfb12e0b97$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6bbb7bcfb12e0b97$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ffp7O = parcelRequire("ffp7O");
var $6bbb7bcfb12e0b97$var$kLastResolve = Symbol('lastResolve');
var $6bbb7bcfb12e0b97$var$kLastReject = Symbol('lastReject');
var $6bbb7bcfb12e0b97$var$kError = Symbol('error');
var $6bbb7bcfb12e0b97$var$kEnded = Symbol('ended');
var $6bbb7bcfb12e0b97$var$kLastPromise = Symbol('lastPromise');
var $6bbb7bcfb12e0b97$var$kHandlePromise = Symbol('handlePromise');
var $6bbb7bcfb12e0b97$var$kStream = Symbol('stream');
function $6bbb7bcfb12e0b97$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $6bbb7bcfb12e0b97$var$readAndResolve(iter) {
    var resolve = iter[$6bbb7bcfb12e0b97$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$6bbb7bcfb12e0b97$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$6bbb7bcfb12e0b97$var$kLastPromise] = null;
            iter[$6bbb7bcfb12e0b97$var$kLastResolve] = null;
            iter[$6bbb7bcfb12e0b97$var$kLastReject] = null;
            resolve($6bbb7bcfb12e0b97$var$createIterResult(data, false));
        }
    }
}
function $6bbb7bcfb12e0b97$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $89WEd.nextTick($6bbb7bcfb12e0b97$var$readAndResolve, iter);
}
function $6bbb7bcfb12e0b97$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$6bbb7bcfb12e0b97$var$kEnded]) {
                resolve($6bbb7bcfb12e0b97$var$createIterResult(undefined, true));
                return;
            }
            iter[$6bbb7bcfb12e0b97$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $6bbb7bcfb12e0b97$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $6bbb7bcfb12e0b97$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($6bbb7bcfb12e0b97$var$_Object$setPrototypeO = {
    get stream () {
        return this[$6bbb7bcfb12e0b97$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$6bbb7bcfb12e0b97$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$6bbb7bcfb12e0b97$var$kEnded]) return Promise.resolve($6bbb7bcfb12e0b97$var$createIterResult(undefined, true));
        if (this[$6bbb7bcfb12e0b97$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $89WEd.nextTick(function() {
                if (_this[$6bbb7bcfb12e0b97$var$kError]) reject(_this[$6bbb7bcfb12e0b97$var$kError]);
                else resolve($6bbb7bcfb12e0b97$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$6bbb7bcfb12e0b97$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($6bbb7bcfb12e0b97$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$6bbb7bcfb12e0b97$var$kStream].read();
            if (data !== null) return Promise.resolve($6bbb7bcfb12e0b97$var$createIterResult(data, false));
            promise = new Promise(this[$6bbb7bcfb12e0b97$var$kHandlePromise]);
        }
        this[$6bbb7bcfb12e0b97$var$kLastPromise] = promise;
        return promise;
    }
}, $6bbb7bcfb12e0b97$var$_defineProperty($6bbb7bcfb12e0b97$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $6bbb7bcfb12e0b97$var$_defineProperty($6bbb7bcfb12e0b97$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$6bbb7bcfb12e0b97$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($6bbb7bcfb12e0b97$var$createIterResult(undefined, true));
        });
    });
}), $6bbb7bcfb12e0b97$var$_Object$setPrototypeO), $6bbb7bcfb12e0b97$var$AsyncIteratorPrototype);
var $6bbb7bcfb12e0b97$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($6bbb7bcfb12e0b97$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kStream, {
        value: stream,
        writable: true
    }), $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kLastResolve, {
        value: null,
        writable: true
    }), $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kLastReject, {
        value: null,
        writable: true
    }), $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kError, {
        value: null,
        writable: true
    }), $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $6bbb7bcfb12e0b97$var$_defineProperty(_Object$create, $6bbb7bcfb12e0b97$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$6bbb7bcfb12e0b97$var$kStream].read();
            if (data) {
                iterator[$6bbb7bcfb12e0b97$var$kLastPromise] = null;
                iterator[$6bbb7bcfb12e0b97$var$kLastResolve] = null;
                iterator[$6bbb7bcfb12e0b97$var$kLastReject] = null;
                resolve($6bbb7bcfb12e0b97$var$createIterResult(data, false));
            } else {
                iterator[$6bbb7bcfb12e0b97$var$kLastResolve] = resolve;
                iterator[$6bbb7bcfb12e0b97$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$6bbb7bcfb12e0b97$var$kLastPromise] = null;
    $ffp7O(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$6bbb7bcfb12e0b97$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$6bbb7bcfb12e0b97$var$kLastPromise] = null;
                iterator[$6bbb7bcfb12e0b97$var$kLastResolve] = null;
                iterator[$6bbb7bcfb12e0b97$var$kLastReject] = null;
                reject(err);
            }
            iterator[$6bbb7bcfb12e0b97$var$kError] = err;
            return;
        }
        var resolve = iterator[$6bbb7bcfb12e0b97$var$kLastResolve];
        if (resolve !== null) {
            iterator[$6bbb7bcfb12e0b97$var$kLastPromise] = null;
            iterator[$6bbb7bcfb12e0b97$var$kLastResolve] = null;
            iterator[$6bbb7bcfb12e0b97$var$kLastReject] = null;
            resolve($6bbb7bcfb12e0b97$var$createIterResult(undefined, true));
        }
        iterator[$6bbb7bcfb12e0b97$var$kEnded] = true;
    });
    stream.on('readable', $6bbb7bcfb12e0b97$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $6bbb7bcfb12e0b97$var$createReadableStreamAsyncIterator;

});
parcelRegister("ffp7O", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $b19bbf0e372784b9$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("65TCv")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b19bbf0e372784b9$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b19bbf0e372784b9$var$noop() {}
function $b19bbf0e372784b9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $b19bbf0e372784b9$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $b19bbf0e372784b9$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b19bbf0e372784b9$var$once(callback || $b19bbf0e372784b9$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b19bbf0e372784b9$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b19bbf0e372784b9$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($b19bbf0e372784b9$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $b19bbf0e372784b9$var$eos;

});


parcelRegister("b4IFv", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("2Zcgi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $22caca3c3637feb8$var$Transform;

var $65TCv = parcelRequire("65TCv");
var $22caca3c3637feb8$require$_require$codes = $65TCv.codes;
var $22caca3c3637feb8$var$ERR_METHOD_NOT_IMPLEMENTED = $22caca3c3637feb8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $22caca3c3637feb8$var$ERR_MULTIPLE_CALLBACK = $22caca3c3637feb8$require$_require$codes.ERR_MULTIPLE_CALLBACK, $22caca3c3637feb8$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $22caca3c3637feb8$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $22caca3c3637feb8$var$ERR_TRANSFORM_WITH_LENGTH_0 = $22caca3c3637feb8$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $9UfBk = parcelRequire("9UfBk");

(parcelRequire("h7THt"))($22caca3c3637feb8$var$Transform, $9UfBk);
function $22caca3c3637feb8$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $22caca3c3637feb8$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $22caca3c3637feb8$var$Transform(options) {
    if (!(this instanceof $22caca3c3637feb8$var$Transform)) return new $22caca3c3637feb8$var$Transform(options);
    $9UfBk.call(this, options);
    this._transformState = {
        afterTransform: $22caca3c3637feb8$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $22caca3c3637feb8$var$prefinish);
}
function $22caca3c3637feb8$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $22caca3c3637feb8$var$done(_this, er, data);
    });
    else $22caca3c3637feb8$var$done(this, null, null);
}
$22caca3c3637feb8$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9UfBk.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$22caca3c3637feb8$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $22caca3c3637feb8$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$22caca3c3637feb8$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$22caca3c3637feb8$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$22caca3c3637feb8$var$Transform.prototype._destroy = function(err, cb) {
    $9UfBk.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $22caca3c3637feb8$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $22caca3c3637feb8$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $22caca3c3637feb8$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("aDLvt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $7bf265bea233d486$var$PassThrough;

var $2Zcgi = parcelRequire("2Zcgi");

(parcelRequire("h7THt"))($7bf265bea233d486$var$PassThrough, $2Zcgi);
function $7bf265bea233d486$var$PassThrough(options) {
    if (!(this instanceof $7bf265bea233d486$var$PassThrough)) return new $7bf265bea233d486$var$PassThrough(options);
    $2Zcgi.call(this, options);
}
$7bf265bea233d486$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("k6Zq3", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $ea4402be98d05334$var$eos;
function $ea4402be98d05334$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $65TCv = parcelRequire("65TCv");
var $ea4402be98d05334$require$_require$codes = $65TCv.codes;
var $ea4402be98d05334$var$ERR_MISSING_ARGS = $ea4402be98d05334$require$_require$codes.ERR_MISSING_ARGS, $ea4402be98d05334$var$ERR_STREAM_DESTROYED = $ea4402be98d05334$require$_require$codes.ERR_STREAM_DESTROYED;
function $ea4402be98d05334$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ea4402be98d05334$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $ea4402be98d05334$var$destroyer(stream, reading, writing, callback) {
    callback = $ea4402be98d05334$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($ea4402be98d05334$var$eos === undefined) $ea4402be98d05334$var$eos = (parcelRequire("ffp7O"));
    $ea4402be98d05334$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ea4402be98d05334$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $ea4402be98d05334$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $ea4402be98d05334$var$call(fn) {
    fn();
}
function $ea4402be98d05334$var$pipe(from, to) {
    return from.pipe(to);
}
function $ea4402be98d05334$var$popCallback(streams) {
    if (!streams.length) return $ea4402be98d05334$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $ea4402be98d05334$var$noop;
    return streams.pop();
}
function $ea4402be98d05334$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ea4402be98d05334$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ea4402be98d05334$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ea4402be98d05334$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ea4402be98d05334$var$call);
            if (reading) return;
            destroys.forEach($ea4402be98d05334$var$call);
            callback(error);
        });
    });
    return streams.reduce($ea4402be98d05334$var$pipe);
}
module.exports = $ea4402be98d05334$var$pipeline;

});




parcelRegister("16AOW", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $btUeh = parcelRequire("btUeh");

var $51Mbu = parcelRequire("51Mbu");

var $btvME = parcelRequire("btvME");
var $0ce2e9c71535d6c2$require$Buffer = $btvME.Buffer;

var $5dZZC = parcelRequire("5dZZC");

var $a8JxD = parcelRequire("a8JxD");

var $816Zj = parcelRequire("816Zj");
var $0ce2e9c71535d6c2$var$ZEROS = $0ce2e9c71535d6c2$require$Buffer.alloc(128);
function $0ce2e9c71535d6c2$var$Hmac(alg, key) {
    $51Mbu.call(this, 'digest');
    if (typeof key === 'string') key = $0ce2e9c71535d6c2$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $a8JxD() : $816Zj(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0ce2e9c71535d6c2$require$Buffer.concat([
        key,
        $0ce2e9c71535d6c2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0ce2e9c71535d6c2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0ce2e9c71535d6c2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $a8JxD() : $816Zj(alg);
    this._hash.update(ipad);
}
$h7THt($0ce2e9c71535d6c2$var$Hmac, $51Mbu);
$0ce2e9c71535d6c2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0ce2e9c71535d6c2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $a8JxD() : $816Zj(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $0ce2e9c71535d6c2$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $btUeh($5dZZC, key);
    return new $0ce2e9c71535d6c2$var$Hmac(alg, key);
};

});
parcelRegister("btUeh", function(module, exports) {
'use strict';

var $h7THt = parcelRequire("h7THt");

var $btvME = parcelRequire("btvME");
var $85be0520d698c131$require$Buffer = $btvME.Buffer;

var $51Mbu = parcelRequire("51Mbu");
var $85be0520d698c131$var$ZEROS = $85be0520d698c131$require$Buffer.alloc(128);
var $85be0520d698c131$var$blocksize = 64;
function $85be0520d698c131$var$Hmac(alg, key) {
    $51Mbu.call(this, 'digest');
    if (typeof key === 'string') key = $85be0520d698c131$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $85be0520d698c131$var$blocksize) key = alg(key);
    else if (key.length < $85be0520d698c131$var$blocksize) key = $85be0520d698c131$require$Buffer.concat([
        key,
        $85be0520d698c131$var$ZEROS
    ], $85be0520d698c131$var$blocksize);
    var ipad = this._ipad = $85be0520d698c131$require$Buffer.allocUnsafe($85be0520d698c131$var$blocksize);
    var opad = this._opad = $85be0520d698c131$require$Buffer.allocUnsafe($85be0520d698c131$var$blocksize);
    for(var i = 0; i < $85be0520d698c131$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$h7THt($85be0520d698c131$var$Hmac, $51Mbu);
$85be0520d698c131$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$85be0520d698c131$var$Hmac.prototype._final = function() {
    var h = this._alg($85be0520d698c131$require$Buffer.concat(this._hash));
    return this._alg($85be0520d698c131$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $85be0520d698c131$var$Hmac;

});

parcelRegister("5dZZC", function(module, exports) {

var $7Ge75 = parcelRequire("7Ge75");
module.exports = function(buffer) {
    return new $7Ge75().update(buffer).digest();
};

});


parcelRegister("cjBTf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4DSyq"));

});
parcelRegister("4DSyq", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("9ztwK", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $6f7e4972211d6b85$export$448fa22aedc9dbca; }, function (v) { return $6f7e4972211d6b85$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $6f7e4972211d6b85$export$b80c7ba289c8fa56; }, function (v) { return $6f7e4972211d6b85$export$b80c7ba289c8fa56 = v; });
var $6f7e4972211d6b85$export$448fa22aedc9dbca;
var $6f7e4972211d6b85$export$b80c7ba289c8fa56;
'use strict';

$6f7e4972211d6b85$export$448fa22aedc9dbca = (parcelRequire("93acE"));

$6f7e4972211d6b85$export$b80c7ba289c8fa56 = (parcelRequire("aIuHr"));

});
parcelRegister("93acE", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $696c4ef5ecf61c7b$require$Buffer = $btvME.Buffer;

var $bcI5y = parcelRequire("bcI5y");

var $29NIO = parcelRequire("29NIO");

var $aIuHr = parcelRequire("aIuHr");

var $7unxR = parcelRequire("7unxR");
var $696c4ef5ecf61c7b$var$ZERO_BUF;
var $696c4ef5ecf61c7b$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $696c4ef5ecf61c7b$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $696c4ef5ecf61c7b$var$checks = [];
var $696c4ef5ecf61c7b$var$nextTick;
function $696c4ef5ecf61c7b$var$getNextTick() {
    if ($696c4ef5ecf61c7b$var$nextTick) return $696c4ef5ecf61c7b$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $696c4ef5ecf61c7b$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $696c4ef5ecf61c7b$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $696c4ef5ecf61c7b$var$nextTick = $parcel$global.setImmediate;
    else $696c4ef5ecf61c7b$var$nextTick = $parcel$global.setTimeout;
    return $696c4ef5ecf61c7b$var$nextTick;
}
function $696c4ef5ecf61c7b$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $696c4ef5ecf61c7b$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $696c4ef5ecf61c7b$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $696c4ef5ecf61c7b$require$Buffer.from(res);
    });
}
function $696c4ef5ecf61c7b$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$696c4ef5ecf61c7b$var$subtle || !$696c4ef5ecf61c7b$var$subtle.importKey || !$696c4ef5ecf61c7b$var$subtle.deriveBits) return Promise.resolve(false);
    if ($696c4ef5ecf61c7b$var$checks[algo] !== undefined) return $696c4ef5ecf61c7b$var$checks[algo];
    $696c4ef5ecf61c7b$var$ZERO_BUF = $696c4ef5ecf61c7b$var$ZERO_BUF || $696c4ef5ecf61c7b$require$Buffer.alloc(8);
    var prom = $696c4ef5ecf61c7b$var$browserPbkdf2($696c4ef5ecf61c7b$var$ZERO_BUF, $696c4ef5ecf61c7b$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $696c4ef5ecf61c7b$var$checks[algo] = prom;
    return prom;
}
function $696c4ef5ecf61c7b$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $696c4ef5ecf61c7b$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $696c4ef5ecf61c7b$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    keylen = $bcI5y(iterations, keylen);
    password = $7unxR(password, $29NIO, 'Password');
    salt = $7unxR(salt, $29NIO, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $696c4ef5ecf61c7b$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $696c4ef5ecf61c7b$var$getNextTick()(function() {
            var out;
            try {
                out = $aIuHr(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $696c4ef5ecf61c7b$var$resolvePromise($696c4ef5ecf61c7b$var$checkNative(algo).then(function(resp) {
        if (resp) return $696c4ef5ecf61c7b$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $aIuHr(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("bcI5y", function(module, exports) {
'use strict';
var $828303c5f64a50e5$var$$isFinite = isFinite;
var $828303c5f64a50e5$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$828303c5f64a50e5$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $828303c5f64a50e5$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    // `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
    // the native binding requires a true Int32; `-0` is held as a double and
    // aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
    return keylen + 0;
};

});

parcelRegister("29NIO", function(module, exports) {

var $89WEd = parcelRequire("89WEd");
'use strict';
var $1922fdbc8b3c84d8$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $1922fdbc8b3c84d8$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $1922fdbc8b3c84d8$var$pVersionMajor = parseInt($89WEd.version.split('.')[0].slice(1), 10);
    $1922fdbc8b3c84d8$var$defaultEncoding = $1922fdbc8b3c84d8$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $1922fdbc8b3c84d8$var$defaultEncoding = 'utf-8';
module.exports = $1922fdbc8b3c84d8$var$defaultEncoding;

});

parcelRegister("aIuHr", function(module, exports) {
'use strict';

var $5dZZC = parcelRequire("5dZZC");

var $a8JxD = parcelRequire("a8JxD");

var $816Zj = parcelRequire("816Zj");

var $btvME = parcelRequire("btvME");
var $7cd5d3bbed81eff2$require$Buffer = $btvME.Buffer;

var $bcI5y = parcelRequire("bcI5y");

var $29NIO = parcelRequire("29NIO");

var $7unxR = parcelRequire("7unxR");
var $7cd5d3bbed81eff2$var$ZEROS = $7cd5d3bbed81eff2$require$Buffer.alloc(128);
var $7cd5d3bbed81eff2$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $7cd5d3bbed81eff2$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $7cd5d3bbed81eff2$var$rmd160Func(data) {
    return new $a8JxD().update(data).digest();
}
function $7cd5d3bbed81eff2$var$getDigest(alg) {
    function shaFunc(data) {
        return $816Zj(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $7cd5d3bbed81eff2$var$rmd160Func;
    if (alg === 'md5') return $5dZZC;
    return shaFunc;
}
function $7cd5d3bbed81eff2$var$Hmac(alg, key, saltLen) {
    var hash = $7cd5d3bbed81eff2$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $7cd5d3bbed81eff2$require$Buffer.concat([
        key,
        $7cd5d3bbed81eff2$var$ZEROS
    ], blocksize);
    var ipad = $7cd5d3bbed81eff2$require$Buffer.allocUnsafe(blocksize + $7cd5d3bbed81eff2$var$sizes[alg]);
    var opad = $7cd5d3bbed81eff2$require$Buffer.allocUnsafe(blocksize + $7cd5d3bbed81eff2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $7cd5d3bbed81eff2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $7cd5d3bbed81eff2$var$sizes[alg];
}
$7cd5d3bbed81eff2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $7cd5d3bbed81eff2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    keylen = $bcI5y(iterations, keylen);
    password = $7unxR(password, $29NIO, 'Password');
    salt = $7unxR(salt, $29NIO, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $7cd5d3bbed81eff2$var$mapping[lowerDigest] || lowerDigest;
    var size = $7cd5d3bbed81eff2$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $7cd5d3bbed81eff2$var$Hmac(mappedDigest, password, salt.length);
    var DK = $7cd5d3bbed81eff2$require$Buffer.allocUnsafe(keylen);
    var block1 = $7cd5d3bbed81eff2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $7cd5d3bbed81eff2$var$pbkdf2;

});
parcelRegister("7unxR", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $573d9957775c4025$require$Buffer = $btvME.Buffer;

var $ik3RQ = parcelRequire("ik3RQ");
var $573d9957775c4025$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $573d9957775c4025$var$useArrayBuffer = $573d9957775c4025$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $573d9957775c4025$var$isView = $573d9957775c4025$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $573d9957775c4025$require$Buffer.isBuffer(thing) || $573d9957775c4025$var$useUint8Array && thing instanceof Uint8Array || $573d9957775c4025$var$isView && $573d9957775c4025$var$isView(thing)) return $ik3RQ(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("frS5g", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $b3f35492d18bd0d9$export$bdd223f16383713e; }, function (v) { return $b3f35492d18bd0d9$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $b3f35492d18bd0d9$export$26e5786e8ac8e530; }, function (v) { return $b3f35492d18bd0d9$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $b3f35492d18bd0d9$export$2f64596b8cbf08b4; }, function (v) { return $b3f35492d18bd0d9$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $b3f35492d18bd0d9$export$20533d26f07f1ee0; }, function (v) { return $b3f35492d18bd0d9$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $b3f35492d18bd0d9$export$12ada9414fbc594c; }, function (v) { return $b3f35492d18bd0d9$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $b3f35492d18bd0d9$export$2ce6d8d0e8b04e1a; }, function (v) { return $b3f35492d18bd0d9$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $b3f35492d18bd0d9$export$36b6d6ef312eab39; }, function (v) { return $b3f35492d18bd0d9$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $b3f35492d18bd0d9$export$f5e7e39d57cd9700; }, function (v) { return $b3f35492d18bd0d9$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $b3f35492d18bd0d9$export$dedd8dc3dc62b370; }, function (v) { return $b3f35492d18bd0d9$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $b3f35492d18bd0d9$export$58a258485f1e49f6; }, function (v) { return $b3f35492d18bd0d9$export$58a258485f1e49f6 = v; });
var $b3f35492d18bd0d9$export$bdd223f16383713e;
var $b3f35492d18bd0d9$export$26e5786e8ac8e530;
var $b3f35492d18bd0d9$export$2f64596b8cbf08b4;
var $b3f35492d18bd0d9$export$20533d26f07f1ee0;
var $b3f35492d18bd0d9$export$12ada9414fbc594c;
var $b3f35492d18bd0d9$export$2ce6d8d0e8b04e1a;
var $b3f35492d18bd0d9$export$36b6d6ef312eab39;
var $b3f35492d18bd0d9$export$f5e7e39d57cd9700;
var $b3f35492d18bd0d9$export$dedd8dc3dc62b370;
var $b3f35492d18bd0d9$export$58a258485f1e49f6;

var $hwYfD = parcelRequire("hwYfD");

var $AyKOg = parcelRequire("AyKOg");

var $1JBFd = parcelRequire("1JBFd");

var $9snyR = parcelRequire("9snyR");

var $46t1V = parcelRequire("46t1V");
function $b3f35492d18bd0d9$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($1JBFd[suite]) {
        keyLen = $1JBFd[suite].key;
        ivLen = $1JBFd[suite].iv;
    } else if ($9snyR[suite]) {
        keyLen = $9snyR[suite].key * 8;
        ivLen = $9snyR[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $46t1V(password, false, keyLen, ivLen);
    return $b3f35492d18bd0d9$var$createCipheriv(suite, keys.key, keys.iv);
}
function $b3f35492d18bd0d9$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($1JBFd[suite]) {
        keyLen = $1JBFd[suite].key;
        ivLen = $1JBFd[suite].iv;
    } else if ($9snyR[suite]) {
        keyLen = $9snyR[suite].key * 8;
        ivLen = $9snyR[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $46t1V(password, false, keyLen, ivLen);
    return $b3f35492d18bd0d9$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $b3f35492d18bd0d9$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($1JBFd[suite]) return $AyKOg.createCipheriv(suite, key, iv);
    if ($9snyR[suite]) return new $hwYfD({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $b3f35492d18bd0d9$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($1JBFd[suite]) return $AyKOg.createDecipheriv(suite, key, iv);
    if ($9snyR[suite]) return new $hwYfD({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $b3f35492d18bd0d9$var$getCiphers() {
    return Object.keys($9snyR).concat($AyKOg.getCiphers());
}
$b3f35492d18bd0d9$export$bdd223f16383713e = $b3f35492d18bd0d9$export$26e5786e8ac8e530 = $b3f35492d18bd0d9$var$createCipher;
$b3f35492d18bd0d9$export$2f64596b8cbf08b4 = $b3f35492d18bd0d9$export$20533d26f07f1ee0 = $b3f35492d18bd0d9$var$createCipheriv;
$b3f35492d18bd0d9$export$12ada9414fbc594c = $b3f35492d18bd0d9$export$2ce6d8d0e8b04e1a = $b3f35492d18bd0d9$var$createDecipher;
$b3f35492d18bd0d9$export$36b6d6ef312eab39 = $b3f35492d18bd0d9$export$f5e7e39d57cd9700 = $b3f35492d18bd0d9$var$createDecipheriv;
$b3f35492d18bd0d9$export$dedd8dc3dc62b370 = $b3f35492d18bd0d9$export$58a258485f1e49f6 = $b3f35492d18bd0d9$var$getCiphers;

});
parcelRegister("hwYfD", function(module, exports) {

var $51Mbu = parcelRequire("51Mbu");

var $43Tx4 = parcelRequire("43Tx4");

var $h7THt = parcelRequire("h7THt");

var $btvME = parcelRequire("btvME");
var $cc3429724f777cd2$require$Buffer = $btvME.Buffer;
var $cc3429724f777cd2$var$modes = {
    'des-ede3-cbc': $43Tx4.CBC.instantiate($43Tx4.EDE),
    'des-ede3': $43Tx4.EDE,
    'des-ede-cbc': $43Tx4.CBC.instantiate($43Tx4.EDE),
    'des-ede': $43Tx4.EDE,
    'des-cbc': $43Tx4.CBC.instantiate($43Tx4.DES),
    'des-ecb': $43Tx4.DES
};
$cc3429724f777cd2$var$modes.des = $cc3429724f777cd2$var$modes['des-cbc'];
$cc3429724f777cd2$var$modes.des3 = $cc3429724f777cd2$var$modes['des-ede3-cbc'];
module.exports = $cc3429724f777cd2$var$DES;
$h7THt($cc3429724f777cd2$var$DES, $51Mbu);
function $cc3429724f777cd2$var$DES(opts) {
    $51Mbu.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $cc3429724f777cd2$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$cc3429724f777cd2$require$Buffer.isBuffer(key)) key = $cc3429724f777cd2$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $cc3429724f777cd2$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$cc3429724f777cd2$require$Buffer.isBuffer(iv)) iv = $cc3429724f777cd2$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$cc3429724f777cd2$var$DES.prototype._update = function(data) {
    return $cc3429724f777cd2$require$Buffer.from(this._des.update(data));
};
$cc3429724f777cd2$var$DES.prototype._final = function() {
    return $cc3429724f777cd2$require$Buffer.from(this._des.final());
};

});
parcelRegister("43Tx4", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $2f5284ca23dc3f20$export$cc8859615686b300; }, function (v) { return $2f5284ca23dc3f20$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $2f5284ca23dc3f20$export$8ad3f227af08fcc5; }, function (v) { return $2f5284ca23dc3f20$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $2f5284ca23dc3f20$export$947646e34766044f; }, function (v) { return $2f5284ca23dc3f20$export$947646e34766044f = v; });
var $2f5284ca23dc3f20$export$eab97d15b1788b8d;
var $2f5284ca23dc3f20$export$26e5786e8ac8e530;
var $2f5284ca23dc3f20$export$cc8859615686b300;
var $2f5284ca23dc3f20$export$8ad3f227af08fcc5;
var $2f5284ca23dc3f20$export$947646e34766044f;
'use strict';

$2f5284ca23dc3f20$export$eab97d15b1788b8d = (parcelRequire("dGaoO"));

$2f5284ca23dc3f20$export$26e5786e8ac8e530 = (parcelRequire("cLBKy"));

$2f5284ca23dc3f20$export$cc8859615686b300 = (parcelRequire("3aWh9"));

$2f5284ca23dc3f20$export$8ad3f227af08fcc5 = (parcelRequire("gAR1H"));

$2f5284ca23dc3f20$export$947646e34766044f = (parcelRequire("54QBn"));

});
parcelRegister("dGaoO", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $9f5743ab7a921274$export$cfaef8ed399428b0; }, function (v) { return $9f5743ab7a921274$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $9f5743ab7a921274$export$a80c7deaea7cbd80; }, function (v) { return $9f5743ab7a921274$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $9f5743ab7a921274$export$ed7577ae6e1cd0ef; }, function (v) { return $9f5743ab7a921274$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $9f5743ab7a921274$export$5dcbef3aa594f567; }, function (v) { return $9f5743ab7a921274$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $9f5743ab7a921274$export$5bc8001ca71ed9c5; }, function (v) { return $9f5743ab7a921274$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $9f5743ab7a921274$export$3e714e2c5d5d8cb2; }, function (v) { return $9f5743ab7a921274$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $9f5743ab7a921274$export$94c3e544fd062b7f; }, function (v) { return $9f5743ab7a921274$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $9f5743ab7a921274$export$9f77e0932fb78f72; }, function (v) { return $9f5743ab7a921274$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $9f5743ab7a921274$export$d865ce2836f5927f; }, function (v) { return $9f5743ab7a921274$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $9f5743ab7a921274$export$95e62ad65da8b7d2; }, function (v) { return $9f5743ab7a921274$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $9f5743ab7a921274$export$209139ff098c441a; }, function (v) { return $9f5743ab7a921274$export$209139ff098c441a = v; });
var $9f5743ab7a921274$export$cfaef8ed399428b0;
var $9f5743ab7a921274$export$a80c7deaea7cbd80;
var $9f5743ab7a921274$export$ed7577ae6e1cd0ef;
var $9f5743ab7a921274$export$5dcbef3aa594f567;
var $9f5743ab7a921274$export$5bc8001ca71ed9c5;
var $9f5743ab7a921274$export$3e714e2c5d5d8cb2;
var $9f5743ab7a921274$export$94c3e544fd062b7f;
var $9f5743ab7a921274$export$9f77e0932fb78f72;
var $9f5743ab7a921274$export$d865ce2836f5927f;
var $9f5743ab7a921274$export$95e62ad65da8b7d2;
var $9f5743ab7a921274$export$209139ff098c441a;
'use strict';
$9f5743ab7a921274$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9f5743ab7a921274$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9f5743ab7a921274$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9f5743ab7a921274$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9f5743ab7a921274$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9f5743ab7a921274$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9f5743ab7a921274$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9f5743ab7a921274$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9f5743ab7a921274$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9f5743ab7a921274$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9f5743ab7a921274$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9f5743ab7a921274$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9f5743ab7a921274$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9f5743ab7a921274$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9f5743ab7a921274$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9f5743ab7a921274$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9f5743ab7a921274$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9f5743ab7a921274$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9f5743ab7a921274$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9f5743ab7a921274$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9f5743ab7a921274$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9f5743ab7a921274$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("cLBKy", function(module, exports) {
'use strict';

var $j0nF4 = parcelRequire("j0nF4");
function $94b7282fc287090a$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $94b7282fc287090a$var$Cipher;
$94b7282fc287090a$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$94b7282fc287090a$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$94b7282fc287090a$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$94b7282fc287090a$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$94b7282fc287090a$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$94b7282fc287090a$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$94b7282fc287090a$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$94b7282fc287090a$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$94b7282fc287090a$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$94b7282fc287090a$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$94b7282fc287090a$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $j0nF4.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("j0nF4", function(module, exports) {
module.exports = $dd605f153995388e$var$assert;
function $dd605f153995388e$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$dd605f153995388e$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("3aWh9", function(module, exports) {
'use strict';

var $j0nF4 = parcelRequire("j0nF4");

var $h7THt = parcelRequire("h7THt");

var $dGaoO = parcelRequire("dGaoO");

var $cLBKy = parcelRequire("cLBKy");
function $24ff829dc543689b$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $24ff829dc543689b$var$DES(options) {
    $cLBKy.call(this, options);
    var state = new $24ff829dc543689b$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$h7THt($24ff829dc543689b$var$DES, $cLBKy);
module.exports = $24ff829dc543689b$var$DES;
$24ff829dc543689b$var$DES.create = function create(options) {
    return new $24ff829dc543689b$var$DES(options);
};
var $24ff829dc543689b$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$24ff829dc543689b$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $j0nF4.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dGaoO.readUInt32BE(key, 0);
    var kR = $dGaoO.readUInt32BE(key, 4);
    $dGaoO.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $24ff829dc543689b$var$shiftTable[i >>> 1];
        kL = $dGaoO.r28shl(kL, shift);
        kR = $dGaoO.r28shl(kR, shift);
        $dGaoO.pc2(kL, kR, state.keys, i);
    }
};
$24ff829dc543689b$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dGaoO.readUInt32BE(inp, inOff);
    var r = $dGaoO.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dGaoO.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dGaoO.writeUInt32BE(out, l, outOff);
    $dGaoO.writeUInt32BE(out, r, outOff + 4);
};
$24ff829dc543689b$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$24ff829dc543689b$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$j0nF4.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$24ff829dc543689b$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dGaoO.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dGaoO.substitute(keyL, keyR);
        var f = $dGaoO.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dGaoO.rip(r, l, out, off);
};
$24ff829dc543689b$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dGaoO.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dGaoO.substitute(keyL, keyR);
        var f = $dGaoO.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dGaoO.rip(l, r, out, off);
};

});

parcelRegister("gAR1H", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $c149240f63d1f9b4$export$f9bb8d20ccc7477a; }, function (v) { return $c149240f63d1f9b4$export$f9bb8d20ccc7477a = v; });
var $c149240f63d1f9b4$export$f9bb8d20ccc7477a;
'use strict';

var $j0nF4 = parcelRequire("j0nF4");

var $h7THt = parcelRequire("h7THt");
var $c149240f63d1f9b4$var$proto = {};
function $c149240f63d1f9b4$var$CBCState(iv) {
    $j0nF4.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $c149240f63d1f9b4$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $h7THt(CBC, Base);
    var keys = Object.keys($c149240f63d1f9b4$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $c149240f63d1f9b4$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$c149240f63d1f9b4$export$f9bb8d20ccc7477a = $c149240f63d1f9b4$var$instantiate;
$c149240f63d1f9b4$var$proto._cbcInit = function _cbcInit() {
    var state = new $c149240f63d1f9b4$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$c149240f63d1f9b4$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("54QBn", function(module, exports) {
'use strict';

var $j0nF4 = parcelRequire("j0nF4");

var $h7THt = parcelRequire("h7THt");

var $cLBKy = parcelRequire("cLBKy");

var $3aWh9 = parcelRequire("3aWh9");
function $3b262114aee66c96$var$EDEState(type, key) {
    $j0nF4.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $3aWh9.create({
            type: 'encrypt',
            key: k1
        }),
        $3aWh9.create({
            type: 'decrypt',
            key: k2
        }),
        $3aWh9.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $3aWh9.create({
            type: 'decrypt',
            key: k3
        }),
        $3aWh9.create({
            type: 'encrypt',
            key: k2
        }),
        $3aWh9.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $3b262114aee66c96$var$EDE(options) {
    $cLBKy.call(this, options);
    var state = new $3b262114aee66c96$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$h7THt($3b262114aee66c96$var$EDE, $cLBKy);
module.exports = $3b262114aee66c96$var$EDE;
$3b262114aee66c96$var$EDE.create = function create(options) {
    return new $3b262114aee66c96$var$EDE(options);
};
$3b262114aee66c96$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$3b262114aee66c96$var$EDE.prototype._pad = $3aWh9.prototype._pad;
$3b262114aee66c96$var$EDE.prototype._unpad = $3aWh9.prototype._unpad;

});



parcelRegister("AyKOg", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $06de5253ab2e5b63$export$2f64596b8cbf08b4; }, function (v) { return $06de5253ab2e5b63$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $06de5253ab2e5b63$export$36b6d6ef312eab39; }, function (v) { return $06de5253ab2e5b63$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $06de5253ab2e5b63$export$58a258485f1e49f6; }, function (v) { return $06de5253ab2e5b63$export$58a258485f1e49f6 = v; });
var $06de5253ab2e5b63$export$bdd223f16383713e;
var $06de5253ab2e5b63$export$26e5786e8ac8e530;
var $06de5253ab2e5b63$export$2f64596b8cbf08b4;
var $06de5253ab2e5b63$export$20533d26f07f1ee0;
var $06de5253ab2e5b63$export$12ada9414fbc594c;
var $06de5253ab2e5b63$export$2ce6d8d0e8b04e1a;
var $06de5253ab2e5b63$export$36b6d6ef312eab39;
var $06de5253ab2e5b63$export$f5e7e39d57cd9700;
var $06de5253ab2e5b63$export$dedd8dc3dc62b370;
var $06de5253ab2e5b63$export$58a258485f1e49f6;

var $eDoJI = parcelRequire("eDoJI");

var $jAKJv = parcelRequire("jAKJv");

var $9jBDq = parcelRequire("9jBDq");
function $06de5253ab2e5b63$var$getCiphers() {
    return Object.keys($9jBDq);
}
$06de5253ab2e5b63$export$bdd223f16383713e = $06de5253ab2e5b63$export$26e5786e8ac8e530 = $eDoJI.createCipher;
$06de5253ab2e5b63$export$2f64596b8cbf08b4 = $06de5253ab2e5b63$export$20533d26f07f1ee0 = $eDoJI.createCipheriv;
$06de5253ab2e5b63$export$12ada9414fbc594c = $06de5253ab2e5b63$export$2ce6d8d0e8b04e1a = $jAKJv.createDecipher;
$06de5253ab2e5b63$export$36b6d6ef312eab39 = $06de5253ab2e5b63$export$f5e7e39d57cd9700 = $jAKJv.createDecipheriv;
$06de5253ab2e5b63$export$dedd8dc3dc62b370 = $06de5253ab2e5b63$export$58a258485f1e49f6 = $06de5253ab2e5b63$var$getCiphers;

});
parcelRegister("eDoJI", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $02bfde89adaa71c6$export$2f64596b8cbf08b4; }, function (v) { return $02bfde89adaa71c6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $02bfde89adaa71c6$export$bdd223f16383713e; }, function (v) { return $02bfde89adaa71c6$export$bdd223f16383713e = v; });
var $02bfde89adaa71c6$export$2f64596b8cbf08b4;
var $02bfde89adaa71c6$export$bdd223f16383713e;

var $1JBFd = parcelRequire("1JBFd");

var $dw7VU = parcelRequire("dw7VU");

var $btvME = parcelRequire("btvME");
var $02bfde89adaa71c6$require$Buffer = $btvME.Buffer;

var $f72GJ = parcelRequire("f72GJ");

var $51Mbu = parcelRequire("51Mbu");

var $6QbXv = parcelRequire("6QbXv");

var $46t1V = parcelRequire("46t1V");

var $h7THt = parcelRequire("h7THt");
function $02bfde89adaa71c6$var$Cipher(mode, key, iv) {
    $51Mbu.call(this);
    this._cache = new $02bfde89adaa71c6$var$Splitter();
    this._cipher = new $6QbXv.AES(key);
    this._prev = $02bfde89adaa71c6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$h7THt($02bfde89adaa71c6$var$Cipher, $51Mbu);
$02bfde89adaa71c6$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $02bfde89adaa71c6$require$Buffer.concat(out);
};
var $02bfde89adaa71c6$var$PADDING = $02bfde89adaa71c6$require$Buffer.alloc(16, 0x10);
$02bfde89adaa71c6$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($02bfde89adaa71c6$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$02bfde89adaa71c6$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $02bfde89adaa71c6$var$Splitter() {
    this.cache = $02bfde89adaa71c6$require$Buffer.allocUnsafe(0);
}
$02bfde89adaa71c6$var$Splitter.prototype.add = function(data) {
    this.cache = $02bfde89adaa71c6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$02bfde89adaa71c6$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$02bfde89adaa71c6$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $02bfde89adaa71c6$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $02bfde89adaa71c6$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $02bfde89adaa71c6$var$createCipheriv(suite, password, iv) {
    var config = $1JBFd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $02bfde89adaa71c6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $02bfde89adaa71c6$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $f72GJ(config.module, password, iv);
    else if (config.type === 'auth') return new $dw7VU(config.module, password, iv);
    return new $02bfde89adaa71c6$var$Cipher(config.module, password, iv);
}
function $02bfde89adaa71c6$var$createCipher(suite, password) {
    var config = $1JBFd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $46t1V(password, false, config.key, config.iv);
    return $02bfde89adaa71c6$var$createCipheriv(suite, keys.key, keys.iv);
}
$02bfde89adaa71c6$export$2f64596b8cbf08b4 = $02bfde89adaa71c6$var$createCipheriv;
$02bfde89adaa71c6$export$bdd223f16383713e = $02bfde89adaa71c6$var$createCipher;

});
parcelRegister("1JBFd", function(module, exports) {








var $143735a16464a493$var$modeModules = {
    ECB: (parcelRequire("8ZLM6")),
    CBC: (parcelRequire("9xHCm")),
    CFB: (parcelRequire("3izXf")),
    CFB8: (parcelRequire("1T1yN")),
    CFB1: (parcelRequire("capb8")),
    OFB: (parcelRequire("2fzMw")),
    CTR: (parcelRequire("3jtkI")),
    GCM: (parcelRequire("3jtkI"))
};

var $9jBDq = parcelRequire("9jBDq");
for(var $143735a16464a493$var$key in $9jBDq)$9jBDq[$143735a16464a493$var$key].module = $143735a16464a493$var$modeModules[$9jBDq[$143735a16464a493$var$key].mode];
module.exports = $9jBDq;

});
parcelRegister("8ZLM6", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $68c9144f100e98e1$export$5b0f6292f11d1d18; }, function (v) { return $68c9144f100e98e1$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $68c9144f100e98e1$export$e85a0c9a1067c5d3; }, function (v) { return $68c9144f100e98e1$export$e85a0c9a1067c5d3 = v; });
var $68c9144f100e98e1$export$5b0f6292f11d1d18;
var $68c9144f100e98e1$export$e85a0c9a1067c5d3;
$68c9144f100e98e1$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$68c9144f100e98e1$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("9xHCm", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $6f2907ad6e0e34bf$export$5b0f6292f11d1d18; }, function (v) { return $6f2907ad6e0e34bf$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $6f2907ad6e0e34bf$export$e85a0c9a1067c5d3; }, function (v) { return $6f2907ad6e0e34bf$export$e85a0c9a1067c5d3 = v; });
var $6f2907ad6e0e34bf$export$5b0f6292f11d1d18;
var $6f2907ad6e0e34bf$export$e85a0c9a1067c5d3;

var $ldPiq = parcelRequire("ldPiq");
$6f2907ad6e0e34bf$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $ldPiq(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$6f2907ad6e0e34bf$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $ldPiq(out, pad);
};

});
parcelRegister("ldPiq", function(module, exports) {

var $38gB7 = parcelRequire("38gB7");
var $f7329a366b608448$require$Buffer = $38gB7.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $f7329a366b608448$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("3izXf", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $266ef15f9110ef5b$export$5b0f6292f11d1d18; }, function (v) { return $266ef15f9110ef5b$export$5b0f6292f11d1d18 = v; });
var $266ef15f9110ef5b$export$5b0f6292f11d1d18;

var $btvME = parcelRequire("btvME");
var $266ef15f9110ef5b$require$Buffer = $btvME.Buffer;

var $ldPiq = parcelRequire("ldPiq");
function $266ef15f9110ef5b$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $ldPiq(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $266ef15f9110ef5b$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$266ef15f9110ef5b$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $266ef15f9110ef5b$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $266ef15f9110ef5b$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $266ef15f9110ef5b$require$Buffer.concat([
                out,
                $266ef15f9110ef5b$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $266ef15f9110ef5b$require$Buffer.concat([
                out,
                $266ef15f9110ef5b$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("1T1yN", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $15fc2356672612aa$export$5b0f6292f11d1d18; }, function (v) { return $15fc2356672612aa$export$5b0f6292f11d1d18 = v; });
var $15fc2356672612aa$export$5b0f6292f11d1d18;

var $btvME = parcelRequire("btvME");
var $15fc2356672612aa$require$Buffer = $btvME.Buffer;
function $15fc2356672612aa$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $15fc2356672612aa$require$Buffer.concat([
        self._prev.slice(1),
        $15fc2356672612aa$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$15fc2356672612aa$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $15fc2356672612aa$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $15fc2356672612aa$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("capb8", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $8db9f3275af02d20$export$5b0f6292f11d1d18; }, function (v) { return $8db9f3275af02d20$export$5b0f6292f11d1d18 = v; });
var $8db9f3275af02d20$export$5b0f6292f11d1d18;

var $btvME = parcelRequire("btvME");
var $8db9f3275af02d20$require$Buffer = $btvME.Buffer;
function $8db9f3275af02d20$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $8db9f3275af02d20$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $8db9f3275af02d20$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $8db9f3275af02d20$require$Buffer.allocUnsafe(buffer.length);
    buffer = $8db9f3275af02d20$require$Buffer.concat([
        buffer,
        $8db9f3275af02d20$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$8db9f3275af02d20$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $8db9f3275af02d20$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $8db9f3275af02d20$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("2fzMw", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1a38bcf60d741873$export$5b0f6292f11d1d18; }, function (v) { return $1a38bcf60d741873$export$5b0f6292f11d1d18 = v; });
var $1a38bcf60d741873$export$5b0f6292f11d1d18;

var $38gB7 = parcelRequire("38gB7");
var $1a38bcf60d741873$require$Buffer = $38gB7.Buffer;

var $ldPiq = parcelRequire("ldPiq");
function $1a38bcf60d741873$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$1a38bcf60d741873$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $1a38bcf60d741873$require$Buffer.concat([
        self._cache,
        $1a38bcf60d741873$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $ldPiq(chunk, pad);
};

});

parcelRegister("3jtkI", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $2699e665dce66024$export$5b0f6292f11d1d18; }, function (v) { return $2699e665dce66024$export$5b0f6292f11d1d18 = v; });
var $2699e665dce66024$export$5b0f6292f11d1d18;

var $ldPiq = parcelRequire("ldPiq");

var $btvME = parcelRequire("btvME");
var $2699e665dce66024$require$Buffer = $btvME.Buffer;

var $ezSWK = parcelRequire("ezSWK");
function $2699e665dce66024$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $ezSWK(self._prev);
    return out;
}
var $2699e665dce66024$var$blockSize = 16;
$2699e665dce66024$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $2699e665dce66024$var$blockSize);
    var start = self._cache.length;
    self._cache = $2699e665dce66024$require$Buffer.concat([
        self._cache,
        $2699e665dce66024$require$Buffer.allocUnsafe(chunkNum * $2699e665dce66024$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $2699e665dce66024$var$getBlock(self);
        var offset = start + i * $2699e665dce66024$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $ldPiq(chunk, pad);
};

});
parcelRegister("ezSWK", function(module, exports) {
function $a9cef4d1f91ca15c$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $a9cef4d1f91ca15c$var$incr32;

});


parcelRegister("9jBDq", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("dw7VU", function(module, exports) {

var $6QbXv = parcelRequire("6QbXv");

var $btvME = parcelRequire("btvME");
var $9d746ad54a5ae8aa$require$Buffer = $btvME.Buffer;

var $51Mbu = parcelRequire("51Mbu");

var $h7THt = parcelRequire("h7THt");

var $5Ud6v = parcelRequire("5Ud6v");

var $ldPiq = parcelRequire("ldPiq");

var $ezSWK = parcelRequire("ezSWK");
function $9d746ad54a5ae8aa$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $9d746ad54a5ae8aa$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $9d746ad54a5ae8aa$require$Buffer.concat([
            iv,
            $9d746ad54a5ae8aa$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $9d746ad54a5ae8aa$require$Buffer.concat([
            iv,
            $9d746ad54a5ae8aa$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Ud6v(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($9d746ad54a5ae8aa$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($9d746ad54a5ae8aa$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $9d746ad54a5ae8aa$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $9d746ad54a5ae8aa$require$Buffer.from(self._finID);
    $ezSWK(out);
    return out;
}
function $9d746ad54a5ae8aa$var$StreamCipher(mode, key, iv, decrypt) {
    $51Mbu.call(this);
    var h = $9d746ad54a5ae8aa$require$Buffer.alloc(4, 0);
    this._cipher = new $6QbXv.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Ud6v(ck);
    iv = $9d746ad54a5ae8aa$var$calcIv(this, iv, ck);
    this._prev = $9d746ad54a5ae8aa$require$Buffer.from(iv);
    this._cache = $9d746ad54a5ae8aa$require$Buffer.allocUnsafe(0);
    this._secCache = $9d746ad54a5ae8aa$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$h7THt($9d746ad54a5ae8aa$var$StreamCipher, $51Mbu);
$9d746ad54a5ae8aa$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $9d746ad54a5ae8aa$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$9d746ad54a5ae8aa$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $ldPiq(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $9d746ad54a5ae8aa$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$9d746ad54a5ae8aa$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$9d746ad54a5ae8aa$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$9d746ad54a5ae8aa$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$9d746ad54a5ae8aa$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $9d746ad54a5ae8aa$var$StreamCipher;

});
parcelRegister("6QbXv", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $4fb0e029dab10b47$export$b80fbe1c3a2b92b5; }, function (v) { return $4fb0e029dab10b47$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $4fb0e029dab10b47$export$b80fbe1c3a2b92b5;

var $btvME = parcelRequire("btvME");
var $4fb0e029dab10b47$require$Buffer = $btvME.Buffer;
function $4fb0e029dab10b47$var$asUInt32Array(buf) {
    if (!$4fb0e029dab10b47$require$Buffer.isBuffer(buf)) buf = $4fb0e029dab10b47$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $4fb0e029dab10b47$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $4fb0e029dab10b47$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $4fb0e029dab10b47$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $4fb0e029dab10b47$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $4fb0e029dab10b47$var$AES(key) {
    this._key = $4fb0e029dab10b47$var$asUInt32Array(key);
    this._reset();
}
$4fb0e029dab10b47$var$AES.blockSize = 16;
$4fb0e029dab10b47$var$AES.keySize = 32;
$4fb0e029dab10b47$var$AES.prototype.blockSize = $4fb0e029dab10b47$var$AES.blockSize;
$4fb0e029dab10b47$var$AES.prototype.keySize = $4fb0e029dab10b47$var$AES.keySize;
$4fb0e029dab10b47$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $4fb0e029dab10b47$var$G.SBOX[t >>> 24] << 24 | $4fb0e029dab10b47$var$G.SBOX[t >>> 16 & 0xff] << 16 | $4fb0e029dab10b47$var$G.SBOX[t >>> 8 & 0xff] << 8 | $4fb0e029dab10b47$var$G.SBOX[t & 0xff];
            t ^= $4fb0e029dab10b47$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $4fb0e029dab10b47$var$G.SBOX[t >>> 24] << 24 | $4fb0e029dab10b47$var$G.SBOX[t >>> 16 & 0xff] << 16 | $4fb0e029dab10b47$var$G.SBOX[t >>> 8 & 0xff] << 8 | $4fb0e029dab10b47$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $4fb0e029dab10b47$var$G.INV_SUB_MIX[0][$4fb0e029dab10b47$var$G.SBOX[tt >>> 24]] ^ $4fb0e029dab10b47$var$G.INV_SUB_MIX[1][$4fb0e029dab10b47$var$G.SBOX[tt >>> 16 & 0xff]] ^ $4fb0e029dab10b47$var$G.INV_SUB_MIX[2][$4fb0e029dab10b47$var$G.SBOX[tt >>> 8 & 0xff]] ^ $4fb0e029dab10b47$var$G.INV_SUB_MIX[3][$4fb0e029dab10b47$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$4fb0e029dab10b47$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $4fb0e029dab10b47$var$asUInt32Array(M);
    return $4fb0e029dab10b47$var$cryptBlock(M, this._keySchedule, $4fb0e029dab10b47$var$G.SUB_MIX, $4fb0e029dab10b47$var$G.SBOX, this._nRounds);
};
$4fb0e029dab10b47$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $4fb0e029dab10b47$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$4fb0e029dab10b47$var$AES.prototype.decryptBlock = function(M) {
    M = $4fb0e029dab10b47$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $4fb0e029dab10b47$var$cryptBlock(M, this._invKeySchedule, $4fb0e029dab10b47$var$G.INV_SUB_MIX, $4fb0e029dab10b47$var$G.INV_SBOX, this._nRounds);
    var buf = $4fb0e029dab10b47$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$4fb0e029dab10b47$var$AES.prototype.scrub = function() {
    $4fb0e029dab10b47$var$scrubVec(this._keySchedule);
    $4fb0e029dab10b47$var$scrubVec(this._invKeySchedule);
    $4fb0e029dab10b47$var$scrubVec(this._key);
};
$4fb0e029dab10b47$export$b80fbe1c3a2b92b5 = $4fb0e029dab10b47$var$AES;

});

parcelRegister("5Ud6v", function(module, exports) {

var $btvME = parcelRequire("btvME");
var $44cc58e5cc998e0a$require$Buffer = $btvME.Buffer;
var $44cc58e5cc998e0a$var$ZEROES = $44cc58e5cc998e0a$require$Buffer.alloc(16, 0);
function $44cc58e5cc998e0a$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $44cc58e5cc998e0a$var$fromArray(out) {
    var buf = $44cc58e5cc998e0a$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $44cc58e5cc998e0a$var$GHASH(key) {
    this.h = key;
    this.state = $44cc58e5cc998e0a$require$Buffer.alloc(16, 0);
    this.cache = $44cc58e5cc998e0a$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$44cc58e5cc998e0a$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$44cc58e5cc998e0a$var$GHASH.prototype._multiply = function() {
    var Vi = $44cc58e5cc998e0a$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $44cc58e5cc998e0a$var$fromArray(Zi);
};
$44cc58e5cc998e0a$var$GHASH.prototype.update = function(buf) {
    this.cache = $44cc58e5cc998e0a$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$44cc58e5cc998e0a$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($44cc58e5cc998e0a$require$Buffer.concat([
        this.cache,
        $44cc58e5cc998e0a$var$ZEROES
    ], 16));
    this.ghash($44cc58e5cc998e0a$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $44cc58e5cc998e0a$var$GHASH;

});


parcelRegister("f72GJ", function(module, exports) {

var $6QbXv = parcelRequire("6QbXv");

var $btvME = parcelRequire("btvME");
var $b00998452ff277be$require$Buffer = $btvME.Buffer;

var $51Mbu = parcelRequire("51Mbu");

var $h7THt = parcelRequire("h7THt");
function $b00998452ff277be$var$StreamCipher(mode, key, iv, decrypt) {
    $51Mbu.call(this);
    this._cipher = new $6QbXv.AES(key);
    this._prev = $b00998452ff277be$require$Buffer.from(iv);
    this._cache = $b00998452ff277be$require$Buffer.allocUnsafe(0);
    this._secCache = $b00998452ff277be$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$h7THt($b00998452ff277be$var$StreamCipher, $51Mbu);
$b00998452ff277be$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$b00998452ff277be$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $b00998452ff277be$var$StreamCipher;

});

parcelRegister("46t1V", function(module, exports) {

var $btvME = parcelRequire("btvME");
var $2fce3dbf3df4e7fd$require$Buffer = $btvME.Buffer;

var $7Ge75 = parcelRequire("7Ge75");
/* eslint-disable camelcase */ function $2fce3dbf3df4e7fd$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$2fce3dbf3df4e7fd$require$Buffer.isBuffer(password)) password = $2fce3dbf3df4e7fd$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$2fce3dbf3df4e7fd$require$Buffer.isBuffer(salt)) salt = $2fce3dbf3df4e7fd$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $2fce3dbf3df4e7fd$require$Buffer.alloc(keyLen);
    var iv = $2fce3dbf3df4e7fd$require$Buffer.alloc(ivLen || 0);
    var tmp = $2fce3dbf3df4e7fd$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $7Ge75();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $2fce3dbf3df4e7fd$var$EVP_BytesToKey;

});


parcelRegister("jAKJv", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $e435a1511f878fe2$export$12ada9414fbc594c; }, function (v) { return $e435a1511f878fe2$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e435a1511f878fe2$export$36b6d6ef312eab39; }, function (v) { return $e435a1511f878fe2$export$36b6d6ef312eab39 = v; });
var $e435a1511f878fe2$export$12ada9414fbc594c;
var $e435a1511f878fe2$export$36b6d6ef312eab39;

var $dw7VU = parcelRequire("dw7VU");

var $btvME = parcelRequire("btvME");
var $e435a1511f878fe2$require$Buffer = $btvME.Buffer;

var $1JBFd = parcelRequire("1JBFd");

var $f72GJ = parcelRequire("f72GJ");

var $51Mbu = parcelRequire("51Mbu");

var $6QbXv = parcelRequire("6QbXv");

var $46t1V = parcelRequire("46t1V");

var $h7THt = parcelRequire("h7THt");
function $e435a1511f878fe2$var$Decipher(mode, key, iv) {
    $51Mbu.call(this);
    this._cache = new $e435a1511f878fe2$var$Splitter();
    this._last = void 0;
    this._cipher = new $6QbXv.AES(key);
    this._prev = $e435a1511f878fe2$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$h7THt($e435a1511f878fe2$var$Decipher, $51Mbu);
$e435a1511f878fe2$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $e435a1511f878fe2$require$Buffer.concat(out);
};
$e435a1511f878fe2$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $e435a1511f878fe2$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$e435a1511f878fe2$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $e435a1511f878fe2$var$Splitter() {
    this.cache = $e435a1511f878fe2$require$Buffer.allocUnsafe(0);
}
$e435a1511f878fe2$var$Splitter.prototype.add = function(data) {
    this.cache = $e435a1511f878fe2$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$e435a1511f878fe2$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$e435a1511f878fe2$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $e435a1511f878fe2$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $e435a1511f878fe2$var$createDecipheriv(suite, password, iv) {
    var config = $1JBFd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $e435a1511f878fe2$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $e435a1511f878fe2$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $f72GJ(config.module, password, iv, true);
    else if (config.type === 'auth') return new $dw7VU(config.module, password, iv, true);
    return new $e435a1511f878fe2$var$Decipher(config.module, password, iv);
}
function $e435a1511f878fe2$var$createDecipher(suite, password) {
    var config = $1JBFd[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $46t1V(password, false, config.key, config.iv);
    return $e435a1511f878fe2$var$createDecipheriv(suite, keys.key, keys.iv);
}
$e435a1511f878fe2$export$12ada9414fbc594c = $e435a1511f878fe2$var$createDecipher;
$e435a1511f878fe2$export$36b6d6ef312eab39 = $e435a1511f878fe2$var$createDecipheriv;

});


parcelRegister("9snyR", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $6e29015ed8826e0a$export$116f8a5cee447347; }, function (v) { return $6e29015ed8826e0a$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $6e29015ed8826e0a$export$7483c4066bfb7ae9; }, function (v) { return $6e29015ed8826e0a$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $6e29015ed8826e0a$export$e7a565d2e588bb06; }, function (v) { return $6e29015ed8826e0a$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $6e29015ed8826e0a$export$aaa2f54a426f3eb8; }, function (v) { return $6e29015ed8826e0a$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $6e29015ed8826e0a$export$eba20568dde4ada; }, function (v) { return $6e29015ed8826e0a$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $6e29015ed8826e0a$export$d3b5e5996938f5ae; }, function (v) { return $6e29015ed8826e0a$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $6e29015ed8826e0a$export$57c08356130bc99b; }, function (v) { return $6e29015ed8826e0a$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $6e29015ed8826e0a$export$c7169791d5c1e65d; }, function (v) { return $6e29015ed8826e0a$export$c7169791d5c1e65d = v; });
var $6e29015ed8826e0a$export$116f8a5cee447347;
var $6e29015ed8826e0a$export$7483c4066bfb7ae9;
var $6e29015ed8826e0a$export$e7a565d2e588bb06;
var $6e29015ed8826e0a$export$aaa2f54a426f3eb8;
var $6e29015ed8826e0a$export$eba20568dde4ada;
var $6e29015ed8826e0a$export$d3b5e5996938f5ae;
var $6e29015ed8826e0a$export$57c08356130bc99b;
var $6e29015ed8826e0a$export$c7169791d5c1e65d;
$6e29015ed8826e0a$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$6e29015ed8826e0a$export$7483c4066bfb7ae9 = $6e29015ed8826e0a$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$6e29015ed8826e0a$export$aaa2f54a426f3eb8 = $6e29015ed8826e0a$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$6e29015ed8826e0a$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$6e29015ed8826e0a$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$6e29015ed8826e0a$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("dJrbL", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $9ff4917356f47a8a$export$971862a2fcb1bb40; }, function (v) { return $9ff4917356f47a8a$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $9ff4917356f47a8a$export$c6ff6a88acbeaf40; }, function (v) { return $9ff4917356f47a8a$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $9ff4917356f47a8a$export$fdc27893e98845cc; }, function (v) { return $9ff4917356f47a8a$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $9ff4917356f47a8a$export$6671fb9a1323bed; }, function (v) { return $9ff4917356f47a8a$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $9ff4917356f47a8a$export$d74daf141a551db; }, function (v) { return $9ff4917356f47a8a$export$d74daf141a551db = v; });
var $9ff4917356f47a8a$export$971862a2fcb1bb40;
var $9ff4917356f47a8a$export$c6ff6a88acbeaf40;
var $9ff4917356f47a8a$export$fdc27893e98845cc;
var $9ff4917356f47a8a$export$6671fb9a1323bed;
var $9ff4917356f47a8a$export$d74daf141a551db;

var $38gB7 = parcelRequire("38gB7");
var $9ff4917356f47a8a$require$Buffer = $38gB7.Buffer;

var $2OW5C = parcelRequire("2OW5C");

var $5V8Ph = parcelRequire("5V8Ph");

var $b1vh2 = parcelRequire("b1vh2");
function $9ff4917356f47a8a$var$getDiffieHellman(mod) {
    var prime = new $9ff4917356f47a8a$require$Buffer($5V8Ph[mod].prime, 'hex');
    var gen = new $9ff4917356f47a8a$require$Buffer($5V8Ph[mod].gen, 'hex');
    return new $b1vh2(prime, gen);
}
var $9ff4917356f47a8a$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $9ff4917356f47a8a$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($9ff4917356f47a8a$require$Buffer.isBuffer(enc) || $9ff4917356f47a8a$var$ENCODINGS[enc] === undefined) return $9ff4917356f47a8a$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $9ff4917356f47a8a$require$Buffer([
        2
    ]);
    if (!$9ff4917356f47a8a$require$Buffer.isBuffer(generator)) generator = new $9ff4917356f47a8a$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $b1vh2($2OW5C(prime, generator), generator, true);
    if (!$9ff4917356f47a8a$require$Buffer.isBuffer(prime)) prime = new $9ff4917356f47a8a$require$Buffer(prime, enc);
    return new $b1vh2(prime, generator, true);
}
$9ff4917356f47a8a$export$971862a2fcb1bb40 = $9ff4917356f47a8a$export$c6ff6a88acbeaf40 = $9ff4917356f47a8a$export$fdc27893e98845cc = $9ff4917356f47a8a$var$getDiffieHellman;
$9ff4917356f47a8a$export$6671fb9a1323bed = $9ff4917356f47a8a$export$d74daf141a551db = $9ff4917356f47a8a$var$createDiffieHellman;

});
parcelRegister("2OW5C", function(module, exports) {

var $gYWQI = parcelRequire("gYWQI");
module.exports = $20dd4fa5cbdd1aab$var$findPrime;
$20dd4fa5cbdd1aab$var$findPrime.simpleSieve = $20dd4fa5cbdd1aab$var$simpleSieve;
$20dd4fa5cbdd1aab$var$findPrime.fermatTest = $20dd4fa5cbdd1aab$var$fermatTest;

var $iTE0Q = parcelRequire("iTE0Q");
var $20dd4fa5cbdd1aab$var$TWENTYFOUR = new $iTE0Q(24);

var $e2rPe = parcelRequire("e2rPe");
var $20dd4fa5cbdd1aab$var$millerRabin = new $e2rPe();
var $20dd4fa5cbdd1aab$var$ONE = new $iTE0Q(1);
var $20dd4fa5cbdd1aab$var$TWO = new $iTE0Q(2);
var $20dd4fa5cbdd1aab$var$FIVE = new $iTE0Q(5);
var $20dd4fa5cbdd1aab$var$SIXTEEN = new $iTE0Q(16);
var $20dd4fa5cbdd1aab$var$EIGHT = new $iTE0Q(8);
var $20dd4fa5cbdd1aab$var$TEN = new $iTE0Q(10);
var $20dd4fa5cbdd1aab$var$THREE = new $iTE0Q(3);
var $20dd4fa5cbdd1aab$var$SEVEN = new $iTE0Q(7);
var $20dd4fa5cbdd1aab$var$ELEVEN = new $iTE0Q(11);
var $20dd4fa5cbdd1aab$var$FOUR = new $iTE0Q(4);
var $20dd4fa5cbdd1aab$var$TWELVE = new $iTE0Q(12);
var $20dd4fa5cbdd1aab$var$primes = null;
function $20dd4fa5cbdd1aab$var$_getPrimes() {
    if ($20dd4fa5cbdd1aab$var$primes !== null) return $20dd4fa5cbdd1aab$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $20dd4fa5cbdd1aab$var$primes = res;
    return res;
}
function $20dd4fa5cbdd1aab$var$simpleSieve(p) {
    var primes = $20dd4fa5cbdd1aab$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $20dd4fa5cbdd1aab$var$fermatTest(p) {
    var red = $iTE0Q.mont(p);
    return $20dd4fa5cbdd1aab$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $20dd4fa5cbdd1aab$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $iTE0Q([
            0x8c,
            0x7b
        ]);
        else return new $iTE0Q([
            0x8c,
            0x27
        ]);
    }
    gen = new $iTE0Q(gen);
    var num, n2;
    while(true){
        num = new $iTE0Q($gYWQI(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($20dd4fa5cbdd1aab$var$ONE);
        if (!num.testn(1)) num.iadd($20dd4fa5cbdd1aab$var$TWO);
        if (!gen.cmp($20dd4fa5cbdd1aab$var$TWO)) while(num.mod($20dd4fa5cbdd1aab$var$TWENTYFOUR).cmp($20dd4fa5cbdd1aab$var$ELEVEN))num.iadd($20dd4fa5cbdd1aab$var$FOUR);
        else if (!gen.cmp($20dd4fa5cbdd1aab$var$FIVE)) while(num.mod($20dd4fa5cbdd1aab$var$TEN).cmp($20dd4fa5cbdd1aab$var$THREE))num.iadd($20dd4fa5cbdd1aab$var$FOUR);
        n2 = num.shrn(1);
        if ($20dd4fa5cbdd1aab$var$simpleSieve(n2) && $20dd4fa5cbdd1aab$var$simpleSieve(num) && $20dd4fa5cbdd1aab$var$fermatTest(n2) && $20dd4fa5cbdd1aab$var$fermatTest(num) && $20dd4fa5cbdd1aab$var$millerRabin.test(n2) && $20dd4fa5cbdd1aab$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("iTE0Q", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("dluwd")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("e2rPe", function(module, exports) {

var $iTE0Q = parcelRequire("iTE0Q");

var $a2CsU = parcelRequire("a2CsU");
function $a386d61f9b2e3e3e$var$MillerRabin(rand) {
    this.rand = rand || new $a2CsU.Rand();
}
module.exports = $a386d61f9b2e3e3e$var$MillerRabin;
$a386d61f9b2e3e3e$var$MillerRabin.create = function create(rand) {
    return new $a386d61f9b2e3e3e$var$MillerRabin(rand);
};
$a386d61f9b2e3e3e$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $iTE0Q(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$a386d61f9b2e3e3e$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$a386d61f9b2e3e3e$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $iTE0Q.mont(n);
    var rone = new $iTE0Q(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $iTE0Q(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$a386d61f9b2e3e3e$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $iTE0Q.mont(n);
    var rone = new $iTE0Q(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $iTE0Q(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("a2CsU", function(module, exports) {
var $74f7edb5a145bc6a$var$r;
module.exports = function rand(len) {
    if (!$74f7edb5a145bc6a$var$r) $74f7edb5a145bc6a$var$r = new $74f7edb5a145bc6a$var$Rand(null);
    return $74f7edb5a145bc6a$var$r.generate(len);
};
function $74f7edb5a145bc6a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $74f7edb5a145bc6a$var$Rand;
$74f7edb5a145bc6a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$74f7edb5a145bc6a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $74f7edb5a145bc6a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $74f7edb5a145bc6a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $74f7edb5a145bc6a$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $74f7edb5a145bc6a$var$crypto = (parcelRequire("dluwd"));
    if (typeof $74f7edb5a145bc6a$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $74f7edb5a145bc6a$var$Rand.prototype._rand = function _rand(n) {
        return $74f7edb5a145bc6a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("5V8Ph", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("b1vh2", function(module, exports) {

var $38gB7 = parcelRequire("38gB7");
var $80680c08f474e6b4$require$Buffer = $38gB7.Buffer;

var $iTE0Q = parcelRequire("iTE0Q");

var $e2rPe = parcelRequire("e2rPe");
var $80680c08f474e6b4$var$millerRabin = new $e2rPe();
var $80680c08f474e6b4$var$TWENTYFOUR = new $iTE0Q(24);
var $80680c08f474e6b4$var$ELEVEN = new $iTE0Q(11);
var $80680c08f474e6b4$var$TEN = new $iTE0Q(10);
var $80680c08f474e6b4$var$THREE = new $iTE0Q(3);
var $80680c08f474e6b4$var$SEVEN = new $iTE0Q(7);

var $2OW5C = parcelRequire("2OW5C");

var $gYWQI = parcelRequire("gYWQI");
module.exports = $80680c08f474e6b4$var$DH;
function $80680c08f474e6b4$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$80680c08f474e6b4$require$Buffer.isBuffer(pub)) pub = new $80680c08f474e6b4$require$Buffer(pub, enc);
    this._pub = new $iTE0Q(pub);
    return this;
}
function $80680c08f474e6b4$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$80680c08f474e6b4$require$Buffer.isBuffer(priv)) priv = new $80680c08f474e6b4$require$Buffer(priv, enc);
    this._priv = new $iTE0Q(priv);
    return this;
}
var $80680c08f474e6b4$var$primeCache = {};
function $80680c08f474e6b4$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $80680c08f474e6b4$var$primeCache) return $80680c08f474e6b4$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$2OW5C.simpleSieve || !$2OW5C.fermatTest(prime) || !$80680c08f474e6b4$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $80680c08f474e6b4$var$primeCache[hex] = error;
        return error;
    }
    if (!$80680c08f474e6b4$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($80680c08f474e6b4$var$TWENTYFOUR).cmp($80680c08f474e6b4$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($80680c08f474e6b4$var$TEN);
            if (rem.cmp($80680c08f474e6b4$var$THREE) && rem.cmp($80680c08f474e6b4$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $80680c08f474e6b4$var$primeCache[hex] = error;
    return error;
}
function $80680c08f474e6b4$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $iTE0Q(prime);
    this._prime = $iTE0Q.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $80680c08f474e6b4$var$setPublicKey;
        this.setPrivateKey = $80680c08f474e6b4$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($80680c08f474e6b4$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $80680c08f474e6b4$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$80680c08f474e6b4$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $iTE0Q($gYWQI(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$80680c08f474e6b4$var$DH.prototype.computeSecret = function(other) {
    other = new $iTE0Q(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $80680c08f474e6b4$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $80680c08f474e6b4$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $80680c08f474e6b4$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$80680c08f474e6b4$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $80680c08f474e6b4$var$formatReturnValue(this._pub, enc);
};
$80680c08f474e6b4$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $80680c08f474e6b4$var$formatReturnValue(this._priv, enc);
};
$80680c08f474e6b4$var$DH.prototype.getPrime = function(enc) {
    return $80680c08f474e6b4$var$formatReturnValue(this.__prime, enc);
};
$80680c08f474e6b4$var$DH.prototype.getGenerator = function(enc) {
    return $80680c08f474e6b4$var$formatReturnValue(this._gen, enc);
};
$80680c08f474e6b4$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$80680c08f474e6b4$require$Buffer.isBuffer(gen)) gen = new $80680c08f474e6b4$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $iTE0Q(gen);
    return this;
};
function $80680c08f474e6b4$var$formatReturnValue(bn, enc) {
    var buf = new $80680c08f474e6b4$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("dqvLe", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $9c6657186ab8199e$require$Buffer = $btvME.Buffer;

var $jIYxV = parcelRequire("jIYxV");

var $g9mEL = parcelRequire("g9mEL");

var $h7THt = parcelRequire("h7THt");

var $b2kGJ = parcelRequire("b2kGJ");

var $lDYLS = parcelRequire("lDYLS");

var $4DSyq = parcelRequire("4DSyq");
Object.keys($4DSyq).forEach(function(key) {
    $4DSyq[key].id = $9c6657186ab8199e$require$Buffer.from($4DSyq[key].id, 'hex');
    $4DSyq[key.toLowerCase()] = $4DSyq[key];
});
function $9c6657186ab8199e$var$Sign(algorithm) {
    $g9mEL.Writable.call(this);
    var data = $4DSyq[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $jIYxV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$h7THt($9c6657186ab8199e$var$Sign, $g9mEL.Writable);
$9c6657186ab8199e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$9c6657186ab8199e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $9c6657186ab8199e$require$Buffer.from(data, enc) : data);
    return this;
};
$9c6657186ab8199e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $b2kGJ(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $9c6657186ab8199e$var$Verify(algorithm) {
    $g9mEL.Writable.call(this);
    var data = $4DSyq[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $jIYxV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$h7THt($9c6657186ab8199e$var$Verify, $g9mEL.Writable);
$9c6657186ab8199e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$9c6657186ab8199e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $9c6657186ab8199e$require$Buffer.from(data, enc) : data);
    return this;
};
$9c6657186ab8199e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $9c6657186ab8199e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $lDYLS(sigBuffer, hash, key, this._signType, this._tag);
};
function $9c6657186ab8199e$var$createSign(algorithm) {
    return new $9c6657186ab8199e$var$Sign(algorithm);
}
function $9c6657186ab8199e$var$createVerify(algorithm) {
    return new $9c6657186ab8199e$var$Verify(algorithm);
}
module.exports = {
    Sign: $9c6657186ab8199e$var$createSign,
    Verify: $9c6657186ab8199e$var$createVerify,
    createSign: $9c6657186ab8199e$var$createSign,
    createVerify: $9c6657186ab8199e$var$createVerify
};

});
parcelRegister("b2kGJ", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $808fedd6b6dc9a65$require$Buffer = $btvME.Buffer;

var $16AOW = parcelRequire("16AOW");

var $lAauW = parcelRequire("lAauW");

var $47TpL = parcelRequire("47TpL");
var $808fedd6b6dc9a65$require$EC = $47TpL.ec;

var $4hSXR = parcelRequire("4hSXR");

var $38Wbi = parcelRequire("38Wbi");

var $85inq = parcelRequire("85inq");
var $808fedd6b6dc9a65$var$RSA_PKCS1_PADDING = 1;
function $808fedd6b6dc9a65$var$sign(hash, key, hashType, signType, tag) {
    var priv = $38Wbi(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $808fedd6b6dc9a65$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $808fedd6b6dc9a65$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $808fedd6b6dc9a65$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $808fedd6b6dc9a65$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $lAauW(pad, priv);
    return out;
}
function $808fedd6b6dc9a65$var$ecSign(hash, priv) {
    var curveId = $85inq[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $808fedd6b6dc9a65$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $808fedd6b6dc9a65$require$Buffer.from(out.toDER());
}
function $808fedd6b6dc9a65$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $4hSXR(0);
    var k;
    var H = $808fedd6b6dc9a65$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $808fedd6b6dc9a65$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $808fedd6b6dc9a65$var$makeKey(q, kv, algo);
        r = $808fedd6b6dc9a65$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $4hSXR(0);
        }
    }
    return $808fedd6b6dc9a65$var$toDER(r, s);
}
function $808fedd6b6dc9a65$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $808fedd6b6dc9a65$require$Buffer.from(res);
}
function $808fedd6b6dc9a65$var$getKey(x, q, hash, algo) {
    x = $808fedd6b6dc9a65$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $808fedd6b6dc9a65$require$Buffer.alloc(q.byteLength() - x.length);
        x = $808fedd6b6dc9a65$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $808fedd6b6dc9a65$var$bits2octets(hash, q);
    var v = $808fedd6b6dc9a65$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $808fedd6b6dc9a65$require$Buffer.alloc(hlen);
    k = $16AOW(algo, k).update(v).update($808fedd6b6dc9a65$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $16AOW(algo, k).update(v).digest();
    k = $16AOW(algo, k).update(v).update($808fedd6b6dc9a65$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $16AOW(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $808fedd6b6dc9a65$var$bits2int(obits, q) {
    var bits = new $4hSXR(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $808fedd6b6dc9a65$var$bits2octets(bits, q) {
    bits = $808fedd6b6dc9a65$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $808fedd6b6dc9a65$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $808fedd6b6dc9a65$require$Buffer.alloc(q.byteLength() - out.length);
        out = $808fedd6b6dc9a65$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $808fedd6b6dc9a65$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $808fedd6b6dc9a65$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $16AOW(algo, kv.k).update(kv.v).digest();
            t = $808fedd6b6dc9a65$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $808fedd6b6dc9a65$var$bits2int(t, q);
        kv.k = $16AOW(algo, kv.k).update(kv.v).update($808fedd6b6dc9a65$require$Buffer.from([
            0
        ])).digest();
        kv.v = $16AOW(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $808fedd6b6dc9a65$var$makeR(g, k, p, q) {
    return g.toRed($4hSXR.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $808fedd6b6dc9a65$var$sign;
module.exports.getKey = $808fedd6b6dc9a65$var$getKey;
module.exports.makeKey = $808fedd6b6dc9a65$var$makeKey;

});
parcelRegister("lAauW", function(module, exports) {
'use strict';

var $4J58B = parcelRequire("4J58B");

var $gYWQI = parcelRequire("gYWQI");

var $btvME = parcelRequire("btvME");
var $fb651a78abfc2b8d$require$Buffer = $btvME.Buffer;
function $fb651a78abfc2b8d$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $4J58B($gYWQI(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $fb651a78abfc2b8d$var$blind(priv) {
    var r = $fb651a78abfc2b8d$var$getr(priv);
    var blinder = r.toRed($4J58B.mont(priv.modulus)).redPow(new $4J58B(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $fb651a78abfc2b8d$var$crt(msg, priv) {
    var blinds = $fb651a78abfc2b8d$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $4J58B(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($4J58B.mont(priv.prime1));
    var c2 = blinded.toRed($4J58B.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($fb651a78abfc2b8d$require$Buffer, 'be', len);
}
$fb651a78abfc2b8d$var$crt.getr = $fb651a78abfc2b8d$var$getr;
module.exports = $fb651a78abfc2b8d$var$crt;

});
parcelRegister("4J58B", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("dluwd")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("47TpL", function(module, exports) {
'use strict';
var $3012cd0bcef830f3$var$elliptic = module.exports;

$3012cd0bcef830f3$var$elliptic.version = (parcelRequire("hM64n")).version;

$3012cd0bcef830f3$var$elliptic.utils = (parcelRequire("g6Gr9"));

$3012cd0bcef830f3$var$elliptic.rand = (parcelRequire("a2CsU"));

$3012cd0bcef830f3$var$elliptic.curve = (parcelRequire("gqj4v"));

$3012cd0bcef830f3$var$elliptic.curves = (parcelRequire("7S8eE"));

// Protocols
$3012cd0bcef830f3$var$elliptic.ec = (parcelRequire("5mlFr"));

$3012cd0bcef830f3$var$elliptic.eddsa = (parcelRequire("hSN2q"));

});
parcelRegister("hM64n", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("g6Gr9", function(module, exports) {
'use strict';
var $bb9e1ffe249e5275$var$utils = module.exports;

var $iTE0Q = parcelRequire("iTE0Q");

var $j0nF4 = parcelRequire("j0nF4");

var $8u6BG = parcelRequire("8u6BG");
$bb9e1ffe249e5275$var$utils.assert = $j0nF4;
$bb9e1ffe249e5275$var$utils.toArray = $8u6BG.toArray;
$bb9e1ffe249e5275$var$utils.zero2 = $8u6BG.zero2;
$bb9e1ffe249e5275$var$utils.toHex = $8u6BG.toHex;
$bb9e1ffe249e5275$var$utils.encode = $8u6BG.encode;
// Represent num in a w-NAF form
function $bb9e1ffe249e5275$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$bb9e1ffe249e5275$var$utils.getNAF = $bb9e1ffe249e5275$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $bb9e1ffe249e5275$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$bb9e1ffe249e5275$var$utils.getJSF = $bb9e1ffe249e5275$var$getJSF;
function $bb9e1ffe249e5275$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$bb9e1ffe249e5275$var$utils.cachedProperty = $bb9e1ffe249e5275$var$cachedProperty;
function $bb9e1ffe249e5275$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $bb9e1ffe249e5275$var$utils.toArray(bytes, 'hex') : bytes;
}
$bb9e1ffe249e5275$var$utils.parseBytes = $bb9e1ffe249e5275$var$parseBytes;
function $bb9e1ffe249e5275$var$intFromLE(bytes) {
    return new $iTE0Q(bytes, 'hex', 'le');
}
$bb9e1ffe249e5275$var$utils.intFromLE = $bb9e1ffe249e5275$var$intFromLE;

});
parcelRegister("8u6BG", function(module, exports) {
'use strict';
var $62d6400e1123cf38$var$utils = module.exports;
function $62d6400e1123cf38$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$62d6400e1123cf38$var$utils.toArray = $62d6400e1123cf38$var$toArray;
function $62d6400e1123cf38$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$62d6400e1123cf38$var$utils.zero2 = $62d6400e1123cf38$var$zero2;
function $62d6400e1123cf38$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $62d6400e1123cf38$var$zero2(msg[i].toString(16));
    return res;
}
$62d6400e1123cf38$var$utils.toHex = $62d6400e1123cf38$var$toHex;
$62d6400e1123cf38$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $62d6400e1123cf38$var$toHex(arr);
    else return arr;
};

});


parcelRegister("gqj4v", function(module, exports) {
'use strict';
var $bf4dde47edc22a63$var$curve = module.exports;

$bf4dde47edc22a63$var$curve.base = (parcelRequire("3GfRa"));

$bf4dde47edc22a63$var$curve.short = (parcelRequire("bzFtB"));

$bf4dde47edc22a63$var$curve.mont = (parcelRequire("6Q5wm"));

$bf4dde47edc22a63$var$curve.edwards = (parcelRequire("gxS8P"));

});
parcelRegister("3GfRa", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $g6Gr9 = parcelRequire("g6Gr9");
var $2ae19823d66ead6c$var$getNAF = $g6Gr9.getNAF;
var $2ae19823d66ead6c$var$getJSF = $g6Gr9.getJSF;
var $2ae19823d66ead6c$var$assert = $g6Gr9.assert;
function $2ae19823d66ead6c$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $iTE0Q(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $iTE0Q.red(conf.prime) : $iTE0Q.mont(this.p);
    // Useful for many curves
    this.zero = new $iTE0Q(0).toRed(this.red);
    this.one = new $iTE0Q(1).toRed(this.red);
    this.two = new $iTE0Q(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $iTE0Q(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2ae19823d66ead6c$var$BaseCurve;
$2ae19823d66ead6c$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$2ae19823d66ead6c$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$2ae19823d66ead6c$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2ae19823d66ead6c$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2ae19823d66ead6c$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2ae19823d66ead6c$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2ae19823d66ead6c$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2ae19823d66ead6c$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$2ae19823d66ead6c$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2ae19823d66ead6c$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2ae19823d66ead6c$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2ae19823d66ead6c$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2ae19823d66ead6c$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2ae19823d66ead6c$var$BaseCurve.BasePoint = $2ae19823d66ead6c$var$BasePoint;
$2ae19823d66ead6c$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$2ae19823d66ead6c$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2ae19823d66ead6c$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $g6Gr9.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2ae19823d66ead6c$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2ae19823d66ead6c$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$2ae19823d66ead6c$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2ae19823d66ead6c$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$2ae19823d66ead6c$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $g6Gr9.encode(this._encode(compact), enc);
};
$2ae19823d66ead6c$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2ae19823d66ead6c$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2ae19823d66ead6c$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2ae19823d66ead6c$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2ae19823d66ead6c$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2ae19823d66ead6c$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("bzFtB", function(module, exports) {
'use strict';

var $g6Gr9 = parcelRequire("g6Gr9");

var $iTE0Q = parcelRequire("iTE0Q");

var $h7THt = parcelRequire("h7THt");

var $3GfRa = parcelRequire("3GfRa");
var $86d322f2bc6c743e$var$assert = $g6Gr9.assert;
function $86d322f2bc6c743e$var$ShortCurve(conf) {
    $3GfRa.call(this, 'short', conf);
    this.a = new $iTE0Q(conf.a, 16).toRed(this.red);
    this.b = new $iTE0Q(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$h7THt($86d322f2bc6c743e$var$ShortCurve, $3GfRa);
module.exports = $86d322f2bc6c743e$var$ShortCurve;
$86d322f2bc6c743e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $iTE0Q(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $iTE0Q(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $86d322f2bc6c743e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $iTE0Q(vec.a, 16),
            b: new $iTE0Q(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$86d322f2bc6c743e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $iTE0Q.mont(num);
    var tinv = new $iTE0Q(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $iTE0Q(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$86d322f2bc6c743e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $iTE0Q(1);
    var y1 = new $iTE0Q(0);
    var x2 = new $iTE0Q(0);
    var y2 = new $iTE0Q(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$86d322f2bc6c743e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$86d322f2bc6c743e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $iTE0Q(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$86d322f2bc6c743e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$86d322f2bc6c743e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $86d322f2bc6c743e$var$Point(curve, x, y, isRed) {
    $3GfRa.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $iTE0Q(x, 16);
        this.y = new $iTE0Q(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$h7THt($86d322f2bc6c743e$var$Point, $3GfRa.BasePoint);
$86d322f2bc6c743e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $86d322f2bc6c743e$var$Point(this, x, y, isRed);
};
$86d322f2bc6c743e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $86d322f2bc6c743e$var$Point.fromJSON(this, obj, red);
};
$86d322f2bc6c743e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$86d322f2bc6c743e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$86d322f2bc6c743e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$86d322f2bc6c743e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$86d322f2bc6c743e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$86d322f2bc6c743e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$86d322f2bc6c743e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$86d322f2bc6c743e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$86d322f2bc6c743e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$86d322f2bc6c743e$var$Point.prototype.mul = function mul(k) {
    k = new $iTE0Q(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$86d322f2bc6c743e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$86d322f2bc6c743e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$86d322f2bc6c743e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$86d322f2bc6c743e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$86d322f2bc6c743e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $86d322f2bc6c743e$var$JPoint(curve, x, y, z) {
    $3GfRa.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $iTE0Q(0);
    } else {
        this.x = new $iTE0Q(x, 16);
        this.y = new $iTE0Q(y, 16);
        this.z = new $iTE0Q(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$h7THt($86d322f2bc6c743e$var$JPoint, $3GfRa.BasePoint);
$86d322f2bc6c743e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $86d322f2bc6c743e$var$JPoint(this, x, y, z);
};
$86d322f2bc6c743e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$86d322f2bc6c743e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$86d322f2bc6c743e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$86d322f2bc6c743e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$86d322f2bc6c743e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$86d322f2bc6c743e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $iTE0Q(k, kbase);
    return this.curve._wnafMul(this, k);
};
$86d322f2bc6c743e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$86d322f2bc6c743e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$86d322f2bc6c743e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$86d322f2bc6c743e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("6Q5wm", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $h7THt = parcelRequire("h7THt");

var $3GfRa = parcelRequire("3GfRa");

var $g6Gr9 = parcelRequire("g6Gr9");
function $4fabe1be2842fa0a$var$MontCurve(conf) {
    $3GfRa.call(this, 'mont', conf);
    this.a = new $iTE0Q(conf.a, 16).toRed(this.red);
    this.b = new $iTE0Q(conf.b, 16).toRed(this.red);
    this.i4 = new $iTE0Q(4).toRed(this.red).redInvm();
    this.two = new $iTE0Q(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$h7THt($4fabe1be2842fa0a$var$MontCurve, $3GfRa);
module.exports = $4fabe1be2842fa0a$var$MontCurve;
$4fabe1be2842fa0a$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $4fabe1be2842fa0a$var$Point(curve, x, z) {
    $3GfRa.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $iTE0Q(x, 16);
        this.z = new $iTE0Q(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$h7THt($4fabe1be2842fa0a$var$Point, $3GfRa.BasePoint);
$4fabe1be2842fa0a$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($g6Gr9.toArray(bytes, enc), 1);
};
$4fabe1be2842fa0a$var$MontCurve.prototype.point = function point(x, z) {
    return new $4fabe1be2842fa0a$var$Point(this, x, z);
};
$4fabe1be2842fa0a$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $4fabe1be2842fa0a$var$Point.fromJSON(this, obj);
};
$4fabe1be2842fa0a$var$Point.prototype.precompute = function precompute() {
// No-op
};
$4fabe1be2842fa0a$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$4fabe1be2842fa0a$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $4fabe1be2842fa0a$var$Point(curve, obj[0], obj[1] || curve.one);
};
$4fabe1be2842fa0a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$4fabe1be2842fa0a$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$4fabe1be2842fa0a$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$4fabe1be2842fa0a$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$4fabe1be2842fa0a$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$4fabe1be2842fa0a$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$4fabe1be2842fa0a$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$4fabe1be2842fa0a$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$4fabe1be2842fa0a$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$4fabe1be2842fa0a$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$4fabe1be2842fa0a$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("gxS8P", function(module, exports) {
'use strict';

var $g6Gr9 = parcelRequire("g6Gr9");

var $iTE0Q = parcelRequire("iTE0Q");

var $h7THt = parcelRequire("h7THt");

var $3GfRa = parcelRequire("3GfRa");
var $c0b9b9c6c268a1f1$var$assert = $g6Gr9.assert;
function $c0b9b9c6c268a1f1$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3GfRa.call(this, 'edwards', conf);
    this.a = new $iTE0Q(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $iTE0Q(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $iTE0Q(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $c0b9b9c6c268a1f1$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$h7THt($c0b9b9c6c268a1f1$var$EdwardsCurve, $3GfRa);
module.exports = $c0b9b9c6c268a1f1$var$EdwardsCurve;
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $iTE0Q(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $iTE0Q(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $c0b9b9c6c268a1f1$var$Point(curve, x, y, z, t) {
    $3GfRa.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $iTE0Q(x, 16);
        this.y = new $iTE0Q(y, 16);
        this.z = z ? new $iTE0Q(z, 16) : this.curve.one;
        this.t = t && new $iTE0Q(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$h7THt($c0b9b9c6c268a1f1$var$Point, $3GfRa.BasePoint);
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c0b9b9c6c268a1f1$var$Point.fromJSON(this, obj);
};
$c0b9b9c6c268a1f1$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $c0b9b9c6c268a1f1$var$Point(this, x, y, z, t);
};
$c0b9b9c6c268a1f1$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c0b9b9c6c268a1f1$var$Point(curve, obj[0], obj[1], obj[2]);
};
$c0b9b9c6c268a1f1$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c0b9b9c6c268a1f1$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$c0b9b9c6c268a1f1$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c0b9b9c6c268a1f1$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$c0b9b9c6c268a1f1$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$c0b9b9c6c268a1f1$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c0b9b9c6c268a1f1$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$c0b9b9c6c268a1f1$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$c0b9b9c6c268a1f1$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$c0b9b9c6c268a1f1$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$c0b9b9c6c268a1f1$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$c0b9b9c6c268a1f1$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$c0b9b9c6c268a1f1$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$c0b9b9c6c268a1f1$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$c0b9b9c6c268a1f1$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$c0b9b9c6c268a1f1$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$c0b9b9c6c268a1f1$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$c0b9b9c6c268a1f1$var$Point.prototype.toP = $c0b9b9c6c268a1f1$var$Point.prototype.normalize;
$c0b9b9c6c268a1f1$var$Point.prototype.mixedAdd = $c0b9b9c6c268a1f1$var$Point.prototype.add;

});


parcelRegister("7S8eE", function(module, exports) {
'use strict';
var $5bb3f6eee78d8029$var$curves = module.exports;

var $jJL0E = parcelRequire("jJL0E");

var $gqj4v = parcelRequire("gqj4v");

var $g6Gr9 = parcelRequire("g6Gr9");
var $5bb3f6eee78d8029$var$assert = $g6Gr9.assert;
function $5bb3f6eee78d8029$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $gqj4v.short(options);
    else if (options.type === 'edwards') this.curve = new $gqj4v.edwards(options);
    else this.curve = new $gqj4v.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $5bb3f6eee78d8029$var$assert(this.g.validate(), 'Invalid curve');
    $5bb3f6eee78d8029$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$5bb3f6eee78d8029$var$curves.PresetCurve = $5bb3f6eee78d8029$var$PresetCurve;
function $5bb3f6eee78d8029$var$defineCurve(name, options) {
    Object.defineProperty($5bb3f6eee78d8029$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $5bb3f6eee78d8029$var$PresetCurve(options);
            Object.defineProperty($5bb3f6eee78d8029$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$5bb3f6eee78d8029$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $jJL0E.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$5bb3f6eee78d8029$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $jJL0E.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$5bb3f6eee78d8029$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $jJL0E.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$5bb3f6eee78d8029$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $jJL0E.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$5bb3f6eee78d8029$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $jJL0E.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$5bb3f6eee78d8029$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $jJL0E.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$5bb3f6eee78d8029$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $jJL0E.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $5bb3f6eee78d8029$var$pre;

try {
    $5bb3f6eee78d8029$var$pre = (parcelRequire("6Efx5"));
} catch (e) {
    $5bb3f6eee78d8029$var$pre = undefined;
}
$5bb3f6eee78d8029$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $jJL0E.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $5bb3f6eee78d8029$var$pre
    ]
});

});
parcelRegister("jJL0E", function(module, exports) {
var $e5e6af69a9f9f5dd$var$hash = module.exports;

$e5e6af69a9f9f5dd$var$hash.utils = (parcelRequire("aswIj"));

$e5e6af69a9f9f5dd$var$hash.common = (parcelRequire("bS9ba"));

$e5e6af69a9f9f5dd$var$hash.sha = (parcelRequire("1iW8r"));

$e5e6af69a9f9f5dd$var$hash.ripemd = (parcelRequire("7Nya8"));

$e5e6af69a9f9f5dd$var$hash.hmac = (parcelRequire("3gQMI"));
// Proxy hash functions to the main object
$e5e6af69a9f9f5dd$var$hash.sha1 = $e5e6af69a9f9f5dd$var$hash.sha.sha1;
$e5e6af69a9f9f5dd$var$hash.sha256 = $e5e6af69a9f9f5dd$var$hash.sha.sha256;
$e5e6af69a9f9f5dd$var$hash.sha224 = $e5e6af69a9f9f5dd$var$hash.sha.sha224;
$e5e6af69a9f9f5dd$var$hash.sha384 = $e5e6af69a9f9f5dd$var$hash.sha.sha384;
$e5e6af69a9f9f5dd$var$hash.sha512 = $e5e6af69a9f9f5dd$var$hash.sha.sha512;
$e5e6af69a9f9f5dd$var$hash.ripemd160 = $e5e6af69a9f9f5dd$var$hash.ripemd.ripemd160;

});
parcelRegister("aswIj", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $79d5e53149ddbef8$export$69f1b2dcda23c5f8; }, function (v) { return $79d5e53149ddbef8$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $79d5e53149ddbef8$export$45b10814cc054894; }, function (v) { return $79d5e53149ddbef8$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $79d5e53149ddbef8$export$7ea66e3774a60b67; }, function (v) { return $79d5e53149ddbef8$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $79d5e53149ddbef8$export$34a52f00f601f6f1; }, function (v) { return $79d5e53149ddbef8$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $79d5e53149ddbef8$export$812b0cbd5e8a72ab; }, function (v) { return $79d5e53149ddbef8$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $79d5e53149ddbef8$export$f24f9e11d63bb314; }, function (v) { return $79d5e53149ddbef8$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $79d5e53149ddbef8$export$b71357c7e07ca1f1; }, function (v) { return $79d5e53149ddbef8$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $79d5e53149ddbef8$export$2e58a4b541fdcbe8; }, function (v) { return $79d5e53149ddbef8$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $79d5e53149ddbef8$export$183b950bde9faab8; }, function (v) { return $79d5e53149ddbef8$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $79d5e53149ddbef8$export$4785c77169fea59e; }, function (v) { return $79d5e53149ddbef8$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $79d5e53149ddbef8$export$242a185dfcffac5b; }, function (v) { return $79d5e53149ddbef8$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $79d5e53149ddbef8$export$58c04ae0ae31877d; }, function (v) { return $79d5e53149ddbef8$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $79d5e53149ddbef8$export$d058ca695f8c6f11; }, function (v) { return $79d5e53149ddbef8$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $79d5e53149ddbef8$export$a1efd7fc3e986367; }, function (v) { return $79d5e53149ddbef8$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $79d5e53149ddbef8$export$bbfea4a2b5abaab4; }, function (v) { return $79d5e53149ddbef8$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $79d5e53149ddbef8$export$97ad4afc7de86152; }, function (v) { return $79d5e53149ddbef8$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $79d5e53149ddbef8$export$ce4673d9a79f6a4b; }, function (v) { return $79d5e53149ddbef8$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $79d5e53149ddbef8$export$786cc99fc6eedc0b; }, function (v) { return $79d5e53149ddbef8$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $79d5e53149ddbef8$export$45c59b9a1848dd0; }, function (v) { return $79d5e53149ddbef8$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $79d5e53149ddbef8$export$50d8f613e76d3034; }, function (v) { return $79d5e53149ddbef8$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $79d5e53149ddbef8$export$b8e83683c60ee162; }, function (v) { return $79d5e53149ddbef8$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $79d5e53149ddbef8$export$aeeb51790d1bcc4a; }, function (v) { return $79d5e53149ddbef8$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $79d5e53149ddbef8$export$bb7c616f719ad9c; }, function (v) { return $79d5e53149ddbef8$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $79d5e53149ddbef8$export$4d63290824f9d7df; }, function (v) { return $79d5e53149ddbef8$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $79d5e53149ddbef8$export$2f64ceb90ef28ea1; }, function (v) { return $79d5e53149ddbef8$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $79d5e53149ddbef8$export$8d2089d465f6d10d; }, function (v) { return $79d5e53149ddbef8$export$8d2089d465f6d10d = v; });
var $79d5e53149ddbef8$export$69f1b2dcda23c5f8;
var $79d5e53149ddbef8$export$45b10814cc054894;
var $79d5e53149ddbef8$export$7ea66e3774a60b67;
var $79d5e53149ddbef8$export$34a52f00f601f6f1;
var $79d5e53149ddbef8$export$812b0cbd5e8a72ab;
var $79d5e53149ddbef8$export$f24f9e11d63bb314;
var $79d5e53149ddbef8$export$b71357c7e07ca1f1;
var $79d5e53149ddbef8$export$2e58a4b541fdcbe8;
var $79d5e53149ddbef8$export$183b950bde9faab8;
var $79d5e53149ddbef8$export$4785c77169fea59e;
var $79d5e53149ddbef8$export$242a185dfcffac5b;
var $79d5e53149ddbef8$export$58c04ae0ae31877d;
var $79d5e53149ddbef8$export$d058ca695f8c6f11;
var $79d5e53149ddbef8$export$a1efd7fc3e986367;
var $79d5e53149ddbef8$export$bbfea4a2b5abaab4;
var $79d5e53149ddbef8$export$97ad4afc7de86152;
var $79d5e53149ddbef8$export$ce4673d9a79f6a4b;
var $79d5e53149ddbef8$export$786cc99fc6eedc0b;
var $79d5e53149ddbef8$export$45c59b9a1848dd0;
var $79d5e53149ddbef8$export$50d8f613e76d3034;
var $79d5e53149ddbef8$export$b8e83683c60ee162;
var $79d5e53149ddbef8$export$aeeb51790d1bcc4a;
var $79d5e53149ddbef8$export$bb7c616f719ad9c;
var $79d5e53149ddbef8$export$4d63290824f9d7df;
var $79d5e53149ddbef8$export$2f64ceb90ef28ea1;
var $79d5e53149ddbef8$export$8d2089d465f6d10d;
'use strict';

var $j0nF4 = parcelRequire("j0nF4");

var $h7THt = parcelRequire("h7THt");
$79d5e53149ddbef8$export$69f1b2dcda23c5f8 = $h7THt;
function $79d5e53149ddbef8$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $79d5e53149ddbef8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($79d5e53149ddbef8$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$79d5e53149ddbef8$export$45b10814cc054894 = $79d5e53149ddbef8$var$toArray;
function $79d5e53149ddbef8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $79d5e53149ddbef8$var$zero2(msg[i].toString(16));
    return res;
}
$79d5e53149ddbef8$export$7ea66e3774a60b67 = $79d5e53149ddbef8$var$toHex;
function $79d5e53149ddbef8$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$79d5e53149ddbef8$export$34a52f00f601f6f1 = $79d5e53149ddbef8$var$htonl;
function $79d5e53149ddbef8$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $79d5e53149ddbef8$var$htonl(w);
        res += $79d5e53149ddbef8$var$zero8(w.toString(16));
    }
    return res;
}
$79d5e53149ddbef8$export$812b0cbd5e8a72ab = $79d5e53149ddbef8$var$toHex32;
function $79d5e53149ddbef8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$79d5e53149ddbef8$export$f24f9e11d63bb314 = $79d5e53149ddbef8$var$zero2;
function $79d5e53149ddbef8$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$79d5e53149ddbef8$export$b71357c7e07ca1f1 = $79d5e53149ddbef8$var$zero8;
function $79d5e53149ddbef8$var$join32(msg, start, end, endian) {
    var len = end - start;
    $j0nF4(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$79d5e53149ddbef8$export$2e58a4b541fdcbe8 = $79d5e53149ddbef8$var$join32;
function $79d5e53149ddbef8$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$79d5e53149ddbef8$export$183b950bde9faab8 = $79d5e53149ddbef8$var$split32;
function $79d5e53149ddbef8$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$79d5e53149ddbef8$export$4785c77169fea59e = $79d5e53149ddbef8$var$rotr32;
function $79d5e53149ddbef8$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$79d5e53149ddbef8$export$242a185dfcffac5b = $79d5e53149ddbef8$var$rotl32;
function $79d5e53149ddbef8$var$sum32(a, b) {
    return a + b >>> 0;
}
$79d5e53149ddbef8$export$58c04ae0ae31877d = $79d5e53149ddbef8$var$sum32;
function $79d5e53149ddbef8$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$79d5e53149ddbef8$export$d058ca695f8c6f11 = $79d5e53149ddbef8$var$sum32_3;
function $79d5e53149ddbef8$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$79d5e53149ddbef8$export$a1efd7fc3e986367 = $79d5e53149ddbef8$var$sum32_4;
function $79d5e53149ddbef8$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$79d5e53149ddbef8$export$bbfea4a2b5abaab4 = $79d5e53149ddbef8$var$sum32_5;
function $79d5e53149ddbef8$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$79d5e53149ddbef8$export$97ad4afc7de86152 = $79d5e53149ddbef8$var$sum64;
function $79d5e53149ddbef8$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$79d5e53149ddbef8$export$ce4673d9a79f6a4b = $79d5e53149ddbef8$var$sum64_hi;
function $79d5e53149ddbef8$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$79d5e53149ddbef8$export$786cc99fc6eedc0b = $79d5e53149ddbef8$var$sum64_lo;
function $79d5e53149ddbef8$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$79d5e53149ddbef8$export$45c59b9a1848dd0 = $79d5e53149ddbef8$var$sum64_4_hi;
function $79d5e53149ddbef8$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$79d5e53149ddbef8$export$50d8f613e76d3034 = $79d5e53149ddbef8$var$sum64_4_lo;
function $79d5e53149ddbef8$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$79d5e53149ddbef8$export$b8e83683c60ee162 = $79d5e53149ddbef8$var$sum64_5_hi;
function $79d5e53149ddbef8$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$79d5e53149ddbef8$export$aeeb51790d1bcc4a = $79d5e53149ddbef8$var$sum64_5_lo;
function $79d5e53149ddbef8$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$79d5e53149ddbef8$export$bb7c616f719ad9c = $79d5e53149ddbef8$var$rotr64_hi;
function $79d5e53149ddbef8$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$79d5e53149ddbef8$export$4d63290824f9d7df = $79d5e53149ddbef8$var$rotr64_lo;
function $79d5e53149ddbef8$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$79d5e53149ddbef8$export$2f64ceb90ef28ea1 = $79d5e53149ddbef8$var$shr64_hi;
function $79d5e53149ddbef8$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$79d5e53149ddbef8$export$8d2089d465f6d10d = $79d5e53149ddbef8$var$shr64_lo;

});

parcelRegister("bS9ba", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $8a4bdba2993e4355$export$8687658379b577e6; }, function (v) { return $8a4bdba2993e4355$export$8687658379b577e6 = v; });
var $8a4bdba2993e4355$export$8687658379b577e6;
'use strict';

var $aswIj = parcelRequire("aswIj");

var $j0nF4 = parcelRequire("j0nF4");
function $8a4bdba2993e4355$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$8a4bdba2993e4355$export$8687658379b577e6 = $8a4bdba2993e4355$var$BlockHash;
$8a4bdba2993e4355$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $aswIj.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $aswIj.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$8a4bdba2993e4355$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $j0nF4(this.pending === null);
    return this._digest(enc);
};
$8a4bdba2993e4355$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("1iW8r", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $0f349155cafa0cc4$export$5091bdda49ba90f5; }, function (v) { return $0f349155cafa0cc4$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $0f349155cafa0cc4$export$97b70509d4e397ea; }, function (v) { return $0f349155cafa0cc4$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $0f349155cafa0cc4$export$bced8d2aada2d1c9; }, function (v) { return $0f349155cafa0cc4$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $0f349155cafa0cc4$export$612d47d55dedde45; }, function (v) { return $0f349155cafa0cc4$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $0f349155cafa0cc4$export$a888d2532e6dc7bb; }, function (v) { return $0f349155cafa0cc4$export$a888d2532e6dc7bb = v; });
var $0f349155cafa0cc4$export$5091bdda49ba90f5;
var $0f349155cafa0cc4$export$97b70509d4e397ea;
var $0f349155cafa0cc4$export$bced8d2aada2d1c9;
var $0f349155cafa0cc4$export$612d47d55dedde45;
var $0f349155cafa0cc4$export$a888d2532e6dc7bb;
'use strict';

$0f349155cafa0cc4$export$5091bdda49ba90f5 = (parcelRequire("eFzAV"));

$0f349155cafa0cc4$export$97b70509d4e397ea = (parcelRequire("kREoi"));

$0f349155cafa0cc4$export$bced8d2aada2d1c9 = (parcelRequire("hjuCW"));

$0f349155cafa0cc4$export$612d47d55dedde45 = (parcelRequire("hQ3HN"));

$0f349155cafa0cc4$export$a888d2532e6dc7bb = (parcelRequire("NHH6p"));

});
parcelRegister("eFzAV", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $bS9ba = parcelRequire("bS9ba");

var $ftB6Z = parcelRequire("ftB6Z");
var $aae0815e1f4e3b3e$var$rotl32 = $aswIj.rotl32;
var $aae0815e1f4e3b3e$var$sum32 = $aswIj.sum32;
var $aae0815e1f4e3b3e$var$sum32_5 = $aswIj.sum32_5;
var $aae0815e1f4e3b3e$var$ft_1 = $ftB6Z.ft_1;
var $aae0815e1f4e3b3e$var$BlockHash = $bS9ba.BlockHash;
var $aae0815e1f4e3b3e$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $aae0815e1f4e3b3e$var$SHA1() {
    if (!(this instanceof $aae0815e1f4e3b3e$var$SHA1)) return new $aae0815e1f4e3b3e$var$SHA1();
    $aae0815e1f4e3b3e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$aswIj.inherits($aae0815e1f4e3b3e$var$SHA1, $aae0815e1f4e3b3e$var$BlockHash);
module.exports = $aae0815e1f4e3b3e$var$SHA1;
$aae0815e1f4e3b3e$var$SHA1.blockSize = 512;
$aae0815e1f4e3b3e$var$SHA1.outSize = 160;
$aae0815e1f4e3b3e$var$SHA1.hmacStrength = 80;
$aae0815e1f4e3b3e$var$SHA1.padLength = 64;
$aae0815e1f4e3b3e$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $aae0815e1f4e3b3e$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $aae0815e1f4e3b3e$var$sum32_5($aae0815e1f4e3b3e$var$rotl32(a, 5), $aae0815e1f4e3b3e$var$ft_1(s, b, c, d), e, W[i], $aae0815e1f4e3b3e$var$sha1_K[s]);
        e = d;
        d = c;
        c = $aae0815e1f4e3b3e$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $aae0815e1f4e3b3e$var$sum32(this.h[0], a);
    this.h[1] = $aae0815e1f4e3b3e$var$sum32(this.h[1], b);
    this.h[2] = $aae0815e1f4e3b3e$var$sum32(this.h[2], c);
    this.h[3] = $aae0815e1f4e3b3e$var$sum32(this.h[3], d);
    this.h[4] = $aae0815e1f4e3b3e$var$sum32(this.h[4], e);
};
$aae0815e1f4e3b3e$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aswIj.toHex32(this.h, 'big');
    else return $aswIj.split32(this.h, 'big');
};

});
parcelRegister("ftB6Z", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $b4465a0a89593299$export$5a92649d7ddb9f63; }, function (v) { return $b4465a0a89593299$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $b4465a0a89593299$export$c6d0d020c3a6269; }, function (v) { return $b4465a0a89593299$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $b4465a0a89593299$export$eb90c27fca05f956; }, function (v) { return $b4465a0a89593299$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $b4465a0a89593299$export$14a4a98e063b1999; }, function (v) { return $b4465a0a89593299$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $b4465a0a89593299$export$d20cecfa1564c686; }, function (v) { return $b4465a0a89593299$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $b4465a0a89593299$export$44fd472a12fc6db; }, function (v) { return $b4465a0a89593299$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $b4465a0a89593299$export$1ed238bb6ea1dd47; }, function (v) { return $b4465a0a89593299$export$1ed238bb6ea1dd47 = v; });
var $b4465a0a89593299$export$5a92649d7ddb9f63;
var $b4465a0a89593299$export$c6d0d020c3a6269;
var $b4465a0a89593299$export$eb90c27fca05f956;
var $b4465a0a89593299$export$cc992891a14496a1;
var $b4465a0a89593299$export$14a4a98e063b1999;
var $b4465a0a89593299$export$d20cecfa1564c686;
var $b4465a0a89593299$export$44fd472a12fc6db;
var $b4465a0a89593299$export$1ed238bb6ea1dd47;
'use strict';

var $aswIj = parcelRequire("aswIj");
var $b4465a0a89593299$var$rotr32 = $aswIj.rotr32;
function $b4465a0a89593299$var$ft_1(s, x, y, z) {
    if (s === 0) return $b4465a0a89593299$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $b4465a0a89593299$var$p32(x, y, z);
    if (s === 2) return $b4465a0a89593299$var$maj32(x, y, z);
}
$b4465a0a89593299$export$5a92649d7ddb9f63 = $b4465a0a89593299$var$ft_1;
function $b4465a0a89593299$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$b4465a0a89593299$export$c6d0d020c3a6269 = $b4465a0a89593299$var$ch32;
function $b4465a0a89593299$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$b4465a0a89593299$export$eb90c27fca05f956 = $b4465a0a89593299$var$maj32;
function $b4465a0a89593299$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$b4465a0a89593299$export$cc992891a14496a1 = $b4465a0a89593299$var$p32;
function $b4465a0a89593299$var$s0_256(x) {
    return $b4465a0a89593299$var$rotr32(x, 2) ^ $b4465a0a89593299$var$rotr32(x, 13) ^ $b4465a0a89593299$var$rotr32(x, 22);
}
$b4465a0a89593299$export$14a4a98e063b1999 = $b4465a0a89593299$var$s0_256;
function $b4465a0a89593299$var$s1_256(x) {
    return $b4465a0a89593299$var$rotr32(x, 6) ^ $b4465a0a89593299$var$rotr32(x, 11) ^ $b4465a0a89593299$var$rotr32(x, 25);
}
$b4465a0a89593299$export$d20cecfa1564c686 = $b4465a0a89593299$var$s1_256;
function $b4465a0a89593299$var$g0_256(x) {
    return $b4465a0a89593299$var$rotr32(x, 7) ^ $b4465a0a89593299$var$rotr32(x, 18) ^ x >>> 3;
}
$b4465a0a89593299$export$44fd472a12fc6db = $b4465a0a89593299$var$g0_256;
function $b4465a0a89593299$var$g1_256(x) {
    return $b4465a0a89593299$var$rotr32(x, 17) ^ $b4465a0a89593299$var$rotr32(x, 19) ^ x >>> 10;
}
$b4465a0a89593299$export$1ed238bb6ea1dd47 = $b4465a0a89593299$var$g1_256;

});


parcelRegister("kREoi", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $hjuCW = parcelRequire("hjuCW");
function $03eb7c3cab06e514$var$SHA224() {
    if (!(this instanceof $03eb7c3cab06e514$var$SHA224)) return new $03eb7c3cab06e514$var$SHA224();
    $hjuCW.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$aswIj.inherits($03eb7c3cab06e514$var$SHA224, $hjuCW);
module.exports = $03eb7c3cab06e514$var$SHA224;
$03eb7c3cab06e514$var$SHA224.blockSize = 512;
$03eb7c3cab06e514$var$SHA224.outSize = 224;
$03eb7c3cab06e514$var$SHA224.hmacStrength = 192;
$03eb7c3cab06e514$var$SHA224.padLength = 64;
$03eb7c3cab06e514$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $aswIj.toHex32(this.h.slice(0, 7), 'big');
    else return $aswIj.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("hjuCW", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $bS9ba = parcelRequire("bS9ba");

var $ftB6Z = parcelRequire("ftB6Z");

var $j0nF4 = parcelRequire("j0nF4");
var $c9abf7ebe46929f9$var$sum32 = $aswIj.sum32;
var $c9abf7ebe46929f9$var$sum32_4 = $aswIj.sum32_4;
var $c9abf7ebe46929f9$var$sum32_5 = $aswIj.sum32_5;
var $c9abf7ebe46929f9$var$ch32 = $ftB6Z.ch32;
var $c9abf7ebe46929f9$var$maj32 = $ftB6Z.maj32;
var $c9abf7ebe46929f9$var$s0_256 = $ftB6Z.s0_256;
var $c9abf7ebe46929f9$var$s1_256 = $ftB6Z.s1_256;
var $c9abf7ebe46929f9$var$g0_256 = $ftB6Z.g0_256;
var $c9abf7ebe46929f9$var$g1_256 = $ftB6Z.g1_256;
var $c9abf7ebe46929f9$var$BlockHash = $bS9ba.BlockHash;
var $c9abf7ebe46929f9$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $c9abf7ebe46929f9$var$SHA256() {
    if (!(this instanceof $c9abf7ebe46929f9$var$SHA256)) return new $c9abf7ebe46929f9$var$SHA256();
    $c9abf7ebe46929f9$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $c9abf7ebe46929f9$var$sha256_K;
    this.W = new Array(64);
}
$aswIj.inherits($c9abf7ebe46929f9$var$SHA256, $c9abf7ebe46929f9$var$BlockHash);
module.exports = $c9abf7ebe46929f9$var$SHA256;
$c9abf7ebe46929f9$var$SHA256.blockSize = 512;
$c9abf7ebe46929f9$var$SHA256.outSize = 256;
$c9abf7ebe46929f9$var$SHA256.hmacStrength = 192;
$c9abf7ebe46929f9$var$SHA256.padLength = 64;
$c9abf7ebe46929f9$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $c9abf7ebe46929f9$var$sum32_4($c9abf7ebe46929f9$var$g1_256(W[i - 2]), W[i - 7], $c9abf7ebe46929f9$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $j0nF4(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $c9abf7ebe46929f9$var$sum32_5(h, $c9abf7ebe46929f9$var$s1_256(e), $c9abf7ebe46929f9$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $c9abf7ebe46929f9$var$sum32($c9abf7ebe46929f9$var$s0_256(a), $c9abf7ebe46929f9$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $c9abf7ebe46929f9$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $c9abf7ebe46929f9$var$sum32(T1, T2);
    }
    this.h[0] = $c9abf7ebe46929f9$var$sum32(this.h[0], a);
    this.h[1] = $c9abf7ebe46929f9$var$sum32(this.h[1], b);
    this.h[2] = $c9abf7ebe46929f9$var$sum32(this.h[2], c);
    this.h[3] = $c9abf7ebe46929f9$var$sum32(this.h[3], d);
    this.h[4] = $c9abf7ebe46929f9$var$sum32(this.h[4], e);
    this.h[5] = $c9abf7ebe46929f9$var$sum32(this.h[5], f);
    this.h[6] = $c9abf7ebe46929f9$var$sum32(this.h[6], g);
    this.h[7] = $c9abf7ebe46929f9$var$sum32(this.h[7], h);
};
$c9abf7ebe46929f9$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aswIj.toHex32(this.h, 'big');
    else return $aswIj.split32(this.h, 'big');
};

});


parcelRegister("hQ3HN", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $NHH6p = parcelRequire("NHH6p");
function $cfca2ad0e2b76153$var$SHA384() {
    if (!(this instanceof $cfca2ad0e2b76153$var$SHA384)) return new $cfca2ad0e2b76153$var$SHA384();
    $NHH6p.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$aswIj.inherits($cfca2ad0e2b76153$var$SHA384, $NHH6p);
module.exports = $cfca2ad0e2b76153$var$SHA384;
$cfca2ad0e2b76153$var$SHA384.blockSize = 1024;
$cfca2ad0e2b76153$var$SHA384.outSize = 384;
$cfca2ad0e2b76153$var$SHA384.hmacStrength = 192;
$cfca2ad0e2b76153$var$SHA384.padLength = 128;
$cfca2ad0e2b76153$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aswIj.toHex32(this.h.slice(0, 12), 'big');
    else return $aswIj.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("NHH6p", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $bS9ba = parcelRequire("bS9ba");

var $j0nF4 = parcelRequire("j0nF4");
var $09567879d46e6ab9$var$rotr64_hi = $aswIj.rotr64_hi;
var $09567879d46e6ab9$var$rotr64_lo = $aswIj.rotr64_lo;
var $09567879d46e6ab9$var$shr64_hi = $aswIj.shr64_hi;
var $09567879d46e6ab9$var$shr64_lo = $aswIj.shr64_lo;
var $09567879d46e6ab9$var$sum64 = $aswIj.sum64;
var $09567879d46e6ab9$var$sum64_hi = $aswIj.sum64_hi;
var $09567879d46e6ab9$var$sum64_lo = $aswIj.sum64_lo;
var $09567879d46e6ab9$var$sum64_4_hi = $aswIj.sum64_4_hi;
var $09567879d46e6ab9$var$sum64_4_lo = $aswIj.sum64_4_lo;
var $09567879d46e6ab9$var$sum64_5_hi = $aswIj.sum64_5_hi;
var $09567879d46e6ab9$var$sum64_5_lo = $aswIj.sum64_5_lo;
var $09567879d46e6ab9$var$BlockHash = $bS9ba.BlockHash;
var $09567879d46e6ab9$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $09567879d46e6ab9$var$SHA512() {
    if (!(this instanceof $09567879d46e6ab9$var$SHA512)) return new $09567879d46e6ab9$var$SHA512();
    $09567879d46e6ab9$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $09567879d46e6ab9$var$sha512_K;
    this.W = new Array(160);
}
$aswIj.inherits($09567879d46e6ab9$var$SHA512, $09567879d46e6ab9$var$BlockHash);
module.exports = $09567879d46e6ab9$var$SHA512;
$09567879d46e6ab9$var$SHA512.blockSize = 1024;
$09567879d46e6ab9$var$SHA512.outSize = 512;
$09567879d46e6ab9$var$SHA512.hmacStrength = 192;
$09567879d46e6ab9$var$SHA512.padLength = 128;
$09567879d46e6ab9$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $09567879d46e6ab9$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $09567879d46e6ab9$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $09567879d46e6ab9$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $09567879d46e6ab9$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $09567879d46e6ab9$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $09567879d46e6ab9$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$09567879d46e6ab9$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $j0nF4(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $09567879d46e6ab9$var$s1_512_hi(eh, el);
        var c1_lo = $09567879d46e6ab9$var$s1_512_lo(eh, el);
        var c2_hi = $09567879d46e6ab9$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $09567879d46e6ab9$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $09567879d46e6ab9$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $09567879d46e6ab9$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $09567879d46e6ab9$var$s0_512_hi(ah, al);
        c0_lo = $09567879d46e6ab9$var$s0_512_lo(ah, al);
        c1_hi = $09567879d46e6ab9$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $09567879d46e6ab9$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $09567879d46e6ab9$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $09567879d46e6ab9$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $09567879d46e6ab9$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $09567879d46e6ab9$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $09567879d46e6ab9$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $09567879d46e6ab9$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $09567879d46e6ab9$var$sum64(this.h, 0, ah, al);
    $09567879d46e6ab9$var$sum64(this.h, 2, bh, bl);
    $09567879d46e6ab9$var$sum64(this.h, 4, ch, cl);
    $09567879d46e6ab9$var$sum64(this.h, 6, dh, dl);
    $09567879d46e6ab9$var$sum64(this.h, 8, eh, el);
    $09567879d46e6ab9$var$sum64(this.h, 10, fh, fl);
    $09567879d46e6ab9$var$sum64(this.h, 12, gh, gl);
    $09567879d46e6ab9$var$sum64(this.h, 14, hh, hl);
};
$09567879d46e6ab9$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aswIj.toHex32(this.h, 'big');
    else return $aswIj.split32(this.h, 'big');
};
function $09567879d46e6ab9$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$s0_512_hi(xh, xl) {
    var c0_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $09567879d46e6ab9$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $09567879d46e6ab9$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$s0_512_lo(xh, xl) {
    var c0_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $09567879d46e6ab9$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $09567879d46e6ab9$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$s1_512_hi(xh, xl) {
    var c0_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $09567879d46e6ab9$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$s1_512_lo(xh, xl) {
    var c0_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $09567879d46e6ab9$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$g0_512_hi(xh, xl) {
    var c0_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $09567879d46e6ab9$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$g0_512_lo(xh, xl) {
    var c0_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $09567879d46e6ab9$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$g1_512_hi(xh, xl) {
    var c0_hi = $09567879d46e6ab9$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $09567879d46e6ab9$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $09567879d46e6ab9$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $09567879d46e6ab9$var$g1_512_lo(xh, xl) {
    var c0_lo = $09567879d46e6ab9$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $09567879d46e6ab9$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $09567879d46e6ab9$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("7Nya8", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $5ad79bf91b76fb50$export$d1cea0ee4e3f0d3e; }, function (v) { return $5ad79bf91b76fb50$export$d1cea0ee4e3f0d3e = v; });
var $5ad79bf91b76fb50$export$d1cea0ee4e3f0d3e;
'use strict';

var $aswIj = parcelRequire("aswIj");

var $bS9ba = parcelRequire("bS9ba");
var $5ad79bf91b76fb50$var$rotl32 = $aswIj.rotl32;
var $5ad79bf91b76fb50$var$sum32 = $aswIj.sum32;
var $5ad79bf91b76fb50$var$sum32_3 = $aswIj.sum32_3;
var $5ad79bf91b76fb50$var$sum32_4 = $aswIj.sum32_4;
var $5ad79bf91b76fb50$var$BlockHash = $bS9ba.BlockHash;
function $5ad79bf91b76fb50$var$RIPEMD160() {
    if (!(this instanceof $5ad79bf91b76fb50$var$RIPEMD160)) return new $5ad79bf91b76fb50$var$RIPEMD160();
    $5ad79bf91b76fb50$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$aswIj.inherits($5ad79bf91b76fb50$var$RIPEMD160, $5ad79bf91b76fb50$var$BlockHash);
$5ad79bf91b76fb50$export$d1cea0ee4e3f0d3e = $5ad79bf91b76fb50$var$RIPEMD160;
$5ad79bf91b76fb50$var$RIPEMD160.blockSize = 512;
$5ad79bf91b76fb50$var$RIPEMD160.outSize = 160;
$5ad79bf91b76fb50$var$RIPEMD160.hmacStrength = 192;
$5ad79bf91b76fb50$var$RIPEMD160.padLength = 64;
$5ad79bf91b76fb50$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $5ad79bf91b76fb50$var$sum32($5ad79bf91b76fb50$var$rotl32($5ad79bf91b76fb50$var$sum32_4(A, $5ad79bf91b76fb50$var$f(j, B, C, D), msg[$5ad79bf91b76fb50$var$r[j] + start], $5ad79bf91b76fb50$var$K(j)), $5ad79bf91b76fb50$var$s[j]), E);
        A = E;
        E = D;
        D = $5ad79bf91b76fb50$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $5ad79bf91b76fb50$var$sum32($5ad79bf91b76fb50$var$rotl32($5ad79bf91b76fb50$var$sum32_4(Ah, $5ad79bf91b76fb50$var$f(79 - j, Bh, Ch, Dh), msg[$5ad79bf91b76fb50$var$rh[j] + start], $5ad79bf91b76fb50$var$Kh(j)), $5ad79bf91b76fb50$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $5ad79bf91b76fb50$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $5ad79bf91b76fb50$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $5ad79bf91b76fb50$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $5ad79bf91b76fb50$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $5ad79bf91b76fb50$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $5ad79bf91b76fb50$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$5ad79bf91b76fb50$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $aswIj.toHex32(this.h, 'little');
    else return $aswIj.split32(this.h, 'little');
};
function $5ad79bf91b76fb50$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $5ad79bf91b76fb50$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $5ad79bf91b76fb50$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $5ad79bf91b76fb50$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $5ad79bf91b76fb50$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $5ad79bf91b76fb50$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $5ad79bf91b76fb50$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("3gQMI", function(module, exports) {
'use strict';

var $aswIj = parcelRequire("aswIj");

var $j0nF4 = parcelRequire("j0nF4");
function $261bcfa790090098$var$Hmac(hash, key, enc) {
    if (!(this instanceof $261bcfa790090098$var$Hmac)) return new $261bcfa790090098$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($aswIj.toArray(key, enc));
}
module.exports = $261bcfa790090098$var$Hmac;
$261bcfa790090098$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $j0nF4(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$261bcfa790090098$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$261bcfa790090098$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("6Efx5", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("5mlFr", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $7qGkP = parcelRequire("7qGkP");

var $g6Gr9 = parcelRequire("g6Gr9");

var $7S8eE = parcelRequire("7S8eE");

var $a2CsU = parcelRequire("a2CsU");
var $3e6fd087d588d01b$var$assert = $g6Gr9.assert;

var $lpyI3 = parcelRequire("lpyI3");

var $kNfV3 = parcelRequire("kNfV3");
function $3e6fd087d588d01b$var$EC(options) {
    if (!(this instanceof $3e6fd087d588d01b$var$EC)) return new $3e6fd087d588d01b$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $3e6fd087d588d01b$var$assert(Object.prototype.hasOwnProperty.call($7S8eE, options), 'Unknown curve ' + options);
        options = $7S8eE[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $7S8eE.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $3e6fd087d588d01b$var$EC;
$3e6fd087d588d01b$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lpyI3(this, options);
};
$3e6fd087d588d01b$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lpyI3.fromPrivate(this, priv, enc);
};
$3e6fd087d588d01b$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lpyI3.fromPublic(this, pub, enc);
};
$3e6fd087d588d01b$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $7qGkP({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $a2CsU(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $iTE0Q(2));
    for(;;){
        var priv = new $iTE0Q(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$3e6fd087d588d01b$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($iTE0Q.isBN(msg) || typeof msg === 'number') {
        msg = new $iTE0Q(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $iTE0Q(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $iTE0Q(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$3e6fd087d588d01b$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$iTE0Q.isBN(msg)) {
        $3e6fd087d588d01b$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $3e6fd087d588d01b$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$3e6fd087d588d01b$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $3e6fd087d588d01b$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $3e6fd087d588d01b$var$assert(new $iTE0Q(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $7qGkP({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $iTE0Q(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $iTE0Q(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kNfV3({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$3e6fd087d588d01b$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $kNfV3(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$3e6fd087d588d01b$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $3e6fd087d588d01b$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $kNfV3(signature, enc);
    var n = this.n;
    var e = new $iTE0Q(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$3e6fd087d588d01b$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kNfV3(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("7qGkP", function(module, exports) {
'use strict';

var $jJL0E = parcelRequire("jJL0E");

var $8u6BG = parcelRequire("8u6BG");

var $j0nF4 = parcelRequire("j0nF4");
function $568bccf839e3e718$var$HmacDRBG(options) {
    if (!(this instanceof $568bccf839e3e718$var$HmacDRBG)) return new $568bccf839e3e718$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $8u6BG.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $8u6BG.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $8u6BG.toArray(options.pers, options.persEnc || 'hex');
    $j0nF4(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $568bccf839e3e718$var$HmacDRBG;
$568bccf839e3e718$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$568bccf839e3e718$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $jJL0E.hmac(this.hash, this.K);
};
$568bccf839e3e718$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$568bccf839e3e718$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $8u6BG.toArray(entropy, entropyEnc);
    add = $8u6BG.toArray(add, addEnc);
    $j0nF4(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$568bccf839e3e718$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $8u6BG.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $8u6BG.encode(res, enc);
};

});

parcelRegister("lpyI3", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $g6Gr9 = parcelRequire("g6Gr9");
var $f966db59c7bf26f9$var$assert = $g6Gr9.assert;
function $f966db59c7bf26f9$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $f966db59c7bf26f9$var$KeyPair;
$f966db59c7bf26f9$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $f966db59c7bf26f9$var$KeyPair) return pub;
    return new $f966db59c7bf26f9$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$f966db59c7bf26f9$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $f966db59c7bf26f9$var$KeyPair) return priv;
    return new $f966db59c7bf26f9$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$f966db59c7bf26f9$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$f966db59c7bf26f9$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$f966db59c7bf26f9$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$f966db59c7bf26f9$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $iTE0Q(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$f966db59c7bf26f9$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $f966db59c7bf26f9$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $f966db59c7bf26f9$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$f966db59c7bf26f9$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $f966db59c7bf26f9$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$f966db59c7bf26f9$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$f966db59c7bf26f9$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$f966db59c7bf26f9$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("kNfV3", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $g6Gr9 = parcelRequire("g6Gr9");
var $f234bb804eb1f454$var$assert = $g6Gr9.assert;
function $f234bb804eb1f454$var$Signature(options, enc) {
    if (options instanceof $f234bb804eb1f454$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f234bb804eb1f454$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $iTE0Q(options.r, 16);
    this.s = new $iTE0Q(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f234bb804eb1f454$var$Signature;
function $f234bb804eb1f454$var$Position() {
    this.place = 0;
}
function $f234bb804eb1f454$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f234bb804eb1f454$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f234bb804eb1f454$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $g6Gr9.toArray(data, enc);
    var p = new $f234bb804eb1f454$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f234bb804eb1f454$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f234bb804eb1f454$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f234bb804eb1f454$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $iTE0Q(r);
    this.s = new $iTE0Q(s);
    this.recoveryParam = null;
    return true;
};
function $f234bb804eb1f454$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f234bb804eb1f454$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f234bb804eb1f454$var$rmPadding(r);
    s = $f234bb804eb1f454$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f234bb804eb1f454$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f234bb804eb1f454$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f234bb804eb1f454$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $g6Gr9.encode(res, enc);
};

});


parcelRegister("hSN2q", function(module, exports) {
'use strict';

var $jJL0E = parcelRequire("jJL0E");

var $7S8eE = parcelRequire("7S8eE");

var $g6Gr9 = parcelRequire("g6Gr9");
var $d04d84c99de5ff07$var$assert = $g6Gr9.assert;
var $d04d84c99de5ff07$var$parseBytes = $g6Gr9.parseBytes;

var $RBV86 = parcelRequire("RBV86");

var $jwtA5 = parcelRequire("jwtA5");
function $d04d84c99de5ff07$var$EDDSA(curve) {
    $d04d84c99de5ff07$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $d04d84c99de5ff07$var$EDDSA)) return new $d04d84c99de5ff07$var$EDDSA(curve);
    curve = $7S8eE[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $jJL0E.sha512;
}
module.exports = $d04d84c99de5ff07$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $d04d84c99de5ff07$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $d04d84c99de5ff07$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $d04d84c99de5ff07$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $d04d84c99de5ff07$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$d04d84c99de5ff07$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $g6Gr9.intFromLE(hash.digest()).umod(this.curve.n);
};
$d04d84c99de5ff07$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $RBV86.fromPublic(this, pub);
};
$d04d84c99de5ff07$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $RBV86.fromSecret(this, secret);
};
$d04d84c99de5ff07$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $jwtA5) return sig;
    return new $jwtA5(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $d04d84c99de5ff07$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$d04d84c99de5ff07$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $g6Gr9.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $g6Gr9.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$d04d84c99de5ff07$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$d04d84c99de5ff07$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $g6Gr9.intFromLE(bytes);
};
$d04d84c99de5ff07$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("RBV86", function(module, exports) {
'use strict';

var $g6Gr9 = parcelRequire("g6Gr9");
var $0a125d9022bd9cb1$var$assert = $g6Gr9.assert;
var $0a125d9022bd9cb1$var$parseBytes = $g6Gr9.parseBytes;
var $0a125d9022bd9cb1$var$cachedProperty = $g6Gr9.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $0a125d9022bd9cb1$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $0a125d9022bd9cb1$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $0a125d9022bd9cb1$var$parseBytes(params.pub);
}
$0a125d9022bd9cb1$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $0a125d9022bd9cb1$var$KeyPair) return pub;
    return new $0a125d9022bd9cb1$var$KeyPair(eddsa, {
        pub: pub
    });
};
$0a125d9022bd9cb1$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $0a125d9022bd9cb1$var$KeyPair) return secret;
    return new $0a125d9022bd9cb1$var$KeyPair(eddsa, {
        secret: secret
    });
};
$0a125d9022bd9cb1$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$0a125d9022bd9cb1$var$cachedProperty($0a125d9022bd9cb1$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$0a125d9022bd9cb1$var$KeyPair.prototype.sign = function sign(message) {
    $0a125d9022bd9cb1$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$0a125d9022bd9cb1$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$0a125d9022bd9cb1$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $0a125d9022bd9cb1$var$assert(this._secret, 'KeyPair is public only');
    return $g6Gr9.encode(this.secret(), enc);
};
$0a125d9022bd9cb1$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $g6Gr9.encode(this.pubBytes(), enc);
};
module.exports = $0a125d9022bd9cb1$var$KeyPair;

});

parcelRegister("jwtA5", function(module, exports) {
'use strict';

var $iTE0Q = parcelRequire("iTE0Q");

var $g6Gr9 = parcelRequire("g6Gr9");
var $e367f3ab6fe91477$var$assert = $g6Gr9.assert;
var $e367f3ab6fe91477$var$cachedProperty = $g6Gr9.cachedProperty;
var $e367f3ab6fe91477$var$parseBytes = $g6Gr9.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $e367f3ab6fe91477$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $e367f3ab6fe91477$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $e367f3ab6fe91477$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $e367f3ab6fe91477$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $iTE0Q) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$e367f3ab6fe91477$var$cachedProperty($e367f3ab6fe91477$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$e367f3ab6fe91477$var$cachedProperty($e367f3ab6fe91477$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$e367f3ab6fe91477$var$cachedProperty($e367f3ab6fe91477$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$e367f3ab6fe91477$var$cachedProperty($e367f3ab6fe91477$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$e367f3ab6fe91477$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$e367f3ab6fe91477$var$Signature.prototype.toHex = function toHex() {
    return $g6Gr9.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $e367f3ab6fe91477$var$Signature;

});



parcelRegister("4hSXR", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("dluwd")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("38Wbi", function(module, exports) {
'use strict';

var $39Lmy = parcelRequire("39Lmy");

var $2YQXK = parcelRequire("2YQXK");

var $cLfOB = parcelRequire("cLfOB");

var $AyKOg = parcelRequire("AyKOg");

var $9ztwK = parcelRequire("9ztwK");
var $249f40091722fc2d$require$pbkdf2Sync = $9ztwK.pbkdf2Sync;

var $btvME = parcelRequire("btvME");
var $249f40091722fc2d$require$Buffer = $btvME.Buffer;
function $249f40091722fc2d$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $2YQXK[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $249f40091722fc2d$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $AyKOg.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $249f40091722fc2d$require$Buffer.concat(out);
}
function $249f40091722fc2d$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$249f40091722fc2d$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $249f40091722fc2d$require$Buffer.from(buffer);
    var stripped = $cLfOB(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $39Lmy.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $39Lmy.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $39Lmy.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $39Lmy.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $39Lmy.EncryptedPrivateKey.decode(data, 'der');
            data = $249f40091722fc2d$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $39Lmy.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $39Lmy.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $39Lmy.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $39Lmy.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $39Lmy.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $39Lmy.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $39Lmy.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $39Lmy.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$249f40091722fc2d$var$parseKeys.signature = $39Lmy.signature;
module.exports = $249f40091722fc2d$var$parseKeys;

});
parcelRegister("39Lmy", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $24c6f3a1478b1f31$export$c98397a6eb8d0678; }, function (v) { return $24c6f3a1478b1f31$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $24c6f3a1478b1f31$export$f4aab6816f64fa6b; }, function (v) { return $24c6f3a1478b1f31$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $24c6f3a1478b1f31$export$4471f5c65d097c11; }, function (v) { return $24c6f3a1478b1f31$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $24c6f3a1478b1f31$export$ca8b6604d6ce14de; }, function (v) { return $24c6f3a1478b1f31$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $24c6f3a1478b1f31$export$8f54525b330fd87b; }, function (v) { return $24c6f3a1478b1f31$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $24c6f3a1478b1f31$export$23cd2842b44ca3e7; }, function (v) { return $24c6f3a1478b1f31$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $24c6f3a1478b1f31$export$245c9aaa9f5ce4ce; }, function (v) { return $24c6f3a1478b1f31$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $24c6f3a1478b1f31$export$8ad762e3e6399afe; }, function (v) { return $24c6f3a1478b1f31$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $24c6f3a1478b1f31$export$32ef6f92e22c6ab0; }, function (v) { return $24c6f3a1478b1f31$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $24c6f3a1478b1f31$export$c9cd164b539ebb63; }, function (v) { return $24c6f3a1478b1f31$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $24c6f3a1478b1f31$export$c98397a6eb8d0678;
var $24c6f3a1478b1f31$export$f4aab6816f64fa6b;
var $24c6f3a1478b1f31$export$4471f5c65d097c11;
var $24c6f3a1478b1f31$export$ca8b6604d6ce14de;
var $24c6f3a1478b1f31$export$8f54525b330fd87b;
var $24c6f3a1478b1f31$export$23cd2842b44ca3e7;
var $24c6f3a1478b1f31$export$245c9aaa9f5ce4ce;
var $24c6f3a1478b1f31$export$8ad762e3e6399afe;
var $24c6f3a1478b1f31$export$32ef6f92e22c6ab0;
var $24c6f3a1478b1f31$export$c9cd164b539ebb63;
'use strict';

var $7y1Ow = parcelRequire("7y1Ow");

$24c6f3a1478b1f31$export$c98397a6eb8d0678 = (parcelRequire("ghRS4"));
var $24c6f3a1478b1f31$var$RSAPrivateKey = $7y1Ow.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$24c6f3a1478b1f31$export$f4aab6816f64fa6b = $24c6f3a1478b1f31$var$RSAPrivateKey;
var $24c6f3a1478b1f31$var$RSAPublicKey = $7y1Ow.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$24c6f3a1478b1f31$export$4471f5c65d097c11 = $24c6f3a1478b1f31$var$RSAPublicKey;
var $24c6f3a1478b1f31$var$AlgorithmIdentifier = $7y1Ow.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $24c6f3a1478b1f31$var$PublicKey = $7y1Ow.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($24c6f3a1478b1f31$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$24c6f3a1478b1f31$export$ca8b6604d6ce14de = $24c6f3a1478b1f31$var$PublicKey;
var $24c6f3a1478b1f31$var$PrivateKeyInfo = $7y1Ow.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($24c6f3a1478b1f31$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$24c6f3a1478b1f31$export$8f54525b330fd87b = $24c6f3a1478b1f31$var$PrivateKeyInfo;
var $24c6f3a1478b1f31$var$EncryptedPrivateKeyInfo = $7y1Ow.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$24c6f3a1478b1f31$export$23cd2842b44ca3e7 = $24c6f3a1478b1f31$var$EncryptedPrivateKeyInfo;
var $24c6f3a1478b1f31$var$DSAPrivateKey = $7y1Ow.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$24c6f3a1478b1f31$export$245c9aaa9f5ce4ce = $24c6f3a1478b1f31$var$DSAPrivateKey;
$24c6f3a1478b1f31$export$8ad762e3e6399afe = $7y1Ow.define('DSAparam', function() {
    this['int']();
});
var $24c6f3a1478b1f31$var$ECParameters = $7y1Ow.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $24c6f3a1478b1f31$var$ECPrivateKey = $7y1Ow.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($24c6f3a1478b1f31$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$24c6f3a1478b1f31$export$32ef6f92e22c6ab0 = $24c6f3a1478b1f31$var$ECPrivateKey;
$24c6f3a1478b1f31$export$c9cd164b539ebb63 = $7y1Ow.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("7y1Ow", function(module, exports) {
var $57ed1d8f44ea7708$var$asn1 = module.exports;

$57ed1d8f44ea7708$var$asn1.bignum = (parcelRequire("iTE0Q"));

$57ed1d8f44ea7708$var$asn1.define = (parcelRequire("g1pp4")).define;

$57ed1d8f44ea7708$var$asn1.base = (parcelRequire("a6O9e"));

$57ed1d8f44ea7708$var$asn1.constants = (parcelRequire("fiKfX"));

$57ed1d8f44ea7708$var$asn1.decoders = (parcelRequire("aSK3S"));

$57ed1d8f44ea7708$var$asn1.encoders = (parcelRequire("432o4"));

});
parcelRegister("g1pp4", function(module, exports) {

var $7y1Ow = parcelRequire("7y1Ow");

var $h7THt = parcelRequire("h7THt");
var $baa071e419ff6967$var$api = module.exports;
$baa071e419ff6967$var$api.define = function define(name, body) {
    return new $baa071e419ff6967$var$Entity(name, body);
};
function $baa071e419ff6967$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$baa071e419ff6967$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("2U1Sj")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $h7THt(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$baa071e419ff6967$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($7y1Ow.decoders[enc]);
    return this.decoders[enc];
};
$baa071e419ff6967$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$baa071e419ff6967$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($7y1Ow.encoders[enc]);
    return this.encoders[enc];
};
$baa071e419ff6967$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("2U1Sj", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("a6O9e", function(module, exports) {
var $75c15d3cdb01a717$var$base = module.exports;

$75c15d3cdb01a717$var$base.Reporter = (parcelRequire("019Bx")).Reporter;

$75c15d3cdb01a717$var$base.DecoderBuffer = (parcelRequire("gMhOI")).DecoderBuffer;

$75c15d3cdb01a717$var$base.EncoderBuffer = (parcelRequire("gMhOI")).EncoderBuffer;

$75c15d3cdb01a717$var$base.Node = (parcelRequire("8JgSV"));

});
parcelRegister("019Bx", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $00378b560c9e99a1$export$957313a2f485e5ed; }, function (v) { return $00378b560c9e99a1$export$957313a2f485e5ed = v; });
var $00378b560c9e99a1$export$957313a2f485e5ed;

var $h7THt = parcelRequire("h7THt");
function $00378b560c9e99a1$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$00378b560c9e99a1$export$957313a2f485e5ed = $00378b560c9e99a1$var$Reporter;
$00378b560c9e99a1$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $00378b560c9e99a1$var$ReporterError;
};
$00378b560c9e99a1$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$00378b560c9e99a1$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$00378b560c9e99a1$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$00378b560c9e99a1$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$00378b560c9e99a1$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$00378b560c9e99a1$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$00378b560c9e99a1$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$00378b560c9e99a1$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$00378b560c9e99a1$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $00378b560c9e99a1$var$ReporterError;
    if (inherited) err = msg;
    else err = new $00378b560c9e99a1$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$00378b560c9e99a1$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $00378b560c9e99a1$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$h7THt($00378b560c9e99a1$var$ReporterError, Error);
$00378b560c9e99a1$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $00378b560c9e99a1$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("gMhOI", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $c36ef31a6a74f064$export$bf9f79cdc4a49163; }, function (v) { return $c36ef31a6a74f064$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $c36ef31a6a74f064$export$8ff24f7760c7a78e; }, function (v) { return $c36ef31a6a74f064$export$8ff24f7760c7a78e = v; });
var $c36ef31a6a74f064$export$bf9f79cdc4a49163;
var $c36ef31a6a74f064$export$8ff24f7760c7a78e;

var $h7THt = parcelRequire("h7THt");

var $a6O9e = parcelRequire("a6O9e");
var $c36ef31a6a74f064$require$Reporter = $a6O9e.Reporter;

var $38gB7 = parcelRequire("38gB7");
var $c36ef31a6a74f064$require$Buffer = $38gB7.Buffer;
function $c36ef31a6a74f064$var$DecoderBuffer(base, options) {
    $c36ef31a6a74f064$require$Reporter.call(this, options);
    if (!$c36ef31a6a74f064$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$h7THt($c36ef31a6a74f064$var$DecoderBuffer, $c36ef31a6a74f064$require$Reporter);
$c36ef31a6a74f064$export$bf9f79cdc4a49163 = $c36ef31a6a74f064$var$DecoderBuffer;
$c36ef31a6a74f064$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $c36ef31a6a74f064$require$Reporter.prototype.save.call(this)
    };
};
$c36ef31a6a74f064$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $c36ef31a6a74f064$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $c36ef31a6a74f064$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$c36ef31a6a74f064$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$c36ef31a6a74f064$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$c36ef31a6a74f064$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $c36ef31a6a74f064$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$c36ef31a6a74f064$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $c36ef31a6a74f064$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $c36ef31a6a74f064$var$EncoderBuffer)) item = new $c36ef31a6a74f064$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $c36ef31a6a74f064$require$Buffer.byteLength(value);
    } else if ($c36ef31a6a74f064$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$c36ef31a6a74f064$export$8ff24f7760c7a78e = $c36ef31a6a74f064$var$EncoderBuffer;
$c36ef31a6a74f064$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $c36ef31a6a74f064$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($c36ef31a6a74f064$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("8JgSV", function(module, exports) {

var $a6O9e = parcelRequire("a6O9e");
var $65af9faa07f6297b$require$Reporter = $a6O9e.Reporter;

var $a6O9e = parcelRequire("a6O9e");
var $65af9faa07f6297b$require$EncoderBuffer = $a6O9e.EncoderBuffer;

var $a6O9e = parcelRequire("a6O9e");
var $65af9faa07f6297b$require$DecoderBuffer = $a6O9e.DecoderBuffer;

var $j0nF4 = parcelRequire("j0nF4");
// Supported tags
var $65af9faa07f6297b$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $65af9faa07f6297b$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($65af9faa07f6297b$var$tags);
// Overrided methods list
var $65af9faa07f6297b$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $65af9faa07f6297b$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $65af9faa07f6297b$var$Node;
var $65af9faa07f6297b$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$65af9faa07f6297b$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $65af9faa07f6297b$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$65af9faa07f6297b$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $65af9faa07f6297b$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$65af9faa07f6297b$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $j0nF4(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $j0nF4.equal(state.children.length, 1, 'Root node can have only one child');
};
$65af9faa07f6297b$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $j0nF4(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $j0nF4(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$65af9faa07f6297b$var$overrided.forEach(function(method) {
    $65af9faa07f6297b$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$65af9faa07f6297b$var$tags.forEach(function(tag) {
    $65af9faa07f6297b$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $j0nF4(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$65af9faa07f6297b$var$Node.prototype.use = function use(item) {
    $j0nF4(item);
    var state = this._baseState;
    $j0nF4(state.use === null);
    state.use = item;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $j0nF4(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $j0nF4(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $j0nF4(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$65af9faa07f6297b$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $j0nF4(state.key === null);
    state.key = newKey;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$65af9faa07f6297b$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $j0nF4(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$65af9faa07f6297b$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $j0nF4(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$65af9faa07f6297b$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $65af9faa07f6297b$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$65af9faa07f6297b$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$65af9faa07f6297b$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $j0nF4(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$65af9faa07f6297b$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$65af9faa07f6297b$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $65af9faa07f6297b$require$EncoderBuffer(data, this.reporter);
};
$65af9faa07f6297b$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$65af9faa07f6297b$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $65af9faa07f6297b$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$65af9faa07f6297b$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $j0nF4(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$65af9faa07f6297b$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$65af9faa07f6297b$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$65af9faa07f6297b$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("fiKfX", function(module, exports) {
var $b23c6b0485c209d1$var$constants = module.exports;
// Helper
$b23c6b0485c209d1$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$b23c6b0485c209d1$var$constants.der = (parcelRequire("9gcqi"));

});
parcelRegister("9gcqi", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $6bdf3eadc0e9c7c3$export$3584c46ed60baee8; }, function (v) { return $6bdf3eadc0e9c7c3$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $6bdf3eadc0e9c7c3$export$f18596ef8d632e49; }, function (v) { return $6bdf3eadc0e9c7c3$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $6bdf3eadc0e9c7c3$export$2b067c6666111485; }, function (v) { return $6bdf3eadc0e9c7c3$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $6bdf3eadc0e9c7c3$export$f17df38a421ab9e3; }, function (v) { return $6bdf3eadc0e9c7c3$export$f17df38a421ab9e3 = v; });
var $6bdf3eadc0e9c7c3$export$3584c46ed60baee8;
var $6bdf3eadc0e9c7c3$export$f18596ef8d632e49;
var $6bdf3eadc0e9c7c3$export$2b067c6666111485;
var $6bdf3eadc0e9c7c3$export$f17df38a421ab9e3;

var $fiKfX = parcelRequire("fiKfX");
$6bdf3eadc0e9c7c3$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$6bdf3eadc0e9c7c3$export$f18596ef8d632e49 = $fiKfX._reverse($6bdf3eadc0e9c7c3$export$3584c46ed60baee8);
$6bdf3eadc0e9c7c3$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$6bdf3eadc0e9c7c3$export$f17df38a421ab9e3 = $fiKfX._reverse($6bdf3eadc0e9c7c3$export$2b067c6666111485);

});


parcelRegister("aSK3S", function(module, exports) {
var $7ec2ad6782c9fe97$var$decoders = module.exports;

$7ec2ad6782c9fe97$var$decoders.der = (parcelRequire("5b1Il"));

$7ec2ad6782c9fe97$var$decoders.pem = (parcelRequire("ibcgj"));

});
parcelRegister("5b1Il", function(module, exports) {

var $h7THt = parcelRequire("h7THt");

var $7y1Ow = parcelRequire("7y1Ow");
var $3c4f4f4384fc1609$var$base = $7y1Ow.base;
var $3c4f4f4384fc1609$var$bignum = $7y1Ow.bignum;
// Import DER constants
var $3c4f4f4384fc1609$var$der = $7y1Ow.constants.der;
function $3c4f4f4384fc1609$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $3c4f4f4384fc1609$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $3c4f4f4384fc1609$var$DERDecoder;
$3c4f4f4384fc1609$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $3c4f4f4384fc1609$var$base.DecoderBuffer)) data = new $3c4f4f4384fc1609$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $3c4f4f4384fc1609$var$DERNode(parent) {
    $3c4f4f4384fc1609$var$base.Node.call(this, 'der', parent);
}
$h7THt($3c4f4f4384fc1609$var$DERNode, $3c4f4f4384fc1609$var$base.Node);
$3c4f4f4384fc1609$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $3c4f4f4384fc1609$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $3c4f4f4384fc1609$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $3c4f4f4384fc1609$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$3c4f4f4384fc1609$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $3c4f4f4384fc1609$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $3c4f4f4384fc1609$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$3c4f4f4384fc1609$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $3c4f4f4384fc1609$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$3c4f4f4384fc1609$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $3c4f4f4384fc1609$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $3c4f4f4384fc1609$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $3c4f4f4384fc1609$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $3c4f4f4384fc1609$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("ibcgj", function(module, exports) {

var $h7THt = parcelRequire("h7THt");

var $38gB7 = parcelRequire("38gB7");
var $d3c2c417e4eca36f$require$Buffer = $38gB7.Buffer;

var $5b1Il = parcelRequire("5b1Il");
function $d3c2c417e4eca36f$var$PEMDecoder(entity) {
    $5b1Il.call(this, entity);
    this.enc = 'pem';
}
$h7THt($d3c2c417e4eca36f$var$PEMDecoder, $5b1Il);
module.exports = $d3c2c417e4eca36f$var$PEMDecoder;
$d3c2c417e4eca36f$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $d3c2c417e4eca36f$require$Buffer(base64, 'base64');
    return $5b1Il.prototype.decode.call(this, input, options);
};

});


parcelRegister("432o4", function(module, exports) {
var $2f294b4956886ee0$var$encoders = module.exports;

$2f294b4956886ee0$var$encoders.der = (parcelRequire("arGXM"));

$2f294b4956886ee0$var$encoders.pem = (parcelRequire("jFZ6B"));

});
parcelRegister("arGXM", function(module, exports) {

var $h7THt = parcelRequire("h7THt");

var $38gB7 = parcelRequire("38gB7");
var $79adc099251291f0$require$Buffer = $38gB7.Buffer;

var $7y1Ow = parcelRequire("7y1Ow");
var $79adc099251291f0$var$base = $7y1Ow.base;
// Import DER constants
var $79adc099251291f0$var$der = $7y1Ow.constants.der;
function $79adc099251291f0$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $79adc099251291f0$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $79adc099251291f0$var$DEREncoder;
$79adc099251291f0$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $79adc099251291f0$var$DERNode(parent) {
    $79adc099251291f0$var$base.Node.call(this, 'der', parent);
}
$h7THt($79adc099251291f0$var$DERNode, $79adc099251291f0$var$base.Node);
$79adc099251291f0$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $79adc099251291f0$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $79adc099251291f0$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $79adc099251291f0$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$79adc099251291f0$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $79adc099251291f0$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$79adc099251291f0$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $79adc099251291f0$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $79adc099251291f0$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$79adc099251291f0$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $79adc099251291f0$var$two(date.getFullYear()),
        $79adc099251291f0$var$two(date.getUTCMonth() + 1),
        $79adc099251291f0$var$two(date.getUTCDate()),
        $79adc099251291f0$var$two(date.getUTCHours()),
        $79adc099251291f0$var$two(date.getUTCMinutes()),
        $79adc099251291f0$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $79adc099251291f0$var$two(date.getFullYear() % 100),
        $79adc099251291f0$var$two(date.getUTCMonth() + 1),
        $79adc099251291f0$var$two(date.getUTCDate()),
        $79adc099251291f0$var$two(date.getUTCHours()),
        $79adc099251291f0$var$two(date.getUTCMinutes()),
        $79adc099251291f0$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$79adc099251291f0$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$79adc099251291f0$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$79adc099251291f0$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $79adc099251291f0$require$Buffer(numArray);
    }
    if ($79adc099251291f0$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $79adc099251291f0$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $79adc099251291f0$require$Buffer(out));
};
$79adc099251291f0$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$79adc099251291f0$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$79adc099251291f0$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $79adc099251291f0$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($79adc099251291f0$var$der.tagByName.hasOwnProperty(tag)) res = $79adc099251291f0$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $79adc099251291f0$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("jFZ6B", function(module, exports) {

var $h7THt = parcelRequire("h7THt");

var $arGXM = parcelRequire("arGXM");
function $e5313ee9e6a26929$var$PEMEncoder(entity) {
    $arGXM.call(this, entity);
    this.enc = 'pem';
}
$h7THt($e5313ee9e6a26929$var$PEMEncoder, $arGXM);
module.exports = $e5313ee9e6a26929$var$PEMEncoder;
$e5313ee9e6a26929$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $arGXM.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("ghRS4", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $7y1Ow = parcelRequire("7y1Ow");
var $bdb8058a78018b44$var$Time = $7y1Ow.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $bdb8058a78018b44$var$AttributeTypeValue = $7y1Ow.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $bdb8058a78018b44$var$AlgorithmIdentifier = $7y1Ow.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $bdb8058a78018b44$var$SubjectPublicKeyInfo = $7y1Ow.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($bdb8058a78018b44$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $bdb8058a78018b44$var$RelativeDistinguishedName = $7y1Ow.define('RelativeDistinguishedName', function() {
    this.setof($bdb8058a78018b44$var$AttributeTypeValue);
});
var $bdb8058a78018b44$var$RDNSequence = $7y1Ow.define('RDNSequence', function() {
    this.seqof($bdb8058a78018b44$var$RelativeDistinguishedName);
});
var $bdb8058a78018b44$var$Name = $7y1Ow.define('Name', function() {
    this.choice({
        rdnSequence: this.use($bdb8058a78018b44$var$RDNSequence)
    });
});
var $bdb8058a78018b44$var$Validity = $7y1Ow.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($bdb8058a78018b44$var$Time), this.key('notAfter').use($bdb8058a78018b44$var$Time));
});
var $bdb8058a78018b44$var$Extension = $7y1Ow.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $bdb8058a78018b44$var$TBSCertificate = $7y1Ow.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($bdb8058a78018b44$var$AlgorithmIdentifier), this.key('issuer').use($bdb8058a78018b44$var$Name), this.key('validity').use($bdb8058a78018b44$var$Validity), this.key('subject').use($bdb8058a78018b44$var$Name), this.key('subjectPublicKeyInfo').use($bdb8058a78018b44$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($bdb8058a78018b44$var$Extension).optional());
});
var $bdb8058a78018b44$var$X509Certificate = $7y1Ow.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($bdb8058a78018b44$var$TBSCertificate), this.key('signatureAlgorithm').use($bdb8058a78018b44$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $bdb8058a78018b44$var$X509Certificate;

});


parcelRegister("2YQXK", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("cLfOB", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $94a62466da08a873$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $94a62466da08a873$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $94a62466da08a873$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $46t1V = parcelRequire("46t1V");

var $AyKOg = parcelRequire("AyKOg");

var $btvME = parcelRequire("btvME");
var $94a62466da08a873$require$Buffer = $btvME.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($94a62466da08a873$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($94a62466da08a873$var$fullRegex);
        decrypted = $94a62466da08a873$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $94a62466da08a873$require$Buffer.from(match[2], 'hex');
        var cipherText = $94a62466da08a873$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $46t1V(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $AyKOg.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $94a62466da08a873$require$Buffer.concat(out);
    }
    var tag = key.match($94a62466da08a873$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("85inq", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("lDYLS", function(module, exports) {
'use strict';

var $btvME = parcelRequire("btvME");
var $fc1c6163f4e34198$require$Buffer = $btvME.Buffer;

var $4hSXR = parcelRequire("4hSXR");

var $47TpL = parcelRequire("47TpL");
var $fc1c6163f4e34198$require$EC = $47TpL.ec;

var $38Wbi = parcelRequire("38Wbi");

var $85inq = parcelRequire("85inq");
function $fc1c6163f4e34198$var$verify(sig, hash, key, signType, tag) {
    var pub = $38Wbi(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $fc1c6163f4e34198$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $fc1c6163f4e34198$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $fc1c6163f4e34198$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $fc1c6163f4e34198$require$Buffer.from(pad);
    var red = $4hSXR.mont(pub.modulus);
    sig = new $4hSXR(sig).toRed(red);
    sig = sig.redPow(new $4hSXR(pub.publicExponent));
    sig = $fc1c6163f4e34198$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $fc1c6163f4e34198$var$ecVerify(sig, hash, pub) {
    var curveId = $85inq[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $fc1c6163f4e34198$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $fc1c6163f4e34198$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $38Wbi.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $fc1c6163f4e34198$var$checkValue(s, q);
    $fc1c6163f4e34198$var$checkValue(r, q);
    var montp = $4hSXR.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $4hSXR(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $fc1c6163f4e34198$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $fc1c6163f4e34198$var$verify;

});


parcelRegister("8JN1X", function(module, exports) {

var $38gB7 = parcelRequire("38gB7");
var $65c88f2bc19b1bb8$require$Buffer = $38gB7.Buffer;

var $47TpL = parcelRequire("47TpL");

var $iTE0Q = parcelRequire("iTE0Q");
module.exports = function createECDH(curve) {
    return new $65c88f2bc19b1bb8$var$ECDH(curve);
};
var $65c88f2bc19b1bb8$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$65c88f2bc19b1bb8$var$aliases.p224 = $65c88f2bc19b1bb8$var$aliases.secp224r1;
$65c88f2bc19b1bb8$var$aliases.p256 = $65c88f2bc19b1bb8$var$aliases.secp256r1 = $65c88f2bc19b1bb8$var$aliases.prime256v1;
$65c88f2bc19b1bb8$var$aliases.p192 = $65c88f2bc19b1bb8$var$aliases.secp192r1 = $65c88f2bc19b1bb8$var$aliases.prime192v1;
$65c88f2bc19b1bb8$var$aliases.p384 = $65c88f2bc19b1bb8$var$aliases.secp384r1;
$65c88f2bc19b1bb8$var$aliases.p521 = $65c88f2bc19b1bb8$var$aliases.secp521r1;
function $65c88f2bc19b1bb8$var$ECDH(curve) {
    this.curveType = $65c88f2bc19b1bb8$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $47TpL.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$65c88f2bc19b1bb8$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$65c88f2bc19b1bb8$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$65c88f2bc19b1bb8$require$Buffer.isBuffer(other)) other = new $65c88f2bc19b1bb8$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $65c88f2bc19b1bb8$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$65c88f2bc19b1bb8$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $65c88f2bc19b1bb8$var$formatReturnValue(key, enc);
};
$65c88f2bc19b1bb8$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $65c88f2bc19b1bb8$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$65c88f2bc19b1bb8$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$65c88f2bc19b1bb8$require$Buffer.isBuffer(pub)) pub = new $65c88f2bc19b1bb8$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$65c88f2bc19b1bb8$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$65c88f2bc19b1bb8$require$Buffer.isBuffer(priv)) priv = new $65c88f2bc19b1bb8$require$Buffer(priv, enc);
    var _priv = new $iTE0Q(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $65c88f2bc19b1bb8$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $65c88f2bc19b1bb8$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $65c88f2bc19b1bb8$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $65c88f2bc19b1bb8$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("2edFl", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $19f77d510096434f$export$512823e338ddb1b7; }, function (v) { return $19f77d510096434f$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $19f77d510096434f$export$7efb24e2fddf99b9; }, function (v) { return $19f77d510096434f$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $19f77d510096434f$export$9d0e0c0c4a8d30f3; }, function (v) { return $19f77d510096434f$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $19f77d510096434f$export$b9d55ff329113abd; }, function (v) { return $19f77d510096434f$export$b9d55ff329113abd = v; });
var $19f77d510096434f$export$512823e338ddb1b7;
var $19f77d510096434f$export$7efb24e2fddf99b9;
var $19f77d510096434f$export$9d0e0c0c4a8d30f3;
var $19f77d510096434f$export$b9d55ff329113abd;

$19f77d510096434f$export$512823e338ddb1b7 = (parcelRequire("ih9lr"));

$19f77d510096434f$export$7efb24e2fddf99b9 = (parcelRequire("b2lHs"));
$19f77d510096434f$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $19f77d510096434f$export$512823e338ddb1b7(key, buf, true);
};
$19f77d510096434f$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $19f77d510096434f$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("ih9lr", function(module, exports) {

var $38Wbi = parcelRequire("38Wbi");

var $gYWQI = parcelRequire("gYWQI");

var $jIYxV = parcelRequire("jIYxV");

var $eUamw = parcelRequire("eUamw");

var $fNVsO = parcelRequire("fNVsO");

var $iTE0Q = parcelRequire("iTE0Q");

var $fZL8p = parcelRequire("fZL8p");

var $lAauW = parcelRequire("lAauW");

var $btvME = parcelRequire("btvME");
var $d4e1103d2f622ace$require$Buffer = $btvME.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $38Wbi(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $d4e1103d2f622ace$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $d4e1103d2f622ace$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $iTE0Q(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $lAauW(paddedMsg, key);
    else return $fZL8p(paddedMsg, key);
};
function $d4e1103d2f622ace$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $jIYxV('sha1').update($d4e1103d2f622ace$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $d4e1103d2f622ace$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $gYWQI(hLen);
    var maskedDb = $fNVsO($d4e1103d2f622ace$require$Buffer.concat([
        iHash,
        ps,
        $d4e1103d2f622ace$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $eUamw(seed, dblen));
    var maskedSeed = $fNVsO(seed, $eUamw(maskedDb, hLen));
    return new $iTE0Q($d4e1103d2f622ace$require$Buffer.concat([
        $d4e1103d2f622ace$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $d4e1103d2f622ace$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $d4e1103d2f622ace$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $d4e1103d2f622ace$var$nonZero(k - mLen - 3);
    return new $iTE0Q($d4e1103d2f622ace$require$Buffer.concat([
        $d4e1103d2f622ace$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $d4e1103d2f622ace$require$Buffer.alloc(1),
        msg
    ], k));
}
function $d4e1103d2f622ace$var$nonZero(len) {
    var out = $d4e1103d2f622ace$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $gYWQI(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $gYWQI(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("eUamw", function(module, exports) {

var $jIYxV = parcelRequire("jIYxV");

var $btvME = parcelRequire("btvME");
var $ad9e556416fd2ab5$require$Buffer = $btvME.Buffer;
module.exports = function(seed, len) {
    var t = $ad9e556416fd2ab5$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $ad9e556416fd2ab5$var$i2ops(i++);
        t = $ad9e556416fd2ab5$require$Buffer.concat([
            t,
            $jIYxV('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $ad9e556416fd2ab5$var$i2ops(c) {
    var out = $ad9e556416fd2ab5$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("fNVsO", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("fZL8p", function(module, exports) {

var $iTE0Q = parcelRequire("iTE0Q");

var $btvME = parcelRequire("btvME");
var $ba511d7d35d6269d$require$Buffer = $btvME.Buffer;
function $ba511d7d35d6269d$var$withPublic(paddedMsg, key) {
    return $ba511d7d35d6269d$require$Buffer.from(paddedMsg.toRed($iTE0Q.mont(key.modulus)).redPow(new $iTE0Q(key.publicExponent)).fromRed().toArray());
}
module.exports = $ba511d7d35d6269d$var$withPublic;

});


parcelRegister("b2lHs", function(module, exports) {

var $38Wbi = parcelRequire("38Wbi");

var $eUamw = parcelRequire("eUamw");

var $fNVsO = parcelRequire("fNVsO");

var $iTE0Q = parcelRequire("iTE0Q");

var $lAauW = parcelRequire("lAauW");

var $jIYxV = parcelRequire("jIYxV");

var $fZL8p = parcelRequire("fZL8p");

var $btvME = parcelRequire("btvME");
var $8090b6bf5d59a552$require$Buffer = $btvME.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $38Wbi(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $iTE0Q(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $fZL8p(new $iTE0Q(enc), key);
    else msg = $lAauW(enc, key);
    var zBuffer = $8090b6bf5d59a552$require$Buffer.alloc(k - msg.length);
    msg = $8090b6bf5d59a552$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $8090b6bf5d59a552$var$oaep(key, msg);
    else if (padding === 1) return $8090b6bf5d59a552$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $8090b6bf5d59a552$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $jIYxV('sha1').update($8090b6bf5d59a552$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $fNVsO(maskedSeed, $eUamw(maskedDb, hLen));
    var db = $fNVsO(maskedDb, $eUamw(seed, k - hLen - 1));
    if ($8090b6bf5d59a552$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $8090b6bf5d59a552$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $8090b6bf5d59a552$var$compare(a, b) {
    a = $8090b6bf5d59a552$require$Buffer.from(a);
    b = $8090b6bf5d59a552$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("kdv2S", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $eb7d1a8400c3e383$export$bb1abf2ce84fc7e8; }, function (v) { return $eb7d1a8400c3e383$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $eb7d1a8400c3e383$export$2f7171e78e524d5e; }, function (v) { return $eb7d1a8400c3e383$export$2f7171e78e524d5e = v; });
var $eb7d1a8400c3e383$export$bb1abf2ce84fc7e8;
var $eb7d1a8400c3e383$export$2f7171e78e524d5e;

var $89WEd = parcelRequire("89WEd");
'use strict';
function $eb7d1a8400c3e383$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $btvME = parcelRequire("btvME");

var $gYWQI = parcelRequire("gYWQI");
var $eb7d1a8400c3e383$var$Buffer = $btvME.Buffer;
var $eb7d1a8400c3e383$var$kBufferMaxLength = $btvME.kMaxLength;
var $eb7d1a8400c3e383$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $eb7d1a8400c3e383$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $eb7d1a8400c3e383$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $eb7d1a8400c3e383$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $eb7d1a8400c3e383$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $eb7d1a8400c3e383$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $eb7d1a8400c3e383$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $eb7d1a8400c3e383$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($eb7d1a8400c3e383$var$crypto && $eb7d1a8400c3e383$var$crypto.getRandomValues || false) {
    $eb7d1a8400c3e383$export$bb1abf2ce84fc7e8 = $eb7d1a8400c3e383$var$randomFill;
    $eb7d1a8400c3e383$export$2f7171e78e524d5e = $eb7d1a8400c3e383$var$randomFillSync;
} else {
    $eb7d1a8400c3e383$export$bb1abf2ce84fc7e8 = $eb7d1a8400c3e383$var$oldBrowser;
    $eb7d1a8400c3e383$export$2f7171e78e524d5e = $eb7d1a8400c3e383$var$oldBrowser;
}
function $eb7d1a8400c3e383$var$randomFill(buf, offset, size, cb) {
    if (!$eb7d1a8400c3e383$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $eb7d1a8400c3e383$var$assertOffset(offset, buf.length);
    $eb7d1a8400c3e383$var$assertSize(size, offset, buf.length);
    return $eb7d1a8400c3e383$var$actualFill(buf, offset, size, cb);
}
function $eb7d1a8400c3e383$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $eb7d1a8400c3e383$var$crypto.getRandomValues(uint);
    if (cb) {
        $89WEd.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $gYWQI(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $gYWQI(size);
    bytes.copy(buf, offset);
    return buf;
}
function $eb7d1a8400c3e383$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$eb7d1a8400c3e383$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $eb7d1a8400c3e383$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $eb7d1a8400c3e383$var$assertSize(size, offset, buf.length);
    return $eb7d1a8400c3e383$var$actualFill(buf, offset, size);
}

});


parcelRegister("e9cdc", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("asSBv")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("hR5EF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cffbc5dccac27d21$export$2e2bcd8739ae039; });
function $cffbc5dccac27d21$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("lUMx8", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", function () { return $ff4479a450807ce5$export$fa981bbccf843781; }, function (v) { return $ff4479a450807ce5$export$fa981bbccf843781 = v; });
var $ff4479a450807ce5$export$fa981bbccf843781;
'use strict';
const $ff4479a450807ce5$var$char = function(a) {
    return String.fromCharCode(a);
};
const $ff4479a450807ce5$var$chars = {
    nilChar: $ff4479a450807ce5$var$char(176),
    missingChar: $ff4479a450807ce5$var$char(201),
    nilPremitive: $ff4479a450807ce5$var$char(175),
    missingPremitive: $ff4479a450807ce5$var$char(200),
    emptyChar: $ff4479a450807ce5$var$char(178),
    emptyValue: $ff4479a450807ce5$var$char(177),
    boundryChar: $ff4479a450807ce5$var$char(179),
    objStart: $ff4479a450807ce5$var$char(198),
    arrStart: $ff4479a450807ce5$var$char(204),
    arrayEnd: $ff4479a450807ce5$var$char(185)
};
const $ff4479a450807ce5$var$charsArr = [
    $ff4479a450807ce5$var$chars.nilChar,
    $ff4479a450807ce5$var$chars.nilPremitive,
    $ff4479a450807ce5$var$chars.missingChar,
    $ff4479a450807ce5$var$chars.missingPremitive,
    $ff4479a450807ce5$var$chars.boundryChar,
    $ff4479a450807ce5$var$chars.emptyChar,
    $ff4479a450807ce5$var$chars.emptyValue,
    $ff4479a450807ce5$var$chars.arrayEnd,
    $ff4479a450807ce5$var$chars.objStart,
    $ff4479a450807ce5$var$chars.arrStart
];
const $ff4479a450807ce5$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === 'string') {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $ff4479a450807ce5$var$getValue(node[0].val, e_schema);
        else return $ff4479a450807ce5$var$getValue(node, e_schema);
    } else {
        const hasValidData = $ff4479a450807ce5$var$hasData(node);
        if (hasValidData === true) {
            let str = '';
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $ff4479a450807ce5$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //const itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === 'string') for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $ff4479a450807ce5$var$getValue(node[arr_i].val, itemSchema);
                    str = $ff4479a450807ce5$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $ff4479a450807ce5$var$_e(node[arr_i], itemSchema, options);
                    str = $ff4479a450807ce5$var$processValue(str, r);
                }
                str += $ff4479a450807ce5$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $ff4479a450807ce5$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $ff4479a450807ce5$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $ff4479a450807ce5$var$_e(node.val, e_schema[key], options);
                    else r = $ff4479a450807ce5$var$_e(node.child[key], e_schema[key], options);
                    str = $ff4479a450807ce5$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $ff4479a450807ce5$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $ff4479a450807ce5$var$chars.missingPremitive;
        case null:
            return $ff4479a450807ce5$var$chars.nilPremitive;
        case '':
            return $ff4479a450807ce5$var$chars.emptyValue;
        default:
            return a;
    }
};
const $ff4479a450807ce5$var$processValue = function(str, r) {
    if (!$ff4479a450807ce5$var$isAppChar(r[0]) && !$ff4479a450807ce5$var$isAppChar(str[str.length - 1])) str += $ff4479a450807ce5$var$chars.boundryChar;
    return str + r;
};
const $ff4479a450807ce5$var$isAppChar = function(ch) {
    return $ff4479a450807ce5$var$charsArr.indexOf(ch) !== -1;
};
function $ff4479a450807ce5$var$hasData(jObj) {
    if (jObj === undefined) return $ff4479a450807ce5$var$chars.missingChar;
    else if (jObj === null) return $ff4479a450807ce5$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $ff4479a450807ce5$var$chars.emptyChar;
    else return true;
}

var $3WVUR = parcelRequire("3WVUR");

var $6OSnz = parcelRequire("6OSnz");
var $ff4479a450807ce5$require$buildOptions = $6OSnz.buildOptions;
const $ff4479a450807ce5$var$convert2nimn = function(node, e_schema, options) {
    options = $ff4479a450807ce5$require$buildOptions(options, $3WVUR.defaultOptions, $3WVUR.props);
    return $ff4479a450807ce5$var$_e(node, e_schema, options);
};
$ff4479a450807ce5$export$fa981bbccf843781 = $ff4479a450807ce5$var$convert2nimn;

});
parcelRegister("3WVUR", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", function () { return $2e03b6d40517b1aa$export$ba43bf67f3d48107; }, function (v) { return $2e03b6d40517b1aa$export$ba43bf67f3d48107 = v; });
$parcel$export(module.exports, "props", function () { return $2e03b6d40517b1aa$export$8128bb6492cf3de7; }, function (v) { return $2e03b6d40517b1aa$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "getTraversalObj", function () { return $2e03b6d40517b1aa$export$2ca3eb0a2f8a693a; }, function (v) { return $2e03b6d40517b1aa$export$2ca3eb0a2f8a693a = v; });
var $2e03b6d40517b1aa$export$ba43bf67f3d48107;
var $2e03b6d40517b1aa$export$8128bb6492cf3de7;
var $2e03b6d40517b1aa$export$2ca3eb0a2f8a693a;
'use strict';

var $6OSnz = parcelRequire("6OSnz");

var $6OSnz = parcelRequire("6OSnz");
var $2e03b6d40517b1aa$require$buildOptions = $6OSnz.buildOptions;

var $e6qaR = parcelRequire("e6qaR");

var $duWUg = parcelRequire("duWUg");
const $2e03b6d40517b1aa$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $6OSnz.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $2e03b6d40517b1aa$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    numParseOptions: {
        hex: true,
        leadingZeros: true
    },
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: [],
    alwaysCreateTextNode: false
};
$2e03b6d40517b1aa$export$ba43bf67f3d48107 = $2e03b6d40517b1aa$var$defaultOptions;
const $2e03b6d40517b1aa$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'ignoreNameSpace',
    'allowBooleanAttributes',
    'parseNodeValue',
    'parseAttributeValue',
    'arrayMode',
    'trimValues',
    'cdataTagName',
    'cdataPositionChar',
    'tagValueProcessor',
    'attrValueProcessor',
    'parseTrueNumberOnly',
    'numParseOptions',
    'stopNodes',
    'alwaysCreateTextNode'
];
$2e03b6d40517b1aa$export$8128bb6492cf3de7 = $2e03b6d40517b1aa$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $2e03b6d40517b1aa$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $2e03b6d40517b1aa$var$parseValue(val, options.parseNodeValue, options.numParseOptions);
    }
    return val;
}
function $2e03b6d40517b1aa$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $2e03b6d40517b1aa$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $duWUg(val, options);
    } else {
        if ($6OSnz.isExist(val)) return val;
        else return '';
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $2e03b6d40517b1aa$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function $2e03b6d40517b1aa$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === 'string') {
        attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $6OSnz.getAllMatches(attrStr, $2e03b6d40517b1aa$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $2e03b6d40517b1aa$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $2e03b6d40517b1aa$var$parseValue(matches[i][4], options.parseAttributeValue, options.numParseOptions);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $2e03b6d40517b1aa$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/\r\n?/g, "\n");
    options = $2e03b6d40517b1aa$require$buildOptions(options, $2e03b6d40517b1aa$var$defaultOptions, $2e03b6d40517b1aa$var$props);
    const xmlObj = new $e6qaR('!xml');
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            if (xmlData[i + 1] === '/') {
                const closeIndex = $2e03b6d40517b1aa$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $6OSnz.getValue(currentNode.val) + '' + $2e03b6d40517b1aa$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $2e03b6d40517b1aa$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') i = $2e03b6d40517b1aa$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === '!--') i = $2e03b6d40517b1aa$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === '!D') {
                const closeIndex = $2e03b6d40517b1aa$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $2e03b6d40517b1aa$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $6OSnz.getValue(currentNode.val) + '' + $2e03b6d40517b1aa$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $e6qaR(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $6OSnz.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || '') + (tagExp || '');
                i = closeIndex + 2;
            } else {
                const result = $2e03b6d40517b1aa$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                let shouldBuildAttributesMap = true;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) {
                        tagName = tagName.substr(colonIndex + 1);
                        shouldBuildAttributesMap = tagName !== result.data.substr(colonIndex + 1);
                    }
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') currentNode.val = $6OSnz.getValue(currentNode.val) + '' + $2e03b6d40517b1aa$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $e6qaR(tagName, currentNode, '');
                    if (tagName !== tagExp) childNode.attrsMap = $2e03b6d40517b1aa$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $e6qaR(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp && shouldBuildAttributesMap) childNode.attrsMap = $2e03b6d40517b1aa$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $2e03b6d40517b1aa$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === '>') return {
            data: tagExp,
            index: index
        };
        else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $2e03b6d40517b1aa$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$2e03b6d40517b1aa$export$2ca3eb0a2f8a693a = $2e03b6d40517b1aa$var$getTraversalObj;

});
parcelRegister("6OSnz", function(module, exports) {

$parcel$export(module.exports, "isExist", function () { return $4f7198262958b1df$export$a5edf3f35b6dd392; }, function (v) { return $4f7198262958b1df$export$a5edf3f35b6dd392 = v; });
$parcel$export(module.exports, "isEmptyObject", function () { return $4f7198262958b1df$export$83b788b1a3698c03; }, function (v) { return $4f7198262958b1df$export$83b788b1a3698c03 = v; });
$parcel$export(module.exports, "merge", function () { return $4f7198262958b1df$export$4950aa0f605343fb; }, function (v) { return $4f7198262958b1df$export$4950aa0f605343fb = v; });
$parcel$export(module.exports, "getValue", function () { return $4f7198262958b1df$export$bf7199a9ebcb84a9; }, function (v) { return $4f7198262958b1df$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "buildOptions", function () { return $4f7198262958b1df$export$ecbd7d678ac4909b; }, function (v) { return $4f7198262958b1df$export$ecbd7d678ac4909b = v; });
$parcel$export(module.exports, "isTagNameInArrayMode", function () { return $4f7198262958b1df$export$fd3b6180ca5b0284; }, function (v) { return $4f7198262958b1df$export$fd3b6180ca5b0284 = v; });
$parcel$export(module.exports, "isName", function () { return $4f7198262958b1df$export$998d7ff9801e90bb; }, function (v) { return $4f7198262958b1df$export$998d7ff9801e90bb = v; });
$parcel$export(module.exports, "getAllMatches", function () { return $4f7198262958b1df$export$aaa9734c55cb7a19; }, function (v) { return $4f7198262958b1df$export$aaa9734c55cb7a19 = v; });
$parcel$export(module.exports, "nameRegexp", function () { return $4f7198262958b1df$export$e8f2644f7085b4b1; }, function (v) { return $4f7198262958b1df$export$e8f2644f7085b4b1 = v; });
var $4f7198262958b1df$export$a5edf3f35b6dd392;
var $4f7198262958b1df$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $4f7198262958b1df$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $4f7198262958b1df$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $4f7198262958b1df$export$ecbd7d678ac4909b;
/**
 * Check if a tag name should be treated as array
 *
 * @param tagName the node tagname
 * @param arrayMode the array mode option
 * @param parentTagName the parent tag name
 * @returns {boolean} true if node should be parsed as array
 */ var $4f7198262958b1df$export$fd3b6180ca5b0284;
var $4f7198262958b1df$export$998d7ff9801e90bb;
var $4f7198262958b1df$export$aaa9734c55cb7a19;
var $4f7198262958b1df$export$e8f2644f7085b4b1;
'use strict';
const $4f7198262958b1df$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $4f7198262958b1df$var$nameChar = $4f7198262958b1df$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $4f7198262958b1df$var$nameRegexp = '[' + $4f7198262958b1df$var$nameStartChar + '][' + $4f7198262958b1df$var$nameChar + ']*';
const $4f7198262958b1df$var$regexName = new RegExp('^' + $4f7198262958b1df$var$nameRegexp + '$');
const $4f7198262958b1df$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $4f7198262958b1df$var$isName = function(string) {
    const match = $4f7198262958b1df$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$4f7198262958b1df$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$4f7198262958b1df$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$4f7198262958b1df$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$4f7198262958b1df$export$bf7199a9ebcb84a9 = function(v) {
    if ($4f7198262958b1df$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$4f7198262958b1df$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    let newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$4f7198262958b1df$export$fd3b6180ca5b0284 = function(tagName, arrayMode, parentTagName) {
    if (arrayMode === false) return false;
    else if (arrayMode instanceof RegExp) return arrayMode.test(tagName);
    else if (typeof arrayMode === 'function') return !!arrayMode(tagName, parentTagName);
    return arrayMode === "strict";
};
$4f7198262958b1df$export$998d7ff9801e90bb = $4f7198262958b1df$var$isName;
$4f7198262958b1df$export$aaa9734c55cb7a19 = $4f7198262958b1df$var$getAllMatches;
$4f7198262958b1df$export$e8f2644f7085b4b1 = $4f7198262958b1df$var$nameRegexp;

});

parcelRegister("e6qaR", function(module, exports) {
'use strict';
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});

parcelRegister("duWUg", function(module, exports) {
const $028938dc24d96fb8$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $028938dc24d96fb8$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
// const octRegex = /^0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
const $028938dc24d96fb8$var$consider = {
    hex: true,
    // oct: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $028938dc24d96fb8$var$toNumber(str, options = {}) {
    options = Object.assign({}, $028938dc24d96fb8$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (str === "0") return 0;
    else if (options.hex && $028938dc24d96fb8$var$hexRegex.test(trimmedStr)) return $028938dc24d96fb8$var$parse_int(trimmedStr, 16);
    else if (trimmedStr.search(/[eE]/) !== -1) {
        const notation = trimmedStr.match(/^([-\+])?(0*)([0-9]*(\.[0-9]*)?[eE][-\+]?[0-9]+)$/);
        // +00.123 => [ , '+', '00', '.123', ..
        if (notation) {
            // console.log(notation)
            if (options.leadingZeros) trimmedStr = (notation[1] || "") + notation[3];
            else {
                if (notation[2] === "0" && notation[3][0] === ".") ;
                else return str;
            }
            return options.eNotation ? Number(trimmedStr) : str;
        } else return str;
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    } else {
        //separate negative sign, leading zeros, and rest number
        const match = $028938dc24d96fb8$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $028938dc24d96fb8$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else if (options.leadingZeros && leadingZeros === str) return 0; //00
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) return numTrimmedByZeros === numStr || sign + numTrimmedByZeros === numStr ? num : str;
                else return trimmedStr === numStr || trimmedStr === sign + numStr ? num : str;
            }
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $028938dc24d96fb8$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $028938dc24d96fb8$var$parse_int(numStr, base) {
    //polyfill
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
module.exports = $028938dc24d96fb8$var$toNumber;

});



parcelRegister("eHjIk", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", function () { return $ab345f9d514088b9$export$54ffaacfc0931fb0; }, function (v) { return $ab345f9d514088b9$export$54ffaacfc0931fb0 = v; });
var $ab345f9d514088b9$export$54ffaacfc0931fb0;
'use strict';

var $6OSnz = parcelRequire("6OSnz");

var $6OSnz = parcelRequire("6OSnz");
var $ab345f9d514088b9$require$buildOptions = $6OSnz.buildOptions;

var $3WVUR = parcelRequire("3WVUR");
//TODO: do it later
const $ab345f9d514088b9$var$convertToJsonString = function(node, options) {
    options = $ab345f9d514088b9$require$buildOptions(options, $3WVUR.defaultOptions, $3WVUR.props);
    options.indentBy = options.indentBy || '';
    return $ab345f9d514088b9$var$_cToJsonStr(node, options, 0);
};
const $ab345f9d514088b9$var$_cToJsonStr = function(node, options, level) {
    let jObj = '{';
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(let tag in node.child[tagname])jObj += $ab345f9d514088b9$var$_cToJsonStr(node.child[tagname][tag], options) + ' , ';
            jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $ab345f9d514088b9$var$_cToJsonStr(node.child[tagname][0], options) + ' ,';
    }
    $6OSnz.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($6OSnz.isEmptyObject(jObj)) return $6OSnz.isExist(node.val) ? node.val : '';
    else {
        if ($6OSnz.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $ab345f9d514088b9$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ',') jObj = jObj.substr(0, jObj.length - 2);
    return jObj + '}';
};
function $ab345f9d514088b9$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $ab345f9d514088b9$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$ab345f9d514088b9$export$54ffaacfc0931fb0 = $ab345f9d514088b9$var$convertToJsonString;

});

parcelRegister("cfkXl", function(module, exports) {
'use strict';

var $6OSnz = parcelRequire("6OSnz");
var $8ea72439525276c9$require$buildOptions = $6OSnz.buildOptions;
const $8ea72439525276c9$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    format: false,
    indentBy: '  ',
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $8ea72439525276c9$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'cdataTagName',
    'cdataPositionChar',
    'format',
    'indentBy',
    'supressEmptyNode',
    'tagValueProcessor',
    'attrValueProcessor',
    'rootNodeName'
];
function $8ea72439525276c9$var$Parser(options) {
    this.options = $8ea72439525276c9$require$buildOptions(options, $8ea72439525276c9$var$defaultOptions, $8ea72439525276c9$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $8ea72439525276c9$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $8ea72439525276c9$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $8ea72439525276c9$var$replaceCDATAstr;
    this.replaceCDATAarr = $8ea72439525276c9$var$replaceCDATAarr;
    this.processTextOrObjNode = $8ea72439525276c9$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $8ea72439525276c9$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $8ea72439525276c9$var$buildEmptyTextNode;
        this.buildObjNode = $8ea72439525276c9$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $8ea72439525276c9$var$buildTextValNode;
        this.buildObjNode = $8ea72439525276c9$var$buildObjectNode;
    }
    this.buildTextValNode = $8ea72439525276c9$var$buildTextValNode;
    this.buildObjectNode = $8ea72439525276c9$var$buildObjectNode;
}
$8ea72439525276c9$var$Parser.prototype.parse = function(jObj) {
    if (Array.isArray(jObj) && this.options.rootNodeName && this.options.rootNodeName.length > 1) jObj = {
        [this.options.rootNodeName]: jObj
    };
    return this.j2x(jObj, 0).val;
};
$8ea72439525276c9$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr('', jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor('' + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr('', jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === 'undefined') ;
                    else if (item === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                    else if (typeof item === 'object') val += this.processTextOrObjNode(item, key, level);
                    else val += this.buildTextNode(item, key, '', level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += ' ' + Ks[j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[j]]) + '"';
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $8ea72439525276c9$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextNode(result.val, key, result.attrStr, level);
    else return this.buildObjNode(result.val, key, result.attrStr, level);
}
function $8ea72439525276c9$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
}
function $8ea72439525276c9$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
        return str + this.newLine;
    }
}
function $8ea72439525276c9$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
    // + this.indentate(level)
    '</' + key + this.tagEndChar;
    else return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + '</' + key + this.tagEndChar;
}
function $8ea72439525276c9$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $8ea72439525276c9$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
}
function $8ea72439525276c9$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== '') return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $8ea72439525276c9$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $8ea72439525276c9$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $8ea72439525276c9$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $8ea72439525276c9$var$Parser;

});

parcelRegister("bVGkv", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $eAuXG = parcelRequire("eAuXG");

var $c7I8n = parcelRequire("c7I8n");

var $jCBkf = parcelRequire("jCBkf");

var $cUr9z = parcelRequire("cUr9z");

var $G0330 = parcelRequire("G0330");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $8af5da6834a68d15$var$createInstance(defaultConfig) {
    var context = new $c7I8n(defaultConfig);
    var instance = $eAuXG($c7I8n.prototype.request, context);
    // Copy axios.prototype to instance
    $fBYmO.extend(instance, $c7I8n.prototype, context);
    // Copy context to instance
    $fBYmO.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8af5da6834a68d15$var$createInstance($jCBkf(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $8af5da6834a68d15$var$axios = $8af5da6834a68d15$var$createInstance($cUr9z);
// Expose Axios class to allow class inheritance
$8af5da6834a68d15$var$axios.Axios = $c7I8n;

// Expose Cancel & CancelToken
$8af5da6834a68d15$var$axios.CanceledError = (parcelRequire("eVoIL"));

$8af5da6834a68d15$var$axios.CancelToken = (parcelRequire("3k7vN"));

$8af5da6834a68d15$var$axios.isCancel = (parcelRequire("3TLsJ"));

$8af5da6834a68d15$var$axios.VERSION = (parcelRequire("8g8UE")).version;

$8af5da6834a68d15$var$axios.toFormData = (parcelRequire("2mVL5"));

// Expose AxiosError class
$8af5da6834a68d15$var$axios.AxiosError = (parcelRequire("jmL4N"));
// alias for CanceledError for backward compatibility
$8af5da6834a68d15$var$axios.Cancel = $8af5da6834a68d15$var$axios.CanceledError;
// Expose all/spread
$8af5da6834a68d15$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$8af5da6834a68d15$var$axios.spread = (parcelRequire("8ILEC"));

// Expose isAxiosError
$8af5da6834a68d15$var$axios.isAxiosError = (parcelRequire("1m4B9"));
$8af5da6834a68d15$var$axios.formToJSON = function(thing) {
    return $G0330($fBYmO.isHTMLForm(thing) ? new FormData(thing) : thing);
};
module.exports = $8af5da6834a68d15$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $8af5da6834a68d15$var$axios;

});
parcelRegister("fBYmO", function(module, exports) {
'use strict';

var $eAuXG = parcelRequire("eAuXG");
// utils is a library of generic helper functions non-specific to axios
var $b5d92353491197d5$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $b5d92353491197d5$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $b5d92353491197d5$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $b5d92353491197d5$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $b5d92353491197d5$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $b5d92353491197d5$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $b5d92353491197d5$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $b5d92353491197d5$var$isBuffer(val) {
    return val !== null && !$b5d92353491197d5$var$isUndefined(val) && val.constructor !== null && !$b5d92353491197d5$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $b5d92353491197d5$var$isArrayBuffer = $b5d92353491197d5$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $b5d92353491197d5$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $b5d92353491197d5$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $b5d92353491197d5$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $b5d92353491197d5$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $b5d92353491197d5$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $b5d92353491197d5$var$isPlainObject(val) {
    if ($b5d92353491197d5$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */ function $b5d92353491197d5$var$isEmptyObject(val) {
    if (!$b5d92353491197d5$var$isPlainObject(val)) return false;
    for(var key in val){
        if (Object.prototype.hasOwnProperty.call(val, key)) return false;
    }
    return true;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $b5d92353491197d5$var$isDate = $b5d92353491197d5$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $b5d92353491197d5$var$isFile = $b5d92353491197d5$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $b5d92353491197d5$var$isBlob = $b5d92353491197d5$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $b5d92353491197d5$var$isFileList = $b5d92353491197d5$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $b5d92353491197d5$var$isFunction(val) {
    return $b5d92353491197d5$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $b5d92353491197d5$var$isStream(val) {
    return $b5d92353491197d5$var$isObject(val) && $b5d92353491197d5$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $b5d92353491197d5$var$isFormData(thing) {
    var pattern = '[object FormData]';
    if (!thing) return false;
    if (typeof FormData === 'function' && thing instanceof FormData) return true;
    // Reject non-objects (strings, numbers, booleans) up front — Object.getPrototypeOf
    // throws a TypeError on primitives in ES5 environments.
    if (!$b5d92353491197d5$var$isObject(thing)) return false;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    var proto = Object.getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$b5d92353491197d5$var$isFunction(thing.append)) return false;
    return $b5d92353491197d5$var$toString.call(thing) === pattern || $b5d92353491197d5$var$isFunction(thing.toString) && thing.toString() === pattern;
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $b5d92353491197d5$var$isURLSearchParams = $b5d92353491197d5$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $b5d92353491197d5$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $b5d92353491197d5$var$isStandardBrowserEnv() {
    var product;
    if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $b5d92353491197d5$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($b5d92353491197d5$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $b5d92353491197d5$var$merge() {
    var result = Object.create(null);
    function assignValue(val, key) {
        var target;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        target = Object.prototype.hasOwnProperty.call(result, key) ? result[key] : undefined;
        if ($b5d92353491197d5$var$isPlainObject(target) && $b5d92353491197d5$var$isPlainObject(val)) result[key] = $b5d92353491197d5$var$merge(target, val);
        else if ($b5d92353491197d5$var$isPlainObject(val)) result[key] = $b5d92353491197d5$var$merge({}, val);
        else if ($b5d92353491197d5$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$b5d92353491197d5$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $b5d92353491197d5$var$extend(a, b, thisArg) {
    $b5d92353491197d5$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $eAuXG(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $b5d92353491197d5$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $b5d92353491197d5$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */ function $b5d92353491197d5$var$toFlatObject(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $b5d92353491197d5$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */ function $b5d92353491197d5$var$toArray(thing) {
    if (!thing) return null;
    if ($b5d92353491197d5$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$b5d92353491197d5$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $b5d92353491197d5$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
function $b5d92353491197d5$var$forEachEntry(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
}
function $b5d92353491197d5$var$matchAll(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
}
var $b5d92353491197d5$var$isHTMLForm = $b5d92353491197d5$var$kindOfTest('HTMLFormElement');
var $b5d92353491197d5$var$hasOwnProperty = function resolver(_hasOwnProperty) {
    return function(obj, prop) {
        return _hasOwnProperty.call(obj, prop);
    };
}(Object.prototype.hasOwnProperty);
module.exports = {
    isArray: $b5d92353491197d5$var$isArray,
    isArrayBuffer: $b5d92353491197d5$var$isArrayBuffer,
    isBuffer: $b5d92353491197d5$var$isBuffer,
    isFormData: $b5d92353491197d5$var$isFormData,
    isArrayBufferView: $b5d92353491197d5$var$isArrayBufferView,
    isString: $b5d92353491197d5$var$isString,
    isNumber: $b5d92353491197d5$var$isNumber,
    isObject: $b5d92353491197d5$var$isObject,
    isPlainObject: $b5d92353491197d5$var$isPlainObject,
    isEmptyObject: $b5d92353491197d5$var$isEmptyObject,
    isUndefined: $b5d92353491197d5$var$isUndefined,
    isDate: $b5d92353491197d5$var$isDate,
    isFile: $b5d92353491197d5$var$isFile,
    isBlob: $b5d92353491197d5$var$isBlob,
    isFunction: $b5d92353491197d5$var$isFunction,
    isStream: $b5d92353491197d5$var$isStream,
    isURLSearchParams: $b5d92353491197d5$var$isURLSearchParams,
    isStandardBrowserEnv: $b5d92353491197d5$var$isStandardBrowserEnv,
    forEach: $b5d92353491197d5$var$forEach,
    merge: $b5d92353491197d5$var$merge,
    extend: $b5d92353491197d5$var$extend,
    trim: $b5d92353491197d5$var$trim,
    stripBOM: $b5d92353491197d5$var$stripBOM,
    inherits: $b5d92353491197d5$var$inherits,
    toFlatObject: $b5d92353491197d5$var$toFlatObject,
    kindOf: $b5d92353491197d5$var$kindOf,
    kindOfTest: $b5d92353491197d5$var$kindOfTest,
    endsWith: $b5d92353491197d5$var$endsWith,
    toArray: $b5d92353491197d5$var$toArray,
    isTypedArray: $b5d92353491197d5$var$isTypedArray,
    isFileList: $b5d92353491197d5$var$isFileList,
    forEachEntry: $b5d92353491197d5$var$forEachEntry,
    matchAll: $b5d92353491197d5$var$matchAll,
    isHTMLForm: $b5d92353491197d5$var$isHTMLForm,
    hasOwnProperty: $b5d92353491197d5$var$hasOwnProperty
};

});
parcelRegister("eAuXG", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
};

});


parcelRegister("c7I8n", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $9FR5l = parcelRequire("9FR5l");

var $gXuBd = parcelRequire("gXuBd");

var $5UQnl = parcelRequire("5UQnl");

var $jCBkf = parcelRequire("jCBkf");

var $eKrzx = parcelRequire("eKrzx");

var $i0blT = parcelRequire("i0blT");
var $8d385f94f389ac2c$var$validators = $i0blT.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $8d385f94f389ac2c$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $gXuBd(),
        response: new $gXuBd()
    };
}
/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */ $8d385f94f389ac2c$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $jCBkf(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $i0blT.assertOptions(transitional, {
        silentJSONParsing: $8d385f94f389ac2c$var$validators.transitional($8d385f94f389ac2c$var$validators.boolean),
        forcedJSONParsing: $8d385f94f389ac2c$var$validators.transitional($8d385f94f389ac2c$var$validators.boolean),
        clarifyTimeoutError: $8d385f94f389ac2c$var$validators.transitional($8d385f94f389ac2c$var$validators.boolean)
    }, false);
    var paramsSerializer = config.paramsSerializer;
    if (paramsSerializer != null) {
        if ($fBYmO.isFunction(paramsSerializer)) config.paramsSerializer = {
            serialize: paramsSerializer
        };
        else $i0blT.assertOptions(paramsSerializer, {
            encode: $8d385f94f389ac2c$var$validators.function,
            serialize: $8d385f94f389ac2c$var$validators.function
        }, true);
    }
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $5UQnl,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $5UQnl(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$8d385f94f389ac2c$var$Axios.prototype.getUri = function getUri(config) {
    config = $jCBkf(this.defaults, config);
    var fullPath = $eKrzx(config.baseURL, config.url, config.allowAbsoluteUrls);
    return $9FR5l(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$fBYmO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $8d385f94f389ac2c$var$Axios.prototype[method] = function(url, config) {
        var requestConfig = config || {};
        return this.request($jCBkf(requestConfig, {
            method: method,
            url: url,
            data: $fBYmO.hasOwnProperty(requestConfig, 'data') ? requestConfig.data : undefined
        }));
    };
});
$fBYmO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($jCBkf(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $8d385f94f389ac2c$var$Axios.prototype[method] = generateHTTPMethod();
    $8d385f94f389ac2c$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $8d385f94f389ac2c$var$Axios;

});
parcelRegister("9FR5l", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $ioVIo = parcelRequire("ioVIo");
function $70b11f0266c40fe2$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
    var _encode = $70b11f0266c40fe2$var$encode;
    var serializeFn;
    if (options) {
        if ($fBYmO.isFunction(options)) serializeFn = options;
        else {
            _encode = $fBYmO.hasOwnProperty(options, 'encode') && options.encode || $70b11f0266c40fe2$var$encode;
            serializeFn = $fBYmO.hasOwnProperty(options, 'serialize') ? options.serialize : undefined;
        }
    }
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = $fBYmO.isURLSearchParams(params) ? params.toString() : new $ioVIo(params, options).toString(_encode);
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});
parcelRegister("ioVIo", function(module, exports) {
'use strict';

var $2mVL5 = parcelRequire("2mVL5");
function $d6573ce142008017$var$encode(str) {
    // Do not map `%00` back to a raw null byte: that reversed
    // the safe percent-encoding from encodeURIComponent and enabled null byte injection.
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
function $d6573ce142008017$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && $2mVL5(params, this, options);
}
var $d6573ce142008017$var$prototype = $d6573ce142008017$var$AxiosURLSearchParams.prototype;
$d6573ce142008017$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$d6573ce142008017$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function(value) {
        return encoder.call(this, value, $d6573ce142008017$var$encode);
    } : $d6573ce142008017$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
module.exports = $d6573ce142008017$var$AxiosURLSearchParams;

});
parcelRegister("2mVL5", function(module, exports) {

var $38gB7 = parcelRequire("38gB7");
var $1b9a70737fe200a0$require$Buffer = $38gB7.Buffer;
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $jmL4N = parcelRequire("jmL4N");

var $cpLAC = parcelRequire("cpLAC");
function $1b9a70737fe200a0$var$isVisitable(thing) {
    return $fBYmO.isPlainObject(thing) || $fBYmO.isArray(thing);
}
function $1b9a70737fe200a0$var$removeBrackets(key) {
    return $fBYmO.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
function $1b9a70737fe200a0$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1b9a70737fe200a0$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
function $1b9a70737fe200a0$var$isFlatArray(arr) {
    return $fBYmO.isArray(arr) && !arr.some($1b9a70737fe200a0$var$isVisitable);
}
var $1b9a70737fe200a0$var$predicates = $fBYmO.toFlatObject($fBYmO, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
function $1b9a70737fe200a0$var$isSpecCompliant(thing) {
    return thing && $fBYmO.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/ function $1b9a70737fe200a0$var$toFormData(obj, formData, options) {
    if (!$fBYmO.isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ($cpLAC || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = $fBYmO.toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !$fBYmO.isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    var useBlob = _Blob && $1b9a70737fe200a0$var$isSpecCompliant(formData);
    if (!$fBYmO.isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ($fBYmO.isDate(value)) return value.toISOString();
        if (!useBlob && $fBYmO.isBlob(value)) throw new $jmL4N('Blob is not supported. Use a Buffer instead.');
        if ($fBYmO.isArrayBuffer(value) || $fBYmO.isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $1b9a70737fe200a0$require$Buffer.from(value);
        return value;
    }
    var stack = [];
    function assertValueDepth(value, depth) {
        if (depth > maxDepth) throw new $jmL4N('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $jmL4N.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (!$fBYmO.isObject(value) || stack.indexOf(value) !== -1) return;
        stack.push(value);
        $fBYmO.forEach(value, function each(el) {
            assertValueDepth(el, depth + 1);
        });
        stack.pop();
    }
    /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === 'object') {
            if ($fBYmO.endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                assertValueDepth(value, 1);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ($fBYmO.isArray(value) && $1b9a70737fe200a0$var$isFlatArray(value) || $fBYmO.isFileList(value) || $fBYmO.endsWith(key, '[]') && (arr = $fBYmO.toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1b9a70737fe200a0$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !($fBYmO.isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1b9a70737fe200a0$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($1b9a70737fe200a0$var$isVisitable(value)) return true;
        formData.append($1b9a70737fe200a0$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var exposedHelpers = Object.assign($1b9a70737fe200a0$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1b9a70737fe200a0$var$isVisitable
    });
    function build(value, path, depth) {
        if ($fBYmO.isUndefined(value)) return;
        // eslint-disable-next-line no-param-reassign
        depth = depth || 0;
        if (depth > maxDepth) throw new $jmL4N('Maximum object depth of ' + maxDepth + ' exceeded (got ' + depth + ' levels)', $jmL4N.ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        $fBYmO.forEach(value, function each(el, key) {
            var result = !($fBYmO.isUndefined(el) || el === null) && visitor.call(formData, el, $fBYmO.isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!$fBYmO.isObject(obj)) throw new TypeError('data must be an object');
    build(obj, null, 0);
    return formData;
}
module.exports = $1b9a70737fe200a0$var$toFormData;

});
parcelRegister("jmL4N", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $cK9za = parcelRequire("cK9za");
var $e19496c1ac0b954c$var$REDACTED_VALUE = '[REDACTED ****]';
function $e19496c1ac0b954c$var$makeValueDescriptor(value) {
    var descriptor = Object.create(null);
    descriptor.value = value;
    return descriptor;
}
function $e19496c1ac0b954c$var$getRedactKeys(config) {
    // An empty array is treated as "no override" so an upstream `redact: []` cannot
    // silently disable redaction. To opt out, pass non-string values or unset keys.
    var override = config && $fBYmO.isArray(config.redact) && config.redact.length ? config.redact : null;
    var redact = override || $cK9za;
    var keys = {};
    $fBYmO.forEach(redact, function eachRedactKey(key) {
        if (typeof key === 'string') keys[key.toLowerCase()] = true;
    });
    return keys;
}
function $e19496c1ac0b954c$var$shouldRedact(key, keys) {
    return typeof key === 'string' && keys[key.toLowerCase()];
}
var $e19496c1ac0b954c$var$CIRCULAR_VALUE = '[Circular]';
function $e19496c1ac0b954c$var$serializeConfigValue(value, keys, key, seen) {
    var result;
    if ($e19496c1ac0b954c$var$shouldRedact(key, keys)) return $e19496c1ac0b954c$var$REDACTED_VALUE;
    if ($fBYmO.isArray(value)) {
        if (seen.indexOf(value) !== -1) return $e19496c1ac0b954c$var$CIRCULAR_VALUE;
        seen.push(value);
        result = [];
        $fBYmO.forEach(value, function eachArrayValue(item, index) {
            result[index] = $e19496c1ac0b954c$var$serializeConfigValue(item, keys, index, seen);
        });
        seen.pop();
        return result;
    }
    if ($fBYmO.isPlainObject(value)) {
        if (seen.indexOf(value) !== -1) return $e19496c1ac0b954c$var$CIRCULAR_VALUE;
        seen.push(value);
        result = {};
        $fBYmO.forEach(value, function eachObjectValue(item, itemKey) {
            result[itemKey] = $e19496c1ac0b954c$var$serializeConfigValue(item, keys, itemKey, seen);
        });
        seen.pop();
        return result;
    }
    return value;
}
function $e19496c1ac0b954c$var$serializeConfig(config) {
    if (!config) return config;
    return $e19496c1ac0b954c$var$serializeConfigValue(config, $e19496c1ac0b954c$var$getRedactKeys(config), undefined, []);
}
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $e19496c1ac0b954c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$fBYmO.inherits($e19496c1ac0b954c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $e19496c1ac0b954c$var$serializeConfig(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $e19496c1ac0b954c$var$prototype = $e19496c1ac0b954c$var$AxiosError.prototype;
var $e19496c1ac0b954c$var$descriptors = Object.create(null);
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL',
    'ERR_FORM_DATA_DEPTH_EXCEEDED'
].forEach(function(code) {
    $e19496c1ac0b954c$var$descriptors[code] = $e19496c1ac0b954c$var$makeValueDescriptor(code);
});
Object.defineProperties($e19496c1ac0b954c$var$AxiosError, $e19496c1ac0b954c$var$descriptors);
Object.defineProperty($e19496c1ac0b954c$var$prototype, 'isAxiosError', $e19496c1ac0b954c$var$makeValueDescriptor(true));
// eslint-disable-next-line func-names
$e19496c1ac0b954c$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($e19496c1ac0b954c$var$prototype);
    $fBYmO.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $e19496c1ac0b954c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $e19496c1ac0b954c$var$AxiosError;

});
parcelRegister("cK9za", function(module, exports) {
'use strict';
module.exports = [
    'authorization',
    'proxy-authorization',
    'cookie',
    'set-cookie',
    'x-api-key',
    'password'
];

});


parcelRegister("cpLAC", function(module, exports) {
// eslint-disable-next-line strict

module.exports = (parcelRequire("bntqK"));

});
parcelRegister("bntqK", function(module, exports) {
'use strict';
/* eslint-env browser */ module.exports = typeof self === 'object' ? self.FormData : window.FormData;

});





parcelRegister("gXuBd", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
function $c589e46b32b4a4d2$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $c589e46b32b4a4d2$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $c589e46b32b4a4d2$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Clear all interceptors from the stack
 */ $c589e46b32b4a4d2$var$InterceptorManager.prototype.clear = function clear() {
    if (this.handlers) this.handlers = [];
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $c589e46b32b4a4d2$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $fBYmO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $c589e46b32b4a4d2$var$InterceptorManager;

});

parcelRegister("5UQnl", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $9KyiP = parcelRequire("9KyiP");

var $3TLsJ = parcelRequire("3TLsJ");

var $cUr9z = parcelRequire("cUr9z");

var $eVoIL = parcelRequire("eVoIL");

var $7B2OU = parcelRequire("7B2OU");

var $SIXJ0 = parcelRequire("SIXJ0");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $44eacf6acf740293$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $eVoIL();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $44eacf6acf740293$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $9KyiP.call(config, config.data, config.headers, null, config.transformRequest);
    $7B2OU(config.headers, 'Accept');
    $7B2OU(config.headers, 'Content-Type');
    // Flatten headers
    var commonHeaders = $fBYmO.hasOwnProperty(config.headers, 'common') && config.headers.common ? config.headers.common : {};
    var methodHeaders = config.method && $fBYmO.hasOwnProperty(config.headers, config.method) && config.headers[config.method] ? config.headers[config.method] : {};
    config.headers = $fBYmO.merge(commonHeaders, methodHeaders, config.headers);
    $fBYmO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    $fBYmO.forEach(config.headers, function sanitizeHeaderConfigValue(value, header) {
        config.headers[header] = $SIXJ0(value);
    });
    var adapter = config.adapter || $cUr9z.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $44eacf6acf740293$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $9KyiP.call(config, response.data, response.headers, response.status, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$3TLsJ(reason)) {
            $44eacf6acf740293$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $9KyiP.call(config, reason.response.data, reason.response.headers, reason.response.status, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("9KyiP", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $cUr9z = parcelRequire("cUr9z");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, status, fns) {
    var context = this || $cUr9z;
    /*eslint no-param-reassign:0*/ $fBYmO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers, status);
    });
    return data;
};

});
parcelRegister("cUr9z", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $7B2OU = parcelRequire("7B2OU");

var $jmL4N = parcelRequire("jmL4N");

var $lTqqG = parcelRequire("lTqqG");

var $2mVL5 = parcelRequire("2mVL5");

var $gaYg6 = parcelRequire("gaYg6");

var $g2TCN = parcelRequire("g2TCN");

var $G0330 = parcelRequire("G0330");

var $cK9za = parcelRequire("cK9za");
var $965fc7178ae009b0$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $965fc7178ae009b0$var$setContentTypeIfUnset(headers, value) {
    if (!$fBYmO.isUndefined(headers) && $fBYmO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $965fc7178ae009b0$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("cGXfz"));
    return adapter;
}
function $965fc7178ae009b0$var$stringifySafely(rawValue, parser, encoder) {
    if ($fBYmO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $fBYmO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $965fc7178ae009b0$var$defaults = {
    transitional: $lTqqG,
    adapter: $965fc7178ae009b0$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $7B2OU(headers, 'Accept');
            $7B2OU(headers, 'Content-Type');
            var contentType = headers && headers['Content-Type'] || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = $fBYmO.isObject(data);
            if (isObjectPayload && $fBYmO.isHTMLForm(data)) data = new FormData(data);
            var isFormData = $fBYmO.isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify($G0330(data)) : data;
            if ($fBYmO.isArrayBuffer(data) || $fBYmO.isBuffer(data) || $fBYmO.isStream(data) || $fBYmO.isFile(data) || $fBYmO.isBlob(data)) return data;
            if ($fBYmO.isArrayBufferView(data)) return data.buffer;
            if ($fBYmO.isURLSearchParams(data)) {
                $965fc7178ae009b0$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                var formSerializer = $fBYmO.hasOwnProperty(this, 'formSerializer') ? this.formSerializer : undefined;
                var envOption = $fBYmO.hasOwnProperty(this, 'env') ? this.env : undefined;
                if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) return $gaYg6(data, formSerializer).toString();
                if ((isFileList = $fBYmO.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = envOption && envOption.FormData;
                    return $2mVL5(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                $965fc7178ae009b0$var$setContentTypeIfUnset(headers, 'application/json');
                return $965fc7178ae009b0$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $965fc7178ae009b0$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if (data && $fBYmO.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw $jmL4N.from(e, $jmL4N.ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    redact: $cK9za.slice(),
    env: {
        FormData: $g2TCN.classes.FormData,
        Blob: $g2TCN.classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$fBYmO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $965fc7178ae009b0$var$defaults.headers[method] = {};
});
$fBYmO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $965fc7178ae009b0$var$defaults.headers[method] = $fBYmO.merge($965fc7178ae009b0$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $965fc7178ae009b0$var$defaults;

});
parcelRegister("7B2OU", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $fBYmO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("lTqqG", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("gaYg6", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $2mVL5 = parcelRequire("2mVL5");

var $g2TCN = parcelRequire("g2TCN");
module.exports = function toURLEncodedForm(data, options) {
    return $2mVL5(data, new $g2TCN.classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ($g2TCN.isNode && $fBYmO.isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
};

});
parcelRegister("g2TCN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kIubR"));

});
parcelRegister("kIubR", function(module, exports) {
'use strict';


module.exports = {
    isBrowser: true,
    classes: {
        URLSearchParams: (parcelRequire("fK51Q")),
        FormData: (parcelRequire("f56Z2")),
        Blob: Blob
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("fK51Q", function(module, exports) {
'use strict';

var $ioVIo = parcelRequire("ioVIo");
module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : $ioVIo;

});

parcelRegister("f56Z2", function(module, exports) {
'use strict';
module.exports = FormData;

});




parcelRegister("G0330", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $jmL4N = parcelRequire("jmL4N");
var $07e3f5ebc363b27a$var$MAX_FORM_DATA_TO_JSON_DEPTH = 100;
function $07e3f5ebc363b27a$var$assertPathDepth(path) {
    var depth = path.length - 1;
    if (depth > $07e3f5ebc363b27a$var$MAX_FORM_DATA_TO_JSON_DEPTH) throw new $jmL4N('Maximum object depth of ' + $07e3f5ebc363b27a$var$MAX_FORM_DATA_TO_JSON_DEPTH + ' exceeded (got ' + depth + ' levels)', $jmL4N.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function $07e3f5ebc363b27a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return $fBYmO.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
function $07e3f5ebc363b27a$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $07e3f5ebc363b27a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && $fBYmO.isArray(target) ? target.length : name;
        if (isLast) {
            if ($fBYmO.hasOwnProperty(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !$fBYmO.isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && $fBYmO.isArray(target[name])) target[name] = $07e3f5ebc363b27a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ($fBYmO.isFormData(formData) && $fBYmO.isFunction(formData.entries)) {
        var obj = {};
        $fBYmO.forEachEntry(formData, function(name, value) {
            var path = $07e3f5ebc363b27a$var$parsePropPath(name);
            $07e3f5ebc363b27a$var$assertPathDepth(path);
            buildPath(path, value, obj, 0);
        });
        return obj;
    }
    return null;
}
module.exports = $07e3f5ebc363b27a$var$formDataToJSON;

});

parcelRegister("cGXfz", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");

var $hix3L = parcelRequire("hix3L");

var $i1Prz = parcelRequire("i1Prz");

var $9FR5l = parcelRequire("9FR5l");

var $eKrzx = parcelRequire("eKrzx");

var $jRsfb = parcelRequire("jRsfb");

var $4tlSm = parcelRequire("4tlSm");

var $lTqqG = parcelRequire("lTqqG");

var $jmL4N = parcelRequire("jmL4N");

var $eVoIL = parcelRequire("eVoIL");

var $j69IA = parcelRequire("j69IA");

var $g2TCN = parcelRequire("g2TCN");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        // Guard against prototype pollution: only honor own properties.
        var withXSRFToken = $fBYmO.hasOwnProperty(config, 'withXSRFToken') ? config.withXSRFToken : undefined;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($fBYmO.isFormData(requestData) && $fBYmO.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        var configAuth = $fBYmO.hasOwnProperty(config, 'auth') ? config.auth : undefined;
        if (configAuth) {
            var username = $fBYmO.hasOwnProperty(configAuth, 'username') ? configAuth.username || '' : '';
            var password = $fBYmO.hasOwnProperty(configAuth, 'password') && configAuth.password ? unescape(encodeURIComponent(configAuth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $eKrzx(config.baseURL, config.url, config.allowAbsoluteUrls);
        request.open(config.method.toUpperCase(), $9FR5l(fullPath, config.params, $fBYmO.hasOwnProperty(config, 'paramsSerializer') ? config.paramsSerializer : undefined), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $jRsfb(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $hix3L(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $jmL4N('Request aborted', $jmL4N.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $jmL4N('Network Error', $jmL4N.ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $lTqqG;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $jmL4N(timeoutErrorMessage, transitional.clarifyTimeoutError ? $jmL4N.ETIMEDOUT : $jmL4N.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($fBYmO.isStandardBrowserEnv()) {
            // Add xsrf header
            if ($fBYmO.isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(config);
            // Strict boolean check: only `true` short-circuits the same-origin guard.
            if (withXSRFToken === true || withXSRFToken !== false && $4tlSm(fullPath)) {
                // Add xsrf header
                var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && $i1Prz.read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $fBYmO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$fBYmO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new $eVoIL(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        // false, 0 (zero number), and '' (empty string) are valid JSON values
        if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') requestData = null;
        var protocol = $j69IA(fullPath);
        if (protocol && $g2TCN.protocols.indexOf(protocol) === -1) {
            reject(new $jmL4N('Unsupported protocol ' + protocol + ':', $jmL4N.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("hix3L", function(module, exports) {
'use strict';

var $jmL4N = parcelRequire("jmL4N");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $jmL4N('Request failed with status code ' + response.status, [
        $jmL4N.ERR_BAD_REQUEST,
        $jmL4N.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("i1Prz", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
module.exports = $fBYmO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($fBYmO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($fBYmO.isString(path)) cookie.push('path=' + path);
            if ($fBYmO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var nameEQ = name + '=';
            var cookies = document.cookie.split(';');
            var cookie;
            for(var i = 0; i < cookies.length; i++){
                cookie = cookies[i];
                while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
            }
            return null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("eKrzx", function(module, exports) {
'use strict';

var $40V4V = parcelRequire("40V4V");

var $7WBLU = parcelRequire("7WBLU");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @param {boolean} allowAbsoluteUrls Set to true to allow absolute URLs
 *
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    var isRelativeURL = !$40V4V(requestedURL);
    if (baseURL && (isRelativeURL || allowAbsoluteUrls === false)) return $7WBLU(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("40V4V", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("7WBLU", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("jRsfb", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $e758e0361361318b$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $fBYmO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $fBYmO.trim(line.slice(0, i)).toLowerCase();
        val = $fBYmO.trim(line.slice(i + 1));
        if (key) {
            if (parsed[key] && $e758e0361361318b$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4tlSm", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
module.exports = $fBYmO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */ return function isURLSameOrigin(requestURL) {
        var parsed = $fBYmO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("eVoIL", function(module, exports) {
'use strict';

var $jmL4N = parcelRequire("jmL4N");

var $fBYmO = parcelRequire("fBYmO");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */ function $add990a61d6d8f33$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $jmL4N.call(this, message == null ? 'canceled' : message, $jmL4N.ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
$fBYmO.inherits($add990a61d6d8f33$var$CanceledError, $jmL4N, {
    __CANCEL__: true
});
module.exports = $add990a61d6d8f33$var$CanceledError;

});

parcelRegister("j69IA", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});




parcelRegister("3TLsJ", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("SIXJ0", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
var $0a47ebd672b8e7b5$var$INVALID_HEADER_VALUE_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
var $0a47ebd672b8e7b5$var$BOUNDARY_WHITESPACE_RE = /^[\x09\x20]+|[\x09\x20]+$/g;
function $0a47ebd672b8e7b5$var$sanitizeHeaderValue(value) {
    if (value === false || value == null) return value;
    if ($fBYmO.isArray(value)) return value.map($0a47ebd672b8e7b5$var$sanitizeHeaderValue);
    return String(value).replace($0a47ebd672b8e7b5$var$INVALID_HEADER_VALUE_RE, '').replace($0a47ebd672b8e7b5$var$BOUNDARY_WHITESPACE_RE, '');
}
module.exports = $0a47ebd672b8e7b5$var$sanitizeHeaderValue;

});


parcelRegister("jCBkf", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so a polluted Object.prototype cannot leak
    // values (e.g. transport, adapter) into the returned config via inheritance.
    var config = Object.create(null);
    function getOwn(source, prop) {
        return $fBYmO.hasOwnProperty(source, prop) ? source[prop] : undefined;
    }
    function hasOwn(source, prop) {
        return $fBYmO.hasOwnProperty(source, prop);
    }
    function getMergedValue(target, source) {
        if ($fBYmO.isPlainObject(target) && $fBYmO.isPlainObject(source)) return $fBYmO.merge(target, source);
        else if ($fBYmO.isEmptyObject(source)) return $fBYmO.merge({}, target);
        else if ($fBYmO.isPlainObject(source)) return $fBYmO.merge({}, source);
        else if ($fBYmO.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (hasOwn(config2, prop) && !$fBYmO.isUndefined(config2[prop])) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop) && !$fBYmO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (hasOwn(config2, prop) && !$fBYmO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (hasOwn(config2, prop) && !$fBYmO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (hasOwn(config1, prop) && !$fBYmO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (hasOwn(config2, prop)) return getMergedValue(getOwn(config1, prop), config2[prop]);
        else if (hasOwn(config1, prop)) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'withXSRFToken': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'allowedSocketPaths': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $fBYmO.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        var merge = $fBYmO.hasOwnProperty(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        var configValue = merge(prop);
        $fBYmO.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("i0blT", function(module, exports) {
'use strict';

var $8g8UE = parcelRequire("8g8UE");
var $d1b1085fc6217557$require$VERSION = $8g8UE.version;

var $jmL4N = parcelRequire("jmL4N");
var $d1b1085fc6217557$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $d1b1085fc6217557$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $d1b1085fc6217557$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $d1b1085fc6217557$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $d1b1085fc6217557$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $jmL4N(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $jmL4N.ERR_DEPRECATED);
        if (version && !$d1b1085fc6217557$var$deprecatedWarnings[opt]) {
            $d1b1085fc6217557$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $d1b1085fc6217557$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new $jmL4N('options must be an object', $jmL4N.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $jmL4N('option ' + opt + ' must be ' + result, $jmL4N.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $jmL4N('Unknown option ' + opt, $jmL4N.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $d1b1085fc6217557$var$assertOptions,
    validators: $d1b1085fc6217557$var$validators
};

});
parcelRegister("8g8UE", function(module, exports) {
module.exports = {
    "version": "0.33.0"
};

});



parcelRegister("3k7vN", function(module, exports) {
'use strict';

var $eVoIL = parcelRequire("eVoIL");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $26b9110ed6778ced$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i = token._listeners.length;
        while(i-- > 0)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message, config, request) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $eVoIL(message, config, request);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $26b9110ed6778ced$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $26b9110ed6778ced$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $26b9110ed6778ced$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $26b9110ed6778ced$var$CancelToken.source = function source() {
    var cancel;
    var token = new $26b9110ed6778ced$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $26b9110ed6778ced$var$CancelToken;

});

parcelRegister("8ILEC", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1m4B9", function(module, exports) {
'use strict';

var $fBYmO = parcelRequire("fBYmO");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $fBYmO.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("l44DO", function(module, exports) {
/* global window */ 
var $bO85P = parcelRequire("bO85P");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $bO85P.default)(root);
var $f55d92555ac6e91d$export$2e2bcd8739ae039 = result;

});
parcelRegister("bO85P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898aa455632c7423$export$2e2bcd8739ae039; });
function $898aa455632c7423$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("4sE1X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33f8d42cff5e422c$var$inspect;

var $33f8d42cff5e422c$var$_nodejsCustomInspectSymbol = $33f8d42cff5e422c$var$_interopRequireDefault((parcelRequire("c2WvV")));
function $33f8d42cff5e422c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33f8d42cff5e422c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $33f8d42cff5e422c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $33f8d42cff5e422c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $33f8d42cff5e422c$var$_typeof(obj);
}
var $33f8d42cff5e422c$var$MAX_ARRAY_LENGTH = 10;
var $33f8d42cff5e422c$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $33f8d42cff5e422c$var$inspect(value) {
    return $33f8d42cff5e422c$var$formatValue(value, []);
}
function $33f8d42cff5e422c$var$formatValue(value, seenValues) {
    switch($33f8d42cff5e422c$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $33f8d42cff5e422c$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $33f8d42cff5e422c$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $33f8d42cff5e422c$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $33f8d42cff5e422c$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $33f8d42cff5e422c$var$formatArray(value, seenValues);
    return $33f8d42cff5e422c$var$formatObject(value, seenValues);
}
function $33f8d42cff5e422c$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $33f8d42cff5e422c$var$MAX_RECURSIVE_DEPTH) return '[' + $33f8d42cff5e422c$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $33f8d42cff5e422c$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $33f8d42cff5e422c$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $33f8d42cff5e422c$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($33f8d42cff5e422c$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($33f8d42cff5e422c$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $33f8d42cff5e422c$var$getCustomFn(object) {
    var customInspectFn = object[String($33f8d42cff5e422c$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $33f8d42cff5e422c$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("c2WvV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $8c530f97342b0dc0$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $8c530f97342b0dc0$var$_default = $8c530f97342b0dc0$var$nodejsCustomInspectSymbol;
module.exports.default = $8c530f97342b0dc0$var$_default;

});


parcelRegister("8uRs4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $62fa9673bccc5b74$var$defineInspect;

var $62fa9673bccc5b74$var$_invariant = $62fa9673bccc5b74$var$_interopRequireDefault((parcelRequire("6QVGa")));

var $62fa9673bccc5b74$var$_nodejsCustomInspectSymbol = $62fa9673bccc5b74$var$_interopRequireDefault((parcelRequire("c2WvV")));
function $62fa9673bccc5b74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $62fa9673bccc5b74$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $62fa9673bccc5b74$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($62fa9673bccc5b74$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$62fa9673bccc5b74$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("6QVGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fd4574c79ada5e4$var$invariant;
function $4fd4574c79ada5e4$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});


parcelRegister("k4RGx", function(module, exports) {
/* global window */ 
var $59idQ = parcelRequire("59idQ");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $59idQ.default)(root);
var $e9ddd31e276bdfec$export$2e2bcd8739ae039 = result;

});
parcelRegister("59idQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfbed8f603762c3$export$2e2bcd8739ae039; });
function $3bfbed8f603762c3$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("glcOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/ $parcel$global.Buffer = $parcel$global.Buffer || (parcelRequire("38gB7")).Buffer; // Required for aws sigv4 signing

var $adm0U = parcelRequire("adm0U");

var $be588c7417c073bf$var$crypto = (parcelRequire("doStr")).util.crypto;
var $be588c7417c073bf$var$encrypt = function(key, src, encoding) {
    if (encoding === void 0) encoding = '';
    return $be588c7417c073bf$var$crypto.lib.createHmac('sha256', key).update(src, 'utf8').digest(encoding);
};
var $be588c7417c073bf$var$hash = function(src) {
    src = src || '';
    return $be588c7417c073bf$var$crypto.createHash('sha256').update(src, 'utf8').digest('hex');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $be588c7417c073bf$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
* List of header keys included in the canonical headers.
* @access private
*/ var $be588c7417c073bf$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $be588c7417c073bf$var$canonical_request = function(request) {
    var url_info = $adm0U.parse(request.url);
    return [
        request.method || '/',
        url_info.path,
        url_info.query,
        $be588c7417c073bf$var$canonical_headers(request.headers),
        $be588c7417c073bf$var$signed_headers(request.headers),
        $be588c7417c073bf$var$hash(request.body)
    ].join('\n');
};
var $be588c7417c073bf$var$parse_service_info = function(request) {
    var url_info = $adm0U.parse(request.url), host = url_info.host;
    var matched = host.match(/([^.]+)\.(?:([^.]*)\.)?amazonaws\.com$/), parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $be588c7417c073bf$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $be588c7417c073bf$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $be588c7417c073bf$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $be588c7417c073bf$var$get_signing_key = function(secret_key, d_str, service_info) {
    if (secret_key === void 0) secret_key = '';
    var k = 'AWS4' + secret_key, k_date = $be588c7417c073bf$var$encrypt(k, d_str), k_region = $be588c7417c073bf$var$encrypt(k_date, service_info.region), k_service = $be588c7417c073bf$var$encrypt(k_region, service_info.service), k_signing = $be588c7417c073bf$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $be588c7417c073bf$var$get_signature = function(signing_key, str_to_sign) {
    return $be588c7417c073bf$var$encrypt(signing_key, str_to_sign, 'hex');
};
/**
* @private
* Create authorization header
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
*/ var $be588c7417c073bf$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    if (access_key === void 0) access_key = '';
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
/**
* Sign a HTTP request, add 'Authorization' header to request param
* @method sign
* @memberof Signer
* @static
*
* @param {object} request - HTTP request object
<pre>
request: {
    method: GET | POST | PUT ...
    url: ...,
    headers: {
        header1: ...
    },
    body: data
}
</pre>
* @param {object} access_info - AWS access credential info
<pre>
access_info: {
    access_key: ...,
    secret_key: ...,
    session_token: ...
}
</pre>
* @param {object} [service_info] - AWS service type and region, optional,
*                                  if not provided then parse out from url
<pre>
service_info: {
    service: ...,
    region: ...
}
</pre>
*
* @returns {object} Signed HTTP request
*/ var $be588c7417c073bf$var$sign = function(request, access_info, service_info) {
    if (service_info === void 0) service_info = null;
    request.headers = request.headers || {};
    // datetime string and date string
    var dt = new Date(), dt_str = dt.toISOString().replace(/[:-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8), algorithm = 'AWS4-HMAC-SHA256';
    var url_info = $adm0U.parse(request.url);
    request.headers['host'] = url_info.host;
    request.headers['x-amz-date'] = dt_str;
    if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
    // Task 1: Create a Canonical Request
    var request_str = $be588c7417c073bf$var$canonical_request(request);
    // Task 2: Create a String to Sign
    service_info = service_info || $be588c7417c073bf$var$parse_service_info(request);
    var scope = $be588c7417c073bf$var$credential_scope(d_str, service_info.region, service_info.service);
    var str_to_sign = $be588c7417c073bf$var$string_to_sign(algorithm, request_str, dt_str, scope);
    // Task 3: Calculate the Signature
    var signing_key = $be588c7417c073bf$var$get_signing_key(access_info.secret_key, d_str, service_info), signature = $be588c7417c073bf$var$get_signature(signing_key, str_to_sign);
    // Task 4: Adding the Signing information to the Request
    var authorization_header = $be588c7417c073bf$var$get_authorization_header(algorithm, access_info.access_key, scope, $be588c7417c073bf$var$signed_headers(request.headers), signature);
    request.headers['Authorization'] = authorization_header;
    return request;
};
/**
* AWS request signer.
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
*
* @class Signer
*/ var $be588c7417c073bf$var$Signer = /** @class */ function() {
    function Signer() {}
    Signer.sign = $be588c7417c073bf$var$sign;
    return Signer;
}();
module.exports.Signer = $be588c7417c073bf$var$Signer;
module.exports.default = $be588c7417c073bf$var$Signer;

});
parcelRegister("doStr", function(module, exports) {
parcelRequire("kQcRm");

var $e2mZ5 = parcelRequire("e2mZ5");
if (typeof window !== 'undefined') window.AWS = $e2mZ5;
module.exports = $e2mZ5;
if (typeof self !== 'undefined') self.AWS = $e2mZ5;

});
parcelRegister("kQcRm", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

// browser specific modules
$1ymo4.crypto.lib = (parcelRequire("lc2WQ"));

$1ymo4.Buffer = (parcelRequire("6ZYhl")).Buffer;

$1ymo4.url = (parcelRequire("dOLpM"));

$1ymo4.querystring = (parcelRequire("8FmBz"));

$1ymo4.realClock = (parcelRequire("9C5td"));
$1ymo4.environment = 'js';

$1ymo4.createEventStream = (parcelRequire("2sIAi")).createEventStream;
$1ymo4.isBrowser = function() {
    return true;
};
$1ymo4.isNode = function() {
    return false;
};

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 */ module.exports = $e2mZ5;
parcelRequire("kO0Co");
parcelRequire("cimjr");
parcelRequire("4CIYd");
parcelRequire("kLiqy");
parcelRequire("gbcJ3");
parcelRequire("4p9td");
parcelRequire("68isk");

// Load the DOMParser XML parser
$e2mZ5.XML.Parser = (parcelRequire("7sJwB"));
parcelRequire("i0ZMX");
if (typeof $f2c2a3a457642f89$var$process === 'undefined') var $f2c2a3a457642f89$var$process = {
    browser: true
};

});
parcelRegister("1ymo4", function(module, exports) {
/* eslint guard-for-in:0 */ 
var $89WEd = parcelRequire("89WEd");
var $121a550da83ab3b1$var$AWS;







/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */ var $121a550da83ab3b1$var$util = {
    environment: 'nodejs',
    engine: function engine() {
        if ($121a550da83ab3b1$var$util.isBrowser() && typeof navigator !== 'undefined') return navigator.userAgent;
        else {
            var engine = $89WEd.platform + '/' + $89WEd.version;
            return engine;
        }
    },
    userAgent: function userAgent() {
        var name = $121a550da83ab3b1$var$util.environment;
        var agent = 'aws-sdk-' + name + '/' + (parcelRequire("e2mZ5")).VERSION;
        if (name === 'nodejs') agent += ' ' + $121a550da83ab3b1$var$util.engine();
        return agent;
    },
    uriEscape: function uriEscape(string) {
        var output = encodeURIComponent(string);
        output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
        // AWS percent-encodes some extra non-standard characters in a URI
        output = output.replace(/[*]/g, function(ch) {
            return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
        });
        return output;
    },
    uriEscapePath: function uriEscapePath(string) {
        var parts = [];
        $121a550da83ab3b1$var$util.arrayEach(string.split('/'), function(part) {
            parts.push($121a550da83ab3b1$var$util.uriEscape(part));
        });
        return parts.join('/');
    },
    urlParse: function urlParse(url) {
        return $121a550da83ab3b1$var$util.url.parse(url);
    },
    urlFormat: function urlFormat(url) {
        return $121a550da83ab3b1$var$util.url.format(url);
    },
    queryStringParse: function queryStringParse(qs) {
        return $121a550da83ab3b1$var$util.querystring.parse(qs);
    },
    queryParamsToString: function queryParamsToString(params) {
        var items = [];
        var escape1 = $121a550da83ab3b1$var$util.uriEscape;
        var sortedKeys = Object.keys(params).sort();
        $121a550da83ab3b1$var$util.arrayEach(sortedKeys, function(name) {
            var value = params[name];
            var ename = escape1(name);
            var result = ename + '=';
            if (Array.isArray(value)) {
                var vals = [];
                $121a550da83ab3b1$var$util.arrayEach(value, function(item) {
                    vals.push(escape1(item));
                });
                result = ename + '=' + vals.sort().join('&' + ename + '=');
            } else if (value !== undefined && value !== null) result = ename + '=' + escape1(value);
            items.push(result);
        });
        return items.join('&');
    },
    readFileSync: function readFileSync(path) {
        if ($121a550da83ab3b1$var$util.isBrowser()) return null;
        return (parcelRequire("dluwd")).readFileSync(path, 'utf-8');
    },
    base64: {
        encode: function encode64(string) {
            if (typeof string === 'number') throw $121a550da83ab3b1$var$util.error(new Error('Cannot base64 encode number ' + string));
            if (string === null || typeof string === 'undefined') return string;
            var buf = $121a550da83ab3b1$var$util.buffer.toBuffer(string);
            return buf.toString('base64');
        },
        decode: function decode64(string) {
            if (typeof string === 'number') throw $121a550da83ab3b1$var$util.error(new Error('Cannot base64 decode number ' + string));
            if (string === null || typeof string === 'undefined') return string;
            return $121a550da83ab3b1$var$util.buffer.toBuffer(string, 'base64');
        }
    },
    buffer: {
        /**
     * Buffer constructor for Node buffer and buffer pollyfill
     */ toBuffer: function(data, encoding) {
            return typeof $121a550da83ab3b1$var$util.Buffer.from === 'function' && $121a550da83ab3b1$var$util.Buffer.from !== Uint8Array.from ? $121a550da83ab3b1$var$util.Buffer.from(data, encoding) : new $121a550da83ab3b1$var$util.Buffer(data, encoding);
        },
        alloc: function(size, fill, encoding) {
            if (typeof size !== 'number') throw new Error('size passed to alloc must be a number.');
            if (typeof $121a550da83ab3b1$var$util.Buffer.alloc === 'function') return $121a550da83ab3b1$var$util.Buffer.alloc(size, fill, encoding);
            else {
                var buf = new $121a550da83ab3b1$var$util.Buffer(size);
                if (fill !== undefined && typeof buf.fill === 'function') buf.fill(fill, undefined, undefined, encoding);
                return buf;
            }
        },
        toStream: function toStream(buffer) {
            if (!$121a550da83ab3b1$var$util.Buffer.isBuffer(buffer)) buffer = $121a550da83ab3b1$var$util.buffer.toBuffer(buffer);
            var readable = new $121a550da83ab3b1$var$util.stream.Readable();
            var pos = 0;
            readable._read = function(size) {
                if (pos >= buffer.length) return readable.push(null);
                var end = pos + size;
                if (end > buffer.length) end = buffer.length;
                readable.push(buffer.slice(pos, end));
                pos = end;
            };
            return readable;
        },
        /**
     * Concatenates a list of Buffer objects.
     */ concat: function(buffers) {
            var length = 0, offset = 0, buffer = null, i;
            for(i = 0; i < buffers.length; i++)length += buffers[i].length;
            buffer = $121a550da83ab3b1$var$util.buffer.alloc(length);
            for(i = 0; i < buffers.length; i++){
                buffers[i].copy(buffer, offset);
                offset += buffers[i].length;
            }
            return buffer;
        }
    },
    string: {
        byteLength: function byteLength(string) {
            if (string === null || string === undefined) return 0;
            if (typeof string === 'string') string = $121a550da83ab3b1$var$util.buffer.toBuffer(string);
            if (typeof string.byteLength === 'number') return string.byteLength;
            else if (typeof string.length === 'number') return string.length;
            else if (typeof string.size === 'number') return string.size;
            else if (typeof string.path === 'string') return (parcelRequire("dluwd")).lstatSync(string.path).size;
            else throw $121a550da83ab3b1$var$util.error(new Error('Cannot determine length of ' + string), {
                object: string
            });
        },
        upperFirst: function upperFirst(string) {
            return string[0].toUpperCase() + string.substr(1);
        },
        lowerFirst: function lowerFirst(string) {
            return string[0].toLowerCase() + string.substr(1);
        }
    },
    ini: {
        parse: function string(ini) {
            var currentSection, map = {};
            $121a550da83ab3b1$var$util.arrayEach(ini.split(/\r?\n/), function(line) {
                line = line.split(/(^|\s)[;#]/)[0].trim(); // remove comments and trim
                var isSection = line[0] === '[' && line[line.length - 1] === ']';
                if (isSection) {
                    currentSection = line.substring(1, line.length - 1);
                    if (currentSection === '__proto__' || currentSection.split(/\s/)[1] === '__proto__') throw $121a550da83ab3b1$var$util.error(new Error('Cannot load profile name \'' + currentSection + '\' from shared ini file.'));
                } else if (currentSection) {
                    var indexOfEqualsSign = line.indexOf('=');
                    var start = 0;
                    var end = line.length - 1;
                    var isAssignment = indexOfEqualsSign !== -1 && indexOfEqualsSign !== start && indexOfEqualsSign !== end;
                    if (isAssignment) {
                        var name = line.substring(0, indexOfEqualsSign).trim();
                        var value = line.substring(indexOfEqualsSign + 1).trim();
                        map[currentSection] = map[currentSection] || {};
                        map[currentSection][name] = value;
                    }
                }
            });
            return map;
        }
    },
    fn: {
        noop: function() {},
        callback: function(err) {
            if (err) throw err;
        },
        /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */ makeAsync: function makeAsync(fn, expectedArgs) {
            if (expectedArgs && expectedArgs <= fn.length) return fn;
            return function() {
                var args = Array.prototype.slice.call(arguments, 0);
                var callback = args.pop();
                var result = fn.apply(null, args);
                callback(result);
            };
        }
    },
    /**
   * Date and time utility functions.
   */ date: {
        /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */ getDate: function getDate() {
            if (!$121a550da83ab3b1$var$AWS) $121a550da83ab3b1$var$AWS = (parcelRequire("e2mZ5"));
            if ($121a550da83ab3b1$var$AWS.config.systemClockOffset) return new Date(new Date().getTime() + $121a550da83ab3b1$var$AWS.config.systemClockOffset);
            else return new Date();
        },
        /**
     * @return [String] the date in ISO-8601 format
     */ iso8601: function iso8601(date) {
            if (date === undefined) date = $121a550da83ab3b1$var$util.date.getDate();
            return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
        },
        /**
     * @return [String] the date in RFC 822 format
     */ rfc822: function rfc822(date) {
            if (date === undefined) date = $121a550da83ab3b1$var$util.date.getDate();
            return date.toUTCString();
        },
        /**
     * @return [Integer] the UNIX timestamp value for the current time
     */ unixTimestamp: function unixTimestamp(date) {
            if (date === undefined) date = $121a550da83ab3b1$var$util.date.getDate();
            return date.getTime() / 1000;
        },
        /**
     * @param [String,number,Date] date
     * @return [Date]
     */ from: function format(date) {
            if (typeof date === 'number') return new Date(date * 1000); // unix timestamp
            else return new Date(date);
        },
        /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */ format: function format(date, formatter) {
            if (!formatter) formatter = 'iso8601';
            return $121a550da83ab3b1$var$util.date[formatter]($121a550da83ab3b1$var$util.date.from(date));
        },
        parseTimestamp: function parseTimestamp(value) {
            if (typeof value === 'number') return new Date(value * 1000);
            else if (value.match(/^\d+$/)) return new Date(value * 1000);
            else if (value.match(/^\d{4}/)) return new Date(value);
            else if (value.match(/^\w{3},/)) return new Date(value);
            else throw $121a550da83ab3b1$var$util.error(new Error('unhandled timestamp format: ' + value), {
                code: 'TimestampParserError'
            });
        }
    },
    crypto: {
        crc32Table: [
            0x00000000,
            0x77073096,
            0xEE0E612C,
            0x990951BA,
            0x076DC419,
            0x706AF48F,
            0xE963A535,
            0x9E6495A3,
            0x0EDB8832,
            0x79DCB8A4,
            0xE0D5E91E,
            0x97D2D988,
            0x09B64C2B,
            0x7EB17CBD,
            0xE7B82D07,
            0x90BF1D91,
            0x1DB71064,
            0x6AB020F2,
            0xF3B97148,
            0x84BE41DE,
            0x1ADAD47D,
            0x6DDDE4EB,
            0xF4D4B551,
            0x83D385C7,
            0x136C9856,
            0x646BA8C0,
            0xFD62F97A,
            0x8A65C9EC,
            0x14015C4F,
            0x63066CD9,
            0xFA0F3D63,
            0x8D080DF5,
            0x3B6E20C8,
            0x4C69105E,
            0xD56041E4,
            0xA2677172,
            0x3C03E4D1,
            0x4B04D447,
            0xD20D85FD,
            0xA50AB56B,
            0x35B5A8FA,
            0x42B2986C,
            0xDBBBC9D6,
            0xACBCF940,
            0x32D86CE3,
            0x45DF5C75,
            0xDCD60DCF,
            0xABD13D59,
            0x26D930AC,
            0x51DE003A,
            0xC8D75180,
            0xBFD06116,
            0x21B4F4B5,
            0x56B3C423,
            0xCFBA9599,
            0xB8BDA50F,
            0x2802B89E,
            0x5F058808,
            0xC60CD9B2,
            0xB10BE924,
            0x2F6F7C87,
            0x58684C11,
            0xC1611DAB,
            0xB6662D3D,
            0x76DC4190,
            0x01DB7106,
            0x98D220BC,
            0xEFD5102A,
            0x71B18589,
            0x06B6B51F,
            0x9FBFE4A5,
            0xE8B8D433,
            0x7807C9A2,
            0x0F00F934,
            0x9609A88E,
            0xE10E9818,
            0x7F6A0DBB,
            0x086D3D2D,
            0x91646C97,
            0xE6635C01,
            0x6B6B51F4,
            0x1C6C6162,
            0x856530D8,
            0xF262004E,
            0x6C0695ED,
            0x1B01A57B,
            0x8208F4C1,
            0xF50FC457,
            0x65B0D9C6,
            0x12B7E950,
            0x8BBEB8EA,
            0xFCB9887C,
            0x62DD1DDF,
            0x15DA2D49,
            0x8CD37CF3,
            0xFBD44C65,
            0x4DB26158,
            0x3AB551CE,
            0xA3BC0074,
            0xD4BB30E2,
            0x4ADFA541,
            0x3DD895D7,
            0xA4D1C46D,
            0xD3D6F4FB,
            0x4369E96A,
            0x346ED9FC,
            0xAD678846,
            0xDA60B8D0,
            0x44042D73,
            0x33031DE5,
            0xAA0A4C5F,
            0xDD0D7CC9,
            0x5005713C,
            0x270241AA,
            0xBE0B1010,
            0xC90C2086,
            0x5768B525,
            0x206F85B3,
            0xB966D409,
            0xCE61E49F,
            0x5EDEF90E,
            0x29D9C998,
            0xB0D09822,
            0xC7D7A8B4,
            0x59B33D17,
            0x2EB40D81,
            0xB7BD5C3B,
            0xC0BA6CAD,
            0xEDB88320,
            0x9ABFB3B6,
            0x03B6E20C,
            0x74B1D29A,
            0xEAD54739,
            0x9DD277AF,
            0x04DB2615,
            0x73DC1683,
            0xE3630B12,
            0x94643B84,
            0x0D6D6A3E,
            0x7A6A5AA8,
            0xE40ECF0B,
            0x9309FF9D,
            0x0A00AE27,
            0x7D079EB1,
            0xF00F9344,
            0x8708A3D2,
            0x1E01F268,
            0x6906C2FE,
            0xF762575D,
            0x806567CB,
            0x196C3671,
            0x6E6B06E7,
            0xFED41B76,
            0x89D32BE0,
            0x10DA7A5A,
            0x67DD4ACC,
            0xF9B9DF6F,
            0x8EBEEFF9,
            0x17B7BE43,
            0x60B08ED5,
            0xD6D6A3E8,
            0xA1D1937E,
            0x38D8C2C4,
            0x4FDFF252,
            0xD1BB67F1,
            0xA6BC5767,
            0x3FB506DD,
            0x48B2364B,
            0xD80D2BDA,
            0xAF0A1B4C,
            0x36034AF6,
            0x41047A60,
            0xDF60EFC3,
            0xA867DF55,
            0x316E8EEF,
            0x4669BE79,
            0xCB61B38C,
            0xBC66831A,
            0x256FD2A0,
            0x5268E236,
            0xCC0C7795,
            0xBB0B4703,
            0x220216B9,
            0x5505262F,
            0xC5BA3BBE,
            0xB2BD0B28,
            0x2BB45A92,
            0x5CB36A04,
            0xC2D7FFA7,
            0xB5D0CF31,
            0x2CD99E8B,
            0x5BDEAE1D,
            0x9B64C2B0,
            0xEC63F226,
            0x756AA39C,
            0x026D930A,
            0x9C0906A9,
            0xEB0E363F,
            0x72076785,
            0x05005713,
            0x95BF4A82,
            0xE2B87A14,
            0x7BB12BAE,
            0x0CB61B38,
            0x92D28E9B,
            0xE5D5BE0D,
            0x7CDCEFB7,
            0x0BDBDF21,
            0x86D3D2D4,
            0xF1D4E242,
            0x68DDB3F8,
            0x1FDA836E,
            0x81BE16CD,
            0xF6B9265B,
            0x6FB077E1,
            0x18B74777,
            0x88085AE6,
            0xFF0F6A70,
            0x66063BCA,
            0x11010B5C,
            0x8F659EFF,
            0xF862AE69,
            0x616BFFD3,
            0x166CCF45,
            0xA00AE278,
            0xD70DD2EE,
            0x4E048354,
            0x3903B3C2,
            0xA7672661,
            0xD06016F7,
            0x4969474D,
            0x3E6E77DB,
            0xAED16A4A,
            0xD9D65ADC,
            0x40DF0B66,
            0x37D83BF0,
            0xA9BCAE53,
            0xDEBB9EC5,
            0x47B2CF7F,
            0x30B5FFE9,
            0xBDBDF21C,
            0xCABAC28A,
            0x53B39330,
            0x24B4A3A6,
            0xBAD03605,
            0xCDD70693,
            0x54DE5729,
            0x23D967BF,
            0xB3667A2E,
            0xC4614AB8,
            0x5D681B02,
            0x2A6F2B94,
            0xB40BBE37,
            0xC30C8EA1,
            0x5A05DF1B,
            0x2D02EF8D
        ],
        crc32: function crc32(data) {
            var tbl = $121a550da83ab3b1$var$util.crypto.crc32Table;
            var crc = -1;
            if (typeof data === 'string') data = $121a550da83ab3b1$var$util.buffer.toBuffer(data);
            for(var i = 0; i < data.length; i++){
                var code = data.readUInt8(i);
                crc = crc >>> 8 ^ tbl[(crc ^ code) & 0xFF];
            }
            return (crc ^ -1) >>> 0;
        },
        hmac: function hmac(key, string, digest, fn) {
            if (!digest) digest = 'binary';
            if (digest === 'buffer') digest = undefined;
            if (!fn) fn = 'sha256';
            if (typeof string === 'string') string = $121a550da83ab3b1$var$util.buffer.toBuffer(string);
            return $121a550da83ab3b1$var$util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
        },
        md5: function md5(data, digest, callback) {
            return $121a550da83ab3b1$var$util.crypto.hash('md5', data, digest, callback);
        },
        sha256: function sha256(data, digest, callback) {
            return $121a550da83ab3b1$var$util.crypto.hash('sha256', data, digest, callback);
        },
        hash: function(algorithm, data, digest, callback) {
            var hash = $121a550da83ab3b1$var$util.crypto.createHash(algorithm);
            if (!digest) digest = 'binary';
            if (digest === 'buffer') digest = undefined;
            if (typeof data === 'string') data = $121a550da83ab3b1$var$util.buffer.toBuffer(data);
            var sliceFn = $121a550da83ab3b1$var$util.arraySliceFn(data);
            var isBuffer = $121a550da83ab3b1$var$util.Buffer.isBuffer(data);
            //Identifying objects with an ArrayBuffer as buffers
            if ($121a550da83ab3b1$var$util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
            if (callback && typeof data === 'object' && typeof data.on === 'function' && !isBuffer) {
                data.on('data', function(chunk) {
                    hash.update(chunk);
                });
                data.on('error', function(err) {
                    callback(err);
                });
                data.on('end', function() {
                    callback(null, hash.digest(digest));
                });
            } else if (callback && sliceFn && !isBuffer && typeof FileReader !== 'undefined') {
                // this might be a File/Blob
                var index = 0, size = 524288;
                var reader = new FileReader();
                reader.onerror = function() {
                    callback(new Error('Failed to read data.'));
                };
                reader.onload = function() {
                    var buf = new $121a550da83ab3b1$var$util.Buffer(new Uint8Array(reader.result));
                    hash.update(buf);
                    index += buf.length;
                    reader._continueReading();
                };
                reader._continueReading = function() {
                    if (index >= data.size) {
                        callback(null, hash.digest(digest));
                        return;
                    }
                    var back = index + size;
                    if (back > data.size) back = data.size;
                    reader.readAsArrayBuffer(sliceFn.call(data, index, back));
                };
                reader._continueReading();
            } else {
                if ($121a550da83ab3b1$var$util.isBrowser() && typeof data === 'object' && !isBuffer) data = new $121a550da83ab3b1$var$util.Buffer(new Uint8Array(data));
                var out = hash.update(data).digest(digest);
                if (callback) callback(null, out);
                return out;
            }
        },
        toHex: function toHex(data) {
            var out = [];
            for(var i = 0; i < data.length; i++)out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
            return out.join('');
        },
        createHash: function createHash(algorithm) {
            return $121a550da83ab3b1$var$util.crypto.lib.createHash(algorithm);
        }
    },
    /** @!ignore */ /* Abort constant */ abort: {},
    each: function each(object, iterFunction) {
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) {
            var ret = iterFunction.call(this, key, object[key]);
            if (ret === $121a550da83ab3b1$var$util.abort) break;
        }
    },
    arrayEach: function arrayEach(array, iterFunction) {
        for(var idx in array)if (Object.prototype.hasOwnProperty.call(array, idx)) {
            var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
            if (ret === $121a550da83ab3b1$var$util.abort) break;
        }
    },
    update: function update(obj1, obj2) {
        $121a550da83ab3b1$var$util.each(obj2, function iterator(key, item) {
            obj1[key] = item;
        });
        return obj1;
    },
    merge: function merge(obj1, obj2) {
        return $121a550da83ab3b1$var$util.update($121a550da83ab3b1$var$util.copy(obj1), obj2);
    },
    copy: function copy(object) {
        if (object === null || object === undefined) return object;
        var dupe = {};
        // jshint forin:false
        for(var key in object)dupe[key] = object[key];
        return dupe;
    },
    isEmpty: function isEmpty(obj) {
        for(var prop in obj){
            if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
        }
        return true;
    },
    arraySliceFn: function arraySliceFn(obj) {
        var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
        return typeof fn === 'function' ? fn : null;
    },
    isType: function isType(obj, type) {
        // handle cross-"frame" objects
        if (typeof type === 'function') type = $121a550da83ab3b1$var$util.typeName(type);
        return Object.prototype.toString.call(obj) === '[object ' + type + ']';
    },
    typeName: function typeName(type) {
        if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
        var str = type.toString();
        var match = str.match(/^\s*function (.+)\(/);
        return match ? match[1] : str;
    },
    error: function error(err, options) {
        var originalError = null;
        if (typeof err.message === 'string' && err.message !== '') {
            if (typeof options === 'string' || options && options.message) {
                originalError = $121a550da83ab3b1$var$util.copy(err);
                originalError.message = err.message;
            }
        }
        err.message = err.message || null;
        if (typeof options === 'string') err.message = options;
        else if (typeof options === 'object' && options !== null) {
            $121a550da83ab3b1$var$util.update(err, options);
            if (options.message) err.message = options.message;
            if (options.code || options.name) err.code = options.code || options.name;
            if (options.stack) err.stack = options.stack;
        }
        if (typeof Object.defineProperty === 'function') {
            Object.defineProperty(err, 'name', {
                writable: true,
                enumerable: false
            });
            Object.defineProperty(err, 'message', {
                enumerable: true
            });
        }
        err.name = String(options && options.name || err.name || err.code || 'Error');
        err.time = new Date();
        if (originalError) err.originalError = originalError;
        for(var key in options || {})if (key[0] === '[' && key[key.length - 1] === ']') {
            key = key.slice(1, -1);
            if (key === 'code' || key === 'message') continue;
            err['[' + key + ']'] = 'See error.' + key + ' for details.';
            Object.defineProperty(err, key, {
                value: err[key] || options && options[key] || originalError && originalError[key],
                enumerable: false,
                writable: true
            });
        }
        return err;
    },
    /**
   * @api private
   */ inherit: function inherit(klass, features) {
        var newObject = null;
        if (features === undefined) {
            features = klass;
            klass = Object;
            newObject = {};
        } else {
            var ctor = function ConstructorWrapper() {};
            ctor.prototype = klass.prototype;
            newObject = new ctor();
        }
        // constructor not supplied, create pass-through ctor
        if (features.constructor === Object) features.constructor = function() {
            if (klass !== Object) return klass.apply(this, arguments);
        };
        features.constructor.prototype = newObject;
        $121a550da83ab3b1$var$util.update(features.constructor.prototype, features);
        features.constructor.__super__ = klass;
        return features.constructor;
    },
    /**
   * @api private
   */ mixin: function mixin() {
        var klass = arguments[0];
        for(var i = 1; i < arguments.length; i++)// jshint forin:false
        for(var prop in arguments[i].prototype){
            var fn = arguments[i].prototype[prop];
            if (prop !== 'constructor') klass.prototype[prop] = fn;
        }
        return klass;
    },
    /**
   * @api private
   */ hideProperties: function hideProperties(obj, props) {
        if (typeof Object.defineProperty !== 'function') return;
        $121a550da83ab3b1$var$util.arrayEach(props, function(key) {
            Object.defineProperty(obj, key, {
                enumerable: false,
                writable: true,
                configurable: true
            });
        });
    },
    /**
   * @api private
   */ property: function property(obj, name, value, enumerable, isValue) {
        var opts = {
            configurable: true,
            enumerable: enumerable !== undefined ? enumerable : true
        };
        if (typeof value === 'function' && !isValue) opts.get = value;
        else {
            opts.value = value;
            opts.writable = true;
        }
        Object.defineProperty(obj, name, opts);
    },
    /**
   * @api private
   */ memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
        var cachedValue = null;
        // build enumerable attribute for each value with lazy accessor.
        $121a550da83ab3b1$var$util.property(obj, name, function() {
            if (cachedValue === null) cachedValue = get();
            return cachedValue;
        }, enumerable);
    },
    /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */ hoistPayloadMember: function hoistPayloadMember(resp) {
        var req = resp.request;
        var operationName = req.operation;
        var operation = req.service.api.operations[operationName];
        var output = operation.output;
        if (output.payload && !operation.hasEventOutput) {
            var payloadMember = output.members[output.payload];
            var responsePayload = resp.data[output.payload];
            if (payloadMember.type === 'structure') $121a550da83ab3b1$var$util.each(responsePayload, function(key, value) {
                $121a550da83ab3b1$var$util.property(resp.data, key, value, false);
            });
        }
    },
    /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */ computeSha256: function computeSha256(body, done) {
        if ($121a550da83ab3b1$var$util.isNode()) {
            var Stream = $121a550da83ab3b1$var$util.stream.Stream;
            var fs = (parcelRequire("dluwd"));
            if (typeof Stream === 'function' && body instanceof Stream) {
                if (typeof body.path === 'string') {
                    var settings = {};
                    if (typeof body.start === 'number') settings.start = body.start;
                    if (typeof body.end === 'number') settings.end = body.end;
                    body = fs.createReadStream(body.path, settings);
                } else return done(new Error("Non-file stream objects are not supported with SigV4"));
            }
        }
        $121a550da83ab3b1$var$util.crypto.sha256(body, 'hex', function(err, sha) {
            if (err) done(err);
            else done(null, sha);
        });
    },
    /**
   * @api private
   */ isClockSkewed: function isClockSkewed(serverTime) {
        if (serverTime) {
            $121a550da83ab3b1$var$util.property($121a550da83ab3b1$var$AWS.config, 'isClockSkewed', Math.abs(new Date().getTime() - serverTime) >= 300000, false);
            return $121a550da83ab3b1$var$AWS.config.isClockSkewed;
        }
    },
    applyClockOffset: function applyClockOffset(serverTime) {
        if (serverTime) $121a550da83ab3b1$var$AWS.config.systemClockOffset = serverTime - new Date().getTime();
    },
    /**
   * @api private
   */ extractRequestId: function extractRequestId(resp) {
        var requestId = resp.httpResponse.headers['x-amz-request-id'] || resp.httpResponse.headers['x-amzn-requestid'];
        if (!requestId && resp.data && resp.data.ResponseMetadata) requestId = resp.data.ResponseMetadata.RequestId;
        if (requestId) resp.requestId = requestId;
        if (resp.error) resp.error.requestId = requestId;
    },
    /**
   * @api private
   */ addPromises: function addPromises(constructors, PromiseDependency) {
        var deletePromises = false;
        if (PromiseDependency === undefined && $121a550da83ab3b1$var$AWS && $121a550da83ab3b1$var$AWS.config) PromiseDependency = $121a550da83ab3b1$var$AWS.config.getPromisesDependency();
        if (PromiseDependency === undefined && typeof Promise !== 'undefined') PromiseDependency = Promise;
        if (typeof PromiseDependency !== 'function') deletePromises = true;
        if (!Array.isArray(constructors)) constructors = [
            constructors
        ];
        for(var ind = 0; ind < constructors.length; ind++){
            var constructor = constructors[ind];
            if (deletePromises) {
                if (constructor.deletePromisesFromClass) constructor.deletePromisesFromClass();
            } else if (constructor.addPromisesToClass) constructor.addPromisesToClass(PromiseDependency);
        }
    },
    /**
   * @api private
   * Return a function that will return a promise whose fate is decided by the
   * callback behavior of the given method with `methodName`. The method to be
   * promisified should conform to node.js convention of accepting a callback as
   * last argument and calling that callback with error as the first argument
   * and success value on the second argument.
   */ promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
        return function promise() {
            var self = this;
            var args = Array.prototype.slice.call(arguments);
            return new PromiseDependency(function(resolve, reject) {
                args.push(function(err, data) {
                    if (err) reject(err);
                    else resolve(data);
                });
                self[methodName].apply(self, args);
            });
        };
    },
    /**
   * @api private
   */ isDualstackAvailable: function isDualstackAvailable(service) {
        if (!service) return false;
        var metadata = (parcelRequire("8k6fM"));
        if (typeof service !== 'string') service = service.serviceIdentifier;
        if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
        return !!metadata[service].dualstackAvailable;
    },
    /**
   * @api private
   */ calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions, err) {
        if (!retryDelayOptions) retryDelayOptions = {};
        var customBackoff = retryDelayOptions.customBackoff || null;
        if (typeof customBackoff === 'function') return customBackoff(retryCount, err);
        var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
        var delay = Math.random() * (Math.pow(2, retryCount) * base);
        return delay;
    },
    /**
   * @api private
   */ handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
        if (!options) options = {};
        var http = $121a550da83ab3b1$var$AWS.HttpClient.getInstance();
        var httpOptions = options.httpOptions || {};
        var retryCount = 0;
        var errCallback = function(err) {
            var maxRetries = options.maxRetries || 0;
            if (err && err.code === 'TimeoutError') err.retryable = true;
            // Call `calculateRetryDelay()` only when relevant, see #3401
            if (err && err.retryable && retryCount < maxRetries) {
                var delay = $121a550da83ab3b1$var$util.calculateRetryDelay(retryCount, options.retryDelayOptions, err);
                if (delay >= 0) {
                    retryCount++;
                    setTimeout(sendRequest, delay + (err.retryAfter || 0));
                    return;
                }
            }
            cb(err);
        };
        var sendRequest = function() {
            var data = '';
            http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
                httpResponse.on('data', function(chunk) {
                    data += chunk.toString();
                });
                httpResponse.on('end', function() {
                    var statusCode = httpResponse.statusCode;
                    if (statusCode < 300) cb(null, data);
                    else {
                        var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
                        var err = $121a550da83ab3b1$var$util.error(new Error(), {
                            statusCode: statusCode,
                            retryable: statusCode >= 500 || statusCode === 429
                        });
                        if (retryAfter && err.retryable) err.retryAfter = retryAfter;
                        errCallback(err);
                    }
                });
            }, errCallback);
        };
        $121a550da83ab3b1$var$AWS.util.defer(sendRequest);
    },
    /**
   * @api private
   */ uuid: {
        v4: function uuidV4() {
            return (parcelRequire("if7n2")).default();
        }
    },
    /**
   * @api private
   */ convertPayloadToString: function convertPayloadToString(resp) {
        var req = resp.request;
        var operation = req.operation;
        var rules = req.service.api.operations[operation].output || {};
        if (rules.payload && resp.data[rules.payload]) resp.data[rules.payload] = resp.data[rules.payload].toString();
    },
    /**
   * @api private
   */ defer: function defer(callback) {
        if (typeof setImmediate === 'function') setImmediate(callback);
        else setTimeout(callback, 0);
    },
    /**
   * @api private
   */ getRequestPayloadShape: function getRequestPayloadShape(req) {
        var operations = req.service.api.operations;
        if (!operations) return undefined;
        var operation = (operations || {})[req.operation];
        if (!operation || !operation.input || !operation.input.payload) return undefined;
        return operation.input.members[operation.input.payload];
    },
    getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
        var profiles = {};
        var profilesFromConfig = {};
        if ($89WEd.env[$121a550da83ab3b1$var$util.configOptInEnv]) var profilesFromConfig = iniLoader.loadFrom({
            isConfig: true,
            filename: $89WEd.env[$121a550da83ab3b1$var$util.sharedConfigFileEnv]
        });
        var profilesFromCreds = {};
        try {
            var profilesFromCreds = iniLoader.loadFrom({
                filename: filename || $89WEd.env[$121a550da83ab3b1$var$util.configOptInEnv] && $89WEd.env[$121a550da83ab3b1$var$util.sharedCredentialsFileEnv]
            });
        } catch (error) {
            // if using config, assume it is fully descriptive without a credentials file:
            if (!$89WEd.env[$121a550da83ab3b1$var$util.configOptInEnv]) throw error;
        }
        for(var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++)profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromConfig[profileNames[i]]);
        for(var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++)profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromCreds[profileNames[i]]);
        return profiles;
        /**
     * Roughly the semantics of `Object.assign(target, source)`
     */ function objectAssign(target, source) {
            for(var i = 0, keys = Object.keys(source); i < keys.length; i++)target[keys[i]] = source[keys[i]];
            return target;
        }
    },
    /**
   * @api private
   */ ARN: {
        validate: function validateARN(str) {
            return str && str.indexOf('arn:') === 0 && str.split(':').length >= 6;
        },
        parse: function parseARN(arn) {
            var matched = arn.split(':');
            return {
                partition: matched[1],
                service: matched[2],
                region: matched[3],
                accountId: matched[4],
                resource: matched.slice(5).join(':')
            };
        },
        build: function buildARN(arnObject) {
            if (arnObject.service === undefined || arnObject.region === undefined || arnObject.accountId === undefined || arnObject.resource === undefined) throw $121a550da83ab3b1$var$util.error(new Error('Input ARN object is invalid'));
            return 'arn:' + (arnObject.partition || 'aws') + ':' + arnObject.service + ':' + arnObject.region + ':' + arnObject.accountId + ':' + arnObject.resource;
        }
    },
    /**
   * @api private
   */ defaultProfile: 'default',
    /**
   * @api private
   */ configOptInEnv: 'AWS_SDK_LOAD_CONFIG',
    /**
   * @api private
   */ sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',
    /**
   * @api private
   */ sharedConfigFileEnv: 'AWS_CONFIG_FILE',
    /**
   * @api private
   */ imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
};
/**
 * @api private
 */ module.exports = $121a550da83ab3b1$var$util;

});
parcelRegister("e2mZ5", function(module, exports) {
/**
 * The main AWS namespace
 */ 
var $a38314cf182c5897$var$AWS = {
    util: (parcelRequire("1ymo4"))
};
/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */ var $a38314cf182c5897$var$_hidden = {};
$a38314cf182c5897$var$_hidden.toString(); // hack to parse macro
/**
 * @api private
 */ module.exports = $a38314cf182c5897$var$AWS;















$a38314cf182c5897$var$AWS.util.update($a38314cf182c5897$var$AWS, {
    /**
   * @constant
   */ VERSION: '2.1693.0',
    /**
   * @api private
   */ Signers: {},
    /**
   * @api private
   */ Protocol: {
        Json: (parcelRequire("iOHL8")),
        Query: (parcelRequire("9yfKy")),
        Rest: (parcelRequire("14bAM")),
        RestJson: (parcelRequire("2ZRi9")),
        RestXml: (parcelRequire("lSJkz"))
    },
    /**
   * @api private
   */ XML: {
        Builder: (parcelRequire("9LU6q")),
        Parser: null // conditionally set based on environment
    },
    /**
   * @api private
   */ JSON: {
        Builder: (parcelRequire("liGav")),
        Parser: (parcelRequire("6R1kV"))
    },
    /**
   * @api private
   */ Model: {
        Api: (parcelRequire("ewGti")),
        Operation: (parcelRequire("ldrzu")),
        Shape: (parcelRequire("dYWAN")),
        Paginator: (parcelRequire("6mQ8f")),
        ResourceWaiter: (parcelRequire("abtYM"))
    },
    /**
   * @api private
   */ apiLoader: (parcelRequire("5T6Re")),
    /**
   * @api private
   */ EndpointCache: (parcelRequire("14xpY")).EndpointCache
});
parcelRequire("9WcNx");
parcelRequire("7jEum");
parcelRequire("43MiT");
parcelRequire("6UNOb");
parcelRequire("23Avo");
parcelRequire("7GHSW");
parcelRequire("4wnK2");
parcelRequire("izIGu");
parcelRequire("7XmUC");
parcelRequire("lJJIP");
parcelRequire("c97pA");
/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */ $a38314cf182c5897$var$AWS.events = new $a38314cf182c5897$var$AWS.SequentialExecutor();
//create endpoint cache lazily
$a38314cf182c5897$var$AWS.util.memoizedProperty($a38314cf182c5897$var$AWS, 'endpointCache', function() {
    return new $a38314cf182c5897$var$AWS.EndpointCache($a38314cf182c5897$var$AWS.config.endpointCacheSize);
}, true);

});
parcelRegister("iOHL8", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $liGav = parcelRequire("liGav");

var $6R1kV = parcelRequire("6R1kV");

var $43c8b = parcelRequire("43c8b");
var $db2ed7331416dd0c$require$populateHostPrefix = $43c8b.populateHostPrefix;
function $db2ed7331416dd0c$var$buildRequest(req) {
    var httpRequest = req.httpRequest;
    var api = req.service.api;
    var target = api.targetPrefix + '.' + api.operations[req.operation].name;
    var version = api.jsonVersion || '1.0';
    var input = api.operations[req.operation].input;
    var builder = new $liGav();
    if (version === 1) version = '1.0';
    if (api.awsQueryCompatible) {
        if (!httpRequest.params) httpRequest.params = {};
        // because Query protocol does this.
        Object.assign(httpRequest.params, req.params);
    }
    httpRequest.body = builder.build(req.params || {}, input);
    httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
    httpRequest.headers['X-Amz-Target'] = target;
    $db2ed7331416dd0c$require$populateHostPrefix(req);
}
function $db2ed7331416dd0c$var$extractError(resp) {
    var error = {};
    var httpResponse = resp.httpResponse;
    error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
    if (typeof error.code === 'string') error.code = error.code.split(':')[0];
    if (httpResponse.body.length > 0) try {
        var e = JSON.parse(httpResponse.body.toString());
        var code = e.__type || e.code || e.Code;
        if (code) error.code = code.split('#').pop();
        if (error.code === 'RequestEntityTooLarge') error.message = 'Request body must be less than 1 MB';
        else error.message = e.message || e.Message || null;
        // The minimized models do not have error shapes, so
        // without expanding the model size, it's not possible
        // to validate the response shape (members) or
        // check if any are sensitive to logging.
        // Assign the fields as non-enumerable, allowing specific access only.
        for(var key in e || {}){
            if (key === 'code' || key === 'message') continue;
            error['[' + key + ']'] = 'See error.' + key + ' for details.';
            Object.defineProperty(error, key, {
                value: e[key],
                enumerable: false,
                writable: true
            });
        }
    } catch (e) {
        error.statusCode = httpResponse.statusCode;
        error.message = httpResponse.statusMessage;
    }
    else {
        error.statusCode = httpResponse.statusCode;
        error.message = httpResponse.statusCode.toString();
    }
    resp.error = $1ymo4.error(new Error(), error);
}
function $db2ed7331416dd0c$var$extractData(resp) {
    var body = resp.httpResponse.body.toString() || '{}';
    if (resp.request.service.config.convertResponseTypes === false) resp.data = JSON.parse(body);
    else {
        var operation = resp.request.service.api.operations[resp.request.operation];
        var shape = operation.output || {};
        var parser = new $6R1kV();
        resp.data = parser.parse(body, shape);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $db2ed7331416dd0c$var$buildRequest,
    extractError: $db2ed7331416dd0c$var$extractError,
    extractData: $db2ed7331416dd0c$var$extractData
};

});
parcelRegister("liGav", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
function $f81bfd2c2a83d309$var$JsonBuilder() {}
$f81bfd2c2a83d309$var$JsonBuilder.prototype.build = function(value, shape) {
    return JSON.stringify($f81bfd2c2a83d309$var$translate(value, shape));
};
function $f81bfd2c2a83d309$var$translate(value, shape) {
    if (!shape || value === undefined || value === null) return undefined;
    switch(shape.type){
        case 'structure':
            return $f81bfd2c2a83d309$var$translateStructure(value, shape);
        case 'map':
            return $f81bfd2c2a83d309$var$translateMap(value, shape);
        case 'list':
            return $f81bfd2c2a83d309$var$translateList(value, shape);
        default:
            return $f81bfd2c2a83d309$var$translateScalar(value, shape);
    }
}
function $f81bfd2c2a83d309$var$translateStructure(structure, shape) {
    if (shape.isDocument) return structure;
    var struct = {};
    $1ymo4.each(structure, function(name, value) {
        var memberShape = shape.members[name];
        if (memberShape) {
            if (memberShape.location !== 'body') return;
            var locationName = memberShape.isLocationName ? memberShape.name : name;
            var result = $f81bfd2c2a83d309$var$translate(value, memberShape);
            if (result !== undefined) struct[locationName] = result;
        }
    });
    return struct;
}
function $f81bfd2c2a83d309$var$translateList(list, shape) {
    var out = [];
    $1ymo4.arrayEach(list, function(value) {
        var result = $f81bfd2c2a83d309$var$translate(value, shape.member);
        if (result !== undefined) out.push(result);
    });
    return out;
}
function $f81bfd2c2a83d309$var$translateMap(map, shape) {
    var out = {};
    $1ymo4.each(map, function(key, value) {
        var result = $f81bfd2c2a83d309$var$translate(value, shape.value);
        if (result !== undefined) out[key] = result;
    });
    return out;
}
function $f81bfd2c2a83d309$var$translateScalar(value, shape) {
    return shape.toWireFormat(value);
}
/**
 * @api private
 */ module.exports = $f81bfd2c2a83d309$var$JsonBuilder;

});

parcelRegister("6R1kV", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
function $4fd8bab142b71cc1$var$JsonParser() {}
$4fd8bab142b71cc1$var$JsonParser.prototype.parse = function(value, shape) {
    return $4fd8bab142b71cc1$var$translate(JSON.parse(value), shape);
};
function $4fd8bab142b71cc1$var$translate(value, shape) {
    if (!shape || value === undefined) return undefined;
    switch(shape.type){
        case 'structure':
            return $4fd8bab142b71cc1$var$translateStructure(value, shape);
        case 'map':
            return $4fd8bab142b71cc1$var$translateMap(value, shape);
        case 'list':
            return $4fd8bab142b71cc1$var$translateList(value, shape);
        default:
            return $4fd8bab142b71cc1$var$translateScalar(value, shape);
    }
}
function $4fd8bab142b71cc1$var$translateStructure(structure, shape) {
    if (structure == null) return undefined;
    if (shape.isDocument) return structure;
    var struct = {};
    var shapeMembers = shape.members;
    var isAwsQueryCompatible = shape.api && shape.api.awsQueryCompatible;
    $1ymo4.each(shapeMembers, function(name, memberShape) {
        var locationName = memberShape.isLocationName ? memberShape.name : name;
        if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
            var value = structure[locationName];
            var result = $4fd8bab142b71cc1$var$translate(value, memberShape);
            if (result !== undefined) struct[name] = result;
        } else if (isAwsQueryCompatible && memberShape.defaultValue) {
            if (memberShape.type === 'list') struct[name] = typeof memberShape.defaultValue === 'function' ? memberShape.defaultValue() : memberShape.defaultValue;
        }
    });
    return struct;
}
function $4fd8bab142b71cc1$var$translateList(list, shape) {
    if (list == null) return undefined;
    var out = [];
    $1ymo4.arrayEach(list, function(value) {
        var result = $4fd8bab142b71cc1$var$translate(value, shape.member);
        if (result === undefined) out.push(null);
        else out.push(result);
    });
    return out;
}
function $4fd8bab142b71cc1$var$translateMap(map, shape) {
    if (map == null) return undefined;
    var out = {};
    $1ymo4.each(map, function(key, value) {
        var result = $4fd8bab142b71cc1$var$translate(value, shape.value);
        if (result === undefined) out[key] = null;
        else out[key] = result;
    });
    return out;
}
function $4fd8bab142b71cc1$var$translateScalar(value, shape) {
    return shape.toType(value);
}
/**
 * @api private
 */ module.exports = $4fd8bab142b71cc1$var$JsonParser;

});

parcelRegister("43c8b", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * Prepend prefix defined by API model to endpoint that's already
 * constructed. This feature does not apply to operations using
 * endpoint discovery and can be disabled.
 * @api private
 */ function $2f30da2f8091edf5$var$populateHostPrefix(request) {
    var enabled = request.service.config.hostPrefixEnabled;
    if (!enabled) return request;
    var operationModel = request.service.api.operations[request.operation];
    //don't marshal host prefix when operation has endpoint discovery traits
    if ($2f30da2f8091edf5$var$hasEndpointDiscover(request)) return request;
    if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
        var hostPrefixNotation = operationModel.endpoint.hostPrefix;
        var hostPrefix = $2f30da2f8091edf5$var$expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
        $2f30da2f8091edf5$var$prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
        $2f30da2f8091edf5$var$validateHostname(request.httpRequest.endpoint.hostname);
    }
    return request;
}
/**
 * @api private
 */ function $2f30da2f8091edf5$var$hasEndpointDiscover(request) {
    var api = request.service.api;
    var operationModel = api.operations[request.operation];
    var isEndpointOperation = api.endpointOperation && api.endpointOperation === $1ymo4.string.lowerFirst(operationModel.name);
    return operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true;
}
/**
 * @api private
 */ function $2f30da2f8091edf5$var$expandHostPrefix(hostPrefixNotation, params, shape) {
    $1ymo4.each(shape.members, function(name, member) {
        if (member.hostLabel === true) {
            if (typeof params[name] !== 'string' || params[name] === '') throw $1ymo4.error(new Error(), {
                message: 'Parameter ' + name + ' should be a non-empty string.',
                code: 'InvalidParameter'
            });
            var regex = new RegExp('\\{' + name + '\\}', 'g');
            hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
        }
    });
    return hostPrefixNotation;
}
/**
 * @api private
 */ function $2f30da2f8091edf5$var$prependEndpointPrefix(endpoint, prefix) {
    if (endpoint.host) endpoint.host = prefix + endpoint.host;
    if (endpoint.hostname) endpoint.hostname = prefix + endpoint.hostname;
}
/**
 * @api private
 */ function $2f30da2f8091edf5$var$validateHostname(hostname) {
    var labels = hostname.split('.');
    //Reference: https://tools.ietf.org/html/rfc1123#section-2
    var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
    $1ymo4.arrayEach(labels, function(label) {
        if (!label.length || label.length < 1 || label.length > 63) throw $1ymo4.error(new Error(), {
            code: 'ValidationError',
            message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
        });
        if (!hostPattern.test(label)) throw $e2mZ5.util.error(new Error(), {
            code: 'ValidationError',
            message: label + ' is not hostname compatible.'
        });
    });
}
module.exports = {
    populateHostPrefix: $2f30da2f8091edf5$var$populateHostPrefix
};

});


parcelRegister("9yfKy", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $1ymo4 = parcelRequire("1ymo4");

var $dxafe = parcelRequire("dxafe");

var $dYWAN = parcelRequire("dYWAN");

var $43c8b = parcelRequire("43c8b");
var $6f43819df4326e03$require$populateHostPrefix = $43c8b.populateHostPrefix;
function $6f43819df4326e03$var$buildRequest(req) {
    var operation = req.service.api.operations[req.operation];
    var httpRequest = req.httpRequest;
    httpRequest.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
    httpRequest.params = {
        Version: req.service.api.apiVersion,
        Action: operation.name
    };
    // convert the request parameters into a list of query params,
    // e.g. Deeply.NestedParam.0.Name=value
    var builder = new $dxafe();
    builder.serialize(req.params, operation.input, function(name, value) {
        httpRequest.params[name] = value;
    });
    httpRequest.body = $1ymo4.queryParamsToString(httpRequest.params);
    $6f43819df4326e03$require$populateHostPrefix(req);
}
function $6f43819df4326e03$var$extractError(resp) {
    var data, body = resp.httpResponse.body.toString();
    if (body.match('<UnknownOperationException')) data = {
        Code: 'UnknownOperation',
        Message: 'Unknown operation ' + resp.request.operation
    };
    else try {
        data = new $e2mZ5.XML.Parser().parse(body);
    } catch (e) {
        data = {
            Code: resp.httpResponse.statusCode,
            Message: resp.httpResponse.statusMessage
        };
    }
    if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
    if (data.Errors) data = data.Errors;
    if (data.Error) data = data.Error;
    if (data.Code) resp.error = $1ymo4.error(new Error(), {
        code: data.Code,
        message: data.Message
    });
    else resp.error = $1ymo4.error(new Error(), {
        code: resp.httpResponse.statusCode,
        message: null
    });
}
function $6f43819df4326e03$var$extractData(resp) {
    var req = resp.request;
    var operation = req.service.api.operations[req.operation];
    var shape = operation.output || {};
    var origRules = shape;
    if (origRules.resultWrapper) {
        var tmp = $dYWAN.create({
            type: 'structure'
        });
        tmp.members[origRules.resultWrapper] = shape;
        tmp.memberNames = [
            origRules.resultWrapper
        ];
        $1ymo4.property(shape, 'name', shape.resultWrapper);
        shape = tmp;
    }
    var parser = new $e2mZ5.XML.Parser();
    // TODO: Refactor XML Parser to parse RequestId from response.
    if (shape && shape.members && !shape.members._XAMZRequestId) {
        var requestIdShape = $dYWAN.create({
            type: 'string'
        }, {
            api: {
                protocol: 'query'
            }
        }, 'requestId');
        shape.members._XAMZRequestId = requestIdShape;
    }
    var data = parser.parse(resp.httpResponse.body.toString(), shape);
    resp.requestId = data._XAMZRequestId || data.requestId;
    if (data._XAMZRequestId) delete data._XAMZRequestId;
    if (origRules.resultWrapper) {
        if (data[origRules.resultWrapper]) {
            $1ymo4.update(data, data[origRules.resultWrapper]);
            delete data[origRules.resultWrapper];
        }
    }
    resp.data = data;
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $6f43819df4326e03$var$buildRequest,
    extractError: $6f43819df4326e03$var$extractError,
    extractData: $6f43819df4326e03$var$extractData
};

});
parcelRegister("dxafe", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
function $9da64dce3eba2091$var$QueryParamSerializer() {}
$9da64dce3eba2091$var$QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
    $9da64dce3eba2091$var$serializeStructure('', params, shape, fn);
};
function $9da64dce3eba2091$var$ucfirst(shape) {
    if (shape.isQueryName || shape.api.protocol !== 'ec2') return shape.name;
    else return shape.name[0].toUpperCase() + shape.name.substr(1);
}
function $9da64dce3eba2091$var$serializeStructure(prefix, struct, rules, fn) {
    $1ymo4.each(rules.members, function(name, member) {
        var value = struct[name];
        if (value === null || value === undefined) return;
        var memberName = $9da64dce3eba2091$var$ucfirst(member);
        memberName = prefix ? prefix + '.' + memberName : memberName;
        $9da64dce3eba2091$var$serializeMember(memberName, value, member, fn);
    });
}
function $9da64dce3eba2091$var$serializeMap(name, map, rules, fn) {
    var i = 1;
    $1ymo4.each(map, function(key, value) {
        var prefix = rules.flattened ? '.' : '.entry.';
        var position = prefix + i++ + '.';
        var keyName = position + (rules.key.name || 'key');
        var valueName = position + (rules.value.name || 'value');
        $9da64dce3eba2091$var$serializeMember(name + keyName, key, rules.key, fn);
        $9da64dce3eba2091$var$serializeMember(name + valueName, value, rules.value, fn);
    });
}
function $9da64dce3eba2091$var$serializeList(name, list, rules, fn) {
    var memberRules = rules.member || {};
    if (list.length === 0) {
        if (rules.api.protocol !== 'ec2') fn.call(this, name, null);
        return;
    }
    $1ymo4.arrayEach(list, function(v, n) {
        var suffix = '.' + (n + 1);
        if (rules.api.protocol === 'ec2') // Do nothing for EC2
        suffix = suffix + ''; // make linter happy
        else if (rules.flattened) {
            if (memberRules.name) {
                var parts = name.split('.');
                parts.pop();
                parts.push($9da64dce3eba2091$var$ucfirst(memberRules));
                name = parts.join('.');
            }
        } else suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
        $9da64dce3eba2091$var$serializeMember(name + suffix, v, memberRules, fn);
    });
}
function $9da64dce3eba2091$var$serializeMember(name, value, rules, fn) {
    if (value === null || value === undefined) return;
    if (rules.type === 'structure') $9da64dce3eba2091$var$serializeStructure(name, value, rules, fn);
    else if (rules.type === 'list') $9da64dce3eba2091$var$serializeList(name, value, rules, fn);
    else if (rules.type === 'map') $9da64dce3eba2091$var$serializeMap(name, value, rules, fn);
    else fn(name, rules.toWireFormat(value).toString());
}
/**
 * @api private
 */ module.exports = $9da64dce3eba2091$var$QueryParamSerializer;

});

parcelRegister("dYWAN", function(module, exports) {

var $boi3b = parcelRequire("boi3b");

var $1ymo4 = parcelRequire("1ymo4");
function $a2de5435c00504a4$var$property(obj, name, value) {
    if (value !== null && value !== undefined) $1ymo4.property.apply(this, arguments);
}
function $a2de5435c00504a4$var$memoizedProperty(obj, name) {
    if (!obj.constructor.prototype[name]) $1ymo4.memoizedProperty.apply(this, arguments);
}
function $a2de5435c00504a4$var$Shape(shape, options, memberName) {
    options = options || {};
    $a2de5435c00504a4$var$property(this, 'shape', shape.shape);
    $a2de5435c00504a4$var$property(this, 'api', options.api, false);
    $a2de5435c00504a4$var$property(this, 'type', shape.type);
    $a2de5435c00504a4$var$property(this, 'enum', shape.enum);
    $a2de5435c00504a4$var$property(this, 'min', shape.min);
    $a2de5435c00504a4$var$property(this, 'max', shape.max);
    $a2de5435c00504a4$var$property(this, 'pattern', shape.pattern);
    $a2de5435c00504a4$var$property(this, 'location', shape.location || this.location || 'body');
    $a2de5435c00504a4$var$property(this, 'name', this.name || shape.xmlName || shape.queryName || shape.locationName || memberName);
    $a2de5435c00504a4$var$property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
    $a2de5435c00504a4$var$property(this, 'requiresLength', shape.requiresLength, false);
    $a2de5435c00504a4$var$property(this, 'isComposite', shape.isComposite || false);
    $a2de5435c00504a4$var$property(this, 'isShape', true, false);
    $a2de5435c00504a4$var$property(this, 'isQueryName', Boolean(shape.queryName), false);
    $a2de5435c00504a4$var$property(this, 'isLocationName', Boolean(shape.locationName), false);
    $a2de5435c00504a4$var$property(this, 'isIdempotent', shape.idempotencyToken === true);
    $a2de5435c00504a4$var$property(this, 'isJsonValue', shape.jsonvalue === true);
    $a2de5435c00504a4$var$property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
    $a2de5435c00504a4$var$property(this, 'isEventStream', Boolean(shape.eventstream), false);
    $a2de5435c00504a4$var$property(this, 'isEvent', Boolean(shape.event), false);
    $a2de5435c00504a4$var$property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
    $a2de5435c00504a4$var$property(this, 'isEventHeader', Boolean(shape.eventheader), false);
    $a2de5435c00504a4$var$property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
    $a2de5435c00504a4$var$property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
    $a2de5435c00504a4$var$property(this, 'hostLabel', Boolean(shape.hostLabel), false);
    if (options.documentation) {
        $a2de5435c00504a4$var$property(this, 'documentation', shape.documentation);
        $a2de5435c00504a4$var$property(this, 'documentationUrl', shape.documentationUrl);
    }
    if (shape.xmlAttribute) $a2de5435c00504a4$var$property(this, 'isXmlAttribute', shape.xmlAttribute || false);
    // type conversion and parsing
    $a2de5435c00504a4$var$property(this, 'defaultValue', null);
    this.toWireFormat = function(value) {
        if (value === null || value === undefined) return '';
        return value;
    };
    this.toType = function(value) {
        return value;
    };
}
/**
 * @api private
 */ $a2de5435c00504a4$var$Shape.normalizedTypes = {
    character: 'string',
    double: 'float',
    long: 'integer',
    short: 'integer',
    biginteger: 'integer',
    bigdecimal: 'float',
    blob: 'binary'
};
/**
 * @api private
 */ $a2de5435c00504a4$var$Shape.types = {
    'structure': $a2de5435c00504a4$var$StructureShape,
    'list': $a2de5435c00504a4$var$ListShape,
    'map': $a2de5435c00504a4$var$MapShape,
    'boolean': $a2de5435c00504a4$var$BooleanShape,
    'timestamp': $a2de5435c00504a4$var$TimestampShape,
    'float': $a2de5435c00504a4$var$FloatShape,
    'integer': $a2de5435c00504a4$var$IntegerShape,
    'string': $a2de5435c00504a4$var$StringShape,
    'base64': $a2de5435c00504a4$var$Base64Shape,
    'binary': $a2de5435c00504a4$var$BinaryShape
};
$a2de5435c00504a4$var$Shape.resolve = function resolve(shape, options) {
    if (shape.shape) {
        var refShape = options.api.shapes[shape.shape];
        if (!refShape) throw new Error('Cannot find shape reference: ' + shape.shape);
        return refShape;
    } else return null;
};
$a2de5435c00504a4$var$Shape.create = function create(shape, options, memberName) {
    if (shape.isShape) return shape;
    var refShape = $a2de5435c00504a4$var$Shape.resolve(shape, options);
    if (refShape) {
        var filteredKeys = Object.keys(shape);
        if (!options.documentation) filteredKeys = filteredKeys.filter(function(name) {
            return !name.match(/documentation/);
        });
        // create an inline shape with extra members
        var InlineShape = function() {
            refShape.constructor.call(this, shape, options, memberName);
        };
        InlineShape.prototype = refShape;
        return new InlineShape();
    } else {
        // set type if not set
        if (!shape.type) {
            if (shape.members) shape.type = 'structure';
            else if (shape.member) shape.type = 'list';
            else if (shape.key) shape.type = 'map';
            else shape.type = 'string';
        }
        // normalize types
        var origType = shape.type;
        if ($a2de5435c00504a4$var$Shape.normalizedTypes[shape.type]) shape.type = $a2de5435c00504a4$var$Shape.normalizedTypes[shape.type];
        if ($a2de5435c00504a4$var$Shape.types[shape.type]) return new $a2de5435c00504a4$var$Shape.types[shape.type](shape, options, memberName);
        else throw new Error('Unrecognized shape type: ' + origType);
    }
};
function $a2de5435c00504a4$var$CompositeShape(shape) {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    $a2de5435c00504a4$var$property(this, 'isComposite', true);
    if (shape.flattened) $a2de5435c00504a4$var$property(this, 'flattened', shape.flattened || false);
}
function $a2de5435c00504a4$var$StructureShape(shape, options) {
    var self = this;
    var requiredMap = null, firstInit = !this.isShape;
    $a2de5435c00504a4$var$CompositeShape.apply(this, arguments);
    if (firstInit) {
        $a2de5435c00504a4$var$property(this, 'defaultValue', function() {
            return {};
        });
        $a2de5435c00504a4$var$property(this, 'members', {});
        $a2de5435c00504a4$var$property(this, 'memberNames', []);
        $a2de5435c00504a4$var$property(this, 'required', []);
        $a2de5435c00504a4$var$property(this, 'isRequired', function() {
            return false;
        });
        $a2de5435c00504a4$var$property(this, 'isDocument', Boolean(shape.document));
    }
    if (shape.members) {
        $a2de5435c00504a4$var$property(this, 'members', new $boi3b(shape.members, options, function(name, member) {
            return $a2de5435c00504a4$var$Shape.create(member, options, name);
        }));
        $a2de5435c00504a4$var$memoizedProperty(this, 'memberNames', function() {
            return shape.xmlOrder || Object.keys(shape.members);
        });
        if (shape.event) {
            $a2de5435c00504a4$var$memoizedProperty(this, 'eventPayloadMemberName', function() {
                var members = self.members;
                var memberNames = self.memberNames;
                // iterate over members to find ones that are event payloads
                for(var i = 0, iLen = memberNames.length; i < iLen; i++){
                    if (members[memberNames[i]].isEventPayload) return memberNames[i];
                }
            });
            $a2de5435c00504a4$var$memoizedProperty(this, 'eventHeaderMemberNames', function() {
                var members = self.members;
                var memberNames = self.memberNames;
                var eventHeaderMemberNames = [];
                // iterate over members to find ones that are event headers
                for(var i = 0, iLen = memberNames.length; i < iLen; i++)if (members[memberNames[i]].isEventHeader) eventHeaderMemberNames.push(memberNames[i]);
                return eventHeaderMemberNames;
            });
        }
    }
    if (shape.required) {
        $a2de5435c00504a4$var$property(this, 'required', shape.required);
        $a2de5435c00504a4$var$property(this, 'isRequired', function(name) {
            if (!requiredMap) {
                requiredMap = {};
                for(var i = 0; i < shape.required.length; i++)requiredMap[shape.required[i]] = true;
            }
            return requiredMap[name];
        }, false, true);
    }
    $a2de5435c00504a4$var$property(this, 'resultWrapper', shape.resultWrapper || null);
    if (shape.payload) $a2de5435c00504a4$var$property(this, 'payload', shape.payload);
    if (typeof shape.xmlNamespace === 'string') $a2de5435c00504a4$var$property(this, 'xmlNamespaceUri', shape.xmlNamespace);
    else if (typeof shape.xmlNamespace === 'object') {
        $a2de5435c00504a4$var$property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
        $a2de5435c00504a4$var$property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
    }
}
function $a2de5435c00504a4$var$ListShape(shape, options) {
    var self = this, firstInit = !this.isShape;
    $a2de5435c00504a4$var$CompositeShape.apply(this, arguments);
    if (firstInit) $a2de5435c00504a4$var$property(this, 'defaultValue', function() {
        return [];
    });
    if (shape.member) $a2de5435c00504a4$var$memoizedProperty(this, 'member', function() {
        return $a2de5435c00504a4$var$Shape.create(shape.member, options);
    });
    if (this.flattened) {
        var oldName = this.name;
        $a2de5435c00504a4$var$memoizedProperty(this, 'name', function() {
            return self.member.name || oldName;
        });
    }
}
function $a2de5435c00504a4$var$MapShape(shape, options) {
    var firstInit = !this.isShape;
    $a2de5435c00504a4$var$CompositeShape.apply(this, arguments);
    if (firstInit) {
        $a2de5435c00504a4$var$property(this, 'defaultValue', function() {
            return {};
        });
        $a2de5435c00504a4$var$property(this, 'key', $a2de5435c00504a4$var$Shape.create({
            type: 'string'
        }, options));
        $a2de5435c00504a4$var$property(this, 'value', $a2de5435c00504a4$var$Shape.create({
            type: 'string'
        }, options));
    }
    if (shape.key) $a2de5435c00504a4$var$memoizedProperty(this, 'key', function() {
        return $a2de5435c00504a4$var$Shape.create(shape.key, options);
    });
    if (shape.value) $a2de5435c00504a4$var$memoizedProperty(this, 'value', function() {
        return $a2de5435c00504a4$var$Shape.create(shape.value, options);
    });
}
function $a2de5435c00504a4$var$TimestampShape(shape) {
    var self = this;
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    if (shape.timestampFormat) $a2de5435c00504a4$var$property(this, 'timestampFormat', shape.timestampFormat);
    else if (self.isTimestampFormatSet && this.timestampFormat) $a2de5435c00504a4$var$property(this, 'timestampFormat', this.timestampFormat);
    else if (this.location === 'header') $a2de5435c00504a4$var$property(this, 'timestampFormat', 'rfc822');
    else if (this.location === 'querystring') $a2de5435c00504a4$var$property(this, 'timestampFormat', 'iso8601');
    else if (this.api) switch(this.api.protocol){
        case 'json':
        case 'rest-json':
            $a2de5435c00504a4$var$property(this, 'timestampFormat', 'unixTimestamp');
            break;
        case 'rest-xml':
        case 'query':
        case 'ec2':
            $a2de5435c00504a4$var$property(this, 'timestampFormat', 'iso8601');
            break;
    }
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        if (typeof value.toUTCString === 'function') return value;
        return typeof value === 'string' || typeof value === 'number' ? $1ymo4.date.parseTimestamp(value) : null;
    };
    this.toWireFormat = function(value) {
        return $1ymo4.date.format(value, self.timestampFormat);
    };
}
function $a2de5435c00504a4$var$StringShape() {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    var nullLessProtocols = [
        'rest-xml',
        'query',
        'ec2'
    ];
    this.toType = function(value) {
        value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ? value || '' : value;
        if (this.isJsonValue) return JSON.parse(value);
        return value && typeof value.toString === 'function' ? value.toString() : value;
    };
    this.toWireFormat = function(value) {
        return this.isJsonValue ? JSON.stringify(value) : value;
    };
}
function $a2de5435c00504a4$var$FloatShape() {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        return parseFloat(value);
    };
    this.toWireFormat = this.toType;
}
function $a2de5435c00504a4$var$IntegerShape() {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        return parseInt(value, 10);
    };
    this.toWireFormat = this.toType;
}
function $a2de5435c00504a4$var$BinaryShape() {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        var buf = $1ymo4.base64.decode(value);
        if (this.isSensitive && $1ymo4.isNode() && typeof $1ymo4.Buffer.alloc === 'function') {
            /* Node.js can create a Buffer that is not isolated.
   * i.e. buf.byteLength !== buf.buffer.byteLength
   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
   */ var secureBuf = $1ymo4.Buffer.alloc(buf.length, buf);
            buf.fill(0);
            buf = secureBuf;
        }
        return buf;
    };
    this.toWireFormat = $1ymo4.base64.encode;
}
function $a2de5435c00504a4$var$Base64Shape() {
    $a2de5435c00504a4$var$BinaryShape.apply(this, arguments);
}
function $a2de5435c00504a4$var$BooleanShape() {
    $a2de5435c00504a4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (typeof value === 'boolean') return value;
        if (value === null || value === undefined) return null;
        return value === 'true';
    };
}
/**
 * @api private
 */ $a2de5435c00504a4$var$Shape.shapes = {
    StructureShape: $a2de5435c00504a4$var$StructureShape,
    ListShape: $a2de5435c00504a4$var$ListShape,
    MapShape: $a2de5435c00504a4$var$MapShape,
    StringShape: $a2de5435c00504a4$var$StringShape,
    BooleanShape: $a2de5435c00504a4$var$BooleanShape,
    Base64Shape: $a2de5435c00504a4$var$Base64Shape
};
/**
 * @api private
 */ module.exports = $a2de5435c00504a4$var$Shape;

});
parcelRegister("boi3b", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
var $84aff00387b5ebba$require$memoizedProperty = $1ymo4.memoizedProperty;
function $84aff00387b5ebba$var$memoize(name, value, factory, nameTr) {
    $84aff00387b5ebba$require$memoizedProperty(this, nameTr(name), function() {
        return factory(name, value);
    });
}
function $84aff00387b5ebba$var$Collection(iterable, options, factory, nameTr, callback) {
    nameTr = nameTr || String;
    var self = this;
    for(var id in iterable)if (Object.prototype.hasOwnProperty.call(iterable, id)) {
        $84aff00387b5ebba$var$memoize.call(self, id, iterable[id], factory, nameTr);
        if (callback) callback(id, iterable[id]);
    }
}
/**
 * @api private
 */ module.exports = $84aff00387b5ebba$var$Collection;

});



parcelRegister("14bAM", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $43c8b = parcelRequire("43c8b");
var $0c6f2828d189d944$require$populateHostPrefix = $43c8b.populateHostPrefix;
function $0c6f2828d189d944$var$populateMethod(req) {
    req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}
function $0c6f2828d189d944$var$generateURI(endpointPath, operationPath, input, params) {
    var uri = [
        endpointPath,
        operationPath
    ].join('/');
    uri = uri.replace(/\/+/g, '/');
    var queryString = {}, queryStringSet = false;
    $1ymo4.each(input.members, function(name, member) {
        var paramValue = params[name];
        if (paramValue === null || paramValue === undefined) return;
        if (member.location === 'uri') {
            var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
            uri = uri.replace(regex, function(_, plus) {
                var fn = plus ? $1ymo4.uriEscapePath : $1ymo4.uriEscape;
                return fn(String(paramValue));
            });
        } else if (member.location === 'querystring') {
            queryStringSet = true;
            if (member.type === 'list') queryString[member.name] = paramValue.map(function(val) {
                return $1ymo4.uriEscape(member.member.toWireFormat(val).toString());
            });
            else if (member.type === 'map') $1ymo4.each(paramValue, function(key, value) {
                if (Array.isArray(value)) queryString[key] = value.map(function(val) {
                    return $1ymo4.uriEscape(String(val));
                });
                else queryString[key] = $1ymo4.uriEscape(String(value));
            });
            else queryString[member.name] = $1ymo4.uriEscape(member.toWireFormat(paramValue).toString());
        }
    });
    if (queryStringSet) {
        uri += uri.indexOf('?') >= 0 ? '&' : '?';
        var parts = [];
        $1ymo4.arrayEach(Object.keys(queryString).sort(), function(key) {
            if (!Array.isArray(queryString[key])) queryString[key] = [
                queryString[key]
            ];
            for(var i = 0; i < queryString[key].length; i++)parts.push($1ymo4.uriEscape(String(key)) + '=' + queryString[key][i]);
        });
        uri += parts.join('&');
    }
    return uri;
}
function $0c6f2828d189d944$var$populateURI(req) {
    var operation = req.service.api.operations[req.operation];
    var input = operation.input;
    var uri = $0c6f2828d189d944$var$generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
    req.httpRequest.path = uri;
}
function $0c6f2828d189d944$var$populateHeaders(req) {
    var operation = req.service.api.operations[req.operation];
    $1ymo4.each(operation.input.members, function(name, member) {
        var value = req.params[name];
        if (value === null || value === undefined) return;
        if (member.location === 'headers' && member.type === 'map') $1ymo4.each(value, function(key, memberValue) {
            req.httpRequest.headers[member.name + key] = memberValue;
        });
        else if (member.location === 'header') {
            value = member.toWireFormat(value).toString();
            if (member.isJsonValue) value = $1ymo4.base64.encode(value);
            req.httpRequest.headers[member.name] = value;
        }
    });
}
function $0c6f2828d189d944$var$buildRequest(req) {
    $0c6f2828d189d944$var$populateMethod(req);
    $0c6f2828d189d944$var$populateURI(req);
    $0c6f2828d189d944$var$populateHeaders(req);
    $0c6f2828d189d944$require$populateHostPrefix(req);
}
function $0c6f2828d189d944$var$extractError() {}
function $0c6f2828d189d944$var$extractData(resp) {
    var req = resp.request;
    var data = {};
    var r = resp.httpResponse;
    var operation = req.service.api.operations[req.operation];
    var output = operation.output;
    // normalize headers names to lower-cased keys for matching
    var headers = {};
    $1ymo4.each(r.headers, function(k, v) {
        headers[k.toLowerCase()] = v;
    });
    $1ymo4.each(output.members, function(name, member) {
        var header = (member.name || name).toLowerCase();
        if (member.location === 'headers' && member.type === 'map') {
            data[name] = {};
            var location = member.isLocationName ? member.name : '';
            var pattern = new RegExp('^' + location + '(.+)', 'i');
            $1ymo4.each(r.headers, function(k, v) {
                var result = k.match(pattern);
                if (result !== null) data[name][result[1]] = v;
            });
        } else if (member.location === 'header') {
            if (headers[header] !== undefined) {
                var value = member.isJsonValue ? $1ymo4.base64.decode(headers[header]) : headers[header];
                data[name] = member.toType(value);
            }
        } else if (member.location === 'statusCode') data[name] = parseInt(r.statusCode, 10);
    });
    resp.data = data;
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $0c6f2828d189d944$var$buildRequest,
    extractError: $0c6f2828d189d944$var$extractError,
    extractData: $0c6f2828d189d944$var$extractData,
    generateURI: $0c6f2828d189d944$var$generateURI
};

});

parcelRegister("2ZRi9", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $1ymo4 = parcelRequire("1ymo4");

var $14bAM = parcelRequire("14bAM");

var $iOHL8 = parcelRequire("iOHL8");

var $liGav = parcelRequire("liGav");

var $6R1kV = parcelRequire("6R1kV");
var $22ea9de4424c0761$var$METHODS_WITHOUT_BODY = [
    'GET',
    'HEAD',
    'DELETE'
];
function $22ea9de4424c0761$var$unsetContentLength(req) {
    var payloadMember = $1ymo4.getRequestPayloadShape(req);
    if (payloadMember === undefined && $22ea9de4424c0761$var$METHODS_WITHOUT_BODY.indexOf(req.httpRequest.method) >= 0) delete req.httpRequest.headers['Content-Length'];
}
function $22ea9de4424c0761$var$populateBody(req) {
    var builder = new $liGav();
    var input = req.service.api.operations[req.operation].input;
    if (input.payload) {
        var params = {};
        var payloadShape = input.members[input.payload];
        params = req.params[input.payload];
        if (payloadShape.type === 'structure') {
            req.httpRequest.body = builder.build(params || {}, payloadShape);
            $22ea9de4424c0761$var$applyContentTypeHeader(req);
        } else if (params !== undefined) {
            // non-JSON payload
            req.httpRequest.body = params;
            if (payloadShape.type === 'binary' || payloadShape.isStreaming) $22ea9de4424c0761$var$applyContentTypeHeader(req, true);
        }
    } else {
        req.httpRequest.body = builder.build(req.params, input);
        $22ea9de4424c0761$var$applyContentTypeHeader(req);
    }
}
function $22ea9de4424c0761$var$applyContentTypeHeader(req, isBinary) {
    if (!req.httpRequest.headers['Content-Type']) {
        var type = isBinary ? 'binary/octet-stream' : 'application/json';
        req.httpRequest.headers['Content-Type'] = type;
    }
}
function $22ea9de4424c0761$var$buildRequest(req) {
    $14bAM.buildRequest(req);
    // never send body payload on GET/HEAD/DELETE
    if ($22ea9de4424c0761$var$METHODS_WITHOUT_BODY.indexOf(req.httpRequest.method) < 0) $22ea9de4424c0761$var$populateBody(req);
}
function $22ea9de4424c0761$var$extractError(resp) {
    $iOHL8.extractError(resp);
}
function $22ea9de4424c0761$var$extractData(resp) {
    $14bAM.extractData(resp);
    var req = resp.request;
    var operation = req.service.api.operations[req.operation];
    var rules = req.service.api.operations[req.operation].output || {};
    var parser;
    var hasEventOutput = operation.hasEventOutput;
    if (rules.payload) {
        var payloadMember = rules.members[rules.payload];
        var body = resp.httpResponse.body;
        if (payloadMember.isEventStream) {
            parser = new $6R1kV();
            resp.data[rules.payload] = $1ymo4.createEventStream($e2mZ5.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body, parser, payloadMember);
        } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
            var parser = new $6R1kV();
            resp.data[rules.payload] = parser.parse(body, payloadMember);
        } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) resp.data[rules.payload] = body;
        else resp.data[rules.payload] = payloadMember.toType(body);
    } else {
        var data = resp.data;
        $iOHL8.extractData(resp);
        resp.data = $1ymo4.merge(data, resp.data);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $22ea9de4424c0761$var$buildRequest,
    extractError: $22ea9de4424c0761$var$extractError,
    extractData: $22ea9de4424c0761$var$extractData,
    unsetContentLength: $22ea9de4424c0761$var$unsetContentLength
};

});

parcelRegister("lSJkz", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $1ymo4 = parcelRequire("1ymo4");

var $14bAM = parcelRequire("14bAM");
function $fee1cdd9be234e78$var$populateBody(req) {
    var input = req.service.api.operations[req.operation].input;
    var builder = new $e2mZ5.XML.Builder();
    var params = req.params;
    var payload = input.payload;
    if (payload) {
        var payloadMember = input.members[payload];
        params = params[payload];
        if (params === undefined) return;
        if (payloadMember.type === 'structure') {
            var rootElement = payloadMember.name;
            req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
        } else req.httpRequest.body = params;
    } else req.httpRequest.body = builder.toXML(params, input, input.name || input.shape || $1ymo4.string.upperFirst(req.operation) + 'Request');
}
function $fee1cdd9be234e78$var$buildRequest(req) {
    $14bAM.buildRequest(req);
    // never send body payload on GET/HEAD
    if ([
        'GET',
        'HEAD'
    ].indexOf(req.httpRequest.method) < 0) $fee1cdd9be234e78$var$populateBody(req);
}
function $fee1cdd9be234e78$var$extractError(resp) {
    $14bAM.extractError(resp);
    var data;
    try {
        data = new $e2mZ5.XML.Parser().parse(resp.httpResponse.body.toString());
    } catch (e) {
        data = {
            Code: resp.httpResponse.statusCode,
            Message: resp.httpResponse.statusMessage
        };
    }
    if (data.Errors) data = data.Errors;
    if (data.Error) data = data.Error;
    if (data.Code) resp.error = $1ymo4.error(new Error(), {
        code: data.Code,
        message: data.Message
    });
    else resp.error = $1ymo4.error(new Error(), {
        code: resp.httpResponse.statusCode,
        message: null
    });
}
function $fee1cdd9be234e78$var$extractData(resp) {
    $14bAM.extractData(resp);
    var parser;
    var req = resp.request;
    var body = resp.httpResponse.body;
    var operation = req.service.api.operations[req.operation];
    var output = operation.output;
    var hasEventOutput = operation.hasEventOutput;
    var payload = output.payload;
    if (payload) {
        var payloadMember = output.members[payload];
        if (payloadMember.isEventStream) {
            parser = new $e2mZ5.XML.Parser();
            resp.data[payload] = $1ymo4.createEventStream($e2mZ5.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body, parser, payloadMember);
        } else if (payloadMember.type === 'structure') {
            parser = new $e2mZ5.XML.Parser();
            resp.data[payload] = parser.parse(body.toString(), payloadMember);
        } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) resp.data[payload] = body;
        else resp.data[payload] = payloadMember.toType(body);
    } else if (body.length > 0) {
        parser = new $e2mZ5.XML.Parser();
        var data = parser.parse(body.toString(), output);
        $1ymo4.update(resp.data, data);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $fee1cdd9be234e78$var$buildRequest,
    extractError: $fee1cdd9be234e78$var$extractError,
    extractData: $fee1cdd9be234e78$var$extractData
};

});

parcelRegister("9LU6q", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $iSNqg = parcelRequire("iSNqg");
var $71d405aac428ad03$require$XmlNode = $iSNqg.XmlNode;

var $fUjEs = parcelRequire("fUjEs");
var $71d405aac428ad03$require$XmlText = $fUjEs.XmlText;
function $71d405aac428ad03$var$XmlBuilder() {}
$71d405aac428ad03$var$XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
    var xml = new $71d405aac428ad03$require$XmlNode(rootElement);
    $71d405aac428ad03$var$applyNamespaces(xml, shape, true);
    $71d405aac428ad03$var$serialize(xml, params, shape);
    return xml.children.length > 0 || noEmpty ? xml.toString() : '';
};
function $71d405aac428ad03$var$serialize(xml, value, shape) {
    switch(shape.type){
        case 'structure':
            return $71d405aac428ad03$var$serializeStructure(xml, value, shape);
        case 'map':
            return $71d405aac428ad03$var$serializeMap(xml, value, shape);
        case 'list':
            return $71d405aac428ad03$var$serializeList(xml, value, shape);
        default:
            return $71d405aac428ad03$var$serializeScalar(xml, value, shape);
    }
}
function $71d405aac428ad03$var$serializeStructure(xml, params, shape) {
    $1ymo4.arrayEach(shape.memberNames, function(memberName) {
        var memberShape = shape.members[memberName];
        if (memberShape.location !== 'body') return;
        var value = params[memberName];
        var name = memberShape.name;
        if (value !== undefined && value !== null) {
            if (memberShape.isXmlAttribute) xml.addAttribute(name, value);
            else if (memberShape.flattened) $71d405aac428ad03$var$serialize(xml, value, memberShape);
            else {
                var element = new $71d405aac428ad03$require$XmlNode(name);
                xml.addChildNode(element);
                $71d405aac428ad03$var$applyNamespaces(element, memberShape);
                $71d405aac428ad03$var$serialize(element, value, memberShape);
            }
        }
    });
}
function $71d405aac428ad03$var$serializeMap(xml, map, shape) {
    var xmlKey = shape.key.name || 'key';
    var xmlValue = shape.value.name || 'value';
    $1ymo4.each(map, function(key, value) {
        var entry = new $71d405aac428ad03$require$XmlNode(shape.flattened ? shape.name : 'entry');
        xml.addChildNode(entry);
        var entryKey = new $71d405aac428ad03$require$XmlNode(xmlKey);
        var entryValue = new $71d405aac428ad03$require$XmlNode(xmlValue);
        entry.addChildNode(entryKey);
        entry.addChildNode(entryValue);
        $71d405aac428ad03$var$serialize(entryKey, key, shape.key);
        $71d405aac428ad03$var$serialize(entryValue, value, shape.value);
    });
}
function $71d405aac428ad03$var$serializeList(xml, list, shape) {
    if (shape.flattened) $1ymo4.arrayEach(list, function(value) {
        var name = shape.member.name || shape.name;
        var element = new $71d405aac428ad03$require$XmlNode(name);
        xml.addChildNode(element);
        $71d405aac428ad03$var$serialize(element, value, shape.member);
    });
    else $1ymo4.arrayEach(list, function(value) {
        var name = shape.member.name || 'member';
        var element = new $71d405aac428ad03$require$XmlNode(name);
        xml.addChildNode(element);
        $71d405aac428ad03$var$serialize(element, value, shape.member);
    });
}
function $71d405aac428ad03$var$serializeScalar(xml, value, shape) {
    xml.addChildNode(new $71d405aac428ad03$require$XmlText(shape.toWireFormat(value)));
}
function $71d405aac428ad03$var$applyNamespaces(xml, shape, isRoot) {
    var uri, prefix = 'xmlns';
    if (shape.xmlNamespaceUri) {
        uri = shape.xmlNamespaceUri;
        if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
    } else if (isRoot && shape.api.xmlNamespaceUri) uri = shape.api.xmlNamespaceUri;
    if (uri) xml.addAttribute(prefix, uri);
}
/**
 * @api private
 */ module.exports = $71d405aac428ad03$var$XmlBuilder;

});
parcelRegister("iSNqg", function(module, exports) {

var $3WznW = parcelRequire("3WznW");
var $dbf39b6feb1f0d7d$require$escapeAttribute = $3WznW.escapeAttribute;
/**
 * Represents an XML node.
 * @api private
 */ function $dbf39b6feb1f0d7d$var$XmlNode(name, children) {
    if (children === void 0) children = [];
    this.name = name;
    this.children = children;
    this.attributes = {};
}
$dbf39b6feb1f0d7d$var$XmlNode.prototype.addAttribute = function(name, value) {
    this.attributes[name] = value;
    return this;
};
$dbf39b6feb1f0d7d$var$XmlNode.prototype.addChildNode = function(child) {
    this.children.push(child);
    return this;
};
$dbf39b6feb1f0d7d$var$XmlNode.prototype.removeAttribute = function(name) {
    delete this.attributes[name];
    return this;
};
$dbf39b6feb1f0d7d$var$XmlNode.prototype.toString = function() {
    var hasChildren = Boolean(this.children.length);
    var xmlText = '<' + this.name;
    // add attributes
    var attributes = this.attributes;
    for(var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++){
        var attributeName = attributeNames[i];
        var attribute = attributes[attributeName];
        if (typeof attribute !== 'undefined' && attribute !== null) xmlText += ' ' + attributeName + '=\"' + $dbf39b6feb1f0d7d$require$escapeAttribute('' + attribute) + '\"';
    }
    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function(c) {
        return c.toString();
    }).join('') + '</' + this.name + '>';
};
/**
 * @api private
 */ module.exports = {
    XmlNode: $dbf39b6feb1f0d7d$var$XmlNode
};

});
parcelRegister("3WznW", function(module, exports) {
/**
 * Escapes characters that can not be in an XML attribute.
 */ function $2df23c9ef360fcb5$var$escapeAttribute(value) {
    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
/**
 * @api private
 */ module.exports = {
    escapeAttribute: $2df23c9ef360fcb5$var$escapeAttribute
};

});


parcelRegister("fUjEs", function(module, exports) {

var $eQ2Fm = parcelRequire("eQ2Fm");
var $b94b5461f3f20b0d$require$escapeElement = $eQ2Fm.escapeElement;
/**
 * Represents an XML text value.
 * @api private
 */ function $b94b5461f3f20b0d$var$XmlText(value) {
    this.value = value;
}
$b94b5461f3f20b0d$var$XmlText.prototype.toString = function() {
    return $b94b5461f3f20b0d$require$escapeElement('' + this.value);
};
/**
 * @api private
 */ module.exports = {
    XmlText: $b94b5461f3f20b0d$var$XmlText
};

});
parcelRegister("eQ2Fm", function(module, exports) {
/**
 * Escapes characters that can not be in an XML element.
 */ function $acd7fd771b520393$var$escapeElement(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#x0D;').replace(/\n/g, '&#x0A;').replace(/\u0085/g, '&#x85;').replace(/\u2028/, '&#x2028;');
}
/**
 * @api private
 */ module.exports = {
    escapeElement: $acd7fd771b520393$var$escapeElement
};

});



parcelRegister("ewGti", function(module, exports) {

var $boi3b = parcelRequire("boi3b");

var $ldrzu = parcelRequire("ldrzu");

var $dYWAN = parcelRequire("dYWAN");

var $6mQ8f = parcelRequire("6mQ8f");

var $abtYM = parcelRequire("abtYM");

var $8k6fM = parcelRequire("8k6fM");

var $1ymo4 = parcelRequire("1ymo4");
var $a934ffcab0132cf4$var$property = $1ymo4.property;
var $a934ffcab0132cf4$var$memoizedProperty = $1ymo4.memoizedProperty;
function $a934ffcab0132cf4$var$Api(api, options) {
    var self = this;
    api = api || {};
    options = options || {};
    options.api = this;
    api.metadata = api.metadata || {};
    var serviceIdentifier = options.serviceIdentifier;
    delete options.serviceIdentifier;
    $a934ffcab0132cf4$var$property(this, 'isApi', true, false);
    $a934ffcab0132cf4$var$property(this, 'apiVersion', api.metadata.apiVersion);
    $a934ffcab0132cf4$var$property(this, 'endpointPrefix', api.metadata.endpointPrefix);
    $a934ffcab0132cf4$var$property(this, 'signingName', api.metadata.signingName);
    $a934ffcab0132cf4$var$property(this, 'globalEndpoint', api.metadata.globalEndpoint);
    $a934ffcab0132cf4$var$property(this, 'signatureVersion', api.metadata.signatureVersion);
    $a934ffcab0132cf4$var$property(this, 'jsonVersion', api.metadata.jsonVersion);
    $a934ffcab0132cf4$var$property(this, 'targetPrefix', api.metadata.targetPrefix);
    $a934ffcab0132cf4$var$property(this, 'protocol', api.metadata.protocol);
    $a934ffcab0132cf4$var$property(this, 'timestampFormat', api.metadata.timestampFormat);
    $a934ffcab0132cf4$var$property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
    $a934ffcab0132cf4$var$property(this, 'abbreviation', api.metadata.serviceAbbreviation);
    $a934ffcab0132cf4$var$property(this, 'fullName', api.metadata.serviceFullName);
    $a934ffcab0132cf4$var$property(this, 'serviceId', api.metadata.serviceId);
    if (serviceIdentifier && $8k6fM[serviceIdentifier]) $a934ffcab0132cf4$var$property(this, 'xmlNoDefaultLists', $8k6fM[serviceIdentifier].xmlNoDefaultLists, false);
    $a934ffcab0132cf4$var$memoizedProperty(this, 'className', function() {
        var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
        if (!name) return null;
        name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
        if (name === 'ElasticLoadBalancing') name = 'ELB';
        return name;
    });
    function addEndpointOperation(name, operation) {
        if (operation.endpointoperation === true) $a934ffcab0132cf4$var$property(self, 'endpointOperation', $1ymo4.string.lowerFirst(name));
        if (operation.endpointdiscovery && !self.hasRequiredEndpointDiscovery) $a934ffcab0132cf4$var$property(self, 'hasRequiredEndpointDiscovery', operation.endpointdiscovery.required === true);
    }
    $a934ffcab0132cf4$var$property(this, 'operations', new $boi3b(api.operations, options, function(name, operation) {
        return new $ldrzu(name, operation, options);
    }, $1ymo4.string.lowerFirst, addEndpointOperation));
    $a934ffcab0132cf4$var$property(this, 'shapes', new $boi3b(api.shapes, options, function(name, shape) {
        return $dYWAN.create(shape, options);
    }));
    $a934ffcab0132cf4$var$property(this, 'paginators', new $boi3b(api.paginators, options, function(name, paginator) {
        return new $6mQ8f(name, paginator, options);
    }));
    $a934ffcab0132cf4$var$property(this, 'waiters', new $boi3b(api.waiters, options, function(name, waiter) {
        return new $abtYM(name, waiter, options);
    }, $1ymo4.string.lowerFirst));
    if (options.documentation) {
        $a934ffcab0132cf4$var$property(this, 'documentation', api.documentation);
        $a934ffcab0132cf4$var$property(this, 'documentationUrl', api.documentationUrl);
    }
    $a934ffcab0132cf4$var$property(this, 'awsQueryCompatible', api.metadata.awsQueryCompatible);
}
/**
 * @api private
 */ module.exports = $a934ffcab0132cf4$var$Api;

});
parcelRegister("ldrzu", function(module, exports) {

var $dYWAN = parcelRequire("dYWAN");

var $1ymo4 = parcelRequire("1ymo4");
var $f72032f6996e538b$var$property = $1ymo4.property;
var $f72032f6996e538b$var$memoizedProperty = $1ymo4.memoizedProperty;
function $f72032f6996e538b$var$Operation(name, operation, options) {
    var self = this;
    options = options || {};
    $f72032f6996e538b$var$property(this, 'name', operation.name || name);
    $f72032f6996e538b$var$property(this, 'api', options.api, false);
    operation.http = operation.http || {};
    $f72032f6996e538b$var$property(this, 'endpoint', operation.endpoint);
    $f72032f6996e538b$var$property(this, 'httpMethod', operation.http.method || 'POST');
    $f72032f6996e538b$var$property(this, 'httpPath', operation.http.requestUri || '/');
    $f72032f6996e538b$var$property(this, 'authtype', operation.authtype || '');
    $f72032f6996e538b$var$property(this, 'endpointDiscoveryRequired', operation.endpointdiscovery ? operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL' : 'NULL');
    // httpChecksum replaces usage of httpChecksumRequired, but some APIs
    // (s3control) still uses old trait.
    var httpChecksumRequired = operation.httpChecksumRequired || operation.httpChecksum && operation.httpChecksum.requestChecksumRequired;
    $f72032f6996e538b$var$property(this, 'httpChecksumRequired', httpChecksumRequired, false);
    $f72032f6996e538b$var$memoizedProperty(this, 'input', function() {
        if (!operation.input) return new $dYWAN.create({
            type: 'structure'
        }, options);
        return $dYWAN.create(operation.input, options);
    });
    $f72032f6996e538b$var$memoizedProperty(this, 'output', function() {
        if (!operation.output) return new $dYWAN.create({
            type: 'structure'
        }, options);
        return $dYWAN.create(operation.output, options);
    });
    $f72032f6996e538b$var$memoizedProperty(this, 'errors', function() {
        var list = [];
        if (!operation.errors) return null;
        for(var i = 0; i < operation.errors.length; i++)list.push($dYWAN.create(operation.errors[i], options));
        return list;
    });
    $f72032f6996e538b$var$memoizedProperty(this, 'paginator', function() {
        return options.api.paginators[name];
    });
    if (options.documentation) {
        $f72032f6996e538b$var$property(this, 'documentation', operation.documentation);
        $f72032f6996e538b$var$property(this, 'documentationUrl', operation.documentationUrl);
    }
    // idempotentMembers only tracks top-level input shapes
    $f72032f6996e538b$var$memoizedProperty(this, 'idempotentMembers', function() {
        var idempotentMembers = [];
        var input = self.input;
        var members = input.members;
        if (!input.members) return idempotentMembers;
        for(var name in members){
            if (!members.hasOwnProperty(name)) continue;
            if (members[name].isIdempotent === true) idempotentMembers.push(name);
        }
        return idempotentMembers;
    });
    $f72032f6996e538b$var$memoizedProperty(this, 'hasEventOutput', function() {
        var output = self.output;
        return $f72032f6996e538b$var$hasEventStream(output);
    });
}
function $f72032f6996e538b$var$hasEventStream(topLevelShape) {
    var members = topLevelShape.members;
    var payload = topLevelShape.payload;
    if (!topLevelShape.members) return false;
    if (payload) {
        var payloadMember = members[payload];
        return payloadMember.isEventStream;
    }
    // check if any member is an event stream
    for(var name in members)if (!members.hasOwnProperty(name)) {
        if (members[name].isEventStream === true) return true;
    }
    return false;
}
/**
 * @api private
 */ module.exports = $f72032f6996e538b$var$Operation;

});

parcelRegister("6mQ8f", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
var $4a2d3c807acd114b$require$property = $1ymo4.property;
function $4a2d3c807acd114b$var$Paginator(name, paginator) {
    $4a2d3c807acd114b$require$property(this, 'inputToken', paginator.input_token);
    $4a2d3c807acd114b$require$property(this, 'limitKey', paginator.limit_key);
    $4a2d3c807acd114b$require$property(this, 'moreResults', paginator.more_results);
    $4a2d3c807acd114b$require$property(this, 'outputToken', paginator.output_token);
    $4a2d3c807acd114b$require$property(this, 'resultKey', paginator.result_key);
}
/**
 * @api private
 */ module.exports = $4a2d3c807acd114b$var$Paginator;

});

parcelRegister("abtYM", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");
var $76a22fb7db66d80f$var$property = $1ymo4.property;
function $76a22fb7db66d80f$var$ResourceWaiter(name, waiter, options) {
    options = options || {};
    $76a22fb7db66d80f$var$property(this, 'name', name);
    $76a22fb7db66d80f$var$property(this, 'api', options.api, false);
    if (waiter.operation) $76a22fb7db66d80f$var$property(this, 'operation', $1ymo4.string.lowerFirst(waiter.operation));
    var self = this;
    var keys = [
        'type',
        'description',
        'delay',
        'maxAttempts',
        'acceptors'
    ];
    keys.forEach(function(key) {
        var value = waiter[key];
        if (value) $76a22fb7db66d80f$var$property(self, key, value);
    });
}
/**
 * @api private
 */ module.exports = $76a22fb7db66d80f$var$ResourceWaiter;

});

parcelRegister("8k6fM", function(module, exports) {
module.exports = JSON.parse("{\"acm\":{\"name\":\"ACM\",\"cors\":true},\"apigateway\":{\"name\":\"APIGateway\",\"cors\":true},\"applicationautoscaling\":{\"prefix\":\"application-autoscaling\",\"name\":\"ApplicationAutoScaling\",\"cors\":true},\"appstream\":{\"name\":\"AppStream\"},\"autoscaling\":{\"name\":\"AutoScaling\",\"cors\":true},\"batch\":{\"name\":\"Batch\"},\"budgets\":{\"name\":\"Budgets\"},\"clouddirectory\":{\"name\":\"CloudDirectory\",\"versions\":[\"2016-05-10*\"]},\"cloudformation\":{\"name\":\"CloudFormation\",\"cors\":true},\"cloudfront\":{\"name\":\"CloudFront\",\"versions\":[\"2013-05-12*\",\"2013-11-11*\",\"2014-05-31*\",\"2014-10-21*\",\"2014-11-06*\",\"2015-04-17*\",\"2015-07-27*\",\"2015-09-17*\",\"2016-01-13*\",\"2016-01-28*\",\"2016-08-01*\",\"2016-08-20*\",\"2016-09-07*\",\"2016-09-29*\",\"2016-11-25*\",\"2017-03-25*\",\"2017-10-30*\",\"2018-06-18*\",\"2018-11-05*\",\"2019-03-26*\"],\"cors\":true},\"cloudhsm\":{\"name\":\"CloudHSM\",\"cors\":true},\"cloudsearch\":{\"name\":\"CloudSearch\"},\"cloudsearchdomain\":{\"name\":\"CloudSearchDomain\"},\"cloudtrail\":{\"name\":\"CloudTrail\",\"cors\":true},\"cloudwatch\":{\"prefix\":\"monitoring\",\"name\":\"CloudWatch\",\"cors\":true},\"cloudwatchevents\":{\"prefix\":\"events\",\"name\":\"CloudWatchEvents\",\"versions\":[\"2014-02-03*\"],\"cors\":true},\"cloudwatchlogs\":{\"prefix\":\"logs\",\"name\":\"CloudWatchLogs\",\"cors\":true},\"codebuild\":{\"name\":\"CodeBuild\",\"cors\":true},\"codecommit\":{\"name\":\"CodeCommit\",\"cors\":true},\"codedeploy\":{\"name\":\"CodeDeploy\",\"cors\":true},\"codepipeline\":{\"name\":\"CodePipeline\",\"cors\":true},\"cognitoidentity\":{\"prefix\":\"cognito-identity\",\"name\":\"CognitoIdentity\",\"cors\":true},\"cognitoidentityserviceprovider\":{\"prefix\":\"cognito-idp\",\"name\":\"CognitoIdentityServiceProvider\",\"cors\":true},\"cognitosync\":{\"prefix\":\"cognito-sync\",\"name\":\"CognitoSync\",\"cors\":true},\"configservice\":{\"prefix\":\"config\",\"name\":\"ConfigService\",\"cors\":true},\"cur\":{\"name\":\"CUR\",\"cors\":true},\"datapipeline\":{\"name\":\"DataPipeline\"},\"devicefarm\":{\"name\":\"DeviceFarm\",\"cors\":true},\"directconnect\":{\"name\":\"DirectConnect\",\"cors\":true},\"directoryservice\":{\"prefix\":\"ds\",\"name\":\"DirectoryService\"},\"discovery\":{\"name\":\"Discovery\"},\"dms\":{\"name\":\"DMS\"},\"dynamodb\":{\"name\":\"DynamoDB\",\"cors\":true},\"dynamodbstreams\":{\"prefix\":\"streams.dynamodb\",\"name\":\"DynamoDBStreams\",\"cors\":true},\"ec2\":{\"name\":\"EC2\",\"versions\":[\"2013-06-15*\",\"2013-10-15*\",\"2014-02-01*\",\"2014-05-01*\",\"2014-06-15*\",\"2014-09-01*\",\"2014-10-01*\",\"2015-03-01*\",\"2015-04-15*\",\"2015-10-01*\",\"2016-04-01*\",\"2016-09-15*\"],\"cors\":true},\"ecr\":{\"name\":\"ECR\",\"cors\":true},\"ecs\":{\"name\":\"ECS\",\"cors\":true},\"efs\":{\"prefix\":\"elasticfilesystem\",\"name\":\"EFS\",\"cors\":true},\"elasticache\":{\"name\":\"ElastiCache\",\"versions\":[\"2012-11-15*\",\"2014-03-24*\",\"2014-07-15*\",\"2014-09-30*\"],\"cors\":true},\"elasticbeanstalk\":{\"name\":\"ElasticBeanstalk\",\"cors\":true},\"elb\":{\"prefix\":\"elasticloadbalancing\",\"name\":\"ELB\",\"cors\":true},\"elbv2\":{\"prefix\":\"elasticloadbalancingv2\",\"name\":\"ELBv2\",\"cors\":true},\"emr\":{\"prefix\":\"elasticmapreduce\",\"name\":\"EMR\",\"cors\":true},\"es\":{\"name\":\"ES\"},\"elastictranscoder\":{\"name\":\"ElasticTranscoder\",\"cors\":true},\"firehose\":{\"name\":\"Firehose\",\"cors\":true},\"gamelift\":{\"name\":\"GameLift\",\"cors\":true},\"glacier\":{\"name\":\"Glacier\"},\"health\":{\"name\":\"Health\"},\"iam\":{\"name\":\"IAM\",\"cors\":true},\"importexport\":{\"name\":\"ImportExport\"},\"inspector\":{\"name\":\"Inspector\",\"versions\":[\"2015-08-18*\"],\"cors\":true},\"iot\":{\"name\":\"Iot\",\"cors\":true},\"iotdata\":{\"prefix\":\"iot-data\",\"name\":\"IotData\",\"cors\":true},\"kinesis\":{\"name\":\"Kinesis\",\"cors\":true},\"kinesisanalytics\":{\"name\":\"KinesisAnalytics\"},\"kms\":{\"name\":\"KMS\",\"cors\":true},\"lambda\":{\"name\":\"Lambda\",\"cors\":true},\"lexruntime\":{\"prefix\":\"runtime.lex\",\"name\":\"LexRuntime\",\"cors\":true},\"lightsail\":{\"name\":\"Lightsail\"},\"machinelearning\":{\"name\":\"MachineLearning\",\"cors\":true},\"marketplacecommerceanalytics\":{\"name\":\"MarketplaceCommerceAnalytics\",\"cors\":true},\"marketplacemetering\":{\"prefix\":\"meteringmarketplace\",\"name\":\"MarketplaceMetering\"},\"mturk\":{\"prefix\":\"mturk-requester\",\"name\":\"MTurk\",\"cors\":true},\"mobileanalytics\":{\"name\":\"MobileAnalytics\",\"cors\":true},\"opsworks\":{\"name\":\"OpsWorks\",\"cors\":true},\"opsworkscm\":{\"name\":\"OpsWorksCM\"},\"organizations\":{\"name\":\"Organizations\"},\"pinpoint\":{\"name\":\"Pinpoint\"},\"polly\":{\"name\":\"Polly\",\"cors\":true},\"rds\":{\"name\":\"RDS\",\"versions\":[\"2014-09-01*\"],\"cors\":true},\"redshift\":{\"name\":\"Redshift\",\"cors\":true},\"rekognition\":{\"name\":\"Rekognition\",\"cors\":true},\"resourcegroupstaggingapi\":{\"name\":\"ResourceGroupsTaggingAPI\"},\"route53\":{\"name\":\"Route53\",\"cors\":true},\"route53domains\":{\"name\":\"Route53Domains\",\"cors\":true},\"s3\":{\"name\":\"S3\",\"dualstackAvailable\":true,\"cors\":true},\"s3control\":{\"name\":\"S3Control\",\"dualstackAvailable\":true,\"xmlNoDefaultLists\":true},\"servicecatalog\":{\"name\":\"ServiceCatalog\",\"cors\":true},\"ses\":{\"prefix\":\"email\",\"name\":\"SES\",\"cors\":true},\"shield\":{\"name\":\"Shield\"},\"simpledb\":{\"prefix\":\"sdb\",\"name\":\"SimpleDB\"},\"sms\":{\"name\":\"SMS\"},\"snowball\":{\"name\":\"Snowball\"},\"sns\":{\"name\":\"SNS\",\"cors\":true},\"sqs\":{\"name\":\"SQS\",\"cors\":true},\"ssm\":{\"name\":\"SSM\",\"cors\":true},\"storagegateway\":{\"name\":\"StorageGateway\",\"cors\":true},\"stepfunctions\":{\"prefix\":\"states\",\"name\":\"StepFunctions\"},\"sts\":{\"name\":\"STS\",\"cors\":true},\"support\":{\"name\":\"Support\"},\"swf\":{\"name\":\"SWF\"},\"xray\":{\"name\":\"XRay\",\"cors\":true},\"waf\":{\"name\":\"WAF\",\"cors\":true},\"wafregional\":{\"prefix\":\"waf-regional\",\"name\":\"WAFRegional\"},\"workdocs\":{\"name\":\"WorkDocs\",\"cors\":true},\"workspaces\":{\"name\":\"WorkSpaces\"},\"lexmodelbuildingservice\":{\"prefix\":\"lex-models\",\"name\":\"LexModelBuildingService\",\"cors\":true},\"marketplaceentitlementservice\":{\"prefix\":\"entitlement.marketplace\",\"name\":\"MarketplaceEntitlementService\"},\"athena\":{\"name\":\"Athena\",\"cors\":true},\"greengrass\":{\"name\":\"Greengrass\"},\"dax\":{\"name\":\"DAX\"},\"migrationhub\":{\"prefix\":\"AWSMigrationHub\",\"name\":\"MigrationHub\"},\"cloudhsmv2\":{\"name\":\"CloudHSMV2\",\"cors\":true},\"glue\":{\"name\":\"Glue\"},\"pricing\":{\"name\":\"Pricing\",\"cors\":true},\"costexplorer\":{\"prefix\":\"ce\",\"name\":\"CostExplorer\",\"cors\":true},\"mediaconvert\":{\"name\":\"MediaConvert\"},\"medialive\":{\"name\":\"MediaLive\"},\"mediapackage\":{\"name\":\"MediaPackage\"},\"mediastore\":{\"name\":\"MediaStore\"},\"mediastoredata\":{\"prefix\":\"mediastore-data\",\"name\":\"MediaStoreData\",\"cors\":true},\"appsync\":{\"name\":\"AppSync\"},\"guardduty\":{\"name\":\"GuardDuty\"},\"mq\":{\"name\":\"MQ\"},\"comprehend\":{\"name\":\"Comprehend\",\"cors\":true},\"iotjobsdataplane\":{\"prefix\":\"iot-jobs-data\",\"name\":\"IoTJobsDataPlane\"},\"kinesisvideoarchivedmedia\":{\"prefix\":\"kinesis-video-archived-media\",\"name\":\"KinesisVideoArchivedMedia\",\"cors\":true},\"kinesisvideomedia\":{\"prefix\":\"kinesis-video-media\",\"name\":\"KinesisVideoMedia\",\"cors\":true},\"kinesisvideo\":{\"name\":\"KinesisVideo\",\"cors\":true},\"sagemakerruntime\":{\"prefix\":\"runtime.sagemaker\",\"name\":\"SageMakerRuntime\"},\"sagemaker\":{\"name\":\"SageMaker\"},\"translate\":{\"name\":\"Translate\",\"cors\":true},\"resourcegroups\":{\"prefix\":\"resource-groups\",\"name\":\"ResourceGroups\",\"cors\":true},\"cloud9\":{\"name\":\"Cloud9\"},\"serverlessapplicationrepository\":{\"prefix\":\"serverlessrepo\",\"name\":\"ServerlessApplicationRepository\"},\"servicediscovery\":{\"name\":\"ServiceDiscovery\"},\"workmail\":{\"name\":\"WorkMail\"},\"autoscalingplans\":{\"prefix\":\"autoscaling-plans\",\"name\":\"AutoScalingPlans\"},\"transcribeservice\":{\"prefix\":\"transcribe\",\"name\":\"TranscribeService\"},\"connect\":{\"name\":\"Connect\",\"cors\":true},\"acmpca\":{\"prefix\":\"acm-pca\",\"name\":\"ACMPCA\"},\"fms\":{\"name\":\"FMS\"},\"secretsmanager\":{\"name\":\"SecretsManager\",\"cors\":true},\"iotanalytics\":{\"name\":\"IoTAnalytics\",\"cors\":true},\"iot1clickdevicesservice\":{\"prefix\":\"iot1click-devices\",\"name\":\"IoT1ClickDevicesService\"},\"iot1clickprojects\":{\"prefix\":\"iot1click-projects\",\"name\":\"IoT1ClickProjects\"},\"pi\":{\"name\":\"PI\"},\"neptune\":{\"name\":\"Neptune\"},\"mediatailor\":{\"name\":\"MediaTailor\"},\"eks\":{\"name\":\"EKS\"},\"dlm\":{\"name\":\"DLM\"},\"signer\":{\"name\":\"Signer\"},\"chime\":{\"name\":\"Chime\"},\"pinpointemail\":{\"prefix\":\"pinpoint-email\",\"name\":\"PinpointEmail\"},\"ram\":{\"name\":\"RAM\"},\"route53resolver\":{\"name\":\"Route53Resolver\"},\"pinpointsmsvoice\":{\"prefix\":\"sms-voice\",\"name\":\"PinpointSMSVoice\"},\"quicksight\":{\"name\":\"QuickSight\"},\"rdsdataservice\":{\"prefix\":\"rds-data\",\"name\":\"RDSDataService\"},\"amplify\":{\"name\":\"Amplify\"},\"datasync\":{\"name\":\"DataSync\"},\"robomaker\":{\"name\":\"RoboMaker\"},\"transfer\":{\"name\":\"Transfer\"},\"globalaccelerator\":{\"name\":\"GlobalAccelerator\"},\"comprehendmedical\":{\"name\":\"ComprehendMedical\",\"cors\":true},\"kinesisanalyticsv2\":{\"name\":\"KinesisAnalyticsV2\"},\"mediaconnect\":{\"name\":\"MediaConnect\"},\"fsx\":{\"name\":\"FSx\"},\"securityhub\":{\"name\":\"SecurityHub\"},\"appmesh\":{\"name\":\"AppMesh\",\"versions\":[\"2018-10-01*\"]},\"licensemanager\":{\"prefix\":\"license-manager\",\"name\":\"LicenseManager\"},\"kafka\":{\"name\":\"Kafka\"},\"apigatewaymanagementapi\":{\"name\":\"ApiGatewayManagementApi\"},\"apigatewayv2\":{\"name\":\"ApiGatewayV2\"},\"docdb\":{\"name\":\"DocDB\"},\"backup\":{\"name\":\"Backup\"},\"worklink\":{\"name\":\"WorkLink\"},\"textract\":{\"name\":\"Textract\"},\"managedblockchain\":{\"name\":\"ManagedBlockchain\"},\"mediapackagevod\":{\"prefix\":\"mediapackage-vod\",\"name\":\"MediaPackageVod\"},\"groundstation\":{\"name\":\"GroundStation\"},\"iotthingsgraph\":{\"name\":\"IoTThingsGraph\"},\"iotevents\":{\"name\":\"IoTEvents\"},\"ioteventsdata\":{\"prefix\":\"iotevents-data\",\"name\":\"IoTEventsData\"},\"personalize\":{\"name\":\"Personalize\",\"cors\":true},\"personalizeevents\":{\"prefix\":\"personalize-events\",\"name\":\"PersonalizeEvents\",\"cors\":true},\"personalizeruntime\":{\"prefix\":\"personalize-runtime\",\"name\":\"PersonalizeRuntime\",\"cors\":true},\"applicationinsights\":{\"prefix\":\"application-insights\",\"name\":\"ApplicationInsights\"},\"servicequotas\":{\"prefix\":\"service-quotas\",\"name\":\"ServiceQuotas\"},\"ec2instanceconnect\":{\"prefix\":\"ec2-instance-connect\",\"name\":\"EC2InstanceConnect\"},\"eventbridge\":{\"name\":\"EventBridge\"},\"lakeformation\":{\"name\":\"LakeFormation\"},\"forecastservice\":{\"prefix\":\"forecast\",\"name\":\"ForecastService\",\"cors\":true},\"forecastqueryservice\":{\"prefix\":\"forecastquery\",\"name\":\"ForecastQueryService\",\"cors\":true},\"qldb\":{\"name\":\"QLDB\"},\"qldbsession\":{\"prefix\":\"qldb-session\",\"name\":\"QLDBSession\"},\"workmailmessageflow\":{\"name\":\"WorkMailMessageFlow\"},\"codestarnotifications\":{\"prefix\":\"codestar-notifications\",\"name\":\"CodeStarNotifications\"},\"savingsplans\":{\"name\":\"SavingsPlans\"},\"sso\":{\"name\":\"SSO\"},\"ssooidc\":{\"prefix\":\"sso-oidc\",\"name\":\"SSOOIDC\"},\"marketplacecatalog\":{\"prefix\":\"marketplace-catalog\",\"name\":\"MarketplaceCatalog\",\"cors\":true},\"dataexchange\":{\"name\":\"DataExchange\"},\"sesv2\":{\"name\":\"SESV2\"},\"migrationhubconfig\":{\"prefix\":\"migrationhub-config\",\"name\":\"MigrationHubConfig\"},\"connectparticipant\":{\"name\":\"ConnectParticipant\"},\"appconfig\":{\"name\":\"AppConfig\"},\"iotsecuretunneling\":{\"name\":\"IoTSecureTunneling\"},\"wafv2\":{\"name\":\"WAFV2\"},\"elasticinference\":{\"prefix\":\"elastic-inference\",\"name\":\"ElasticInference\"},\"imagebuilder\":{\"name\":\"Imagebuilder\"},\"schemas\":{\"name\":\"Schemas\"},\"accessanalyzer\":{\"name\":\"AccessAnalyzer\"},\"codegurureviewer\":{\"prefix\":\"codeguru-reviewer\",\"name\":\"CodeGuruReviewer\"},\"codeguruprofiler\":{\"name\":\"CodeGuruProfiler\"},\"computeoptimizer\":{\"prefix\":\"compute-optimizer\",\"name\":\"ComputeOptimizer\"},\"frauddetector\":{\"name\":\"FraudDetector\"},\"kendra\":{\"name\":\"Kendra\"},\"networkmanager\":{\"name\":\"NetworkManager\"},\"outposts\":{\"name\":\"Outposts\"},\"augmentedairuntime\":{\"prefix\":\"sagemaker-a2i-runtime\",\"name\":\"AugmentedAIRuntime\"},\"ebs\":{\"name\":\"EBS\"},\"kinesisvideosignalingchannels\":{\"prefix\":\"kinesis-video-signaling\",\"name\":\"KinesisVideoSignalingChannels\",\"cors\":true},\"detective\":{\"name\":\"Detective\"},\"codestarconnections\":{\"prefix\":\"codestar-connections\",\"name\":\"CodeStarconnections\"},\"synthetics\":{\"name\":\"Synthetics\"},\"iotsitewise\":{\"name\":\"IoTSiteWise\"},\"macie2\":{\"name\":\"Macie2\"},\"codeartifact\":{\"name\":\"CodeArtifact\"},\"ivs\":{\"name\":\"IVS\"},\"braket\":{\"name\":\"Braket\"},\"identitystore\":{\"name\":\"IdentityStore\"},\"appflow\":{\"name\":\"Appflow\"},\"redshiftdata\":{\"prefix\":\"redshift-data\",\"name\":\"RedshiftData\"},\"ssoadmin\":{\"prefix\":\"sso-admin\",\"name\":\"SSOAdmin\"},\"timestreamquery\":{\"prefix\":\"timestream-query\",\"name\":\"TimestreamQuery\"},\"timestreamwrite\":{\"prefix\":\"timestream-write\",\"name\":\"TimestreamWrite\"},\"s3outposts\":{\"name\":\"S3Outposts\"},\"databrew\":{\"name\":\"DataBrew\"},\"servicecatalogappregistry\":{\"prefix\":\"servicecatalog-appregistry\",\"name\":\"ServiceCatalogAppRegistry\"},\"networkfirewall\":{\"prefix\":\"network-firewall\",\"name\":\"NetworkFirewall\"},\"mwaa\":{\"name\":\"MWAA\"},\"amplifybackend\":{\"name\":\"AmplifyBackend\"},\"appintegrations\":{\"name\":\"AppIntegrations\"},\"connectcontactlens\":{\"prefix\":\"connect-contact-lens\",\"name\":\"ConnectContactLens\"},\"devopsguru\":{\"prefix\":\"devops-guru\",\"name\":\"DevOpsGuru\"},\"ecrpublic\":{\"prefix\":\"ecr-public\",\"name\":\"ECRPUBLIC\"},\"lookoutvision\":{\"name\":\"LookoutVision\"},\"sagemakerfeaturestoreruntime\":{\"prefix\":\"sagemaker-featurestore-runtime\",\"name\":\"SageMakerFeatureStoreRuntime\"},\"customerprofiles\":{\"prefix\":\"customer-profiles\",\"name\":\"CustomerProfiles\"},\"auditmanager\":{\"name\":\"AuditManager\"},\"emrcontainers\":{\"prefix\":\"emr-containers\",\"name\":\"EMRcontainers\"},\"healthlake\":{\"name\":\"HealthLake\"},\"sagemakeredge\":{\"prefix\":\"sagemaker-edge\",\"name\":\"SagemakerEdge\"},\"amp\":{\"name\":\"Amp\",\"cors\":true},\"greengrassv2\":{\"name\":\"GreengrassV2\"},\"iotdeviceadvisor\":{\"name\":\"IotDeviceAdvisor\"},\"iotfleethub\":{\"name\":\"IoTFleetHub\"},\"iotwireless\":{\"name\":\"IoTWireless\"},\"location\":{\"name\":\"Location\",\"cors\":true},\"wellarchitected\":{\"name\":\"WellArchitected\"},\"lexmodelsv2\":{\"prefix\":\"models.lex.v2\",\"name\":\"LexModelsV2\"},\"lexruntimev2\":{\"prefix\":\"runtime.lex.v2\",\"name\":\"LexRuntimeV2\",\"cors\":true},\"fis\":{\"name\":\"Fis\"},\"lookoutmetrics\":{\"name\":\"LookoutMetrics\"},\"mgn\":{\"name\":\"Mgn\"},\"lookoutequipment\":{\"name\":\"LookoutEquipment\"},\"nimble\":{\"name\":\"Nimble\"},\"finspace\":{\"name\":\"Finspace\"},\"finspacedata\":{\"prefix\":\"finspace-data\",\"name\":\"Finspacedata\"},\"ssmcontacts\":{\"prefix\":\"ssm-contacts\",\"name\":\"SSMContacts\"},\"ssmincidents\":{\"prefix\":\"ssm-incidents\",\"name\":\"SSMIncidents\"},\"applicationcostprofiler\":{\"name\":\"ApplicationCostProfiler\"},\"apprunner\":{\"name\":\"AppRunner\"},\"proton\":{\"name\":\"Proton\"},\"route53recoverycluster\":{\"prefix\":\"route53-recovery-cluster\",\"name\":\"Route53RecoveryCluster\"},\"route53recoverycontrolconfig\":{\"prefix\":\"route53-recovery-control-config\",\"name\":\"Route53RecoveryControlConfig\"},\"route53recoveryreadiness\":{\"prefix\":\"route53-recovery-readiness\",\"name\":\"Route53RecoveryReadiness\"},\"chimesdkidentity\":{\"prefix\":\"chime-sdk-identity\",\"name\":\"ChimeSDKIdentity\"},\"chimesdkmessaging\":{\"prefix\":\"chime-sdk-messaging\",\"name\":\"ChimeSDKMessaging\"},\"snowdevicemanagement\":{\"prefix\":\"snow-device-management\",\"name\":\"SnowDeviceManagement\"},\"memorydb\":{\"name\":\"MemoryDB\"},\"opensearch\":{\"name\":\"OpenSearch\"},\"kafkaconnect\":{\"name\":\"KafkaConnect\"},\"voiceid\":{\"prefix\":\"voice-id\",\"name\":\"VoiceID\"},\"wisdom\":{\"name\":\"Wisdom\"},\"account\":{\"name\":\"Account\"},\"cloudcontrol\":{\"name\":\"CloudControl\"},\"grafana\":{\"name\":\"Grafana\"},\"panorama\":{\"name\":\"Panorama\"},\"chimesdkmeetings\":{\"prefix\":\"chime-sdk-meetings\",\"name\":\"ChimeSDKMeetings\"},\"resiliencehub\":{\"name\":\"Resiliencehub\"},\"migrationhubstrategy\":{\"name\":\"MigrationHubStrategy\"},\"appconfigdata\":{\"name\":\"AppConfigData\"},\"drs\":{\"name\":\"Drs\"},\"migrationhubrefactorspaces\":{\"prefix\":\"migration-hub-refactor-spaces\",\"name\":\"MigrationHubRefactorSpaces\"},\"evidently\":{\"name\":\"Evidently\"},\"inspector2\":{\"name\":\"Inspector2\"},\"rbin\":{\"name\":\"Rbin\"},\"rum\":{\"name\":\"RUM\"},\"backupgateway\":{\"prefix\":\"backup-gateway\",\"name\":\"BackupGateway\"},\"iottwinmaker\":{\"name\":\"IoTTwinMaker\"},\"workspacesweb\":{\"prefix\":\"workspaces-web\",\"name\":\"WorkSpacesWeb\"},\"amplifyuibuilder\":{\"name\":\"AmplifyUIBuilder\"},\"keyspaces\":{\"name\":\"Keyspaces\"},\"billingconductor\":{\"name\":\"Billingconductor\"},\"pinpointsmsvoicev2\":{\"prefix\":\"pinpoint-sms-voice-v2\",\"name\":\"PinpointSMSVoiceV2\"},\"ivschat\":{\"name\":\"Ivschat\"},\"chimesdkmediapipelines\":{\"prefix\":\"chime-sdk-media-pipelines\",\"name\":\"ChimeSDKMediaPipelines\"},\"emrserverless\":{\"prefix\":\"emr-serverless\",\"name\":\"EMRServerless\"},\"m2\":{\"name\":\"M2\"},\"connectcampaigns\":{\"name\":\"ConnectCampaigns\"},\"redshiftserverless\":{\"prefix\":\"redshift-serverless\",\"name\":\"RedshiftServerless\"},\"rolesanywhere\":{\"name\":\"RolesAnywhere\"},\"licensemanagerusersubscriptions\":{\"prefix\":\"license-manager-user-subscriptions\",\"name\":\"LicenseManagerUserSubscriptions\"},\"privatenetworks\":{\"name\":\"PrivateNetworks\"},\"supportapp\":{\"prefix\":\"support-app\",\"name\":\"SupportApp\"},\"controltower\":{\"name\":\"ControlTower\"},\"iotfleetwise\":{\"name\":\"IoTFleetWise\"},\"migrationhuborchestrator\":{\"name\":\"MigrationHubOrchestrator\"},\"connectcases\":{\"name\":\"ConnectCases\"},\"resourceexplorer2\":{\"prefix\":\"resource-explorer-2\",\"name\":\"ResourceExplorer2\"},\"scheduler\":{\"name\":\"Scheduler\"},\"chimesdkvoice\":{\"prefix\":\"chime-sdk-voice\",\"name\":\"ChimeSDKVoice\"},\"ssmsap\":{\"prefix\":\"ssm-sap\",\"name\":\"SsmSap\"},\"oam\":{\"name\":\"OAM\"},\"arczonalshift\":{\"prefix\":\"arc-zonal-shift\",\"name\":\"ARCZonalShift\"},\"omics\":{\"name\":\"Omics\"},\"opensearchserverless\":{\"name\":\"OpenSearchServerless\"},\"securitylake\":{\"name\":\"SecurityLake\"},\"simspaceweaver\":{\"name\":\"SimSpaceWeaver\"},\"docdbelastic\":{\"prefix\":\"docdb-elastic\",\"name\":\"DocDBElastic\"},\"sagemakergeospatial\":{\"prefix\":\"sagemaker-geospatial\",\"name\":\"SageMakerGeospatial\"},\"codecatalyst\":{\"name\":\"CodeCatalyst\"},\"pipes\":{\"name\":\"Pipes\"},\"sagemakermetrics\":{\"prefix\":\"sagemaker-metrics\",\"name\":\"SageMakerMetrics\"},\"kinesisvideowebrtcstorage\":{\"prefix\":\"kinesis-video-webrtc-storage\",\"name\":\"KinesisVideoWebRTCStorage\"},\"licensemanagerlinuxsubscriptions\":{\"prefix\":\"license-manager-linux-subscriptions\",\"name\":\"LicenseManagerLinuxSubscriptions\"},\"kendraranking\":{\"prefix\":\"kendra-ranking\",\"name\":\"KendraRanking\"},\"cleanrooms\":{\"name\":\"CleanRooms\"},\"cloudtraildata\":{\"prefix\":\"cloudtrail-data\",\"name\":\"CloudTrailData\"},\"tnb\":{\"name\":\"Tnb\"},\"internetmonitor\":{\"name\":\"InternetMonitor\"},\"ivsrealtime\":{\"prefix\":\"ivs-realtime\",\"name\":\"IVSRealTime\"},\"vpclattice\":{\"prefix\":\"vpc-lattice\",\"name\":\"VPCLattice\"},\"osis\":{\"name\":\"OSIS\"},\"mediapackagev2\":{\"name\":\"MediaPackageV2\"},\"paymentcryptography\":{\"prefix\":\"payment-cryptography\",\"name\":\"PaymentCryptography\"},\"paymentcryptographydata\":{\"prefix\":\"payment-cryptography-data\",\"name\":\"PaymentCryptographyData\"},\"codegurusecurity\":{\"prefix\":\"codeguru-security\",\"name\":\"CodeGuruSecurity\"},\"verifiedpermissions\":{\"name\":\"VerifiedPermissions\"},\"appfabric\":{\"name\":\"AppFabric\"},\"medicalimaging\":{\"prefix\":\"medical-imaging\",\"name\":\"MedicalImaging\"},\"entityresolution\":{\"name\":\"EntityResolution\"},\"managedblockchainquery\":{\"prefix\":\"managedblockchain-query\",\"name\":\"ManagedBlockchainQuery\"},\"neptunedata\":{\"name\":\"Neptunedata\"},\"pcaconnectorad\":{\"prefix\":\"pca-connector-ad\",\"name\":\"PcaConnectorAd\"},\"bedrock\":{\"name\":\"Bedrock\"},\"bedrockruntime\":{\"prefix\":\"bedrock-runtime\",\"name\":\"BedrockRuntime\"},\"datazone\":{\"name\":\"DataZone\"},\"launchwizard\":{\"prefix\":\"launch-wizard\",\"name\":\"LaunchWizard\"},\"trustedadvisor\":{\"name\":\"TrustedAdvisor\"},\"inspectorscan\":{\"prefix\":\"inspector-scan\",\"name\":\"InspectorScan\"},\"bcmdataexports\":{\"prefix\":\"bcm-data-exports\",\"name\":\"BCMDataExports\"},\"costoptimizationhub\":{\"prefix\":\"cost-optimization-hub\",\"name\":\"CostOptimizationHub\"},\"eksauth\":{\"prefix\":\"eks-auth\",\"name\":\"EKSAuth\"},\"freetier\":{\"name\":\"FreeTier\"},\"repostspace\":{\"name\":\"Repostspace\"},\"workspacesthinclient\":{\"prefix\":\"workspaces-thin-client\",\"name\":\"WorkSpacesThinClient\"},\"b2bi\":{\"name\":\"B2bi\"},\"bedrockagent\":{\"prefix\":\"bedrock-agent\",\"name\":\"BedrockAgent\"},\"bedrockagentruntime\":{\"prefix\":\"bedrock-agent-runtime\",\"name\":\"BedrockAgentRuntime\"},\"qbusiness\":{\"name\":\"QBusiness\"},\"qconnect\":{\"name\":\"QConnect\"},\"cleanroomsml\":{\"name\":\"CleanRoomsML\"},\"marketplaceagreement\":{\"prefix\":\"marketplace-agreement\",\"name\":\"MarketplaceAgreement\"},\"marketplacedeployment\":{\"prefix\":\"marketplace-deployment\",\"name\":\"MarketplaceDeployment\"},\"networkmonitor\":{\"name\":\"NetworkMonitor\"},\"supplychain\":{\"name\":\"SupplyChain\"},\"artifact\":{\"name\":\"Artifact\"},\"chatbot\":{\"name\":\"Chatbot\"},\"timestreaminfluxdb\":{\"prefix\":\"timestream-influxdb\",\"name\":\"TimestreamInfluxDB\"},\"codeconnections\":{\"name\":\"CodeConnections\"},\"deadline\":{\"name\":\"Deadline\"},\"controlcatalog\":{\"name\":\"ControlCatalog\"},\"route53profiles\":{\"name\":\"Route53Profiles\"},\"mailmanager\":{\"name\":\"MailManager\"},\"taxsettings\":{\"name\":\"TaxSettings\"},\"applicationsignals\":{\"prefix\":\"application-signals\",\"name\":\"ApplicationSignals\"},\"pcaconnectorscep\":{\"prefix\":\"pca-connector-scep\",\"name\":\"PcaConnectorScep\"},\"apptest\":{\"name\":\"AppTest\"},\"qapps\":{\"name\":\"QApps\"},\"ssmquicksetup\":{\"prefix\":\"ssm-quicksetup\",\"name\":\"SSMQuickSetup\"},\"pcs\":{\"name\":\"PCS\"}}");

});


parcelRegister("5T6Re", function(module, exports) {
function $4497689a1931aa7b$var$apiLoader(svc, version) {
    if (!$4497689a1931aa7b$var$apiLoader.services.hasOwnProperty(svc)) throw new Error('InvalidService: Failed to load api for ' + svc);
    return $4497689a1931aa7b$var$apiLoader.services[svc][version];
}
/**
 * @api private
 *
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */ $4497689a1931aa7b$var$apiLoader.services = {};
/**
 * @api private
 */ module.exports = $4497689a1931aa7b$var$apiLoader;

});

parcelRegister("14xpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dZhNC = parcelRequire("dZhNC");
var $0c8016436c462f9a$var$CACHE_SIZE = 1000;
/**
 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
 */ var $0c8016436c462f9a$var$EndpointCache = /** @class */ function() {
    function EndpointCache(maxSize) {
        if (maxSize === void 0) maxSize = $0c8016436c462f9a$var$CACHE_SIZE;
        this.maxSize = maxSize;
        this.cache = new $dZhNC.LRUCache(maxSize);
    }
    Object.defineProperty(EndpointCache.prototype, "size", {
        get: function() {
            return this.cache.length;
        },
        enumerable: true,
        configurable: true
    });
    EndpointCache.prototype.put = function(key, value) {
        var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        var endpointRecord = this.populateValue(value);
        this.cache.put(keyString, endpointRecord);
    };
    EndpointCache.prototype.get = function(key) {
        var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        var now = Date.now();
        var records = this.cache.get(keyString);
        if (records) {
            for(var i = records.length - 1; i >= 0; i--){
                var record = records[i];
                if (record.Expire < now) records.splice(i, 1);
            }
            if (records.length === 0) {
                this.cache.remove(keyString);
                return undefined;
            }
        }
        return records;
    };
    EndpointCache.getKeyString = function(key) {
        var identifiers = [];
        var identifierNames = Object.keys(key).sort();
        for(var i = 0; i < identifierNames.length; i++){
            var identifierName = identifierNames[i];
            if (key[identifierName] === undefined) continue;
            identifiers.push(key[identifierName]);
        }
        return identifiers.join(' ');
    };
    EndpointCache.prototype.populateValue = function(endpoints) {
        var now = Date.now();
        return endpoints.map(function(endpoint) {
            return {
                Address: endpoint.Address || '',
                Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60000
            };
        });
    };
    EndpointCache.prototype.empty = function() {
        this.cache.empty();
    };
    EndpointCache.prototype.remove = function(key) {
        var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        this.cache.remove(keyString);
    };
    return EndpointCache;
}();
module.exports.EndpointCache = $0c8016436c462f9a$var$EndpointCache;

});
parcelRegister("dZhNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a2eec776be9dfe41$var$LinkedListNode = /** @class */ function() {
    function LinkedListNode(key, value) {
        this.key = key;
        this.value = value;
    }
    return LinkedListNode;
}();
var $a2eec776be9dfe41$var$LRUCache = /** @class */ function() {
    function LRUCache(size) {
        this.nodeMap = {};
        this.size = 0;
        if (typeof size !== 'number' || size < 1) throw new Error('Cache size can only be positive number');
        this.sizeLimit = size;
    }
    Object.defineProperty(LRUCache.prototype, "length", {
        get: function() {
            return this.size;
        },
        enumerable: true,
        configurable: true
    });
    LRUCache.prototype.prependToList = function(node) {
        if (!this.headerNode) this.tailNode = node;
        else {
            this.headerNode.prev = node;
            node.next = this.headerNode;
        }
        this.headerNode = node;
        this.size++;
    };
    LRUCache.prototype.removeFromTail = function() {
        if (!this.tailNode) return undefined;
        var node = this.tailNode;
        var prevNode = node.prev;
        if (prevNode) prevNode.next = undefined;
        node.prev = undefined;
        this.tailNode = prevNode;
        this.size--;
        return node;
    };
    LRUCache.prototype.detachFromList = function(node) {
        if (this.headerNode === node) this.headerNode = node.next;
        if (this.tailNode === node) this.tailNode = node.prev;
        if (node.prev) node.prev.next = node.next;
        if (node.next) node.next.prev = node.prev;
        node.next = undefined;
        node.prev = undefined;
        this.size--;
    };
    LRUCache.prototype.get = function(key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            this.prependToList(node);
            return node.value;
        }
    };
    LRUCache.prototype.remove = function(key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    LRUCache.prototype.put = function(key, value) {
        if (this.nodeMap[key]) this.remove(key);
        else if (this.size === this.sizeLimit) {
            var tailNode = this.removeFromTail();
            var key_1 = tailNode.key;
            delete this.nodeMap[key_1];
        }
        var newNode = new $a2eec776be9dfe41$var$LinkedListNode(key, value);
        this.nodeMap[key] = newNode;
        this.prependToList(newNode);
    };
    LRUCache.prototype.empty = function() {
        var keys = Object.keys(this.nodeMap);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    return LRUCache;
}();
module.exports.LRUCache = $a2eec776be9dfe41$var$LRUCache;

});


parcelRegister("9WcNx", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
 *     Default to be false.
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */ $e2mZ5.SequentialExecutor = $e2mZ5.util.inherit({
    constructor: function SequentialExecutor() {
        this._events = {};
    },
    /**
   * @api private
   */ listeners: function listeners(eventName) {
        return this._events[eventName] ? this._events[eventName].slice(0) : [];
    },
    on: function on(eventName, listener, toHead) {
        if (this._events[eventName]) toHead ? this._events[eventName].unshift(listener) : this._events[eventName].push(listener);
        else this._events[eventName] = [
            listener
        ];
        return this;
    },
    onAsync: function onAsync(eventName, listener, toHead) {
        listener._isAsync = true;
        return this.on(eventName, listener, toHead);
    },
    removeListener: function removeListener(eventName, listener) {
        var listeners = this._events[eventName];
        if (listeners) {
            var length = listeners.length;
            var position = -1;
            for(var i = 0; i < length; ++i)if (listeners[i] === listener) position = i;
            if (position > -1) listeners.splice(position, 1);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners(eventName) {
        if (eventName) delete this._events[eventName];
        else this._events = {};
        return this;
    },
    /**
   * @api private
   */ emit: function emit(eventName, eventArgs, doneCallback) {
        if (!doneCallback) doneCallback = function() {};
        var listeners = this.listeners(eventName);
        var count = listeners.length;
        this.callListeners(listeners, eventArgs, doneCallback);
        return count > 0;
    },
    /**
   * @api private
   */ callListeners: function callListeners(listeners, args, doneCallback, prevError) {
        var self = this;
        var error = prevError || null;
        function callNextListener(err) {
            if (err) {
                error = $e2mZ5.util.error(error || new Error(), err);
                if (self._haltHandlersOnError) return doneCallback.call(self, error);
            }
            self.callListeners(listeners, args, doneCallback, error);
        }
        while(listeners.length > 0){
            var listener = listeners.shift();
            if (listener._isAsync) {
                listener.apply(self, args.concat([
                    callNextListener
                ]));
                return; // stop here, callNextListener will continue
            } else {
                try {
                    listener.apply(self, args);
                } catch (err) {
                    error = $e2mZ5.util.error(error || new Error(), err);
                }
                if (error && self._haltHandlersOnError) {
                    doneCallback.call(self, error);
                    return;
                }
            }
        }
        doneCallback.call(self, error);
    },
    /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */ addListeners: function addListeners(listeners) {
        var self = this;
        // extract listeners if parameter is an SequentialExecutor object
        if (listeners._events) listeners = listeners._events;
        $e2mZ5.util.each(listeners, function(event, callbacks) {
            if (typeof callbacks === 'function') callbacks = [
                callbacks
            ];
            $e2mZ5.util.arrayEach(callbacks, function(callback) {
                self.on(event, callback);
            });
        });
        return self;
    },
    /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */ addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
        this[name] = callback;
        this.addListener(eventName, callback, toHead);
        return this;
    },
    /**
   * @api private
   */ addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
        callback._isAsync = true;
        return this.addNamedListener(name, eventName, callback, toHead);
    },
    /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */ addNamedListeners: function addNamedListeners(callback) {
        var self = this;
        callback(function() {
            self.addNamedListener.apply(self, arguments);
        }, function() {
            self.addNamedAsyncListener.apply(self, arguments);
        });
        return this;
    }
});
/**
 * {on} is the prefered method.
 * @api private
 */ $e2mZ5.SequentialExecutor.prototype.addListener = $e2mZ5.SequentialExecutor.prototype.on;
/**
 * @api private
 */ module.exports = $e2mZ5.SequentialExecutor;

});

parcelRegister("7jEum", function(module, exports) {

var $89WEd = parcelRequire("89WEd");

var $e2mZ5 = parcelRequire("e2mZ5");

var $ewGti = parcelRequire("ewGti");

var $g4RWN = parcelRequire("g4RWN");
var $5539b6f85dc371f7$var$inherit = $e2mZ5.util.inherit;
var $5539b6f85dc371f7$var$clientCount = 0;

var $9qqX2 = parcelRequire("9qqX2");
/**
 * The service class representing an AWS service.
 *
 * @class_abstract This class is an abstract class.
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */ $e2mZ5.Service = $5539b6f85dc371f7$var$inherit({
    /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */ constructor: function Service(config) {
        if (!this.loadServiceClass) throw $e2mZ5.util.error(new Error(), 'Service must be constructed with `new\' operator');
        if (config) {
            if (config.region) {
                var region = config.region;
                if ($9qqX2.isFipsRegion(region)) {
                    config.region = $9qqX2.getRealRegion(region);
                    config.useFipsEndpoint = true;
                }
                if ($9qqX2.isGlobalRegion(region)) config.region = $9qqX2.getRealRegion(region);
            }
            if (typeof config.useDualstack === 'boolean' && typeof config.useDualstackEndpoint !== 'boolean') config.useDualstackEndpoint = config.useDualstack;
        }
        var ServiceClass = this.loadServiceClass(config || {});
        if (ServiceClass) {
            var originalConfig = $e2mZ5.util.copy(config);
            var svc = new ServiceClass(config);
            Object.defineProperty(svc, '_originalConfig', {
                get: function() {
                    return originalConfig;
                },
                enumerable: false,
                configurable: true
            });
            svc._clientId = ++$5539b6f85dc371f7$var$clientCount;
            return svc;
        }
        this.initialize(config);
    },
    /**
   * @api private
   */ initialize: function initialize(config) {
        var svcConfig = $e2mZ5.config[this.serviceIdentifier];
        this.config = new $e2mZ5.Config($e2mZ5.config);
        if (svcConfig) this.config.update(svcConfig, true);
        if (config) this.config.update(config, true);
        this.validateService();
        if (!this.config.endpoint) $g4RWN.configureEndpoint(this);
        this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
        this.setEndpoint(this.config.endpoint);
        //enable attaching listeners to service client
        $e2mZ5.SequentialExecutor.call(this);
        $e2mZ5.Service.addDefaultMonitoringListeners(this);
        if ((this.config.clientSideMonitoring || $e2mZ5.Service._clientSideMonitoring) && this.publisher) {
            var publisher = this.publisher;
            this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
                $89WEd.nextTick(function() {
                    publisher.eventHandler(event);
                });
            });
            this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
                $89WEd.nextTick(function() {
                    publisher.eventHandler(event);
                });
            });
        }
    },
    /**
   * @api private
   */ validateService: function validateService() {},
    /**
   * @api private
   */ loadServiceClass: function loadServiceClass(serviceConfig) {
        var config = serviceConfig;
        if (!$e2mZ5.util.isEmpty(this.api)) return null;
        else if (config.apiConfig) return $e2mZ5.Service.defineServiceApi(this.constructor, config.apiConfig);
        else if (!this.constructor.services) return null;
        else {
            config = new $e2mZ5.Config($e2mZ5.config);
            config.update(serviceConfig, true);
            var version = config.apiVersions[this.constructor.serviceIdentifier];
            version = version || config.apiVersion;
            return this.getLatestServiceClass(version);
        }
    },
    /**
   * @api private
   */ getLatestServiceClass: function getLatestServiceClass(version) {
        version = this.getLatestServiceVersion(version);
        if (this.constructor.services[version] === null) $e2mZ5.Service.defineServiceApi(this.constructor, version);
        return this.constructor.services[version];
    },
    /**
   * @api private
   */ getLatestServiceVersion: function getLatestServiceVersion(version) {
        if (!this.constructor.services || this.constructor.services.length === 0) throw new Error('No services defined on ' + this.constructor.serviceIdentifier);
        if (!version) version = 'latest';
        else if ($e2mZ5.util.isType(version, Date)) version = $e2mZ5.util.date.iso8601(version).split('T')[0];
        if (Object.hasOwnProperty(this.constructor.services, version)) return version;
        var keys = Object.keys(this.constructor.services).sort();
        var selectedVersion = null;
        for(var i = keys.length - 1; i >= 0; i--){
            // versions that end in "*" are not available on disk and can be
            // skipped, so do not choose these as selectedVersions
            if (keys[i][keys[i].length - 1] !== '*') selectedVersion = keys[i];
            if (keys[i].substr(0, 10) <= version) return selectedVersion;
        }
        throw new Error('Could not find ' + this.constructor.serviceIdentifier + ' API to satisfy version constraint `' + version + '\'');
    },
    /**
   * @api private
   */ api: {},
    /**
   * @api private
   */ defaultRetryCount: 3,
    /**
   * @api private
   */ customizeRequests: function customizeRequests(callback) {
        if (!callback) this.customRequestHandler = null;
        else if (typeof callback === 'function') this.customRequestHandler = callback;
        else throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    },
    /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ makeRequest: function makeRequest(operation, params, callback) {
        if (typeof params === 'function') {
            callback = params;
            params = null;
        }
        params = params || {};
        if (this.config.params) {
            var rules = this.api.operations[operation];
            if (rules) {
                params = $e2mZ5.util.copy(params);
                $e2mZ5.util.each(this.config.params, function(key, value) {
                    if (rules.input.members[key]) {
                        if (params[key] === undefined || params[key] === null) params[key] = value;
                    }
                });
            }
        }
        var request = new $e2mZ5.Request(this, operation, params);
        this.addAllRequestListeners(request);
        this.attachMonitoringEmitter(request);
        if (callback) request.send(callback);
        return request;
    },
    /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
        if (typeof params === 'function') {
            callback = params;
            params = {};
        }
        var request = this.makeRequest(operation, params).toUnauthenticated();
        return callback ? request.send(callback) : request;
    },
    /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ waitFor: function waitFor(state, params, callback) {
        var waiter = new $e2mZ5.ResourceWaiter(this, state);
        return waiter.wait(params, callback);
    },
    /**
   * @api private
   */ addAllRequestListeners: function addAllRequestListeners(request) {
        var list = [
            $e2mZ5.events,
            $e2mZ5.EventListeners.Core,
            this.serviceInterface(),
            $e2mZ5.EventListeners.CorePost
        ];
        for(var i = 0; i < list.length; i++)if (list[i]) request.addListeners(list[i]);
        // disable parameter validation
        if (!this.config.paramValidation) request.removeListener('validate', $e2mZ5.EventListeners.Core.VALIDATE_PARAMETERS);
        if (this.config.logger) request.addListeners($e2mZ5.EventListeners.Logger);
        this.setupRequestListeners(request);
        // call prototype's customRequestHandler
        if (typeof this.constructor.prototype.customRequestHandler === 'function') this.constructor.prototype.customRequestHandler(request);
        // call instance's customRequestHandler
        if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') this.customRequestHandler(request);
    },
    /**
   * Event recording metrics for a whole API call.
   * @returns {object} a subset of api call metrics
   * @api private
   */ apiCallEvent: function apiCallEvent(request) {
        var api = request.service.api.operations[request.operation];
        var monitoringEvent = {
            Type: 'ApiCall',
            Api: api ? api.name : request.operation,
            Version: 1,
            Service: request.service.api.serviceId || request.service.api.endpointPrefix,
            Region: request.httpRequest.region,
            MaxRetriesExceeded: 0,
            UserAgent: request.httpRequest.getUserAgent()
        };
        var response = request.response;
        if (response.httpResponse.statusCode) monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
        if (response.error) {
            var error = response.error;
            var statusCode = response.httpResponse.statusCode;
            if (statusCode > 299) {
                if (error.code) monitoringEvent.FinalAwsException = error.code;
                if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
            } else {
                if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
                if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
            }
        }
        return monitoringEvent;
    },
    /**
   * Event recording metrics for an API call attempt.
   * @returns {object} a subset of api call attempt metrics
   * @api private
   */ apiAttemptEvent: function apiAttemptEvent(request) {
        var api = request.service.api.operations[request.operation];
        var monitoringEvent = {
            Type: 'ApiCallAttempt',
            Api: api ? api.name : request.operation,
            Version: 1,
            Service: request.service.api.serviceId || request.service.api.endpointPrefix,
            Fqdn: request.httpRequest.endpoint.hostname,
            UserAgent: request.httpRequest.getUserAgent()
        };
        var response = request.response;
        if (response.httpResponse.statusCode) monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
        if (!request._unAuthenticated && request.service.config.credentials && request.service.config.credentials.accessKeyId) monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
        if (!response.httpResponse.headers) return monitoringEvent;
        if (request.httpRequest.headers['x-amz-security-token']) monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
        if (response.httpResponse.headers['x-amzn-requestid']) monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
        if (response.httpResponse.headers['x-amz-request-id']) monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
        if (response.httpResponse.headers['x-amz-id-2']) monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
        return monitoringEvent;
    },
    /**
   * Add metrics of failed request.
   * @api private
   */ attemptFailEvent: function attemptFailEvent(request) {
        var monitoringEvent = this.apiAttemptEvent(request);
        var response = request.response;
        var error = response.error;
        if (response.httpResponse.statusCode > 299) {
            if (error.code) monitoringEvent.AwsException = error.code;
            if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
        } else {
            if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
            if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
        }
        return monitoringEvent;
    },
    /**
   * Attach listeners to request object to fetch metrics of each request
   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
   * @api private
   */ attachMonitoringEmitter: function attachMonitoringEmitter(request) {
        var attemptTimestamp; //timestamp marking the beginning of a request attempt
        var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
        var attemptLatency; //latency from request sent out to http response reaching SDK
        var callStartRealTime; //Start time of API call. Used to calculating API call latency
        var attemptCount = 0; //request.retryCount is not reliable here
        var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
        var callTimestamp; //timestamp when the request is created
        var self = this;
        var addToHead = true;
        request.on('validate', function() {
            callStartRealTime = $e2mZ5.util.realClock.now();
            callTimestamp = Date.now();
        }, addToHead);
        request.on('sign', function() {
            attemptStartRealTime = $e2mZ5.util.realClock.now();
            attemptTimestamp = Date.now();
            region = request.httpRequest.region;
            attemptCount++;
        }, addToHead);
        request.on('validateResponse', function() {
            attemptLatency = Math.round($e2mZ5.util.realClock.now() - attemptStartRealTime);
        });
        request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
            var apiAttemptEvent = self.apiAttemptEvent(request);
            apiAttemptEvent.Timestamp = attemptTimestamp;
            apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
            apiAttemptEvent.Region = region;
            self.emit('apiCallAttempt', [
                apiAttemptEvent
            ]);
        });
        request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
            var apiAttemptEvent = self.attemptFailEvent(request);
            apiAttemptEvent.Timestamp = attemptTimestamp;
            //attemptLatency may not be available if fail before response
            attemptLatency = attemptLatency || Math.round($e2mZ5.util.realClock.now() - attemptStartRealTime);
            apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
            apiAttemptEvent.Region = region;
            self.emit('apiCallAttempt', [
                apiAttemptEvent
            ]);
        });
        request.addNamedListener('API_CALL', 'complete', function API_CALL() {
            var apiCallEvent = self.apiCallEvent(request);
            apiCallEvent.AttemptCount = attemptCount;
            if (apiCallEvent.AttemptCount <= 0) return;
            apiCallEvent.Timestamp = callTimestamp;
            var latency = Math.round($e2mZ5.util.realClock.now() - callStartRealTime);
            apiCallEvent.Latency = latency >= 0 ? latency : 0;
            var response = request.response;
            if (response.error && response.error.retryable && typeof response.retryCount === 'number' && typeof response.maxRetries === 'number' && response.retryCount >= response.maxRetries) apiCallEvent.MaxRetriesExceeded = 1;
            self.emit('apiCall', [
                apiCallEvent
            ]);
        });
    },
    /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @method_abstract This is an abstract method.
   */ setupRequestListeners: function setupRequestListeners(request) {},
    /**
   * Gets the signing name for a given request
   * @api private
   */ getSigningName: function getSigningName() {
        return this.api.signingName || this.api.endpointPrefix;
    },
    /**
   * Gets the signer class for a given request
   * @api private
   */ getSignerClass: function getSignerClass(request) {
        var version;
        // get operation authtype if present
        var operation = null;
        var authtype = '';
        if (request) {
            var operations = request.service.api.operations || {};
            operation = operations[request.operation] || null;
            authtype = operation ? operation.authtype : '';
        }
        if (this.config.signatureVersion) version = this.config.signatureVersion;
        else if (authtype === 'v4' || authtype === 'v4-unsigned-body') version = 'v4';
        else if (authtype === 'bearer') version = 'bearer';
        else version = this.api.signatureVersion;
        return $e2mZ5.Signers.RequestSigner.getVersion(version);
    },
    /**
   * @api private
   */ serviceInterface: function serviceInterface() {
        switch(this.api.protocol){
            case 'ec2':
                return $e2mZ5.EventListeners.Query;
            case 'query':
                return $e2mZ5.EventListeners.Query;
            case 'json':
                return $e2mZ5.EventListeners.Json;
            case 'rest-json':
                return $e2mZ5.EventListeners.RestJson;
            case 'rest-xml':
                return $e2mZ5.EventListeners.RestXml;
        }
        if (this.api.protocol) throw new Error('Invalid service `protocol\' ' + this.api.protocol + ' in API config');
    },
    /**
   * @api private
   */ successfulResponse: function successfulResponse(resp) {
        return resp.httpResponse.statusCode < 300;
    },
    /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */ numRetries: function numRetries() {
        if (this.config.maxRetries !== undefined) return this.config.maxRetries;
        else return this.defaultRetryCount;
    },
    /**
   * @api private
   */ retryDelays: function retryDelays(retryCount, err) {
        return $e2mZ5.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions, err);
    },
    /**
   * @api private
   */ retryableError: function retryableError(error) {
        if (this.timeoutError(error)) return true;
        if (this.networkingError(error)) return true;
        if (this.expiredCredentialsError(error)) return true;
        if (this.throttledError(error)) return true;
        if (error.statusCode >= 500) return true;
        return false;
    },
    /**
   * @api private
   */ networkingError: function networkingError(error) {
        return error.code === 'NetworkingError';
    },
    /**
   * @api private
   */ timeoutError: function timeoutError(error) {
        return error.code === 'TimeoutError';
    },
    /**
   * @api private
   */ expiredCredentialsError: function expiredCredentialsError(error) {
        // TODO : this only handles *one* of the expired credential codes
        return error.code === 'ExpiredTokenException';
    },
    /**
   * @api private
   */ clockSkewError: function clockSkewError(error) {
        switch(error.code){
            case 'RequestTimeTooSkewed':
            case 'RequestExpired':
            case 'InvalidSignatureException':
            case 'SignatureDoesNotMatch':
            case 'AuthFailure':
            case 'RequestInTheFuture':
                return true;
            default:
                return false;
        }
    },
    /**
   * @api private
   */ getSkewCorrectedDate: function getSkewCorrectedDate() {
        return new Date(Date.now() + this.config.systemClockOffset);
    },
    /**
   * @api private
   */ applyClockOffset: function applyClockOffset(newServerTime) {
        if (newServerTime) this.config.systemClockOffset = newServerTime - Date.now();
    },
    /**
   * @api private
   */ isClockSkewed: function isClockSkewed(newServerTime) {
        if (newServerTime) return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 300000;
    },
    /**
   * @api private
   */ throttledError: function throttledError(error) {
        // this logic varies between services
        if (error.statusCode === 429) return true;
        switch(error.code){
            case 'ProvisionedThroughputExceededException':
            case 'Throttling':
            case 'ThrottlingException':
            case 'RequestLimitExceeded':
            case 'RequestThrottled':
            case 'RequestThrottledException':
            case 'TooManyRequestsException':
            case 'TransactionInProgressException':
            case 'EC2ThrottledException':
                return true;
            default:
                return false;
        }
    },
    /**
   * @api private
   */ endpointFromTemplate: function endpointFromTemplate(endpoint) {
        if (typeof endpoint !== 'string') return endpoint;
        var e = endpoint;
        e = e.replace(/\{service\}/g, this.api.endpointPrefix);
        e = e.replace(/\{region\}/g, this.config.region);
        e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
        return e;
    },
    /**
   * @api private
   */ setEndpoint: function setEndpoint(endpoint) {
        this.endpoint = new $e2mZ5.Endpoint(endpoint, this.config);
    },
    /**
   * @api private
   */ paginationConfig: function paginationConfig(operation, throwException) {
        var paginator = this.api.operations[operation].paginator;
        if (!paginator) {
            if (throwException) {
                var e = new Error();
                throw $e2mZ5.util.error(e, 'No pagination configuration for ' + operation);
            }
            return null;
        }
        return paginator;
    }
});
$e2mZ5.util.update($e2mZ5.Service, {
    /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */ defineMethods: function defineMethods(svc) {
        $e2mZ5.util.each(svc.prototype.api.operations, function iterator(method) {
            if (svc.prototype[method]) return;
            var operation = svc.prototype.api.operations[method];
            if (operation.authtype === 'none') svc.prototype[method] = function(params, callback) {
                return this.makeUnauthenticatedRequest(method, params, callback);
            };
            else svc.prototype[method] = function(params, callback) {
                return this.makeRequest(method, params, callback);
            };
        });
    },
    /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */ defineService: function defineService(serviceIdentifier, versions, features) {
        $e2mZ5.Service._serviceMap[serviceIdentifier] = true;
        if (!Array.isArray(versions)) {
            features = versions;
            versions = [];
        }
        var svc = $5539b6f85dc371f7$var$inherit($e2mZ5.Service, features || {});
        if (typeof serviceIdentifier === 'string') {
            $e2mZ5.Service.addVersions(svc, versions);
            var identifier = svc.serviceIdentifier || serviceIdentifier;
            svc.serviceIdentifier = identifier;
        } else {
            svc.prototype.api = serviceIdentifier;
            $e2mZ5.Service.defineMethods(svc);
        }
        $e2mZ5.SequentialExecutor.call(this.prototype);
        //util.clientSideMonitoring is only available in node
        if (!this.prototype.publisher && $e2mZ5.util.clientSideMonitoring) {
            var Publisher = $e2mZ5.util.clientSideMonitoring.Publisher;
            var configProvider = $e2mZ5.util.clientSideMonitoring.configProvider;
            var publisherConfig = configProvider();
            this.prototype.publisher = new Publisher(publisherConfig);
            if (publisherConfig.enabled) //if csm is enabled in environment, SDK should send all metrics
            $e2mZ5.Service._clientSideMonitoring = true;
        }
        $e2mZ5.SequentialExecutor.call(svc.prototype);
        $e2mZ5.Service.addDefaultMonitoringListeners(svc.prototype);
        return svc;
    },
    /**
   * @api private
   */ addVersions: function addVersions(svc, versions) {
        if (!Array.isArray(versions)) versions = [
            versions
        ];
        svc.services = svc.services || {};
        for(var i = 0; i < versions.length; i++)if (svc.services[versions[i]] === undefined) svc.services[versions[i]] = null;
        svc.apiVersions = Object.keys(svc.services).sort();
    },
    /**
   * @api private
   */ defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
        var svc = $5539b6f85dc371f7$var$inherit(superclass, {
            serviceIdentifier: superclass.serviceIdentifier
        });
        function setApi(api) {
            if (api.isApi) svc.prototype.api = api;
            else svc.prototype.api = new $ewGti(api, {
                serviceIdentifier: superclass.serviceIdentifier
            });
        }
        if (typeof version === 'string') {
            if (apiConfig) setApi(apiConfig);
            else try {
                setApi($e2mZ5.apiLoader(superclass.serviceIdentifier, version));
            } catch (err) {
                throw $e2mZ5.util.error(err, {
                    message: 'Could not find API configuration ' + superclass.serviceIdentifier + '-' + version
                });
            }
            if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) superclass.apiVersions = superclass.apiVersions.concat(version).sort();
            superclass.services[version] = svc;
        } else setApi(version);
        $e2mZ5.Service.defineMethods(svc);
        return svc;
    },
    /**
   * @api private
   */ hasService: function(identifier) {
        return Object.prototype.hasOwnProperty.call($e2mZ5.Service._serviceMap, identifier);
    },
    /**
   * @param attachOn attach default monitoring listeners to object
   *
   * Each monitoring event should be emitted from service client to service constructor prototype and then
   * to global service prototype like bubbling up. These default monitoring events listener will transfer
   * the monitoring events to the upper layer.
   * @api private
   */ addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
        attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
            var baseClass = Object.getPrototypeOf(attachOn);
            if (baseClass._events) baseClass.emit('apiCallAttempt', [
                event
            ]);
        });
        attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
            var baseClass = Object.getPrototypeOf(attachOn);
            if (baseClass._events) baseClass.emit('apiCall', [
                event
            ]);
        });
    },
    /**
   * @api private
   */ _serviceMap: {}
});
$e2mZ5.util.mixin($e2mZ5.Service, $e2mZ5.SequentialExecutor);
/**
 * @api private
 */ module.exports = $e2mZ5.Service;

});
parcelRegister("g4RWN", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $amMNL = parcelRequire("amMNL");
function $bb46dddae5c1eda3$var$generateRegionPrefix(region) {
    if (!region) return null;
    var parts = region.split('-');
    if (parts.length < 3) return null;
    return parts.slice(0, parts.length - 2).join('-') + '-*';
}
function $bb46dddae5c1eda3$var$derivedKeys(service) {
    var region = service.config.region;
    var regionPrefix = $bb46dddae5c1eda3$var$generateRegionPrefix(region);
    var endpointPrefix = service.api.endpointPrefix;
    return [
        [
            region,
            endpointPrefix
        ],
        [
            regionPrefix,
            endpointPrefix
        ],
        [
            region,
            '*'
        ],
        [
            regionPrefix,
            '*'
        ],
        [
            '*',
            endpointPrefix
        ],
        [
            region,
            'internal-*'
        ],
        [
            '*',
            '*'
        ]
    ].map(function(item) {
        return item[0] && item[1] ? item.join('/') : null;
    });
}
function $bb46dddae5c1eda3$var$applyConfig(service, config) {
    $1ymo4.each(config, function(key, value) {
        if (key === 'globalEndpoint') return;
        if (service.config[key] === undefined || service.config[key] === null) service.config[key] = value;
    });
}
function $bb46dddae5c1eda3$var$configureEndpoint(service) {
    var keys = $bb46dddae5c1eda3$var$derivedKeys(service);
    var useFipsEndpoint = service.config.useFipsEndpoint;
    var useDualstackEndpoint = service.config.useDualstackEndpoint;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!key) continue;
        var rules = useFipsEndpoint ? useDualstackEndpoint ? $amMNL.dualstackFipsRules : $amMNL.fipsRules : useDualstackEndpoint ? $amMNL.dualstackRules : $amMNL.rules;
        if (Object.prototype.hasOwnProperty.call(rules, key)) {
            var config = rules[key];
            if (typeof config === 'string') config = $amMNL.patterns[config];
            // set global endpoint
            service.isGlobalEndpoint = !!config.globalEndpoint;
            if (config.signingRegion) service.signingRegion = config.signingRegion;
            // signature version
            if (!config.signatureVersion) // Note: config is a global object and should not be mutated here.
            // However, we are retaining this line for backwards compatibility.
            // The non-v4 signatureVersion will be set in a copied object below.
            config.signatureVersion = 'v4';
            var useBearer = (service.api && service.api.signatureVersion) === 'bearer';
            // merge config
            $bb46dddae5c1eda3$var$applyConfig(service, Object.assign({}, config, {
                signatureVersion: useBearer ? 'bearer' : config.signatureVersion
            }));
            return;
        }
    }
}
function $bb46dddae5c1eda3$var$getEndpointSuffix(region) {
    var regionRegexes = {
        '^(us|eu|ap|sa|ca|me)\\-\\w+\\-\\d+$': 'amazonaws.com',
        '^cn\\-\\w+\\-\\d+$': 'amazonaws.com.cn',
        '^us\\-gov\\-\\w+\\-\\d+$': 'amazonaws.com',
        '^us\\-iso\\-\\w+\\-\\d+$': 'c2s.ic.gov',
        '^us\\-isob\\-\\w+\\-\\d+$': 'sc2s.sgov.gov',
        '^eu\\-isoe\\-west\\-1$': 'cloud.adc-e.uk',
        '^us\\-isof\\-\\w+\\-\\d+$': 'csp.hci.ic.gov'
    };
    var defaultSuffix = 'amazonaws.com';
    var regexes = Object.keys(regionRegexes);
    for(var i = 0; i < regexes.length; i++){
        var regionPattern = RegExp(regexes[i]);
        var dnsSuffix = regionRegexes[regexes[i]];
        if (regionPattern.test(region)) return dnsSuffix;
    }
    return defaultSuffix;
}
/**
 * @api private
 */ module.exports = {
    configureEndpoint: $bb46dddae5c1eda3$var$configureEndpoint,
    getEndpointSuffix: $bb46dddae5c1eda3$var$getEndpointSuffix
};

});
parcelRegister("amMNL", function(module, exports) {
module.exports = JSON.parse("{\"rules\":{\"*/*\":{\"endpoint\":\"{service}.{region}.amazonaws.com\"},\"cn-*/*\":{\"endpoint\":\"{service}.{region}.amazonaws.com.cn\"},\"eu-isoe-*/*\":\"euIsoe\",\"us-iso-*/*\":\"usIso\",\"us-isob-*/*\":\"usIsob\",\"us-isof-*/*\":\"usIsof\",\"*/budgets\":\"globalSSL\",\"*/cloudfront\":\"globalSSL\",\"*/sts\":\"globalSSL\",\"*/importexport\":{\"endpoint\":\"{service}.amazonaws.com\",\"signatureVersion\":\"v2\",\"globalEndpoint\":true},\"*/route53\":\"globalSSL\",\"cn-*/route53\":{\"endpoint\":\"{service}.amazonaws.com.cn\",\"globalEndpoint\":true,\"signingRegion\":\"cn-northwest-1\"},\"us-gov-*/route53\":\"globalGovCloud\",\"us-iso-*/route53\":{\"endpoint\":\"{service}.c2s.ic.gov\",\"globalEndpoint\":true,\"signingRegion\":\"us-iso-east-1\"},\"us-isob-*/route53\":{\"endpoint\":\"{service}.sc2s.sgov.gov\",\"globalEndpoint\":true,\"signingRegion\":\"us-isob-east-1\"},\"us-isof-*/route53\":\"globalUsIsof\",\"eu-isoe-*/route53\":\"globalEuIsoe\",\"*/waf\":\"globalSSL\",\"*/iam\":\"globalSSL\",\"cn-*/iam\":{\"endpoint\":\"{service}.cn-north-1.amazonaws.com.cn\",\"globalEndpoint\":true,\"signingRegion\":\"cn-north-1\"},\"us-iso-*/iam\":{\"endpoint\":\"{service}.us-iso-east-1.c2s.ic.gov\",\"globalEndpoint\":true,\"signingRegion\":\"us-iso-east-1\"},\"us-gov-*/iam\":\"globalGovCloud\",\"*/ce\":{\"endpoint\":\"{service}.us-east-1.amazonaws.com\",\"globalEndpoint\":true,\"signingRegion\":\"us-east-1\"},\"cn-*/ce\":{\"endpoint\":\"{service}.cn-northwest-1.amazonaws.com.cn\",\"globalEndpoint\":true,\"signingRegion\":\"cn-northwest-1\"},\"us-gov-*/sts\":{\"endpoint\":\"{service}.{region}.amazonaws.com\"},\"us-gov-west-1/s3\":\"s3signature\",\"us-west-1/s3\":\"s3signature\",\"us-west-2/s3\":\"s3signature\",\"eu-west-1/s3\":\"s3signature\",\"ap-southeast-1/s3\":\"s3signature\",\"ap-southeast-2/s3\":\"s3signature\",\"ap-northeast-1/s3\":\"s3signature\",\"sa-east-1/s3\":\"s3signature\",\"us-east-1/s3\":{\"endpoint\":\"{service}.amazonaws.com\",\"signatureVersion\":\"s3\"},\"us-east-1/sdb\":{\"endpoint\":\"{service}.amazonaws.com\",\"signatureVersion\":\"v2\"},\"*/sdb\":{\"endpoint\":\"{service}.{region}.amazonaws.com\",\"signatureVersion\":\"v2\"},\"*/resource-explorer-2\":\"dualstackByDefault\",\"*/kendra-ranking\":\"dualstackByDefault\",\"*/internetmonitor\":\"dualstackByDefault\",\"*/codecatalyst\":\"globalDualstackByDefault\"},\"fipsRules\":{\"*/*\":\"fipsStandard\",\"us-gov-*/*\":\"fipsStandard\",\"us-iso-*/*\":{\"endpoint\":\"{service}-fips.{region}.c2s.ic.gov\"},\"us-iso-*/dms\":\"usIso\",\"us-isob-*/*\":{\"endpoint\":\"{service}-fips.{region}.sc2s.sgov.gov\"},\"us-isob-*/dms\":\"usIsob\",\"cn-*/*\":{\"endpoint\":\"{service}-fips.{region}.amazonaws.com.cn\"},\"*/api.ecr\":\"fips.api.ecr\",\"*/api.sagemaker\":\"fips.api.sagemaker\",\"*/batch\":\"fipsDotPrefix\",\"*/eks\":\"fipsDotPrefix\",\"*/models.lex\":\"fips.models.lex\",\"*/runtime.lex\":\"fips.runtime.lex\",\"*/runtime.sagemaker\":{\"endpoint\":\"runtime-fips.sagemaker.{region}.amazonaws.com\"},\"*/iam\":\"fipsWithoutRegion\",\"*/route53\":\"fipsWithoutRegion\",\"*/transcribe\":\"fipsDotPrefix\",\"*/waf\":\"fipsWithoutRegion\",\"us-gov-*/transcribe\":\"fipsDotPrefix\",\"us-gov-*/api.ecr\":\"fips.api.ecr\",\"us-gov-*/models.lex\":\"fips.models.lex\",\"us-gov-*/runtime.lex\":\"fips.runtime.lex\",\"us-gov-*/access-analyzer\":\"fipsWithServiceOnly\",\"us-gov-*/acm\":\"fipsWithServiceOnly\",\"us-gov-*/acm-pca\":\"fipsWithServiceOnly\",\"us-gov-*/api.sagemaker\":\"fipsWithServiceOnly\",\"us-gov-*/appconfig\":\"fipsWithServiceOnly\",\"us-gov-*/application-autoscaling\":\"fipsWithServiceOnly\",\"us-gov-*/autoscaling\":\"fipsWithServiceOnly\",\"us-gov-*/autoscaling-plans\":\"fipsWithServiceOnly\",\"us-gov-*/batch\":\"fipsWithServiceOnly\",\"us-gov-*/cassandra\":\"fipsWithServiceOnly\",\"us-gov-*/clouddirectory\":\"fipsWithServiceOnly\",\"us-gov-*/cloudformation\":\"fipsWithServiceOnly\",\"us-gov-*/cloudshell\":\"fipsWithServiceOnly\",\"us-gov-*/cloudtrail\":\"fipsWithServiceOnly\",\"us-gov-*/config\":\"fipsWithServiceOnly\",\"us-gov-*/connect\":\"fipsWithServiceOnly\",\"us-gov-*/databrew\":\"fipsWithServiceOnly\",\"us-gov-*/dlm\":\"fipsWithServiceOnly\",\"us-gov-*/dms\":\"fipsWithServiceOnly\",\"us-gov-*/dynamodb\":\"fipsWithServiceOnly\",\"us-gov-*/ec2\":\"fipsWithServiceOnly\",\"us-gov-*/eks\":\"fipsWithServiceOnly\",\"us-gov-*/elasticache\":\"fipsWithServiceOnly\",\"us-gov-*/elasticbeanstalk\":\"fipsWithServiceOnly\",\"us-gov-*/elasticloadbalancing\":\"fipsWithServiceOnly\",\"us-gov-*/elasticmapreduce\":\"fipsWithServiceOnly\",\"us-gov-*/events\":\"fipsWithServiceOnly\",\"us-gov-*/fis\":\"fipsWithServiceOnly\",\"us-gov-*/glacier\":\"fipsWithServiceOnly\",\"us-gov-*/greengrass\":\"fipsWithServiceOnly\",\"us-gov-*/guardduty\":\"fipsWithServiceOnly\",\"us-gov-*/identitystore\":\"fipsWithServiceOnly\",\"us-gov-*/imagebuilder\":\"fipsWithServiceOnly\",\"us-gov-*/kafka\":\"fipsWithServiceOnly\",\"us-gov-*/kinesis\":\"fipsWithServiceOnly\",\"us-gov-*/logs\":\"fipsWithServiceOnly\",\"us-gov-*/mediaconvert\":\"fipsWithServiceOnly\",\"us-gov-*/monitoring\":\"fipsWithServiceOnly\",\"us-gov-*/networkmanager\":\"fipsWithServiceOnly\",\"us-gov-*/organizations\":\"fipsWithServiceOnly\",\"us-gov-*/outposts\":\"fipsWithServiceOnly\",\"us-gov-*/participant.connect\":\"fipsWithServiceOnly\",\"us-gov-*/ram\":\"fipsWithServiceOnly\",\"us-gov-*/rds\":\"fipsWithServiceOnly\",\"us-gov-*/redshift\":\"fipsWithServiceOnly\",\"us-gov-*/resource-groups\":\"fipsWithServiceOnly\",\"us-gov-*/runtime.sagemaker\":\"fipsWithServiceOnly\",\"us-gov-*/serverlessrepo\":\"fipsWithServiceOnly\",\"us-gov-*/servicecatalog-appregistry\":\"fipsWithServiceOnly\",\"us-gov-*/servicequotas\":\"fipsWithServiceOnly\",\"us-gov-*/sns\":\"fipsWithServiceOnly\",\"us-gov-*/sqs\":\"fipsWithServiceOnly\",\"us-gov-*/ssm\":\"fipsWithServiceOnly\",\"us-gov-*/streams.dynamodb\":\"fipsWithServiceOnly\",\"us-gov-*/sts\":\"fipsWithServiceOnly\",\"us-gov-*/support\":\"fipsWithServiceOnly\",\"us-gov-*/swf\":\"fipsWithServiceOnly\",\"us-gov-west-1/states\":\"fipsWithServiceOnly\",\"us-iso-east-1/elasticfilesystem\":{\"endpoint\":\"elasticfilesystem-fips.{region}.c2s.ic.gov\"},\"us-gov-west-1/organizations\":\"fipsWithServiceOnly\",\"us-gov-west-1/route53\":{\"endpoint\":\"route53.us-gov.amazonaws.com\"},\"*/resource-explorer-2\":\"fipsDualstackByDefault\",\"*/kendra-ranking\":\"dualstackByDefault\",\"*/internetmonitor\":\"dualstackByDefault\",\"*/codecatalyst\":\"fipsGlobalDualstackByDefault\"},\"dualstackRules\":{\"*/*\":{\"endpoint\":\"{service}.{region}.api.aws\"},\"cn-*/*\":{\"endpoint\":\"{service}.{region}.api.amazonwebservices.com.cn\"},\"*/s3\":\"dualstackLegacy\",\"cn-*/s3\":\"dualstackLegacyCn\",\"*/s3-control\":\"dualstackLegacy\",\"cn-*/s3-control\":\"dualstackLegacyCn\",\"ap-south-1/ec2\":\"dualstackLegacyEc2\",\"eu-west-1/ec2\":\"dualstackLegacyEc2\",\"sa-east-1/ec2\":\"dualstackLegacyEc2\",\"us-east-1/ec2\":\"dualstackLegacyEc2\",\"us-east-2/ec2\":\"dualstackLegacyEc2\",\"us-west-2/ec2\":\"dualstackLegacyEc2\"},\"dualstackFipsRules\":{\"*/*\":{\"endpoint\":\"{service}-fips.{region}.api.aws\"},\"cn-*/*\":{\"endpoint\":\"{service}-fips.{region}.api.amazonwebservices.com.cn\"},\"*/s3\":\"dualstackFipsLegacy\",\"cn-*/s3\":\"dualstackFipsLegacyCn\",\"*/s3-control\":\"dualstackFipsLegacy\",\"cn-*/s3-control\":\"dualstackFipsLegacyCn\"},\"patterns\":{\"globalSSL\":{\"endpoint\":\"https://{service}.amazonaws.com\",\"globalEndpoint\":true,\"signingRegion\":\"us-east-1\"},\"globalGovCloud\":{\"endpoint\":\"{service}.us-gov.amazonaws.com\",\"globalEndpoint\":true,\"signingRegion\":\"us-gov-west-1\"},\"globalUsIsof\":{\"endpoint\":\"{service}.csp.hci.ic.gov\",\"globalEndpoint\":true,\"signingRegion\":\"us-isof-south-1\"},\"globalEuIsoe\":{\"endpoint\":\"{service}.cloud.adc-e.uk\",\"globalEndpoint\":true,\"signingRegion\":\"eu-isoe-west-1\"},\"s3signature\":{\"endpoint\":\"{service}.{region}.amazonaws.com\",\"signatureVersion\":\"s3\"},\"euIsoe\":{\"endpoint\":\"{service}.{region}.cloud.adc-e.uk\"},\"usIso\":{\"endpoint\":\"{service}.{region}.c2s.ic.gov\"},\"usIsob\":{\"endpoint\":\"{service}.{region}.sc2s.sgov.gov\"},\"usIsof\":{\"endpoint\":\"{service}.{region}.csp.hci.ic.gov\"},\"fipsStandard\":{\"endpoint\":\"{service}-fips.{region}.amazonaws.com\"},\"fipsDotPrefix\":{\"endpoint\":\"fips.{service}.{region}.amazonaws.com\"},\"fipsWithoutRegion\":{\"endpoint\":\"{service}-fips.amazonaws.com\"},\"fips.api.ecr\":{\"endpoint\":\"ecr-fips.{region}.amazonaws.com\"},\"fips.api.sagemaker\":{\"endpoint\":\"api-fips.sagemaker.{region}.amazonaws.com\"},\"fips.models.lex\":{\"endpoint\":\"models-fips.lex.{region}.amazonaws.com\"},\"fips.runtime.lex\":{\"endpoint\":\"runtime-fips.lex.{region}.amazonaws.com\"},\"fipsWithServiceOnly\":{\"endpoint\":\"{service}.{region}.amazonaws.com\"},\"dualstackLegacy\":{\"endpoint\":\"{service}.dualstack.{region}.amazonaws.com\"},\"dualstackLegacyCn\":{\"endpoint\":\"{service}.dualstack.{region}.amazonaws.com.cn\"},\"dualstackFipsLegacy\":{\"endpoint\":\"{service}-fips.dualstack.{region}.amazonaws.com\"},\"dualstackFipsLegacyCn\":{\"endpoint\":\"{service}-fips.dualstack.{region}.amazonaws.com.cn\"},\"dualstackLegacyEc2\":{\"endpoint\":\"api.ec2.{region}.aws\"},\"dualstackByDefault\":{\"endpoint\":\"{service}.{region}.api.aws\"},\"fipsDualstackByDefault\":{\"endpoint\":\"{service}-fips.{region}.api.aws\"},\"globalDualstackByDefault\":{\"endpoint\":\"{service}.global.api.aws\"},\"fipsGlobalDualstackByDefault\":{\"endpoint\":\"{service}-fips.global.api.aws\"}}}");

});


parcelRegister("9qqX2", function(module, exports) {
function $6dcb72bb1fcd59f8$var$isFipsRegion(region) {
    return typeof region === 'string' && (region.startsWith('fips-') || region.endsWith('-fips'));
}
function $6dcb72bb1fcd59f8$var$isGlobalRegion(region) {
    return typeof region === 'string' && [
        'aws-global',
        'aws-us-gov-global'
    ].includes(region);
}
function $6dcb72bb1fcd59f8$var$getRealRegion(region) {
    return [
        'fips-aws-global',
        'aws-fips',
        'aws-global'
    ].includes(region) ? 'us-east-1' : [
        'fips-aws-us-gov-global',
        'aws-us-gov-global'
    ].includes(region) ? 'us-gov-west-1' : region.replace(/fips-(dkr-|prod-)?|-fips/, '');
}
module.exports = {
    isFipsRegion: $6dcb72bb1fcd59f8$var$isFipsRegion,
    isGlobalRegion: $6dcb72bb1fcd59f8$var$isGlobalRegion,
    getRealRegion: $6dcb72bb1fcd59f8$var$getRealRegion
};

});


parcelRegister("43MiT", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
parcelRequire("kO0Co");
parcelRequire("cimjr");
var $2f4ce9536c0c48a7$var$PromisesDependency;
/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 and SQS only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute s3UsEast1RegionalEndpoint
 *   @return ['legacy'|'regional'] when region is set to 'us-east-1', whether to send s3
 *     request to global endpoints or 'us-east-1' regional endpoints. This config is only
 *     applicable to S3 client;
 *     Defaults to 'legacy'
 * @!attribute s3UseArnRegion
 *   @return [Boolean] whether to override the request region with the region inferred
 *     from requested resource's ARN. Only available for S3 buckets
 *     Defaults to `true`
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount, err) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a
 *       retry count and error and returns the amount of time to delay in
 *       milliseconds. If the result is a non-zero negative value, no further
 *       retry attempts will be made. The `base` option will be ignored if this
 *       option is supplied. The function is only called for retryable errors.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; The number of milliseconds a request can
 *       take before automatically being terminated.
 *       Defaults to two minutes (120000).
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 *
 * @!attribute endpointDiscoveryEnabled
 *   @return [Boolean|undefined] whether to call operations with endpoints
 *     given by service dynamically. Setting this config to `true` will enable
 *     endpoint discovery for all applicable operations. Setting it to `false`
 *     will explicitly disable endpoint discovery even though operations that
 *     require endpoint discovery will presumably fail. Leaving it to
 *     `undefined` means SDK only do endpoint discovery when it's required.
 *     Defaults to `undefined`
 *
 * @!attribute endpointCacheSize
 *   @return [Number] the size of the global cache storing endpoints from endpoint
 *     discovery operations. Once endpoint cache is created, updating this setting
 *     cannot change existing cache size.
 *     Defaults to 1000
 *
 * @!attribute hostPrefixEnabled
 *   @return [Boolean] whether to marshal request parameters to the prefix of
 *     hostname. Defaults to `true`.
 *
 * @!attribute stsRegionalEndpoints
 *   @return ['legacy'|'regional'] whether to send sts request to global endpoints or
 *     regional endpoints.
 *     Defaults to 'legacy'.
 *
 * @!attribute useFipsEndpoint
 *   @return [Boolean] Enables FIPS compatible endpoints. Defaults to `false`.
 *
 * @!attribute useDualstackEndpoint
 *   @return [Boolean] Enables IPv6 dualstack endpoint. Defaults to `false`.
 */ $e2mZ5.Config = $e2mZ5.util.inherit({
    /**
   * @!endgroup
   */ /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   * @option options s3UsEast1RegionalEndpoint ['legacy'|'regional'] when region
   *   is set to 'us-east-1', whether to send s3 request to global endpoints or
   *   'us-east-1' regional endpoints. This config is only applicable to S3 client.
   *   Defaults to `legacy`
   * @option options s3UseArnRegion [Boolean] whether to override the request region
   *   with the region inferred from requested resource's ARN. Only available for S3 buckets
   *   Defaults to `true`
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a
   *     retry count and error and returns the amount of time to delay in
   *     milliseconds. If the result is a non-zero negative value, no further
   *     retry attempts will be made. The `base` option will be ignored if this
   *     option is supplied. The function is only called for retryable errors.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   * @option options useAccelerateEndpoint [Boolean] Whether to use the
   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
   * @option options clientSideMonitoring [Boolean] whether to collect and
   *   publish this client's performance metrics of all its API requests.
   * @option options endpointDiscoveryEnabled [Boolean|undefined] whether to
   *   call operations with endpoints given by service dynamically. Setting this
   * config to `true` will enable endpoint discovery for all applicable operations.
   *   Setting it to `false` will explicitly disable endpoint discovery even though
   *   operations that require endpoint discovery will presumably fail. Leaving it
   *   to `undefined` means SDK will only do endpoint discovery when it's required.
   *   Defaults to `undefined`
   * @option options endpointCacheSize [Number] the size of the global cache storing
   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
   *   updating this setting cannot change existing cache size.
   *   Defaults to 1000
   * @option options hostPrefixEnabled [Boolean] whether to marshal request
   *   parameters to the prefix of hostname.
   *   Defaults to `true`.
   * @option options stsRegionalEndpoints ['legacy'|'regional'] whether to send sts request
   *   to global endpoints or regional endpoints.
   *   Defaults to 'legacy'.
   * @option options useFipsEndpoint [Boolean] Enables FIPS compatible endpoints.
   *   Defaults to `false`.
   * @option options useDualstackEndpoint [Boolean] Enables IPv6 dualstack endpoint.
   *   Defaults to `false`.
   */ constructor: function Config(options) {
        if (options === undefined) options = {};
        options = this.extractCredentials(options);
        $e2mZ5.util.each.call(this, this.keys, function(key, value) {
            this.set(key, options[key], value);
        });
    },
    /**
   * @!group Managing Credentials
   */ /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */ getCredentials: function getCredentials(callback) {
        var self = this;
        function finish(err) {
            callback(err, err ? null : self.credentials);
        }
        function credError(msg, err) {
            return new $e2mZ5.util.error(err || new Error(), {
                code: 'CredentialsError',
                message: msg,
                name: 'CredentialsError'
            });
        }
        function getAsyncCredentials() {
            self.credentials.get(function(err) {
                if (err) {
                    var msg = 'Could not load credentials from ' + self.credentials.constructor.name;
                    err = credError(msg, err);
                }
                finish(err);
            });
        }
        function getStaticCredentials() {
            var err = null;
            if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) err = credError('Missing credentials');
            finish(err);
        }
        if (self.credentials) {
            if (typeof self.credentials.get === 'function') getAsyncCredentials();
            else getStaticCredentials();
        } else if (self.credentialProvider) self.credentialProvider.resolve(function(err, creds) {
            if (err) err = credError('Could not load credentials from any providers', err);
            self.credentials = creds;
            finish(err);
        });
        else finish(credError('No credentials to load'));
    },
    /**
   * Loads token from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Token} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your token is loaded prior to a request, you can use this method
   * directly to provide accurate token data stored in the object.
   *
   * @note If you configure the SDK with static token, the token data should
   *   already be present in {token} attribute. This method is primarily necessary
   *   to load token from asynchronous sources, or sources that can refresh
   *   token periodically.
   * @example Getting your access token
   *   AWS.config.getToken(function(err) {
   *     if (err) console.log(err.stack); // token not loaded
   *     else console.log("Token:", AWS.config.token.token);
   *   })
   * @callback callback function(err)
   *   Called when the {token} have been properly set on the configuration object.
   *
   *   @param err [Error] if this is set, token was not successfully loaded and
   *     this error provides information why.
   * @see token
   */ getToken: function getToken(callback) {
        var self = this;
        function finish(err) {
            callback(err, err ? null : self.token);
        }
        function tokenError(msg, err) {
            return new $e2mZ5.util.error(err || new Error(), {
                code: 'TokenError',
                message: msg,
                name: 'TokenError'
            });
        }
        function getAsyncToken() {
            self.token.get(function(err) {
                if (err) {
                    var msg = 'Could not load token from ' + self.token.constructor.name;
                    err = tokenError(msg, err);
                }
                finish(err);
            });
        }
        function getStaticToken() {
            var err = null;
            if (!self.token.token) err = tokenError('Missing token');
            finish(err);
        }
        if (self.token) {
            if (typeof self.token.get === 'function') getAsyncToken();
            else getStaticToken();
        } else if (self.tokenProvider) self.tokenProvider.resolve(function(err, token) {
            if (err) err = tokenError('Could not load token from any providers', err);
            self.token = token;
            finish(err);
        });
        else finish(tokenError('No token to load'));
    },
    /**
   * @!group Loading and Setting Configuration Options
   */ /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */ update: function update(options, allowUnknownKeys) {
        allowUnknownKeys = allowUnknownKeys || false;
        options = this.extractCredentials(options);
        $e2mZ5.util.each.call(this, options, function(key, value) {
            if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) || $e2mZ5.Service.hasService(key)) this.set(key, value);
        });
    },
    /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */ loadFromPath: function loadFromPath(path) {
        this.clear();
        var options = JSON.parse($e2mZ5.util.readFileSync(path));
        var fileSystemCreds = new $e2mZ5.FileSystemCredentials(path);
        var chain = new $e2mZ5.CredentialProviderChain();
        chain.providers.unshift(fileSystemCreds);
        chain.resolve(function(err, creds) {
            if (err) throw err;
            else options.credentials = creds;
        });
        this.constructor(options);
        return this;
    },
    /**
   * Clears configuration data on this object
   *
   * @api private
   */ clear: function clear() {
        /*jshint forin:false */ $e2mZ5.util.each.call(this, this.keys, function(key) {
            delete this[key];
        });
        // reset credential provider
        this.set('credentials', undefined);
        this.set('credentialProvider', undefined);
    },
    /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */ set: function set(property, value, defaultValue) {
        if (value === undefined) {
            if (defaultValue === undefined) defaultValue = this.keys[property];
            if (typeof defaultValue === 'function') this[property] = defaultValue.call(this);
            else this[property] = defaultValue;
        } else if (property === 'httpOptions' && this[property]) // deep merge httpOptions
        this[property] = $e2mZ5.util.merge(this[property], value);
        else this[property] = value;
    },
    /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */ keys: {
        credentials: null,
        credentialProvider: null,
        region: null,
        logger: null,
        apiVersions: {},
        apiVersion: null,
        endpoint: undefined,
        httpOptions: {
            timeout: 120000
        },
        maxRetries: undefined,
        maxRedirects: 10,
        paramValidation: true,
        sslEnabled: true,
        s3ForcePathStyle: false,
        s3BucketEndpoint: false,
        s3DisableBodySigning: true,
        s3UsEast1RegionalEndpoint: 'legacy',
        s3UseArnRegion: undefined,
        computeChecksums: true,
        convertResponseTypes: true,
        correctClockSkew: false,
        customUserAgent: null,
        dynamoDbCrc32: true,
        systemClockOffset: 0,
        signatureVersion: null,
        signatureCache: true,
        retryDelayOptions: {},
        useAccelerateEndpoint: false,
        clientSideMonitoring: false,
        endpointDiscoveryEnabled: undefined,
        endpointCacheSize: 1000,
        hostPrefixEnabled: true,
        stsRegionalEndpoints: 'legacy',
        useFipsEndpoint: false,
        useDualstackEndpoint: false,
        token: null
    },
    /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */ extractCredentials: function extractCredentials(options) {
        if (options.accessKeyId && options.secretAccessKey) {
            options = $e2mZ5.util.copy(options);
            options.credentials = new $e2mZ5.Credentials(options);
        }
        return options;
    },
    /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */ setPromisesDependency: function setPromisesDependency(dep) {
        $2f4ce9536c0c48a7$var$PromisesDependency = dep;
        // if null was passed in, we should try to use native promises
        if (dep === null && typeof Promise === 'function') $2f4ce9536c0c48a7$var$PromisesDependency = Promise;
        var constructors = [
            $e2mZ5.Request,
            $e2mZ5.Credentials,
            $e2mZ5.CredentialProviderChain
        ];
        if ($e2mZ5.S3) {
            constructors.push($e2mZ5.S3);
            if ($e2mZ5.S3.ManagedUpload) constructors.push($e2mZ5.S3.ManagedUpload);
        }
        $e2mZ5.util.addPromises(constructors, $2f4ce9536c0c48a7$var$PromisesDependency);
    },
    /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */ getPromisesDependency: function getPromisesDependency() {
        return $2f4ce9536c0c48a7$var$PromisesDependency;
    }
});
/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */ $e2mZ5.config = new $e2mZ5.Config();

});
parcelRegister("kO0Co", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */ $e2mZ5.Credentials = $e2mZ5.util.inherit({
    /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */ constructor: function Credentials() {
        // hide secretAccessKey from being displayed with util.inspect
        $e2mZ5.util.hideProperties(this, [
            'secretAccessKey'
        ]);
        this.expired = false;
        this.expireTime = null;
        this.refreshCallbacks = [];
        if (arguments.length === 1 && typeof arguments[0] === 'object') {
            var creds = arguments[0].credentials || arguments[0];
            this.accessKeyId = creds.accessKeyId;
            this.secretAccessKey = creds.secretAccessKey;
            this.sessionToken = creds.sessionToken;
        } else {
            this.accessKeyId = arguments[0];
            this.secretAccessKey = arguments[1];
            this.sessionToken = arguments[2];
        }
    },
    /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */ expiryWindow: 15,
    /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */ needsRefresh: function needsRefresh() {
        var currentTime = $e2mZ5.util.date.getDate().getTime();
        var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
        if (this.expireTime && adjustedTime > this.expireTime) return true;
        else return this.expired || !this.accessKeyId || !this.secretAccessKey;
    },
    /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */ get: function get(callback) {
        var self = this;
        if (this.needsRefresh()) this.refresh(function(err) {
            if (!err) self.expired = false; // reset expired flag
            if (callback) callback(err);
        });
        else if (callback) callback();
    },
    /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */ /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */ /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */ refresh: function refresh(callback) {
        this.expired = false;
        callback();
    },
    /**
   * @api private
   * @param callback
   */ coalesceRefresh: function coalesceRefresh(callback, sync) {
        var self = this;
        if (self.refreshCallbacks.push(callback) === 1) self.load(function onLoad(err) {
            $e2mZ5.util.arrayEach(self.refreshCallbacks, function(callback) {
                if (sync) callback(err);
                else // callback could throw, so defer to ensure all callbacks are notified
                $e2mZ5.util.defer(function() {
                    callback(err);
                });
            });
            self.refreshCallbacks.length = 0;
        });
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        callback();
    }
});
/**
 * @api private
 */ $e2mZ5.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.getPromise = $e2mZ5.util.promisifyMethod('get', PromiseDependency);
    this.prototype.refreshPromise = $e2mZ5.util.promisifyMethod('refresh', PromiseDependency);
};
/**
 * @api private
 */ $e2mZ5.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.getPromise;
    delete this.prototype.refreshPromise;
};
$e2mZ5.util.addPromises($e2mZ5.Credentials);

});

parcelRegister("cimjr", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */ $e2mZ5.CredentialProviderChain = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */ constructor: function CredentialProviderChain(providers) {
        if (providers) this.providers = providers;
        else this.providers = $e2mZ5.CredentialProviderChain.defaultProviders.slice(0);
        this.resolveCallbacks = [];
    },
    /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */ /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */ resolve: function resolve(callback) {
        var self = this;
        if (self.providers.length === 0) {
            callback(new Error('No providers'));
            return self;
        }
        if (self.resolveCallbacks.push(callback) === 1) {
            var index = 0;
            var providers = self.providers.slice(0);
            function resolveNext(err, creds) {
                if (!err && creds || index === providers.length) {
                    $e2mZ5.util.arrayEach(self.resolveCallbacks, function(callback) {
                        callback(err, creds);
                    });
                    self.resolveCallbacks.length = 0;
                    return;
                }
                var provider = providers[index++];
                if (typeof provider === 'function') creds = provider.call();
                else creds = provider;
                if (creds.get) creds.get(function(getErr) {
                    resolveNext(getErr, getErr ? null : creds);
                });
                else resolveNext(null, creds);
            }
            resolveNext();
        }
        return self;
    }
});
/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SsoCredentials(); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () { return new AWS.ECSCredentials(); },
 *   function () { return new AWS.ProcessCredentials(); },
 *   function () { return new AWS.TokenFileWebIdentityCredentials(); },
 *   function () { return new AWS.EC2MetadataCredentials() }
 * ]
 * ```
 */ $e2mZ5.CredentialProviderChain.defaultProviders = [];
/**
 * @api private
 */ $e2mZ5.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.resolvePromise = $e2mZ5.util.promisifyMethod('resolve', PromiseDependency);
};
/**
 * @api private
 */ $e2mZ5.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.resolvePromise;
};
$e2mZ5.util.addPromises($e2mZ5.CredentialProviderChain);

});


parcelRegister("6UNOb", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $508e9bf1a2b3e9c2$var$inherit = $e2mZ5.util.inherit;
/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */ $e2mZ5.Endpoint = $508e9bf1a2b3e9c2$var$inherit({
    /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */ constructor: function Endpoint(endpoint, config) {
        $e2mZ5.util.hideProperties(this, [
            'slashes',
            'auth',
            'hash',
            'search',
            'query'
        ]);
        if (typeof endpoint === 'undefined' || endpoint === null) throw new Error('Invalid endpoint: ' + endpoint);
        else if (typeof endpoint !== 'string') return $e2mZ5.util.copy(endpoint);
        if (!endpoint.match(/^http/)) {
            var useSSL = config && config.sslEnabled !== undefined ? config.sslEnabled : $e2mZ5.config.sslEnabled;
            endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
        }
        $e2mZ5.util.update(this, $e2mZ5.util.urlParse(endpoint));
        // Ensure the port property is set as an integer
        if (this.port) this.port = parseInt(this.port, 10);
        else this.port = this.protocol === 'https:' ? 443 : 80;
    }
});
/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */ $e2mZ5.HttpRequest = $508e9bf1a2b3e9c2$var$inherit({
    /**
   * @api private
   */ constructor: function HttpRequest(endpoint, region) {
        endpoint = new $e2mZ5.Endpoint(endpoint);
        this.method = 'POST';
        this.path = endpoint.path || '/';
        this.headers = {};
        this.body = '';
        this.endpoint = endpoint;
        this.region = region;
        this._userAgent = '';
        this.setUserAgent();
    },
    /**
   * @api private
   */ setUserAgent: function setUserAgent() {
        this._userAgent = this.headers[this.getUserAgentHeaderName()] = $e2mZ5.util.userAgent();
    },
    getUserAgentHeaderName: function getUserAgentHeaderName() {
        var prefix = $e2mZ5.util.isBrowser() ? 'X-Amz-' : '';
        return prefix + 'User-Agent';
    },
    /**
   * @api private
   */ appendToUserAgent: function appendToUserAgent(agentPartial) {
        if (typeof agentPartial === 'string' && agentPartial) this._userAgent += ' ' + agentPartial;
        this.headers[this.getUserAgentHeaderName()] = this._userAgent;
    },
    /**
   * @api private
   */ getUserAgent: function getUserAgent() {
        return this._userAgent;
    },
    /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */ pathname: function pathname() {
        return this.path.split('?', 1)[0];
    },
    /**
   * @return [String] the query string portion of the {path}
   */ search: function search() {
        var query = this.path.split('?', 2)[1];
        if (query) {
            query = $e2mZ5.util.queryStringParse(query);
            return $e2mZ5.util.queryParamsToString(query);
        }
        return '';
    },
    /**
   * @api private
   * update httpRequest endpoint with endpoint string
   */ updateEndpoint: function updateEndpoint(endpointStr) {
        var newEndpoint = new $e2mZ5.Endpoint(endpointStr);
        this.endpoint = newEndpoint;
        this.path = newEndpoint.path || '/';
        if (this.headers['Host']) this.headers['Host'] = newEndpoint.host;
    }
});
/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */ $e2mZ5.HttpResponse = $508e9bf1a2b3e9c2$var$inherit({
    /**
   * @api private
   */ constructor: function HttpResponse() {
        this.statusCode = undefined;
        this.headers = {};
        this.body = undefined;
        this.streaming = false;
        this.stream = null;
    },
    /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */ createUnbufferedStream: function createUnbufferedStream() {
        this.streaming = true;
        return this.stream;
    }
});
$e2mZ5.HttpClient = $508e9bf1a2b3e9c2$var$inherit({});
/**
 * @api private
 */ $e2mZ5.HttpClient.getInstance = function getInstance() {
    if (this.singleton === undefined) this.singleton = new this();
    return this.singleton;
};

});

parcelRegister("23Avo", function(module, exports) {

var $89WEd = parcelRequire("89WEd");

var $e2mZ5 = parcelRequire("e2mZ5");

var $9WcNx = parcelRequire("9WcNx");

var $6S06I = parcelRequire("6S06I");
var $17f82dce8e2a9053$require$DISCOVER_ENDPOINT = $6S06I.discoverEndpoint;
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */ $e2mZ5.EventListeners = {
    /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */ Core: {} /* doc hack */ 
};
/**
 * @api private
 */ function $17f82dce8e2a9053$var$getOperationAuthtype(req) {
    if (!req.service.api.operations) return '';
    var operation = req.service.api.operations[req.operation];
    return operation ? operation.authtype : '';
}
/**
 * @api private
 */ function $17f82dce8e2a9053$var$getIdentityType(req) {
    var service = req.service;
    if (service.config.signatureVersion) return service.config.signatureVersion;
    if (service.api.signatureVersion) return service.api.signatureVersion;
    return $17f82dce8e2a9053$var$getOperationAuthtype(req);
}






$e2mZ5.EventListeners = {
    Core: new $9WcNx().addNamedListeners(function(add, addAsync) {
        addAsync('VALIDATE_CREDENTIALS', 'validate', function VALIDATE_CREDENTIALS(req, done) {
            if (!req.service.api.signatureVersion && !req.service.config.signatureVersion) return done(); // none
            var identityType = $17f82dce8e2a9053$var$getIdentityType(req);
            if (identityType === 'bearer') {
                req.service.config.getToken(function(err) {
                    if (err) req.response.error = $e2mZ5.util.error(err, {
                        code: 'TokenError'
                    });
                    done();
                });
                return;
            }
            req.service.config.getCredentials(function(err) {
                if (err) req.response.error = $e2mZ5.util.error(err, {
                    code: 'CredentialsError',
                    message: 'Missing credentials in config, if using AWS_CONFIG_FILE, set AWS_SDK_LOAD_CONFIG=1'
                });
                done();
            });
        });
        add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
            if (!req.service.isGlobalEndpoint) {
                var dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                if (!req.service.config.region) req.response.error = $e2mZ5.util.error(new Error(), {
                    code: 'ConfigError',
                    message: 'Missing region in config'
                });
                else if (!dnsHostRegex.test(req.service.config.region)) req.response.error = $e2mZ5.util.error(new Error(), {
                    code: 'ConfigError',
                    message: 'Invalid region in config'
                });
            }
        });
        add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
            if (!req.service.api.operations) return;
            var operation = req.service.api.operations[req.operation];
            if (!operation) return;
            var idempotentMembers = operation.idempotentMembers;
            if (!idempotentMembers.length) return;
            // creates a copy of params so user's param object isn't mutated
            var params = $e2mZ5.util.copy(req.params);
            for(var i = 0, iLen = idempotentMembers.length; i < iLen; i++)if (!params[idempotentMembers[i]]) // add the member
            params[idempotentMembers[i]] = $e2mZ5.util.uuid.v4();
            req.params = params;
        });
        add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
            if (!req.service.api.operations) return;
            var rules = req.service.api.operations[req.operation].input;
            var validation = req.service.config.paramValidation;
            new $e2mZ5.ParamValidator(validation).validate(rules, req.params);
        });
        add('COMPUTE_CHECKSUM', 'afterBuild', function COMPUTE_CHECKSUM(req) {
            if (!req.service.api.operations) return;
            var operation = req.service.api.operations[req.operation];
            if (!operation) return;
            var body = req.httpRequest.body;
            var isNonStreamingPayload = body && ($e2mZ5.util.Buffer.isBuffer(body) || typeof body === 'string');
            var headers = req.httpRequest.headers;
            if (operation.httpChecksumRequired && req.service.config.computeChecksums && isNonStreamingPayload && !headers['Content-MD5']) {
                var md5 = $e2mZ5.util.crypto.md5(body, 'base64');
                headers['Content-MD5'] = md5;
            }
        });
        addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
            req.haltHandlersOnError();
            if (!req.service.api.operations) return;
            var operation = req.service.api.operations[req.operation];
            var authtype = operation ? operation.authtype : '';
            if (!req.service.api.signatureVersion && !authtype && !req.service.config.signatureVersion) return done(); // none
            if (req.service.getSignerClass(req) === $e2mZ5.Signers.V4) {
                var body = req.httpRequest.body || '';
                if (authtype.indexOf('unsigned-body') >= 0) {
                    req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
                    return done();
                }
                $e2mZ5.util.computeSha256(body, function(err, sha) {
                    if (err) done(err);
                    else {
                        req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
                        done();
                    }
                });
            } else done();
        });
        add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
            var authtype = $17f82dce8e2a9053$var$getOperationAuthtype(req);
            var payloadMember = $e2mZ5.util.getRequestPayloadShape(req);
            if (req.httpRequest.headers['Content-Length'] === undefined) try {
                var length = $e2mZ5.util.string.byteLength(req.httpRequest.body);
                req.httpRequest.headers['Content-Length'] = length;
            } catch (err) {
                if (payloadMember && payloadMember.isStreaming) {
                    if (payloadMember.requiresLength) //streaming payload requires length(s3, glacier)
                    throw err;
                    else if (authtype.indexOf('unsigned-body') >= 0) {
                        //unbounded streaming payload(lex, mediastore)
                        req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
                        return;
                    } else throw err;
                }
                throw err;
            }
        });
        add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
            req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
        });
        add('SET_TRACE_ID', 'afterBuild', function SET_TRACE_ID(req) {
            var traceIdHeaderName = 'X-Amzn-Trace-Id';
            if ($e2mZ5.util.isNode() && !Object.hasOwnProperty.call(req.httpRequest.headers, traceIdHeaderName)) {
                var ENV_LAMBDA_FUNCTION_NAME = 'AWS_LAMBDA_FUNCTION_NAME';
                var ENV_TRACE_ID = '_X_AMZN_TRACE_ID';
                var functionName = $89WEd.env[ENV_LAMBDA_FUNCTION_NAME];
                var traceId = $89WEd.env[ENV_TRACE_ID];
                if (typeof functionName === 'string' && functionName.length > 0 && typeof traceId === 'string' && traceId.length > 0) req.httpRequest.headers[traceIdHeaderName] = traceId;
            }
        });
        add('RESTART', 'restart', function RESTART() {
            var err = this.response.error;
            if (!err || !err.retryable) return;
            this.httpRequest = new $e2mZ5.HttpRequest(this.service.endpoint, this.service.region);
            if (this.response.retryCount < this.service.config.maxRetries) this.response.retryCount++;
            else this.response.error = null;
        });
        var addToHead = true;
        addAsync('DISCOVER_ENDPOINT', 'sign', $17f82dce8e2a9053$require$DISCOVER_ENDPOINT, addToHead);
        addAsync('SIGN', 'sign', function SIGN(req, done) {
            var service = req.service;
            var identityType = $17f82dce8e2a9053$var$getIdentityType(req);
            if (!identityType || identityType.length === 0) return done(); // none
            if (identityType === 'bearer') service.config.getToken(function(err, token) {
                if (err) {
                    req.response.error = err;
                    return done();
                }
                try {
                    var SignerClass = service.getSignerClass(req);
                    var signer = new SignerClass(req.httpRequest);
                    signer.addAuthorization(token);
                } catch (e) {
                    req.response.error = e;
                }
                done();
            });
            else service.config.getCredentials(function(err, credentials) {
                if (err) {
                    req.response.error = err;
                    return done();
                }
                try {
                    var date = service.getSkewCorrectedDate();
                    var SignerClass = service.getSignerClass(req);
                    var operations = req.service.api.operations || {};
                    var operation = operations[req.operation];
                    var signer = new SignerClass(req.httpRequest, service.getSigningName(req), {
                        signatureCache: service.config.signatureCache,
                        operation: operation,
                        signatureVersion: service.api.signatureVersion
                    });
                    signer.setServiceClientId(service._clientId);
                    // clear old authorization headers
                    delete req.httpRequest.headers['Authorization'];
                    delete req.httpRequest.headers['Date'];
                    delete req.httpRequest.headers['X-Amz-Date'];
                    // add new authorization
                    signer.addAuthorization(credentials, date);
                    req.signedAt = date;
                } catch (e) {
                    req.response.error = e;
                }
                done();
            });
        });
        add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
            if (this.service.successfulResponse(resp, this)) {
                resp.data = {};
                resp.error = null;
            } else {
                resp.data = null;
                resp.error = $e2mZ5.util.error(new Error(), {
                    code: 'UnknownError',
                    message: 'An unknown error occurred.'
                });
            }
        });
        add('ERROR', 'error', function ERROR(err, resp) {
            var awsQueryCompatible = resp.request.service.api.awsQueryCompatible;
            if (awsQueryCompatible) {
                var headers = resp.httpResponse.headers;
                var queryErrorCode = headers ? headers['x-amzn-query-error'] : undefined;
                if (queryErrorCode && queryErrorCode.includes(';')) resp.error.code = queryErrorCode.split(';')[0];
            }
        }, true);
        addAsync('SEND', 'send', function SEND(resp, done) {
            resp.httpResponse._abortCallback = done;
            resp.error = null;
            resp.data = null;
            function callback(httpResp) {
                resp.httpResponse.stream = httpResp;
                var stream = resp.request.httpRequest.stream;
                var service = resp.request.service;
                var api = service.api;
                var operationName = resp.request.operation;
                var operation = api.operations[operationName] || {};
                httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
                    resp.request.emit('httpHeaders', [
                        statusCode,
                        headers,
                        resp,
                        statusMessage
                    ]);
                    if (!resp.httpResponse.streaming) {
                        if ($e2mZ5.HttpClient.streamsApiVersion === 2) {
                            // if we detect event streams, we're going to have to
                            // return the stream immediately
                            if (operation.hasEventOutput && service.successfulResponse(resp)) {
                                // skip reading the IncomingStream
                                resp.request.emit('httpDone');
                                done();
                                return;
                            }
                            httpResp.on('readable', function onReadable() {
                                var data = httpResp.read();
                                if (data !== null) resp.request.emit('httpData', [
                                    data,
                                    resp
                                ]);
                            });
                        } else httpResp.on('data', function onData(data) {
                            resp.request.emit('httpData', [
                                data,
                                resp
                            ]);
                        });
                    }
                });
                httpResp.on('end', function onEnd() {
                    if (!stream || !stream.didCallback) {
                        if ($e2mZ5.HttpClient.streamsApiVersion === 2 && operation.hasEventOutput && service.successfulResponse(resp)) // don't concatenate response chunks when streaming event stream data when response is successful
                        return;
                        resp.request.emit('httpDone');
                        done();
                    }
                });
            }
            function progress(httpResp) {
                httpResp.on('sendProgress', function onSendProgress(value) {
                    resp.request.emit('httpUploadProgress', [
                        value,
                        resp
                    ]);
                });
                httpResp.on('receiveProgress', function onReceiveProgress(value) {
                    resp.request.emit('httpDownloadProgress', [
                        value,
                        resp
                    ]);
                });
            }
            function error(err) {
                if (err.code !== 'RequestAbortedError') {
                    var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
                    err = $e2mZ5.util.error(err, {
                        code: errCode,
                        region: resp.request.httpRequest.region,
                        hostname: resp.request.httpRequest.endpoint.hostname,
                        retryable: true
                    });
                }
                resp.error = err;
                resp.request.emit('httpError', [
                    resp.error,
                    resp
                ], function() {
                    done();
                });
            }
            function executeSend() {
                var http = $e2mZ5.HttpClient.getInstance();
                var httpOptions = resp.request.service.config.httpOptions || {};
                try {
                    var stream = http.handleRequest(resp.request.httpRequest, httpOptions, callback, error);
                    progress(stream);
                } catch (err) {
                    error(err);
                }
            }
            var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
            if (timeDiff >= 600) this.emit('sign', [
                this
            ], function(err) {
                if (err) done(err);
                else executeSend();
            });
            else executeSend();
        });
        add('HTTP_HEADERS', 'httpHeaders', function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
            resp.httpResponse.statusCode = statusCode;
            resp.httpResponse.statusMessage = statusMessage;
            resp.httpResponse.headers = headers;
            resp.httpResponse.body = $e2mZ5.util.buffer.toBuffer('');
            resp.httpResponse.buffers = [];
            resp.httpResponse.numBytes = 0;
            var dateHeader = headers.date || headers.Date;
            var service = resp.request.service;
            if (dateHeader) {
                var serverTime = Date.parse(dateHeader);
                if (service.config.correctClockSkew && service.isClockSkewed(serverTime)) service.applyClockOffset(serverTime);
            }
        });
        add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
            if (chunk) {
                if ($e2mZ5.util.isNode()) {
                    resp.httpResponse.numBytes += chunk.length;
                    var total = resp.httpResponse.headers['content-length'];
                    var progress = {
                        loaded: resp.httpResponse.numBytes,
                        total: total
                    };
                    resp.request.emit('httpDownloadProgress', [
                        progress,
                        resp
                    ]);
                }
                resp.httpResponse.buffers.push($e2mZ5.util.buffer.toBuffer(chunk));
            }
        });
        add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
            // convert buffers array into single buffer
            if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
                var body = $e2mZ5.util.buffer.concat(resp.httpResponse.buffers);
                resp.httpResponse.body = body;
            }
            delete resp.httpResponse.numBytes;
            delete resp.httpResponse.buffers;
        });
        add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
            if (resp.httpResponse.statusCode) {
                resp.error.statusCode = resp.httpResponse.statusCode;
                if (resp.error.retryable === undefined) resp.error.retryable = this.service.retryableError(resp.error, this);
            }
        });
        add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
            if (!resp.error) return;
            switch(resp.error.code){
                case 'RequestExpired':
                case 'ExpiredTokenException':
                case 'ExpiredToken':
                    resp.error.retryable = true;
                    resp.request.service.config.credentials.expired = true;
            }
        });
        add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
            var err = resp.error;
            if (!err) return;
            if (typeof err.code === 'string' && typeof err.message === 'string') {
                if (err.code.match(/Signature/) && err.message.match(/expired/)) resp.error.retryable = true;
            }
        });
        add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
            if (!resp.error) return;
            if (this.service.clockSkewError(resp.error) && this.service.config.correctClockSkew) resp.error.retryable = true;
        });
        add('REDIRECT', 'retry', function REDIRECT(resp) {
            if (resp.error && resp.error.statusCode >= 300 && resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
                this.httpRequest.endpoint = new $e2mZ5.Endpoint(resp.httpResponse.headers['location']);
                this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
                this.httpRequest.path = this.httpRequest.endpoint.path;
                resp.error.redirect = true;
                resp.error.retryable = true;
            }
        });
        add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
            if (resp.error) {
                if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) resp.error.retryDelay = 0;
                else if (resp.retryCount < resp.maxRetries) resp.error.retryDelay = this.service.retryDelays(resp.retryCount, resp.error) || 0;
            }
        });
        addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
            var delay, willRetry = false;
            if (resp.error) {
                delay = resp.error.retryDelay || 0;
                if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
                    resp.retryCount++;
                    willRetry = true;
                } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
                    resp.redirectCount++;
                    willRetry = true;
                }
            }
            // delay < 0 is a signal from customBackoff to skip retries
            if (willRetry && delay >= 0) {
                resp.error = null;
                setTimeout(done, delay);
            } else done();
        });
    }),
    CorePost: new $9WcNx().addNamedListeners(function(add) {
        add('EXTRACT_REQUEST_ID', 'extractData', $e2mZ5.util.extractRequestId);
        add('EXTRACT_REQUEST_ID', 'extractError', $e2mZ5.util.extractRequestId);
        add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
            function isDNSError(err) {
                return err.errno === 'ENOTFOUND' || typeof err.errno === 'number' && typeof $e2mZ5.util.getSystemErrorName === 'function' && [
                    'EAI_NONAME',
                    'EAI_NODATA'
                ].indexOf($e2mZ5.util.getSystemErrorName(err.errno) >= 0);
            }
            if (err.code === 'NetworkingError' && isDNSError(err)) {
                var message = 'Inaccessible host: `' + err.hostname + '\' at port `' + err.port + '\'. This service may not be available in the `' + err.region + '\' region.';
                this.response.error = $e2mZ5.util.error(new Error(message), {
                    code: 'UnknownEndpoint',
                    region: err.region,
                    hostname: err.hostname,
                    retryable: true,
                    originalError: err
                });
            }
        });
    }),
    Logger: new $9WcNx().addNamedListeners(function(add) {
        add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
            var req = resp.request;
            var logger = req.service.config.logger;
            if (!logger) return;
            function filterSensitiveLog(inputShape, shape) {
                if (!shape) return shape;
                if (inputShape.isSensitive) return '***SensitiveInformation***';
                switch(inputShape.type){
                    case 'structure':
                        var struct = {};
                        $e2mZ5.util.each(shape, function(subShapeName, subShape) {
                            if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
                            else struct[subShapeName] = subShape;
                        });
                        return struct;
                    case 'list':
                        var list = [];
                        $e2mZ5.util.arrayEach(shape, function(subShape, index) {
                            list.push(filterSensitiveLog(inputShape.member, subShape));
                        });
                        return list;
                    case 'map':
                        var map = {};
                        $e2mZ5.util.each(shape, function(key, value) {
                            map[key] = filterSensitiveLog(inputShape.value, value);
                        });
                        return map;
                    default:
                        return shape;
                }
            }
            function buildMessage() {
                var time = resp.request.service.getSkewCorrectedDate().getTime();
                var delta = (time - req.startTime.getTime()) / 1000;
                var ansi = logger.isTTY ? true : false;
                var status = resp.httpResponse.statusCode;
                var censoredParams = req.params;
                if (req.service.api.operations && req.service.api.operations[req.operation] && req.service.api.operations[req.operation].input) {
                    var inputShape = req.service.api.operations[req.operation].input;
                    censoredParams = filterSensitiveLog(inputShape, req.params);
                }
                var params = (parcelRequire("5wf39")).inspect(censoredParams, true, null);
                var message = '';
                if (ansi) message += '\x1B[33m';
                message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
                message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
                if (ansi) message += '\x1B[0;1m';
                message += ' ' + $e2mZ5.util.string.lowerFirst(req.operation);
                message += '(' + params + ')';
                if (ansi) message += '\x1B[0m';
                return message;
            }
            var line = buildMessage();
            if (typeof logger.log === 'function') logger.log(line);
            else if (typeof logger.write === 'function') logger.write(line + '\n');
        });
    }),
    Json: new $9WcNx().addNamedListeners(function(add) {
        var svc = (parcelRequire("iOHL8"));
        add('BUILD', 'build', svc.buildRequest);
        add('EXTRACT_DATA', 'extractData', svc.extractData);
        add('EXTRACT_ERROR', 'extractError', svc.extractError);
    }),
    Rest: new $9WcNx().addNamedListeners(function(add) {
        var svc = (parcelRequire("14bAM"));
        add('BUILD', 'build', svc.buildRequest);
        add('EXTRACT_DATA', 'extractData', svc.extractData);
        add('EXTRACT_ERROR', 'extractError', svc.extractError);
    }),
    RestJson: new $9WcNx().addNamedListeners(function(add) {
        var svc = (parcelRequire("2ZRi9"));
        add('BUILD', 'build', svc.buildRequest);
        add('EXTRACT_DATA', 'extractData', svc.extractData);
        add('EXTRACT_ERROR', 'extractError', svc.extractError);
        add('UNSET_CONTENT_LENGTH', 'afterBuild', svc.unsetContentLength);
    }),
    RestXml: new $9WcNx().addNamedListeners(function(add) {
        var svc = (parcelRequire("lSJkz"));
        add('BUILD', 'build', svc.buildRequest);
        add('EXTRACT_DATA', 'extractData', svc.extractData);
        add('EXTRACT_ERROR', 'extractError', svc.extractError);
    }),
    Query: new $9WcNx().addNamedListeners(function(add) {
        var svc = (parcelRequire("9yfKy"));
        add('BUILD', 'build', svc.buildRequest);
        add('EXTRACT_DATA', 'extractData', svc.extractData);
        add('EXTRACT_ERROR', 'extractError', svc.extractError);
    })
};

});
parcelRegister("6S06I", function(module, exports) {

var $89WEd = parcelRequire("89WEd");

var $e2mZ5 = parcelRequire("e2mZ5");

var $1ymo4 = parcelRequire("1ymo4");
var $5007de89ab33abb4$var$endpointDiscoveryEnabledEnvs = [
    'AWS_ENABLE_ENDPOINT_DISCOVERY',
    'AWS_ENDPOINT_DISCOVERY_ENABLED'
];
/**
 * Generate key (except resources and operation part) to index the endpoints in the cache
 * If input shape has endpointdiscoveryid trait then use
 *   accessKey + operation + resources + region + service as cache key
 * If input shape doesn't have endpointdiscoveryid trait then use
 *   accessKey + region + service as cache key
 * @return [map<String,String>] object with keys to index endpoints.
 * @api private
 */ function $5007de89ab33abb4$var$getCacheKey(request) {
    var service = request.service;
    var api = service.api || {};
    var operations = api.operations;
    var identifiers = {};
    if (service.config.region) identifiers.region = service.config.region;
    if (api.serviceId) identifiers.serviceId = api.serviceId;
    if (service.config.credentials.accessKeyId) identifiers.accessKeyId = service.config.credentials.accessKeyId;
    return identifiers;
}
/**
 * Recursive helper for marshallCustomIdentifiers().
 * Looks for required string input members that have 'endpointdiscoveryid' trait.
 * @api private
 */ function $5007de89ab33abb4$var$marshallCustomIdentifiersHelper(result, params, shape) {
    if (!shape || params === undefined || params === null) return;
    if (shape.type === 'structure' && shape.required && shape.required.length > 0) $1ymo4.arrayEach(shape.required, function(name) {
        var memberShape = shape.members[name];
        if (memberShape.endpointDiscoveryId === true) {
            var locationName = memberShape.isLocationName ? memberShape.name : name;
            result[locationName] = String(params[name]);
        } else $5007de89ab33abb4$var$marshallCustomIdentifiersHelper(result, params[name], memberShape);
    });
}
/**
 * Get custom identifiers for cache key.
 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
 * @param [object] request object
 * @param [object] input shape of the given operation's api
 * @api private
 */ function $5007de89ab33abb4$var$marshallCustomIdentifiers(request, shape) {
    var identifiers = {};
    $5007de89ab33abb4$var$marshallCustomIdentifiersHelper(identifiers, request.params, shape);
    return identifiers;
}
/**
 * Call endpoint discovery operation when it's optional.
 * When endpoint is available in cache then use the cached endpoints. If endpoints
 * are unavailable then use regional endpoints and call endpoint discovery operation
 * asynchronously. This is turned off by default.
 * @param [object] request object
 * @api private
 */ function $5007de89ab33abb4$var$optionalDiscoverEndpoint(request) {
    var service = request.service;
    var api = service.api;
    var operationModel = api.operations ? api.operations[request.operation] : undefined;
    var inputShape = operationModel ? operationModel.input : undefined;
    var identifiers = $5007de89ab33abb4$var$marshallCustomIdentifiers(request, inputShape);
    var cacheKey = $5007de89ab33abb4$var$getCacheKey(request);
    if (Object.keys(identifiers).length > 0) {
        cacheKey = $1ymo4.update(cacheKey, identifiers);
        if (operationModel) cacheKey.operation = operationModel.name;
    }
    var endpoints = $e2mZ5.endpointCache.get(cacheKey);
    if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') //endpoint operation is being made but response not yet received
    //or endpoint operation just failed in 1 minute
    return;
    else if (endpoints && endpoints.length > 0) //found endpoint record from cache
    request.httpRequest.updateEndpoint(endpoints[0].Address);
    else {
        //endpoint record not in cache or outdated. make discovery operation
        var endpointRequest = service.makeRequest(api.endpointOperation, {
            Operation: operationModel.name,
            Identifiers: identifiers
        });
        $5007de89ab33abb4$var$addApiVersionHeader(endpointRequest);
        endpointRequest.removeListener('validate', $e2mZ5.EventListeners.Core.VALIDATE_PARAMETERS);
        endpointRequest.removeListener('retry', $e2mZ5.EventListeners.Core.RETRY_CHECK);
        //put in a placeholder for endpoints already requested, prevent
        //too much in-flight calls
        $e2mZ5.endpointCache.put(cacheKey, [
            {
                Address: '',
                CachePeriodInMinutes: 1
            }
        ]);
        endpointRequest.send(function(err, data) {
            if (data && data.Endpoints) $e2mZ5.endpointCache.put(cacheKey, data.Endpoints);
            else if (err) $e2mZ5.endpointCache.put(cacheKey, [
                {
                    Address: '',
                    CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
                }
            ]);
        });
    }
}
var $5007de89ab33abb4$var$requestQueue = {};
/**
 * Call endpoint discovery operation when it's required.
 * When endpoint is available in cache then use cached ones. If endpoints are
 * unavailable then SDK should call endpoint operation then use returned new
 * endpoint for the api call. SDK will automatically attempt to do endpoint
 * discovery. This is turned off by default
 * @param [object] request object
 * @api private
 */ function $5007de89ab33abb4$var$requiredDiscoverEndpoint(request, done) {
    var service = request.service;
    var api = service.api;
    var operationModel = api.operations ? api.operations[request.operation] : undefined;
    var inputShape = operationModel ? operationModel.input : undefined;
    var identifiers = $5007de89ab33abb4$var$marshallCustomIdentifiers(request, inputShape);
    var cacheKey = $5007de89ab33abb4$var$getCacheKey(request);
    if (Object.keys(identifiers).length > 0) {
        cacheKey = $1ymo4.update(cacheKey, identifiers);
        if (operationModel) cacheKey.operation = operationModel.name;
    }
    var cacheKeyStr = $e2mZ5.EndpointCache.getKeyString(cacheKey);
    var endpoints = $e2mZ5.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
    if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
        //endpoint operation is being made but response not yet received
        //push request object to a pending queue
        if (!$5007de89ab33abb4$var$requestQueue[cacheKeyStr]) $5007de89ab33abb4$var$requestQueue[cacheKeyStr] = [];
        $5007de89ab33abb4$var$requestQueue[cacheKeyStr].push({
            request: request,
            callback: done
        });
        return;
    } else if (endpoints && endpoints.length > 0) {
        request.httpRequest.updateEndpoint(endpoints[0].Address);
        done();
    } else {
        var endpointRequest = service.makeRequest(api.endpointOperation, {
            Operation: operationModel.name,
            Identifiers: identifiers
        });
        endpointRequest.removeListener('validate', $e2mZ5.EventListeners.Core.VALIDATE_PARAMETERS);
        $5007de89ab33abb4$var$addApiVersionHeader(endpointRequest);
        //put in a placeholder for endpoints already requested, prevent
        //too much in-flight calls
        $e2mZ5.endpointCache.put(cacheKeyStr, [
            {
                Address: '',
                CachePeriodInMinutes: 60 //long-live cache
            }
        ]);
        endpointRequest.send(function(err, data) {
            if (err) {
                request.response.error = $1ymo4.error(err, {
                    retryable: false
                });
                $e2mZ5.endpointCache.remove(cacheKey);
                //fail all the pending requests in batch
                if ($5007de89ab33abb4$var$requestQueue[cacheKeyStr]) {
                    var pendingRequests = $5007de89ab33abb4$var$requestQueue[cacheKeyStr];
                    $1ymo4.arrayEach(pendingRequests, function(requestContext) {
                        requestContext.request.response.error = $1ymo4.error(err, {
                            retryable: false
                        });
                        requestContext.callback();
                    });
                    delete $5007de89ab33abb4$var$requestQueue[cacheKeyStr];
                }
            } else if (data) {
                $e2mZ5.endpointCache.put(cacheKeyStr, data.Endpoints);
                request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
                //update the endpoint for all the pending requests in batch
                if ($5007de89ab33abb4$var$requestQueue[cacheKeyStr]) {
                    var pendingRequests = $5007de89ab33abb4$var$requestQueue[cacheKeyStr];
                    $1ymo4.arrayEach(pendingRequests, function(requestContext) {
                        requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
                        requestContext.callback();
                    });
                    delete $5007de89ab33abb4$var$requestQueue[cacheKeyStr];
                }
            }
            done();
        });
    }
}
/**
 * add api version header to endpoint operation
 * @api private
 */ function $5007de89ab33abb4$var$addApiVersionHeader(endpointRequest) {
    var api = endpointRequest.service.api;
    var apiVersion = api.apiVersion;
    if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
}
/**
 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
 * endpoint from cache.
 * @api private
 */ function $5007de89ab33abb4$var$invalidateCachedEndpoints(response) {
    var error = response.error;
    var httpResponse = response.httpResponse;
    if (error && (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)) {
        var request = response.request;
        var operations = request.service.api.operations || {};
        var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
        var identifiers = $5007de89ab33abb4$var$marshallCustomIdentifiers(request, inputShape);
        var cacheKey = $5007de89ab33abb4$var$getCacheKey(request);
        if (Object.keys(identifiers).length > 0) {
            cacheKey = $1ymo4.update(cacheKey, identifiers);
            if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
        }
        $e2mZ5.endpointCache.remove(cacheKey);
    }
}
/**
 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
 * @param [object] client Service client object.
 * @api private
 */ function $5007de89ab33abb4$var$hasCustomEndpoint(client) {
    //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
    if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) throw $1ymo4.error(new Error(), {
        code: 'ConfigurationException',
        message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
    });
    var svcConfig = $e2mZ5.config[client.serviceIdentifier] || {};
    return Boolean($e2mZ5.config.endpoint || svcConfig.endpoint || client._originalConfig && client._originalConfig.endpoint);
}
/**
 * @api private
 */ function $5007de89ab33abb4$var$isFalsy(value) {
    return [
        'false',
        '0'
    ].indexOf(value) >= 0;
}
/**
 * If endpoint discovery should perform for this request when no operation requires endpoint
 * discovery for the given service.
 * SDK performs config resolution in order like below:
 * 1. If set in client configuration.
 * 2. If set in env AWS_ENABLE_ENDPOINT_DISCOVERY.
 * 3. If set in shared ini config file with key 'endpoint_discovery_enabled'.
 * @param [object] request request object.
 * @returns [boolean|undefined] if endpoint discovery config is not set in any source, this
 *  function returns undefined
 * @api private
 */ function $5007de89ab33abb4$var$resolveEndpointDiscoveryConfig(request) {
    var service = request.service || {};
    if (service.config.endpointDiscoveryEnabled !== undefined) return service.config.endpointDiscoveryEnabled;
    //shared ini file is only available in Node
    //not to check env in browser
    if ($1ymo4.isBrowser()) return undefined;
    // If any of recognized endpoint discovery config env is set
    for(var i = 0; i < $5007de89ab33abb4$var$endpointDiscoveryEnabledEnvs.length; i++){
        var env = $5007de89ab33abb4$var$endpointDiscoveryEnabledEnvs[i];
        if (Object.prototype.hasOwnProperty.call($89WEd.env, env)) {
            if ($89WEd.env[env] === '' || $89WEd.env[env] === undefined) throw $1ymo4.error(new Error(), {
                code: 'ConfigurationException',
                message: 'environmental variable ' + env + ' cannot be set to nothing'
            });
            return !$5007de89ab33abb4$var$isFalsy($89WEd.env[env]);
        }
    }
    var configFile = {};
    try {
        configFile = $e2mZ5.util.iniLoader ? $e2mZ5.util.iniLoader.loadFrom({
            isConfig: true,
            filename: $89WEd.env[$e2mZ5.util.sharedConfigFileEnv]
        }) : {};
    } catch (e) {}
    var sharedFileConfig = configFile[$e2mZ5.util.defaultProfile] || {};
    if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
        if (sharedFileConfig.endpoint_discovery_enabled === undefined) throw $1ymo4.error(new Error(), {
            code: 'ConfigurationException',
            message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
        });
        return !$5007de89ab33abb4$var$isFalsy(sharedFileConfig.endpoint_discovery_enabled);
    }
    return undefined;
}
/**
 * attach endpoint discovery logic to request object
 * @param [object] request
 * @api private
 */ function $5007de89ab33abb4$var$discoverEndpoint(request, done) {
    var service = request.service || {};
    if ($5007de89ab33abb4$var$hasCustomEndpoint(service) || request.isPresigned()) return done();
    var operations = service.api.operations || {};
    var operationModel = operations[request.operation];
    var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
    var isEnabled = $5007de89ab33abb4$var$resolveEndpointDiscoveryConfig(request);
    var hasRequiredEndpointDiscovery = service.api.hasRequiredEndpointDiscovery;
    if (isEnabled || hasRequiredEndpointDiscovery) // Once a customer enables endpoint discovery, the SDK should start appending
    // the string endpoint-discovery to the user-agent on all requests.
    request.httpRequest.appendToUserAgent('endpoint-discovery');
    switch(isEndpointDiscoveryRequired){
        case 'OPTIONAL':
            if (isEnabled || hasRequiredEndpointDiscovery) {
                // For a given service; if at least one operation requires endpoint discovery then the SDK must enable endpoint discovery
                // by default for all operations of that service, including operations where endpoint discovery is optional.
                $5007de89ab33abb4$var$optionalDiscoverEndpoint(request);
                request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', $5007de89ab33abb4$var$invalidateCachedEndpoints);
            }
            done();
            break;
        case 'REQUIRED':
            if (isEnabled === false) {
                // For a given operation; if endpoint discovery is required and it has been disabled on the SDK client,
                // then the SDK must return a clear and actionable exception.
                request.response.error = $1ymo4.error(new Error(), {
                    code: 'ConfigurationException',
                    message: 'Endpoint Discovery is disabled but ' + service.api.className + '.' + request.operation + '() requires it. Please check your configurations.'
                });
                done();
                break;
            }
            request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', $5007de89ab33abb4$var$invalidateCachedEndpoints);
            $5007de89ab33abb4$var$requiredDiscoverEndpoint(request, done);
            break;
        case 'NULL':
        default:
            done();
            break;
    }
}
module.exports = {
    discoverEndpoint: $5007de89ab33abb4$var$discoverEndpoint,
    requiredDiscoverEndpoint: $5007de89ab33abb4$var$requiredDiscoverEndpoint,
    optionalDiscoverEndpoint: $5007de89ab33abb4$var$optionalDiscoverEndpoint,
    marshallCustomIdentifiers: $5007de89ab33abb4$var$marshallCustomIdentifiers,
    getCacheKey: $5007de89ab33abb4$var$getCacheKey,
    invalidateCachedEndpoint: $5007de89ab33abb4$var$invalidateCachedEndpoints
};

});

parcelRegister("5wf39", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $89WEd = parcelRequire("89WEd");
var $404b9d7cff47e01b$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $404b9d7cff47e01b$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$404b9d7cff47e01b$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($404b9d7cff47e01b$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($404b9d7cff47e01b$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($404b9d7cff47e01b$var$isNull(x) || !$404b9d7cff47e01b$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $404b9d7cff47e01b$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($89WEd.throwDeprecation) throw new Error(msg);
            else if ($89WEd.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $404b9d7cff47e01b$var$debugs = {};
var $404b9d7cff47e01b$var$debugEnvRegex = /^$/;
var $404b9d7cff47e01b$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$404b9d7cff47e01b$var$debugs[set]) {
        if ($404b9d7cff47e01b$var$debugEnvRegex.test(set)) {
            var pid = $89WEd.pid;
            $404b9d7cff47e01b$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $404b9d7cff47e01b$var$debugs[set] = function() {};
    }
    return $404b9d7cff47e01b$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $404b9d7cff47e01b$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $404b9d7cff47e01b$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($404b9d7cff47e01b$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($404b9d7cff47e01b$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($404b9d7cff47e01b$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($404b9d7cff47e01b$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($404b9d7cff47e01b$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $404b9d7cff47e01b$var$stylizeWithColor;
    return $404b9d7cff47e01b$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $404b9d7cff47e01b$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$404b9d7cff47e01b$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$404b9d7cff47e01b$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $404b9d7cff47e01b$var$stylizeWithColor(str, styleType) {
    var style = $404b9d7cff47e01b$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $404b9d7cff47e01b$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $404b9d7cff47e01b$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $404b9d7cff47e01b$var$stylizeNoColor(str, styleType) {
    return str;
}
function $404b9d7cff47e01b$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $404b9d7cff47e01b$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $404b9d7cff47e01b$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$404b9d7cff47e01b$var$isString(ret)) ret = $404b9d7cff47e01b$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $404b9d7cff47e01b$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $404b9d7cff47e01b$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($404b9d7cff47e01b$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $404b9d7cff47e01b$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($404b9d7cff47e01b$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($404b9d7cff47e01b$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($404b9d7cff47e01b$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($404b9d7cff47e01b$var$isError(value)) return $404b9d7cff47e01b$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($404b9d7cff47e01b$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($404b9d7cff47e01b$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($404b9d7cff47e01b$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($404b9d7cff47e01b$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($404b9d7cff47e01b$var$isError(value)) base = ' ' + $404b9d7cff47e01b$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($404b9d7cff47e01b$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $404b9d7cff47e01b$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $404b9d7cff47e01b$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $404b9d7cff47e01b$var$reduceToSingleString(output, base, braces);
}
function $404b9d7cff47e01b$var$formatPrimitive(ctx, value) {
    if ($404b9d7cff47e01b$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($404b9d7cff47e01b$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($404b9d7cff47e01b$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($404b9d7cff47e01b$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($404b9d7cff47e01b$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $404b9d7cff47e01b$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $404b9d7cff47e01b$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($404b9d7cff47e01b$var$hasOwnProperty(value, String(i))) output.push($404b9d7cff47e01b$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($404b9d7cff47e01b$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $404b9d7cff47e01b$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$404b9d7cff47e01b$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($404b9d7cff47e01b$var$isNull(recurseTimes)) str = $404b9d7cff47e01b$var$formatValue(ctx, desc.value, null);
            else str = $404b9d7cff47e01b$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($404b9d7cff47e01b$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $404b9d7cff47e01b$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("ehjbD"));
function $404b9d7cff47e01b$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $404b9d7cff47e01b$var$isArray;
function $404b9d7cff47e01b$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $404b9d7cff47e01b$var$isBoolean;
function $404b9d7cff47e01b$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $404b9d7cff47e01b$var$isNull;
function $404b9d7cff47e01b$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $404b9d7cff47e01b$var$isNullOrUndefined;
function $404b9d7cff47e01b$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $404b9d7cff47e01b$var$isNumber;
function $404b9d7cff47e01b$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $404b9d7cff47e01b$var$isString;
function $404b9d7cff47e01b$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $404b9d7cff47e01b$var$isSymbol;
function $404b9d7cff47e01b$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $404b9d7cff47e01b$var$isUndefined;
function $404b9d7cff47e01b$var$isRegExp(re) {
    return $404b9d7cff47e01b$var$isObject(re) && $404b9d7cff47e01b$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $404b9d7cff47e01b$var$isRegExp;
module.exports.types.isRegExp = $404b9d7cff47e01b$var$isRegExp;
function $404b9d7cff47e01b$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $404b9d7cff47e01b$var$isObject;
function $404b9d7cff47e01b$var$isDate(d) {
    return $404b9d7cff47e01b$var$isObject(d) && $404b9d7cff47e01b$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $404b9d7cff47e01b$var$isDate;
module.exports.types.isDate = $404b9d7cff47e01b$var$isDate;
function $404b9d7cff47e01b$var$isError(e) {
    return $404b9d7cff47e01b$var$isObject(e) && ($404b9d7cff47e01b$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $404b9d7cff47e01b$var$isError;
module.exports.types.isNativeError = $404b9d7cff47e01b$var$isError;
function $404b9d7cff47e01b$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $404b9d7cff47e01b$var$isFunction;
function $404b9d7cff47e01b$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $404b9d7cff47e01b$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("g2kud"));
function $404b9d7cff47e01b$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $404b9d7cff47e01b$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $404b9d7cff47e01b$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $404b9d7cff47e01b$var$timestamp() {
    var d = new Date();
    var time = [
        $404b9d7cff47e01b$var$pad(d.getHours()),
        $404b9d7cff47e01b$var$pad(d.getMinutes()),
        $404b9d7cff47e01b$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $404b9d7cff47e01b$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $404b9d7cff47e01b$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("h7THt"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$404b9d7cff47e01b$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $404b9d7cff47e01b$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $404b9d7cff47e01b$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($404b9d7cff47e01b$var$kCustomPromisifiedSymbol && original[$404b9d7cff47e01b$var$kCustomPromisifiedSymbol]) {
        var fn = original[$404b9d7cff47e01b$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $404b9d7cff47e01b$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($404b9d7cff47e01b$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $404b9d7cff47e01b$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $404b9d7cff47e01b$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $404b9d7cff47e01b$var$kCustomPromisifiedSymbol;
function $404b9d7cff47e01b$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $404b9d7cff47e01b$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $89WEd.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $89WEd.nextTick($404b9d7cff47e01b$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $404b9d7cff47e01b$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $404b9d7cff47e01b$var$callbackify;

});
parcelRegister("ehjbD", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $2hln8 = parcelRequire("2hln8");

var $aeAL3 = parcelRequire("aeAL3");

var $kES0E = parcelRequire("kES0E");

var $cCmuD = parcelRequire("cCmuD");
function $a651894c8d1f50fa$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $a651894c8d1f50fa$var$BigIntSupported = typeof BigInt !== 'undefined';
var $a651894c8d1f50fa$var$SymbolSupported = typeof Symbol !== 'undefined';
var $a651894c8d1f50fa$var$ObjectToString = $a651894c8d1f50fa$var$uncurryThis(Object.prototype.toString);
var $a651894c8d1f50fa$var$numberValue = $a651894c8d1f50fa$var$uncurryThis(Number.prototype.valueOf);
var $a651894c8d1f50fa$var$stringValue = $a651894c8d1f50fa$var$uncurryThis(String.prototype.valueOf);
var $a651894c8d1f50fa$var$booleanValue = $a651894c8d1f50fa$var$uncurryThis(Boolean.prototype.valueOf);
if ($a651894c8d1f50fa$var$BigIntSupported) var $a651894c8d1f50fa$var$bigIntValue = $a651894c8d1f50fa$var$uncurryThis(BigInt.prototype.valueOf);
if ($a651894c8d1f50fa$var$SymbolSupported) var $a651894c8d1f50fa$var$symbolValue = $a651894c8d1f50fa$var$uncurryThis(Symbol.prototype.valueOf);
function $a651894c8d1f50fa$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $2hln8;
module.exports.isGeneratorFunction = $aeAL3;
module.exports.isTypedArray = $cCmuD;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $a651894c8d1f50fa$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $a651894c8d1f50fa$var$isPromise;
function $a651894c8d1f50fa$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $cCmuD(value) || $a651894c8d1f50fa$var$isDataView(value);
}
module.exports.isArrayBufferView = $a651894c8d1f50fa$var$isArrayBufferView;
function $a651894c8d1f50fa$var$isUint8Array(value) {
    return $kES0E(value) === 'Uint8Array';
}
module.exports.isUint8Array = $a651894c8d1f50fa$var$isUint8Array;
function $a651894c8d1f50fa$var$isUint8ClampedArray(value) {
    return $kES0E(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $a651894c8d1f50fa$var$isUint8ClampedArray;
function $a651894c8d1f50fa$var$isUint16Array(value) {
    return $kES0E(value) === 'Uint16Array';
}
module.exports.isUint16Array = $a651894c8d1f50fa$var$isUint16Array;
function $a651894c8d1f50fa$var$isUint32Array(value) {
    return $kES0E(value) === 'Uint32Array';
}
module.exports.isUint32Array = $a651894c8d1f50fa$var$isUint32Array;
function $a651894c8d1f50fa$var$isInt8Array(value) {
    return $kES0E(value) === 'Int8Array';
}
module.exports.isInt8Array = $a651894c8d1f50fa$var$isInt8Array;
function $a651894c8d1f50fa$var$isInt16Array(value) {
    return $kES0E(value) === 'Int16Array';
}
module.exports.isInt16Array = $a651894c8d1f50fa$var$isInt16Array;
function $a651894c8d1f50fa$var$isInt32Array(value) {
    return $kES0E(value) === 'Int32Array';
}
module.exports.isInt32Array = $a651894c8d1f50fa$var$isInt32Array;
function $a651894c8d1f50fa$var$isFloat32Array(value) {
    return $kES0E(value) === 'Float32Array';
}
module.exports.isFloat32Array = $a651894c8d1f50fa$var$isFloat32Array;
function $a651894c8d1f50fa$var$isFloat64Array(value) {
    return $kES0E(value) === 'Float64Array';
}
module.exports.isFloat64Array = $a651894c8d1f50fa$var$isFloat64Array;
function $a651894c8d1f50fa$var$isBigInt64Array(value) {
    return $kES0E(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $a651894c8d1f50fa$var$isBigInt64Array;
function $a651894c8d1f50fa$var$isBigUint64Array(value) {
    return $kES0E(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $a651894c8d1f50fa$var$isBigUint64Array;
function $a651894c8d1f50fa$var$isMapToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object Map]';
}
$a651894c8d1f50fa$var$isMapToString.working = typeof Map !== 'undefined' && $a651894c8d1f50fa$var$isMapToString(new Map());
function $a651894c8d1f50fa$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $a651894c8d1f50fa$var$isMapToString.working ? $a651894c8d1f50fa$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $a651894c8d1f50fa$var$isMap;
function $a651894c8d1f50fa$var$isSetToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object Set]';
}
$a651894c8d1f50fa$var$isSetToString.working = typeof Set !== 'undefined' && $a651894c8d1f50fa$var$isSetToString(new Set());
function $a651894c8d1f50fa$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $a651894c8d1f50fa$var$isSetToString.working ? $a651894c8d1f50fa$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $a651894c8d1f50fa$var$isSet;
function $a651894c8d1f50fa$var$isWeakMapToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object WeakMap]';
}
$a651894c8d1f50fa$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $a651894c8d1f50fa$var$isWeakMapToString(new WeakMap());
function $a651894c8d1f50fa$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $a651894c8d1f50fa$var$isWeakMapToString.working ? $a651894c8d1f50fa$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $a651894c8d1f50fa$var$isWeakMap;
function $a651894c8d1f50fa$var$isWeakSetToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object WeakSet]';
}
$a651894c8d1f50fa$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $a651894c8d1f50fa$var$isWeakSetToString(new WeakSet());
function $a651894c8d1f50fa$var$isWeakSet(value) {
    return $a651894c8d1f50fa$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $a651894c8d1f50fa$var$isWeakSet;
function $a651894c8d1f50fa$var$isArrayBufferToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$a651894c8d1f50fa$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $a651894c8d1f50fa$var$isArrayBufferToString(new ArrayBuffer());
function $a651894c8d1f50fa$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $a651894c8d1f50fa$var$isArrayBufferToString.working ? $a651894c8d1f50fa$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $a651894c8d1f50fa$var$isArrayBuffer;
function $a651894c8d1f50fa$var$isDataViewToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object DataView]';
}
$a651894c8d1f50fa$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $a651894c8d1f50fa$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $a651894c8d1f50fa$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $a651894c8d1f50fa$var$isDataViewToString.working ? $a651894c8d1f50fa$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $a651894c8d1f50fa$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $a651894c8d1f50fa$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $a651894c8d1f50fa$var$isSharedArrayBufferToString(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $a651894c8d1f50fa$var$isSharedArrayBuffer(value) {
    if (typeof $a651894c8d1f50fa$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $a651894c8d1f50fa$var$isSharedArrayBufferToString.working === 'undefined') $a651894c8d1f50fa$var$isSharedArrayBufferToString.working = $a651894c8d1f50fa$var$isSharedArrayBufferToString(new $a651894c8d1f50fa$var$SharedArrayBufferCopy());
    return $a651894c8d1f50fa$var$isSharedArrayBufferToString.working ? $a651894c8d1f50fa$var$isSharedArrayBufferToString(value) : value instanceof $a651894c8d1f50fa$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $a651894c8d1f50fa$var$isSharedArrayBuffer;
function $a651894c8d1f50fa$var$isAsyncFunction(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $a651894c8d1f50fa$var$isAsyncFunction;
function $a651894c8d1f50fa$var$isMapIterator(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $a651894c8d1f50fa$var$isMapIterator;
function $a651894c8d1f50fa$var$isSetIterator(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $a651894c8d1f50fa$var$isSetIterator;
function $a651894c8d1f50fa$var$isGeneratorObject(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $a651894c8d1f50fa$var$isGeneratorObject;
function $a651894c8d1f50fa$var$isWebAssemblyCompiledModule(value) {
    return $a651894c8d1f50fa$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $a651894c8d1f50fa$var$isWebAssemblyCompiledModule;
function $a651894c8d1f50fa$var$isNumberObject(value) {
    return $a651894c8d1f50fa$var$checkBoxedPrimitive(value, $a651894c8d1f50fa$var$numberValue);
}
module.exports.isNumberObject = $a651894c8d1f50fa$var$isNumberObject;
function $a651894c8d1f50fa$var$isStringObject(value) {
    return $a651894c8d1f50fa$var$checkBoxedPrimitive(value, $a651894c8d1f50fa$var$stringValue);
}
module.exports.isStringObject = $a651894c8d1f50fa$var$isStringObject;
function $a651894c8d1f50fa$var$isBooleanObject(value) {
    return $a651894c8d1f50fa$var$checkBoxedPrimitive(value, $a651894c8d1f50fa$var$booleanValue);
}
module.exports.isBooleanObject = $a651894c8d1f50fa$var$isBooleanObject;
function $a651894c8d1f50fa$var$isBigIntObject(value) {
    return $a651894c8d1f50fa$var$BigIntSupported && $a651894c8d1f50fa$var$checkBoxedPrimitive(value, $a651894c8d1f50fa$var$bigIntValue);
}
module.exports.isBigIntObject = $a651894c8d1f50fa$var$isBigIntObject;
function $a651894c8d1f50fa$var$isSymbolObject(value) {
    return $a651894c8d1f50fa$var$SymbolSupported && $a651894c8d1f50fa$var$checkBoxedPrimitive(value, $a651894c8d1f50fa$var$symbolValue);
}
module.exports.isSymbolObject = $a651894c8d1f50fa$var$isSymbolObject;
function $a651894c8d1f50fa$var$isBoxedPrimitive(value) {
    return $a651894c8d1f50fa$var$isNumberObject(value) || $a651894c8d1f50fa$var$isStringObject(value) || $a651894c8d1f50fa$var$isBooleanObject(value) || $a651894c8d1f50fa$var$isBigIntObject(value) || $a651894c8d1f50fa$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $a651894c8d1f50fa$var$isBoxedPrimitive;
function $a651894c8d1f50fa$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($a651894c8d1f50fa$var$isArrayBuffer(value) || $a651894c8d1f50fa$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $a651894c8d1f50fa$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("2hln8", function(module, exports) {
'use strict';

var $1a8dbf59b5cfa77e$var$hasToStringTag = (parcelRequire("g1tzO"))();

var $a8i6o = parcelRequire("a8i6o");
var $1a8dbf59b5cfa77e$var$$toString = $a8i6o('Object.prototype.toString');
/** @type {import('.')} */ var $1a8dbf59b5cfa77e$var$isStandardArguments = function isArguments(value) {
    if ($1a8dbf59b5cfa77e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $1a8dbf59b5cfa77e$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $1a8dbf59b5cfa77e$var$isLegacyArguments = function isArguments(value) {
    if ($1a8dbf59b5cfa77e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $1a8dbf59b5cfa77e$var$$toString(value) !== '[object Array]' && 'callee' in value && $1a8dbf59b5cfa77e$var$$toString(value.callee) === '[object Function]';
};
var $1a8dbf59b5cfa77e$var$supportsStandardArguments = function() {
    return $1a8dbf59b5cfa77e$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$1a8dbf59b5cfa77e$var$isStandardArguments.isLegacyArguments = $1a8dbf59b5cfa77e$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $1a8dbf59b5cfa77e$var$supportsStandardArguments ? $1a8dbf59b5cfa77e$var$isStandardArguments : $1a8dbf59b5cfa77e$var$isLegacyArguments;

});

parcelRegister("aeAL3", function(module, exports) {
'use strict';

var $a8i6o = parcelRequire("a8i6o");

var $3FlK0 = parcelRequire("3FlK0");
var $7737b9885471f9f1$var$isFnRegex = $3FlK0(/^\s*(?:function)?\*/);

var $7737b9885471f9f1$var$hasToStringTag = (parcelRequire("g1tzO"))();

var $ehyg4 = parcelRequire("ehyg4");
var $7737b9885471f9f1$var$toStr = $a8i6o('Object.prototype.toString');
var $7737b9885471f9f1$var$fnToStr = $a8i6o('Function.prototype.toString');

var $ktAYS = parcelRequire("ktAYS");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($7737b9885471f9f1$var$isFnRegex($7737b9885471f9f1$var$fnToStr(fn))) return true;
    if (!$7737b9885471f9f1$var$hasToStringTag) {
        var str = $7737b9885471f9f1$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$ehyg4) return false;
    var GeneratorFunction = $ktAYS();
    return GeneratorFunction && $ehyg4(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("3FlK0", function(module, exports) {
'use strict';

var $a8i6o = parcelRequire("a8i6o");

var $iVgnu = parcelRequire("iVgnu");
var $2ab610bb073964a6$var$$exec = $a8i6o('RegExp.prototype.exec');

var $bBDQA = parcelRequire("bBDQA");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$iVgnu(regex)) throw new $bBDQA('`regex` must be a RegExp');
    return function test(s) {
        return $2ab610bb073964a6$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("iVgnu", function(module, exports) {
'use strict';

var $a8i6o = parcelRequire("a8i6o");

var $dc6a412ca09f581c$var$hasToStringTag = (parcelRequire("g1tzO"))();

var $dHVYz = parcelRequire("dHVYz");

var $eXqlJ = parcelRequire("eXqlJ");
/** @type {import('.')} */ var $dc6a412ca09f581c$var$fn;
if ($dc6a412ca09f581c$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $dc6a412ca09f581c$var$$exec = $a8i6o('RegExp.prototype.exec');
    /** @type {object} */ var $dc6a412ca09f581c$var$isRegexMarker = {};
    var $dc6a412ca09f581c$var$throwRegexMarker = function() {
        throw $dc6a412ca09f581c$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $dc6a412ca09f581c$var$badStringifier = {
        toString: $dc6a412ca09f581c$var$throwRegexMarker,
        valueOf: $dc6a412ca09f581c$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $dc6a412ca09f581c$var$badStringifier[Symbol.toPrimitive] = $dc6a412ca09f581c$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $dc6a412ca09f581c$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $eXqlJ(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $dHVYz(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $dc6a412ca09f581c$var$$exec(value, /** @type {unknown} */ $dc6a412ca09f581c$var$badStringifier);
        } catch (e) {
            return e === $dc6a412ca09f581c$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $dc6a412ca09f581c$var$$toString = $a8i6o('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $dc6a412ca09f581c$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $dc6a412ca09f581c$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $dc6a412ca09f581c$var$$toString(value) === $dc6a412ca09f581c$var$regexClass;
    };
}
module.exports = $dc6a412ca09f581c$var$fn;

});


parcelRegister("ktAYS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $07baba9029b068aa$export$2e2bcd8739ae039; });

var $9OBD6 = parcelRequire("9OBD6");
var /** @type {import('./index.d.mts').default} */ $07baba9029b068aa$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9OBD6)));

});
parcelRegister("9OBD6", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $7255f907fd81fd5e$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$7255f907fd81fd5e$var$cached;

});




parcelRegister("g2kud", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("7GHSW", function(module, exports) {

var $89WEd = parcelRequire("89WEd");

var $e2mZ5 = parcelRequire("e2mZ5");

var $hdeUV = parcelRequire("hdeUV");
var $598e7f5866c6770e$var$inherit = $e2mZ5.util.inherit;
var $598e7f5866c6770e$var$domain = $e2mZ5.util.domain;

var $iGn9k = parcelRequire("iGn9k");
/**
 * @api private
 */ var $598e7f5866c6770e$var$hardErrorStates = {
    success: 1,
    error: 1,
    complete: 1
};
function $598e7f5866c6770e$var$isTerminalState(machine) {
    return Object.prototype.hasOwnProperty.call($598e7f5866c6770e$var$hardErrorStates, machine._asm.currentState);
}
var $598e7f5866c6770e$var$fsm = new $hdeUV();
$598e7f5866c6770e$var$fsm.setupStates = function() {
    var transition = function(_, done) {
        var self = this;
        self._haltHandlersOnError = false;
        self.emit(self._asm.currentState, function(err) {
            if (err) {
                if ($598e7f5866c6770e$var$isTerminalState(self)) {
                    if ($598e7f5866c6770e$var$domain && self.domain instanceof $598e7f5866c6770e$var$domain.Domain) {
                        err.domainEmitter = self;
                        err.domain = self.domain;
                        err.domainThrown = false;
                        self.domain.emit('error', err);
                    } else throw err;
                } else {
                    self.response.error = err;
                    done(err);
                }
            } else done(self.response.error);
        });
    };
    this.addState('validate', 'build', 'error', transition);
    this.addState('build', 'afterBuild', 'restart', transition);
    this.addState('afterBuild', 'sign', 'restart', transition);
    this.addState('sign', 'send', 'retry', transition);
    this.addState('retry', 'afterRetry', 'afterRetry', transition);
    this.addState('afterRetry', 'sign', 'error', transition);
    this.addState('send', 'validateResponse', 'retry', transition);
    this.addState('validateResponse', 'extractData', 'extractError', transition);
    this.addState('extractError', 'extractData', 'retry', transition);
    this.addState('extractData', 'success', 'retry', transition);
    this.addState('restart', 'build', 'error', transition);
    this.addState('success', 'complete', 'complete', transition);
    this.addState('error', 'complete', 'complete', transition);
    this.addState('complete', null, null, transition);
};
$598e7f5866c6770e$var$fsm.setupStates();
/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(error, response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */ $e2mZ5.Request = $598e7f5866c6770e$var$inherit({
    /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */ constructor: function Request(service, operation, params) {
        var endpoint = service.endpoint;
        var region = service.config.region;
        var customUserAgent = service.config.customUserAgent;
        if (service.signingRegion) region = service.signingRegion;
        else if (service.isGlobalEndpoint) region = 'us-east-1';
        this.domain = $598e7f5866c6770e$var$domain && $598e7f5866c6770e$var$domain.active;
        this.service = service;
        this.operation = operation;
        this.params = params || {};
        this.httpRequest = new $e2mZ5.HttpRequest(endpoint, region);
        this.httpRequest.appendToUserAgent(customUserAgent);
        this.startTime = service.getSkewCorrectedDate();
        this.response = new $e2mZ5.Response(this);
        this._asm = new $hdeUV($598e7f5866c6770e$var$fsm.states, 'validate');
        this._haltHandlersOnError = false;
        $e2mZ5.SequentialExecutor.call(this);
        this.emit = this.emitEvent;
    },
    /**
   * @!group Sending a Request
   */ /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */ send: function send(callback) {
        if (callback) {
            // append to user agent
            this.httpRequest.appendToUserAgent('callback');
            this.on('complete', function(resp) {
                callback.call(resp, resp.error, resp.data);
            });
        }
        this.runTo();
        return this.response;
    },
    /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */ /**
   * @api private
   */ build: function build(callback) {
        return this.runTo('send', callback);
    },
    /**
   * @api private
   */ runTo: function runTo(state, done) {
        this._asm.runTo(state, done, this);
        return this;
    },
    /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */ abort: function abort() {
        this.removeAllListeners('validateResponse');
        this.removeAllListeners('extractError');
        this.on('validateResponse', function addAbortedError(resp) {
            resp.error = $e2mZ5.util.error(new Error('Request aborted by user'), {
                code: 'RequestAbortedError',
                retryable: false
            });
        });
        if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) {
            this.httpRequest.stream.abort();
            if (this.httpRequest._abortCallback) this.httpRequest._abortCallback();
            else this.removeAllListeners('send'); // haven't sent yet, so let's not
        }
        return this;
    },
    /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */ eachPage: function eachPage(callback) {
        // Make all callbacks async-ish
        callback = $e2mZ5.util.fn.makeAsync(callback, 3);
        function wrappedCallback(response) {
            callback.call(response, response.error, response.data, function(result) {
                if (result === false) return;
                if (response.hasNextPage()) response.nextPage().on('complete', wrappedCallback).send();
                else callback.call(response, null, null, $e2mZ5.util.fn.noop);
            });
        }
        this.on('complete', wrappedCallback).send();
    },
    /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */ eachItem: function eachItem(callback) {
        var self = this;
        function wrappedCallback(err, data) {
            if (err) return callback(err, null);
            if (data === null) return callback(null, null);
            var config = self.service.paginationConfig(self.operation);
            var resultKey = config.resultKey;
            if (Array.isArray(resultKey)) resultKey = resultKey[0];
            var items = $iGn9k.search(data, resultKey);
            var continueIteration = true;
            $e2mZ5.util.arrayEach(items, function(item) {
                continueIteration = callback(null, item);
                if (continueIteration === false) return $e2mZ5.util.abort;
            });
            return continueIteration;
        }
        this.eachPage(wrappedCallback);
    },
    /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */ isPageable: function isPageable() {
        return this.service.paginationConfig(this.operation) ? true : false;
    },
    /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */ createReadStream: function createReadStream() {
        var streams = $e2mZ5.util.stream;
        var req = this;
        var stream = null;
        if ($e2mZ5.HttpClient.streamsApiVersion === 2) {
            stream = new streams.PassThrough();
            $89WEd.nextTick(function() {
                req.send();
            });
        } else {
            stream = new streams.Stream();
            stream.readable = true;
            stream.sent = false;
            stream.on('newListener', function(event) {
                if (!stream.sent && event === 'data') {
                    stream.sent = true;
                    $89WEd.nextTick(function() {
                        req.send();
                    });
                }
            });
        }
        this.on('error', function(err) {
            stream.emit('error', err);
        });
        this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
            if (statusCode < 300) {
                req.removeListener('httpData', $e2mZ5.EventListeners.Core.HTTP_DATA);
                req.removeListener('httpError', $e2mZ5.EventListeners.Core.HTTP_ERROR);
                req.on('httpError', function streamHttpError(error) {
                    resp.error = error;
                    resp.error.retryable = false;
                });
                var shouldCheckContentLength = false;
                var expectedLen;
                if (req.httpRequest.method !== 'HEAD') expectedLen = parseInt(headers['content-length'], 10);
                if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
                    shouldCheckContentLength = true;
                    var receivedLen = 0;
                }
                var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
                    if (shouldCheckContentLength && receivedLen !== expectedLen) stream.emit('error', $e2mZ5.util.error(new Error('Stream content length mismatch. Received ' + receivedLen + ' of ' + expectedLen + ' bytes.'), {
                        code: 'StreamContentLengthMismatch'
                    }));
                    else if ($e2mZ5.HttpClient.streamsApiVersion === 2) stream.end();
                    else stream.emit('end');
                };
                var httpStream = resp.httpResponse.createUnbufferedStream();
                if ($e2mZ5.HttpClient.streamsApiVersion === 2) {
                    if (shouldCheckContentLength) {
                        var lengthAccumulator = new streams.PassThrough();
                        lengthAccumulator._write = function(chunk) {
                            if (chunk && chunk.length) receivedLen += chunk.length;
                            return streams.PassThrough.prototype._write.apply(this, arguments);
                        };
                        lengthAccumulator.on('end', checkContentLengthAndEmit);
                        stream.on('error', function(err) {
                            shouldCheckContentLength = false;
                            httpStream.unpipe(lengthAccumulator);
                            lengthAccumulator.emit('end');
                            lengthAccumulator.end();
                        });
                        httpStream.pipe(lengthAccumulator).pipe(stream, {
                            end: false
                        });
                    } else httpStream.pipe(stream);
                } else {
                    if (shouldCheckContentLength) httpStream.on('data', function(arg) {
                        if (arg && arg.length) receivedLen += arg.length;
                    });
                    httpStream.on('data', function(arg) {
                        stream.emit('data', arg);
                    });
                    httpStream.on('end', checkContentLengthAndEmit);
                }
                httpStream.on('error', function(err) {
                    shouldCheckContentLength = false;
                    stream.emit('error', err);
                });
            }
        });
        return stream;
    },
    /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */ emitEvent: function emit(eventName, args, done) {
        if (typeof args === 'function') {
            done = args;
            args = null;
        }
        if (!done) done = function() {};
        if (!args) args = this.eventParameters(eventName, this.response);
        var origEmit = $e2mZ5.SequentialExecutor.prototype.emit;
        origEmit.call(this, eventName, args, function(err) {
            if (err) this.response.error = err;
            done.call(this, err);
        });
    },
    /**
   * @api private
   */ eventParameters: function eventParameters(eventName) {
        switch(eventName){
            case 'restart':
            case 'validate':
            case 'sign':
            case 'build':
            case 'afterValidate':
            case 'afterBuild':
                return [
                    this
                ];
            case 'error':
                return [
                    this.response.error,
                    this.response
                ];
            default:
                return [
                    this.response
                ];
        }
    },
    /**
   * @api private
   */ presign: function presign(expires, callback) {
        if (!callback && typeof expires === 'function') {
            callback = expires;
            expires = null;
        }
        return new $e2mZ5.Signers.Presign().sign(this.toGet(), expires, callback);
    },
    /**
   * @api private
   */ isPresigned: function isPresigned() {
        return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
    },
    /**
   * @api private
   */ toUnauthenticated: function toUnauthenticated() {
        this._unAuthenticated = true;
        this.removeListener('validate', $e2mZ5.EventListeners.Core.VALIDATE_CREDENTIALS);
        this.removeListener('sign', $e2mZ5.EventListeners.Core.SIGN);
        return this;
    },
    /**
   * @api private
   */ toGet: function toGet() {
        if (this.service.api.protocol === 'query' || this.service.api.protocol === 'ec2') {
            this.removeListener('build', this.buildAsGet);
            this.addListener('build', this.buildAsGet);
        }
        return this;
    },
    /**
   * @api private
   */ buildAsGet: function buildAsGet(request) {
        request.httpRequest.method = 'GET';
        request.httpRequest.path = request.service.endpoint.path + '?' + request.httpRequest.body;
        request.httpRequest.body = '';
        // don't need these headers on a GET request
        delete request.httpRequest.headers['Content-Length'];
        delete request.httpRequest.headers['Content-Type'];
    },
    /**
   * @api private
   */ haltHandlersOnError: function haltHandlersOnError() {
        this._haltHandlersOnError = true;
    }
});
/**
 * @api private
 */ $e2mZ5.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.promise = function promise() {
        var self = this;
        // append to user agent
        this.httpRequest.appendToUserAgent('promise');
        return new PromiseDependency(function(resolve, reject) {
            self.on('complete', function(resp) {
                if (resp.error) reject(resp.error);
                else // define $response property so that it is not enumerable
                // this prevents circular reference errors when stringifying the JSON object
                resolve(Object.defineProperty(resp.data || {}, '$response', {
                    value: resp
                }));
            });
            self.runTo();
        });
    };
};
/**
 * @api private
 */ $e2mZ5.Request.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.promise;
};
$e2mZ5.util.addPromises($e2mZ5.Request);
$e2mZ5.util.mixin($e2mZ5.Request, $e2mZ5.SequentialExecutor);

});
parcelRegister("hdeUV", function(module, exports) {
function $c87f38d3743e288a$var$AcceptorStateMachine(states, state) {
    this.currentState = state || null;
    this.states = states || {};
}
$c87f38d3743e288a$var$AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
    if (typeof finalState === 'function') {
        inputError = bindObject;
        bindObject = done;
        done = finalState;
        finalState = null;
    }
    var self = this;
    var state = self.states[self.currentState];
    state.fn.call(bindObject || self, inputError, function(err) {
        if (err) {
            if (state.fail) self.currentState = state.fail;
            else return done ? done.call(bindObject, err) : null;
        } else {
            if (state.accept) self.currentState = state.accept;
            else return done ? done.call(bindObject) : null;
        }
        if (self.currentState === finalState) return done ? done.call(bindObject, err) : null;
        self.runTo(finalState, done, bindObject, err);
    });
};
$c87f38d3743e288a$var$AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
    if (typeof acceptState === 'function') {
        fn = acceptState;
        acceptState = null;
        failState = null;
    } else if (typeof failState === 'function') {
        fn = failState;
        failState = null;
    }
    if (!this.currentState) this.currentState = name;
    this.states[name] = {
        accept: acceptState,
        fail: failState,
        fn: fn
    };
    return this;
};
/**
 * @api private
 */ module.exports = $c87f38d3743e288a$var$AcceptorStateMachine;

});

parcelRegister("iGn9k", function(module, exports) {
(function(exports1) {
    "use strict";
    function isArray(obj) {
        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Array]";
        else return false;
    }
    function isObject(obj) {
        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Object]";
        else return false;
    }
    function strictDeepEqual(first, second) {
        // Check the scalar case first.
        if (first === second) return true;
        // Check if they are the same type.
        var firstType = Object.prototype.toString.call(first);
        if (firstType !== Object.prototype.toString.call(second)) return false;
        // We know that first and second have the same type so we can just check the
        // first type from now on.
        if (isArray(first) === true) {
            // Short circuit if they're not the same length;
            if (first.length !== second.length) return false;
            for(var i = 0; i < first.length; i++){
                if (strictDeepEqual(first[i], second[i]) === false) return false;
            }
            return true;
        }
        if (isObject(first) === true) {
            // An object is equal if it has the same key/value pairs.
            var keysSeen = {};
            for(var key in first)if (hasOwnProperty.call(first, key)) {
                if (strictDeepEqual(first[key], second[key]) === false) return false;
                keysSeen[key] = true;
            }
            // Now check that there aren't any keys in second that weren't
            // in first.
            for(var key2 in second)if (hasOwnProperty.call(second, key2)) {
                if (keysSeen[key2] !== true) return false;
            }
            return true;
        }
        return false;
    }
    function isFalse(obj) {
        // From the spec:
        // A false value corresponds to the following values:
        // Empty list
        // Empty object
        // Empty string
        // False boolean
        // null value
        // First check the scalar values.
        if (obj === "" || obj === false || obj === null) return true;
        else if (isArray(obj) && obj.length === 0) // Check for an empty array.
        return true;
        else if (isObject(obj)) {
            // Check for an empty object.
            for(var key in obj){
                // If there are any keys, then
                // the object is not empty so the object
                // is not false.
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        } else return false;
    }
    function objValues(obj) {
        var keys = Object.keys(obj);
        var values = [];
        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
        return values;
    }
    function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key2 in b)merged[key2] = b[key2];
        return merged;
    }
    var trimLeft;
    if (typeof String.prototype.trimLeft === "function") trimLeft = function(str) {
        return str.trimLeft();
    };
    else trimLeft = function(str) {
        return str.match(/^\s*(.*)/)[1];
    };
    // Type constants used to define functions.
    var TYPE_NUMBER = 0;
    var TYPE_ANY = 1;
    var TYPE_STRING = 2;
    var TYPE_ARRAY = 3;
    var TYPE_OBJECT = 4;
    var TYPE_BOOLEAN = 5;
    var TYPE_EXPREF = 6;
    var TYPE_NULL = 7;
    var TYPE_ARRAY_NUMBER = 8;
    var TYPE_ARRAY_STRING = 9;
    var TYPE_NAME_TABLE = {
        0: 'number',
        1: 'any',
        2: 'string',
        3: 'array',
        4: 'object',
        5: 'boolean',
        6: 'expression',
        7: 'null',
        8: 'Array<number>',
        9: 'Array<string>'
    };
    var TOK_EOF = "EOF";
    var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
    var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
    var TOK_RBRACKET = "Rbracket";
    var TOK_RPAREN = "Rparen";
    var TOK_COMMA = "Comma";
    var TOK_COLON = "Colon";
    var TOK_RBRACE = "Rbrace";
    var TOK_NUMBER = "Number";
    var TOK_CURRENT = "Current";
    var TOK_EXPREF = "Expref";
    var TOK_PIPE = "Pipe";
    var TOK_OR = "Or";
    var TOK_AND = "And";
    var TOK_EQ = "EQ";
    var TOK_GT = "GT";
    var TOK_LT = "LT";
    var TOK_GTE = "GTE";
    var TOK_LTE = "LTE";
    var TOK_NE = "NE";
    var TOK_FLATTEN = "Flatten";
    var TOK_STAR = "Star";
    var TOK_FILTER = "Filter";
    var TOK_DOT = "Dot";
    var TOK_NOT = "Not";
    var TOK_LBRACE = "Lbrace";
    var TOK_LBRACKET = "Lbracket";
    var TOK_LPAREN = "Lparen";
    var TOK_LITERAL = "Literal";
    // The "&", "[", "<", ">" tokens
    // are not in basicToken because
    // there are two token variants
    // ("&&", "[?", "<=", ">=").  This is specially handled
    // below.
    var basicTokens = {
        ".": TOK_DOT,
        "*": TOK_STAR,
        ",": TOK_COMMA,
        ":": TOK_COLON,
        "{": TOK_LBRACE,
        "}": TOK_RBRACE,
        "]": TOK_RBRACKET,
        "(": TOK_LPAREN,
        ")": TOK_RPAREN,
        "@": TOK_CURRENT
    };
    var operatorStartToken = {
        "<": true,
        ">": true,
        "=": true,
        "!": true
    };
    var skipChars = {
        " ": true,
        "\t": true,
        "\n": true
    };
    function isAlpha(ch) {
        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch === "_";
    }
    function isNum(ch) {
        return ch >= "0" && ch <= "9" || ch === "-";
    }
    function isAlphaNum(ch) {
        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9" || ch === "_";
    }
    function Lexer() {}
    Lexer.prototype = {
        tokenize: function(stream) {
            var tokens = [];
            this._current = 0;
            var start;
            var identifier;
            var token;
            while(this._current < stream.length){
                if (isAlpha(stream[this._current])) {
                    start = this._current;
                    identifier = this._consumeUnquotedIdentifier(stream);
                    tokens.push({
                        type: TOK_UNQUOTEDIDENTIFIER,
                        value: identifier,
                        start: start
                    });
                } else if (basicTokens[stream[this._current]] !== undefined) {
                    tokens.push({
                        type: basicTokens[stream[this._current]],
                        value: stream[this._current],
                        start: this._current
                    });
                    this._current++;
                } else if (isNum(stream[this._current])) {
                    token = this._consumeNumber(stream);
                    tokens.push(token);
                } else if (stream[this._current] === "[") {
                    // No need to increment this._current.  This happens
                    // in _consumeLBracket
                    token = this._consumeLBracket(stream);
                    tokens.push(token);
                } else if (stream[this._current] === "\"") {
                    start = this._current;
                    identifier = this._consumeQuotedIdentifier(stream);
                    tokens.push({
                        type: TOK_QUOTEDIDENTIFIER,
                        value: identifier,
                        start: start
                    });
                } else if (stream[this._current] === "'") {
                    start = this._current;
                    identifier = this._consumeRawStringLiteral(stream);
                    tokens.push({
                        type: TOK_LITERAL,
                        value: identifier,
                        start: start
                    });
                } else if (stream[this._current] === "`") {
                    start = this._current;
                    var literal = this._consumeLiteral(stream);
                    tokens.push({
                        type: TOK_LITERAL,
                        value: literal,
                        start: start
                    });
                } else if (operatorStartToken[stream[this._current]] !== undefined) tokens.push(this._consumeOperator(stream));
                else if (skipChars[stream[this._current]] !== undefined) // Ignore whitespace.
                this._current++;
                else if (stream[this._current] === "&") {
                    start = this._current;
                    this._current++;
                    if (stream[this._current] === "&") {
                        this._current++;
                        tokens.push({
                            type: TOK_AND,
                            value: "&&",
                            start: start
                        });
                    } else tokens.push({
                        type: TOK_EXPREF,
                        value: "&",
                        start: start
                    });
                } else if (stream[this._current] === "|") {
                    start = this._current;
                    this._current++;
                    if (stream[this._current] === "|") {
                        this._current++;
                        tokens.push({
                            type: TOK_OR,
                            value: "||",
                            start: start
                        });
                    } else tokens.push({
                        type: TOK_PIPE,
                        value: "|",
                        start: start
                    });
                } else {
                    var error = new Error("Unknown character:" + stream[this._current]);
                    error.name = "LexerError";
                    throw error;
                }
            }
            return tokens;
        },
        _consumeUnquotedIdentifier: function(stream) {
            var start = this._current;
            this._current++;
            while(this._current < stream.length && isAlphaNum(stream[this._current]))this._current++;
            return stream.slice(start, this._current);
        },
        _consumeQuotedIdentifier: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(stream[this._current] !== "\"" && this._current < maxLength){
                // You can escape a double quote and you can escape an escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "\"")) current += 2;
                else current++;
                this._current = current;
            }
            this._current++;
            return JSON.parse(stream.slice(start, this._current));
        },
        _consumeRawStringLiteral: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(stream[this._current] !== "'" && this._current < maxLength){
                // You can escape a single quote and you can escape an escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "'")) current += 2;
                else current++;
                this._current = current;
            }
            this._current++;
            var literal = stream.slice(start + 1, this._current - 1);
            return literal.replace("\\'", "'");
        },
        _consumeNumber: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(isNum(stream[this._current]) && this._current < maxLength)this._current++;
            var value = parseInt(stream.slice(start, this._current));
            return {
                type: TOK_NUMBER,
                value: value,
                start: start
            };
        },
        _consumeLBracket: function(stream) {
            var start = this._current;
            this._current++;
            if (stream[this._current] === "?") {
                this._current++;
                return {
                    type: TOK_FILTER,
                    value: "[?",
                    start: start
                };
            } else if (stream[this._current] === "]") {
                this._current++;
                return {
                    type: TOK_FLATTEN,
                    value: "[]",
                    start: start
                };
            } else return {
                type: TOK_LBRACKET,
                value: "[",
                start: start
            };
        },
        _consumeOperator: function(stream) {
            var start = this._current;
            var startingChar = stream[start];
            this._current++;
            if (startingChar === "!") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_NE,
                        value: "!=",
                        start: start
                    };
                } else return {
                    type: TOK_NOT,
                    value: "!",
                    start: start
                };
            } else if (startingChar === "<") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_LTE,
                        value: "<=",
                        start: start
                    };
                } else return {
                    type: TOK_LT,
                    value: "<",
                    start: start
                };
            } else if (startingChar === ">") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_GTE,
                        value: ">=",
                        start: start
                    };
                } else return {
                    type: TOK_GT,
                    value: ">",
                    start: start
                };
            } else if (startingChar === "=") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_EQ,
                        value: "==",
                        start: start
                    };
                }
            }
        },
        _consumeLiteral: function(stream) {
            this._current++;
            var start = this._current;
            var maxLength = stream.length;
            var literal;
            while(stream[this._current] !== "`" && this._current < maxLength){
                // You can escape a literal char or you can escape the escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "`")) current += 2;
                else current++;
                this._current = current;
            }
            var literalString = trimLeft(stream.slice(start, this._current));
            literalString = literalString.replace("\\`", "`");
            if (this._looksLikeJSON(literalString)) literal = JSON.parse(literalString);
            else // Try to JSON parse it as "<literal>"
            literal = JSON.parse("\"" + literalString + "\"");
            // +1 gets us to the ending "`", +1 to move on to the next char.
            this._current++;
            return literal;
        },
        _looksLikeJSON: function(literalString) {
            var startingChars = "[{\"";
            var jsonLiterals = [
                "true",
                "false",
                "null"
            ];
            var numberLooking = "-0123456789";
            if (literalString === "") return false;
            else if (startingChars.indexOf(literalString[0]) >= 0) return true;
            else if (jsonLiterals.indexOf(literalString) >= 0) return true;
            else if (numberLooking.indexOf(literalString[0]) >= 0) try {
                JSON.parse(literalString);
                return true;
            } catch (ex) {
                return false;
            }
            else return false;
        }
    };
    var bindingPower = {};
    bindingPower[TOK_EOF] = 0;
    bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
    bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
    bindingPower[TOK_RBRACKET] = 0;
    bindingPower[TOK_RPAREN] = 0;
    bindingPower[TOK_COMMA] = 0;
    bindingPower[TOK_RBRACE] = 0;
    bindingPower[TOK_NUMBER] = 0;
    bindingPower[TOK_CURRENT] = 0;
    bindingPower[TOK_EXPREF] = 0;
    bindingPower[TOK_PIPE] = 1;
    bindingPower[TOK_OR] = 2;
    bindingPower[TOK_AND] = 3;
    bindingPower[TOK_EQ] = 5;
    bindingPower[TOK_GT] = 5;
    bindingPower[TOK_LT] = 5;
    bindingPower[TOK_GTE] = 5;
    bindingPower[TOK_LTE] = 5;
    bindingPower[TOK_NE] = 5;
    bindingPower[TOK_FLATTEN] = 9;
    bindingPower[TOK_STAR] = 20;
    bindingPower[TOK_FILTER] = 21;
    bindingPower[TOK_DOT] = 40;
    bindingPower[TOK_NOT] = 45;
    bindingPower[TOK_LBRACE] = 50;
    bindingPower[TOK_LBRACKET] = 55;
    bindingPower[TOK_LPAREN] = 60;
    function Parser() {}
    Parser.prototype = {
        parse: function(expression) {
            this._loadTokens(expression);
            this.index = 0;
            var ast = this.expression(0);
            if (this._lookahead(0) !== TOK_EOF) {
                var t = this._lookaheadToken(0);
                var error = new Error("Unexpected token type: " + t.type + ", value: " + t.value);
                error.name = "ParserError";
                throw error;
            }
            return ast;
        },
        _loadTokens: function(expression) {
            var lexer = new Lexer();
            var tokens = lexer.tokenize(expression);
            tokens.push({
                type: TOK_EOF,
                value: "",
                start: expression.length
            });
            this.tokens = tokens;
        },
        expression: function(rbp) {
            var leftToken = this._lookaheadToken(0);
            this._advance();
            var left = this.nud(leftToken);
            var currentToken = this._lookahead(0);
            while(rbp < bindingPower[currentToken]){
                this._advance();
                left = this.led(currentToken, left);
                currentToken = this._lookahead(0);
            }
            return left;
        },
        _lookahead: function(number) {
            return this.tokens[this.index + number].type;
        },
        _lookaheadToken: function(number) {
            return this.tokens[this.index + number];
        },
        _advance: function() {
            this.index++;
        },
        nud: function(token) {
            var left;
            var right;
            var expression;
            switch(token.type){
                case TOK_LITERAL:
                    return {
                        type: "Literal",
                        value: token.value
                    };
                case TOK_UNQUOTEDIDENTIFIER:
                    return {
                        type: "Field",
                        name: token.value
                    };
                case TOK_QUOTEDIDENTIFIER:
                    var node = {
                        type: "Field",
                        name: token.value
                    };
                    if (this._lookahead(0) === TOK_LPAREN) throw new Error("Quoted identifier not allowed for function names.");
                    return node;
                case TOK_NOT:
                    right = this.expression(bindingPower.Not);
                    return {
                        type: "NotExpression",
                        children: [
                            right
                        ]
                    };
                case TOK_STAR:
                    left = {
                        type: "Identity"
                    };
                    right = null;
                    if (this._lookahead(0) === TOK_RBRACKET) // This can happen in a multiselect,
                    // [a, b, *]
                    right = {
                        type: "Identity"
                    };
                    else right = this._parseProjectionRHS(bindingPower.Star);
                    return {
                        type: "ValueProjection",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_FILTER:
                    return this.led(token.type, {
                        type: "Identity"
                    });
                case TOK_LBRACE:
                    return this._parseMultiselectHash();
                case TOK_FLATTEN:
                    left = {
                        type: TOK_FLATTEN,
                        children: [
                            {
                                type: "Identity"
                            }
                        ]
                    };
                    right = this._parseProjectionRHS(bindingPower.Flatten);
                    return {
                        type: "Projection",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_LBRACKET:
                    if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                        right = this._parseIndexExpression();
                        return this._projectIfSlice({
                            type: "Identity"
                        }, right);
                    } else if (this._lookahead(0) === TOK_STAR && this._lookahead(1) === TOK_RBRACKET) {
                        this._advance();
                        this._advance();
                        right = this._parseProjectionRHS(bindingPower.Star);
                        return {
                            type: "Projection",
                            children: [
                                {
                                    type: "Identity"
                                },
                                right
                            ]
                        };
                    }
                    return this._parseMultiselectList();
                case TOK_CURRENT:
                    return {
                        type: TOK_CURRENT
                    };
                case TOK_EXPREF:
                    expression = this.expression(bindingPower.Expref);
                    return {
                        type: "ExpressionReference",
                        children: [
                            expression
                        ]
                    };
                case TOK_LPAREN:
                    var args = [];
                    while(this._lookahead(0) !== TOK_RPAREN){
                        if (this._lookahead(0) === TOK_CURRENT) {
                            expression = {
                                type: TOK_CURRENT
                            };
                            this._advance();
                        } else expression = this.expression(0);
                        args.push(expression);
                    }
                    this._match(TOK_RPAREN);
                    return args[0];
                default:
                    this._errorToken(token);
            }
        },
        led: function(tokenName, left) {
            var right;
            switch(tokenName){
                case TOK_DOT:
                    var rbp = bindingPower.Dot;
                    if (this._lookahead(0) !== TOK_STAR) {
                        right = this._parseDotRHS(rbp);
                        return {
                            type: "Subexpression",
                            children: [
                                left,
                                right
                            ]
                        };
                    }
                    // Creating a projection.
                    this._advance();
                    right = this._parseProjectionRHS(rbp);
                    return {
                        type: "ValueProjection",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_PIPE:
                    right = this.expression(bindingPower.Pipe);
                    return {
                        type: TOK_PIPE,
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_OR:
                    right = this.expression(bindingPower.Or);
                    return {
                        type: "OrExpression",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_AND:
                    right = this.expression(bindingPower.And);
                    return {
                        type: "AndExpression",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_LPAREN:
                    var name = left.name;
                    var args = [];
                    var expression, node;
                    while(this._lookahead(0) !== TOK_RPAREN){
                        if (this._lookahead(0) === TOK_CURRENT) {
                            expression = {
                                type: TOK_CURRENT
                            };
                            this._advance();
                        } else expression = this.expression(0);
                        if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                        args.push(expression);
                    }
                    this._match(TOK_RPAREN);
                    node = {
                        type: "Function",
                        name: name,
                        children: args
                    };
                    return node;
                case TOK_FILTER:
                    var condition = this.expression(0);
                    this._match(TOK_RBRACKET);
                    if (this._lookahead(0) === TOK_FLATTEN) right = {
                        type: "Identity"
                    };
                    else right = this._parseProjectionRHS(bindingPower.Filter);
                    return {
                        type: "FilterProjection",
                        children: [
                            left,
                            right,
                            condition
                        ]
                    };
                case TOK_FLATTEN:
                    var leftNode = {
                        type: TOK_FLATTEN,
                        children: [
                            left
                        ]
                    };
                    var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
                    return {
                        type: "Projection",
                        children: [
                            leftNode,
                            rightNode
                        ]
                    };
                case TOK_EQ:
                case TOK_NE:
                case TOK_GT:
                case TOK_GTE:
                case TOK_LT:
                case TOK_LTE:
                    return this._parseComparator(left, tokenName);
                case TOK_LBRACKET:
                    var token = this._lookaheadToken(0);
                    if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                        right = this._parseIndexExpression();
                        return this._projectIfSlice(left, right);
                    }
                    this._match(TOK_STAR);
                    this._match(TOK_RBRACKET);
                    right = this._parseProjectionRHS(bindingPower.Star);
                    return {
                        type: "Projection",
                        children: [
                            left,
                            right
                        ]
                    };
                default:
                    this._errorToken(this._lookaheadToken(0));
            }
        },
        _match: function(tokenType) {
            if (this._lookahead(0) === tokenType) this._advance();
            else {
                var t = this._lookaheadToken(0);
                var error = new Error("Expected " + tokenType + ", got: " + t.type);
                error.name = "ParserError";
                throw error;
            }
        },
        _errorToken: function(token) {
            var error = new Error("Invalid token (" + token.type + "): \"" + token.value + "\"");
            error.name = "ParserError";
            throw error;
        },
        _parseIndexExpression: function() {
            if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) return this._parseSliceExpression();
            else {
                var node = {
                    type: "Index",
                    value: this._lookaheadToken(0).value
                };
                this._advance();
                this._match(TOK_RBRACKET);
                return node;
            }
        },
        _projectIfSlice: function(left, right) {
            var indexExpr = {
                type: "IndexExpression",
                children: [
                    left,
                    right
                ]
            };
            if (right.type === "Slice") return {
                type: "Projection",
                children: [
                    indexExpr,
                    this._parseProjectionRHS(bindingPower.Star)
                ]
            };
            else return indexExpr;
        },
        _parseSliceExpression: function() {
            // [start:end:step] where each part is optional, as well as the last
            // colon.
            var parts = [
                null,
                null,
                null
            ];
            var index = 0;
            var currentToken = this._lookahead(0);
            while(currentToken !== TOK_RBRACKET && index < 3){
                if (currentToken === TOK_COLON) {
                    index++;
                    this._advance();
                } else if (currentToken === TOK_NUMBER) {
                    parts[index] = this._lookaheadToken(0).value;
                    this._advance();
                } else {
                    var t = this._lookahead(0);
                    var error = new Error("Syntax error, unexpected token: " + t.value + "(" + t.type + ")");
                    error.name = "Parsererror";
                    throw error;
                }
                currentToken = this._lookahead(0);
            }
            this._match(TOK_RBRACKET);
            return {
                type: "Slice",
                children: parts
            };
        },
        _parseComparator: function(left, comparator) {
            var right = this.expression(bindingPower[comparator]);
            return {
                type: "Comparator",
                name: comparator,
                children: [
                    left,
                    right
                ]
            };
        },
        _parseDotRHS: function(rbp) {
            var lookahead = this._lookahead(0);
            var exprTokens = [
                TOK_UNQUOTEDIDENTIFIER,
                TOK_QUOTEDIDENTIFIER,
                TOK_STAR
            ];
            if (exprTokens.indexOf(lookahead) >= 0) return this.expression(rbp);
            else if (lookahead === TOK_LBRACKET) {
                this._match(TOK_LBRACKET);
                return this._parseMultiselectList();
            } else if (lookahead === TOK_LBRACE) {
                this._match(TOK_LBRACE);
                return this._parseMultiselectHash();
            }
        },
        _parseProjectionRHS: function(rbp) {
            var right;
            if (bindingPower[this._lookahead(0)] < 10) right = {
                type: "Identity"
            };
            else if (this._lookahead(0) === TOK_LBRACKET) right = this.expression(rbp);
            else if (this._lookahead(0) === TOK_FILTER) right = this.expression(rbp);
            else if (this._lookahead(0) === TOK_DOT) {
                this._match(TOK_DOT);
                right = this._parseDotRHS(rbp);
            } else {
                var t = this._lookaheadToken(0);
                var error = new Error("Sytanx error, unexpected token: " + t.value + "(" + t.type + ")");
                error.name = "ParserError";
                throw error;
            }
            return right;
        },
        _parseMultiselectList: function() {
            var expressions = [];
            while(this._lookahead(0) !== TOK_RBRACKET){
                var expression = this.expression(0);
                expressions.push(expression);
                if (this._lookahead(0) === TOK_COMMA) {
                    this._match(TOK_COMMA);
                    if (this._lookahead(0) === TOK_RBRACKET) throw new Error("Unexpected token Rbracket");
                }
            }
            this._match(TOK_RBRACKET);
            return {
                type: "MultiSelectList",
                children: expressions
            };
        },
        _parseMultiselectHash: function() {
            var pairs = [];
            var identifierTypes = [
                TOK_UNQUOTEDIDENTIFIER,
                TOK_QUOTEDIDENTIFIER
            ];
            var keyToken, keyName, value, node;
            for(;;){
                keyToken = this._lookaheadToken(0);
                if (identifierTypes.indexOf(keyToken.type) < 0) throw new Error("Expecting an identifier token, got: " + keyToken.type);
                keyName = keyToken.value;
                this._advance();
                this._match(TOK_COLON);
                value = this.expression(0);
                node = {
                    type: "KeyValuePair",
                    name: keyName,
                    value: value
                };
                pairs.push(node);
                if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                else if (this._lookahead(0) === TOK_RBRACE) {
                    this._match(TOK_RBRACE);
                    break;
                }
            }
            return {
                type: "MultiSelectHash",
                children: pairs
            };
        }
    };
    function TreeInterpreter(runtime) {
        this.runtime = runtime;
    }
    TreeInterpreter.prototype = {
        search: function(node, value) {
            return this.visit(node, value);
        },
        visit: function(node, value) {
            var matched, current, result, first, second, field, left, right, collected, i;
            switch(node.type){
                case "Field":
                    if (value !== null && isObject(value)) {
                        field = value[node.name];
                        if (field === undefined) return null;
                        else return field;
                    }
                    return null;
                case "Subexpression":
                    result = this.visit(node.children[0], value);
                    for(i = 1; i < node.children.length; i++){
                        result = this.visit(node.children[1], result);
                        if (result === null) return null;
                    }
                    return result;
                case "IndexExpression":
                    left = this.visit(node.children[0], value);
                    right = this.visit(node.children[1], left);
                    return right;
                case "Index":
                    if (!isArray(value)) return null;
                    var index = node.value;
                    if (index < 0) index = value.length + index;
                    result = value[index];
                    if (result === undefined) result = null;
                    return result;
                case "Slice":
                    if (!isArray(value)) return null;
                    var sliceParams = node.children.slice(0);
                    var computed = this.computeSliceParams(value.length, sliceParams);
                    var start = computed[0];
                    var stop = computed[1];
                    var step = computed[2];
                    result = [];
                    if (step > 0) for(i = start; i < stop; i += step)result.push(value[i]);
                    else for(i = start; i > stop; i += step)result.push(value[i]);
                    return result;
                case "Projection":
                    // Evaluate left child.
                    var base = this.visit(node.children[0], value);
                    if (!isArray(base)) return null;
                    collected = [];
                    for(i = 0; i < base.length; i++){
                        current = this.visit(node.children[1], base[i]);
                        if (current !== null) collected.push(current);
                    }
                    return collected;
                case "ValueProjection":
                    // Evaluate left child.
                    base = this.visit(node.children[0], value);
                    if (!isObject(base)) return null;
                    collected = [];
                    var values = objValues(base);
                    for(i = 0; i < values.length; i++){
                        current = this.visit(node.children[1], values[i]);
                        if (current !== null) collected.push(current);
                    }
                    return collected;
                case "FilterProjection":
                    base = this.visit(node.children[0], value);
                    if (!isArray(base)) return null;
                    var filtered = [];
                    var finalResults = [];
                    for(i = 0; i < base.length; i++){
                        matched = this.visit(node.children[2], base[i]);
                        if (!isFalse(matched)) filtered.push(base[i]);
                    }
                    for(var j = 0; j < filtered.length; j++){
                        current = this.visit(node.children[1], filtered[j]);
                        if (current !== null) finalResults.push(current);
                    }
                    return finalResults;
                case "Comparator":
                    first = this.visit(node.children[0], value);
                    second = this.visit(node.children[1], value);
                    switch(node.name){
                        case TOK_EQ:
                            result = strictDeepEqual(first, second);
                            break;
                        case TOK_NE:
                            result = !strictDeepEqual(first, second);
                            break;
                        case TOK_GT:
                            result = first > second;
                            break;
                        case TOK_GTE:
                            result = first >= second;
                            break;
                        case TOK_LT:
                            result = first < second;
                            break;
                        case TOK_LTE:
                            result = first <= second;
                            break;
                        default:
                            throw new Error("Unknown comparator: " + node.name);
                    }
                    return result;
                case TOK_FLATTEN:
                    var original = this.visit(node.children[0], value);
                    if (!isArray(original)) return null;
                    var merged = [];
                    for(i = 0; i < original.length; i++){
                        current = original[i];
                        if (isArray(current)) merged.push.apply(merged, current);
                        else merged.push(current);
                    }
                    return merged;
                case "Identity":
                    return value;
                case "MultiSelectList":
                    if (value === null) return null;
                    collected = [];
                    for(i = 0; i < node.children.length; i++)collected.push(this.visit(node.children[i], value));
                    return collected;
                case "MultiSelectHash":
                    if (value === null) return null;
                    collected = {};
                    var child;
                    for(i = 0; i < node.children.length; i++){
                        child = node.children[i];
                        collected[child.name] = this.visit(child.value, value);
                    }
                    return collected;
                case "OrExpression":
                    matched = this.visit(node.children[0], value);
                    if (isFalse(matched)) matched = this.visit(node.children[1], value);
                    return matched;
                case "AndExpression":
                    first = this.visit(node.children[0], value);
                    if (isFalse(first) === true) return first;
                    return this.visit(node.children[1], value);
                case "NotExpression":
                    first = this.visit(node.children[0], value);
                    return isFalse(first);
                case "Literal":
                    return node.value;
                case TOK_PIPE:
                    left = this.visit(node.children[0], value);
                    return this.visit(node.children[1], left);
                case TOK_CURRENT:
                    return value;
                case "Function":
                    var resolvedArgs = [];
                    for(i = 0; i < node.children.length; i++)resolvedArgs.push(this.visit(node.children[i], value));
                    return this.runtime.callFunction(node.name, resolvedArgs);
                case "ExpressionReference":
                    var refNode = node.children[0];
                    // Tag the node with a specific attribute so the type
                    // checker verify the type.
                    refNode.jmespathType = TOK_EXPREF;
                    return refNode;
                default:
                    throw new Error("Unknown node type: " + node.type);
            }
        },
        computeSliceParams: function(arrayLength, sliceParams) {
            var start = sliceParams[0];
            var stop = sliceParams[1];
            var step = sliceParams[2];
            var computed = [
                null,
                null,
                null
            ];
            if (step === null) step = 1;
            else if (step === 0) {
                var error = new Error("Invalid slice, step cannot be 0");
                error.name = "RuntimeError";
                throw error;
            }
            var stepValueNegative = step < 0 ? true : false;
            if (start === null) start = stepValueNegative ? arrayLength - 1 : 0;
            else start = this.capSliceRange(arrayLength, start, step);
            if (stop === null) stop = stepValueNegative ? -1 : arrayLength;
            else stop = this.capSliceRange(arrayLength, stop, step);
            computed[0] = start;
            computed[1] = stop;
            computed[2] = step;
            return computed;
        },
        capSliceRange: function(arrayLength, actualValue, step) {
            if (actualValue < 0) {
                actualValue += arrayLength;
                if (actualValue < 0) actualValue = step < 0 ? -1 : 0;
            } else if (actualValue >= arrayLength) actualValue = step < 0 ? arrayLength - 1 : arrayLength;
            return actualValue;
        }
    };
    function Runtime(interpreter) {
        this._interpreter = interpreter;
        this.functionTable = {
            // name: [function, <signature>]
            // The <signature> can be:
            //
            // {
            //   args: [[type1, type2], [type1, type2]],
            //   variadic: true|false
            // }
            //
            // Each arg in the arg list is a list of valid types
            // (if the function is overloaded and supports multiple
            // types.  If the type is "any" then no type checking
            // occurs on the argument.  Variadic is optional
            // and if not provided is assumed to be false.
            abs: {
                _func: this._functionAbs,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            avg: {
                _func: this._functionAvg,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            ceil: {
                _func: this._functionCeil,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            contains: {
                _func: this._functionContains,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "ends_with": {
                _func: this._functionEndsWith,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_STRING
                        ]
                    }
                ]
            },
            floor: {
                _func: this._functionFloor,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            length: {
                _func: this._functionLength,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY,
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            map: {
                _func: this._functionMap,
                _signature: [
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    },
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    }
                ]
            },
            max: {
                _func: this._functionMax,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER,
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            "merge": {
                _func: this._functionMerge,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ],
                        variadic: true
                    }
                ]
            },
            "max_by": {
                _func: this._functionMaxBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            sum: {
                _func: this._functionSum,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            "starts_with": {
                _func: this._functionStartsWith,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_STRING
                        ]
                    }
                ]
            },
            min: {
                _func: this._functionMin,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER,
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            "min_by": {
                _func: this._functionMinBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            type: {
                _func: this._functionType,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            keys: {
                _func: this._functionKeys,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            values: {
                _func: this._functionValues,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            sort: {
                _func: this._functionSort,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_STRING,
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            "sort_by": {
                _func: this._functionSortBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            join: {
                _func: this._functionJoin,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            reverse: {
                _func: this._functionReverse,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY
                        ]
                    }
                ]
            },
            "to_array": {
                _func: this._functionToArray,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "to_string": {
                _func: this._functionToString,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "to_number": {
                _func: this._functionToNumber,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "not_null": {
                _func: this._functionNotNull,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ],
                        variadic: true
                    }
                ]
            }
        };
    }
    Runtime.prototype = {
        callFunction: function(name, resolvedArgs) {
            var functionEntry = this.functionTable[name];
            if (functionEntry === undefined) throw new Error("Unknown function: " + name + "()");
            this._validateArgs(name, resolvedArgs, functionEntry._signature);
            return functionEntry._func.call(this, resolvedArgs);
        },
        _validateArgs: function(name, args, signature) {
            // Validating the args requires validating
            // the correct arity and the correct type of each arg.
            // If the last argument is declared as variadic, then we need
            // a minimum number of args to be required.  Otherwise it has to
            // be an exact amount.
            var pluralized;
            if (signature[signature.length - 1].variadic) {
                if (args.length < signature.length) {
                    pluralized = signature.length === 1 ? " argument" : " arguments";
                    throw new Error("ArgumentError: " + name + "() " + "takes at least" + signature.length + pluralized + " but received " + args.length);
                }
            } else if (args.length !== signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " + "takes " + signature.length + pluralized + " but received " + args.length);
            }
            var currentSpec;
            var actualType;
            var typeMatched;
            for(var i = 0; i < signature.length; i++){
                typeMatched = false;
                currentSpec = signature[i].types;
                actualType = this._getTypeName(args[i]);
                for(var j = 0; j < currentSpec.length; j++)if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
                if (!typeMatched) {
                    var expected = currentSpec.map(function(typeIdentifier) {
                        return TYPE_NAME_TABLE[typeIdentifier];
                    }).join(',');
                    throw new Error("TypeError: " + name + "() " + "expected argument " + (i + 1) + " to be type " + expected + " but received type " + TYPE_NAME_TABLE[actualType] + " instead.");
                }
            }
        },
        _typeMatches: function(actual, expected, argValue) {
            if (expected === TYPE_ANY) return true;
            if (expected === TYPE_ARRAY_STRING || expected === TYPE_ARRAY_NUMBER || expected === TYPE_ARRAY) {
                // The expected type can either just be array,
                // or it can require a specific subtype (array of numbers).
                //
                // The simplest case is if "array" with no subtype is specified.
                if (expected === TYPE_ARRAY) return actual === TYPE_ARRAY;
                else if (actual === TYPE_ARRAY) {
                    // Otherwise we need to check subtypes.
                    // I think this has potential to be improved.
                    var subtype;
                    if (expected === TYPE_ARRAY_NUMBER) subtype = TYPE_NUMBER;
                    else if (expected === TYPE_ARRAY_STRING) subtype = TYPE_STRING;
                    for(var i = 0; i < argValue.length; i++){
                        if (!this._typeMatches(this._getTypeName(argValue[i]), subtype, argValue[i])) return false;
                    }
                    return true;
                }
            } else return actual === expected;
        },
        _getTypeName: function(obj) {
            switch(Object.prototype.toString.call(obj)){
                case "[object String]":
                    return TYPE_STRING;
                case "[object Number]":
                    return TYPE_NUMBER;
                case "[object Array]":
                    return TYPE_ARRAY;
                case "[object Boolean]":
                    return TYPE_BOOLEAN;
                case "[object Null]":
                    return TYPE_NULL;
                case "[object Object]":
                    // Check if it's an expref.  If it has, it's been
                    // tagged with a jmespathType attr of 'Expref';
                    if (obj.jmespathType === TOK_EXPREF) return TYPE_EXPREF;
                    else return TYPE_OBJECT;
            }
        },
        _functionStartsWith: function(resolvedArgs) {
            return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
        },
        _functionEndsWith: function(resolvedArgs) {
            var searchStr = resolvedArgs[0];
            var suffix = resolvedArgs[1];
            return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
        },
        _functionReverse: function(resolvedArgs) {
            var typeName = this._getTypeName(resolvedArgs[0]);
            if (typeName === TYPE_STRING) {
                var originalStr = resolvedArgs[0];
                var reversedStr = "";
                for(var i = originalStr.length - 1; i >= 0; i--)reversedStr += originalStr[i];
                return reversedStr;
            } else {
                var reversedArray = resolvedArgs[0].slice(0);
                reversedArray.reverse();
                return reversedArray;
            }
        },
        _functionAbs: function(resolvedArgs) {
            return Math.abs(resolvedArgs[0]);
        },
        _functionCeil: function(resolvedArgs) {
            return Math.ceil(resolvedArgs[0]);
        },
        _functionAvg: function(resolvedArgs) {
            var sum = 0;
            var inputArray = resolvedArgs[0];
            for(var i = 0; i < inputArray.length; i++)sum += inputArray[i];
            return sum / inputArray.length;
        },
        _functionContains: function(resolvedArgs) {
            return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
        },
        _functionFloor: function(resolvedArgs) {
            return Math.floor(resolvedArgs[0]);
        },
        _functionLength: function(resolvedArgs) {
            if (!isObject(resolvedArgs[0])) return resolvedArgs[0].length;
            else // As far as I can tell, there's no way to get the length
            // of an object without O(n) iteration through the object.
            return Object.keys(resolvedArgs[0]).length;
        },
        _functionMap: function(resolvedArgs) {
            var mapped = [];
            var interpreter = this._interpreter;
            var exprefNode = resolvedArgs[0];
            var elements = resolvedArgs[1];
            for(var i = 0; i < elements.length; i++)mapped.push(interpreter.visit(exprefNode, elements[i]));
            return mapped;
        },
        _functionMerge: function(resolvedArgs) {
            var merged = {};
            for(var i = 0; i < resolvedArgs.length; i++){
                var current = resolvedArgs[i];
                for(var key in current)merged[key] = current[key];
            }
            return merged;
        },
        _functionMax: function(resolvedArgs) {
            if (resolvedArgs[0].length > 0) {
                var typeName = this._getTypeName(resolvedArgs[0][0]);
                if (typeName === TYPE_NUMBER) return Math.max.apply(Math, resolvedArgs[0]);
                else {
                    var elements = resolvedArgs[0];
                    var maxElement = elements[0];
                    for(var i = 1; i < elements.length; i++)if (maxElement.localeCompare(elements[i]) < 0) maxElement = elements[i];
                    return maxElement;
                }
            } else return null;
        },
        _functionMin: function(resolvedArgs) {
            if (resolvedArgs[0].length > 0) {
                var typeName = this._getTypeName(resolvedArgs[0][0]);
                if (typeName === TYPE_NUMBER) return Math.min.apply(Math, resolvedArgs[0]);
                else {
                    var elements = resolvedArgs[0];
                    var minElement = elements[0];
                    for(var i = 1; i < elements.length; i++)if (elements[i].localeCompare(minElement) < 0) minElement = elements[i];
                    return minElement;
                }
            } else return null;
        },
        _functionSum: function(resolvedArgs) {
            var sum = 0;
            var listToSum = resolvedArgs[0];
            for(var i = 0; i < listToSum.length; i++)sum += listToSum[i];
            return sum;
        },
        _functionType: function(resolvedArgs) {
            switch(this._getTypeName(resolvedArgs[0])){
                case TYPE_NUMBER:
                    return "number";
                case TYPE_STRING:
                    return "string";
                case TYPE_ARRAY:
                    return "array";
                case TYPE_OBJECT:
                    return "object";
                case TYPE_BOOLEAN:
                    return "boolean";
                case TYPE_EXPREF:
                    return "expref";
                case TYPE_NULL:
                    return "null";
            }
        },
        _functionKeys: function(resolvedArgs) {
            return Object.keys(resolvedArgs[0]);
        },
        _functionValues: function(resolvedArgs) {
            var obj = resolvedArgs[0];
            var keys = Object.keys(obj);
            var values = [];
            for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
            return values;
        },
        _functionJoin: function(resolvedArgs) {
            var joinChar = resolvedArgs[0];
            var listJoin = resolvedArgs[1];
            return listJoin.join(joinChar);
        },
        _functionToArray: function(resolvedArgs) {
            if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) return resolvedArgs[0];
            else return [
                resolvedArgs[0]
            ];
        },
        _functionToString: function(resolvedArgs) {
            if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) return resolvedArgs[0];
            else return JSON.stringify(resolvedArgs[0]);
        },
        _functionToNumber: function(resolvedArgs) {
            var typeName = this._getTypeName(resolvedArgs[0]);
            var convertedValue;
            if (typeName === TYPE_NUMBER) return resolvedArgs[0];
            else if (typeName === TYPE_STRING) {
                convertedValue = +resolvedArgs[0];
                if (!isNaN(convertedValue)) return convertedValue;
            }
            return null;
        },
        _functionNotNull: function(resolvedArgs) {
            for(var i = 0; i < resolvedArgs.length; i++){
                if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) return resolvedArgs[i];
            }
            return null;
        },
        _functionSort: function(resolvedArgs) {
            var sortedArray = resolvedArgs[0].slice(0);
            sortedArray.sort();
            return sortedArray;
        },
        _functionSortBy: function(resolvedArgs) {
            var sortedArray = resolvedArgs[0].slice(0);
            if (sortedArray.length === 0) return sortedArray;
            var interpreter = this._interpreter;
            var exprefNode = resolvedArgs[1];
            var requiredType = this._getTypeName(interpreter.visit(exprefNode, sortedArray[0]));
            if ([
                TYPE_NUMBER,
                TYPE_STRING
            ].indexOf(requiredType) < 0) throw new Error("TypeError");
            var that = this;
            // In order to get a stable sort out of an unstable
            // sort algorithm, we decorate/sort/undecorate (DSU)
            // by creating a new list of [index, element] pairs.
            // In the cmp function, if the evaluated elements are
            // equal, then the index will be used as the tiebreaker.
            // After the decorated list has been sorted, it will be
            // undecorated to extract the original elements.
            var decorated = [];
            for(var i = 0; i < sortedArray.length; i++)decorated.push([
                i,
                sortedArray[i]
            ]);
            decorated.sort(function(a, b) {
                var exprA = interpreter.visit(exprefNode, a[1]);
                var exprB = interpreter.visit(exprefNode, b[1]);
                if (that._getTypeName(exprA) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprA));
                else if (that._getTypeName(exprB) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprB));
                if (exprA > exprB) return 1;
                else if (exprA < exprB) return -1;
                else // If they're equal compare the items by their
                // order to maintain relative order of equal keys
                // (i.e. to get a stable sort).
                return a[0] - b[0];
            });
            // Undecorate: extract out the original list elements.
            for(var j = 0; j < decorated.length; j++)sortedArray[j] = decorated[j][1];
            return sortedArray;
        },
        _functionMaxBy: function(resolvedArgs) {
            var exprefNode = resolvedArgs[1];
            var resolvedArray = resolvedArgs[0];
            var keyFunction = this.createKeyFunction(exprefNode, [
                TYPE_NUMBER,
                TYPE_STRING
            ]);
            var maxNumber = -Infinity;
            var maxRecord;
            var current;
            for(var i = 0; i < resolvedArray.length; i++){
                current = keyFunction(resolvedArray[i]);
                if (current > maxNumber) {
                    maxNumber = current;
                    maxRecord = resolvedArray[i];
                }
            }
            return maxRecord;
        },
        _functionMinBy: function(resolvedArgs) {
            var exprefNode = resolvedArgs[1];
            var resolvedArray = resolvedArgs[0];
            var keyFunction = this.createKeyFunction(exprefNode, [
                TYPE_NUMBER,
                TYPE_STRING
            ]);
            var minNumber = Infinity;
            var minRecord;
            var current;
            for(var i = 0; i < resolvedArray.length; i++){
                current = keyFunction(resolvedArray[i]);
                if (current < minNumber) {
                    minNumber = current;
                    minRecord = resolvedArray[i];
                }
            }
            return minRecord;
        },
        createKeyFunction: function(exprefNode, allowedTypes) {
            var that = this;
            var interpreter = this._interpreter;
            var keyFunc = function(x) {
                var current = interpreter.visit(exprefNode, x);
                if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
                    var msg = "TypeError: expected one of " + allowedTypes + ", received " + that._getTypeName(current);
                    throw new Error(msg);
                }
                return current;
            };
            return keyFunc;
        }
    };
    function compile(stream) {
        var parser = new Parser();
        var ast = parser.parse(stream);
        return ast;
    }
    function tokenize(stream) {
        var lexer = new Lexer();
        return lexer.tokenize(stream);
    }
    function search(data, expression) {
        var parser = new Parser();
        // This needs to be improved.  Both the interpreter and runtime depend on
        // each other.  The runtime needs the interpreter to support exprefs.
        // There's likely a clean way to avoid the cyclic dependency.
        var runtime = new Runtime();
        var interpreter = new TreeInterpreter(runtime);
        runtime._interpreter = interpreter;
        var node = parser.parse(expression);
        return interpreter.search(node, data);
    }
    exports1.tokenize = tokenize;
    exports1.compile = compile;
    exports1.search = search;
    exports1.strictDeepEqual = strictDeepEqual;
})(module.exports);

});


parcelRegister("4wnK2", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $34ac91290701c6aa$var$inherit = $e2mZ5.util.inherit;

var $iGn9k = parcelRequire("iGn9k");
/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */ $e2mZ5.Response = $34ac91290701c6aa$var$inherit({
    /**
   * @api private
   */ constructor: function Response(request) {
        this.request = request;
        this.data = null;
        this.error = null;
        this.retryCount = 0;
        this.redirectCount = 0;
        this.httpResponse = new $e2mZ5.HttpResponse();
        if (request) {
            this.maxRetries = request.service.numRetries();
            this.maxRedirects = request.service.config.maxRedirects;
        }
    },
    /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */ nextPage: function nextPage(callback) {
        var config;
        var service = this.request.service;
        var operation = this.request.operation;
        try {
            config = service.paginationConfig(operation, true);
        } catch (e) {
            this.error = e;
        }
        if (!this.hasNextPage()) {
            if (callback) callback(this.error, null);
            else if (this.error) throw this.error;
            return null;
        }
        var params = $e2mZ5.util.copy(this.request.params);
        if (!this.nextPageTokens) return callback ? callback(null, null) : null;
        else {
            var inputTokens = config.inputToken;
            if (typeof inputTokens === 'string') inputTokens = [
                inputTokens
            ];
            for(var i = 0; i < inputTokens.length; i++)params[inputTokens[i]] = this.nextPageTokens[i];
            return service.makeRequest(this.request.operation, params, callback);
        }
    },
    /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */ hasNextPage: function hasNextPage() {
        this.cacheNextPageTokens();
        if (this.nextPageTokens) return true;
        if (this.nextPageTokens === undefined) return undefined;
        else return false;
    },
    /**
   * @api private
   */ cacheNextPageTokens: function cacheNextPageTokens() {
        if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
        this.nextPageTokens = undefined;
        var config = this.request.service.paginationConfig(this.request.operation);
        if (!config) return this.nextPageTokens;
        this.nextPageTokens = null;
        if (config.moreResults) {
            if (!$iGn9k.search(this.data, config.moreResults)) return this.nextPageTokens;
        }
        var exprs = config.outputToken;
        if (typeof exprs === 'string') exprs = [
            exprs
        ];
        $e2mZ5.util.arrayEach.call(this, exprs, function(expr) {
            var output = $iGn9k.search(this.data, expr);
            if (output) {
                this.nextPageTokens = this.nextPageTokens || [];
                this.nextPageTokens.push(output);
            }
        });
        return this.nextPageTokens;
    }
});

});

parcelRegister("izIGu", function(module, exports) {
/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */ 
var $e2mZ5 = parcelRequire("e2mZ5");
var $d85e2840d6c2bbe9$var$inherit = $e2mZ5.util.inherit;

var $iGn9k = parcelRequire("iGn9k");
/**
 * @api private
 */ function $d85e2840d6c2bbe9$var$CHECK_ACCEPTORS(resp) {
    var waiter = resp.request._waiter;
    var acceptors = waiter.config.acceptors;
    var acceptorMatched = false;
    var state = 'retry';
    acceptors.forEach(function(acceptor) {
        if (!acceptorMatched) {
            var matcher = waiter.matchers[acceptor.matcher];
            if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
                acceptorMatched = true;
                state = acceptor.state;
            }
        }
    });
    if (!acceptorMatched && resp.error) state = 'failure';
    if (state === 'success') waiter.setSuccess(resp);
    else waiter.setError(resp, state === 'retry');
}
/**
 * @api private
 */ $e2mZ5.ResourceWaiter = $d85e2840d6c2bbe9$var$inherit({
    /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */ constructor: function constructor(service, state) {
        this.service = service;
        this.state = state;
        this.loadWaiterConfig(this.state);
    },
    service: null,
    state: null,
    config: null,
    matchers: {
        path: function(resp, expected, argument) {
            try {
                var result = $iGn9k.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            return $iGn9k.strictDeepEqual(result, expected);
        },
        pathAll: function(resp, expected, argument) {
            try {
                var results = $iGn9k.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            if (!Array.isArray(results)) results = [
                results
            ];
            var numResults = results.length;
            if (!numResults) return false;
            for(var ind = 0; ind < numResults; ind++){
                if (!$iGn9k.strictDeepEqual(results[ind], expected)) return false;
            }
            return true;
        },
        pathAny: function(resp, expected, argument) {
            try {
                var results = $iGn9k.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            if (!Array.isArray(results)) results = [
                results
            ];
            var numResults = results.length;
            for(var ind = 0; ind < numResults; ind++){
                if ($iGn9k.strictDeepEqual(results[ind], expected)) return true;
            }
            return false;
        },
        status: function(resp, expected) {
            var statusCode = resp.httpResponse.statusCode;
            return typeof statusCode === 'number' && statusCode === expected;
        },
        error: function(resp, expected) {
            if (typeof expected === 'string' && resp.error) return expected === resp.error.code;
            // if expected is not string, can be boolean indicating presence of error
            return expected === !!resp.error;
        }
    },
    listeners: new $e2mZ5.SequentialExecutor().addNamedListeners(function(add) {
        add('RETRY_CHECK', 'retry', function(resp) {
            var waiter = resp.request._waiter;
            if (resp.error && resp.error.code === 'ResourceNotReady') resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
        });
        add('CHECK_OUTPUT', 'extractData', $d85e2840d6c2bbe9$var$CHECK_ACCEPTORS);
        add('CHECK_ERROR', 'extractError', $d85e2840d6c2bbe9$var$CHECK_ACCEPTORS);
    }),
    /**
   * @return [AWS.Request]
   */ wait: function wait(params, callback) {
        if (typeof params === 'function') {
            callback = params;
            params = undefined;
        }
        if (params && params.$waiter) {
            params = $e2mZ5.util.copy(params);
            if (typeof params.$waiter.delay === 'number') this.config.delay = params.$waiter.delay;
            if (typeof params.$waiter.maxAttempts === 'number') this.config.maxAttempts = params.$waiter.maxAttempts;
            delete params.$waiter;
        }
        var request = this.service.makeRequest(this.config.operation, params);
        request._waiter = this;
        request.response.maxRetries = this.config.maxAttempts;
        request.addListeners(this.listeners);
        if (callback) request.send(callback);
        return request;
    },
    setSuccess: function setSuccess(resp) {
        resp.error = null;
        resp.data = resp.data || {};
        resp.request.removeAllListeners('extractData');
    },
    setError: function setError(resp, retryable) {
        resp.data = null;
        resp.error = $e2mZ5.util.error(resp.error || new Error(), {
            code: 'ResourceNotReady',
            message: 'Resource is not in the state ' + this.state,
            retryable: retryable
        });
    },
    /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */ loadWaiterConfig: function loadWaiterConfig(state) {
        if (!this.service.api.waiters[state]) throw new $e2mZ5.util.error(new Error(), {
            code: 'StateNotFoundError',
            message: 'State ' + state + ' not found.'
        });
        this.config = $e2mZ5.util.copy(this.service.api.waiters[state]);
    }
});

});

parcelRegister("7XmUC", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $5cafd0f80a5d4b2c$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ $e2mZ5.Signers.RequestSigner = $5cafd0f80a5d4b2c$var$inherit({
    constructor: function RequestSigner(request) {
        this.request = request;
    },
    setServiceClientId: function setServiceClientId(id) {
        this.serviceClientId = id;
    },
    getServiceClientId: function getServiceClientId() {
        return this.serviceClientId;
    }
});
$e2mZ5.Signers.RequestSigner.getVersion = function getVersion(version) {
    switch(version){
        case 'v2':
            return $e2mZ5.Signers.V2;
        case 'v3':
            return $e2mZ5.Signers.V3;
        case 's3v4':
            return $e2mZ5.Signers.V4;
        case 'v4':
            return $e2mZ5.Signers.V4;
        case 's3':
            return $e2mZ5.Signers.S3;
        case 'v3https':
            return $e2mZ5.Signers.V3Https;
        case 'bearer':
            return $e2mZ5.Signers.Bearer;
    }
    throw new Error('Unknown signing version ' + version);
};
parcelRequire("8SPFp");
parcelRequire("9P6Mr");
parcelRequire("7cRED");
parcelRequire("fI2lb");
parcelRequire("b2fHC");
parcelRequire("4WGF1");
parcelRequire("70EG9");

});
parcelRegister("8SPFp", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $677b71d9cc3da95b$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ $e2mZ5.Signers.V2 = $677b71d9cc3da95b$var$inherit($e2mZ5.Signers.RequestSigner, {
    addAuthorization: function addAuthorization(credentials, date) {
        if (!date) date = $e2mZ5.util.date.getDate();
        var r = this.request;
        r.params.Timestamp = $e2mZ5.util.date.iso8601(date);
        r.params.SignatureVersion = '2';
        r.params.SignatureMethod = 'HmacSHA256';
        r.params.AWSAccessKeyId = credentials.accessKeyId;
        if (credentials.sessionToken) r.params.SecurityToken = credentials.sessionToken;
        delete r.params.Signature; // delete old Signature for re-signing
        r.params.Signature = this.signature(credentials);
        r.body = $e2mZ5.util.queryParamsToString(r.params);
        r.headers['Content-Length'] = r.body.length;
    },
    signature: function signature(credentials) {
        return $e2mZ5.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
    },
    stringToSign: function stringToSign() {
        var parts = [];
        parts.push(this.request.method);
        parts.push(this.request.endpoint.host.toLowerCase());
        parts.push(this.request.pathname());
        parts.push($e2mZ5.util.queryParamsToString(this.request.params));
        return parts.join('\n');
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.V2;

});

parcelRegister("9P6Mr", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $726e22e8f713b668$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ $e2mZ5.Signers.V3 = $726e22e8f713b668$var$inherit($e2mZ5.Signers.RequestSigner, {
    addAuthorization: function addAuthorization(credentials, date) {
        var datetime = $e2mZ5.util.date.rfc822(date);
        this.request.headers['X-Amz-Date'] = datetime;
        if (credentials.sessionToken) this.request.headers['x-amz-security-token'] = credentials.sessionToken;
        this.request.headers['X-Amzn-Authorization'] = this.authorization(credentials, datetime);
    },
    authorization: function authorization(credentials) {
        return "AWS3 AWSAccessKeyId=" + credentials.accessKeyId + ',' + 'Algorithm=HmacSHA256,' + 'SignedHeaders=' + this.signedHeaders() + ',' + 'Signature=' + this.signature(credentials);
    },
    signedHeaders: function signedHeaders() {
        var headers = [];
        $e2mZ5.util.arrayEach(this.headersToSign(), function iterator(h) {
            headers.push(h.toLowerCase());
        });
        return headers.sort().join(';');
    },
    canonicalHeaders: function canonicalHeaders() {
        var headers = this.request.headers;
        var parts = [];
        $e2mZ5.util.arrayEach(this.headersToSign(), function iterator(h) {
            parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
        });
        return parts.sort().join('\n') + '\n';
    },
    headersToSign: function headersToSign() {
        var headers = [];
        $e2mZ5.util.each(this.request.headers, function iterator(k) {
            if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) headers.push(k);
        });
        return headers;
    },
    signature: function signature(credentials) {
        return $e2mZ5.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
    },
    stringToSign: function stringToSign() {
        var parts = [];
        parts.push(this.request.method);
        parts.push('/');
        parts.push('');
        parts.push(this.canonicalHeaders());
        parts.push(this.request.body);
        return $e2mZ5.util.crypto.sha256(parts.join('\n'));
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.V3;

});

parcelRegister("7cRED", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $53f34604b4269153$var$inherit = $e2mZ5.util.inherit;
parcelRequire("9P6Mr");
/**
 * @api private
 */ $e2mZ5.Signers.V3Https = $53f34604b4269153$var$inherit($e2mZ5.Signers.V3, {
    authorization: function authorization(credentials) {
        return "AWS3-HTTPS AWSAccessKeyId=" + credentials.accessKeyId + ',' + 'Algorithm=HmacSHA256,' + 'Signature=' + this.signature(credentials);
    },
    stringToSign: function stringToSign() {
        return this.request.headers['X-Amz-Date'];
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.V3Https;

});

parcelRegister("fI2lb", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $1AZff = parcelRequire("1AZff");
var $b6fcc7e5a817583b$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ var $b6fcc7e5a817583b$var$expiresHeader = 'presigned-expires';
/**
 * @api private
 */ $e2mZ5.Signers.V4 = $b6fcc7e5a817583b$var$inherit($e2mZ5.Signers.RequestSigner, {
    constructor: function V4(request, serviceName, options) {
        $e2mZ5.Signers.RequestSigner.call(this, request);
        this.serviceName = serviceName;
        options = options || {};
        this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
        this.operation = options.operation;
        this.signatureVersion = options.signatureVersion;
    },
    algorithm: 'AWS4-HMAC-SHA256',
    addAuthorization: function addAuthorization(credentials, date) {
        var datetime = $e2mZ5.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');
        if (this.isPresigned()) this.updateForPresigned(credentials, datetime);
        else this.addHeaders(credentials, datetime);
        this.request.headers['Authorization'] = this.authorization(credentials, datetime);
    },
    addHeaders: function addHeaders(credentials, datetime) {
        this.request.headers['X-Amz-Date'] = datetime;
        if (credentials.sessionToken) this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    },
    updateForPresigned: function updateForPresigned(credentials, datetime) {
        var credString = this.credentialString(datetime);
        var qs = {
            'X-Amz-Date': datetime,
            'X-Amz-Algorithm': this.algorithm,
            'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
            'X-Amz-Expires': this.request.headers[$b6fcc7e5a817583b$var$expiresHeader],
            'X-Amz-SignedHeaders': this.signedHeaders()
        };
        if (credentials.sessionToken) qs['X-Amz-Security-Token'] = credentials.sessionToken;
        if (this.request.headers['Content-Type']) qs['Content-Type'] = this.request.headers['Content-Type'];
        if (this.request.headers['Content-MD5']) qs['Content-MD5'] = this.request.headers['Content-MD5'];
        if (this.request.headers['Cache-Control']) qs['Cache-Control'] = this.request.headers['Cache-Control'];
        // need to pull in any other X-Amz-* headers
        $e2mZ5.util.each.call(this, this.request.headers, function(key, value) {
            if (key === $b6fcc7e5a817583b$var$expiresHeader) return;
            if (this.isSignableHeader(key)) {
                var lowerKey = key.toLowerCase();
                // Metadata should be normalized
                if (lowerKey.indexOf('x-amz-meta-') === 0) qs[lowerKey] = value;
                else if (lowerKey.indexOf('x-amz-') === 0) qs[key] = value;
            }
        });
        var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
        this.request.path += sep + $e2mZ5.util.queryParamsToString(qs);
    },
    authorization: function authorization(credentials, datetime) {
        var parts = [];
        var credString = this.credentialString(datetime);
        parts.push(this.algorithm + ' Credential=' + credentials.accessKeyId + '/' + credString);
        parts.push('SignedHeaders=' + this.signedHeaders());
        parts.push('Signature=' + this.signature(credentials, datetime));
        return parts.join(', ');
    },
    signature: function signature(credentials, datetime) {
        var signingKey = $1AZff.getSigningKey(credentials, datetime.substr(0, 8), this.request.region, this.serviceName, this.signatureCache);
        return $e2mZ5.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
    },
    stringToSign: function stringToSign(datetime) {
        var parts = [];
        parts.push('AWS4-HMAC-SHA256');
        parts.push(datetime);
        parts.push(this.credentialString(datetime));
        parts.push(this.hexEncodedHash(this.canonicalString()));
        return parts.join('\n');
    },
    canonicalString: function canonicalString() {
        var parts = [], pathname = this.request.pathname();
        if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = $e2mZ5.util.uriEscapePath(pathname);
        parts.push(this.request.method);
        parts.push(pathname);
        parts.push(this.request.search());
        parts.push(this.canonicalHeaders() + '\n');
        parts.push(this.signedHeaders());
        parts.push(this.hexEncodedBodyHash());
        return parts.join('\n');
    },
    canonicalHeaders: function canonicalHeaders() {
        var headers = [];
        $e2mZ5.util.each.call(this, this.request.headers, function(key, item) {
            headers.push([
                key,
                item
            ]);
        });
        headers.sort(function(a, b) {
            return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
        });
        var parts = [];
        $e2mZ5.util.arrayEach.call(this, headers, function(item) {
            var key = item[0].toLowerCase();
            if (this.isSignableHeader(key)) {
                var value = item[1];
                if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') throw $e2mZ5.util.error(new Error('Header ' + key + ' contains invalid value'), {
                    code: 'InvalidHeader'
                });
                parts.push(key + ':' + this.canonicalHeaderValues(value.toString()));
            }
        });
        return parts.join('\n');
    },
    canonicalHeaderValues: function canonicalHeaderValues(values) {
        return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    },
    signedHeaders: function signedHeaders() {
        var keys = [];
        $e2mZ5.util.each.call(this, this.request.headers, function(key) {
            key = key.toLowerCase();
            if (this.isSignableHeader(key)) keys.push(key);
        });
        return keys.sort().join(';');
    },
    credentialString: function credentialString(datetime) {
        return $1AZff.createScope(datetime.substr(0, 8), this.request.region, this.serviceName);
    },
    hexEncodedHash: function hash(string) {
        return $e2mZ5.util.crypto.sha256(string, 'hex');
    },
    hexEncodedBodyHash: function hexEncodedBodyHash() {
        var request = this.request;
        if (this.isPresigned() && [
            's3',
            's3-object-lambda'
        ].indexOf(this.serviceName) > -1 && !request.body) return 'UNSIGNED-PAYLOAD';
        else if (request.headers['X-Amz-Content-Sha256']) return request.headers['X-Amz-Content-Sha256'];
        else return this.hexEncodedHash(this.request.body || '');
    },
    unsignableHeaders: [
        'authorization',
        'content-type',
        'content-length',
        'user-agent',
        $b6fcc7e5a817583b$var$expiresHeader,
        'expect',
        'x-amzn-trace-id'
    ],
    isSignableHeader: function isSignableHeader(key) {
        if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
        return this.unsignableHeaders.indexOf(key) < 0;
    },
    isPresigned: function isPresigned() {
        return this.request.headers[$b6fcc7e5a817583b$var$expiresHeader] ? true : false;
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.V4;

});
parcelRegister("1AZff", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 */ var $1298a92fef2457d1$var$cachedSecret = {};
/**
 * @api private
 */ var $1298a92fef2457d1$var$cacheQueue = [];
/**
 * @api private
 */ var $1298a92fef2457d1$var$maxCacheEntries = 50;
/**
 * @api private
 */ var $1298a92fef2457d1$var$v4Identifier = 'aws4_request';
/**
 * @api private
 */ module.exports = {
    /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */ createScope: function createScope(date, region, serviceName) {
        return [
            date.substr(0, 8),
            region,
            serviceName,
            $1298a92fef2457d1$var$v4Identifier
        ].join('/');
    },
    /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */ getSigningKey: function getSigningKey(credentials, date, region, service, shouldCache) {
        var credsIdentifier = $e2mZ5.util.crypto.hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
        var cacheKey = [
            credsIdentifier,
            date,
            region,
            service
        ].join('_');
        shouldCache = shouldCache !== false;
        if (shouldCache && cacheKey in $1298a92fef2457d1$var$cachedSecret) return $1298a92fef2457d1$var$cachedSecret[cacheKey];
        var kDate = $e2mZ5.util.crypto.hmac('AWS4' + credentials.secretAccessKey, date, 'buffer');
        var kRegion = $e2mZ5.util.crypto.hmac(kDate, region, 'buffer');
        var kService = $e2mZ5.util.crypto.hmac(kRegion, service, 'buffer');
        var signingKey = $e2mZ5.util.crypto.hmac(kService, $1298a92fef2457d1$var$v4Identifier, 'buffer');
        if (shouldCache) {
            $1298a92fef2457d1$var$cachedSecret[cacheKey] = signingKey;
            $1298a92fef2457d1$var$cacheQueue.push(cacheKey);
            if ($1298a92fef2457d1$var$cacheQueue.length > $1298a92fef2457d1$var$maxCacheEntries) // remove the oldest entry (not the least recently used)
            delete $1298a92fef2457d1$var$cachedSecret[$1298a92fef2457d1$var$cacheQueue.shift()];
        }
        return signingKey;
    },
    /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */ emptyCache: function emptyCache() {
        $1298a92fef2457d1$var$cachedSecret = {};
        $1298a92fef2457d1$var$cacheQueue = [];
    }
};

});


parcelRegister("b2fHC", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $808c0fd36f450add$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ $e2mZ5.Signers.S3 = $808c0fd36f450add$var$inherit($e2mZ5.Signers.RequestSigner, {
    /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */ subResources: {
        'acl': 1,
        'accelerate': 1,
        'analytics': 1,
        'cors': 1,
        'lifecycle': 1,
        'delete': 1,
        'inventory': 1,
        'location': 1,
        'logging': 1,
        'metrics': 1,
        'notification': 1,
        'partNumber': 1,
        'policy': 1,
        'requestPayment': 1,
        'replication': 1,
        'restore': 1,
        'tagging': 1,
        'torrent': 1,
        'uploadId': 1,
        'uploads': 1,
        'versionId': 1,
        'versioning': 1,
        'versions': 1,
        'website': 1
    },
    // when building the stringToSign, these querystring params should be
    // part of the canonical resource string with their NON-encoded values
    responseHeaders: {
        'response-content-type': 1,
        'response-content-language': 1,
        'response-expires': 1,
        'response-cache-control': 1,
        'response-content-disposition': 1,
        'response-content-encoding': 1
    },
    addAuthorization: function addAuthorization(credentials, date) {
        if (!this.request.headers['presigned-expires']) this.request.headers['X-Amz-Date'] = $e2mZ5.util.date.rfc822(date);
        if (credentials.sessionToken) // presigned URLs require this header to be lowercased
        this.request.headers['x-amz-security-token'] = credentials.sessionToken;
        var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
        var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;
        this.request.headers['Authorization'] = auth;
    },
    stringToSign: function stringToSign() {
        var r = this.request;
        var parts = [];
        parts.push(r.method);
        parts.push(r.headers['Content-MD5'] || '');
        parts.push(r.headers['Content-Type'] || '');
        // This is the "Date" header, but we use X-Amz-Date.
        // The S3 signing mechanism requires us to pass an empty
        // string for this Date header regardless.
        parts.push(r.headers['presigned-expires'] || '');
        var headers = this.canonicalizedAmzHeaders();
        if (headers) parts.push(headers);
        parts.push(this.canonicalizedResource());
        return parts.join('\n');
    },
    canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
        var amzHeaders = [];
        $e2mZ5.util.each(this.request.headers, function(name) {
            if (name.match(/^x-amz-/i)) amzHeaders.push(name);
        });
        amzHeaders.sort(function(a, b) {
            return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
        });
        var parts = [];
        $e2mZ5.util.arrayEach.call(this, amzHeaders, function(name) {
            parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
        });
        return parts.join('\n');
    },
    canonicalizedResource: function canonicalizedResource() {
        var r = this.request;
        var parts = r.path.split('?');
        var path = parts[0];
        var querystring = parts[1];
        var resource = '';
        if (r.virtualHostedBucket) resource += '/' + r.virtualHostedBucket;
        resource += path;
        if (querystring) {
            // collect a list of sub resources and query params that need to be signed
            var resources = [];
            $e2mZ5.util.arrayEach.call(this, querystring.split('&'), function(param) {
                var name = param.split('=')[0];
                var value = param.split('=')[1];
                if (this.subResources[name] || this.responseHeaders[name]) {
                    var subresource = {
                        name: name
                    };
                    if (value !== undefined) {
                        if (this.subResources[name]) subresource.value = value;
                        else subresource.value = decodeURIComponent(value);
                    }
                    resources.push(subresource);
                }
            });
            resources.sort(function(a, b) {
                return a.name < b.name ? -1 : 1;
            });
            if (resources.length) {
                querystring = [];
                $e2mZ5.util.arrayEach(resources, function(res) {
                    if (res.value === undefined) querystring.push(res.name);
                    else querystring.push(res.name + '=' + res.value);
                });
                resource += '?' + querystring.join('&');
            }
        }
        return resource;
    },
    sign: function sign(secret, string) {
        return $e2mZ5.util.crypto.hmac(secret, string, 'base64', 'sha1');
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.S3;

});

parcelRegister("4WGF1", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $399dabb71601fdb0$var$inherit = $e2mZ5.util.inherit;
/**
 * @api private
 */ var $399dabb71601fdb0$var$expiresHeader = 'presigned-expires';
/**
 * @api private
 */ function $399dabb71601fdb0$var$signedUrlBuilder(request) {
    var expires = request.httpRequest.headers[$399dabb71601fdb0$var$expiresHeader];
    var signerClass = request.service.getSignerClass(request);
    delete request.httpRequest.headers['User-Agent'];
    delete request.httpRequest.headers['X-Amz-User-Agent'];
    if (signerClass === $e2mZ5.Signers.V4) {
        if (expires > 604800) {
            var message = "Presigning does not support expiry time greater than a week with SigV4 signing.";
            throw $e2mZ5.util.error(new Error(), {
                code: 'InvalidExpiryTime',
                message: message,
                retryable: false
            });
        }
        request.httpRequest.headers[$399dabb71601fdb0$var$expiresHeader] = expires;
    } else if (signerClass === $e2mZ5.Signers.S3) {
        var now = request.service ? request.service.getSkewCorrectedDate() : $e2mZ5.util.date.getDate();
        request.httpRequest.headers[$399dabb71601fdb0$var$expiresHeader] = parseInt($e2mZ5.util.date.unixTimestamp(now) + expires, 10).toString();
    } else throw $e2mZ5.util.error(new Error(), {
        message: 'Presigning only supports S3 or SigV4 signing.',
        code: 'UnsupportedSigner',
        retryable: false
    });
}
/**
 * @api private
 */ function $399dabb71601fdb0$var$signedUrlSigner(request) {
    var endpoint = request.httpRequest.endpoint;
    var parsedUrl = $e2mZ5.util.urlParse(request.httpRequest.path);
    var queryParams = {};
    if (parsedUrl.search) queryParams = $e2mZ5.util.queryStringParse(parsedUrl.search.substr(1));
    var auth = request.httpRequest.headers['Authorization'].split(' ');
    if (auth[0] === 'AWS') {
        auth = auth[1].split(':');
        queryParams['Signature'] = auth.pop();
        queryParams['AWSAccessKeyId'] = auth.join(':');
        $e2mZ5.util.each(request.httpRequest.headers, function(key, value) {
            if (key === $399dabb71601fdb0$var$expiresHeader) key = 'Expires';
            if (key.indexOf('x-amz-meta-') === 0) {
                // Delete existing, potentially not normalized key
                delete queryParams[key];
                key = key.toLowerCase();
            }
            queryParams[key] = value;
        });
        delete request.httpRequest.headers[$399dabb71601fdb0$var$expiresHeader];
        delete queryParams['Authorization'];
        delete queryParams['Host'];
    } else if (auth[0] === 'AWS4-HMAC-SHA256') {
        auth.shift();
        var rest = auth.join(' ');
        var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
        queryParams['X-Amz-Signature'] = signature;
        delete queryParams['Expires'];
    }
    // build URL
    endpoint.pathname = parsedUrl.pathname;
    endpoint.search = $e2mZ5.util.queryParamsToString(queryParams);
}
/**
 * @api private
 */ $e2mZ5.Signers.Presign = $399dabb71601fdb0$var$inherit({
    /**
   * @api private
   */ sign: function sign(request, expireTime, callback) {
        request.httpRequest.headers[$399dabb71601fdb0$var$expiresHeader] = expireTime || 3600;
        request.on('build', $399dabb71601fdb0$var$signedUrlBuilder);
        request.on('sign', $399dabb71601fdb0$var$signedUrlSigner);
        request.removeListener('afterBuild', $e2mZ5.EventListeners.Core.SET_CONTENT_LENGTH);
        request.removeListener('afterBuild', $e2mZ5.EventListeners.Core.COMPUTE_SHA256);
        request.emit('beforePresign', [
            request
        ]);
        if (callback) request.build(function() {
            if (this.response.error) callback(this.response.error);
            else callback(null, $e2mZ5.util.urlFormat(request.httpRequest.endpoint));
        });
        else {
            request.build();
            if (request.response.error) throw request.response.error;
            return $e2mZ5.util.urlFormat(request.httpRequest.endpoint);
        }
    }
});
/**
 * @api private
 */ module.exports = $e2mZ5.Signers.Presign;

});

parcelRegister("70EG9", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 */ $e2mZ5.Signers.Bearer = $e2mZ5.util.inherit($e2mZ5.Signers.RequestSigner, {
    constructor: function Bearer(request) {
        $e2mZ5.Signers.RequestSigner.call(this, request);
    },
    addAuthorization: function addAuthorization(token) {
        this.request.headers['Authorization'] = 'Bearer ' + token.token;
    }
});

});


parcelRegister("lJJIP", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 */ $e2mZ5.ParamValidator = $e2mZ5.util.inherit({
    /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */ constructor: function ParamValidator(validation) {
        if (validation === true || validation === undefined) validation = {
            'min': true
        };
        this.validation = validation;
    },
    validate: function validate(shape, params, context) {
        this.errors = [];
        this.validateMember(shape, params || {}, context || 'params');
        if (this.errors.length > 1) {
            var msg = this.errors.join('\n* ');
            msg = 'There were ' + this.errors.length + ' validation errors:\n* ' + msg;
            throw $e2mZ5.util.error(new Error(msg), {
                code: 'MultipleValidationErrors',
                errors: this.errors
            });
        } else if (this.errors.length === 1) throw this.errors[0];
        else return true;
    },
    fail: function fail(code, message) {
        this.errors.push($e2mZ5.util.error(new Error(message), {
            code: code
        }));
    },
    validateStructure: function validateStructure(shape, params, context) {
        if (shape.isDocument) return true;
        this.validateType(params, context, [
            'object'
        ], 'structure');
        var paramName;
        for(var i = 0; shape.required && i < shape.required.length; i++){
            paramName = shape.required[i];
            var value = params[paramName];
            if (value === undefined || value === null) this.fail('MissingRequiredParameter', 'Missing required key \'' + paramName + '\' in ' + context);
        }
        // validate hash members
        for(paramName in params){
            if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
            var paramValue = params[paramName], memberShape = shape.members[paramName];
            if (memberShape !== undefined) {
                var memberContext = [
                    context,
                    paramName
                ].join('.');
                this.validateMember(memberShape, paramValue, memberContext);
            } else if (paramValue !== undefined && paramValue !== null) this.fail('UnexpectedParameter', 'Unexpected key \'' + paramName + '\' found in ' + context);
        }
        return true;
    },
    validateMember: function validateMember(shape, param, context) {
        switch(shape.type){
            case 'structure':
                return this.validateStructure(shape, param, context);
            case 'list':
                return this.validateList(shape, param, context);
            case 'map':
                return this.validateMap(shape, param, context);
            default:
                return this.validateScalar(shape, param, context);
        }
    },
    validateList: function validateList(shape, params, context) {
        if (this.validateType(params, context, [
            Array
        ])) {
            this.validateRange(shape, params.length, context, 'list member count');
            // validate array members
            for(var i = 0; i < params.length; i++)this.validateMember(shape.member, params[i], context + '[' + i + ']');
        }
    },
    validateMap: function validateMap(shape, params, context) {
        if (this.validateType(params, context, [
            'object'
        ], 'map')) {
            // Build up a count of map members to validate range traits.
            var mapCount = 0;
            for(var param in params){
                if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
                // Validate any map key trait constraints
                this.validateMember(shape.key, param, context + '[key=\'' + param + '\']');
                this.validateMember(shape.value, params[param], context + '[\'' + param + '\']');
                mapCount++;
            }
            this.validateRange(shape, mapCount, context, 'map member count');
        }
    },
    validateScalar: function validateScalar(shape, value, context) {
        switch(shape.type){
            case null:
            case undefined:
            case 'string':
                return this.validateString(shape, value, context);
            case 'base64':
            case 'binary':
                return this.validatePayload(value, context);
            case 'integer':
            case 'float':
                return this.validateNumber(shape, value, context);
            case 'boolean':
                return this.validateType(value, context, [
                    'boolean'
                ]);
            case 'timestamp':
                return this.validateType(value, context, [
                    Date,
                    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/,
                    'number'
                ], 'Date object, ISO-8601 string, or a UNIX timestamp');
            default:
                return this.fail('UnkownType', 'Unhandled type ' + shape.type + ' for ' + context);
        }
    },
    validateString: function validateString(shape, value, context) {
        var validTypes = [
            'string'
        ];
        if (shape.isJsonValue) validTypes = validTypes.concat([
            'number',
            'object',
            'boolean'
        ]);
        if (value !== null && this.validateType(value, context, validTypes)) {
            this.validateEnum(shape, value, context);
            this.validateRange(shape, value.length, context, 'string length');
            this.validatePattern(shape, value, context);
            this.validateUri(shape, value, context);
        }
    },
    validateUri: function validateUri(shape, value, context) {
        if (shape['location'] === 'uri') {
            if (value.length === 0) this.fail('UriParameterError', 'Expected uri parameter to have length >= 1, but found "' + value + '" for ' + context);
        }
    },
    validatePattern: function validatePattern(shape, value, context) {
        if (this.validation['pattern'] && shape['pattern'] !== undefined) {
            if (!new RegExp(shape['pattern']).test(value)) this.fail('PatternMatchError', 'Provided value "' + value + '" ' + 'does not match regex pattern /' + shape['pattern'] + '/ for ' + context);
        }
    },
    validateRange: function validateRange(shape, value, context, descriptor) {
        if (this.validation['min']) {
            if (shape['min'] !== undefined && value < shape['min']) this.fail('MinRangeError', 'Expected ' + descriptor + ' >= ' + shape['min'] + ', but found ' + value + ' for ' + context);
        }
        if (this.validation['max']) {
            if (shape['max'] !== undefined && value > shape['max']) this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= ' + shape['max'] + ', but found ' + value + ' for ' + context);
        }
    },
    validateEnum: function validateRange(shape, value, context) {
        if (this.validation['enum'] && shape['enum'] !== undefined) // Fail if the string value is not present in the enum list
        {
            if (shape['enum'].indexOf(value) === -1) this.fail('EnumError', 'Found string value of ' + value + ', but ' + 'expected ' + shape['enum'].join('|') + ' for ' + context);
        }
    },
    validateType: function validateType(value, context, acceptedTypes, type) {
        // We will not log an error for null or undefined, but we will return
        // false so that callers know that the expected type was not strictly met.
        if (value === null || value === undefined) return false;
        var foundInvalidType = false;
        for(var i = 0; i < acceptedTypes.length; i++){
            if (typeof acceptedTypes[i] === 'string') {
                if (typeof value === acceptedTypes[i]) return true;
            } else if (acceptedTypes[i] instanceof RegExp) {
                if ((value || '').toString().match(acceptedTypes[i])) return true;
            } else {
                if (value instanceof acceptedTypes[i]) return true;
                if ($e2mZ5.util.isType(value, acceptedTypes[i])) return true;
                if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
                acceptedTypes[i] = $e2mZ5.util.typeName(acceptedTypes[i]);
            }
            foundInvalidType = true;
        }
        var acceptedType = type;
        if (!acceptedType) acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
        var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
        this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' + vowel + ' ' + acceptedType);
        return false;
    },
    validateNumber: function validateNumber(shape, value, context) {
        if (value === null || value === undefined) return;
        if (typeof value === 'string') {
            var castedValue = parseFloat(value);
            if (castedValue.toString() === value) value = castedValue;
        }
        if (this.validateType(value, context, [
            'number'
        ])) this.validateRange(shape, value, context, 'numeric value');
    },
    validatePayload: function validatePayload(value, context) {
        if (value === null || value === undefined) return;
        if (typeof value === 'string') return;
        if (value && typeof value.byteLength === 'number') return; // typed arrays
        if ($e2mZ5.util.isNode()) {
            var Stream = $e2mZ5.util.stream.Stream;
            if ($e2mZ5.util.Buffer.isBuffer(value) || value instanceof Stream) return;
        } else {
            if (value instanceof Blob) return;
        }
        var types = [
            'Buffer',
            'Stream',
            'File',
            'Blob',
            'ArrayBuffer',
            'DataView'
        ];
        if (value) for(var i = 0; i < types.length; i++){
            if ($e2mZ5.util.isType(value, types[i])) return;
            if ($e2mZ5.util.typeName(value.constructor) === types[i]) return;
        }
        this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' + 'string, Buffer, Stream, Blob, or typed array object');
    }
});

});

parcelRegister("c97pA", function(module, exports) {
var $8d7c13200329c256$var$warning = [
    'The AWS SDK for JavaScript (v2) has reached end-of-support.',
    'It will no longer receive updates or releases.\n',
    'Please migrate your code to use AWS SDK for JavaScript (v3).',
    'For more information, check the blog post at https://a.co/cUPnyil'
].join('\n');
module.exports = {
    suppress: false
};
/**
 * To suppress this message:
 * @example
 * require('aws-sdk/lib/maintenance_mode_message').suppress = true;
 */ function $8d7c13200329c256$var$emitWarning() {
    return;
}
setTimeout(function() {
    if (!module.exports.suppress) $8d7c13200329c256$var$emitWarning();
}, 0);

});


parcelRegister("if7n2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d47f585df28229c0$export$2e2bcd8739ae039; });

var $bVPjg = parcelRequire("bVPjg");

var $37JCU = parcelRequire("37JCU");
function $d47f585df28229c0$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $bVPjg.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $37JCU.default)(rnds);
}
var $d47f585df28229c0$export$2e2bcd8739ae039 = $d47f585df28229c0$var$v4;

});
parcelRegister("bVPjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8afcd1a434d80579$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $8afcd1a434d80579$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var $8afcd1a434d80579$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $8afcd1a434d80579$export$2e2bcd8739ae039() {
    if (!$8afcd1a434d80579$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return $8afcd1a434d80579$var$getRandomValues($8afcd1a434d80579$var$rnds8);
}

});

parcelRegister("37JCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24656b04df9b39a9$export$2e2bcd8739ae039; });
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $24656b04df9b39a9$var$byteToHex = [];
for(var $24656b04df9b39a9$var$i = 0; $24656b04df9b39a9$var$i < 256; ++$24656b04df9b39a9$var$i)$24656b04df9b39a9$var$byteToHex[$24656b04df9b39a9$var$i] = ($24656b04df9b39a9$var$i + 0x100).toString(16).substr(1);
function $24656b04df9b39a9$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $24656b04df9b39a9$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
var $24656b04df9b39a9$export$2e2bcd8739ae039 = $24656b04df9b39a9$var$bytesToUuid;

});



parcelRegister("lc2WQ", function(module, exports) {

var $lvAZG = parcelRequire("lvAZG");

var $gID3H = parcelRequire("gID3H");

var $25bPt = parcelRequire("25bPt");

var $deh0b = parcelRequire("deh0b");
/**
 * @api private
 */ module.exports = exports = {
    createHash: function createHash(alg) {
        alg = alg.toLowerCase();
        if (alg === 'md5') return new $gID3H();
        else if (alg === 'sha256') return new $deh0b();
        else if (alg === 'sha1') return new $25bPt();
        throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createHmac: function createHmac(alg, key) {
        alg = alg.toLowerCase();
        if (alg === 'md5') return new $lvAZG($gID3H, key);
        else if (alg === 'sha256') return new $lvAZG($deh0b, key);
        else if (alg === 'sha1') return new $lvAZG($25bPt, key);
        throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createSign: function() {
        throw new Error('createSign is not implemented in the browser');
    }
};

});
parcelRegister("lvAZG", function(module, exports) {

var $6PPtJ = parcelRequire("6PPtJ");
/**
 * @api private
 */ function Hmac(hashCtor, secret) {
    this.hash = new hashCtor();
    this.outer = new hashCtor();
    var inner = bufferFromSecret(hashCtor, secret);
    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
    outer.set(inner);
    for(var i = 0; i < hashCtor.BLOCK_SIZE; i++){
        inner[i] ^= 0x36;
        outer[i] ^= 0x5c;
    }
    this.hash.update(inner);
    this.outer.update(outer);
    // Zero out the copied key buffer.
    for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
}
/**
 * @api private
 */ module.exports = exports = Hmac;
Hmac.prototype.update = function(toHash) {
    if ($6PPtJ.isEmptyData(toHash) || this.error) return this;
    try {
        this.hash.update($6PPtJ.convertToBuffer(toHash));
    } catch (e) {
        this.error = e;
    }
    return this;
};
Hmac.prototype.digest = function(encoding) {
    if (!this.outer.finished) this.outer.update(this.hash.digest());
    return this.outer.digest(encoding);
};
function bufferFromSecret(hashCtor, secret) {
    var input = $6PPtJ.convertToBuffer(secret);
    if (input.byteLength > hashCtor.BLOCK_SIZE) {
        var bufferHash = new hashCtor;
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("6PPtJ", function(module, exports) {

var $6ZYhl = parcelRequire("6ZYhl");
var $4f9f70144640251e$require$Buffer = $6ZYhl.Buffer;
/**
 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
 * e.g. missing in IE 10.
 *
 * @api private
 */ if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'undefined') ArrayBuffer.isView = function(arg) {
    return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
};
/**
 * @api private
 */ var viewStrings = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]',
    '[object DataView]'
];
/**
 * @api private
 */ function isEmptyData(data) {
    if (typeof data === 'string') return data.length === 0;
    return data.byteLength === 0;
}
/**
 * @api private
 */ function convertToBuffer(data) {
    if (typeof data === 'string') data = new $4f9f70144640251e$require$Buffer(data, 'utf8');
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
/**
 * @api private
 */ module.exports = exports = {
    isEmptyData: isEmptyData,
    convertToBuffer: convertToBuffer
};

});
parcelRegister("6ZYhl", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $518732b42d9a6513$export$a143d493d941bafc; }, function (v) { return $518732b42d9a6513$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $518732b42d9a6513$export$f99ded8fe4b79145; }, function (v) { return $518732b42d9a6513$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $518732b42d9a6513$export$a143d493d941bafc;
var $518732b42d9a6513$export$e4cf37d7f6fb9e0a;
var $518732b42d9a6513$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $518732b42d9a6513$export$599f31c3813fae4d;
'use strict';

var $9TmCM = parcelRequire("9TmCM");

var $kynfZ = parcelRequire("kynfZ");

var $gU3Ij = parcelRequire("gU3Ij");
$518732b42d9a6513$export$a143d493d941bafc = $518732b42d9a6513$var$Buffer;
$518732b42d9a6513$export$e4cf37d7f6fb9e0a = $518732b42d9a6513$var$SlowBuffer;
$518732b42d9a6513$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $518732b42d9a6513$var$typedArraySupport();
$518732b42d9a6513$export$599f31c3813fae4d = $518732b42d9a6513$var$kMaxLength();
function $518732b42d9a6513$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $518732b42d9a6513$var$kMaxLength() {
    return $518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $518732b42d9a6513$var$createBuffer(that, length) {
    if ($518732b42d9a6513$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $518732b42d9a6513$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $518732b42d9a6513$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $518732b42d9a6513$var$Buffer(arg, encodingOrOffset, length) {
    if (!$518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $518732b42d9a6513$var$Buffer)) return new $518732b42d9a6513$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $518732b42d9a6513$var$allocUnsafe(this, arg);
    }
    return $518732b42d9a6513$var$from(this, arg, encodingOrOffset, length);
}
$518732b42d9a6513$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$518732b42d9a6513$var$Buffer._augment = function(arr) {
    arr.__proto__ = $518732b42d9a6513$var$Buffer.prototype;
    return arr;
};
function $518732b42d9a6513$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $518732b42d9a6513$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $518732b42d9a6513$var$fromString(that, value, encodingOrOffset);
    return $518732b42d9a6513$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $518732b42d9a6513$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $518732b42d9a6513$var$from(null, value, encodingOrOffset, length);
};
if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $518732b42d9a6513$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $518732b42d9a6513$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $518732b42d9a6513$var$Buffer[Symbol.species] === $518732b42d9a6513$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($518732b42d9a6513$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $518732b42d9a6513$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $518732b42d9a6513$var$alloc(that, size, fill, encoding) {
    $518732b42d9a6513$var$assertSize(size);
    if (size <= 0) return $518732b42d9a6513$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $518732b42d9a6513$var$createBuffer(that, size).fill(fill, encoding) : $518732b42d9a6513$var$createBuffer(that, size).fill(fill);
    return $518732b42d9a6513$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $518732b42d9a6513$var$Buffer.alloc = function(size, fill, encoding) {
    return $518732b42d9a6513$var$alloc(null, size, fill, encoding);
};
function $518732b42d9a6513$var$allocUnsafe(that, size) {
    $518732b42d9a6513$var$assertSize(size);
    that = $518732b42d9a6513$var$createBuffer(that, size < 0 ? 0 : $518732b42d9a6513$var$checked(size) | 0);
    if (!$518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $518732b42d9a6513$var$Buffer.allocUnsafe = function(size) {
    return $518732b42d9a6513$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $518732b42d9a6513$var$Buffer.allocUnsafeSlow = function(size) {
    return $518732b42d9a6513$var$allocUnsafe(null, size);
};
function $518732b42d9a6513$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$518732b42d9a6513$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $518732b42d9a6513$var$byteLength(string, encoding) | 0;
    that = $518732b42d9a6513$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $518732b42d9a6513$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $518732b42d9a6513$var$checked(array.length) | 0;
    that = $518732b42d9a6513$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $518732b42d9a6513$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $518732b42d9a6513$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $518732b42d9a6513$var$fromArrayLike(that, array);
    return that;
}
function $518732b42d9a6513$var$fromObject(that, obj) {
    if ($518732b42d9a6513$var$Buffer.isBuffer(obj)) {
        var len = $518732b42d9a6513$var$checked(obj.length) | 0;
        that = $518732b42d9a6513$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $518732b42d9a6513$var$isnan(obj.length)) return $518732b42d9a6513$var$createBuffer(that, 0);
            return $518732b42d9a6513$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $gU3Ij(obj.data)) return $518732b42d9a6513$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $518732b42d9a6513$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $518732b42d9a6513$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $518732b42d9a6513$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $518732b42d9a6513$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $518732b42d9a6513$var$Buffer.alloc(+length);
}
$518732b42d9a6513$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$518732b42d9a6513$var$Buffer.compare = function compare(a, b) {
    if (!$518732b42d9a6513$var$Buffer.isBuffer(a) || !$518732b42d9a6513$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$518732b42d9a6513$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$518732b42d9a6513$var$Buffer.concat = function concat(list, length) {
    if (!$gU3Ij(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $518732b42d9a6513$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $518732b42d9a6513$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$518732b42d9a6513$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $518732b42d9a6513$var$byteLength(string, encoding) {
    if ($518732b42d9a6513$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $518732b42d9a6513$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $518732b42d9a6513$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $518732b42d9a6513$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$518732b42d9a6513$var$Buffer.byteLength = $518732b42d9a6513$var$byteLength;
function $518732b42d9a6513$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $518732b42d9a6513$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $518732b42d9a6513$var$utf8Slice(this, start, end);
        case 'ascii':
            return $518732b42d9a6513$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $518732b42d9a6513$var$latin1Slice(this, start, end);
        case 'base64':
            return $518732b42d9a6513$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $518732b42d9a6513$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$518732b42d9a6513$var$Buffer.prototype._isBuffer = true;
function $518732b42d9a6513$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$518732b42d9a6513$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$518732b42d9a6513$var$swap(this, i, i + 1);
    return this;
};
$518732b42d9a6513$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $518732b42d9a6513$var$swap(this, i, i + 3);
        $518732b42d9a6513$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$518732b42d9a6513$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $518732b42d9a6513$var$swap(this, i, i + 7);
        $518732b42d9a6513$var$swap(this, i + 1, i + 6);
        $518732b42d9a6513$var$swap(this, i + 2, i + 5);
        $518732b42d9a6513$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$518732b42d9a6513$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $518732b42d9a6513$var$utf8Slice(this, 0, length);
    return $518732b42d9a6513$var$slowToString.apply(this, arguments);
};
$518732b42d9a6513$var$Buffer.prototype.equals = function equals(b) {
    if (!$518732b42d9a6513$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $518732b42d9a6513$var$Buffer.compare(this, b) === 0;
};
$518732b42d9a6513$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $518732b42d9a6513$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$518732b42d9a6513$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$518732b42d9a6513$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $518732b42d9a6513$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $518732b42d9a6513$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($518732b42d9a6513$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $518732b42d9a6513$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $518732b42d9a6513$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $518732b42d9a6513$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$518732b42d9a6513$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$518732b42d9a6513$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $518732b42d9a6513$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$518732b42d9a6513$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $518732b42d9a6513$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $518732b42d9a6513$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $518732b42d9a6513$var$utf8Write(buf, string, offset, length) {
    return $518732b42d9a6513$var$blitBuffer($518732b42d9a6513$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $518732b42d9a6513$var$asciiWrite(buf, string, offset, length) {
    return $518732b42d9a6513$var$blitBuffer($518732b42d9a6513$var$asciiToBytes(string), buf, offset, length);
}
function $518732b42d9a6513$var$latin1Write(buf, string, offset, length) {
    return $518732b42d9a6513$var$asciiWrite(buf, string, offset, length);
}
function $518732b42d9a6513$var$base64Write(buf, string, offset, length) {
    return $518732b42d9a6513$var$blitBuffer($518732b42d9a6513$var$base64ToBytes(string), buf, offset, length);
}
function $518732b42d9a6513$var$ucs2Write(buf, string, offset, length) {
    return $518732b42d9a6513$var$blitBuffer($518732b42d9a6513$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$518732b42d9a6513$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $518732b42d9a6513$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $518732b42d9a6513$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $518732b42d9a6513$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $518732b42d9a6513$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $518732b42d9a6513$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $518732b42d9a6513$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$518732b42d9a6513$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $518732b42d9a6513$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9TmCM.fromByteArray(buf);
    else return $9TmCM.fromByteArray(buf.slice(start, end));
}
function $518732b42d9a6513$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $518732b42d9a6513$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $518732b42d9a6513$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $518732b42d9a6513$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $518732b42d9a6513$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $518732b42d9a6513$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $518732b42d9a6513$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $518732b42d9a6513$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $518732b42d9a6513$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $518732b42d9a6513$var$toHex(buf[i]);
    return out;
}
function $518732b42d9a6513$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$518732b42d9a6513$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $518732b42d9a6513$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $518732b42d9a6513$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $518732b42d9a6513$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$518732b42d9a6513$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$518732b42d9a6513$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$518732b42d9a6513$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$518732b42d9a6513$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$518732b42d9a6513$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$518732b42d9a6513$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$518732b42d9a6513$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$518732b42d9a6513$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$518732b42d9a6513$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$518732b42d9a6513$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$518732b42d9a6513$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$518732b42d9a6513$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$518732b42d9a6513$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$518732b42d9a6513$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$518732b42d9a6513$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return $kynfZ.read(this, offset, true, 23, 4);
};
$518732b42d9a6513$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 4, this.length);
    return $kynfZ.read(this, offset, false, 23, 4);
};
$518732b42d9a6513$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 8, this.length);
    return $kynfZ.read(this, offset, true, 52, 8);
};
$518732b42d9a6513$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkOffset(offset, 8, this.length);
    return $kynfZ.read(this, offset, false, 52, 8);
};
function $518732b42d9a6513$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$518732b42d9a6513$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$518732b42d9a6513$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $518732b42d9a6513$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$518732b42d9a6513$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $518732b42d9a6513$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$518732b42d9a6513$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $518732b42d9a6513$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$518732b42d9a6513$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $518732b42d9a6513$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$518732b42d9a6513$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $518732b42d9a6513$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $518732b42d9a6513$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$518732b42d9a6513$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $518732b42d9a6513$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$518732b42d9a6513$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $518732b42d9a6513$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$518732b42d9a6513$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $518732b42d9a6513$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$518732b42d9a6513$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $518732b42d9a6513$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$518732b42d9a6513$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$518732b42d9a6513$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $518732b42d9a6513$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$518732b42d9a6513$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $518732b42d9a6513$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$518732b42d9a6513$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $518732b42d9a6513$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$518732b42d9a6513$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $518732b42d9a6513$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $518732b42d9a6513$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $518732b42d9a6513$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $518732b42d9a6513$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kynfZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$518732b42d9a6513$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $518732b42d9a6513$var$writeFloat(this, value, offset, true, noAssert);
};
$518732b42d9a6513$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $518732b42d9a6513$var$writeFloat(this, value, offset, false, noAssert);
};
function $518732b42d9a6513$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $518732b42d9a6513$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kynfZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$518732b42d9a6513$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $518732b42d9a6513$var$writeDouble(this, value, offset, true, noAssert);
};
$518732b42d9a6513$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $518732b42d9a6513$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$518732b42d9a6513$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$518732b42d9a6513$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$518732b42d9a6513$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$518732b42d9a6513$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $518732b42d9a6513$var$Buffer.isBuffer(val) ? val : $518732b42d9a6513$var$utf8ToBytes(new $518732b42d9a6513$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $518732b42d9a6513$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $518732b42d9a6513$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $518732b42d9a6513$var$stringtrim(str).replace($518732b42d9a6513$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $518732b42d9a6513$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $518732b42d9a6513$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $518732b42d9a6513$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $518732b42d9a6513$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $518732b42d9a6513$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $518732b42d9a6513$var$base64ToBytes(str) {
    return $9TmCM.toByteArray($518732b42d9a6513$var$base64clean(str));
}
function $518732b42d9a6513$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $518732b42d9a6513$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("kynfZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $ef6905fb0ad75988$export$aafa59e2e03f2942; }, function (v) { return $ef6905fb0ad75988$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $ef6905fb0ad75988$export$68d8715fc104d294; }, function (v) { return $ef6905fb0ad75988$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ef6905fb0ad75988$export$aafa59e2e03f2942;
var $ef6905fb0ad75988$export$68d8715fc104d294;
$ef6905fb0ad75988$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ef6905fb0ad75988$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("gID3H", function(module, exports) {

var $6PPtJ = parcelRequire("6PPtJ");

var $6ZYhl = parcelRequire("6ZYhl");
var $c2bf0da173e0397b$require$Buffer = $6ZYhl.Buffer;
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];
/**
 * @api private
 */ function Md5() {
    this.state = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476
    ];
    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
    this.bufferLength = 0;
    this.bytesHashed = 0;
    this.finished = false;
}
/**
 * @api private
 */ module.exports = exports = Md5;
Md5.BLOCK_SIZE = BLOCK_SIZE;
Md5.prototype.update = function(sourceData) {
    if ($6PPtJ.isEmptyData(sourceData)) return this;
    else if (this.finished) throw new Error('Attempted to update an already finished hash.');
    var data = $6PPtJ.convertToBuffer(sourceData);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    while(byteLength > 0){
        this.buffer.setUint8(this.bufferLength++, data[position++]);
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }
    return this;
};
Md5.prototype.digest = function(encoding) {
    if (!this.finished) {
        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
        var bitsHashed = bytesHashed * 8;
        buffer.setUint8(this.bufferLength++, 128);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for(var i = this.bufferLength; i < BLOCK_SIZE; i++)buffer.setUint8(i, 0);
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for(var i = this.bufferLength; i < BLOCK_SIZE - 8; i++)buffer.setUint8(i, 0);
        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
        this.hashBuffer();
        this.finished = true;
    }
    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
    for(var i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
    var buff = new $c2bf0da173e0397b$require$Buffer(out.buffer, out.byteOffset, out.byteLength);
    return encoding ? buff.toString(encoding) : buff;
};
Md5.prototype.hashBuffer = function() {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var a = state[0], b = state[1], c = state[2], d = state[3];
    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
    state[0] = a + state[0] & 0xFFFFFFFF;
    state[1] = b + state[1] & 0xFFFFFFFF;
    state[2] = c + state[2] & 0xFFFFFFFF;
    state[3] = d + state[3] & 0xFFFFFFFF;
};
function cmn(q, a, b, x, s, t) {
    a = (a + q & 0xFFFFFFFF) + (x + t & 0xFFFFFFFF) & 0xFFFFFFFF;
    return (a << s | a >>> 32 - s) + b & 0xFFFFFFFF;
}
function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}

});

parcelRegister("25bPt", function(module, exports) {

var $6ZYhl = parcelRequire("6ZYhl");
var $18453970d00f0bf1$require$Buffer = $6ZYhl.Buffer;

var $6PPtJ = parcelRequire("6PPtJ");
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 20;
var KEY = new Uint32Array([
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
]);
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
/**
 * @api private
 */ function Sha1() {
    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;
    // The first 64 bytes (16 words) is the data chunk
    this.block = new Uint32Array(80);
    this.offset = 0;
    this.shift = 24;
    this.totalLength = 0;
}
/**
 * @api private
 */ module.exports = exports = Sha1;
Sha1.BLOCK_SIZE = BLOCK_SIZE;
Sha1.prototype.update = function(data) {
    if (this.finished) throw new Error('Attempted to update an already finished hash.');
    if ($6PPtJ.isEmptyData(data)) return this;
    data = $6PPtJ.convertToBuffer(data);
    var length = data.length;
    this.totalLength += length * 8;
    for(var i = 0; i < length; i++)this.write(data[i]);
    return this;
};
Sha1.prototype.write = function write(byte) {
    this.block[this.offset] |= (byte & 0xff) << this.shift;
    if (this.shift) this.shift -= 8;
    else {
        this.offset++;
        this.shift = 24;
    }
    if (this.offset === 16) this.processBlock();
};
Sha1.prototype.digest = function(encoding) {
    // Pad
    this.write(0x80);
    if (this.offset > 14 || this.offset === 14 && this.shift < 24) this.processBlock();
    this.offset = 14;
    this.shift = 24;
    // 64-bit length big-endian
    this.write(0x00); // numbers this big aren't accurate in javascript anyway
    this.write(0x00); // ..So just hard-code to zero.
    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
    for(var s = 24; s >= 0; s -= 8)this.write(this.totalLength >> s);
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new $18453970d00f0bf1$require$Buffer(DIGEST_LENGTH);
    var outView = new DataView(out.buffer);
    outView.setUint32(0, this.h0, false);
    outView.setUint32(4, this.h1, false);
    outView.setUint32(8, this.h2, false);
    outView.setUint32(12, this.h3, false);
    outView.setUint32(16, this.h4, false);
    return encoding ? out.toString(encoding) : out;
};
Sha1.prototype.processBlock = function processBlock() {
    // Extend the sixteen 32-bit words into eighty 32-bit words:
    for(var i = 16; i < 80; i++){
        var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
        this.block[i] = w << 1 | w >>> 31;
    }
    // Initialize hash value for this chunk:
    var a = this.h0;
    var b = this.h1;
    var c = this.h2;
    var d = this.h3;
    var e = this.h4;
    var f, k;
    // Main loop:
    for(i = 0; i < 80; i++){
        if (i < 20) {
            f = d ^ b & (c ^ d);
            k = 0x5A827999;
        } else if (i < 40) {
            f = b ^ c ^ d;
            k = 0x6ED9EBA1;
        } else if (i < 60) {
            f = b & c | d & (b | c);
            k = 0x8F1BBCDC;
        } else {
            f = b ^ c ^ d;
            k = 0xCA62C1D6;
        }
        var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i] | 0);
        e = d;
        d = c;
        c = b << 30 | b >>> 2;
        b = a;
        a = temp;
    }
    // Add this chunk's hash to result so far:
    this.h0 = this.h0 + a | 0;
    this.h1 = this.h1 + b | 0;
    this.h2 = this.h2 + c | 0;
    this.h3 = this.h3 + d | 0;
    this.h4 = this.h4 + e | 0;
    // The block is now reusable.
    this.offset = 0;
    for(i = 0; i < 16; i++)this.block[i] = 0;
};

});

parcelRegister("deh0b", function(module, exports) {

var $6ZYhl = parcelRequire("6ZYhl");
var $9a19c5639613a0ce$require$Buffer = $6ZYhl.Buffer;

var $6PPtJ = parcelRequire("6PPtJ");
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 32;
var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
/**
 * @private
 */ function Sha256() {
    this.state = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.temp = new Int32Array(64);
    this.buffer = new Uint8Array(64);
    this.bufferLength = 0;
    this.bytesHashed = 0;
    /**
     * @private
     */ this.finished = false;
}
/**
 * @api private
 */ module.exports = exports = Sha256;
Sha256.BLOCK_SIZE = BLOCK_SIZE;
Sha256.prototype.update = function(data) {
    if (this.finished) throw new Error('Attempted to update an already finished hash.');
    if ($6PPtJ.isEmptyData(data)) return this;
    data = $6PPtJ.convertToBuffer(data);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) throw new Error('Cannot hash more than 2^53 - 1 bits');
    while(byteLength > 0){
        this.buffer[this.bufferLength++] = data[position++];
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }
    return this;
};
Sha256.prototype.digest = function(encoding) {
    if (!this.finished) {
        var bitsHashed = this.bytesHashed * 8;
        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        var undecoratedLength = this.bufferLength;
        bufferView.setUint8(this.bufferLength++, 0x80);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for(var i = this.bufferLength; i < BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for(var i = this.bufferLength; i < BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
        this.hashBuffer();
        this.finished = true;
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new $9a19c5639613a0ce$require$Buffer(DIGEST_LENGTH);
    for(var i = 0; i < 8; i++){
        out[i * 4] = this.state[i] >>> 24 & 0xff;
        out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
        out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
        out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
    }
    return encoding ? out.toString(encoding) : out;
};
Sha256.prototype.hashBuffer = function() {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
    for(var i = 0; i < BLOCK_SIZE; i++){
        if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
        else {
            var u = this.temp[i - 2];
            var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = this.temp[i - 15];
            var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
        }
        var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (KEY[i] + this.temp[i] | 0) | 0) | 0;
        var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
        state7 = state6;
        state6 = state5;
        state5 = state4;
        state4 = state3 + t1 | 0;
        state3 = state2;
        state2 = state1;
        state1 = state0;
        state0 = t1 + t2 | 0;
    }
    state[0] += state0;
    state[1] += state1;
    state[2] += state2;
    state[3] += state3;
    state[4] += state4;
    state[5] += state5;
    state[6] += state6;
    state[7] += state7;
};

});


parcelRegister("dOLpM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4w7fO = parcelRequire("4w7fO");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $8TIGE = parcelRequire("8TIGE");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) {
            // IDNA Support: Returns a puny coded representation of "domain".
            // It only converts the part of the domain name that
            // has non ASCII characters. I.e. it dosent matter if
            // you call it with a domain that already is in ASCII.
            var domainArray = this.hostname.split('.');
            var newOut = [];
            for(var i = 0; i < domainArray.length; ++i){
                var s = domainArray[i];
                newOut.push(s.match(/[^A-Za-z0-9_-]/) ? 'xn--' + $4w7fO.encode(s) : s);
            }
            this.hostname = newOut.join('.');
        }
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $8TIGE.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && isObject(this.query) && Object.keys(this.query).length) query = $8TIGE.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    Object.keys(this).forEach(function(k) {
        result[k] = this[k];
    }, this);
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        Object.keys(relative).forEach(function(k) {
            if (k !== 'protocol') result[k] = relative[k];
        });
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            Object.keys(relative).forEach(function(k) {
                result[k] = relative[k];
            });
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especialy happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last == '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especialy happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
function isString(arg) {
    return typeof arg === "string";
}
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function isNull(arg) {
    return arg === null;
}
function isNullOrUndefined(arg) {
    return arg == null;
}

});
parcelRegister("4w7fO", function(module, exports) {
/*! https://mths.be/punycode v1.3.2 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("8TIGE", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $67a61fb3980457d6$export$98e6a39c04603d36; }, function (v) { return $67a61fb3980457d6$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $67a61fb3980457d6$export$fac44ee5b035f737; }, function (v) { return $67a61fb3980457d6$export$fac44ee5b035f737 = v; });
var $67a61fb3980457d6$export$2f872c0f2117be69;
var $67a61fb3980457d6$export$98e6a39c04603d36;
var $67a61fb3980457d6$export$c564cdbbe6da493;
var $67a61fb3980457d6$export$fac44ee5b035f737;
'use strict';

$67a61fb3980457d6$export$2f872c0f2117be69 = $67a61fb3980457d6$export$98e6a39c04603d36 = (parcelRequire("8mOse"));

$67a61fb3980457d6$export$c564cdbbe6da493 = $67a61fb3980457d6$export$fac44ee5b035f737 = (parcelRequire("c1dcb"));

});
parcelRegister("8mOse", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $61778400d2c0156e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$61778400d2c0156e$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($61778400d2c0156e$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $61778400d2c0156e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("c1dcb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $8bffd065b53f03ea$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $8bffd065b53f03ea$var$map($8bffd065b53f03ea$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($8bffd065b53f03ea$var$stringifyPrimitive(k)) + eq;
        if ($8bffd065b53f03ea$var$isArray(obj[k])) return $8bffd065b53f03ea$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($8bffd065b53f03ea$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($8bffd065b53f03ea$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($8bffd065b53f03ea$var$stringifyPrimitive(name)) + eq + encodeURIComponent($8bffd065b53f03ea$var$stringifyPrimitive(obj));
};
var $8bffd065b53f03ea$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $8bffd065b53f03ea$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $8bffd065b53f03ea$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("8FmBz", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $64f3aff075d61002$export$2f872c0f2117be69; }, function (v) { return $64f3aff075d61002$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "parse", function () { return $64f3aff075d61002$export$98e6a39c04603d36; }, function (v) { return $64f3aff075d61002$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "encode", function () { return $64f3aff075d61002$export$c564cdbbe6da493; }, function (v) { return $64f3aff075d61002$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "stringify", function () { return $64f3aff075d61002$export$fac44ee5b035f737; }, function (v) { return $64f3aff075d61002$export$fac44ee5b035f737 = v; });
var $64f3aff075d61002$export$2f872c0f2117be69;
var $64f3aff075d61002$export$98e6a39c04603d36;
var $64f3aff075d61002$export$c564cdbbe6da493;
var $64f3aff075d61002$export$fac44ee5b035f737;
'use strict';

$64f3aff075d61002$export$2f872c0f2117be69 = $64f3aff075d61002$export$98e6a39c04603d36 = (parcelRequire("16sGr"));

$64f3aff075d61002$export$c564cdbbe6da493 = $64f3aff075d61002$export$fac44ee5b035f737 = (parcelRequire("58gQY"));

});
parcelRegister("16sGr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $0cdc99eff10930ce$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$0cdc99eff10930ce$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if (Array.isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};

});

parcelRegister("58gQY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $3bcac5dde5d6ffb8$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return Object.keys(obj).map(function(k) {
        var ks = encodeURIComponent($3bcac5dde5d6ffb8$var$stringifyPrimitive(k)) + eq;
        if (Array.isArray(obj[k])) return obj[k].map(function(v) {
            return ks + encodeURIComponent($3bcac5dde5d6ffb8$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($3bcac5dde5d6ffb8$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($3bcac5dde5d6ffb8$var$stringifyPrimitive(name)) + eq + encodeURIComponent($3bcac5dde5d6ffb8$var$stringifyPrimitive(obj));
};

});


parcelRegister("9C5td", function(module, exports) {
module.exports = {
    //provide realtime clock for performance measurement
    now: function now() {
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
        return Date.now();
    }
};

});

parcelRegister("2sIAi", function(module, exports) {

var $55h2c = parcelRequire("55h2c");
var $1cb0c7d3a4759dc3$require$eventMessageChunker = $55h2c.eventMessageChunker;

var $MCP2f = parcelRequire("MCP2f");
var $1cb0c7d3a4759dc3$require$parseEvent = $MCP2f.parseEvent;
function $1cb0c7d3a4759dc3$var$createEventStream(body, parser, model) {
    var eventMessages = $1cb0c7d3a4759dc3$require$eventMessageChunker(body);
    var events = [];
    for(var i = 0; i < eventMessages.length; i++)events.push($1cb0c7d3a4759dc3$require$parseEvent(parser, eventMessages[i], model));
    return events;
}
/**
 * @api private
 */ module.exports = {
    createEventStream: $1cb0c7d3a4759dc3$var$createEventStream
};

});
parcelRegister("55h2c", function(module, exports) {
/**
 * Takes in a buffer of event messages and splits them into individual messages.
 * @param {Buffer} buffer
 * @api private
 */ function $3b3aa217412add14$var$eventMessageChunker(buffer) {
    /** @type Buffer[] */ var messages = [];
    var offset = 0;
    while(offset < buffer.length){
        var totalLength = buffer.readInt32BE(offset);
        // create new buffer for individual message (shares memory with original)
        var message = buffer.slice(offset, totalLength + offset);
        // increment offset to it starts at the next message
        offset += totalLength;
        messages.push(message);
    }
    return messages;
}
/**
 * @api private
 */ module.exports = {
    eventMessageChunker: $3b3aa217412add14$var$eventMessageChunker
};

});

parcelRegister("MCP2f", function(module, exports) {

var $2cRbp = parcelRequire("2cRbp");
var $0922991476c7d06c$require$parseMessage = $2cRbp.parseMessage;
/**
 *
 * @param {*} parser
 * @param {Buffer} message
 * @param {*} shape
 * @api private
 */ function $0922991476c7d06c$var$parseEvent(parser, message, shape) {
    var parsedMessage = $0922991476c7d06c$require$parseMessage(message);
    // check if message is an event or error
    var messageType = parsedMessage.headers[':message-type'];
    if (messageType) {
        if (messageType.value === 'error') throw $0922991476c7d06c$var$parseError(parsedMessage);
        else if (messageType.value !== 'event') // not sure how to parse non-events/non-errors, ignore for now
        return;
    }
    // determine event type
    var eventType = parsedMessage.headers[':event-type'];
    // check that the event type is modeled
    var eventModel = shape.members[eventType.value];
    if (!eventModel) return;
    var result = {};
    // check if an event payload exists
    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
    if (eventPayloadMemberName) {
        var payloadShape = eventModel.members[eventPayloadMemberName];
        // if the shape is binary, return the byte array
        if (payloadShape.type === 'binary') result[eventPayloadMemberName] = parsedMessage.body;
        else result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
    }
    // read event headers
    var eventHeaderNames = eventModel.eventHeaderMemberNames;
    for(var i = 0; i < eventHeaderNames.length; i++){
        var name = eventHeaderNames[i];
        if (parsedMessage.headers[name]) // parse the header!
        result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
    }
    var output = {};
    output[eventType.value] = result;
    return output;
}
function $0922991476c7d06c$var$parseError(message) {
    var errorCode = message.headers[':error-code'];
    var errorMessage = message.headers[':error-message'];
    var error = new Error(errorMessage.value || errorMessage);
    error.code = error.name = errorCode.value || errorCode;
    return error;
}
/**
 * @api private
 */ module.exports = {
    parseEvent: $0922991476c7d06c$var$parseEvent
};

});
parcelRegister("2cRbp", function(module, exports) {

var $eVzyB = parcelRequire("eVzyB");
var $19b5f4c79e639cf1$require$Int64 = $eVzyB.Int64;

var $jRp8c = parcelRequire("jRp8c");
var $19b5f4c79e639cf1$require$splitMessage = $jRp8c.splitMessage;
var $19b5f4c79e639cf1$var$BOOLEAN_TAG = 'boolean';
var $19b5f4c79e639cf1$var$BYTE_TAG = 'byte';
var $19b5f4c79e639cf1$var$SHORT_TAG = 'short';
var $19b5f4c79e639cf1$var$INT_TAG = 'integer';
var $19b5f4c79e639cf1$var$LONG_TAG = 'long';
var $19b5f4c79e639cf1$var$BINARY_TAG = 'binary';
var $19b5f4c79e639cf1$var$STRING_TAG = 'string';
var $19b5f4c79e639cf1$var$TIMESTAMP_TAG = 'timestamp';
var $19b5f4c79e639cf1$var$UUID_TAG = 'uuid';
/**
 * @api private
 *
 * @param {Buffer} headers
 */ function $19b5f4c79e639cf1$var$parseHeaders(headers) {
    var out = {};
    var position = 0;
    while(position < headers.length){
        var nameLength = headers.readUInt8(position++);
        var name = headers.slice(position, position + nameLength).toString();
        position += nameLength;
        switch(headers.readUInt8(position++)){
            case 0 /* boolTrue */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$BOOLEAN_TAG,
                    value: true
                };
                break;
            case 1 /* boolFalse */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$BOOLEAN_TAG,
                    value: false
                };
                break;
            case 2 /* byte */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$BYTE_TAG,
                    value: headers.readInt8(position++)
                };
                break;
            case 3 /* short */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$SHORT_TAG,
                    value: headers.readInt16BE(position)
                };
                position += 2;
                break;
            case 4 /* integer */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$INT_TAG,
                    value: headers.readInt32BE(position)
                };
                position += 4;
                break;
            case 5 /* long */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$LONG_TAG,
                    value: new $19b5f4c79e639cf1$require$Int64(headers.slice(position, position + 8))
                };
                position += 8;
                break;
            case 6 /* byteArray */ :
                var binaryLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: $19b5f4c79e639cf1$var$BINARY_TAG,
                    value: headers.slice(position, position + binaryLength)
                };
                position += binaryLength;
                break;
            case 7 /* string */ :
                var stringLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: $19b5f4c79e639cf1$var$STRING_TAG,
                    value: headers.slice(position, position + stringLength).toString()
                };
                position += stringLength;
                break;
            case 8 /* timestamp */ :
                out[name] = {
                    type: $19b5f4c79e639cf1$var$TIMESTAMP_TAG,
                    value: new Date(new $19b5f4c79e639cf1$require$Int64(headers.slice(position, position + 8)).valueOf())
                };
                position += 8;
                break;
            case 9 /* uuid */ :
                var uuidChars = headers.slice(position, position + 16).toString('hex');
                position += 16;
                out[name] = {
                    type: $19b5f4c79e639cf1$var$UUID_TAG,
                    value: uuidChars.substr(0, 8) + '-' + uuidChars.substr(8, 4) + '-' + uuidChars.substr(12, 4) + '-' + uuidChars.substr(16, 4) + '-' + uuidChars.substr(20)
                };
                break;
            default:
                throw new Error('Unrecognized header type tag');
        }
    }
    return out;
}
function $19b5f4c79e639cf1$var$parseMessage(message) {
    var parsed = $19b5f4c79e639cf1$require$splitMessage(message);
    return {
        headers: $19b5f4c79e639cf1$var$parseHeaders(parsed.headers),
        body: parsed.body
    };
}
/**
 * @api private
 */ module.exports = {
    parseMessage: $19b5f4c79e639cf1$var$parseMessage
};

});
parcelRegister("eVzyB", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $ade1f876be8bcd91$require$util = $e2mZ5.util;
var $ade1f876be8bcd91$var$toBuffer = $ade1f876be8bcd91$require$util.buffer.toBuffer;
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 * @param {Buffer} bytes
 *
 * @api private
 */ function $ade1f876be8bcd91$var$Int64(bytes) {
    if (bytes.length !== 8) throw new Error('Int64 buffers must be exactly 8 bytes');
    if (!$ade1f876be8bcd91$require$util.Buffer.isBuffer(bytes)) bytes = $ade1f876be8bcd91$var$toBuffer(bytes);
    this.bytes = bytes;
}
/**
 * @param {number} number
 * @returns {Int64}
 *
 * @api private
 */ $ade1f876be8bcd91$var$Int64.fromNumber = function(number) {
    if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + ' is too large (or, if negative, too small) to represent as an Int64');
    var bytes = new Uint8Array(8);
    for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
    if (number < 0) $ade1f876be8bcd91$var$negate(bytes);
    return new $ade1f876be8bcd91$var$Int64(bytes);
};
/**
 * @returns {number}
 *
 * @api private
 */ $ade1f876be8bcd91$var$Int64.prototype.valueOf = function() {
    var bytes = this.bytes.slice(0);
    var negative = bytes[0] & 128;
    if (negative) $ade1f876be8bcd91$var$negate(bytes);
    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
};
$ade1f876be8bcd91$var$Int64.prototype.toString = function() {
    return String(this.valueOf());
};
/**
 * @param {Buffer} bytes
 *
 * @api private
 */ function $ade1f876be8bcd91$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xFF;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}
/**
 * @api private
 */ module.exports = {
    Int64: $ade1f876be8bcd91$var$Int64
};

});

parcelRegister("jRp8c", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");
var $e756761e7ca1e8a1$require$util = $e2mZ5.util;
var $e756761e7ca1e8a1$var$toBuffer = $e756761e7ca1e8a1$require$util.buffer.toBuffer;
// All prelude components are unsigned, 32-bit integers
var $e756761e7ca1e8a1$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $e756761e7ca1e8a1$var$PRELUDE_LENGTH = $e756761e7ca1e8a1$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $e756761e7ca1e8a1$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $e756761e7ca1e8a1$var$MINIMUM_MESSAGE_LENGTH = $e756761e7ca1e8a1$var$PRELUDE_LENGTH + $e756761e7ca1e8a1$var$CHECKSUM_LENGTH * 2;
/**
 * @api private
 *
 * @param {Buffer} message
 */ function $e756761e7ca1e8a1$var$splitMessage(message) {
    if (!$e756761e7ca1e8a1$require$util.Buffer.isBuffer(message)) message = $e756761e7ca1e8a1$var$toBuffer(message);
    if (message.length < $e756761e7ca1e8a1$var$MINIMUM_MESSAGE_LENGTH) throw new Error('Provided message too short to accommodate event stream message overhead');
    if (message.length !== message.readUInt32BE(0)) throw new Error('Reported message length does not match received message length');
    var expectedPreludeChecksum = message.readUInt32BE($e756761e7ca1e8a1$var$PRELUDE_LENGTH);
    if (expectedPreludeChecksum !== $e756761e7ca1e8a1$require$util.crypto.crc32(message.slice(0, $e756761e7ca1e8a1$var$PRELUDE_LENGTH))) throw new Error('The prelude checksum specified in the message (' + expectedPreludeChecksum + ') does not match the calculated CRC32 checksum.');
    var expectedMessageChecksum = message.readUInt32BE(message.length - $e756761e7ca1e8a1$var$CHECKSUM_LENGTH);
    if (expectedMessageChecksum !== $e756761e7ca1e8a1$require$util.crypto.crc32(message.slice(0, message.length - $e756761e7ca1e8a1$var$CHECKSUM_LENGTH))) throw new Error('The message checksum did not match the expected value of ' + expectedMessageChecksum);
    var headersStart = $e756761e7ca1e8a1$var$PRELUDE_LENGTH + $e756761e7ca1e8a1$var$CHECKSUM_LENGTH;
    var headersEnd = headersStart + message.readUInt32BE($e756761e7ca1e8a1$var$PRELUDE_MEMBER_LENGTH);
    return {
        headers: message.slice(headersStart, headersEnd),
        body: message.slice(headersEnd, message.length - $e756761e7ca1e8a1$var$CHECKSUM_LENGTH)
    };
}
/**
 * @api private
 */ module.exports = {
    splitMessage: $e756761e7ca1e8a1$var$splitMessage
};

});




parcelRegister("4CIYd", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $eWi76 = parcelRequire("eWi76");
/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * @note AWS.TemporaryCredentials is deprecated, but remains available for
 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
 *   preferred class for temporary credentials.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */ $e2mZ5.TemporaryCredentials = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */ constructor: function TemporaryCredentials(params, masterCredentials) {
        $e2mZ5.Credentials.call(this);
        this.loadMasterCredentials(masterCredentials);
        this.expired = true;
        this.params = params || {};
        if (this.params.RoleArn) this.params.RoleSessionName = this.params.RoleSessionName || 'temporary-credentials';
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $e2mZ5.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.masterCredentials.get(function() {
            self.service.config.credentials = self.masterCredentials;
            var operation = self.params.RoleArn ? self.service.assumeRole : self.service.getSessionToken;
            operation.call(self.service, function(err, data) {
                if (!err) self.service.credentialsFrom(data, self);
                callback(err);
            });
        });
    },
    /**
   * @api private
   */ loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
        this.masterCredentials = masterCredentials || $e2mZ5.config.credentials;
        while(this.masterCredentials.masterCredentials)this.masterCredentials = this.masterCredentials.masterCredentials;
        if (typeof this.masterCredentials.get !== 'function') this.masterCredentials = new $e2mZ5.Credentials(this.masterCredentials);
    },
    /**
   * @api private
   */ createClients: function() {
        this.service = this.service || new $eWi76({
            params: this.params
        });
    }
});

});
parcelRegister("eWi76", function(module, exports) {
parcelRequire("kQcRm");

var $e2mZ5 = parcelRequire("e2mZ5");
var $ae0488733e2dd711$var$Service = $e2mZ5.Service;
var $ae0488733e2dd711$var$apiLoader = $e2mZ5.apiLoader;
$ae0488733e2dd711$var$apiLoader.services['sts'] = {};
$e2mZ5.STS = $ae0488733e2dd711$var$Service.defineService('sts', [
    '2011-06-15'
]);
parcelRequire("kD940");


Object.defineProperty($ae0488733e2dd711$var$apiLoader.services['sts'], '2011-06-15', {
    get: function get() {
        var model = (parcelRequire("jKK8R"));
        model.paginators = (parcelRequire("77PuM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $e2mZ5.STS;

});
parcelRegister("kD940", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $gTZHm = parcelRequire("gTZHm");
var $f04e7b06967adab0$var$ENV_REGIONAL_ENDPOINT_ENABLED = 'AWS_STS_REGIONAL_ENDPOINTS';
var $f04e7b06967adab0$var$CONFIG_REGIONAL_ENDPOINT_ENABLED = 'sts_regional_endpoints';
$e2mZ5.util.update($e2mZ5.STS.prototype, {
    /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */ credentialsFrom: function credentialsFrom(data, credentials) {
        if (!data) return null;
        if (!credentials) credentials = new $e2mZ5.TemporaryCredentials();
        credentials.expired = false;
        credentials.accessKeyId = data.Credentials.AccessKeyId;
        credentials.secretAccessKey = data.Credentials.SecretAccessKey;
        credentials.sessionToken = data.Credentials.SessionToken;
        credentials.expireTime = data.Credentials.Expiration;
        return credentials;
    },
    assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
        return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
    },
    assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
        return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
    },
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.addListener('validate', this.optInRegionalEndpoint, true);
    },
    /**
   * @api private
   */ optInRegionalEndpoint: function optInRegionalEndpoint(req) {
        var service = req.service;
        var config = service.config;
        config.stsRegionalEndpoints = $gTZHm(service._originalConfig, {
            env: $f04e7b06967adab0$var$ENV_REGIONAL_ENDPOINT_ENABLED,
            sharedConfig: $f04e7b06967adab0$var$CONFIG_REGIONAL_ENDPOINT_ENABLED,
            clientConfig: 'stsRegionalEndpoints'
        });
        if (config.stsRegionalEndpoints === 'regional' && service.isGlobalEndpoint) {
            //client will throw if region is not supplied; request will be signed with specified region
            if (!config.region) throw $e2mZ5.util.error(new Error(), {
                code: 'ConfigError',
                message: 'Missing region in config'
            });
            var insertPoint = config.endpoint.indexOf('.amazonaws.com');
            var regionalEndpoint = config.endpoint.substring(0, insertPoint) + '.' + config.region + config.endpoint.substring(insertPoint);
            req.httpRequest.updateEndpoint(regionalEndpoint);
            req.httpRequest.region = config.region;
        }
    }
});

});
parcelRegister("gTZHm", function(module, exports) {

var $89WEd = parcelRequire("89WEd");

var $e2mZ5 = parcelRequire("e2mZ5");
/**
 * @api private
 */ function $c4e1a46952c3c336$var$validateRegionalEndpointsFlagValue(configValue, errorOptions) {
    if (typeof configValue !== 'string') return undefined;
    else if ([
        'legacy',
        'regional'
    ].indexOf(configValue.toLowerCase()) >= 0) return configValue.toLowerCase();
    else throw $e2mZ5.util.error(new Error(), errorOptions);
}
/**
 * Resolve the configuration value for regional endpoint from difference sources: client
 * config, environmental variable, shared config file. Value can be case-insensitive
 * 'legacy' or 'reginal'.
 * @param originalConfig user-supplied config object to resolve
 * @param options a map of config property names from individual configuration source
 *  - env: name of environmental variable that refers to the config
 *  - sharedConfig: name of shared configuration file property that refers to the config
 *  - clientConfig: name of client configuration property that refers to the config
 *
 * @api private
 */ function $c4e1a46952c3c336$var$resolveRegionalEndpointsFlag(originalConfig, options) {
    originalConfig = originalConfig || {};
    //validate config value
    var resolved;
    if (originalConfig[options.clientConfig]) {
        resolved = $c4e1a46952c3c336$var$validateRegionalEndpointsFlagValue(originalConfig[options.clientConfig], {
            code: 'InvalidConfiguration',
            message: 'invalid "' + options.clientConfig + '" configuration. Expect "legacy" ' + ' or "regional". Got "' + originalConfig[options.clientConfig] + '".'
        });
        if (resolved) return resolved;
    }
    if (!$e2mZ5.util.isNode()) return resolved;
    //validate environmental variable
    if (Object.prototype.hasOwnProperty.call($89WEd.env, options.env)) {
        var envFlag = $89WEd.env[options.env];
        resolved = $c4e1a46952c3c336$var$validateRegionalEndpointsFlagValue(envFlag, {
            code: 'InvalidEnvironmentalVariable',
            message: 'invalid ' + options.env + ' environmental variable. Expect "legacy" ' + ' or "regional". Got "' + $89WEd.env[options.env] + '".'
        });
        if (resolved) return resolved;
    }
    //validate shared config file
    var profile = {};
    try {
        var profiles = $e2mZ5.util.getProfilesFromSharedConfig($e2mZ5.util.iniLoader);
        profile = profiles[$e2mZ5.util.defaultProfile];
    } catch (e) {}
    if (profile && Object.prototype.hasOwnProperty.call(profile, options.sharedConfig)) {
        var fileFlag = profile[options.sharedConfig];
        resolved = $c4e1a46952c3c336$var$validateRegionalEndpointsFlagValue(fileFlag, {
            code: 'InvalidConfiguration',
            message: 'invalid ' + options.sharedConfig + ' profile config. Expect "legacy" ' + ' or "regional". Got "' + profile[options.sharedConfig] + '".'
        });
        if (resolved) return resolved;
    }
    return resolved;
}
module.exports = $c4e1a46952c3c336$var$resolveRegionalEndpointsFlag;

});


parcelRegister("jKK8R", function(module, exports) {
module.exports = JSON.parse("{\"version\":\"2.0\",\"metadata\":{\"apiVersion\":\"2011-06-15\",\"endpointPrefix\":\"sts\",\"globalEndpoint\":\"sts.amazonaws.com\",\"protocol\":\"query\",\"serviceAbbreviation\":\"AWS STS\",\"serviceFullName\":\"AWS Security Token Service\",\"serviceId\":\"STS\",\"signatureVersion\":\"v4\",\"uid\":\"sts-2011-06-15\",\"xmlNamespace\":\"https://sts.amazonaws.com/doc/2011-06-15/\"},\"operations\":{\"AssumeRole\":{\"input\":{\"type\":\"structure\",\"required\":[\"RoleArn\",\"RoleSessionName\"],\"members\":{\"RoleArn\":{},\"RoleSessionName\":{},\"PolicyArns\":{\"shape\":\"S4\"},\"Policy\":{},\"DurationSeconds\":{\"type\":\"integer\"},\"Tags\":{\"shape\":\"S8\"},\"TransitiveTagKeys\":{\"type\":\"list\",\"member\":{}},\"ExternalId\":{},\"SerialNumber\":{},\"TokenCode\":{},\"SourceIdentity\":{},\"ProvidedContexts\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"members\":{\"ProviderArn\":{},\"ContextAssertion\":{}}}}}},\"output\":{\"resultWrapper\":\"AssumeRoleResult\",\"type\":\"structure\",\"members\":{\"Credentials\":{\"shape\":\"Sl\"},\"AssumedRoleUser\":{\"shape\":\"Sq\"},\"PackedPolicySize\":{\"type\":\"integer\"},\"SourceIdentity\":{}}}},\"AssumeRoleWithSAML\":{\"input\":{\"type\":\"structure\",\"required\":[\"RoleArn\",\"PrincipalArn\",\"SAMLAssertion\"],\"members\":{\"RoleArn\":{},\"PrincipalArn\":{},\"SAMLAssertion\":{\"type\":\"string\",\"sensitive\":true},\"PolicyArns\":{\"shape\":\"S4\"},\"Policy\":{},\"DurationSeconds\":{\"type\":\"integer\"}}},\"output\":{\"resultWrapper\":\"AssumeRoleWithSAMLResult\",\"type\":\"structure\",\"members\":{\"Credentials\":{\"shape\":\"Sl\"},\"AssumedRoleUser\":{\"shape\":\"Sq\"},\"PackedPolicySize\":{\"type\":\"integer\"},\"Subject\":{},\"SubjectType\":{},\"Issuer\":{},\"Audience\":{},\"NameQualifier\":{},\"SourceIdentity\":{}}}},\"AssumeRoleWithWebIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"RoleArn\",\"RoleSessionName\",\"WebIdentityToken\"],\"members\":{\"RoleArn\":{},\"RoleSessionName\":{},\"WebIdentityToken\":{\"type\":\"string\",\"sensitive\":true},\"ProviderId\":{},\"PolicyArns\":{\"shape\":\"S4\"},\"Policy\":{},\"DurationSeconds\":{\"type\":\"integer\"}}},\"output\":{\"resultWrapper\":\"AssumeRoleWithWebIdentityResult\",\"type\":\"structure\",\"members\":{\"Credentials\":{\"shape\":\"Sl\"},\"SubjectFromWebIdentityToken\":{},\"AssumedRoleUser\":{\"shape\":\"Sq\"},\"PackedPolicySize\":{\"type\":\"integer\"},\"Provider\":{},\"Audience\":{},\"SourceIdentity\":{}}}},\"DecodeAuthorizationMessage\":{\"input\":{\"type\":\"structure\",\"required\":[\"EncodedMessage\"],\"members\":{\"EncodedMessage\":{}}},\"output\":{\"resultWrapper\":\"DecodeAuthorizationMessageResult\",\"type\":\"structure\",\"members\":{\"DecodedMessage\":{}}}},\"GetAccessKeyInfo\":{\"input\":{\"type\":\"structure\",\"required\":[\"AccessKeyId\"],\"members\":{\"AccessKeyId\":{}}},\"output\":{\"resultWrapper\":\"GetAccessKeyInfoResult\",\"type\":\"structure\",\"members\":{\"Account\":{}}}},\"GetCallerIdentity\":{\"input\":{\"type\":\"structure\",\"members\":{}},\"output\":{\"resultWrapper\":\"GetCallerIdentityResult\",\"type\":\"structure\",\"members\":{\"UserId\":{},\"Account\":{},\"Arn\":{}}}},\"GetFederationToken\":{\"input\":{\"type\":\"structure\",\"required\":[\"Name\"],\"members\":{\"Name\":{},\"Policy\":{},\"PolicyArns\":{\"shape\":\"S4\"},\"DurationSeconds\":{\"type\":\"integer\"},\"Tags\":{\"shape\":\"S8\"}}},\"output\":{\"resultWrapper\":\"GetFederationTokenResult\",\"type\":\"structure\",\"members\":{\"Credentials\":{\"shape\":\"Sl\"},\"FederatedUser\":{\"type\":\"structure\",\"required\":[\"FederatedUserId\",\"Arn\"],\"members\":{\"FederatedUserId\":{},\"Arn\":{}}},\"PackedPolicySize\":{\"type\":\"integer\"}}}},\"GetSessionToken\":{\"input\":{\"type\":\"structure\",\"members\":{\"DurationSeconds\":{\"type\":\"integer\"},\"SerialNumber\":{},\"TokenCode\":{}}},\"output\":{\"resultWrapper\":\"GetSessionTokenResult\",\"type\":\"structure\",\"members\":{\"Credentials\":{\"shape\":\"Sl\"}}}}},\"shapes\":{\"S4\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"members\":{\"arn\":{}}}},\"S8\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"required\":[\"Key\",\"Value\"],\"members\":{\"Key\":{},\"Value\":{}}}},\"Sl\":{\"type\":\"structure\",\"required\":[\"AccessKeyId\",\"SecretAccessKey\",\"SessionToken\",\"Expiration\"],\"members\":{\"AccessKeyId\":{},\"SecretAccessKey\":{\"type\":\"string\",\"sensitive\":true},\"SessionToken\":{},\"Expiration\":{\"type\":\"timestamp\"}}},\"Sq\":{\"type\":\"structure\",\"required\":[\"AssumedRoleId\",\"Arn\"],\"members\":{\"AssumedRoleId\":{},\"Arn\":{}}}}}");

});

parcelRegister("77PuM", function(module, exports) {
module.exports = JSON.parse("{\"pagination\":{}}");

});



parcelRegister("kLiqy", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $eWi76 = parcelRequire("eWi76");
/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
 * the way masterCredentials and refreshes are handled.
 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
 * masterCredentials passed by the user to support chaining of STS credentials.
 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
 * during instantiation, precluding the ability to refresh credentials which
 * require intermediate, temporary credentials.
 *
 * For example, if the application should use RoleA, which must be assumed from
 * RoleB, and the environment provides credentials which can assume RoleB, then
 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
 * temporary credentials for RoleA:
 *
 * ```javascript
 * var roleACreds = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: 'RoleA'},
 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
 *     params: {RoleArn: 'RoleB'},
 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
 *   })
 * });
 * ```
 *
 * If AWS.TemporaryCredentials had been used in the previous example,
 * `roleACreds` would fail to refresh because `roleACreds` would
 * use the environment credentials for the AssumeRole request.
 *
 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
 * service instance during instantiation while AWS.TemporaryCredentials creates
 * the STS service instance during the first refresh. Creating the service
 * instance during instantiation effectively captures the master credentials
 * from the global config, so that subsequent changes to the global config do
 * not affect the master credentials used to refresh the temporary credentials.
 *
 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
 * to AWS.config.credentials:
 *
 * ```javascript
 * var envCreds = new AWS.EnvironmentCredentials('AWS');
 * AWS.config.credentials = envCreds;
 * // masterCredentials will be envCreds
 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * Similarly, to use the CredentialProviderChain's default providers as the
 * master credentials, simply create a new instance of
 * AWS.ChainableTemporaryCredentials:
 *
 * ```javascript
 * AWS.config.credentials = new ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * @!attribute service
 *   @return [AWS.STS] the STS service instance used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */ $e2mZ5.ChainableTemporaryCredentials = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * Creates a new temporary credentials object.
   *
   * @param options [map] a set of options
   * @option options params [map] ({}) a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
   *   also be passed in or an error will be thrown.
   * @option options masterCredentials [AWS.Credentials] the master credentials
   *   used to get and refresh temporary credentials from AWS STS. By default,
   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
   * @option options tokenCodeFn [Function] (null) Function to provide
   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
   *   is called with value of `SerialNumber` and `callback`, and should provide
   *   the `TokenCode` or an error to the callback in the format
   *   `callback(err, token)`.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
   *     params: {
   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
   *     }
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */ constructor: function ChainableTemporaryCredentials(options) {
        $e2mZ5.Credentials.call(this);
        options = options || {};
        this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
        this.expired = true;
        this.tokenCodeFn = null;
        var params = $e2mZ5.util.copy(options.params) || {};
        if (params.RoleArn) params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
        if (params.SerialNumber) {
            if (!options.tokenCodeFn || typeof options.tokenCodeFn !== 'function') throw new $e2mZ5.util.error(new Error('tokenCodeFn must be a function when params.SerialNumber is given'), {
                code: this.errorCode
            });
            else this.tokenCodeFn = options.tokenCodeFn;
        }
        var config = $e2mZ5.util.merge({
            params: params,
            credentials: options.masterCredentials || $e2mZ5.config.credentials
        }, options.stsConfig || {});
        this.service = new $eWi76(config);
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $e2mZ5.util.fn.callback);
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        var self = this;
        var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
        this.getTokenCode(function(err, tokenCode) {
            var params = {};
            if (err) {
                callback(err);
                return;
            }
            if (tokenCode) params.TokenCode = tokenCode;
            self.service[operation](params, function(err, data) {
                if (!err) self.service.credentialsFrom(data, self);
                callback(err);
            });
        });
    },
    /**
   * @api private
   */ getTokenCode: function getTokenCode(callback) {
        var self = this;
        if (this.tokenCodeFn) this.tokenCodeFn(this.service.config.params.SerialNumber, function(err, token) {
            if (err) {
                var message = err;
                if (err instanceof Error) message = err.message;
                callback($e2mZ5.util.error(new Error('Error fetching MFA token: ' + message), {
                    code: self.errorCode
                }));
                return;
            }
            callback(null, token);
        });
        else callback(null);
    }
});

});

parcelRegister("gbcJ3", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $eWi76 = parcelRequire("eWi76");
/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */ $e2mZ5.WebIdentityCredentials = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */ constructor: function WebIdentityCredentials(params, clientConfig) {
        $e2mZ5.Credentials.call(this);
        this.expired = true;
        this.params = params;
        this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
        this.data = null;
        this._clientConfig = $e2mZ5.util.copy(clientConfig || {});
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $e2mZ5.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.service.assumeRoleWithWebIdentity(function(err, data) {
            self.data = null;
            if (!err) {
                self.data = data;
                self.service.credentialsFrom(data, self);
            }
            callback(err);
        });
    },
    /**
   * @api private
   */ createClients: function() {
        if (!this.service) {
            var stsConfig = $e2mZ5.util.merge({}, this._clientConfig);
            stsConfig.params = this.params;
            this.service = new $eWi76(stsConfig);
        }
    }
});

});

parcelRegister("4p9td", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $5SYrP = parcelRequire("5SYrP");

var $eWi76 = parcelRequire("eWi76");
/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * DISCLAIMER: This convenience method leverages the Enhanced (simplified) Authflow. The underlying
 * implementation calls Cognito's `getId()` and `GetCredentialsForIdentity()`.
 * In this flow there is no way to explicitly set a session policy, resulting in
 * STS attaching the default policy and limiting the permissions of the federated role.
 * To be able to explicitly set a session policy, do not use this convenience method.
 * Instead, you can use the Cognito client to call `getId()`, `GetOpenIdToken()` and then use
 * that token with your desired session policy to call STS's `AssumeRoleWithWebIdentity()`
 * For further reading refer to: https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */ $e2mZ5.CognitoIdentityCredentials = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * @api private
   */ localStorageKey: {
        id: 'aws.cognito.identity-id.',
        providers: 'aws.cognito.identity-providers.'
    },
    /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */ constructor: function CognitoIdentityCredentials(params, clientConfig) {
        $e2mZ5.Credentials.call(this);
        this.expired = true;
        this.params = params;
        this.data = null;
        this._identityId = null;
        this._clientConfig = $e2mZ5.util.copy(clientConfig || {});
        this.loadCachedId();
        var self = this;
        Object.defineProperty(this, 'identityId', {
            get: function() {
                self.loadCachedId();
                return self._identityId || self.params.IdentityId;
            },
            set: function(identityId) {
                self._identityId = identityId;
            }
        });
    },
    /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $e2mZ5.util.fn.callback);
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.data = null;
        self._identityId = null;
        self.getId(function(err) {
            if (!err) {
                if (!self.params.RoleArn) self.getCredentialsForIdentity(callback);
                else self.getCredentialsFromSTS(callback);
            } else {
                self.clearIdOnNotAuthorized(err);
                callback(err);
            }
        });
    },
    /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */ clearCachedId: function clearCache() {
        this._identityId = null;
        delete this.params.IdentityId;
        var poolId = this.params.IdentityPoolId;
        var loginId = this.params.LoginId || '';
        delete this.storage[this.localStorageKey.id + poolId + loginId];
        delete this.storage[this.localStorageKey.providers + poolId + loginId];
    },
    /**
   * @api private
   */ clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
        var self = this;
        if (err.code == 'NotAuthorizedException') self.clearCachedId();
    },
    /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */ getId: function getId(callback) {
        var self = this;
        if (typeof self.params.IdentityId === 'string') return callback(null, self.params.IdentityId);
        self.cognito.getId(function(err, data) {
            if (!err && data.IdentityId) {
                self.params.IdentityId = data.IdentityId;
                callback(null, data.IdentityId);
            } else callback(err);
        });
    },
    /**
   * @api private
   */ loadCredentials: function loadCredentials(data, credentials) {
        if (!data || !credentials) return;
        credentials.expired = false;
        credentials.accessKeyId = data.Credentials.AccessKeyId;
        credentials.secretAccessKey = data.Credentials.SecretKey;
        credentials.sessionToken = data.Credentials.SessionToken;
        credentials.expireTime = data.Credentials.Expiration;
    },
    /**
   * @api private
   */ getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
        var self = this;
        self.cognito.getCredentialsForIdentity(function(err, data) {
            if (!err) {
                self.cacheId(data);
                self.data = data;
                self.loadCredentials(self.data, self);
            } else self.clearIdOnNotAuthorized(err);
            callback(err);
        });
    },
    /**
   * @api private
   */ getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
        var self = this;
        self.cognito.getOpenIdToken(function(err, data) {
            if (!err) {
                self.cacheId(data);
                self.params.WebIdentityToken = data.Token;
                self.webIdentityCredentials.refresh(function(webErr) {
                    if (!webErr) {
                        self.data = self.webIdentityCredentials.data;
                        self.sts.credentialsFrom(self.data, self);
                    }
                    callback(webErr);
                });
            } else {
                self.clearIdOnNotAuthorized(err);
                callback(err);
            }
        });
    },
    /**
   * @api private
   */ loadCachedId: function loadCachedId() {
        var self = this;
        // in the browser we source default IdentityId from localStorage
        if ($e2mZ5.util.isBrowser() && !self.params.IdentityId) {
            var id = self.getStorage('id');
            if (id && self.params.Logins) {
                var actualProviders = Object.keys(self.params.Logins);
                var cachedProviders = (self.getStorage('providers') || '').split(',');
                // only load ID if at least one provider used this ID before
                var intersect = cachedProviders.filter(function(n) {
                    return actualProviders.indexOf(n) !== -1;
                });
                if (intersect.length !== 0) self.params.IdentityId = id;
            } else if (id) self.params.IdentityId = id;
        }
    },
    /**
   * @api private
   */ createClients: function() {
        var clientConfig = this._clientConfig;
        this.webIdentityCredentials = this.webIdentityCredentials || new $e2mZ5.WebIdentityCredentials(this.params, clientConfig);
        if (!this.cognito) {
            var cognitoConfig = $e2mZ5.util.merge({}, clientConfig);
            cognitoConfig.params = this.params;
            this.cognito = new $5SYrP(cognitoConfig);
        }
        this.sts = this.sts || new $eWi76(clientConfig);
    },
    /**
   * @api private
   */ cacheId: function cacheId(data) {
        this._identityId = data.IdentityId;
        this.params.IdentityId = this._identityId;
        // cache this IdentityId in browser localStorage if possible
        if ($e2mZ5.util.isBrowser()) {
            this.setStorage('id', data.IdentityId);
            if (this.params.Logins) this.setStorage('providers', Object.keys(this.params.Logins).join(','));
        }
    },
    /**
   * @api private
   */ getStorage: function getStorage(key) {
        return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
    },
    /**
   * @api private
   */ setStorage: function setStorage(key, val) {
        try {
            this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
        } catch (_) {}
    },
    /**
   * @api private
   */ storage: function() {
        try {
            var storage = $e2mZ5.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ? window.localStorage : {};
            // Test set/remove which would throw an error in Safari's private browsing
            storage['aws.test-storage'] = 'foobar';
            delete storage['aws.test-storage'];
            return storage;
        } catch (_) {
            return {};
        }
    }()
});

});
parcelRegister("5SYrP", function(module, exports) {
parcelRequire("kQcRm");

var $e2mZ5 = parcelRequire("e2mZ5");
var $4490e298181ab4a2$var$Service = $e2mZ5.Service;
var $4490e298181ab4a2$var$apiLoader = $e2mZ5.apiLoader;
$4490e298181ab4a2$var$apiLoader.services['cognitoidentity'] = {};
$e2mZ5.CognitoIdentity = $4490e298181ab4a2$var$Service.defineService('cognitoidentity', [
    '2014-06-30'
]);


Object.defineProperty($4490e298181ab4a2$var$apiLoader.services['cognitoidentity'], '2014-06-30', {
    get: function get() {
        var model = (parcelRequire("4yryY"));
        model.paginators = (parcelRequire("51zwq")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $e2mZ5.CognitoIdentity;

});
parcelRegister("4yryY", function(module, exports) {
module.exports = JSON.parse("{\"version\":\"2.0\",\"metadata\":{\"apiVersion\":\"2014-06-30\",\"endpointPrefix\":\"cognito-identity\",\"jsonVersion\":\"1.1\",\"protocol\":\"json\",\"protocols\":[\"json\"],\"serviceFullName\":\"Amazon Cognito Identity\",\"serviceId\":\"Cognito Identity\",\"signatureVersion\":\"v4\",\"targetPrefix\":\"AWSCognitoIdentityService\",\"uid\":\"cognito-identity-2014-06-30\",\"auth\":[\"aws.auth#sigv4\"]},\"operations\":{\"CreateIdentityPool\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolName\",\"AllowUnauthenticatedIdentities\"],\"members\":{\"IdentityPoolName\":{},\"AllowUnauthenticatedIdentities\":{\"type\":\"boolean\"},\"AllowClassicFlow\":{\"type\":\"boolean\"},\"SupportedLoginProviders\":{\"shape\":\"S5\"},\"DeveloperProviderName\":{},\"OpenIdConnectProviderARNs\":{\"shape\":\"S9\"},\"CognitoIdentityProviders\":{\"shape\":\"Sb\"},\"SamlProviderARNs\":{\"shape\":\"Sg\"},\"IdentityPoolTags\":{\"shape\":\"Sh\"}}},\"output\":{\"shape\":\"Sk\"}},\"DeleteIdentities\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityIdsToDelete\"],\"members\":{\"IdentityIdsToDelete\":{\"type\":\"list\",\"member\":{}}}},\"output\":{\"type\":\"structure\",\"members\":{\"UnprocessedIdentityIds\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"ErrorCode\":{}}}}}}},\"DeleteIdentityPool\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\"],\"members\":{\"IdentityPoolId\":{}}}},\"DescribeIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityId\"],\"members\":{\"IdentityId\":{}}},\"output\":{\"shape\":\"Sv\"}},\"DescribeIdentityPool\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\"],\"members\":{\"IdentityPoolId\":{}}},\"output\":{\"shape\":\"Sk\"}},\"GetCredentialsForIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityId\"],\"members\":{\"IdentityId\":{},\"Logins\":{\"shape\":\"S10\"},\"CustomRoleArn\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"Credentials\":{\"type\":\"structure\",\"members\":{\"AccessKeyId\":{},\"SecretKey\":{},\"SessionToken\":{},\"Expiration\":{\"type\":\"timestamp\"}}}}},\"authtype\":\"none\",\"auth\":[\"smithy.api#noAuth\"]},\"GetId\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\"],\"members\":{\"AccountId\":{},\"IdentityPoolId\":{},\"Logins\":{\"shape\":\"S10\"}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{}}},\"authtype\":\"none\",\"auth\":[\"smithy.api#noAuth\"]},\"GetIdentityPoolRoles\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\"],\"members\":{\"IdentityPoolId\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityPoolId\":{},\"Roles\":{\"shape\":\"S1c\"},\"RoleMappings\":{\"shape\":\"S1e\"}}}},\"GetOpenIdToken\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityId\"],\"members\":{\"IdentityId\":{},\"Logins\":{\"shape\":\"S10\"}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"Token\":{}}},\"authtype\":\"none\",\"auth\":[\"smithy.api#noAuth\"]},\"GetOpenIdTokenForDeveloperIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"Logins\"],\"members\":{\"IdentityPoolId\":{},\"IdentityId\":{},\"Logins\":{\"shape\":\"S10\"},\"PrincipalTags\":{\"shape\":\"S1s\"},\"TokenDuration\":{\"type\":\"long\"}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"Token\":{}}}},\"GetPrincipalTagAttributeMap\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"IdentityProviderName\"],\"members\":{\"IdentityPoolId\":{},\"IdentityProviderName\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityPoolId\":{},\"IdentityProviderName\":{},\"UseDefaults\":{\"type\":\"boolean\"},\"PrincipalTags\":{\"shape\":\"S1s\"}}}},\"ListIdentities\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"MaxResults\"],\"members\":{\"IdentityPoolId\":{},\"MaxResults\":{\"type\":\"integer\"},\"NextToken\":{},\"HideDisabled\":{\"type\":\"boolean\"}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityPoolId\":{},\"Identities\":{\"type\":\"list\",\"member\":{\"shape\":\"Sv\"}},\"NextToken\":{}}}},\"ListIdentityPools\":{\"input\":{\"type\":\"structure\",\"required\":[\"MaxResults\"],\"members\":{\"MaxResults\":{\"type\":\"integer\"},\"NextToken\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityPools\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"members\":{\"IdentityPoolId\":{},\"IdentityPoolName\":{}}}},\"NextToken\":{}}}},\"ListTagsForResource\":{\"input\":{\"type\":\"structure\",\"required\":[\"ResourceArn\"],\"members\":{\"ResourceArn\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"Tags\":{\"shape\":\"Sh\"}}}},\"LookupDeveloperIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\"],\"members\":{\"IdentityPoolId\":{},\"IdentityId\":{},\"DeveloperUserIdentifier\":{},\"MaxResults\":{\"type\":\"integer\"},\"NextToken\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"DeveloperUserIdentifierList\":{\"type\":\"list\",\"member\":{}},\"NextToken\":{}}}},\"MergeDeveloperIdentities\":{\"input\":{\"type\":\"structure\",\"required\":[\"SourceUserIdentifier\",\"DestinationUserIdentifier\",\"DeveloperProviderName\",\"IdentityPoolId\"],\"members\":{\"SourceUserIdentifier\":{},\"DestinationUserIdentifier\":{},\"DeveloperProviderName\":{},\"IdentityPoolId\":{}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{}}}},\"SetIdentityPoolRoles\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"Roles\"],\"members\":{\"IdentityPoolId\":{},\"Roles\":{\"shape\":\"S1c\"},\"RoleMappings\":{\"shape\":\"S1e\"}}}},\"SetPrincipalTagAttributeMap\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"IdentityProviderName\"],\"members\":{\"IdentityPoolId\":{},\"IdentityProviderName\":{},\"UseDefaults\":{\"type\":\"boolean\"},\"PrincipalTags\":{\"shape\":\"S1s\"}}},\"output\":{\"type\":\"structure\",\"members\":{\"IdentityPoolId\":{},\"IdentityProviderName\":{},\"UseDefaults\":{\"type\":\"boolean\"},\"PrincipalTags\":{\"shape\":\"S1s\"}}}},\"TagResource\":{\"input\":{\"type\":\"structure\",\"required\":[\"ResourceArn\",\"Tags\"],\"members\":{\"ResourceArn\":{},\"Tags\":{\"shape\":\"Sh\"}}},\"output\":{\"type\":\"structure\",\"members\":{}}},\"UnlinkDeveloperIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityId\",\"IdentityPoolId\",\"DeveloperProviderName\",\"DeveloperUserIdentifier\"],\"members\":{\"IdentityId\":{},\"IdentityPoolId\":{},\"DeveloperProviderName\":{},\"DeveloperUserIdentifier\":{}}}},\"UnlinkIdentity\":{\"input\":{\"type\":\"structure\",\"required\":[\"IdentityId\",\"Logins\",\"LoginsToRemove\"],\"members\":{\"IdentityId\":{},\"Logins\":{\"shape\":\"S10\"},\"LoginsToRemove\":{\"shape\":\"Sw\"}}},\"authtype\":\"none\",\"auth\":[\"smithy.api#noAuth\"]},\"UntagResource\":{\"input\":{\"type\":\"structure\",\"required\":[\"ResourceArn\",\"TagKeys\"],\"members\":{\"ResourceArn\":{},\"TagKeys\":{\"type\":\"list\",\"member\":{}}}},\"output\":{\"type\":\"structure\",\"members\":{}}},\"UpdateIdentityPool\":{\"input\":{\"shape\":\"Sk\"},\"output\":{\"shape\":\"Sk\"}}},\"shapes\":{\"S5\":{\"type\":\"map\",\"key\":{},\"value\":{}},\"S9\":{\"type\":\"list\",\"member\":{}},\"Sb\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"members\":{\"ProviderName\":{},\"ClientId\":{},\"ServerSideTokenCheck\":{\"type\":\"boolean\"}}}},\"Sg\":{\"type\":\"list\",\"member\":{}},\"Sh\":{\"type\":\"map\",\"key\":{},\"value\":{}},\"Sk\":{\"type\":\"structure\",\"required\":[\"IdentityPoolId\",\"IdentityPoolName\",\"AllowUnauthenticatedIdentities\"],\"members\":{\"IdentityPoolId\":{},\"IdentityPoolName\":{},\"AllowUnauthenticatedIdentities\":{\"type\":\"boolean\"},\"AllowClassicFlow\":{\"type\":\"boolean\"},\"SupportedLoginProviders\":{\"shape\":\"S5\"},\"DeveloperProviderName\":{},\"OpenIdConnectProviderARNs\":{\"shape\":\"S9\"},\"CognitoIdentityProviders\":{\"shape\":\"Sb\"},\"SamlProviderARNs\":{\"shape\":\"Sg\"},\"IdentityPoolTags\":{\"shape\":\"Sh\"}}},\"Sv\":{\"type\":\"structure\",\"members\":{\"IdentityId\":{},\"Logins\":{\"shape\":\"Sw\"},\"CreationDate\":{\"type\":\"timestamp\"},\"LastModifiedDate\":{\"type\":\"timestamp\"}}},\"Sw\":{\"type\":\"list\",\"member\":{}},\"S10\":{\"type\":\"map\",\"key\":{},\"value\":{}},\"S1c\":{\"type\":\"map\",\"key\":{},\"value\":{}},\"S1e\":{\"type\":\"map\",\"key\":{},\"value\":{\"type\":\"structure\",\"required\":[\"Type\"],\"members\":{\"Type\":{},\"AmbiguousRoleResolution\":{},\"RulesConfiguration\":{\"type\":\"structure\",\"required\":[\"Rules\"],\"members\":{\"Rules\":{\"type\":\"list\",\"member\":{\"type\":\"structure\",\"required\":[\"Claim\",\"MatchType\",\"Value\",\"RoleARN\"],\"members\":{\"Claim\":{},\"MatchType\":{},\"Value\":{},\"RoleARN\":{}}}}}}}}},\"S1s\":{\"type\":\"map\",\"key\":{},\"value\":{}}}}");

});

parcelRegister("51zwq", function(module, exports) {
module.exports = JSON.parse("{\"pagination\":{\"ListIdentityPools\":{\"input_token\":\"NextToken\",\"limit_key\":\"MaxResults\",\"output_token\":\"NextToken\",\"result_key\":\"IdentityPools\"}}}");

});



parcelRegister("68isk", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $eWi76 = parcelRequire("eWi76");
/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */ $e2mZ5.SAMLCredentials = $e2mZ5.util.inherit($e2mZ5.Credentials, {
    /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */ constructor: function SAMLCredentials(params) {
        $e2mZ5.Credentials.call(this);
        this.expired = true;
        this.params = params;
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $e2mZ5.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.service.assumeRoleWithSAML(function(err, data) {
            if (!err) self.service.credentialsFrom(data, self);
            callback(err);
        });
    },
    /**
   * @api private
   */ createClients: function() {
        this.service = this.service || new $eWi76({
            params: this.params
        });
    }
});

});

parcelRegister("7sJwB", function(module, exports) {

var $1ymo4 = parcelRequire("1ymo4");

var $dYWAN = parcelRequire("dYWAN");
function $56ee7630cce501fd$var$DomXmlParser() {}
$56ee7630cce501fd$var$DomXmlParser.prototype.parse = function(xml, shape) {
    if (xml.replace(/^\s+/, '') === '') return {};
    var result, error;
    try {
        if (window.DOMParser) {
            try {
                var parser = new DOMParser();
                result = parser.parseFromString(xml, 'text/xml');
            } catch (syntaxError) {
                throw $1ymo4.error(new Error('Parse error in document'), {
                    originalError: syntaxError,
                    code: 'XMLParserError',
                    retryable: true
                });
            }
            if (result.documentElement === null) throw $1ymo4.error(new Error('Cannot parse empty document.'), {
                code: 'XMLParserError',
                retryable: true
            });
            var isError = result.getElementsByTagName('parsererror')[0];
            if (isError && (isError.parentNode === result || isError.parentNode.nodeName === 'body' || isError.parentNode.parentNode === result || isError.parentNode.parentNode.nodeName === 'body')) {
                var errorElement = isError.getElementsByTagName('div')[0] || isError;
                throw $1ymo4.error(new Error(errorElement.textContent || 'Parser error in document'), {
                    code: 'XMLParserError',
                    retryable: true
                });
            }
        } else if (window.ActiveXObject) {
            result = new window.ActiveXObject('Microsoft.XMLDOM');
            result.async = false;
            if (!result.loadXML(xml)) throw $1ymo4.error(new Error('Parse error in document'), {
                code: 'XMLParserError',
                retryable: true
            });
        } else throw new Error('Cannot load XML parser');
    } catch (e) {
        error = e;
    }
    if (result && result.documentElement && !error) {
        var data = $56ee7630cce501fd$var$parseXml(result.documentElement, shape);
        var metadata = $56ee7630cce501fd$var$getElementByTagName(result.documentElement, 'ResponseMetadata');
        if (metadata) data.ResponseMetadata = $56ee7630cce501fd$var$parseXml(metadata, {});
        return data;
    } else if (error) throw $1ymo4.error(error || new Error(), {
        code: 'XMLParserError',
        retryable: true
    });
    else return {};
};
function $56ee7630cce501fd$var$getElementByTagName(xml, tag) {
    var elements = xml.getElementsByTagName(tag);
    for(var i = 0, iLen = elements.length; i < iLen; i++){
        if (elements[i].parentNode === xml) return elements[i];
    }
}
function $56ee7630cce501fd$var$parseXml(xml, shape) {
    if (!shape) shape = {};
    switch(shape.type){
        case 'structure':
            return $56ee7630cce501fd$var$parseStructure(xml, shape);
        case 'map':
            return $56ee7630cce501fd$var$parseMap(xml, shape);
        case 'list':
            return $56ee7630cce501fd$var$parseList(xml, shape);
        case undefined:
        case null:
            return $56ee7630cce501fd$var$parseUnknown(xml);
        default:
            return $56ee7630cce501fd$var$parseScalar(xml, shape);
    }
}
function $56ee7630cce501fd$var$parseStructure(xml, shape) {
    var data = {};
    if (xml === null) return data;
    $1ymo4.each(shape.members, function(memberName, memberShape) {
        if (memberShape.isXmlAttribute) {
            if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
                var value = xml.attributes[memberShape.name].value;
                data[memberName] = $56ee7630cce501fd$var$parseXml({
                    textContent: value
                }, memberShape);
            }
        } else {
            var xmlChild = memberShape.flattened ? xml : $56ee7630cce501fd$var$getElementByTagName(xml, memberShape.name);
            if (xmlChild) data[memberName] = $56ee7630cce501fd$var$parseXml(xmlChild, memberShape);
            else if (!memberShape.flattened && memberShape.type === 'list' && !shape.api.xmlNoDefaultLists) data[memberName] = memberShape.defaultValue;
        }
    });
    return data;
}
function $56ee7630cce501fd$var$parseMap(xml, shape) {
    var data = {};
    var xmlKey = shape.key.name || 'key';
    var xmlValue = shape.value.name || 'value';
    var tagName = shape.flattened ? shape.name : 'entry';
    var child = xml.firstElementChild;
    while(child){
        if (child.nodeName === tagName) {
            var key = $56ee7630cce501fd$var$getElementByTagName(child, xmlKey).textContent;
            var value = $56ee7630cce501fd$var$getElementByTagName(child, xmlValue);
            data[key] = $56ee7630cce501fd$var$parseXml(value, shape.value);
        }
        child = child.nextElementSibling;
    }
    return data;
}
function $56ee7630cce501fd$var$parseList(xml, shape) {
    var data = [];
    var tagName = shape.flattened ? shape.name : shape.member.name || 'member';
    var child = xml.firstElementChild;
    while(child){
        if (child.nodeName === tagName) data.push($56ee7630cce501fd$var$parseXml(child, shape.member));
        child = child.nextElementSibling;
    }
    return data;
}
function $56ee7630cce501fd$var$parseScalar(xml, shape) {
    if (xml.getAttribute) {
        var encoding = xml.getAttribute('encoding');
        if (encoding === 'base64') shape = new $dYWAN.create({
            type: encoding
        });
    }
    var text = xml.textContent;
    if (text === '') text = null;
    if (typeof shape.toType === 'function') return shape.toType(text);
    else return text;
}
function $56ee7630cce501fd$var$parseUnknown(xml) {
    if (xml === undefined || xml === null) return '';
    // empty object
    if (!xml.firstElementChild) {
        if (xml.parentNode.parentNode === null) return {};
        if (xml.childNodes.length === 0) return '';
        else return xml.textContent;
    }
    // object, parse as structure
    var shape = {
        type: 'structure',
        members: {}
    };
    var child = xml.firstElementChild;
    while(child){
        var tag = child.nodeName;
        if (Object.prototype.hasOwnProperty.call(shape.members, tag)) // multiple tags of the same name makes it a list
        shape.members[tag].type = 'list';
        else shape.members[tag] = {
            name: tag
        };
        child = child.nextElementSibling;
    }
    return $56ee7630cce501fd$var$parseStructure(xml, shape);
}
/**
 * @api private
 */ module.exports = $56ee7630cce501fd$var$DomXmlParser;

});

parcelRegister("i0ZMX", function(module, exports) {

var $e2mZ5 = parcelRequire("e2mZ5");

var $aCOpQ = parcelRequire("aCOpQ");
var $d1d827fe1dd8d5b1$require$EventEmitter = $aCOpQ.EventEmitter;
parcelRequire("6UNOb");
/**
 * @api private
 */ $e2mZ5.XHRClient = $e2mZ5.util.inherit({
    handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
        var self = this;
        var endpoint = httpRequest.endpoint;
        var emitter = new $d1d827fe1dd8d5b1$require$EventEmitter();
        var href = endpoint.protocol + '//' + endpoint.hostname;
        if (endpoint.port !== 80 && endpoint.port !== 443) href += ':' + endpoint.port;
        href += httpRequest.path;
        var xhr = new XMLHttpRequest(), headersEmitted = false;
        httpRequest.stream = xhr;
        xhr.addEventListener('readystatechange', function() {
            try {
                if (xhr.status === 0) return; // 0 code is invalid
            } catch (e) {
                return;
            }
            if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
                emitter.statusCode = xhr.status;
                emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
                emitter.emit('headers', emitter.statusCode, emitter.headers, xhr.statusText);
                headersEmitted = true;
            }
            if (this.readyState === this.DONE) self.finishRequest(xhr, emitter);
        }, false);
        xhr.upload.addEventListener('progress', function(evt) {
            emitter.emit('sendProgress', evt);
        });
        xhr.addEventListener('progress', function(evt) {
            emitter.emit('receiveProgress', evt);
        }, false);
        xhr.addEventListener('timeout', function() {
            errCallback($e2mZ5.util.error(new Error('Timeout'), {
                code: 'TimeoutError'
            }));
        }, false);
        xhr.addEventListener('error', function() {
            errCallback($e2mZ5.util.error(new Error('Network Failure'), {
                code: 'NetworkingError'
            }));
        }, false);
        xhr.addEventListener('abort', function() {
            errCallback($e2mZ5.util.error(new Error('Request aborted'), {
                code: 'RequestAbortedError'
            }));
        }, false);
        callback(emitter);
        xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
        $e2mZ5.util.each(httpRequest.headers, function(key, value) {
            if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') xhr.setRequestHeader(key, value);
        });
        if (httpOptions.timeout && httpOptions.xhrAsync !== false) xhr.timeout = httpOptions.timeout;
        if (httpOptions.xhrWithCredentials) xhr.withCredentials = true;
        try {
            xhr.responseType = 'arraybuffer';
        } catch (e) {}
        try {
            if (httpRequest.body) xhr.send(httpRequest.body);
            else xhr.send();
        } catch (err) {
            if (httpRequest.body && typeof httpRequest.body.buffer === 'object') xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
            else throw err;
        }
        return emitter;
    },
    parseHeaders: function parseHeaders(rawHeaders) {
        var headers = {};
        $e2mZ5.util.arrayEach(rawHeaders.split(/\r?\n/), function(line) {
            var key = line.split(':', 1)[0];
            var value = line.substring(key.length + 2);
            if (key.length > 0) headers[key.toLowerCase()] = value;
        });
        return headers;
    },
    finishRequest: function finishRequest(xhr, emitter) {
        var buffer;
        if (xhr.responseType === 'arraybuffer' && xhr.response) {
            var ab = xhr.response;
            buffer = new $e2mZ5.util.Buffer(ab.byteLength);
            var view = new Uint8Array(ab);
            for(var i = 0; i < buffer.length; ++i)buffer[i] = view[i];
        }
        try {
            if (!buffer && typeof xhr.responseText === 'string') buffer = new $e2mZ5.util.Buffer(xhr.responseText);
        } catch (e) {}
        if (buffer) emitter.emit('data', buffer);
        emitter.emit('end');
    }
});
/**
 * @api private
 */ $e2mZ5.HttpClient.prototype = $e2mZ5.XHRClient.prototype;
/**
 * @api private
 */ $e2mZ5.HttpClient.streamsApiVersion = 1;

});
parcelRegister("aCOpQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $7bc48f826226c162$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $7bc48f826226c162$var$EventEmitter;
// Backwards-compat with node 0.10.x
$7bc48f826226c162$var$EventEmitter.EventEmitter = $7bc48f826226c162$var$EventEmitter;
$7bc48f826226c162$var$EventEmitter.prototype._events = undefined;
$7bc48f826226c162$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$7bc48f826226c162$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$7bc48f826226c162$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$7bc48f826226c162$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$7bc48f826226c162$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $7bc48f826226c162$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($7bc48f826226c162$var$isUndefined(handler)) return false;
    if ($7bc48f826226c162$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($7bc48f826226c162$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$7bc48f826226c162$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$7bc48f826226c162$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $7bc48f826226c162$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($7bc48f826226c162$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($7bc48f826226c162$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$7bc48f826226c162$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $7bc48f826226c162$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$7bc48f826226c162$var$EventEmitter.prototype.on = $7bc48f826226c162$var$EventEmitter.prototype.addListener;
$7bc48f826226c162$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$7bc48f826226c162$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$7bc48f826226c162$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$7bc48f826226c162$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $7bc48f826226c162$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($7bc48f826226c162$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$7bc48f826226c162$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($7bc48f826226c162$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$7bc48f826226c162$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($7bc48f826226c162$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$7bc48f826226c162$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($7bc48f826226c162$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$7bc48f826226c162$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $7bc48f826226c162$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $7bc48f826226c162$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $7bc48f826226c162$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $7bc48f826226c162$var$isUndefined(arg) {
    return arg === void 0;
}

});





parcelRegister("5VL3l", function(module, exports) {
/* global window */ 
var $4ORea = parcelRequire("4ORea");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $4ORea.default)(root);
var $4516c65f220f7443$export$2e2bcd8739ae039 = result;

});
parcelRegister("4ORea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38251ed0f78a1907$export$2e2bcd8739ae039; });
function $38251ed0f78a1907$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("lvH3K", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("4Y9KI"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("4Y9KI", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("7Hpfc"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("7Hpfc", function(module, exports) {
/**
 * Helpers.
 */ var $59b0218440ff91b6$var$s = 1000;
var $59b0218440ff91b6$var$m = $59b0218440ff91b6$var$s * 60;
var $59b0218440ff91b6$var$h = $59b0218440ff91b6$var$m * 60;
var $59b0218440ff91b6$var$d = $59b0218440ff91b6$var$h * 24;
var $59b0218440ff91b6$var$y = $59b0218440ff91b6$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $59b0218440ff91b6$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $59b0218440ff91b6$var$fmtLong(val) : $59b0218440ff91b6$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $59b0218440ff91b6$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $59b0218440ff91b6$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $59b0218440ff91b6$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $59b0218440ff91b6$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $59b0218440ff91b6$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $59b0218440ff91b6$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $59b0218440ff91b6$var$fmtShort(ms) {
    if (ms >= $59b0218440ff91b6$var$d) return Math.round(ms / $59b0218440ff91b6$var$d) + 'd';
    if (ms >= $59b0218440ff91b6$var$h) return Math.round(ms / $59b0218440ff91b6$var$h) + 'h';
    if (ms >= $59b0218440ff91b6$var$m) return Math.round(ms / $59b0218440ff91b6$var$m) + 'm';
    if (ms >= $59b0218440ff91b6$var$s) return Math.round(ms / $59b0218440ff91b6$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $59b0218440ff91b6$var$fmtLong(ms) {
    return $59b0218440ff91b6$var$plural(ms, $59b0218440ff91b6$var$d, 'day') || $59b0218440ff91b6$var$plural(ms, $59b0218440ff91b6$var$h, 'hour') || $59b0218440ff91b6$var$plural(ms, $59b0218440ff91b6$var$m, 'minute') || $59b0218440ff91b6$var$plural(ms, $59b0218440ff91b6$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $59b0218440ff91b6$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



parcelRegister("cX1nd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signer = void 0;

/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/ $parcel$global.Buffer = $parcel$global.Buffer || (parcelRequire("38gB7")).Buffer; // Required for aws sigv4 signing

var $adm0U = parcelRequire("adm0U");

var $aR7W6 = parcelRequire("aR7W6");
var $96dc0f780efc98cf$require$Sha256 = $aR7W6.Sha256;
parcelRequire("kIMvM");
var $lnDBj = parcelRequire("lnDBj");
var $96dc0f780efc98cf$require$toHex = $lnDBj.toHex;
var $96dc0f780efc98cf$var$encrypt = function(key, src, encoding) {
    if (encoding === void 0) encoding = '';
    var hash = new $96dc0f780efc98cf$require$Sha256(key);
    hash.update(src);
    var result = hash.digestSync();
    if (encoding === 'hex') return $96dc0f780efc98cf$require$toHex(result);
    return result;
};
var $96dc0f780efc98cf$var$hash = function(src) {
    var arg = src || '';
    var hash = new $96dc0f780efc98cf$require$Sha256();
    hash.update(arg);
    return $96dc0f780efc98cf$require$toHex(hash.digestSync());
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $96dc0f780efc98cf$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
* List of header keys included in the canonical headers.
* @access private
*/ var $96dc0f780efc98cf$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $96dc0f780efc98cf$var$canonical_request = function(request) {
    var url_info = $adm0U.parse(request.url);
    return [
        request.method || '/',
        url_info.path,
        url_info.query,
        $96dc0f780efc98cf$var$canonical_headers(request.headers),
        $96dc0f780efc98cf$var$signed_headers(request.headers),
        $96dc0f780efc98cf$var$hash(request.body)
    ].join('\n');
};
var $96dc0f780efc98cf$var$parse_service_info = function(request) {
    var url_info = $adm0U.parse(request.url), host = url_info.host;
    var matched = host.match(/([^.]+)\.(?:([^.]*)\.)?amazonaws\.com$/), parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $96dc0f780efc98cf$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $96dc0f780efc98cf$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $96dc0f780efc98cf$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $96dc0f780efc98cf$var$get_signing_key = function(secret_key, d_str, service_info) {
    if (secret_key === void 0) secret_key = '';
    var k = 'AWS4' + secret_key, k_date = $96dc0f780efc98cf$var$encrypt(k, d_str), k_region = $96dc0f780efc98cf$var$encrypt(k_date, service_info.region), k_service = $96dc0f780efc98cf$var$encrypt(k_region, service_info.service), k_signing = $96dc0f780efc98cf$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $96dc0f780efc98cf$var$get_signature = function(signing_key, str_to_sign) {
    return $96dc0f780efc98cf$var$encrypt(signing_key, str_to_sign, 'hex');
};
/**
* @private
* Create authorization header
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
*/ var $96dc0f780efc98cf$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    if (access_key === void 0) access_key = '';
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
/**
* Sign a HTTP request, add 'Authorization' header to request param
* @method sign
* @memberof Signer
* @static
*
* @param {object} request - HTTP request object
<pre>
request: {
    method: GET | POST | PUT ...
    url: ...,
    headers: {
        header1: ...
    },
    body: data
}
</pre>
* @param {object} access_info - AWS access credential info
<pre>
access_info: {
    access_key: ...,
    secret_key: ...,
    session_token: ...
}
</pre>
* @param {object} [service_info] - AWS service type and region, optional,
*                                  if not provided then parse out from url
<pre>
service_info: {
    service: ...,
    region: ...
}
</pre>
*
* @returns {object} Signed HTTP request
*/ var $96dc0f780efc98cf$var$sign = function(request, access_info, service_info) {
    if (service_info === void 0) service_info = null;
    request.headers = request.headers || {};
    // datetime string and date string
    var dt = new Date(), dt_str = dt.toISOString().replace(/[:-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8), algorithm = 'AWS4-HMAC-SHA256';
    var url_info = $adm0U.parse(request.url);
    request.headers['host'] = url_info.host;
    request.headers['x-amz-date'] = dt_str;
    if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
    // Task 1: Create a Canonical Request
    var request_str = $96dc0f780efc98cf$var$canonical_request(request);
    // Task 2: Create a String to Sign
    service_info = service_info || $96dc0f780efc98cf$var$parse_service_info(request);
    var scope = $96dc0f780efc98cf$var$credential_scope(d_str, service_info.region, service_info.service);
    var str_to_sign = $96dc0f780efc98cf$var$string_to_sign(algorithm, request_str, dt_str, scope);
    // Task 3: Calculate the Signature
    var signing_key = $96dc0f780efc98cf$var$get_signing_key(access_info.secret_key, d_str, service_info), signature = $96dc0f780efc98cf$var$get_signature(signing_key, str_to_sign);
    // Task 4: Adding the Signing information to the Request
    var authorization_header = $96dc0f780efc98cf$var$get_authorization_header(algorithm, access_info.access_key, scope, $96dc0f780efc98cf$var$signed_headers(request.headers), signature);
    request.headers['Authorization'] = authorization_header;
    return request;
};
/**
* AWS request signer.
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
*
* @class Signer
*/ var $96dc0f780efc98cf$var$Signer = /** @class */ function() {
    function Signer() {}
    Signer.sign = $96dc0f780efc98cf$var$sign;
    return Signer;
}();
module.exports.Signer = $96dc0f780efc98cf$var$Signer;
module.exports.default = $96dc0f780efc98cf$var$Signer;

});
parcelRegister("kIMvM", function(module, exports) {
$parcel$export(module.exports, "toHex", function () { return (parcelRequire("lnDBj")).toHex; });
parcelRequire("lnDBj");

});
parcelRegister("lnDBj", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $f90a76d6b79be04b$export$7ea66e3774a60b67; });
const $f90a76d6b79be04b$var$SHORT_TO_HEX = {};
const $f90a76d6b79be04b$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $f90a76d6b79be04b$var$SHORT_TO_HEX[i] = encodedByte;
    $f90a76d6b79be04b$var$HEX_TO_SHORT[encodedByte] = i;
}
function $f90a76d6b79be04b$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $f90a76d6b79be04b$var$HEX_TO_SHORT) out[i / 2] = $f90a76d6b79be04b$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $f90a76d6b79be04b$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $f90a76d6b79be04b$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});



parcelRegister("37gNm", function(module, exports) {
(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
    else module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
        if (functionName !== undefined) this.setFunctionName(functionName);
        if (args !== undefined) this.setArgs(args);
        if (fileName !== undefined) this.setFileName(fileName);
        if (lineNumber !== undefined) this.setLineNumber(lineNumber);
        if (columnNumber !== undefined) this.setColumnNumber(columnNumber);
        if (source !== undefined) this.setSource(source);
    }
    StackFrame.prototype = {
        getFunctionName: function() {
            return this.functionName;
        },
        setFunctionName: function(v) {
            this.functionName = String(v);
        },
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
            this.args = v;
        },
        // NOTE: Property name may be misleading as it includes the path,
        // but it somewhat mirrors V8's JavaScriptStackTraceApi
        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
        getFileName: function() {
            return this.fileName;
        },
        setFileName: function(v) {
            this.fileName = String(v);
        },
        getLineNumber: function() {
            return this.lineNumber;
        },
        setLineNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Line Number must be a Number');
            this.lineNumber = Number(v);
        },
        getColumnNumber: function() {
            return this.columnNumber;
        },
        setColumnNumber: function(v) {
            if (!_isNumber(v)) throw new TypeError('Column Number must be a Number');
            this.columnNumber = Number(v);
        },
        getSource: function() {
            return this.source;
        },
        setSource: function(v) {
            this.source = String(v);
        },
        toString: function() {
            var functionName = this.getFunctionName() || '{anonymous}';
            var args = '(' + (this.getArgs() || []).join(',') + ')';
            var fileName = this.getFileName() ? '@' + this.getFileName() : '';
            var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
            var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
            return functionName + args + fileName + lineNumber + columnNumber;
        }
    };
    return StackFrame;
});

});

parcelRegister("iQC18", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $db8a92c866b34ea3$export$dca3b0875bd9a954; }, function (v) { return $db8a92c866b34ea3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $db8a92c866b34ea3$export$16fa2f45be04daa8; }, function (v) { return $db8a92c866b34ea3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $db8a92c866b34ea3$export$ffb0004e005737fa; }, function (v) { return $db8a92c866b34ea3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $db8a92c866b34ea3$export$e2c29f18771995cb; }, function (v) { return $db8a92c866b34ea3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $db8a92c866b34ea3$export$221d75b3f55bb0bd; }, function (v) { return $db8a92c866b34ea3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $db8a92c866b34ea3$export$5f8d39834fd61797; }, function (v) { return $db8a92c866b34ea3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $db8a92c866b34ea3$export$74bf444e3cd11ea5; }, function (v) { return $db8a92c866b34ea3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $db8a92c866b34ea3$export$ae55be85d98224ed; }, function (v) { return $db8a92c866b34ea3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $db8a92c866b34ea3$export$e530037191fcd5d7; }, function (v) { return $db8a92c866b34ea3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $db8a92c866b34ea3$export$fd42f52fd3ae1109; }, function (v) { return $db8a92c866b34ea3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $db8a92c866b34ea3$export$c8a8987d4410bf2d; }, function (v) { return $db8a92c866b34ea3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $db8a92c866b34ea3$export$d38cd72104c1f0e9; }, function (v) { return $db8a92c866b34ea3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $db8a92c866b34ea3$export$7d1e3a5e95ceca43; }, function (v) { return $db8a92c866b34ea3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $db8a92c866b34ea3$export$257a8862b851cb5b; }, function (v) { return $db8a92c866b34ea3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $db8a92c866b34ea3$export$a8257692ac88316c; }, function (v) { return $db8a92c866b34ea3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $db8a92c866b34ea3$export$488013bae63b21da; }, function (v) { return $db8a92c866b34ea3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $db8a92c866b34ea3$export$7c73462e0d25e514; }, function (v) { return $db8a92c866b34ea3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $db8a92c866b34ea3$export$35808ee640e87ca7; }, function (v) { return $db8a92c866b34ea3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $db8a92c866b34ea3$export$fae74005e78b1a27; }, function (v) { return $db8a92c866b34ea3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $db8a92c866b34ea3$export$dc8fbce3eb94dc1e; }, function (v) { return $db8a92c866b34ea3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $db8a92c866b34ea3$export$6d9c69b0de29b591; }, function (v) { return $db8a92c866b34ea3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $db8a92c866b34ea3$export$d5a552a76deda3c2; }, function (v) { return $db8a92c866b34ea3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $db8a92c866b34ea3$export$e5c5a5f917a5871c; }, function (v) { return $db8a92c866b34ea3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $db8a92c866b34ea3$export$1538c33de8887b59; }, function (v) { return $db8a92c866b34ea3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $db8a92c866b34ea3$export$13e3392192263954; }, function (v) { return $db8a92c866b34ea3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $db8a92c866b34ea3$export$b8f5890fc79d6aca; }, function (v) { return $db8a92c866b34ea3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $db8a92c866b34ea3$export$60241385465d0a34; }, function (v) { return $db8a92c866b34ea3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $db8a92c866b34ea3$export$83d89fbfd8236492; }, function (v) { return $db8a92c866b34ea3$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db8a92c866b34ea3$export$dca3b0875bd9a954;
var $db8a92c866b34ea3$export$16fa2f45be04daa8;
var $db8a92c866b34ea3$export$ffb0004e005737fa;
var $db8a92c866b34ea3$export$e2c29f18771995cb;
var $db8a92c866b34ea3$export$221d75b3f55bb0bd;
var $db8a92c866b34ea3$export$5f8d39834fd61797;
var $db8a92c866b34ea3$export$74bf444e3cd11ea5;
var $db8a92c866b34ea3$export$ae55be85d98224ed;
var $db8a92c866b34ea3$export$e530037191fcd5d7;
var $db8a92c866b34ea3$export$fd42f52fd3ae1109;
var $db8a92c866b34ea3$export$c8a8987d4410bf2d;
var $db8a92c866b34ea3$export$d38cd72104c1f0e9;
var $db8a92c866b34ea3$export$7d1e3a5e95ceca43;
var $db8a92c866b34ea3$export$257a8862b851cb5b;
var $db8a92c866b34ea3$export$a8257692ac88316c;
var $db8a92c866b34ea3$export$488013bae63b21da;
var $db8a92c866b34ea3$export$7c73462e0d25e514;
var $db8a92c866b34ea3$export$35808ee640e87ca7;
var $db8a92c866b34ea3$export$fae74005e78b1a27;
var $db8a92c866b34ea3$export$dc8fbce3eb94dc1e;
var $db8a92c866b34ea3$export$6d9c69b0de29b591;
var $db8a92c866b34ea3$export$d5a552a76deda3c2;
var $db8a92c866b34ea3$export$e5c5a5f917a5871c;
var $db8a92c866b34ea3$export$1538c33de8887b59;
var $db8a92c866b34ea3$export$13e3392192263954;
var $db8a92c866b34ea3$export$b8f5890fc79d6aca;
var $db8a92c866b34ea3$export$60241385465d0a34;
var $db8a92c866b34ea3$export$83d89fbfd8236492;
'use strict';

var $cYrgI = parcelRequire("cYrgI");
var $db8a92c866b34ea3$var$n = "function" === typeof Symbol && Symbol.for, $db8a92c866b34ea3$var$p = $db8a92c866b34ea3$var$n ? Symbol.for("react.element") : 60103, $db8a92c866b34ea3$var$q = $db8a92c866b34ea3$var$n ? Symbol.for("react.portal") : 60106, $db8a92c866b34ea3$var$r = $db8a92c866b34ea3$var$n ? Symbol.for("react.fragment") : 60107, $db8a92c866b34ea3$var$t = $db8a92c866b34ea3$var$n ? Symbol.for("react.strict_mode") : 60108, $db8a92c866b34ea3$var$u = $db8a92c866b34ea3$var$n ? Symbol.for("react.profiler") : 60114, $db8a92c866b34ea3$var$v = $db8a92c866b34ea3$var$n ? Symbol.for("react.provider") : 60109, $db8a92c866b34ea3$var$w = $db8a92c866b34ea3$var$n ? Symbol.for("react.context") : 60110, $db8a92c866b34ea3$var$x = $db8a92c866b34ea3$var$n ? Symbol.for("react.forward_ref") : 60112, $db8a92c866b34ea3$var$y = $db8a92c866b34ea3$var$n ? Symbol.for("react.suspense") : 60113, $db8a92c866b34ea3$var$z = $db8a92c866b34ea3$var$n ? Symbol.for("react.memo") : 60115, $db8a92c866b34ea3$var$A = $db8a92c866b34ea3$var$n ? Symbol.for("react.lazy") : 60116, $db8a92c866b34ea3$var$B = "function" === typeof Symbol && Symbol.iterator;
function $db8a92c866b34ea3$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $db8a92c866b34ea3$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $db8a92c866b34ea3$var$E = {};
function $db8a92c866b34ea3$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $db8a92c866b34ea3$var$E;
    this.updater = c || $db8a92c866b34ea3$var$D;
}
$db8a92c866b34ea3$var$F.prototype.isReactComponent = {};
$db8a92c866b34ea3$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($db8a92c866b34ea3$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$db8a92c866b34ea3$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $db8a92c866b34ea3$var$G() {}
$db8a92c866b34ea3$var$G.prototype = $db8a92c866b34ea3$var$F.prototype;
function $db8a92c866b34ea3$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $db8a92c866b34ea3$var$E;
    this.updater = c || $db8a92c866b34ea3$var$D;
}
var $db8a92c866b34ea3$var$I = $db8a92c866b34ea3$var$H.prototype = new $db8a92c866b34ea3$var$G;
$db8a92c866b34ea3$var$I.constructor = $db8a92c866b34ea3$var$H;
$cYrgI($db8a92c866b34ea3$var$I, $db8a92c866b34ea3$var$F.prototype);
$db8a92c866b34ea3$var$I.isPureReactComponent = !0;
var $db8a92c866b34ea3$var$J = {
    current: null
}, $db8a92c866b34ea3$var$K = Object.prototype.hasOwnProperty, $db8a92c866b34ea3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $db8a92c866b34ea3$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$db8a92c866b34ea3$var$K.call(b, e) && !$db8a92c866b34ea3$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $db8a92c866b34ea3$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $db8a92c866b34ea3$var$J.current
    };
}
function $db8a92c866b34ea3$var$N(a, b) {
    return {
        $$typeof: $db8a92c866b34ea3$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $db8a92c866b34ea3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $db8a92c866b34ea3$var$p;
}
function $db8a92c866b34ea3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $db8a92c866b34ea3$var$P = /\/+/g, $db8a92c866b34ea3$var$Q = [];
function $db8a92c866b34ea3$var$R(a, b, c, e) {
    if ($db8a92c866b34ea3$var$Q.length) {
        var d = $db8a92c866b34ea3$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $db8a92c866b34ea3$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $db8a92c866b34ea3$var$Q.length && $db8a92c866b34ea3$var$Q.push(a);
}
function $db8a92c866b34ea3$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $db8a92c866b34ea3$var$p:
                case $db8a92c866b34ea3$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $db8a92c866b34ea3$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $db8a92c866b34ea3$var$U(d, k);
        g += $db8a92c866b34ea3$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $db8a92c866b34ea3$var$B && a[$db8a92c866b34ea3$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $db8a92c866b34ea3$var$U(d, k++), g += $db8a92c866b34ea3$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($db8a92c866b34ea3$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $db8a92c866b34ea3$var$V(a, b, c) {
    return null == a ? 0 : $db8a92c866b34ea3$var$T(a, "", b, c);
}
function $db8a92c866b34ea3$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $db8a92c866b34ea3$var$escape(a.key) : b.toString(36);
}
function $db8a92c866b34ea3$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $db8a92c866b34ea3$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $db8a92c866b34ea3$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($db8a92c866b34ea3$var$O(a) && (a = $db8a92c866b34ea3$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($db8a92c866b34ea3$var$P, "$&/") + "/") + c)), e.push(a));
}
function $db8a92c866b34ea3$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($db8a92c866b34ea3$var$P, "$&/") + "/");
    b = $db8a92c866b34ea3$var$R(b, g, e, d);
    $db8a92c866b34ea3$var$V(a, $db8a92c866b34ea3$var$aa, b);
    $db8a92c866b34ea3$var$S(b);
}
var $db8a92c866b34ea3$var$Y = {
    current: null
};
function $db8a92c866b34ea3$var$Z() {
    var a = $db8a92c866b34ea3$var$Y.current;
    if (null === a) throw Error($db8a92c866b34ea3$var$C(321));
    return a;
}
var $db8a92c866b34ea3$var$ba = {
    ReactCurrentDispatcher: $db8a92c866b34ea3$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $db8a92c866b34ea3$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $cYrgI
};
$db8a92c866b34ea3$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $db8a92c866b34ea3$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $db8a92c866b34ea3$var$R(null, null, b, c);
        $db8a92c866b34ea3$var$V(a, $db8a92c866b34ea3$var$W, b);
        $db8a92c866b34ea3$var$S(b);
    },
    count: function(a) {
        return $db8a92c866b34ea3$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $db8a92c866b34ea3$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$db8a92c866b34ea3$var$O(a)) throw Error($db8a92c866b34ea3$var$C(143));
        return a;
    }
};
$db8a92c866b34ea3$export$16fa2f45be04daa8 = $db8a92c866b34ea3$var$F;
$db8a92c866b34ea3$export$ffb0004e005737fa = $db8a92c866b34ea3$var$r;
$db8a92c866b34ea3$export$e2c29f18771995cb = $db8a92c866b34ea3$var$u;
$db8a92c866b34ea3$export$221d75b3f55bb0bd = $db8a92c866b34ea3$var$H;
$db8a92c866b34ea3$export$5f8d39834fd61797 = $db8a92c866b34ea3$var$t;
$db8a92c866b34ea3$export$74bf444e3cd11ea5 = $db8a92c866b34ea3$var$y;
$db8a92c866b34ea3$export$ae55be85d98224ed = $db8a92c866b34ea3$var$ba;
$db8a92c866b34ea3$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($db8a92c866b34ea3$var$C(267, a));
    var e = $cYrgI({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $db8a92c866b34ea3$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$db8a92c866b34ea3$var$K.call(b, h) && !$db8a92c866b34ea3$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $db8a92c866b34ea3$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$db8a92c866b34ea3$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $db8a92c866b34ea3$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $db8a92c866b34ea3$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$db8a92c866b34ea3$export$c8a8987d4410bf2d = $db8a92c866b34ea3$var$M;
$db8a92c866b34ea3$export$d38cd72104c1f0e9 = function(a) {
    var b = $db8a92c866b34ea3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$db8a92c866b34ea3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$db8a92c866b34ea3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $db8a92c866b34ea3$var$x,
        render: a
    };
};
$db8a92c866b34ea3$export$a8257692ac88316c = $db8a92c866b34ea3$var$O;
$db8a92c866b34ea3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $db8a92c866b34ea3$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$db8a92c866b34ea3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $db8a92c866b34ea3$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$db8a92c866b34ea3$export$35808ee640e87ca7 = function(a, b) {
    return $db8a92c866b34ea3$var$Z().useCallback(a, b);
};
$db8a92c866b34ea3$export$fae74005e78b1a27 = function(a, b) {
    return $db8a92c866b34ea3$var$Z().useContext(a, b);
};
$db8a92c866b34ea3$export$dc8fbce3eb94dc1e = function() {};
$db8a92c866b34ea3$export$6d9c69b0de29b591 = function(a, b) {
    return $db8a92c866b34ea3$var$Z().useEffect(a, b);
};
$db8a92c866b34ea3$export$d5a552a76deda3c2 = function(a, b, c) {
    return $db8a92c866b34ea3$var$Z().useImperativeHandle(a, b, c);
};
$db8a92c866b34ea3$export$e5c5a5f917a5871c = function(a, b) {
    return $db8a92c866b34ea3$var$Z().useLayoutEffect(a, b);
};
$db8a92c866b34ea3$export$1538c33de8887b59 = function(a, b) {
    return $db8a92c866b34ea3$var$Z().useMemo(a, b);
};
$db8a92c866b34ea3$export$13e3392192263954 = function(a, b, c) {
    return $db8a92c866b34ea3$var$Z().useReducer(a, b, c);
};
$db8a92c866b34ea3$export$b8f5890fc79d6aca = function(a) {
    return $db8a92c866b34ea3$var$Z().useRef(a);
};
$db8a92c866b34ea3$export$60241385465d0a34 = function(a) {
    return $db8a92c866b34ea3$var$Z().useState(a);
};
$db8a92c866b34ea3$export$83d89fbfd8236492 = "16.13.1";

});

parcelRegister("7Saq1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HIDE_TIMEOUT = undefined;
var $5bb5a87efac2165e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5bb5a87efac2165e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.OverlayComponent = $5bb5a87efac2165e$var$OverlayComponent;
module.exports.defaultFormat = $5bb5a87efac2165e$var$defaultFormat;
module.exports.defaultParse = $5bb5a87efac2165e$var$defaultParse;

var $denZA = parcelRequire("denZA");
var $5bb5a87efac2165e$var$_react2 = $5bb5a87efac2165e$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $5bb5a87efac2165e$var$_propTypes2 = $5bb5a87efac2165e$var$_interopRequireDefault($cvFNP);

var $7eLBQ = parcelRequire("7eLBQ");
var $5bb5a87efac2165e$var$_DayPicker2 = $5bb5a87efac2165e$var$_interopRequireDefault($7eLBQ);

var $9hsGH = parcelRequire("9hsGH");

var $dF5u6 = parcelRequire("dF5u6");

var $7yR5m = parcelRequire("7yR5m");
function $5bb5a87efac2165e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5bb5a87efac2165e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5bb5a87efac2165e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bb5a87efac2165e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5bb5a87efac2165e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $5bb5a87efac2165e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// When clicking on a day cell, overlay will be hidden after this timeout
var $5bb5a87efac2165e$var$HIDE_TIMEOUT = module.exports.HIDE_TIMEOUT = 100;
/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */ function $5bb5a87efac2165e$var$OverlayComponent(_ref) {
    var input = _ref.input, selectedDay = _ref.selectedDay, month = _ref.month, children = _ref.children, classNames = _ref.classNames, props = $5bb5a87efac2165e$var$_objectWithoutProperties(_ref, [
        'input',
        'selectedDay',
        'month',
        'children',
        'classNames'
    ]);
    return $5bb5a87efac2165e$var$_react2.default.createElement('div', $5bb5a87efac2165e$var$_extends({
        className: classNames.overlayWrapper
    }, props), $5bb5a87efac2165e$var$_react2.default.createElement('div', {
        className: classNames.overlay
    }, children));
}
$5bb5a87efac2165e$var$OverlayComponent.propTypes = {
    input: $5bb5a87efac2165e$var$_propTypes2.default.any,
    selectedDay: $5bb5a87efac2165e$var$_propTypes2.default.any,
    month: $5bb5a87efac2165e$var$_propTypes2.default.instanceOf(Date),
    children: $5bb5a87efac2165e$var$_propTypes2.default.node,
    classNames: $5bb5a87efac2165e$var$_propTypes2.default.object
};
/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */ function $5bb5a87efac2165e$var$defaultFormat(d) {
    if ((0, $9hsGH.isDate)(d)) {
        var year = d.getFullYear();
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        return year + '-' + month + '-' + day;
    }
    return '';
}
/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */ function $5bb5a87efac2165e$var$defaultParse(str) {
    if (typeof str !== 'string') return undefined;
    var split = str.split('-');
    if (split.length !== 3) return undefined;
    var year = parseInt(split[0], 10);
    var month = parseInt(split[1], 10) - 1;
    var day = parseInt(split[2], 10);
    if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) return undefined;
    return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
}
var $5bb5a87efac2165e$var$DayPickerInput = function(_React$Component) {
    $5bb5a87efac2165e$var$_inherits(DayPickerInput, _React$Component);
    function DayPickerInput(props) {
        $5bb5a87efac2165e$var$_classCallCheck(this, DayPickerInput);
        var _this = $5bb5a87efac2165e$var$_possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));
        _this.input = null;
        _this.daypicker = null;
        _this.clickTimeout = null;
        _this.hideTimeout = null;
        _this.inputBlurTimeout = null;
        _this.inputFocusTimeout = null;
        _this.state = _this.getInitialStateFromProps(props);
        _this.state.showOverlay = props.showOverlay;
        _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
        _this.handleInputClick = _this.handleInputClick.bind(_this);
        _this.handleInputFocus = _this.handleInputFocus.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
        _this.handleDayClick = _this.handleDayClick.bind(_this);
        _this.handleMonthChange = _this.handleMonthChange.bind(_this);
        _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
        _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
        return _this;
    }
    $5bb5a87efac2165e$var$_createClass(DayPickerInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var newState = {};
                // Current props
                var _props = this.props, value = _props.value, formatDate = _props.formatDate, format = _props.format, dayPickerProps = _props.dayPickerProps;
                // Update the input value if `value`, `dayPickerProps.locale` or `format`
                // props have changed
                if (value !== prevProps.value || dayPickerProps.locale !== prevProps.dayPickerProps.locale || format !== prevProps.format) {
                    if ((0, $9hsGH.isDate)(value)) newState.value = formatDate(value, format, dayPickerProps.locale);
                    else newState.value = value;
                }
                // Update the month if the months from props changed
                var prevMonth = prevProps.dayPickerProps.month;
                if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, $9hsGH.isSameMonth)(dayPickerProps.month, prevMonth)) newState.month = dayPickerProps.month;
                // Updated the selected days from props if they changed
                if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) newState.selectedDays = dayPickerProps.selectedDays;
                if (Object.keys(newState).length > 0) // eslint-disable-next-line react/no-did-update-set-state
                this.setState(newState);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this.clickTimeout);
                clearTimeout(this.hideTimeout);
                clearTimeout(this.inputFocusTimeout);
                clearTimeout(this.inputBlurTimeout);
                clearTimeout(this.overlayBlurTimeout);
            }
        },
        {
            key: 'getInitialMonthFromProps',
            value: function getInitialMonthFromProps(props) {
                var dayPickerProps = props.dayPickerProps, format = props.format;
                var day = void 0;
                if (props.value) {
                    if ((0, $9hsGH.isDate)(props.value)) day = props.value;
                    else day = props.parseDate(props.value, format, dayPickerProps.locale);
                }
                return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
            }
        },
        {
            key: 'getInitialStateFromProps',
            value: function getInitialStateFromProps(props) {
                var dayPickerProps = props.dayPickerProps, formatDate = props.formatDate, format = props.format, typedValue = props.typedValue;
                var value = props.value;
                if (props.value && (0, $9hsGH.isDate)(props.value)) value = formatDate(props.value, format, dayPickerProps.locale);
                return {
                    value: value,
                    typedValue: typedValue,
                    month: this.getInitialMonthFromProps(props),
                    selectedDays: dayPickerProps.selectedDays
                };
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'getDayPicker',
            value: function getDayPicker() {
                return this.daypicker;
            }
        },
        {
            key: 'updateState',
            value: function updateState(day, value, callback) {
                var _this2 = this;
                var _props2 = this.props, dayPickerProps = _props2.dayPickerProps, onDayChange = _props2.onDayChange;
                this.setState({
                    month: day,
                    value: value,
                    typedValue: ''
                }, function() {
                    if (callback) callback();
                    if (!onDayChange) return;
                    var modifiersObj = $5bb5a87efac2165e$var$_extends({
                        disabled: dayPickerProps.disabledDays,
                        selected: dayPickerProps.selectedDays
                    }, dayPickerProps.modifiers);
                    var modifiers = (0, $dF5u6.getModifiersForDay)(day, modifiersObj).reduce(function(obj, modifier) {
                        return $5bb5a87efac2165e$var$_extends({}, obj, $5bb5a87efac2165e$var$_defineProperty({}, modifier, true));
                    }, {});
                    onDayChange(day, modifiers, _this2);
                });
            }
        },
        {
            key: 'showDayPicker',
            value: function showDayPicker() {
                var _this3 = this;
                var _props3 = this.props, parseDate = _props3.parseDate, format = _props3.format, dayPickerProps = _props3.dayPickerProps;
                var _state = this.state, value = _state.value, showOverlay = _state.showOverlay;
                if (showOverlay) return;
                // Reset the current displayed month when showing the overlay
                var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
                 : this.getInitialMonthFromProps(this.props); // Restore the month from the props
                this.setState(function(state) {
                    return {
                        showOverlay: true,
                        month: month || state.month
                    };
                }, function() {
                    if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
                });
            }
        },
        {
            key: 'hideDayPicker',
            value: function hideDayPicker() {
                var _this4 = this;
                if (this.state.showOverlay === false) return;
                this.setState({
                    showOverlay: false
                }, function() {
                    if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
                });
            }
        },
        {
            key: 'hideAfterDayClick',
            value: function hideAfterDayClick() {
                var _this5 = this;
                if (!this.props.hideOnDayClick) return;
                this.hideTimeout = setTimeout(function() {
                    _this5.overlayHasFocus = false;
                    _this5.hideDayPicker();
                }, $5bb5a87efac2165e$var$HIDE_TIMEOUT);
            }
        },
        {
            key: 'handleInputClick',
            value: function handleInputClick(e) {
                this.showDayPicker();
                if (this.props.inputProps.onClick) {
                    e.persist();
                    this.props.inputProps.onClick(e);
                }
            }
        },
        {
            key: 'handleInputFocus',
            value: function handleInputFocus(e) {
                var _this6 = this;
                this.showDayPicker();
                // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
                // the input is blurred
                this.inputFocusTimeout = setTimeout(function() {
                    _this6.overlayHasFocus = false;
                }, 2);
                if (this.props.inputProps.onFocus) {
                    e.persist();
                    this.props.inputProps.onFocus(e);
                }
            }
        },
        {
            key: 'handleInputBlur',
            value: function handleInputBlur(e) {
                var _this7 = this;
                this.inputBlurTimeout = setTimeout(function() {
                    if (!_this7.overlayHasFocus) _this7.hideDayPicker();
                }, 1);
                if (this.props.inputProps.onBlur) {
                    e.persist();
                    this.props.inputProps.onBlur(e);
                }
            }
        },
        {
            key: 'handleOverlayFocus',
            value: function handleOverlayFocus(e) {
                e.preventDefault();
                this.overlayHasFocus = true;
                if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') return;
                this.input.focus();
            }
        },
        {
            key: 'handleOverlayBlur',
            value: function handleOverlayBlur() {
                var _this8 = this;
                // We need to set a timeout otherwise IE11 will hide the overlay when
                // focusing it
                this.overlayBlurTimeout = setTimeout(function() {
                    _this8.overlayHasFocus = false;
                }, 3);
            }
        },
        {
            key: 'handleInputChange',
            value: function handleInputChange(e) {
                var _props4 = this.props, dayPickerProps = _props4.dayPickerProps, format = _props4.format, inputProps = _props4.inputProps, onDayChange = _props4.onDayChange, parseDate = _props4.parseDate;
                if (inputProps.onChange) {
                    e.persist();
                    inputProps.onChange(e);
                }
                var value = e.target.value;
                if (value.trim() === '') {
                    this.setState({
                        value: value,
                        typedValue: ''
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                var day = parseDate(value, format, dayPickerProps.locale);
                if (!day) {
                    // Day is invalid: we save the value in the typedValue state
                    this.setState({
                        value: value,
                        typedValue: value
                    });
                    if (onDayChange) onDayChange(undefined, {}, this);
                    return;
                }
                this.updateState(day, value);
            }
        },
        {
            key: 'handleInputKeyDown',
            value: function handleInputKeyDown(e) {
                if (e.keyCode === $7yR5m.TAB) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyDown) {
                    e.persist();
                    this.props.inputProps.onKeyDown(e);
                }
            }
        },
        {
            key: 'handleInputKeyUp',
            value: function handleInputKeyUp(e) {
                if (e.keyCode === $7yR5m.ESC) this.hideDayPicker();
                else this.showDayPicker();
                if (this.props.inputProps.onKeyUp) {
                    e.persist();
                    this.props.inputProps.onKeyUp(e);
                }
            }
        },
        {
            key: 'handleMonthChange',
            value: function handleMonthChange(month) {
                var _this9 = this;
                this.setState({
                    month: month
                }, function() {
                    if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) _this9.props.dayPickerProps.onMonthChange(month);
                });
            }
        },
        {
            key: 'handleDayClick',
            value: function handleDayClick(day, modifiers, e) {
                var _this10 = this;
                var _props5 = this.props, clickUnselectsDay = _props5.clickUnselectsDay, dayPickerProps = _props5.dayPickerProps, onDayChange = _props5.onDayChange, formatDate = _props5.formatDate, format = _props5.format;
                if (dayPickerProps.onDayClick) dayPickerProps.onDayClick(day, modifiers, e);
                // Do nothing if the day is disabled
                if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) return;
                // If the clicked day is already selected, remove the clicked day
                // from the selected days and empty the field value
                if (modifiers.selected && clickUnselectsDay) {
                    var selectedDays = this.state.selectedDays;
                    if (Array.isArray(selectedDays)) {
                        selectedDays = selectedDays.slice(0);
                        var selectedDayIdx = selectedDays.indexOf(day);
                        selectedDays.splice(selectedDayIdx, 1);
                    } else if (selectedDays) selectedDays = null;
                    this.setState({
                        value: '',
                        typedValue: '',
                        selectedDays: selectedDays
                    }, this.hideAfterDayClick);
                    if (onDayChange) onDayChange(undefined, modifiers, this);
                    return;
                }
                var value = formatDate(day, format, dayPickerProps.locale);
                this.setState({
                    value: value,
                    typedValue: '',
                    month: day
                }, function() {
                    if (onDayChange) onDayChange(day, modifiers, _this10);
                    _this10.hideAfterDayClick();
                });
            }
        },
        {
            key: 'renderOverlay',
            value: function renderOverlay() {
                var _this11 = this;
                var _props6 = this.props, classNames = _props6.classNames, dayPickerProps = _props6.dayPickerProps, parseDate = _props6.parseDate, formatDate = _props6.formatDate, format = _props6.format;
                var _state2 = this.state, selectedDays = _state2.selectedDays, value = _state2.value;
                var selectedDay = void 0;
                if (!selectedDays && value) {
                    var day = parseDate(value, format, dayPickerProps.locale);
                    if (day) selectedDay = day;
                } else if (selectedDays) selectedDay = selectedDays;
                var onTodayButtonClick = void 0;
                if (dayPickerProps.todayButton) // Set the current day when clicking the today button
                onTodayButtonClick = function onTodayButtonClick() {
                    return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
                };
                var Overlay = this.props.overlayComponent;
                return $5bb5a87efac2165e$var$_react2.default.createElement(Overlay, {
                    classNames: classNames,
                    month: this.state.month,
                    selectedDay: selectedDay,
                    input: this.input,
                    tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
                    ,
                    onFocus: this.handleOverlayFocus,
                    onBlur: this.handleOverlayBlur
                }, $5bb5a87efac2165e$var$_react2.default.createElement($5bb5a87efac2165e$var$_DayPicker2.default, $5bb5a87efac2165e$var$_extends({
                    ref: function ref(el) {
                        return _this11.daypicker = el;
                    },
                    onTodayButtonClick: onTodayButtonClick
                }, dayPickerProps, {
                    month: this.state.month,
                    selectedDays: selectedDay,
                    onDayClick: this.handleDayClick,
                    onMonthChange: this.handleMonthChange
                })));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this12 = this;
                var Input = this.props.component;
                var inputProps = this.props.inputProps;
                return $5bb5a87efac2165e$var$_react2.default.createElement('div', {
                    className: this.props.classNames.container,
                    style: this.props.style
                }, $5bb5a87efac2165e$var$_react2.default.createElement(Input, $5bb5a87efac2165e$var$_extends({
                    ref: function ref(el) {
                        return _this12.input = el;
                    },
                    placeholder: this.props.placeholder
                }, inputProps, {
                    value: this.state.value || this.state.typedValue,
                    onChange: this.handleInputChange,
                    onFocus: this.handleInputFocus,
                    onBlur: this.handleInputBlur,
                    onKeyDown: this.handleInputKeyDown,
                    onKeyUp: this.handleInputKeyUp,
                    onClick: !inputProps.disabled ? this.handleInputClick : undefined
                })), this.state.showOverlay && this.renderOverlay());
            }
        }
    ]);
    return DayPickerInput;
}($5bb5a87efac2165e$var$_react2.default.Component);
$5bb5a87efac2165e$var$DayPickerInput.propTypes = {
    value: $5bb5a87efac2165e$var$_propTypes2.default.oneOfType([
        $5bb5a87efac2165e$var$_propTypes2.default.string,
        $5bb5a87efac2165e$var$_propTypes2.default.instanceOf(Date)
    ]),
    inputProps: $5bb5a87efac2165e$var$_propTypes2.default.object,
    placeholder: $5bb5a87efac2165e$var$_propTypes2.default.string,
    format: $5bb5a87efac2165e$var$_propTypes2.default.oneOfType([
        $5bb5a87efac2165e$var$_propTypes2.default.string,
        $5bb5a87efac2165e$var$_propTypes2.default.arrayOf($5bb5a87efac2165e$var$_propTypes2.default.string)
    ]),
    formatDate: $5bb5a87efac2165e$var$_propTypes2.default.func,
    parseDate: $5bb5a87efac2165e$var$_propTypes2.default.func,
    typedValue: $5bb5a87efac2165e$var$_propTypes2.default.string,
    showOverlay: $5bb5a87efac2165e$var$_propTypes2.default.bool,
    dayPickerProps: $5bb5a87efac2165e$var$_propTypes2.default.object,
    hideOnDayClick: $5bb5a87efac2165e$var$_propTypes2.default.bool,
    clickUnselectsDay: $5bb5a87efac2165e$var$_propTypes2.default.bool,
    keepFocus: $5bb5a87efac2165e$var$_propTypes2.default.bool,
    component: $5bb5a87efac2165e$var$_propTypes2.default.any,
    overlayComponent: $5bb5a87efac2165e$var$_propTypes2.default.any,
    style: $5bb5a87efac2165e$var$_propTypes2.default.object,
    classNames: $5bb5a87efac2165e$var$_propTypes2.default.shape({
        container: $5bb5a87efac2165e$var$_propTypes2.default.string,
        overlayWrapper: $5bb5a87efac2165e$var$_propTypes2.default.string,
        overlay: $5bb5a87efac2165e$var$_propTypes2.default.string.isRequired
    }),
    onDayChange: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onDayPickerHide: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onDayPickerShow: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onChange: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onClick: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onFocus: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onBlur: $5bb5a87efac2165e$var$_propTypes2.default.func,
    onKeyUp: $5bb5a87efac2165e$var$_propTypes2.default.func
};
$5bb5a87efac2165e$var$DayPickerInput.defaultProps = {
    dayPickerProps: {},
    value: '',
    typedValue: '',
    placeholder: 'YYYY-M-D',
    format: 'L',
    formatDate: $5bb5a87efac2165e$var$defaultFormat,
    parseDate: $5bb5a87efac2165e$var$defaultParse,
    showOverlay: false,
    hideOnDayClick: true,
    clickUnselectsDay: false,
    keepFocus: true,
    component: 'input',
    inputProps: {},
    overlayComponent: $5bb5a87efac2165e$var$OverlayComponent,
    classNames: {
        container: 'DayPickerInput',
        overlayWrapper: 'DayPickerInput-OverlayWrapper',
        overlay: 'DayPickerInput-Overlay'
    }
};
module.exports.default = $5bb5a87efac2165e$var$DayPickerInput;

});
parcelRegister("cvFNP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91b8ce686e3cbe09$var$ReactIs, $91b8ce686e3cbe09$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eUCV2"))();

});

parcelRegister("7eLBQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModifiersUtils = module.exports.LocaleUtils = module.exports.DateUtils = module.exports.DayPicker = undefined;
var $544ec56b14d7f518$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $544ec56b14d7f518$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $544ec56b14d7f518$var$_react2 = $544ec56b14d7f518$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $544ec56b14d7f518$var$_propTypes2 = $544ec56b14d7f518$var$_interopRequireDefault($cvFNP);

var $i30IP = parcelRequire("i30IP");
var $544ec56b14d7f518$var$_Caption2 = $544ec56b14d7f518$var$_interopRequireDefault($i30IP);

var $19KKq = parcelRequire("19KKq");
var $544ec56b14d7f518$var$_Navbar2 = $544ec56b14d7f518$var$_interopRequireDefault($19KKq);

var $2qQ4T = parcelRequire("2qQ4T");
var $544ec56b14d7f518$var$_Month2 = $544ec56b14d7f518$var$_interopRequireDefault($2qQ4T);

var $gT5es = parcelRequire("gT5es");
var $544ec56b14d7f518$var$_Weekday2 = $544ec56b14d7f518$var$_interopRequireDefault($gT5es);

var $g4lke = parcelRequire("g4lke");
var $544ec56b14d7f518$var$Helpers = $544ec56b14d7f518$var$_interopRequireWildcard($g4lke);

var $9hsGH = parcelRequire("9hsGH");
var $544ec56b14d7f518$var$DateUtils = $544ec56b14d7f518$var$_interopRequireWildcard($9hsGH);

var $1BThc = parcelRequire("1BThc");
var $544ec56b14d7f518$var$LocaleUtils = $544ec56b14d7f518$var$_interopRequireWildcard($1BThc);

var $dF5u6 = parcelRequire("dF5u6");
var $544ec56b14d7f518$var$ModifiersUtils = $544ec56b14d7f518$var$_interopRequireWildcard($dF5u6);

var $cwLUT = parcelRequire("cwLUT");
var $544ec56b14d7f518$var$_classNames2 = $544ec56b14d7f518$var$_interopRequireDefault($cwLUT);

var $7yR5m = parcelRequire("7yR5m");
function $544ec56b14d7f518$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $544ec56b14d7f518$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $544ec56b14d7f518$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $544ec56b14d7f518$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $544ec56b14d7f518$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $544ec56b14d7f518$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $544ec56b14d7f518$var$DayPicker = module.exports.DayPicker = function(_Component) {
    $544ec56b14d7f518$var$_inherits(DayPicker, _Component);
    function DayPicker(props) {
        $544ec56b14d7f518$var$_classCallCheck(this, DayPicker);
        var _this = $544ec56b14d7f518$var$_possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
        _this.dayPicker = null;
        _this.showNextMonth = function(callback) {
            if (!_this.allowNextMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var nextMonth = $544ec56b14d7f518$var$DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
            _this.showMonth(nextMonth, callback);
        };
        _this.showPreviousMonth = function(callback) {
            if (!_this.allowPreviousMonth()) return;
            var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
            var previousMonth = $544ec56b14d7f518$var$DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
            _this.showMonth(previousMonth, callback);
        };
        _this.handleKeyDown = function(e) {
            e.persist();
            switch(e.keyCode){
                case $7yR5m.LEFT:
                    if (_this.props.dir === 'rtl') _this.showNextMonth();
                    else _this.showPreviousMonth();
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    break;
                case $7yR5m.RIGHT:
                    if (_this.props.dir === 'rtl') _this.showPreviousMonth();
                    else _this.showNextMonth();
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    break;
                case $7yR5m.UP:
                    _this.showPreviousYear();
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    break;
                case $7yR5m.DOWN:
                    _this.showNextYear();
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    break;
                default:
                    break;
            }
            if (_this.props.onKeyDown) _this.props.onKeyDown(e);
        };
        _this.handleDayKeyDown = function(day, modifiers, e) {
            e.persist();
            switch(e.keyCode){
                case $7yR5m.LEFT:
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === 'rtl') _this.focusNextDay(e.target);
                    else _this.focusPreviousDay(e.target);
                    break;
                case $7yR5m.RIGHT:
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    if (_this.props.dir === 'rtl') _this.focusPreviousDay(e.target);
                    else _this.focusNextDay(e.target);
                    break;
                case $7yR5m.UP:
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    _this.focusPreviousWeek(e.target);
                    break;
                case $7yR5m.DOWN:
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    _this.focusNextWeek(e.target);
                    break;
                case $7yR5m.ENTER:
                case $7yR5m.SPACE:
                    $544ec56b14d7f518$var$Helpers.cancelEvent(e);
                    if (_this.props.onDayClick) _this.handleDayClick(day, modifiers, e);
                    break;
                default:
                    break;
            }
            if (_this.props.onDayKeyDown) _this.props.onDayKeyDown(day, modifiers, e);
        };
        _this.handleDayClick = function(day, modifiers, e) {
            e.persist();
            if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) _this.handleOutsideDayClick(day);
            if (_this.props.onDayClick) _this.props.onDayClick(day, modifiers, e);
        };
        _this.handleTodayButtonClick = function(e) {
            var today = new Date();
            var month = new Date(today.getFullYear(), today.getMonth());
            _this.showMonth(month);
            e.target.blur();
            if (_this.props.onTodayButtonClick) {
                e.persist();
                _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), $544ec56b14d7f518$var$ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
            }
        };
        var currentMonth = _this.getCurrentMonthFromProps(props);
        _this.state = {
            currentMonth: currentMonth
        };
        return _this;
    }
    $544ec56b14d7f518$var$_createClass(DayPicker, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                // Changing the `month` props means changing the current displayed month
                if (prevProps.month !== this.props.month && !$544ec56b14d7f518$var$DateUtils.isSameMonth(prevProps.month, this.props.month)) {
                    var currentMonth = this.getCurrentMonthFromProps(this.props);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        currentMonth: currentMonth
                    });
                }
            }
        },
        {
            key: 'getCurrentMonthFromProps',
            /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */ value: function getCurrentMonthFromProps(props) {
                var initialMonth = $544ec56b14d7f518$var$Helpers.startOfMonth(props.month || props.initialMonth || new Date());
                var currentMonth = initialMonth;
                if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
                    var fromMonth = $544ec56b14d7f518$var$Helpers.startOfMonth(props.fromMonth);
                    var diffInMonths = $544ec56b14d7f518$var$Helpers.getMonthsDiff(fromMonth, currentMonth);
                    currentMonth = $544ec56b14d7f518$var$DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
                } else if (props.toMonth && props.numberOfMonths > 1 && $544ec56b14d7f518$var$Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) currentMonth = $544ec56b14d7f518$var$DateUtils.addMonths($544ec56b14d7f518$var$Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
                return currentMonth;
            }
        },
        {
            key: 'getNextNavigableMonth',
            value: function getNextNavigableMonth() {
                return $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
            }
        },
        {
            key: 'getPreviousNavigableMonth',
            value: function getPreviousNavigableMonth() {
                return $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, -1);
            }
        },
        {
            key: 'allowPreviousMonth',
            value: function allowPreviousMonth() {
                var previousMonth = $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, -1);
                return this.allowMonth(previousMonth);
            }
        },
        {
            key: 'allowNextMonth',
            value: function allowNextMonth() {
                var nextMonth = $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
                return this.allowMonth(nextMonth);
            }
        },
        {
            key: 'allowMonth',
            value: function allowMonth(d) {
                var _props = this.props, fromMonth = _props.fromMonth, toMonth = _props.toMonth, canChangeMonth = _props.canChangeMonth;
                if (!canChangeMonth || fromMonth && $544ec56b14d7f518$var$Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && $544ec56b14d7f518$var$Helpers.getMonthsDiff(toMonth, d) > 0) return false;
                return true;
            }
        },
        {
            key: 'allowYearChange',
            value: function allowYearChange() {
                return this.props.canChangeMonth;
            }
        },
        {
            key: 'showMonth',
            value: function showMonth(d, callback) {
                var _this2 = this;
                if (!this.allowMonth(d)) return;
                this.setState({
                    currentMonth: $544ec56b14d7f518$var$Helpers.startOfMonth(d)
                }, function() {
                    if (callback) callback();
                    if (_this2.props.onMonthChange) _this2.props.onMonthChange(_this2.state.currentMonth);
                });
            }
        },
        {
            key: 'showNextYear',
            value: function showNextYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, 12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: 'showPreviousYear',
            value: function showPreviousYear() {
                if (!this.allowYearChange()) return;
                var nextMonth = $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, -12);
                this.showMonth(nextMonth);
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.wrapper.focus();
            }
        },
        {
            key: 'focusFirstDayOfMonth',
            value: function focusFirstDayOfMonth() {
                $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
            }
        },
        {
            key: 'focusLastDayOfMonth',
            value: function focusLastDayOfMonth() {
                var dayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                dayNodes[dayNodes.length - 1].focus();
            }
        },
        {
            key: 'focusPreviousDay',
            value: function focusPreviousDay(dayNode) {
                var _this3 = this;
                var dayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $544ec56b14d7f518$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === 0) this.showPreviousMonth(function() {
                    return _this3.focusLastDayOfMonth();
                });
                else dayNodes[dayNodeIndex - 1].focus();
            }
        },
        {
            key: 'focusNextDay',
            value: function focusNextDay(dayNode) {
                var _this4 = this;
                var dayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $544ec56b14d7f518$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                if (dayNodeIndex === -1) return;
                if (dayNodeIndex === dayNodes.length - 1) this.showNextMonth(function() {
                    return _this4.focusFirstDayOfMonth();
                });
                else dayNodes[dayNodeIndex + 1].focus();
            }
        },
        {
            key: 'focusNextWeek',
            value: function focusNextWeek(dayNode) {
                var _this5 = this;
                var dayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $544ec56b14d7f518$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;
                if (isInLastWeekOfMonth) this.showNextMonth(function() {
                    var daysAfterIndex = dayNodes.length - dayNodeIndex;
                    var nextMonthDayNodeIndex = 7 - daysAfterIndex;
                    $544ec56b14d7f518$var$Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex + 7].focus();
            }
        },
        {
            key: 'focusPreviousWeek',
            value: function focusPreviousWeek(dayNode) {
                var _this6 = this;
                var dayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(this.dayPicker, this.props.classNames);
                var dayNodeIndex = $544ec56b14d7f518$var$Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
                var isInFirstWeekOfMonth = dayNodeIndex <= 6;
                if (isInFirstWeekOfMonth) this.showPreviousMonth(function() {
                    var previousMonthDayNodes = $544ec56b14d7f518$var$Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
                    var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
                    var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
                    previousMonthDayNodes[previousMonthDayNodeIndex].focus();
                });
                else dayNodes[dayNodeIndex - 7].focus();
            }
        },
        {
            key: 'handleOutsideDayClick',
            value: function handleOutsideDayClick(day) {
                var currentMonth = this.state.currentMonth;
                var numberOfMonths = this.props.numberOfMonths;
                var diffInMonths = $544ec56b14d7f518$var$Helpers.getMonthsDiff(currentMonth, day);
                if (diffInMonths > 0 && diffInMonths >= numberOfMonths) this.showNextMonth();
                else if (diffInMonths < 0) this.showPreviousMonth();
            }
        },
        {
            key: 'renderNavbar',
            value: function renderNavbar() {
                var _props2 = this.props, labels = _props2.labels, locale = _props2.locale, localeUtils = _props2.localeUtils, canChangeMonth = _props2.canChangeMonth, navbarElement = _props2.navbarElement, attributes = $544ec56b14d7f518$var$_objectWithoutProperties(_props2, [
                    'labels',
                    'locale',
                    'localeUtils',
                    'canChangeMonth',
                    'navbarElement'
                ]);
                if (!canChangeMonth) return null;
                var props = {
                    month: this.state.currentMonth,
                    classNames: this.props.classNames,
                    className: this.props.classNames.navBar,
                    nextMonth: this.getNextNavigableMonth(),
                    previousMonth: this.getPreviousNavigableMonth(),
                    showPreviousButton: this.allowPreviousMonth(),
                    showNextButton: this.allowNextMonth(),
                    onNextClick: this.showNextMonth,
                    onPreviousClick: this.showPreviousMonth,
                    dir: attributes.dir,
                    labels: labels,
                    locale: locale,
                    localeUtils: localeUtils
                };
                return $544ec56b14d7f518$var$_react2.default.isValidElement(navbarElement) ? $544ec56b14d7f518$var$_react2.default.cloneElement(navbarElement, props) : $544ec56b14d7f518$var$_react2.default.createElement(navbarElement, props);
            }
        },
        {
            key: 'renderMonths',
            value: function renderMonths() {
                var months = [];
                var firstDayOfWeek = $544ec56b14d7f518$var$Helpers.getFirstDayOfWeekFromProps(this.props);
                for(var i = 0; i < this.props.numberOfMonths; i += 1){
                    var month = $544ec56b14d7f518$var$DateUtils.addMonths(this.state.currentMonth, i);
                    months.push($544ec56b14d7f518$var$_react2.default.createElement($544ec56b14d7f518$var$_Month2.default, $544ec56b14d7f518$var$_extends({
                        key: i
                    }, this.props, {
                        month: month,
                        firstDayOfWeek: firstDayOfWeek,
                        onDayKeyDown: this.handleDayKeyDown,
                        onDayClick: this.handleDayClick
                    })));
                }
                if (this.props.reverseMonths) months.reverse();
                return months;
            }
        },
        {
            key: 'renderFooter',
            value: function renderFooter() {
                if (this.props.todayButton) return $544ec56b14d7f518$var$_react2.default.createElement('div', {
                    className: this.props.classNames.footer
                }, this.renderTodayButton());
                return null;
            }
        },
        {
            key: 'renderTodayButton',
            value: function renderTodayButton() {
                return $544ec56b14d7f518$var$_react2.default.createElement('button', {
                    type: 'button',
                    tabIndex: 0,
                    className: this.props.classNames.todayButton,
                    'aria-label': this.props.todayButton,
                    onClick: this.handleTodayButtonClick
                }, this.props.todayButton);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var className = this.props.classNames.container;
                if (!this.props.onDayClick) className = className + ' ' + this.props.classNames.interactionDisabled;
                if (this.props.className) className = className + ' ' + this.props.className;
                return $544ec56b14d7f518$var$_react2.default.createElement('div', $544ec56b14d7f518$var$_extends({}, this.props.containerProps, {
                    className: className,
                    ref: function ref(el) {
                        return _this7.dayPicker = el;
                    },
                    lang: this.props.locale
                }), $544ec56b14d7f518$var$_react2.default.createElement('div', {
                    className: this.props.classNames.wrapper,
                    ref: function ref(el) {
                        return _this7.wrapper = el;
                    },
                    tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
                    onKeyDown: this.handleKeyDown,
                    onFocus: this.props.onFocus,
                    onBlur: this.props.onBlur
                }, this.renderNavbar(), $544ec56b14d7f518$var$_react2.default.createElement('div', {
                    className: this.props.classNames.months
                }, this.renderMonths()), this.renderFooter()));
            }
        }
    ]);
    return DayPicker;
}($denZA.Component);
$544ec56b14d7f518$var$DayPicker.propTypes = {
    // Rendering months
    initialMonth: $544ec56b14d7f518$var$_propTypes2.default.instanceOf(Date),
    month: $544ec56b14d7f518$var$_propTypes2.default.instanceOf(Date),
    numberOfMonths: $544ec56b14d7f518$var$_propTypes2.default.number,
    fromMonth: $544ec56b14d7f518$var$_propTypes2.default.instanceOf(Date),
    toMonth: $544ec56b14d7f518$var$_propTypes2.default.instanceOf(Date),
    canChangeMonth: $544ec56b14d7f518$var$_propTypes2.default.bool,
    reverseMonths: $544ec56b14d7f518$var$_propTypes2.default.bool,
    pagedNavigation: $544ec56b14d7f518$var$_propTypes2.default.bool,
    todayButton: $544ec56b14d7f518$var$_propTypes2.default.string,
    showWeekNumbers: $544ec56b14d7f518$var$_propTypes2.default.bool,
    showWeekDays: $544ec56b14d7f518$var$_propTypes2.default.bool,
    // Modifiers
    selectedDays: $544ec56b14d7f518$var$_propTypes2.default.oneOfType([
        $544ec56b14d7f518$var$_propTypes2.default.object,
        $544ec56b14d7f518$var$_propTypes2.default.func,
        $544ec56b14d7f518$var$_propTypes2.default.array
    ]),
    disabledDays: $544ec56b14d7f518$var$_propTypes2.default.oneOfType([
        $544ec56b14d7f518$var$_propTypes2.default.object,
        $544ec56b14d7f518$var$_propTypes2.default.func,
        $544ec56b14d7f518$var$_propTypes2.default.array
    ]),
    modifiers: $544ec56b14d7f518$var$_propTypes2.default.object,
    modifiersStyles: $544ec56b14d7f518$var$_propTypes2.default.object,
    // Localization
    dir: $544ec56b14d7f518$var$_propTypes2.default.string,
    firstDayOfWeek: $544ec56b14d7f518$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    labels: $544ec56b14d7f518$var$_propTypes2.default.shape({
        nextMonth: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        previousMonth: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired
    }),
    locale: $544ec56b14d7f518$var$_propTypes2.default.string,
    localeUtils: $544ec56b14d7f518$var$_propTypes2.default.shape({
        formatMonthTitle: $544ec56b14d7f518$var$_propTypes2.default.func,
        formatWeekdayShort: $544ec56b14d7f518$var$_propTypes2.default.func,
        formatWeekdayLong: $544ec56b14d7f518$var$_propTypes2.default.func,
        getFirstDayOfWeek: $544ec56b14d7f518$var$_propTypes2.default.func
    }),
    months: $544ec56b14d7f518$var$_propTypes2.default.arrayOf($544ec56b14d7f518$var$_propTypes2.default.string),
    weekdaysLong: $544ec56b14d7f518$var$_propTypes2.default.arrayOf($544ec56b14d7f518$var$_propTypes2.default.string),
    weekdaysShort: $544ec56b14d7f518$var$_propTypes2.default.arrayOf($544ec56b14d7f518$var$_propTypes2.default.string),
    // Customization
    showOutsideDays: $544ec56b14d7f518$var$_propTypes2.default.bool,
    enableOutsideDaysClick: $544ec56b14d7f518$var$_propTypes2.default.bool,
    fixedWeeks: $544ec56b14d7f518$var$_propTypes2.default.bool,
    // CSS and HTML
    classNames: $544ec56b14d7f518$var$_propTypes2.default.shape({
        body: $544ec56b14d7f518$var$_propTypes2.default.string,
        container: $544ec56b14d7f518$var$_propTypes2.default.string,
        day: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        disabled: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        footer: $544ec56b14d7f518$var$_propTypes2.default.string,
        interactionDisabled: $544ec56b14d7f518$var$_propTypes2.default.string,
        months: $544ec56b14d7f518$var$_propTypes2.default.string,
        month: $544ec56b14d7f518$var$_propTypes2.default.string,
        navBar: $544ec56b14d7f518$var$_propTypes2.default.string,
        outside: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        selected: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        today: $544ec56b14d7f518$var$_propTypes2.default.string.isRequired,
        todayButton: $544ec56b14d7f518$var$_propTypes2.default.string,
        week: $544ec56b14d7f518$var$_propTypes2.default.string,
        wrapper: $544ec56b14d7f518$var$_propTypes2.default.string
    }),
    className: $544ec56b14d7f518$var$_propTypes2.default.string,
    containerProps: $544ec56b14d7f518$var$_propTypes2.default.object,
    tabIndex: $544ec56b14d7f518$var$_propTypes2.default.number,
    // Custom elements
    renderDay: $544ec56b14d7f518$var$_propTypes2.default.func,
    renderWeek: $544ec56b14d7f518$var$_propTypes2.default.func,
    weekdayElement: $544ec56b14d7f518$var$_propTypes2.default.oneOfType([
        $544ec56b14d7f518$var$_propTypes2.default.element,
        $544ec56b14d7f518$var$_propTypes2.default.func,
        $544ec56b14d7f518$var$_propTypes2.default.instanceOf($denZA.Component)
    ]),
    navbarElement: $544ec56b14d7f518$var$_propTypes2.default.oneOfType([
        $544ec56b14d7f518$var$_propTypes2.default.element,
        $544ec56b14d7f518$var$_propTypes2.default.func,
        $544ec56b14d7f518$var$_propTypes2.default.instanceOf($denZA.Component)
    ]),
    captionElement: $544ec56b14d7f518$var$_propTypes2.default.oneOfType([
        $544ec56b14d7f518$var$_propTypes2.default.element,
        $544ec56b14d7f518$var$_propTypes2.default.func,
        $544ec56b14d7f518$var$_propTypes2.default.instanceOf($denZA.Component)
    ]),
    // Events
    onBlur: $544ec56b14d7f518$var$_propTypes2.default.func,
    onFocus: $544ec56b14d7f518$var$_propTypes2.default.func,
    onKeyDown: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayClick: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayKeyDown: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayMouseEnter: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayMouseLeave: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayMouseDown: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayMouseUp: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayTouchStart: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayTouchEnd: $544ec56b14d7f518$var$_propTypes2.default.func,
    onDayFocus: $544ec56b14d7f518$var$_propTypes2.default.func,
    onMonthChange: $544ec56b14d7f518$var$_propTypes2.default.func,
    onCaptionClick: $544ec56b14d7f518$var$_propTypes2.default.func,
    onWeekClick: $544ec56b14d7f518$var$_propTypes2.default.func,
    onTodayButtonClick: $544ec56b14d7f518$var$_propTypes2.default.func
};
$544ec56b14d7f518$var$DayPicker.defaultProps = {
    classNames: $544ec56b14d7f518$var$_classNames2.default,
    tabIndex: 0,
    numberOfMonths: 1,
    labels: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month'
    },
    locale: 'en',
    localeUtils: $544ec56b14d7f518$var$LocaleUtils,
    showOutsideDays: false,
    enableOutsideDaysClick: true,
    fixedWeeks: false,
    canChangeMonth: true,
    reverseMonths: false,
    pagedNavigation: false,
    showWeekNumbers: false,
    showWeekDays: true,
    renderDay: function renderDay(day) {
        return day.getDate();
    },
    renderWeek: function renderWeek(weekNumber) {
        return weekNumber;
    },
    weekdayElement: $544ec56b14d7f518$var$_react2.default.createElement($544ec56b14d7f518$var$_Weekday2.default, null),
    navbarElement: $544ec56b14d7f518$var$_react2.default.createElement($544ec56b14d7f518$var$_Navbar2.default, {
        classNames: $544ec56b14d7f518$var$_classNames2.default
    }),
    captionElement: $544ec56b14d7f518$var$_react2.default.createElement($544ec56b14d7f518$var$_Caption2.default, {
        classNames: $544ec56b14d7f518$var$_classNames2.default
    })
};
$544ec56b14d7f518$var$DayPicker.VERSION = '7.4.8';
$544ec56b14d7f518$var$DayPicker.DateUtils = $544ec56b14d7f518$var$DateUtils;
$544ec56b14d7f518$var$DayPicker.LocaleUtils = $544ec56b14d7f518$var$LocaleUtils;
$544ec56b14d7f518$var$DayPicker.ModifiersUtils = $544ec56b14d7f518$var$ModifiersUtils;
module.exports.DateUtils = $544ec56b14d7f518$var$DateUtils;
module.exports.LocaleUtils = $544ec56b14d7f518$var$LocaleUtils;
module.exports.ModifiersUtils = $544ec56b14d7f518$var$ModifiersUtils;
module.exports.default = $544ec56b14d7f518$var$DayPicker;

});
parcelRegister("i30IP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d239112fff30fee8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $d239112fff30fee8$var$_react2 = $d239112fff30fee8$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $d239112fff30fee8$var$_propTypes2 = $d239112fff30fee8$var$_interopRequireDefault($cvFNP);

var $1BThc = parcelRequire("1BThc");
var $d239112fff30fee8$var$_LocaleUtils2 = $d239112fff30fee8$var$_interopRequireDefault($1BThc);

var $7yR5m = parcelRequire("7yR5m");
function $d239112fff30fee8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d239112fff30fee8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d239112fff30fee8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d239112fff30fee8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d239112fff30fee8$var$Caption = function(_Component) {
    $d239112fff30fee8$var$_inherits(Caption, _Component);
    function Caption(props) {
        $d239112fff30fee8$var$_classCallCheck(this, Caption);
        var _this = $d239112fff30fee8$var$_possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        return _this;
    }
    $d239112fff30fee8$var$_createClass(Caption, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
            }
        },
        {
            key: 'handleKeyUp',
            value: function handleKeyUp(e) {
                if (e.keyCode === $7yR5m.ENTER) this.props.onClick(e);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, date = _props.date, months = _props.months, locale = _props.locale, localeUtils = _props.localeUtils, onClick = _props.onClick;
                return $d239112fff30fee8$var$_react2.default.createElement('div', {
                    className: classNames.caption,
                    role: 'heading'
                }, $d239112fff30fee8$var$_react2.default.createElement('div', {
                    onClick: onClick,
                    onKeyUp: this.handleKeyUp
                }, months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
            }
        }
    ]);
    return Caption;
}($denZA.Component);
$d239112fff30fee8$var$Caption.propTypes = {
    date: $d239112fff30fee8$var$_propTypes2.default.instanceOf(Date),
    months: $d239112fff30fee8$var$_propTypes2.default.arrayOf($d239112fff30fee8$var$_propTypes2.default.string),
    locale: $d239112fff30fee8$var$_propTypes2.default.string,
    localeUtils: $d239112fff30fee8$var$_propTypes2.default.object,
    onClick: $d239112fff30fee8$var$_propTypes2.default.func,
    classNames: $d239112fff30fee8$var$_propTypes2.default.shape({
        caption: $d239112fff30fee8$var$_propTypes2.default.string.isRequired
    }).isRequired
};
$d239112fff30fee8$var$Caption.defaultProps = {
    localeUtils: $d239112fff30fee8$var$_LocaleUtils2.default
};
module.exports.default = $d239112fff30fee8$var$Caption;

});
parcelRegister("1BThc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDay = $12c41fe6631b15ae$var$formatDay;
module.exports.formatMonthTitle = $12c41fe6631b15ae$var$formatMonthTitle;
module.exports.formatWeekdayShort = $12c41fe6631b15ae$var$formatWeekdayShort;
module.exports.formatWeekdayLong = $12c41fe6631b15ae$var$formatWeekdayLong;
module.exports.getFirstDayOfWeek = $12c41fe6631b15ae$var$getFirstDayOfWeek;
module.exports.getMonths = $12c41fe6631b15ae$var$getMonths;
var $12c41fe6631b15ae$var$WEEKDAYS_LONG = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
var $12c41fe6631b15ae$var$WEEKDAYS_SHORT = [
    'Su',
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa'
];
var $12c41fe6631b15ae$var$MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
function $12c41fe6631b15ae$var$formatDay(day) {
    return day.toDateString();
}
function $12c41fe6631b15ae$var$formatMonthTitle(d) {
    return $12c41fe6631b15ae$var$MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}
function $12c41fe6631b15ae$var$formatWeekdayShort(i) {
    return $12c41fe6631b15ae$var$WEEKDAYS_SHORT[i];
}
function $12c41fe6631b15ae$var$formatWeekdayLong(i) {
    return $12c41fe6631b15ae$var$WEEKDAYS_LONG[i];
}
function $12c41fe6631b15ae$var$getFirstDayOfWeek() {
    return 0;
}
function $12c41fe6631b15ae$var$getMonths() {
    return $12c41fe6631b15ae$var$MONTHS;
}
module.exports.default = {
    formatDay: $12c41fe6631b15ae$var$formatDay,
    formatMonthTitle: $12c41fe6631b15ae$var$formatMonthTitle,
    formatWeekdayShort: $12c41fe6631b15ae$var$formatWeekdayShort,
    formatWeekdayLong: $12c41fe6631b15ae$var$formatWeekdayLong,
    getFirstDayOfWeek: $12c41fe6631b15ae$var$getFirstDayOfWeek,
    getMonths: $12c41fe6631b15ae$var$getMonths
};

});

parcelRegister("7yR5m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5814e30e3b09fa20$var$LEFT = module.exports.LEFT = 37;
var $5814e30e3b09fa20$var$UP = module.exports.UP = 38;
var $5814e30e3b09fa20$var$RIGHT = module.exports.RIGHT = 39;
var $5814e30e3b09fa20$var$DOWN = module.exports.DOWN = 40;
var $5814e30e3b09fa20$var$ENTER = module.exports.ENTER = 13;
var $5814e30e3b09fa20$var$SPACE = module.exports.SPACE = 32;
var $5814e30e3b09fa20$var$ESC = module.exports.ESC = 27;
var $5814e30e3b09fa20$var$TAB = module.exports.TAB = 9;

});


parcelRegister("19KKq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0d7ae4d6e9583bde$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $0d7ae4d6e9583bde$var$_react2 = $0d7ae4d6e9583bde$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $0d7ae4d6e9583bde$var$_propTypes2 = $0d7ae4d6e9583bde$var$_interopRequireDefault($cvFNP);

var $cwLUT = parcelRequire("cwLUT");
var $0d7ae4d6e9583bde$var$_classNames2 = $0d7ae4d6e9583bde$var$_interopRequireDefault($cwLUT);

var $7yR5m = parcelRequire("7yR5m");
function $0d7ae4d6e9583bde$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d7ae4d6e9583bde$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0d7ae4d6e9583bde$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0d7ae4d6e9583bde$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0d7ae4d6e9583bde$var$Navbar = function(_Component) {
    $0d7ae4d6e9583bde$var$_inherits(Navbar, _Component);
    function Navbar() {
        var _ref;
        var _temp, _this, _ret;
        $0d7ae4d6e9583bde$var$_classCallCheck(this, Navbar);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0d7ae4d6e9583bde$var$_possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleNextClick = function() {
            if (_this.props.onNextClick) _this.props.onNextClick();
        }, _this.handlePreviousClick = function() {
            if (_this.props.onPreviousClick) _this.props.onPreviousClick();
        }, _this.handleNextKeyDown = function(e) {
            if (e.keyCode !== $7yR5m.ENTER && e.keyCode !== $7yR5m.SPACE) return;
            e.preventDefault();
            _this.handleNextClick();
        }, _this.handlePreviousKeyDown = function(e) {
            if (e.keyCode !== $7yR5m.ENTER && e.keyCode !== $7yR5m.SPACE) return;
            e.preventDefault();
            _this.handlePreviousClick();
        }, _temp), $0d7ae4d6e9583bde$var$_possibleConstructorReturn(_this, _ret);
    }
    $0d7ae4d6e9583bde$var$_createClass(Navbar, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, className = _props.className, showPreviousButton = _props.showPreviousButton, showNextButton = _props.showNextButton, labels = _props.labels, dir = _props.dir;
                var previousClickHandler = void 0;
                var nextClickHandler = void 0;
                var previousKeyDownHandler = void 0;
                var nextKeyDownHandler = void 0;
                var shouldShowPrevious = void 0;
                var shouldShowNext = void 0;
                if (dir === 'rtl') {
                    previousClickHandler = this.handleNextClick;
                    nextClickHandler = this.handlePreviousClick;
                    previousKeyDownHandler = this.handleNextKeyDown;
                    nextKeyDownHandler = this.handlePreviousKeyDown;
                    shouldShowNext = showPreviousButton;
                    shouldShowPrevious = showNextButton;
                } else {
                    previousClickHandler = this.handlePreviousClick;
                    nextClickHandler = this.handleNextClick;
                    previousKeyDownHandler = this.handlePreviousKeyDown;
                    nextKeyDownHandler = this.handleNextKeyDown;
                    shouldShowNext = showNextButton;
                    shouldShowPrevious = showPreviousButton;
                }
                var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
                var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;
                var previousButton = $0d7ae4d6e9583bde$var$_react2.default.createElement('span', {
                    tabIndex: '0',
                    role: 'button',
                    'aria-label': labels.previousMonth,
                    key: 'previous',
                    className: previousClassName,
                    onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
                    onClick: shouldShowPrevious ? previousClickHandler : undefined
                });
                var nextButton = $0d7ae4d6e9583bde$var$_react2.default.createElement('span', {
                    tabIndex: '0',
                    role: 'button',
                    'aria-label': labels.nextMonth,
                    key: 'right',
                    className: nextClassName,
                    onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
                    onClick: shouldShowNext ? nextClickHandler : undefined
                });
                return $0d7ae4d6e9583bde$var$_react2.default.createElement('div', {
                    className: className || classNames.navBar
                }, dir === 'rtl' ? [
                    nextButton,
                    previousButton
                ] : [
                    previousButton,
                    nextButton
                ]);
            }
        }
    ]);
    return Navbar;
}($denZA.Component);
$0d7ae4d6e9583bde$var$Navbar.propTypes = {
    classNames: $0d7ae4d6e9583bde$var$_propTypes2.default.shape({
        navBar: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired,
        navButtonPrev: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired,
        navButtonNext: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired,
        navButtonInteractionDisabled: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired
    }),
    className: $0d7ae4d6e9583bde$var$_propTypes2.default.string,
    showPreviousButton: $0d7ae4d6e9583bde$var$_propTypes2.default.bool,
    showNextButton: $0d7ae4d6e9583bde$var$_propTypes2.default.bool,
    onPreviousClick: $0d7ae4d6e9583bde$var$_propTypes2.default.func,
    onNextClick: $0d7ae4d6e9583bde$var$_propTypes2.default.func,
    dir: $0d7ae4d6e9583bde$var$_propTypes2.default.string,
    labels: $0d7ae4d6e9583bde$var$_propTypes2.default.shape({
        previousMonth: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired,
        nextMonth: $0d7ae4d6e9583bde$var$_propTypes2.default.string.isRequired
    })
};
$0d7ae4d6e9583bde$var$Navbar.defaultProps = {
    classNames: $0d7ae4d6e9583bde$var$_classNames2.default,
    dir: 'ltr',
    labels: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month'
    },
    showPreviousButton: true,
    showNextButton: true
};
module.exports.default = $0d7ae4d6e9583bde$var$Navbar;

});
parcelRegister("cwLUT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Proxy object to map classnames when css modules are not used
module.exports.default = {
    container: 'DayPicker',
    wrapper: 'DayPicker-wrapper',
    interactionDisabled: 'DayPicker--interactionDisabled',
    months: 'DayPicker-Months',
    month: 'DayPicker-Month',
    navBar: 'DayPicker-NavBar',
    navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
    navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
    navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
    caption: 'DayPicker-Caption',
    weekdays: 'DayPicker-Weekdays',
    weekdaysRow: 'DayPicker-WeekdaysRow',
    weekday: 'DayPicker-Weekday',
    body: 'DayPicker-Body',
    week: 'DayPicker-Week',
    weekNumber: 'DayPicker-WeekNumber',
    day: 'DayPicker-Day',
    footer: 'DayPicker-Footer',
    todayButton: 'DayPicker-TodayButton',
    // default modifiers
    today: 'today',
    selected: 'selected',
    disabled: 'disabled',
    outside: 'outside'
};

});


parcelRegister("2qQ4T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1c566814e08b7cf7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $1c566814e08b7cf7$var$_react2 = $1c566814e08b7cf7$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $1c566814e08b7cf7$var$_propTypes2 = $1c566814e08b7cf7$var$_interopRequireDefault($cvFNP);

var $9VKQz = parcelRequire("9VKQz");
var $1c566814e08b7cf7$var$_Weekdays2 = $1c566814e08b7cf7$var$_interopRequireDefault($9VKQz);

var $5ls0z = parcelRequire("5ls0z");
var $1c566814e08b7cf7$var$_Day2 = $1c566814e08b7cf7$var$_interopRequireDefault($5ls0z);

var $7yR5m = parcelRequire("7yR5m");

var $dF5u6 = parcelRequire("dF5u6");
var $1c566814e08b7cf7$var$ModifiersUtils = $1c566814e08b7cf7$var$_interopRequireWildcard($dF5u6);

var $g4lke = parcelRequire("g4lke");
var $1c566814e08b7cf7$var$Helpers = $1c566814e08b7cf7$var$_interopRequireWildcard($g4lke);

var $9hsGH = parcelRequire("9hsGH");
var $1c566814e08b7cf7$var$DateUtils = $1c566814e08b7cf7$var$_interopRequireWildcard($9hsGH);
function $1c566814e08b7cf7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1c566814e08b7cf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c566814e08b7cf7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c566814e08b7cf7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1c566814e08b7cf7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1c566814e08b7cf7$var$Month = function(_Component) {
    $1c566814e08b7cf7$var$_inherits(Month, _Component);
    function Month() {
        var _ref;
        var _temp, _this, _ret;
        $1c566814e08b7cf7$var$_classCallCheck(this, Month);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1c566814e08b7cf7$var$_possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.renderDay = function(day) {
            var monthNumber = _this.props.month.getMonth();
            var propModifiers = $1c566814e08b7cf7$var$Helpers.getModifiersFromProps(_this.props);
            var dayModifiers = $1c566814e08b7cf7$var$ModifiersUtils.getModifiersForDay(day, propModifiers);
            if ($1c566814e08b7cf7$var$DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) dayModifiers.push(_this.props.classNames.today);
            if (day.getMonth() !== monthNumber) dayModifiers.push(_this.props.classNames.outside);
            var isOutside = day.getMonth() !== monthNumber;
            var tabIndex = -1;
            // Focus on the first day of the month
            if (_this.props.onDayClick && !isOutside && day.getDate() === 1) tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
            var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
            var modifiers = {};
            dayModifiers.forEach(function(modifier) {
                modifiers[modifier] = true;
            });
            return $1c566814e08b7cf7$var$_react2.default.createElement($1c566814e08b7cf7$var$_Day2.default, {
                key: '' + (isOutside ? 'outside-' : '') + key,
                classNames: _this.props.classNames,
                day: day,
                modifiers: modifiers,
                modifiersStyles: _this.props.modifiersStyles,
                empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
                tabIndex: tabIndex,
                ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
                ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
                ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
                onClick: _this.props.onDayClick,
                onFocus: _this.props.onDayFocus,
                onKeyDown: _this.props.onDayKeyDown,
                onMouseEnter: _this.props.onDayMouseEnter,
                onMouseLeave: _this.props.onDayMouseLeave,
                onMouseDown: _this.props.onDayMouseDown,
                onMouseUp: _this.props.onDayMouseUp,
                onTouchEnd: _this.props.onDayTouchEnd,
                onTouchStart: _this.props.onDayTouchStart
            }, _this.props.renderDay(day, modifiers));
        }, _temp), $1c566814e08b7cf7$var$_possibleConstructorReturn(_this, _ret);
    }
    $1c566814e08b7cf7$var$_createClass(Month, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, classNames = _props.classNames, month = _props.month, months = _props.months, fixedWeeks = _props.fixedWeeks, captionElement = _props.captionElement, weekdayElement = _props.weekdayElement, locale = _props.locale, localeUtils = _props.localeUtils, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, firstDayOfWeek = _props.firstDayOfWeek, onCaptionClick = _props.onCaptionClick, showWeekNumbers = _props.showWeekNumbers, showWeekDays = _props.showWeekDays, onWeekClick = _props.onWeekClick;
                var captionProps = {
                    date: month,
                    classNames: classNames,
                    months: months,
                    localeUtils: localeUtils,
                    locale: locale,
                    onClick: onCaptionClick ? function(e) {
                        return onCaptionClick(month, e);
                    } : undefined
                };
                var caption = $1c566814e08b7cf7$var$_react2.default.isValidElement(captionElement) ? $1c566814e08b7cf7$var$_react2.default.cloneElement(captionElement, captionProps) : $1c566814e08b7cf7$var$_react2.default.createElement(captionElement, captionProps);
                var weeks = $1c566814e08b7cf7$var$Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
                return $1c566814e08b7cf7$var$_react2.default.createElement('div', {
                    className: classNames.month,
                    role: 'grid'
                }, caption, showWeekDays && $1c566814e08b7cf7$var$_react2.default.createElement($1c566814e08b7cf7$var$_Weekdays2.default, {
                    classNames: classNames,
                    weekdaysShort: weekdaysShort,
                    weekdaysLong: weekdaysLong,
                    firstDayOfWeek: firstDayOfWeek,
                    showWeekNumbers: showWeekNumbers,
                    locale: locale,
                    localeUtils: localeUtils,
                    weekdayElement: weekdayElement
                }), $1c566814e08b7cf7$var$_react2.default.createElement('div', {
                    className: classNames.body,
                    role: 'rowgroup'
                }, weeks.map(function(week) {
                    var weekNumber = void 0;
                    if (showWeekNumbers) weekNumber = $1c566814e08b7cf7$var$DateUtils.getWeekNumber(week[6]);
                    return $1c566814e08b7cf7$var$_react2.default.createElement('div', {
                        key: week[0].getTime(),
                        className: classNames.week,
                        role: 'row'
                    }, showWeekNumbers && $1c566814e08b7cf7$var$_react2.default.createElement('div', {
                        className: classNames.weekNumber,
                        tabIndex: onWeekClick ? 0 : -1,
                        role: 'gridcell',
                        onClick: onWeekClick ? function(e) {
                            return onWeekClick(weekNumber, week, e);
                        } : undefined,
                        onKeyUp: onWeekClick ? function(e) {
                            return e.keyCode === $7yR5m.ENTER && onWeekClick(weekNumber, week, e);
                        } : undefined
                    }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
                })));
            }
        }
    ]);
    return Month;
}($denZA.Component);
$1c566814e08b7cf7$var$Month.propTypes = {
    classNames: $1c566814e08b7cf7$var$_propTypes2.default.shape({
        body: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        month: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        outside: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        today: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        week: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        weekNumber: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        disabled: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
        selected: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired
    }).isRequired,
    tabIndex: $1c566814e08b7cf7$var$_propTypes2.default.number,
    month: $1c566814e08b7cf7$var$_propTypes2.default.instanceOf(Date).isRequired,
    months: $1c566814e08b7cf7$var$_propTypes2.default.arrayOf($1c566814e08b7cf7$var$_propTypes2.default.string),
    modifiersStyles: $1c566814e08b7cf7$var$_propTypes2.default.object,
    showWeekDays: $1c566814e08b7cf7$var$_propTypes2.default.bool,
    showOutsideDays: $1c566814e08b7cf7$var$_propTypes2.default.bool,
    renderDay: $1c566814e08b7cf7$var$_propTypes2.default.func.isRequired,
    renderWeek: $1c566814e08b7cf7$var$_propTypes2.default.func.isRequired,
    captionElement: $1c566814e08b7cf7$var$_propTypes2.default.oneOfType([
        $1c566814e08b7cf7$var$_propTypes2.default.element,
        $1c566814e08b7cf7$var$_propTypes2.default.func,
        $1c566814e08b7cf7$var$_propTypes2.default.instanceOf($1c566814e08b7cf7$var$_react2.default.Component)
    ]).isRequired,
    weekdayElement: $1c566814e08b7cf7$var$_propTypes2.default.oneOfType([
        $1c566814e08b7cf7$var$_propTypes2.default.element,
        $1c566814e08b7cf7$var$_propTypes2.default.func,
        $1c566814e08b7cf7$var$_propTypes2.default.instanceOf($1c566814e08b7cf7$var$_react2.default.Component)
    ]),
    fixedWeeks: $1c566814e08b7cf7$var$_propTypes2.default.bool,
    showWeekNumbers: $1c566814e08b7cf7$var$_propTypes2.default.bool,
    locale: $1c566814e08b7cf7$var$_propTypes2.default.string.isRequired,
    localeUtils: $1c566814e08b7cf7$var$_propTypes2.default.object.isRequired,
    weekdaysLong: $1c566814e08b7cf7$var$_propTypes2.default.arrayOf($1c566814e08b7cf7$var$_propTypes2.default.string),
    weekdaysShort: $1c566814e08b7cf7$var$_propTypes2.default.arrayOf($1c566814e08b7cf7$var$_propTypes2.default.string),
    firstDayOfWeek: $1c566814e08b7cf7$var$_propTypes2.default.number.isRequired,
    onCaptionClick: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayClick: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayFocus: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayKeyDown: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayMouseEnter: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayMouseLeave: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayMouseDown: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayMouseUp: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayTouchEnd: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onDayTouchStart: $1c566814e08b7cf7$var$_propTypes2.default.func,
    onWeekClick: $1c566814e08b7cf7$var$_propTypes2.default.func
};
module.exports.default = $1c566814e08b7cf7$var$Month;

});
parcelRegister("9VKQz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $73adc6c0634e5978$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $73adc6c0634e5978$var$_react2 = $73adc6c0634e5978$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $73adc6c0634e5978$var$_propTypes2 = $73adc6c0634e5978$var$_interopRequireDefault($cvFNP);
function $73adc6c0634e5978$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73adc6c0634e5978$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $73adc6c0634e5978$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $73adc6c0634e5978$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $73adc6c0634e5978$var$Weekdays = function(_Component) {
    $73adc6c0634e5978$var$_inherits(Weekdays, _Component);
    function Weekdays() {
        $73adc6c0634e5978$var$_classCallCheck(this, Weekdays);
        return $73adc6c0634e5978$var$_possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
    }
    $73adc6c0634e5978$var$_createClass(Weekdays, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, firstDayOfWeek = _props.firstDayOfWeek, showWeekNumbers = _props.showWeekNumbers, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, locale = _props.locale, localeUtils = _props.localeUtils, weekdayElement = _props.weekdayElement;
                var days = [];
                for(var i = 0; i < 7; i += 1){
                    var weekday = (i + firstDayOfWeek) % 7;
                    var elementProps = {
                        key: i,
                        className: classNames.weekday,
                        weekday: weekday,
                        weekdaysLong: weekdaysLong,
                        weekdaysShort: weekdaysShort,
                        localeUtils: localeUtils,
                        locale: locale
                    };
                    var element = $73adc6c0634e5978$var$_react2.default.isValidElement(weekdayElement) ? $73adc6c0634e5978$var$_react2.default.cloneElement(weekdayElement, elementProps) : $73adc6c0634e5978$var$_react2.default.createElement(weekdayElement, elementProps);
                    days.push(element);
                }
                return $73adc6c0634e5978$var$_react2.default.createElement('div', {
                    className: classNames.weekdays,
                    role: 'rowgroup'
                }, $73adc6c0634e5978$var$_react2.default.createElement('div', {
                    className: classNames.weekdaysRow,
                    role: 'row'
                }, showWeekNumbers && $73adc6c0634e5978$var$_react2.default.createElement('div', {
                    className: classNames.weekday
                }), days));
            }
        }
    ]);
    return Weekdays;
}($denZA.Component);
$73adc6c0634e5978$var$Weekdays.propTypes = {
    classNames: $73adc6c0634e5978$var$_propTypes2.default.shape({
        weekday: $73adc6c0634e5978$var$_propTypes2.default.string.isRequired,
        weekdays: $73adc6c0634e5978$var$_propTypes2.default.string.isRequired,
        weekdaysRow: $73adc6c0634e5978$var$_propTypes2.default.string.isRequired
    }).isRequired,
    firstDayOfWeek: $73adc6c0634e5978$var$_propTypes2.default.number.isRequired,
    weekdaysLong: $73adc6c0634e5978$var$_propTypes2.default.arrayOf($73adc6c0634e5978$var$_propTypes2.default.string),
    weekdaysShort: $73adc6c0634e5978$var$_propTypes2.default.arrayOf($73adc6c0634e5978$var$_propTypes2.default.string),
    showWeekNumbers: $73adc6c0634e5978$var$_propTypes2.default.bool,
    locale: $73adc6c0634e5978$var$_propTypes2.default.string.isRequired,
    localeUtils: $73adc6c0634e5978$var$_propTypes2.default.object.isRequired,
    weekdayElement: $73adc6c0634e5978$var$_propTypes2.default.oneOfType([
        $73adc6c0634e5978$var$_propTypes2.default.element,
        $73adc6c0634e5978$var$_propTypes2.default.func,
        $73adc6c0634e5978$var$_propTypes2.default.instanceOf($73adc6c0634e5978$var$_react2.default.Component)
    ])
};
module.exports.default = $73adc6c0634e5978$var$Weekdays;

});

parcelRegister("5ls0z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3e44a3c12d7e8db7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3e44a3c12d7e8db7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $3e44a3c12d7e8db7$var$_react2 = $3e44a3c12d7e8db7$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $3e44a3c12d7e8db7$var$_propTypes2 = $3e44a3c12d7e8db7$var$_interopRequireDefault($cvFNP);

var $9hsGH = parcelRequire("9hsGH");

var $g4lke = parcelRequire("g4lke");

var $cwLUT = parcelRequire("cwLUT");
var $3e44a3c12d7e8db7$var$_classNames2 = $3e44a3c12d7e8db7$var$_interopRequireDefault($cwLUT);
function $3e44a3c12d7e8db7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e44a3c12d7e8db7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e44a3c12d7e8db7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3e44a3c12d7e8db7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */ 
function $3e44a3c12d7e8db7$var$handleEvent(handler, day, modifiers) {
    if (!handler) return undefined;
    return function(e) {
        e.persist();
        handler(day, modifiers, e);
    };
}
var $3e44a3c12d7e8db7$var$Day = function(_Component) {
    $3e44a3c12d7e8db7$var$_inherits(Day, _Component);
    function Day() {
        $3e44a3c12d7e8db7$var$_classCallCheck(this, Day);
        return $3e44a3c12d7e8db7$var$_possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
    }
    $3e44a3c12d7e8db7$var$_createClass(Day, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                var propNames = Object.keys(this.props);
                var nextPropNames = Object.keys(nextProps);
                if (propNames.length !== nextPropNames.length) return true;
                return propNames.some(function(name) {
                    if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
                        var prop = _this2.props[name];
                        var nextProp = nextProps[name];
                        var modifiers = Object.keys(prop);
                        var nextModifiers = Object.keys(nextProp);
                        if (modifiers.length !== nextModifiers.length) return true;
                        return modifiers.some(function(mod) {
                            return !(0, $g4lke.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
                        });
                    }
                    if (name === 'day') return !(0, $9hsGH.isSameDay)(_this2.props[name], nextProps[name]);
                    return !(0, $g4lke.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, classNames = _props.classNames, modifiersStyles = _props.modifiersStyles, day = _props.day, tabIndex = _props.tabIndex, empty = _props.empty, modifiers = _props.modifiers, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, onMouseUp = _props.onMouseUp, onMouseDown = _props.onMouseDown, onClick = _props.onClick, onKeyDown = _props.onKeyDown, onTouchStart = _props.onTouchStart, onTouchEnd = _props.onTouchEnd, onFocus = _props.onFocus, ariaLabel = _props.ariaLabel, ariaDisabled = _props.ariaDisabled, ariaSelected = _props.ariaSelected, children = _props.children;
                var className = classNames.day;
                if (classNames !== $3e44a3c12d7e8db7$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
                className += ' ' + Object.keys(modifiers).join(' ');
                else className += Object.keys(modifiers).map(function(modifier) {
                    return ' ' + className + '--' + modifier;
                }).join('');
                var style = void 0;
                if (modifiersStyles) Object.keys(modifiers).filter(function(modifier) {
                    return !!modifiersStyles[modifier];
                }).forEach(function(modifier) {
                    style = $3e44a3c12d7e8db7$var$_extends({}, style, modifiersStyles[modifier]);
                });
                if (empty) return $3e44a3c12d7e8db7$var$_react2.default.createElement('div', {
                    'aria-disabled': true,
                    className: className,
                    style: style
                });
                return $3e44a3c12d7e8db7$var$_react2.default.createElement('div', {
                    className: className,
                    tabIndex: tabIndex,
                    style: style,
                    role: 'gridcell',
                    'aria-label': ariaLabel,
                    'aria-disabled': ariaDisabled,
                    'aria-selected': ariaSelected,
                    onClick: $3e44a3c12d7e8db7$var$handleEvent(onClick, day, modifiers),
                    onKeyDown: $3e44a3c12d7e8db7$var$handleEvent(onKeyDown, day, modifiers),
                    onMouseEnter: $3e44a3c12d7e8db7$var$handleEvent(onMouseEnter, day, modifiers),
                    onMouseLeave: $3e44a3c12d7e8db7$var$handleEvent(onMouseLeave, day, modifiers),
                    onMouseUp: $3e44a3c12d7e8db7$var$handleEvent(onMouseUp, day, modifiers),
                    onMouseDown: $3e44a3c12d7e8db7$var$handleEvent(onMouseDown, day, modifiers),
                    onTouchEnd: $3e44a3c12d7e8db7$var$handleEvent(onTouchEnd, day, modifiers),
                    onTouchStart: $3e44a3c12d7e8db7$var$handleEvent(onTouchStart, day, modifiers),
                    onFocus: $3e44a3c12d7e8db7$var$handleEvent(onFocus, day, modifiers)
                }, children);
            }
        }
    ]);
    return Day;
}($denZA.Component);
$3e44a3c12d7e8db7$var$Day.propTypes = {
    classNames: $3e44a3c12d7e8db7$var$_propTypes2.default.shape({
        day: $3e44a3c12d7e8db7$var$_propTypes2.default.string.isRequired
    }).isRequired,
    day: $3e44a3c12d7e8db7$var$_propTypes2.default.instanceOf(Date).isRequired,
    children: $3e44a3c12d7e8db7$var$_propTypes2.default.node.isRequired,
    ariaDisabled: $3e44a3c12d7e8db7$var$_propTypes2.default.bool,
    ariaLabel: $3e44a3c12d7e8db7$var$_propTypes2.default.string,
    ariaSelected: $3e44a3c12d7e8db7$var$_propTypes2.default.bool,
    empty: $3e44a3c12d7e8db7$var$_propTypes2.default.bool,
    modifiers: $3e44a3c12d7e8db7$var$_propTypes2.default.object,
    modifiersStyles: $3e44a3c12d7e8db7$var$_propTypes2.default.object,
    onClick: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onKeyDown: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onMouseEnter: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onMouseLeave: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onMouseDown: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onMouseUp: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onTouchEnd: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onTouchStart: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    onFocus: $3e44a3c12d7e8db7$var$_propTypes2.default.func,
    tabIndex: $3e44a3c12d7e8db7$var$_propTypes2.default.number
};
$3e44a3c12d7e8db7$var$Day.defaultProps = {
    tabIndex: -1
};
$3e44a3c12d7e8db7$var$Day.defaultProps = {
    modifiers: {},
    modifiersStyles: {},
    empty: false
};
module.exports.default = $3e44a3c12d7e8db7$var$Day;

});
parcelRegister("9hsGH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = $6c1bf461ca402526$var$clone;
module.exports.isDate = $6c1bf461ca402526$var$isDate;
module.exports.addMonths = $6c1bf461ca402526$var$addMonths;
module.exports.isSameDay = $6c1bf461ca402526$var$isSameDay;
module.exports.isSameMonth = $6c1bf461ca402526$var$isSameMonth;
module.exports.isDayBefore = $6c1bf461ca402526$var$isDayBefore;
module.exports.isDayAfter = $6c1bf461ca402526$var$isDayAfter;
module.exports.isPastDay = $6c1bf461ca402526$var$isPastDay;
module.exports.isFutureDay = $6c1bf461ca402526$var$isFutureDay;
module.exports.isDayBetween = $6c1bf461ca402526$var$isDayBetween;
module.exports.addDayToRange = $6c1bf461ca402526$var$addDayToRange;
module.exports.isDayInRange = $6c1bf461ca402526$var$isDayInRange;
module.exports.getWeekNumber = $6c1bf461ca402526$var$getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */ function $6c1bf461ca402526$var$clone(d) {
    return new Date(d.getTime());
}
/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */ function $6c1bf461ca402526$var$isDate(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */ function $6c1bf461ca402526$var$addMonths(d, n) {
    var newDate = $6c1bf461ca402526$var$clone(d);
    newDate.setMonth(d.getMonth() + n);
    return newDate;
}
/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isSameDay(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isSameMonth(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}
/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $6c1bf461ca402526$var$isDayBefore(d1, d2) {
    var day1 = $6c1bf461ca402526$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $6c1bf461ca402526$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 < day2;
}
/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */ function $6c1bf461ca402526$var$isDayAfter(d1, d2) {
    var day1 = $6c1bf461ca402526$var$clone(d1).setHours(0, 0, 0, 0);
    var day2 = $6c1bf461ca402526$var$clone(d2).setHours(0, 0, 0, 0);
    return day1 > day2;
}
/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isPastDay(d) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return $6c1bf461ca402526$var$isDayBefore(d, today);
}
/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isFutureDay(d) {
    var tomorrow = new Date(new Date().getTime() + 86400000);
    tomorrow.setHours(0, 0, 0, 0);
    return d >= tomorrow;
}
/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isDayBetween(d, d1, d2) {
    var date = $6c1bf461ca402526$var$clone(d);
    date.setHours(0, 0, 0, 0);
    return $6c1bf461ca402526$var$isDayAfter(date, d1) && $6c1bf461ca402526$var$isDayBefore(date, d2) || $6c1bf461ca402526$var$isDayAfter(date, d2) && $6c1bf461ca402526$var$isDayBefore(date, d1);
}
/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */ function $6c1bf461ca402526$var$addDayToRange(day) {
    var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        from: null,
        to: null
    };
    var from = range.from, to = range.to;
    if (!from) from = day;
    else if (from && to && $6c1bf461ca402526$var$isSameDay(from, to) && $6c1bf461ca402526$var$isSameDay(day, from)) {
        from = null;
        to = null;
    } else if (to && $6c1bf461ca402526$var$isDayBefore(day, from)) from = day;
    else if (to && $6c1bf461ca402526$var$isSameDay(day, to)) {
        from = day;
        to = day;
    } else {
        to = day;
        if ($6c1bf461ca402526$var$isDayBefore(to, from)) {
            to = from;
            from = day;
        }
    }
    return {
        from: from,
        to: to
    };
}
/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */ function $6c1bf461ca402526$var$isDayInRange(day, range) {
    var from = range.from, to = range.to;
    return from && $6c1bf461ca402526$var$isSameDay(day, from) || to && $6c1bf461ca402526$var$isSameDay(day, to) || from && to && $6c1bf461ca402526$var$isDayBetween(day, from, to);
}
/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */ function $6c1bf461ca402526$var$getWeekNumber(day) {
    var date = $6c1bf461ca402526$var$clone(day);
    date.setHours(0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}
module.exports.default = {
    addDayToRange: $6c1bf461ca402526$var$addDayToRange,
    addMonths: $6c1bf461ca402526$var$addMonths,
    clone: $6c1bf461ca402526$var$clone,
    getWeekNumber: $6c1bf461ca402526$var$getWeekNumber,
    isDate: $6c1bf461ca402526$var$isDate,
    isDayAfter: $6c1bf461ca402526$var$isDayAfter,
    isDayBefore: $6c1bf461ca402526$var$isDayBefore,
    isDayBetween: $6c1bf461ca402526$var$isDayBetween,
    isDayInRange: $6c1bf461ca402526$var$isDayInRange,
    isFutureDay: $6c1bf461ca402526$var$isFutureDay,
    isPastDay: $6c1bf461ca402526$var$isPastDay,
    isSameDay: $6c1bf461ca402526$var$isSameDay,
    isSameMonth: $6c1bf461ca402526$var$isSameMonth
};

});

parcelRegister("g4lke", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bb2d8fd494d21f05$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.cancelEvent = $bb2d8fd494d21f05$var$cancelEvent;
module.exports.getFirstDayOfMonth = $bb2d8fd494d21f05$var$getFirstDayOfMonth;
module.exports.getDaysInMonth = $bb2d8fd494d21f05$var$getDaysInMonth;
module.exports.getModifiersFromProps = $bb2d8fd494d21f05$var$getModifiersFromProps;
module.exports.getFirstDayOfWeekFromProps = $bb2d8fd494d21f05$var$getFirstDayOfWeekFromProps;
module.exports.isRangeOfDates = $bb2d8fd494d21f05$var$isRangeOfDates;
module.exports.getMonthsDiff = $bb2d8fd494d21f05$var$getMonthsDiff;
module.exports.getWeekArray = $bb2d8fd494d21f05$var$getWeekArray;
module.exports.startOfMonth = $bb2d8fd494d21f05$var$startOfMonth;
module.exports.getDayNodes = $bb2d8fd494d21f05$var$getDayNodes;
module.exports.nodeListToArray = $bb2d8fd494d21f05$var$nodeListToArray;
module.exports.hasOwnProp = $bb2d8fd494d21f05$var$hasOwnProp;

var $9hsGH = parcelRequire("9hsGH");

var $1BThc = parcelRequire("1BThc");

var $cwLUT = parcelRequire("cwLUT");
var $bb2d8fd494d21f05$var$_classNames2 = $bb2d8fd494d21f05$var$_interopRequireDefault($cwLUT);
function $bb2d8fd494d21f05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bb2d8fd494d21f05$var$cancelEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $bb2d8fd494d21f05$var$getFirstDayOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}
function $bb2d8fd494d21f05$var$getDaysInMonth(d) {
    var resultDate = $bb2d8fd494d21f05$var$getFirstDayOfMonth(d);
    resultDate.setMonth(resultDate.getMonth() + 1);
    resultDate.setDate(resultDate.getDate() - 1);
    return resultDate.getDate();
}
function $bb2d8fd494d21f05$var$getModifiersFromProps(props) {
    var modifiers = $bb2d8fd494d21f05$var$_extends({}, props.modifiers);
    if (props.selectedDays) modifiers[props.classNames.selected] = props.selectedDays;
    if (props.disabledDays) modifiers[props.classNames.disabled] = props.disabledDays;
    return modifiers;
}
function $bb2d8fd494d21f05$var$getFirstDayOfWeekFromProps(props) {
    var firstDayOfWeek = props.firstDayOfWeek, _props$locale = props.locale, locale = _props$locale === undefined ? 'en' : _props$locale, _props$localeUtils = props.localeUtils, localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;
    if (!isNaN(firstDayOfWeek)) return firstDayOfWeek;
    if (localeUtils.getFirstDayOfWeek) return localeUtils.getFirstDayOfWeek(locale);
    return 0;
}
function $bb2d8fd494d21f05$var$isRangeOfDates(value) {
    return !!(value && value.from && value.to);
}
function $bb2d8fd494d21f05$var$getMonthsDiff(d1, d2) {
    return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}
function $bb2d8fd494d21f05$var$getWeekArray(d) {
    var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1BThc.getFirstDayOfWeek)();
    var fixedWeeks = arguments[2];
    var daysInMonth = $bb2d8fd494d21f05$var$getDaysInMonth(d);
    var dayArray = [];
    var week = [];
    var weekArray = [];
    for(var i = 1; i <= daysInMonth; i += 1)dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
    dayArray.forEach(function(day) {
        if (week.length > 0 && day.getDay() === firstDayOfWeek) {
            weekArray.push(week);
            week = [];
        }
        week.push(day);
        if (dayArray.indexOf(day) === dayArray.length - 1) weekArray.push(week);
    });
    // unshift days to start the first week
    var firstWeek = weekArray[0];
    for(var _i = 7 - firstWeek.length; _i > 0; _i -= 1){
        var outsideDate = (0, $9hsGH.clone)(firstWeek[0]);
        outsideDate.setDate(firstWeek[0].getDate() - 1);
        firstWeek.unshift(outsideDate);
    }
    // push days until the end of the last week
    var lastWeek = weekArray[weekArray.length - 1];
    for(var _i2 = lastWeek.length; _i2 < 7; _i2 += 1){
        var _outsideDate = (0, $9hsGH.clone)(lastWeek[lastWeek.length - 1]);
        _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
        lastWeek.push(_outsideDate);
    }
    // add extra weeks to reach 6 weeks
    if (fixedWeeks && weekArray.length < 6) {
        var lastExtraWeek = void 0;
        for(var _i3 = weekArray.length; _i3 < 6; _i3 += 1){
            lastExtraWeek = weekArray[weekArray.length - 1];
            var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
            var extraWeek = [];
            for(var j = 0; j < 7; j += 1){
                var _outsideDate2 = (0, $9hsGH.clone)(lastDay);
                _outsideDate2.setDate(lastDay.getDate() + j + 1);
                extraWeek.push(_outsideDate2);
            }
            weekArray.push(extraWeek);
        }
    }
    return weekArray;
}
function $bb2d8fd494d21f05$var$startOfMonth(d) {
    var newDate = (0, $9hsGH.clone)(d);
    newDate.setDate(1);
    newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
    return newDate;
}
function $bb2d8fd494d21f05$var$getDayNodes(node, classNames) {
    var outsideClassName = void 0;
    if (classNames === $bb2d8fd494d21f05$var$_classNames2.default) // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
    else outsideClassName = '' + classNames.outside;
    var dayQuery = classNames.day.replace(/ /g, '.');
    var outsideDayQuery = outsideClassName.replace(/ /g, '.');
    var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
    return node.querySelectorAll(selector);
}
function $bb2d8fd494d21f05$var$nodeListToArray(nodeList) {
    return Array.prototype.slice.call(nodeList, 0);
}
function $bb2d8fd494d21f05$var$hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});


parcelRegister("dF5u6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dayMatchesModifier = $9f235bca344fd135$var$dayMatchesModifier;
module.exports.getModifiersForDay = $9f235bca344fd135$var$getModifiersForDay;

var $9hsGH = parcelRequire("9hsGH");

var $g4lke = parcelRequire("g4lke");
/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */ function $9f235bca344fd135$var$dayMatchesModifier(day, modifier) {
    if (!modifier) return false;
    var arr = Array.isArray(modifier) ? modifier : [
        modifier
    ];
    return arr.some(function(mod) {
        if (!mod) return false;
        if (mod instanceof Date) return (0, $9hsGH.isSameDay)(day, mod);
        if ((0, $g4lke.isRangeOfDates)(mod)) return (0, $9hsGH.isDayInRange)(day, mod);
        if (mod.after && mod.before && (0, $9hsGH.isDayAfter)(mod.before, mod.after)) return (0, $9hsGH.isDayAfter)(day, mod.after) && (0, $9hsGH.isDayBefore)(day, mod.before);
        if (mod.after && mod.before && ((0, $9hsGH.isDayAfter)(mod.after, mod.before) || (0, $9hsGH.isSameDay)(mod.after, mod.before))) return (0, $9hsGH.isDayAfter)(day, mod.after) || (0, $9hsGH.isDayBefore)(day, mod.before);
        if (mod.after) return (0, $9hsGH.isDayAfter)(day, mod.after);
        if (mod.before) return (0, $9hsGH.isDayBefore)(day, mod.before);
        if (mod.daysOfWeek) return mod.daysOfWeek.some(function(dayOfWeek) {
            return day.getDay() === dayOfWeek;
        });
        if (typeof mod === 'function') return mod(day);
        return false;
    });
}
/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */ function $9f235bca344fd135$var$getModifiersForDay(day) {
    var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(modifiersObj).reduce(function(modifiers, modifierName) {
        var value = modifiersObj[modifierName];
        if ($9f235bca344fd135$var$dayMatchesModifier(day, value)) modifiers.push(modifierName);
        return modifiers;
    }, []);
}
module.exports.default = {
    dayMatchesModifier: $9f235bca344fd135$var$dayMatchesModifier,
    getModifiersForDay: $9f235bca344fd135$var$getModifiersForDay
};

});


parcelRegister("gT5es", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c4b5d7651e8fc93c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $denZA = parcelRequire("denZA");
var $c4b5d7651e8fc93c$var$_react2 = $c4b5d7651e8fc93c$var$_interopRequireDefault($denZA);

var $cvFNP = parcelRequire("cvFNP");
var $c4b5d7651e8fc93c$var$_propTypes2 = $c4b5d7651e8fc93c$var$_interopRequireDefault($cvFNP);
function $c4b5d7651e8fc93c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4b5d7651e8fc93c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4b5d7651e8fc93c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c4b5d7651e8fc93c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c4b5d7651e8fc93c$var$Weekday = function(_Component) {
    $c4b5d7651e8fc93c$var$_inherits(Weekday, _Component);
    function Weekday() {
        $c4b5d7651e8fc93c$var$_classCallCheck(this, Weekday);
        return $c4b5d7651e8fc93c$var$_possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
    }
    $c4b5d7651e8fc93c$var$_createClass(Weekday, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return this.props !== nextProps;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, weekday = _props.weekday, className = _props.className, weekdaysLong = _props.weekdaysLong, weekdaysShort = _props.weekdaysShort, localeUtils = _props.localeUtils, locale = _props.locale;
                var title = void 0;
                if (weekdaysLong) title = weekdaysLong[weekday];
                else title = localeUtils.formatWeekdayLong(weekday, locale);
                var content = void 0;
                if (weekdaysShort) content = weekdaysShort[weekday];
                else content = localeUtils.formatWeekdayShort(weekday, locale);
                return $c4b5d7651e8fc93c$var$_react2.default.createElement('div', {
                    className: className,
                    role: 'columnheader'
                }, $c4b5d7651e8fc93c$var$_react2.default.createElement('abbr', {
                    title: title
                }, content));
            }
        }
    ]);
    return Weekday;
}($denZA.Component);
$c4b5d7651e8fc93c$var$Weekday.propTypes = {
    weekday: $c4b5d7651e8fc93c$var$_propTypes2.default.number,
    className: $c4b5d7651e8fc93c$var$_propTypes2.default.string,
    locale: $c4b5d7651e8fc93c$var$_propTypes2.default.string,
    localeUtils: $c4b5d7651e8fc93c$var$_propTypes2.default.object,
    weekdaysLong: $c4b5d7651e8fc93c$var$_propTypes2.default.arrayOf($c4b5d7651e8fc93c$var$_propTypes2.default.string),
    weekdaysShort: $c4b5d7651e8fc93c$var$_propTypes2.default.arrayOf($c4b5d7651e8fc93c$var$_propTypes2.default.string)
};
module.exports.default = $c4b5d7651e8fc93c$var$Weekday;

});



parcelRegister("e5Q7j", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("fKF2T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b77afdb99d2fe4d7$export$2e2bcd8739ae039; });

var $8PJGo = parcelRequire("8PJGo");
var $b77afdb99d2fe4d7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b77afdb99d2fe4d7$var$index = (0, $8PJGo.default)(function(prop) {
    return $b77afdb99d2fe4d7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $b77afdb99d2fe4d7$export$2e2bcd8739ae039 = $b77afdb99d2fe4d7$var$index;

});
parcelRegister("8PJGo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e685d0740659b6$export$2e2bcd8739ae039; });
function $66e685d0740659b6$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $66e685d0740659b6$export$2e2bcd8739ae039 = $66e685d0740659b6$var$memoize;

});


parcelRegister("cL3gO", function(module, exports) {

!function(e, t) {
    t(module.exports, (parcelRequire("denZA")));
}(module.exports, function(e, t) {
    "use strict";
    function n(e, t, n, o, r, i, u) {
        try {
            var l = e[i](u), s = l.value;
        } catch (e) {
            return void n(e);
        }
        l.done ? t(s) : Promise.resolve(s).then(o, r);
    }
    function o(e) {
        return function() {
            var t = this, o = arguments;
            return new Promise(function(r, i) {
                var u = e.apply(t, o);
                function l(e) {
                    n(u, r, i, l, s, "next", e);
                }
                function s(e) {
                    n(u, r, i, l, s, "throw", e);
                }
                l(void 0);
            });
        };
    }
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }).apply(this, arguments);
    }
    function i(e, t) {
        if (null == e) return {};
        var n, o, r = {}, i = Object.keys(e);
        for(o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }
    function u(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
    }, s = function(e) {
        var t = e.value;
        return void 0 === t ? "" : t;
    }, a = function() {
        return t.createElement(t.Fragment, null, "\xa0");
    }, c = {
        Cell: s,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
    };
    function d() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        return t.reduce(function(e, t) {
            var n = t.style, o = t.className;
            return e = r({}, e, {}, i(t, [
                "style",
                "className"
            ])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
        }, {});
    }
    var f = function(e, t) {
        return void 0 === t && (t = {}), function(n) {
            return void 0 === n && (n = {}), [].concat(e, [
                n
            ]).reduce(function(e, o) {
                return function e(t, n, o) {
                    return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [
                        t
                    ].concat(n)) : d(t, n);
                }(e, o, r({}, t, {
                    userProps: n
                }));
            }, {});
        };
    }, p = function(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function(e, t) {
            return t(e, n);
        }, t);
    }, g = function(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function(e) {
            e(t, n);
        });
    };
    function v(e, t, n, o) {
        e.findIndex(function(e) {
            return e.pluginName === n;
        });
        t.forEach(function(t) {
            e.findIndex(function(e) {
                return e.pluginName === t;
            });
        });
    }
    function m(e, t) {
        return "function" == typeof e ? e(t) : e;
    }
    function h(e) {
        var n = t.useRef();
        return n.current = e, t.useCallback(function() {
            return n.current;
        }, []);
    }
    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function w(e, n) {
        var o = t.useRef(!1);
        y(function() {
            o.current && e(), o.current = !0;
        }, n);
    }
    function R(e, t, n) {
        return void 0 === n && (n = {}), function(o, i) {
            void 0 === i && (i = {});
            var u = "string" == typeof o ? t[o] : o;
            if (void 0 === u) throw console.info(t), new Error("Renderer Error \u261D\uFE0F");
            return b(u, r({}, e, {
                column: t
            }, n, {}, i));
        };
    }
    function b(e, n) {
        var o;
        return function(e) {
            var t;
            return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        }(o = e) || "function" == typeof o || function(e) {
            return "object" == typeof e && "symbol" == typeof e.$$typeof && [
                "react.memo",
                "react.forward_ref"
            ].includes(e.$$typeof.description);
        }(o) ? t.createElement(e, n) : e;
    }
    function S(e, t, n) {
        return void 0 === n && (n = 0), e.map(function(e) {
            return x(e = r({}, e, {
                parent: t,
                depth: n
            })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
        });
    }
    function C(e) {
        return G(e, "columns");
    }
    function x(e) {
        var t = e.id, n = e.accessor, o = e.Header;
        if ("string" == typeof n) {
            t = t || n;
            var r = n.split(".");
            n = function(e) {
                return function(e, t, n) {
                    if (!t) return e;
                    var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
                        var e = function(e) {
                            return (function e(t, n) {
                                void 0 === n && (n = []);
                                if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)e(t[o], n);
                                else n.push(t);
                                return n;
                            })(e).map(function(e) {
                                return String(e).replace(".", "_");
                            }).join(".").replace(W, ".").replace(O, "").split(".");
                        }(t);
                        return E.set(r, e), e;
                    }();
                    try {
                        o = i.reduce(function(e, t) {
                            return e[t];
                        }, e);
                    } catch (e) {}
                    return void 0 !== o ? o : n;
                }(e, r);
            };
        }
        if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
        if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e, {
            id: t,
            accessor: n
        }), e;
    }
    function P(e, t) {
        if (!t) throw new Error;
        return Object.assign(e, r({
            Header: a,
            Footer: a
        }, c, {}, t, {}, e)), Object.assign(e, {
            originalWidth: e.width
        }), e;
    }
    function B(e, t, n) {
        void 0 === n && (n = function() {
            return {};
        });
        for(var o = [], i = e, u = 0, l = function() {
            return u++;
        }, s = function() {
            var e = {
                headers: []
            }, u = [], s = i.some(function(e) {
                return e.parent;
            });
            i.forEach(function(o) {
                var i, a = [].concat(u).reverse()[0];
                if (s) {
                    if (o.parent) i = r({}, o.parent, {
                        originalId: o.parent.id,
                        id: o.parent.id + "_" + l(),
                        headers: [
                            o
                        ]
                    }, n(o));
                    else i = P(r({
                        originalId: o.id + "_placeholder",
                        id: o.id + "_placeholder_" + l(),
                        placeholderOf: o,
                        headers: [
                            o
                        ]
                    }, n(o)), t);
                    a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
                }
                e.headers.push(o);
            }), o.push(e), i = u;
        }; i.length;)s();
        return o.reverse();
    }
    var E = new Map;
    function I() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        for(var o = 0; o < t.length; o += 1)if (void 0 !== t[o]) return t[o];
    }
    function F(e) {
        if ("function" == typeof e) return e;
    }
    function G(e, t) {
        var n = [];
        return function e(o) {
            o.forEach(function(o) {
                o[t] ? e(o[t]) : n.push(o);
            });
        }(e), n;
    }
    function A(e, t) {
        var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
        return e.forEach(function(e) {
            return function e(t, r) {
                void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function(t) {
                    return e(t, i);
                });
            }(e);
        }), u;
    }
    function k(e, t, n) {
        return F(e) || t[e] || n[e] || n.text;
    }
    function H(e, t, n) {
        return e ? e(t, n) : void 0 === t;
    }
    function T() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var W = /\[/g, O = /\]/g;
    var M = function(e) {
        return r({
            role: "table"
        }, e);
    }, j = function(e) {
        return r({
            role: "rowgroup"
        }, e);
    }, N = function(e, t) {
        var n = t.column;
        return r({
            key: "header_" + n.id,
            colSpan: n.totalVisibleHeaderCount,
            role: "columnheader"
        }, e);
    }, L = function(e, t) {
        var n = t.column;
        return r({
            key: "footer_" + n.id,
            colSpan: n.totalVisibleHeaderCount
        }, e);
    }, D = function(e, t) {
        return r({
            key: "headerGroup_" + t.index,
            role: "row"
        }, e);
    }, V = function(e, t) {
        return r({
            key: "footerGroup_" + t.index
        }, e);
    }, _ = function(e, t) {
        return r({
            key: "row_" + t.row.id,
            role: "row"
        }, e);
    }, X = function(e, t) {
        var n = t.cell;
        return r({
            key: "cell_" + n.row.id + "_" + n.column.id,
            role: "cell"
        }, e);
    };
    function q() {
        return {
            useOptions: [],
            stateReducers: [],
            useControlledState: [],
            columns: [],
            columnsDeps: [],
            allColumns: [],
            allColumnsDeps: [],
            accessValue: [],
            materializedColumns: [],
            materializedColumnsDeps: [],
            useInstanceAfterData: [],
            visibleColumns: [],
            visibleColumnsDeps: [],
            headerGroups: [],
            headerGroupsDeps: [],
            useInstanceBeforeDimensions: [],
            useInstance: [],
            prepareRow: [],
            getTableProps: [
                M
            ],
            getTableBodyProps: [
                j
            ],
            getHeaderGroupProps: [
                D
            ],
            getFooterGroupProps: [
                V
            ],
            getHeaderProps: [
                N
            ],
            getFooterProps: [
                L
            ],
            getRowProps: [
                _
            ],
            getCellProps: [
                X
            ],
            useFinalInstance: []
        };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e) {
        e.getToggleHiddenProps = [
            U
        ], e.getToggleHideAllColumnsProps = [
            $
        ], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.hiddenColumns
            ]);
        }), e.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHidden(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isVisible,
                title: "Toggle Column Visible"
            }
        ];
    }, $ = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHideAllColumns(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
                title: "Toggle All Columns Hidden",
                indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
            }
        ];
    };
    function J(e, t, n, o) {
        if (t.type === l.init) return r({
            hiddenColumns: []
        }, e);
        if (t.type === l.resetHiddenColumns) return r({}, e, {
            hiddenColumns: o.initialState.hiddenColumns || []
        });
        if (t.type === l.toggleHideColumn) {
            var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [
                t.columnId
            ]) : e.hiddenColumns.filter(function(e) {
                return e !== t.columnId;
            });
            return r({}, e, {
                hiddenColumns: i
            });
        }
        return t.type === l.setHiddenColumns ? r({}, e, {
            hiddenColumns: m(t.value, e.hiddenColumns)
        }) : t.type === l.toggleHideAllColumns ? r({}, e, {
            hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function(e) {
                return e.id;
            }) : []
        }) : void 0;
    }
    function Y(e) {
        var n = e.headers, o = e.state.hiddenColumns;
        t.useRef(!1).current;
        var r = 0;
        n.forEach(function(e) {
            return r += function e(t, n) {
                t.isVisible = n && !o.includes(t.id);
                var r = 0;
                return t.headers && t.headers.length ? t.headers.forEach(function(n) {
                    return r += e(n, t.isVisible);
                }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
            }(e, !0);
        });
    }
    function Q(e) {
        var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback(function(e, t) {
            return r({
                type: l.toggleHideColumn,
                columnId: e,
                value: t
            });
        }, [
            r
        ]), v = t.useCallback(function(e) {
            return r({
                type: l.setHiddenColumns,
                value: e
            });
        }, [
            r
        ]), m = t.useCallback(function(e) {
            return r({
                type: l.toggleHideAllColumns,
                value: e
            });
        }, [
            r
        ]), y = f(u().getToggleHideAllColumnsProps, {
            instance: d()
        });
        o.forEach(function(e) {
            e.toggleHidden = function(t) {
                r({
                    type: l.toggleHideColumn,
                    columnId: e.id,
                    value: t
                });
            }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
                instance: d(),
                column: e
            });
        });
        var R = h(c);
        w(function() {
            R() && r({
                type: l.resetHiddenColumns
            });
        }, [
            r,
            n
        ]), Object.assign(e, {
            allColumnsHidden: p,
            toggleHideColumn: g,
            setHiddenColumns: v,
            toggleHideAllColumns: m,
            getToggleHideAllColumnsProps: y
        });
    }
    var Z = {}, ee = {}, te = function(e, t, n) {
        return e;
    }, ne = function(e, t) {
        return e.subRows || [];
    }, oe = function(e, t, n) {
        return "" + (n ? [
            n.id,
            t
        ].join(".") : t);
    }, re = function(e) {
        return e;
    };
    function ie(e) {
        var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
        return r({}, i(e, [
            "initialState",
            "defaultColumn",
            "getSubRows",
            "getRowId",
            "stateReducer",
            "useControlledState"
        ]), {
            initialState: n,
            defaultColumn: u,
            getSubRows: s,
            getRowId: c,
            stateReducer: f,
            useControlledState: g
        });
    }
    function ue(e, t) {
        void 0 === t && (t = 0);
        var n = 0, o = 0, r = 0, i = 0;
        return e.forEach(function(e) {
            var u = e.headers;
            if (e.totalLeft = t, u && u.length) {
                var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
                e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
            } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
            e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
        }), [
            n,
            o,
            r,
            i
        ];
    }
    function le(e) {
        var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
        t.forEach(function(e, c) {
            return function e(n, c, d, f, g) {
                void 0 === d && (d = 0);
                var v = n, m = u(n, c, f), h = r[m];
                if (h) h.subRows && h.originalSubRows.forEach(function(t, n) {
                    return e(t, n, d + 1, h);
                });
                else if ((h = {
                    id: m,
                    original: v,
                    index: c,
                    depth: d,
                    cells: [
                        {}
                    ]
                }).cells.map = T, h.cells.filter = T, h.cells.forEach = T, h.cells[0].getCellProps = T, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
                    var y = [];
                    h.originalSubRows.forEach(function(t, n) {
                        return e(t, n, d + 1, h, y);
                    }), h.subRows = y;
                }
                i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
                    row: h,
                    column: i,
                    instance: a()
                });
            }(e, c, 0, void 0, n);
        });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e) {
        e.getToggleAllRowsExpandedProps = [
            ae
        ], e.getToggleRowExpandedProps = [
            ce
        ], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onClick: function(e) {
                    n.toggleAllRowsExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle All Rows Expanded"
            }
        ];
    }, ce = function(e, t) {
        var n = t.row;
        return [
            e,
            {
                onClick: function() {
                    n.toggleRowExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle Row Expanded"
            }
        ];
    };
    function de(e, t, n, o) {
        if (t.type === l.init) return r({
            expanded: {}
        }, e);
        if (t.type === l.resetExpanded) return r({}, e, {
            expanded: o.initialState.expanded || {}
        });
        if (t.type === l.toggleAllRowsExpanded) {
            var s = t.value, a = o.isAllRowsExpanded, c = o.rowsById;
            if (void 0 !== s ? s : !a) {
                var d = {};
                return Object.keys(c).forEach(function(e) {
                    d[e] = !0;
                }), r({}, e, {
                    expanded: d
                });
            }
            return r({}, e, {
                expanded: {}
            });
        }
        if (t.type === l.toggleRowExpanded) {
            var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
            if (!v && m) return r({}, e, {
                expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
            });
            if (v && !m) {
                var h = e.expanded;
                h[p];
                return r({}, e, {
                    expanded: i(h, [
                        p
                    ].map(u))
                });
            }
            return e;
        }
    }
    function fe(e) {
        var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
        v(y, [
            "useSortBy",
            "useGroupBy",
            "usePivotColumns",
            "useGlobalFilter"
        ], "useExpanded");
        var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
        C && Object.keys(r).some(function(e) {
            return !R[e];
        }) && (C = !1), w(function() {
            S() && b({
                type: l.resetExpanded
            });
        }, [
            b,
            n
        ]);
        var x = t.useCallback(function(e, t) {
            b({
                type: l.toggleRowExpanded,
                id: e,
                value: t
            });
        }, [
            b
        ]), P = t.useCallback(function(e) {
            return b({
                type: l.toggleAllRowsExpanded,
                value: e
            });
        }, [
            b
        ]), B = t.useMemo(function() {
            return a ? A(o, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: d
            }) : o;
        }, [
            a,
            o,
            u,
            R,
            d
        ]), E = t.useMemo(function() {
            return function(e) {
                var t = 0;
                return Object.keys(e).forEach(function(e) {
                    var n = e.split(".");
                    t = Math.max(t, n.length);
                }), t;
            }(R);
        }, [
            R
        ]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, {
            instance: I()
        });
        Object.assign(e, {
            preExpandedRows: o,
            expandedRows: B,
            rows: B,
            expandedDepth: E,
            isAllRowsExpanded: C,
            toggleRowExpanded: x,
            toggleAllRowsExpanded: P,
            getToggleAllRowsExpandedProps: F
        });
    }
    function pe(e, t) {
        var n = t.instance.getHooks, o = t.instance;
        e.toggleRowExpanded = function(t) {
            return o.toggleRowExpanded(e.id, t);
        }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
            instance: o,
            row: e
        });
    }
    var ge = function(e, t, n) {
        return e = e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return String(o).toLowerCase().includes(String(n).toLowerCase());
            });
        });
    };
    ge.autoRemove = function(e) {
        return !e;
    };
    var ve = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
            });
        });
    };
    ve.autoRemove = function(e) {
        return !e;
    };
    var me = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o) === String(n);
            });
        });
    };
    me.autoRemove = function(e) {
        return !e;
    };
    var he = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t].includes(n);
            });
        });
    };
    he.autoRemove = function(e) {
        return !e || !e.length;
    };
    var ye = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.every(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    ye.autoRemove = function(e) {
        return !e || !e.length;
    };
    var we = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.some(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    we.autoRemove = function(e) {
        return !e || !e.length;
    };
    var Re = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return n.includes(o);
            });
        });
    };
    Re.autoRemove = function(e) {
        return !e || !e.length;
    };
    var be = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] === n;
            });
        });
    };
    be.autoRemove = function(e) {
        return void 0 === e;
    };
    var Se = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] == n;
            });
        });
    };
    Se.autoRemove = function(e) {
        return null == e;
    };
    var Ce = function(e, t, n) {
        var o = n || [], r = o[0], i = o[1];
        if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
            var u = r;
            r = i, i = u;
        }
        return e.filter(function(e) {
            return t.some(function(t) {
                var n = e.values[t];
                return n >= r && n <= i;
            });
        });
    };
    Ce.autoRemove = function(e) {
        return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var xe = Object.freeze({
        __proto__: null,
        text: ge,
        exactText: ve,
        exactTextCase: me,
        includes: he,
        includesAll: ye,
        includesSome: we,
        includesValue: Re,
        exact: be,
        equals: Se,
        between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e) {
        e.stateReducers.push(Be), e.useInstance.push(Ee);
    };
    function Be(e, t, n, o) {
        if (t.type === l.init) return r({
            filters: []
        }, e);
        if (t.type === l.resetFilters) return r({}, e, {
            filters: o.initialState.filters || []
        });
        if (t.type === l.setFilter) {
            var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find(function(e) {
                return e.id === i;
            });
            if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
            var d = k(c.filter, a || {}, xe), f = e.filters.find(function(e) {
                return e.id === i;
            }), p = m(u, f && f.value);
            return H(d.autoRemove, p, c) ? r({}, e, {
                filters: e.filters.filter(function(e) {
                    return e.id !== i;
                })
            }) : r({}, e, f ? {
                filters: e.filters.map(function(e) {
                    return e.id === i ? {
                        id: i,
                        value: p
                    } : e;
                })
            } : {
                filters: [].concat(e.filters, [
                    {
                        id: i,
                        value: p
                    }
                ])
            });
        }
        if (t.type === l.setAllFilters) {
            var g = t.filters, v = o.allColumns, h = o.filterTypes;
            return r({}, e, {
                filters: m(g, e.filters).filter(function(e) {
                    var t = v.find(function(t) {
                        return t.id === e.id;
                    });
                    return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
                })
            });
        }
    }
    function Ee(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback(function(e, t) {
            g({
                type: l.setFilter,
                columnId: e,
                filterValue: t
            });
        }, [
            g
        ]), R = t.useCallback(function(e) {
            g({
                type: l.setAllFilters,
                filters: e
            });
        }, [
            g
        ]);
        u.forEach(function(e) {
            var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
            e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
                return y(e.id, t);
            };
            var i = p.find(function(e) {
                return e.id === t;
            });
            e.filterValue = i && i.value;
        });
        var b = t.useMemo(function() {
            if (a || !p.length) return [
                o,
                r,
                i
            ];
            var e = [], t = {};
            return [
                function n(o, r) {
                    void 0 === r && (r = 0);
                    var i = o;
                    return (i = p.reduce(function(e, t) {
                        var n = t.id, o = t.value, i = u.find(function(e) {
                            return e.id === n;
                        });
                        if (!i) return e;
                        0 === r && (i.preFilteredRows = e);
                        var l = k(i.filter, s || {}, xe);
                        return l ? (i.filteredRows = l(e, [
                            n
                        ], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
                    }, o)).forEach(function(o) {
                        e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
                    }), i;
                }(o),
                e,
                t
            ];
        }, [
            a,
            p,
            o,
            r,
            i,
            u,
            s
        ]), S = b[0], C = b[1], x = b[2];
        t.useMemo(function() {
            u.filter(function(e) {
                return !p.find(function(t) {
                    return t.id === e.id;
                });
            }).forEach(function(e) {
                e.preFilteredRows = S, e.filteredRows = S;
            });
        }, [
            S,
            p,
            u
        ]);
        var P = h(m);
        w(function() {
            P() && g({
                type: l.resetFilters
            });
        }, [
            g,
            a ? null : n
        ]), Object.assign(e, {
            preFilteredRows: o,
            preFilteredFlatRows: r,
            preFilteredRowsById: i,
            filteredRows: S,
            filteredFlatRows: C,
            filteredRowsById: x,
            rows: S,
            flatRows: C,
            rowsById: x,
            setFilter: y,
            setAllFilters: R
        });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e) {
        e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };
    function Fe(e, t, n, o) {
        if (t.type === l.resetGlobalFilter) return r({}, e, {
            globalFilter: o.initialState.globalFilter || void 0
        });
        if (t.type === l.setGlobalFilter) {
            var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
            if (H(a.autoRemove, c)) {
                e.globalFilter;
                return i(e, [
                    "globalFilter"
                ]);
            }
            return r({}, e, {
                globalFilter: c
            });
        }
    }
    function Ge(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback(function(e) {
            f({
                type: l.setGlobalFilter,
                filterValue: e
            });
        }, [
            f
        ]), y = t.useMemo(function() {
            if (c || void 0 === d) return [
                o,
                r,
                i
            ];
            var e = [], t = {}, n = k(a, s || {}, xe);
            if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
            u.forEach(function(e) {
                var t = e.disableGlobalFilter;
                e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
            });
            var l = u.filter(function(e) {
                return !0 === e.canFilter;
            });
            return [
                function o(r) {
                    return (r = n(r, l.map(function(e) {
                        return e.id;
                    }), d)).forEach(function(n) {
                        e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
                    }), r;
                }(o),
                e,
                t
            ];
        }, [
            c,
            d,
            a,
            s,
            u,
            o,
            r,
            i,
            v
        ]), R = y[0], b = y[1], S = y[2], C = h(g);
        w(function() {
            C() && f({
                type: l.resetGlobalFilter
            });
        }, [
            f,
            c ? null : n
        ]), Object.assign(e, {
            preGlobalFilteredRows: o,
            preGlobalFilteredFlatRows: r,
            preGlobalFilteredRowsById: i,
            globalFilteredRows: R,
            globalFilteredFlatRows: b,
            globalFilteredRowsById: S,
            rows: R,
            flatRows: b,
            rowsById: S,
            setGlobalFilter: m,
            disableGlobalFilter: v
        });
    }
    function Ae(e, t) {
        return t.reduce(function(e, t) {
            return e + ("number" == typeof t ? t : 0);
        }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
        __proto__: null,
        sum: Ae,
        min: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e));
            }), t;
        },
        max: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.max(t, e));
            }), t;
        },
        minMax: function(e) {
            var t = e[0] || 0, n = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
            }), t + ".." + n;
        },
        average: function(e) {
            return Ae(0, e) / e.length;
        },
        median: function(e) {
            if (!e.length) return null;
            var t = Math.floor(e.length / 2), n = [].concat(e).sort(function(e, t) {
                return e - t;
            });
            return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
        },
        unique: function(e) {
            return Array.from(new Set(e).values());
        },
        uniqueCount: function(e) {
            return new Set(e).size;
        },
        count: function(e) {
            return e.length;
        }
    }), He = [], Te = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e) {
        e.getGroupByToggleProps = [
            We
        ], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.groupBy
            ]);
        }), e.visibleColumns.push(Me), e.useInstance.push(Ne), e.prepareRow.push(Le);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canGroupBy ? function(e) {
                    e.persist(), n.toggleGroupBy();
                } : void 0,
                style: {
                    cursor: n.canGroupBy ? "pointer" : void 0
                },
                title: "Toggle GroupBy"
            }
        ];
    };
    function Oe(e, t, n, o) {
        if (t.type === l.init) return r({
            groupBy: []
        }, e);
        if (t.type === l.resetGroupBy) return r({}, e, {
            groupBy: o.initialState.groupBy || []
        });
        if (t.type === l.setGroupBy) return r({}, e, {
            groupBy: t.value
        });
        if (t.type === l.toggleGroupBy) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
            return r({}, e, s ? {
                groupBy: [].concat(e.groupBy, [
                    i
                ])
            } : {
                groupBy: e.groupBy.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function Me(e, t) {
        var n = t.instance.state.groupBy, o = n.map(function(t) {
            return e.find(function(e) {
                return e.id === t;
            });
        }).filter(Boolean), r = e.filter(function(e) {
            return !n.includes(e.id);
        });
        return (e = [].concat(o, r)).forEach(function(e) {
            e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
        }), e;
    }
    var je = {};
    function Ne(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.flatHeaders, a = e.groupByFn, c = void 0 === a ? De : a, d = e.manualGroupBy, p = e.aggregations, g = void 0 === p ? je : p, m = e.plugins, y = e.state.groupBy, R = e.dispatch, b = e.autoResetGroupBy, S = void 0 === b || b, C = e.disableGroupBy, x = e.defaultCanGroupBy, P = e.getHooks;
        v(m, [
            "useColumnOrder",
            "useFilters"
        ], "useGroupBy");
        var B = h(e);
        u.forEach(function(t) {
            var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
            t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== C && void 0, !0) : I(t.canGroupBy, o, x, !1), t.canGroupBy && (t.toggleGroupBy = function() {
                return e.toggleGroupBy(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        var E = t.useCallback(function(e, t) {
            R({
                type: l.toggleGroupBy,
                columnId: e,
                value: t
            });
        }, [
            R
        ]), F = t.useCallback(function(e) {
            R({
                type: l.setGroupBy,
                value: e
            });
        }, [
            R
        ]);
        s.forEach(function(e) {
            e.getGroupByToggleProps = f(P().getGroupByToggleProps, {
                instance: B(),
                header: e
            });
        });
        var A = t.useMemo(function() {
            if (d || !y.length) return [
                o,
                r,
                i,
                He,
                Te,
                r,
                i
            ];
            var e = y.filter(function(e) {
                return u.find(function(t) {
                    return t.id === e;
                });
            }), t = [], n = {}, l = [], s = {}, a = [], f = {}, p = function o(r, i, d) {
                if (void 0 === i && (i = 0), i === e.length) return r;
                var p = e[i], v = c(r, p);
                return Object.entries(v).map(function(r, c) {
                    var v = r[0], m = r[1], h = p + ":" + v, y = o(m, i + 1, h = d ? d + ">" + h : h), w = i ? G(m, "leafRows") : m, R = function(t, n, o) {
                        var r = {};
                        return u.forEach(function(i) {
                            if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
                            else {
                                var u = "function" == typeof i.aggregate ? i.aggregate : g[i.aggregate] || ke[i.aggregate];
                                if (u) {
                                    var l = n.map(function(e) {
                                        return e.values[i.id];
                                    }), s = t.map(function(e) {
                                        var t = e.values[i.id];
                                        if (!o && i.aggregateValue) {
                                            var n = "function" == typeof i.aggregateValue ? i.aggregateValue : g[i.aggregateValue] || ke[i.aggregateValue];
                                            if (!n) throw console.info({
                                                column: i
                                            }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                                            t = n(t, e, i);
                                        }
                                        return t;
                                    });
                                    r[i.id] = u(s, l);
                                } else {
                                    if (i.aggregate) throw console.info({
                                        column: i
                                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                                    r[i.id] = null;
                                }
                            }
                        }), r;
                    }(w, m, i), b = {
                        id: h,
                        isGrouped: !0,
                        groupByID: p,
                        groupByVal: v,
                        values: R,
                        subRows: y,
                        leafRows: w,
                        depth: i,
                        index: c
                    };
                    return y.forEach(function(e) {
                        t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
                    }), b;
                });
            }(o);
            return p.forEach(function(e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
            }), [
                p,
                t,
                n,
                l,
                s,
                a,
                f
            ];
        }, [
            d,
            y,
            o,
            r,
            i,
            u,
            g,
            c
        ]), k = A[0], H = A[1], T = A[2], z = A[3], W = A[4], O = A[5], M = A[6], j = h(S);
        w(function() {
            j() && R({
                type: l.resetGroupBy
            });
        }, [
            R,
            d ? null : n
        ]), Object.assign(e, {
            preGroupedRows: o,
            preGroupedFlatRow: r,
            preGroupedRowsById: i,
            groupedRows: k,
            groupedFlatRows: H,
            groupedRowsById: T,
            onlyGroupedFlatRows: z,
            onlyGroupedRowsById: W,
            nonGroupedFlatRows: O,
            nonGroupedRowsById: M,
            rows: k,
            flatRows: H,
            rowsById: T,
            toggleGroupBy: E,
            setGroupBy: F
        });
    }
    function Le(e) {
        e.allCells.forEach(function(t) {
            var n;
            t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
        });
    }
    function De(e, t) {
        return e.reduce(function(e, n, o) {
            var r = "" + n.values[t];
            return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
        }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e, t) {
        return e === t ? 0 : e > t ? 1 : -1;
    }
    function Xe(e, t, n) {
        return [
            e.values[n],
            t.values[n]
        ];
    }
    function qe(e) {
        return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Ke = Object.freeze({
        __proto__: null,
        alphanumeric: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = parseInt(u, 10), a = parseInt(l, 10), c = [
                    s,
                    a
                ].sort();
                if (isNaN(c[0])) {
                    if (u > l) return 1;
                    if (l > u) return -1;
                } else {
                    if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
                    if (s > a) return 1;
                    if (a > s) return -1;
                }
            }
            return r.length - i.length;
        },
        datetime: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            return _e(r = r.getTime(), i = i.getTime());
        },
        basic: function(e, t, n) {
            var o = Xe(e, t, n);
            return _e(o[0], o[1]);
        },
        string: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = u.toLowerCase(), a = l.toLowerCase();
                if (s > a) return 1;
                if (a > s) return -1;
                if (u > l) return 1;
                if (l > u) return -1;
            }
            return r.length - i.length;
        },
        number: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1], u = /[^0-9.]/gi;
            return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
        }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
    var Ue = function(e) {
        e.getSortByToggleProps = [
            $e
        ], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e, t) {
        var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
            return e.shiftKey;
        } : r;
        return [
            e,
            {
                onClick: o.canSort ? function(e) {
                    e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
                } : void 0,
                style: {
                    cursor: o.canSort ? "pointer" : void 0
                },
                title: o.canSort ? "Toggle SortBy" : void 0
            }
        ];
    };
    function Je(e, t, n, o) {
        if (t.type === l.init) return r({
            sortBy: []
        }, e);
        if (t.type === l.resetSortBy) return r({}, e, {
            sortBy: o.initialState.sortBy || []
        });
        if (t.type === l.clearSortBy) return r({}, e, {
            sortBy: e.sortBy.filter(function(e) {
                return e.id !== t.columnId;
            })
        });
        if (t.type === l.setSortBy) return r({}, e, {
            sortBy: t.sortBy
        });
        if (t.type === l.toggleSortBy) {
            var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find(function(e) {
                return e.id === u;
            }).sortDescFirst, y = m.find(function(e) {
                return e.id === u;
            }), w = m.findIndex(function(e) {
                return e.id === u;
            }), R = null != s, b = [];
            return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [
                {
                    id: u,
                    desc: R ? s : h
                }
            ] : "add" === i ? (b = [].concat(m, [
                {
                    id: u,
                    desc: R ? s : h
                }
            ])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function(e) {
                return e.id === u ? r({}, e, {
                    desc: R ? s : !y.desc
                }) : e;
            }) : "remove" === i && (b = m.filter(function(e) {
                return e.id !== u;
            })), r({}, e, {
                sortBy: b
            });
        }
    }
    function Ye(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
        v(R, [
            "useFilters",
            "useGlobalFilter",
            "useGroupBy",
            "usePivotColumns"
        ], "useSortBy");
        var x = t.useCallback(function(e) {
            y({
                type: l.setSortBy,
                sortBy: e
            });
        }, [
            y
        ]), P = t.useCallback(function(e, t, n) {
            y({
                type: l.toggleSortBy,
                columnId: e,
                desc: t,
                multi: n
            });
        }, [
            y
        ]), B = h(e);
        g.forEach(function(e) {
            var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id, i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
            e.canSort = i, e.canSort && (e.toggleSortBy = function(t, n) {
                return P(e.id, t, n);
            }, e.clearSortBy = function() {
                y({
                    type: l.clearSortBy,
                    columnId: e.id
                });
            }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
                instance: B(),
                column: e
            });
            var u = m.find(function(e) {
                return e.id === r;
            });
            e.isSorted = !!u, e.sortedIndex = m.findIndex(function(e) {
                return e.id === r;
            }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
        });
        var E = t.useMemo(function() {
            if (c || !m.length) return [
                o,
                r
            ];
            var e = [], t = m.filter(function(e) {
                return i.find(function(t) {
                    return t.id === e.id;
                });
            });
            return [
                function n(o) {
                    var r = s(o, t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
                        var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
                        if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
                        return function(t, n) {
                            return o(t, n, e.id, e.desc);
                        };
                    }), t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        return t && t.sortInverted ? e.desc : !e.desc;
                    }));
                    return r.forEach(function(t) {
                        e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
                    }), r;
                }(o),
                e
            ];
        }, [
            c,
            m,
            o,
            r,
            i,
            s,
            a
        ]), G = E[0], A = E[1], k = h(C);
        w(function() {
            k() && y({
                type: l.resetSortBy
            });
        }, [
            c ? null : n
        ]), Object.assign(e, {
            preSortedRows: o,
            preSortedFlatRows: r,
            sortedRows: G,
            sortedFlatRows: A,
            rows: G,
            flatRows: A,
            setSortBy: x,
            toggleSortBy: P
        });
    }
    function Qe(e, t, n) {
        return [].concat(e).sort(function(e, o) {
            for(var r = 0; r < t.length; r += 1){
                var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
                if (0 !== l) return u ? -l : l;
            }
            return n[0] ? e.index - o.index : o.index - e.index;
        });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e) {
        e.stateReducers.push(et), e.useInstance.push(tt);
    };
    function et(e, t, n, o) {
        if (t.type === l.init) return r({
            pageSize: 10,
            pageIndex: 0
        }, e);
        if (t.type === l.resetPage) return r({}, e, {
            pageIndex: o.initialState.pageIndex || 0
        });
        if (t.type === l.gotoPage) {
            var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
            return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
                pageIndex: s
            }) : e;
        }
        if (t.type === l.setPageSize) {
            var c = t.pageSize, d = e.pageSize * e.pageIndex;
            return r({}, e, {
                pageIndex: Math.floor(d / c),
                pageSize: c
            });
        }
    }
    function tt(e) {
        var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
        v(s, [
            "useGlobalFilter",
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded"
        ], "usePagination");
        var I = h(r);
        w(function() {
            I() && P({
                type: l.resetPage
            });
        }, [
            P,
            E ? null : B,
            b,
            S,
            C,
            x
        ]);
        var F = E ? a : Math.ceil(n.length / m), G = t.useMemo(function() {
            return F > 0 ? [].concat(new Array(F)).fill(null).map(function(e, t) {
                return t;
            }) : [];
        }, [
            F
        ]), k = t.useMemo(function() {
            var e;
            if (E) e = n;
            else {
                var t = m * y, o = t + m;
                e = n.slice(t, o);
            }
            return d ? e : A(e, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: p
            });
        }, [
            p,
            R,
            u,
            E,
            y,
            m,
            d,
            n
        ]), H = y > 0, T = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback(function(e) {
            P({
                type: l.gotoPage,
                pageIndex: e
            });
        }, [
            P
        ]), W = t.useCallback(function() {
            return z(function(e) {
                return e - 1;
            });
        }, [
            z
        ]), O = t.useCallback(function() {
            return z(function(e) {
                return e + 1;
            });
        }, [
            z
        ]), M = t.useCallback(function(e) {
            P({
                type: l.setPageSize,
                pageSize: e
            });
        }, [
            P
        ]);
        Object.assign(e, {
            pageOptions: G,
            pageCount: F,
            page: k,
            canPreviousPage: H,
            canNextPage: T,
            gotoPage: z,
            previousPage: W,
            nextPage: O,
            setPageSize: M
        });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e) {
        e.getPivotToggleProps = [
            rt
        ], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canPivot ? function(e) {
                    e.persist(), n.togglePivot();
                } : void 0,
                style: {
                    cursor: n.canPivot ? "pointer" : void 0
                },
                title: "Toggle Pivot"
            }
        ];
    };
    function it(e, t, n, o) {
        if (t.type === l.init) return r({
            pivotColumns: ot
        }, e);
        if (t.type === l.resetPivot) return r({}, e, {
            pivotColumns: o.initialState.pivotColumns || ot
        });
        if (t.type === l.togglePivot) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
            return r({}, e, s ? {
                pivotColumns: [].concat(e.pivotColumns, [
                    i
                ])
            } : {
                pivotColumns: e.pivotColumns.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function ut(e) {
        e.allColumns.forEach(function(t) {
            t.isPivotSource = e.state.pivotColumns.includes(t.id);
        });
    }
    function lt(e, t) {
        var n = t.instance;
        return e.forEach(function(e) {
            e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set;
        }), e;
    }
    function st(e, t) {
        var n = t.column;
        return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function at(e, t) {
        var n = t.instance, o = n.allColumns, i = n.state;
        if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
        var u = i.pivotColumns.map(function(e) {
            return o.find(function(t) {
                return t.id === e;
            });
        }).filter(Boolean), l = o.filter(function(e) {
            return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }), s = C(function e(t, n, o) {
            void 0 === t && (t = 0), void 0 === o && (o = []);
            var i = u[t];
            return i ? Array.from(i.uniqueValues).sort().map(function(u) {
                var l = r({}, i, {
                    Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
                    isPivotGroup: !0,
                    parent: n,
                    depth: t,
                    id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
                    pivotValue: u
                });
                return l.columns = e(t + 1, l, [].concat(o, [
                    function(e) {
                        return e.values[i.id] === u;
                    }
                ])), l;
            }) : l.map(function(e) {
                return r({}, e, {
                    canPivot: !1,
                    isPivoted: !0,
                    parent: n,
                    depth: t,
                    id: "" + (n ? n.id + "." + e.id : e.id),
                    accessor: function(t, n, r) {
                        if (o.every(function(e) {
                            return e(r);
                        })) return r.values[e.id];
                    }
                });
            });
        }());
        return [].concat(e, s);
    }
    function ct(e, t) {
        var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
        return [].concat(e, [
            o,
            r
        ]);
    }
    function dt(e, t) {
        var n = t.instance.state;
        return e = e.filter(function(e) {
            return !e.isPivotSource;
        }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function(e) {
            return e.isGrouped || e.isPivoted;
        })), e;
    }
    function ft(e, t) {
        var n = t.instance;
        return [].concat(e, [
            n.state.pivotColumns,
            n.state.groupBy
        ]);
    }
    function pt(e) {
        var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
        v(i, [
            "useGroupBy"
        ], "usePivotColumns");
        var g = h(e);
        n.forEach(function(t) {
            var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
            t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
                return e.togglePivot(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        o.forEach(function(e) {
            e.getPivotToggleProps = f(r().getPivotToggleProps, {
                instance: g(),
                header: e
            });
        });
        var m = h(a);
        w(function() {
            m() && u({
                type: l.resetPivot
            });
        }, [
            u,
            c ? null : t
        ]), Object.assign(e, {
            togglePivot: function(e, t) {
                u({
                    type: l.togglePivot,
                    columnId: e,
                    value: t
                });
            }
        });
    }
    function gt(e) {
        e.allCells.forEach(function(e) {
            e.isPivoted = e.column.isPivoted;
        });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e) {
        e.getToggleRowSelectedProps = [
            mt
        ], e.getToggleAllRowsSelectedProps = [
            ht
        ], e.getToggleAllPageRowsSelectedProps = [
            yt
        ], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e, t) {
        var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
        return [
            e,
            {
                onChange: function(e) {
                    o.toggleRowSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !(!o.original || !o.original[i]) || o.isSelected,
                title: "Toggle Row Selected",
                indeterminate: o.isSomeSelected
            }
        ];
    }, ht = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllRowsSelected,
                title: "Toggle All Rows Selected",
                indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
            }
        ];
    }, yt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllPageRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllPageRowsSelected,
                title: "Toggle All Current Page Rows Selected",
                indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function(e) {
                    var t = e.id;
                    return n.state.selectedRowIds[t];
                }))
            }
        ];
    };
    function wt(e, t, n, o) {
        if (t.type === l.init) return r({
            selectedRowIds: {}
        }, e);
        if (t.type === l.resetSelectedRows) return r({}, e, {
            selectedRowIds: o.initialState.selectedRowIds || {}
        });
        if (t.type === l.toggleAllRowsSelected) {
            var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
            return d ? Object.keys(c).forEach(function(e) {
                f[e] = !0;
            }) : Object.keys(c).forEach(function(e) {
                delete f[e];
            }), r({}, e, {
                selectedRowIds: f
            });
        }
        if (t.type === l.toggleRowSelected) {
            var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
            if (w === R) return e;
            var b = r({}, e.selectedRowIds);
            return function e(t) {
                var n = v[t];
                if (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n)) return y(n).forEach(function(t) {
                    return e(t.id);
                });
            }(p), r({}, e, {
                selectedRowIds: b
            });
        }
        if (t.type === l.toggleAllPageRowsSelected) {
            var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
            return C.forEach(function(e) {
                return function e(t) {
                    var n = x[t];
                    if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function(t) {
                        return e(t.id);
                    });
                }(e.id);
            }), r({}, e, {
                selectedRowIds: G
            });
        }
        return e;
    }
    function Rt(e) {
        var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
        v(i, [
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded",
            "usePagination"
        ], "useRowSelect");
        var S = t.useMemo(function() {
            var e = [];
            return o.forEach(function(t) {
                var n = m ? function e(t, n, o) {
                    if (n[t.id]) return !0;
                    var r = o(t);
                    if (r && r.length) {
                        var i = !0, u = !1;
                        return r.forEach(function(t) {
                            u && !i || (e(t, n, o) ? u = !0 : i = !1);
                        }), !!i || !!u && null;
                    }
                    return !1;
                }(t, p, b) : !!p[t.id];
                t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
            }), e;
        }, [
            o,
            m,
            p,
            b
        ]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
        C && Object.keys(a).some(function(e) {
            return !p[e];
        }) && (C = !1), C || R && R.length && R.some(function(e) {
            var t = e.id;
            return !p[t];
        }) && (x = !1);
        var P = h(d);
        w(function() {
            P() && y({
                type: l.resetSelectedRows
            });
        }, [
            y,
            n
        ]);
        var B = t.useCallback(function(e) {
            return y({
                type: l.toggleAllRowsSelected,
                value: e
            });
        }, [
            y
        ]), E = t.useCallback(function(e) {
            return y({
                type: l.toggleAllPageRowsSelected,
                value: e
            });
        }, [
            y
        ]), I = t.useCallback(function(e, t) {
            return y({
                type: l.toggleRowSelected,
                id: e,
                value: t
            });
        }, [
            y
        ]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, {
            instance: F()
        }), A = f(r().getToggleAllPageRowsSelectedProps, {
            instance: F()
        });
        Object.assign(e, {
            selectedFlatRows: S,
            isAllRowsSelected: C,
            isAllPageRowsSelected: x,
            toggleRowSelected: I,
            toggleAllRowsSelected: B,
            getToggleAllRowsSelectedProps: G,
            getToggleAllPageRowsSelectedProps: A,
            toggleAllPageRowsSelected: E
        });
    }
    function bt(e, t) {
        var n = t.instance;
        e.toggleRowSelected = function(t) {
            return n.toggleRowSelected(e.id, t);
        }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
            instance: n,
            row: e
        });
    }
    var St = function(e) {
        return {};
    }, Ct = function(e) {
        return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e) {
        e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };
    function Pt(e, t, n, o) {
        var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
        if (t.type === l.init) return r({
            rowState: {}
        }, e);
        if (t.type === l.resetRowState) return r({}, e, {
            rowState: o.initialState.rowState || {}
        });
        if (t.type === l.setRowState) {
            var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
            return r({}, e, {
                rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
            });
        }
        if (t.type === l.setCellState) {
            var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function(e) {
                return e.column.id === S;
            }));
            return r({}, e, {
                rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
                    cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
                }), R))
            });
        }
    }
    function Bt(e) {
        var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback(function(e, t) {
            return i({
                type: l.setRowState,
                rowId: e,
                value: t
            });
        }, [
            i
        ]), s = t.useCallback(function(e, t, n) {
            return i({
                type: l.setCellState,
                rowId: e,
                columnId: t,
                value: n
            });
        }, [
            i
        ]), a = h(o);
        w(function() {
            a() && i({
                type: l.resetRowState
            });
        }, [
            r
        ]), Object.assign(e, {
            setRowState: u,
            setCellState: s
        });
    }
    function Et(e, t) {
        var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
        e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
            return n.setRowState(e.id, t);
        }, e.cells.forEach(function(t) {
            e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
                return n.setCellState(e.id, t.column.id, o);
            };
        }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e) {
        e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.columnOrder
            ]);
        }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };
    function Ft(e, t, n, o) {
        return t.type === l.init ? r({
            columnOrder: []
        }, e) : t.type === l.resetColumnOrder ? r({}, e, {
            columnOrder: o.initialState.columnOrder || []
        }) : t.type === l.setColumnOrder ? r({}, e, {
            columnOrder: m(t.columnOrder, e.columnOrder)
        }) : void 0;
    }
    function Gt(e, t) {
        var n = t.instance.state.columnOrder;
        if (!n || !n.length) return e;
        for(var o = [].concat(n), r = [].concat(e), i = [], u = function() {
            var e = o.shift(), t = r.findIndex(function(t) {
                return t.id === e;
            });
            t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;)u();
        return [].concat(i, r);
    }
    function At(e) {
        var n = e.dispatch;
        e.setColumnOrder = t.useCallback(function(e) {
            return n({
                type: l.setColumnOrder,
                columnOrder: e
            });
        }, [
            n
        ]);
    }
    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e) {
        e.getResizerProps = [
            Ht
        ], e.getHeaderProps.push({
            style: {
                position: "relative"
            }
        }), e.stateReducers.push(Tt), e.useInstance.push(Wt), e.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e, t) {
        var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
                if (e.touches && e.touches.length > 1) return;
                n = !0;
            }
            var o = (function(e) {
                var t = [];
                return function e(n) {
                    n.columns && n.columns.length && n.columns.map(e);
                    t.push(n);
                }(e), t;
            })(t).map(function(e) {
                return [
                    e.id,
                    e.totalWidth
                ];
            }), i = n ? Math.round(e.touches[0].clientX) : e.clientX, u = function(e) {
                r({
                    type: l.columnResizing,
                    clientX: e
                });
            }, s = function() {
                return r({
                    type: l.columnDoneResizing
                });
            }, a = {
                mouse: {
                    moveEvent: "mousemove",
                    moveHandler: function(e) {
                        return u(e.clientX);
                    },
                    upEvent: "mouseup",
                    upHandler: function(e) {
                        document.removeEventListener("mousemove", a.mouse.moveHandler), document.removeEventListener("mouseup", a.mouse.upHandler), s();
                    }
                },
                touch: {
                    moveEvent: "touchmove",
                    moveHandler: function(e) {
                        return e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1;
                    },
                    upEvent: "touchend",
                    upHandler: function(e) {
                        document.removeEventListener(a.touch.moveEvent, a.touch.moveHandler), document.removeEventListener(a.touch.upEvent, a.touch.moveHandler), s();
                    }
                }
            }, c = n ? a.touch : a.mouse, d = !!function() {
                if ("boolean" == typeof z) return z;
                var e = !1;
                try {
                    var t = {
                        get passive () {
                            return e = !0, !1;
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                    e = !1;
                }
                return z = e;
            }() && {
                passive: !1
            };
            document.addEventListener(c.moveEvent, c.moveHandler, d), document.addEventListener(c.upEvent, c.upHandler, d), r({
                type: l.columnStartResizing,
                columnId: t.id,
                columnWidth: t.totalWidth,
                headerIdWidths: o,
                clientX: i
            });
        };
        return [
            e,
            {
                onMouseDown: function(e) {
                    return e.persist() || i(e, o);
                },
                onTouchStart: function(e) {
                    return e.persist() || i(e, o);
                },
                style: {
                    cursor: "col-resize"
                },
                draggable: !1,
                role: "separator"
            }
        ];
    };
    function Tt(e, t) {
        if (t.type === l.init) return r({
            columnResizing: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            columnResizing: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
            return r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    startX: n,
                    headerIdWidths: u,
                    columnWidth: i,
                    isResizingColumn: o
                })
            });
        }
        if (t.type === l.columnResizing) {
            var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
            return (void 0 === f ? [] : f).forEach(function(e) {
                var t = e[0], n = e[1];
                g[t] = Math.max(n + n * p, 0);
            }), r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            columnResizing: r({}, e.columnResizing, {
                startX: null,
                isResizingColumn: null
            })
        }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e) {
        var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
        t.forEach(function(e) {
            var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
            e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
                instance: i(),
                header: e
            }));
        });
    };
    function Wt(e) {
        var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
        v(n, [
            "useAbsoluteLayout"
        ], "useResizeColumns");
        var s = h(i);
        w(function() {
            s() && o({
                type: l.resetResize
            });
        }, [
            u
        ]);
        var a = t.useCallback(function() {
            return o({
                type: l.resetResize
            });
        }, [
            o
        ]);
        Object.assign(e, {
            resetResizing: a
        });
    }
    var Ot = {
        position: "absolute",
        top: 0
    }, Mt = function(e) {
        e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.column.totalLeft + "px",
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e, t) {
        return [
            e,
            {
                style: {
                    position: "relative",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Nt = {
        display: "inline-block",
        boxSizing: "border-box"
    }, Lt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Dt = function(e) {
        e.getRowProps.push(Lt), e.getHeaderGroupProps.push(Lt), e.getFooterGroupProps.push(Lt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    function Vt(e) {
        e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e, t) {
        return [
            e,
            {
                style: {
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, Xt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    flex: "1 0 auto",
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, qt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    }, Kt = function(e, t) {
        var n = t.cell;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.column.totalFlexWidth + " 0 auto",
                    minWidth: n.column.totalMinWidth + "px",
                    width: n.column.totalWidth + "px"
                }
            }
        ];
    }, Ut = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    };
    function $t(e) {
        e.stateReducers.push(Qt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "grid",
                    gridTemplateColumns: t.instance.state.gridLayout.columnWidths.map(function(e) {
                        return e;
                    }).join(" ")
                }
            }
        ];
    }, Yt = function(e, t) {
        return [
            e,
            {
                id: "header-cell-" + t.column.id,
                style: {
                    position: "sticky"
                }
            }
        ];
    };
    function Qt(e, t, n, o) {
        if ("init" === t.type) return r({
            gridLayout: {
                columnWidths: o.columns.map(function() {
                    return "auto";
                })
            }
        }, e);
        if ("columnStartResizing" === t.type) {
            var i = t.columnId, u = o.visibleColumns.findIndex(function(e) {
                return e.id === i;
            }), l = function(e) {
                var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
                if (void 0 !== n) return n;
            }(i);
            return void 0 !== l ? r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnId: i,
                    columnIndex: u,
                    startingWidth: l
                })
            }) : e;
        }
        if ("columnResizing" === t.type) {
            var s = e.gridLayout, a = s.columnIndex, c = s.startingWidth, d = s.columnWidths, f = c - (e.columnResizing.startX - t.clientX), p = [].concat(d);
            return p[a] = f + "px", r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnWidths: p
                })
            });
        }
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
        void 0 === n && (n = 0);
        var r = t.useRef({}), i = h(e), u = h(n);
        return t.useCallback(function() {
            var e = o(regeneratorRuntime.mark(function e() {
                var t, n, l, s = arguments;
                return regeneratorRuntime.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            for(t = s.length, n = new Array(t), l = 0; l < t; l++)n[l] = s[l];
                            return r.current.promise || (r.current.promise = new Promise(function(e, t) {
                                r.current.resolve = e, r.current.reject = t;
                            })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                                return regeneratorRuntime.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                                        case 5:
                                            e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                                            break;
                                        case 9:
                                            e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                                        case 12:
                                            return e.prev = 12, delete r.current.promise, e.finish(12);
                                        case 15:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, null, [
                                    [
                                        1,
                                        9,
                                        12,
                                        15
                                    ]
                                ]);
                            })), u()), e.abrupt("return", r.current.promise);
                        case 5:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), [
            i,
            u
        ]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
        e = ie(e), o = [
            K
        ].concat(o);
        var u = t.useRef({}), s = h(u.current);
        Object.assign(s(), r({}, e, {
            plugins: o,
            hooks: q()
        })), o.filter(Boolean).forEach(function(e) {
            e(s().hooks);
        });
        var a = h(s().hooks);
        s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
        var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback(function(e, t) {
            if (!t.type) throw console.info({
                action: t
            }), new Error("Unknown Action \uD83D\uDC46");
            return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [
                F()
            ]).reduce(function(n, o) {
                return o(n, t, e, s()) || n;
            }, e);
        }, [
            a,
            F,
            s
        ]), A = t.useReducer(G, void 0, function() {
            return G(m, {
                type: l.init
            });
        }), k = A[0], H = A[1], T = p([].concat(a().useControlledState, [
            I
        ]), k, {
            instance: s()
        });
        Object.assign(s(), {
            state: T,
            dispatch: H
        });
        var z = t.useMemo(function() {
            return S(p(a().columns, v, {
                instance: s()
            }));
        }, [
            a,
            s,
            v
        ].concat(p(a().columnsDeps, [], {
            instance: s()
        })));
        s().columns = z;
        var W = t.useMemo(function() {
            return p(a().allColumns, C(z), {
                instance: s()
            }).map(x);
        }, [
            z,
            a,
            s
        ].concat(p(a().allColumnsDeps, [], {
            instance: s()
        })));
        s().allColumns = W;
        var O = t.useMemo(function() {
            for(var e = [], t = [], n = {}, o = [].concat(W); o.length;){
                var r = o.shift();
                le({
                    data: d,
                    rows: e,
                    flatRows: t,
                    rowsById: n,
                    column: r,
                    getRowId: b,
                    getSubRows: w,
                    accessValueHooks: a().accessValue,
                    getInstance: s
                });
            }
            return [
                e,
                t,
                n
            ];
        }, [
            W,
            d,
            b,
            w,
            a,
            s
        ]), M = O[0], j = O[1], N = O[2];
        Object.assign(s(), {
            rows: M,
            initialRows: [].concat(M),
            flatRows: j,
            rowsById: N
        }), g(a().useInstanceAfterData, s());
        var L = t.useMemo(function() {
            return p(a().visibleColumns, W, {
                instance: s()
            }).map(function(e) {
                return P(e, y);
            });
        }, [
            a,
            W,
            s,
            y
        ].concat(p(a().visibleColumnsDeps, [], {
            instance: s()
        })));
        W = t.useMemo(function() {
            var e = [].concat(L);
            return W.forEach(function(t) {
                e.find(function(e) {
                    return e.id === t.id;
                }) || e.push(t);
            }), e;
        }, [
            W,
            L
        ]), s().allColumns = W;
        var D = t.useMemo(function() {
            return p(a().headerGroups, B(L, y), s());
        }, [
            a,
            L,
            y,
            s
        ].concat(p(a().headerGroupsDeps, [], {
            instance: s()
        })));
        s().headerGroups = D;
        var V = t.useMemo(function() {
            return D.length ? D[0].headers : [];
        }, [
            D
        ]);
        s().headers = V, s().flatHeaders = D.reduce(function(e, t) {
            return [].concat(e, t.headers);
        }, []), g(a().useInstanceBeforeDimensions, s());
        var _ = L.filter(function(e) {
            return e.isVisible;
        }).map(function(e) {
            return e.id;
        }).sort().join("_");
        L = t.useMemo(function() {
            return L.filter(function(e) {
                return e.isVisible;
            });
        }, [
            L,
            _
        ]), s().visibleColumns = L;
        var X = ue(V), U = X[0], $ = X[1], J = X[2];
        return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function(e) {
            e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
                instance: s(),
                column: e
            }), e.getFooterProps = f(a().getFooterProps, {
                instance: s(),
                column: e
            });
        }), s().headerGroups = t.useMemo(function() {
            return D.filter(function(e, t) {
                return e.headers = e.headers.filter(function(e) {
                    return e.headers ? function e(t) {
                        return t.filter(function(t) {
                            return t.headers ? e(t.headers) : t.isVisible;
                        }).length;
                    }(e.headers) : e.isVisible;
                }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), !0);
            });
        }, [
            D,
            s,
            a
        ]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function(e) {
            e.getRowProps = f(a().getRowProps, {
                instance: s(),
                row: e
            }), e.allCells = W.map(function(t) {
                var n = e.values[t.id], o = {
                    column: t,
                    row: e,
                    value: n
                };
                return o.getCellProps = f(a().getCellProps, {
                    instance: s(),
                    cell: o
                }), o.render = R(s(), t, {
                    row: e,
                    cell: o,
                    value: n
                }), o;
            }), e.cells = L.map(function(t) {
                return e.allCells.find(function(e) {
                    return e.column.id === t.id;
                });
            }), g(a().prepareRow, e, {
                instance: s()
            });
        }, [
            a,
            s,
            W,
            L
        ]), s().getTableProps = f(a().getTableProps, {
            instance: s()
        }), s().getTableBodyProps = f(a().getTableBodyProps, {
            instance: s()
        }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

var $9bbb433fb5a34647$exports = {};
$parcel$extendImportMap({
    "8RGfr": "checkmark.6bfd9145.svg",
    "6ECCK": "lego-error-page.50fe5bbf.svg",
    "5aLgo": "lego-404.8067b124.svg"
});

parcelRequire("denZA");
var $f4b08d136a5afca6$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $f4b08d136a5afca6$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $f4b08d136a5afca6$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $f4b08d136a5afca6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$f4b08d136a5afca6$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($f4b08d136a5afca6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f4b08d136a5afca6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $9dd946d56741c033$export$71ad59f2e432cfe8 = "-ms-";
var $9dd946d56741c033$export$2c0f367103c8d01c = "-moz-";
var $9dd946d56741c033$export$39dfd62a25e0fe93 = "-webkit-";
var $9dd946d56741c033$export$a29989082612d0d9 = "comm";
var $9dd946d56741c033$export$aa3a2e812ca8570d = "rule";
var $9dd946d56741c033$export$527d108ccf083c2b = "decl";
var $9dd946d56741c033$export$d3d35020fa5b54f0 = "@page";
var $9dd946d56741c033$export$500415a86c544f73 = "@media";
var $9dd946d56741c033$export$a763edbf796b780a = "@import";
var $9dd946d56741c033$export$2790aeb8b4e5c826 = "@charset";
var $9dd946d56741c033$export$1cc683e23b84b133 = "@viewport";
var $9dd946d56741c033$export$9447a5efea57e862 = "@supports";
var $9dd946d56741c033$export$ef011b4e114b1fba = "@document";
var $9dd946d56741c033$export$6aad947bda0f3f46 = "@namespace";
var $9dd946d56741c033$export$b44a8529a35fcb60 = "@keyframes";
var $9dd946d56741c033$export$2c16de31893252e6 = "@font-face";
var $9dd946d56741c033$export$3d846dd52e150c6f = "@counter-style";
var $9dd946d56741c033$export$22314bfbb57653fe = "@font-feature-values";
var $9dd946d56741c033$export$d773506282b3cfe6 = "@layer";
var $9dd946d56741c033$export$2335f513bbd82c6d = Math.abs;
var $9dd946d56741c033$export$6788812c4e6611e6 = String.fromCharCode;
var $9dd946d56741c033$export$e6e34fd1f2686227 = Object.assign;
function $9dd946d56741c033$export$d6af199866bfb566(e, r) {
    return $9dd946d56741c033$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $9dd946d56741c033$export$a9db5e087081082d(e, 0)) << 2 ^ $9dd946d56741c033$export$a9db5e087081082d(e, 1)) << 2 ^ $9dd946d56741c033$export$a9db5e087081082d(e, 2)) << 2 ^ $9dd946d56741c033$export$a9db5e087081082d(e, 3) : 0;
}
function $9dd946d56741c033$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $9dd946d56741c033$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $9dd946d56741c033$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $9dd946d56741c033$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $9dd946d56741c033$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $9dd946d56741c033$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $9dd946d56741c033$export$36776f635604f274(e) {
    return e.length;
}
function $9dd946d56741c033$export$f9084667e487ed46(e) {
    return e.length;
}
function $9dd946d56741c033$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $9dd946d56741c033$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $9dd946d56741c033$export$53f1d5ea8de3d7c = 1;
var $9dd946d56741c033$export$4e0c71f277ca26b3 = 1;
var $9dd946d56741c033$export$f24224f1c91d8156 = 0;
var $9dd946d56741c033$export$5880b8b5730aff45 = 0;
var $9dd946d56741c033$export$c0306caf338ac095 = 0;
var $9dd946d56741c033$export$30a86d91af8ff6e6 = "";
function $9dd946d56741c033$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $9dd946d56741c033$export$53f1d5ea8de3d7c,
        column: $9dd946d56741c033$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $9dd946d56741c033$export$784d13d8ee351f07(e, r) {
    return $9dd946d56741c033$export$e6e34fd1f2686227($9dd946d56741c033$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $9dd946d56741c033$export$eba6f6f03b0a92e7() {
    return $9dd946d56741c033$export$c0306caf338ac095;
}
function $9dd946d56741c033$export$232faf9add678146() {
    $9dd946d56741c033$export$c0306caf338ac095 = $9dd946d56741c033$export$5880b8b5730aff45 > 0 ? $9dd946d56741c033$export$a9db5e087081082d($9dd946d56741c033$export$30a86d91af8ff6e6, --$9dd946d56741c033$export$5880b8b5730aff45) : 0;
    if ($9dd946d56741c033$export$4e0c71f277ca26b3--, $9dd946d56741c033$export$c0306caf338ac095 === 10) $9dd946d56741c033$export$4e0c71f277ca26b3 = 1, $9dd946d56741c033$export$53f1d5ea8de3d7c--;
    return $9dd946d56741c033$export$c0306caf338ac095;
}
function $9dd946d56741c033$export$48cfd1e771a65c4f() {
    $9dd946d56741c033$export$c0306caf338ac095 = $9dd946d56741c033$export$5880b8b5730aff45 < $9dd946d56741c033$export$f24224f1c91d8156 ? $9dd946d56741c033$export$a9db5e087081082d($9dd946d56741c033$export$30a86d91af8ff6e6, $9dd946d56741c033$export$5880b8b5730aff45++) : 0;
    if ($9dd946d56741c033$export$4e0c71f277ca26b3++, $9dd946d56741c033$export$c0306caf338ac095 === 10) $9dd946d56741c033$export$4e0c71f277ca26b3 = 1, $9dd946d56741c033$export$53f1d5ea8de3d7c++;
    return $9dd946d56741c033$export$c0306caf338ac095;
}
function $9dd946d56741c033$export$4d3fb11e950abb9e() {
    return $9dd946d56741c033$export$a9db5e087081082d($9dd946d56741c033$export$30a86d91af8ff6e6, $9dd946d56741c033$export$5880b8b5730aff45);
}
function $9dd946d56741c033$export$e88cb2efb12ae807() {
    return $9dd946d56741c033$export$5880b8b5730aff45;
}
function $9dd946d56741c033$export$58adb3bec8346d0f(e, r) {
    return $9dd946d56741c033$export$2f35ab04d2335697($9dd946d56741c033$export$30a86d91af8ff6e6, e, r);
}
function $9dd946d56741c033$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $9dd946d56741c033$export$2de70f21292aac9e(e) {
    return $9dd946d56741c033$export$53f1d5ea8de3d7c = $9dd946d56741c033$export$4e0c71f277ca26b3 = 1, $9dd946d56741c033$export$f24224f1c91d8156 = $9dd946d56741c033$export$36776f635604f274($9dd946d56741c033$export$30a86d91af8ff6e6 = e), $9dd946d56741c033$export$5880b8b5730aff45 = 0, [];
}
function $9dd946d56741c033$export$45918ac1574455b1(e) {
    return $9dd946d56741c033$export$30a86d91af8ff6e6 = "", e;
}
function $9dd946d56741c033$export$410ac95b9ec204b8(e) {
    return $9dd946d56741c033$export$87c2784dc9fc4ab($9dd946d56741c033$export$58adb3bec8346d0f($9dd946d56741c033$export$5880b8b5730aff45 - 1, $9dd946d56741c033$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $9dd946d56741c033$export$660b2ee2d4fb4eff(e) {
    return $9dd946d56741c033$export$45918ac1574455b1($9dd946d56741c033$export$5f8c09e3ae6f64e1($9dd946d56741c033$export$2de70f21292aac9e(e)));
}
function $9dd946d56741c033$export$7af1228ff777d175(e) {
    while($9dd946d56741c033$export$c0306caf338ac095 = $9dd946d56741c033$export$4d3fb11e950abb9e())if ($9dd946d56741c033$export$c0306caf338ac095 < 33) $9dd946d56741c033$export$48cfd1e771a65c4f();
    else break;
    return $9dd946d56741c033$export$9e1725a4cfeada27(e) > 2 || $9dd946d56741c033$export$9e1725a4cfeada27($9dd946d56741c033$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $9dd946d56741c033$export$5f8c09e3ae6f64e1(e) {
    while($9dd946d56741c033$export$48cfd1e771a65c4f())switch($9dd946d56741c033$export$9e1725a4cfeada27($9dd946d56741c033$export$c0306caf338ac095)){
        case 0:
            $9dd946d56741c033$export$10d8903dec122b9d($9dd946d56741c033$export$c2ab62c7bf24634($9dd946d56741c033$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $9dd946d56741c033$export$10d8903dec122b9d($9dd946d56741c033$export$410ac95b9ec204b8($9dd946d56741c033$export$c0306caf338ac095), e);
            break;
        default:
            $9dd946d56741c033$export$10d8903dec122b9d($9dd946d56741c033$export$6788812c4e6611e6($9dd946d56741c033$export$c0306caf338ac095), e);
    }
    return e;
}
function $9dd946d56741c033$export$955ba06d119e085e(e, r) {
    while(--r && $9dd946d56741c033$export$48cfd1e771a65c4f())if ($9dd946d56741c033$export$c0306caf338ac095 < 48 || $9dd946d56741c033$export$c0306caf338ac095 > 102 || $9dd946d56741c033$export$c0306caf338ac095 > 57 && $9dd946d56741c033$export$c0306caf338ac095 < 65 || $9dd946d56741c033$export$c0306caf338ac095 > 70 && $9dd946d56741c033$export$c0306caf338ac095 < 97) break;
    return $9dd946d56741c033$export$58adb3bec8346d0f(e, $9dd946d56741c033$export$e88cb2efb12ae807() + (r < 6 && $9dd946d56741c033$export$4d3fb11e950abb9e() == 32 && $9dd946d56741c033$export$48cfd1e771a65c4f() == 32));
}
function $9dd946d56741c033$export$c889f2fcc19dbf12(e) {
    while($9dd946d56741c033$export$48cfd1e771a65c4f())switch($9dd946d56741c033$export$c0306caf338ac095){
        case e:
            return $9dd946d56741c033$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $9dd946d56741c033$export$c889f2fcc19dbf12($9dd946d56741c033$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $9dd946d56741c033$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $9dd946d56741c033$export$48cfd1e771a65c4f();
            break;
    }
    return $9dd946d56741c033$export$5880b8b5730aff45;
}
function $9dd946d56741c033$export$4254d4e2b3745c4c(e, r) {
    while($9dd946d56741c033$export$48cfd1e771a65c4f())if (e + $9dd946d56741c033$export$c0306caf338ac095 === 57) break;
    else if (e + $9dd946d56741c033$export$c0306caf338ac095 === 84 && $9dd946d56741c033$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $9dd946d56741c033$export$58adb3bec8346d0f(r, $9dd946d56741c033$export$5880b8b5730aff45 - 1) + "*" + $9dd946d56741c033$export$6788812c4e6611e6(e === 47 ? e : $9dd946d56741c033$export$48cfd1e771a65c4f());
}
function $9dd946d56741c033$export$c2ab62c7bf24634(e) {
    while(!$9dd946d56741c033$export$9e1725a4cfeada27($9dd946d56741c033$export$4d3fb11e950abb9e()))$9dd946d56741c033$export$48cfd1e771a65c4f();
    return $9dd946d56741c033$export$58adb3bec8346d0f(e, $9dd946d56741c033$export$5880b8b5730aff45);
}
function $9dd946d56741c033$export$ef7acd7185315e22(e) {
    return $9dd946d56741c033$export$45918ac1574455b1($9dd946d56741c033$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $9dd946d56741c033$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $9dd946d56741c033$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $9dd946d56741c033$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $9dd946d56741c033$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($9dd946d56741c033$export$f8e21b1e77979a08(j += $9dd946d56741c033$export$77ad94ebf1c2b9ed($9dd946d56741c033$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $9dd946d56741c033$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $9dd946d56741c033$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $9dd946d56741c033$export$955ba06d119e085e($9dd946d56741c033$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($9dd946d56741c033$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $9dd946d56741c033$export$10d8903dec122b9d($9dd946d56741c033$export$4a34f930e789283c($9dd946d56741c033$export$4254d4e2b3745c4c($9dd946d56741c033$export$48cfd1e771a65c4f(), $9dd946d56741c033$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $9dd946d56741c033$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $9dd946d56741c033$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $9dd946d56741c033$export$36776f635604f274(j) - l) $9dd946d56741c033$export$10d8903dec122b9d(p > 32 ? $9dd946d56741c033$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $9dd946d56741c033$export$f8483753829ec8f3($9dd946d56741c033$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $9dd946d56741c033$export$10d8903dec122b9d(y = $9dd946d56741c033$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $9dd946d56741c033$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $9dd946d56741c033$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $9dd946d56741c033$export$98e6a39c04603d36(e, y, y, n && $9dd946d56741c033$export$10d8903dec122b9d($9dd946d56741c033$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $9dd946d56741c033$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $9dd946d56741c033$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $9dd946d56741c033$export$232faf9add678146() == 125) continue;
            }
            switch(j += $9dd946d56741c033$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($9dd946d56741c033$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($9dd946d56741c033$export$4d3fb11e950abb9e() === 45) j += $9dd946d56741c033$export$410ac95b9ec204b8($9dd946d56741c033$export$48cfd1e771a65c4f());
                    v = $9dd946d56741c033$export$4d3fb11e950abb9e(), o = l = $9dd946d56741c033$export$36776f635604f274(g = j += $9dd946d56741c033$export$c2ab62c7bf24634($9dd946d56741c033$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $9dd946d56741c033$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $9dd946d56741c033$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $9dd946d56741c033$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $9dd946d56741c033$export$2f35ab04d2335697(e, v + 1, v = $9dd946d56741c033$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $9dd946d56741c033$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $9dd946d56741c033$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $9dd946d56741c033$export$35059013cd4a06db(e, r, a, s === 0 ? $9dd946d56741c033$export$aa3a2e812ca8570d : i, f, o, l);
}
function $9dd946d56741c033$export$4a34f930e789283c(e, r, a) {
    return $9dd946d56741c033$export$35059013cd4a06db(e, r, a, $9dd946d56741c033$export$a29989082612d0d9, $9dd946d56741c033$export$6788812c4e6611e6($9dd946d56741c033$export$eba6f6f03b0a92e7()), $9dd946d56741c033$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $9dd946d56741c033$export$f8483753829ec8f3(e, r, a, n) {
    return $9dd946d56741c033$export$35059013cd4a06db(e, r, a, $9dd946d56741c033$export$527d108ccf083c2b, $9dd946d56741c033$export$2f35ab04d2335697(e, 0, n), $9dd946d56741c033$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $9dd946d56741c033$export$82e9f45cca5ba907(n, c, s) {
    switch($9dd946d56741c033$export$d6af199866bfb566(n, c)){
        case 5103:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $9dd946d56741c033$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$2c0f367103c8d01c + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($9dd946d56741c033$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "box-$1$2" + $9dd946d56741c033$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + "flex-item-" + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$9dd946d56741c033$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $9dd946d56741c033$export$71ad59f2e432cfe8 + "grid-row-" + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + "flex-line-pack" + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + "box-" + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "-grow", "") + $9dd946d56741c033$export$39dfd62a25e0fe93 + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $9dd946d56741c033$export$39dfd62a25e0fe93 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $9dd946d56741c033$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed($9dd946d56741c033$export$77ad94ebf1c2b9ed($9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed($9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "box-pack:$3" + $9dd946d56741c033$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $9dd946d56741c033$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$9dd946d56741c033$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $9dd946d56741c033$export$71ad59f2e432cfe8 + "grid-column-align" + $9dd946d56741c033$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $9dd946d56741c033$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$9dd946d56741c033$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $9dd946d56741c033$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$9dd946d56741c033$export$f8e21b1e77979a08(s, "span") ? $9dd946d56741c033$export$4659b591c19bdf3d(s, /\d+/) : +$9dd946d56741c033$export$4659b591c19bdf3d(s, /\d+/) - +$9dd946d56741c033$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $9dd946d56741c033$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $9dd946d56741c033$export$71ad59f2e432cfe8 + $9dd946d56741c033$export$77ad94ebf1c2b9ed($9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $9dd946d56741c033$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($9dd946d56741c033$export$36776f635604f274(n) - 1 - c > 6) switch($9dd946d56741c033$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($9dd946d56741c033$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $9dd946d56741c033$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $9dd946d56741c033$export$2c0f367103c8d01c + ($9dd946d56741c033$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$9dd946d56741c033$export$f8e21b1e77979a08(n, "stretch") ? $9dd946d56741c033$export$82e9f45cca5ba907($9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $9dd946d56741c033$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $9dd946d56741c033$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($9dd946d56741c033$export$a9db5e087081082d(n, c + 6) === 121) return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, ":", ":" + $9dd946d56741c033$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($9dd946d56741c033$export$a9db5e087081082d(n, $9dd946d56741c033$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $9dd946d56741c033$export$39dfd62a25e0fe93 + ($9dd946d56741c033$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $9dd946d56741c033$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $9dd946d56741c033$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, ":", ":" + $9dd946d56741c033$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $9dd946d56741c033$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $9dd946d56741c033$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $9dd946d56741c033$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $9dd946d56741c033$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $9dd946d56741c033$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $9dd946d56741c033$export$a763edbf796b780a:
        case $9dd946d56741c033$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $9dd946d56741c033$export$a29989082612d0d9:
            return "";
        case $9dd946d56741c033$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $9dd946d56741c033$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $9dd946d56741c033$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $9dd946d56741c033$export$36776f635604f274(a = $9dd946d56741c033$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $9dd946d56741c033$export$5a7767152ae0305f(e) {
    var r = $9dd946d56741c033$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $9dd946d56741c033$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $9dd946d56741c033$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $9dd946d56741c033$export$527d108ccf083c2b:
                n.return = $9dd946d56741c033$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $9dd946d56741c033$export$b44a8529a35fcb60:
                return $9dd946d56741c033$export$dfdc1655ccc5b9cb([
                    $9dd946d56741c033$export$784d13d8ee351f07(n, {
                        value: $9dd946d56741c033$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $9dd946d56741c033$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $9dd946d56741c033$export$aa3a2e812ca8570d:
                if (n.length) return $9dd946d56741c033$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($9dd946d56741c033$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $9dd946d56741c033$export$dfdc1655ccc5b9cb([
                                $9dd946d56741c033$export$784d13d8ee351f07(n, {
                                    props: [
                                        $9dd946d56741c033$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $9dd946d56741c033$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $9dd946d56741c033$export$dfdc1655ccc5b9cb([
                                $9dd946d56741c033$export$784d13d8ee351f07(n, {
                                    props: [
                                        $9dd946d56741c033$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9dd946d56741c033$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $9dd946d56741c033$export$784d13d8ee351f07(n, {
                                    props: [
                                        $9dd946d56741c033$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9dd946d56741c033$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $9dd946d56741c033$export$784d13d8ee351f07(n, {
                                    props: [
                                        $9dd946d56741c033$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $9dd946d56741c033$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $9dd946d56741c033$export$76a88f7de6507443(e) {
    switch(e.type){
        case $9dd946d56741c033$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $9dd946d56741c033$export$1be1fc439b849fdf($9dd946d56741c033$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($9dd946d56741c033$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $9dd946d56741c033$export$2f35ab04d2335697(r, 1, $9dd946d56741c033$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $9dd946d56741c033$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $9dd946d56741c033$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $9dd946d56741c033$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $3050f2889b70ef35$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $511dd05da8fbca8a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $2aaccd627868fbab$var$isBrowser = typeof document !== 'undefined';
var $2aaccd627868fbab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $9dd946d56741c033$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $9dd946d56741c033$export$9e1725a4cfeada27)(character)) break;
        (0, $9dd946d56741c033$export$48cfd1e771a65c4f)();
    }
    return (0, $9dd946d56741c033$export$58adb3bec8346d0f)(begin, (0, $9dd946d56741c033$export$5880b8b5730aff45));
};
var $2aaccd627868fbab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $9dd946d56741c033$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $9dd946d56741c033$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2aaccd627868fbab$var$identifierWithPointTracking((0, $9dd946d56741c033$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $9dd946d56741c033$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $9dd946d56741c033$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9dd946d56741c033$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $9dd946d56741c033$export$48cfd1e771a65c4f)());
    return parsed;
};
var $2aaccd627868fbab$var$getRules = function getRules(value, points) {
    return (0, $9dd946d56741c033$export$45918ac1574455b1)($2aaccd627868fbab$var$toRules((0, $9dd946d56741c033$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2aaccd627868fbab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2aaccd627868fbab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2aaccd627868fbab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2aaccd627868fbab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2aaccd627868fbab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2aaccd627868fbab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $2aaccd627868fbab$var$prefix(value, length) {
    switch((0, $9dd946d56741c033$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$2c0f367103c8d01c) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + 'box-' + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)((0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)((0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)((0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9dd946d56741c033$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $9dd946d56741c033$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9dd946d56741c033$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $9dd946d56741c033$export$2c0f367103c8d01c) + ((0, $9dd946d56741c033$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9dd946d56741c033$export$f8e21b1e77979a08)(value, 'stretch') ? $2aaccd627868fbab$var$prefix((0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9dd946d56741c033$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9dd946d56741c033$export$a9db5e087081082d)(value, (0, $9dd946d56741c033$export$36776f635604f274)(value) - 3 - (~(0, $9dd946d56741c033$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + ((0, $9dd946d56741c033$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9dd946d56741c033$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + value + (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $2aaccd627868fbab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $9dd946d56741c033$export$527d108ccf083c2b:
                element["return"] = $2aaccd627868fbab$var$prefix(element.value, element.length);
                break;
            case 0, $9dd946d56741c033$export$b44a8529a35fcb60:
                return (0, $9dd946d56741c033$export$dfdc1655ccc5b9cb)([
                    (0, $9dd946d56741c033$export$784d13d8ee351f07)(element, {
                        value: (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $9dd946d56741c033$export$aa3a2e812ca8570d:
                if (element.length) return (0, $9dd946d56741c033$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $9dd946d56741c033$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $9dd946d56741c033$export$dfdc1655ccc5b9cb)([
                                (0, $9dd946d56741c033$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $9dd946d56741c033$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $9dd946d56741c033$export$dfdc1655ccc5b9cb)([
                                (0, $9dd946d56741c033$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $9dd946d56741c033$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $9dd946d56741c033$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $9dd946d56741c033$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $9dd946d56741c033$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $9dd946d56741c033$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $9dd946d56741c033$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $2aaccd627868fbab$var$getServerStylisCache = $2aaccd627868fbab$var$isBrowser ? undefined : (0, $3050f2889b70ef35$export$2e2bcd8739ae039)(function() {
    return (0, $511dd05da8fbca8a$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $2aaccd627868fbab$var$defaultStylisPlugins = [
    $2aaccd627868fbab$var$prefixer
];
var $2aaccd627868fbab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($2aaccd627868fbab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $2aaccd627868fbab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($2aaccd627868fbab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $2aaccd627868fbab$var$compat,
        $2aaccd627868fbab$var$removeLabel
    ];
    if (!$2aaccd627868fbab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $9dd946d56741c033$export$fac44ee5b035f737),
            (0, $9dd946d56741c033$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $9dd946d56741c033$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $9dd946d56741c033$export$dfdc1655ccc5b9cb)((0, $9dd946d56741c033$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $9dd946d56741c033$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $9dd946d56741c033$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $9dd946d56741c033$export$dfdc1655ccc5b9cb)((0, $9dd946d56741c033$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $2aaccd627868fbab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $f4b08d136a5afca6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};



var $denZA = parcelRequire("denZA");

function $78dfc96d1f03aba0$export$2e2bcd8739ae039() {
    return $78dfc96d1f03aba0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $78dfc96d1f03aba0$export$2e2bcd8739ae039.apply(null, arguments);
}


var $fe871eb1f294ed50$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $fe871eb1f294ed50$export$2e2bcd8739ae039 = $fe871eb1f294ed50$var$weakMemoize;


var $4080a25632a78fde$exports = {};
'use strict';
var $acc4579a148d10c8$exports = {};
'use strict';

$acc4579a148d10c8$exports = (parcelRequire("kzTA8"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4080a25632a78fde$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4080a25632a78fde$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4080a25632a78fde$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4080a25632a78fde$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4080a25632a78fde$var$TYPE_STATICS = {};
$4080a25632a78fde$var$TYPE_STATICS[$acc4579a148d10c8$exports.ForwardRef] = $4080a25632a78fde$var$FORWARD_REF_STATICS;
$4080a25632a78fde$var$TYPE_STATICS[$acc4579a148d10c8$exports.Memo] = $4080a25632a78fde$var$MEMO_STATICS;
function $4080a25632a78fde$var$getStatics(component) {
    // React v16.11 and below
    if ($acc4579a148d10c8$exports.isMemo(component)) return $4080a25632a78fde$var$MEMO_STATICS;
     // React v16.12 and above
    return $4080a25632a78fde$var$TYPE_STATICS[component['$$typeof']] || $4080a25632a78fde$var$REACT_STATICS;
}
var $4080a25632a78fde$var$defineProperty = Object.defineProperty;
var $4080a25632a78fde$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4080a25632a78fde$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4080a25632a78fde$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4080a25632a78fde$var$getPrototypeOf = Object.getPrototypeOf;
var $4080a25632a78fde$var$objectPrototype = Object.prototype;
function $4080a25632a78fde$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4080a25632a78fde$var$objectPrototype) {
            var inheritedComponent = $4080a25632a78fde$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4080a25632a78fde$var$objectPrototype) $4080a25632a78fde$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4080a25632a78fde$var$getOwnPropertyNames(sourceComponent);
        if ($4080a25632a78fde$var$getOwnPropertySymbols) keys = keys.concat($4080a25632a78fde$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4080a25632a78fde$var$getStatics(targetComponent);
        var sourceStatics = $4080a25632a78fde$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4080a25632a78fde$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4080a25632a78fde$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4080a25632a78fde$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$4080a25632a78fde$exports = $4080a25632a78fde$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $fd09c4e1c8ba03a1$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4080a25632a78fde$exports)))(targetComponent, sourceComponent);
};
var $fd09c4e1c8ba03a1$export$2e2bcd8739ae039 = $fd09c4e1c8ba03a1$var$hoistNonReactStatics;


var $1278f2480a4a1734$var$isBrowser = typeof document !== 'undefined';
function $1278f2480a4a1734$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $1278f2480a4a1734$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1278f2480a4a1734$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1278f2480a4a1734$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1278f2480a4a1734$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$1278f2480a4a1734$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$1278f2480a4a1734$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $8b88a4e9975771c2$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $4e6e6a7d058448be$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $d1c95c767e684975$var$isDevelopment = false;
var $d1c95c767e684975$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d1c95c767e684975$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d1c95c767e684975$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d1c95c767e684975$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $d1c95c767e684975$var$processStyleName = /* #__PURE__ */ (0, $511dd05da8fbca8a$export$2e2bcd8739ae039)(function(styleName) {
    return $d1c95c767e684975$var$isCustomProperty(styleName) ? styleName : styleName.replace($d1c95c767e684975$var$hyphenateRegex, '-$&').toLowerCase();
});
var $d1c95c767e684975$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($d1c95c767e684975$var$animationRegex, function(match, p1, p2) {
                $d1c95c767e684975$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d1c95c767e684975$var$cursor
                };
                return p1;
            });
    }
    if ((0, $4e6e6a7d058448be$export$2e2bcd8739ae039)[key] !== 1 && !$d1c95c767e684975$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $d1c95c767e684975$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $d1c95c767e684975$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $d1c95c767e684975$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d1c95c767e684975$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d1c95c767e684975$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $d1c95c767e684975$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $d1c95c767e684975$var$cursor;
                var result = interpolation(mergedProps);
                $d1c95c767e684975$var$cursor = previousCursor;
                return $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $d1c95c767e684975$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($d1c95c767e684975$var$isProcessableValue(asString)) string += $d1c95c767e684975$var$processStyleName(key) + ":" + $d1c95c767e684975$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $d1c95c767e684975$var$isDevelopment) throw new Error($d1c95c767e684975$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d1c95c767e684975$var$isProcessableValue(value[_i])) string += $d1c95c767e684975$var$processStyleName(key) + ":" + $d1c95c767e684975$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $d1c95c767e684975$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d1c95c767e684975$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $d1c95c767e684975$var$cursor;
function $d1c95c767e684975$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $d1c95c767e684975$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d1c95c767e684975$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $d1c95c767e684975$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d1c95c767e684975$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $8b88a4e9975771c2$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d1c95c767e684975$var$cursor
    };
}


var $b586a210f9df88c2$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $b586a210f9df88c2$var$EmotionCacheContext = /* #__PURE__ */ (0, $denZA.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $2aaccd627868fbab$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $b586a210f9df88c2$export$e7094788287c5e9b = $b586a210f9df88c2$var$EmotionCacheContext.Provider;
var $b586a210f9df88c2$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $denZA.useContext)($b586a210f9df88c2$var$EmotionCacheContext);
};
var $b586a210f9df88c2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $denZA.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $denZA.useContext)($b586a210f9df88c2$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $b586a210f9df88c2$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $denZA.createContext)({});
var $b586a210f9df88c2$export$3b14a55fb2447963 = function useTheme() {
    return (0, $denZA.useContext)($b586a210f9df88c2$export$971d5caa766a69d7);
};
var $b586a210f9df88c2$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $b586a210f9df88c2$var$createCacheWithTheme = /* #__PURE__ */ (0, $fe871eb1f294ed50$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $fe871eb1f294ed50$export$2e2bcd8739ae039)(function(theme) {
        return $b586a210f9df88c2$var$getTheme(outerTheme, theme);
    });
});
var $b586a210f9df88c2$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $denZA.useContext)($b586a210f9df88c2$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $b586a210f9df88c2$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $denZA.createElement)($b586a210f9df88c2$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $b586a210f9df88c2$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $denZA.useContext)($b586a210f9df88c2$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $denZA.createElement)(Component, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $denZA.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fd09c4e1c8ba03a1$export$2e2bcd8739ae039)(WithTheme, Component);
}
// thus we only need to replace what is a valid character for JS, but not for CSS
var $b586a210f9df88c2$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $b586a210f9df88c2$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $b586a210f9df88c2$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $b586a210f9df88c2$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($b586a210f9df88c2$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$b586a210f9df88c2$var$typePropName] = type;
    var error, match;
    return newProps;
};
var $b586a210f9df88c2$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $b586a210f9df88c2$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$b586a210f9df88c2$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $1278f2480a4a1734$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $d1c95c767e684975$export$6321afa313b251b5)(registeredStyles, undefined, (0, $denZA.useContext)($b586a210f9df88c2$export$971d5caa766a69d7));
    var labelFromStack;
    var rules = (0, $1278f2480a4a1734$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($b586a210f9df88c2$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $b586a210f9df88c2$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $denZA.createElement)(type, newProps);
    return ele;
});


var $cba4caf5919b97f9$exports = {};
function $cba4caf5919b97f9$var$_extends() {
    return $cba4caf5919b97f9$exports = $cba4caf5919b97f9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cba4caf5919b97f9$exports.__esModule = true, $cba4caf5919b97f9$exports["default"] = $cba4caf5919b97f9$exports, $cba4caf5919b97f9$var$_extends.apply(null, arguments);
}
$cba4caf5919b97f9$exports = $cba4caf5919b97f9$var$_extends, $cba4caf5919b97f9$exports.__esModule = true, $cba4caf5919b97f9$exports["default"] = $cba4caf5919b97f9$exports;







var $e208e4c212768ccf$exports = {};
'use strict';

$e208e4c212768ccf$exports = (parcelRequire("1Gy4F"));


var $3065b8940bbf3845$export$ffb0004e005737fa = (0, $e208e4c212768ccf$exports.Fragment);
function $3065b8940bbf3845$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $b586a210f9df88c2$export$dda1d9f60106f0e9).call(props, 'css')) return (0, $e208e4c212768ccf$exports.jsx)(type, props, key);
    return (0, $e208e4c212768ccf$exports.jsx)((0, $b586a210f9df88c2$export$a9c23c6ac3fc3eca), (0, $b586a210f9df88c2$export$db3b6bfb95261072)(type, props), key);
}
function $3065b8940bbf3845$export$25062201e9e25d76(type, props, key) {
    if (!(0, $b586a210f9df88c2$export$dda1d9f60106f0e9).call(props, 'css')) return (0, $e208e4c212768ccf$exports.jsxs)(type, props, key);
    return (0, $e208e4c212768ccf$exports.jsxs)((0, $b586a210f9df88c2$export$a9c23c6ac3fc3eca), (0, $b586a210f9df88c2$export$db3b6bfb95261072)(type, props), key);
}


var $d486a8928008256a$exports = {};
'use strict';
function $d486a8928008256a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d486a8928008256a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d486a8928008256a$var$checkDCE();

$d486a8928008256a$exports = (parcelRequire("hguJr"));



function $02bd24b5ece937eb$export$2e2bcd8739ae039(t, e) {
    return $02bd24b5ece937eb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $02bd24b5ece937eb$export$2e2bcd8739ae039(t, e);
}


function $219455562f995e41$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $02bd24b5ece937eb$export$2e2bcd8739ae039)(t, o);
}



var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");

function $62758d237043c32c$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $62758d237043c32c$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $62758d237043c32c$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $62758d237043c32c$var$isAbsolute(to);
    var isFromAbs = from && $62758d237043c32c$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $62758d237043c32c$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $62758d237043c32c$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $62758d237043c32c$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $62758d237043c32c$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$62758d237043c32c$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $62758d237043c32c$export$2e2bcd8739ae039 = $62758d237043c32c$var$resolvePathname;


function $b30c45e4c3841e63$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $b30c45e4c3841e63$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $b30c45e4c3841e63$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $b30c45e4c3841e63$var$valueOf(a);
        var bValue = $b30c45e4c3841e63$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $b30c45e4c3841e63$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $b30c45e4c3841e63$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $b30c45e4c3841e63$export$2e2bcd8739ae039 = $b30c45e4c3841e63$var$valueEqual;



var $0c0a5d185b6e826c$var$isProduction = true;
var $0c0a5d185b6e826c$var$prefix = 'Invariant failed';
function $0c0a5d185b6e826c$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0c0a5d185b6e826c$var$isProduction) throw new Error($0c0a5d185b6e826c$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0c0a5d185b6e826c$var$prefix, ": ").concat(provided) : $0c0a5d185b6e826c$var$prefix;
    throw new Error(value);
}


function $6c86b1a1c6654d60$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $6c86b1a1c6654d60$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $6c86b1a1c6654d60$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $6c86b1a1c6654d60$var$stripBasename(path, prefix) {
    return $6c86b1a1c6654d60$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $6c86b1a1c6654d60$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $6c86b1a1c6654d60$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $6c86b1a1c6654d60$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $6c86b1a1c6654d60$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $62758d237043c32c$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $6c86b1a1c6654d60$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $b30c45e4c3841e63$export$2e2bcd8739ae039)(a.state, b.state);
}
function $6c86b1a1c6654d60$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $6c86b1a1c6654d60$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $6c86b1a1c6654d60$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $6c86b1a1c6654d60$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $6c86b1a1c6654d60$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $6c86b1a1c6654d60$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $6c86b1a1c6654d60$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $6c86b1a1c6654d60$var$PopStateEvent = 'popstate';
var $6c86b1a1c6654d60$var$HashChangeEvent = 'hashchange';
function $6c86b1a1c6654d60$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $6c86b1a1c6654d60$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$6c86b1a1c6654d60$var$canUseDOM && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $6c86b1a1c6654d60$var$supportsHistory();
    var needsHashChangeListener = !$6c86b1a1c6654d60$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6c86b1a1c6654d60$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $6c86b1a1c6654d60$var$stripTrailingSlash($6c86b1a1c6654d60$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $6c86b1a1c6654d60$var$stripBasename(path, basename);
        return $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $6c86b1a1c6654d60$var$createTransitionManager();
    function setState(nextState) {
        (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($6c86b1a1c6654d60$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($6c86b1a1c6654d60$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($6c86b1a1c6654d60$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $6c86b1a1c6654d60$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($6c86b1a1c6654d60$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($6c86b1a1c6654d60$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($6c86b1a1c6654d60$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($6c86b1a1c6654d60$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $6c86b1a1c6654d60$var$HashChangeEvent$1 = 'hashchange';
var $6c86b1a1c6654d60$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $6c86b1a1c6654d60$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $6c86b1a1c6654d60$var$stripLeadingSlash,
        decodePath: $6c86b1a1c6654d60$var$addLeadingSlash
    },
    slash: {
        encodePath: $6c86b1a1c6654d60$var$addLeadingSlash,
        decodePath: $6c86b1a1c6654d60$var$addLeadingSlash
    }
};
function $6c86b1a1c6654d60$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $6c86b1a1c6654d60$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $6c86b1a1c6654d60$var$pushHashPath(path) {
    window.location.hash = path;
}
function $6c86b1a1c6654d60$var$replaceHashPath(path) {
    window.location.replace($6c86b1a1c6654d60$var$stripHash(window.location.href) + '#' + path);
}
function $6c86b1a1c6654d60$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$6c86b1a1c6654d60$var$canUseDOM && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $6c86b1a1c6654d60$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $6c86b1a1c6654d60$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $6c86b1a1c6654d60$var$stripTrailingSlash($6c86b1a1c6654d60$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $6c86b1a1c6654d60$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($6c86b1a1c6654d60$var$getHashPath());
        if (basename) path = $6c86b1a1c6654d60$var$stripBasename(path, basename);
        return $6c86b1a1c6654d60$export$90c043f1c57770b8(path);
    }
    var transitionManager = $6c86b1a1c6654d60$var$createTransitionManager();
    function setState(nextState) {
        (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $6c86b1a1c6654d60$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $6c86b1a1c6654d60$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $6c86b1a1c6654d60$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($6c86b1a1c6654d60$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($6c86b1a1c6654d60$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $6c86b1a1c6654d60$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $6c86b1a1c6654d60$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $6c86b1a1c6654d60$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $6c86b1a1c6654d60$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $6c86b1a1c6654d60$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6c86b1a1c6654d60$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6c86b1a1c6654d60$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6c86b1a1c6654d60$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($6c86b1a1c6654d60$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $6c86b1a1c6654d60$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $6c86b1a1c6654d60$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $6c86b1a1c6654d60$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($6c86b1a1c6654d60$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($6c86b1a1c6654d60$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($6c86b1a1c6654d60$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $6c86b1a1c6654d60$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $6c86b1a1c6654d60$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $6c86b1a1c6654d60$var$createTransitionManager();
    function setState(nextState) {
        (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $6c86b1a1c6654d60$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $6c86b1a1c6654d60$export$90c043f1c57770b8(entry, undefined, createKey()) : $6c86b1a1c6654d60$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $6c86b1a1c6654d60$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $6c86b1a1c6654d60$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $6c86b1a1c6654d60$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $7304ecac6ded77f0$exports = {};
var $7c6c986de7ab51ac$exports = {};
$7c6c986de7ab51ac$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $7304ecac6ded77f0$exports = $7304ecac6ded77f0$var$pathToRegexp;
$7304ecac6ded77f0$exports.parse = $7304ecac6ded77f0$var$parse;
$7304ecac6ded77f0$exports.compile = $7304ecac6ded77f0$var$compile;
$7304ecac6ded77f0$exports.tokensToFunction = $7304ecac6ded77f0$var$tokensToFunction;
$7304ecac6ded77f0$exports.tokensToRegExp = $7304ecac6ded77f0$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $7304ecac6ded77f0$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $7304ecac6ded77f0$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $7304ecac6ded77f0$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $7304ecac6ded77f0$var$escapeGroup(pattern) : asterisk ? '.*' : $7304ecac6ded77f0$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $7304ecac6ded77f0$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $7304ecac6ded77f0$var$escapeString(delimiter) + ']+?';
    return $7304ecac6ded77f0$var$escapeString(prevText) + '|(?:(?!' + $7304ecac6ded77f0$var$escapeString(prevText) + ')[^' + $7304ecac6ded77f0$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $7304ecac6ded77f0$var$compile(str, options) {
    return $7304ecac6ded77f0$var$tokensToFunction($7304ecac6ded77f0$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $7304ecac6ded77f0$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $7304ecac6ded77f0$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $7304ecac6ded77f0$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $7304ecac6ded77f0$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $7304ecac6ded77f0$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($7c6c986de7ab51ac$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $7304ecac6ded77f0$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $7304ecac6ded77f0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $7304ecac6ded77f0$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $7304ecac6ded77f0$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $7304ecac6ded77f0$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($7304ecac6ded77f0$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $7304ecac6ded77f0$var$flags(options));
    return $7304ecac6ded77f0$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$stringToRegexp(path, keys, options) {
    return $7304ecac6ded77f0$var$tokensToRegExp($7304ecac6ded77f0$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$tokensToRegExp(tokens, keys, options) {
    if (!$7c6c986de7ab51ac$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $7304ecac6ded77f0$var$escapeString(token);
        else {
            var prefix = $7304ecac6ded77f0$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $7304ecac6ded77f0$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $7304ecac6ded77f0$var$attachKeys(new RegExp('^' + route, $7304ecac6ded77f0$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $7304ecac6ded77f0$var$pathToRegexp(path, keys, options) {
    if (!$7c6c986de7ab51ac$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $7304ecac6ded77f0$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($7c6c986de7ab51ac$exports(path)) return $7304ecac6ded77f0$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $7304ecac6ded77f0$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}



function $a3ddd36595e6b8f4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $32ee599feb5ae61e$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $32ee599feb5ae61e$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $32ee599feb5ae61e$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $32ee599feb5ae61e$var$commonjsGlobal[key] = ($32ee599feb5ae61e$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $32ee599feb5ae61e$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $32ee599feb5ae61e$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $32ee599feb5ae61e$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $32ee599feb5ae61e$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $32ee599feb5ae61e$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $219455562f995e41$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $32ee599feb5ae61e$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($32ee599feb5ae61e$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $32ee599feb5ae61e$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $219455562f995e41$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $32ee599feb5ae61e$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $32ee599feb5ae61e$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $32ee599feb5ae61e$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $32ee599feb5ae61e$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createContext || $32ee599feb5ae61e$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $32ee599feb5ae61e$var$createNamedContext = function createNamedContext(name) {
    var context = $32ee599feb5ae61e$var$createContext();
    context.displayName = name;
    return context;
};
var $32ee599feb5ae61e$export$c213558b66925821 = /*#__PURE__*/ $32ee599feb5ae61e$var$createNamedContext("Router-History");
var $32ee599feb5ae61e$export$63baa8ccbe60bb07 = /*#__PURE__*/ $32ee599feb5ae61e$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $32ee599feb5ae61e$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $32ee599feb5ae61e$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6c86b1a1c6654d60$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
var $32ee599feb5ae61e$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $32ee599feb5ae61e$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $32ee599feb5ae61e$var$messageType;
var $32ee599feb5ae61e$var$cache = {};
var $32ee599feb5ae61e$var$cacheLimit = 10000;
var $32ee599feb5ae61e$var$cacheCount = 0;
function $32ee599feb5ae61e$var$compilePath(path) {
    if ($32ee599feb5ae61e$var$cache[path]) return $32ee599feb5ae61e$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($7304ecac6ded77f0$exports))).compile(path);
    if ($32ee599feb5ae61e$var$cacheCount < $32ee599feb5ae61e$var$cacheLimit) {
        $32ee599feb5ae61e$var$cache[path] = generator;
        $32ee599feb5ae61e$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $32ee599feb5ae61e$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $32ee599feb5ae61e$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $32ee599feb5ae61e$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $6c86b1a1c6654d60$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $32ee599feb5ae61e$export$82476f982757e71e(to, computedMatch.params) : (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, to, {
            pathname: $32ee599feb5ae61e$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $6c86b1a1c6654d60$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $6c86b1a1c6654d60$export$c3e8bb440bd55b18)(prevLocation, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $32ee599feb5ae61e$var$cache$1 = {};
var $32ee599feb5ae61e$var$cacheLimit$1 = 10000;
var $32ee599feb5ae61e$var$cacheCount$1 = 0;
function $32ee599feb5ae61e$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $32ee599feb5ae61e$var$cache$1[cacheKey] || ($32ee599feb5ae61e$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($7304ecac6ded77f0$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($32ee599feb5ae61e$var$cacheCount$1 < $32ee599feb5ae61e$var$cacheLimit$1) {
        pathCache[path] = result;
        $32ee599feb5ae61e$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $32ee599feb5ae61e$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $32ee599feb5ae61e$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $32ee599feb5ae61e$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Children.count(children) === 0;
}
function $32ee599feb5ae61e$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $32ee599feb5ae61e$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $32ee599feb5ae61e$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $32ee599feb5ae61e$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
function $32ee599feb5ae61e$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $32ee599feb5ae61e$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, location, {
        pathname: $32ee599feb5ae61e$var$addLeadingSlash(basename) + location.pathname
    });
}
function $32ee599feb5ae61e$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $32ee599feb5ae61e$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $32ee599feb5ae61e$var$createURL(location) {
    return typeof location === "string" ? location : (0, $6c86b1a1c6654d60$export$fe53371bee54353d)(location);
}
function $32ee599feb5ae61e$var$staticHandler(methodName) {
    return function() {
        (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
    };
}
function $32ee599feb5ae61e$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $32ee599feb5ae61e$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $32ee599feb5ae61e$var$noop;
        };
        _this.handleBlock = function() {
            return $32ee599feb5ae61e$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $32ee599feb5ae61e$var$addBasename(basename, (0, $6c86b1a1c6654d60$export$90c043f1c57770b8)(location));
        context.url = $32ee599feb5ae61e$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $32ee599feb5ae61e$var$addLeadingSlash(basename + $32ee599feb5ae61e$var$createURL(path));
            },
            action: "POP",
            location: $32ee599feb5ae61e$var$stripBasename(basename, (0, $6c86b1a1c6654d60$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $32ee599feb5ae61e$var$staticHandler("go"),
            goBack: $32ee599feb5ae61e$var$staticHandler("goBack"),
            goForward: $32ee599feb5ae61e$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$55185c17a0fcbe46, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $32ee599feb5ae61e$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $32ee599feb5ae61e$export$81336c211d5ff295(location.pathname, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $32ee599feb5ae61e$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($32ee599feb5ae61e$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(Component, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4080a25632a78fde$exports)))(C, Component);
}
var $32ee599feb5ae61e$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useContext;
function $32ee599feb5ae61e$export$3420e1dc2c4a518c() {
    return $32ee599feb5ae61e$var$useContext($32ee599feb5ae61e$export$c213558b66925821);
}
function $32ee599feb5ae61e$export$45d76561a5302f2b() {
    return $32ee599feb5ae61e$var$useContext($32ee599feb5ae61e$export$63baa8ccbe60bb07).location;
}
function $32ee599feb5ae61e$export$99eaa27ddbbb95ef() {
    var match = $32ee599feb5ae61e$var$useContext($32ee599feb5ae61e$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $32ee599feb5ae61e$export$632be4bb944c1bc7(path) {
    var location = $32ee599feb5ae61e$export$45d76561a5302f2b();
    var match = $32ee599feb5ae61e$var$useContext($32ee599feb5ae61e$export$63baa8ccbe60bb07).match;
    return path ? $32ee599feb5ae61e$export$81336c211d5ff295(location.pathname, path) : match;
}
var $32ee599feb5ae61e$var$global$1, $32ee599feb5ae61e$var$key, $32ee599feb5ae61e$var$buildNames, $32ee599feb5ae61e$var$initialBuildName, $32ee599feb5ae61e$var$secondaryBuildName;




var $denZA = parcelRequire("denZA");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $53a8aaf8c02cd9f8$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6c86b1a1c6654d60$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $32ee599feb5ae61e$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $53a8aaf8c02cd9f8$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $219455562f995e41$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $6c86b1a1c6654d60$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $32ee599feb5ae61e$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
var $53a8aaf8c02cd9f8$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $53a8aaf8c02cd9f8$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $6c86b1a1c6654d60$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $53a8aaf8c02cd9f8$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $53a8aaf8c02cd9f8$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).forwardRef;
if (typeof $53a8aaf8c02cd9f8$var$forwardRef === "undefined") $53a8aaf8c02cd9f8$var$forwardRef = $53a8aaf8c02cd9f8$var$forwardRefShim;
function $53a8aaf8c02cd9f8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $53a8aaf8c02cd9f8$var$LinkAnchor = $53a8aaf8c02cd9f8$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$53a8aaf8c02cd9f8$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($53a8aaf8c02cd9f8$var$forwardRefShim !== $53a8aaf8c02cd9f8$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a = $53a8aaf8c02cd9f8$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $53a8aaf8c02cd9f8$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $32ee599feb5ae61e$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $53a8aaf8c02cd9f8$var$normalizeToLocation($53a8aaf8c02cd9f8$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $53a8aaf8c02cd9f8$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $6c86b1a1c6654d60$export$fe53371bee54353d)(context.location) === (0, $6c86b1a1c6654d60$export$fe53371bee54353d)($53a8aaf8c02cd9f8$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($53a8aaf8c02cd9f8$var$forwardRefShim !== $53a8aaf8c02cd9f8$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(component, props);
    });
});
var $53a8aaf8c02cd9f8$var$toType, $53a8aaf8c02cd9f8$var$refType;
var $53a8aaf8c02cd9f8$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $53a8aaf8c02cd9f8$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).forwardRef;
if (typeof $53a8aaf8c02cd9f8$var$forwardRef$1 === "undefined") $53a8aaf8c02cd9f8$var$forwardRef$1 = $53a8aaf8c02cd9f8$var$forwardRefShim$1;
function $53a8aaf8c02cd9f8$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $53a8aaf8c02cd9f8$export$b0d92dbee9b5b60d = $53a8aaf8c02cd9f8$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $32ee599feb5ae61e$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $53a8aaf8c02cd9f8$var$normalizeToLocation($53a8aaf8c02cd9f8$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $32ee599feb5ae61e$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $53a8aaf8c02cd9f8$var$joinClassnames(className, activeClassName);
            style = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($53a8aaf8c02cd9f8$var$forwardRefShim$1 !== $53a8aaf8c02cd9f8$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a, props);
    });
});
var $53a8aaf8c02cd9f8$var$ariaCurrentType;




var $cvFNP = parcelRequire("cvFNP");
/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $1da0335809723f81$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1da0335809723f81$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1da0335809723f81$var$__read(arguments[i]));
    return ar;
};
var $1da0335809723f81$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ var $1da0335809723f81$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = 'WARN';
        this.name = name;
        this.level = level;
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $1da0335809723f81$var$LOG_LEVELS[logger_level_name];
        var type_level = $1da0335809723f81$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === 'ERROR' && console.error) log = console.error.bind(console);
        if (type === 'WARN' && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        if (msg.length === 1 && typeof msg[0] === 'string') log(prefix + " - " + msg[0]);
        else if (msg.length === 1) log(prefix, msg[0]);
        else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            log(prefix + " - " + msg[0], obj);
        } else log(prefix, msg);
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'INFO'
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'WARN'
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'ERROR'
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'DEBUG'
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $1da0335809723f81$var$__spread([
            'VERBOSE'
        ], msg));
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();


var $471a5eebd413fda8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $471a5eebd413fda8$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Amplify');
var $471a5eebd413fda8$export$b412d755cfa0136 = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Logger = (0, $1da0335809723f81$export$ba6a9c7ac8291f7f);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        $471a5eebd413fda8$var$logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else $471a5eebd413fda8$var$logger.debug('no getModuleName method for component', comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $471a5eebd413fda8$var$logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = $471a5eebd413fda8$var$__read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable['getCategory'] && typeof pluggable['getCategory'] === 'function') this._components.map(function(comp) {
            if (comp['addPluggable'] && typeof comp['addPluggable'] === 'function') comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var $471a5eebd413fda8$export$a3858a9a153cffc7 = new $471a5eebd413fda8$export$b412d755cfa0136();
var /**
 * @deprecated use named import
 */ $471a5eebd413fda8$export$2e2bcd8739ae039 = $471a5eebd413fda8$export$a3858a9a153cffc7;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // generated by genversion
var $9989856f69c01623$export$83d89fbfd8236492 = '3.8.6';


var $eb2795a39e4549eb$var$BASE_USER_AGENT = "aws-amplify/" + (0, $9989856f69c01623$export$83d89fbfd8236492);
var $eb2795a39e4549eb$export$2dffd0b5373a4389 = {
    userAgent: $eb2795a39e4549eb$var$BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== 'undefined' && navigator.product) {
    $eb2795a39e4549eb$export$2dffd0b5373a4389.product = navigator.product || '';
    $eb2795a39e4549eb$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case 'ReactNative':
            $eb2795a39e4549eb$export$2dffd0b5373a4389.userAgent = $eb2795a39e4549eb$var$BASE_USER_AGENT + " react-native";
            $eb2795a39e4549eb$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $eb2795a39e4549eb$export$2dffd0b5373a4389.userAgent = $eb2795a39e4549eb$var$BASE_USER_AGENT + " js";
            $eb2795a39e4549eb$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $eb2795a39e4549eb$export$ede38edb26c0bfdf = function() {
    return $eb2795a39e4549eb$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $eb2795a39e4549eb$export$2e2bcd8739ae039 = $eb2795a39e4549eb$export$2dffd0b5373a4389;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $f95e38e92a3bcc1d$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('ClientDevice_Browser');
function $f95e38e92a3bcc1d$export$a2e6d3a753e91268() {
    if (typeof window === 'undefined') return {};
    return $f95e38e92a3bcc1d$var$browserClientInfo();
}
function $f95e38e92a3bcc1d$var$browserClientInfo() {
    if (typeof window === 'undefined') {
        $f95e38e92a3bcc1d$var$logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        $f95e38e92a3bcc1d$var$logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = $f95e38e92a3bcc1d$var$browserType(userAgent);
    var timezone = $f95e38e92a3bcc1d$var$browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language: language,
        timezone: timezone
    };
}
function $f95e38e92a3bcc1d$export$edcd89beb969619a() {
    if (typeof window === 'undefined') {
        $f95e38e92a3bcc1d$var$logger.warn('No window object available to get browser client info');
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function $f95e38e92a3bcc1d$var$browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function $f95e38e92a3bcc1d$var$browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}


var $9dc3a3d48be6b7be$export$11b7ab1da2ac1804 = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, $f95e38e92a3bcc1d$export$a2e6d3a753e91268)();
    };
    ClientDevice.dimension = function() {
        return (0, $f95e38e92a3bcc1d$export$edcd89beb969619a)();
    };
    return ClientDevice;
}();
var /**
 * @deprecated use named import
 */ $9dc3a3d48be6b7be$export$2e2bcd8739ae039 = $9dc3a3d48be6b7be$export$11b7ab1da2ac1804;




/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a643974fbe0dd2a5$var$__assign = undefined && undefined.__assign || function() {
    $a643974fbe0dd2a5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a643974fbe0dd2a5$var$__assign.apply(this, arguments);
};
var $a643974fbe0dd2a5$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a643974fbe0dd2a5$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a643974fbe0dd2a5$var$__read(arguments[i]));
    return ar;
};
var $a643974fbe0dd2a5$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Hub');
var $a643974fbe0dd2a5$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
function $a643974fbe0dd2a5$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $a643974fbe0dd2a5$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'xr'
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $a643974fbe0dd2a5$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $a643974fbe0dd2a5$var$__spread(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $a643974fbe0dd2a5$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $a643974fbe0dd2a5$var$__spread(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = '';
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $a643974fbe0dd2a5$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $a643974fbe0dd2a5$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $a643974fbe0dd2a5$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $a643974fbe0dd2a5$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = 'noname';
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($a643974fbe0dd2a5$var$isLegacyCallback(callback)) {
            $a643974fbe0dd2a5$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== 'function') throw new Error('No callback supplied to Hub');
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $a643974fbe0dd2a5$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $a643974fbe0dd2a5$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $a643974fbe0dd2a5$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = $a643974fbe0dd2a5$var$__read(match), groups = _a.slice(1);
                    var dispatchingCapsule = $a643974fbe0dd2a5$var$__assign($a643974fbe0dd2a5$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $a643974fbe0dd2a5$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var $a643974fbe0dd2a5$export$8c41bb232f1008b1 = new $a643974fbe0dd2a5$export$6b38ef2be9abbbb9('__default__');
var /**
 * @deprecated use named import
 */ $a643974fbe0dd2a5$export$2e2bcd8739ae039 = $a643974fbe0dd2a5$export$8c41bb232f1008b1;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $4c96feb7aec319a2$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('I18n');
/**
 * Language transition class
 */ var $4c96feb7aec319a2$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        $4c96feb7aec319a2$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();




var $20154f355a8c1f05$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('I18n');
var $20154f355a8c1f05$var$_config = null;
var $20154f355a8c1f05$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $20154f355a8c1f05$export$dbe3113d60765c1a = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $20154f355a8c1f05$var$logger.debug('configure I18n');
        if (!config) return $20154f355a8c1f05$var$_config;
        $20154f355a8c1f05$var$_config = Object.assign({}, $20154f355a8c1f05$var$_config, config.I18n || config);
        I18n.createInstance();
        return $20154f355a8c1f05$var$_config;
    };
    I18n.getModuleName = function() {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $20154f355a8c1f05$var$logger.debug('create I18n instance');
        if ($20154f355a8c1f05$var$_i18n) return;
        $20154f355a8c1f05$var$_i18n = new (0, $4c96feb7aec319a2$export$dbe3113d60765c1a)($20154f355a8c1f05$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $20154f355a8c1f05$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        return $20154f355a8c1f05$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $20154f355a8c1f05$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $20154f355a8c1f05$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$20154f355a8c1f05$var$_i18n) $20154f355a8c1f05$var$_i18n = new (0, $4c96feb7aec319a2$export$dbe3113d60765c1a)($20154f355a8c1f05$var$_config);
        return true;
    };
    return I18n;
}();
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).register($20154f355a8c1f05$export$dbe3113d60765c1a);
var /**
 * @deprecated use named import
 */ $20154f355a8c1f05$export$2e2bcd8739ae039 = $20154f355a8c1f05$export$dbe3113d60765c1a;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $4635c76aed896f54$var$MIME_MAP = [
    {
        type: 'text/plain',
        ext: 'txt'
    },
    {
        type: 'text/html',
        ext: 'html'
    },
    {
        type: 'text/javascript',
        ext: 'js'
    },
    {
        type: 'text/css',
        ext: 'css'
    },
    {
        type: 'text/csv',
        ext: 'csv'
    },
    {
        type: 'text/yaml',
        ext: 'yml'
    },
    {
        type: 'text/yaml',
        ext: 'yaml'
    },
    {
        type: 'text/calendar',
        ext: 'ics'
    },
    {
        type: 'text/calendar',
        ext: 'ical'
    },
    {
        type: 'image/apng',
        ext: 'apng'
    },
    {
        type: 'image/bmp',
        ext: 'bmp'
    },
    {
        type: 'image/gif',
        ext: 'gif'
    },
    {
        type: 'image/x-icon',
        ext: 'ico'
    },
    {
        type: 'image/x-icon',
        ext: 'cur'
    },
    {
        type: 'image/jpeg',
        ext: 'jpg'
    },
    {
        type: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        type: 'image/jpeg',
        ext: 'jfif'
    },
    {
        type: 'image/jpeg',
        ext: 'pjp'
    },
    {
        type: 'image/jpeg',
        ext: 'pjpeg'
    },
    {
        type: 'image/png',
        ext: 'png'
    },
    {
        type: 'image/svg+xml',
        ext: 'svg'
    },
    {
        type: 'image/tiff',
        ext: 'tif'
    },
    {
        type: 'image/tiff',
        ext: 'tiff'
    },
    {
        type: 'image/webp',
        ext: 'webp'
    },
    {
        type: 'application/json',
        ext: 'json'
    },
    {
        type: 'application/xml',
        ext: 'xml'
    },
    {
        type: 'application/x-sh',
        ext: 'sh'
    },
    {
        type: 'application/zip',
        ext: 'zip'
    },
    {
        type: 'application/x-rar-compressed',
        ext: 'rar'
    },
    {
        type: 'application/x-tar',
        ext: 'tar'
    },
    {
        type: 'application/x-bzip',
        ext: 'bz'
    },
    {
        type: 'application/x-bzip2',
        ext: 'bz2'
    },
    {
        type: 'application/pdf',
        ext: 'pdf'
    },
    {
        type: 'application/java-archive',
        ext: 'jar'
    },
    {
        type: 'application/msword',
        ext: 'doc'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xlsx'
    },
    {
        type: 'message/rfc822',
        ext: 'eml'
    }
];
var $4635c76aed896f54$export$dd1bc94b04021eeb = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var $4635c76aed896f54$export$756e1e7707954007 = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        if (typeof a_val === 'undefined') return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var $4635c76aed896f54$export$5e10ed067f63a9ea = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var $4635c76aed896f54$export$49cecb876bed446d = function(filename, defVal) {
    if (defVal === void 0) defVal = 'application/octet-stream';
    var name = filename.toLowerCase();
    var filtered = $4635c76aed896f54$var$MIME_MAP.filter(function(mime) {
        return name.endsWith('.' + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var $4635c76aed896f54$export$689bea3eece53c0e = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) return true;
    return 'application/json' === type || 'application/xml' === type || 'application/sh' === type;
};
var $4635c76aed896f54$export$9e15fb06e64c4810 = function() {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var $4635c76aed896f54$export$8f33cb495ca11832 = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var $4635c76aed896f54$export$97b87b8868ff7a3c = function() {
    if (typeof self === 'undefined') return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};
var $4635c76aed896f54$export$a2708fdb45cd35f = function() {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = false;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var $4635c76aed896f54$export$6281ea8cfc59a49c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$4635c76aed896f54$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : $4635c76aed896f54$export$6281ea8cfc59a49c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $4635c76aed896f54$export$f8790a3d3d35829c = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!$4635c76aed896f54$export$250974ab4f95003c(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : $4635c76aed896f54$export$f8790a3d3d35829c(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var $4635c76aed896f54$export$250974ab4f95003c = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};
/**
 * @deprecated use per-function imports
 */ var $4635c76aed896f54$export$174a40858393256b = /** @class */ function() {
    function JS() {}
    JS.isEmpty = $4635c76aed896f54$export$dd1bc94b04021eeb;
    JS.sortByField = $4635c76aed896f54$export$756e1e7707954007;
    JS.objectLessAttributes = $4635c76aed896f54$export$5e10ed067f63a9ea;
    JS.filenameToContentType = $4635c76aed896f54$export$49cecb876bed446d;
    JS.isTextFile = $4635c76aed896f54$export$689bea3eece53c0e;
    JS.generateRandomString = $4635c76aed896f54$export$9e15fb06e64c4810;
    JS.makeQuerablePromise = $4635c76aed896f54$export$8f33cb495ca11832;
    JS.isWebWorker = $4635c76aed896f54$export$97b87b8868ff7a3c;
    JS.browserOrNode = $4635c76aed896f54$export$a2708fdb45cd35f;
    JS.transferKeyToLowerCase = $4635c76aed896f54$export$6281ea8cfc59a49c;
    JS.transferKeyToUpperCase = $4635c76aed896f54$export$f8790a3d3d35829c;
    JS.isStrictObject = $4635c76aed896f54$export$250974ab4f95003c;
    return JS;
}();
var /**
 * @deprecated use per-function imports
 */ $4635c76aed896f54$export$2e2bcd8739ae039 = $4635c76aed896f54$export$174a40858393256b;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $7ec7b47ff92a6deb$exports = {};
"use strict";
Object.defineProperty($7ec7b47ff92a6deb$exports, "__esModule", {
    value: true
});

var $d8IY1 = parcelRequire("d8IY1");

$d8IY1.__exportStar((parcelRequire("d9GOM")), $7ec7b47ff92a6deb$exports);


var $1ebed31995d5f4d1$var$SHORT_TO_HEX = {};
var $1ebed31995d5f4d1$var$HEX_TO_SHORT = {};
for(var $1ebed31995d5f4d1$var$i = 0; $1ebed31995d5f4d1$var$i < 256; $1ebed31995d5f4d1$var$i++){
    var $1ebed31995d5f4d1$var$encodedByte = $1ebed31995d5f4d1$var$i.toString(16).toLowerCase();
    if ($1ebed31995d5f4d1$var$encodedByte.length === 1) $1ebed31995d5f4d1$var$encodedByte = "0" + $1ebed31995d5f4d1$var$encodedByte;
    $1ebed31995d5f4d1$var$SHORT_TO_HEX[$1ebed31995d5f4d1$var$i] = $1ebed31995d5f4d1$var$encodedByte;
    $1ebed31995d5f4d1$var$HEX_TO_SHORT[$1ebed31995d5f4d1$var$encodedByte] = $1ebed31995d5f4d1$var$i;
}
function $1ebed31995d5f4d1$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $1ebed31995d5f4d1$var$HEX_TO_SHORT) out[i / 2] = $1ebed31995d5f4d1$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $1ebed31995d5f4d1$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $1ebed31995d5f4d1$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



var $adm0U = parcelRequire("adm0U");
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $09510d704ef249f3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $09510d704ef249f3$var$FIVE_MINUTES_IN_MS = 300000;
var $09510d704ef249f3$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($09510d704ef249f3$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $09510d704ef249f3$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $09510d704ef249f3$export$3e048df13f4eb60b.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = $09510d704ef249f3$export$3e048df13f4eb60b.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function(header) {
        var _a = $09510d704ef249f3$var$__read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - $09510d704ef249f3$export$3e048df13f4eb60b.getDateWithClockOffset().getTime()) >= $09510d704ef249f3$var$FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean(headers['x-amzn-errortype'] === 'BadRequestException' && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $09510d704ef249f3$export$3e048df13f4eb60b.clockOffset = offset;
    }
};


var $dd99114d408ebf0b$var$__assign = undefined && undefined.__assign || function() {
    $dd99114d408ebf0b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd99114d408ebf0b$var$__assign.apply(this, arguments);
};
var $dd99114d408ebf0b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dd99114d408ebf0b$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Signer');
var $dd99114d408ebf0b$var$DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var $dd99114d408ebf0b$var$IOT_SERVICE_NAME = 'iotdevicegateway';
var $dd99114d408ebf0b$var$encrypt = function(key, src) {
    var hash = new (0, $7ec7b47ff92a6deb$exports.Sha256)(key);
    hash.update(src);
    return hash.digestSync();
};
var $dd99114d408ebf0b$var$hash = function(src) {
    var arg = src || '';
    var hash = new (0, $7ec7b47ff92a6deb$exports.Sha256)();
    hash.update(arg);
    return (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $dd99114d408ebf0b$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $dd99114d408ebf0b$var$canonical_query = function(query) {
    if (!query || query.length === 0) return '';
    return query.split('&').map(function(e) {
        var key_val = e.split('=');
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $dd99114d408ebf0b$var$escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $dd99114d408ebf0b$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return '';
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ':' + item.value;
    }).join('\n') + '\n';
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $dd99114d408ebf0b$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $dd99114d408ebf0b$var$canonical_request = function(request) {
    var url_info = (0, $adm0U.parse)(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        $dd99114d408ebf0b$var$canonical_query(url_info.query),
        $dd99114d408ebf0b$var$canonical_headers(request.headers),
        $dd99114d408ebf0b$var$signed_headers(request.headers),
        $dd99114d408ebf0b$var$hash(request.data)
    ].join('\n');
};
var $dd99114d408ebf0b$var$parse_service_info = function(request) {
    var url_info = (0, $adm0U.parse)(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $dd99114d408ebf0b$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        'aws4_request'
    ].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $dd99114d408ebf0b$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $dd99114d408ebf0b$var$hash(canonical_request)
    ].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $dd99114d408ebf0b$var$get_signing_key = function(secret_key, d_str, service_info) {
    $dd99114d408ebf0b$var$logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = $dd99114d408ebf0b$var$encrypt(k, d_str), k_region = $dd99114d408ebf0b$var$encrypt(k_date, service_info.region), k_service = $dd99114d408ebf0b$var$encrypt(k_region, service_info.service), k_signing = $dd99114d408ebf0b$var$encrypt(k_service, 'aws4_request');
    return k_signing;
};
var $dd99114d408ebf0b$var$get_signature = function(signing_key, str_to_sign) {
    return (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)($dd99114d408ebf0b$var$encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $dd99114d408ebf0b$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature
    ].join(', ');
};
var $dd99114d408ebf0b$export$fdf54fdde81cc9f0 = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = (0, $09510d704ef249f3$export$3e048df13f4eb60b).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = (0, $adm0U.parse)(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) request.headers['X-Amz-Security-Token'] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $dd99114d408ebf0b$var$canonical_request(request);
        $dd99114d408ebf0b$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $dd99114d408ebf0b$var$parse_service_info(request), scope = $dd99114d408ebf0b$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $dd99114d408ebf0b$var$string_to_sign($dd99114d408ebf0b$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $dd99114d408ebf0b$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $dd99114d408ebf0b$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $dd99114d408ebf0b$var$get_authorization_header($dd99114d408ebf0b$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $dd99114d408ebf0b$var$signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = (0, $09510d704ef249f3$export$3e048df13f4eb60b).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = (0, $adm0U.parse)(urlToSign, true, true), search = _a.search, parsedUrl = $dd99114d408ebf0b$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $dd99114d408ebf0b$var$parse_service_info({
            url: (0, $adm0U.format)(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $dd99114d408ebf0b$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $dd99114d408ebf0b$var$IOT_SERVICE_NAME;
        var queryParams = $dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign({
            'X-Amz-Algorithm': $dd99114d408ebf0b$var$DEFAULT_ALGORITHM,
            'X-Amz-Credential': [
                accessInfo.access_key,
                credentialScope
            ].join('/'),
            'X-Amz-Date': now.substr(0, 16)
        }, sessionTokenRequired ? {
            'X-Amz-Security-Token': "" + accessInfo.session_token
        } : {}), expiration ? {
            'X-Amz-Expires': "" + expiration
        } : {}), {
            'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',')
        });
        var canonicalRequest = $dd99114d408ebf0b$var$canonical_request({
            method: method,
            url: (0, $adm0U.format)($dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign({}, parsedUrl), {
                query: $dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $dd99114d408ebf0b$var$string_to_sign($dd99114d408ebf0b$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $dd99114d408ebf0b$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $dd99114d408ebf0b$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $dd99114d408ebf0b$var$__assign({
            'X-Amz-Signature': signature
        }, accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token
        });
        var result = (0, $adm0U.format)({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign($dd99114d408ebf0b$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var /**
 * @deprecated use per-function import
 */ $dd99114d408ebf0b$export$2e2bcd8739ae039 = $dd99114d408ebf0b$export$fdf54fdde81cc9f0;



var $ae0d5b8a0cfbbb01$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Parser');
var $ae0d5b8a0cfbbb01$export$33f4f68299e2efa8 = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region']
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) amplifyConfig.Auth = {
        userPoolId: config['aws_user_pools_id'],
        userPoolWebClientId: config['aws_user_pools_web_client_id'],
        region: config['aws_cognito_region'],
        identityPoolId: config['aws_cognito_identity_pool_id'],
        identityPoolRegion: config['aws_cognito_region'],
        mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable'
    };
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) storageConfig = {
        AWSS3: {
            bucket: config['aws_user_files_s3_bucket'],
            region: config['aws_user_files_s3_bucket_region'],
            dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing']
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    $ae0d5b8a0cfbbb01$var$logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */ var $ae0d5b8a0cfbbb01$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = $ae0d5b8a0cfbbb01$export$33f4f68299e2efa8;
    return Parser;
}();
var /**
 * @deprecated use per-function export
 */ $ae0d5b8a0cfbbb01$export$2e2bcd8739ae039 = $ae0d5b8a0cfbbb01$export$7acfa6ed01010e37;





/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $59e04b8bcc93b29e$var$dataMemory = {};
/** @class */ var $59e04b8bcc93b29e$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $59e04b8bcc93b29e$var$dataMemory[key] = value;
        return $59e04b8bcc93b29e$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($59e04b8bcc93b29e$var$dataMemory, key) ? $59e04b8bcc93b29e$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $59e04b8bcc93b29e$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $59e04b8bcc93b29e$var$dataMemory = {};
        return $59e04b8bcc93b29e$var$dataMemory;
    };
    return MemoryStorage;
}();
var $59e04b8bcc93b29e$export$a2bd19c49e4760e8 = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        } catch (exception) {
            this.storageWindow = $59e04b8bcc93b29e$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var /**
 * @deprecated use named import
 */ $59e04b8bcc93b29e$export$2e2bcd8739ae039 = $59e04b8bcc93b29e$export$a2bd19c49e4760e8;



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


var $cf5e2b98e027d007$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cf5e2b98e027d007$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cf5e2b98e027d007$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cf5e2b98e027d007$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cf5e2b98e027d007$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cf5e2b98e027d007$var$__read(arguments[i]));
    return ar;
};
var $cf5e2b98e027d007$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Util');
var $cf5e2b98e027d007$export$1e38badc838ad384 = /** @class */ function(_super) {
    $cf5e2b98e027d007$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $cf5e2b98e027d007$var$isNonRetryableError = function(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function $cf5e2b98e027d007$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $cf5e2b98e027d007$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $cf5e2b98e027d007$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
                    $cf5e2b98e027d007$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(void 0, $cf5e2b98e027d007$var$__spread(args))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 3:
                    err_1 = _a.sent();
                    $cf5e2b98e027d007$var$logger.debug("error on " + functionToRetry.name, err_1);
                    if ($cf5e2b98e027d007$var$isNonRetryableError(err_1)) {
                        $cf5e2b98e027d007$var$logger.debug(functionToRetry.name + " non retryable error", err_1);
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $cf5e2b98e027d007$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $cf5e2b98e027d007$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $cf5e2b98e027d007$var$MAX_DELAY_MS = 300000;
function $cf5e2b98e027d007$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $cf5e2b98e027d007$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $cf5e2b98e027d007$var$MAX_DELAY_MS;
    return $cf5e2b98e027d007$export$9369b12211e1fce4(functionToRetry, args, $cf5e2b98e027d007$var$jitteredBackoff(maxDelayMs));
};


var $7688e56ffc231eeb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7688e56ffc231eeb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7688e56ffc231eeb$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('CognitoCredentials');
var $7688e56ffc231eeb$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser) {
        $7688e56ffc231eeb$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        $7688e56ffc231eeb$var$logger.debug('google api already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $7688e56ffc231eeb$export$75ace714083c1340 = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $7688e56ffc231eeb$var$__awaiter(this, void 0, void 0, function() {
            return $7688e56ffc231eeb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $7688e56ffc231eeb$var$logger.debug('need to wait for the Google SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $7688e56ffc231eeb$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $7688e56ffc231eeb$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser) ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            $7688e56ffc231eeb$var$logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    $7688e56ffc231eeb$var$logger.debug('google Auth undefined');
                    rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $7688e56ffc231eeb$var$logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === 'network_error') // Not using NonRetryableError so handler will be retried
                        rej('Network error reloading google auth response');
                        else rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)('Failed to reload google auth response'));
                    });
                } else rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)('User is not signed in with Google'));
            }).catch(function(err) {
                $7688e56ffc231eeb$var$logger.debug('Failed to refresh google token', err);
                rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}();
var /**
 * @deprecated use named import
 */ $7688e56ffc231eeb$export$2e2bcd8739ae039 = $7688e56ffc231eeb$export$75ace714083c1340;





var $c46d5275f7dd3e6e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c46d5275f7dd3e6e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c46d5275f7dd3e6e$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('CognitoCredentials');
var $c46d5275f7dd3e6e$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser) {
        $c46d5275f7dd3e6e$var$logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        $c46d5275f7dd3e6e$var$logger.debug('FB SDK already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $c46d5275f7dd3e6e$export$1b6b8b5328e38349 = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $c46d5275f7dd3e6e$var$__awaiter(this, void 0, void 0, function() {
            return $c46d5275f7dd3e6e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $c46d5275f7dd3e6e$var$logger.debug('need to wait for the Facebook SDK loaded');
                        return [
                            4 /*yield*/ ,
                            $c46d5275f7dd3e6e$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $c46d5275f7dd3e6e$var$logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser) fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            $c46d5275f7dd3e6e$var$logger.debug(errorMessage);
            return Promise.reject(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    $c46d5275f7dd3e6e$var$logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        $c46d5275f7dd3e6e$var$logger.debug(errorMessage);
                        rej(new (0, $cf5e2b98e027d007$export$1e38badc838ad384)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: 'public_profile,email'
            });
        });
    };
    return FacebookOAuth;
}();
var /**
 * @deprecated use named import
 */ $c46d5275f7dd3e6e$export$2e2bcd8739ae039 = $c46d5275f7dd3e6e$export$1b6b8b5328e38349;


var $c3feafeb259bd3b0$export$75ace714083c1340 = new (0, $7688e56ffc231eeb$export$75ace714083c1340)();
var $c3feafeb259bd3b0$export$1b6b8b5328e38349 = new (0, $c46d5275f7dd3e6e$export$1b6b8b5328e38349)();





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $fd96a331b5a987bc$var$extendStatics = function(d, b) {
    $fd96a331b5a987bc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $fd96a331b5a987bc$var$extendStatics(d, b);
};
function $fd96a331b5a987bc$export$a8ba968b8961cb8a(d, b) {
    $fd96a331b5a987bc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fd96a331b5a987bc$export$18ce0697a983be9b = function() {
    $fd96a331b5a987bc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fd96a331b5a987bc$export$18ce0697a983be9b.apply(this, arguments);
};
function $fd96a331b5a987bc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fd96a331b5a987bc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fd96a331b5a987bc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fd96a331b5a987bc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fd96a331b5a987bc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fd96a331b5a987bc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $fd96a331b5a987bc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $fd96a331b5a987bc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $fd96a331b5a987bc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fd96a331b5a987bc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fd96a331b5a987bc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fd96a331b5a987bc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fd96a331b5a987bc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fd96a331b5a987bc$export$10c90e4f7922046c(v) {
    return this instanceof $fd96a331b5a987bc$export$10c90e4f7922046c ? (this.v = v, this) : new $fd96a331b5a987bc$export$10c90e4f7922046c(v);
}
function $fd96a331b5a987bc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fd96a331b5a987bc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fd96a331b5a987bc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fd96a331b5a987bc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $fd96a331b5a987bc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fd96a331b5a987bc$export$19a8beecd37a4c45 === "function" ? $fd96a331b5a987bc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fd96a331b5a987bc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $fd96a331b5a987bc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $fd96a331b5a987bc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fd96a331b5a987bc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $fd96a331b5a987bc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $96998cfc8b9d4854$var$extendStatics = function(d, b) {
    $96998cfc8b9d4854$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $96998cfc8b9d4854$var$extendStatics(d, b);
};
function $96998cfc8b9d4854$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $96998cfc8b9d4854$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $96998cfc8b9d4854$export$18ce0697a983be9b = function() {
    $96998cfc8b9d4854$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96998cfc8b9d4854$export$18ce0697a983be9b.apply(this, arguments);
};
function $96998cfc8b9d4854$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $96998cfc8b9d4854$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $96998cfc8b9d4854$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $96998cfc8b9d4854$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $96998cfc8b9d4854$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $96998cfc8b9d4854$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $96998cfc8b9d4854$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $96998cfc8b9d4854$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $96998cfc8b9d4854$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $96998cfc8b9d4854$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $96998cfc8b9d4854$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $96998cfc8b9d4854$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $96998cfc8b9d4854$export$45d3717a4c69092e(o, m, p);
}
function $96998cfc8b9d4854$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $96998cfc8b9d4854$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $96998cfc8b9d4854$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($96998cfc8b9d4854$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $96998cfc8b9d4854$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $96998cfc8b9d4854$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $96998cfc8b9d4854$export$10c90e4f7922046c(v) {
    return this instanceof $96998cfc8b9d4854$export$10c90e4f7922046c ? (this.v = v, this) : new $96998cfc8b9d4854$export$10c90e4f7922046c(v);
}
function $96998cfc8b9d4854$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $96998cfc8b9d4854$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $96998cfc8b9d4854$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $96998cfc8b9d4854$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $96998cfc8b9d4854$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $96998cfc8b9d4854$export$19a8beecd37a4c45 === "function" ? $96998cfc8b9d4854$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $96998cfc8b9d4854$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $96998cfc8b9d4854$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $96998cfc8b9d4854$var$ownKeys = function(o) {
    $96998cfc8b9d4854$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $96998cfc8b9d4854$var$ownKeys(o);
};
function $96998cfc8b9d4854$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $96998cfc8b9d4854$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $96998cfc8b9d4854$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $96998cfc8b9d4854$var$__setModuleDefault(result, mod);
    return result;
}
function $96998cfc8b9d4854$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $96998cfc8b9d4854$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $96998cfc8b9d4854$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $96998cfc8b9d4854$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $96998cfc8b9d4854$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $96998cfc8b9d4854$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $96998cfc8b9d4854$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $96998cfc8b9d4854$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $96998cfc8b9d4854$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $96998cfc8b9d4854$export$2e2bcd8739ae039 = {
    __extends: $96998cfc8b9d4854$export$a8ba968b8961cb8a,
    __assign: $96998cfc8b9d4854$export$18ce0697a983be9b,
    __rest: $96998cfc8b9d4854$export$3c9a16f847548506,
    __decorate: $96998cfc8b9d4854$export$29e00dfd3077644b,
    __param: $96998cfc8b9d4854$export$d5ad3fd78186038f,
    __esDecorate: $96998cfc8b9d4854$export$3a84e1ae4e97e9b0,
    __runInitializers: $96998cfc8b9d4854$export$d831c04e792af3d,
    __propKey: $96998cfc8b9d4854$export$6a2a36740a146cb8,
    __setFunctionName: $96998cfc8b9d4854$export$d1a06452d3489bc7,
    __metadata: $96998cfc8b9d4854$export$f1db080c865becb9,
    __awaiter: $96998cfc8b9d4854$export$1050f835b63b671e,
    __generator: $96998cfc8b9d4854$export$67ebef60e6f28a6,
    __createBinding: $96998cfc8b9d4854$export$45d3717a4c69092e,
    __exportStar: $96998cfc8b9d4854$export$f33643c0debef087,
    __values: $96998cfc8b9d4854$export$19a8beecd37a4c45,
    __read: $96998cfc8b9d4854$export$8d051b38c9118094,
    __spread: $96998cfc8b9d4854$export$afc72e2116322959,
    __spreadArrays: $96998cfc8b9d4854$export$6388937ca91ccae8,
    __spreadArray: $96998cfc8b9d4854$export$1216008129fb82ed,
    __await: $96998cfc8b9d4854$export$10c90e4f7922046c,
    __asyncGenerator: $96998cfc8b9d4854$export$e427f37a30a4de9b,
    __asyncDelegator: $96998cfc8b9d4854$export$bbd80228419bb833,
    __asyncValues: $96998cfc8b9d4854$export$e3b29a3d6162315f,
    __makeTemplateObject: $96998cfc8b9d4854$export$4fb47efe1390b86f,
    __importStar: $96998cfc8b9d4854$export$c21735bcef00d192,
    __importDefault: $96998cfc8b9d4854$export$da59b14a69baef04,
    __classPrivateFieldGet: $96998cfc8b9d4854$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $96998cfc8b9d4854$export$d40a35129aaff81f,
    __classPrivateFieldIn: $96998cfc8b9d4854$export$81fdc39f203e4e04,
    __addDisposableResource: $96998cfc8b9d4854$export$88ac25d8e944e405,
    __disposeResources: $96998cfc8b9d4854$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $96998cfc8b9d4854$export$889dfb5d17574b0b
};



var $cc61513580735d44$export$dc00db384271fff6;
(function(AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})($cc61513580735d44$export$dc00db384271fff6 || ($cc61513580735d44$export$dc00db384271fff6 = {}));
var $cc61513580735d44$export$8a7902a72d4cb6dd;
(function(CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8a7902a72d4cb6dd || ($cc61513580735d44$export$8a7902a72d4cb6dd = {}));
var $cc61513580735d44$export$2d7512435854af72;
(function(CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$2d7512435854af72 || ($cc61513580735d44$export$2d7512435854af72 = {}));
var $cc61513580735d44$export$8d556ce24d00472;
(function(IdentityPool) {
    IdentityPool.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8d556ce24d00472 || ($cc61513580735d44$export$8d556ce24d00472 = {}));
var $cc61513580735d44$export$8b0f706f4df56c63;
(function(InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8b0f706f4df56c63 || ($cc61513580735d44$export$8b0f706f4df56c63 = {}));
var $cc61513580735d44$export$fa781b52e13bf866;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$fa781b52e13bf866 || ($cc61513580735d44$export$fa781b52e13bf866 = {}));
var $cc61513580735d44$export$cd419aa7f32ec382;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$cd419aa7f32ec382 || ($cc61513580735d44$export$cd419aa7f32ec382 = {}));
var $cc61513580735d44$export$82cff5e5a0a874dd;
(function(NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$82cff5e5a0a874dd || ($cc61513580735d44$export$82cff5e5a0a874dd = {}));
var $cc61513580735d44$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$cbdaf31887dd0603 || ($cc61513580735d44$export$cbdaf31887dd0603 = {}));
var $cc61513580735d44$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$4a67805ad445f61 || ($cc61513580735d44$export$4a67805ad445f61 = {}));
var $cc61513580735d44$export$6ce299b58e0ab8fe;
(function(DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$6ce299b58e0ab8fe || ($cc61513580735d44$export$6ce299b58e0ab8fe = {}));
var $cc61513580735d44$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})($cc61513580735d44$export$d4e71bc0b80dc0fb || ($cc61513580735d44$export$d4e71bc0b80dc0fb = {}));
var $cc61513580735d44$export$7235a8ee19d2bee3;
(function(UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$7235a8ee19d2bee3 || ($cc61513580735d44$export$7235a8ee19d2bee3 = {}));
var $cc61513580735d44$export$2b5603236acc81d9;
(function(DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$2b5603236acc81d9 || ($cc61513580735d44$export$2b5603236acc81d9 = {}));
var $cc61513580735d44$export$cb6981b8f9a703c2;
(function(DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$cb6981b8f9a703c2 || ($cc61513580735d44$export$cb6981b8f9a703c2 = {}));
var $cc61513580735d44$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$ecba565262f8bb2 || ($cc61513580735d44$export$ecba565262f8bb2 = {}));
var $cc61513580735d44$export$46587acc7855d6e2;
(function(DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$46587acc7855d6e2 || ($cc61513580735d44$export$46587acc7855d6e2 = {}));
var $cc61513580735d44$export$16e1ea20d4f13fa7;
(function(IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$16e1ea20d4f13fa7 || ($cc61513580735d44$export$16e1ea20d4f13fa7 = {}));
var $cc61513580735d44$export$4b5909fe2abc147d;
(function(DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$4b5909fe2abc147d || ($cc61513580735d44$export$4b5909fe2abc147d = {}));
var $cc61513580735d44$export$cb77a58cb7dbb17;
(function(ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$cb77a58cb7dbb17 || ($cc61513580735d44$export$cb77a58cb7dbb17 = {}));
var $cc61513580735d44$export$bb51e43959182308;
(function(GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$bb51e43959182308 || ($cc61513580735d44$export$bb51e43959182308 = {}));
var $cc61513580735d44$export$a9627919734faa48;
(function(Credentials) {
    Credentials.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$a9627919734faa48 || ($cc61513580735d44$export$a9627919734faa48 = {}));
var $cc61513580735d44$export$ba56c4cb277a72f9;
(function(GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$ba56c4cb277a72f9 || ($cc61513580735d44$export$ba56c4cb277a72f9 = {}));
var $cc61513580735d44$export$90d12448d3766cda;
(function(InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$90d12448d3766cda || ($cc61513580735d44$export$90d12448d3766cda = {}));
var $cc61513580735d44$export$badc3094716a9faa;
(function(GetIdInput) {
    GetIdInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$badc3094716a9faa || ($cc61513580735d44$export$badc3094716a9faa = {}));
var $cc61513580735d44$export$c3ec238968a6e7ac;
(function(GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$c3ec238968a6e7ac || ($cc61513580735d44$export$c3ec238968a6e7ac = {}));
var $cc61513580735d44$export$f5f529c0b4e5eb30;
(function(GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$f5f529c0b4e5eb30 || ($cc61513580735d44$export$f5f529c0b4e5eb30 = {}));
var $cc61513580735d44$export$819b5ceb37e06be;
(function(MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})($cc61513580735d44$export$819b5ceb37e06be || ($cc61513580735d44$export$819b5ceb37e06be = {}));
var $cc61513580735d44$export$3f8398961535c3a;
(function(MappingRule) {
    MappingRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$3f8398961535c3a || ($cc61513580735d44$export$3f8398961535c3a = {}));
var $cc61513580735d44$export$269dcf2519324984;
(function(RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$269dcf2519324984 || ($cc61513580735d44$export$269dcf2519324984 = {}));
var $cc61513580735d44$export$c726ef784882c23e;
(function(RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})($cc61513580735d44$export$c726ef784882c23e || ($cc61513580735d44$export$c726ef784882c23e = {}));
var $cc61513580735d44$export$c8be61b857de8364;
(function(RoleMapping) {
    RoleMapping.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$c8be61b857de8364 || ($cc61513580735d44$export$c8be61b857de8364 = {}));
var $cc61513580735d44$export$69a6cbc1a215fcdf;
(function(GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$69a6cbc1a215fcdf || ($cc61513580735d44$export$69a6cbc1a215fcdf = {}));
var $cc61513580735d44$export$e31993063e9290fd;
(function(GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$e31993063e9290fd || ($cc61513580735d44$export$e31993063e9290fd = {}));
var $cc61513580735d44$export$c2cdb3ad9240cf7d;
(function(GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$c2cdb3ad9240cf7d || ($cc61513580735d44$export$c2cdb3ad9240cf7d = {}));
var $cc61513580735d44$export$f9e8c5d2069aeea4;
(function(DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$f9e8c5d2069aeea4 || ($cc61513580735d44$export$f9e8c5d2069aeea4 = {}));
var $cc61513580735d44$export$b30c26022c4ccb98;
(function(GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$b30c26022c4ccb98 || ($cc61513580735d44$export$b30c26022c4ccb98 = {}));
var $cc61513580735d44$export$39b050249a579e7b;
(function(GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$39b050249a579e7b || ($cc61513580735d44$export$39b050249a579e7b = {}));
var $cc61513580735d44$export$8c1e5f4b8dc33aa1;
(function(ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8c1e5f4b8dc33aa1 || ($cc61513580735d44$export$8c1e5f4b8dc33aa1 = {}));
var $cc61513580735d44$export$5270c3e17502575a;
(function(ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$5270c3e17502575a || ($cc61513580735d44$export$5270c3e17502575a = {}));
var $cc61513580735d44$export$1d38161f8b62ad;
(function(ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$1d38161f8b62ad || ($cc61513580735d44$export$1d38161f8b62ad = {}));
var $cc61513580735d44$export$5a7a0c97755dcf8e;
(function(IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$5a7a0c97755dcf8e || ($cc61513580735d44$export$5a7a0c97755dcf8e = {}));
var $cc61513580735d44$export$f862a07a4a7c6250;
(function(ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$f862a07a4a7c6250 || ($cc61513580735d44$export$f862a07a4a7c6250 = {}));
var $cc61513580735d44$export$8eb1e3f42ea35fee;
(function(ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8eb1e3f42ea35fee || ($cc61513580735d44$export$8eb1e3f42ea35fee = {}));
var $cc61513580735d44$export$6db0c8c0f26e7fec;
(function(ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$6db0c8c0f26e7fec || ($cc61513580735d44$export$6db0c8c0f26e7fec = {}));
var $cc61513580735d44$export$1624698866821668;
(function(LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$1624698866821668 || ($cc61513580735d44$export$1624698866821668 = {}));
var $cc61513580735d44$export$fb0cf3531245501b;
(function(LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$fb0cf3531245501b || ($cc61513580735d44$export$fb0cf3531245501b = {}));
var $cc61513580735d44$export$8f282934b0cfbc4a;
(function(MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$8f282934b0cfbc4a || ($cc61513580735d44$export$8f282934b0cfbc4a = {}));
var $cc61513580735d44$export$13aa23992eef667b;
(function(MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$13aa23992eef667b || ($cc61513580735d44$export$13aa23992eef667b = {}));
var $cc61513580735d44$export$21f15e80c2bbca09;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$21f15e80c2bbca09 || ($cc61513580735d44$export$21f15e80c2bbca09 = {}));
var $cc61513580735d44$export$20f43a93eb8d3b02;
(function(SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$20f43a93eb8d3b02 || ($cc61513580735d44$export$20f43a93eb8d3b02 = {}));
var $cc61513580735d44$export$a5e7dff780e8dcb0;
(function(TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$a5e7dff780e8dcb0 || ($cc61513580735d44$export$a5e7dff780e8dcb0 = {}));
var $cc61513580735d44$export$2d5279802486e8b0;
(function(TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$2d5279802486e8b0 || ($cc61513580735d44$export$2d5279802486e8b0 = {}));
var $cc61513580735d44$export$b977eb1c8f754bfa;
(function(UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$b977eb1c8f754bfa || ($cc61513580735d44$export$b977eb1c8f754bfa = {}));
var $cc61513580735d44$export$2415026a66f5e70b;
(function(UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$2415026a66f5e70b || ($cc61513580735d44$export$2415026a66f5e70b = {}));
var $cc61513580735d44$export$4dbbd8ede80c9c36;
(function(UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$4dbbd8ede80c9c36 || ($cc61513580735d44$export$4dbbd8ede80c9c36 = {}));
var $cc61513580735d44$export$2128f49a7cd2e47f;
(function(UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($cc61513580735d44$export$2128f49a7cd2e47f || ($cc61513580735d44$export$2128f49a7cd2e47f = {}));



var $3d9355a0aa2c65bb$export$1d94dfe0d9d1f1e7 = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $fd06166a72894760$var$extendStatics = function(d, b) {
    $fd06166a72894760$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $fd06166a72894760$var$extendStatics(d, b);
};
function $fd06166a72894760$export$a8ba968b8961cb8a(d, b) {
    $fd06166a72894760$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fd06166a72894760$export$18ce0697a983be9b = function() {
    $fd06166a72894760$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fd06166a72894760$export$18ce0697a983be9b.apply(this, arguments);
};
function $fd06166a72894760$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fd06166a72894760$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fd06166a72894760$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fd06166a72894760$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fd06166a72894760$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fd06166a72894760$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $fd06166a72894760$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $fd06166a72894760$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $fd06166a72894760$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fd06166a72894760$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fd06166a72894760$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fd06166a72894760$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fd06166a72894760$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fd06166a72894760$export$10c90e4f7922046c(v) {
    return this instanceof $fd06166a72894760$export$10c90e4f7922046c ? (this.v = v, this) : new $fd06166a72894760$export$10c90e4f7922046c(v);
}
function $fd06166a72894760$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fd06166a72894760$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fd06166a72894760$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fd06166a72894760$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $fd06166a72894760$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fd06166a72894760$export$19a8beecd37a4c45 === "function" ? $fd06166a72894760$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fd06166a72894760$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $fd06166a72894760$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $fd06166a72894760$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fd06166a72894760$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $fd06166a72894760$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $aed66665aa7d42d3$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $fd06166a72894760$export$18ce0697a983be9b)((0, $fd06166a72894760$export$18ce0697a983be9b)({}, this), {
            headers: (0, $fd06166a72894760$export$18ce0697a983be9b)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $aed66665aa7d42d3$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $aed66665aa7d42d3$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $fd06166a72894760$export$18ce0697a983be9b)((0, $fd06166a72894760$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $fd06166a72894760$export$afc72e2116322959)(param) : param, _a));
    }, {});
}




function $318406ae2be697e4$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
    return hostPattern.test(hostname);
}




var $af1cee24dadce5fc$export$44d8caf684388429 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.CreateIdentityPool"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1CreateIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$2f9133f6d812a2b4 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DeleteIdentities"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1DeleteIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$900e66311faca63a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DeleteIdentityPool"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1DeleteIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$f0f695bb22170112 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DescribeIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1DescribeIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$24669e6016ff61f7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.DescribeIdentityPool"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1DescribeIdentityPoolInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$88af91ae17f8527c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$83083ba13837129b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetId"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1GetIdInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$291166950901964 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetIdentityPoolRoles"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$32ecbc22cb6e2bd8 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetOpenIdToken"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1GetOpenIdTokenInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$ace1f9f6edceb0aa = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$dcc2b10f333c963c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListIdentities"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1ListIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$dfc0836148ba7f7b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListIdentityPools"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1ListIdentityPoolsInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$aea8c8426f72de9a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.ListTagsForResource"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1ListTagsForResourceInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$3ddf979554ffe001 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.LookupDeveloperIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$5d3f7522269fe239 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.MergeDeveloperIdentities"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$50298d3eb327ab40 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.SetIdentityPoolRoles"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$be03555111349623 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.TagResource"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1TagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$43e326e2b54f124a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$4ee03f1a7a9d5800 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UnlinkIdentity"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1UnlinkIdentityInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$3f5f89d1d8515037 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UntagResource"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1UntagResourceInput(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$7a962066e209647 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            headers = {
                "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityService.UpdateIdentityPool"
            };
            body = JSON.stringify($af1cee24dadce5fc$var$serializeAws_json1_1IdentityPool(input, context));
            return [
                2 /*return*/ ,
                $af1cee24dadce5fc$var$buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var $af1cee24dadce5fc$export$2065e670c73ee068 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1CreateIdentityPoolCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$a14663734e0f26e7 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentitiesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$77baf36526f7cd7e = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentityPoolCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$1863cd4cff27fb2f = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1DescribeIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityDescription(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DescribeIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$1457f79b69c648d1 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DescribeIdentityPoolCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$ebea9103431f9a50 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetCredentialsForIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$9f5769abdc93f0b4 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$731e618e28a38bab = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$ccfef68aa75a7c47 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$c7916ef0d543f5e3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$a2439911ac8089ba = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentitiesResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentitiesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$36b32c966a7eefbd = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentityPoolsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$efb57976dadbc12b = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ListTagsForResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListTagsForResourceCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$6476ab94d95217ab = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1LookupDeveloperIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$73edba62ad60e9b9 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$4d01436d85148f27 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1SetIdentityPoolRolesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$2bbf6fe70d6779a6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1TagResourceResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1TagResourceCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$d8ee329529310a85 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$b3b4038b9cc6cf0c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1UnlinkIdentityCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UnlinkIdentityCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$4e56caf614610ee8 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1UntagResourceCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1UntagResourceResponse(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UntagResourceCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$export$e9cc2af0cb85eeaa = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPool(data, context);
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UpdateIdentityPoolCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, errorTypeParts, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
        var _l;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_m) {
            switch(_m.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _l = {};
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_l.body = _m.sent(), _l)
                    ]));
                    errorCode = "UnknownError";
                    errorTypeParts = parsedOutput.body["__type"].split("#");
                    errorCode = errorTypeParts[1] === undefined ? errorTypeParts[0] : errorTypeParts[1];
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cognitoidentity#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cognitoidentity#InternalErrorException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cognitoidentity#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _m.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 18:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $af1cee24dadce5fc$var$deserializeMetadata(output)
                    });
                    _m.label = 19;
                case 19:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "DeveloperUserAlreadyRegisteredException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsException(body, context);
            contents = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $af1cee24dadce5fc$var$deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1CognitoIdentityProvider = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ClientId !== undefined && {
        ClientId: input.ClientId
    }), input.ProviderName !== undefined && {
        ProviderName: input.ProviderName
    }), input.ServerSideTokenCheck !== undefined && {
        ServerSideTokenCheck: input.ServerSideTokenCheck
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1CognitoIdentityProviderList = function(input, context) {
    return input.map(function(entry) {
        return $af1cee24dadce5fc$var$serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1CreateIdentityPoolInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && {
        CognitoIdentityProviders: $af1cee24dadce5fc$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolName !== undefined && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && {
        IdentityPoolTags: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && {
        OpenIdConnectProviderARNs: $af1cee24dadce5fc$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && {
        SamlProviderARNs: $af1cee24dadce5fc$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && {
        SupportedLoginProviders: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1DeleteIdentitiesInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityIdsToDelete !== undefined && {
        IdentityIdsToDelete: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1DeleteIdentityPoolInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1DescribeIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1DescribeIdentityPoolInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1GetCredentialsForIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CustomRoleArn !== undefined && {
        CustomRoleArn: input.CustomRoleArn
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1GetIdentityPoolRolesInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1GetIdInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AccountId !== undefined && {
        AccountId: input.AccountId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && {
        Logins: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.Logins !== undefined && {
        Logins: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.TokenDuration !== undefined && {
        TokenDuration: input.TokenDuration
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1GetOpenIdTokenInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1IdentityIdList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPool = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AllowClassicFlow !== undefined && {
        AllowClassicFlow: input.AllowClassicFlow
    }), input.AllowUnauthenticatedIdentities !== undefined && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities
    }), input.CognitoIdentityProviders !== undefined && {
        CognitoIdentityProviders: $af1cee24dadce5fc$var$serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context)
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.IdentityPoolName !== undefined && {
        IdentityPoolName: input.IdentityPoolName
    }), input.IdentityPoolTags !== undefined && {
        IdentityPoolTags: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context)
    }), input.OpenIdConnectProviderARNs !== undefined && {
        OpenIdConnectProviderARNs: $af1cee24dadce5fc$var$serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context)
    }), input.SamlProviderARNs !== undefined && {
        SamlProviderARNs: $af1cee24dadce5fc$var$serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context)
    }), input.SupportedLoginProviders !== undefined && {
        SupportedLoginProviders: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsListType = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsType = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$serializeAws_json1_1IdentityProviders = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$serializeAws_json1_1ListIdentitiesInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.HideDisabled !== undefined && {
        HideDisabled: input.HideDisabled
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1ListIdentityPoolsInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1ListTagsForResourceInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1LoginsList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$serializeAws_json1_1LookupDeveloperIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DeveloperUserIdentifier !== undefined && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.MaxResults !== undefined && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && {
        NextToken: input.NextToken
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1MappingRule = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Claim !== undefined && {
        Claim: input.Claim
    }), input.MatchType !== undefined && {
        MatchType: input.MatchType
    }), input.RoleARN !== undefined && {
        RoleARN: input.RoleARN
    }), input.Value !== undefined && {
        Value: input.Value
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1MappingRulesList = function(input, context) {
    return input.map(function(entry) {
        return $af1cee24dadce5fc$var$serializeAws_json1_1MappingRule(entry, context);
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1MergeDeveloperIdentitiesInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DestinationUserIdentifier !== undefined && {
        DestinationUserIdentifier: input.DestinationUserIdentifier
    }), input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.SourceUserIdentifier !== undefined && {
        SourceUserIdentifier: input.SourceUserIdentifier
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1OIDCProviderList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1RoleMapping = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AmbiguousRoleResolution !== undefined && {
        AmbiguousRoleResolution: input.AmbiguousRoleResolution
    }), input.RulesConfiguration !== undefined && {
        RulesConfiguration: $af1cee24dadce5fc$var$serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context)
    }), input.Type !== undefined && {
        Type: input.Type
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1RoleMappingMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $af1cee24dadce5fc$var$serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $af1cee24dadce5fc$var$serializeAws_json1_1RolesMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$serializeAws_json1_1RulesConfigurationType = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Rules !== undefined && {
        Rules: $af1cee24dadce5fc$var$serializeAws_json1_1MappingRulesList(input.Rules, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1SAMLProviderList = function(input, context) {
    return input.map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1SetIdentityPoolRolesInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    }), input.RoleMappings !== undefined && {
        RoleMappings: $af1cee24dadce5fc$var$serializeAws_json1_1RoleMappingMap(input.RoleMappings, context)
    }), input.Roles !== undefined && {
        Roles: $af1cee24dadce5fc$var$serializeAws_json1_1RolesMap(input.Roles, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1TagResourceInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    }), input.Tags !== undefined && {
        Tags: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsType(input.Tags, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1UnlinkDeveloperIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DeveloperProviderName !== undefined && {
        DeveloperProviderName: input.DeveloperProviderName
    }), input.DeveloperUserIdentifier !== undefined && {
        DeveloperUserIdentifier: input.DeveloperUserIdentifier
    }), input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.IdentityPoolId !== undefined && {
        IdentityPoolId: input.IdentityPoolId
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1UnlinkIdentityInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.IdentityId !== undefined && {
        IdentityId: input.IdentityId
    }), input.Logins !== undefined && {
        Logins: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsMap(input.Logins, context)
    }), input.LoginsToRemove !== undefined && {
        LoginsToRemove: $af1cee24dadce5fc$var$serializeAws_json1_1LoginsList(input.LoginsToRemove, context)
    });
};
var $af1cee24dadce5fc$var$serializeAws_json1_1UntagResourceInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ResourceArn !== undefined && {
        ResourceArn: input.ResourceArn
    }), input.TagKeys !== undefined && {
        TagKeys: $af1cee24dadce5fc$var$serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context)
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1CognitoIdentityProvider = function(output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null ? output.ServerSideTokenCheck : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1CognitoIdentityProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return $af1cee24dadce5fc$var$deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1Credentials = function(output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null ? new Date(Math.round(output.Expiration * 1000)) : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeleteIdentitiesResponse = function(output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserIdentifierList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ExternalServiceException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetCredentialsForIdentityResponse = function(output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1Credentials(output.Credentials, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdentityPoolRolesResponse = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context) : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1RolesMap(output.Roles, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetIdResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1GetOpenIdTokenResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentitiesList = function(output, context) {
    return (output || []).map(function(entry) {
        return $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityDescription = function(output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null ? new Date(Math.round(output.CreationDate * 1000)) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null ? new Date(Math.round(output.LastModifiedDate * 1000)) : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1LoginsList(output.Logins, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPool = function(output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null ? output.AllowUnauthenticatedIdentities : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context) : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null ? output.DeveloperProviderName : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context) : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context) : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context) : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolShortDescription = function(output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolsList = function(output, context) {
    return (output || []).map(function(entry) {
        return $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolTagsType = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityProviders = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InternalErrorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentitiesResponse = function(output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1IdentitiesList(output.Identities, context) : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListIdentityPoolsResponse = function(output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ListTagsForResourceResponse = function(output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1LoginsList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1LookupDeveloperIdentityResponse = function(output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context) : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1MappingRule = function(output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1MappingRulesList = function(output, context) {
    return (output || []).map(function(entry) {
        return $af1cee24dadce5fc$var$deserializeAws_json1_1MappingRule(entry, context);
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function(output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1NotAuthorizedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1OIDCProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceConflictException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1RoleMapping = function(output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null ? output.AmbiguousRoleResolution : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1RoleMappingMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $af1cee24dadce5fc$var$deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1RolesMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1RulesConfigurationType = function(output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null ? $af1cee24dadce5fc$var$deserializeAws_json1_1MappingRulesList(output.Rules, context) : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1SAMLProviderList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1TagResourceResponse = function(output, context) {
    return {};
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1TooManyRequestsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UnprocessedIdentityId = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined
    };
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UnprocessedIdentityIdList = function(output, context) {
    return (output || []).map(function(entry) {
        return $af1cee24dadce5fc$var$deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var $af1cee24dadce5fc$var$deserializeAws_json1_1UntagResourceResponse = function(output, context) {
    return {};
};
var $af1cee24dadce5fc$var$deserializeMetadata = function(output) {
    return {
        httpStatusCode: output.statusCode,
        httpHeaders: output.headers,
        requestId: output.headers["x-amzn-requestid"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $af1cee24dadce5fc$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $af1cee24dadce5fc$var$collectBodyString = function(streamBody, context) {
    return $af1cee24dadce5fc$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $af1cee24dadce5fc$var$buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)(contents)
                    ];
            }
        });
    });
};
var $af1cee24dadce5fc$var$parseBody = function(streamBody, context) {
    return $af1cee24dadce5fc$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $11951985bf3f746b$var$extendStatics = function(d, b) {
    $11951985bf3f746b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $11951985bf3f746b$var$extendStatics(d, b);
};
function $11951985bf3f746b$export$a8ba968b8961cb8a(d, b) {
    $11951985bf3f746b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $11951985bf3f746b$export$18ce0697a983be9b = function() {
    $11951985bf3f746b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $11951985bf3f746b$export$18ce0697a983be9b.apply(this, arguments);
};
function $11951985bf3f746b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $11951985bf3f746b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $11951985bf3f746b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $11951985bf3f746b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $11951985bf3f746b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $11951985bf3f746b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $11951985bf3f746b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $11951985bf3f746b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $11951985bf3f746b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $11951985bf3f746b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $11951985bf3f746b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($11951985bf3f746b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $11951985bf3f746b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $11951985bf3f746b$export$10c90e4f7922046c(v) {
    return this instanceof $11951985bf3f746b$export$10c90e4f7922046c ? (this.v = v, this) : new $11951985bf3f746b$export$10c90e4f7922046c(v);
}
function $11951985bf3f746b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $11951985bf3f746b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $11951985bf3f746b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $11951985bf3f746b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $11951985bf3f746b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $11951985bf3f746b$export$19a8beecd37a4c45 === "function" ? $11951985bf3f746b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $11951985bf3f746b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $11951985bf3f746b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $11951985bf3f746b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $11951985bf3f746b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $11951985bf3f746b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $a42579721993f193$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $11951985bf3f746b$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var logger, outputFilterSensitiveLog, response, parsed, $metadata, outputWithoutMetadata;
                return (0, $11951985bf3f746b$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") logger.debug({
                                httpResponse: response
                            });
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            $metadata = parsed.$metadata, outputWithoutMetadata = (0, $11951985bf3f746b$export$3c9a16f847548506)(parsed, [
                                "$metadata"
                            ]);
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") logger.info({
                                output: outputFilterSensitiveLog(outputWithoutMetadata)
                            });
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};



var $c09da373168caa8b$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $11951985bf3f746b$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var logger, inputFilterSensitiveLog, request;
                return (0, $11951985bf3f746b$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger = context.logger, inputFilterSensitiveLog = context.inputFilterSensitiveLog;
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.info) === "function") logger.info({
                                input: inputFilterSensitiveLog(args.input)
                            });
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            if (typeof (logger === null || logger === void 0 ? void 0 : logger.debug) === "function") logger.debug({
                                httpRequest: request
                            });
                            return [
                                2 /*return*/ ,
                                next((0, $11951985bf3f746b$export$18ce0697a983be9b)((0, $11951985bf3f746b$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};




var $9aadd364f0631d68$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ]
};
var $9aadd364f0631d68$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ]
};
function $9aadd364f0631d68$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $a42579721993f193$export$d10196e291075f95)(config, deserializer), $9aadd364f0631d68$export$f5d82b333b4f39c9);
            commandStack.add((0, $c09da373168caa8b$export$125a23d36094c5de)(config, serializer), $9aadd364f0631d68$export$1bd449976e9c484d);
        }
    };
}




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $fc94f897f76e66dd$var$extendStatics = function(d, b) {
    $fc94f897f76e66dd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $fc94f897f76e66dd$var$extendStatics(d, b);
};
function $fc94f897f76e66dd$export$a8ba968b8961cb8a(d, b) {
    $fc94f897f76e66dd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc94f897f76e66dd$export$18ce0697a983be9b = function() {
    $fc94f897f76e66dd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc94f897f76e66dd$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc94f897f76e66dd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc94f897f76e66dd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc94f897f76e66dd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc94f897f76e66dd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc94f897f76e66dd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc94f897f76e66dd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $fc94f897f76e66dd$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $fc94f897f76e66dd$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $fc94f897f76e66dd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc94f897f76e66dd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc94f897f76e66dd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc94f897f76e66dd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc94f897f76e66dd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc94f897f76e66dd$export$10c90e4f7922046c(v) {
    return this instanceof $fc94f897f76e66dd$export$10c90e4f7922046c ? (this.v = v, this) : new $fc94f897f76e66dd$export$10c90e4f7922046c(v);
}
function $fc94f897f76e66dd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc94f897f76e66dd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc94f897f76e66dd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc94f897f76e66dd$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc94f897f76e66dd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc94f897f76e66dd$export$19a8beecd37a4c45 === "function" ? $fc94f897f76e66dd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc94f897f76e66dd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $fc94f897f76e66dd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $fc94f897f76e66dd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc94f897f76e66dd$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $fc94f897f76e66dd$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $6814728732d56399$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $6814728732d56399$var$stepWeights[b.step] - $6814728732d56399$var$stepWeights[a.step] || $6814728732d56399$var$priorityWeights[b.priority || "normal"] - $6814728732d56399$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, $fc94f897f76e66dd$export$18ce0697a983be9b)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, $fc94f897f76e66dd$export$18ce0697a983be9b)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $fc94f897f76e66dd$export$afc72e2116322959)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $fc94f897f76e66dd$export$afc72e2116322959)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $fc94f897f76e66dd$export$18ce0697a983be9b)((0, $fc94f897f76e66dd$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $fc94f897f76e66dd$export$18ce0697a983be9b)((0, $fc94f897f76e66dd$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, $fc94f897f76e66dd$export$afc72e2116322959)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name;
            var entry = (0, $fc94f897f76e66dd$export$18ce0697a983be9b)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) throw new Error("Duplicate middleware name '" + name + "'");
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name;
            var entry = (0, $fc94f897f76e66dd$export$18ce0697a983be9b)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) throw new Error("Duplicated middleware name '" + name + "'");
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($6814728732d56399$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($6814728732d56399$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $fc94f897f76e66dd$export$19a8beecd37a4c45)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $6814728732d56399$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $6814728732d56399$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




var $0b86a7f9694de380$export$1f2bb630327ac4b6 = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, $6814728732d56399$export$73604a93307363d8)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();



var $5ee71f766328e8a3$export$cc7e12c76513e857 = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, $6814728732d56399$export$73604a93307363d8)();
    }
    return Command;
}();






/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ function $b5fbea5816c6a090$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}


/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var $cb1b53da86195f79$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};


/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var $398e8cd657eaeefc$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $398e8cd657eaeefc$export$113d90026b452881(obj[key]);
    }
    return obj;
};


/**
 * Lazy String holder for JSON typed contents.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $757c0994bf81e46f$var$extendStatics = function(d, b) {
    $757c0994bf81e46f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $757c0994bf81e46f$var$extendStatics(d, b);
};
function $757c0994bf81e46f$export$a8ba968b8961cb8a(d, b) {
    $757c0994bf81e46f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $757c0994bf81e46f$export$18ce0697a983be9b = function() {
    $757c0994bf81e46f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $757c0994bf81e46f$export$18ce0697a983be9b.apply(this, arguments);
};
function $757c0994bf81e46f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $757c0994bf81e46f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $757c0994bf81e46f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $757c0994bf81e46f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $757c0994bf81e46f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $757c0994bf81e46f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $757c0994bf81e46f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $757c0994bf81e46f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $757c0994bf81e46f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $757c0994bf81e46f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $757c0994bf81e46f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($757c0994bf81e46f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $757c0994bf81e46f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $757c0994bf81e46f$export$10c90e4f7922046c(v) {
    return this instanceof $757c0994bf81e46f$export$10c90e4f7922046c ? (this.v = v, this) : new $757c0994bf81e46f$export$10c90e4f7922046c(v);
}
function $757c0994bf81e46f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $757c0994bf81e46f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $757c0994bf81e46f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $757c0994bf81e46f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $757c0994bf81e46f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $757c0994bf81e46f$export$19a8beecd37a4c45 === "function" ? $757c0994bf81e46f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $757c0994bf81e46f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $757c0994bf81e46f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $757c0994bf81e46f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $757c0994bf81e46f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $757c0994bf81e46f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $d0504491462b3bea$export$40e2db4f1ce24b10 = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $757c0994bf81e46f$export$afc72e2116322959)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$d0504491462b3bea$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $d0504491462b3bea$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($d0504491462b3bea$export$40e2db4f1ce24b10, String);
var $d0504491462b3bea$export$494ed5148690ecaf = /** @class */ function(_super) {
    (0, $757c0994bf81e46f$export$a8ba968b8961cb8a)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($d0504491462b3bea$export$40e2db4f1ce24b10);


/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var $e8dafff637da29c2$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var $e8dafff637da29c2$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $e8dafff637da29c2$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $e8dafff637da29c2$var$days[dayOfWeek] + ", " + dayOfMonthString + " " + $e8dafff637da29c2$var$months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}


/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ function $09c0920d5a1271b1$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}


var $2323beca7fe8f8bb$export$17127055dc9ac067 = "***SensitiveInformation***";








var $b75f76f26c77b518$export$e08b3308c36761ec = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $cc61513580735d44$export$bb51e43959182308).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $cc61513580735d44$export$ba56c4cb277a72f9).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function(input, context) {
        return (0, $af1cee24dadce5fc$export$88af91ae17f8527c)(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function(output, context) {
        return (0, $af1cee24dadce5fc$export$ebea9103431f9a50)(output, context);
    };
    return GetCredentialsForIdentityCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));




/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */ var $f1f344eceeb479be$export$478ec1fdae99aa79 = /** @class */ function(_super) {
    (0, $fd96a331b5a987bc$export$a8ba968b8961cb8a)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error);


function $69e53560a4475df2$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $f1f344eceeb479be$export$478ec1fdae99aa79)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $fd96a331b5a987bc$export$19a8beecd37a4c45)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}


var $1403355727d2ce3e$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};



var $35bc765f5556cf36$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) // This is a static memoization; no need to incorporate refreshing
    return function() {
        if (!hasResult) {
            result = provider();
            hasResult = true;
        }
        return result;
    };
    var isConstant = false;
    return function() {
        return (0, $fd96a331b5a987bc$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var resolved;
            return (0, $fd96a331b5a987bc$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!hasResult) {
                            result = provider();
                            hasResult = true;
                        }
                        if (isConstant) return [
                            2 /*return*/ ,
                            result
                        ];
                        return [
                            4 /*yield*/ ,
                            result
                        ];
                    case 1:
                        resolved = _a.sent();
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2 /*return*/ ,
                                resolved
                            ];
                        }
                        if (isExpired(resolved)) return [
                            2 /*return*/ ,
                            result = provider()
                        ];
                        return [
                            2 /*return*/ ,
                            resolved
                        ];
                }
            });
        });
    };
};






function $8cbe00f0752e6945$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce(function(arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then(function(token) {
            return [
                name,
                token
            ];
        }));
        return arr;
    }, [])).then(function(resolvedPairs) {
        return resolvedPairs.reduce(function(logins, _a) {
            var _b = (0, $fd96a331b5a987bc$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}


function $9e00f51273bd8045$export$4d624d71eb462130(parameters) {
    var _this = this;
    return function() {
        return (0, $fd96a331b5a987bc$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
            var _j;
            return (0, $fd96a331b5a987bc$export$67ebef60e6f28a6)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _f = (_e = parameters.client).send;
                        _g = (0, $b75f76f26c77b518$export$e08b3308c36761ec).bind;
                        _j = {
                            CustomRoleArn: parameters.customRoleArn,
                            IdentityId: parameters.identityId
                        };
                        if (!parameters.logins) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8cbe00f0752e6945$export$fb1e896f6704b6a6)(parameters.logins)
                        ];
                    case 1:
                        _h = _k.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _h = undefined;
                        _k.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            _f.apply(_e, [
                                new (_g.apply((0, $b75f76f26c77b518$export$e08b3308c36761ec), [
                                    void 0,
                                    (_j.Logins = _h, _j)
                                ]))()
                            ])
                        ];
                    case 4:
                        _a = _k.sent().Credentials, _b = _a === void 0 ? $9e00f51273bd8045$var$throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? $9e00f51273bd8045$var$throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? $9e00f51273bd8045$var$throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                        return [
                            2 /*return*/ ,
                            {
                                identityId: parameters.identityId,
                                accessKeyId: AccessKeyId,
                                secretAccessKey: SecretKey,
                                sessionToken: SessionToken,
                                expiration: Expiration
                            }
                        ];
                }
            });
        });
    };
}
function $9e00f51273bd8045$var$throwOnMissingAccessKeyId() {
    throw new (0, $f1f344eceeb479be$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no access key ID");
}
function $9e00f51273bd8045$var$throwOnMissingCredentials() {
    throw new (0, $f1f344eceeb479be$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no credentials");
}
function $9e00f51273bd8045$var$throwOnMissingSecretKey() {
    throw new (0, $f1f344eceeb479be$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no secret key");
}







var $6fe0805914a4e7b6$export$41ceb4ced4f97a44 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetIdCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $cc61513580735d44$export$badc3094716a9faa).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $cc61513580735d44$export$c3ec238968a6e7ac).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function(input, context) {
        return (0, $af1cee24dadce5fc$export$83083ba13837129b)(input, context);
    };
    GetIdCommand.prototype.deserialize = function(output, context) {
        return (0, $af1cee24dadce5fc$export$9f5769abdc93f0b4)(output, context);
    };
    return GetIdCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));




var $d8f9f2be9cefaaa1$var$STORE_NAME = "IdentityIds";
var $d8f9f2be9cefaaa1$export$55d38e5384f402 = /** @class */ function() {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) dbName = "aws:cognito-identity-ids";
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function(key) {
        return this.withObjectStore("readonly", function(store) {
            var req = store.get(key);
            return new Promise(function(resolve) {
                req.onerror = function() {
                    return resolve(null);
                };
                req.onsuccess = function() {
                    return resolve(req.result ? req.result.value : null);
                };
            });
        }).catch(function() {
            return null;
        });
    };
    IndexedDbStorage.prototype.removeItem = function(key) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.delete(key);
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function(id, value) {
        return this.withObjectStore("readwrite", function(store) {
            var req = store.put({
                id: id,
                value: value
            });
            return new Promise(function(resolve, reject) {
                req.onerror = function() {
                    return reject(req.error);
                };
                req.onsuccess = function() {
                    return resolve();
                };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function() {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function(resolve, reject) {
            openDbRequest.onsuccess = function() {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function() {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function() {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function() {
                var db = openDbRequest.result;
                db.onerror = function() {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($d8f9f2be9cefaaa1$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function(mode, action) {
        return this.getDb().then(function(db) {
            var tx = db.transaction($d8f9f2be9cefaaa1$var$STORE_NAME, mode);
            tx.oncomplete = function() {
                return db.close();
            };
            return new Promise(function(resolve, reject) {
                tx.onerror = function() {
                    return reject(tx.error);
                };
                resolve(action(tx.objectStore($d8f9f2be9cefaaa1$var$STORE_NAME)));
            }).catch(function(err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}();


var $0f2c9d307a93dc0b$export$e4315e25b840a0ea = /** @class */ function() {
    function InMemoryStorage(store) {
        if (store === void 0) store = {};
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function(key) {
        if (key in this.store) return this.store[key];
        return null;
    };
    InMemoryStorage.prototype.removeItem = function(key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function(key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}();


var $137d54ac2ae9c2b0$var$inMemoryStorage = new (0, $0f2c9d307a93dc0b$export$e4315e25b840a0ea)();
function $137d54ac2ae9c2b0$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $d8f9f2be9cefaaa1$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $137d54ac2ae9c2b0$var$inMemoryStorage;
}



function $0a698db94ca9721d$export$6c7d622e9507a2e(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? (0, $137d54ac2ae9c2b0$export$c2ed3351cac403d1)() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function() {
        return (0, $fd96a331b5a987bc$export$1050f835b63b671e)(_this, void 0, void 0, function() {
            var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
            var _g;
            return (0, $fd96a331b5a987bc$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        _a = cacheKey;
                        if (!_a) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            cache.getItem(cacheKey)
                        ];
                    case 1:
                        _a = _h.sent();
                        _h.label = 2;
                    case 2:
                        identityId = _a;
                        if (!!identityId) return [
                            3 /*break*/ ,
                            7
                        ];
                        _d = (_c = client).send;
                        _e = (0, $6fe0805914a4e7b6$export$41ceb4ced4f97a44).bind;
                        _g = {
                            AccountId: accountId,
                            IdentityPoolId: identityPoolId
                        };
                        if (!logins) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8cbe00f0752e6945$export$fb1e896f6704b6a6)(logins)
                        ];
                    case 3:
                        _f = _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _f = undefined;
                        _h.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _d.apply(_c, [
                                new (_e.apply((0, $6fe0805914a4e7b6$export$41ceb4ced4f97a44), [
                                    void 0,
                                    (_g.Logins = _f, _g)
                                ]))()
                            ])
                        ];
                    case 6:
                        _b = _h.sent().IdentityId, IdentityId = _b === void 0 ? $0a698db94ca9721d$var$throwOnMissingId() : _b;
                        identityId = IdentityId;
                        if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function() {});
                        _h.label = 7;
                    case 7:
                        provider = (0, $9e00f51273bd8045$export$4d624d71eb462130)({
                            client: client,
                            customRoleArn: customRoleArn,
                            logins: logins,
                            identityId: identityId
                        });
                        return [
                            2 /*return*/ ,
                            provider()
                        ];
                }
            });
        });
    };
    return function() {
        return provider().catch(function(err) {
            return (0, $fd96a331b5a987bc$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $fd96a331b5a987bc$export$67ebef60e6f28a6)(this, function(_a) {
                    if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(function() {});
                    throw err;
                });
            });
        });
    };
}
function $0a698db94ca9721d$var$throwOnMissingId() {
    throw new (0, $f1f344eceeb479be$export$478ec1fdae99aa79)("Response from Amazon Cognito contained no identity ID");
}




var $30316d0885e7093a$exports = {};
$30316d0885e7093a$exports = JSON.parse("{\"name\":\"@aws-sdk/client-cognito-identity\",\"description\":\"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native\",\"version\":\"1.0.0-rc.4\",\"scripts\":{\"clean\":\"npm run remove-definitions && npm run remove-dist\",\"build-documentation\":\"npm run clean && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/credential-provider-node\":\"1.0.0-rc.3\",\"@aws-sdk/fetch-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/hash-node\":\"1.0.0-rc.3\",\"@aws-sdk/invalid-dependency\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-content-length\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-host-header\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-logger\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-retry\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-serde\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-signing\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-stack\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-user-agent\":\"1.0.0-rc.3\",\"@aws-sdk/node-config-provider\":\"1.0.0-rc.3\",\"@aws-sdk/node-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/protocol-http\":\"1.0.0-rc.3\",\"@aws-sdk/smithy-client\":\"1.0.0-rc.4\",\"@aws-sdk/types\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-browser\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-node\":\"1.0.0-rc.3\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"1.0.0-rc.3\",\"@aws-sdk/client-iam\":\"1.0.0-rc.4\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^7.0.2\",\"@types/node\":\"^12.7.5\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.17.8\",\"typescript\":\"~4.0.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/master/clients/client-cognito-identity\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cognito-identity\"}}");


var $ff311350cc9f0502$exports = {};
"use strict";
Object.defineProperty($ff311350cc9f0502$exports, "__esModule", {
    value: true
});
$ff311350cc9f0502$exports.WebCryptoSha256 = $ff311350cc9f0502$exports.Ie11Sha256 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2c69042511ad8ded$var$extendStatics = function(d, b) {
    $2c69042511ad8ded$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2c69042511ad8ded$var$extendStatics(d, b);
};
function $2c69042511ad8ded$export$a8ba968b8961cb8a(d, b) {
    $2c69042511ad8ded$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2c69042511ad8ded$export$18ce0697a983be9b = function() {
    $2c69042511ad8ded$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c69042511ad8ded$export$18ce0697a983be9b.apply(this, arguments);
};
function $2c69042511ad8ded$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2c69042511ad8ded$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2c69042511ad8ded$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2c69042511ad8ded$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2c69042511ad8ded$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2c69042511ad8ded$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2c69042511ad8ded$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2c69042511ad8ded$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2c69042511ad8ded$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2c69042511ad8ded$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2c69042511ad8ded$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2c69042511ad8ded$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2c69042511ad8ded$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2c69042511ad8ded$export$10c90e4f7922046c(v) {
    return this instanceof $2c69042511ad8ded$export$10c90e4f7922046c ? (this.v = v, this) : new $2c69042511ad8ded$export$10c90e4f7922046c(v);
}
function $2c69042511ad8ded$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2c69042511ad8ded$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2c69042511ad8ded$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2c69042511ad8ded$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2c69042511ad8ded$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2c69042511ad8ded$export$19a8beecd37a4c45 === "function" ? $2c69042511ad8ded$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2c69042511ad8ded$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2c69042511ad8ded$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2c69042511ad8ded$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2c69042511ad8ded$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2c69042511ad8ded$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



(0, $2c69042511ad8ded$export$f33643c0debef087)((parcelRequire("7Zaqq")), $ff311350cc9f0502$exports);

var $1MmVL = parcelRequire("1MmVL");
Object.defineProperty($ff311350cc9f0502$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $1MmVL.Sha256;
    }
});

var $eNCbH = parcelRequire("eNCbH");
Object.defineProperty($ff311350cc9f0502$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $eNCbH.Sha256;
    }
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $0e7182bb77bf3413$var$extendStatics = function(d, b) {
    $0e7182bb77bf3413$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $0e7182bb77bf3413$var$extendStatics(d, b);
};
function $0e7182bb77bf3413$export$a8ba968b8961cb8a(d, b) {
    $0e7182bb77bf3413$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0e7182bb77bf3413$export$18ce0697a983be9b = function() {
    $0e7182bb77bf3413$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e7182bb77bf3413$export$18ce0697a983be9b.apply(this, arguments);
};
function $0e7182bb77bf3413$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0e7182bb77bf3413$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0e7182bb77bf3413$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0e7182bb77bf3413$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0e7182bb77bf3413$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0e7182bb77bf3413$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $0e7182bb77bf3413$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $0e7182bb77bf3413$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $0e7182bb77bf3413$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0e7182bb77bf3413$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0e7182bb77bf3413$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0e7182bb77bf3413$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0e7182bb77bf3413$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0e7182bb77bf3413$export$10c90e4f7922046c(v) {
    return this instanceof $0e7182bb77bf3413$export$10c90e4f7922046c ? (this.v = v, this) : new $0e7182bb77bf3413$export$10c90e4f7922046c(v);
}
function $0e7182bb77bf3413$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0e7182bb77bf3413$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0e7182bb77bf3413$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0e7182bb77bf3413$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $0e7182bb77bf3413$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0e7182bb77bf3413$export$19a8beecd37a4c45 === "function" ? $0e7182bb77bf3413$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0e7182bb77bf3413$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $0e7182bb77bf3413$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $0e7182bb77bf3413$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0e7182bb77bf3413$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $0e7182bb77bf3413$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $aae12316be83ad26$var$extendStatics = function(d, b) {
    $aae12316be83ad26$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $aae12316be83ad26$var$extendStatics(d, b);
};
function $aae12316be83ad26$export$a8ba968b8961cb8a(d, b) {
    $aae12316be83ad26$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $aae12316be83ad26$export$18ce0697a983be9b = function() {
    $aae12316be83ad26$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aae12316be83ad26$export$18ce0697a983be9b.apply(this, arguments);
};
function $aae12316be83ad26$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $aae12316be83ad26$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $aae12316be83ad26$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $aae12316be83ad26$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $aae12316be83ad26$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $aae12316be83ad26$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $aae12316be83ad26$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $aae12316be83ad26$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $aae12316be83ad26$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $aae12316be83ad26$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $aae12316be83ad26$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($aae12316be83ad26$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $aae12316be83ad26$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $aae12316be83ad26$export$10c90e4f7922046c(v) {
    return this instanceof $aae12316be83ad26$export$10c90e4f7922046c ? (this.v = v, this) : new $aae12316be83ad26$export$10c90e4f7922046c(v);
}
function $aae12316be83ad26$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $aae12316be83ad26$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $aae12316be83ad26$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $aae12316be83ad26$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $aae12316be83ad26$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $aae12316be83ad26$export$19a8beecd37a4c45 === "function" ? $aae12316be83ad26$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $aae12316be83ad26$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $aae12316be83ad26$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $aae12316be83ad26$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $aae12316be83ad26$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $aae12316be83ad26$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $157312cd117a37c4$export$c3b4775ad75a73db = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, $157312cd117a37c4$var$hexEncode);
};
var $157312cd117a37c4$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $2c1b8b553ca62535$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $157312cd117a37c4$export$c3b4775ad75a73db)).join("/");
};




function $c44136875091ca82$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $aae12316be83ad26$export$19a8beecd37a4c45)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $157312cd117a37c4$export$c3b4775ad75a73db)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $157312cd117a37c4$export$c3b4775ad75a73db)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $157312cd117a37c4$export$c3b4775ad75a73db)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}


function $81485acbfe10e792$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


var $34bde8d3da0ca366$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(httpOptions) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    FetchHttpHandler.prototype.handle = function(request, options) {
        var abortSignal = options === null || options === void 0 ? void 0 : options.abortSignal;
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $c44136875091ca82$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        var requestOptions = {
            body: request.body,
            headers: new Headers(request.headers),
            method: request.method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $0e7182bb77bf3413$export$19a8beecd37a4c45)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $3d9355a0aa2c65bb$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $3d9355a0aa2c65bb$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $81485acbfe10e792$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();



var $33a6b0c1aa82f56b$var$alphabetByEncoding = {};
var $33a6b0c1aa82f56b$var$alphabetByValue = new Array(64);
for(var $33a6b0c1aa82f56b$var$i = 0, $33a6b0c1aa82f56b$var$start = "A".charCodeAt(0), $33a6b0c1aa82f56b$var$limit = "Z".charCodeAt(0); $33a6b0c1aa82f56b$var$i + $33a6b0c1aa82f56b$var$start <= $33a6b0c1aa82f56b$var$limit; $33a6b0c1aa82f56b$var$i++){
    var $33a6b0c1aa82f56b$var$char = String.fromCharCode($33a6b0c1aa82f56b$var$i + $33a6b0c1aa82f56b$var$start);
    $33a6b0c1aa82f56b$var$alphabetByEncoding[$33a6b0c1aa82f56b$var$char] = $33a6b0c1aa82f56b$var$i;
    $33a6b0c1aa82f56b$var$alphabetByValue[$33a6b0c1aa82f56b$var$i] = $33a6b0c1aa82f56b$var$char;
}
for(var $33a6b0c1aa82f56b$var$i = 0, $33a6b0c1aa82f56b$var$start = "a".charCodeAt(0), $33a6b0c1aa82f56b$var$limit = "z".charCodeAt(0); $33a6b0c1aa82f56b$var$i + $33a6b0c1aa82f56b$var$start <= $33a6b0c1aa82f56b$var$limit; $33a6b0c1aa82f56b$var$i++){
    var $33a6b0c1aa82f56b$var$char = String.fromCharCode($33a6b0c1aa82f56b$var$i + $33a6b0c1aa82f56b$var$start);
    var $33a6b0c1aa82f56b$var$index = $33a6b0c1aa82f56b$var$i + 26;
    $33a6b0c1aa82f56b$var$alphabetByEncoding[$33a6b0c1aa82f56b$var$char] = $33a6b0c1aa82f56b$var$index;
    $33a6b0c1aa82f56b$var$alphabetByValue[$33a6b0c1aa82f56b$var$index] = $33a6b0c1aa82f56b$var$char;
}
for(var $33a6b0c1aa82f56b$var$i = 0; $33a6b0c1aa82f56b$var$i < 10; $33a6b0c1aa82f56b$var$i++){
    $33a6b0c1aa82f56b$var$alphabetByEncoding[$33a6b0c1aa82f56b$var$i.toString(10)] = $33a6b0c1aa82f56b$var$i + 52;
    var $33a6b0c1aa82f56b$var$char = $33a6b0c1aa82f56b$var$i.toString(10);
    var $33a6b0c1aa82f56b$var$index = $33a6b0c1aa82f56b$var$i + 52;
    $33a6b0c1aa82f56b$var$alphabetByEncoding[$33a6b0c1aa82f56b$var$char] = $33a6b0c1aa82f56b$var$index;
    $33a6b0c1aa82f56b$var$alphabetByValue[$33a6b0c1aa82f56b$var$index] = $33a6b0c1aa82f56b$var$char;
}
$33a6b0c1aa82f56b$var$alphabetByEncoding["+"] = 62;
$33a6b0c1aa82f56b$var$alphabetByValue[62] = "+";
$33a6b0c1aa82f56b$var$alphabetByEncoding["/"] = 63;
$33a6b0c1aa82f56b$var$alphabetByValue[63] = "/";
var $33a6b0c1aa82f56b$var$bitsPerLetter = 6;
var $33a6b0c1aa82f56b$var$bitsPerByte = 8;
var $33a6b0c1aa82f56b$var$maxLetterValue = 63;
function $33a6b0c1aa82f56b$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= $33a6b0c1aa82f56b$var$alphabetByEncoding[input[j]] << (limit - j) * $33a6b0c1aa82f56b$var$bitsPerLetter;
            bitLength += $33a6b0c1aa82f56b$var$bitsPerLetter;
        } else bits >>= $33a6b0c1aa82f56b$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $33a6b0c1aa82f56b$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $33a6b0c1aa82f56b$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $33a6b0c1aa82f56b$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $33a6b0c1aa82f56b$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $33a6b0c1aa82f56b$var$bitsPerByte;
            bitLength += $33a6b0c1aa82f56b$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $33a6b0c1aa82f56b$var$bitsPerLetter);
        bits <<= bitClusterCount * $33a6b0c1aa82f56b$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $33a6b0c1aa82f56b$var$bitsPerLetter;
            str += $33a6b0c1aa82f56b$var$alphabetByValue[(bits & $33a6b0c1aa82f56b$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}


var $fe8309fe516a0324$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $fe8309fe516a0324$var$collectBlob(stream);
    return $fe8309fe516a0324$var$collectStream(stream);
};
function $fe8309fe516a0324$var$collectBlob(blob) {
    return (0, $0e7182bb77bf3413$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $0e7182bb77bf3413$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $fe8309fe516a0324$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $33a6b0c1aa82f56b$export$c537b38001c583b7)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $fe8309fe516a0324$var$collectStream(stream) {
    return (0, $0e7182bb77bf3413$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $0e7182bb77bf3413$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function $fe8309fe516a0324$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}




var $76e89413b78ae54a$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $55e183fc3f78a8fe$var$extendStatics = function(d, b) {
    $55e183fc3f78a8fe$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $55e183fc3f78a8fe$var$extendStatics(d, b);
};
function $55e183fc3f78a8fe$export$a8ba968b8961cb8a(d, b) {
    $55e183fc3f78a8fe$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $55e183fc3f78a8fe$export$18ce0697a983be9b = function() {
    $55e183fc3f78a8fe$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55e183fc3f78a8fe$export$18ce0697a983be9b.apply(this, arguments);
};
function $55e183fc3f78a8fe$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $55e183fc3f78a8fe$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $55e183fc3f78a8fe$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $55e183fc3f78a8fe$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $55e183fc3f78a8fe$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $55e183fc3f78a8fe$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $55e183fc3f78a8fe$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $55e183fc3f78a8fe$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $55e183fc3f78a8fe$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $55e183fc3f78a8fe$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $55e183fc3f78a8fe$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($55e183fc3f78a8fe$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $55e183fc3f78a8fe$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $55e183fc3f78a8fe$export$10c90e4f7922046c(v) {
    return this instanceof $55e183fc3f78a8fe$export$10c90e4f7922046c ? (this.v = v, this) : new $55e183fc3f78a8fe$export$10c90e4f7922046c(v);
}
function $55e183fc3f78a8fe$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $55e183fc3f78a8fe$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $55e183fc3f78a8fe$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $55e183fc3f78a8fe$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $55e183fc3f78a8fe$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $55e183fc3f78a8fe$export$19a8beecd37a4c45 === "function" ? $55e183fc3f78a8fe$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $55e183fc3f78a8fe$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $55e183fc3f78a8fe$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $55e183fc3f78a8fe$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $55e183fc3f78a8fe$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $55e183fc3f78a8fe$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $9e75aa053b37740b$export$a3922aa5f87bae85 = function(options) {
    return function(next) {
        return function(args) {
            return (0, $55e183fc3f78a8fe$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                return (0, $55e183fc3f78a8fe$export$67ebef60e6f28a6)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var $9e75aa053b37740b$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high"
};
var $9e75aa053b37740b$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($9e75aa053b37740b$export$a3922aa5f87bae85(options), $9e75aa053b37740b$export$44d3d03587957ce9);
        }
    };
};




/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var $1c7cbf8c0532dd5d$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $1c7cbf8c0532dd5d$export$89cd1b0ccfcb99d = [
    "Throttling",
    "ThrottlingException",
    "ThrottledException",
    "RequestThrottledException",
    "TooManyRequestsException",
    "ProvisionedThroughputExceededException",
    "TransactionInProgressException",
    "RequestLimitExceeded",
    "BandwidthLimitExceeded",
    "LimitExceededException",
    "RequestThrottled",
    "SlowDown",
    "PriorRequestNotComplete",
    "EC2ThrottledException"
];
var $1c7cbf8c0532dd5d$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $1c7cbf8c0532dd5d$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];


var $5f6b59af8fc1cbdd$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $5f6b59af8fc1cbdd$export$7b87435661177a94 = function(error) {
    return (0, $1c7cbf8c0532dd5d$export$9fde012b8b2a10ca).includes(error.name);
};
var $5f6b59af8fc1cbdd$export$cbecb89f6256ccc8 = function(error) {
    var _a;
    return (0, $1c7cbf8c0532dd5d$export$89cd1b0ccfcb99d).includes(error.name) || ((_a = error.$retryable) === null || _a === void 0 ? void 0 : _a.throttling) == true;
};
var $5f6b59af8fc1cbdd$export$31778435da988512 = function(error) {
    var _a;
    return (0, $1c7cbf8c0532dd5d$export$18bd3bfe89ded398).includes(error.name) || (0, $1c7cbf8c0532dd5d$export$38bf589d26009e4f).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};


var $4fe67744bc7750d5$exports = {};
var $f1e0d6f5993c48e8$exports = {};
var $e1774e4c29fcef9f$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $e1774e4c29fcef9f$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($e1774e4c29fcef9f$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $e1774e4c29fcef9f$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $e1774e4c29fcef9f$exports = function whatwgRNG() {
        $e1774e4c29fcef9f$var$getRandomValues($e1774e4c29fcef9f$var$rnds8);
        return $e1774e4c29fcef9f$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $e1774e4c29fcef9f$var$rnds = new Array(16);
    $e1774e4c29fcef9f$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $e1774e4c29fcef9f$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $e1774e4c29fcef9f$var$rnds;
    };
}


var $5a7ecc9f8fdc5fd1$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5a7ecc9f8fdc5fd1$var$byteToHex = [];
for(var $5a7ecc9f8fdc5fd1$var$i = 0; $5a7ecc9f8fdc5fd1$var$i < 256; ++$5a7ecc9f8fdc5fd1$var$i)$5a7ecc9f8fdc5fd1$var$byteToHex[$5a7ecc9f8fdc5fd1$var$i] = ($5a7ecc9f8fdc5fd1$var$i + 0x100).toString(16).substr(1);
function $5a7ecc9f8fdc5fd1$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $5a7ecc9f8fdc5fd1$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$5a7ecc9f8fdc5fd1$exports = $5a7ecc9f8fdc5fd1$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $f1e0d6f5993c48e8$var$_nodeId;
var $f1e0d6f5993c48e8$var$_clockseq;
// Previous uuid creation time
var $f1e0d6f5993c48e8$var$_lastMSecs = 0;
var $f1e0d6f5993c48e8$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $f1e0d6f5993c48e8$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $f1e0d6f5993c48e8$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $f1e0d6f5993c48e8$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $e1774e4c29fcef9f$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $f1e0d6f5993c48e8$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $f1e0d6f5993c48e8$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $f1e0d6f5993c48e8$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $f1e0d6f5993c48e8$var$_lastMSecs + (nsecs - $f1e0d6f5993c48e8$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $f1e0d6f5993c48e8$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $f1e0d6f5993c48e8$var$_lastMSecs = msecs;
    $f1e0d6f5993c48e8$var$_lastNSecs = nsecs;
    $f1e0d6f5993c48e8$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5a7ecc9f8fdc5fd1$exports(b);
}
$f1e0d6f5993c48e8$exports = $f1e0d6f5993c48e8$var$v1;


var $ab6bc6ae068d2a05$exports = {};


function $ab6bc6ae068d2a05$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $e1774e4c29fcef9f$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5a7ecc9f8fdc5fd1$exports(rnds);
}
$ab6bc6ae068d2a05$exports = $ab6bc6ae068d2a05$var$v4;


var $4fe67744bc7750d5$var$uuid = $ab6bc6ae068d2a05$exports;
$4fe67744bc7750d5$var$uuid.v1 = $f1e0d6f5993c48e8$exports;
$4fe67744bc7750d5$var$uuid.v4 = $ab6bc6ae068d2a05$exports;
$4fe67744bc7750d5$exports = $4fe67744bc7750d5$var$uuid;


/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var $d9e54df63153b6d5$export$7067ba90effbd789 = 100;
var $d9e54df63153b6d5$export$2412c80d04e902c6 = 20000;
var $d9e54df63153b6d5$export$4af31f8250b48e23 = 500;
var $d9e54df63153b6d5$export$f8c3d11675a1153 = 500;
var $d9e54df63153b6d5$export$797febae1136bc84 = 5;
var $d9e54df63153b6d5$export$b643545eaf9af837 = 10;
var $d9e54df63153b6d5$export$a25da3406dc148e4 = 1;



var $497f4f7e0253c2f1$export$2ebe7988802fc284 = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, $d9e54df63153b6d5$export$b643545eaf9af837) : (0, $d9e54df63153b6d5$export$797febae1136bc84);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, $d9e54df63153b6d5$export$a25da3406dc148e4);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



var $eeb31997cd8b17a3$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $d9e54df63153b6d5$export$2412c80d04e902c6), Math.random() * Math.pow(2, attempts) * delayBase));
};



var $95c091ae3b571932$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $5f6b59af8fc1cbdd$export$46428803f4bd8a0c)(error) || (0, $5f6b59af8fc1cbdd$export$7b87435661177a94)(error) || (0, $5f6b59af8fc1cbdd$export$cbecb89f6256ccc8)(error) || (0, $5f6b59af8fc1cbdd$export$31778435da988512)(error);
};


var $4389388ca4b0184c$export$2c7e51f38ba5a406 = 3;
var $4389388ca4b0184c$export$41315747b7c5d042 = "standard";
var $4389388ca4b0184c$export$64af437cce00eae8 = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $95c091ae3b571932$export$3839fd261f89ec2);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $eeb31997cd8b17a3$export$1cddd42598a3b1f6);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $497f4f7e0253c2f1$export$2ebe7988802fc284)((0, $d9e54df63153b6d5$export$f8c3d11675a1153));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $55e183fc3f78a8fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $55e183fc3f78a8fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = $4389388ca4b0184c$export$2c7e51f38ba5a406;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, $55e183fc3f78a8fe$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $55e183fc3f78a8fe$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) request.headers["amz-sdk-invocation-id"] = (0, $4fe67744bc7750d5$exports.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, $55e183fc3f78a8fe$export$67ebef60e6f28a6)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) request.headers["amz-sdk-request"] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, $5f6b59af8fc1cbdd$export$cbecb89f6256ccc8)(err_1) ? (0, $d9e54df63153b6d5$export$4af31f8250b48e23) : (0, $d9e54df63153b6d5$export$7067ba90effbd789), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();




var $c604e29ac2d64e7a$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $c604e29ac2d64e7a$export$9ae8a04532f798bc = "max_attempts";
var $c604e29ac2d64e7a$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$c604e29ac2d64e7a$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $c604e29ac2d64e7a$export$a19952f9e421517c + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$c604e29ac2d64e7a$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $c604e29ac2d64e7a$export$9ae8a04532f798bc + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, $4389388ca4b0184c$export$2c7e51f38ba5a406)
};
var $c604e29ac2d64e7a$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $c604e29ac2d64e7a$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $55e183fc3f78a8fe$export$18ce0697a983be9b)((0, $55e183fc3f78a8fe$export$18ce0697a983be9b)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, $4389388ca4b0184c$export$64af437cce00eae8)(maxAttempts)
    });
};
var $c604e29ac2d64e7a$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $4389388ca4b0184c$export$2c7e51f38ba5a406);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $c604e29ac2d64e7a$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $c604e29ac2d64e7a$export$c5c0171a17765aea = "retry_mode";
var $c604e29ac2d64e7a$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$c604e29ac2d64e7a$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$c604e29ac2d64e7a$export$c5c0171a17765aea];
    },
    default: (0, $4389388ca4b0184c$export$41315747b7c5d042)
};






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $abd53005f0a8fbf3$var$extendStatics = function(d, b) {
    $abd53005f0a8fbf3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $abd53005f0a8fbf3$var$extendStatics(d, b);
};
function $abd53005f0a8fbf3$export$a8ba968b8961cb8a(d, b) {
    $abd53005f0a8fbf3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $abd53005f0a8fbf3$export$18ce0697a983be9b = function() {
    $abd53005f0a8fbf3$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $abd53005f0a8fbf3$export$18ce0697a983be9b.apply(this, arguments);
};
function $abd53005f0a8fbf3$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $abd53005f0a8fbf3$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $abd53005f0a8fbf3$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $abd53005f0a8fbf3$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $abd53005f0a8fbf3$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $abd53005f0a8fbf3$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $abd53005f0a8fbf3$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $abd53005f0a8fbf3$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $abd53005f0a8fbf3$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $abd53005f0a8fbf3$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $abd53005f0a8fbf3$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($abd53005f0a8fbf3$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $abd53005f0a8fbf3$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $abd53005f0a8fbf3$export$10c90e4f7922046c(v) {
    return this instanceof $abd53005f0a8fbf3$export$10c90e4f7922046c ? (this.v = v, this) : new $abd53005f0a8fbf3$export$10c90e4f7922046c(v);
}
function $abd53005f0a8fbf3$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $abd53005f0a8fbf3$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $abd53005f0a8fbf3$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $abd53005f0a8fbf3$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $abd53005f0a8fbf3$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $abd53005f0a8fbf3$export$19a8beecd37a4c45 === "function" ? $abd53005f0a8fbf3$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $abd53005f0a8fbf3$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $abd53005f0a8fbf3$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $abd53005f0a8fbf3$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $abd53005f0a8fbf3$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $abd53005f0a8fbf3$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $97aff0a7f8e2d400$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $abd53005f0a8fbf3$export$19a8beecd37a4c45)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $abd53005f0a8fbf3$export$8d051b38c9118094)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}


var $72615e0d08f796d3$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $97aff0a7f8e2d400$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};



function $0c5496a008122b7f$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}


function $69602509ea521450$export$69d579f32876892f(packageName, packageVersion) {
    var originUserAgent = typeof navigator !== "undefined" && typeof navigator.userAgent === "string" ? navigator.userAgent : "";
    return "aws-sdk-js-v3-" + packageName + "/" + packageVersion + " " + originUserAgent;
}



var $QxOwh = parcelRequire("QxOwh");
// Partition default templates
var $e8c893f41c4bb257$var$AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var $e8c893f41c4bb257$var$AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var $e8c893f41c4bb257$var$AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var $e8c893f41c4bb257$var$AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var $e8c893f41c4bb257$var$AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var $e8c893f41c4bb257$var$AWS_REGIONS = new Set([
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $e8c893f41c4bb257$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $e8c893f41c4bb257$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $e8c893f41c4bb257$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $e8c893f41c4bb257$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $e8c893f41c4bb257$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($e8c893f41c4bb257$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($e8c893f41c4bb257$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($e8c893f41c4bb257$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($e8c893f41c4bb257$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($e8c893f41c4bb257$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $e8c893f41c4bb257$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve(regionInfo);
};


var $91d0fbc2edd4bab1$export$608864383388f904 = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $e8c893f41c4bb257$export$2e4318bf13462aa2),
    signingName: "cognito-identity"
};


var $f90c1caedb9c9887$export$b1f2d721b555a243 = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $91d0fbc2edd4bab1$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $33a6b0c1aa82f56b$export$c537b38001c583b7),
    base64Encoder: (0, $33a6b0c1aa82f56b$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $0c5496a008122b7f$export$967f3527bf233bc0),
    credentialDefaultProvider: function() {},
    defaultUserAgent: (0, $69602509ea521450$export$69d579f32876892f)((0, (/*@__PURE__*/$parcel$interopDefault($30316d0885e7093a$exports))).name, (0, (/*@__PURE__*/$parcel$interopDefault($30316d0885e7093a$exports))).version),
    maxAttempts: (0, $4389388ca4b0184c$export$2c7e51f38ba5a406),
    region: (0, $76e89413b78ae54a$export$8b6362171c4dfa64)("Region is missing"),
    requestHandler: new (0, $34bde8d3da0ca366$export$83588b87edbfa7e0)(),
    sha256: (0, $ff311350cc9f0502$exports.Sha256),
    streamCollector: (0, $fe8309fe516a0324$export$17bf97b72e307d52),
    urlParser: (0, $72615e0d08f796d3$export$7a5253c0f62e0150),
    utf8Decoder: (0, $QxOwh.fromUtf8),
    utf8Encoder: (0, $QxOwh.toUtf8)
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $499b5ffb12c7abf1$var$extendStatics = function(d, b) {
    $499b5ffb12c7abf1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $499b5ffb12c7abf1$var$extendStatics(d, b);
};
function $499b5ffb12c7abf1$export$a8ba968b8961cb8a(d, b) {
    $499b5ffb12c7abf1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $499b5ffb12c7abf1$export$18ce0697a983be9b = function() {
    $499b5ffb12c7abf1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $499b5ffb12c7abf1$export$18ce0697a983be9b.apply(this, arguments);
};
function $499b5ffb12c7abf1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $499b5ffb12c7abf1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $499b5ffb12c7abf1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $499b5ffb12c7abf1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $499b5ffb12c7abf1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $499b5ffb12c7abf1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $499b5ffb12c7abf1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $499b5ffb12c7abf1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $499b5ffb12c7abf1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $499b5ffb12c7abf1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $499b5ffb12c7abf1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($499b5ffb12c7abf1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $499b5ffb12c7abf1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $499b5ffb12c7abf1$export$10c90e4f7922046c(v) {
    return this instanceof $499b5ffb12c7abf1$export$10c90e4f7922046c ? (this.v = v, this) : new $499b5ffb12c7abf1$export$10c90e4f7922046c(v);
}
function $499b5ffb12c7abf1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $499b5ffb12c7abf1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $499b5ffb12c7abf1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $499b5ffb12c7abf1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $499b5ffb12c7abf1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $499b5ffb12c7abf1$export$19a8beecd37a4c45 === "function" ? $499b5ffb12c7abf1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $499b5ffb12c7abf1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $499b5ffb12c7abf1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $499b5ffb12c7abf1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $499b5ffb12c7abf1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $499b5ffb12c7abf1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $cbbb9d6cf6d91cb9$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $499b5ffb12c7abf1$export$18ce0697a983be9b)((0, $499b5ffb12c7abf1$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? $cbbb9d6cf6d91cb9$var$normalizeEndpoint(input) : function() {
            return $cbbb9d6cf6d91cb9$var$getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var $cbbb9d6cf6d91cb9$var$normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var $cbbb9d6cf6d91cb9$var$getEndPointFromRegion = function(input) {
    return (0, $499b5ffb12c7abf1$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $499b5ffb12c7abf1$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};



var $3c8ee15af3f289ba$export$26513716e2900bad = "AWS_REGION";
var $3c8ee15af3f289ba$export$8afb1c306a7d01b = "region";
var $3c8ee15af3f289ba$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$3c8ee15af3f289ba$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$3c8ee15af3f289ba$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $3c8ee15af3f289ba$export$9a37503ca194454d = {
    preferredFile: "credentials"
};
var $3c8ee15af3f289ba$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $499b5ffb12c7abf1$export$18ce0697a983be9b)((0, $499b5ffb12c7abf1$export$18ce0697a983be9b)({}, input), {
        region: $3c8ee15af3f289ba$var$normalizeRegion(input.region)
    });
};
var $3c8ee15af3f289ba$var$normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b3f7c219a24eb20a$var$extendStatics = function(d, b) {
    $b3f7c219a24eb20a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b3f7c219a24eb20a$var$extendStatics(d, b);
};
function $b3f7c219a24eb20a$export$a8ba968b8961cb8a(d, b) {
    $b3f7c219a24eb20a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b3f7c219a24eb20a$export$18ce0697a983be9b = function() {
    $b3f7c219a24eb20a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b3f7c219a24eb20a$export$18ce0697a983be9b.apply(this, arguments);
};
function $b3f7c219a24eb20a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b3f7c219a24eb20a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b3f7c219a24eb20a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b3f7c219a24eb20a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b3f7c219a24eb20a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b3f7c219a24eb20a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b3f7c219a24eb20a$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b3f7c219a24eb20a$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b3f7c219a24eb20a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b3f7c219a24eb20a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b3f7c219a24eb20a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b3f7c219a24eb20a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b3f7c219a24eb20a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b3f7c219a24eb20a$export$10c90e4f7922046c(v) {
    return this instanceof $b3f7c219a24eb20a$export$10c90e4f7922046c ? (this.v = v, this) : new $b3f7c219a24eb20a$export$10c90e4f7922046c(v);
}
function $b3f7c219a24eb20a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b3f7c219a24eb20a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b3f7c219a24eb20a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b3f7c219a24eb20a$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b3f7c219a24eb20a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b3f7c219a24eb20a$export$19a8beecd37a4c45 === "function" ? $b3f7c219a24eb20a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b3f7c219a24eb20a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b3f7c219a24eb20a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b3f7c219a24eb20a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b3f7c219a24eb20a$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b3f7c219a24eb20a$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $8cd3c273011346a7$var$CONTENT_LENGTH_HEADER = "content-length";
function $8cd3c273011346a7$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $b3f7c219a24eb20a$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $b3f7c219a24eb20a$export$67ebef60e6f28a6)(this, function(_b) {
                    request = args.request;
                    if ((0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($8cd3c273011346a7$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $b3f7c219a24eb20a$export$18ce0697a983be9b)((0, $b3f7c219a24eb20a$export$18ce0697a983be9b)({}, request.headers), (_a = {}, _a[$8cd3c273011346a7$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $b3f7c219a24eb20a$export$18ce0697a983be9b)((0, $b3f7c219a24eb20a$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $8cd3c273011346a7$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware"
};
var $8cd3c273011346a7$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($8cd3c273011346a7$export$940b29eb2788b975(options.bodyLengthChecker), $8cd3c273011346a7$export$1f7816f8f350b2f5);
        }
    };
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $16e2fb469e22b01e$var$extendStatics = function(d, b) {
    $16e2fb469e22b01e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $16e2fb469e22b01e$var$extendStatics(d, b);
};
function $16e2fb469e22b01e$export$a8ba968b8961cb8a(d, b) {
    $16e2fb469e22b01e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $16e2fb469e22b01e$export$18ce0697a983be9b = function() {
    $16e2fb469e22b01e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16e2fb469e22b01e$export$18ce0697a983be9b.apply(this, arguments);
};
function $16e2fb469e22b01e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $16e2fb469e22b01e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $16e2fb469e22b01e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $16e2fb469e22b01e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $16e2fb469e22b01e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $16e2fb469e22b01e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $16e2fb469e22b01e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $16e2fb469e22b01e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $16e2fb469e22b01e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $16e2fb469e22b01e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $16e2fb469e22b01e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($16e2fb469e22b01e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $16e2fb469e22b01e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $16e2fb469e22b01e$export$10c90e4f7922046c(v) {
    return this instanceof $16e2fb469e22b01e$export$10c90e4f7922046c ? (this.v = v, this) : new $16e2fb469e22b01e$export$10c90e4f7922046c(v);
}
function $16e2fb469e22b01e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $16e2fb469e22b01e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $16e2fb469e22b01e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $16e2fb469e22b01e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $16e2fb469e22b01e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $16e2fb469e22b01e$export$19a8beecd37a4c45 === "function" ? $16e2fb469e22b01e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $16e2fb469e22b01e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $16e2fb469e22b01e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $16e2fb469e22b01e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $16e2fb469e22b01e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $16e2fb469e22b01e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $34b32b3749f83262$export$c1625bf0b32b4481(input) {
    return input;
}
var $34b32b3749f83262$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $16e2fb469e22b01e$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $16e2fb469e22b01e$export$67ebef60e6f28a6)(this, function(_b) {
                    if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $34b32b3749f83262$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ]
};
var $34b32b3749f83262$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($34b32b3749f83262$export$858685d7aeef192d(options), $34b32b3749f83262$export$696d244ba96181e8);
        }
    };
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4bacd5efdd48542f$var$extendStatics = function(d, b) {
    $4bacd5efdd48542f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4bacd5efdd48542f$var$extendStatics(d, b);
};
function $4bacd5efdd48542f$export$a8ba968b8961cb8a(d, b) {
    $4bacd5efdd48542f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4bacd5efdd48542f$export$18ce0697a983be9b = function() {
    $4bacd5efdd48542f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4bacd5efdd48542f$export$18ce0697a983be9b.apply(this, arguments);
};
function $4bacd5efdd48542f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4bacd5efdd48542f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4bacd5efdd48542f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4bacd5efdd48542f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4bacd5efdd48542f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4bacd5efdd48542f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $4bacd5efdd48542f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $4bacd5efdd48542f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $4bacd5efdd48542f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4bacd5efdd48542f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4bacd5efdd48542f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4bacd5efdd48542f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4bacd5efdd48542f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4bacd5efdd48542f$export$10c90e4f7922046c(v) {
    return this instanceof $4bacd5efdd48542f$export$10c90e4f7922046c ? (this.v = v, this) : new $4bacd5efdd48542f$export$10c90e4f7922046c(v);
}
function $4bacd5efdd48542f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4bacd5efdd48542f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4bacd5efdd48542f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4bacd5efdd48542f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4bacd5efdd48542f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4bacd5efdd48542f$export$19a8beecd37a4c45 === "function" ? $4bacd5efdd48542f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4bacd5efdd48542f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $4bacd5efdd48542f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $4bacd5efdd48542f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4bacd5efdd48542f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $4bacd5efdd48542f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $8e0fede809fe3b2b$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $4bacd5efdd48542f$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var logger, response, httpResponse;
                var _a;
                return (0, $4bacd5efdd48542f$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            logger = context.logger;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            httpResponse = response.response;
                            if (typeof logger.info === "function") logger.info({
                                metadata: {
                                    statusCode: httpResponse.statusCode,
                                    requestId: (_a = httpResponse.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : httpResponse.headers["x-amzn-request-id"],
                                    extendedRequestId: httpResponse.headers["x-amz-id-2"],
                                    cfId: httpResponse.headers["x-amz-cf-id"]
                                }
                            });
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $8e0fede809fe3b2b$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize"
};
var $8e0fede809fe3b2b$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($8e0fede809fe3b2b$export$fe0e777ee4f58cde(), $8e0fede809fe3b2b$export$877c148ab4ad0722);
        }
    };
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3ddef09dab2d97c6$var$extendStatics = function(d, b) {
    $3ddef09dab2d97c6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3ddef09dab2d97c6$var$extendStatics(d, b);
};
function $3ddef09dab2d97c6$export$a8ba968b8961cb8a(d, b) {
    $3ddef09dab2d97c6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3ddef09dab2d97c6$export$18ce0697a983be9b = function() {
    $3ddef09dab2d97c6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ddef09dab2d97c6$export$18ce0697a983be9b.apply(this, arguments);
};
function $3ddef09dab2d97c6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3ddef09dab2d97c6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3ddef09dab2d97c6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3ddef09dab2d97c6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3ddef09dab2d97c6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3ddef09dab2d97c6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3ddef09dab2d97c6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3ddef09dab2d97c6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3ddef09dab2d97c6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3ddef09dab2d97c6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3ddef09dab2d97c6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3ddef09dab2d97c6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3ddef09dab2d97c6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3ddef09dab2d97c6$export$10c90e4f7922046c(v) {
    return this instanceof $3ddef09dab2d97c6$export$10c90e4f7922046c ? (this.v = v, this) : new $3ddef09dab2d97c6$export$10c90e4f7922046c(v);
}
function $3ddef09dab2d97c6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3ddef09dab2d97c6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3ddef09dab2d97c6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3ddef09dab2d97c6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3ddef09dab2d97c6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3ddef09dab2d97c6$export$19a8beecd37a4c45 === "function" ? $3ddef09dab2d97c6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3ddef09dab2d97c6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3ddef09dab2d97c6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3ddef09dab2d97c6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3ddef09dab2d97c6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3ddef09dab2d97c6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7593851311689ec4$var$extendStatics = function(d, b) {
    $7593851311689ec4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7593851311689ec4$var$extendStatics(d, b);
};
function $7593851311689ec4$export$a8ba968b8961cb8a(d, b) {
    $7593851311689ec4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7593851311689ec4$export$18ce0697a983be9b = function() {
    $7593851311689ec4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7593851311689ec4$export$18ce0697a983be9b.apply(this, arguments);
};
function $7593851311689ec4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7593851311689ec4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7593851311689ec4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7593851311689ec4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7593851311689ec4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7593851311689ec4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7593851311689ec4$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7593851311689ec4$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7593851311689ec4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7593851311689ec4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7593851311689ec4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7593851311689ec4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7593851311689ec4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7593851311689ec4$export$10c90e4f7922046c(v) {
    return this instanceof $7593851311689ec4$export$10c90e4f7922046c ? (this.v = v, this) : new $7593851311689ec4$export$10c90e4f7922046c(v);
}
function $7593851311689ec4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7593851311689ec4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7593851311689ec4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7593851311689ec4$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7593851311689ec4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7593851311689ec4$export$19a8beecd37a4c45 === "function" ? $7593851311689ec4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7593851311689ec4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7593851311689ec4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7593851311689ec4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7593851311689ec4$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7593851311689ec4$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $6516c526ec594e84$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $6516c526ec594e84$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $6516c526ec594e84$export$6e114beec37430d7 = "X-Amz-Date";
var $6516c526ec594e84$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $6516c526ec594e84$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $6516c526ec594e84$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $6516c526ec594e84$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $6516c526ec594e84$export$9924a64a4b8b0d58 = "authorization";
var $6516c526ec594e84$export$acf4b8bdf24aab34 = $6516c526ec594e84$export$6e114beec37430d7.toLowerCase();
var $6516c526ec594e84$export$c65c8c9f514da472 = "date";
var $6516c526ec594e84$export$20d6a73fd0b10982 = [
    $6516c526ec594e84$export$9924a64a4b8b0d58,
    $6516c526ec594e84$export$acf4b8bdf24aab34,
    $6516c526ec594e84$export$c65c8c9f514da472
];
var $6516c526ec594e84$export$29961f34c719157e = $6516c526ec594e84$export$41ae838dc1e0f082.toLowerCase();
var $6516c526ec594e84$export$eaef12179141669a = "x-amz-content-sha256";
var $6516c526ec594e84$export$fdc81b663012a8d2 = $6516c526ec594e84$export$8e1383b7eea7bee.toLowerCase();
var $6516c526ec594e84$export$96307741595055fc = "host";
var $6516c526ec594e84$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $6516c526ec594e84$export$8085db98abbe0597 = /^proxy-/;
var $6516c526ec594e84$export$758380400526c39 = /^sec-/;
var $6516c526ec594e84$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $6516c526ec594e84$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $6516c526ec594e84$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $6516c526ec594e84$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $6516c526ec594e84$export$bf665777b4a1722f = 50;
var $6516c526ec594e84$export$c4bf0942098f6bb = "aws4_request";
var $6516c526ec594e84$export$274df788bdcca184 = 604800;


var $f624d790c0639947$var$signingKeyCache = {};
var $f624d790c0639947$var$cacheQueue = [];
function $f624d790c0639947$export$41a9651decfe2bde(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $6516c526ec594e84$export$c4bf0942098f6bb);
}
function $f624d790c0639947$export$8b95a069d16dd783(sha256Constructor, credentials, shortDate, region, service) {
    var cacheKey = shortDate + ":" + region + ":" + service + ":" + (credentials.accessKeyId + ":" + credentials.sessionToken);
    if (cacheKey in $f624d790c0639947$var$signingKeyCache) return $f624d790c0639947$var$signingKeyCache[cacheKey];
    $f624d790c0639947$var$cacheQueue.push(cacheKey);
    while($f624d790c0639947$var$cacheQueue.length > (0, $6516c526ec594e84$export$bf665777b4a1722f))delete $f624d790c0639947$var$signingKeyCache[$f624d790c0639947$var$cacheQueue.shift()];
    return $f624d790c0639947$var$signingKeyCache[cacheKey] = new Promise(function(resolve, reject) {
        var e_1, _a;
        var keyPromise = Promise.resolve("AWS4" + credentials.secretAccessKey);
        var _loop_1 = function(signable) {
            keyPromise = keyPromise.then(function(intermediateKey) {
                return $f624d790c0639947$var$hmac(sha256Constructor, intermediateKey, signable);
            });
            keyPromise.catch(function() {});
        };
        try {
            for(var _b = (0, $7593851311689ec4$export$19a8beecd37a4c45)([
                shortDate,
                region,
                service,
                (0, $6516c526ec594e84$export$c4bf0942098f6bb)
            ]), _c = _b.next(); !_c.done; _c = _b.next()){
                var signable = _c.value;
                _loop_1(signable);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        keyPromise.then(resolve, function(reason) {
            delete $f624d790c0639947$var$signingKeyCache[cacheKey];
            reject(reason);
        });
    });
}
function $f624d790c0639947$export$a31b95746ea0a30a() {
    $f624d790c0639947$var$cacheQueue.length = 0;
    Object.keys($f624d790c0639947$var$signingKeyCache).forEach(function(cacheKey) {
        delete $f624d790c0639947$var$signingKeyCache[cacheKey];
    });
}
function $f624d790c0639947$var$hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}








function $0b933dfd2cdaac39$export$859d7f1bb55e2914(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $6516c526ec594e84$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $6516c526ec594e84$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $6516c526ec594e84$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}





function $495269128b0a13e0$export$8fea7e63ecd1ddbb(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $6516c526ec594e84$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $157312cd117a37c4$export$c3b4775ad75a73db)(key) + "=" + (0, $157312cd117a37c4$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $157312cd117a37c4$export$c3b4775ad75a73db)(key) + "=" + (0, $157312cd117a37c4$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}



var $518dbdf05e8bf6ef$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};




function $6b9584cab98078dc$export$a46a74202b0efd71(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $6516c526ec594e84$export$eaef12179141669a)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $518dbdf05e8bf6ef$export$9dd3754ae86f0017)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, $6516c526ec594e84$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
}



function $c0d25a43c2d63212$export$17944590be865217(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}




function $55151d6901b42960$export$d043aa0bf7223286(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $7593851311689ec4$export$3c9a16f847548506)(_a, [
        "headers",
        "query"
    ]);
    return (0, $7593851311689ec4$export$18ce0697a983be9b)((0, $7593851311689ec4$export$18ce0697a983be9b)({}, rest), {
        headers: (0, $7593851311689ec4$export$18ce0697a983be9b)({}, headers),
        query: query ? $55151d6901b42960$var$cloneQuery(query) : undefined
    });
}
function $55151d6901b42960$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $7593851311689ec4$export$18ce0697a983be9b)((0, $7593851311689ec4$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $7593851311689ec4$export$afc72e2116322959)(param) : param, _a));
    }, {});
}


function $4bc2c719cca41b3e$export$bfc08a76d4bd60f6(request) {
    var e_1, _a;
    var _b = typeof request.clone === "function" ? request.clone() : (0, $55151d6901b42960$export$d043aa0bf7223286)(request), headers = _b.headers, _c = _b.query, query = _c === void 0 ? {} : _c;
    try {
        for(var _d = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(headers)), _e = _d.next(); !_e.done; _e = _d.next()){
            var name = _e.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-") {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $7593851311689ec4$export$18ce0697a983be9b)((0, $7593851311689ec4$export$18ce0697a983be9b)({}, request), {
        headers: headers,
        query: query
    });
}





function $fa214049c445dc8c$export$a7cfe9131aa06be4(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, $55151d6901b42960$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $7593851311689ec4$export$19a8beecd37a4c45)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $6516c526ec594e84$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}


function $c9f5889deb408cc2$export$b65d57190c224ef2(time) {
    return $c9f5889deb408cc2$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $c9f5889deb408cc2$export$e67a095c620b86fe(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}


var $605ca3d5f91c606d$export$20baf4d3f65eb30c = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = $605ca3d5f91c606d$var$normalizeRegionProvider(region);
        this.credentialProvider = $605ca3d5f91c606d$var$normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $605ca3d5f91c606d$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $6516c526ec594e84$export$274df788bdcca184)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $f624d790c0639947$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $4bc2c719cca41b3e$export$bfc08a76d4bd60f6)((0, $fa214049c445dc8c$export$a7cfe9131aa06be4)(originalRequest));
                        if (credentials.sessionToken) request.query[0, $6516c526ec594e84$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $6516c526ec594e84$export$186cd8495ba0377d] = (0, $6516c526ec594e84$export$863a63fba5b2ddf5);
                        request.query[0, $6516c526ec594e84$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $6516c526ec594e84$export$6e114beec37430d7] = longDate;
                        request.query[0, $6516c526ec594e84$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $0b933dfd2cdaac39$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $6516c526ec594e84$export$2dcbb254f883c238] = $605ca3d5f91c606d$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $6516c526ec594e84$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $6b9584cab98078dc$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $605ca3d5f91c606d$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $f624d790c0639947$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, $6b9584cab98078dc$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $6516c526ec594e84$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $605ca3d5f91c606d$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $fa214049c445dc8c$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $605ca3d5f91c606d$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $f624d790c0639947$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $6516c526ec594e84$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $6516c526ec594e84$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, $6b9584cab98078dc$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $c0d25a43c2d63212$export$17944590be865217)((0, $6516c526ec594e84$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $6516c526ec594e84$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $0b933dfd2cdaac39$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $6516c526ec594e84$export$9924a64a4b8b0d58] = (0, $6516c526ec594e84$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $605ca3d5f91c606d$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $495269128b0a13e0$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $6516c526ec594e84$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $7593851311689ec4$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $7593851311689ec4$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $f624d790c0639947$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $605ca3d5f91c606d$var$formatDate = function(now) {
    var longDate = (0, $c9f5889deb408cc2$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $605ca3d5f91c606d$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var $605ca3d5f91c606d$var$normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $605ca3d5f91c606d$var$normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};




function $bb13a56e54d41cd2$export$1dd62920de1feabb(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = $bb13a56e54d41cd2$var$normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = $bb13a56e54d41cd2$var$normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return $bb13a56e54d41cd2$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $3ddef09dab2d97c6$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                return (0, $3ddef09dab2d97c6$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $3ddef09dab2d97c6$export$8d051b38c9118094)(_a, 2), regionInfo = _b[0], region = _b[1];
            var _c = regionInfo.signingRegion, signingRegion = _c === void 0 ? input.signingRegion : _c, _d = regionInfo.signingService, signingService = _d === void 0 ? input.signingName : _d;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService;
            return new (0, $605ca3d5f91c606d$export$20baf4d3f65eb30c)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, $3ddef09dab2d97c6$export$18ce0697a983be9b)((0, $3ddef09dab2d97c6$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function $bb13a56e54d41cd2$var$normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}




var $43c8c3a6e4eb9d7a$var$isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs($43c8c3a6e4eb9d7a$var$getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var $43c8c3a6e4eb9d7a$var$getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function $43c8c3a6e4eb9d7a$export$78af9708f8cf3422(options) {
    return function(next, context) {
        return function(args) {
            return (0, $3ddef09dab2d97c6$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, $3ddef09dab2d97c6$export$67ebef60e6f28a6)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, $3ddef09dab2d97c6$export$18ce0697a983be9b)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, $3ddef09dab2d97c6$export$18ce0697a983be9b).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if ($43c8c3a6e4eb9d7a$var$isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var $43c8c3a6e4eb9d7a$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware"
};
var $43c8c3a6e4eb9d7a$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($43c8c3a6e4eb9d7a$export$78af9708f8cf3422(options), $43c8c3a6e4eb9d7a$export$29f4b3a6e94017d3);
        }
    };
};




function $6a8df0c97e1a5e12$export$ec9a2d5663958cb(input) {
    return input;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1730e5578fdf4827$var$extendStatics = function(d, b) {
    $1730e5578fdf4827$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1730e5578fdf4827$var$extendStatics(d, b);
};
function $1730e5578fdf4827$export$a8ba968b8961cb8a(d, b) {
    $1730e5578fdf4827$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1730e5578fdf4827$export$18ce0697a983be9b = function() {
    $1730e5578fdf4827$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1730e5578fdf4827$export$18ce0697a983be9b.apply(this, arguments);
};
function $1730e5578fdf4827$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1730e5578fdf4827$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1730e5578fdf4827$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1730e5578fdf4827$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1730e5578fdf4827$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1730e5578fdf4827$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1730e5578fdf4827$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1730e5578fdf4827$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1730e5578fdf4827$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1730e5578fdf4827$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1730e5578fdf4827$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1730e5578fdf4827$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1730e5578fdf4827$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1730e5578fdf4827$export$10c90e4f7922046c(v) {
    return this instanceof $1730e5578fdf4827$export$10c90e4f7922046c ? (this.v = v, this) : new $1730e5578fdf4827$export$10c90e4f7922046c(v);
}
function $1730e5578fdf4827$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1730e5578fdf4827$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1730e5578fdf4827$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1730e5578fdf4827$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1730e5578fdf4827$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1730e5578fdf4827$export$19a8beecd37a4c45 === "function" ? $1730e5578fdf4827$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1730e5578fdf4827$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1730e5578fdf4827$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1730e5578fdf4827$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1730e5578fdf4827$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1730e5578fdf4827$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $4e2650dcbd5d9734$export$62c460923941c0b0(options) {
    return function(next) {
        return function(args) {
            var request = args.request;
            if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) return next(args);
            var headers = request.headers;
            var userAgentHeader = options.runtime === "node" ? "user-agent" : "x-amz-user-agent";
            if (!headers[userAgentHeader]) headers[userAgentHeader] = "" + options.defaultUserAgent;
            else headers[userAgentHeader] += " " + options.defaultUserAgent;
            if (options.customUserAgent) headers[userAgentHeader] += " " + options.customUserAgent;
            return next((0, $1730e5578fdf4827$export$18ce0697a983be9b)((0, $1730e5578fdf4827$export$18ce0697a983be9b)({}, args), {
                request: request
            }));
        };
    };
}
var $4e2650dcbd5d9734$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ]
};
var $4e2650dcbd5d9734$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($4e2650dcbd5d9734$export$62c460923941c0b0(config), $4e2650dcbd5d9734$export$29eb04da6afef73f);
        }
    };
};





/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */ var $7bf877bed09b4c46$export$e576def690e850f7 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $f90c1caedb9c9887$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $3c8ee15af3f289ba$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $cbbb9d6cf6d91cb9$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $bb13a56e54d41cd2$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $c604e29ac2d64e7a$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $6a8df0c97e1a5e12$export$ec9a2d5663958cb)(_config_4);
        var _config_6 = (0, $34b32b3749f83262$export$c1625bf0b32b4481)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $9e75aa053b37740b$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $4e2650dcbd5d9734$export$5393c0d2d7f4f5f0)(_this.config));
        _this.middlewareStack.use((0, $8cd3c273011346a7$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $34b32b3749f83262$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $8e0fede809fe3b2b$export$f6ef65d7766fc255)(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}((0, $0b86a7f9694de380$export$1f2bb630327ac4b6));


var $5f8c093c17ed2e35$var$__assign = undefined && undefined.__assign || function() {
    $5f8c093c17ed2e35$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f8c093c17ed2e35$var$__assign.apply(this, arguments);
};
var $5f8c093c17ed2e35$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5f8c093c17ed2e35$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5f8c093c17ed2e35$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Credentials');
var $5f8c093c17ed2e35$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $5f8c093c17ed2e35$export$9be509043bd0c09a = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = (0, $c3feafeb259bd3b0$export$75ace714083c1340).refreshGoogleToken;
        this._refreshHandlers['facebook'] = (0, $c3feafeb259bd3b0$export$1b6b8b5328e38349).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $5f8c093c17ed2e35$var$__assign($5f8c093c17ed2e35$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $59e04b8bcc93b29e$export$a2bd19c49e4760e8)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        $5f8c093c17ed2e35$var$logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        $5f8c093c17ed2e35$var$logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $5f8c093c17ed2e35$var$logger.debug('getting new cred promise');
            this._gettingCredPromise = (0, $4635c76aed896f54$export$8f33cb495ca11832)(this._keepAlive());
        } else $5f8c093c17ed2e35$var$logger.debug('getting old cred promise');
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return $5f8c093c17ed2e35$var$__awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return $5f8c093c17ed2e35$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $5f8c093c17ed2e35$var$logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            $5f8c093c17ed2e35$var$logger.debug('credentials not changed and not expired, directly return');
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        $5f8c093c17ed2e35$var$logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? (0, $471a5eebd413fda8$export$a3858a9a153cffc7).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') return [
                            2 /*return*/ ,
                            Promise.reject('No Auth module registered in Amplify')
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        $5f8c093c17ed2e35$var$logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        $5f8c093c17ed2e35$var$logger.debug('Error attempting to refreshing the session', err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        $5f8c093c17ed2e35$var$logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        $5f8c093c17ed2e35$var$logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            $5f8c093c17ed2e35$var$logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
            $5f8c093c17ed2e35$var$logger.debug('getting refreshed jwt token from federation provider');
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            $5f8c093c17ed2e35$var$logger.debug('no refresh handler for provider:', provider);
            this.clear();
            return Promise.reject('no refresh handler for provider');
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, $cf5e2b98e027d007$export$a24aa7705df9cf44)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            $5f8c093c17ed2e35$var$logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === 'string' && e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) _this.clear();
            $5f8c093c17ed2e35$var$logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $5f8c093c17ed2e35$var$logger.debug('no credentials for expiration check');
            return true;
        }
        $5f8c093c17ed2e35$var$logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        return $5f8c093c17ed2e35$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, mandatorySignIn, identityId, e_1, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return $5f8c093c17ed2e35$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $5f8c093c17ed2e35$var$logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject('cannot get guest credentials when mandatory signin enabled')
                        ];
                        if (!identityPoolId) {
                            $5f8c093c17ed2e35$var$logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [
                                2 /*return*/ ,
                                Promise.reject('No Cognito Identity pool provided for unauthenticated access')
                            ];
                        }
                        if (!region) {
                            $5f8c093c17ed2e35$var$logger.debug('region is not configured for getting the credentials');
                            return [
                                2 /*return*/ ,
                                Promise.reject('region is not configured for getting the credentials')
                            ];
                        }
                        identityId = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _b.sent();
                        identityId = this._storage.getItem('CognitoIdentityId-' + identityPoolId);
                        this._identityId = identityId;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        $5f8c093c17ed2e35$var$logger.debug('Failed to get the cached identityId', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        cognitoClient = new (0, $7bf877bed09b4c46$export$e576def690e850f7)({
                            region: region,
                            customUserAgent: (0, $eb2795a39e4549eb$export$ede38edb26c0bfdf)()
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient
                            };
                            credentials = (0, $9e00f51273bd8045$export$4d624d71eb462130)(cognitoIdentityParams)();
                        } else {
                            credentialsProvider = function() {
                                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    cognitoClient.send(new (0, $6fe0805914a4e7b6$export$41ceb4ced4f97a44)({
                                                        IdentityPoolId: identityPoolId
                                                    }))
                                                ];
                                            case 1:
                                                IdentityId = _a.sent().IdentityId;
                                                this._identityId = IdentityId;
                                                cognitoIdentityParams = {
                                                    client: cognitoClient,
                                                    identityId: IdentityId
                                                };
                                                credentialsFromCognitoIdentity = (0, $9e00f51273bd8045$export$4d624d71eb462130)(cognitoIdentityParams);
                                                return [
                                                    2 /*return*/ ,
                                                    credentialsFromCognitoIdentity()
                                                ];
                                        }
                                    });
                                });
                            };
                            credentials = credentialsProvider().catch(function(err) {
                                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                                        throw err;
                                    });
                                });
                            });
                        }
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, 'guest', false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                                    var credentialsProvider;
                                    var _this = this;
                                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                                        // If identity id is deleted in the console, we make one attempt to recreate it
                                        // and remove existing id from cache.
                                        if (e.name === 'ResourceNotFoundException' && e.message === "Identity '" + identityId + "' not found.") {
                                            $5f8c093c17ed2e35$var$logger.debug('Failed to load guest credentials');
                                            this._storage.removeItem('CognitoIdentityId-' + identityPoolId);
                                            credentialsProvider = function() {
                                                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                                                    var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    cognitoClient.send(new (0, $6fe0805914a4e7b6$export$41ceb4ced4f97a44)({
                                                                        IdentityPoolId: identityPoolId
                                                                    }))
                                                                ];
                                                            case 1:
                                                                IdentityId = _a.sent().IdentityId;
                                                                this._identityId = IdentityId;
                                                                cognitoIdentityParams = {
                                                                    client: cognitoClient,
                                                                    identityId: IdentityId
                                                                };
                                                                credentialsFromCognitoIdentity = (0, $9e00f51273bd8045$export$4d624d71eb462130)(cognitoIdentityParams);
                                                                return [
                                                                    2 /*return*/ ,
                                                                    credentialsFromCognitoIdentity()
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            credentials = credentialsProvider().catch(function(err) {
                                                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                                                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                                                        throw err;
                                                    });
                                                });
                                            });
                                            return [
                                                2 /*return*/ ,
                                                this._loadCredentials(credentials, 'guest', false, null)
                                            ];
                                        } else return [
                                            2 /*return*/ ,
                                            e
                                        ];
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com'
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject('You must specify a federated provider');
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $5f8c093c17ed2e35$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $5f8c093c17ed2e35$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoClient = new (0, $7bf877bed09b4c46$export$e576def690e850f7)({
            region: region,
            customUserAgent: (0, $eb2795a39e4549eb$export$ede38edb26c0bfdf)()
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient
            };
            credentials = (0, $9e00f51273bd8045$export$4d624d71eb462130)(cognitoIdentityParams)();
        } else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient
            };
            credentials = (0, $0a698db94ca9721d$export$6c7d622e9507a2e)(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        $5f8c093c17ed2e35$var$logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $5f8c093c17ed2e35$var$logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            $5f8c093c17ed2e35$var$logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = new (0, $7bf877bed09b4c46$export$e576def690e850f7)({
            region: region,
            customUserAgent: (0, $eb2795a39e4549eb$export$ede38edb26c0bfdf)()
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                cognitoClient.send(new (0, $6fe0805914a4e7b6$export$41ceb4ced4f97a44)({
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                }))
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            this._identityId = IdentityId;
                            cognitoIdentityParams = {
                                client: cognitoClient,
                                logins: logins,
                                identityId: IdentityId
                            };
                            credentialsFromCognitoIdentity = (0, $9e00f51273bd8045$export$4d624d71eb462130)(cognitoIdentityParams);
                            return [
                                2 /*return*/ ,
                                credentialsFromCognitoIdentity()
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        var identityPoolId = this._config.identityPoolId;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return $5f8c093c17ed2e35$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id, e_2;
                    return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $5f8c093c17ed2e35$var$logger.debug('Load credentials successfully', credentials);
                                if (this._identityId && !credentials.identityId) credentials['identityId'] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $5f8c093c17ed2e35$var$CREDENTIALS_TTL;
                                if (source === 'federated') {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        $5f8c093c17ed2e35$var$logger.debug('Failed to put federated info into auth storage', e);
                                    }
                                }
                                if (!(source === 'guest')) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._storageSync
                                ];
                            case 2:
                                _a.sent();
                                this._storage.setItem('CognitoIdentityId-' + identityPoolId, credentials.identityId // TODO: IdentityId is currently not returned by fromCognitoIdentityPool()
                                );
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                e_2 = _a.sent();
                                $5f8c093c17ed2e35$var$logger.debug('Failed to cache identityId', e_2);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    $5f8c093c17ed2e35$var$logger.debug('Failed to load credentials', credentials);
                    $5f8c093c17ed2e35$var$logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === 'session') return this._setCredentialsFromSession(params);
        else if (source === 'federation') return this._setCredentialsFromFederation(params);
        else if (source === 'guest') return this._setCredentialsForGuest();
        else {
            $5f8c093c17ed2e35$var$logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function() {
        return $5f8c093c17ed2e35$var$__awaiter(this, void 0, void 0, function() {
            return $5f8c093c17ed2e35$var$__generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                $5f8c093c17ed2e35$var$logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var $5f8c093c17ed2e35$export$a9627919734faa48 = new $5f8c093c17ed2e35$export$9be509043bd0c09a(null);
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).register($5f8c093c17ed2e35$export$a9627919734faa48);
var /**
 * @deprecated use named import
 */ $5f8c093c17ed2e35$export$2e2bcd8739ae039 = $5f8c093c17ed2e35$export$a9627919734faa48;


/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 


/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $a22e1f3e60b67e29$export$efa87b877bb98f58 = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = '/service-worker.js';
        if (scope === void 0) scope = '/';
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $471a5eebd413fda8$export$a3858a9a153cffc7).Analytics && typeof (0, $471a5eebd413fda8$export$a3858a9a153cffc7).Analytics.record === 'function') (0, $471a5eebd413fda8$export$a3858a9a153cffc7).Analytics.record({
                name: 'ServiceWorker',
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener('message', function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var /**
 * @deprecated use named import
 */ $a22e1f3e60b67e29$export$2e2bcd8739ae039 = $a22e1f3e60b67e29$export$efa87b877bb98f58;



/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $e5fdd88492201db2$export$98e6a39c04603d36;
var $e5fdd88492201db2$export$dfdc1655ccc5b9cb;
'use strict';
$e5fdd88492201db2$export$98e6a39c04603d36 = $e5fdd88492201db2$var$parse;
$e5fdd88492201db2$export$dfdc1655ccc5b9cb = $e5fdd88492201db2$var$serialize;
/**
 * Module variables.
 * @private
 */ var $e5fdd88492201db2$var$decode = decodeURIComponent;
var $e5fdd88492201db2$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $e5fdd88492201db2$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $e5fdd88492201db2$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $e5fdd88492201db2$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $e5fdd88492201db2$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $e5fdd88492201db2$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $e5fdd88492201db2$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$e5fdd88492201db2$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$e5fdd88492201db2$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$e5fdd88492201db2$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$e5fdd88492201db2$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $e5fdd88492201db2$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $55f08eb90dce9ccc$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $55f08eb90dce9ccc$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $55f08eb90dce9ccc$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $e5fdd88492201db2$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $55f08eb90dce9ccc$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $55f08eb90dce9ccc$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $55f08eb90dce9ccc$var$cleanupCookieValue(value);
    if ($55f08eb90dce9ccc$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $55f08eb90dce9ccc$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}


var $c0cc949f709d8de4$var$__assign = undefined && undefined.__assign || function() {
    $c0cc949f709d8de4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0cc949f709d8de4$var$__assign.apply(this, arguments);
};
var $c0cc949f709d8de4$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $55f08eb90dce9ccc$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $55f08eb90dce9ccc$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $e5fdd88492201db2$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $55f08eb90dce9ccc$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $55f08eb90dce9ccc$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $c0cc949f709d8de4$var$__assign($c0cc949f709d8de4$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e5fdd88492201db2$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $c0cc949f709d8de4$var$__assign($c0cc949f709d8de4$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $c0cc949f709d8de4$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e5fdd88492201db2$export$dfdc1655ccc5b9cb(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $c0cc949f709d8de4$export$2e2bcd8739ae039 = $c0cc949f709d8de4$var$Cookies;


var $008835bf0efed612$export$2e2bcd8739ae039 = (0, $c0cc949f709d8de4$export$2e2bcd8739ae039);



var $c57aff6187c99733$var$isBrowser = (0, $4635c76aed896f54$export$a2708fdb45cd35f)().isBrowser;
var $c57aff6187c99733$export$ded9c57084144144 = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, $008835bf0efed612$export$2e2bcd8739ae039)();
        this.store = $c57aff6187c99733$var$isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, $008835bf0efed612$export$2e2bcd8739ae039)(context.req.headers.cookie) : new (0, $008835bf0efed612$export$2e2bcd8739ae039)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: '/'
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        switch(tokenType){
            // LastAuthUser is needed for computing other key names
            case 'LastAuthUser':
            // accessToken is required for CognitoUserSession
            case 'accessToken':
            // Required for CognitoUserSession
            case 'idToken':
                this.setUniversalItem(key, value);
        }
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value) {
        this.cookies.set(key, value, {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === 'localhost' ? false : true
        });
    };
    return UniversalStorage;
}();


/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $8717f630fe8f2ea7$var$hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var $8717f630fe8f2ea7$export$36df2663cc7faf97 = $8717f630fe8f2ea7$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER';
var $8717f630fe8f2ea7$export$ea26e09ecef8d08d = $8717f630fe8f2ea7$var$hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var $8717f630fe8f2ea7$export$16032fc466434892 = 'x-amz-user-agent';


/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $aa2fc029561a5b08$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
var $aa2fc029561a5b08$export$2e2bcd8739ae039 = $aa2fc029561a5b08$var$Mutex;


var $2a9ca5bca188bdad$exports = {};

$2a9ca5bca188bdad$exports = (parcelRequire("7A0Cm")).Observable;


var $5453ba753374635b$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)));
var $5453ba753374635b$export$2e2bcd8739ae039 = $5453ba753374635b$export$77cea355fa80b5f4;


var $b3ceb7579b19eef7$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $b3ceb7579b19eef7$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, $4635c76aed896f54$export$a2708fdb45cd35f)().isNode) return (0, $5453ba753374635b$export$2e2bcd8739ae039).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, $4635c76aed896f54$export$97b87b8868ff7a3c)() ? self : window;
        return new (0, $5453ba753374635b$export$2e2bcd8739ae039)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = $b3ceb7579b19eef7$var$__values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
var $b3ceb7579b19eef7$export$2e2bcd8739ae039 = $b3ceb7579b19eef7$var$ReachabilityNavigator;

function $7e996bbbae522d0e$export$b855308a44508212(str) {
    return str.split('').map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, '0');
    }).join('');
}
function $7e996bbbae522d0e$export$a7ea17e93539f9a5(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join('');
}


var $10962200452e96d6$export$a002182e51710d39 = {
    userAgent: (0, $eb2795a39e4549eb$export$2dffd0b5373a4389).userAgent
};
var /**
 * @deprecated use named import
 */ $10962200452e96d6$export$2e2bcd8739ae039 = (0, $471a5eebd413fda8$export$a3858a9a153cffc7);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $dff78461fb02b1c9$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($dff78461fb02b1c9$export$eeb013770cb92342 || ($dff78461fb02b1c9$export$eeb013770cb92342 = {}));
function $dff78461fb02b1c9$export$9b905d6895bdc426(obj) {
    var keys = [
        'provider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $dff78461fb02b1c9$export$828f8efbdf71714b(obj) {
    var keys = [
        'customProvider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $dff78461fb02b1c9$export$6bae5520ca265d22(obj) {
    var keys = [
        'customState'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $dff78461fb02b1c9$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $dff78461fb02b1c9$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
})($dff78461fb02b1c9$export$edb367c0a140d3db || ($dff78461fb02b1c9$export$edb367c0a140d3db = {}));
function $dff78461fb02b1c9$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}



/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $96a839bd96e3bde1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getPassword = function getPassword() {
        return this.password;
    };
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    };
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    };
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $20e1bf80043e8642$export$a143d493d941bafc;
var $20e1bf80043e8642$export$e4cf37d7f6fb9e0a;
var $20e1bf80043e8642$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $20e1bf80043e8642$export$599f31c3813fae4d;
'use strict';

var $9TmCM = parcelRequire("9TmCM");

var $9Hytc = parcelRequire("9Hytc");

var $gU3Ij = parcelRequire("gU3Ij");
$20e1bf80043e8642$export$a143d493d941bafc = $20e1bf80043e8642$var$Buffer;
$20e1bf80043e8642$export$e4cf37d7f6fb9e0a = $20e1bf80043e8642$var$SlowBuffer;
$20e1bf80043e8642$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $20e1bf80043e8642$var$typedArraySupport();
$20e1bf80043e8642$export$599f31c3813fae4d = $20e1bf80043e8642$var$kMaxLength();
function $20e1bf80043e8642$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $20e1bf80043e8642$var$kMaxLength() {
    return $20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $20e1bf80043e8642$var$createBuffer(that, length) {
    if ($20e1bf80043e8642$var$kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $20e1bf80043e8642$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $20e1bf80043e8642$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $20e1bf80043e8642$var$Buffer(arg, encodingOrOffset, length) {
    if (!$20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $20e1bf80043e8642$var$Buffer)) return new $20e1bf80043e8642$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return $20e1bf80043e8642$var$allocUnsafe(this, arg);
    }
    return $20e1bf80043e8642$var$from(this, arg, encodingOrOffset, length);
}
$20e1bf80043e8642$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$20e1bf80043e8642$var$Buffer._augment = function(arr) {
    arr.__proto__ = $20e1bf80043e8642$var$Buffer.prototype;
    return arr;
};
function $20e1bf80043e8642$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return $20e1bf80043e8642$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return $20e1bf80043e8642$var$fromString(that, value, encodingOrOffset);
    return $20e1bf80043e8642$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $20e1bf80043e8642$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $20e1bf80043e8642$var$from(null, value, encodingOrOffset, length);
};
if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $20e1bf80043e8642$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $20e1bf80043e8642$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && $20e1bf80043e8642$var$Buffer[Symbol.species] === $20e1bf80043e8642$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($20e1bf80043e8642$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $20e1bf80043e8642$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $20e1bf80043e8642$var$alloc(that, size, fill, encoding) {
    $20e1bf80043e8642$var$assertSize(size);
    if (size <= 0) return $20e1bf80043e8642$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? $20e1bf80043e8642$var$createBuffer(that, size).fill(fill, encoding) : $20e1bf80043e8642$var$createBuffer(that, size).fill(fill);
    return $20e1bf80043e8642$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $20e1bf80043e8642$var$Buffer.alloc = function(size, fill, encoding) {
    return $20e1bf80043e8642$var$alloc(null, size, fill, encoding);
};
function $20e1bf80043e8642$var$allocUnsafe(that, size) {
    $20e1bf80043e8642$var$assertSize(size);
    that = $20e1bf80043e8642$var$createBuffer(that, size < 0 ? 0 : $20e1bf80043e8642$var$checked(size) | 0);
    if (!$20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $20e1bf80043e8642$var$Buffer.allocUnsafe = function(size) {
    return $20e1bf80043e8642$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $20e1bf80043e8642$var$Buffer.allocUnsafeSlow = function(size) {
    return $20e1bf80043e8642$var$allocUnsafe(null, size);
};
function $20e1bf80043e8642$var$fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$20e1bf80043e8642$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $20e1bf80043e8642$var$byteLength(string, encoding) | 0;
    that = $20e1bf80043e8642$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $20e1bf80043e8642$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $20e1bf80043e8642$var$checked(array.length) | 0;
    that = $20e1bf80043e8642$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $20e1bf80043e8642$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $20e1bf80043e8642$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $20e1bf80043e8642$var$fromArrayLike(that, array);
    return that;
}
function $20e1bf80043e8642$var$fromObject(that, obj) {
    if ($20e1bf80043e8642$var$Buffer.isBuffer(obj)) {
        var len = $20e1bf80043e8642$var$checked(obj.length) | 0;
        that = $20e1bf80043e8642$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || $20e1bf80043e8642$var$isnan(obj.length)) return $20e1bf80043e8642$var$createBuffer(that, 0);
            return $20e1bf80043e8642$var$fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && $gU3Ij(obj.data)) return $20e1bf80043e8642$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function $20e1bf80043e8642$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $20e1bf80043e8642$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $20e1bf80043e8642$var$kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function $20e1bf80043e8642$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $20e1bf80043e8642$var$Buffer.alloc(+length);
}
$20e1bf80043e8642$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$20e1bf80043e8642$var$Buffer.compare = function compare(a, b) {
    if (!$20e1bf80043e8642$var$Buffer.isBuffer(a) || !$20e1bf80043e8642$var$Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$20e1bf80043e8642$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$20e1bf80043e8642$var$Buffer.concat = function concat(list, length) {
    if (!$gU3Ij(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $20e1bf80043e8642$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $20e1bf80043e8642$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$20e1bf80043e8642$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $20e1bf80043e8642$var$byteLength(string, encoding) {
    if ($20e1bf80043e8642$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return $20e1bf80043e8642$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $20e1bf80043e8642$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $20e1bf80043e8642$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$20e1bf80043e8642$var$Buffer.byteLength = $20e1bf80043e8642$var$byteLength;
function $20e1bf80043e8642$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $20e1bf80043e8642$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $20e1bf80043e8642$var$utf8Slice(this, start, end);
        case 'ascii':
            return $20e1bf80043e8642$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $20e1bf80043e8642$var$latin1Slice(this, start, end);
        case 'base64':
            return $20e1bf80043e8642$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $20e1bf80043e8642$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$20e1bf80043e8642$var$Buffer.prototype._isBuffer = true;
function $20e1bf80043e8642$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$20e1bf80043e8642$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$20e1bf80043e8642$var$swap(this, i, i + 1);
    return this;
};
$20e1bf80043e8642$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $20e1bf80043e8642$var$swap(this, i, i + 3);
        $20e1bf80043e8642$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$20e1bf80043e8642$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $20e1bf80043e8642$var$swap(this, i, i + 7);
        $20e1bf80043e8642$var$swap(this, i + 1, i + 6);
        $20e1bf80043e8642$var$swap(this, i + 2, i + 5);
        $20e1bf80043e8642$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$20e1bf80043e8642$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return $20e1bf80043e8642$var$utf8Slice(this, 0, length);
    return $20e1bf80043e8642$var$slowToString.apply(this, arguments);
};
$20e1bf80043e8642$var$Buffer.prototype.equals = function equals(b) {
    if (!$20e1bf80043e8642$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $20e1bf80043e8642$var$Buffer.compare(this, b) === 0;
};
$20e1bf80043e8642$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $20e1bf80043e8642$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
$20e1bf80043e8642$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$20e1bf80043e8642$var$Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $20e1bf80043e8642$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $20e1bf80043e8642$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($20e1bf80043e8642$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $20e1bf80043e8642$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $20e1bf80043e8642$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $20e1bf80043e8642$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$20e1bf80043e8642$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$20e1bf80043e8642$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $20e1bf80043e8642$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$20e1bf80043e8642$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $20e1bf80043e8642$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $20e1bf80043e8642$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $20e1bf80043e8642$var$utf8Write(buf, string, offset, length) {
    return $20e1bf80043e8642$var$blitBuffer($20e1bf80043e8642$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $20e1bf80043e8642$var$asciiWrite(buf, string, offset, length) {
    return $20e1bf80043e8642$var$blitBuffer($20e1bf80043e8642$var$asciiToBytes(string), buf, offset, length);
}
function $20e1bf80043e8642$var$latin1Write(buf, string, offset, length) {
    return $20e1bf80043e8642$var$asciiWrite(buf, string, offset, length);
}
function $20e1bf80043e8642$var$base64Write(buf, string, offset, length) {
    return $20e1bf80043e8642$var$blitBuffer($20e1bf80043e8642$var$base64ToBytes(string), buf, offset, length);
}
function $20e1bf80043e8642$var$ucs2Write(buf, string, offset, length) {
    return $20e1bf80043e8642$var$blitBuffer($20e1bf80043e8642$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$20e1bf80043e8642$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $20e1bf80043e8642$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $20e1bf80043e8642$var$utf8Write(this, string, offset, length);
        case 'ascii':
            return $20e1bf80043e8642$var$asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return $20e1bf80043e8642$var$latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $20e1bf80043e8642$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $20e1bf80043e8642$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$20e1bf80043e8642$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $20e1bf80043e8642$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9TmCM.fromByteArray(buf);
    else return $9TmCM.fromByteArray(buf.slice(start, end));
}
function $20e1bf80043e8642$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $20e1bf80043e8642$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $20e1bf80043e8642$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $20e1bf80043e8642$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $20e1bf80043e8642$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $20e1bf80043e8642$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $20e1bf80043e8642$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $20e1bf80043e8642$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $20e1bf80043e8642$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $20e1bf80043e8642$var$toHex(buf[i]);
    return out;
}
function $20e1bf80043e8642$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$20e1bf80043e8642$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $20e1bf80043e8642$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $20e1bf80043e8642$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $20e1bf80043e8642$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$20e1bf80043e8642$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$20e1bf80043e8642$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$20e1bf80043e8642$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$20e1bf80043e8642$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$20e1bf80043e8642$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$20e1bf80043e8642$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$20e1bf80043e8642$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$20e1bf80043e8642$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$20e1bf80043e8642$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$20e1bf80043e8642$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$20e1bf80043e8642$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$20e1bf80043e8642$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$20e1bf80043e8642$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$20e1bf80043e8642$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$20e1bf80043e8642$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return $9Hytc.read(this, offset, true, 23, 4);
};
$20e1bf80043e8642$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 4, this.length);
    return $9Hytc.read(this, offset, false, 23, 4);
};
$20e1bf80043e8642$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 8, this.length);
    return $9Hytc.read(this, offset, true, 52, 8);
};
$20e1bf80043e8642$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkOffset(offset, 8, this.length);
    return $9Hytc.read(this, offset, false, 52, 8);
};
function $20e1bf80043e8642$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$20e1bf80043e8642$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$20e1bf80043e8642$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $20e1bf80043e8642$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$20e1bf80043e8642$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $20e1bf80043e8642$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$20e1bf80043e8642$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $20e1bf80043e8642$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$20e1bf80043e8642$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $20e1bf80043e8642$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$20e1bf80043e8642$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $20e1bf80043e8642$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $20e1bf80043e8642$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$20e1bf80043e8642$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $20e1bf80043e8642$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$20e1bf80043e8642$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $20e1bf80043e8642$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$20e1bf80043e8642$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $20e1bf80043e8642$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$20e1bf80043e8642$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $20e1bf80043e8642$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$20e1bf80043e8642$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$20e1bf80043e8642$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $20e1bf80043e8642$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$20e1bf80043e8642$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $20e1bf80043e8642$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$20e1bf80043e8642$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $20e1bf80043e8642$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$20e1bf80043e8642$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $20e1bf80043e8642$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $20e1bf80043e8642$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $20e1bf80043e8642$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $20e1bf80043e8642$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9Hytc.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$20e1bf80043e8642$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $20e1bf80043e8642$var$writeFloat(this, value, offset, true, noAssert);
};
$20e1bf80043e8642$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $20e1bf80043e8642$var$writeFloat(this, value, offset, false, noAssert);
};
function $20e1bf80043e8642$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $20e1bf80043e8642$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9Hytc.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$20e1bf80043e8642$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $20e1bf80043e8642$var$writeDouble(this, value, offset, true, noAssert);
};
$20e1bf80043e8642$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $20e1bf80043e8642$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$20e1bf80043e8642$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$20e1bf80043e8642$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$20e1bf80043e8642$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$20e1bf80043e8642$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $20e1bf80043e8642$var$Buffer.isBuffer(val) ? val : $20e1bf80043e8642$var$utf8ToBytes(new $20e1bf80043e8642$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $20e1bf80043e8642$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $20e1bf80043e8642$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $20e1bf80043e8642$var$stringtrim(str).replace($20e1bf80043e8642$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $20e1bf80043e8642$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function $20e1bf80043e8642$var$toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function $20e1bf80043e8642$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $20e1bf80043e8642$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $20e1bf80043e8642$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $20e1bf80043e8642$var$base64ToBytes(str) {
    return $9TmCM.toByteArray($20e1bf80043e8642$var$base64clean(str));
}
function $20e1bf80043e8642$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $20e1bf80043e8642$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}



var $asSBv = parcelRequire("asSBv");
parcelRequire("ewqgP");

var $kVxtB = parcelRequire("kVxtB");

var $hlHlW = parcelRequire("hlHlW");
var $00bacd465dc8f80a$var$crypto; // Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) $00bacd465dc8f80a$var$crypto = window.crypto;
 // Native (experimental IE 11) crypto from window (Browser)
if (!$00bacd465dc8f80a$var$crypto && typeof window !== 'undefined' && window.msCrypto) $00bacd465dc8f80a$var$crypto = window.msCrypto;
 // Native crypto from global (NodeJS)
if (!$00bacd465dc8f80a$var$crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) $00bacd465dc8f80a$var$crypto = $parcel$global.crypto;
 // Native crypto import via require (NodeJS)

if (!$00bacd465dc8f80a$var$crypto && true) try {
    $00bacd465dc8f80a$var$crypto = (parcelRequire("3uOnC"));
} catch (err) {}
function $00bacd465dc8f80a$export$2e2bcd8739ae039() {
    if ($00bacd465dc8f80a$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $00bacd465dc8f80a$var$crypto.getRandomValues === 'function') try {
            return $00bacd465dc8f80a$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
         // Use randomBytes method (NodeJS)
        if (typeof $00bacd465dc8f80a$var$crypto.randomBytes === 'function') try {
            return $00bacd465dc8f80a$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $9d48d60c4d359d3e$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes; // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var $9d48d60c4d359d3e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $00bacd465dc8f80a$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $9d48d60c4d359d3e$var$hexStringify(this);
    };
    return WordArray;
}();


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $9067484435c57bd7$export$2e2bcd8739ae039 = $9067484435c57bd7$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $9067484435c57bd7$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
} // return new, unset BigInteger
function $9067484435c57bd7$var$nbi() {
    return new $9067484435c57bd7$var$BigInteger(null);
} // Bits per digit
var $9067484435c57bd7$var$dbits; // JavaScript engine analysis
var $9067484435c57bd7$var$canary = 0xdeadbeefcafe;
var $9067484435c57bd7$var$j_lm = ($9067484435c57bd7$var$canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $9067484435c57bd7$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $9067484435c57bd7$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $9067484435c57bd7$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $9067484435c57bd7$var$inBrowser = typeof navigator !== 'undefined';
if ($9067484435c57bd7$var$inBrowser && $9067484435c57bd7$var$j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    $9067484435c57bd7$var$BigInteger.prototype.am = $9067484435c57bd7$var$am2;
    $9067484435c57bd7$var$dbits = 30;
} else if ($9067484435c57bd7$var$inBrowser && $9067484435c57bd7$var$j_lm && navigator.appName != 'Netscape') {
    $9067484435c57bd7$var$BigInteger.prototype.am = $9067484435c57bd7$var$am1;
    $9067484435c57bd7$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $9067484435c57bd7$var$BigInteger.prototype.am = $9067484435c57bd7$var$am3;
    $9067484435c57bd7$var$dbits = 28;
}
$9067484435c57bd7$var$BigInteger.prototype.DB = $9067484435c57bd7$var$dbits;
$9067484435c57bd7$var$BigInteger.prototype.DM = (1 << $9067484435c57bd7$var$dbits) - 1;
$9067484435c57bd7$var$BigInteger.prototype.DV = 1 << $9067484435c57bd7$var$dbits;
var $9067484435c57bd7$var$BI_FP = 52;
$9067484435c57bd7$var$BigInteger.prototype.FV = Math.pow(2, $9067484435c57bd7$var$BI_FP);
$9067484435c57bd7$var$BigInteger.prototype.F1 = $9067484435c57bd7$var$BI_FP - $9067484435c57bd7$var$dbits;
$9067484435c57bd7$var$BigInteger.prototype.F2 = 2 * $9067484435c57bd7$var$dbits - $9067484435c57bd7$var$BI_FP; // Digit conversions
var $9067484435c57bd7$var$BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var $9067484435c57bd7$var$BI_RC = new Array();
var $9067484435c57bd7$var$rr, $9067484435c57bd7$var$vv;
$9067484435c57bd7$var$rr = '0'.charCodeAt(0);
for($9067484435c57bd7$var$vv = 0; $9067484435c57bd7$var$vv <= 9; ++$9067484435c57bd7$var$vv)$9067484435c57bd7$var$BI_RC[$9067484435c57bd7$var$rr++] = $9067484435c57bd7$var$vv;
$9067484435c57bd7$var$rr = 'a'.charCodeAt(0);
for($9067484435c57bd7$var$vv = 10; $9067484435c57bd7$var$vv < 36; ++$9067484435c57bd7$var$vv)$9067484435c57bd7$var$BI_RC[$9067484435c57bd7$var$rr++] = $9067484435c57bd7$var$vv;
$9067484435c57bd7$var$rr = 'A'.charCodeAt(0);
for($9067484435c57bd7$var$vv = 10; $9067484435c57bd7$var$vv < 36; ++$9067484435c57bd7$var$vv)$9067484435c57bd7$var$BI_RC[$9067484435c57bd7$var$rr++] = $9067484435c57bd7$var$vv;
function $9067484435c57bd7$var$int2char(n) {
    return $9067484435c57bd7$var$BI_RM.charAt(n);
}
function $9067484435c57bd7$var$intAt(s, i) {
    var c = $9067484435c57bd7$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
} // (protected) copy this to r
function $9067484435c57bd7$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV
function $9067484435c57bd7$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
} // return bigint initialized to value
function $9067484435c57bd7$var$nbv(i) {
    var r = $9067484435c57bd7$var$nbi();
    r.fromInt(i);
    return r;
} // (protected) set from string and radix
function $9067484435c57bd7$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $9067484435c57bd7$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $9067484435c57bd7$var$BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words
function $9067484435c57bd7$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
} // (public) return string representation in given radix
function $9067484435c57bd7$var$bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $9067484435c57bd7$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $9067484435c57bd7$var$int2char(d);
        }
    }
    return m ? r : '0';
} // (public) -this
function $9067484435c57bd7$var$bnNegate() {
    var r = $9067484435c57bd7$var$nbi();
    $9067484435c57bd7$var$BigInteger.ZERO.subTo(this, r);
    return r;
} // (public) |this|
function $9067484435c57bd7$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal
function $9067484435c57bd7$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
} // returns bit length of the integer x
function $9067484435c57bd7$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
} // (public) return the number of bits in "this"
function $9067484435c57bd7$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $9067484435c57bd7$var$nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB
function $9067484435c57bd7$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
} // (protected) r = this >> n*DB
function $9067484435c57bd7$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
} // (protected) r = this << n
function $9067484435c57bd7$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
} // (protected) r = this >> n
function $9067484435c57bd7$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
} // (protected) r = this - a
function $9067484435c57bd7$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $9067484435c57bd7$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $9067484435c57bd7$var$BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)
function $9067484435c57bd7$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $9067484435c57bd7$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $9067484435c57bd7$var$nbi();
    var y = $9067484435c57bd7$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $9067484435c57bd7$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $9067484435c57bd7$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $9067484435c57bd7$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $9067484435c57bd7$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $9067484435c57bd7$var$BigInteger.ZERO.subTo(r, r);
} // (public) this mod a
function $9067484435c57bd7$var$bnMod(a) {
    var r = $9067484435c57bd7$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($9067484435c57bd7$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $9067484435c57bd7$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $9067484435c57bd7$var$bnEquals(a) {
    return this.compareTo(a) == 0;
} // (protected) r = this + a
function $9067484435c57bd7$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
} // (public) this + a
function $9067484435c57bd7$var$bnAdd(a) {
    var r = $9067484435c57bd7$var$nbi();
    this.addTo(a, r);
    return r;
} // (public) this - a
function $9067484435c57bd7$var$bnSubtract(a) {
    var r = $9067484435c57bd7$var$nbi();
    this.subTo(a, r);
    return r;
} // (public) this * a
function $9067484435c57bd7$var$bnMultiply(a) {
    var r = $9067484435c57bd7$var$nbi();
    this.multiplyTo(a, r);
    return r;
} // (public) this / a
function $9067484435c57bd7$var$bnDivide(a) {
    var r = $9067484435c57bd7$var$nbi();
    this.divRemTo(a, r, null);
    return r;
} // Montgomery reduction
function $9067484435c57bd7$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
} // xR mod m
function $9067484435c57bd7$var$montConvert(x) {
    var r = $9067484435c57bd7$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($9067484435c57bd7$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
} // x/R mod m
function $9067484435c57bd7$var$montRevert(x) {
    var r = $9067484435c57bd7$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
} // x = x/R mod m (HAC 14.32)
function $9067484435c57bd7$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r
function $9067484435c57bd7$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
} // r = "xy/R mod m"; x,y != r
function $9067484435c57bd7$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$9067484435c57bd7$var$Montgomery.prototype.convert = $9067484435c57bd7$var$montConvert;
$9067484435c57bd7$var$Montgomery.prototype.revert = $9067484435c57bd7$var$montRevert;
$9067484435c57bd7$var$Montgomery.prototype.reduce = $9067484435c57bd7$var$montReduce;
$9067484435c57bd7$var$Montgomery.prototype.mulTo = $9067484435c57bd7$var$montMulTo;
$9067484435c57bd7$var$Montgomery.prototype.sqrTo = $9067484435c57bd7$var$montSqrTo; // (public) this^e % m (HAC 14.85)
function $9067484435c57bd7$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $9067484435c57bd7$var$nbv(1), z = new $9067484435c57bd7$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6; // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $9067484435c57bd7$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $9067484435c57bd7$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $9067484435c57bd7$var$nbi(), t;
    i = $9067484435c57bd7$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
} // protected
$9067484435c57bd7$var$BigInteger.prototype.copyTo = $9067484435c57bd7$var$bnpCopyTo;
$9067484435c57bd7$var$BigInteger.prototype.fromInt = $9067484435c57bd7$var$bnpFromInt;
$9067484435c57bd7$var$BigInteger.prototype.fromString = $9067484435c57bd7$var$bnpFromString;
$9067484435c57bd7$var$BigInteger.prototype.clamp = $9067484435c57bd7$var$bnpClamp;
$9067484435c57bd7$var$BigInteger.prototype.dlShiftTo = $9067484435c57bd7$var$bnpDLShiftTo;
$9067484435c57bd7$var$BigInteger.prototype.drShiftTo = $9067484435c57bd7$var$bnpDRShiftTo;
$9067484435c57bd7$var$BigInteger.prototype.lShiftTo = $9067484435c57bd7$var$bnpLShiftTo;
$9067484435c57bd7$var$BigInteger.prototype.rShiftTo = $9067484435c57bd7$var$bnpRShiftTo;
$9067484435c57bd7$var$BigInteger.prototype.subTo = $9067484435c57bd7$var$bnpSubTo;
$9067484435c57bd7$var$BigInteger.prototype.multiplyTo = $9067484435c57bd7$var$bnpMultiplyTo;
$9067484435c57bd7$var$BigInteger.prototype.squareTo = $9067484435c57bd7$var$bnpSquareTo;
$9067484435c57bd7$var$BigInteger.prototype.divRemTo = $9067484435c57bd7$var$bnpDivRemTo;
$9067484435c57bd7$var$BigInteger.prototype.invDigit = $9067484435c57bd7$var$bnpInvDigit;
$9067484435c57bd7$var$BigInteger.prototype.addTo = $9067484435c57bd7$var$bnpAddTo; // public
$9067484435c57bd7$var$BigInteger.prototype.toString = $9067484435c57bd7$var$bnToString;
$9067484435c57bd7$var$BigInteger.prototype.negate = $9067484435c57bd7$var$bnNegate;
$9067484435c57bd7$var$BigInteger.prototype.abs = $9067484435c57bd7$var$bnAbs;
$9067484435c57bd7$var$BigInteger.prototype.compareTo = $9067484435c57bd7$var$bnCompareTo;
$9067484435c57bd7$var$BigInteger.prototype.bitLength = $9067484435c57bd7$var$bnBitLength;
$9067484435c57bd7$var$BigInteger.prototype.mod = $9067484435c57bd7$var$bnMod;
$9067484435c57bd7$var$BigInteger.prototype.equals = $9067484435c57bd7$var$bnEquals;
$9067484435c57bd7$var$BigInteger.prototype.add = $9067484435c57bd7$var$bnAdd;
$9067484435c57bd7$var$BigInteger.prototype.subtract = $9067484435c57bd7$var$bnSubtract;
$9067484435c57bd7$var$BigInteger.prototype.multiply = $9067484435c57bd7$var$bnMultiply;
$9067484435c57bd7$var$BigInteger.prototype.divide = $9067484435c57bd7$var$bnDivide;
$9067484435c57bd7$var$BigInteger.prototype.modPow = $9067484435c57bd7$var$bnModPow; // "constants"
$9067484435c57bd7$var$BigInteger.ZERO = $9067484435c57bd7$var$nbv(0);
$9067484435c57bd7$var$BigInteger.ONE = $9067484435c57bd7$var$nbv(1);


var $8f7225bacce83d93$var$randomBytes = function randomBytes(nBytes) {
    return (0, $20e1bf80043e8642$export$a143d493d941bafc).from(new (0, $9d48d60c4d359d3e$export$2e2bcd8739ae039)().random(nBytes).toString(), 'hex');
};
var $8f7225bacce83d93$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $8f7225bacce83d93$var$newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var $8f7225bacce83d93$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)($8f7225bacce83d93$var$initN, 16);
        this.g = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)('2', 16);
        this.k = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(this.hexHash("00" + this.N.toString(16) + "0" + this.g.toString(16)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $20e1bf80043e8642$export$a143d493d941bafc).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    };
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    };
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        var hexRandom = $8f7225bacce83d93$var$randomBytes(128).toString('hex');
        var randomBigInt = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(hexRandom, 16);
        var smallABigInt = randomBigInt.mod(this.N);
        return smallABigInt;
    };
    _proto.generateRandomString = function generateRandomString() {
        return $8f7225bacce83d93$var$randomBytes(40).toString('base64');
    };
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    };
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    };
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    };
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $8f7225bacce83d93$var$randomBytes(16).toString('hex');
        this.SaltToHashDevices = this.padHex(new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    };
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $9067484435c57bd7$export$2e2bcd8739ae039).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    };
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    };
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $20e1bf80043e8642$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($kVxtB)))(str).toString();
        return new Array(64 - hashHex.length).join('0') + hashHex;
    };
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $20e1bf80043e8642$export$a143d493d941bafc).from(hexStr, 'hex'));
    };
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create((0, $20e1bf80043e8642$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $20e1bf80043e8642$export$a143d493d941bafc).from(String.fromCharCode(1), 'utf8')
        ]));
        var ikmWordArray = ikm instanceof (0, $20e1bf80043e8642$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $20e1bf80043e8642$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($hlHlW)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($hlHlW)))(infoBitsWordArray, prk);
        return (0, $20e1bf80043e8642$export$a143d493d941bafc).from(hmac.toString(), 'hex').slice(0, 16);
    };
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $9067484435c57bd7$export$2e2bcd8739ae039).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $9067484435c57bd7$export$2e2bcd8739ae039).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this4.padHex(sValue), 'hex'), (0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue.toString(16)), 'hex'));
            callback(null, hkdf);
        });
    };
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    };
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $8f7225bacce83d93$var$newPasswordRequiredChallengeUserAttributePrefix;
    };
    _proto.padHex = function padHex(bigInt) {
        var hashStr = bigInt.toString(16);
        if (hashStr.length % 2 === 1) hashStr = "0" + hashStr;
        else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) hashStr = "00" + hashStr;
        return hashStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
/** @class */ var $9f366626eb127b33$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    };
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    };
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    };
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, $20e1bf80043e8642$export$a143d493d941bafc).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $68963592e483da60$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/** @class */ var $68963592e483da60$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $68963592e483da60$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    return CognitoAccessToken;
}((0, $9f366626eb127b33$export$2e2bcd8739ae039));



function $5fb203a9a4ab7ad3$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/** @class */ var $5fb203a9a4ab7ad3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $5fb203a9a4ab7ad3$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    return CognitoIdToken;
}((0, $9f366626eb127b33$export$2e2bcd8739ae039));


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $eaf04386920ddc0c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 

var $asSBv = parcelRequire("asSBv");
parcelRequire("ewqgP");

var $e9cdc = parcelRequire("e9cdc");

var $hlHlW = parcelRequire("hlHlW");





/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $efbb3a8ba4d8142b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    };
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    };
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    };
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    };
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    };
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $5b7ea01aa8fe12a5$var$monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var $5b7ea01aa8fe12a5$var$weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var $5b7ea01aa8fe12a5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $5b7ea01aa8fe12a5$var$weekNames[now.getUTCDay()];
        var month = $5b7ea01aa8fe12a5$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $450f14f977aaa6d2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    };
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    };
    _proto.getName = function getName() {
        return this.Name;
    };
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    };
    _proto.toString = function toString() {
        return JSON.stringify(this);
    };
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $6a4edda624836e27$var$dataMemory = {};
/** @class */ var $6a4edda624836e27$var$MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $6a4edda624836e27$var$dataMemory[key] = value;
        return $6a4edda624836e27$var$dataMemory[key];
    };
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($6a4edda624836e27$var$dataMemory, key) ? $6a4edda624836e27$var$dataMemory[key] : undefined;
    };
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $6a4edda624836e27$var$dataMemory[key];
    };
    MemoryStorage.clear = function clear() {
        $6a4edda624836e27$var$dataMemory = {};
        return $6a4edda624836e27$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $6a4edda624836e27$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = $6a4edda624836e27$var$MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $fca85d3307cddf9a$var$isBrowser = typeof navigator !== 'undefined';
var $fca85d3307cddf9a$var$userAgent = $fca85d3307cddf9a$var$isBrowser ? navigator.userAgent : 'nodejs';
/** @class */ var $fca85d3307cddf9a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, $6a4edda624836e27$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    };
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    };
    _proto.getUsername = function getUsername() {
        return this.username;
    };
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    };
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    };
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    };
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    };
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split('_')[1]);
        var dateHelper = new (0, $5b7ea01aa8fe12a5$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                serverBValue = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create((0, $20e1bf80043e8642$export$a143d493d941bafc).concat([
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this2.username, 'utf8'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($e9cdc))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($hlHlW)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
         // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    };
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $20e1bf80043e8642$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, $20e1bf80043e8642$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $fca85d3307cddf9a$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    };
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split('_')[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    };
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $5b7ea01aa8fe12a5$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $9067484435c57bd7$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create((0, $20e1bf80043e8642$export$a143d493d941bafc).concat([
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this6.deviceGroupKey, 'utf8'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(_this6.deviceKey, 'utf8'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, $20e1bf80043e8642$export$a143d493d941bafc).from(dateNow, 'utf8')
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($asSBv))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($e9cdc))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($hlHlW)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    };
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    };
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split('_')[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    };
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $8f7225bacce83d93$export$2e2bcd8739ae039)(_this8.pool.getUserPoolId().split('_')[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $20e1bf80043e8642$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, $20e1bf80043e8642$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $fca85d3307cddf9a$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    };
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    };
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $450f14f977aaa6d2$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    };
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    };
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    };
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible() {
        var _this11 = this;
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve);
            else resolve();
        });
    };
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible().then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    };
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    };
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    };
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    };
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    };
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    };
    _proto.getSession = function getSession(callback) {
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $5fb203a9a4ab7ad3$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $68963592e483da60$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $eaf04386920ddc0c$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $efbb3a8ba4d8142b$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    };
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this14 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this14.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this14.signInUserSession = _this14.getCognitoUserSession(authenticationResult);
                _this14.cacheTokens();
                return wrappedCallback(null, _this14.signInUserSession);
            }
            return undefined;
        });
    };
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    };
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    };
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    };
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    };
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    };
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    };
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    };
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $5fb203a9a4ab7ad3$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $68963592e483da60$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $eaf04386920ddc0c$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $efbb3a8ba4d8142b$export$2e2bcd8739ae039)(sessionData);
    };
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    };
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess();
        });
    };
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess();
        });
        return undefined;
    };
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this15 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this15.deviceKey = null;
                _this15.deviceGroupKey = null;
                _this15.randomPassword = null;
                _this15.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    };
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this16 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this16.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    };
    _proto.signOut = function signOut() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this17 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this17.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    };
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    };
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this18 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this18.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    };
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this19 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this19.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this19.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this19.Session
            };
            if (_this19.getUserContextData()) jsonReq.UserContextData = _this19.getUserContextData();
            _this19.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this19.signInUserSession = _this19.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this19.cacheTokens();
                return callback.onSuccess(_this19.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $2079f965df362774$exports = {};


$2079f965df362774$exports = self.fetch || (self.fetch = (parcelRequire("hR5EF")).default || (parcelRequire("hR5EF")));


// constructor
function $4580d683dec96040$var$UserAgent() {} // public
$4580d683dec96040$var$UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';
var $4580d683dec96040$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($4580d683dec96040$var$UserAgent.prototype.userAgent && !$4580d683dec96040$var$UserAgent.prototype.userAgent.includes(content)) $4580d683dec96040$var$UserAgent.prototype.userAgent = $4580d683dec96040$var$UserAgent.prototype.userAgent.concat(' ', content);
    if (!$4580d683dec96040$var$UserAgent.prototype.userAgent || $4580d683dec96040$var$UserAgent.prototype.userAgent === '') $4580d683dec96040$var$UserAgent.prototype.userAgent = content;
}; // class for defining the amzn user-agent
var $4580d683dec96040$export$2e2bcd8739ae039 = $4580d683dec96040$var$UserAgent;


function $95b24db2909f1476$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $95b24db2909f1476$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $95b24db2909f1476$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$95b24db2909f1476$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $95b24db2909f1476$var$_construct(Class, arguments, $95b24db2909f1476$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $95b24db2909f1476$var$_setPrototypeOf(Wrapper, Class);
    };
    return $95b24db2909f1476$var$_wrapNativeSuper(Class);
}
function $95b24db2909f1476$var$_construct(Parent, args, Class) {
    if ($95b24db2909f1476$var$_isNativeReflectConstruct()) $95b24db2909f1476$var$_construct = Reflect.construct;
    else $95b24db2909f1476$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $95b24db2909f1476$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $95b24db2909f1476$var$_construct.apply(null, arguments);
}
function $95b24db2909f1476$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $95b24db2909f1476$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $95b24db2909f1476$var$_setPrototypeOf(o, p) {
    $95b24db2909f1476$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $95b24db2909f1476$var$_setPrototypeOf(o, p);
}
function $95b24db2909f1476$var$_getPrototypeOf(o) {
    $95b24db2909f1476$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $95b24db2909f1476$var$_getPrototypeOf(o);
}
var $95b24db2909f1476$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $95b24db2909f1476$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $95b24db2909f1476$var$_wrapNativeSuper(Error));
/** @class */ var $95b24db2909f1476$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $95b24db2909f1476$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, $4580d683dec96040$export$2e2bcd8739ae039).prototype.userAgent
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = {
                code: code,
                name: code,
                message: data.message || data.Message || null
            };
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = {
                    code: code,
                    name: code,
                    statusCode: response.status,
                    message: response.status ? response.status.toString() : null
                };
                return callback(error);
            } catch (ex) {
                return callback(err);
            } // otherwise check if error is Network error
            else if (err instanceof Error && err.message === 'Network error') {
                var _error = {
                    code: 'NetworkError',
                    name: err.name,
                    message: err.message
                };
                return callback(_error);
            } else return callback(err);
        });
    };
    return Client;
}();




/** @class */ var $5af4820911f74ecb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (!/^[\w-]+_.+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $95b24db2909f1476$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $6a4edda624836e27$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    };
    _proto.getClientId = function getClientId() {
        return this.clientId;
    };
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $fca85d3307cddf9a$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    };
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $fca85d3307cddf9a$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    };
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $f517f7b2bba4fe4b$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $f517f7b2bba4fe4b$exports = factory();
})($f517f7b2bba4fe4b$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


/** @class */ var $511f69237ca8df0b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error('The domain of cookieStorage can not be undefined.');
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $f517f7b2bba4fe4b$exports.set(key, value, options);
        return $f517f7b2bba4fe4b$exports.get(key);
    };
    _proto.getItem = function getItem(key) {
        return $f517f7b2bba4fe4b$exports.get(key);
    };
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $f517f7b2bba4fe4b$exports.remove(key, options);
    };
    _proto.clear = function clear() {
        var cookies = $f517f7b2bba4fe4b$exports.get();
        var index;
        for(index = 0; index < cookies.length; ++index)$f517f7b2bba4fe4b$exports.remove(cookies[index]);
        return {};
    };
    return CookieStorage;
}();







var $adm0U = parcelRequire("adm0U");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $adm0U = parcelRequire("adm0U");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $f37f57e770f5d85f$var$SELF = '_self';
var $f37f57e770f5d85f$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $f37f57e770f5d85f$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $4958bae5d2fa1827$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var $4958bae5d2fa1827$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var $4958bae5d2fa1827$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var $4958bae5d2fa1827$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var $4958bae5d2fa1827$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};





var $kVxtB = parcelRequire("kVxtB");

var $e9cdc = parcelRequire("e9cdc");
var $0cac70f7056cf0c0$var$__assign = undefined && undefined.__assign || function() {
    $0cac70f7056cf0c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0cac70f7056cf0c0$var$__assign.apply(this, arguments);
};
var $0cac70f7056cf0c0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0cac70f7056cf0c0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0cac70f7056cf0c0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0cac70f7056cf0c0$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $0cac70f7056cf0c0$var$dispatchAuthEvent = function(event, data, message) {
    (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $0cac70f7056cf0c0$var$AMPLIFY_SYMBOL);
};
var $0cac70f7056cf0c0$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('OAuth');
var $0cac70f7056cf0c0$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $f37f57e770f5d85f$export$9b38228bd9928080);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === 'string';
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = 'code';
        if (provider === void 0) provider = (0, $dff78461fb02b1c9$export$eeb013770cb92342).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, $7e996bbbae522d0e$export$b855308a44508212)(customState) : generatedState;
        $4958bae5d2fa1827$export$42fffed799c298bb(state);
        var pkce_key = this._generateRandom(128);
        $4958bae5d2fa1827$export$14934cb45d589fa1(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries($0cac70f7056cf0c0$var$__assign($0cac70f7056cf0c0$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === 'code' ? {
            code_challenge: code_challenge
        } : {}), responseType === 'code' ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = $0cac70f7056cf0c0$var$__read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $0cac70f7056cf0c0$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $0cac70f7056cf0c0$var$__awaiter(this, void 0, void 0, function() {
            var code, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $0cac70f7056cf0c0$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $adm0U.parse)(currentUrl).query || '').split('&').map(function(pairings) {
                            return pairings.split('=');
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = $0cac70f7056cf0c0$var$__read(_a, 2), k = _c[0], v = _c[1];
                            return $0cac70f7056cf0c0$var$__assign($0cac70f7056cf0c0$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        if (!code || (0, $adm0U.parse)(currentUrl).pathname !== (0, $adm0U.parse)(this._config.redirectSignIn).pathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        $0cac70f7056cf0c0$var$dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $4958bae5d2fa1827$export$742ac7ded61fbfce();
                        oAuthTokenBody = $0cac70f7056cf0c0$var$__assign({
                            grant_type: 'authorization_code',
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $0cac70f7056cf0c0$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = $0cac70f7056cf0c0$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join('&');
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $0cac70f7056cf0c0$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $0cac70f7056cf0c0$var$__generator(this, function(_b) {
                _a = ((0, $adm0U.parse)(currentUrl).hash || '#').substr(1) // Remove # from returned code
                .split('&').map(function(pairings) {
                    return pairings.split('=');
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = $0cac70f7056cf0c0$var$__read(_a, 2), k = _c[0], v = _c[1];
                    return $0cac70f7056cf0c0$var$__assign($0cac70f7056cf0c0$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $0cac70f7056cf0c0$var$dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                $0cac70f7056cf0c0$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $0cac70f7056cf0c0$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $0cac70f7056cf0c0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $0cac70f7056cf0c0$var$__assign($0cac70f7056cf0c0$var$__assign({}, ((0, $adm0U.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $0cac70f7056cf0c0$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $adm0U.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = $0cac70f7056cf0c0$var$__read(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $0cac70f7056cf0c0$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $0cac70f7056cf0c0$var$__assign.apply(void 0, [
                                $0cac70f7056cf0c0$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $0cac70f7056cf0c0$var$__assign.apply(void 0, [
                                $0cac70f7056cf0c0$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $0cac70f7056cf0c0$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $4958bae5d2fa1827$export$50fdfeece43146fd();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error('Invalid state in OAuth flow');
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $0cac70f7056cf0c0$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $0cac70f7056cf0c0$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = $0cac70f7056cf0c0$var$__read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join('&');
                $0cac70f7056cf0c0$var$dispatchAuthEvent('oAuthSignOut', {
                    oAuth: 'signOut'
                }, "Signing out from " + oAuthLogoutEndpoint);
                $0cac70f7056cf0c0$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL((0, (/*@__PURE__*/$parcel$interopDefault($kVxtB)))(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString((0, (/*@__PURE__*/$parcel$interopDefault($e9cdc)))).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}();
var $0cac70f7056cf0c0$export$2e2bcd8739ae039 = $0cac70f7056cf0c0$var$OAuth;


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $2db9532ebd271cd6$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $4635c76aed896f54$export$174a40858393256b).browserOrNode().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $4635c76aed896f54$export$174a40858393256b).browserOrNode().isNode) ;
    else throw new Error('Not supported');
};


/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $10bacba085c7a79e$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
})($10bacba085c7a79e$export$c3070468b9d65120 || ($10bacba085c7a79e$export$c3070468b9d65120 = {}));


var $d294b72bf558c321$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d294b72bf558c321$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('AuthError');
var $d294b72bf558c321$export$145273558d58e0ac = /** @class */ function(_super) {
    $d294b72bf558c321$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $d294b72bf558c321$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        $d294b72bf558c321$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $d294b72bf558c321$export$71192787e041818c = /** @class */ function(_super) {
    $d294b72bf558c321$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}($d294b72bf558c321$export$145273558d58e0ac);
var $d294b72bf558c321$export$d8113b8d790509a4 = {
    noConfig: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of aws-amplify or amplify packages in your node_modules.\n                Try deleting your node_modules folder and reinstalling the dependencies with `yarn install`\n        "
    },
    missingAuthConfig: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties. \n            Did you run `amplify push` after adding auth via `amplify add auth`?\n            See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n        "
    },
    emptyUsername: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).NO_USER_SESSION
    },
    default: {
        message: (0, $10bacba085c7a79e$export$c3070468b9d65120).DEFAULT_MSG
    }
};



var $bd4b1dc9807d6e1d$var$__assign = undefined && undefined.__assign || function() {
    $bd4b1dc9807d6e1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd4b1dc9807d6e1d$var$__assign.apply(this, arguments);
};
var $bd4b1dc9807d6e1d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bd4b1dc9807d6e1d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bd4b1dc9807d6e1d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bd4b1dc9807d6e1d$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('AuthClass');
var $bd4b1dc9807d6e1d$var$USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var $bd4b1dc9807d6e1d$var$OAUTH_FLOW_MS_TIMEOUT = 10000;
var $bd4b1dc9807d6e1d$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $bd4b1dc9807d6e1d$var$dispatchAuthEvent = function(event, data, message) {
    (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', $bd4b1dc9807d6e1d$var$AMPLIFY_SYMBOL);
};
/**
 * Provide authentication steps
 */ var $bd4b1dc9807d6e1d$export$eeff9d1a8b8c057b = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.Credentials = (0, $5f8c093c17ed2e35$export$a9627919734faa48);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) $bd4b1dc9807d6e1d$var$dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                else $bd4b1dc9807d6e1d$var$dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).listen('auth', function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return 'Auth';
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $bd4b1dc9807d6e1d$var$logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, (0, $ae0d5b8a0cfbbb01$export$7acfa6ed01010e37).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, $511f69237ca8df0b$export$2e2bcd8739ae039)(cookieStorage);
            else this._storage = config.ssr ? new (0, $c57aff6187c99733$export$ded9c57084144144)() : new (0, $59e04b8bcc93b29e$export$a2bd19c49e4760e8)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $bd4b1dc9807d6e1d$var$logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $5af4820911f74ecb$export$2e2bcd8739ae039)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initiailize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new (0, $0cac70f7056cf0c0$export$2e2bcd8739ae039)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $2db9532ebd271cd6$export$2e2bcd8739ae039)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push({
                Name: 'email',
                Value: email
            });
            if (phone_number) attributes.push({
                Name: 'phone_number',
                Value: phone_number
            });
        } else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params['attributes'];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                var ele = {
                    Name: key,
                    Value: attrs_1[key]
                };
                attributes.push(ele);
            });
            validationData = params['validationData'] || null;
        } else return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).SignUpError);
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyPassword);
        $bd4b1dc9807d6e1d$var$logger.debug('signUp attrs:', attributes);
        $bd4b1dc9807d6e1d$var$logger.debug('signUp validation data:', validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                } else {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean' ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $dff78461fb02b1c9$export$ad34f09783c4cb16)(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') $bd4b1dc9807d6e1d$var$logger.warn('The password should be defined under the first parameter object!');
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        var authDetails = new (0, $96a839bd96e3bde1$export$2e2bcd8739ae039)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $bd4b1dc9807d6e1d$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $bd4b1dc9807d6e1d$var$logger.debug(session);
                                delete user['challengeName'];
                                delete user['challengeParam'];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, 'session')
                                ];
                            case 3:
                                cred = _a.sent();
                                $bd4b1dc9807d6e1d$var$logger.debug('succeed to get cognito credentials', cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $bd4b1dc9807d6e1d$var$logger.debug('cannot get cognito credentials', e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $bd4b1dc9807d6e1d$var$logger.error('Failed to get the signed in user', e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn failure', err);
                $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $bd4b1dc9807d6e1d$var$logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error('Pending sign-in attempt already in progress');
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * get user current preferred mfa option
     * this method doesn't work with totp, we need to deprecate it.
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                $bd4b1dc9807d6e1d$var$logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var that = this;
        return new Promise(function(res, rej) {
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('getting preferred mfa failed', err);
                    rej(err);
                    return;
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    rej('invalid MFA Type');
                    return;
                } else {
                    res(mfaType);
                    return;
                }
            }, {
                bypassCache: bypassCache
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = 'SMS_MFA';
                else ret = 'NOMFA';
            } else if (mfaList.length === 0) ret = 'NOMFA';
            else $bd4b1dc9807d6e1d$var$logger.debug('invalid case for getPreferredMFA', data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('getting user data failed', err);
                    rej(err);
                    return;
                } else {
                    res(data);
                    return;
                }
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case 'TOTP':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SMS':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'NOMFA':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') return [
                            2 /*return*/ ,
                            Promise.resolve('No change for mfa type')
                        ];
                        else if (currentMFAType === 'SMS_MFA') smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === 'SMS_MFA') smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $bd4b1dc9807d6e1d$var$logger.debug('no validmfa method provided');
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $bd4b1dc9807d6e1d$var$logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    $bd4b1dc9807d6e1d$var$logger.debug('Set user mfa success', result);
                                    $bd4b1dc9807d6e1d$var$logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        if (err) {
                                            $bd4b1dc9807d6e1d$var$logger.debug('getting user data failed', err);
                                            return rej(err);
                                        } else return res(result);
                                    }, {
                                        bypassCache: true
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                $bd4b1dc9807d6e1d$var$logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                $bd4b1dc9807d6e1d$var$logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $bd4b1dc9807d6e1d$var$logger.debug('associateSoftwareToken sucess', secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $bd4b1dc9807d6e1d$var$logger.debug('verfication totp token', user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    $bd4b1dc9807d6e1d$var$logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $bd4b1dc9807d6e1d$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $bd4b1dc9807d6e1d$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $bd4b1dc9807d6e1d$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $bd4b1dc9807d6e1d$var$logger.debug('cannot get cognito credentials', e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $bd4b1dc9807d6e1d$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $bd4b1dc9807d6e1d$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $bd4b1dc9807d6e1d$var$logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $bd4b1dc9807d6e1d$var$logger.debug('cannot get cognito credentials', e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('completeNewPassword failure', err);
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $bd4b1dc9807d6e1d$var$logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $bd4b1dc9807d6e1d$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    $bd4b1dc9807d6e1d$var$logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== 'sub' && key.indexOf('_verified') < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) verified['email'] = attrs['email'];
                else unverified['email'] = attrs['email'];
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) verified['phone_number'] = attrs['phone_number'];
                else unverified['phone_number'] = attrs['phone_number'];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return $bd4b1dc9807d6e1d$var$__awaiter(_this, void 0, void 0, function() {
                    var user;
                    var _this = this;
                    return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                $bd4b1dc9807d6e1d$var$logger.debug('OAuth signIn in progress, waiting for resolution...');
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            $bd4b1dc9807d6e1d$var$logger.debug('OAuth signIn in progress timeout');
                                            (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).remove('auth', hostedUISignCallback);
                                            res();
                                        }, $bd4b1dc9807d6e1d$var$OAUTH_FLOW_MS_TIMEOUT);
                                        (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).listen('auth', hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === 'cognitoHostedUI' || event === 'cognitoHostedUI_failure') {
                                                $bd4b1dc9807d6e1d$var$logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).remove('auth', hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    $bd4b1dc9807d6e1d$var$logger.debug('Failed to get user from user pool');
                                    rej('No current user');
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                // refresh the session if the session expired.
                                user.getSession(function(err, session) {
                                    return $bd4b1dc9807d6e1d$var$__awaiter(_this, void 0, void 0, function() {
                                        var bypassCache, _a, scope;
                                        var _this = this;
                                        return $bd4b1dc9807d6e1d$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    if (err) {
                                                        $bd4b1dc9807d6e1d$var$logger.debug('Failed to get the user session', err);
                                                        rej(err);
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    bypassCache = params ? params.bypassCache : false;
                                                    if (!bypassCache) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.Credentials.clear()
                                                    ];
                                                case 1:
                                                    _b.sent();
                                                    _b.label = 2;
                                                case 2:
                                                    _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                                    if (scope.split(' ').includes($bd4b1dc9807d6e1d$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                                        if (err) {
                                                            $bd4b1dc9807d6e1d$var$logger.debug('getting user data failed', err);
                                                            // Make sure the user is still valid
                                                            if (err.message === 'User is disabled.' || err.message === 'User does not exist.' || err.message === 'Access Token has been revoked' // Session revoked by another app
                                                            ) rej(err);
                                                            else // the error may also be thrown when lack of permissions to get user info etc
                                                            // in that case we just bypass the error
                                                            res(user);
                                                            return;
                                                        }
                                                        var preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                        var attributeList = [];
                                                        for(var i = 0; i < data.UserAttributes.length; i++){
                                                            var attribute = {
                                                                Name: data.UserAttributes[i].Name,
                                                                Value: data.UserAttributes[i].Value
                                                            };
                                                            var userAttribute = new (0, $450f14f977aaa6d2$export$2e2bcd8739ae039)(attribute);
                                                            attributeList.push(userAttribute);
                                                        }
                                                        var attributes = _this.attributesToObject(attributeList);
                                                        Object.assign(user, {
                                                            attributes: attributes,
                                                            preferredMFA: preferredMFA
                                                        });
                                                        return res(user);
                                                    }, {
                                                        bypassCache: bypassCache
                                                    });
                                                    else {
                                                        $bd4b1dc9807d6e1d$var$logger.debug("Unable to get the user data because the " + $bd4b1dc9807d6e1d$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                                        return [
                                                            2 /*return*/ ,
                                                            res(user)
                                                        ];
                                                    }
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                $bd4b1dc9807d6e1d$var$logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_5, federatedInfo, user, e_6;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $bd4b1dc9807d6e1d$var$logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_5 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('Failed to sync cache info into memory', e_5);
                        throw e_5;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) federatedUser = $bd4b1dc9807d6e1d$var$__assign($bd4b1dc9807d6e1d$var$__assign({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            $bd4b1dc9807d6e1d$var$logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $bd4b1dc9807d6e1d$var$logger.debug('get current authenticated federated user', this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $bd4b1dc9807d6e1d$var$logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_6 = _a.sent();
                        if (e_6 === 'No userPool') $bd4b1dc9807d6e1d$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $bd4b1dc9807d6e1d$var$logger.debug('The user is not authenticated by the error', e_6);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $bd4b1dc9807d6e1d$var$logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject();
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $bd4b1dc9807d6e1d$var$logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $bd4b1dc9807d6e1d$var$logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        if (!user) {
            $bd4b1dc9807d6e1d$var$logger.debug('the user is null');
            return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).NoUserSession);
        }
        return new Promise(function(resolve, reject) {
            $bd4b1dc9807d6e1d$var$logger.debug('Getting the session from this user:', user);
            user.getSession(function(err, session) {
                if (err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('Failed to get the session from user', user);
                    reject(err);
                    return;
                } else {
                    $bd4b1dc9807d6e1d$var$logger.debug('Succeed to get the user session', session);
                    resolve(session);
                    return;
                }
            });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var e_7, federatedInfo;
            var _this = this;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $bd4b1dc9807d6e1d$var$logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('Failed to sync cache info into memory', e_7);
                        throw e_7;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        } catch (e) {
                            $bd4b1dc9807d6e1d$var$logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $bd4b1dc9807d6e1d$var$logger.debug('getting session success', session);
                                return _this.Credentials.set(session, 'session');
                            }).catch(function(error) {
                                $bd4b1dc9807d6e1d$var$logger.debug('getting session failed', error);
                                return _this.Credentials.set(null, 'guest');
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $bd4b1dc9807d6e1d$var$logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function() {
                    return resolve();
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var e_8, isSignedInHostedUI;
            var _this = this;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_8 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('Failed to sync cache info into memory', e_8);
                        throw e_8;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $bd4b1dc9807d6e1d$var$logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    user.getSession(function(err, result) {
                                        if (err) {
                                            $bd4b1dc9807d6e1d$var$logger.debug('failed to get the user session', err);
                                            return rej(err);
                                        }
                                        user.globalSignOut({
                                            onSuccess: function(data) {
                                                $bd4b1dc9807d6e1d$var$logger.debug('global sign out success');
                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                else return res();
                                            },
                                            onFailure: function(err) {
                                                $bd4b1dc9807d6e1d$var$logger.debug('global sign out failed', err);
                                                return rej(err);
                                            }
                                        });
                                    });
                                } else {
                                    $bd4b1dc9807d6e1d$var$logger.debug('user sign out', user);
                                    user.signOut();
                                    if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                    else return res();
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, $4635c76aed896f54$export$174a40858393256b).browserOrNode().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject('Signout timeout fail');
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var e_9, user;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_9 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $bd4b1dc9807d6e1d$var$logger.debug('no current Cognito user');
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $bd4b1dc9807d6e1d$var$logger.debug('no Congito User pool');
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $bd4b1dc9807d6e1d$var$logger.debug('change password failure', err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$logger.debug('forgot password failure', err);
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyCode);
        if (!password) return this.rejectAuthError((0, $dff78461fb02b1c9$export$edb367c0a140d3db).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function() {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $bd4b1dc9807d6e1d$var$dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_10, info, err_1, user;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $bd4b1dc9807d6e1d$var$logger.debug(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_10 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('Failed to retrieve credentials while getting current user info', e_10);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('currentUserInfo error', err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $dff78461fb02b1c9$export$9b905d6895bdc426)(providerOrOptions) || (0, $dff78461fb02b1c9$export$828f8efbdf71714b)(providerOrOptions) || (0, $dff78461fb02b1c9$export$6bae5520ca265d22)(providerOrOptions) || typeof providerOrOptions === 'undefined')) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, $dff78461fb02b1c9$export$eeb013770cb92342).Cognito
                        };
                        provider = (0, $dff78461fb02b1c9$export$9b905d6895bdc426)(options) ? options.provider : options.customProvider;
                        customState = (0, $dff78461fb02b1c9$export$9b905d6895bdc426)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $dff78461fb02b1c9$export$b380f8ec78ef17c8)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) $bd4b1dc9807d6e1d$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, 'federation')
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        $bd4b1dc9807d6e1d$var$logger.debug('federated sign in credentials', credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $bd4b1dc9807d6e1d$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $bd4b1dc9807d6e1d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            $bd4b1dc9807d6e1d$var$logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('parsingCallbackUrl', {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $4635c76aed896f54$export$174a40858393256b).browserOrNode().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!((0, $adm0U.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $bd4b1dc9807d6e1d$var$__read(_a, 1), k = _b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!((0, $adm0U.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _b = $bd4b1dc9807d6e1d$var$__read(_a, 1), k = _b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $efbb3a8ba4d8142b$export$2e2bcd8739ae039)({
                            IdToken: new (0, $5fb203a9a4ab7ad3$export$2e2bcd8739ae039)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $eaf04386920ddc0c$export$2e2bcd8739ae039)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $68963592e483da60$export$2e2bcd8739ae039)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, 'session')
                        ];
                    case 4:
                        credentials = _b.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split('-').splice(1).join('-');
                            $bd4b1dc9807d6e1d$var$dispatchAuthEvent('customOAuthState', (0, $7e996bbbae522d0e$export$a7ea17e93539f9a5)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_2 = _b.sent();
                        $bd4b1dc9807d6e1d$var$logger.debug('Error in cognito hosted auth response', err_2);
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('signIn_failure', err_2, "The OAuth response flow failed");
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('cognitoHostedUI_failure', err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $bd4b1dc9807d6e1d$var$dispatchAuthEvent('customState_failure', err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === 'email_verified' || attribute.Name === 'phone_number_verified') obj[attribute.Name] = attribute.Value === 'true' || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $fca85d3307cddf9a$export$2e2bcd8739ae039)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === 'function' && typeof obj.setItem === 'function' && typeof obj.removeItem === 'function' && typeof obj.clear === 'function';
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $dff78461fb02b1c9$export$edb367c0a140d3db).MissingAuthConfig;
        }
        return (0, $dff78461fb02b1c9$export$edb367c0a140d3db).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $d294b72bf558c321$export$145273558d58e0ac)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $d294b72bf558c321$export$71192787e041818c)(type));
    };
    return AuthClass;
}();
var $bd4b1dc9807d6e1d$export$334c29725a78c21d = new $bd4b1dc9807d6e1d$export$eeff9d1a8b8c057b(null);
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).register($bd4b1dc9807d6e1d$export$334c29725a78c21d);





var /**
 * @deprecated use named import
 */ $e5a347d28ba453e7$export$2e2bcd8739ae039 = (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d);


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $eca0a81f3bf7d24e$export$f84bd70098573c5c = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $59e04b8bcc93b29e$export$a2bd19c49e4760e8)().getStorage()
};
function $eca0a81f3bf7d24e$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $eca0a81f3bf7d24e$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $eca0a81f3bf7d24e$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $eca0a81f3bf7d24e$var$_isInteger(value);
}
function $eca0a81f3bf7d24e$var$_isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $eca0a81f3bf7d24e$var$store = {};
var $eca0a81f3bf7d24e$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $eca0a81f3bf7d24e$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $eca0a81f3bf7d24e$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $eca0a81f3bf7d24e$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $eca0a81f3bf7d24e$var$store[key];
    };
    return CacheObject;
}();


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $c373c1ef5ac5aa80$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('StorageCache');
/**
 * Initialization of the cache
 *
 */ var $c373c1ef5ac5aa80$export$947ed1997bd112b4 = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $eca0a81f3bf7d24e$export$a287f47fed4544b8)(this.config.capacityInBytes)) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).capacityInBytes;
        }
        if (!(0, $eca0a81f3bf7d24e$export$a287f47fed4544b8)(this.config.itemMaxSize)) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).itemMaxSize;
        }
        if (!(0, $eca0a81f3bf7d24e$export$a287f47fed4544b8)(this.config.defaultTTL)) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).defaultTTL;
        }
        if (!(0, $eca0a81f3bf7d24e$export$a287f47fed4544b8)(this.config.defaultPriority)) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $c373c1ef5ac5aa80$var$logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $c373c1ef5ac5aa80$var$logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a)(),
            visitedTime: (0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $eca0a81f3bf7d24e$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $eca0a81f3bf7d24e$export$cc8c3b705bb8e6e2)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $c373c1ef5ac5aa80$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var /**
 * @deprecated use named import
 */ $c373c1ef5ac5aa80$export$2e2bcd8739ae039 = $c373c1ef5ac5aa80$export$947ed1997bd112b4;



var $ad2c5b0d421876d2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ad2c5b0d421876d2$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $ad2c5b0d421876d2$export$e6fda0405fa98d6d = /** @class */ function(_super) {
    $ad2c5b0d421876d2$var$__extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c), config) : (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $ad2c5b0d421876d2$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        $ad2c5b0d421876d2$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $ad2c5b0d421876d2$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            $ad2c5b0d421876d2$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $ad2c5b0d421876d2$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $ad2c5b0d421876d2$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $ad2c5b0d421876d2$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        $ad2c5b0d421876d2$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $ad2c5b0d421876d2$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $ad2c5b0d421876d2$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        $ad2c5b0d421876d2$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $ad2c5b0d421876d2$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        $ad2c5b0d421876d2$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $ad2c5b0d421876d2$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $eca0a81f3bf7d24e$export$f84bd70098573c5c).keyPrefix) {
            $ad2c5b0d421876d2$var$logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, $eca0a81f3bf7d24e$export$dd144842d7b22d3a).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, $c373c1ef5ac5aa80$export$947ed1997bd112b4));
var $ad2c5b0d421876d2$export$2a9787695d97e2c4 = new $ad2c5b0d421876d2$export$e6fda0405fa98d6d();
var /**
 * @deprecated use named import
 */ $ad2c5b0d421876d2$export$2e2bcd8739ae039 = $ad2c5b0d421876d2$export$2a9787695d97e2c4;



var /**
 * @deprecated use named import
 */ $6d9ebea818722de7$export$2e2bcd8739ae039 = (0, $ad2c5b0d421876d2$export$2a9787695d97e2c4);
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).register((0, $ad2c5b0d421876d2$export$2a9787695d97e2c4));



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 




var $3a0334eddcbe8749$export$ff1e75b1e93a2588;
(function(AbortIncompleteMultipartUpload) {
    AbortIncompleteMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ff1e75b1e93a2588 || ($3a0334eddcbe8749$export$ff1e75b1e93a2588 = {}));
var $3a0334eddcbe8749$export$80a5621784397e06;
(function(AbortMultipartUploadOutput) {
    AbortMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$80a5621784397e06 || ($3a0334eddcbe8749$export$80a5621784397e06 = {}));
var $3a0334eddcbe8749$export$2509116d04cdd782;
(function(AbortMultipartUploadRequest) {
    AbortMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2509116d04cdd782 || ($3a0334eddcbe8749$export$2509116d04cdd782 = {}));
var $3a0334eddcbe8749$export$1de06065cff890a8;
(function(NoSuchUpload) {
    NoSuchUpload.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$1de06065cff890a8 || ($3a0334eddcbe8749$export$1de06065cff890a8 = {}));
var $3a0334eddcbe8749$export$b73224f1e3e6ea55;
(function(AccelerateConfiguration) {
    AccelerateConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b73224f1e3e6ea55 || ($3a0334eddcbe8749$export$b73224f1e3e6ea55 = {}));
var $3a0334eddcbe8749$export$4882adf346b33e1a;
(function(Grantee) {
    Grantee.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4882adf346b33e1a || ($3a0334eddcbe8749$export$4882adf346b33e1a = {}));
var $3a0334eddcbe8749$export$16844950929e022f;
(function(Grant) {
    Grant.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$16844950929e022f || ($3a0334eddcbe8749$export$16844950929e022f = {}));
var $3a0334eddcbe8749$export$25fb39c3824c9c44;
(function(Owner) {
    Owner.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$25fb39c3824c9c44 || ($3a0334eddcbe8749$export$25fb39c3824c9c44 = {}));
var $3a0334eddcbe8749$export$6a42fa102a072c77;
(function(AccessControlPolicy) {
    AccessControlPolicy.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$6a42fa102a072c77 || ($3a0334eddcbe8749$export$6a42fa102a072c77 = {}));
var $3a0334eddcbe8749$export$3db5322b6b5badd4;
(function(AccessControlTranslation) {
    AccessControlTranslation.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3db5322b6b5badd4 || ($3a0334eddcbe8749$export$3db5322b6b5badd4 = {}));
var $3a0334eddcbe8749$export$edcc5df28126c9bc;
(function(CompleteMultipartUploadOutput) {
    CompleteMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$edcc5df28126c9bc || ($3a0334eddcbe8749$export$edcc5df28126c9bc = {}));
var $3a0334eddcbe8749$export$76f56660c9039ec5;
(function(CompletedPart) {
    CompletedPart.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$76f56660c9039ec5 || ($3a0334eddcbe8749$export$76f56660c9039ec5 = {}));
var $3a0334eddcbe8749$export$394f3a16361c2a83;
(function(CompletedMultipartUpload) {
    CompletedMultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$394f3a16361c2a83 || ($3a0334eddcbe8749$export$394f3a16361c2a83 = {}));
var $3a0334eddcbe8749$export$2998881f143b41ec;
(function(CompleteMultipartUploadRequest) {
    CompleteMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2998881f143b41ec || ($3a0334eddcbe8749$export$2998881f143b41ec = {}));
var $3a0334eddcbe8749$export$32f1916074d2607f;
(function(CopyObjectResult) {
    CopyObjectResult.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$32f1916074d2607f || ($3a0334eddcbe8749$export$32f1916074d2607f = {}));
var $3a0334eddcbe8749$export$a9f99871811ebc49;
(function(CopyObjectOutput) {
    CopyObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$a9f99871811ebc49 || ($3a0334eddcbe8749$export$a9f99871811ebc49 = {}));
var $3a0334eddcbe8749$export$e84f0e76c8b259eb;
(function(CopyObjectRequest) {
    CopyObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$e84f0e76c8b259eb || ($3a0334eddcbe8749$export$e84f0e76c8b259eb = {}));
var $3a0334eddcbe8749$export$77615b2f7cde9dd7;
(function(ObjectNotInActiveTierError) {
    ObjectNotInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$77615b2f7cde9dd7 || ($3a0334eddcbe8749$export$77615b2f7cde9dd7 = {}));
var $3a0334eddcbe8749$export$b6b374c2bfd60422;
(function(BucketAlreadyExists) {
    BucketAlreadyExists.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b6b374c2bfd60422 || ($3a0334eddcbe8749$export$b6b374c2bfd60422 = {}));
var $3a0334eddcbe8749$export$3d44152d602e5b07;
(function(BucketAlreadyOwnedByYou) {
    BucketAlreadyOwnedByYou.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3d44152d602e5b07 || ($3a0334eddcbe8749$export$3d44152d602e5b07 = {}));
var $3a0334eddcbe8749$export$b9395efd4905ea2f;
(function(CreateBucketOutput) {
    CreateBucketOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b9395efd4905ea2f || ($3a0334eddcbe8749$export$b9395efd4905ea2f = {}));
var $3a0334eddcbe8749$export$80fb9034e13a84f5;
(function(CreateBucketConfiguration) {
    CreateBucketConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$80fb9034e13a84f5 || ($3a0334eddcbe8749$export$80fb9034e13a84f5 = {}));
var $3a0334eddcbe8749$export$8aca1806c1d8d130;
(function(CreateBucketRequest) {
    CreateBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8aca1806c1d8d130 || ($3a0334eddcbe8749$export$8aca1806c1d8d130 = {}));
var $3a0334eddcbe8749$export$196bb0482ff68428;
(function(CreateMultipartUploadOutput) {
    CreateMultipartUploadOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$196bb0482ff68428 || ($3a0334eddcbe8749$export$196bb0482ff68428 = {}));
var $3a0334eddcbe8749$export$f65faae2a46e45c2;
(function(CreateMultipartUploadRequest) {
    CreateMultipartUploadRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$f65faae2a46e45c2 || ($3a0334eddcbe8749$export$f65faae2a46e45c2 = {}));
var $3a0334eddcbe8749$export$8b74a2c46a921740;
(function(DeleteBucketRequest) {
    DeleteBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8b74a2c46a921740 || ($3a0334eddcbe8749$export$8b74a2c46a921740 = {}));
var $3a0334eddcbe8749$export$c5ab088f35618173;
(function(DeleteBucketAnalyticsConfigurationRequest) {
    DeleteBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c5ab088f35618173 || ($3a0334eddcbe8749$export$c5ab088f35618173 = {}));
var $3a0334eddcbe8749$export$eedf1d80102f9cff;
(function(DeleteBucketCorsRequest) {
    DeleteBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$eedf1d80102f9cff || ($3a0334eddcbe8749$export$eedf1d80102f9cff = {}));
var $3a0334eddcbe8749$export$67cbcb88080a155a;
(function(DeleteBucketEncryptionRequest) {
    DeleteBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$67cbcb88080a155a || ($3a0334eddcbe8749$export$67cbcb88080a155a = {}));
var $3a0334eddcbe8749$export$3603c2e1b3558471;
(function(DeleteBucketInventoryConfigurationRequest) {
    DeleteBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3603c2e1b3558471 || ($3a0334eddcbe8749$export$3603c2e1b3558471 = {}));
var $3a0334eddcbe8749$export$6c38b78c3c77b60c;
(function(DeleteBucketLifecycleRequest) {
    DeleteBucketLifecycleRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$6c38b78c3c77b60c || ($3a0334eddcbe8749$export$6c38b78c3c77b60c = {}));
var $3a0334eddcbe8749$export$ff4b8fc3fb36fbd;
(function(DeleteBucketMetricsConfigurationRequest) {
    DeleteBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ff4b8fc3fb36fbd || ($3a0334eddcbe8749$export$ff4b8fc3fb36fbd = {}));
var $3a0334eddcbe8749$export$4c49e000fa5b0b86;
(function(DeleteBucketOwnershipControlsRequest) {
    DeleteBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4c49e000fa5b0b86 || ($3a0334eddcbe8749$export$4c49e000fa5b0b86 = {}));
var $3a0334eddcbe8749$export$cce16146386a1316;
(function(DeleteBucketPolicyRequest) {
    DeleteBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cce16146386a1316 || ($3a0334eddcbe8749$export$cce16146386a1316 = {}));
var $3a0334eddcbe8749$export$238256546e65e80f;
(function(DeleteBucketReplicationRequest) {
    DeleteBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$238256546e65e80f || ($3a0334eddcbe8749$export$238256546e65e80f = {}));
var $3a0334eddcbe8749$export$e9cefd124b305be3;
(function(DeleteBucketTaggingRequest) {
    DeleteBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e9cefd124b305be3 || ($3a0334eddcbe8749$export$e9cefd124b305be3 = {}));
var $3a0334eddcbe8749$export$15e654f934b26a7b;
(function(DeleteBucketWebsiteRequest) {
    DeleteBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$15e654f934b26a7b || ($3a0334eddcbe8749$export$15e654f934b26a7b = {}));
var $3a0334eddcbe8749$export$64d4f4fac943bc25;
(function(DeleteObjectOutput) {
    DeleteObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$64d4f4fac943bc25 || ($3a0334eddcbe8749$export$64d4f4fac943bc25 = {}));
var $3a0334eddcbe8749$export$7d123f24a24f15cf;
(function(DeleteObjectRequest) {
    DeleteObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$7d123f24a24f15cf || ($3a0334eddcbe8749$export$7d123f24a24f15cf = {}));
var $3a0334eddcbe8749$export$d17347461b0f9a2b;
(function(DeletedObject) {
    DeletedObject.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d17347461b0f9a2b || ($3a0334eddcbe8749$export$d17347461b0f9a2b = {}));
var $3a0334eddcbe8749$export$afd90478dc782af0;
(function(_Error) {
    _Error.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$afd90478dc782af0 || ($3a0334eddcbe8749$export$afd90478dc782af0 = {}));
var $3a0334eddcbe8749$export$e1c86a39185a896f;
(function(DeleteObjectsOutput) {
    DeleteObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e1c86a39185a896f || ($3a0334eddcbe8749$export$e1c86a39185a896f = {}));
var $3a0334eddcbe8749$export$84d9d258efc6700d;
(function(ObjectIdentifier) {
    ObjectIdentifier.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$84d9d258efc6700d || ($3a0334eddcbe8749$export$84d9d258efc6700d = {}));
var $3a0334eddcbe8749$export$bfadae053a633538;
(function(Delete) {
    Delete.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$bfadae053a633538 || ($3a0334eddcbe8749$export$bfadae053a633538 = {}));
var $3a0334eddcbe8749$export$c19f81fd3ccd8fc2;
(function(DeleteObjectsRequest) {
    DeleteObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c19f81fd3ccd8fc2 || ($3a0334eddcbe8749$export$c19f81fd3ccd8fc2 = {}));
var $3a0334eddcbe8749$export$4d816bf2553d6082;
(function(DeleteObjectTaggingOutput) {
    DeleteObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4d816bf2553d6082 || ($3a0334eddcbe8749$export$4d816bf2553d6082 = {}));
var $3a0334eddcbe8749$export$2d561b57455087e8;
(function(DeleteObjectTaggingRequest) {
    DeleteObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2d561b57455087e8 || ($3a0334eddcbe8749$export$2d561b57455087e8 = {}));
var $3a0334eddcbe8749$export$cac29ea1b5d93b5d;
(function(DeletePublicAccessBlockRequest) {
    DeletePublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cac29ea1b5d93b5d || ($3a0334eddcbe8749$export$cac29ea1b5d93b5d = {}));
var $3a0334eddcbe8749$export$d592399f8c69d061;
(function(GetBucketAccelerateConfigurationOutput) {
    GetBucketAccelerateConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d592399f8c69d061 || ($3a0334eddcbe8749$export$d592399f8c69d061 = {}));
var $3a0334eddcbe8749$export$c2ed0589b585987a;
(function(GetBucketAccelerateConfigurationRequest) {
    GetBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c2ed0589b585987a || ($3a0334eddcbe8749$export$c2ed0589b585987a = {}));
var $3a0334eddcbe8749$export$1e656ec1fa0dbccd;
(function(GetBucketAclOutput) {
    GetBucketAclOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$1e656ec1fa0dbccd || ($3a0334eddcbe8749$export$1e656ec1fa0dbccd = {}));
var $3a0334eddcbe8749$export$5543bf3f517c214;
(function(GetBucketAclRequest) {
    GetBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$5543bf3f517c214 || ($3a0334eddcbe8749$export$5543bf3f517c214 = {}));
var $3a0334eddcbe8749$export$3288d34c523a1192;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3288d34c523a1192 || ($3a0334eddcbe8749$export$3288d34c523a1192 = {}));
var $3a0334eddcbe8749$export$b9ae9bceb2811d5d;
(function(AnalyticsAndOperator) {
    AnalyticsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b9ae9bceb2811d5d || ($3a0334eddcbe8749$export$b9ae9bceb2811d5d = {}));
var $3a0334eddcbe8749$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c9ec61557dcb764a || ($3a0334eddcbe8749$export$c9ec61557dcb764a = {}));
var $3a0334eddcbe8749$export$fc566d9f8f854701;
(function(AnalyticsS3BucketDestination) {
    AnalyticsS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$fc566d9f8f854701 || ($3a0334eddcbe8749$export$fc566d9f8f854701 = {}));
var $3a0334eddcbe8749$export$20f751b8dcd24833;
(function(AnalyticsExportDestination) {
    AnalyticsExportDestination.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$20f751b8dcd24833 || ($3a0334eddcbe8749$export$20f751b8dcd24833 = {}));
var $3a0334eddcbe8749$export$a14156deb587d512;
(function(StorageClassAnalysisDataExport) {
    StorageClassAnalysisDataExport.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a14156deb587d512 || ($3a0334eddcbe8749$export$a14156deb587d512 = {}));
var $3a0334eddcbe8749$export$13f5184561469c95;
(function(StorageClassAnalysis) {
    StorageClassAnalysis.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$13f5184561469c95 || ($3a0334eddcbe8749$export$13f5184561469c95 = {}));
var $3a0334eddcbe8749$export$15f94404a081a771;
(function(AnalyticsConfiguration) {
    AnalyticsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$15f94404a081a771 || ($3a0334eddcbe8749$export$15f94404a081a771 = {}));
var $3a0334eddcbe8749$export$32ac99bb59e9ea35;
(function(GetBucketAnalyticsConfigurationOutput) {
    GetBucketAnalyticsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$32ac99bb59e9ea35 || ($3a0334eddcbe8749$export$32ac99bb59e9ea35 = {}));
var $3a0334eddcbe8749$export$a4b635f541d39c02;
(function(GetBucketAnalyticsConfigurationRequest) {
    GetBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a4b635f541d39c02 || ($3a0334eddcbe8749$export$a4b635f541d39c02 = {}));
var $3a0334eddcbe8749$export$483798435237259b;
(function(CORSRule) {
    CORSRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$483798435237259b || ($3a0334eddcbe8749$export$483798435237259b = {}));
var $3a0334eddcbe8749$export$3ff8c9c489aa7ab5;
(function(GetBucketCorsOutput) {
    GetBucketCorsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3ff8c9c489aa7ab5 || ($3a0334eddcbe8749$export$3ff8c9c489aa7ab5 = {}));
var $3a0334eddcbe8749$export$cdc36c4a20d66833;
(function(GetBucketCorsRequest) {
    GetBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cdc36c4a20d66833 || ($3a0334eddcbe8749$export$cdc36c4a20d66833 = {}));
var $3a0334eddcbe8749$export$5e055b8b357210fd;
(function(ServerSideEncryptionByDefault) {
    ServerSideEncryptionByDefault.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$5e055b8b357210fd || ($3a0334eddcbe8749$export$5e055b8b357210fd = {}));
var $3a0334eddcbe8749$export$614e3b57594b8702;
(function(ServerSideEncryptionRule) {
    ServerSideEncryptionRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $3a0334eddcbe8749$export$5e055b8b357210fd.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
        });
    };
})($3a0334eddcbe8749$export$614e3b57594b8702 || ($3a0334eddcbe8749$export$614e3b57594b8702 = {}));
var $3a0334eddcbe8749$export$d53e5f9e3c3507bf;
(function(ServerSideEncryptionConfiguration) {
    ServerSideEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Rules && {
            Rules: obj.Rules.map(function(item) {
                return $3a0334eddcbe8749$export$614e3b57594b8702.filterSensitiveLog(item);
            })
        });
    };
})($3a0334eddcbe8749$export$d53e5f9e3c3507bf || ($3a0334eddcbe8749$export$d53e5f9e3c3507bf = {}));
var $3a0334eddcbe8749$export$a5d815db4065bb4e;
(function(GetBucketEncryptionOutput) {
    GetBucketEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $3a0334eddcbe8749$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($3a0334eddcbe8749$export$a5d815db4065bb4e || ($3a0334eddcbe8749$export$a5d815db4065bb4e = {}));
var $3a0334eddcbe8749$export$3871e35cee114580;
(function(GetBucketEncryptionRequest) {
    GetBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3871e35cee114580 || ($3a0334eddcbe8749$export$3871e35cee114580 = {}));
var $3a0334eddcbe8749$export$51ca0161a096cac2;
(function(SSEKMS) {
    SSEKMS.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.KeyId && {
            KeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$51ca0161a096cac2 || ($3a0334eddcbe8749$export$51ca0161a096cac2 = {}));
var $3a0334eddcbe8749$export$e6fda754462bc5e9;
(function(SSES3) {
    SSES3.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e6fda754462bc5e9 || ($3a0334eddcbe8749$export$e6fda754462bc5e9 = {}));
var $3a0334eddcbe8749$export$4507106f7965dad8;
(function(InventoryEncryption) {
    InventoryEncryption.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMS && {
            SSEKMS: $3a0334eddcbe8749$export$51ca0161a096cac2.filterSensitiveLog(obj.SSEKMS)
        });
    };
})($3a0334eddcbe8749$export$4507106f7965dad8 || ($3a0334eddcbe8749$export$4507106f7965dad8 = {}));
var $3a0334eddcbe8749$export$dbf61758afa382d2;
(function(InventoryS3BucketDestination) {
    InventoryS3BucketDestination.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: $3a0334eddcbe8749$export$4507106f7965dad8.filterSensitiveLog(obj.Encryption)
        });
    };
})($3a0334eddcbe8749$export$dbf61758afa382d2 || ($3a0334eddcbe8749$export$dbf61758afa382d2 = {}));
var $3a0334eddcbe8749$export$95a07687ea92cc86;
(function(InventoryDestination) {
    InventoryDestination.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.S3BucketDestination && {
            S3BucketDestination: $3a0334eddcbe8749$export$dbf61758afa382d2.filterSensitiveLog(obj.S3BucketDestination)
        });
    };
})($3a0334eddcbe8749$export$95a07687ea92cc86 || ($3a0334eddcbe8749$export$95a07687ea92cc86 = {}));
var $3a0334eddcbe8749$export$9cab1f8eb4898ac3;
(function(InventoryFilter) {
    InventoryFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$9cab1f8eb4898ac3 || ($3a0334eddcbe8749$export$9cab1f8eb4898ac3 = {}));
var $3a0334eddcbe8749$export$80a40dd3d0e79f33;
(function(InventorySchedule) {
    InventorySchedule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$80a40dd3d0e79f33 || ($3a0334eddcbe8749$export$80a40dd3d0e79f33 = {}));
var $3a0334eddcbe8749$export$e13e8ea2fe7b5717;
(function(InventoryConfiguration) {
    InventoryConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Destination && {
            Destination: $3a0334eddcbe8749$export$95a07687ea92cc86.filterSensitiveLog(obj.Destination)
        });
    };
})($3a0334eddcbe8749$export$e13e8ea2fe7b5717 || ($3a0334eddcbe8749$export$e13e8ea2fe7b5717 = {}));
var $3a0334eddcbe8749$export$4b7c0b968f94593a;
(function(GetBucketInventoryConfigurationOutput) {
    GetBucketInventoryConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $3a0334eddcbe8749$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($3a0334eddcbe8749$export$4b7c0b968f94593a || ($3a0334eddcbe8749$export$4b7c0b968f94593a = {}));
var $3a0334eddcbe8749$export$2bcb6519092e8dbf;
(function(GetBucketInventoryConfigurationRequest) {
    GetBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2bcb6519092e8dbf || ($3a0334eddcbe8749$export$2bcb6519092e8dbf = {}));
var $3a0334eddcbe8749$export$87e69778058ef73d;
(function(LifecycleExpiration) {
    LifecycleExpiration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$87e69778058ef73d || ($3a0334eddcbe8749$export$87e69778058ef73d = {}));
var $3a0334eddcbe8749$export$70a8e907770d2a36;
(function(LifecycleRuleAndOperator) {
    LifecycleRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$70a8e907770d2a36 || ($3a0334eddcbe8749$export$70a8e907770d2a36 = {}));
var $3a0334eddcbe8749$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4338dba1e93ddaf4 || ($3a0334eddcbe8749$export$4338dba1e93ddaf4 = {}));
var $3a0334eddcbe8749$export$a99742a437d0fdf9;
(function(NoncurrentVersionExpiration) {
    NoncurrentVersionExpiration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a99742a437d0fdf9 || ($3a0334eddcbe8749$export$a99742a437d0fdf9 = {}));
var $3a0334eddcbe8749$export$9250e73c985ce931;
(function(NoncurrentVersionTransition) {
    NoncurrentVersionTransition.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$9250e73c985ce931 || ($3a0334eddcbe8749$export$9250e73c985ce931 = {}));
var $3a0334eddcbe8749$export$be58926105124dd4;
(function(Transition) {
    Transition.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$be58926105124dd4 || ($3a0334eddcbe8749$export$be58926105124dd4 = {}));
var $3a0334eddcbe8749$export$1ac30bbe41f1f9ef;
(function(LifecycleRule) {
    LifecycleRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$1ac30bbe41f1f9ef || ($3a0334eddcbe8749$export$1ac30bbe41f1f9ef = {}));
var $3a0334eddcbe8749$export$f2f23f80c8c1c7c4;
(function(GetBucketLifecycleConfigurationOutput) {
    GetBucketLifecycleConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f2f23f80c8c1c7c4 || ($3a0334eddcbe8749$export$f2f23f80c8c1c7c4 = {}));
var $3a0334eddcbe8749$export$86e3489ab08ca98d;
(function(GetBucketLifecycleConfigurationRequest) {
    GetBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$86e3489ab08ca98d || ($3a0334eddcbe8749$export$86e3489ab08ca98d = {}));
var $3a0334eddcbe8749$export$ed9828a2500d585f;
(function(GetBucketLocationOutput) {
    GetBucketLocationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ed9828a2500d585f || ($3a0334eddcbe8749$export$ed9828a2500d585f = {}));
var $3a0334eddcbe8749$export$4109a69a89893a5d;
(function(GetBucketLocationRequest) {
    GetBucketLocationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4109a69a89893a5d || ($3a0334eddcbe8749$export$4109a69a89893a5d = {}));
var $3a0334eddcbe8749$export$cf4abd6ae8fde913;
(function(TargetGrant) {
    TargetGrant.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cf4abd6ae8fde913 || ($3a0334eddcbe8749$export$cf4abd6ae8fde913 = {}));
var $3a0334eddcbe8749$export$a1484d354b9c56b2;
(function(LoggingEnabled) {
    LoggingEnabled.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a1484d354b9c56b2 || ($3a0334eddcbe8749$export$a1484d354b9c56b2 = {}));
var $3a0334eddcbe8749$export$f9d2a0e32a2aa91f;
(function(GetBucketLoggingOutput) {
    GetBucketLoggingOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f9d2a0e32a2aa91f || ($3a0334eddcbe8749$export$f9d2a0e32a2aa91f = {}));
var $3a0334eddcbe8749$export$182d23383f8b69bd;
(function(GetBucketLoggingRequest) {
    GetBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$182d23383f8b69bd || ($3a0334eddcbe8749$export$182d23383f8b69bd = {}));
var $3a0334eddcbe8749$export$4774797e6eda832;
(function(MetricsAndOperator) {
    MetricsAndOperator.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4774797e6eda832 || ($3a0334eddcbe8749$export$4774797e6eda832 = {}));
var $3a0334eddcbe8749$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$564a1f9c338cae45 || ($3a0334eddcbe8749$export$564a1f9c338cae45 = {}));
var $3a0334eddcbe8749$export$908bafa154008a5e;
(function(MetricsConfiguration) {
    MetricsConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$908bafa154008a5e || ($3a0334eddcbe8749$export$908bafa154008a5e = {}));
var $3a0334eddcbe8749$export$a52baffc56d738d2;
(function(GetBucketMetricsConfigurationOutput) {
    GetBucketMetricsConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a52baffc56d738d2 || ($3a0334eddcbe8749$export$a52baffc56d738d2 = {}));
var $3a0334eddcbe8749$export$af907f7627ae4ae9;
(function(GetBucketMetricsConfigurationRequest) {
    GetBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$af907f7627ae4ae9 || ($3a0334eddcbe8749$export$af907f7627ae4ae9 = {}));
var $3a0334eddcbe8749$export$f00ac87a35076252;
(function(GetBucketNotificationConfigurationRequest) {
    GetBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f00ac87a35076252 || ($3a0334eddcbe8749$export$f00ac87a35076252 = {}));
var $3a0334eddcbe8749$export$74fc6120f048b9bc;
(function(FilterRule) {
    FilterRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$74fc6120f048b9bc || ($3a0334eddcbe8749$export$74fc6120f048b9bc = {}));
var $3a0334eddcbe8749$export$46101b74c47ec83a;
(function(S3KeyFilter) {
    S3KeyFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$46101b74c47ec83a || ($3a0334eddcbe8749$export$46101b74c47ec83a = {}));
var $3a0334eddcbe8749$export$c3d4fc0e09105ced;
(function(NotificationConfigurationFilter) {
    NotificationConfigurationFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c3d4fc0e09105ced || ($3a0334eddcbe8749$export$c3d4fc0e09105ced = {}));
var $3a0334eddcbe8749$export$4916e52bc544d4ef;
(function(LambdaFunctionConfiguration) {
    LambdaFunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4916e52bc544d4ef || ($3a0334eddcbe8749$export$4916e52bc544d4ef = {}));
var $3a0334eddcbe8749$export$b48f9efe98802c25;
(function(QueueConfiguration) {
    QueueConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b48f9efe98802c25 || ($3a0334eddcbe8749$export$b48f9efe98802c25 = {}));
var $3a0334eddcbe8749$export$c98b07f3d2e31343;
(function(TopicConfiguration) {
    TopicConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c98b07f3d2e31343 || ($3a0334eddcbe8749$export$c98b07f3d2e31343 = {}));
var $3a0334eddcbe8749$export$165cf006a6abc4b3;
(function(NotificationConfiguration) {
    NotificationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$165cf006a6abc4b3 || ($3a0334eddcbe8749$export$165cf006a6abc4b3 = {}));
var $3a0334eddcbe8749$export$403b2dc6ec5b8d13;
(function(OwnershipControlsRule) {
    OwnershipControlsRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$403b2dc6ec5b8d13 || ($3a0334eddcbe8749$export$403b2dc6ec5b8d13 = {}));
var $3a0334eddcbe8749$export$ae516ccf061cd7d1;
(function(OwnershipControls) {
    OwnershipControls.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ae516ccf061cd7d1 || ($3a0334eddcbe8749$export$ae516ccf061cd7d1 = {}));
var $3a0334eddcbe8749$export$bb1e71315d618124;
(function(GetBucketOwnershipControlsOutput) {
    GetBucketOwnershipControlsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$bb1e71315d618124 || ($3a0334eddcbe8749$export$bb1e71315d618124 = {}));
var $3a0334eddcbe8749$export$55fbc6554b27a2f6;
(function(GetBucketOwnershipControlsRequest) {
    GetBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$55fbc6554b27a2f6 || ($3a0334eddcbe8749$export$55fbc6554b27a2f6 = {}));
var $3a0334eddcbe8749$export$29a8c95926d10996;
(function(GetBucketPolicyOutput) {
    GetBucketPolicyOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$29a8c95926d10996 || ($3a0334eddcbe8749$export$29a8c95926d10996 = {}));
var $3a0334eddcbe8749$export$fde59d57a80f46c6;
(function(GetBucketPolicyRequest) {
    GetBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$fde59d57a80f46c6 || ($3a0334eddcbe8749$export$fde59d57a80f46c6 = {}));
var $3a0334eddcbe8749$export$77c4d21e3fd2b633;
(function(PolicyStatus) {
    PolicyStatus.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$77c4d21e3fd2b633 || ($3a0334eddcbe8749$export$77c4d21e3fd2b633 = {}));
var $3a0334eddcbe8749$export$c9cb93f92e1c4228;
(function(GetBucketPolicyStatusOutput) {
    GetBucketPolicyStatusOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c9cb93f92e1c4228 || ($3a0334eddcbe8749$export$c9cb93f92e1c4228 = {}));
var $3a0334eddcbe8749$export$2e3b292047386a35;
(function(GetBucketPolicyStatusRequest) {
    GetBucketPolicyStatusRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2e3b292047386a35 || ($3a0334eddcbe8749$export$2e3b292047386a35 = {}));
var $3a0334eddcbe8749$export$594f35c535ed76a3;
(function(DeleteMarkerReplication) {
    DeleteMarkerReplication.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$594f35c535ed76a3 || ($3a0334eddcbe8749$export$594f35c535ed76a3 = {}));
var $3a0334eddcbe8749$export$949641a4ad7f11d4;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$949641a4ad7f11d4 || ($3a0334eddcbe8749$export$949641a4ad7f11d4 = {}));
var $3a0334eddcbe8749$export$d9823a04d7ef0d38;
(function(ReplicationTimeValue) {
    ReplicationTimeValue.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d9823a04d7ef0d38 || ($3a0334eddcbe8749$export$d9823a04d7ef0d38 = {}));
var $3a0334eddcbe8749$export$ed9166ec0f465b5e;
(function(Metrics) {
    Metrics.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ed9166ec0f465b5e || ($3a0334eddcbe8749$export$ed9166ec0f465b5e = {}));
var $3a0334eddcbe8749$export$666325b7ed44b812;
(function(ReplicationTime) {
    ReplicationTime.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$666325b7ed44b812 || ($3a0334eddcbe8749$export$666325b7ed44b812 = {}));
var $3a0334eddcbe8749$export$5c4bdf44e1e9cea1;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$5c4bdf44e1e9cea1 || ($3a0334eddcbe8749$export$5c4bdf44e1e9cea1 = {}));
var $3a0334eddcbe8749$export$18e0c6d9cc0aaef5;
(function(ExistingObjectReplication) {
    ExistingObjectReplication.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$18e0c6d9cc0aaef5 || ($3a0334eddcbe8749$export$18e0c6d9cc0aaef5 = {}));
var $3a0334eddcbe8749$export$f149404143b7fc4f;
(function(ReplicationRuleAndOperator) {
    ReplicationRuleAndOperator.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f149404143b7fc4f || ($3a0334eddcbe8749$export$f149404143b7fc4f = {}));
var $3a0334eddcbe8749$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c5652b893758d9eb || ($3a0334eddcbe8749$export$c5652b893758d9eb = {}));
var $3a0334eddcbe8749$export$d6dbaa0624096385;
(function(SseKmsEncryptedObjects) {
    SseKmsEncryptedObjects.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d6dbaa0624096385 || ($3a0334eddcbe8749$export$d6dbaa0624096385 = {}));
var $3a0334eddcbe8749$export$8f4bdf07a780e3ac;
(function(SourceSelectionCriteria) {
    SourceSelectionCriteria.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8f4bdf07a780e3ac || ($3a0334eddcbe8749$export$8f4bdf07a780e3ac = {}));
var $3a0334eddcbe8749$export$4ef0a2a837294f64;
(function(ReplicationRule) {
    ReplicationRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4ef0a2a837294f64 || ($3a0334eddcbe8749$export$4ef0a2a837294f64 = {}));
var $3a0334eddcbe8749$export$74f8efd37d5209b2;
(function(ReplicationConfiguration) {
    ReplicationConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$74f8efd37d5209b2 || ($3a0334eddcbe8749$export$74f8efd37d5209b2 = {}));
var $3a0334eddcbe8749$export$8ec47a87cc54e339;
(function(GetBucketReplicationOutput) {
    GetBucketReplicationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8ec47a87cc54e339 || ($3a0334eddcbe8749$export$8ec47a87cc54e339 = {}));
var $3a0334eddcbe8749$export$e8f64af8ca33bbfd;
(function(GetBucketReplicationRequest) {
    GetBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e8f64af8ca33bbfd || ($3a0334eddcbe8749$export$e8f64af8ca33bbfd = {}));
var $3a0334eddcbe8749$export$8b846c4a43a75e9e;
(function(GetBucketRequestPaymentOutput) {
    GetBucketRequestPaymentOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8b846c4a43a75e9e || ($3a0334eddcbe8749$export$8b846c4a43a75e9e = {}));
var $3a0334eddcbe8749$export$a3b6600fe888f873;
(function(GetBucketRequestPaymentRequest) {
    GetBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a3b6600fe888f873 || ($3a0334eddcbe8749$export$a3b6600fe888f873 = {}));
var $3a0334eddcbe8749$export$b794c693046ccc37;
(function(GetBucketTaggingOutput) {
    GetBucketTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b794c693046ccc37 || ($3a0334eddcbe8749$export$b794c693046ccc37 = {}));
var $3a0334eddcbe8749$export$4cb4643c20453b75;
(function(GetBucketTaggingRequest) {
    GetBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4cb4643c20453b75 || ($3a0334eddcbe8749$export$4cb4643c20453b75 = {}));
var $3a0334eddcbe8749$export$6f458e80d9a168b;
(function(GetBucketVersioningOutput) {
    GetBucketVersioningOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$6f458e80d9a168b || ($3a0334eddcbe8749$export$6f458e80d9a168b = {}));
var $3a0334eddcbe8749$export$199936fd6251213c;
(function(GetBucketVersioningRequest) {
    GetBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$199936fd6251213c || ($3a0334eddcbe8749$export$199936fd6251213c = {}));
var $3a0334eddcbe8749$export$4afca95d558fb444;
(function(ErrorDocument) {
    ErrorDocument.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4afca95d558fb444 || ($3a0334eddcbe8749$export$4afca95d558fb444 = {}));
var $3a0334eddcbe8749$export$c07750ef20ad8d6c;
(function(IndexDocument) {
    IndexDocument.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c07750ef20ad8d6c || ($3a0334eddcbe8749$export$c07750ef20ad8d6c = {}));
var $3a0334eddcbe8749$export$98dc4d8bbaac5b7c;
(function(RedirectAllRequestsTo) {
    RedirectAllRequestsTo.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$98dc4d8bbaac5b7c || ($3a0334eddcbe8749$export$98dc4d8bbaac5b7c = {}));
var $3a0334eddcbe8749$export$fcea0b2db26e6b18;
(function(Condition) {
    Condition.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$fcea0b2db26e6b18 || ($3a0334eddcbe8749$export$fcea0b2db26e6b18 = {}));
var $3a0334eddcbe8749$export$2d8d895a0a0f636e;
(function(Redirect) {
    Redirect.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2d8d895a0a0f636e || ($3a0334eddcbe8749$export$2d8d895a0a0f636e = {}));
var $3a0334eddcbe8749$export$6464c2c4399038e2;
(function(RoutingRule) {
    RoutingRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$6464c2c4399038e2 || ($3a0334eddcbe8749$export$6464c2c4399038e2 = {}));
var $3a0334eddcbe8749$export$4632dcd1018fd6bd;
(function(GetBucketWebsiteOutput) {
    GetBucketWebsiteOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4632dcd1018fd6bd || ($3a0334eddcbe8749$export$4632dcd1018fd6bd = {}));
var $3a0334eddcbe8749$export$b51e2df1df27d690;
(function(GetBucketWebsiteRequest) {
    GetBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b51e2df1df27d690 || ($3a0334eddcbe8749$export$b51e2df1df27d690 = {}));
var $3a0334eddcbe8749$export$9fb6bec1a5c954d6;
(function(GetObjectOutput) {
    GetObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$9fb6bec1a5c954d6 || ($3a0334eddcbe8749$export$9fb6bec1a5c954d6 = {}));
var $3a0334eddcbe8749$export$3373ea9743883feb;
(function(GetObjectRequest) {
    GetObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$3373ea9743883feb || ($3a0334eddcbe8749$export$3373ea9743883feb = {}));
var $3a0334eddcbe8749$export$1f6f8c73c651f3ca;
(function(NoSuchKey) {
    NoSuchKey.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$1f6f8c73c651f3ca || ($3a0334eddcbe8749$export$1f6f8c73c651f3ca = {}));
var $3a0334eddcbe8749$export$7c40a2227fecdc12;
(function(GetObjectAclOutput) {
    GetObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$7c40a2227fecdc12 || ($3a0334eddcbe8749$export$7c40a2227fecdc12 = {}));
var $3a0334eddcbe8749$export$cb1a4ad2e0f38f95;
(function(GetObjectAclRequest) {
    GetObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cb1a4ad2e0f38f95 || ($3a0334eddcbe8749$export$cb1a4ad2e0f38f95 = {}));
var $3a0334eddcbe8749$export$f3dff23941310d9;
(function(ObjectLockLegalHold) {
    ObjectLockLegalHold.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f3dff23941310d9 || ($3a0334eddcbe8749$export$f3dff23941310d9 = {}));
var $3a0334eddcbe8749$export$9939dc80bbea1acd;
(function(GetObjectLegalHoldOutput) {
    GetObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$9939dc80bbea1acd || ($3a0334eddcbe8749$export$9939dc80bbea1acd = {}));
var $3a0334eddcbe8749$export$5f8862ba76850511;
(function(GetObjectLegalHoldRequest) {
    GetObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$5f8862ba76850511 || ($3a0334eddcbe8749$export$5f8862ba76850511 = {}));
var $3a0334eddcbe8749$export$705dac3c9e25f673;
(function(DefaultRetention) {
    DefaultRetention.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$705dac3c9e25f673 || ($3a0334eddcbe8749$export$705dac3c9e25f673 = {}));
var $3a0334eddcbe8749$export$62ac1d02f31163e0;
(function(ObjectLockRule) {
    ObjectLockRule.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$62ac1d02f31163e0 || ($3a0334eddcbe8749$export$62ac1d02f31163e0 = {}));
var $3a0334eddcbe8749$export$262d239426342c96;
(function(ObjectLockConfiguration) {
    ObjectLockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$262d239426342c96 || ($3a0334eddcbe8749$export$262d239426342c96 = {}));
var $3a0334eddcbe8749$export$486dc804d3714e8e;
(function(GetObjectLockConfigurationOutput) {
    GetObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$486dc804d3714e8e || ($3a0334eddcbe8749$export$486dc804d3714e8e = {}));
var $3a0334eddcbe8749$export$43efa1cb9cbd5c84;
(function(GetObjectLockConfigurationRequest) {
    GetObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$43efa1cb9cbd5c84 || ($3a0334eddcbe8749$export$43efa1cb9cbd5c84 = {}));
var $3a0334eddcbe8749$export$a0bcf720e4ebfa6b;
(function(ObjectLockRetention) {
    ObjectLockRetention.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a0bcf720e4ebfa6b || ($3a0334eddcbe8749$export$a0bcf720e4ebfa6b = {}));
var $3a0334eddcbe8749$export$5a061f69fa492eee;
(function(GetObjectRetentionOutput) {
    GetObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$5a061f69fa492eee || ($3a0334eddcbe8749$export$5a061f69fa492eee = {}));
var $3a0334eddcbe8749$export$bd618fd4d0be1150;
(function(GetObjectRetentionRequest) {
    GetObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$bd618fd4d0be1150 || ($3a0334eddcbe8749$export$bd618fd4d0be1150 = {}));
var $3a0334eddcbe8749$export$21e84ade4ffc813f;
(function(GetObjectTaggingOutput) {
    GetObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$21e84ade4ffc813f || ($3a0334eddcbe8749$export$21e84ade4ffc813f = {}));
var $3a0334eddcbe8749$export$e8c3f2a82ba22432;
(function(GetObjectTaggingRequest) {
    GetObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e8c3f2a82ba22432 || ($3a0334eddcbe8749$export$e8c3f2a82ba22432 = {}));
var $3a0334eddcbe8749$export$c7be7807f0a3eea;
(function(GetObjectTorrentOutput) {
    GetObjectTorrentOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c7be7807f0a3eea || ($3a0334eddcbe8749$export$c7be7807f0a3eea = {}));
var $3a0334eddcbe8749$export$93e32e1b0e5460eb;
(function(GetObjectTorrentRequest) {
    GetObjectTorrentRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$93e32e1b0e5460eb || ($3a0334eddcbe8749$export$93e32e1b0e5460eb = {}));
var $3a0334eddcbe8749$export$d5abbb05d727be20;
(function(PublicAccessBlockConfiguration) {
    PublicAccessBlockConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d5abbb05d727be20 || ($3a0334eddcbe8749$export$d5abbb05d727be20 = {}));
var $3a0334eddcbe8749$export$3606af58a9ffe87;
(function(GetPublicAccessBlockOutput) {
    GetPublicAccessBlockOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3606af58a9ffe87 || ($3a0334eddcbe8749$export$3606af58a9ffe87 = {}));
var $3a0334eddcbe8749$export$f768b28d574460bb;
(function(GetPublicAccessBlockRequest) {
    GetPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f768b28d574460bb || ($3a0334eddcbe8749$export$f768b28d574460bb = {}));
var $3a0334eddcbe8749$export$ce473fe6d5e62bdd;
(function(HeadBucketRequest) {
    HeadBucketRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ce473fe6d5e62bdd || ($3a0334eddcbe8749$export$ce473fe6d5e62bdd = {}));
var $3a0334eddcbe8749$export$bbe89283205bd874;
(function(NoSuchBucket) {
    NoSuchBucket.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$bbe89283205bd874 || ($3a0334eddcbe8749$export$bbe89283205bd874 = {}));
var $3a0334eddcbe8749$export$fd185f7330520684;
(function(HeadObjectOutput) {
    HeadObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$fd185f7330520684 || ($3a0334eddcbe8749$export$fd185f7330520684 = {}));
var $3a0334eddcbe8749$export$e9eaca65791fc4c;
(function(HeadObjectRequest) {
    HeadObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$e9eaca65791fc4c || ($3a0334eddcbe8749$export$e9eaca65791fc4c = {}));
var $3a0334eddcbe8749$export$cccced7f72820034;
(function(ListBucketAnalyticsConfigurationsOutput) {
    ListBucketAnalyticsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cccced7f72820034 || ($3a0334eddcbe8749$export$cccced7f72820034 = {}));
var $3a0334eddcbe8749$export$397b8f33cb9cfc07;
(function(ListBucketAnalyticsConfigurationsRequest) {
    ListBucketAnalyticsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$397b8f33cb9cfc07 || ($3a0334eddcbe8749$export$397b8f33cb9cfc07 = {}));
var $3a0334eddcbe8749$export$9e6dae27db161fe4;
(function(ListBucketInventoryConfigurationsOutput) {
    ListBucketInventoryConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
                return $3a0334eddcbe8749$export$e13e8ea2fe7b5717.filterSensitiveLog(item);
            })
        });
    };
})($3a0334eddcbe8749$export$9e6dae27db161fe4 || ($3a0334eddcbe8749$export$9e6dae27db161fe4 = {}));
var $3a0334eddcbe8749$export$443f8cd22179a9b7;
(function(ListBucketInventoryConfigurationsRequest) {
    ListBucketInventoryConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$443f8cd22179a9b7 || ($3a0334eddcbe8749$export$443f8cd22179a9b7 = {}));
var $3a0334eddcbe8749$export$a94e91ae224bc393;
(function(ListBucketMetricsConfigurationsOutput) {
    ListBucketMetricsConfigurationsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a94e91ae224bc393 || ($3a0334eddcbe8749$export$a94e91ae224bc393 = {}));
var $3a0334eddcbe8749$export$18bea5a661e91351;
(function(ListBucketMetricsConfigurationsRequest) {
    ListBucketMetricsConfigurationsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$18bea5a661e91351 || ($3a0334eddcbe8749$export$18bea5a661e91351 = {}));
var $3a0334eddcbe8749$export$356eb44c374cfc19;
(function(Bucket) {
    Bucket.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$356eb44c374cfc19 || ($3a0334eddcbe8749$export$356eb44c374cfc19 = {}));
var $3a0334eddcbe8749$export$fb68aea51fc1aaa8;
(function(ListBucketsOutput) {
    ListBucketsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$fb68aea51fc1aaa8 || ($3a0334eddcbe8749$export$fb68aea51fc1aaa8 = {}));
var $3a0334eddcbe8749$export$70a8419756bd30c7;
(function(CommonPrefix) {
    CommonPrefix.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$70a8419756bd30c7 || ($3a0334eddcbe8749$export$70a8419756bd30c7 = {}));
var $3a0334eddcbe8749$export$f2cea2a27584e4aa;
(function(Initiator) {
    Initiator.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f2cea2a27584e4aa || ($3a0334eddcbe8749$export$f2cea2a27584e4aa = {}));
var $3a0334eddcbe8749$export$60e639cfe2512bff;
(function(MultipartUpload) {
    MultipartUpload.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$60e639cfe2512bff || ($3a0334eddcbe8749$export$60e639cfe2512bff = {}));
var $3a0334eddcbe8749$export$ed83d15740b9f76d;
(function(ListMultipartUploadsOutput) {
    ListMultipartUploadsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ed83d15740b9f76d || ($3a0334eddcbe8749$export$ed83d15740b9f76d = {}));
var $3a0334eddcbe8749$export$d96c3e2cf9803f5e;
(function(ListMultipartUploadsRequest) {
    ListMultipartUploadsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d96c3e2cf9803f5e || ($3a0334eddcbe8749$export$d96c3e2cf9803f5e = {}));
var $3a0334eddcbe8749$export$dcacc4a8f6015c36;
(function(_Object) {
    _Object.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$dcacc4a8f6015c36 || ($3a0334eddcbe8749$export$dcacc4a8f6015c36 = {}));
var $3a0334eddcbe8749$export$bd5de99c03e50bdf;
(function(ListObjectsOutput) {
    ListObjectsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$bd5de99c03e50bdf || ($3a0334eddcbe8749$export$bd5de99c03e50bdf = {}));
var $3a0334eddcbe8749$export$b17e2bd91a04aa76;
(function(ListObjectsRequest) {
    ListObjectsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b17e2bd91a04aa76 || ($3a0334eddcbe8749$export$b17e2bd91a04aa76 = {}));
var $3a0334eddcbe8749$export$6fb2827b4fe28be3;
(function(ListObjectsV2Output) {
    ListObjectsV2Output.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$6fb2827b4fe28be3 || ($3a0334eddcbe8749$export$6fb2827b4fe28be3 = {}));
var $3a0334eddcbe8749$export$32fa6adfa8e5165a;
(function(ListObjectsV2Request) {
    ListObjectsV2Request.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$32fa6adfa8e5165a || ($3a0334eddcbe8749$export$32fa6adfa8e5165a = {}));
var $3a0334eddcbe8749$export$a834fe68df71f671;
(function(DeleteMarkerEntry) {
    DeleteMarkerEntry.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a834fe68df71f671 || ($3a0334eddcbe8749$export$a834fe68df71f671 = {}));
var $3a0334eddcbe8749$export$3288b5b55ddbb34f;
(function(ObjectVersion) {
    ObjectVersion.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3288b5b55ddbb34f || ($3a0334eddcbe8749$export$3288b5b55ddbb34f = {}));
var $3a0334eddcbe8749$export$4037923dade2a143;
(function(ListObjectVersionsOutput) {
    ListObjectVersionsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4037923dade2a143 || ($3a0334eddcbe8749$export$4037923dade2a143 = {}));
var $3a0334eddcbe8749$export$7420470087543a24;
(function(ListObjectVersionsRequest) {
    ListObjectVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$7420470087543a24 || ($3a0334eddcbe8749$export$7420470087543a24 = {}));
var $3a0334eddcbe8749$export$7b5bf7981d51054e;
(function(Part) {
    Part.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$7b5bf7981d51054e || ($3a0334eddcbe8749$export$7b5bf7981d51054e = {}));
var $3a0334eddcbe8749$export$8c83b46649a5c089;
(function(ListPartsOutput) {
    ListPartsOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$8c83b46649a5c089 || ($3a0334eddcbe8749$export$8c83b46649a5c089 = {}));
var $3a0334eddcbe8749$export$756cf37efa2403e6;
(function(ListPartsRequest) {
    ListPartsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$756cf37efa2403e6 || ($3a0334eddcbe8749$export$756cf37efa2403e6 = {}));
var $3a0334eddcbe8749$export$95f02e50cfd87383;
(function(PutBucketAccelerateConfigurationRequest) {
    PutBucketAccelerateConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$95f02e50cfd87383 || ($3a0334eddcbe8749$export$95f02e50cfd87383 = {}));
var $3a0334eddcbe8749$export$15919ea85d7751db;
(function(PutBucketAclRequest) {
    PutBucketAclRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$15919ea85d7751db || ($3a0334eddcbe8749$export$15919ea85d7751db = {}));
var $3a0334eddcbe8749$export$b29e71de1c43092d;
(function(PutBucketAnalyticsConfigurationRequest) {
    PutBucketAnalyticsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b29e71de1c43092d || ($3a0334eddcbe8749$export$b29e71de1c43092d = {}));
var $3a0334eddcbe8749$export$4efc44a8f577c4c6;
(function(CORSConfiguration) {
    CORSConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$4efc44a8f577c4c6 || ($3a0334eddcbe8749$export$4efc44a8f577c4c6 = {}));
var $3a0334eddcbe8749$export$48388c72802bf3b4;
(function(PutBucketCorsRequest) {
    PutBucketCorsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$48388c72802bf3b4 || ($3a0334eddcbe8749$export$48388c72802bf3b4 = {}));
var $3a0334eddcbe8749$export$b9464fee92783639;
(function(PutBucketEncryptionRequest) {
    PutBucketEncryptionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $3a0334eddcbe8749$export$d53e5f9e3c3507bf.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
        });
    };
})($3a0334eddcbe8749$export$b9464fee92783639 || ($3a0334eddcbe8749$export$b9464fee92783639 = {}));
var $3a0334eddcbe8749$export$7bce979f7abe4f73;
(function(PutBucketInventoryConfigurationRequest) {
    PutBucketInventoryConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.InventoryConfiguration && {
            InventoryConfiguration: $3a0334eddcbe8749$export$e13e8ea2fe7b5717.filterSensitiveLog(obj.InventoryConfiguration)
        });
    };
})($3a0334eddcbe8749$export$7bce979f7abe4f73 || ($3a0334eddcbe8749$export$7bce979f7abe4f73 = {}));
var $3a0334eddcbe8749$export$2bad5a8856023522;
(function(BucketLifecycleConfiguration) {
    BucketLifecycleConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2bad5a8856023522 || ($3a0334eddcbe8749$export$2bad5a8856023522 = {}));
var $3a0334eddcbe8749$export$b1f1a3c5136805f6;
(function(PutBucketLifecycleConfigurationRequest) {
    PutBucketLifecycleConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b1f1a3c5136805f6 || ($3a0334eddcbe8749$export$b1f1a3c5136805f6 = {}));
var $3a0334eddcbe8749$export$c183b06f38322f46;
(function(BucketLoggingStatus) {
    BucketLoggingStatus.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$c183b06f38322f46 || ($3a0334eddcbe8749$export$c183b06f38322f46 = {}));
var $3a0334eddcbe8749$export$b7513dc0595a23bf;
(function(PutBucketLoggingRequest) {
    PutBucketLoggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b7513dc0595a23bf || ($3a0334eddcbe8749$export$b7513dc0595a23bf = {}));
var $3a0334eddcbe8749$export$848d3e19e2b6526f;
(function(PutBucketMetricsConfigurationRequest) {
    PutBucketMetricsConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$848d3e19e2b6526f || ($3a0334eddcbe8749$export$848d3e19e2b6526f = {}));
var $3a0334eddcbe8749$export$832249f88bdec051;
(function(PutBucketNotificationConfigurationRequest) {
    PutBucketNotificationConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$832249f88bdec051 || ($3a0334eddcbe8749$export$832249f88bdec051 = {}));
var $3a0334eddcbe8749$export$dd5b80748bfa876c;
(function(PutBucketOwnershipControlsRequest) {
    PutBucketOwnershipControlsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$dd5b80748bfa876c || ($3a0334eddcbe8749$export$dd5b80748bfa876c = {}));
var $3a0334eddcbe8749$export$a3745e522d5251e6;
(function(PutBucketPolicyRequest) {
    PutBucketPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a3745e522d5251e6 || ($3a0334eddcbe8749$export$a3745e522d5251e6 = {}));
var $3a0334eddcbe8749$export$80d3d606687bccbe;
(function(PutBucketReplicationRequest) {
    PutBucketReplicationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$80d3d606687bccbe || ($3a0334eddcbe8749$export$80d3d606687bccbe = {}));
var $3a0334eddcbe8749$export$5b5564785205c8b6;
(function(RequestPaymentConfiguration) {
    RequestPaymentConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$5b5564785205c8b6 || ($3a0334eddcbe8749$export$5b5564785205c8b6 = {}));
var $3a0334eddcbe8749$export$efe882c45e4d54c5;
(function(PutBucketRequestPaymentRequest) {
    PutBucketRequestPaymentRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$efe882c45e4d54c5 || ($3a0334eddcbe8749$export$efe882c45e4d54c5 = {}));
var $3a0334eddcbe8749$export$2c6436847badca04;
(function(Tagging) {
    Tagging.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$2c6436847badca04 || ($3a0334eddcbe8749$export$2c6436847badca04 = {}));
var $3a0334eddcbe8749$export$907025fe881c3d35;
(function(PutBucketTaggingRequest) {
    PutBucketTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$907025fe881c3d35 || ($3a0334eddcbe8749$export$907025fe881c3d35 = {}));
var $3a0334eddcbe8749$export$12496b4e466310a9;
(function(VersioningConfiguration) {
    VersioningConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$12496b4e466310a9 || ($3a0334eddcbe8749$export$12496b4e466310a9 = {}));
var $3a0334eddcbe8749$export$b342a4ff3cacc8f6;
(function(PutBucketVersioningRequest) {
    PutBucketVersioningRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$b342a4ff3cacc8f6 || ($3a0334eddcbe8749$export$b342a4ff3cacc8f6 = {}));
var $3a0334eddcbe8749$export$aec172fe960d640d;
(function(WebsiteConfiguration) {
    WebsiteConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$aec172fe960d640d || ($3a0334eddcbe8749$export$aec172fe960d640d = {}));
var $3a0334eddcbe8749$export$98e48334698c13d8;
(function(PutBucketWebsiteRequest) {
    PutBucketWebsiteRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$98e48334698c13d8 || ($3a0334eddcbe8749$export$98e48334698c13d8 = {}));
var $3a0334eddcbe8749$export$792cedced515bdbd;
(function(PutObjectOutput) {
    PutObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$792cedced515bdbd || ($3a0334eddcbe8749$export$792cedced515bdbd = {}));
var $3a0334eddcbe8749$export$90c5c1bf0f634d21;
(function(PutObjectRequest) {
    PutObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$90c5c1bf0f634d21 || ($3a0334eddcbe8749$export$90c5c1bf0f634d21 = {}));
var $3a0334eddcbe8749$export$e533775617728d56;
(function(PutObjectAclOutput) {
    PutObjectAclOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e533775617728d56 || ($3a0334eddcbe8749$export$e533775617728d56 = {}));
var $3a0334eddcbe8749$export$3dc01ad48475bf08;
(function(PutObjectAclRequest) {
    PutObjectAclRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$3dc01ad48475bf08 || ($3a0334eddcbe8749$export$3dc01ad48475bf08 = {}));
var $3a0334eddcbe8749$export$d9144478e705d522;
(function(PutObjectLegalHoldOutput) {
    PutObjectLegalHoldOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d9144478e705d522 || ($3a0334eddcbe8749$export$d9144478e705d522 = {}));
var $3a0334eddcbe8749$export$71c3c7a041df44ca;
(function(PutObjectLegalHoldRequest) {
    PutObjectLegalHoldRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$71c3c7a041df44ca || ($3a0334eddcbe8749$export$71c3c7a041df44ca = {}));
var $3a0334eddcbe8749$export$93f296cba8bc1760;
(function(PutObjectLockConfigurationOutput) {
    PutObjectLockConfigurationOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$93f296cba8bc1760 || ($3a0334eddcbe8749$export$93f296cba8bc1760 = {}));
var $3a0334eddcbe8749$export$693145724507a617;
(function(PutObjectLockConfigurationRequest) {
    PutObjectLockConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$693145724507a617 || ($3a0334eddcbe8749$export$693145724507a617 = {}));
var $3a0334eddcbe8749$export$edd40f596f5fa31e;
(function(PutObjectRetentionOutput) {
    PutObjectRetentionOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$edd40f596f5fa31e || ($3a0334eddcbe8749$export$edd40f596f5fa31e = {}));
var $3a0334eddcbe8749$export$117e9cab66df5006;
(function(PutObjectRetentionRequest) {
    PutObjectRetentionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$117e9cab66df5006 || ($3a0334eddcbe8749$export$117e9cab66df5006 = {}));
var $3a0334eddcbe8749$export$d9e3a7e4f51c31d5;
(function(PutObjectTaggingOutput) {
    PutObjectTaggingOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$d9e3a7e4f51c31d5 || ($3a0334eddcbe8749$export$d9e3a7e4f51c31d5 = {}));
var $3a0334eddcbe8749$export$f5517f211c9a0baf;
(function(PutObjectTaggingRequest) {
    PutObjectTaggingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$f5517f211c9a0baf || ($3a0334eddcbe8749$export$f5517f211c9a0baf = {}));
var $3a0334eddcbe8749$export$11868106b24a9ab0;
(function(PutPublicAccessBlockRequest) {
    PutPublicAccessBlockRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$11868106b24a9ab0 || ($3a0334eddcbe8749$export$11868106b24a9ab0 = {}));
var $3a0334eddcbe8749$export$a97e3c65be291319;
(function(ObjectAlreadyInActiveTierError) {
    ObjectAlreadyInActiveTierError.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a97e3c65be291319 || ($3a0334eddcbe8749$export$a97e3c65be291319 = {}));
var $3a0334eddcbe8749$export$ee3cf9307c2a87ae;
(function(RestoreObjectOutput) {
    RestoreObjectOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$ee3cf9307c2a87ae || ($3a0334eddcbe8749$export$ee3cf9307c2a87ae = {}));
var $3a0334eddcbe8749$export$e9e40009732846c;
(function(GlacierJobParameters) {
    GlacierJobParameters.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$e9e40009732846c || ($3a0334eddcbe8749$export$e9e40009732846c = {}));
var $3a0334eddcbe8749$export$d60a27d0da10cee5;
(function(Encryption) {
    Encryption.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.KMSKeyId && {
            KMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($3a0334eddcbe8749$export$d60a27d0da10cee5 || ($3a0334eddcbe8749$export$d60a27d0da10cee5 = {}));
var $3a0334eddcbe8749$export$9c5e83992d724a63;
(function(MetadataEntry) {
    MetadataEntry.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$9c5e83992d724a63 || ($3a0334eddcbe8749$export$9c5e83992d724a63 = {}));
var $3a0334eddcbe8749$export$7bb542410b46ffb9;
(function(S3Location) {
    S3Location.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Encryption && {
            Encryption: $3a0334eddcbe8749$export$d60a27d0da10cee5.filterSensitiveLog(obj.Encryption)
        });
    };
})($3a0334eddcbe8749$export$7bb542410b46ffb9 || ($3a0334eddcbe8749$export$7bb542410b46ffb9 = {}));
var $3a0334eddcbe8749$export$cc3fbbd78713fc6c;
(function(OutputLocation) {
    OutputLocation.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.S3 && {
            S3: $3a0334eddcbe8749$export$7bb542410b46ffb9.filterSensitiveLog(obj.S3)
        });
    };
})($3a0334eddcbe8749$export$cc3fbbd78713fc6c || ($3a0334eddcbe8749$export$cc3fbbd78713fc6c = {}));
var $3a0334eddcbe8749$export$e0a8b40ee8e7958f;
(function(FileHeaderInfo) {
    FileHeaderInfo["IGNORE"] = "IGNORE";
    FileHeaderInfo["NONE"] = "NONE";
    FileHeaderInfo["USE"] = "USE";
})($3a0334eddcbe8749$export$e0a8b40ee8e7958f || ($3a0334eddcbe8749$export$e0a8b40ee8e7958f = {}));
var $3a0334eddcbe8749$export$cd4a4cfd0598253e;
(function(CSVInput) {
    CSVInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cd4a4cfd0598253e || ($3a0334eddcbe8749$export$cd4a4cfd0598253e = {}));
var $3a0334eddcbe8749$export$b8d04dd3765058e2;
(function(JSONType) {
    JSONType["DOCUMENT"] = "DOCUMENT";
    JSONType["LINES"] = "LINES";
})($3a0334eddcbe8749$export$b8d04dd3765058e2 || ($3a0334eddcbe8749$export$b8d04dd3765058e2 = {}));
var $3a0334eddcbe8749$export$1bc8a3cf179ad9c;
(function(JSONInput) {
    JSONInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$1bc8a3cf179ad9c || ($3a0334eddcbe8749$export$1bc8a3cf179ad9c = {}));
var $3a0334eddcbe8749$export$a457f185006c756f;
(function(ParquetInput) {
    ParquetInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$a457f185006c756f || ($3a0334eddcbe8749$export$a457f185006c756f = {}));
var $3a0334eddcbe8749$export$71ed8fe19d426eb7;
(function(InputSerialization) {
    InputSerialization.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$71ed8fe19d426eb7 || ($3a0334eddcbe8749$export$71ed8fe19d426eb7 = {}));
var $3a0334eddcbe8749$export$b4890521754421ba;
(function(QuoteFields) {
    QuoteFields["ALWAYS"] = "ALWAYS";
    QuoteFields["ASNEEDED"] = "ASNEEDED";
})($3a0334eddcbe8749$export$b4890521754421ba || ($3a0334eddcbe8749$export$b4890521754421ba = {}));
var $3a0334eddcbe8749$export$623bc581753795b3;
(function(CSVOutput) {
    CSVOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$623bc581753795b3 || ($3a0334eddcbe8749$export$623bc581753795b3 = {}));
var $3a0334eddcbe8749$export$403a844dcc531976;
(function(JSONOutput) {
    JSONOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$403a844dcc531976 || ($3a0334eddcbe8749$export$403a844dcc531976 = {}));
var $3a0334eddcbe8749$export$cb22c2d1ef9f03c1;
(function(OutputSerialization) {
    OutputSerialization.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$cb22c2d1ef9f03c1 || ($3a0334eddcbe8749$export$cb22c2d1ef9f03c1 = {}));
var $3a0334eddcbe8749$export$722dd036ddb6b3f;
(function(SelectParameters) {
    SelectParameters.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($3a0334eddcbe8749$export$722dd036ddb6b3f || ($3a0334eddcbe8749$export$722dd036ddb6b3f = {}));





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $71a559089b3c355a$var$extendStatics = function(d, b) {
    $71a559089b3c355a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $71a559089b3c355a$var$extendStatics(d, b);
};
function $71a559089b3c355a$export$a8ba968b8961cb8a(d, b) {
    $71a559089b3c355a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $71a559089b3c355a$export$18ce0697a983be9b = function() {
    $71a559089b3c355a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71a559089b3c355a$export$18ce0697a983be9b.apply(this, arguments);
};
function $71a559089b3c355a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $71a559089b3c355a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $71a559089b3c355a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $71a559089b3c355a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $71a559089b3c355a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $71a559089b3c355a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $71a559089b3c355a$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $71a559089b3c355a$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $71a559089b3c355a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $71a559089b3c355a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $71a559089b3c355a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($71a559089b3c355a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $71a559089b3c355a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $71a559089b3c355a$export$10c90e4f7922046c(v) {
    return this instanceof $71a559089b3c355a$export$10c90e4f7922046c ? (this.v = v, this) : new $71a559089b3c355a$export$10c90e4f7922046c(v);
}
function $71a559089b3c355a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $71a559089b3c355a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $71a559089b3c355a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $71a559089b3c355a$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $71a559089b3c355a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $71a559089b3c355a$export$19a8beecd37a4c45 === "function" ? $71a559089b3c355a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $71a559089b3c355a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $71a559089b3c355a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $71a559089b3c355a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $71a559089b3c355a$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $71a559089b3c355a$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/**
 * Escapes characters that can not be in an XML attribute.
 */ function $91a851e7ae713bb9$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}


/**
 * Represents an XML node.
 */ var $24cd37c7ad60becc$export$e775a15d806cbddc = /** @class */ function() {
    function XmlNode(name, children) {
        if (children === void 0) children = [];
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.withName = function(name) {
        this.name = name;
        return this;
    };
    XmlNode.prototype.addAttribute = function(name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function(child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function(name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function() {
        var e_1, _a;
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        try {
            for(var _b = (0, $71a559089b3c355a$export$19a8beecd37a4c45)(Object.keys(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var attributeName = _c.value;
                var attribute = attributes[attributeName];
                if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + "=\"" + (0, $91a851e7ae713bb9$export$30330f3d5eb70e11)("" + attribute) + "\"";
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
            return c.toString();
        }).join("") + "</" + this.name + ">";
    };
    return XmlNode;
}();


/**
 * Escapes characters that can not be in an XML element.
 */ function $914cb85bbb419c38$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * Represents an XML text value.
 */ var $63836c47f6d5aed2$export$b35b8f45887823df = /** @class */ function() {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function() {
        return (0, $914cb85bbb419c38$export$e5104ffd394b43ec)("" + this.value);
    };
    return XmlText;
}();




var $7bae4596bfd15ae4$export$98e6a39c04603d36;
var $7bae4596bfd15ae4$export$e4f0b40d01c251ab;
var $7bae4596bfd15ae4$export$2ca3eb0a2f8a693a;
var $7bae4596bfd15ae4$export$e31c2b05678acf26;
var $7bae4596bfd15ae4$export$54ffaacfc0931fb0;
var $7bae4596bfd15ae4$export$a22775fa5e2eebd9;
var $7bae4596bfd15ae4$export$30384b60aedf98a5;
var $7bae4596bfd15ae4$export$3a5cfc971f52ee31;
'use strict';
var $151b7cd0b6a79a2f$export$e31c2b05678acf26;
'use strict';

var $6OSnz = parcelRequire("6OSnz");
const $151b7cd0b6a79a2f$var$convertToJson = function(node, options, parentTagName) {
    const jObj = {};
    // when no child node or attr is present
    if (!options.alwaysCreateTextNode && (!node.child || $6OSnz.isEmptyObject(node.child)) && (!node.attrsMap || $6OSnz.isEmptyObject(node.attrsMap))) return $6OSnz.isExist(node.val) ? node.val : '';
    // otherwise create a textnode if node has some text
    if ($6OSnz.isExist(node.val) && !(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
        const asArray = $6OSnz.isTagNameInArrayMode(node.tagname, options.arrayMode, parentTagName);
        jObj[options.textNodeName] = asArray ? [
            node.val
        ] : node.val;
    }
    $6OSnz.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        const tagName = keys[index];
        if (node.child[tagName] && node.child[tagName].length > 1) {
            jObj[tagName] = [];
            for(let tag in node.child[tagName])if (node.child[tagName].hasOwnProperty(tag)) jObj[tagName].push($151b7cd0b6a79a2f$var$convertToJson(node.child[tagName][tag], options, tagName));
        } else {
            const result = $151b7cd0b6a79a2f$var$convertToJson(node.child[tagName][0], options, tagName);
            const asArray = options.arrayMode === true && typeof result === 'object' || $6OSnz.isTagNameInArrayMode(tagName, options.arrayMode, parentTagName);
            jObj[tagName] = asArray ? [
                result
            ] : result;
        }
    }
    //add value
    return jObj;
};
$151b7cd0b6a79a2f$export$e31c2b05678acf26 = $151b7cd0b6a79a2f$var$convertToJson;



var $3WVUR = parcelRequire("3WVUR");

var $3WVUR = parcelRequire("3WVUR");

var $6OSnz = parcelRequire("6OSnz");
var $7bae4596bfd15ae4$require$buildOptions = $6OSnz.buildOptions;
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $9d289acd0f847118$export$a22775fa5e2eebd9;
'use strict';

var $6OSnz = parcelRequire("6OSnz");
const $9d289acd0f847118$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $9d289acd0f847118$var$props = [
    'allowBooleanAttributes'
];
$9d289acd0f847118$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $6OSnz.buildOptions(options, $9d289acd0f847118$var$defaultOptions, $9d289acd0f847118$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $9d289acd0f847118$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $9d289acd0f847118$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$9d289acd0f847118$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $9d289acd0f847118$var$getErrorObject('InvalidTag', msg, $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $9d289acd0f847118$var$readAttributeStr(xmlData, i);
                if (result === false) return $9d289acd0f847118$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $9d289acd0f847118$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $9d289acd0f847118$var$getErrorObject(isValid.err.code, isValid.err.msg, $9d289acd0f847118$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $9d289acd0f847118$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $9d289acd0f847118$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $9d289acd0f847118$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $9d289acd0f847118$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $9d289acd0f847118$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $9d289acd0f847118$var$getErrorObject(isValid.err.code, isValid.err.msg, $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $9d289acd0f847118$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $9d289acd0f847118$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $9d289acd0f847118$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $9d289acd0f847118$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $9d289acd0f847118$var$getErrorObject('InvalidChar', "char '&' is not expected.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') continue;
            return $9d289acd0f847118$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $9d289acd0f847118$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $9d289acd0f847118$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $9d289acd0f847118$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $9d289acd0f847118$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $9d289acd0f847118$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $9d289acd0f847118$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $9d289acd0f847118$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $9d289acd0f847118$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $9d289acd0f847118$var$doubleQuote = '"';
const $9d289acd0f847118$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $9d289acd0f847118$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $9d289acd0f847118$var$doubleQuote || xmlData[i] === $9d289acd0f847118$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $9d289acd0f847118$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $9d289acd0f847118$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $6OSnz.getAllMatches(attrStr, $9d289acd0f847118$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $9d289acd0f847118$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $9d289acd0f847118$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $9d289acd0f847118$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $9d289acd0f847118$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$9d289acd0f847118$var$validateAttrName(attrName)) return $9d289acd0f847118$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $9d289acd0f847118$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $9d289acd0f847118$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $9d289acd0f847118$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $9d289acd0f847118$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $9d289acd0f847118$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $9d289acd0f847118$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $9d289acd0f847118$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $9d289acd0f847118$var$validateAttrName(attrName) {
    return $6OSnz.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $9d289acd0f847118$var$validateTagName(tagname) {
    return $6OSnz.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $9d289acd0f847118$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $9d289acd0f847118$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


$7bae4596bfd15ae4$export$98e6a39c04603d36 = function(xmlData, givenOptions = {}, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $9d289acd0f847118$export$a22775fa5e2eebd9(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    if (givenOptions.parseTrueNumberOnly && givenOptions.parseNodeValue !== false && !givenOptions.numParseOptions) givenOptions.numParseOptions = {
        leadingZeros: false
    };
    let options = $7bae4596bfd15ae4$require$buildOptions(givenOptions, $3WVUR.defaultOptions, $3WVUR.props);
    const traversableObj = $3WVUR.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $151b7cd0b6a79a2f$export$e31c2b05678acf26(traversableObj, options);
};

$7bae4596bfd15ae4$export$e4f0b40d01c251ab = (parcelRequire("lUMx8")).convert2nimn;
$7bae4596bfd15ae4$export$2ca3eb0a2f8a693a = $3WVUR.getTraversalObj;
$7bae4596bfd15ae4$export$e31c2b05678acf26 = $151b7cd0b6a79a2f$export$e31c2b05678acf26;

$7bae4596bfd15ae4$export$54ffaacfc0931fb0 = (parcelRequire("eHjIk")).convertToJsonString;
$7bae4596bfd15ae4$export$a22775fa5e2eebd9 = $9d289acd0f847118$export$a22775fa5e2eebd9;

$7bae4596bfd15ae4$export$30384b60aedf98a5 = (parcelRequire("cfkXl"));
$7bae4596bfd15ae4$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $7bae4596bfd15ae4$export$e4f0b40d01c251ab($7bae4596bfd15ae4$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $7bae4596bfd15ae4$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
        if (xmlNode.parent) console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
        console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
        console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + "\"child\": {");
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + "\"" + key + "\" :[");
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $7bae4596bfd15ae4$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + " \"" + key + "\" : {");
                    $7bae4596bfd15ae4$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}


var $2fec21551e645b39$export$a7d2d025c66f9235 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "AbortMultipartUpload"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$2a09fb9495f08c55 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.MultipartUpload !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3fa883360ffbe82d = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.TaggingDirective) && {
                        "x-amz-tagging-directive": input.TaggingDirective
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.MetadataDirective) && {
                        "x-amz-metadata-directive": input.MetadataDirective
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "x-id": "CopyObject"
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ff9b8bd3304a2cc2 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
                        "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.CreateBucketConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4730de34492fdc2 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        uploads: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4c739e7bdecdc09e = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$1599103c79e9cc48 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$328eda7443168fa1 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a935f4341563a8e5 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ea4a1894e3000c1a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ff5be01ded2fe32 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$f050fc1ef4eb3607 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9809275ad1405c95 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$d35e7f7cfb4671a8 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9a7bb1ffbd4a4abf = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$898454ff9153710a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$55003dd0346cc6e0 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$400c19cbac9616f7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "DeleteObject"
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6867c23377cf4e18 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        delete: ""
                    };
                    if (input.Delete !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlDelete(input.Delete, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c5216ce889528f85 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6e75832e2b10791c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$401fbb1296db6719 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$36598b1e884464d4 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4d648e59e03d69d2 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "GetBucketAnalyticsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c50cfec8b08a5bc7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$59a2b88153b9bcd3 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$27733aaa6f8bdfce = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "GetBucketInventoryConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a45e301366f2d4b7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$57578b49828da279 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        location: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$fba64f4839ba2759 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$55cedf3b8782e93a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "GetBucketMetricsConfiguration"
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$28aa3066de46a217 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8ff61553a991ad45 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9c4ddc2418c2498a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$5cc8b1c7c38eaa70 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policyStatus: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7bfb07297b27feda = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c40582f35b41168f = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7fe7f3d9e83c1258 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$33bb47afa1d36b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$86d6bcc10cc7214f = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$713ae52666bf2204 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "If-Unmodified-Since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "If-Modified-Since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "If-None-Match": input.IfNoneMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfMatch) && {
                        "If-Match": input.IfMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Range) && {
                        Range: input.Range
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "GetObject"
                    }, input.ResponseContentEncoding !== undefined && {
                        "response-content-encoding": input.ResponseContentEncoding
                    }), input.ResponseCacheControl !== undefined && {
                        "response-cache-control": input.ResponseCacheControl
                    }), input.ResponseContentLanguage !== undefined && {
                        "response-content-language": input.ResponseContentLanguage
                    }), input.ResponseContentDisposition !== undefined && {
                        "response-content-disposition": input.ResponseContentDisposition
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    }), input.ResponseExpires !== undefined && {
                        "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
                    }), input.ResponseContentType !== undefined && {
                        "response-content-type": input.ResponseContentType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$915aba65107b1e0b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9c08e676bdd74a0 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6b8bcfdbd9049617 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$73761af73f60c98c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9eb633d3ed47ffa4 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$19b09331a932f5f6 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        torrent: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$96bfd3c7dd0a4d0a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$33042663db00ac59 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7d02887d047f6825 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Range) && {
                        Range: input.Range
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfNoneMatch) && {
                        "If-None-Match": input.IfNoneMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfUnmodifiedSince) && {
                        "If-Unmodified-Since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfModifiedSince) && {
                        "If-Modified-Since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.IfMatch) && {
                        "If-Match": input.IfMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "HEAD",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$1af1bbf8ced1a360 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        analytics: "",
                        "x-id": "ListBucketAnalyticsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$84049d82728011d8 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        inventory: "",
                        "x-id": "ListBucketInventoryConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4386fb1e1f56eefe = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        metrics: "",
                        "x-id": "ListBucketMetricsConfigurations"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$94ca891f34564e01 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "Content-Type": ""
                    };
                    resolvedPath = "/";
                    body = "";
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$67092c8b2bd6afb9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        uploads: ""
                    }, input.UploadIdMarker !== undefined && {
                        "upload-id-marker": input.UploadIdMarker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.MaxUploads !== undefined && {
                        "max-uploads": input.MaxUploads.toString()
                    }), input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$acd8b176cbc51cb9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Marker !== undefined && {
                        marker: input.Marker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ea6ee77e40f86bd9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "list-type": "2"
                    }, input.ContinuationToken !== undefined && {
                        "continuation-token": input.ContinuationToken
                    }), input.FetchOwner !== undefined && {
                        "fetch-owner": input.FetchOwner.toString()
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.StartAfter !== undefined && {
                        "start-after": input.StartAfter
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e9deb593aaba1069 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        versions: ""
                    }, input.KeyMarker !== undefined && {
                        "key-marker": input.KeyMarker
                    }), input.MaxKeys !== undefined && {
                        "max-keys": input.MaxKeys.toString()
                    }), input.Delimiter !== undefined && {
                        delimiter: input.Delimiter
                    }), input.VersionIdMarker !== undefined && {
                        "version-id-marker": input.VersionIdMarker
                    }), input.Prefix !== undefined && {
                        prefix: input.Prefix
                    }), input.EncodingType !== undefined && {
                        "encoding-type": input.EncodingType
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$b2b39cf3937e8c76 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "ListParts"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    }), input.MaxParts !== undefined && {
                        "max-parts": input.MaxParts.toString()
                    }), input.PartNumberMarker !== undefined && {
                        "part-number-marker": input.PartNumberMarker.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4d770bb452c6d670 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        accelerate: ""
                    };
                    if (input.AccelerateConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$415e832013d5f94b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        acl: ""
                    };
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$82791d7115b07b04 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        analytics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.AnalyticsConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c86e5c4d1766d14 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        cors: ""
                    };
                    if (input.CORSConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c279f7b43c9bb310 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        encryption: ""
                    };
                    if (input.ServerSideEncryptionConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6d95946d99f43eaa = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        inventory: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.InventoryConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$70f4fe83400d730d = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        lifecycle: ""
                    };
                    if (input.LifecycleConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$2426ada7dacc12b9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        logging: ""
                    };
                    if (input.BucketLoggingStatus !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$dd9ccb6c86dc9b75 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        metrics: ""
                    }, input.Id !== undefined && {
                        id: input.Id
                    });
                    if (input.MetricsConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$cc9aba63382b97f4 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        notification: ""
                    };
                    if (input.NotificationConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$cd645fbb22474aad = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        ownershipControls: ""
                    };
                    if (input.OwnershipControls !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$46f7931bb495aaa = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, bodyNode, node, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
                        "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        policy: ""
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("PutBucketPolicyRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Policy !== undefined) {
                        node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Policy").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Policy)).withName("Policy");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$bc85604c47270690 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        replication: ""
                    };
                    if (input.ReplicationConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$d688e45835bb412b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        requestPayment: ""
                    };
                    if (input.RequestPaymentConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$fb33aa4addeb7925 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        tagging: ""
                    };
                    if (input.Tagging !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$b2b33319a5c1fa1b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.MFA) && {
                        "x-amz-mfa": input.MFA
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        versioning: ""
                    };
                    if (input.VersioningConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3684a013c739abf7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        website: ""
                    };
                    if (input.WebsiteConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6c3f9d82bec72a8d = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/octet-stream"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentEncoding) && {
                        "Content-Encoding": input.ContentEncoding
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CacheControl) && {
                        "Cache-Control": input.CacheControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
                        "x-amz-website-redirect-location": input.WebsiteRedirectLocation
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
                        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentLength) && {
                        "Content-Length": input.ContentLength.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
                        "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentDisposition) && {
                        "Content-Disposition": input.ContentDisposition
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
                        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Tagging) && {
                        "x-amz-tagging": input.Tagging
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.Expires) && {
                        Expires: (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.Expires).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.StorageClass) && {
                        "x-amz-storage-class": input.StorageClass
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ServerSideEncryption) && {
                        "x-amz-server-side-encryption": input.ServerSideEncryption
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ObjectLockMode) && {
                        "x-amz-object-lock-mode": input.ObjectLockMode
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSEKMSKeyId) && {
                        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentLanguage) && {
                        "Content-Language": input.ContentLanguage
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentType) && {
                        "Content-Type": input.ContentType
                    }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function(acc, suffix) {
                        acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
                        return acc;
                    }, {}));
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = {
                        "x-id": "PutObject"
                    };
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c5f7c1bb4a245310 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ACL) && {
                        "x-amz-acl": input.ACL
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantFullControl) && {
                        "x-amz-grant-full-control": input.GrantFullControl
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantReadACP) && {
                        "x-amz-grant-read-acp": input.GrantReadACP
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantRead) && {
                        "x-amz-grant-read": input.GrantRead
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWrite) && {
                        "x-amz-grant-write": input.GrantWrite
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.GrantWriteACP) && {
                        "x-amz-grant-write-acp": input.GrantWriteACP
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        acl: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.AccessControlPolicy !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3cae5f4de1f7d8e0 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "legal-hold": ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.LegalHold !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e85a5935e0b9ebcf = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.Token) && {
                        "x-amz-bucket-object-lock-token": input.Token
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        "object-lock": ""
                    };
                    if (input.ObjectLockConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$401e449dfbceed84 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.BypassGovernanceRetention) && {
                        "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        retention: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Retention !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlObjectLockRetention(input.Retention, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c73061b6e5d6a95a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        tagging: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.Tagging !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlTagging(input.Tagging, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9f1c307a4d5bd5b3 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        publicAccessBlock: ""
                    };
                    if (input.PublicAccessBlockConfiguration !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$99a912d071900c76 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        restore: ""
                    }, input.VersionId !== undefined && {
                        versionId: input.VersionId
                    });
                    if (input.RestoreRequest !== undefined) {
                        contents = $2fec21551e645b39$var$serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
                        body = '<?xml version="1.0" encoding="UTF-8"?>';
                        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                        body += contents.toString();
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$47ebf91740d2ce6f = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/xml"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    query = {
                        select: "",
                        "select-type": "2"
                    };
                    body = '<?xml version="1.0" encoding="UTF-8"?>';
                    bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SelectObjectContentRequest");
                    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
                    if (input.Expression !== undefined) {
                        node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Expression)).withName("Expression");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ExpressionType !== undefined) {
                        node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
                        bodyNode.addChildNode(node);
                    }
                    if (input.InputSerialization !== undefined) {
                        node = $2fec21551e645b39$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.OutputSerialization !== undefined) {
                        node = $2fec21551e645b39$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
                        bodyNode.addChildNode(node);
                    }
                    if (input.RequestProgress !== undefined) {
                        node = $2fec21551e645b39$var$serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
                        bodyNode.addChildNode(node);
                    }
                    if (input.ScanRange !== undefined) {
                        node = $2fec21551e645b39$var$serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
                        bodyNode.addChildNode(node);
                    }
                    body += bodyNode.toString();
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6dfc42032d3f37d4 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": "application/octet-stream"
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentLength) && {
                        "Content-Length": input.ContentLength.toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ContentMD5) && {
                        "Content-MD5": input.ContentMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "UploadPart"
                    }, input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    }), input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    });
                    if (input.Body !== undefined) {
                        contents = input.Body;
                        body = contents;
                    }
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$90763da135bbc5f9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "Content-Type": ""
                    }, $2fec21551e645b39$var$isSerializableHeaderValue(input.RequestPayer) && {
                        "x-amz-request-payer": input.RequestPayer
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceRange) && {
                        "x-amz-copy-source-range": input.CopySourceRange
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKey) && {
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfMatch) && {
                        "x-amz-copy-source-if-match": input.CopySourceIfMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedBucketOwner) && {
                        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
                        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySource) && {
                        "x-amz-copy-source": input.CopySource
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
                        "x-amz-copy-source-if-modified-since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
                        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
                        "x-amz-copy-source-if-unmodified-since": (0, $e8dafff637da29c2$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
                        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
                        "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
                        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
                    }), $2fec21551e645b39$var$isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
                        "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
                    });
                    resolvedPath = "/{Bucket}/{Key+}";
                    if (input.Bucket !== undefined) {
                        labelValue = input.Bucket;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                        resolvedPath = resolvedPath.replace("{Bucket}", (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Bucket.");
                    if (input.Key !== undefined) {
                        labelValue = input.Key;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                        resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function(segment) {
                            return (0, $b5fbea5816c6a090$export$7640f3c16fe7f54b)(segment);
                        }).join("/"));
                    } else throw new Error("No value provided for input HTTP label: Key.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "x-id": "UploadPartCopy"
                    }, input.UploadId !== undefined && {
                        uploadId: input.UploadId
                    }), input.PartNumber !== undefined && {
                        partNumber: input.PartNumber.toString()
                    });
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, $aed66665aa7d42d3$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$87447564e9ee4b69 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchUpload":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ee5aaa25931389ce = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Bucket: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Key: undefined,
                        Location: undefined,
                        RequestCharged: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["ETag"] !== undefined) contents.ETag = data["ETag"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["Location"] !== undefined) contents.Location = data["Location"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a5d77c8b6651b993 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlCopyObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CopyObjectResult: undefined,
                        CopySourceVersionId: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyObjectResult = $2fec21551e645b39$var$deserializeAws_restXmlCopyObjectResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$b4e8f8f452bdb204 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlCreateBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Location: undefined
                    };
                    if (output.headers["location"] !== undefined) contents.Location = output.headers["location"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCreateBucketCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#BucketAlreadyExists":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$95cf7bc6357ae5a8 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Key: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c5d62536e1c56e82 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$820ce8b5969d2c78 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$dea26f8b4dad38ea = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketCorsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$48d65b1878f8cb7f = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketEncryptionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$dc33768e2651b6cb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$1660bb2bbec5b369 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketLifecycleCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ea7eb03b8f77dc6a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$649e1231e4f3b774 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$470e22ed3eb8b871 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketPolicyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a8348308c83bfe9d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketReplicationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8f5814a38b853d38 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$bc95350311fac763 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteBucketWebsiteCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$987b292ae9f16665 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        DeleteMarker: undefined,
                        RequestCharged: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ebb9378c7c531fa5 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Deleted: undefined,
                        Errors: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Deleted === "") contents.Deleted = [];
                    if (data["Deleted"] !== undefined) contents.Deleted = $2fec21551e645b39$var$deserializeAws_restXmlDeletedObjects((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Deleted"]), context);
                    if (data.Error === "") contents.Errors = [];
                    if (data["Error"] !== undefined) contents.Errors = $2fec21551e645b39$var$deserializeAws_restXmlErrors((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Error"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7021ac5189f9792d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteObjectTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$4cf24390776e8eb6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeletePublicAccessBlockCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$30393acaf6414a50 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$56e18e7cfcb102eb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $2fec21551e645b39$var$deserializeAws_restXmlGrants((0, $cb1b53da86195f79$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAclCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8103ef82db64a4aa = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        AnalyticsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.AnalyticsConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$472fdec99155a887 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CORSRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CORSRule === "") contents.CORSRules = [];
                    if (data["CORSRule"] !== undefined) contents.CORSRules = $2fec21551e645b39$var$deserializeAws_restXmlCORSRules((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CORSRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketCorsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$d83d67d0bf5676cb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ServerSideEncryptionConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ServerSideEncryptionConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketEncryptionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$cd1101fd9c222af8 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        InventoryConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.InventoryConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlInventoryConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$b85a74c7951988c1 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Rules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Rule === "") contents.Rules = [];
                    if (data["Rule"] !== undefined) contents.Rules = $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRules((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Rule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$d332d0a204c1f2de = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLocationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        LocationConstraint: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = data["LocationConstraint"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLocationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$99325a82aa21e152 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        LoggingEnabled: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $2fec21551e645b39$var$deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketLoggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$33f849a042e960f2 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        MetricsConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.MetricsConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlMetricsConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$f7ea4be33406a0a0 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        LambdaFunctionConfigurations: undefined,
                        QueueConfigurations: undefined,
                        TopicConfigurations: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
                    if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $2fec21551e645b39$var$deserializeAws_restXmlLambdaFunctionConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CloudFunctionConfiguration"]), context);
                    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
                    if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $2fec21551e645b39$var$deserializeAws_restXmlQueueConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["QueueConfiguration"]), context);
                    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
                    if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $2fec21551e645b39$var$deserializeAws_restXmlTopicConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["TopicConfiguration"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e51b6b0868913b77 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        OwnershipControls: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.OwnershipControls = $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControls(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$74beb134589fee09 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Policy: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Policy"] !== undefined) contents.Policy = data["Policy"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketPolicyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$bb27e87cf2face4 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        PolicyStatus: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PolicyStatus = $2fec21551e645b39$var$deserializeAws_restXmlPolicyStatus(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketPolicyStatusCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$640745a275665c3f = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ReplicationConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ReplicationConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlReplicationConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketReplicationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$95dd746113207b99 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Payer: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Payer"] !== undefined) contents.Payer = data["Payer"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketRequestPaymentCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e91d7dc8d3f2bb37 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        TagSet: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$87fb664bdbc56c8d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        MFADelete: undefined,
                        Status: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["MfaDelete"] !== undefined) contents.MFADelete = data["MfaDelete"];
                    if (data["Status"] !== undefined) contents.Status = data["Status"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketVersioningCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e9648c335e4af37a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ErrorDocument: undefined,
                        IndexDocument: undefined,
                        RedirectAllRequestsTo: undefined,
                        RoutingRules: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $2fec21551e645b39$var$deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
                    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $2fec21551e645b39$var$deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
                    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $2fec21551e645b39$var$deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
                    if (data.RoutingRules === "") contents.RoutingRules = [];
                    if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $2fec21551e645b39$var$deserializeAws_restXmlRoutingRules((0, $cb1b53da86195f79$export$52272e038712c64e)(data["RoutingRules"]["RoutingRule"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetBucketWebsiteCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$c8faba1b7abd4024 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $2fec21551e645b39$var$deserializeAws_restXmlGetObjectCommandError(output, context)
            ];
            contents = {
                $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                AcceptRanges: undefined,
                Body: undefined,
                CacheControl: undefined,
                ContentDisposition: undefined,
                ContentEncoding: undefined,
                ContentLanguage: undefined,
                ContentLength: undefined,
                ContentRange: undefined,
                ContentType: undefined,
                DeleteMarker: undefined,
                ETag: undefined,
                Expiration: undefined,
                Expires: undefined,
                LastModified: undefined,
                Metadata: undefined,
                MissingMeta: undefined,
                ObjectLockLegalHoldStatus: undefined,
                ObjectLockMode: undefined,
                ObjectLockRetainUntilDate: undefined,
                PartsCount: undefined,
                ReplicationStatus: undefined,
                RequestCharged: undefined,
                Restore: undefined,
                SSECustomerAlgorithm: undefined,
                SSECustomerKeyMD5: undefined,
                SSEKMSKeyId: undefined,
                ServerSideEncryption: undefined,
                StorageClass: undefined,
                TagCount: undefined,
                VersionId: undefined,
                WebsiteRedirectLocation: undefined
            };
            if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
            if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
            if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
            if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
            if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
            if (output.headers["content-range"] !== undefined) contents.ContentRange = output.headers["content-range"];
            if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
            if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
            if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
            if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
            if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
            if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
            if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
            if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
            if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
            if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
            if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
            if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
            if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
            if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
            if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
            if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
            if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
            if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
            if (output.headers["x-amz-tagging-count"] !== undefined) contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
            if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
            if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
            if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            Object.keys(output.headers).forEach(function(header) {
                if (contents.Metadata === undefined) contents.Metadata = {};
                if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
            });
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7334ba1348400806 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Grants: undefined,
                        Owner: undefined,
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AccessControlList === "") contents.Grants = [];
                    if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $2fec21551e645b39$var$deserializeAws_restXmlGrants((0, $cb1b53da86195f79$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectAclCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3fe12927f071d9c2 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        LegalHold: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.LegalHold = $2fec21551e645b39$var$deserializeAws_restXmlObjectLockLegalHold(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectLegalHoldCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8a6b0973efae922a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ObjectLockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.ObjectLockConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlObjectLockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectLockConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e8bb8c760a500abf = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Retention: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Retention = $2fec21551e645b39$var$deserializeAws_restXmlObjectLockRetention(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectRetentionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$b55a093fbe745f1a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        TagSet: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.TagSet === "") contents.TagSet = [];
                    if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$77cab76edb05348f = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $2fec21551e645b39$var$deserializeAws_restXmlGetObjectTorrentCommandError(output, context)
            ];
            contents = {
                $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                Body: undefined,
                RequestCharged: undefined
            };
            if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
            data = output.body;
            contents.Body = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetObjectTorrentCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ca2eb582f189d59e = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        PublicAccessBlockConfiguration: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.PublicAccessBlockConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGetPublicAccessBlockCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7da61a6d1be4855c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlHeadBucketCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlHeadBucketCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$6facb3b50649bd07 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlHeadObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        AcceptRanges: undefined,
                        CacheControl: undefined,
                        ContentDisposition: undefined,
                        ContentEncoding: undefined,
                        ContentLanguage: undefined,
                        ContentLength: undefined,
                        ContentType: undefined,
                        DeleteMarker: undefined,
                        ETag: undefined,
                        Expiration: undefined,
                        Expires: undefined,
                        LastModified: undefined,
                        Metadata: undefined,
                        MissingMeta: undefined,
                        ObjectLockLegalHoldStatus: undefined,
                        ObjectLockMode: undefined,
                        ObjectLockRetainUntilDate: undefined,
                        PartsCount: undefined,
                        ReplicationStatus: undefined,
                        RequestCharged: undefined,
                        Restore: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        StorageClass: undefined,
                        VersionId: undefined,
                        WebsiteRedirectLocation: undefined
                    };
                    if (output.headers["cache-control"] !== undefined) contents.CacheControl = output.headers["cache-control"];
                    if (output.headers["content-length"] !== undefined) contents.ContentLength = parseInt(output.headers["content-length"], 10);
                    if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
                    if (output.headers["content-type"] !== undefined) contents.ContentType = output.headers["content-type"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["content-disposition"] !== undefined) contents.ContentDisposition = output.headers["content-disposition"];
                    if (output.headers["content-language"] !== undefined) contents.ContentLanguage = output.headers["content-language"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["expires"] !== undefined) contents.Expires = new Date(output.headers["expires"]);
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-replication-status"] !== undefined) contents.ReplicationStatus = output.headers["x-amz-replication-status"];
                    if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
                    if (output.headers["x-amz-website-redirect-location"] !== undefined) contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-mp-parts-count"] !== undefined) contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["last-modified"] !== undefined) contents.LastModified = new Date(output.headers["last-modified"]);
                    if (output.headers["x-amz-missing-meta"] !== undefined) contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
                    if (output.headers["x-amz-restore"] !== undefined) contents.Restore = output.headers["x-amz-restore"];
                    if (output.headers["content-encoding"] !== undefined) contents.ContentEncoding = output.headers["content-encoding"];
                    if (output.headers["x-amz-storage-class"] !== undefined) contents.StorageClass = output.headers["x-amz-storage-class"];
                    if (output.headers["x-amz-delete-marker"] !== undefined) contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
                    if (output.headers["x-amz-object-lock-mode"] !== undefined) contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["accept-ranges"] !== undefined) contents.AcceptRanges = output.headers["accept-ranges"];
                    Object.keys(output.headers).forEach(function(header) {
                        if (contents.Metadata === undefined) contents.Metadata = {};
                        if (header.startsWith("x-amz-meta-")) contents.Metadata[header.substring(11)] = output.headers[header];
                    });
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7c3a4eeaff09f66a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        AnalyticsConfigurationList: undefined,
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
                    if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["AnalyticsConfiguration"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$690ef4b20b3078b6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        InventoryConfigurationList: undefined,
                        IsTruncated: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
                    if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $2fec21551e645b39$var$deserializeAws_restXmlInventoryConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["InventoryConfiguration"]), context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$906cb5e8f067f67 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ContinuationToken: undefined,
                        IsTruncated: undefined,
                        MetricsConfigurationList: undefined,
                        NextContinuationToken: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
                    if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $2fec21551e645b39$var$deserializeAws_restXmlMetricsConfigurationList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["MetricsConfiguration"]), context);
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$63be43683e761a25 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListBucketsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Buckets: undefined,
                        Owner: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.Buckets === "") contents.Buckets = [];
                    if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $2fec21551e645b39$var$deserializeAws_restXmlBuckets((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Buckets"]["Bucket"]), context);
                    if (data["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListBucketsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8da47d46285c7a0 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListMultipartUploadsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        Bucket: undefined,
                        CommonPrefixes: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxUploads: undefined,
                        NextKeyMarker: undefined,
                        NextUploadIdMarker: undefined,
                        Prefix: undefined,
                        UploadIdMarker: undefined,
                        Uploads: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefixList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxUploads"] !== undefined) contents.MaxUploads = parseInt(data["MaxUploads"]);
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = data["NextUploadIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = data["UploadIdMarker"];
                    if (data.Upload === "") contents.Uploads = [];
                    if (data["Upload"] !== undefined) contents.Uploads = $2fec21551e645b39$var$deserializeAws_restXmlMultipartUploadList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Upload"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListMultipartUploadsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$f8d39cd754f5521d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListObjectsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        Marker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextMarker: undefined,
                        Prefix: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefixList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $2fec21551e645b39$var$deserializeAws_restXmlObjectList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Marker"] !== undefined) contents.Marker = data["Marker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextMarker"] !== undefined) contents.NextMarker = data["NextMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListObjectsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$2b371fcdd686ba8b = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListObjectsV2CommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        Contents: undefined,
                        ContinuationToken: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyCount: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextContinuationToken: undefined,
                        Prefix: undefined,
                        StartAfter: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefixList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.Contents === "") contents.Contents = [];
                    if (data["Contents"] !== undefined) contents.Contents = $2fec21551e645b39$var$deserializeAws_restXmlObjectList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Contents"]), context);
                    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = data["ContinuationToken"];
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyCount"] !== undefined) contents.KeyCount = parseInt(data["KeyCount"]);
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = data["NextContinuationToken"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["StartAfter"] !== undefined) contents.StartAfter = data["StartAfter"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchBucket":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$637e7cd668cf8615 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListObjectVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CommonPrefixes: undefined,
                        DeleteMarkers: undefined,
                        Delimiter: undefined,
                        EncodingType: undefined,
                        IsTruncated: undefined,
                        KeyMarker: undefined,
                        MaxKeys: undefined,
                        Name: undefined,
                        NextKeyMarker: undefined,
                        NextVersionIdMarker: undefined,
                        Prefix: undefined,
                        VersionIdMarker: undefined,
                        Versions: undefined
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
                    if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefixList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["CommonPrefixes"]), context);
                    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
                    if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkers((0, $cb1b53da86195f79$export$52272e038712c64e)(data["DeleteMarker"]), context);
                    if (data["Delimiter"] !== undefined) contents.Delimiter = data["Delimiter"];
                    if (data["EncodingType"] !== undefined) contents.EncodingType = data["EncodingType"];
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["KeyMarker"] !== undefined) contents.KeyMarker = data["KeyMarker"];
                    if (data["MaxKeys"] !== undefined) contents.MaxKeys = parseInt(data["MaxKeys"]);
                    if (data["Name"] !== undefined) contents.Name = data["Name"];
                    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = data["NextKeyMarker"];
                    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = data["NextVersionIdMarker"];
                    if (data["Prefix"] !== undefined) contents.Prefix = data["Prefix"];
                    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = data["VersionIdMarker"];
                    if (data.Version === "") contents.Versions = [];
                    if (data["Version"] !== undefined) contents.Versions = $2fec21551e645b39$var$deserializeAws_restXmlObjectVersionList((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Version"]), context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListObjectVersionsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$584d994fd27ec2bb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlListPartsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        AbortDate: undefined,
                        AbortRuleId: undefined,
                        Bucket: undefined,
                        Initiator: undefined,
                        IsTruncated: undefined,
                        Key: undefined,
                        MaxParts: undefined,
                        NextPartNumberMarker: undefined,
                        Owner: undefined,
                        PartNumberMarker: undefined,
                        Parts: undefined,
                        RequestCharged: undefined,
                        StorageClass: undefined,
                        UploadId: undefined
                    };
                    if (output.headers["x-amz-abort-rule-id"] !== undefined) contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-abort-date"] !== undefined) contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    if (data["Bucket"] !== undefined) contents.Bucket = data["Bucket"];
                    if (data["Initiator"] !== undefined) contents.Initiator = $2fec21551e645b39$var$deserializeAws_restXmlInitiator(data["Initiator"], context);
                    if (data["IsTruncated"] !== undefined) contents.IsTruncated = data["IsTruncated"] == "true";
                    if (data["Key"] !== undefined) contents.Key = data["Key"];
                    if (data["MaxParts"] !== undefined) contents.MaxParts = parseInt(data["MaxParts"]);
                    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = parseInt(data["NextPartNumberMarker"]);
                    if (data["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(data["Owner"], context);
                    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = parseInt(data["PartNumberMarker"]);
                    if (data.Part === "") contents.Parts = [];
                    if (data["Part"] !== undefined) contents.Parts = $2fec21551e645b39$var$deserializeAws_restXmlParts((0, $cb1b53da86195f79$export$52272e038712c64e)(data["Part"]), context);
                    if (data["StorageClass"] !== undefined) contents.StorageClass = data["StorageClass"];
                    if (data["UploadId"] !== undefined) contents.UploadId = data["UploadId"];
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlListPartsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e654cd63b770e3c4 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$468a83c548434951 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAclCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$488c2e199ebb898d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3eb4d44bdf561f91 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketCorsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketCorsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$d0f1e0a2cb4f5db6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketEncryptionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a7487a3c5377a809 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9e27fb99395eb8b3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$9e24aeee62aeef65 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketLoggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketLoggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$3a85a94ca87604e2 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ec8129277a63ef1e = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8d1d3805e977d457 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$2b7b6f0e8b2cc8a1 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketPolicyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$8ea9e7fadc7c189a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketReplicationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketReplicationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$12b0ab2c5846a509 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketRequestPaymentCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$5bf4de3b4501436e = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$ef405e59c399a368 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketVersioningCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketVersioningCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$514d37c55d4fb4b5 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutBucketWebsiteCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$45bbdbf5181c3607 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ETag: undefined,
                        Expiration: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSEncryptionContext: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined,
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-context"] !== undefined) contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
                    if (output.headers["x-amz-expiration"] !== undefined) contents.Expiration = output.headers["x-amz-expiration"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$e0d1dc79dd7bc4d6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectAclCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectAclCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#NoSuchKey":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$a32f5469ffeef979 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectLegalHoldCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$470735cd3fe9e5b5 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectLockConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$5377eccfb6cedf8b = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectRetentionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectRetentionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$cecf7bb838bf1182 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutObjectTaggingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        VersionId: undefined
                    };
                    if (output.headers["x-amz-version-id"] !== undefined) contents.VersionId = output.headers["x-amz-version-id"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutObjectTaggingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$7a1b291f9ae3d668 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPutPublicAccessBlockCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$317606d55789efe9 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlRestoreObjectCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        RequestCharged: undefined,
                        RestoreOutputPath: undefined
                    };
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-restore-output-path"] !== undefined) contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlRestoreObjectCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$285881e5f25758a3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2 /*return*/ ,
                $2fec21551e645b39$var$deserializeAws_restXmlSelectObjectContentCommandError(output, context)
            ];
            contents = {
                $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                Payload: undefined
            };
            data = context.eventStreamMarshaller.deserialize(output.body, function(event) {
                return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                    var eventName, eventHeaders, eventMessage, parsedEvent;
                    var _a;
                    return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                eventName = Object.keys(event)[0];
                                eventHeaders = Object.entries(event[eventName].headers).reduce(function(accummulator, curr) {
                                    accummulator[curr[0]] = curr[1].value;
                                    return accummulator;
                                }, {});
                                eventMessage = {
                                    headers: eventHeaders,
                                    body: event[eventName].body
                                };
                                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                                return [
                                    4 /*yield*/ ,
                                    $2fec21551e645b39$var$deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _b.sent()
                                ];
                        }
                    });
                });
            });
            contents.Payload = data;
            return [
                2 /*return*/ ,
                Promise.resolve(contents)
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlSelectObjectContentCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$176ef954f1bec178 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlUploadPartCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        ETag: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["etag"] !== undefined) contents.ETag = output.headers["etag"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlUploadPartCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$export$460d1831a8acdf23 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlUploadPartCopyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output),
                        CopyPartResult: undefined,
                        CopySourceVersionId: undefined,
                        RequestCharged: undefined,
                        SSECustomerAlgorithm: undefined,
                        SSECustomerKeyMD5: undefined,
                        SSEKMSKeyId: undefined,
                        ServerSideEncryption: undefined
                    };
                    if (output.headers["x-amz-copy-source-version-id"] !== undefined) contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
                    if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
                    if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
                    if (output.headers["x-amz-request-charged"] !== undefined) contents.RequestCharged = output.headers["x-amz-request-charged"];
                    if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
                    if (output.headers["x-amz-server-side-encryption"] !== undefined) contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.CopyPartResult = $2fec21551e645b39$var$deserializeAws_restXmlCopyPartResult(data, context);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlUploadPartCopyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $2fec21551e645b39$var$loadRestXmlErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $2fec21551e645b39$var$deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlSelectObjectContentEventStream_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, _b, _c, _d, _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!(output["Cont"] !== undefined)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        (_a.Cont = _f.sent(), _a)
                    ];
                case 2:
                    if (!(output["Progress"] !== undefined)) return [
                        3 /*break*/ ,
                        4
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlProgressEvent_event(output["Progress"], context)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_b.Progress = _f.sent(), _b)
                    ];
                case 4:
                    if (!(output["Stats"] !== undefined)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlStatsEvent_event(output["Stats"], context)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        (_c.Stats = _f.sent(), _c)
                    ];
                case 6:
                    if (!(output["End"] !== undefined)) return [
                        3 /*break*/ ,
                        8
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlEndEvent_event(output["End"], context)
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        (_d.End = _f.sent(), _d)
                    ];
                case 8:
                    if (!(output["Records"] !== undefined)) return [
                        3 /*break*/ ,
                        10
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$deserializeAws_restXmlRecordsEvent_event(output["Records"], context)
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        (_e.Records = _f.sent(), _e)
                    ];
                case 10:
                    return [
                        2 /*return*/ ,
                        {
                            $unknown: output
                        }
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlContinuationEvent_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlEndEvent_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlProgressEvent_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlRecordsEvent_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {};
            contents.Payload = output.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlStatsEvent_event = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, _a;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    contents = {};
                    _a = contents;
                    return [
                        4 /*yield*/ ,
                        $2fec21551e645b39$var$parseBody(output.body, context)
                    ];
                case 1:
                    _a.Details = _b.sent();
                    return [
                        2 /*return*/ ,
                        contents
                    ];
            }
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlBucketAlreadyExistsResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyExists",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "BucketAlreadyOwnedByYou",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchBucket",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchKey",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "NoSuchUpload",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectAlreadyInActiveTierError",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ObjectNotInActiveTierError",
                $fault: "client",
                $metadata: $2fec21551e645b39$var$deserializeMetadata(parsedOutput)
            };
            data = parsedOutput.body;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlAbortIncompleteMultipartUpload = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DaysAfterInitiation").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAccelerateConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccelerateConfiguration");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketAccelerateStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAccessControlPolicy = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccessControlPolicy");
    if (input.Grants !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlGrants(input.Grants, context);
        var containerNode_1 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_1.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_1);
    }
    if (input.Owner !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAccessControlTranslation = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccessControlTranslation");
    if (input.Owner !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OwnerOverride").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Owner)).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAllowedHeaders = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AllowedHeader").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlAllowedMethods = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AllowedMethod").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlAllowedOrigins = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AllowedOrigin").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlAnalyticsAndOperator = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAnalyticsConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsConfiguration");
    if (input.StorageClassAnalysis !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAnalyticsExportDestination = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsExportDestination");
    if (input.S3BucketDestination !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAnalyticsFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsFilter");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAnalyticsAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlAnalyticsS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsS3BucketDestination");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.BucketAccountId)).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AnalyticsS3ExportFileFormat").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlBucketLifecycleConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketLifecycleConfiguration");
    if (input.Rules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlLifecycleRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlBucketLoggingStatus = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketLoggingStatus");
    if (input.LoggingEnabled !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CompletedMultipartUpload");
    if (input.Parts !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlCompletedPartList(input.Parts, context);
        nodes.map(function(node) {
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCompletedPart = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CompletedPart");
    if (input.ETag !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ETag").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ETag)).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("PartNumber").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.PartNumber))).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCompletedPartList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlCompletedPart(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlCondition = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Condition");
    if (input.KeyPrefixEquals !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("KeyPrefixEquals").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    if (input.HttpErrorCodeReturnedEquals !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("HttpErrorCodeReturnedEquals").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCORSConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CORSConfiguration");
    if (input.CORSRules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlCORSRules(input.CORSRules, context);
        nodes.map(function(node) {
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCORSRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CORSRule");
    if (input.AllowedHeaders !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
        nodes.map(function(node) {
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
        nodes.map(function(node) {
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MaxAgeSeconds").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    if (input.ExposeHeaders !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
        nodes.map(function(node) {
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
        nodes.map(function(node) {
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCORSRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlCORSRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlCreateBucketConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CreateBucketConfiguration");
    if (input.LocationConstraint !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketLocationConstraint").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.LocationConstraint)).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCSVInput = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CSVInput");
    if (input.FieldDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AllowQuotedRecordDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FileHeaderInfo !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FileHeaderInfo").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.FileHeaderInfo)).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.Comments !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Comments").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Comments)).withName("Comments");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlCSVOutput = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CSVOutput");
    if (input.FieldDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FieldDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.FieldDelimiter)).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteFields !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QuoteFields").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QuoteFields)).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QuoteCharacter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QuoteCharacter)).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QuoteEscapeCharacter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlDefaultRetention = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DefaultRetention");
    if (input.Days !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Mode !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Years !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Years").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Years))).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlDelete = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Delete");
    if (input.Objects !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlObjectIdentifierList(input.Objects, context);
        nodes.map(function(node) {
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Quiet").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Quiet))).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlDeleteMarkerReplication = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DeleteMarkerReplication");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DeleteMarkerReplicationStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlDestination = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Destination");
    if (input.EncryptionConfiguration !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Account)).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlEncryption = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Encryption");
    if (input.KMSKeyId !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.KMSKeyId)).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("KMSContext").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.KMSContext)).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionType !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.EncryptionType)).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicaKmsKeyID").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlErrorDocument = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ErrorDocument");
    if (input.Key !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlEventList = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Event").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlExistingObjectReplication = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExistingObjectReplication");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExistingObjectReplicationStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlExposeHeaders = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExposeHeader").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlFilterRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FilterRule");
    if (input.Name !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FilterRuleName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("FilterRuleValue").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlFilterRuleList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlFilterRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlGlacierJobParameters = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("GlacierJobParameters");
    if (input.Tier !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlGrant = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Grant");
    if (input.Grantee !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Permission").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlGrantee = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Grantee");
    if (input.EmailAddress !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("EmailAddress").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.EmailAddress)).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.DisplayName !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.URI !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("URI").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.URI)).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ID").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlGrants = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlGrant(entry, context);
        return node.withName("Grant");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlIndexDocument = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("IndexDocument");
    if (input.Suffix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Suffix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Suffix)).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInputSerialization = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InputSerialization");
    if (input.JSON !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("CompressionType").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.CompressionType)).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    if (input.CSV !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryConfiguration");
    if (input.IncludedObjectVersions !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryIncludedObjectVersions").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("IsEnabled").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.IsEnabled))).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Schedule !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
        var containerNode_2 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OptionalFields");
        nodes.map(function(node) {
            containerNode_2.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_2);
    }
    if (input.Destination !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryDestination = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryDestination");
    if (input.S3BucketDestination !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryEncryption = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryEncryption");
    if (input.SSEKMS !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    if (input.SSES3 !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryFilter");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryOptionalFields = function(input, context) {
    return input.map(function(entry) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryOptionalField").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(entry));
        return node.withName("Field");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlInventoryS3BucketDestination = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryS3BucketDestination");
    if (input.Format !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryFormat").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Format)).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Bucket)).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.AccountId !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccountId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.AccountId)).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlInventorySchedule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventorySchedule");
    if (input.Frequency !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("InventoryFrequency").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Frequency)).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlJSONInput = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("JSONInput");
    if (input.Type !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("JSONType").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlJSONOutput = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("JSONOutput");
    if (input.RecordDelimiter !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RecordDelimiter").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.RecordDelimiter)).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLambdaFunctionConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LambdaFunctionConfiguration");
    if (input.Events !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LambdaFunctionArn").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.LambdaFunctionArn)).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLambdaFunctionConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlLifecycleExpiration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LifecycleExpiration");
    if (input.Days !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExpiredObjectDeleteMarker").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    if (input.Date !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Date").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLifecycleRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LifecycleRule");
    if (input.NoncurrentVersionTransitions !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map(function(node) {
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Expiration !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ID").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTransitionList(input.Transitions, context);
        nodes.map(function(node) {
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.NoncurrentVersionExpiration !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExpirationStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLifecycleRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LifecycleRuleAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLifecycleRuleFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LifecycleRuleFilter");
    if (input.And !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLifecycleRuleAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlLifecycleRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlLifecycleRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlLoggingEnabled = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LoggingEnabled");
    if (input.TargetGrants !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTargetGrants(input.TargetGrants, context);
        var containerNode_3 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TargetGrants");
        nodes.map(function(node) {
            containerNode_3.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_3);
    }
    if (input.TargetBucket !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TargetBucket").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.TargetBucket)).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetPrefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TargetPrefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.TargetPrefix)).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlMetadataEntry = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetadataEntry");
    if (input.Value !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetadataValue").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    if (input.Name !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetadataKey").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Name)).withName("Name");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlMetrics = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Metrics");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetricsStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlMetricsAndOperator = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetricsAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlMetricsConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetricsConfiguration");
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetricsId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlMetricsFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MetricsFilter");
    if (input.And !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlMetricsAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionExpiration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionTransition = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NoncurrentVersionTransition");
    if (input.StorageClass !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.NoncurrentDays !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.NoncurrentDays))).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionTransitionList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlNoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlNotificationConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NotificationConfiguration");
    if (input.TopicConfigurations !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map(function(node) {
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlNotificationConfigurationFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NotificationConfigurationFilter");
    if (input.Key !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectIdentifier = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectIdentifier");
    if (input.Key !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectVersionId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.VersionId)).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectIdentifierList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectLockConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockEnabled").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectLockLegalHold = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockLegalHold");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockLegalHoldStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectLockRetention = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockRetention");
    if (input.Mode !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockRetentionMode").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Mode)).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Date").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlObjectLockRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectLockRule");
    if (input.DefaultRetention !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOutputLocation = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OutputLocation");
    if (input.S3 !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlS3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOutputSerialization = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OutputSerialization");
    if (input.JSON !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.CSV !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOwner = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Owner");
    if (input.DisplayName !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("DisplayName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.DisplayName)).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ID").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOwnershipControls = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OwnershipControls");
    if (input.Rules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOwnershipControlsRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("OwnershipControlsRule");
    if (input.ObjectOwnership !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectOwnership").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ObjectOwnership)).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlOwnershipControlsRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlOwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlParquetInput = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ParquetInput");
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlPublicAccessBlockConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("PublicAccessBlockConfiguration");
    if (input.BlockPublicPolicy !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicAcls !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Setting").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlQueueConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QueueConfiguration");
    if (input.Events !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("QueueArn").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.QueueArn)).withName("Queue");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlQueueConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlQueueConfiguration(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlRedirect = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Redirect");
    if (input.HttpRedirectCode !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("HttpRedirectCode").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.HttpRedirectCode)).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplaceKeyPrefixWith").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.HostName !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplaceKeyWith").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRedirectAllRequestsTo = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RedirectAllRequestsTo");
    if (input.Protocol !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Protocol").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Protocol)).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.HostName !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("HostName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.HostName)).withName("HostName");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationConfiguration");
    if (input.Role !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Role").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Role)).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlReplicationRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationRule");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.ID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ID").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ID)).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Priority !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Priority").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Priority))).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationRuleStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationRuleAndOperator = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationRuleAndOperator");
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTagSet(input.Tags, context);
        nodes.map(function(node) {
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationRuleFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationRuleFilter");
    if (input.Tag !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Prefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.And !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationRuleAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationTime = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationTime");
    if (input.Time !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationTimeStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlReplicationTimeValue = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ReplicationTimeValue");
    if (input.Minutes !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Minutes").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Minutes))).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRequestPaymentConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RequestPaymentConfiguration");
    if (input.Payer !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Payer").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Payer)).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRequestProgress = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RequestProgress");
    if (input.Enabled !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("EnableRequestProgress").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Enabled))).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRestoreRequest = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RestoreRequest");
    if (input.GlacierJobParameters !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Days !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Tier !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Tier").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Tier)).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Description").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Description)).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.Type !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RestoreRequestType").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Type)).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRoutingRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RoutingRule");
    if (input.Redirect !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    if (input.Condition !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlRoutingRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlRoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlS3KeyFilter = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("S3KeyFilter");
    if (input.FilterRules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlFilterRuleList(input.FilterRules, context);
        nodes.map(function(node) {
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlS3Location = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("S3Location");
    if (input.BucketName !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketName").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.BucketName)).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("StorageClass").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectCannedACL").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.CannedACL)).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlUserMetadata(input.UserMetadata, context);
        var containerNode_4 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("UserMetadata");
        nodes.map(function(node) {
            containerNode_4.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_4);
    }
    if (input.Prefix !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("LocationPrefix").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Prefix)).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tagging !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlGrants(input.AccessControlList, context);
        var containerNode_5 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("AccessControlList");
        nodes.map(function(node) {
            containerNode_5.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_5);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlScanRange = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ScanRange");
    if (input.End !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("End").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.End))).withName("End");
        bodyNode.addChildNode(node);
    }
    if (input.Start !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Start").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Start))).withName("Start");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlSelectParameters = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SelectParameters");
    if (input.ExpressionType !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ExpressionType").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.ExpressionType)).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.Expression !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Expression").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Expression)).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.InputSerialization !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionByDefault = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ServerSideEncryption").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.SSEAlgorithm)).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ServerSideEncryptionConfiguration");
    if (input.Rules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
        nodes.map(function(node) {
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionRule = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionRules = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlSourceSelectionCriteria = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlSSEKMS = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SSE-KMS");
    if (input.KeyId !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SSEKMSKeyId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.KeyId)).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlSseKmsEncryptedObjects = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SseKmsEncryptedObjects");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SseKmsEncryptedObjectsStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlSSES3 = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("SSE-S3");
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlStorageClassAnalysis = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("StorageClassAnalysis");
    if (input.DataExport !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlStorageClassAnalysisDataExport = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("StorageClassAnalysisSchemaVersion").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTag = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Tag");
    if (input.Value !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Value").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Value)).withName("Value");
        bodyNode.addChildNode(node);
    }
    if (input.Key !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("ObjectKey").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Key)).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTagging = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Tagging");
    if (input.TagSet !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlTagSet(input.TagSet, context);
        var containerNode_6 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TagSet");
        nodes.map(function(node) {
            containerNode_6.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_6);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTagSet = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTag(entry, context);
        return node.withName("Tag");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlTargetGrant = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TargetGrant");
    if (input.Grantee !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
        bodyNode.addChildNode(node);
    }
    if (input.Permission !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketLogsPermission").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Permission)).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTargetGrants = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTargetGrant(entry, context);
        return node.withName("Grant");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlTopicConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TopicConfiguration");
    if (input.Events !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlEventList(input.Events, context);
        nodes.map(function(node) {
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TopicArn").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.TopicArn)).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Id !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("NotificationId").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Id)).withName("Id");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTopicConfigurationList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTopicConfiguration(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlTransition = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Transition");
    if (input.Days !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Days").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(String(input.Days))).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Date !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("Date").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("TransitionStorageClass").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.StorageClass)).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlTransitionList = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlTransition(entry, context);
        return node.withName("member");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlUserMetadata = function(input, context) {
    return input.map(function(entry) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlMetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
var $2fec21551e645b39$var$serializeAws_restXmlVersioningConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("VersioningConfiguration");
    if (input.Status !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("BucketVersioningStatus").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.Status)).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.MFADelete !== undefined) {
        var node = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("MFADelete").addChildNode(new (0, $63836c47f6d5aed2$export$b35b8f45887823df)(input.MFADelete)).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$serializeAws_restXmlWebsiteConfiguration = function(input, context) {
    var bodyNode = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("WebsiteConfiguration");
    if (input.ErrorDocument !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument !== undefined) {
        var node = $2fec21551e645b39$var$serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules !== undefined) {
        var nodes = $2fec21551e645b39$var$serializeAws_restXmlRoutingRules(input.RoutingRules, context);
        var containerNode_7 = new (0, $24cd37c7ad60becc$export$e775a15d806cbddc)("RoutingRules");
        nodes.map(function(node) {
            containerNode_7.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode_7);
    }
    return bodyNode;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAbortIncompleteMultipartUpload = function(output, context) {
    var contents = {
        DaysAfterInitiation: undefined
    };
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAccessControlTranslation = function(output, context) {
    var contents = {
        Owner: undefined
    };
    if (output["Owner"] !== undefined) contents.Owner = output["Owner"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAllowedHeaders = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlAllowedMethods = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlAllowedOrigins = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsConfiguration = function(output, context) {
    var contents = {
        StorageClassAnalysis: undefined,
        Filter: undefined,
        Id: undefined
    };
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $2fec21551e645b39$var$deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsExportDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsFilter = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tag: undefined,
        And: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $2fec21551e645b39$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsAndOperator(output["And"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsS3BucketDestination = function(output, context) {
    var contents = {
        Prefix: undefined,
        BucketAccountId: undefined,
        Bucket: undefined,
        Format: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = output["BucketAccountId"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlBucket = function(output, context) {
    var contents = {
        CreationDate: undefined,
        Name: undefined
    };
    if (output["CreationDate"] !== undefined) contents.CreationDate = new Date(output["CreationDate"]);
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlBuckets = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlBucket(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefix = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefixList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlCommonPrefix(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlCondition = function(output, context) {
    var contents = {
        KeyPrefixEquals: undefined,
        HttpErrorCodeReturnedEquals: undefined
    };
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = output["KeyPrefixEquals"];
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlCopyObjectResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlCopyPartResult = function(output, context) {
    var contents = {
        ETag: undefined,
        LastModified: undefined
    };
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlCORSRule = function(output, context) {
    var contents = {
        AllowedHeaders: undefined,
        AllowedOrigins: undefined,
        MaxAgeSeconds: undefined,
        ExposeHeaders: undefined,
        AllowedMethods: undefined
    };
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $2fec21551e645b39$var$deserializeAws_restXmlAllowedHeaders((0, $cb1b53da86195f79$export$52272e038712c64e)(output["AllowedHeader"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $2fec21551e645b39$var$deserializeAws_restXmlAllowedOrigins((0, $cb1b53da86195f79$export$52272e038712c64e)(output["AllowedOrigin"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $2fec21551e645b39$var$deserializeAws_restXmlExposeHeaders((0, $cb1b53da86195f79$export$52272e038712c64e)(output["ExposeHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $2fec21551e645b39$var$deserializeAws_restXmlAllowedMethods((0, $cb1b53da86195f79$export$52272e038712c64e)(output["AllowedMethod"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlCORSRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlCORSRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDefaultRetention = function(output, context) {
    var contents = {
        Days: undefined,
        Mode: undefined,
        Years: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["Years"] !== undefined) contents.Years = parseInt(output["Years"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeletedObject = function(output, context) {
    var contents = {
        DeleteMarker: undefined,
        Key: undefined,
        VersionId: undefined,
        DeleteMarkerVersionId: undefined
    };
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = output["DeleteMarker"] == "true";
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeletedObjects = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlDeletedObject(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkerEntry = function(output, context) {
    var contents = {
        VersionId: undefined,
        LastModified: undefined,
        Key: undefined,
        IsLatest: undefined,
        Owner: undefined
    };
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(output["Owner"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkerReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkers = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkerEntry(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlDestination = function(output, context) {
    var contents = {
        EncryptionConfiguration: undefined,
        Bucket: undefined,
        Account: undefined,
        StorageClass: undefined,
        Metrics: undefined,
        AccessControlTranslation: undefined,
        ReplicationTime: undefined
    };
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $2fec21551e645b39$var$deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["Account"] !== undefined) contents.Account = output["Account"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Metrics"] !== undefined) contents.Metrics = $2fec21551e645b39$var$deserializeAws_restXmlMetrics(output["Metrics"], context);
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $2fec21551e645b39$var$deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $2fec21551e645b39$var$deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlEncryptionConfiguration = function(output, context) {
    var contents = {
        ReplicaKmsKeyID: undefined
    };
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXml_Error = function(output, context) {
    var contents = {
        Message: undefined,
        Code: undefined,
        Key: undefined,
        VersionId: undefined
    };
    if (output["Message"] !== undefined) contents.Message = output["Message"];
    if (output["Code"] !== undefined) contents.Code = output["Code"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlErrorDocument = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlErrors = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXml_Error(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlEventList = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlExistingObjectReplication = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlExposeHeaders = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlFilterRule = function(output, context) {
    var contents = {
        Name: undefined,
        Value: undefined
    };
    if (output["Name"] !== undefined) contents.Name = output["Name"];
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlFilterRuleList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlFilterRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $2fec21551e645b39$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlGrantee = function(output, context) {
    var contents = {
        EmailAddress: undefined,
        DisplayName: undefined,
        URI: undefined,
        ID: undefined,
        Type: undefined
    };
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = output["EmailAddress"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["URI"] !== undefined) contents.URI = output["URI"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["xsi:type"] !== undefined) contents.Type = output["xsi:type"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlGrants = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlGrant(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlIndexDocument = function(output, context) {
    var contents = {
        Suffix: undefined
    };
    if (output["Suffix"] !== undefined) contents.Suffix = output["Suffix"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInitiator = function(output, context) {
    var contents = {
        ID: undefined,
        DisplayName: undefined
    };
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryConfiguration = function(output, context) {
    var contents = {
        IncludedObjectVersions: undefined,
        IsEnabled: undefined,
        Schedule: undefined,
        Filter: undefined,
        OptionalFields: undefined,
        Destination: undefined,
        Id: undefined
    };
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = output["IncludedObjectVersions"];
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = output["IsEnabled"] == "true";
    if (output["Schedule"] !== undefined) contents.Schedule = $2fec21551e645b39$var$deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlInventoryFilter(output["Filter"], context);
    if (output.OptionalFields === "") contents.OptionalFields = [];
    if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $2fec21551e645b39$var$deserializeAws_restXmlInventoryOptionalFields((0, $cb1b53da86195f79$export$52272e038712c64e)(output["OptionalFields"]["Field"]), context);
    if (output["Destination"] !== undefined) contents.Destination = $2fec21551e645b39$var$deserializeAws_restXmlInventoryDestination(output["Destination"], context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlInventoryConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryDestination = function(output, context) {
    var contents = {
        S3BucketDestination: undefined
    };
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $2fec21551e645b39$var$deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryEncryption = function(output, context) {
    var contents = {
        SSEKMS: undefined,
        SSES3: undefined
    };
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $2fec21551e645b39$var$deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $2fec21551e645b39$var$deserializeAws_restXmlSSES3(output["SSE-S3"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryFilter = function(output, context) {
    var contents = {
        Prefix: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryOptionalFields = function(output, context) {
    return (output || []).map(function(entry) {
        return entry;
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventoryS3BucketDestination = function(output, context) {
    var contents = {
        Format: undefined,
        Encryption: undefined,
        Prefix: undefined,
        Bucket: undefined,
        AccountId: undefined
    };
    if (output["Format"] !== undefined) contents.Format = output["Format"];
    if (output["Encryption"] !== undefined) contents.Encryption = $2fec21551e645b39$var$deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Bucket"] !== undefined) contents.Bucket = output["Bucket"];
    if (output["AccountId"] !== undefined) contents.AccountId = output["AccountId"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlInventorySchedule = function(output, context) {
    var contents = {
        Frequency: undefined
    };
    if (output["Frequency"] !== undefined) contents.Frequency = output["Frequency"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLambdaFunctionConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Filter: undefined,
        LambdaFunctionArn: undefined,
        Id: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $2fec21551e645b39$var$deserializeAws_restXmlEventList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = output["CloudFunction"];
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLambdaFunctionConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlLifecycleExpiration = function(output, context) {
    var contents = {
        Days: undefined,
        ExpiredObjectDeleteMarker: undefined,
        Date: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRule = function(output, context) {
    var contents = {
        NoncurrentVersionTransitions: undefined,
        Expiration: undefined,
        ID: undefined,
        Transitions: undefined,
        Prefix: undefined,
        NoncurrentVersionExpiration: undefined,
        AbortIncompleteMultipartUpload: undefined,
        Filter: undefined,
        Status: undefined
    };
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionTransitionList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["NoncurrentVersionTransition"]), context);
    if (output["Expiration"] !== undefined) contents.Expiration = $2fec21551e645b39$var$deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output.Transition === "") contents.Transitions = [];
    if (output["Transition"] !== undefined) contents.Transitions = $2fec21551e645b39$var$deserializeAws_restXmlTransitionList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Transition"]), context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $2fec21551e645b39$var$deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRuleFilter = function(output, context) {
    var contents = {
        And: undefined,
        Prefix: undefined,
        Tag: undefined
    };
    if (output["And"] !== undefined) contents.And = $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $2fec21551e645b39$var$deserializeAws_restXmlTag(output["Tag"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlLifecycleRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlLoggingEnabled = function(output, context) {
    var contents = {
        TargetGrants: undefined,
        TargetBucket: undefined,
        TargetPrefix: undefined
    };
    if (output.TargetGrants === "") contents.TargetGrants = [];
    if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $2fec21551e645b39$var$deserializeAws_restXmlTargetGrants((0, $cb1b53da86195f79$export$52272e038712c64e)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = output["TargetBucket"];
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = output["TargetPrefix"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMetrics = function(output, context) {
    var contents = {
        Status: undefined,
        EventThreshold: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $2fec21551e645b39$var$deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMetricsAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMetricsConfiguration = function(output, context) {
    var contents = {
        Id: undefined,
        Filter: undefined
    };
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlMetricsFilter(output["Filter"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMetricsConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlMetricsConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlMetricsFilter = function(output, context) {
    var contents = {
        And: undefined,
        Prefix: undefined,
        Tag: undefined
    };
    if (output["And"] !== undefined) contents.And = $2fec21551e645b39$var$deserializeAws_restXmlMetricsAndOperator(output["And"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["Tag"] !== undefined) contents.Tag = $2fec21551e645b39$var$deserializeAws_restXmlTag(output["Tag"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMultipartUpload = function(output, context) {
    var contents = {
        Initiator: undefined,
        UploadId: undefined,
        Key: undefined,
        Owner: undefined,
        StorageClass: undefined,
        Initiated: undefined
    };
    if (output["Initiator"] !== undefined) contents.Initiator = $2fec21551e645b39$var$deserializeAws_restXmlInitiator(output["Initiator"], context);
    if (output["UploadId"] !== undefined) contents.UploadId = output["UploadId"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Initiated"] !== undefined) contents.Initiated = new Date(output["Initiated"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlMultipartUploadList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlMultipartUpload(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionExpiration = function(output, context) {
    var contents = {
        NoncurrentDays: undefined
    };
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionTransition = function(output, context) {
    var contents = {
        StorageClass: undefined,
        NoncurrentDays: undefined
    };
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionTransitionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlNotificationConfigurationFilter = function(output, context) {
    var contents = {
        Key: undefined
    };
    if (output["S3Key"] !== undefined) contents.Key = $2fec21551e645b39$var$deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXml_Object = function(output, context) {
    var contents = {
        Size: undefined,
        ETag: undefined,
        Owner: undefined,
        StorageClass: undefined,
        Key: undefined,
        LastModified: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXml_Object(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectLockConfiguration = function(output, context) {
    var contents = {
        ObjectLockEnabled: undefined,
        Rule: undefined
    };
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = output["ObjectLockEnabled"];
    if (output["Rule"] !== undefined) contents.Rule = $2fec21551e645b39$var$deserializeAws_restXmlObjectLockRule(output["Rule"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectLockLegalHold = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectLockRetention = function(output, context) {
    var contents = {
        Mode: undefined,
        RetainUntilDate: undefined
    };
    if (output["Mode"] !== undefined) contents.Mode = output["Mode"];
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectLockRule = function(output, context) {
    var contents = {
        DefaultRetention: undefined
    };
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $2fec21551e645b39$var$deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectVersion = function(output, context) {
    var contents = {
        Size: undefined,
        Key: undefined,
        StorageClass: undefined,
        Owner: undefined,
        IsLatest: undefined,
        ETag: undefined,
        LastModified: undefined,
        VersionId: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    if (output["Owner"] !== undefined) contents.Owner = $2fec21551e645b39$var$deserializeAws_restXmlOwner(output["Owner"], context);
    if (output["IsLatest"] !== undefined) contents.IsLatest = output["IsLatest"] == "true";
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["VersionId"] !== undefined) contents.VersionId = output["VersionId"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlObjectVersionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlObjectVersion(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlOwner = function(output, context) {
    var contents = {
        DisplayName: undefined,
        ID: undefined
    };
    if (output["DisplayName"] !== undefined) contents.DisplayName = output["DisplayName"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControls = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControlsRules((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControlsRule = function(output, context) {
    var contents = {
        ObjectOwnership: undefined
    };
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = output["ObjectOwnership"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControlsRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlOwnershipControlsRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPart = function(output, context) {
    var contents = {
        Size: undefined,
        LastModified: undefined,
        PartNumber: undefined,
        ETag: undefined
    };
    if (output["Size"] !== undefined) contents.Size = parseInt(output["Size"]);
    if (output["LastModified"] !== undefined) contents.LastModified = new Date(output["LastModified"]);
    if (output["PartNumber"] !== undefined) contents.PartNumber = parseInt(output["PartNumber"]);
    if (output["ETag"] !== undefined) contents.ETag = output["ETag"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlParts = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlPart(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlPolicyStatus = function(output, context) {
    var contents = {
        IsPublic: undefined
    };
    if (output["IsPublic"] !== undefined) contents.IsPublic = output["IsPublic"] == "true";
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlPublicAccessBlockConfiguration = function(output, context) {
    var contents = {
        BlockPublicPolicy: undefined,
        BlockPublicAcls: undefined,
        RestrictPublicBuckets: undefined,
        IgnorePublicAcls: undefined
    };
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlQueueConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Id: undefined,
        Filter: undefined,
        QueueArn: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $2fec21551e645b39$var$deserializeAws_restXmlEventList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Event"]), context);
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["Queue"] !== undefined) contents.QueueArn = output["Queue"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlQueueConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlQueueConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlRedirect = function(output, context) {
    var contents = {
        HttpRedirectCode: undefined,
        ReplaceKeyPrefixWith: undefined,
        Protocol: undefined,
        HostName: undefined,
        ReplaceKeyWith: undefined
    };
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = output["HttpRedirectCode"];
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = output["ReplaceKeyWith"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlRedirectAllRequestsTo = function(output, context) {
    var contents = {
        Protocol: undefined,
        HostName: undefined
    };
    if (output["Protocol"] !== undefined) contents.Protocol = output["Protocol"];
    if (output["HostName"] !== undefined) contents.HostName = output["HostName"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationConfiguration = function(output, context) {
    var contents = {
        Role: undefined,
        Rules: undefined
    };
    if (output["Role"] !== undefined) contents.Role = output["Role"];
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $2fec21551e645b39$var$deserializeAws_restXmlReplicationRules((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationRule = function(output, context) {
    var contents = {
        Prefix: undefined,
        ID: undefined,
        SourceSelectionCriteria: undefined,
        DeleteMarkerReplication: undefined,
        Filter: undefined,
        Priority: undefined,
        Status: undefined,
        ExistingObjectReplication: undefined,
        Destination: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["ID"] !== undefined) contents.ID = output["ID"];
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $2fec21551e645b39$var$deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $2fec21551e645b39$var$deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
    if (output["Priority"] !== undefined) contents.Priority = parseInt(output["Priority"]);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $2fec21551e645b39$var$deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $2fec21551e645b39$var$deserializeAws_restXmlDestination(output["Destination"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationRuleAndOperator = function(output, context) {
    var contents = {
        Prefix: undefined,
        Tags: undefined
    };
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output.Tag === "") contents.Tags = [];
    if (output["Tag"] !== undefined) contents.Tags = $2fec21551e645b39$var$deserializeAws_restXmlTagSet((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationRuleFilter = function(output, context) {
    var contents = {
        Tag: undefined,
        Prefix: undefined,
        And: undefined
    };
    if (output["Tag"] !== undefined) contents.Tag = $2fec21551e645b39$var$deserializeAws_restXmlTag(output["Tag"], context);
    if (output["Prefix"] !== undefined) contents.Prefix = output["Prefix"];
    if (output["And"] !== undefined) contents.And = $2fec21551e645b39$var$deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlReplicationRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationTime = function(output, context) {
    var contents = {
        Time: undefined,
        Status: undefined
    };
    if (output["Time"] !== undefined) contents.Time = $2fec21551e645b39$var$deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlReplicationTimeValue = function(output, context) {
    var contents = {
        Minutes: undefined
    };
    if (output["Minutes"] !== undefined) contents.Minutes = parseInt(output["Minutes"]);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlRoutingRule = function(output, context) {
    var contents = {
        Redirect: undefined,
        Condition: undefined
    };
    if (output["Redirect"] !== undefined) contents.Redirect = $2fec21551e645b39$var$deserializeAws_restXmlRedirect(output["Redirect"], context);
    if (output["Condition"] !== undefined) contents.Condition = $2fec21551e645b39$var$deserializeAws_restXmlCondition(output["Condition"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlRoutingRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlRoutingRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlS3KeyFilter = function(output, context) {
    var contents = {
        FilterRules: undefined
    };
    if (output.FilterRule === "") contents.FilterRules = [];
    if (output["FilterRule"] !== undefined) contents.FilterRules = $2fec21551e645b39$var$deserializeAws_restXmlFilterRuleList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["FilterRule"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionByDefault = function(output, context) {
    var contents = {
        SSEAlgorithm: undefined,
        KMSMasterKeyID: undefined
    };
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = output["SSEAlgorithm"];
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = output["KMSMasterKeyID"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionConfiguration = function(output, context) {
    var contents = {
        Rules: undefined
    };
    if (output.Rule === "") contents.Rules = [];
    if (output["Rule"] !== undefined) contents.Rules = $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionRules((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionRule = function(output, context) {
    var contents = {
        ApplyServerSideEncryptionByDefault: undefined
    };
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionRules = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlServerSideEncryptionRule(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlSourceSelectionCriteria = function(output, context) {
    var contents = {
        SseKmsEncryptedObjects: undefined
    };
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $2fec21551e645b39$var$deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlSSEKMS = function(output, context) {
    var contents = {
        KeyId: undefined
    };
    if (output["KeyId"] !== undefined) contents.KeyId = output["KeyId"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlSseKmsEncryptedObjects = function(output, context) {
    var contents = {
        Status: undefined
    };
    if (output["Status"] !== undefined) contents.Status = output["Status"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlSSES3 = function(output, context) {
    var contents = {};
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlStorageClassAnalysis = function(output, context) {
    var contents = {
        DataExport: undefined
    };
    if (output["DataExport"] !== undefined) contents.DataExport = $2fec21551e645b39$var$deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlStorageClassAnalysisDataExport = function(output, context) {
    var contents = {
        OutputSchemaVersion: undefined,
        Destination: undefined
    };
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = output["OutputSchemaVersion"];
    if (output["Destination"] !== undefined) contents.Destination = $2fec21551e645b39$var$deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlTag = function(output, context) {
    var contents = {
        Value: undefined,
        Key: undefined
    };
    if (output["Value"] !== undefined) contents.Value = output["Value"];
    if (output["Key"] !== undefined) contents.Key = output["Key"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlTagSet = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlTag(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlTargetGrant = function(output, context) {
    var contents = {
        Grantee: undefined,
        Permission: undefined
    };
    if (output["Grantee"] !== undefined) contents.Grantee = $2fec21551e645b39$var$deserializeAws_restXmlGrantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = output["Permission"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlTargetGrants = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlTargetGrant(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlTopicConfiguration = function(output, context) {
    var contents = {
        Events: undefined,
        Filter: undefined,
        TopicArn: undefined,
        Id: undefined
    };
    if (output.Event === "") contents.Events = [];
    if (output["Event"] !== undefined) contents.Events = $2fec21551e645b39$var$deserializeAws_restXmlEventList((0, $cb1b53da86195f79$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $2fec21551e645b39$var$deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
    if (output["Topic"] !== undefined) contents.TopicArn = output["Topic"];
    if (output["Id"] !== undefined) contents.Id = output["Id"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlTopicConfigurationList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlTopicConfiguration(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeAws_restXmlTransition = function(output, context) {
    var contents = {
        Days: undefined,
        Date: undefined,
        StorageClass: undefined
    };
    if (output["Days"] !== undefined) contents.Days = parseInt(output["Days"]);
    if (output["Date"] !== undefined) contents.Date = new Date(output["Date"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = output["StorageClass"];
    return contents;
};
var $2fec21551e645b39$var$deserializeAws_restXmlTransitionList = function(output, context) {
    return (output || []).map(function(entry) {
        return $2fec21551e645b39$var$deserializeAws_restXmlTransition(entry, context);
    });
};
var $2fec21551e645b39$var$deserializeMetadata = function(output) {
    return {
        httpStatusCode: output.statusCode,
        httpHeaders: output.headers,
        requestId: output.headers["x-amzn-requestid"]
    };
};
// Collect low-level response body stream to Uint8Array.
var $2fec21551e645b39$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var $2fec21551e645b39$var$collectBodyString = function(streamBody, context) {
    return $2fec21551e645b39$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $2fec21551e645b39$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $2fec21551e645b39$var$decodeEscapedXML = function(str) {
    return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var $2fec21551e645b39$var$parseBody = function(streamBody, context) {
    return $2fec21551e645b39$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) {
            var parsedObj = (0, $7bae4596bfd15ae4$export$98e6a39c04603d36)(encoded, {
                attributeNamePrefix: "",
                ignoreAttributes: false,
                parseNodeValue: false,
                tagValueProcessor: function(val, tagName) {
                    return $2fec21551e645b39$var$decodeEscapedXML(val);
                }
            });
            var textNodeName = "#text";
            var key = Object.keys(parsedObj)[0];
            var parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $398e8cd657eaeefc$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
};
var $2fec21551e645b39$var$loadRestXmlErrorCode = function(output, data) {
    if (data.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
    return "";
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $be3b098005916c7e$var$extendStatics = function(d, b) {
    $be3b098005916c7e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $be3b098005916c7e$var$extendStatics(d, b);
};
function $be3b098005916c7e$export$a8ba968b8961cb8a(d, b) {
    $be3b098005916c7e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $be3b098005916c7e$export$18ce0697a983be9b = function() {
    $be3b098005916c7e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be3b098005916c7e$export$18ce0697a983be9b.apply(this, arguments);
};
function $be3b098005916c7e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $be3b098005916c7e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $be3b098005916c7e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $be3b098005916c7e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $be3b098005916c7e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $be3b098005916c7e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $be3b098005916c7e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $be3b098005916c7e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $be3b098005916c7e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $be3b098005916c7e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $be3b098005916c7e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($be3b098005916c7e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $be3b098005916c7e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $be3b098005916c7e$export$10c90e4f7922046c(v) {
    return this instanceof $be3b098005916c7e$export$10c90e4f7922046c ? (this.v = v, this) : new $be3b098005916c7e$export$10c90e4f7922046c(v);
}
function $be3b098005916c7e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $be3b098005916c7e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $be3b098005916c7e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $be3b098005916c7e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $be3b098005916c7e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $be3b098005916c7e$export$19a8beecd37a4c45 === "function" ? $be3b098005916c7e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $be3b098005916c7e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $be3b098005916c7e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $be3b098005916c7e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $be3b098005916c7e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $be3b098005916c7e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2b27b55b7528732d$var$extendStatics = function(d, b) {
    $2b27b55b7528732d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2b27b55b7528732d$var$extendStatics(d, b);
};
function $2b27b55b7528732d$export$a8ba968b8961cb8a(d, b) {
    $2b27b55b7528732d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2b27b55b7528732d$export$18ce0697a983be9b = function() {
    $2b27b55b7528732d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b27b55b7528732d$export$18ce0697a983be9b.apply(this, arguments);
};
function $2b27b55b7528732d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2b27b55b7528732d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2b27b55b7528732d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2b27b55b7528732d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2b27b55b7528732d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2b27b55b7528732d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2b27b55b7528732d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2b27b55b7528732d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2b27b55b7528732d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2b27b55b7528732d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2b27b55b7528732d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2b27b55b7528732d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2b27b55b7528732d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2b27b55b7528732d$export$10c90e4f7922046c(v) {
    return this instanceof $2b27b55b7528732d$export$10c90e4f7922046c ? (this.v = v, this) : new $2b27b55b7528732d$export$10c90e4f7922046c(v);
}
function $2b27b55b7528732d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2b27b55b7528732d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2b27b55b7528732d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2b27b55b7528732d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2b27b55b7528732d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2b27b55b7528732d$export$19a8beecd37a4c45 === "function" ? $2b27b55b7528732d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2b27b55b7528732d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2b27b55b7528732d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2b27b55b7528732d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2b27b55b7528732d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2b27b55b7528732d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $02187c72392c16cb$export$a22775fa5e2eebd9 = function(str) {
    return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var $02187c72392c16cb$export$98e6a39c04603d36 = function(arn) {
    var segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    var _a = (0, $2b27b55b7528732d$export$8d051b38c9118094)(segments), //Skip "arn" literal
    partition = _a[1], service = _a[2], region = _a[3], accountId = _a[4], resource = _a.slice(5);
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
var $02187c72392c16cb$export$3f8fe6489e95757d = function(arnObject) {
    var _a = arnObject.partition, partition = _a === void 0 ? "aws" : _a, service = arnObject.service, region = arnObject.region, accountId = arnObject.accountId, resource = arnObject.resource;
    if ([
        service,
        region,
        accountId,
        resource
    ].some(function(segment) {
        return typeof segment !== "string";
    })) throw new Error("Input ARN object is invalid");
    return "arn:" + partition + ":" + service + ":" + region + ":" + accountId + ":" + resource;
};




var $f483e3f661d5b0cc$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var $f483e3f661d5b0cc$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var $f483e3f661d5b0cc$var$DOTS_PATTERN = /\.\./;
var $f483e3f661d5b0cc$export$b0b24e5455be29b0 = /\./;
var $f483e3f661d5b0cc$export$43f53815580748f = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var $f483e3f661d5b0cc$var$S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var $f483e3f661d5b0cc$var$AWS_PARTITION_SUFFIX = "amazonaws.com";
var $f483e3f661d5b0cc$export$5b522ec9d0d23583 = function(options) {
    return typeof options.bucketName === "string";
};
var $f483e3f661d5b0cc$export$2041e7d2db741fc6 = function(region) {
    return $f483e3f661d5b0cc$var$isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var $f483e3f661d5b0cc$export$360a1e07839d0d27 = function(bucketName) {
    return $f483e3f661d5b0cc$var$DOMAIN_PATTERN.test(bucketName) && !$f483e3f661d5b0cc$var$IP_ADDRESS_PATTERN.test(bucketName) && !$f483e3f661d5b0cc$var$DOTS_PATTERN.test(bucketName);
};
var $f483e3f661d5b0cc$var$getRegionalSuffix = function(hostname) {
    var parts = hostname.match($f483e3f661d5b0cc$export$43f53815580748f);
    return [
        parts[2],
        hostname.replace(new RegExp("^" + parts[0]), "")
    ];
};
var $f483e3f661d5b0cc$export$661d620f7edbf69d = function(hostname) {
    return $f483e3f661d5b0cc$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        "us-east-1",
        $f483e3f661d5b0cc$var$AWS_PARTITION_SUFFIX
    ] : $f483e3f661d5b0cc$var$getRegionalSuffix(hostname);
};
var $f483e3f661d5b0cc$export$9822f1db281a24ef = function(hostname) {
    return $f483e3f661d5b0cc$var$S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [
        hostname.replace("." + $f483e3f661d5b0cc$var$AWS_PARTITION_SUFFIX, ""),
        $f483e3f661d5b0cc$var$AWS_PARTITION_SUFFIX
    ] : $f483e3f661d5b0cc$var$getRegionalSuffix(hostname);
};
var $f483e3f661d5b0cc$export$9d570635889bea10 = function(options) {
    if (options.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
    if (options.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
    if (!options.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN");
};
var $f483e3f661d5b0cc$export$56395344d8f6da92 = function(service) {
    if (service !== "s3" && service !== "s3-outposts") throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
};
var $f483e3f661d5b0cc$export$ee796dc843960f7e = function(service) {
    if (service !== "s3") throw new Error("Expect 's3' in Accesspoint ARN service component");
};
var $f483e3f661d5b0cc$export$32ff3a9330dbd031 = function(service) {
    if (service !== "s3-outposts") throw new Error("Expect 's3-posts' in Outpost ARN service component");
};
var $f483e3f661d5b0cc$export$2514cb957fb286b = function(partition, options) {
    if (partition !== options.clientPartition) throw new Error("Partition in ARN is incompatible, got \"" + partition + "\" but expected \"" + options.clientPartition + "\"");
};
var $f483e3f661d5b0cc$export$6cc2fb0ca7159d47 = function(region, options) {
    if (region === "") throw new Error("ARN region is empty");
    if (!options.useArnRegion && !$f483e3f661d5b0cc$var$isEqualRegions(region, options.clientRegion) && !$f483e3f661d5b0cc$var$isEqualRegions(region, options.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
    if (options.useArnRegion && $f483e3f661d5b0cc$var$isFipsRegion(region)) throw new Error("Endpoint does not support FIPS region");
};
var $f483e3f661d5b0cc$var$isFipsRegion = function(region) {
    return region.startsWith("fips-") || region.endsWith("-fips");
};
var $f483e3f661d5b0cc$var$isEqualRegions = function(regionA, regionB) {
    return regionA === regionB || $f483e3f661d5b0cc$export$2041e7d2db741fc6(regionA) === regionB || regionA === $f483e3f661d5b0cc$export$2041e7d2db741fc6(regionB);
};
var $f483e3f661d5b0cc$export$311f0c1e79834f5a = function(accountId) {
    if (!/[0-9]{12}/.exec(accountId)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
};
var $f483e3f661d5b0cc$export$eab3c0a6ee9b0457 = function(label, options) {
    if (options === void 0) options = {
        tlsCompatible: true
    };
    // reference: https://tools.ietf.org/html/rfc3986#section-3.2.2
    if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && $f483e3f661d5b0cc$export$b0b24e5455be29b0.test(label)) throw new Error("Invalid DNS label " + label);
};
var $f483e3f661d5b0cc$export$6b274ce9ea6c3c3a = function(resource) {
    var delimiter = resource.includes(":") ? ":" : "/";
    var _a = (0, $be3b098005916c7e$export$8d051b38c9118094)(resource.split(delimiter)), resourceType = _a[0], rest = _a.slice(1);
    if (resourceType === "accesspoint") {
        // Parse accesspoint ARN
        if (rest.length !== 1 || rest[0] === "") throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
        return {
            accesspointName: rest[0]
        };
    } else if (resourceType === "outpost") {
        // Parse outpost ARN
        if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
        var _b = (0, $be3b098005916c7e$export$8d051b38c9118094)(rest, 3), outpostId = _b[0], _ = _b[1], accesspointName = _b[2];
        return {
            outpostId: outpostId,
            accesspointName: accesspointName
        };
    } else throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
};
var $f483e3f661d5b0cc$export$76b09f028141bdfc = function(dualstackEndpoint) {
    if (dualstackEndpoint) throw new Error("Dualstack endpoint is not supported with Outpost");
};
var $f483e3f661d5b0cc$export$8b4c0cb10287799f = function(region) {
    if ($f483e3f661d5b0cc$var$isFipsRegion(region !== null && region !== void 0 ? region : "")) throw new Error("FIPS region is not supported with Outpost, got " + region);
};


var $a82b8a8e52329b10$export$92dc36ff3a4794f7 = function(options) {
    var baseHostname = options.baseHostname;
    if (!(0, $f483e3f661d5b0cc$export$43f53815580748f).test(baseHostname)) return {
        bucketEndpoint: false,
        hostname: baseHostname
    };
    return (0, $f483e3f661d5b0cc$export$5b522ec9d0d23583)(options) ? $a82b8a8e52329b10$var$getEndpointFromBucketName(options) : $a82b8a8e52329b10$var$getEndpointFromArn(options);
};
var $a82b8a8e52329b10$var$getEndpointFromArn = function(options) {
    // Infer client region and hostname suffix from hostname from endpoints.json, like `s3.us-west-2.amazonaws.com`
    var _a = (0, $be3b098005916c7e$export$8d051b38c9118094)((0, $f483e3f661d5b0cc$export$9822f1db281a24ef)(options.baseHostname), 2), clientRegion = _a[0], hostnameSuffix = _a[1];
    var pathStyleEndpoint = options.pathStyleEndpoint, _b = options.dualstackEndpoint, dualstackEndpoint = _b === void 0 ? false : _b, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
    (0, $f483e3f661d5b0cc$export$9d570635889bea10)({
        pathStyleEndpoint: pathStyleEndpoint,
        accelerateEndpoint: accelerateEndpoint,
        tlsCompatible: tlsCompatible
    });
    // Validate and parse the ARN supplied as a bucket name
    var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
    (0, $f483e3f661d5b0cc$export$56395344d8f6da92)(service);
    (0, $f483e3f661d5b0cc$export$2514cb957fb286b)(partition, {
        clientPartition: clientPartition
    });
    (0, $f483e3f661d5b0cc$export$311f0c1e79834f5a)(accountId);
    (0, $f483e3f661d5b0cc$export$6cc2fb0ca7159d47)(region, {
        useArnRegion: useArnRegion,
        clientRegion: clientRegion,
        clientSigningRegion: clientSigningRegion
    });
    var _g = (0, $f483e3f661d5b0cc$export$6b274ce9ea6c3c3a)(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
    (0, $f483e3f661d5b0cc$export$eab3c0a6ee9b0457)(accesspointName + "-" + accountId, {
        tlsCompatible: tlsCompatible
    });
    var endpointRegion = useArnRegion ? region : clientRegion;
    var signingRegion = useArnRegion ? region : clientSigningRegion;
    if (outpostId) {
        // if this is an Outpost ARN
        (0, $f483e3f661d5b0cc$export$32ff3a9330dbd031)(service);
        (0, $f483e3f661d5b0cc$export$eab3c0a6ee9b0457)(outpostId, {
            tlsCompatible: tlsCompatible
        });
        (0, $f483e3f661d5b0cc$export$76b09f028141bdfc)(dualstackEndpoint);
        (0, $f483e3f661d5b0cc$export$8b4c0cb10287799f)(endpointRegion);
        return {
            bucketEndpoint: true,
            hostname: accesspointName + "-" + accountId + "." + outpostId + ".s3-outposts." + endpointRegion + "." + hostnameSuffix,
            signingRegion: signingRegion,
            signingService: "s3-outposts"
        };
    }
    // construct endpoint from Accesspoint ARN
    (0, $f483e3f661d5b0cc$export$ee796dc843960f7e)(service);
    return {
        bucketEndpoint: true,
        hostname: accesspointName + "-" + accountId + ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion + "." + hostnameSuffix,
        signingRegion: signingRegion
    };
};
var $a82b8a8e52329b10$var$getEndpointFromBucketName = function(_a) {
    var _b = _a.accelerateEndpoint, accelerateEndpoint = _b === void 0 ? false : _b, baseHostname = _a.baseHostname, bucketName = _a.bucketName, _c = _a.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e;
    var _f = (0, $be3b098005916c7e$export$8d051b38c9118094)((0, $f483e3f661d5b0cc$export$661d620f7edbf69d)(baseHostname), 2), clientRegion = _f[0], hostnameSuffix = _f[1];
    if (pathStyleEndpoint || !(0, $f483e3f661d5b0cc$export$360a1e07839d0d27)(bucketName) || tlsCompatible && (0, $f483e3f661d5b0cc$export$b0b24e5455be29b0).test(bucketName)) return {
        bucketEndpoint: false,
        hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
    if (accelerateEndpoint) baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
    else if (dualstackEndpoint) baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
    return {
        bucketEndpoint: true,
        hostname: bucketName + "." + baseHostname
    };
};



var $3ea9352152ab0cfd$export$f49f3b47ec112939 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $be3b098005916c7e$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a, _b, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, _e, hostname, bucketEndpoint;
                return (0, $be3b098005916c7e$export$67ebef60e6f28a6)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            bucketName = args.input.Bucket;
                            replaceBucketInPath = options.bucketEndpoint;
                            request = args.request;
                            if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) return [
                                3 /*break*/ ,
                                7
                            ];
                            if (!options.bucketEndpoint) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = bucketName;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 1:
                            if (!(0, $02187c72392c16cb$export$a22775fa5e2eebd9)(bucketName)) return [
                                3 /*break*/ ,
                                5
                            ];
                            bucketArn = (0, $02187c72392c16cb$export$98e6a39c04603d36)(bucketName);
                            _a = (0, $f483e3f661d5b0cc$export$2041e7d2db741fc6);
                            return [
                                4 /*yield*/ ,
                                options.region()
                            ];
                        case 2:
                            clientRegion = _a.apply(void 0, [
                                _f.sent()
                            ]);
                            return [
                                4 /*yield*/ ,
                                options.regionInfoProvider(clientRegion)
                            ];
                        case 3:
                            _b = _f.sent() || {}, partition = _b.partition, _c = _b.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
                            return [
                                4 /*yield*/ ,
                                options.useArnRegion()
                            ];
                        case 4:
                            useArnRegion = _f.sent();
                            _d = (0, $a82b8a8e52329b10$export$92dc36ff3a4794f7)({
                                bucketName: bucketArn,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:",
                                useArnRegion: useArnRegion,
                                clientPartition: partition,
                                clientSigningRegion: signingRegion
                            }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
                            // If the request needs to use a region or service name inferred from ARN that different from client region, we
                            // need to set them in the handler context so the signer will use them
                            if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) context["signing_region"] = modifiedSigningRegion;
                            if (signingService && signingService !== "s3") context["signing_service"] = signingService;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 5:
                            _e = (0, $a82b8a8e52329b10$export$92dc36ff3a4794f7)({
                                bucketName: bucketName,
                                baseHostname: request.hostname,
                                accelerateEndpoint: options.useAccelerateEndpoint,
                                dualstackEndpoint: options.useDualstackEndpoint,
                                pathStyleEndpoint: options.forcePathStyle,
                                tlsCompatible: request.protocol === "https:"
                            }), hostname = _e.hostname, bucketEndpoint = _e.bucketEndpoint;
                            request.hostname = hostname;
                            replaceBucketInPath = bucketEndpoint;
                            _f.label = 6;
                        case 6:
                            if (replaceBucketInPath) {
                                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                                if (request.path === "") request.path = "/";
                            }
                            _f.label = 7;
                        case 7:
                            return [
                                2 /*return*/ ,
                                next((0, $be3b098005916c7e$export$18ce0697a983be9b)((0, $be3b098005916c7e$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $3ea9352152ab0cfd$export$3912e6e4bed18209 = {
    tags: [
        "BUCKET_ENDPOINT"
    ],
    name: "bucketEndpointMiddleware",
    relation: "before",
    toMiddleware: "hostHeaderMiddleware"
};
var $3ea9352152ab0cfd$export$6b750e866330f2fe = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($3ea9352152ab0cfd$export$f49f3b47ec112939(options), $3ea9352152ab0cfd$export$3912e6e4bed18209);
        }
    };
};




function $16970cf110b23ee7$export$9810f1a949e3136(input) {
    var _a = input.bucketEndpoint, bucketEndpoint = _a === void 0 ? false : _a, _b = input.forcePathStyle, forcePathStyle = _b === void 0 ? false : _b, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
    return (0, $be3b098005916c7e$export$18ce0697a983be9b)((0, $be3b098005916c7e$export$18ce0697a983be9b)({}, input), {
        bucketEndpoint: bucketEndpoint,
        forcePathStyle: forcePathStyle,
        useAccelerateEndpoint: useAccelerateEndpoint,
        useDualstackEndpoint: useDualstackEndpoint,
        useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
            return Promise.resolve(useArnRegion);
        }
    });
}
var $16970cf110b23ee7$export$7eb281bbdddd5d12 = "AWS_S3_USE_ARN_REGION";
var $16970cf110b23ee7$export$812c693bf225d32a = "s3_use_arn_region";
var $16970cf110b23ee7$export$bac037ab69dc2bd4 = {
    environmentVariableSelector: function(env) {
        if (!Object.prototype.hasOwnProperty.call(env, $16970cf110b23ee7$export$7eb281bbdddd5d12)) return undefined;
        if (env[$16970cf110b23ee7$export$7eb281bbdddd5d12] === "true") return true;
        if (env[$16970cf110b23ee7$export$7eb281bbdddd5d12] === "false") return false;
        throw new Error("Cannot load env " + $16970cf110b23ee7$export$7eb281bbdddd5d12 + ". Expected \"true\" or \"false\", got " + env[$16970cf110b23ee7$export$7eb281bbdddd5d12] + ".");
    },
    configFileSelector: function(profile) {
        if (!Object.prototype.hasOwnProperty.call(profile, $16970cf110b23ee7$export$812c693bf225d32a)) return undefined;
        if (profile[$16970cf110b23ee7$export$812c693bf225d32a] === "true") return true;
        if (profile[$16970cf110b23ee7$export$812c693bf225d32a] === "false") return false;
        throw new Error("Cannot load shared config entry " + $16970cf110b23ee7$export$812c693bf225d32a + ". Expected \"true\" or \"false\", got " + profile[$16970cf110b23ee7$export$812c693bf225d32a] + ".");
    },
    default: false
};







var $bb0c44a9a07227e8$export$d60592d05571c4ef = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    DeleteObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$7d123f24a24f15cf).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$64d4f4fac943bc25).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$400c19cbac9616f7)(input, context);
    };
    DeleteObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$987b292ae9f16665)(output, context);
    };
    return DeleteObjectCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $49ea5d2cd455d7fa$var$extendStatics = function(d, b) {
    $49ea5d2cd455d7fa$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $49ea5d2cd455d7fa$var$extendStatics(d, b);
};
function $49ea5d2cd455d7fa$export$a8ba968b8961cb8a(d, b) {
    $49ea5d2cd455d7fa$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $49ea5d2cd455d7fa$export$18ce0697a983be9b = function() {
    $49ea5d2cd455d7fa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $49ea5d2cd455d7fa$export$18ce0697a983be9b.apply(this, arguments);
};
function $49ea5d2cd455d7fa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $49ea5d2cd455d7fa$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $49ea5d2cd455d7fa$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $49ea5d2cd455d7fa$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $49ea5d2cd455d7fa$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $49ea5d2cd455d7fa$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $49ea5d2cd455d7fa$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $49ea5d2cd455d7fa$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $49ea5d2cd455d7fa$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $49ea5d2cd455d7fa$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $49ea5d2cd455d7fa$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($49ea5d2cd455d7fa$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $49ea5d2cd455d7fa$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $49ea5d2cd455d7fa$export$10c90e4f7922046c(v) {
    return this instanceof $49ea5d2cd455d7fa$export$10c90e4f7922046c ? (this.v = v, this) : new $49ea5d2cd455d7fa$export$10c90e4f7922046c(v);
}
function $49ea5d2cd455d7fa$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $49ea5d2cd455d7fa$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $49ea5d2cd455d7fa$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $49ea5d2cd455d7fa$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $49ea5d2cd455d7fa$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $49ea5d2cd455d7fa$export$19a8beecd37a4c45 === "function" ? $49ea5d2cd455d7fa$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $49ea5d2cd455d7fa$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $49ea5d2cd455d7fa$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $49ea5d2cd455d7fa$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $49ea5d2cd455d7fa$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $49ea5d2cd455d7fa$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $779eee88296f2d30$export$16515ae394ee1bc8(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $49ea5d2cd455d7fa$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a, _b, _c, _d, e_1_1;
                var e_1, _e, _f;
                return (0, $49ea5d2cd455d7fa$export$67ebef60e6f28a6)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            input = (0, $49ea5d2cd455d7fa$export$18ce0697a983be9b)({}, args.input);
                            properties = [
                                {
                                    target: "SSECustomerKey",
                                    hash: "SSECustomerKeyMD5"
                                },
                                {
                                    target: "CopySourceSSECustomerKey",
                                    hash: "CopySourceSSECustomerKeyMD5"
                                }
                            ];
                            _g.label = 1;
                        case 1:
                            _g.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            properties_1 = (0, $49ea5d2cd455d7fa$export$19a8beecd37a4c45)(properties), properties_1_1 = properties_1.next();
                            _g.label = 2;
                        case 2:
                            if (!!properties_1_1.done) return [
                                3 /*break*/ ,
                                5
                            ];
                            prop = properties_1_1.value;
                            value = input[prop.target];
                            if (!value) return [
                                3 /*break*/ ,
                                4
                            ];
                            valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                            encoded = options.base64Encoder(valueView);
                            hash = new options.md5();
                            hash.update(valueView);
                            _a = [
                                (0, $49ea5d2cd455d7fa$export$18ce0697a983be9b)({}, input)
                            ];
                            _f = {}, _f[prop.target] = encoded;
                            _b = prop.hash;
                            _d = (_c = options).base64Encoder;
                            return [
                                4 /*yield*/ ,
                                hash.digest()
                            ];
                        case 3:
                            input = (0, $49ea5d2cd455d7fa$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                (_f[_b] = _d.apply(_c, [
                                    _g.sent()
                                ]), _f)
                            ]));
                            _g.label = 4;
                        case 4:
                            properties_1_1 = properties_1.next();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 6:
                            e_1_1 = _g.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            try {
                                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return)) _e.call(properties_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ ,
                                next((0, $49ea5d2cd455d7fa$export$18ce0697a983be9b)((0, $49ea5d2cd455d7fa$export$18ce0697a983be9b)({}, args), {
                                    input: input
                                }))
                            ];
                    }
                });
            });
        };
    };
}
var $779eee88296f2d30$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ]
};
var $779eee88296f2d30$export$baf25e0187b0946b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($779eee88296f2d30$export$16515ae394ee1bc8(config), $779eee88296f2d30$export$bd3ed071b8ca05b3);
        }
    };
};



var $0a31ed0815d65614$export$25364b3fa12a4666 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    GetObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $779eee88296f2d30$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "GetObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$3373ea9743883feb).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$9fb6bec1a5c954d6).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetObjectCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$713ae52666bf2204)(input, context);
    };
    GetObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$c8faba1b7abd4024)(output, context);
    };
    return GetObjectCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));







var $96ab2d2b004b76b8$export$918ee8a533502438 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListObjectsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    ListObjectsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListObjectsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$b17e2bd91a04aa76).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$bd5de99c03e50bdf).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$acd8b176cbc51cb9)(input, context);
    };
    ListObjectsCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$f8d39cd754f5521d)(output, context);
    };
    return ListObjectsCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));



var $82a8cb858a699bad$exports = {};
$82a8cb858a699bad$exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"1.0.0-rc.4\",\"scripts\":{\"clean\":\"npm run remove-definitions && npm run remove-dist\",\"build-documentation\":\"npm run clean && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test:unit\":\"mocha **/cjs/**/*.spec.js\",\"test:e2e\":\"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js\",\"test\":\"yarn test:unit\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/credential-provider-node\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-browser\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-config-resolver\":\"1.0.0-rc.3\",\"@aws-sdk/eventstream-serde-node\":\"1.0.0-rc.3\",\"@aws-sdk/fetch-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/hash-blob-browser\":\"1.0.0-rc.3\",\"@aws-sdk/hash-node\":\"1.0.0-rc.3\",\"@aws-sdk/hash-stream-node\":\"1.0.0-rc.3\",\"@aws-sdk/invalid-dependency\":\"1.0.0-rc.3\",\"@aws-sdk/md5-js\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-apply-body-checksum\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-bucket-endpoint\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-content-length\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-expect-continue\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-host-header\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-location-constraint\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-logger\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-retry\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-sdk-s3\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-serde\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-signing\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-ssec\":\"1.0.0-rc.3\",\"@aws-sdk/middleware-stack\":\"1.0.0-rc.4\",\"@aws-sdk/middleware-user-agent\":\"1.0.0-rc.3\",\"@aws-sdk/node-config-provider\":\"1.0.0-rc.3\",\"@aws-sdk/node-http-handler\":\"1.0.0-rc.3\",\"@aws-sdk/protocol-http\":\"1.0.0-rc.3\",\"@aws-sdk/smithy-client\":\"1.0.0-rc.4\",\"@aws-sdk/types\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-browser\":\"1.0.0-rc.3\",\"@aws-sdk/url-parser-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-base64-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-body-length-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-user-agent-node\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-browser\":\"1.0.0-rc.3\",\"@aws-sdk/util-utf8-node\":\"1.0.0-rc.3\",\"@aws-sdk/xml-builder\":\"1.0.0-rc.3\",\"fast-xml-parser\":\"^3.16.0\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"1.0.0-rc.3\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^7.0.2\",\"@types/node\":\"^12.7.5\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.17.8\",\"typescript\":\"~4.0.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/master/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");



var $91c42892059d5bd2$exports = {};
"use strict";
Object.defineProperty($91c42892059d5bd2$exports, "__esModule", {
    value: true
});
$91c42892059d5bd2$exports.AwsCrc32 = $91c42892059d5bd2$exports.Crc32 = $91c42892059d5bd2$exports.crc32 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $53717e900bf6b072$var$extendStatics = function(d, b) {
    $53717e900bf6b072$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $53717e900bf6b072$var$extendStatics(d, b);
};
function $53717e900bf6b072$export$a8ba968b8961cb8a(d, b) {
    $53717e900bf6b072$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $53717e900bf6b072$export$18ce0697a983be9b = function() {
    $53717e900bf6b072$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53717e900bf6b072$export$18ce0697a983be9b.apply(this, arguments);
};
function $53717e900bf6b072$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $53717e900bf6b072$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $53717e900bf6b072$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $53717e900bf6b072$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $53717e900bf6b072$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $53717e900bf6b072$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $53717e900bf6b072$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $53717e900bf6b072$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $53717e900bf6b072$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $53717e900bf6b072$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $53717e900bf6b072$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($53717e900bf6b072$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $53717e900bf6b072$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $53717e900bf6b072$export$10c90e4f7922046c(v) {
    return this instanceof $53717e900bf6b072$export$10c90e4f7922046c ? (this.v = v, this) : new $53717e900bf6b072$export$10c90e4f7922046c(v);
}
function $53717e900bf6b072$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $53717e900bf6b072$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $53717e900bf6b072$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $53717e900bf6b072$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $53717e900bf6b072$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $53717e900bf6b072$export$19a8beecd37a4c45 === "function" ? $53717e900bf6b072$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $53717e900bf6b072$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $53717e900bf6b072$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $53717e900bf6b072$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $53717e900bf6b072$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $53717e900bf6b072$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $hMh1g = parcelRequire("hMh1g");
function $91c42892059d5bd2$var$crc32(data) {
    return new $91c42892059d5bd2$var$Crc32().update(data).digest();
}
$91c42892059d5bd2$exports.crc32 = $91c42892059d5bd2$var$crc32;
var $91c42892059d5bd2$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $53717e900bf6b072$export$19a8beecd37a4c45)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $91c42892059d5bd2$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
$91c42892059d5bd2$exports.Crc32 = $91c42892059d5bd2$var$Crc32;
// prettier-ignore
var $91c42892059d5bd2$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $91c42892059d5bd2$var$lookupTable = (0, $hMh1g.uint32ArrayFrom)($91c42892059d5bd2$var$a_lookUpTable);
var $c0ce28268da92dcd$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($c0ce28268da92dcd$exports, "__esModule", {
    value: true
});
$c0ce28268da92dcd$exports.AwsCrc32 = void 0;


var $hMh1g = parcelRequire("hMh1g");

var $c0ce28268da92dcd$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $91c42892059d5bd2$exports.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $hMh1g.isEmptyData)(toHash)) return;
        this.crc32.update((0, $hMh1g.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $53717e900bf6b072$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $53717e900bf6b072$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $hMh1g.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
$c0ce28268da92dcd$exports.AwsCrc32 = $c0ce28268da92dcd$var$AwsCrc32;


Object.defineProperty($91c42892059d5bd2$exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $c0ce28268da92dcd$exports.AwsCrc32;
    }
});


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ab67169d519b45a2$var$extendStatics = function(d, b) {
    $ab67169d519b45a2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ab67169d519b45a2$var$extendStatics(d, b);
};
function $ab67169d519b45a2$export$a8ba968b8961cb8a(d, b) {
    $ab67169d519b45a2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ab67169d519b45a2$export$18ce0697a983be9b = function() {
    $ab67169d519b45a2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab67169d519b45a2$export$18ce0697a983be9b.apply(this, arguments);
};
function $ab67169d519b45a2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ab67169d519b45a2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ab67169d519b45a2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ab67169d519b45a2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ab67169d519b45a2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ab67169d519b45a2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ab67169d519b45a2$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ab67169d519b45a2$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ab67169d519b45a2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ab67169d519b45a2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ab67169d519b45a2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ab67169d519b45a2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ab67169d519b45a2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ab67169d519b45a2$export$10c90e4f7922046c(v) {
    return this instanceof $ab67169d519b45a2$export$10c90e4f7922046c ? (this.v = v, this) : new $ab67169d519b45a2$export$10c90e4f7922046c(v);
}
function $ab67169d519b45a2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ab67169d519b45a2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ab67169d519b45a2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ab67169d519b45a2$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ab67169d519b45a2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ab67169d519b45a2$export$19a8beecd37a4c45 === "function" ? $ab67169d519b45a2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ab67169d519b45a2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ab67169d519b45a2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ab67169d519b45a2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ab67169d519b45a2$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ab67169d519b45a2$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $db200dc6a4b749f0$export$8a5e19712a0a5deb = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $db200dc6a4b749f0$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $db200dc6a4b749f0$var$negate(bytes);
        return parseInt((0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function $db200dc6a4b749f0$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


/**
 * @internal
 */ var $c1e7c7f74946c09b$export$74fd41a85c5dcec9 = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, $ab67169d519b45a2$export$19a8beecd37a4c45)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, $ab67169d519b45a2$export$19a8beecd37a4c45)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, $db200dc6a4b749f0$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$c1e7c7f74946c09b$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, $1ebed31995d5f4d1$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$LONG_TAG,
                        value: new (0, $db200dc6a4b749f0$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $db200dc6a4b749f0$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $c1e7c7f74946c09b$var$UUID_TAG,
                        value: (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4)) + "-" + (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6)) + "-" + (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8)) + "-" + (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10)) + "-" + (0, $1ebed31995d5f4d1$export$7ea66e3774a60b67)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var $c1e7c7f74946c09b$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($c1e7c7f74946c09b$var$HEADER_VALUE_TYPE || ($c1e7c7f74946c09b$var$HEADER_VALUE_TYPE = {}));
var $c1e7c7f74946c09b$var$BOOLEAN_TAG = "boolean";
var $c1e7c7f74946c09b$var$BYTE_TAG = "byte";
var $c1e7c7f74946c09b$var$SHORT_TAG = "short";
var $c1e7c7f74946c09b$var$INT_TAG = "integer";
var $c1e7c7f74946c09b$var$LONG_TAG = "long";
var $c1e7c7f74946c09b$var$BINARY_TAG = "binary";
var $c1e7c7f74946c09b$var$STRING_TAG = "string";
var $c1e7c7f74946c09b$var$TIMESTAMP_TAG = "timestamp";
var $c1e7c7f74946c09b$var$UUID_TAG = "uuid";
var $c1e7c7f74946c09b$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



// All prelude components are unsigned, 32-bit integers
var $63deff1749db7ed9$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $63deff1749db7ed9$var$PRELUDE_LENGTH = $63deff1749db7ed9$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $63deff1749db7ed9$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $63deff1749db7ed9$var$MINIMUM_MESSAGE_LENGTH = $63deff1749db7ed9$var$PRELUDE_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH * 2;
function $63deff1749db7ed9$export$546b6bc432bd9a53(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $63deff1749db7ed9$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($63deff1749db7ed9$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($63deff1749db7ed9$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $63deff1749db7ed9$var$CHECKSUM_LENGTH, false);
    var checksummer = new (0, $91c42892059d5bd2$exports.Crc32)().update(new Uint8Array(buffer, byteOffset, $63deff1749db7ed9$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $63deff1749db7ed9$var$PRELUDE_LENGTH, byteLength - ($63deff1749db7ed9$var$PRELUDE_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $63deff1749db7ed9$var$PRELUDE_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $63deff1749db7ed9$var$PRELUDE_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($63deff1749db7ed9$var$PRELUDE_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH + $63deff1749db7ed9$var$CHECKSUM_LENGTH))
    };
}


/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $03f745ed5917dea4$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, $c1e7c7f74946c09b$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, $91c42892059d5bd2$exports.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, $63deff1749db7ed9$export$546b6bc432bd9a53)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();







/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $8536cf949bfbafb9$var$extendStatics = function(d, b) {
    $8536cf949bfbafb9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $8536cf949bfbafb9$var$extendStatics(d, b);
};
function $8536cf949bfbafb9$export$a8ba968b8961cb8a(d, b) {
    $8536cf949bfbafb9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8536cf949bfbafb9$export$18ce0697a983be9b = function() {
    $8536cf949bfbafb9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8536cf949bfbafb9$export$18ce0697a983be9b.apply(this, arguments);
};
function $8536cf949bfbafb9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8536cf949bfbafb9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8536cf949bfbafb9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8536cf949bfbafb9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8536cf949bfbafb9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8536cf949bfbafb9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $8536cf949bfbafb9$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $8536cf949bfbafb9$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $8536cf949bfbafb9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8536cf949bfbafb9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8536cf949bfbafb9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8536cf949bfbafb9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8536cf949bfbafb9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8536cf949bfbafb9$export$10c90e4f7922046c(v) {
    return this instanceof $8536cf949bfbafb9$export$10c90e4f7922046c ? (this.v = v, this) : new $8536cf949bfbafb9$export$10c90e4f7922046c(v);
}
function $8536cf949bfbafb9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8536cf949bfbafb9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8536cf949bfbafb9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8536cf949bfbafb9$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $8536cf949bfbafb9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8536cf949bfbafb9$export$19a8beecd37a4c45 === "function" ? $8536cf949bfbafb9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8536cf949bfbafb9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $8536cf949bfbafb9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $8536cf949bfbafb9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8536cf949bfbafb9$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $8536cf949bfbafb9$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}




function $9d6ffa4537e4cf23$export$3071cd8be9cd01e0(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, $8536cf949bfbafb9$export$e427f37a30a4de9b)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, $8536cf949bfbafb9$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}



function $4c014c6849cff340$export$a1a364c5c6ddc1b4(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $8536cf949bfbafb9$export$e427f37a30a4de9b)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, $8536cf949bfbafb9$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, $8536cf949bfbafb9$export$e3b29a3d6162315f)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}


var $24923085e82ad7f4$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $03f745ed5917dea4$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, $9d6ffa4537e4cf23$export$3071cd8be9cd01e0)(body);
        var unmarshalledStream = (0, $4c014c6849cff340$export$a1a364c5c6ddc1b4)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, $8536cf949bfbafb9$export$e427f37a30a4de9b)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, $8536cf949bfbafb9$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, $8536cf949bfbafb9$export$e3b29a3d6162315f)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, $8536cf949bfbafb9$export$10c90e4f7922046c)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();


var $04bf05c15efe0c10$export$9d23a885702ebafb = function(options) {
    return new (0, $24923085e82ad7f4$export$b64afa0aa6ce60e2)(options);
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e7ceb9c8d20f2403$var$extendStatics = function(d, b) {
    $e7ceb9c8d20f2403$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e7ceb9c8d20f2403$var$extendStatics(d, b);
};
function $e7ceb9c8d20f2403$export$a8ba968b8961cb8a(d, b) {
    $e7ceb9c8d20f2403$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e7ceb9c8d20f2403$export$18ce0697a983be9b = function() {
    $e7ceb9c8d20f2403$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e7ceb9c8d20f2403$export$18ce0697a983be9b.apply(this, arguments);
};
function $e7ceb9c8d20f2403$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e7ceb9c8d20f2403$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e7ceb9c8d20f2403$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e7ceb9c8d20f2403$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e7ceb9c8d20f2403$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e7ceb9c8d20f2403$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e7ceb9c8d20f2403$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e7ceb9c8d20f2403$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e7ceb9c8d20f2403$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e7ceb9c8d20f2403$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e7ceb9c8d20f2403$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e7ceb9c8d20f2403$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e7ceb9c8d20f2403$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e7ceb9c8d20f2403$export$10c90e4f7922046c(v) {
    return this instanceof $e7ceb9c8d20f2403$export$10c90e4f7922046c ? (this.v = v, this) : new $e7ceb9c8d20f2403$export$10c90e4f7922046c(v);
}
function $e7ceb9c8d20f2403$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e7ceb9c8d20f2403$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e7ceb9c8d20f2403$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e7ceb9c8d20f2403$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e7ceb9c8d20f2403$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e7ceb9c8d20f2403$export$19a8beecd37a4c45 === "function" ? $e7ceb9c8d20f2403$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e7ceb9c8d20f2403$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e7ceb9c8d20f2403$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e7ceb9c8d20f2403$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e7ceb9c8d20f2403$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e7ceb9c8d20f2403$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $aaab4ac2b401b42e$export$2346526b0991dd88 = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, $e7ceb9c8d20f2403$export$e427f37a30a4de9b)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, $e7ceb9c8d20f2403$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $e7ceb9c8d20f2403$export$10c90e4f7922046c)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $e7ceb9c8d20f2403$export$10c90e4f7922046c)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, $e7ceb9c8d20f2403$export$10c90e4f7922046c)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var $aaab4ac2b401b42e$export$92326f9d37f111f = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, $e7ceb9c8d20f2403$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, $e7ceb9c8d20f2403$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};


/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var $717d102811667472$export$b64afa0aa6ce60e2 = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, $03f745ed5917dea4$export$b64afa0aa6ce60e2)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, $24923085e82ad7f4$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = $717d102811667472$var$isReadableStream(body) ? (0, $aaab4ac2b401b42e$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $aaab4ac2b401b42e$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var $717d102811667472$var$isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};


var $22787f334a8401a3$export$9d23a885702ebafb = function(options) {
    return new (0, $717d102811667472$export$b64afa0aa6ce60e2)(options);
};







/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f45d0db8afa2b58f$var$extendStatics = function(d, b) {
    $f45d0db8afa2b58f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f45d0db8afa2b58f$var$extendStatics(d, b);
};
function $f45d0db8afa2b58f$export$a8ba968b8961cb8a(d, b) {
    $f45d0db8afa2b58f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f45d0db8afa2b58f$export$18ce0697a983be9b = function() {
    $f45d0db8afa2b58f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f45d0db8afa2b58f$export$18ce0697a983be9b.apply(this, arguments);
};
function $f45d0db8afa2b58f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f45d0db8afa2b58f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f45d0db8afa2b58f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f45d0db8afa2b58f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f45d0db8afa2b58f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f45d0db8afa2b58f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f45d0db8afa2b58f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f45d0db8afa2b58f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f45d0db8afa2b58f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f45d0db8afa2b58f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f45d0db8afa2b58f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f45d0db8afa2b58f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f45d0db8afa2b58f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f45d0db8afa2b58f$export$10c90e4f7922046c(v) {
    return this instanceof $f45d0db8afa2b58f$export$10c90e4f7922046c ? (this.v = v, this) : new $f45d0db8afa2b58f$export$10c90e4f7922046c(v);
}
function $f45d0db8afa2b58f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f45d0db8afa2b58f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f45d0db8afa2b58f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f45d0db8afa2b58f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f45d0db8afa2b58f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f45d0db8afa2b58f$export$19a8beecd37a4c45 === "function" ? $f45d0db8afa2b58f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f45d0db8afa2b58f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f45d0db8afa2b58f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f45d0db8afa2b58f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f45d0db8afa2b58f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f45d0db8afa2b58f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $90fc8c172f76c689$export$7541dba16c2127c8(blob, onChunk, chunkSize) {
    if (chunkSize === void 0) chunkSize = 1048576;
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        var size = blob.size;
        var totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", function(event) {
            var result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            // read the next block
            read();
        });
        // kick off the read
        read();
    });
}


var $0748ad0c29c10484$export$ea66e9c498b7933c = function blobHasher(hashCtor, blob) {
    return (0, $f45d0db8afa2b58f$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var hash;
        return (0, $f45d0db8afa2b58f$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    hash = new hashCtor();
                    return [
                        4 /*yield*/ ,
                        (0, $90fc8c172f76c689$export$7541dba16c2127c8)(blob, function(chunk) {
                            hash.update(chunk);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        hash.digest()
                    ];
            }
        });
    });
};



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $27b4d6507410e4f2$var$extendStatics = function(d, b) {
    $27b4d6507410e4f2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $27b4d6507410e4f2$var$extendStatics(d, b);
};
function $27b4d6507410e4f2$export$a8ba968b8961cb8a(d, b) {
    $27b4d6507410e4f2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $27b4d6507410e4f2$export$18ce0697a983be9b = function() {
    $27b4d6507410e4f2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27b4d6507410e4f2$export$18ce0697a983be9b.apply(this, arguments);
};
function $27b4d6507410e4f2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $27b4d6507410e4f2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $27b4d6507410e4f2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $27b4d6507410e4f2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $27b4d6507410e4f2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $27b4d6507410e4f2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $27b4d6507410e4f2$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $27b4d6507410e4f2$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $27b4d6507410e4f2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $27b4d6507410e4f2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $27b4d6507410e4f2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($27b4d6507410e4f2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $27b4d6507410e4f2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $27b4d6507410e4f2$export$10c90e4f7922046c(v) {
    return this instanceof $27b4d6507410e4f2$export$10c90e4f7922046c ? (this.v = v, this) : new $27b4d6507410e4f2$export$10c90e4f7922046c(v);
}
function $27b4d6507410e4f2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $27b4d6507410e4f2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $27b4d6507410e4f2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $27b4d6507410e4f2$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $27b4d6507410e4f2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $27b4d6507410e4f2$export$19a8beecd37a4c45 === "function" ? $27b4d6507410e4f2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $27b4d6507410e4f2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $27b4d6507410e4f2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $27b4d6507410e4f2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $27b4d6507410e4f2$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $27b4d6507410e4f2$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $QxOwh = parcelRequire("QxOwh");
/**
 * @internal
 */ var $238163e7980ae1a3$export$b2e3d6d444266a5c = 64;
var $238163e7980ae1a3$export$d7bd469488748c5f = 16;
var $238163e7980ae1a3$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


var $9525c9aa60031af3$export$9f5a3dfc7a9f5dd = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, $238163e7980ae1a3$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $238163e7980ae1a3$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if ($9525c9aa60031af3$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = $9525c9aa60031af3$var$convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $238163e7980ae1a3$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, $27b4d6507410e4f2$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, $27b4d6507410e4f2$export$67ebef60e6f28a6)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, $238163e7980ae1a3$export$b2e3d6d444266a5c) >= (0, $238163e7980ae1a3$export$b2e3d6d444266a5c) - 8) {
                        for(i = this.bufferLength; i < (0, $238163e7980ae1a3$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, $238163e7980ae1a3$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, $238163e7980ae1a3$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, $238163e7980ae1a3$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, $238163e7980ae1a3$export$d7bd469488748c5f)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = $9525c9aa60031af3$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $9525c9aa60031af3$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $9525c9aa60031af3$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $9525c9aa60031af3$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $9525c9aa60031af3$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $9525c9aa60031af3$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $9525c9aa60031af3$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $9525c9aa60031af3$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $9525c9aa60031af3$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $9525c9aa60031af3$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $9525c9aa60031af3$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $9525c9aa60031af3$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $9525c9aa60031af3$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $9525c9aa60031af3$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $9525c9aa60031af3$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $9525c9aa60031af3$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $9525c9aa60031af3$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $9525c9aa60031af3$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $9525c9aa60031af3$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $9525c9aa60031af3$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $9525c9aa60031af3$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $9525c9aa60031af3$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $9525c9aa60031af3$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $9525c9aa60031af3$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $9525c9aa60031af3$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $9525c9aa60031af3$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $9525c9aa60031af3$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $9525c9aa60031af3$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $9525c9aa60031af3$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $9525c9aa60031af3$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $9525c9aa60031af3$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $9525c9aa60031af3$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $9525c9aa60031af3$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $9525c9aa60031af3$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $9525c9aa60031af3$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $9525c9aa60031af3$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $9525c9aa60031af3$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $9525c9aa60031af3$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $9525c9aa60031af3$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $9525c9aa60031af3$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $9525c9aa60031af3$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $9525c9aa60031af3$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $9525c9aa60031af3$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $9525c9aa60031af3$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $9525c9aa60031af3$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $9525c9aa60031af3$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $9525c9aa60031af3$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $9525c9aa60031af3$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $9525c9aa60031af3$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $9525c9aa60031af3$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $9525c9aa60031af3$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $9525c9aa60031af3$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $9525c9aa60031af3$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $9525c9aa60031af3$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $9525c9aa60031af3$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $9525c9aa60031af3$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $9525c9aa60031af3$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $9525c9aa60031af3$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $9525c9aa60031af3$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $9525c9aa60031af3$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $9525c9aa60031af3$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $9525c9aa60031af3$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $9525c9aa60031af3$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $9525c9aa60031af3$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function $9525c9aa60031af3$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $9525c9aa60031af3$var$ff(a, b, c, d, x, s, t) {
    return $9525c9aa60031af3$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $9525c9aa60031af3$var$gg(a, b, c, d, x, s, t) {
    return $9525c9aa60031af3$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $9525c9aa60031af3$var$hh(a, b, c, d, x, s, t) {
    return $9525c9aa60031af3$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $9525c9aa60031af3$var$ii(a, b, c, d, x, s, t) {
    return $9525c9aa60031af3$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $9525c9aa60031af3$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $9525c9aa60031af3$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $QxOwh.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}








var $QxOwh = parcelRequire("QxOwh");
// Partition default templates
var $27a67e0cd96140bd$var$AWS_TEMPLATE = "s3.{region}.amazonaws.com";
var $27a67e0cd96140bd$var$AWS_CN_TEMPLATE = "s3.{region}.amazonaws.com.cn";
var $27a67e0cd96140bd$var$AWS_ISO_TEMPLATE = "s3.{region}.c2s.ic.gov";
var $27a67e0cd96140bd$var$AWS_ISO_B_TEMPLATE = "s3.{region}.sc2s.sgov.gov";
var $27a67e0cd96140bd$var$AWS_US_GOV_TEMPLATE = "s3.{region}.amazonaws.com";
// Partition regions
var $27a67e0cd96140bd$var$AWS_REGIONS = new Set([
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var $27a67e0cd96140bd$var$AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var $27a67e0cd96140bd$var$AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var $27a67e0cd96140bd$var$AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var $27a67e0cd96140bd$var$AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var $27a67e0cd96140bd$export$2e4318bf13462aa2 = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "ap-east-1":
            regionInfo = {
                hostname: "s3.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "s3.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "s3.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "s3.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "s3.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "s3.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "s3.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "s3.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "s3.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "s3.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "s3.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "s3.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "s3.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "s3.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "s3-fips-us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "s3.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "s3-external-1":
            regionInfo = {
                hostname: "s3-external-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "s3.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "s3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "s3.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "s3.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "s3.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "s3.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "s3.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "s3.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if ($27a67e0cd96140bd$var$AWS_REGIONS.has(region)) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if ($27a67e0cd96140bd$var$AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if ($27a67e0cd96140bd$var$AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if ($27a67e0cd96140bd$var$AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if ($27a67e0cd96140bd$var$AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: $27a67e0cd96140bd$var$AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve(regionInfo);
};


var $103b69c25e17151a$export$608864383388f904 = {
    apiVersion: "2006-03-01",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, $27a67e0cd96140bd$export$2e4318bf13462aa2),
    signingEscapePath: false,
    signingName: "s3",
    useArnRegion: false
};


var $12c377b717bc0bf2$export$b1f2d721b555a243 = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $103b69c25e17151a$export$608864383388f904)), {
    runtime: "browser",
    base64Decoder: (0, $33a6b0c1aa82f56b$export$c537b38001c583b7),
    base64Encoder: (0, $33a6b0c1aa82f56b$export$37cc283d8fbd3462),
    bodyLengthChecker: (0, $0c5496a008122b7f$export$967f3527bf233bc0),
    credentialDefaultProvider: (0, $76e89413b78ae54a$export$8b6362171c4dfa64)("Credential is missing"),
    defaultUserAgent: (0, $69602509ea521450$export$69d579f32876892f)((0, (/*@__PURE__*/$parcel$interopDefault($82a8cb858a699bad$exports))).name, (0, (/*@__PURE__*/$parcel$interopDefault($82a8cb858a699bad$exports))).version),
    eventStreamSerdeProvider: (0, $22787f334a8401a3$export$9d23a885702ebafb),
    maxAttempts: (0, $4389388ca4b0184c$export$2c7e51f38ba5a406),
    md5: (0, $9525c9aa60031af3$export$9f5a3dfc7a9f5dd),
    region: (0, $76e89413b78ae54a$export$8b6362171c4dfa64)("Region is missing"),
    requestHandler: new (0, $34bde8d3da0ca366$export$83588b87edbfa7e0)(),
    sha256: (0, $ff311350cc9f0502$exports.Sha256),
    streamCollector: (0, $fe8309fe516a0324$export$17bf97b72e307d52),
    streamHasher: (0, $0748ad0c29c10484$export$ea66e9c498b7933c),
    urlParser: (0, $72615e0d08f796d3$export$7a5253c0f62e0150),
    utf8Decoder: (0, $QxOwh.fromUtf8),
    utf8Encoder: (0, $QxOwh.toUtf8)
});



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $11c592d8adeb6f21$var$extendStatics = function(d, b) {
    $11c592d8adeb6f21$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $11c592d8adeb6f21$var$extendStatics(d, b);
};
function $11c592d8adeb6f21$export$a8ba968b8961cb8a(d, b) {
    $11c592d8adeb6f21$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $11c592d8adeb6f21$export$18ce0697a983be9b = function() {
    $11c592d8adeb6f21$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $11c592d8adeb6f21$export$18ce0697a983be9b.apply(this, arguments);
};
function $11c592d8adeb6f21$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $11c592d8adeb6f21$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $11c592d8adeb6f21$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $11c592d8adeb6f21$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $11c592d8adeb6f21$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $11c592d8adeb6f21$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $11c592d8adeb6f21$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $11c592d8adeb6f21$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $11c592d8adeb6f21$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $11c592d8adeb6f21$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $11c592d8adeb6f21$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($11c592d8adeb6f21$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $11c592d8adeb6f21$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $11c592d8adeb6f21$export$10c90e4f7922046c(v) {
    return this instanceof $11c592d8adeb6f21$export$10c90e4f7922046c ? (this.v = v, this) : new $11c592d8adeb6f21$export$10c90e4f7922046c(v);
}
function $11c592d8adeb6f21$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $11c592d8adeb6f21$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $11c592d8adeb6f21$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $11c592d8adeb6f21$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $11c592d8adeb6f21$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $11c592d8adeb6f21$export$19a8beecd37a4c45 === "function" ? $11c592d8adeb6f21$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $11c592d8adeb6f21$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $11c592d8adeb6f21$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $11c592d8adeb6f21$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $11c592d8adeb6f21$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $11c592d8adeb6f21$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $a2622bb6687ddadd$export$5e2ae00bf65442f0 = function(input) {
    return (0, $11c592d8adeb6f21$export$18ce0697a983be9b)((0, $11c592d8adeb6f21$export$18ce0697a983be9b)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c2db72cdec2ba37a$var$extendStatics = function(d, b) {
    $c2db72cdec2ba37a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c2db72cdec2ba37a$var$extendStatics(d, b);
};
function $c2db72cdec2ba37a$export$a8ba968b8961cb8a(d, b) {
    $c2db72cdec2ba37a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c2db72cdec2ba37a$export$18ce0697a983be9b = function() {
    $c2db72cdec2ba37a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2db72cdec2ba37a$export$18ce0697a983be9b.apply(this, arguments);
};
function $c2db72cdec2ba37a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c2db72cdec2ba37a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c2db72cdec2ba37a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c2db72cdec2ba37a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c2db72cdec2ba37a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c2db72cdec2ba37a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c2db72cdec2ba37a$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c2db72cdec2ba37a$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c2db72cdec2ba37a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c2db72cdec2ba37a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c2db72cdec2ba37a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c2db72cdec2ba37a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c2db72cdec2ba37a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c2db72cdec2ba37a$export$10c90e4f7922046c(v) {
    return this instanceof $c2db72cdec2ba37a$export$10c90e4f7922046c ? (this.v = v, this) : new $c2db72cdec2ba37a$export$10c90e4f7922046c(v);
}
function $c2db72cdec2ba37a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c2db72cdec2ba37a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c2db72cdec2ba37a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c2db72cdec2ba37a$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c2db72cdec2ba37a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c2db72cdec2ba37a$export$19a8beecd37a4c45 === "function" ? $c2db72cdec2ba37a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c2db72cdec2ba37a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c2db72cdec2ba37a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c2db72cdec2ba37a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c2db72cdec2ba37a$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c2db72cdec2ba37a$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $f90d9b6fd42e5f5e$export$ea55ca13ab589d75(options) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $c2db72cdec2ba37a$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request;
                return (0, $c2db72cdec2ba37a$export$67ebef60e6f28a6)(this, function(_a) {
                    request = args.request;
                    if ((0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request) && request.body && options.runtime === "node") request.headers = (0, $c2db72cdec2ba37a$export$18ce0697a983be9b)((0, $c2db72cdec2ba37a$export$18ce0697a983be9b)({}, request.headers), {
                        Expect: "100-continue"
                    });
                    return [
                        2 /*return*/ ,
                        next((0, $c2db72cdec2ba37a$export$18ce0697a983be9b)((0, $c2db72cdec2ba37a$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $f90d9b6fd42e5f5e$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware"
};
var $f90d9b6fd42e5f5e$export$7692e5e7214e5cd1 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($f90d9b6fd42e5f5e$export$ea55ca13ab589d75(options), $f90d9b6fd42e5f5e$export$582010bfa3126ad3);
        }
    };
};





/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $8c29272840f57c0a$var$extendStatics = function(d, b) {
    $8c29272840f57c0a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $8c29272840f57c0a$var$extendStatics(d, b);
};
function $8c29272840f57c0a$export$a8ba968b8961cb8a(d, b) {
    $8c29272840f57c0a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8c29272840f57c0a$export$18ce0697a983be9b = function() {
    $8c29272840f57c0a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8c29272840f57c0a$export$18ce0697a983be9b.apply(this, arguments);
};
function $8c29272840f57c0a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8c29272840f57c0a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8c29272840f57c0a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8c29272840f57c0a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8c29272840f57c0a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8c29272840f57c0a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $8c29272840f57c0a$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $8c29272840f57c0a$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $8c29272840f57c0a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8c29272840f57c0a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8c29272840f57c0a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8c29272840f57c0a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8c29272840f57c0a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8c29272840f57c0a$export$10c90e4f7922046c(v) {
    return this instanceof $8c29272840f57c0a$export$10c90e4f7922046c ? (this.v = v, this) : new $8c29272840f57c0a$export$10c90e4f7922046c(v);
}
function $8c29272840f57c0a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8c29272840f57c0a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8c29272840f57c0a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8c29272840f57c0a$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $8c29272840f57c0a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8c29272840f57c0a$export$19a8beecd37a4c45 === "function" ? $8c29272840f57c0a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8c29272840f57c0a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $8c29272840f57c0a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $8c29272840f57c0a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8c29272840f57c0a$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $8c29272840f57c0a$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $cc8bb435152a26aa$export$97e70cdcaaace32a() {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $8c29272840f57c0a$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var Bucket, err;
                return (0, $8c29272840f57c0a$export$67ebef60e6f28a6)(this, function(_a) {
                    Bucket = args.input.Bucket;
                    if (typeof Bucket === "string" && !(0, $02187c72392c16cb$export$a22775fa5e2eebd9)(Bucket) && Bucket.indexOf("/") >= 0) {
                        err = new Error("Bucket name shouldn't contain '/', received '" + Bucket + "'");
                        err.name = "InvalidBucketName";
                        throw err;
                    }
                    return [
                        2 /*return*/ ,
                        next((0, $8c29272840f57c0a$export$18ce0697a983be9b)({}, args))
                    ];
                });
            });
        };
    };
}
var $cc8bb435152a26aa$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware"
};
var $cc8bb435152a26aa$export$c30d61978fbb3ad8 = function(unused) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($cc8bb435152a26aa$export$97e70cdcaaace32a(), $cc8bb435152a26aa$export$db8005617bec77bd);
        }
    };
};




var $568f45636ca18148$export$47830883dba0cb3a = function(config) {
    return function(next) {
        return function(args) {
            return (0, $8c29272840f57c0a$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a;
                return (0, $8c29272840f57c0a$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            request = args.request;
                            if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request) || config.isCustomEndpoint) return [
                                2 /*return*/ ,
                                next((0, $8c29272840f57c0a$export$18ce0697a983be9b)({}, args))
                            ];
                            if (!(request.hostname === "s3.amazonaws.com")) return [
                                3 /*break*/ ,
                                1
                            ];
                            request.hostname = "s3.us-east-1.amazonaws.com";
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 1:
                            _a = "aws-global";
                            return [
                                4 /*yield*/ ,
                                config.region()
                            ];
                        case 2:
                            if (_a === _b.sent()) request.hostname = "s3.amazonaws.com";
                            _b.label = 3;
                        case 3:
                            return [
                                2 /*return*/ ,
                                next((0, $8c29272840f57c0a$export$18ce0697a983be9b)({}, args))
                            ];
                    }
                });
            });
        };
    };
};
var $568f45636ca18148$export$984fdb6c4de63240 = {
    step: "build",
    tags: [
        "USE_REGIONAL_ENDPOINT",
        "S3"
    ],
    name: "useRegionalEndpointMiddleware"
};
var $568f45636ca18148$export$8512187c26b3935b = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($568f45636ca18148$export$47830883dba0cb3a(config), $568f45636ca18148$export$984fdb6c4de63240);
        }
    };
};







/**
 * <p></p>
 */ var $d529a9eefa111fe1$export$b5be36c66bc46237 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(S3Client, _super);
    function S3Client(configuration) {
        var _this = this;
        var _config_0 = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $12c377b717bc0bf2$export$b1f2d721b555a243)), configuration);
        var _config_1 = (0, $3c8ee15af3f289ba$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $cbbb9d6cf6d91cb9$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $bb13a56e54d41cd2$export$1dd62920de1feabb)(_config_2);
        var _config_4 = (0, $c604e29ac2d64e7a$export$ca7f6138f2c98476)(_config_3);
        var _config_5 = (0, $6a8df0c97e1a5e12$export$ec9a2d5663958cb)(_config_4);
        var _config_6 = (0, $16970cf110b23ee7$export$9810f1a949e3136)(_config_5);
        var _config_7 = (0, $34b32b3749f83262$export$c1625bf0b32b4481)(_config_6);
        var _config_8 = (0, $a2622bb6687ddadd$export$5e2ae00bf65442f0)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, $43c8c3a6e4eb9d7a$export$59c2b7ad30ed4046)(_this.config));
        _this.middlewareStack.use((0, $9e75aa053b37740b$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $4e2650dcbd5d9734$export$5393c0d2d7f4f5f0)(_this.config));
        _this.middlewareStack.use((0, $8cd3c273011346a7$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $cc8bb435152a26aa$export$c30d61978fbb3ad8)(_this.config));
        _this.middlewareStack.use((0, $568f45636ca18148$export$8512187c26b3935b)(_this.config));
        _this.middlewareStack.use((0, $f90d9b6fd42e5f5e$export$7692e5e7214e5cd1)(_this.config));
        _this.middlewareStack.use((0, $34b32b3749f83262$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $8e0fede809fe3b2b$export$f6ef65d7766fc255)(_this.config));
        return _this;
    }
    S3Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return S3Client;
}((0, $0b86a7f9694de380$export$1f2bb630327ac4b6));



function $ee3e462d722711bb$export$75025487296cba38(request) {
    var port = request.port, query = request.query;
    var protocol = request.protocol, path = request.path, hostname = request.hostname;
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    if (port) hostname += ":" + port;
    if (path && path.charAt(0) !== "/") path = "/" + path;
    var queryString = query ? (0, $c44136875091ca82$export$6b17a39e52c8ee53)(query) : "";
    if (queryString && queryString[0] !== "?") queryString = "?" + queryString;
    return protocol + "//" + hostname + path + queryString;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3f6671910c2ca285$var$extendStatics = function(d, b) {
    $3f6671910c2ca285$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3f6671910c2ca285$var$extendStatics(d, b);
};
function $3f6671910c2ca285$export$a8ba968b8961cb8a(d, b) {
    $3f6671910c2ca285$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3f6671910c2ca285$export$18ce0697a983be9b = function() {
    $3f6671910c2ca285$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f6671910c2ca285$export$18ce0697a983be9b.apply(this, arguments);
};
function $3f6671910c2ca285$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3f6671910c2ca285$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3f6671910c2ca285$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3f6671910c2ca285$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3f6671910c2ca285$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3f6671910c2ca285$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3f6671910c2ca285$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3f6671910c2ca285$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3f6671910c2ca285$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3f6671910c2ca285$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3f6671910c2ca285$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3f6671910c2ca285$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3f6671910c2ca285$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3f6671910c2ca285$export$10c90e4f7922046c(v) {
    return this instanceof $3f6671910c2ca285$export$10c90e4f7922046c ? (this.v = v, this) : new $3f6671910c2ca285$export$10c90e4f7922046c(v);
}
function $3f6671910c2ca285$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3f6671910c2ca285$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3f6671910c2ca285$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3f6671910c2ca285$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3f6671910c2ca285$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3f6671910c2ca285$export$19a8beecd37a4c45 === "function" ? $3f6671910c2ca285$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3f6671910c2ca285$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3f6671910c2ca285$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3f6671910c2ca285$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3f6671910c2ca285$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3f6671910c2ca285$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


function $f40a13699c4e480d$export$72e3afa9ac8966be(client, command) {
    return (0, $3f6671910c2ca285$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var interceptMiddleware, clientStack, handler;
        var _this = this;
        return (0, $3f6671910c2ca285$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    interceptMiddleware = function(next) {
                        return function(args) {
                            return (0, $3f6671910c2ca285$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                return (0, $3f6671910c2ca285$export$67ebef60e6f28a6)(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            output: {
                                                request: args.request
                                            },
                                            response: undefined
                                        }
                                    ];
                                });
                            });
                        };
                    };
                    clientStack = client.middlewareStack.clone();
                    // @ts-ignore: add middleware to the last of 'build' step
                    clientStack.add(interceptMiddleware, {
                        step: "build",
                        priority: "low"
                    });
                    handler = command.resolveMiddleware(clientStack, client.config, undefined);
                    return [
                        4 /*yield*/ ,
                        handler(command).then(function(output) {
                            return output.output.request;
                        })
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $663ef60c55c8fe3f$var$extendStatics = function(d, b) {
    $663ef60c55c8fe3f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $663ef60c55c8fe3f$var$extendStatics(d, b);
};
function $663ef60c55c8fe3f$export$a8ba968b8961cb8a(d, b) {
    $663ef60c55c8fe3f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $663ef60c55c8fe3f$export$18ce0697a983be9b = function() {
    $663ef60c55c8fe3f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $663ef60c55c8fe3f$export$18ce0697a983be9b.apply(this, arguments);
};
function $663ef60c55c8fe3f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $663ef60c55c8fe3f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $663ef60c55c8fe3f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $663ef60c55c8fe3f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $663ef60c55c8fe3f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $663ef60c55c8fe3f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $663ef60c55c8fe3f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $663ef60c55c8fe3f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $663ef60c55c8fe3f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $663ef60c55c8fe3f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $663ef60c55c8fe3f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($663ef60c55c8fe3f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $663ef60c55c8fe3f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $663ef60c55c8fe3f$export$10c90e4f7922046c(v) {
    return this instanceof $663ef60c55c8fe3f$export$10c90e4f7922046c ? (this.v = v, this) : new $663ef60c55c8fe3f$export$10c90e4f7922046c(v);
}
function $663ef60c55c8fe3f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $663ef60c55c8fe3f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $663ef60c55c8fe3f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $663ef60c55c8fe3f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $663ef60c55c8fe3f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $663ef60c55c8fe3f$export$19a8beecd37a4c45 === "function" ? $663ef60c55c8fe3f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $663ef60c55c8fe3f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $663ef60c55c8fe3f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $663ef60c55c8fe3f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $663ef60c55c8fe3f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $663ef60c55c8fe3f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $327d3127ada8cd67$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $327d3127ada8cd67$export$eaef12179141669a = "X-Amz-Content-Sha256";
var $327d3127ada8cd67$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $327d3127ada8cd67$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $327d3127ada8cd67$export$6e114beec37430d7 = "X-Amz-Date";
var $327d3127ada8cd67$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $327d3127ada8cd67$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $327d3127ada8cd67$export$96307741595055fc = "host";
var $327d3127ada8cd67$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";


var $5647d4bde9e9b1f6$export$a1673011a6b3560f = /** @class */ function() {
    function S3RequestPresigner(options) {
        var resolvedOptions = (0, $663ef60c55c8fe3f$export$18ce0697a983be9b)({
            // Allow `signingName` because we want to support usecase of supply client's resolved config
            // directly. Where service equals signingName.
            service: options.signingName || options.service || "s3",
            uriEscapePath: options.uriEscapePath || false
        }, options);
        this.signer = new (0, $605ca3d5f91c606d$export$20baf4d3f65eb30c)(resolvedOptions);
    }
    S3RequestPresigner.prototype.presign = function(requestToSign, _a) {
        if (_a === void 0) _a = {};
        var _b = _a.unsignableHeaders, unsignableHeaders = _b === void 0 ? new Set() : _b, options = (0, $663ef60c55c8fe3f$export$3c9a16f847548506)(_a, [
            "unsignableHeaders"
        ]);
        return (0, $663ef60c55c8fe3f$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $663ef60c55c8fe3f$export$67ebef60e6f28a6)(this, function(_c) {
                unsignableHeaders.add("content-type");
                requestToSign.headers[0, $327d3127ada8cd67$export$eaef12179141669a] = (0, $327d3127ada8cd67$export$91f7321b40d9fd07);
                return [
                    2 /*return*/ ,
                    this.signer.presign(requestToSign, (0, $663ef60c55c8fe3f$export$18ce0697a983be9b)({
                        expiresIn: 900,
                        unsignableHeaders: unsignableHeaders
                    }, options))
                ];
            });
        });
    };
    return S3RequestPresigner;
}();






var $4bb8477739c21e97$export$d6e65e470b2c127c = function(client, command, options) {
    if (options === void 0) options = {};
    return (0, $663ef60c55c8fe3f$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var s3Presigner, presignInterceptMiddleware, presigned, output;
        return (0, $663ef60c55c8fe3f$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    s3Presigner = new (0, $5647d4bde9e9b1f6$export$a1673011a6b3560f)((0, $663ef60c55c8fe3f$export$18ce0697a983be9b)({}, client.config));
                    presignInterceptMiddleware = function(next, context) {
                        return function(args) {
                            return (0, $663ef60c55c8fe3f$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                                var request, presigned;
                                var _a, _b;
                                return (0, $663ef60c55c8fe3f$export$67ebef60e6f28a6)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            request = args.request;
                                            if (!(0, $aed66665aa7d42d3$export$7587955500404ec3).isInstance(request)) throw new Error("Request to be presigned is not an valid HTTP request.");
                                            // Retry information headers are not meaningful in presigned URLs
                                            delete request.headers["amz-sdk-invocation-id"];
                                            delete request.headers["amz-sdk-request"];
                                            return [
                                                4 /*yield*/ ,
                                                s3Presigner.presign(request, (0, $663ef60c55c8fe3f$export$18ce0697a983be9b)((0, $663ef60c55c8fe3f$export$18ce0697a983be9b)({}, options), {
                                                    signingRegion: (_a = options.signingRegion) !== null && _a !== void 0 ? _a : context["signing_region"],
                                                    signingService: (_b = options.signingService) !== null && _b !== void 0 ? _b : context["signing_service"]
                                                }))
                                            ];
                                        case 1:
                                            presigned = _c.sent();
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    // Intercept the middleware stack by returning fake response
                                                    response: {},
                                                    output: {
                                                        $metadata: {
                                                            httpStatusCode: 200
                                                        },
                                                        presigned: presigned
                                                    }
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                    };
                    client.middlewareStack.addRelativeTo(presignInterceptMiddleware, {
                        name: "presignInterceptMiddleware",
                        relation: "before",
                        toMiddleware: "awsAuthMiddleware"
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        client.send(command)
                    ];
                case 2:
                    output = _a.sent();
                    //@ts-ignore the output is faked, so it's not actually OutputType
                    presigned = output.presigned;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    client.middlewareStack.remove("presignInterceptMiddleware");
                    return [
                        7 /*endfinally*/ 
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        (0, $ee3e462d722711bb$export$75025487296cba38)(presigned)
                    ];
            }
        });
    });
};




/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 

var $f9e2e6b6d5dcf169$exports = {};

$f9e2e6b6d5dcf169$exports = (parcelRequire("bVGkv"));



var $55b56d2c458f166b$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('axios-http-handler');
var $55b56d2c458f166b$export$67c09327664a588d = 'sendProgress';
var $55b56d2c458f166b$export$43af02f23afacda3 = /** @class */ function() {
    function AxiosHttpHandler(httpOptions, emitter) {
        if (httpOptions === void 0) httpOptions = {};
        this.httpOptions = httpOptions;
        this.emitter = emitter;
    }
    AxiosHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
    };
    AxiosHttpHandler.prototype.handle = function(request, options) {
        var requestTimeoutInMs = this.httpOptions.requestTimeout;
        var emitter = this.emitter;
        var path = request.path;
        if (request.query) {
            var queryString = (0, $c44136875091ca82$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : '') + path;
        var axiosRequest = {};
        axiosRequest.url = url;
        axiosRequest.method = request.method;
        axiosRequest.headers = request.headers;
        // The host header is automatically added by the browser and adding it explicitly in the
        // axios request throws an error https://github.com/aws-amplify/amplify-js/issues/5376
        // This is because the host header is a forbidden header for the http client to set
        // see https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name and
        // https://fetch.spec.whatwg.org/#forbidden-header-name
        // The reason we are removing this header here instead of in the aws-sdk's client
        // middleware is that the host header is required to be in the request signature and if
        // we remove it from the middlewares, then the request fails because the header is added
        // by the browser but is absent from the signature.
        delete axiosRequest.headers['host'];
        if (request.body) axiosRequest.data = request.body;
        else // Fix for https://github.com/aws-amplify/amplify-js/issues/5432
        // If the POST request body is empty but content-type header is set, axios is forcibly removing it
        // See https://github.com/axios/axios/issues/1535 and refusing to fix it https://github.com/axios/axios/issues/755
        // This change is a workaround to set the data as null (instead of undefined) to prevent axios from
        // removing the content-type header. Link for the source code
        // https://github.com/axios/axios/blob/dc4bc49673943e35280e5df831f5c3d0347a9393/lib/adapters/xhr.js#L121-L123
        if (axiosRequest.headers['Content-Type']) axiosRequest.data = null;
        if (emitter) axiosRequest.onUploadProgress = function(event) {
            emitter.emit($55b56d2c458f166b$export$67c09327664a588d, event);
            $55b56d2c458f166b$var$logger.debug(event);
        };
        // From gamma release, aws-sdk now expects all response type to be of blob or streams
        axiosRequest.responseType = 'blob';
        var raceOfPromises = [
            (0, (/*@__PURE__*/$parcel$interopDefault($f9e2e6b6d5dcf169$exports))).request(axiosRequest).then(function(response) {
                return {
                    response: new (0, $3d9355a0aa2c65bb$export$1d94dfe0d9d1f1e7)({
                        headers: response.headers,
                        statusCode: response.status,
                        body: response.data
                    })
                };
            }).catch(function(error) {
                // Error
                $55b56d2c458f166b$var$logger.error(error);
                throw error;
            }),
            $55b56d2c458f166b$var$requestTimeout(requestTimeoutInMs)
        ];
        return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler;
}();
function $55b56d2c458f166b$var$requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = 'TimeoutError';
            reject(timeoutError);
        }, timeoutInMs);
    });
}


/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 






var $fcd98fb31e63065c$export$87d2388f8662d995 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(AbortMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AbortMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    AbortMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "AbortMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$2509116d04cdd782).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$80a5621784397e06).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$a7d2d025c66f9235)(input, context);
    };
    AbortMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$87447564e9ee4b69)(output, context);
    };
    return AbortMultipartUploadCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));







var $c9aac496a9994b45$export$f827ea0301b4eeff = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CompleteMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CompleteMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    CompleteMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CompleteMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$2998881f143b41ec).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$edcc5df28126c9bc).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$2a09fb9495f08c55)(input, context);
    };
    CompleteMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$ee5aaa25931389ce)(output, context);
    };
    return CompleteMultipartUploadCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));








var $b0cd2b98bb42e7dd$export$76155123c96043b8 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CreateMultipartUploadCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateMultipartUploadCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    CreateMultipartUploadCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $779eee88296f2d30$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateMultipartUploadCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$f65faae2a46e45c2).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$196bb0482ff68428).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$4730de34492fdc2)(input, context);
    };
    CreateMultipartUploadCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$95cf7bc6357ae5a8)(output, context);
    };
    return CreateMultipartUploadCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));







var $70e40f74660e68f4$export$17fb27d830090508 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListPartsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListPartsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    ListPartsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "ListPartsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$756cf37efa2403e6).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$8c83b46649a5c089).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListPartsCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$b2b39cf3937e8c76)(input, context);
    };
    ListPartsCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$584d994fd27ec2bb)(output, context);
    };
    return ListPartsCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));








var $ac441c43247d2a8d$export$4afa2352f8871c26 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PutObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    PutObjectCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $779eee88296f2d30$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$90c5c1bf0f634d21).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $3a0334eddcbe8749$export$792cedced515bdbd).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$6c3f9d82bec72a8d)(input, context);
    };
    PutObjectCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$45bbdbf5181c3607)(output, context);
    };
    return PutObjectCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));





var $ebf3638ddd0b88d1$export$ee855080cc4fa5a8;
(function(RestoreRequestType) {
    RestoreRequestType["SELECT"] = "SELECT";
})($ebf3638ddd0b88d1$export$ee855080cc4fa5a8 || ($ebf3638ddd0b88d1$export$ee855080cc4fa5a8 = {}));
var $ebf3638ddd0b88d1$export$116b002a1c4d25c0;
(function(RestoreRequest) {
    RestoreRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.OutputLocation && {
            OutputLocation: (0, $3a0334eddcbe8749$export$cc3fbbd78713fc6c).filterSensitiveLog(obj.OutputLocation)
        });
    };
})($ebf3638ddd0b88d1$export$116b002a1c4d25c0 || ($ebf3638ddd0b88d1$export$116b002a1c4d25c0 = {}));
var $ebf3638ddd0b88d1$export$bd1b29d0f94512e7;
(function(RestoreObjectRequest) {
    RestoreObjectRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.RestoreRequest && {
            RestoreRequest: $ebf3638ddd0b88d1$export$116b002a1c4d25c0.filterSensitiveLog(obj.RestoreRequest)
        });
    };
})($ebf3638ddd0b88d1$export$bd1b29d0f94512e7 || ($ebf3638ddd0b88d1$export$bd1b29d0f94512e7 = {}));
var $ebf3638ddd0b88d1$export$d20e6aaa08a7363f;
(function(ContinuationEvent) {
    ContinuationEvent.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$d20e6aaa08a7363f || ($ebf3638ddd0b88d1$export$d20e6aaa08a7363f = {}));
var $ebf3638ddd0b88d1$export$2066b1507471daea;
(function(EndEvent) {
    EndEvent.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$2066b1507471daea || ($ebf3638ddd0b88d1$export$2066b1507471daea = {}));
var $ebf3638ddd0b88d1$export$b25a304ec7d746bb;
(function(Progress) {
    Progress.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$b25a304ec7d746bb || ($ebf3638ddd0b88d1$export$b25a304ec7d746bb = {}));
var $ebf3638ddd0b88d1$export$863d066dc35784fb;
(function(ProgressEvent) {
    ProgressEvent.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$863d066dc35784fb || ($ebf3638ddd0b88d1$export$863d066dc35784fb = {}));
var $ebf3638ddd0b88d1$export$bb48554e89f06bf8;
(function(RecordsEvent) {
    RecordsEvent.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$bb48554e89f06bf8 || ($ebf3638ddd0b88d1$export$bb48554e89f06bf8 = {}));
var $ebf3638ddd0b88d1$export$3cdec2bba15e3523;
(function(Stats) {
    Stats.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$3cdec2bba15e3523 || ($ebf3638ddd0b88d1$export$3cdec2bba15e3523 = {}));
var $ebf3638ddd0b88d1$export$72935df6390a4cde;
(function(StatsEvent) {
    StatsEvent.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$72935df6390a4cde || ($ebf3638ddd0b88d1$export$72935df6390a4cde = {}));
var $ebf3638ddd0b88d1$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = function(value, visitor) {
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.End !== undefined) return visitor.End(value.End);
        if (value.Records !== undefined) return visitor.Records(value.Records);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SelectObjectContentEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.Cont !== undefined) return {
            Cont: $ebf3638ddd0b88d1$export$d20e6aaa08a7363f.filterSensitiveLog(obj.Cont)
        };
        if (obj.Progress !== undefined) return {
            Progress: $ebf3638ddd0b88d1$export$863d066dc35784fb.filterSensitiveLog(obj.Progress)
        };
        if (obj.Stats !== undefined) return {
            Stats: $ebf3638ddd0b88d1$export$72935df6390a4cde.filterSensitiveLog(obj.Stats)
        };
        if (obj.End !== undefined) return {
            End: $ebf3638ddd0b88d1$export$2066b1507471daea.filterSensitiveLog(obj.End)
        };
        if (obj.Records !== undefined) return {
            Records: $ebf3638ddd0b88d1$export$bb48554e89f06bf8.filterSensitiveLog(obj.Records)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})($ebf3638ddd0b88d1$export$4c951f3462fad8ac || ($ebf3638ddd0b88d1$export$4c951f3462fad8ac = {}));
var $ebf3638ddd0b88d1$export$5bf8ed4e571234e3;
(function(SelectObjectContentOutput) {
    SelectObjectContentOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Payload && {
            Payload: "STREAMING_CONTENT"
        });
    };
})($ebf3638ddd0b88d1$export$5bf8ed4e571234e3 || ($ebf3638ddd0b88d1$export$5bf8ed4e571234e3 = {}));
var $ebf3638ddd0b88d1$export$b8081f25e3a7bfbd;
(function(RequestProgress) {
    RequestProgress.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$b8081f25e3a7bfbd || ($ebf3638ddd0b88d1$export$b8081f25e3a7bfbd = {}));
var $ebf3638ddd0b88d1$export$33f7c3433c085364;
(function(ScanRange) {
    ScanRange.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$33f7c3433c085364 || ($ebf3638ddd0b88d1$export$33f7c3433c085364 = {}));
var $ebf3638ddd0b88d1$export$852c159401aad03e;
(function(SelectObjectContentRequest) {
    SelectObjectContentRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($ebf3638ddd0b88d1$export$852c159401aad03e || ($ebf3638ddd0b88d1$export$852c159401aad03e = {}));
var $ebf3638ddd0b88d1$export$1e083fd90afa2f51;
(function(UploadPartOutput) {
    UploadPartOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($ebf3638ddd0b88d1$export$1e083fd90afa2f51 || ($ebf3638ddd0b88d1$export$1e083fd90afa2f51 = {}));
var $ebf3638ddd0b88d1$export$ecf841796ea7b1f0;
(function(UploadPartRequest) {
    UploadPartRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($ebf3638ddd0b88d1$export$ecf841796ea7b1f0 || ($ebf3638ddd0b88d1$export$ecf841796ea7b1f0 = {}));
var $ebf3638ddd0b88d1$export$ff4e5952953c0084;
(function(CopyPartResult) {
    CopyPartResult.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($ebf3638ddd0b88d1$export$ff4e5952953c0084 || ($ebf3638ddd0b88d1$export$ff4e5952953c0084 = {}));
var $ebf3638ddd0b88d1$export$d6a8bd15a4edcee7;
(function(UploadPartCopyOutput) {
    UploadPartCopyOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($ebf3638ddd0b88d1$export$d6a8bd15a4edcee7 || ($ebf3638ddd0b88d1$export$d6a8bd15a4edcee7 = {}));
var $ebf3638ddd0b88d1$export$b68c35e4811b33e;
(function(UploadPartCopyRequest) {
    UploadPartCopyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.SSECustomerKey && {
            SSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        }), obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $2323beca7fe8f8bb$export$17127055dc9ac067)
        });
    };
})($ebf3638ddd0b88d1$export$b68c35e4811b33e || ($ebf3638ddd0b88d1$export$b68c35e4811b33e = {}));







var $3a27c8cf468bf17e$export$20fd13f6cebe56f0 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UploadPartCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UploadPartCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    UploadPartCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $9aadd364f0631d68$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $779eee88296f2d30$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3ea9352152ab0cfd$export$6b750e866330f2fe)(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "UploadPartCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $ebf3638ddd0b88d1$export$ecf841796ea7b1f0).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $ebf3638ddd0b88d1$export$1e083fd90afa2f51).filterSensitiveLog
        };
        if (typeof logger.info === "function") logger.info({
            clientName: clientName,
            commandName: commandName
        });
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UploadPartCommand.prototype.serialize = function(input, context) {
        return (0, $2fec21551e645b39$export$6dfc42032d3f37d4)(input, context);
    };
    UploadPartCommand.prototype.deserialize = function(output, context) {
        return (0, $2fec21551e645b39$export$176ef954f1bec178)(output, context);
    };
    return UploadPartCommand;
}((0, $5ee71f766328e8a3$export$cc7e12c76513e857));




var $hFRVt = parcelRequire("hFRVt");


var $adm0U = parcelRequire("adm0U");
var $60b899990ffb76bd$export$7a5253c0f62e0150 = function(url) {
    var _a = (0, $adm0U.parse)(url), _b = _a.hostname, hostname = _b === void 0 ? "localhost" : _b, _c = _a.pathname, pathname = _c === void 0 ? "/" : _c, port = _a.port, _d = _a.protocol, protocol = _d === void 0 ? "https:" : _d, search = _a.search;
    var query;
    if (search) query = (0, $97aff0a7f8e2d400$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};



var $0c886556af66c068$var$__assign = undefined && undefined.__assign || function() {
    $0c886556af66c068$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c886556af66c068$var$__assign.apply(this, arguments);
};
var $0c886556af66c068$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0c886556af66c068$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0c886556af66c068$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $0c886556af66c068$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('AWSS3ProviderManagedUpload');
var $0c886556af66c068$var$localTestingStorageEndpoint = 'http://localhost:20005';
var $0c886556af66c068$var$SET_CONTENT_LENGTH_HEADER = 'contentLengthMiddleware';
var $0c886556af66c068$export$da75ae8ad0285104 = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        // Defaults
        this.minPartSize = 5242880; // in MB
        this.queueSize = 4;
        // Data for current upload
        this.body = null;
        this.params = null;
        this.opts = null;
        this.multiPartMap = [];
        this.cancel = false;
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = opts;
        this.emitter = emitter;
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var _a, putObjectCommand, s3, uploadId, numberOfPartsToUpload, start, parts;
            return $0c886556af66c068$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.validateAndSanitizeBody(this.params.Body)
                        ];
                    case 1:
                        _a.body = _b.sent();
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= this.minPartSize)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        putObjectCommand = new (0, $ac441c43247d2a8d$export$4afa2352f8871c26)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, this.emitter)
                        ];
                    case 2:
                        s3 = _b.sent();
                        return [
                            2 /*return*/ ,
                            s3.send(putObjectCommand)
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 4:
                        uploadId = _b.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.minPartSize);
                        start = 0;
                        _b.label = 5;
                    case 5:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            10
                        ];
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 6:
                        /** This first block will try to cancel the upload if the cancel
                         *	request came before any parts uploads have started.
                         **/ _b.sent();
                        parts = this.createParts(start);
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(uploadId, parts)
                        ];
                    case 7:
                        _b.sent();
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ return [
                            4 /*yield*/ ,
                            this.checkIfUploadCancelled(uploadId)
                        ];
                    case 8:
                        /** Call cleanup a second time in case there were part upload requests
                         *  in flight. This is to ensure that all parts are cleaned up.
                         */ _b.sent();
                        _b.label = 9;
                    case 9:
                        start += this.queueSize;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(uploadId)
                        ];
                    case 11:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function(startPartNumber) {
        var parts = [];
        var partNumber = startPartNumber;
        for(var bodyStart = startPartNumber * this.minPartSize; bodyStart < this.totalBytesToUpload && parts.length < this.queueSize;){
            var bodyEnd = Math.min(bodyStart + this.minPartSize, this.totalBytesToUpload);
            parts.push({
                bodyPart: this.body.slice(bodyStart, bodyEnd),
                partNumber: ++partNumber,
                emitter: new $hFRVt.EventEmitter(),
                _lastUploadedBytes: 0
            });
            bodyStart += this.minPartSize;
        }
        return parts;
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var createMultiPartUploadCommand, s3, response;
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        createMultiPartUploadCommand = new (0, $b0cd2b98bb42e7dd$export$76155123c96043b8)(this.params);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(createMultiPartUploadCommand)
                        ];
                    case 2:
                        response = _a.sent();
                        $0c886556af66c068$var$logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var promises, parts_1, parts_1_1, part, uploadPartCommandInput, uploadPartCommand, s3, e_1_1, allResults, i, error_1;
            var e_1, _a;
            return $0c886556af66c068$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        promises = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        parts_1 = $0c886556af66c068$var$__values(parts), parts_1_1 = parts_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!parts_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        part = parts_1_1.value;
                        this.setupEventListener(part);
                        uploadPartCommandInput = {
                            PartNumber: part.partNumber,
                            Body: part.bodyPart,
                            UploadId: uploadId,
                            Key: this.params.Key,
                            Bucket: this.params.Bucket
                        };
                        uploadPartCommand = new (0, $3a27c8cf468bf17e$export$20fd13f6cebe56f0)(uploadPartCommandInput);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts, part.emitter)
                        ];
                    case 3:
                        s3 = _b.sent();
                        promises.push(s3.send(uploadPartCommand));
                        _b.label = 4;
                    case 4:
                        parts_1_1 = parts_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        _b.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 9:
                        allResults = _b.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.multiPartMap.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        error_1 = _b.sent();
                        $0c886556af66c068$var$logger.error('error happened while uploading a part. Cancelling the multipart upload', error_1);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var input, completeUploadCommand, s3, data, error_2;
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId,
                            MultipartUpload: {
                                Parts: this.multiPartMap
                            }
                        };
                        completeUploadCommand = new (0, $c9aac496a9994b45$export$f827ea0301b4eeff)(input);
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(completeUploadCommand)
                        ];
                    case 3:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.Key
                        ];
                    case 4:
                        error_2 = _a.sent();
                        $0c886556af66c068$var$logger.error('error happened while finishing the upload. Cancelling the multipart upload', error_2);
                        this.cancelUpload();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.checkIfUploadCancelled = function(uploadId) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var errorMessage, error_3;
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.cancel) return [
                            3 /*break*/ ,
                            5
                        ];
                        errorMessage = 'Upload was cancelled.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanup(uploadId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_3 = _a.sent();
                        errorMessage += error_3.errorMessage;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        throw new Error(errorMessage);
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cancelUpload = function() {
        this.cancel = true;
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var input, s3, data;
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.multiPartMap = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        input = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: uploadId
                        };
                        return [
                            4 /*yield*/ ,
                            this._createNewS3Client(this.opts)
                        ];
                    case 1:
                        s3 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $fcd98fb31e63065c$export$87d2388f8662d995)(input))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            s3.send(new (0, $70e40f74660e68f4$export$17fb27d830090508)(input))
                        ];
                    case 3:
                        data = _a.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error('Multi Part upload clean up failed');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, $55b56d2c458f166b$export$67c09327664a588d), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, $55b56d2c458f166b$export$67c09327664a588d), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === 'number') return input.byteLength;
        else if (typeof input.length === 'number') return input.length;
        else if (typeof input.size === 'number') return input.size;
        else if (typeof input.path === 'string') ;
        else throw new Error('Cannot determine length of ' + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isGenericObject(body)) return [
                            3 /*break*/ ,
                            1
                        ];
                        // Any javascript object
                        return [
                            2 /*return*/ ,
                            JSON.stringify(body)
                        ];
                    case 1:
                        if (!this.isBlob(body)) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(0, $eb2795a39e4549eb$export$2dffd0b5373a4389).isReactNative) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fe8309fe516a0324$export$17bf97b72e307d52)(body)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            body
                        ];
                    case 4:
                        // Files, arrayBuffer etc
                        return [
                            2 /*return*/ ,
                            body
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.isBlob = function(body) {
        return typeof Blob !== 'undefined' && body instanceof Blob;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === 'object') try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    /**
     * @private
     * creates an S3 client with new V3 aws sdk
     */ AWSS3ProviderManagedUpload.prototype._createNewS3Client = function(config, emitter) {
        return $0c886556af66c068$var$__awaiter(this, void 0, void 0, function() {
            var credentials, region, dangerouslyConnectToHttpEndpointForTesting, localTestingConfig, client;
            return $0c886556af66c068$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        region = config.region, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
                        localTestingConfig = {};
                        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
                            endpoint: $0c886556af66c068$var$localTestingStorageEndpoint,
                            tls: false,
                            bucketEndpoint: false,
                            forcePathStyle: true
                        };
                        client = new (0, $d529a9eefa111fe1$export$b5be36c66bc46237)($0c886556af66c068$var$__assign($0c886556af66c068$var$__assign({
                            region: region,
                            credentials: credentials
                        }, localTestingConfig), {
                            requestHandler: new (0, $55b56d2c458f166b$export$43af02f23afacda3)({}, emitter),
                            customUserAgent: (0, $eb2795a39e4549eb$export$ede38edb26c0bfdf)(),
                            urlParser: (0, $60b899990ffb76bd$export$7a5253c0f62e0150)
                        }));
                        client.middlewareStack.remove($0c886556af66c068$var$SET_CONTENT_LENGTH_HEADER);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3ProviderManagedUpload.prototype._getCredentials = function() {
        return (0, $5f8c093c17ed2e35$export$a9627919734faa48).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $5f8c093c17ed2e35$export$a9627919734faa48).shear(credentials);
            $0c886556af66c068$var$logger.debug('set credentials for storage', cred);
            return cred;
        }).catch(function(error) {
            $0c886556af66c068$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    return AWSS3ProviderManagedUpload;
}();



var $hFRVt = parcelRequire("hFRVt");
var $53fcf492c516cd3e$var$__assign = undefined && undefined.__assign || function() {
    $53fcf492c516cd3e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53fcf492c516cd3e$var$__assign.apply(this, arguments);
};
var $53fcf492c516cd3e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $53fcf492c516cd3e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $53fcf492c516cd3e$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('AWSS3Provider');
var $53fcf492c516cd3e$var$AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var $53fcf492c516cd3e$var$dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data['metrics'] = metrics;
        (0, $a643974fbe0dd2a5$export$8c41bb232f1008b1).dispatch('storage', {
            event: event,
            data: data,
            message: message
        }, 'Storage', $53fcf492c516cd3e$var$AMPLIFY_SYMBOL);
    }
};
var $53fcf492c516cd3e$var$localTestingStorageEndpoint = 'http://localhost:20005';
/**
 * Provide storage methods to use AWS S3
 */ var $53fcf492c516cd3e$export$a8628d9eb315b139 = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        this._config = config ? config : {};
        $53fcf492c516cd3e$var$logger.debug('Storage Options', this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $53fcf492c516cd3e$var$logger.debug('configure Storage', config);
        if (!config) return this._config;
        var amplifyConfig = (0, $ae0d5b8a0cfbbb01$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $53fcf492c516cd3e$var$logger.debug('Do not have bucket yet');
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to Amazon S3 presigned URL on success
     */ AWSS3Provider.prototype.get = function(key, config) {
        return $53fcf492c516cd3e$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, prefix, final_key, s3, params, getObjectCommand, response, error_1, signer, request, url, _a, error_2;
            return $53fcf492c516cd3e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $53fcf492c516cd3e$var$logger.debug('get ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        getObjectCommand = new (0, $0a31ed0815d65614$export$25364b3fa12a4666)(params);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(getObjectCommand)
                        ];
                    case 3:
                        response = _b.sent();
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'success'
                        }, {
                            fileSize: Number(response.Body['size'] || response.Body['length'])
                        }, "Download success for " + key);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_1 = _b.sent();
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'download', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Download failed with " + error_1.message);
                        throw error_1;
                    case 5:
                        params.Expires = expires || 900; // Default is 15 mins as defined in V2 AWS SDK
                        _b.label = 6;
                    case 6:
                        _b.trys.push([
                            6,
                            9,
                            ,
                            10
                        ]);
                        signer = new (0, $5647d4bde9e9b1f6$export$a1673011a6b3560f)($53fcf492c516cd3e$var$__assign({}, s3.config));
                        return [
                            4 /*yield*/ ,
                            (0, $f40a13699c4e480d$export$72e3afa9ac8966be)(s3, new (0, $0a31ed0815d65614$export$25364b3fa12a4666)(params))
                        ];
                    case 7:
                        request = _b.sent();
                        _a = (0, $ee3e462d722711bb$export$75025487296cba38);
                        return [
                            4 /*yield*/ ,
                            signer.presign(request, {
                                expiresIn: params.Expires
                            })
                        ];
                    case 8:
                        url = _a.apply(void 0, [
                            _b.sent()
                        ]);
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'success'
                        }, null, "Signed URL: " + url);
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 9:
                        error_2 = _b.sent();
                        $53fcf492c516cd3e$var$logger.warn('get signed url error', error_2);
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Could not get a signed URL for " + key);
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in Amazon S3 bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        return $53fcf492c516cd3e$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, progressCallback, contentType, contentDisposition, cacheControl, expires, metadata, tagging, acl, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, type, prefix, final_key, params, emitter, uploader, response, error_3;
            return $53fcf492c516cd3e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback;
                        contentType = opt.contentType, contentDisposition = opt.contentDisposition, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
                        serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        type = contentType ? contentType : 'binary/octet-stream';
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        $53fcf492c516cd3e$var$logger.debug('put ' + key + ' to ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key,
                            Body: object,
                            ContentType: type
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (contentDisposition) params.ContentDisposition = contentDisposition;
                        if (expires) params.Expires = expires;
                        if (metadata) params.Metadata = metadata;
                        if (tagging) params.Tagging = tagging;
                        if (serverSideEncryption) {
                            params.ServerSideEncryption = serverSideEncryption;
                            if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                            if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                            if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                            if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        }
                        emitter = new $hFRVt.EventEmitter();
                        uploader = new (0, $0c886556af66c068$export$da75ae8ad0285104)(params, opt, emitter);
                        if (acl) params.ACL = acl;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        emitter.on('sendProgress', function(progress) {
                            if (progressCallback) {
                                if (typeof progressCallback === 'function') progressCallback(progress);
                                else $53fcf492c516cd3e$var$logger.warn('progressCallback should be a function, not a ' + typeof progressCallback);
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            uploader.upload()
                        ];
                    case 3:
                        response = _a.sent();
                        $53fcf492c516cd3e$var$logger.debug('upload result', response);
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'success'
                        }, null, "Upload success for " + key);
                        return [
                            2 /*return*/ ,
                            {
                                key: key
                            }
                        ];
                    case 4:
                        error_3 = _a.sent();
                        $53fcf492c516cd3e$var$logger.warn('error uploading', error_3);
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'upload', {
                            method: 'put',
                            result: 'failed'
                        }, null, "Error uploading " + key);
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $53fcf492c516cd3e$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_4;
            return $53fcf492c516cd3e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createNewS3Client(opt);
                        $53fcf492c516cd3e$var$logger.debug('remove ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        deleteObjectCommand = new (0, $bb0c44a9a07227e8$export$d60592d05571c4ef)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(deleteObjectCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'success'
                        }, null, "Deleted " + key + " successfully");
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_4 = _a.sent();
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'delete', {
                            method: 'remove',
                            result: 'failed'
                        }, null, "Deletion of " + key + " failed with " + error_4);
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves to list of keys for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $53fcf492c516cd3e$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, s3, params, listObjectsCommand, response, list, error_5;
            return $53fcf492c516cd3e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        s3 = this._createNewS3Client(opt);
                        $53fcf492c516cd3e$var$logger.debug('list ' + path + ' from ' + final_path);
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: maxKeys
                        };
                        listObjectsCommand = new (0, $96ab2d2b004b76b8$export$918ee8a533502438)(params);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            s3.send(listObjectsCommand)
                        ];
                    case 3:
                        response = _a.sent();
                        list = [];
                        if (response && response.Contents) list = response.Contents.map(function(item) {
                            return {
                                key: item.Key.substr(prefix.length),
                                eTag: item.ETag,
                                lastModified: item.LastModified,
                                size: item.Size
                            };
                        });
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'success'
                        }, null, list.length + " items returned from list operation");
                        $53fcf492c516cd3e$var$logger.debug('list', list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 4:
                        error_5 = _a.sent();
                        $53fcf492c516cd3e$var$logger.warn('list error', error_5);
                        $53fcf492c516cd3e$var$dispatchStorageEvent(track, 'list', {
                            method: 'list',
                            result: 'failed'
                        }, null, "Listing items failed: " + error_5.message);
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._ensureCredentials = function() {
        var _this = this;
        return (0, $5f8c093c17ed2e35$export$a9627919734faa48).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $5f8c093c17ed2e35$export$a9627919734faa48).shear(credentials);
            $53fcf492c516cd3e$var$logger.debug('set credentials for storage', cred);
            _this._config.credentials = cred;
            return true;
        }).catch(function(error) {
            $53fcf492c516cd3e$var$logger.warn('ensure credentials error', error);
            return false;
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : 'private/') + identityId + '/';
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : 'protected/') + identityId + '/';
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : 'public/';
        switch(level){
            case 'private':
                return privatePath;
            case 'protected':
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * @private creates an S3 client with new V3 aws sdk
     */ AWSS3Provider.prototype._createNewS3Client = function(config, emitter) {
        var region = config.region, credentials = config.credentials, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
        var localTestingConfig = {};
        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
            endpoint: $53fcf492c516cd3e$var$localTestingStorageEndpoint,
            tls: false,
            bucketEndpoint: false,
            forcePathStyle: true
        };
        var s3client = new (0, $d529a9eefa111fe1$export$b5be36c66bc46237)($53fcf492c516cd3e$var$__assign($53fcf492c516cd3e$var$__assign({
            region: region,
            credentials: credentials,
            customUserAgent: (0, $eb2795a39e4549eb$export$ede38edb26c0bfdf)()
        }, localTestingConfig), {
            requestHandler: new (0, $55b56d2c458f166b$export$43af02f23afacda3)({}, emitter)
        }));
        return s3client;
    };
    AWSS3Provider.CATEGORY = 'Storage';
    AWSS3Provider.PROVIDER_NAME = 'AWSS3';
    return AWSS3Provider;
}();
var /**
 * @deprecated use named import
 */ $53fcf492c516cd3e$export$2e2bcd8739ae039 = $53fcf492c516cd3e$export$a8628d9eb315b139;


var $ebb8faf6efc571c7$var$__assign = undefined && undefined.__assign || function() {
    $ebb8faf6efc571c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ebb8faf6efc571c7$var$__assign.apply(this, arguments);
};
var $ebb8faf6efc571c7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ebb8faf6efc571c7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ebb8faf6efc571c7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ebb8faf6efc571c7$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('StorageClass');
var $ebb8faf6efc571c7$var$DEFAULT_PROVIDER = 'AWSS3';
/**
 * Provide storage methods to use AWS S3
 */ var $ebb8faf6efc571c7$export$bf2a15d34f3c441c = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        $ebb8faf6efc571c7$var$logger.debug('Storage Options', this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return 'Storage';
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Storage') {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $ebb8faf6efc571c7$var$logger.debug('No plugin found with providerName', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        $ebb8faf6efc571c7$var$logger.debug('configure Storage');
        if (!config) return this._config;
        var amplifyConfig = (0, $ae0d5b8a0cfbbb01$export$7acfa6ed01010e37).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            'bucket',
            'region',
            'level',
            'track',
            'customPrefix',
            'serverSideEncryption',
            'SSECustomerAlgorithm',
            'SSECustomerKey',
            'SSECustomerKeyMD5',
            'SSEKMSKeyId'
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$ebb8faf6efc571c7$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$ebb8faf6efc571c7$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var _b = $ebb8faf6efc571c7$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$ebb8faf6efc571c7$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== 'string') _this._config[providerName] = $ebb8faf6efc571c7$var$__assign($ebb8faf6efc571c7$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $53fcf492c516cd3e$export$a8628d9eb315b139)());
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to either a presigned url or the object
     */ Storage.prototype.get = function(key, config) {
        return $ebb8faf6efc571c7$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ebb8faf6efc571c7$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ebb8faf6efc571c7$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ebb8faf6efc571c7$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.get(key, config)
                ];
            });
        });
    };
    /**
     * Put a file in storage bucket specified to configure method
     * @param {string} key - key of the object
     * @param {Object} object - File to be put in bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ Storage.prototype.put = function(key, object, config) {
        return $ebb8faf6efc571c7$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ebb8faf6efc571c7$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ebb8faf6efc571c7$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ebb8faf6efc571c7$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.put(key, object, config)
                ];
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ Storage.prototype.remove = function(key, config) {
        return $ebb8faf6efc571c7$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ebb8faf6efc571c7$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ebb8faf6efc571c7$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ebb8faf6efc571c7$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.remove(key, config)
                ];
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {String} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public, maxKeys: NUMBER }
     * @return - Promise resolves to list of keys for all objects in path
     */ Storage.prototype.list = function(path, config) {
        return $ebb8faf6efc571c7$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $ebb8faf6efc571c7$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $ebb8faf6efc571c7$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $ebb8faf6efc571c7$var$logger.debug('No plugin found with providerName', provider);
                    Promise.reject('No plugin found in Storage for the provider');
                }
                return [
                    2 /*return*/ ,
                    prov.list(path, config)
                ];
            });
        });
    };
    return Storage;
}();
var /**
 * @deprecated use named import
 */ $ebb8faf6efc571c7$export$2e2bcd8739ae039 = $ebb8faf6efc571c7$export$bf2a15d34f3c441c;




var $8fb5583da54aaa9c$var$__assign = undefined && undefined.__assign || function() {
    $8fb5583da54aaa9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8fb5583da54aaa9c$var$__assign.apply(this, arguments);
};
var $8fb5583da54aaa9c$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Storage');
var $8fb5583da54aaa9c$var$_instance = null;
var $8fb5583da54aaa9c$var$getInstance = function() {
    if ($8fb5583da54aaa9c$var$_instance) return $8fb5583da54aaa9c$var$_instance;
    $8fb5583da54aaa9c$var$logger.debug('Create Storage Instance, debug');
    $8fb5583da54aaa9c$var$_instance = new (0, $ebb8faf6efc571c7$export$bf2a15d34f3c441c)();
    $8fb5583da54aaa9c$var$_instance.vault = new (0, $ebb8faf6efc571c7$export$bf2a15d34f3c441c)();
    var old_configure = $8fb5583da54aaa9c$var$_instance.configure;
    $8fb5583da54aaa9c$var$_instance.configure = function(options) {
        $8fb5583da54aaa9c$var$logger.debug('storage configure called');
        var vaultConfig = $8fb5583da54aaa9c$var$__assign({}, old_configure.call($8fb5583da54aaa9c$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== 'string') vaultConfig[providerName] = $8fb5583da54aaa9c$var$__assign($8fb5583da54aaa9c$var$__assign({}, vaultConfig[providerName]), {
                level: 'private'
            });
        });
        $8fb5583da54aaa9c$var$logger.debug('storage vault configure called');
        $8fb5583da54aaa9c$var$_instance.vault.configure(vaultConfig);
    };
    return $8fb5583da54aaa9c$var$_instance;
};
var $8fb5583da54aaa9c$export$bf2a15d34f3c441c = $8fb5583da54aaa9c$var$getInstance();
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).register($8fb5583da54aaa9c$export$bf2a15d34f3c441c);
var /**
 * @deprecated use named import
 */ $8fb5583da54aaa9c$export$2e2bcd8739ae039 = $8fb5583da54aaa9c$export$bf2a15d34f3c441c;






var $3adece330e373730$exports = {};
!function(t, _) {
    $3adece330e373730$exports = _();
}($3adece330e373730$exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});





/** Always importing Auth when users import Amplify such that
    for unauthenticated access (no sign in and sign up),
    users don't have to import Auth explicitly **/ (0, $471a5eebd413fda8$export$a3858a9a153cffc7).Auth = (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d);
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).Cache = (0, $6d9ebea818722de7$export$2e2bcd8739ae039);
(0, $471a5eebd413fda8$export$a3858a9a153cffc7).ServiceWorker = (0, $a22e1f3e60b67e29$export$efa87b877bb98f58);
var /**
 * @deprecated use named import
 */ $5670e7b58399d657$export$2e2bcd8739ae039 = (0, $471a5eebd413fda8$export$a3858a9a153cffc7);


var $0362c4f0d0793455$exports = {};
var $2151e708169cc25c$exports = {};
$parcel$export($2151e708169cc25c$exports, "ApolloLink", function () { return $168cabbf484f42b9$export$2fed3d61f740bc7f; });
$parcel$export($2151e708169cc25c$exports, "ApolloProvider", function () { return $dc9a7e7d0f7ace8e$exports.ApolloProvider; });
$parcel$export($2151e708169cc25c$exports, "useLazyQuery", function () { return $dc9a7e7d0f7ace8e$exports.useLazyQuery; });
$parcel$export($2151e708169cc25c$exports, "useMutation", function () { return $dc9a7e7d0f7ace8e$exports.useMutation; });
$parcel$export($2151e708169cc25c$exports, "useQuery", function () { return $dc9a7e7d0f7ace8e$exports.useQuery; });

$parcel$export($2151e708169cc25c$exports, "ApolloClient", function () { return $eab636ebc55e3402$export$13f5a5f0f1dbab88; });
$parcel$export($2151e708169cc25c$exports, "mergeOptions", function () { return $eab636ebc55e3402$export$235b7fc70b9fc359; });
$parcel$export($2151e708169cc25c$exports, "NetworkStatus", function () { return $63485496121d66f5$export$bd096ddbd246c79c; });
$parcel$export($2151e708169cc25c$exports, "InMemoryCache", function () { return $293471a6ca1d60d0$export$467265324939f47f; });
$parcel$export($2151e708169cc25c$exports, "gql", function () { return $4530924e0b1e6e3c$export$2e2bcd8739ae039; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1c0ef74047f3db21$var$extendStatics = function(d, b) {
    $1c0ef74047f3db21$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1c0ef74047f3db21$var$extendStatics(d, b);
};
function $1c0ef74047f3db21$export$a8ba968b8961cb8a(d, b) {
    $1c0ef74047f3db21$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1c0ef74047f3db21$export$18ce0697a983be9b = function() {
    $1c0ef74047f3db21$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c0ef74047f3db21$export$18ce0697a983be9b.apply(this, arguments);
};
function $1c0ef74047f3db21$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1c0ef74047f3db21$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1c0ef74047f3db21$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1c0ef74047f3db21$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1c0ef74047f3db21$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1c0ef74047f3db21$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1c0ef74047f3db21$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1c0ef74047f3db21$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1c0ef74047f3db21$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1c0ef74047f3db21$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1c0ef74047f3db21$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1c0ef74047f3db21$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1c0ef74047f3db21$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1c0ef74047f3db21$export$10c90e4f7922046c(v) {
    return this instanceof $1c0ef74047f3db21$export$10c90e4f7922046c ? (this.v = v, this) : new $1c0ef74047f3db21$export$10c90e4f7922046c(v);
}
function $1c0ef74047f3db21$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1c0ef74047f3db21$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1c0ef74047f3db21$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1c0ef74047f3db21$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1c0ef74047f3db21$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1c0ef74047f3db21$export$19a8beecd37a4c45 === "function" ? $1c0ef74047f3db21$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1c0ef74047f3db21$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1c0ef74047f3db21$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1c0ef74047f3db21$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1c0ef74047f3db21$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1c0ef74047f3db21$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $0fc3a50e5c232703$var$extendStatics = function(d, b) {
    $0fc3a50e5c232703$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $0fc3a50e5c232703$var$extendStatics(d, b);
};
function $0fc3a50e5c232703$export$a8ba968b8961cb8a(d, b) {
    $0fc3a50e5c232703$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0fc3a50e5c232703$export$18ce0697a983be9b = function() {
    $0fc3a50e5c232703$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0fc3a50e5c232703$export$18ce0697a983be9b.apply(this, arguments);
};
function $0fc3a50e5c232703$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0fc3a50e5c232703$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0fc3a50e5c232703$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0fc3a50e5c232703$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0fc3a50e5c232703$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0fc3a50e5c232703$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $0fc3a50e5c232703$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $0fc3a50e5c232703$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $0fc3a50e5c232703$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0fc3a50e5c232703$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0fc3a50e5c232703$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0fc3a50e5c232703$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0fc3a50e5c232703$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0fc3a50e5c232703$export$10c90e4f7922046c(v) {
    return this instanceof $0fc3a50e5c232703$export$10c90e4f7922046c ? (this.v = v, this) : new $0fc3a50e5c232703$export$10c90e4f7922046c(v);
}
function $0fc3a50e5c232703$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0fc3a50e5c232703$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0fc3a50e5c232703$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0fc3a50e5c232703$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $0fc3a50e5c232703$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0fc3a50e5c232703$export$19a8beecd37a4c45 === "function" ? $0fc3a50e5c232703$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0fc3a50e5c232703$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $0fc3a50e5c232703$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $0fc3a50e5c232703$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0fc3a50e5c232703$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $0fc3a50e5c232703$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


(function(Object1) {
    typeof globalThis !== 'object' && (this ? get() : (Object1.defineProperty(Object1.prototype, '_T_', {
        configurable: true,
        get: get
    }), _T_));
    function get() {
        var global = this || self;
        global.globalThis = global;
        delete Object1.prototype._T_;
    }
})(Object);
var $6e6802d8caa12845$export$2e2bcd8739ae039 = globalThis;


var $cd76a4c66ed97e84$var$global = (0, $6e6802d8caa12845$export$2e2bcd8739ae039);
var $cd76a4c66ed97e84$var$console = $cd76a4c66ed97e84$var$global.console;
var $cd76a4c66ed97e84$var$genericMessage = "Invariant Violation";
var $cd76a4c66ed97e84$var$_a = Object.setPrototypeOf, $cd76a4c66ed97e84$var$setPrototypeOf = $cd76a4c66ed97e84$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $cd76a4c66ed97e84$var$_a;
var $cd76a4c66ed97e84$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $0fc3a50e5c232703$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $cd76a4c66ed97e84$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $cd76a4c66ed97e84$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $cd76a4c66ed97e84$var$genericMessage;
        $cd76a4c66ed97e84$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $cd76a4c66ed97e84$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $cd76a4c66ed97e84$export$cea12affaee22fe8(message);
}
var $cd76a4c66ed97e84$var$verbosityLevels = [
    "log",
    "warn",
    "error",
    "silent"
];
var $cd76a4c66ed97e84$var$verbosityLevel = $cd76a4c66ed97e84$var$verbosityLevels.indexOf("log");
function $cd76a4c66ed97e84$var$wrapConsoleMethod(method) {
    return function() {
        if ($cd76a4c66ed97e84$var$verbosityLevels.indexOf(method) >= $cd76a4c66ed97e84$var$verbosityLevel) return $cd76a4c66ed97e84$var$console[method].apply($cd76a4c66ed97e84$var$console, arguments);
    };
}
(function(invariant) {
    invariant.log = $cd76a4c66ed97e84$var$wrapConsoleMethod("log");
    invariant.warn = $cd76a4c66ed97e84$var$wrapConsoleMethod("warn");
    invariant.error = $cd76a4c66ed97e84$var$wrapConsoleMethod("error");
})($cd76a4c66ed97e84$export$f5708dca728d7177 || ($cd76a4c66ed97e84$export$f5708dca728d7177 = {}));
function $cd76a4c66ed97e84$export$a80e09f2cd325fb8(level) {
    var old = $cd76a4c66ed97e84$var$verbosityLevels[$cd76a4c66ed97e84$var$verbosityLevel];
    $cd76a4c66ed97e84$var$verbosityLevel = Math.max(0, $cd76a4c66ed97e84$var$verbosityLevels.indexOf(level));
    return old;
}
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $cd76a4c66ed97e84$export$e54fe5b0f43758f7 = $cd76a4c66ed97e84$var$global.process || {
    env: {}
};
if (!$cd76a4c66ed97e84$var$global.process) try {
    Object.defineProperty((0, $6e6802d8caa12845$export$2e2bcd8739ae039), "process", {
        value: $cd76a4c66ed97e84$export$e54fe5b0f43758f7,
        writable: true,
        enumerable: false,
        configurable: true
    });
} catch (_b) {
// If this fails, it isn't the end of the world.
}
var $cd76a4c66ed97e84$var$invariant$1 = $cd76a4c66ed97e84$export$f5708dca728d7177;
var $cd76a4c66ed97e84$export$2e2bcd8739ae039 = $cd76a4c66ed97e84$var$invariant$1;




// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $13a9b929cb97fad0$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $13a9b929cb97fad0$export$2e2bcd8739ae039 = $13a9b929cb97fad0$var$nodejsCustomInspectSymbol;


function $00e0507387858aba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $00e0507387858aba$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $00e0507387858aba$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $00e0507387858aba$var$_typeof(obj);
}
var $00e0507387858aba$var$MAX_ARRAY_LENGTH = 10;
var $00e0507387858aba$var$MAX_RECURSIVE_DEPTH = 2;
function $00e0507387858aba$export$2e2bcd8739ae039(value) {
    return $00e0507387858aba$var$formatValue(value, []);
}
function $00e0507387858aba$var$formatValue(value, seenValues) {
    switch($00e0507387858aba$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $00e0507387858aba$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $00e0507387858aba$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $00e0507387858aba$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $00e0507387858aba$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $00e0507387858aba$var$formatArray(value, seenValues);
    return $00e0507387858aba$var$formatObject(value, seenValues);
}
function $00e0507387858aba$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $00e0507387858aba$var$MAX_RECURSIVE_DEPTH) return '[' + $00e0507387858aba$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $00e0507387858aba$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $00e0507387858aba$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $00e0507387858aba$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($00e0507387858aba$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($00e0507387858aba$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $00e0507387858aba$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $13a9b929cb97fad0$export$2e2bcd8739ae039))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $00e0507387858aba$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


function $d21ee6ace4420d01$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}



function $164159eb5c9960f2$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $d21ee6ace4420d01$export$2e2bcd8739ae039)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $13a9b929cb97fad0$export$2e2bcd8739ae039) classObject.prototype[0, $13a9b929cb97fad0$export$2e2bcd8739ae039] = fn;
}


var $d123b4e875f670f4$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $164159eb5c9960f2$export$2e2bcd8739ae039)($d123b4e875f670f4$export$18a2be9195644f38);
var $d123b4e875f670f4$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $164159eb5c9960f2$export$2e2bcd8739ae039)($d123b4e875f670f4$export$50792b0e93539fde);
function $d123b4e875f670f4$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 


var $0f36c934b7f2a151$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0f36c934b7f2a151$export$a89c95c098ac2a58 = Object.freeze({});
function $0f36c934b7f2a151$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0f36c934b7f2a151$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $d123b4e875f670f4$export$8ee0fc9ee280b4ee)(node)) throw new Error("Invalid AST Node: ".concat((0, $00e0507387858aba$export$2e2bcd8739ae039)(node), "."));
            var visitFn = $0f36c934b7f2a151$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0f36c934b7f2a151$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $d123b4e875f670f4$export$8ee0fc9ee280b4ee)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0f36c934b7f2a151$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0f36c934b7f2a151$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0f36c934b7f2a151$export$a89c95c098ac2a58) skipping[i] = $0f36c934b7f2a151$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0f36c934b7f2a151$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0f36c934b7f2a151$export$a89c95c098ac2a58) skipping[i] = $0f36c934b7f2a151$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0f36c934b7f2a151$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}



function $25c4098f02b173bc$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $25c4098f02b173bc$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(evaledValue !== void 0, 38);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $25c4098f02b173bc$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $25c4098f02b173bc$export$2dafb573e282fe8d(names, root) {
    return $25c4098f02b173bc$export$1b217de6ce18b9a(root).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $25c4098f02b173bc$export$8d1e9e5bbfa5d09a(document) {
    return document && $25c4098f02b173bc$export$2dafb573e282fe8d([
        'client'
    ], document) && $25c4098f02b173bc$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $25c4098f02b173bc$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $25c4098f02b173bc$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$25c4098f02b173bc$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 39);
        var ifArgument = directiveArguments[0];
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === 'if', 40);
        var ifValue = ifArgument.value;
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 41);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}




function $1081014e8b85fcce$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(42);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(fragments.length === 1, 43);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $1c0ef74047f3db21$export$6388937ca91ccae8)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $1081014e8b85fcce$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $1081014e8b85fcce$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread':
            var fragment = fragmentMap && fragmentMap[selection.name.value];
            (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(fragment, 44);
            return fragment;
        default:
            return null;
    }
}



var $d2d1e34902e2629b$exports = {};
'use strict';
$d2d1e34902e2629b$exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};




function $9745e36fc8004d84$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $9745e36fc8004d84$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function $9745e36fc8004d84$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $9745e36fc8004d84$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $9745e36fc8004d84$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $9745e36fc8004d84$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $9745e36fc8004d84$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $9745e36fc8004d84$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $9745e36fc8004d84$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $9745e36fc8004d84$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $9745e36fc8004d84$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $9745e36fc8004d84$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($9745e36fc8004d84$var$isIntValue(value) || $9745e36fc8004d84$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($9745e36fc8004d84$var$isBooleanValue(value) || $9745e36fc8004d84$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($9745e36fc8004d84$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $9745e36fc8004d84$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($9745e36fc8004d84$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($9745e36fc8004d84$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $9745e36fc8004d84$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($9745e36fc8004d84$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($9745e36fc8004d84$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(53);
}
function $9745e36fc8004d84$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $9745e36fc8004d84$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9745e36fc8004d84$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $9745e36fc8004d84$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $9745e36fc8004d84$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $9745e36fc8004d84$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (args && directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($d2d1e34902e2629b$exports)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($9745e36fc8004d84$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $9745e36fc8004d84$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9745e36fc8004d84$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $9745e36fc8004d84$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $9745e36fc8004d84$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') return result.__typename;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($9745e36fc8004d84$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === '__typename') return result[$9745e36fc8004d84$export$7d1ad22471852218(selection)];
        } else {
            var typename = $9745e36fc8004d84$export$cf7bf7e4f289cc26(result, (0, $1081014e8b85fcce$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') return typename;
        }
    }
}
function $9745e36fc8004d84$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $9745e36fc8004d84$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}


function $17ae57d9cfe56e00$export$a7d0d8111d2386df(doc) {
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(doc && doc.kind === 'Document', 45);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(46);
        return definition;
    });
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(operations.length <= 1, 47);
    return doc;
}
function $17ae57d9cfe56e00$export$7a5b1fa979d2c158(doc) {
    $17ae57d9cfe56e00$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $17ae57d9cfe56e00$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $17ae57d9cfe56e00$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $17ae57d9cfe56e00$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $17ae57d9cfe56e00$export$7a5b1fa979d2c158(doc);
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(queryDef && queryDef.operation === 'query', 48);
    return queryDef;
}
function $17ae57d9cfe56e00$export$772111caef41b3f5(doc) {
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(doc.kind === 'Document', 49);
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(doc.definitions.length <= 1, 50);
    var fragmentDef = doc.definitions[0];
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(fragmentDef.kind === 'FragmentDefinition', 51);
    return fragmentDef;
}
function $17ae57d9cfe56e00$export$f431198736b7f96d(queryDoc) {
    $17ae57d9cfe56e00$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(52);
}
function $17ae57d9cfe56e00$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $9745e36fc8004d84$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}







function $12eae7d273eb9e04$export$21c5d5745f10f2e(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}




var $3068b259105be920$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $3068b259105be920$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $3068b259105be920$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $3068b259105be920$var$nullIfDocIsEmpty(doc) {
    return $3068b259105be920$var$isEmpty((0, $17ae57d9cfe56e00$export$7a5b1fa979d2c158)(doc) || (0, $17ae57d9cfe56e00$export$772111caef41b3f5)(doc), (0, $1081014e8b85fcce$export$193789b4c8246dd4)((0, $17ae57d9cfe56e00$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $3068b259105be920$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $3068b259105be920$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $3068b259105be920$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($3068b259105be920$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $3068b259105be920$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($3068b259105be920$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && (0, $12eae7d273eb9e04$export$21c5d5745f10f2e)(variablesToRemove, function(v) {
        return !!v.name && !variablesInUse[v.name];
    }).length) modifiedDoc = $3068b259105be920$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && (0, $12eae7d273eb9e04$export$21c5d5745f10f2e)(fragmentSpreadsToRemove, function(fs) {
        return !!fs.name && !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $3068b259105be920$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $3068b259105be920$export$43b332f87950a467(doc) {
    return (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)((0, $17ae57d9cfe56e00$export$a7d0d8111d2386df)(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $1c0ef74047f3db21$export$6388937ca91ccae8)(selections, [
                        $3068b259105be920$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
$3068b259105be920$export$43b332f87950a467.added = function(field) {
    return field === $3068b259105be920$var$TYPENAME_FIELD;
};
var $3068b259105be920$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $3068b259105be920$export$74985f3324559867(doc) {
    return $3068b259105be920$export$e5ae0530da5fe96c([
        $3068b259105be920$var$connectionRemoveConfig
    ], (0, $17ae57d9cfe56e00$export$a7d0d8111d2386df)(doc));
}
function $3068b259105be920$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $3068b259105be920$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $3068b259105be920$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($3068b259105be920$var$getDirectiveMatcher(directives)) || nestedCheck && $3068b259105be920$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $3068b259105be920$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $3068b259105be920$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $3068b259105be920$var$getArgumentMatcher(config);
    return $3068b259105be920$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $3068b259105be920$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $3068b259105be920$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $3068b259105be920$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection) || (0, $9745e36fc8004d84$export$22a1cdafaf27bcff)(selection)) && selection.selectionSet) $3068b259105be920$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $3068b259105be920$export$57c368c23873f32b(document) {
    var definition = (0, $17ae57d9cfe56e00$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $3068b259105be920$export$8eae69e876ee321e(document) {
    (0, $17ae57d9cfe56e00$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $3068b259105be920$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return (0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}




var $c772d51c17702622$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c772d51c17702622$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $c772d51c17702622$export$160070228be94b08(sources);
}
function $c772d51c17702622$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $c772d51c17702622$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
function $c772d51c17702622$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
var $c772d51c17702622$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $c772d51c17702622$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $c772d51c17702622$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = $c772d51c17702622$var$isObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ($c772d51c17702622$var$isObject(source) && $c772d51c17702622$var$isObject(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($c772d51c17702622$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $1c0ef74047f3db21$export$6388937ca91ccae8)([
                            target,
                            source,
                            sourceKey
                        ], context));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ($c772d51c17702622$var$isObject(value) && !this.pastCopies.has(value)) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            this.pastCopies.add(value);
        }
        return value;
    };
    return DeepMerger;
}();


function $a19243e5d55d358c$export$e243c4ad6f76d660(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming) {
            return existing ? (0, $1c0ef74047f3db21$export$6388937ca91ccae8)(existing, incoming) : incoming;
        }
    };
}
function $a19243e5d55d358c$export$8888432c2a216040(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (args) {
                var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                for(var i = 0; i < incoming.length; ++i)merged[offset + i] = incoming[i];
            } else merged.push.apply(merged, incoming);
            return merged;
        }
    };
}
function $a19243e5d55d358c$export$e16db2cef93d81f6(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        read: function(existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing) return;
            var edges = [];
            var startCursor = "";
            var endCursor = "";
            existing.edges.forEach(function(edge) {
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        startCursor = startCursor || edge.cursor;
                        endCursor = edge.cursor;
                    }
                }
            });
            return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, $a19243e5d55d358c$var$getExtras(existing)), {
                edges: edges,
                pageInfo: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, existing.pageInfo), {
                    startCursor: startCursor,
                    endCursor: endCursor
                })
            });
        },
        merge: function(existing, incoming, _a) {
            if (existing === void 0) existing = $a19243e5d55d358c$var$makeEmptyData();
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            var incomingEdges = incoming.edges ? incoming.edges.map(function(edge) {
                if (isReference(edge = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, edge))) edge.cursor = readField("cursor", edge);
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                if (firstEdge && startCursor) firstEdge.cursor = startCursor;
                if (lastEdge && endCursor) lastEdge.cursor = endCursor;
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) incoming = (0, $c772d51c17702622$export$dd702b3c8240390c)(incoming, {
                    pageInfo: {
                        startCursor: firstCursor
                    }
                });
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) incoming = (0, $c772d51c17702622$export$dd702b3c8240390c)(incoming, {
                    pageInfo: {
                        endCursor: lastCursor
                    }
                });
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.after;
                });
                if (index >= 0) prefix = prefix.slice(0, index + 1);
            } else if (args && args.before) {
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.before;
                });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            } else if (incoming.edges) prefix = [];
            var edges = (0, $1c0ef74047f3db21$export$6388937ca91ccae8)(prefix, incomingEdges, suffix);
            var pageInfo = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0, $1c0ef74047f3db21$export$3c9a16f847548506)(_b, [
                    "hasPreviousPage",
                    "hasNextPage",
                    "startCursor",
                    "endCursor"
                ]);
                Object.assign(pageInfo, extras);
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage) pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor) pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage) pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor) pageInfo.endCursor = endCursor;
                }
            }
            return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, $a19243e5d55d358c$var$getExtras(existing)), $a19243e5d55d358c$var$getExtras(incoming)), {
                edges: edges,
                pageInfo: pageInfo
            });
        }
    };
}
var $a19243e5d55d358c$var$getExtras = function(obj) {
    return (0, $1c0ef74047f3db21$export$3c9a16f847548506)(obj, $a19243e5d55d358c$var$notExtras);
};
var $a19243e5d55d358c$var$notExtras = [
    "edges",
    "pageInfo"
];
function $a19243e5d55d358c$var$makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: ""
        }
    };
}



parcelRequire("l44DO");
(0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).prototype['@@observable'] = function() {
    return this;
};



var $6e6fde8d50bbb700$var$toString = Object.prototype.toString;
function $6e6fde8d50bbb700$export$629a2bd3f5a49ecc(value) {
    return $6e6fde8d50bbb700$var$cloneDeepHelper(value);
}
function $6e6fde8d50bbb700$var$cloneDeepHelper(val, seen) {
    switch($6e6fde8d50bbb700$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $6e6fde8d50bbb700$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $6e6fde8d50bbb700$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}


function $03d4d56a4cdf4207$export$4bd44a2aa29d3d6e() {
    return 'development';
}
function $03d4d56a4cdf4207$export$f0cb0fda19c18b37(env) {
    return $03d4d56a4cdf4207$export$4bd44a2aa29d3d6e() === env;
}
function $03d4d56a4cdf4207$export$df77466336fe5355() {
    return $03d4d56a4cdf4207$export$f0cb0fda19c18b37('development') === true;
}
function $03d4d56a4cdf4207$export$410cbc2864fa25b5() {
    return $03d4d56a4cdf4207$export$f0cb0fda19c18b37('test') === true;
}


function $24fc4d147ff47476$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $24fc4d147ff47476$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ($24fc4d147ff47476$var$isObject(obj)) {
            if (!Object.isFrozen(obj)) Object.freeze(obj);
            Object.getOwnPropertyNames(obj).forEach(function(name) {
                if ($24fc4d147ff47476$var$isObject(obj[name])) workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function $24fc4d147ff47476$export$7f9c177735b71f18(obj) {
    return obj;
}


function $5f2b90e1a9e73549$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}



function $9dd27e0de5b47bdd$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                new Promise(function(resolve) {
                    return resolve(examiner(arg));
                }).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(e) {
                    --activeCallbackCount;
                    error && error.call(observer, e);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}






function $e27e70bb23806e5a$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))
        });
    }
    if (typeof Symbol === "function" && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}


function $0bedadf61bd47463$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $0bedadf61bd47463$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.addCount = 0;
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    (0, $5f2b90e1a9e73549$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) Promise.resolve().then(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    (0, $5f2b90e1a9e73549$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                if (_this.sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        (0, $5f2b90e1a9e73549$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($0bedadf61bd47463$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(sources)
        ];
        if ($0bedadf61bd47463$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
            ++this.addCount;
        }
    };
    Concast.prototype.removeObserver = function(observer, quietly) {
        if (this.observers.delete(observer) && --this.addCount < 1 && !quietly) this.handlers.error(new Error("Observable cancelled prematurely"));
    };
    Concast.prototype.cleanup = function(callback) {
        var _this = this;
        var called = false;
        var once = function() {
            if (!called) {
                called = true;
                _this.observers.delete(observer);
                callback();
            }
        };
        var observer = {
            next: once,
            error: once,
            complete: once
        };
        var count = this.addCount;
        this.addObserver(observer);
        this.addCount = count;
    };
    return Concast;
}((0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))));
(0, $e27e70bb23806e5a$export$33c8bd820eece9b2)($0bedadf61bd47463$export$ae0cf2ec7a6fa78e);



function $4601cc972277e257$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


function $902c27612e1be103$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length > 0 || false;
}


var $69ceb149a16d20bc$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');


function $7f27dcb76d655f12$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}





function $f8f6148122a7cd65$export$4fd972edbe7450d3(errorValue) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
        observer.error(errorValue);
    });
}



function $8246f7422af0f6d1$export$4dbaaf6c79705e6c(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}



function $adc4b504a22d7ae5$export$60f45028237c39d1(promise) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}


var $2e5a9920d2a85a54$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};



function $92b3fc0a29960409$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(26);
    }
    return operation;
}



function $7adac2cb01a6d35a$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $34e0cd820ce972bc$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $17ae57d9cfe56e00$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : '';
    return transformedOperation;
}




function $168cabbf484f42b9$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
}
function $168cabbf484f42b9$var$toLink(handler) {
    return typeof handler === 'function' ? new $168cabbf484f42b9$export$2fed3d61f740bc7f(handler) : handler;
}
function $168cabbf484f42b9$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $168cabbf484f42b9$var$LinkError = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
var $168cabbf484f42b9$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($168cabbf484f42b9$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $168cabbf484f42b9$var$toLink(left);
        var rightLink = $168cabbf484f42b9$var$toLink(right || new ApolloLink($168cabbf484f42b9$var$passthrough));
        if ($168cabbf484f42b9$var$isTerminating(leftLink) && $168cabbf484f42b9$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of() : rightLink.request(operation) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of() : rightLink.request(operation, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $7adac2cb01a6d35a$export$f29bedd62f56fcb2)(operation.context, (0, $34e0cd820ce972bc$export$4f3f7df1b558c729)((0, $92b3fc0a29960409$export$a92a48117d546c9)(operation)))) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $168cabbf484f42b9$var$toLink(first);
        if ($168cabbf484f42b9$var$isTerminating(firstLink)) return firstLink;
        var nextLink = $168cabbf484f42b9$var$toLink(second);
        if ($168cabbf484f42b9$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
            }) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
            }) || (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($168cabbf484f42b9$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(21);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $c83d4e97abb1b5e9$export$6e22c362a0406a2c = (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).empty;



var $38e508df7448dfce$export$6788812c4e6611e6 = (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).from;



var $7869d694be0a0e42$export$65980d18b75784e2 = (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).split;



var $8a5839baa6798a55$export$ee1b3e54f0441b22 = (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).concat;



var $e94d84574ec6fa6b$export$51396ec711da548b = (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).execute;



var $dc9a7e7d0f7ace8e$exports = {};





var $af4f22a2f9229942$export$83d89fbfd8236492 = '3.3.11';



var $e1b66af69cf82465$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1b66af69cf82465$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                throw parseError;
            }
        }).then(function(result) {
            if (response.status >= 300) (0, $2e5a9920d2a85a54$export$c33ef9219f27efd7)(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !$e1b66af69cf82465$var$hasOwnProperty.call(result, 'data') && !$e1b66af69cf82465$var$hasOwnProperty.call(result, 'errors')) (0, $2e5a9920d2a85a54$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
}



var $ca6956a8d0a31436$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};




/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $115290dc99333c54$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $115290dc99333c54$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $115290dc99333c54$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $115290dc99333c54$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $115290dc99333c54$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $115290dc99333c54$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $115290dc99333c54$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


function $c358b437c3ffbcb0$export$c2d084dc44961371(ast) {
    return (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(ast, {
        leave: $c358b437c3ffbcb0$var$printDocASTReducer
    });
}
var $c358b437c3ffbcb0$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $c358b437c3ffbcb0$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $c358b437c3ffbcb0$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(node.variableDefinitions, ', '), ')');
        var directives = $c358b437c3ffbcb0$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $c358b437c3ffbcb0$var$join([
            op,
            $c358b437c3ffbcb0$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $c358b437c3ffbcb0$var$wrap(' = ', defaultValue) + $c358b437c3ffbcb0$var$wrap(' ', $c358b437c3ffbcb0$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $c358b437c3ffbcb0$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $c358b437c3ffbcb0$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(args, ', '), ')');
        if (argsLine.length > $c358b437c3ffbcb0$var$MAX_LINE_LENGTH) argsLine = prefix + $c358b437c3ffbcb0$var$wrap('(\n', $c358b437c3ffbcb0$var$indent($c358b437c3ffbcb0$var$join(args, '\n')), '\n)');
        return $c358b437c3ffbcb0$var$join([
            argsLine,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $c358b437c3ffbcb0$var$wrap(' ', $c358b437c3ffbcb0$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $c358b437c3ffbcb0$var$join([
            '...',
            $c358b437c3ffbcb0$var$wrap('on ', typeCondition),
            $c358b437c3ffbcb0$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($c358b437c3ffbcb0$var$wrap('', $c358b437c3ffbcb0$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $115290dc99333c54$export$adb6ca997eeb1f45)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $c358b437c3ffbcb0$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $c358b437c3ffbcb0$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $c358b437c3ffbcb0$var$join([
            'schema',
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $c358b437c3ffbcb0$var$join([
            'scalar',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $c358b437c3ffbcb0$var$join([
            'type',
            name,
            $c358b437c3ffbcb0$var$wrap('implements ', $c358b437c3ffbcb0$var$join(interfaces, ' & ')),
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($c358b437c3ffbcb0$var$hasMultilineItems(args) ? $c358b437c3ffbcb0$var$wrap('(\n', $c358b437c3ffbcb0$var$indent($c358b437c3ffbcb0$var$join(args, '\n')), '\n)') : $c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(args, ', '), ')')) + ': ' + type + $c358b437c3ffbcb0$var$wrap(' ', $c358b437c3ffbcb0$var$join(directives, ' '));
    }),
    InputValueDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $c358b437c3ffbcb0$var$join([
            name + ': ' + type,
            $c358b437c3ffbcb0$var$wrap('= ', defaultValue),
            $c358b437c3ffbcb0$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $c358b437c3ffbcb0$var$join([
            'interface',
            name,
            $c358b437c3ffbcb0$var$wrap('implements ', $c358b437c3ffbcb0$var$join(interfaces, ' & ')),
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $c358b437c3ffbcb0$var$join([
            'union',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c358b437c3ffbcb0$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $c358b437c3ffbcb0$var$join([
            'enum',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $c358b437c3ffbcb0$var$join([
            name,
            $c358b437c3ffbcb0$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $c358b437c3ffbcb0$var$join([
            'input',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $c358b437c3ffbcb0$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($c358b437c3ffbcb0$var$hasMultilineItems(args) ? $c358b437c3ffbcb0$var$wrap('(\n', $c358b437c3ffbcb0$var$indent($c358b437c3ffbcb0$var$join(args, '\n')), '\n)') : $c358b437c3ffbcb0$var$wrap('(', $c358b437c3ffbcb0$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $c358b437c3ffbcb0$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $c358b437c3ffbcb0$var$join([
            'extend schema',
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $c358b437c3ffbcb0$var$join([
            'extend scalar',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $c358b437c3ffbcb0$var$join([
            'extend type',
            name,
            $c358b437c3ffbcb0$var$wrap('implements ', $c358b437c3ffbcb0$var$join(interfaces, ' & ')),
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $c358b437c3ffbcb0$var$join([
            'extend interface',
            name,
            $c358b437c3ffbcb0$var$wrap('implements ', $c358b437c3ffbcb0$var$join(interfaces, ' & ')),
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $c358b437c3ffbcb0$var$join([
            'extend union',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c358b437c3ffbcb0$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $c358b437c3ffbcb0$var$join([
            'extend enum',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $c358b437c3ffbcb0$var$join([
            'extend input',
            name,
            $c358b437c3ffbcb0$var$join(directives, ' '),
            $c358b437c3ffbcb0$var$block(fields)
        ], ' ');
    }
};
function $c358b437c3ffbcb0$var$addDescription(cb) {
    return function(node) {
        return $c358b437c3ffbcb0$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $c358b437c3ffbcb0$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $c358b437c3ffbcb0$var$block(array) {
    return $c358b437c3ffbcb0$var$wrap('{\n', $c358b437c3ffbcb0$var$indent($c358b437c3ffbcb0$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $c358b437c3ffbcb0$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $c358b437c3ffbcb0$var$indent(str) {
    return $c358b437c3ffbcb0$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $c358b437c3ffbcb0$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $c358b437c3ffbcb0$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($c358b437c3ffbcb0$var$isMultiline);
}


var $9111a093939311aa$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $9111a093939311aa$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $9111a093939311aa$var$defaultOptions = {
    method: 'POST'
};
var $9111a093939311aa$export$dd86f00dc866e75d = {
    http: $9111a093939311aa$var$defaultHttpOptions,
    headers: $9111a093939311aa$var$defaultHeaders,
    options: $9111a093939311aa$var$defaultOptions
};
var $9111a093939311aa$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, fallbackConfig.options), {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http || {};
    configs.forEach(function(config) {
        options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, http), config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $c358b437c3ffbcb0$export$c2d084dc44961371)(query);
    return {
        options: options,
        body: body
    };
};



var $55c0cd8b6b130764$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(22);
};


var $c10169dbdc8ea87e$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};


var $78c2926d653880e5$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};



var $aed09fe0dab48b39$exports = {};
"use strict";
Object.defineProperty($aed09fe0dab48b39$exports, "__esModule", {
    value: true
});
$aed09fe0dab48b39$exports.visit = $aed09fe0dab48b39$var$visit;
$aed09fe0dab48b39$exports.visitInParallel = $aed09fe0dab48b39$var$visitInParallel;
$aed09fe0dab48b39$exports.getVisitFn = $aed09fe0dab48b39$var$getVisitFn;
$aed09fe0dab48b39$exports.BREAK = $aed09fe0dab48b39$exports.QueryDocumentKeys = void 0;

var $aed09fe0dab48b39$var$_inspect = $aed09fe0dab48b39$var$_interopRequireDefault((parcelRequire("4sE1X")));
var $21895566dac6a839$exports = {};
"use strict";
Object.defineProperty($21895566dac6a839$exports, "__esModule", {
    value: true
});
$21895566dac6a839$exports.isNode = $21895566dac6a839$var$isNode;
$21895566dac6a839$exports.Token = $21895566dac6a839$exports.Location = void 0;

var $21895566dac6a839$var$_defineInspect = $21895566dac6a839$var$_interopRequireDefault((parcelRequire("8uRs4")));
function $21895566dac6a839$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $21895566dac6a839$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
$21895566dac6a839$exports.Location = $21895566dac6a839$var$Location;
(0, $21895566dac6a839$var$_defineInspect.default)($21895566dac6a839$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $21895566dac6a839$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
$21895566dac6a839$exports.Token = $21895566dac6a839$var$Token;
(0, $21895566dac6a839$var$_defineInspect.default)($21895566dac6a839$var$Token);
/**
 * @internal
 */ function $21895566dac6a839$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 


function $aed09fe0dab48b39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $aed09fe0dab48b39$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
$aed09fe0dab48b39$exports.QueryDocumentKeys = $aed09fe0dab48b39$var$QueryDocumentKeys;
var $aed09fe0dab48b39$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ $aed09fe0dab48b39$exports.BREAK = $aed09fe0dab48b39$var$BREAK;
function $aed09fe0dab48b39$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $aed09fe0dab48b39$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $21895566dac6a839$exports.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $aed09fe0dab48b39$var$_inspect.default)(node), "."));
            var visitFn = $aed09fe0dab48b39$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $aed09fe0dab48b39$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $21895566dac6a839$exports.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $aed09fe0dab48b39$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $aed09fe0dab48b39$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $aed09fe0dab48b39$var$BREAK) skipping[i] = $aed09fe0dab48b39$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $aed09fe0dab48b39$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $aed09fe0dab48b39$var$BREAK) skipping[i] = $aed09fe0dab48b39$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $aed09fe0dab48b39$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}











function $0732374ae176f0fc$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $ca6956a8d0a31436$export$5f8e80ac52052e28)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $ca6956a8d0a31436$export$5f8e80ac52052e28)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}



var $d23220de39dd5bfc$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, _b = linkOptions.includeUnusedVariables, includeUnusedVariables = _b === void 0 ? false : _b, requestOptions = (0, $1c0ef74047f3db21$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    (0, $55c0cd8b6b130764$export$8423f0cd3773115e)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $168cabbf484f42b9$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $78c2926d653880e5$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $9111a093939311aa$export$a00ebfd5f1eebfb1)(operation, (0, $9111a093939311aa$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0, $aed09fe0dab48b39$exports.visit)(operation.query, {
                Variable: function(node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') unusedNames_1.delete(node.name.value);
                }
            });
            if (unusedNames_1.size) {
                body.variables = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, body.variables);
                unusedNames_1.forEach(function(name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0, $c10169dbdc8ea87e$export$f5853cd1fc39aea6)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = (0, $0732374ae176f0fc$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $f8f6148122a7cd65$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $ca6956a8d0a31436$export$5f8e80ac52052e28)(body, 'Payload');
        } catch (parseError) {
            return (0, $f8f6148122a7cd65$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $e1b66af69cf82465$export$d4051215bea0639f)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError') return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};





var $a073b62f9ab58469$export$f4bbf1aec241cc1 = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $d23220de39dd5bfc$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $168cabbf484f42b9$export$2fed3d61f740bc7f));







var $91ec8471c498125e$var$_a = Object.prototype, $91ec8471c498125e$var$toString = $91ec8471c498125e$var$_a.toString, $91ec8471c498125e$var$hasOwnProperty = $91ec8471c498125e$var$_a.hasOwnProperty;
var $91ec8471c498125e$var$fnToStr = Function.prototype.toString;
var $91ec8471c498125e$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $91ec8471c498125e$export$411ce8e5a71e3069(a, b) {
    try {
        return $91ec8471c498125e$var$check(a, b);
    } finally{
        $91ec8471c498125e$var$previousComparisons.clear();
    }
}
function $91ec8471c498125e$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $91ec8471c498125e$var$toString.call(a);
    var bTag = $91ec8471c498125e$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($91ec8471c498125e$var$previouslyCompared(a, b)) return true;
            var aKeys = $91ec8471c498125e$var$definedKeys(a);
            var bKeys = $91ec8471c498125e$var$definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$91ec8471c498125e$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$91ec8471c498125e$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($91ec8471c498125e$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$91ec8471c498125e$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            var aCode = $91ec8471c498125e$var$fnToStr.call(a);
            if (aCode !== $91ec8471c498125e$var$fnToStr.call(b)) return false;
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !$91ec8471c498125e$var$endsWith(aCode, $91ec8471c498125e$var$nativeCodeSuffix);
    }
    // Otherwise the values are not equal.
    return false;
}
function $91ec8471c498125e$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($91ec8471c498125e$var$isDefinedKey, obj);
}
function $91ec8471c498125e$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
var $91ec8471c498125e$var$nativeCodeSuffix = "{ [native code] }";
function $91ec8471c498125e$var$endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $91ec8471c498125e$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $91ec8471c498125e$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $91ec8471c498125e$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $91ec8471c498125e$export$2e2bcd8739ae039 = $91ec8471c498125e$export$411ce8e5a71e3069;






function $de39ce370f7cbdab$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $de39ce370f7cbdab$var$generateErrorMessage = function(err) {
    var message = '';
    if ((0, $4601cc972277e257$export$d307f5934e447d0e)(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += errorMessage + "\n";
    });
    if (err.networkError) message += err.networkError.message + "\n";
    message = message.replace(/\n$/, '');
    return message;
};
var $de39ce370f7cbdab$export$26a337512320b8c6 = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $de39ce370f7cbdab$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);





var $63485496121d66f5$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($63485496121d66f5$export$bd096ddbd246c79c || ($63485496121d66f5$export$bd096ddbd246c79c = {}));
function $63485496121d66f5$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}






var $b6f69b5f5b1dd770$export$300bd58938939860 = function() {
    function Reobserver(observer, options, fetch, shouldFetch) {
        this.observer = observer;
        this.options = options;
        this.fetch = fetch;
        this.shouldFetch = shouldFetch;
    }
    Reobserver.prototype.reobserve = function(newOptions, newNetworkStatus) {
        if (newOptions) this.updateOptions(newOptions);
        else this.updatePolling();
        var concast = this.fetch(this.options, newNetworkStatus);
        if (this.concast) this.concast.removeObserver(this.observer, true);
        concast.addObserver(this.observer);
        return (this.concast = concast).promise;
    };
    Reobserver.prototype.updateOptions = function(newOptions) {
        Object.assign(this.options, (0, $7f27dcb76d655f12$export$8e16b83750b44988)(newOptions));
        this.updatePolling();
        return this;
    };
    Reobserver.prototype.stop = function() {
        if (this.concast) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
        }
        if (this.pollingInfo) {
            clearTimeout(this.pollingInfo.timeout);
            this.options.pollInterval = 0;
            this.updatePolling();
        }
    };
    Reobserver.prototype.updatePolling = function() {
        var _this = this;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(pollInterval, 20);
        if (this.shouldFetch === false) return;
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (_this.shouldFetch && _this.shouldFetch()) _this.reobserve({
                    fetchPolicy: "network-only",
                    nextFetchPolicy: _this.options.fetchPolicy || "cache-first"
                }, (0, $63485496121d66f5$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    return Reobserver;
}();


var $b29d538cad2b5757$var$warnedAboutUpdateQuery = false;
var $b29d538cad2b5757$export$6c1b56eac59c9584 = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.observer = {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    _this.updateLastResult(result);
                    (0, $5f2b90e1a9e73549$export$9f6c99ae166dbeca)(_this.observers, 'next', result);
                }
            },
            error: function(error) {
                _this.updateLastResult((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, _this.lastResult), {
                    error: error,
                    errors: error.graphQLErrors,
                    networkStatus: (0, $63485496121d66f5$export$bd096ddbd246c79c).error,
                    loading: false
                }));
                (0, $5f2b90e1a9e73549$export$9f6c99ae166dbeca)(_this.observers, 'error', _this.lastError = error);
            }
        };
        _this.isTornDown = false;
        _this.options = options;
        _this.queryId = queryManager.generateQueryId();
        var opDef = (0, $17ae57d9cfe56e00$export$7a5b1fa979d2c158)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        _this.queryInfo = queryInfo;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.lastResult;
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $63485496121d66f5$export$bd096ddbd246c79c).ready;
        var result = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $63485496121d66f5$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        if (this.isTornDown) return result;
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') delete result.partial;
        else if (!result.data || !this.queryManager.transform(this.options.query).hasForcedResolvers) {
            var diff = this.queryInfo.getDiff();
            result.data = diff.complete || this.options.returnPartialData ? diff.result : void 0;
            if (diff.complete) {
                if (result.networkStatus === (0, $63485496121d66f5$export$bd096ddbd246c79c).loading && (fetchPolicy === 'cache-first' || fetchPolicy === 'cache-only')) {
                    result.networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
                delete result.partial;
            } else result.partial = true;
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        return !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.lastResultSnapshot, newResult);
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') {
            reobserveOptions.fetchPolicy = 'network-only';
            reobserveOptions.nextFetchPolicy = fetchPolicy || "cache-first";
        }
        if (variables && !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.options.variables), variables);
        return this.newReobserver(false).reobserve(reobserveOptions, (0, $63485496121d66f5$export$bd096ddbd246c79c).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.options), fetchMoreOptions), {
            variables: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        var qid = this.queryManager.generateQueryId();
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.queryInfo.networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).fetchMore;
            this.observe();
        }
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $63485496121d66f5$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            var data = fetchMoreResult.data;
            var updateQuery = fetchMoreOptions.updateQuery;
            if (updateQuery) _this.updateQuery(function(previous) {
                return updateQuery(previous, {
                    fetchMoreResult: data,
                    variables: combinedOptions.variables
                });
            });
            else _this.queryManager.cache.writeQuery({
                query: combinedOptions.query,
                variables: combinedOptions.variables,
                data: data
            });
            return fetchMoreResult;
        }).finally(function() {
            _this.queryManager.stopQuery(qid);
            _this.reobserve();
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        var reobserveOptions = {
            fetchPolicy: fetchPolicy,
            variables: variables
        };
        if (fetchPolicy !== 'cache-first' && fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
            reobserveOptions.fetchPolicy = 'cache-and-network';
            reobserveOptions.nextFetchPolicy = fetchPolicy;
        }
        return this.reobserve(reobserveOptions, (0, $63485496121d66f5$export$bd096ddbd246c79c).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var _a;
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            previousResult: (_a = this.lastResult) === null || _a === void 0 ? void 0 : _a.data,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.getReobserver().updateOptions({
            pollInterval: pollInterval
        });
    };
    ObservableQuery.prototype.stopPolling = function() {
        if (this.reobserver) this.reobserver.updateOptions({
            pollInterval: 0
        });
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $6e6fde8d50bbb700$export$629a2bd3f5a49ecc)(newResult);
        if (!(0, $4601cc972277e257$export$d307f5934e447d0e)(newResult.errors)) delete this.lastError;
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        if (observer === this.observer) return function() {};
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $b29d538cad2b5757$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (this.lastError) observer.error && observer.error(this.lastError);
        else if (this.lastResult) observer.next && observer.next(this.lastResult);
        if (first) this.reobserve().catch(function(_) {});
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.getReobserver = function() {
        return this.reobserver || (this.reobserver = this.newReobserver(true));
    };
    ObservableQuery.prototype.newReobserver = function(shareOptions) {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        queryManager.setObservableQuery(this);
        return new (0, $b6f69b5f5b1dd770$export$300bd58938939860)(this.observer, shareOptions ? this.options : (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.options), function(currentOptions, newNetworkStatus) {
            queryManager.setObservableQuery(_this);
            return queryManager.fetchQueryObservable(queryId, currentOptions, newNetworkStatus);
        }, !queryManager.ssrMode && function() {
            return !(0, $63485496121d66f5$export$37509604341a3464)(_this.queryInfo.networkStatus);
        });
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        this.isTornDown = false;
        return this.getReobserver().reobserve(newOptions, newNetworkStatus);
    };
    ObservableQuery.prototype.observe = function() {
        this.observer.next(this.getCurrentResult(false));
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.reobserver) {
            this.reobserver.stop();
            delete this.reobserver;
        }
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}((0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))));
(0, $e27e70bb23806e5a$export$33c8bd820eece9b2)($b29d538cad2b5757$export$6c1b56eac59c9584);
function $b29d538cad2b5757$var$defaultSubscriptionObserverErrorCallback(error) {}







// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var $9355c1f69d79ae9b$var$defaultMakeData = function() {
    return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var $9355c1f69d79ae9b$var$_a = Array.prototype, $9355c1f69d79ae9b$var$forEach = $9355c1f69d79ae9b$var$_a.forEach, $9355c1f69d79ae9b$var$slice = $9355c1f69d79ae9b$var$_a.slice;
var $9355c1f69d79ae9b$export$73571c50d0f2507e = /** @class */ function() {
    function Trie(weakness, makeData) {
        if (weakness === void 0) weakness = true;
        if (makeData === void 0) makeData = $9355c1f69d79ae9b$var$defaultMakeData;
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function(array) {
        var node = this;
        $9355c1f69d79ae9b$var$forEach.call(array, function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = this.makeData($9355c1f69d79ae9b$var$slice.call(array)));
    };
    Trie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $9355c1f69d79ae9b$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}();
function $9355c1f69d79ae9b$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $befa4e6383d64e40$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $befa4e6383d64e40$var$MISSING_VALUE = {};
var $befa4e6383d64e40$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $befa4e6383d64e40$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $befa4e6383d64e40$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $befa4e6383d64e40$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $befa4e6383d64e40$var$MISSING_VALUE) break;
                if (context_1 !== $befa4e6383d64e40$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $befa4e6383d64e40$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($befa4e6383d64e40$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $befa4e6383d64e40$var$currentContext.slots[this.id] = $befa4e6383d64e40$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $befa4e6383d64e40$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $befa4e6383d64e40$var$currentContext;
            $befa4e6383d64e40$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $befa4e6383d64e40$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $befa4e6383d64e40$var$currentContext;
            return function() {
                var saved = $befa4e6383d64e40$var$currentContext;
                try {
                    $befa4e6383d64e40$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $befa4e6383d64e40$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($befa4e6383d64e40$var$currentContext) {
                var saved = $befa4e6383d64e40$var$currentContext;
                try {
                    $befa4e6383d64e40$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $befa4e6383d64e40$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $befa4e6383d64e40$var$globalKey = "@wry/context:Slot";
var $befa4e6383d64e40$var$host = Array;
var $befa4e6383d64e40$export$8c6ed5c666ac1360 = $befa4e6383d64e40$var$host[$befa4e6383d64e40$var$globalKey] || function() {
    var Slot = $befa4e6383d64e40$var$makeSlotClass();
    try {
        Object.defineProperty($befa4e6383d64e40$var$host, $befa4e6383d64e40$var$globalKey, {
            value: $befa4e6383d64e40$var$host[$befa4e6383d64e40$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $befa4e6383d64e40$export$2385a24977818dd0 = $befa4e6383d64e40$export$8c6ed5c666ac1360.bind, $befa4e6383d64e40$export$9fa6f2e300a97f8 = $befa4e6383d64e40$export$8c6ed5c666ac1360.noContext;
function $befa4e6383d64e40$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($befa4e6383d64e40$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $befa4e6383d64e40$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $befa4e6383d64e40$export$2385a24977818dd0(gen.next);
        var boundThrow = $befa4e6383d64e40$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($befa4e6383d64e40$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $befa4e6383d64e40$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $befa4e6383d64e40$var$wrappedFibers = [];
function $befa4e6383d64e40$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($befa4e6383d64e40$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $befa4e6383d64e40$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $befa4e6383d64e40$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $e3ad5e784c15e685$var$defaultDispose() {}
var $e3ad5e784c15e685$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $e3ad5e784c15e685$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function(key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    };
    Cache.prototype.set = function(key, value) {
        var node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $e3ad5e784c15e685$var$parentEntrySlot = new (0, $befa4e6383d64e40$export$8c6ed5c666ac1360)();
function $e3ad5e784c15e685$var$maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
var $e3ad5e784c15e685$var$emptySetPool = [];
var $e3ad5e784c15e685$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $e3ad5e784c15e685$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $e3ad5e784c15e685$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $e3ad5e784c15e685$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $e3ad5e784c15e685$var$valueCopy(value) {
    return value.slice(0);
}
var $e3ad5e784c15e685$var$Entry = /** @class */ function() {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function() {
        if (this.value.length === 1 && !$e3ad5e784c15e685$var$mightBeDirty(this)) return this.value[0];
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function(args) {
        $e3ad5e784c15e685$var$assert(!this.recomputing, "already recomputing");
        $e3ad5e784c15e685$var$rememberParent(this);
        return $e3ad5e784c15e685$var$mightBeDirty(this) ? $e3ad5e784c15e685$var$reallyRecompute(this, args) : $e3ad5e784c15e685$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $e3ad5e784c15e685$var$reportDirty(this);
        $e3ad5e784c15e685$var$forgetChildren(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $e3ad5e784c15e685$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $e3ad5e784c15e685$var$forgetChildren(this);
        $e3ad5e784c15e685$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $e3ad5e784c15e685$var$forgetChild(parent, _this);
        });
    };
    Entry.prototype.dependOn = function(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $e3ad5e784c15e685$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function() {
        var _this = this;
        if (this.deps) {
            this.deps.forEach(function(dep) {
                return dep.delete(_this);
            });
            this.deps.clear();
            $e3ad5e784c15e685$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}();
function $e3ad5e784c15e685$var$rememberParent(child) {
    var parent = $e3ad5e784c15e685$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($e3ad5e784c15e685$var$mightBeDirty(child)) $e3ad5e784c15e685$var$reportDirtyChild(parent, child);
        else $e3ad5e784c15e685$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $e3ad5e784c15e685$var$reallyRecompute(entry, args) {
    $e3ad5e784c15e685$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $e3ad5e784c15e685$var$parentEntrySlot.withValue(entry, $e3ad5e784c15e685$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($e3ad5e784c15e685$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $e3ad5e784c15e685$var$setClean(entry);
    return $e3ad5e784c15e685$var$valueGet(entry.value);
}
function $e3ad5e784c15e685$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $e3ad5e784c15e685$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $e3ad5e784c15e685$var$setClean(entry) {
    entry.dirty = false;
    if ($e3ad5e784c15e685$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $e3ad5e784c15e685$var$reportClean(entry);
}
function $e3ad5e784c15e685$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $e3ad5e784c15e685$var$reportDirtyChild(parent, child);
    });
}
function $e3ad5e784c15e685$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $e3ad5e784c15e685$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $e3ad5e784c15e685$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $e3ad5e784c15e685$var$assert(parent.childValues.has(child));
    $e3ad5e784c15e685$var$assert($e3ad5e784c15e685$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $e3ad5e784c15e685$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $e3ad5e784c15e685$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $e3ad5e784c15e685$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $e3ad5e784c15e685$var$assert(parent.childValues.has(child));
    $e3ad5e784c15e685$var$assert(!$e3ad5e784c15e685$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $e3ad5e784c15e685$var$valueCopy(child.value));
    else if (!$e3ad5e784c15e685$var$valueIs(childValue, child.value)) parent.setDirty();
    $e3ad5e784c15e685$var$removeDirtyChild(parent, child);
    if ($e3ad5e784c15e685$var$mightBeDirty(parent)) return;
    $e3ad5e784c15e685$var$reportClean(parent);
}
function $e3ad5e784c15e685$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($e3ad5e784c15e685$var$emptySetPool.length < $e3ad5e784c15e685$var$POOL_TARGET_SIZE) $e3ad5e784c15e685$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $e3ad5e784c15e685$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach(function(_value, child) {
        $e3ad5e784c15e685$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $e3ad5e784c15e685$var$assert(parent.dirtyChildren === null);
}
function $e3ad5e784c15e685$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $e3ad5e784c15e685$var$removeDirtyChild(parent, child);
}
function $e3ad5e784c15e685$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        $e3ad5e784c15e685$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $e3ad5e784c15e685$export$c723b7eff9d8f870(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = $e3ad5e784c15e685$var$parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) depsByKey.set(key, dep_1 = new Set);
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                $e3ad5e784c15e685$var$maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key) {
        var dep = depsByKey.get(key);
        if (dep) {
            dep.forEach(function(entry) {
                return entry.setDirty();
            });
            depsByKey.delete(key);
            $e3ad5e784c15e685$var$maybeUnsubscribe(dep);
        }
    };
    return depend;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $e3ad5e784c15e685$var$keyTrie = new (0, $9355c1f69d79ae9b$export$73571c50d0f2507e)(typeof WeakMap === "function");
function $e3ad5e784c15e685$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $e3ad5e784c15e685$var$keyTrie.lookupArray(args);
}
var $e3ad5e784c15e685$var$caches = new Set();
function $e3ad5e784c15e685$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $e3ad5e784c15e685$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey || $e3ad5e784c15e685$export$cd3144f8dd136006;
    function optimistic() {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new $e3ad5e784c15e685$var$Entry(originalFunction));
            entry.subscribe = options.subscribe;
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $e3ad5e784c15e685$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$e3ad5e784c15e685$var$parentEntrySlot.hasValue()) {
            $e3ad5e784c15e685$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $e3ad5e784c15e685$var$caches.clear();
        }
        return value;
    }
    function lookup() {
        var key = makeCacheKey.apply(null, arguments);
        if (key !== void 0) return cache.get(key);
    }
    optimistic.dirty = function() {
        var entry = lookup.apply(null, arguments);
        if (entry) entry.setDirty();
    };
    optimistic.peek = function() {
        var entry = lookup.apply(null, arguments);
        if (entry) return entry.peek();
    };
    optimistic.forget = function() {
        var key = makeCacheKey.apply(null, arguments);
        return key !== void 0 && cache.delete(key);
    };
    return optimistic;
}



var $966cab6a0dd47606$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.getFragmentDoc = (0, $e3ad5e784c15e685$export$4997ffc0176396a6)((0, $1081014e8b85fcce$export$abbf37c7cf644e41));
    }
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read({
            rootId: options.id || 'ROOT_QUERY',
            query: options.query,
            variables: options.variables,
            returnPartialData: options.returnPartialData,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read({
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            returnPartialData: options.returnPartialData,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        return this.write({
            dataId: options.id || 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
            broadcast: options.broadcast
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        return this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            broadcast: options.broadcast
        });
    };
    return ApolloCache;
}();


var $8e55112e06bff733$export$94affb487e701bf2;
$8e55112e06bff733$export$94affb487e701bf2 || ($8e55112e06bff733$export$94affb487e701bf2 = {});


var $255d62779a9fb347$export$257c68286583b0f9 = function() {
    function MissingFieldError(message, path, query, clientOnly, variables) {
        this.message = message;
        this.path = path;
        this.query = query;
        this.clientOnly = clientOnly;
        this.variables = variables;
    }
    return MissingFieldError;
}();



















var $6bf51bbd8f3de767$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $6bf51bbd8f3de767$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $6bf51bbd8f3de767$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $6bf51bbd8f3de767$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($6bf51bbd8f3de767$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $6bf51bbd8f3de767$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if (result && typeof result === "object") return Array.isArray(result) ? result.every(function(item) {
        return $6bf51bbd8f3de767$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(field) && (0, $25c4098f02b173bc$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $9745e36fc8004d84$export$7d1ad22471852218)(field);
            return $6bf51bbd8f3de767$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $6bf51bbd8f3de767$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $6bf51bbd8f3de767$export$4f39afca21bd938e(value) {
    return value !== null && typeof value === "object" && !(0, $9745e36fc8004d84$export$fa99cac1c0883c47)(value) && !Array.isArray(value);
}
function $6bf51bbd8f3de767$export$b874a818f7a2fa6d() {
    return new (0, $c772d51c17702622$export$509e11c221f576c0);
}


var $60bb2bf72aea2e9a$var$DELETE = Object.create(null);
var $60bb2bf72aea2e9a$var$delModifier = function() {
    return $60bb2bf72aea2e9a$var$DELETE;
};
var $60bb2bf72aea2e9a$var$INVALIDATE = Object.create(null);
var $60bb2bf72aea2e9a$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $24fc4d147ff47476$export$7f9c177735b71f18)((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $9745e36fc8004d84$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $9745e36fc8004d84$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $60bb2bf72aea2e9a$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $60bb2bf72aea2e9a$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(dataId, incoming) {
        var _this = this;
        var existing = this.lookup(dataId);
        var merged = new (0, $c772d51c17702622$export$509e11c221f576c0)($60bb2bf72aea2e9a$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $60bb2bf72aea2e9a$var$Layer)) delete merged[storeFieldName];
                    }
                });
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $60bb2bf72aea2e9a$var$DELETE,
                INVALIDATE: $60bb2bf72aea2e9a$var$INVALIDATE,
                isReference: (0, $9745e36fc8004d84$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $9745e36fc8004d84$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $60bb2bf72aea2e9a$var$delModifier ? $60bb2bf72aea2e9a$var$DELETE : modify((0, $24fc4d147ff47476$export$7f9c177735b71f18)(fieldValue), (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $60bb2bf72aea2e9a$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $60bb2bf72aea2e9a$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $60bb2bf72aea2e9a$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $60bb2bf72aea2e9a$var$delModifier, _a) : $60bb2bf72aea2e9a$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options) {
        var evicted = false;
        if (options.id) {
            if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $60bb2bf72aea2e9a$var$Layer) evicted = this.parent.evict(options) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $1c0ef74047f3db21$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $60bb2bf72aea2e9a$var$Layer) this.parent.getRootIdSet(ids);
        else Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $60bb2bf72aea2e9a$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var workSet_1 = new Set([
                this.data[dataId]
            ]);
            var canTraverse_1 = function(obj) {
                return obj !== null && typeof obj === 'object';
            };
            workSet_1.forEach(function(obj) {
                if ((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                else if (canTraverse_1(obj)) Object.values(obj).filter(canTraverse_1).forEach(workSet_1.add, workSet_1);
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return this.group.keyMaker.lookupArray(args);
    };
    return EntityStore;
}();
var $60bb2bf72aea2e9a$var$CacheGroup = function() {
    function CacheGroup(caching) {
        this.caching = caching;
        this.d = null;
        this.keyMaker = new (0, $9355c1f69d79ae9b$export$73571c50d0f2507e)((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9));
        this.d = caching ? (0, $e3ad5e784c15e685$export$c723b7eff9d8f870)() : null;
    }
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($60bb2bf72aea2e9a$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) this.d($60bb2bf72aea2e9a$var$makeDepKey(dataId, fieldName));
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($60bb2bf72aea2e9a$var$makeDepKey(dataId, storeFieldName));
    };
    return CacheGroup;
}();
function $60bb2bf72aea2e9a$var$makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $60bb2bf72aea2e9a$var$CacheGroup(resultCaching)) || this;
            _this.storageTrie = new (0, $9355c1f69d79ae9b$export$73571c50d0f2507e)((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9));
            _this.sharedLayerGroup = new $60bb2bf72aea2e9a$var$CacheGroup(resultCaching);
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return new $60bb2bf72aea2e9a$var$Layer(layerId, this, replay, this.sharedLayerGroup);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($60bb2bf72aea2e9a$export$cb507f57054c7321 || ($60bb2bf72aea2e9a$export$cb507f57054c7321 = {}));
var $60bb2bf72aea2e9a$var$Layer = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                if (_this.data[dataId] !== parent.lookup(dataId)) _this.delete(dataId);
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}($60bb2bf72aea2e9a$export$cb507f57054c7321);
function $60bb2bf72aea2e9a$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $91ec8471c498125e$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $60bb2bf72aea2e9a$export$488c0743feab3d61(store) {
    return !!(store instanceof $60bb2bf72aea2e9a$export$cb507f57054c7321 && store.group.caching);
}




function $39df35e765ec6b93$var$missingFromInvariant(err, context) {
    return new (0, $255d62779a9fb347$export$257c68286583b0f9)(err.message, context.path.slice(), context.query, context.clientOnly, context.variables);
}
var $39df35e765ec6b93$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.config = config;
        this.executeSelectionSet = (0, $e3ad5e784c15e685$export$4997ffc0176396a6)(function(options) {
            return _this.execSelectionSetImpl(options);
        }, {
            keyArgs: function(options) {
                return [
                    options.selectionSet,
                    options.objectOrReference,
                    options.context
                ];
            },
            makeCacheKey: function(selectionSet, parent, context) {
                if ((0, $60bb2bf72aea2e9a$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $9745e36fc8004d84$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString);
            }
        });
        this.knownResults = new WeakMap();
        this.executeSubSelectedArray = (0, $e3ad5e784c15e685$export$4997ffc0176396a6)(function(options) {
            return _this.execSubSelectedArrayImpl(options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $60bb2bf72aea2e9a$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
        this.config = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({
            addTypename: true
        }, config);
    }
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c;
        var policies = this.config.cache.policies;
        variables = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, (0, $17ae57d9cfe56e00$export$84c19026e616569e)((0, $17ae57d9cfe56e00$export$d96b2213c1b9d3a9)(query))), variables);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $17ae57d9cfe56e00$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: (0, $9745e36fc8004d84$export$634ae0e932e9be99)(rootId),
            context: {
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0, $1081014e8b85fcce$export$193789b4c8246dd4)((0, $17ae57d9cfe56e00$export$5320a7ba9466a3df)(query)),
                path: [],
                clientOnly: false
            }
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) throw execResult.missing[0];
        return {
            result: execResult.result,
            missing: execResult.missing,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $60bb2bf72aea2e9a$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context);
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, context = _a.context;
        if ((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: {},
            missing: [
                $39df35e765ec6b93$var$missingFromInvariant(new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(4), context)
            ]
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var objectsToMerge = [];
        var finalResult = {
            result: null
        };
        var typename = store.getFieldValue(objectOrReference, "__typename");
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function getMissing() {
            return finalResult.missing || (finalResult.missing = []);
        }
        function handleMissing(result) {
            var _a;
            if (result.missing) (_a = getMissing()).push.apply(_a, result.missing);
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a;
            if (!(0, $25c4098f02b173bc$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $9745e36fc8004d84$export$7d1ad22471852218)(selection);
                context.path.push(resultName);
                var wasClientOnly = context.clientOnly;
                context.clientOnly = wasClientOnly || !!(selection.directives && selection.directives.some(function(d) {
                    return d.name.value === "client";
                }));
                if (fieldValue === void 0) {
                    if (!(0, $3068b259105be920$export$43b332f87950a467).added(selection)) getMissing().push($39df35e765ec6b93$var$missingFromInvariant(new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(5), context));
                } else if (Array.isArray(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    context: context
                }));
                else if (!selection.selectionSet) ;
                else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    context: context
                }));
                if (fieldValue !== void 0) objectsToMerge.push((_a = {}, _a[resultName] = fieldValue, _a));
                context.clientOnly = wasClientOnly;
                (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(context.path.pop() === resultName);
            } else {
                var fragment = (0, $1081014e8b85fcce$export$f80bdb85f299186)(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        finalResult.result = (0, $c772d51c17702622$export$160070228be94b08)(objectsToMerge);
        this.knownResults.set(finalResult.result, selectionSet);
        return finalResult;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, context = _a.context;
        var missing;
        function handleMissing(childResult, i) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(context.path.pop() === i);
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            context.path.push(i);
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                context: context
            }), i);
            (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(context.path.pop() === i);
            return item;
        });
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $39df35e765ec6b93$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if (value && typeof value === "object") {
                (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!(0, $9745e36fc8004d84$export$fa99cac1c0883c47)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}







var $1de5eb93349a98f9$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader) {
        this.cache = cache;
        this.reader = reader;
    }
    StoreWriter.prototype.writeToStore = function(_a) {
        var query = _a.query, result = _a.result, dataId = _a.dataId, store = _a.store, variables = _a.variables;
        var operationDefinition = (0, $17ae57d9cfe56e00$export$7a5b1fa979d2c158)(query);
        var merger = (0, $6bf51bbd8f3de767$export$b874a818f7a2fa6d)();
        variables = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, (0, $17ae57d9cfe56e00$export$84c19026e616569e)(operationDefinition)), variables);
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map
            },
            context: {
                store: store,
                written: Object.create(null),
                merge: function(existing, incoming) {
                    return merger.merge(existing, incoming);
                },
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0, $1081014e8b85fcce$export$193789b4c8246dd4)((0, $17ae57d9cfe56e00$export$5320a7ba9466a3df)(query))
            }
        });
        if (!(0, $9745e36fc8004d84$export$fa99cac1c0883c47)(ref)) throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(7);
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var _b = policies.identify(result, selectionSet, context.fragmentMap), id = _b[0], keyObject = _b[1];
        dataId = dataId || id;
        if ("string" === typeof dataId) {
            var sets = context.written[dataId] || (context.written[dataId] = []);
            var ref = (0, $9745e36fc8004d84$export$634ae0e932e9be99)(dataId);
            if (sets.indexOf(selectionSet) >= 0) return ref;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, ref, selectionSet, context)) return ref;
        }
        var incomingFields = Object.create(null);
        if (keyObject) incomingFields = context.merge(incomingFields, keyObject);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $9745e36fc8004d84$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incomingFields.__typename = typename;
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a;
            if (!(0, $25c4098f02b173bc$export$3dc388a5f013b4a5)(selection, context.variables)) return;
            if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection)) {
                var resultFieldKey = (0, $9745e36fc8004d84$export$7d1ad22471852218)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    var storeFieldName = policies.getStoreFieldName({
                        typename: typename,
                        fieldName: selection.name.value,
                        field: selection,
                        variables: context.variables
                    });
                    var childTree = $1de5eb93349a98f9$var$getChildMergeTree(mergeTree, storeFieldName);
                    var incomingValue = _this.processFieldValue(value, selection, context, childTree);
                    var childTypename = selection.selectionSet && context.store.getFieldValue(incomingValue, "__typename") || void 0;
                    var merge = policies.getMergeFunction(typename, selection.name.value, childTypename);
                    if (merge) childTree.info = {
                        field: selection,
                        typename: typename,
                        merge: merge
                    };
                    else $1de5eb93349a98f9$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                    incomingFields = context.merge(incomingFields, (_a = {}, _a[storeFieldName] = incomingValue, _a));
                } else if (policies.usingPossibleTypes && !(0, $25c4098f02b173bc$export$2dafb573e282fe8d)([
                    "defer",
                    "client"
                ], selection)) throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(8);
            } else {
                var fragment = (0, $1081014e8b85fcce$export$f80bdb85f299186)(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        if ("string" === typeof dataId) {
            var entityRef_1 = (0, $9745e36fc8004d84$export$634ae0e932e9be99)(dataId);
            if (mergeTree.map.size) incomingFields = this.applyMerges(mergeTree, entityRef_1, incomingFields, context);
            var hasSelectionSet_1, fieldsWithSelectionSets_1, hasMergeFunction_1;
            context.store.merge(dataId, incomingFields);
            return entityRef_1;
        }
        return incomingFields;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) return value;
        if (Array.isArray(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $1de5eb93349a98f9$var$getChildMergeTree(mergeTree, i));
            $1de5eb93349a98f9$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $9745e36fc8004d84$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = !Array.isArray(incoming) && ((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(existing) || (0, $6bf51bbd8f3de767$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $9745e36fc8004d84$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return Array.isArray(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                incoming = Array.isArray(i_1) ? i_1.slice(0) : (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $1de5eb93349a98f9$var$emptyMergeTreePool = [];
function $1de5eb93349a98f9$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $1de5eb93349a98f9$var$emptyMergeTreePool.pop() || {
        map: new Map
    });
    return map.get(name);
}
function $1de5eb93349a98f9$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && !childTree.info && !childTree.map.size) {
        $1de5eb93349a98f9$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $1de5eb93349a98f9$var$warnings = new Set();
function $1de5eb93349a98f9$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(existing)) return;
    if ((0, $91ec8471c498125e$export$411ce8e5a71e3069)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
    var typeDotName = parentType + "." + fieldName;
    if ($1de5eb93349a98f9$var$warnings.has(typeDotName)) return;
    $1de5eb93349a98f9$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!Array.isArray(existing) && !Array.isArray(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
}





var $56d38d3c94ac9676$export$ac9723609f5c76c2 = new (0, $befa4e6383d64e40$export$8c6ed5c666ac1360)();
function $56d38d3c94ac9676$var$consumeAndIterate(set, callback) {
    if (set.size) {
        var items_1 = [];
        set.forEach(function(item) {
            return items_1.push(item);
        });
        set.clear();
        items_1.forEach(callback);
    }
}
var $56d38d3c94ac9676$var$cacheInfoMap = new WeakMap();
function $56d38d3c94ac9676$var$getCacheInfo(cache) {
    var info = $56d38d3c94ac9676$var$cacheInfoMap.get(cache);
    if (!info) $56d38d3c94ac9676$var$cacheInfoMap.set(cache, info = {
        vars: new Set,
        dep: (0, $e3ad5e784c15e685$export$c723b7eff9d8f870)()
    });
    return info;
}
function $56d38d3c94ac9676$export$cbe12faed7725318(cache) {
    $56d38d3c94ac9676$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $56d38d3c94ac9676$export$f342bdd61b3e9412(cache) {
    $56d38d3c94ac9676$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $56d38d3c94ac9676$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $56d38d3c94ac9676$var$getCacheInfo(cache).dep.dirty(rv);
                    $56d38d3c94ac9676$var$broadcast(cache);
                });
                $56d38d3c94ac9676$var$consumeAndIterate(listeners, function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $56d38d3c94ac9676$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $56d38d3c94ac9676$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $56d38d3c94ac9676$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $56d38d3c94ac9676$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}








function $1fd178653ef2ea76$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $9745e36fc8004d84$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $1fd178653ef2ea76$export$bd03c5a9c99d6bce = function(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = id !== void 0 ? {
            id: id
        } : _id !== void 0 ? {
            _id: _id
        } : void 0;
        if (id === void 0) id = _id;
        if (id !== void 0) return __typename + ":" + (typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
};
var $1fd178653ef2ea76$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $1fd178653ef2ea76$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $1fd178653ef2ea76$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $1fd178653ef2ea76$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $1fd178653ef2ea76$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({
            dataIdFromObject: $1fd178653ef2ea76$export$bd03c5a9c99d6bce
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, selectionSet, fragmentMap) {
        var typename = selectionSet && fragmentMap ? (0, $9745e36fc8004d84$export$cf7bf7e4f289cc26)(object, selectionSet, fragmentMap) : object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var context = {
            typename: typename,
            selectionSet: selectionSet,
            fragmentMap: fragmentMap
        };
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn(object, context);
            if (Array.isArray(specifierOrId)) keyFn = $1fd178653ef2ea76$var$keyFieldsFnFromSpecifier(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id && String(id);
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $1c0ef74047f3db21$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $1fd178653ef2ea76$var$mergeTrueFn : merge === false ? $1fd178653ef2ea76$var$mergeFalseFn : existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn = keyFields === false ? $1fd178653ef2ea76$var$nullKeyFieldsFn : Array.isArray(keyFields) ? $1fd178653ef2ea76$var$keyFieldsFnFromSpecifier(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = keyArgs === false ? $1fd178653ef2ea76$var$simpleKeyArgsFn : Array.isArray(keyArgs) ? $1fd178653ef2ea76$var$keyArgsFnFromSpecifier(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $1fd178653ef2ea76$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!old || old === which, 1);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $6bf51bbd8f3de767$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) supertypes.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $1c0ef74047f3db21$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) this.updateTypePolicy(typename, (0, $7f27dcb76d655f12$export$8e16b83750b44988).apply(void 0, inbox.splice(0)));
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        checkingFuzzySubtypes;
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $6bf51bbd8f3de767$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $1fd178653ef2ea76$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if (Array.isArray(specifierOrString)) keyFn = $1fd178653ef2ea76$var$keyArgsFnFromSpecifier(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $9745e36fc8004d84$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $9745e36fc8004d84$export$3cdb6c178b88cabe)(fieldName, $1fd178653ef2ea76$var$argsFromFieldSpecifier(fieldSpec));
        return fieldName === (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $1fd178653ef2ea76$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $9745e36fc8004d84$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $56d38d3c94ac9676$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $1fd178653ef2ea76$var$mergeTrueFn) return $1fd178653ef2ea76$var$makeMergeObjectsFunction(context.store.getFieldValue)(existing, incoming);
        if (merge === $1fd178653ef2ea76$var$mergeFalseFn) return incoming;
        return merge(existing, incoming, $1fd178653ef2ea76$var$makeFieldFunctionOptions(this, void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $1fd178653ef2ea76$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $6bf51bbd8f3de767$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, getFieldValue = _a.getFieldValue, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $1fd178653ef2ea76$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $9745e36fc8004d84$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function(fieldNameOrOptions, from) {
            var options = typeof fieldNameOrOptions === "string" ? {
                fieldName: fieldNameOrOptions,
                from: from
            } : (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, fieldNameOrOptions);
            if (void 0 === options.from) options.from = objectOrReference;
            if (void 0 === options.variables) options.variables = variables;
            return policies.readField(options, context);
        },
        mergeObjects: $1fd178653ef2ea76$var$makeMergeObjectsFunction(getFieldValue)
    };
}
function $1fd178653ef2ea76$var$makeMergeObjectsFunction(getFieldValue) {
    return function mergeObjects(existing, incoming) {
        if (Array.isArray(existing) || Array.isArray(incoming)) throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(2);
        if (existing && typeof existing === "object" && incoming && typeof incoming === "object") {
            var eType = getFieldValue(existing, "__typename");
            var iType = getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer || !(0, $6bf51bbd8f3de767$export$4f39afca21bd938e)(existing) || !(0, $6bf51bbd8f3de767$export$4f39afca21bd938e)(incoming)) return incoming;
            return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}
function $1fd178653ef2ea76$var$keyArgsFnFromSpecifier(specifier) {
    return function(args, context) {
        return args ? context.fieldName + ":" + JSON.stringify($1fd178653ef2ea76$var$computeKeyObject(args, specifier, false)) : context.fieldName;
    };
}
function $1fd178653ef2ea76$var$keyFieldsFnFromSpecifier(specifier) {
    var trie = new (0, $9355c1f69d79ae9b$export$73571c50d0f2507e)((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9));
    return function(object, context) {
        var aliasMap;
        if (context.selectionSet && context.fragmentMap) {
            var info = trie.lookupArray([
                context.selectionSet,
                context.fragmentMap
            ]);
            aliasMap = info.aliasMap || (info.aliasMap = $1fd178653ef2ea76$var$makeAliasMap(context.selectionSet, context.fragmentMap));
        }
        var keyObject = context.keyObject = $1fd178653ef2ea76$var$computeKeyObject(object, specifier, true, aliasMap);
        return context.typename + ":" + JSON.stringify(keyObject);
    };
}
function $1fd178653ef2ea76$var$makeAliasMap(selectionSet, fragmentMap) {
    var map = Object.create(null);
    var workQueue = new Set([
        selectionSet
    ]);
    workQueue.forEach(function(selectionSet) {
        selectionSet.selections.forEach(function(selection) {
            if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection)) {
                if (selection.alias) {
                    var responseKey = selection.alias.value;
                    var storeKey = selection.name.value;
                    if (storeKey !== responseKey) {
                        var aliases = map.aliases || (map.aliases = Object.create(null));
                        aliases[storeKey] = responseKey;
                    }
                }
                if (selection.selectionSet) {
                    var subsets = map.subsets || (map.subsets = Object.create(null));
                    subsets[selection.name.value] = $1fd178653ef2ea76$var$makeAliasMap(selection.selectionSet, fragmentMap);
                }
            } else {
                var fragment = (0, $1081014e8b85fcce$export$f80bdb85f299186)(selection, fragmentMap);
                if (fragment) workQueue.add(fragment.selectionSet);
            }
        });
    });
    return map;
}
function $1fd178653ef2ea76$var$computeKeyObject(response, specifier, strict, aliasMap) {
    var keyObj = Object.create(null);
    var prevKey;
    specifier.forEach(function(s) {
        if (Array.isArray(s)) {
            if (typeof prevKey === "string") {
                var subsets = aliasMap && aliasMap.subsets;
                var subset = subsets && subsets[prevKey];
                keyObj[prevKey] = $1fd178653ef2ea76$var$computeKeyObject(response[prevKey], s, strict, subset);
            }
        } else {
            var aliases = aliasMap && aliasMap.aliases;
            var responseName = aliases && aliases[s] || s;
            if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(response, responseName)) keyObj[prevKey = s] = response[responseName];
            else {
                (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!strict, 3);
                prevKey = void 0;
            }
        }
    });
    return keyObj;
}



var $293471a6ca1d60d0$var$defaultConfig = {
    dataIdFromObject: (0, $1fd178653ef2ea76$export$bd03c5a9c99d6bce),
    addTypename: true,
    resultCaching: true,
    typePolicies: {}
};
var $293471a6ca1d60d0$export$467265324939f47f = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = (0, $56d38d3c94ac9676$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.maybeBroadcastWatch = (0, $e3ad5e784c15e685$export$4997ffc0176396a6)(function(c, fromOptimisticTransaction) {
            return _this.broadcastWatch.call(_this, c, !!fromOptimisticTransaction);
        }, {
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $60bb2bf72aea2e9a$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, rootId = c.rootId, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, JSON.stringify({
                        optimistic: optimistic,
                        rootId: rootId,
                        variables: variables
                    }));
                }
            }
        });
        _this.watchDep = (0, $e3ad5e784c15e685$export$c723b7eff9d8f870)();
        _this.config = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, $293471a6ca1d60d0$var$defaultConfig), config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $1fd178653ef2ea76$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.data = new (0, $60bb2bf72aea2e9a$export$cb507f57054c7321).Root({
            policies: _this.policies,
            resultCaching: _this.config.resultCaching
        });
        _this.optimisticData = _this.data;
        _this.storeWriter = new (0, $1de5eb93349a98f9$export$eb8361c5d132fb8f)(_this, _this.storeReader = new (0, $39df35e765ec6b93$export$628ef07ba8965f12)({
            cache: _this,
            addTypename: _this.addTypename
        }));
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: options.query,
                variables: options.variables,
                rootId: options.rootId,
                config: this.config,
                returnPartialData: returnPartialData
            }).result || null;
        } catch (e) {
            if (e instanceof (0, $255d62779a9fb347$export$257c68286583b0f9)) return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore({
                store: this.data,
                query: options.query,
                result: options.result,
                dataId: options.dataId,
                variables: options.variables
            });
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore({
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            query: options.query,
            variables: options.variables,
            returnPartialData: options.returnPartialData,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) (0, $56d38d3c94ac9676$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $56d38d3c94ac9676$export$cbe12faed7725318)(_this);
            _this.watchDep.dirty(watch);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function() {
        return this.optimisticData.gc();
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        return (0, $9745e36fc8004d84$export$fa99cac1c0883c47)(object) ? object.__ref : this.policies.identify(object)[0];
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $6bf51bbd8f3de767$export$b5a638e9b3fff9f3).call(options, "id")) return false;
            options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.optimisticData = this.data;
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _this = this;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                transaction(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var fromOptimisticTransaction = false;
        if (typeof optimisticId === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimisticId, perform);
            fromOptimisticTransaction = true;
        } else if (optimisticId === null) perform(this.data);
        else perform();
        this.broadcastWatches(fromOptimisticTransaction);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $3068b259105be920$export$43b332f87950a467)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function(fromOptimisticTransaction) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, fromOptimisticTransaction);
        });
    };
    InMemoryCache.prototype.broadcastWatch = function(c, fromOptimisticTransaction) {
        this.watchDep.dirty(c);
        this.watchDep(c);
        var diff = this.diff({
            query: c.query,
            variables: c.variables,
            optimistic: c.optimistic
        });
        if (c.optimistic && fromOptimisticTransaction) diff.fromOptimisticTransaction = true;
        c.callback(diff);
    };
    return InMemoryCache;
}((0, $966cab6a0dd47606$export$5fc74f25506aa9c));




var $ffa3693d5b913579$exports = {};




var $969a20c86bab0cc9$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $c772d51c17702622$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $c772d51c17702622$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $25c4098f02b173bc$export$2dafb573e282fe8d)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $3068b259105be920$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $0f36c934b7f2a151$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $3068b259105be920$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $17ae57d9cfe56e00$export$f431198736b7f96d)(document);
                fragments = (0, $17ae57d9cfe56e00$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $1081014e8b85fcce$export$193789b4c8246dd4)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!(0, $25c4098f02b173bc$export$3dc388a5f013b4a5)(selection, variables)) return [
                                2
                            ];
                            if ((0, $9745e36fc8004d84$export$fb56ad75dd311c12)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $9745e36fc8004d84$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $9745e36fc8004d84$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(fragment, 11);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $c772d51c17702622$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $9745e36fc8004d84$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $56d38d3c94ac9676$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $9745e36fc8004d84$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();





var $ac170c81a3185268$var$destructiveMethodCounts = new ((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $ac170c81a3185268$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $ac170c81a3185268$var$destructiveMethodCounts.set(cache, ($ac170c81a3185268$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $ac170c81a3185268$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $ac170c81a3185268$export$79a6120a39c90b6a = function() {
    function QueryInfo(cache) {
        this.cache = cache;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.diff = null;
        this.observableQuery = null;
        if (!$ac170c81a3185268$var$destructiveMethodCounts.has(cache)) {
            $ac170c81a3185268$var$destructiveMethodCounts.set(cache, 0);
            $ac170c81a3185268$var$wrapDestructiveCacheMethod(cache, "evict");
            $ac170c81a3185268$var$wrapDestructiveCacheMethod(cache, "modify");
            $ac170c81a3185268$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $63485496121d66f5$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $63485496121d66f5$export$bd096ddbd246c79c).loading && !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).setVariables;
        if (!(0, $91ec8471c498125e$export$411ce8e5a71e3069)(query.variables, this.variables)) this.diff = null;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $ac170c81a3185268$var$cancelNotifyTimeout(this);
        this.diff = null;
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        if (this.diff && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(variables, this.variables)) return this.diff;
        this.updateWatch(this.variables = variables);
        return this.diff = this.cache.diff({
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true
        });
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.diff;
        this.diff = diff;
        if (!this.dirty && (diff && diff.result) !== (oldDiff && oldDiff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                if (_this.getDiff().fromOptimisticTransaction) oq["observe"]();
                else oq.reobserve();
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $ac170c81a3185268$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $63485496121d66f5$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.cancel();
            delete this.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        if (!this.lastWatch || this.lastWatch.query !== this.document || !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(variables, this.lastWatch.variables)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = {
                query: this.document,
                variables: variables,
                optimistic: true,
                callback: function(diff) {
                    return _this.setDiff(diff);
                }
            });
        }
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $ac170c81a3185268$var$destructiveMethodCounts.get(this.cache) && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, options, allowCacheWrite) {
        var _this = this;
        this.graphQLErrors = (0, $4601cc972277e257$export$d307f5934e447d0e)(result.errors) ? result.errors : [];
        this.reset();
        if (options.fetchPolicy === 'no-cache') this.diff = {
            result: result.data,
            complete: true
        };
        else if (!this.stopped && allowCacheWrite) {
            if ($ac170c81a3185268$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: _this.document,
                        data: result.data,
                        variables: options.variables
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $ac170c81a3185268$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.diff && _this.diff.complete) {
                    result.data = _this.diff.result;
                    return;
                }
                var diff = cache.diff({
                    query: _this.document,
                    variables: options.variables,
                    returnPartialData: true,
                    optimistic: true
                });
                if (!_this.stopped) _this.updateWatch(options.variables);
                _this.diff = diff;
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $ac170c81a3185268$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $902c27612e1be103$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}


var $1877c32c6cf21a66$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1877c32c6cf21a66$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $969a20c86bab0cc9$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(12));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $1c0ef74047f3db21$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mutationId, mutationStoreValue, self;
            return (0, $1c0ef74047f3db21$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(mutation, 13);
                        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!fetchPolicy || fetchPolicy === 'no-cache', 14);
                        mutationId = this.generateMutationId();
                        mutation = this.transform(mutation).document;
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            errorPolicy: errorPolicy,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $902c27612e1be103$export$b4df399e879e53ab)(result) && errorPolicy === 'none') {
                                            error = new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = null;
                                        }
                                        if (fetchPolicy !== 'no-cache') try {
                                            self.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                errorPolicy: errorPolicy,
                                                updateQueries: updateQueries,
                                                update: updateWithProxyFn
                                            });
                                        } catch (e) {
                                            error = new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                                                networkError: e
                                            });
                                            return;
                                        }
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error && mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = error;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ((0, $4601cc972277e257$export$d307f5934e447d0e)(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            if (errorPolicy === 'ignore' && storeResult && (0, $902c27612e1be103$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        }, reject);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        if ((0, $ac170c81a3185268$export$5f47a9fb9a521654)(mutation.result, mutation.errorPolicy)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$1877c32c6cf21a66$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: mutation.result,
                        queryName: document && (0, $17ae57d9cfe56e00$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: document,
                        variables: variables
                    });
                }
            });
            cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) update(c, mutation.result);
            }, null);
        }
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {}
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var forLink = (0, $3068b259105be920$export$74985f3324559867)(this.cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = forLink && this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $25c4098f02b173bc$export$8d1e9e5bbfa5d09a)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $17ae57d9cfe56e00$export$84c19026e616569e)((0, $17ae57d9cfe56e00$export$7a5b1fa979d2c158)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(options.query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $ac170c81a3185268$export$79a6120a39c90b6a)(this.cache);
        var observable = new (0, $b29d538cad2b5757$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: options.query,
            observableQuery: observable,
            variables: options.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(options.query, 15);
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(options.query.kind === 'Document', 16);
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!options.returnPartialData, 17);
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!options.pollInterval, 18);
        var queryId = this.generateQueryId();
        return this.fetchQuery(queryId, options).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function() {
        this.cancelPendingFetches(new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(19));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery && observableQuery.hasObservers()) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.getQuery(queryId).setDiff(null);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, false).map(function(result) {
                if (fetchPolicy !== 'no-cache') {
                    if ((0, $ac170c81a3185268$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: 'ROOT_SUBSCRIPTION',
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                if ((0, $902c27612e1be103$export$b4df399e879e53ab)(result)) throw new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        this.getQuery(queryId).stop();
        this.queries.delete(queryId);
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $17ae57d9cfe56e00$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $0bedadf61bd47463$export$ae0cf2ec7a6fa78e)([
                        (0, $e94d84574ec6fa6b$export$51396ec711da548b)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.cleanup(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(serverQuery);
                    });
                }
            } else observable = new (0, $0bedadf61bd47463$export$ae0cf2ec7a6fa78e)([
                (0, $e94d84574ec6fa6b$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $0bedadf61bd47463$export$ae0cf2ec7a6fa78e)([
                (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = (0, $9dd27e0de5b47bdd$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, allowCacheWrite, options) {
        var lastRequestId = queryInfo.lastRequestId;
        return (0, $9dd27e0de5b47bdd$export$707ee4c4c95d39e3)(this.getObservableFromLink(queryInfo.document, options.context, options.variables), function(result) {
            var hasErrors = (0, $4601cc972277e257$export$d307f5934e447d0e)(result.errors);
            if (lastRequestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                    graphQLErrors: result.errors
                }));
                queryInfo.markResult(result, options, allowCacheWrite);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: queryInfo.networkStatus || (0, $63485496121d66f5$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") aqr.errors = result.errors;
            return aqr;
        }, function(networkError) {
            var error = (0, $de39ce370f7cbdab$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                networkError: networkError
            });
            if (lastRequestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $63485496121d66f5$export$bd096ddbd246c79c).loading;
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var oldNetworkStatus = queryInfo.networkStatus;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var mightUseNetwork = fetchPolicy === "cache-first" || fetchPolicy === "cache-and-network" || fetchPolicy === "network-only" || fetchPolicy === "no-cache";
        if (mightUseNetwork && notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $63485496121d66f5$export$37509604341a3464)(networkStatus)) {
            if (fetchPolicy !== "cache-first") fetchPolicy = "cache-and-network";
            returnPartialData = true;
        }
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            return _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            Promise.resolve().then(function() {
                return concast.cancel(reason);
            });
        });
        var concast = new (0, $0bedadf61bd47463$export$ae0cf2ec7a6fa78e)(this.transform(normalized.query).hasClientExports ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables) : fromVariables(normalized.variables));
        concast.cleanup(function() {
            _this.fetchCancelFns.delete(queryId);
            var nextFetchPolicy = options.nextFetchPolicy;
            if (nextFetchPolicy) {
                options.nextFetchPolicy = void 0;
                options.fetchPolicy = typeof nextFetchPolicy === "function" ? nextFetchPolicy.call(options, options.fetchPolicy || "cache-first") : nextFetchPolicy;
            }
        });
        return concast;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, options, networkStatus) {
        var _this = this;
        var query = options.query, variables = options.variables, fetchPolicy = options.fetchPolicy, errorPolicy = options.errorPolicy, returnPartialData = options.returnPartialData, context = options.context;
        queryInfo.init({
            document: query,
            variables: variables,
            lastRequestId: this.generateRequestId(),
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $63485496121d66f5$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            var fromData = function(data) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports))).of((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $63485496121d66f5$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (_this.transform(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data);
            });
            return fromData(data);
        };
        var resultsFromLink = function(allowCacheWrite) {
            return _this.getResultsFromLink(queryInfo, allowCacheWrite, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return [
                    resultsFromCache(diff, queryInfo.markReady())
                ];
                if (returnPartialData) return [
                    resultsFromCache(diff),
                    resultsFromLink(true)
                ];
                return [
                    resultsFromLink(true)
                ];
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData) return [
                    resultsFromCache(diff),
                    resultsFromLink(true)
                ];
                return [
                    resultsFromLink(true)
                ];
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady())
                ];
            case "network-only":
                return [
                    resultsFromLink(true)
                ];
            case "no-cache":
                return [
                    resultsFromLink(false)
                ];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $ac170c81a3185268$export$79a6120a39c90b6a)(this.cache));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();



var $eab636ebc55e3402$var$hasSuggestedDevtools = false;
function $eab636ebc55e3402$export$235b7fc70b9fc359(defaults, options) {
    return (0, $7f27dcb76d655f12$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, defaults.variables), options.variables)
    });
}
var $eab636ebc55e3402$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' && !window.__APOLLO_CLIENT__ && false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $a073b62f9ab58469$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).empty();
        if (!cache) throw new (0, $cd76a4c66ed97e84$export$cea12affaee22fe8)(9);
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') window.__APOLLO_CLIENT__ = this;
        $eab636ebc55e3402$var$hasSuggestedDevtools;
        var nav, ua, url;
        this.version = (0, $af4f22a2f9229942$export$83d89fbfd8236492);
        this.localState = new (0, $969a20c86bab0cc9$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $1877c32c6cf21a66$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = $eab636ebc55e3402$export$235b7fc70b9fc359(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = $eab636ebc55e3402$export$235b7fc70b9fc359(this.defaultOptions.query, options);
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = $eab636ebc55e3402$export$235b7fc70b9fc359(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function(options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $e94d84574ec6fa6b$export$51396ec711da548b)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();




var $ce8d3bc4374c232b$exports = {};











function $e5830da5aeefc3eb$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}


function $7f2a1398ef2703c8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7f2a1398ef2703c8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7f2a1398ef2703c8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7f2a1398ef2703c8$var$_typeof(obj);
}
function $7f2a1398ef2703c8$export$2e2bcd8739ae039(value) {
    return $7f2a1398ef2703c8$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $efc3fcc1d664d90f$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $efc3fcc1d664d90f$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $efc3fcc1d664d90f$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $f53cc60450cdece9$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $e77cda6e9df54a26$export$96a9681e539deed(location) {
    return $e77cda6e9df54a26$export$867940333fd9f869(location.source, (0, $f53cc60450cdece9$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $e77cda6e9df54a26$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $e77cda6e9df54a26$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $e77cda6e9df54a26$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $e77cda6e9df54a26$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $e77cda6e9df54a26$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $e77cda6e9df54a26$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $e77cda6e9df54a26$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $e77cda6e9df54a26$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $e77cda6e9df54a26$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $e77cda6e9df54a26$var$leftPad(len, str) {
    return $e77cda6e9df54a26$var$whitespace(len - str.length) + str;
}


function $7dea8c85bfa2f509$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7dea8c85bfa2f509$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7dea8c85bfa2f509$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7dea8c85bfa2f509$var$_typeof(obj);
}
function $7dea8c85bfa2f509$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7dea8c85bfa2f509$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7dea8c85bfa2f509$var$ownKeys(Object(source), true).forEach(function(key) {
            $7dea8c85bfa2f509$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7dea8c85bfa2f509$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7dea8c85bfa2f509$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7dea8c85bfa2f509$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7dea8c85bfa2f509$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7dea8c85bfa2f509$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7dea8c85bfa2f509$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7dea8c85bfa2f509$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7dea8c85bfa2f509$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7dea8c85bfa2f509$var$_setPrototypeOf(subClass, superClass);
}
function $7dea8c85bfa2f509$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7dea8c85bfa2f509$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7dea8c85bfa2f509$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7dea8c85bfa2f509$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7dea8c85bfa2f509$var$_possibleConstructorReturn(this, result);
    };
}
function $7dea8c85bfa2f509$var$_possibleConstructorReturn(self, call) {
    if (call && ($7dea8c85bfa2f509$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7dea8c85bfa2f509$var$_assertThisInitialized(self);
}
function $7dea8c85bfa2f509$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7dea8c85bfa2f509$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7dea8c85bfa2f509$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7dea8c85bfa2f509$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7dea8c85bfa2f509$var$_construct(Class, arguments, $7dea8c85bfa2f509$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7dea8c85bfa2f509$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7dea8c85bfa2f509$var$_wrapNativeSuper(Class);
}
function $7dea8c85bfa2f509$var$_construct(Parent, args, Class) {
    if ($7dea8c85bfa2f509$var$_isNativeReflectConstruct()) $7dea8c85bfa2f509$var$_construct = Reflect.construct;
    else $7dea8c85bfa2f509$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7dea8c85bfa2f509$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7dea8c85bfa2f509$var$_construct.apply(null, arguments);
}
function $7dea8c85bfa2f509$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7dea8c85bfa2f509$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7dea8c85bfa2f509$var$_setPrototypeOf(o, p) {
    $7dea8c85bfa2f509$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7dea8c85bfa2f509$var$_setPrototypeOf(o, p);
}
function $7dea8c85bfa2f509$var$_getPrototypeOf(o) {
    $7dea8c85bfa2f509$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7dea8c85bfa2f509$var$_getPrototypeOf(o);
}
var $7dea8c85bfa2f509$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $7dea8c85bfa2f509$var$_inherits(GraphQLError, _Error);
    var _super = $7dea8c85bfa2f509$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $7dea8c85bfa2f509$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $7dea8c85bfa2f509$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $7dea8c85bfa2f509$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $f53cc60450cdece9$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $f53cc60450cdece9$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $7f2a1398ef2703c8$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $7dea8c85bfa2f509$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($7dea8c85bfa2f509$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($7dea8c85bfa2f509$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $7dea8c85bfa2f509$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($7dea8c85bfa2f509$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($7dea8c85bfa2f509$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $7dea8c85bfa2f509$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $7dea8c85bfa2f509$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $7dea8c85bfa2f509$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $efc3fcc1d664d90f$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $7dea8c85bfa2f509$var$_wrapNativeSuper(Error));
function $7dea8c85bfa2f509$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $7dea8c85bfa2f509$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $e77cda6e9df54a26$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $e77cda6e9df54a26$export$867940333fd9f869)(error.source, location);
    }
    return output;
}
function $7dea8c85bfa2f509$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $e5830da5aeefc3eb$export$2e2bcd8739ae039)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 


function $c710a84fc4183718$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $7dea8c85bfa2f509$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $343e0f81579b8ed3$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $11f0649b55f5d08a$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 






function $cb08d5a7db871144$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cb08d5a7db871144$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cb08d5a7db871144$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cb08d5a7db871144$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$cb08d5a7db871144$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $3b6481cf07489bb1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3b6481cf07489bb1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3b6481cf07489bb1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3b6481cf07489bb1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $3b6481cf07489bb1$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $e5830da5aeefc3eb$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $00e0507387858aba$export$2e2bcd8739ae039)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $e5830da5aeefc3eb$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $e5830da5aeefc3eb$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $3b6481cf07489bb1$var$_createClass(Source, [
        {
            key: (0, $efc3fcc1d664d90f$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $3b6481cf07489bb1$export$75135ee9ed6e435b(source) {
    return (0, $cb08d5a7db871144$export$2e2bcd8739ae039)(source, $3b6481cf07489bb1$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $6a01213c29fc74d0$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 






var $71433fecf35e3c1c$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $71433fecf35e3c1c$var$readToken(this, token);
        }while (token.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $71433fecf35e3c1c$export$59ac0f4da287406a(kind) {
    return kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BANG || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).DOLLAR || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).AMP || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_L || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_R || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).SPREAD || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).EQUALS || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).AT || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_L || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_R || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PIPE || kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R;
}
function $71433fecf35e3c1c$var$printCharCode(code) {
    return isNaN(code) ? (0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $71433fecf35e3c1c$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $71433fecf35e3c1c$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $71433fecf35e3c1c$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $71433fecf35e3c1c$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $71433fecf35e3c1c$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $71433fecf35e3c1c$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, pos, $71433fecf35e3c1c$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $71433fecf35e3c1c$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($71433fecf35e3c1c$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($71433fecf35e3c1c$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $71433fecf35e3c1c$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $71433fecf35e3c1c$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($71433fecf35e3c1c$var$printCharCode(code), "."));
    } else {
        position = $71433fecf35e3c1c$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $71433fecf35e3c1c$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $71433fecf35e3c1c$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $71433fecf35e3c1c$var$isNameStart(code)) throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($71433fecf35e3c1c$var$printCharCode(code), "."));
    return new (0, $d123b4e875f670f4$export$50792b0e93539fde)(isFloat ? (0, $11f0649b55f5d08a$export$8b9d26ab11394711).FLOAT : (0, $11f0649b55f5d08a$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $71433fecf35e3c1c$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($71433fecf35e3c1c$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $71433fecf35e3c1c$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($71433fecf35e3c1c$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $71433fecf35e3c1c$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $71433fecf35e3c1c$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $115290dc99333c54$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($71433fecf35e3c1c$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $71433fecf35e3c1c$var$uniCharCode(a, b, c, d) {
    return $71433fecf35e3c1c$var$char2hex(a) << 12 | $71433fecf35e3c1c$var$char2hex(b) << 8 | $71433fecf35e3c1c$var$char2hex(c) << 4 | $71433fecf35e3c1c$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $71433fecf35e3c1c$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $71433fecf35e3c1c$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $d123b4e875f670f4$export$50792b0e93539fde)((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $71433fecf35e3c1c$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $a2e22671d828ed33$export$98e6a39c04603d36(source, options) {
    var parser = new $a2e22671d828ed33$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $a2e22671d828ed33$export$5303528d1070ff6f(source, options) {
    var parser = new $a2e22671d828ed33$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF);
    return value;
}
function $a2e22671d828ed33$export$28b8f402ccc88182(source, options) {
    var parser = new $a2e22671d828ed33$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF);
    return type;
}
var $a2e22671d828ed33$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $3b6481cf07489bb1$export$75135ee9ed6e435b)(source) ? source : new (0, $3b6481cf07489bb1$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $71433fecf35e3c1c$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_L, item, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).STRING:
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $11f0649b55f5d08a$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).LIST,
            values: this.any((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_L, item, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, item, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).STRING) || this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AMP) || this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $11f0649b55f5d08a$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $11f0649b55f5d08a$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $11f0649b55f5d08a$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $6a01213c29fc74d0$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $d123b4e875f670f4$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($a2e22671d828ed33$var$getTokenKindDesc(kind), ", found ").concat($a2e22671d828ed33$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $c710a84fc4183718$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($a2e22671d828ed33$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $11f0649b55f5d08a$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $c710a84fc4183718$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($a2e22671d828ed33$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $a2e22671d828ed33$var$getTokenDesc(token) {
    var value = token.value;
    return $a2e22671d828ed33$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $a2e22671d828ed33$var$getTokenKindDesc(kind) {
    return (0, $71433fecf35e3c1c$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $4530924e0b1e6e3c$var$docCache = new Map();
var $4530924e0b1e6e3c$var$fragmentSourceMap = new Map();
var $4530924e0b1e6e3c$var$printFragmentWarnings = true;
var $4530924e0b1e6e3c$var$experimentalFragmentVariables = false;
function $4530924e0b1e6e3c$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $4530924e0b1e6e3c$var$cacheKeyFromLoc(loc) {
    return $4530924e0b1e6e3c$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $4530924e0b1e6e3c$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $4530924e0b1e6e3c$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $4530924e0b1e6e3c$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($4530924e0b1e6e3c$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $4530924e0b1e6e3c$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $4530924e0b1e6e3c$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $4530924e0b1e6e3c$var$parseDocument(source) {
    var cacheKey = $4530924e0b1e6e3c$var$normalize(source);
    if (!$4530924e0b1e6e3c$var$docCache.has(cacheKey)) {
        var parsed = (0, $a2e22671d828ed33$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $4530924e0b1e6e3c$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $4530924e0b1e6e3c$var$experimentalFragmentVariables,
            experimentalFragmentArguments: $4530924e0b1e6e3c$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $4530924e0b1e6e3c$var$docCache.set(cacheKey, $4530924e0b1e6e3c$var$stripLoc($4530924e0b1e6e3c$var$processFragments(parsed)));
    }
    return $4530924e0b1e6e3c$var$docCache.get(cacheKey);
}
function $4530924e0b1e6e3c$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $4530924e0b1e6e3c$var$parseDocument(result);
}
function $4530924e0b1e6e3c$export$657554ef4dc7ac2d() {
    $4530924e0b1e6e3c$var$docCache.clear();
    $4530924e0b1e6e3c$var$fragmentSourceMap.clear();
}
function $4530924e0b1e6e3c$export$e4294e638636c6ab() {
    $4530924e0b1e6e3c$var$printFragmentWarnings = false;
}
function $4530924e0b1e6e3c$export$78cf889af350c840() {
    $4530924e0b1e6e3c$var$experimentalFragmentVariables = true;
}
function $4530924e0b1e6e3c$export$5290df9bbbd3cfa() {
    $4530924e0b1e6e3c$var$experimentalFragmentVariables = false;
}
var $4530924e0b1e6e3c$var$extras = {
    gql: $4530924e0b1e6e3c$export$72e4926bf8358653,
    resetCaches: $4530924e0b1e6e3c$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $4530924e0b1e6e3c$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $4530924e0b1e6e3c$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $4530924e0b1e6e3c$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $4530924e0b1e6e3c$var$extras.gql, gql_1.resetCaches = $4530924e0b1e6e3c$var$extras.resetCaches, gql_1.disableFragmentWarnings = $4530924e0b1e6e3c$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $4530924e0b1e6e3c$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $4530924e0b1e6e3c$var$extras.disableExperimentalFragmentVariables;
})($4530924e0b1e6e3c$export$72e4926bf8358653 || ($4530924e0b1e6e3c$export$72e4926bf8358653 = {}));
$4530924e0b1e6e3c$export$72e4926bf8358653["default"] = $4530924e0b1e6e3c$export$72e4926bf8358653;
var $4530924e0b1e6e3c$export$2e2bcd8739ae039 = $4530924e0b1e6e3c$export$72e4926bf8358653;


(0, $cd76a4c66ed97e84$export$a80e09f2cd325fb8)("log");
var $2151e708169cc25c$export$657554ef4dc7ac2d = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039).resetCaches, $2151e708169cc25c$export$e4294e638636c6ab = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039).disableFragmentWarnings, $2151e708169cc25c$export$78cf889af350c840 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039).enableExperimentalFragmentVariables, $2151e708169cc25c$export$5290df9bbbd3cfa = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039).disableExperimentalFragmentVariables;
$parcel$exportWildcard($2151e708169cc25c$exports, $ce8d3bc4374c232b$exports);
$parcel$exportWildcard($2151e708169cc25c$exports, $ffa3693d5b913579$exports);


var $54335b8b21116335$exports = {};
$parcel$export($54335b8b21116335$exports, "useLazyQuery", function () { return $879159a57326e8fe$export$fd83eea6ecd2d8fa; });
$parcel$export($54335b8b21116335$exports, "useMutation", function () { return $9c9f7b47eb4524c9$export$609860bf8b0084c; });
$parcel$export($54335b8b21116335$exports, "useQuery", function () { return $367246b9cce32bfd$export$dd0a697e1782aedd; });

$parcel$export($54335b8b21116335$exports, "ApolloProvider", function () { return $0abd703f2109c9e4$export$c16b04c8a9956446; });

var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $b207a9cf96c16e3c$var$cache = new ((0, $69ceb149a16d20bc$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $b207a9cf96c16e3c$export$a47505d961ee3a1() {
    var context = $b207a9cf96c16e3c$var$cache.get((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createContext);
    if (!context) {
        context = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createContext({});
        context.displayName = 'ApolloContext';
        $b207a9cf96c16e3c$var$cache.set((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createContext, context);
    }
    return context;
}


var $ed170e2041667a63$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = (0, $b207a9cf96c16e3c$export$a47505d961ee3a1)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(context && context.client, 27);
        return props.children(context.client);
    });
};




var $denZA = parcelRequire("denZA");


var $0abd703f2109c9e4$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $b207a9cf96c16e3c$export$a47505d961ee3a1)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(context.client, 28);
        return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};





var $denZA = parcelRequire("denZA");


function $cd9eac9315f5ec3e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useContext((0, $b207a9cf96c16e3c$export$a47505d961ee3a1)()).client;
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(client, 33);
    return client;
}




var $denZA = parcelRequire("denZA");





var $79a5ce8e37e46d92$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($79a5ce8e37e46d92$export$d1d99cf900472499 || ($79a5ce8e37e46d92$export$d1d99cf900472499 = {}));
var $79a5ce8e37e46d92$var$cache = new Map();
function $79a5ce8e37e46d92$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $79a5ce8e37e46d92$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $79a5ce8e37e46d92$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $79a5ce8e37e46d92$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $79a5ce8e37e46d92$export$8f49e4af10703ce3(document) {
    var cached = $79a5ce8e37e46d92$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!!document && !!document.kind, 34);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 35);
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 36);
    type = queries.length ? $79a5ce8e37e46d92$export$d1d99cf900472499.Query : $79a5ce8e37e46d92$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $79a5ce8e37e46d92$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(definitions.length === 1, 37);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $79a5ce8e37e46d92$var$cache.set(document, payload);
    return payload;
}


var $fab7d16573cba2e2$export$43795b6fdc114bf6 = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(!!client, 29);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $79a5ce8e37e46d92$export$8f49e4af10703ce3)(document);
        var requiredOperationName = (0, $79a5ce8e37e46d92$export$5db520940cf00715)(type);
        var usedOperationName = (0, $79a5ce8e37e46d92$export$5db520940cf00715)(operation.type);
        (0, $cd76a4c66ed97e84$export$f5708dca728d7177)(operation.type === type, 30);
    };
    return OperationData;
}();


var $6306bcc7bf46bc6f$export$ae4ab90ed0fb78ce = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}((0, $fab7d16573cba2e2$export$43795b6fdc114bf6));









var $5815b691b769fff6$export$1197ada6fead761a = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $79a5ce8e37e46d92$export$d1d99cf900472499).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $79a5ce8e37e46d92$export$d1d99cf900472499).Mutation);
        return [
            this.runMutation,
            (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, result), {
                client: this.refreshClient().client
            })
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(options) {
        return this.refreshClient().client.mutate((0, $eab636ebc55e3402$export$235b7fc70b9fc359)(this.getOptions(), options));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}((0, $fab7d16573cba2e2$export$43795b6fdc114bf6));








var $250217e3d94b536b$export$baa8865f9b235420 = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.runLazy = false;
        _this.previous = Object.create(null);
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getQueryResult = function() {
            var result = _this.observableQueryFields();
            var options = _this.getOptions();
            if (options.skip) result = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                networkStatus: (0, $63485496121d66f5$export$bd096ddbd246c79c).ready,
                called: true
            });
            else if (_this.currentObservable) {
                var currentResult = _this.currentObservable.getCurrentResult();
                var data = currentResult.data, loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) error = new (0, $de39ce370f7cbdab$export$26a337512320b8c6)({
                    graphQLErrors: errors
                });
                result = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, result), {
                    data: data,
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) ;
                else if (error) Object.assign(result, {
                    data: (_this.currentObservable.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = _this.currentObservable.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && partial && (!data || Object.keys(data).length === 0) && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, $63485496121d66f5$export$bd096ddbd246c79c).loading
                        });
                        result.refetch();
                        return result;
                    }
                }
            }
            result.client = _this.client;
            _this.setOptions(options, true);
            var previousResult = _this.previous.result;
            _this.previous.loading = previousResult && previousResult.loading || false;
            result.previousData = previousResult && (previousResult.data || previousResult.previousData);
            _this.previous.result = result;
            _this.currentObservable && _this.currentObservable.resetQueryStoreErrors();
            return result;
        };
        _this.obsRefetch = function(variables) {
            var _a;
            return (_a = _this.currentObservable) === null || _a === void 0 ? void 0 : _a.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 || _a.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 || _a.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previous.query) {
            this.removeQuerySubscription();
            this.removeObservable(!skip);
            this.previous.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $63485496121d66f5$export$bd096ddbd246c79c).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var _this = this;
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        return new Promise(function(resolve) {
            return _this.startQuerySubscription(resolve);
        });
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        this.removeObservable(true);
        delete this.previous.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteResult = function() {
        var result = this.getQueryResult();
        this.startQuerySubscription();
        return result;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var _a = this.getOptions(), ssr = _a.ssr, skip = _a.skip;
        var ssrDisabled = ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)({
            loading: true,
            networkStatus: (0, $63485496121d66f5$export$bd096ddbd246c79c).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previous.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) {
            if (skip) result = this.getQueryResult();
            else result = this.context.renderPromises.addQueryPromise(this, this.getQueryResult) || ssrLoading;
        }
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $79a5ce8e37e46d92$export$d1d99cf900472499).Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
            displayName: displayName,
            context: options.context
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.ssrInitiated()) this.currentObservable = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previous.observableQueryOptions = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable = this.refreshClient().client.watchQuery((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, observableQueryOptions));
            if (this.ssrInitiated()) this.context.renderPromises.registerSSRObservable(this.currentObservable, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable) {
            this.initializeObservableQuery();
            return;
        }
        if (this.getOptions().skip) return;
        var newObservableQueryOptions = (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $91ec8471c498125e$export$411ce8e5a71e3069)(newObservableQueryOptions, this.previous.observableQueryOptions)) {
            this.previous.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function(onNewData) {
        var _this = this;
        if (onNewData === void 0) onNewData = this.onNewData;
        if (this.currentSubscription || this.getOptions().skip) return;
        this.currentSubscription = this.currentObservable.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previous.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(previousResult.data, data)) return;
                onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previous.result;
                if (previousResult && previousResult.loading || !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(error, _this.previous.error)) {
                    _this.previous.error = error;
                    onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var currentObservable = this.currentObservable;
        if (currentObservable) {
            var lastError = currentObservable.getLastError();
            var lastResult = currentObservable.getLastResult();
            currentObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(currentObservable, {
                lastError: lastError,
                lastResult: lastResult
            });
        }
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        if (!this.currentObservable || !this.previous.result) return;
        var _a = this.previous.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError, skip = _b.skip;
            if (this.previousOptions && !this.previous.loading && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.previousOptions.query, query) && (0, $91ec8471c498125e$export$411ce8e5a71e3069)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error && !skip) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
            delete this.currentSubscription;
        }
    };
    QueryData.prototype.removeObservable = function(andDelete) {
        if (this.currentObservable) {
            this.currentObservable["tearDownQuery"]();
            if (andDelete) delete this.currentObservable;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var _a;
        return {
            variables: (_a = this.currentObservable) === null || _a === void 0 ? void 0 : _a.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}((0, $fab7d16573cba2e2$export$43795b6fdc114bf6));





var $denZA = parcelRequire("denZA");

function $ad198191229e82ae$export$722debc0e56fea39(memoFn, key) {
    var ref = (0, $denZA.useRef)();
    if (!ref.current || !(0, $91ec8471c498125e$export$411ce8e5a71e3069)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}



function $eb4cc05c62398237$export$fff0865807e996c5(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $denZA.useContext)((0, $b207a9cf96c16e3c$export$a47505d961ee3a1)());
    var _a = (0, $denZA.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $denZA.useRef)();
    var queryData = queryDataRef.current || (queryDataRef.current = new (0, $250217e3d94b536b$export$baa8865f9b235420)({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(function() {
                return queryDataRef.current && forceUpdate();
            });
            else forceUpdate();
        }
    }));
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = (0, $ad198191229e82ae$export$722debc0e56fea39)(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $denZA.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $denZA.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}


function $879159a57326e8fe$export$fd83eea6ecd2d8fa(query, options) {
    return (0, $eb4cc05c62398237$export$fff0865807e996c5)(query, options, true);
}




var $denZA = parcelRequire("denZA");


function $9c9f7b47eb4524c9$export$609860bf8b0084c(mutation, options) {
    var context = (0, $denZA.useContext)((0, $b207a9cf96c16e3c$export$a47505d961ee3a1)());
    var _a = (0, $denZA.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $denZA.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new (0, $5815b691b769fff6$export$1197ada6fead761a)({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $denZA.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}



function $367246b9cce32bfd$export$dd0a697e1782aedd(query, options) {
    return (0, $eb4cc05c62398237$export$fff0865807e996c5)(query, options, false);
}




var $denZA = parcelRequire("denZA");


function $ba968c8eeb6d26d7$export$368b4214baeb914c(subscription, options) {
    var context = (0, $denZA.useContext)((0, $b207a9cf96c16e3c$export$a47505d961ee3a1)());
    var updatedOptions = options ? (0, $1c0ef74047f3db21$export$18ce0697a983be9b)((0, $1c0ef74047f3db21$export$18ce0697a983be9b)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $denZA.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $denZA.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new (0, $6306bcc7bf46bc6f$export$ae4ab90ed0fb78ce)({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $denZA.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $denZA.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}



var $denZA = parcelRequire("denZA");
function $15e250725b15a673$export$b10e3d92c03f6472(rv) {
    var value = rv();
    var _a = (0, $denZA.useState)(value), setValue = _a[1];
    (0, $denZA.useEffect)(function() {
        return rv.onNextChange(setValue);
    }, [
        value
    ]);
    (0, $denZA.useEffect)(function() {
        setValue(rv());
    }, []);
    return value;
}





var $b6b1194a897ae96a$exports = {};


$parcel$exportWildcard($54335b8b21116335$exports, $b6b1194a897ae96a$exports);


$parcel$exportWildcard($0362c4f0d0793455$exports, $2151e708169cc25c$exports);
$parcel$exportWildcard($0362c4f0d0793455$exports, $54335b8b21116335$exports);


var $1672a4b8783b587e$exports = {};
"use strict";
Object.defineProperty($1672a4b8783b587e$exports, "__esModule", {
    value: true
});
var $4f11aed3d4bbd44d$exports = {};
"use strict";
var $4f11aed3d4bbd44d$var$__extends = $4f11aed3d4bbd44d$exports && $4f11aed3d4bbd44d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4f11aed3d4bbd44d$var$__assign = $4f11aed3d4bbd44d$exports && $4f11aed3d4bbd44d$exports.__assign || function() {
    $4f11aed3d4bbd44d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f11aed3d4bbd44d$var$__assign.apply(this, arguments);
};
var $4f11aed3d4bbd44d$var$__awaiter = $4f11aed3d4bbd44d$exports && $4f11aed3d4bbd44d$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4f11aed3d4bbd44d$var$__generator = $4f11aed3d4bbd44d$exports && $4f11aed3d4bbd44d$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($4f11aed3d4bbd44d$exports, "__esModule", {
    value: true
});

var $748c82f3cdadce71$var$genericMessage = "Invariant Violation";
var $748c82f3cdadce71$var$_a = Object.setPrototypeOf, $748c82f3cdadce71$var$setPrototypeOf = $748c82f3cdadce71$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $748c82f3cdadce71$var$_a;
var $748c82f3cdadce71$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $748c82f3cdadce71$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $748c82f3cdadce71$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $748c82f3cdadce71$var$genericMessage;
        $748c82f3cdadce71$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $748c82f3cdadce71$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $748c82f3cdadce71$export$cea12affaee22fe8(message);
}
var $748c82f3cdadce71$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $748c82f3cdadce71$var$verbosityLevel = $748c82f3cdadce71$var$verbosityLevels.indexOf("log");
function $748c82f3cdadce71$var$wrapConsoleMethod(name) {
    return function() {
        if ($748c82f3cdadce71$var$verbosityLevels.indexOf(name) >= $748c82f3cdadce71$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $748c82f3cdadce71$var$wrapConsoleMethod("debug");
    invariant.log = $748c82f3cdadce71$var$wrapConsoleMethod("log");
    invariant.warn = $748c82f3cdadce71$var$wrapConsoleMethod("warn");
    invariant.error = $748c82f3cdadce71$var$wrapConsoleMethod("error");
})($748c82f3cdadce71$export$f5708dca728d7177 || ($748c82f3cdadce71$export$f5708dca728d7177 = {}));
function $748c82f3cdadce71$export$a80e09f2cd325fb8(level) {
    var old = $748c82f3cdadce71$var$verbosityLevels[$748c82f3cdadce71$var$verbosityLevel];
    $748c82f3cdadce71$var$verbosityLevel = Math.max(0, $748c82f3cdadce71$var$verbosityLevels.indexOf(level));
    return old;
}
var $748c82f3cdadce71$export$2e2bcd8739ae039 = $748c82f3cdadce71$export$f5708dca728d7177;


var $4ca15a806d479a79$export$83d89fbfd8236492 = "3.14.1";


function $25c5812995d7743a$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $2fc1e9b073b084c3$export$2e2bcd8739ae039 = (0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $25c5812995d7743a$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $2446d69a15b4063e$var$prefixCounts = new Map();
function $2446d69a15b4063e$export$d0c8ec0fe1b18b70(prefix) {
    var count = $2446d69a15b4063e$var$prefixCounts.get(prefix) || 1;
    $2446d69a15b4063e$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $94015d1ae53ddce6$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $2446d69a15b4063e$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $e368ce965ba005d3$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $e368ce965ba005d3$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $e368ce965ba005d3$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $e368ce965ba005d3$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $748c82f3cdadce71$export$f5708dca728d7177)(condition, $e368ce965ba005d3$var$getHandledErrorMsg(message, args) || $e368ce965ba005d3$var$getFallbackErrorMsg(message, args));
}, {
    debug: $e368ce965ba005d3$var$wrap((0, $748c82f3cdadce71$export$f5708dca728d7177).debug),
    log: $e368ce965ba005d3$var$wrap((0, $748c82f3cdadce71$export$f5708dca728d7177).log),
    warn: $e368ce965ba005d3$var$wrap((0, $748c82f3cdadce71$export$f5708dca728d7177).warn),
    error: $e368ce965ba005d3$var$wrap((0, $748c82f3cdadce71$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $e368ce965ba005d3$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $748c82f3cdadce71$export$cea12affaee22fe8)($e368ce965ba005d3$var$getHandledErrorMsg(message, optionalParams) || $e368ce965ba005d3$var$getFallbackErrorMsg(message, optionalParams));
}
var $e368ce965ba005d3$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $4ca15a806d479a79$export$83d89fbfd8236492));
function $e368ce965ba005d3$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $94015d1ae53ddce6$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $e368ce965ba005d3$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $2fc1e9b073b084c3$export$2e2bcd8739ae039)[$e368ce965ba005d3$export$b8ca975fa04efdf3] && (0, $2fc1e9b073b084c3$export$2e2bcd8739ae039)[$e368ce965ba005d3$export$b8ca975fa04efdf3](message, messageArgs.map($e368ce965ba005d3$var$stringify));
}
function $e368ce965ba005d3$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $4ca15a806d479a79$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($e368ce965ba005d3$var$stringify)
    })));
}




var $3d581bb3e8682081$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;


function $ee0e445fbdcc527a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ee0e445fbdcc527a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ee0e445fbdcc527a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ee0e445fbdcc527a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ee0e445fbdcc527a$var$_arrayLikeToArray(o, minLen);
}
function $ee0e445fbdcc527a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ee0e445fbdcc527a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee0e445fbdcc527a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ee0e445fbdcc527a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee0e445fbdcc527a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $ee0e445fbdcc527a$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $ee0e445fbdcc527a$var$hasSymbol = function(name) {
    return $ee0e445fbdcc527a$var$hasSymbols() && Boolean(Symbol[name]);
};
var $ee0e445fbdcc527a$var$getSymbol = function(name) {
    return $ee0e445fbdcc527a$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($ee0e445fbdcc527a$var$hasSymbols() && !$ee0e445fbdcc527a$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $ee0e445fbdcc527a$var$SymbolIterator = $ee0e445fbdcc527a$var$getSymbol('iterator');
var $ee0e445fbdcc527a$var$SymbolObservable = $ee0e445fbdcc527a$var$getSymbol('observable');
var $ee0e445fbdcc527a$var$SymbolSpecies = $ee0e445fbdcc527a$var$getSymbol('species'); // === Abstract Operations ===
function $ee0e445fbdcc527a$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $ee0e445fbdcc527a$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$ee0e445fbdcc527a$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $ee0e445fbdcc527a$export$77cea355fa80b5f4;
}
function $ee0e445fbdcc527a$var$isObservable(x) {
    return x instanceof $ee0e445fbdcc527a$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $ee0e445fbdcc527a$var$hostReportError(e) {
    if ($ee0e445fbdcc527a$var$hostReportError.log) $ee0e445fbdcc527a$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $ee0e445fbdcc527a$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $ee0e445fbdcc527a$var$hostReportError(e);
        }
    });
}
function $ee0e445fbdcc527a$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $ee0e445fbdcc527a$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $ee0e445fbdcc527a$var$hostReportError(e);
    }
}
function $ee0e445fbdcc527a$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $ee0e445fbdcc527a$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $ee0e445fbdcc527a$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $ee0e445fbdcc527a$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $ee0e445fbdcc527a$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $ee0e445fbdcc527a$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $ee0e445fbdcc527a$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $ee0e445fbdcc527a$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $ee0e445fbdcc527a$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $ee0e445fbdcc527a$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $ee0e445fbdcc527a$var$enqueue(function() {
            return $ee0e445fbdcc527a$var$flushSubscription(subscription);
        });
        return;
    }
    $ee0e445fbdcc527a$var$notifySubscription(subscription, type, value);
}
var $ee0e445fbdcc527a$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $ee0e445fbdcc527a$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $ee0e445fbdcc527a$var$closeSubscription(this);
            $ee0e445fbdcc527a$var$cleanupSubscription(this);
        }
    };
    $ee0e445fbdcc527a$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $ee0e445fbdcc527a$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $ee0e445fbdcc527a$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $ee0e445fbdcc527a$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $ee0e445fbdcc527a$var$onNotify(this._subscription, 'complete');
    };
    $ee0e445fbdcc527a$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $ee0e445fbdcc527a$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $ee0e445fbdcc527a$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $ee0e445fbdcc527a$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $ee0e445fbdcc527a$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $ee0e445fbdcc527a$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $ee0e445fbdcc527a$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $ee0e445fbdcc527a$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$ee0e445fbdcc527a$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $ee0e445fbdcc527a$var$getMethod(x, $ee0e445fbdcc527a$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($ee0e445fbdcc527a$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($ee0e445fbdcc527a$var$hasSymbol('iterator')) {
            method = $ee0e445fbdcc527a$var$getMethod(x, $ee0e445fbdcc527a$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $ee0e445fbdcc527a$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $ee0e445fbdcc527a$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $ee0e445fbdcc527a$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $ee0e445fbdcc527a$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $ee0e445fbdcc527a$var$_createClass(Observable, null, [
        {
            key: $ee0e445fbdcc527a$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($ee0e445fbdcc527a$var$hasSymbols()) Object.defineProperty($ee0e445fbdcc527a$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $ee0e445fbdcc527a$var$SymbolObservable,
        hostReportError: $ee0e445fbdcc527a$var$hostReportError
    },
    configurable: true
});


parcelRequire("k4RGx");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $5d65596304d6012f$var$prototype = (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).prototype;
var $5d65596304d6012f$var$fakeObsSymbol = "@@observable";
if (!$5d65596304d6012f$var$prototype[$5d65596304d6012f$var$fakeObsSymbol]) // @ts-expect-error
$5d65596304d6012f$var$prototype[$5d65596304d6012f$var$fakeObsSymbol] = function() {
    return this;
};


// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $00d96d3ddd396725$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $00d96d3ddd396725$var$forEach, slice: $00d96d3ddd396725$var$slice } = Array.prototype;
const { hasOwnProperty: $00d96d3ddd396725$var$hasOwnProperty } = Object.prototype;
class $00d96d3ddd396725$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $00d96d3ddd396725$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $00d96d3ddd396725$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $00d96d3ddd396725$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($00d96d3ddd396725$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($00d96d3ddd396725$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $00d96d3ddd396725$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $00d96d3ddd396725$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $00d96d3ddd396725$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


function $4491d36e18dba4b0$var$defaultDispose() {}
class $4491d36e18dba4b0$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $4491d36e18dba4b0$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $458f66330938bcf2$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $458f66330938bcf2$var$MISSING_VALUE = {};
let $458f66330938bcf2$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $458f66330938bcf2$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $458f66330938bcf2$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $458f66330938bcf2$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $458f66330938bcf2$var$MISSING_VALUE) break;
                if (context !== $458f66330938bcf2$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $458f66330938bcf2$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($458f66330938bcf2$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $458f66330938bcf2$var$currentContext.slots[this.id] = $458f66330938bcf2$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $458f66330938bcf2$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $458f66330938bcf2$var$currentContext;
            $458f66330938bcf2$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $458f66330938bcf2$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $458f66330938bcf2$var$currentContext;
            return function() {
                const saved = $458f66330938bcf2$var$currentContext;
                try {
                    $458f66330938bcf2$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $458f66330938bcf2$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($458f66330938bcf2$var$currentContext) {
                const saved = $458f66330938bcf2$var$currentContext;
                try {
                    $458f66330938bcf2$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $458f66330938bcf2$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $458f66330938bcf2$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $458f66330938bcf2$var$globalKey = "@wry/context:Slot";
const $458f66330938bcf2$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$458f66330938bcf2$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$458f66330938bcf2$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $458f66330938bcf2$var$globalHost = $458f66330938bcf2$var$host;
const $458f66330938bcf2$export$8c6ed5c666ac1360 = $458f66330938bcf2$var$globalHost[$458f66330938bcf2$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$458f66330938bcf2$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($458f66330938bcf2$var$globalHost, $458f66330938bcf2$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($458f66330938bcf2$var$makeSlotClass());


const { bind: $d84f67f2bdfedb53$export$2385a24977818dd0, noContext: $d84f67f2bdfedb53$export$9fa6f2e300a97f8 } = (0, $458f66330938bcf2$export$8c6ed5c666ac1360);
function $d84f67f2bdfedb53$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($d84f67f2bdfedb53$export$2385a24977818dd0(callback), delay);
}
function $d84f67f2bdfedb53$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $d84f67f2bdfedb53$export$2385a24977818dd0(gen.next);
        const boundThrow = $d84f67f2bdfedb53$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($d84f67f2bdfedb53$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $d84f67f2bdfedb53$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $d84f67f2bdfedb53$var$wrappedFibers = [];
function $d84f67f2bdfedb53$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($d84f67f2bdfedb53$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $d84f67f2bdfedb53$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $d84f67f2bdfedb53$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $82590c04b7562c11$export$11fa9682b6ba79b1 = new (0, $458f66330938bcf2$export$8c6ed5c666ac1360)();
function $82590c04b7562c11$export$d906efd39458576(fn) {
    return $82590c04b7562c11$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $13c081963cd5566e$export$5a15a386532a5ea4 } = Object.prototype;
const $13c081963cd5566e$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $13c081963cd5566e$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $009f50136b2aaeb6$var$emptySetPool = [];
const $009f50136b2aaeb6$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $009f50136b2aaeb6$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $009f50136b2aaeb6$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $009f50136b2aaeb6$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $009f50136b2aaeb6$var$valueCopy(value) {
    return value.slice(0);
}
class $009f50136b2aaeb6$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$009f50136b2aaeb6$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$009f50136b2aaeb6$var$mightBeDirty(this)) {
            $009f50136b2aaeb6$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $009f50136b2aaeb6$var$assert(!this.recomputing, "already recomputing");
        $009f50136b2aaeb6$var$rememberParent(this);
        return $009f50136b2aaeb6$var$mightBeDirty(this) ? $009f50136b2aaeb6$var$reallyRecompute(this, args) : $009f50136b2aaeb6$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $009f50136b2aaeb6$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $13c081963cd5566e$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $009f50136b2aaeb6$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $009f50136b2aaeb6$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $009f50136b2aaeb6$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $009f50136b2aaeb6$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $13c081963cd5566e$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $009f50136b2aaeb6$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$009f50136b2aaeb6$export$3bb977b3ba9d3b59.count = 0;
function $009f50136b2aaeb6$var$rememberParent(child) {
    const parent = (0, $82590c04b7562c11$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($009f50136b2aaeb6$var$mightBeDirty(child)) $009f50136b2aaeb6$var$reportDirtyChild(parent, child);
        else $009f50136b2aaeb6$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $009f50136b2aaeb6$var$reallyRecompute(entry, args) {
    $009f50136b2aaeb6$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $82590c04b7562c11$export$11fa9682b6ba79b1).withValue(entry, $009f50136b2aaeb6$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($009f50136b2aaeb6$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $009f50136b2aaeb6$var$setClean(entry);
    return $009f50136b2aaeb6$var$valueGet(entry.value);
}
function $009f50136b2aaeb6$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $009f50136b2aaeb6$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$009f50136b2aaeb6$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $009f50136b2aaeb6$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $009f50136b2aaeb6$var$setClean(entry) {
    entry.dirty = false;
    if ($009f50136b2aaeb6$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $009f50136b2aaeb6$var$reportClean(entry);
}
function $009f50136b2aaeb6$var$reportDirty(child) {
    $009f50136b2aaeb6$var$eachParent(child, $009f50136b2aaeb6$var$reportDirtyChild);
}
function $009f50136b2aaeb6$var$reportClean(child) {
    $009f50136b2aaeb6$var$eachParent(child, $009f50136b2aaeb6$var$reportCleanChild);
}
function $009f50136b2aaeb6$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $13c081963cd5566e$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $009f50136b2aaeb6$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $009f50136b2aaeb6$var$assert(parent.childValues.has(child));
    $009f50136b2aaeb6$var$assert($009f50136b2aaeb6$var$mightBeDirty(child));
    const parentWasClean = !$009f50136b2aaeb6$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $009f50136b2aaeb6$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $009f50136b2aaeb6$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $009f50136b2aaeb6$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $009f50136b2aaeb6$var$assert(parent.childValues.has(child));
    $009f50136b2aaeb6$var$assert(!$009f50136b2aaeb6$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $009f50136b2aaeb6$var$valueCopy(child.value));
    else if (!$009f50136b2aaeb6$var$valueIs(childValue, child.value)) parent.setDirty();
    $009f50136b2aaeb6$var$removeDirtyChild(parent, child);
    if ($009f50136b2aaeb6$var$mightBeDirty(parent)) return;
    $009f50136b2aaeb6$var$reportClean(parent);
}
function $009f50136b2aaeb6$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($009f50136b2aaeb6$var$emptySetPool.length < $009f50136b2aaeb6$var$POOL_TARGET_SIZE) $009f50136b2aaeb6$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $009f50136b2aaeb6$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $009f50136b2aaeb6$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $009f50136b2aaeb6$var$assert(parent.dirtyChildren === null);
}
function $009f50136b2aaeb6$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $009f50136b2aaeb6$var$removeDirtyChild(parent, child);
}
function $009f50136b2aaeb6$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $13c081963cd5566e$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $aeaddeea393c8887$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $aeaddeea393c8887$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $82590c04b7562c11$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $13c081963cd5566e$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $13c081963cd5566e$export$5a15a386532a5ea4).call($aeaddeea393c8887$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $13c081963cd5566e$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $13c081963cd5566e$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $1b448f80410d1c96$var$defaultKeyTrie;
function $1b448f80410d1c96$export$cd3144f8dd136006(...args) {
    const trie = $1b448f80410d1c96$var$defaultKeyTrie || ($1b448f80410d1c96$var$defaultKeyTrie = new (0, $00d96d3ddd396725$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $1b448f80410d1c96$var$caches = new Set();
function $1b448f80410d1c96$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $1b448f80410d1c96$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $009f50136b2aaeb6$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $1b448f80410d1c96$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $82590c04b7562c11$export$11fa9682b6ba79b1).hasValue()) {
            $1b448f80410d1c96$var$caches.forEach((cache)=>cache.clean());
            $1b448f80410d1c96$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $42c784ba3b2f9e5f$var$_a;
var $42c784ba3b2f9e5f$var$muteAllDeprecations = Symbol.for("apollo.deprecations");
var $42c784ba3b2f9e5f$var$deprecationsSlot = Symbol.for("apollo.deprecations.slot");
var $42c784ba3b2f9e5f$var$global = (0, $2fc1e9b073b084c3$export$2e2bcd8739ae039);
var $42c784ba3b2f9e5f$var$slot = ($42c784ba3b2f9e5f$var$_a = $42c784ba3b2f9e5f$var$global[$42c784ba3b2f9e5f$var$deprecationsSlot]) !== null && $42c784ba3b2f9e5f$var$_a !== void 0 ? $42c784ba3b2f9e5f$var$_a : $42c784ba3b2f9e5f$var$global[$42c784ba3b2f9e5f$var$deprecationsSlot] = new (0, $458f66330938bcf2$export$8c6ed5c666ac1360)();
function $42c784ba3b2f9e5f$var$isMuted(name) {
    return $42c784ba3b2f9e5f$var$global[$42c784ba3b2f9e5f$var$muteAllDeprecations] || ($42c784ba3b2f9e5f$var$slot.getValue() || []).includes(name);
}
function $42c784ba3b2f9e5f$export$d18d1529326946c4(name) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $42c784ba3b2f9e5f$var$slot.withValue.apply($42c784ba3b2f9e5f$var$slot, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([
        Array.isArray(name) ? name : [
            name
        ]
    ], args, false));
}
function $42c784ba3b2f9e5f$export$6d0d09df4c29a84a(options, name, callSite, recommendation) {
    if (recommendation === void 0) recommendation = "Please remove this option.";
    $42c784ba3b2f9e5f$export$606a5c06d13e04b6(name, function() {
        if (name in options) globalThis.__DEV__ !== false && (0, $e368ce965ba005d3$export$f5708dca728d7177).warn(103, callSite, name, recommendation);
    });
}
function $42c784ba3b2f9e5f$export$606a5c06d13e04b6(name, cb) {
    if (!$42c784ba3b2f9e5f$var$isMuted(name)) cb();
}



function $6146854cafbce44e$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $f96ca9e5fcce97a4$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $f96ca9e5fcce97a4$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}





function $ae49ee641f394b19$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $e368ce965ba005d3$export$3991762405098ea)(112, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $e368ce965ba005d3$export$f5708dca728d7177)(fragments.length === 1, 113, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $96998cfc8b9d4854$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $ae49ee641f394b19$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $ae49ee641f394b19$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $e368ce965ba005d3$export$f5708dca728d7177)(fragment, 114, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $ae49ee641f394b19$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $0f36c934b7f2a151$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}


function $0bb0b818d41c35d5$var$noop() {}
const $0bb0b818d41c35d5$var$defaultDispose = $0bb0b818d41c35d5$var$noop;
const $0bb0b818d41c35d5$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $0bb0b818d41c35d5$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $0bb0b818d41c35d5$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $0bb0b818d41c35d5$var$noop,
        unregister: $0bb0b818d41c35d5$var$noop
    };
};
const $0bb0b818d41c35d5$var$finalizationBatchSize = 10024;
class $0bb0b818d41c35d5$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $0bb0b818d41c35d5$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $0bb0b818d41c35d5$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $0bb0b818d41c35d5$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $0bb0b818d41c35d5$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $0bb0b818d41c35d5$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $b8a0bc784510a2ac$var$scheduledCleanup = new WeakSet();
function $b8a0bc784510a2ac$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$b8a0bc784510a2ac$var$scheduledCleanup.has(cache)) {
        $b8a0bc784510a2ac$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b8a0bc784510a2ac$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b8a0bc784510a2ac$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $0bb0b818d41c35d5$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $0bb0b818d41c35d5$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $b8a0bc784510a2ac$var$schedule(this);
        return ret;
    };
    return cache;
};
var $b8a0bc784510a2ac$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $b8a0bc784510a2ac$var$schedule(this);
        return ret;
    };
    return cache;
};



var $535ed9599261f315$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $535ed9599261f315$export$f29926b23b28936b = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $2fc1e9b073b084c3$export$2e2bcd8739ae039)[$535ed9599261f315$var$cacheSizeSymbol]);




var $04c3a5585ce93a2d$var$globalCaches = {};
function $04c3a5585ce93a2d$export$a8fcd406d9e37621(name, getSize) {
    $04c3a5585ce93a2d$var$globalCaches[name] = getSize;
}
var $04c3a5585ce93a2d$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $04c3a5585ce93a2d$var$_getApolloClientMemoryInternals : undefined;
var $04c3a5585ce93a2d$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $04c3a5585ce93a2d$var$_getInMemoryCacheMemoryInternals : undefined;
var $04c3a5585ce93a2d$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $04c3a5585ce93a2d$var$_getApolloCacheMemoryInternals : undefined;
function $04c3a5585ce93a2d$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $535ed9599261f315$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $04c3a5585ce93a2d$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $04c3a5585ce93a2d$var$getCurrentCacheSizes(),
        sizes: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            print: (_a = $04c3a5585ce93a2d$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($04c3a5585ce93a2d$var$globalCaches),
            parser: (_b = $04c3a5585ce93a2d$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($04c3a5585ce93a2d$var$globalCaches),
            canonicalStringify: (_c = $04c3a5585ce93a2d$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($04c3a5585ce93a2d$var$globalCaches),
            links: $04c3a5585ce93a2d$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $04c3a5585ce93a2d$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $04c3a5585ce93a2d$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $04c3a5585ce93a2d$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $04c3a5585ce93a2d$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $04c3a5585ce93a2d$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $04c3a5585ce93a2d$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $04c3a5585ce93a2d$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $04c3a5585ce93a2d$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $04c3a5585ce93a2d$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $04c3a5585ce93a2d$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $04c3a5585ce93a2d$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $04c3a5585ce93a2d$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $04c3a5585ce93a2d$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $04c3a5585ce93a2d$var$getWrapperInformation(f) {
    return $04c3a5585ce93a2d$var$isWrapper(f) ? f.size : undefined;
}
function $04c3a5585ce93a2d$var$isDefined(value) {
    return value != null;
}
function $04c3a5585ce93a2d$var$transformInfo(transform) {
    return $04c3a5585ce93a2d$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $04c3a5585ce93a2d$var$recurseTransformInfo(transform) {
    return transform ? (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([
        $04c3a5585ce93a2d$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $04c3a5585ce93a2d$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $04c3a5585ce93a2d$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($04c3a5585ce93a2d$var$isDefined) : [];
}
function $04c3a5585ce93a2d$var$linkInfo(link) {
    var _a;
    return link ? (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $04c3a5585ce93a2d$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $04c3a5585ce93a2d$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($04c3a5585ce93a2d$var$isDefined) : [];
}


var $c76e1ae212f44f08$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $c76e1ae212f44f08$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $c76e1ae212f44f08$var$sortingMap = new (0, $b8a0bc784510a2ac$export$5b4f745137d91413)((0, $535ed9599261f315$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $04c3a5585ce93a2d$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $c76e1ae212f44f08$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $c76e1ae212f44f08$var$sortingMap;
$c76e1ae212f44f08$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $c76e1ae212f44f08$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($c76e1ae212f44f08$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $c76e1ae212f44f08$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $c76e1ae212f44f08$var$sortingMap.get(sortedKey) || keys;
                $c76e1ae212f44f08$var$sortingMap.set(unsortedKey, sortedKeys);
                $c76e1ae212f44f08$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $c76e1ae212f44f08$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $ec76639e667918c8$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $ec76639e667918c8$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $ec76639e667918c8$export$540432d49fcec6c9(value) {
    return (0, $f96ca9e5fcce97a4$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $ec76639e667918c8$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $ec76639e667918c8$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $ec76639e667918c8$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $ec76639e667918c8$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $ec76639e667918c8$var$isVariable(value) {
    return value.kind === "Variable";
}
function $ec76639e667918c8$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $ec76639e667918c8$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $ec76639e667918c8$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $ec76639e667918c8$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $ec76639e667918c8$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($ec76639e667918c8$var$isIntValue(value) || $ec76639e667918c8$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($ec76639e667918c8$var$isBooleanValue(value) || $ec76639e667918c8$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($ec76639e667918c8$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $ec76639e667918c8$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($ec76639e667918c8$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($ec76639e667918c8$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $ec76639e667918c8$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($ec76639e667918c8$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($ec76639e667918c8$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $e368ce965ba005d3$export$3991762405098ea)(123, name.value, value.kind);
}
function $ec76639e667918c8$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $ec76639e667918c8$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $ec76639e667918c8$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $ec76639e667918c8$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $ec76639e667918c8$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $ec76639e667918c8$var$storeKeyNameStringify = (0, $c76e1ae212f44f08$export$88a0ad9b6f961b51);
var $ec76639e667918c8$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($ec76639e667918c8$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $ec76639e667918c8$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($ec76639e667918c8$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($ec76639e667918c8$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $ec76639e667918c8$var$storeKeyNameStringify;
        $ec76639e667918c8$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $ec76639e667918c8$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $ec76639e667918c8$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $ec76639e667918c8$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $ec76639e667918c8$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($ec76639e667918c8$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$ec76639e667918c8$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $ec76639e667918c8$export$cf7bf7e4f289cc26(result, (0, $ae49ee641f394b19$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $ec76639e667918c8$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $ec76639e667918c8$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $4ae841454fdc700d$export$a7d0d8111d2386df(doc) {
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(doc && doc.kind === "Document", 115);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $e368ce965ba005d3$export$3991762405098ea)(116, definition.kind);
        return definition;
    });
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(operations.length <= 1, 117, operations.length);
    return doc;
}
function $4ae841454fdc700d$export$7a5b1fa979d2c158(doc) {
    $4ae841454fdc700d$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $4ae841454fdc700d$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $4ae841454fdc700d$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $4ae841454fdc700d$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $4ae841454fdc700d$export$7a5b1fa979d2c158(doc);
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 118);
    return queryDef;
}
function $4ae841454fdc700d$export$772111caef41b3f5(doc) {
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(doc.kind === "Document", 119);
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(doc.definitions.length <= 1, 120);
    var fragmentDef = doc.definitions[0];
    (0, $e368ce965ba005d3$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 121);
    return fragmentDef;
}
function $4ae841454fdc700d$export$f431198736b7f96d(queryDoc) {
    $4ae841454fdc700d$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $e368ce965ba005d3$export$3991762405098ea)(122);
}
function $4ae841454fdc700d$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $ec76639e667918c8$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $e29bd98c80fd12b4$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $4ae841454fdc700d$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $1e870573741fca5b$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $e368ce965ba005d3$export$3991762405098ea)(58, key);
    }
    return operation;
}


function $0d6b5993ee1bdbf3$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
}
function $0d6b5993ee1bdbf3$var$toLink(handler) {
    return typeof handler === "function" ? new $0d6b5993ee1bdbf3$export$2fed3d61f740bc7f(handler) : handler;
}
function $0d6b5993ee1bdbf3$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $0d6b5993ee1bdbf3$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($0d6b5993ee1bdbf3$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $0d6b5993ee1bdbf3$var$toLink(left);
        var rightLink = $0d6b5993ee1bdbf3$var$toLink(right || new ApolloLink($0d6b5993ee1bdbf3$var$passthrough));
        var ret;
        if ($0d6b5993ee1bdbf3$var$isTerminating(leftLink) && $0d6b5993ee1bdbf3$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $6146854cafbce44e$export$f29bedd62f56fcb2)(operation.context, (0, $e29bd98c80fd12b4$export$4f3f7df1b558c729)((0, $1e870573741fca5b$export$a92a48117d546c9)(operation)))) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $0d6b5993ee1bdbf3$var$toLink(first);
        if ($0d6b5993ee1bdbf3$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $e368ce965ba005d3$export$f5708dca728d7177).warn(47, firstLink);
            return firstLink;
        }
        var nextLink = $0d6b5993ee1bdbf3$var$toLink(second);
        var ret;
        if ($0d6b5993ee1bdbf3$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
            }) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
            }) || (0, $ee0e445fbdcc527a$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($0d6b5993ee1bdbf3$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $e368ce965ba005d3$export$3991762405098ea)(48);
    };
    /**
     * @deprecated `onError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.onError = function(error, observer) {
        if (globalThis.__DEV__ !== false) (0, $42c784ba3b2f9e5f$export$606a5c06d13e04b6)("onError", function() {
            globalThis.__DEV__ !== false && (0, $e368ce965ba005d3$export$f5708dca728d7177).warn(49);
        });
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    /**
     * @deprecated `setOnError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.setOnError = function(fn) {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $e368ce965ba005d3$export$f5708dca728d7177).warn(50);
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $1e1d9b3d0a6f8566$exports = {};
"use strict";
Object.defineProperty($1e1d9b3d0a6f8566$exports, "__esModule", {
    value: true
});
$1e1d9b3d0a6f8566$exports.print = $1e1d9b3d0a6f8566$var$print;

var $9f27e3f58166a103$exports = {};
"use strict";
Object.defineProperty($9f27e3f58166a103$exports, "__esModule", {
    value: true
});
$9f27e3f58166a103$exports.dedentBlockStringValue = $9f27e3f58166a103$var$dedentBlockStringValue;
$9f27e3f58166a103$exports.getBlockStringIndentation = $9f27e3f58166a103$var$getBlockStringIndentation;
$9f27e3f58166a103$exports.printBlockString = $9f27e3f58166a103$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $9f27e3f58166a103$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $9f27e3f58166a103$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $9f27e3f58166a103$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $9f27e3f58166a103$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $9f27e3f58166a103$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $9f27e3f58166a103$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $9f27e3f58166a103$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $1e1d9b3d0a6f8566$var$print(ast) {
    return (0, $aed09fe0dab48b39$exports.visit)(ast, {
        leave: $1e1d9b3d0a6f8566$var$printDocASTReducer
    });
}
var $1e1d9b3d0a6f8566$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1e1d9b3d0a6f8566$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1e1d9b3d0a6f8566$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1e1d9b3d0a6f8566$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1e1d9b3d0a6f8566$var$join([
            op,
            $1e1d9b3d0a6f8566$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1e1d9b3d0a6f8566$var$wrap(' = ', defaultValue) + $1e1d9b3d0a6f8566$var$wrap(' ', $1e1d9b3d0a6f8566$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1e1d9b3d0a6f8566$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1e1d9b3d0a6f8566$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(args, ', '), ')');
        if (argsLine.length > $1e1d9b3d0a6f8566$var$MAX_LINE_LENGTH) argsLine = prefix + $1e1d9b3d0a6f8566$var$wrap('(\n', $1e1d9b3d0a6f8566$var$indent($1e1d9b3d0a6f8566$var$join(args, '\n')), '\n)');
        return $1e1d9b3d0a6f8566$var$join([
            argsLine,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1e1d9b3d0a6f8566$var$wrap(' ', $1e1d9b3d0a6f8566$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1e1d9b3d0a6f8566$var$join([
            '...',
            $1e1d9b3d0a6f8566$var$wrap('on ', typeCondition),
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1e1d9b3d0a6f8566$var$wrap('', $1e1d9b3d0a6f8566$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $9f27e3f58166a103$exports.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1e1d9b3d0a6f8566$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1e1d9b3d0a6f8566$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1e1d9b3d0a6f8566$var$join([
            'schema',
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1e1d9b3d0a6f8566$var$join([
            'scalar',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'type',
            name,
            $1e1d9b3d0a6f8566$var$wrap('implements ', $1e1d9b3d0a6f8566$var$join(interfaces, ' & ')),
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1e1d9b3d0a6f8566$var$hasMultilineItems(args) ? $1e1d9b3d0a6f8566$var$wrap('(\n', $1e1d9b3d0a6f8566$var$indent($1e1d9b3d0a6f8566$var$join(args, '\n')), '\n)') : $1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(args, ', '), ')')) + ': ' + type + $1e1d9b3d0a6f8566$var$wrap(' ', $1e1d9b3d0a6f8566$var$join(directives, ' '));
    }),
    InputValueDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1e1d9b3d0a6f8566$var$join([
            name + ': ' + type,
            $1e1d9b3d0a6f8566$var$wrap('= ', defaultValue),
            $1e1d9b3d0a6f8566$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'interface',
            name,
            $1e1d9b3d0a6f8566$var$wrap('implements ', $1e1d9b3d0a6f8566$var$join(interfaces, ' & ')),
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1e1d9b3d0a6f8566$var$join([
            'union',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1e1d9b3d0a6f8566$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1e1d9b3d0a6f8566$var$join([
            'enum',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1e1d9b3d0a6f8566$var$join([
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'input',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1e1d9b3d0a6f8566$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1e1d9b3d0a6f8566$var$hasMultilineItems(args) ? $1e1d9b3d0a6f8566$var$wrap('(\n', $1e1d9b3d0a6f8566$var$indent($1e1d9b3d0a6f8566$var$join(args, '\n')), '\n)') : $1e1d9b3d0a6f8566$var$wrap('(', $1e1d9b3d0a6f8566$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1e1d9b3d0a6f8566$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1e1d9b3d0a6f8566$var$join([
            'extend schema',
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1e1d9b3d0a6f8566$var$join([
            'extend scalar',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'extend type',
            name,
            $1e1d9b3d0a6f8566$var$wrap('implements ', $1e1d9b3d0a6f8566$var$join(interfaces, ' & ')),
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'extend interface',
            name,
            $1e1d9b3d0a6f8566$var$wrap('implements ', $1e1d9b3d0a6f8566$var$join(interfaces, ' & ')),
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1e1d9b3d0a6f8566$var$join([
            'extend union',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1e1d9b3d0a6f8566$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1e1d9b3d0a6f8566$var$join([
            'extend enum',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1e1d9b3d0a6f8566$var$join([
            'extend input',
            name,
            $1e1d9b3d0a6f8566$var$join(directives, ' '),
            $1e1d9b3d0a6f8566$var$block(fields)
        ], ' ');
    }
};
function $1e1d9b3d0a6f8566$var$addDescription(cb) {
    return function(node) {
        return $1e1d9b3d0a6f8566$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1e1d9b3d0a6f8566$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1e1d9b3d0a6f8566$var$block(array) {
    return $1e1d9b3d0a6f8566$var$wrap('{\n', $1e1d9b3d0a6f8566$var$indent($1e1d9b3d0a6f8566$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1e1d9b3d0a6f8566$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1e1d9b3d0a6f8566$var$indent(str) {
    return $1e1d9b3d0a6f8566$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1e1d9b3d0a6f8566$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1e1d9b3d0a6f8566$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1e1d9b3d0a6f8566$var$isMultiline);
}


var $7abddbdc01c27e70$exports = {};
"use strict";
function $7abddbdc01c27e70$var$__export(m) {
    for(var p in m)if (!$7abddbdc01c27e70$exports.hasOwnProperty(p)) $7abddbdc01c27e70$exports[p] = m[p];
}
Object.defineProperty($7abddbdc01c27e70$exports, "__esModule", {
    value: true
});

/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ $7abddbdc01c27e70$var$__export((parcelRequire("glcOD")));



var $adm0U = parcelRequire("adm0U");
var $0a7462c06f793177$exports = {};
"use strict";
Object.defineProperty($0a7462c06f793177$exports, "__esModule", {
    value: true
});
var $0a7462c06f793177$var$userAgent = '';
$0a7462c06f793177$exports.userAgent = $0a7462c06f793177$var$userAgent;


var $2d6699e7fa70dd02$exports = {};
$2d6699e7fa70dd02$exports = JSON.parse("{\"name\":\"aws-appsync-auth-link\",\"version\":\"3.0.2\",\"main\":\"lib/index.js\",\"license\":\"Apache-2.0\",\"description\":\"AWS Mobile AppSync Auth Link for JavaScript\",\"author\":{\"name\":\"Amazon Web Services\",\"url\":\"https://aws.amazon.com/\"},\"homepage\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\"},\"scripts\":{\"prepare\":\"tsc\",\"test\":\"jest --coverage --coverageReporters=text --passWithNoTests\",\"test-watch\":\"jest --watch\"},\"dependencies\":{\"@apollo/client\":\"^3.2.0\",\"aws-sdk\":\"^2.518.0\",\"debug\":\"2.6.9\"}}");


var $4f11aed3d4bbd44d$var$SERVICE = 'appsync';
$4f11aed3d4bbd44d$exports.USER_AGENT_HEADER = 'x-amz-user-agent';
$4f11aed3d4bbd44d$exports.USER_AGENT = "aws-amplify/" + $2d6699e7fa70dd02$exports.version + ($0a7462c06f793177$exports.userAgent && ' ') + $0a7462c06f793177$exports.userAgent;
var $4f11aed3d4bbd44d$var$AUTH_TYPE;
(function(AUTH_TYPE) {
    AUTH_TYPE["NONE"] = "NONE";
    AUTH_TYPE["API_KEY"] = "API_KEY";
    AUTH_TYPE["AWS_IAM"] = "AWS_IAM";
    AUTH_TYPE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    AUTH_TYPE["OPENID_CONNECT"] = "OPENID_CONNECT";
})($4f11aed3d4bbd44d$var$AUTH_TYPE = $4f11aed3d4bbd44d$exports.AUTH_TYPE || ($4f11aed3d4bbd44d$exports.AUTH_TYPE = {}));
var $4f11aed3d4bbd44d$var$AuthLink = /** @class */ function(_super) {
    $4f11aed3d4bbd44d$var$__extends(AuthLink, _super);
    /**
     *
     * @param {*} options
     */ function AuthLink(options) {
        var _this = _super.call(this) || this;
        _this.link = $4f11aed3d4bbd44d$exports.authLink(options);
        return _this;
    }
    AuthLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return AuthLink;
}($0d6b5993ee1bdbf3$export$2fed3d61f740bc7f);
$4f11aed3d4bbd44d$exports.AuthLink = $4f11aed3d4bbd44d$var$AuthLink;
var $4f11aed3d4bbd44d$var$headerBasedAuth = function(_a, operation, forward) {
    var _b = _a === void 0 ? {
        header: '',
        value: ''
    } : _a, header = _b.header, value = _b.value;
    return $4f11aed3d4bbd44d$var$__awaiter(void 0, void 0, void 0, function() {
        var origContext, headers, headerValue, _c;
        var _d, _e;
        return $4f11aed3d4bbd44d$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    origContext = operation.getContext();
                    headers = $4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({}, origContext.headers), (_d = {}, _d[$4f11aed3d4bbd44d$exports.USER_AGENT_HEADER] = $4f11aed3d4bbd44d$exports.USER_AGENT, _d));
                    if (!(header && value)) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(typeof value === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value.call(undefined)
                    ];
                case 1:
                    _c = _f.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        value
                    ];
                case 3:
                    _c = _f.sent();
                    _f.label = 4;
                case 4:
                    headerValue = _c;
                    headers = $4f11aed3d4bbd44d$var$__assign((_e = {}, _e[header] = headerValue, _e), headers);
                    _f.label = 5;
                case 5:
                    operation.setContext($4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({}, origContext), {
                        headers: headers
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $4f11aed3d4bbd44d$var$iamBasedAuth = function(_a, operation, forward) {
    var credentials = _a.credentials, region = _a.region, url = _a.url;
    return $4f11aed3d4bbd44d$var$__awaiter(void 0, void 0, void 0, function() {
        var service, origContext, creds, _b, accessKeyId, secretAccessKey, sessionToken, _c, host, path, formatted, headers;
        var _d;
        return $4f11aed3d4bbd44d$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    service = $4f11aed3d4bbd44d$var$SERVICE;
                    origContext = operation.getContext();
                    creds = typeof credentials === 'function' ? credentials.call() : credentials || {};
                    if (!(creds && typeof creds.getPromise === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        creds.getPromise()
                    ];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        creds
                    ];
                case 3:
                    _b = _e.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                    _c = $adm0U.parse(url), host = _c.host, path = _c.path;
                    formatted = $4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({}, $4f11aed3d4bbd44d$var$formatAsRequest(operation, {})), {
                        service: service,
                        region: region,
                        url: url,
                        host: host,
                        path: path
                    });
                    headers = $7abddbdc01c27e70$exports.Signer.sign(formatted, {
                        access_key: accessKeyId,
                        secret_key: secretAccessKey,
                        session_token: sessionToken
                    }).headers;
                    operation.setContext($4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({}, origContext), {
                        headers: $4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({}, origContext.headers), headers), (_d = {}, _d[$4f11aed3d4bbd44d$exports.USER_AGENT_HEADER] = $4f11aed3d4bbd44d$exports.USER_AGENT, _d))
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
$4f11aed3d4bbd44d$exports.authLink = function(_a) {
    var url = _a.url, region = _a.region, _b = _a.auth, type = (_b === void 0 ? {} : _b).type, auth = _a.auth;
    return new $0d6b5993ee1bdbf3$export$2fed3d61f740bc7f(function(operation, forward) {
        return new $ee0e445fbdcc527a$export$77cea355fa80b5f4(function(observer) {
            var handle;
            var promise;
            switch(type){
                case $4f11aed3d4bbd44d$var$AUTH_TYPE.NONE:
                    promise = $4f11aed3d4bbd44d$var$headerBasedAuth(undefined, operation, forward);
                    break;
                case $4f11aed3d4bbd44d$var$AUTH_TYPE.AWS_IAM:
                    var _a = auth.credentials, credentials = _a === void 0 ? {} : _a;
                    promise = $4f11aed3d4bbd44d$var$iamBasedAuth({
                        credentials: credentials,
                        region: region,
                        url: url
                    }, operation, forward);
                    break;
                case $4f11aed3d4bbd44d$var$AUTH_TYPE.API_KEY:
                    var _b = auth.apiKey, apiKey = _b === void 0 ? '' : _b;
                    promise = $4f11aed3d4bbd44d$var$headerBasedAuth({
                        header: 'X-Api-Key',
                        value: apiKey
                    }, operation, forward);
                    break;
                case $4f11aed3d4bbd44d$var$AUTH_TYPE.AMAZON_COGNITO_USER_POOLS:
                case $4f11aed3d4bbd44d$var$AUTH_TYPE.OPENID_CONNECT:
                    var _c = auth.jwtToken, jwtToken = _c === void 0 ? '' : _c;
                    promise = $4f11aed3d4bbd44d$var$headerBasedAuth({
                        header: 'Authorization',
                        value: jwtToken
                    }, operation, forward);
                    break;
                default:
                    var error = new Error("Invalid AUTH_TYPE: " + auth.type);
                    throw error;
            }
            promise.then(function(observable) {
                handle = observable.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
};
var $4f11aed3d4bbd44d$var$formatAsRequest = function(_a, options) {
    var operationName = _a.operationName, variables = _a.variables, query = _a.query;
    var body = {
        operationName: operationName,
        variables: $4f11aed3d4bbd44d$var$removeTemporaryVariables(variables),
        query: $1e1d9b3d0a6f8566$exports.print(query)
    };
    return $4f11aed3d4bbd44d$var$__assign($4f11aed3d4bbd44d$var$__assign({
        body: JSON.stringify(body),
        method: 'POST'
    }, options), {
        headers: $4f11aed3d4bbd44d$var$__assign({
            accept: '*/*',
            'content-type': 'application/json; charset=UTF-8'
        }, options.headers)
    });
};
/**
 * Removes all temporary variables (starting with '@@') so that the signature matches the final request.
 */ var $4f11aed3d4bbd44d$var$removeTemporaryVariables = function(variables) {
    return Object.keys(variables).filter(function(key) {
        return !key.startsWith("@@");
    }).reduce(function(acc, key) {
        acc[key] = variables[key];
        return acc;
    }, {});
};


$1672a4b8783b587e$exports.AuthLink = $4f11aed3d4bbd44d$exports.AuthLink;
$1672a4b8783b587e$exports.AUTH_TYPE = $4f11aed3d4bbd44d$exports.AUTH_TYPE;
$1672a4b8783b587e$exports.USER_AGENT_HEADER = $4f11aed3d4bbd44d$exports.USER_AGENT_HEADER;
$1672a4b8783b587e$exports.USER_AGENT = $4f11aed3d4bbd44d$exports.USER_AGENT;
$1672a4b8783b587e$exports.createAuthLink = function(_a) {
    var url = _a.url, region = _a.region, auth = _a.auth;
    return new $4f11aed3d4bbd44d$exports.AuthLink({
        url: url,
        region: region,
        auth: auth
    });
};

$1672a4b8783b587e$exports.Signer = $7abddbdc01c27e70$exports.Signer;


var $7f42520b6e9d7224$exports = {};
"use strict";
var $7f42520b6e9d7224$var$__rest = $7f42520b6e9d7224$exports && $7f42520b6e9d7224$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($7f42520b6e9d7224$exports, "__esModule", {
    value: true
});
$7f42520b6e9d7224$exports.createSubscriptionHandshakeLink = $7f42520b6e9d7224$exports.CONTROL_EVENTS_KEY = void 0;
var $f6539c95c5f2a32a$exports = {};
"use strict";
var $f6539c95c5f2a32a$var$__extends = $f6539c95c5f2a32a$exports && $f6539c95c5f2a32a$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f6539c95c5f2a32a$var$__assign = $f6539c95c5f2a32a$exports && $f6539c95c5f2a32a$exports.__assign || function() {
    $f6539c95c5f2a32a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6539c95c5f2a32a$var$__assign.apply(this, arguments);
};
var $f6539c95c5f2a32a$var$__awaiter = $f6539c95c5f2a32a$exports && $f6539c95c5f2a32a$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f6539c95c5f2a32a$var$__generator = $f6539c95c5f2a32a$exports && $f6539c95c5f2a32a$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f6539c95c5f2a32a$var$__rest = $f6539c95c5f2a32a$exports && $f6539c95c5f2a32a$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($f6539c95c5f2a32a$exports, "__esModule", {
    value: true
});
$f6539c95c5f2a32a$exports.SubscriptionHandshakeLink = $f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY = void 0;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e1a311bc8034de19$var$extendStatics = function(d, b) {
    $e1a311bc8034de19$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e1a311bc8034de19$var$extendStatics(d, b);
};
function $e1a311bc8034de19$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e1a311bc8034de19$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e1a311bc8034de19$export$18ce0697a983be9b = function() {
    $e1a311bc8034de19$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e1a311bc8034de19$export$18ce0697a983be9b.apply(this, arguments);
};
function $e1a311bc8034de19$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e1a311bc8034de19$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e1a311bc8034de19$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e1a311bc8034de19$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e1a311bc8034de19$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e1a311bc8034de19$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e1a311bc8034de19$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e1a311bc8034de19$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e1a311bc8034de19$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e1a311bc8034de19$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e1a311bc8034de19$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e1a311bc8034de19$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e1a311bc8034de19$export$45d3717a4c69092e(o, m, p);
}
function $e1a311bc8034de19$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e1a311bc8034de19$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e1a311bc8034de19$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e1a311bc8034de19$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e1a311bc8034de19$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e1a311bc8034de19$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e1a311bc8034de19$export$10c90e4f7922046c(v) {
    return this instanceof $e1a311bc8034de19$export$10c90e4f7922046c ? (this.v = v, this) : new $e1a311bc8034de19$export$10c90e4f7922046c(v);
}
function $e1a311bc8034de19$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e1a311bc8034de19$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e1a311bc8034de19$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e1a311bc8034de19$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e1a311bc8034de19$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e1a311bc8034de19$export$19a8beecd37a4c45 === "function" ? $e1a311bc8034de19$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e1a311bc8034de19$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e1a311bc8034de19$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e1a311bc8034de19$var$ownKeys = function(o) {
    $e1a311bc8034de19$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e1a311bc8034de19$var$ownKeys(o);
};
function $e1a311bc8034de19$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e1a311bc8034de19$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e1a311bc8034de19$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e1a311bc8034de19$var$__setModuleDefault(result, mod);
    return result;
}
function $e1a311bc8034de19$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e1a311bc8034de19$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e1a311bc8034de19$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e1a311bc8034de19$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e1a311bc8034de19$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e1a311bc8034de19$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e1a311bc8034de19$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e1a311bc8034de19$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e1a311bc8034de19$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e1a311bc8034de19$export$2e2bcd8739ae039 = {
    __extends: $e1a311bc8034de19$export$a8ba968b8961cb8a,
    __assign: $e1a311bc8034de19$export$18ce0697a983be9b,
    __rest: $e1a311bc8034de19$export$3c9a16f847548506,
    __decorate: $e1a311bc8034de19$export$29e00dfd3077644b,
    __param: $e1a311bc8034de19$export$d5ad3fd78186038f,
    __esDecorate: $e1a311bc8034de19$export$3a84e1ae4e97e9b0,
    __runInitializers: $e1a311bc8034de19$export$d831c04e792af3d,
    __propKey: $e1a311bc8034de19$export$6a2a36740a146cb8,
    __setFunctionName: $e1a311bc8034de19$export$d1a06452d3489bc7,
    __metadata: $e1a311bc8034de19$export$f1db080c865becb9,
    __awaiter: $e1a311bc8034de19$export$1050f835b63b671e,
    __generator: $e1a311bc8034de19$export$67ebef60e6f28a6,
    __createBinding: $e1a311bc8034de19$export$45d3717a4c69092e,
    __exportStar: $e1a311bc8034de19$export$f33643c0debef087,
    __values: $e1a311bc8034de19$export$19a8beecd37a4c45,
    __read: $e1a311bc8034de19$export$8d051b38c9118094,
    __spread: $e1a311bc8034de19$export$afc72e2116322959,
    __spreadArrays: $e1a311bc8034de19$export$6388937ca91ccae8,
    __spreadArray: $e1a311bc8034de19$export$1216008129fb82ed,
    __await: $e1a311bc8034de19$export$10c90e4f7922046c,
    __asyncGenerator: $e1a311bc8034de19$export$e427f37a30a4de9b,
    __asyncDelegator: $e1a311bc8034de19$export$bbd80228419bb833,
    __asyncValues: $e1a311bc8034de19$export$e3b29a3d6162315f,
    __makeTemplateObject: $e1a311bc8034de19$export$4fb47efe1390b86f,
    __importStar: $e1a311bc8034de19$export$c21735bcef00d192,
    __importDefault: $e1a311bc8034de19$export$da59b14a69baef04,
    __classPrivateFieldGet: $e1a311bc8034de19$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e1a311bc8034de19$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e1a311bc8034de19$export$81fdc39f203e4e04,
    __addDisposableResource: $e1a311bc8034de19$export$88ac25d8e944e405,
    __disposeResources: $e1a311bc8034de19$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e1a311bc8034de19$export$889dfb5d17574b0b
};


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d8450ab9c8d54cc7$var$extendStatics = function(d, b) {
    $d8450ab9c8d54cc7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d8450ab9c8d54cc7$var$extendStatics(d, b);
};
function $d8450ab9c8d54cc7$export$a8ba968b8961cb8a(d, b) {
    $d8450ab9c8d54cc7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d8450ab9c8d54cc7$export$18ce0697a983be9b = function() {
    $d8450ab9c8d54cc7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d8450ab9c8d54cc7$export$18ce0697a983be9b.apply(this, arguments);
};
function $d8450ab9c8d54cc7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d8450ab9c8d54cc7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d8450ab9c8d54cc7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d8450ab9c8d54cc7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d8450ab9c8d54cc7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d8450ab9c8d54cc7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d8450ab9c8d54cc7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d8450ab9c8d54cc7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d8450ab9c8d54cc7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d8450ab9c8d54cc7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d8450ab9c8d54cc7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d8450ab9c8d54cc7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d8450ab9c8d54cc7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d8450ab9c8d54cc7$export$10c90e4f7922046c(v) {
    return this instanceof $d8450ab9c8d54cc7$export$10c90e4f7922046c ? (this.v = v, this) : new $d8450ab9c8d54cc7$export$10c90e4f7922046c(v);
}
function $d8450ab9c8d54cc7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8450ab9c8d54cc7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d8450ab9c8d54cc7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8450ab9c8d54cc7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d8450ab9c8d54cc7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d8450ab9c8d54cc7$export$19a8beecd37a4c45 === "function" ? $d8450ab9c8d54cc7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d8450ab9c8d54cc7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d8450ab9c8d54cc7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d8450ab9c8d54cc7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d8450ab9c8d54cc7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d8450ab9c8d54cc7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $110a5fad09111db0$var$global = (0, $6e6802d8caa12845$export$2e2bcd8739ae039);
var $110a5fad09111db0$var$console = $110a5fad09111db0$var$global.console;
var $110a5fad09111db0$var$genericMessage = "Invariant Violation";
var $110a5fad09111db0$var$_a = Object.setPrototypeOf, $110a5fad09111db0$var$setPrototypeOf = $110a5fad09111db0$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $110a5fad09111db0$var$_a;
var $110a5fad09111db0$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $d8450ab9c8d54cc7$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $110a5fad09111db0$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $110a5fad09111db0$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $110a5fad09111db0$var$genericMessage;
        $110a5fad09111db0$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $110a5fad09111db0$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $110a5fad09111db0$export$cea12affaee22fe8(message);
}
var $110a5fad09111db0$var$verbosityLevels = [
    "log",
    "warn",
    "error",
    "silent"
];
var $110a5fad09111db0$var$verbosityLevel = $110a5fad09111db0$var$verbosityLevels.indexOf("log");
function $110a5fad09111db0$var$wrapConsoleMethod(method) {
    return function() {
        if ($110a5fad09111db0$var$verbosityLevels.indexOf(method) >= $110a5fad09111db0$var$verbosityLevel) return $110a5fad09111db0$var$console[method].apply($110a5fad09111db0$var$console, arguments);
    };
}
(function(invariant) {
    invariant.log = $110a5fad09111db0$var$wrapConsoleMethod("log");
    invariant.warn = $110a5fad09111db0$var$wrapConsoleMethod("warn");
    invariant.error = $110a5fad09111db0$var$wrapConsoleMethod("error");
})($110a5fad09111db0$export$f5708dca728d7177 || ($110a5fad09111db0$export$f5708dca728d7177 = {}));
function $110a5fad09111db0$export$a80e09f2cd325fb8(level) {
    var old = $110a5fad09111db0$var$verbosityLevels[$110a5fad09111db0$var$verbosityLevel];
    $110a5fad09111db0$var$verbosityLevel = Math.max(0, $110a5fad09111db0$var$verbosityLevels.indexOf(level));
    return old;
}
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $110a5fad09111db0$export$e54fe5b0f43758f7 = $110a5fad09111db0$var$global.process || {
    env: {}
};
if (!$110a5fad09111db0$var$global.process) try {
    Object.defineProperty((0, $6e6802d8caa12845$export$2e2bcd8739ae039), "process", {
        value: $110a5fad09111db0$export$e54fe5b0f43758f7,
        writable: true,
        enumerable: false,
        configurable: true
    });
} catch (_b) {
// If this fails, it isn't the end of the world.
}
var $110a5fad09111db0$var$invariant$1 = $110a5fad09111db0$export$f5708dca728d7177;
var $110a5fad09111db0$export$2e2bcd8739ae039 = $110a5fad09111db0$var$invariant$1;


var $db4d4846f4f16e03$export$83d89fbfd8236492 = "3.14.1";


function $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $07fdd70bb5002750$export$2e2bcd8739ae039 = (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $ba889b1a848874b3$var$prefixCounts = new Map();
function $ba889b1a848874b3$export$d0c8ec0fe1b18b70(prefix) {
    var count = $ba889b1a848874b3$var$prefixCounts.get(prefix) || 1;
    $ba889b1a848874b3$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $b4b94e90f3a612fe$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $ba889b1a848874b3$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $2eb7c81495a30e7e$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $2eb7c81495a30e7e$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $2eb7c81495a30e7e$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $2eb7c81495a30e7e$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $110a5fad09111db0$export$f5708dca728d7177)(condition, $2eb7c81495a30e7e$var$getHandledErrorMsg(message, args) || $2eb7c81495a30e7e$var$getFallbackErrorMsg(message, args));
}, {
    debug: $2eb7c81495a30e7e$var$wrap((0, $110a5fad09111db0$export$f5708dca728d7177).debug),
    log: $2eb7c81495a30e7e$var$wrap((0, $110a5fad09111db0$export$f5708dca728d7177).log),
    warn: $2eb7c81495a30e7e$var$wrap((0, $110a5fad09111db0$export$f5708dca728d7177).warn),
    error: $2eb7c81495a30e7e$var$wrap((0, $110a5fad09111db0$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $2eb7c81495a30e7e$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $110a5fad09111db0$export$cea12affaee22fe8)($2eb7c81495a30e7e$var$getHandledErrorMsg(message, optionalParams) || $2eb7c81495a30e7e$var$getFallbackErrorMsg(message, optionalParams));
}
var $2eb7c81495a30e7e$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $db4d4846f4f16e03$export$83d89fbfd8236492));
function $2eb7c81495a30e7e$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $b4b94e90f3a612fe$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $2eb7c81495a30e7e$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $07fdd70bb5002750$export$2e2bcd8739ae039)[$2eb7c81495a30e7e$export$b8ca975fa04efdf3] && (0, $07fdd70bb5002750$export$2e2bcd8739ae039)[$2eb7c81495a30e7e$export$b8ca975fa04efdf3](message, messageArgs.map($2eb7c81495a30e7e$var$stringify));
}
function $2eb7c81495a30e7e$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $db4d4846f4f16e03$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($2eb7c81495a30e7e$var$stringify)
    })));
}




var $81281483e596a241$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;


function $eb1b7151939a7f3b$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $eb1b7151939a7f3b$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}


var $b937ee76313d8ee6$export$4995664c1b49842e = Symbol();
function $b937ee76313d8ee6$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$b937ee76313d8ee6$export$4995664c1b49842e]);
    return false;
}
function $b937ee76313d8ee6$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $b937ee76313d8ee6$var$generateErrorMessage = function(err) {
    var errors = (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $eb1b7151939a7f3b$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $b937ee76313d8ee6$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $e1a311bc8034de19$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $b937ee76313d8ee6$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);


function $5b50e19789d289fa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5b50e19789d289fa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b50e19789d289fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5b50e19789d289fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5b50e19789d289fa$var$_arrayLikeToArray(o, minLen);
}
function $5b50e19789d289fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5b50e19789d289fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5b50e19789d289fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5b50e19789d289fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5b50e19789d289fa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $5b50e19789d289fa$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $5b50e19789d289fa$var$hasSymbol = function(name) {
    return $5b50e19789d289fa$var$hasSymbols() && Boolean(Symbol[name]);
};
var $5b50e19789d289fa$var$getSymbol = function(name) {
    return $5b50e19789d289fa$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($5b50e19789d289fa$var$hasSymbols() && !$5b50e19789d289fa$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $5b50e19789d289fa$var$SymbolIterator = $5b50e19789d289fa$var$getSymbol('iterator');
var $5b50e19789d289fa$var$SymbolObservable = $5b50e19789d289fa$var$getSymbol('observable');
var $5b50e19789d289fa$var$SymbolSpecies = $5b50e19789d289fa$var$getSymbol('species'); // === Abstract Operations ===
function $5b50e19789d289fa$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $5b50e19789d289fa$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$5b50e19789d289fa$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $5b50e19789d289fa$export$77cea355fa80b5f4;
}
function $5b50e19789d289fa$var$isObservable(x) {
    return x instanceof $5b50e19789d289fa$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $5b50e19789d289fa$var$hostReportError(e) {
    if ($5b50e19789d289fa$var$hostReportError.log) $5b50e19789d289fa$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $5b50e19789d289fa$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $5b50e19789d289fa$var$hostReportError(e);
        }
    });
}
function $5b50e19789d289fa$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $5b50e19789d289fa$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $5b50e19789d289fa$var$hostReportError(e);
    }
}
function $5b50e19789d289fa$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $5b50e19789d289fa$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $5b50e19789d289fa$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $5b50e19789d289fa$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $5b50e19789d289fa$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $5b50e19789d289fa$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $5b50e19789d289fa$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $5b50e19789d289fa$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $5b50e19789d289fa$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $5b50e19789d289fa$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $5b50e19789d289fa$var$enqueue(function() {
            return $5b50e19789d289fa$var$flushSubscription(subscription);
        });
        return;
    }
    $5b50e19789d289fa$var$notifySubscription(subscription, type, value);
}
var $5b50e19789d289fa$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $5b50e19789d289fa$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $5b50e19789d289fa$var$closeSubscription(this);
            $5b50e19789d289fa$var$cleanupSubscription(this);
        }
    };
    $5b50e19789d289fa$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $5b50e19789d289fa$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $5b50e19789d289fa$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $5b50e19789d289fa$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $5b50e19789d289fa$var$onNotify(this._subscription, 'complete');
    };
    $5b50e19789d289fa$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $5b50e19789d289fa$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $5b50e19789d289fa$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $5b50e19789d289fa$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $5b50e19789d289fa$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $5b50e19789d289fa$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $5b50e19789d289fa$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $5b50e19789d289fa$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$5b50e19789d289fa$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $5b50e19789d289fa$var$getMethod(x, $5b50e19789d289fa$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($5b50e19789d289fa$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($5b50e19789d289fa$var$hasSymbol('iterator')) {
            method = $5b50e19789d289fa$var$getMethod(x, $5b50e19789d289fa$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $5b50e19789d289fa$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $5b50e19789d289fa$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $5b50e19789d289fa$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $5b50e19789d289fa$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $5b50e19789d289fa$var$_createClass(Observable, null, [
        {
            key: $5b50e19789d289fa$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($5b50e19789d289fa$var$hasSymbols()) Object.defineProperty($5b50e19789d289fa$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $5b50e19789d289fa$var$SymbolObservable,
        hostReportError: $5b50e19789d289fa$var$hostReportError
    },
    configurable: true
});


parcelRequire("5VL3l");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $2f4ad3d2bc87c0f5$var$prototype = (0, $5b50e19789d289fa$export$77cea355fa80b5f4).prototype;
var $2f4ad3d2bc87c0f5$var$fakeObsSymbol = "@@observable";
if (!$2f4ad3d2bc87c0f5$var$prototype[$2f4ad3d2bc87c0f5$var$fakeObsSymbol]) // @ts-expect-error
$2f4ad3d2bc87c0f5$var$prototype[$2f4ad3d2bc87c0f5$var$fakeObsSymbol] = function() {
    return this;
};




// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $d4a0e367eca3bf36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $d4a0e367eca3bf36$var$MISSING_VALUE = {};
let $d4a0e367eca3bf36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $d4a0e367eca3bf36$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $d4a0e367eca3bf36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $d4a0e367eca3bf36$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $d4a0e367eca3bf36$var$MISSING_VALUE) break;
                if (context !== $d4a0e367eca3bf36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $d4a0e367eca3bf36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($d4a0e367eca3bf36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $d4a0e367eca3bf36$var$currentContext.slots[this.id] = $d4a0e367eca3bf36$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $d4a0e367eca3bf36$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $d4a0e367eca3bf36$var$currentContext;
            $d4a0e367eca3bf36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $d4a0e367eca3bf36$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $d4a0e367eca3bf36$var$currentContext;
            return function() {
                const saved = $d4a0e367eca3bf36$var$currentContext;
                try {
                    $d4a0e367eca3bf36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $d4a0e367eca3bf36$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($d4a0e367eca3bf36$var$currentContext) {
                const saved = $d4a0e367eca3bf36$var$currentContext;
                try {
                    $d4a0e367eca3bf36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $d4a0e367eca3bf36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $d4a0e367eca3bf36$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $d4a0e367eca3bf36$var$globalKey = "@wry/context:Slot";
const $d4a0e367eca3bf36$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$d4a0e367eca3bf36$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$d4a0e367eca3bf36$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $d4a0e367eca3bf36$var$globalHost = $d4a0e367eca3bf36$var$host;
const $d4a0e367eca3bf36$export$8c6ed5c666ac1360 = $d4a0e367eca3bf36$var$globalHost[$d4a0e367eca3bf36$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$d4a0e367eca3bf36$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($d4a0e367eca3bf36$var$globalHost, $d4a0e367eca3bf36$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($d4a0e367eca3bf36$var$makeSlotClass());


const { bind: $903470d24586a01b$export$2385a24977818dd0, noContext: $903470d24586a01b$export$9fa6f2e300a97f8 } = (0, $d4a0e367eca3bf36$export$8c6ed5c666ac1360);
function $903470d24586a01b$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($903470d24586a01b$export$2385a24977818dd0(callback), delay);
}
function $903470d24586a01b$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $903470d24586a01b$export$2385a24977818dd0(gen.next);
        const boundThrow = $903470d24586a01b$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($903470d24586a01b$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $903470d24586a01b$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $903470d24586a01b$var$wrappedFibers = [];
function $903470d24586a01b$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($903470d24586a01b$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $903470d24586a01b$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $903470d24586a01b$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $25a7215e27201dfb$export$11fa9682b6ba79b1 = new (0, $d4a0e367eca3bf36$export$8c6ed5c666ac1360)();
function $25a7215e27201dfb$export$d906efd39458576(fn) {
    return $25a7215e27201dfb$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $c6e8f08c1e766ffc$export$5a15a386532a5ea4 } = Object.prototype;
const $c6e8f08c1e766ffc$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $c6e8f08c1e766ffc$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $2b61addd6410ff8e$var$emptySetPool = [];
const $2b61addd6410ff8e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $2b61addd6410ff8e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $2b61addd6410ff8e$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $2b61addd6410ff8e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $2b61addd6410ff8e$var$valueCopy(value) {
    return value.slice(0);
}
class $2b61addd6410ff8e$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$2b61addd6410ff8e$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$2b61addd6410ff8e$var$mightBeDirty(this)) {
            $2b61addd6410ff8e$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $2b61addd6410ff8e$var$assert(!this.recomputing, "already recomputing");
        $2b61addd6410ff8e$var$rememberParent(this);
        return $2b61addd6410ff8e$var$mightBeDirty(this) ? $2b61addd6410ff8e$var$reallyRecompute(this, args) : $2b61addd6410ff8e$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $2b61addd6410ff8e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $c6e8f08c1e766ffc$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $2b61addd6410ff8e$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $2b61addd6410ff8e$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $2b61addd6410ff8e$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $2b61addd6410ff8e$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $c6e8f08c1e766ffc$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $2b61addd6410ff8e$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$2b61addd6410ff8e$export$3bb977b3ba9d3b59.count = 0;
function $2b61addd6410ff8e$var$rememberParent(child) {
    const parent = (0, $25a7215e27201dfb$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($2b61addd6410ff8e$var$mightBeDirty(child)) $2b61addd6410ff8e$var$reportDirtyChild(parent, child);
        else $2b61addd6410ff8e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $2b61addd6410ff8e$var$reallyRecompute(entry, args) {
    $2b61addd6410ff8e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $25a7215e27201dfb$export$11fa9682b6ba79b1).withValue(entry, $2b61addd6410ff8e$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($2b61addd6410ff8e$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $2b61addd6410ff8e$var$setClean(entry);
    return $2b61addd6410ff8e$var$valueGet(entry.value);
}
function $2b61addd6410ff8e$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $2b61addd6410ff8e$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$2b61addd6410ff8e$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $2b61addd6410ff8e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $2b61addd6410ff8e$var$setClean(entry) {
    entry.dirty = false;
    if ($2b61addd6410ff8e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $2b61addd6410ff8e$var$reportClean(entry);
}
function $2b61addd6410ff8e$var$reportDirty(child) {
    $2b61addd6410ff8e$var$eachParent(child, $2b61addd6410ff8e$var$reportDirtyChild);
}
function $2b61addd6410ff8e$var$reportClean(child) {
    $2b61addd6410ff8e$var$eachParent(child, $2b61addd6410ff8e$var$reportCleanChild);
}
function $2b61addd6410ff8e$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $c6e8f08c1e766ffc$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $2b61addd6410ff8e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $2b61addd6410ff8e$var$assert(parent.childValues.has(child));
    $2b61addd6410ff8e$var$assert($2b61addd6410ff8e$var$mightBeDirty(child));
    const parentWasClean = !$2b61addd6410ff8e$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $2b61addd6410ff8e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $2b61addd6410ff8e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $2b61addd6410ff8e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $2b61addd6410ff8e$var$assert(parent.childValues.has(child));
    $2b61addd6410ff8e$var$assert(!$2b61addd6410ff8e$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $2b61addd6410ff8e$var$valueCopy(child.value));
    else if (!$2b61addd6410ff8e$var$valueIs(childValue, child.value)) parent.setDirty();
    $2b61addd6410ff8e$var$removeDirtyChild(parent, child);
    if ($2b61addd6410ff8e$var$mightBeDirty(parent)) return;
    $2b61addd6410ff8e$var$reportClean(parent);
}
function $2b61addd6410ff8e$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($2b61addd6410ff8e$var$emptySetPool.length < $2b61addd6410ff8e$var$POOL_TARGET_SIZE) $2b61addd6410ff8e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $2b61addd6410ff8e$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $2b61addd6410ff8e$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $2b61addd6410ff8e$var$assert(parent.dirtyChildren === null);
}
function $2b61addd6410ff8e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $2b61addd6410ff8e$var$removeDirtyChild(parent, child);
}
function $2b61addd6410ff8e$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $c6e8f08c1e766ffc$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $877ca69549d793e0$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $877ca69549d793e0$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $25a7215e27201dfb$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $c6e8f08c1e766ffc$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $c6e8f08c1e766ffc$export$5a15a386532a5ea4).call($877ca69549d793e0$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $c6e8f08c1e766ffc$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $c6e8f08c1e766ffc$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $4dce6137c9a98ad9$var$defaultKeyTrie;
function $4dce6137c9a98ad9$export$cd3144f8dd136006(...args) {
    const trie = $4dce6137c9a98ad9$var$defaultKeyTrie || ($4dce6137c9a98ad9$var$defaultKeyTrie = new (0, $00d96d3ddd396725$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $4dce6137c9a98ad9$var$caches = new Set();
function $4dce6137c9a98ad9$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $4dce6137c9a98ad9$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $2b61addd6410ff8e$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $4dce6137c9a98ad9$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $25a7215e27201dfb$export$11fa9682b6ba79b1).hasValue()) {
            $4dce6137c9a98ad9$var$caches.forEach((cache)=>cache.clean());
            $4dce6137c9a98ad9$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $5fda202f800562be$var$_a;
var $5fda202f800562be$var$muteAllDeprecations = Symbol.for("apollo.deprecations");
var $5fda202f800562be$var$deprecationsSlot = Symbol.for("apollo.deprecations.slot");
var $5fda202f800562be$var$global = (0, $07fdd70bb5002750$export$2e2bcd8739ae039);
var $5fda202f800562be$var$slot = ($5fda202f800562be$var$_a = $5fda202f800562be$var$global[$5fda202f800562be$var$deprecationsSlot]) !== null && $5fda202f800562be$var$_a !== void 0 ? $5fda202f800562be$var$_a : $5fda202f800562be$var$global[$5fda202f800562be$var$deprecationsSlot] = new (0, $d4a0e367eca3bf36$export$8c6ed5c666ac1360)();
function $5fda202f800562be$var$isMuted(name) {
    return $5fda202f800562be$var$global[$5fda202f800562be$var$muteAllDeprecations] || ($5fda202f800562be$var$slot.getValue() || []).includes(name);
}
function $5fda202f800562be$export$d18d1529326946c4(name) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $5fda202f800562be$var$slot.withValue.apply($5fda202f800562be$var$slot, (0, $e1a311bc8034de19$export$1216008129fb82ed)([
        Array.isArray(name) ? name : [
            name
        ]
    ], args, false));
}
function $5fda202f800562be$export$6d0d09df4c29a84a(options, name, callSite, recommendation) {
    if (recommendation === void 0) recommendation = "Please remove this option.";
    $5fda202f800562be$export$606a5c06d13e04b6(name, function() {
        if (name in options) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(103, callSite, name, recommendation);
    });
}
function $5fda202f800562be$export$606a5c06d13e04b6(name, cb) {
    if (!$5fda202f800562be$var$isMuted(name)) cb();
}



function $6fa2d8209ec0d355$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}







function $c6a6aa3a7c270c22$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(112, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(fragments.length === 1, 113, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $e1a311bc8034de19$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $c6a6aa3a7c270c22$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $c6a6aa3a7c270c22$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(fragment, 114, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $c6a6aa3a7c270c22$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $0f36c934b7f2a151$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}



var $ecbc49d50bf3b336$var$scheduledCleanup = new WeakSet();
function $ecbc49d50bf3b336$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$ecbc49d50bf3b336$var$scheduledCleanup.has(cache)) {
        $ecbc49d50bf3b336$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $ecbc49d50bf3b336$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $ecbc49d50bf3b336$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $0bb0b818d41c35d5$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $0bb0b818d41c35d5$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $ecbc49d50bf3b336$var$schedule(this);
        return ret;
    };
    return cache;
};
var $ecbc49d50bf3b336$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $4491d36e18dba4b0$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $ecbc49d50bf3b336$var$schedule(this);
        return ret;
    };
    return cache;
};



var $5ee7d26f5ccf9fde$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $5ee7d26f5ccf9fde$export$f29926b23b28936b = (0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, (0, $07fdd70bb5002750$export$2e2bcd8739ae039)[$5ee7d26f5ccf9fde$var$cacheSizeSymbol]);




var $1b3de6a864a1d125$var$globalCaches = {};
function $1b3de6a864a1d125$export$a8fcd406d9e37621(name, getSize) {
    $1b3de6a864a1d125$var$globalCaches[name] = getSize;
}
var $1b3de6a864a1d125$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $1b3de6a864a1d125$var$_getApolloClientMemoryInternals : undefined;
var $1b3de6a864a1d125$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $1b3de6a864a1d125$var$_getInMemoryCacheMemoryInternals : undefined;
var $1b3de6a864a1d125$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $1b3de6a864a1d125$var$_getApolloCacheMemoryInternals : undefined;
function $1b3de6a864a1d125$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $5ee7d26f5ccf9fde$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $1b3de6a864a1d125$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $1b3de6a864a1d125$var$getCurrentCacheSizes(),
        sizes: (0, $e1a311bc8034de19$export$18ce0697a983be9b)({
            print: (_a = $1b3de6a864a1d125$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($1b3de6a864a1d125$var$globalCaches),
            parser: (_b = $1b3de6a864a1d125$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($1b3de6a864a1d125$var$globalCaches),
            canonicalStringify: (_c = $1b3de6a864a1d125$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($1b3de6a864a1d125$var$globalCaches),
            links: $1b3de6a864a1d125$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $1b3de6a864a1d125$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $1b3de6a864a1d125$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $1b3de6a864a1d125$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $1b3de6a864a1d125$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, $1b3de6a864a1d125$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $1b3de6a864a1d125$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $1b3de6a864a1d125$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $1b3de6a864a1d125$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $1b3de6a864a1d125$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $1b3de6a864a1d125$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $1b3de6a864a1d125$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $1b3de6a864a1d125$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $1b3de6a864a1d125$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $1b3de6a864a1d125$var$getWrapperInformation(f) {
    return $1b3de6a864a1d125$var$isWrapper(f) ? f.size : undefined;
}
function $1b3de6a864a1d125$var$isDefined(value) {
    return value != null;
}
function $1b3de6a864a1d125$var$transformInfo(transform) {
    return $1b3de6a864a1d125$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $1b3de6a864a1d125$var$recurseTransformInfo(transform) {
    return transform ? (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([
        $1b3de6a864a1d125$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $1b3de6a864a1d125$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $1b3de6a864a1d125$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($1b3de6a864a1d125$var$isDefined) : [];
}
function $1b3de6a864a1d125$var$linkInfo(link) {
    var _a;
    return link ? (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $1b3de6a864a1d125$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $1b3de6a864a1d125$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($1b3de6a864a1d125$var$isDefined) : [];
}


var $34add3d77e5e6904$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $34add3d77e5e6904$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $34add3d77e5e6904$var$sortingMap = new (0, $ecbc49d50bf3b336$export$5b4f745137d91413)((0, $5ee7d26f5ccf9fde$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $1b3de6a864a1d125$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $34add3d77e5e6904$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $34add3d77e5e6904$var$sortingMap;
$34add3d77e5e6904$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $34add3d77e5e6904$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($34add3d77e5e6904$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $34add3d77e5e6904$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $34add3d77e5e6904$var$sortingMap.get(sortedKey) || keys;
                $34add3d77e5e6904$var$sortingMap.set(unsortedKey, sortedKeys);
                $34add3d77e5e6904$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $34add3d77e5e6904$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $60e5b25a31d8fc3c$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $60e5b25a31d8fc3c$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $60e5b25a31d8fc3c$export$540432d49fcec6c9(value) {
    return (0, $eb1b7151939a7f3b$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $60e5b25a31d8fc3c$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $60e5b25a31d8fc3c$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $60e5b25a31d8fc3c$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $60e5b25a31d8fc3c$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $60e5b25a31d8fc3c$var$isVariable(value) {
    return value.kind === "Variable";
}
function $60e5b25a31d8fc3c$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $60e5b25a31d8fc3c$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $60e5b25a31d8fc3c$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $60e5b25a31d8fc3c$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $60e5b25a31d8fc3c$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($60e5b25a31d8fc3c$var$isIntValue(value) || $60e5b25a31d8fc3c$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($60e5b25a31d8fc3c$var$isBooleanValue(value) || $60e5b25a31d8fc3c$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($60e5b25a31d8fc3c$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $60e5b25a31d8fc3c$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($60e5b25a31d8fc3c$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($60e5b25a31d8fc3c$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $60e5b25a31d8fc3c$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($60e5b25a31d8fc3c$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($60e5b25a31d8fc3c$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(123, name.value, value.kind);
}
function $60e5b25a31d8fc3c$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $60e5b25a31d8fc3c$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $60e5b25a31d8fc3c$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $60e5b25a31d8fc3c$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $60e5b25a31d8fc3c$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $60e5b25a31d8fc3c$var$storeKeyNameStringify = (0, $34add3d77e5e6904$export$88a0ad9b6f961b51);
var $60e5b25a31d8fc3c$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($60e5b25a31d8fc3c$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $60e5b25a31d8fc3c$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($60e5b25a31d8fc3c$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($60e5b25a31d8fc3c$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $60e5b25a31d8fc3c$var$storeKeyNameStringify;
        $60e5b25a31d8fc3c$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $60e5b25a31d8fc3c$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $60e5b25a31d8fc3c$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $60e5b25a31d8fc3c$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $60e5b25a31d8fc3c$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($60e5b25a31d8fc3c$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$60e5b25a31d8fc3c$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $60e5b25a31d8fc3c$export$cf7bf7e4f289cc26(result, (0, $c6a6aa3a7c270c22$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $60e5b25a31d8fc3c$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $60e5b25a31d8fc3c$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $bdcb7f3ac338176f$export$a7d0d8111d2386df(doc) {
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(doc && doc.kind === "Document", 115);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(116, definition.kind);
        return definition;
    });
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(operations.length <= 1, 117, operations.length);
    return doc;
}
function $bdcb7f3ac338176f$export$7a5b1fa979d2c158(doc) {
    $bdcb7f3ac338176f$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $bdcb7f3ac338176f$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $bdcb7f3ac338176f$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $bdcb7f3ac338176f$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $bdcb7f3ac338176f$export$7a5b1fa979d2c158(doc);
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 118);
    return queryDef;
}
function $bdcb7f3ac338176f$export$772111caef41b3f5(doc) {
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(doc.kind === "Document", 119);
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(doc.definitions.length <= 1, 120);
    var fragmentDef = doc.definitions[0];
    (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 121);
    return fragmentDef;
}
function $bdcb7f3ac338176f$export$f431198736b7f96d(queryDoc) {
    $bdcb7f3ac338176f$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(122);
}
function $bdcb7f3ac338176f$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $60e5b25a31d8fc3c$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $d360d05b974572dc$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $bdcb7f3ac338176f$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $1dc6c6390d4ecb0d$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(58, key);
    }
    return operation;
}


function $24e18527a43b07a2$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
}
function $24e18527a43b07a2$var$toLink(handler) {
    return typeof handler === "function" ? new $24e18527a43b07a2$export$2fed3d61f740bc7f(handler) : handler;
}
function $24e18527a43b07a2$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $24e18527a43b07a2$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($24e18527a43b07a2$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $24e18527a43b07a2$var$toLink(left);
        var rightLink = $24e18527a43b07a2$var$toLink(right || new ApolloLink($24e18527a43b07a2$var$passthrough));
        var ret;
        if ($24e18527a43b07a2$var$isTerminating(leftLink) && $24e18527a43b07a2$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $6fa2d8209ec0d355$export$f29bedd62f56fcb2)(operation.context, (0, $d360d05b974572dc$export$4f3f7df1b558c729)((0, $1dc6c6390d4ecb0d$export$a92a48117d546c9)(operation)))) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $24e18527a43b07a2$var$toLink(first);
        if ($24e18527a43b07a2$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(47, firstLink);
            return firstLink;
        }
        var nextLink = $24e18527a43b07a2$var$toLink(second);
        var ret;
        if ($24e18527a43b07a2$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
            }) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
            }) || (0, $5b50e19789d289fa$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($24e18527a43b07a2$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(48);
    };
    /**
     * @deprecated `onError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.onError = function(error, observer) {
        if (globalThis.__DEV__ !== false) (0, $5fda202f800562be$export$606a5c06d13e04b6)("onError", function() {
            globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(49);
        });
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    /**
     * @deprecated `setOnError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.setOnError = function(fn) {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(50);
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $573cfb6c72c1b335$exports = {};
"use strict";
Object.defineProperty($573cfb6c72c1b335$exports, "__esModule", {
    value: true
});
var $71637e952cf38065$exports = {};
"use strict";
var $71637e952cf38065$var$__spreadArrays = $71637e952cf38065$exports && $71637e952cf38065$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($71637e952cf38065$exports, "__esModule", {
    value: true
});

var $lvH3K = parcelRequire("lvH3K");
var $71637e952cf38065$var$debugLogger = $lvH3K.default('aws-appsync');
var $71637e952cf38065$var$extend = function(category) {
    if (category === void 0) category = '';
    var newCategory = category ? $71637e952cf38065$var$__spreadArrays(this.namespace.split(':'), [
        category
    ]).join(':') : this.namespace;
    var result = $lvH3K.default(newCategory);
    result.extend = $71637e952cf38065$var$extend.bind(result);
    return result;
};
$71637e952cf38065$var$debugLogger.extend = $71637e952cf38065$var$extend.bind($71637e952cf38065$var$debugLogger);
$71637e952cf38065$exports.default = $71637e952cf38065$var$debugLogger;


Object.defineProperty($573cfb6c72c1b335$exports, "rootLogger", {
    enumerable: true,
    get: function() {
        return $71637e952cf38065$exports.default;
    }
});


var $0c32d268e8d918d9$exports = {};
/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/ // Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.
/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
client = new Paho.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  message = new Paho.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */ /* jshint shadow:true */ (function ExportLibrary(root, factory) {
    $0c32d268e8d918d9$exports = factory();
})($0c32d268e8d918d9$exports, function LibraryFactory() {
    var PahoMQTT = function(global1) {
        // Private variables below, these are only visible inside the function closure
        // which is used to define the module.
        var version = "@VERSION@-@BUILDLEVEL@";
        /**
	 * @private
	 */ var localStorage = global1.localStorage || function() {
            var data = {};
            return {
                setItem: function(key, item) {
                    data[key] = item;
                },
                getItem: function(key) {
                    return data[key];
                },
                removeItem: function(key) {
                    delete data[key];
                }
            };
        }();
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var MESSAGE_TYPE = {
            CONNECT: 1,
            CONNACK: 2,
            PUBLISH: 3,
            PUBACK: 4,
            PUBREC: 5,
            PUBREL: 6,
            PUBCOMP: 7,
            SUBSCRIBE: 8,
            SUBACK: 9,
            UNSUBSCRIBE: 10,
            UNSUBACK: 11,
            PINGREQ: 12,
            PINGRESP: 13,
            DISCONNECT: 14
        };
        // Collection of utility methods used to simplify module code
        // and promote the DRY pattern.
        /**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */ var validate = function(obj, keys) {
            for(var key in obj)if (obj.hasOwnProperty(key)) {
                if (keys.hasOwnProperty(key)) {
                    if (typeof obj[key] !== keys[key]) throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof obj[key],
                        key
                    ]));
                } else {
                    var errorStr = "Unknown property, " + key + ". Valid properties are:";
                    for(var validKey in keys)if (keys.hasOwnProperty(validKey)) errorStr = errorStr + " " + validKey;
                    throw new Error(errorStr);
                }
            }
        };
        /**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */ var scope = function(f, scope) {
            return function() {
                return f.apply(scope, arguments);
            };
        };
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var ERROR = {
            OK: {
                code: 0,
                text: "AMQJSC0000I OK."
            },
            CONNECT_TIMEOUT: {
                code: 1,
                text: "AMQJSC0001E Connect timed out."
            },
            SUBSCRIBE_TIMEOUT: {
                code: 2,
                text: "AMQJS0002E Subscribe timed out."
            },
            UNSUBSCRIBE_TIMEOUT: {
                code: 3,
                text: "AMQJS0003E Unsubscribe timed out."
            },
            PING_TIMEOUT: {
                code: 4,
                text: "AMQJS0004E Ping timed out."
            },
            INTERNAL_ERROR: {
                code: 5,
                text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"
            },
            CONNACK_RETURNCODE: {
                code: 6,
                text: "AMQJS0006E Bad Connack return code:{0} {1}."
            },
            SOCKET_ERROR: {
                code: 7,
                text: "AMQJS0007E Socket error:{0}."
            },
            SOCKET_CLOSE: {
                code: 8,
                text: "AMQJS0008I Socket closed."
            },
            MALFORMED_UTF: {
                code: 9,
                text: "AMQJS0009E Malformed UTF data:{0} {1} {2}."
            },
            UNSUPPORTED: {
                code: 10,
                text: "AMQJS0010E {0} is not supported by this browser."
            },
            INVALID_STATE: {
                code: 11,
                text: "AMQJS0011E Invalid state {0}."
            },
            INVALID_TYPE: {
                code: 12,
                text: "AMQJS0012E Invalid type {0} for {1}."
            },
            INVALID_ARGUMENT: {
                code: 13,
                text: "AMQJS0013E Invalid argument {0} for {1}."
            },
            UNSUPPORTED_OPERATION: {
                code: 14,
                text: "AMQJS0014E Unsupported operation."
            },
            INVALID_STORED_DATA: {
                code: 15,
                text: "AMQJS0015E Invalid data in local storage key={0} value={1}."
            },
            INVALID_MQTT_MESSAGE_TYPE: {
                code: 16,
                text: "AMQJS0016E Invalid MQTT message type {0}."
            },
            MALFORMED_UNICODE: {
                code: 17,
                text: "AMQJS0017E Malformed Unicode string:{0} {1}."
            },
            BUFFER_FULL: {
                code: 18,
                text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}."
            }
        };
        /** CONNACK RC Meaning. */ var CONNACK_RC = {
            0: "Connection Accepted",
            1: "Connection Refused: unacceptable protocol version",
            2: "Connection Refused: identifier rejected",
            3: "Connection Refused: server unavailable",
            4: "Connection Refused: bad user name or password",
            5: "Connection Refused: not authorized"
        };
        /**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */ var format = function(error, substitutions) {
            var text = error.text;
            if (substitutions) {
                var field, start;
                for(var i = 0; i < substitutions.length; i++){
                    field = "{" + i + "}";
                    start = text.indexOf(field);
                    if (start > 0) {
                        var part1 = text.substring(0, start);
                        var part2 = text.substring(start + field.length);
                        text = part1 + substitutions[i] + part2;
                    }
                }
            }
            return text;
        };
        //MQTT protocol and version          6    M    Q    I    s    d    p    3
        var MqttProtoIdentifierv3 = [
            0x00,
            0x06,
            0x4d,
            0x51,
            0x49,
            0x73,
            0x64,
            0x70,
            0x03
        ];
        //MQTT proto/version for 311         4    M    Q    T    T    4
        var MqttProtoIdentifierv4 = [
            0x00,
            0x04,
            0x4d,
            0x51,
            0x54,
            0x54,
            0x04
        ];
        /**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */ var WireMessage = function(type, options) {
            this.type = type;
            for(var name in options)if (options.hasOwnProperty(name)) this[name] = options[name];
        };
        WireMessage.prototype.encode = function() {
            // Compute the first byte of the fixed header
            var first = (this.type & 0x0f) << 4;
            /*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */ var remLength = 0;
            var topicStrLength = [];
            var destinationNameLength = 0;
            var willMessagePayloadBytes;
            // if the message contains a messageIdentifier then we need two bytes for that
            if (this.messageIdentifier !== undefined) remLength += 2;
            switch(this.type){
                // If this a Connect then we need to include 12 bytes for its header
                case MESSAGE_TYPE.CONNECT:
                    switch(this.mqttVersion){
                        case 3:
                            remLength += MqttProtoIdentifierv3.length + 3;
                            break;
                        case 4:
                            remLength += MqttProtoIdentifierv4.length + 3;
                            break;
                    }
                    remLength += UTF8Length(this.clientId) + 2;
                    if (this.willMessage !== undefined) {
                        remLength += UTF8Length(this.willMessage.destinationName) + 2;
                        // Will message is always a string, sent as UTF-8 characters with a preceding length.
                        willMessagePayloadBytes = this.willMessage.payloadBytes;
                        if (!(willMessagePayloadBytes instanceof Uint8Array)) willMessagePayloadBytes = new Uint8Array(payloadBytes);
                        remLength += willMessagePayloadBytes.byteLength + 2;
                    }
                    if (this.userName !== undefined) remLength += UTF8Length(this.userName) + 2;
                    if (this.password !== undefined) remLength += UTF8Length(this.password) + 2;
                    break;
                // Subscribe, Unsubscribe can both contain topic strings
                case MESSAGE_TYPE.SUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    remLength += this.requestedQos.length; // 1 byte for each topic's Qos
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    break;
                case MESSAGE_TYPE.PUBREL:
                    first |= 0x02; // Qos = 1;
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    if (this.payloadMessage.duplicate) first |= 0x08;
                    first = first |= this.payloadMessage.qos << 1;
                    if (this.payloadMessage.retained) first |= 0x01;
                    destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
                    remLength += destinationNameLength + 2;
                    var payloadBytes = this.payloadMessage.payloadBytes;
                    remLength += payloadBytes.byteLength;
                    if (payloadBytes instanceof ArrayBuffer) payloadBytes = new Uint8Array(payloadBytes);
                    else if (!(payloadBytes instanceof Uint8Array)) payloadBytes = new Uint8Array(payloadBytes.buffer);
                    break;
                case MESSAGE_TYPE.DISCONNECT:
                    break;
                default:
                    break;
            }
            // Now we can allocate a buffer for the message
            var mbi = encodeMBI(remLength); // Convert the length to MQTT MBI format
            var pos = mbi.length + 1; // Offset of start of variable header
            var buffer = new ArrayBuffer(remLength + pos);
            var byteStream = new Uint8Array(buffer); // view it as a sequence of bytes
            //Write the fixed header into the buffer
            byteStream[0] = first;
            byteStream.set(mbi, 1);
            // If this is a PUBLISH then the variable header starts with a topic
            if (this.type == MESSAGE_TYPE.PUBLISH) pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
            else if (this.type == MESSAGE_TYPE.CONNECT) {
                switch(this.mqttVersion){
                    case 3:
                        byteStream.set(MqttProtoIdentifierv3, pos);
                        pos += MqttProtoIdentifierv3.length;
                        break;
                    case 4:
                        byteStream.set(MqttProtoIdentifierv4, pos);
                        pos += MqttProtoIdentifierv4.length;
                        break;
                }
                var connectFlags = 0;
                if (this.cleanSession) connectFlags = 0x02;
                if (this.willMessage !== undefined) {
                    connectFlags |= 0x04;
                    connectFlags |= this.willMessage.qos << 3;
                    if (this.willMessage.retained) connectFlags |= 0x20;
                }
                if (this.userName !== undefined) connectFlags |= 0x80;
                if (this.password !== undefined) connectFlags |= 0x40;
                byteStream[pos++] = connectFlags;
                pos = writeUint16(this.keepAliveInterval, byteStream, pos);
            }
            // Output the messageIdentifier - if there is one
            if (this.messageIdentifier !== undefined) pos = writeUint16(this.messageIdentifier, byteStream, pos);
            switch(this.type){
                case MESSAGE_TYPE.CONNECT:
                    pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
                    if (this.willMessage !== undefined) {
                        pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
                        pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
                        byteStream.set(willMessagePayloadBytes, pos);
                        pos += willMessagePayloadBytes.byteLength;
                    }
                    if (this.userName !== undefined) pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
                    if (this.password !== undefined) pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    // PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
                    byteStream.set(payloadBytes, pos);
                    break;
                //    	    case MESSAGE_TYPE.PUBREC:
                //    	    case MESSAGE_TYPE.PUBREL:
                //    	    case MESSAGE_TYPE.PUBCOMP:
                //    	    	break;
                case MESSAGE_TYPE.SUBSCRIBE:
                    // SUBSCRIBE has a list of topic strings and request QoS
                    for(var i = 0; i < this.topics.length; i++){
                        pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                        byteStream[pos++] = this.requestedQos[i];
                    }
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    // UNSUBSCRIBE has a list of topic strings
                    for(var i = 0; i < this.topics.length; i++)pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                    break;
                default:
            }
            return buffer;
        };
        function decodeMessage(input, pos) {
            var startingPos = pos;
            var first = input[pos];
            var type = first >> 4;
            var messageInfo = first &= 0x0f;
            pos += 1;
            // Decode the remaining length (MBI format)
            var digit;
            var remLength = 0;
            var multiplier = 1;
            do {
                if (pos == input.length) return [
                    null,
                    startingPos
                ];
                digit = input[pos++];
                remLength += (digit & 0x7F) * multiplier;
                multiplier *= 128;
            }while ((digit & 0x80) !== 0);
            var endPos = pos + remLength;
            if (endPos > input.length) return [
                null,
                startingPos
            ];
            var wireMessage = new WireMessage(type);
            switch(type){
                case MESSAGE_TYPE.CONNACK:
                    var connectAcknowledgeFlags = input[pos++];
                    if (connectAcknowledgeFlags & 0x01) wireMessage.sessionPresent = true;
                    wireMessage.returnCode = input[pos++];
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    var qos = messageInfo >> 1 & 0x03;
                    var len = readUint16(input, pos);
                    pos += 2;
                    var topicName = parseUTF8(input, pos, len);
                    pos += len;
                    // If QoS 1 or 2 there will be a messageIdentifier
                    if (qos > 0) {
                        wireMessage.messageIdentifier = readUint16(input, pos);
                        pos += 2;
                    }
                    var message = new PahoMQTT.Message(input.subarray(pos, endPos));
                    if ((messageInfo & 0x01) == 0x01) message.retained = true;
                    if ((messageInfo & 0x08) == 0x08) message.duplicate = true;
                    message.qos = qos;
                    message.destinationName = topicName;
                    wireMessage.payloadMessage = message;
                    break;
                case MESSAGE_TYPE.PUBACK:
                case MESSAGE_TYPE.PUBREC:
                case MESSAGE_TYPE.PUBREL:
                case MESSAGE_TYPE.PUBCOMP:
                case MESSAGE_TYPE.UNSUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    break;
                case MESSAGE_TYPE.SUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    pos += 2;
                    wireMessage.returnCode = input.subarray(pos, endPos);
                    break;
                default:
                    break;
            }
            return [
                wireMessage,
                endPos
            ];
        }
        function writeUint16(input, buffer, offset) {
            buffer[offset++] = input >> 8; //MSB
            buffer[offset++] = input % 256; //LSB
            return offset;
        }
        function writeString(input, utf8Length, buffer, offset) {
            offset = writeUint16(utf8Length, buffer, offset);
            stringToUTF8(input, buffer, offset);
            return offset + utf8Length;
        }
        function readUint16(buffer, offset) {
            return 256 * buffer[offset] + buffer[offset + 1];
        }
        /**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */ function encodeMBI(number) {
            var output = new Array(1);
            var numBytes = 0;
            do {
                var digit = number % 128;
                number = number >> 7;
                if (number > 0) digit |= 0x80;
                output[numBytes++] = digit;
            }while (number > 0 && numBytes < 4);
            return output;
        }
        /**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */ function UTF8Length(input) {
            var output = 0;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                if (charCode > 0x7FF) {
                    // Surrogate pair means its a 4 byte character
                    if (0xD800 <= charCode && charCode <= 0xDBFF) {
                        i++;
                        output++;
                    }
                    output += 3;
                } else if (charCode > 0x7F) output += 2;
                else output++;
            }
            return output;
        }
        /**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */ function stringToUTF8(input, output, start) {
            var pos = start;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                // Check for a surrogate pair.
                if (0xD800 <= charCode && charCode <= 0xDBFF) {
                    var lowCharCode = input.charCodeAt(++i);
                    if (isNaN(lowCharCode)) throw new Error(format(ERROR.MALFORMED_UNICODE, [
                        charCode,
                        lowCharCode
                    ]));
                    charCode = (charCode - 0xD800 << 10) + (lowCharCode - 0xDC00) + 0x10000;
                }
                if (charCode <= 0x7F) output[pos++] = charCode;
                else if (charCode <= 0x7FF) {
                    output[pos++] = charCode >> 6 & 0x1F | 0xC0;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else if (charCode <= 0xFFFF) {
                    output[pos++] = charCode >> 12 & 0x0F | 0xE0;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else {
                    output[pos++] = charCode >> 18 & 0x07 | 0xF0;
                    output[pos++] = charCode >> 12 & 0x3F | 0x80;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                }
            }
            return output;
        }
        function parseUTF8(input, offset, length) {
            var output = "";
            var utf16;
            var pos = offset;
            while(pos < offset + length){
                var byte1 = input[pos++];
                if (byte1 < 128) utf16 = byte1;
                else {
                    var byte2 = input[pos++] - 128;
                    if (byte2 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                        byte1.toString(16),
                        byte2.toString(16),
                        ""
                    ]));
                    if (byte1 < 0xE0) utf16 = 64 * (byte1 - 0xC0) + byte2;
                    else {
                        var byte3 = input[pos++] - 128;
                        if (byte3 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                            byte1.toString(16),
                            byte2.toString(16),
                            byte3.toString(16)
                        ]));
                        if (byte1 < 0xF0) utf16 = 4096 * (byte1 - 0xE0) + 64 * byte2 + byte3;
                        else {
                            var byte4 = input[pos++] - 128;
                            if (byte4 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                            if (byte1 < 0xF8) utf16 = 262144 * (byte1 - 0xF0) + 4096 * byte2 + 64 * byte3 + byte4;
                            else throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                        }
                    }
                }
                if (utf16 > 0xFFFF) {
                    utf16 -= 0x10000;
                    output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
                    utf16 = 0xDC00 + (utf16 & 0x3FF); // trail character
                }
                output += String.fromCharCode(utf16);
            }
            return output;
        }
        /**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */ var Pinger = function(client, keepAliveInterval) {
            this._client = client;
            this._keepAliveInterval = keepAliveInterval * 1000;
            this.isReset = false;
            var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();
            var doTimeout = function(pinger) {
                return function() {
                    return doPing.apply(pinger);
                };
            };
            /** @ignore */ var doPing = function() {
                if (!this.isReset) {
                    this._client._trace("Pinger.doPing", "Timed out");
                    this._client._disconnected(ERROR.PING_TIMEOUT.code, format(ERROR.PING_TIMEOUT));
                } else {
                    this.isReset = false;
                    this._client._trace("Pinger.doPing", "send PINGREQ");
                    this._client.socket.send(pingReq);
                    this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
                }
            };
            this.reset = function() {
                this.isReset = true;
                clearTimeout(this.timeout);
                if (this._keepAliveInterval > 0) this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
            };
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Monitor request completion.
	 * @ignore
	 */ var Timeout = function(client, timeoutSeconds, action, args) {
            if (!timeoutSeconds) timeoutSeconds = 30;
            var doTimeout = function(action, client, args) {
                return function() {
                    return action.apply(client, args);
                };
            };
            this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */ var ClientImpl = function(uri, host, port, path, clientId) {
            // Check dependencies are satisfied in this browser.
            if (!("WebSocket" in global1 && global1.WebSocket !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "WebSocket"
            ]));
            if (!("ArrayBuffer" in global1 && global1.ArrayBuffer !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "ArrayBuffer"
            ]));
            this._trace("Paho.Client", uri, host, port, path, clientId);
            this.host = host;
            this.port = port;
            this.path = path;
            this.uri = uri;
            this.clientId = clientId;
            this._wsuri = null;
            // Local storagekeys are qualified with the following string.
            // The conditional inclusion of path in the key is for backward
            // compatibility to when the path was not configurable and assumed to
            // be /mqtt
            this._localKey = host + ":" + port + (path != "/mqtt" ? ":" + path : "") + ":" + clientId + ":";
            // Create private instance-only message queue
            // Internal queue of messages to be sent, in sending order.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            // Messages we have sent and are expecting a response for, indexed by their respective message ids.
            this._sentMessages = {};
            // Messages we have received and acknowleged and are expecting a confirm message for
            // indexed by their respective message ids.
            this._receivedMessages = {};
            // Internal list of callbacks to be executed when messages
            // have been successfully sent over web socket, e.g. disconnect
            // when it doesn't have to wait for ACK, just message is dispatched.
            this._notify_msg_sent = {};
            // Unique identifier for SEND messages, incrementing
            // counter as messages are sent.
            this._message_identifier = 1;
            // Used to determine the transmission sequence of stored sent messages.
            this._sequence = 0;
            // Load the local state, if any, from the saved version, only restore state relevant to this client.
            for(var key in localStorage)if (key.indexOf("Sent:" + this._localKey) === 0 || key.indexOf("Received:" + this._localKey) === 0) this.restore(key);
        };
        // Messaging Client public instance members.
        ClientImpl.prototype.host = null;
        ClientImpl.prototype.port = null;
        ClientImpl.prototype.path = null;
        ClientImpl.prototype.uri = null;
        ClientImpl.prototype.clientId = null;
        // Messaging Client private instance members.
        ClientImpl.prototype.socket = null;
        /* true once we have received an acknowledgement to a CONNECT packet. */ ClientImpl.prototype.connected = false;
        /* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */ ClientImpl.prototype.maxMessageIdentifier = 65536;
        ClientImpl.prototype.connectOptions = null;
        ClientImpl.prototype.hostIndex = null;
        ClientImpl.prototype.onConnected = null;
        ClientImpl.prototype.onConnectionLost = null;
        ClientImpl.prototype.onMessageDelivered = null;
        ClientImpl.prototype.onMessageArrived = null;
        ClientImpl.prototype.traceFunction = null;
        ClientImpl.prototype._msg_queue = null;
        ClientImpl.prototype._buffered_msg_queue = null;
        ClientImpl.prototype._connectTimeout = null;
        /* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */ ClientImpl.prototype.sendPinger = null;
        /* The receivePinger monitors how long we allow before we require evidence that the server is alive. */ ClientImpl.prototype.receivePinger = null;
        ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
        ClientImpl.prototype._reconnecting = false;
        ClientImpl.prototype._reconnectTimeout = null;
        ClientImpl.prototype.disconnectedPublishing = false;
        ClientImpl.prototype.disconnectedBufferSize = 5000;
        ClientImpl.prototype.receiveBuffer = null;
        ClientImpl.prototype._traceBuffer = null;
        ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;
        ClientImpl.prototype.connect = function(connectOptions) {
            var connectOptionsMasked = this._traceMask(connectOptions, "password");
            this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
            if (this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this._reconnecting) {
                // connect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process to use new connect options.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            this.connectOptions = connectOptions;
            this._reconnectInterval = 1;
            this._reconnecting = false;
            if (connectOptions.uris) {
                this.hostIndex = 0;
                this._doConnect(connectOptions.uris[0]);
            } else this._doConnect(this.uri);
        };
        ClientImpl.prototype.subscribe = function(filter, subscribeOptions) {
            this._trace("Client.subscribe", filter, subscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = [
                filter
            ];
            if (subscribeOptions.qos !== undefined) wireMessage.requestedQos = [
                subscribeOptions.qos
            ];
            else wireMessage.requestedQos = [
                0
            ];
            if (subscribeOptions.onSuccess) wireMessage.onSuccess = function(grantedQos) {
                subscribeOptions.onSuccess({
                    invocationContext: subscribeOptions.invocationContext,
                    grantedQos: grantedQos
                });
            };
            if (subscribeOptions.onFailure) wireMessage.onFailure = function(errorCode) {
                subscribeOptions.onFailure({
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: errorCode,
                    errorMessage: format(errorCode)
                });
            };
            if (subscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure, [
                {
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: ERROR.SUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.SUBSCRIBE_TIMEOUT)
                }
            ]);
            // All subscriptions return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        /** @ignore */ ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
            this._trace("Client.unsubscribe", filter, unsubscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = [
                filter
            ];
            if (unsubscribeOptions.onSuccess) wireMessage.callback = function() {
                unsubscribeOptions.onSuccess({
                    invocationContext: unsubscribeOptions.invocationContext
                });
            };
            if (unsubscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure, [
                {
                    invocationContext: unsubscribeOptions.invocationContext,
                    errorCode: ERROR.UNSUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.UNSUBSCRIBE_TIMEOUT)
                }
            ]);
            // All unsubscribes return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.send = function(message) {
            this._trace("Client.send", message);
            var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
            wireMessage.payloadMessage = message;
            if (this.connected) {
                // Mark qos 1 & 2 message as "ACK required"
                // For qos 0 message, invoke onMessageDelivered callback if there is one.
                // Then schedule the message.
                if (message.qos > 0) this._requires_ack(wireMessage);
                else if (this.onMessageDelivered) this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
                this._schedule_message(wireMessage);
            } else {
                // Currently disconnected, will not schedule this message
                // Check if reconnecting is in progress and disconnected publish is enabled.
                if (this._reconnecting && this.disconnectedPublishing) {
                    // Check the limit which include the "required ACK" messages
                    var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                    if (messageCount > this.disconnectedBufferSize) throw new Error(format(ERROR.BUFFER_FULL, [
                        this.disconnectedBufferSize
                    ]));
                    else if (message.qos > 0) // Mark this message as "ACK required"
                    this._requires_ack(wireMessage);
                    else {
                        wireMessage.sequence = ++this._sequence;
                        // Add messages in fifo order to array, by adding to start
                        this._buffered_msg_queue.unshift(wireMessage);
                    }
                } else throw new Error(format(ERROR.INVALID_STATE, [
                    "not connected"
                ]));
            }
        };
        ClientImpl.prototype.disconnect = function() {
            this._trace("Client.disconnect");
            if (this._reconnecting) {
                // disconnect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            if (!this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "not connecting or connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);
            // Run the disconnected call back as soon as the message has been sent,
            // in case of a failure later on in the disconnect processing.
            // as a consequence, the _disconected call back may be run several times.
            this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.getTraceLog = function() {
            if (this._traceBuffer !== null) {
                this._trace("Client.getTraceLog", new Date());
                this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                for(var key in this._sentMessages)this._trace("_sentMessages ", key, this._sentMessages[key]);
                for(var key in this._receivedMessages)this._trace("_receivedMessages ", key, this._receivedMessages[key]);
                return this._traceBuffer;
            }
        };
        ClientImpl.prototype.startTrace = function() {
            if (this._traceBuffer === null) this._traceBuffer = [];
            this._trace("Client.startTrace", new Date(), version);
        };
        ClientImpl.prototype.stopTrace = function() {
            delete this._traceBuffer;
        };
        ClientImpl.prototype._doConnect = function(wsurl) {
            // When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
            if (this.connectOptions.useSSL) {
                var uriParts = wsurl.split(":");
                uriParts[0] = "wss";
                wsurl = uriParts.join(":");
            }
            this._wsuri = wsurl;
            this.connected = false;
            if (this.connectOptions.mqttVersion < 4) this.socket = new WebSocket(wsurl, [
                "mqttv3.1"
            ]);
            else this.socket = new WebSocket(wsurl, [
                "mqtt"
            ]);
            this.socket.binaryType = "arraybuffer";
            this.socket.onopen = scope(this._on_socket_open, this);
            this.socket.onmessage = scope(this._on_socket_message, this);
            this.socket.onerror = scope(this._on_socket_error, this);
            this.socket.onclose = scope(this._on_socket_close, this);
            this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected, [
                ERROR.CONNECT_TIMEOUT.code,
                format(ERROR.CONNECT_TIMEOUT)
            ]);
        };
        // Schedule a new message to be sent over the WebSockets
        // connection. CONNECT messages cause WebSocket connection
        // to be started. All other messages are queued internally
        // until this has happened. When WS connection starts, process
        // all outstanding messages.
        ClientImpl.prototype._schedule_message = function(message) {
            // Add messages in fifo order to array, by adding to start
            this._msg_queue.unshift(message);
            // Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
            if (this.connected) this._process_queue();
        };
        ClientImpl.prototype.store = function(prefix, wireMessage) {
            var storedMessage = {
                type: wireMessage.type,
                messageIdentifier: wireMessage.messageIdentifier,
                version: 1
            };
            switch(wireMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    if (wireMessage.pubRecReceived) storedMessage.pubRecReceived = true;
                    // Convert the payload to a hex string.
                    storedMessage.payloadMessage = {};
                    var hex = "";
                    var messageBytes = wireMessage.payloadMessage.payloadBytes;
                    for(var i = 0; i < messageBytes.length; i++)if (messageBytes[i] <= 0xF) hex = hex + "0" + messageBytes[i].toString(16);
                    else hex = hex + messageBytes[i].toString(16);
                    storedMessage.payloadMessage.payloadHex = hex;
                    storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
                    storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
                    if (wireMessage.payloadMessage.duplicate) storedMessage.payloadMessage.duplicate = true;
                    if (wireMessage.payloadMessage.retained) storedMessage.payloadMessage.retained = true;
                    // Add a sequence number to sent messages.
                    if (prefix.indexOf("Sent:") === 0) {
                        if (wireMessage.sequence === undefined) wireMessage.sequence = ++this._sequence;
                        storedMessage.sequence = wireMessage.sequence;
                    }
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        prefix + this._localKey + wireMessage.messageIdentifier,
                        storedMessage
                    ]));
            }
            localStorage.setItem(prefix + this._localKey + wireMessage.messageIdentifier, JSON.stringify(storedMessage));
        };
        ClientImpl.prototype.restore = function(key) {
            var value = localStorage.getItem(key);
            var storedMessage = JSON.parse(value);
            var wireMessage = new WireMessage(storedMessage.type, storedMessage);
            switch(storedMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    // Replace the payload message with a Message object.
                    var hex = storedMessage.payloadMessage.payloadHex;
                    var buffer = new ArrayBuffer(hex.length / 2);
                    var byteStream = new Uint8Array(buffer);
                    var i = 0;
                    while(hex.length >= 2){
                        var x = parseInt(hex.substring(0, 2), 16);
                        hex = hex.substring(2, hex.length);
                        byteStream[i++] = x;
                    }
                    var payloadMessage = new PahoMQTT.Message(byteStream);
                    payloadMessage.qos = storedMessage.payloadMessage.qos;
                    payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
                    if (storedMessage.payloadMessage.duplicate) payloadMessage.duplicate = true;
                    if (storedMessage.payloadMessage.retained) payloadMessage.retained = true;
                    wireMessage.payloadMessage = payloadMessage;
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        key,
                        value
                    ]));
            }
            if (key.indexOf("Sent:" + this._localKey) === 0) {
                wireMessage.payloadMessage.duplicate = true;
                this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            } else if (key.indexOf("Received:" + this._localKey) === 0) this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
        };
        ClientImpl.prototype._process_queue = function() {
            var message = null;
            // Send all queued messages down socket connection
            while(message = this._msg_queue.pop()){
                this._socket_send(message);
                // Notify listeners that message was successfully sent
                if (this._notify_msg_sent[message]) {
                    this._notify_msg_sent[message]();
                    delete this._notify_msg_sent[message];
                }
            }
        };
        /**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */ ClientImpl.prototype._requires_ack = function(wireMessage) {
            var messageCount = Object.keys(this._sentMessages).length;
            if (messageCount > this.maxMessageIdentifier) throw Error("Too many messages:" + messageCount);
            while(this._sentMessages[this._message_identifier] !== undefined)this._message_identifier++;
            wireMessage.messageIdentifier = this._message_identifier;
            this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            if (wireMessage.type === MESSAGE_TYPE.PUBLISH) this.store("Sent:", wireMessage);
            if (this._message_identifier === this.maxMessageIdentifier) this._message_identifier = 1;
        };
        /**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_open = function() {
            // Create the CONNECT message object.
            var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
            wireMessage.clientId = this.clientId;
            this._socket_send(wireMessage);
        };
        /**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_message = function(event) {
            this._trace("Client._on_socket_message", event.data);
            var messages = this._deframeMessages(event.data);
            for(var i = 0; i < messages.length; i += 1)this._handleMessage(messages[i]);
        };
        ClientImpl.prototype._deframeMessages = function(data) {
            var byteArray = new Uint8Array(data);
            var messages = [];
            if (this.receiveBuffer) {
                var newData = new Uint8Array(this.receiveBuffer.length + byteArray.length);
                newData.set(this.receiveBuffer);
                newData.set(byteArray, this.receiveBuffer.length);
                byteArray = newData;
                delete this.receiveBuffer;
            }
            try {
                var offset = 0;
                while(offset < byteArray.length){
                    var result = decodeMessage(byteArray, offset);
                    var wireMessage = result[0];
                    offset = result[1];
                    if (wireMessage !== null) messages.push(wireMessage);
                    else break;
                }
                if (offset < byteArray.length) this.receiveBuffer = byteArray.subarray(offset);
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
            return messages;
        };
        ClientImpl.prototype._handleMessage = function(wireMessage) {
            this._trace("Client._handleMessage", wireMessage);
            try {
                switch(wireMessage.type){
                    case MESSAGE_TYPE.CONNACK:
                        this._connectTimeout.cancel();
                        if (this._reconnectTimeout) this._reconnectTimeout.cancel();
                        // If we have started using clean session then clear up the local state.
                        if (this.connectOptions.cleanSession) {
                            for(var key in this._sentMessages){
                                var sentMessage = this._sentMessages[key];
                                localStorage.removeItem("Sent:" + this._localKey + sentMessage.messageIdentifier);
                            }
                            this._sentMessages = {};
                            for(var key in this._receivedMessages){
                                var receivedMessage = this._receivedMessages[key];
                                localStorage.removeItem("Received:" + this._localKey + receivedMessage.messageIdentifier);
                            }
                            this._receivedMessages = {};
                        }
                        // Client connected and ready for business.
                        if (wireMessage.returnCode === 0) {
                            this.connected = true;
                            // Jump to the end of the list of uris and stop looking for a good host.
                            if (this.connectOptions.uris) this.hostIndex = this.connectOptions.uris.length;
                        } else {
                            this._disconnected(ERROR.CONNACK_RETURNCODE.code, format(ERROR.CONNACK_RETURNCODE, [
                                wireMessage.returnCode,
                                CONNACK_RC[wireMessage.returnCode]
                            ]));
                            break;
                        }
                        // Resend messages.
                        var sequencedMessages = [];
                        for(var msgId in this._sentMessages)if (this._sentMessages.hasOwnProperty(msgId)) sequencedMessages.push(this._sentMessages[msgId]);
                        // Also schedule qos 0 buffered messages if any
                        if (this._buffered_msg_queue.length > 0) {
                            var msg = null;
                            while(msg = this._buffered_msg_queue.pop()){
                                sequencedMessages.push(msg);
                                if (this.onMessageDelivered) this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
                            }
                        }
                        // Sort sentMessages into the original sent order.
                        var sequencedMessages = sequencedMessages.sort(function(a, b) {
                            return a.sequence - b.sequence;
                        });
                        for(var i = 0, len = sequencedMessages.length; i < len; i++){
                            var sentMessage = sequencedMessages[i];
                            if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
                                var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                    messageIdentifier: sentMessage.messageIdentifier
                                });
                                this._schedule_message(pubRelMessage);
                            } else this._schedule_message(sentMessage);
                        }
                        // Execute the connectOptions.onSuccess callback if there is one.
                        // Will also now return if this connection was the result of an automatic
                        // reconnect and which URI was successfully connected to.
                        if (this.connectOptions.onSuccess) this.connectOptions.onSuccess({
                            invocationContext: this.connectOptions.invocationContext
                        });
                        var reconnected = false;
                        if (this._reconnecting) {
                            reconnected = true;
                            this._reconnectInterval = 1;
                            this._reconnecting = false;
                        }
                        // Execute the onConnected callback if there is one.
                        this._connected(reconnected, this._wsuri);
                        // Process all queued messages now that the connection is established.
                        this._process_queue();
                        break;
                    case MESSAGE_TYPE.PUBLISH:
                        this._receivePublish(wireMessage);
                        break;
                    case MESSAGE_TYPE.PUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            delete this._sentMessages[wireMessage.messageIdentifier];
                            localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                            if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREC:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            sentMessage.pubRecReceived = true;
                            var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                messageIdentifier: wireMessage.messageIdentifier
                            });
                            this.store("Sent:", sentMessage);
                            this._schedule_message(pubRelMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREL:
                        var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Received:" + this._localKey + wireMessage.messageIdentifier);
                        // If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
                        if (receivedMessage) {
                            this._receiveMessage(receivedMessage);
                            delete this._receivedMessages[wireMessage.messageIdentifier];
                        }
                        // Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
                        var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {
                            messageIdentifier: wireMessage.messageIdentifier
                        });
                        this._schedule_message(pubCompMessage);
                        break;
                    case MESSAGE_TYPE.PUBCOMP:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        delete this._sentMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                        if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        break;
                    case MESSAGE_TYPE.SUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            // This will need to be fixed when we add multiple topic support
                            if (wireMessage.returnCode[0] === 0x80) {
                                if (sentMessage.onFailure) sentMessage.onFailure(wireMessage.returnCode);
                            } else if (sentMessage.onSuccess) sentMessage.onSuccess(wireMessage.returnCode);
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.UNSUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            if (sentMessage.callback) sentMessage.callback();
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.PINGRESP:
                        /* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */ this.sendPinger.reset();
                        break;
                    case MESSAGE_TYPE.DISCONNECT:
                        // Clients do not expect to receive disconnect packets.
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                        break;
                    default:
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                }
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
        };
        /** @ignore */ ClientImpl.prototype._on_socket_error = function(error) {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_ERROR.code, format(ERROR.SOCKET_ERROR, [
                error.data
            ]));
        };
        /** @ignore */ ClientImpl.prototype._on_socket_close = function() {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_CLOSE.code, format(ERROR.SOCKET_CLOSE));
        };
        /** @ignore */ ClientImpl.prototype._socket_send = function(wireMessage) {
            if (wireMessage.type == 1) {
                var wireMessageMasked = this._traceMask(wireMessage, "password");
                this._trace("Client._socket_send", wireMessageMasked);
            } else this._trace("Client._socket_send", wireMessage);
            this.socket.send(wireMessage.encode());
            /* We have proved to the server we are alive. */ this.sendPinger.reset();
        };
        /** @ignore */ ClientImpl.prototype._receivePublish = function(wireMessage) {
            switch(wireMessage.payloadMessage.qos){
                case "undefined":
                case 0:
                    this._receiveMessage(wireMessage);
                    break;
                case 1:
                    var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubAckMessage);
                    this._receiveMessage(wireMessage);
                    break;
                case 2:
                    this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
                    this.store("Received:", wireMessage);
                    var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubRecMessage);
                    break;
                default:
                    throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
            }
        };
        /** @ignore */ ClientImpl.prototype._receiveMessage = function(wireMessage) {
            if (this.onMessageArrived) this.onMessageArrived(wireMessage.payloadMessage);
        };
        /**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */ ClientImpl.prototype._connected = function(reconnect, uri) {
            // Execute the onConnected callback if there is one.
            if (this.onConnected) this.onConnected(reconnect, uri);
        };
        /**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */ ClientImpl.prototype._reconnect = function() {
            this._trace("Client._reconnect");
            if (!this.connected) {
                this._reconnecting = true;
                this.sendPinger.cancel();
                this.receivePinger.cancel();
                if (this._reconnectInterval < 128) this._reconnectInterval = this._reconnectInterval * 2;
                if (this.connectOptions.uris) {
                    this.hostIndex = 0;
                    this._doConnect(this.connectOptions.uris[0]);
                } else this._doConnect(this.uri);
            }
        };
        /**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */ ClientImpl.prototype._disconnected = function(errorCode, errorText) {
            this._trace("Client._disconnected", errorCode, errorText);
            if (errorCode !== undefined && this._reconnecting) {
                //Continue automatic reconnect process
                this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
                return;
            }
            this.sendPinger.cancel();
            this.receivePinger.cancel();
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            // Clear message buffers.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            this._notify_msg_sent = {};
            if (this.socket) {
                // Cancel all socket callbacks so that they cannot be driven again by this socket.
                this.socket.onopen = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onclose = null;
                if (this.socket.readyState === 1) this.socket.close();
                delete this.socket;
            }
            if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1) {
                // Try the next host.
                this.hostIndex++;
                this._doConnect(this.connectOptions.uris[this.hostIndex]);
            } else {
                if (errorCode === undefined) {
                    errorCode = ERROR.OK.code;
                    errorText = format(ERROR.OK);
                }
                // Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
                if (this.connected) {
                    this.connected = false;
                    // Execute the connectionLostCallback if there is one, and we were connected.
                    if (this.onConnectionLost) this.onConnectionLost({
                        errorCode: errorCode,
                        errorMessage: errorText,
                        reconnect: this.connectOptions.reconnect,
                        uri: this._wsuri
                    });
                    if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
                        // Start automatic reconnect process for the very first time since last successful connect.
                        this._reconnectInterval = 1;
                        this._reconnect();
                        return;
                    }
                } else {
                    // Otherwise we never had a connection, so indicate that the connect has failed.
                    if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
                        this._trace("Failed to connect V4, dropping back to V3");
                        this.connectOptions.mqttVersion = 3;
                        if (this.connectOptions.uris) {
                            this.hostIndex = 0;
                            this._doConnect(this.connectOptions.uris[0]);
                        } else this._doConnect(this.uri);
                    } else if (this.connectOptions.onFailure) this.connectOptions.onFailure({
                        invocationContext: this.connectOptions.invocationContext,
                        errorCode: errorCode,
                        errorMessage: errorText
                    });
                }
            }
        };
        /** @ignore */ ClientImpl.prototype._trace = function() {
            // Pass trace message back to client's callback function
            if (this.traceFunction) {
                var args = Array.prototype.slice.call(arguments);
                for(var i in args)if (typeof args[i] !== "undefined") args.splice(i, 1, JSON.stringify(args[i]));
                var record = args.join("");
                this.traceFunction({
                    severity: "Debug",
                    message: record
                });
            }
            //buffer style trace
            if (this._traceBuffer !== null) for(var i = 0, max = arguments.length; i < max; i++){
                if (this._traceBuffer.length == this._MAX_TRACE_ENTRIES) this._traceBuffer.shift();
                if (i === 0) this._traceBuffer.push(arguments[i]);
                else if (typeof arguments[i] === "undefined") this._traceBuffer.push(arguments[i]);
                else this._traceBuffer.push("  " + JSON.stringify(arguments[i]));
            }
        };
        /** @ignore */ ClientImpl.prototype._traceMask = function(traceObject, masked) {
            var traceObjectMasked = {};
            for(var attr in traceObject)if (traceObject.hasOwnProperty(attr)) {
                if (attr == masked) traceObjectMasked[attr] = "******";
                else traceObjectMasked[attr] = traceObject[attr];
            }
            return traceObjectMasked;
        };
        // ------------------------------------------------------------------------
        // Public Programming interface.
        // ------------------------------------------------------------------------
        /**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */ var Client = function(host, port, path, clientId) {
            var uri;
            if (typeof host !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                typeof host,
                "host"
            ]));
            if (arguments.length == 2) {
                // host: must be full ws:// uri
                // port: clientId
                clientId = port;
                uri = host;
                var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                if (match) {
                    host = match[4] || match[2];
                    port = parseInt(match[7]);
                    path = match[8];
                } else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    host,
                    "host"
                ]));
            } else {
                if (arguments.length == 3) {
                    clientId = path;
                    path = "/mqtt";
                }
                if (typeof port !== "number" || port < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof port,
                    "port"
                ]));
                if (typeof path !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof path,
                    "path"
                ]));
                var ipv6AddSBracket = host.indexOf(":") !== -1 && host.slice(0, 1) !== "[" && host.slice(-1) !== "]";
                uri = "ws://" + (ipv6AddSBracket ? "[" + host + "]" : host) + ":" + port + path;
            }
            var clientIdLength = 0;
            for(var i = 0; i < clientId.length; i++){
                var charCode = clientId.charCodeAt(i);
                if (0xD800 <= charCode && charCode <= 0xDBFF) i++; // Surrogate pair.
                clientIdLength++;
            }
            if (typeof clientId !== "string" || clientIdLength > 65535) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                clientId,
                "clientId"
            ]));
            var client = new ClientImpl(uri, host, port, path, clientId);
            //Public Properties
            Object.defineProperties(this, {
                "host": {
                    get: function() {
                        return host;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "port": {
                    get: function() {
                        return port;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "path": {
                    get: function() {
                        return path;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "uri": {
                    get: function() {
                        return uri;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "clientId": {
                    get: function() {
                        return client.clientId;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "onConnected": {
                    get: function() {
                        return client.onConnected;
                    },
                    set: function(newOnConnected) {
                        if (typeof newOnConnected === "function") client.onConnected = newOnConnected;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnected,
                            "onConnected"
                        ]));
                    }
                },
                "disconnectedPublishing": {
                    get: function() {
                        return client.disconnectedPublishing;
                    },
                    set: function(newDisconnectedPublishing) {
                        client.disconnectedPublishing = newDisconnectedPublishing;
                    }
                },
                "disconnectedBufferSize": {
                    get: function() {
                        return client.disconnectedBufferSize;
                    },
                    set: function(newDisconnectedBufferSize) {
                        client.disconnectedBufferSize = newDisconnectedBufferSize;
                    }
                },
                "onConnectionLost": {
                    get: function() {
                        return client.onConnectionLost;
                    },
                    set: function(newOnConnectionLost) {
                        if (typeof newOnConnectionLost === "function") client.onConnectionLost = newOnConnectionLost;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnectionLost,
                            "onConnectionLost"
                        ]));
                    }
                },
                "onMessageDelivered": {
                    get: function() {
                        return client.onMessageDelivered;
                    },
                    set: function(newOnMessageDelivered) {
                        if (typeof newOnMessageDelivered === "function") client.onMessageDelivered = newOnMessageDelivered;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageDelivered,
                            "onMessageDelivered"
                        ]));
                    }
                },
                "onMessageArrived": {
                    get: function() {
                        return client.onMessageArrived;
                    },
                    set: function(newOnMessageArrived) {
                        if (typeof newOnMessageArrived === "function") client.onMessageArrived = newOnMessageArrived;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageArrived,
                            "onMessageArrived"
                        ]));
                    }
                },
                "trace": {
                    get: function() {
                        return client.traceFunction;
                    },
                    set: function(trace) {
                        if (typeof trace === "function") client.traceFunction = trace;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof trace,
                            "onTrace"
                        ]));
                    }
                }
            });
            /**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */ this.connect = function(connectOptions) {
                connectOptions = connectOptions || {};
                validate(connectOptions, {
                    timeout: "number",
                    userName: "string",
                    password: "string",
                    willMessage: "object",
                    keepAliveInterval: "number",
                    cleanSession: "boolean",
                    useSSL: "boolean",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    hosts: "object",
                    ports: "object",
                    reconnect: "boolean",
                    mqttVersion: "number",
                    mqttVersionExplicit: "boolean",
                    uris: "object"
                });
                // If no keep alive interval is set, assume 60 seconds.
                if (connectOptions.keepAliveInterval === undefined) connectOptions.keepAliveInterval = 60;
                if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.mqttVersion,
                    "connectOptions.mqttVersion"
                ]));
                if (connectOptions.mqttVersion === undefined) {
                    connectOptions.mqttVersionExplicit = false;
                    connectOptions.mqttVersion = 4;
                } else connectOptions.mqttVersionExplicit = true;
                //Check that if password is set, so is username
                if (connectOptions.password !== undefined && connectOptions.userName === undefined) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.password,
                    "connectOptions.password"
                ]));
                if (connectOptions.willMessage) {
                    if (!(connectOptions.willMessage instanceof Message)) throw new Error(format(ERROR.INVALID_TYPE, [
                        connectOptions.willMessage,
                        "connectOptions.willMessage"
                    ]));
                    // The will message must have a payload that can be represented as a string.
                    // Cause the willMessage to throw an exception if this is not the case.
                    connectOptions.willMessage.stringPayload = null;
                    if (typeof connectOptions.willMessage.destinationName === "undefined") throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof connectOptions.willMessage.destinationName,
                        "connectOptions.willMessage.destinationName"
                    ]));
                }
                if (typeof connectOptions.cleanSession === "undefined") connectOptions.cleanSession = true;
                if (connectOptions.hosts) {
                    if (!(connectOptions.hosts instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    if (connectOptions.hosts.length < 1) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    var usingURIs = false;
                    for(var i = 0; i < connectOptions.hosts.length; i++){
                        if (typeof connectOptions.hosts[i] !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                        if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
                            if (i === 0) usingURIs = true;
                            else if (!usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                                connectOptions.hosts[i],
                                "connectOptions.hosts[" + i + "]"
                            ]));
                        } else if (usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                    }
                    if (!usingURIs) {
                        if (!connectOptions.ports) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (!(connectOptions.ports instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (connectOptions.hosts.length !== connectOptions.ports.length) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        connectOptions.uris = [];
                        for(var i = 0; i < connectOptions.hosts.length; i++){
                            if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                                typeof connectOptions.ports[i],
                                "connectOptions.ports[" + i + "]"
                            ]));
                            var host = connectOptions.hosts[i];
                            var port = connectOptions.ports[i];
                            var ipv6 = host.indexOf(":") !== -1;
                            uri = "ws://" + (ipv6 ? "[" + host + "]" : host) + ":" + port + path;
                            connectOptions.uris.push(uri);
                        }
                    } else connectOptions.uris = connectOptions.hosts;
                }
                client.connect(connectOptions);
            };
            /**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.subscribe = function(filter, subscribeOptions) {
                if (typeof filter !== "string") throw new Error("Invalid argument:" + filter);
                subscribeOptions = subscribeOptions || {};
                validate(subscribeOptions, {
                    qos: "number",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (subscribeOptions.timeout && !subscribeOptions.onFailure) throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    subscribeOptions.qos,
                    "subscribeOptions.qos"
                ]));
                client.subscribe(filter, subscribeOptions);
            };
            /**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.unsubscribe = function(filter, unsubscribeOptions) {
                if (typeof filter !== "string") throw new Error("Invalid argument:" + filter);
                unsubscribeOptions = unsubscribeOptions || {};
                validate(unsubscribeOptions, {
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure) throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                client.unsubscribe(filter, unsubscribeOptions);
            };
            /**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.send = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.publish = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */ this.disconnect = function() {
                client.disconnect();
            };
            /**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */ this.getTraceLog = function() {
                return client.getTraceLog();
            };
            /**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */ this.startTrace = function() {
                client.startTrace();
            };
            /**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */ this.stopTrace = function() {
                client.stopTrace();
            };
            this.isConnected = function() {
                return client.connected;
            };
        };
        /**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */ var Message = function(newPayload) {
            var payload;
            if (typeof newPayload === "string" || newPayload instanceof ArrayBuffer || ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView)) payload = newPayload;
            else throw format(ERROR.INVALID_ARGUMENT, [
                newPayload,
                "newPayload"
            ]);
            var destinationName;
            var qos = 0;
            var retained = false;
            var duplicate = false;
            Object.defineProperties(this, {
                "payloadString": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") return payload;
                        else return parseUTF8(payload, 0, payload.length);
                    }
                },
                "payloadBytes": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") {
                            var buffer = new ArrayBuffer(UTF8Length(payload));
                            var byteStream = new Uint8Array(buffer);
                            stringToUTF8(payload, byteStream, 0);
                            return byteStream;
                        } else return payload;
                    }
                },
                "destinationName": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newDestinationName) {
                        if (typeof newDestinationName === "string") destinationName = newDestinationName;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newDestinationName,
                            "newDestinationName"
                        ]));
                    }
                },
                "qos": {
                    enumerable: true,
                    get: function() {
                        return qos;
                    },
                    set: function(newQos) {
                        if (newQos === 0 || newQos === 1 || newQos === 2) qos = newQos;
                        else throw new Error("Invalid argument:" + newQos);
                    }
                },
                "retained": {
                    enumerable: true,
                    get: function() {
                        return retained;
                    },
                    set: function(newRetained) {
                        if (typeof newRetained === "boolean") retained = newRetained;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newRetained,
                            "newRetained"
                        ]));
                    }
                },
                "topic": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newTopic) {
                        destinationName = newTopic;
                    }
                },
                "duplicate": {
                    enumerable: true,
                    get: function() {
                        return duplicate;
                    },
                    set: function(newDuplicate) {
                        duplicate = newDuplicate;
                    }
                }
            });
        };
        // Module contents.
        return {
            Client: Client,
            Message: Message
        };
    // eslint-disable-next-line no-nested-ternary
    }(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    return PahoMQTT;
});



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e42b8c73ebaf58b9$var$extendStatics = function(d, b) {
    $e42b8c73ebaf58b9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e42b8c73ebaf58b9$var$extendStatics(d, b);
};
function $e42b8c73ebaf58b9$export$a8ba968b8961cb8a(d, b) {
    $e42b8c73ebaf58b9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e42b8c73ebaf58b9$export$18ce0697a983be9b = function() {
    $e42b8c73ebaf58b9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e42b8c73ebaf58b9$export$18ce0697a983be9b.apply(this, arguments);
};
function $e42b8c73ebaf58b9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e42b8c73ebaf58b9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e42b8c73ebaf58b9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e42b8c73ebaf58b9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e42b8c73ebaf58b9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e42b8c73ebaf58b9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e42b8c73ebaf58b9$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e42b8c73ebaf58b9$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e42b8c73ebaf58b9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e42b8c73ebaf58b9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e42b8c73ebaf58b9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e42b8c73ebaf58b9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e42b8c73ebaf58b9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e42b8c73ebaf58b9$export$10c90e4f7922046c(v) {
    return this instanceof $e42b8c73ebaf58b9$export$10c90e4f7922046c ? (this.v = v, this) : new $e42b8c73ebaf58b9$export$10c90e4f7922046c(v);
}
function $e42b8c73ebaf58b9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e42b8c73ebaf58b9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e42b8c73ebaf58b9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e42b8c73ebaf58b9$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e42b8c73ebaf58b9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e42b8c73ebaf58b9$export$19a8beecd37a4c45 === "function" ? $e42b8c73ebaf58b9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e42b8c73ebaf58b9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e42b8c73ebaf58b9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e42b8c73ebaf58b9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e42b8c73ebaf58b9$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e42b8c73ebaf58b9$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $bc303f47c32b5611$var$genericMessage = "Invariant Violation";
var $bc303f47c32b5611$var$_a = Object.setPrototypeOf, $bc303f47c32b5611$var$setPrototypeOf = $bc303f47c32b5611$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $bc303f47c32b5611$var$_a;
var $bc303f47c32b5611$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $e42b8c73ebaf58b9$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $bc303f47c32b5611$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $bc303f47c32b5611$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $bc303f47c32b5611$var$genericMessage;
        $bc303f47c32b5611$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $bc303f47c32b5611$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $bc303f47c32b5611$export$cea12affaee22fe8(message);
}
function $bc303f47c32b5611$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $bc303f47c32b5611$var$wrapConsoleMethod("warn");
    invariant.error = $bc303f47c32b5611$var$wrapConsoleMethod("error");
})($bc303f47c32b5611$export$f5708dca728d7177 || ($bc303f47c32b5611$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $bc303f47c32b5611$export$e54fe5b0f43758f7 = {
    env: {}
};
try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($bc303f47c32b5611$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $bc303f47c32b5611$var$invariant$1 = $bc303f47c32b5611$export$f5708dca728d7177;
var $bc303f47c32b5611$export$2e2bcd8739ae039 = $bc303f47c32b5611$var$invariant$1;




var $5a73e07fa2a990d4$var$_a = Object.prototype, $5a73e07fa2a990d4$var$toString = $5a73e07fa2a990d4$var$_a.toString, $5a73e07fa2a990d4$var$hasOwnProperty = $5a73e07fa2a990d4$var$_a.hasOwnProperty;
var $5a73e07fa2a990d4$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $5a73e07fa2a990d4$export$411ce8e5a71e3069(a, b) {
    try {
        return $5a73e07fa2a990d4$var$check(a, b);
    } finally{
        $5a73e07fa2a990d4$var$previousComparisons.clear();
    }
}
function $5a73e07fa2a990d4$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $5a73e07fa2a990d4$var$toString.call(a);
    var bTag = $5a73e07fa2a990d4$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($5a73e07fa2a990d4$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$5a73e07fa2a990d4$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$5a73e07fa2a990d4$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($5a73e07fa2a990d4$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$5a73e07fa2a990d4$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $5a73e07fa2a990d4$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $5a73e07fa2a990d4$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $5a73e07fa2a990d4$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $5a73e07fa2a990d4$export$2e2bcd8739ae039 = $5a73e07fa2a990d4$export$411ce8e5a71e3069;


function $72319acb0396de54$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $72319acb0396de54$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $72319acb0396de54$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $72319acb0396de54$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $72319acb0396de54$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $72319acb0396de54$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $72319acb0396de54$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $72319acb0396de54$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $72319acb0396de54$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $72319acb0396de54$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $72319acb0396de54$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $72319acb0396de54$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($72319acb0396de54$var$isIntValue(value) || $72319acb0396de54$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($72319acb0396de54$var$isBooleanValue(value) || $72319acb0396de54$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($72319acb0396de54$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $72319acb0396de54$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($72319acb0396de54$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($72319acb0396de54$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $72319acb0396de54$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($72319acb0396de54$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($72319acb0396de54$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $bc303f47c32b5611$export$cea12affaee22fe8)(17);
}
function $72319acb0396de54$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $72319acb0396de54$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $72319acb0396de54$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $72319acb0396de54$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $72319acb0396de54$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $72319acb0396de54$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($d2d1e34902e2629b$exports)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($72319acb0396de54$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $72319acb0396de54$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $72319acb0396de54$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $72319acb0396de54$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $72319acb0396de54$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $72319acb0396de54$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $72319acb0396de54$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $72319acb0396de54$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $72319acb0396de54$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $72319acb0396de54$var$defaultValueFromVariable(node) {
    throw new (0, $bc303f47c32b5611$export$cea12affaee22fe8)(18);
}
function $72319acb0396de54$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $72319acb0396de54$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $72319acb0396de54$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $72319acb0396de54$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $72319acb0396de54$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $72319acb0396de54$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $72319acb0396de54$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $72319acb0396de54$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $bc303f47c32b5611$export$f5708dca728d7177)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $72319acb0396de54$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $aed09fe0dab48b39$exports.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $72319acb0396de54$export$2dafb573e282fe8d(names, doc) {
    return $72319acb0396de54$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $72319acb0396de54$export$8d1e9e5bbfa5d09a(document) {
    return document && $72319acb0396de54$export$2dafb573e282fe8d([
        'client'
    ], document) && $72319acb0396de54$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $72319acb0396de54$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $72319acb0396de54$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($72319acb0396de54$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $bc303f47c32b5611$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $bc303f47c32b5611$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $bc303f47c32b5611$export$f5708dca728d7177)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $72319acb0396de54$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $bc303f47c32b5611$export$cea12affaee22fe8)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $bc303f47c32b5611$export$f5708dca728d7177)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)((0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $e42b8c73ebaf58b9$export$6388937ca91ccae8)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $72319acb0396de54$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $72319acb0396de54$export$a92e7a440b22bdf0(doc) {
    $72319acb0396de54$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(mutationDef, 1);
    return mutationDef;
}
function $72319acb0396de54$export$a7d0d8111d2386df(doc) {
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $bc303f47c32b5611$export$cea12affaee22fe8)(3);
        return definition;
    });
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(operations.length <= 1, 4);
    return doc;
}
function $72319acb0396de54$export$7a5b1fa979d2c158(doc) {
    $72319acb0396de54$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $72319acb0396de54$export$78a8e95d8d43ad7f(document) {
    var def = $72319acb0396de54$export$7a5b1fa979d2c158(document);
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(def, 5);
    return def;
}
function $72319acb0396de54$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $72319acb0396de54$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $72319acb0396de54$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $72319acb0396de54$export$7a5b1fa979d2c158(doc);
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $72319acb0396de54$export$772111caef41b3f5(doc) {
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(doc.kind === 'Document', 7);
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $bc303f47c32b5611$export$f5708dca728d7177)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $72319acb0396de54$export$f431198736b7f96d(queryDoc) {
    $72319acb0396de54$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $bc303f47c32b5611$export$cea12affaee22fe8)(10);
}
function $72319acb0396de54$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $72319acb0396de54$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $72319acb0396de54$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $72319acb0396de54$export$e6e34fd1f2686227.apply(void 0, (0, $e42b8c73ebaf58b9$export$6388937ca91ccae8)([
            {}
        ], defaultValues));
    }
    return {};
}
function $72319acb0396de54$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $72319acb0396de54$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $72319acb0396de54$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $72319acb0396de54$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $72319acb0396de54$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $72319acb0396de54$var$nullIfDocIsEmpty(doc) {
    return $72319acb0396de54$var$isEmpty($72319acb0396de54$export$7a5b1fa979d2c158(doc) || $72319acb0396de54$export$772111caef41b3f5(doc), $72319acb0396de54$export$193789b4c8246dd4($72319acb0396de54$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $72319acb0396de54$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $72319acb0396de54$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $72319acb0396de54$var$nullIfDocIsEmpty((0, $aed09fe0dab48b39$exports.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($72319acb0396de54$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $72319acb0396de54$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($72319acb0396de54$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $72319acb0396de54$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $72319acb0396de54$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $72319acb0396de54$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $72319acb0396de54$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $72319acb0396de54$export$43b332f87950a467(doc) {
    return (0, $aed09fe0dab48b39$exports.visit)($72319acb0396de54$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $72319acb0396de54$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($72319acb0396de54$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)((0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $e42b8c73ebaf58b9$export$6388937ca91ccae8)(selections, [
                        $72319acb0396de54$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $72319acb0396de54$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $72319acb0396de54$export$74985f3324559867(doc) {
    return $72319acb0396de54$export$e5ae0530da5fe96c([
        $72319acb0396de54$var$connectionRemoveConfig
    ], $72319acb0396de54$export$a7d0d8111d2386df(doc));
}
function $72319acb0396de54$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $72319acb0396de54$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $72319acb0396de54$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$72319acb0396de54$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($72319acb0396de54$var$getDirectiveMatcher(directives)) || nestedCheck && $72319acb0396de54$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $72319acb0396de54$export$deed3420cb5d2e1d(directives, doc) {
    $72319acb0396de54$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $72319acb0396de54$var$nullIfDocIsEmpty((0, $aed09fe0dab48b39$exports.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $72319acb0396de54$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($72319acb0396de54$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)((0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $72319acb0396de54$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $72319acb0396de54$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $72319acb0396de54$var$getArgumentMatcher(config);
    return $72319acb0396de54$var$nullIfDocIsEmpty((0, $aed09fe0dab48b39$exports.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)((0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $72319acb0396de54$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $72319acb0396de54$var$nullIfDocIsEmpty((0, $aed09fe0dab48b39$exports.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $72319acb0396de54$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($72319acb0396de54$export$fb56ad75dd311c12(selection) || $72319acb0396de54$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $72319acb0396de54$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $72319acb0396de54$export$57c368c23873f32b(document) {
    var definition = $72319acb0396de54$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $aed09fe0dab48b39$exports.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)((0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $72319acb0396de54$export$8eae69e876ee321e(document) {
    $72319acb0396de54$export$a7d0d8111d2386df(document);
    var modifiedDoc = $72319acb0396de54$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $aed09fe0dab48b39$exports.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $72319acb0396de54$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $72319acb0396de54$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $72319acb0396de54$var$toString = Object.prototype.toString;
function $72319acb0396de54$export$629a2bd3f5a49ecc(value) {
    return $72319acb0396de54$var$cloneDeepHelper(value, new Map());
}
function $72319acb0396de54$var$cloneDeepHelper(val, seen) {
    switch($72319acb0396de54$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $72319acb0396de54$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $72319acb0396de54$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $72319acb0396de54$export$4bd44a2aa29d3d6e() {
    return 'development';
}
function $72319acb0396de54$export$f0cb0fda19c18b37(env) {
    return $72319acb0396de54$export$4bd44a2aa29d3d6e() === env;
}
function $72319acb0396de54$export$f15d00aa73aafac4() {
    return $72319acb0396de54$export$f0cb0fda19c18b37('production') === true;
}
function $72319acb0396de54$export$df77466336fe5355() {
    return $72319acb0396de54$export$f0cb0fda19c18b37('development') === true;
}
function $72319acb0396de54$export$410cbc2864fa25b5() {
    return $72319acb0396de54$export$f0cb0fda19c18b37('test') === true;
}
function $72319acb0396de54$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $72319acb0396de54$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $72319acb0396de54$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $72319acb0396de54$var$deepFreeze(o[prop]);
    });
    return o;
}
function $72319acb0396de54$export$7f9c177735b71f18(obj) {
    if ($72319acb0396de54$export$df77466336fe5355() || $72319acb0396de54$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $72319acb0396de54$var$deepFreeze(obj);
    }
    return obj;
}
var $72319acb0396de54$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72319acb0396de54$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $72319acb0396de54$export$160070228be94b08(sources);
}
function $72319acb0396de54$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $72319acb0396de54$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $72319acb0396de54$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $72319acb0396de54$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $72319acb0396de54$var$mergeHelper(target, source, pastCopies) {
    if ($72319acb0396de54$var$isObject(source) && $72319acb0396de54$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $72319acb0396de54$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($72319acb0396de54$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $72319acb0396de54$var$mergeHelper($72319acb0396de54$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $72319acb0396de54$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $e42b8c73ebaf58b9$export$18ce0697a983be9b)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $72319acb0396de54$var$haveWarned = Object.create({});
function $72319acb0396de54$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$72319acb0396de54$export$f15d00aa73aafac4() && !$72319acb0396de54$var$haveWarned[msg]) {
        if (!$72319acb0396de54$export$410cbc2864fa25b5()) $72319acb0396de54$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $72319acb0396de54$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}


var $f6539c95c5f2a32a$var$logger = $573cfb6c72c1b335$exports.rootLogger.extend('subscriptions');
var $f6539c95c5f2a32a$var$mqttLogger = $f6539c95c5f2a32a$var$logger.extend('mqtt');
$f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY = '@@controlEvents';
var $f6539c95c5f2a32a$var$SubscriptionHandshakeLink = /** @class */ function(_super) {
    $f6539c95c5f2a32a$var$__extends(SubscriptionHandshakeLink, _super);
    function SubscriptionHandshakeLink(subsInfoContextKey) {
        var _this = _super.call(this) || this;
        _this.topicObservers = new Map();
        _this.clientObservers = new Map();
        _this.onMessage = function(topic, message, selectionNames) {
            var parsedMessage = JSON.parse(message);
            var observers = _this.topicObservers.get(topic);
            var data = selectionNames.reduce(function(acc, name) {
                return acc[name] = acc[name] || null, acc;
            }, parsedMessage.data || {});
            $f6539c95c5f2a32a$var$logger('Message received', {
                data: data,
                topic: topic,
                observers: observers
            });
            observers.forEach(function(observer) {
                try {
                    observer.next($f6539c95c5f2a32a$var$__assign($f6539c95c5f2a32a$var$__assign({}, parsedMessage), {
                        data: data
                    }));
                } catch (err) {
                    $f6539c95c5f2a32a$var$logger(err);
                }
            });
        };
        _this.subsInfoContextKey = subsInfoContextKey;
        return _this;
    }
    SubscriptionHandshakeLink.prototype.request = function(operation) {
        var _a;
        var _this = this;
        var _b = operation.getContext(), _c = this.subsInfoContextKey, subsInfo = _b[_c], _d = _b.controlMessages, _e = $f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY, controlEvents = (_d === void 0 ? (_a = {}, _a[$f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY] = undefined, _a) : _d)[_e];
        var _f = subsInfo.extensions, _g = (_f === void 0 ? {
            subscription: {
                newSubscriptions: {},
                mqttConnections: []
            }
        } : _f).subscription, newSubscriptions = _g.newSubscriptions, mqttConnections = _g.mqttConnections, _h = subsInfo.errors, errors = _h === void 0 ? [] : _h;
        if (errors && errors.length) return new $5b50e19789d289fa$export$77cea355fa80b5f4(function(observer) {
            observer.error(new $b937ee76313d8ee6$export$26a337512320b8c6({
                errorMessage: 'Error during subscription handshake',
                extraInfo: {
                    errors: errors
                },
                graphQLErrors: errors
            }));
            return function() {};
        });
        var newSubscriptionTopics = Object.keys(newSubscriptions).map(function(subKey) {
            return newSubscriptions[subKey].topic;
        });
        var existingTopicsWithObserver = new Set(newSubscriptionTopics.filter(function(t) {
            return _this.topicObservers.has(t);
        }));
        var newTopics = new Set(newSubscriptionTopics.filter(function(t) {
            return !existingTopicsWithObserver.has(t);
        }));
        return new $5b50e19789d289fa$export$77cea355fa80b5f4(function(observer) {
            existingTopicsWithObserver.forEach(function(t) {
                _this.topicObservers.get(t).add(observer);
                var anObserver = Array.from(_this.topicObservers.get(t)).find(function() {
                    return true;
                });
                var clientId = Array.from(_this.clientObservers).find(function(_a) {
                    var observers = _a[1].observers;
                    return observers.has(anObserver);
                })[0];
                _this.clientObservers.get(clientId).observers.add(observer);
            });
            var newTopicsConnectionInfo = mqttConnections.filter(function(c) {
                return c.topics.some(function(t) {
                    return newTopics.has(t);
                });
            }).map(function(_a) {
                var topics = _a.topics, rest = $f6539c95c5f2a32a$var$__rest(_a, [
                    "topics"
                ]);
                return $f6539c95c5f2a32a$var$__assign($f6539c95c5f2a32a$var$__assign({}, rest), {
                    topics: topics.filter(function(t) {
                        return newTopics.has(t);
                    })
                });
            });
            _this.connectNewClients(newTopicsConnectionInfo, observer, operation);
            return function() {
                var clientsForCurrentObserver = Array.from(_this.clientObservers).filter(function(_a) {
                    var observers = _a[1].observers;
                    return observers.has(observer);
                });
                clientsForCurrentObserver.forEach(function(_a) {
                    var clientId = _a[0];
                    return _this.clientObservers.get(clientId).observers.delete(observer);
                });
                _this.clientObservers.forEach(function(_a) {
                    var observers = _a.observers, client = _a.client;
                    if (observers.size === 0) {
                        if (client.isConnected()) client.disconnect();
                        _this.clientObservers.delete(client.clientId);
                    }
                });
                _this.clientObservers = new Map(Array.from(_this.clientObservers).filter(function(_a) {
                    var observers = _a[1].observers;
                    return observers.size > 0;
                }));
                _this.topicObservers.forEach(function(observers) {
                    return observers.delete(observer);
                });
                _this.topicObservers = new Map(Array.from(_this.topicObservers).filter(function(_a) {
                    var observers = _a[1];
                    return observers.size > 0;
                }));
            };
        }).filter(function(data) {
            var _a = data.extensions, _b = (_a === void 0 ? {} : _a).controlMsgType, controlMsgType = _b === void 0 ? undefined : _b;
            var isControlMsg = typeof controlMsgType !== 'undefined';
            return controlEvents === true || !isControlMsg;
        });
    };
    SubscriptionHandshakeLink.prototype.connectNewClients = function(connectionInfo, observer, operation) {
        return $f6539c95c5f2a32a$var$__awaiter(this, void 0, void 0, function() {
            var query, selectionNames, result, data;
            var _this = this;
            return $f6539c95c5f2a32a$var$__generator(this, function(_a) {
                query = operation.query;
                selectionNames = $72319acb0396de54$export$f431198736b7f96d(query).selectionSet.selections.map(function(_a) {
                    var value = _a.name.value;
                    return value;
                });
                result = Promise.all(connectionInfo.map(function(c) {
                    return _this.connectNewClient(c, observer, selectionNames);
                }));
                data = selectionNames.reduce(function(acc, name) {
                    return acc[name] = acc[name] || null, acc;
                }, {});
                observer.next({
                    data: data,
                    extensions: {
                        controlMsgType: 'CONNECTED',
                        controlMsgInfo: {
                            connectionInfo: connectionInfo
                        }
                    }
                });
                return [
                    2 /*return*/ ,
                    result
                ];
            });
        });
    };
    SubscriptionHandshakeLink.prototype.connectNewClient = function(connectionInfo, observer, selectionNames) {
        return $f6539c95c5f2a32a$var$__awaiter(this, void 0, void 0, function() {
            var clientId, url, topics, client;
            var _this = this;
            return $f6539c95c5f2a32a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        clientId = connectionInfo.client, url = connectionInfo.url, topics = connectionInfo.topics;
                        client = new $0c32d268e8d918d9$exports.Client(url, clientId);
                        client.trace = $f6539c95c5f2a32a$var$mqttLogger.bind(null, clientId);
                        client.onConnectionLost = function(_a) {
                            var errorCode = _a.errorCode, args = $f6539c95c5f2a32a$var$__rest(_a, [
                                "errorCode"
                            ]);
                            if (errorCode !== 0) topics.forEach(function(t) {
                                if (_this.topicObservers.has(t)) _this.topicObservers.get(t).forEach(function(observer) {
                                    return observer.error($f6539c95c5f2a32a$var$__assign($f6539c95c5f2a32a$var$__assign({}, args), {
                                        permanent: true
                                    }));
                                });
                            });
                            topics.forEach(function(t) {
                                return _this.topicObservers.delete(t);
                            });
                        };
                        client.onMessageArrived = function(_a) {
                            var destinationName = _a.destinationName, payloadString = _a.payloadString;
                            return _this.onMessage(destinationName, payloadString, selectionNames);
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                client.connect({
                                    useSSL: url.indexOf('wss://') === 0,
                                    mqttVersion: 3,
                                    onSuccess: function() {
                                        return resolve(client);
                                    },
                                    onFailure: reject
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.subscribeToTopics(client, topics, observer)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    SubscriptionHandshakeLink.prototype.subscribeToTopics = function(client, topics, observer) {
        var _this = this;
        return Promise.all(topics.map(function(topic) {
            return _this.subscribeToTopic(client, topic, observer);
        }));
    };
    SubscriptionHandshakeLink.prototype.subscribeToTopic = function(client, topic, observer) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            client.subscribe(topic, {
                onSuccess: function() {
                    if (!_this.topicObservers.has(topic)) _this.topicObservers.set(topic, new Set());
                    if (!_this.clientObservers.has(client.clientId)) _this.clientObservers.set(client.clientId, {
                        client: client,
                        observers: new Set()
                    });
                    _this.topicObservers.get(topic).add(observer);
                    _this.clientObservers.get(client.clientId).observers.add(observer);
                    resolve(topic);
                },
                onFailure: reject
            });
        });
    };
    return SubscriptionHandshakeLink;
}($24e18527a43b07a2$export$2fed3d61f740bc7f);
$f6539c95c5f2a32a$exports.SubscriptionHandshakeLink = $f6539c95c5f2a32a$var$SubscriptionHandshakeLink;


Object.defineProperty($7f42520b6e9d7224$exports, "CONTROL_EVENTS_KEY", {
    enumerable: true,
    get: function() {
        return $f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY;
    }
});





function $8a3d0f3a74be5946$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $8a3d0f3a74be5946$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(evaledValue !== void 0, 105, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $8a3d0f3a74be5946$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $8a3d0f3a74be5946$export$528b5e7d8ba07fbf = function(names, root) {
    return $8a3d0f3a74be5946$export$2dafb573e282fe8d(names, root, false);
};
var $8a3d0f3a74be5946$export$ad1b63b26c1a9b76 = function(names, root) {
    return $8a3d0f3a74be5946$export$2dafb573e282fe8d(names, root, true);
};
function $8a3d0f3a74be5946$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $0f36c934b7f2a151$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $8a3d0f3a74be5946$export$8d1e9e5bbfa5d09a(document) {
    return document && $8a3d0f3a74be5946$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $8a3d0f3a74be5946$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $8a3d0f3a74be5946$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$8a3d0f3a74be5946$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 106, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 107, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $2eb7c81495a30e7e$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 108, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $8a3d0f3a74be5946$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).VARIABLE) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(109);
            else if (modeArg.value.kind !== (0, $343e0f81579b8ed3$export$a84bdc57c5122798).STRING) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(110);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(111, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}







// A version of Array.isArray that works better with readonly arrays.
var $aca77c2f393daf5d$export$43bee75e5e14138e = Array.isArray;
function $aca77c2f393daf5d$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $9e7e4cfb850b6dcc$var$TYPENAME_FIELD = {
    kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $9e7e4cfb850b6dcc$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_SPREAD && $9e7e4cfb850b6dcc$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $9e7e4cfb850b6dcc$var$nullIfDocIsEmpty(doc) {
    return $9e7e4cfb850b6dcc$var$isEmpty((0, $bdcb7f3ac338176f$export$7a5b1fa979d2c158)(doc) || (0, $bdcb7f3ac338176f$export$772111caef41b3f5)(doc), (0, $c6a6aa3a7c270c22$export$193789b4c8246dd4)((0, $bdcb7f3ac338176f$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $9e7e4cfb850b6dcc$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $9e7e4cfb850b6dcc$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $9e7e4cfb850b6dcc$export$e5ae0530da5fe96c(directives, doc) {
    (0, $bdcb7f3ac338176f$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $9e7e4cfb850b6dcc$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $9e7e4cfb850b6dcc$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $aca77c2f393daf5d$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).error(124);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $9e7e4cfb850b6dcc$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $aca77c2f393daf5d$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $9e7e4cfb850b6dcc$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $9e7e4cfb850b6dcc$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $60e5b25a31d8fc3c$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $60e5b25a31d8fc3c$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([], selections, true), [
                        $9e7e4cfb850b6dcc$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $9e7e4cfb850b6dcc$var$TYPENAME_FIELD;
    }
});
var $9e7e4cfb850b6dcc$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(125);
        }
        return willRemove;
    }
};
function $9e7e4cfb850b6dcc$export$74985f3324559867(doc) {
    return $9e7e4cfb850b6dcc$export$e5ae0530da5fe96c([
        $9e7e4cfb850b6dcc$var$connectionRemoveConfig
    ], (0, $bdcb7f3ac338176f$export$a7d0d8111d2386df)(doc));
}
function $9e7e4cfb850b6dcc$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $9e7e4cfb850b6dcc$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $9e7e4cfb850b6dcc$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $60e5b25a31d8fc3c$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($9e7e4cfb850b6dcc$var$getDirectiveMatcher(directives)) || nestedCheck && $9e7e4cfb850b6dcc$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $9e7e4cfb850b6dcc$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $343e0f81579b8ed3$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $9e7e4cfb850b6dcc$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $9e7e4cfb850b6dcc$var$getArgumentMatcher(config);
    return $9e7e4cfb850b6dcc$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $9e7e4cfb850b6dcc$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $9e7e4cfb850b6dcc$var$nullIfDocIsEmpty((0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $9e7e4cfb850b6dcc$export$57c368c23873f32b(document) {
    var definition = (0, $bdcb7f3ac338176f$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $9e7e4cfb850b6dcc$export$8eae69e876ee321e(document) {
    (0, $bdcb7f3ac338176f$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $9e7e4cfb850b6dcc$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $9e7e4cfb850b6dcc$export$b6125cad5877ac5e(document) {
    (0, $bdcb7f3ac338176f$export$a7d0d8111d2386df)(document);
    return (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, node), {
                directives: (0, $e1a311bc8034de19$export$1216008129fb82ed)((0, $e1a311bc8034de19$export$1216008129fb82ed)([], node.directives || [], true), [
                    {
                        kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $343e0f81579b8ed3$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}



var $94f16b87abe0000e$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $2eb7c81495a30e7e$export$3991762405098ea)(54, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $b085f004d8a00531$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $f5076b2365d472e1$var$isReactNative = (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $f5076b2365d472e1$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($f5076b2365d472e1$var$isReactNative && !$parcel$global.HermesInternal);
var $f5076b2365d472e1$export$7293b8a0b474028d = typeof WeakSet === "function";
var $f5076b2365d472e1$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $f5076b2365d472e1$export$c34f882e9f1c1637 = $f5076b2365d472e1$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $f5076b2365d472e1$export$71594e8a50f746f4 = typeof (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $f5076b2365d472e1$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $f5076b2365d472e1$export$4001f6cd4a62405b = ($f5076b2365d472e1$export$71594e8a50f746f4 || $f5076b2365d472e1$var$isReactNative) && !$f5076b2365d472e1$var$usingJSDOM;


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $69a2689ae4922292$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $0dbc0819ea06a94b$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $f5076b2365d472e1$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $2918e88361e847b0$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $f5076b2365d472e1$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $de7acbe29ded0dda$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $f5076b2365d472e1$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $2f7879bd2bb4dba7$var$isNodeResponse(value) {
    return !!value.body;
}
function $2f7879bd2bb4dba7$var$isReadableStream(value) {
    return !!value.getReader;
}
function $2f7879bd2bb4dba7$var$isAsyncIterableIterator(value) {
    return !!((0, $f5076b2365d472e1$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $2f7879bd2bb4dba7$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $2f7879bd2bb4dba7$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $2f7879bd2bb4dba7$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $2f7879bd2bb4dba7$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($2f7879bd2bb4dba7$var$isNodeResponse(response)) body = response.body;
    if ($2f7879bd2bb4dba7$var$isAsyncIterableIterator(body)) return (0, $69a2689ae4922292$export$2e2bcd8739ae039)(body);
    if ($2f7879bd2bb4dba7$var$isReadableStream(body)) return (0, $de7acbe29ded0dda$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($2f7879bd2bb4dba7$var$isStreamableBlob(body)) return (0, $de7acbe29ded0dda$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($2f7879bd2bb4dba7$var$isBlob(body)) return (0, $2918e88361e847b0$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($2f7879bd2bb4dba7$var$isNodeReadableStream(body)) return (0, $0dbc0819ea06a94b$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


/**
 * @deprecated `throwServerError` will be removed in Apollo Client 4.0. This is
 * safe to use in Apollo Client 3.x.
 *
 * **Recommended now**
 *
 * No action needed
 *
 * **When migrating**
 *
 * `ServerError` is a subclass of `Error`. To throw a server error, use
 * `throw new ServerError(...)` instead.
 *
 * ```ts
 * throw new ServerError("error message", { response, result });
 * ```
 */ var $2c7c54c7f586feee$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};







var $775b50bacfb63355$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $775b50bacfb63355$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $775b50bacfb63355$export$160070228be94b08(sources);
}
function $775b50bacfb63355$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $775b50bacfb63355$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $775b50bacfb63355$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $775b50bacfb63355$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $775b50bacfb63355$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $eb1b7151939a7f3b$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $eb1b7151939a7f3b$export$417207af72fad9c9)(source) && (0, $eb1b7151939a7f3b$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($775b50bacfb63355$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $e1a311bc8034de19$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $eb1b7151939a7f3b$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $e1a311bc8034de19$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $ba045485dcebcc2a$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $ba045485dcebcc2a$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $ba045485dcebcc2a$export$f90dc0a3531b8b83(value) {
    return $ba045485dcebcc2a$export$879767c5cdf33cb3(value) || $ba045485dcebcc2a$export$6c17a45d8c64ff02(value);
}
function $ba045485dcebcc2a$export$3f32b6369f408f33(value) {
    return (0, $eb1b7151939a7f3b$export$417207af72fad9c9)(value) && "payload" in value;
}
function $ba045485dcebcc2a$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $775b50bacfb63355$export$509e11c221f576c0)();
    if ($ba045485dcebcc2a$export$879767c5cdf33cb3(result) && (0, $aca77c2f393daf5d$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $1645c80d34e8a6cb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1645c80d34e8a6cb$export$ccb60864026baf09(response, nextValue) {
    return (0, $e1a311bc8034de19$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $e1a311bc8034de19$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $2f7879bd2bb4dba7$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $1645c80d34e8a6cb$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $1645c80d34e8a6cb$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $ba045485dcebcc2a$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $b937ee76313d8ee6$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $1645c80d34e8a6cb$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $1645c80d34e8a6cb$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $2c7c54c7f586feee$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $1645c80d34e8a6cb$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $1645c80d34e8a6cb$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $1645c80d34e8a6cb$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$1645c80d34e8a6cb$var$hasOwnProperty.call(result, "data") && !$1645c80d34e8a6cb$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $2c7c54c7f586feee$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $4b58c38ab9a5e7a7$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $2eb7c81495a30e7e$export$3991762405098ea)(51);
};






var $0fa219f4483fe1b4$var$printCache;
var $0fa219f4483fe1b4$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $0fa219f4483fe1b4$var$printCache.get(ast);
    if (!result) {
        result = (0, $c358b437c3ffbcb0$export$c2d084dc44961371)(ast);
        $0fa219f4483fe1b4$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $0fa219f4483fe1b4$var$printCache = new (0, $ecbc49d50bf3b336$export$8dbad6f439bb2331)((0, $5ee7d26f5ccf9fde$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$0fa219f4483fe1b4$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $1b3de6a864a1d125$export$a8fcd406d9e37621)("print", function() {
    return $0fa219f4483fe1b4$var$printCache ? $0fa219f4483fe1b4$var$printCache.size : 0;
});


var $ec6a9deec52c7abb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $ec6a9deec52c7abb$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $ec6a9deec52c7abb$var$defaultOptions = {
    method: "POST"
};
var $ec6a9deec52c7abb$export$dd86f00dc866e75d = {
    http: $ec6a9deec52c7abb$var$defaultHttpOptions,
    headers: $ec6a9deec52c7abb$var$defaultHeaders,
    options: $ec6a9deec52c7abb$var$defaultOptions
};
var $ec6a9deec52c7abb$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $ec6a9deec52c7abb$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $ec6a9deec52c7abb$export$12d90ccf75844275.apply(void 0, (0, $e1a311bc8034de19$export$1216008129fb82ed)([
        operation,
        $ec6a9deec52c7abb$export$e88934976ca4fd65
    ], configs, false));
}
function $ec6a9deec52c7abb$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $ec6a9deec52c7abb$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $0fa219f4483fe1b4$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $ec6a9deec52c7abb$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $ad5cc2337954469e$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $94f16b87abe0000e$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $94f16b87abe0000e$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $39d967706eb6acf9$export$de246493ae27fe3f(variables, query) {
    var result = (0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $0f36c934b7f2a151$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $db69d3d49de8aa6c$export$4fd972edbe7450d3(errorValue) {
    return new (0, $5b50e19789d289fa$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $188346718a8d2ae9$var$backupFetch = (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $188346718a8d2ae9$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $ec6a9deec52c7abb$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $e1a311bc8034de19$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $4b58c38ab9a5e7a7$export$8423f0cd3773115e)(preferredFetch || $188346718a8d2ae9$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $24e18527a43b07a2$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $b085f004d8a00531$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $e1a311bc8034de19$export$18ce0697a983be9b)((0, $e1a311bc8034de19$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $8a3d0f3a74be5946$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(52);
            var transformedQuery = (0, $9e7e4cfb850b6dcc$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $db69d3d49de8aa6c$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $ec6a9deec52c7abb$export$12d90ccf75844275)(operation, print, (0, $ec6a9deec52c7abb$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $39d967706eb6acf9$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $bdcb7f3ac338176f$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $8a3d0f3a74be5946$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $2eb7c81495a30e7e$export$f5708dca728d7177).warn(53);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $ad5cc2337954469e$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $db69d3d49de8aa6c$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $94f16b87abe0000e$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $db69d3d49de8aa6c$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $5b50e19789d289fa$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $5d3fb052df146bb1$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $188346718a8d2ae9$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $1645c80d34e8a6cb$export$ccb60864026baf09)(response, observerNext);
                else return (0, $1645c80d34e8a6cb$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $1645c80d34e8a6cb$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};



var $e42acb5d0ddde8b1$exports = {};
"use strict";
var $e42acb5d0ddde8b1$var$__extends = $e42acb5d0ddde8b1$exports && $e42acb5d0ddde8b1$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e42acb5d0ddde8b1$var$__assign = $e42acb5d0ddde8b1$exports && $e42acb5d0ddde8b1$exports.__assign || function() {
    $e42acb5d0ddde8b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e42acb5d0ddde8b1$var$__assign.apply(this, arguments);
};
var $e42acb5d0ddde8b1$var$__awaiter = $e42acb5d0ddde8b1$exports && $e42acb5d0ddde8b1$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e42acb5d0ddde8b1$var$__generator = $e42acb5d0ddde8b1$exports && $e42acb5d0ddde8b1$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($e42acb5d0ddde8b1$exports, "__esModule", {
    value: true
});
$e42acb5d0ddde8b1$exports.NonTerminatingLink = void 0;




function $6a66087bb1ef69cb$export$2f04de43fe27971a(setter) {
    return new (0, $24e18527a43b07a2$export$2fed3d61f740bc7f)(function(operation, forward) {
        var request = (0, $e1a311bc8034de19$export$3c9a16f847548506)(operation, []);
        return new (0, $5b50e19789d289fa$export$77cea355fa80b5f4)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}


var $e42acb5d0ddde8b1$var$NonTerminatingLink = /** @class */ function(_super) {
    $e42acb5d0ddde8b1$var$__extends(NonTerminatingLink, _super);
    function NonTerminatingLink(contextKey, _a) {
        var link = _a.link;
        var _this = _super.call(this) || this;
        _this.contextKey = contextKey;
        _this.link = link;
        return _this;
    }
    NonTerminatingLink.prototype.request = function(operation, forward) {
        var _this = this;
        return $6a66087bb1ef69cb$export$2f04de43fe27971a(function(_request, prevContext) {
            return $e42acb5d0ddde8b1$var$__awaiter(_this, void 0, void 0, function() {
                var result;
                var _a;
                var _this = this;
                return $e42acb5d0ddde8b1$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    _this.link.request(operation).subscribe({
                                        next: resolve,
                                        error: reject
                                    });
                                })
                            ];
                        case 1:
                            result = _b.sent();
                            return [
                                2 /*return*/ ,
                                $e42acb5d0ddde8b1$var$__assign($e42acb5d0ddde8b1$var$__assign({}, prevContext), (_a = {}, _a[this.contextKey] = result, _a))
                            ];
                    }
                });
            });
        }).request(operation, forward);
    };
    return NonTerminatingLink;
}($24e18527a43b07a2$export$2fed3d61f740bc7f);
$e42acb5d0ddde8b1$exports.NonTerminatingLink = $e42acb5d0ddde8b1$var$NonTerminatingLink;


var $879b37b55320331f$exports = {};

var $38gB7 = parcelRequire("38gB7");
var $879b37b55320331f$require$Buffer = $38gB7.Buffer;
"use strict";
var $879b37b55320331f$var$__extends = $879b37b55320331f$exports && $879b37b55320331f$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $879b37b55320331f$var$__assign = $879b37b55320331f$exports && $879b37b55320331f$exports.__assign || function() {
    $879b37b55320331f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $879b37b55320331f$var$__assign.apply(this, arguments);
};
var $879b37b55320331f$var$__awaiter = $879b37b55320331f$exports && $879b37b55320331f$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $879b37b55320331f$var$__generator = $879b37b55320331f$exports && $879b37b55320331f$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($879b37b55320331f$exports, "__esModule", {
    value: true
});
$879b37b55320331f$exports.AppSyncRealTimeSubscriptionHandshakeLink = $879b37b55320331f$exports.CONTROL_EVENTS_KEY = void 0;


var $5e834c856ec1e1e2$exports = {};
"use strict";
Object.defineProperty($5e834c856ec1e1e2$exports, "__esModule", {
    value: true
});
$5e834c856ec1e1e2$exports.Signer = $5e834c856ec1e1e2$exports.USER_AGENT = $5e834c856ec1e1e2$exports.USER_AGENT_HEADER = $5e834c856ec1e1e2$exports.AUTH_TYPE = $5e834c856ec1e1e2$exports.AuthLink = $5e834c856ec1e1e2$exports.createAuthLink = void 0;
var $a9a17efd86da7aa3$exports = {};
"use strict";
var $a9a17efd86da7aa3$var$__extends = $a9a17efd86da7aa3$exports && $a9a17efd86da7aa3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a9a17efd86da7aa3$var$__assign = $a9a17efd86da7aa3$exports && $a9a17efd86da7aa3$exports.__assign || function() {
    $a9a17efd86da7aa3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a9a17efd86da7aa3$var$__assign.apply(this, arguments);
};
var $a9a17efd86da7aa3$var$__awaiter = $a9a17efd86da7aa3$exports && $a9a17efd86da7aa3$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a9a17efd86da7aa3$var$__generator = $a9a17efd86da7aa3$exports && $a9a17efd86da7aa3$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($a9a17efd86da7aa3$exports, "__esModule", {
    value: true
});
$a9a17efd86da7aa3$exports.authLink = $a9a17efd86da7aa3$exports.AuthLink = $a9a17efd86da7aa3$exports.AUTH_TYPE = $a9a17efd86da7aa3$exports.USER_AGENT = $a9a17efd86da7aa3$exports.USER_AGENT_HEADER = void 0;


var $3f9b3b748b386fa0$exports = {};
"use strict";
var $3f9b3b748b386fa0$var$__createBinding = $3f9b3b748b386fa0$exports && $3f9b3b748b386fa0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3f9b3b748b386fa0$var$__exportStar = $3f9b3b748b386fa0$exports && $3f9b3b748b386fa0$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3f9b3b748b386fa0$var$__createBinding(exports1, m, p);
};
Object.defineProperty($3f9b3b748b386fa0$exports, "__esModule", {
    value: true
});

/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ $3f9b3b748b386fa0$var$__exportStar((parcelRequire("cX1nd")), $3f9b3b748b386fa0$exports);



var $adm0U = parcelRequire("adm0U");
var $fb9e44da759263d0$exports = {};
"use strict";
Object.defineProperty($fb9e44da759263d0$exports, "__esModule", {
    value: true
});
$fb9e44da759263d0$exports.userAgent = void 0;
var $fb9e44da759263d0$var$userAgent = '';
$fb9e44da759263d0$exports.userAgent = $fb9e44da759263d0$var$userAgent;


var $eed9665dece52134$exports = {};
$eed9665dece52134$exports = JSON.parse("{\"name\":\"aws-appsync-auth-link\",\"version\":\"3.0.8\",\"main\":\"lib/index.js\",\"files\":[\"lib\"],\"license\":\"Apache-2.0\",\"description\":\"AWS Mobile AppSync Auth Link for JavaScript\",\"author\":{\"name\":\"Amazon Web Services\",\"url\":\"https://aws.amazon.com/\"},\"homepage\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git\"},\"scripts\":{\"clean\":\"rm -rf lib\",\"prepare\":\"tsc\",\"test\":\"jest --coverage --coverageReporters=text --passWithNoTests\",\"test-watch\":\"jest --watch\"},\"dependencies\":{\"@aws-crypto/sha256-js\":\"^1.2.0\",\"@aws-sdk/types\":\"^3.25.0\",\"@aws-sdk/util-hex-encoding\":\"^3.29.0\",\"debug\":\"2.6.9\"},\"devDependencies\":{\"@apollo/client\":\"^3.2.0\"},\"peerDependencies\":{\"@apollo/client\":\"3.x\"}}");


var $a9a17efd86da7aa3$var$SERVICE = 'appsync';
$a9a17efd86da7aa3$exports.USER_AGENT_HEADER = 'x-amz-user-agent';
$a9a17efd86da7aa3$exports.USER_AGENT = "aws-amplify/".concat($eed9665dece52134$exports.version).concat($fb9e44da759263d0$exports.userAgent && ' ').concat($fb9e44da759263d0$exports.userAgent);
var $a9a17efd86da7aa3$var$AUTH_TYPE;
(function(AUTH_TYPE) {
    AUTH_TYPE["NONE"] = "NONE";
    AUTH_TYPE["API_KEY"] = "API_KEY";
    AUTH_TYPE["AWS_IAM"] = "AWS_IAM";
    AUTH_TYPE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    AUTH_TYPE["OPENID_CONNECT"] = "OPENID_CONNECT";
    AUTH_TYPE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($a9a17efd86da7aa3$var$AUTH_TYPE = $a9a17efd86da7aa3$exports.AUTH_TYPE || ($a9a17efd86da7aa3$exports.AUTH_TYPE = {}));
var $a9a17efd86da7aa3$var$AuthLink = /** @class */ function(_super) {
    $a9a17efd86da7aa3$var$__extends(AuthLink, _super);
    /**
     *
     * @param {*} options
     */ function AuthLink(options) {
        var _this = _super.call(this) || this;
        _this.link = (0, $a9a17efd86da7aa3$exports.authLink)(options);
        return _this;
    }
    AuthLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return AuthLink;
}($24e18527a43b07a2$export$2fed3d61f740bc7f);
$a9a17efd86da7aa3$exports.AuthLink = $a9a17efd86da7aa3$var$AuthLink;
var $a9a17efd86da7aa3$var$headerBasedAuth = function(_a, operation, forward) {
    var _b = _a === void 0 ? {
        header: '',
        value: ''
    } : _a, header = _b.header, value = _b.value;
    return $a9a17efd86da7aa3$var$__awaiter(void 0, void 0, void 0, function() {
        var origContext, headers, headerValue, _c;
        var _d, _e;
        return $a9a17efd86da7aa3$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    origContext = operation.getContext();
                    headers = $a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({}, origContext.headers), (_d = {}, _d[$a9a17efd86da7aa3$exports.USER_AGENT_HEADER] = $a9a17efd86da7aa3$exports.USER_AGENT, _d));
                    if (!(header && value)) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(typeof value === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value.call(undefined)
                    ];
                case 1:
                    _c = _f.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        value
                    ];
                case 3:
                    _c = _f.sent();
                    _f.label = 4;
                case 4:
                    headerValue = _c;
                    headers = $a9a17efd86da7aa3$var$__assign((_e = {}, _e[header] = headerValue, _e), headers);
                    _f.label = 5;
                case 5:
                    operation.setContext($a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({}, origContext), {
                        headers: headers
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $a9a17efd86da7aa3$var$iamBasedAuth = function(_a, operation, forward) {
    var credentials = _a.credentials, region = _a.region, url = _a.url;
    return $a9a17efd86da7aa3$var$__awaiter(void 0, void 0, void 0, function() {
        var service, origContext, creds, _b, accessKeyId, secretAccessKey, sessionToken, _c, host, path, formatted, headers;
        var _d;
        return $a9a17efd86da7aa3$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    service = $a9a17efd86da7aa3$var$SERVICE;
                    origContext = operation.getContext();
                    creds = typeof credentials === 'function' ? credentials.call() : credentials || {};
                    if (!(creds && typeof creds.getPromise === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        creds.getPromise()
                    ];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        creds
                    ];
                case 3:
                    _b = _e.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                    _c = $adm0U.parse(url), host = _c.host, path = _c.path;
                    formatted = $a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({}, $a9a17efd86da7aa3$var$formatAsRequest(operation, {})), {
                        service: service,
                        region: region,
                        url: url,
                        host: host,
                        path: path
                    });
                    headers = $3f9b3b748b386fa0$exports.Signer.sign(formatted, {
                        access_key: accessKeyId,
                        secret_key: secretAccessKey,
                        session_token: sessionToken
                    }).headers;
                    operation.setContext($a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({}, origContext), {
                        headers: $a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({}, origContext.headers), headers), (_d = {}, _d[$a9a17efd86da7aa3$exports.USER_AGENT_HEADER] = $a9a17efd86da7aa3$exports.USER_AGENT, _d))
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $a9a17efd86da7aa3$var$authLink = function(_a) {
    var url = _a.url, region = _a.region, _b = _a.auth, _c = _b === void 0 ? {} : _b, type = _c.type, auth = _a.auth;
    return new $24e18527a43b07a2$export$2fed3d61f740bc7f(function(operation, forward) {
        return new $5b50e19789d289fa$export$77cea355fa80b5f4(function(observer) {
            var handle;
            var promise;
            switch(type){
                case $a9a17efd86da7aa3$var$AUTH_TYPE.NONE:
                    promise = $a9a17efd86da7aa3$var$headerBasedAuth(undefined, operation, forward);
                    break;
                case $a9a17efd86da7aa3$var$AUTH_TYPE.AWS_IAM:
                    var _a = auth.credentials, credentials = _a === void 0 ? {} : _a;
                    promise = $a9a17efd86da7aa3$var$iamBasedAuth({
                        credentials: credentials,
                        region: region,
                        url: url
                    }, operation, forward);
                    break;
                case $a9a17efd86da7aa3$var$AUTH_TYPE.API_KEY:
                    var _b = auth.apiKey, apiKey = _b === void 0 ? '' : _b;
                    promise = $a9a17efd86da7aa3$var$headerBasedAuth({
                        header: 'X-Api-Key',
                        value: apiKey
                    }, operation, forward);
                    break;
                case $a9a17efd86da7aa3$var$AUTH_TYPE.AMAZON_COGNITO_USER_POOLS:
                case $a9a17efd86da7aa3$var$AUTH_TYPE.OPENID_CONNECT:
                    var _c = auth.jwtToken, jwtToken = _c === void 0 ? '' : _c;
                    promise = $a9a17efd86da7aa3$var$headerBasedAuth({
                        header: 'Authorization',
                        value: jwtToken
                    }, operation, forward);
                    break;
                case $a9a17efd86da7aa3$var$AUTH_TYPE.AWS_LAMBDA:
                    var _d = auth.token, token = _d === void 0 ? '' : _d;
                    promise = $a9a17efd86da7aa3$var$headerBasedAuth({
                        header: 'Authorization',
                        value: token
                    }, operation, forward);
                    break;
                default:
                    var error = new Error("Invalid AUTH_TYPE: ".concat(auth.type));
                    throw error;
            }
            promise.then(function(observable) {
                handle = observable.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
};
$a9a17efd86da7aa3$exports.authLink = $a9a17efd86da7aa3$var$authLink;
var $a9a17efd86da7aa3$var$formatAsRequest = function(_a, options) {
    var operationName = _a.operationName, variables = _a.variables, query = _a.query;
    var body = {
        operationName: operationName,
        variables: $a9a17efd86da7aa3$var$removeTemporaryVariables(variables),
        query: (0, $1e1d9b3d0a6f8566$exports.print)(query)
    };
    return $a9a17efd86da7aa3$var$__assign($a9a17efd86da7aa3$var$__assign({
        body: JSON.stringify(body),
        method: 'POST'
    }, options), {
        headers: $a9a17efd86da7aa3$var$__assign({
            accept: '*/*',
            'content-type': 'application/json; charset=UTF-8'
        }, options.headers)
    });
};
/**
 * Removes all temporary variables (starting with '@@') so that the signature matches the final request.
 */ var $a9a17efd86da7aa3$var$removeTemporaryVariables = function(variables) {
    return Object.keys(variables).filter(function(key) {
        return !key.startsWith("@@");
    }).reduce(function(acc, key) {
        acc[key] = variables[key];
        return acc;
    }, {});
};


Object.defineProperty($5e834c856ec1e1e2$exports, "AuthLink", {
    enumerable: true,
    get: function() {
        return $a9a17efd86da7aa3$exports.AuthLink;
    }
});
Object.defineProperty($5e834c856ec1e1e2$exports, "AUTH_TYPE", {
    enumerable: true,
    get: function() {
        return $a9a17efd86da7aa3$exports.AUTH_TYPE;
    }
});
Object.defineProperty($5e834c856ec1e1e2$exports, "USER_AGENT_HEADER", {
    enumerable: true,
    get: function() {
        return $a9a17efd86da7aa3$exports.USER_AGENT_HEADER;
    }
});
Object.defineProperty($5e834c856ec1e1e2$exports, "USER_AGENT", {
    enumerable: true,
    get: function() {
        return $a9a17efd86da7aa3$exports.USER_AGENT;
    }
});
var $5e834c856ec1e1e2$var$createAuthLink = function(_a) {
    var url = _a.url, region = _a.region, auth = _a.auth;
    return new $a9a17efd86da7aa3$exports.AuthLink({
        url: url,
        region: region,
        auth: auth
    });
};
$5e834c856ec1e1e2$exports.createAuthLink = $5e834c856ec1e1e2$var$createAuthLink;

Object.defineProperty($5e834c856ec1e1e2$exports, "Signer", {
    enumerable: true,
    get: function() {
        return $3f9b3b748b386fa0$exports.Signer;
    }
});




var $adm0U = parcelRequire("adm0U");

var $89f78f67db57fa98$exports = {};
"use strict";
Object.defineProperty($89f78f67db57fa98$exports, "__esModule", {
    value: true
});
$89f78f67db57fa98$exports.MESSAGE_TYPES = $89f78f67db57fa98$exports.SOCKET_STATUS = $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS = void 0;
//#region Subscription link enums
var $89f78f67db57fa98$var$SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($89f78f67db57fa98$var$SUBSCRIPTION_STATUS = $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS || ($89f78f67db57fa98$exports.SUBSCRIPTION_STATUS = {}));
var $89f78f67db57fa98$var$SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($89f78f67db57fa98$var$SOCKET_STATUS = $89f78f67db57fa98$exports.SOCKET_STATUS || ($89f78f67db57fa98$exports.SOCKET_STATUS = {}));
var $89f78f67db57fa98$var$MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error"; // Server -> Client
})($89f78f67db57fa98$var$MESSAGE_TYPES = $89f78f67db57fa98$exports.MESSAGE_TYPES || ($89f78f67db57fa98$exports.MESSAGE_TYPES = {})); //#endregion


var $6e759e78370038e6$exports = {};
"use strict";
var $6e759e78370038e6$var$__extends = $6e759e78370038e6$exports && $6e759e78370038e6$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e759e78370038e6$var$__awaiter = $6e759e78370038e6$exports && $6e759e78370038e6$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6e759e78370038e6$var$__generator = $6e759e78370038e6$exports && $6e759e78370038e6$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($6e759e78370038e6$exports, "__esModule", {
    value: true
});
$6e759e78370038e6$exports.jitteredExponentialRetry = $6e759e78370038e6$exports.retry = $6e759e78370038e6$exports.NonRetryableError = void 0;

var $6e759e78370038e6$var$logger = $573cfb6c72c1b335$exports.rootLogger.extend("retry");
var $6e759e78370038e6$var$MAX_DELAY_MS = 5000;
/**
 * Internal use of Subscription link
 * @private
 */ var $6e759e78370038e6$var$NonRetryableError = /** @class */ function(_super) {
    $6e759e78370038e6$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
$6e759e78370038e6$exports.NonRetryableError = $6e759e78370038e6$var$NonRetryableError;
var $6e759e78370038e6$var$isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
/**
 * @private
 * Internal use of Subscription link
 */ function $6e759e78370038e6$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $6e759e78370038e6$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $6e759e78370038e6$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    $6e759e78370038e6$var$logger("Attempt #" + attempt + " for this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(undefined, args)
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 3:
                    err_1 = _a.sent();
                    $6e759e78370038e6$var$logger("error " + err_1);
                    if ($6e759e78370038e6$var$isNonRetryableError(err_1)) {
                        $6e759e78370038e6$var$logger("non retryable error");
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $6e759e78370038e6$var$logger("retryIn ", retryIn_1);
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $6e759e78370038e6$var$retry(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
$6e759e78370038e6$exports.retry = $6e759e78370038e6$var$retry;
function $6e759e78370038e6$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
/**
 * @private
 * Internal use of Subscription link
 */ $6e759e78370038e6$exports.jitteredExponentialRetry = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $6e759e78370038e6$var$MAX_DELAY_MS;
    return $6e759e78370038e6$var$retry(functionToRetry, args, $6e759e78370038e6$var$jitteredBackoff(maxDelayMs));
};


var $879b37b55320331f$var$logger = $573cfb6c72c1b335$exports.rootLogger.extend("subscriptions");
$879b37b55320331f$exports.CONTROL_EVENTS_KEY = "@@controlEvents";
var $879b37b55320331f$var$NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var $879b37b55320331f$var$SERVICE = "appsync";
var $879b37b55320331f$var$APPSYNC_REALTIME_HEADERS = {
    accept: 'application/json, text/javascript',
    'content-encoding': 'amz-1.0',
    'content-type': 'application/json; charset=UTF-8'
};
/**
 * Time in milliseconds to wait for GQL_CONNECTION_INIT message
 */ var $879b37b55320331f$var$CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milliseconds to wait for GQL_START_ACK message
 */ var $879b37b55320331f$var$START_ACK_TIMEOUT = 15000;
/**
 * Default Time in milliseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ var $879b37b55320331f$var$DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var $879b37b55320331f$var$AppSyncRealTimeSubscriptionHandshakeLink = /** @class */ function(_super) {
    $879b37b55320331f$var$__extends(AppSyncRealTimeSubscriptionHandshakeLink, _super);
    function AppSyncRealTimeSubscriptionHandshakeLink(_a) {
        var theUrl = _a.url, theRegion = _a.region, theAuth = _a.auth;
        var _this = _super.call(this) || this;
        _this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = $879b37b55320331f$var$DEFAULT_KEEP_ALIVE_TIMEOUT;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.url = theUrl;
        _this.region = theRegion;
        _this.auth = theAuth;
        return _this;
    }
    AppSyncRealTimeSubscriptionHandshakeLink.prototype.request = function(operation) {
        var _a;
        var _this = this;
        var query = operation.query, variables = operation.variables;
        var _b = operation.getContext(), _c = _b.controlMessages, _d = $879b37b55320331f$exports.CONTROL_EVENTS_KEY, controlEvents = (_c === void 0 ? (_a = {}, _a[$879b37b55320331f$exports.CONTROL_EVENTS_KEY] = undefined, _a) : _c)[_d], headers = _b.headers;
        return new $5b50e19789d289fa$export$77cea355fa80b5f4(function(observer) {
            var subscriptionId = $4fe67744bc7750d5$exports.v4();
            var options = {
                appSyncGraphqlEndpoint: _this.url,
                authenticationType: _this.auth.type,
                query: $c358b437c3ffbcb0$export$c2d084dc44961371(query),
                region: _this.region,
                graphql_headers: function() {
                    return headers;
                },
                variables: variables,
                apiKey: _this.auth.type === $5e834c856ec1e1e2$exports.AUTH_TYPE.API_KEY ? _this.auth.apiKey : "",
                credentials: _this.auth.type === $5e834c856ec1e1e2$exports.AUTH_TYPE.AWS_IAM ? _this.auth.credentials : null,
                jwtToken: _this.auth.type === $5e834c856ec1e1e2$exports.AUTH_TYPE.AMAZON_COGNITO_USER_POOLS || _this.auth.type === $5e834c856ec1e1e2$exports.AUTH_TYPE.OPENID_CONNECT ? _this.auth.jwtToken : null
            };
            _this._startSubscriptionWithAWSAppSyncRealTime({
                options: options,
                observer: observer,
                subscriptionId: subscriptionId
            });
            return function() {
                return $879b37b55320331f$var$__awaiter(_this, void 0, void 0, function() {
                    var subscriptionState;
                    return $879b37b55320331f$var$__generator(this, function(_a) {
                        // Cleanup after unsubscribing or observer.complete was called after _startSubscriptionWithAWSAppSyncRealTime
                        try {
                            this._verifySubscriptionAlreadyStarted(subscriptionId);
                            subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                            if (subscriptionState === $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.CONNECTED) this._sendUnsubscriptionMessage(subscriptionId);
                            else throw new Error("Subscription has failed, starting to remove subscription.");
                        } catch (err) {
                            this._removeSubscriptionObserver(subscriptionId);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            };
        }).filter(function(data) {
            var _a = data.extensions, _b = (_a === void 0 ? {} : _a).controlMsgType, controlMsgType = _b === void 0 ? undefined : _b;
            var isControlMsg = typeof controlMsgType !== "undefined";
            return controlEvents === true || !isControlMsg;
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._verifySubscriptionAlreadyStarted = function(subscriptionId) {
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var subscriptionState;
            var _this = this;
            return $879b37b55320331f$var$__generator(this, function(_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.PENDING) return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                        _this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: res,
                            subscriptionFailedCallback: rej
                        });
                    })
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === $89f78f67db57fa98$exports.SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
                this._removeSubscriptionObserver(subscriptionId);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $879b37b55320331f$var$logger({
                err: err
            });
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        if (this.subscriptionObserverMap.size === 0) // Socket could be sending data to unsubscribe so is required to wait until is flushed
        this._closeSocketWhenFlushed();
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._closeSocketWhenFlushed = function() {
        $879b37b55320331f$var$logger("closing WebSocket...");
        clearTimeout(this.keepAliveTimeoutId);
        if (!this.awsRealTimeSocket) {
            this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) setTimeout(this._closeSocketWhenFlushed.bind(this), 1000);
        else {
            var tempSocket = this.awsRealTimeSocket;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED;
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, credentials, jwtToken, subscriptionState, data, dataString, headerObj, _c, subscriptionMessage, stringToAWSRealTime, err_1, _d, message, _e, subscriptionFailedCallback_1, _f, subscriptionFailedCallback, subscriptionReadyCallback;
            var _g;
            var _this = this;
            return $879b37b55320331f$var$__generator(this, function(_h) {
                switch(_h.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function() {
                            return {};
                        } : _b, credentials = options.credentials, jwtToken = options.jwtToken;
                        subscriptionState = $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState
                        });
                        dataString = JSON.stringify(data);
                        _c = [
                            $879b37b55320331f$var$__assign({}, graphql_headers())
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region,
                                credentials: credentials,
                                jwtToken: jwtToken
                            })
                        ];
                    case 1:
                        headerObj = $879b37b55320331f$var$__assign.apply(void 0, [
                            $879b37b55320331f$var$__assign.apply(void 0, _c.concat([
                                _h.sent()
                            ])),
                            (_g = {}, _g[$5e834c856ec1e1e2$exports.USER_AGENT_HEADER] = $5e834c856ec1e1e2$exports.USER_AGENT, _g)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: $879b37b55320331f$var$__assign({}, headerObj)
                                }
                            },
                            type: $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _h.label = 2;
                    case 2:
                        _h.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                credentials: credentials,
                                jwtToken: jwtToken
                            })
                        ];
                    case 3:
                        _h.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _h.sent();
                        _d = err_1.message, message = _d === void 0 ? "" : _d;
                        observer.error({
                            errors: [
                                $879b37b55320331f$var$__assign({}, new $7dea8c85bfa2f509$export$92d6ed0888e7cb7f("Connection failed: " + message))
                            ]
                        });
                        observer.complete();
                        _e = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback, subscriptionFailedCallback_1 = _e === void 0 ? null : _e;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === "function") subscriptionFailedCallback_1();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        _f = this.subscriptionObserverMap.get(subscriptionId), subscriptionFailedCallback = _f.subscriptionFailedCallback, subscriptionReadyCallback = _f.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, $879b37b55320331f$var$START_ACK_TIMEOUT)
                        });
                        this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, credentials = _a.credentials, jwtToken = _a.jwtToken;
        if (this.socketStatus === $89f78f67db57fa98$exports.SOCKET_STATUS.READY) return Promise.resolve();
        return new Promise(function(res, rej) {
            return $879b37b55320331f$var$__awaiter(_this, void 0, void 0, function() {
                var discoverableEndpoint, payloadString, headerString, _a, _b, headerQs, payloadQs, awsRealTimeUrl, err_2;
                return $879b37b55320331f$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CONNECTING;
                            discoverableEndpoint = AppSyncRealTimeSubscriptionHandshakeLink._discoverAppSyncRealTimeEndpoint(this.url);
                            payloadString = "{}";
                            _b = (_a = JSON).stringify;
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    credentials: credentials,
                                    jwtToken: jwtToken
                                })
                            ];
                        case 2:
                            headerString = _b.apply(_a, [
                                _c.sent()
                            ]);
                            headerQs = $879b37b55320331f$require$Buffer.from(headerString).toString("base64");
                            payloadQs = $879b37b55320331f$require$Buffer.from(payloadString).toString("base64");
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake({
                                    awsRealTimeUrl: awsRealTimeUrl
                                })
                            ];
                        case 3:
                            _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $879b37b55320331f$var$logger("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_2 = _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_2);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = null;
                            this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, credentials = _a.credentials, jwtToken = _a.jwtToken;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return $879b37b55320331f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeOPENIDHeader.bind(this)
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== "function") {
                            $879b37b55320331f$var$logger("Authentication type " + authenticationType + " not supported");
                            return [
                                2 /*return*/ ,
                                {}
                            ];
                        }
                        host = $adm0U.parse(appSyncGraphqlEndpoint).host;
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                credentials: credentials,
                                jwtToken: jwtToken
                            })
                        ];
                    case 1:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host, jwtToken = _a.jwtToken;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var _b, _c;
            return $879b37b55320331f$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _b = {};
                        if (!(typeof jwtToken === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            jwtToken.call(undefined)
                        ];
                    case 1:
                        _c = _d.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            jwtToken
                        ];
                    case 3:
                        _c = _d.sent();
                        _d.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            (_b.Authorization = _c, _b.host = host, _b)
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var dt, dtStr;
            return $879b37b55320331f$var$__generator(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region, credentials = _a.credentials;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var endpointInfo, creds, _b, accessKeyId, secretAccessKey, sessionToken, formattedCredentials, request, signed_params;
            return $879b37b55320331f$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: $879b37b55320331f$var$SERVICE
                        };
                        creds = typeof credentials === "function" ? credentials.call() : credentials || {};
                        if (!(creds && typeof creds.getPromise === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            creds.getPromise()
                        ];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!creds) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            creds
                        ];
                    case 3:
                        _b = _c.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                        formattedCredentials = {
                            access_key: accessKeyId,
                            secret_key: secretAccessKey,
                            session_token: sessionToken
                        };
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            body: payload,
                            method: "POST",
                            headers: $879b37b55320331f$var$__assign({}, $879b37b55320331f$var$APPSYNC_REALTIME_HEADERS)
                        };
                        signed_params = $5e834c856ec1e1e2$exports.Signer.sign(request, formattedCredentials, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeRetryableHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            return $879b37b55320331f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $879b37b55320331f$var$logger("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            $6e759e78370038e6$exports.jitteredExponentialRetry(this._initializeHandshake.bind(this), [
                                {
                                    awsRealTimeUrl: awsRealTimeUrl
                                }
                            ])
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._initializeHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $879b37b55320331f$var$__awaiter(this, void 0, void 0, function() {
            var err_3, errorType, errorCode;
            var _this = this;
            return $879b37b55320331f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $879b37b55320331f$var$logger("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = AppSyncRealTimeSubscriptionHandshakeLink.createWebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        $879b37b55320331f$var$logger("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function(error) {
                                        $879b37b55320331f$var$logger("WebSocket closed " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function(event) {
                                        $879b37b55320331f$var$logger("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function(message) {
                                        $879b37b55320331f$var$logger("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? $879b37b55320331f$var$DEFAULT_KEEP_ALIVE_TIMEOUT : _b;
                                        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            res("Cool, connected to AWS AppSyncRealTime");
                                            return;
                                        }
                                        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (_d === void 0 ? [] : _d)[0], _f = _e === void 0 ? {} : _e, _g = _f.errorType, errorType = _g === void 0 ? "" : _g, _h = _f.errorCode, errorCode = _h === void 0 ? 0 : _h;
                                            rej({
                                                errorType: errorType,
                                                errorCode: errorCode
                                            });
                                        }
                                    };
                                    var gqlInit = {
                                        type: $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_CONNECTION_INIT
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + $879b37b55320331f$var$CONNECTION_INIT_TIMEOUT + " ms"));
                                    }
                                    setTimeout(checkAckOk.bind(_this), $879b37b55320331f$var$CONNECTION_INIT_TIMEOUT);
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_3 = _b.sent();
                        errorType = err_3.errorType, errorCode = err_3.errorCode;
                        if ($879b37b55320331f$var$NON_RETRYABLE_CODES.indexOf(errorCode) >= 0) throw new $6e759e78370038e6$exports.NonRetryableError(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_3;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._handleIncomingSubscriptionMessage = function(message) {
        $879b37b55320331f$var$logger("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, _g = _c.startAckTimeoutId, startAckTimeoutId = _g === void 0 ? 0 : _g, _h = _c.subscriptionReadyCallback, subscriptionReadyCallback = _h === void 0 ? null : _h, _j = _c.subscriptionFailedCallback, subscriptionFailedCallback = _j === void 0 ? null : _j;
        $879b37b55320331f$var$logger({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $879b37b55320331f$var$logger("observer not found for id: " + id);
            return;
        }
        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_START_ACK) {
            $879b37b55320331f$var$logger("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            clearTimeout(startAckTimeoutId);
            if (observer) observer.next({
                data: payload,
                extensions: {
                    controlMsgType: "CONNECTED"
                }
            });
            else $879b37b55320331f$var$logger("observer not found for id: " + id);
            var subscriptionState = $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            return;
        }
        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._timeoutDisconnect.bind(this), this.keepAliveTimeout);
            return;
        }
        if (type === $89f78f67db57fa98$exports.MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState
            });
            observer.error({
                errors: [
                    $879b37b55320331f$var$__assign({}, new $7dea8c85bfa2f509$export$92d6ed0888e7cb7f("Connection failed: " + JSON.stringify(payload)))
                ]
            });
            clearTimeout(startAckTimeoutId);
            observer.complete();
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._timeoutDisconnect = function() {
        this.subscriptionObserverMap.forEach(function(_a) {
            var observer = _a.observer;
            observer.error({
                errors: [
                    $879b37b55320331f$var$__assign({}, new $7dea8c85bfa2f509$export$92d6ed0888e7cb7f("Timeout disconnect"))
                ]
            });
            observer.complete();
        });
        this.subscriptionObserverMap = new Map();
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.close();
        this.socketStatus = $89f78f67db57fa98$exports.SOCKET_STATUS.CLOSED;
    };
    AppSyncRealTimeSubscriptionHandshakeLink.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, query = _a.query, variables = _a.variables;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: $89f78f67db57fa98$exports.SUBSCRIPTION_STATUS.FAILED
        });
        observer.error({
            errors: [
                $879b37b55320331f$var$__assign({}, new $7dea8c85bfa2f509$export$92d6ed0888e7cb7f("Subscription timeout " + JSON.stringify({
                    query: query,
                    variables: variables
                })))
            ]
        });
        // Cleanup will be automatically executed
        observer.complete();
        $879b37b55320331f$var$logger("timeoutStartSubscription", JSON.stringify({
            query: query,
            variables: variables
        }));
    };
    AppSyncRealTimeSubscriptionHandshakeLink.createWebSocket = function(awsRealTimeUrl, protocol) {
        return new WebSocket(awsRealTimeUrl, protocol);
    };
    AppSyncRealTimeSubscriptionHandshakeLink._discoverAppSyncRealTimeEndpoint = function(url) {
        return url.replace("https://", "wss://").replace('http://', 'ws://').replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
    };
    return AppSyncRealTimeSubscriptionHandshakeLink;
}($24e18527a43b07a2$export$2fed3d61f740bc7f);
$879b37b55320331f$exports.AppSyncRealTimeSubscriptionHandshakeLink = $879b37b55320331f$var$AppSyncRealTimeSubscriptionHandshakeLink;


function $7f42520b6e9d7224$var$createSubscriptionHandshakeLink(infoOrUrl, theResultsFetcherLink) {
    var resultsFetcherLink, subscriptionLinks;
    if (typeof infoOrUrl === "string") {
        resultsFetcherLink = theResultsFetcherLink || $188346718a8d2ae9$export$95180a16573d6675({
            uri: infoOrUrl
        });
        subscriptionLinks = $24e18527a43b07a2$export$2fed3d61f740bc7f.from([
            new $e42acb5d0ddde8b1$exports.NonTerminatingLink("controlMessages", {
                link: new $24e18527a43b07a2$export$2fed3d61f740bc7f(function(operation, _forward) {
                    return new $5b50e19789d289fa$export$77cea355fa80b5f4(function(observer) {
                        var _a;
                        var _b = operation, _c = _b.variables, _d = $f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY, controlEvents = _c[_d], variables = $7f42520b6e9d7224$var$__rest(_c, [
                            typeof _d === "symbol" ? _d : _d + ""
                        ]);
                        if (typeof controlEvents !== "undefined") operation.variables = variables;
                        observer.next((_a = {}, _a[$f6539c95c5f2a32a$exports.CONTROL_EVENTS_KEY] = controlEvents, _a));
                        return function() {};
                    });
                })
            }),
            new $e42acb5d0ddde8b1$exports.NonTerminatingLink("subsInfo", {
                link: resultsFetcherLink
            }),
            new $f6539c95c5f2a32a$exports.SubscriptionHandshakeLink("subsInfo")
        ]);
    } else {
        var url = infoOrUrl.url;
        resultsFetcherLink = theResultsFetcherLink || $188346718a8d2ae9$export$95180a16573d6675({
            uri: url
        });
        subscriptionLinks = new $879b37b55320331f$exports.AppSyncRealTimeSubscriptionHandshakeLink(infoOrUrl);
    }
    return $24e18527a43b07a2$export$2fed3d61f740bc7f.split(function(operation) {
        var query = operation.query;
        var _a = $72319acb0396de54$export$f431198736b7f96d(query), kind = _a.kind, graphqlOperation = _a.operation;
        var isSubscription = kind === "OperationDefinition" && graphqlOperation === "subscription";
        return isSubscription;
    }, subscriptionLinks, resultsFetcherLink);
}
$7f42520b6e9d7224$exports.createSubscriptionHandshakeLink = $7f42520b6e9d7224$var$createSubscriptionHandshakeLink;


const $60c0faf497b0a45e$export$61087a22b18fbdb6 = {
    Auth: {
        region: "eu-west-1",
        identityPoolId: "eu-west-1:51f889eb-7ce5-4d7e-9aef-c7e916765eaa",
        userPoolId: "eu-west-1_i2OTaCyie",
        userPoolWebClientId: "1msqm5gd4p2stmdke92ir00227",
        mandatorySignIn: false,
        cookieStorage: {
            domain: "staging.mcp.b2b.lego.com",
            secure: false,
            expires: 7
        },
        oauth: {
            domain: "auth.staging.mcp.b2b.lego.com",
            scope: [
                'email',
                'profile',
                'openid',
                'aws.cognito.signin.user.admin'
            ],
            redirectSignIn: "https://survey-admin.staging.mcp.b2b.lego.com/",
            redirectSignOut: "https://survey-admin.staging.mcp.b2b.lego.com/",
            responseType: 'code'
        }
    },
    Storage: {
        AWSS3: {
            bucket: "staging-mcp-upload-bucket",
            region: "eu-west-1",
            level: 'public'
        }
    }
};


/**
 * @this {Promise}
 */ function $e8f73cf9d55161d6$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $e8f73cf9d55161d6$export$2e2bcd8739ae039 = $e8f73cf9d55161d6$var$finallyConstructor;


function $998226b3e884bcac$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $998226b3e884bcac$export$2e2bcd8739ae039 = $998226b3e884bcac$var$allSettled;


/**
 * @constructor
 */ function $ef6ad1c8ec6707d1$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$ef6ad1c8ec6707d1$var$AggregateError.prototype = Error.prototype;
function $ef6ad1c8ec6707d1$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $ef6ad1c8ec6707d1$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $ef6ad1c8ec6707d1$export$2e2bcd8739ae039 = $ef6ad1c8ec6707d1$var$any;


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $3f6e2bc6f00d923c$var$setTimeoutFunc = setTimeout;
function $3f6e2bc6f00d923c$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $3f6e2bc6f00d923c$var$noop() {}
// Polyfill for Function.prototype.bind
function $3f6e2bc6f00d923c$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $3f6e2bc6f00d923c$var$Promise(fn) {
    if (!(this instanceof $3f6e2bc6f00d923c$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $3f6e2bc6f00d923c$var$doResolve(fn, this);
}
function $3f6e2bc6f00d923c$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $3f6e2bc6f00d923c$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $3f6e2bc6f00d923c$var$resolve : $3f6e2bc6f00d923c$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $3f6e2bc6f00d923c$var$reject(deferred.promise, e);
            return;
        }
        $3f6e2bc6f00d923c$var$resolve(deferred.promise, ret);
    });
}
function $3f6e2bc6f00d923c$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $3f6e2bc6f00d923c$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $3f6e2bc6f00d923c$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $3f6e2bc6f00d923c$var$doResolve($3f6e2bc6f00d923c$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $3f6e2bc6f00d923c$var$finale(self);
    } catch (e) {
        $3f6e2bc6f00d923c$var$reject(self, e);
    }
}
function $3f6e2bc6f00d923c$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $3f6e2bc6f00d923c$var$finale(self);
}
function $3f6e2bc6f00d923c$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $3f6e2bc6f00d923c$var$Promise._immediateFn(function() {
        if (!self._handled) $3f6e2bc6f00d923c$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$3f6e2bc6f00d923c$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $3f6e2bc6f00d923c$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $3f6e2bc6f00d923c$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $3f6e2bc6f00d923c$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $3f6e2bc6f00d923c$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $3f6e2bc6f00d923c$var$reject(self, ex);
    }
}
$3f6e2bc6f00d923c$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$3f6e2bc6f00d923c$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($3f6e2bc6f00d923c$var$noop);
    $3f6e2bc6f00d923c$var$handle(this, new $3f6e2bc6f00d923c$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$3f6e2bc6f00d923c$var$Promise.prototype['finally'] = (0, $e8f73cf9d55161d6$export$2e2bcd8739ae039);
$3f6e2bc6f00d923c$var$Promise.all = function(arr) {
    return new $3f6e2bc6f00d923c$var$Promise(function(resolve, reject) {
        if (!$3f6e2bc6f00d923c$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$3f6e2bc6f00d923c$var$Promise.any = (0, $ef6ad1c8ec6707d1$export$2e2bcd8739ae039);
$3f6e2bc6f00d923c$var$Promise.allSettled = (0, $998226b3e884bcac$export$2e2bcd8739ae039);
$3f6e2bc6f00d923c$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $3f6e2bc6f00d923c$var$Promise) return value;
    return new $3f6e2bc6f00d923c$var$Promise(function(resolve) {
        resolve(value);
    });
};
$3f6e2bc6f00d923c$var$Promise.reject = function(value) {
    return new $3f6e2bc6f00d923c$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$3f6e2bc6f00d923c$var$Promise.race = function(arr) {
    return new $3f6e2bc6f00d923c$var$Promise(function(resolve, reject) {
        if (!$3f6e2bc6f00d923c$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$3f6e2bc6f00d923c$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$3f6e2bc6f00d923c$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $3f6e2bc6f00d923c$var$setTimeoutFunc(fn, 0);
};
$3f6e2bc6f00d923c$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $3f6e2bc6f00d923c$export$2e2bcd8739ae039 = $3f6e2bc6f00d923c$var$Promise;



var $2bb64b3ee44f1905$var$local = {};
if (0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) $2bb64b3ee44f1905$var$local = window;
else if (typeof self !== 'undefined') $2bb64b3ee44f1905$var$local = self;
var $2bb64b3ee44f1905$export$775f0de60169233c = 'Promise' in $2bb64b3ee44f1905$var$local ? $2bb64b3ee44f1905$var$local.Promise : (0, $3f6e2bc6f00d923c$export$2e2bcd8739ae039);


var $81ba5eca3c0826ee$var$slice = [].slice;
var $81ba5eca3c0826ee$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $81ba5eca3c0826ee$export$20dfe5c0db9ba10 = $81ba5eca3c0826ee$export$4e09c449d6c407f7 && typeof performance !== 'undefined' ? performance : {};
function $81ba5eca3c0826ee$export$98d4a615201428ae() {
    var xhr = new window.XMLHttpRequest();
    return 'withCredentials' in xhr;
}
var $81ba5eca3c0826ee$var$byteToHex = [];
for(var $81ba5eca3c0826ee$var$i = 0; $81ba5eca3c0826ee$var$i < 256; ++$81ba5eca3c0826ee$var$i)$81ba5eca3c0826ee$var$byteToHex[$81ba5eca3c0826ee$var$i] = ($81ba5eca3c0826ee$var$i + 0x100).toString(16).substr(1);
function $81ba5eca3c0826ee$export$58b867e287a802c8(buffer) {
    var hexOctets = [];
    for(var _i = 0; _i < buffer.length; _i++)hexOctets.push($81ba5eca3c0826ee$var$byteToHex[buffer[_i]]);
    return hexOctets.join('');
}
var $81ba5eca3c0826ee$var$destination = new Uint8Array(16);
function $81ba5eca3c0826ee$export$cd94982b18c6332c() {
    if (typeof crypto != 'undefined' && typeof crypto.getRandomValues == 'function') return crypto.getRandomValues($81ba5eca3c0826ee$var$destination);
    else if (typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function') return msCrypto.getRandomValues($81ba5eca3c0826ee$var$destination);
    return $81ba5eca3c0826ee$var$destination;
}
function $81ba5eca3c0826ee$export$59b2544ec352d56(length) {
    var id = $81ba5eca3c0826ee$export$58b867e287a802c8($81ba5eca3c0826ee$export$cd94982b18c6332c());
    return id.substr(0, length);
}
function $81ba5eca3c0826ee$export$312052e2a8d615c6(span) {
    var dtVersion = '00';
    var dtUnSampledFlags = '00';
    var dtSampledFlags = '01';
    if (span && span.traceId && span.id && span.parentId) {
        var flags = span.sampled ? dtSampledFlags : dtUnSampledFlags;
        var id = span.sampled ? span.id : span.parentId;
        return dtVersion + '-' + span.traceId + '-' + id + '-' + flags;
    }
}
function $81ba5eca3c0826ee$export$86a08f9fd706a6b8(value) {
    var parsed = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(value);
    if (parsed) {
        var flags = parsed[4];
        var sampled = flags !== '00';
        return {
            traceId: parsed[2],
            id: parsed[3],
            sampled: sampled
        };
    }
}
function $81ba5eca3c0826ee$export$a6f4cb80c241b86f(header) {
    return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(header) && header.slice(3, 35) !== '00000000000000000000000000000000' && header.slice(36, 52) !== '0000000000000000';
}
function $81ba5eca3c0826ee$export$6fbffd43bfec7ed8(_ref) {
    var sampleRate = _ref.sampleRate;
    if (typeof sampleRate !== 'number' || String(sampleRate).length > 256) return;
    var NAMESPACE = 'es';
    var SEPARATOR = '=';
    return "" + NAMESPACE + SEPARATOR + "s:" + sampleRate;
}
function $81ba5eca3c0826ee$export$4a0dedceb084213c(target, name, value) {
    if (typeof target.setRequestHeader === 'function') target.setRequestHeader(name, value);
    else if (target.headers && typeof target.headers.append === 'function') target.headers.append(name, value);
    else target[name] = value;
}
function $81ba5eca3c0826ee$export$8731073ee4364c34(source, target) {
    var isSame = false;
    if (typeof target === 'string') isSame = source === target;
    else if (target && typeof target.test === 'function') isSame = target.test(source);
    else if (Array.isArray(target)) target.forEach(function(t) {
        if (!isSame) isSame = $81ba5eca3c0826ee$export$8731073ee4364c34(source, t);
    });
    return isSame;
}
function $81ba5eca3c0826ee$export$69a8fd7b83cf9f89() {
    return $81ba5eca3c0826ee$export$4e09c449d6c407f7 && typeof Set === 'function' && typeof JSON.stringify === 'function' && $81ba5eca3c0826ee$export$20dfe5c0db9ba10 && typeof $81ba5eca3c0826ee$export$20dfe5c0db9ba10.now === 'function' && $81ba5eca3c0826ee$export$98d4a615201428ae();
}
function $81ba5eca3c0826ee$export$4f65e594f6031297(key, value, obj) {
    if (!obj || !key) return;
    var skey = $81ba5eca3c0826ee$export$fbffb0ac2c2ec159(key);
    var valueType = typeof value;
    if (value != undefined && valueType !== 'boolean' && valueType !== 'number') value = String(value);
    obj[skey] = value;
    return obj;
}
function $81ba5eca3c0826ee$export$11b3928e177dda19(serverTimingEntries) {
    if (serverTimingEntries === void 0) serverTimingEntries = [];
    var serverTimingInfo = [];
    var entrySeparator = ', ';
    var valueSeparator = ';';
    for(var _i2 = 0; _i2 < serverTimingEntries.length; _i2++){
        var _serverTimingEntries$ = serverTimingEntries[_i2], name = _serverTimingEntries$.name, duration = _serverTimingEntries$.duration, description = _serverTimingEntries$.description;
        var timingValue = name;
        if (description) timingValue += valueSeparator + 'desc=' + description;
        if (duration) timingValue += valueSeparator + 'dur=' + duration;
        serverTimingInfo.push(timingValue);
    }
    return serverTimingInfo.join(entrySeparator);
}
function $81ba5eca3c0826ee$export$e752b05e58096a2f() {
    return $81ba5eca3c0826ee$export$20dfe5c0db9ba10.timing.fetchStart;
}
function $81ba5eca3c0826ee$export$b3289ee923920b2a(url) {
    return url && url.split('?')[0];
}
function $81ba5eca3c0826ee$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === 'object';
}
function $81ba5eca3c0826ee$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $81ba5eca3c0826ee$export$bf6cb145536e8bab(dst, objs, deep) {
    for(var i = 0, ii = objs.length; i < ii; ++i){
        var obj = objs[i];
        if (!$81ba5eca3c0826ee$export$a6cdc56e425d0d0a(obj) && !$81ba5eca3c0826ee$export$f6e2535fb5126e54(obj)) continue;
        var keys = Object.keys(obj);
        for(var j = 0, jj = keys.length; j < jj; j++){
            var key = keys[j];
            var src = obj[key];
            if (deep && $81ba5eca3c0826ee$export$a6cdc56e425d0d0a(src)) {
                if (!$81ba5eca3c0826ee$export$a6cdc56e425d0d0a(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
                $81ba5eca3c0826ee$export$bf6cb145536e8bab(dst[key], [
                    src
                ], false);
            } else dst[key] = src;
        }
    }
    return dst;
}
function $81ba5eca3c0826ee$export$bf6fdd3c8902f077() {
    if (typeof document !== 'undefined') {
        var scripts = document.getElementsByTagName('script');
        for(var i = 0, l = scripts.length; i < l; i++){
            var sc = scripts[i];
            if (sc.src.indexOf('elastic') > 0) return sc;
        }
    }
}
function $81ba5eca3c0826ee$export$8fc24885882b6ead() {
    if (typeof document !== 'undefined') {
        var currentScript = document.currentScript;
        if (!currentScript) return $81ba5eca3c0826ee$export$bf6fdd3c8902f077();
        return currentScript;
    }
}
function $81ba5eca3c0826ee$export$8b58be045bf06082() {
    return $81ba5eca3c0826ee$export$bf6cb145536e8bab(Object.create(null), $81ba5eca3c0826ee$var$slice.call(arguments), false);
}
function $81ba5eca3c0826ee$export$4950aa0f605343fb() {
    return $81ba5eca3c0826ee$export$bf6cb145536e8bab(Object.create(null), $81ba5eca3c0826ee$var$slice.call(arguments), true);
}
function $81ba5eca3c0826ee$export$fce6876652108ab(obj) {
    return typeof obj === 'undefined';
}
function $81ba5eca3c0826ee$export$8793edee2d425525() {}
function $81ba5eca3c0826ee$export$71aa6c912b956294(array, predicate, thisArg) {
    if (array == null) throw new TypeError('array is null or not defined');
    var o = Object(array);
    var len = o.length >>> 0;
    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
    var k = 0;
    while(k < len){
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) return kValue;
        k++;
    }
    return undefined;
}
function $81ba5eca3c0826ee$export$fbffb0ac2c2ec159(key) {
    return key.replace(/[.*"]/g, '_');
}
function $81ba5eca3c0826ee$var$getLatestSpan(spans, typeFilter) {
    var latestSpan = null;
    for(var _i3 = 0; _i3 < spans.length; _i3++){
        var span = spans[_i3];
        if (typeFilter && typeFilter(span.type) && (!latestSpan || latestSpan._end < span._end)) latestSpan = span;
    }
    return latestSpan;
}
function $81ba5eca3c0826ee$export$4066158e069099c5(spans) {
    return $81ba5eca3c0826ee$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') === -1;
    });
}
function $81ba5eca3c0826ee$export$9db886af3c22d167(spans) {
    return $81ba5eca3c0826ee$var$getLatestSpan(spans, function(type) {
        return String(type).indexOf('external') !== -1;
    });
}
function $81ba5eca3c0826ee$export$26335e41fd84043b(spans) {
    var earliestSpan = spans[0];
    for(var _i4 = 1; _i4 < spans.length; _i4++){
        var span = spans[_i4];
        if (earliestSpan._start > span._start) earliestSpan = span;
    }
    return earliestSpan;
}
function $81ba5eca3c0826ee$export$461939dd4422153() {
    return $81ba5eca3c0826ee$export$20dfe5c0db9ba10.now();
}
function $81ba5eca3c0826ee$export$1428f42a7de81803(time) {
    return typeof time === 'number' && time >= 0 ? time : $81ba5eca3c0826ee$export$461939dd4422153();
}
function $81ba5eca3c0826ee$export$75bba95db5c3e753(start, end) {
    if ($81ba5eca3c0826ee$export$fce6876652108ab(end) || $81ba5eca3c0826ee$export$fce6876652108ab(start)) return null;
    return parseInt(end - start);
}
function $81ba5eca3c0826ee$export$fbacb21386347f76(callback) {
    setTimeout(callback, 0);
}
function $81ba5eca3c0826ee$export$3262a5e6cc4c389e(callback) {
    (0, $2bb64b3ee44f1905$export$775f0de60169233c).resolve().then(callback);
}
function $81ba5eca3c0826ee$export$475e1d086d647d28() {
    return typeof $81ba5eca3c0826ee$export$20dfe5c0db9ba10.getEntriesByType === 'function';
}
function $81ba5eca3c0826ee$export$c043ff66aa95c00c(type) {
    return typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.indexOf(type) >= 0;
}
function $81ba5eca3c0826ee$export$759b2c522265ced() {
    return 'interactionCount' in performance;
}
function $81ba5eca3c0826ee$export$7aca418b79512736() {
    var flagName = '_elastic_inspect_beacon_';
    if (sessionStorage.getItem(flagName) != null) return true;
    if (!window.URL || !window.URLSearchParams) return false;
    try {
        var parsedUrl = new URL(window.location.href);
        var isFlagSet = parsedUrl.searchParams.has(flagName);
        if (isFlagSet) sessionStorage.setItem(flagName, true);
        return isFlagSet;
    } catch (e) {}
    return false;
}
function $81ba5eca3c0826ee$export$ffcb82e8b0e258ec(timing) {
    return timing.redirectStart > 0;
}


var $9c916c6998c5246b$export$8e769ad4338a911e = {
    fetchInProgress: false
};
function $9c916c6998c5246b$export$652b0f25a523f48f(name) {
    return '__apm_symbol__' + name;
}
function $9c916c6998c5246b$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
}
function $9c916c6998c5246b$var$attachOriginToPatched(patched, original) {
    patched[$9c916c6998c5246b$export$652b0f25a523f48f('OriginalDelegate')] = original;
}
function $9c916c6998c5246b$export$27a263d91197d790(target, name, patchFn) {
    var proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = Object.getPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    var delegateName = $9c916c6998c5246b$export$652b0f25a523f48f(name);
    var delegate;
    if (proto && !(delegate = proto[delegateName])) {
        delegate = proto[delegateName] = proto[name];
        var desc = proto && Object.getOwnPropertyDescriptor(proto, name);
        if ($9c916c6998c5246b$var$isPropertyWritable(desc)) {
            var patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $9c916c6998c5246b$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
var $9c916c6998c5246b$export$1d2facecfc1955cc = $9c916c6998c5246b$export$652b0f25a523f48f('xhrIgnore');
var $9c916c6998c5246b$export$bda265647bf75488 = $9c916c6998c5246b$export$652b0f25a523f48f('xhrSync');
var $9c916c6998c5246b$export$9a7ca3b2c2e97bd9 = $9c916c6998c5246b$export$652b0f25a523f48f('xhrURL');
var $9c916c6998c5246b$export$90db053605542d02 = $9c916c6998c5246b$export$652b0f25a523f48f('xhrMethod');


var $c898cf419eb79f2e$export$2cb68534ade458e0 = 'schedule';
var $c898cf419eb79f2e$export$156c69d71663cf9e = 'invoke';
var $c898cf419eb79f2e$export$19be37673fbac3e8 = 'addEventListener';
var $c898cf419eb79f2e$export$2d40f446af293d52 = 'removeEventListener';
var $c898cf419eb79f2e$export$fcac77ffb8211a1f = [
    'link',
    'css',
    'script',
    'img',
    'xmlhttprequest',
    'fetch',
    'beacon',
    'iframe'
];
var $c898cf419eb79f2e$export$1307ffda4f2726e8 = 5000;
var $c898cf419eb79f2e$export$92d7cb2c71942fbd = 300000;
var $c898cf419eb79f2e$export$b78d68e75d8e9dad = 1000;
var $c898cf419eb79f2e$export$1502f4f8c48fa539 = 'page-load';
var $c898cf419eb79f2e$export$e9e58a8c189b78b1 = 'route-change';
var $c898cf419eb79f2e$export$dd0e4c11f1ad6f76 = 'custom';
var $c898cf419eb79f2e$export$ca341a703d5e2151 = 'user-interaction';
var $c898cf419eb79f2e$export$c774c31b4c31da8 = 'http-request';
var $c898cf419eb79f2e$export$c757be00d1bf3ef5 = 'temporary';
var $c898cf419eb79f2e$export$f0eae82cd3ba085f = 'Unknown';
var $c898cf419eb79f2e$export$2f2f0ccc41f2d4f6 = 'page-exit';
var $c898cf419eb79f2e$export$38ee95dde3859fb7 = [
    $c898cf419eb79f2e$export$1502f4f8c48fa539,
    $c898cf419eb79f2e$export$e9e58a8c189b78b1,
    $c898cf419eb79f2e$export$ca341a703d5e2151,
    $c898cf419eb79f2e$export$c774c31b4c31da8,
    $c898cf419eb79f2e$export$dd0e4c11f1ad6f76,
    $c898cf419eb79f2e$export$c757be00d1bf3ef5
];
var $c898cf419eb79f2e$export$ffae20858202e0de = 'success';
var $c898cf419eb79f2e$export$a1656598af524751 = 'failure';
var $c898cf419eb79f2e$export$f46af96a885f2c9b = 'unknown';
var $c898cf419eb79f2e$export$833fd3a4a36bef5e = 60;
var $c898cf419eb79f2e$export$53ee6f7d651aa888 = 'transaction:start';
var $c898cf419eb79f2e$export$3583e51eacab0340 = 'transaction:end';
var $c898cf419eb79f2e$export$36257f40a0d30563 = 'config:change';
var $c898cf419eb79f2e$export$19245af82a094556 = 'queue:flush';
var $c898cf419eb79f2e$export$c11a56b9bfcb1d0f = 'queue:add_transaction';
var $c898cf419eb79f2e$export$543fdf328f404af7 = 'transaction:ignore';
var $c898cf419eb79f2e$export$942b1c2707517311 = 'xmlhttprequest';
var $c898cf419eb79f2e$export$4a07cffb9c3bc884 = 'fetch';
var $c898cf419eb79f2e$export$149eb684a26496a2 = 'history';
var $c898cf419eb79f2e$export$2c4d7da089dce968 = 'eventtarget';
var $c898cf419eb79f2e$export$cb5542418ddbb7ed = 'click';
var $c898cf419eb79f2e$export$103bedf43ba882db = 'error';
var $c898cf419eb79f2e$export$d75a03bca9277b83 = ':before';
var $c898cf419eb79f2e$export$eeaba87877acb280 = ':after';
var $c898cf419eb79f2e$export$f1f46202fdd81911 = 'elastic_apm_config';
var $c898cf419eb79f2e$export$fd2c36a5e8e50e04 = 'longtask';
var $c898cf419eb79f2e$export$ef5de76f1655b5ca = 'paint';
var $c898cf419eb79f2e$export$20471946a1148a1b = 'measure';
var $c898cf419eb79f2e$export$f52dcf7131a7f04 = 'navigation';
var $c898cf419eb79f2e$export$84ba8fa7099b85b = 'resource';
var $c898cf419eb79f2e$export$c2572a516b804ad3 = 'first-contentful-paint';
var $c898cf419eb79f2e$export$6de1676190bd73c4 = 'largest-contentful-paint';
var $c898cf419eb79f2e$export$98085453dd812392 = 'first-input';
var $c898cf419eb79f2e$export$fc5ce9a4261f08e8 = 'layout-shift';
var $c898cf419eb79f2e$export$e39a34cfd532e15 = 'event';
var $c898cf419eb79f2e$export$4fd720569787ab6f = 'errors';
var $c898cf419eb79f2e$export$33e749855cc8f893 = 'transactions';
var $c898cf419eb79f2e$export$11170dadd5705a7b = 'ConfigService';
var $c898cf419eb79f2e$export$7d973190a36b8246 = 'LoggingService';
var $c898cf419eb79f2e$export$ab6389d1a16bebfe = 'TransactionService';
var $c898cf419eb79f2e$export$8f8a420bfb2d7e37 = 'ApmServer';
var $c898cf419eb79f2e$export$6a0f49a7699bafca = 'PerformanceMonitoring';
var $c898cf419eb79f2e$export$3bb4e88cf5c5fd65 = 'ErrorLogging';
var $c898cf419eb79f2e$export$58a4ef0ce68953f5 = '.truncated';
var $c898cf419eb79f2e$export$1ef49423f809800e = 1024;
var $c898cf419eb79f2e$export$c74ee24a01db1ae5 = 1800000;
var $c898cf419eb79f2e$export$304f7f334b3888b0 = 10000;


function $6e337dda3b38edee$export$41ed32b4ed20742(callback) {
    var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
    if (!XMLHttpRequestPrototype || !XMLHttpRequestPrototype[0, $c898cf419eb79f2e$export$19be37673fbac3e8]) return;
    var READY_STATE_CHANGE = 'readystatechange';
    var LOAD = 'load';
    var ERROR = 'error';
    var TIMEOUT = 'timeout';
    var ABORT = 'abort';
    function invokeTask(task, status) {
        if (task.state !== (0, $c898cf419eb79f2e$export$156c69d71663cf9e)) {
            task.state = (0, $c898cf419eb79f2e$export$156c69d71663cf9e);
            task.data.status = status;
            callback((0, $c898cf419eb79f2e$export$156c69d71663cf9e), task);
        }
    }
    function scheduleTask(task) {
        if (task.state === (0, $c898cf419eb79f2e$export$2cb68534ade458e0)) return;
        task.state = (0, $c898cf419eb79f2e$export$2cb68534ade458e0);
        callback((0, $c898cf419eb79f2e$export$2cb68534ade458e0), task);
        var target = task.data.target;
        function addListener(name) {
            target[0, $c898cf419eb79f2e$export$19be37673fbac3e8](name, function(_ref) {
                var type = _ref.type;
                if (type === READY_STATE_CHANGE) {
                    if (target.readyState === 4 && target.status !== 0) invokeTask(task, 'success');
                } else {
                    var status = type === LOAD ? 'success' : type;
                    invokeTask(task, status);
                }
            });
        }
        addListener(READY_STATE_CHANGE);
        addListener(LOAD);
        addListener(TIMEOUT);
        addListener(ERROR);
        addListener(ABORT);
    }
    var openNative = (0, $9c916c6998c5246b$export$27a263d91197d790)(XMLHttpRequestPrototype, 'open', function() {
        return function(self, args) {
            if (!self[0, $9c916c6998c5246b$export$1d2facecfc1955cc]) {
                self[0, $9c916c6998c5246b$export$90db053605542d02] = args[0];
                self[0, $9c916c6998c5246b$export$9a7ca3b2c2e97bd9] = (args[1] || '').toString();
                self[0, $9c916c6998c5246b$export$bda265647bf75488] = args[2] === false;
            }
            return openNative.apply(self, args);
        };
    });
    var sendNative = (0, $9c916c6998c5246b$export$27a263d91197d790)(XMLHttpRequestPrototype, 'send', function() {
        return function(self, args) {
            if (self[0, $9c916c6998c5246b$export$1d2facecfc1955cc]) return sendNative.apply(self, args);
            var task = {
                source: (0, $c898cf419eb79f2e$export$942b1c2707517311),
                state: '',
                type: 'macroTask',
                data: {
                    target: self,
                    method: self[0, $9c916c6998c5246b$export$90db053605542d02],
                    sync: self[0, $9c916c6998c5246b$export$bda265647bf75488],
                    url: self[0, $9c916c6998c5246b$export$9a7ca3b2c2e97bd9],
                    status: ''
                }
            };
            try {
                scheduleTask(task);
                return sendNative.apply(self, args);
            } catch (e) {
                invokeTask(task, ERROR);
                throw e;
            }
        };
    });
}







function $03a1fcf2d7b8ba32$export$1f29f0bf55f6a59e(status) {
    if (status === 0 || status > 399 && status < 600) return false;
    return true;
}


function $a688f717d9590693$var$_extends() {
    return $a688f717d9590693$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a688f717d9590693$var$_extends.apply(null, arguments);
}
var $a688f717d9590693$export$1080ec02d04a92c0 = 60000;
function $a688f717d9590693$export$7671e9773d28088a(method, payload) {
    if (!$a688f717d9590693$export$f8c1c61350d9749()) return false;
    var isKeepAliveSupported = 'keepalive' in new Request('');
    if (!isKeepAliveSupported) return false;
    var size = $a688f717d9590693$var$calculateSize(payload);
    return method === 'POST' && size < $a688f717d9590693$export$1080ec02d04a92c0;
}
function $a688f717d9590693$export$de4ef9c2599856d6(method, url, _ref) {
    var _ref$keepalive = _ref.keepalive, keepalive = _ref$keepalive === void 0 ? false : _ref$keepalive, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? (0, $c898cf419eb79f2e$export$304f7f334b3888b0) : _ref$timeout, payload = _ref.payload, headers = _ref.headers, sendCredentials = _ref.sendCredentials;
    var timeoutConfig = {};
    if (typeof AbortController === 'function') {
        var controller = new AbortController();
        timeoutConfig.signal = controller.signal;
        setTimeout(function() {
            return controller.abort();
        }, timeout);
    }
    var fetchResponse;
    return window.fetch(url, $a688f717d9590693$var$_extends({
        body: payload,
        headers: headers,
        method: method,
        keepalive: keepalive,
        credentials: sendCredentials ? 'include' : 'omit'
    }, timeoutConfig)).then(function(response) {
        fetchResponse = response;
        return fetchResponse.text();
    }).then(function(responseText) {
        var bodyResponse = {
            url: url,
            status: fetchResponse.status,
            responseText: responseText
        };
        if (!(0, $03a1fcf2d7b8ba32$export$1f29f0bf55f6a59e)(fetchResponse.status)) throw bodyResponse;
        return bodyResponse;
    });
}
function $a688f717d9590693$export$f8c1c61350d9749() {
    return typeof window.fetch === 'function' && typeof window.Request === 'function';
}
function $a688f717d9590693$var$calculateSize(payload) {
    if (!payload) return 0;
    if (payload instanceof Blob) return payload.size;
    return new Blob([
        payload
    ]).size;
}


function $232079264dcffe6b$export$28f71c1f202028d4(callback) {
    if (!(0, $a688f717d9590693$export$f8c1c61350d9749)()) return;
    function scheduleTask(task) {
        task.state = (0, $c898cf419eb79f2e$export$2cb68534ade458e0);
        callback((0, $c898cf419eb79f2e$export$2cb68534ade458e0), task);
    }
    function invokeTask(task) {
        task.state = (0, $c898cf419eb79f2e$export$156c69d71663cf9e);
        callback((0, $c898cf419eb79f2e$export$156c69d71663cf9e), task);
    }
    function handleResponseError(task, error) {
        task.data.aborted = $232079264dcffe6b$var$isAbortError(error);
        task.data.error = error;
        invokeTask(task);
    }
    function readStream(stream, task) {
        var reader = stream.getReader();
        var _read = function read() {
            reader.read().then(function(_ref) {
                var done = _ref.done;
                if (done) invokeTask(task);
                else _read();
            }, function(error) {
                handleResponseError(task, error);
            });
        };
        _read();
    }
    var nativeFetch = window.fetch;
    window.fetch = function(input, init) {
        var fetchSelf = this;
        var args = arguments;
        var request, url;
        var isURL = input instanceof URL;
        if (typeof input === 'string' || isURL) {
            request = new Request(input, init);
            if (isURL) url = request.url;
            else url = input;
        } else if (input) {
            request = new Request(input, init);
            url = request.url;
        } else return nativeFetch.apply(fetchSelf, args);
        var task = {
            source: (0, $c898cf419eb79f2e$export$4a07cffb9c3bc884),
            state: '',
            type: 'macroTask',
            data: {
                target: request,
                method: request.method,
                url: url,
                aborted: false
            }
        };
        return new (0, $2bb64b3ee44f1905$export$775f0de60169233c)(function(resolve, reject) {
            (0, $9c916c6998c5246b$export$8e769ad4338a911e).fetchInProgress = true;
            scheduleTask(task);
            var promise;
            try {
                promise = nativeFetch.apply(fetchSelf, [
                    request
                ]);
            } catch (error) {
                reject(error);
                task.data.error = error;
                invokeTask(task);
                (0, $9c916c6998c5246b$export$8e769ad4338a911e).fetchInProgress = false;
                return;
            }
            promise.then(function(response) {
                var clonedResponse = response.clone ? response.clone() : {};
                resolve(response);
                (0, $81ba5eca3c0826ee$export$3262a5e6cc4c389e)(function() {
                    task.data.response = response;
                    var body = clonedResponse.body;
                    if (body) readStream(body, task);
                    else invokeTask(task);
                });
            }, function(error) {
                reject(error);
                (0, $81ba5eca3c0826ee$export$3262a5e6cc4c389e)(function() {
                    handleResponseError(task, error);
                });
            });
            (0, $9c916c6998c5246b$export$8e769ad4338a911e).fetchInProgress = false;
        });
    };
}
function $232079264dcffe6b$var$isAbortError(error) {
    return error && error.name === 'AbortError';
}



function $f8eaa20e230722d0$export$1c3c71cac9d1d555(callback) {
    if (!window.history) return;
    var nativePushState = history.pushState;
    if (typeof nativePushState === 'function') history.pushState = function(state, title, url) {
        var task = {
            source: (0, $c898cf419eb79f2e$export$149eb684a26496a2),
            data: {
                state: state,
                title: title,
                url: url
            }
        };
        callback((0, $c898cf419eb79f2e$export$156c69d71663cf9e), task);
        nativePushState.apply(this, arguments);
    };
}



var $b5a55fec8aea0311$var$EventHandler = function() {
    function EventHandler() {
        this.observers = {};
    }
    var _proto = EventHandler.prototype;
    _proto.observe = function observe(name, fn) {
        var _this = this;
        if (typeof fn === 'function') {
            if (!this.observers[name]) this.observers[name] = [];
            this.observers[name].push(fn);
            return function() {
                var index = _this.observers[name].indexOf(fn);
                if (index > -1) _this.observers[name].splice(index, 1);
            };
        }
    };
    _proto.sendOnly = function sendOnly(name, args) {
        var obs = this.observers[name];
        if (obs) obs.forEach(function(fn) {
            try {
                fn.apply(undefined, args);
            } catch (error) {
                console.log(error, error.stack);
            }
        });
    };
    _proto.send = function send(name, args) {
        this.sendOnly(name + (0, $c898cf419eb79f2e$export$d75a03bca9277b83), args);
        this.sendOnly(name, args);
        this.sendOnly(name + (0, $c898cf419eb79f2e$export$eeaba87877acb280), args);
    };
    return EventHandler;
}();
var $b5a55fec8aea0311$export$2e2bcd8739ae039 = $b5a55fec8aea0311$var$EventHandler;



var $436e4e100da18924$export$602cc6306ec009d8 = new (0, $b5a55fec8aea0311$export$2e2bcd8739ae039)();
var $436e4e100da18924$var$alreadyPatched = false;
function $436e4e100da18924$export$94da54533f7f9289() {
    if (!$436e4e100da18924$var$alreadyPatched) {
        $436e4e100da18924$var$alreadyPatched = true;
        (0, $6e337dda3b38edee$export$41ed32b4ed20742)(function(event, task) {
            $436e4e100da18924$export$602cc6306ec009d8.send((0, $c898cf419eb79f2e$export$942b1c2707517311), [
                event,
                task
            ]);
        });
        (0, $232079264dcffe6b$export$28f71c1f202028d4)(function(event, task) {
            $436e4e100da18924$export$602cc6306ec009d8.send((0, $c898cf419eb79f2e$export$4a07cffb9c3bc884), [
                event,
                task
            ]);
        });
        (0, $f8eaa20e230722d0$export$1c3c71cac9d1d555)(function(event, task) {
            $436e4e100da18924$export$602cc6306ec009d8.send((0, $c898cf419eb79f2e$export$149eb684a26496a2), [
                event,
                task
            ]);
        });
    }
    return $436e4e100da18924$export$602cc6306ec009d8;
}


var $d15fb30d84867e0d$export$a866f231438cc228 = false;
var $d15fb30d84867e0d$export$ca000e230c0caa3e = {
    bootstrapTime: null,
    lastHiddenStart: Number.MIN_SAFE_INTEGER
};


var $770f7a375fe5760b$var$enabled = false;
function $770f7a375fe5760b$export$36aff1fbb4f5dfc6() {
    if ((0, $81ba5eca3c0826ee$export$69a8fd7b83cf9f89)()) {
        (0, $436e4e100da18924$export$94da54533f7f9289)();
        (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).bootstrapTime = (0, $81ba5eca3c0826ee$export$461939dd4422153)();
        $770f7a375fe5760b$var$enabled = true;
    } else if (0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) console.log('[Elastic APM] platform is not supported!');
    return $770f7a375fe5760b$var$enabled;
}

function $f327a9448dbd3dd9$var$filePathToFileName(fileUrl) {
    var origin = window.location.origin || window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    if (fileUrl.indexOf(origin) > -1) fileUrl = fileUrl.replace(origin + '/', '');
    return fileUrl;
}
function $f327a9448dbd3dd9$var$cleanFilePath(filePath) {
    if (filePath === void 0) filePath = '';
    if (filePath === '<anonymous>') filePath = '';
    return filePath;
}
function $f327a9448dbd3dd9$var$isFileInline(fileUrl) {
    if (fileUrl) return window.location.href.indexOf(fileUrl) === 0;
    return false;
}
function $f327a9448dbd3dd9$var$normalizeStackFrames(stackFrames) {
    return stackFrames.map(function(frame) {
        if (frame.functionName) frame.functionName = $f327a9448dbd3dd9$var$normalizeFunctionName(frame.functionName);
        return frame;
    });
}
function $f327a9448dbd3dd9$var$normalizeFunctionName(fnName) {
    var parts = fnName.split('/');
    if (parts.length > 1) fnName = [
        'Object',
        parts[parts.length - 1]
    ].join('.');
    else fnName = parts[0];
    fnName = fnName.replace(/.<$/gi, '.<anonymous>');
    fnName = fnName.replace(/^Anonymous function$/, '<anonymous>');
    parts = fnName.split('.');
    if (parts.length > 1) fnName = parts[parts.length - 1];
    else fnName = parts[0];
    return fnName;
}
function $f327a9448dbd3dd9$var$isValidStackTrace(stackTraces) {
    if (stackTraces.length === 0) return false;
    if (stackTraces.length === 1) {
        var stackTrace = stackTraces[0];
        return 'lineNumber' in stackTrace;
    }
    return true;
}
function $f327a9448dbd3dd9$export$8c8855196b9f04f8(stackParser, errorEvent) {
    var error = errorEvent.error, filename = errorEvent.filename, lineno = errorEvent.lineno, colno = errorEvent.colno;
    var stackTraces = [];
    if (error) try {
        stackTraces = stackParser.parse(error);
    } catch (e) {}
    if (!$f327a9448dbd3dd9$var$isValidStackTrace(stackTraces)) stackTraces = [
        {
            fileName: filename,
            lineNumber: lineno,
            columnNumber: colno
        }
    ];
    var normalizedStackTraces = $f327a9448dbd3dd9$var$normalizeStackFrames(stackTraces);
    return normalizedStackTraces.map(function(stack) {
        var fileName = stack.fileName, lineNumber = stack.lineNumber, columnNumber = stack.columnNumber, _stack$functionName = stack.functionName, functionName = _stack$functionName === void 0 ? '<anonymous>' : _stack$functionName;
        if (!fileName && !lineNumber) return {};
        if (!columnNumber && !lineNumber) return {};
        var filePath = $f327a9448dbd3dd9$var$cleanFilePath(fileName);
        var cleanedFileName = $f327a9448dbd3dd9$var$filePathToFileName(filePath);
        if ($f327a9448dbd3dd9$var$isFileInline(filePath)) cleanedFileName = '(inline script)';
        return {
            abs_path: fileName,
            filename: cleanedFileName,
            function: functionName,
            lineno: lineNumber,
            colno: columnNumber
        };
    });
}
function $f327a9448dbd3dd9$export$388e43ae04f18461(frames) {
    return frames.filter(function(_ref) {
        var filename = _ref.filename, lineno = _ref.lineno;
        return typeof filename !== 'undefined' && typeof lineno !== 'undefined';
    });
}




function $5988178a6f0b5e35$var$isDefaultPort(port, protocol) {
    switch(protocol){
        case 'http:':
            return port === '80';
        case 'https:':
            return port === '443';
    }
    return true;
}
var $5988178a6f0b5e35$var$RULES = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    [
        '/',
        'path'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1
    ]
];
var $5988178a6f0b5e35$var$PROTOCOL_REGEX = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
var $5988178a6f0b5e35$export$59d795186a5d3f58 = function() {
    function Url(url) {
        var _this$extractProtocol = this.extractProtocol(url || ''), protocol = _this$extractProtocol.protocol, address = _this$extractProtocol.address, slashes = _this$extractProtocol.slashes;
        var relative = !protocol && !slashes;
        var location = this.getLocation();
        var instructions = $5988178a6f0b5e35$var$RULES.slice();
        address = address.replace('\\', '/');
        if (!slashes) instructions[2] = [
            NaN,
            'path'
        ];
        var index;
        for(var i = 0; i < instructions.length; i++){
            var instruction = instructions[i];
            var parse = instruction[0];
            var key = instruction[1];
            if (typeof parse === 'string') {
                index = address.indexOf(parse);
                if (~index) {
                    var instLength = instruction[2];
                    if (instLength) {
                        var newIndex = address.lastIndexOf(parse);
                        index = Math.max(index, newIndex);
                        this[key] = address.slice(0, index);
                        address = address.slice(index + instLength);
                    } else {
                        this[key] = address.slice(index);
                        address = address.slice(0, index);
                    }
                }
            } else {
                this[key] = address;
                address = '';
            }
            this[key] = this[key] || (relative && instruction[3] ? location[key] || '' : '');
            if (instruction[3]) this[key] = this[key].toLowerCase();
        }
        if (relative && this.path.charAt(0) !== '/') this.path = '/' + this.path;
        this.relative = relative;
        this.protocol = protocol || location.protocol;
        this.hostname = this.host;
        this.port = '';
        if (/:\d+$/.test(this.host)) {
            var value = this.host.split(':');
            var port = value.pop();
            var hostname = value.join(':');
            if ($5988178a6f0b5e35$var$isDefaultPort(port, this.protocol)) this.host = hostname;
            else this.port = port;
            this.hostname = hostname;
        }
        this.origin = this.protocol && this.host && this.protocol !== 'file:' ? this.protocol + '//' + this.host : 'null';
        this.href = this.toString();
    }
    var _proto = Url.prototype;
    _proto.toString = function toString() {
        var result = this.protocol;
        result += '//';
        if (this.auth) {
            var REDACTED = '[REDACTED]';
            var userpass = this.auth.split(':');
            var username = userpass[0] ? REDACTED : '';
            var password = userpass[1] ? ':' + REDACTED : '';
            result += username + password + '@';
        }
        result += this.host;
        result += this.path;
        result += this.query;
        result += this.hash;
        return result;
    };
    _proto.getLocation = function getLocation() {
        var globalVar = {};
        if (0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) globalVar = window;
        return globalVar.location;
    };
    _proto.extractProtocol = function extractProtocol(url) {
        var match = $5988178a6f0b5e35$var$PROTOCOL_REGEX.exec(url);
        return {
            protocol: match[1] ? match[1].toLowerCase() : '',
            slashes: !!match[2],
            address: match[3]
        };
    };
    return Url;
}();
function $5988178a6f0b5e35$export$456a5af62e4119f6(urlStr, depth) {
    if (depth === void 0) depth = 2;
    var parsedUrl = new $5988178a6f0b5e35$export$59d795186a5d3f58(urlStr);
    var query = parsedUrl.query, path = parsedUrl.path;
    var pathParts = path.substring(1).split('/');
    var redactString = ':id';
    var wildcard = '*';
    var specialCharsRegex = /\W|_/g;
    var digitsRegex = /[0-9]/g;
    var lowerCaseRegex = /[a-z]/g;
    var upperCaseRegex = /[A-Z]/g;
    var redactedParts = [];
    var redactedBefore = false;
    for(var index = 0; index < pathParts.length; index++){
        var part = pathParts[index];
        if (redactedBefore || index > depth - 1) {
            if (part) redactedParts.push(wildcard);
            break;
        }
        var numberOfSpecialChars = (part.match(specialCharsRegex) || []).length;
        if (numberOfSpecialChars >= 2) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberOfDigits = (part.match(digitsRegex) || []).length;
        if (numberOfDigits > 3 || part.length > 3 && numberOfDigits / part.length >= 0.3) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        var numberofUpperCase = (part.match(upperCaseRegex) || []).length;
        var numberofLowerCase = (part.match(lowerCaseRegex) || []).length;
        var lowerCaseRate = numberofLowerCase / part.length;
        var upperCaseRate = numberofUpperCase / part.length;
        if (part.length > 5 && (upperCaseRate > 0.3 && upperCaseRate < 0.6 || lowerCaseRate > 0.3 && lowerCaseRate < 0.6)) {
            redactedParts.push(redactString);
            redactedBefore = true;
            continue;
        }
        part && redactedParts.push(part);
    }
    var redacted = '/' + (redactedParts.length >= 2 ? redactedParts.join('/') : redactedParts.join('')) + (query ? '?{query}' : '');
    return redacted;
}




var $2c87e6d217c9f6e4$var$_excluded = [
    "tags"
];
function $2c87e6d217c9f6e4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2c87e6d217c9f6e4$var$LEFT_SQUARE_BRACKET = 91;
var $2c87e6d217c9f6e4$var$RIGHT_SQUARE_BRACKET = 93;
var $2c87e6d217c9f6e4$var$EXTERNAL = 'external';
var $2c87e6d217c9f6e4$var$RESOURCE = 'resource';
var $2c87e6d217c9f6e4$var$HARD_NAVIGATION = 'hard-navigation';
function $2c87e6d217c9f6e4$var$getPortNumber(port, protocol) {
    if (port === '') port = protocol === 'http:' ? '80' : protocol === 'https:' ? '443' : '';
    return port;
}
function $2c87e6d217c9f6e4$var$getResponseContext(perfTimingEntry) {
    var transferSize = perfTimingEntry.transferSize, encodedBodySize = perfTimingEntry.encodedBodySize, decodedBodySize = perfTimingEntry.decodedBodySize, serverTiming = perfTimingEntry.serverTiming;
    var respContext = {
        transfer_size: transferSize,
        encoded_body_size: encodedBodySize,
        decoded_body_size: decodedBodySize
    };
    var serverTimingStr = (0, $81ba5eca3c0826ee$export$11b3928e177dda19)(serverTiming);
    if (serverTimingStr) respContext.headers = {
        'server-timing': serverTimingStr
    };
    return respContext;
}
function $2c87e6d217c9f6e4$var$getDestination(parsedUrl) {
    var port = parsedUrl.port, protocol = parsedUrl.protocol, hostname = parsedUrl.hostname;
    var portNumber = $2c87e6d217c9f6e4$var$getPortNumber(port, protocol);
    var ipv6Hostname = hostname.charCodeAt(0) === $2c87e6d217c9f6e4$var$LEFT_SQUARE_BRACKET && hostname.charCodeAt(hostname.length - 1) === $2c87e6d217c9f6e4$var$RIGHT_SQUARE_BRACKET;
    var address = hostname;
    if (ipv6Hostname) address = hostname.slice(1, -1);
    return {
        service: {
            resource: hostname + ':' + portNumber,
            name: '',
            type: ''
        },
        address: address,
        port: Number(portNumber)
    };
}
function $2c87e6d217c9f6e4$var$getResourceContext(data) {
    var entry = data.entry, url = data.url;
    var parsedUrl = new (0, $5988178a6f0b5e35$export$59d795186a5d3f58)(url);
    var destination = $2c87e6d217c9f6e4$var$getDestination(parsedUrl);
    return {
        http: {
            url: url,
            response: $2c87e6d217c9f6e4$var$getResponseContext(entry)
        },
        destination: destination
    };
}
function $2c87e6d217c9f6e4$var$getExternalContext(data) {
    var url = data.url, method = data.method, target = data.target, response = data.response;
    var parsedUrl = new (0, $5988178a6f0b5e35$export$59d795186a5d3f58)(url);
    var destination = $2c87e6d217c9f6e4$var$getDestination(parsedUrl);
    var context = {
        http: {
            method: method,
            url: parsedUrl.href
        },
        destination: destination
    };
    var statusCode;
    if (target && typeof target.status !== 'undefined') statusCode = target.status;
    else if (response) statusCode = response.status;
    context.http.status_code = statusCode;
    return context;
}
function $2c87e6d217c9f6e4$var$getNavigationContext(data) {
    var url = data.url;
    var parsedUrl = new (0, $5988178a6f0b5e35$export$59d795186a5d3f58)(url);
    var destination = $2c87e6d217c9f6e4$var$getDestination(parsedUrl);
    return {
        destination: destination
    };
}
function $2c87e6d217c9f6e4$export$1303843c2f44065a() {
    return {
        page: {
            referer: document.referrer,
            url: location.href
        }
    };
}
function $2c87e6d217c9f6e4$export$ed109afa225aed5b(span, data) {
    if (!data) return;
    var type = span.type;
    var context;
    switch(type){
        case $2c87e6d217c9f6e4$var$EXTERNAL:
            context = $2c87e6d217c9f6e4$var$getExternalContext(data);
            break;
        case $2c87e6d217c9f6e4$var$RESOURCE:
            context = $2c87e6d217c9f6e4$var$getResourceContext(data);
            break;
        case $2c87e6d217c9f6e4$var$HARD_NAVIGATION:
            context = $2c87e6d217c9f6e4$var$getNavigationContext(data);
            break;
    }
    span.addContext(context);
}
function $2c87e6d217c9f6e4$export$d10ae57e760667a5(transaction, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, tags = _ref.tags, configContext = $2c87e6d217c9f6e4$var$_objectWithoutPropertiesLoose(_ref, $2c87e6d217c9f6e4$var$_excluded);
    var pageContext = $2c87e6d217c9f6e4$export$1303843c2f44065a();
    var responseContext = {};
    if (transaction.type === (0, $c898cf419eb79f2e$export$2f2f0ccc41f2d4f6)) {
        transaction.ensureContext();
        if (transaction.context.page && transaction.context.page.url) pageContext.page.url = transaction.context.page.url;
    } else if (transaction.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539) && (0, $81ba5eca3c0826ee$export$475e1d086d647d28)()) {
        var entries = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).getEntriesByType((0, $c898cf419eb79f2e$export$f52dcf7131a7f04));
        if (entries && entries.length > 0) responseContext = {
            response: $2c87e6d217c9f6e4$var$getResponseContext(entries[0])
        };
    }
    transaction.addContext(pageContext, responseContext, configContext);
}



var $f7503fddfe9be557$export$cddc53a868778b3a = {
    service: {
        name: [
            (0, $c898cf419eb79f2e$export$1ef49423f809800e),
            true
        ],
        version: true,
        agent: {
            version: [
                (0, $c898cf419eb79f2e$export$1ef49423f809800e),
                true
            ]
        },
        environment: true
    },
    labels: {
        '*': true
    }
};
var $f7503fddfe9be557$export$a92fd7a0c1236a31 = {
    '*': true,
    headers: {
        '*': true
    }
};
var $f7503fddfe9be557$var$DESTINATION_MODEL = {
    address: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e)
    ],
    service: {
        '*': [
            (0, $c898cf419eb79f2e$export$1ef49423f809800e),
            true
        ]
    }
};
var $f7503fddfe9be557$var$CONTEXT_MODEL = {
    user: {
        id: true,
        email: true,
        username: true
    },
    tags: {
        '*': true
    },
    http: {
        response: $f7503fddfe9be557$export$a92fd7a0c1236a31
    },
    destination: $f7503fddfe9be557$var$DESTINATION_MODEL,
    response: $f7503fddfe9be557$export$a92fd7a0c1236a31
};
var $f7503fddfe9be557$export$41c959b800170f79 = {
    name: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    type: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    trace_id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    parent_id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    transaction_id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    subtype: true,
    action: true,
    context: $f7503fddfe9be557$var$CONTEXT_MODEL
};
var $f7503fddfe9be557$export$d887b343e3ec3a69 = {
    name: true,
    parent_id: true,
    type: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    trace_id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    span_count: {
        started: [
            (0, $c898cf419eb79f2e$export$1ef49423f809800e),
            true
        ]
    },
    context: $f7503fddfe9be557$var$CONTEXT_MODEL
};
var $f7503fddfe9be557$export$fdad63db1c0e037c = {
    id: [
        (0, $c898cf419eb79f2e$export$1ef49423f809800e),
        true
    ],
    trace_id: true,
    transaction_id: true,
    parent_id: true,
    culprit: true,
    exception: {
        type: true
    },
    transaction: {
        type: true
    },
    context: $f7503fddfe9be557$var$CONTEXT_MODEL
};
function $f7503fddfe9be557$export$6a506b36fdea397d(value, limit, required, placeholder) {
    if (limit === void 0) limit = (0, $c898cf419eb79f2e$export$1ef49423f809800e);
    if (required === void 0) required = false;
    if (placeholder === void 0) placeholder = 'N/A';
    if (required && $f7503fddfe9be557$var$isEmpty(value)) value = placeholder;
    if (typeof value === 'string') return value.substring(0, limit);
    return value;
}
function $f7503fddfe9be557$var$isEmpty(value) {
    return value == null || value === '' || typeof value === 'undefined';
}
function $f7503fddfe9be557$var$replaceValue(target, key, currModel) {
    var value = $f7503fddfe9be557$export$6a506b36fdea397d(target[key], currModel[0], currModel[1]);
    if ($f7503fddfe9be557$var$isEmpty(value)) {
        delete target[key];
        return;
    }
    target[key] = value;
}
function $f7503fddfe9be557$export$488247de36c98c6b(model, target, childTarget) {
    if (model === void 0) model = {};
    if (childTarget === void 0) childTarget = target;
    var keys = Object.keys(model);
    var emptyArr = [];
    var _loop = function _loop() {
        var currKey = keys[i];
        var currModel = model[currKey] === true ? emptyArr : model[currKey];
        if (!Array.isArray(currModel)) $f7503fddfe9be557$export$488247de36c98c6b(currModel, target, childTarget[currKey]);
        else if (currKey === '*') Object.keys(childTarget).forEach(function(key) {
            return $f7503fddfe9be557$var$replaceValue(childTarget, key, currModel);
        });
        else $f7503fddfe9be557$var$replaceValue(childTarget, currKey, currModel);
    };
    for(var i = 0; i < keys.length; i++)_loop();
    return target;
}


var $c66375c8c82b4372$exports = {};

(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
        'stackframe'
    ], factory);
    else $c66375c8c82b4372$exports = factory((parcelRequire("37gNm")));
})($c66375c8c82b4372$exports, function ErrorStackParser(StackFrame) {
    'use strict';
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
    function _map(array, fn, thisArg) {
        if (typeof Array.prototype.map === 'function') return array.map(fn, thisArg);
        else {
            var output = new Array(array.length);
            for(var i = 0; i < array.length; i++)output[i] = fn.call(thisArg, array[i]);
            return output;
        }
    }
    function _filter(array, fn, thisArg) {
        if (typeof Array.prototype.filter === 'function') return array.filter(fn, thisArg);
        else {
            var output = [];
            for(var i = 0; i < array.length; i++)if (fn.call(thisArg, array[i])) output.push(array[i]);
            return output;
        }
    }
    function _indexOf(array, target) {
        if (typeof Array.prototype.indexOf === 'function') return array.indexOf(target);
        else {
            for(var i = 0; i < array.length; i++){
                if (array[i] === target) return i;
            }
            return -1;
        }
    }
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error('Cannot parse given Error object');
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
                var locationParts = this.extractLocation(tokens.pop());
                var functionName = tokens.join(' ') || undefined;
                var fileName = _indexOf([
                    'eval',
                    '<anonymous>'
                ], locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return _map(filtered, function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame(line);
                else {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionName = tokens.join('@') || undefined;
                    return new StackFrame(functionName, undefined, locationParts[0], locationParts[1], locationParts[2], line);
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame(match[3] || undefined, undefined, match[2], match[1], undefined, lines[i]));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = _filter(error.stack.split('\n'), function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return _map(filtered, function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || '';
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                return new StackFrame(functionName, args, locationParts[0], locationParts[1], locationParts[2], line);
            }, this);
        }
    };
});


var $8424b0768b92f162$var$_excluded = [
    "tags"
];
function $8424b0768b92f162$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8424b0768b92f162$var$IGNORE_KEYS = [
    'stack',
    'message'
];
var $8424b0768b92f162$var$PROMISE_REJECTION_PREFIX = 'Unhandled promise rejection: ';
function $8424b0768b92f162$var$getErrorProperties(error) {
    var propertyFound = false;
    var properties = {};
    Object.keys(error).forEach(function(key) {
        if ($8424b0768b92f162$var$IGNORE_KEYS.indexOf(key) >= 0) return;
        var val = error[key];
        if (val == null || typeof val === 'function') return;
        if (typeof val === 'object') {
            if (typeof val.toISOString !== 'function') return;
            val = val.toISOString();
        }
        properties[key] = val;
        propertyFound = true;
    });
    if (propertyFound) return properties;
}
var $8424b0768b92f162$var$ErrorLogging = function() {
    function ErrorLogging(apmServer, configService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._transactionService = transactionService;
    }
    var _proto = ErrorLogging.prototype;
    _proto.createErrorDataModel = function createErrorDataModel(errorEvent, opts) {
        var frames = (0, $f327a9448dbd3dd9$export$8c8855196b9f04f8)((0, (/*@__PURE__*/$parcel$interopDefault($c66375c8c82b4372$exports))), errorEvent);
        var filteredFrames = (0, $f327a9448dbd3dd9$export$388e43ae04f18461)(frames);
        var culprit = '(inline script)';
        var lastFrame = filteredFrames[filteredFrames.length - 1];
        if (lastFrame && lastFrame.filename) culprit = lastFrame.filename;
        var message = errorEvent.message, error = errorEvent.error;
        var errorMessage = message;
        var errorType = '';
        var errorContext = {};
        if (error && typeof error === 'object') {
            errorMessage = errorMessage || error.message;
            errorType = error.name;
            var customProperties = $8424b0768b92f162$var$getErrorProperties(error);
            if (customProperties) errorContext.custom = customProperties;
        }
        if (opts && opts.labels) {
            var keys = Object.keys(opts.labels);
            errorContext.tags = {};
            keys.forEach(function(k) {
                return (0, $81ba5eca3c0826ee$export$4f65e594f6031297)(k, opts.labels[k], errorContext.tags);
            });
        }
        if (!errorType) {
            if (errorMessage && errorMessage.indexOf(':') > -1) errorType = errorMessage.split(':')[0];
        }
        var currentTransaction = this._transactionService.getCurrentTransaction();
        var transactionContext = currentTransaction ? currentTransaction.context : {};
        var _this$_configService$ = this._configService.get('context'), tags = _this$_configService$.tags, configContext = $8424b0768b92f162$var$_objectWithoutPropertiesLoose(_this$_configService$, $8424b0768b92f162$var$_excluded);
        var pageContext = (0, $2c87e6d217c9f6e4$export$1303843c2f44065a)();
        var context = (0, $81ba5eca3c0826ee$export$4950aa0f605343fb)({}, pageContext, transactionContext, configContext, errorContext);
        var errorObject = {
            id: (0, $81ba5eca3c0826ee$export$59b2544ec352d56)(),
            culprit: culprit,
            exception: {
                message: errorMessage,
                stacktrace: filteredFrames,
                type: errorType
            },
            context: context
        };
        if (currentTransaction) errorObject = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)(errorObject, {
            trace_id: currentTransaction.traceId,
            parent_id: currentTransaction.id,
            transaction_id: currentTransaction.id,
            transaction: {
                type: currentTransaction.type,
                sampled: currentTransaction.sampled
            }
        });
        return (0, $f7503fddfe9be557$export$488247de36c98c6b)((0, $f7503fddfe9be557$export$fdad63db1c0e037c), errorObject);
    };
    _proto.logErrorEvent = function logErrorEvent(errorEvent, opts) {
        if (typeof errorEvent === 'undefined') return;
        var errorObject = this.createErrorDataModel(errorEvent, opts);
        if (typeof errorObject.exception.message === 'undefined') return;
        this._apmServer.addError(errorObject);
    };
    _proto.registerListeners = function registerListeners() {
        var _this = this;
        window.addEventListener('error', function(errorEvent) {
            return _this.logErrorEvent(errorEvent);
        });
        window.addEventListener('unhandledrejection', function(promiseRejectionEvent) {
            return _this.logPromiseEvent(promiseRejectionEvent);
        });
    };
    _proto.logPromiseEvent = function logPromiseEvent(promiseRejectionEvent) {
        var reason = promiseRejectionEvent.reason;
        if (reason == null) reason = '<no reason specified>';
        var errorEvent;
        if (typeof reason.message === 'string') {
            var name = reason.name ? reason.name + ': ' : '';
            errorEvent = {
                error: reason,
                message: $8424b0768b92f162$var$PROMISE_REJECTION_PREFIX + name + reason.message
            };
        } else errorEvent = this._parseRejectReason(reason);
        this.logErrorEvent(errorEvent);
    };
    _proto.logError = function logError(messageOrError, opts) {
        var errorEvent = {};
        if (typeof messageOrError === 'string') errorEvent.message = messageOrError;
        else errorEvent.error = messageOrError;
        return this.logErrorEvent(errorEvent, opts);
    };
    _proto._parseRejectReason = function _parseRejectReason(reason) {
        var errorEvent = {
            message: $8424b0768b92f162$var$PROMISE_REJECTION_PREFIX
        };
        if (Array.isArray(reason)) errorEvent.message += '<object>';
        else if (typeof reason === 'object') try {
            errorEvent.message += JSON.stringify(reason);
            errorEvent.error = reason;
        } catch (error) {
            errorEvent.message += '<object>';
        }
        else if (typeof reason === 'function') errorEvent.message += '<function>';
        else errorEvent.message += reason;
        return errorEvent;
    };
    return ErrorLogging;
}();
var $8424b0768b92f162$export$2e2bcd8739ae039 = $8424b0768b92f162$var$ErrorLogging;



var $9af5f5effd3d929a$var$Queue = function() {
    function Queue(onFlush, opts) {
        if (opts === void 0) opts = {};
        this.onFlush = onFlush;
        this.items = [];
        this.queueLimit = opts.queueLimit || -1;
        this.flushInterval = opts.flushInterval || 0;
        this.timeoutId = undefined;
    }
    var _proto = Queue.prototype;
    _proto._setTimer = function _setTimer() {
        var _this = this;
        this.timeoutId = setTimeout(function() {
            return _this.flush();
        }, this.flushInterval);
    };
    _proto._clear = function _clear() {
        if (typeof this.timeoutId !== 'undefined') {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this.items = [];
    };
    _proto.flush = function flush() {
        this.onFlush(this.items);
        this._clear();
    };
    _proto.add = function add(item) {
        this.items.push(item);
        if (this.queueLimit !== -1 && this.items.length >= this.queueLimit) this.flush();
        else if (typeof this.timeoutId === 'undefined') this._setTimer();
    };
    return Queue;
}();
var $9af5f5effd3d929a$export$2e2bcd8739ae039 = $9af5f5effd3d929a$var$Queue;


function $8ac95c1c43d400ed$export$2e2bcd8739ae039(fn, onThrottle, opts) {
    var context = this;
    var limit = opts.limit;
    var interval = opts.interval;
    var counter = 0;
    var timeoutId;
    return function() {
        counter++;
        if (typeof timeoutId === 'undefined') timeoutId = setTimeout(function() {
            counter = 0;
            timeoutId = undefined;
        }, interval);
        if (counter > limit && typeof onThrottle === 'function') return onThrottle.apply(context, arguments);
        else return fn.apply(context, arguments);
    };
}


var $4e70de5410636a6e$var$NDJSON = function() {
    function NDJSON() {}
    NDJSON.stringify = function stringify(object) {
        return JSON.stringify(object) + '\n';
    };
    return NDJSON;
}();
var $4e70de5410636a6e$export$2e2bcd8739ae039 = $4e70de5410636a6e$var$NDJSON;








var $8564c6c1fe599bf1$export$76056912abddbcc9 = [
    'fetchStart',
    'domainLookupStart',
    'domainLookupEnd',
    'connectStart',
    'connectEnd',
    'requestStart',
    'responseStart',
    'responseEnd',
    'domLoading',
    'domInteractive',
    'domContentLoadedEventStart',
    'domContentLoadedEventEnd',
    'domComplete',
    'loadEventStart',
    'loadEventEnd'
];
var $8564c6c1fe599bf1$export$82a807639806d09d = [
    'fs',
    'ls',
    'le',
    'cs',
    'ce',
    'qs',
    'rs',
    're',
    'dl',
    'di',
    'ds',
    'de',
    'dc',
    'es',
    'ee'
];
function $8564c6c1fe599bf1$export$f010c0904d0d2983(timing) {
    var marks = $8564c6c1fe599bf1$var$getNavigationTimingMarks(timing);
    if (marks == null) return null;
    return {
        navigationTiming: marks,
        agent: {
            timeToFirstByte: marks.responseStart,
            domInteractive: marks.domInteractive,
            domComplete: marks.domComplete
        }
    };
}
function $8564c6c1fe599bf1$var$getNavigationTimingMarks(timing) {
    var redirectStart = timing.redirectStart, fetchStart = timing.fetchStart, navigationStart = timing.navigationStart, responseStart = timing.responseStart, responseEnd = timing.responseEnd;
    if (fetchStart >= navigationStart && responseStart >= fetchStart && responseEnd >= responseStart) {
        var marks = {};
        $8564c6c1fe599bf1$export$76056912abddbcc9.forEach(function(timingKey) {
            var m = timing[timingKey];
            if (m && m >= fetchStart) {
                if ((0, $81ba5eca3c0826ee$export$ffcb82e8b0e258ec)(timing)) marks[timingKey] = parseInt(m - redirectStart);
                else marks[timingKey] = parseInt(m - fetchStart);
            }
        });
        return marks;
    }
    return null;
}



function $a415d170de117aac$var$compressStackFrames(frames) {
    return frames.map(function(frame) {
        return {
            ap: frame.abs_path,
            f: frame.filename,
            fn: frame.function,
            li: frame.lineno,
            co: frame.colno
        };
    });
}
function $a415d170de117aac$var$compressResponse(response) {
    return {
        ts: response.transfer_size,
        ebs: response.encoded_body_size,
        dbs: response.decoded_body_size
    };
}
function $a415d170de117aac$var$compressHTTP(http) {
    var compressed = {};
    var method = http.method, status_code = http.status_code, url = http.url, response = http.response;
    compressed.url = url;
    if (method) compressed.mt = method;
    if (status_code) compressed.sc = status_code;
    if (response) compressed.r = $a415d170de117aac$var$compressResponse(response);
    return compressed;
}
function $a415d170de117aac$var$compressContext(context) {
    if (!context) return null;
    var compressed = {};
    var page = context.page, http = context.http, response = context.response, destination = context.destination, user = context.user, custom = context.custom, tags = context.tags;
    if (page) compressed.p = {
        rf: page.referer,
        url: page.url
    };
    if (http) compressed.h = $a415d170de117aac$var$compressHTTP(http);
    if (response) compressed.r = $a415d170de117aac$var$compressResponse(response);
    if (destination) {
        var service = destination.service;
        compressed.dt = {
            se: {
                n: service.name,
                t: service.type,
                rc: service.resource
            },
            ad: destination.address,
            po: destination.port
        };
    }
    if (user) compressed.u = {
        id: user.id,
        un: user.username,
        em: user.email
    };
    if (custom) compressed.cu = custom;
    if (tags) compressed.g = tags;
    return compressed;
}
function $a415d170de117aac$var$compressMarks(marks) {
    if (!marks) return null;
    var compressedNtMarks = $a415d170de117aac$var$compressNavigationTimingMarks(marks.navigationTiming);
    var compressed = {
        nt: compressedNtMarks,
        a: $a415d170de117aac$var$compressAgentMarks(compressedNtMarks, marks.agent)
    };
    return compressed;
}
function $a415d170de117aac$var$compressNavigationTimingMarks(ntMarks) {
    if (!ntMarks) return null;
    var compressed = {};
    (0, $8564c6c1fe599bf1$export$82a807639806d09d).forEach(function(mark, index) {
        var mapping = (0, $8564c6c1fe599bf1$export$76056912abddbcc9)[index];
        compressed[mark] = ntMarks[mapping];
    });
    return compressed;
}
function $a415d170de117aac$var$compressAgentMarks(compressedNtMarks, agentMarks) {
    var compressed = {};
    if (compressedNtMarks) compressed = {
        fb: compressedNtMarks.rs,
        di: compressedNtMarks.di,
        dc: compressedNtMarks.dc
    };
    if (agentMarks) {
        var fp = agentMarks.firstContentfulPaint;
        var lp = agentMarks.largestContentfulPaint;
        if (fp) compressed.fp = fp;
        if (lp) compressed.lp = lp;
    }
    if (Object.keys(compressed).length === 0) return null;
    return compressed;
}
function $a415d170de117aac$export$12b7560e2fabea9(metadata) {
    var service = metadata.service, labels = metadata.labels;
    var agent = service.agent, language = service.language;
    return {
        se: {
            n: service.name,
            ve: service.version,
            a: {
                n: agent.name,
                ve: agent.version
            },
            la: {
                n: language.name
            },
            en: service.environment
        },
        l: labels
    };
}
function $a415d170de117aac$export$2113d87e265597f0(transaction) {
    var spans = transaction.spans.map(function(span) {
        var spanData = {
            id: span.id,
            n: span.name,
            t: span.type,
            s: span.start,
            d: span.duration,
            c: $a415d170de117aac$var$compressContext(span.context),
            o: span.outcome,
            sr: span.sample_rate
        };
        if (span.parent_id !== transaction.id) spanData.pid = span.parent_id;
        if (span.sync === true) spanData.sy = true;
        if (span.subtype) spanData.su = span.subtype;
        if (span.action) spanData.ac = span.action;
        return spanData;
    });
    var tr = {
        id: transaction.id,
        pid: transaction.parent_id,
        tid: transaction.trace_id,
        n: transaction.name,
        t: transaction.type,
        d: transaction.duration,
        c: $a415d170de117aac$var$compressContext(transaction.context),
        k: $a415d170de117aac$var$compressMarks(transaction.marks),
        me: $a415d170de117aac$export$9327fccd6912fe3c(transaction.breakdown),
        y: spans,
        yc: {
            sd: spans.length
        },
        sm: transaction.sampled,
        sr: transaction.sample_rate,
        o: transaction.outcome
    };
    if (transaction.experience) {
        var _transaction$experien = transaction.experience, cls = _transaction$experien.cls, fid = _transaction$experien.fid, tbt = _transaction$experien.tbt, longtask = _transaction$experien.longtask;
        tr.exp = {
            cls: cls,
            fid: fid,
            tbt: tbt,
            lt: longtask
        };
    }
    if (transaction.session) {
        var _transaction$session = transaction.session, id = _transaction$session.id, sequence = _transaction$session.sequence;
        tr.ses = {
            id: id,
            seq: sequence
        };
    }
    return tr;
}
function $a415d170de117aac$export$c8289256501a337d(error) {
    var exception = error.exception;
    var compressed = {
        id: error.id,
        cl: error.culprit,
        ex: {
            mg: exception.message,
            st: $a415d170de117aac$var$compressStackFrames(exception.stacktrace),
            t: error.type
        },
        c: $a415d170de117aac$var$compressContext(error.context)
    };
    var transaction = error.transaction;
    if (transaction) {
        compressed.tid = error.trace_id;
        compressed.pid = error.parent_id;
        compressed.xid = error.transaction_id;
        compressed.x = {
            t: transaction.type,
            sm: transaction.sampled
        };
    }
    return compressed;
}
function $a415d170de117aac$export$9327fccd6912fe3c(breakdowns) {
    return breakdowns.map(function(_ref) {
        var span = _ref.span, samples = _ref.samples;
        return {
            y: {
                t: span.type
            },
            sa: {
                ysc: {
                    v: samples['span.self_time.count'].value
                },
                yss: {
                    v: samples['span.self_time.sum.us'].value
                }
            }
        };
    });
}
function $a415d170de117aac$export$5569fdd03c217956(params, type) {
    if (type === void 0) type = 'gzip';
    var isCompressionStreamSupported = typeof CompressionStream === 'function';
    return new (0, $2bb64b3ee44f1905$export$775f0de60169233c)(function(resolve) {
        if (!isCompressionStreamSupported) return resolve(params);
        if ((0, $81ba5eca3c0826ee$export$7aca418b79512736)()) return resolve(params);
        var payload = params.payload, headers = params.headers, beforeSend = params.beforeSend;
        var payloadStream = new Blob([
            payload
        ]).stream();
        var compressedStream = payloadStream.pipeThrough(new CompressionStream(type));
        return new Response(compressedStream).blob().then(function(payload) {
            headers['Content-Encoding'] = type;
            return resolve({
                payload: payload,
                headers: headers,
                beforeSend: beforeSend
            });
        });
    });
}







function $dabaf7b8756a1710$export$998d51f5856d10f5(method, url, _ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? HTTP_REQUEST_TIMEOUT : _ref$timeout, payload = _ref.payload, headers = _ref.headers, beforeSend = _ref.beforeSend, sendCredentials = _ref.sendCredentials;
    return new (0, $2bb64b3ee44f1905$export$775f0de60169233c)(function(resolve, reject) {
        var xhr = new window.XMLHttpRequest();
        xhr[0, $9c916c6998c5246b$export$1d2facecfc1955cc] = true;
        xhr.open(method, url, true);
        xhr.timeout = timeout;
        xhr.withCredentials = sendCredentials;
        if (headers) {
            for(var header in headers)if (headers.hasOwnProperty(header)) xhr.setRequestHeader(header, headers[header]);
        }
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var status = xhr.status, responseText = xhr.responseText;
                if ((0, $03a1fcf2d7b8ba32$export$1f29f0bf55f6a59e)(status)) resolve(xhr);
                else reject({
                    url: url,
                    status: status,
                    responseText: responseText
                });
            }
        };
        xhr.onerror = function() {
            var status = xhr.status, responseText = xhr.responseText;
            reject({
                url: url,
                status: status,
                responseText: responseText
            });
        };
        var canSend = true;
        if (typeof beforeSend === 'function') canSend = beforeSend({
            url: url,
            method: method,
            headers: headers,
            payload: payload,
            xhr: xhr
        });
        if (canSend) xhr.send(payload);
        else reject({
            url: url,
            status: 0,
            responseText: 'Request rejected by user configuration.'
        });
    });
}


var $5c61aee7b759d238$var$THROTTLE_INTERVAL = 60000;
var $5c61aee7b759d238$var$ApmServer = function() {
    function ApmServer(configService, loggingService) {
        this._configService = configService;
        this._loggingService = loggingService;
        this.queue = undefined;
        this.throttleEvents = (0, $81ba5eca3c0826ee$export$8793edee2d425525);
    }
    var _proto = ApmServer.prototype;
    _proto.init = function init() {
        var _this = this;
        var queueLimit = this._configService.get('queueLimit');
        var flushInterval = this._configService.get('flushInterval');
        var limit = this._configService.get('eventsLimit');
        var onFlush = function onFlush(events) {
            var promise = _this.sendEvents(events);
            if (promise) promise.catch(function(reason) {
                _this._loggingService.warn('Failed sending events!', _this._constructError(reason));
            });
        };
        this.queue = new (0, $9af5f5effd3d929a$export$2e2bcd8739ae039)(onFlush, {
            queueLimit: queueLimit,
            flushInterval: flushInterval
        });
        this.throttleEvents = (0, $8ac95c1c43d400ed$export$2e2bcd8739ae039)(this.queue.add.bind(this.queue), function() {
            return _this._loggingService.warn('Dropped events due to throttling!');
        }, {
            limit: limit,
            interval: $5c61aee7b759d238$var$THROTTLE_INTERVAL
        });
        this._configService.observeEvent((0, $c898cf419eb79f2e$export$19245af82a094556), function() {
            _this.queue.flush();
        });
    };
    _proto._postJson = function _postJson(endPoint, payload) {
        var _this2 = this;
        var headers = {
            'Content-Type': 'application/x-ndjson'
        };
        var apmRequest = this._configService.get('apmRequest');
        var params = {
            payload: payload,
            headers: headers,
            beforeSend: apmRequest
        };
        return (0, $a415d170de117aac$export$5569fdd03c217956)(params).catch(function(error) {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) _this2._loggingService.debug('Compressing the payload using CompressionStream API failed', error.message);
            return params;
        }).then(function(result) {
            return _this2._makeHttpRequest('POST', endPoint, result);
        }).then(function(_ref) {
            var responseText = _ref.responseText;
            return responseText;
        });
    };
    _proto._constructError = function _constructError(reason) {
        var url = reason.url, status = reason.status, responseText = reason.responseText;
        if (typeof status == 'undefined') return reason;
        var message = url + ' HTTP status: ' + status;
        if ((0, $d15fb30d84867e0d$export$a866f231438cc228) && responseText) try {
            var serverErrors = [];
            var response = JSON.parse(responseText);
            if (response.errors && response.errors.length > 0) {
                response.errors.forEach(function(err) {
                    return serverErrors.push(err.message);
                });
                message += ' ' + serverErrors.join(',');
            }
        } catch (e) {
            this._loggingService.debug('Error parsing response from APM server', e);
        }
        return new Error(message);
    };
    _proto._makeHttpRequest = function _makeHttpRequest(method, url, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$timeout = _ref2.timeout, timeout = _ref2$timeout === void 0 ? (0, $c898cf419eb79f2e$export$304f7f334b3888b0) : _ref2$timeout, payload = _ref2.payload, headers = _ref2.headers, beforeSend = _ref2.beforeSend;
        var sendCredentials = this._configService.get('sendCredentials');
        if (!beforeSend && (0, $a688f717d9590693$export$7671e9773d28088a)(method, payload)) return (0, $a688f717d9590693$export$de4ef9c2599856d6)(method, url, {
            keepalive: true,
            timeout: timeout,
            payload: payload,
            headers: headers,
            sendCredentials: sendCredentials
        }).catch(function(reason) {
            if (reason instanceof TypeError) return (0, $dabaf7b8756a1710$export$998d51f5856d10f5)(method, url, {
                timeout: timeout,
                payload: payload,
                headers: headers,
                beforeSend: beforeSend,
                sendCredentials: sendCredentials
            });
            throw reason;
        });
        return (0, $dabaf7b8756a1710$export$998d51f5856d10f5)(method, url, {
            timeout: timeout,
            payload: payload,
            headers: headers,
            beforeSend: beforeSend,
            sendCredentials: sendCredentials
        });
    };
    _proto.fetchConfig = function fetchConfig(serviceName, environment) {
        var _this3 = this;
        var _this$getEndpoints = this.getEndpoints(), configEndpoint = _this$getEndpoints.configEndpoint;
        if (!serviceName) return (0, $2bb64b3ee44f1905$export$775f0de60169233c).reject('serviceName is required for fetching central config.');
        configEndpoint += "?service.name=" + serviceName;
        if (environment) configEndpoint += "&service.environment=" + environment;
        var localConfig = this._configService.getLocalConfig();
        if (localConfig) configEndpoint += "&ifnonematch=" + localConfig.etag;
        var apmRequest = this._configService.get('apmRequest');
        return this._makeHttpRequest('GET', configEndpoint, {
            timeout: 5000,
            beforeSend: apmRequest
        }).then(function(xhr) {
            var status = xhr.status, responseText = xhr.responseText;
            if (status === 304) return localConfig;
            else {
                var remoteConfig = JSON.parse(responseText);
                var etag = xhr.getResponseHeader('etag');
                if (etag) {
                    remoteConfig.etag = etag.replace(/["]/g, '');
                    _this3._configService.setLocalConfig(remoteConfig, true);
                }
                return remoteConfig;
            }
        }).catch(function(reason) {
            var error = _this3._constructError(reason);
            return (0, $2bb64b3ee44f1905$export$775f0de60169233c).reject(error);
        });
    };
    _proto.createMetaData = function createMetaData() {
        var cfg = this._configService;
        var metadata = {
            service: {
                name: cfg.get('serviceName'),
                version: cfg.get('serviceVersion'),
                agent: {
                    name: 'rum-js',
                    version: cfg.version
                },
                language: {
                    name: 'javascript'
                },
                environment: cfg.get('environment')
            },
            labels: cfg.get('context.tags')
        };
        return (0, $f7503fddfe9be557$export$488247de36c98c6b)((0, $f7503fddfe9be557$export$cddc53a868778b3a), metadata);
    };
    _proto.addError = function addError(error) {
        var _this$throttleEvents;
        this.throttleEvents((_this$throttleEvents = {}, _this$throttleEvents[0, $c898cf419eb79f2e$export$4fd720569787ab6f] = error, _this$throttleEvents));
    };
    _proto.addTransaction = function addTransaction(transaction) {
        var _this$throttleEvents2;
        this.throttleEvents((_this$throttleEvents2 = {}, _this$throttleEvents2[0, $c898cf419eb79f2e$export$33e749855cc8f893] = transaction, _this$throttleEvents2));
    };
    _proto.ndjsonErrors = function ndjsonErrors(errors, compress) {
        var key = compress ? 'e' : 'error';
        return errors.map(function(error) {
            var _NDJSON$stringify;
            return (0, $4e70de5410636a6e$export$2e2bcd8739ae039).stringify((_NDJSON$stringify = {}, _NDJSON$stringify[key] = compress ? (0, $a415d170de117aac$export$c8289256501a337d)(error) : error, _NDJSON$stringify));
        });
    };
    _proto.ndjsonMetricsets = function ndjsonMetricsets(metricsets) {
        return metricsets.map(function(metricset) {
            return (0, $4e70de5410636a6e$export$2e2bcd8739ae039).stringify({
                metricset: metricset
            });
        }).join('');
    };
    _proto.ndjsonTransactions = function ndjsonTransactions(transactions, compress) {
        var _this4 = this;
        var key = compress ? 'x' : 'transaction';
        return transactions.map(function(tr) {
            var _NDJSON$stringify2;
            var spans = '', breakdowns = '';
            if (!compress) {
                if (tr.spans) {
                    spans = tr.spans.map(function(span) {
                        return (0, $4e70de5410636a6e$export$2e2bcd8739ae039).stringify({
                            span: span
                        });
                    }).join('');
                    delete tr.spans;
                }
                if (tr.breakdown) {
                    breakdowns = _this4.ndjsonMetricsets(tr.breakdown);
                    delete tr.breakdown;
                }
            }
            return (0, $4e70de5410636a6e$export$2e2bcd8739ae039).stringify((_NDJSON$stringify2 = {}, _NDJSON$stringify2[key] = compress ? (0, $a415d170de117aac$export$2113d87e265597f0)(tr) : tr, _NDJSON$stringify2)) + spans + breakdowns;
        });
    };
    _proto.sendEvents = function sendEvents(events) {
        var _payload, _NDJSON$stringify3;
        if (events.length === 0) return;
        var transactions = [];
        var errors = [];
        for(var i = 0; i < events.length; i++){
            var event = events[i];
            if (event[0, $c898cf419eb79f2e$export$33e749855cc8f893]) transactions.push(event[0, $c898cf419eb79f2e$export$33e749855cc8f893]);
            if (event[0, $c898cf419eb79f2e$export$4fd720569787ab6f]) errors.push(event[0, $c898cf419eb79f2e$export$4fd720569787ab6f]);
        }
        if (transactions.length === 0 && errors.length === 0) return;
        var cfg = this._configService;
        var payload = (_payload = {}, _payload[0, $c898cf419eb79f2e$export$33e749855cc8f893] = transactions, _payload[0, $c898cf419eb79f2e$export$4fd720569787ab6f] = errors, _payload);
        var filteredPayload = cfg.applyFilters(payload);
        if (!filteredPayload) {
            this._loggingService.warn('Dropped payload due to filtering!');
            return;
        }
        var apiVersion = cfg.get('apiVersion');
        var compress = apiVersion > 2;
        var ndjson = [];
        var metadata = this.createMetaData();
        var metadataKey = compress ? 'm' : 'metadata';
        ndjson.push((0, $4e70de5410636a6e$export$2e2bcd8739ae039).stringify((_NDJSON$stringify3 = {}, _NDJSON$stringify3[metadataKey] = compress ? (0, $a415d170de117aac$export$12b7560e2fabea9)(metadata) : metadata, _NDJSON$stringify3)));
        ndjson = ndjson.concat(this.ndjsonErrors(filteredPayload[0, $c898cf419eb79f2e$export$4fd720569787ab6f], compress), this.ndjsonTransactions(filteredPayload[0, $c898cf419eb79f2e$export$33e749855cc8f893], compress));
        var ndjsonPayload = ndjson.join('');
        var _this$getEndpoints2 = this.getEndpoints(), intakeEndpoint = _this$getEndpoints2.intakeEndpoint;
        return this._postJson(intakeEndpoint, ndjsonPayload);
    };
    _proto.getEndpoints = function getEndpoints() {
        var serverUrl = this._configService.get('serverUrl');
        var apiVersion = this._configService.get('apiVersion');
        var serverUrlPrefix = this._configService.get('serverUrlPrefix') || "/intake/v" + apiVersion + "/rum/events";
        var intakeEndpoint = serverUrl + serverUrlPrefix;
        var configEndpoint = serverUrl + "/config/v1/rum/agents";
        return {
            intakeEndpoint: intakeEndpoint,
            configEndpoint: configEndpoint
        };
    };
    return ApmServer;
}();
var $5c61aee7b759d238$export$2e2bcd8739ae039 = $5c61aee7b759d238$var$ApmServer;






function $f4c4c8bffc059370$var$_extends() {
    return $f4c4c8bffc059370$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f4c4c8bffc059370$var$_extends.apply(null, arguments);
}
function $f4c4c8bffc059370$var$getConfigFromScript() {
    var script = (0, $81ba5eca3c0826ee$export$8fc24885882b6ead)();
    var config = $f4c4c8bffc059370$var$getDataAttributesFromNode(script);
    return config;
}
function $f4c4c8bffc059370$var$getDataAttributesFromNode(node) {
    if (!node) return {};
    var dataAttrs = {};
    var dataRegex = /^data-([\w-]+)$/;
    var attrs = node.attributes;
    for(var i = 0; i < attrs.length; i++){
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
            var key = attr.nodeName.match(dataRegex)[1];
            var camelCasedkey = key.split('-').map(function(value, index) {
                return index > 0 ? value.charAt(0).toUpperCase() + value.substring(1) : value;
            }).join('');
            dataAttrs[camelCasedkey] = attr.value || attr.nodeValue;
        }
    }
    return dataAttrs;
}
var $f4c4c8bffc059370$var$Config = function() {
    function Config() {
        this.config = {
            serviceName: '',
            serviceVersion: '',
            environment: '',
            serverUrl: 'http://localhost:8200',
            serverUrlPrefix: '',
            active: true,
            instrument: true,
            disableInstrumentations: [],
            logLevel: 'warn',
            breakdownMetrics: false,
            ignoreTransactions: [],
            eventsLimit: 80,
            queueLimit: -1,
            flushInterval: 500,
            distributedTracing: true,
            distributedTracingOrigins: [],
            distributedTracingHeaderName: 'traceparent',
            pageLoadTraceId: '',
            pageLoadSpanId: '',
            pageLoadSampled: false,
            pageLoadParentId: '',
            pageLoadTransactionName: '',
            propagateTracestate: false,
            transactionSampleRate: 1.0,
            centralConfig: false,
            monitorLongtasks: true,
            apiVersion: 2,
            context: {},
            session: false,
            apmRequest: null,
            sendCredentials: false,
            reportTransactionsWithoutSpans: false
        };
        this.events = new (0, $b5a55fec8aea0311$export$2e2bcd8739ae039)();
        this.filters = [];
        this.version = '';
    }
    var _proto = Config.prototype;
    _proto.init = function init() {
        var scriptData = $f4c4c8bffc059370$var$getConfigFromScript();
        this.setConfig(scriptData);
    };
    _proto.setVersion = function setVersion(version) {
        this.version = version;
    };
    _proto.addFilter = function addFilter(cb) {
        if (typeof cb !== 'function') throw new Error('Argument to must be function');
        this.filters.push(cb);
    };
    _proto.applyFilters = function applyFilters(data) {
        try {
            for(var i = 0; i < this.filters.length; i++){
                data = this.filters[i](data);
                if (!data) return;
            }
            data.transactions = data.transactions.filter(function(t) {
                return t;
            });
            data.errors = data.errors.filter(function(e) {
                return e;
            });
            if (data.transactions.length === 0 && data.errors.length === 0) return;
        } catch (e) {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) console.log('[Elastic APM] Error applying filters for RUM payload', e);
            return;
        }
        return data;
    };
    _proto.get = function get(key) {
        return key.split('.').reduce(function(obj, objKey) {
            return obj && obj[objKey];
        }, this.config);
    };
    _proto.setUserContext = function setUserContext(userContext) {
        if (userContext === void 0) userContext = {};
        var context = {};
        var _userContext = userContext, id = _userContext.id, username = _userContext.username, email = _userContext.email;
        if (typeof id === 'number' || typeof id === 'string') context.id = id;
        if (typeof username === 'string') context.username = username;
        if (typeof email === 'string') context.email = email;
        this.config.context.user = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)(this.config.context.user || {}, context);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        if (customContext === void 0) customContext = {};
        this.config.context.custom = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)(this.config.context.custom || {}, customContext);
    };
    _proto.addLabels = function addLabels(tags) {
        var _this = this;
        if (!this.config.context.tags) this.config.context.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $81ba5eca3c0826ee$export$4f65e594f6031297)(k, tags[k], _this.config.context.tags);
        });
    };
    _proto.setConfig = function setConfig(properties) {
        if (properties === void 0) properties = {};
        var _properties = properties, transactionSampleRate = _properties.transactionSampleRate, serverUrl = _properties.serverUrl;
        if (serverUrl) properties.serverUrl = serverUrl.replace(/\/+$/, '');
        if (!(0, $81ba5eca3c0826ee$export$fce6876652108ab)(transactionSampleRate)) {
            if (transactionSampleRate < 0.0001 && transactionSampleRate > 0) transactionSampleRate = 0.0001;
            properties.transactionSampleRate = Math.round(transactionSampleRate * 10000) / 10000;
        }
        this.config = (0, $81ba5eca3c0826ee$export$4950aa0f605343fb)(this.config, properties);
        this.events.send((0, $c898cf419eb79f2e$export$36257f40a0d30563), [
            this.config
        ]);
    };
    _proto.validate = function validate(properties) {
        if (properties === void 0) properties = {};
        var requiredKeys = [
            'serviceName',
            'serverUrl'
        ];
        var allKeys = Object.keys(this.config);
        var errors = {
            missing: [],
            invalid: [],
            unknown: []
        };
        Object.keys(properties).forEach(function(key) {
            if (requiredKeys.indexOf(key) !== -1 && !properties[key]) errors.missing.push(key);
            if (allKeys.indexOf(key) === -1) errors.unknown.push(key);
        });
        if (properties.serviceName && !/^[a-zA-Z0-9 _-]+$/.test(properties.serviceName)) errors.invalid.push({
            key: 'serviceName',
            value: properties.serviceName,
            allowed: 'a-z, A-Z, 0-9, _, -, <space>'
        });
        var sampleRate = properties.transactionSampleRate;
        if (typeof sampleRate !== 'undefined' && (typeof sampleRate !== 'number' || isNaN(sampleRate) || sampleRate < 0 || sampleRate > 1)) errors.invalid.push({
            key: 'transactionSampleRate',
            value: sampleRate,
            allowed: 'Number between 0 and 1'
        });
        return errors;
    };
    _proto.getLocalConfig = function getLocalConfig() {
        var storage = sessionStorage;
        if (this.config.session) storage = localStorage;
        var config = storage.getItem((0, $c898cf419eb79f2e$export$f1f46202fdd81911));
        if (config) return JSON.parse(config);
    };
    _proto.setLocalConfig = function setLocalConfig(config, merge) {
        if (config) {
            if (merge) {
                var prevConfig = this.getLocalConfig();
                config = $f4c4c8bffc059370$var$_extends({}, prevConfig, config);
            }
            var storage = sessionStorage;
            if (this.config.session) storage = localStorage;
            storage.setItem((0, $c898cf419eb79f2e$export$f1f46202fdd81911), JSON.stringify(config));
        }
    };
    _proto.dispatchEvent = function dispatchEvent(name, args) {
        this.events.send(name, args);
    };
    _proto.observeEvent = function observeEvent(name, fn) {
        return this.events.observe(name, fn);
    };
    return Config;
}();
var $f4c4c8bffc059370$export$2e2bcd8739ae039 = $f4c4c8bffc059370$var$Config;



var $606216bbcaaf79d2$var$LoggingService = function() {
    function LoggingService(spec) {
        if (spec === void 0) spec = {};
        this.levels = [
            'trace',
            'debug',
            'info',
            'warn',
            'error'
        ];
        this.level = spec.level || 'warn';
        this.prefix = spec.prefix || '';
        this.resetLogMethods();
    }
    var _proto = LoggingService.prototype;
    _proto.shouldLog = function shouldLog(level) {
        return this.levels.indexOf(level) >= this.levels.indexOf(this.level);
    };
    _proto.setLevel = function setLevel(level) {
        if (level === this.level) return;
        this.level = level;
        this.resetLogMethods();
    };
    _proto.resetLogMethods = function resetLogMethods() {
        var _this = this;
        this.levels.forEach(function(level) {
            _this[level] = _this.shouldLog(level) ? log : (0, $81ba5eca3c0826ee$export$8793edee2d425525);
            function log() {
                var normalizedLevel = level;
                if (level === 'trace' || level === 'debug') normalizedLevel = 'info';
                var args = arguments;
                args[0] = this.prefix + args[0];
                if (console) {
                    var realMethod = console[normalizedLevel] || console.log;
                    if (typeof realMethod === 'function') realMethod.apply(console, args);
                }
            }
        });
    };
    return LoggingService;
}();
var $606216bbcaaf79d2$export$2e2bcd8739ae039 = $606216bbcaaf79d2$var$LoggingService;




var $fa349a7677bf25be$var$_serviceCreators;
var $fa349a7677bf25be$export$a7d9bc765837b75c = ($fa349a7677bf25be$var$_serviceCreators = {}, $fa349a7677bf25be$var$_serviceCreators[0, $c898cf419eb79f2e$export$11170dadd5705a7b] = function() {
    return new (0, $f4c4c8bffc059370$export$2e2bcd8739ae039)();
}, $fa349a7677bf25be$var$_serviceCreators[0, $c898cf419eb79f2e$export$7d973190a36b8246] = function() {
    return new (0, $606216bbcaaf79d2$export$2e2bcd8739ae039)({
        prefix: '[Elastic APM] '
    });
}, $fa349a7677bf25be$var$_serviceCreators[0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37] = function(factory) {
    var _factory$getService = factory.getService([
        (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
        (0, $c898cf419eb79f2e$export$7d973190a36b8246)
    ]), configService = _factory$getService[0], loggingService = _factory$getService[1];
    return new (0, $5c61aee7b759d238$export$2e2bcd8739ae039)(configService, loggingService);
}, $fa349a7677bf25be$var$_serviceCreators);
var $fa349a7677bf25be$export$654036ce31f352db = function() {
    function ServiceFactory() {
        this.instances = {};
        this.initialized = false;
    }
    var _proto = ServiceFactory.prototype;
    _proto.init = function init() {
        if (this.initialized) return;
        this.initialized = true;
        var configService = this.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.init();
        var _this$getService = this.getService([
            (0, $c898cf419eb79f2e$export$7d973190a36b8246),
            (0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37)
        ]), loggingService = _this$getService[0], apmServer = _this$getService[1];
        configService.events.observe((0, $c898cf419eb79f2e$export$36257f40a0d30563), function() {
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
        });
        apmServer.init();
    };
    _proto.getService = function getService(name) {
        var _this = this;
        if (typeof name === 'string') {
            if (!this.instances[name]) {
                if (typeof $fa349a7677bf25be$export$a7d9bc765837b75c[name] === 'function') this.instances[name] = $fa349a7677bf25be$export$a7d9bc765837b75c[name](this);
                else if (0, $d15fb30d84867e0d$export$a866f231438cc228) console.log('Cannot get service, No creator for: ' + name);
            }
            return this.instances[name];
        } else if (Array.isArray(name)) return name.map(function(n) {
            return _this.getService(n);
        });
    };
    return ServiceFactory;
}();


function $d2418efc491b1dd5$export$174fd5f90dd8a5db() {
    (0, $fa349a7677bf25be$export$a7d9bc765837b75c)[0, $c898cf419eb79f2e$export$3bb4e88cf5c5fd65] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37),
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
            (0, $c898cf419eb79f2e$export$ab6389d1a16bebfe)
        ]), apmServer = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1], transactionService = _serviceFactory$getSe[2];
        return new (0, $8424b0768b92f162$export$2e2bcd8739ae039)(apmServer, configService, transactionService);
    };
}








var $0a6e736d8176e915$var$SpanBase = function() {
    function SpanBase(name, type, options) {
        if (options === void 0) options = {};
        if (!name) name = (0, $c898cf419eb79f2e$export$f0eae82cd3ba085f);
        if (!type) type = (0, $c898cf419eb79f2e$export$dd0e4c11f1ad6f76);
        this.name = name;
        this.type = type;
        this.options = options;
        this.id = options.id || (0, $81ba5eca3c0826ee$export$59b2544ec352d56)(16);
        this.traceId = options.traceId;
        this.sampled = options.sampled;
        this.sampleRate = options.sampleRate;
        this.timestamp = options.timestamp;
        this._start = (0, $81ba5eca3c0826ee$export$1428f42a7de81803)(options.startTime);
        this._end = undefined;
        this.ended = false;
        this.outcome = undefined;
        this.onEnd = options.onEnd;
    }
    var _proto = SpanBase.prototype;
    _proto.ensureContext = function ensureContext() {
        if (!this.context) this.context = {};
    };
    _proto.addLabels = function addLabels(tags) {
        this.ensureContext();
        var ctx = this.context;
        if (!ctx.tags) ctx.tags = {};
        var keys = Object.keys(tags);
        keys.forEach(function(k) {
            return (0, $81ba5eca3c0826ee$export$4f65e594f6031297)(k, tags[k], ctx.tags);
        });
    };
    _proto.addContext = function addContext() {
        for(var _len = arguments.length, context = new Array(_len), _key = 0; _key < _len; _key++)context[_key] = arguments[_key];
        if (context.length === 0) return;
        this.ensureContext();
        this.context = (0, $81ba5eca3c0826ee$export$4950aa0f605343fb).apply(void 0, [
            this.context
        ].concat(context));
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $81ba5eca3c0826ee$export$1428f42a7de81803)(endTime);
        this.callOnEnd();
    };
    _proto.callOnEnd = function callOnEnd() {
        if (typeof this.onEnd === 'function') this.onEnd(this);
    };
    _proto.duration = function duration() {
        return (0, $81ba5eca3c0826ee$export$75bba95db5c3e753)(this._start, this._end);
    };
    return SpanBase;
}();
var $0a6e736d8176e915$export$2e2bcd8739ae039 = $0a6e736d8176e915$var$SpanBase;



function $3b8cd0270f37e3ff$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $3b8cd0270f37e3ff$var$_setPrototypeOf(t, o);
}
function $3b8cd0270f37e3ff$var$_setPrototypeOf(t, e) {
    return $3b8cd0270f37e3ff$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3b8cd0270f37e3ff$var$_setPrototypeOf(t, e);
}
var $3b8cd0270f37e3ff$var$Span = function(_SpanBase) {
    function Span(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.parentId = _this.options.parentId;
        _this.subtype = undefined;
        _this.action = undefined;
        if (_this.type.indexOf('.') !== -1) {
            var fields = _this.type.split('.', 3);
            _this.type = fields[0];
            _this.subtype = fields[1];
            _this.action = fields[2];
        }
        _this.sync = _this.options.sync;
        return _this;
    }
    $3b8cd0270f37e3ff$var$_inheritsLoose(Span, _SpanBase);
    var _proto = Span.prototype;
    _proto.end = function end(endTime, data) {
        _SpanBase.prototype.end.call(this, endTime);
        (0, $2c87e6d217c9f6e4$export$ed109afa225aed5b)(this, data);
    };
    return Span;
}((0, $0a6e736d8176e915$export$2e2bcd8739ae039));
var $3b8cd0270f37e3ff$export$2e2bcd8739ae039 = $3b8cd0270f37e3ff$var$Span;


function $a3f071508e72d542$var$_extends() {
    return $a3f071508e72d542$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3f071508e72d542$var$_extends.apply(null, arguments);
}
var $a3f071508e72d542$export$b0c5c2fac8144e54 = {
    fid: 0,
    fcp: 0,
    tbt: {
        start: Infinity,
        duration: 0
    },
    cls: {
        score: 0,
        firstEntryTime: Number.NEGATIVE_INFINITY,
        prevEntryTime: Number.NEGATIVE_INFINITY,
        currentSessionScore: 0
    },
    longtask: {
        count: 0,
        duration: 0,
        max: 0
    }
};
var $a3f071508e72d542$var$LONG_TASK_THRESHOLD = 50;
function $a3f071508e72d542$export$2bed7abe701121db(longtasks, agg) {
    var spans = [];
    for(var i = 0; i < longtasks.length; i++){
        var _longtasks$i = longtasks[i], name = _longtasks$i.name, startTime = _longtasks$i.startTime, duration = _longtasks$i.duration, attribution = _longtasks$i.attribution;
        var end = startTime + duration;
        var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)("Longtask(" + name + ")", (0, $c898cf419eb79f2e$export$fd2c36a5e8e50e04), {
            startTime: startTime
        });
        agg.count++;
        agg.duration += duration;
        agg.max = Math.max(duration, agg.max);
        if (attribution.length > 0) {
            var _attribution$ = attribution[0], _name = _attribution$.name, containerType = _attribution$.containerType, containerName = _attribution$.containerName, containerId = _attribution$.containerId;
            var customContext = {
                attribution: _name,
                type: containerType
            };
            if (containerName) customContext.name = containerName;
            if (containerId) customContext.id = containerId;
            span.addContext({
                custom: customContext
            });
        }
        span.end(end);
        spans.push(span);
    }
    return spans;
}
function $a3f071508e72d542$export$dbb9abd64c7ad2de(fidEntries) {
    var firstInput = fidEntries[0];
    if (firstInput) {
        var startTime = firstInput.startTime, processingStart = firstInput.processingStart;
        var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)('First Input Delay', (0, $c898cf419eb79f2e$export$98085453dd812392), {
            startTime: startTime
        });
        span.end(processingStart);
        return span;
    }
}
function $a3f071508e72d542$export$4f167c0032dd3716(tbtObject) {
    var start = tbtObject.start, duration = tbtObject.duration;
    var tbtSpan = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)('Total Blocking Time', (0, $c898cf419eb79f2e$export$fd2c36a5e8e50e04), {
        startTime: start
    });
    tbtSpan.end(start + duration);
    return tbtSpan;
}
function $a3f071508e72d542$export$cdc3b71aeb75f979(longtaskEntries) {
    longtaskEntries.forEach(function(entry) {
        var name = entry.name, startTime = entry.startTime, duration = entry.duration;
        if (startTime < $a3f071508e72d542$export$b0c5c2fac8144e54.fcp) return;
        if (name !== 'self' && name.indexOf('same-origin') === -1) return;
        $a3f071508e72d542$export$b0c5c2fac8144e54.tbt.start = Math.min($a3f071508e72d542$export$b0c5c2fac8144e54.tbt.start, startTime);
        var blockingTime = duration - $a3f071508e72d542$var$LONG_TASK_THRESHOLD;
        if (blockingTime > 0) $a3f071508e72d542$export$b0c5c2fac8144e54.tbt.duration += blockingTime;
    });
}
function $a3f071508e72d542$export$1ee9edc2f05fc2c0(clsEntries) {
    clsEntries.forEach(function(entry) {
        if (!entry.hadRecentInput && entry.value) {
            var shouldCreateNewSession = entry.startTime - $a3f071508e72d542$export$b0c5c2fac8144e54.cls.firstEntryTime > 5000 || entry.startTime - $a3f071508e72d542$export$b0c5c2fac8144e54.cls.prevEntryTime > 1000;
            if (shouldCreateNewSession) {
                $a3f071508e72d542$export$b0c5c2fac8144e54.cls.firstEntryTime = entry.startTime;
                $a3f071508e72d542$export$b0c5c2fac8144e54.cls.currentSessionScore = 0;
            }
            $a3f071508e72d542$export$b0c5c2fac8144e54.cls.prevEntryTime = entry.startTime;
            $a3f071508e72d542$export$b0c5c2fac8144e54.cls.currentSessionScore += entry.value;
            $a3f071508e72d542$export$b0c5c2fac8144e54.cls.score = Math.max($a3f071508e72d542$export$b0c5c2fac8144e54.cls.score, $a3f071508e72d542$export$b0c5c2fac8144e54.cls.currentSessionScore);
        }
    });
}
function $a3f071508e72d542$export$9042c3a3f5ee2ee(list, _ref) {
    var isHardNavigation = _ref.isHardNavigation, trStart = _ref.trStart;
    var longtaskEntries = list.getEntriesByType((0, $c898cf419eb79f2e$export$fd2c36a5e8e50e04)).filter(function(entry) {
        return entry.startTime >= trStart;
    });
    var longTaskSpans = $a3f071508e72d542$export$2bed7abe701121db(longtaskEntries, $a3f071508e72d542$export$b0c5c2fac8144e54.longtask);
    var result = {
        spans: longTaskSpans,
        marks: {}
    };
    if (!isHardNavigation) return result;
    var lcpEntries = list.getEntriesByType((0, $c898cf419eb79f2e$export$6de1676190bd73c4));
    var lastLcpEntry = lcpEntries[lcpEntries.length - 1];
    if (lastLcpEntry) {
        var lcp = parseInt(lastLcpEntry.startTime);
        $a3f071508e72d542$export$b0c5c2fac8144e54.lcp = lcp;
        result.marks.largestContentfulPaint = lcp;
    }
    var timing = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).timing;
    var unloadDiff = timing.fetchStart - timing.navigationStart;
    if ((0, $81ba5eca3c0826ee$export$ffcb82e8b0e258ec)(timing)) unloadDiff = 0;
    var fcpEntry = list.getEntriesByName((0, $c898cf419eb79f2e$export$c2572a516b804ad3))[0];
    if (fcpEntry) {
        var fcp = parseInt(unloadDiff >= 0 ? fcpEntry.startTime - unloadDiff : fcpEntry.startTime);
        $a3f071508e72d542$export$b0c5c2fac8144e54.fcp = fcp;
        result.marks.firstContentfulPaint = fcp;
    }
    var fidEntries = list.getEntriesByType((0, $c898cf419eb79f2e$export$98085453dd812392));
    var fidSpan = $a3f071508e72d542$export$dbb9abd64c7ad2de(fidEntries);
    if (fidSpan) {
        $a3f071508e72d542$export$b0c5c2fac8144e54.fid = fidSpan.duration();
        result.spans.push(fidSpan);
    }
    $a3f071508e72d542$export$cdc3b71aeb75f979(longtaskEntries);
    var clsEntries = list.getEntriesByType((0, $c898cf419eb79f2e$export$fc5ce9a4261f08e8));
    $a3f071508e72d542$export$1ee9edc2f05fc2c0(clsEntries);
    return result;
}
var $a3f071508e72d542$export$e105e1823c980668 = function() {
    function PerfEntryRecorder(callback) {
        this.po = {
            observe: (0, $81ba5eca3c0826ee$export$8793edee2d425525),
            disconnect: (0, $81ba5eca3c0826ee$export$8793edee2d425525)
        };
        if (window.PerformanceObserver) this.po = new PerformanceObserver(callback);
    }
    var _proto = PerfEntryRecorder.prototype;
    _proto.start = function start(type, options) {
        if (options === void 0) options = {
            buffered: true
        };
        try {
            if (!(0, $81ba5eca3c0826ee$export$c043ff66aa95c00c)(type)) return;
            this.po.observe($a3f071508e72d542$var$_extends({
                type: type
            }, options));
        } catch (_) {}
    };
    _proto.stop = function stop() {
        this.po.disconnect();
    };
    return PerfEntryRecorder;
}();


var $ba6dda3f504fe70c$var$INP_THRESHOLD = 40;
var $ba6dda3f504fe70c$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
var $ba6dda3f504fe70c$export$ce4caaf0f98f57c6 = {
    minInteractionId: Infinity,
    maxInteractionId: 0,
    interactionCount: 0,
    longestInteractions: []
};
function $ba6dda3f504fe70c$export$57066f288181694e(recorder) {
    if (recorder === void 0) recorder = new (0, $a3f071508e72d542$export$e105e1823c980668)($ba6dda3f504fe70c$export$c902b4a33027abbf);
    var isPerfCountSupported = (0, $81ba5eca3c0826ee$export$759b2c522265ced)();
    var durationThreshold = isPerfCountSupported ? $ba6dda3f504fe70c$var$INP_THRESHOLD : 16;
    recorder.start((0, $c898cf419eb79f2e$export$e39a34cfd532e15), {
        buffered: true,
        durationThreshold: durationThreshold
    });
    if (!isPerfCountSupported) recorder.start((0, $c898cf419eb79f2e$export$98085453dd812392));
}
function $ba6dda3f504fe70c$export$c902b4a33027abbf(list) {
    var entries = list.getEntries();
    entries.forEach(function(entry) {
        if (!entry.interactionId) return;
        $ba6dda3f504fe70c$var$updateInteractionCount(entry);
        if (entry.duration < $ba6dda3f504fe70c$var$INP_THRESHOLD) return;
        $ba6dda3f504fe70c$var$storeUserInteraction(entry);
    });
}
function $ba6dda3f504fe70c$export$5ec729e92b081a59() {
    if ($ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.length === 0) {
        if ($ba6dda3f504fe70c$export$434fd613d1a3899c() > 0) return 0;
        return;
    }
    var interactionIndex = Math.min($ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.length - 1, Math.floor($ba6dda3f504fe70c$export$434fd613d1a3899c() / 50));
    var inp = $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions[interactionIndex].duration;
    return inp;
}
function $ba6dda3f504fe70c$export$434fd613d1a3899c() {
    return performance.interactionCount || $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.interactionCount;
}
function $ba6dda3f504fe70c$export$8101508a6abf9c5c() {
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.minInteractionId = Infinity;
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.maxInteractionId = 0;
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.interactionCount = 0;
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions = [];
}
function $ba6dda3f504fe70c$var$storeUserInteraction(entry) {
    var leastSlow = $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions[$ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.length - 1];
    if (typeof leastSlow !== 'undefined' && entry.duration <= leastSlow.duration && entry.interactionId != leastSlow.id) return;
    var filteredInteraction = $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.filter(function(interaction) {
        return interaction.id === entry.interactionId;
    });
    if (filteredInteraction.length > 0) {
        var foundInteraction = filteredInteraction[0];
        foundInteraction.duration = Math.max(foundInteraction.duration, entry.duration);
    } else $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.push({
        id: entry.interactionId,
        duration: entry.duration
    });
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.sort(function(a, b) {
        return b.duration - a.duration;
    });
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.longestInteractions.splice($ba6dda3f504fe70c$var$MAX_INTERACTIONS_TO_CONSIDER);
}
function $ba6dda3f504fe70c$var$updateInteractionCount(entry) {
    if ((0, $81ba5eca3c0826ee$export$759b2c522265ced)()) return;
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.minInteractionId = Math.min($ba6dda3f504fe70c$export$ce4caaf0f98f57c6.minInteractionId, entry.interactionId);
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.maxInteractionId = Math.max($ba6dda3f504fe70c$export$ce4caaf0f98f57c6.maxInteractionId, entry.interactionId);
    $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.interactionCount = ($ba6dda3f504fe70c$export$ce4caaf0f98f57c6.maxInteractionId - $ba6dda3f504fe70c$export$ce4caaf0f98f57c6.minInteractionId) / 7 + 1;
}








var $f1769ffce293c033$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO = 0.05;
var $f1769ffce293c033$var$TRANSACTION_DURATION_THRESHOLD = 60000;
function $f1769ffce293c033$export$82a182639eda9ace(originalSpans, transDuration, threshold) {
    originalSpans.sort(function(spanA, spanB) {
        return spanA._start - spanB._start;
    });
    var spans = [];
    var lastCount = 1;
    originalSpans.forEach(function(span, index) {
        if (spans.length === 0) spans.push(span);
        else {
            var lastSpan = spans[spans.length - 1];
            var isContinuouslySimilar = lastSpan.type === span.type && lastSpan.subtype === span.subtype && lastSpan.action === span.action && lastSpan.name === span.name && span.duration() / transDuration < threshold && (span._start - lastSpan._end) / transDuration < threshold;
            var isLastSpan = originalSpans.length === index + 1;
            if (isContinuouslySimilar) {
                lastCount++;
                lastSpan._end = span._end;
            }
            if (lastCount > 1 && (!isContinuouslySimilar || isLastSpan)) {
                lastSpan.name = lastCount + 'x ' + lastSpan.name;
                lastCount = 1;
            }
            if (!isContinuouslySimilar) spans.push(span);
        }
    });
    return spans;
}
function $f1769ffce293c033$export$e5fabcf37bedf526(transaction) {
    if (transaction.sampled) {
        var filterdSpans = transaction.spans.filter(function(span) {
            return span.duration() > 0 && span._start >= transaction._start && span._end <= transaction._end;
        });
        if (transaction.isManaged()) {
            var duration = transaction.duration();
            var similarSpans = $f1769ffce293c033$export$82a182639eda9ace(filterdSpans, duration, $f1769ffce293c033$var$SIMILAR_SPAN_TO_TRANSACTION_RATIO);
            transaction.spans = similarSpans;
        } else transaction.spans = filterdSpans;
    } else transaction.resetFields();
    return transaction;
}
var $f1769ffce293c033$export$2e2bcd8739ae039 = function() {
    function PerformanceMonitoring(apmServer, configService, loggingService, transactionService) {
        this._apmServer = apmServer;
        this._configService = configService;
        this._logginService = loggingService;
        this._transactionService = transactionService;
    }
    var _proto = PerformanceMonitoring.prototype;
    _proto.init = function init(flags) {
        var _this = this;
        if (flags === void 0) flags = {};
        this._configService.events.observe((0, $c898cf419eb79f2e$export$3583e51eacab0340) + (0, $c898cf419eb79f2e$export$eeaba87877acb280), function(tr) {
            var payload = _this.createTransactionPayload(tr);
            if (payload) {
                _this._apmServer.addTransaction(payload);
                _this._configService.dispatchEvent((0, $c898cf419eb79f2e$export$c11a56b9bfcb1d0f));
            }
        });
        if (flags[0, $c898cf419eb79f2e$export$149eb684a26496a2]) (0, $436e4e100da18924$export$602cc6306ec009d8).observe((0, $c898cf419eb79f2e$export$149eb684a26496a2), this.getHistorySub());
        if (flags[0, $c898cf419eb79f2e$export$942b1c2707517311]) (0, $436e4e100da18924$export$602cc6306ec009d8).observe((0, $c898cf419eb79f2e$export$942b1c2707517311), this.getXHRSub());
        if (flags[0, $c898cf419eb79f2e$export$4a07cffb9c3bc884]) (0, $436e4e100da18924$export$602cc6306ec009d8).observe((0, $c898cf419eb79f2e$export$4a07cffb9c3bc884), this.getFetchSub());
    };
    _proto.getHistorySub = function getHistorySub() {
        var transactionService = this._transactionService;
        return function(event, task) {
            if (task.source === (0, $c898cf419eb79f2e$export$149eb684a26496a2) && event === (0, $c898cf419eb79f2e$export$156c69d71663cf9e)) transactionService.startTransaction(task.data.title, 'route-change', {
                managed: true,
                canReuse: true
            });
        };
    };
    _proto.getXHRSub = function getXHRSub() {
        var _this2 = this;
        return function(event, task) {
            if (task.source === (0, $c898cf419eb79f2e$export$942b1c2707517311) && !(0, $9c916c6998c5246b$export$8e769ad4338a911e).fetchInProgress) _this2.processAPICalls(event, task);
        };
    };
    _proto.getFetchSub = function getFetchSub() {
        var _this3 = this;
        return function(event, task) {
            if (task.source === (0, $c898cf419eb79f2e$export$4a07cffb9c3bc884)) _this3.processAPICalls(event, task);
        };
    };
    _proto.processAPICalls = function processAPICalls(event, task) {
        var configService = this._configService;
        var transactionService = this._transactionService;
        if (task.data && task.data.url) {
            var endpoints = this._apmServer.getEndpoints();
            var isOwnEndpoint = Object.keys(endpoints).some(function(endpoint) {
                return task.data.url.indexOf(endpoints[endpoint]) !== -1;
            });
            if (isOwnEndpoint) return;
        }
        if (event === (0, $c898cf419eb79f2e$export$2cb68534ade458e0) && task.data) {
            var data = task.data;
            var requestUrl = new (0, $5988178a6f0b5e35$export$59d795186a5d3f58)(data.url);
            var spanName = data.method + ' ' + (requestUrl.relative ? requestUrl.path : (0, $81ba5eca3c0826ee$export$b3289ee923920b2a)(requestUrl.href));
            if (!transactionService.getCurrentTransaction()) transactionService.startTransaction(spanName, (0, $c898cf419eb79f2e$export$c774c31b4c31da8), {
                managed: true
            });
            var span = transactionService.startSpan(spanName, 'external.http', {
                blocking: true
            });
            if (!span) return;
            var isDtEnabled = configService.get('distributedTracing');
            var dtOrigins = configService.get('distributedTracingOrigins');
            var currentUrl = new (0, $5988178a6f0b5e35$export$59d795186a5d3f58)(window.location.href);
            var isSameOrigin = (0, $81ba5eca3c0826ee$export$8731073ee4364c34)(requestUrl.origin, currentUrl.origin) || (0, $81ba5eca3c0826ee$export$8731073ee4364c34)(requestUrl.origin, dtOrigins);
            var target = data.target;
            if (isDtEnabled && isSameOrigin && target) {
                this.injectDtHeader(span, target);
                var propagateTracestate = configService.get('propagateTracestate');
                if (propagateTracestate) this.injectTSHeader(span, target);
            } else if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logginService.debug("Could not inject distributed tracing header to the request origin ('" + requestUrl.origin + "') from the current origin ('" + currentUrl.origin + "')");
            if (data.sync) span.sync = data.sync;
            data.span = span;
        } else if (event === (0, $c898cf419eb79f2e$export$156c69d71663cf9e)) {
            var _data = task.data;
            if (_data && _data.span) {
                var _span = _data.span, response = _data.response, _target = _data.target;
                var status;
                if (response) status = response.status;
                else status = _target.status;
                var outcome;
                if (_data.status != 'abort' && !_data.aborted) {
                    if (status >= 400 || status == 0) outcome = (0, $c898cf419eb79f2e$export$a1656598af524751);
                    else outcome = (0, $c898cf419eb79f2e$export$ffae20858202e0de);
                } else outcome = (0, $c898cf419eb79f2e$export$f46af96a885f2c9b);
                _span.outcome = outcome;
                var tr = transactionService.getCurrentTransaction();
                if (tr && tr.type === (0, $c898cf419eb79f2e$export$c774c31b4c31da8)) tr.outcome = outcome;
                transactionService.endSpan(_span, _data);
            }
        }
    };
    _proto.injectDtHeader = function injectDtHeader(span, target) {
        var headerName = this._configService.get('distributedTracingHeaderName');
        var headerValue = (0, $81ba5eca3c0826ee$export$312052e2a8d615c6)(span);
        var isHeaderValid = (0, $81ba5eca3c0826ee$export$a6f4cb80c241b86f)(headerValue);
        if (isHeaderValid && headerValue && headerName) (0, $81ba5eca3c0826ee$export$4a0dedceb084213c)(target, headerName, headerValue);
    };
    _proto.injectTSHeader = function injectTSHeader(span, target) {
        var headerValue = (0, $81ba5eca3c0826ee$export$6fbffd43bfec7ed8)(span);
        if (headerValue) (0, $81ba5eca3c0826ee$export$4a0dedceb084213c)(target, 'tracestate', headerValue);
    };
    _proto.extractDtHeader = function extractDtHeader(target) {
        var configService = this._configService;
        var headerName = configService.get('distributedTracingHeaderName');
        if (target) return (0, $81ba5eca3c0826ee$export$86a08f9fd706a6b8)(target[headerName]);
    };
    _proto.filterTransaction = function filterTransaction(tr) {
        var duration = tr.duration();
        if (!duration) {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) {
                var message = "transaction(" + tr.id + ", " + tr.name + ") was discarded! ";
                if (duration === 0) message += "Transaction duration is 0";
                else message += "Transaction wasn't ended";
                this._logginService.debug(message);
            }
            return false;
        }
        if (tr.isManaged()) {
            if (duration > $f1769ffce293c033$var$TRANSACTION_DURATION_THRESHOLD) {
                if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction duration (" + duration + ") is greater than managed transaction threshold (" + $f1769ffce293c033$var$TRANSACTION_DURATION_THRESHOLD + ")");
                return false;
            }
            var recordEmpty = this._configService.get('reportTransactionsWithoutSpans');
            if (tr.sampled && tr.spans.length === 0 && !recordEmpty) {
                if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logginService.debug("transaction(" + tr.id + ", " + tr.name + ") was discarded! Transaction does not have any spans");
                return false;
            }
        }
        return true;
    };
    _proto.createTransactionDataModel = function createTransactionDataModel(transaction) {
        var transactionStart = transaction._start;
        var spans = transaction.spans.map(function(span) {
            var spanData = {
                id: span.id,
                transaction_id: transaction.id,
                parent_id: span.parentId || transaction.id,
                trace_id: transaction.traceId,
                name: span.name,
                type: span.type,
                subtype: span.subtype,
                action: span.action,
                sync: span.sync,
                start: parseInt(span._start - transactionStart),
                duration: span.duration(),
                context: span.context,
                outcome: span.outcome,
                sample_rate: span.sampleRate
            };
            return (0, $f7503fddfe9be557$export$488247de36c98c6b)((0, $f7503fddfe9be557$export$41c959b800170f79), spanData);
        });
        var transactionData = {
            id: transaction.id,
            parent_id: transaction.parentId,
            trace_id: transaction.traceId,
            session: transaction.session,
            name: transaction.name,
            type: transaction.type,
            duration: transaction.duration(),
            spans: spans,
            context: transaction.context,
            marks: transaction.marks,
            breakdown: transaction.breakdownTimings,
            span_count: {
                started: spans.length
            },
            sampled: transaction.sampled,
            sample_rate: transaction.sampleRate,
            experience: transaction.experience,
            outcome: transaction.outcome
        };
        return (0, $f7503fddfe9be557$export$488247de36c98c6b)((0, $f7503fddfe9be557$export$d887b343e3ec3a69), transactionData);
    };
    _proto.createTransactionPayload = function createTransactionPayload(transaction) {
        var adjustedTransaction = $f1769ffce293c033$export$e5fabcf37bedf526(transaction);
        var filtered = this.filterTransaction(adjustedTransaction);
        if (filtered) return this.createTransactionDataModel(transaction);
        this._configService.dispatchEvent((0, $c898cf419eb79f2e$export$543fdf328f404af7));
    };
    return PerformanceMonitoring;
}();









var $73b9eb46cadd4f25$var$pageLoadBreakdowns = [
    [
        'domainLookupStart',
        'domainLookupEnd',
        'DNS'
    ],
    [
        'connectStart',
        'connectEnd',
        'TCP'
    ],
    [
        'requestStart',
        'responseStart',
        'Request'
    ],
    [
        'responseStart',
        'responseEnd',
        'Response'
    ],
    [
        'domLoading',
        'domComplete',
        'Processing'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Load'
    ]
];
function $73b9eb46cadd4f25$var$getValue(value) {
    return {
        value: value
    };
}
function $73b9eb46cadd4f25$var$calculateSelfTime(transaction) {
    var spans = transaction.spans, _start = transaction._start, _end = transaction._end;
    if (spans.length === 0) return transaction.duration();
    spans.sort(function(span1, span2) {
        return span1._start - span2._start;
    });
    var span = spans[0];
    var spanEnd = span._end;
    var spanStart = span._start;
    var lastContinuousEnd = spanEnd;
    var selfTime = spanStart - _start;
    for(var i = 1; i < spans.length; i++){
        span = spans[i];
        spanStart = span._start;
        spanEnd = span._end;
        if (spanStart > lastContinuousEnd) {
            selfTime += spanStart - lastContinuousEnd;
            lastContinuousEnd = spanEnd;
        } else if (spanEnd > lastContinuousEnd) lastContinuousEnd = spanEnd;
    }
    if (lastContinuousEnd < _end) selfTime += _end - lastContinuousEnd;
    return selfTime;
}
function $73b9eb46cadd4f25$var$groupSpans(transaction) {
    var spanMap = {};
    var transactionSelfTime = $73b9eb46cadd4f25$var$calculateSelfTime(transaction);
    spanMap['app'] = {
        count: 1,
        duration: transactionSelfTime
    };
    var spans = transaction.spans;
    for(var i = 0; i < spans.length; i++){
        var span = spans[i];
        var duration = span.duration();
        if (duration === 0 || duration == null) continue;
        var type = span.type, subtype = span.subtype;
        var key = type.replace((0, $c898cf419eb79f2e$export$58a4ef0ce68953f5), '');
        if (subtype) key += '.' + subtype;
        if (!spanMap[key]) spanMap[key] = {
            duration: 0,
            count: 0
        };
        spanMap[key].count++;
        spanMap[key].duration += duration;
    }
    return spanMap;
}
function $73b9eb46cadd4f25$var$getSpanBreakdown(transactionDetails, _ref) {
    var details = _ref.details, _ref$count = _ref.count, count = _ref$count === void 0 ? 1 : _ref$count, duration = _ref.duration;
    return {
        transaction: transactionDetails,
        span: details,
        samples: {
            'span.self_time.count': $73b9eb46cadd4f25$var$getValue(count),
            'span.self_time.sum.us': $73b9eb46cadd4f25$var$getValue(duration * 1000)
        }
    };
}
function $73b9eb46cadd4f25$export$f29e26af65381f57(transaction, timings) {
    if (timings === void 0) timings = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).timing;
    var breakdowns = [];
    var name = transaction.name, type = transaction.type, sampled = transaction.sampled;
    var transactionDetails = {
        name: name,
        type: type
    };
    if (!sampled) return breakdowns;
    if (type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539) && timings) for(var i = 0; i < $73b9eb46cadd4f25$var$pageLoadBreakdowns.length; i++){
        var current = $73b9eb46cadd4f25$var$pageLoadBreakdowns[i];
        var start = timings[current[0]];
        var end = timings[current[1]];
        var duration = (0, $81ba5eca3c0826ee$export$75bba95db5c3e753)(start, end);
        if (duration === 0 || duration == null) continue;
        breakdowns.push($73b9eb46cadd4f25$var$getSpanBreakdown(transactionDetails, {
            details: {
                type: current[2]
            },
            duration: duration
        }));
    }
    else {
        var spanMap = $73b9eb46cadd4f25$var$groupSpans(transaction);
        Object.keys(spanMap).forEach(function(key) {
            var _key$split = key.split('.'), type = _key$split[0], subtype = _key$split[1];
            var _spanMap$key = spanMap[key], duration = _spanMap$key.duration, count = _spanMap$key.count;
            breakdowns.push($73b9eb46cadd4f25$var$getSpanBreakdown(transactionDetails, {
                details: {
                    type: type,
                    subtype: subtype
                },
                duration: duration,
                count: count
            }));
        });
    }
    return breakdowns;
}


function $9ed84b7409876a52$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $9ed84b7409876a52$var$_setPrototypeOf(t, o);
}
function $9ed84b7409876a52$var$_setPrototypeOf(t, e) {
    return $9ed84b7409876a52$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9ed84b7409876a52$var$_setPrototypeOf(t, e);
}
var $9ed84b7409876a52$var$Transaction = function(_SpanBase) {
    function Transaction(name, type, options) {
        var _this;
        _this = _SpanBase.call(this, name, type, options) || this;
        _this.traceId = (0, $81ba5eca3c0826ee$export$59b2544ec352d56)();
        _this.marks = undefined;
        _this.spans = [];
        _this._activeSpans = {};
        _this._activeTasks = new Set();
        _this.blocked = false;
        _this.captureTimings = false;
        _this.breakdownTimings = [];
        _this.sampleRate = _this.options.transactionSampleRate;
        _this.sampled = Math.random() <= _this.sampleRate;
        return _this;
    }
    $9ed84b7409876a52$var$_inheritsLoose(Transaction, _SpanBase);
    var _proto = Transaction.prototype;
    _proto.addMarks = function addMarks(obj) {
        this.marks = (0, $81ba5eca3c0826ee$export$4950aa0f605343fb)(this.marks || {}, obj);
    };
    _proto.mark = function mark(key) {
        var skey = (0, $81ba5eca3c0826ee$export$fbffb0ac2c2ec159)(key);
        var markTime = (0, $81ba5eca3c0826ee$export$461939dd4422153)() - this._start;
        var custom = {};
        custom[skey] = markTime;
        this.addMarks({
            custom: custom
        });
    };
    _proto.canReuse = function canReuse() {
        var threshold = this.options.reuseThreshold || (0, $c898cf419eb79f2e$export$1307ffda4f2726e8);
        return !!this.options.canReuse && !this.ended && (0, $81ba5eca3c0826ee$export$461939dd4422153)() - this._start < threshold;
    };
    _proto.redefine = function redefine(name, type, options) {
        if (name) this.name = name;
        if (type) this.type = type;
        if (options) {
            this.options.reuseThreshold = options.reuseThreshold;
            this.options = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)(this.options, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var _this2 = this;
        if (this.ended) return;
        var opts = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)({}, options);
        opts.onEnd = function(trc) {
            _this2._onSpanEnd(trc);
        };
        opts.traceId = this.traceId;
        opts.sampled = this.sampled;
        opts.sampleRate = this.sampleRate;
        if (!opts.parentId) opts.parentId = this.id;
        var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)(name, type, opts);
        this._activeSpans[span.id] = span;
        if (opts.blocking) this.addTask(span.id);
        return span;
    };
    _proto.isFinished = function isFinished() {
        return !this.blocked && this._activeTasks.size === 0;
    };
    _proto.detectFinish = function detectFinish() {
        if (this.isFinished()) this.end();
    };
    _proto.end = function end(endTime) {
        if (this.ended) return;
        this.ended = true;
        this._end = (0, $81ba5eca3c0826ee$export$1428f42a7de81803)(endTime);
        for(var sid in this._activeSpans){
            var span = this._activeSpans[sid];
            span.type = span.type + (0, $c898cf419eb79f2e$export$58a4ef0ce68953f5);
            span.end(endTime);
        }
        this.callOnEnd();
    };
    _proto.captureBreakdown = function captureBreakdown() {
        this.breakdownTimings = (0, $73b9eb46cadd4f25$export$f29e26af65381f57)(this);
    };
    _proto.block = function block(flag) {
        this.blocked = flag;
        if (!this.blocked) this.detectFinish();
    };
    _proto.addTask = function addTask(taskId) {
        if (!taskId) taskId = 'task-' + (0, $81ba5eca3c0826ee$export$59b2544ec352d56)(16);
        this._activeTasks.add(taskId);
        return taskId;
    };
    _proto.removeTask = function removeTask(taskId) {
        var deleted = this._activeTasks.delete(taskId);
        deleted && this.detectFinish();
    };
    _proto.resetFields = function resetFields() {
        this.spans = [];
        this.sampleRate = 0;
    };
    _proto._onSpanEnd = function _onSpanEnd(span) {
        this.spans.push(span);
        delete this._activeSpans[span.id];
        this.removeTask(span.id);
    };
    _proto.isManaged = function isManaged() {
        return !!this.options.managed;
    };
    return Transaction;
}((0, $0a6e736d8176e915$export$2e2bcd8739ae039));
var $9ed84b7409876a52$export$2e2bcd8739ae039 = $9ed84b7409876a52$var$Transaction;








function $98ef97d83c893bc1$export$ee8bd369faf2c186(start, end, trStart, trEnd, baseTime) {
    if (baseTime === void 0) baseTime = 0;
    return typeof start === 'number' && typeof end === 'number' && start >= baseTime && end > start && start - baseTime >= trStart && end - baseTime <= trEnd && end - start < (0, $c898cf419eb79f2e$export$92d7cb2c71942fbd) && start - baseTime < (0, $c898cf419eb79f2e$export$92d7cb2c71942fbd) && end - baseTime < (0, $c898cf419eb79f2e$export$92d7cb2c71942fbd);
}



var $cc6713694adfc93b$var$eventPairs = [
    [
        'redirectStart',
        'redirectEnd',
        'Redirect'
    ],
    [
        'domainLookupStart',
        'domainLookupEnd',
        'Domain lookup'
    ],
    [
        'connectStart',
        'connectEnd',
        'Making a connection to the server'
    ],
    [
        'requestStart',
        'responseEnd',
        'Requesting and receiving the document'
    ],
    [
        'domLoading',
        'domInteractive',
        'Parsing the document, executing sync. scripts'
    ],
    [
        'domContentLoadedEventStart',
        'domContentLoadedEventEnd',
        'Fire "DOMContentLoaded" event'
    ],
    [
        'loadEventStart',
        'loadEventEnd',
        'Fire "load" event'
    ]
];
function $cc6713694adfc93b$export$3f88cb87ead13585(timings, baseTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < $cc6713694adfc93b$var$eventPairs.length; i++){
        var start = timings[$cc6713694adfc93b$var$eventPairs[i][0]];
        var end = timings[$cc6713694adfc93b$var$eventPairs[i][1]];
        if (!(0, $98ef97d83c893bc1$export$ee8bd369faf2c186)(start, end, trStart, trEnd, baseTime)) continue;
        var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)($cc6713694adfc93b$var$eventPairs[i][2], 'hard-navigation.browser-timing');
        var data = null;
        if ($cc6713694adfc93b$var$eventPairs[i][0] === 'requestStart') {
            span.pageResponse = true;
            data = {
                url: location.origin
            };
        }
        span._start = start - baseTime;
        span.end(end - baseTime, data);
        spans.push(span);
    }
    return spans;
}





function $5effce94acb72a60$export$d31d86bf4b796a11(entries, trStart, trEnd) {
    var userTimingSpans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], name = _entries$i.name, startTime = _entries$i.startTime, duration = _entries$i.duration;
        var end = startTime + duration;
        if (duration <= (0, $c898cf419eb79f2e$export$833fd3a4a36bef5e) || !(0, $98ef97d83c893bc1$export$ee8bd369faf2c186)(startTime, end, trStart, trEnd)) continue;
        var kind = 'app';
        var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)(name, kind);
        span._start = startTime;
        span.end(end);
        userTimingSpans.push(span);
    }
    return userTimingSpans;
}






function $0ede1e8dc25f4388$var$createResourceTimingSpan(resourceTimingEntry) {
    var name = resourceTimingEntry.name, initiatorType = resourceTimingEntry.initiatorType, startTime = resourceTimingEntry.startTime, responseEnd = resourceTimingEntry.responseEnd;
    var kind = 'resource';
    if (initiatorType) kind += '.' + initiatorType;
    var spanName = (0, $81ba5eca3c0826ee$export$b3289ee923920b2a)(name);
    var span = new (0, $3b8cd0270f37e3ff$export$2e2bcd8739ae039)(spanName, kind);
    span._start = startTime;
    span.end(responseEnd, {
        url: name,
        entry: resourceTimingEntry
    });
    return span;
}
function $0ede1e8dc25f4388$var$isCapturedByPatching(resourceStartTime, requestPatchTime) {
    return requestPatchTime != null && resourceStartTime > requestPatchTime;
}
function $0ede1e8dc25f4388$var$isIntakeAPIEndpoint(url) {
    return /intake\/v\d+\/rum\/events/.test(url);
}
function $0ede1e8dc25f4388$export$c7038f2b5602881b(entries, requestPatchTime, trStart, trEnd) {
    var spans = [];
    for(var i = 0; i < entries.length; i++){
        var _entries$i = entries[i], initiatorType = _entries$i.initiatorType, name = _entries$i.name, startTime = _entries$i.startTime, responseEnd = _entries$i.responseEnd;
        if ((0, $c898cf419eb79f2e$export$fcac77ffb8211a1f).indexOf(initiatorType) === -1 || name == null) continue;
        if ((initiatorType === 'xmlhttprequest' || initiatorType === 'fetch') && ($0ede1e8dc25f4388$var$isIntakeAPIEndpoint(name) || $0ede1e8dc25f4388$var$isCapturedByPatching(startTime, requestPatchTime))) continue;
        if ((0, $98ef97d83c893bc1$export$ee8bd369faf2c186)(startTime, responseEnd, trStart, trEnd)) spans.push($0ede1e8dc25f4388$var$createResourceTimingSpan(entries[i]));
    }
    return spans;
}



function $229f88190de43244$export$ffbf565d212a6a74(transaction) {
    if (!transaction.captureTimings) {
        if (transaction.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539)) transaction._start = 0;
        return;
    }
    var trEnd = transaction._end;
    if (transaction.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539)) {
        if (transaction.marks && transaction.marks.custom) {
            var customMarks = transaction.marks.custom;
            Object.keys(customMarks).forEach(function(key) {
                customMarks[key] += transaction._start;
            });
        }
        var trStart = 0;
        transaction._start = trStart;
        var timings = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).timing;
        var baseTime = (0, $81ba5eca3c0826ee$export$ffcb82e8b0e258ec)(timings) ? timings.redirectStart : timings.fetchStart;
        (0, $cc6713694adfc93b$export$3f88cb87ead13585)(timings, baseTime, trStart, trEnd).forEach(function(span) {
            span.traceId = transaction.traceId;
            span.sampled = transaction.sampled;
            if (span.pageResponse && transaction.options.pageLoadSpanId) span.id = transaction.options.pageLoadSpanId;
            transaction.spans.push(span);
        });
        if (transaction.options.pageLoadParentId) transaction.parentId = transaction.options.pageLoadParentId;
        transaction.addMarks((0, $8564c6c1fe599bf1$export$f010c0904d0d2983)(timings));
    }
    if ((0, $81ba5eca3c0826ee$export$475e1d086d647d28)()) {
        var _trStart = transaction._start;
        var resourceEntries = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).getEntriesByType((0, $c898cf419eb79f2e$export$84ba8fa7099b85b));
        (0, $0ede1e8dc25f4388$export$c7038f2b5602881b)(resourceEntries, (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).bootstrapTime, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
        var userEntries = (0, $81ba5eca3c0826ee$export$20dfe5c0db9ba10).getEntriesByType((0, $c898cf419eb79f2e$export$20471946a1148a1b));
        (0, $5effce94acb72a60$export$d31d86bf4b796a11)(userEntries, _trStart, trEnd).forEach(function(span) {
            return transaction.spans.push(span);
        });
    }
}






var $746cba9ae4997c02$var$TransactionService = function() {
    function TransactionService(logger, config) {
        var _this = this;
        this._config = config;
        this._logger = logger;
        this.currentTransaction = undefined;
        this.respIntervalId = undefined;
        this.recorder = new (0, $a3f071508e72d542$export$e105e1823c980668)(function(list) {
            var tr = _this.getCurrentTransaction();
            if (tr && tr.captureTimings) {
                var _tr$spans;
                var isHardNavigation = tr.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539);
                var _captureObserverEntri = (0, $a3f071508e72d542$export$9042c3a3f5ee2ee)(list, {
                    isHardNavigation: isHardNavigation,
                    trStart: isHardNavigation ? 0 : tr._start
                }), spans = _captureObserverEntri.spans, marks = _captureObserverEntri.marks;
                (_tr$spans = tr.spans).push.apply(_tr$spans, spans);
                tr.addMarks({
                    agent: marks
                });
            }
        });
    }
    var _proto = TransactionService.prototype;
    _proto.createCurrentTransaction = function createCurrentTransaction(name, type, options) {
        var tr = new (0, $9ed84b7409876a52$export$2e2bcd8739ae039)(name, type, options);
        this.currentTransaction = tr;
        return tr;
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.currentTransaction && !this.currentTransaction.ended) return this.currentTransaction;
    };
    _proto.createOptions = function createOptions(options) {
        var config = this._config.config;
        var presetOptions = {
            transactionSampleRate: config.transactionSampleRate
        };
        var perfOptions = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)(presetOptions, options);
        if (perfOptions.managed) perfOptions = (0, $81ba5eca3c0826ee$export$8b58be045bf06082)({
            pageLoadTraceId: config.pageLoadTraceId,
            pageLoadSampled: config.pageLoadSampled,
            pageLoadSpanId: config.pageLoadSpanId,
            pageLoadTransactionName: config.pageLoadTransactionName,
            pageLoadParentId: config.pageLoadParentId
        }, perfOptions);
        return perfOptions;
    };
    _proto.startManagedTransaction = function startManagedTransaction(name, type, perfOptions) {
        var tr = this.getCurrentTransaction();
        var isRedefined = false;
        if (!tr) tr = this.createCurrentTransaction(name, type, perfOptions);
        else if (tr.canReuse() && perfOptions.canReuse) {
            var redefineType = tr.type;
            var currentTypeOrder = (0, $c898cf419eb79f2e$export$38ee95dde3859fb7).indexOf(tr.type);
            var redefineTypeOrder = (0, $c898cf419eb79f2e$export$38ee95dde3859fb7).indexOf(type);
            if (currentTypeOrder >= 0 && redefineTypeOrder < currentTypeOrder) redefineType = type;
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logger.debug("redefining transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", 'to', "(" + (name || tr.name) + ", " + redefineType + ")", tr);
            tr.redefine(name, redefineType, perfOptions);
            isRedefined = true;
        } else {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logger.debug("ending previous transaction(" + tr.id + ", " + tr.name + ")", tr);
            tr.end();
            tr = this.createCurrentTransaction(name, type, perfOptions);
        }
        if (tr.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539)) {
            if (!isRedefined) {
                this.recorder.start((0, $c898cf419eb79f2e$export$6de1676190bd73c4));
                this.recorder.start((0, $c898cf419eb79f2e$export$ef5de76f1655b5ca));
                this.recorder.start((0, $c898cf419eb79f2e$export$98085453dd812392));
                this.recorder.start((0, $c898cf419eb79f2e$export$fc5ce9a4261f08e8));
            }
            if (perfOptions.pageLoadTraceId) tr.traceId = perfOptions.pageLoadTraceId;
            if (perfOptions.pageLoadSampled) tr.sampled = perfOptions.pageLoadSampled;
            if (tr.name === (0, $c898cf419eb79f2e$export$f0eae82cd3ba085f) && perfOptions.pageLoadTransactionName) tr.name = perfOptions.pageLoadTransactionName;
        }
        if (!isRedefined && this._config.get('monitorLongtasks')) this.recorder.start((0, $c898cf419eb79f2e$export$fd2c36a5e8e50e04));
        if (tr.sampled) tr.captureTimings = true;
        return tr;
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        var _this2 = this;
        var perfOptions = this.createOptions(options);
        var tr;
        var fireOnstartHook = true;
        if (perfOptions.managed) {
            var current = this.currentTransaction;
            tr = this.startManagedTransaction(name, type, perfOptions);
            if (current === tr) fireOnstartHook = false;
        } else tr = new (0, $9ed84b7409876a52$export$2e2bcd8739ae039)(name, type, perfOptions);
        tr.onEnd = function() {
            return _this2.handleTransactionEnd(tr);
        };
        if (fireOnstartHook) {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logger.debug("startTransaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")");
            this._config.events.send((0, $c898cf419eb79f2e$export$53ee6f7d651aa888), [
                tr
            ]);
        }
        return tr;
    };
    _proto.handleTransactionEnd = function handleTransactionEnd(tr) {
        var _this3 = this;
        this.recorder.stop();
        var currentUrl = window.location.href;
        return (0, $2bb64b3ee44f1905$export$775f0de60169233c).resolve().then(function() {
            var name = tr.name, type = tr.type;
            var lastHiddenStart = (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).lastHiddenStart;
            if (lastHiddenStart >= tr._start) {
                if (0, $d15fb30d84867e0d$export$a866f231438cc228) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") was discarded! The page was hidden during the transaction!");
                _this3._config.dispatchEvent((0, $c898cf419eb79f2e$export$543fdf328f404af7));
                return;
            }
            if (_this3.shouldIgnoreTransaction(name) || type === (0, $c898cf419eb79f2e$export$c757be00d1bf3ef5)) {
                if (0, $d15fb30d84867e0d$export$a866f231438cc228) _this3._logger.debug("transaction(" + tr.id + ", " + name + ", " + type + ") is ignored");
                _this3._config.dispatchEvent((0, $c898cf419eb79f2e$export$543fdf328f404af7));
                return;
            }
            if (type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539)) {
                var pageLoadTransactionName = _this3._config.get('pageLoadTransactionName');
                if (name === (0, $c898cf419eb79f2e$export$f0eae82cd3ba085f) && pageLoadTransactionName) tr.name = pageLoadTransactionName;
                if (tr.captureTimings) {
                    var cls = (0, $a3f071508e72d542$export$b0c5c2fac8144e54).cls, fid = (0, $a3f071508e72d542$export$b0c5c2fac8144e54).fid, tbt = (0, $a3f071508e72d542$export$b0c5c2fac8144e54).tbt, longtask = (0, $a3f071508e72d542$export$b0c5c2fac8144e54).longtask;
                    if (tbt.duration > 0) tr.spans.push((0, $a3f071508e72d542$export$4f167c0032dd3716)(tbt));
                    tr.experience = {};
                    if ((0, $81ba5eca3c0826ee$export$c043ff66aa95c00c)((0, $c898cf419eb79f2e$export$fd2c36a5e8e50e04))) tr.experience.tbt = tbt.duration;
                    if ((0, $81ba5eca3c0826ee$export$c043ff66aa95c00c)((0, $c898cf419eb79f2e$export$fc5ce9a4261f08e8))) tr.experience.cls = cls.score;
                    if (fid > 0) tr.experience.fid = fid;
                    if (longtask.count > 0) tr.experience.longtask = {
                        count: longtask.count,
                        sum: longtask.duration,
                        max: longtask.max
                    };
                }
                _this3.setSession(tr);
            }
            if (tr.name === (0, $c898cf419eb79f2e$export$f0eae82cd3ba085f)) tr.name = (0, $5988178a6f0b5e35$export$456a5af62e4119f6)(currentUrl);
            (0, $229f88190de43244$export$ffbf565d212a6a74)(tr);
            _this3.adjustTransactionTime(tr);
            var breakdownMetrics = _this3._config.get('breakdownMetrics');
            if (breakdownMetrics) tr.captureBreakdown();
            var configContext = _this3._config.get('context');
            (0, $2c87e6d217c9f6e4$export$d10ae57e760667a5)(tr, configContext);
            _this3._config.events.send((0, $c898cf419eb79f2e$export$3583e51eacab0340), [
                tr
            ]);
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) _this3._logger.debug("end transaction(" + tr.id + ", " + tr.name + ", " + tr.type + ")", tr);
        }, function(err) {
            if (0, $d15fb30d84867e0d$export$a866f231438cc228) _this3._logger.debug("error ending transaction(" + tr.id + ", " + tr.name + ")", err);
        });
    };
    _proto.setSession = function setSession(tr) {
        var session = this._config.get('session');
        if (session) {
            if (typeof session == 'boolean') tr.session = {
                id: (0, $81ba5eca3c0826ee$export$59b2544ec352d56)(16),
                sequence: 1
            };
            else if (session.timestamp && Date.now() - session.timestamp > (0, $c898cf419eb79f2e$export$c74ee24a01db1ae5)) tr.session = {
                id: (0, $81ba5eca3c0826ee$export$59b2544ec352d56)(16),
                sequence: 1
            };
            else tr.session = {
                id: session.id,
                sequence: session.sequence ? session.sequence + 1 : 1
            };
            var sessionConfig = {
                session: {
                    id: tr.session.id,
                    sequence: tr.session.sequence,
                    timestamp: Date.now()
                }
            };
            this._config.setConfig(sessionConfig);
            this._config.setLocalConfig(sessionConfig, true);
        }
    };
    _proto.adjustTransactionTime = function adjustTransactionTime(transaction) {
        var spans = transaction.spans;
        var earliestSpan = (0, $81ba5eca3c0826ee$export$26335e41fd84043b)(spans);
        if (earliestSpan && earliestSpan._start < transaction._start) transaction._start = earliestSpan._start;
        var latestSpan = (0, $81ba5eca3c0826ee$export$4066158e069099c5)(spans) || {};
        var latestSpanEnd = latestSpan._end || 0;
        if (transaction.type === (0, $c898cf419eb79f2e$export$1502f4f8c48fa539)) {
            var transactionEndWithoutDelay = transaction._end - (0, $c898cf419eb79f2e$export$b78d68e75d8e9dad);
            var lcp = (0, $a3f071508e72d542$export$b0c5c2fac8144e54).lcp || 0;
            var latestXHRSpan = (0, $81ba5eca3c0826ee$export$9db886af3c22d167)(spans) || {};
            var latestXHRSpanEnd = latestXHRSpan._end || 0;
            transaction._end = Math.max(latestSpanEnd, latestXHRSpanEnd, lcp, transactionEndWithoutDelay);
        } else if (latestSpanEnd > transaction._end) transaction._end = latestSpanEnd;
        this.truncateSpans(spans, transaction._end);
    };
    _proto.truncateSpans = function truncateSpans(spans, transactionEnd) {
        for(var i = 0; i < spans.length; i++){
            var span = spans[i];
            if (span._end > transactionEnd) {
                span._end = transactionEnd;
                span.type += (0, $c898cf419eb79f2e$export$58a4ef0ce68953f5);
            }
            if (span._start > transactionEnd) span._start = transactionEnd;
        }
    };
    _proto.shouldIgnoreTransaction = function shouldIgnoreTransaction(transactionName) {
        var ignoreList = this._config.get('ignoreTransactions');
        if (ignoreList && ignoreList.length) for(var i = 0; i < ignoreList.length; i++){
            var element = ignoreList[i];
            if (typeof element.test === 'function') {
                if (element.test(transactionName)) return true;
            } else if (element === transactionName) return true;
        }
        return false;
    };
    _proto.startSpan = function startSpan(name, type, options) {
        var tr = this.getCurrentTransaction();
        if (!tr) tr = this.createCurrentTransaction(undefined, (0, $c898cf419eb79f2e$export$c757be00d1bf3ef5), this.createOptions({
            canReuse: true,
            managed: true
        }));
        var span = tr.startSpan(name, type, options);
        if (0, $d15fb30d84867e0d$export$a866f231438cc228) this._logger.debug("startSpan(" + name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        return span;
    };
    _proto.endSpan = function endSpan(span, context) {
        if (!span) return;
        if (0, $d15fb30d84867e0d$export$a866f231438cc228) {
            var tr = this.getCurrentTransaction();
            tr && this._logger.debug("endSpan(" + span.name + ", " + span.type + ")", "on transaction(" + tr.id + ", " + tr.name + ")");
        }
        span.end(null, context);
    };
    return TransactionService;
}();
var $746cba9ae4997c02$export$2e2bcd8739ae039 = $746cba9ae4997c02$var$TransactionService;






function $bf267aab9b623f7c$export$174fd5f90dd8a5db() {
    (0, $fa349a7677bf25be$export$a7d9bc765837b75c)[0, $c898cf419eb79f2e$export$ab6389d1a16bebfe] = function(serviceFactory) {
        var _serviceFactory$getSe = serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$7d973190a36b8246),
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b)
        ]), loggingService = _serviceFactory$getSe[0], configService = _serviceFactory$getSe[1];
        return new (0, $746cba9ae4997c02$export$2e2bcd8739ae039)(loggingService, configService);
    };
    (0, $fa349a7677bf25be$export$a7d9bc765837b75c)[0, $c898cf419eb79f2e$export$6a0f49a7699bafca] = function(serviceFactory) {
        var _serviceFactory$getSe2 = serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37),
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
            (0, $c898cf419eb79f2e$export$7d973190a36b8246),
            (0, $c898cf419eb79f2e$export$ab6389d1a16bebfe)
        ]), apmServer = _serviceFactory$getSe2[0], configService = _serviceFactory$getSe2[1], loggingService = _serviceFactory$getSe2[2], transactionService = _serviceFactory$getSe2[3];
        return new (0, $f1769ffce293c033$export$2e2bcd8739ae039)(apmServer, configService, loggingService, transactionService);
    };
}






var $3b23f4b50f745e9c$var$INTERACTIVE_SELECTOR = 'a[data-transaction-name], button[data-transaction-name]';
function $3b23f4b50f745e9c$export$1f926008e0357783(transactionService) {
    var clickHandler = function clickHandler(event) {
        if (event.target instanceof Element) $3b23f4b50f745e9c$var$createUserInteractionTransaction(transactionService, event.target);
    };
    var eventName = 'click';
    var useCapture = true;
    window.addEventListener(eventName, clickHandler, useCapture);
    return function() {
        window.removeEventListener(eventName, clickHandler, useCapture);
    };
}
function $3b23f4b50f745e9c$var$createUserInteractionTransaction(transactionService, target) {
    var _getTransactionMetada = $3b23f4b50f745e9c$var$getTransactionMetadata(target), transactionName = _getTransactionMetada.transactionName, context = _getTransactionMetada.context;
    var tr = transactionService.startTransaction("Click - " + transactionName, (0, $c898cf419eb79f2e$export$ca341a703d5e2151), {
        managed: true,
        canReuse: true,
        reuseThreshold: 300
    });
    if (tr && context) tr.addContext(context);
}
function $3b23f4b50f745e9c$var$getTransactionMetadata(target) {
    var metadata = {
        transactionName: null,
        context: null
    };
    metadata.transactionName = $3b23f4b50f745e9c$var$buildTransactionName(target);
    var classes = target.getAttribute('class');
    if (classes) metadata.context = {
        custom: {
            classes: classes
        }
    };
    return metadata;
}
function $3b23f4b50f745e9c$var$buildTransactionName(target) {
    var dtName = $3b23f4b50f745e9c$var$findCustomTransactionName(target);
    if (dtName) return dtName;
    var tagName = target.tagName.toLowerCase();
    var name = target.getAttribute('name');
    if (!!name) return tagName + "[\"" + name + "\"]";
    return tagName;
}
function $3b23f4b50f745e9c$var$findCustomTransactionName(target) {
    var trCustomNameAttribute = 'data-transaction-name';
    var fallbackName = target.getAttribute(trCustomNameAttribute);
    if (target.closest) {
        var element = target.closest($3b23f4b50f745e9c$var$INTERACTIVE_SELECTOR);
        return element ? element.getAttribute(trCustomNameAttribute) : fallbackName;
    }
    return fallbackName;
}







function $39933dd808ed9234$export$2eecdd2f9bb703f5(transactionService) {
    var inp = (0, $ba6dda3f504fe70c$export$5ec729e92b081a59)();
    if (inp >= 0) {
        var startTime = (0, $81ba5eca3c0826ee$export$461939dd4422153)();
        var inpTr = transactionService.startTransaction((0, $c898cf419eb79f2e$export$2f2f0ccc41f2d4f6), (0, $c898cf419eb79f2e$export$2f2f0ccc41f2d4f6), {
            startTime: startTime
        });
        var navigations = performance.getEntriesByType('navigation');
        if (navigations.length > 0) {
            var hardNavigationUrl = navigations[0].name;
            inpTr.addContext({
                page: {
                    url: hardNavigationUrl
                }
            });
        }
        inpTr.addLabels({
            inp_value: inp
        });
        var endTime = startTime + inp + 1;
        inpTr.end(endTime);
        (0, $ba6dda3f504fe70c$export$8101508a6abf9c5c)();
        return inpTr;
    }
}


function $3bc8b32fdc9b2fad$export$469e44f8217c68b6(configService, transactionService) {
    if (document.visibilityState === 'hidden') (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).lastHiddenStart = 0;
    var visibilityChangeHandler = function visibilityChangeHandler() {
        if (document.visibilityState === 'hidden') $3bc8b32fdc9b2fad$var$onPageHidden(configService, transactionService);
    };
    var pageHideHandler = function pageHideHandler() {
        return $3bc8b32fdc9b2fad$var$onPageHidden(configService, transactionService);
    };
    var useCapture = true;
    window.addEventListener('visibilitychange', visibilityChangeHandler, useCapture);
    window.addEventListener('pagehide', pageHideHandler, useCapture);
    return function() {
        window.removeEventListener('visibilitychange', visibilityChangeHandler, useCapture);
        window.removeEventListener('pagehide', pageHideHandler, useCapture);
    };
}
function $3bc8b32fdc9b2fad$var$onPageHidden(configService, transactionService) {
    var inpTr = (0, $39933dd808ed9234$export$2eecdd2f9bb703f5)(transactionService);
    if (inpTr) var unobserve = configService.observeEvent((0, $c898cf419eb79f2e$export$c11a56b9bfcb1d0f), function() {
        $3bc8b32fdc9b2fad$var$endManagedTransaction(configService, transactionService);
        unobserve();
    });
    else $3bc8b32fdc9b2fad$var$endManagedTransaction(configService, transactionService);
}
function $3bc8b32fdc9b2fad$var$endManagedTransaction(configService, transactionService) {
    var tr = transactionService.getCurrentTransaction();
    if (tr) {
        var unobserveDiscard = configService.observeEvent((0, $c898cf419eb79f2e$export$543fdf328f404af7), function() {
            (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).lastHiddenStart = (0, $81ba5eca3c0826ee$export$461939dd4422153)();
            unobserveDiscard();
            unobserveQueueAdd();
        });
        var unobserveQueueAdd = configService.observeEvent((0, $c898cf419eb79f2e$export$c11a56b9bfcb1d0f), function() {
            configService.dispatchEvent((0, $c898cf419eb79f2e$export$19245af82a094556));
            (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).lastHiddenStart = (0, $81ba5eca3c0826ee$export$461939dd4422153)();
            unobserveQueueAdd();
            unobserveDiscard();
        });
        tr.end();
    } else {
        configService.dispatchEvent((0, $c898cf419eb79f2e$export$19245af82a094556));
        (0, $d15fb30d84867e0d$export$ca000e230c0caa3e).lastHiddenStart = (0, $81ba5eca3c0826ee$export$461939dd4422153)();
    }
}




function $247879c48c5f39e8$export$7852da8de47c1ce0(instrument, disabledInstrumentations) {
    var _flags;
    var flags = (_flags = {}, _flags[0, $c898cf419eb79f2e$export$942b1c2707517311] = false, _flags[0, $c898cf419eb79f2e$export$4a07cffb9c3bc884] = false, _flags[0, $c898cf419eb79f2e$export$149eb684a26496a2] = false, _flags[0, $c898cf419eb79f2e$export$1502f4f8c48fa539] = false, _flags[0, $c898cf419eb79f2e$export$103bedf43ba882db] = false, _flags[0, $c898cf419eb79f2e$export$2c4d7da089dce968] = false, _flags[0, $c898cf419eb79f2e$export$cb5542418ddbb7ed] = false, _flags);
    if (!instrument) return flags;
    Object.keys(flags).forEach(function(key) {
        if (disabledInstrumentations.indexOf(key) === -1) flags[key] = true;
    });
    return flags;
}


var $9bc6b1e8af275af3$var$RAF_TIMEOUT = 100;
function $9bc6b1e8af275af3$export$2e2bcd8739ae039(callback) {
    var handler = function handler() {
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        setTimeout(callback);
    };
    var timeout = setTimeout(handler, $9bc6b1e8af275af3$var$RAF_TIMEOUT);
    var raf = requestAnimationFrame(handler);
}




function $3464366cc857c1ff$export$791d8bdb130abda4() {
    (0, $bf267aab9b623f7c$export$174fd5f90dd8a5db)();
    (0, $d2418efc491b1dd5$export$174fd5f90dd8a5db)();
    var serviceFactory = new (0, $fa349a7677bf25be$export$654036ce31f352db)();
    return serviceFactory;
}



var $8fce4b0c6f9c354e$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        return this.isEnabled() && this._initialized && configService.get('active');
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
                (0, $c898cf419eb79f2e$export$7d973190a36b8246),
                (0, $c898cf419eb79f2e$export$ab6389d1a16bebfe)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion('5.16.0');
            this.config(config);
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get('active');
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $247879c48c5f39e8$export$7852da8de47c1ce0)(configService.get('instrument'), configService.get('disableInstrumentations'));
                var performanceMonitoring = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$6a0f49a7699bafca));
                performanceMonitoring.init(flags);
                if (flags[0, $c898cf419eb79f2e$export$103bedf43ba882db]) {
                    var errorLogging = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$3bb4e88cf5c5fd65));
                    errorLogging.registerListeners();
                }
                if (configService.get('session')) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $c898cf419eb79f2e$export$1502f4f8c48fa539] && _this._sendPageLoadMetrics();
                };
                if (configService.get('centralConfig')) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $3bc8b32fdc9b2fad$export$469e44f8217c68b6)(configService, transactionService);
                if (flags[0, $c898cf419eb79f2e$export$2c4d7da089dce968] && flags[0, $c898cf419eb79f2e$export$cb5542418ddbb7ed]) (0, $3b23f4b50f745e9c$export$1f926008e0357783)(transactionService);
                (0, $ba6dda3f504fe70c$export$57066f288181694e)();
            } else {
                this._disable = true;
                loggingService.warn('RUM agent is inactive');
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37),
            (0, $c898cf419eb79f2e$export$7d973190a36b8246),
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get('serviceName'), configService.get('environment')).then(function(config) {
            var transactionSampleRate = config['transaction_sample_rate'];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn("invalid value \"" + value + "\" for " + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn('failed fetching config:', error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $c898cf419eb79f2e$export$1502f4f8c48fa539), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $c898cf419eb79f2e$export$1502f4f8c48fa539));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $c898cf419eb79f2e$export$1502f4f8c48fa539));
            }, (0, $c898cf419eb79f2e$export$b78d68e75d8e9dad));
        };
        if (document.readyState === 'complete') sendPageLoadMetrics();
        else window.addEventListener('load', sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
            (0, $c898cf419eb79f2e$export$7d973190a36b8246)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = 'Unknown config options are specified for RUM agent: ' + unknown.join(', ');
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ', ';
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + ' is missing';
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + " \"" + value + "\" contains invalid characters! (allowed: " + allowed + ")" + (index !== invalid.length - 1 ? separator : '');
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$3bb4e88cf5c5fd65));
            return errorLogging.logError(error);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.addFilter(fn);
    };
    return ApmBase;
}();


function $fd8342fe733aea4b$var$getApmBase() {
    if ((0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $770f7a375fe5760b$export$36aff1fbb4f5dfc6)();
    var serviceFactory = (0, $3464366cc857c1ff$export$791d8bdb130abda4)();
    var apmBase = new (0, $8fce4b0c6f9c354e$export$2e2bcd8739ae039)(serviceFactory, !enabled);
    if (0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) window.elasticApm = apmBase;
    return apmBase;
}
var $fd8342fe733aea4b$export$66cd81c234b843ce = $fd8342fe733aea4b$var$getApmBase();
var $fd8342fe733aea4b$export$2cd8252107eb640b = $fd8342fe733aea4b$export$66cd81c234b843ce.init.bind($fd8342fe733aea4b$export$66cd81c234b843ce);
var $fd8342fe733aea4b$export$2e2bcd8739ae039 = $fd8342fe733aea4b$export$2cd8252107eb640b;


const $701a617efab9f26c$export$af88d00dbe7f521 = {
    init: ()=>{
        (0, $fd8342fe733aea4b$export$2cd8252107eb640b)({
            serviceName: 'mcp-admin-ui',
            serverUrl: 'https://partner-operations.apm.ece.legogroup.io',
            environment: "staging",
            propagateTracestate: true,
            breakdownMetrics: true,
            distributedTracingOrigins: [
                "https://vvw77vvbofdpjf4itb3wjly3pe.appsync-api.eu-west-1.amazonaws.com/graphql"
            ],
            serviceVersion: "dc68b938fd87e3f2d24537eedee605823ae4d385"
        });
    },
    logError: (error)=>{
        // eslint-disable-next-line no-console
        console.error(error);
        (0, $fd8342fe733aea4b$export$66cd81c234b843ce).captureError(error);
    }
};





function $02bbd90ab070cb52$export$2288787135a8f66e(errorHandler) {
    return new (0, $168cabbf484f42b9$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($2a9ca5bca188bdad$exports)))(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $02bbd90ab070cb52$export$d2c8415987899609 = function(_super) {
    (0, $1c0ef74047f3db21$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $02bbd90ab070cb52$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $168cabbf484f42b9$export$2fed3d61f740bc7f));





const $d6b6ea7cd62267ef$export$d27e4189c1f0e8f4 = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    closeButton: false
};




var $denZA = parcelRequire("denZA");
function $96c30c9afb001dc1$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $96c30c9afb001dc1$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $96c30c9afb001dc1$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $96c30c9afb001dc1$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $96c30c9afb001dc1$export$2e2bcd8739ae039 = $96c30c9afb001dc1$export$4f5d2d50c9deca37;



function $b1500a705028f634$var$_extends() {
    $b1500a705028f634$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1500a705028f634$var$_extends.apply(this, arguments);
}
function $b1500a705028f634$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b1500a705028f634$var$isNum(v) {
    return typeof v === 'number' && !isNaN(v);
}
function $b1500a705028f634$var$isBool(v) {
    return typeof v === 'boolean';
}
function $b1500a705028f634$var$isStr(v) {
    return typeof v === 'string';
}
function $b1500a705028f634$var$isFn(v) {
    return typeof v === 'function';
}
function $b1500a705028f634$var$parseClassName(v) {
    return $b1500a705028f634$var$isStr(v) || $b1500a705028f634$var$isFn(v) ? v : null;
}
function $b1500a705028f634$var$isToastIdValid(toastId) {
    return toastId === 0 || toastId;
}
function $b1500a705028f634$var$getAutoCloseDelay(toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || $b1500a705028f634$var$isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var $b1500a705028f634$var$canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b1500a705028f634$var$canBeRendered(content) {
    return (0, $denZA.isValidElement)(content) || $b1500a705028f634$var$isStr(content) || $b1500a705028f634$var$isFn(content) || $b1500a705028f634$var$isNum(content);
}
var $b1500a705028f634$var$POSITION = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center'
};
var $b1500a705028f634$var$TYPE = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default',
    DARK: 'dark'
};
/**
 * Used to collapse toast after exit animation
 */ function $b1500a705028f634$export$184cca501f1aed7f(node, done, duration) {
    if (duration === void 0) duration = 300;
    var height = node.scrollHeight;
    var style = node.style;
    requestAnimationFrame(function() {
        style.minHeight = 'initial';
        style.height = height + 'px';
        style.transition = "all " + duration + "ms";
        requestAnimationFrame(function() {
            style.height = '0';
            style.padding = '0';
            style.margin = '0';
            setTimeout(done, duration);
        });
    });
}
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */ function $b1500a705028f634$export$3ff7dc44d332d222(_ref) {
    var enter = _ref.enter, exit = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
    return function ToastTransition(_ref2) {
        var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
        var enterClassName = appendPosition ? enter + "--" + position : enter;
        var exitClassName = appendPosition ? exit + "--" + position : exit;
        var baseClassName = (0, $denZA.useRef)();
        var animationStep = (0, $denZA.useRef)(0);
        (0, $denZA.useLayoutEffect)(function() {
            onEnter();
        }, []);
        (0, $denZA.useEffect)(function() {
            if (!isIn) preventExitTransition ? onExited() : onExit();
        }, [
            isIn
        ]);
        function onEnter() {
            var node = nodeRef.current;
            baseClassName.current = node.className;
            node.className += " " + enterClassName;
            node.addEventListener('animationend', onEntered);
        }
        function onEntered() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onEntered);
            if (animationStep.current === 0) node.className = baseClassName.current;
        }
        function onExit() {
            animationStep.current = 1;
            var node = nodeRef.current;
            node.className += " " + exitClassName;
            node.addEventListener('animationend', onExited);
        }
        function onExited() {
            var node = nodeRef.current;
            node.removeEventListener('animationend', onExited);
            collapse ? $b1500a705028f634$export$184cca501f1aed7f(node, done, collapseDuration) : done();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Fragment, null, children);
    };
}
var $b1500a705028f634$var$eventManager = {
    list: /*#__PURE__*/ new Map(),
    emitQueue: /*#__PURE__*/ new Map(),
    on: function on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function off(event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function(cb) {
                return cb !== callback;
            });
            this.list.set(event, cb);
            return this;
        }
        this.list["delete"](event);
        return this;
    },
    cancelEmit: function cancelEmit(event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(clearTimeout);
            this.emitQueue["delete"](event);
        }
        return this;
    },
    /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */ emit: function emit(event) {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.list.has(event) && this.list.get(event).forEach(function(callback) {
            var timer = setTimeout(function() {
                // @ts-ignore
                callback.apply(void 0, args);
            }, 0);
            _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
            _this.emitQueue.get(event).push(timer);
        });
    }
};
/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */ function $b1500a705028f634$var$useKeeper(arg, refresh) {
    if (refresh === void 0) refresh = false;
    var ref = (0, $denZA.useRef)(arg);
    (0, $denZA.useEffect)(function() {
        if (refresh) ref.current = arg;
    });
    return ref.current;
}
function $b1500a705028f634$var$reducer(state, action) {
    switch(action.type){
        case 0:
            return [].concat(state, [
                action.toastId
            ]).filter(function(id) {
                return id !== action.staleId;
            });
        case 1:
            return $b1500a705028f634$var$isToastIdValid(action.toastId) ? state.filter(function(id) {
                return id !== action.toastId;
            }) : [];
    }
}
function $b1500a705028f634$export$b262e13ca2dd2381(props) {
    var _useReducer = (0, $denZA.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = _useReducer[1];
    var _useReducer2 = (0, $denZA.useReducer)($b1500a705028f634$var$reducer, []), toast = _useReducer2[0], dispatch = _useReducer2[1];
    var containerRef = (0, $denZA.useRef)(null);
    var toastCount = $b1500a705028f634$var$useKeeper(0);
    var queue = $b1500a705028f634$var$useKeeper([]);
    var collection = $b1500a705028f634$var$useKeeper({});
    var instance = $b1500a705028f634$var$useKeeper({
        toastKey: 1,
        displayedToast: 0,
        props: props,
        containerId: null,
        isToastActive: isToastActive,
        getToast: function getToast(id) {
            return collection[id] || null;
        }
    });
    (0, $denZA.useEffect)(function() {
        instance.containerId = props.containerId;
        $b1500a705028f634$var$eventManager.cancelEmit(3).on(0, buildToast).on(1, function(toastId) {
            return containerRef.current && removeToast(toastId);
        }).on(5, clearWaitingQueue).emit(2, instance);
        return function() {
            return $b1500a705028f634$var$eventManager.emit(3, instance);
        };
    }, []);
    (0, $denZA.useEffect)(function() {
        instance.isToastActive = isToastActive;
        instance.displayedToast = toast.length;
        $b1500a705028f634$var$eventManager.emit(4, toast.length, props.containerId);
    }, [
        toast
    ]);
    (0, $denZA.useEffect)(function() {
        instance.props = props;
    });
    function isToastActive(id) {
        return toast.indexOf(id) !== -1;
    }
    function clearWaitingQueue(_ref) {
        var containerId = _ref.containerId;
        var limit = instance.props.limit;
        if (limit && (!containerId || instance.containerId === containerId)) {
            toastCount -= queue.length;
            queue = [];
        }
    }
    function removeToast(toastId) {
        dispatch({
            type: 1,
            toastId: toastId
        });
    }
    function dequeueToast() {
        var _queue$shift = queue.shift(), toastContent = _queue$shift.toastContent, toastProps = _queue$shift.toastProps, staleId = _queue$shift.staleId;
        appendToast(toastContent, toastProps, staleId);
    }
    /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */ function isNotValid(_ref2) {
        var containerId = _ref2.containerId, toastId = _ref2.toastId, updateId = _ref2.updateId;
        return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
    } // this function and all the function called inside needs to rely on ref(`useKeeper`)
    function buildToast(content, _ref3) {
        var delay = _ref3.delay, staleId = _ref3.staleId, options = $b1500a705028f634$var$_objectWithoutPropertiesLoose(_ref3, [
            "delay",
            "staleId"
        ]);
        if (!$b1500a705028f634$var$canBeRendered(content) || isNotValid(options)) return;
        var toastId = options.toastId, updateId = options.updateId;
        var props = instance.props;
        var closeToast = function closeToast() {
            return removeToast(toastId);
        };
        var isNotAnUpdate = options.updateId == null;
        if (isNotAnUpdate) toastCount++;
        var toastProps = {
            toastId: toastId,
            updateId: updateId,
            isIn: false,
            key: options.key || instance.toastKey++,
            type: options.type,
            closeToast: closeToast,
            closeButton: options.closeButton,
            rtl: props.rtl,
            position: options.position || props.position,
            transition: options.transition || props.transition,
            className: $b1500a705028f634$var$parseClassName(options.className || props.toastClassName),
            bodyClassName: $b1500a705028f634$var$parseClassName(options.bodyClassName || props.bodyClassName),
            style: options.style || props.toastStyle,
            bodyStyle: options.bodyStyle || props.bodyStyle,
            onClick: options.onClick || props.onClick,
            pauseOnHover: $b1500a705028f634$var$isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
            pauseOnFocusLoss: $b1500a705028f634$var$isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
            draggable: $b1500a705028f634$var$isBool(options.draggable) ? options.draggable : props.draggable,
            draggablePercent: $b1500a705028f634$var$isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
            draggableDirection: options.draggableDirection || props.draggableDirection,
            closeOnClick: $b1500a705028f634$var$isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
            progressClassName: $b1500a705028f634$var$parseClassName(options.progressClassName || props.progressClassName),
            progressStyle: options.progressStyle || props.progressStyle,
            autoClose: $b1500a705028f634$var$getAutoCloseDelay(options.autoClose, props.autoClose),
            hideProgressBar: $b1500a705028f634$var$isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
            progress: options.progress,
            role: $b1500a705028f634$var$isStr(options.role) ? options.role : props.role,
            deleteToast: function deleteToast() {
                removeFromCollection(toastId);
            }
        };
        if ($b1500a705028f634$var$isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
        if ($b1500a705028f634$var$isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging
        if (toastProps.draggableDirection === "y" && toastProps.draggablePercent === 80) toastProps.draggablePercent *= 1.5;
        var closeButton = props.closeButton;
        if (options.closeButton === false || $b1500a705028f634$var$canBeRendered(options.closeButton)) closeButton = options.closeButton;
        else if (options.closeButton === true) closeButton = $b1500a705028f634$var$canBeRendered(props.closeButton) ? props.closeButton : true;
        toastProps.closeButton = closeButton;
        var toastContent = content;
        if ((0, $denZA.isValidElement)(content) && !$b1500a705028f634$var$isStr(content.type)) toastContent = (0, $denZA.cloneElement)(content, {
            closeToast: closeToast,
            toastProps: toastProps
        });
        else if ($b1500a705028f634$var$isFn(content)) toastContent = content({
            closeToast: closeToast,
            toastProps: toastProps
        });
         // not handling limit + delay by design. Waiting for user feedback first
        if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) queue.push({
            toastContent: toastContent,
            toastProps: toastProps,
            staleId: staleId
        });
        else if ($b1500a705028f634$var$isNum(delay) && delay > 0) setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, delay);
        else appendToast(toastContent, toastProps, staleId);
    }
    function appendToast(content, toastProps, staleId) {
        var toastId = toastProps.toastId;
        if (staleId) delete collection[staleId];
        collection[toastId] = {
            content: content,
            props: toastProps
        };
        dispatch({
            type: 0,
            toastId: toastId,
            staleId: staleId
        });
    }
    function removeFromCollection(toastId) {
        delete collection[toastId];
        var queueLen = queue.length;
        toastCount = $b1500a705028f634$var$isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
        if (toastCount < 0) toastCount = 0;
        if (queueLen > 0) {
            var freeSlot = $b1500a705028f634$var$isToastIdValid(toastId) ? 1 : instance.props.limit;
            if (queueLen === 1 || freeSlot === 1) {
                instance.displayedToast++;
                dequeueToast();
            } else {
                var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
                instance.displayedToast = toDequeue;
                for(var i = 0; i < toDequeue; i++)dequeueToast();
            }
        } else forceUpdate();
    }
    function getToastToRender(cb) {
        var toastToRender = {};
        var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);
        for(var i = 0; i < toastList.length; i++){
            var _toast = collection[toastList[i]];
            var position = _toast.props.position;
            toastToRender[position] || (toastToRender[position] = []);
            toastToRender[position].push(_toast);
        }
        return Object.keys(toastToRender).map(function(p) {
            return cb(p, toastToRender[p]);
        });
    }
    return {
        getToastToRender: getToastToRender,
        collection: collection,
        containerRef: containerRef,
        isToastActive: isToastActive
    };
}
function $b1500a705028f634$var$getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function $b1500a705028f634$var$getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function $b1500a705028f634$export$a407b657d3044108(props) {
    var _useState = (0, $denZA.useState)(true), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState2 = (0, $denZA.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
    var toastRef = (0, $denZA.useRef)(null);
    var drag = $b1500a705028f634$var$useKeeper({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: true,
        canDrag: false,
        boundingRect: null
    });
    var syncProps = $b1500a705028f634$var$useKeeper(props, true);
    var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
    (0, $denZA.useEffect)(function() {
        if ($b1500a705028f634$var$isFn(props.onOpen)) props.onOpen((0, $denZA.isValidElement)(props.children) && props.children.props);
        return function() {
            if ($b1500a705028f634$var$isFn(syncProps.onClose)) syncProps.onClose((0, $denZA.isValidElement)(syncProps.children) && syncProps.children.props);
        };
    }, []);
    (0, $denZA.useEffect)(function() {
        props.draggable && bindDragEvents();
        return function() {
            props.draggable && unbindDragEvents();
        };
    }, [
        props.draggable
    ]);
    (0, $denZA.useEffect)(function() {
        props.pauseOnFocusLoss && bindFocusEvents();
        return function() {
            props.pauseOnFocusLoss && unbindFocusEvents();
        };
    }, [
        props.pauseOnFocusLoss
    ]);
    function onDragStart(e) {
        if (props.draggable) {
            var toast = toastRef.current;
            drag.canCloseOnClick = true;
            drag.canDrag = true;
            drag.boundingRect = toast.getBoundingClientRect();
            toast.style.transition = '';
            drag.x = $b1500a705028f634$var$getX(e.nativeEvent);
            drag.y = $b1500a705028f634$var$getY(e.nativeEvent);
            if (props.draggableDirection === "x") {
                drag.start = drag.x;
                drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
            } else {
                drag.start = drag.y;
                drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
            }
        }
    }
    function onDragTransitionEnd() {
        if (drag.boundingRect) {
            var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
            if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) pauseToast();
            else playToast();
        }
    }
    function playToast() {
        setIsRunning(true);
    }
    function pauseToast() {
        setIsRunning(false);
    }
    function bindFocusEvents() {
        if (!document.hasFocus()) pauseToast();
        window.addEventListener('focus', playToast);
        window.addEventListener('blur', pauseToast);
    }
    function unbindFocusEvents() {
        window.removeEventListener('focus', playToast);
        window.removeEventListener('blur', pauseToast);
    }
    function bindDragEvents() {
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragEnd);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragEnd);
    }
    function unbindDragEvents() {
        document.removeEventListener('mousemove', onDragMove);
        document.removeEventListener('mouseup', onDragEnd);
        document.removeEventListener('touchmove', onDragMove);
        document.removeEventListener('touchend', onDragEnd);
    }
    function onDragMove(e) {
        if (drag.canDrag) {
            e.preventDefault();
            var toast = toastRef.current;
            if (isRunning) pauseToast();
            drag.x = $b1500a705028f634$var$getX(e);
            drag.y = $b1500a705028f634$var$getY(e);
            if (props.draggableDirection === "x") drag.delta = drag.x - drag.start;
            else drag.delta = drag.y - drag.start;
             // prevent false positif during a toast click
            if (drag.start !== drag.x) drag.canCloseOnClick = false;
            toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
            toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
        }
    }
    function onDragEnd() {
        var toast = toastRef.current;
        if (drag.canDrag) {
            drag.canDrag = false;
            if (Math.abs(drag.delta) > drag.removalDistance) {
                setPreventExitTransition(true);
                props.closeToast();
                return;
            }
            toast.style.transition = 'transform 0.2s, opacity 0.2s';
            toast.style.transform = "translate" + props.draggableDirection + "(0)";
            toast.style.opacity = '1';
        }
    }
    var eventHandlers = {
        onMouseDown: onDragStart,
        onTouchStart: onDragStart,
        onMouseUp: onDragTransitionEnd,
        onTouchEnd: onDragTransitionEnd
    };
    if (autoClose && pauseOnHover) {
        eventHandlers.onMouseEnter = pauseToast;
        eventHandlers.onMouseLeave = playToast;
    } // prevent toast from closing when user drags the toast
    if (closeOnClick) eventHandlers.onClick = function(e) {
        onClick && onClick(e);
        drag.canCloseOnClick && closeToast();
    };
    return {
        playToast: playToast,
        pauseToast: pauseToast,
        isRunning: isRunning,
        preventExitTransition: preventExitTransition,
        toastRef: toastRef,
        eventHandlers: eventHandlers
    };
}
function $b1500a705028f634$var$CloseButton(_ref) {
    var closeToast = _ref.closeToast, type = _ref.type, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
    return (0, $denZA.createElement)("button", {
        className: "Toastify__close-button Toastify__close-button--" + type,
        type: "button",
        onClick: function onClick(e) {
            e.stopPropagation();
            closeToast(e);
        },
        "aria-label": ariaLabel
    }, (0, $denZA.createElement)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, $denZA.createElement)("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b1500a705028f634$var$ProgressBar(_ref) {
    var _cx, _animationEvent;
    var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn;
    var style = $b1500a705028f634$var$_extends({}, userStyle, {
        animationDuration: delay + "ms",
        animationPlayState: isRunning ? 'running' : 'paused',
        opacity: hide ? 0 : 1
    });
    if (controlledProgress) style.transform = "scaleX(" + progress + ")";
    var defaultClassName = (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
    var classNames = $b1500a705028f634$var$isFn(className) ? className({
        rtl: rtl,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)(defaultClassName, className); // 🧐 controlledProgress is derived from progress
    // so if controlledProgress is set
    // it means that this is also the case for progress
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function() {
        isIn && closeToast();
    }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin
    return (0, $denZA.createElement)("div", Object.assign({
        role: "progressbar",
        "aria-hidden": hide ? 'true' : 'false',
        "aria-label": "notification timer",
        className: classNames,
        style: style
    }, animationEvent));
}
$b1500a705028f634$var$ProgressBar.defaultProps = {
    type: $b1500a705028f634$var$TYPE.DEFAULT,
    hide: false
};
var $b1500a705028f634$var$Toast = function Toast(props) {
    var _cx;
    var _useToast = $b1500a705028f634$export$a407b657d3044108(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
    var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn;
    var defaultClassName = (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)("Toastify__toast", "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
    var cssClasses = $b1500a705028f634$var$isFn(className) ? className({
        rtl: rtl,
        position: position,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)(defaultClassName, className);
    var isProgressControlled = !!progress;
    function renderCloseButton(closeButton) {
        if (!closeButton) return;
        var props = {
            closeToast: closeToast,
            type: type
        };
        if ($b1500a705028f634$var$isFn(closeButton)) return closeButton(props);
        if ((0, $denZA.isValidElement)(closeButton)) return (0, $denZA.cloneElement)(closeButton, props);
    }
    return (0, $denZA.createElement)(Transition, {
        isIn: isIn,
        done: deleteToast,
        position: position,
        preventExitTransition: preventExitTransition,
        nodeRef: toastRef
    }, (0, $denZA.createElement)("div", Object.assign({
        id: toastId,
        onClick: onClick,
        className: cssClasses
    }, eventHandlers, {
        style: style,
        ref: toastRef
    }), (0, $denZA.createElement)("div", Object.assign({}, isIn && {
        role: role
    }, {
        className: $b1500a705028f634$var$isFn(bodyClassName) ? bodyClassName({
            type: type
        }) : (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)("Toastify__toast-body", bodyClassName),
        style: bodyStyle
    }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0, $denZA.createElement)($b1500a705028f634$var$ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
        key: "pb-" + updateId
    } : {}, {
        rtl: rtl,
        delay: autoClose,
        isRunning: isRunning,
        isIn: isIn,
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: isProgressControlled,
        progress: progress
    }))));
};
var $b1500a705028f634$export$d20e79fdc3899e95 = /*#__PURE__*/ $b1500a705028f634$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__bounce-enter",
    exit: "Toastify--animate Toastify__bounce-exit",
    appendPosition: true
});
var $b1500a705028f634$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $b1500a705028f634$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__slide-enter",
    exit: "Toastify--animate Toastify__slide-exit",
    appendPosition: true
});
var $b1500a705028f634$export$65cfd44a2050f99 = /*#__PURE__*/ $b1500a705028f634$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__zoom-enter",
    exit: "Toastify--animate Toastify__zoom-exit"
});
var $b1500a705028f634$export$4d2fae537bd90431 = /*#__PURE__*/ $b1500a705028f634$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__flip-enter",
    exit: "Toastify--animate Toastify__flip-exit"
});
var $b1500a705028f634$export$f2815235e76a62b9 = function ToastContainer(props) {
    var _useToastContainer = $b1500a705028f634$export$b262e13ca2dd2381(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
    function getClassName(position) {
        var _cx;
        var defaultClassName = (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
        return $b1500a705028f634$var$isFn(className) ? className({
            position: position,
            rtl: rtl,
            defaultClassName: defaultClassName
        }) : (0, $96c30c9afb001dc1$export$2e2bcd8739ae039)(defaultClassName, $b1500a705028f634$var$parseClassName(className));
    }
    return (0, $denZA.createElement)("div", {
        ref: containerRef,
        className: "Toastify",
        id: containerId
    }, getToastToRender(function(position, toastList) {
        var containerStyle = toastList.length === 0 ? $b1500a705028f634$var$_extends({}, style, {
            pointerEvents: 'none'
        }) : $b1500a705028f634$var$_extends({}, style);
        return (0, $denZA.createElement)("div", {
            className: getClassName(position),
            style: containerStyle,
            key: "container-" + position
        }, toastList.map(function(_ref) {
            var content = _ref.content, toastProps = _ref.props;
            return (0, $denZA.createElement)($b1500a705028f634$var$Toast, Object.assign({}, toastProps, {
                isIn: isToastActive(toastProps.toastId),
                key: "toast-" + toastProps.key,
                closeButton: toastProps.closeButton === true ? $b1500a705028f634$var$CloseButton : toastProps.closeButton
            }), content);
        }));
    }));
};
$b1500a705028f634$export$f2815235e76a62b9.defaultProps = {
    position: $b1500a705028f634$var$POSITION.TOP_RIGHT,
    transition: $b1500a705028f634$export$d20e79fdc3899e95,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: $b1500a705028f634$var$CloseButton,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    draggableDirection: "x",
    role: 'alert'
};
var $b1500a705028f634$var$containers = /*#__PURE__*/ new Map();
var $b1500a705028f634$var$latestInstance;
var $b1500a705028f634$var$containerDomNode;
var $b1500a705028f634$var$containerConfig;
var $b1500a705028f634$var$queue = [];
var $b1500a705028f634$var$lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */ function $b1500a705028f634$var$isAnyContainerMounted() {
    return $b1500a705028f634$var$containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */ function $b1500a705028f634$var$getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = $b1500a705028f634$var$containers.get(containerId || $b1500a705028f634$var$latestInstance);
    if (!container) return null;
    return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */ function $b1500a705028f634$var$generateToastId() {
    return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */ function $b1500a705028f634$var$getToastId(options) {
    if (options && ($b1500a705028f634$var$isStr(options.toastId) || $b1500a705028f634$var$isNum(options.toastId))) return options.toastId;
    return $b1500a705028f634$var$generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */ function $b1500a705028f634$var$dispatchToast(content, options) {
    if ($b1500a705028f634$var$isAnyContainerMounted()) $b1500a705028f634$var$eventManager.emit(0, content, options);
    else {
        $b1500a705028f634$var$queue.push({
            content: content,
            options: options
        });
        if ($b1500a705028f634$var$lazy && $b1500a705028f634$var$canUseDom) {
            $b1500a705028f634$var$lazy = false;
            $b1500a705028f634$var$containerDomNode = document.createElement('div');
            document.body.appendChild($b1500a705028f634$var$containerDomNode);
            (0, $d486a8928008256a$exports.render)((0, $denZA.createElement)($b1500a705028f634$export$f2815235e76a62b9, Object.assign({}, $b1500a705028f634$var$containerConfig)), $b1500a705028f634$var$containerDomNode);
        }
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */ function $b1500a705028f634$var$mergeOptions(type, options) {
    return $b1500a705028f634$var$_extends({}, options, {
        type: options && options.type || type,
        toastId: $b1500a705028f634$var$getToastId(options)
    });
}
var $b1500a705028f634$var$createToastByType = function createToastByType(type) {
    return function(content, options) {
        return $b1500a705028f634$var$dispatchToast(content, $b1500a705028f634$var$mergeOptions(type, options));
    };
};
var $b1500a705028f634$export$b410431fab84fa58 = function toast(content, options) {
    return $b1500a705028f634$var$dispatchToast(content, $b1500a705028f634$var$mergeOptions($b1500a705028f634$var$TYPE.DEFAULT, options));
};
$b1500a705028f634$export$b410431fab84fa58.success = /*#__PURE__*/ $b1500a705028f634$var$createToastByType($b1500a705028f634$var$TYPE.SUCCESS);
$b1500a705028f634$export$b410431fab84fa58.info = /*#__PURE__*/ $b1500a705028f634$var$createToastByType($b1500a705028f634$var$TYPE.INFO);
$b1500a705028f634$export$b410431fab84fa58.error = /*#__PURE__*/ $b1500a705028f634$var$createToastByType($b1500a705028f634$var$TYPE.ERROR);
$b1500a705028f634$export$b410431fab84fa58.warning = /*#__PURE__*/ $b1500a705028f634$var$createToastByType($b1500a705028f634$var$TYPE.WARNING);
$b1500a705028f634$export$b410431fab84fa58.dark = /*#__PURE__*/ $b1500a705028f634$var$createToastByType($b1500a705028f634$var$TYPE.DARK);
$b1500a705028f634$export$b410431fab84fa58.warn = $b1500a705028f634$export$b410431fab84fa58.warning;
/**
 * Remove toast programmaticaly
 */ $b1500a705028f634$export$b410431fab84fa58.dismiss = function(id) {
    return $b1500a705028f634$var$eventManager.emit(1, id);
};
/**
 * Clear waiting queue when limit is used
 */ $b1500a705028f634$export$b410431fab84fa58.clearWaitingQueue = function(params) {
    if (params === void 0) params = {};
    return $b1500a705028f634$var$eventManager.emit(5, params);
};
/**
 * return true if one container is displaying the toast
 */ $b1500a705028f634$export$b410431fab84fa58.isActive = function(id) {
    var isToastActive = false;
    $b1500a705028f634$var$containers.forEach(function(container) {
        if (container.isToastActive && container.isToastActive(id)) isToastActive = true;
    });
    return isToastActive;
};
$b1500a705028f634$export$b410431fab84fa58.update = function(toastId, options) {
    if (options === void 0) options = {};
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function() {
        var toast = $b1500a705028f634$var$getToast(toastId, options);
        if (toast) {
            var oldOptions = toast.props, oldContent = toast.content;
            var nextOptions = $b1500a705028f634$var$_extends({}, oldOptions, options, {
                toastId: options.toastId || toastId,
                updateId: $b1500a705028f634$var$generateToastId()
            });
            if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
            var content = nextOptions.render || oldContent;
            delete nextOptions.render;
            $b1500a705028f634$var$dispatchToast(content, nextOptions);
        }
    }, 0);
};
/**
 * Used for controlled progress bar.
 */ $b1500a705028f634$export$b410431fab84fa58.done = function(id) {
    $b1500a705028f634$export$b410431fab84fa58.update(id, {
        progress: 1
    });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */ $b1500a705028f634$export$b410431fab84fa58.onChange = function(callback) {
    if ($b1500a705028f634$var$isFn(callback)) $b1500a705028f634$var$eventManager.on(4, callback);
    return function() {
        $b1500a705028f634$var$isFn(callback) && $b1500a705028f634$var$eventManager.off(4, callback);
    };
};
/**
 * Configure the ToastContainer when lazy mounted
 */ $b1500a705028f634$export$b410431fab84fa58.configure = function(config) {
    if (config === void 0) config = {};
    $b1500a705028f634$var$lazy = true;
    $b1500a705028f634$var$containerConfig = config;
};
$b1500a705028f634$export$b410431fab84fa58.POSITION = $b1500a705028f634$var$POSITION;
$b1500a705028f634$export$b410431fab84fa58.TYPE = $b1500a705028f634$var$TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */ $b1500a705028f634$var$eventManager.on(2, function(containerInstance) {
    $b1500a705028f634$var$latestInstance = containerInstance.containerId || containerInstance;
    $b1500a705028f634$var$containers.set($b1500a705028f634$var$latestInstance, containerInstance);
    $b1500a705028f634$var$queue.forEach(function(item) {
        $b1500a705028f634$var$eventManager.emit(0, item.content, item.options);
    });
    $b1500a705028f634$var$queue = [];
}).on(3, function(containerInstance) {
    $b1500a705028f634$var$containers["delete"](containerInstance.containerId || containerInstance);
    if ($b1500a705028f634$var$containers.size === 0) $b1500a705028f634$var$eventManager.off(0).off(1).off(5);
    if ($b1500a705028f634$var$canUseDom && $b1500a705028f634$var$containerDomNode) document.body.removeChild($b1500a705028f634$var$containerDomNode);
});



var $denZA = parcelRequire("denZA");
var $e4aab489102d1f45$var$__assign = undefined && undefined.__assign || function() {
    $e4aab489102d1f45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e4aab489102d1f45$var$__assign.apply(this, arguments);
};
var $e4aab489102d1f45$export$761e6d83b3265241 = $denZA.forwardRef(function AccountingDocument(props, svgRef) {
    return $denZA.createElement("svg", $e4aab489102d1f45$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.597 7.03a1.471 1.471 0 011.226.58.75.75 0 101.194-.908 2.97 2.97 0 00-1.705-1.099V5.25a.75.75 0 10-1.5 0v.363c-.43.095-.828.273-1.158.52-.515.387-.904.978-.904 1.695 0 .716.389 1.308.904 1.694.515.387 1.192.604 1.908.604.422 0 .775.13 1.006.303.23.172.303.354.303.493 0 .138-.073.32-.304.494-.232.173-.586.303-1.009.303h-.03a1.475 1.475 0 01-1.231-.58.75.75 0 10-1.194.91 2.974 2.974 0 001.709 1.098v.353a.75.75 0 001.5 0v-.363c.43-.097.825-.274 1.155-.521.515-.387.904-.978.904-1.694 0-.715-.388-1.306-.902-1.693-.515-.386-1.191-.603-1.907-.603-.422 0-.776-.13-1.008-.303-.23-.174-.304-.356-.304-.495 0-.138.073-.32.304-.494.231-.173.585-.303 1.006-.303h.037zM10.75 15a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm-4.5 3.75a.75.75 0 000 1.5H17.5a.75.75 0 000-1.5H6.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22 21.75V8.12a2.25 2.25 0 00-.659-1.59L15.47.659A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.25v19.5A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75zM3.25 1.5a.75.75 0 00-.75.75v19.5a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75V9h-5.25A2.25 2.25 0 0113 6.75V1.5H3.25zm12 6h4.94L14.5 1.81v4.94a.75.75 0 00.75.75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $562a2ee27aab1347$var$__assign = undefined && undefined.__assign || function() {
    $562a2ee27aab1347$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $562a2ee27aab1347$var$__assign.apply(this, arguments);
};
var $562a2ee27aab1347$export$36f90dd5c5d5cc11 = $denZA.forwardRef(function AccountingDocumentBold(props, svgRef) {
    return $denZA.createElement("svg", $562a2ee27aab1347$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.561 5.854L16.146.439A1.511 1.511 0 0015.086 0H3.5A1.5 1.5 0 002 1.5v21A1.5 1.5 0 003.5 24h18a.5.5 0 00.5-.5V6.914a1.49 1.49 0 00-.439-1.06zM9.817 11.183l-3.37-1.26A2.55 2.55 0 015 7.455 2.529 2.529 0 017.289 4.92a.249.249 0 00.211-.247V4a1 1 0 012 0v.625c0 .138.112.25.25.25H11a1 1 0 110 2H7.875C7 6.875 7 7.311 7 7.455a.9.9 0 00.183.612l3.37 1.26A2.55 2.55 0 0112 11.8a2.53 2.53 0 01-2.289 2.53.249.249 0 00-.211.247v.673a1 1 0 11-2 0v-.625a.25.25 0 00-.25-.25H6a1 1 0 110-2h3.125c.875 0 .875-.436.875-.58a.9.9 0 00-.183-.612zM19.25 15.5a.75.75 0 00-.75-.75h-5a.75.75 0 000 1.5h5a.75.75 0 00.75-.75zm-4.5-4.5a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm4.5 9a.75.75 0 00-.75-.75h-10a.75.75 0 000 1.5h10a.75.75 0 00.75-.75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $fa13c09b2be7da6a$var$__assign = undefined && undefined.__assign || function() {
    $fa13c09b2be7da6a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa13c09b2be7da6a$var$__assign.apply(this, arguments);
};
var $fa13c09b2be7da6a$export$4c2b5ab87db1a6be = $denZA.forwardRef(function AdvertisingMegaphone(props, svgRef) {
    return $denZA.createElement("svg", $fa13c09b2be7da6a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#advertising-megaphone_svg__advertising-megaphone_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M11.808.371a1.678 1.678 0 011.98-.092l.127.092 2.063 1.665 2.647-.131a1.678 1.678 0 011.659 1.097l.044.14.691 2.558 2.22 1.449c.617.403.894 1.155.7 1.853l-.049.149-.944 2.476.944 2.477a1.68 1.68 0 01-.525 1.912l-.127.092-2.219 1.444-.695 2.557a1.677 1.677 0 01-1.556 1.24h-.147l-2.648-.133-2.063 1.662a.75.75 0 01-.978-.032l-.076-.082a.75.75 0 01.033-.978l.08-.076 2.287-1.841a.75.75 0 01.398-.163l.11-.002 2.932.146a.177.177 0 00.161-.087l.02-.046.77-2.835a.75.75 0 01.228-.365l.087-.067 2.457-1.599a.18.18 0 00.08-.165l-.01-.048-1.046-2.743a.75.75 0 01-.031-.429l.031-.105 1.045-2.744a.178.178 0 00-.032-.18l-.037-.032L19.961 6.8a.75.75 0 01-.277-.329l-.037-.103-.767-2.834a.178.178 0 00-.132-.127l-.049-.004-2.932.146a.75.75 0 01-.418-.103l-.09-.062-2.286-1.845a.178.178 0 00-.17-.03l-.053.03-2.286 1.845a.75.75 0 01-.399.163l-.11.002L7.024 3.4a.178.178 0 00-.162.086l-.019.045-.767 2.834a.75.75 0 01-.227.365l-.087.067-2.457 1.605a.18.18 0 00-.08.164l.01.048 1.046 2.744a.75.75 0 01.031.43l-.031.104-.448 1.175A.75.75 0 012.4 12.63l.03-.097.346-.908-.944-2.478a1.68 1.68 0 01.524-1.91l.127-.091 2.22-1.449.691-2.558A1.678 1.678 0 016.952 1.9l.147.001 2.646.133L11.808.371z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.348 19.136a.75.75 0 01.724-.045l8.25-10.469-.047-.073a.75.75 0 011.2-.893l.066.09 5.963 9.393.011.018.32.504a.75.75 0 01-1.2.893l-.066-.09-.023-.035-5.19 1.623a3.013 3.013 0 01-1.09 3.448 2.79 2.79 0 01-3.86-.665l-.668-1.025-1.585.496a.75.75 0 01-1.314.563l-.066-.09-.32-.503-.011-.017-.994-1.566-.01-.018-.321-.504a.75.75 0 01.231-1.035zm4.498 1.068a.87.87 0 00-.027.008L2.4 20.97l-.4-.631 8.173-10.374 4.54 7.153-5.653 1.769a.653.653 0 00-.043.013l-4.171 1.305zm1.379 1.14l.347.535a1.291 1.291 0 001.828.396 1.51 1.51 0 00.526-1.775l-2.701.845z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "advertising-megaphone_svg__advertising-megaphone_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $9edbd8c0726c6630$var$__assign = undefined && undefined.__assign || function() {
    $9edbd8c0726c6630$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9edbd8c0726c6630$var$__assign.apply(this, arguments);
};
var $9edbd8c0726c6630$export$93d05658c51f49eb = $denZA.forwardRef(function AdvertisingMegaphoneBold(props, svgRef) {
    return $denZA.createElement("svg", $9edbd8c0726c6630$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.86 14.293l-2.077-3.561a.258.258 0 01-.033-.149l.32-4.154c.038-.49-.27-.936-.73-1.052l-3.885-.987a.242.242 0 01-.126-.081l-2.592-3.174a.934.934 0 00-1.23-.206l-3.418 2.163a.23.23 0 01-.144.035l-3.988-.334a.989.989 0 00-1.01.76L3.907 8c-.126.537.19 1.078.705 1.209.515.13 1.035-.198 1.16-.735l.798-3.407a.241.241 0 01.253-.189l3.36.281a.952.952 0 00.576-.143l2.88-1.82a.232.232 0 01.307.052l2.172 2.666c.131.16.307.273.503.323l3.271.831a.25.25 0 01.183.263l-.27 3.5c-.017.21.031.42.136.6l1.748 3a.26.26 0 01-.05.32l-2.564 2.263c-.154.137-.262.32-.31.525l-.798 3.406a.241.241 0 01-.252.19l-3.355-.281c-.529-.044-.992.366-1.034.917-.043.55.351 1.033.88 1.077l4.374.366h.079a.968.968 0 00.93-.762l.95-4.049a.25.25 0 01.077-.131l3.046-2.7a1.03 1.03 0 00.198-1.279z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.04 19.826a.517.517 0 01.03-.6L9.017 9.093a.257.257 0 00.015-.3l-.069-.106a.77.77 0 01.202-1.04.703.703 0 01.998.21l6.124 9.607a.77.77 0 01-.201 1.04.693.693 0 01-.398.125.715.715 0 01-.6-.335l-.076-.117a.234.234 0 00-.252-.1l-4.122.964a.24.24 0 00-.157.121.258.258 0 00-.018.203c.458 1.37-.136 2.88-1.386 3.52-1.25.64-2.761.208-3.522-1.006l-.576-.91a.234.234 0 00-.27-.1l-2.166.675a.47.47 0 01-.537-.2l-.967-1.518zm5.722 1.222a1.288 1.288 0 001.83.385c.532-.37.732-1.084.476-1.694a.238.238 0 00-.288-.139l-2.144.67a.246.246 0 00-.156.155.26.26 0 00.025.223l.257.4z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $8682a5aa73cd6e27$var$__assign = undefined && undefined.__assign || function() {
    $8682a5aa73cd6e27$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8682a5aa73cd6e27$var$__assign.apply(this, arguments);
};
var $8682a5aa73cd6e27$export$267633f7675997a1 = $denZA.forwardRef(function Agreement(props, svgRef) {
    return $denZA.createElement("svg", $8682a5aa73cd6e27$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.23 14.455h-2.022a.223.223 0 01-.223-.189V7.894a.223.223 0 01.223-.189h2.038A.76.76 0 0024 6.951c0-.41-.36-.753-.77-.753h-1.988a1.68 1.68 0 00-1.336.582l-4.368-1.593a3.12 3.12 0 00-2.45.137L10.672 6.54s-.017 0-.017-.017a2.863 2.863 0 00-1.696-.548c-.36 0-.72.069-1.062.206L4.454 7.568a1.708 1.708 0 00-1.679-1.353H.754A.735.735 0 000 6.95a.76.76 0 00.754.754h2.021c.103 0 .206.086.223.189v6.355a.243.243 0 00-.034.103.232.232 0 01-.189.103H.754a.76.76 0 00-.754.753.76.76 0 00.754.754h2.038c.531 0 1.028-.257 1.336-.65H5.79l3.272 3.665c.36.428.874.685 1.422.72h.154c.497 0 .977-.172 1.37-.514a2.14 2.14 0 00.703-1.268c.976.017 1.918-.548 2.295-1.508.018-.05.035-.102.052-.154h.051c.052 0 .086 0 .137-.017l4.66-.89c.308.36.77.582 1.285.582h2.038a.76.76 0 00.754-.754c0-.411-.343-.72-.754-.72zM13.755 6.66a1.56 1.56 0 011.268-.068l4.454 1.627v5.705l-2.365.445c.018-.103.035-.223.035-.325 0-.48-.154-.943-.446-1.337l-2.5-3.169.428-.137a.756.756 0 00.48-.942.756.756 0 00-.943-.48l-3.46 1.13c-.189.07-.412-.033-.497-.222a.406.406 0 01.188-.548l3.358-1.679zm-1.32 9.696l-.033-.017-.874-.874a.755.755 0 00-1.062 0 .755.755 0 000 1.063l.754.753v.309a.553.553 0 01-.206.445.564.564 0 01-.428.137.634.634 0 01-.411-.206L6.68 14.043a.764.764 0 00-.565-.256H4.488V9.16L8.48 7.568c.154-.068.325-.103.496-.103.052 0 .103 0 .155.017a1.9 1.9 0 001.456 3.135c.205 0 .394-.034.6-.102l1.524-.497 2.81 3.597c.085.12.136.274.136.428a.725.725 0 01-.205.514.697.697 0 01-.514.206h-.171l-1.25-1.25a.755.755 0 00-1.063 0 .755.755 0 000 1.062l1.2 1.199c0 .017-.018.051-.018.068-.206.48-.72.703-1.2.514z"
    }));
});



var $denZA = parcelRequire("denZA");
var $16244ebd5717e944$var$__assign = undefined && undefined.__assign || function() {
    $16244ebd5717e944$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16244ebd5717e944$var$__assign.apply(this, arguments);
};
var $16244ebd5717e944$export$dfd6c0dab96dd991 = $denZA.forwardRef(function AgreementBold(props, svgRef) {
    return $denZA.createElement("svg", $16244ebd5717e944$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M1 16.25h1.667a1.861 1.861 0 001.784-1.5c.033-.146.05-.295.049-.444V14a.25.25 0 01.25-.25H6a.5.5 0 01.373.167l3.59 4.023a.87.87 0 001.537-.561v-.318a.249.249 0 00-.073-.177l-.781-.78a.5.5 0 01.708-.708l.927.928.083.033a1.192 1.192 0 001.585-.764.249.249 0 00-.062-.249L12.646 14.1a.5.5 0 01.708-.708l1.28 1.281c.047.047.11.073.177.073H15a1 1 0 00.8-1.6l-2.874-3.678a.251.251 0 00-.276-.083l-1.56.515a1.686 1.686 0 01-1.8-2.712.251.251 0 00-.154-.413 1.668 1.668 0 00-.838.1L4.843 8.252A.25.25 0 014.5 8.02v-.326c0-.124-.011-.247-.034-.369a1.867 1.867 0 00-1.8-1.575H1a1 1 0 00-1 1v8.5a1 1 0 001 1z"
    }), $denZA.createElement("path", {
        d: "M14.656 8.726l-.49.161a.25.25 0 00-.166.164.248.248 0 00.043.226l2.557 3.266a2.027 2.027 0 01.374 1.526.25.25 0 00.294.286l1.935-.368a.255.255 0 01.206.053.249.249 0 01.091.193v.073c0 .212.035.423.1.625.23.77.931 1.303 1.735 1.319H23a1 1 0 001-1v-8.5a1 1 0 00-1-1h-1.667a1.794 1.794 0 00-1.442.747 1.969 1.969 0 00-.319.659.252.252 0 01-.327.17l-4.015-1.46a1.95 1.95 0 00-1.518.087l-3.455 1.728a.686.686 0 00.52 1.265l3.567-1.171a.5.5 0 01.312.951z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d9d4d1d17997da95$var$__assign = undefined && undefined.__assign || function() {
    $d9d4d1d17997da95$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9d4d1d17997da95$var$__assign.apply(this, arguments);
};
var $d9d4d1d17997da95$export$caec2af78bcc877f = $denZA.forwardRef(function Alert(props, svgRef) {
    return $denZA.createElement("svg", $d9d4d1d17997da95$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M13.934 21.021a.73.73 0 00-.924.514 1.34 1.34 0 01-.908.907 1.297 1.297 0 01-1.01-.102 1.265 1.265 0 01-.633-.788.764.764 0 00-.924-.514.764.764 0 00-.514.925c.205.719.702 1.318 1.352 1.695.428.222.89.342 1.353.342.274 0 .53-.034.804-.12a2.836 2.836 0 001.918-1.917.76.76 0 00-.514-.942zm7.258-2.858c-.137-.172-1.232-1.73-1.232-7.67 0-4.296-3.304-7.823-7.498-8.2V.754A.76.76 0 0011.709 0a.76.76 0 00-.754.753v1.54c-4.176.395-7.463 3.921-7.463 8.2 0 5.872-1.335 7.772-1.335 7.772a.769.769 0 00-.086.788c.12.257.394.428.668.428h17.974c.342 0 .668-.189.753-.514.086-.308 0-.616-.274-.804zM3.937 17.99c.48-1.232 1.044-3.543 1.044-7.497 0-3.715 3.03-6.745 6.745-6.745 3.714 0 6.744 3.03 6.744 6.745 0 4.04.497 6.282.959 7.497H3.937z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f9a86f28517b5e7e$var$__assign = undefined && undefined.__assign || function() {
    $f9a86f28517b5e7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9a86f28517b5e7e$var$__assign.apply(this, arguments);
};
var $f9a86f28517b5e7e$export$b064d7839e1e373e = $denZA.forwardRef(function AlertBold(props, svgRef) {
    return $denZA.createElement("svg", $f9a86f28517b5e7e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.229 10.491c0-4.032-2.907-7.387-6.73-8.103V1.5a1.5 1.5 0 10-3 0v.879c-3.838.703-6.762 4.073-6.762 8.112 0 5.88-1.337 7.783-1.337 7.783a.77.77 0 00-.086.789c.12.257.394.428.669.428h18c.343 0 .668-.188.754-.514.086-.308 0-.617-.274-.806-.137-.171-1.235-1.731-1.235-7.68zM9.25 21.78c0-.326.21-.629.539-.729l4.405-.017c.395.12.635.532.515.943 0 0-.209 2.023-2.709 2.023s-2.726-2.023-2.726-2.023a.77.77 0 01-.025-.196z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6b440cd674145e5e$var$__assign = undefined && undefined.__assign || function() {
    $6b440cd674145e5e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b440cd674145e5e$var$__assign.apply(this, arguments);
};
var $6b440cd674145e5e$export$2b3af6baec22bd98 = $denZA.forwardRef(function Analytics(props, svgRef) {
    return $denZA.createElement("svg", $6b440cd674145e5e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.75 0a.75.75 0 01.75.75v9.175l4.545-2.727a2.25 2.25 0 114.448-.272l2.873 1.276.043-.043a2.25 2.25 0 012.33-.534l3.836-4.796a2.25 2.25 0 11.9 1.276L16.91 8.56a2.25 2.25 0 11-4.153 1.012L9.884 8.296a2.25 2.25 0 01-3.067.188L1.5 11.674v7.362l3.017-1.509A2.25 2.25 0 018.871 16.5h3.257a2.248 2.248 0 013.611-.936l3.76-2.089a2.25 2.25 0 11.5 1.439l-3.531 1.961a2.253 2.253 0 01-.627 1.966 2.25 2.25 0 01-3.713-.84H8.871a2.25 2.25 0 01-3.683.869L1.5 20.713v1.786h21.75a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0zM7.5 17.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM21.08 2.59l.017.03a.749.749 0 001.401-.37.75.75 0 10-1.418.34zM7.607 7.137l.003.006a.75.75 0 10-.007-.012l.004.006zm6.112 10.644a.75.75 0 111.06-1.06.75.75 0 01-1.06 1.06zm7.309-4.077a.75.75 0 101.444-.408.75.75 0 00-1.444.409zM14.469 9.22a.75.75 0 111.061 1.062.75.75 0 01-1.06-1.062z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $e7461021055d29f9$var$__assign = undefined && undefined.__assign || function() {
    $e7461021055d29f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e7461021055d29f9$var$__assign.apply(this, arguments);
};
var $e7461021055d29f9$export$c994623dcd067c12 = $denZA.forwardRef(function Announcement(props, svgRef) {
    return $denZA.createElement("svg", $e7461021055d29f9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21 3.75a.75.75 0 00-1.166-.624l-1.134.756A21.55 21.55 0 016.751 7.5H4.5a4.5 4.5 0 000 9h1.535a7.988 7.988 0 002.448 5.043.75.75 0 101.034-1.086 6.49 6.49 0 01-1.972-3.942A21.55 21.55 0 0118.7 20.118l1.134.756A.75.75 0 0021 20.25V3.75zM7.5 15.012a23.05 23.05 0 0112 3.837V5.15a23.05 23.05 0 01-12 3.837v6.024zM6 9H4.5a3 3 0 100 6H6V9z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M23.25 9.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $ee3220140ddb7cd0$var$__assign = undefined && undefined.__assign || function() {
    $ee3220140ddb7cd0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ee3220140ddb7cd0$var$__assign.apply(this, arguments);
};
var $ee3220140ddb7cd0$export$4c30be745f22bee4 = $denZA.forwardRef(function AnnouncementBold(props, svgRef) {
    return $denZA.createElement("svg", $ee3220140ddb7cd0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.604 2.589A.75.75 0 0121 3.25v16.5a.75.75 0 01-1.166.624l-1.134-.756a21.55 21.55 0 00-11.155-3.603 6.49 6.49 0 001.972 3.942.75.75 0 11-1.034 1.086A7.988 7.988 0 016.035 16V7h.716c4.253 0 8.41-1.26 11.95-3.618l1.133-.756a.75.75 0 01.77-.037zM1.318 8.318A4.5 4.5 0 014.5 7v9a4.5 4.5 0 01-3.182-7.682zm21.432.557c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z"
    }));
});



var $denZA = parcelRequire("denZA");
var $a80fc6ca0fd09b79$var$__assign = undefined && undefined.__assign || function() {
    $a80fc6ca0fd09b79$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a80fc6ca0fd09b79$var$__assign.apply(this, arguments);
};
var $a80fc6ca0fd09b79$export$1fa5a43af950a186 = $denZA.forwardRef(function ArrowDown(props, svgRef) {
    return $denZA.createElement("svg", $a80fc6ca0fd09b79$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.445 6.495a.75.75 0 011.06-.05L12 15.986l10.495-9.541a.75.75 0 011.01 1.11l-11 10a.75.75 0 01-1.01 0l-11-10a.75.75 0 01-.05-1.06z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $4d7ab6c910052729$var$__assign = undefined && undefined.__assign || function() {
    $4d7ab6c910052729$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d7ab6c910052729$var$__assign.apply(this, arguments);
};
var $4d7ab6c910052729$export$2fbb36af09846aa0 = $denZA.forwardRef(function ArrowDownBold(props, svgRef) {
    return $denZA.createElement("svg", $4d7ab6c910052729$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M2.506 6.388A1.5 1.5 0 00.494 8.612l10.5 9.5a1.5 1.5 0 002.012 0l10.5-9.5a1.5 1.5 0 00-2.012-2.224L12 14.978l-9.494-8.59z"
    }));
});



var $denZA = parcelRequire("denZA");
var $11260efa4dda2d08$var$__assign = undefined && undefined.__assign || function() {
    $11260efa4dda2d08$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $11260efa4dda2d08$var$__assign.apply(this, arguments);
};
var $11260efa4dda2d08$export$e4c291d45fea4cd0 = $denZA.forwardRef(function ArrowLeft(props, svgRef) {
    return $denZA.createElement("svg", $11260efa4dda2d08$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M17.505.445a.75.75 0 01.05 1.06L8.014 12l9.541 10.495a.75.75 0 01-1.11 1.01l-10-11a.75.75 0 010-1.01l10-11a.75.75 0 011.06-.05z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $2afa648b8e417cf2$var$__assign = undefined && undefined.__assign || function() {
    $2afa648b8e417cf2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2afa648b8e417cf2$var$__assign.apply(this, arguments);
};
var $2afa648b8e417cf2$export$ea9a5c7ec18f8eaf = $denZA.forwardRef(function ArrowLeftBold(props, svgRef) {
    return $denZA.createElement("svg", $2afa648b8e417cf2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M17.506.388a1.5 1.5 0 01.106 2.118L9.022 12l8.59 9.494a1.5 1.5 0 01-2.224 2.012l-9.5-10.5a1.5 1.5 0 010-2.012l9.5-10.5a1.5 1.5 0 012.118-.106z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $e021565b6cf5cb0c$var$__assign = undefined && undefined.__assign || function() {
    $e021565b6cf5cb0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e021565b6cf5cb0c$var$__assign.apply(this, arguments);
};
var $e021565b6cf5cb0c$export$fb2824d245253d9b = $denZA.forwardRef(function ArrowLongDown(props, svgRef) {
    return $denZA.createElement("svg", $e021565b6cf5cb0c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a.75.75 0 01.75.75v19.305l6.747-6.132a.75.75 0 011.009 1.11l-8.002 7.272a.75.75 0 01-1.008 0l-8-7.27a.75.75 0 111.008-1.11l6.746 6.13V1.5A.75.75 0 0112 .75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $59f86aa046643b08$var$__assign = undefined && undefined.__assign || function() {
    $59f86aa046643b08$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $59f86aa046643b08$var$__assign.apply(this, arguments);
};
var $59f86aa046643b08$export$a2ec4c6969a7d302 = $denZA.forwardRef(function ArrowLongDownBold(props, svgRef) {
    return $denZA.createElement("svg", $59f86aa046643b08$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a1.5 1.5 0 011.5 1.5v17.61l5.493-4.992a1.5 1.5 0 012.017 2.22l-8 7.272a1.5 1.5 0 01-2.018 0l-8-7.27a1.5 1.5 0 012.018-2.22l5.491 4.99V1.5A1.5 1.5 0 0112 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $96862bc6d3c4d84b$var$__assign = undefined && undefined.__assign || function() {
    $96862bc6d3c4d84b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96862bc6d3c4d84b$var$__assign.apply(this, arguments);
};
var $96862bc6d3c4d84b$export$5e0a9a0faf09e20c = $denZA.forwardRef(function ArrowLongUp(props, svgRef) {
    return $denZA.createElement("svg", $96862bc6d3c4d84b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.496.945a.75.75 0 011.008 0l8.002 7.272a.75.75 0 11-1.009 1.11L12.75 3.195V22.5a.75.75 0 01-1.5 0V3.195l-6.746 6.13a.75.75 0 01-1.008-1.11l8-7.27z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $7ff59cb23884fbb1$var$__assign = undefined && undefined.__assign || function() {
    $7ff59cb23884fbb1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ff59cb23884fbb1$var$__assign.apply(this, arguments);
};
var $7ff59cb23884fbb1$export$469287007f7d4034 = $denZA.forwardRef(function ArrowLongUpBold(props, svgRef) {
    return $denZA.createElement("svg", $7ff59cb23884fbb1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.991.39a1.5 1.5 0 012.018 0l8.001 7.272a1.5 1.5 0 01-2.017 2.22L13.5 4.89V22.5a1.5 1.5 0 01-3 0V4.89L5.009 9.88A1.5 1.5 0 012.99 7.66l8-7.27z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $045005454ae4104a$var$__assign = undefined && undefined.__assign || function() {
    $045005454ae4104a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $045005454ae4104a$var$__assign.apply(this, arguments);
};
var $045005454ae4104a$export$acad20503ad73ac1 = $denZA.forwardRef(function ArrowRight(props, svgRef) {
    return $denZA.createElement("svg", $045005454ae4104a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.495.445a.75.75 0 011.06.05l10 11a.75.75 0 010 1.01l-10 11a.75.75 0 11-1.11-1.01L15.986 12 6.445 1.505a.75.75 0 01.05-1.06z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $c3105185e735c6e9$var$__assign = undefined && undefined.__assign || function() {
    $c3105185e735c6e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3105185e735c6e9$var$__assign.apply(this, arguments);
};
var $c3105185e735c6e9$export$d6d021d74f4bac76 = $denZA.forwardRef(function ArrowRightBold(props, svgRef) {
    return $denZA.createElement("svg", $c3105185e735c6e9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M8.612.494a1.5 1.5 0 00-2.224 2.012L14.978 12l-8.59 9.494a1.5 1.5 0 002.224 2.012l9.5-10.5a1.5 1.5 0 000-2.012l-9.5-10.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $dac9d16518033d8e$var$__assign = undefined && undefined.__assign || function() {
    $dac9d16518033d8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dac9d16518033d8e$var$__assign.apply(this, arguments);
};
var $dac9d16518033d8e$export$2624c5890f1bbcf7 = $denZA.forwardRef(function ArrowUp(props, svgRef) {
    return $denZA.createElement("svg", $dac9d16518033d8e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.495 6.445a.75.75 0 011.01 0l11 10a.75.75 0 01-1.01 1.11L12 8.014 1.505 17.555a.75.75 0 01-1.01-1.11l11-10z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $4d1d1d05aab0b4ea$var$__assign = undefined && undefined.__assign || function() {
    $4d1d1d05aab0b4ea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d1d1d05aab0b4ea$var$__assign.apply(this, arguments);
};
var $4d1d1d05aab0b4ea$export$b524ae00c198b715 = $denZA.forwardRef(function ArrowUpAndDown(props, svgRef) {
    return $denZA.createElement("svg", $4d1d1d05aab0b4ea$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.526 1.466a.75.75 0 00-1.052 0l-6.6 6.5a.75.75 0 101.052 1.068L12 3.053l6.074 5.981a.75.75 0 101.052-1.068l-6.6-6.5zm-6.6 13.5a.75.75 0 00-1.052 1.068l6.6 6.5a.75.75 0 001.052 0l6.6-6.5a.75.75 0 00-1.052-1.068L12 20.947l-6.074-5.981z"
    }));
});



var $denZA = parcelRequire("denZA");
var $dea1de70a494ae92$var$__assign = undefined && undefined.__assign || function() {
    $dea1de70a494ae92$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dea1de70a494ae92$var$__assign.apply(this, arguments);
};
var $dea1de70a494ae92$export$61bdb2a1da0ccc8a = $denZA.forwardRef(function ArrowUpAndDownBold(props, svgRef) {
    return $denZA.createElement("svg", $dea1de70a494ae92$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M13.053.931a1.5 1.5 0 00-2.106 0l-6.6 6.5A1.5 1.5 0 006.453 9.57L12 4.105l5.547 5.464a1.5 1.5 0 102.106-2.138l-6.6-6.5zm-6.6 13.5a1.5 1.5 0 10-2.106 2.138l6.6 6.5a1.5 1.5 0 002.106 0l6.6-6.5a1.5 1.5 0 00-2.105-2.138L12 19.895 6.453 14.43z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8f973e014f05500e$var$__assign = undefined && undefined.__assign || function() {
    $8f973e014f05500e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f973e014f05500e$var$__assign.apply(this, arguments);
};
var $8f973e014f05500e$export$928b9ecbfcbe86f4 = $denZA.forwardRef(function ArrowUpBold(props, svgRef) {
    return $denZA.createElement("svg", $8f973e014f05500e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.994 5.888a1.5 1.5 0 012.012 0l10.5 9.5a1.5 1.5 0 01-2.012 2.224L12 9.022l-9.494 8.59a1.5 1.5 0 11-2.012-2.224l10.5-9.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b94eea2085bb4e91$var$__assign = undefined && undefined.__assign || function() {
    $b94eea2085bb4e91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b94eea2085bb4e91$var$__assign.apply(this, arguments);
};
var $b94eea2085bb4e91$export$650e18e4b9cea8d1 = $denZA.forwardRef(function Attach(props, svgRef) {
    return $denZA.createElement("svg", $b94eea2085bb4e91$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M15.323 2.525c-.985.11-1.817.55-2.177.91l-8 8c-1.78 1.78-2.567 5.373 0 7.94 2.566 2.566 6.158 1.78 7.939 0l8-8a.75.75 0 011.06 1.06l-8 8c-2.22 2.22-6.771 3.289-10.06 0-3.29-3.29-2.22-7.841 0-10.06l8-8c.64-.64 1.807-1.2 3.072-1.34 1.296-.145 2.791.142 3.989 1.34 1.197 1.196 1.484 2.692 1.34 3.987-.141 1.265-.7 2.433-1.34 3.073l-8 8a3.07 3.07 0 01-1.722.824c-.755.098-1.61-.096-2.34-.824-.734-.735-.913-1.603-.811-2.356.097-.715.448-1.34.812-1.705l8-8a.75.75 0 111.06 1.06l-8 8c-.135.137-.333.462-.386.847-.047.348.023.73.387 1.093.369.37.748.441 1.085.397.374-.048.7-.242.854-.397l8-8c.36-.36.8-1.193.91-2.177.106-.955-.107-1.96-.91-2.762-.803-.803-1.807-1.016-2.762-.91z"
    }));
});



var $denZA = parcelRequire("denZA");
var $25e72a1229a5b7e2$var$__assign = undefined && undefined.__assign || function() {
    $25e72a1229a5b7e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25e72a1229a5b7e2$var$__assign.apply(this, arguments);
};
var $25e72a1229a5b7e2$export$50809d59c9e8104e = $denZA.forwardRef(function AttachBold(props, svgRef) {
    return $denZA.createElement("svg", $25e72a1229a5b7e2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M15.157 3.02c-.845.094-1.51.474-1.73.695l-8 8c-1.56 1.56-2.205 4.673 0 6.879 2.206 2.205 5.318 1.56 6.879 0l8-8a1.5 1.5 0 012.121 2.12l-8 8c-2.44 2.44-7.471 3.651-11.121 0-3.65-3.65-2.44-8.681 0-11.12l8-8c.779-.78 2.114-1.4 3.52-1.556 1.466-.162 3.207.161 4.601 1.556 1.394 1.394 1.718 3.135 1.555 4.6-.156 1.406-.776 2.742-1.555 3.521l-8 8a3.818 3.818 0 01-2.155 1.038c-.965.125-2.059-.13-2.966-1.038-.92-.92-1.155-2.032-1.025-2.987.12-.88.546-1.656 1.025-2.134l8-8a1.5 1.5 0 112.121 2.12l-8 8v.002a.93.93 0 00-.173.416.504.504 0 00.012.219.59.59 0 00.161.243.63.63 0 00.253.169.468.468 0 00.206.014.861.861 0 00.42-.183l8-8c.22-.221.6-.886.694-1.73.088-.785-.089-1.543-.694-2.15-.606-.605-1.365-.781-2.149-.694z"
    }));
});



var $denZA = parcelRequire("denZA");
var $efede261d0d60bee$var$__assign = undefined && undefined.__assign || function() {
    $efede261d0d60bee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efede261d0d60bee$var$__assign.apply(this, arguments);
};
var $efede261d0d60bee$export$67e8020d92d2196d = $denZA.forwardRef(function BarGraph(props, svgRef) {
    return $denZA.createElement("svg", $efede261d0d60bee$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.44 1.94a1.5 1.5 0 011.06-.44h3A1.5 1.5 0 0115 3v18h1.5V7.5A1.5 1.5 0 0118 6h3a1.5 1.5 0 011.5 1.5V21h.75a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h.75v-9A1.5 1.5 0 013 10.5h3A1.5 1.5 0 017.5 12v9H9V3c0-.398.158-.78.44-1.06zM21 21V7.5h-3V21h3zM10.5 3h3v18h-3V3zM6 21v-9H3v9h3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $0dfdb4117bbf2889$var$__assign = undefined && undefined.__assign || function() {
    $0dfdb4117bbf2889$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0dfdb4117bbf2889$var$__assign.apply(this, arguments);
};
var $0dfdb4117bbf2889$export$3f015ab66c3e5653 = $denZA.forwardRef(function Bluetooth(props, svgRef) {
    return $denZA.createElement("svg", $0dfdb4117bbf2889$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.287.076a.75.75 0 01.79.082l6.75 5.25a.75.75 0 01.054 1.138l-5.982 5.63 5.964 5.262a.75.75 0 01-.036 1.154l-6.75 5.25a.75.75 0 01-1.21-.592v-9.161L6.13 18.546a.75.75 0 11-1.028-1.092l5.57-5.243L5.12 7.312a.75.75 0 11.993-1.124l4.754 4.194V.75a.75.75 0 01.42-.674zm1.08 13.63l4.825 4.258-4.825 3.753v-8.01zm0-3.089V2.283l4.848 3.771-4.848 4.563z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $cf52e02b2ed56737$var$__assign = undefined && undefined.__assign || function() {
    $cf52e02b2ed56737$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf52e02b2ed56737$var$__assign.apply(this, arguments);
};
var $cf52e02b2ed56737$export$acd2cbead02af9c1 = $denZA.forwardRef(function BookmarkFavourite(props, svgRef) {
    return $denZA.createElement("svg", $cf52e02b2ed56737$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $64b48f3c21277eef$var$__assign = undefined && undefined.__assign || function() {
    $64b48f3c21277eef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64b48f3c21277eef$var$__assign.apply(this, arguments);
};
var $64b48f3c21277eef$export$cea5fccc97fad67f = $denZA.forwardRef(function BookmarkFavouriteBold(props, svgRef) {
    return $denZA.createElement("svg", $64b48f3c21277eef$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $71242a1e09b5ad87$var$__assign = undefined && undefined.__assign || function() {
    $71242a1e09b5ad87$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71242a1e09b5ad87$var$__assign.apply(this, arguments);
};
var $71242a1e09b5ad87$export$142047257e111cb6 = $denZA.forwardRef(function BookmarkFavouriteStar(props, svgRef) {
    return $denZA.createElement("svg", $71242a1e09b5ad87$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75zM12 4.715c.507 0 .97.285 1.199.736l1.039 2.047 1.65.001c.502-.012.965.26 1.202.694l.059.123a1.33 1.33 0 01-.298 1.468l-1.586 1.56.88 2.022a1.34 1.34 0 01-.249 1.424l-.102.1c-.432.38-1.058.44-1.548.156L12 13.778l-2.237 1.26a1.339 1.339 0 01-1.445-.064l-.111-.088a1.342 1.342 0 01-.348-1.533l.876-2.013-1.58-1.556a1.332 1.332 0 01-.349-1.344l.046-.128c.212-.506.713-.83 1.243-.817l1.667-.001 1.04-2.042c.208-.41.61-.684 1.062-.73L12 4.715zm-.001 1.688l-1.11 2.182a.75.75 0 01-.668.41L8.49 8.994l1.664 1.638a.75.75 0 01.2.726l-.038.108-.889 2.038 2.205-1.24a.75.75 0 01.636-.047l.1.048 2.203 1.242-.887-2.037a.75.75 0 01.086-.747l.076-.087 1.664-1.638-1.731.001a.75.75 0 01-.615-.32l-.054-.09L12 6.403z"
    }));
});



var $denZA = parcelRequire("denZA");
var $83da85ebf9e994c8$var$__assign = undefined && undefined.__assign || function() {
    $83da85ebf9e994c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83da85ebf9e994c8$var$__assign.apply(this, arguments);
};
var $83da85ebf9e994c8$export$848b7e76934f1777 = $denZA.forwardRef(function BookmarkFavouriteStarBold(props, svgRef) {
    return $denZA.createElement("svg", $83da85ebf9e994c8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21 2.25A2.25 2.25 0 0018.75 0H5.25A2.25 2.25 0 003 2.25V22.5a1.5 1.5 0 002.382 1.212l6.177-4.492a.75.75 0 01.882 0l6.177 4.492A1.5 1.5 0 0021 22.502V2.25zm-9.737 4.005c.232-.714 1.242-.714 1.474 0l.652 2.008c.004.01.013.017.024.017h2.111c.751 0 1.063.96.456 1.402l-1.708 1.24a.025.025 0 00-.01.029l.653 2.007c.232.714-.585 1.308-1.192.867l-1.708-1.241a.025.025 0 00-.03 0l-1.707 1.24c-.608.442-1.425-.152-1.193-.866l.652-2.007a.025.025 0 00-.009-.028L8.02 9.682c-.607-.441-.295-1.402.456-1.402h2.11a.026.026 0 00.025-.017l.652-2.008z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b5de50c18c59e586$var$__assign = undefined && undefined.__assign || function() {
    $b5de50c18c59e586$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5de50c18c59e586$var$__assign.apply(this, arguments);
};
var $b5de50c18c59e586$export$6262ca71fb4fada9 = $denZA.forwardRef(function BusinessDeal(props, svgRef) {
    return $denZA.createElement("svg", $b5de50c18c59e586$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#business-deal_svg__business-deal_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M4.626 14.25a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75zm0 1.5a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z"
    }), $denZA.createElement("path", {
        d: "M4.624 20.25a5.214 5.214 0 014.527 2.628.75.75 0 01-1.302.744 3.714 3.714 0 00-6.45 0 .75.75 0 01-1.302-.744 5.214 5.214 0 014.527-2.628zm14.75-6a3.375 3.375 0 100 6.75 3.375 3.375 0 000-6.75zm0 1.5a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z"
    }), $denZA.createElement("path", {
        d: "M19.374 20.25a5.214 5.214 0 014.527 2.628.75.75 0 01-1.302.744 3.714 3.714 0 00-6.45 0 .75.75 0 01-1.302-.744 5.214 5.214 0 014.527-2.628zM14.625 1.5a.75.75 0 01.102 1.493L14.625 3h-2.627c-.284 0-.528.2-.582.479a.602.602 0 00.24.606l.067.036 2.71.845a2.092 2.092 0 01-.612 4.028L13.655 9H10.5a.75.75 0 01-.102-1.493L10.5 7.5h3.156c.284 0 .528-.2.582-.48a.603.603 0 00-.239-.606l-.066-.036-2.71-.844a2.091 2.091 0 01.611-4.028L12 1.5h2.625z"
    }), $denZA.createElement("path", {
        d: "M12.75 0a.75.75 0 01.743.648L13.5.75v1.5a.75.75 0 01-1.493.102L12 2.25V.75a.75.75 0 01.75-.75zm0 7.5a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102L12 9.75v-1.5a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M8.25 0a.75.75 0 01.102 1.493L8.25 1.5h-3a.75.75 0 00-.743.648L4.5 2.25v8.25c0 .38.282.694.648.743l.102.007h6a.75.75 0 01.743.648L12 12v2.688l3.22-3.218a.75.75 0 01.412-.21l.118-.01h4.5a.75.75 0 00.743-.648L21 10.5V2.25a.75.75 0 00-.648-.743L20.25 1.5H18a.75.75 0 01-.102-1.493L18 0h2.25a2.25 2.25 0 012.245 2.096l.005.154v8.25a2.25 2.25 0 01-2.096 2.245l-.154.005h-4.19l-4.28 4.28a.75.75 0 01-1.273-.427L10.5 16.5v-3.75H5.25a2.25 2.25 0 01-2.245-2.096L3 10.5V2.25A2.25 2.25 0 015.096.005L5.25 0h3z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "business-deal_svg__business-deal_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $735891ac4f9a905f$var$__assign = undefined && undefined.__assign || function() {
    $735891ac4f9a905f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $735891ac4f9a905f$var$__assign.apply(this, arguments);
};
var $735891ac4f9a905f$export$1c86741c3cec44d4 = $denZA.forwardRef(function BusinessDealBold(props, svgRef) {
    return $denZA.createElement("svg", $735891ac4f9a905f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.63 16.08c0 1.458-1.231 2.64-2.75 2.64s-2.75-1.182-2.75-2.64c0-1.458 1.231-2.64 2.75-2.64s2.75 1.182 2.75 2.64zM.586 22.73a.232.232 0 00.039.213.254.254 0 00.201.097h8.108c.08 0 .154-.036.201-.097a.232.232 0 00.038-.213c-.577-1.812-2.32-3.05-4.293-3.05-1.974 0-3.716 1.238-4.294 3.05zm21.284-6.65c0 1.458-1.231 2.64-2.75 2.64s-2.75-1.182-2.75-2.64c0-1.458 1.231-2.64 2.75-2.64s2.75 1.182 2.75 2.64zm1.506 6.864a.231.231 0 00.038-.212c-.577-1.812-2.32-3.05-4.293-3.05-1.974 0-3.716 1.238-4.294 3.05a.233.233 0 00.038.213.254.254 0 00.201.097h8.11a.25.25 0 00.2-.098z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.5 10.08V1.44C3.5.645 4.172 0 5 0h14c.828 0 1.5.645 1.5 1.44v8.64c0 .795-.672 1.44-1.5 1.44h-3.689a.255.255 0 00-.177.067l-2.78 2.673a.51.51 0 01-.545.104.48.48 0 01-.309-.444v-2.16a.245.245 0 00-.25-.24H5c-.828 0-1.5-.645-1.5-1.44zm5.583-5.44c0 .934.777 1.698 1.75 1.72h2.334c.3 0 .542.233.542.52 0 .288-.243.52-.542.52h-3.5a.613.613 0 00-.625.6c0 .332.28.6.625.6h1.458c.066 0 .13.026.177.07a.234.234 0 01.073.17v.28c0 .331.28.6.625.6a.613.613 0 00.625-.6v-.28c0-.063.026-.124.073-.17a.255.255 0 01.177-.07h.292c.99 0 1.792-.77 1.792-1.72s-.802-1.72-1.792-1.72h-2.334a.53.53 0 01-.519-.52.53.53 0 01.52-.52h3.5a.613.613 0 00.624-.6c0-.331-.28-.6-.625-.6h-1.458a.245.245 0 01-.25-.24V2.4c0-.331-.28-.6-.625-.6a.613.613 0 00-.625.6v.28c0 .133-.112.24-.25.24h-.292c-.973.022-1.75.786-1.75 1.72z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $bf6f4986dfeb91b8$var$__assign = undefined && undefined.__assign || function() {
    $bf6f4986dfeb91b8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf6f4986dfeb91b8$var$__assign.apply(this, arguments);
};
var $bf6f4986dfeb91b8$export$77cdf53c363a3886 = $denZA.forwardRef(function CheckTick(props, svgRef) {
    return $denZA.createElement("svg", $bf6f4986dfeb91b8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.03 4.97a.75.75 0 010 1.06l-13 13a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l5.47 5.47L20.97 4.97a.75.75 0 011.06 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $6892ac9a89282880$var$__assign = undefined && undefined.__assign || function() {
    $6892ac9a89282880$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6892ac9a89282880$var$__assign.apply(this, arguments);
};
var $6892ac9a89282880$export$add807e002afa321 = $denZA.forwardRef(function CheckTickBold(props, svgRef) {
    return $denZA.createElement("svg", $6892ac9a89282880$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.56 4.44a1.5 1.5 0 010 2.12l-13 13a1.5 1.5 0 01-2.12 0l-6-6a1.5 1.5 0 012.12-2.12l4.94 4.939 11.94-11.94a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $63312bc3f3500ce1$var$__assign = undefined && undefined.__assign || function() {
    $63312bc3f3500ce1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63312bc3f3500ce1$var$__assign.apply(this, arguments);
};
var $63312bc3f3500ce1$export$105b96a34d430ab0 = $denZA.forwardRef(function CloudAvailable(props, svgRef) {
    return $denZA.createElement("svg", $63312bc3f3500ce1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M17.03 19.502H4.52c-1.5-.11-4.34-1.06-4.5-3.88a4.42 4.42 0 011.33-3.61 4.36 4.36 0 013-1.07 7.13 7.13 0 016.71-5.93c4.34-.21 6.31 2.34 6.88 3.75a5.77 5.77 0 013.36 1.32 5.25 5.25 0 011.72 4.18 4.849 4.849 0 01-1.7 3.66 6.25 6.25 0 01-4.29 1.58zm-11.51-7.23a.839.839 0 01-.69.21 3.605 3.605 0 00-.54 0 2.8 2.8 0 00-1.9.68 2.91 2.91 0 00-.87 2.38c.13 2.2 3 2.46 3.1 2.47h12.41a4.76 4.76 0 003.25-1.19 3.37 3.37 0 001.24-2.57 3.85 3.85 0 00-1.15-3 4.35 4.35 0 00-2.75-1 .9.9 0 01-1-.69s-1-3.28-5.49-3.06c-4.85.25-5.36 5.06-5.36 5.11a1.06 1.06 0 01-.25.66z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d244d2a4e641b62a$var$__assign = undefined && undefined.__assign || function() {
    $d244d2a4e641b62a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d244d2a4e641b62a$var$__assign.apply(this, arguments);
};
var $d244d2a4e641b62a$export$3a083cd204da2316 = $denZA.forwardRef(function CloudDownload(props, svgRef) {
    return $denZA.createElement("svg", $d244d2a4e641b62a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.254 11.808a.75.75 0 01.75.75v7.18l2.47-2.47a.75.75 0 011.06 1.06l-3.75 3.71a.75.75 0 01-.52.22.75.75 0 01-.49-.22l-3.8-3.71a.764.764 0 011.1-1.06l2.47 2.47v-7.18a.75.75 0 01.71-.75z"
    }), $denZA.createElement("path", {
        d: "M18.754 15.888a.75.75 0 01-.22-1.47c.13 0 3.14-1 3.14-4a4 4 0 00-3.48-4.12 1 1 0 01-.88-.65 5.22 5.22 0 00-5.49-3.16c-4.06.23-5 4-5.28 5.26a1.06 1.06 0 01-1 .86 2.79 2.79 0 00-3 2.74 2.54 2.54 0 00.58 2 3.82 3.82 0 002.42 1 .75.75 0 01.73.77.8.8 0 01-.76.73 5.31 5.31 0 01-3.49-1.47 4 4 0 01-1-3.11 4.21 4.21 0 014.13-4.09c1.29-4.84 4.28-6 6.58-6.14a6.79 6.79 0 016.85 3.84 5.48 5.48 0 014.58 5.58 5.86 5.86 0 01-4.21 5.39.731.731 0 01-.2.04z"
    }));
});



var $denZA = parcelRequire("denZA");
var $7bfd15ffd5fdd6e1$var$__assign = undefined && undefined.__assign || function() {
    $7bfd15ffd5fdd6e1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7bfd15ffd5fdd6e1$var$__assign.apply(this, arguments);
};
var $7bfd15ffd5fdd6e1$export$a41884c08973b4dc = $denZA.forwardRef(function CloudFolder(props, svgRef) {
    return $denZA.createElement("svg", $7bfd15ffd5fdd6e1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.098 15.882a.69.69 0 00-.53-.25h-2.06v-2a.68.68 0 00-.69-.68h-5.48v-.68a.68.68 0 00-.69-.68h-4.79a.678.678 0 00-.69.68v8.45c0 .409.15.803.42 1.11a1.73 1.73 0 001.38.59h10.54c.399.002.787-.132 1.1-.38a1.73 1.73 0 00.61-1l1-4.61a.68.68 0 00-.12-.55zm-13 5.13a.35.35 0 01-.15.05h-.11a.35.35 0 01-.21-.11.34.34 0 01-.08-.22v-7.82h3.43v.68a.68.68 0 00.69.68h5.48v1.36h-6.87a.68.68 0 00-.66.49l-1.4 4.7a.34.34 0 01-.15.19h.03zm10.81-.24a.37.37 0 01-.37.29h-8.97l1.22-4.08h8.92l-.8 3.79z"
    }), $denZA.createElement("path", {
        d: "M4.598 15.522a.76.76 0 01-.25 0 4.82 4.82 0 01-3.33-5c.25-2 1.77-3.34 4.08-3.58.41-1.67 1.49-5.56 6.32-5.91a6.61 6.61 0 016.62 3.74 6.13 6.13 0 015.09 4.48 4.89 4.89 0 01-2.62 5.37.776.776 0 01-.71-1.38c.09 0 2.38-1.27 1.82-3.63a4.57 4.57 0 00-3.71-3.29 1.28 1.28 0 01-1.17-.75 5 5 0 00-5.17-3c-3.85.28-4.66 3.29-4.98 4.74a1.45 1.45 0 01-1.28 1.1c-1.15.1-2.55.58-2.76 2.23-.3 2.42 2.19 3.33 2.3 3.37a.78.78 0 01-.25 1.51z"
    }));
});



var $denZA = parcelRequire("denZA");
var $da4f4763c9c9b4fc$var$__assign = undefined && undefined.__assign || function() {
    $da4f4763c9c9b4fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $da4f4763c9c9b4fc$var$__assign.apply(this, arguments);
};
var $da4f4763c9c9b4fc$export$c984feb5da8d9e3b = $denZA.forwardRef(function CloudUnavailable(props, svgRef) {
    return $denZA.createElement("svg", $da4f4763c9c9b4fc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M22.29 23.574a.748.748 0 01-.54-.23L1.21 2.144a.75.75 0 011.08-1l20.54 21.16a.75.75 0 01-.54 1.27zM6.1 19.294a6 6 0 01-3.8-1.27 3.8 3.8 0 01-1.28-2.8 4.11 4.11 0 011.12-3.25 4.87 4.87 0 013-1.24v-.36a.72.72 0 01.88-.7.75.75 0 01.72.78l-.06 1.1a1 1 0 01-.83.7 3.83 3.83 0 00-2.57.83 2.68 2.68 0 00-.71 2.14 2.33 2.33 0 00.74 1.72 4.71 4.71 0 003 .88h7.67a.75.75 0 010 1.5H6.1v-.03zm14.92-1.57a.74.74 0 01-.41-.12.75.75 0 01-.22-1s1.39-2.15.92-3.8a3.81 3.81 0 00-3.61-2.76h-.26a.849.849 0 01-.62-.5 5.13 5.13 0 00-6.86-3 .751.751 0 11-.57-1.39 6.54 6.54 0 018.63 3.37 5.16 5.16 0 014.71 3.82c.67 2.32-1 4.93-1.11 5a.75.75 0 01-.6.38z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c8d44437ef5094ba$var$__assign = undefined && undefined.__assign || function() {
    $c8d44437ef5094ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c8d44437ef5094ba$var$__assign.apply(this, arguments);
};
var $c8d44437ef5094ba$export$613a29ed35edc9c6 = $denZA.forwardRef(function CloudUpload(props, svgRef) {
    return $denZA.createElement("svg", $c8d44437ef5094ba$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.254 22.298a.75.75 0 00.75-.75v-7.19l2.47 2.47a.75.75 0 001.06-1.06l-3.75-3.73a.75.75 0 00-.52-.22.75.75 0 00-.49.22l-3.8 3.73a.764.764 0 101.1 1.06l2.47-2.47v7.18a.75.75 0 00.71.76z"
    }), $denZA.createElement("path", {
        d: "M18.754 15.888a.75.75 0 01-.22-1.47c.13 0 3.14-1 3.14-4a4 4 0 00-3.48-4.12 1 1 0 01-.88-.65 5.22 5.22 0 00-5.49-3.16c-4.06.23-5 4-5.28 5.26a1.06 1.06 0 01-1 .86 2.79 2.79 0 00-3 2.74 2.54 2.54 0 00.58 2 3.82 3.82 0 002.42 1 .75.75 0 01.73.77.8.8 0 01-.76.73 5.31 5.31 0 01-3.49-1.47 4 4 0 01-1-3.11 4.21 4.21 0 014.13-4.09c1.29-4.84 4.28-6 6.58-6.14a6.79 6.79 0 016.85 3.84 5.48 5.48 0 014.58 5.58 5.86 5.86 0 01-4.21 5.39.731.731 0 01-.2.04z"
    }));
});



var $denZA = parcelRequire("denZA");
var $03ee826cdb9ab5c7$var$__assign = undefined && undefined.__assign || function() {
    $03ee826cdb9ab5c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $03ee826cdb9ab5c7$var$__assign.apply(this, arguments);
};
var $03ee826cdb9ab5c7$export$163fa6932802c5a0 = $denZA.forwardRef(function CloudUploadDownload(props, svgRef) {
    return $denZA.createElement("svg", $03ee826cdb9ab5c7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M9.11 13.46v8.18a.71.71 0 101.41 0v-8.18l1.62 1.62a.71.71 0 101-1l-2.82-2.82a.7.7 0 00-.5-.26.7.7 0 00-.49.2L6.5 14.08a.71.71 0 001 1l1.61-1.62zm6.41-2.01a.71.71 0 01.71.71v8.18l1.62-1.62a.711.711 0 111 1L16 22.54a.7.7 0 01-.46.21.7.7 0 01-.49-.21l-2.82-2.82a.71.71 0 011-1l1.62 1.62v-8.18a.71.71 0 01.67-.71z"
    }), $denZA.createElement("path", {
        d: "M4.66 16.41h-.2C3.07 16 .58 14.52 1.14 11.58A4.34 4.34 0 015.13 8a7.73 7.73 0 012.46-4.45 6.84 6.84 0 018-.51 7.16 7.16 0 012.6 2.69 5.38 5.38 0 014.68 4.75A5.86 5.86 0 0120.1 16a.75.75 0 11-.77-1.29 4.36 4.36 0 002-4.06 4 4 0 00-3.66-3.48.94.94 0 01-.76-.55 5.49 5.49 0 00-2.14-2.31 5.41 5.41 0 00-6.22.36 6.35 6.35 0 00-2 4 .88.88 0 01-.86.78 3 3 0 00-3.07 2.39c-.43 2.26 2 3 2.25 3.07a.75.75 0 01-.2 1.47l-.01.03z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6c27742d84cb97e9$var$__assign = undefined && undefined.__assign || function() {
    $6c27742d84cb97e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c27742d84cb97e9$var$__assign.apply(this, arguments);
};
var $6c27742d84cb97e9$export$52f0f02147b12c03 = $denZA.forwardRef(function Code(props, svgRef) {
    return $denZA.createElement("svg", $6c27742d84cb97e9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.06 22.03H2.44A2.44 2.44 0 010 19.6V3.47A2.44 2.44 0 012.44 1h18.62a2.44 2.44 0 012.44 2.47V19.6a2.44 2.44 0 01-2.44 2.44v-.01zM2.44 2.47a.94.94 0 00-.94 1V19.6a.94.94 0 00.94.94h18.62a.939.939 0 00.94-.94V3.47a.94.94 0 00-.94-1H2.44z"
    }), $denZA.createElement("path", {
        d: "M22.75 5.63h-22v1.5h22v-1.5zM10.44 17.28a.75.75 0 01-.67-1.08l2.72-5.51a.751.751 0 011.35.66l-2.72 5.51a.75.75 0 01-.68.42zM7.28 17a.75.75 0 01-.5-.19l-2.26-2a1.74 1.74 0 010-2.44l2-2a.778.778 0 111.1 1.1l-2 2a.22.22 0 000 .31l2.2 1.93a.75.75 0 01-.5 1.31L7.28 17zm9.08.19a.75.75 0 01-.5-1.31l2.26-2a.291.291 0 00-.08-.25l-2-2a.75.75 0 011.05-1.07l2 2a1.73 1.73 0 01.08 2.37l-2.33 2.06a.75.75 0 01-.48.2z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c4069aff1a5dd295$var$__assign = undefined && undefined.__assign || function() {
    $c4069aff1a5dd295$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4069aff1a5dd295$var$__assign.apply(this, arguments);
};
var $c4069aff1a5dd295$export$6d7e986e2641be95 = $denZA.forwardRef(function CodeBold(props, svgRef) {
    return $denZA.createElement("svg", $c4069aff1a5dd295$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#code-bold_svg__code-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M21.39 23.28H2.76a2.69 2.69 0 01-2.68-2.69V4.44a2.69 2.69 0 012.68-2.69h18.63a2.69 2.69 0 012.69 2.69v16.15a2.69 2.69 0 01-2.69 2.69zM2.76 3.75a.68.68 0 00-.69.68v16.16a.69.69 0 00.69.69h18.63a.69.69 0 00.69-.69V4.44a.69.69 0 00-.69-.69H2.76z"
    }), $denZA.createElement("path", {
        d: "M1.08 7.38L1 22.28h22.08V7.38h-22zm7.28 10.53a1 1 0 01-1.41.09L4.6 15.92a2 2 0 01.09-2.72l2-2a1 1 0 011.628 1.096 1 1 0 01-.218.324l-2 2 2.15 1.9a1 1 0 01.11 1.39zm6-5.46L11.66 18a1 1 0 01-1.79-.88l2.72-5.51a1 1 0 111.79.88l-.02-.04zm5.32 3.65l-.09.09-2.26 2a1.003 1.003 0 01-1.33-1.5l2.17-1.92-2-2a1 1 0 011.41-1.42l2 2a2 2 0 01.12 2.76l-.02-.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "code-bold_svg__code-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $b56942f49f8b3ef3$var$__assign = undefined && undefined.__assign || function() {
    $b56942f49f8b3ef3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b56942f49f8b3ef3$var$__assign.apply(this, arguments);
};
var $b56942f49f8b3ef3$export$c7c44baae9d9f25f = $denZA.forwardRef(function Controls(props, svgRef) {
    return $denZA.createElement("svg", $b56942f49f8b3ef3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.246 0H.754A.761.761 0 000 .754v22.492c0 .411.343.754.754.754h22.492a.761.761 0 00.754-.754V.754A.761.761 0 0023.246 0zM1.509 22.491V1.51h21v20.98h-21z"
    }), $denZA.createElement("path", {
        d: "M5.246 16.491h2.348c.343 1.286 1.509 2.246 2.897 2.246a3 3 0 002.898-2.246h5.348a.76.76 0 00.754-.754.76.76 0 00-.754-.754h-5.331a2.919 2.919 0 00-.789-1.372 2.981 2.981 0 00-2.126-.874 3 3 0 00-2.897 2.246H5.246a.76.76 0 00-.755.754.76.76 0 00.755.754zm5.245-2.245c.395 0 .772.154 1.063.445.292.292.446.652.446 1.063a1.51 1.51 0 01-1.509 1.509 1.5 1.5 0 01-1.508-1.509c.017-.823.686-1.508 1.508-1.508zM5.246 9h8.348c.343 1.286 1.509 2.246 2.897 2.246 1.646 0 3-1.337 3-3 0-1.646-1.354-3-3-3a3 3 0 00-2.897 2.245H5.246a.761.761 0 00-.755.755c0 .411.343.754.755.754zM16.49 6.754c.823 0 1.509.669 1.509 1.492a1.51 1.51 0 01-1.509 1.508A1.496 1.496 0 0115 8.246c0-.823.669-1.492 1.491-1.492z"
    }));
});



var $denZA = parcelRequire("denZA");
var $655dba9cbe5df6d8$var$__assign = undefined && undefined.__assign || function() {
    $655dba9cbe5df6d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $655dba9cbe5df6d8$var$__assign.apply(this, arguments);
};
var $655dba9cbe5df6d8$export$281a0dedb095a201 = $denZA.forwardRef(function ControlsBold(props, svgRef) {
    return $denZA.createElement("svg", $655dba9cbe5df6d8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.754 0h22.492c.411 0 .754.343.754.754v22.492a.761.761 0 01-.754.754H.754A.761.761 0 010 23.246V.754C0 .343.343 0 .754 0zm12.652 7.241a3.25 3.25 0 013.085-2.245 3.264 3.264 0 013.25 3.25 3.253 3.253 0 01-3.25 3.25c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.455-1.005-1.004 0-.55.455-1.005 1.005-1.005h8.16zm-6 7.492a3.25 3.25 0 013.085-2.246c.87 0 1.688.334 2.3.946.383.366.645.818.801 1.3h5.145c.55 0 1.004.455 1.004 1.004a1.01 1.01 0 01-1.004 1.004h-5.16a3.25 3.25 0 01-3.086 2.246c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.454-1.005-1.004s.455-1.004 1.005-1.004h2.16z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $88a0171ecb792bad$var$__assign = undefined && undefined.__assign || function() {
    $88a0171ecb792bad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88a0171ecb792bad$var$__assign.apply(this, arguments);
};
var $88a0171ecb792bad$export$3c877bb842c36952 = $denZA.forwardRef(function Cross(props, svgRef) {
    return $denZA.createElement("svg", $88a0171ecb792bad$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M2.53 1.47a.75.75 0 00-1.06 1.06L10.94 12l-9.47 9.47a.75.75 0 101.06 1.06L12 13.06l9.47 9.47a.75.75 0 101.06-1.06L13.06 12l9.47-9.47a.75.75 0 00-1.06-1.06L12 10.94 2.53 1.47z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8fedfba03f19bbd3$var$__assign = undefined && undefined.__assign || function() {
    $8fedfba03f19bbd3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8fedfba03f19bbd3$var$__assign.apply(this, arguments);
};
var $8fedfba03f19bbd3$export$44fbda67c66d275 = $denZA.forwardRef(function CrossBold(props, svgRef) {
    return $denZA.createElement("svg", $8fedfba03f19bbd3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M3.06.94A1.5 1.5 0 10.94 3.06L9.878 12l-8.94 8.94a1.5 1.5 0 002.122 2.12L12 14.122l8.94 8.94a1.5 1.5 0 002.12-2.122L14.122 12l8.94-8.94A1.5 1.5 0 0020.939.94L12 9.878 3.06.939z"
    }));
});



var $denZA = parcelRequire("denZA");
var $4150faef6b2f0785$var$__assign = undefined && undefined.__assign || function() {
    $4150faef6b2f0785$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4150faef6b2f0785$var$__assign.apply(this, arguments);
};
var $4150faef6b2f0785$export$fe82a520fc33e5f4 = $denZA.forwardRef(function Dashboard(props, svgRef) {
    return $denZA.createElement("svg", $4150faef6b2f0785$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm-2 .5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm4-.5a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5zM15 0a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm7 1.5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM11 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4zm-2 .5H2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $1e342a116902d9e6$var$__assign = undefined && undefined.__assign || function() {
    $1e342a116902d9e6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e342a116902d9e6$var$__assign.apply(this, arguments);
};
var $1e342a116902d9e6$export$735b4219f406972d = $denZA.forwardRef(function DashboardBold(props, svgRef) {
    return $denZA.createElement("svg", $1e342a116902d9e6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm2 0a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-12a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm-4 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $62e41880483f4f9e$var$__assign = undefined && undefined.__assign || function() {
    $62e41880483f4f9e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $62e41880483f4f9e$var$__assign.apply(this, arguments);
};
var $62e41880483f4f9e$export$6feb5ea51a7b0b47 = $denZA.forwardRef(function Database(props, svgRef) {
    return $denZA.createElement("svg", $62e41880483f4f9e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.767 1.373C5.987.484 8.949 0 12 0c3.05 0 6.012.483 8.233 1.372 1.11.444 2.029.986 2.682 1.616C23.569 3.62 24 4.388 24 5.25v13.5c0 .894-.456 1.67-1.119 2.296-.66.626-1.577 1.154-2.648 1.582C18.09 23.486 15.177 24 12 24c-3.178 0-6.089-.514-8.233-1.372-1.07-.428-1.987-.956-2.648-1.582C.456 20.42 0 19.644 0 18.75V5.251c0-.863.43-1.63 1.085-2.262.653-.63 1.571-1.172 2.682-1.616zM1.5 14.625v4.125c0 .349.174.756.65 1.206.477.452 1.208.893 2.174 1.28C6.25 22.005 8.964 22.5 12 22.5c3.036 0 5.75-.494 7.676-1.265.966-.386 1.697-.827 2.175-1.279.476-.45.649-.857.649-1.206v-4.125c-.615.484-1.389.903-2.267 1.254-2.144.857-5.056 1.371-8.233 1.371-3.178 0-6.089-.514-8.233-1.372-.878-.35-1.652-.77-2.267-1.253zM1.5 12V7.874c.606.478 1.374.898 2.267 1.255 2.22.889 5.182 1.372 8.233 1.372 3.05 0 6.012-.483 8.233-1.372.893-.357 1.661-.777 2.267-1.255V12c0 .349-.174.757-.65 1.207-.477.451-1.208.893-2.174 1.279-1.927.77-4.64 1.264-7.676 1.264-3.035 0-5.75-.494-7.676-1.264-.966-.387-1.697-.828-2.175-1.28-.475-.45-.649-.857-.649-1.206zm.627-5.566c-.465-.45-.627-.852-.627-1.183 0-.33.162-.733.627-1.183.468-.451 1.197-.903 2.197-1.303C6.322 1.966 9.084 1.501 12 1.501c2.917 0 5.678.465 7.676 1.264 1 .4 1.73.852 2.197 1.303.465.45.627.852.627 1.183 0 .33-.162.733-.627 1.183-.468.45-1.197.903-2.197 1.303C17.678 8.536 14.916 9 12 9c-2.917 0-5.678-.465-7.676-1.264-1-.4-1.73-.852-2.197-1.303z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $06ce287fd87ec129$var$__assign = undefined && undefined.__assign || function() {
    $06ce287fd87ec129$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06ce287fd87ec129$var$__assign.apply(this, arguments);
};
var $06ce287fd87ec129$export$e457f953b131f785 = $denZA.forwardRef(function DatabaseBold(props, svgRef) {
    return $denZA.createElement("svg", $06ce287fd87ec129$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.5 17.034a.25.25 0 00-.408-.194C19.155 18.417 15.5 19.25 12 19.25c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716z"
    }), $denZA.createElement("path", {
        d: "M2.5 14.25c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716a.25.25 0 00-.408-.194C19.155 13.917 15.5 14.75 12 14.75c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716z"
    }), $denZA.createElement("path", {
        d: "M12 10.25c-3.5 0-7.156-.833-9.093-2.411a.249.249 0 00-.407.194V9.75c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4V8.034a.25.25 0 00-.408-.193C19.154 9.418 15.5 10.25 12 10.25z"
    }), $denZA.createElement("path", {
        d: "M21.5 5.25c0 2.21-4.253 4-9.5 4s-9.5-1.79-9.5-4 4.253-4 9.5-4 9.5 1.79 9.5 4z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9b6ea59c11b5353e$var$__assign = undefined && undefined.__assign || function() {
    $9b6ea59c11b5353e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b6ea59c11b5353e$var$__assign.apply(this, arguments);
};
var $9b6ea59c11b5353e$export$6341f9a885713487 = $denZA.forwardRef(function Date(props, svgRef) {
    return $denZA.createElement("svg", $9b6ea59c11b5353e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.427 3.813h-3.552V1.707A.713.713 0 0017.168 1a.713.713 0 00-.707.707v2.106H8.039V1.707A.713.713 0 007.332 1a.713.713 0 00-.707.707v2.106H3.073A2.078 2.078 0 001 5.886v15.557c0 1.14.932 2.073 2.073 2.073h18.354a2.078 2.078 0 002.073-2.073V5.886a2.078 2.078 0 00-2.073-2.074zM3.073 5.21h3.552v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h8.438v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h3.552c.37 0 .659.305.659.659v3.55H2.414V5.886c0-.37.29-.675.66-.675zm18.354 16.875H3.073a.662.662 0 01-.659-.66v-10.59h19.688v10.59a.676.676 0 01-.675.66z"
    }), $denZA.createElement("path", {
        d: "M6.271 15.063a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.049 2.812h-.097a1.066 1.066 0 00-.996 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.084 1.084 0 00-1.028-1.045zm5.93-2.812a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.048 2.812h-.112a1.066 1.066 0 00-.997 1.045 1.06 1.06 0 102.122 0c0-.563-.45-1.013-1.013-1.045zm5.995-4.918h-.097a1.058 1.058 0 00-1.012 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.081 1.081 0 00-1.012-1.045zm-.064 4.918h-.017c-.578 0-1.044.482-1.044 1.06 0 .58.466 1.061 1.06 1.061a1.05 1.05 0 001.061-1.06 1.07 1.07 0 00-1.06-1.061z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c1d40901e8de0a2e$var$__assign = undefined && undefined.__assign || function() {
    $c1d40901e8de0a2e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1d40901e8de0a2e$var$__assign.apply(this, arguments);
};
var $c1d40901e8de0a2e$export$6cbcb5cd862c2b93 = $denZA.forwardRef(function DateBold(props, svgRef) {
    return $denZA.createElement("svg", $c1d40901e8de0a2e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M6.271 12.566a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm5.979 0a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm6.054.016h-.128c-.75.043-1.367.646-1.367 1.42 0 .782.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.435v-.011a1.456 1.456 0 00-1.365-1.408h-.011zM6.33 17.5h-.128c-.74.044-1.35.67-1.35 1.42 0 .781.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.436v-.01A1.459 1.459 0 006.341 17.5h-.01zm5.979 0h-.145c-.74.044-1.35.67-1.35 1.42a1.435 1.435 0 102.872 0c0-.774-.618-1.377-1.366-1.42h-.011zm5.903 0c-.793 0-1.42.657-1.42 1.436 0 .782.631 1.435 1.437 1.435.801 0 1.435-.634 1.435-1.435 0-.786-.65-1.436-1.435-1.436h-.017z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.332.625c-.593 0-1.082.49-1.082 1.082v1.73H3.073A2.453 2.453 0 00.625 5.886v15.557c0 1.348 1.1 2.448 2.448 2.448h18.354c1.348 0 2.448-1.1 2.448-2.448V5.886c0-1.348-1.1-2.449-2.448-2.449H18.25v-1.73c0-.593-.49-1.082-1.082-1.082-.593 0-1.082.49-1.082 1.082v1.73H8.414v-1.73c0-.593-.489-1.082-1.082-1.082zM2.79 21.427V11.21h18.938v10.206a.3.3 0 01-.3.294H3.073a.287.287 0 01-.284-.284z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $6aa7e8776e67a2c8$var$__assign = undefined && undefined.__assign || function() {
    $6aa7e8776e67a2c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6aa7e8776e67a2c8$var$__assign.apply(this, arguments);
};
var $6aa7e8776e67a2c8$export$bfadae053a633538 = $denZA.forwardRef(function Delete(props, svgRef) {
    return $denZA.createElement("svg", $6aa7e8776e67a2c8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M9.827 10.077a.75.75 0 01.75.75v6.461a.75.75 0 01-1.5 0v-6.461a.75.75 0 01.75-.75zm5.596.75a.75.75 0 00-1.5 0v6.461a.75.75 0 001.5 0v-6.461z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.827 2A2.365 2.365 0 007.46 4.365v.866H1.75a.75.75 0 000 1.5h2.481v13.788a2.365 2.365 0 002.365 2.366h11.308a2.365 2.365 0 002.365-2.366V6.731h2.481a.75.75 0 000-1.5h-5.712v-.866A2.365 2.365 0 0014.673 2H9.827zM8.198 6.73h8.09a.74.74 0 00.014 0h2.467v13.79a.866.866 0 01-.865.864H6.596a.865.865 0 01-.865-.865V6.731h2.467zm7.34-1.5v-.865a.865.865 0 00-.865-.865H9.827a.865.865 0 00-.866.865v.866h6.577z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $c1c67c05a0d6134e$var$__assign = undefined && undefined.__assign || function() {
    $c1c67c05a0d6134e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1c67c05a0d6134e$var$__assign.apply(this, arguments);
};
var $c1c67c05a0d6134e$export$8d5b5b936cb45ab2 = $denZA.forwardRef(function DeleteBold(props, svgRef) {
    return $denZA.createElement("svg", $c1c67c05a0d6134e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.577 1A3.115 3.115 0 006.46 4.115v.116H1.5a1.5 1.5 0 000 3h1.731v13.038a3.116 3.116 0 003.115 3.116h11.308a3.115 3.115 0 003.115-3.116V7.231H22.5a1.5 1.5 0 000-3h-4.962v-.116A3.116 3.116 0 0014.423 1H9.577zm0 8.077a1.5 1.5 0 011.5 1.5v6.461a1.5 1.5 0 01-3 0v-6.461a1.5 1.5 0 011.5-1.5zm6.346 1.5a1.5 1.5 0 10-3 0v6.461a1.5 1.5 0 003 0v-6.461z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $9fd8c171e11e984d$var$__assign = undefined && undefined.__assign || function() {
    $9fd8c171e11e984d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9fd8c171e11e984d$var$__assign.apply(this, arguments);
};
var $9fd8c171e11e984d$export$92da3e5df6c76b76 = $denZA.forwardRef(function DevicesExternalScreen(props, svgRef) {
    return $denZA.createElement("svg", $9fd8c171e11e984d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.746 2A.746.746 0 000 2.746v14.92c0 .413.334.747.746.747h5.853a10.296 10.296 0 00-2.703 2.375.746.746 0 001.166.932 8.804 8.804 0 016.715-3.307h.325a8.802 8.802 0 016.715 3.307.746.746 0 101.166-.932 10.296 10.296 0 00-2.703-2.375h5.847a.746.746 0 00.746-.746V2.746A.746.746 0 0023.127 2H.746zm11.37 14.92H22.38V3.493H1.492v13.429h10.272a10.291 10.291 0 01.351 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $2d1eecf6352e5b9a$var$__assign = undefined && undefined.__assign || function() {
    $2d1eecf6352e5b9a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2d1eecf6352e5b9a$var$__assign.apply(this, arguments);
};
var $2d1eecf6352e5b9a$export$2ab1c2ba66a64865 = $denZA.forwardRef(function DevicesLaptop(props, svgRef) {
    return $denZA.createElement("svg", $2d1eecf6352e5b9a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.211 18.925l-2.005-4.378V5.19a2.197 2.197 0 00-2.19-2.189H4.396a2.2 2.2 0 00-2.206 2.19v9.34L.184 18.91a2.48 2.48 0 00-.184.902c0 .585.234 1.136.635 1.554.401.418.97.635 1.554.635h19.017c.3 0 .601-.067.886-.184a2.124 2.124 0 001.152-1.22 2.15 2.15 0 00-.033-1.67zM3.66 5.19c0-.401.334-.735.735-.735h14.622c.4 0 .735.334.735.735v8.773H3.66V5.19zm18.23 14.89a.653.653 0 01-.383.4c-.1.034-.2.067-.301.067H2.189a.733.733 0 01-.518-.217.733.733 0 01-.217-.518c0-.1.017-.2.067-.284l1.871-4.094h16.61l1.872 4.094a.78.78 0 01.017.551z"
    }), $denZA.createElement("path", {
        d: "M13.168 17.622h-2.924a.742.742 0 00-.736.735c0 .401.335.735.736.735h2.924a.742.742 0 00.735-.735.742.742 0 00-.735-.735z"
    }));
});



var $denZA = parcelRequire("denZA");
var $ce62cdd30fb9941d$var$__assign = undefined && undefined.__assign || function() {
    $ce62cdd30fb9941d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce62cdd30fb9941d$var$__assign.apply(this, arguments);
};
var $ce62cdd30fb9941d$export$13ffd9e444ebb4d9 = $denZA.forwardRef(function DevicesResponsiveWebSite(props, svgRef) {
    return $denZA.createElement("svg", $ce62cdd30fb9941d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h7.5A.75.75 0 019 .75v12a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-12zm1.5 9.75V12h6v-1.5h-6zm6-1.5h-6V1.5h6V9z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.5 5.25a.75.75 0 01.75-.75h10.5A2.25 2.25 0 0124 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-5.115l.5 3h1.615a.75.75 0 010 1.5H8.25a.75.75 0 010-1.5h1.615l.5-3H5.25A2.25 2.25 0 013 17.25v-1.5a.75.75 0 01.75-.75H22.5V6.75a.75.75 0 00-.75-.75h-10.5a.75.75 0 01-.75-.75zm12 11.25h-18v.75a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75v-.75zm-10.615 3h3.23l.5 3h-4.23l.5-3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $aa680070abab02fd$var$__assign = undefined && undefined.__assign || function() {
    $aa680070abab02fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa680070abab02fd$var$__assign.apply(this, arguments);
};
var $aa680070abab02fd$export$9924e86c6f4ee998 = $denZA.forwardRef(function DevicesSmartWatch(props, svgRef) {
    return $denZA.createElement("svg", $aa680070abab02fd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.373 4.488h-.994l-.428-2.62A2.26 2.26 0 0014.724 0H9.773a2.23 2.23 0 00-2.21 1.867l-.428 2.621H6.14c-1.18 0-2.14.96-2.14 2.124V17.37c0 1.165.96 2.125 2.124 2.125h.994l.428 2.62A2.242 2.242 0 009.756 24h4.95a2.229 2.229 0 002.21-1.884l.429-2.621h.993c1.165 0 2.124-.96 2.124-2.125V6.612a2.095 2.095 0 00-2.09-2.124zM9.019 2.124a.752.752 0 01.737-.617h4.95c.36 0 .686.257.737.617l.394 2.381H8.625l.394-2.38zM15.46 21.86a.766.766 0 01-.736.633H9.773a.738.738 0 01-.737-.633l-.41-2.364h7.228l-.394 2.364zm3.53-4.489a.614.614 0 01-.617.617H6.124a.614.614 0 01-.617-.617V6.612c0-.342.275-.616.617-.616h12.249c.342 0 .616.274.616.616V17.37z"
    }), $denZA.createElement("path", {
        d: "M12.24 13.122a1.508 1.508 0 100-3.015 1.508 1.508 0 000 3.015zm-1.867-2.998a1.13 1.13 0 001.13-1.13c0-.634-.497-1.131-1.13-1.131-.634 0-1.131.497-1.131 1.13a1.13 1.13 0 001.13 1.131zm-.377 1.867a1.13 1.13 0 00-1.13-1.13 1.12 1.12 0 00-1.132 1.13 1.13 1.13 0 102.262 0zm5.619-1.131a1.13 1.13 0 100 2.262c.633 0 1.13-.497 1.13-1.13a1.14 1.14 0 00-1.13-1.131zm-1.491-.736a1.13 1.13 0 001.13-1.13c0-.634-.496-1.131-1.13-1.131-.634 0-1.13.497-1.13 1.13 0 .634.496 1.131 1.13 1.131zm-3.751 3.735a1.13 1.13 0 00-1.131 1.13c0 .634.497 1.13 1.13 1.13.634 0 1.131-.496 1.131-1.13a1.13 1.13 0 00-1.13-1.13zm3.751 0a1.13 1.13 0 00-1.13 1.13c0 .634.496 1.13 1.13 1.13.634 0 1.13-.496 1.13-1.13a1.13 1.13 0 00-1.13-1.13z"
    }));
});



var $denZA = parcelRequire("denZA");
var $07981fd1996b3d32$var$__assign = undefined && undefined.__assign || function() {
    $07981fd1996b3d32$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $07981fd1996b3d32$var$__assign.apply(this, arguments);
};
var $07981fd1996b3d32$export$dd6647a8feb33032 = $denZA.forwardRef(function DevicesSmileyBold(props, svgRef) {
    return $denZA.createElement("svg", $07981fd1996b3d32$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.53 20l-2-5H2.27L.45 19.85a2.29 2.29 0 002.13 3.26h19A2.19 2.19 0 0023.53 20zm-9.45 0h-3.92a1 1 0 110-2h3.92a1 1 0 110 2z"
    }), $denZA.createElement("path", {
        d: "M21.65 15.37H2.27V3.46A2.66 2.66 0 015 .89h13.92a2.66 2.66 0 012.74 2.58l-.01 11.9zM4.09 13.66h15.75V3.46a.9.9 0 00-.93-.87H5a.9.9 0 00-.93.87l.02 10.2z"
    }), $denZA.createElement("path", {
        d: "M9.7 7.52a1 1 0 01-1-1V5.24a1 1 0 112 0v1.28a1 1 0 01-1 1zm4.38 0a1 1 0 01-1-1V5.24a1 1 0 012 0v1.28a1 1 0 01-1 1zM11.5 12c-1.66-.1-2.846-.62-4.25-1.51a1 1 0 011.09-1.66A8.23 8.23 0 0012 10a8.16 8.16 0 003.59-1.2 1.001 1.001 0 011.09 1.68c-1.41.885-2.518 1.407-4.18 1.52h-1z"
    }));
});



var $denZA = parcelRequire("denZA");
var $0ee3a0751be5d19c$var$__assign = undefined && undefined.__assign || function() {
    $0ee3a0751be5d19c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0ee3a0751be5d19c$var$__assign.apply(this, arguments);
};
var $0ee3a0751be5d19c$export$86ae6e8ac17a67c6 = $denZA.forwardRef(function Directions(props, svgRef) {
    return $denZA.createElement("svg", $0ee3a0751be5d19c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.28 4.183l-2.47-2.469a.752.752 0 00-.531-.223h-8.246V.754A.761.761 0 0011.28 0a.761.761 0 00-.754.754v.755H3.788a.761.761 0 00-.754.754v6c0 .411.343.754.754.754h6.755v1.509H3.788a.752.752 0 00-.53.223l-2.47 2.434a1.493 1.493 0 000 2.126l2.47 2.468a.752.752 0 00.53.223h6.755v5.246c0 .411.343.754.754.754a.761.761 0 00.754-.754V18h8.246a.761.761 0 00.754-.754v-6a.761.761 0 00-.754-.755h-8.263V8.983h8.246a.752.752 0 00.531-.223l2.469-2.469c.583-.565.583-1.525 0-2.108zM19.526 16.49H4.097l-2.246-2.245L4.097 12h15.446v4.491h-.017zm2.691-11.245L19.971 7.49H4.526V3H19.97l2.246 2.246z"
    }));
});



var $denZA = parcelRequire("denZA");
var $5901d307601c0f4c$var$__assign = undefined && undefined.__assign || function() {
    $5901d307601c0f4c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5901d307601c0f4c$var$__assign.apply(this, arguments);
};
var $5901d307601c0f4c$export$8871f210e34a6755 = $denZA.forwardRef(function DirectionsBold(props, svgRef) {
    return $denZA.createElement("svg", $5901d307601c0f4c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.811 1.714l2.469 2.469c.583.583.583 1.543 0 2.108L20.81 8.76a.752.752 0 01-.531.223h-7.53v1.508h7.547a.76.76 0 01.754.755v6a.761.761 0 01-.754.754H12.75v4.5a1.5 1.5 0 01-3 0V18H3.788a.752.752 0 01-.53-.223L.787 15.31a1.493 1.493 0 010-2.126l2.47-2.434a.752.752 0 01.53-.223H9.75v-1.51H3.788a.761.761 0 01-.754-.754v-6a.76.76 0 01.754-.754H9.75V1.5a1.5 1.5 0 013-.009h7.53c.206 0 .394.086.531.223z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f2fc154f4773ff6a$var$__assign = undefined && undefined.__assign || function() {
    $f2fc154f4773ff6a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2fc154f4773ff6a$var$__assign.apply(this, arguments);
};
var $f2fc154f4773ff6a$export$5f0fddd75cd8dcd7 = $denZA.forwardRef(function Discount(props, svgRef) {
    return $denZA.createElement("svg", $f2fc154f4773ff6a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5 1.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm13.5 12a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm3.226-14.03a.75.75 0 00-1.06 0L1.22 21.312l-.067.076a.75.75 0 001.127.984L21.726 3.28l.067-.076a.75.75 0 00-.067-.984z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $5c3ae843a658fb0d$var$__assign = undefined && undefined.__assign || function() {
    $5c3ae843a658fb0d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c3ae843a658fb0d$var$__assign.apply(this, arguments);
};
var $5c3ae843a658fb0d$export$f4dcdf7799f12754 = $denZA.forwardRef(function DiscountBold(props, svgRef) {
    return $denZA.createElement("svg", $5c3ae843a658fb0d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.255 1.973a1.75 1.75 0 00-2.475-.035l-18 17.5a1.75 1.75 0 002.44 2.509l18-17.5a1.75 1.75 0 00.035-2.474zM5 8.558a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm17.5 10.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $01d26031ee31db8e$var$__assign = undefined && undefined.__assign || function() {
    $01d26031ee31db8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01d26031ee31db8e$var$__assign.apply(this, arguments);
};
var $01d26031ee31db8e$export$a7aaed3e118dd255 = $denZA.forwardRef(function Download(props, svgRef) {
    return $denZA.createElement("svg", $01d26031ee31db8e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 3a.75.75 0 01.75.75v10.189l3.22-3.22a.75.75 0 011.06 1.06l-4.5 4.5a.747.747 0 01-1.052.008l-.005-.004-.003-.003-4.5-4.5a.75.75 0 011.061-1.06l3.22 3.219V3.749A.75.75 0 0112 3z"
    }), $denZA.createElement("path", {
        d: "M1.5 15.75a.75.75 0 10-1.499 0v1.5A3.75 3.75 0 003.751 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $5361ada1e446055a$var$__assign = undefined && undefined.__assign || function() {
    $5361ada1e446055a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5361ada1e446055a$var$__assign.apply(this, arguments);
};
var $5361ada1e446055a$export$81d26d25f3637d53 = $denZA.forwardRef(function DownwardTrend(props, svgRef) {
    return $denZA.createElement("svg", $5361ada1e446055a$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M3.817.44A.75.75 0 014.81.067l14.42 6.549-.558-1.486a.75.75 0 111.404-.527l1.194 3.18.012.033a.747.747 0 01-.45.933L17.65 9.943a.75.75 0 11-.527-1.404l1.485-.558L4.19 1.433A.75.75 0 013.818.44z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 9a1.5 1.5 0 00-1.5 1.5v12H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75V18a1.5 1.5 0 00-1.5-1.5h-3a1.5 1.5 0 00-1.5 1.5v4.5H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5v-12A1.5 1.5 0 006 9H3zm3 13.5v-12H3v12h3zm7.5-9v9h-3v-9h3zm7.5 9V18h-3v4.5h3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $af6bd3e0e13f3f1d$var$__assign = undefined && undefined.__assign || function() {
    $af6bd3e0e13f3f1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af6bd3e0e13f3f1d$var$__assign.apply(this, arguments);
};
var $af6bd3e0e13f3f1d$export$4a82481d9e63c9e1 = $denZA.forwardRef(function Duplicate(props, svgRef) {
    return $denZA.createElement("svg", $af6bd3e0e13f3f1d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2 4.251A2.251 2.251 0 014.25 2H16.5a2 2 0 012 2A.75.75 0 0117 4a.5.5 0 00-.5-.5H4.25a.751.751 0 00-.75.751V16.5a.5.5 0 00.5.5.75.75 0 010 1.5 2 2 0 01-2-2V4.251z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20 7.5H8a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2H8z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14 10.45a.75.75 0 01.75.75v2.05h2.05a.75.75 0 010 1.5h-2.05v2.05a.75.75 0 11-1.5 0v-2.05H11.2a.75.75 0 110-1.5h2.05V11.2a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $85e1645e9037490c$var$__assign = undefined && undefined.__assign || function() {
    $85e1645e9037490c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $85e1645e9037490c$var$__assign.apply(this, arguments);
};
var $85e1645e9037490c$export$7791901baee658a0 = $denZA.forwardRef(function DuplicateBold(props, svgRef) {
    return $denZA.createElement("svg", $85e1645e9037490c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.25 4.251a3.001 3.001 0 013-3.001H16.5A2.75 2.75 0 0119.25 4a1.5 1.5 0 01-2.98.25H4.25v12.021A1.5 1.5 0 014 19.25a2.75 2.75 0 01-2.75-2.75V4.251z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.5 6.5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-12a2 2 0 00-2-2h-12zm7 5.2a1 1 0 00-2 0v1.8h-1.8a1 1 0 000 2h1.8v1.8a1 1 0 102 0v-1.8h1.8a1 1 0 100-2h-1.8v-1.8z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $dcb79f91bc463ca9$var$__assign = undefined && undefined.__assign || function() {
    $dcb79f91bc463ca9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dcb79f91bc463ca9$var$__assign.apply(this, arguments);
};
var $dcb79f91bc463ca9$export$6ed0965c9443aaa6 = $denZA.forwardRef(function Edit(props, svgRef) {
    return $denZA.createElement("svg", $dcb79f91bc463ca9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01-.04 6.231l-.41.411-.001.001-14.08 14.08-.005.005a.75.75 0 01-.344.196l-6.906 1.77a.75.75 0 01-.912-.913l1.77-6.904a.75.75 0 01.196-.344v-.001L16.486 1.318A4.388 4.388 0 0119.592 0zM2.921 17.802l-1.13 4.406 4.41-1.13-3.28-3.276zm4.738 2.612l-4.077-4.07L16.605 3.32l4.074 4.074-13.02 13.02zM22.27 5.507a2.85 2.85 0 01-.531.825l-4.07-4.07a2.89 2.89 0 013.991.079 2.887 2.887 0 01.61 3.166z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $1d527b4726173bd6$var$__assign = undefined && undefined.__assign || function() {
    $1d527b4726173bd6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d527b4726173bd6$var$__assign.apply(this, arguments);
};
var $1d527b4726173bd6$export$680fa2622ca83bb7 = $denZA.forwardRef(function EditBold(props, svgRef) {
    return $denZA.createElement("svg", $1d527b4726173bd6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01.076 6.115 1.017 1.017 0 00-.09-.103l-6-6a1.014 1.014 0 00-.104-.09A4.388 4.388 0 0119.593 0zm1.701 8.707a.962.962 0 00.103.09L9.304 20.89 3.11 14.695 15.201 2.603a.993.993 0 00.092.104l6 6zm-19.509 7.49l-1.76 6.866a.75.75 0 00.912.913l6.865-1.76-6.017-6.019z"
    }));
});



var $denZA = parcelRequire("denZA");
var $1e14e66d4cc53545$var$__assign = undefined && undefined.__assign || function() {
    $1e14e66d4cc53545$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e14e66d4cc53545$var$__assign.apply(this, arguments);
};
var $1e14e66d4cc53545$export$4c6ac753363de59f = $denZA.forwardRef(function EditFile(props, svgRef) {
    return $denZA.createElement("svg", $1e14e66d4cc53545$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.755 14.775l7.904-7.904a.812.812 0 00.032-.031l.974-.975a2.852 2.852 0 00-.924-4.648 2.85 2.85 0 00-3.107.618l-8.91 8.91a.75.75 0 00-.211.424l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212zM20.65 2.5a1.35 1.35 0 00-.955.395l-.46.46 1.91 1.91.46-.46A1.35 1.35 0 0020.65 2.5zm-9.688 9.128l7.213-7.212 1.909 1.909-7.213 7.213-2.227.318.318-2.228z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M2.69 6.892a.65.65 0 01.46-.19h7a.75.75 0 000-1.5h-7A2.15 2.15 0 001 7.351v14a2.15 2.15 0 002.15 2.15h14a2.15 2.15 0 002.15-2.15v-7a.75.75 0 00-1.5 0v7a.65.65 0 01-.65.65h-14a.65.65 0 01-.65-.65v-14a.65.65 0 01.19-.46z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d1a97dbca4f982ae$var$__assign = undefined && undefined.__assign || function() {
    $d1a97dbca4f982ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d1a97dbca4f982ae$var$__assign.apply(this, arguments);
};
var $d1a97dbca4f982ae$export$b78ec286cc721c36 = $denZA.forwardRef(function EditFileBold(props, svgRef) {
    return $denZA.createElement("svg", $d1a97dbca4f982ae$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 6.451h6.9a1.5 1.5 0 100-3h-7a2.9 2.9 0 00-2.9 2.9v14a2.9 2.9 0 002.9 2.9h14a2.9 2.9 0 002.9-2.9v-7a1.5 1.5 0 10-3 0v6.9H3v-13.8z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.722 5.558a.772.772 0 00-.015-.015l-4.015-4.015.692-.693a2.85 2.85 0 014.031 4.03l-.693.693zm-1.414 1.414a1.652 1.652 0 01-.015-.015l-4.015-4.015-6.803 6.802a.75.75 0 00-.212.425l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212l6.803-6.803z"
    }));
});



var $denZA = parcelRequire("denZA");
var $e6ec74cde0a35f8f$var$__assign = undefined && undefined.__assign || function() {
    $e6ec74cde0a35f8f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e6ec74cde0a35f8f$var$__assign.apply(this, arguments);
};
var $e6ec74cde0a35f8f$export$65259f2909ebaca1 = $denZA.forwardRef(function EmailUnread(props, svgRef) {
    return $denZA.createElement("svg", $e6ec74cde0a35f8f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#email-unread_svg__email-unread_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M21.6 4H2.4A2.4 2.4 0 000 6.4v12.8a2.4 2.4 0 002.4 2.4h19.2a2.4 2.4 0 002.4-2.4V6.4A2.4 2.4 0 0021.6 4zM2.4 5.6h19.2a.8.8 0 01.8.8v12.8a.8.8 0 01-.8.8H2.4a.8.8 0 01-.8-.8V6.4a.8.8 0 01.8-.8z"
    }), $denZA.createElement("path", {
        d: "M22.35 4.753a.8.8 0 011.065 1.189l-.089.079-8.687 6.681a4.329 4.329 0 01-5.089.138l-.19-.138L.675 6.021a.8.8 0 01.876-1.334l.1.066 8.686 6.681a2.729 2.729 0 003.16.119l.168-.119 8.687-6.681z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "email-unread_svg__email-unread_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $0cb89df189895679$var$__assign = undefined && undefined.__assign || function() {
    $0cb89df189895679$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0cb89df189895679$var$__assign.apply(this, arguments);
};
var $0cb89df189895679$export$7814126f72106a6c = $denZA.forwardRef(function EmailUnreadBold(props, svgRef) {
    return $denZA.createElement("svg", $0cb89df189895679$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#email-unread-bold_svg__email-unread-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M23.888 5.832a.182.182 0 00-.2.039l-9.747 9.745a2.75 2.75 0 01-3.888 0L.31 5.871A.182.182 0 000 6v12a2 2 0 002 2h20a2 2 0 002-2V6a.181.181 0 00-.112-.168z"
    }), $denZA.createElement("path", {
        d: "M11.115 14.556c.489.487 1.28.487 1.768 0l9.686-9.686a.5.5 0 00.121-.511C22.58 4.03 22.274 4 22 4H2c-.275 0-.583.03-.691.359a.5.5 0 00.121.511l9.685 9.686z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "email-unread-bold_svg__email-unread-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $4af8f15fe8673df3$var$__assign = undefined && undefined.__assign || function() {
    $4af8f15fe8673df3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4af8f15fe8673df3$var$__assign.apply(this, arguments);
};
var $4af8f15fe8673df3$export$49bd1dfb0ad29c40 = $denZA.forwardRef(function Expand(props, svgRef) {
    return $denZA.createElement("svg", $4af8f15fe8673df3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.746 3.806v4.69a.75.75 0 001.5 0v-6.5a.747.747 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-7.22 7.22a.75.75 0 101.06 1.06l7.22-7.22zM1.996 14.974a.75.75 0 01.75.75v4.689l7.22-7.22a.75.75 0 011.06 1.061l-7.22 7.22h4.69a.75.75 0 110 1.5h-6.5a.746.746 0 01-.679-.43.747.747 0 01-.071-.32v-6.5a.75.75 0 01.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $ff1822b588ebfeef$var$__assign = undefined && undefined.__assign || function() {
    $ff1822b588ebfeef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff1822b588ebfeef$var$__assign.apply(this, arguments);
};
var $ff1822b588ebfeef$export$6b5ba4345fea866a = $denZA.forwardRef(function ExpandBold(props, svgRef) {
    return $denZA.createElement("svg", $ff1822b588ebfeef$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.996 8.496a1.5 1.5 0 003 0v-6.5a1.496 1.496 0 00-1.5-1.5h-6.5a1.5 1.5 0 000 3h2.879l-5.94 5.94a1.5 1.5 0 102.121 2.12l5.94-5.939v2.879zm-19 5.728a1.5 1.5 0 011.5 1.5v2.878l5.94-5.939a1.5 1.5 0 112.12 2.121l-5.939 5.94h2.879a1.5 1.5 0 110 3h-6.5a1.494 1.494 0 01-1.374-.897 1.495 1.495 0 01-.126-.603v-6.5a1.5 1.5 0 011.5-1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $5d3bebd6fa95b9d3$var$__assign = undefined && undefined.__assign || function() {
    $5d3bebd6fa95b9d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5d3bebd6fa95b9d3$var$__assign.apply(this, arguments);
};
var $5d3bebd6fa95b9d3$export$7562e752e5ef1fad = $denZA.forwardRef(function Faq(props, svgRef) {
    return $denZA.createElement("svg", $5d3bebd6fa95b9d3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M11.325 11.46h1.227c-.037-.166-.091-.367-.091-.587 0-.659.494-1.117 1.3-1.85 1.025-.915 1.739-1.738 1.739-2.965C15.5 4.263 14.053 3 12.277 3c-1.61 0-2.8.934-3.277 2.563l1.19.495c.366-1.172 1.117-1.758 2.05-1.758.99 0 1.795.75 1.795 1.85 0 .896-.512 1.39-1.428 2.251-.787.696-1.465 1.337-1.465 2.252 0 .293.074.586.183.806zm.696 4.027c.641 0 1.172-.476 1.172-1.153 0-.678-.531-1.154-1.172-1.154-.604 0-1.153.476-1.153 1.154 0 .677.549 1.153 1.153 1.153z"
    }));
});



var $denZA = parcelRequire("denZA");
var $cd3a9369d16dd532$var$__assign = undefined && undefined.__assign || function() {
    $cd3a9369d16dd532$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd3a9369d16dd532$var$__assign.apply(this, arguments);
};
var $cd3a9369d16dd532$export$b995d600f3ba41d6 = $denZA.forwardRef(function FaqBold(props, svgRef) {
    return $denZA.createElement("svg", $cd3a9369d16dd532$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25zm10.759 11.094h-1.88a1.996 1.996 0 01-.182-.792c0-.66.495-1.22 1.303-1.864.676-.561.973-.858.973-1.386 0-.594-.462-1.006-1.039-1.006-.61 0-1.056.429-1.37 1.253L9 6.508C9.478 4.825 10.7 4 12.25 4c1.798 0 3.25 1.138 3.25 2.887 0 .973-.462 1.617-1.37 2.409l-.176.153c-.57.495-.978.849-.978 1.299 0 .131.016.247.033.346zm.66 2.656c0 .874-.66 1.534-1.535 1.534-.89 0-1.55-.66-1.55-1.534 0-.858.66-1.534 1.55-1.534a1.51 1.51 0 011.535 1.534z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $52e295d4ec31e03a$var$__assign = undefined && undefined.__assign || function() {
    $52e295d4ec31e03a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52e295d4ec31e03a$var$__assign.apply(this, arguments);
};
var $52e295d4ec31e03a$export$f07d42f183ae8811 = $denZA.forwardRef(function FeedScroll(props, svgRef) {
    return $denZA.createElement("svg", $52e295d4ec31e03a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M2.2 2.467a.733.733 0 00-.733.733v13.2a.733.733 0 00.733.733h5.136a.733.733 0 110 1.467H2.2A2.2 2.2 0 010 16.4V3.2A2.2 2.2 0 012.2 1h19.067a2.2 2.2 0 012.2 2.2v11.733a.733.733 0 11-1.467 0V3.2a.733.733 0 00-.733-.733h-2.2v8.066a.733.733 0 01-1.467 0V2.467H2.2z"
    }), $denZA.createElement("path", {
        d: "M5.133 5.4a.733.733 0 000 1.467h7.334a.733.733 0 000-1.467H5.133zm9.018 6.815a.733.733 0 011.252.518v2.934c0 .358.26.664.613.723l1.949.325a2.2 2.2 0 011.838 2.17v3.382a.733.733 0 101.467 0v-3.383a3.667 3.667 0 00-3.064-3.616l-1.336-.223v-2.312a2.2 2.2 0 00-4.4 0v3.95l-.092-.046a2.334 2.334 0 00-3.309 1.521v.002a2.334 2.334 0 00.813 2.388l.001.001 2.862 2.29a.733.733 0 10.916-1.145l-2.864-2.292-.002-.002a.867.867 0 01-.129-1.23.866.866 0 011.056-.222l1.154.575a.733.733 0 001.06-.656v-5.134c0-.194.078-.38.215-.518zM4.4 9.067c0-.405.328-.734.733-.734h7.334a.733.733 0 010 1.467H5.133a.733.733 0 01-.733-.733zm.733 2.2a.733.733 0 100 1.466H8.8a.733.733 0 100-1.466H5.133z"
    }));
});



var $denZA = parcelRequire("denZA");
var $45fc7157ac5574f8$var$__assign = undefined && undefined.__assign || function() {
    $45fc7157ac5574f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $45fc7157ac5574f8$var$__assign.apply(this, arguments);
};
var $45fc7157ac5574f8$export$51369d9fa2a33304 = $denZA.forwardRef(function FeedScrollBold(props, svgRef) {
    return $denZA.createElement("svg", $45fc7157ac5574f8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M5.92 16.823a.253.253 0 00-.041-.219.248.248 0 00-.2-.1H5.5a1 1 0 01-1-1v-12a1 1 0 011-1h14a1 1 0 011 1v10.678c0 .117.08.218.194.244 1.084.25 2.08.787 2.884 1.555A.25.25 0 0024 15.8V2.505a2.5 2.5 0 00-2.5-2.5h-19a2.5 2.5 0 00-2.5 2.5v14a2.5 2.5 0 002.5 2.5h3.152a.251.251 0 00.242-.312 3.6 3.6 0 01.026-1.87z"
    }), $denZA.createElement("path", {
        d: "M23 24a.75.75 0 00.75-.75v-3A4.756 4.756 0 0019 15.5h-2a.25.25 0 01-.25-.25v-5.5a2.25 2.25 0 00-4.5 0v7.06a.25.25 0 01-.442.16l-.578-.7a2.25 2.25 0 00-3.46 2.877l3.806 4.579c.143.172.354.27.577.271L23 24z"
    }));
});



var $denZA = parcelRequire("denZA");
var $0dde824b5e870cae$var$__assign = undefined && undefined.__assign || function() {
    $0dde824b5e870cae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0dde824b5e870cae$var$__assign.apply(this, arguments);
};
var $0dde824b5e870cae$export$2f3ad13cc6e1f36d = $denZA.forwardRef(function FilesAnalytics(props, svgRef) {
    return $denZA.createElement("svg", $0dde824b5e870cae$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.35 6.59L15.47.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75V8.18a2.25 2.25 0 00-.65-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.75V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }), $denZA.createElement("path", {
        d: "M6.37 8.6a.64.64 0 01.64.64v5.58l1.8-1.68a2.33 2.33 0 013.13 0l.62.58a1 1 0 00.82.26 1 1 0 00.71-.43l1.34-2.09a.64.64 0 011.08.69l-1.34 2.1a2.261 2.261 0 01-1.64 1 2.32 2.32 0 01-1.83-.59l-.62-.58a1 1 0 00-1.4 0l-2.67 2.49v1.65h9.62a.64.64 0 110 1.28H6.37a.64.64 0 01-.64-.64V9.24a.64.64 0 01.64-.64z"
    }));
});



var $denZA = parcelRequire("denZA");
var $babd24b0d75b754b$var$__assign = undefined && undefined.__assign || function() {
    $babd24b0d75b754b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $babd24b0d75b754b$var$__assign.apply(this, arguments);
};
var $babd24b0d75b754b$export$2da06534dde49690 = $denZA.forwardRef(function FilesCode(props, svgRef) {
    return $denZA.createElement("svg", $babd24b0d75b754b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.34 6.59L15.5.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.7V8.18a2.25 2.25 0 00-.66-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.74V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }), $denZA.createElement("path", {
        d: "M13.5 10.32a.68.68 0 000 1l2.91 2.91-2.91 2.87a.68.68 0 000 1 .67.67 0 001 0l3.39-3.39a.681.681 0 000-1l-3.39-3.39a.68.68 0 00-1 0zm-3.12 0a.68.68 0 00-1 0l-3.35 3.39a.68.68 0 000 1l3.39 3.39a.67.67 0 001 0 .681.681 0 000-1L7.5 14.19l2.91-2.91a.68.68 0 00-.03-.96z"
    }));
});



var $denZA = parcelRequire("denZA");
var $1e9471c8c009feb7$var$__assign = undefined && undefined.__assign || function() {
    $1e9471c8c009feb7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e9471c8c009feb7$var$__assign.apply(this, arguments);
};
var $1e9471c8c009feb7$export$e3f95c4e98f5bc36 = $denZA.forwardRef(function FilesDatabase(props, svgRef) {
    return $denZA.createElement("svg", $1e9471c8c009feb7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M11.25 9.81a10 10 0 00-3.38.53 3.62 3.62 0 00-1.16.66 1.45 1.45 0 00-.53 1.06v4.5a1.45 1.45 0 00.54 1.08c.34.28.725.497 1.14.64a10 10 0 003.38.53 9.975 9.975 0 003.38-.53c.416-.143.802-.36 1.14-.64a1.45 1.45 0 00.54-1.08v-4.5a1.451 1.451 0 00-.51-1.06 3.62 3.62 0 00-1.16-.66 10 10 0 00-3.38-.53zm3.94 6.75s0 .1-.16.24a2.582 2.582 0 01-.79.43 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.182.095.369.179.56.25a10 10 0 003.38.53 10 10 0 003.4-.56 4.8 4.8 0 00.56-.25v.81zm0-2.25s0 .1-.16.24a2.58 2.58 0 01-.78.45 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.182.095.369.179.56.25a10 10 0 003.38.53 9.975 9.975 0 003.38-.53 4.76 4.76 0 00.56-.25l.01.76zm0-2.25s0 .09-.16.23a2.53 2.53 0 01-.8.44 8.909 8.909 0 01-3 .46 8.909 8.909 0 01-3-.46 2.528 2.528 0 01-.8-.44c-.15-.14-.16-.22-.16-.23 0-.01 0-.09.16-.23a2.53 2.53 0 01.82-.43 8.909 8.909 0 013-.46 8.909 8.909 0 013 .46c.292.097.563.246.8.44.14.16.14.21.14.22z"
    }), $denZA.createElement("path", {
        d: "M21.35 6.59L15.47.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75V8.18a2.25 2.25 0 00-.65-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.75V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }));
});



var $denZA = parcelRequire("denZA");
var $089b7f87ab319191$var$__assign = undefined && undefined.__assign || function() {
    $089b7f87ab319191$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $089b7f87ab319191$var$__assign.apply(this, arguments);
};
var $089b7f87ab319191$export$c1715d484b9fa172 = $denZA.forwardRef(function FilesPdf(props, svgRef) {
    return $denZA.createElement("svg", $089b7f87ab319191$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.494a.752.752 0 00-.75.747v19.418a.745.745 0 00.75.747h3c.414 0 .75.335.75.747a.748.748 0 01-.75.747h-3a2.255 2.255 0 01-1.591-.656A2.236 2.236 0 010 21.659V2.241C0 1.646.237 1.076.659.656 1.081.236 1.653 0 2.25 0h10.629a2.26 2.26 0 011.592.657l5.87 5.847A2.24 2.24 0 0121 8.088v4.609a.748.748 0 01-.75.747.748.748 0 01-.75-.747V8.963h-5.25a2.255 2.255 0 01-1.591-.657A2.236 2.236 0 0112 6.722V1.494H2.25zM13.5 6.722V1.803l5.69 5.666h-4.94a.751.751 0 01-.75-.747z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.25 14.935a.748.748 0 00-.75.747v7.47c0 .412.336.746.75.746s.75-.334.75-.747v-2.24h.004c.796 0 1.559-.315 2.121-.876a2.981 2.981 0 000-4.225 3.006 3.006 0 00-2.121-.875H8.25zM9 16.43v2.988h.004a1.5 1.5 0 001.06-.438 1.49 1.49 0 000-2.112 1.503 1.503 0 00-1.06-.438H9zm5.25-1.495a.748.748 0 00-.75.747v7.47a.745.745 0 00.75.746c.995 0 1.948-.393 2.652-1.094A3.727 3.727 0 0018 20.164V18.67c0-.99-.395-1.94-1.098-2.64a3.758 3.758 0 00-2.652-1.095zm.75 7.341v-5.719a2.25 2.25 0 011.5 2.113v1.494a2.236 2.236 0 01-1.5 2.112z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.75 16.43a.751.751 0 00-.75.746v2.24h1.5a.748.748 0 110 1.494H21v2.241a.748.748 0 01-.75.747.748.748 0 01-.75-.747v-5.975c0-.594.237-1.164.659-1.584.422-.42.994-.657 1.591-.657h1.5c.414 0 .75.335.75.747a.748.748 0 01-.75.747h-1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $fcd60a9340263410$var$__assign = undefined && undefined.__assign || function() {
    $fcd60a9340263410$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fcd60a9340263410$var$__assign.apply(this, arguments);
};
var $fcd60a9340263410$export$5787518a8920ddc6 = $denZA.forwardRef(function FilesPtt(props, svgRef) {
    return $denZA.createElement("svg", $fcd60a9340263410$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.499 15.748a.75.75 0 01.75-.75H9a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5zm1.5 3.75v-3H9a1.5 1.5 0 110 3h-.001zm5.25-4.5H15a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5a.75.75 0 01.75-.75zm.75 1.5H15a1.5 1.5 0 110 3h-.001v-3z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M23.249 16.498h-.75v6.75a.75.75 0 01-1.5 0v-6.75h-.75a.75.75 0 010-1.5h3a.75.75 0 010 1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $b7299a85ed95e638$var$__assign = undefined && undefined.__assign || function() {
    $b7299a85ed95e638$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b7299a85ed95e638$var$__assign.apply(this, arguments);
};
var $b7299a85ed95e638$export$4f1e1e7a399aeb90 = $denZA.forwardRef(function FilesQueryFile(props, svgRef) {
    return $denZA.createElement("svg", $b7299a85ed95e638$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M22.34 6.59L16.47.71A2.25 2.25 0 0014.88 0H4.22A2.25 2.25 0 002 2.3v19.4A2.25 2.25 0 004.22 24h16.5a2.25 2.25 0 002.25-2.25V8.18a2.25 2.25 0 00-.63-1.59zM15.5 1.86l5.72 5.7h-5a.75.75 0 01-.75-.75l.03-4.95zm6 19.84a.75.75 0 01-.75.75H4.22a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75h9.75v5.26a2.25 2.25 0 002.25 2.25h5.25l.03 12.64z"
    }), $denZA.createElement("path", {
        d: "M16.34 11.75a1.84 1.84 0 00-1.93-1.69h-.61a.64.64 0 100 1.28h.69a.58.58 0 01.6.5v1.05a1.73 1.73 0 00.89 1.46l.38.22-.39.2a1.7 1.7 0 00-.89 1.46v1.05a.57.57 0 01-.6.5h-.69a.64.64 0 100 1.28h.72a1.83 1.83 0 001.82-1.69v-1.09a.42.42 0 01.23-.36l1.34-.77a.63.63 0 00.32-.55.61.61 0 00-.31-.57l-1.34-.77a.46.46 0 01-.23-.37v-1.14zm-8.238-.057a1.84 1.84 0 011.93-1.69h.61a.64.64 0 110 1.28h-.69a.58.58 0 00-.6.5v1.05a1.73 1.73 0 01-.89 1.46l-.38.22.39.2a1.7 1.7 0 01.89 1.46v1.05a.57.57 0 00.6.5h.69a.64.64 0 110 1.28h-.72a1.83 1.83 0 01-1.82-1.69v-1.09a.42.42 0 00-.23-.36l-1.34-.77a.63.63 0 01-.32-.55.61.61 0 01.31-.57l1.34-.77a.46.46 0 00.23-.37v-1.14z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8bd3f1c07e5fc2e5$var$__assign = undefined && undefined.__assign || function() {
    $8bd3f1c07e5fc2e5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8bd3f1c07e5fc2e5$var$__assign.apply(this, arguments);
};
var $8bd3f1c07e5fc2e5$export$7eb16584d50da272 = $denZA.forwardRef(function FilesToDo(props, svgRef) {
    return $denZA.createElement("svg", $8bd3f1c07e5fc2e5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M10.12 9.027a.75.75 0 01.149 1.05l-2.132 2.845a1.5 1.5 0 01-2.26.16L4.72 11.927a.751.751 0 011.06-1.062l1.157 1.157L9.07 9.177a.75.75 0 011.05-.15zm.149 7.806a.751.751 0 00-1.2-.9l-2.132 2.844-1.157-1.158a.75.75 0 10-1.06 1.061l1.157 1.158a1.5 1.5 0 002.26-.16l2.132-2.845zM12 12.772a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zm.75 5.254a.75.75 0 000 1.502h4.5a.75.75 0 000-1.502h-4.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.5 21.66a2.253 2.253 0 01-2.25 2.251H3.75a2.25 2.25 0 01-2.25-2.252V2.263A2.253 2.253 0 013.75.01h10.629a2.25 2.25 0 011.59.659l5.873 5.877c.421.423.658.995.658 1.592v13.52zM3.22 1.731a.75.75 0 01.53-.22h9.75v5.255a2.253 2.253 0 002.25 2.252H21v12.64a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V2.263c0-.2.079-.39.22-.53zm17.47 5.785h-4.94a.75.75 0 01-.75-.75V1.823l5.69 5.694z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $aa76d1bc57616fda$var$__assign = undefined && undefined.__assign || function() {
    $aa76d1bc57616fda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa76d1bc57616fda$var$__assign.apply(this, arguments);
};
var $aa76d1bc57616fda$export$10b5cda80b0293f5 = $denZA.forwardRef(function FilesWord(props, svgRef) {
    return $denZA.createElement("svg", $aa76d1bc57616fda$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.247 14.998a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75 3.75 3.75 0 003.75-3.75v-1.5a3.75 3.75 0 00-3.75-3.75zm.75 7.371v-5.742a2.249 2.249 0 011.5 2.121v1.5a2.25 2.25 0 01-1.5 2.121zm5.159-6.712a2.25 2.25 0 013.841 1.591v4.5a2.25 2.25 0 01-4.5 0v-4.5c0-.597.237-1.169.66-1.591zm1.591.841a.75.75 0 00-.75.75v4.5a.75.75 0 101.5 0v-4.5a.75.75 0 00-.75-.75z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M20.595 16.096a3.75 3.75 0 012.652-1.098.75.75 0 010 1.5 2.25 2.25 0 00-2.25 2.25v1.5a2.25 2.25 0 002.25 2.25.75.75 0 010 1.5 3.75 3.75 0 01-3.75-3.75v-1.5a3.75 3.75 0 011.098-2.652z"
    }));
});



var $denZA = parcelRequire("denZA");
var $add521aae373a090$var$__assign = undefined && undefined.__assign || function() {
    $add521aae373a090$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $add521aae373a090$var$__assign.apply(this, arguments);
};
var $add521aae373a090$export$7a3d1a91ed30f8c1 = $denZA.forwardRef(function FilesXls(props, svgRef) {
    return $denZA.createElement("svg", $add521aae373a090$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.72 1.712a.752.752 0 01.53-.218H12v5.228c0 .594.237 1.164.659 1.584.422.42.994.657 1.591.657h5.25v3.734a.749.749 0 001.5 0V8.088a2.233 2.233 0 00-.659-1.584L14.471.657A2.251 2.251 0 0012.879 0H2.25C1.653 0 1.081.236.659.656.237 1.076 0 1.646 0 2.241v19.418c0 .595.237 1.165.659 1.585.422.42.994.656 1.591.656h3c.414 0 .75-.334.75-.747a.748.748 0 00-.75-.747h-3a.751.751 0 01-.75-.747V2.241c0-.198.079-.388.22-.529zm11.78.091v4.919a.745.745 0 00.75.747h4.94L13.5 1.803z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M16.74 22.491h-1.51a.761.761 0 01-.754-.754v-6a.761.761 0 00-.755-.754.761.761 0 00-.754.754v6a2.253 2.253 0 002.246 2.246h1.508a.76.76 0 00.755-.754.732.732 0 00-.737-.738zm-5.726-7.44a.758.758 0 00-.977.412l-.789 2.023-.805-2.006a.752.752 0 00-.978-.411.752.752 0 00-.411.977l1.389 3.463-1.389 3.462a.758.758 0 00.411.978.752.752 0 00.977-.429l.806-2.006.806 2.006a.76.76 0 00.977.429.752.752 0 00.412-.978l-1.389-3.462 1.389-3.463a.765.765 0 00-.429-.995zm9.48 2.195c0 .703.428 1.063 1.2 1.645l.038.03c.799.611 1.762 1.348 1.762 2.816a2.253 2.253 0 01-2.246 2.246H19.74a.761.761 0 01-.755-.754c0-.412.343-.755.755-.755h1.508a.761.761 0 00.755-.754c0-.703-.429-1.063-1.2-1.646l-.006-.004c-.805-.599-1.794-1.336-1.794-2.841a2.253 2.253 0 012.245-2.246h1.509c.411 0 .754.343.754.754a.76.76 0 01-.754.754h-1.509a.761.761 0 00-.754.755z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d62a7a5176a43ab9$var$__assign = undefined && undefined.__assign || function() {
    $d62a7a5176a43ab9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d62a7a5176a43ab9$var$__assign.apply(this, arguments);
};
var $d62a7a5176a43ab9$export$ec91da630f36d5ea = $denZA.forwardRef(function Filter(props, svgRef) {
    return $denZA.createElement("svg", $d62a7a5176a43ab9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08zm-9.497 10.525a.754.754 0 00-.6.737v7.372l-3 2.503V12.29a.754.754 0 00-.6-.737c-4.594-.943-8.04-4.868-8.383-9.531H22.44c-.326 4.663-3.771 8.588-8.366 9.531z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8d96ddf50c6c558a$var$__assign = undefined && undefined.__assign || function() {
    $8d96ddf50c6c558a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d96ddf50c6c558a$var$__assign.apply(this, arguments);
};
var $8d96ddf50c6c558a$export$12f6556880dd4f70 = $denZA.forwardRef(function FilterBold(props, svgRef) {
    return $denZA.createElement("svg", $8d96ddf50c6c558a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f93b219bff893b45$var$__assign = undefined && undefined.__assign || function() {
    $f93b219bff893b45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f93b219bff893b45$var$__assign.apply(this, arguments);
};
var $f93b219bff893b45$export$630b74b270eecb49 = $denZA.forwardRef(function GraphBar(props, svgRef) {
    return $denZA.createElement("svg", $f93b219bff893b45$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 25 24",
        width: 25
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.751 0a2.25 2.25 0 00-2.22 2.612L16.79 4.754a2.25 2.25 0 00-2.87.69l-3.42-.915v-.028a2.25 2.25 0 10-4.463.406l-3.384 3.38a2.25 2.25 0 101.336.786l2.835-2.832a2.25 2.25 0 003.154-.299l3.527.944a2.25 2.25 0 104.31-1.03l2.451-1.916A2.25 2.25 0 1021.751 0zM2.542 9.81l.032.015a.75.75 0 11-.032-.015zm18.679-8.09a.75.75 0 111.06 1.06.75.75 0 01-1.06-1.06zM7.564 4.804l.006.014a.75.75 0 10-.006-.014zM15.75 6a.75.75 0 100 1.5.75.75 0 000-1.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9 22.5V10.25A1.25 1.25 0 0110.25 9h2.751a1.25 1.25 0 011.25 1.25V22.5h2.25v-7.75a1.25 1.25 0 011.247-1.25h2.754a1.25 1.25 0 011.25 1.25v7.75h.749a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h.75v-3.25A1.25 1.25 0 012.75 18h2.751a1.25 1.25 0 011.25 1.25v3.25H9zm1.5 0v-12h2.251v12H10.5zm9.751 0h-2.25V15h2.25v7.5zM3 19.5v3h2.251v-3H3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $0b95783e0b9275db$var$__assign = undefined && undefined.__assign || function() {
    $0b95783e0b9275db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b95783e0b9275db$var$__assign.apply(this, arguments);
};
var $0b95783e0b9275db$export$357400b174a17c2b = $denZA.forwardRef(function HardDrive(props, svgRef) {
    return $denZA.createElement("svg", $0b95783e0b9275db$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18.375 16.875a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zm.208 1.437a.378.378 0 01-.281.056.376.376 0 11.281-.056z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M5.25 17.25a.75.75 0 000 1.5H9a.75.75 0 000-1.5H5.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.878.75h10.245a3.75 3.75 0 013.65 2.894L23.85 16.75a5.249 5.249 0 01-5.099 6.5H5.25a5.25 5.25 0 01-5.1-6.5L3.228 3.645A3.75 3.75 0 016.878.75zm15.523 16.394l-.01-.042a3.75 3.75 0 00-3.641-2.852H5.25a3.75 3.75 0 00-3.64 2.852l-.01.042a3.75 3.75 0 003.65 4.606h13.5a3.75 3.75 0 003.655-4.589l-.004-.017zM19.313 3.986l2.248 9.58a5.25 5.25 0 00-2.811-.816H5.25a5.25 5.25 0 00-2.811.816l2.248-9.58A2.25 2.25 0 016.878 2.25h10.245a2.25 2.25 0 012.19 1.736z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $fc8b51f342788998$var$__assign = undefined && undefined.__assign || function() {
    $fc8b51f342788998$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc8b51f342788998$var$__assign.apply(this, arguments);
};
var $fc8b51f342788998$export$84202caead5689ba = $denZA.forwardRef(function History(props, svgRef) {
    return $denZA.createElement("svg", $fc8b51f342788998$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M17.987 10.535v-.788h1.508a.76.76 0 00.753-.753.76.76 0 00-.753-.754h-4.506a.76.76 0 00-.754.754.76.76 0 00.754.753h1.508v.788c-3.375.377-5.996 3.238-5.996 6.698 0 3.718 3.032 6.75 6.75 6.75 3.717 0 6.749-3.032 6.749-6.75a6.78 6.78 0 00-6.013-6.698zm-.754 11.94a5.242 5.242 0 110-10.484 5.242 5.242 0 010 10.484z"
    }), $denZA.createElement("path", {
        d: "M19.272 17.233h-1.285v-2.998a.76.76 0 00-.754-.753.76.76 0 00-.753.754v3.751a.76.76 0 00.753.754h2.039a.76.76 0 00.754-.754.76.76 0 00-.754-.754zM8.24 15.743H1.884a.38.38 0 01-.377-.377V5.242h17.234v.754a.76.76 0 00.754.753.76.76 0 00.753-.753V1.867C20.231.84 19.392 0 18.381 0H1.884A1.864 1.864 0 000 1.867v13.516a1.898 1.898 0 001.884 1.867h6.373a.76.76 0 00.754-.753c0-.411-.36-.754-.771-.754zM1.867 1.507h16.48c.205 0 .377.172.377.36v1.885H1.507V1.867c0-.205.155-.36.36-.36z"
    }));
});



var $denZA = parcelRequire("denZA");
var $a2d2380942a30368$var$__assign = undefined && undefined.__assign || function() {
    $a2d2380942a30368$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2d2380942a30368$var$__assign.apply(this, arguments);
};
var $a2d2380942a30368$export$e3e58178368f2952 = $denZA.forwardRef(function HistoryBold(props, svgRef) {
    return $denZA.createElement("svg", $a2d2380942a30368$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.014 19.833A6.75 6.75 0 0017.25 24 6.758 6.758 0 0024 17.251a6.75 6.75 0 10-12.986 2.582zM12.5 17.25a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M19.25 18.251h-2a1 1 0 01-1-1v-2.5a1 1 0 112 0V16c0 .138.112.25.25.25h.75a1 1 0 110 2.001z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.3 18.5a.968.968 0 01.946.722l.004.022A1 1 0 018.3 20.5H3a3 3 0 01-3-3V3a3 3 0 013-3h18a3 3 0 013 3v7.049a.983.983 0 01-1.59.777l-.022-.018a1 1 0 01-.388-.777V5.25a.25.25 0 00-.25-.25H2.25a.25.25 0 00-.25.251V17.5a1 1 0 001 1h5.3zm2.2-17a.966.966 0 00-.846.5.969.969 0 00-.154.5c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.969.969 0 00-.154-.5.966.966 0 00-.846-.5zM6.154 2a.966.966 0 011.692 0A.97.97 0 018 2.5a.972.972 0 01-.154.5.966.966 0 01-1.692 0A.972.972 0 016 2.5a.969.969 0 01.154-.5zM3.5 1.5a1 1 0 00-.908.591.992.992 0 00-.092.409c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.97.97 0 00-.154-.5.983.983 0 00-.846-.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $e09ac2439cd73908$var$__assign = undefined && undefined.__assign || function() {
    $e09ac2439cd73908$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e09ac2439cd73908$var$__assign.apply(this, arguments);
};
var $e09ac2439cd73908$export$b94310965bed44e6 = $denZA.forwardRef(function Home(props, svgRef) {
    return $denZA.createElement("svg", $e09ac2439cd73908$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.516 13.37c.388 0 .703.316.703.704v7.031h4.218v-4.922a2.11 2.11 0 012.11-2.11h1.406a2.11 2.11 0 012.11 2.11v4.922h4.218v-7.031a.703.703 0 011.407 0v7.734a.703.703 0 01-.704.703H14.36a.703.703 0 01-.703-.703v-5.625a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v5.625a.703.703 0 01-.703.703H4.516a.703.703 0 01-.704-.703v-7.734c0-.389.315-.703.704-.703z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.25 3.406a.703.703 0 00-.497.206L2.2 13.165a.703.703 0 11-.994-.995l9.552-9.552a2.11 2.11 0 012.984 0l9.552 9.552a.703.703 0 01-.994.995l-9.553-9.553a.703.703 0 00-.497-.206z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $3c41e01e178447ff$var$__assign = undefined && undefined.__assign || function() {
    $3c41e01e178447ff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c41e01e178447ff$var$__assign.apply(this, arguments);
};
var $3c41e01e178447ff$export$611e0072bc063769 = $denZA.forwardRef(function HomeBold(props, svgRef) {
    return $denZA.createElement("svg", $3c41e01e178447ff$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M22.933 11.288l-9.55-9.56a2.48 2.48 0 00-3.51 0l-9.56 9.56a1.08 1.08 0 00.76 1.84h1.73v8.06a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.11-1.08v-5.63a.33.33 0 01.33-.33h3.37a.33.33 0 01.33.33v5.63a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.08-1.08v-8.06h1.76a1.08 1.08 0 00.73-1.84z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8aa4481ccc5b4169$var$__assign = undefined && undefined.__assign || function() {
    $8aa4481ccc5b4169$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8aa4481ccc5b4169$var$__assign.apply(this, arguments);
};
var $8aa4481ccc5b4169$export$25513f6e9c35561f = $denZA.forwardRef(function HumanResourcesOfferMan(props, svgRef) {
    return $denZA.createElement("svg", $8aa4481ccc5b4169$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#human-resources-offer-man_svg__human-resources-offer-man_svg__clip0)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M16.865 0a4.875 4.875 0 100 9.75 4.875 4.875 0 000-9.75zm0 1.5a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75zM.749 13.5a.75.75 0 01.743.648l.007.102V15H6a3.752 3.752 0 013.624 2.784l.05.216h3.075a3.75 3.75 0 013.745 3.55l.005.2a.75.75 0 01-.648.743l-.102.007H1.499v.75a.75.75 0 01-1.493.102l-.007-.102v-9a.75.75 0 01.75-.75zm.75 7.5v-4.5H6l.154.005A2.252 2.252 0 018.122 18H5.999l-.102.007A.75.75 0 006 19.5h6.75l.154.005a2.251 2.251 0 011.92 1.37l.047.125H1.499z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M23.937 14.75a7.502 7.502 0 00-14.144 0 .75.75 0 001.414.5 6.002 6.002 0 0111.316 0 .75.75 0 001.414-.5z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "human-resources-offer-man_svg__human-resources-offer-man_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $e0f0d34606bb0a42$var$__assign = undefined && undefined.__assign || function() {
    $e0f0d34606bb0a42$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e0f0d34606bb0a42$var$__assign.apply(this, arguments);
};
var $e0f0d34606bb0a42$export$a853083deadc2998 = $denZA.forwardRef(function HumanResourcesOfferManBold(props, svgRef) {
    return $denZA.createElement("svg", $e0f0d34606bb0a42$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.728 4.503c0 1.958-1.653 3.545-3.692 3.545-2.04 0-3.692-1.587-3.692-3.545 0-1.957 1.653-3.544 3.692-3.544s3.692 1.587 3.692 3.544zm-3.692 4.834c-2.695 0-5.062 1.717-5.8 4.205a.235.235 0 00.04.21c.048.06.122.096.2.096h11.118a.253.253 0 00.2-.096.232.232 0 00.04-.21c-.738-2.487-3.104-4.203-5.798-4.205zM1.156 15.12c-.553 0-1 .43-1 .96v6.96c0 .53.447.96 1 .96.552 0 1-.43 1-.96v-6.96c0-.53-.448-.96-1-.96zm14.5 4.56H6.53a.613.613 0 01-.625-.6c0-.331.28-.6.625-.6h2.526c.336 0 .65-.162.835-.431a.927.927 0 00.085-.907c-.352-.79-1.162-1.303-2.057-1.302H3.656a.49.49 0 00-.5.48v6.24c0 .265.224.48.5.48H14.42c1.234-.002 2.235-.962 2.236-2.148v-.252c0-.53-.448-.96-1-.96z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9a9d51e39726eb37$var$__assign = undefined && undefined.__assign || function() {
    $9a9d51e39726eb37$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a9d51e39726eb37$var$__assign.apply(this, arguments);
};
var $9a9d51e39726eb37$export$ad52482257e413dd = $denZA.forwardRef(function Ideas(props, svgRef) {
    return $denZA.createElement("svg", $9a9d51e39726eb37$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.75.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0V.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5.578 15.171a7.35 7.35 0 002.672 2.576V19.5a2.25 2.25 0 002.25 2.25h.75v1.5a.75.75 0 001.5 0v-1.5h.75a2.25 2.25 0 002.25-2.25v-1.753a7.35 7.35 0 003.75-6.507v-.003a7.624 7.624 0 00-7.513-7.487A7.623 7.623 0 004.5 11.241v.003a7.35 7.35 0 001.078 3.928zM13.5 20.25a.75.75 0 00.75-.75V18h-4.5v1.5a.75.75 0 00.75.75h3zM9.097 16.5h2.153v-2.69l-2.03-2.03a.75.75 0 111.06-1.06L12 12.44l1.72-1.72a.75.75 0 111.06 1.06l-2.03 2.03v2.69h2.153A5.85 5.85 0 0018 11.262a6.123 6.123 0 00-6-6.012 6.123 6.123 0 00-6 6.015A5.85 5.85 0 009.097 16.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M.75 11.25a.75.75 0 01.75-.75H3A.75.75 0 013 12H1.5a.75.75 0 01-.75-.75zm3.52-8.04a.75.75 0 00-1.04 1.08l1.1 1.058a.75.75 0 001.04-1.082L4.27 3.21zm15.98 8.04a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H21a.75.75 0 01-.75-.75zm.52-6.96a.75.75 0 10-1.04-1.08l-1.1 1.056a.75.75 0 001.04 1.082l1.1-1.057z"
    }));
});



var $denZA = parcelRequire("denZA");
var $1e5210211e7aa89f$var$__assign = undefined && undefined.__assign || function() {
    $1e5210211e7aa89f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e5210211e7aa89f$var$__assign.apply(this, arguments);
};
var $1e5210211e7aa89f$export$f7545e2d7d9761e3 = $denZA.forwardRef(function IdeasBold(props, svgRef) {
    return $denZA.createElement("svg", $1e5210211e7aa89f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#ideas-bold_svg__ideas-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M12 3.75a7.62 7.62 0 00-7.5 7.49 7.35 7.35 0 003.75 6.5h7.5a7.35 7.35 0 003.75-6.51A7.62 7.62 0 0012 3.75zm-.75 12.75v-2.62L9.53 12.1c-.39-.39-.76-1-.37-1.38.39-.38.83-.3 1.22.09L12 12.44l1.48-1.53c.39-.39.91-.58 1.3-.19.39.39.23.83-.16 1.22l-1.87 1.87v2.69h-1.5zm-3 1.99v1a2.25 2.25 0 002.25 2.25h.5V23a1 1 0 00.66.93.68.68 0 00.67 0A1 1 0 0013 23v-1.25h.5a2.25 2.25 0 002.25-2.25v-1h-1.5l-6-.01zM12 3.35a1 1 0 001-1V1a1 1 0 00-2 0v1.4a1 1 0 001 .95zm8.92-.25a1 1 0 00-1.41 0l-1 1a1 1 0 101.38 1.44l1-1a1 1 0 00.03-1.44zM5.53 5.45A1 1 0 005.5 4l-1-1a1.033 1.033 0 10-1.4 1.52l1 1a1 1 0 001.41 0l.02-.07zm16.87 4.67H21a1 1 0 000 2h1.4a1 1 0 000-2zm-20.85.13a1 1 0 000 2H3a1 1 0 000-2H1.55z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "ideas-bold_svg__ideas-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $e8e86c12a536215d$var$__assign = undefined && undefined.__assign || function() {
    $e8e86c12a536215d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8e86c12a536215d$var$__assign.apply(this, arguments);
};
var $e8e86c12a536215d$export$bf44615096563be0 = $denZA.forwardRef(function LaptopSmiley(props, svgRef) {
    return $denZA.createElement("svg", $e8e86c12a536215d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#laptop-smiley_svg__laptop-smiley_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M10.5 5.5a.75.75 0 00-1.5 0V7a.75.75 0 001.5 0V5.5zM8.755 9.47a.75.75 0 00-1.01 1.108 6.318 6.318 0 008.51 0 .75.75 0 10-1.01-1.108 4.818 4.818 0 01-6.49 0zm5.495-4.72a.75.75 0 01.75.75V7a.75.75 0 01-1.5 0V5.5a.75.75 0 01.75-.75zM10.5 17.5a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 1a2.25 2.25 0 00-2.25 2.25v11.087L.197 18.829l-.003.008A2.25 2.25 0 002.25 22h19.5a2.25 2.25 0 002.057-3.163l-2.057-4.5V3.25A2.25 2.25 0 0019.5 1h-15zm15.75 12.75H3.75V3.25a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v10.5zM1.563 19.448l1.92-4.198h17.035l1.92 4.198a.75.75 0 01-.688 1.052H2.25a.75.75 0 01-.687-1.052z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "laptop-smiley_svg__laptop-smiley_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $db83448bd2182115$var$__assign = undefined && undefined.__assign || function() {
    $db83448bd2182115$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $db83448bd2182115$var$__assign.apply(this, arguments);
};
var $db83448bd2182115$export$4574c7fd55cd3f3 = $denZA.forwardRef(function LayoutDiagram(props, svgRef) {
    return $denZA.createElement("svg", $db83448bd2182115$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-3v3H18a2.25 2.25 0 012.25 2.25V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75h3v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 01.75 15h3v-.75A2.25 2.25 0 016 12h5.25V9h-3a.75.75 0 01-.75-.75V.75zM15 7.5v-6H9v6h6zm-13.5 9h6v6h-6v-6zm15 6v-6h6v6h-6z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $639dcad09a2bf100$var$__assign = undefined && undefined.__assign || function() {
    $639dcad09a2bf100$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $639dcad09a2bf100$var$__assign.apply(this, arguments);
};
var $639dcad09a2bf100$export$24a3cfb04e7f826e = $denZA.forwardRef(function LayoutDiagramBold(props, svgRef) {
    return $denZA.createElement("svg", $639dcad09a2bf100$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M8.25 0a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h2.625v2.625H6a2.625 2.625 0 00-2.625 2.625V15H.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H5.625v-.75A.375.375 0 016 13.875h12a.375.375 0 01.375.375V15H15.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-2.625v-.75A2.625 2.625 0 0018 11.625h-4.875V9h2.625a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-7.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $445b2bb7285c6a15$var$__assign = undefined && undefined.__assign || function() {
    $445b2bb7285c6a15$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $445b2bb7285c6a15$var$__assign.apply(this, arguments);
};
var $445b2bb7285c6a15$export$f90ad0f3c590b2cb = $denZA.forwardRef(function LayoutGridView(props, svgRef) {
    return $denZA.createElement("svg", $445b2bb7285c6a15$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9A.75.75 0 010 9.75v-9zm1.5.75V9H9V1.5H1.5zM0 14.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75v7.5H9V15H1.5zM13.5.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75V9h7.5V1.5H15zm-1.5 12.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM15 15v7.5h7.5V15H15z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b9c310b25806844f$var$__assign = undefined && undefined.__assign || function() {
    $b9c310b25806844f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9c310b25806844f$var$__assign.apply(this, arguments);
};
var $b9c310b25806844f$export$3eb98c9b2991c13c = $denZA.forwardRef(function LayoutGridViewBold(props, svgRef) {
    return $denZA.createElement("svg", $b9c310b25806844f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM13.5.773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $d119bebc966d779a$var$__assign = undefined && undefined.__assign || function() {
    $d119bebc966d779a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d119bebc966d779a$var$__assign.apply(this, arguments);
};
var $d119bebc966d779a$export$b73dd58f0dc7b9ee = $denZA.forwardRef(function LayoutList(props, svgRef) {
    return $denZA.createElement("svg", $d119bebc966d779a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.66 2a2.66 2.66 0 100 5.32 2.66 2.66 0 000-5.32zm-.482 1.496a1.26 1.26 0 11.964 2.328 1.26 1.26 0 01-.964-2.328zM3.66 9.84a2.66 2.66 0 100 5.318 2.66 2.66 0 000-5.318zm-.482 1.496a1.26 1.26 0 11.964 2.329 1.26 1.26 0 01-.964-2.33zm-.536 6.546a2.661 2.661 0 013.475 3.476 2.66 2.66 0 11-3.475-3.476zM3.66 19.08a1.258 1.258 0 00-.891 2.15 1.26 1.26 0 10.891-2.15z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M8.233 4.613a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233zm-.7 8.54a.7.7 0 01.7-.7H21.3a.7.7 0 110 1.4H8.233a.7.7 0 01-.7-.7zm.7 7.14a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9b681311c3718817$var$__assign = undefined && undefined.__assign || function() {
    $9b681311c3718817$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b681311c3718817$var$__assign.apply(this, arguments);
};
var $9b681311c3718817$export$8c8aefe5a4ba5254 = $denZA.forwardRef(function LayoutListBold(props, svgRef) {
    return $denZA.createElement("svg", $9b681311c3718817$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M3.13 1a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm0 8.018a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm-1.198 8.256a3.13 3.13 0 013.41 5.105 3.13 3.13 0 11-3.41-5.105zM8.761 3.298a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761zm-1.5 9.518a1.5 1.5 0 011.5-1.5h13.364a1.5 1.5 0 110 3H8.761a1.5 1.5 0 01-1.5-1.5zm1.5 6.518a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761z"
    }));
});



var $denZA = parcelRequire("denZA");
var $87b87a2184a9434b$var$__assign = undefined && undefined.__assign || function() {
    $87b87a2184a9434b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87b87a2184a9434b$var$__assign.apply(this, arguments);
};
var $87b87a2184a9434b$export$d57cd6dbf45f4bdf = $denZA.forwardRef(function LayoutListView(props, svgRef) {
    return $denZA.createElement("svg", $87b87a2184a9434b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm1.5.75v3h21v-3h-21zM0 9.75A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21zM0 18.75A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $15aa9792f8c58fc0$var$__assign = undefined && undefined.__assign || function() {
    $15aa9792f8c58fc0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15aa9792f8c58fc0$var$__assign.apply(this, arguments);
};
var $15aa9792f8c58fc0$export$faa3c8ce2462319b = $denZA.forwardRef(function LayoutListViewBold(props, svgRef) {
    return $denZA.createElement("svg", $15aa9792f8c58fc0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm0 9A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm0 9A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $84f7c2dde47e8b97$var$__assign = undefined && undefined.__assign || function() {
    $84f7c2dde47e8b97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84f7c2dde47e8b97$var$__assign.apply(this, arguments);
};
var $84f7c2dde47e8b97$export$3c505bfe7119a36a = $denZA.forwardRef(function LearningLibrary(props, svgRef) {
    return $denZA.createElement("svg", $84f7c2dde47e8b97$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#learning-library_svg__learning-library_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M2.213 2.273l.183.005c3.703.192 6.703 1.053 8.547 2.339a.75.75 0 11-.858 1.23C8.496 4.74 5.762 3.954 2.304 3.775a.75.75 0 00-.797.648l-.007.104v13.356a.747.747 0 00.69.753c5.618.253 9.792 2.08 10.525 4.388a.75.75 0 01-1.392.549l-.038-.095c-.486-1.532-4.106-3.116-9.174-3.345a2.25 2.25 0 01-2.107-2.101L0 17.878V4.528a2.25 2.25 0 012.213-2.255z"
    }), $denZA.createElement("path", {
        d: "M23.25 8.25a.75.75 0 01.743.648L24 9v8.873a2.253 2.253 0 01-2.123 2.261c-4.938.223-8.507 1.74-9.123 3.237l-.04.107a.75.75 0 11-1.429-.454c.733-2.308 4.907-4.135 10.512-4.388a.75.75 0 00.697-.659l.006-.099V9a.75.75 0 01.75-.75zM3.852 6.728c1.96.22 3.889.67 5.745 1.34a.75.75 0 11-.51 1.41 23.688 23.688 0 00-5.403-1.26.75.75 0 01.066-1.495l.102.005zm.002 3.815a25.71 25.71 0 015.74 1.339.75.75 0 11-.505 1.412 24.267 24.267 0 00-5.407-1.26.75.75 0 01.07-1.496l.102.005zM3.7 14.582l.101.005a26 26 0 015.792 1.338.75.75 0 01-.502 1.414 24.496 24.496 0 00-5.458-1.262.75.75 0 01.066-1.495z"
    }), $denZA.createElement("path", {
        d: "M12 9.751a.75.75 0 01.743.648l.007.102v12.75a.75.75 0 01-1.493.102l-.007-.102v-12.75a.75.75 0 01.75-.75zm5.25-9.75a.75.75 0 01.743.648L18 .751v1.5a.75.75 0 01-1.493.102L16.5 2.25V.75a.75.75 0 01.75-.75zM11.909 2.69a.75.75 0 01.976-.072l.084.073 1.061 1.06a.75.75 0 01-.976 1.134l-.084-.073-1.061-1.06a.75.75 0 010-1.061zm9.621 0a.75.75 0 011.134.977l-.073.084-1.06 1.061a.75.75 0 01-1.134-.976l.073-.084 1.06-1.061zm-4.28 9.311a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102l-.007-.102v-1.5a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M13.664 7.14a3.75 3.75 0 001.218 4.005l.118.091v1.515c0 .414.336.75.75.75h3l.102-.007a.75.75 0 00.648-.743v-1.514l.164-.129a3.75 3.75 0 10-5.936-4.16l-.064.192zm3.984-1.118a2.25 2.25 0 01.729 4.162l-.094.065a.75.75 0 00-.283.586v1.166h-1.5v-1.166a.75.75 0 00-.375-.65 2.25 2.25 0 011.523-4.163z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "learning-library_svg__learning-library_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $ad9d55c1411584ac$var$__assign = undefined && undefined.__assign || function() {
    $ad9d55c1411584ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad9d55c1411584ac$var$__assign.apply(this, arguments);
};
var $ad9d55c1411584ac$export$cccceed87933e06f = $denZA.forwardRef(function LearningLibraryBold(props, svgRef) {
    return $denZA.createElement("svg", $ad9d55c1411584ac$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#learning-library-bold_svg__learning-library-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M17.39 3.09a1 1 0 001-1v-1a1 1 0 10-2 0v1a1 1 0 001 1zm3.86 1.11a1 1 0 00.75-.35l.65-.77a1 1 0 00-1.52-1.28l-.65.76a1 1 0 00.76 1.65l.01-.01zm-8.48-.35a1 1 0 001.53-1.29l-.64-.76a1 1 0 00-1.53 1.29l.64.76zM23 7.47a1 1 0 00-1 1v9.83a18.159 18.159 0 00-9 2.6V6.11A1.31 1.31 0 0012.37 5c-.95-.58-5.94-3.43-11.26-2.56A1.32 1.32 0 000 3.74v15a1.32 1.32 0 001.21 1.32c3.55.29 8.21 1.33 9.65 3.32a1.33 1.33 0 001 .55h.09a1.29 1.29 0 00.93-.4c.68-.71 3.39-3 9.83-3.29a1.32 1.32 0 001.29-1.3V8.47a1 1 0 00-1-1zm-12.87 5.48a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74c1.874.127 3.725.486 5.51 1.07a.83.83 0 01.51 1.05zm0 4a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74c1.878.159 3.73.552 5.51 1.17a.83.83 0 01.51 1v-.05zM9.9 9.26a.78.78 0 01-.78.16 20.88 20.88 0 00-5.17-1 .84.84 0 01-.43-1.46.77.77 0 01.59-.18 22.63 22.63 0 015.51 1.08.82.82 0 01.53.62.84.84 0 01-.25.78z"
    }), $denZA.createElement("path", {
        d: "M15.25 10.89v1.22a.75.75 0 00.75.75h.5v.67a1 1 0 002 0v-.67h.6a.75.75 0 00.65-.74v-1.2a4 4 0 10-4.5 0v-.03zm.3-3.24a2 2 0 11.15.758 2 2 0 01-.15-.768v.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "learning-library-bold_svg__learning-library-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $6a0020419bed7afc$var$__assign = undefined && undefined.__assign || function() {
    $6a0020419bed7afc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a0020419bed7afc$var$__assign.apply(this, arguments);
};
var $6a0020419bed7afc$export$5047665d7d511e82 = $denZA.forwardRef(function LevelIndicator(props, svgRef) {
    return $denZA.createElement("svg", $6a0020419bed7afc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 3.771a11.961 11.961 0 00-8.52 3.6A12.054 12.054 0 000 15.943v2.074a2.253 2.253 0 002.246 2.245h19.508A2.253 2.253 0 0024 18.017v-2.074c.05-6.653-5.332-12.12-12-12.173zm-.017 12.754h.034a2.25 2.25 0 012.229 2.246H9.754a2.25 2.25 0 012.229-2.246zm10.525 1.492a.761.761 0 01-.754.754h-6c0-1.714-1.166-3.171-2.76-3.617l1.972-5.897a.736.736 0 00-.48-.943.736.736 0 00-.943.48l-2.092 6.274a3.761 3.761 0 00-3.188 3.703h-6a.761.761 0 01-.754-.754v-2.074A10.535 10.535 0 014.56 8.434 10.389 10.389 0 0112 5.28c5.828.034 10.543 4.817 10.508 10.663v2.074z"
    }), $denZA.createElement("path", {
        d: "M4.869 16.525a1.131 1.131 0 100-2.262 1.131 1.131 0 000 2.262zm1.508-6a1.13 1.13 0 100 2.263 1.12 1.12 0 001.132-1.131 1.13 1.13 0 00-1.132-1.132zm12.754 6a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm-.377-4.868c0-.6-.48-1.097-1.08-1.114h-.12a1.138 1.138 0 00-1.063 1.114 1.13 1.13 0 102.263 0zM9.429 7.526c-.018 0-.018 0 0 0h-.12A1.138 1.138 0 008.246 8.64a1.13 1.13 0 001.131 1.13 1.12 1.12 0 001.131-1.131c0-.6-.497-1.097-1.08-1.114z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9961f8260882004d$var$__assign = undefined && undefined.__assign || function() {
    $9961f8260882004d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9961f8260882004d$var$__assign.apply(this, arguments);
};
var $9961f8260882004d$export$b0288941685426f5 = $denZA.forwardRef(function LevelIndicatorBold(props, svgRef) {
    return $denZA.createElement("svg", $9961f8260882004d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 4C8.8 4 5.7 5.3 3.5 7.6 1.2 9.9 0 12.9 0 16.2v2.1c0 1.2 1 2.2 2.2 2.2h5.6c.5 0 .4-1 .4-1.5 0-1.9 1.4-3.4 3.2-3.7L13.5 9c.1-.4.5-.6.9-.5.4.1.6.5.5.9l-2 5.9c1.4.4 2.4 1.5 2.7 2.9 0 .2.1.5.1.7 0 .5-.3 1.5.5 1.5h5.5c1.2 0 2.2-1 2.2-2.2v-2.1C24.1 9.5 18.7 4.1 12 4zm7 7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.3 1.3-1.4h.1c.8 0 1.4.7 1.4 1.4zm.1 5.1c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM7 13.1c-.2.1-.4.2-.6.2-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.2 0 .4.1.6.2.4.2.8.7.8 1.2s-.3 1-.8 1.2zm-2.1 1.1c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.4 1.4-1.4zm4.5-4c-.8 0-1.4-.6-1.4-1.3 0-.2.1-.4.2-.6.2-.4.6-.7 1.1-.7h.1c.5 0 .9.3 1.2.7.1.2.2.4.2.6 0 .7-.7 1.3-1.4 1.3z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f1c024a974f78031$var$__assign = undefined && undefined.__assign || function() {
    $f1c024a974f78031$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1c024a974f78031$var$__assign.apply(this, arguments);
};
var $f1c024a974f78031$export$a6c7ac8248d6e38a = $denZA.forwardRef(function Link(props, svgRef) {
    return $denZA.createElement("svg", $f1c024a974f78031$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M22.2 4.3c-.9-.9-2-1.3-3.2-1.3-1.2 0-2.4.5-3.2 1.3-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0 1.2-1.2 3.2-1.2 4.4 0 .4.6.7 1.4.7 2.2 0 .8-.3 1.6-.9 2.2l-5.6 5.6c-.5.5-1.3.9-2.1.9s-1.5-.2-2.1-.7c-.6-.5-1-1.2-1.1-2 0-.8.2-1.6.6-2.2.2-.3.2-.8-.2-1-.3-.2-.8-.2-1 .2-.7.9-1 2.1-.8 3.2.1 1.1.7 2.2 1.6 2.9.8.7 1.9 1.1 3 1.1h.2c1.2 0 2.2-.5 3.1-1.3l5.6-5.6c.9-.9 1.3-2 1.3-3.2 0-1.2-.6-2.5-1.4-3.4z"
    }), $denZA.createElement("path", {
        d: "M7.8 17.8c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2L9 7.8c.5-.5 1.3-.8 2-.9.8 0 1.5.2 2.1.7.6.5 1 1.2 1.1 2 .1.8-.1 1.5-.6 2.2-.2.3-.2.8.2 1 .3.2.8.2 1-.2.7-.9 1-2.1.8-3.2-.1-1.1-.7-2.2-1.6-2.9-.9-.8-2-1.1-3.2-1.1-1 .1-2.1.6-2.9 1.4l-5.6 5.6c-.9.9-1.3 2-1.3 3.2 0 1.2.5 2.4 1.3 3.2.9.9 2 1.3 3.2 1.3 1.2 0 2.4-.5 3.2-1.3.3-.3.3-.8 0-1.1-.3-.3-.6-.2-.9.1z"
    }));
});



var $denZA = parcelRequire("denZA");
var $13d1cf1a03a31b11$var$__assign = undefined && undefined.__assign || function() {
    $13d1cf1a03a31b11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13d1cf1a03a31b11$var$__assign.apply(this, arguments);
};
var $13d1cf1a03a31b11$export$6343830e6ea0f555 = $denZA.forwardRef(function LinkBold(props, svgRef) {
    return $denZA.createElement("svg", $13d1cf1a03a31b11$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M17.02 6.183a2.331 2.331 0 113.297 3.297l-5.588 5.588a2.332 2.332 0 01-3.536-3.018 1.5 1.5 0 00-2.426-1.764 5.332 5.332 0 008.085 6.902l5.586-5.586a5.331 5.331 0 10-7.54-7.54 1.5 1.5 0 102.122 2.12z"
    }), $denZA.createElement("path", {
        d: "M6.98 17.506a2.332 2.332 0 01-3.297-3.298L9.27 8.62a2.332 2.332 0 013.536 3.019 1.5 1.5 0 002.426 1.764A5.331 5.331 0 007.148 6.5l-5.586 5.587a5.332 5.332 0 007.54 7.54 1.5 1.5 0 10-2.122-2.121z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6300fe37dd0d1e55$var$__assign = undefined && undefined.__assign || function() {
    $6300fe37dd0d1e55$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6300fe37dd0d1e55$var$__assign.apply(this, arguments);
};
var $6300fe37dd0d1e55$export$633fe2b1e4202809 = $denZA.forwardRef(function ListSearch(props, svgRef) {
    return $denZA.createElement("svg", $6300fe37dd0d1e55$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.356 0h19.267a2.369 2.369 0 012.363 2.361v8.133a.75.75 0 01-1.5 0V5.997H1.5v12.625a.87.87 0 00.866.867H6.76a.75.75 0 010 1.499h-4.4A2.369 2.369 0 010 18.625V2.353A2.36 2.36 0 012.353 0h.003zm-.857 4.497h20.988V2.365a.87.87 0 00-.867-.866H2.357a.862.862 0 00-.858.858v2.14z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M17.643 12.835a.75.75 0 010 1.06l-2.998 2.998a.75.75 0 01-1.06 0l-1.5-1.499a.75.75 0 111.06-1.06l.97.97 2.468-2.469a.75.75 0 011.06 0z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.331 8.749a6.62 6.62 0 017.714 10.236l3.735 3.735a.75.75 0 11-1.06 1.06l-3.735-3.735a6.621 6.621 0 01-10.236-2.648 6.62 6.62 0 013.582-8.648zm2.533.995a5.121 5.121 0 100 10.242 5.121 5.121 0 000-10.242z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $6a77d94ed7833686$var$__assign = undefined && undefined.__assign || function() {
    $6a77d94ed7833686$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a77d94ed7833686$var$__assign.apply(this, arguments);
};
var $6a77d94ed7833686$export$21cdcd57c45bce1 = $denZA.forwardRef(function ListSearchBold(props, svgRef) {
    return $denZA.createElement("svg", $6a77d94ed7833686$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 16.8h6.25c.552 0 1 .43 1 .96s-.448.96-1 .96H3c-1.657 0-3-1.29-3-2.88V2.88C0 1.29 1.343 0 3 0h15.5c1.657 0 3 1.29 3 2.88v6.48c0 .53-.448.96-1 .96s-1-.43-1-.96V7.2a.49.49 0 00-.5-.48H2.5a.49.49 0 00-.5.48v8.64c0 .53.448.96 1 .96zm8-13.44c0-.53-.448-.96-1-.96s-1 .43-1 .96.448.96 1 .96 1-.43 1-.96zM7 2.4c.552 0 1 .43 1 .96s-.448.96-1 .96-1-.43-1-.96.448-.96 1-.96zm-2 .96c0-.53-.448-.96-1-.96s-1 .43-1 .96.448.96 1 .96 1-.43 1-.96z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.64 19.15a.233.233 0 00.034.3l2.033 1.951a.934.934 0 01.259.927.981.981 0 01-.707.68 1.03 1.03 0 01-.966-.248l-2.033-1.953a.259.259 0 00-.311-.032c-2.367 1.445-5.487.95-7.242-1.151-1.755-2.1-1.583-5.132.4-7.036 1.983-1.905 5.14-2.072 7.33-.388 2.188 1.683 2.707 4.678 1.203 6.95zm-8.14-2.83c0 1.855 1.567 3.36 3.5 3.36s3.5-1.505 3.5-3.36c0-1.856-1.567-3.36-3.5-3.36s-3.5 1.504-3.5 3.36z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10.528 8.697l-3.41 3.415a.255.255 0 01-.361 0l-.535-.536a1.026 1.026 0 00-.969-.286.983.983 0 00-.731.673.934.934 0 00.256.941l1.438 1.44c.189.189.45.296.721.296.273 0 .533-.107.722-.296l4.313-4.32a.934.934 0 00.256-.941.983.983 0 00-.732-.673c-.353-.08-.723.03-.968.287z"
    }));
});



var $denZA = parcelRequire("denZA");
var $2164dd66671e2e77$var$__assign = undefined && undefined.__assign || function() {
    $2164dd66671e2e77$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2164dd66671e2e77$var$__assign.apply(this, arguments);
};
var $2164dd66671e2e77$export$18a2be9195644f38 = $denZA.forwardRef(function Location(props, svgRef) {
    return $denZA.createElement("svg", $2164dd66671e2e77$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#location_svg__location_svg__clip0)",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }, $denZA.createElement("path", {
        d: "M8.818 5.068a4.5 4.5 0 116.364 6.364 4.5 4.5 0 01-6.364-6.364zM12 5.25a3 3 0 100 6 3 3 0 000-6z"
    }), $denZA.createElement("path", {
        d: "M12 1.5a6.75 6.75 0 00-6.75 6.75c0 .706.273 1.77.772 3.08.49 1.287 1.167 2.732 1.907 4.169 1.48 2.874 3.184 5.665 4.071 7.001.887-1.336 2.591-4.127 4.071-7.001.74-1.438 1.417-2.883 1.907-4.17.499-1.308.772-2.373.772-3.079A6.75 6.75 0 0012 1.5zM12 0a8.25 8.25 0 00-8.25 8.25c0 .997.361 2.278.87 3.614.518 1.358 1.222 2.857 1.975 4.321 1.508 2.928 3.24 5.766 4.155 7.145a1.5 1.5 0 002.5 0c.914-1.379 2.647-4.217 4.155-7.145.753-1.463 1.457-2.963 1.975-4.321.509-1.336.87-2.617.87-3.614A8.25 8.25 0 0012 0z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "location_svg__location_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $e5c45790d500d023$var$__assign = undefined && undefined.__assign || function() {
    $e5c45790d500d023$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5c45790d500d023$var$__assign.apply(this, arguments);
};
var $e5c45790d500d023$export$d63fce71f4dc7df5 = $denZA.forwardRef(function LocationBold(props, svgRef) {
    return $denZA.createElement("svg", $e5c45790d500d023$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#location-bold_svg__location-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.166 2.416A8.25 8.25 0 0120.25 8.25c0 .997-.361 2.278-.87 3.614-.518 1.358-1.222 2.857-1.975 4.321-1.508 2.928-3.24 5.766-4.155 7.145a1.5 1.5 0 01-2.5 0c-.914-1.379-2.647-4.217-4.155-7.145-.753-1.463-1.457-2.963-1.975-4.321-.509-1.336-.87-2.617-.87-3.614a8.25 8.25 0 012.416-5.834zm3.536 8.132a3.25 3.25 0 114.596-4.596 3.25 3.25 0 01-4.596 4.596z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "location-bold_svg__location-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $96fe4a23f20f60eb$var$__assign = undefined && undefined.__assign || function() {
    $96fe4a23f20f60eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96fe4a23f20f60eb$var$__assign.apply(this, arguments);
};
var $96fe4a23f20f60eb$export$5b9db7ce80343746 = $denZA.forwardRef(function Lock(props, svgRef) {
    return $denZA.createElement("svg", $96fe4a23f20f60eb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.75 14a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6 6v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V8.75a.75.75 0 00-.75-.75H18V6A6 6 0 106 6zm6-4.5A4.5 4.5 0 007.5 6v2h9V6A4.5 4.5 0 0012 1.5zm-7.5 8h15v12h-15v-12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $7a4aeb18f3dc277b$var$__assign = undefined && undefined.__assign || function() {
    $7a4aeb18f3dc277b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a4aeb18f3dc277b$var$__assign.apply(this, arguments);
};
var $7a4aeb18f3dc277b$export$4038de8e7cd615d7 = $denZA.forwardRef(function LockBold(props, svgRef) {
    return $denZA.createElement("svg", $7a4aeb18f3dc277b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .625A6.375 6.375 0 005.625 7v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-1.875V7A6.375 6.375 0 0012 .625zM16.125 7v2h-8.25V7a4.125 4.125 0 018.25 0zm-5.25 8a1.125 1.125 0 012.25 0v3a1.125 1.125 0 01-2.25 0v-3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $ba0694079806f420$var$__assign = undefined && undefined.__assign || function() {
    $ba0694079806f420$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba0694079806f420$var$__assign.apply(this, arguments);
};
var $ba0694079806f420$export$88195aaac9f90319 = $denZA.forwardRef(function LogIn(props, svgRef) {
    return $denZA.createElement("svg", $ba0694079806f420$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.727 1.393h.037a2.09 2.09 0 011.985 2.165v16.769a2.09 2.09 0 01-2.022 2.164H9.235a2.09 2.09 0 01-1.985-2.164v-4.185a.75.75 0 011.5 0v4.2l-.001.033a.591.591 0 00.546.616h11.409a.591.591 0 00.545-.65V3.509a.59.59 0 00-.545-.615H9.295a.591.591 0 00-.545.65v4.2a.75.75 0 01-1.5 0V3.557a2.091 2.091 0 012.023-2.165h11.454z"
    }), $denZA.createElement("path", {
        d: "M12.169 7.916a.75.75 0 000 1.06l2.22 2.22H1.5a.75.75 0 000 1.5h12.888l-2.22 2.22a.75.75 0 001.062 1.06l3.496-3.496a.754.754 0 00.17-.81.747.747 0 00-.167-.254l-3.5-3.5a.75.75 0 00-1.06 0z"
    }));
});



var $denZA = parcelRequire("denZA");
var $53fe70ec408b3fb8$var$__assign = undefined && undefined.__assign || function() {
    $53fe70ec408b3fb8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53fe70ec408b3fb8$var$__assign.apply(this, arguments);
};
var $53fe70ec408b3fb8$export$c9b57264511cea21 = $denZA.forwardRef(function LogInBold(props, svgRef) {
    return $denZA.createElement("svg", $53fe70ec408b3fb8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20.727.5a2.84 2.84 0 012.772 2.928V20.17a2.841 2.841 0 01-2.772 2.928H9.273c-.025 0-.05 0-.075-.002A2.841 2.841 0 016.5 20.17V18a1.5 1.5 0 013 0v2.099h10.999V3.5h-11V6a1.5 1.5 0 11-3 0V3.427A2.841 2.841 0 019.274.5h11.454z"
    }), $denZA.createElement("path", {
        d: "M11.639 7.243a1.5 1.5 0 000 2.12l.939.94H1.5a1.5 1.5 0 100 3h11.078l-.94.94a1.5 1.5 0 102.122 2.12l3.495-3.494a1.495 1.495 0 00.334-1.631 1.496 1.496 0 00-.33-.496l-3.5-3.5a1.5 1.5 0 00-2.12 0z"
    }));
});



var $denZA = parcelRequire("denZA");
var $0866d530aa5f91de$var$__assign = undefined && undefined.__assign || function() {
    $0866d530aa5f91de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0866d530aa5f91de$var$__assign.apply(this, arguments);
};
var $0866d530aa5f91de$export$f292abd37582246c = $denZA.forwardRef(function LogOut(props, svgRef) {
    return $denZA.createElement("svg", $0866d530aa5f91de$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.507 2h.037A2.058 2.058 0 0123.5 4.133V20.5a2.06 2.06 0 01-1.992 2.132h-11.22A2.059 2.059 0 018.333 20.5v-4.084a.75.75 0 011.5 0v4.1a.56.56 0 00.515.617h11.136a.559.559 0 00.515-.617V4.082a.558.558 0 00-.515-.582H10.348a.56.56 0 00-.515.617v4.1a.75.75 0 11-1.5 0V4.131A2.06 2.06 0 0110.326 2h11.18z"
    }), $denZA.createElement("path", {
        d: "M5.697 8.373a.75.75 0 00-1.06 0l-3.41 3.41a.748.748 0 000 1.075l3.41 3.408a.75.75 0 101.06-1.06L3.56 13.07h12.538a.75.75 0 100-1.5H3.561l2.136-2.136a.75.75 0 000-1.061z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c293547be4529b47$var$__assign = undefined && undefined.__assign || function() {
    $c293547be4529b47$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c293547be4529b47$var$__assign.apply(this, arguments);
};
var $c293547be4529b47$export$e2c9b76f2918cc76 = $denZA.forwardRef(function LogOutBold(props, svgRef) {
    return $denZA.createElement("svg", $c293547be4529b47$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.257.75a2.808 2.808 0 012.742 2.894v16.344a2.809 2.809 0 01-2.742 2.894H10.076c-.025 0-.05 0-.075-.002a2.81 2.81 0 01-2.668-2.892V18a1.5 1.5 0 113 0v1.882h10.666V3.75H10.333V5.5a1.5 1.5 0 01-3 0V3.644A2.81 2.81 0 0110.076.75h11.18z"
    }), $denZA.createElement("path", {
        d: "M5.977 7.343a1.5 1.5 0 00-2.121 0L.45 10.749a1.5 1.5 0 000 2.142l3.406 3.406a1.5 1.5 0 102.121-2.122l-.856-.855H15.85a1.5 1.5 0 000-3H5.121l.856-.856a1.5 1.5 0 000-2.121z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6a41de9631eb6a8b$var$__assign = undefined && undefined.__assign || function() {
    $6a41de9631eb6a8b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a41de9631eb6a8b$var$__assign.apply(this, arguments);
};
var $6a41de9631eb6a8b$export$2a4143257785f953 = $denZA.forwardRef(function MenuNavigationHorizontal(props, svgRef) {
    return $denZA.createElement("svg", $6a41de9631eb6a8b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M5.5 12a2 2 0 11-4 0 2 2 0 014 0zm8.5 0a2 2 0 11-4 0 2 2 0 014 0zm6.5 2a2 2 0 100-4 2 2 0 000 4z"
    }));
});



var $denZA = parcelRequire("denZA");
var $5a69fb346b32f070$var$__assign = undefined && undefined.__assign || function() {
    $5a69fb346b32f070$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5a69fb346b32f070$var$__assign.apply(this, arguments);
};
var $5a69fb346b32f070$export$e01a035729e5e1c1 = $denZA.forwardRef(function MenuNavigationHorizontalBold(props, svgRef) {
    return $denZA.createElement("svg", $5a69fb346b32f070$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M6.5 12a3 3 0 11-6 0 3 3 0 016 0zm8.5 0a3 3 0 11-6 0 3 3 0 016 0zm5.5 3a3 3 0 100-6 3 3 0 000 6z"
    }));
});



var $denZA = parcelRequire("denZA");
var $769236051d0b7687$var$__assign = undefined && undefined.__assign || function() {
    $769236051d0b7687$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $769236051d0b7687$var$__assign.apply(this, arguments);
};
var $769236051d0b7687$export$56dbed97f074c6e4 = $denZA.forwardRef(function MenuNavigationVertical(props, svgRef) {
    return $denZA.createElement("svg", $769236051d0b7687$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.75 16.903a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $84adab97705cd2af$var$__assign = undefined && undefined.__assign || function() {
    $84adab97705cd2af$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84adab97705cd2af$var$__assign.apply(this, arguments);
};
var $84adab97705cd2af$export$e738f441fd7fb6d9 = $denZA.forwardRef(function MenuNavigationVerticalBold(props, svgRef) {
    return $denZA.createElement("svg", $84adab97705cd2af$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M1 6.5A1.5 1.5 0 012.5 5h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 6.5zm0 6A1.5 1.5 0 012.5 11h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 12.5zM2.5 17a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3h-19z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f2a0cb2e911f0fb7$var$__assign = undefined && undefined.__assign || function() {
    $f2a0cb2e911f0fb7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2a0cb2e911f0fb7$var$__assign.apply(this, arguments);
};
var $f2a0cb2e911f0fb7$export$da45d96ed490d127 = $denZA.forwardRef(function Minus(props, svgRef) {
    return $denZA.createElement("svg", $f2a0cb2e911f0fb7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.913 12a.75.75 0 01-.75.75H.837a.75.75 0 010-1.5h22.326a.75.75 0 01.75.75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $97c13c2de352bd3a$var$__assign = undefined && undefined.__assign || function() {
    $97c13c2de352bd3a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97c13c2de352bd3a$var$__assign.apply(this, arguments);
};
var $97c13c2de352bd3a$export$b7a01a7ec68fd5c0 = $denZA.forwardRef(function MinusBold(props, svgRef) {
    return $denZA.createElement("svg", $97c13c2de352bd3a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.935 12a1.5 1.5 0 01-1.5 1.5H1.565a1.5 1.5 0 010-3h20.87a1.5 1.5 0 011.5 1.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $69d2b613242b66a1$var$__assign = undefined && undefined.__assign || function() {
    $69d2b613242b66a1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69d2b613242b66a1$var$__assign.apply(this, arguments);
};
var $69d2b613242b66a1$export$e49a5ad3dd6df925 = $denZA.forwardRef(function Move(props, svgRef) {
    return $denZA.createElement("svg", $69d2b613242b66a1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M8.47 5.532a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06l-1.72 1.72h7.44v-7.44l-1.72 1.72a.75.75 0 01-1.06 0z"
    }));
});



var $denZA = parcelRequire("denZA");
var $34a14f064c779561$var$__assign = undefined && undefined.__assign || function() {
    $34a14f064c779561$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34a14f064c779561$var$__assign.apply(this, arguments);
};
var $34a14f064c779561$export$a3c5fa6436f5d841 = $denZA.forwardRef(function MoveBold(props, svgRef) {
    return $denZA.createElement("svg", $34a14f064c779561$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.94 6.06a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 012.12 0l3 3a1.5 1.5 0 01-2.12 2.12l-.44-.439V10.5h4.879l-.44-.44a1.5 1.5 0 012.122-2.12l3 3a1.5 1.5 0 010 2.12l-3 3a1.5 1.5 0 01-2.122-2.12l.44-.44H13.5v4.879l.44-.44a1.5 1.5 0 012.12 2.122l-3 3a1.5 1.5 0 01-2.12 0l-3-3a1.5 1.5 0 012.12-2.122l.44.44V13.5H5.621l.44.44a1.5 1.5 0 01-2.122 2.12l-3-3a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 112.122 2.12l-.44.44H10.5V5.621l-.44.44a1.5 1.5 0 01-2.12 0z"
    }));
});



var $denZA = parcelRequire("denZA");
var $34bf557dba6d6ca9$var$__assign = undefined && undefined.__assign || function() {
    $34bf557dba6d6ca9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34bf557dba6d6ca9$var$__assign.apply(this, arguments);
};
var $34bf557dba6d6ca9$export$814afb5995e98181 = $denZA.forwardRef(function NetworkMonitor(props, svgRef) {
    return $denZA.createElement("svg", $34bf557dba6d6ca9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.125 0a.75.75 0 00-.75.75V7.5c0 .414.336.75.75.75h4.125v1.5H9.375a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H12.75v-1.5h4.125a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-9.75zm9 6.75V1.5h-8.25v5.25h8.25zM0 13.5a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75H6.375v1.5H8.25a.75.75 0 010 1.5H3a.75.75 0 010-1.5h1.875V21H.75a.75.75 0 01-.75-.75V13.5zm9.75 6v-5.25H1.5v5.25h8.25zm3-6a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75h-4.125v1.5H21a.75.75 0 010 1.5h-5.25a.75.75 0 010-1.5h1.875V21H13.5a.75.75 0 01-.75-.75V13.5zm9.75 6h-8.25v-5.25h8.25v5.25z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $eb7008255885018c$var$__assign = undefined && undefined.__assign || function() {
    $eb7008255885018c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eb7008255885018c$var$__assign.apply(this, arguments);
};
var $eb7008255885018c$export$aa45e342fa88404f = $denZA.forwardRef(function Newspaper(props, svgRef) {
    return $denZA.createElement("svg", $eb7008255885018c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0h19.5A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25A2.25 2.25 0 010 21.75V2.25A2.25 2.25 0 012.25 0zm19.5 1.5H2.25a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75zm-1.5 12a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-.75 2.25a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zM18 19.5a.75.75 0 00-.75-.75H13.5l-.102.007a.75.75 0 00.102 1.493h3.75l.102-.007A.75.75 0 0018 19.5zm-8.25-6.75a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zm.75 3.75a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-3 2.25a.75.75 0 01.102 1.493l-.102.007H3.75a.75.75 0 01-.102-1.493l.102-.007H7.5zM4.5 3h15A1.5 1.5 0 0121 4.5V9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 9V4.5A1.5 1.5 0 014.5 3zm15 1.5h-15V9h15V4.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $3ca46b6696059ccb$var$__assign = undefined && undefined.__assign || function() {
    $3ca46b6696059ccb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ca46b6696059ccb$var$__assign.apply(this, arguments);
};
var $3ca46b6696059ccb$export$b8dad214827a9937 = $denZA.forwardRef(function NewspaperBold(props, svgRef) {
    return $denZA.createElement("svg", $3ca46b6696059ccb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M22 0H2a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2zm0 21.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19z"
    }), $denZA.createElement("path", {
        d: "M18.5 4h-13c-.69 0-1.25.56-1.25 1.25v2.5C4.25 8.44 4.81 9 5.5 9h13c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm-8 7H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm0 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm0 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm8.5 0h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5A.75.75 0 0019 18zm0-7h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5A.75.75 0 0019 11zm0 3.5h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $cacf4eb09d698425$var$__assign = undefined && undefined.__assign || function() {
    $cacf4eb09d698425$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cacf4eb09d698425$var$__assign.apply(this, arguments);
};
var $cacf4eb09d698425$export$b99d3348f709c998 = $denZA.forwardRef(function PieChart(props, svgRef) {
    return $denZA.createElement("svg", $cacf4eb09d698425$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.894 3.856A9.75 9.75 0 0014 1a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h9a.75.75 0 00.75-.75 9.75 9.75 0 00-2.856-6.894zM14.75 2.534A8.249 8.249 0 0122.216 10H14.75V2.534z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5.333 5.393A9.75 9.75 0 0110.75 3.75a.75.75 0 01.75.75v8.25h8.25a.75.75 0 01.75.75A9.75 9.75 0 115.333 5.393zM10 5.284a8.25 8.25 0 108.966 8.966H10.75a.75.75 0 01-.75-.75V5.284z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $6fa83091a6fb13cf$var$__assign = undefined && undefined.__assign || function() {
    $6fa83091a6fb13cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fa83091a6fb13cf$var$__assign.apply(this, arguments);
};
var $6fa83091a6fb13cf$export$656559010049c8e = $denZA.forwardRef(function Pin(props, svgRef) {
    return $denZA.createElement("svg", $6fa83091a6fb13cf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M16.307.125a2.203 2.203 0 00-2.589.895L9.922 6.986a8.1 8.1 0 00-5.446.98l.37.635-.372-.634a2.203 2.203 0 00-.441 3.46l3.5 3.5-7.318 7.318a.734.734 0 001.039 1.038l7.317-7.318 3.502 3.502a2.203 2.203 0 003.46-.44l.002-.003a8.1 8.1 0 00.979-5.445l5.965-3.797a2.204 2.204 0 00.376-3.416l-5.72-5.72a2.202 2.202 0 00-.828-.521zM4.976 9.463a.734.734 0 01.24-.228 6.63 6.63 0 014.882-.713.734.734 0 00.791-.32l4.068-6.393a.735.735 0 011.139-.125l5.72 5.72a.734.734 0 01-.125 1.139l-6.392 4.068a.734.734 0 00-.32.792 6.63 6.63 0 01-.713 4.881.734.734 0 01-1.153.146l-8.042-8.042a.735.735 0 01-.095-.925z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b1083f72bc9757c1$var$__assign = undefined && undefined.__assign || function() {
    $b1083f72bc9757c1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1083f72bc9757c1$var$__assign.apply(this, arguments);
};
var $b1083f72bc9757c1$export$88393934ec04748c = $denZA.forwardRef(function PinBold(props, svgRef) {
    return $denZA.createElement("svg", $b1083f72bc9757c1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M15.336.013a2.203 2.203 0 011.798.632l5.721 5.721a2.203 2.203 0 01-.376 3.416l-5.965 3.797a8.099 8.099 0 01-.98 5.445v.002a2.203 2.203 0 01-3.46.441L9.09 16.485 2.507 23.07c-.398.399-.969.52-1.472.365a.734.734 0 01-.97-.972 1.468 1.468 0 01.365-1.47l6.584-6.584-2.981-2.981a2.203 2.203 0 01.44-3.46l.373.634-.37-.635a8.1 8.1 0 015.446-.98l3.796-5.966A2.203 2.203 0 0115.336.013z"
    }));
});



var $denZA = parcelRequire("denZA");
var $8566a4064ae73515$var$__assign = undefined && undefined.__assign || function() {
    $8566a4064ae73515$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8566a4064ae73515$var$__assign.apply(this, arguments);
};
var $8566a4064ae73515$export$2d9ac7aa84f97a08 = $denZA.forwardRef(function Plus(props, svgRef) {
    return $denZA.createElement("svg", $8566a4064ae73515$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.75 1a.75.75 0 00-1.5 0v10.25H1a.75.75 0 000 1.5h10.25V23a.75.75 0 001.5 0V12.75H23a.75.75 0 000-1.5H12.75V1z"
    }));
});



var $denZA = parcelRequire("denZA");
var $2dba54b43697217b$var$__assign = undefined && undefined.__assign || function() {
    $2dba54b43697217b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2dba54b43697217b$var$__assign.apply(this, arguments);
};
var $2dba54b43697217b$export$2ef3672ebfdfd8df = $denZA.forwardRef(function PlusBold(props, svgRef) {
    return $denZA.createElement("svg", $2dba54b43697217b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M13.5 1.565a1.5 1.5 0 00-3 0V10.5H1.565a1.5 1.5 0 000 3H10.5v8.935a1.5 1.5 0 003 0V13.5h8.935a1.5 1.5 0 000-3H13.5V1.565z"
    }));
});



var $denZA = parcelRequire("denZA");
var $3bbf20f384d4e7c7$var$__assign = undefined && undefined.__assign || function() {
    $3bbf20f384d4e7c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bbf20f384d4e7c7$var$__assign.apply(this, arguments);
};
var $3bbf20f384d4e7c7$export$531cef85654f2406 = $denZA.forwardRef(function Print(props, svgRef) {
    return $denZA.createElement("svg", $3bbf20f384d4e7c7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M3.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm3.75 6.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H8.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 6V2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25A2.25 2.25 0 0124 8.25v7.5A2.25 2.25 0 0121.75 18H19.5v5.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5zm1.72-4.28a.75.75 0 01.53-.22h10.5a.75.75 0 01.75.75V6H6V2.25a.75.75 0 01.22-.53zM2.25 7.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75H4.5v-3.75a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v3.75h2.25a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25zm15.75 6v9H6v-9h12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $a2ec44eaf83fff38$var$__assign = undefined && undefined.__assign || function() {
    $a2ec44eaf83fff38$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2ec44eaf83fff38$var$__assign.apply(this, arguments);
};
var $a2ec44eaf83fff38$export$3326d4c83d14f416 = $denZA.forwardRef(function PrintBold(props, svgRef) {
    return $denZA.createElement("svg", $a2ec44eaf83fff38$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25a2.25 2.25 0 012.249 2.25v7.5a2.25 2.25 0 01-2.25 2.25H19.5v5.25a.75.75 0 01-.75.749H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5V2.25zm13 11.25h-11V22h11v-8.5zm0-8V2.25a.25.25 0 00-.25-.25H6.75a.25.25 0 00-.25.25V5.5h11zM2.75 9.75a1 1 0 011-1h1.5a1 1 0 010 2h-1.5a1 1 0 01-1-1z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M8.25 14.75a1 1 0 000 2h7.5a1 1 0 000-2h-7.5zm0 3a1 1 0 100 2h5.25a1 1 0 000-2H8.25z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c4b7651478188ca5$var$__assign = undefined && undefined.__assign || function() {
    $c4b7651478188ca5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4b7651478188ca5$var$__assign.apply(this, arguments);
};
var $c4b7651478188ca5$export$3b87754677f810a3 = $denZA.forwardRef(function ProfitAndLoss(props, svgRef) {
    return $denZA.createElement("svg", $c4b7651478188ca5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20 1.25a.75.75 0 01.743.648L20.75 2v7a.75.75 0 01-1.493.102L19.25 9V2a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M19.47 1.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073L20 3.061l-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3zM4 22.75a.75.75 0 01-.743-.648L3.25 22v-7a.75.75 0 011.493-.102L4.75 15v7a.75.75 0 01-.75.75z"
    }), $denZA.createElement("path", {
        d: "M4.53 22.53a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L4 20.939l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3zM13.5 8.25a.75.75 0 01.102 1.493l-.102.007h-2.033a.592.592 0 00-.305 1.1l.083.04 2.065.826a2.092 2.092 0 01-.613 4.028l-.166.006H10.5a.75.75 0 01-.102-1.493l.102-.007h2.032a.592.592 0 00.304-1.1l-.083-.042-2.066-.825a2.092 2.092 0 01.614-4.026l.166-.007H13.5z"
    }), $denZA.createElement("path", {
        d: "M12 7.5a.75.75 0 01.743.648l.007.102V9a.75.75 0 01-1.493.102L11.25 9v-.75A.75.75 0 0112 7.5zm0 6.75a.75.75 0 01.743.648l.007.102v.75a.75.75 0 01-1.493.102l-.007-.102V15a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M12 5.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm0 1.5a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $2979ccd6dcc35ba9$var$__assign = undefined && undefined.__assign || function() {
    $2979ccd6dcc35ba9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2979ccd6dcc35ba9$var$__assign.apply(this, arguments);
};
var $2979ccd6dcc35ba9$export$c09363a928487262 = $denZA.forwardRef(function ProfitAndLossBold(props, svgRef) {
    return $denZA.createElement("svg", $2979ccd6dcc35ba9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M20 1.25a.75.75 0 01.743.648L20.75 2v7a.75.75 0 01-1.493.102L19.25 9V2a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M19.47 1.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073L20 3.061l-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3zM4 22.75a.75.75 0 01-.743-.648L3.25 22v-7a.75.75 0 011.493-.102L4.75 15v7a.75.75 0 01-.75.75z"
    }), $denZA.createElement("path", {
        d: "M4.53 22.53a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L4 20.939l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3zM5 11.5A6.5 6.5 0 1011.5 5 6.508 6.508 0 005 11.5zm5.592-3.697l-.006-.008a.19.19 0 00.165-.2v-.35a.75.75 0 011.5 0v.335a.17.17 0 00.169.165h.581a.75.75 0 010 1.5h-2.035a.592.592 0 00-.219 1.141l2.062.826a2.078 2.078 0 01-.417 3.989.184.184 0 00-.137.2v.353a.75.75 0 01-1.5 0v-.334a.17.17 0 00-.164-.166H10a.75.75 0 010-1.5h2.033a.592.592 0 00.22-1.141l-2.061-.83a2.079 2.079 0 01.4-3.98z"
    }));
});



var $denZA = parcelRequire("denZA");
var $5e427d2658a73bed$var$__assign = undefined && undefined.__assign || function() {
    $5e427d2658a73bed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e427d2658a73bed$var$__assign.apply(this, arguments);
};
var $5e427d2658a73bed$export$323217037b764dc5 = $denZA.forwardRef(function Programming(props, svgRef) {
    return $denZA.createElement("svg", $5e427d2658a73bed$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M15.954 7.07a.75.75 0 10-1.06 1.061l2.404 2.405-2.404 2.405a.75.75 0 101.06 1.06l2.935-2.935a.75.75 0 000-1.06L15.954 7.07zm-6.848 0a.75.75 0 010 1.061l-2.404 2.405 2.404 2.405A.75.75 0 118.046 14L5.11 11.066a.75.75 0 010-1.06L8.046 7.07a.75.75 0 011.06 0zm4.584.768a.75.75 0 10-1.423-.474l-1.957 5.87a.75.75 0 101.423.474l1.957-5.87z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.75.003a.75.75 0 01.75.75v1.392l2.184-.672a10.364 10.364 0 018.477 1.078 8.862 8.862 0 007.076.974l2.37-.677a1.876 1.876 0 012.389 1.802v12.87a1.874 1.874 0 01-1.36 1.803l-2.987.854a10.365 10.365 0 01-8.278-1.138 8.856 8.856 0 00-7.25-.922l-2.621.81v4.26a.75.75 0 01-1.5 0V.753a.75.75 0 01.75-.75zm.75 17.353V3.714l2.625-.807a8.864 8.864 0 017.25.922 10.36 10.36 0 008.274 1.138l2.368-.677a.377.377 0 01.479.361v12.87a.375.375 0 01-.272.36l-2.987.854a8.866 8.866 0 01-7.08-.974 10.357 10.357 0 00-8.478-1.078l-2.179.673z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $8e86dbb767715de0$var$__assign = undefined && undefined.__assign || function() {
    $8e86dbb767715de0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e86dbb767715de0$var$__assign.apply(this, arguments);
};
var $8e86dbb767715de0$export$d5f8ac158b287764 = $denZA.forwardRef(function ProgrammingBold(props, svgRef) {
    return $denZA.createElement("svg", $8e86dbb767715de0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 22.5a1.5 1.5 0 01-3 0v-21a1.5 1.5 0 013 0v.025a.25.25 0 00.335.236l.717-.261a9.779 9.779 0 018.226 1.067 9.36 9.36 0 007.45 1.025L21.9 2.9A1.652 1.652 0 0124 4.485v13.159a1.655 1.655 0 01-1.2 1.583L20 20.1a10.33 10.33 0 01-8.248-1.129A8.766 8.766 0 004.371 18l-1.206.435A.25.25 0 003 18.67v3.83zM15.005 7.297a.75.75 0 00.215.734l2.293 2.293a.252.252 0 010 .354l-2.293 2.293a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3a.75.75 0 00-1.275.326zm-3.992 6.916a.751.751 0 01-.475-.949l2-6a.75.75 0 011.424.474l-2 6a.751.751 0 01-.949.475zM5 10.501c0 .199.08.39.22.53l3 3a.75.75 0 101.06-1.06l-2.293-2.293a.252.252 0 010-.354L9.28 8.031a.75.75 0 00-1.06-1.06l-3 3a.749.749 0 00-.22.53z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b4d8ec6d3365983a$var$__assign = undefined && undefined.__assign || function() {
    $b4d8ec6d3365983a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4d8ec6d3365983a$var$__assign.apply(this, arguments);
};
var $b4d8ec6d3365983a$export$f93ec6528f706bfe = $denZA.forwardRef(function Refresh(props, svgRef) {
    return $denZA.createElement("svg", $b4d8ec6d3365983a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M19.378 10.056a.746.746 0 00-.825.159l-2.667 2.667a.75.75 0 001.06 1.06l1.368-1.367a6.583 6.583 0 01-11.352 4.02.75.75 0 10-1.09 1.03 8.084 8.084 0 0013.948-5.082l1.4 1.4a.75.75 0 001.06-1.061l-2.664-2.664a.763.763 0 00-.238-.162zm-11.7.811a.776.776 0 00-1.092 0l-1.39 1.398v-.2c0-1.397.397-2.695 1.191-3.793.795-1.099 1.887-1.897 3.178-2.396 1.291-.5 2.681-.5 3.973-.2 1.29.4 2.482 1.098 3.277 2.196.298.3.695.4 1.092.1.298-.3.397-.699.1-1.098-1.093-1.298-2.483-2.196-4.072-2.596-1.59-.399-3.277-.399-4.866.2a8.206 8.206 0 00-3.873 2.995c-.993 1.398-1.49 2.995-1.49 4.592v.2l-1.39-1.398a.776.776 0 00-1.093 0 .786.786 0 000 1.098l2.682 2.696c.099.1.298.2.496.2.199 0 .397-.1.497-.2l2.681-2.695c.397-.3.397-.8.1-1.099z"
    }));
});



var $denZA = parcelRequire("denZA");
var $565924a9a090593f$var$__assign = undefined && undefined.__assign || function() {
    $565924a9a090593f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $565924a9a090593f$var$__assign.apply(this, arguments);
};
var $565924a9a090593f$export$af5e85d717d10540 = $denZA.forwardRef(function RefreshBold(props, svgRef) {
    return $denZA.createElement("svg", $565924a9a090593f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M14.339 3.815a8.834 8.834 0 00-11.044 7.02l-.234-.234a1.5 1.5 0 10-2.122 2.122l2.617 2.616a1.496 1.496 0 002.224-.002l2.614-2.614a1.5 1.5 0 00-1.905-2.301 5.833 5.833 0 018.995-2.767 1.5 1.5 0 101.792-2.406 8.832 8.832 0 00-2.937-1.434zm5.625 5.819a1.495 1.495 0 00-1.157-.044 1.495 1.495 0 00-.534.345L15.606 12.6a1.5 1.5 0 001.534 2.485 5.825 5.825 0 01-2.986 2.663 5.833 5.833 0 01-5.336-.532 1.5 1.5 0 10-1.636 2.514 8.833 8.833 0 0013.41-5.355l.347.347a1.5 1.5 0 102.122-2.122l-2.656-2.655a1.495 1.495 0 00-.44-.312z"
    }));
});



var $denZA = parcelRequire("denZA");
var $1488028f32f03f65$var$__assign = undefined && undefined.__assign || function() {
    $1488028f32f03f65$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1488028f32f03f65$var$__assign.apply(this, arguments);
};
var $1488028f32f03f65$export$6d3b1b9014d6cc79 = $denZA.forwardRef(function Retract(props, svgRef) {
    return $denZA.createElement("svg", $1488028f32f03f65$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.026 2.526a.75.75 0 10-1.06-1.06l-7.22 7.22v-4.69a.75.75 0 10-1.5 0v6.5a.747.747 0 00.75.75h6.5a.75.75 0 100-1.5h-4.69l7.22-7.22zm-12.53 18.448a.75.75 0 01-.75-.75v-4.69l-7.22 7.22a.75.75 0 11-1.06-1.06l7.22-7.22h-4.69a.75.75 0 010-1.5h6.5a.747.747 0 01.75.75v6.5a.75.75 0 01-.75.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c1e05bda3db0ea11$var$__assign = undefined && undefined.__assign || function() {
    $c1e05bda3db0ea11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1e05bda3db0ea11$var$__assign.apply(this, arguments);
};
var $c1e05bda3db0ea11$export$9515f4411b0668 = $denZA.forwardRef(function RetractBold(props, svgRef) {
    return $denZA.createElement("svg", $c1e05bda3db0ea11$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.56 3.06A1.5 1.5 0 0021.44.94L15.5 6.878V4a1.5 1.5 0 00-3 0v6.5a1.494 1.494 0 00.859 1.357c.194.092.412.143.641.143h6.5a1.5 1.5 0 000-3h-2.879l5.94-5.94zM10.5 21.728a1.5 1.5 0 01-1.5-1.5v-2.879l-5.94 5.94a1.5 1.5 0 11-2.12-2.122l5.939-5.939H4a1.5 1.5 0 010-3h6.5a1.494 1.494 0 011.374.896c.08.185.126.39.126.604v6.5a1.5 1.5 0 01-1.5 1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d5430225fd80e444$var$__assign = undefined && undefined.__assign || function() {
    $d5430225fd80e444$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5430225fd80e444$var$__assign.apply(this, arguments);
};
var $d5430225fd80e444$export$b204c8549f010cd = $denZA.forwardRef(function RotateLeft(props, svgRef) {
    return $denZA.createElement("svg", $d5430225fd80e444$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M1 1.75a.75.75 0 011.5 0v4.714a10.997 10.997 0 119.497 16.53.75.75 0 010-1.5A9.497 9.497 0 103.47 7.832h5.11a.75.75 0 010 1.5h-6.2a.745.745 0 01-.077 0H1.75a.75.75 0 01-.75-.75V1.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $1acae5bed0dad92a$var$__assign = undefined && undefined.__assign || function() {
    $1acae5bed0dad92a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1acae5bed0dad92a$var$__assign.apply(this, arguments);
};
var $1acae5bed0dad92a$export$7257def152302e45 = $denZA.forwardRef(function RotateLeftBold(props, svgRef) {
    return $denZA.createElement("svg", $1acae5bed0dad92a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M0 2a1.5 1.5 0 113 0v2.414a11.746 11.746 0 118.746 19.58 1.5 1.5 0 01.002-3 8.747 8.747 0 10-7.23-13.663h3.813a1.5 1.5 0 110 3H2.152a1.2 1.2 0 01-.12 0H1.5a1.5 1.5 0 01-1.5-1.5V2z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d6a11fb6c1126916$var$__assign = undefined && undefined.__assign || function() {
    $d6a11fb6c1126916$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6a11fb6c1126916$var$__assign.apply(this, arguments);
};
var $d6a11fb6c1126916$export$75099d76a78789f = $denZA.forwardRef(function RotateRight(props, svgRef) {
    return $denZA.createElement("svg", $d6a11fb6c1126916$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.257 2.002a.75.75 0 00-1.5 0v4.714a10.999 10.999 0 00-18.484-.813 10.997 10.997 0 008.987 17.343.75.75 0 100-1.5 9.496 9.496 0 118.528-13.663h-5.113a.75.75 0 000 1.5h6.2a.744.744 0 00.078 0h.554a.75.75 0 00.75-.75V2.002z"
    }));
});



var $denZA = parcelRequire("denZA");
var $bf0f390a1e90c930$var$__assign = undefined && undefined.__assign || function() {
    $bf0f390a1e90c930$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf0f390a1e90c930$var$__assign.apply(this, arguments);
};
var $bf0f390a1e90c930$export$1d157cf51c63a935 = $denZA.forwardRef(function RotateRightBold(props, svgRef) {
    return $denZA.createElement("svg", $bf0f390a1e90c930$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M24 2a1.5 1.5 0 00-3 0v2.414A11.75 11.75 0 007.576 1.47a11.747 11.747 0 004.678 22.525 1.5 1.5 0 00-.002-3 8.747 8.747 0 117.23-13.664h-3.813a1.5 1.5 0 000 3h6.179c.04.002.08.002.12 0h.532a1.5 1.5 0 001.5-1.5V2z"
    }));
});



var $denZA = parcelRequire("denZA");
var $0e372fd258078647$var$__assign = undefined && undefined.__assign || function() {
    $0e372fd258078647$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e372fd258078647$var$__assign.apply(this, arguments);
};
var $0e372fd258078647$export$be11e187edb4cb0c = $denZA.forwardRef(function Save(props, svgRef) {
    return $denZA.createElement("svg", $0e372fd258078647$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.5 15.75a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm7.5-15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 24A2.25 2.25 0 010 21.75V7.243a3.75 3.75 0 011.099-2.651L4.59 1.099A3.75 3.75 0 017.243 0H21.75A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25zM6.382 1.671a2.25 2.25 0 01.86-.171H7.5v5.25A2.25 2.25 0 009.75 9h7.5a2.25 2.25 0 002.25-2.25V1.5h2.25a.75.75 0 01.75.75v19.5a.75.75 0 01-.75.75H19.5v-8.25A2.25 2.25 0 0017.25 12H6.75a2.25 2.25 0 00-2.25 2.25v8.25H2.25a.75.75 0 01-.75-.75V7.243c0-.597.237-1.169.66-1.59l3.49-3.495a2.25 2.25 0 01.73-.488zM6 22.5h12v-8.25a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v8.25zm12-21v5.25a.75.75 0 01-.75.75h-7.5A.75.75 0 019 6.75V1.5h9z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $dc764e8239826c08$var$__assign = undefined && undefined.__assign || function() {
    $dc764e8239826c08$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dc764e8239826c08$var$__assign.apply(this, arguments);
};
var $dc764e8239826c08$export$71dc135d99594e20 = $denZA.forwardRef(function SavingMoneyFlower(props, svgRef) {
    return $denZA.createElement("svg", $dc764e8239826c08$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M11.946 0a6.75 6.75 0 01.75 13.459v7.211l.106-.13a18.234 18.234 0 012.328-2.325c-1.331-1.451-.836-3.25.846-4.494l.153-.11.098-.056a7.972 7.972 0 017.201.11.75.75 0 01.173 1.203 5.175 5.175 0 00-.69.82c-.247.364-.393.639-.66 1.24l-.286.656c-.393.887-.682 1.379-1.182 1.923-1.473 1.605-3.493 1.636-4.657-.376l.082.137c-1 .83-1.814 1.665-2.46 2.488a9.83 9.83 0 00-.887 1.32l-.103.197a3.164 3.164 0 00-.092.197l-.016.038-.004.011a.928.928 0 01-.015.037l-.005.01-.007.012-.01.023-.005.01a.689.689 0 01-.015.026l-.009.013-.014.022-.015.022-.011.014-.016.02-.014.016a.796.796 0 01-.053.055l-.017.015a.864.864 0 01-.058.047l-.014.01a.768.768 0 01-.071.042l-.012.006a.721.721 0 01-.071.032c-.004 0-.007.002-.01.003l-.017.006-.008.003a.632.632 0 01-.061.017l-.022.005a.794.794 0 01-.13.015h-.055a.735.735 0 01-.047-.004l-.02-.003-.038-.006a.85.85 0 01-.06-.014l-.039-.012a.708.708 0 01-.041-.015l-.012-.005-.036-.018-.023-.01a.76.76 0 01-.012-.007l-.007-.004a.656.656 0 01-.15-.11l-.013-.015a.472.472 0 01-.045-.049l-.016-.02-.007-.01a.486.486 0 01-.016-.02l-.017-.028a.983.983 0 01-.029-.05l-.005-.01a.77.77 0 01-.032-.07l-.073-.168a4.996 4.996 0 00-.086-.171l-.056-.105a9.755 9.755 0 00-.887-1.32c-.646-.823-1.46-1.658-2.46-2.488-1.141 1.816-3.018 1.808-4.444.377l-.132-.138c-.544-.594-.837-1.124-1.291-2.174l-.092-.212c-.32-.734-.468-1.025-.736-1.422a5.18 5.18 0 00-.697-.83.75.75 0 01.173-1.203 7.969 7.969 0 017.2-.11l.098.057c1.805 1.246 2.371 3.11 1 4.603a18.033 18.033 0 012.436 2.456l-.003-7.213A6.75 6.75 0 0111.946 0zM6.754 14.787a6.47 6.47 0 00-4.566-.224l-.135.046.18.25c.332.493.507.837.86 1.646l.101.233c.391.905.62 1.319 1.02 1.754.842.917 1.66.95 2.273-.145-.393-.287-.81-.57-1.252-.85a.75.75 0 01.806-1.266 27.22 27.22 0 011.536 1.051c.78-.793.465-1.654-.666-2.435l.045.033-.202-.093zm14.951-.225a6.472 6.472 0 00-4.821.341l.048-.022-.089.064c-1.017.755-1.275 1.577-.526 2.337.48-.354.991-.705 1.535-1.05a.75.75 0 01.806 1.265c-.442.28-.859.563-1.253.848.612 1.097 1.432 1.064 2.274.148.4-.436.629-.85 1.02-1.755l.194-.445c.296-.668.47-.996.776-1.446l.17-.239-.134-.046zM11.946 1.5a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm0 .75a.75.75 0 01.743.648l.007.101.75.001a.75.75 0 01.102 1.493l-.102.007h-1.5l-.015-.001-.52.001a.591.591 0 00-.303 1.1l.084.04 2.064.827a2.092 2.092 0 01-.56 4.021v.012a.75.75 0 01-1.493.102l-.007-.102v-.001l-.75.001a.75.75 0 01-.102-1.493L10.446 9h2.03a.592.592 0 00.304-1.1l-.083-.04-2.061-.826a2.091 2.091 0 01.56-4.023V3a.75.75 0 01.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $e4a56ba380140a38$var$__assign = undefined && undefined.__assign || function() {
    $e4a56ba380140a38$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e4a56ba380140a38$var$__assign.apply(this, arguments);
};
var $e4a56ba380140a38$export$3cb7ee0299df8f39 = $denZA.forwardRef(function SavingMoneyFlowerBold(props, svgRef) {
    return $denZA.createElement("svg", $e4a56ba380140a38$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.589 13.325a.475.475 0 00-.319-.255.493.493 0 00-.406.08c-.672.462-1.44.78-2.25.93-.714.14-1.397.4-2.017.767a2.37 2.37 0 00-1.234 1.902 1.68 1.68 0 00.096.57.225.225 0 01-.077.254 14.71 14.71 0 00-1.62 1.452.246.246 0 01-.264.058.231.231 0 01-.152-.215v-4.107c0-.113.085-.21.2-.228 3.631-.581 6.193-3.747 5.89-7.28C19.134 3.718 16.07 1 12.388 1c-3.68 0-6.746 2.72-7.049 6.252-.302 3.534 2.26 6.7 5.89 7.28.116.02.2.116.2.229v3.192a.23.23 0 01-.136.208.247.247 0 01-.254-.03 10.423 10.423 0 00-1.829-1.144.132.132 0 01-.076-.125 2.56 2.56 0 00-1.314-2.078 6.242 6.242 0 00-5.606.069.452.452 0 00-.068.716 5.012 5.012 0 011.18 1.817c.234.607.577 1.17 1.014 1.661.43.501 1.06.805 1.734.838.087 0 .173-.005.26-.018a2.08 2.08 0 001.513-1.178.24.24 0 01.08-.083l.034-.022a.246.246 0 01.24-.016 7.342 7.342 0 013.197 2.701.222.222 0 01.033.117v.846a1 1 0 00.794.903c.443.098.9-.096 1.123-.478A13.173 13.173 0 0116.606 19a.093.093 0 01.134.022c.304.56.848.96 1.487 1.1.118.021.238.032.358.032a3.14 3.14 0 002.153-1.033 6.111 6.111 0 00.85-5.796zm-10.925-1.384c-.463 0-.839-.362-.839-.808 0-.446.376-.808.839-.808h2.338c.338 0 .63-.23.693-.55a.674.674 0 00-.431-.759l-2.372-.907c-.987-.38-1.592-1.343-1.485-2.361.107-1.019.901-1.845 1.947-2.027a.233.233 0 00.197-.227v-.111c0-.446.376-.808.839-.808.463 0 .838.362.838.808v.069c0 .127.107.23.24.23h.647c.463 0 .838.362.838.808 0 .446-.375.808-.838.808h-2.339a.698.698 0 00-.69.55.674.674 0 00.429.758l2.374.914c.986.38 1.592 1.344 1.484 2.362-.107 1.018-.902 1.844-1.947 2.025a.234.234 0 00-.198.227v.11c0 .446-.375.808-.838.808-.463 0-.839-.362-.839-.808v-.069a.235.235 0 00-.24-.23l-.647-.004z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9098a574bb5560eb$var$__assign = undefined && undefined.__assign || function() {
    $9098a574bb5560eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9098a574bb5560eb$var$__assign.apply(this, arguments);
};
var $9098a574bb5560eb$export$4b85d3515bd863a5 = $denZA.forwardRef(function Search(props, svgRef) {
    return $denZA.createElement("svg", $9098a574bb5560eb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 1.25a8.75 8.75 0 105.634 15.445l5.836 5.835a.75.75 0 001.06-1.06l-5.835-5.836A8.75 8.75 0 0010 1.25zM2.75 10a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $95edb1f71c32a046$var$__assign = undefined && undefined.__assign || function() {
    $95edb1f71c32a046$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95edb1f71c32a046$var$__assign.apply(this, arguments);
};
var $95edb1f71c32a046$export$8278256c54fb93b2 = $denZA.forwardRef(function SearchBold(props, svgRef) {
    return $denZA.createElement("svg", $95edb1f71c32a046$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $26ca177d5eddbeff$var$__assign = undefined && undefined.__assign || function() {
    $26ca177d5eddbeff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26ca177d5eddbeff$var$__assign.apply(this, arguments);
};
var $26ca177d5eddbeff$export$9fb697de7778c436 = $denZA.forwardRef(function Security(props, svgRef) {
    return $denZA.createElement("svg", $26ca177d5eddbeff$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.181 1.874A22.449 22.449 0 0012 .001 22.45 22.45 0 002.806 1.88 2.237 2.237 0 001.5 3.926v7.611A12.657 12.657 0 009.612 23.35l1.041.4a3.75 3.75 0 002.692 0l1.042-.4a12.656 12.656 0 008.112-11.813V3.926a2.238 2.238 0 00-1.318-2.052zM3 3.924v-.005a.737.737 0 01.425-.673 20.95 20.95 0 018.582-1.745 20.95 20.95 0 018.567 1.745.737.737 0 01.425.673v7.619a11.156 11.156 0 01-7.15 10.412l-1.042.4c-.52.2-1.095.2-1.615 0l-1.041-.4A11.156 11.156 0 013 11.538V3.923z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.745 12.917a.696.696 0 10-1.391 0V14.5a.696.696 0 001.391 0v-1.583z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.583 8.167v1.284h-.887a.696.696 0 00-.696.695v7.125c0 .384.311.696.696.696h8.707a.696.696 0 00.696-.696v-7.125a.696.696 0 00-.695-.695h-.888V8.167a3.467 3.467 0 10-6.933 0zm2-1.467a2.075 2.075 0 013.541 1.467v1.284h-4.15V8.167c0-.55.22-1.078.608-1.467zM8.39 16.575v-5.733h7.317v5.733H8.39z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $592577cc840b053c$var$__assign = undefined && undefined.__assign || function() {
    $592577cc840b053c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $592577cc840b053c$var$__assign.apply(this, arguments);
};
var $592577cc840b053c$export$ff3cf24dfc418321 = $denZA.forwardRef(function SecurityBold(props, svgRef) {
    return $denZA.createElement("svg", $592577cc840b053c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#security-bold_svg__security-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M22.15 2.8a2.24 2.24 0 00-1-.83A22.45 22.45 0 0012 .09 22.45 22.45 0 002.82 2 2.24 2.24 0 001.5 4v7.61a12.66 12.66 0 008.11 11.83l1 .4a3.75 3.75 0 002.69 0l1-.4a12.66 12.66 0 008.2-11.82V4a2.24 2.24 0 00-.35-1.2zm-5 13.56a.7.7 0 01-.7.7H7.7a.7.7 0 01-.7-.7V9.23a.7.7 0 01.7-.7h.89V7.25a3.47 3.47 0 116.93 0v1.29h.89a.7.7 0 01.7.7l.04 7.12z"
    }), $denZA.createElement("path", {
        d: "M14.13 7.25a2.08 2.08 0 00-4.15 0v1.29h4.15V7.25zm-5.74 8.41h7.32V9.93H8.39v5.73zm3-3.66a.7.7 0 111.39 0v1.58a.7.7 0 11-1.39 0V12z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "security-bold_svg__security-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $9502c6b84a1b7f59$var$__assign = undefined && undefined.__assign || function() {
    $9502c6b84a1b7f59$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9502c6b84a1b7f59$var$__assign.apply(this, arguments);
};
var $9502c6b84a1b7f59$export$ef9b1a59e592288f = $denZA.forwardRef(function Select(props, svgRef) {
    return $denZA.createElement("svg", $9502c6b84a1b7f59$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.608 24H9.983c-.191 0-.479-.096-.575-.288l-3.737-4.887c-.575-.767-.575-1.725-.096-2.492.67-.958 2.013-1.245 3.067-.575 0 0 .096 0 .096.096l.479.384v-8.05c0-1.15.958-2.109 2.204-2.109 1.246 0 2.204.958 2.204 2.109v5.175l3.45.766c1.725.383 2.97 2.013 2.78 3.833l-.48 5.367c0 .383-.383.671-.767.671zm-8.241-1.438h7.57l.384-4.695c.096-1.055-.671-2.109-1.725-2.3l-4.025-.863c-.288-.096-.575-.383-.575-.67v-5.75c0-.384-.288-.767-.671-.767-.287 0-.575.287-.575.67v9.296c0 .288-.192.48-.383.671-.288.096-.575.096-.767-.096l-1.63-1.245c-.382-.192-.766-.096-1.053.191-.192.288-.192.575 0 .863l3.45 4.695zm1.15-17.92a.756.756 0 01-.767-.767V1.767c0-.48.287-.767.767-.767.479 0 .766.288.766.767v2.108c-.095.383-.383.767-.766.767zm2.779.671a.732.732 0 01-.48-.192.752.752 0 010-1.054l1.438-1.438a.752.752 0 011.054 0 .752.752 0 010 1.054l-1.437 1.438c-.192.096-.383.191-.575.191zm-5.654 0a.732.732 0 01-.48-.192L6.63 3.683a.752.752 0 010-1.054.752.752 0 011.054 0l1.438 1.438a.752.752 0 010 1.054c-.192.096-.383.191-.48.191zm8.528 2.204h-2.108a.756.756 0 01-.766-.767c0-.48.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.288.767-.767.767zm-9.295 0H5.767A.756.756 0 015 6.75c0-.383.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.384.767-.767.767z"
    }));
});



var $denZA = parcelRequire("denZA");
var $865d4c5a342457c0$var$__assign = undefined && undefined.__assign || function() {
    $865d4c5a342457c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $865d4c5a342457c0$var$__assign.apply(this, arguments);
};
var $865d4c5a342457c0$export$603458ca8a362063 = $denZA.forwardRef(function SelectBold(props, svgRef) {
    return $denZA.createElement("svg", $865d4c5a342457c0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M11.517.75c-.29 0-.551.088-.74.277-.19.189-.277.45-.277.74v2.108c0 .5.38 1.017 1.017 1.017.28 0 .51-.142.675-.321a1.49 1.49 0 00.334-.635l.007-.03v-2.14c0-.289-.088-.55-.276-.74-.19-.188-.45-.276-.74-.276zM7.86 2.452a1.002 1.002 0 00-1.408 0 1.002 1.002 0 000 1.408L7.99 5.3c.14.14.392.263.653.263a.56.56 0 00.16-.028c.047-.014.095-.033.142-.053.09-.038.192-.09.285-.136l.04-.02.029-.028a1.002 1.002 0 000-1.408L7.86 2.452zm7.217 0a1.002 1.002 0 011.408 0 1.002 1.002 0 010 1.408L15.02 5.326l-.058.03c-.175.087-.413.207-.665.207a.98.98 0 01-.656-.265 1.002 1.002 0 010-1.408l1.437-1.438zm-9.31 3.281c-.638 0-1.017.517-1.017 1.017 0 .5.38 1.017 1.017 1.017h2.108c.5 0 1.017-.38 1.017-1.017 0-.637-.517-1.017-1.017-1.017H5.767zm8.556.277c.189-.189.45-.277.74-.277h2.108c.5 0 1.017.38 1.017 1.017 0 .29-.088.55-.277.74-.19.189-.45.277-.74.277h-2.108c-.501 0-1.017-.38-1.017-1.017 0-.29.088-.55.277-.74zM9.983 24h8.625c.384 0 .767-.288.767-.67l.48-5.367c.19-1.821-1.055-3.45-2.78-3.834l-3.45-.766V8.188c0-1.15-.958-2.109-2.204-2.109-1.246 0-2.204.958-2.204 2.109v8.05l-.48-.384c0-.096-.095-.096-.095-.096-1.054-.67-2.396-.383-3.067.575-.48.767-.48 1.725.096 2.492l3.737 4.887c.096.192.384.288.575.288z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6005b0641d96a04e$var$__assign = undefined && undefined.__assign || function() {
    $6005b0641d96a04e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6005b0641d96a04e$var$__assign.apply(this, arguments);
};
var $6005b0641d96a04e$export$2b74fd7268b370b8 = $denZA.forwardRef(function SeoSearch(props, svgRef) {
    return $denZA.createElement("svg", $6005b0641d96a04e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18.875 2.5a2.375 2.375 0 100 4.75 2.375 2.375 0 000-4.75zM15 4.875a3.875 3.875 0 117.75 0 3.875 3.875 0 01-7.75 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.555 6.554a.75.75 0 011.06 0L23.78 8.72a.75.75 0 01-1.06 1.06l-2.165-2.166a.75.75 0 010-1.06zM2.5 3.75a.75.75 0 00-.75.75V6c0 .414.336.75.75.75H13a.75.75 0 010 1.5H2.5A2.25 2.25 0 01.25 6V4.5A2.25 2.25 0 012.5 2.25H13a.75.75 0 010 1.5H2.5zm-.75 7.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zM5.5 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12A.75.75 0 015.5 12zm-3.75 4.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm3.75.375a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75zm-3.75 4.875a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm3.75.375a.75.75 0 01.75-.75h12a.75.75 0 010 1.5h-12a.75.75 0 01-.75-.75z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $b5c35340d2e54f5c$var$__assign = undefined && undefined.__assign || function() {
    $b5c35340d2e54f5c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5c35340d2e54f5c$var$__assign.apply(this, arguments);
};
var $b5c35340d2e54f5c$export$f249f61886f02153 = $denZA.forwardRef(function SeoSearchBold(props, svgRef) {
    return $denZA.createElement("svg", $b5c35340d2e54f5c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M2.25 2.983H11a1 1 0 100-2H1.58C.73.963.024 1.633 0 2.483v3c.024.85.73 1.52 1.58 1.5H11a1 1 0 100-2H2.25a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.369 6.18a.249.249 0 00.043.3l2.297 2.3a1 1 0 01-1.414 1.414L20 7.894a.251.251 0 00-.3-.042 4.182 4.182 0 111.669-1.672zm-5.683-1.163a2.18 2.18 0 104.028-1.668 2.18 2.18 0 00-4.028 1.668z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M3 15.983a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.5-6H5a1 1 0 100 2h9.5a1 1 0 100-2zm-11.5-4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.5-1H5a1 1 0 100 2h9.5a1 1 0 100-2zm0 10H5a1 1 0 100 2h9.5a1 1 0 100-2z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c5f3b2a85b43be07$var$__assign = undefined && undefined.__assign || function() {
    $c5f3b2a85b43be07$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5f3b2a85b43be07$var$__assign.apply(this, arguments);
};
var $c5f3b2a85b43be07$export$d59771a2e9612de9 = $denZA.forwardRef(function Server(props, svgRef) {
    return $denZA.createElement("svg", $c5f3b2a85b43be07$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M13.509 9H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6.737.754A.76.76 0 0019.49 9h-3a.761.761 0 00-.754.754c0 .412.343.755.754.755h3c.429-.018.755-.343.755-.755zM5.623 8.623c-.617 0-1.132.497-1.132 1.114 0 .617.498 1.132 1.115 1.132a1.13 1.13 0 001.131-1.132c.017-.6-.497-1.114-1.114-1.114zM13.509 18H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6 0H16.49a.761.761 0 00-.754.754c0 .412.343.755.754.755h3a.761.761 0 00.755-.755.746.746 0 00-.737-.754z"
    }), $denZA.createElement("path", {
        d: "M21.446 14.246A5.235 5.235 0 0024 9.754a5.04 5.04 0 00-.497-2.211v-.017l-2.52-5.366A3.742 3.742 0 0017.589 0H6.41a3.76 3.76 0 00-3.394 2.16L.497 7.526v.017A5.04 5.04 0 000 9.754a5.235 5.235 0 002.554 4.492A5.264 5.264 0 000 18.754 5.246 5.246 0 005.246 24h13.508A5.246 5.246 0 0024 18.754c0-1.92-1.029-3.583-2.554-4.508zM4.37 2.794a2.27 2.27 0 012.04-1.303h11.195a2.27 2.27 0 012.04 1.303l.96 2.04a5.357 5.357 0 00-1.835-.325H5.246c-.652 0-1.269.12-1.835.325l.96-2.04zm-2.86 6.96A3.748 3.748 0 015.246 6h13.508a3.753 3.753 0 013.755 3.754 3.753 3.753 0 01-3.755 3.755H5.246c-2.057 0-3.737-1.698-3.737-3.755zm17.245 12.737H5.246a3.753 3.753 0 01-3.755-3.754 3.753 3.753 0 013.755-3.754h13.508a3.753 3.753 0 013.755 3.754 3.764 3.764 0 01-3.755 3.754z"
    }), $denZA.createElement("path", {
        d: "M5.623 17.623c-.617 0-1.132.497-1.132 1.114 0 .309.12.583.326.789a1.13 1.13 0 001.92-.806c.017-.583-.497-1.097-1.114-1.097z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f4128ef152720e5c$var$__assign = undefined && undefined.__assign || function() {
    $f4128ef152720e5c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4128ef152720e5c$var$__assign.apply(this, arguments);
};
var $f4128ef152720e5c$export$c72f6eaae7b9adff = $denZA.forwardRef(function Settings(props, svgRef) {
    return $denZA.createElement("svg", $f4128ef152720e5c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM8.75 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM18.717 3.87l1.415 1.413-.61.61c-.914.913-1.02 2.224-.6 3.24C19.343 10.15 20.346 11 21.635 11h.865v2.002h-.864c-1.29 0-2.293.852-2.713 1.866-.421 1.016-.316 2.328.597 3.24l.611.611-1.413 1.414-.613-.612c-.913-.912-2.224-1.018-3.24-.597C13.85 19.346 13 20.348 13 21.637v.863h-2v-.863c0-1.289-.85-2.291-1.866-2.713-1.016-.422-2.328-.316-3.24.597l-.587.585a.045.045 0 01-.052 0l-1.388-1.388.613-.613c.913-.913 1.018-2.224.597-3.24C4.657 13.852 3.655 13 2.365 13H1.5v-2h.866c1.29 0 2.29-.85 2.71-1.865.422-1.015.317-2.327-.597-3.24l-.612-.611L5.282 3.87l.613.612c.912.912 2.224 1.018 3.24.597C10.15 4.657 11 3.655 11 2.366V1.5h2v.866c0 1.29.85 2.291 1.865 2.712 1.015.421 2.326.316 3.239-.596l.613-.612z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $5248b283f8824d1e$var$__assign = undefined && undefined.__assign || function() {
    $5248b283f8824d1e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5248b283f8824d1e$var$__assign.apply(this, arguments);
};
var $5248b283f8824d1e$export$18e4ef42d74628e8 = $denZA.forwardRef(function SettingsBold(props, svgRef) {
    return $denZA.createElement("svg", $5248b283f8824d1e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM12 16a4 4 0 100-8 4 4 0 000 8z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $f45902a4f03d0602$var$__assign = undefined && undefined.__assign || function() {
    $f45902a4f03d0602$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f45902a4f03d0602$var$__assign.apply(this, arguments);
};
var $f45902a4f03d0602$export$c9915453de10000b = $denZA.forwardRef(function Share(props, svgRef) {
    return $denZA.createElement("svg", $f45902a4f03d0602$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.15 9.5a.65.65 0 00-.65.65v11.2a.65.65 0 00.65.65h12.6a.65.65 0 00.65-.65v-11.2a.65.65 0 00-.65-.65h-1.4a.75.75 0 010-1.5h1.4a2.15 2.15 0 012.15 2.15v11.2a2.15 2.15 0 01-2.15 2.15H6.15A2.15 2.15 0 014 21.35v-11.2A2.15 2.15 0 016.15 8h1.4a.75.75 0 010 1.5h-1.4z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M11.92 1.22a.748.748 0 011.06 0l3.5 3.5a.75.75 0 01-1.06 1.06L13.2 3.56v7.99a.75.75 0 01-1.5 0V3.56L9.48 5.78a.75.75 0 01-1.06-1.06l3.5-3.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $6c2f26ed145d0640$var$__assign = undefined && undefined.__assign || function() {
    $6c2f26ed145d0640$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c2f26ed145d0640$var$__assign.apply(this, arguments);
};
var $6c2f26ed145d0640$export$4781d373f2233cee = $denZA.forwardRef(function ShareBold(props, svgRef) {
    return $denZA.createElement("svg", $6c2f26ed145d0640$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M6 10h1.3a1.5 1.5 0 100-3H5.9A2.9 2.9 0 003 9.9v11.2A2.9 2.9 0 005.9 24h12.6a2.9 2.9 0 002.9-2.9V9.9A2.899 2.899 0 0018.5 7h-1.4a1.5 1.5 0 000 3h1.3v11H6V10z"
    }), $denZA.createElement("path", {
        d: "M11.19.43a1.4 1.4 0 012-.02l3.29 3.29a1.414 1.414 0 01-2 2l-.88-.88v5.8a1.41 1.41 0 01-2.82 0V4.81l-.88.88a1.414 1.414 0 01-2-2L11.19.43z"
    }));
});



var $denZA = parcelRequire("denZA");
var $69970b04d8e78b22$var$__assign = undefined && undefined.__assign || function() {
    $69970b04d8e78b22$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69970b04d8e78b22$var$__assign.apply(this, arguments);
};
var $69970b04d8e78b22$export$8446584e1e5a8d07 = $denZA.forwardRef(function ShoppingBagEmpty(props, svgRef) {
    return $denZA.createElement("svg", $69970b04d8e78b22$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#shopping-bag-empty_svg__shopping-bag-empty_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M4.806 6H19.18a2.157 2.157 0 012.048 1.8l2.006 13.98c.033.6-.192 1.186-.618 1.61a2.077 2.077 0 01-1.567.61l-18.066-.001a2.107 2.107 0 01-1.612-.609c-.426-.424-.651-1.009-.612-1.675L2.76 7.777a2.15 2.15 0 012.206-1.776L4.807 6zM19.05 7.5H4.906a.645.645 0 00-.663.514L2.249 21.863a.607.607 0 00.178.463.642.642 0 00.51.174l18.157.001a.606.606 0 00.463-.175.608.608 0 00.185-.397L19.745 8.037c-.056-.321-.34-.55-.696-.537zM11.98 0a4.515 4.515 0 014.42 3.666.75.75 0 01-1.474.282A3.014 3.014 0 0011.98 1.5a3.013 3.013 0 00-2.943 2.432.75.75 0 01-1.472-.288A4.514 4.514 0 0111.98 0z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "shopping-bag-empty_svg__shopping-bag-empty_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $61b3aa6a75efa8b2$var$__assign = undefined && undefined.__assign || function() {
    $61b3aa6a75efa8b2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61b3aa6a75efa8b2$var$__assign.apply(this, arguments);
};
var $61b3aa6a75efa8b2$export$6bf565d591efd349 = $denZA.forwardRef(function ShoppingBagEmptyBold(props, svgRef) {
    return $denZA.createElement("svg", $61b3aa6a75efa8b2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#shopping-bag-empty-bold_svg__shopping-bag-empty-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M4.967 6h14.212a2.157 2.157 0 012.048 1.8l2.006 13.98c.033.6-.192 1.186-.618 1.61a2.077 2.077 0 01-1.567.61l-18.066-.001a2.107 2.107 0 01-1.612-.609c-.426-.424-.651-1.009-.612-1.675L2.76 7.777a2.15 2.15 0 012.206-1.776zm7.012-6a4.515 4.515 0 014.42 3.666.75.75 0 01-1.474.282A3.014 3.014 0 0011.98 1.5a3.013 3.013 0 00-2.943 2.432.75.75 0 01-1.472-.288A4.514 4.514 0 0111.98 0z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "shopping-bag-empty-bold_svg__shopping-bag-empty-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $3d1e028963884119$var$__assign = undefined && undefined.__assign || function() {
    $3d1e028963884119$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d1e028963884119$var$__assign.apply(this, arguments);
};
var $3d1e028963884119$export$4a37ae897f9e8014 = $denZA.forwardRef(function StatusError(props, svgRef) {
    return $denZA.createElement("svg", $3d1e028963884119$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M17.03 6.97a.75.75 0 010 1.06L13.06 12l3.97 3.97a.75.75 0 11-1.06 1.06L12 13.06l-3.97 3.97a.75.75 0 01-1.06-1.06L10.94 12 6.97 8.03a.75.75 0 011.06-1.06L12 10.94l3.97-3.97a.75.75 0 011.06 0z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $c01ecd8407100ac8$var$__assign = undefined && undefined.__assign || function() {
    $c01ecd8407100ac8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c01ecd8407100ac8$var$__assign.apply(this, arguments);
};
var $c01ecd8407100ac8$export$750f42de29e1826b = $denZA.forwardRef(function StatusErrorBold(props, svgRef) {
    return $denZA.createElement("svg", $c01ecd8407100ac8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.56-17.56a1.5 1.5 0 010 2.12L14.122 12l3.44 3.44a1.5 1.5 0 01-2.122 2.12L12 14.122l-3.44 3.44a1.5 1.5 0 01-2.12-2.122L9.878 12l-3.44-3.44A1.5 1.5 0 118.56 6.44L12 9.878l3.44-3.44a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $8e374e26c8c47298$var$__assign = undefined && undefined.__assign || function() {
    $8e374e26c8c47298$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e374e26c8c47298$var$__assign.apply(this, arguments);
};
var $8e374e26c8c47298$export$e0c13b137c9285c0 = $denZA.forwardRef(function StatusHelp(props, svgRef) {
    return $denZA.createElement("svg", $8e374e26c8c47298$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.825 14.11h-1.32a2.008 2.008 0 01-.198-.868c0-.986.73-1.676 1.577-2.425.986-.927 1.538-1.46 1.538-2.425 0-1.184-.867-1.992-1.932-1.992-1.005 0-1.814.631-2.208 1.893L9 7.761C9.513 6.006 10.794 5 12.53 5 14.442 5 16 6.36 16 8.293c0 1.321-.769 2.208-1.873 3.194-.868.79-1.4 1.282-1.4 1.992 0 .203.043.391.08.552l.018.079zm.69 3.096c0 .73-.571 1.242-1.261 1.242a1.237 1.237 0 01-1.243-1.242c0-.73.592-1.243 1.243-1.243.69 0 1.261.513 1.261 1.243z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm1.509 0c0 5.777 4.697 10.491 10.491 10.491S22.491 17.777 22.491 12c0-5.777-4.697-10.491-10.491-10.491S1.509 6.223 1.509 12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $308e8d3a86b17ccd$var$__assign = undefined && undefined.__assign || function() {
    $308e8d3a86b17ccd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $308e8d3a86b17ccd$var$__assign.apply(this, arguments);
};
var $308e8d3a86b17ccd$export$493d925eb43dfdfe = $denZA.forwardRef(function StatusHelpBold(props, svgRef) {
    return $denZA.createElement("svg", $308e8d3a86b17ccd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm12.934 1.731h-2.315a2.457 2.457 0 01-.223-.975c0-.812.61-1.502 1.604-2.294.832-.69 1.198-1.056 1.198-1.706 0-.73-.569-1.238-1.28-1.238-.75 0-1.299.528-1.684 1.543L8 8.086C8.589 6.016 10.091 5 12 5c2.213 0 4 1.401 4 3.553 0 1.198-.569 1.99-1.685 2.965l-.218.189c-.7.608-1.204 1.044-1.204 1.598 0 .162.02.304.041.426zM13.746 17c0 1.076-.812 1.888-1.888 1.888-1.097 0-1.909-.812-1.909-1.888 0-1.056.812-1.888 1.909-1.888A1.86 1.86 0 0113.746 17z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $28342eea724458b3$var$__assign = undefined && undefined.__assign || function() {
    $28342eea724458b3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28342eea724458b3$var$__assign.apply(this, arguments);
};
var $28342eea724458b3$export$390e0440e6f2b300 = $denZA.forwardRef(function StatusInformation(props, svgRef) {
    return $denZA.createElement("svg", $28342eea724458b3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.515 3.515a12 12 0 1116.97 16.97 12 12 0 01-16.97-16.97zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.044 7.016a1.01 1.01 0 001.026-1.008C13.07 5.45 12.602 5 12.044 5 11.468 5 11 5.45 11 6.008c0 .576.468 1.008 1.044 1.008zm-.702 11.106h1.386V9.356h-1.386v8.766z"
    }));
});



var $denZA = parcelRequire("denZA");
var $429b3d4e69163b2d$var$__assign = undefined && undefined.__assign || function() {
    $429b3d4e69163b2d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $429b3d4e69163b2d$var$__assign.apply(this, arguments);
};
var $429b3d4e69163b2d$export$d8874184141c994a = $denZA.forwardRef(function StatusInformationBold(props, svgRef) {
    return $denZA.createElement("svg", $429b3d4e69163b2d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm1.57 6.008c0 .87-.71 1.508-1.526 1.508-.829 0-1.544-.633-1.544-1.508 0-.851.71-1.508 1.544-1.508.823 0 1.526.662 1.526 1.508zm-2.728 12.614V9.4h2.386v9.222h-2.386z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $2311b7a87fc47db5$var$__assign = undefined && undefined.__assign || function() {
    $2311b7a87fc47db5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2311b7a87fc47db5$var$__assign.apply(this, arguments);
};
var $2311b7a87fc47db5$export$785e45f1d8c03432 = $denZA.forwardRef(function StatusSuccess(props, svgRef) {
    return $denZA.createElement("svg", $2311b7a87fc47db5$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.53 8.531a.75.75 0 00-1.06-1.06L9 15.94l-3.47-3.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l9-9z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $8d3ba8b69cd13d82$var$__assign = undefined && undefined.__assign || function() {
    $8d3ba8b69cd13d82$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d3ba8b69cd13d82$var$__assign.apply(this, arguments);
};
var $8d3ba8b69cd13d82$export$17e1460061865da = $denZA.forwardRef(function StatusSuccessBold(props, svgRef) {
    return $denZA.createElement("svg", $8d3ba8b69cd13d82$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.94-2.94a1.5 1.5 0 00-2.12-2.12L9 14.878l-2.94-2.94a1.5 1.5 0 00-2.12 2.122l4 4a1.5 1.5 0 002.12 0l9-9z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $e795c1d7a19fa517$var$__assign = undefined && undefined.__assign || function() {
    $e795c1d7a19fa517$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e795c1d7a19fa517$var$__assign.apply(this, arguments);
};
var $e795c1d7a19fa517$export$a2518b5310db22ab = $denZA.forwardRef(function StatusWarning(props, svgRef) {
    return $denZA.createElement("svg", $e795c1d7a19fa517$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.75 20.727L14.289 1.424C13.98.807 13.466.344 12.815.138a2.576 2.576 0 00-1.954.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.272 2.272 0 001.028 3.034c.31.154.652.24.995.24H21.71a2.26 2.26 0 002.263-2.263 2.037 2.037 0 00-.223-1.011zm-1.49 1.543a.793.793 0 01-.55.223H2.255a.791.791 0 01-.703-1.114l9.497-19.287c.103-.205.274-.377.48-.48a1.14 1.14 0 01.463-.102c.394 0 .771.222.943.582l9.48 19.303a.781.781 0 01.085.343c-.017.206-.085.395-.24.532z"
    }), $denZA.createElement("path", {
        d: "M11.558 16.119h1.152l.252-8.118h-1.674l.27 8.118zm.576 3.96c.63 0 1.134-.468 1.134-1.134 0-.666-.504-1.134-1.134-1.134-.612 0-1.134.468-1.134 1.134 0 .666.522 1.134 1.134 1.134z"
    }));
});



var $denZA = parcelRequire("denZA");
var $02f87be4862405c0$var$__assign = undefined && undefined.__assign || function() {
    $02f87be4862405c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02f87be4862405c0$var$__assign.apply(this, arguments);
};
var $02f87be4862405c0$export$f1b6053a528b50d9 = $denZA.forwardRef(function StatusWarningBold(props, svgRef) {
    return $denZA.createElement("svg", $02f87be4862405c0$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.297 1.424l9.463 19.303c.154.308.24.651.223 1.011a2.26 2.26 0 01-2.263 2.263H2.263c-.343 0-.686-.086-.994-.24a2.272 2.272 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.868.258a2.576 2.576 0 011.955-.12c.651.206 1.165.669 1.474 1.286zm-1.263 14.352h-2.046l-.483-7.775h2.994l-.465 7.775zm.726 2.995c0 .986-.744 1.73-1.711 1.73-1.024 0-1.749-.744-1.749-1.73 0-.967.725-1.73 1.749-1.73.967 0 1.71.763 1.71 1.73z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $24606ff49c6f4469$var$__assign = undefined && undefined.__assign || function() {
    $24606ff49c6f4469$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24606ff49c6f4469$var$__assign.apply(this, arguments);
};
var $24606ff49c6f4469$export$e16de4ea1abb52c8 = $denZA.forwardRef(function Stopwatch(props, svgRef) {
    return $denZA.createElement("svg", $24606ff49c6f4469$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M8.807 10.346a.75.75 0 00-1.114 1.006l3.75 4.15a.75.75 0 001.114-1.005l-3.75-4.15z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.751 9.751 0 015.18 1.981l.907-.908a.75.75 0 011.193-.882l.375.375.375.375a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $057a330b74c96ac8$var$__assign = undefined && undefined.__assign || function() {
    $057a330b74c96ac8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $057a330b74c96ac8$var$__assign.apply(this, arguments);
};
var $057a330b74c96ac8$export$da6e25dd6239a135 = $denZA.forwardRef(function StopwatchBold(props, svgRef) {
    return $denZA.createElement("svg", $057a330b74c96ac8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 1.5h.75a.75.75 0 000-1.5h-4.5a.75.75 0 000 1.5h.75v3.116a9.75 9.75 0 108.901 3.287l1.32-1.319a.75.75 0 00.06-1.115l-.75-.75a.75.75 0 00-1.11.054l-1.424 1.424a9.755 9.755 0 00-3.997-1.58V1.5zM7.395 12.395l3.307 3.307c.484.484 1.351.402 1.937-.184.586-.586.668-1.453.184-1.938l-3.307-3.306c-.484-.484-1.351-.402-1.937.184-.586.586-.668 1.453-.184 1.937z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $2e7321853f62d998$var$__assign = undefined && undefined.__assign || function() {
    $2e7321853f62d998$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e7321853f62d998$var$__assign.apply(this, arguments);
};
var $2e7321853f62d998$export$88a6666ae2487175 = $denZA.forwardRef(function Strategy(props, svgRef) {
    return $denZA.createElement("svg", $2e7321853f62d998$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#strategy_svg__strategy_svg__clip0)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.879.618a1.303 1.303 0 012.25.013l2.343 4.154A1.304 1.304 0 0114.35 6.75h-1.6v9.743c1.066-1.557 2.696-2.712 4.875-3.515l-.73-1.753a1.305 1.305 0 011.384-1.789l4.6.647a1.303 1.303 0 01.862 2.076l-2.793 3.709a1.305 1.305 0 01-2.246-.288l-.502-1.215c-3.592 1.302-5.358 3.562-5.446 7.287l-.004.299v1.3a.75.75 0 01-1.493.102l-.007-.102v-1.305c-.002-3.901-1.764-6.245-5.45-7.581l-.502 1.216a1.305 1.305 0 01-2.247.285L.26 12.161a1.303 1.303 0 01.86-2.078l4.6-.647a1.305 1.305 0 011.383 1.793l-.729 1.75c2.18.802 3.809 1.957 4.875 3.514V6.75h-1.6a1.303 1.303 0 01-1.128-1.952l2.357-4.18zM12 5.25h2.012L12 1.682 9.988 5.25H12zm-7.187 7.579l.774-1.86-3.93.553 2.385 3.168.77-1.861zm17.529-1.307l-3.93-.553.776 1.861.768 1.859 2.386-3.167z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "strategy_svg__strategy_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $bb0f5af207dd3672$var$__assign = undefined && undefined.__assign || function() {
    $bb0f5af207dd3672$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb0f5af207dd3672$var$__assign.apply(this, arguments);
};
var $bb0f5af207dd3672$export$c058c71d1bbd656d = $denZA.forwardRef(function StrategyBold(props, svgRef) {
    return $denZA.createElement("svg", $bb0f5af207dd3672$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 24c.306 0 .6-.126.816-.352.216-.224.338-.53.338-.848v-.404c-.008-3.763 2.036-7.206 5.274-8.884a.225.225 0 01.184-.01c.06.024.108.072.133.133l.232.582a.929.929 0 00.854.593.91.91 0 00.739-.384l2.322-3.208a.992.992 0 00.116-.946.93.93 0 00-.725-.583l-3.827-.56a.907.907 0 00-.857.364.992.992 0 00-.123.955l.207.52a.244.244 0 01-.113.31 11.909 11.909 0 00-4.007 3.252.226.226 0 01-.256.072.24.24 0 01-.153-.225V6.923a.25.25 0 01.067-.17.225.225 0 01.164-.07h.745a.956.956 0 00.837-.503c.172-.312.17-.696-.007-1.006l-2.13-3.758A.993.993 0 0012 .958a.993.993 0 00-.83.458L9.04 5.174c-.175.31-.177.694-.005 1.006a.957.957 0 00.836.504h.745c.06 0 .12.024.163.07a.244.244 0 01.067.17v7.453a.24.24 0 01-.153.225.226.226 0 01-.256-.072 11.909 11.909 0 00-4.007-3.253.244.244 0 01-.112-.308l.206-.521a.992.992 0 00-.122-.955.906.906 0 00-.858-.363l-3.827.56a.93.93 0 00-.725.583.992.992 0 00.116.946l2.326 3.209a.911.911 0 00.855.376.929.929 0 00.738-.585l.232-.582a.239.239 0 01.133-.133.223.223 0 01.184.01c3.239 1.679 5.282 5.121 5.275 8.884v.404c0 .66.514 1.195 1.15 1.198z"
    }));
});



var $denZA = parcelRequire("denZA");
var $67a92a5a9be558cf$var$__assign = undefined && undefined.__assign || function() {
    $67a92a5a9be558cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67a92a5a9be558cf$var$__assign.apply(this, arguments);
};
var $67a92a5a9be558cf$export$616b2c96b9b691e = $denZA.forwardRef(function SupportChat(props, svgRef) {
    return $denZA.createElement("svg", $67a92a5a9be558cf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.5 2.438a7.188 7.188 0 00-7.152 6.469 1.438 1.438 0 011.402 1.437v7.187a1.438 1.438 0 01-1.438 1.438h-.718A3.594 3.594 0 011 15.375V12.5a3.594 3.594 0 012.9-3.526 8.625 8.625 0 0117.2 0A3.593 3.593 0 0124 12.5v2.875a3.594 3.594 0 01-2.875 3.521v.073a3.593 3.593 0 01-3.594 3.593h-1.56A2.156 2.156 0 0113.936 24H12.5a2.157 2.157 0 010-4.313h1.438a2.156 2.156 0 012.032 1.438h1.561a2.157 2.157 0 002.157-2.156 1.438 1.438 0 01-1.438-1.438v-7.187a1.438 1.438 0 011.401-1.437 7.187 7.187 0 00-7.151-6.47zm1.946 18.898a.719.719 0 01-.508 1.227H12.5a.719.719 0 110-1.438h1.438c.19 0 .373.076.508.21zm5.96-3.805a2.156 2.156 0 002.157-2.156V12.5a2.157 2.157 0 00-2.157-2.156h-.718v7.187h.718zM3.07 10.975a2.156 2.156 0 011.525-.631h.718v7.187h-.718a2.156 2.156 0 01-2.157-2.156V12.5c0-.572.228-1.12.632-1.525z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10.11 15.267a.719.719 0 00-.97 1.063 4.987 4.987 0 006.72 0 .719.719 0 00-.97-1.063 3.55 3.55 0 01-4.78 0zM9.625 9.85a.72.72 0 01.719.719v1.257a.719.719 0 01-1.438 0V10.57a.72.72 0 01.719-.719zm6.469.719a.719.719 0 10-1.438 0v1.257a.719.719 0 001.438 0V10.57z"
    }));
});



var $denZA = parcelRequire("denZA");
var $0f3205a85ec0c960$var$__assign = undefined && undefined.__assign || function() {
    $0f3205a85ec0c960$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0f3205a85ec0c960$var$__assign.apply(this, arguments);
};
var $0f3205a85ec0c960$export$9c6a6487c263eb9c = $denZA.forwardRef(function SupportChatBold(props, svgRef) {
    return $denZA.createElement("svg", $0f3205a85ec0c960$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M10.986.044a9 9 0 019.838 8.002 3.969 3.969 0 012.926 3.829v2.875a3.969 3.969 0 01-2.881 3.817 3.969 3.969 0 01-3.963 3.745h-1.31a2.528 2.528 0 01-2.284 1.438h-1.437a2.531 2.531 0 010-5.063h1.438a2.531 2.531 0 012.282 1.438h1.311a1.782 1.782 0 001.75-1.452 1.813 1.813 0 01-1.406-1.767V9.72a1.813 1.813 0 011.358-1.755 6.813 6.813 0 00-13.466 0A1.812 1.812 0 016.5 9.72v7.187a1.812 1.812 0 01-1.813 1.813H3.97A3.969 3.969 0 010 14.75v-2.875a3.969 3.969 0 012.926-3.83 9 9 0 018.06-8.001z"
    }), $denZA.createElement("path", {
        d: "M13.656 9.944a1.094 1.094 0 012.188 0v1.257a1.094 1.094 0 11-2.188 0V9.944zm-5.464 4.493a1.094 1.094 0 011.545-.072 3.175 3.175 0 004.276 0 1.094 1.094 0 111.474 1.617 5.362 5.362 0 01-7.224 0 1.094 1.094 0 01-.071-1.545zM9 8.85c-.604 0-1.094.49-1.094 1.094v1.257a1.094 1.094 0 102.188 0V9.944c0-.604-.49-1.094-1.094-1.094z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f1fef17562ab850b$var$__assign = undefined && undefined.__assign || function() {
    $f1fef17562ab850b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1fef17562ab850b$var$__assign.apply(this, arguments);
};
var $f1fef17562ab850b$export$3288d34c523a1192 = $denZA.forwardRef(function Tag(props, svgRef) {
    return $denZA.createElement("svg", $f1fef17562ab850b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18 3.75a2.25 2.25 0 110 4.499 2.25 2.25 0 010-4.499zm.287 1.557a.75.75 0 10-.574 1.386.75.75 0 00.574-1.386z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.75 0A2.25 2.25 0 0124 2.25v6.257a3.75 3.75 0 01-1.098 2.651L11.342 22.72a2.25 2.25 0 01-3.182 0l-6.88-6.88a2.25 2.25 0 010-3.181L12.843 1.097A3.75 3.75 0 0115.493 0h6.257zm.53 1.72a.75.75 0 00-.53-.22h-6.257a2.25 2.25 0 00-1.59.658L2.34 13.72a.75.75 0 000 1.06l6.88 6.88a.75.75 0 001.06 0l11.56-11.561a2.25 2.25 0 00.659-1.591V2.25a.75.75 0 00-.22-.53z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $90ff8511b1add54a$var$__assign = undefined && undefined.__assign || function() {
    $90ff8511b1add54a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90ff8511b1add54a$var$__assign.apply(this, arguments);
};
var $90ff8511b1add54a$export$eb1b14be98724170 = $denZA.forwardRef(function TagBold(props, svgRef) {
    return $denZA.createElement("svg", $90ff8511b1add54a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M21.966.373a2.25 2.25 0 00-.527-.063h-6.257a3.752 3.752 0 00-2.65 1.098L.97 12.968a2.25 2.25 0 000 3.182l6.879 6.88a2.25 2.25 0 003.182 0l11.56-11.562a3.753 3.753 0 001.098-2.65V2.56A2.25 2.25 0 0021.966.373z"
    }));
});



var $denZA = parcelRequire("denZA");
var $c9445f350606fb9b$var$__assign = undefined && undefined.__assign || function() {
    $c9445f350606fb9b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9445f350606fb9b$var$__assign.apply(this, arguments);
};
var $c9445f350606fb9b$export$a51f2b8e6ae258ea = $denZA.forwardRef(function Target(props, svgRef) {
    return $denZA.createElement("svg", $c9445f350606fb9b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.735.61a.75.75 0 00-1.262-.395l-3.248 3.192a.75.75 0 00-.216.423l-.53 3.506-3.993 3.993a.75.75 0 101.06 1.06l3.993-3.992 3.506-.532a.75.75 0 00.423-.215l3.192-3.248a.75.75 0 00-.394-1.263l-2.124-.406-.407-2.124zm-3.658 6.188l.378-2.496 2.07-2.035.24 1.248a.75.75 0 00.595.596l1.248.238-2.035 2.07-2.496.379z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.538 3.046A9 9 0 006.68 19.518l.01.002.008.002a.746.746 0 01.4.255A8.999 8.999 0 0020.33 9.704a.75.75 0 111.45-.382 10.5 10.5 0 01-3.938 11.141l.651 2.605a.75.75 0 11-1.455.364l-.533-2.134a10.5 10.5 0 01-9.51.125l-.502 2.009a.75.75 0 11-1.455-.364l.61-2.437a10.492 10.492 0 01-4.245-6.24A10.5 10.5 0 0112.69 1.554a.75.75 0 11-.152 1.492z"
    }), $denZA.createElement("path", {
        d: "M11.622 7.5a.75.75 0 000-1.5 6.001 6.001 0 105.828 4.556.75.75 0 10-1.456.362A4.501 4.501 0 1111.622 7.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $fb3e79f5f693ae35$var$__assign = undefined && undefined.__assign || function() {
    $fb3e79f5f693ae35$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb3e79f5f693ae35$var$__assign.apply(this, arguments);
};
var $fb3e79f5f693ae35$export$789133e8ec70b6e2 = $denZA.forwardRef(function TargetBold(props, svgRef) {
    return $denZA.createElement("svg", $fb3e79f5f693ae35$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 23 24",
        width: 23
    }, props), $denZA.createElement("path", {
        d: "M21.98 3.811a.5.5 0 00-.462-.308h-2.752a.25.25 0 01-.25-.25V.5a.5.5 0 00-.854-.354l-2.416 2.416a2.486 2.486 0 00-.733 1.77v1.685a.25.25 0 01-.117.212.492.492 0 00-.09.069l-5.004 5.004a1 1 0 101.415 1.415l5.004-5.004a.464.464 0 00.07-.09.253.253 0 01.212-.117h1.684a2.485 2.485 0 001.77-.734l2.416-2.416a.5.5 0 00.108-.545z"
    }), $denZA.createElement("path", {
        d: "M10.01 8.006a1 1 0 000-2.001 6.005 6.005 0 106.004 6.005 1 1 0 00-2.002 0 4.003 4.003 0 11-4.003-4.004z"
    }), $denZA.createElement("path", {
        d: "M20.017 12.01a1 1 0 00-2.001 0 8.006 8.006 0 11-8.007-8.007 1 1 0 000-2.001 10 10 0 00-7.167 16.981.25.25 0 01.011.338l-2.61 3.047a1 1 0 001.52 1.301l2.664-3.107a.25.25 0 01.32-.05 9.948 9.948 0 0010.523 0 .25.25 0 01.323.05l2.664 3.107a1 1 0 001.52-1.3l-2.611-3.048a.25.25 0 01.01-.337 9.97 9.97 0 002.841-6.974z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d99db393c587c578$var$__assign = undefined && undefined.__assign || function() {
    $d99db393c587c578$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d99db393c587c578$var$__assign.apply(this, arguments);
};
var $d99db393c587c578$export$290b33259d59609 = $denZA.forwardRef(function ThreedPrinting(props, svgRef) {
    return $denZA.createElement("svg", $d99db393c587c578$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M9.543 4.262l1.714-1.713v4.18a.76.76 0 00.754.754.76.76 0 00.754-.754V2.531l1.713 1.714a.74.74 0 00.531.223.755.755 0 00.531-1.285L12.542.2h-.017a.452.452 0 00-.103-.085c-.017-.017-.034-.017-.052-.035a.13.13 0 00-.068-.034C12.285.03 12.251.03 12.233.03c-.017 0-.034-.017-.068-.017a.832.832 0 00-.291 0c-.018 0-.035.017-.069.017s-.051.017-.086.017c-.017.017-.051.017-.068.034-.017.018-.034.018-.069.035A.452.452 0 0011.48.2h-.018l-2.98 3a.755.755 0 000 1.062.755.755 0 001.061 0zM5.106 17.815l-3.598 3.598V20.23a.76.76 0 00-.754-.754.76.76 0 00-.754.754v2.998c0 .051 0 .103.017.154 0 .017.017.035.017.069s.017.051.017.085c.018.018.018.052.035.069.017.017.017.034.034.068a.416.416 0 00.086.103v.017h.017a.455.455 0 00.103.086c.017.017.034.017.068.034.017.017.051.017.069.035.017.017.051.017.085.017.017 0 .035.017.069.017C.668 24 .72 24 .77 24h2.998a.76.76 0 00.754-.754.76.76 0 00-.754-.754H2.587l3.598-3.598a.755.755 0 000-1.062.76.76 0 00-1.08-.017z"
    }), $denZA.createElement("path", {
        d: "M16.277 19.7l-3.53 1.593V13.96l6.751-3.067v4.831a.76.76 0 00.754.754.76.76 0 00.754-.754V9.728c0-.035 0-.069-.017-.12v-.035a.23.23 0 00-.035-.102v-.017c-.017-.035-.034-.069-.05-.12 0-.018-.018-.018-.018-.035a.374.374 0 00-.069-.085v-.018c-.034-.034-.068-.05-.085-.085-.017 0-.017-.017-.034-.017l-.018-.017c-.034-.018-.051-.035-.085-.052l-5.277-2.364a.753.753 0 00-.994.377.753.753 0 00.377.993l3.752 1.697-6.442 2.912-6.443-2.912L9.321 8.03a.752.752 0 00-.617-1.37L3.46 9.042a.374.374 0 00-.086.052l-.017.017c-.017 0-.017.017-.034.017-.034.034-.069.051-.103.086a.358.358 0 00-.068.102c0 .018-.018.018-.018.035a.835.835 0 00-.05.12v.017c-.018.034-.018.068-.035.103v.034c0 .034-.017.068-.017.12v5.997a.76.76 0 00.754.753.76.76 0 00.753-.753v-4.85l6.751 3.068v7.35l-3.51-1.593a.753.753 0 00-.994.377.753.753 0 00.377.993l4.575 2.09c.051.018.085.035.137.052h.034a.38.38 0 00.137.017c.051 0 .086 0 .137-.017h.034c.052-.017.086-.017.137-.051l4.575-2.074a.753.753 0 00.377-.993c-.206-.412-.651-.583-1.028-.412z"
    }), $denZA.createElement("path", {
        d: "M23.901 23.572a.13.13 0 00.035-.069c.017-.017.017-.051.017-.068 0-.017.017-.052.017-.069a.376.376 0 00.017-.137v-2.998a.76.76 0 00-.754-.754.76.76 0 00-.754.754v1.182l-3.598-3.598a.755.755 0 00-1.062 0 .755.755 0 000 1.062l3.598 3.598h-1.182a.76.76 0 00-.754.754.76.76 0 00.754.754h2.998c.052 0 .103 0 .154-.017.018 0 .035-.017.069-.017s.051-.018.086-.018c.017-.017.051-.017.068-.034.017-.017.035-.017.069-.034s.068-.052.103-.086h.017v-.017a.453.453 0 00.085-.103c0-.051.017-.068.017-.085z"
    }));
});



var $denZA = parcelRequire("denZA");
var $e9c662d7339c83e9$var$__assign = undefined && undefined.__assign || function() {
    $e9c662d7339c83e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9c662d7339c83e9$var$__assign.apply(this, arguments);
};
var $e9c662d7339c83e9$export$75745cda8b35a66 = $denZA.forwardRef(function ThreedPrintingBold(props, svgRef) {
    return $denZA.createElement("svg", $e9c662d7339c83e9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M10 3.312h.75a.25.25 0 01.25.25v1a1 1 0 102 0v-1a.25.25 0 01.25-.25H14a.75.75 0 00.473-1.332l-2-1.625a.752.752 0 00-.946 0l-2 1.625A.75.75 0 0010 3.312z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.04 16.531a2 2 0 00.546 1.945l1.154 1.155a.25.25 0 01-.076.406L12.2 21.99a.5.5 0 01-.4 0l-4.47-1.947a.251.251 0 01-.077-.406l1.161-1.161a2 2 0 10-2.828-2.828l-.659.659a.25.25 0 01-.427-.176v-5.975a.75.75 0 01.449-.687L11.7 6.516a.75.75 0 01.6 0l6.751 2.953c.273.12.449.39.449.687v5.975a.25.25 0 01-.427.176l-.659-.659a2 2 0 00-3.373.883zm1.465-6.375a.25.25 0 00-.15-.229L12.1 8.066a.249.249 0 00-.2 0L7.645 9.927a.25.25 0 000 .458l4.255 1.862a.257.257 0 00.2 0l4.255-1.862a.25.25 0 00.15-.229z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M7.707 17.769a1 1 0 10-1.414-1.414L2.5 20.148a.25.25 0 01-.354 0l-.616-.616a.75.75 0 00-1.28.53v3c0 .414.336.75.75.75h3a.75.75 0 00.53-1.28l-.616-.616a.25.25 0 010-.354l3.793-3.793zm16.043 5.293v-3a.75.75 0 00-1.28-.53l-.616.616a.25.25 0 01-.354 0l-3.793-3.793a1 1 0 10-1.414 1.414l3.793 3.793a.25.25 0 010 .354l-.616.616a.75.75 0 00.53 1.28h3a.75.75 0 00.75-.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f1aa93036ece2df0$var$__assign = undefined && undefined.__assign || function() {
    $f1aa93036ece2df0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1aa93036ece2df0$var$__assign.apply(this, arguments);
};
var $f1aa93036ece2df0$export$680ea196effce5f = $denZA.forwardRef(function Time(props, svgRef) {
    return $denZA.createElement("svg", $f1aa93036ece2df0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 7.5a.75.75 0 01.75.75v3.44l4.467 4.468a.75.75 0 01-1.06 1.06L11.47 12.53a.748.748 0 01-.22-.53V8.25A.75.75 0 0112 7.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.045 4.045a11.25 11.25 0 1115.91 15.91 11.25 11.25 0 01-15.91-15.91zM12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $37055922f7b6d3ef$var$__assign = undefined && undefined.__assign || function() {
    $37055922f7b6d3ef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37055922f7b6d3ef$var$__assign.apply(this, arguments);
};
var $37055922f7b6d3ef$export$cef7b1bbd85670df = $denZA.forwardRef(function TimeBold(props, svgRef) {
    return $denZA.createElement("svg", $37055922f7b6d3ef$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5zM13.5 8a1.5 1.5 0 00-3 0v4.621l4.94 4.94a1.5 1.5 0 002.12-2.122l-4.06-4.06V8z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $f4e4d0aa82879691$var$__assign = undefined && undefined.__assign || function() {
    $f4e4d0aa82879691$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4e4d0aa82879691$var$__assign.apply(this, arguments);
};
var $f4e4d0aa82879691$export$cec4f96e18e205ef = $denZA.forwardRef(function Transfer(props, svgRef) {
    return $denZA.createElement("svg", $f4e4d0aa82879691$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M4.28 6.53a.75.75 0 00-1.06-1.06l-3 3-.003.002A.748.748 0 00.22 9.53l3 3a.75.75 0 001.06-1.06L2.56 9.75H13.5a.75.75 0 000-1.5H2.56l1.72-1.72zm16.5 4.94a.75.75 0 10-1.06 1.06l1.72 1.72H10.5a.75.75 0 000 1.5h10.94l-1.72 1.72a.75.75 0 101.06 1.06l3-3A.746.746 0 0024 15v-.008a.748.748 0 00-.22-.522l-3-3z"
    }));
});



var $denZA = parcelRequire("denZA");
var $ea057cdfb15f9c52$var$__assign = undefined && undefined.__assign || function() {
    $ea057cdfb15f9c52$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea057cdfb15f9c52$var$__assign.apply(this, arguments);
};
var $ea057cdfb15f9c52$export$a818bbe058f189e = $denZA.forwardRef(function Unlock(props, svgRef) {
    return $denZA.createElement("svg", $ea057cdfb15f9c52$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M15 14.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.818 3.818A4.5 4.5 0 0111.5 7v2H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75H13V7A6 6 0 101 7v2.25a.75.75 0 001.5 0V7a4.5 4.5 0 011.318-3.182zM22.5 10.5h-15v12h15v-12z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $cac05be16bfbf270$var$__assign = undefined && undefined.__assign || function() {
    $cac05be16bfbf270$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cac05be16bfbf270$var$__assign.apply(this, arguments);
};
var $cac05be16bfbf270$export$cc1b5dff9a340610 = $denZA.forwardRef(function UnlockBold(props, svgRef) {
    return $denZA.createElement("svg", $cac05be16bfbf270$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.917 1.917a6.545 6.545 0 0111.174 4.628V8.6H23.23a.77.77 0 01.77.77v13.86a.77.77 0 01-.77.771H6.289a.77.77 0 01-.77-.77V9.369a.77.77 0 01.77-.77h4.492V6.545a4.235 4.235 0 10-8.47 0v2.31a1.155 1.155 0 11-2.311 0v-2.31c0-1.736.69-3.4 1.917-4.628zM14.76 13.604c-.638 0-1.155.517-1.155 1.155v3.08a1.155 1.155 0 102.31 0v-3.08c0-.638-.517-1.155-1.155-1.155z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $187180f9a418e119$var$__assign = undefined && undefined.__assign || function() {
    $187180f9a418e119$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $187180f9a418e119$var$__assign.apply(this, arguments);
};
var $187180f9a418e119$export$c58532f0fb5faa97 = $denZA.forwardRef(function Upload(props, svgRef) {
    return $denZA.createElement("svg", $187180f9a418e119$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12.52 3.21a.747.747 0 00-1.05.01l-4.5 4.5a.75.75 0 101.061 1.06l3.22-3.22v10.19a.75.75 0 001.5 0V5.56l3.219 3.22a.75.75 0 101.06-1.06l-4.5-4.5a.544.544 0 00-.01-.01z"
    }), $denZA.createElement("path", {
        d: "M1.5 15.75a.75.75 0 10-1.499 0v1.5A3.75 3.75 0 003.751 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $d97886adc4a40565$var$__assign = undefined && undefined.__assign || function() {
    $d97886adc4a40565$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d97886adc4a40565$var$__assign.apply(this, arguments);
};
var $d97886adc4a40565$export$1f42c19cf267f1bb = $denZA.forwardRef(function UpwardTrend(props, svgRef) {
    return $denZA.createElement("svg", $d97886adc4a40565$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M17.331.048a.75.75 0 00-.526 1.404l1.486.558-14.42 6.548a.75.75 0 10.621 1.366l14.42-6.548-.558 1.487a.75.75 0 001.404.527l1.194-3.182.002-.006a.747.747 0 00-.44-.96l-.003-.001L17.33.048z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18 9a1.5 1.5 0 00-1.5 1.5v12H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5V18A1.5 1.5 0 006 16.5H3A1.5 1.5 0 001.5 18v4.5H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75v-12A1.5 1.5 0 0021 9h-3zm3 1.5h-3v12h3v-12zm-10.5 3h3v9h-3v-9zm-4.5 9V18H3v4.5h3z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $3b0bac81c443abc6$var$__assign = undefined && undefined.__assign || function() {
    $3b0bac81c443abc6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b0bac81c443abc6$var$__assign.apply(this, arguments);
};
var $3b0bac81c443abc6$export$d5ad65c4a4d4aa75 = $denZA.forwardRef(function UsbStick(props, svgRef) {
    return $denZA.createElement("svg", $3b0bac81c443abc6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M11.25 3a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v5.379A2.25 2.25 0 0118 8.25V18a6 6 0 11-12 0V8.25a2.25 2.25 0 011.5-2.121V.75zM9 1.5h6V6H9V1.5zM7.72 7.72a.75.75 0 01.53-.22h7.5a.75.75 0 01.75.75V18a4.5 4.5 0 11-9 0V8.25a.75.75 0 01.22-.53z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $fb9a758a93995345$var$__assign = undefined && undefined.__assign || function() {
    $fb9a758a93995345$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb9a758a93995345$var$__assign.apply(this, arguments);
};
var $fb9a758a93995345$export$67fadca628676d83 = $denZA.forwardRef(function ViewHide(props, svgRef) {
    return $denZA.createElement("svg", $fb9a758a93995345$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.072 2.23a.75.75 0 01-.021 1.061l-18.75 18a.75.75 0 11-1.039-1.082l18.75-18a.75.75 0 011.06.022zm-2.929 5.958a.75.75 0 011.047-.164c1.156.843 2.223 1.8 3.187 2.858l.003.003a2.413 2.413 0 010 3.23l-.003.002C20.758 17 16.412 20.07 11.995 20a10.734 10.734 0 01-3.255-.483.75.75 0 01.445-1.432 9.236 9.236 0 002.826.415c3.779.064 7.744-2.627 10.255-5.39a.914.914 0 000-1.22 19.816 19.816 0 00-2.96-2.654.75.75 0 01-.163-1.048zM12 5c.874-.009 1.745.093 2.592.304a.75.75 0 01-.362 1.456 8.799 8.799 0 00-2.244-.26c-3.713-.062-7.69 2.57-10.252 5.388a.913.913 0 000 1.22c.767.84 1.605 1.613 2.503 2.31a.75.75 0 01-.92 1.185 21.553 21.553 0 01-2.693-2.486l-.004-.004a2.413 2.413 0 010-3.23l.002-.002C3.3 7.935 7.655 4.932 12 5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998 9.5a3 3 0 00-3 3 .75.75 0 01-1.5 0 4.499 4.499 0 014.5-4.5.75.75 0 010 1.5zm3.75 2.249a.75.75 0 01.75.75 4.502 4.502 0 01-4.5 4.501.75.75 0 110-1.5 3 3 0 003-3 .75.75 0 01.75-.751z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $176e1eca291319f1$var$__assign = undefined && undefined.__assign || function() {
    $176e1eca291319f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $176e1eca291319f1$var$__assign.apply(this, arguments);
};
var $176e1eca291319f1$export$639d2a0e5f6e1492 = $denZA.forwardRef(function ViewHideBold(props, svgRef) {
    return $denZA.createElement("svg", $176e1eca291319f1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.967 19.978a1.365 1.365 0 00-.028 1.83 1.145 1.145 0 001.702.027l3.342-3.485c1.275.553 2.57.873 3.827.9h.31c3.597.065 7.577-2.369 10.525-5.858a2.54 2.54 0 00.002-3.219 19.969 19.969 0 00-3.61-3.35l2.973-3.1c.477-.498.49-1.318.028-1.83a1.145 1.145 0 00-1.702-.027L2.967 19.978zm12.253-9.175l-4.118 4.294a3.03 3.03 0 001.007.171c1.79 0 3.24-1.56 3.24-3.485 0-.34-.045-.669-.13-.98z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.109 8.298c.304 0 .598.045.878.13l3.126-3.26c-1.231-.521-2.475-.822-3.677-.851l-.315-.001C8.529 4.25 4.527 6.677 1.576 10.17a2.54 2.54 0 00-.002 3.218 20.048 20.048 0 003.506 3.283l3.883-4.049a3.744 3.744 0 01-.095-.84c0-1.925 1.451-3.485 3.24-3.485z"
    }));
});



var $denZA = parcelRequire("denZA");
var $fb6cd4058592c1ce$var$__assign = undefined && undefined.__assign || function() {
    $fb6cd4058592c1ce$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb6cd4058592c1ce$var$__assign.apply(this, arguments);
};
var $fb6cd4058592c1ce$export$153f7030970dae8f = $denZA.forwardRef(function ViewShow(props, svgRef) {
    return $denZA.createElement("svg", $fb6cd4058592c1ce$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M23.383 10.337c-2.606-2.863-6.909-5.88-11.246-5.88H12c-4.389-.068-8.76 3-11.383 5.88a2.435 2.435 0 000 3.24c2.589 2.863 6.892 5.88 11.229 5.88h.274c4.337 0 8.64-3.034 11.246-5.88.84-.926.84-2.314.017-3.24zm-1.114 2.229c-2.383 2.623-6.275 5.4-10.115 5.4H12c-3.891.051-7.851-2.743-10.251-5.383a.916.916 0 010-1.217c3.6-3.995 7.56-5.4 10.131-5.4h.137c2.554-.052 6.583 1.354 10.252 5.383a.916.916 0 010 1.217z"
    }), $denZA.createElement("path", {
        d: "M12 7.457c-2.486 0-4.509 2.023-4.509 4.492 0 1.2.463 2.331 1.32 3.188A4.444 4.444 0 0012 16.457c2.486 0 4.491-2.023 4.509-4.491 0-1.2-.463-2.332-1.32-3.189A4.474 4.474 0 0012 7.457zm3 4.509a2.981 2.981 0 01-3 3 2.981 2.981 0 01-3-3c0-1.646 1.354-3 3-3a2.981 2.981 0 013 3z"
    }));
});



var $denZA = parcelRequire("denZA");
var $f2a62fcb81623bd1$var$__assign = undefined && undefined.__assign || function() {
    $f2a62fcb81623bd1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2a62fcb81623bd1$var$__assign.apply(this, arguments);
};
var $f2a62fcb81623bd1$export$6d39d2f2d511d9a3 = $denZA.forwardRef(function ViewShowBold(props, svgRef) {
    return $denZA.createElement("svg", $f2a62fcb81623bd1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.436 4.502h-.315c-3.592-.066-7.594 2.36-10.545 5.854a2.54 2.54 0 00-.002 3.219c2.863 3.392 6.7 5.786 10.236 5.86h.31c3.597.066 7.577-2.368 10.525-5.858a2.54 2.54 0 00.002-3.218C19.79 6.98 15.935 4.586 12.436 4.502zm-.327 10.952c1.79 0 3.24-1.56 3.24-3.485 0-1.925-1.45-3.486-3.24-3.486-1.79 0-3.24 1.56-3.24 3.486 0 1.925 1.45 3.485 3.24 3.485z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $508f6e27b459455f$var$__assign = undefined && undefined.__assign || function() {
    $508f6e27b459455f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $508f6e27b459455f$var$__assign.apply(this, arguments);
};
var $508f6e27b459455f$export$b5e8fd97b49d7a6e = $denZA.forwardRef(function VirtualReality(props, svgRef) {
    return $denZA.createElement("svg", $508f6e27b459455f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.5 13.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998.75A8.272 8.272 0 003.75 8.998v.019a4.125 4.125 0 00.375 8.233c.164 0 .326-.022.482-.063A2.25 2.25 0 006.75 18.75h3a.75.75 0 00.416-.126L12 17.401l1.833 1.223a.751.751 0 00.416.126h3a2.25 2.25 0 002.143-1.563c.156.041.318.063.483.063a4.125 4.125 0 00.375-8.233v-.019A8.272 8.272 0 0012.002.75h-.004zm6.232 9.225a1.875 1.875 0 01.52-.6v-.374A6.772 6.772 0 0012 2.25a6.772 6.772 0 00-6.75 6.751v.374a1.875 1.875 0 01.52.6 2.25 2.25 0 01.98-.225h10.5c.343 0 .677.079.98.225zM6 12v4.5a.75.75 0 00.75.75h2.773l2.061-1.374a.75.75 0 01.832 0l2.06 1.374h2.773a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H6.75A.75.75 0 006 12zm-1.5-1.125a.375.375 0 00-.375-.375 2.625 2.625 0 000 5.25.375.375 0 00.375-.375v-4.5zm15.375-.375a.375.375 0 00-.375.375v4.5a.375.375 0 00.375.375 2.625 2.625 0 000-5.25z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M17.774 20.89a.75.75 0 00-1.05-1.072 6.75 6.75 0 01-8.774.582.75.75 0 10-.9 1.2 8.25 8.25 0 0010.724-.71z"
    }));
});



var $denZA = parcelRequire("denZA");
var $9bb7431e1ee7ab8e$var$__assign = undefined && undefined.__assign || function() {
    $9bb7431e1ee7ab8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9bb7431e1ee7ab8e$var$__assign.apply(this, arguments);
};
var $9bb7431e1ee7ab8e$export$d1389198cb17768a = $denZA.forwardRef(function VirtualRealityBold(props, svgRef) {
    return $denZA.createElement("svg", $9bb7431e1ee7ab8e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M18.53 20.81a9.54 9.54 0 01-6.19 2.92 9.42 9.42 0 01-6.5-2 1 1 0 01-.18-1.31.861.861 0 011.24-.22 7.71 7.71 0 005.32 1.66 7.81 7.81 0 005.06-2.39.858.858 0 011.26 0 1 1 0 01-.01 1.34zM3.75 9.19A8.22 8.22 0 0111.1 1a10 10 0 011.74 0 8.34 8.34 0 017.41 8.22 4.06 4.06 0 013.65 3.22 4.582 4.582 0 01-.06 2 4 4 0 01-4.45 2.94 2.2 2.2 0 01-2.14 1.56h-3s-.33.06-2.25-1.35l-1.83 1.22s-.19.24-3.42.13a2.32 2.32 0 01-2.14-1.56S1.53 18 .16 14.44a8.13 8.13 0 01-.07-2 4.21 4.21 0 013.66-3.25zm.19 2.09a1.92 1.92 0 00-2 1.55 2.06 2.06 0 002 2.63.3.3 0 00.3-.3V11.5a.33.33 0 00-.3-.22zm13.51 1a.65.65 0 00-.68-.64H7.18a.62.62 0 00-.68.64v3.77a.61.61 0 00.44.66c.916.048 1.834.048 2.75 0l2-1.24a.58.58 0 01.62.07c1.35.89 1.88 1.17 1.88 1.17h2.53a.629.629 0 00.68-.64l.05-3.79zM17.81 9a6.58 6.58 0 00-.63-3 6.101 6.101 0 00-1.75-2.09 6 6 0 00-2.9-1.14c-.5-.03-1-.03-1.5 0a5.88 5.88 0 00-2.94 1.41 6.06 6.06 0 00-1.55 2.07A6.41 6.41 0 006 9c.173.152.324.327.45.52 0 0 .12-.14.77-.2h9.08a2.16 2.16 0 011 .21 1.4 1.4 0 01.51-.53zm2 2.51v3.66a.3.3 0 00.3.3 2.06 2.06 0 002-2.63 1.92 1.92 0 00-2-1.55.331.331 0 00-.29.2l-.01.02z"
    }), $denZA.createElement("path", {
        d: "M18 11l-11.94-.1H6l.21 6.21h12L18 11zm-2.25 3.4h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 010 1.5z"
    }));
});



var $denZA = parcelRequire("denZA");
var $4fc30495f05f91bf$var$__assign = undefined && undefined.__assign || function() {
    $4fc30495f05f91bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fc30495f05f91bf$var$__assign.apply(this, arguments);
};
var $4fc30495f05f91bf$export$6b41c506d6ea41ba = $denZA.forwardRef(function WifiOff(props, svgRef) {
    return $denZA.createElement("svg", $4fc30495f05f91bf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.78.22a.75.75 0 010 1.06l-22.5 22.5a.75.75 0 01-1.06-1.06L22.72.22a.75.75 0 011.06 0zM9.348 17.598a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM12 18a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm2.361-4.904a.75.75 0 01.99-.382c.924.41 1.765.988 2.48 1.703a.75.75 0 01-1.061 1.06 6.726 6.726 0 00-2.027-1.392.75.75 0 01-.382-.99zM12 8.227a.75.75 0 01-.703.795 11.2 11.2 0 00-7.25 3.272.75.75 0 11-1.063-1.058 12.7 12.7 0 018.221-3.712.75.75 0 01.795.703zm5.304 1.229a.75.75 0 011.024-.278 12.768 12.768 0 012.688 2.057.75.75 0 11-1.062 1.06 11.271 11.271 0 00-2.372-1.815.75.75 0 01-.278-1.024zM7.146 3.695a17.234 17.234 0 017.94-.417.75.75 0 11-.268 1.476A15.734 15.734 0 001.262 8.729.75.75 0 01.238 7.633a17.234 17.234 0 016.908-3.938zM20.178 5.9a.75.75 0 011.035-.234 17.212 17.212 0 012.549 1.967.75.75 0 01-1.024 1.096 15.711 15.711 0 00-2.327-1.795.75.75 0 01-.233-1.035z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $32291515faec62bd$var$__assign = undefined && undefined.__assign || function() {
    $32291515faec62bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32291515faec62bd$var$__assign.apply(this, arguments);
};
var $32291515faec62bd$export$788829a381a1aca1 = $denZA.forwardRef(function WifiOn(props, svgRef) {
    return $denZA.createElement("svg", $32291515faec62bd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.348 16.098a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM12 16.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-5.836-3.583a8.25 8.25 0 0111.666 0 .75.75 0 01-1.06 1.06 6.75 6.75 0 00-9.546 0 .75.75 0 11-1.06-1.06z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.985 9.735a12.75 12.75 0 0118.03 0 .75.75 0 01-1.06 1.06 11.25 11.25 0 00-15.91 0 .75.75 0 11-1.06-1.06z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.239 6.132a17.25 17.25 0 0123.522 0A.75.75 0 1122.74 7.23a15.75 15.75 0 00-21.478 0A.75.75 0 01.24 6.132z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $26c9f8ef2a407aba$var$__assign = undefined && undefined.__assign || function() {
    $26c9f8ef2a407aba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26c9f8ef2a407aba$var$__assign.apply(this, arguments);
};
var $26c9f8ef2a407aba$export$6e5f9bb1ece75cb9 = $denZA.forwardRef(function Workshop(props, svgRef) {
    return $denZA.createElement("svg", $26c9f8ef2a407aba$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M12 3a.76.76 0 00.754-.754V.754A.76.76 0 0012 0a.761.761 0 00-.755.754v1.509c0 .394.343.737.755.737zM4.491 9h1.612a.761.761 0 00.754-.754.761.761 0 00-.754-.755H4.49a.761.761 0 00-.754.755c0 .411.343.754.754.754zm12.652-.754a.76.76 0 00.754.754h1.611a.761.761 0 00.755-.754.761.761 0 00-.755-.755h-1.611c-.412.018-.754.343-.754.755zm-10.492-3a.74.74 0 00.532.223.755.755 0 00.531-1.286L6.343 2.81a.755.755 0 00-1.063 0 .755.755 0 000 1.063l1.37 1.373zm10.166.223a.74.74 0 00.531-.223l1.372-1.372a.755.755 0 000-1.063.755.755 0 00-1.063 0l-1.372 1.372a.755.755 0 000 1.063.818.818 0 00.532.223zm-7.063 6.668v1.354c0 .412.343.755.754.755h3a.761.761 0 00.755-.755v-1.354a4.471 4.471 0 002.245-3.891 4.47 4.47 0 00-1.32-3.189A4.444 4.444 0 0012 3.737 4.496 4.496 0 007.508 8.23a4.444 4.444 0 002.246 3.908zm.12-6.017A2.981 2.981 0 0112 5.246a2.981 2.981 0 013 3 2.98 2.98 0 01-1.8 2.743.75.75 0 00-.446.685v1.063h-1.508v-1.063a.75.75 0 00-.446-.685 3.004 3.004 0 01-.926-4.869zM13.491 15h-3a.761.761 0 00-.754.754c0 .412.343.755.754.755h3a.761.761 0 00.755-.755.75.75 0 00-.755-.754zm10.474 8.006a5.182 5.182 0 00-2.657-2.983 7.906 7.906 0 00-.565-.24 3.373 3.373 0 00-1.697-6.292 3.373 3.373 0 00-3.378 3.378c0 1.234.669 2.314 1.68 2.914h-.017c-1.508.531-2.691 1.697-3.205 3.206a.752.752 0 00.462.96c.086.034.172.034.24.034.309 0 .6-.189.703-.497a3.725 3.725 0 012.297-2.297 3.65 3.65 0 012.846.171 3.693 3.693 0 011.903 2.126c.137.394.566.6.96.463.343-.12.549-.549.428-.943zM19.028 15c1.029 0 1.869.84 1.869 1.869 0 1.028-.84 1.868-1.869 1.868a1.877 1.877 0 01-1.885-1.868c0-1.046.84-1.869 1.885-1.869zM7.251 20.023a7.906 7.906 0 00-.565-.24 3.373 3.373 0 00-1.697-6.292c-1.87 0-3.395 1.526-3.395 3.378 0 1.234.669 2.331 1.68 2.914h-.017C1.748 20.314.566 21.48.051 22.989a.752.752 0 00.463.96.625.625 0 00.24.034c.309 0 .6-.189.703-.497a3.725 3.725 0 012.297-2.297 3.65 3.65 0 012.846.171 3.692 3.692 0 011.903 2.126c.137.394.565.6.96.463a.752.752 0 00.463-.96 5.29 5.29 0 00-2.675-2.966zM4.971 15C6 15 6.84 15.84 6.84 16.869c0 1.028-.84 1.885-1.869 1.885a1.873 1.873 0 01-1.868-1.868c0-1.029.84-1.886 1.868-1.886z"
    }));
});



var $denZA = parcelRequire("denZA");
var $777c465c1db10807$var$__assign = undefined && undefined.__assign || function() {
    $777c465c1db10807$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $777c465c1db10807$var$__assign.apply(this, arguments);
};
var $777c465c1db10807$export$7da4007fe4a3162 = $denZA.forwardRef(function WorkshopBold(props, svgRef) {
    return $denZA.createElement("svg", $777c465c1db10807$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("g", {
        clipPath: "url(#workshop-bold_svg__workshop-bold_svg__clip0)"
    }, $denZA.createElement("path", {
        d: "M9.74 12.14v1.36a.76.76 0 00.75.75h3a.76.76 0 00.75-.75v-1.36a4.5 4.5 0 10-4.51 0h.01zM13.48 15h-3a.755.755 0 100 1.51h3a.76.76 0 00.696-1.04.75.75 0 00-.696-.47zM24 23a5.18 5.18 0 00-2.66-3 6.92 6.92 0 00-.57-.24 3.38 3.38 0 10-3.39 0A5.181 5.181 0 0014.12 23a.75.75 0 00.46 1 .578.578 0 00.23 0h8.25v-.05a.74.74 0 00.49 0A.77.77 0 0024 23zM7.24 20a6.92 6.92 0 00-.57-.24 3.39 3.39 0 10-3.41 0A5.181 5.181 0 000 23a.75.75 0 00.5 1c.08.016.16.016.24 0H9.1a.74.74 0 00.36 0 .75.75 0 00.46-1 5.29 5.29 0 00-2.68-3zM12 3.47a1 1 0 001-1V1a1 1 0 00-2 0v1.47a1 1 0 001 1zm5 2.07a1 1 0 00.69-.27l1.07-1a1.022 1.022 0 00-1.42-1.47l-1.07 1A1 1 0 0017 5.54zM5.28 4.26l1.07 1a1 1 0 001.38-1.45l-1.07-1a1 1 0 00-1.2-.12.73.73 0 00-.19.13 1 1 0 00-.14.22 1 1 0 00.15 1.22z"
    }), $denZA.createElement("path", {
        d: "M17 8.14a1 1 0 001 1h1.5a1 1 0 000-2H18a1 1 0 00-1 1zM6 9.26a1 1 0 000-2H4.49a1 1 0 000 2H6z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "workshop-bold_svg__workshop-bold_svg__clip0"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    }))));
});



var $denZA = parcelRequire("denZA");
var $b9e177d130cf4abe$var$__assign = undefined && undefined.__assign || function() {
    $b9e177d130cf4abe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9e177d130cf4abe$var$__assign.apply(this, arguments);
};
var $b9e177d130cf4abe$export$d13069184bfa0730 = $denZA.forwardRef(function ZoomIn(props, svgRef) {
    return $denZA.createElement("svg", $b9e177d130cf4abe$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M10.056 1a9.056 9.056 0 017.072 14.713l5.58 5.58a1 1 0 01-1.321 1.498l-.094-.084-5.58-5.58A9.056 9.056 0 1110.056 1zm0 2a7.056 7.056 0 100 14.112 7.056 7.056 0 000-14.112z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 6.833c.368 0 .666.299.666.667v1.834H12.5a.666.666 0 110 1.332h-1.834V12.5a.666.666 0 11-1.332 0v-1.834H7.5a.666.666 0 110-1.332h1.834V7.5c0-.368.298-.667.666-.667z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $28b18912c8bfa67e$var$__assign = undefined && undefined.__assign || function() {
    $28b18912c8bfa67e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28b18912c8bfa67e$var$__assign.apply(this, arguments);
};
var $28b18912c8bfa67e$export$52a27ea68a20ff47 = $denZA.forwardRef(function ZoomInBold(props, svgRef) {
    return $denZA.createElement("svg", $28b18912c8bfa67e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10 6.75a.916.916 0 00-.916.917V9.25H7.5a.916.916 0 100 1.833h1.584v1.583a.916.916 0 101.832 0v-1.583H12.5a.916.916 0 100-1.833h-1.584V7.667A.916.916 0 0010 6.75z"
    }));
});



var $denZA = parcelRequire("denZA");
var $ade5176683ba5baf$var$__assign = undefined && undefined.__assign || function() {
    $ade5176683ba5baf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ade5176683ba5baf$var$__assign.apply(this, arguments);
};
var $ade5176683ba5baf$export$adc4acb67269225 = $denZA.forwardRef(function ZoomOut(props, svgRef) {
    return $denZA.createElement("svg", $ade5176683ba5baf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        d: "M7.5 9.334a.666.666 0 100 1.332h5a.666.666 0 100-1.332h-5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.112 10.056a9.056 9.056 0 10-3.399 7.072l5.58 5.58.094.083a1 1 0 001.32-1.498l-5.579-5.58a9.018 9.018 0 001.984-5.657zM3 10.056a7.056 7.056 0 1114.112 0 7.056 7.056 0 01-14.112 0z",
        fillRule: "evenodd"
    }));
});



var $denZA = parcelRequire("denZA");
var $82124aab837f213c$var$__assign = undefined && undefined.__assign || function() {
    $82124aab837f213c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82124aab837f213c$var$__assign.apply(this, arguments);
};
var $82124aab837f213c$export$d875a145579e27ff = $denZA.forwardRef(function ZoomOutBold(props, svgRef) {
    return $denZA.createElement("svg", $82124aab837f213c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.833 10c0-.368.299-.666.667-.666h5a.666.666 0 110 1.332h-5A.666.666 0 016.833 10z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.583 10c0-.506.41-.916.917-.916h5a.916.916 0 110 1.832h-5A.916.916 0 016.583 10zm.917-.416a.416.416 0 100 .832h5a.417.417 0 000-.832h-5z",
        fillRule: "evenodd"
    }));
});






var $cvFNP = parcelRequire("cvFNP");
var $afd981dfa3fc797b$exports = {};
var $9610b07f9eadd944$exports = {};
function $9610b07f9eadd944$var$_setPrototypeOf(t, e) {
    return $9610b07f9eadd944$exports = $9610b07f9eadd944$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9610b07f9eadd944$exports.__esModule = true, $9610b07f9eadd944$exports["default"] = $9610b07f9eadd944$exports, $9610b07f9eadd944$var$_setPrototypeOf(t, e);
}
$9610b07f9eadd944$exports = $9610b07f9eadd944$var$_setPrototypeOf, $9610b07f9eadd944$exports.__esModule = true, $9610b07f9eadd944$exports["default"] = $9610b07f9eadd944$exports;


function $afd981dfa3fc797b$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $9610b07f9eadd944$exports(t, o);
}
$afd981dfa3fc797b$exports = $afd981dfa3fc797b$var$_inheritsLoose, $afd981dfa3fc797b$exports.__esModule = true, $afd981dfa3fc797b$exports["default"] = $afd981dfa3fc797b$exports;



var $denZA = parcelRequire("denZA");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $d3af3714ccf18d8f$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $d3af3714ccf18d8f$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $d3af3714ccf18d8f$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $d3af3714ccf18d8f$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $d3af3714ccf18d8f$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $0ba74084da88a258$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $0ba74084da88a258$export$2e2bcd8739ae039 = $0ba74084da88a258$var$stylis_min;



// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $d3b4f848cd0ddacc$var$delimiter = '/*|*/';
var $d3b4f848cd0ddacc$var$needle = $d3b4f848cd0ddacc$var$delimiter + '}';
function $d3b4f848cd0ddacc$var$toSheet(block) {
    if (block) $d3b4f848cd0ddacc$var$Sheet.current.insert(block + '}');
}
var $d3b4f848cd0ddacc$var$Sheet = {
    current: null
};
var $d3b4f848cd0ddacc$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $d3b4f848cd0ddacc$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $d3b4f848cd0ddacc$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $d3b4f848cd0ddacc$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $d3b4f848cd0ddacc$var$delimiter : '');
            }
        case -2:
            content.split($d3b4f848cd0ddacc$var$needle).forEach($d3b4f848cd0ddacc$var$toSheet);
    }
};
var $d3b4f848cd0ddacc$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $0ba74084da88a258$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($d3b4f848cd0ddacc$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $d3b4f848cd0ddacc$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $d3af3714ccf18d8f$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $d3b4f848cd0ddacc$export$2e2bcd8739ae039 = $d3b4f848cd0ddacc$var$createCache;


var $b5df2bf29f627646$var$isBrowser = true;
function $b5df2bf29f627646$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $b5df2bf29f627646$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b5df2bf29f627646$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $776d5e36bc4ba4fe$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $776d5e36bc4ba4fe$export$2e2bcd8739ae039 = $776d5e36bc4ba4fe$var$murmur2;


var $114574abc3bc83c3$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $114574abc3bc83c3$export$2e2bcd8739ae039 = $114574abc3bc83c3$var$unitlessKeys;


function $1147a957d2773720$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $1147a957d2773720$export$2e2bcd8739ae039 = $1147a957d2773720$var$memoize;


var $98dd1eb922782220$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $98dd1eb922782220$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $98dd1eb922782220$var$hyphenateRegex = /[A-Z]|^ms/g;
var $98dd1eb922782220$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $98dd1eb922782220$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $98dd1eb922782220$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $98dd1eb922782220$var$processStyleName = (0, $1147a957d2773720$export$2e2bcd8739ae039)(function(styleName) {
    return $98dd1eb922782220$var$isCustomProperty(styleName) ? styleName : styleName.replace($98dd1eb922782220$var$hyphenateRegex, '-$&').toLowerCase();
});
var $98dd1eb922782220$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($98dd1eb922782220$var$animationRegex, function(match, p1, p2) {
                $98dd1eb922782220$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $98dd1eb922782220$var$cursor
                };
                return p1;
            });
    }
    if ((0, $114574abc3bc83c3$export$2e2bcd8739ae039)[key] !== 1 && !$98dd1eb922782220$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $98dd1eb922782220$var$contentValuePattern, $98dd1eb922782220$var$contentValues, $98dd1eb922782220$var$oldProcessStyleValue, $98dd1eb922782220$var$msPattern, $98dd1eb922782220$var$hyphenPattern, $98dd1eb922782220$var$hyphenatedCache;
var $98dd1eb922782220$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $98dd1eb922782220$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $98dd1eb922782220$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $98dd1eb922782220$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $98dd1eb922782220$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $98dd1eb922782220$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $98dd1eb922782220$var$cursor;
                var result = interpolation(mergedProps);
                $98dd1eb922782220$var$cursor = previousCursor;
                return $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $98dd1eb922782220$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($98dd1eb922782220$var$isProcessableValue(value)) string += $98dd1eb922782220$var$processStyleName(_key) + ":" + $98dd1eb922782220$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($98dd1eb922782220$var$isProcessableValue(value[_i])) string += $98dd1eb922782220$var$processStyleName(_key) + ":" + $98dd1eb922782220$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $98dd1eb922782220$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $98dd1eb922782220$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $98dd1eb922782220$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $98dd1eb922782220$var$cursor;
var $98dd1eb922782220$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $98dd1eb922782220$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $98dd1eb922782220$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $98dd1eb922782220$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $98dd1eb922782220$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $776d5e36bc4ba4fe$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $98dd1eb922782220$var$cursor
    };
};




function $02d9e7d4bf2d70ef$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $98dd1eb922782220$export$6321afa313b251b5)(args);
}
var $02d9e7d4bf2d70ef$export$2e2bcd8739ae039 = $02d9e7d4bf2d70ef$var$css;


var $e30926212b3658f1$var$EmotionCacheContext = (0, $denZA.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $d3b4f848cd0ddacc$export$2e2bcd8739ae039)() : null);
var $e30926212b3658f1$export$2c657da244d00bd6 = (0, $denZA.createContext)({});
var $e30926212b3658f1$export$8b61c863970f2dd2 = $e30926212b3658f1$var$EmotionCacheContext.Provider;
var $e30926212b3658f1$export$f78961b537b140b1 = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return (0, $denZA.createElement)($e30926212b3658f1$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return (0, $denZA.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $e30926212b3658f1$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e30926212b3658f1$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e30926212b3658f1$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e30926212b3658f1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e30926212b3658f1$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$e30926212b3658f1$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $b5df2bf29f627646$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $98dd1eb922782220$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $b5df2bf29f627646$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e30926212b3658f1$var$hasOwnProperty.call(props, key) && key !== 'css' && key !== $e30926212b3658f1$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = (0, $denZA.createElement)(type, newProps);
    return ele;
};
var $e30926212b3658f1$var$Emotion = /* #__PURE__ */ $e30926212b3658f1$export$f78961b537b140b1(function(props, cache, ref) {
    // use Context.read for the theme when it's stable
    if (typeof props.css === 'function') return (0, $denZA.createElement)($e30926212b3658f1$export$2c657da244d00bd6.Consumer, null, function(theme) {
        return $e30926212b3658f1$var$render(cache, props, theme, ref);
    });
    return $e30926212b3658f1$var$render(cache, props, null, ref);
});
var $e30926212b3658f1$export$34b9dba7ce09269b = function jsx(type, props) {
    var args = arguments;
    if (props == null || !$e30926212b3658f1$var$hasOwnProperty.call(props, 'css')) // $FlowFixMe
    return (0, $denZA.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = $e30926212b3658f1$var$Emotion;
    var newProps = {};
    for(var key in props)if ($e30926212b3658f1$var$hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[$e30926212b3658f1$var$typePropName] = type;
    var error, match;
    createElementArgArray[1] = newProps;
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $denZA.createElement).apply(null, createElementArgArray);
};
var $e30926212b3658f1$var$warnedAboutCssPropForGlobal = false;
var $e30926212b3658f1$export$98f03c5d19621d70 = /* #__PURE__ */ $e30926212b3658f1$export$f78961b537b140b1(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return (0, $denZA.createElement)($e30926212b3658f1$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var serialized = (0, $98dd1eb922782220$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return (0, $denZA.createElement)($e30926212b3658f1$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $98dd1eb922782220$export$6321afa313b251b5)([
        styles
    ]);
    return (0, $denZA.createElement)($e30926212b3658f1$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e30926212b3658f1$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($afd981dfa3fc797b$exports)))(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $d3af3714ccf18d8f$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $b5df2bf29f627646$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $denZA.Component));
var $e30926212b3658f1$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $e30926212b3658f1$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e30926212b3658f1$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $b5df2bf29f627646$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e30926212b3658f1$export$9b9c0f9d9f3552b8 = $e30926212b3658f1$export$f78961b537b140b1(function(props, context) {
    return (0, $denZA.createElement)($e30926212b3658f1$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $98dd1eb922782220$export$6321afa313b251b5)(args, context.registered);
            (0, $b5df2bf29f627646$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $e30926212b3658f1$var$merge(context.registered, css, $e30926212b3658f1$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        return ele;
    });
});




var $denZA = parcelRequire("denZA");
var $a9513ca373e01b66$var$KlikContext = $denZA.createContext(undefined);
var $a9513ca373e01b66$export$21c472c8a0d1544e = function(_a) {
    var children = _a.children, _b = _a.frameworkPrefix, frameworkPrefix = _b === void 0 ? 'klik' : _b, _c = _a.theme, theme = _c === void 0 ? 'light-blue' : _c;
    return $denZA.createElement($a9513ca373e01b66$var$KlikContext.Provider, {
        value: {
            frameworkPrefix: frameworkPrefix,
            theme: theme
        }
    }, children);
};
var $a9513ca373e01b66$export$5f34505ed222b7a4 = $a9513ca373e01b66$var$KlikContext.Consumer;
var $a9513ca373e01b66$export$d3be3afeac0548cc = function() {
    var ctx = $denZA.useContext($a9513ca373e01b66$var$KlikContext);
    if (!ctx) throw new Error('"useklikContext" can only be called inside of AppContext.Provider!');
    return ctx;
};



var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
function $8408d2f0a282387b$var$toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $8408d2f0a282387b$var$toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function $8408d2f0a282387b$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $8408d2f0a282387b$var$toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}



var $denZA = parcelRequire("denZA");

var $efef0f8ceb54059d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $efef0f8ceb54059d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $efef0f8ceb54059d$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($efef0f8ceb54059d$var$__read(arguments[i]));
    return ar;
};
var $efef0f8ceb54059d$export$bf3ce3de7ed5b595 = function(prefix) {
    return function() {
        var classes = [];
        for(var _i = 0; _i < arguments.length; _i++)classes[_i] = arguments[_i];
        return (0, $8408d2f0a282387b$export$2e2bcd8739ae039)(classes).split(' ').map(function(cname) {
            var newStr = cname.replace(prefix + "-", '');
            return prefix + "-" + newStr;
        }).join(' ');
    };
};
var $efef0f8ceb54059d$export$b2c43d7d050b2e63 = function(children) {
    return $denZA.Children.toArray(children).filter(function(child) {
        return $denZA.isValidElement(child);
    });
};
var $efef0f8ceb54059d$export$c81b8d8584b2fbae = !!(typeof window !== 'undefined' && window.document.createElement);
var $efef0f8ceb54059d$export$92bd60949cc504a0 = function(arr, obj) {
    return arr.some(function(item) {
        return item.label === obj.label && item.value === obj.value;
    });
};
var $efef0f8ceb54059d$export$e3ab1274632d862 = function() {
    var frameworkPrefix = (0, $a9513ca373e01b66$export$d3be3afeac0548cc)().frameworkPrefix;
    return $efef0f8ceb54059d$export$bf3ce3de7ed5b595(frameworkPrefix);
};
var $efef0f8ceb54059d$export$e08e3b67e392101e = function() {
    var callbacks = [];
    for(var _i = 0; _i < arguments.length; _i++)callbacks[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            for(var callbacks_1 = $efef0f8ceb54059d$var$__values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()){
                var callback = callbacks_1_1.value;
                if (typeof callback === 'function') // eslint-disable-next-line node/callback-return
                callback.apply(void 0, $efef0f8ceb54059d$var$__spread(args));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
};



var $denZA = parcelRequire("denZA");

var $711fdfa14bd663e0$export$a2fc124486ff7b59 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('toast-body')
    }, children);
};
$711fdfa14bd663e0$export$a2fc124486ff7b59.displayName = 'Toast.Body';



var $denZA = parcelRequire("denZA");

var $e8ce532d8e2f8576$export$3c4e2c6b58120fe3 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("p", {
        className: cn('toast-heading')
    }, children);
};
$e8ce532d8e2f8576$export$3c4e2c6b58120fe3.displayName = 'Toast.Heading';


var $e2a5d556d9ae4bcd$export$8d8dc7d5f743331b = function(_a) {
    var _b;
    var children = _a.children, _c = _a.status, status = _c === void 0 ? 'default' : _c;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var classNames = cn('toast', (_b = {
        'toast-status': status !== 'default'
    }, _b["status-" + status] = status !== 'default', _b));
    return $denZA.createElement("article", {
        "aria-labelledby": status + "-alert",
        className: classNames,
        role: "alert"
    }, children);
};
$e2a5d556d9ae4bcd$export$8d8dc7d5f743331b.Body = (0, $711fdfa14bd663e0$export$a2fc124486ff7b59);
$e2a5d556d9ae4bcd$export$8d8dc7d5f743331b.Heading = (0, $e8ce532d8e2f8576$export$3c4e2c6b58120fe3);



var $denZA = parcelRequire("denZA");

var $8483a51dc91884cb$export$f2815235e76a62b9 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('toasts')
    }, children);
};


var $49d1557d9beb4649$export$2c66e96878bf4792 = [];



var $denZA = parcelRequire("denZA");
var $c611c5d883831cb2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c611c5d883831cb2$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c611c5d883831cb2$var$__read(arguments[i]));
    return ar;
};
var $c611c5d883831cb2$var$ClickResult;
(function(ClickResult) {
    ClickResult[ClickResult["OutsideElement"] = 0] = "OutsideElement";
    ClickResult[ClickResult["InsideElement"] = 1] = "InsideElement";
})($c611c5d883831cb2$var$ClickResult || ($c611c5d883831cb2$var$ClickResult = {}));
var $c611c5d883831cb2$export$1896bab46732d207 = function(focusedElement, clickOutsideCallback, deps) {
    // This function runs on every click-event, for every single menu.
    // be aware the cancelling the event propagation can impact monitoring tools
    var detectClickOutside = function(event) {
        if (Array.isArray(focusedElement)) {
            var res = focusedElement.map(function(elm) {
                if (elm.current) {
                    if (elm.current.contains(event.target)) return $c611c5d883831cb2$var$ClickResult.InsideElement;
                }
                return $c611c5d883831cb2$var$ClickResult.OutsideElement;
            });
            if (!res.includes($c611c5d883831cb2$var$ClickResult.InsideElement)) clickOutsideCallback(event);
            return;
        }
        if (focusedElement.current) {
            if (!focusedElement.current.contains(event.target)) clickOutsideCallback(event);
        }
    };
    // Initialize the position of the dropdown.
    // TODO: document event listeners should be removed in the future.
    $denZA.useLayoutEffect(function() {
        document.addEventListener('mousedown', detectClickOutside);
        document.addEventListener('touchstart', detectClickOutside);
        return function() {
            document.removeEventListener('mousedown', detectClickOutside);
            document.removeEventListener('touchstart', detectClickOutside);
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    }, $c611c5d883831cb2$var$__spread([
        focusedElement
    ], deps ? deps : []));
};



var $denZA = parcelRequire("denZA");
var $da439be2d92c6b01$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $da439be2d92c6b01$export$437db1325ef18dbd = function() {
    var _a = $da439be2d92c6b01$var$__read($denZA.useState(false), 2), isMobile = _a[0], setMobile = _a[1];
    $denZA.useEffect(function() {
        var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        if (!userAgent) // eslint-disable-next-line no-console
        console.error('could not detect userAgent, are you using ssr');
        setMobile(/Mobi|Android/u.test(navigator.userAgent));
    }, []);
    return {
        isMobile: isMobile
    };
};



var $denZA = parcelRequire("denZA");
// TODO: Clean up these types. They should be moved out of consts and instead decorate components
// that have statusses, sizes etc. That way they are unified across all components, don't have variations.
var $0d449d3c25ab4d6d$export$c647cb0ee6e282fe = [
    'small',
    'medium',
    'large',
    'default'
];
var $0d449d3c25ab4d6d$export$68604822a8cdca29 = {
    xsmall: 'm2',
    small: 'm1',
    normal: '0',
    medium: '05',
    large: '1',
    xlarge: '2',
    x2large: '3',
    x3large: '4',
    x4large: '5',
    x5large: '6',
    x6large: '7'
};
var $0d449d3c25ab4d6d$export$e791e5b0f9f766b8 = {
    medium: 59,
    large: 1024,
    extraLarge: 1440,
    fullWidth: 1632
};


var $20817d17cc29bb87$export$26ca5b065308b0d1 = function(fontSize) {
    var size = $denZA.useMemo(function() {
        if (!fontSize) return '';
        return "text-size-" + (0, $0d449d3c25ab4d6d$export$68604822a8cdca29)[fontSize];
    }, [
        fontSize
    ]);
    return size;
};


/* eslint-disable */ 
var $denZA = parcelRequire("denZA");
var $f3834b459a71251c$var$isHTMLElement = (value)=>value instanceof HTMLElement;
const $f3834b459a71251c$var$EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input'
};
const $f3834b459a71251c$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $f3834b459a71251c$var$VALUE = 'value';
const $f3834b459a71251c$var$SELECT = 'select';
const $f3834b459a71251c$var$UNDEFINED = 'undefined';
const $f3834b459a71251c$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
function $f3834b459a71251c$var$attachEventListeners({ ref: ref }, shouldAttachChangeEvent, handleChange) {
    if ($f3834b459a71251c$var$isHTMLElement(ref) && handleChange) {
        ref.addEventListener(shouldAttachChangeEvent ? $f3834b459a71251c$var$EVENTS.CHANGE : $f3834b459a71251c$var$EVENTS.INPUT, handleChange);
        ref.addEventListener($f3834b459a71251c$var$EVENTS.BLUR, handleChange);
    }
}
var $f3834b459a71251c$var$isNullOrUndefined = (value)=>value == null;
const $f3834b459a71251c$var$isObjectType = (value)=>typeof value === 'object';
var $f3834b459a71251c$var$isObject = (value)=>!$f3834b459a71251c$var$isNullOrUndefined(value) && !Array.isArray(value) && $f3834b459a71251c$var$isObjectType(value) && !(value instanceof Date);
var $f3834b459a71251c$var$isKey = (value)=>!Array.isArray(value) && (/^\w*$/.test(value) || !/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/.test(value));
var $f3834b459a71251c$var$compact = (value)=>value.filter(Boolean);
var $f3834b459a71251c$var$stringToPath = (input)=>$f3834b459a71251c$var$compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
function $f3834b459a71251c$var$set(object, path, value) {
    let index = -1;
    const tempPath = $f3834b459a71251c$var$isKey(path) ? [
        path
    ] : $f3834b459a71251c$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $f3834b459a71251c$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
var $f3834b459a71251c$export$19bfedbbacd9b12a = (data, value = {})=>{
    for(const key in data)!$f3834b459a71251c$var$isKey(key) ? $f3834b459a71251c$var$set(value, key, data[key]) : value[key] = data[key];
    return value;
};
var $f3834b459a71251c$var$isUndefined = (val)=>val === undefined;
var $f3834b459a71251c$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    const result = $f3834b459a71251c$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$f3834b459a71251c$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $f3834b459a71251c$var$isUndefined(result) || result === obj ? $f3834b459a71251c$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $f3834b459a71251c$var$focusOnErrorField = (fields, fieldErrors)=>{
    for(const key in fields)if ($f3834b459a71251c$export$3988ae62b71be9a3(fieldErrors, key)) {
        const field = fields[key];
        if (field) {
            if (field.ref.focus) {
                if ($f3834b459a71251c$var$isUndefined(field.ref.focus())) break;
            } else if (field.options) {
                field.options[0].ref.focus();
                break;
            }
        }
    }
};
var $f3834b459a71251c$var$removeAllEventListeners = (ref, validateWithStateUpdate)=>{
    if ($f3834b459a71251c$var$isHTMLElement(ref) && ref.removeEventListener) {
        ref.removeEventListener($f3834b459a71251c$var$EVENTS.INPUT, validateWithStateUpdate);
        ref.removeEventListener($f3834b459a71251c$var$EVENTS.CHANGE, validateWithStateUpdate);
        ref.removeEventListener($f3834b459a71251c$var$EVENTS.BLUR, validateWithStateUpdate);
    }
};
const $f3834b459a71251c$var$defaultReturn = {
    isValid: false,
    value: ''
};
var $f3834b459a71251c$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.ref.checked ? {
            isValid: true,
            value: option.ref.value
        } : previous, $f3834b459a71251c$var$defaultReturn) : $f3834b459a71251c$var$defaultReturn;
var $f3834b459a71251c$var$getMultipleSelectValue = (options)=>[
        ...options
    ].filter(({ selected: selected })=>selected).map(({ value: value })=>value);
var $f3834b459a71251c$var$isRadioInput = (element)=>element.type === 'radio';
var $f3834b459a71251c$var$isFileInput = (element)=>element.type === 'file';
var $f3834b459a71251c$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $f3834b459a71251c$var$isMultipleSelect = (element)=>element.type === `${$f3834b459a71251c$var$SELECT}-multiple`;
const $f3834b459a71251c$var$defaultResult = {
    value: false,
    isValid: false
};
const $f3834b459a71251c$var$validResult = {
    value: true,
    isValid: true
};
var $f3834b459a71251c$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.ref.checked).map(({ ref: { value: value } })=>value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        const { checked: checked, value: value, attributes: attributes } = options[0].ref;
        return checked ? attributes && !$f3834b459a71251c$var$isUndefined(attributes.value) ? $f3834b459a71251c$var$isUndefined(value) || value === '' ? $f3834b459a71251c$var$validResult : {
            value: value,
            isValid: true
        } : $f3834b459a71251c$var$validResult : $f3834b459a71251c$var$defaultResult;
    }
    return $f3834b459a71251c$var$defaultResult;
};
function $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled) {
    const field = fieldsRef.current[name];
    if (field) {
        const { ref: { value: value, disabled: disabled }, ref: ref } = field;
        if (disabled && excludeDisabled) return;
        if ($f3834b459a71251c$var$isFileInput(ref)) return ref.files;
        if ($f3834b459a71251c$var$isRadioInput(ref)) return $f3834b459a71251c$var$getRadioValue(field.options).value;
        if ($f3834b459a71251c$var$isMultipleSelect(ref)) return $f3834b459a71251c$var$getMultipleSelectValue(ref.options);
        if ($f3834b459a71251c$var$isCheckBoxInput(ref)) return $f3834b459a71251c$var$getCheckboxValue(field.options).value;
        return value;
    }
    if (shallowFieldsStateRef) return $f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name);
}
function $f3834b459a71251c$var$isDetached(element) {
    if (!element) return true;
    if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) return false;
    return $f3834b459a71251c$var$isDetached(element.parentNode);
}
var $f3834b459a71251c$var$isEmptyObject = (value)=>$f3834b459a71251c$var$isObject(value) && !Object.keys(value).length;
var $f3834b459a71251c$var$isBoolean = (value)=>typeof value === 'boolean';
function $f3834b459a71251c$var$baseGet(object, updatePath) {
    const path = updatePath.slice(0, -1);
    const length = path.length;
    let index = 0;
    while(index < length)object = $f3834b459a71251c$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $f3834b459a71251c$var$unset(object, path) {
    const updatePath = $f3834b459a71251c$var$isKey(path) ? [
        path
    ] : $f3834b459a71251c$var$stringToPath(path);
    const childObject = updatePath.length == 1 ? object : $f3834b459a71251c$var$baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef = undefined;
    if (childObject) delete childObject[key];
    for(let k = 0; k < updatePath.slice(0, -1).length; k++){
        let index = -1;
        let objectRef = undefined;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) previousObjRef = object;
        while(++index < currentPaths.length){
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && ($f3834b459a71251c$var$isObject(objectRef) && $f3834b459a71251c$var$isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter((data)=>$f3834b459a71251c$var$isObject(data) && !$f3834b459a71251c$var$isEmptyObject(data) || $f3834b459a71251c$var$isBoolean(data)).length)) previousObjRef ? delete previousObjRef[item] : delete object[item];
            previousObjRef = objectRef;
        }
    }
    return object;
}
const $f3834b459a71251c$var$isSameRef = (fieldValue, ref)=>fieldValue && fieldValue.ref === ref;
function $f3834b459a71251c$var$findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    const { ref: ref, ref: { name: name, type: type } } = field;
    const fieldRef = fieldsRef.current[name];
    if (!shouldUnregister) {
        const value = $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        if (!$f3834b459a71251c$var$isUndefined(value)) $f3834b459a71251c$var$set(shallowFieldsStateRef.current, name, value);
    }
    if (!type) {
        delete fieldsRef.current[name];
        return;
    }
    if (($f3834b459a71251c$var$isRadioInput(ref) || $f3834b459a71251c$var$isCheckBoxInput(ref)) && fieldRef) {
        const { options: options } = fieldRef;
        if (Array.isArray(options) && options.length) {
            $f3834b459a71251c$var$compact(options).forEach((option, index)=>{
                const { ref: ref } = option;
                if (ref && $f3834b459a71251c$var$isDetached(ref) && $f3834b459a71251c$var$isSameRef(option, ref) || forceDelete) {
                    $f3834b459a71251c$var$removeAllEventListeners(ref, handleChange);
                    $f3834b459a71251c$var$unset(options, `[${index}]`);
                }
            });
            if (options && !$f3834b459a71251c$var$compact(options).length) delete fieldsRef.current[name];
        } else delete fieldsRef.current[name];
    } else if ($f3834b459a71251c$var$isDetached(ref) && $f3834b459a71251c$var$isSameRef(fieldRef, ref) || forceDelete) {
        $f3834b459a71251c$var$removeAllEventListeners(ref, handleChange);
        delete fieldsRef.current[name];
    }
}
function $f3834b459a71251c$var$setFieldArrayDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while(++index < values.length){
        for(const key in values[index])if (Array.isArray(values[index][key])) {
            !dirtyFields[index] && (dirtyFields[index] = {});
            dirtyFields[index][key] = [];
            $f3834b459a71251c$var$setFieldArrayDirtyFields(values[index][key], $f3834b459a71251c$export$3988ae62b71be9a3(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
        } else $f3834b459a71251c$export$3988ae62b71be9a3(defaultValues[index] || {}, key) === values[index][key] ? $f3834b459a71251c$var$set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), {
            [key]: true
        });
        !dirtyFields.length && parentNode && delete parentNode[parentName];
    }
    return dirtyFields.length ? dirtyFields : undefined;
}
var $f3834b459a71251c$var$isString = (value)=>typeof value === 'string';
var $f3834b459a71251c$var$isPrimitive = (value)=>$f3834b459a71251c$var$isNullOrUndefined(value) || !$f3834b459a71251c$var$isObjectType(value);
function $f3834b459a71251c$var$deepMerge(target, source) {
    if ($f3834b459a71251c$var$isPrimitive(target) || $f3834b459a71251c$var$isPrimitive(source)) return source;
    for(const key in source){
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] = $f3834b459a71251c$var$isObject(targetValue) && $f3834b459a71251c$var$isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? $f3834b459a71251c$var$deepMerge(targetValue, sourceValue) : sourceValue;
        } catch (_a) {}
    }
    return target;
}
var $f3834b459a71251c$var$getFieldsValues = (fieldsRef, shallowFieldsStateRef, excludeDisabled, search)=>{
    const output = {};
    for(const name in fieldsRef.current)if ($f3834b459a71251c$var$isUndefined(search) || ($f3834b459a71251c$var$isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find((data)=>name.startsWith(data)))) output[name] = $f3834b459a71251c$var$getFieldValue(fieldsRef, name, undefined, excludeDisabled);
    return $f3834b459a71251c$var$deepMerge($f3834b459a71251c$export$19bfedbbacd9b12a(Object.assign({}, (shallowFieldsStateRef || {}).current || {})), $f3834b459a71251c$export$19bfedbbacd9b12a(output));
};
function $f3834b459a71251c$var$deepEqual(object1, object2, isErrorObject) {
    if ($f3834b459a71251c$var$isPrimitive(object1) || $f3834b459a71251c$var$isPrimitive(object2)) return object1 === object2;
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1)if (!(isErrorObject && [
        'ref',
        'context'
    ].includes(key))) {
        const val1 = object1[key];
        const val2 = object2[key];
        if (($f3834b459a71251c$var$isObject(val1) || Array.isArray(val1)) && ($f3834b459a71251c$var$isObject(val2) || Array.isArray(val2)) ? !$f3834b459a71251c$var$deepEqual(val1, val2, isErrorObject) : val1 !== val2) return false;
    }
    return true;
}
function $f3834b459a71251c$var$isErrorStateChanged({ errors: errors, name: name, error: error, validFields: validFields, fieldsWithValidation: fieldsWithValidation }) {
    const isValid = $f3834b459a71251c$var$isUndefined(error);
    const previousError = $f3834b459a71251c$export$3988ae62b71be9a3(errors, name);
    return isValid && !!previousError || !isValid && !$f3834b459a71251c$var$deepEqual(previousError, error, true) || isValid && $f3834b459a71251c$export$3988ae62b71be9a3(fieldsWithValidation, name) && !$f3834b459a71251c$export$3988ae62b71be9a3(validFields, name);
}
var $f3834b459a71251c$var$isRegex = (value)=>value instanceof RegExp;
const $f3834b459a71251c$var$isValueMessage = (value)=>$f3834b459a71251c$var$isObject(value) && !$f3834b459a71251c$var$isRegex(value);
var $f3834b459a71251c$var$getValueAndMessage = (validationData)=>$f3834b459a71251c$var$isValueMessage(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $f3834b459a71251c$var$isFunction = (value)=>typeof value === 'function';
var $f3834b459a71251c$var$isMessage = (value)=>$f3834b459a71251c$var$isString(value) || $f3834b459a71251c$var$isObject(value) && (0, $denZA.isValidElement)(value);
function $f3834b459a71251c$var$getValidateError(result, ref, type = 'validate') {
    if ($f3834b459a71251c$var$isMessage(result) || $f3834b459a71251c$var$isBoolean(result) && !result) return {
        type: type,
        message: $f3834b459a71251c$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $f3834b459a71251c$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>{
    if (validateAllFieldCriteria) {
        const error = errors[name];
        return Object.assign(Object.assign({}, error), {
            types: Object.assign(Object.assign({}, error && error.types ? error.types : {}), {
                [type]: message || true
            })
        });
    }
    return {};
};
var $f3834b459a71251c$var$validateField = async (fieldsRef, validateAllFieldCriteria, { ref: ref, ref: { type: type, value: value }, options: options, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate }, shallowFieldsStateRef)=>{
    const fields = fieldsRef.current;
    const name = ref.name;
    const error = {};
    const isRadio = $f3834b459a71251c$var$isRadioInput(ref);
    const isCheckBox = $f3834b459a71251c$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = value === '';
    const appendErrorsCurry = $f3834b459a71251c$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $f3834b459a71251c$var$INPUT_VALIDATION_RULES.maxLength, minType = $f3834b459a71251c$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
    };
    if (required && (!isRadio && !isCheckBox && (isEmpty || $f3834b459a71251c$var$isNullOrUndefined(value)) || $f3834b459a71251c$var$isBoolean(value) && !value || isCheckBox && !$f3834b459a71251c$var$getCheckboxValue(options).isValid || isRadio && !$f3834b459a71251c$var$getRadioValue(options).isValid)) {
        const { value: requiredValue, message: requiredMessage } = $f3834b459a71251c$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $f3834b459a71251c$var$getValueAndMessage(required);
        if (requiredValue) {
            error[name] = Object.assign({
                type: $f3834b459a71251c$var$INPUT_VALIDATION_RULES.required,
                message: requiredMessage,
                ref: isRadioOrCheckbox ? ((fields[name].options || [])[0] || {}).ref : ref
            }, appendErrorsCurry($f3834b459a71251c$var$INPUT_VALIDATION_RULES.required, requiredMessage));
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (!$f3834b459a71251c$var$isNullOrUndefined(min) || !$f3834b459a71251c$var$isNullOrUndefined(max)) {
        let exceedMax;
        let exceedMin;
        const { value: maxValue, message: maxMessage } = $f3834b459a71251c$var$getValueAndMessage(max);
        const { value: minValue, message: minMessage } = $f3834b459a71251c$var$getValueAndMessage(min);
        if (type === 'number' || !type && !isNaN(value)) {
            const valueNumber = ref.valueAsNumber || parseFloat(value);
            if (!$f3834b459a71251c$var$isNullOrUndefined(maxValue)) exceedMax = valueNumber > maxValue;
            if (!$f3834b459a71251c$var$isNullOrUndefined(minValue)) exceedMin = valueNumber < minValue;
        } else {
            const valueDate = ref.valueAsDate || new Date(value);
            if ($f3834b459a71251c$var$isString(maxValue)) exceedMax = valueDate > new Date(maxValue);
            if ($f3834b459a71251c$var$isString(minValue)) exceedMin = valueDate < new Date(minValue);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxMessage, minMessage, $f3834b459a71251c$var$INPUT_VALIDATION_RULES.max, $f3834b459a71251c$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) return error;
        }
    }
    if ($f3834b459a71251c$var$isString(value) && !isEmpty && (maxLength || minLength)) {
        const { value: maxLengthValue, message: maxLengthMessage } = $f3834b459a71251c$var$getValueAndMessage(maxLength);
        const { value: minLengthValue, message: minLengthMessage } = $f3834b459a71251c$var$getValueAndMessage(minLength);
        const inputLength = value.toString().length;
        const exceedMax = !$f3834b459a71251c$var$isNullOrUndefined(maxLengthValue) && inputLength > maxLengthValue;
        const exceedMin = !$f3834b459a71251c$var$isNullOrUndefined(minLengthValue) && inputLength < minLengthValue;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxLengthMessage, minLengthMessage);
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (pattern && !isEmpty) {
        const { value: patternValue, message: patternMessage } = $f3834b459a71251c$var$getValueAndMessage(pattern);
        if ($f3834b459a71251c$var$isRegex(patternValue) && !patternValue.test(value)) {
            error[name] = Object.assign({
                type: $f3834b459a71251c$var$INPUT_VALIDATION_RULES.pattern,
                message: patternMessage,
                ref: ref
            }, appendErrorsCurry($f3834b459a71251c$var$INPUT_VALIDATION_RULES.pattern, patternMessage));
            if (!validateAllFieldCriteria) return error;
        }
    }
    if (validate) {
        const fieldValue = $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
        if ($f3834b459a71251c$var$isFunction(validate)) {
            const result = await validate(fieldValue);
            const validateError = $f3834b459a71251c$var$getValidateError(result, validateRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry($f3834b459a71251c$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) return error;
            }
        } else if ($f3834b459a71251c$var$isObject(validate)) {
            let validationResult = {};
            for (const [key, validateFunction] of Object.entries(validate)){
                if (!$f3834b459a71251c$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateResult = await validateFunction(fieldValue);
                const validateError = $f3834b459a71251c$var$getValidateError(validateResult, validateRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$f3834b459a71251c$var$isEmptyObject(validationResult)) {
                error[name] = Object.assign({
                    ref: validateRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    return error;
};
const $f3834b459a71251c$var$getPath = (path, values)=>{
    const getInnerPath = (key, value, isObject)=>{
        const pathWithIndex = isObject ? `${path}.${key}` : `${path}[${key}]`;
        return $f3834b459a71251c$var$isPrimitive(value) ? pathWithIndex : $f3834b459a71251c$var$getPath(pathWithIndex, value);
    };
    return Object.entries(values).map(([key, value])=>getInnerPath(key, value, $f3834b459a71251c$var$isObject(values))).flat(Infinity);
};
var $f3834b459a71251c$var$assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField)=>{
    let value;
    watchFields.add(fieldName);
    if ($f3834b459a71251c$var$isEmptyObject(fieldValues)) value = undefined;
    else {
        value = $f3834b459a71251c$export$3988ae62b71be9a3(fieldValues, fieldName);
        if ($f3834b459a71251c$var$isObject(value) || Array.isArray(value)) $f3834b459a71251c$var$getPath(fieldName, value).forEach((name)=>watchFields.add(name));
    }
    return $f3834b459a71251c$var$isUndefined(value) ? isSingleField ? inputValue : $f3834b459a71251c$export$3988ae62b71be9a3(inputValue, fieldName) : value;
};
var $f3834b459a71251c$var$skipValidation = ({ isOnBlur: isOnBlur, isOnChange: isOnChange, isOnTouch: isOnTouch, isTouched: isTouched, isReValidateOnBlur: isReValidateOnBlur, isReValidateOnChange: isReValidateOnChange, isBlurEvent: isBlurEvent, isSubmitted: isSubmitted, isOnAll: isOnAll })=>{
    if (isOnAll) return false;
    else if (!isSubmitted && isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? isReValidateOnBlur : isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? isReValidateOnChange : isOnChange) return isBlurEvent;
    return true;
};
var $f3834b459a71251c$var$getFieldArrayParentName = (name)=>name.substring(0, name.indexOf('['));
const $f3834b459a71251c$var$isMatchFieldArrayName = (name, searchName)=>RegExp(`^${searchName}[\\d+]`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
var $f3834b459a71251c$var$isNameInFieldArray = (names, name)=>[
        ...names
    ].some((current)=>$f3834b459a71251c$var$isMatchFieldArrayName(name, current));
var $f3834b459a71251c$var$isSelectInput = (element)=>element.type === `${$f3834b459a71251c$var$SELECT}-one`;
function $f3834b459a71251c$var$onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    const observer = new MutationObserver(()=>{
        for (const field of Object.values(fieldsRef.current)){
            if (field && field.options) {
                for (const option of field.options)if (option && option.ref && $f3834b459a71251c$var$isDetached(option.ref)) removeFieldEventListenerAndRef(field);
            } else if (field && $f3834b459a71251c$var$isDetached(field.ref)) removeFieldEventListenerAndRef(field);
        }
    });
    observer.observe(window.document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $f3834b459a71251c$var$cloneObject(data, isWeb) {
    let copy;
    if ($f3834b459a71251c$var$isPrimitive(data) || isWeb && data instanceof File) return data;
    if (data instanceof Date) {
        copy = new Date(data.getTime());
        return copy;
    }
    if (data instanceof Set) {
        copy = new Set();
        for (const item of data)copy.add(item);
        return copy;
    }
    if (data instanceof Map) {
        copy = new Map();
        for (const key of data.keys())copy.set(key, $f3834b459a71251c$var$cloneObject(data.get(key), isWeb));
        return copy;
    }
    copy = Array.isArray(data) ? [] : {};
    for(const key in data)copy[key] = $f3834b459a71251c$var$cloneObject(data[key], isWeb);
    return copy;
}
var $f3834b459a71251c$var$modeChecker = (mode)=>({
        isOnSubmit: !mode || mode === $f3834b459a71251c$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $f3834b459a71251c$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $f3834b459a71251c$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $f3834b459a71251c$var$VALIDATION_MODE.all,
        isOnTouch: mode === $f3834b459a71251c$var$VALIDATION_MODE.onTouched
    });
var $f3834b459a71251c$var$isRadioOrCheckboxFunction = (ref)=>$f3834b459a71251c$var$isRadioInput(ref) || $f3834b459a71251c$var$isCheckBoxInput(ref);
const $f3834b459a71251c$var$isWindowUndefined = typeof window === $f3834b459a71251c$var$UNDEFINED;
const $f3834b459a71251c$var$isWeb = typeof document !== $f3834b459a71251c$var$UNDEFINED && !$f3834b459a71251c$var$isWindowUndefined && !$f3834b459a71251c$var$isUndefined(window.HTMLElement);
const $f3834b459a71251c$var$isProxyEnabled = $f3834b459a71251c$var$isWeb ? 'Proxy' in window : typeof Proxy !== $f3834b459a71251c$var$UNDEFINED;
function $f3834b459a71251c$export$87c0cf8eb5a167e0({ mode: mode = $f3834b459a71251c$var$VALIDATION_MODE.onSubmit, reValidateMode: reValidateMode = $f3834b459a71251c$var$VALIDATION_MODE.onChange, resolver: resolver, context: context, defaultValues: defaultValues = {}, shouldFocusError: shouldFocusError = true, shouldUnregister: shouldUnregister = true, criteriaMode: criteriaMode } = {}) {
    const fieldsRef = (0, $denZA.useRef)({});
    const fieldArrayDefaultValuesRef = (0, $denZA.useRef)({});
    const watchFieldsRef = (0, $denZA.useRef)(new Set());
    const useWatchFieldsRef = (0, $denZA.useRef)({});
    const useWatchRenderFunctionsRef = (0, $denZA.useRef)({});
    const fieldsWithValidationRef = (0, $denZA.useRef)({});
    const validFieldsRef = (0, $denZA.useRef)({});
    const defaultValuesRef = (0, $denZA.useRef)(defaultValues);
    const defaultValuesAtRenderRef = (0, $denZA.useRef)({});
    const isUnMount = (0, $denZA.useRef)(false);
    const isWatchAllRef = (0, $denZA.useRef)(false);
    const handleChangeRef = (0, $denZA.useRef)();
    const shallowFieldsStateRef = (0, $denZA.useRef)(shouldUnregister ? {} : $f3834b459a71251c$var$cloneObject(defaultValues, $f3834b459a71251c$var$isWeb));
    const resetFieldArrayFunctionRef = (0, $denZA.useRef)({});
    const contextRef = (0, $denZA.useRef)(context);
    const resolverRef = (0, $denZA.useRef)(resolver);
    const fieldArrayNamesRef = (0, $denZA.useRef)(new Set());
    const modeRef = (0, $denZA.useRef)($f3834b459a71251c$var$modeChecker(mode));
    const { isOnSubmit: isOnSubmit, isOnTouch: isOnTouch } = modeRef.current;
    const isValidateAllFieldCriteria = criteriaMode === $f3834b459a71251c$var$VALIDATION_MODE.all;
    const [formState, setFormState] = (0, $denZA.useState)({
        isDirty: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touched: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: !isOnSubmit,
        errors: {}
    });
    const readFormStateRef = (0, $denZA.useRef)({
        isDirty: !$f3834b459a71251c$var$isProxyEnabled,
        dirtyFields: !$f3834b459a71251c$var$isProxyEnabled,
        touched: !$f3834b459a71251c$var$isProxyEnabled || isOnTouch,
        isSubmitting: !$f3834b459a71251c$var$isProxyEnabled,
        isValid: !$f3834b459a71251c$var$isProxyEnabled
    });
    const formStateRef = (0, $denZA.useRef)(formState);
    const observerRef = (0, $denZA.useRef)();
    const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange } = (0, $denZA.useRef)($f3834b459a71251c$var$modeChecker(reValidateMode)).current;
    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    const updateFormState = (0, $denZA.useCallback)((state = {})=>!isUnMount.current && setFormState(Object.assign(Object.assign({}, formStateRef.current), state)), []);
    const shouldRenderBaseOnError = (0, $denZA.useCallback)((name, error, shouldRender = false, state = {}, isValid)=>{
        let shouldReRender = shouldRender || $f3834b459a71251c$var$isErrorStateChanged({
            errors: formStateRef.current.errors,
            error: error,
            name: name,
            validFields: validFieldsRef.current,
            fieldsWithValidation: fieldsWithValidationRef.current
        });
        const previousError = $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.errors, name);
        if (error) {
            $f3834b459a71251c$var$unset(validFieldsRef.current, name);
            shouldReRender = shouldReRender || !previousError || !$f3834b459a71251c$var$deepEqual(previousError, error, true);
            $f3834b459a71251c$var$set(formStateRef.current.errors, name, error);
        } else {
            if ($f3834b459a71251c$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name) || resolverRef.current) {
                $f3834b459a71251c$var$set(validFieldsRef.current, name, true);
                shouldReRender = shouldReRender || previousError;
            }
            $f3834b459a71251c$var$unset(formStateRef.current.errors, name);
        }
        if (shouldReRender && !$f3834b459a71251c$var$isNullOrUndefined(shouldRender) || !$f3834b459a71251c$var$isEmptyObject(state)) updateFormState(Object.assign(Object.assign(Object.assign({}, state), {
            errors: formStateRef.current.errors
        }), resolverRef.current ? {
            isValid: !!isValid
        } : {}));
    }, []);
    const setFieldValue = (0, $denZA.useCallback)((name, rawValue)=>{
        const { ref: ref, options: options } = fieldsRef.current[name];
        const value = $f3834b459a71251c$var$isWeb && $f3834b459a71251c$var$isHTMLElement(ref) && $f3834b459a71251c$var$isNullOrUndefined(rawValue) ? '' : rawValue;
        if ($f3834b459a71251c$var$isRadioInput(ref) && options) options.forEach(({ ref: radioRef })=>radioRef.checked = radioRef.value === value);
        else if ($f3834b459a71251c$var$isFileInput(ref) && !$f3834b459a71251c$var$isString(value)) ref.files = value;
        else if ($f3834b459a71251c$var$isMultipleSelect(ref)) [
            ...ref.options
        ].forEach((selectRef)=>selectRef.selected = value.includes(selectRef.value));
        else if ($f3834b459a71251c$var$isCheckBoxInput(ref) && options) options.length > 1 ? options.forEach(({ ref: checkboxRef })=>checkboxRef.checked = Array.isArray(value) ? !!value.find((data)=>data === checkboxRef.value) : value === checkboxRef.value) : options[0].ref.checked = !!value;
        else ref.value = value;
    }, []);
    const isFormDirty = ()=>!$f3834b459a71251c$var$deepEqual(getValues(), $f3834b459a71251c$var$isEmptyObject(defaultValuesRef.current) ? defaultValuesAtRenderRef.current : defaultValuesRef.current) || !$f3834b459a71251c$var$isEmptyObject(formStateRef.current.dirtyFields);
    const updateAndGetDirtyState = (0, $denZA.useCallback)((name, shouldRender = true)=>{
        if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
            const isFieldDirty = !$f3834b459a71251c$var$deepEqual($f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesAtRenderRef.current, name), $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            const isDirtyFieldExist = $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name);
            const previousIsDirty = formStateRef.current.isDirty;
            isFieldDirty ? $f3834b459a71251c$var$set(formStateRef.current.dirtyFields, name, true) : $f3834b459a71251c$var$unset(formStateRef.current.dirtyFields, name);
            const state = {
                isDirty: isFormDirty(),
                dirtyFields: formStateRef.current.dirtyFields
            };
            const isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name);
            if (isChanged && shouldRender) {
                formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
                updateFormState(Object.assign({}, state));
            }
            return isChanged ? state : {};
        }
        return {};
    }, []);
    const executeValidation = (0, $denZA.useCallback)(async (name, skipReRender)=>{
        if (fieldsRef.current[name]) {
            const error = (await $f3834b459a71251c$var$validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
            shouldRenderBaseOnError(name, error, skipReRender);
            return $f3834b459a71251c$var$isUndefined(error);
        }
        return false;
    }, [
        shouldRenderBaseOnError,
        isValidateAllFieldCriteria
    ]);
    const executeSchemaOrResolverValidation = (0, $denZA.useCallback)(async (names)=>{
        const { errors: errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
        const previousFormIsValid = formStateRef.current.isValid;
        if (Array.isArray(names)) {
            const isInputsValid = names.map((name)=>{
                const error = $f3834b459a71251c$export$3988ae62b71be9a3(errors, name);
                error ? $f3834b459a71251c$var$set(formStateRef.current.errors, name, error) : $f3834b459a71251c$var$unset(formStateRef.current.errors, name);
                return !error;
            }).every(Boolean);
            updateFormState({
                isValid: $f3834b459a71251c$var$isEmptyObject(errors),
                errors: formStateRef.current.errors
            });
            return isInputsValid;
        } else {
            const error = $f3834b459a71251c$export$3988ae62b71be9a3(errors, names);
            shouldRenderBaseOnError(names, error, previousFormIsValid !== $f3834b459a71251c$var$isEmptyObject(errors), {}, $f3834b459a71251c$var$isEmptyObject(errors));
            return !error;
        }
    }, [
        shouldRenderBaseOnError,
        isValidateAllFieldCriteria
    ]);
    const trigger = (0, $denZA.useCallback)(async (name)=>{
        const fields = name || Object.keys(fieldsRef.current);
        if (resolverRef.current) return executeSchemaOrResolverValidation(fields);
        if (Array.isArray(fields)) {
            !name && (formStateRef.current.errors = {});
            const result = await Promise.all(fields.map(async (data)=>await executeValidation(data, null)));
            updateFormState();
            return result.every(Boolean);
        }
        return await executeValidation(fields, readFormStateRef.current.isValid);
    }, [
        executeSchemaOrResolverValidation,
        executeValidation
    ]);
    const setInternalValues = (0, $denZA.useCallback)((name, value, { shouldDirty: shouldDirty, shouldValidate: shouldValidate })=>{
        const data = {};
        $f3834b459a71251c$var$set(data, name, value);
        for (const fieldName of $f3834b459a71251c$var$getPath(name, value))if (fieldsRef.current[fieldName]) {
            setFieldValue(fieldName, $f3834b459a71251c$export$3988ae62b71be9a3(data, fieldName));
            shouldDirty && updateAndGetDirtyState(fieldName);
            shouldValidate && trigger(fieldName);
        }
    }, [
        trigger,
        setFieldValue,
        updateAndGetDirtyState
    ]);
    const setInternalValue = (0, $denZA.useCallback)((name, value, config = {})=>{
        if (fieldsRef.current[name]) {
            setFieldValue(name, value);
            config.shouldDirty && updateAndGetDirtyState(name);
        } else if (!$f3834b459a71251c$var$isPrimitive(value)) {
            setInternalValues(name, value, config);
            if (fieldArrayNamesRef.current.has(name)) {
                fieldArrayDefaultValuesRef.current[name] = value;
                resetFieldArrayFunctionRef.current[name]({
                    [name]: value
                });
                if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
                    $f3834b459a71251c$var$set(formStateRef.current.dirtyFields, name, $f3834b459a71251c$var$setFieldArrayDirtyFields(value, $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name, []), $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name, [])));
                    updateFormState({
                        isDirty: !$f3834b459a71251c$var$deepEqual(Object.assign(Object.assign({}, getValues()), {
                            [name]: value
                        }), defaultValuesRef.current),
                        dirtyFields: formStateRef.current.dirtyFields
                    });
                }
            }
        }
        !shouldUnregister && $f3834b459a71251c$var$set(shallowFieldsStateRef.current, name, value);
    }, [
        updateAndGetDirtyState,
        setFieldValue,
        setInternalValues
    ]);
    const isFieldWatched = (name)=>isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    const renderWatchedInputs = (name, found = true)=>{
        if (!$f3834b459a71251c$var$isEmptyObject(useWatchFieldsRef.current)) {
            for(const key in useWatchFieldsRef.current)if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has($f3834b459a71251c$var$getFieldArrayParentName(name))) {
                useWatchRenderFunctionsRef.current[key]();
                found = false;
            }
        }
        return found;
    };
    function setValue(name, value, config) {
        setInternalValue(name, value, config);
        isFieldWatched(name) && updateFormState();
        renderWatchedInputs(name);
        (config || {}).shouldValidate && trigger(name);
    }
    handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : async ({ type: type, target: target })=>{
        let name = target.name;
        const field = fieldsRef.current[name];
        let error;
        let isValid;
        if (field) {
            const isBlurEvent = type === $f3834b459a71251c$var$EVENTS.BLUR;
            const shouldSkipValidation = $f3834b459a71251c$var$skipValidation(Object.assign({
                isBlurEvent: isBlurEvent,
                isReValidateOnChange: isReValidateOnChange,
                isReValidateOnBlur: isReValidateOnBlur,
                isTouched: !!$f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.touched, name),
                isSubmitted: formStateRef.current.isSubmitted
            }, modeRef.current));
            let state = updateAndGetDirtyState(name, false);
            let shouldRender = !$f3834b459a71251c$var$isEmptyObject(state) || isFieldWatched(name);
            if (isBlurEvent && !$f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                $f3834b459a71251c$var$set(formStateRef.current.touched, name, true);
                state = Object.assign(Object.assign({}, state), {
                    touched: formStateRef.current.touched
                });
            }
            if (shouldSkipValidation) {
                renderWatchedInputs(name);
                return (!$f3834b459a71251c$var$isEmptyObject(state) || shouldRender && $f3834b459a71251c$var$isEmptyObject(state)) && updateFormState(state);
            }
            if (resolverRef.current) {
                const { errors: errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
                const previousFormIsValid = formStateRef.current.isValid;
                error = $f3834b459a71251c$export$3988ae62b71be9a3(errors, name);
                if (!error && resolverRef.current) {
                    const parentNodeName = name.substring(0, name.lastIndexOf('.') > name.lastIndexOf('[') ? name.lastIndexOf('.') : name.lastIndexOf('['));
                    const currentError = $f3834b459a71251c$export$3988ae62b71be9a3(errors, parentNodeName, {});
                    currentError.type && currentError.message && (error = currentError);
                    if (parentNodeName && (currentError || $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.errors, parentNodeName))) name = parentNodeName;
                }
                isValid = $f3834b459a71251c$var$isEmptyObject(errors);
                if (previousFormIsValid !== isValid) shouldRender = true;
            } else error = (await $f3834b459a71251c$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
            renderWatchedInputs(name);
            shouldRenderBaseOnError(name, error, shouldRender, state, isValid);
        }
    };
    function setFieldArrayDefaultValues(data) {
        if (!shouldUnregister) {
            let copy = $f3834b459a71251c$var$cloneObject(data, $f3834b459a71251c$var$isWeb);
            for (const value of fieldArrayNamesRef.current)if ($f3834b459a71251c$var$isKey(value) && !copy[value]) copy = Object.assign(Object.assign({}, copy), {
                [value]: []
            });
            return copy;
        }
        return data;
    }
    function getValues(payload) {
        if ($f3834b459a71251c$var$isString(payload)) return $f3834b459a71251c$var$getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
        if (Array.isArray(payload)) {
            const data = {};
            for (const name of payload)$f3834b459a71251c$var$set(data, name, $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            return data;
        }
        return setFieldArrayDefaultValues($f3834b459a71251c$var$getFieldsValues(fieldsRef, shallowFieldsStateRef));
    }
    const validateResolver = (0, $denZA.useCallback)(async (values = {})=>{
        const { errors: errors } = await resolverRef.current(Object.assign(Object.assign(Object.assign({}, defaultValuesRef.current), getValues()), values), contextRef.current, isValidateAllFieldCriteria);
        const isValid = $f3834b459a71251c$var$isEmptyObject(errors);
        formStateRef.current.isValid !== isValid && updateFormState({
            isValid: isValid
        });
    }, [
        isValidateAllFieldCriteria
    ]);
    const removeFieldEventListener = (0, $denZA.useCallback)((field, forceDelete)=>$f3834b459a71251c$var$findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete), [
        shouldUnregister
    ]);
    const updateWatchedValue = (name)=>{
        if (isWatchAllRef.current) updateFormState();
        else if (watchFieldsRef) {
            let shouldRenderUseWatch = true;
            for (const watchField of watchFieldsRef.current)if (watchField.startsWith(name)) {
                updateFormState();
                shouldRenderUseWatch = false;
                break;
            }
            shouldRenderUseWatch && renderWatchedInputs(name);
        }
    };
    const removeFieldEventListenerAndRef = (0, $denZA.useCallback)((field, forceDelete)=>{
        if (field) {
            removeFieldEventListener(field, forceDelete);
            if (shouldUnregister && !$f3834b459a71251c$var$compact(field.options || []).length) {
                $f3834b459a71251c$var$unset(defaultValuesAtRenderRef.current, field.ref.name);
                $f3834b459a71251c$var$unset(validFieldsRef.current, field.ref.name);
                $f3834b459a71251c$var$unset(fieldsWithValidationRef.current, field.ref.name);
                $f3834b459a71251c$var$unset(formStateRef.current.errors, field.ref.name);
                $f3834b459a71251c$var$set(formStateRef.current.dirtyFields, field.ref.name, true);
                updateFormState({
                    errors: formStateRef.current.errors,
                    isDirty: isFormDirty(),
                    dirtyFields: formStateRef.current.dirtyFields
                });
                readFormStateRef.current.isValid && resolverRef.current && validateResolver();
                updateWatchedValue(field.ref.name);
            }
        }
    }, [
        validateResolver,
        removeFieldEventListener
    ]);
    function clearErrors(name) {
        name && (Array.isArray(name) ? name : [
            name
        ]).forEach((inputName)=>fieldsRef.current[inputName] ? $f3834b459a71251c$var$isKey(inputName) ? delete formStateRef.current.errors[inputName] : $f3834b459a71251c$var$set(formStateRef.current.errors, inputName, undefined) : $f3834b459a71251c$var$unset(formStateRef.current.errors, inputName));
        updateFormState({
            errors: name ? formStateRef.current.errors : {}
        });
    }
    function setError(name, error) {
        const ref = (fieldsRef.current[name] || {}).ref;
        $f3834b459a71251c$var$set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
            ref: ref
        }));
        updateFormState({
            isValid: false,
            errors: formStateRef.current.errors
        });
        error.shouldFocus && ref && ref.focus && ref.focus();
    }
    const watchInternal = (0, $denZA.useCallback)((fieldNames, defaultValue, watchId)=>{
        const watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
        const combinedDefaultValues = $f3834b459a71251c$var$isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;
        const fieldValues = $f3834b459a71251c$var$getFieldsValues(fieldsRef, shallowFieldsStateRef, false, fieldNames);
        if ($f3834b459a71251c$var$isString(fieldNames)) return $f3834b459a71251c$var$assignWatchFields(fieldValues, fieldNames, watchFields, $f3834b459a71251c$var$isUndefined(defaultValue) ? $f3834b459a71251c$export$3988ae62b71be9a3(combinedDefaultValues, fieldNames) : defaultValue, true);
        if (Array.isArray(fieldNames)) return fieldNames.reduce((previous, name)=>Object.assign(Object.assign({}, previous), {
                [name]: $f3834b459a71251c$var$assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)
            }), {});
        isWatchAllRef.current = $f3834b459a71251c$var$isUndefined(watchId);
        return $f3834b459a71251c$export$19bfedbbacd9b12a(!$f3834b459a71251c$var$isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
    }, []);
    function watch(fieldNames, defaultValue) {
        return watchInternal(fieldNames, defaultValue);
    }
    function unregister(name) {
        for (const fieldName of Array.isArray(name) ? name : [
            name
        ])removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
    }
    function registerFieldRef(ref, validateOptions = {}) {
        const { name: name, type: type, value: value } = ref;
        const fieldRefAndValidationOptions = Object.assign({
            ref: ref
        }, validateOptions);
        const fields = fieldsRef.current;
        const isRadioOrCheckbox = $f3834b459a71251c$var$isRadioOrCheckboxFunction(ref);
        const isFieldArray = $f3834b459a71251c$var$isNameInFieldArray(fieldArrayNamesRef.current, name);
        const compareRef = (currentRef)=>$f3834b459a71251c$var$isWeb && (!$f3834b459a71251c$var$isHTMLElement(ref) || currentRef === ref);
        let field = fields[name];
        let isEmptyDefaultValue = true;
        let defaultValue;
        if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && $f3834b459a71251c$var$compact(field.options).find((option)=>{
            return value === option.ref.value && compareRef(option.ref);
        }) : compareRef(field.ref))) {
            fields[name] = Object.assign(Object.assign({}, field), validateOptions);
            return;
        }
        if (type) field = isRadioOrCheckbox ? Object.assign({
            options: [
                ...$f3834b459a71251c$var$compact(field && field.options || []),
                {
                    ref: ref
                }
            ],
            ref: {
                type: type,
                name: name
            }
        }, validateOptions) : Object.assign({}, fieldRefAndValidationOptions);
        else field = fieldRefAndValidationOptions;
        fields[name] = field;
        const isEmptyUnmountFields = $f3834b459a71251c$var$isUndefined($f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name));
        if (!$f3834b459a71251c$var$isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
            defaultValue = $f3834b459a71251c$export$3988ae62b71be9a3(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
            isEmptyDefaultValue = $f3834b459a71251c$var$isUndefined(defaultValue);
            if (!isEmptyDefaultValue && !isFieldArray) setFieldValue(name, defaultValue);
        }
        if (!$f3834b459a71251c$var$isEmptyObject(validateOptions)) {
            $f3834b459a71251c$var$set(fieldsWithValidationRef.current, name, true);
            if (!isOnSubmit && readFormStateRef.current.isValid) $f3834b459a71251c$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then((error)=>{
                const previousFormIsValid = formStateRef.current.isValid;
                $f3834b459a71251c$var$isEmptyObject(error) ? $f3834b459a71251c$var$set(validFieldsRef.current, name, true) : $f3834b459a71251c$var$unset(validFieldsRef.current, name);
                if (previousFormIsValid !== $f3834b459a71251c$var$isEmptyObject(error)) updateFormState();
            });
        }
        if (!defaultValuesAtRenderRef.current[name] && !(isFieldArray && isEmptyDefaultValue)) {
            const fieldValue = $f3834b459a71251c$var$getFieldValue(fieldsRef, name, shallowFieldsStateRef);
            $f3834b459a71251c$var$set(defaultValuesAtRenderRef.current, name, isEmptyDefaultValue ? $f3834b459a71251c$var$isObject(fieldValue) ? Object.assign({}, fieldValue) : fieldValue : defaultValue);
            !isFieldArray && $f3834b459a71251c$var$unset(formStateRef.current.dirtyFields, name);
        }
        if (type) $f3834b459a71251c$var$attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || $f3834b459a71251c$var$isSelectInput(ref), handleChangeRef.current);
    }
    function register(refOrValidationOptions, rules) {
        if (!$f3834b459a71251c$var$isWindowUndefined) {
            if ($f3834b459a71251c$var$isString(refOrValidationOptions)) registerFieldRef({
                name: refOrValidationOptions
            }, rules);
            else if ($f3834b459a71251c$var$isObject(refOrValidationOptions) && 'name' in refOrValidationOptions) registerFieldRef(refOrValidationOptions, rules);
            else return (ref)=>ref && registerFieldRef(ref, refOrValidationOptions);
        }
    }
    const handleSubmit = (0, $denZA.useCallback)((onValid, onInvalid)=>async (e)=>{
            if (e && e.preventDefault) {
                e.preventDefault();
                e.persist();
            }
            let fieldErrors = {};
            let fieldValues = setFieldArrayDefaultValues($f3834b459a71251c$var$getFieldsValues(fieldsRef, shallowFieldsStateRef, true));
            readFormStateRef.current.isSubmitting && updateFormState({
                isSubmitting: true
            });
            try {
                if (resolverRef.current) {
                    const { errors: errors, values: values } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
                    formStateRef.current.errors = fieldErrors = errors;
                    fieldValues = values;
                } else {
                    for (const field of Object.values(fieldsRef.current))if (field) {
                        const { ref: { name: name } } = field;
                        const fieldError = await $f3834b459a71251c$var$validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);
                        if (fieldError[name]) {
                            $f3834b459a71251c$var$set(fieldErrors, name, fieldError[name]);
                            $f3834b459a71251c$var$unset(validFieldsRef.current, name);
                        } else if ($f3834b459a71251c$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name)) {
                            $f3834b459a71251c$var$unset(formStateRef.current.errors, name);
                            $f3834b459a71251c$var$set(validFieldsRef.current, name, true);
                        }
                    }
                }
                if ($f3834b459a71251c$var$isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every((name)=>name in fieldsRef.current)) {
                    updateFormState({
                        errors: {},
                        isSubmitting: true
                    });
                    await onValid(fieldValues, e);
                } else {
                    formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                    onInvalid && await onInvalid(formStateRef.current.errors, e);
                    shouldFocusError && $f3834b459a71251c$var$focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
                }
            } finally{
                updateFormState({
                    isSubmitted: true,
                    isSubmitting: false,
                    isSubmitSuccessful: $f3834b459a71251c$var$isEmptyObject(formStateRef.current.errors),
                    errors: formStateRef.current.errors,
                    submitCount: formStateRef.current.submitCount + 1
                });
            }
        }, [
        shouldFocusError,
        isValidateAllFieldCriteria
    ]);
    const resetRefs = ({ errors: errors, isDirty: isDirty, isSubmitted: isSubmitted, touched: touched, isValid: isValid, submitCount: submitCount, dirtyFields: dirtyFields })=>{
        if (!isValid) {
            validFieldsRef.current = {};
            fieldsWithValidationRef.current = {};
        }
        defaultValuesAtRenderRef.current = {};
        fieldArrayDefaultValuesRef.current = {};
        watchFieldsRef.current = new Set();
        isWatchAllRef.current = false;
        updateFormState({
            submitCount: submitCount ? formStateRef.current.submitCount : 0,
            isDirty: isDirty ? formStateRef.current.isDirty : false,
            isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
            isValid: isValid ? formStateRef.current.isValid : false,
            dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
            touched: touched ? formStateRef.current.touched : {},
            errors: errors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (values, omitResetState = {})=>{
        if ($f3834b459a71251c$var$isWeb) {
            for (const field of Object.values(fieldsRef.current))if (field) {
                const { ref: ref, options: options } = field;
                const inputRef = $f3834b459a71251c$var$isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;
                if ($f3834b459a71251c$var$isHTMLElement(inputRef)) try {
                    inputRef.closest('form').reset();
                    break;
                } catch (_a) {}
            }
        }
        fieldsRef.current = {};
        defaultValuesRef.current = $f3834b459a71251c$var$cloneObject(values || defaultValuesRef.current, $f3834b459a71251c$var$isWeb);
        values && renderWatchedInputs('');
        Object.values(resetFieldArrayFunctionRef.current).forEach((resetFieldArray)=>$f3834b459a71251c$var$isFunction(resetFieldArray) && resetFieldArray());
        shallowFieldsStateRef.current = shouldUnregister ? {} : $f3834b459a71251c$var$cloneObject(values, $f3834b459a71251c$var$isWeb) || {};
        resetRefs(omitResetState);
    };
    (0, $denZA.useEffect)(()=>{
        isUnMount.current = false;
        resolver && readFormStateRef.current.isValid && validateResolver();
        observerRef.current = observerRef.current || !$f3834b459a71251c$var$isWeb ? observerRef.current : $f3834b459a71251c$var$onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
        return ()=>{
            isUnMount.current = true;
            observerRef.current && observerRef.current.disconnect();
            shallowFieldsStateRef.current = {};
            Object.values(fieldsRef.current).forEach((field)=>removeFieldEventListenerAndRef(field, true));
        };
    }, [
        removeFieldEventListenerAndRef
    ]);
    if (!resolver && readFormStateRef.current.isValid) formState.isValid = $f3834b459a71251c$var$deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && $f3834b459a71251c$var$isEmptyObject(formStateRef.current.errors);
    const commonProps = {
        trigger: trigger,
        setValue: (0, $denZA.useCallback)(setValue, [
            setInternalValue,
            trigger
        ]),
        getValues: (0, $denZA.useCallback)(getValues, []),
        register: (0, $denZA.useCallback)(register, [
            defaultValuesRef.current
        ]),
        unregister: (0, $denZA.useCallback)(unregister, [])
    };
    const control = Object.assign({
        updateWatchedValue: updateWatchedValue,
        shouldUnregister: shouldUnregister,
        removeFieldEventListener: removeFieldEventListener,
        watchInternal: watchInternal,
        mode: modeRef.current,
        reValidateMode: {
            isReValidateOnBlur: isReValidateOnBlur,
            isReValidateOnChange: isReValidateOnChange
        },
        fieldsRef: fieldsRef,
        resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
        useWatchFieldsRef: useWatchFieldsRef,
        useWatchRenderFunctionsRef: useWatchRenderFunctionsRef,
        fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef,
        validFieldsRef: validFieldsRef,
        fieldsWithValidationRef: fieldsWithValidationRef,
        fieldArrayNamesRef: fieldArrayNamesRef,
        readFormStateRef: readFormStateRef,
        formStateRef: formStateRef,
        defaultValuesRef: defaultValuesRef,
        shallowFieldsStateRef: shallowFieldsStateRef,
        updateFormState: updateFormState,
        validateResolver: resolver ? validateResolver : undefined
    }, commonProps);
    return Object.assign({
        watch: watch,
        control: control,
        formState: $f3834b459a71251c$var$isProxyEnabled ? new Proxy(formState, {
            get: (obj, prop)=>{
                if (prop in obj) {
                    readFormStateRef.current[prop] = true;
                    return obj[prop];
                }
                return undefined;
            }
        }) : formState,
        handleSubmit: handleSubmit,
        reset: (0, $denZA.useCallback)(reset, []),
        clearErrors: (0, $denZA.useCallback)(clearErrors, []),
        setError: (0, $denZA.useCallback)(setError, []),
        errors: formState.errors
    }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f3834b459a71251c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $f3834b459a71251c$var$FormContext = (0, $denZA.createContext)(null);
$f3834b459a71251c$var$FormContext.displayName = 'RHFContext';
const $f3834b459a71251c$export$4d957a5e1be13b03 = ()=>(0, $denZA.useContext)($f3834b459a71251c$var$FormContext);
const $f3834b459a71251c$export$8ce1ff4f94d08846 = (_a)=>{
    var { children: children } = _a, props = $f3834b459a71251c$var$__rest(_a, [
        "children"
    ]);
    return (0, $denZA.createElement)($f3834b459a71251c$var$FormContext.Provider, {
        value: Object.assign({}, props)
    }, children);
};
var $f3834b459a71251c$var$generateId = ()=>{
    const d = typeof performance === $f3834b459a71251c$var$UNDEFINED ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
const $f3834b459a71251c$var$removeAt = (data, index)=>[
        ...data.slice(0, index),
        ...data.slice(index + 1)
    ];
function $f3834b459a71251c$var$removeAtIndexes(data, index) {
    let k = -1;
    while(++k < data.length)if (index.indexOf(k) >= 0) delete data[k];
    return $f3834b459a71251c$var$compact(data);
}
var $f3834b459a71251c$var$removeArrayAt = (data, index)=>$f3834b459a71251c$var$isUndefined(index) ? [] : Array.isArray(index) ? $f3834b459a71251c$var$removeAtIndexes(data, index) : $f3834b459a71251c$var$removeAt(data, index);
var $f3834b459a71251c$var$moveArrayAt = (data, from, to)=>{
    if (Array.isArray(data)) {
        if ($f3834b459a71251c$var$isUndefined(data[to])) data[to] = undefined;
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};
var $f3834b459a71251c$var$swapArrayAt = (data, indexA, indexB)=>{
    const temp = [
        data[indexB],
        data[indexA]
    ];
    data[indexA] = temp[0];
    data[indexB] = temp[1];
};
function $f3834b459a71251c$var$prepend(data, value) {
    return [
        ...Array.isArray(value) ? value : [
            value || undefined
        ],
        ...data
    ];
}
function $f3834b459a71251c$var$insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...Array.isArray(value) ? value : [
            value || undefined
        ],
        ...data.slice(index)
    ];
}
var $f3834b459a71251c$var$fillEmptyArray = (value)=>Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
function $f3834b459a71251c$var$mapValueToBoolean(value) {
    if ($f3834b459a71251c$var$isObject(value)) {
        const object = {};
        for(const key in value)object[key] = true;
        return [
            object
        ];
    }
    return [
        true
    ];
}
var $f3834b459a71251c$var$fillBooleanArray = (value)=>(Array.isArray(value) ? value : [
        value
    ]).map($f3834b459a71251c$var$mapValueToBoolean).flat();
const $f3834b459a71251c$var$mapIds = (values = [], keyName)=>{
    return values.map((value)=>Object.assign({
            [keyName]: $f3834b459a71251c$var$generateId()
        }, value));
};
const $f3834b459a71251c$export$310131896651d559 = ({ control: control, name: name, keyName: keyName = 'id' })=>{
    const methods = $f3834b459a71251c$export$4d957a5e1be13b03();
    const focusIndexRef = (0, $denZA.useRef)(-1);
    const { updateWatchedValue: updateWatchedValue, resetFieldArrayFunctionRef: resetFieldArrayFunctionRef, fieldArrayNamesRef: fieldArrayNamesRef, fieldsRef: fieldsRef, defaultValuesRef: defaultValuesRef, removeFieldEventListener: removeFieldEventListener, formStateRef: formStateRef, shallowFieldsStateRef: shallowFieldsStateRef, updateFormState: updateFormState, readFormStateRef: readFormStateRef, validFieldsRef: validFieldsRef, fieldsWithValidationRef: fieldsWithValidationRef, fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef, validateResolver: validateResolver, getValues: getValues, shouldUnregister: shouldUnregister } = control || methods.control;
    const fieldArrayParentName = $f3834b459a71251c$var$getFieldArrayParentName(name);
    const memoizedDefaultValues = (0, $denZA.useRef)([
        ...$f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? $f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name, []) : $f3834b459a71251c$export$3988ae62b71be9a3(shouldUnregister ? defaultValuesRef.current : shallowFieldsStateRef.current, name, [])
    ]);
    const [fields, setFields] = (0, $denZA.useState)($f3834b459a71251c$var$mapIds(memoizedDefaultValues.current, keyName));
    const allFields = (0, $denZA.useRef)(fields);
    const getCurrentFieldsValues = ()=>$f3834b459a71251c$export$3988ae62b71be9a3(getValues(), name, allFields.current).map((item, index)=>Object.assign(Object.assign({}, allFields.current[index]), item));
    allFields.current = fields;
    fieldArrayNamesRef.current.add(name);
    if (!$f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) $f3834b459a71251c$var$set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, fieldArrayParentName));
    const setFieldAndValidState = (fieldsValues)=>{
        setFields(fieldsValues);
        if (readFormStateRef.current.isValid && validateResolver) {
            const values = getValues();
            $f3834b459a71251c$var$set(values, name, fieldsValues);
            validateResolver(values);
        }
    };
    const getIsDirtyState = (flagOrFields)=>(readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && ($f3834b459a71251c$var$isUndefined(flagOrFields) || !$f3834b459a71251c$var$deepEqual(flagOrFields.map((_a = {})=>{
            var _b = keyName, omitted = _a[_b], rest = $f3834b459a71251c$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return rest;
        }), $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name, [])));
    const resetFields = ()=>{
        for(const key in fieldsRef.current)$f3834b459a71251c$var$isMatchFieldArrayName(key, name) && removeFieldEventListener(fieldsRef.current[key], true);
    };
    const cleanup = (ref)=>!$f3834b459a71251c$var$compact($f3834b459a71251c$export$3988ae62b71be9a3(ref, name, [])).length && $f3834b459a71251c$var$unset(ref, name);
    const updateDirtyFieldsWithDefaultValues = (updatedFieldArrayValues)=>{
        const defaultFieldArrayValues = $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name, []);
        const updateDirtyFieldsBaseOnDefaultValues = (base, target)=>{
            for(const key in base){
                for(const innerKey in base[key])if (innerKey !== keyName && (!target[key] || !base[key] || base[key][innerKey] !== target[key][innerKey])) $f3834b459a71251c$var$set(formStateRef.current.dirtyFields, `${name}[${key}]`, Object.assign(Object.assign({}, $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, `${name}[${key}]`, {})), {
                    [innerKey]: true
                }));
            }
        };
        if (updatedFieldArrayValues) {
            updateDirtyFieldsBaseOnDefaultValues(defaultFieldArrayValues, updatedFieldArrayValues);
            updateDirtyFieldsBaseOnDefaultValues(updatedFieldArrayValues, defaultFieldArrayValues);
        }
    };
    const batchStateUpdate = (method, args, updatedFieldValues, isDirty = true, shouldSet = true, shouldUpdateValid = false)=>{
        if ($f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name)) {
            const output = method($f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name), args.argA, args.argB);
            shouldSet && $f3834b459a71251c$var$set(shallowFieldsStateRef.current, name, output);
        }
        if ($f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name)) {
            const output = method($f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
            shouldSet && $f3834b459a71251c$var$set(fieldArrayDefaultValuesRef.current, name, output);
            cleanup(fieldArrayDefaultValuesRef.current);
        }
        if (Array.isArray($f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.errors, name))) {
            const output = method($f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && $f3834b459a71251c$var$set(formStateRef.current.errors, name, output);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touched && $f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.touched, name)) {
            const output = method($f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.touched, name), args.argA, args.argB);
            shouldSet && $f3834b459a71251c$var$set(formStateRef.current.touched, name, output);
            cleanup(formStateRef.current.touched);
        }
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            const output = method($f3834b459a71251c$export$3988ae62b71be9a3(formStateRef.current.dirtyFields, name, []), args.argC, args.argD);
            shouldSet && $f3834b459a71251c$var$set(formStateRef.current.dirtyFields, name, output);
            updateDirtyFieldsWithDefaultValues(updatedFieldValues);
            cleanup(formStateRef.current.dirtyFields);
        }
        if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
            $f3834b459a71251c$var$set(validFieldsRef.current, name, method($f3834b459a71251c$export$3988ae62b71be9a3(validFieldsRef.current, name, []), args.argA));
            cleanup(validFieldsRef.current);
            $f3834b459a71251c$var$set(fieldsWithValidationRef.current, name, method($f3834b459a71251c$export$3988ae62b71be9a3(fieldsWithValidationRef.current, name, []), args.argA));
            cleanup(fieldsWithValidationRef.current);
        }
        updateFormState({
            errors: formStateRef.current.errors,
            dirtyFields: formStateRef.current.dirtyFields,
            isDirty: isDirty,
            touched: formStateRef.current.touched
        });
    };
    const append = (value, shouldFocus = true)=>{
        const updateFormValues = [
            ...allFields.current,
            ...$f3834b459a71251c$var$mapIds(Array.isArray(value) ? value : [
                value
            ], keyName)
        ];
        setFieldAndValidState(updateFormValues);
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            updateDirtyFieldsWithDefaultValues(updateFormValues);
            updateFormState({
                isDirty: true,
                dirtyFields: formStateRef.current.dirtyFields
            });
        }
        !shouldUnregister && $f3834b459a71251c$var$set(shallowFieldsStateRef.current, name, [
            ...shallowFieldsStateRef.current[name] || [],
            value
        ]);
        focusIndexRef.current = shouldFocus ? allFields.current.length : -1;
    };
    const prepend$1 = (value, shouldFocus = true)=>{
        const emptyArray = $f3834b459a71251c$var$fillEmptyArray(value);
        const updatedFieldArrayValues = $f3834b459a71251c$var$prepend(getCurrentFieldsValues(), $f3834b459a71251c$var$mapIds(Array.isArray(value) ? value : [
            value
        ], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate($f3834b459a71251c$var$prepend, {
            argA: emptyArray,
            argC: $f3834b459a71251c$var$fillBooleanArray(value)
        }, updatedFieldArrayValues);
        focusIndexRef.current = shouldFocus ? 0 : -1;
    };
    const remove = (index)=>{
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldValues = $f3834b459a71251c$var$removeArrayAt(fieldValues, index);
        setFieldAndValidState(updatedFieldValues);
        resetFields();
        batchStateUpdate($f3834b459a71251c$var$removeArrayAt, {
            argA: index,
            argC: index
        }, updatedFieldValues, getIsDirtyState($f3834b459a71251c$var$removeArrayAt(fieldValues, index)), true, true);
    };
    const insert$1 = (index, value, shouldFocus = true)=>{
        const emptyArray = $f3834b459a71251c$var$fillEmptyArray(value);
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldArrayValues = $f3834b459a71251c$var$insert(fieldValues, index, $f3834b459a71251c$var$mapIds(Array.isArray(value) ? value : [
            value
        ], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate($f3834b459a71251c$var$insert, {
            argA: index,
            argB: emptyArray,
            argC: index,
            argD: $f3834b459a71251c$var$fillBooleanArray(value)
        }, updatedFieldArrayValues, getIsDirtyState($f3834b459a71251c$var$insert(fieldValues, index)));
        focusIndexRef.current = shouldFocus ? index : -1;
    };
    const swap = (indexA, indexB)=>{
        const fieldValues = getCurrentFieldsValues();
        $f3834b459a71251c$var$swapArrayAt(fieldValues, indexA, indexB);
        resetFields();
        setFieldAndValidState([
            ...fieldValues
        ]);
        batchStateUpdate($f3834b459a71251c$var$swapArrayAt, {
            argA: indexA,
            argB: indexB,
            argC: indexA,
            argD: indexB
        }, undefined, getIsDirtyState(fieldValues), false);
    };
    const move = (from, to)=>{
        const fieldValues = getCurrentFieldsValues();
        $f3834b459a71251c$var$moveArrayAt(fieldValues, from, to);
        resetFields();
        setFieldAndValidState([
            ...fieldValues
        ]);
        batchStateUpdate($f3834b459a71251c$var$moveArrayAt, {
            argA: from,
            argB: to,
            argC: from,
            argD: to
        }, undefined, getIsDirtyState(fieldValues), false);
    };
    const reset = (data)=>{
        resetFields();
        !data && $f3834b459a71251c$var$unset(fieldArrayDefaultValuesRef.current, name);
        $f3834b459a71251c$var$unset(shallowFieldsStateRef.current, name);
        memoizedDefaultValues.current = $f3834b459a71251c$export$3988ae62b71be9a3(data || defaultValuesRef.current, name);
        setFields($f3834b459a71251c$var$mapIds(memoizedDefaultValues.current, keyName));
    };
    (0, $denZA.useEffect)(()=>{
        const defaultValues = $f3834b459a71251c$export$3988ae62b71be9a3(fieldArrayDefaultValuesRef.current, name);
        if (defaultValues && fields.length < defaultValues.length) {
            defaultValues.pop();
            $f3834b459a71251c$var$set(fieldArrayDefaultValuesRef.current, name, defaultValues);
        }
        updateWatchedValue(name);
        if (focusIndexRef.current > -1) for(const key in fieldsRef.current){
            const field = fieldsRef.current[key];
            if (key.startsWith(`${name}[${focusIndexRef.current}]`) && field.ref.focus) {
                field.ref.focus();
                break;
            }
        }
        focusIndexRef.current = -1;
    }, [
        fields,
        name
    ]);
    (0, $denZA.useEffect)(()=>{
        const resetFunctions = resetFieldArrayFunctionRef.current;
        const fieldArrayNames = fieldArrayNamesRef.current;
        if (!$f3834b459a71251c$var$getFieldArrayParentName(name)) resetFunctions[name] = reset;
        return ()=>{
            resetFields();
            delete resetFunctions[name];
            fieldArrayNames.delete(name);
        };
    }, []);
    return {
        swap: (0, $denZA.useCallback)(swap, [
            name
        ]),
        move: (0, $denZA.useCallback)(move, [
            name
        ]),
        prepend: (0, $denZA.useCallback)(prepend$1, [
            name
        ]),
        append: (0, $denZA.useCallback)(append, [
            name
        ]),
        remove: (0, $denZA.useCallback)(remove, [
            name
        ]),
        insert: (0, $denZA.useCallback)(insert$1, [
            name
        ]),
        fields: fields
    };
};
function $f3834b459a71251c$export$3c773aa2b84f29e0({ control: control, name: name, defaultValue: defaultValue }) {
    const methods = $f3834b459a71251c$export$4d957a5e1be13b03();
    const { useWatchFieldsRef: useWatchFieldsRef, useWatchRenderFunctionsRef: useWatchRenderFunctionsRef, watchInternal: watchInternal, defaultValuesRef: defaultValuesRef } = control || methods.control;
    const [value, setValue] = (0, $denZA.useState)($f3834b459a71251c$var$isUndefined(defaultValue) ? $f3834b459a71251c$var$isString(name) ? $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce((previous, inputName)=>Object.assign(Object.assign({}, previous), {
            [inputName]: $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, inputName)
        }), {}) : defaultValuesRef.current : defaultValue);
    const idRef = (0, $denZA.useRef)();
    const defaultValueRef = (0, $denZA.useRef)(defaultValue);
    const updateWatchValue = (0, $denZA.useCallback)(()=>{
        const value = watchInternal(name, defaultValueRef.current, idRef.current);
        setValue($f3834b459a71251c$var$isObject(value) ? Object.assign({}, value) : Array.isArray(value) ? [
            ...value
        ] : value);
    }, [
        setValue,
        watchInternal,
        defaultValueRef,
        name,
        idRef
    ]);
    (0, $denZA.useEffect)(()=>{
        const id = idRef.current = $f3834b459a71251c$var$generateId();
        const watchFieldsHookRender = useWatchRenderFunctionsRef.current;
        const watchFieldsHook = useWatchFieldsRef.current;
        watchFieldsHook[id] = new Set();
        watchFieldsHookRender[id] = updateWatchValue;
        watchInternal(name, defaultValueRef.current, id);
        return ()=>{
            delete watchFieldsHook[id];
            delete watchFieldsHookRender[id];
        };
    }, [
        name,
        updateWatchValue,
        useWatchRenderFunctionsRef,
        useWatchFieldsRef,
        watchInternal,
        defaultValueRef
    ]);
    return $f3834b459a71251c$var$isUndefined(value) ? defaultValue : value;
}
var $f3834b459a71251c$var$getInputValue = (event)=>$f3834b459a71251c$var$isPrimitive(event) || !$f3834b459a71251c$var$isObject(event.target) || $f3834b459a71251c$var$isObject(event.target) && !event.type ? event : $f3834b459a71251c$var$isUndefined(event.target.value) ? event.target.checked : event.target.value;
const $f3834b459a71251c$export$bd0bf19f25da8474 = (_a)=>{
    var { name: name, rules: rules, as: as, render: render, defaultValue: defaultValue, control: control, onFocus: onFocus } = _a, rest = $f3834b459a71251c$var$__rest(_a, [
        "name",
        "rules",
        "as",
        "render",
        "defaultValue",
        "control",
        "onFocus"
    ]);
    const methods = $f3834b459a71251c$export$4d957a5e1be13b03();
    const { defaultValuesRef: defaultValuesRef, setValue: setValue, register: register, unregister: unregister, trigger: trigger, mode: mode, reValidateMode: { isReValidateOnBlur: isReValidateOnBlur, isReValidateOnChange: isReValidateOnChange }, formStateRef: { current: { isSubmitted: isSubmitted, touched: touched } }, updateFormState: updateFormState, readFormStateRef: readFormStateRef, fieldsRef: fieldsRef, fieldArrayNamesRef: fieldArrayNamesRef, shallowFieldsStateRef: shallowFieldsStateRef } = control || methods.control;
    const isNotFieldArray = !$f3834b459a71251c$var$isNameInFieldArray(fieldArrayNamesRef.current, name);
    const getInitialValue = ()=>!$f3834b459a71251c$var$isUndefined($f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name)) && isNotFieldArray ? $f3834b459a71251c$export$3988ae62b71be9a3(shallowFieldsStateRef.current, name) : $f3834b459a71251c$var$isUndefined(defaultValue) ? $f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name) : defaultValue;
    const [value, setInputStateValue] = (0, $denZA.useState)(getInitialValue());
    const valueRef = (0, $denZA.useRef)(value);
    const ref = (0, $denZA.useRef)({
        focus: ()=>null
    });
    const onFocusRef = (0, $denZA.useRef)(onFocus || (()=>ref.current.focus()));
    const shouldValidate = (isBlurEvent)=>!$f3834b459a71251c$var$skipValidation(Object.assign({
            isBlurEvent: isBlurEvent,
            isReValidateOnBlur: isReValidateOnBlur,
            isReValidateOnChange: isReValidateOnChange,
            isSubmitted: isSubmitted,
            isTouched: !!$f3834b459a71251c$export$3988ae62b71be9a3(touched, name)
        }, mode));
    const commonTask = ([event])=>{
        const data = $f3834b459a71251c$var$getInputValue(event);
        setInputStateValue(data);
        valueRef.current = data;
        return data;
    };
    const registerField = (0, $denZA.useCallback)(()=>{
        if (fieldsRef.current[name]) fieldsRef.current[name] = Object.assign({
            ref: fieldsRef.current[name].ref
        }, rules);
        else {
            register(Object.defineProperty({
                name: name,
                focus: onFocusRef.current
            }, $f3834b459a71251c$var$VALUE, {
                set (data) {
                    setInputStateValue(data);
                    valueRef.current = data;
                },
                get () {
                    return valueRef.current;
                }
            }), rules);
            if (isNotFieldArray && !$f3834b459a71251c$export$3988ae62b71be9a3(defaultValuesRef.current, name)) setInputStateValue(getInitialValue());
        }
    }, [
        rules,
        name,
        register
    ]);
    (0, $denZA.useEffect)(()=>()=>unregister(name), [
        unregister,
        name
    ]);
    (0, $denZA.useEffect)(()=>{
        registerField();
    }, [
        registerField
    ]);
    (0, $denZA.useEffect)(()=>{
        if (!fieldsRef.current[name]) {
            registerField();
            if (isNotFieldArray) setInputStateValue(getInitialValue());
        }
    });
    const onBlur = ()=>{
        if (readFormStateRef.current.touched && !$f3834b459a71251c$export$3988ae62b71be9a3(touched, name)) {
            $f3834b459a71251c$var$set(touched, name, true);
            updateFormState({
                touched: touched
            });
        }
        if (shouldValidate(true)) trigger(name);
    };
    const onChange = (...event)=>setValue(name, commonTask(event), {
            shouldValidate: shouldValidate(),
            shouldDirty: true
        });
    const commonProps = {
        onChange: onChange,
        onBlur: onBlur,
        name: name,
        value: value,
        ref: ref
    };
    const props = Object.assign(Object.assign({}, rest), commonProps);
    return as ? (0, $denZA.isValidElement)(as) ? (0, $denZA.cloneElement)(as, props) : (0, $denZA.createElement)(as, props) : render ? render(commonProps) : null;
};


var $8156e482268b1351$export$b0aeb07a3112de27 = function(_a) {
    var name = _a.name, warnings = _a.warnings, registerProp = _a.register, controlProp = _a.control, errorsProp = _a.errors, statusProp = _a.status;
    if (!name) throw new Error("useFormField: all form fields require the 'name' prop");
    var formContext = (0, $f3834b459a71251c$export$4d957a5e1be13b03)();
    var errors = errorsProp !== null && errorsProp !== void 0 ? errorsProp : formContext === null || formContext === void 0 ? void 0 : formContext.errors;
    var register = registerProp !== null && registerProp !== void 0 ? registerProp : formContext === null || formContext === void 0 ? void 0 : formContext.register;
    var control = controlProp !== null && controlProp !== void 0 ? controlProp : formContext === null || formContext === void 0 ? void 0 : formContext.control;
    if (!((register || control) && errors)) throw new Error("useFormField '" + name + "': you need to pass ('register' or 'control') and 'errors' props from useForm, or alternatively wrap the form in a FormProvider");
    var fieldErrors = errors[name];
    var fieldWarnings = warnings === null || warnings === void 0 ? void 0 : warnings[name];
    var status = statusProp;
    var helperText;
    if (fieldErrors) {
        status = 'error';
        helperText = fieldErrors.message;
    } else if (fieldWarnings) {
        status = 'warning';
        helperText = fieldWarnings.message;
    }
    return {
        register: register,
        status: status,
        helperText: helperText,
        name: name,
        control: control,
        fieldErrors: fieldErrors,
        fieldWarnings: fieldWarnings,
        formState: formContext === null || formContext === void 0 ? void 0 : formContext.formState
    };
};



var $denZA = parcelRequire("denZA");

var $23f5639cc6b966d7$export$9949bd9c713ba425 = function() {
    var ctx = $denZA.useContext((0, $ed5e4887d38fbfdd$export$a6e93d8cb5d50678));
    if (!ctx) throw new Error('"useNotification" can only be called inside of NotificationContextProvider!');
    return ctx;
};



var $e55e8a2120fd7762$export$673c0f2dc34a292b;
(function(PortalRoots) {
    PortalRoots["TOAST"] = "toast";
    PortalRoots["POPOVER"] = "popover";
    PortalRoots["TOOLTIP"] = "tooltip";
    PortalRoots["DROPDOWN"] = "dropdown";
    PortalRoots["MODAL"] = "modal";
})($e55e8a2120fd7762$export$673c0f2dc34a292b || ($e55e8a2120fd7762$export$673c0f2dc34a292b = {}));
var $e55e8a2120fd7762$var$portalRenderRoots = {};
var $e55e8a2120fd7762$export$6ecd3efa4eebe261 = function(root) {
    if (!(0, $efef0f8ceb54059d$export$c81b8d8584b2fbae)) throw new Error('dom not available');
    if (!$e55e8a2120fd7762$var$portalRenderRoots[root]) {
        var elm = document.createElement('div');
        elm.id = root;
        $e55e8a2120fd7762$var$portalRenderRoots[root] = elm;
        document.body.appendChild(elm);
    }
    return {
        portalRoot: $e55e8a2120fd7762$var$portalRenderRoots[root]
    };
};



var $denZA = parcelRequire("denZA");
var $54342fa4a3fea3d9$export$45712eceda6fad21 = function(_a) {
    var onPress = _a.onPress, ref = _a.ref;
    $denZA.useEffect(function() {
        if (ref.current) // eslint-disable-next-line no-console
        console.log(onPress);
    });
    return {
        isPressed: true,
        pressProps: {}
    };
};



var $denZA = parcelRequire("denZA");
var $c9bab4bc692bb080$export$38d56e9c4e5a652b = function(forwardedRef) {
    // eslint-disable-next-line no-null/no-null
    var innerRef = $denZA.useRef(null);
    // Update the shared ref if the forwardedRef changes
    $denZA.useEffect(function() {
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') {
            forwardedRef(innerRef.current);
            return;
        } else forwardedRef.current = innerRef.current;
    }, [
        forwardedRef
    ]);
    return innerRef;
};


/**
 * useSpace
 * Turn a spaceValue into a string
 * so it can be used as a className
 *
 * @param space SpaceValue
 * @memberof hooks
 * @author Jeremy Thomas
 */ var $6f7c5c4933eb8f4b$export$450c36e0b0e62ccd = function(space) {
    if (!space) return '';
    return "" + space;
};




var $ed5e4887d38fbfdd$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ed5e4887d38fbfdd$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ed5e4887d38fbfdd$var$__read(arguments[i]));
    return ar;
};
var $ed5e4887d38fbfdd$export$a6e93d8cb5d50678 = $denZA.createContext(undefined);
var $ed5e4887d38fbfdd$export$363d05e3285e82a1 = function(_a) {
    var children = _a.children, _b = _a.autoDismiss, autoDismiss = _b === void 0 ? true : _b, _c = _a.autoDismissTimeout, autoDismissTimeout = _c === void 0 ? 3000 : _c;
    var _d = $ed5e4887d38fbfdd$var$__read($denZA.useState([]), 2), toasts = _d[0], setToasts = _d[1];
    var _e = $ed5e4887d38fbfdd$var$__read($denZA.useState(), 2), tobeCleaned = _e[0], scheduleClean = _e[1];
    var portalRoot = (0, $e55e8a2120fd7762$export$6ecd3efa4eebe261)((0, $e55e8a2120fd7762$export$673c0f2dc34a292b).TOAST).portalRoot;
    $denZA.useEffect(function() {
        setToasts(function(prevToasts) {
            return prevToasts.filter(function(toast) {
                return toast.key !== tobeCleaned;
            });
        });
    }, [
        tobeCleaned
    ]);
    var addToast = function(content, options) {
        var toast = $denZA.createElement((0, $e2a5d556d9ae4bcd$export$8d8dc7d5f743331b), {
            key: Math.random(),
            status: options.status
        }, content);
        setToasts(function(prevToasts) {
            return $ed5e4887d38fbfdd$var$__spread(prevToasts, [
                toast
            ]);
        });
        // TODO: the timeout must also be cleared otherwise they will continue to run even if the component is removed
        if (autoDismiss) setTimeout(function() {
            if (toast.key) scheduleClean(toast.key.toString());
        }, autoDismissTimeout);
    };
    var removeToast = function() {
        setToasts(function(prev) {
            return prev.filter(function(_, i) {
                return i;
            });
        });
    };
    var clearToasts = function() {
        setToasts([]);
    };
    return $denZA.createElement($ed5e4887d38fbfdd$export$a6e93d8cb5d50678.Provider, {
        value: {
            addToast: addToast,
            clearToasts: clearToasts,
            removeToast: removeToast
        }
    }, children, !!toasts.length && $d486a8928008256a$exports.createPortal($denZA.createElement((0, $8483a51dc91884cb$export$f2815235e76a62b9), null, toasts), portalRoot));
};





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $bc78a18b6a68f96d$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $bc78a18b6a68f96d$export$e2a22331486dcca0 = $bc78a18b6a68f96d$export$bdbb4cbb3078e58d();


var $308426badd43ef89$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $bc78a18b6a68f96d$export$bdbb4cbb3078e58d)()
    };
};
var $308426badd43ef89$export$e575061ef2a070eb = $308426badd43ef89$export$1921362e86c73c88();
var $308426badd43ef89$export$b4d5da5f34fb77ad = $denZA.createContext($308426badd43ef89$export$1921362e86c73c88());
var $308426badd43ef89$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $308426badd43ef89$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};


var $b3689d7f6454aa75$var$generateUID = function(context) {
    var quartz = context || (0, $308426badd43ef89$export$e575061ef2a070eb);
    var prefix = (0, $308426badd43ef89$export$36e24695f02d4503)(quartz);
    var id = (0, $308426badd43ef89$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $b3689d7f6454aa75$var$useUIDState = function() {
    // @ts-ignore
    return $denZA.useState($b3689d7f6454aa75$var$generateUID($denZA.useContext((0, $308426badd43ef89$export$b4d5da5f34fb77ad))));
};
var $b3689d7f6454aa75$export$87d05f07e65211f1 = function() {
    var uid = $b3689d7f6454aa75$var$useUIDState()[0].uid;
    return uid;
};
var $b3689d7f6454aa75$export$bb5ca5fba6fb4f1f = function() {
    var gen = $b3689d7f6454aa75$var$useUIDState()[0].gen;
    return gen;
};


var $368dfcda2edba615$export$3ec6e0c16b571c32 = function(type) {
    var uid = (0, $b3689d7f6454aa75$export$87d05f07e65211f1)();
    return type + "-" + uid;
};
var $368dfcda2edba615$export$9178c5a458a4a458 = function(id, index) {
    return id + "-tab-" + index;
};
var $368dfcda2edba615$export$2c0ff9f06f6a462b = function(id, index) {
    return id + "-tabpanel-" + index;
};


var $9a5d87e7a4870d4c$exports = {};
'use strict';

$9a5d87e7a4870d4c$exports = (parcelRequire("iQC18"));


var $f870f799b81a40f8$var$__assign = undefined && undefined.__assign || function() {
    $f870f799b81a40f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f870f799b81a40f8$var$__assign.apply(this, arguments);
};
var $f870f799b81a40f8$export$caec2af78bcc877f = $9a5d87e7a4870d4c$exports.forwardRef(function Alert(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $f870f799b81a40f8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M13.934 21.021a.73.73 0 00-.924.514 1.34 1.34 0 01-.908.907 1.297 1.297 0 01-1.01-.102 1.265 1.265 0 01-.633-.788.764.764 0 00-.924-.514.764.764 0 00-.514.925c.205.719.702 1.318 1.352 1.695.428.222.89.342 1.353.342.274 0 .53-.034.804-.12a2.836 2.836 0 001.918-1.917.76.76 0 00-.514-.942zm7.258-2.858c-.137-.172-1.232-1.73-1.232-7.67 0-4.296-3.304-7.823-7.498-8.2V.754A.76.76 0 0011.709 0a.76.76 0 00-.754.753v1.54c-4.176.395-7.463 3.921-7.463 8.2 0 5.872-1.335 7.772-1.335 7.772a.769.769 0 00-.086.788c.12.257.394.428.668.428h17.974c.342 0 .668-.189.753-.514.086-.308 0-.616-.274-.804zM3.937 17.99c.48-1.232 1.044-3.543 1.044-7.497 0-3.715 3.03-6.745 6.745-6.745 3.714 0 6.744 3.03 6.744 6.745 0 4.04.497 6.282.959 7.497H3.937z"
    }));
});



var $ef22a185946da15a$var$__assign = undefined && undefined.__assign || function() {
    $ef22a185946da15a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef22a185946da15a$var$__assign.apply(this, arguments);
};
var $ef22a185946da15a$export$b064d7839e1e373e = $9a5d87e7a4870d4c$exports.forwardRef(function AlertBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ef22a185946da15a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M20.229 10.491c0-4.032-2.907-7.387-6.73-8.103V1.5a1.5 1.5 0 10-3 0v.879c-3.838.703-6.762 4.073-6.762 8.112 0 5.88-1.337 7.783-1.337 7.783a.77.77 0 00-.086.789c.12.257.394.428.669.428h18c.343 0 .668-.188.754-.514.086-.308 0-.617-.274-.806-.137-.171-1.235-1.731-1.235-7.68zM9.25 21.78c0-.326.21-.629.539-.729l4.405-.017c.395.12.635.532.515.943 0 0-.209 2.023-2.709 2.023s-2.726-2.023-2.726-2.023a.77.77 0 01-.025-.196z"
    }));
});



var $c3553699c81819da$var$__assign = undefined && undefined.__assign || function() {
    $c3553699c81819da$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3553699c81819da$var$__assign.apply(this, arguments);
};
var $c3553699c81819da$export$c994623dcd067c12 = $9a5d87e7a4870d4c$exports.forwardRef(function Announcement(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c3553699c81819da$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M21 3.75a.75.75 0 00-1.166-.624l-1.134.756A21.55 21.55 0 016.751 7.5H4.5a4.5 4.5 0 000 9h1.535a7.988 7.988 0 002.448 5.043.75.75 0 101.034-1.086 6.49 6.49 0 01-1.972-3.942A21.55 21.55 0 0118.7 20.118l1.134.756A.75.75 0 0021 20.25V3.75zM7.5 15.012a23.05 23.05 0 0112 3.837V5.15a23.05 23.05 0 01-12 3.837v6.024zM6 9H4.5a3 3 0 100 6H6V9z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.25 9.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }));
});



var $39a454cac71f548b$var$__assign = undefined && undefined.__assign || function() {
    $39a454cac71f548b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39a454cac71f548b$var$__assign.apply(this, arguments);
};
var $39a454cac71f548b$export$4c30be745f22bee4 = $9a5d87e7a4870d4c$exports.forwardRef(function AnnouncementBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $39a454cac71f548b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M20.604 2.589A.75.75 0 0121 3.25v16.5a.75.75 0 01-1.166.624l-1.134-.756a21.55 21.55 0 00-11.155-3.603 6.49 6.49 0 001.972 3.942.75.75 0 11-1.034 1.086A7.988 7.988 0 016.035 16V7h.716c4.253 0 8.41-1.26 11.95-3.618l1.133-.756a.75.75 0 01.77-.037zM1.318 8.318A4.5 4.5 0 014.5 7v9a4.5 4.5 0 01-3.182-7.682zm21.432.557c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z"
    }));
});



var $1a05ede52b3619cf$var$__assign = undefined && undefined.__assign || function() {
    $1a05ede52b3619cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a05ede52b3619cf$var$__assign.apply(this, arguments);
};
var $1a05ede52b3619cf$export$1fa5a43af950a186 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowDown(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1a05ede52b3619cf$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M.445 6.495a.75.75 0 011.06-.05L12 15.986l10.495-9.541a.75.75 0 011.01 1.11l-11 10a.75.75 0 01-1.01 0l-11-10a.75.75 0 01-.05-1.06z",
        fillRule: "evenodd"
    }));
});



var $b4e72cdf9dbc256d$var$__assign = undefined && undefined.__assign || function() {
    $b4e72cdf9dbc256d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4e72cdf9dbc256d$var$__assign.apply(this, arguments);
};
var $b4e72cdf9dbc256d$export$2fbb36af09846aa0 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowDownBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b4e72cdf9dbc256d$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M2.506 6.388A1.5 1.5 0 00.494 8.612l10.5 9.5a1.5 1.5 0 002.012 0l10.5-9.5a1.5 1.5 0 00-2.012-2.224L12 14.978l-9.494-8.59z"
    }));
});



var $36bf889250647b17$var$__assign = undefined && undefined.__assign || function() {
    $36bf889250647b17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36bf889250647b17$var$__assign.apply(this, arguments);
};
var $36bf889250647b17$export$e4c291d45fea4cd0 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLeft(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $36bf889250647b17$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M17.505.445a.75.75 0 01.05 1.06L8.014 12l9.541 10.495a.75.75 0 01-1.11 1.01l-10-11a.75.75 0 010-1.01l10-11a.75.75 0 011.06-.05z",
        fillRule: "evenodd"
    }));
});



var $ac257ca03c82dc0f$var$__assign = undefined && undefined.__assign || function() {
    $ac257ca03c82dc0f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ac257ca03c82dc0f$var$__assign.apply(this, arguments);
};
var $ac257ca03c82dc0f$export$ea9a5c7ec18f8eaf = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLeftBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ac257ca03c82dc0f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M17.506.388a1.5 1.5 0 01.106 2.118L9.022 12l8.59 9.494a1.5 1.5 0 01-2.224 2.012l-9.5-10.5a1.5 1.5 0 010-2.012l9.5-10.5a1.5 1.5 0 012.118-.106z",
        fillRule: "evenodd"
    }));
});



var $647e5a0736a4d582$var$__assign = undefined && undefined.__assign || function() {
    $647e5a0736a4d582$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $647e5a0736a4d582$var$__assign.apply(this, arguments);
};
var $647e5a0736a4d582$export$fb2824d245253d9b = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLongDown(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $647e5a0736a4d582$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a.75.75 0 01.75.75v19.305l6.747-6.132a.75.75 0 011.009 1.11l-8.002 7.272a.75.75 0 01-1.008 0l-8-7.27a.75.75 0 111.008-1.11l6.746 6.13V1.5A.75.75 0 0112 .75z",
        fillRule: "evenodd"
    }));
});



var $c26488d4d7ee82fe$var$__assign = undefined && undefined.__assign || function() {
    $c26488d4d7ee82fe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c26488d4d7ee82fe$var$__assign.apply(this, arguments);
};
var $c26488d4d7ee82fe$export$a2ec4c6969a7d302 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLongDownBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c26488d4d7ee82fe$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a1.5 1.5 0 011.5 1.5v17.61l5.493-4.992a1.5 1.5 0 012.017 2.22l-8 7.272a1.5 1.5 0 01-2.018 0l-8-7.27a1.5 1.5 0 012.018-2.22l5.491 4.99V1.5A1.5 1.5 0 0112 0z",
        fillRule: "evenodd"
    }));
});



var $57967474d898b0f5$var$__assign = undefined && undefined.__assign || function() {
    $57967474d898b0f5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $57967474d898b0f5$var$__assign.apply(this, arguments);
};
var $57967474d898b0f5$export$5e0a9a0faf09e20c = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLongUp(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $57967474d898b0f5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M11.496.945a.75.75 0 011.008 0l8.002 7.272a.75.75 0 11-1.009 1.11L12.75 3.195V22.5a.75.75 0 01-1.5 0V3.195l-6.746 6.13a.75.75 0 01-1.008-1.11l8-7.27z",
        fillRule: "evenodd"
    }));
});



var $964d928cc53196f2$var$__assign = undefined && undefined.__assign || function() {
    $964d928cc53196f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $964d928cc53196f2$var$__assign.apply(this, arguments);
};
var $964d928cc53196f2$export$469287007f7d4034 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowLongUpBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $964d928cc53196f2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10.991.39a1.5 1.5 0 012.018 0l8.001 7.272a1.5 1.5 0 01-2.017 2.22L13.5 4.89V22.5a1.5 1.5 0 01-3 0V4.89L5.009 9.88A1.5 1.5 0 012.99 7.66l8-7.27z",
        fillRule: "evenodd"
    }));
});



var $e7c1b98fcce7c1f4$var$__assign = undefined && undefined.__assign || function() {
    $e7c1b98fcce7c1f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e7c1b98fcce7c1f4$var$__assign.apply(this, arguments);
};
var $e7c1b98fcce7c1f4$export$acad20503ad73ac1 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowRight(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $e7c1b98fcce7c1f4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M6.495.445a.75.75 0 011.06.05l10 11a.75.75 0 010 1.01l-10 11a.75.75 0 11-1.11-1.01L15.986 12 6.445 1.505a.75.75 0 01.05-1.06z",
        fillRule: "evenodd"
    }));
});



var $01c576487ae13177$var$__assign = undefined && undefined.__assign || function() {
    $01c576487ae13177$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01c576487ae13177$var$__assign.apply(this, arguments);
};
var $01c576487ae13177$export$d6d021d74f4bac76 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowRightBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $01c576487ae13177$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.612.494a1.5 1.5 0 00-2.224 2.012L14.978 12l-8.59 9.494a1.5 1.5 0 002.224 2.012l9.5-10.5a1.5 1.5 0 000-2.012l-9.5-10.5z"
    }));
});



var $7e161e081d5b3be1$var$__assign = undefined && undefined.__assign || function() {
    $7e161e081d5b3be1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e161e081d5b3be1$var$__assign.apply(this, arguments);
};
var $7e161e081d5b3be1$export$2624c5890f1bbcf7 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowUp(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $7e161e081d5b3be1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M11.495 6.445a.75.75 0 011.01 0l11 10a.75.75 0 01-1.01 1.11L12 8.014 1.505 17.555a.75.75 0 01-1.01-1.11l11-10z",
        fillRule: "evenodd"
    }));
});



var $6c99a6d836da18a0$var$__assign = undefined && undefined.__assign || function() {
    $6c99a6d836da18a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6c99a6d836da18a0$var$__assign.apply(this, arguments);
};
var $6c99a6d836da18a0$export$b524ae00c198b715 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowUpAndDown(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6c99a6d836da18a0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.526 1.466a.75.75 0 00-1.052 0l-6.6 6.5a.75.75 0 101.052 1.068L12 3.053l6.074 5.981a.75.75 0 101.052-1.068l-6.6-6.5zm-6.6 13.5a.75.75 0 00-1.052 1.068l6.6 6.5a.75.75 0 001.052 0l6.6-6.5a.75.75 0 00-1.052-1.068L12 20.947l-6.074-5.981z"
    }));
});



var $7a69f8f669493d23$var$__assign = undefined && undefined.__assign || function() {
    $7a69f8f669493d23$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a69f8f669493d23$var$__assign.apply(this, arguments);
};
var $7a69f8f669493d23$export$61bdb2a1da0ccc8a = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowUpAndDownBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $7a69f8f669493d23$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M13.053.931a1.5 1.5 0 00-2.106 0l-6.6 6.5A1.5 1.5 0 006.453 9.57L12 4.105l5.547 5.464a1.5 1.5 0 102.106-2.138l-6.6-6.5zm-6.6 13.5a1.5 1.5 0 10-2.106 2.138l6.6 6.5a1.5 1.5 0 002.106 0l6.6-6.5a1.5 1.5 0 00-2.105-2.138L12 19.895 6.453 14.43z"
    }));
});



var $f56dfd66f318a8c5$var$__assign = undefined && undefined.__assign || function() {
    $f56dfd66f318a8c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f56dfd66f318a8c5$var$__assign.apply(this, arguments);
};
var $f56dfd66f318a8c5$export$928b9ecbfcbe86f4 = $9a5d87e7a4870d4c$exports.forwardRef(function ArrowUpBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $f56dfd66f318a8c5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10.994 5.888a1.5 1.5 0 012.012 0l10.5 9.5a1.5 1.5 0 01-2.012 2.224L12 9.022l-9.494 8.59a1.5 1.5 0 11-2.012-2.224l10.5-9.5z",
        fillRule: "evenodd"
    }));
});



var $d266f065f6451374$var$__assign = undefined && undefined.__assign || function() {
    $d266f065f6451374$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d266f065f6451374$var$__assign.apply(this, arguments);
};
var $d266f065f6451374$export$650e18e4b9cea8d1 = $9a5d87e7a4870d4c$exports.forwardRef(function Attach(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $d266f065f6451374$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M15.323 2.525c-.985.11-1.817.55-2.177.91l-8 8c-1.78 1.78-2.567 5.373 0 7.94 2.566 2.566 6.158 1.78 7.939 0l8-8a.75.75 0 011.06 1.06l-8 8c-2.22 2.22-6.771 3.289-10.06 0-3.29-3.29-2.22-7.841 0-10.06l8-8c.64-.64 1.807-1.2 3.072-1.34 1.296-.145 2.791.142 3.989 1.34 1.197 1.196 1.484 2.692 1.34 3.987-.141 1.265-.7 2.433-1.34 3.073l-8 8a3.07 3.07 0 01-1.722.824c-.755.098-1.61-.096-2.34-.824-.734-.735-.913-1.603-.811-2.356.097-.715.448-1.34.812-1.705l8-8a.75.75 0 111.06 1.06l-8 8c-.135.137-.333.462-.386.847-.047.348.023.73.387 1.093.369.37.748.441 1.085.397.374-.048.7-.242.854-.397l8-8c.36-.36.8-1.193.91-2.177.106-.955-.107-1.96-.91-2.762-.803-.803-1.807-1.016-2.762-.91z"
    }));
});



var $6115e7b28f7f91d1$var$__assign = undefined && undefined.__assign || function() {
    $6115e7b28f7f91d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6115e7b28f7f91d1$var$__assign.apply(this, arguments);
};
var $6115e7b28f7f91d1$export$50809d59c9e8104e = $9a5d87e7a4870d4c$exports.forwardRef(function AttachBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6115e7b28f7f91d1$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M15.157 3.02c-.845.094-1.51.474-1.73.695l-8 8c-1.56 1.56-2.205 4.673 0 6.879 2.206 2.205 5.318 1.56 6.879 0l8-8a1.5 1.5 0 012.121 2.12l-8 8c-2.44 2.44-7.471 3.651-11.121 0-3.65-3.65-2.44-8.681 0-11.12l8-8c.779-.78 2.114-1.4 3.52-1.556 1.466-.162 3.207.161 4.601 1.556 1.394 1.394 1.718 3.135 1.555 4.6-.156 1.406-.776 2.742-1.555 3.521l-8 8a3.818 3.818 0 01-2.155 1.038c-.965.125-2.059-.13-2.966-1.038-.92-.92-1.155-2.032-1.025-2.987.12-.88.546-1.656 1.025-2.134l8-8a1.5 1.5 0 112.121 2.12l-8 8v.002a.93.93 0 00-.173.416.504.504 0 00.012.219.59.59 0 00.161.243.63.63 0 00.253.169.468.468 0 00.206.014.861.861 0 00.42-.183l8-8c.22-.221.6-.886.694-1.73.088-.785-.089-1.543-.694-2.15-.606-.605-1.365-.781-2.149-.694z"
    }));
});



var $04fa49c36fe7f773$var$__assign = undefined && undefined.__assign || function() {
    $04fa49c36fe7f773$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04fa49c36fe7f773$var$__assign.apply(this, arguments);
};
var $04fa49c36fe7f773$export$acd2cbead02af9c1 = $9a5d87e7a4870d4c$exports.forwardRef(function BookmarkFavourite(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $04fa49c36fe7f773$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75z"
    }));
});



var $6fff1b2bac98c86f$var$__assign = undefined && undefined.__assign || function() {
    $6fff1b2bac98c86f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fff1b2bac98c86f$var$__assign.apply(this, arguments);
};
var $6fff1b2bac98c86f$export$cea5fccc97fad67f = $9a5d87e7a4870d4c$exports.forwardRef(function BookmarkFavouriteBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6fff1b2bac98c86f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5z"
    }));
});



var $06d031f0b32d05f9$var$__assign = undefined && undefined.__assign || function() {
    $06d031f0b32d05f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06d031f0b32d05f9$var$__assign.apply(this, arguments);
};
var $06d031f0b32d05f9$export$142047257e111cb6 = $9a5d87e7a4870d4c$exports.forwardRef(function BookmarkFavouriteStar(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $06d031f0b32d05f9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75zM12 4.715c.507 0 .97.285 1.199.736l1.039 2.047 1.65.001c.502-.012.965.26 1.202.694l.059.123a1.33 1.33 0 01-.298 1.468l-1.586 1.56.88 2.022a1.34 1.34 0 01-.249 1.424l-.102.1c-.432.38-1.058.44-1.548.156L12 13.778l-2.237 1.26a1.339 1.339 0 01-1.445-.064l-.111-.088a1.342 1.342 0 01-.348-1.533l.876-2.013-1.58-1.556a1.332 1.332 0 01-.349-1.344l.046-.128c.212-.506.713-.83 1.243-.817l1.667-.001 1.04-2.042c.208-.41.61-.684 1.062-.73L12 4.715zm-.001 1.688l-1.11 2.182a.75.75 0 01-.668.41L8.49 8.994l1.664 1.638a.75.75 0 01.2.726l-.038.108-.889 2.038 2.205-1.24a.75.75 0 01.636-.047l.1.048 2.203 1.242-.887-2.037a.75.75 0 01.086-.747l.076-.087 1.664-1.638-1.731.001a.75.75 0 01-.615-.32l-.054-.09L12 6.403z"
    }));
});



var $27c9c14ca287e587$var$__assign = undefined && undefined.__assign || function() {
    $27c9c14ca287e587$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27c9c14ca287e587$var$__assign.apply(this, arguments);
};
var $27c9c14ca287e587$export$848b7e76934f1777 = $9a5d87e7a4870d4c$exports.forwardRef(function BookmarkFavouriteStarBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $27c9c14ca287e587$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M21 2.25A2.25 2.25 0 0018.75 0H5.25A2.25 2.25 0 003 2.25V22.5a1.5 1.5 0 002.382 1.212l6.177-4.492a.75.75 0 01.882 0l6.177 4.492A1.5 1.5 0 0021 22.502V2.25zm-9.737 4.005c.232-.714 1.242-.714 1.474 0l.652 2.008c.004.01.013.017.024.017h2.111c.751 0 1.063.96.456 1.402l-1.708 1.24a.025.025 0 00-.01.029l.653 2.007c.232.714-.585 1.308-1.192.867l-1.708-1.241a.025.025 0 00-.03 0l-1.707 1.24c-.608.442-1.425-.152-1.193-.866l.652-2.007a.025.025 0 00-.009-.028L8.02 9.682c-.607-.441-.295-1.402.456-1.402h2.11a.026.026 0 00.025-.017l.652-2.008z",
        fillRule: "evenodd"
    }));
});



var $356eea63aae722c7$var$__assign = undefined && undefined.__assign || function() {
    $356eea63aae722c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $356eea63aae722c7$var$__assign.apply(this, arguments);
};
var $356eea63aae722c7$export$77cdf53c363a3886 = $9a5d87e7a4870d4c$exports.forwardRef(function CheckTick(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $356eea63aae722c7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M22.03 4.97a.75.75 0 010 1.06l-13 13a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l5.47 5.47L20.97 4.97a.75.75 0 011.06 0z",
        fillRule: "evenodd"
    }));
});



var $ca35121afe25890a$var$__assign = undefined && undefined.__assign || function() {
    $ca35121afe25890a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca35121afe25890a$var$__assign.apply(this, arguments);
};
var $ca35121afe25890a$export$add807e002afa321 = $9a5d87e7a4870d4c$exports.forwardRef(function CheckTickBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ca35121afe25890a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M22.56 4.44a1.5 1.5 0 010 2.12l-13 13a1.5 1.5 0 01-2.12 0l-6-6a1.5 1.5 0 012.12-2.12l4.94 4.939 11.94-11.94a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});



var $fce937ae8f8e31d0$var$__assign = undefined && undefined.__assign || function() {
    $fce937ae8f8e31d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fce937ae8f8e31d0$var$__assign.apply(this, arguments);
};
var $fce937ae8f8e31d0$export$c7c44baae9d9f25f = $9a5d87e7a4870d4c$exports.forwardRef(function Controls(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $fce937ae8f8e31d0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.246 0H.754A.761.761 0 000 .754v22.492c0 .411.343.754.754.754h22.492a.761.761 0 00.754-.754V.754A.761.761 0 0023.246 0zM1.509 22.491V1.51h21v20.98h-21z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M5.246 16.491h2.348c.343 1.286 1.509 2.246 2.897 2.246a3 3 0 002.898-2.246h5.348a.76.76 0 00.754-.754.76.76 0 00-.754-.754h-5.331a2.919 2.919 0 00-.789-1.372 2.981 2.981 0 00-2.126-.874 3 3 0 00-2.897 2.246H5.246a.76.76 0 00-.755.754.76.76 0 00.755.754zm5.245-2.245c.395 0 .772.154 1.063.445.292.292.446.652.446 1.063a1.51 1.51 0 01-1.509 1.509 1.5 1.5 0 01-1.508-1.509c.017-.823.686-1.508 1.508-1.508zM5.246 9h8.348c.343 1.286 1.509 2.246 2.897 2.246 1.646 0 3-1.337 3-3 0-1.646-1.354-3-3-3a3 3 0 00-2.897 2.245H5.246a.761.761 0 00-.755.755c0 .411.343.754.755.754zM16.49 6.754c.823 0 1.509.669 1.509 1.492a1.51 1.51 0 01-1.509 1.508A1.496 1.496 0 0115 8.246c0-.823.669-1.492 1.491-1.492z"
    }));
});



var $564ea9f970b4f9f6$var$__assign = undefined && undefined.__assign || function() {
    $564ea9f970b4f9f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $564ea9f970b4f9f6$var$__assign.apply(this, arguments);
};
var $564ea9f970b4f9f6$export$281a0dedb095a201 = $9a5d87e7a4870d4c$exports.forwardRef(function ControlsBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $564ea9f970b4f9f6$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M.754 0h22.492c.411 0 .754.343.754.754v22.492a.761.761 0 01-.754.754H.754A.761.761 0 010 23.246V.754C0 .343.343 0 .754 0zm12.652 7.241a3.25 3.25 0 013.085-2.245 3.264 3.264 0 013.25 3.25 3.253 3.253 0 01-3.25 3.25c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.455-1.005-1.004 0-.55.455-1.005 1.005-1.005h8.16zm-6 7.492a3.25 3.25 0 013.085-2.246c.87 0 1.688.334 2.3.946.383.366.645.818.801 1.3h5.145c.55 0 1.004.455 1.004 1.004a1.01 1.01 0 01-1.004 1.004h-5.16a3.25 3.25 0 01-3.086 2.246c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.454-1.005-1.004s.455-1.004 1.005-1.004h2.16z",
        fillRule: "evenodd"
    }));
});



var $77e0e75571c47de0$var$__assign = undefined && undefined.__assign || function() {
    $77e0e75571c47de0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $77e0e75571c47de0$var$__assign.apply(this, arguments);
};
var $77e0e75571c47de0$export$3c877bb842c36952 = $9a5d87e7a4870d4c$exports.forwardRef(function Cross(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $77e0e75571c47de0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M2.53 1.47a.75.75 0 00-1.06 1.06L10.94 12l-9.47 9.47a.75.75 0 101.06 1.06L12 13.06l9.47 9.47a.75.75 0 101.06-1.06L13.06 12l9.47-9.47a.75.75 0 00-1.06-1.06L12 10.94 2.53 1.47z"
    }));
});



var $ea57c3c51f0db820$var$__assign = undefined && undefined.__assign || function() {
    $ea57c3c51f0db820$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea57c3c51f0db820$var$__assign.apply(this, arguments);
};
var $ea57c3c51f0db820$export$44fbda67c66d275 = $9a5d87e7a4870d4c$exports.forwardRef(function CrossBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ea57c3c51f0db820$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M3.06.94A1.5 1.5 0 10.94 3.06L9.878 12l-8.94 8.94a1.5 1.5 0 002.122 2.12L12 14.122l8.94 8.94a1.5 1.5 0 002.12-2.122L14.122 12l8.94-8.94A1.5 1.5 0 0020.939.94L12 9.878 3.06.939z"
    }));
});



var $e733bb8d61de2077$var$__assign = undefined && undefined.__assign || function() {
    $e733bb8d61de2077$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e733bb8d61de2077$var$__assign.apply(this, arguments);
};
var $e733bb8d61de2077$export$fe82a520fc33e5f4 = $9a5d87e7a4870d4c$exports.forwardRef(function Dashboard(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $e733bb8d61de2077$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm-2 .5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm4-.5a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5zM15 0a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm7 1.5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM11 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4zm-2 .5H2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5z",
        fillRule: "evenodd"
    }));
});



var $4442996ec263fcee$var$__assign = undefined && undefined.__assign || function() {
    $4442996ec263fcee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4442996ec263fcee$var$__assign.apply(this, arguments);
};
var $4442996ec263fcee$export$735b4219f406972d = $9a5d87e7a4870d4c$exports.forwardRef(function DashboardBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4442996ec263fcee$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm2 0a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-12a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm-4 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4z",
        fillRule: "evenodd"
    }));
});



var $d3bfca1a845df749$var$__assign = undefined && undefined.__assign || function() {
    $d3bfca1a845df749$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d3bfca1a845df749$var$__assign.apply(this, arguments);
};
var $d3bfca1a845df749$export$6341f9a885713487 = $9a5d87e7a4870d4c$exports.forwardRef(function Date(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $d3bfca1a845df749$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.427 3.813h-3.552V1.707A.713.713 0 0017.168 1a.713.713 0 00-.707.707v2.106H8.039V1.707A.713.713 0 007.332 1a.713.713 0 00-.707.707v2.106H3.073A2.078 2.078 0 001 5.886v15.557c0 1.14.932 2.073 2.073 2.073h18.354a2.078 2.078 0 002.073-2.073V5.886a2.078 2.078 0 00-2.073-2.074zM3.073 5.21h3.552v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h8.438v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h3.552c.37 0 .659.305.659.659v3.55H2.414V5.886c0-.37.29-.675.66-.675zm18.354 16.875H3.073a.662.662 0 01-.659-.66v-10.59h19.688v10.59a.676.676 0 01-.675.66z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M6.271 15.063a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.049 2.812h-.097a1.066 1.066 0 00-.996 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.084 1.084 0 00-1.028-1.045zm5.93-2.812a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.048 2.812h-.112a1.066 1.066 0 00-.997 1.045 1.06 1.06 0 102.122 0c0-.563-.45-1.013-1.013-1.045zm5.995-4.918h-.097a1.058 1.058 0 00-1.012 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.081 1.081 0 00-1.012-1.045zm-.064 4.918h-.017c-.578 0-1.044.482-1.044 1.06 0 .58.466 1.061 1.06 1.061a1.05 1.05 0 001.061-1.06 1.07 1.07 0 00-1.06-1.061z"
    }));
});



var $1b67cf84e0b7a02e$var$__assign = undefined && undefined.__assign || function() {
    $1b67cf84e0b7a02e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b67cf84e0b7a02e$var$__assign.apply(this, arguments);
};
var $1b67cf84e0b7a02e$export$6cbcb5cd862c2b93 = $9a5d87e7a4870d4c$exports.forwardRef(function DateBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1b67cf84e0b7a02e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M6.271 12.566a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm5.979 0a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm6.054.016h-.128c-.75.043-1.367.646-1.367 1.42 0 .782.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.435v-.011a1.456 1.456 0 00-1.365-1.408h-.011zM6.33 17.5h-.128c-.74.044-1.35.67-1.35 1.42 0 .781.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.436v-.01A1.459 1.459 0 006.341 17.5h-.01zm5.979 0h-.145c-.74.044-1.35.67-1.35 1.42a1.435 1.435 0 102.872 0c0-.774-.618-1.377-1.366-1.42h-.011zm5.903 0c-.793 0-1.42.657-1.42 1.436 0 .782.631 1.435 1.437 1.435.801 0 1.435-.634 1.435-1.435 0-.786-.65-1.436-1.435-1.436h-.017z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M7.332.625c-.593 0-1.082.49-1.082 1.082v1.73H3.073A2.453 2.453 0 00.625 5.886v15.557c0 1.348 1.1 2.448 2.448 2.448h18.354c1.348 0 2.448-1.1 2.448-2.448V5.886c0-1.348-1.1-2.449-2.448-2.449H18.25v-1.73c0-.593-.49-1.082-1.082-1.082-.593 0-1.082.49-1.082 1.082v1.73H8.414v-1.73c0-.593-.489-1.082-1.082-1.082zM2.79 21.427V11.21h18.938v10.206a.3.3 0 01-.3.294H3.073a.287.287 0 01-.284-.284z",
        fillRule: "evenodd"
    }));
});



var $6b0eb423d4a798e2$var$__assign = undefined && undefined.__assign || function() {
    $6b0eb423d4a798e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b0eb423d4a798e2$var$__assign.apply(this, arguments);
};
var $6b0eb423d4a798e2$export$bfadae053a633538 = $9a5d87e7a4870d4c$exports.forwardRef(function Delete(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6b0eb423d4a798e2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M9.827 10.077a.75.75 0 01.75.75v6.461a.75.75 0 01-1.5 0v-6.461a.75.75 0 01.75-.75zm5.596.75a.75.75 0 00-1.5 0v6.461a.75.75 0 001.5 0v-6.461z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M9.827 2A2.365 2.365 0 007.46 4.365v.866H1.75a.75.75 0 000 1.5h2.481v13.788a2.365 2.365 0 002.365 2.366h11.308a2.365 2.365 0 002.365-2.366V6.731h2.481a.75.75 0 000-1.5h-5.712v-.866A2.365 2.365 0 0014.673 2H9.827zM8.198 6.73h8.09a.74.74 0 00.014 0h2.467v13.79a.866.866 0 01-.865.864H6.596a.865.865 0 01-.865-.865V6.731h2.467zm7.34-1.5v-.865a.865.865 0 00-.865-.865H9.827a.865.865 0 00-.866.865v.866h6.577z",
        fillRule: "evenodd"
    }));
});



var $364dfe7347489774$var$__assign = undefined && undefined.__assign || function() {
    $364dfe7347489774$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $364dfe7347489774$var$__assign.apply(this, arguments);
};
var $364dfe7347489774$export$8d5b5b936cb45ab2 = $9a5d87e7a4870d4c$exports.forwardRef(function DeleteBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $364dfe7347489774$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M9.577 1A3.115 3.115 0 006.46 4.115v.116H1.5a1.5 1.5 0 000 3h1.731v13.038a3.116 3.116 0 003.115 3.116h11.308a3.115 3.115 0 003.115-3.116V7.231H22.5a1.5 1.5 0 000-3h-4.962v-.116A3.116 3.116 0 0014.423 1H9.577zm0 8.077a1.5 1.5 0 011.5 1.5v6.461a1.5 1.5 0 01-3 0v-6.461a1.5 1.5 0 011.5-1.5zm6.346 1.5a1.5 1.5 0 10-3 0v6.461a1.5 1.5 0 003 0v-6.461z",
        fillRule: "evenodd"
    }));
});



var $39fdfa896770cc91$var$__assign = undefined && undefined.__assign || function() {
    $39fdfa896770cc91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39fdfa896770cc91$var$__assign.apply(this, arguments);
};
var $39fdfa896770cc91$export$4a82481d9e63c9e1 = $9a5d87e7a4870d4c$exports.forwardRef(function Duplicate(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $39fdfa896770cc91$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M2 4.251A2.251 2.251 0 014.25 2H16.5a2 2 0 012 2A.75.75 0 0117 4a.5.5 0 00-.5-.5H4.25a.751.751 0 00-.75.751V16.5a.5.5 0 00.5.5.75.75 0 010 1.5 2 2 0 01-2-2V4.251z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M20 7.5H8a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2H8z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M14 10.45a.75.75 0 01.75.75v2.05h2.05a.75.75 0 010 1.5h-2.05v2.05a.75.75 0 11-1.5 0v-2.05H11.2a.75.75 0 110-1.5h2.05V11.2a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    }));
});



var $efb84add33b88073$var$__assign = undefined && undefined.__assign || function() {
    $efb84add33b88073$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efb84add33b88073$var$__assign.apply(this, arguments);
};
var $efb84add33b88073$export$7791901baee658a0 = $9a5d87e7a4870d4c$exports.forwardRef(function DuplicateBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $efb84add33b88073$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M1.25 4.251a3.001 3.001 0 013-3.001H16.5A2.75 2.75 0 0119.25 4a1.5 1.5 0 01-2.98.25H4.25v12.021A1.5 1.5 0 014 19.25a2.75 2.75 0 01-2.75-2.75V4.251z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M8.5 6.5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-12a2 2 0 00-2-2h-12zm7 5.2a1 1 0 00-2 0v1.8h-1.8a1 1 0 000 2h1.8v1.8a1 1 0 102 0v-1.8h1.8a1 1 0 100-2h-1.8v-1.8z",
        fillRule: "evenodd"
    }));
});



var $a538a455bab1af32$var$__assign = undefined && undefined.__assign || function() {
    $a538a455bab1af32$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a538a455bab1af32$var$__assign.apply(this, arguments);
};
var $a538a455bab1af32$export$6ed0965c9443aaa6 = $9a5d87e7a4870d4c$exports.forwardRef(function Edit(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $a538a455bab1af32$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01-.04 6.231l-.41.411-.001.001-14.08 14.08-.005.005a.75.75 0 01-.344.196l-6.906 1.77a.75.75 0 01-.912-.913l1.77-6.904a.75.75 0 01.196-.344v-.001L16.486 1.318A4.388 4.388 0 0119.592 0zM2.921 17.802l-1.13 4.406 4.41-1.13-3.28-3.276zm4.738 2.612l-4.077-4.07L16.605 3.32l4.074 4.074-13.02 13.02zM22.27 5.507a2.85 2.85 0 01-.531.825l-4.07-4.07a2.89 2.89 0 013.991.079 2.887 2.887 0 01.61 3.166z",
        fillRule: "evenodd"
    }));
});



var $032cdd77d129843c$var$__assign = undefined && undefined.__assign || function() {
    $032cdd77d129843c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $032cdd77d129843c$var$__assign.apply(this, arguments);
};
var $032cdd77d129843c$export$680fa2622ca83bb7 = $9a5d87e7a4870d4c$exports.forwardRef(function EditBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $032cdd77d129843c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01.076 6.115 1.017 1.017 0 00-.09-.103l-6-6a1.014 1.014 0 00-.104-.09A4.388 4.388 0 0119.593 0zm1.701 8.707a.962.962 0 00.103.09L9.304 20.89 3.11 14.695 15.201 2.603a.993.993 0 00.092.104l6 6zm-19.509 7.49l-1.76 6.866a.75.75 0 00.912.913l6.865-1.76-6.017-6.019z"
    }));
});



var $29071bcb088b9a6b$var$__assign = undefined && undefined.__assign || function() {
    $29071bcb088b9a6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29071bcb088b9a6b$var$__assign.apply(this, arguments);
};
var $29071bcb088b9a6b$export$4c6ac753363de59f = $9a5d87e7a4870d4c$exports.forwardRef(function EditFile(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $29071bcb088b9a6b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M13.755 14.775l7.904-7.904a.812.812 0 00.032-.031l.974-.975a2.852 2.852 0 00-.924-4.648 2.85 2.85 0 00-3.107.618l-8.91 8.91a.75.75 0 00-.211.424l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212zM20.65 2.5a1.35 1.35 0 00-.955.395l-.46.46 1.91 1.91.46-.46A1.35 1.35 0 0020.65 2.5zm-9.688 9.128l7.213-7.212 1.909 1.909-7.213 7.213-2.227.318.318-2.228z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M2.69 6.892a.65.65 0 01.46-.19h7a.75.75 0 000-1.5h-7A2.15 2.15 0 001 7.351v14a2.15 2.15 0 002.15 2.15h14a2.15 2.15 0 002.15-2.15v-7a.75.75 0 00-1.5 0v7a.65.65 0 01-.65.65h-14a.65.65 0 01-.65-.65v-14a.65.65 0 01.19-.46z"
    }));
});



var $c2a53a150b389268$var$__assign = undefined && undefined.__assign || function() {
    $c2a53a150b389268$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2a53a150b389268$var$__assign.apply(this, arguments);
};
var $c2a53a150b389268$export$b78ec286cc721c36 = $9a5d87e7a4870d4c$exports.forwardRef(function EditFileBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c2a53a150b389268$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M3 6.451h6.9a1.5 1.5 0 100-3h-7a2.9 2.9 0 00-2.9 2.9v14a2.9 2.9 0 002.9 2.9h14a2.9 2.9 0 002.9-2.9v-7a1.5 1.5 0 10-3 0v6.9H3v-13.8z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.722 5.558a.772.772 0 00-.015-.015l-4.015-4.015.692-.693a2.85 2.85 0 014.031 4.03l-.693.693zm-1.414 1.414a1.652 1.652 0 01-.015-.015l-4.015-4.015-6.803 6.802a.75.75 0 00-.212.425l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212l6.803-6.803z"
    }));
});



var $93ea2f83680422ec$var$__assign = undefined && undefined.__assign || function() {
    $93ea2f83680422ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $93ea2f83680422ec$var$__assign.apply(this, arguments);
};
var $93ea2f83680422ec$export$49bd1dfb0ad29c40 = $9a5d87e7a4870d4c$exports.forwardRef(function Expand(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $93ea2f83680422ec$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.746 3.806v4.69a.75.75 0 001.5 0v-6.5a.747.747 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-7.22 7.22a.75.75 0 101.06 1.06l7.22-7.22zM1.996 14.974a.75.75 0 01.75.75v4.689l7.22-7.22a.75.75 0 011.06 1.061l-7.22 7.22h4.69a.75.75 0 110 1.5h-6.5a.746.746 0 01-.679-.43.747.747 0 01-.071-.32v-6.5a.75.75 0 01.75-.75z"
    }));
});



var $0e2f29acd04a08de$var$__assign = undefined && undefined.__assign || function() {
    $0e2f29acd04a08de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e2f29acd04a08de$var$__assign.apply(this, arguments);
};
var $0e2f29acd04a08de$export$6b5ba4345fea866a = $9a5d87e7a4870d4c$exports.forwardRef(function ExpandBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $0e2f29acd04a08de$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M20.996 8.496a1.5 1.5 0 003 0v-6.5a1.496 1.496 0 00-1.5-1.5h-6.5a1.5 1.5 0 000 3h2.879l-5.94 5.94a1.5 1.5 0 102.121 2.12l5.94-5.939v2.879zm-19 5.728a1.5 1.5 0 011.5 1.5v2.878l5.94-5.939a1.5 1.5 0 112.12 2.121l-5.939 5.94h2.879a1.5 1.5 0 110 3h-6.5a1.494 1.494 0 01-1.374-.897 1.495 1.495 0 01-.126-.603v-6.5a1.5 1.5 0 011.5-1.5z"
    }));
});



var $99ff5506e320c50a$var$__assign = undefined && undefined.__assign || function() {
    $99ff5506e320c50a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $99ff5506e320c50a$var$__assign.apply(this, arguments);
};
var $99ff5506e320c50a$export$7562e752e5ef1fad = $9a5d87e7a4870d4c$exports.forwardRef(function Faq(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $99ff5506e320c50a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M11.325 11.46h1.227c-.037-.166-.091-.367-.091-.587 0-.659.494-1.117 1.3-1.85 1.025-.915 1.739-1.738 1.739-2.965C15.5 4.263 14.053 3 12.277 3c-1.61 0-2.8.934-3.277 2.563l1.19.495c.366-1.172 1.117-1.758 2.05-1.758.99 0 1.795.75 1.795 1.85 0 .896-.512 1.39-1.428 2.251-.787.696-1.465 1.337-1.465 2.252 0 .293.074.586.183.806zm.696 4.027c.641 0 1.172-.476 1.172-1.153 0-.678-.531-1.154-1.172-1.154-.604 0-1.153.476-1.153 1.154 0 .677.549 1.153 1.153 1.153z"
    }));
});



var $834923420675fef7$var$__assign = undefined && undefined.__assign || function() {
    $834923420675fef7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $834923420675fef7$var$__assign.apply(this, arguments);
};
var $834923420675fef7$export$b995d600f3ba41d6 = $9a5d87e7a4870d4c$exports.forwardRef(function FaqBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $834923420675fef7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25zm10.759 11.094h-1.88a1.996 1.996 0 01-.182-.792c0-.66.495-1.22 1.303-1.864.676-.561.973-.858.973-1.386 0-.594-.462-1.006-1.039-1.006-.61 0-1.056.429-1.37 1.253L9 6.508C9.478 4.825 10.7 4 12.25 4c1.798 0 3.25 1.138 3.25 2.887 0 .973-.462 1.617-1.37 2.409l-.176.153c-.57.495-.978.849-.978 1.299 0 .131.016.247.033.346zm.66 2.656c0 .874-.66 1.534-1.535 1.534-.89 0-1.55-.66-1.55-1.534 0-.858.66-1.534 1.55-1.534a1.51 1.51 0 011.535 1.534z",
        fillRule: "evenodd"
    }));
});



var $6a03e47f738f415f$var$__assign = undefined && undefined.__assign || function() {
    $6a03e47f738f415f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a03e47f738f415f$var$__assign.apply(this, arguments);
};
var $6a03e47f738f415f$export$ec91da630f36d5ea = $9a5d87e7a4870d4c$exports.forwardRef(function Filter(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6a03e47f738f415f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08zm-9.497 10.525a.754.754 0 00-.6.737v7.372l-3 2.503V12.29a.754.754 0 00-.6-.737c-4.594-.943-8.04-4.868-8.383-9.531H22.44c-.326 4.663-3.771 8.588-8.366 9.531z"
    }));
});



var $f6c9ba16608198e3$var$__assign = undefined && undefined.__assign || function() {
    $f6c9ba16608198e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6c9ba16608198e3$var$__assign.apply(this, arguments);
};
var $f6c9ba16608198e3$export$12f6556880dd4f70 = $9a5d87e7a4870d4c$exports.forwardRef(function FilterBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $f6c9ba16608198e3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08z"
    }));
});



var $0d1c529793d3f864$var$__assign = undefined && undefined.__assign || function() {
    $0d1c529793d3f864$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d1c529793d3f864$var$__assign.apply(this, arguments);
};
var $0d1c529793d3f864$export$b94310965bed44e6 = $9a5d87e7a4870d4c$exports.forwardRef(function Home(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $0d1c529793d3f864$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M4.516 13.37c.388 0 .703.316.703.704v7.031h4.218v-4.922a2.11 2.11 0 012.11-2.11h1.406a2.11 2.11 0 012.11 2.11v4.922h4.218v-7.031a.703.703 0 011.407 0v7.734a.703.703 0 01-.704.703H14.36a.703.703 0 01-.703-.703v-5.625a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v5.625a.703.703 0 01-.703.703H4.516a.703.703 0 01-.704-.703v-7.734c0-.389.315-.703.704-.703z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12.25 3.406a.703.703 0 00-.497.206L2.2 13.165a.703.703 0 11-.994-.995l9.552-9.552a2.11 2.11 0 012.984 0l9.552 9.552a.703.703 0 01-.994.995l-9.553-9.553a.703.703 0 00-.497-.206z",
        fillRule: "evenodd"
    }));
});



var $405940daa7187933$var$__assign = undefined && undefined.__assign || function() {
    $405940daa7187933$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $405940daa7187933$var$__assign.apply(this, arguments);
};
var $405940daa7187933$export$611e0072bc063769 = $9a5d87e7a4870d4c$exports.forwardRef(function HomeBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $405940daa7187933$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.25 1.625a2.484 2.484 0 00-1.757.728L.94 11.905a1.078 1.078 0 001.524 1.525l9.553-9.553a.329.329 0 01.464 0l9.553 9.553a1.078 1.078 0 001.524-1.525l-9.552-9.552a2.484 2.484 0 00-1.757-.728z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M4.516 12.996c-.596 0-1.079.482-1.079 1.078v7.734c0 .596.483 1.078 1.079 1.078h5.625c.595 0 1.078-.482 1.078-1.078v-5.625a.328.328 0 01.328-.328h1.406a.328.328 0 01.328.328v5.625c0 .596.483 1.078 1.078 1.078h5.625c.596 0 1.078-.482 1.078-1.078v-7.734a1.078 1.078 0 10-2.156 0v6.656h-3.468v-4.547a2.484 2.484 0 00-2.485-2.484h-1.406a2.484 2.484 0 00-2.485 2.484v4.547H5.595v-6.656c0-.596-.483-1.078-1.078-1.078z"
    }));
});



var $3b6dd9ea352b3471$var$__assign = undefined && undefined.__assign || function() {
    $3b6dd9ea352b3471$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b6dd9ea352b3471$var$__assign.apply(this, arguments);
};
var $3b6dd9ea352b3471$export$4574c7fd55cd3f3 = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutDiagram(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $3b6dd9ea352b3471$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-3v3H18a2.25 2.25 0 012.25 2.25V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75h3v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 01.75 15h3v-.75A2.25 2.25 0 016 12h5.25V9h-3a.75.75 0 01-.75-.75V.75zM15 7.5v-6H9v6h6zm-13.5 9h6v6h-6v-6zm15 6v-6h6v6h-6z",
        fillRule: "evenodd"
    }));
});



var $5eb21a27ee458926$var$__assign = undefined && undefined.__assign || function() {
    $5eb21a27ee458926$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5eb21a27ee458926$var$__assign.apply(this, arguments);
};
var $5eb21a27ee458926$export$24a3cfb04e7f826e = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutDiagramBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $5eb21a27ee458926$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.25 0a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h2.625v2.625H6a2.625 2.625 0 00-2.625 2.625V15H.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H5.625v-.75A.375.375 0 016 13.875h12a.375.375 0 01.375.375V15H15.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-2.625v-.75A2.625 2.625 0 0018 11.625h-4.875V9h2.625a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-7.5z"
    }));
});



var $6e6136474fe21ec9$var$__assign = undefined && undefined.__assign || function() {
    $6e6136474fe21ec9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e6136474fe21ec9$var$__assign.apply(this, arguments);
};
var $6e6136474fe21ec9$export$f90ad0f3c590b2cb = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutGridView(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6e6136474fe21ec9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9A.75.75 0 010 9.75v-9zm1.5.75V9H9V1.5H1.5zM0 14.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75v7.5H9V15H1.5zM13.5.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75V9h7.5V1.5H15zm-1.5 12.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM15 15v7.5h7.5V15H15z",
        fillRule: "evenodd"
    }));
});



var $61ed6a9e013c3205$var$__assign = undefined && undefined.__assign || function() {
    $61ed6a9e013c3205$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61ed6a9e013c3205$var$__assign.apply(this, arguments);
};
var $61ed6a9e013c3205$export$3eb98c9b2991c13c = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutGridViewBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $61ed6a9e013c3205$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM13.5.773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9z",
        fillRule: "evenodd"
    }));
});



var $1b0df93bf581b52a$var$__assign = undefined && undefined.__assign || function() {
    $1b0df93bf581b52a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b0df93bf581b52a$var$__assign.apply(this, arguments);
};
var $1b0df93bf581b52a$export$b73dd58f0dc7b9ee = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutList(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1b0df93bf581b52a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M3.66 2a2.66 2.66 0 100 5.32 2.66 2.66 0 000-5.32zm-.482 1.496a1.26 1.26 0 11.964 2.328 1.26 1.26 0 01-.964-2.328zM3.66 9.84a2.66 2.66 0 100 5.318 2.66 2.66 0 000-5.318zm-.482 1.496a1.26 1.26 0 11.964 2.329 1.26 1.26 0 01-.964-2.33zm-.536 6.546a2.661 2.661 0 013.475 3.476 2.66 2.66 0 11-3.475-3.476zM3.66 19.08a1.258 1.258 0 00-.891 2.15 1.26 1.26 0 10.891-2.15z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.233 4.613a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233zm-.7 8.54a.7.7 0 01.7-.7H21.3a.7.7 0 110 1.4H8.233a.7.7 0 01-.7-.7zm.7 7.14a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233z"
    }));
});



var $3648c7f08eb37cf2$var$__assign = undefined && undefined.__assign || function() {
    $3648c7f08eb37cf2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3648c7f08eb37cf2$var$__assign.apply(this, arguments);
};
var $3648c7f08eb37cf2$export$8c8aefe5a4ba5254 = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutListBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $3648c7f08eb37cf2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M3.13 1a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm0 8.018a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm-1.198 8.256a3.13 3.13 0 013.41 5.105 3.13 3.13 0 11-3.41-5.105zM8.761 3.298a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761zm-1.5 9.518a1.5 1.5 0 011.5-1.5h13.364a1.5 1.5 0 110 3H8.761a1.5 1.5 0 01-1.5-1.5zm1.5 6.518a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761z"
    }));
});



var $c371ff412415f1a3$var$__assign = undefined && undefined.__assign || function() {
    $c371ff412415f1a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c371ff412415f1a3$var$__assign.apply(this, arguments);
};
var $c371ff412415f1a3$export$d57cd6dbf45f4bdf = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutListView(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c371ff412415f1a3$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm1.5.75v3h21v-3h-21zM0 9.75A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21zM0 18.75A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21z",
        fillRule: "evenodd"
    }));
});



var $1cb79de56b1e282f$var$__assign = undefined && undefined.__assign || function() {
    $1cb79de56b1e282f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1cb79de56b1e282f$var$__assign.apply(this, arguments);
};
var $1cb79de56b1e282f$export$faa3c8ce2462319b = $9a5d87e7a4870d4c$exports.forwardRef(function LayoutListViewBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1cb79de56b1e282f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm0 9A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm0 9A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5z",
        fillRule: "evenodd"
    }));
});



var $c7548c40ea503477$var$__assign = undefined && undefined.__assign || function() {
    $c7548c40ea503477$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7548c40ea503477$var$__assign.apply(this, arguments);
};
var $c7548c40ea503477$export$5047665d7d511e82 = $9a5d87e7a4870d4c$exports.forwardRef(function LevelIndicator(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c7548c40ea503477$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12 3.771a11.961 11.961 0 00-8.52 3.6A12.054 12.054 0 000 15.943v2.074a2.253 2.253 0 002.246 2.245h19.508A2.253 2.253 0 0024 18.017v-2.074c.05-6.653-5.332-12.12-12-12.173zm-.017 12.754h.034a2.25 2.25 0 012.229 2.246H9.754a2.25 2.25 0 012.229-2.246zm10.525 1.492a.761.761 0 01-.754.754h-6c0-1.714-1.166-3.171-2.76-3.617l1.972-5.897a.736.736 0 00-.48-.943.736.736 0 00-.943.48l-2.092 6.274a3.761 3.761 0 00-3.188 3.703h-6a.761.761 0 01-.754-.754v-2.074A10.535 10.535 0 014.56 8.434 10.389 10.389 0 0112 5.28c5.828.034 10.543 4.817 10.508 10.663v2.074z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M4.869 16.525a1.131 1.131 0 100-2.262 1.131 1.131 0 000 2.262zm1.508-6a1.13 1.13 0 100 2.263 1.12 1.12 0 001.132-1.131 1.13 1.13 0 00-1.132-1.132zm12.754 6a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm-.377-4.868c0-.6-.48-1.097-1.08-1.114h-.12a1.138 1.138 0 00-1.063 1.114 1.13 1.13 0 102.263 0zM9.429 7.526c-.018 0-.018 0 0 0h-.12A1.138 1.138 0 008.246 8.64a1.13 1.13 0 001.131 1.13 1.12 1.12 0 001.131-1.131c0-.6-.497-1.097-1.08-1.114z"
    }));
});



var $c6f9d34f91dec039$var$__assign = undefined && undefined.__assign || function() {
    $c6f9d34f91dec039$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6f9d34f91dec039$var$__assign.apply(this, arguments);
};
var $c6f9d34f91dec039$export$b0288941685426f5 = $9a5d87e7a4870d4c$exports.forwardRef(function LevelIndicatorBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c6f9d34f91dec039$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12 4C8.8 4 5.7 5.3 3.5 7.6 1.2 9.9 0 12.9 0 16.2v2.1c0 1.2 1 2.2 2.2 2.2h5.6c.5 0 .4-1 .4-1.5 0-1.9 1.4-3.4 3.2-3.7L13.5 9c.1-.4.5-.6.9-.5.4.1.6.5.5.9l-2 5.9c1.4.4 2.4 1.5 2.7 2.9 0 .2.1.5.1.7 0 .5-.3 1.5.5 1.5h5.5c1.2 0 2.2-1 2.2-2.2v-2.1C24.1 9.5 18.7 4.1 12 4zm7 7.9c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.3 1.3-1.4h.1c.8 0 1.4.7 1.4 1.4zm.1 5.1c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM7 13.1c-.2.1-.4.2-.6.2-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.2 0 .4.1.6.2.4.2.8.7.8 1.2s-.3 1-.8 1.2zm-2.1 1.1c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.7.6-1.4 1.4-1.4zm4.5-4c-.8 0-1.4-.6-1.4-1.3 0-.2.1-.4.2-.6.2-.4.6-.7 1.1-.7h.1c.5 0 .9.3 1.2.7.1.2.2.4.2.6 0 .7-.7 1.3-1.4 1.3z"
    }));
});



var $dd74a777b803ea43$var$__assign = undefined && undefined.__assign || function() {
    $dd74a777b803ea43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd74a777b803ea43$var$__assign.apply(this, arguments);
};
var $dd74a777b803ea43$export$a6c7ac8248d6e38a = $9a5d87e7a4870d4c$exports.forwardRef(function Link(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $dd74a777b803ea43$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M22.2 4.3c-.9-.9-2-1.3-3.2-1.3-1.2 0-2.4.5-3.2 1.3-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0 1.2-1.2 3.2-1.2 4.4 0 .4.6.7 1.4.7 2.2 0 .8-.3 1.6-.9 2.2l-5.6 5.6c-.5.5-1.3.9-2.1.9s-1.5-.2-2.1-.7c-.6-.5-1-1.2-1.1-2 0-.8.2-1.6.6-2.2.2-.3.2-.8-.2-1-.3-.2-.8-.2-1 .2-.7.9-1 2.1-.8 3.2.1 1.1.7 2.2 1.6 2.9.8.7 1.9 1.1 3 1.1h.2c1.2 0 2.2-.5 3.1-1.3l5.6-5.6c.9-.9 1.3-2 1.3-3.2 0-1.2-.6-2.5-1.4-3.4z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M7.8 17.8c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2L9 7.8c.5-.5 1.3-.8 2-.9.8 0 1.5.2 2.1.7.6.5 1 1.2 1.1 2 .1.8-.1 1.5-.6 2.2-.2.3-.2.8.2 1 .3.2.8.2 1-.2.7-.9 1-2.1.8-3.2-.1-1.1-.7-2.2-1.6-2.9-.9-.8-2-1.1-3.2-1.1-1 .1-2.1.6-2.9 1.4l-5.6 5.6c-.9.9-1.3 2-1.3 3.2 0 1.2.5 2.4 1.3 3.2.9.9 2 1.3 3.2 1.3 1.2 0 2.4-.5 3.2-1.3.3-.3.3-.8 0-1.1-.3-.3-.6-.2-.9.1z"
    }));
});



var $3e9a6a6c870a088e$var$__assign = undefined && undefined.__assign || function() {
    $3e9a6a6c870a088e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3e9a6a6c870a088e$var$__assign.apply(this, arguments);
};
var $3e9a6a6c870a088e$export$6343830e6ea0f555 = $9a5d87e7a4870d4c$exports.forwardRef(function LinkBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $3e9a6a6c870a088e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M17.02 6.183a2.331 2.331 0 113.297 3.297l-5.588 5.588a2.332 2.332 0 01-3.536-3.018 1.5 1.5 0 00-2.426-1.764 5.332 5.332 0 008.085 6.902l5.586-5.586a5.331 5.331 0 10-7.54-7.54 1.5 1.5 0 102.122 2.12z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M6.98 17.506a2.332 2.332 0 01-3.297-3.298L9.27 8.62a2.332 2.332 0 013.536 3.019 1.5 1.5 0 002.426 1.764A5.331 5.331 0 007.148 6.5l-5.586 5.587a5.332 5.332 0 007.54 7.54 1.5 1.5 0 10-2.122-2.121z"
    }));
});



var $e757226605aed43f$var$__assign = undefined && undefined.__assign || function() {
    $e757226605aed43f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e757226605aed43f$var$__assign.apply(this, arguments);
};
var $e757226605aed43f$export$5b9db7ce80343746 = $9a5d87e7a4870d4c$exports.forwardRef(function Lock(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $e757226605aed43f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.75 14a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M6 6v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V8.75a.75.75 0 00-.75-.75H18V6A6 6 0 106 6zm6-4.5A4.5 4.5 0 007.5 6v2h9V6A4.5 4.5 0 0012 1.5zm-7.5 8h15v12h-15v-12z",
        fillRule: "evenodd"
    }));
});



var $84844c5dce0a1d0f$var$__assign = undefined && undefined.__assign || function() {
    $84844c5dce0a1d0f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84844c5dce0a1d0f$var$__assign.apply(this, arguments);
};
var $84844c5dce0a1d0f$export$4038de8e7cd615d7 = $9a5d87e7a4870d4c$exports.forwardRef(function LockBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $84844c5dce0a1d0f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .625A6.375 6.375 0 005.625 7v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-1.875V7A6.375 6.375 0 0012 .625zM16.125 7v2h-8.25V7a4.125 4.125 0 018.25 0zm-5.25 8a1.125 1.125 0 012.25 0v3a1.125 1.125 0 01-2.25 0v-3z",
        fillRule: "evenodd"
    }));
});



var $435b0806f4b54acd$var$__assign = undefined && undefined.__assign || function() {
    $435b0806f4b54acd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $435b0806f4b54acd$var$__assign.apply(this, arguments);
};
var $435b0806f4b54acd$export$88195aaac9f90319 = $9a5d87e7a4870d4c$exports.forwardRef(function LogIn(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $435b0806f4b54acd$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M20.727 1.393h.037a2.09 2.09 0 011.985 2.165v16.769a2.09 2.09 0 01-2.022 2.164H9.235a2.09 2.09 0 01-1.985-2.164v-4.185a.75.75 0 011.5 0v4.2l-.001.033a.591.591 0 00.546.616h11.409a.591.591 0 00.545-.65V3.509a.59.59 0 00-.545-.615H9.295a.591.591 0 00-.545.65v4.2a.75.75 0 01-1.5 0V3.557a2.091 2.091 0 012.023-2.165h11.454z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.169 7.916a.75.75 0 000 1.06l2.22 2.22H1.5a.75.75 0 000 1.5h12.888l-2.22 2.22a.75.75 0 001.062 1.06l3.496-3.496a.754.754 0 00.17-.81.747.747 0 00-.167-.254l-3.5-3.5a.75.75 0 00-1.06 0z"
    }));
});



var $c3efe5afc9c0db77$var$__assign = undefined && undefined.__assign || function() {
    $c3efe5afc9c0db77$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3efe5afc9c0db77$var$__assign.apply(this, arguments);
};
var $c3efe5afc9c0db77$export$c9b57264511cea21 = $9a5d87e7a4870d4c$exports.forwardRef(function LogInBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c3efe5afc9c0db77$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M20.727.5a2.84 2.84 0 012.772 2.928V20.17a2.841 2.841 0 01-2.772 2.928H9.273c-.025 0-.05 0-.075-.002A2.841 2.841 0 016.5 20.17V18a1.5 1.5 0 013 0v2.099h10.999V3.5h-11V6a1.5 1.5 0 11-3 0V3.427A2.841 2.841 0 019.274.5h11.454z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M11.639 7.243a1.5 1.5 0 000 2.12l.939.94H1.5a1.5 1.5 0 100 3h11.078l-.94.94a1.5 1.5 0 102.122 2.12l3.495-3.494a1.495 1.495 0 00.334-1.631 1.496 1.496 0 00-.33-.496l-3.5-3.5a1.5 1.5 0 00-2.12 0z"
    }));
});



var $721606f1e297fae4$var$__assign = undefined && undefined.__assign || function() {
    $721606f1e297fae4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $721606f1e297fae4$var$__assign.apply(this, arguments);
};
var $721606f1e297fae4$export$f292abd37582246c = $9a5d87e7a4870d4c$exports.forwardRef(function LogOut(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $721606f1e297fae4$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.507 2h.037A2.058 2.058 0 0123.5 4.133V20.5a2.06 2.06 0 01-1.992 2.132h-11.22A2.059 2.059 0 018.333 20.5v-4.084a.75.75 0 011.5 0v4.1a.56.56 0 00.515.617h11.136a.559.559 0 00.515-.617V4.082a.558.558 0 00-.515-.582H10.348a.56.56 0 00-.515.617v4.1a.75.75 0 11-1.5 0V4.131A2.06 2.06 0 0110.326 2h11.18z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M5.697 8.373a.75.75 0 00-1.06 0l-3.41 3.41a.748.748 0 000 1.075l3.41 3.408a.75.75 0 101.06-1.06L3.56 13.07h12.538a.75.75 0 100-1.5H3.561l2.136-2.136a.75.75 0 000-1.061z"
    }));
});



var $ade00a6d7868f22f$var$__assign = undefined && undefined.__assign || function() {
    $ade00a6d7868f22f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ade00a6d7868f22f$var$__assign.apply(this, arguments);
};
var $ade00a6d7868f22f$export$e2c9b76f2918cc76 = $9a5d87e7a4870d4c$exports.forwardRef(function LogOutBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ade00a6d7868f22f$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.257.75a2.808 2.808 0 012.742 2.894v16.344a2.809 2.809 0 01-2.742 2.894H10.076c-.025 0-.05 0-.075-.002a2.81 2.81 0 01-2.668-2.892V18a1.5 1.5 0 113 0v1.882h10.666V3.75H10.333V5.5a1.5 1.5 0 01-3 0V3.644A2.81 2.81 0 0110.076.75h11.18z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M5.977 7.343a1.5 1.5 0 00-2.121 0L.45 10.749a1.5 1.5 0 000 2.142l3.406 3.406a1.5 1.5 0 102.121-2.122l-.856-.855H15.85a1.5 1.5 0 000-3H5.121l.856-.856a1.5 1.5 0 000-2.121z"
    }));
});



var $51e1696a26ec1838$var$__assign = undefined && undefined.__assign || function() {
    $51e1696a26ec1838$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51e1696a26ec1838$var$__assign.apply(this, arguments);
};
var $51e1696a26ec1838$export$2a4143257785f953 = $9a5d87e7a4870d4c$exports.forwardRef(function MenuNavigationHorizontal(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $51e1696a26ec1838$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M5.5 12a2 2 0 11-4 0 2 2 0 014 0zm8.5 0a2 2 0 11-4 0 2 2 0 014 0zm6.5 2a2 2 0 100-4 2 2 0 000 4z"
    }));
});



var $1379a7ea19c0dada$var$__assign = undefined && undefined.__assign || function() {
    $1379a7ea19c0dada$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1379a7ea19c0dada$var$__assign.apply(this, arguments);
};
var $1379a7ea19c0dada$export$e01a035729e5e1c1 = $9a5d87e7a4870d4c$exports.forwardRef(function MenuNavigationHorizontalBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1379a7ea19c0dada$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M6.5 12a3 3 0 11-6 0 3 3 0 016 0zm8.5 0a3 3 0 11-6 0 3 3 0 016 0zm5.5 3a3 3 0 100-6 3 3 0 000 6z"
    }));
});



var $90f3899778b50a07$var$__assign = undefined && undefined.__assign || function() {
    $90f3899778b50a07$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90f3899778b50a07$var$__assign.apply(this, arguments);
};
var $90f3899778b50a07$export$56dbed97f074c6e4 = $9a5d87e7a4870d4c$exports.forwardRef(function MenuNavigationVertical(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $90f3899778b50a07$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.75 16.903a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5z"
    }));
});



var $345b5a80bd9c58d5$var$__assign = undefined && undefined.__assign || function() {
    $345b5a80bd9c58d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $345b5a80bd9c58d5$var$__assign.apply(this, arguments);
};
var $345b5a80bd9c58d5$export$e738f441fd7fb6d9 = $9a5d87e7a4870d4c$exports.forwardRef(function MenuNavigationVerticalBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $345b5a80bd9c58d5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M1 6.5A1.5 1.5 0 012.5 5h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 6.5zm0 6A1.5 1.5 0 012.5 11h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 12.5zM2.5 17a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3h-19z"
    }));
});



var $2c769c8148f7ffd7$var$__assign = undefined && undefined.__assign || function() {
    $2c769c8148f7ffd7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c769c8148f7ffd7$var$__assign.apply(this, arguments);
};
var $2c769c8148f7ffd7$export$da45d96ed490d127 = $9a5d87e7a4870d4c$exports.forwardRef(function Minus(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $2c769c8148f7ffd7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M23.913 12a.75.75 0 01-.75.75H.837a.75.75 0 010-1.5h22.326a.75.75 0 01.75.75z",
        fillRule: "evenodd"
    }));
});



var $1aeba5e77d3fa419$var$__assign = undefined && undefined.__assign || function() {
    $1aeba5e77d3fa419$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1aeba5e77d3fa419$var$__assign.apply(this, arguments);
};
var $1aeba5e77d3fa419$export$b7a01a7ec68fd5c0 = $9a5d87e7a4870d4c$exports.forwardRef(function MinusBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $1aeba5e77d3fa419$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M23.935 12a1.5 1.5 0 01-1.5 1.5H1.565a1.5 1.5 0 010-3h20.87a1.5 1.5 0 011.5 1.5z",
        fillRule: "evenodd"
    }));
});



var $cd42281d25fca1cc$var$__assign = undefined && undefined.__assign || function() {
    $cd42281d25fca1cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd42281d25fca1cc$var$__assign.apply(this, arguments);
};
var $cd42281d25fca1cc$export$e49a5ad3dd6df925 = $9a5d87e7a4870d4c$exports.forwardRef(function Move(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $cd42281d25fca1cc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.47 5.532a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06l-1.72 1.72h7.44v-7.44l-1.72 1.72a.75.75 0 01-1.06 0z"
    }));
});



var $6a5e76141797f569$var$__assign = undefined && undefined.__assign || function() {
    $6a5e76141797f569$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a5e76141797f569$var$__assign.apply(this, arguments);
};
var $6a5e76141797f569$export$a3c5fa6436f5d841 = $9a5d87e7a4870d4c$exports.forwardRef(function MoveBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6a5e76141797f569$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M7.94 6.06a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 012.12 0l3 3a1.5 1.5 0 01-2.12 2.12l-.44-.439V10.5h4.879l-.44-.44a1.5 1.5 0 012.122-2.12l3 3a1.5 1.5 0 010 2.12l-3 3a1.5 1.5 0 01-2.122-2.12l.44-.44H13.5v4.879l.44-.44a1.5 1.5 0 012.12 2.122l-3 3a1.5 1.5 0 01-2.12 0l-3-3a1.5 1.5 0 012.12-2.122l.44.44V13.5H5.621l.44.44a1.5 1.5 0 01-2.122 2.12l-3-3a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 112.122 2.12l-.44.44H10.5V5.621l-.44.44a1.5 1.5 0 01-2.12 0z"
    }));
});



var $a1bacd628eb72df9$var$__assign = undefined && undefined.__assign || function() {
    $a1bacd628eb72df9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1bacd628eb72df9$var$__assign.apply(this, arguments);
};
var $a1bacd628eb72df9$export$656559010049c8e = $9a5d87e7a4870d4c$exports.forwardRef(function Pin(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $a1bacd628eb72df9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M16.307.125a2.203 2.203 0 00-2.589.895L9.922 6.986a8.1 8.1 0 00-5.446.98l.37.635-.372-.634a2.203 2.203 0 00-.441 3.46l3.5 3.5-7.318 7.318a.734.734 0 001.039 1.038l7.317-7.318 3.502 3.502a2.203 2.203 0 003.46-.44l.002-.003a8.1 8.1 0 00.979-5.445l5.965-3.797a2.204 2.204 0 00.376-3.416l-5.72-5.72a2.202 2.202 0 00-.828-.521zM4.976 9.463a.734.734 0 01.24-.228 6.63 6.63 0 014.882-.713.734.734 0 00.791-.32l4.068-6.393a.735.735 0 011.139-.125l5.72 5.72a.734.734 0 01-.125 1.139l-6.392 4.068a.734.734 0 00-.32.792 6.63 6.63 0 01-.713 4.881.734.734 0 01-1.153.146l-8.042-8.042a.735.735 0 01-.095-.925z",
        fillRule: "evenodd"
    }));
});



var $bd5d2f2184ad4616$var$__assign = undefined && undefined.__assign || function() {
    $bd5d2f2184ad4616$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd5d2f2184ad4616$var$__assign.apply(this, arguments);
};
var $bd5d2f2184ad4616$export$88393934ec04748c = $9a5d87e7a4870d4c$exports.forwardRef(function PinBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $bd5d2f2184ad4616$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M15.336.013a2.203 2.203 0 011.798.632l5.721 5.721a2.203 2.203 0 01-.376 3.416l-5.965 3.797a8.099 8.099 0 01-.98 5.445v.002a2.203 2.203 0 01-3.46.441L9.09 16.485 2.507 23.07c-.398.399-.969.52-1.472.365a.734.734 0 01-.97-.972 1.468 1.468 0 01.365-1.47l6.584-6.584-2.981-2.981a2.203 2.203 0 01.44-3.46l.373.634-.37-.635a8.1 8.1 0 015.446-.98l3.796-5.966A2.203 2.203 0 0115.336.013z"
    }));
});



var $63b270b05313865e$var$__assign = undefined && undefined.__assign || function() {
    $63b270b05313865e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63b270b05313865e$var$__assign.apply(this, arguments);
};
var $63b270b05313865e$export$2d9ac7aa84f97a08 = $9a5d87e7a4870d4c$exports.forwardRef(function Plus(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $63b270b05313865e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.75 1a.75.75 0 00-1.5 0v10.25H1a.75.75 0 000 1.5h10.25V23a.75.75 0 001.5 0V12.75H23a.75.75 0 000-1.5H12.75V1z"
    }));
});



var $da013a4641ed104b$var$__assign = undefined && undefined.__assign || function() {
    $da013a4641ed104b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $da013a4641ed104b$var$__assign.apply(this, arguments);
};
var $da013a4641ed104b$export$2ef3672ebfdfd8df = $9a5d87e7a4870d4c$exports.forwardRef(function PlusBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $da013a4641ed104b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M13.5 1.565a1.5 1.5 0 00-3 0V10.5H1.565a1.5 1.5 0 000 3H10.5v8.935a1.5 1.5 0 003 0V13.5h8.935a1.5 1.5 0 000-3H13.5V1.565z"
    }));
});



var $cbcaa3f9fd2d6756$var$__assign = undefined && undefined.__assign || function() {
    $cbcaa3f9fd2d6756$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbcaa3f9fd2d6756$var$__assign.apply(this, arguments);
};
var $cbcaa3f9fd2d6756$export$531cef85654f2406 = $9a5d87e7a4870d4c$exports.forwardRef(function Print(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $cbcaa3f9fd2d6756$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M3.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm3.75 6.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H8.25z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 6V2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25A2.25 2.25 0 0124 8.25v7.5A2.25 2.25 0 0121.75 18H19.5v5.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5zm1.72-4.28a.75.75 0 01.53-.22h10.5a.75.75 0 01.75.75V6H6V2.25a.75.75 0 01.22-.53zM2.25 7.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75H4.5v-3.75a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v3.75h2.25a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25zm15.75 6v9H6v-9h12z",
        fillRule: "evenodd"
    }));
});



var $432d999247aed986$var$__assign = undefined && undefined.__assign || function() {
    $432d999247aed986$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $432d999247aed986$var$__assign.apply(this, arguments);
};
var $432d999247aed986$export$3326d4c83d14f416 = $9a5d87e7a4870d4c$exports.forwardRef(function PrintBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $432d999247aed986$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25a2.25 2.25 0 012.249 2.25v7.5a2.25 2.25 0 01-2.25 2.25H19.5v5.25a.75.75 0 01-.75.749H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5V2.25zm13 11.25h-11V22h11v-8.5zm0-8V2.25a.25.25 0 00-.25-.25H6.75a.25.25 0 00-.25.25V5.5h11zM2.75 9.75a1 1 0 011-1h1.5a1 1 0 010 2h-1.5a1 1 0 01-1-1z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.25 14.75a1 1 0 000 2h7.5a1 1 0 000-2h-7.5zm0 3a1 1 0 100 2h5.25a1 1 0 000-2H8.25z"
    }));
});



var $ec07cb270752cab9$var$__assign = undefined && undefined.__assign || function() {
    $ec07cb270752cab9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec07cb270752cab9$var$__assign.apply(this, arguments);
};
var $ec07cb270752cab9$export$f93ec6528f706bfe = $9a5d87e7a4870d4c$exports.forwardRef(function Refresh(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $ec07cb270752cab9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M19.378 10.056a.746.746 0 00-.825.159l-2.667 2.667a.75.75 0 001.06 1.06l1.368-1.367a6.583 6.583 0 01-11.352 4.02.75.75 0 10-1.09 1.03 8.084 8.084 0 0013.948-5.082l1.4 1.4a.75.75 0 001.06-1.061l-2.664-2.664a.763.763 0 00-.238-.162zm-11.7.811a.776.776 0 00-1.092 0l-1.39 1.398v-.2c0-1.397.397-2.695 1.191-3.793.795-1.099 1.887-1.897 3.178-2.396 1.291-.5 2.681-.5 3.973-.2 1.29.4 2.482 1.098 3.277 2.196.298.3.695.4 1.092.1.298-.3.397-.699.1-1.098-1.093-1.298-2.483-2.196-4.072-2.596-1.59-.399-3.277-.399-4.866.2a8.206 8.206 0 00-3.873 2.995c-.993 1.398-1.49 2.995-1.49 4.592v.2l-1.39-1.398a.776.776 0 00-1.093 0 .786.786 0 000 1.098l2.682 2.696c.099.1.298.2.496.2.199 0 .397-.1.497-.2l2.681-2.695c.397-.3.397-.8.1-1.099z"
    }));
});



var $0de53b0dfaae2d43$var$__assign = undefined && undefined.__assign || function() {
    $0de53b0dfaae2d43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0de53b0dfaae2d43$var$__assign.apply(this, arguments);
};
var $0de53b0dfaae2d43$export$af5e85d717d10540 = $9a5d87e7a4870d4c$exports.forwardRef(function RefreshBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $0de53b0dfaae2d43$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M14.339 3.815a8.834 8.834 0 00-11.044 7.02l-.234-.234a1.5 1.5 0 10-2.122 2.122l2.617 2.616a1.496 1.496 0 002.224-.002l2.614-2.614a1.5 1.5 0 00-1.905-2.301 5.833 5.833 0 018.995-2.767 1.5 1.5 0 101.792-2.406 8.832 8.832 0 00-2.937-1.434zm5.625 5.819a1.495 1.495 0 00-1.157-.044 1.495 1.495 0 00-.534.345L15.606 12.6a1.5 1.5 0 001.534 2.485 5.825 5.825 0 01-2.986 2.663 5.833 5.833 0 01-5.336-.532 1.5 1.5 0 10-1.636 2.514 8.833 8.833 0 0013.41-5.355l.347.347a1.5 1.5 0 102.122-2.122l-2.656-2.655a1.495 1.495 0 00-.44-.312z"
    }));
});



var $4081b30f20a97be7$var$__assign = undefined && undefined.__assign || function() {
    $4081b30f20a97be7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4081b30f20a97be7$var$__assign.apply(this, arguments);
};
var $4081b30f20a97be7$export$6d3b1b9014d6cc79 = $9a5d87e7a4870d4c$exports.forwardRef(function Retract(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4081b30f20a97be7$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.026 2.526a.75.75 0 10-1.06-1.06l-7.22 7.22v-4.69a.75.75 0 10-1.5 0v6.5a.747.747 0 00.75.75h6.5a.75.75 0 100-1.5h-4.69l7.22-7.22zm-12.53 18.448a.75.75 0 01-.75-.75v-4.69l-7.22 7.22a.75.75 0 11-1.06-1.06l7.22-7.22h-4.69a.75.75 0 010-1.5h6.5a.747.747 0 01.75.75v6.5a.75.75 0 01-.75.75z"
    }));
});



var $6ca25b026388d0d5$var$__assign = undefined && undefined.__assign || function() {
    $6ca25b026388d0d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ca25b026388d0d5$var$__assign.apply(this, arguments);
};
var $6ca25b026388d0d5$export$9515f4411b0668 = $9a5d87e7a4870d4c$exports.forwardRef(function RetractBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6ca25b026388d0d5$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.56 3.06A1.5 1.5 0 0021.44.94L15.5 6.878V4a1.5 1.5 0 00-3 0v6.5a1.494 1.494 0 00.859 1.357c.194.092.412.143.641.143h6.5a1.5 1.5 0 000-3h-2.879l5.94-5.94zM10.5 21.728a1.5 1.5 0 01-1.5-1.5v-2.879l-5.94 5.94a1.5 1.5 0 11-2.12-2.122l5.939-5.939H4a1.5 1.5 0 010-3h6.5a1.494 1.494 0 011.374.896c.08.185.126.39.126.604v6.5a1.5 1.5 0 01-1.5 1.5z"
    }));
});



var $4ad2e8b64ebceb0a$var$__assign = undefined && undefined.__assign || function() {
    $4ad2e8b64ebceb0a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ad2e8b64ebceb0a$var$__assign.apply(this, arguments);
};
var $4ad2e8b64ebceb0a$export$b204c8549f010cd = $9a5d87e7a4870d4c$exports.forwardRef(function RotateLeft(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4ad2e8b64ebceb0a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M1 1.75a.75.75 0 011.5 0v4.714a10.997 10.997 0 119.497 16.53.75.75 0 010-1.5A9.497 9.497 0 103.47 7.832h5.11a.75.75 0 010 1.5h-6.2a.745.745 0 01-.077 0H1.75a.75.75 0 01-.75-.75V1.75z"
    }));
});



var $f1d10c001955102c$var$__assign = undefined && undefined.__assign || function() {
    $f1d10c001955102c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1d10c001955102c$var$__assign.apply(this, arguments);
};
var $f1d10c001955102c$export$7257def152302e45 = $9a5d87e7a4870d4c$exports.forwardRef(function RotateLeftBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $f1d10c001955102c$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M0 2a1.5 1.5 0 113 0v2.414a11.746 11.746 0 118.746 19.58 1.5 1.5 0 01.002-3 8.747 8.747 0 10-7.23-13.663h3.813a1.5 1.5 0 110 3H2.152a1.2 1.2 0 01-.12 0H1.5a1.5 1.5 0 01-1.5-1.5V2z"
    }));
});



var $b973dd537e415c55$var$__assign = undefined && undefined.__assign || function() {
    $b973dd537e415c55$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b973dd537e415c55$var$__assign.apply(this, arguments);
};
var $b973dd537e415c55$export$75099d76a78789f = $9a5d87e7a4870d4c$exports.forwardRef(function RotateRight(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b973dd537e415c55$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.257 2.002a.75.75 0 00-1.5 0v4.714a10.999 10.999 0 00-18.484-.813 10.997 10.997 0 008.987 17.343.75.75 0 100-1.5 9.496 9.496 0 118.528-13.663h-5.113a.75.75 0 000 1.5h6.2a.744.744 0 00.078 0h.554a.75.75 0 00.75-.75V2.002z"
    }));
});



var $d09a5f8695335551$var$__assign = undefined && undefined.__assign || function() {
    $d09a5f8695335551$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d09a5f8695335551$var$__assign.apply(this, arguments);
};
var $d09a5f8695335551$export$1d157cf51c63a935 = $9a5d87e7a4870d4c$exports.forwardRef(function RotateRightBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $d09a5f8695335551$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M24 2a1.5 1.5 0 00-3 0v2.414A11.75 11.75 0 007.576 1.47a11.747 11.747 0 004.678 22.525 1.5 1.5 0 00-.002-3 8.747 8.747 0 117.23-13.664h-3.813a1.5 1.5 0 000 3h6.179c.04.002.08.002.12 0h.532a1.5 1.5 0 001.5-1.5V2z"
    }));
});



var $27e04c6747bcd113$var$__assign = undefined && undefined.__assign || function() {
    $27e04c6747bcd113$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $27e04c6747bcd113$var$__assign.apply(this, arguments);
};
var $27e04c6747bcd113$export$4b85d3515bd863a5 = $9a5d87e7a4870d4c$exports.forwardRef(function Search(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $27e04c6747bcd113$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10 1.25a8.75 8.75 0 105.634 15.445l5.836 5.835a.75.75 0 001.06-1.06l-5.835-5.836A8.75 8.75 0 0010 1.25zM2.75 10a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z",
        fillRule: "evenodd"
    }));
});



var $c6354cfcb2fa41c2$var$__assign = undefined && undefined.__assign || function() {
    $c6354cfcb2fa41c2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6354cfcb2fa41c2$var$__assign.apply(this, arguments);
};
var $c6354cfcb2fa41c2$export$8278256c54fb93b2 = $9a5d87e7a4870d4c$exports.forwardRef(function SearchBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $c6354cfcb2fa41c2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }));
});



var $671ffbfe57b49935$var$__assign = undefined && undefined.__assign || function() {
    $671ffbfe57b49935$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $671ffbfe57b49935$var$__assign.apply(this, arguments);
};
var $671ffbfe57b49935$export$ef9b1a59e592288f = $9a5d87e7a4870d4c$exports.forwardRef(function Select(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $671ffbfe57b49935$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M18.608 24H9.983c-.191 0-.479-.096-.575-.288l-3.737-4.887c-.575-.767-.575-1.725-.096-2.492.67-.958 2.013-1.245 3.067-.575 0 0 .096 0 .096.096l.479.384v-8.05c0-1.15.958-2.109 2.204-2.109 1.246 0 2.204.958 2.204 2.109v5.175l3.45.766c1.725.383 2.97 2.013 2.78 3.833l-.48 5.367c0 .383-.383.671-.767.671zm-8.241-1.438h7.57l.384-4.695c.096-1.055-.671-2.109-1.725-2.3l-4.025-.863c-.288-.096-.575-.383-.575-.67v-5.75c0-.384-.288-.767-.671-.767-.287 0-.575.287-.575.67v9.296c0 .288-.192.48-.383.671-.288.096-.575.096-.767-.096l-1.63-1.245c-.382-.192-.766-.096-1.053.191-.192.288-.192.575 0 .863l3.45 4.695zm1.15-17.92a.756.756 0 01-.767-.767V1.767c0-.48.287-.767.767-.767.479 0 .766.288.766.767v2.108c-.095.383-.383.767-.766.767zm2.779.671a.732.732 0 01-.48-.192.752.752 0 010-1.054l1.438-1.438a.752.752 0 011.054 0 .752.752 0 010 1.054l-1.437 1.438c-.192.096-.383.191-.575.191zm-5.654 0a.732.732 0 01-.48-.192L6.63 3.683a.752.752 0 010-1.054.752.752 0 011.054 0l1.438 1.438a.752.752 0 010 1.054c-.192.096-.383.191-.48.191zm8.528 2.204h-2.108a.756.756 0 01-.766-.767c0-.48.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.288.767-.767.767zm-9.295 0H5.767A.756.756 0 015 6.75c0-.383.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.384.767-.767.767z"
    }));
});



var $a05022b5ec25e431$var$__assign = undefined && undefined.__assign || function() {
    $a05022b5ec25e431$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a05022b5ec25e431$var$__assign.apply(this, arguments);
};
var $a05022b5ec25e431$export$603458ca8a362063 = $9a5d87e7a4870d4c$exports.forwardRef(function SelectBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $a05022b5ec25e431$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M11.517.75c-.29 0-.551.088-.74.277-.19.189-.277.45-.277.74v2.108c0 .5.38 1.017 1.017 1.017.28 0 .51-.142.675-.321a1.49 1.49 0 00.334-.635l.007-.03v-2.14c0-.289-.088-.55-.276-.74-.19-.188-.45-.276-.74-.276zM7.86 2.452a1.002 1.002 0 00-1.408 0 1.002 1.002 0 000 1.408L7.99 5.3c.14.14.392.263.653.263a.56.56 0 00.16-.028c.047-.014.095-.033.142-.053.09-.038.192-.09.285-.136l.04-.02.029-.028a1.002 1.002 0 000-1.408L7.86 2.452zm7.217 0a1.002 1.002 0 011.408 0 1.002 1.002 0 010 1.408L15.02 5.326l-.058.03c-.175.087-.413.207-.665.207a.98.98 0 01-.656-.265 1.002 1.002 0 010-1.408l1.437-1.438zm-9.31 3.281c-.638 0-1.017.517-1.017 1.017 0 .5.38 1.017 1.017 1.017h2.108c.5 0 1.017-.38 1.017-1.017 0-.637-.517-1.017-1.017-1.017H5.767zm8.556.277c.189-.189.45-.277.74-.277h2.108c.5 0 1.017.38 1.017 1.017 0 .29-.088.55-.277.74-.19.189-.45.277-.74.277h-2.108c-.501 0-1.017-.38-1.017-1.017 0-.29.088-.55.277-.74zM9.983 24h8.625c.384 0 .767-.288.767-.67l.48-5.367c.19-1.821-1.055-3.45-2.78-3.834l-3.45-.766V8.188c0-1.15-.958-2.109-2.204-2.109-1.246 0-2.204.958-2.204 2.109v8.05l-.48-.384c0-.096-.095-.096-.095-.096-1.054-.67-2.396-.383-3.067.575-.48.767-.48 1.725.096 2.492l3.737 4.887c.096.192.384.288.575.288z"
    }));
});



var $511bdd3355cef201$var$__assign = undefined && undefined.__assign || function() {
    $511bdd3355cef201$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $511bdd3355cef201$var$__assign.apply(this, arguments);
};
var $511bdd3355cef201$export$c72f6eaae7b9adff = $9a5d87e7a4870d4c$exports.forwardRef(function Settings(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $511bdd3355cef201$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM8.75 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM18.717 3.87l1.415 1.413-.61.61c-.914.913-1.02 2.224-.6 3.24C19.343 10.15 20.346 11 21.635 11h.865v2.002h-.864c-1.29 0-2.293.852-2.713 1.866-.421 1.016-.316 2.328.597 3.24l.611.611-1.413 1.414-.613-.612c-.913-.912-2.224-1.018-3.24-.597C13.85 19.346 13 20.348 13 21.637v.863h-2v-.863c0-1.289-.85-2.291-1.866-2.713-1.016-.422-2.328-.316-3.24.597l-.587.585a.045.045 0 01-.052 0l-1.388-1.388.613-.613c.913-.913 1.018-2.224.597-3.24C4.657 13.852 3.655 13 2.365 13H1.5v-2h.866c1.29 0 2.29-.85 2.71-1.865.422-1.015.317-2.327-.597-3.24l-.612-.611L5.282 3.87l.613.612c.912.912 2.224 1.018 3.24.597C10.15 4.657 11 3.655 11 2.366V1.5h2v.866c0 1.29.85 2.291 1.865 2.712 1.015.421 2.326.316 3.239-.596l.613-.612z",
        fillRule: "evenodd"
    }));
});



var $7a2cccbba916ab76$var$__assign = undefined && undefined.__assign || function() {
    $7a2cccbba916ab76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a2cccbba916ab76$var$__assign.apply(this, arguments);
};
var $7a2cccbba916ab76$export$18e4ef42d74628e8 = $9a5d87e7a4870d4c$exports.forwardRef(function SettingsBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $7a2cccbba916ab76$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM12 16a4 4 0 100-8 4 4 0 000 8z",
        fillRule: "evenodd"
    }));
});



var $45ab758191c25682$var$__assign = undefined && undefined.__assign || function() {
    $45ab758191c25682$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $45ab758191c25682$var$__assign.apply(this, arguments);
};
var $45ab758191c25682$export$c9915453de10000b = $9a5d87e7a4870d4c$exports.forwardRef(function Share(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $45ab758191c25682$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M6.15 9.5a.65.65 0 00-.65.65v11.2a.65.65 0 00.65.65h12.6a.65.65 0 00.65-.65v-11.2a.65.65 0 00-.65-.65h-1.4a.75.75 0 010-1.5h1.4a2.15 2.15 0 012.15 2.15v11.2a2.15 2.15 0 01-2.15 2.15H6.15A2.15 2.15 0 014 21.35v-11.2A2.15 2.15 0 016.15 8h1.4a.75.75 0 010 1.5h-1.4z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M11.92 1.22a.748.748 0 011.06 0l3.5 3.5a.75.75 0 01-1.06 1.06L13.2 3.56v7.99a.75.75 0 01-1.5 0V3.56L9.48 5.78a.75.75 0 01-1.06-1.06l3.5-3.5z"
    }));
});



var $12912ab01f5ce54b$var$__assign = undefined && undefined.__assign || function() {
    $12912ab01f5ce54b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12912ab01f5ce54b$var$__assign.apply(this, arguments);
};
var $12912ab01f5ce54b$export$4781d373f2233cee = $9a5d87e7a4870d4c$exports.forwardRef(function ShareBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $12912ab01f5ce54b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M5.5 10h1.3a1.5 1.5 0 100-3H5.4a2.9 2.9 0 00-2.9 2.9v11.2A2.9 2.9 0 005.4 24H18a2.9 2.9 0 002.9-2.9V9.9A2.9 2.9 0 0018 7h-1.4a1.5 1.5 0 000 3h1.3v11H5.5V10z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M10.623.456a1.495 1.495 0 011.553-.379c.214.071.415.192.585.362l3.5 3.5a1.5 1.5 0 01-2.121 2.122l-.94-.94V11.3a1.5 1.5 0 01-3 0V5.122l-.94.939a1.5 1.5 0 01-2.12-2.122L10.623.456z"
    }));
});



var $0571c44f9b4c6d52$var$__assign = undefined && undefined.__assign || function() {
    $0571c44f9b4c6d52$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0571c44f9b4c6d52$var$__assign.apply(this, arguments);
};
var $0571c44f9b4c6d52$export$4a37ae897f9e8014 = $9a5d87e7a4870d4c$exports.forwardRef(function StatusError(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $0571c44f9b4c6d52$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M17.03 6.97a.75.75 0 010 1.06L13.06 12l3.97 3.97a.75.75 0 11-1.06 1.06L12 13.06l-3.97 3.97a.75.75 0 01-1.06-1.06L10.94 12 6.97 8.03a.75.75 0 011.06-1.06L12 10.94l3.97-3.97a.75.75 0 011.06 0z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12z",
        fillRule: "evenodd"
    }));
});



var $b74b4d8db4c884e9$var$__assign = undefined && undefined.__assign || function() {
    $b74b4d8db4c884e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b74b4d8db4c884e9$var$__assign.apply(this, arguments);
};
var $b74b4d8db4c884e9$export$750f42de29e1826b = $9a5d87e7a4870d4c$exports.forwardRef(function StatusErrorBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b74b4d8db4c884e9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.56-17.56a1.5 1.5 0 010 2.12L14.122 12l3.44 3.44a1.5 1.5 0 01-2.122 2.12L12 14.122l-3.44 3.44a1.5 1.5 0 01-2.12-2.122L9.878 12l-3.44-3.44A1.5 1.5 0 118.56 6.44L12 9.878l3.44-3.44a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    }));
});



var $383341f18d7a04f9$var$__assign = undefined && undefined.__assign || function() {
    $383341f18d7a04f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $383341f18d7a04f9$var$__assign.apply(this, arguments);
};
var $383341f18d7a04f9$export$e0c13b137c9285c0 = $9a5d87e7a4870d4c$exports.forwardRef(function StatusHelp(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $383341f18d7a04f9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.825 14.11h-1.32a2.008 2.008 0 01-.198-.868c0-.986.73-1.676 1.577-2.425.986-.927 1.538-1.46 1.538-2.425 0-1.184-.867-1.992-1.932-1.992-1.005 0-1.814.631-2.208 1.893L9 7.761C9.513 6.006 10.794 5 12.53 5 14.442 5 16 6.36 16 8.293c0 1.321-.769 2.208-1.873 3.194-.868.79-1.4 1.282-1.4 1.992 0 .203.043.391.08.552l.018.079zm.69 3.096c0 .73-.571 1.242-1.261 1.242a1.237 1.237 0 01-1.243-1.242c0-.73.592-1.243 1.243-1.243.69 0 1.261.513 1.261 1.243z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm1.509 0c0 5.777 4.697 10.491 10.491 10.491S22.491 17.777 22.491 12c0-5.777-4.697-10.491-10.491-10.491S1.509 6.223 1.509 12z",
        fillRule: "evenodd"
    }));
});



var $3005e2bfcac6d271$var$__assign = undefined && undefined.__assign || function() {
    $3005e2bfcac6d271$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3005e2bfcac6d271$var$__assign.apply(this, arguments);
};
var $3005e2bfcac6d271$export$493d925eb43dfdfe = $9a5d87e7a4870d4c$exports.forwardRef(function StatusHelpBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $3005e2bfcac6d271$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm12.934 1.731h-2.315a2.457 2.457 0 01-.223-.975c0-.812.61-1.502 1.604-2.294.832-.69 1.198-1.056 1.198-1.706 0-.73-.569-1.238-1.28-1.238-.75 0-1.299.528-1.684 1.543L8 8.086C8.589 6.016 10.091 5 12 5c2.213 0 4 1.401 4 3.553 0 1.198-.569 1.99-1.685 2.965l-.218.189c-.7.608-1.204 1.044-1.204 1.598 0 .162.02.304.041.426zM13.746 17c0 1.076-.812 1.888-1.888 1.888-1.097 0-1.909-.812-1.909-1.888 0-1.056.812-1.888 1.909-1.888A1.86 1.86 0 0113.746 17z",
        fillRule: "evenodd"
    }));
});



var $6e783f4cd8af5143$var$__assign = undefined && undefined.__assign || function() {
    $6e783f4cd8af5143$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e783f4cd8af5143$var$__assign.apply(this, arguments);
};
var $6e783f4cd8af5143$export$390e0440e6f2b300 = $9a5d87e7a4870d4c$exports.forwardRef(function StatusInformation(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $6e783f4cd8af5143$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M3.515 3.515a12 12 0 1116.97 16.97 12 12 0 01-16.97-16.97zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.044 7.016a1.01 1.01 0 001.026-1.008C13.07 5.45 12.602 5 12.044 5 11.468 5 11 5.45 11 6.008c0 .576.468 1.008 1.044 1.008zm-.702 11.106h1.386V9.356h-1.386v8.766z"
    }));
});



var $59981a04b68672cc$var$__assign = undefined && undefined.__assign || function() {
    $59981a04b68672cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $59981a04b68672cc$var$__assign.apply(this, arguments);
};
var $59981a04b68672cc$export$d8874184141c994a = $9a5d87e7a4870d4c$exports.forwardRef(function StatusInformationBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $59981a04b68672cc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm1.57 6.008c0 .87-.71 1.508-1.526 1.508-.829 0-1.544-.633-1.544-1.508 0-.851.71-1.508 1.544-1.508.823 0 1.526.662 1.526 1.508zm-2.728 12.614V9.4h2.386v9.222h-2.386z",
        fillRule: "evenodd"
    }));
});



var $4960611d16622bfe$var$__assign = undefined && undefined.__assign || function() {
    $4960611d16622bfe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4960611d16622bfe$var$__assign.apply(this, arguments);
};
var $4960611d16622bfe$export$785e45f1d8c03432 = $9a5d87e7a4870d4c$exports.forwardRef(function StatusSuccess(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4960611d16622bfe$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M18.53 8.531a.75.75 0 00-1.06-1.06L9 15.94l-3.47-3.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l9-9z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12z",
        fillRule: "evenodd"
    }));
});



var $b2eca817e22d26eb$var$__assign = undefined && undefined.__assign || function() {
    $b2eca817e22d26eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2eca817e22d26eb$var$__assign.apply(this, arguments);
};
var $b2eca817e22d26eb$export$17e1460061865da = $9a5d87e7a4870d4c$exports.forwardRef(function StatusSuccessBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b2eca817e22d26eb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.94-2.94a1.5 1.5 0 00-2.12-2.12L9 14.878l-2.94-2.94a1.5 1.5 0 00-2.12 2.122l4 4a1.5 1.5 0 002.12 0l9-9z",
        fillRule: "evenodd"
    }));
});



var $761bf03ac35a507a$var$__assign = undefined && undefined.__assign || function() {
    $761bf03ac35a507a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $761bf03ac35a507a$var$__assign.apply(this, arguments);
};
var $761bf03ac35a507a$export$a2518b5310db22ab = $9a5d87e7a4870d4c$exports.forwardRef(function StatusWarning(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $761bf03ac35a507a$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.75 20.727L14.289 1.424C13.98.807 13.466.344 12.815.138a2.576 2.576 0 00-1.954.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.272 2.272 0 001.028 3.034c.31.154.652.24.995.24H21.71a2.26 2.26 0 002.263-2.263 2.037 2.037 0 00-.223-1.011zm-1.49 1.543a.793.793 0 01-.55.223H2.255a.791.791 0 01-.703-1.114l9.497-19.287c.103-.205.274-.377.48-.48a1.14 1.14 0 01.463-.102c.394 0 .771.222.943.582l9.48 19.303a.781.781 0 01.085.343c-.017.206-.085.395-.24.532z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M11.558 16.119h1.152l.252-8.118h-1.674l.27 8.118zm.576 3.96c.63 0 1.134-.468 1.134-1.134 0-.666-.504-1.134-1.134-1.134-.612 0-1.134.468-1.134 1.134 0 .666.522 1.134 1.134 1.134z"
    }));
});



var $b407efa589598ca9$var$__assign = undefined && undefined.__assign || function() {
    $b407efa589598ca9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b407efa589598ca9$var$__assign.apply(this, arguments);
};
var $b407efa589598ca9$export$f1b6053a528b50d9 = $9a5d87e7a4870d4c$exports.forwardRef(function StatusWarningBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b407efa589598ca9$var$__assign({
        fill: "currentColor",
        height: 25,
        ref: svgRef,
        viewBox: "0 0 24 25",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M14.297 1.424l9.463 19.303c.154.308.24.651.223 1.011a2.26 2.26 0 01-2.263 2.263H2.263c-.343 0-.686-.086-.994-.24a2.272 2.272 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.868.258a2.576 2.576 0 011.955-.12c.651.206 1.165.669 1.474 1.286zm-1.263 14.352h-2.046l-.483-7.775h2.994l-.465 7.775zm.726 2.995c0 .986-.744 1.73-1.711 1.73-1.024 0-1.749-.744-1.749-1.73 0-.967.725-1.73 1.749-1.73.967 0 1.71.763 1.71 1.73z",
        fillRule: "evenodd"
    }));
});



var $71bf5955dfaf4290$var$__assign = undefined && undefined.__assign || function() {
    $71bf5955dfaf4290$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71bf5955dfaf4290$var$__assign.apply(this, arguments);
};
var $71bf5955dfaf4290$export$e16de4ea1abb52c8 = $9a5d87e7a4870d4c$exports.forwardRef(function Stopwatch(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $71bf5955dfaf4290$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M8.807 10.346a.75.75 0 00-1.114 1.006l3.75 4.15a.75.75 0 001.114-1.005l-3.75-4.15z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.751 9.751 0 015.18 1.981l.907-.908a.75.75 0 011.193-.882l.375.375.375.375a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }));
});



var $bfcf241bc781eae9$var$__assign = undefined && undefined.__assign || function() {
    $bfcf241bc781eae9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bfcf241bc781eae9$var$__assign.apply(this, arguments);
};
var $bfcf241bc781eae9$export$da6e25dd6239a135 = $9a5d87e7a4870d4c$exports.forwardRef(function StopwatchBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $bfcf241bc781eae9$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 1.5h.75a.75.75 0 000-1.5h-4.5a.75.75 0 000 1.5h.75v3.116a9.75 9.75 0 108.901 3.287l1.32-1.319a.75.75 0 00.06-1.115l-.75-.75a.75.75 0 00-1.11.054l-1.424 1.424a9.755 9.755 0 00-3.997-1.58V1.5zM7.395 12.395l3.307 3.307c.484.484 1.351.402 1.937-.184.586-.586.668-1.453.184-1.938l-3.307-3.306c-.484-.484-1.351-.402-1.937.184-.586.586-.668 1.453-.184 1.937z",
        fillRule: "evenodd"
    }));
});



var $43c369efe7f9f398$var$__assign = undefined && undefined.__assign || function() {
    $43c369efe7f9f398$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43c369efe7f9f398$var$__assign.apply(this, arguments);
};
var $43c369efe7f9f398$export$616b2c96b9b691e = $9a5d87e7a4870d4c$exports.forwardRef(function SupportChat(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $43c369efe7f9f398$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12.5 2.438a7.188 7.188 0 00-7.152 6.469 1.438 1.438 0 011.402 1.437v7.187a1.438 1.438 0 01-1.438 1.438h-.718A3.594 3.594 0 011 15.375V12.5a3.594 3.594 0 012.9-3.526 8.625 8.625 0 0117.2 0A3.593 3.593 0 0124 12.5v2.875a3.594 3.594 0 01-2.875 3.521v.073a3.593 3.593 0 01-3.594 3.593h-1.56A2.156 2.156 0 0113.936 24H12.5a2.157 2.157 0 010-4.313h1.438a2.156 2.156 0 012.032 1.438h1.561a2.157 2.157 0 002.157-2.156 1.438 1.438 0 01-1.438-1.438v-7.187a1.438 1.438 0 011.401-1.437 7.187 7.187 0 00-7.151-6.47zm1.946 18.898a.719.719 0 01-.508 1.227H12.5a.719.719 0 110-1.438h1.438c.19 0 .373.076.508.21zm5.96-3.805a2.156 2.156 0 002.157-2.156V12.5a2.157 2.157 0 00-2.157-2.156h-.718v7.187h.718zM3.07 10.975a2.156 2.156 0 011.525-.631h.718v7.187h-.718a2.156 2.156 0 01-2.157-2.156V12.5c0-.572.228-1.12.632-1.525z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M10.11 15.267a.719.719 0 00-.97 1.063 4.987 4.987 0 006.72 0 .719.719 0 00-.97-1.063 3.55 3.55 0 01-4.78 0zM9.625 9.85a.72.72 0 01.719.719v1.257a.719.719 0 01-1.438 0V10.57a.72.72 0 01.719-.719zm6.469.719a.719.719 0 10-1.438 0v1.257a.719.719 0 001.438 0V10.57z"
    }));
});



var $4f1ff669c0ff2dbb$var$__assign = undefined && undefined.__assign || function() {
    $4f1ff669c0ff2dbb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f1ff669c0ff2dbb$var$__assign.apply(this, arguments);
};
var $4f1ff669c0ff2dbb$export$9c6a6487c263eb9c = $9a5d87e7a4870d4c$exports.forwardRef(function SupportChatBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4f1ff669c0ff2dbb$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M10.986.044a9 9 0 019.838 8.002 3.969 3.969 0 012.926 3.829v2.875a3.969 3.969 0 01-2.881 3.817 3.969 3.969 0 01-3.963 3.745h-1.31a2.528 2.528 0 01-2.284 1.438h-1.437a2.531 2.531 0 010-5.063h1.438a2.531 2.531 0 012.282 1.438h1.311a1.782 1.782 0 001.75-1.452 1.813 1.813 0 01-1.406-1.767V9.72a1.813 1.813 0 011.358-1.755 6.813 6.813 0 00-13.466 0A1.812 1.812 0 016.5 9.72v7.187a1.812 1.812 0 01-1.813 1.813H3.97A3.969 3.969 0 010 14.75v-2.875a3.969 3.969 0 012.926-3.83 9 9 0 018.06-8.001z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M13.656 9.944a1.094 1.094 0 012.188 0v1.257a1.094 1.094 0 11-2.188 0V9.944zm-5.464 4.493a1.094 1.094 0 011.545-.072 3.175 3.175 0 004.276 0 1.094 1.094 0 111.474 1.617 5.362 5.362 0 01-7.224 0 1.094 1.094 0 01-.071-1.545zM9 8.85c-.604 0-1.094.49-1.094 1.094v1.257a1.094 1.094 0 102.188 0V9.944c0-.604-.49-1.094-1.094-1.094z"
    }));
});



var $d64c36416fe985b2$var$__assign = undefined && undefined.__assign || function() {
    $d64c36416fe985b2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d64c36416fe985b2$var$__assign.apply(this, arguments);
};
var $d64c36416fe985b2$export$3288d34c523a1192 = $9a5d87e7a4870d4c$exports.forwardRef(function Tag(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $d64c36416fe985b2$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M18 3.75a2.25 2.25 0 110 4.499 2.25 2.25 0 010-4.499zm.287 1.557a.75.75 0 10-.574 1.386.75.75 0 00.574-1.386z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M21.75 0A2.25 2.25 0 0124 2.25v6.257a3.75 3.75 0 01-1.098 2.651L11.342 22.72a2.25 2.25 0 01-3.182 0l-6.88-6.88a2.25 2.25 0 010-3.181L12.843 1.097A3.75 3.75 0 0115.493 0h6.257zm.53 1.72a.75.75 0 00-.53-.22h-6.257a2.25 2.25 0 00-1.59.658L2.34 13.72a.75.75 0 000 1.06l6.88 6.88a.75.75 0 001.06 0l11.56-11.561a2.25 2.25 0 00.659-1.591V2.25a.75.75 0 00-.22-.53z",
        fillRule: "evenodd"
    }));
});



var $8f3765a602981b6a$var$__assign = undefined && undefined.__assign || function() {
    $8f3765a602981b6a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f3765a602981b6a$var$__assign.apply(this, arguments);
};
var $8f3765a602981b6a$export$eb1b14be98724170 = $9a5d87e7a4870d4c$exports.forwardRef(function TagBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $8f3765a602981b6a$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M21.966.373a2.25 2.25 0 00-.527-.063h-6.257a3.752 3.752 0 00-2.65 1.098L.97 12.968a2.25 2.25 0 000 3.182l6.879 6.88a2.25 2.25 0 003.182 0l11.56-11.562a3.753 3.753 0 001.098-2.65V2.56A2.25 2.25 0 0021.966.373z"
    }));
});



var $621f765a5c41f20b$var$__assign = undefined && undefined.__assign || function() {
    $621f765a5c41f20b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $621f765a5c41f20b$var$__assign.apply(this, arguments);
};
var $621f765a5c41f20b$export$680ea196effce5f = $9a5d87e7a4870d4c$exports.forwardRef(function Time(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $621f765a5c41f20b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12 7.5a.75.75 0 01.75.75v3.44l4.467 4.468a.75.75 0 01-1.06 1.06L11.47 12.53a.748.748 0 01-.22-.53V8.25A.75.75 0 0112 7.5z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M4.045 4.045a11.25 11.25 0 1115.91 15.91 11.25 11.25 0 01-15.91-15.91zM12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z",
        fillRule: "evenodd"
    }));
});



var $540587f8a7b76f4b$var$__assign = undefined && undefined.__assign || function() {
    $540587f8a7b76f4b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $540587f8a7b76f4b$var$__assign.apply(this, arguments);
};
var $540587f8a7b76f4b$export$cef7b1bbd85670df = $9a5d87e7a4870d4c$exports.forwardRef(function TimeBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $540587f8a7b76f4b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5zM13.5 8a1.5 1.5 0 00-3 0v4.621l4.94 4.94a1.5 1.5 0 002.12-2.122l-4.06-4.06V8z",
        fillRule: "evenodd"
    }));
});



var $91cb2cee4dfaaf4b$var$__assign = undefined && undefined.__assign || function() {
    $91cb2cee4dfaaf4b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $91cb2cee4dfaaf4b$var$__assign.apply(this, arguments);
};
var $91cb2cee4dfaaf4b$export$a818bbe058f189e = $9a5d87e7a4870d4c$exports.forwardRef(function Unlock(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $91cb2cee4dfaaf4b$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M15 14.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M3.818 3.818A4.5 4.5 0 0111.5 7v2H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75H13V7A6 6 0 101 7v2.25a.75.75 0 001.5 0V7a4.5 4.5 0 011.318-3.182zM22.5 10.5h-15v12h15v-12z",
        fillRule: "evenodd"
    }));
});



var $26ef30f8f7bcbfe8$var$__assign = undefined && undefined.__assign || function() {
    $26ef30f8f7bcbfe8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26ef30f8f7bcbfe8$var$__assign.apply(this, arguments);
};
var $26ef30f8f7bcbfe8$export$cc1b5dff9a340610 = $9a5d87e7a4870d4c$exports.forwardRef(function UnlockBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $26ef30f8f7bcbfe8$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M2.492 2.492A6.375 6.375 0 0113.375 7v2h9.875a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V9.75A.75.75 0 016.75 9h4.375V7a4.125 4.125 0 00-8.25 0v2.25a1.125 1.125 0 01-2.25 0V7a6.38 6.38 0 011.867-4.508zM15 13.875c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 002.25 0v-3c0-.621-.504-1.125-1.125-1.125z",
        fillRule: "evenodd"
    }));
});



var $b0e12029e8b40878$var$__assign = undefined && undefined.__assign || function() {
    $b0e12029e8b40878$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b0e12029e8b40878$var$__assign.apply(this, arguments);
};
var $b0e12029e8b40878$export$67fadca628676d83 = $9a5d87e7a4870d4c$exports.forwardRef(function ViewHide(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b0e12029e8b40878$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M22.072 2.23a.75.75 0 01-.021 1.061l-18.75 18a.75.75 0 11-1.039-1.082l18.75-18a.75.75 0 011.06.022zm-2.929 5.958a.75.75 0 011.047-.164c1.156.843 2.223 1.8 3.187 2.858l.003.003a2.413 2.413 0 010 3.23l-.003.002C20.758 17 16.412 20.07 11.995 20a10.734 10.734 0 01-3.255-.483.75.75 0 01.445-1.432 9.236 9.236 0 002.826.415c3.779.064 7.744-2.627 10.255-5.39a.914.914 0 000-1.22 19.816 19.816 0 00-2.96-2.654.75.75 0 01-.163-1.048zM12 5c.874-.009 1.745.093 2.592.304a.75.75 0 01-.362 1.456 8.799 8.799 0 00-2.244-.26c-3.713-.062-7.69 2.57-10.252 5.388a.913.913 0 000 1.22c.767.84 1.605 1.613 2.503 2.31a.75.75 0 01-.92 1.185 21.553 21.553 0 01-2.693-2.486l-.004-.004a2.413 2.413 0 010-3.23l.002-.002C3.3 7.935 7.655 4.932 12 5z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998 9.5a3 3 0 00-3 3 .75.75 0 01-1.5 0 4.499 4.499 0 014.5-4.5.75.75 0 010 1.5zm3.75 2.249a.75.75 0 01.75.75 4.502 4.502 0 01-4.5 4.501.75.75 0 110-1.5 3 3 0 003-3 .75.75 0 01.75-.751z",
        fillRule: "evenodd"
    }));
});



var $4e6bf70219bde87e$var$__assign = undefined && undefined.__assign || function() {
    $4e6bf70219bde87e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e6bf70219bde87e$var$__assign.apply(this, arguments);
};
var $4e6bf70219bde87e$export$639d2a0e5f6e1492 = $9a5d87e7a4870d4c$exports.forwardRef(function ViewHideBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $4e6bf70219bde87e$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M2.967 19.978a1.365 1.365 0 00-.028 1.83 1.145 1.145 0 001.702.027l3.342-3.485c1.275.553 2.57.873 3.827.9h.31c3.597.065 7.577-2.369 10.525-5.858a2.54 2.54 0 00.002-3.219 19.969 19.969 0 00-3.61-3.35l2.973-3.1c.477-.498.49-1.318.028-1.83a1.145 1.145 0 00-1.702-.027L2.967 19.978zm12.253-9.175l-4.118 4.294a3.03 3.03 0 001.007.171c1.79 0 3.24-1.56 3.24-3.485 0-.34-.045-.669-.13-.98z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12.109 8.298c.304 0 .598.045.878.13l3.126-3.26c-1.231-.521-2.475-.822-3.677-.851l-.315-.001C8.529 4.25 4.527 6.677 1.576 10.17a2.54 2.54 0 00-.002 3.218 20.048 20.048 0 003.506 3.283l3.883-4.049a3.744 3.744 0 01-.095-.84c0-1.925 1.451-3.485 3.24-3.485z"
    }));
});



var $b2f885ffe86226ee$var$__assign = undefined && undefined.__assign || function() {
    $b2f885ffe86226ee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2f885ffe86226ee$var$__assign.apply(this, arguments);
};
var $b2f885ffe86226ee$export$153f7030970dae8f = $9a5d87e7a4870d4c$exports.forwardRef(function ViewShow(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $b2f885ffe86226ee$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M23.383 10.337c-2.606-2.863-6.909-5.88-11.246-5.88H12c-4.389-.068-8.76 3-11.383 5.88a2.435 2.435 0 000 3.24c2.589 2.863 6.892 5.88 11.229 5.88h.274c4.337 0 8.64-3.034 11.246-5.88.84-.926.84-2.314.017-3.24zm-1.114 2.229c-2.383 2.623-6.275 5.4-10.115 5.4H12c-3.891.051-7.851-2.743-10.251-5.383a.916.916 0 010-1.217c3.6-3.995 7.56-5.4 10.131-5.4h.137c2.554-.052 6.583 1.354 10.252 5.383a.916.916 0 010 1.217z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M12 7.457c-2.486 0-4.509 2.023-4.509 4.492 0 1.2.463 2.331 1.32 3.188A4.444 4.444 0 0012 16.457c2.486 0 4.491-2.023 4.509-4.491 0-1.2-.463-2.332-1.32-3.189A4.474 4.474 0 0012 7.457zm3 4.509a2.981 2.981 0 01-3 3 2.981 2.981 0 01-3-3c0-1.646 1.354-3 3-3a2.981 2.981 0 013 3z"
    }));
});



var $0ef0b17938ba55e0$var$__assign = undefined && undefined.__assign || function() {
    $0ef0b17938ba55e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0ef0b17938ba55e0$var$__assign.apply(this, arguments);
};
var $0ef0b17938ba55e0$export$6d39d2f2d511d9a3 = $9a5d87e7a4870d4c$exports.forwardRef(function ViewShowBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $0ef0b17938ba55e0$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M12.436 4.502h-.315c-3.592-.066-7.594 2.36-10.545 5.854a2.54 2.54 0 00-.002 3.219c2.863 3.392 6.7 5.786 10.236 5.86h.31c3.597.066 7.577-2.368 10.525-5.858a2.54 2.54 0 00.002-3.218C19.79 6.98 15.935 4.586 12.436 4.502zm-.327 10.952c1.79 0 3.24-1.56 3.24-3.485 0-1.925-1.45-3.486-3.24-3.486-1.79 0-3.24 1.56-3.24 3.486 0 1.925 1.45 3.485 3.24 3.485z",
        fillRule: "evenodd"
    }));
});



var $f5fffdedc8a118cc$var$__assign = undefined && undefined.__assign || function() {
    $f5fffdedc8a118cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5fffdedc8a118cc$var$__assign.apply(this, arguments);
};
var $f5fffdedc8a118cc$export$d13069184bfa0730 = $9a5d87e7a4870d4c$exports.forwardRef(function ZoomIn(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $f5fffdedc8a118cc$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M10.056 1a9.056 9.056 0 017.072 14.713l5.58 5.58a1 1 0 01-1.321 1.498l-.094-.084-5.58-5.58A9.056 9.056 0 1110.056 1zm0 2a7.056 7.056 0 100 14.112 7.056 7.056 0 000-14.112z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10 6.833c.368 0 .666.299.666.667v1.834H12.5a.666.666 0 110 1.332h-1.834V12.5a.666.666 0 11-1.332 0v-1.834H7.5a.666.666 0 110-1.332h1.834V7.5c0-.368.298-.667.666-.667z",
        fillRule: "evenodd"
    }));
});



var $9ea57411ce031434$var$__assign = undefined && undefined.__assign || function() {
    $9ea57411ce031434$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9ea57411ce031434$var$__assign.apply(this, arguments);
};
var $9ea57411ce031434$export$52a27ea68a20ff47 = $9a5d87e7a4870d4c$exports.forwardRef(function ZoomInBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $9ea57411ce031434$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M10 6.75a.916.916 0 00-.916.917V9.25H7.5a.916.916 0 100 1.833h1.584v1.583a.916.916 0 101.832 0v-1.583H12.5a.916.916 0 100-1.833h-1.584V7.667A.916.916 0 0010 6.75z"
    }));
});



var $86405ae3253c9c82$var$__assign = undefined && undefined.__assign || function() {
    $86405ae3253c9c82$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86405ae3253c9c82$var$__assign.apply(this, arguments);
};
var $86405ae3253c9c82$export$adc4acb67269225 = $9a5d87e7a4870d4c$exports.forwardRef(function ZoomOut(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $86405ae3253c9c82$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        d: "M7.5 9.334a.666.666 0 100 1.332h5a.666.666 0 100-1.332h-5z"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M19.112 10.056a9.056 9.056 0 10-3.399 7.072l5.58 5.58.094.083a1 1 0 001.32-1.498l-5.579-5.58a9.018 9.018 0 001.984-5.657zM3 10.056a7.056 7.056 0 1114.112 0 7.056 7.056 0 01-14.112 0z",
        fillRule: "evenodd"
    }));
});



var $aa427e8a4a34dd69$var$__assign = undefined && undefined.__assign || function() {
    $aa427e8a4a34dd69$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa427e8a4a34dd69$var$__assign.apply(this, arguments);
};
var $aa427e8a4a34dd69$export$d875a145579e27ff = $9a5d87e7a4870d4c$exports.forwardRef(function ZoomOutBold(props, svgRef) {
    return $9a5d87e7a4870d4c$exports.createElement("svg", $aa427e8a4a34dd69$var$__assign({
        fill: "currentColor",
        height: 24,
        ref: svgRef,
        viewBox: "0 0 24 24",
        width: 24
    }, props), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M6.833 10c0-.368.299-.666.667-.666h5a.666.666 0 110 1.332h-5A.666.666 0 016.833 10z",
        fillRule: "evenodd"
    }), $9a5d87e7a4870d4c$exports.createElement("path", {
        clipRule: "evenodd",
        d: "M6.583 10c0-.506.41-.916.917-.916h5a.916.916 0 110 1.832h-5A.916.916 0 016.583 10zm.917-.416a.416.416 0 100 .832h5a.417.417 0 000-.832h-5z",
        fillRule: "evenodd"
    }));
});





var $denZA = parcelRequire("denZA");

var $b32201c8bf47faa5$export$8b88dfb72c256495 = function(id, index) {
    return id + "-accordion-header-" + index;
};
var $b32201c8bf47faa5$export$9df4f6ac67762779 = function(id, index) {
    return id + "-accordion-panel-" + index;
};


var $23d70be9089e3653$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $23d70be9089e3653$export$d99097c13d4dac9f = function(_a) {
    var children = _a.children, isDisabled = _a.isDisabled, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, label = _a.label, _c = _a.id, id = _c === void 0 ? 'accordion' : _c, _d = _a.index, index = _d === void 0 ? 0 : _d, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _e = $23d70be9089e3653$var$__read($denZA.useState(isExpanded), 2), isOpen = _e[0], setOpen = _e[1];
    var handleClick = function(event) {
        onClick === null || onClick === void 0 || onClick(event);
        setOpen(!isOpen);
    };
    var headerId = (0, $b32201c8bf47faa5$export$8b88dfb72c256495)(id, index);
    var panelId = (0, $b32201c8bf47faa5$export$9df4f6ac67762779)(id, index);
    return $denZA.createElement($denZA.Fragment, null, $denZA.createElement("button", {
        "aria-controls": panelId,
        "aria-disabled": isDisabled,
        "aria-expanded": isOpen,
        className: cn('accordion-trigger'),
        disabled: isDisabled,
        id: headerId,
        // eslint-disable-next-line react/jsx-no-bind
        onClick: handleClick
    }, $denZA.createElement("div", {
        className: cn('accordion-trigger-text')
    }, label), $denZA.createElement("span", {
        className: cn('icon')
    }, $denZA.createElement((0, $b4e72cdf9dbc256d$export$2fbb36af09846aa0), null))), $denZA.createElement("div", {
        "aria-hidden": !isOpen,
        "aria-labelledby": headerId,
        className: cn('accordion-panel'),
        hidden: !isOpen,
        id: panelId
    }, children));
};
$23d70be9089e3653$export$d99097c13d4dac9f.displayName = 'Accordion.Item';


var $b2545404796667be$var$__assign = undefined && undefined.__assign || function() {
    $b2545404796667be$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2545404796667be$var$__assign.apply(this, arguments);
};
var $b2545404796667be$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2545404796667be$export$a766cd26d0d69044 = function(_a) {
    var children = _a.children, props = $b2545404796667be$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var id = (0, $368dfcda2edba615$export$3ec6e0c16b571c32)('accordion');
    return(// TODO: accordion: allow for custom aria-label at top-level
    $denZA.createElement("div", $b2545404796667be$var$__assign({
        "aria-label": "accordion",
        className: cn('accordion')
    }, props, {
        id: id
    }), $denZA.Children.map(children, function(child, index) {
        return $denZA.cloneElement(child, $b2545404796667be$var$__assign({
            index: index,
            id: id
        }, child.props));
    })));
};
$b2545404796667be$export$a766cd26d0d69044.Item = (0, $23d70be9089e3653$export$d99097c13d4dac9f);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $eb6a869937062ff9$var$__assign = undefined && undefined.__assign || function() {
    $eb6a869937062ff9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eb6a869937062ff9$var$__assign.apply(this, arguments);
};
var $eb6a869937062ff9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $eb6a869937062ff9$export$10bb7d797ee5079f = $denZA.forwardRef(function BreadcrumbSeparator(_a, ref) {
    var props = $eb6a869937062ff9$var$__rest(_a, []);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('icon', 'breadcrumb-separator');
    return $denZA.createElement("span", $eb6a869937062ff9$var$__assign({
        className: className,
        ref: ref,
        role: "presentation"
    }, props), $denZA.createElement((0, $01c576487ae13177$export$d6d021d74f4bac76), null));
});
$eb6a869937062ff9$export$10bb7d797ee5079f.displayName = 'Breadcrumb.Separator';


var $a53fe57f301a925d$var$__assign = undefined && undefined.__assign || function() {
    $a53fe57f301a925d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a53fe57f301a925d$var$__assign.apply(this, arguments);
};
var $a53fe57f301a925d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a53fe57f301a925d$export$c13f210c706eb549 = $denZA.forwardRef(function BreadcrumbItem(_a, ref) {
    var children = _a.children, hasDropdown = _a.hasDropdown, isActive = _a.isActive, isLastItem = _a.isLastItem, props = $a53fe57f301a925d$var$__rest(_a, [
        "children",
        "hasDropdown",
        "isActive",
        "isLastItem"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('breadcrumb-item', {
        'is-current': isActive,
        'has-dropdown': hasDropdown
    });
    var validChildren = (0, $efef0f8ceb54059d$export$b2c43d7d050b2e63)(children);
    var validChildrenCount = validChildren.length;
    return $denZA.createElement("li", $a53fe57f301a925d$var$__assign({
        className: className,
        ref: ref
    }, props), validChildren.map(function(child, index) {
        return $denZA.cloneElement(child, {
            isActive: isActive,
            isLastChild: validChildrenCount === index + 1
        });
    }), !isLastItem && $denZA.createElement((0, $eb6a869937062ff9$export$10bb7d797ee5079f), null));
});
$a53fe57f301a925d$export$c13f210c706eb549.displayName = 'Breadcrumb.Item';



var $denZA = parcelRequire("denZA");

var $9da5aefef5c6b95b$var$__assign = undefined && undefined.__assign || function() {
    $9da5aefef5c6b95b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9da5aefef5c6b95b$var$__assign.apply(this, arguments);
};
var $9da5aefef5c6b95b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9da5aefef5c6b95b$export$ca871f5ef145e138 = $denZA.forwardRef(function BreadcrumbLink(_a, ref) {
    var children = _a.children, isActive = _a.isActive, props = $9da5aefef5c6b95b$var$__rest(_a, [
        "children",
        "isActive"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('breadcrumb-link');
    var commonProps = $9da5aefef5c6b95b$var$__assign({
        ref: ref,
        className: className
    }, props);
    return $denZA.createElement("a", $9da5aefef5c6b95b$var$__assign({}, isActive ? {
        'aria-current': 'page'
    } : {}, {
        href: "#"
    }, commonProps), children);
});
$9da5aefef5c6b95b$export$ca871f5ef145e138.displayName = 'Breadcrumb.Link';



var $b9f0b3e89beaa0e5$var$__assign = undefined && undefined.__assign || function() {
    $b9f0b3e89beaa0e5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9f0b3e89beaa0e5$var$__assign.apply(this, arguments);
};
var $b9f0b3e89beaa0e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b9f0b3e89beaa0e5$export$dabcc1ec9dd9d1cc = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c, props = $b9f0b3e89beaa0e5$var$__rest(_a, [
        "children",
        "size"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    /**
     * TODO: Add automatic dropdown addition class to an item.
     * ! ASSUMPTION: a <Breadcrumb> element that contains 6 <Breadcrumb.Item> elements will collapse
     * ! the 3rd, 4th and 5th element in one cloned <Breadcrumb.Item> with `...` as text and a
     * ! dropdown generated from the 3rd, 4th and 5th item.
     * ? we need to know whether this should be with responsiveness
     * ? we need to know whether this is simple like f.ex pagination
     */ var className = cn('breadcrumb', (_b = {}, _b["is-" + size] = size, _b));
    var validChildren = (0, $efef0f8ceb54059d$export$b2c43d7d050b2e63)(children);
    var validChildrenCount = validChildren.length;
    return $denZA.createElement("nav", $b9f0b3e89beaa0e5$var$__assign({
        "aria-label": "breadcrumb",
        className: className,
        role: "presentation"
    }, props), $denZA.createElement("ol", null, validChildren.map(function(child, index) {
        return $denZA.cloneElement(child, {
            isLastItem: validChildrenCount === index + 1
        });
    })));
};
$b9f0b3e89beaa0e5$export$dabcc1ec9dd9d1cc.Item = (0, $a53fe57f301a925d$export$c13f210c706eb549);
$b9f0b3e89beaa0e5$export$dabcc1ec9dd9d1cc.Link = (0, $9da5aefef5c6b95b$export$ca871f5ef145e138);
$b9f0b3e89beaa0e5$export$dabcc1ec9dd9d1cc.Separator = (0, $eb6a869937062ff9$export$10bb7d797ee5079f);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable func-style */ 
var $denZA = parcelRequire("denZA");
function $5292e3956f9937a3$export$8477fce780cb2224(render) {
    var forward = $denZA.forwardRef(render);
    return forward;
}



var $denZA = parcelRequire("denZA");

var $a41ed5d6245be746$var$__assign = undefined && undefined.__assign || function() {
    $a41ed5d6245be746$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a41ed5d6245be746$var$__assign.apply(this, arguments);
};
var $a41ed5d6245be746$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a41ed5d6245be746$var$defaultElement = 'div';
var $a41ed5d6245be746$export$ed0c65eec41bee08 = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? $a41ed5d6245be746$var$defaultElement : _b, children = _a.children, props = $a41ed5d6245be746$var$__rest(_a, [
        "as",
        "children"
    ]);
    return $denZA.createElement(as, $a41ed5d6245be746$var$__assign({
        ref: ref
    }, props), children);
});


// Utilities
// These types are relied upon by the forwardRefAs functin and Polymorph component
// NOTE: Please don't modify these types without asserting that the typying tests
// are still functioning
// parts of this code is based on https://github.com/kripod/react-polymorphic-box/blob/main/src/Box.tsx




var $f1b18e5f74506b97$var$__assign = undefined && undefined.__assign || function() {
    $f1b18e5f74506b97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1b18e5f74506b97$var$__assign.apply(this, arguments);
};
var $f1b18e5f74506b97$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f1b18e5f74506b97$export$f04a61298a47a40f = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function Icon(_a, ref) {
    var _b;
    var icon = _a.icon, _c = _a.as, as = _c === void 0 ? 'span' : _c, _d = _a.parentClass, parentClass = _d === void 0 ? '' : _d, props = $f1b18e5f74506b97$var$__rest(_a, [
        "icon",
        "as",
        "parentClass"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), $f1b18e5f74506b97$var$__assign({
        as: as
    }, props, {
        className: cn('icon', (_b = {}, _b[parentClass] = parentClass, _b)),
        ref: ref
    }), icon);
});






var $denZA = parcelRequire("denZA");
var $57b6ef9d28caaeab$var$__assign = undefined && undefined.__assign || function() {
    $57b6ef9d28caaeab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $57b6ef9d28caaeab$var$__assign.apply(this, arguments);
};
var $57b6ef9d28caaeab$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $57b6ef9d28caaeab$var$ButtonElements = [
    'button',
    'input',
    'a'
];
var $57b6ef9d28caaeab$export$ea18c227d4417cc3 = function(_a) {
    var as = _a.as, isDisabled = _a.isDisabled, label = _a.label, props = $57b6ef9d28caaeab$var$__rest(_a, [
        "as",
        "isDisabled",
        "label"
    ]);
    $denZA.useEffect(function() {
        if ($57b6ef9d28caaeab$var$ButtonElements.indexOf(as)) throw Error("invalid component type " + $57b6ef9d28caaeab$var$ButtonElements.toString());
    }, [
        as
    ]);
    return $57b6ef9d28caaeab$var$__assign({
        role: 'button',
        tabIndex: isDisabled ? -1 : 0,
        'aria-disabled': isDisabled,
        'aria-label': label
    }, props);
};


var $42d1cd4b7ec0f526$var$__assign = undefined && undefined.__assign || function() {
    $42d1cd4b7ec0f526$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42d1cd4b7ec0f526$var$__assign.apply(this, arguments);
};
var $42d1cd4b7ec0f526$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $42d1cd4b7ec0f526$export$353f5b6fc5456de1 = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function(_a, ref) {
    var _b, _c;
    var _d = _a.as, as = _d === void 0 ? 'button' : _d, label = _a.label, iconPosition = _a.iconPosition, icon = _a.icon, isReverse = _a.isReverse, variant = _a.variant, size = _a.size, state = _a.state, props = $42d1cd4b7ec0f526$var$__rest(_a, [
        "as",
        "label",
        "iconPosition",
        "icon",
        "isReverse",
        "variant",
        "size",
        "state"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var aria = $42d1cd4b7ec0f526$var$__rest((0, $57b6ef9d28caaeab$export$ea18c227d4417cc3)($42d1cd4b7ec0f526$var$__assign({
        as: as,
        label: label
    }, props)), []);
    var children = $denZA.useMemo(function() {
        if (!icon && label) return $denZA.createElement("span", null, label);
        var buttonIcon = $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
            "aria-hidden": true,
            icon: icon
        });
        if (!label && icon) return buttonIcon;
        return $denZA.createElement($denZA.Fragment, null, (!iconPosition || iconPosition === 'left') && buttonIcon, label !== null && label !== void 0 ? label : $denZA.createElement("span", null, label), iconPosition && iconPosition === 'right' && buttonIcon);
    }, [
        icon,
        label,
        iconPosition
    ]);
    var className = cn('button', $42d1cd4b7ec0f526$var$__assign((_b = {
        'is-reverse': isReverse,
        'is-icon-only': !label && icon ? true : false
    }, _b["is-" + (variant ? variant : '')] = variant, _b["is-" + size] = size, _b), state && (_c = {}, _c["is-" + state] = state, _c)));
    return $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), $42d1cd4b7ec0f526$var$__assign({
        as: as
    }, aria, {
        className: className,
        ref: ref
    }), children);
});






var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $68db5240ff1ba371$var$__assign = undefined && undefined.__assign || function() {
    $68db5240ff1ba371$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68db5240ff1ba371$var$__assign.apply(this, arguments);
};
var $68db5240ff1ba371$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $68db5240ff1ba371$export$3e2eed2f68e1214c = $denZA.forwardRef(function ButtonToggleItem(_a, ref) {
    var _b;
    var isSelected = _a.isSelected, isFocus = _a.isFocus, isDisabled = _a.isDisabled, label = _a.label, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'left' : _c, _d = _a.iconSize, iconSize = _d === void 0 ? 'medium' : _d, props = $68db5240ff1ba371$var$__rest(_a, [
        "isSelected",
        "isFocus",
        "isDisabled",
        "label",
        "icon",
        "iconPosition",
        "iconSize"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var iconOnly = icon && !label;
    var iconElement = $denZA.createElement("span", {
        className: cn('icon')
    }, icon);
    var className = cn('button-toggle-item', (_b = {
        'is-selected': isSelected,
        'is-focus': isFocus,
        'is-disabled': isDisabled,
        'is-icon-only': iconOnly
    }, _b["is-icon-" + iconSize] = iconSize, _b));
    return $denZA.createElement("button", $68db5240ff1ba371$var$__assign({
        className: className,
        disabled: isDisabled,
        ref: ref
    }, props), // eslint-disable-next-line no-null/no-null
    icon ? iconPosition === 'left' && iconElement : null, label && $denZA.createElement("span", {
        className: cn('button-toggle-text')
    }, label), // eslint-disable-next-line no-null/no-null
    icon ? iconPosition === 'right' && iconElement : null);
});
$68db5240ff1ba371$export$3e2eed2f68e1214c.displayName = 'ButtonToggle.Item';


var $054fc54193d35381$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $054fc54193d35381$export$2bcaf2ecc9612e8f = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.isFullWidth, isFullWidth = _d === void 0 ? false : _d, onChange = _a.onChange, initialActiveButton = _a.initialActiveButton;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _e = $054fc54193d35381$var$__read($denZA.useState(initialActiveButton), 2), activeButton = _e[0], setActiveButton = _e[1];
    var validChildren = (0, $efef0f8ceb54059d$export$b2c43d7d050b2e63)(children);
    var className = cn('button-toggle', (_b = {}, _b["is-" + size] = size, _b["is-fullwidth"] = isFullWidth, _b));
    return $denZA.createElement("div", {
        className: className
    }, validChildren.map(function(child, index) {
        return $denZA.cloneElement(child, {
            index: index,
            onClick: function() {
                setActiveButton(index);
                onChange === null || onChange === void 0 || onChange(index);
            },
            isSelected: index === activeButton
        });
    }));
};
$054fc54193d35381$export$2bcaf2ecc9612e8f.Item = (0, $68db5240ff1ba371$export$3e2eed2f68e1214c);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $0c0b0558a0f085a0$export$f40b7e0b762b928b = function(_a) {
    var icon = _a.icon, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b;
    return $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        "aria-label": ariaLabel,
        as: "button",
        icon: icon
    });
};
$0c0b0558a0f085a0$export$f40b7e0b762b928b.displayName = 'Card.Action';



var $denZA = parcelRequire("denZA");

var $4c50be067721af3a$export$9b6a647253f61c5f = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-actions')
    }, children);
};
$4c50be067721af3a$export$9b6a647253f61c5f.displayName = 'Card.Actions';



var $denZA = parcelRequire("denZA");

var $6789553040ec0e31$export$851de33184ecdac4 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-body')
    }, children);
};
$6789553040ec0e31$export$851de33184ecdac4.displayName = 'Card.Body';



var $denZA = parcelRequire("denZA");

var $2a233df2fa91c04d$export$64ef9b8c11710c47 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-content')
    }, children);
};
$2a233df2fa91c04d$export$64ef9b8c11710c47.displayName = 'Card.Content';



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

var $30bb2787c5a45e83$export$2e0a83ec2e27ecbb = function(_a) {
    var _b = _a.isVertical, isVertical = _b === void 0 ? false : _b;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("hr", {
        className: cn('divider', {
            'is-vertical': isVertical
        })
    });
};


var $a368992814e0413a$export$ca04f93e3f5a6e48 = function() {
    return $denZA.createElement((0, $30bb2787c5a45e83$export$2e0a83ec2e27ecbb), null);
};
$a368992814e0413a$export$ca04f93e3f5a6e48.displayName = 'Card.Divider';



var $denZA = parcelRequire("denZA");

var $4394e61e120638a9$export$448e687a629d6c89 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-figure')
    }, children);
};
$4394e61e120638a9$export$448e687a629d6c89.displayName = 'Card.Figure';



var $denZA = parcelRequire("denZA");

var $fb5f7d1c8544f142$export$e9897d434e0741ee = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-footer')
    }, children);
};
$fb5f7d1c8544f142$export$e9897d434e0741ee.displayName = 'Card.Footer';



var $denZA = parcelRequire("denZA");

var $55ef4450514e1f13$export$5665775b26e26c5d = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-header')
    }, children);
};
$55ef4450514e1f13$export$5665775b26e26c5d.displayName = 'Card.Header';



var $denZA = parcelRequire("denZA");

var $0df3546edd313881$export$d7df4bcb9a53fba5 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-heading')
    }, children);
};
$0df3546edd313881$export$d7df4bcb9a53fba5.displayName = 'Card.Heading';



var $denZA = parcelRequire("denZA");

var $afe2d6005b613907$export$93526684a821b474 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-headings')
    }, children);
};
$afe2d6005b613907$export$93526684a821b474.displayName = 'Card.Headings';



var $denZA = parcelRequire("denZA");

var $0063cf39dd6b7b93$export$8a8c015277a3d77a = function(_a) {
    var _b;
    var children = _a.children, _c = _a.ratio, ratio = _c === void 0 ? '5by3' : _c, _d = _a.cover, cover = _d === void 0 ? false : _d;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('card-image');
    var figureClassName = cn('card-image-figure', (_b = {}, _b["is-ratio-" + ratio] = ratio, _b["is-cover"] = cover, _b));
    return $denZA.createElement("div", {
        className: className
    }, $denZA.createElement("figure", {
        className: figureClassName
    }, children));
};
$0063cf39dd6b7b93$export$8a8c015277a3d77a.displayName = 'Card.Image';



var $denZA = parcelRequire("denZA");

var $69ca15da1076bd87$export$d14d08fa0d83d69d = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-item')
    }, children);
};
$69ca15da1076bd87$export$d14d08fa0d83d69d.displayName = 'Card.Item';



var $denZA = parcelRequire("denZA");

var $2244b2132e0f3d1c$export$955b33155a1e7657 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-links')
    }, children);
};
$2244b2132e0f3d1c$export$955b33155a1e7657.displayName = 'Card.Links';



var $denZA = parcelRequire("denZA");

var $f12236ed7a4953bf$export$d2d17d20ef6b7c77 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('card-subheading')
    }, children);
};
$f12236ed7a4953bf$export$d2d17d20ef6b7c77.displayName = 'Card.SubHeading';


var $d849662016ecefb8$export$60332b2344f7fe41 = function(_a) {
    var children = _a.children, isCompact = _a.isCompact, isLandscape = _a.isLandscape;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('card', {
        'is-compact': isCompact,
        'is-landscape': isLandscape
    });
    return $denZA.createElement("div", {
        className: className
    }, children);
};
$d849662016ecefb8$export$60332b2344f7fe41.Action = (0, $0c0b0558a0f085a0$export$f40b7e0b762b928b);
$d849662016ecefb8$export$60332b2344f7fe41.Actions = (0, $4c50be067721af3a$export$9b6a647253f61c5f);
$d849662016ecefb8$export$60332b2344f7fe41.Body = (0, $6789553040ec0e31$export$851de33184ecdac4);
$d849662016ecefb8$export$60332b2344f7fe41.Content = (0, $2a233df2fa91c04d$export$64ef9b8c11710c47);
$d849662016ecefb8$export$60332b2344f7fe41.Divider = (0, $a368992814e0413a$export$ca04f93e3f5a6e48);
$d849662016ecefb8$export$60332b2344f7fe41.Figure = (0, $4394e61e120638a9$export$448e687a629d6c89);
$d849662016ecefb8$export$60332b2344f7fe41.Footer = (0, $fb5f7d1c8544f142$export$e9897d434e0741ee);
$d849662016ecefb8$export$60332b2344f7fe41.Header = (0, $55ef4450514e1f13$export$5665775b26e26c5d);
$d849662016ecefb8$export$60332b2344f7fe41.Heading = (0, $0df3546edd313881$export$d7df4bcb9a53fba5);
$d849662016ecefb8$export$60332b2344f7fe41.Headings = (0, $afe2d6005b613907$export$93526684a821b474);
$d849662016ecefb8$export$60332b2344f7fe41.Image = (0, $0063cf39dd6b7b93$export$8a8c015277a3d77a);
$d849662016ecefb8$export$60332b2344f7fe41.Item = (0, $69ca15da1076bd87$export$d14d08fa0d83d69d);
$d849662016ecefb8$export$60332b2344f7fe41.Links = (0, $2244b2132e0f3d1c$export$955b33155a1e7657);
$d849662016ecefb8$export$60332b2344f7fe41.SubHeading = (0, $f12236ed7a4953bf$export$d2d17d20ef6b7c77);






var $denZA = parcelRequire("denZA");




var $denZA = parcelRequire("denZA");

var $3fc8b45692d3ccd0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3fc8b45692d3ccd0$export$fe8da2af71b7fec6;
(function(CheckStates) {
    CheckStates["Checked"] = "checked";
    CheckStates["UnChecked"] = "unchecked";
    CheckStates["Indeterminate"] = "indeterminate";
})($3fc8b45692d3ccd0$export$fe8da2af71b7fec6 || ($3fc8b45692d3ccd0$export$fe8da2af71b7fec6 = {}));
var $3fc8b45692d3ccd0$export$e375f10ce42261c5 = function(_a) {
    var isRequired = _a.isRequired, _b = _a.defaultChecked, defaultChecked = _b === void 0 ? $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.UnChecked : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, label = _a.label, onChange = _a.onChange;
    var _d = $3fc8b45692d3ccd0$var$__read($denZA.useState(defaultChecked), 2), checkState = _d[0], setCheckState = _d[1];
    var uid = (0, $b3689d7f6454aa75$export$87d05f07e65211f1)();
    var onCheckedChange = $denZA.useCallback(function(e) {
        if (onChange) onChange(e);
        setCheckState(e.target.checked ? $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.Checked : $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.UnChecked);
    }, [
        onChange
    ]);
    var checkboxAria = $denZA.useMemo(function() {
        return {
            role: 'checkbox',
            'aria-disabled': isDisabled,
            'aria-checked': checkState === $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.Indeterminate ? 'mixed' : checkState === $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.Checked,
            'aria-labelledby': uid,
            type: 'checkbox',
            tabIndex: isDisabled ? -1 : 0,
            id: uid,
            disabled: isDisabled,
            required: isRequired,
            checked: checkState === $3fc8b45692d3ccd0$export$fe8da2af71b7fec6.Checked,
            onChange: onCheckedChange
        };
    }, [
        isRequired,
        isDisabled,
        checkState,
        onCheckedChange,
        defaultChecked
    ]);
    var labelAria = $denZA.useMemo(function() {
        return {
            htmlFor: uid,
            'aria-label': label
        };
    }, [
        label
    ]);
    return {
        checkboxProps: checkboxAria,
        labelProps: labelAria
    };
};


var $58724900fb07117e$var$__assign = undefined && undefined.__assign || function() {
    $58724900fb07117e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $58724900fb07117e$var$__assign.apply(this, arguments);
};
var $58724900fb07117e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $58724900fb07117e$export$48513f6b9f8ce62d = $denZA.forwardRef(function(_a, ref) {
    var _b;
    var label = _a.label, labelLeft = _a.labelLeft, defaultChecked = _a.defaultChecked, _c = _a.status, status = _c === void 0 ? '' : _c, indeterminate = _a.indeterminate, props = $58724900fb07117e$var$__rest(_a, [
        "label",
        "labelLeft",
        "defaultChecked",
        "status",
        "indeterminate"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var inputRef = (0, $c9bab4bc692bb080$export$38d56e9c4e5a652b)(ref);
    var _d = (0, $3fc8b45692d3ccd0$export$e375f10ce42261c5)($58724900fb07117e$var$__assign({
        label: label,
        defaultChecked: defaultChecked
    }, props)), checkboxProps = _d.checkboxProps, labelProps = _d.labelProps;
    $denZA.useEffect(function() {
        if (inputRef.current) inputRef.current.indeterminate = !!indeterminate;
    }, [
        inputRef,
        indeterminate
    ]);
    var labelEl = label && $denZA.createElement("span", {
        className: cn('checkbox-text')
    }, label);
    var icon = indeterminate ? $denZA.createElement((0, $1aeba5e77d3fa419$export$b7a01a7ec68fd5c0), null) : $denZA.createElement((0, $ca35121afe25890a$export$add807e002afa321), null);
    return $denZA.createElement("div", {
        className: cn('checkbox', (_b = {}, _b["status-" + status] = status, _b))
    }, $denZA.createElement("label", $58724900fb07117e$var$__assign({
        className: cn('checkbox-label')
    }, labelProps), labelLeft && labelEl, $denZA.createElement("input", $58724900fb07117e$var$__assign({
        className: cn('checkbox-hidden')
    }, checkboxProps, props, {
        ref: inputRef
    })), $denZA.createElement("span", {
        className: cn('checkbox-shape')
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: icon
    })), !labelLeft && labelEl));
});






var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $97b771b7bfe74101$export$cf7203ccc57043c5 = $denZA.createContext(undefined);
var $97b771b7bfe74101$export$1a82d72bf3dc6ae3 = function() {
    var context = $denZA.useContext($97b771b7bfe74101$export$cf7203ccc57043c5);
    if (context) return context;
    throw new Error("ContentSwitcherItem compound components can't be rendered outside ContentSwitcher component");
};



var $denZA = parcelRequire("denZA");




var $672b8001bbe48ed8$export$3ec6e0c16b571c32 = function(type) {
    var uid = (0, $b3689d7f6454aa75$export$87d05f07e65211f1)();
    return type + "-" + uid;
};
var $672b8001bbe48ed8$export$f44e27dc002af170 = function(id, index) {
    return id + "-item-" + index;
};


var $d36fe6b430223acd$var$__assign = undefined && undefined.__assign || function() {
    $d36fe6b430223acd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d36fe6b430223acd$var$__assign.apply(this, arguments);
};
var $d36fe6b430223acd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d36fe6b430223acd$export$24231bd1a3b914e5 = function(_a) {
    var label = _a.label, index = _a.index, icon = _a.icon, iconSelected = _a.iconSelected, iconBefore = _a.iconBefore, iconBeforeSelected = _a.iconBeforeSelected, iconAfter = _a.iconAfter, iconAfterSelected = _a.iconAfterSelected, _b = _a.disabled, disabled = _b === void 0 ? false : _b, props = $d36fe6b430223acd$var$__rest(_a, [
        "label",
        "index",
        "icon",
        "iconSelected",
        "iconBefore",
        "iconBeforeSelected",
        "iconAfter",
        "iconAfterSelected",
        "disabled"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _c = (0, $97b771b7bfe74101$export$1a82d72bf3dc6ae3)(), id = _c.id, selectedItem = _c.selectedItem, setSelectedItem = _c.setSelectedItem, focusedItem = _c.focusedItem, setFocusedItem = _c.setFocusedItem, isDisabled = _c.isDisabled;
    var isSelected = selectedItem === index;
    var className = cn('switcher-item', {
        'is-selected': isSelected,
        'is-focused': focusedItem === index,
        'is-disabled': disabled,
        'is-icon-only': icon
    });
    var iconBeforeEl = iconBefore && $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: isSelected ? iconBeforeSelected !== null && iconBeforeSelected !== void 0 ? iconBeforeSelected : iconBefore : iconBefore,
        parentClass: "icon-before"
    });
    var iconAfterEl = iconAfter && $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: isSelected ? iconAfterSelected !== null && iconAfterSelected !== void 0 ? iconAfterSelected : iconAfter : iconAfter,
        parentClass: "icon-after"
    });
    var attr = $d36fe6b430223acd$var$__assign({
        className: className,
        role: 'presentation',
        'aria-selected': isSelected ? true : undefined,
        id: (0, $672b8001bbe48ed8$export$f44e27dc002af170)(id, index),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function() {
            setFocusedItem(index);
            setSelectedItem(index);
        },
        disabled: disabled || isDisabled
    }, props);
    if (icon) return $denZA.createElement("button", $d36fe6b430223acd$var$__assign({
        type: "button"
    }, attr), $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: isSelected ? iconSelected !== null && iconSelected !== void 0 ? iconSelected : icon : icon
    }));
    return $denZA.createElement("button", $d36fe6b430223acd$var$__assign({
        type: "button"
    }, attr), iconBeforeEl, $denZA.createElement("span", null, label), iconAfterEl);
};
$d36fe6b430223acd$export$24231bd1a3b914e5.displayName = 'ContentSwitcher.Item';



var $2260767461f585e1$var$__assign = undefined && undefined.__assign || function() {
    $2260767461f585e1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2260767461f585e1$var$__assign.apply(this, arguments);
};
var $2260767461f585e1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2260767461f585e1$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2260767461f585e1$export$e7cdf232acff13df = function(_a) {
    var _b;
    var children = _a.children, _c = _a.initialSelectedItem, initialSelectedItem = _c === void 0 ? 0 : _c, onSelectedItemChange = _a.onSelectedItemChange, isDisabled = _a.isDisabled, _d = _a.size, size = _d === void 0 ? 'default' : _d, props = $2260767461f585e1$var$__rest(_a, [
        "children",
        "initialSelectedItem",
        "onSelectedItemChange",
        "isDisabled",
        "size"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _e = $2260767461f585e1$var$__read($denZA.useState(initialSelectedItem), 2), selectedItem = _e[0], setSelectedItem = _e[1];
    var _f = $2260767461f585e1$var$__read($denZA.useState(selectedItem), 2), focusedItem = _f[0], setFocusedItem = _f[1];
    $denZA.useEffect(function() {
        onSelectedItemChange === null || onSelectedItemChange === void 0 || onSelectedItemChange(selectedItem);
    }, [
        selectedItem,
        onSelectedItemChange
    ]);
    var id = (0, $672b8001bbe48ed8$export$3ec6e0c16b571c32)('switcher');
    var className = cn('switcher', (_b = {}, _b["is-" + size] = size, _b["is-disabled"] = isDisabled, _b));
    var listClassName = cn('switcher-list');
    var contextValue = $denZA.useMemo(function() {
        return {
            id: id,
            selectedItem: selectedItem,
            setSelectedItem: setSelectedItem,
            focusedItem: focusedItem,
            setFocusedItem: setFocusedItem,
            onSelectedItemChange: onSelectedItemChange,
            isDisabled: isDisabled
        };
    }, [
        id,
        selectedItem,
        setSelectedItem,
        focusedItem,
        setFocusedItem,
        onSelectedItemChange,
        isDisabled
    ]);
    return $denZA.createElement((0, $97b771b7bfe74101$export$cf7203ccc57043c5).Provider, {
        value: contextValue
    }, $denZA.createElement("div", $2260767461f585e1$var$__assign({
        className: className
    }, props), $denZA.createElement("ul", {
        className: listClassName
    }, children)));
};
$2260767461f585e1$export$e7cdf232acff13df.Item = (0, $d36fe6b430223acd$export$24231bd1a3b914e5);





var $denZA = parcelRequire("denZA");
var $f265d8b34b3034b4$exports = {};
'use strict';
Object.defineProperty($f265d8b34b3034b4$exports, "__esModule", {
    value: true
});

var $7eLBQ = parcelRequire("7eLBQ");
Object.defineProperty($f265d8b34b3034b4$exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f265d8b34b3034b4$var$_interopRequireDefault($7eLBQ).default;
    }
});

var $9hsGH = parcelRequire("9hsGH");
Object.defineProperty($f265d8b34b3034b4$exports, 'DateUtils', {
    enumerable: true,
    get: function get() {
        return $f265d8b34b3034b4$var$_interopRequireDefault($9hsGH).default;
    }
});

var $1BThc = parcelRequire("1BThc");
Object.defineProperty($f265d8b34b3034b4$exports, 'LocaleUtils', {
    enumerable: true,
    get: function get() {
        return $f265d8b34b3034b4$var$_interopRequireDefault($1BThc).default;
    }
});

var $dF5u6 = parcelRequire("dF5u6");
Object.defineProperty($f265d8b34b3034b4$exports, 'ModifiersUtils', {
    enumerable: true,
    get: function get() {
        return $f265d8b34b3034b4$var$_interopRequireDefault($dF5u6).default;
    }
});
function $f265d8b34b3034b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $13275fc3d2f911a4$exports = {};

$13275fc3d2f911a4$exports = (parcelRequire("7Saq1"));



var $f012f27580660ad2$var$__assign = undefined && undefined.__assign || function() {
    $f012f27580660ad2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f012f27580660ad2$var$__assign.apply(this, arguments);
};
var $f012f27580660ad2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// adds an inner div to each day, so we can style it
var $f012f27580660ad2$var$renderDay = function(date) {
    return $denZA.createElement("div", {
        className: "DayPicker-DayInner"
    }, date.getDate());
};
/**
 * Poor mans keyboard mask.
 * Adds a dash ('-') between the dates when the user enters dates,
 * if the input is at 'DD' or 'DD-MM' (to add a dash after DD or MM).
 * Except if the user deleted text using backspace or delete
 */ var $f012f27580660ad2$var$maybeAddGuidingDash = function(inputRef) {
    return function(event) {
        if (!inputRef.current) return;
        if (event.key === 'Backspace' || event.key === 'Delete') return;
        var currentValue = inputRef.current.value;
        if (!/^\d\d(-\d\d)?$/gu.test(currentValue)) return;
        // hacky workaround to add the dash directly to the input field, without messing with the DayPicker's state
        inputRef.current.value = currentValue + "-";
    };
};
/**
 * formats a Date to a string on the format 'DD-MM-YY'
 */ var $f012f27580660ad2$var$formatDate = function(date) {
    if (!(0, $f265d8b34b3034b4$exports.DateUtils).isDate(date)) return '';
    var day = date.getUTCDate().toString().padStart(2, '0'); // 9 -> '09'
    var month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // 3 -> '04'
    var year = ("" + date.getUTCFullYear()).slice(2); // 2019 -> '19'
    return day + "-" + month + "-" + year;
};
/**
 * parses a date string from the format 'DD-MM-YY' to a Date
 * If it is invalid, it returns undefined
 */ var $f012f27580660ad2$var$parseDate = function(string) {
    if (typeof string !== 'string') return undefined;
    if (string.length !== 8) return undefined;
    var split = string.split('-');
    if (split.length !== 3) return undefined;
    var dayString = split[0];
    var monthString = split[1];
    var yearString = split[2];
    var dayNumber = Number.parseInt(dayString, 10);
    var monthNumber = Number.parseInt(monthString, 10) - 1;
    var yearNumber = Number.parseInt(yearString, 10);
    if (Number.isNaN(yearNumber) || yearString.length !== 2 || Number.isNaN(dayNumber) || dayNumber < 1 || dayNumber > 31 || Number.isNaN(monthNumber) || monthNumber < 0 || monthNumber > 11) return undefined;
    return new Date("20" + yearString + "-" + monthString + "-" + dayString + "T12:00:00Z"); // always set noon to avoid time zone issues
};
var $f012f27580660ad2$export$17334619f3ac2224 = function(_a) {
    var _b, _c;
    var onChange = _a.onChange, initialValue = _a.initialValue, _d = _a.startLabel, startLabel = _d === void 0 ? 'Start' : _d, _e = _a.endLabel, endLabel = _e === void 0 ? 'End' : _e, _f = _a.column, column = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g, _h = _a.startStatus, startStatus = _h === void 0 ? 'default' : _h, _j = _a.endStatus, endStatus = _j === void 0 ? 'default' : _j, startInputProps = _a.startInputProps, endInputProps = _a.endInputProps, helperText = _a.helperText, _k = _a.disabled, disabled = _k === void 0 ? false : _k, _l = _a.disableAutoFocus, disableAutoFocus = _l === void 0 ? false : _l, _m = _a.numberOfMonths, numberOfMonths = _m === void 0 ? 2 : _m;
    var _o = $f012f27580660ad2$var$__read((0, $denZA.useState)({
        start: undefined,
        end: undefined
    }), 2), range = _o[0], setRange = _o[1];
    var _p = $f012f27580660ad2$var$__read((0, $denZA.useState)(), 2), hoveringToDate = _p[0], setHoveringToDate = _p[1];
    // which month to show in the first (left) calendar when the 'end' field is open
    var _q = $f012f27580660ad2$var$__read((0, $denZA.useState)(), 2), firstMonthInToCalendar = _q[0], setFirstMonthInToCalendar = _q[1];
    var startInputRef = (0, $denZA.useRef)(null);
    var endInputRef = (0, $denZA.useRef)(null);
    var _r = $f012f27580660ad2$var$__read((0, $denZA.useState)(false), 2), selectStart = _r[0], setStart = _r[1];
    var start = range.start, end = range.end;
    // set the internal range state whenever the initialValue prop changes, making this a controlled component
    $denZA.useEffect(function() {
        setRange(initialValue !== null && initialValue !== void 0 ? initialValue : {
            start: undefined,
            end: undefined
        });
    }, [
        initialValue
    ]);
    // is called whenever 'start' or 'end' is changed, either by typing or clicking
    var handleRangeChange = function(isStart) {
        return function(date) {
            setHoveringToDate(undefined);
            var nextRange = {
                start: isStart ? date : start,
                end: isStart ? end : date
            };
            setRange(nextRange);
            onChange(nextRange);
        };
    };
    var inputIds = {
        start: startLabel.replace(/\s/gu, '') + "-start",
        end: endLabel.replace(/\s/gu, '') + "-end"
    };
    var combinedStatus = 'default';
    if (startStatus === 'error' || endStatus === 'error') combinedStatus = 'error';
    else if (startStatus === 'warning' || endStatus === 'warning') combinedStatus = 'warning';
    $denZA.useEffect(function() {
        var _a;
        if (start && !disableAutoFocus && selectStart) {
            (_a = endInputRef.current) === null || _a === void 0 || _a.focus();
            setStart(false);
        }
        if (start && end) {
            if (start > end) setRange({
                start: start,
                end: undefined
            });
        }
    }, [
        start,
        disableAutoFocus,
        selectStart,
        end
    ]);
    return $denZA.createElement("fieldset", {
        className: "DateRangePicker " + size + " " + (column ? 'DateRangePicker-column' : '')
    }, $denZA.createElement("div", {
        className: "FieldsContainer"
    }, $denZA.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, $denZA.createElement("label", {
        htmlFor: inputIds.start
    }, startLabel), $denZA.createElement((0, (/*@__PURE__*/$parcel$interopDefault($13275fc3d2f911a4$exports))), {
        dayPickerProps: {
            selectedDays: {
                from: start,
                to: end
            },
            // focus the 'end' input when the user selects a date
            onDayClick: function() {
                if (!disableAutoFocus) setStart(true);
            },
            modifiers: {
                start: start,
                end: end
            },
            firstDayOfWeek: 1,
            numberOfMonths: numberOfMonths,
            showWeekNumbers: true,
            renderDay: $f012f27580660ad2$var$renderDay
        },
        formatDate: $f012f27580660ad2$var$formatDate,
        inputProps: $f012f27580660ad2$var$__assign((_b = {
            ref: startInputRef,
            disabled: disabled === true || disabled === 'start',
            className: startStatus,
            // automatically add a dash to the input after 'DD' or 'DD-MM'
            onKeyUp: $f012f27580660ad2$var$maybeAddGuidingDash(startInputRef),
            // select the whole text when the user focuses the input field
            onFocus: function(event) {
                event.target.select();
            },
            id: inputIds.start
        }, _b['aria-label'] = startLabel, _b.autoComplete = 'off', _b), startInputProps),
        onDayChange: handleRangeChange(true),
        parseDate: $f012f27580660ad2$var$parseDate,
        placeholder: "DD-MM-YY",
        value: start
    })), $denZA.createElement("div", {
        style: {
            padding: '0.5rem'
        }
    }), $denZA.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        }
    }, $denZA.createElement("label", {
        htmlFor: inputIds.end
    }, endLabel), $denZA.createElement((0, (/*@__PURE__*/$parcel$interopDefault($13275fc3d2f911a4$exports))), {
        dayPickerProps: {
            // set selected days to the current 'hoveringToDate', or the 'end' date as a fallback - this is used to style the dates in between
            selectedDays: [
                start,
                {
                    from: start,
                    to: hoveringToDate !== null && hoveringToDate !== void 0 ? hoveringToDate : end
                }
            ],
            onDayMouseEnter: function(date) {
                /*
                        If hovering over a date that is before 'start', we don't want to show it.
                          If 'end' have already been set, set hover to that, to highlight start-end
                          if 'end' have not yet been set, hover at 'start' to not highlight anything
                        */ if (start && start > date) {
                    if (end) setHoveringToDate(end);
                    else setHoveringToDate(start);
                } else setHoveringToDate(date);
            },
            // don't allow selecting a date that is before 'start'
            disabledDays: start ? {
                before: start
            } : undefined,
            modifiers: {
                start: start,
                end: hoveringToDate !== null && hoveringToDate !== void 0 ? hoveringToDate : end
            },
            firstDayOfWeek: 1,
            month: firstMonthInToCalendar,
            fromMonth: start,
            numberOfMonths: numberOfMonths,
            showWeekNumbers: true,
            renderDay: $f012f27580660ad2$var$renderDay
        },
        formatDate: $f012f27580660ad2$var$formatDate,
        inputProps: $f012f27580660ad2$var$__assign((_c = {
            ref: endInputRef,
            disabled: disabled === true || disabled === 'end',
            className: endStatus,
            // automatically add a dash to the input after 'DD' or 'DD-MM'
            onKeyUp: $f012f27580660ad2$var$maybeAddGuidingDash(endInputRef),
            onFocus: function(event) {
                event.target.select();
            },
            id: inputIds.end
        }, _c['aria-label'] = endLabel, _c.autoComplete = 'off', _c), endInputProps),
        onDayChange: handleRangeChange(false),
        onDayPickerHide: function() {
            // unset hover state when calendar disappears
            setHoveringToDate(undefined);
        },
        onDayPickerShow: function() {
            // when showing the 'end' picker, we want to ensure that the correct months are shown:
            // if no range is selected, let the 'start' month be the first shown
            // if a range within the same month is selected, let the 'start' month be the first shown
            // if a multi-month range is selected, make the 'end' date be in the RIGHT calendar, by setting the left calendar to be the month before 'end'
            var nextFirstMonthInToCalendar = start;
            if (start instanceof Date && end instanceof Date && !(0, $f265d8b34b3034b4$exports.DateUtils).isSameMonth(start, end)) nextFirstMonthInToCalendar = (0, $f265d8b34b3034b4$exports.DateUtils).addMonths(end, -1);
            setFirstMonthInToCalendar(nextFirstMonthInToCalendar);
        },
        parseDate: $f012f27580660ad2$var$parseDate,
        placeholder: "DD-MM-YY",
        value: end
    }))), helperText && $denZA.createElement("div", {
        "aria-label": startLabel + " or " + endLabel,
        className: "HelperText " + combinedStatus,
        role: "alert"
    }, helperText));
};








var $denZA = parcelRequire("denZA");

var $a5fb96d96161834a$var$__assign = undefined && undefined.__assign || function() {
    $a5fb96d96161834a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a5fb96d96161834a$var$__assign.apply(this, arguments);
};
var $a5fb96d96161834a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a5fb96d96161834a$export$4071300121a182f5 = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, isOpen = _a.isOpen, _b = _a.mode, mode = _b === void 0 ? 'right' : _b, offset = _a.offset, props = $a5fb96d96161834a$var$__rest(_a, [
        "children",
        "isOpen",
        "mode",
        "offset"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var offsetStyles = {
        top: offset
    };
    return $denZA.createElement("div", {
        className: cn('drawer')
    }, $denZA.createElement("nav", $a5fb96d96161834a$var$__assign({
        className: cn('drawer-nav', {
            'is-open': isOpen,
            'from-left': mode === 'left',
            'from-right': mode === 'right',
            'is-fullscreen': mode === 'screen'
        }),
        style: offset ? offsetStyles : {}
    }, props, {
        ref: ref
    }), children));
});





var $denZA = parcelRequire("denZA");






var $denZA = parcelRequire("denZA");


var $25a30d99b12277d5$export$6648d5fa18559e7f = function(_a) {
    var _b;
    var _c = _a.selected, selected = _c === void 0 ? false : _c, value = _a.value, label = _a.label, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var clickHandler = $denZA.useCallback(function() {
        if (onClick) onClick({
            value: value,
            label: label
        });
    }, [
        value,
        label
    ]);
    return $denZA.createElement("div", {
        "aria-label": label,
        className: cn('dropdown-item', (_b = {}, _b['is-selected'] = selected, _b)),
        key: label,
        onClick: clickHandler,
        role: "button"
    }, $denZA.createElement("span", {
        className: cn('dropdown-item-content')
    }, label), selected && $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: $denZA.createElement((0, $ca35121afe25890a$export$add807e002afa321), null)
    }));
};
$25a30d99b12277d5$export$6648d5fa18559e7f.displayName = 'Dropdown.Item';


var $4f59921c5e698984$var$__assign = undefined && undefined.__assign || function() {
    $4f59921c5e698984$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f59921c5e698984$var$__assign.apply(this, arguments);
};
var $4f59921c5e698984$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * isSelected helper function
 * @param current
 * @param controlledValues
 */ var $4f59921c5e698984$var$isSelected = function(current, controlledValues) {
    if (!current || !controlledValues) return false;
    if (Array.isArray(controlledValues)) {
        if (controlledValues.length < 1) return false;
        return controlledValues.some(function(item) {
            return item.value === current;
        });
    }
    return current === controlledValues.value;
};
var $4f59921c5e698984$export$931cbfb6bfb85fc = $denZA.forwardRef(function(_a, ref) {
    var onDropdownSelect = _a.onDropdownSelect, children = _a.children, value = _a.value, _b = _a.isClipped, isClipped = _b === void 0 ? false : _b, _c = _a.isNarrow, isNarrow = _c === void 0 ? false : _c, _d = _a._hasFocus, _hasFocus = _d === void 0 ? false : _d, props = $4f59921c5e698984$var$__rest(_a, [
        "onDropdownSelect",
        "children",
        "value",
        "isClipped",
        "isNarrow",
        "_hasFocus"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var shared = (0, $c9bab4bc692bb080$export$38d56e9c4e5a652b)(ref);
    var portalRoot = (0, $e55e8a2120fd7762$export$6ecd3efa4eebe261)((0, $e55e8a2120fd7762$export$673c0f2dc34a292b).DROPDOWN).portalRoot;
    var clickHandler = $denZA.useCallback(function(option) {
        if (onDropdownSelect) onDropdownSelect(option);
    }, (0, $49d1557d9beb4649$export$2c66e96878bf4792));
    var providedChildren = $denZA.useMemo(function() {
        return $denZA.Children.map(children, function(child) {
            return $denZA.cloneElement(child, $4f59921c5e698984$var$__assign({
                onClick: clickHandler,
                selected: $4f59921c5e698984$var$isSelected(child.props.value, value)
            }, child.props));
        });
    }, [
        children
    ]);
    return $d486a8928008256a$exports.createPortal($denZA.createElement("div", $4f59921c5e698984$var$__assign({
        className: cn('dropdown', {
            'is-narrow': isNarrow,
            'is-clipped': isClipped
        }),
        ref: shared,
        role: "group"
    }, props), providedChildren), portalRoot);
});
$4f59921c5e698984$export$931cbfb6bfb85fc.Item = (0, $25a30d99b12277d5$export$6648d5fa18559e7f);





var $denZA = parcelRequire("denZA");

var $a02a493469d16616$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a02a493469d16616$var$defaultOptions = {
    inheritWidth: false,
    closeOnClickOutside: true
};
var $a02a493469d16616$var$DROPDOWN_OFFSET = 8;
var $a02a493469d16616$export$8c32fdb3462273b4 = function(dropdown, target, options) {
    if (options === void 0) options = $a02a493469d16616$var$defaultOptions;
    var _a = $a02a493469d16616$var$__read($denZA.useState(), 2), rect = _a[0], setRect = _a[1];
    var _b = $a02a493469d16616$var$__read($denZA.useState(false), 2), isOpen = _b[0], setVisible = _b[1];
    (0, $c611c5d883831cb2$export$1896bab46732d207)(dropdown, function() {
        if (options.closeOnClickOutside) setVisible(false);
    }, [
        options.closeOnClickOutside
    ]);
    var toggleVisible = function() {
        return setVisible(function(prev) {
            return !prev;
        });
    };
    var setPosition = function(domRect) {
        if (dropdown.current && domRect) {
            var top_1 = domRect.top, left = domRect.left, height = domRect.height, width = domRect.width;
            dropdown.current.style.position = 'absolute';
            dropdown.current.style.top = top_1 + height + $a02a493469d16616$var$DROPDOWN_OFFSET + "px";
            dropdown.current.style.left = left + "px";
            if (options.inheritWidth) dropdown.current.style.width = width + "px";
        }
    };
    var updateRect = function() {
        if (dropdown.current && target.current) setRect(target.current.getBoundingClientRect());
    };
    // Initialize the position of the dropdown.
    // TODO: document event listeners should be removed in the future.
    $denZA.useLayoutEffect(function() {
        if (dropdown.current && target.current) setRect(target.current.getBoundingClientRect());
        window.addEventListener('resize', updateRect);
        return function() {
            window.removeEventListener('resize', updateRect);
        };
    }, [
        target,
        dropdown
    ]);
    $denZA.useLayoutEffect(function() {
        setPosition(rect);
    }, [
        rect
    ]);
    $denZA.useEffect(function() {
        updateRect();
        if (dropdown.current) {
            if (isOpen) setPosition(rect);
            dropdown.current.style.display = isOpen ? '' : 'none';
        }
    }, [
        isOpen,
        dropdown
    ]);
    return {
        setVisible: setVisible,
        toggleVisible: toggleVisible,
        isOpen: isOpen
    };
};





var $denZA = parcelRequire("denZA");
var $108f06fe02e48b21$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $108f06fe02e48b21$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * KlikErrorBoundary
 */ var $108f06fe02e48b21$export$c0ae8bb4140c23c0 = /** @class */ function(_super) {
    $108f06fe02e48b21$var$__extends(KlikErrorBoundary, _super);
    function KlikErrorBoundary(_a) {
        var component = _a.component, props = $108f06fe02e48b21$var$__rest(_a, [
            "component"
        ]);
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        _this.component = component;
        return _this;
    }
    KlikErrorBoundary.getDerivedStateFromError = function(_error) {
        return {
            hasError: true
        };
    };
    KlikErrorBoundary.prototype.componentDidCatch = function(_error, _errorInfo) {
    // TODO: log to sentry
    };
    KlikErrorBoundary.prototype.render = function() {
        var hasError = this.state.hasError;
        var children = this.props.children;
        if (hasError && this.component) return this.component;
        if (hasError) return $denZA.createElement("h1", null, "The App stepped on a brick and crashed");
        return children;
    };
    return KlikErrorBoundary;
}($denZA.Component);





var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");


var $4fce7b9b6378f354$var$__assign = undefined && undefined.__assign || function() {
    $4fce7b9b6378f354$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fce7b9b6378f354$var$__assign.apply(this, arguments);
};
var $4fce7b9b6378f354$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4fce7b9b6378f354$export$a67c0bc59081311a = $denZA.forwardRef(function(_a, ref) {
    var label = _a.label, size = _a.size, props = $4fce7b9b6378f354$var$__rest(_a, [
        "label",
        "size"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var fontSize = (0, $20817d17cc29bb87$export$26ca5b065308b0d1)(size);
    return $denZA.createElement("p", $4fce7b9b6378f354$var$__assign({
        ref: ref
    }, props, {
        className: cn('help', fontSize)
    }), label);
});





var $denZA = parcelRequire("denZA");


var $47a262fe25e646ba$var$__assign = undefined && undefined.__assign || function() {
    $47a262fe25e646ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $47a262fe25e646ba$var$__assign.apply(this, arguments);
};
var $47a262fe25e646ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $47a262fe25e646ba$export$b04be29aa201d4f5 = $denZA.forwardRef(function(_a, ref) {
    var label = _a.label, htmlFor = _a.htmlFor, form = _a.form, size = _a.size, props = $47a262fe25e646ba$var$__rest(_a, [
        "label",
        "htmlFor",
        "form",
        "size"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var fontSize = (0, $20817d17cc29bb87$export$26ca5b065308b0d1)(size);
    return $denZA.createElement("div", $47a262fe25e646ba$var$__assign({
        className: cn('form-label', fontSize),
        ref: ref
    }, props), $denZA.createElement("label", {
        form: form,
        htmlFor: htmlFor
    }, label));
});





var $denZA = parcelRequire("denZA");

var $b2d7e56af1ad27ba$var$__assign = undefined && undefined.__assign || function() {
    $b2d7e56af1ad27ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2d7e56af1ad27ba$var$__assign.apply(this, arguments);
};
var $b2d7e56af1ad27ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec = $denZA.forwardRef(function Input(_a, ref) {
    var _b;
    var _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, isFlexible = _a.isFlexible, isRequired = _a.isRequired, _e = _a.validationStatus, validationStatus = _e === void 0 ? '' : _e, props = $b2d7e56af1ad27ba$var$__rest(_a, [
        "isDisabled",
        "size",
        "isFlexible",
        "isRequired",
        "validationStatus"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("textarea", $b2d7e56af1ad27ba$var$__assign({
        className: cn('input', (_b = {}, _b["is-" + size] = size, _b['is-flexible'] = isFlexible, _b["status-" + validationStatus] = validationStatus, _b["is-disabled"] = isDisabled, _b)),
        ref: ref,
        required: isRequired
    }, props));
});





var $denZA = parcelRequire("denZA");

var $50b672410cbc3674$var$__assign = undefined && undefined.__assign || function() {
    $50b672410cbc3674$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50b672410cbc3674$var$__assign.apply(this, arguments);
};
var $50b672410cbc3674$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $50b672410cbc3674$export$2c73285ae9390cec = $denZA.forwardRef(function Input(_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.isFlexible, isFlexible = _e === void 0 ? false : _e, _f = _a.isRequired, isRequired = _f === void 0 ? false : _f, _g = _a.validationStatus, validationStatus = _g === void 0 ? '' : _g, _h = _a.type, type = _h === void 0 ? 'text' : _h, props = $50b672410cbc3674$var$__rest(_a, [
        "size",
        "isDisabled",
        "isFlexible",
        "isRequired",
        "validationStatus",
        "type"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("input", $50b672410cbc3674$var$__assign({
        className: cn('input', (_b = {}, _b["is-" + size] = size, _b['is-flexible'] = isFlexible, _b["status-" + validationStatus] = validationStatus, _b["is-disabled"] = isDisabled, _b)),
        ref: ref,
        required: isRequired,
        type: type
    }, props));
});




var $f17f0d4dac27dd1d$var$__assign = undefined && undefined.__assign || function() {
    $f17f0d4dac27dd1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f17f0d4dac27dd1d$var$__assign.apply(this, arguments);
};
var $f17f0d4dac27dd1d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f17f0d4dac27dd1d$export$a7fed597f4b8afd8 = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $f17f0d4dac27dd1d$var$__rest(_a, [
        "children"
    ]);
    return $denZA.createElement("form", $f17f0d4dac27dd1d$var$__assign({}, props, {
        ref: ref
    }), children);
});
$f17f0d4dac27dd1d$export$a7fed597f4b8afd8.TextArea = (0, $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec);
$f17f0d4dac27dd1d$export$a7fed597f4b8afd8.TextField = (0, $50b672410cbc3674$export$2c73285ae9390cec);
$f17f0d4dac27dd1d$export$a7fed597f4b8afd8.Label = (0, $47a262fe25e646ba$export$b04be29aa201d4f5);
$f17f0d4dac27dd1d$export$a7fed597f4b8afd8.HelpText = (0, $4fce7b9b6378f354$export$a67c0bc59081311a);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $bb16d03ccf0bf36f$export$7eeca4f9565066a1 = function(_a) {
    var label = _a.label, logo = _a.logo, href = _a.href, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('header-brand')
    }, $denZA.createElement("a", {
        className: cn('header-logo'),
        href: href,
        onClick: onClick
    }, logo), $denZA.createElement("p", {
        className: cn('header-name')
    }, label));
};
$bb16d03ccf0bf36f$export$7eeca4f9565066a1.displayName = 'Header.Brand';



var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");


var $bd1cbac930fbba19$var$__assign = undefined && undefined.__assign || function() {
    $bd1cbac930fbba19$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd1cbac930fbba19$var$__assign.apply(this, arguments);
};
var $bd1cbac930fbba19$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bd1cbac930fbba19$var$contextMap = {
    li: {
        wrapper: 'header-dropdown-item',
        element: 'header-dropdown-link'
    },
    div: {
        wrapper: 'header-nav-item',
        element: 'header-nav-item-trigger'
    }
};
var $bd1cbac930fbba19$export$874a25df02b6ade7 = function(_a) {
    var _b;
    var children = _a.children, active = _a.isActive, label = _a.label, _c = _a.behaviour, behaviour = _c === void 0 ? 'text' : _c, icon = _a.icon, _d = _a._context, _context = _d === void 0 ? 'div' : _d;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _e = $bd1cbac930fbba19$var$__read($denZA.useState(false), 2), isOpen = _e[0], toggleIsOpen = _e[1];
    var Component = _context;
    var wrapperClasses = cn((_b = {}, _b[$bd1cbac930fbba19$var$contextMap[_context].wrapper] = true, _b['is-active'] = active, _b));
    var elementClasses = $bd1cbac930fbba19$var$contextMap[_context].element;
    if (icon) {
        var classes = cn('header-icon', {
            'is-active': active
        });
        return $denZA.createElement(Component, {
            className: classes
        }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
            as: "button",
            icon: icon
        }));
    }
    if (behaviour === 'dropdown') {
        var handleMenuExpand = function() {
            toggleIsOpen(function(prev) {
                return !prev;
            });
        };
        var dropDownChild = function() {
            if ($denZA.isValidElement(children)) return $denZA.cloneElement(children, $bd1cbac930fbba19$var$__assign({
                isOpen: isOpen
            }, children.props));
            return undefined;
        };
        return $denZA.createElement(Component, {
            className: wrapperClasses
        }, $denZA.createElement("button", {
            className: cn(elementClasses, {
                'is-open': isOpen
            }),
            onClick: handleMenuExpand
        }, label, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
            as: "span",
            className: cn({
                'is-open': isOpen
            }),
            icon: $denZA.createElement((0, $1a05ede52b3619cf$export$1fa5a43af950a186), null)
        })), dropDownChild());
    }
    if (behaviour === 'link') return $denZA.createElement(Component, {
        className: wrapperClasses
    }, children);
    // FIX HREF ATTRIBUTE with a real path
    return $denZA.createElement(Component, {
        className: wrapperClasses
    }, $denZA.createElement("a", {
        className: cn(elementClasses),
        href: "/"
    }, children));
};
$bd1cbac930fbba19$export$874a25df02b6ade7.displayName = 'Header.Item';


var $d8902704512ad1d3$var$__assign = undefined && undefined.__assign || function() {
    $d8902704512ad1d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d8902704512ad1d3$var$__assign.apply(this, arguments);
};
var $d8902704512ad1d3$export$e93b0271171ef3a = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('header-dropdown', {
            'is-open': isOpen
        })
    }, $denZA.createElement("ul", {
        className: cn('header-dropdown-menu')
    }, $denZA.Children.map(children, function(child) {
        if ($denZA.isValidElement(child)) return $denZA.createElement((0, $bd1cbac930fbba19$export$874a25df02b6ade7), $d8902704512ad1d3$var$__assign({
            _context: "li"
        }, child.props));
        return child;
    })));
};
$d8902704512ad1d3$export$e93b0271171ef3a.displayName = 'Header.Dropdown';


/* eslint-disable react/jsx-no-bind */ 
var $denZA = parcelRequire("denZA");

var $baee1db9ff83456f$export$544c0cc1f2471d5c = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("nav", {
        className: cn('header-nav'),
        id: "headerNav"
    }, children);
};



var $denZA = parcelRequire("denZA");

/* eslint-disable react/jsx-no-bind */ 

var $denZA = parcelRequire("denZA");


var $3b02a5d921648ea6$export$92c1304de87d1a00 = function() {
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var toggle = function() {
        var navigation = document.getElementById('headerNav');
        var overlay = document.getElementById('headerNavOverlay');
        if (navigation && overlay) {
            navigation.classList.toggle(cn('is-open'));
            overlay.classList.toggle(cn('is-open'));
        }
    };
    return {
        toggle: toggle
    };
};
var $3b02a5d921648ea6$export$758743339b817716 = function(_a) {
    var onBurgerClickHandler = _a.onBurgerClickHandler;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var toggle = $3b02a5d921648ea6$export$92c1304de87d1a00().toggle;
    var classes = cn('header-icon', 'is-burger');
    var expandMenuClickHandler = function() {
        toggle();
        if (onBurgerClickHandler) onBurgerClickHandler();
    };
    // TODO: the icon should be an <Icon as="button" icon={MenuNavigationVertical}/>
    return $denZA.createElement("div", {
        className: classes
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "button",
        icon: $denZA.createElement((0, $90f3899778b50a07$export$56dbed97f074c6e4), null),
        onClick: expandMenuClickHandler
    }));
};
$3b02a5d921648ea6$export$758743339b817716.displayName = 'Header.BurgerItem'; // /**
 //  * Overlay
 //  */
 // export const Overlay: React.FunctionComponent = () => {
 //   const cn = useFrameworkClassnamePrefixer();
 //   const { toggle } = useBurgerMenu();
 //   return <div className={cn('header-overlay')} id="headerNavOverlay" onClick={toggle} />;
 // };



var $ae74a71b474fcc96$var$__assign = undefined && undefined.__assign || function() {
    $ae74a71b474fcc96$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae74a71b474fcc96$var$__assign.apply(this, arguments);
};
var $ae74a71b474fcc96$export$55509f68abe8b44e = function(_a) {
    var children = _a.children, onBurgerClickHandler = _a.onBurgerClickHandler;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("nav", {
        className: cn('header-icons')
    }, $denZA.Children.map(children, function(child) {
        if ($denZA.isValidElement(child)) return $denZA.createElement((0, $bd1cbac930fbba19$export$874a25df02b6ade7), $ae74a71b474fcc96$var$__assign({
            behaviour: "icon"
        }, child.props));
        return child;
    }), $denZA.createElement((0, $3b02a5d921648ea6$export$758743339b817716), {
        onBurgerClickHandler: onBurgerClickHandler
    }));
};
$ae74a71b474fcc96$export$55509f68abe8b44e.displayName = 'Header.IconGroup';



var $e92df155358c547d$var$__assign = undefined && undefined.__assign || function() {
    $e92df155358c547d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e92df155358c547d$var$__assign.apply(this, arguments);
};
var $e92df155358c547d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e92df155358c547d$export$8b251419efc915eb = $denZA.forwardRef(function Header(_a, ref) {
    var children = _a.children, props = $e92df155358c547d$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("header", $e92df155358c547d$var$__assign({
        className: cn('header'),
        ref: ref
    }, props), $denZA.createElement("div", {
        className: cn('header-body')
    }, children));
});
$e92df155358c547d$export$8b251419efc915eb.Item = (0, $bd1cbac930fbba19$export$874a25df02b6ade7);
$e92df155358c547d$export$8b251419efc915eb.Brand = (0, $bb16d03ccf0bf36f$export$7eeca4f9565066a1);
$e92df155358c547d$export$8b251419efc915eb.Dropdown = (0, $d8902704512ad1d3$export$e93b0271171ef3a);
$e92df155358c547d$export$8b251419efc915eb.IconGroup = (0, $ae74a71b474fcc96$export$55509f68abe8b44e);
$e92df155358c547d$export$8b251419efc915eb.Group = (0, $baee1db9ff83456f$export$544c0cc1f2471d5c);









var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");


var $3626b20da7671b3a$var$__assign = undefined && undefined.__assign || function() {
    $3626b20da7671b3a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3626b20da7671b3a$var$__assign.apply(this, arguments);
};
var $3626b20da7671b3a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3626b20da7671b3a$export$a7b06bfba60a8a78 = function(_a) {
    var _b = _a.as, as = _b === void 0 ? 'div' : _b, contentBefore = _a.contentBefore, contentAfter = _a.contentAfter, title = _a.title, content = _a.content, props = $3626b20da7671b3a$var$__rest(_a, [
        "as",
        "contentBefore",
        "contentAfter",
        "title",
        "content"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), $3626b20da7671b3a$var$__assign({
        as: as
    }, props, {
        className: cn('list-item')
    }), // eslint-disable-next-line no-null/no-null
    contentBefore ? contentBefore : null, $denZA.createElement("div", {
        className: cn('list-item-content')
    }, $denZA.createElement("p", {
        className: cn('list-item-title')
    }, title), content && $denZA.createElement("div", {
        className: cn('list-item-body')
    }, content)), // eslint-disable-next-line no-null/no-null
    contentAfter ? contentAfter : null);
};
$3626b20da7671b3a$export$a7b06bfba60a8a78.displayName = 'List.ListItem';


var $28bb06004d90ff5c$var$__assign = undefined && undefined.__assign || function() {
    $28bb06004d90ff5c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28bb06004d90ff5c$var$__assign.apply(this, arguments);
};
var $28bb06004d90ff5c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $28bb06004d90ff5c$export$54c2e3dc7acea9f5 = function(_a) {
    var children = _a.children, isBorderless = _a.isBorderless, props = $28bb06004d90ff5c$var$__rest(_a, [
        "children",
        "isBorderless"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('list', {
        'is-borderless': isBorderless
    });
    return $denZA.createElement("div", $28bb06004d90ff5c$var$__assign({
        className: className
    }, props), children);
};
$28bb06004d90ff5c$export$54c2e3dc7acea9f5.ListItem = (0, $3626b20da7671b3a$export$a7b06bfba60a8a78);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $9f90552e04e9b191$export$9aa902172f77c978 = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var dropDownClasses = cn('menu-blocks', {
        'is-open': isOpen
    });
    return $denZA.createElement("div", {
        className: dropDownClasses
    }, children);
};
$9f90552e04e9b191$export$9aa902172f77c978.displayName = 'Menu.Blocks';



var $denZA = parcelRequire("denZA");

var $87705888fa4d5a08$export$c7794ca2de686af4 = function(_a) {
    var children = _a.children, isOpen = _a.isOpen;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var dropDownClasses = cn('menu-dropdown', {
        'is-open': isOpen
    });
    return $denZA.createElement("div", {
        className: dropDownClasses
    }, children);
};
$87705888fa4d5a08$export$c7794ca2de686af4.displayName = 'Menu.Dropdown';



var $denZA = parcelRequire("denZA");

var $dbff1f822a99c6e3$export$981fb8ff62be65c8 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('menu-icons')
    }, children);
};
$dbff1f822a99c6e3$export$981fb8ff62be65c8.displayName = 'Menu.Icons';


/* eslint-disable react/jsx-no-bind */ 
var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");



var $cd31d7ca69c4cbf1$export$27d2ad3c5815583e = function(_a) {
    var _b;
    var _c = _a.as, as = _c === void 0 ? 'button' : _c, iconRight = _a.iconRight, iconCenter = _a.iconCenter, children = _a.children, onClick = _a.onClick, parentClass = _a.parentClass;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('menu-trigger', (_b = {}, _b["" + parentClass] = parentClass, _b));
    if (iconCenter) {
        var textClasses = cn('text');
        return $denZA.createElement($cd31d7ca69c4cbf1$export$27d2ad3c5815583e, {
            parentClass: "is-icon"
        }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
            icon: iconCenter
        }), $denZA.createElement("div", {
            className: textClasses
        }, children));
    }
    return $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), {
        as: as,
        className: className,
        onClick: onClick
    }, children, iconRight && $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: iconRight
    }));
};
$cd31d7ca69c4cbf1$export$27d2ad3c5815583e.displayName = 'Menu.Trigger';


var $07dab1c9359f9365$var$contextMap = {
    li: {
        wrapper: 'menu-item',
        element: 'menu-trigger'
    },
    div: {
        wrapper: 'menu-item',
        element: 'menu-trigger'
    }
};
var $07dab1c9359f9365$export$2ce376c2cc3355c8 = function(_a) {
    var _b;
    var children = _a.children, isActive = _a.isActive, _c = _a._context, _context = _c === void 0 ? 'div' : _c, isOpen = _a.isOpen;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var Component = _context;
    var wrapperClasses = cn((_b = {}, _b[$07dab1c9359f9365$var$contextMap[_context].wrapper] = true, _b['is-active'] = isActive, _b['is-open'] = isOpen, _b));
    if (typeof children === 'string') return $denZA.createElement(Component, {
        className: wrapperClasses
    }, $denZA.createElement((0, $cd31d7ca69c4cbf1$export$27d2ad3c5815583e), null, children));
    return $denZA.createElement(Component, {
        className: wrapperClasses
    }, children);
};
$07dab1c9359f9365$export$2ce376c2cc3355c8.displayName = 'Menu.Item';



var $denZA = parcelRequire("denZA");


var $2f93a59a92a92ea6$var$__assign = undefined && undefined.__assign || function() {
    $2f93a59a92a92ea6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f93a59a92a92ea6$var$__assign.apply(this, arguments);
};
var $2f93a59a92a92ea6$export$d4c4e98c5044dc8 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("ul", {
        className: cn('menu-list')
    }, $denZA.Children.map(children, function(child) {
        if ($denZA.isValidElement(child)) return $denZA.createElement((0, $07dab1c9359f9365$export$2ce376c2cc3355c8), $2f93a59a92a92ea6$var$__assign({
            _context: "li"
        }, child.props));
        return child;
    }));
};
$2f93a59a92a92ea6$export$d4c4e98c5044dc8.displayName = 'Menu.List';




var $denZA = parcelRequire("denZA");


var $a001d925749cdaa9$export$8ebf4bc57ff5021 = function(_a) {
    var label = _a.label, page = _a.page, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    if (page === 0) // eslint-disable-next-line no-null/no-null
    return null;
    return $denZA.createElement("button", {
        className: cn('menu-pages-back'),
        onClick: onClick
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: $denZA.createElement((0, $36bf889250647b17$export$e4c291d45fea4cd0), null)
    }), $denZA.createElement("span", null, label));
};
$a001d925749cdaa9$export$8ebf4bc57ff5021.displayName = 'MenuPages.PagesBack';
var $a001d925749cdaa9$export$68e46bfb56b31de9 = function(_a) {
    var onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("button", {
        className: cn('menu-pages-close'),
        onClick: onClick
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: $denZA.createElement((0, $ea57c3c51f0db820$export$44fbda67c66d275), null)
    }));
};
$a001d925749cdaa9$export$68e46bfb56b31de9.displayName = 'MenuPages.PagesClose';
var $a001d925749cdaa9$export$3d67f97c8ce1ce96 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var dropDownClasses = cn('menu-pages-header');
    return $denZA.createElement("div", {
        className: dropDownClasses
    }, children);
};
$a001d925749cdaa9$export$3d67f97c8ce1ce96.displayName = 'MenuPages.PagesHeader';
var $a001d925749cdaa9$export$4e5528e8d9514c2e = function(_a) {
    var children = _a.children, page = _a.page;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var dropDownClasses = cn('menu-pages-list');
    return $denZA.createElement("div", {
        className: dropDownClasses
    }, $denZA.Children.map(children, function(child, index) {
        if (page === index) return child;
        // eslint-disable-next-line no-null/no-null
        return null;
    }));
};
$a001d925749cdaa9$export$4e5528e8d9514c2e.displayName = 'MenuPages.PagesList';
var $a001d925749cdaa9$export$1c7e879bbf33896c = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('menu-page')
    }, children);
};
$a001d925749cdaa9$export$1c7e879bbf33896c.displayName = 'MenuPages.Page';
var $a001d925749cdaa9$export$c9ade7ad40f5ee0 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('menu-pages')
    }, children);
};
$a001d925749cdaa9$export$c9ade7ad40f5ee0.Header = $a001d925749cdaa9$export$3d67f97c8ce1ce96;
$a001d925749cdaa9$export$c9ade7ad40f5ee0.List = $a001d925749cdaa9$export$4e5528e8d9514c2e;
$a001d925749cdaa9$export$c9ade7ad40f5ee0.Back = $a001d925749cdaa9$export$8ebf4bc57ff5021;
$a001d925749cdaa9$export$c9ade7ad40f5ee0.Close = $a001d925749cdaa9$export$68e46bfb56b31de9;
$a001d925749cdaa9$export$c9ade7ad40f5ee0.Page = $a001d925749cdaa9$export$1c7e879bbf33896c;
$a001d925749cdaa9$export$c9ade7ad40f5ee0.displayName = 'Menu.Pages';



var $denZA = parcelRequire("denZA");

var $437b2c0800ede859$export$5cef8db5139658fa = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('menu-stack')
    }, children);
};
$437b2c0800ede859$export$5cef8db5139658fa.displayName = 'Menu.Stack';



var $9b19d9cf55b495d3$export$d9b273488cd8ce6f = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('menu')
    }, children);
};
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Dropdown = (0, $87705888fa4d5a08$export$c7794ca2de686af4);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.List = (0, $2f93a59a92a92ea6$export$d4c4e98c5044dc8);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Stack = (0, $437b2c0800ede859$export$5cef8db5139658fa);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Blocks = (0, $9f90552e04e9b191$export$9aa902172f77c978);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Icons = (0, $dbff1f822a99c6e3$export$981fb8ff62be65c8);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Item = (0, $07dab1c9359f9365$export$2ce376c2cc3355c8);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Trigger = (0, $cd31d7ca69c4cbf1$export$27d2ad3c5815583e);
$9b19d9cf55b495d3$export$d9b273488cd8ce6f.Pages = (0, $a001d925749cdaa9$export$c9ade7ad40f5ee0);






var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $e462f4354cf0137d$var$__assign = undefined && undefined.__assign || function() {
    $e462f4354cf0137d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e462f4354cf0137d$var$__assign.apply(this, arguments);
};
var $e462f4354cf0137d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e462f4354cf0137d$export$4772a6b0d09e1d41 = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $e462f4354cf0137d$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $e462f4354cf0137d$var$__assign({
        className: cn('toast-actions')
    }, props, {
        ref: ref
    }), $denZA.createElement("div", {
        className: cn('buttons', 'is-end')
    }, children));
});
$e462f4354cf0137d$export$4772a6b0d09e1d41.displayName = 'Modal.Action';



var $denZA = parcelRequire("denZA");

var $b5e1ec0cb67d9c71$var$__assign = undefined && undefined.__assign || function() {
    $b5e1ec0cb67d9c71$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5e1ec0cb67d9c71$var$__assign.apply(this, arguments);
};
var $b5e1ec0cb67d9c71$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b5e1ec0cb67d9c71$export$cb540d8b0ef7906c = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $b5e1ec0cb67d9c71$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $b5e1ec0cb67d9c71$var$__assign({
        className: cn('toast-body')
    }, props, {
        ref: ref
    }), children);
});
$b5e1ec0cb67d9c71$export$cb540d8b0ef7906c.displayName = 'Modal.Body';



var $denZA = parcelRequire("denZA");

var $c81c05d80a7678bb$var$__assign = undefined && undefined.__assign || function() {
    $c81c05d80a7678bb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c81c05d80a7678bb$var$__assign.apply(this, arguments);
};
var $c81c05d80a7678bb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c81c05d80a7678bb$export$9af27c346834c182 = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $c81c05d80a7678bb$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $c81c05d80a7678bb$var$__assign({
        className: cn('toast-heading'),
        ref: ref
    }, props), children);
});
$c81c05d80a7678bb$export$9af27c346834c182.displayName = 'Modal.Heading';



var $denZA = parcelRequire("denZA");

var $18e9bd4c260f6222$var$__assign = undefined && undefined.__assign || function() {
    $18e9bd4c260f6222$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $18e9bd4c260f6222$var$__assign.apply(this, arguments);
};
var $18e9bd4c260f6222$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $18e9bd4c260f6222$export$3e66242728a15052 = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $18e9bd4c260f6222$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $18e9bd4c260f6222$var$__assign({
        className: cn('toast-inset'),
        ref: ref
    }, props), children);
});
$18e9bd4c260f6222$export$3e66242728a15052.displayName = 'Modal.Inset';


var $ca747c7cf976dab1$var$__assign = undefined && undefined.__assign || function() {
    $ca747c7cf976dab1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca747c7cf976dab1$var$__assign.apply(this, arguments);
};
var $ca747c7cf976dab1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ca747c7cf976dab1$export$2b77a92f1a5ad772 = $denZA.forwardRef(function(_a, ref) {
    var _b;
    var heading = _a.heading, body = _a.body, action = _a.action, icon = _a.icon, _c = _a.status, status = _c === void 0 ? '' : _c, exitClickHandler = _a.exitClickHandler, props = $ca747c7cf976dab1$var$__rest(_a, [
        "heading",
        "body",
        "action",
        "icon",
        "status",
        "exitClickHandler"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var statusClasses = (_b = {
        'toast-status': status
    }, _b["status-" + status] = status, _b);
    return $denZA.createElement("div", $ca747c7cf976dab1$var$__assign({
        className: cn('modal-container'),
        ref: ref
    }, props, {
        role: "dialog"
    }), $denZA.createElement("div", {
        className: cn('toast', statusClasses)
    }, $denZA.createElement("div", {
        className: cn('toast-main')
    }, icon && $denZA.createElement("div", {
        className: cn('toast-icon')
    }, icon), $denZA.createElement("div", {
        className: cn('toast-content')
    }, heading, body)), $denZA.createElement("button", {
        className: cn('toast-close'),
        onClick: exitClickHandler,
        tabIndex: 0
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        "aria-label": "close",
        icon: $denZA.createElement((0, $ea57c3c51f0db820$export$44fbda67c66d275), null)
    })), action));
});
$ca747c7cf976dab1$export$2b77a92f1a5ad772.Heading = (0, $c81c05d80a7678bb$export$9af27c346834c182);
$ca747c7cf976dab1$export$2b77a92f1a5ad772.Body = (0, $b5e1ec0cb67d9c71$export$cb540d8b0ef7906c);
$ca747c7cf976dab1$export$2b77a92f1a5ad772.Action = (0, $e462f4354cf0137d$export$4772a6b0d09e1d41);
$ca747c7cf976dab1$export$2b77a92f1a5ad772.Inset = (0, $18e9bd4c260f6222$export$3e66242728a15052);





var $denZA = parcelRequire("denZA");


var $3a717be46ffbdf53$var$__assign = undefined && undefined.__assign || function() {
    $3a717be46ffbdf53$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a717be46ffbdf53$var$__assign.apply(this, arguments);
};
var $3a717be46ffbdf53$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a717be46ffbdf53$export$c055307528189a65;
(function(OverlayMode) {
    OverlayMode["Container"] = "container";
    OverlayMode["Page"] = "page";
})($3a717be46ffbdf53$export$c055307528189a65 || ($3a717be46ffbdf53$export$c055307528189a65 = {}));
var $3a717be46ffbdf53$export$c6fdb837b070b4ff = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, _b = _a.mode, mode = _b === void 0 ? $3a717be46ffbdf53$export$c055307528189a65.Page : _b, onClick = _a.onClick, isOpen = _a.isOpen, props = $3a717be46ffbdf53$var$__rest(_a, [
        "children",
        "mode",
        "onClick",
        "isOpen"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var overlayRef = (0, $c9bab4bc692bb080$export$38d56e9c4e5a652b)(ref);
    var clickHandler = $denZA.useCallback(function(e) {
        if (overlayRef.current === e.target) {
            if (onClick) onClick();
        }
    }, [
        onClick
    ]);
    return $denZA.createElement("div", $3a717be46ffbdf53$var$__assign({
        className: cn('overlay', "overlay-" + mode, {
            'is-open': isOpen
        }),
        onClick: clickHandler,
        ref: overlayRef,
        role: "presentation",
        tabIndex: -1
    }, props), children);
});






var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");


var $2b59abf75747fd58$export$8302fb64fcdab778;
(function(PaginationAction) {
    PaginationAction["Next"] = "Next";
    PaginationAction["Prev"] = "Prev";
    PaginationAction["First"] = "First";
    PaginationAction["Last"] = "Last";
})($2b59abf75747fd58$export$8302fb64fcdab778 || ($2b59abf75747fd58$export$8302fb64fcdab778 = {}));
var $2b59abf75747fd58$export$c3639e97caabff2c = $denZA.forwardRef(function(_a, ref) {
    var label = _a.label, icon = _a.icon, withText = _a.withText, navAction = _a.navAction, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b, hasFocus = _a.hasFocus, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var sharedRef = $denZA.useRef(null);
    var onPaginationItemClick = $denZA.useCallback(function() {
        if (onClick && navAction !== undefined) onClick(navAction);
    }, []);
    $denZA.useEffect(function() {
        if (hasFocus) {
            if (sharedRef.current) sharedRef.current.focus();
        }
    }, [
        hasFocus,
        ref
    ]);
    var onKeyDown = $denZA.useCallback(function(e) {
        if (hasFocus) switch(e.key){
            case 'Enter':
                e.preventDefault();
                if (onClick && navAction !== undefined) onClick(navAction);
        }
    }, [
        hasFocus
    ]);
    return $denZA.createElement("li", {
        className: cn('pagination-item', 'is-icon')
    }, $denZA.createElement("button", {
        "data-text": label,
        onClick: onPaginationItemClick,
        onKeyDown: onKeyDown,
        ref: sharedRef,
        role: "button",
        tabIndex: !hasFocus ? -1 : 0
    }, iconPosition === 'right' || $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: icon
    }), withText !== null && withText !== void 0 ? withText : $denZA.createElement("span", {
        className: cn('pagination-item-text')
    }, label), iconPosition === 'left' || $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: icon
    })));
});



var $denZA = parcelRequire("denZA");

var $3f8147016ae6dfd3$export$c82a077939f0464b = function(_a) {
    var page = _a.page, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.isEllipsis, isEllipsis = _c === void 0 ? false : _c, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var onPaginationItemClick = $denZA.useCallback(function() {
        if (onClick) onClick(page);
    }, [
        page
    ]);
    var pagelabel = !isEllipsis ? page : '...';
    return $denZA.createElement("li", {
        className: cn('pagination-item', {
            'is-active': isSelected
        }),
        role: "presentation"
    }, $denZA.createElement("button", {
        "aria-label": "" + page,
        "data-text": pagelabel,
        onClick: onPaginationItemClick,
        tabIndex: -1
    }, $denZA.createElement("span", {
        className: cn('pagination-item-text')
    }, pagelabel)));
};


/* eslint-disable react/jsx-no-bind */ 
var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");







var $denZA = parcelRequire("denZA");



var $bc0ce3c6185f306a$var$__assign = undefined && undefined.__assign || function() {
    $bc0ce3c6185f306a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc0ce3c6185f306a$var$__assign.apply(this, arguments);
};
var $bc0ce3c6185f306a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc0ce3c6185f306a$export$3288d34c523a1192 = $denZA.forwardRef(function(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, label = _a.label, isDisabled = _a.isDisabled, showDelete = _a.showDelete, isInteractive = _a.isInteractive, onDelete = _a.onDelete, onClick = _a.onClick, props = $bc0ce3c6185f306a$var$__rest(_a, [
        "size",
        "label",
        "isDisabled",
        "showDelete",
        "isInteractive",
        "onDelete",
        "onClick"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("span", $bc0ce3c6185f306a$var$__assign({
        className: cn('tag', "is-" + size, {
            'is-disabled': isDisabled
        }),
        ref: ref
    }, props), $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), {
        as: isInteractive ? 'button' : 'span',
        className: cn('tag-item'),
        onClick: isInteractive ? onClick : undefined
    }, label), showDelete && $denZA.createElement("button", {
        className: cn('tag-item', 'is-icon'),
        onClick: onDelete
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: $denZA.createElement((0, $ea57c3c51f0db820$export$44fbda67c66d275), null)
    })));
});



var $denZA = parcelRequire("denZA");

var $bef6394bf8d8ed55$export$b72686b556e29ca6 = function(_a) {
    var _b;
    var children = _a.children, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var className = cn('tags', (_b = {}, _b["are-" + size] = size, _b));
    return $denZA.createElement("div", {
        className: className
    }, children);
};




var $cee932fc0fd65edc$var$__assign = undefined && undefined.__assign || function() {
    $cee932fc0fd65edc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cee932fc0fd65edc$var$__assign.apply(this, arguments);
};
var $cee932fc0fd65edc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cee932fc0fd65edc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cee932fc0fd65edc$export$ef9b1a59e592288f = $denZA.forwardRef(function(_a, ref) {
    var value = _a.value, name = _a.name, children = _a.children, onOptionSelect = _a.onOptionSelect, onOptionDelete = _a.onOptionDelete, _b = _a.isMultiSelect, isMultiSelect = _b === void 0 ? false : _b, props = $cee932fc0fd65edc$var$__rest(_a, [
        "value",
        "name",
        "children",
        "onOptionSelect",
        "onOptionDelete",
        "isMultiSelect"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var dropdown = $denZA.useRef(null);
    // eslint-disable-next-line no-null/no-null
    var input = $denZA.useRef(null);
    var select = (0, $c9bab4bc692bb080$export$38d56e9c4e5a652b)(ref);
    var _c = (0, $a02a493469d16616$export$8c32fdb3462273b4)(dropdown, select, {
        inheritWidth: true
    }), toggleVisible = _c.toggleVisible, setVisible = _c.setVisible;
    var _d = $cee932fc0fd65edc$var$__read($denZA.useState(false), 2), hasFocus = _d[0], setHasFocus = _d[1];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _e = $cee932fc0fd65edc$var$__read($denZA.useState(false), 2), dropdownFocus = _e[0], setDropdownFocus = _e[1];
    (0, $c611c5d883831cb2$export$1896bab46732d207)(dropdown, function() {
        setVisible(false);
    });
    var handleClick = $denZA.useCallback(function(event) {
        event.stopPropagation();
        setVisible(function(isOpen) {
            if (isOpen && isMultiSelect) return true;
            return !isOpen;
        });
    }, [
        input,
        isMultiSelect
    ]);
    var displayValue = $denZA.useMemo(function() {
        var _a;
        if (isMultiSelect) {
            var actualValue = value;
            if (actualValue.length > 0) {
                var tags = Array.from(actualValue).map(function(val) {
                    return $denZA.createElement((0, $bc0ce3c6185f306a$export$3288d34c523a1192), {
                        key: val.label + val.value,
                        label: val.label,
                        onDelete: function() {
                            if (onOptionDelete) onOptionDelete(val);
                        },
                        showDelete: true
                    });
                });
                return $denZA.createElement((0, $bef6394bf8d8ed55$export$b72686b556e29ca6), null, tags);
            } else return 'Select one or more options';
        } else return (_a = value) === null || _a === void 0 ? void 0 : _a.label;
    }, [
        value
    ]);
    var onKeyDown = function(e) {
        if (hasFocus) switch(e.key){
            case ' ':
                e.preventDefault();
                toggleVisible();
                setDropdownFocus(true);
                return;
        }
    };
    return $denZA.createElement("div", $cee932fc0fd65edc$var$__assign({}, props, {
        className: cn('input', 'is-select'),
        onClick: (0, $efef0f8ceb54059d$export$e08e3b67e392101e)(handleClick, props.onClick),
        onFocus: function() {
            return setHasFocus(true);
        },
        onKeyDown: (0, $efef0f8ceb54059d$export$e08e3b67e392101e)(onKeyDown, props.onKeyDown),
        ref: select,
        role: "input",
        tabIndex: hasFocus ? 0 : -1
    }), $denZA.createElement("span", {
        className: cn('input-content')
    }, displayValue), $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        icon: $denZA.createElement((0, $1a05ede52b3619cf$export$1fa5a43af950a186), null)
    }), $denZA.createElement("input", {
        className: cn('input-hidden'),
        name: name,
        readOnly: true,
        ref: input,
        value: JSON.stringify(value)
    }), $denZA.createElement((0, $4f59921c5e698984$export$931cbfb6bfb85fc), {
        _hasFocus: dropdownFocus,
        onDropdownSelect: onOptionSelect,
        ref: dropdown,
        value: value
    }, children));
});
$cee932fc0fd65edc$export$ef9b1a59e592288f.Option = (0, $25a30d99b12277d5$export$6648d5fa18559e7f);




var $60530867ebf2143c$var$standardSelectionRange = [
    {
        label: '10',
        value: 10
    },
    {
        label: '20',
        value: 20
    },
    {
        label: '50',
        value: 50
    },
    {
        label: '100',
        value: 100
    }
];
var $60530867ebf2143c$export$f3c3b6eb4de78615 = function(_a) {
    var _b = _a.description, description = _b === void 0 ? 'Results per page' : _b, _c = _a.sizeOptions, sizeOptions = _c === void 0 ? $60530867ebf2143c$var$standardSelectionRange : _c, onSizeChange = _a.onSizeChange;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var onSelect = $denZA.useCallback(function(_a) {
        var value = _a.value;
        if (onSizeChange) onSizeChange(value);
    }, [
        sizeOptions
    ]);
    var options = $denZA.useMemo(function() {
        return sizeOptions.map(function(size) {
            return $denZA.createElement((0, $cee932fc0fd65edc$export$ef9b1a59e592288f).Option, {
                key: size.value,
                label: size.label,
                value: size.value
            });
        });
    }, [
        sizeOptions
    ]);
    return $denZA.createElement("div", {
        "aria-label": "pagination result",
        className: cn('pagination-results'),
        role: "presentation"
    }, $denZA.createElement("p", {
        className: cn('pagination-results-label')
    }, description), $denZA.createElement((0, $cee932fc0fd65edc$export$ef9b1a59e592288f), {
        onOptionSelect: onSelect,
        tabIndex: 0
    }, options));
};



var $denZA = parcelRequire("denZA");

var $65b279ea19ac28cc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $65b279ea19ac28cc$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($65b279ea19ac28cc$var$__read(arguments[i]));
    return ar;
};
var $65b279ea19ac28cc$var$itemsAmout = 7;
var $65b279ea19ac28cc$var$startEndAmount = 4;
var $65b279ea19ac28cc$export$f80c710216eae131 = function(_a) {
    var page = _a.page, totalPages = _a.totalPages, _b = _a.nextLabel, nextLabel = _b === void 0 ? 'Next' : _b, _c = _a.prevLabel, prevLabel = _c === void 0 ? 'Previous' : _c, _d = _a.lastLabel, lastLabel = _d === void 0 ? 'Last' : _d, _e = _a.firstLabel, firstLabel = _e === void 0 ? 'First' : _e, _f = _a.showLabel, showLabel = _f === void 0 ? true : _f, onPageClick = _a.onPageClick;
    var _g = $65b279ea19ac28cc$var$__read($denZA.useState(page), 2), currentPage = _g[0], setCurrentPage = _g[1];
    var onClick = function(clickedPage) {
        setCurrentPage(clickedPage);
    };
    var onNavigationClick = function(action) {
        switch(action){
            case (0, $2b59abf75747fd58$export$8302fb64fcdab778).First:
                setCurrentPage(1);
                break;
            case (0, $2b59abf75747fd58$export$8302fb64fcdab778).Last:
                setCurrentPage(totalPages);
                break;
            case (0, $2b59abf75747fd58$export$8302fb64fcdab778).Next:
                setCurrentPage(function(prev) {
                    return prev !== totalPages ? ++prev : prev;
                });
                break;
            case (0, $2b59abf75747fd58$export$8302fb64fcdab778).Prev:
                setCurrentPage(function(prev) {
                    return prev !== 1 ? --prev : prev;
                });
                break;
        }
    };
    $denZA.useLayoutEffect(function() {
        if (onPageClick) onPageClick(currentPage);
    }, [
        currentPage
    ]);
    var fullLayout = function() {
        var items = [];
        for(var index = 1; index <= totalPages; index++)items = $65b279ea19ac28cc$var$__spread(items, [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page
            }
        ]);
        return items;
    };
    var edgeLayout = function() {
        var items = [];
        if (page > totalPages - $65b279ea19ac28cc$var$startEndAmount) {
            items = $65b279ea19ac28cc$var$__spread(items, [
                {
                    key: 1,
                    onClick: onClick,
                    page: 1
                }
            ]);
            items = $65b279ea19ac28cc$var$__spread(items, [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0
                }
            ]);
        }
        for(var index = 1; index <= 5; index++){
            var itemPage = page <= 4 ? index : totalPages - 5 + index;
            var isSelected = itemPage === page;
            items = $65b279ea19ac28cc$var$__spread(items, [
                {
                    key: itemPage,
                    onClick: onClick,
                    page: itemPage,
                    isSelected: isSelected
                }
            ]);
        }
        if (page <= $65b279ea19ac28cc$var$startEndAmount) {
            items = $65b279ea19ac28cc$var$__spread(items, [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0
                }
            ]);
            items = $65b279ea19ac28cc$var$__spread(items, [
                {
                    key: totalPages,
                    onClick: onClick,
                    page: totalPages
                }
            ]);
        }
        return items;
    };
    var middleLayout = function() {
        var items = [];
        items = $65b279ea19ac28cc$var$__spread(items, [
            {
                key: 1,
                onClick: onClick,
                page: 1
            }
        ]);
        items = $65b279ea19ac28cc$var$__spread(items, [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0
            }
        ]);
        for(var index = page - 1; index < page + 2; index++)items = $65b279ea19ac28cc$var$__spread(items, [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page
            }
        ]);
        items = $65b279ea19ac28cc$var$__spread(items, [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0
            }
        ]);
        items = $65b279ea19ac28cc$var$__spread(items, [
            {
                key: totalPages,
                onClick: onClick,
                page: totalPages
            }
        ]);
        return items;
    };
    var getPaginationItems = $denZA.useCallback(function() {
        if (totalPages <= $65b279ea19ac28cc$var$itemsAmout) return fullLayout();
        if (page > $65b279ea19ac28cc$var$startEndAmount && page <= totalPages - $65b279ea19ac28cc$var$startEndAmount) return middleLayout();
        return edgeLayout();
    }, [
        page,
        totalPages
    ]);
    var getNavigation = function() {
        return {
            prev: function() {
                return {
                    ariaLabel: prevLabel,
                    label: showLabel ? prevLabel : '',
                    navAction: (0, $2b59abf75747fd58$export$8302fb64fcdab778).Prev,
                    onClick: onNavigationClick
                };
            },
            next: function() {
                return {
                    ariaLabel: nextLabel,
                    label: showLabel ? nextLabel : '',
                    iconPosition: 'right',
                    navAction: (0, $2b59abf75747fd58$export$8302fb64fcdab778).Next,
                    onClick: onNavigationClick
                };
            },
            first: function() {
                return {
                    ariaLabel: firstLabel,
                    label: showLabel ? firstLabel : '',
                    navAction: (0, $2b59abf75747fd58$export$8302fb64fcdab778).First,
                    onClick: onNavigationClick
                };
            },
            last: function() {
                return {
                    ariaLabel: lastLabel,
                    label: showLabel ? lastLabel : '',
                    iconPosition: 'right',
                    navAction: (0, $2b59abf75747fd58$export$8302fb64fcdab778).Last,
                    onClick: onNavigationClick
                };
            }
        };
    };
    return {
        getPaginationItems: getPaginationItems,
        getNavigation: getNavigation
    };
};


var $a426674027101122$var$__assign = undefined && undefined.__assign || function() {
    $a426674027101122$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a426674027101122$var$__assign.apply(this, arguments);
};
var $a426674027101122$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a426674027101122$export$68f5e1453c188a82 = function(_a) {
    var _b = _a.isCentered, isCentered = _b === void 0 ? false : _b, _c = _a.isStacked, isStacked = _c === void 0 ? false : _c, showFirstLast = _a.showFirstLast, showPageSizeSelector = _a.showPageSizeSelector, onSizeChange = _a.onSizeChange, props = $a426674027101122$var$__rest(_a, [
        "isCentered",
        "isStacked",
        "showFirstLast",
        "showPageSizeSelector",
        "onSizeChange"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _d = (0, $65b279ea19ac28cc$export$f80c710216eae131)($a426674027101122$var$__assign({}, props)), getPaginationItems = _d.getPaginationItems, getNavigation = _d.getNavigation;
    // eslint-disable-next-line no-null/no-null
    var sharedRef = $denZA.useRef(null);
    var onFocus = function() {
        var _a;
        (_a = sharedRef.current) === null || _a === void 0 || _a.focus();
    };
    return $denZA.createElement("nav", {
        "aria-label": "pagination navigation",
        className: cn('pagination', {
            'is-centered': isCentered,
            'is-stacked': isStacked
        }),
        // eslint-disable-next-line react/jsx-no-bind
        onFocus: onFocus,
        tabIndex: 0
    }, $denZA.createElement("ol", {
        className: cn('pagination-list')
    }, showFirstLast && $denZA.createElement((0, $2b59abf75747fd58$export$c3639e97caabff2c), $a426674027101122$var$__assign({
        icon: $denZA.createElement((0, $ac257ca03c82dc0f$export$ea9a5c7ec18f8eaf), null)
    }, getNavigation().first())), $denZA.createElement((0, $2b59abf75747fd58$export$c3639e97caabff2c), $a426674027101122$var$__assign({
        icon: $denZA.createElement((0, $ac257ca03c82dc0f$export$ea9a5c7ec18f8eaf), null)
    }, getNavigation().prev())), getPaginationItems().map(function(_a) {
        var key = _a.key, item = $a426674027101122$var$__rest(_a, [
            "key"
        ]);
        return $denZA.createElement((0, $3f8147016ae6dfd3$export$c82a077939f0464b), $a426674027101122$var$__assign({
            key: key
        }, item));
    }), $denZA.createElement((0, $2b59abf75747fd58$export$c3639e97caabff2c), $a426674027101122$var$__assign({
        icon: $denZA.createElement((0, $01c576487ae13177$export$d6d021d74f4bac76), null)
    }, getNavigation().next())), showFirstLast && $denZA.createElement((0, $2b59abf75747fd58$export$c3639e97caabff2c), $a426674027101122$var$__assign({
        icon: $denZA.createElement((0, $01c576487ae13177$export$d6d021d74f4bac76), null)
    }, getNavigation().last()))), showPageSizeSelector && $denZA.createElement((0, $60530867ebf2143c$export$f3c3b6eb4de78615), {
        onSizeChange: onSizeChange
    }));
};






var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $115e86979909e1fc$var$__assign = undefined && undefined.__assign || function() {
    $115e86979909e1fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $115e86979909e1fc$var$__assign.apply(this, arguments);
};
var $115e86979909e1fc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $115e86979909e1fc$export$e4d8dc88bb9cc931 = $denZA.forwardRef(function(_a, ref) {
    var label = _a.label, arrowPosition = _a.arrowPosition, props = $115e86979909e1fc$var$__rest(_a, [
        "label",
        "arrowPosition"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $115e86979909e1fc$var$__assign({
        className: cn('toast', 'popover', 'tooltip', arrowPosition),
        ref: ref,
        tabIndex: -1
    }, props), $denZA.createElement("div", {
        className: cn('arrow-below')
    }), $denZA.createElement("div", {
        className: cn('arrow-above')
    }), $denZA.createElement("div", {
        className: cn('toast-main')
    }, $denZA.createElement("div", {
        className: cn('toast-content')
    }, $denZA.createElement("div", {
        className: cn('toast-body')
    }, $denZA.createElement("p", null, label)))));
});



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
function $69056a6870357082$export$2e2bcd8739ae039(element) {
    var rect = element.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        x: rect.left,
        y: rect.top
    };
}


/*:: import type { Window } from '../types'; */ /*:: declare function getWindow(node: Node | Window): Window; */ function $48a707365a591d1f$export$2e2bcd8739ae039(node) {
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $2473799f338209d1$export$2e2bcd8739ae039(node) {
    var win = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */ function $735045e7618807f1$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */ function $735045e7618807f1$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */ function $735045e7618807f1$export$af51f0f06c0f328a(node) {
    var OwnElement = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


function $d24feb910a52b10a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $398c846111dc3d38$export$2e2bcd8739ae039(node) {
    if (node === (0, $48a707365a591d1f$export$2e2bcd8739ae039)(node) || !(0, $735045e7618807f1$export$1b3bfaa9684536aa)(node)) return (0, $2473799f338209d1$export$2e2bcd8739ae039)(node);
    else return (0, $d24feb910a52b10a$export$2e2bcd8739ae039)(node);
}


function $f0ad2e6fa9de341c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $5c3703843f46e145$export$2e2bcd8739ae039(element) {
    // $FlowFixMe: assume body is always available
    return (((0, $735045e7618807f1$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $5e796fbcb902c67f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $69056a6870357082$export$2e2bcd8739ae039)((0, $5c3703843f46e145$export$2e2bcd8739ae039)(element)).left + (0, $2473799f338209d1$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $042e63c265d6f70e$export$2e2bcd8739ae039(element) {
    return (0, $48a707365a591d1f$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $d66b5f9934fc28a8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}


function $b837a4cd8c5c7915$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var documentElement = (0, $5c3703843f46e145$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $69056a6870357082$export$2e2bcd8739ae039)(elementOrVirtualElement);
    var isOffsetParentAnElement = (0, $735045e7618807f1$export$1b3bfaa9684536aa)(offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d66b5f9934fc28a8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $398c846111dc3d38$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $735045e7618807f1$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $69056a6870357082$export$2e2bcd8739ae039)(offsetParent);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5e796fbcb902c67f$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}


// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function $65e748c44474ad1e$export$2e2bcd8739ae039(element) {
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: element.offsetWidth,
        height: element.offsetHeight
    };
}




function $dd4549a519872889$export$2e2bcd8739ae039(element) {
    if ((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(element) === 'html') return element;
    return element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    (0, $5c3703843f46e145$export$2e2bcd8739ae039)(element) // fallback
    ;
}





function $ca281693b8ccf69f$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe: assume body is always available
    return node.ownerDocument.body;
    if ((0, $735045e7618807f1$export$1b3bfaa9684536aa)(node) && (0, $d66b5f9934fc28a8$export$2e2bcd8739ae039)(node)) return node;
    return $ca281693b8ccf69f$export$2e2bcd8739ae039((0, $dd4549a519872889$export$2e2bcd8739ae039)(node));
}






function $92eb43ed4b51f923$export$2e2bcd8739ae039(element, list) {
    if (list === void 0) list = [];
    var scrollParent = (0, $ca281693b8ccf69f$export$2e2bcd8739ae039)(element);
    var isBody = (0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(scrollParent) === 'body';
    var win = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d66b5f9934fc28a8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($92eb43ed4b51f923$export$2e2bcd8739ae039((0, $dd4549a519872889$export$2e2bcd8739ae039)(target)));
}







function $c2bc873187a21fbf$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(element)) >= 0;
}




function $da086ae96c5807e2$var$getTrueOffsetParent(element) {
    if (!(0, $735045e7618807f1$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    var offsetParent = element.offsetParent;
    if (offsetParent) {
        var html = (0, $5c3703843f46e145$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(offsetParent).position === 'static' && (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(html).position !== 'static') return html;
    }
    return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $da086ae96c5807e2$var$getContainingBlock(element) {
    var currentNode = (0, $dd4549a519872889$export$2e2bcd8739ae039)(element);
    while((0, $735045e7618807f1$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $da086ae96c5807e2$export$2e2bcd8739ae039(element) {
    var window = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(element);
    var offsetParent = $da086ae96c5807e2$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c2bc873187a21fbf$export$2e2bcd8739ae039)(offsetParent) && (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $da086ae96c5807e2$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && (0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $042e63c265d6f70e$export$2e2bcd8739ae039)(offsetParent).position === 'static') return window;
    return offsetParent || $da086ae96c5807e2$var$getContainingBlock(element) || window;
}



var $dce98d96c03bdc14$export$1e95b668f3b82d = 'top';
var $dce98d96c03bdc14$export$40e543e69a8b3fbb = 'bottom';
var $dce98d96c03bdc14$export$79ffe56a765070d2 = 'right';
var $dce98d96c03bdc14$export$eabcd2c8791e7bf4 = 'left';
var $dce98d96c03bdc14$export$dfb5619354ba860 = 'auto';
var $dce98d96c03bdc14$export$aec2ce47c367b8c3 = [
    $dce98d96c03bdc14$export$1e95b668f3b82d,
    $dce98d96c03bdc14$export$40e543e69a8b3fbb,
    $dce98d96c03bdc14$export$79ffe56a765070d2,
    $dce98d96c03bdc14$export$eabcd2c8791e7bf4
];
var $dce98d96c03bdc14$export$b3571188c770cc5a = 'start';
var $dce98d96c03bdc14$export$bd5df0f255a350f8 = 'end';
var $dce98d96c03bdc14$export$390fd549c5303b4d = 'clippingParents';
var $dce98d96c03bdc14$export$d7b7311ec04a3e8f = 'viewport';
var $dce98d96c03bdc14$export$ae5ab1c730825774 = 'popper';
var $dce98d96c03bdc14$export$ca50aac9f3ba507f = 'reference';
var $dce98d96c03bdc14$export$368f9a87e87fa4e1 = /*#__PURE__*/ $dce98d96c03bdc14$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $dce98d96c03bdc14$export$b3571188c770cc5a,
        placement + "-" + $dce98d96c03bdc14$export$bd5df0f255a350f8
    ]);
}, []);
var $dce98d96c03bdc14$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($dce98d96c03bdc14$export$aec2ce47c367b8c3, [
    $dce98d96c03bdc14$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $dce98d96c03bdc14$export$b3571188c770cc5a,
        placement + "-" + $dce98d96c03bdc14$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $dce98d96c03bdc14$export$421679a7c3d56e = 'beforeRead';
var $dce98d96c03bdc14$export$aafa59e2e03f2942 = 'read';
var $dce98d96c03bdc14$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $dce98d96c03bdc14$export$c65e99957a05207c = 'beforeMain';
var $dce98d96c03bdc14$export$f22da7240b7add18 = 'main';
var $dce98d96c03bdc14$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $dce98d96c03bdc14$export$8d4d2d70e7d46032 = 'beforeWrite';
var $dce98d96c03bdc14$export$68d8715fc104d294 = 'write';
var $dce98d96c03bdc14$export$70a6e5159acce2e6 = 'afterWrite';
var $dce98d96c03bdc14$export$d087d3878fdf71d5 = [
    $dce98d96c03bdc14$export$421679a7c3d56e,
    $dce98d96c03bdc14$export$aafa59e2e03f2942,
    $dce98d96c03bdc14$export$6964f6c886723980,
    $dce98d96c03bdc14$export$c65e99957a05207c,
    $dce98d96c03bdc14$export$f22da7240b7add18,
    $dce98d96c03bdc14$export$bab79516f2d662fe,
    $dce98d96c03bdc14$export$8d4d2d70e7d46032,
    $dce98d96c03bdc14$export$68d8715fc104d294,
    $dce98d96c03bdc14$export$70a6e5159acce2e6
];


function $3d2b32c6502895d6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3d2b32c6502895d6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3d2b32c6502895d6$var$order(modifiers); // order based on phase
    return (0, $dce98d96c03bdc14$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $64de559867e9ce8b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $911836f84861e628$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
            options: Object.assign(Object.assign({}, existing.options), current.options),
            data: Object.assign(Object.assign({}, existing.data), current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $75b61832a482ce7a$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $75b61832a482ce7a$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $75b61832a482ce7a$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $75b61832a482ce7a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $75b61832a482ce7a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $75b61832a482ce7a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign(Object.assign({}, $75b61832a482ce7a$var$DEFAULT_OPTIONS), defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(options) {
                cleanupModifierEffects();
                state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
                state.scrollParents = {
                    reference: (0, $735045e7618807f1$export$45a5e7f76e0caa8d)(reference) ? (0, $92eb43ed4b51f923$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $92eb43ed4b51f923$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $92eb43ed4b51f923$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3d2b32c6502895d6$export$2e2bcd8739ae039)((0, $911836f84861e628$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$75b61832a482ce7a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b837a4cd8c5c7915$export$2e2bcd8739ae039)(reference, (0, $da086ae96c5807e2$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $65e748c44474ad1e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $64de559867e9ce8b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$75b61832a482ce7a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $75b61832a482ce7a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $75b61832a482ce7a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $f79221392923f70a$var$passive = {
    passive: true
};
function $f79221392923f70a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $f79221392923f70a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $f79221392923f70a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $f79221392923f70a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $f79221392923f70a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $f79221392923f70a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $f79221392923f70a$var$effect,
    data: {}
};



function $6e691f41cc209c94$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $31cd36d7712f9ed1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $3fe25c99941c2f28$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $781542c84e40294d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $31cd36d7712f9ed1$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $dce98d96c03bdc14$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $dce98d96c03bdc14$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $dce98d96c03bdc14$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3fe25c99941c2f28$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $dce98d96c03bdc14$export$b3571188c770cc5a:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
                break;
            case 0, $dce98d96c03bdc14$export$bd5df0f255a350f8:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ca052d4c1fc9bb85$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $781542c84e40294d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ca052d4c1fc9bb85$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ca052d4c1fc9bb85$var$popperOffsets,
    data: {}
};








var $de6260142264e8a2$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $de6260142264e8a2$var$roundOffsets(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: Math.round(x * dpr) / dpr || 0,
        y: Math.round(y * dpr) / dpr || 0
    };
}
function $de6260142264e8a2$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive;
    var _roundOffsets = $de6260142264e8a2$var$roundOffsets(offsets), x = _roundOffsets.x, y = _roundOffsets.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4);
    var sideY = (0, $dce98d96c03bdc14$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $da086ae96c5807e2$export$2e2bcd8739ae039)(popper);
        if (offsetParent === (0, $48a707365a591d1f$export$2e2bcd8739ae039)(popper)) offsetParent = (0, $5c3703843f46e145$export$2e2bcd8739ae039)(popper);
         // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        /*:: offsetParent = (offsetParent: Element); */ if (placement === (0, $dce98d96c03bdc14$export$1e95b668f3b82d)) {
            sideY = (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb);
            y -= offsetParent.clientHeight - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4)) {
            sideX = (0, $dce98d96c03bdc14$export$79ffe56a765070d2);
            x -= offsetParent.clientWidth - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $de6260142264e8a2$var$unsetSides);
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $de6260142264e8a2$var$computeStyles(_ref3) {
    var state = _ref3.state, options = _ref3.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), $de6260142264e8a2$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), $de6260142264e8a2$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false
    })));
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $de6260142264e8a2$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $de6260142264e8a2$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $ac17dfe0f87e1cd3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $735045e7618807f1$export$1b3bfaa9684536aa)(element) || !(0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $ac17dfe0f87e1cd3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $735045e7618807f1$export$1b3bfaa9684536aa)(element) || !(0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $ac17dfe0f87e1cd3$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $ac17dfe0f87e1cd3$var$applyStyles,
    effect: $ac17dfe0f87e1cd3$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $496b9d8fc7e1441e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4),
        (0, $dce98d96c03bdc14$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4),
        (0, $dce98d96c03bdc14$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $496b9d8fc7e1441e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $dce98d96c03bdc14$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $496b9d8fc7e1441e$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $496b9d8fc7e1441e$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $496b9d8fc7e1441e$var$offset
};


var $5da5985b75c408fa$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $5da5985b75c408fa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $5da5985b75c408fa$var$hash[matched];
    });
}



var $fc9813019922d638$var$hash = {
    start: 'end',
    end: 'start'
};
function $fc9813019922d638$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $fc9813019922d638$var$hash[matched];
    });
}







function $3e5756203164100b$export$2e2bcd8739ae039(element) {
    var win = (0, $48a707365a591d1f$export$2e2bcd8739ae039)(element);
    var html = (0, $5c3703843f46e145$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5e796fbcb902c67f$export$2e2bcd8739ae039)(element),
        y: y
    };
}






function $e79892ea4874fee2$export$2e2bcd8739ae039(element) {
    var html = (0, $5c3703843f46e145$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $2473799f338209d1$export$2e2bcd8739ae039)(element);
    var body = element.ownerDocument.body;
    var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5e796fbcb902c67f$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $042e63c265d6f70e$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $11a347ede51ebc83$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $735045e7618807f1$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $3bf728023e31ed65$export$2e2bcd8739ae039(rect) {
    return Object.assign(Object.assign({}, rect), {}, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}


function $481a45b317c8d1a6$var$getInnerBoundingClientRect(element) {
    var rect = (0, $69056a6870357082$export$2e2bcd8739ae039)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $481a45b317c8d1a6$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $dce98d96c03bdc14$export$d7b7311ec04a3e8f) ? (0, $3bf728023e31ed65$export$2e2bcd8739ae039)((0, $3e5756203164100b$export$2e2bcd8739ae039)(element)) : (0, $735045e7618807f1$export$1b3bfaa9684536aa)(clippingParent) ? $481a45b317c8d1a6$var$getInnerBoundingClientRect(clippingParent) : (0, $3bf728023e31ed65$export$2e2bcd8739ae039)((0, $e79892ea4874fee2$export$2e2bcd8739ae039)((0, $5c3703843f46e145$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $481a45b317c8d1a6$var$getClippingParents(element) {
    var clippingParents = (0, $92eb43ed4b51f923$export$2e2bcd8739ae039)((0, $dd4549a519872889$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $042e63c265d6f70e$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $735045e7618807f1$export$1b3bfaa9684536aa)(element) ? (0, $da086ae96c5807e2$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $735045e7618807f1$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $735045e7618807f1$export$45a5e7f76e0caa8d)(clippingParent) && (0, $11a347ede51ebc83$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $f0ad2e6fa9de341c$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $481a45b317c8d1a6$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $481a45b317c8d1a6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $481a45b317c8d1a6$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = Math.max(rect.top, accRect.top);
        accRect.right = Math.min(rect.right, accRect.right);
        accRect.bottom = Math.min(rect.bottom, accRect.bottom);
        accRect.left = Math.max(rect.left, accRect.left);
        return accRect;
    }, $481a45b317c8d1a6$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}







function $3fad322a9559bc15$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $1f945a81f6180847$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign(Object.assign({}, (0, $3fad322a9559bc15$export$2e2bcd8739ae039)()), paddingObject);
}


function $348fa2e5f20a91a2$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $776506833c477f57$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $dce98d96c03bdc14$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $dce98d96c03bdc14$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $dce98d96c03bdc14$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $1f945a81f6180847$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $348fa2e5f20a91a2$export$2e2bcd8739ae039)(padding, (0, $dce98d96c03bdc14$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $dce98d96c03bdc14$export$ae5ab1c730825774) ? (0, $dce98d96c03bdc14$export$ca50aac9f3ba507f) : (0, $dce98d96c03bdc14$export$ae5ab1c730825774);
    var referenceElement = state.elements.reference;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $481a45b317c8d1a6$export$2e2bcd8739ae039)((0, $735045e7618807f1$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $5c3703843f46e145$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $69056a6870357082$export$2e2bcd8739ae039)(referenceElement);
    var popperOffsets = (0, $781542c84e40294d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $3bf728023e31ed65$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, popperRect), popperOffsets));
    var elementClientRect = elementContext === (0, $dce98d96c03bdc14$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $dce98d96c03bdc14$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $dce98d96c03bdc14$export$79ffe56a765070d2),
                (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $dce98d96c03bdc14$export$1e95b668f3b82d),
                (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $2edb7e61fb877815$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $dce98d96c03bdc14$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $31cd36d7712f9ed1$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $dce98d96c03bdc14$export$368f9a87e87fa4e1) : (0, $dce98d96c03bdc14$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $31cd36d7712f9ed1$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $dce98d96c03bdc14$export$aec2ce47c367b8c3); // $FlowFixMe
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $776506833c477f57$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $9ee62c7cb9690e11$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement) === (0, $dce98d96c03bdc14$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $5da5985b75c408fa$export$2e2bcd8739ae039)(placement);
    return [
        (0, $fc9813019922d638$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $fc9813019922d638$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $9ee62c7cb9690e11$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $5da5985b75c408fa$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $9ee62c7cb9690e11$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement) === (0, $dce98d96c03bdc14$export$dfb5619354ba860) ? (0, $2edb7e61fb877815$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $31cd36d7712f9ed1$export$2e2bcd8739ae039)(placement) === (0, $dce98d96c03bdc14$export$b3571188c770cc5a);
        var isVertical = [
            (0, $dce98d96c03bdc14$export$1e95b668f3b82d),
            (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $776506833c477f57$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $dce98d96c03bdc14$export$79ffe56a765070d2) : (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb) : (0, $dce98d96c03bdc14$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $5da5985b75c408fa$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $5da5985b75c408fa$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $9ee62c7cb9690e11$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $9ee62c7cb9690e11$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $43b0edfd4b184a5e$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}


function $923d9eb4027ab953$export$2e2bcd8739ae039(min, value, max) {
    return Math.max(min, Math.min(value, max));
}







function $b68d97ff4f49c4e2$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $776506833c477f57$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $31cd36d7712f9ed1$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3fe25c99941c2f28$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $43b0edfd4b184a5e$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
        placement: state.placement
    })) : tetherOffset;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var mainSide = mainAxis === 'y' ? (0, $dce98d96c03bdc14$export$1e95b668f3b82d) : (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb) : (0, $dce98d96c03bdc14$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = popperOffsets[mainAxis] + overflow[mainSide];
        var max = popperOffsets[mainAxis] - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $dce98d96c03bdc14$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $dce98d96c03bdc14$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $65e748c44474ad1e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $3fad322a9559bc15$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $923d9eb4027ab953$export$2e2bcd8739ae039)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
        var arrowOffsetParent = state.elements.arrow && (0, $da086ae96c5807e2$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
        var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $923d9eb4027ab953$export$2e2bcd8739ae039)(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _mainSide = mainAxis === 'x' ? (0, $dce98d96c03bdc14$export$1e95b668f3b82d) : (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb) : (0, $dce98d96c03bdc14$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var _preventedOffset = (0, $923d9eb4027ab953$export$2e2bcd8739ae039)(_min, _offset, _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b68d97ff4f49c4e2$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b68d97ff4f49c4e2$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};












function $ea58bbe2a7e31870$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6e691f41cc209c94$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $3fe25c99941c2f28$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4),
        (0, $dce98d96c03bdc14$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = state.modifiersData[name + "#persistent"].padding;
    var arrowRect = (0, $65e748c44474ad1e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $dce98d96c03bdc14$export$1e95b668f3b82d) : (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb) : (0, $dce98d96c03bdc14$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $da086ae96c5807e2$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $923d9eb4027ab953$export$2e2bcd8739ae039)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ea58bbe2a7e31870$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element, _options$padding = options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $11a347ede51ebc83$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
    state.modifiersData[name + "#persistent"] = {
        padding: (0, $1f945a81f6180847$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $348fa2e5f20a91a2$export$2e2bcd8739ae039)(padding, (0, $dce98d96c03bdc14$export$aec2ce47c367b8c3)))
    };
} // eslint-disable-next-line import/no-unused-modules
var $ea58bbe2a7e31870$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $ea58bbe2a7e31870$var$arrow,
    effect: $ea58bbe2a7e31870$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $f6f63d7bd1366e58$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f6f63d7bd1366e58$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $dce98d96c03bdc14$export$1e95b668f3b82d),
        (0, $dce98d96c03bdc14$export$79ffe56a765070d2),
        (0, $dce98d96c03bdc14$export$40e543e69a8b3fbb),
        (0, $dce98d96c03bdc14$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f6f63d7bd1366e58$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $776506833c477f57$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $776506833c477f57$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f6f63d7bd1366e58$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f6f63d7bd1366e58$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f6f63d7bd1366e58$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f6f63d7bd1366e58$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f6f63d7bd1366e58$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $f6f63d7bd1366e58$var$hide
};




var $74c769e845636171$export$d34966752335dd47 = [
    (0, $f79221392923f70a$export$2e2bcd8739ae039),
    (0, $ca052d4c1fc9bb85$export$2e2bcd8739ae039),
    (0, $de6260142264e8a2$export$2e2bcd8739ae039),
    (0, $ac17dfe0f87e1cd3$export$2e2bcd8739ae039),
    (0, $496b9d8fc7e1441e$export$2e2bcd8739ae039),
    (0, $9ee62c7cb9690e11$export$2e2bcd8739ae039),
    (0, $b68d97ff4f49c4e2$export$2e2bcd8739ae039),
    (0, $ea58bbe2a7e31870$export$2e2bcd8739ae039),
    (0, $f6f63d7bd1366e58$export$2e2bcd8739ae039)
];
var $74c769e845636171$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $75b61832a482ce7a$export$ed5e13716264f202)({
    defaultModifiers: $74c769e845636171$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $1142db11f1693f5b$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $1142db11f1693f5b$var$hasElementType = typeof Element !== 'undefined';
var $1142db11f1693f5b$var$hasMap = typeof Map === 'function';
var $1142db11f1693f5b$var$hasSet = typeof Set === 'function';
var $1142db11f1693f5b$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $1142db11f1693f5b$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$1142db11f1693f5b$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($1142db11f1693f5b$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$1142db11f1693f5b$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($1142db11f1693f5b$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($1142db11f1693f5b$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($1142db11f1693f5b$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$1142db11f1693f5b$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$1142db11f1693f5b$exports = function isEqual(a, b) {
    try {
        return $1142db11f1693f5b$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $denZA = parcelRequire("denZA");
var $14486719c0554cd6$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $14486719c0554cd6$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $14486719c0554cd6$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $14486719c0554cd6$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $14486719c0554cd6$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $14486719c0554cd6$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $denZA.useLayoutEffect : $denZA.useEffect;


var $f793efa12b3f3174$var$EMPTY_MODIFIERS = [];
var $f793efa12b3f3174$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $denZA.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $f793efa12b3f3174$var$EMPTY_MODIFIERS
    };
    var _React$useState = $denZA.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $denZA.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                setState({
                    styles: (0, $14486719c0554cd6$export$5150077fc2e7c662)(elements.map(function(element) {
                        return [
                            element,
                            state.styles[element] || {}
                        ];
                    })),
                    attributes: (0, $14486719c0554cd6$export$5150077fc2e7c662)(elements.map(function(element) {
                        return [
                            element,
                            state.attributes[element]
                        ];
                    }))
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $denZA.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1142db11f1693f5b$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $denZA.useRef();
    (0, $14486719c0554cd6$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $14486719c0554cd6$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $74c769e845636171$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $9aa35ae36edfc809$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// eslint-disable-next-line complexity
var $9aa35ae36edfc809$var$getArrowPlacement = function(placement) {
    switch(placement){
        case 'bottom':
            return 'arrow-nn';
        case 'bottom-end':
            return 'arrow-nw';
        case 'bottom-start':
            return 'arrow-ne';
        case 'top':
            return 'arrow-ss';
        case 'top-end':
            return 'arrow-sw';
        case 'top-start':
            return 'arrow-se';
        case 'right':
            return 'arrow-ww';
        case 'right-end':
            return 'arrow-ws';
        case 'right-start':
            return 'arrow-wn';
        case 'left':
            return 'arrow-ee';
        case 'left-end':
            return 'arrow-es';
        case 'left-start':
            return 'arrow-en';
        default:
            return 'arrow-nn';
    }
};
var $9aa35ae36edfc809$export$1afc38dc718ba2c4 = function(refElement, popperElement, popperPlacement) {
    var _a = $9aa35ae36edfc809$var$__read($denZA.useState(''), 2), position = _a[0], setPosition = _a[1];
    var handlePosision = $denZA.useCallback(function(options) {
        var state = options.state;
        setPosition($9aa35ae36edfc809$var$getArrowPlacement(state.placement));
    }, []);
    var _b = $f793efa12b3f3174$export$f4d5bf230a36dd6e(refElement, popperElement, {
        placement: popperPlacement !== null && popperPlacement !== void 0 ? popperPlacement : 'auto',
        modifiers: [
            {
                name: 'arrow',
                fn: handlePosision
            },
            {
                name: 'offset',
                options: {
                    offset: [
                        2,
                        14
                    ]
                }
            }
        ]
    }), styles = _b.styles, attributes = _b.attributes;
    return {
        styles: styles,
        attributes: attributes,
        position: position
    };
};


var $7ec35b078bfd0be8$var$__assign = undefined && undefined.__assign || function() {
    $7ec35b078bfd0be8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ec35b078bfd0be8$var$__assign.apply(this, arguments);
};
var $7ec35b078bfd0be8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7ec35b078bfd0be8$export$28c660c63b792dea = function(_a) {
    var children = _a.children, label = _a.label, _b = _a.tooltipPosition, tooltipPosition = _b === void 0 ? 'top' : _b;
    // eslint-disable-next-line no-null/no-null
    var _c = $7ec35b078bfd0be8$var$__read($denZA.useState(null), 2), referenceElement = _c[0], setReferenceElement = _c[1];
    // eslint-disable-next-line no-null/no-null
    var _d = $7ec35b078bfd0be8$var$__read($denZA.useState(null), 2), popperElement = _d[0], setPopperElement = _d[1];
    var _e = $7ec35b078bfd0be8$var$__read($denZA.useState(false), 2), isVisible = _e[0], setIsVisible = _e[1];
    var portalRoot = (0, $e55e8a2120fd7762$export$6ecd3efa4eebe261)((0, $e55e8a2120fd7762$export$673c0f2dc34a292b).TOOLTIP).portalRoot;
    var _f = (0, $9aa35ae36edfc809$export$1afc38dc718ba2c4)(referenceElement, popperElement, tooltipPosition), styles = _f.styles, attributes = _f.attributes, position = _f.position;
    var renderToolTip = function() {
        if (isVisible) return $d486a8928008256a$exports.createPortal($denZA.createElement((0, $115e86979909e1fc$export$e4d8dc88bb9cc931), $7ec35b078bfd0be8$var$__assign({
            ref: setPopperElement,
            style: styles.popper
        }, attributes.popper, {
            arrowPosition: position,
            label: label
        })), portalRoot);
        return undefined;
    };
    return $denZA.createElement($denZA.Fragment, null, $denZA.isValidElement(children) && $denZA.cloneElement(children, $7ec35b078bfd0be8$var$__assign({
        onMouseLeave: function() {
            return setIsVisible(false);
        },
        onMouseOver: function() {
            return setIsVisible(true);
        },
        ref: function(node) {
            return setReferenceElement(node);
        }
    }, children.props)), renderToolTip());
};







var $denZA = parcelRequire("denZA");


var $3a020e27918e9d20$var$__assign = undefined && undefined.__assign || function() {
    $3a020e27918e9d20$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a020e27918e9d20$var$__assign.apply(this, arguments);
};
var $3a020e27918e9d20$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a020e27918e9d20$export$472ec417bca1d382 = $denZA.forwardRef(function(_a, ref) {
    var content = _a.content, title = _a.title, onExit = _a.onExit, position = _a.position, props = $3a020e27918e9d20$var$__rest(_a, [
        "content",
        "title",
        "onExit",
        "position"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var exitRef = $denZA.useRef(null);
    var onClickHandler = $denZA.useCallback(function() {
        if (onExit) onExit();
    }, [
        onExit
    ]);
    $denZA.useEffect(function() {
        var _a;
        // focus the exit button immediately
        (_a = exitRef.current) === null || _a === void 0 || _a.focus();
    }, []);
    return $denZA.createElement("div", $3a020e27918e9d20$var$__assign({
        className: cn('toast', 'popover', position),
        ref: ref,
        role: "presentation",
        tabIndex: -1
    }, props), $denZA.createElement("div", {
        className: cn('arrow-below')
    }), $denZA.createElement("div", {
        className: cn('arrow-above')
    }), $denZA.createElement("div", {
        className: cn('toast-main')
    }, $denZA.createElement("div", {
        className: cn('toast-content')
    }, $denZA.createElement("p", {
        className: cn('toast-heading')
    }, title), $denZA.createElement("div", {
        className: cn('toast-body')
    }, $denZA.createElement("p", null, content)))), $denZA.createElement("button", {
        className: cn('toast-close'),
        onClick: onClickHandler,
        ref: exitRef,
        tabIndex: 0
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: $denZA.createElement((0, $77e0e75571c47de0$export$3c877bb842c36952), null)
    })));
});


var $bceac2a5fff8799a$var$__assign = undefined && undefined.__assign || function() {
    $bceac2a5fff8799a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bceac2a5fff8799a$var$__assign.apply(this, arguments);
};
var $bceac2a5fff8799a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bceac2a5fff8799a$export$5b6b19405a83ff9d = function(_a) {
    var children = _a.children, content = _a.content, title = _a.title, _b = _a.popoverPosition, popoverPosition = _b === void 0 ? 'bottom' : _b;
    // eslint-disable-next-line no-null/no-null
    var _c = $bceac2a5fff8799a$var$__read($denZA.useState(null), 2), referenceElement = _c[0], setReferenceElement = _c[1];
    // eslint-disable-next-line no-null/no-null
    var _d = $bceac2a5fff8799a$var$__read($denZA.useState(null), 2), popperElement = _d[0], setPopperElement = _d[1];
    var _e = $bceac2a5fff8799a$var$__read($denZA.useState(false), 2), isVisible = _e[0], setIsVisible = _e[1];
    var portalRoot = (0, $e55e8a2120fd7762$export$6ecd3efa4eebe261)((0, $e55e8a2120fd7762$export$673c0f2dc34a292b).POPOVER).portalRoot;
    var _f = (0, $9aa35ae36edfc809$export$1afc38dc718ba2c4)(referenceElement, popperElement, popoverPosition), styles = _f.styles, attributes = _f.attributes, position = _f.position;
    var renderPopover = function() {
        if (isVisible) return $d486a8928008256a$exports.createPortal($denZA.createElement((0, $3a020e27918e9d20$export$472ec417bca1d382), $bceac2a5fff8799a$var$__assign({
            "aria-label": title,
            // eslint-disable-next-line react/jsx-no-bind
            onExit: function() {
                return setIsVisible(false);
            },
            ref: setPopperElement,
            style: styles.popper
        }, attributes.popper, {
            content: content,
            position: position,
            title: title
        })), portalRoot);
        return undefined;
    };
    (0, $c611c5d883831cb2$export$1896bab46732d207)([
        {
            current: popperElement
        },
        {
            current: referenceElement
        }
    ], function() {
        setIsVisible(false);
    });
    return $denZA.createElement($denZA.Fragment, null, $denZA.isValidElement(children) && $denZA.cloneElement(children, $bceac2a5fff8799a$var$__assign({
        onClick: function() {
            return setIsVisible(true);
        },
        ref: function(node) {
            return setReferenceElement(node);
        }
    }, children.props)), renderPopover());
};





var $denZA = parcelRequire("denZA");


var $f29599c929c5ee5e$var$__assign = undefined && undefined.__assign || function() {
    $f29599c929c5ee5e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f29599c929c5ee5e$var$__assign.apply(this, arguments);
};
var $f29599c929c5ee5e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f29599c929c5ee5e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f29599c929c5ee5e$export$9e72f56a493060bf = $denZA.forwardRef(function CircularProgress(_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, value = _a.value, _d = _a.min, min = _d === void 0 ? 0 : _d, _e = _a.max, max = _e === void 0 ? 100 : _e, props = $f29599c929c5ee5e$var$__rest(_a, [
        "size",
        "value",
        "min",
        "max"
    ]);
    var frameworkPrefix = (0, $a9513ca373e01b66$export$d3be3afeac0548cc)().frameworkPrefix;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var innerRef = $denZA.useRef(null);
    var _f = $f29599c929c5ee5e$var$__read($denZA.useState({
        width: 0,
        height: 0,
        strokeWidth: 0,
        radius: 0,
        center: 0
    }), 2), computedValues = _f[0], setComputedValues = _f[1];
    /**
     * useLayoutEffect because the values that are calculated are also the values that are used for
     * display, this allows us to calculate the values before the browser re-paints so there is no flicker
     *
     */ $denZA.useLayoutEffect(function() {
        if (innerRef.current) {
            if (value) innerRef.current.style.setProperty("--" + frameworkPrefix + "-circle-stroke-percentage", value.toString());
            var diameter = parseInt(getComputedStyle(innerRef.current).getPropertyValue("--" + frameworkPrefix + "-circle-full-diameter"), 10);
            var strokeWidth = parseInt(getComputedStyle(innerRef.current).getPropertyValue("--" + frameworkPrefix + "-circle-stroke-width"), 10);
            setComputedValues({
                width: diameter,
                height: diameter,
                strokeWidth: strokeWidth,
                radius: diameter / 2 - strokeWidth / 2,
                center: diameter / 2
            });
        }
    }, [
        value
    ]);
    var isIndeterminate = typeof value !== 'number';
    var accessibilityProps = {
        role: 'progressbar',
        'aria-valuemin': min,
        'aria-valuemax': max
    };
    if (!isIndeterminate) accessibilityProps['aria-valuenow'] = value;
    /**
     * svg height, width and viewbox values cannot use the `var(prop)` method
     * nor can it be used in cx, cy
     */ return $denZA.createElement("div", $f29599c929c5ee5e$var$__assign({
        className: "klik-progress"
    }, accessibilityProps, {
        ref: ref
    }, props), $denZA.createElement("div", {
        className: cn('progress-ring', (_b = {}, _b["is-" + size] = size, _b)),
        ref: innerRef
    }, $denZA.createElement("svg", {
        className: cn('progress-ring-svg'),
        height: computedValues.height,
        viewBox: "0 0 " + computedValues.width + " " + computedValues.height,
        width: computedValues.width
    }, $denZA.createElement("circle", {
        className: cn('progress-ring-circle-border'),
        cx: computedValues.center,
        cy: computedValues.center,
        fill: "transparent",
        r: computedValues.radius,
        stroke: "var(--klik-circle-stroke-border)",
        strokeWidth: "var(--klik-circle-stroke-width)"
    }), $denZA.createElement("circle", {
        className: cn('progress-ring-circle'),
        cx: computedValues.center,
        cy: computedValues.center,
        fill: "transparent",
        r: computedValues.radius,
        stroke: "var(--klik-circle-stroke-color)",
        strokeDasharray: "var(--klik-circle-stroke-dasharray)",
        strokeDashoffset: "var(--klik-circle-stroke-dashoffset)",
        strokeWidth: "var(--klik-circle-stroke-width)"
    })), $denZA.createElement("p", {
        className: cn('progress-value')
    }, "50%")));
});



var $denZA = parcelRequire("denZA");

var $ead0a0bc4e3112f2$var$__assign = undefined && undefined.__assign || function() {
    $ead0a0bc4e3112f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ead0a0bc4e3112f2$var$__assign.apply(this, arguments);
};
var $ead0a0bc4e3112f2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ead0a0bc4e3112f2$export$11f983dff6f48944 = $denZA.forwardRef(function LinearProgress(_a, ref) {
    var value = _a.value, _b = _a.max, max = _b === void 0 ? 100 : _b, _c = _a.hasLabel, hasLabel = _c === void 0 ? false : _c, props = $ead0a0bc4e3112f2$var$__rest(_a, [
        "value",
        "max",
        "hasLabel"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var innerRef = $denZA.useRef(null);
    var isIndeterminate = typeof value !== 'number';
    var accessibilityProps = {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 100
    };
    if (!isIndeterminate) accessibilityProps['aria-valuenow'] = value;
    /**
     * svg height, width and viewbox values cannot use the `var(prop)` method
     * nor can it be used in cx, cy
     */ return $denZA.createElement("div", $ead0a0bc4e3112f2$var$__assign({
        className: cn('progress')
    }, accessibilityProps, {
        ref: ref
    }, props), hasLabel && $denZA.createElement("p", {
        className: cn('progress-value')
    }, value), $denZA.createElement("progress", {
        className: cn('progress-bar'),
        max: max,
        ref: innerRef,
        value: value
    }));
});





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $895d79b4ed1d67fd$export$37b0961d2f4751e2 = function(_a) {
    var label = _a.label, value = _a.value, isDisabled = _a.isDisabled, isError = _a.isError, name = _a.name;
    var shouldBeDisabled = isDisabled !== null && isDisabled !== void 0 ? isDisabled : isError;
    return $denZA.useMemo(function() {
        return {
            'aria-label': label,
            'aria-disabled': shouldBeDisabled,
            disabled: shouldBeDisabled,
            tabIndex: shouldBeDisabled ? -1 : 0,
            type: 'radio',
            name: name,
            value: value
        };
    }, [
        isDisabled,
        isError,
        label,
        value
    ]);
};


var $a84416227312107f$var$__assign = undefined && undefined.__assign || function() {
    $a84416227312107f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a84416227312107f$var$__assign.apply(this, arguments);
};
var $a84416227312107f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a84416227312107f$export$f4422ae58352e179 = $denZA.forwardRef(function(_a, ref) {
    var _b;
    var label = _a.label, isError = _a.isError, isDisabled = _a.isDisabled, props = $a84416227312107f$var$__rest(_a, [
        "label",
        "isError",
        "isDisabled"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var ariaRadio = $a84416227312107f$var$__rest((0, $895d79b4ed1d67fd$export$37b0961d2f4751e2)($a84416227312107f$var$__assign({
        label: label,
        isDisabled: isDisabled,
        isError: isError
    }, props)), []);
    return $denZA.createElement("div", {
        className: cn('radio', (_b = {}, _b["status-error"] = isError, _b))
    }, $denZA.createElement("label", {
        className: cn('radio-label')
    }, $denZA.createElement("input", $a84416227312107f$var$__assign({
        className: cn('radio-hidden')
    }, props, {
        ref: ref
    }, ariaRadio)), $denZA.createElement("span", {
        className: cn('radio-shape')
    }), label && $denZA.createElement("span", {
        className: cn('radio-text')
    }, label)));
});
$a84416227312107f$export$f4422ae58352e179.displayName = 'Radio.Button';


var $0b5f6e5af89b2bbe$var$__assign = undefined && undefined.__assign || function() {
    $0b5f6e5af89b2bbe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b5f6e5af89b2bbe$var$__assign.apply(this, arguments);
};
var $0b5f6e5af89b2bbe$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0b5f6e5af89b2bbe$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0b5f6e5af89b2bbe$export$d7b12c4107be0d61 = function(_a) {
    var children = _a.children, onChange = _a.onChange, name = _a.name, props = $0b5f6e5af89b2bbe$var$__rest(_a, [
        "children",
        "onChange",
        "name"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _b = $0b5f6e5af89b2bbe$var$__read($denZA.useState(''), 2), selectedRadio = _b[0], setSelectedRadio = _b[1];
    var onRadioChange = $denZA.useCallback(function(e) {
        setSelectedRadio(e.currentTarget.value);
        if (onChange) onChange(e);
    }, [
        selectedRadio
    ]);
    var validChildren = (0, $efef0f8ceb54059d$export$b2c43d7d050b2e63)(children);
    return $denZA.createElement("div", $0b5f6e5af89b2bbe$var$__assign({
        className: cn('radios')
    }, props), validChildren.map(function(child) {
        return $denZA.cloneElement(child, {
            onChange: onRadioChange,
            name: name
        });
    }));
};
$0b5f6e5af89b2bbe$export$d7b12c4107be0d61.Button = (0, $a84416227312107f$export$f4422ae58352e179);






var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $4fb1223b1cfd4612$export$fb912d881d4e6ab8 = function(_a) {
    var label = _a.label, logo = _a.logo, href = _a.href, onClick = _a.onClick;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('sidebar-brand')
    }, $denZA.createElement("a", {
        className: cn('sidebar-logo'),
        href: href,
        onClick: onClick
    }, logo), $denZA.createElement("p", {
        className: cn('sidebar-name')
    }, label));
};


/* eslint-disable react/jsx-no-bind */ 
var $denZA = parcelRequire("denZA");

var $4e4fffc9d74bf898$export$879a7d62bcf41a75 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('sidebar-group')
    }, children);
};
$4e4fffc9d74bf898$export$879a7d62bcf41a75.displayName = 'Sidebar.Group';
var $4e4fffc9d74bf898$export$37d56758a11353df = function() {
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("hr", {
        className: cn('sidebar-divider')
    });
};
$4e4fffc9d74bf898$export$37d56758a11353df.displayName = 'Sidebar.Divider';


/* eslint-disable react/jsx-no-bind */ 
var $denZA = parcelRequire("denZA");

var $b9d625172c557b85$export$a9f2769ca96a3d36 = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('sidebar-menu')
    }, children);
};
$b9d625172c557b85$export$a9f2769ca96a3d36.displayName = 'Sidebar.Menu';
var $b9d625172c557b85$export$ecfd54512feac3da = function(_a) {
    var children = _a.children;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", {
        className: cn('sidebar-link')
    }, children);
};
$b9d625172c557b85$export$ecfd54512feac3da.displayName = 'Sidebar.Link';


var $f4786cc397569425$var$__assign = undefined && undefined.__assign || function() {
    $f4786cc397569425$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4786cc397569425$var$__assign.apply(this, arguments);
};
var $f4786cc397569425$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f4786cc397569425$export$1ba59dacbcbf90fe = function(_a) {
    var children = _a.children, props = $f4786cc397569425$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("aside", $f4786cc397569425$var$__assign({
        className: cn('sidebar')
    }, props), children);
};
$f4786cc397569425$export$1ba59dacbcbf90fe.Group = (0, $4e4fffc9d74bf898$export$879a7d62bcf41a75);
$f4786cc397569425$export$1ba59dacbcbf90fe.Divider = (0, $4e4fffc9d74bf898$export$37d56758a11353df);
$f4786cc397569425$export$1ba59dacbcbf90fe.Brand = (0, $4fb1223b1cfd4612$export$fb912d881d4e6ab8);
$f4786cc397569425$export$1ba59dacbcbf90fe.Menu = (0, $b9d625172c557b85$export$a9f2769ca96a3d36);
$f4786cc397569425$export$1ba59dacbcbf90fe.Link = (0, $b9d625172c557b85$export$ecfd54512feac3da);






var $denZA = parcelRequire("denZA");





var $7a4a7c027dbf1345$var$__assign = undefined && undefined.__assign || function() {
    $7a4a7c027dbf1345$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a4a7c027dbf1345$var$__assign.apply(this, arguments);
};
var $7a4a7c027dbf1345$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a4a7c027dbf1345$export$651ad66661acd392 = $denZA.forwardRef(function(_a, ref) {
    var _b;
    var _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, label = _a.label, onDropdownSelect = _a.onDropdownSelect, isNarrow = _a.isNarrow, isClipped = _a.isClipped, children = _a.children, props = $7a4a7c027dbf1345$var$__rest(_a, [
        "isDisabled",
        "size",
        "label",
        "onDropdownSelect",
        "isNarrow",
        "isClipped",
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line no-null/no-null
    var dropdown = $denZA.useRef(null);
    var reference = (0, $c9bab4bc692bb080$export$38d56e9c4e5a652b)(ref);
    // eslint-disable-next-line no-null/no-null
    var reff = $denZA.useRef(null);
    var _e = (0, $a02a493469d16616$export$8c32fdb3462273b4)(dropdown, reference), toggleVisible = _e.toggleVisible, setVisible = _e.setVisible;
    var buttonClasses = (_b = {}, _b["button"] = true, _b["is-" + size] = size, _b["is-disabled"] = isDisabled, _b);
    (0, $c611c5d883831cb2$export$1896bab46732d207)(dropdown, function() {
        setVisible(false);
    });
    return $denZA.createElement("div", {
        className: cn('split-button'),
        ref: reff,
        role: "button"
    }, $denZA.createElement("button", $7a4a7c027dbf1345$var$__assign({
        className: cn(buttonClasses),
        ref: ref
    }, props), label), $denZA.createElement("button", {
        className: cn('is-split-icon', buttonClasses),
        onClick: toggleVisible,
        ref: reference
    }, $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
        as: "span",
        icon: $denZA.createElement((0, $b4e72cdf9dbc256d$export$2fbb36af09846aa0), null)
    })), $denZA.createElement((0, $4f59921c5e698984$export$931cbfb6bfb85fc), {
        isClipped: isClipped,
        isNarrow: isNarrow,
        onDropdownSelect: (0, $efef0f8ceb54059d$export$e08e3b67e392101e)(toggleVisible, onDropdownSelect),
        ref: dropdown
    }, children));
});
$7a4a7c027dbf1345$export$651ad66661acd392.Action = (0, $25a30d99b12277d5$export$6648d5fa18559e7f);





var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");



var $5b17c01107884a95$var$__assign = undefined && undefined.__assign || function() {
    $5b17c01107884a95$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b17c01107884a95$var$__assign.apply(this, arguments);
};
var $5b17c01107884a95$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5b17c01107884a95$export$ee86eb81f202b5fe = function(_a) {
    var label = _a.label, _b = _a.state, state = _b === void 0 ? 'incomplete' : _b, index = _a.index, props = $5b17c01107884a95$var$__rest(_a, [
        "label",
        "state",
        "index"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var uid = (0, $368dfcda2edba615$export$3ec6e0c16b571c32)('stepper');
    var body = $denZA.useMemo(function() {
        if (state === 'complete') return $denZA.createElement((0, $f1b18e5f74506b97$export$f04a61298a47a40f), {
            icon: $denZA.createElement((0, $ca35121afe25890a$export$add807e002afa321), null)
        });
        return index;
    }, [
        index,
        state
    ]);
    return $denZA.createElement("li", {
        "aria-current": state === 'active',
        className: cn('stepper-item', "is-" + state),
        role: "presentation"
    }, $denZA.createElement("div", {
        className: cn('stepper-graph')
    }, $denZA.createElement("button", $5b17c01107884a95$var$__assign({
        className: cn('stepper-link'),
        id: uid
    }, props, {
        tabIndex: state === 'complete' ? 0 : -1
    }), body)), $denZA.createElement("label", {
        className: cn('stepper-label'),
        htmlFor: uid
    }, label));
};
$5b17c01107884a95$export$ee86eb81f202b5fe.displayName = 'Stepper.Item';


var $c0642f60efdfdb40$var$__assign = undefined && undefined.__assign || function() {
    $c0642f60efdfdb40$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0642f60efdfdb40$var$__assign.apply(this, arguments);
};
var $c0642f60efdfdb40$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c0642f60efdfdb40$export$ed8ca599049e8881 = function(_a) {
    var _b;
    var children = _a.children, isVertical = _a.isVertical, _c = _a.alignment, alignment = _c === void 0 ? 'center' : _c, activeStep = _a.activeStep, completedSteps = _a.completedSteps, onChange = _a.onChange, props = $c0642f60efdfdb40$var$__rest(_a, [
        "children",
        "isVertical",
        "alignment",
        "activeStep",
        "completedSteps",
        "onChange"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var state = $denZA.useCallback(function(index) {
        if (index === activeStep) return 'active';
        return (completedSteps === null || completedSteps === void 0 ? void 0 : completedSteps.includes(index)) ? 'complete' : 'incomplete';
    }, [
        activeStep,
        completedSteps
    ]);
    return $denZA.createElement("ul", $c0642f60efdfdb40$var$__assign({
        className: cn('stepper', (_b = {
            'is-vertical': isVertical
        }, _b["is-" + alignment] = alignment, _b))
    }, props), $denZA.Children.map(children, function(child, index) {
        return $denZA.cloneElement(child, $c0642f60efdfdb40$var$__assign({
            index: index + 1,
            state: state(index + 1),
            onClick: function() {
                if (onChange && state(index + 1) === 'complete') onChange(index + 1);
            }
        }, child.props));
    }));
};
$c0642f60efdfdb40$export$ed8ca599049e8881.Item = (0, $5b17c01107884a95$export$ee86eb81f202b5fe);





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $14a0144c590c61a4$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $14a0144c590c61a4$export$d853f7095ae95f88 = function(_a) {
    var isDisabled = _a.isDisabled, defaultChecked = _a.defaultChecked;
    var _b = $14a0144c590c61a4$var$__read($denZA.useState(!!defaultChecked), 2), isOn = _b[0], setIsOn = _b[1];
    var onKeyDown = function(e) {
        switch(e.key){
            case 'Enter':
            case ' ':
                e.preventDefault();
                setIsOn(function(prev) {
                    return !prev;
                });
                return;
        }
    };
    var onClick = $denZA.useCallback(function() {
        setIsOn(function(prev) {
            return !prev;
        });
    }, [
        isOn
    ]);
    return {
        checked: isOn,
        role: 'switch',
        tabIndex: isDisabled ? -1 : 0,
        'aria-checked': isOn,
        'aria-disabled': isDisabled,
        onClick: onClick,
        onKeyDown: onKeyDown
    };
};


var $14eec2f1accbb64a$var$__assign = undefined && undefined.__assign || function() {
    $14eec2f1accbb64a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14eec2f1accbb64a$var$__assign.apply(this, arguments);
};
var $14eec2f1accbb64a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $14eec2f1accbb64a$export$b5d5cf8927ab7262 = function(_a) {
    var isDisabled = _a.isDisabled, onSwitch = _a.onSwitch, props = $14eec2f1accbb64a$var$__rest(_a, [
        "isDisabled",
        "onSwitch"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _b = (0, $14a0144c590c61a4$export$d853f7095ae95f88)($14eec2f1accbb64a$var$__assign({
        isDisabled: isDisabled
    }, props)), checked = _b.checked, onClick = _b.onClick, attars = $14eec2f1accbb64a$var$__rest(_b, [
        "checked",
        "onClick"
    ]);
    var onClickHandler = $denZA.useCallback(function(e) {
        if (onSwitch) onSwitch(!!checked);
    }, [
        onClick,
        checked
    ]);
    return $denZA.createElement("div", $14eec2f1accbb64a$var$__assign({
        className: cn('switch', {
            'is-active': checked,
            'is-disabled': isDisabled
        }),
        onClick: (0, $efef0f8ceb54059d$export$e08e3b67e392101e)(onClickHandler, onClick)
    }, attars, props), $denZA.createElement("div", {
        className: cn('switch-dot')
    }));
};





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $817e4c4f960693e4$export$b9d98644d6233b40;
(function(FocusSelectionMode) {
    FocusSelectionMode["AUTOMATIC"] = "automatic";
    FocusSelectionMode["MANUAL"] = "manual";
})($817e4c4f960693e4$export$b9d98644d6233b40 || ($817e4c4f960693e4$export$b9d98644d6233b40 = {}));
var $817e4c4f960693e4$export$cfa7aa87c26e7d1f = $denZA.createContext(undefined);
var $817e4c4f960693e4$export$5c3d36c3adf0ba92 = function() {
    var context = $denZA.useContext($817e4c4f960693e4$export$cfa7aa87c26e7d1f);
    if (context) return context;
    throw new Error("Tab compound components can't be rendered outside Tabs component");
};



var $b060d9a617a6aa22$var$__assign = undefined && undefined.__assign || function() {
    $b060d9a617a6aa22$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b060d9a617a6aa22$var$__assign.apply(this, arguments);
};
var $b060d9a617a6aa22$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b060d9a617a6aa22$export$3e41faf802a29e71 = function(_a) {
    var children = _a.children, index = _a.index, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, props = $b060d9a617a6aa22$var$__rest(_a, [
        "children",
        "index",
        "isDisabled"
    ]);
    var _c = (0, $817e4c4f960693e4$export$5c3d36c3adf0ba92)(), id = _c.id, activeTab = _c.activeTab, setActiveTab = _c.setActiveTab, focusedTab = _c.focusedTab, setFocusedTab = _c.setFocusedTab;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    if (index === undefined) // eslint-disable-next-line no-null/no-null
    return null;
    var className = cn('tab', {
        'is-active': activeTab === index,
        'is-focused': focusedTab === index,
        'is-disabled': isDisabled
    });
    return $denZA.createElement("li", {
        className: className,
        role: "presentation"
    }, $denZA.createElement("button", $b060d9a617a6aa22$var$__assign({
        "aria-controls": activeTab === index ? (0, $368dfcda2edba615$export$2c0ff9f06f6a462b)(id, index) : undefined,
        "aria-selected": activeTab === index ? true : undefined,
        id: (0, $368dfcda2edba615$export$9178c5a458a4a458)(id, index),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function() {
            setFocusedTab(index);
            setActiveTab(index);
        },
        role: "tab",
        tabIndex: activeTab === index ? 0 : -1
    }, props), children));
};
$b060d9a617a6aa22$export$3e41faf802a29e71.displayName = 'Tabs.Tab';



var $denZA = parcelRequire("denZA");


var $89a2b443e1923945$var$__assign = undefined && undefined.__assign || function() {
    $89a2b443e1923945$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89a2b443e1923945$var$__assign.apply(this, arguments);
};
var $89a2b443e1923945$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * Based on an existing array return the original index identifier
 *
 * example: current `activeTab` is 1 and children returns an array of [0, 1, 2, 3, 4] where the
 * 3rd and 4th element are disabled, so you get back [0, 1, 4] and acgiveTab is still 1 but the
 * enabledSelectedIndex is for the enabledIndexes array and is also 1
 *
 * however in the case of where `activeTab` is 4 in the original array, now `enabledSelectedIndex`
 * should return `2` as the `activeTab` is the last elemnt in the enabledIndexes
 *
 * note that we are mixing index positions and index values in an array to keep track of this.
 *
 */ var $89a2b443e1923945$var$getAvailableTabIndexes = function(activeTab, children) {
    var enabledIndexes = $denZA.Children.map(children, function(child, index) {
        return child.props.isDisabled === true ? undefined : index;
    });
    var enabledSelectedIndex = enabledIndexes.indexOf(activeTab);
    return {
        enabledSelectedIndex: enabledSelectedIndex,
        enabledIndexes: enabledIndexes
    };
};
var $89a2b443e1923945$var$getNextAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[(activeTabIndex + 1) % availableTabIndexes.length];
};
var $89a2b443e1923945$var$getPrevAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[(activeTabIndex + availableTabIndexes.length - 1) % availableTabIndexes.length];
};
var $89a2b443e1923945$var$getFirstAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[0];
};
var $89a2b443e1923945$var$getLastAvailableTab = function(activeTabIndex, availableTabIndexes) {
    return availableTabIndexes[availableTabIndexes.length - 1];
};
var $89a2b443e1923945$export$e51a686c67fdaa2d = function(_a) {
    var _b;
    var children = _a.children, size = _a.size;
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var _c = (0, $817e4c4f960693e4$export$5c3d36c3adf0ba92)(), activeTab = _c.activeTab, setActiveTab = _c.setActiveTab, focusedTab = _c.focusedTab, setFocusedTab = _c.setFocusedTab, selectionMode = _c.selectionMode;
    var _d = $89a2b443e1923945$var$__read($denZA.useState(false), 2), hasFocus = _d[0], setHasFocus = _d[1];
    $denZA.useEffect(function() {
        if (!hasFocus) setFocusedTab(-1);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        hasFocus,
        setFocusedTab
    ]);
    var onFocus = function() {
        setHasFocus(true);
        setFocusedTab(activeTab);
    };
    // TODO: Think about this whole onKeyDown/OnFocus/hasFocus
    // in terms of a re-usable hook cause this is messy
    // we should also probably work with refs and prefer to use ref.current.focus(), but sadly we
    // have a design that seems to re-implement the default focus behavior
    // we need a broad discussion about focus traps and what consitutes the focus, because we are missing
    // focus behavior on the TabPanel component.
    // eslint-disable-next-line complexity
    var onKeyDown = function(e) {
        var _a = $89a2b443e1923945$var$getAvailableTabIndexes(focusedTab, children), enabledSelectedIndex = _a.enabledSelectedIndex, enabledIndexes = _a.enabledIndexes;
        var newIndex;
        if (hasFocus) switch(e.key){
            case 'ArrowDown':
            case 'ArrowRight':
                e.preventDefault();
                newIndex = $89a2b443e1923945$var$getNextAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $817e4c4f960693e4$export$b9d98644d6233b40).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                newIndex = $89a2b443e1923945$var$getPrevAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $817e4c4f960693e4$export$b9d98644d6233b40).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'End':
                e.preventDefault();
                newIndex = $89a2b443e1923945$var$getLastAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $817e4c4f960693e4$export$b9d98644d6233b40).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'Home':
                e.preventDefault();
                newIndex = $89a2b443e1923945$var$getFirstAvailableTab(enabledSelectedIndex, enabledIndexes);
                if (selectionMode === (0, $817e4c4f960693e4$export$b9d98644d6233b40).AUTOMATIC) setActiveTab(newIndex);
                setFocusedTab(newIndex);
                return;
            case 'Enter':
            case ' ':
                e.preventDefault();
                setActiveTab(focusedTab);
                return;
        }
    };
    var className = cn('tablist', $89a2b443e1923945$var$__assign({}, size && (_b = {}, _b["is-" + size] = true, _b)));
    return $denZA.createElement("ul", {
        className: className,
        role: "tablist"
    }, $denZA.Children.map(children, function(child, index) {
        return $denZA.cloneElement(child, $89a2b443e1923945$var$__assign({
            index: index,
            onFocus: onFocus,
            onBlur: function() {
                // all we're doing here is making sure that we know we're in a focused mode.
                setHasFocus(false);
            },
            onKeyDown: onKeyDown
        }, child.props));
    }));
};
$89a2b443e1923945$export$e51a686c67fdaa2d.displayName = 'Tabs.TabList';



var $denZA = parcelRequire("denZA");

var $780e45225e6f0a65$var$__assign = undefined && undefined.__assign || function() {
    $780e45225e6f0a65$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $780e45225e6f0a65$var$__assign.apply(this, arguments);
};
var $780e45225e6f0a65$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $780e45225e6f0a65$export$3d96ec278d3efce4 = function(_a) {
    var children = _a.children, props = $780e45225e6f0a65$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $780e45225e6f0a65$var$__assign({
        className: cn('tabpanel'),
        role: "tabpanel"
    }, props), children);
};
$780e45225e6f0a65$export$3d96ec278d3efce4.displayName = 'Tabs.TabPanel';



var $denZA = parcelRequire("denZA");



var $28ce13f50a0c9595$var$__assign = undefined && undefined.__assign || function() {
    $28ce13f50a0c9595$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28ce13f50a0c9595$var$__assign.apply(this, arguments);
};
var $28ce13f50a0c9595$export$5dae8d435677f210 = function(_a) {
    var children = _a.children;
    var _b = (0, $817e4c4f960693e4$export$5c3d36c3adf0ba92)(), id = _b.id, activeTab = _b.activeTab;
    var activeChild = children[activeTab];
    if (!$denZA.isValidElement(activeChild)) activeChild = $denZA.createElement((0, $780e45225e6f0a65$export$3d96ec278d3efce4), null, "Make sure to associate a tab panel for this tab");
    return $denZA.cloneElement(activeChild, $28ce13f50a0c9595$var$__assign({
        tabIndex: 0,
        id: (0, $368dfcda2edba615$export$2c0ff9f06f6a462b)(id, activeTab),
        'aria-labelledby': (0, $368dfcda2edba615$export$9178c5a458a4a458)(id, activeTab)
    }, activeChild.props));
};
$28ce13f50a0c9595$export$5dae8d435677f210.displayName = 'Tabs.TabPanels';




var $30ac1d16a094a7bc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $30ac1d16a094a7bc$export$b2539bed5023c21c = function(_a) {
    var children = _a.children, onActiveTabChange = _a.onActiveTabChange, _b = _a.initialActiveTab, initialActiveTab = _b === void 0 ? 0 : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? (0, $817e4c4f960693e4$export$b9d98644d6233b40).AUTOMATIC : _c;
    var _d = $30ac1d16a094a7bc$var$__read($denZA.useState(initialActiveTab), 2), activeTab = _d[0], setActiveTab = _d[1];
    var _e = $30ac1d16a094a7bc$var$__read($denZA.useState(activeTab), 2), focusedTab = _e[0], setFocusedTab = _e[1];
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    $denZA.useEffect(function() {
        onActiveTabChange === null || onActiveTabChange === void 0 || onActiveTabChange(activeTab);
    }, [
        activeTab,
        onActiveTabChange
    ]);
    var id = (0, $368dfcda2edba615$export$3ec6e0c16b571c32)('tabs');
    var contextValue = $denZA.useMemo(function() {
        return {
            id: id,
            activeTab: activeTab,
            setActiveTab: setActiveTab,
            focusedTab: focusedTab,
            setFocusedTab: setFocusedTab,
            selectionMode: selectionMode,
            onActiveTabChange: onActiveTabChange
        };
    }, [
        id,
        activeTab,
        setActiveTab,
        focusedTab,
        setFocusedTab,
        onActiveTabChange,
        selectionMode
    ]);
    var className = cn('tabs');
    return $denZA.createElement((0, $817e4c4f960693e4$export$cfa7aa87c26e7d1f).Provider, {
        value: contextValue
    }, $denZA.createElement("div", {
        className: className,
        id: id
    }, children));
};
$30ac1d16a094a7bc$export$b2539bed5023c21c.TabList = (0, $89a2b443e1923945$export$e51a686c67fdaa2d);
$30ac1d16a094a7bc$export$b2539bed5023c21c.Tab = (0, $b060d9a617a6aa22$export$3e41faf802a29e71);
$30ac1d16a094a7bc$export$b2539bed5023c21c.TabPanels = (0, $28ce13f50a0c9595$export$5dae8d435677f210);
$30ac1d16a094a7bc$export$b2539bed5023c21c.TabPanel = (0, $780e45225e6f0a65$export$3d96ec278d3efce4);









var $denZA = parcelRequire("denZA");

var $13c757ea12b3c317$var$__assign = undefined && undefined.__assign || function() {
    $13c757ea12b3c317$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13c757ea12b3c317$var$__assign.apply(this, arguments);
};
var $13c757ea12b3c317$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $13c757ea12b3c317$export$67efe7a6dccb9914 = $denZA.forwardRef(function(_a, ref) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'default' : _b, isDisabled = _a.isDisabled, props = $13c757ea12b3c317$var$__rest(_a, [
        "label",
        "size",
        "isDisabled"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("a", $13c757ea12b3c317$var$__assign({
        "aria-disabled": isDisabled,
        "aria-label": label,
        className: cn('text-link', "is-" + size),
        disabled: isDisabled
    }, props, {
        ref: ref
    }), label);
});



var $denZA = parcelRequire("denZA");

var $60aa74d5bda232a3$var$__assign = undefined && undefined.__assign || function() {
    $60aa74d5bda232a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60aa74d5bda232a3$var$__assign.apply(this, arguments);
};
var $60aa74d5bda232a3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $60aa74d5bda232a3$export$9ce414e821e502ec = $denZA.forwardRef(function(_a, ref) {
    var children = _a.children, props = $60aa74d5bda232a3$var$__rest(_a, [
        "children"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    return $denZA.createElement("div", $60aa74d5bda232a3$var$__assign({
        className: cn('text-links'),
        ref: ref
    }, props), children);
});









var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");



var $c4e7303a4bc8d366$var$__assign = undefined && undefined.__assign || function() {
    $c4e7303a4bc8d366$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4e7303a4bc8d366$var$__assign.apply(this, arguments);
};
var $c4e7303a4bc8d366$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c4e7303a4bc8d366$export$1c6175f3aa4394b7 = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'p' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.weight, weight = _d === void 0 ? 'default' : _d, props = $c4e7303a4bc8d366$var$__rest(_a, [
        "as",
        "size",
        "weight"
    ]);
    var cn = (0, $efef0f8ceb54059d$export$e3ab1274632d862)();
    var fontSize = (0, $20817d17cc29bb87$export$26ca5b065308b0d1)(size);
    return $denZA.createElement((0, $a41ed5d6245be746$export$ed0c65eec41bee08), $c4e7303a4bc8d366$var$__assign({
        as: as,
        className: cn('text', "" + fontSize, "text-weight-" + weight),
        ref: ref
    }, props));
});


var $b6acf710a785f58c$var$__assign = undefined && undefined.__assign || function() {
    $b6acf710a785f58c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6acf710a785f58c$var$__assign.apply(this, arguments);
};
var $b6acf710a785f58c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6acf710a785f58c$export$a8a3e93435678ff9 = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'h1' : _b, props = $b6acf710a785f58c$var$__rest(_a, [
        "as"
    ]);
    return $denZA.createElement((0, $c4e7303a4bc8d366$export$1c6175f3aa4394b7), $b6acf710a785f58c$var$__assign({
        as: as
    }, props, {
        ref: ref
    }));
});



var $denZA = parcelRequire("denZA");


var $7e9f25ea992d2b4a$var$__assign = undefined && undefined.__assign || function() {
    $7e9f25ea992d2b4a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e9f25ea992d2b4a$var$__assign.apply(this, arguments);
};
var $7e9f25ea992d2b4a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e9f25ea992d2b4a$export$358a232cca1ab2ac = (0, $5292e3956f9937a3$export$8477fce780cb2224)(function(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'p' : _b, props = $7e9f25ea992d2b4a$var$__rest(_a, [
        "as"
    ]);
    return $denZA.createElement((0, $c4e7303a4bc8d366$export$1c6175f3aa4394b7), $7e9f25ea992d2b4a$var$__assign({
        as: as
    }, props, {
        ref: ref
    }));
});










// All variables are taken from the Klik UI Library - https://brand.lego.com/
const $b274acb0dd1693ab$export$a74e2025f5286b02 = {
    size: {
        size7: '5.9375rem',
        size6: '3.8125rem',
        size5: '3.0625rem',
        size4: '2.4375rem',
        size3: '1.9375rem',
        size2: '1.5625rem',
        size1: '1.25rem',
        size05: '1.125rem',
        size0: '1rem',
        sizeM1: '0.875rem',
        sizeM2: '0.6875rem'
    },
    weight: {
        regular: 400,
        medium: 500,
        bold: 700
    },
    lineHeight: {
        l: 1.5,
        m: 1.375,
        s: 1.25,
        xs: 1.125
    },
    letterSpacing: {
        xxl: '0.1em',
        xl: '0.0825em',
        l: '0.075em',
        m: '0.05em',
        s: '0.0375em',
        xs: '0.025em',
        xxs: '0.0125em'
    }
};


const $afd4d1d9630ef27f$var$mediaSizes = {
    medium: 592,
    large: 1024,
    xLarge: 1440,
    fullWidth: 1632
};
const $afd4d1d9630ef27f$export$987d49ffe1b0900f = {
    medium: `@media (min-width: ${$afd4d1d9630ef27f$var$mediaSizes.medium}px)`,
    large: `@media (min-width: ${$afd4d1d9630ef27f$var$mediaSizes.large}px)`,
    xLarge: `@media (min-width: ${$afd4d1d9630ef27f$var$mediaSizes.xLarge}px)`
};


const $a8ddc88815af1a66$export$4738d597a47e577d = 4;
const $a8ddc88815af1a66$var$spacingFactor = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    16,
    32
];
const $a8ddc88815af1a66$export$5458b64234d1333c = $a8ddc88815af1a66$var$spacingFactor.reduce((acc, next)=>{
    acc[`size${next}`] = next * $a8ddc88815af1a66$export$4738d597a47e577d;
    return acc;
}, {});



const $eca06d1b9813a83c$export$6f98e8eaf0be1996 = {
    small: (0, $a8ddc88815af1a66$export$4738d597a47e577d) * 2,
    medium: (0, $a8ddc88815af1a66$export$4738d597a47e577d) * 4,
    large: (0, $a8ddc88815af1a66$export$4738d597a47e577d) * 6,
    xLarge: (0, $a8ddc88815af1a66$export$4738d597a47e577d) * 8
};


const $a8152c9d3f9ec984$export$8f45430ccf837300 = {
    neutralColors: {
        white: '#ffffff',
        black: '#141414',
        slate02: '#fcfcfc',
        slate05: '#f8f8f8',
        slate10: '#f1f1f1',
        slate20: '#e4e4e3',
        slate30: '#d6d6d5',
        slate300: '#B2B2B0',
        slate40: '#c8c8c7',
        slate50: '#adadac',
        slate60: '#919190',
        slateBase: '#767674',
        slate90: '#474746',
        slate100: '#2f2f2e',
        slate900: '#292928'
    },
    boldColors: {
        copper: {
            copper200: '#F3C48B',
            copper400: '#CC8A37'
        },
        darkBlue: {
            base: '#0248a4',
            darkBlue80: '#013a87'
        },
        lightBlue: {
            lightBlue05: '#f4f8fc',
            ligthBlue10: '#e9f2f8',
            ligthBlue20: '#d4e5f2',
            lightBlue50: '#7db0d8',
            base: '#277bbe',
            lightBlue80: '#1f6298',
            lightBlue90: '#174a72',
            lightBlue100: '#10314c'
        }
    },
    accentColors: {
        gold: {
            base: '#fdb100'
        }
    },
    utilityColors: {
        information: {
            base: '#009bd7',
            information400: '#179FE3'
        },
        success: {
            base: '#22a317',
            dark: '#138b09',
            success400: '#1CB20C'
        },
        warning: {
            base: '#ffc900',
            warning100: '#ffc90096',
            warning400: '#F2A705'
        },
        error: {
            error500: '#DB1F1F',
            error600: '#B20707'
        }
    },
    shadows: {
        boxShadow: 'rgba(47, 47, 46, 0.1)'
    }
};


const $16681adf0d4cc247$export$bcd6882dc7e615be = {
    borderRadius: 4
};


const $ae3efe89c6a10731$export$e62953d023125748 = {
    requiredProof: {
        startYear: 2024
    }
};




const $c9fea4fcfdeb89a5$var$contentWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $c9fea4fcfdeb89a5$var$leftContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'flex-start'
});
const $c9fea4fcfdeb89a5$var$iconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3,
    '&:empty': {
        display: 'none'
    }
});
const $c9fea4fcfdeb89a5$var$textWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $c9fea4fcfdeb89a5$var$headerTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium
});
const $c9fea4fcfdeb89a5$var$bodyTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    lineHeight: 1.125,
    whiteSpace: 'pre-wrap'
});
const $c9fea4fcfdeb89a5$var$buttonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    flexShrink: 0,
    marginTop: -(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1
});
const $c9fea4fcfdeb89a5$var$closeIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60
});
const $c9fea4fcfdeb89a5$export$860cef82710cac7 = ({ icon: icon, header: header, text: text, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $c9fea4fcfdeb89a5$var$contentWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("span", {
                css: $c9fea4fcfdeb89a5$var$leftContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                        css: $c9fea4fcfdeb89a5$var$iconStyle,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $c9fea4fcfdeb89a5$var$textWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h4", {
                                css: $c9fea4fcfdeb89a5$var$headerTextStyle,
                                children: header
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $c9fea4fcfdeb89a5$var$bodyTextStyle,
                                children: text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $c9fea4fcfdeb89a5$var$buttonWrapperStyle,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                    "aria-label": "Close notification button",
                    icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $88a0171ecb792bad$export$3c877bb842c36952), {
                        css: $c9fea4fcfdeb89a5$var$closeIconStyle
                    }),
                    variant: "ghost",
                    size: "small",
                    onClick: onClose
                })
            })
        ]
    });
};
$c9fea4fcfdeb89a5$export$860cef82710cac7.propTypes = {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).element,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func
};


const $525afb211ce04815$export$628738c5f3e0b7f2 = {
    INFO: 'info',
    WARNING: 'warn',
    SUCCESS: 'success',
    ERROR: 'error'
};



const $41263b671f20f58e$var$getIconColor = (snackbarType)=>{
    if (snackbarType === (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.success.success400;
    if (snackbarType === (0, $525afb211ce04815$export$628738c5f3e0b7f2).INFO) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.information.information400;
    if (snackbarType === (0, $525afb211ce04815$export$628738c5f3e0b7f2).WARNING) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400;
    if (snackbarType === (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.error.error500;
    return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate90;
};
const $41263b671f20f58e$export$2791228263505492 = ({ header: header, text: text, type: type })=>{
    const Icon = type === (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS ? (0, $8d3ba8b69cd13d82$export$17e1460061865da) : (0, $02f87be4862405c0$export$f1b6053a528b50d9);
    const getContent = ()=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c9fea4fcfdeb89a5$export$860cef82710cac7), {
            icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)(Icon, {
                css: {
                    color: $41263b671f20f58e$var$getIconColor(type)
                }
            }),
            header: header,
            text: text
        });
    if (!type) return (0, $b1500a705028f634$export$b410431fab84fa58)(getContent());
    return (0, $b1500a705028f634$export$b410431fab84fa58)[type](getContent());
};



const $bacbba0a13f46eeb$export$60d4ee6105aea05 = {
    errorHeader: 'Something went wrong',
    errorText: 'We could not complete your request. We are working on it. Please try again later.',
    imageUploadFetchError: 'Uploaded files are currently not available.',
    successHeader: 'Success'
};




(0, $5670e7b58399d657$export$2e2bcd8739ae039).configure((0, $60c0faf497b0a45e$export$61087a22b18fbdb6));
const $3612b1be3096e797$var$appSyncLinkConfig = {
    url: "https://vvw77vvbofdpjf4itb3wjly3pe.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    auth: {
        type: 'AWS_IAM',
        credentials: async ()=>{
            try {
                const credentials = await (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).currentCredentials();
                return credentials;
            } catch (error) {
                (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
            }
        }
    },
    disableOffline: true
};
const $3612b1be3096e797$var$errorLink = (0, $02bbd90ab070cb52$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors, networkError: networkError })=>{
    if (graphQLErrors) {
        const currentTransaction = (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.getCurrentTransaction();
        graphQLErrors.forEach((graphQLError)=>{
            (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.captureError(graphQLError);
        });
        const filteredGraphQLErrors = graphQLErrors.filter((error)=>error?.extensions?.code !== 'VALIDATION_ERROR');
        if (filteredGraphQLErrors.length > 0) {
            const uniqueMessages = [
                ...new Set(filteredGraphQLErrors.map(({ message: message })=>message))
            ];
            let errorMessage = `${uniqueMessages.join('\n')}`;
            errorMessage += `\nTime: ${new Date().toLocaleString()}`;
            errorMessage += `\nID: ${currentTransaction?.id ?? 'Unknown'}`;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
                text: errorMessage,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
            });
        }
        if (networkError) (0, $41263b671f20f58e$export$2791228263505492)({
            header: 'Network error',
            text: `${networkError.name}: ${networkError.message}`,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
    }
});
const $3612b1be3096e797$var$loggerLink = new (0, $168cabbf484f42b9$export$2fed3d61f740bc7f)((operation, forward)=>{
    const currentTransaction = (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.getCurrentTransaction();
    const span = currentTransaction?.startSpan(`Call ${operation.operationName}`, 'graphql', {
        blocking: true,
        sync: false
    });
    // Add the request payload and name the context for debugging purpose
    (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.setCustomContext({
        operation: operation.operationName,
        variables: operation.variables
    });
    return forward(operation).map((data)=>{
        span?.end();
        return data;
    });
});
// from https://github.com/awslabs/aws-mobile-appsync-sdk-js#using-authorization-and-subscription-links-with-apollo-client-no-offline-support
const $3612b1be3096e797$var$client = new (0, $eab636ebc55e3402$export$13f5a5f0f1dbab88)({
    link: (0, $168cabbf484f42b9$export$2fed3d61f740bc7f).from([
        $3612b1be3096e797$var$loggerLink,
        $3612b1be3096e797$var$errorLink,
        (0, $1672a4b8783b587e$exports.createAuthLink)($3612b1be3096e797$var$appSyncLinkConfig),
        (0, $7f42520b6e9d7224$exports.createSubscriptionHandshakeLink)($3612b1be3096e797$var$appSyncLinkConfig)
    ]),
    cache: new (0, $293471a6ca1d60d0$export$467265324939f47f)()
});
const $3612b1be3096e797$export$8e363dbef886ff17 = ({ children: children })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0abd703f2109c9e4$export$c16b04c8a9956446), {
        client: $3612b1be3096e797$var$client,
        children: children
    });
$3612b1be3096e797$export$8e363dbef886ff17.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired
};




var $denZA = parcelRequire("denZA");



var $cvFNP = parcelRequire("cvFNP");



const $7957273fefe35e99$export$6155b080a981da85 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query Getroles {
    getRoles
  }
`;


const $b92321121d608eea$export$38ee920e59704589 = /*#__PURE__*/ (0, $denZA.createContext)();
const $b92321121d608eea$var$environment = "staging";
const $b92321121d608eea$var$isProduction = [
    'staging',
    'prod',
    'production'
].includes($b92321121d608eea$var$environment.toLowerCase());
const $b92321121d608eea$var$userHasMcpAdminAccess = (user)=>{
    if (!user) return false;
    if (!$b92321121d608eea$var$isProduction) return true;
    const roles = user.attributes['custom:roles'] || [];
    return roles.includes('MCPAdminUser');
};
const $b92321121d608eea$export$17718da877d9c5f8 = (roles)=>!!(roles && roles.includes('admin') && roles.includes('revenue'));
const $b92321121d608eea$export$88f24fd8fcfab6ca = ({ children: children })=>{
    const [user, setUser] = (0, $denZA.useState)(null);
    const [error, setError] = (0, $denZA.useState)(null);
    if (error) throw error;
    (0, $denZA.useEffect)(()=>{
        async function getUser() {
            let user = {};
            try {
                user = await (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).currentAuthenticatedUser();
                const idTokenPayload = user.signInUserSession?.idToken?.payload;
                const identityProvider = idTokenPayload?.identities?.[0]?.providerName;
                if (identityProvider !== "partner-idp-admin") {
                    (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(`User authenticated with wrong provider: ${identityProvider}. Re-authenticating with ${"partner-idp-admin"}.`);
                    await (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).signOut();
                    (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).federatedSignIn({
                        customProvider: "partner-idp-admin"
                    });
                    return;
                }
                if (!$b92321121d608eea$var$userHasMcpAdminAccess(user)) throw new Error('User is missing application access!');
                setUser(user);
            } catch (error) {
                if (error === 'The user is not authenticated') (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).federatedSignIn({
                    customProvider: "partner-idp-admin"
                });
                else {
                    (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
                    setError(error);
                }
            }
        }
        if (!user) getUser();
    }, [
        user
    ]);
    const name = user?.attributes['custom:fullName'] || '';
    // Query for Permit.io roles once the user is authenticated
    const { data: rolesData } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $7957273fefe35e99$export$6155b080a981da85), {
        skip: !user || !$b92321121d608eea$var$userHasMcpAdminAccess(user),
        fetchPolicy: 'network-only'
    });
    let roles = rolesData?.getRoles || [];
    const userAttributes = {
        id: user?.id || '',
        roles: roles,
        name: name,
        username: name,
        email: user?.attributes['email'] || ''
    };
    if (userAttributes.email) {
        (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.setUserContext({
            email: userAttributes.email,
            id: userAttributes.id,
            username: userAttributes.username
        });
        (0, $fd8342fe733aea4b$export$66cd81c234b843ce)?.setCustomContext({
            roles: userAttributes.roles
        });
    }
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)($b92321121d608eea$export$38ee920e59704589.Provider, {
        value: {
            cognitoData: user || {},
            isLoggedIn: !!user && $b92321121d608eea$var$userHasMcpAdminAccess(user),
            ...userAttributes
        },
        children: children
    });
};
const $b92321121d608eea$export$23bbbc4533528f03 = ()=>{
    const context = (0, $denZA.useContext)($b92321121d608eea$export$38ee920e59704589);
    if (context === undefined) throw new Error('useUser must be used within a UserProvider');
    return context;
};
$b92321121d608eea$export$88f24fd8fcfab6ca.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node
};






var $41a2d7d9a477bc20$exports = {};
$parcel$export($41a2d7d9a477bc20$exports, "ColorModeContext", function () { return $cb7c335cf150f8d2$export$49ddd74a6729fdb0; });
$parcel$export($41a2d7d9a477bc20$exports, "ColorModeProvider", function () { return $cb7c335cf150f8d2$export$7a858aa3ff83dde7; });
$parcel$export($41a2d7d9a477bc20$exports, "useChakra", function () { return $de2d1b30ad83f058$export$a513a93efd9ab8a7; });
$parcel$export($41a2d7d9a477bc20$exports, "useToken", function () { return $de2d1b30ad83f058$export$31dcd79391e423fe; });
$parcel$export($41a2d7d9a477bc20$exports, "GlobalStyle", function () { return $77f2276a0a421ee3$export$f05794e648629f6c; });
$parcel$export($41a2d7d9a477bc20$exports, "StylesProvider", function () { return $77f2276a0a421ee3$export$dc4c659861f00dbe; });
$parcel$export($41a2d7d9a477bc20$exports, "ThemeProvider", function () { return $77f2276a0a421ee3$export$d8964aec282183a3; });
$parcel$export($41a2d7d9a477bc20$exports, "useStyles", function () { return $77f2276a0a421ee3$export$28e6b9b82ee883c; });
$parcel$export($41a2d7d9a477bc20$exports, "useTheme", function () { return $77f2276a0a421ee3$export$93d4e7f90805808f; });
$parcel$export($41a2d7d9a477bc20$exports, "chakra", function () { return $fa3b5b33d58c73c3$export$7cd122d781af9fa4; });
$parcel$export($41a2d7d9a477bc20$exports, "forwardRef", function () { return $f3563a42e5e5d5b1$export$257a8862b851cb5b; });
$parcel$export($41a2d7d9a477bc20$exports, "useMultiStyleConfig", function () { return $fb07eb4efac940d0$export$31cdfe60c085d76f; });
$parcel$export($41a2d7d9a477bc20$exports, "useStyleConfig", function () { return $fb07eb4efac940d0$export$b863f77547fbcb03; });
// Number assertions
function $6b74ef5ae6a56e47$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $6b74ef5ae6a56e47$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $6b74ef5ae6a56e47$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $6b74ef5ae6a56e47$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $6b74ef5ae6a56e47$export$4c0262a4f954db45(value) {
    return $6b74ef5ae6a56e47$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $6b74ef5ae6a56e47$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $6b74ef5ae6a56e47$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $6b74ef5ae6a56e47$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$6b74ef5ae6a56e47$export$43bee75e5e14138e(value);
}
function $6b74ef5ae6a56e47$export$83b788b1a3698c03(value) {
    return $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $6b74ef5ae6a56e47$export$e0287cc73292b477(value) {
    return value && !$6b74ef5ae6a56e47$export$83b788b1a3698c03(value);
}
function $6b74ef5ae6a56e47$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $6b74ef5ae6a56e47$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $6b74ef5ae6a56e47$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $6b74ef5ae6a56e47$export$dd1bc94b04021eeb(value) {
    if ($6b74ef5ae6a56e47$export$43bee75e5e14138e(value)) return $6b74ef5ae6a56e47$export$4c0262a4f954db45(value);
    if ($6b74ef5ae6a56e47$export$a6cdc56e425d0d0a(value)) return $6b74ef5ae6a56e47$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $6b74ef5ae6a56e47$export$a866f231438cc228 = false;
var $6b74ef5ae6a56e47$export$61cb32cff9a99948 = false;
function $6b74ef5ae6a56e47$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $6b74ef5ae6a56e47$export$4215e022093e324e(value) {
    return value && $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a(value) && $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a(value.target);
}

function $405775388fe7f58e$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $405775388fe7f58e$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$405775388fe7f58e$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $405775388fe7f58e$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $405775388fe7f58e$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $405775388fe7f58e$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $405775388fe7f58e$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $405775388fe7f58e$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $405775388fe7f58e$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $405775388fe7f58e$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $405775388fe7f58e$export$4e09c449d6c407f7 = $405775388fe7f58e$export$71594e8a50f746f4();
var $405775388fe7f58e$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : undefined;
var $405775388fe7f58e$export$91a6105db3d4be7b = (condition)=>condition ? true : undefined;
var $405775388fe7f58e$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $405775388fe7f58e$export$cd4e5573fbe2b576(node) {
    var doc = $405775388fe7f58e$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $405775388fe7f58e$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $405775388fe7f58e$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}
function $405775388fe7f58e$export$17948c8429b9b73a(event) {
    var { key: key, keyCode: keyCode } = event;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $405775388fe7f58e$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _ref, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $405775388fe7f58e$export$cd4e5573fbe2b576(target);
    var originalTarget = event.nativeEvent.explicitOriginalTarget;
    return (_ref = (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : originalTarget) != null ? _ref : activeElement;
}
function $405775388fe7f58e$export$189689d1febf0166(event) {
    return event.button !== 0;
}

/* eslint-disable no-nested-ternary */ 
function $da6e679e22b3b02c$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $da6e679e22b3b02c$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $da6e679e22b3b02c$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $da6e679e22b3b02c$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce((f1, f2)=>function() {
            return f1(f2(...arguments));
        }, fn1);
};
function $da6e679e22b3b02c$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $da6e679e22b3b02c$export$8793edee2d425525 = ()=>{};
var $da6e679e22b3b02c$export$c106dd0671a0fc2d = $da6e679e22b3b02c$export$d2de3aaeafa91619((options)=>()=>{
        var { condition: condition, message: message } = options;
        if (condition && (0, $6b74ef5ae6a56e47$export$a866f231438cc228)) console.warn(message);
    });
var $da6e679e22b3b02c$export$a3bc9b8ed74fc = $da6e679e22b3b02c$export$d2de3aaeafa91619((options)=>()=>{
        var { condition: condition, message: message } = options;
        if (condition && (0, $6b74ef5ae6a56e47$export$a866f231438cc228)) console.error(message);
    });
var $da6e679e22b3b02c$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return (v)=>fns.reduce((a, b)=>b(a), v);
};
var $da6e679e22b3b02c$var$distance1D = (a, b)=>Math.abs(a - b);
var $da6e679e22b3b02c$var$isPoint = (point)=>"x" in point && "y" in point;
function $da6e679e22b3b02c$export$9f17032d917177de(a, b) {
    if ((0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(a) && (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(b)) return $da6e679e22b3b02c$var$distance1D(a, b);
    if ($da6e679e22b3b02c$var$isPoint(a) && $da6e679e22b3b02c$var$isPoint(b)) {
        var xDelta = $da6e679e22b3b02c$var$distance1D(a.x, b.x);
        var yDelta = $da6e679e22b3b02c$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}



var $denZA = parcelRequire("denZA");

var $39a0361a481e4676$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
/**
 * SSR: Graceful fallback for the `body` element
 */ var $39a0361a481e4676$var$mockBody = {
    classList: {
        add: (0, $da6e679e22b3b02c$export$8793edee2d425525),
        remove: (0, $da6e679e22b3b02c$export$8793edee2d425525)
    }
};
var $39a0361a481e4676$var$getBody = ()=>(0, $405775388fe7f58e$export$4e09c449d6c407f7) ? document.body : $39a0361a481e4676$var$mockBody;
function $39a0361a481e4676$export$c33f904b1f8d1262(isDark) {
    var body = $39a0361a481e4676$var$getBody();
    body.classList.add(isDark ? $39a0361a481e4676$var$classNames.dark : $39a0361a481e4676$var$classNames.light);
    body.classList.remove(isDark ? $39a0361a481e4676$var$classNames.light : $39a0361a481e4676$var$classNames.dark);
}
/**
 * Check if JS media query matches the query string passed
 */ function $39a0361a481e4676$var$getMediaQuery(query) {
    var mediaQueryList = window.matchMedia == null ? void 0 : window.matchMedia(query);
    if (!mediaQueryList) return undefined;
    return !!mediaQueryList.media === mediaQueryList.matches;
}
var $39a0361a481e4676$export$973f5a1dfb5a80d2 = {
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)"
};
var $39a0361a481e4676$export$15a7a451d35fbac2 = $39a0361a481e4676$export$973f5a1dfb5a80d2.light;
var $39a0361a481e4676$export$120c158f752df069 = $39a0361a481e4676$export$973f5a1dfb5a80d2.dark;
function $39a0361a481e4676$export$3caa7590cc1987bd(fallback) {
    var _getMediaQuery;
    var isDark = (_getMediaQuery = $39a0361a481e4676$var$getMediaQuery($39a0361a481e4676$export$973f5a1dfb5a80d2.dark)) != null ? _getMediaQuery : fallback === "dark";
    return isDark ? "dark" : "light";
}
function $39a0361a481e4676$export$f03a6b845d3fb58b(fn) {
    if (!("matchMedia" in window)) return 0, $da6e679e22b3b02c$export$8793edee2d425525;
    var mediaQueryList = window.matchMedia($39a0361a481e4676$export$973f5a1dfb5a80d2.dark);
    var listener = ()=>{
        fn(mediaQueryList.matches ? "dark" : "light");
    };
    listener();
    mediaQueryList.addListener(listener);
    return ()=>{
        mediaQueryList.removeListener(listener);
    };
}
var $39a0361a481e4676$export$e8e78c978b129247 = {
    get: ()=>document.documentElement.style.getPropertyValue("--chakra-ui-color-mode"),
    set: (mode)=>{
        if (0, $405775388fe7f58e$export$4e09c449d6c407f7) document.documentElement.style.setProperty("--chakra-ui-color-mode", mode);
    }
};



var $22a339189fa7168d$var$hasSupport = ()=>typeof Storage !== "undefined";
var $22a339189fa7168d$export$7367158f2f597ab1 = "chakra-ui-color-mode";
var $22a339189fa7168d$export$8e35886de8a54f45 = {
    get (init) {
        if (!$22a339189fa7168d$var$hasSupport()) return init;
        try {
            var _value = localStorage.getItem($22a339189fa7168d$export$7367158f2f597ab1);
            return _value != null ? _value : init;
        } catch (error) {
            if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) console.log(error);
            return init;
        }
    },
    set (value) {
        if (!$22a339189fa7168d$var$hasSupport()) return;
        try {
            localStorage.setItem($22a339189fa7168d$export$7367158f2f597ab1, value);
        } catch (error) {
            if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) console.log(error);
        }
    },
    type: "localStorage"
};
var $22a339189fa7168d$export$2e2b0158437077e3 = function cookieStorageManager(cookies) {
    if (cookies === void 0) cookies = "";
    return {
        get (init) {
            var match = cookies.match(new RegExp("(^| )" + $22a339189fa7168d$export$7367158f2f597ab1 + "=([^;]+)"));
            if (match) return match[2];
            return init;
        },
        set (value) {
            document.cookie = $22a339189fa7168d$export$7367158f2f597ab1 + "=" + value + "; max-age=31536000; path=/";
        },
        type: "cookie"
    };
};


function $cb7c335cf150f8d2$var$_extends() {
    $cb7c335cf150f8d2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb7c335cf150f8d2$var$_extends.apply(this, arguments);
}
var $cb7c335cf150f8d2$export$49ddd74a6729fdb0 = /*#__PURE__*/ $denZA.createContext({});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $cb7c335cf150f8d2$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
var $cb7c335cf150f8d2$export$20f3076712c8dfa = ()=>{
    var context = $denZA.useContext($cb7c335cf150f8d2$export$49ddd74a6729fdb0);
    if (context === undefined) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
};
function $cb7c335cf150f8d2$export$7a858aa3ff83dde7(props) {
    var { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode }, colorModeManager: colorModeManager = (0, $22a339189fa7168d$export$8e35886de8a54f45) } = props;
    /**
   * Only attempt to retrieve if we're on the server. Else this will result
   * in a hydration mismatch warning and partially invalid visuals.
   *
   * Else fallback safely to `theme.config.initialColormode` (default light)
   */ var [colorMode, rawSetColorMode] = $denZA.useState(colorModeManager.type === "cookie" ? colorModeManager.get(initialColorMode) : initialColorMode);
    $denZA.useEffect(()=>{
        /**
     * Since we cannot initially retrieve localStorage to due above mentioned
     * reasons, do so after hydration.
     *
     * Priority:
     * - system color mode
     * - defined value on <ColorModeScript />, if present
     * - previously stored value
     */ if ((0, $405775388fe7f58e$export$4e09c449d6c407f7) && colorModeManager.type === "localStorage") {
            var mode = useSystemColorMode ? (0, $39a0361a481e4676$export$3caa7590cc1987bd)(initialColorMode) : (0, $39a0361a481e4676$export$e8e78c978b129247).get() || colorModeManager.get();
            if (mode) rawSetColorMode(mode);
        }
    }, [
        colorModeManager,
        useSystemColorMode,
        initialColorMode
    ]);
    $denZA.useEffect(()=>{
        var isDark = colorMode === "dark";
        (0, $39a0361a481e4676$export$c33f904b1f8d1262)(isDark);
        (0, $39a0361a481e4676$export$e8e78c978b129247).set(isDark ? "dark" : "light");
    }, [
        colorMode
    ]);
    var setColorMode = $denZA.useCallback((value)=>{
        colorModeManager.set(value);
        rawSetColorMode(value);
    }, [
        colorModeManager
    ]);
    var toggleColorMode = $denZA.useCallback(()=>{
        setColorMode(colorMode === "light" ? "dark" : "light");
    }, [
        colorMode,
        setColorMode
    ]);
    $denZA.useEffect(()=>{
        var removeListener;
        if (useSystemColorMode) removeListener = (0, $39a0361a481e4676$export$f03a6b845d3fb58b)(setColorMode);
        return ()=>{
            if (removeListener && useSystemColorMode) removeListener();
        };
    }, [
        setColorMode,
        useSystemColorMode
    ]); // presence of `value` indicates a controlled context
    var context = $denZA.useMemo(()=>({
            colorMode: value != null ? value : colorMode,
            toggleColorMode: value ? (0, $da6e679e22b3b02c$export$8793edee2d425525) : toggleColorMode,
            setColorMode: value ? (0, $da6e679e22b3b02c$export$8793edee2d425525) : setColorMode
        }), [
        colorMode,
        setColorMode,
        toggleColorMode,
        value
    ]);
    return /*#__PURE__*/ $denZA.createElement($cb7c335cf150f8d2$export$49ddd74a6729fdb0.Provider, {
        value: context
    }, children);
}
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $cb7c335cf150f8d2$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
var $cb7c335cf150f8d2$export$8b41b18ed1f3731e = (props)=>/*#__PURE__*/ $denZA.createElement($cb7c335cf150f8d2$export$49ddd74a6729fdb0.Provider, $cb7c335cf150f8d2$var$_extends({
        value: {
            colorMode: "dark",
            toggleColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525),
            setColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525)
        }
    }, props));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $cb7c335cf150f8d2$export$8b41b18ed1f3731e.displayName = "DarkMode";
var $cb7c335cf150f8d2$export$cee2b1aa9166b2a3 = (props)=>/*#__PURE__*/ $denZA.createElement($cb7c335cf150f8d2$export$49ddd74a6729fdb0.Provider, $cb7c335cf150f8d2$var$_extends({
        value: {
            colorMode: "light",
            toggleColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525),
            setColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525)
        }
    }, props));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $cb7c335cf150f8d2$export$cee2b1aa9166b2a3.displayName = "LightMode";
function $cb7c335cf150f8d2$export$d18f2ef57b0d7644(light, dark) {
    var { colorMode: colorMode } = $cb7c335cf150f8d2$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}


var $954a09018ee9d0a8$exports = {};
$parcel$export($954a09018ee9d0a8$exports, "css", function () { return $0a79821e0a6de3e8$export$dbf350e5966cf602; });
$parcel$export($954a09018ee9d0a8$exports, "isStyleProp", function () { return $796ce8a66d67a463$export$95b76554d0cd12d6; });
$parcel$export($954a09018ee9d0a8$exports, "layoutPropNames", function () { return $796ce8a66d67a463$export$bccb7c6ca2f4f912; });
$parcel$export($954a09018ee9d0a8$exports, "propNames", function () { return $796ce8a66d67a463$export$332cc7004bcbb8b4; });
$parcel$export($954a09018ee9d0a8$exports, "toCSSVar", function () { return $6be3b2071575aaa5$export$d4e5dc2a444c0164; });

var $6d2b4e6cb71d3435$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        var valueStr = String(value);
        var key = scale ? scale + "." + valueStr : valueStr;
        return (0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    };
function $6d2b4e6cb71d3435$export$99c68a89351e15c0(options) {
    var { scale: scale, transform: transform, compose: compose } = options;
    var fn = (value, theme)=>{
        var _transform;
        var _value = $6d2b4e6cb71d3435$export$92f5bb613cffac78(scale, value)(theme);
        var result = (_transform = transform == null ? void 0 : transform(_value, theme)) != null ? _transform : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}



function $c33ee75ac5b8395e$export$9ced7da5e9a2be1b(scale, transform) {
    return (property)=>{
        var result = {
            property: property,
            scale: scale
        };
        result.transform = (0, $6d2b4e6cb71d3435$export$99c68a89351e15c0)({
            scale: scale,
            transform: transform
        });
        return result;
    };
}
var $c33ee75ac5b8395e$var$getRtl = (_ref)=>{
    var { rtl: rtl, ltr: ltr } = _ref;
    return (theme)=>theme.direction === "rtl" ? rtl : ltr;
};
function $c33ee75ac5b8395e$export$965c6ce6d3869a7a(options) {
    var { property: property, scale: scale, transform: transform } = options;
    return {
        scale: scale,
        property: $c33ee75ac5b8395e$var$getRtl(property),
        transform: scale ? (0, $6d2b4e6cb71d3435$export$99c68a89351e15c0)({
            scale: scale,
            compose: transform
        }) : transform
    };
}



/**
 * The CSS transform order following the upcoming spec from CSSWG
 * translate => rotate => scale => skew
 * @see https://drafts.csswg.org/css-transforms-2/#ctm
 * @see https://www.stefanjudis.com/blog/order-in-css-transformation-transform-functions-vs-individual-transforms/
 */ var $d603d218334deb2b$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $d603d218334deb2b$export$5f430efbe955e23() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$d603d218334deb2b$var$transformTemplate
    ].join(" ");
}
function $d603d218334deb2b$export$64ac7328c339e78f() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$d603d218334deb2b$var$transformTemplate
    ].join(" ");
}
var $d603d218334deb2b$export$b74d0d62597cd7c1 = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $d603d218334deb2b$export$560b9f000772a3a3 = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $d603d218334deb2b$export$c6454f9b51b226bb(value) {
    return {
        "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
        "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
        "--chakra-ring-width": value,
        boxShadow: [
            "var(--chakra-ring-offset-shadow)",
            "var(--chakra-ring-shadow)",
            "var(--chakra-shadow, 0 0 #0000)"
        ].join(", ")
    };
}
var $d603d218334deb2b$export$2d29807f3ae71abd = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
var $d603d218334deb2b$var$owlSelector = "& > :not(style) ~ :not(style)";
var $d603d218334deb2b$export$3acb83ecb79510bf = {
    [$d603d218334deb2b$var$owlSelector]: {
        marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
        marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
    }
};
var $d603d218334deb2b$export$fe76fcc282cee508 = {
    [$d603d218334deb2b$var$owlSelector]: {
        marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
        marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
    }
};



function $84faec6549ef53db$var$_wrapRegExp(re, groups) {
    $84faec6549ef53db$var$_wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, undefined, groups);
    };
    var _RegExp = $84faec6549ef53db$var$_wrapNativeSuper(RegExp);
    var _super = RegExp.prototype;
    var _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = _RegExp.call(this, re, flags);
        _groups.set(_this, groups || _groups.get(re));
        return _this;
    }
    $84faec6549ef53db$var$_inherits(BabelRegExp, _RegExp);
    BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        if (result) result.groups = buildGroups(result, this);
        return result;
    };
    BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if (typeof substitution === "string") {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        } else if (typeof substitution === "function") {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = [];
                args.push.apply(args, arguments);
                if (typeof args[args.length - 1] !== "object") args.push(buildGroups(args, _this));
                return substitution.apply(this, args);
            });
        } else return _super[Symbol.replace].call(this, str, substitution);
    };
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            groups[name] = result[g[name]];
            return groups;
        }, Object.create(null));
    }
    return $84faec6549ef53db$var$_wrapRegExp.apply(this, arguments);
}
function $84faec6549ef53db$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $84faec6549ef53db$var$_setPrototypeOf(subClass, superClass);
}
function $84faec6549ef53db$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $84faec6549ef53db$var$_assertThisInitialized(self);
}
function $84faec6549ef53db$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $84faec6549ef53db$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $84faec6549ef53db$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$84faec6549ef53db$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $84faec6549ef53db$var$_construct(Class, arguments, $84faec6549ef53db$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $84faec6549ef53db$var$_setPrototypeOf(Wrapper, Class);
    };
    return $84faec6549ef53db$var$_wrapNativeSuper(Class);
}
function $84faec6549ef53db$var$_construct(Parent, args, Class) {
    if ($84faec6549ef53db$var$_isNativeReflectConstruct()) $84faec6549ef53db$var$_construct = Reflect.construct;
    else $84faec6549ef53db$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $84faec6549ef53db$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $84faec6549ef53db$var$_construct.apply(null, arguments);
}
function $84faec6549ef53db$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $84faec6549ef53db$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $84faec6549ef53db$var$_setPrototypeOf(o, p) {
    $84faec6549ef53db$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $84faec6549ef53db$var$_setPrototypeOf(o, p);
}
function $84faec6549ef53db$var$_getPrototypeOf(o) {
    $84faec6549ef53db$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $84faec6549ef53db$var$_getPrototypeOf(o);
}
var $84faec6549ef53db$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $84faec6549ef53db$var$valueSet = new Set(Object.values($84faec6549ef53db$var$directionMap));
var $84faec6549ef53db$export$64d5d115563291e3 = new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $84faec6549ef53db$var$trimSpace = (str)=>str.trim();
function $84faec6549ef53db$export$1089ae7f4d02cd2e(value, theme) {
    var _regex$exec$groups, _regex$exec;
    if (value == null || $84faec6549ef53db$export$64d5d115563291e3.has(value)) return value;
    var regex = /*#__PURE__*/ $84faec6549ef53db$var$_wrapRegExp(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
        type: 1,
        values: 2
    });
    var { type: type, values: values } = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {};
    if (!type || !values) return value;
    var _type = type.includes("-gradient") ? type : type + "-gradient";
    var [maybeDirection, ...stops] = values.split(",").map($84faec6549ef53db$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    var direction = maybeDirection in $84faec6549ef53db$var$directionMap ? $84faec6549ef53db$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    var _values = stops.map((stop)=>{
        // if stop is valid shorthand direction, return it
        if ($84faec6549ef53db$var$valueSet.has(stop)) return stop;
        var firstStop = stop.indexOf(" "); // color stop could be `red.200 20%` based on css gradient spec
        var [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        var _stopOrFunc = $84faec6549ef53db$export$710a7f202c1f9f4e(_stop) ? _stop : _stop && _stop.split(" "); // else, get and transform the color token or css value
        var key = "colors." + _color;
        var color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color,
            _stopOrFunc
        ].join(" ") : color;
    });
    return _type + "(" + _values.join(", ") + ")";
}
var $84faec6549ef53db$export$710a7f202c1f9f4e = (value)=>{
    return (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(value) && value.includes("(") && value.includes(")");
};
var $84faec6549ef53db$export$6bab994d7a66bebb = (value, theme)=>$84faec6549ef53db$export$1089ae7f4d02cd2e(value, theme != null ? theme : {});


var $3bd46247c4397f9f$var$analyzeCSSValue = (value)=>{
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $3bd46247c4397f9f$var$wrap = (str)=>(value)=>str + "(" + value + ")";
var $3bd46247c4397f9f$export$f1c738cddd9a74ae = {
    filter (value) {
        return value !== "auto" ? value : (0, $d603d218334deb2b$export$b74d0d62597cd7c1);
    },
    backdropFilter (value) {
        return value !== "auto" ? value : (0, $d603d218334deb2b$export$560b9f000772a3a3);
    },
    ring (value) {
        return (0, $d603d218334deb2b$export$c6454f9b51b226bb)($3bd46247c4397f9f$export$f1c738cddd9a74ae.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return (0, $d603d218334deb2b$export$5f430efbe955e23)();
        if (value === "auto-gpu") return (0, $d603d218334deb2b$export$64ac7328c339e78f)();
        return value;
    },
    px (value) {
        if (value == null) return value;
        var { unitless: unitless } = $3bd46247c4397f9f$var$analyzeCSSValue(value);
        return unitless || (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) ? value + "px" : value;
    },
    fraction (value) {
        return !(0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) || value > 1 ? value : value * 100 + "%";
    },
    float (value, theme) {
        var map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ((0, $6b74ef5ae6a56e47$export$30a9abfd5fb9f5f6)(value) || value == null) return value;
        var unitless = (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(value) && !value.endsWith("deg");
        return (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) || unitless ? value + "deg" : value;
    },
    gradient: (0, $84faec6549ef53db$export$6bab994d7a66bebb),
    blur: $3bd46247c4397f9f$var$wrap("blur"),
    opacity: $3bd46247c4397f9f$var$wrap("opacity"),
    brightness: $3bd46247c4397f9f$var$wrap("brightness"),
    contrast: $3bd46247c4397f9f$var$wrap("contrast"),
    dropShadow: $3bd46247c4397f9f$var$wrap("drop-shadow"),
    grayscale: $3bd46247c4397f9f$var$wrap("grayscale"),
    hueRotate: $3bd46247c4397f9f$var$wrap("hue-rotate"),
    invert: $3bd46247c4397f9f$var$wrap("invert"),
    saturate: $3bd46247c4397f9f$var$wrap("saturate"),
    sepia: $3bd46247c4397f9f$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        var prevent = (0, $84faec6549ef53db$export$710a7f202c1f9f4e)(value) || (0, $84faec6549ef53db$export$64d5d115563291e3).has(value);
        return !prevent ? "url(" + value + ")" : value;
    },
    outline (value) {
        var isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _flexDirectionTemplat;
        var { space: space, divide: divide } = (_flexDirectionTemplat = (0, $d603d218334deb2b$export$2d29807f3ae71abd)[value]) != null ? _flexDirectionTemplat : {};
        var result = {
            flexDirection: value
        };
        if (space) result[space] = 1;
        if (divide) result[divide] = 1;
        return result;
    }
};




function $2faf7f8b566cee19$var$_extends() {
    $2faf7f8b566cee19$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2faf7f8b566cee19$var$_extends.apply(this, arguments);
}
var $2faf7f8b566cee19$export$625550452a3fa3ec = {
    borderWidths: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("borderWidths"),
    borderStyles: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("borderStyles"),
    colors: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("colors"),
    borders: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("borders"),
    radii: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("radii", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).px),
    space: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("space", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).px),
    spaceT: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("space", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).px),
    degreeT (property) {
        return {
            property: property,
            transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).degree
        };
    },
    prop (property, scale, transform) {
        return $2faf7f8b566cee19$var$_extends({
            property: property,
            scale: scale
        }, scale && {
            transform: (0, $6d2b4e6cb71d3435$export$99c68a89351e15c0)({
                scale: scale,
                transform: transform
            })
        });
    },
    propT (property, transform) {
        return {
            property: property,
            transform: transform
        };
    },
    sizes: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("sizes", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).px),
    sizesT: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("sizes", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).fraction),
    shadows: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("shadows"),
    logical: $c33ee75ac5b8395e$export$965c6ce6d3869a7a,
    blur: (0, $c33ee75ac5b8395e$export$9ced7da5e9a2be1b)("blur", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).blur)
};


var $986263dba86a5109$export$8ce1fd94bee2f412 = {
    background: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("background"),
    backgroundColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("backgroundColor"),
    backgroundImage: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("backgroundImage", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).bgImage),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).bgClip
    },
    bgSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundSize"),
    bgPosition: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundPosition"),
    bg: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("background"),
    bgColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("backgroundColor"),
    bgPos: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundPosition"),
    bgRepeat: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundRepeat"),
    bgAttachment: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundAttachment"),
    bgGradient: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("backgroundImage", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).gradient),
    bgClip: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).bgClip
    }
};
Object.assign($986263dba86a5109$export$8ce1fd94bee2f412, {
    bgImage: $986263dba86a5109$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $986263dba86a5109$export$8ce1fd94bee2f412.backgroundImage
});



var $59249ec991dcb533$export$1edee58a52776cd9 = {
    border: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("border"),
    borderWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderWidth"),
    borderStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderStyle"),
    borderColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderColor"),
    borderRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii("borderRadius"),
    borderTop: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderTop"),
    borderBlockStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderBlockStart"),
    borderTopLeftRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii("borderTopLeftRadius"),
    borderStartStartRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii("borderTopRightRadius"),
    borderStartEndRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderRight"),
    borderInlineEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderInlineEnd"),
    borderBottom: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderBottom"),
    borderBlockEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderBlockEnd"),
    borderBottomLeftRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii("borderBottomLeftRadius"),
    borderBottomRightRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii("borderBottomRightRadius"),
    borderLeft: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderInline"),
    borderY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borders("borderBlock"),
    borderTopWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderTopWidth"),
    borderBlockStartWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderBlockStartWidth"),
    borderTopColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderTopColor"),
    borderBlockStartColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderBlockStartColor"),
    borderTopStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderTopStyle"),
    borderBlockStartStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderBlockStartStyle"),
    borderBottomWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderBottomWidth"),
    borderBlockEndWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderBlockEndWidth"),
    borderBottomColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderBottomColor"),
    borderBlockEndColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderBlockEndColor"),
    borderBottomStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderBottomStyle"),
    borderBlockEndStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderBlockEndStyle"),
    borderLeftWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderLeftWidth"),
    borderInlineStartWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderInlineStartWidth"),
    borderLeftColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderLeftColor"),
    borderInlineStartColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderInlineStartColor"),
    borderLeftStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderLeftStyle"),
    borderInlineStartStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderInlineStartStyle"),
    borderRightWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderRightWidth"),
    borderInlineEndWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderWidths("borderInlineEndWidth"),
    borderRightColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderRightColor"),
    borderInlineEndColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("borderInlineEndColor"),
    borderRightStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderRightStyle"),
    borderInlineEndStyle: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).borderStyles("borderInlineEndStyle"),
    borderTopRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($59249ec991dcb533$export$1edee58a52776cd9, {
    rounded: $59249ec991dcb533$export$1edee58a52776cd9.borderRadius,
    roundedTop: $59249ec991dcb533$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $59249ec991dcb533$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $59249ec991dcb533$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $59249ec991dcb533$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $59249ec991dcb533$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $59249ec991dcb533$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $59249ec991dcb533$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $59249ec991dcb533$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $59249ec991dcb533$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $59249ec991dcb533$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $59249ec991dcb533$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $59249ec991dcb533$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $59249ec991dcb533$export$1edee58a52776cd9.borderInlineEndStyle
}); /**
 * The prop types for border properties listed above
 */ 



var $7b65c594ae4aeb4e$export$35e9368ef982300f = {
    color: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("color"),
    textColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("color"),
    fill: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("fill"),
    stroke: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("stroke")
};



var $428ba786ba1e4c36$export$dc573d8a6576cdb3 = {
    boxShadow: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($428ba786ba1e4c36$export$dc573d8a6576cdb3, {
    shadow: $428ba786ba1e4c36$export$dc573d8a6576cdb3.boxShadow
}); /**
 * Types for box and text shadow properties
 */ 



var $1b6a80b84e8ddffd$export$3dea766d36a8935f = {
    filter: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).filter
    },
    blur: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).blur("--chakra-blur"),
    brightness: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-brightness", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).brightness),
    contrast: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-contrast", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).contrast),
    hueRotate: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).degreeT("--chakra-hue-rotate"),
    invert: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-invert", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).invert),
    saturate: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-saturate", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).saturate),
    dropShadow: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-drop-shadow", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).dropShadow),
    backdropFilter: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).backdropFilter
    },
    backdropBlur: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).blur("--chakra-backdrop-blur"),
    backdropBrightness: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-backdrop-brightness", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).brightness),
    backdropContrast: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-backdrop-contrast", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).contrast),
    backdropHueRotate: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-backdrop-invert", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).invert),
    backdropSaturate: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("--chakra-backdrop-saturate", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).saturate)
};





var $2c160fdf20d674ab$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).flexDirection
    },
    experimental_spaceX: {
        static: (0, $d603d218334deb2b$export$3acb83ecb79510bf),
        transform: (0, $6d2b4e6cb71d3435$export$99c68a89351e15c0)({
            scale: "space",
            transform: (value)=>value !== null ? {
                    "--chakra-space-x": value
                } : null
        })
    },
    experimental_spaceY: {
        static: (0, $d603d218334deb2b$export$fe76fcc282cee508),
        transform: (0, $6d2b4e6cb71d3435$export$99c68a89351e15c0)({
            scale: "space",
            transform: (value)=>value != null ? {
                    "--chakra-space-y": value
                } : null
        })
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true
};
Object.assign($2c160fdf20d674ab$export$feec61708a55c80e, {
    flexDir: $2c160fdf20d674ab$export$feec61708a55c80e.flexDirection
});



var $01560696f2265317$export$85fc379452d91af0 = {
    gridGap: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("gridGap"),
    gridColumnGap: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("gridColumnGap"),
    gridRowGap: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};



var $c8b4fa6651009963$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).outline
    },
    outlineOffset: true,
    outlineColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("outlineColor")
};



var $aa06873b9e64738e$export$b3219800bda33a1f = {
    width: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizesT("width"),
    inlineSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizesT("inlineSize"),
    height: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("height"),
    blockSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("blockSize"),
    boxSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes([
        "width",
        "height"
    ]),
    minWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("minWidth"),
    minInlineSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("minInlineSize"),
    minHeight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("minHeight"),
    minBlockSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("minBlockSize"),
    maxWidth: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("maxWidth"),
    maxInlineSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("maxInlineSize"),
    maxHeight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("maxHeight"),
    maxBlockSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).sizes("maxBlockSize"),
    d: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("display"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("float", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($aa06873b9e64738e$export$b3219800bda33a1f, {
    w: $aa06873b9e64738e$export$b3219800bda33a1f.width,
    h: $aa06873b9e64738e$export$b3219800bda33a1f.height,
    minW: $aa06873b9e64738e$export$b3219800bda33a1f.minWidth,
    maxW: $aa06873b9e64738e$export$b3219800bda33a1f.maxWidth,
    minH: $aa06873b9e64738e$export$b3219800bda33a1f.minHeight,
    maxH: $aa06873b9e64738e$export$b3219800bda33a1f.maxHeight,
    overscroll: $aa06873b9e64738e$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $aa06873b9e64738e$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $aa06873b9e64738e$export$b3219800bda33a1f.overscrollBehaviorY
}); /**
 * Types for layout related CSS properties
 */ 



var $ecc247c3258f08c8$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("listStyleImage")
};



var $e5Q7j = parcelRequire("e5Q7j");
function $dfe73229adf076fd$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $dfe73229adf076fd$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $dfe73229adf076fd$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $dfe73229adf076fd$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $dfe73229adf076fd$export$fc10aeed3a532e2a = (fn)=>{
    var cache = new WeakMap();
    var memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $dfe73229adf076fd$export$1bb32d0c65da6059 = $dfe73229adf076fd$export$fc10aeed3a532e2a($dfe73229adf076fd$export$3988ae62b71be9a3);
function $dfe73229adf076fd$export$73b8ef55a37133c7(path, scale) {
    return $dfe73229adf076fd$export$1bb32d0c65da6059(scale, path, path);
}
function $dfe73229adf076fd$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach((key)=>{
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $dfe73229adf076fd$export$2458ce75c8ef9806 = (object)=>$dfe73229adf076fd$export$3417cf6417437960(object, (val)=>val !== null && val !== undefined);
var $dfe73229adf076fd$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $dfe73229adf076fd$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, _ref)=>{
        var [key, value] = _ref;
        carry[key] = value;
        return carry;
    }, {});
var $dfe73229adf076fd$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};


var $c28b535bd1596343$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $c28b535bd1596343$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $c28b535bd1596343$var$getWithPriority = (theme, key, styles)=>{
    var result = {};
    var obj = (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, key, {});
    for(var prop in obj){
        var isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $c28b535bd1596343$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $c28b535bd1596343$var$srOnly;
            if (value === "focusable") return $c28b535bd1596343$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$c28b535bd1596343$var$getWithPriority(theme, "layerStyles." + value, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$c28b535bd1596343$var$getWithPriority(theme, "textStyles." + value, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$c28b535bd1596343$var$getWithPriority(theme, value, styles)
    }
};



var $2ae3b46ac6c13b53$export$5880b8b5730aff45 = {
    position: true,
    pos: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("position"),
    zIndex: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("zIndex", "zIndices"),
    inset: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT([
        "top",
        "right",
        "bottom",
        "left"
    ]),
    insetX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT([
        "left",
        "right"
    ]),
    insetInline: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("insetInline"),
    insetY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("insetBlock"),
    top: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("top"),
    insetBlockStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("insetBlockStart"),
    bottom: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("bottom"),
    insetBlockEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("insetBlockEnd"),
    left: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("left"),
    insetInlineStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("right"),
    insetInlineEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($2ae3b46ac6c13b53$export$5880b8b5730aff45, {
    insetStart: $2ae3b46ac6c13b53$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $2ae3b46ac6c13b53$export$5880b8b5730aff45.insetInlineEnd
}); /**
 * Types for position CSS properties
 */ 



var $3a9ac879c4d805e7$export$e7d0da6968da5dd = {
    ring: {
        transform: (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).ring
    },
    ringColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("--chakra-ring-color"),
    ringOffset: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("--chakra-ring-offset-width"),
    ringOffsetColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("--chakra-ring-offset-color"),
    ringInset: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("--chakra-ring-inset")
};



var $2c1498f5a6a5260b$export$a941ed4b947d12f8 = {
    margin: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("margin"),
    marginTop: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginTop"),
    marginBlockStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginBlockStart"),
    marginRight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginRight"),
    marginInlineEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginInlineEnd"),
    marginBottom: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginBottom"),
    marginBlockEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginBlockEnd"),
    marginLeft: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginLeft"),
    marginInlineStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginInlineStart"),
    marginX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginInline"),
    marginY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("marginBlock"),
    padding: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("padding"),
    paddingTop: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingTop"),
    paddingBlockStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingBlockStart"),
    paddingRight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingRight"),
    paddingBottom: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingBottom"),
    paddingBlockEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingBlockEnd"),
    paddingLeft: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingLeft"),
    paddingInlineStart: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingInlineStart"),
    paddingInlineEnd: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingInlineEnd"),
    paddingX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingInline"),
    paddingY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).space("paddingBlock")
};
Object.assign($2c1498f5a6a5260b$export$a941ed4b947d12f8, {
    m: $2c1498f5a6a5260b$export$a941ed4b947d12f8.margin,
    mt: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginTop,
    mr: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginRight,
    me: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginBottom,
    ml: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginLeft,
    ms: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginInlineStart,
    mx: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginX,
    my: $2c1498f5a6a5260b$export$a941ed4b947d12f8.marginY,
    p: $2c1498f5a6a5260b$export$a941ed4b947d12f8.padding,
    pt: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingTop,
    py: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingY,
    px: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingX,
    pb: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingBottom,
    pl: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingLeft,
    ps: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingRight,
    pe: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $2c1498f5a6a5260b$export$a941ed4b947d12f8.paddingInlineEnd
}); /**
 * Types for space related CSS properties
 */ 



var $46c4c439db1f211d$export$6b7f9af9aa033040 = {
    textDecorationColor: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).shadows("textShadow")
};



var $7f61dc32f9e1ad7e$export$51186ad6e864892a = {
    clipPath: true,
    transform: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).propT("transform", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).transform),
    transformOrigin: true,
    translateX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("--chakra-translate-x"),
    translateY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).spaceT("--chakra-translate-y"),
    skewX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).degreeT("--chakra-skew-x"),
    skewY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).degreeT("--chakra-skew-y"),
    scaleX: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("--chakra-scale-x"),
    scaleY: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("--chakra-scale-y"),
    scale: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).degreeT("--chakra-rotate")
};



var $2d53220dd56809db$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("transitionDuration", "transition.duration"),
    transitionProperty: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("transitionProperty", "transition.property"),
    transitionTimingFunction: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("transitionTimingFunction", "transition.easing")
};



var $7ed46d056480cb36$export$d846a084e680d8e = {
    fontFamily: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("fontFamily", "fonts"),
    fontSize: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("fontSize", "fontSizes", (0, $3bd46247c4397f9f$export$f1c738cddd9a74ae).px),
    fontWeight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("fontWeight", "fontWeights"),
    lineHeight: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("lineHeight", "lineHeights"),
    letterSpacing: (0, $2faf7f8b566cee19$export$625550452a3fa3ec).prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    },
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    }
}; /**
 * Types for typography related CSS properties
 */ 





var $e5Q7j = parcelRequire("e5Q7j");

var $434c255a0c4338da$var$group = {
    hover: (selector)=>selector + ":hover &, " + selector + "[data-hover] &",
    focus: (selector)=>selector + ":focus &, " + selector + "[data-focus] &",
    active: (selector)=>selector + ":active &, " + selector + "[data-active] &",
    disabled: (selector)=>selector + ":disabled &, " + selector + "[data-disabled] &",
    invalid: (selector)=>selector + ":invalid &, " + selector + "[data-invalid] &",
    checked: (selector)=>selector + ":checked &, " + selector + "[data-checked] &",
    indeterminate: (selector)=>selector + ":indeterminate &, " + selector + "[aria-checked=mixed] &, " + selector + "[data-indeterminate] &",
    readOnly: (selector)=>selector + ":read-only &, " + selector + "[readonly] &, " + selector + "[data-read-only] &",
    expanded: (selector)=>selector + ":read-only &, " + selector + "[aria-expanded=true] &, " + selector + "[data-expanded] &"
};
var $434c255a0c4338da$var$toGroup = (fn)=>$434c255a0c4338da$var$merge(fn, "[role=group]", "[data-group]", ".group");
var $434c255a0c4338da$var$merge = function merge(fn) {
    for(var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)selectors[_key - 1] = arguments[_key];
    return selectors.map(fn).join(", ");
};
var $434c255a0c4338da$export$a36cf593fde2a546 = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within",
    _focusVisible: "&:focus-visible",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */ _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    _empty: "&:empty",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
   * Styles to apply when parent is hovered
   */ _groupHover: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.hover),
    /**
   * Styles to apply when parent is focused
   */ _groupFocus: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.focus),
    /**
   * Styles to apply when parent is active
   */ _groupActive: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.active),
    /**
   * Styles to apply when parent is disabled
   */ _groupDisabled: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.disabled),
    /**
   * Styles to apply when parent is invalid
   */ _groupInvalid: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.invalid),
    /**
   * Styles to apply when parent is checked
   */ _groupChecked: $434c255a0c4338da$var$toGroup($434c255a0c4338da$var$group.checked),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when any parent element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * used when the user has requested the system
   * use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &, [data-theme=dark] &, &[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &, [data-theme=light] &, &[data-theme=light]"
};
var $434c255a0c4338da$export$4ec9644154df43c2 = (0, $dfe73229adf076fd$export$259b4dd69e654a7a)($434c255a0c4338da$export$a36cf593fde2a546);



var $e5Q7j = parcelRequire("e5Q7j");


function $796ce8a66d67a463$var$_extends() {
    $796ce8a66d67a463$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $796ce8a66d67a463$var$_extends.apply(this, arguments);
}
var $796ce8a66d67a463$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, (0, $986263dba86a5109$export$8ce1fd94bee2f412), (0, $59249ec991dcb533$export$1edee58a52776cd9), (0, $7b65c594ae4aeb4e$export$35e9368ef982300f), (0, $2c160fdf20d674ab$export$feec61708a55c80e), (0, $aa06873b9e64738e$export$b3219800bda33a1f), (0, $1b6a80b84e8ddffd$export$3dea766d36a8935f), (0, $3a9ac879c4d805e7$export$e7d0da6968da5dd), (0, $c8b4fa6651009963$export$2499a341a8256d68), (0, $01560696f2265317$export$85fc379452d91af0), (0, $c28b535bd1596343$export$36263e8f8d7ce3b1), (0, $2ae3b46ac6c13b53$export$5880b8b5730aff45), (0, $428ba786ba1e4c36$export$dc573d8a6576cdb3), (0, $2c1498f5a6a5260b$export$a941ed4b947d12f8), (0, $7ed46d056480cb36$export$d846a084e680d8e), (0, $46c4c439db1f211d$export$6b7f9af9aa033040), (0, $7f61dc32f9e1ad7e$export$51186ad6e864892a), (0, $ecc247c3258f08c8$export$8837f4fc672e936d), (0, $2d53220dd56809db$export$66bb15e2994e6a26));
var $796ce8a66d67a463$var$layoutSystem = Object.assign({}, (0, $2c1498f5a6a5260b$export$a941ed4b947d12f8), (0, $aa06873b9e64738e$export$b3219800bda33a1f), (0, $2c160fdf20d674ab$export$feec61708a55c80e), (0, $01560696f2265317$export$85fc379452d91af0), (0, $2ae3b46ac6c13b53$export$5880b8b5730aff45));
var $796ce8a66d67a463$export$bccb7c6ca2f4f912 = (0, $dfe73229adf076fd$export$259b4dd69e654a7a)($796ce8a66d67a463$var$layoutSystem);
var $796ce8a66d67a463$export$332cc7004bcbb8b4 = [
    ...(0, $dfe73229adf076fd$export$259b4dd69e654a7a)($796ce8a66d67a463$export$30cfa87a708babfc),
    ...(0, $434c255a0c4338da$export$4ec9644154df43c2)
];
var $796ce8a66d67a463$var$styleProps = $796ce8a66d67a463$var$_extends({}, $796ce8a66d67a463$export$30cfa87a708babfc, (0, $434c255a0c4338da$export$a36cf593fde2a546));
var $796ce8a66d67a463$export$95b76554d0cd12d6 = (prop)=>prop in $796ce8a66d67a463$var$styleProps;



var $d49016b7bb2480a0$export$fc306d944aa46af9 = (styles)=>(theme)=>{
        /**
   * Before any style can be processed, the user needs to call `toCSSVar`
   * which analyzes the theme's breakpoint and appends a `__breakpoints` property
   * to the theme with more details of the breakpoints.
   *
   * To learn more, go here: packages/utils/src/responsive.ts #analyzeBreakpoints
   */ if (!theme.__breakpoints) return styles;
        var { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        var computedStyles = {};
        for(var key in styles){
            var value = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue; // converts the object responsive syntax to array syntax
            value = (0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            var queries = value.slice(0, medias.length).length;
            for(var index = 0; index < queries; index += 1){
                var media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };


var $0a79821e0a6de3e8$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(value) && !(0, $6b74ef5ae6a56e47$export$30a9abfd5fb9f5f6)(value);
var $0a79821e0a6de3e8$var$resolveTokenValue = (theme, value)=>{
    var _ref, _getVar2;
    if (value == null) return value;
    var getVar = (val)=>{
        var _theme$__cssMap, _theme$__cssMap$val;
        return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
    };
    var getValue = (val)=>{
        var _getVar;
        return (_getVar = getVar(val)) != null ? _getVar : val;
    };
    var valueSplit = value.split(",").map((v)=>v.trim());
    var [tokenValue, fallbackValue] = valueSplit;
    value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
    return value;
};
function $0a79821e0a6de3e8$export$955358618f994a11(options) {
    var { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    var css = function css(stylesOrFn, nested) {
        if (nested === void 0) nested = false;
        var _styles = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(stylesOrFn, theme);
        var styles = (0, $d49016b7bb2480a0$export$fc306d944aa46af9)(_styles)(theme);
        var computedStyles = {};
        for(var key in styles){
            var _config$transform, _config, _config2, _config3, _config4;
            var valueOrFn = styles[key];
            /**
       * allows the user to pass functional values
       * boxShadow: theme => `0 2px 2px ${theme.colors.red}`
       */ var value = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(valueOrFn, theme);
            /**
       * converts pseudo shorthands to valid selector
       * "_hover" => "&:hover"
       */ if (key in pseudos) key = pseudos[key];
            /**
       * allows the user to use theme tokens in css vars
       * { --banner-height: "sizes.md" } => { --banner-height: "var(--chakra-sizes-md)" }
       *
       * You can also provide fallback values
       * { --banner-height: "sizes.no-exist, 40px" } => { --banner-height: "40px" }
       */ if ($0a79821e0a6de3e8$var$isCSSVariableTokenValue(key, value)) value = $0a79821e0a6de3e8$var$resolveTokenValue(theme, value);
            var config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(value)) {
                var _computedStyles$key;
                computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles[key], css(value, true));
                continue;
            }
            var rawValue = (_config$transform = (_config = config) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme, _styles)) != null ? _config$transform : value;
            /**
       * Used for `layerStyle`, `textStyle` and `apply`. After getting the
       * styles in the theme, we need to process them since they might
       * contain theme tokens.
       *
       * `processResult` is the config property we pass to `layerStyle`, `textStyle` and `apply`
       */ rawValue = (_config2 = config) != null && _config2.processResult ? css(rawValue, true) : rawValue;
            /**
       * allows us define css properties for RTL and LTR.
       *
       * const marginStart = {
       *   property: theme => theme.direction === "rtl" ? "marginRight": "marginLeft",
       * }
       */ var configProperty = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_config3 = config) == null ? void 0 : _config3.property, theme);
            if (!nested && (_config4 = config) != null && _config4.static) {
                var staticStyles = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (var property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css;
}
var $0a79821e0a6de3e8$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        var cssFn = $0a79821e0a6de3e8$export$955358618f994a11({
            theme: theme,
            pseudos: (0, $434c255a0c4338da$export$a36cf593fde2a546),
            configs: (0, $796ce8a66d67a463$export$30cfa87a708babfc)
        });
        return cssFn(styles);
    };


var $971bf6a595ce5438$exports = {};


var $88298f37f45d59d6$exports = {};



/**
 * Thank you @markdalgleish for this piece of art!
 */ 
function $9face71b9ee62195$var$resolveReference(operand) {
    if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $9face71b9ee62195$var$toExpression = function toExpression(operator) {
    for(var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)operands[_key - 1] = arguments[_key];
    return operands.map($9face71b9ee62195$var$resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};
var $9face71b9ee62195$var$_add = function add() {
    for(var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)operands[_key2] = arguments[_key2];
    return "calc(" + $9face71b9ee62195$var$toExpression("+", ...operands) + ")";
};
var $9face71b9ee62195$var$_subtract = function subtract() {
    for(var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)operands[_key3] = arguments[_key3];
    return "calc(" + $9face71b9ee62195$var$toExpression("-", ...operands) + ")";
};
var $9face71b9ee62195$var$_multiply = function multiply() {
    for(var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)operands[_key4] = arguments[_key4];
    return "calc(" + $9face71b9ee62195$var$toExpression("*", ...operands) + ")";
};
var $9face71b9ee62195$var$_divide = function divide() {
    for(var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)operands[_key5] = arguments[_key5];
    return "calc(" + $9face71b9ee62195$var$toExpression("/", ...operands) + ")";
};
var $9face71b9ee62195$var$_negate = (x)=>{
    var value = $9face71b9ee62195$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
    return $9face71b9ee62195$var$_multiply(value, -1);
};
var $9face71b9ee62195$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: function add() {
            for(var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)operands[_key6] = arguments[_key6];
            return $9face71b9ee62195$export$42bfa9b2d4dad91a($9face71b9ee62195$var$_add(x, ...operands));
        },
        subtract: function subtract() {
            for(var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)operands[_key7] = arguments[_key7];
            return $9face71b9ee62195$export$42bfa9b2d4dad91a($9face71b9ee62195$var$_subtract(x, ...operands));
        },
        multiply: function multiply() {
            for(var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)operands[_key8] = arguments[_key8];
            return $9face71b9ee62195$export$42bfa9b2d4dad91a($9face71b9ee62195$var$_multiply(x, ...operands));
        },
        divide: function divide() {
            for(var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)operands[_key9] = arguments[_key9];
            return $9face71b9ee62195$export$42bfa9b2d4dad91a($9face71b9ee62195$var$_divide(x, ...operands));
        },
        negate: ()=>$9face71b9ee62195$export$42bfa9b2d4dad91a($9face71b9ee62195$var$_negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $9face71b9ee62195$var$_add,
    subtract: $9face71b9ee62195$var$_subtract,
    multiply: $9face71b9ee62195$var$_multiply,
    divide: $9face71b9ee62195$var$_divide,
    negate: $9face71b9ee62195$var$_negate
});


function $0fd9776e552a94bb$var$replaceWhiteSpace(value, replaceValue) {
    if (replaceValue === void 0) replaceValue = "-";
    return value.replace(/\s+/g, replaceValue);
}
function $0fd9776e552a94bb$var$escape(value) {
    var valueStr = $0fd9776e552a94bb$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    var isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? valueStr.replace(".", "\\.") : value;
}
function $0fd9776e552a94bb$export$9748efee331ec573(value, prefix) {
    if (prefix === void 0) prefix = "";
    return [
        prefix,
        $0fd9776e552a94bb$var$escape(value)
    ].filter(Boolean).join("-");
}
function $0fd9776e552a94bb$export$bb435e137b4b8e38(name, fallback) {
    return "var(" + $0fd9776e552a94bb$var$escape(name) + (fallback ? ", " + fallback : "") + ")";
}
function $0fd9776e552a94bb$export$3695bd65cc73dae9(value, prefix) {
    if (prefix === void 0) prefix = "";
    return "--" + $0fd9776e552a94bb$export$9748efee331ec573(value, prefix);
}
function $0fd9776e552a94bb$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    var cssVariable = $0fd9776e552a94bb$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $0fd9776e552a94bb$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}


function $4cb94e5c0fd5e9d1$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $4cb94e5c0fd5e9d1$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $4cb94e5c0fd5e9d1$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $4cb94e5c0fd5e9d1$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $4cb94e5c0fd5e9d1$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $4cb94e5c0fd5e9d1$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $4cb94e5c0fd5e9d1$export$c36ae5e7e50e8840(array, index) {
    return array.filter((_, idx)=>idx !== index);
}
function $4cb94e5c0fd5e9d1$export$fb9705de59d96855(array, item) {
    return [
        ...array,
        item
    ];
}
function $4cb94e5c0fd5e9d1$export$fe2d9b4e03920b4c(array, item) {
    return array.filter((eachItem)=>eachItem !== item);
}
function $4cb94e5c0fd5e9d1$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
function $4cb94e5c0fd5e9d1$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $4cb94e5c0fd5e9d1$export$c42e0e80904d519(index, count, -1, loop);
}
function $4cb94e5c0fd5e9d1$export$5f7ec48d69707ddd(array, size) {
    return array.reduce((rows, currentValue, index)=>{
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
function $4cb94e5c0fd5e9d1$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}




function $b0d64feb46216e43$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $b0d64feb46216e43$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var { unitless: unitless } = $b0d64feb46216e43$var$analyzeCSSValue(value);
    return unitless || (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) ? value + "px" : value;
}
var $b0d64feb46216e43$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $b0d64feb46216e43$var$sortBps = (breakpoints)=>(0, $dfe73229adf076fd$export$5150077fc2e7c662)(Object.entries(breakpoints).sort($b0d64feb46216e43$var$sortByBreakpointValue));
function $b0d64feb46216e43$var$normalize(breakpoints) {
    var sorted = $b0d64feb46216e43$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $b0d64feb46216e43$var$keys(breakpoints) {
    var value = Object.keys($b0d64feb46216e43$var$sortBps(breakpoints));
    return new Set(value);
}
function $b0d64feb46216e43$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $b0d64feb46216e43$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, (m)=>"" + (parseFloat(m) + factor));
}
function $b0d64feb46216e43$var$queryString(min, max) {
    var query = [];
    if (min) query.push("@media screen and (min-width: " + $b0d64feb46216e43$export$91c0eda1d06bf008(min) + ")");
    if (query.length > 0 && max) query.push("and");
    if (max) query.push("@media screen and (max-width: " + $b0d64feb46216e43$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $b0d64feb46216e43$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $b0d64feb46216e43$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($b0d64feb46216e43$var$sortByBreakpointValue).map((_ref, index, entry)=>{
        var _entry;
        var [breakpoint, minW] = _ref;
        var [, maxW] = (_entry = entry[index + 1]) != null ? _entry : [];
        maxW = parseFloat(maxW) > 0 ? $b0d64feb46216e43$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $b0d64feb46216e43$var$queryString(null, maxW),
            minWQuery: $b0d64feb46216e43$var$queryString(minW),
            minMaxQuery: $b0d64feb46216e43$var$queryString(minW, maxW)
        };
    });
    var _keys = $b0d64feb46216e43$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every((key)=>_keys.has(key));
        },
        asObject: $b0d64feb46216e43$var$sortBps(breakpoints),
        asArray: $b0d64feb46216e43$var$normalize(breakpoints),
        details: queries,
        media: [
            null,
            ...normalized.map((minW)=>$b0d64feb46216e43$var$queryString(minW)).slice(1)
        ],
        toArrayValue (test) {
            if (!(0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map((bp)=>{
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while((0, $4cb94e5c0fd5e9d1$export$7475b2c64539e4cf)(result) === null)result.pop();
            return result;
        },
        toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}



function $0e470ce15a1d8eb6$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ((0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(value)) return value.map((item, index)=>inner(item, [
                ...path,
                String(index)
            ]));
        if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(value)) return Object.fromEntries(Object.entries(value).map((_ref)=>{
            var [key, child] = _ref;
            return [
                key,
                inner(child, [
                    ...path,
                    key
                ])
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}




function $eb79211f5309f78b$var$_extends() {
    $eb79211f5309f78b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb79211f5309f78b$var$_extends.apply(this, arguments);
}
function $eb79211f5309f78b$export$69e96ceeb663bb9(target, options) {
    var context = {
        cssMap: {},
        cssVars: {}
    };
    (0, $0e470ce15a1d8eb6$export$915658b6215945a4)(target, (value, path)=>{
        var _tokenHandlerMap$firs;
        // firstKey will be e.g. "space"
        var [firstKey] = path;
        var handler = (_tokenHandlerMap$firs = $eb79211f5309f78b$var$tokenHandlerMap[firstKey]) != null ? _tokenHandlerMap$firs : $eb79211f5309f78b$var$tokenHandlerMap.defaultHandler;
        var { cssVars: cssVars, cssMap: cssMap } = handler(path, value, options);
        Object.assign(context.cssVars, cssVars);
        Object.assign(context.cssMap, cssMap);
    });
    return context;
}
/**
 * Define transformation handlers for ThemeScale
 */ var $eb79211f5309f78b$var$tokenHandlerMap = {
    space: (keys, value, options)=>{
        var properties = $eb79211f5309f78b$var$tokenHandlerMap.defaultHandler(keys, value, options);
        var [firstKey, ...referenceKeys] = keys;
        var negativeLookupKey = firstKey + ".-" + referenceKeys.join(".");
        var negativeVarKey = keys.join("-");
        var { variable: variable, reference: reference } = (0, $0fd9776e552a94bb$export$8b4981022bd80a4e)(negativeVarKey, undefined, options.cssVarPrefix);
        var negativeValue = (0, $9face71b9ee62195$export$42bfa9b2d4dad91a).negate(value);
        var varRef = (0, $9face71b9ee62195$export$42bfa9b2d4dad91a).negate(reference);
        return {
            cssVars: properties.cssVars,
            cssMap: $eb79211f5309f78b$var$_extends({}, properties.cssMap, {
                [negativeLookupKey]: {
                    value: "" + negativeValue,
                    var: "" + variable,
                    varRef: varRef
                }
            })
        };
    },
    defaultHandler: (keys, value, options)=>{
        var lookupKey = keys.join(".");
        var varKey = keys.join("-");
        var { variable: variable, reference: reference } = (0, $0fd9776e552a94bb$export$8b4981022bd80a4e)(varKey, undefined, options.cssVarPrefix);
        return {
            cssVars: {
                [variable]: value
            },
            cssMap: {
                [lookupKey]: {
                    value: value,
                    var: variable,
                    varRef: reference
                }
            }
        };
    }
};



function $dfdd2d6837072c6a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $dfdd2d6837072c6a$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur"
];
function $dfdd2d6837072c6a$export$10e0af2de97b9ee7(theme) {
    var _tokens = $dfdd2d6837072c6a$var$tokens;
    return (0, $dfe73229adf076fd$export$357523c63a2253b9)(theme, _tokens);
}
function $dfdd2d6837072c6a$export$290969626bfda4a4(rawTheme) {
    var cleanTheme = $dfdd2d6837072c6a$var$_objectWithoutPropertiesLoose(rawTheme, [
        "__cssMap",
        "__cssVars",
        "__breakpoints"
    ]);
    return cleanTheme;
}


function $6be3b2071575aaa5$var$_extends() {
    $6be3b2071575aaa5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6be3b2071575aaa5$var$_extends.apply(this, arguments);
}
function $6be3b2071575aaa5$export$d4e5dc2a444c0164(rawTheme) {
    var _theme$config;
    /**
   * In the case the theme has already been converted to css-var (e.g extending the theme),
   * we can omit the computed css vars and recompute it for the extended theme.
   */ var theme = (0, $dfdd2d6837072c6a$export$290969626bfda4a4)(rawTheme); // omit components and breakpoints from css variable map
    var tokens = (0, $dfdd2d6837072c6a$export$10e0af2de97b9ee7)(theme);
    var cssVarPrefix = (_theme$config = theme.config) == null ? void 0 : _theme$config.cssVarPrefix;
    var { cssMap: /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */ cssMap, cssVars: /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */ cssVars } = (0, $eb79211f5309f78b$export$69e96ceeb663bb9)(tokens, {
        cssVarPrefix: cssVarPrefix
    });
    var defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: $6be3b2071575aaa5$var$_extends({}, defaultCssVars, cssVars),
        __cssMap: cssMap,
        __breakpoints: (0, $b0d64feb46216e43$export$9aa97eb2b674b920)(theme.breakpoints)
    });
    return theme;
}





$parcel$exportWildcard($954a09018ee9d0a8$exports, $971bf6a595ce5438$exports);
$parcel$exportWildcard($954a09018ee9d0a8$exports, $88298f37f45d59d6$exports);



var $denZA = parcelRequire("denZA");









var $803605a2d06b7a22$var$pkg = {
    name: "@emotion/react",
    version: "11.4.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/cache": "^11.4.0",
        "@emotion/serialize": "^1.0.2",
        "@emotion/sheet": "^1.0.2",
        "@emotion/utils": "^1.0.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.1.3",
        "@emotion/css-prettifier": "1.0.0",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.3.0",
        "@types/react": "^16.9.11",
        dtslint: "^0.3.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
        ],
        umdName: "emotionReact"
    }
};
var $803605a2d06b7a22$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $b586a210f9df88c2$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $denZA.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $b586a210f9df88c2$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $b586a210f9df88c2$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $denZA.createElement).apply(null, createElementArgArray);
};
var $803605a2d06b7a22$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $803605a2d06b7a22$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $b586a210f9df88c2$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $d1c95c767e684975$export$6321afa313b251b5)([
        styles
    ], undefined, (0, $denZA.useContext)((0, $b586a210f9df88c2$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $denZA.useRef)();
    (0, $denZA.useLayoutEffect)(function() {
        var key = cache.key + "-global";
        var sheet = new (0, $f4b08d136a5afca6$export$9d753cd7ae895cce)({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $denZA.useLayoutEffect)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1278f2480a4a1734$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $803605a2d06b7a22$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $d1c95c767e684975$export$6321afa313b251b5)(args);
}
var $803605a2d06b7a22$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $803605a2d06b7a22$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $803605a2d06b7a22$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $803605a2d06b7a22$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1278f2480a4a1734$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $803605a2d06b7a22$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $b586a210f9df88c2$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $d1c95c767e684975$export$6321afa313b251b5)(args, cache.registered);
        (0, $1278f2480a4a1734$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $803605a2d06b7a22$var$merge(cache.registered, css, $803605a2d06b7a22$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $denZA.useContext)((0, $b586a210f9df88c2$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return ele;
});
var $803605a2d06b7a22$var$isBrowser, $803605a2d06b7a22$var$isJest, $803605a2d06b7a22$var$globalContext, $803605a2d06b7a22$var$globalKey;




var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");
var $a1c31816786fd039$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a1c31816786fd039$var$hasElementType = typeof Element !== 'undefined';
var $a1c31816786fd039$var$hasMap = typeof Map === 'function';
var $a1c31816786fd039$var$hasSet = typeof Set === 'function';
var $a1c31816786fd039$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a1c31816786fd039$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a1c31816786fd039$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a1c31816786fd039$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a1c31816786fd039$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a1c31816786fd039$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a1c31816786fd039$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a1c31816786fd039$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a1c31816786fd039$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$a1c31816786fd039$exports = function isEqual(a, b) {
    try {
        return $a1c31816786fd039$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};






var $denZA = parcelRequire("denZA");
function $030819e6d0340981$export$fd42f52fd3ae1109(options) {
    if (options === void 0) options = {};
    var { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    var Context = /*#__PURE__*/ $denZA.createContext(undefined);
    Context.displayName = name;
    function useContext() {
        var context = $denZA.useContext(Context);
        if (!context && strict) {
            var error = new Error(errorMessage);
            error.name = "ContextError";
            Error.captureStackTrace == null || Error.captureStackTrace(error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}




var $denZA = parcelRequire("denZA");
var $77f2276a0a421ee3$export$d8964aec282183a3 = (props)=>{
    var { cssVarsRoot: cssVarsRoot = ":host, :root", theme: theme, children: children } = props;
    var computedTheme = $denZA.useMemo(()=>(0, $6be3b2071575aaa5$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $b586a210f9df88c2$export$407448d2b89b1813), {
        theme: computedTheme
    }, /*#__PURE__*/ $denZA.createElement((0, $803605a2d06b7a22$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [cssVarsRoot]: theme.__cssVars
            })
    }), children);
};
function $77f2276a0a421ee3$export$93d4e7f90805808f() {
    var theme = $denZA.useContext((0, $b586a210f9df88c2$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}
var [$77f2276a0a421ee3$export$dc4c659861f00dbe, $77f2276a0a421ee3$export$28e6b9b82ee883c] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
var $77f2276a0a421ee3$export$f05794e648629f6c = ()=>{
    var { colorMode: colorMode } = (0, $cb7c335cf150f8d2$export$20f3076712c8dfa)();
    return /*#__PURE__*/ $denZA.createElement((0, $803605a2d06b7a22$export$98f03c5d19621d70), {
        styles: (theme)=>{
            var styleObjectOrFn = (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, "styles.global");
            var globalStyles = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return undefined;
            var styles = (0, $0a79821e0a6de3e8$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
};



var $7581331fc4faccf3$export$b4133d44fe7b7e93 = [
    "a",
    "b",
    "article",
    "aside",
    "blockquote",
    "button",
    "caption",
    "cite",
    "circle",
    "code",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hr",
    "img",
    "input",
    "kbd",
    "label",
    "li",
    "main",
    "mark",
    "nav",
    "ol",
    "p",
    "path",
    "pre",
    "q",
    "rect",
    "s",
    "svg",
    "section",
    "select",
    "strong",
    "small",
    "span",
    "sub",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "ul"
];
function $7581331fc4faccf3$export$adfcf5a5e4d17785(props) {
    return (0, $dfe73229adf076fd$export$30a06c8d3562193f)(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}
function $7581331fc4faccf3$export$2e2bcd8739ae039(target) {
    return (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(target) && ((0, $6b74ef5ae6a56e47$export$a866f231438cc228) ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}
function $7581331fc4faccf3$export$be63e0664592e141(primitive) {
    return $7581331fc4faccf3$export$2e2bcd8739ae039(primitive) ? "chakra." + primitive : $7581331fc4faccf3$var$getComponentName(primitive);
}
function $7581331fc4faccf3$var$getComponentName(primitive) {
    return ((0, $6b74ef5ae6a56e47$export$a866f231438cc228) ? (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(primitive) && primitive : false) || !(0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(primitive) && primitive.displayName || !(0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(primitive) && primitive.name || "ChakraComponent";
}


function $de2d1b30ad83f058$var$_extends() {
    $de2d1b30ad83f058$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de2d1b30ad83f058$var$_extends.apply(this, arguments);
}
function $de2d1b30ad83f058$export$a513a93efd9ab8a7() {
    var colorModeResult = (0, $cb7c335cf150f8d2$export$20f3076712c8dfa)();
    var theme = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    return $de2d1b30ad83f058$var$_extends({}, colorModeResult, {
        theme: theme
    });
}
function $de2d1b30ad83f058$export$31dcd79391e423fe(scale, token, fallback) {
    var theme = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    if (Array.isArray(token)) {
        var fallbackArr = [];
        if (fallback) fallbackArr = Array.isArray(fallback) ? fallback : [
            fallback
        ];
        return token.map((token, index)=>{
            var _fallbackArr$index;
            var path = scale + "." + token;
            return (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, path, (_fallbackArr$index = fallbackArr[index]) != null ? _fallbackArr$index : token);
        });
    }
    var path = scale + "." + token;
    return (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, path, fallback != null ? fallback : token);
}
function $de2d1b30ad83f058$export$1f264be2c424fccf(themeKey, props) {
    var _theme$components, _styleConfig$defaultP;
    var { theme: theme, colorMode: colorMode } = $de2d1b30ad83f058$export$a513a93efd9ab8a7();
    var styleConfig = props.styleConfig || ((_theme$components = theme.components) == null ? void 0 : _theme$components[themeKey]);
    var defaultProps = (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {};
    var propsWithDefault = $de2d1b30ad83f058$var$_extends({}, defaultProps, (0, $dfe73229adf076fd$export$2458ce75c8ef9806)(props));
    var stylesRef = (0, $denZA.useRef)({});
    var mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, propsWithDefault, {
        theme: theme,
        colorMode: colorMode
    });
    var memoizedStyles = (0, $denZA.useMemo)(()=>{
        if (styleConfig) {
            var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes, _styleConfig$sizes2;
            var baseStyles = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
            var variants = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
            var sizes = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$sizes = (_styleConfig$sizes2 = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes2[mergedProps.size]) != null ? _styleConfig$sizes : {}, mergedProps);
            var styles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(baseStyles, sizes, variants);
            if (styleConfig.parts) styleConfig.parts.forEach((part)=>{
                var _styles$part;
                styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
            });
            var isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a1c31816786fd039$exports)))(stylesRef.current, styles);
            if (!isStyleEqual) stylesRef.current = styles;
        }
        return stylesRef.current;
    }, [
        styleConfig,
        mergedProps
    ]);
    return {
        styles: memoizedStyles,
        props: (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(propsWithDefault)
    };
}








parcelRequire("denZA");

// eslint-disable-next-line no-undef
var $3f67a1d4eac8daae$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3f67a1d4eac8daae$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $511dd05da8fbca8a$export$2e2bcd8739ae039)(function(prop) {
    return $3f67a1d4eac8daae$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});




var $denZA = parcelRequire("denZA");


var $63b6f0700ece4ba6$var$isBrowser = typeof document !== 'undefined';
function $63b6f0700ece4ba6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $63b6f0700ece4ba6$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $63b6f0700ece4ba6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $63b6f0700ece4ba6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $63b6f0700ece4ba6$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$63b6f0700ece4ba6$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$63b6f0700ece4ba6$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0abbbc61156565b1$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $b09548d846f27629$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $01b18cf43ed16766$var$isDevelopment = false;
var $01b18cf43ed16766$var$hyphenateRegex = /[A-Z]|^ms/g;
var $01b18cf43ed16766$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $01b18cf43ed16766$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $01b18cf43ed16766$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $01b18cf43ed16766$var$processStyleName = /* #__PURE__ */ (0, $511dd05da8fbca8a$export$2e2bcd8739ae039)(function(styleName) {
    return $01b18cf43ed16766$var$isCustomProperty(styleName) ? styleName : styleName.replace($01b18cf43ed16766$var$hyphenateRegex, '-$&').toLowerCase();
});
var $01b18cf43ed16766$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($01b18cf43ed16766$var$animationRegex, function(match, p1, p2) {
                $01b18cf43ed16766$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $01b18cf43ed16766$var$cursor
                };
                return p1;
            });
    }
    if ((0, $b09548d846f27629$export$2e2bcd8739ae039)[key] !== 1 && !$01b18cf43ed16766$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $01b18cf43ed16766$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $01b18cf43ed16766$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $01b18cf43ed16766$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $01b18cf43ed16766$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $01b18cf43ed16766$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $01b18cf43ed16766$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $01b18cf43ed16766$var$cursor;
                var result = interpolation(mergedProps);
                $01b18cf43ed16766$var$cursor = previousCursor;
                return $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $01b18cf43ed16766$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($01b18cf43ed16766$var$isProcessableValue(asString)) string += $01b18cf43ed16766$var$processStyleName(key) + ":" + $01b18cf43ed16766$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $01b18cf43ed16766$var$isDevelopment) throw new Error($01b18cf43ed16766$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($01b18cf43ed16766$var$isProcessableValue(value[_i])) string += $01b18cf43ed16766$var$processStyleName(key) + ":" + $01b18cf43ed16766$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $01b18cf43ed16766$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $01b18cf43ed16766$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $01b18cf43ed16766$var$cursor;
function $01b18cf43ed16766$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $01b18cf43ed16766$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $01b18cf43ed16766$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $01b18cf43ed16766$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $01b18cf43ed16766$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $0abbbc61156565b1$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $01b18cf43ed16766$var$cursor
    };
}


var $9bec512734f86f5b$var$testOmitPropsOnStringTag = (0, $3f67a1d4eac8daae$export$2e2bcd8739ae039);
var $9bec512734f86f5b$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9bec512734f86f5b$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9bec512734f86f5b$var$testOmitPropsOnStringTag : $9bec512734f86f5b$var$testOmitPropsOnComponent;
};
var $9bec512734f86f5b$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9bec512734f86f5b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $9bec512734f86f5b$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9bec512734f86f5b$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9bec512734f86f5b$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $b586a210f9df88c2$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var finalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $denZA.useContext)((0, $b586a210f9df88c2$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $63b6f0700ece4ba6$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $01b18cf43ed16766$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            var rules = (0, $63b6f0700ece4ba6$export$6f077d94b33a01aa)(cache, serialized, typeof finalTag === 'string');
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9bec512734f86f5b$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            var ele = /*#__PURE__*/ (0, $denZA.createElement)(finalTag, newProps);
            return ele;
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $9bec512734f86f5b$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $9bec512734f86f5b$export$2e2bcd8739ae039 = $9bec512734f86f5b$var$createStyled;





var $c2147514e287c11e$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $c2147514e287c11e$var$newStyled = (0, $9bec512734f86f5b$export$2e2bcd8739ae039).bind();
$c2147514e287c11e$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $c2147514e287c11e$var$newStyled[tagName] = $c2147514e287c11e$var$newStyled(tagName);
});
var $c2147514e287c11e$export$2e2bcd8739ae039 = $c2147514e287c11e$var$newStyled;



/**
 * List of props for emotion to omit from DOM.
 * It mostly consists of Chakra props
 */ var $a6ed185b86388571$var$allPropNames = new Set([
    ...(0, $796ce8a66d67a463$export$332cc7004bcbb8b4),
    "textStyle",
    "layerStyle",
    "apply",
    "isTruncated",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
/**
 * htmlWidth and htmlHeight is used in the <Image />
 * component to support the native `width` and `height` attributes
 *
 * https://github.com/chakra-ui/chakra-ui/issues/149
 */ var $a6ed185b86388571$var$validHTMLProps = new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize"
]);
var $a6ed185b86388571$export$3ba67b570e26eea0 = (prop)=>$a6ed185b86388571$var$validHTMLProps.has(prop) || !$a6ed185b86388571$var$allPropNames.has(prop);



function $fa3b5b33d58c73c3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fa3b5b33d58c73c3$export$9dba07f3d84163bb = (_ref)=>{
    var { baseStyle: baseStyle } = _ref;
    return (props)=>{
        var { css: cssProp, __css: __css, sx: sx } = props, rest = $fa3b5b33d58c73c3$var$_objectWithoutPropertiesLoose(props, [
            "theme",
            "css",
            "__css",
            "sx"
        ]);
        var styleProps = (0, $dfe73229adf076fd$export$3417cf6417437960)(rest, (_, prop)=>(0, $796ce8a66d67a463$export$95b76554d0cd12d6)(prop));
        var finalBaseStyle = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(baseStyle, props);
        var finalStyles = Object.assign({}, __css, finalBaseStyle, (0, $dfe73229adf076fd$export$2458ce75c8ef9806)(styleProps), sx);
        var computedCSS = (0, $0a79821e0a6de3e8$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
};
function $fa3b5b33d58c73c3$export$3817b7a54a07cec7(component, options) {
    var _ref2 = options != null ? options : {}, { baseStyle: baseStyle } = _ref2, styledOptions = $fa3b5b33d58c73c3$var$_objectWithoutPropertiesLoose(_ref2, [
        "baseStyle"
    ]);
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $a6ed185b86388571$export$3ba67b570e26eea0);
    var styleObject = $fa3b5b33d58c73c3$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    return (0, $c2147514e287c11e$export$2e2bcd8739ae039)(component, styledOptions)(styleObject);
}
var $fa3b5b33d58c73c3$export$7cd122d781af9fa4 = $fa3b5b33d58c73c3$export$3817b7a54a07cec7;
(0, $7581331fc4faccf3$export$b4133d44fe7b7e93).forEach((tag)=>{
    $fa3b5b33d58c73c3$export$7cd122d781af9fa4[tag] = $fa3b5b33d58c73c3$export$7cd122d781af9fa4(tag);
});


/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */ 
var $denZA = parcelRequire("denZA");
function $f3563a42e5e5d5b1$export$257a8862b851cb5b(component) {
    return /*#__PURE__*/ $denZA.forwardRef(component);
}



var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");


function $fb07eb4efac940d0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fb07eb4efac940d0$export$b863f77547fbcb03(themeKey, props, opts) {
    var _styleConfig$defaultP;
    if (props === void 0) props = {};
    if (opts === void 0) opts = {};
    var { styleConfig: styleConfigProp } = props, rest = $fb07eb4efac940d0$var$_objectWithoutPropertiesLoose(props, [
        "styleConfig"
    ]);
    var { theme: theme, colorMode: colorMode } = (0, $de2d1b30ad83f058$export$a513a93efd9ab8a7)();
    var themeStyleConfig = (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, "components." + themeKey);
    var styleConfig = styleConfigProp || themeStyleConfig;
    var mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({
        theme: theme,
        colorMode: colorMode
    }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, (0, $dfe73229adf076fd$export$2458ce75c8ef9806)((0, $dfe73229adf076fd$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */ var stylesRef = (0, $denZA.useRef)({});
    if (styleConfig) {
        var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;
        var baseStyles = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
        var variants = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
        var sizes = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
        var styles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, baseStyles, sizes, variants);
        if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) styleConfig.parts.forEach((part)=>{
            var _styles$part;
            styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
        });
        var isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a1c31816786fd039$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $fb07eb4efac940d0$export$31cdfe60c085d76f(themeKey, props) {
    return $fb07eb4efac940d0$export$b863f77547fbcb03(themeKey, props, {
        isMultiPart: true
    });
}



$parcel$exportWildcard($41a2d7d9a477bc20$exports, $954a09018ee9d0a8$exports);




var $denZA = parcelRequire("denZA");
function $5a8ac46908ed925f$var$_extends() {
    $5a8ac46908ed925f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a8ac46908ed925f$var$_extends.apply(this, arguments);
}
function $5a8ac46908ed925f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5a8ac46908ed925f$var$fallbackIcon = {
    path: /*#__PURE__*/ $denZA.createElement("g", {
        stroke: "currentColor",
        strokeWidth: "1.5"
    }, /*#__PURE__*/ $denZA.createElement("path", {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
    }), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
    }), /*#__PURE__*/ $denZA.createElement("circle", {
        fill: "none",
        strokeMiterlimit: "10",
        cx: "12",
        cy: "12",
        r: "11.25"
    })),
    viewBox: "0 0 24 24"
};
var $5a8ac46908ed925f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css } = props, rest = $5a8ac46908ed925f$var$_objectWithoutPropertiesLoose(props, [
        "as",
        "viewBox",
        "color",
        "focusable",
        "children",
        "className",
        "__css"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-icon", className);
    var styles = $5a8ac46908ed925f$var$_extends({
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color
    }, __css);
    var shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    var _viewBox = viewBox != null ? viewBox : $5a8ac46908ed925f$var$fallbackIcon.viewBox;
    /**
   * If you're using an icon library like `react-icons`.
   * Note: anyone passing the `as` prop, should manage the `viewBox` from the external component
   */ if (element && typeof element !== "string") return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg, $5a8ac46908ed925f$var$_extends({
        as: element
    }, shared, rest));
    var _path = children != null ? children : $5a8ac46908ed925f$var$fallbackIcon.path;
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg, $5a8ac46908ed925f$var$_extends({
        verticalAlign: "middle",
        viewBox: _viewBox
    }, shared, rest), _path);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $5a8ac46908ed925f$export$f04a61298a47a40f.displayName = "Icon";
var $5a8ac46908ed925f$export$2e2bcd8739ae039 = $5a8ac46908ed925f$export$f04a61298a47a40f;




var $e5Q7j = parcelRequire("e5Q7j");


var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
function $297359e2972e0fce$export$f3a192d0cbd30b96(callback) {
    return (0, $denZA.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}


function $7220ea761a0d340e$export$91db9bc4f8ac944a() {
    var unloadingRef = (0, $denZA.useRef)(false);
    var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)((0, $denZA.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0, $297359e2972e0fce$export$f3a192d0cbd30b96)(function() {
        return unloadingRef.current = true;
    });
    return (0, $denZA.useCallback)(function() {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
}



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
/**
 * @public
 */ var $d69cc1886c6dd912$export$f224e4635b6f8ce2 = (0, $denZA.createContext)(null);



var $denZA = parcelRequire("denZA");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $c8ac78540807b621$export$fe4300aa8eebea86(init) {
    var ref = (0, $denZA.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


var $85ba540bf4ec8b68$var$presenceId = 0;
function $85ba540bf4ec8b68$var$getPresenceId() {
    var id = $85ba540bf4ec8b68$var$presenceId;
    $85ba540bf4ec8b68$var$presenceId++;
    return id;
}
var $85ba540bf4ec8b68$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $c8ac78540807b621$export$fe4300aa8eebea86)($85ba540bf4ec8b68$var$newChildrenMap);
    var id = (0, $c8ac78540807b621$export$fe4300aa8eebea86)($85ba540bf4ec8b68$var$getPresenceId);
    var context = (0, $denZA.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var allComplete = true;
                presenceChildren.forEach(function(isComplete) {
                    if (!isComplete) allComplete = false;
                });
                allComplete && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $denZA.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $denZA.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $denZA.createElement((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $85ba540bf4ec8b68$var$newChildrenMap() {
    return new Map();
}



var $denZA = parcelRequire("denZA");

var $fcdceafa6330cb62$export$f8caf8121275292d = 1 / 60 * 1000;
var $fcdceafa6330cb62$var$getCurrentTime = typeof performance !== "undefined" ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
var $fcdceafa6330cb62$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? function(callback) {
    return window.requestAnimationFrame(callback);
} : function(callback) {
    return setTimeout(function() {
        return callback($fcdceafa6330cb62$var$getCurrentTime());
    }, $fcdceafa6330cb62$export$f8caf8121275292d);
};


function $974629f7a454fc93$export$b995e5e85f5c8289(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function(callback, keepAlive, immediate) {
            if (keepAlive === void 0) keepAlive = false;
            if (immediate === void 0) immediate = false;
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function(callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function(frameData) {
            var _a;
            isProcessing = true;
            _a = [
                toRunNextFrame,
                toRun
            ], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(var i = 0; i < numToRun; i++){
                var callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
        }
    };
    return step;
}


var $74f0db85147db332$var$maxElapsed = 40;
var $74f0db85147db332$var$useDefaultElapsed = true;
var $74f0db85147db332$var$runNextFrame = false;
var $74f0db85147db332$var$isProcessing = false;
var $74f0db85147db332$var$frame = {
    delta: 0,
    timestamp: 0
};
var $74f0db85147db332$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
var $74f0db85147db332$var$steps = /*#__PURE__*/ $74f0db85147db332$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = (0, $974629f7a454fc93$export$b995e5e85f5c8289)(function() {
        return $74f0db85147db332$var$runNextFrame = true;
    });
    return acc;
}, {});
var $74f0db85147db332$var$sync = /*#__PURE__*/ $74f0db85147db332$var$stepsOrder.reduce(function(acc, key) {
    var step = $74f0db85147db332$var$steps[key];
    acc[key] = function(process, keepAlive, immediate) {
        if (keepAlive === void 0) keepAlive = false;
        if (immediate === void 0) immediate = false;
        if (!$74f0db85147db332$var$runNextFrame) $74f0db85147db332$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var $74f0db85147db332$export$d93e9c1fe0553512 = /*#__PURE__*/ $74f0db85147db332$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = $74f0db85147db332$var$steps[key].cancel;
    return acc;
}, {});
var $74f0db85147db332$export$cd75ccfd720a3cd4 = /*#__PURE__*/ $74f0db85147db332$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = function() {
        return $74f0db85147db332$var$steps[key].process($74f0db85147db332$var$frame);
    };
    return acc;
}, {});
var $74f0db85147db332$var$processStep = function(stepId) {
    return $74f0db85147db332$var$steps[stepId].process($74f0db85147db332$var$frame);
};
var $74f0db85147db332$var$processFrame = function(timestamp) {
    $74f0db85147db332$var$runNextFrame = false;
    $74f0db85147db332$var$frame.delta = $74f0db85147db332$var$useDefaultElapsed ? (0, $fcdceafa6330cb62$export$f8caf8121275292d) : Math.max(Math.min(timestamp - $74f0db85147db332$var$frame.timestamp, $74f0db85147db332$var$maxElapsed), 1);
    $74f0db85147db332$var$frame.timestamp = timestamp;
    $74f0db85147db332$var$isProcessing = true;
    $74f0db85147db332$var$stepsOrder.forEach($74f0db85147db332$var$processStep);
    $74f0db85147db332$var$isProcessing = false;
    if ($74f0db85147db332$var$runNextFrame) {
        $74f0db85147db332$var$useDefaultElapsed = false;
        (0, $fcdceafa6330cb62$export$4fdea63ab5513fd5)($74f0db85147db332$var$processFrame);
    }
};
var $74f0db85147db332$var$startLoop = function() {
    $74f0db85147db332$var$runNextFrame = true;
    $74f0db85147db332$var$useDefaultElapsed = true;
    if (!$74f0db85147db332$var$isProcessing) (0, $fcdceafa6330cb62$export$4fdea63ab5513fd5)($74f0db85147db332$var$processFrame);
};
var $74f0db85147db332$export$7244445918e670ed = function() {
    return $74f0db85147db332$var$frame;
};
var $74f0db85147db332$export$2e2bcd8739ae039 = $74f0db85147db332$var$sync;




function $6015cfe93c8d0678$export$8793edee2d425525(any) {
    return any;
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $1e15aa74128cf363$export$a6a6a93acd99480a(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $1e15aa74128cf363$export$7dccf987ed3cfb10(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $1e15aa74128cf363$export$e79a6921359ce186(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) transformPoint = (0, $6015cfe93c8d0678$export$8793edee2d425525);
    var topLeft = transformPoint({
        x: left,
        y: top
    });
    var bottomRight = transformPoint({
        x: right,
        y: bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}
/**
 * Create an empty axis box of zero size
 */ function $1e15aa74128cf363$export$392205f483678b20() {
    return {
        x: {
            min: 0,
            max: 1
        },
        y: {
            min: 0,
            max: 1
        }
    };
}
function $1e15aa74128cf363$export$cad7f7b798bfcc39(box) {
    return {
        x: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, box.x),
        y: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, box.y)
    };
}
/**
 * Create an empty box delta
 */ var $1e15aa74128cf363$var$zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
};
function $1e15aa74128cf363$export$eabbe41f409ce55b() {
    return {
        x: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $1e15aa74128cf363$var$zeroDelta),
        y: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $1e15aa74128cf363$var$zeroDelta)
    };
}


var $fff46e0a9cea3aa7$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};


function $c7939c84ff320929$var$isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function $c7939c84ff320929$export$e900175ee6159829(visualElement, ancestors) {
    if (ancestors === void 0) ancestors = [];
    var parent = visualElement.parent;
    if (parent) $c7939c84ff320929$export$e900175ee6159829(parent, ancestors);
    if ($c7939c84ff320929$var$isProjecting(visualElement)) ancestors.push(visualElement);
    return ancestors;
}
function $c7939c84ff320929$export$99d2ce63b1d58b9f(visualElement) {
    var children = [];
    var addChild = function(child) {
        if ($c7939c84ff320929$var$isProjecting(child)) children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort((0, $fff46e0a9cea3aa7$export$d689d9dec5ad338));
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */ function $c7939c84ff320929$export$ec1805441219fc83(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0, $1e15aa74128cf363$export$cad7f7b798bfcc39)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    (0, $74f0db85147db332$export$2e2bcd8739ae039).update(function() {
        return visualElement.rebaseProjectionTarget();
    });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */ function $c7939c84ff320929$export$4f13d577f7028d57(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */ visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}


var $6d61c3f1679e997a$var$unresolvedJobs = new Set();
function $6d61c3f1679e997a$var$pushJob(stack, job, pointer) {
    if (!stack[pointer]) stack[pointer] = [];
    stack[pointer].push(job);
}
function $6d61c3f1679e997a$export$7e76af4b25f08a69(callback) {
    $6d61c3f1679e997a$var$unresolvedJobs.add(callback);
    return function() {
        return $6d61c3f1679e997a$var$unresolvedJobs.delete(callback);
    };
}
function $6d61c3f1679e997a$export$6445c3d91f1ae606() {
    if (!$6d61c3f1679e997a$var$unresolvedJobs.size) return;
    var pointer = 0;
    var reads = [
        []
    ];
    var writes = [];
    var setRead = function(job) {
        return $6d61c3f1679e997a$var$pushJob(reads, job, pointer);
    };
    var setWrite = function(job) {
        $6d61c3f1679e997a$var$pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */ $6d61c3f1679e997a$var$unresolvedJobs.forEach(function(callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    $6d61c3f1679e997a$var$unresolvedJobs.clear();
    /**
     * Execute jobs
     */ var numStacks = writes.length;
    for(var i = 0; i <= numStacks; i++){
        reads[i] && reads[i].forEach($6d61c3f1679e997a$var$executeJob);
        writes[i] && writes[i].forEach($6d61c3f1679e997a$var$executeJob);
    }
}
var $6d61c3f1679e997a$var$executeJob = function(job) {
    return job();
};



/**
 * @public
 */ var $1979636016632b46$export$99c2b779aa4e8b8b;
(function(Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})($1979636016632b46$export$99c2b779aa4e8b8b || ($1979636016632b46$export$99c2b779aa4e8b8b = {}));
/**
 * @public
 */ var $1979636016632b46$export$560b21f26820dbed;
(function(VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})($1979636016632b46$export$560b21f26820dbed || ($1979636016632b46$export$560b21f26820dbed = {}));


/**
 * Default handlers for batching VisualElements
 */ var $be5d107b6aab6315$var$defaultHandler = {
    layoutReady: function(child) {
        return child.notifyLayoutReady();
    }
};
/**
 * Create a batcher to process VisualElements
 */ function $be5d107b6aab6315$export$29e5fe0a0fc8f32f() {
    var queue = new Set();
    return {
        add: function(child) {
            return queue.add(child);
        },
        flush: function(_a) {
            var _b = _a === void 0 ? $be5d107b6aab6315$var$defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0, $6d61c3f1679e997a$export$7e76af4b25f08a69)(function(read, write) {
                var order = Array.from(queue).sort((0, $fff46e0a9cea3aa7$export$d689d9dec5ad338));
                var ancestors = parent ? (0, $c7939c84ff320929$export$e900175ee6159829)(parent) : [];
                write(function() {
                    var allElements = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(ancestors)), (0, $96998cfc8b9d4854$export$8d051b38c9118094)(order));
                    allElements.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    order.forEach((0, $c7939c84ff320929$export$ec1805441219fc83));
                });
                write(function() {
                    ancestors.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    order.forEach(layoutReady);
                });
                read(function() {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */ order.forEach(function(child) {
                        if (child.isPresent) child.presence = (0, $1979636016632b46$export$99c2b779aa4e8b8b).Present;
                    });
                });
                write(function() {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */ (0, $74f0db85147db332$export$cd75ccfd720a3cd4).preRender();
                    (0, $74f0db85147db332$export$cd75ccfd720a3cd4).render();
                });
                read(function() {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */ (0, $74f0db85147db332$export$2e2bcd8739ae039).postRender(function() {
                        return order.forEach($be5d107b6aab6315$var$assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0, $6d61c3f1679e997a$export$6445c3d91f1ae606)();
        }
    };
}
function $be5d107b6aab6315$var$assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}


var $4accc4bb8978d8fb$export$a3d1a816cb91a642 = (0, $denZA.createContext)((0, $be5d107b6aab6315$export$29e5fe0a0fc8f32f)());
/**
 * @internal
 */ var $4accc4bb8978d8fb$export$88d0442641a5238c = (0, $denZA.createContext)((0, $be5d107b6aab6315$export$29e5fe0a0fc8f32f)());
function $4accc4bb8978d8fb$export$8475119b63356082(context) {
    return !!context.forceUpdate;
}


function $6865f9da11d2ff76$var$getChildKey(child) {
    return child.key || "";
}
function $6865f9da11d2ff76$var$updateChildLookup(children, allChildren) {
    var seenChildren = null;
    children.forEach(function(child) {
        var key = $6865f9da11d2ff76$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $6865f9da11d2ff76$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $denZA.Children).forEach(children, function(child) {
        if ((0, $denZA.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $6865f9da11d2ff76$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = (0, $7220ea761a0d340e$export$91db9bc4f8ac944a)();
    var layoutContext = (0, $denZA.useContext)((0, $4accc4bb8978d8fb$export$a3d1a816cb91a642));
    if ((0, $4accc4bb8978d8fb$export$8475119b63356082)(layoutContext)) forceRender = layoutContext.forceUpdate;
    var isInitialRender = (0, $denZA.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $6865f9da11d2ff76$var$onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $denZA.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $denZA.useRef)(new Map()).current;
    // A living record of all currently exiting components.
    var exiting = (0, $denZA.useRef)(new Set()).current;
    $6865f9da11d2ff76$var$updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return $denZA.createElement($denZA.Fragment, null, filteredChildren.map(function(child) {
            return $denZA.createElement((0, $85ba540bf4ec8b68$export$979daf65881a382a), {
                key: $6865f9da11d2ff76$var$getChildKey(child),
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout
            }, child);
        }));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($6865f9da11d2ff76$var$getChildKey);
    var targetKeys = filteredChildren.map($6865f9da11d2ff76$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
        else // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $denZA.createElement((0, $85ba540bf4ec8b68$export$979daf65881a382a), {
            key: $6865f9da11d2ff76$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $denZA.createElement((0, $85ba540bf4ec8b68$export$979daf65881a382a), {
            key: $6865f9da11d2ff76$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    presentChildren.current = childrenToRender;
    return $denZA.createElement($denZA.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $denZA.cloneElement)(child);
    }));
};



var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $55bf63153c212c34$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $55bf63153c212c34$export$65570e08d843624d = {
    measureLayout: $55bf63153c212c34$var$createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform"
    ]),
    animation: $55bf63153c212c34$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag"
    ]),
    exit: $55bf63153c212c34$var$createDefinition([
        "exit"
    ]),
    drag: $55bf63153c212c34$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $55bf63153c212c34$var$createDefinition([
        "whileFocus"
    ]),
    hover: $55bf63153c212c34$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $55bf63153c212c34$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $55bf63153c212c34$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    layoutAnimation: $55bf63153c212c34$var$createDefinition([
        "layout",
        "layoutId"
    ])
};
function $55bf63153c212c34$export$449561ec5703cdc8(features) {
    for(var key in features){
        var Component = features[key];
        if (Component !== null) $55bf63153c212c34$export$65570e08d843624d[key].Component = Component;
    }
}


var $5f54a675503b9e5d$export$491112666e282270 = function() {};
var $5f54a675503b9e5d$export$f5708dca728d7177 = function() {};



var $denZA = parcelRequire("denZA");
var $3cf7f9c1cbcafe74$export$40f10139ecf1f171 = (0, $denZA.createContext)({
    strict: false
});


var $45f4e8ea32aa4314$var$featureNames = Object.keys((0, $55bf63153c212c34$export$65570e08d843624d));
var $45f4e8ea32aa4314$var$numFeatures = $45f4e8ea32aa4314$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $45f4e8ea32aa4314$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $denZA.useContext)((0, $3cf7f9c1cbcafe74$export$40f10139ecf1f171));
    if (!visualElement) return null;
    for(var i = 0; i < $45f4e8ea32aa4314$var$numFeatures; i++){
        var name_1 = $45f4e8ea32aa4314$var$featureNames[i];
        var _a = (0, $55bf63153c212c34$export$65570e08d843624d)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($denZA.createElement(Component, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}



var $denZA = parcelRequire("denZA");
/**
 * @public
 */ var $7106ca00da13be0f$export$22a697fb29aac98d = (0, $denZA.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false
});



var $denZA = parcelRequire("denZA");
var $212fd79dbb8c2c78$export$2285bbca2c666415 = (0, $denZA.createContext)({});
function $212fd79dbb8c2c78$export$cd995842eb2ab956() {
    return (0, $denZA.useContext)($212fd79dbb8c2c78$export$2285bbca2c666415).visualElement;
}




var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $fa7d48d3f8d00960$export$2a8c16d82a0a0e26() {
    var context = (0, $denZA.useContext)((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = $fa7d48d3f8d00960$var$useUniqueId();
    (0, $denZA.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $fa7d48d3f8d00960$export$8249053f690ea39a() {
    return $fa7d48d3f8d00960$export$ee27c052bca048fb((0, $denZA.useContext)((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2)));
}
function $fa7d48d3f8d00960$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}
var $fa7d48d3f8d00960$var$counter = 0;
var $fa7d48d3f8d00960$var$incrementId = function() {
    return $fa7d48d3f8d00960$var$counter++;
};
var $fa7d48d3f8d00960$var$useUniqueId = function() {
    return (0, $c8ac78540807b621$export$fe4300aa8eebea86)($fa7d48d3f8d00960$var$incrementId);
};



var $denZA = parcelRequire("denZA");
/**
 * @internal
 */ var $f62ada1909872bcd$export$a3579ca508007a95 = (0, $denZA.createContext)(null);




var $denZA = parcelRequire("denZA");
var $b6a72c32084c5202$export$4e09c449d6c407f7 = typeof window !== "undefined";


var $50728eb3b8ed425d$export$700979bc83e7db82 = (0, $b6a72c32084c5202$export$4e09c449d6c407f7) ? (0, $denZA.useLayoutEffect) : (0, $denZA.useEffect);




function $aa512730784d950b$var$useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0, $denZA.useContext)((0, $f62ada1909872bcd$export$a3579ca508007a95));
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $aa512730784d950b$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var config = (0, $denZA.useContext)((0, $7106ca00da13be0f$export$22a697fb29aac98d));
    var lazyContext = (0, $denZA.useContext)((0, $3cf7f9c1cbcafe74$export$40f10139ecf1f171));
    var parent = (0, $212fd79dbb8c2c78$export$cd995842eb2ab956)();
    var presenceContext = (0, $denZA.useContext)((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2));
    var layoutId = $aa512730784d950b$var$useLayoutId(props);
    var visualElementRef = (0, $denZA.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, props), {
            layoutId: layoutId
        }),
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
    var visualElement = visualElementRef.current;
    (0, $50728eb3b8ed425d$export$700979bc83e7db82)(function() {
        if (!visualElement) return;
        visualElement.setProps((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, config), props), {
            layoutId: layoutId
        }));
        visualElement.isPresent = (0, $fa7d48d3f8d00960$export$ee27c052bca048fb)(presenceContext);
        visualElement.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */ visualElement.syncRender();
    });
    (0, $denZA.useEffect)(function() {
        var _a;
        if (!visualElement) return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $50728eb3b8ed425d$export$700979bc83e7db82)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}



var $denZA = parcelRequire("denZA");
function $c743c65af8b08295$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $d7ff84d028e2ae52$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $denZA.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $c743c65af8b08295$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $denZA = parcelRequire("denZA");

/**
 * Decides if the supplied variable is an array of variant labels
 */ function $b2123e5233c590bc$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $b2123e5233c590bc$export$720b90e312cea233(v) {
    return typeof v === "string" || $b2123e5233c590bc$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $b2123e5233c590bc$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $b2123e5233c590bc$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $b2123e5233c590bc$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function $b2123e5233c590bc$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $b2123e5233c590bc$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $b2123e5233c590bc$var$getCurrent(visualElement), $b2123e5233c590bc$var$getVelocity(visualElement));
}
function $b2123e5233c590bc$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $b2123e5233c590bc$export$720b90e312cea233(props.initial) || $b2123e5233c590bc$export$720b90e312cea233(props.animate) || $b2123e5233c590bc$export$720b90e312cea233(props.whileHover) || $b2123e5233c590bc$export$720b90e312cea233(props.whileDrag) || $b2123e5233c590bc$export$720b90e312cea233(props.whileTap) || $b2123e5233c590bc$export$720b90e312cea233(props.whileFocus) || $b2123e5233c590bc$export$720b90e312cea233(props.exit);
}
function $b2123e5233c590bc$export$c0eba02279c18fea(props) {
    return Boolean($b2123e5233c590bc$export$cf3a7bd331c35bf0(props) || props.variants);
}


function $b2f3e17c31d5bdb7$export$12fc32fc096a04a3(props, context) {
    if ((0, $b2123e5233c590bc$export$cf3a7bd331c35bf0)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $b2123e5233c590bc$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b2123e5233c590bc$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $a2ffa78815af949d$export$c5638d843b37a176(props, isStatic) {
    var _a = (0, $b2f3e17c31d5bdb7$export$12fc32fc096a04a3)(props, (0, $denZA.useContext)((0, $212fd79dbb8c2c78$export$2285bbca2c666415))), initial = _a.initial, animate = _a.animate;
    return (0, $denZA.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, /**
     * Only break memoisation in static mode
     */ isStatic ? [
        $a2ffa78815af949d$var$variantLabelsAsDependency(initial),
        $a2ffa78815af949d$var$variantLabelsAsDependency(animate)
    ] : []);
}
function $a2ffa78815af949d$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */ function $cc56b1e8556a5233$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $55bf63153c212c34$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var isStatic = (0, $denZA.useContext)((0, $7106ca00da13be0f$export$22a697fb29aac98d)).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */ var context = (0, $a2ffa78815af949d$export$c5638d843b37a176)(props, isStatic);
        /**
         *
         */ var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $b6a72c32084c5202$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $aa512730784d950b$export$dc0335d73ab0b115)(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */ features = (0, $45f4e8ea32aa4314$export$4a39035bacc4ed76)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $denZA.createElement($denZA.Fragment, null, $denZA.createElement((0, $212fd79dbb8c2c78$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, (0, $d7ff84d028e2ae52$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic)), features);
    }
    return (0, $denZA.forwardRef)(MotionComponent);
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $cdcb503cea3dca64$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $cc56b1e8556a5233$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}



/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $b10cb6e0dcd570b2$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];


function $b8e4e4448b37037b$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $b10cb6e0dcd570b2$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}




var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $e52a5b25e7005ee3$export$d57fad728466ad75 = {};
/**
 * @internal
 */ function $e52a5b25e7005ee3$export$2cba7fcde4b7b2d5(correctors) {
    for(var key in correctors)$e52a5b25e7005ee3$export$d57fad728466ad75[key] = correctors[key];
}


/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $bc91e92b6451f52c$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $bc91e92b6451f52c$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $bc91e92b6451f52c$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$bc91e92b6451f52c$var$order.forEach(function(operationKey) {
    return $bc91e92b6451f52c$export$67cd428da31419e1.forEach(function(axesKey) {
        return $bc91e92b6451f52c$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $bc91e92b6451f52c$export$61f68472e7973485(a, b) {
    return $bc91e92b6451f52c$export$7b42a0094fb00b6e.indexOf(a) - $bc91e92b6451f52c$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $bc91e92b6451f52c$var$transformPropSet = new Set($bc91e92b6451f52c$export$7b42a0094fb00b6e);
function $bc91e92b6451f52c$export$15240a8a4379d8de(key) {
    return $bc91e92b6451f52c$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $bc91e92b6451f52c$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $bc91e92b6451f52c$export$91fe49ee9d172523(key) {
    return $bc91e92b6451f52c$var$transformOriginProps.has(key);
}


function $2da952e8f2ad2cb0$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $bc91e92b6451f52c$export$15240a8a4379d8de)(key) || (0, $bc91e92b6451f52c$export$91fe49ee9d172523)(key) || (layout || layoutId !== undefined) && (!!(0, $e52a5b25e7005ee3$export$d57fad728466ad75)[key] || key === "opacity");
}


var $7358f47b8e0272c8$export$605d60a2578142d3 = function(value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};




var $a5c677edbc350c85$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $a5c677edbc350c85$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $bc91e92b6451f52c$export$61f68472e7973485));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += ($a5c677edbc350c85$var$translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $a5c677edbc350c85$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $baaa023ea5470eff$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $5867fa4b52a23e21$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};



var $58ed3844003d7457$export$7d15b64cf5a3a4c4 = function(min, max) {
    return function(v) {
        return Math.max(Math.min(v, max), min);
    };
};
var $58ed3844003d7457$export$83d2e9e3e4ee39ed = function(v) {
    return v % 1 ? Number(v.toFixed(5)) : v;
};
var $58ed3844003d7457$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
var $58ed3844003d7457$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var $58ed3844003d7457$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $58ed3844003d7457$export$844ec244b1367d54(v) {
    return typeof v === 'string';
}


var $f611823ce945608e$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === 'number';
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $f611823ce945608e$export$58f0f39f63f3cf42 = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $f611823ce945608e$export$98e628dec113755e), {
    transform: (0, $58ed3844003d7457$export$7d15b64cf5a3a4c4)(0, 1)
});
var $f611823ce945608e$export$dcdf75081b88279d = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $f611823ce945608e$export$98e628dec113755e), {
    default: 1
});



var $d4e2413af6dede3d$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return (0, $58ed3844003d7457$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(' ').length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "" + v + unit;
        }
    };
};
var $d4e2413af6dede3d$export$41fc368e1a942b97 = $d4e2413af6dede3d$var$createUnitType('deg');
var $d4e2413af6dede3d$export$626336c2cd4b14de = $d4e2413af6dede3d$var$createUnitType('%');
var $d4e2413af6dede3d$export$91c0eda1d06bf008 = $d4e2413af6dede3d$var$createUnitType('px');
var $d4e2413af6dede3d$export$f91e8c45a95a32f2 = $d4e2413af6dede3d$var$createUnitType('vh');
var $d4e2413af6dede3d$export$aed3d7b7d206c196 = $d4e2413af6dede3d$var$createUnitType('vw');
var $d4e2413af6dede3d$export$44e2e1705876d7ed = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $d4e2413af6dede3d$export$626336c2cd4b14de), {
    parse: function(v) {
        return $d4e2413af6dede3d$export$626336c2cd4b14de.parse(v) / 100;
    },
    transform: function(v) {
        return $d4e2413af6dede3d$export$626336c2cd4b14de.transform(v * 100);
    }
});




var $3abd23252f93b043$export$7d260a2a5f8bc19e = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $f611823ce945608e$export$98e628dec113755e)), {
    transform: Math.round
});


var $a0a36ef2df6e4e06$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderTopWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderRightWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderRadius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    radius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    maxWidth: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    height: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    maxHeight: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    size: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    top: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    right: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    bottom: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    left: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    paddingTop: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    paddingRight: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    paddingBottom: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    paddingLeft: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    margin: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    marginTop: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    marginRight: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    marginBottom: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    marginLeft: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    rotateX: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    rotateY: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    rotateZ: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    scale: (0, $f611823ce945608e$export$dcdf75081b88279d),
    scaleX: (0, $f611823ce945608e$export$dcdf75081b88279d),
    scaleY: (0, $f611823ce945608e$export$dcdf75081b88279d),
    scaleZ: (0, $f611823ce945608e$export$dcdf75081b88279d),
    skew: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    skewX: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    skewY: (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    distance: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    translateX: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    translateY: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    translateZ: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    x: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    y: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    z: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    perspective: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    transformPerspective: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    opacity: (0, $f611823ce945608e$export$58f0f39f63f3cf42),
    originX: (0, $d4e2413af6dede3d$export$44e2e1705876d7ed),
    originY: (0, $d4e2413af6dede3d$export$44e2e1705876d7ed),
    originZ: (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $3abd23252f93b043$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $f611823ce945608e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $f611823ce945608e$export$58f0f39f63f3cf42),
    numOctaves: (0, $3abd23252f93b043$export$7d260a2a5f8bc19e)
};


function $80ed0788f6376c99$export$bb517f8b40f8e99d(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $baaa023ea5470eff$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $a0a36ef2df6e4e06$export$eec14432cd1cb67b)[key];
        var valueAsType = (0, $5867fa4b52a23e21$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $bc91e92b6451f52c$export$15240a8a4379d8de)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $bc91e92b6451f52c$export$91fe49ee9d172523)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */ if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) && (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) && (0, $e52a5b25e7005ee3$export$d57fad728466ad75)[key]) {
            var correctedValue = (0, $e52a5b25e7005ee3$export$d57fad728466ad75)[key].process(value, layoutState, projection);
            /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */ var applyTo = (0, $e52a5b25e7005ee3$export$d57fad728466ad75)[key].applyTo;
            if (applyTo) {
                var num = applyTo.length;
                for(var i = 0; i < num; i++)style[applyTo[i]] = correctedValue;
            } else style[key] = correctedValue;
        } else style[key] = valueAsType;
    }
    if (layoutState && projection && buildProjectionTransform && buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) style.transform = transformTemplate(transform, style.transform);
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    } else {
        if (hasTransform) style.transform = (0, $a5c677edbc350c85$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
        if (hasTransformOrigin) style.transformOrigin = (0, $a5c677edbc350c85$export$22d2fbf39767d07a)(transformOrigin);
    }
}


var $506500fc944b7b20$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};


function $2d359582c7155b50$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $7358f47b8e0272c8$export$605d60a2578142d3)(source[key]) && !(0, $2da952e8f2ad2cb0$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $2d359582c7155b50$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $denZA.useMemo)(function() {
        var state = (0, $506500fc944b7b20$export$8940b483cf52eeda)();
        (0, $80ed0788f6376c99$export$bb517f8b40f8e99d)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, vars), style);
    }, [
        visualState
    ]);
}
function $2d359582c7155b50$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $2d359582c7155b50$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $2d359582c7155b50$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $2d359582c7155b50$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $2d359582c7155b50$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $3356311a760c5126$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $3356311a760c5126$export$2f9c46555243bf04(key) {
    return $3356311a760c5126$var$validMotionProps.has(key);
}


var $cf1db2e9771744b4$var$shouldForward = function(key) {
    return !(0, $3356311a760c5126$export$2f9c46555243bf04)(key);
};

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    var $cf1db2e9771744b4$var$emotionIsPropValid_1 = (parcelRequire("fKF2T")).default;
    $cf1db2e9771744b4$var$shouldForward = function(key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) return !(0, $3356311a760c5126$export$2f9c46555243bf04)(key);
        else return $cf1db2e9771744b4$var$emotionIsPropValid_1(key);
    };
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $cf1db2e9771744b4$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($cf1db2e9771744b4$var$shouldForward(key) || forwardMotionProps === true && (0, $3356311a760c5126$export$2f9c46555243bf04)(key) || !isDom && !(0, $3356311a760c5126$export$2f9c46555243bf04)(key)) filteredProps[key] = props[key];
    return filteredProps;
}





var $denZA = parcelRequire("denZA");




function $52c0854f4d3368e4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $d4e2413af6dede3d$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $52c0854f4d3368e4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $52c0854f4d3368e4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $52c0854f4d3368e4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}



// Convert a progress 0-1 to a pixels value based on the provided length
var $8727300fc8a75852$var$progressToPixels = function(progress, length) {
    return (0, $d4e2413af6dede3d$export$91c0eda1d06bf008).transform(progress * length);
};
var $8727300fc8a75852$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $8727300fc8a75852$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $8727300fc8a75852$export$311b43f666da1d82(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $8727300fc8a75852$var$dashKeys : $8727300fc8a75852$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = $8727300fc8a75852$var$progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = $8727300fc8a75852$var$progressToPixels(length, totalLength);
    var pathSpacing = $8727300fc8a75852$var$progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $e62e83fc79d9051e$export$5475d24f125d7053(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $80ed0788f6376c99$export$bb517f8b40f8e99d)(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $52c0854f4d3368e4$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) (0, $8727300fc8a75852$export$311b43f666da1d82)(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
}




var $e271a3e6057f00e6$export$41be8b43e1c4d4f9 = function() {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $506500fc944b7b20$export$8940b483cf52eeda)()), {
        attrs: {}
    });
};


function $b13cb989b45e8d94$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $denZA.useMemo)(function() {
        var state = (0, $e271a3e6057f00e6$export$41be8b43e1c4d4f9)();
        (0, $e62e83fc79d9051e$export$5475d24f125d7053)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, state.attrs), {
            style: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $2d359582c7155b50$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}


function $ea5ab6238b914d04$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $b8e4e4448b37037b$export$88f3fc2fd3766989)(Component) ? (0, $b13cb989b45e8d94$export$84309c4f53cb1bd5) : (0, $2d359582c7155b50$export$57be0a314572d87d);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $cf1db2e9771744b4$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, filteredProps), visualProps), {
            ref: ref
        });
        return (0, $denZA.createElement)(Component, elementProps);
    };
    return useRender;
}


var $63a301c0f4eea2a8$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $63a301c0f4eea2a8$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $63a301c0f4eea2a8$export$9fd24a634729c672 = function(str) {
    return str.replace($63a301c0f4eea2a8$var$CAMEL_CASE_PATTERN, $63a301c0f4eea2a8$var$REPLACE_TEMPLATE).toLowerCase();
};


function $bb55b4b0603e9d04$export$1a32bf6229c258c0(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ var $f756084cb8de12a0$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform"
]);


function $09b50fcfd6e137c5$export$c5f8399d19a7394b(element, renderState) {
    (0, $bb55b4b0603e9d04$export$1a32bf6229c258c0)(element, renderState);
    for(var key in renderState.attrs)element.setAttribute(!(0, $f756084cb8de12a0$export$28931db5d57958e5).has(key) ? (0, $63a301c0f4eea2a8$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $4d0083cb4e71e15c$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $7358f47b8e0272c8$export$605d60a2578142d3)(style[key]) || (0, $2da952e8f2ad2cb0$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $83cec102475aad91$export$16da615486abaa45(props) {
    var newValues = (0, $4d0083cb4e71e15c$export$16da615486abaa45)(props);
    for(var key in props)if ((0, $7358f47b8e0272c8$export$605d60a2578142d3)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




var $denZA = parcelRequire("denZA");
function $e581871f7d7ebfdf$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}





var $04dc632a61d0368f$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};


var $1ade74f2cc3503c3$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $1ade74f2cc3503c3$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $04dc632a61d0368f$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */ function $2f07025c608900b9$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $7358f47b8e0272c8$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $1ade74f2cc3503c3$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}



function $3572a6b6f388b264$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $3572a6b6f388b264$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $3572a6b6f388b264$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $denZA.useContext)((0, $212fd79dbb8c2c78$export$2285bbca2c666415));
        var presenceContext = (0, $denZA.useContext)((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2));
        return isStatic ? $3572a6b6f388b264$var$makeState(config, props, context, presenceContext) : (0, $c8ac78540807b621$export$fe4300aa8eebea86)(function() {
            return $3572a6b6f388b264$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $3572a6b6f388b264$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $2f07025c608900b9$export$fcc2206ecb6d74b)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $b2123e5233c590bc$export$cf3a7bd331c35bf0)(props);
    var isVariantNode = (0, $b2123e5233c590bc$export$c0eba02279c18fea)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $e581871f7d7ebfdf$export$aa71198ceeaf53ce)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $b2123e5233c590bc$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target)values[key] = target[key];
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}




var $cc9f9f4b7d4525ec$export$44dabd3fae512e85 = {
    useVisualState: (0, $3572a6b6f388b264$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $83cec102475aad91$export$16da615486abaa45),
        createRenderState: (0, $e271a3e6057f00e6$export$41be8b43e1c4d4f9),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            if ($cc9f9f4b7d4525ec$var$isPath(instance)) renderState.totalPathLength = instance.getTotalLength();
            (0, $e62e83fc79d9051e$export$5475d24f125d7053)(renderState, latestValues, undefined, undefined, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            // TODO: Replace with direct assignment
            (0, $09b50fcfd6e137c5$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};
function $cc9f9f4b7d4525ec$var$isPath(element) {
    return element.tagName === "path";
}





var $a8b3ca83bbe643f0$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $3572a6b6f388b264$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4d0083cb4e71e15c$export$16da615486abaa45),
        createRenderState: (0, $506500fc944b7b20$export$8940b483cf52eeda)
    })
};


function $c621e42f39a17382$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $b8e4e4448b37037b$export$88f3fc2fd3766989)(Component) ? (0, $cc9f9f4b7d4525ec$export$44dabd3fae512e85) : (0, $a8b3ca83bbe643f0$export$e13ea21d87ea57c8);
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $ea5ab6238b914d04$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}


var $3829e4ee3bdfc35f$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})($3829e4ee3bdfc35f$export$2deb71ebd3734d23 || ($3829e4ee3bdfc35f$export$2deb71ebd3734d23 = {}));



var $denZA = parcelRequire("denZA");
function $bd7fae79e55f4f7e$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $bd7fae79e55f4f7e$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $denZA.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $bd7fae79e55f4f7e$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $0e746a4d2204a2fc$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $bd7fae79e55f4f7e$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $bd7fae79e55f4f7e$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}


function $d6d4d2c9c3e1a334$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $d6d4d2c9c3e1a334$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}





/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $a05aeb9c29066806$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $a05aeb9c29066806$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $a05aeb9c29066806$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $a05aeb9c29066806$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $a05aeb9c29066806$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $a05aeb9c29066806$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $d6d4d2c9c3e1a334$export$c4dfce035d43d1e0)(event) ? $a05aeb9c29066806$var$pointFromTouch(event, pointType) : $a05aeb9c29066806$var$pointFromMouse(event, pointType)
    };
}
function $a05aeb9c29066806$export$750e59ed656e0503(event) {
    return $a05aeb9c29066806$export$12f84bb882d06e1a(event, "client");
}
var $a05aeb9c29066806$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $a05aeb9c29066806$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $a05aeb9c29066806$var$filterPrimaryPointer(listener) : listener;
};



// We check for event support via functions in case they've been mocked by a testing suite.
var $956a6b764b96e72f$export$ed662207763ba653 = function() {
    return (0, $b6a72c32084c5202$export$4e09c449d6c407f7) && window.onpointerdown === null;
};
var $956a6b764b96e72f$export$58e9cbc5718eb8c2 = function() {
    return (0, $b6a72c32084c5202$export$4e09c449d6c407f7) && window.ontouchstart === null;
};
var $956a6b764b96e72f$export$1a3879af679d3ede = function() {
    return (0, $b6a72c32084c5202$export$4e09c449d6c407f7) && window.onmousedown === null;
};


var $36c4b7d5f680165c$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $36c4b7d5f680165c$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $36c4b7d5f680165c$var$getPointerEventName(name) {
    if ((0, $956a6b764b96e72f$export$ed662207763ba653)()) return name;
    else if ((0, $956a6b764b96e72f$export$58e9cbc5718eb8c2)()) return $36c4b7d5f680165c$var$touchEventNames[name];
    else if ((0, $956a6b764b96e72f$export$1a3879af679d3ede)()) return $36c4b7d5f680165c$var$mouseEventNames[name];
    return name;
}
function $36c4b7d5f680165c$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $bd7fae79e55f4f7e$export$b1d829ddf82884aa)(target, $36c4b7d5f680165c$var$getPointerEventName(eventName), (0, $a05aeb9c29066806$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}
function $36c4b7d5f680165c$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $bd7fae79e55f4f7e$export$c1052189363cb2e0)(ref, $36c4b7d5f680165c$var$getPointerEventName(eventName), handler && (0, $a05aeb9c29066806$export$f4437ba81469b709)(handler, eventName === "pointerdown"), options);
}


function $948207fd41cbebf1$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $948207fd41cbebf1$var$globalHorizontalLock = $948207fd41cbebf1$export$518c5fc2dcb7974b("dragHorizontal");
var $948207fd41cbebf1$var$globalVerticalLock = $948207fd41cbebf1$export$518c5fc2dcb7974b("dragVertical");
function $948207fd41cbebf1$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $948207fd41cbebf1$var$globalVerticalLock();
    else if (drag === "x") lock = $948207fd41cbebf1$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $948207fd41cbebf1$var$globalHorizontalLock();
        var openVertical_1 = $948207fd41cbebf1$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $948207fd41cbebf1$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $948207fd41cbebf1$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $cf980a17137dbdc1$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $d6d4d2c9c3e1a334$export$764db16956f554f8)(event) || (0, $948207fd41cbebf1$export$1b3dd616664938e4)()) return;
        callback === null || callback === void 0 || callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Hover, isActive);
    };
}
function $cf980a17137dbdc1$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $36c4b7d5f680165c$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $cf980a17137dbdc1$var$createHoverEvent(visualElement, true, onHoverStart) : undefined);
    (0, $36c4b7d5f680165c$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $cf980a17137dbdc1$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}



var $denZA = parcelRequire("denZA");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $8cbad3b28812e91c$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $8cbad3b28812e91c$export$e841ada32ff745b(parent, child.parentElement);
};




var $1febbb3d73d31607$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $1febbb3d73d31607$export$a4627e546088548d = function() {
    var transformers = [];
    for(var _i = 0; _i < arguments.length; _i++)transformers[_i] = arguments[_i];
    return transformers.reduce($1febbb3d73d31607$var$combineFunctions);
};




/**
 * @param handlers -
 * @internal
 */ function $ecfa33f1f5a98670$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $denZA.useRef)(false);
    var cancelPointerEndListeners = (0, $denZA.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Tap, false);
        return !(0, $948207fd41cbebf1$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $8cbad3b28812e91c$export$e841ada32ff745b)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $1febbb3d73d31607$export$a4627e546088548d)((0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp), (0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Tap, true);
    }
    (0, $36c4b7d5f680165c$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0, $297359e2972e0fce$export$f3a192d0cbd30b96)(removePointerEndListener);
}


var $54c635bc7cd40a8b$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};


var $6def5b5b2f5fc91d$export$e5b72898e5a201f1 = {
    tap: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)((0, $ecfa33f1f5a98670$export$16dee6ef8c34532)),
    focus: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)((0, $0e746a4d2204a2fc$export$cac52d7cca250a66)),
    hover: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)((0, $cf980a17137dbdc1$export$dea06860711b7ebc))
};




var $denZA = parcelRequire("denZA");






function $64a8ca18932fde24$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}







var $bc06f1106e0ccce0$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};


var $974d30d3e80b9d74$var$safeMin = 0.001;
var $974d30d3e80b9d74$export$a3cdb76e84ee608e = 0.01;
var $974d30d3e80b9d74$export$1824b851fad8862b = 10.0;
var $974d30d3e80b9d74$export$ff08f2d53484465 = 0.05;
var $974d30d3e80b9d74$export$201ca48e54038115 = 1;
function $974d30d3e80b9d74$export$b15f158dc6d6f458(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    (0, $5f54a675503b9e5d$export$491112666e282270)(duration <= $974d30d3e80b9d74$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = (0, $bc06f1106e0ccce0$export$7d15b64cf5a3a4c4)($974d30d3e80b9d74$export$ff08f2d53484465, $974d30d3e80b9d74$export$201ca48e54038115, dampingRatio);
    duration = (0, $bc06f1106e0ccce0$export$7d15b64cf5a3a4c4)($974d30d3e80b9d74$export$a3cdb76e84ee608e, $974d30d3e80b9d74$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $974d30d3e80b9d74$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $974d30d3e80b9d74$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $974d30d3e80b9d74$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $974d30d3e80b9d74$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$974d30d3e80b9d74$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $974d30d3e80b9d74$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $974d30d3e80b9d74$var$rootIterations = 12;
function $974d30d3e80b9d74$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $974d30d3e80b9d74$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $974d30d3e80b9d74$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


var $3969676e9391a89b$var$durationKeys = [
    "duration",
    "bounce"
];
var $3969676e9391a89b$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $3969676e9391a89b$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $3969676e9391a89b$var$getSpringOptions(options) {
    var springOptions = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$3969676e9391a89b$var$isSpringType(options, $3969676e9391a89b$var$physicsKeys) && $3969676e9391a89b$var$isSpringType(options, $3969676e9391a89b$var$durationKeys)) {
        var derived = (0, $974d30d3e80b9d74$export$b15f158dc6d6f458)(options);
        springOptions = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $3969676e9391a89b$export$b36281d89752ae66(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    var state = {
        done: false,
        value: from
    };
    var _e = $3969676e9391a89b$var$getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = $3969676e9391a89b$var$zero;
    var resolveVelocity = $3969676e9391a89b$var$zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            var angularFreq_1 = (0, $974d30d3e80b9d74$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t) + initialDelta * Math.cos(angularFreq_1 * t));
            };
            resolveVelocity = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t)) - envelope * (Math.cos(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t));
            };
        } else if (dampingRatio === 1) resolveSpring = function(t) {
            return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
            };
        }
    }
    createSpring();
    return {
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function() {
            var _a;
            velocity = -velocity;
            _a = [
                to,
                from
            ], from = _a[0], to = _a[1];
            createSpring();
        }
    };
}
$3969676e9391a89b$export$b36281d89752ae66.needsInterpolation = function(a, b) {
    return typeof a === "string" || typeof b === "string";
};
var $3969676e9391a89b$var$zero = function(_t) {
    return 0;
};


var $4b12c414d833e494$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


var $12faf2db10f0b925$export$2c9e8a9632a706b2 = function(from, to, progress) {
    return -progress * from + progress * to + from;
};








var $b928cd39c63020f8$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean((0, $58ed3844003d7457$export$844ec244b1367d54)(v) && (0, $58ed3844003d7457$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $b928cd39c63020f8$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        var _a;
        if (!(0, $58ed3844003d7457$export$844ec244b1367d54)(v)) return v;
        var _b = v.match((0, $58ed3844003d7457$export$2444ca58c08448e4)), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
        return _a = {}, _a[aName] = parseFloat(a), _a[bName] = parseFloat(b), _a[cName] = parseFloat(c), _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1, _a;
    };
};


var $0b6594840c115128$var$clampRgbUnit = (0, $58ed3844003d7457$export$7d15b64cf5a3a4c4)(0, 255);
var $0b6594840c115128$export$7a99c86b5b1f4c9e = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $f611823ce945608e$export$98e628dec113755e)), {
    transform: function(v) {
        return Math.round($0b6594840c115128$var$clampRgbUnit(v));
    }
});
var $0b6594840c115128$export$4e46ac54fc82cf3b = {
    test: (0, $b928cd39c63020f8$export$2c8400d58aca05e)('rgb', 'red'),
    parse: (0, $b928cd39c63020f8$export$73d6f35be992df24)('red', 'green', 'blue'),
    transform: function(_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'rgba(' + $0b6594840c115128$export$7a99c86b5b1f4c9e.transform(red) + ', ' + $0b6594840c115128$export$7a99c86b5b1f4c9e.transform(green) + ', ' + $0b6594840c115128$export$7a99c86b5b1f4c9e.transform(blue) + ', ' + (0, $58ed3844003d7457$export$83d2e9e3e4ee39ed)((0, $f611823ce945608e$export$58f0f39f63f3cf42).transform(alpha$1)) + ')';
    }
};



function $cdc05485d8924b11$var$parseHex(v) {
    var r = '';
    var g = '';
    var b = '';
    var a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $cdc05485d8924b11$export$834dfc94dde4b3d8 = {
    test: (0, $b928cd39c63020f8$export$2c8400d58aca05e)('#'),
    parse: $cdc05485d8924b11$var$parseHex,
    transform: (0, $0b6594840c115128$export$4e46ac54fc82cf3b).transform
};





var $0695d3c322bb9cd8$export$810b04175080204c = {
    test: (0, $b928cd39c63020f8$export$2c8400d58aca05e)('hsl', 'hue'),
    parse: (0, $b928cd39c63020f8$export$73d6f35be992df24)('hue', 'saturation', 'lightness'),
    transform: function(_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'hsla(' + Math.round(hue) + ', ' + (0, $d4e2413af6dede3d$export$626336c2cd4b14de).transform((0, $58ed3844003d7457$export$83d2e9e3e4ee39ed)(saturation)) + ', ' + (0, $d4e2413af6dede3d$export$626336c2cd4b14de).transform((0, $58ed3844003d7457$export$83d2e9e3e4ee39ed)(lightness)) + ', ' + (0, $58ed3844003d7457$export$83d2e9e3e4ee39ed)((0, $f611823ce945608e$export$58f0f39f63f3cf42).transform(alpha$1)) + ')';
    }
};



var $4f635f5fc7d99240$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var $4f635f5fc7d99240$var$colorTypes = [
    (0, $cdc05485d8924b11$export$834dfc94dde4b3d8),
    (0, $0b6594840c115128$export$4e46ac54fc82cf3b),
    (0, $0695d3c322bb9cd8$export$810b04175080204c)
];
var $4f635f5fc7d99240$var$getColorType = function(v) {
    return $4f635f5fc7d99240$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
var $4f635f5fc7d99240$var$notAnimatable = function(color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var $4f635f5fc7d99240$export$51e568cf5c039bac = function(from, to) {
    var fromColorType = $4f635f5fc7d99240$var$getColorType(from);
    var toColorType = $4f635f5fc7d99240$var$getColorType(to);
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(!!fromColorType, $4f635f5fc7d99240$var$notAnimatable(from));
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(!!toColorType, $4f635f5fc7d99240$var$notAnimatable(to));
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, fromColor);
    var mixFunc = fromColorType === (0, $0695d3c322bb9cd8$export$810b04175080204c) ? (0, $12faf2db10f0b925$export$2c9e8a9632a706b2) : $4f635f5fc7d99240$export$d4ecea248cce73c;
    return function(v) {
        for(var key in blended)if (key !== "alpha") blended[key] = mixFunc(fromColor[key], toColor[key], v);
        blended.alpha = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};







var $df0779e3f53f4b3c$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $0b6594840c115128$export$4e46ac54fc82cf3b).test(v) || (0, $cdc05485d8924b11$export$834dfc94dde4b3d8).test(v) || (0, $0695d3c322bb9cd8$export$810b04175080204c).test(v);
    },
    parse: function(v) {
        if ((0, $0b6594840c115128$export$4e46ac54fc82cf3b).test(v)) return (0, $0b6594840c115128$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0695d3c322bb9cd8$export$810b04175080204c).test(v)) return (0, $0695d3c322bb9cd8$export$810b04175080204c).parse(v);
        else return (0, $cdc05485d8924b11$export$834dfc94dde4b3d8).parse(v);
    },
    transform: function(v) {
        return (0, $58ed3844003d7457$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty('red') ? (0, $0b6594840c115128$export$4e46ac54fc82cf3b).transform(v) : (0, $0695d3c322bb9cd8$export$810b04175080204c).transform(v);
    }
};




var $57a52f1e861e60bd$var$colorToken = '${c}';
var $57a52f1e861e60bd$var$numberToken = '${n}';
function $57a52f1e861e60bd$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $58ed3844003d7457$export$844ec244b1367d54)(v) && ((_b = (_a = v.match((0, $58ed3844003d7457$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $58ed3844003d7457$export$740b69c5fad25dba))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $57a52f1e861e60bd$var$analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match((0, $58ed3844003d7457$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $58ed3844003d7457$export$740b69c5fad25dba), $57a52f1e861e60bd$var$colorToken);
        values.push.apply(values, colors.map((0, $df0779e3f53f4b3c$export$35e9368ef982300f).parse));
    }
    var numbers = v.match((0, $58ed3844003d7457$export$2444ca58c08448e4));
    if (numbers) {
        v = v.replace((0, $58ed3844003d7457$export$2444ca58c08448e4), $57a52f1e861e60bd$var$numberToken);
        values.push.apply(values, numbers.map((0, $f611823ce945608e$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $57a52f1e861e60bd$var$parse(v) {
    return $57a52f1e861e60bd$var$analyse(v).values;
}
function $57a52f1e861e60bd$var$createTransformer(v) {
    var _a = $57a52f1e861e60bd$var$analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function(v) {
        var output = tokenised;
        for(var i = 0; i < numValues; i++)output = output.replace(i < numColors ? $57a52f1e861e60bd$var$colorToken : $57a52f1e861e60bd$var$numberToken, i < numColors ? (0, $df0779e3f53f4b3c$export$35e9368ef982300f).transform(v[i]) : (0, $58ed3844003d7457$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
var $57a52f1e861e60bd$var$convertNumbersToZero = function(v) {
    return typeof v === 'number' ? 0 : v;
};
function $57a52f1e861e60bd$var$getAnimatableNone(v) {
    var parsed = $57a52f1e861e60bd$var$parse(v);
    var transformer = $57a52f1e861e60bd$var$createTransformer(v);
    return transformer(parsed.map($57a52f1e861e60bd$var$convertNumbersToZero));
}
var $57a52f1e861e60bd$export$83a0e34f1302825b = {
    test: $57a52f1e861e60bd$var$test,
    parse: $57a52f1e861e60bd$var$parse,
    createTransformer: $57a52f1e861e60bd$var$createTransformer,
    getAnimatableNone: $57a52f1e861e60bd$var$getAnimatableNone
};




var $a0225e157f270d45$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
var $a0225e157f270d45$export$4e960b977ccfec97 = function(v) {
    return typeof v === 'number';
};




function $91ade8d2289c2981$var$getMixer(origin, target) {
    if ((0, $a0225e157f270d45$export$4e960b977ccfec97)(origin)) return function(v) {
        return (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(origin, target, v);
    };
    else if ((0, $df0779e3f53f4b3c$export$35e9368ef982300f).test(origin)) return (0, $4f635f5fc7d99240$export$51e568cf5c039bac)(origin, target);
    else return $91ade8d2289c2981$export$65516310a87d8205(origin, target);
}
var $91ade8d2289c2981$export$3bbefa2f402845c4 = function(from, to) {
    var output = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], from);
    var numValues = output.length;
    var blendValue = from.map(function(fromThis, i) {
        return $91ade8d2289c2981$var$getMixer(fromThis, to[i]);
    });
    return function(v) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
var $91ade8d2289c2981$export$ebc23b6840c51ba1 = function(origin, target) {
    var output = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, origin), target);
    var blendValue = {};
    for(var key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $91ade8d2289c2981$var$getMixer(origin[key], target[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $91ade8d2289c2981$var$analyse(value) {
    var parsed = (0, $57a52f1e861e60bd$export$83a0e34f1302825b).parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for(var i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
var $91ade8d2289c2981$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $57a52f1e861e60bd$export$83a0e34f1302825b).createTransformer(target);
    var originStats = $91ade8d2289c2981$var$analyse(origin);
    var targetStats = $91ade8d2289c2981$var$analyse(target);
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return (0, $1febbb3d73d31607$export$a4627e546088548d)($91ade8d2289c2981$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
};






var $042559a8f710c070$var$mixNumber = function(from, to) {
    return function(p) {
        return (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(from, to, p);
    };
};
function $042559a8f710c070$var$detectMixerFactory(v) {
    if (typeof v === 'number') return $042559a8f710c070$var$mixNumber;
    else if (typeof v === 'string') {
        if ((0, $df0779e3f53f4b3c$export$35e9368ef982300f).test(v)) return 0, $4f635f5fc7d99240$export$51e568cf5c039bac;
        else return 0, $91ade8d2289c2981$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $91ade8d2289c2981$export$3bbefa2f402845c4;
    else if (typeof v === 'object') return 0, $91ade8d2289c2981$export$ebc23b6840c51ba1;
}
function $042559a8f710c070$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || $042559a8f710c070$var$detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $1febbb3d73d31607$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $042559a8f710c070$var$fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function(v) {
        return mixer((0, $4b12c414d833e494$export$504d7abb21fa8c9)(from, to, v));
    };
}
function $042559a8f710c070$var$slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function(v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        var progressInRange = (0, $4b12c414d833e494$export$504d7abb21fa8c9)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $042559a8f710c070$export$89e29e4ab65e70a9(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(inputLength === output.length, 'Both input and output ranges must be the same length');
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = $042559a8f710c070$var$createMixers(output, ease, mixer);
    var interpolator = inputLength === 2 ? $042559a8f710c070$var$fastInterpolate(input, mixers) : $042559a8f710c070$var$slowInterpolate(input, mixers);
    return isClamp ? function(v) {
        return interpolator((0, $bc06f1106e0ccce0$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v));
    } : interpolator;
}


var $9f21634cf8b43cce$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};
var $9f21634cf8b43cce$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var $9f21634cf8b43cce$export$c90c8c5a3c7a5e80 = function(power) {
    return function(p) {
        return Math.pow(p, power);
    };
};
var $9f21634cf8b43cce$export$2a739ba6da1d1495 = function(power) {
    return function(p) {
        return p * p * ((power + 1) * p - power);
    };
};
var $9f21634cf8b43cce$export$222fa0be41d8b537 = function(power) {
    var backEasing = $9f21634cf8b43cce$export$2a739ba6da1d1495(power);
    return function(p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};


var $06075b9de2c72539$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var $06075b9de2c72539$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var $06075b9de2c72539$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var $06075b9de2c72539$var$BOUNCE_THIRD_THRESHOLD = 0.9;
var $06075b9de2c72539$export$45db2fc2f15997e7 = function(p) {
    return p;
};
var $06075b9de2c72539$export$929e5a82286172a6 = (0, $9f21634cf8b43cce$export$c90c8c5a3c7a5e80)(2);
var $06075b9de2c72539$export$57636bb43b1ccbb0 = (0, $9f21634cf8b43cce$export$2c07eeff45156d4d)($06075b9de2c72539$export$929e5a82286172a6);
var $06075b9de2c72539$export$c07234257a03d5e9 = (0, $9f21634cf8b43cce$export$f946554fb8aeaf0d)($06075b9de2c72539$export$929e5a82286172a6);
var $06075b9de2c72539$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $06075b9de2c72539$export$c8d67a19199d1a50 = (0, $9f21634cf8b43cce$export$2c07eeff45156d4d)($06075b9de2c72539$export$e444123e42d03385);
var $06075b9de2c72539$export$30d3455eee55bed5 = (0, $9f21634cf8b43cce$export$f946554fb8aeaf0d)($06075b9de2c72539$export$c8d67a19199d1a50);
var $06075b9de2c72539$export$b01116c84cdfe1a2 = (0, $9f21634cf8b43cce$export$2a739ba6da1d1495)($06075b9de2c72539$var$DEFAULT_OVERSHOOT_STRENGTH);
var $06075b9de2c72539$export$77edfce482316a60 = (0, $9f21634cf8b43cce$export$2c07eeff45156d4d)($06075b9de2c72539$export$b01116c84cdfe1a2);
var $06075b9de2c72539$export$ddc5fd596f6c71b2 = (0, $9f21634cf8b43cce$export$f946554fb8aeaf0d)($06075b9de2c72539$export$b01116c84cdfe1a2);
var $06075b9de2c72539$export$6b0af63b873d419e = (0, $9f21634cf8b43cce$export$222fa0be41d8b537)($06075b9de2c72539$var$DEFAULT_OVERSHOOT_STRENGTH);
var $06075b9de2c72539$var$ca = 4356.0 / 361.0;
var $06075b9de2c72539$var$cb = 35442.0 / 1805.0;
var $06075b9de2c72539$var$cc = 16061.0 / 1805.0;
var $06075b9de2c72539$export$cccc9e04465dce11 = function(p) {
    if (p === 1 || p === 0) return p;
    var p2 = p * p;
    return p < $06075b9de2c72539$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $06075b9de2c72539$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $06075b9de2c72539$var$BOUNCE_THIRD_THRESHOLD ? $06075b9de2c72539$var$ca * p2 - $06075b9de2c72539$var$cb * p + $06075b9de2c72539$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var $06075b9de2c72539$export$fccebd7948554554 = (0, $9f21634cf8b43cce$export$2c07eeff45156d4d)($06075b9de2c72539$export$cccc9e04465dce11);
var $06075b9de2c72539$export$41ad9e9849a703ce = function(p) {
    return p < 0.5 ? 0.5 * (1.0 - $06075b9de2c72539$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $06075b9de2c72539$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;
};


function $e69b645c3d229ca4$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $06075b9de2c72539$export$c07234257a03d5e9);
    }).splice(0, values.length - 1);
}
function $e69b645c3d229ca4$export$24dbcec0b26e6d9d(values) {
    var numValues = values.length;
    return values.map(function(_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function $e69b645c3d229ca4$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}
function $e69b645c3d229ca4$export$d25ddfdf17c3ad3e(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = {
        done: false,
        value: from
    };
    var values = Array.isArray(to) ? to : [
        from,
        to
    ];
    var times = $e69b645c3d229ca4$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $e69b645c3d229ca4$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $042559a8f710c070$export$89e29e4ab65e70a9)(times, values, {
            ease: Array.isArray(ease) ? ease : $e69b645c3d229ca4$export$6b60b58e4ea7d715(values, ease)
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function(t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function() {
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}


function $7e79f2f32789879d$export$e9341ba102272ab9(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = {
        done: false,
        value: from
    };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: function(t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function() {}
    };
}


var $cd335636556b7c07$var$types = {
    keyframes: (0, $e69b645c3d229ca4$export$d25ddfdf17c3ad3e),
    spring: (0, $3969676e9391a89b$export$b36281d89752ae66),
    decay: (0, $7e79f2f32789879d$export$e9341ba102272ab9)
};
function $cd335636556b7c07$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $e69b645c3d229ca4$export$d25ddfdf17c3ad3e;
    else if ($cd335636556b7c07$var$types[config.type]) return $cd335636556b7c07$var$types[config.type];
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $e69b645c3d229ca4$export$d25ddfdf17c3ad3e;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $3969676e9391a89b$export$b36281d89752ae66;
    return 0, $e69b645c3d229ca4$export$d25ddfdf17c3ad3e;
}




function $76b294f68d644f5f$export$7d0784e050d8e25f(elapsed, duration, delay) {
    if (delay === void 0) delay = 0;
    return elapsed - duration - delay;
}
function $76b294f68d644f5f$export$ab9042754680126b(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) delay = 0;
    if (isForwardPlayback === void 0) isForwardPlayback = true;
    return isForwardPlayback ? $76b294f68d644f5f$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $76b294f68d644f5f$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}


var $b59f620790db2efc$var$framesync = function(update) {
    var passTimestamp = function(_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function() {
            return (0, $74f0db85147db332$export$2e2bcd8739ae039).update(passTimestamp, true);
        },
        stop: function() {
            return (0, $74f0db85147db332$export$d93e9c1fe0553512).update(passTimestamp);
        }
    };
};
function $b59f620790db2efc$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? $b59f620790db2efc$var$framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = (0, $cd335636556b7c07$export$74df49bbebf8cb2c)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $042559a8f710c070$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    var animation = animator((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $76b294f68d644f5f$export$ab9042754680126b)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $76b294f68d644f5f$export$7d0784e050d8e25f)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $76b294f68d644f5f$export$c9c9437f9b8733b5)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function() {
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}



function $6badb23fc0c68554$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



function $3832fe44741545c8$export$ee3ff3a17106998(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $b59f620790db2efc$export$e3607ec2d7a891c4)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), {
            driver: driver,
            onUpdate: function(v) {
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete
        }));
    }
    function startSpring(options) {
        startAnimation((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function(v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = (0, $6badb23fc0c68554$export$eab0632f7ad4f9d7)(v - prev_1, (0, $74f0db85147db332$export$7244445918e670ed)().delta);
            if (heading_1 === 1 && v > boundary_1 || heading_1 === -1 && v < boundary_1) startSpring({
                from: v,
                to: boundary_1,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: function() {
            return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        }
    };
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $84048116a109605a$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};





var $f0a11627b0085979$var$a = function(a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var $f0a11627b0085979$var$b = function(a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var $f0a11627b0085979$var$c = function(a1) {
    return 3.0 * a1;
};
var $f0a11627b0085979$var$calcBezier = function(t, a1, a2) {
    return (($f0a11627b0085979$var$a(a1, a2) * t + $f0a11627b0085979$var$b(a1, a2)) * t + $f0a11627b0085979$var$c(a1)) * t;
};
var $f0a11627b0085979$var$getSlope = function(t, a1, a2) {
    return 3.0 * $f0a11627b0085979$var$a(a1, a2) * t * t + 2.0 * $f0a11627b0085979$var$b(a1, a2) * t + $f0a11627b0085979$var$c(a1);
};
var $f0a11627b0085979$var$subdivisionPrecision = 0.0000001;
var $f0a11627b0085979$var$subdivisionMaxIterations = 10;
function $f0a11627b0085979$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $f0a11627b0085979$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $f0a11627b0085979$var$subdivisionPrecision && ++i < $f0a11627b0085979$var$subdivisionMaxIterations);
    return currentT;
}
var $f0a11627b0085979$var$newtonIterations = 8;
var $f0a11627b0085979$var$newtonMinSlope = 0.001;
function $f0a11627b0085979$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $f0a11627b0085979$var$newtonIterations; ++i){
        var currentSlope = $f0a11627b0085979$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $f0a11627b0085979$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var $f0a11627b0085979$var$kSplineTableSize = 11;
var $f0a11627b0085979$var$kSampleStepSize = 1.0 / ($f0a11627b0085979$var$kSplineTableSize - 1.0);
function $f0a11627b0085979$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $06075b9de2c72539$export$45db2fc2f15997e7;
    var sampleValues = new Float32Array($f0a11627b0085979$var$kSplineTableSize);
    for(var i = 0; i < $f0a11627b0085979$var$kSplineTableSize; ++i)sampleValues[i] = $f0a11627b0085979$var$calcBezier(i * $f0a11627b0085979$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $f0a11627b0085979$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $f0a11627b0085979$var$kSampleStepSize;
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $f0a11627b0085979$var$kSampleStepSize;
        var initialSlope = $f0a11627b0085979$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $f0a11627b0085979$var$newtonMinSlope) return $f0a11627b0085979$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $f0a11627b0085979$var$binarySubdivide(aX, intervalStart, intervalStart + $f0a11627b0085979$var$kSampleStepSize, mX1, mX2);
    }
    return function(t) {
        return t === 0 || t === 1 ? t : $f0a11627b0085979$var$calcBezier(getTForX(t), mY1, mY2);
    };
}


var $d41bfcddb03821a1$var$easingLookup = {
    linear: (0, $06075b9de2c72539$export$45db2fc2f15997e7),
    easeIn: (0, $06075b9de2c72539$export$929e5a82286172a6),
    easeInOut: (0, $06075b9de2c72539$export$c07234257a03d5e9),
    easeOut: (0, $06075b9de2c72539$export$57636bb43b1ccbb0),
    circIn: (0, $06075b9de2c72539$export$e444123e42d03385),
    circInOut: (0, $06075b9de2c72539$export$30d3455eee55bed5),
    circOut: (0, $06075b9de2c72539$export$c8d67a19199d1a50),
    backIn: (0, $06075b9de2c72539$export$b01116c84cdfe1a2),
    backInOut: (0, $06075b9de2c72539$export$ddc5fd596f6c71b2),
    backOut: (0, $06075b9de2c72539$export$77edfce482316a60),
    anticipate: (0, $06075b9de2c72539$export$6b0af63b873d419e),
    bounceIn: (0, $06075b9de2c72539$export$fccebd7948554554),
    bounceInOut: (0, $06075b9de2c72539$export$41ad9e9849a703ce),
    bounceOut: (0, $06075b9de2c72539$export$cccc9e04465dce11)
};
var $d41bfcddb03821a1$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $5f54a675503b9e5d$export$f5708dca728d7177)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $f0a11627b0085979$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $5f54a675503b9e5d$export$f5708dca728d7177)($d41bfcddb03821a1$var$easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return $d41bfcddb03821a1$var$easingLookup[definition];
    }
    return definition;
};
var $d41bfcddb03821a1$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $3cc3e4039abcf5b9$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $57a52f1e861e60bd$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};




var $1843d1b88ad410b3$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    };
};
var $1843d1b88ad410b3$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restDelta: 0.01,
        restSpeed: 10
    };
};
var $1843d1b88ad410b3$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $1843d1b88ad410b3$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $1843d1b88ad410b3$var$defaultTransitions = {
    x: $1843d1b88ad410b3$export$2577c2184b2254d3,
    y: $1843d1b88ad410b3$export$2577c2184b2254d3,
    z: $1843d1b88ad410b3$export$2577c2184b2254d3,
    rotate: $1843d1b88ad410b3$export$2577c2184b2254d3,
    rotateX: $1843d1b88ad410b3$export$2577c2184b2254d3,
    rotateY: $1843d1b88ad410b3$export$2577c2184b2254d3,
    rotateZ: $1843d1b88ad410b3$export$2577c2184b2254d3,
    scaleX: $1843d1b88ad410b3$export$a743142a31c132c,
    scaleY: $1843d1b88ad410b3$export$a743142a31c132c,
    scale: $1843d1b88ad410b3$export$a743142a31c132c,
    opacity: $1843d1b88ad410b3$export$c2d663fbb86d66d6,
    backgroundColor: $1843d1b88ad410b3$export$c2d663fbb86d66d6,
    color: $1843d1b88ad410b3$export$c2d663fbb86d66d6,
    default: $1843d1b88ad410b3$export$a743142a31c132c
};
var $1843d1b88ad410b3$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $04dc632a61d0368f$export$9153ad4c4999f4a0)(to)) transitionFactory = $1843d1b88ad410b3$var$keyframes;
    else transitionFactory = $1843d1b88ad410b3$var$defaultTransitions[valueKey] || $1843d1b88ad410b3$var$defaultTransitions.default;
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
        to: to
    }, transitionFactory(to));
};






var $846de0c84ebb8c35$var$maxDefaults = new Set([
    'brightness',
    'contrast',
    'saturate',
    'opacity'
]);
function $846de0c84ebb8c35$var$applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
    if (name === 'drop-shadow') return v;
    var number = (value.match((0, $58ed3844003d7457$export$2444ca58c08448e4)) || [])[0];
    if (!number) return v;
    var unit = value.replace(number, '');
    var defaultValue = $846de0c84ebb8c35$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
var $846de0c84ebb8c35$var$functionRegex = /([a-z-]*)\(.*?\)/g;
var $846de0c84ebb8c35$export$3dea766d36a8935f = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $57a52f1e861e60bd$export$83a0e34f1302825b)), {
    getAnimatableNone: function(v) {
        var functions = v.match($846de0c84ebb8c35$var$functionRegex);
        return functions ? functions.map($846de0c84ebb8c35$var$applyDefaultFilter).join(' ') : v;
    }
});





/**
 * A map of default value types for common values
 */ var $8014879745292743$export$98cd7c72c5a731fb = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $a0a36ef2df6e4e06$export$eec14432cd1cb67b)), {
    // Color props
    color: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    backgroundColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    outlineColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    fill: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    stroke: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    borderTopColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    borderRightColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    borderBottomColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    borderLeftColor: (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    filter: (0, $846de0c84ebb8c35$export$3dea766d36a8935f),
    WebkitFilter: (0, $846de0c84ebb8c35$export$3dea766d36a8935f)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $8014879745292743$export$67d1babe0338d23b = function(key) {
    return $8014879745292743$export$98cd7c72c5a731fb[key];
};


function $06a75118b4d74acf$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $8014879745292743$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $846de0c84ebb8c35$export$3dea766d36a8935f)) defaultValueType = (0, $57a52f1e861e60bd$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $6d22ab817dfb51e8$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $6d22ab817dfb51e8$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $6d22ab817dfb51e8$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $84048116a109605a$export$fc3e7e8557f8c8c7)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $84048116a109605a$export$fc3e7e8557f8c8c7)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $d41bfcddb03821a1$export$216948827bbdc797)(ease) ? ease.map((0, $d41bfcddb03821a1$export$ef97fe084f156ca4)) : (0, $d41bfcddb03821a1$export$ef97fe084f156ca4)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $5f54a675503b9e5d$export$491112666e282270)(!$6d22ab817dfb51e8$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $6d22ab817dfb51e8$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $6d22ab817dfb51e8$export$b55a0e77aebddb70(transition, key) {
    var _a;
    var valueTransition = $6d22ab817dfb51e8$export$7c1391340308742e(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function $6d22ab817dfb51e8$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function $6d22ab817dfb51e8$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $6d22ab817dfb51e8$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$6d22ab817dfb51e8$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, transition), (0, $1843d1b88ad410b3$export$262124b154b9f1c0)(key, options.to));
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), $6d22ab817dfb51e8$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $6d22ab817dfb51e8$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $6d22ab817dfb51e8$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $3cc3e4039abcf5b9$export$65676b58b122bc38)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $06a75118b4d74acf$export$cea0cedcb94873b5)(key, target);
    else if ($6d22ab817dfb51e8$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $6d22ab817dfb51e8$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $6d22ab817dfb51e8$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $6d22ab817dfb51e8$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $3cc3e4039abcf5b9$export$65676b58b122bc38)(key, origin);
    (0, $5f54a675503b9e5d$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $3832fe44741545c8$export$ee3ff3a17106998)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), valueTransition)) : (0, $b59f620790db2efc$export$e3607ec2d7a891c4)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $6d22ab817dfb51e8$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $6d22ab817dfb51e8$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $6d22ab817dfb51e8$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $06a75118b4d74acf$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $6d22ab817dfb51e8$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */ function $6d22ab817dfb51e8$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $6d22ab817dfb51e8$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $6d22ab817dfb51e8$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = setTimeout(start, (0, $84048116a109605a$export$fc3e7e8557f8c8c7)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}




/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $1072a1b6f0e7d2fd$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};





function $9c7b4c19a6d5ce10$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $9c7b4c19a6d5ce10$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}


var $ef01c8873232a128$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $9c7b4c19a6d5ce10$export$20e507e47fae79fd)(this.subscriptions, handler);
        return function() {
            return (0, $9c7b4c19a6d5ce10$export$fe2d9b4e03920b4c)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();


var $ee79af719c41456d$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $ee79af719c41456d$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $ef01c8873232a128$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $ef01c8873232a128$export$e7dff9482a5fd23c)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $ef01c8873232a128$export$e7dff9482a5fd23c)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $74f0db85147db332$export$7244445918e670ed)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $74f0db85147db332$export$2e2bcd8739ae039).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $74f0db85147db332$export$2e2bcd8739ae039).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $ee79af719c41456d$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $6badb23fc0c68554$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
/**
 * @internal
 */ function $ee79af719c41456d$export$ce8bdc721e76545f(init) {
    return new $ee79af719c41456d$export$8cea36d14ee64562(init);
}






/**
 * Tests a provided value against a ValueType
 */ var $657135e3ed9d70e0$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};


/**
 * ValueType for "auto"
 */ var $4c258e33bee8dfa6$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};


/**
 * A list of value types commonly used for dimensions
 */ var $94548fa0567ba129$export$d176691c1998a1f5 = [
    (0, $f611823ce945608e$export$98e628dec113755e),
    (0, $d4e2413af6dede3d$export$91c0eda1d06bf008),
    (0, $d4e2413af6dede3d$export$626336c2cd4b14de),
    (0, $d4e2413af6dede3d$export$41fc368e1a942b97),
    (0, $d4e2413af6dede3d$export$aed3d7b7d206c196),
    (0, $d4e2413af6dede3d$export$f91e8c45a95a32f2),
    (0, $4c258e33bee8dfa6$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $94548fa0567ba129$export$eefdd52e3ccae428 = function(v) {
    return $94548fa0567ba129$export$d176691c1998a1f5.find((0, $657135e3ed9d70e0$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * A list of all ValueTypes
 */ var $379031576ad426d7$var$valueTypes = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)((0, $94548fa0567ba129$export$d176691c1998a1f5))), [
    (0, $df0779e3f53f4b3c$export$35e9368ef982300f),
    (0, $57a52f1e861e60bd$export$83a0e34f1302825b)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $379031576ad426d7$export$950e7e59ea1ffed7 = function(v) {
    return $379031576ad426d7$var$valueTypes.find((0, $657135e3ed9d70e0$export$6eae4d0a6a7ca7cd)(v));
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $32afa7c939dcc12a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $ee79af719c41456d$export$ce8bdc721e76545f)(value));
}
function $32afa7c939dcc12a$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $b2123e5233c590bc$export$7b1b1c981f4f0558)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $1ade74f2cc3503c3$export$5485128c47bd48bb)(target[key]);
        $32afa7c939dcc12a$var$setMotionValue(visualElement, key, value);
    }
}
function $32afa7c939dcc12a$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(variantLabels)).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $32afa7c939dcc12a$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $32afa7c939dcc12a$var$setVariants(child, variantLabels);
        });
    });
}
function $32afa7c939dcc12a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $32afa7c939dcc12a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $32afa7c939dcc12a$var$setVariants(visualElement, [
        definition
    ]);
    else $32afa7c939dcc12a$export$1f61c53461aff4a5(visualElement, definition);
}
function $32afa7c939dcc12a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && (0, $1072a1b6f0e7d2fd$export$65583ed5a868f2d9)(value)) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $379031576ad426d7$export$950e7e59ea1ffed7)(value) && (0, $57a52f1e861e60bd$export$83a0e34f1302825b).test(targetValue)) value = (0, $06a75118b4d74acf$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $ee79af719c41456d$export$ce8bdc721e76545f)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $32afa7c939dcc12a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $32afa7c939dcc12a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $32afa7c939dcc12a$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}



/**
 * @internal
 */ function $c17dcd84aa354b08$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $c17dcd84aa354b08$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $c17dcd84aa354b08$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $b2123e5233c590bc$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $c17dcd84aa354b08$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $c17dcd84aa354b08$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $b2123e5233c590bc$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $c17dcd84aa354b08$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $c17dcd84aa354b08$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $c17dcd84aa354b08$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $c17dcd84aa354b08$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var animation = (0, $6d22ab817dfb51e8$export$592dbd515a49cf1b)(key, value, valueTarget, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            delay: delay
        }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $32afa7c939dcc12a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $c17dcd84aa354b08$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($c17dcd84aa354b08$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($c17dcd84aa354b08$var$animateVariant(child, variant, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $c17dcd84aa354b08$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $c17dcd84aa354b08$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $c17dcd84aa354b08$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}




var $b3135fc0bc745fa0$export$16e45afcc206d3a8 = [
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Animate,
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Hover,
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Tap,
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Drag,
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Focus,
    (0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Exit
];
var $b3135fc0bc745fa0$var$reversePriorityOrder = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)($b3135fc0bc745fa0$export$16e45afcc206d3a8)).reverse();
var $b3135fc0bc745fa0$var$numAnimationTypes = $b3135fc0bc745fa0$export$16e45afcc206d3a8.length;
function $b3135fc0bc745fa0$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $c17dcd84aa354b08$export$ff62cf473653f109)(visualElement, animation, options);
        }));
    };
}
function $b3135fc0bc745fa0$export$bb53502b7a672aa8(visualElement) {
    var animate = $b3135fc0bc745fa0$var$animateList(visualElement);
    var state = $b3135fc0bc745fa0$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $b2123e5233c590bc$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $b3135fc0bc745fa0$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $b2123e5233c590bc$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $e581871f7d7ebfdf$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var shouldAnimateType = $b3135fc0bc745fa0$export$b9d9a225005a5327(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $04dc632a61d0368f$export$9153ad4c4999f4a0)(next) && (0, $04dc632a61d0368f$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $64a8ca18932fde24$export$90e866afbd6b9f1a)(next, prev)) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        type: type
                    }, options)
                };
            }))));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $b3135fc0bc745fa0$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $b3135fc0bc745fa0$export$b9d9a225005a5327(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $b2123e5233c590bc$export$562271cd22f751d)(next)) return !(0, $64a8ca18932fde24$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $b3135fc0bc745fa0$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b3135fc0bc745fa0$var$createState() {
    var _a;
    return _a = {}, _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Animate] = $b3135fc0bc745fa0$var$createTypeState(true), _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Hover] = $b3135fc0bc745fa0$var$createTypeState(), _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Tap] = $b3135fc0bc745fa0$var$createTypeState(), _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Drag] = $b3135fc0bc745fa0$var$createTypeState(), _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Focus] = $b3135fc0bc745fa0$var$createTypeState(), _a[(0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Exit] = $b3135fc0bc745fa0$var$createTypeState(), _a;
}




var $2e344faed2e5a38b$export$7f9953c70dacfd7f = {
    animation: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $b3135fc0bc745fa0$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $e581871f7d7ebfdf$export$aa71198ceeaf53ce)(animate)) (0, $denZA.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)((0, $fa7d48d3f8d00960$export$2a8c16d82a0a0e26)(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0, $denZA.useContext)((0, $d69cc1886c6dd912$export$f224e4635b6f8ce2));
        (0, $denZA.useEffect)(function() {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(onExitComplete));
        }, [
            isPresent
        ]);
    })
};




var $denZA = parcelRequire("denZA");









var $5addcfee6c02c025$export$aff838a5553f2a92 = function(point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};



var $3617c4b9f2831f47$export$319d74662aaa2966 = function(point) {
    return (0, $5addcfee6c02c025$export$aff838a5553f2a92)(point) && point.hasOwnProperty('z');
};



var $f392cc06572bb320$var$distance1D = function(a, b) {
    return Math.abs(a - b);
};
function $f392cc06572bb320$export$9f17032d917177de(a, b) {
    if ((0, $a0225e157f270d45$export$4e960b977ccfec97)(a) && (0, $a0225e157f270d45$export$4e960b977ccfec97)(b)) return $f392cc06572bb320$var$distance1D(a, b);
    else if ((0, $5addcfee6c02c025$export$aff838a5553f2a92)(a) && (0, $5addcfee6c02c025$export$aff838a5553f2a92)(b)) {
        var xDelta = $f392cc06572bb320$var$distance1D(a.x, b.x);
        var yDelta = $f392cc06572bb320$var$distance1D(a.y, b.y);
        var zDelta = (0, $3617c4b9f2831f47$export$319d74662aaa2966)(a) && (0, $3617c4b9f2831f47$export$319d74662aaa2966)(b) ? $f392cc06572bb320$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}


/**
 * @internal
 */ var $9cdaeed08f3fe321$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $9cdaeed08f3fe321$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $f392cc06572bb320$export$9f17032d917177de)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $74f0db85147db332$export$7244445918e670ed)().timestamp;
            _this.history.push((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $9cdaeed08f3fe321$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $d6d4d2c9c3e1a334$export$764db16956f554f8)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $9cdaeed08f3fe321$var$getPanInfo($9cdaeed08f3fe321$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $d6d4d2c9c3e1a334$export$c4dfce035d43d1e0)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $a05aeb9c29066806$export$12f84bb882d06e1a)(event);
        var initialInfo = $9cdaeed08f3fe321$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $74f0db85147db332$export$7244445918e670ed)().timestamp;
        this.history = [
            (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $9cdaeed08f3fe321$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $1febbb3d73d31607$export$a4627e546088548d)((0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $9cdaeed08f3fe321$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9cdaeed08f3fe321$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9cdaeed08f3fe321$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $9cdaeed08f3fe321$var$subtractPoint(point, $9cdaeed08f3fe321$var$lastDevicePoint(history)),
        offset: $9cdaeed08f3fe321$var$subtractPoint(point, $9cdaeed08f3fe321$var$startDevicePoint(history)),
        velocity: $9cdaeed08f3fe321$var$getVelocity(history, 0.1)
    };
}
function $9cdaeed08f3fe321$var$startDevicePoint(history) {
    return history[0];
}
function $9cdaeed08f3fe321$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9cdaeed08f3fe321$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $9cdaeed08f3fe321$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $84048116a109605a$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}








// Call a handler once for each axis
function $9d58c79c2c7f2533$export$b789de563eb43b1(handler) {
    return [
        handler("x"),
        handler("y")
    ];
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $c93b792f5f9df289$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */ function $c93b792f5f9df289$export$365d4f5bee5334d2(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? $c93b792f5f9df289$export$b3c764d3fca3ffe3(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $c93b792f5f9df289$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $c93b792f5f9df289$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $c93b792f5f9df289$export$690c180aa5775042(layoutBox.x, left, right),
        y: $c93b792f5f9df289$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $c93b792f5f9df289$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $c93b792f5f9df289$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $c93b792f5f9df289$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $c93b792f5f9df289$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */ function $c93b792f5f9df289$export$c24202d5faacd1d9(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(constraints.min, constraints.max - axisLength, progress);
    return {
        min: min,
        max: min + axisLength
    };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $c93b792f5f9df289$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $c93b792f5f9df289$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $c93b792f5f9df289$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $c93b792f5f9df289$export$a3366d3bac43a742;
    return {
        x: $c93b792f5f9df289$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $c93b792f5f9df289$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $c93b792f5f9df289$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $c93b792f5f9df289$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $c93b792f5f9df289$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $c93b792f5f9df289$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */ function $17de0af38d0ff3fd$export$895c5e634403eaa7(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0, $1e15aa74128cf363$export$a6a6a93acd99480a)((0, $1e15aa74128cf363$export$e79a6921359ce186)(box, transformPagePoint));
}



var $d4ec815e0250a6aa$var$clampProgress = function(v) {
    return (0, $bc06f1106e0ccce0$export$7d15b64cf5a3a4c4)(0, 1, v);
};
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */ function $d4ec815e0250a6aa$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $f392cc06572bb320$export$9f17032d917177de)(value, target) < maxDistance;
}
function $d4ec815e0250a6aa$var$calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $d4ec815e0250a6aa$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = $d4ec815e0250a6aa$var$calcLength(source);
    var targetLength = $d4ec815e0250a6aa$var$calcLength(target);
    if (targetLength > sourceLength) origin = (0, $4b12c414d833e494$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $4b12c414d833e494$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return $d4ec815e0250a6aa$var$clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $d4ec815e0250a6aa$export$acf2fd1e22884f56(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $d4ec815e0250a6aa$var$calcLength(target) / $d4ec815e0250a6aa$var$calcLength(source);
    if ($d4ec815e0250a6aa$export$28d0384c4b79bde2(delta.scale, 1, 0.0001)) delta.scale = 1;
    delta.translate = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($d4ec815e0250a6aa$export$28d0384c4b79bde2(delta.translate)) delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $d4ec815e0250a6aa$export$1435a2beec546d2e(delta, source, target, origin) {
    $d4ec815e0250a6aa$export$acf2fd1e22884f56(delta.x, source.x, target.x, $d4ec815e0250a6aa$var$defaultOrigin(origin.originX));
    $d4ec815e0250a6aa$export$acf2fd1e22884f56(delta.y, source.y, target.y, $d4ec815e0250a6aa$var$defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */ function $d4ec815e0250a6aa$var$defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function $d4ec815e0250a6aa$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d4ec815e0250a6aa$var$calcLength(relative);
}
function $d4ec815e0250a6aa$export$426154f9d100f99(projection, parentProjection) {
    $d4ec815e0250a6aa$export$cabef5b392704b41(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    $d4ec815e0250a6aa$export$cabef5b392704b41(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}







function $a2d806c1dcbec339$export$21d180ad0c0013cb(target, prev, next, p) {
    target.min = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(prev.min, next.min, p);
    target.max = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(prev.max, next.max, p);
}
function $a2d806c1dcbec339$export$58fa21d412109d6b(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min
    };
}
function $a2d806c1dcbec339$export$5d8b2d12fde0857a(parent, child) {
    return {
        x: $a2d806c1dcbec339$export$58fa21d412109d6b(parent.x, child.x),
        y: $a2d806c1dcbec339$export$58fa21d412109d6b(parent.y, child.y)
    };
}
function $a2d806c1dcbec339$export$d1cc994fa3b9d457(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || nextId === undefined && prev !== next;
}





function $ee272b6102c1c0f3$export$fe8f97248bbe2d04(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d81b9f898691502b$export$ab0da4c5058aa6e9(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $d81b9f898691502b$export$d7ad1d43f7ab13a6(box, originBox) {
    $d81b9f898691502b$export$ab0da4c5058aa6e9(box.x, originBox.x);
    $d81b9f898691502b$export$ab0da4c5058aa6e9(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */ function $d81b9f898691502b$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d81b9f898691502b$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d81b9f898691502b$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d81b9f898691502b$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d81b9f898691502b$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $d81b9f898691502b$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d81b9f898691502b$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d81b9f898691502b$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $d81b9f898691502b$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d81b9f898691502b$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d81b9f898691502b$export$fe9134d4e4502d7e(final, axis, transforms, _a) {
    var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d81b9f898691502b$export$e8e3a712e9ebf422(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $d81b9f898691502b$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $d81b9f898691502b$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d81b9f898691502b$export$c8fdd2c80d7384dd(finalBox, box, transforms) {
    $d81b9f898691502b$export$fe9134d4e4502d7e(finalBox.x, box.x, transforms, $d81b9f898691502b$var$xKeys);
    $d81b9f898691502b$export$fe9134d4e4502d7e(finalBox.y, box.y, transforms, $d81b9f898691502b$var$yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $d81b9f898691502b$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = $d81b9f898691502b$export$2290ec7febe36dd6(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = $d81b9f898691502b$export$2290ec7febe36dd6(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $d81b9f898691502b$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    var originPoint = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(axis.min, axis.max, origin) - translate;
    axis.min = $d81b9f898691502b$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d81b9f898691502b$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d81b9f898691502b$export$42b76f1d0d16d5b(axis, transforms, _a) {
    var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $d81b9f898691502b$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d81b9f898691502b$export$73e1ad0a9694e25c(box, transforms) {
    $d81b9f898691502b$export$42b76f1d0d16d5b(box.x, transforms, $d81b9f898691502b$var$xKeys);
    $d81b9f898691502b$export$42b76f1d0d16d5b(box.y, transforms, $d81b9f898691502b$var$yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d81b9f898691502b$export$e2a980535c55eabb(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        $d81b9f898691502b$export$d80074982803af5c(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if ((0, $ee272b6102c1c0f3$export$fe8f97248bbe2d04)(node)) $d81b9f898691502b$export$c8fdd2c80d7384dd(box, box, node.getLatestValues());
    }
}


/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */ function $d33d7a556b259657$export$69bccedc5101c4d1(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) isLayoutDrag = true;
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) return false;
    var offset;
    if (isLayoutDrag) {
        offset = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(projectionParent.projection.target, visualElement.projection.target);
        (0, $d81b9f898691502b$export$73e1ad0a9694e25c)(offset, projectionParent.getLatestValues());
    } else offset = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}





var $096f71a504c81613$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ var $096f71a504c81613$var$lastPointerEvent;
var $096f71a504c81613$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */ this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */ this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */ this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */ this.elastic = (0, $1e15aa74128cf363$export$392205f483678b20)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */ this.props = {};
        /**
         * @internal
         */ this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */ this.cursorProgress = {
            x: 0.5,
            y: 0.5
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */ this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        $096f71a504c81613$export$f0a15892c27dc07c.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */ VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function(event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */ var initialPoint = (0, $a05aeb9c29066806$export$750e59ed656e0503)(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 || _a.call(_this);
            _this.cancelLayout = (0, $6d61c3f1679e997a$export$7e76af4b25f08a69)(function(read, write) {
                var ancestors = (0, $c7939c84ff320929$export$e900175ee6159829)(_this.visualElement);
                var children = (0, $c7939c84ff320929$export$99d2ce63b1d58b9f)(_this.visualElement);
                var tree = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(ancestors)), (0, $96998cfc8b9d4854$export$8d051b38c9118094)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */ _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function() {
                    tree.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    (0, $c7939c84ff320929$export$ec1805441219fc83)(_this.visualElement);
                    children.forEach((0, $c7939c84ff320929$export$ec1805441219fc83));
                });
                write(function() {
                    tree.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    if (snapToCursor) hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                });
                read(function() {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */ var projection = _this.visualElement.projection;
                    (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress ? cursorProgress[axis] : (0, $4b12c414d833e494$export$504d7abb21fa8c9)(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */ var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) _this.originPoint[axis] = axisValue.get();
                    });
                });
                write(function() {
                    (0, $74f0db85147db332$export$cd75ccfd720a3cd4).update();
                    (0, $74f0db85147db332$export$cd75ccfd720a3cd4).preRender();
                    (0, $74f0db85147db332$export$cd75ccfd720a3cd4).render();
                    (0, $74f0db85147db332$export$cd75ccfd720a3cd4).postRender();
                });
                read(function() {
                    return _this.resolveDragConstraints();
                });
            });
        };
        var onStart = function(event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $948207fd41cbebf1$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            (0, $6d61c3f1679e997a$export$6445c3d91f1ae606)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 || _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 || _c.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Drag, true);
        };
        var onMove = function(event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $096f71a504c81613$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 || _b.call(_a, _this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 || _d.call(_c, event, info);
            // Update the last pointer event
            $096f71a504c81613$var$lastPointerEvent = event;
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new (0, $9cdaeed08f3fe321$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: transformPagePoint
        });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function() {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) this.constraints = (0, $c743c65af8b08295$export$dedd81df7bc1307)(dragConstraints) ? this.resolveRefConstraints(layout, dragConstraints) : (0, $c93b792f5f9df289$export$4e9195bf7793bc78)(layout, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $c93b792f5f9df289$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (this.constraints && !this.hasMutatedConstraints) (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $c93b792f5f9df289$export$e9672cc4c36a8b87)(layout[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function(layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        (0, $5f54a675503b9e5d$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = (0, $17de0af38d0ff3fd$export$895c5e634403eaa7)(constraintsElement, transformPagePoint);
        var measuredConstraints = (0, $c93b792f5f9df289$export$4228500f19d4cdf7)(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $1e15aa74128cf363$export$7dccf987ed3cfb10)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $1e15aa74128cf363$export$a6a6a93acd99480a)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function() {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 || _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $3829e4ee3bdfc35f$export$2deb71ebd3734d23).Drag, false);
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 || _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        return (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!$096f71a504c81613$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            } else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */ VisualElementDragControls.prototype.updateAxis = function(axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!$096f71a504c81613$var$shouldDrag(axis, drag, this.currentDirection)) return;
        return this.getAxisMotionValue(axis) ? this.updateAxisMotionValue(axis, offset) : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function(axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue) return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints ? (0, $c93b792f5f9df289$export$b3c764d3fca3ffe3)(nextValue, this.constraints[axis], this.elastic[axis]) : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function(axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = (0, $c93b792f5f9df289$export$365d4f5bee5334d2)(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function(_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? (0, $c93b792f5f9df289$export$a3366d3bac43a742) : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
            "drag",
            "dragDirectionLock",
            "dragPropagation",
            "dragConstraints",
            "dragElastic",
            "dragMomentum"
        ]);
        this.props = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) return this.props[dragKey];
        else if (!layout && layoutId === undefined) return this.visualElement.getValue(axis, 0);
    };
    VisualElementDragControls.prototype.isLayoutDrag = function() {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function() {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function(velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */ var isRelative = (0, $d33d7a556b259657$export$69bccedc5101c4d1)(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */ var constraints = this.constraints || {};
        if (isRelative && Object.keys(constraints).length && this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(projectionParent.projection.targetFinal, constraints);
                (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max
                    };
                });
            }
        }
        var momentumAnimations = (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            var _a;
            if (!$096f71a504c81613$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis) ? _this.startAxisValueAnimation(axis, inertia) : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function() {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 || _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function() {
        var _this = this;
        (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue ? axisValue.stop() : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue) return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return (0, $6d22ab817dfb51e8$export$592dbd515a49cf1b)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function() {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!(0, $c743c65af8b08295$export$dedd81df7bc1307)(dragConstraints) || !this.constraintsBox) return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            boxProgress[axis] = (0, $d4ec815e0250a6aa$export$13abbfca044ca46d)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */ this.updateConstraints(function() {
            (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                if (!$096f71a504c81613$var$shouldDrag(axis, drag, null)) return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = (0, $c93b792f5f9df289$export$c24202d5faacd1d9)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */ setTimeout((0, $6d61c3f1679e997a$export$6445c3d91f1ae606), 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function(onReady) {
        var _this = this;
        this.cancelLayout = (0, $6d61c3f1679e997a$export$7e76af4b25f08a69)(function(read, write) {
            var ancestors = (0, $c7939c84ff320929$export$e900175ee6159829)(_this.visualElement);
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.resetTransform();
                });
            });
            read(function() {
                return (0, $c7939c84ff320929$export$ec1805441219fc83)(_this.visualElement);
            });
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.restoreTransform();
                });
            });
            read(function() {
                _this.resolveDragConstraints();
            });
            if (onReady) write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function(visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $36c4b7d5f680165c$export$fcff2e64e6676b81)(element, "pointerdown", function(event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $bd7fae79e55f4f7e$export$b1d829ddf82884aa)(window, "resize", function() {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */ var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function() {
            if (_this.isDragging) _this.resolveDragConstraints();
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */ var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) this.start($096f71a504c81613$var$lastPointerEvent, {
            cursorProgress: prevDragCursor
        });
        /**
         * Return a function that will teardown the drag gesture
         */ return function() {
            stopPointerListener === null || stopPointerListener === void 0 || stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 || stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}();
function $096f71a504c81613$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $096f71a504c81613$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $d99195907cc89e58$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0, $denZA.useContext)((0, $7106ca00da13be0f$export$22a697fb29aac98d)).transformPagePoint;
    var dragControls = (0, $c8ac78540807b621$export$fe4300aa8eebea86)(function() {
        return new (0, $096f71a504c81613$export$86bff71f18910307)({
            visualElement: visualElement
        });
    });
    dragControls.setProps((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, props), {
        transformPagePoint: transformPagePoint
    }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $denZA.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls
    ]);
    // Mount the drag controls with the visualElement
    (0, $denZA.useEffect)(function() {
        return dragControls.mount(visualElement);
    }, []);
}



var $denZA = parcelRequire("denZA");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $8664cf20e55cb182$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $denZA.useRef)(null);
    var transformPagePoint = (0, $denZA.useContext)((0, $7106ca00da13be0f$export$22a697fb29aac98d)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $denZA.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $9cdaeed08f3fe321$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $36c4b7d5f680165c$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $297359e2972e0fce$export$f3a192d0cbd30b96)(function() {
        return panSession.current && panSession.current.end();
    });
}



var $88e24ec07f94cafb$export$d7d5d435647ed5a0 = {
    pan: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)((0, $8664cf20e55cb182$export$eb0f62174cac1aec)),
    drag: (0, $54c635bc7cd40a8b$export$46d1d6d046f826e4)((0, $d99195907cc89e58$export$7941f8aafa4b6021))
};




var $denZA = parcelRequire("denZA");












function $ea3588f715dd8571$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $ea3588f715dd8571$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ea3588f715dd8571$export$b9f0c1f373aee2b0(current) {
    var match = $ea3588f715dd8571$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $ea3588f715dd8571$var$maxDepth = 4;
function $ea3588f715dd8571$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $5f54a675503b9e5d$export$f5708dca728d7177)(depth <= $ea3588f715dd8571$var$maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
    var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)($ea3588f715dd8571$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($ea3588f715dd8571$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ea3588f715dd8571$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ea3588f715dd8571$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$ea3588f715dd8571$var$isCSSVariable(current)) return;
        var resolved = $ea3588f715dd8571$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$ea3588f715dd8571$var$isCSSVariable(current)) continue;
        var resolved = $ea3588f715dd8571$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}


function $d61ded63760bfb6c$export$fafff692be55225d(pixels, axis) {
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ function $d61ded63760bfb6c$export$5eafb6257a5844c(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */ if (typeof latest === "string") {
        if ((0, $d4e2413af6dede3d$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
        else return latest;
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */ var x = $d61ded63760bfb6c$export$fafff692be55225d(latest, target.x);
    var y = $d61ded63760bfb6c$export$fafff692be55225d(latest, target.y);
    return x + "% " + y + "%";
}
var $d61ded63760bfb6c$var$varToken = "_$css";
function $d61ded63760bfb6c$export$eb0bc629e74dcf8(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */ var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) latest = latest.replace((0, $ea3588f715dd8571$export$f7c0a352d8ef6313), function(match) {
        cssVariables.push(match);
        return $d61ded63760bfb6c$var$varToken;
    });
    var shadow = (0, $57a52f1e861e60bd$export$83a0e34f1302825b).parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    var template = (0, $57a52f1e861e60bd$export$83a0e34f1302825b).createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */ var averageScale = (0, $12faf2db10f0b925$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace($d61ded63760bfb6c$var$varToken, function() {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var $d61ded63760bfb6c$var$borderCorrectionDefinition = {
    process: $d61ded63760bfb6c$export$5eafb6257a5844c
};
var $d61ded63760bfb6c$export$f5121daded6e3d5d = {
    borderRadius: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, $d61ded63760bfb6c$var$borderCorrectionDefinition), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: $d61ded63760bfb6c$var$borderCorrectionDefinition,
    borderTopRightRadius: $d61ded63760bfb6c$var$borderCorrectionDefinition,
    borderBottomLeftRadius: $d61ded63760bfb6c$var$borderCorrectionDefinition,
    borderBottomRightRadius: $d61ded63760bfb6c$var$borderCorrectionDefinition,
    boxShadow: {
        process: $d61ded63760bfb6c$export$eb0bc629e74dcf8
    }
};


var $000e2dae35138b5a$var$progressTarget = 1000;
var $000e2dae35138b5a$var$Animate = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */ _this.frameTarget = (0, $1e15aa74128cf363$export$392205f483678b20)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */ _this.currentAnimationTarget = (0, $1e15aa74128cf363$export$392205f483678b20)();
        /**
         * Track whether we're animating this axis.
         */ _this.isAnimating = {
            x: false,
            y: false
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined
        };
        _this.isAnimatingTree = false;
        _this.animate = function(target, origin, _a) {
            if (_a === void 0) _a = {};
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
                "originBox",
                "targetBox",
                "visibilityAction",
                "shouldStackAnimate",
                "onComplete",
                "prevParent"
            ]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */ if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */ if (_this.isAnimatingTree && shouldStackAnimate !== true) return;
            else if (shouldStackAnimate) _this.isAnimatingTree = true;
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */ origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */ var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */ if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */ if (targetBox) parentLayout = prevParent.getLayoutState().layout;
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */ if (originBox && !(0, $a2d806c1dcbec339$export$d1cc994fa3b9d457)(prevParent, projectionParent) && prevParent.prevViewportBox) prevParentViewportBox = prevParent.prevViewportBox;
                }
                if (prevParentViewportBox && $000e2dae35138b5a$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(prevParentViewportBox, origin);
                    target = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(parentLayout, target);
                }
            }
            var boxHasMoved = $000e2dae35138b5a$var$hasMoved(origin, target);
            var animations = (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */ if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) return;
                else if (visibilityAction !== undefined) visualElement.setVisibility(visibilityAction === (0, $1979636016632b46$export$560b21f26820dbed).Show);
                else if (boxHasMoved) // If the box has moved, animate between it's current visual state and its
                // final state
                return _this.animateAxis(axis, target[axis], origin[axis], (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, config), {
                    isRelative: isRelative
                }));
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 || _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */ return Promise.all(animations).then(function() {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function() {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = (0, $6d22ab817dfb51e8$export$592dbd515a49cf1b);
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function() {
            return _this.safeToRemove();
        };
        (0, $e52a5b25e7005ee3$export$2cba7fcde4b7b2d5)((0, $d61ded63760bfb6c$export$f5121daded6e3d5d));
    };
    Animate.prototype.componentWillUnmount = function() {
        var _this = this;
        this.unsubLayoutReady();
        (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
            var _a, _b;
            return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */ Animate.prototype.animateAxis = function(axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */ if (this.isAnimating[axis] && $000e2dae35138b5a$var$axisIsEqual(target, this.currentAnimationTarget[axis])) return;
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 || _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */ layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */ var frame = function() {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / $000e2dae35138b5a$var$progressTarget;
            // Tween the axis and update the visualElement with the latest values
            (0, $a2d806c1dcbec339$export$21d180ad0c0013cb)(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function() {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition || visualElement.getDefaultTransition() || $000e2dae35138b5a$var$defaultLayoutTransition;
        // Start the animation on this axis
        var animation = (0, $6d22ab817dfb51e8$export$592dbd515a49cf1b)(axis === "x" ? "layoutX" : "layoutY", layoutProgress, $000e2dae35138b5a$var$progressTarget, layoutTransition && (0, $6d22ab817dfb51e8$export$7c1391340308742e)(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function() {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 || _b.call(_a);
    };
    Animate.prototype.render = function() {
        return null;
    };
    return Animate;
}($denZA.Component);
function $000e2dae35138b5a$export$bd44d4206e0b4eca(props) {
    var _a = (0, $96998cfc8b9d4854$export$8d051b38c9118094)((0, $fa7d48d3f8d00960$export$2a8c16d82a0a0e26)(), 2), safeToRemove = _a[1];
    return $denZA.createElement($000e2dae35138b5a$var$Animate, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, props, {
        safeToRemove: safeToRemove
    }));
}
function $000e2dae35138b5a$var$hasMoved(a, b) {
    return !$000e2dae35138b5a$var$isZeroBox(a) && !$000e2dae35138b5a$var$isZeroBox(b) && (!$000e2dae35138b5a$var$axisIsEqual(a.x, b.x) || !$000e2dae35138b5a$var$axisIsEqual(a.y, b.y));
}
var $000e2dae35138b5a$var$zeroAxis = {
    min: 0,
    max: 0
};
function $000e2dae35138b5a$var$isZeroBox(a) {
    return $000e2dae35138b5a$var$axisIsEqual(a.x, $000e2dae35138b5a$var$zeroAxis) && $000e2dae35138b5a$var$axisIsEqual(a.y, $000e2dae35138b5a$var$zeroAxis);
}
function $000e2dae35138b5a$var$axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var $000e2dae35138b5a$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $000e2dae35138b5a$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || !prevParent && !(originBox || targetBox);
}




var $denZA = parcelRequire("denZA");


/**
 * This component is responsible for scheduling the measuring of the motion component
 */ var $6206026621702603$var$Measure = /** @class */ function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */ Measure.prototype.componentDidMount = function() {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0, $4accc4bb8978d8fb$export$8475119b63356082)(syncLayout) && syncLayout.register(visualElement);
        (0, $4accc4bb8978d8fb$export$8475119b63356082)(framerSyncLayout) && framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function() {
            if ((0, $4accc4bb8978d8fb$export$8475119b63356082)(syncLayout)) syncLayout.remove(visualElement);
            if ((0, $4accc4bb8978d8fb$export$8475119b63356082)(framerSyncLayout)) framerSyncLayout.remove(visualElement);
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */ Measure.prototype.getSnapshotBeforeUpdate = function() {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0, $4accc4bb8978d8fb$export$8475119b63356082)(syncLayout)) syncLayout.syncUpdate();
        else {
            (0, $c7939c84ff320929$export$4f13d577f7028d57)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function() {
        var syncLayout = this.props.syncLayout;
        if (!(0, $4accc4bb8978d8fb$export$8475119b63356082)(syncLayout)) syncLayout.flush();
    };
    Measure.prototype.render = function() {
        return null;
    };
    return Measure;
}((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
function $6206026621702603$export$47ef792ac0e676f6(props) {
    var syncLayout = (0, $denZA.useContext)((0, $4accc4bb8978d8fb$export$a3d1a816cb91a642));
    var framerSyncLayout = (0, $denZA.useContext)((0, $4accc4bb8978d8fb$export$88d0442641a5238c));
    return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($6206026621702603$var$Measure, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, props, {
        syncLayout: syncLayout,
        framerSyncLayout: framerSyncLayout
    }));
}


var $e5939cd8feec1e26$export$eb704cf7366aa18a = {
    measureLayout: (0, $6206026621702603$export$47ef792ac0e676f6),
    layoutAnimation: (0, $000e2dae35138b5a$export$bd44d4206e0b4eca)
};














var $44e30b011a378613$export$3cdcde773d12ad30 = function() {
    return {
        isEnabled: false,
        isHydrated: false,
        isTargetLocked: false,
        target: (0, $1e15aa74128cf363$export$392205f483678b20)(),
        targetFinal: (0, $1e15aa74128cf363$export$392205f483678b20)()
    };
};
function $44e30b011a378613$export$e7071b3cce6bc4ce() {
    return {
        isHydrated: false,
        layout: (0, $1e15aa74128cf363$export$392205f483678b20)(),
        layoutCorrected: (0, $1e15aa74128cf363$export$392205f483678b20)(),
        treeScale: {
            x: 1,
            y: 1
        },
        delta: (0, $1e15aa74128cf363$export$eabbe41f409ce55b)(),
        deltaFinal: (0, $1e15aa74128cf363$export$eabbe41f409ce55b)(),
        deltaTransform: ""
    };
}
var $44e30b011a378613$export$6ce978c1a0625804 = $44e30b011a378613$export$e7071b3cce6bc4ce();


/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */ function $1dd5ea6d0ac163b1$export$d842ebfa32edc648(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(" + rotate + ") ";
        if (rotateX) transform += "rotateX(" + rotateX + ") ";
        if (rotateY) transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === $1dd5ea6d0ac163b1$export$f6730f82d2dcfda3 ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */ function $1dd5ea6d0ac163b1$export$9df601cd9cfcf364(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var $1dd5ea6d0ac163b1$export$f6730f82d2dcfda3 = $1dd5ea6d0ac163b1$export$d842ebfa32edc648((0, $44e30b011a378613$export$6ce978c1a0625804).delta, (0, $44e30b011a378613$export$6ce978c1a0625804).treeScale, {
    x: 1,
    y: 1
});





var $6c25fe065e27de05$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $6c25fe065e27de05$export$f6841af6ea5003ab() {
    var managers = $6c25fe065e27de05$var$names.map(function() {
        return new (0, $ef01c8873232a128$export$e7dff9482a5fd23c)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            return $6c25fe065e27de05$var$names.forEach(function(name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $6c25fe065e27de05$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $6c25fe065e27de05$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(args)));
        };
    });
    return lifecycles;
}




function $61834af08bd8ec0d$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $7358f47b8e0272c8$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $7358f47b8e0272c8$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $ee79af719c41456d$export$ce8bdc721e76545f)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $ee79af719c41456d$export$ce8bdc721e76545f)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




function $13262157e4e70e0f$export$1b3a41764b83e037(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */ (0, $d81b9f898691502b$export$d7ad1d43f7ab13a6)(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */ (0, $d81b9f898691502b$export$e2a980535c55eabb)(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */ (0, $d4ec815e0250a6aa$export$1435a2beec546d2e)(delta, layoutCorrected, target, transformOrigin);
}





var $fa2e3f540470bde3$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $9c7b4c19a6d5ce10$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $9c7b4c19a6d5ce10$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $fff46e0a9cea3aa7$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();





function $fbd6ef1da58570bf$export$8a57a029e604f408(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = (0, $a2d806c1dcbec339$export$5d8b2d12fde0857a)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}



var $ffcd8c63cc6eb770$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) options = {};
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */ var lifecycles = (0, $6c25fe065e27de05$export$f6841af6ea5003ab)();
        /**
         *
         */ var projection = (0, $44e30b011a378613$export$3cdcde773d12ad30)();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */ var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */ var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */ var layoutState = (0, $44e30b011a378613$export$e7071b3cce6bc4ce)();
        /**
         *
         */ var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */ var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */ var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         *
         */ function render() {
            if (!instance) return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */ (0, $d81b9f898691502b$export$c8fdd2c80d7384dd)(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */ (0, $d4ec815e0250a6aa$export$1435a2beec546d2e)(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues) valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady()) return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            (0, $13262157e4e70e0f$export$1b3a41764b83e037)(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated && element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = (0, $1dd5ea6d0ac163b1$export$d842ebfa32edc648)(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform || // Also compare calculated treeScale, for values that rely on this only for scale correction
            prevTreeScaleX !== treeScale.x || prevTreeScaleY !== treeScale.y) element.scheduleRender();
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach($ffcd8c63cc6eb770$var$fireUpdateLayoutProjection);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $74f0db85147db332$export$2e2bcd8739ae039).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $7358f47b8e0272c8$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $b2123e5233c590bc$export$cf3a7bd331c35bf0)(props);
        var isVariantNode = (0, $b2123e5233c590bc$export$c0eba02279c18fea)(props);
        var element = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */ path: parent ? (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(parent.path)), [
                parent
            ]) : [],
            layoutTree: parent ? parent.layoutTree : new (0, $fa2e3f540470bde3$export$1465d17e3de78a96)(),
            /**
             *
             */ presenceId: presenceId,
            projection: projection,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                parent === null || parent === void 0 || parent.children.add(element);
            },
            /**
             *
             */ unmount: function() {
                (0, $74f0db85147db332$export$d93e9c1fe0553512).update(update);
                (0, $74f0db85147db332$export$d93e9c1fe0553512).render(render);
                (0, $74f0db85147db332$export$d93e9c1fe0553512).preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */ scheduleUpdateLayoutProjection: parent ? parent.scheduleUpdateLayoutProjection : function() {
                return (0, $74f0db85147db332$export$2e2bcd8739ae039).preRender(element.updateTreeLayoutProjection, false, true);
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $ee79af719c41456d$export$ce8bdc721e76545f)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $7358f47b8e0272c8$export$605d60a2578142d3)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $74f0db85147db332$export$2e2bcd8739ae039).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $61834af08bd8ec0d$export$9a552858d5197f6e)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $ffcd8c63cc6eb770$var$numVariantProps; i++){
                    var name_1 = $ffcd8c63cc6eb770$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $b2123e5233c590bc$export$720b90e312cea233)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */ enableLayoutProjection: function() {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */ lockProjectionTarget: function() {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function() {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            },
            getLayoutState: function() {
                return layoutState;
            },
            setCrossfader: function(newCrossfader) {
                crossfader = newCrossfader;
            },
            isProjectionReady: function() {
                return projection.isEnabled && projection.isHydrated && layoutState.isHydrated;
            },
            /**
             * Start a layout animation on a given axis.
             */ startLayoutAnimation: function(axis, transition, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative ? projection.relativeTarget[axis] : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function(v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */ stopLayoutAnimation: function() {
                (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function(withTransform) {
                if (withTransform === void 0) withTransform = true;
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform) (0, $d81b9f898691502b$export$73e1ad0a9694e25c)(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */ getProjectionAnimationProgress: function() {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: (0, $ee79af719c41456d$export$ce8bdc721e76545f)(0),
                    y: (0, $ee79af719c41456d$export$ce8bdc721e76545f)(0)
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */ setProjectionTargetAxis: function(axis, min, max, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) projection.relativeTarget = (0, $1e15aa74128cf363$export$392205f483678b20)();
                    target = projection.relativeTarget[axis];
                } else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */ rebaseProjectionTarget: function(force, box) {
                if (box === void 0) box = layoutState.layout;
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget && !projection.isTargetLocked && !x.isAnimating() && !y.isAnimating();
                if (force || shouldRebase) (0, $9d58c79c2c7f2533$export$b789de563eb43b1)(function(axis) {
                    var _a = box[axis], min = _a.min, max = _a.max;
                    element.setProjectionTargetAxis(axis, min, max);
                });
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */ notifyLayoutReady: function(config) {
                (0, $fbd6ef1da58570bf$export$8a57a029e604f408)(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            },
            /**
             * Temporarily reset the transform of the instance.
             */ resetTransform: function() {
                return resetTransform(element, instance, props);
            },
            restoreTransform: function() {
                return restoreTransform(instance, renderState);
            },
            updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function() {
                element.layoutTree.forEach($ffcd8c63cc6eb770$var$fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */ (0, $74f0db85147db332$export$2e2bcd8739ae039).preRender(updateTreeLayoutProjection, false, true);
            // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function() {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for(var i = element.path.length - 1; i >= 0; i--){
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function() {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent) return;
                (0, $d4ec815e0250a6aa$export$426154f9d100f99)(projection, relativeParent.projection);
                if ((0, $ee272b6102c1c0f3$export$fe8f97248bbe2d04)(relativeParent)) {
                    var target = projection.target;
                    (0, $d81b9f898691502b$export$c8fdd2c80d7384dd)(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function() {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */ pointTo: function(newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */ unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = (0, $1febbb3d73d31607$export$a4627e546088548d)(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function() {
                    var _a;
                    if (element.isPresent) element.presence = (0, $1979636016632b46$export$99c2b779aa4e8b8b).Present;
                    else (_a = element.layoutSafeToRemove) === null || _a === void 0 || _a.call(element);
                }));
            },
            // TODO: Clean this up
            isPresent: true,
            presence: (0, $1979636016632b46$export$99c2b779aa4e8b8b).Entering
        });
        return element;
    };
};
function $ffcd8c63cc6eb770$var$fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function $ffcd8c63cc6eb770$var$fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var $ffcd8c63cc6eb770$var$variantProps = (0, $96998cfc8b9d4854$export$1216008129fb82ed)([
    "initial"
], (0, $96998cfc8b9d4854$export$8d051b38c9118094)((0, $b3135fc0bc745fa0$export$16e45afcc206d3a8)));
var $ffcd8c63cc6eb770$var$numVariantProps = $ffcd8c63cc6eb770$var$variantProps.length;













var $83ead0fe350c2e09$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $83ead0fe350c2e09$var$isPositionalKey = function(key) {
    return $83ead0fe350c2e09$var$positionalKeys.has(key);
};
var $83ead0fe350c2e09$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($83ead0fe350c2e09$var$isPositionalKey);
};
var $83ead0fe350c2e09$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $83ead0fe350c2e09$var$isNumOrPxType = function(v) {
    return v === (0, $f611823ce945608e$export$98e628dec113755e) || v === (0, $d4e2413af6dede3d$export$91c0eda1d06bf008);
};
var $83ead0fe350c2e09$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($83ead0fe350c2e09$export$d0c75e4fa9e69db8 || ($83ead0fe350c2e09$export$d0c75e4fa9e69db8 = {}));
var $83ead0fe350c2e09$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $83ead0fe350c2e09$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $83ead0fe350c2e09$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $83ead0fe350c2e09$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $83ead0fe350c2e09$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $83ead0fe350c2e09$var$nonTranslationalTransformKeys = (0, $bc91e92b6451f52c$export$7b42a0094fb00b6e).filter(function(key) {
    return !$83ead0fe350c2e09$var$transformKeys.has(key);
});
function $83ead0fe350c2e09$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $83ead0fe350c2e09$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $83ead0fe350c2e09$var$positionalValues = {
    // Dimensions
    width: function(_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function(_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $83ead0fe350c2e09$var$getTranslateFromMatrix(4, 13),
    y: $83ead0fe350c2e09$var$getTranslateFromMatrix(5, 14)
};
var $83ead0fe350c2e09$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        transform: transform
    };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $83ead0fe350c2e09$var$setAndResetVelocity(value, $83ead0fe350c2e09$var$positionalValues[key](originBbox, originComputedStyle));
        target[key] = $83ead0fe350c2e09$var$positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $83ead0fe350c2e09$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, target);
    transitionEnd = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($83ead0fe350c2e09$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0, $94548fa0567ba129$export$eefdd52e3ccae428)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $04dc632a61d0368f$export$9153ad4c4999f4a0)(to)) {
            var numKeyframes = to.length;
            for(var i = to[0] === null ? 1 : 0; i < numKeyframes; i++)if (!toType) {
                toType = (0, $94548fa0567ba129$export$eefdd52e3ccae428)(to[i]);
                (0, $5f54a675503b9e5d$export$f5708dca728d7177)(toType === fromType || $83ead0fe350c2e09$var$isNumOrPxType(fromType) && $83ead0fe350c2e09$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $5f54a675503b9e5d$export$f5708dca728d7177)((0, $94548fa0567ba129$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $94548fa0567ba129$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($83ead0fe350c2e09$var$isNumOrPxType(fromType) && $83ead0fe350c2e09$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $d4e2413af6dede3d$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $83ead0fe350c2e09$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $83ead0fe350c2e09$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = $83ead0fe350c2e09$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $83ead0fe350c2e09$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $83ead0fe350c2e09$var$hasPositionalKey(target) ? $83ead0fe350c2e09$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $3a595bc608a843fd$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $ea3588f715dd8571$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $83ead0fe350c2e09$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







function $1c19de9aabf5cf1b$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $1c19de9aabf5cf1b$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $bc91e92b6451f52c$export$15240a8a4379d8de)(key)) {
            var defaultType = (0, $8014879745292743$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $1c19de9aabf5cf1b$export$3735103072e4a80(domElement);
            return ((0, $baaa023ea5470eff$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $17de0af38d0ff3fd$export$895c5e634403eaa7)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $32afa7c939dcc12a$export$5a759dc7a1cfb72a)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $32afa7c939dcc12a$export$6afbed164019a54c)(element, target, origin);
            var parsed = (0, $3a595bc608a843fd$export$5849e743e29831d6)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $4d0083cb4e71e15c$export$16da615486abaa45),
    build: function(element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $80ed0788f6376c99$export$bb517f8b40f8e99d)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $1dd5ea6d0ac163b1$export$d842ebfa32edc648) : undefined, isProjectionTranform ? (0, $1dd5ea6d0ac163b1$export$9df601cd9cfcf364) : undefined);
    },
    render: (0, $bb55b4b0603e9d04$export$1a32bf6229c258c0)
};
var $1c19de9aabf5cf1b$export$9509f7c142585e92 = (0, $ffcd8c63cc6eb770$export$5ad594e944c33d76)($1c19de9aabf5cf1b$export$985b1494d4aeee90);













var $cce8e6f62133698f$export$3ba8992de7b705bc = (0, $ffcd8c63cc6eb770$export$5ad594e944c33d76)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $1c19de9aabf5cf1b$export$985b1494d4aeee90)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $bc91e92b6451f52c$export$15240a8a4379d8de)(key)) return ((_a = (0, $8014879745292743$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $f756084cb8de12a0$export$28931db5d57958e5).has(key) ? (0, $63a301c0f4eea2a8$export$9fd24a634729c672)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $83cec102475aad91$export$16da615486abaa45),
    build: function(_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $e62e83fc79d9051e$export$5475d24f125d7053)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $1dd5ea6d0ac163b1$export$d842ebfa32edc648) : undefined, isProjectionTranform ? (0, $1dd5ea6d0ac163b1$export$9df601cd9cfcf364) : undefined);
    },
    render: (0, $09b50fcfd6e137c5$export$c5f8399d19a7394b)
}));



var $878ef3214e71c400$export$56ba0183203348f5 = function(Component, options) {
    return (0, $b8e4e4448b37037b$export$88f3fc2fd3766989)(Component) ? (0, $cce8e6f62133698f$export$3ba8992de7b705bc)(options, {
        enableHardwareAcceleration: false
    }) : (0, $1c19de9aabf5cf1b$export$9509f7c142585e92)(options, {
        enableHardwareAcceleration: true
    });
};


var $92af15db400e8627$var$featureBundle = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, (0, $2e344faed2e5a38b$export$7f9953c70dacfd7f)), (0, $6def5b5b2f5fc91d$export$e5b72898e5a201f1)), (0, $88e24ec07f94cafb$export$d7d5d435647ed5a0)), (0, $e5939cd8feec1e26$export$eb704cf7366aa18a));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $92af15db400e8627$export$e25e478948902b8b = /*@__PURE__*/ (0, $cdcb503cea3dca64$export$a28d6df673050e18)(function(Component, config) {
    return (0, $c621e42f39a17382$export$732916c0e88175fb)(Component, config, $92af15db400e8627$var$featureBundle, (0, $878ef3214e71c400$export$56ba0183203348f5));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $92af15db400e8627$export$546614c4a05701f9(key) {
    return (0, $cc56b1e8556a5233$export$46b7e4b9dc6110c3)((0, $c621e42f39a17382$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $92af15db400e8627$var$featureBundle, (0, $878ef3214e71c400$export$56ba0183203348f5)));
}



var $denZA = parcelRequire("denZA");

function $211c36bc7cb0eba9$var$_extends() {
    $211c36bc7cb0eba9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $211c36bc7cb0eba9$var$_extends.apply(this, arguments);
}
var $211c36bc7cb0eba9$export$f5b6cb31aedd80b0 = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
var $211c36bc7cb0eba9$export$af37b65475548421 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0
        },
        exit: {
            x: "-100%"
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0
        },
        exit: {
            x: "100%"
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            y: 0
        },
        exit: {
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            y: 0
        },
        exit: {
            y: "100%"
        }
    }
};
function $211c36bc7cb0eba9$export$938a85570760a707(options) {
    var _options$direction;
    var side = (_options$direction = options == null ? void 0 : options.direction) != null ? _options$direction : "right";
    switch(side){
        case "right":
            return $211c36bc7cb0eba9$export$af37b65475548421.slideRight;
        case "left":
            return $211c36bc7cb0eba9$export$af37b65475548421.slideLeft;
        case "bottom":
            return $211c36bc7cb0eba9$export$af37b65475548421.slideDown;
        case "top":
            return $211c36bc7cb0eba9$export$af37b65475548421.slideUp;
        default:
            return $211c36bc7cb0eba9$export$af37b65475548421.slideRight;
    }
}
var $211c36bc7cb0eba9$export$77d40b8ffce6f841 = {
    enter: {
        duration: 0.2,
        ease: $211c36bc7cb0eba9$export$f5b6cb31aedd80b0.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $211c36bc7cb0eba9$export$f5b6cb31aedd80b0.easeIn
    }
};
var $211c36bc7cb0eba9$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>$211c36bc7cb0eba9$var$_extends({}, transition, {
            delay: (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(delay) ? delay : delay == null ? void 0 : delay["enter"]
        }),
    exit: (transition, delay)=>$211c36bc7cb0eba9$var$_extends({}, transition, {
            delay: (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(delay) ? delay : delay == null ? void 0 : delay["exit"]
        })
};


function $c93b6b1a78aaf16c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c93b6b1a78aaf16c$var$_extends() {
    $c93b6b1a78aaf16c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c93b6b1a78aaf16c$var$_extends.apply(this, arguments);
}
var $c93b6b1a78aaf16c$var$isNumeric = (value)=>value != null && parseInt(value.toString(), 10) > 0;
var $c93b6b1a78aaf16c$var$defaultTransitions = {
    exit: {
        height: {
            duration: 0.2,
            ease: (0, $211c36bc7cb0eba9$export$f5b6cb31aedd80b0).ease
        },
        opacity: {
            duration: 0.3,
            ease: (0, $211c36bc7cb0eba9$export$f5b6cb31aedd80b0).ease
        }
    },
    enter: {
        height: {
            duration: 0.3,
            ease: (0, $211c36bc7cb0eba9$export$f5b6cb31aedd80b0).ease
        },
        opacity: {
            duration: 0.4,
            ease: (0, $211c36bc7cb0eba9$export$f5b6cb31aedd80b0).ease
        }
    }
};
var $c93b6b1a78aaf16c$var$variants = {
    exit: (_ref)=>{
        var _transition$exit;
        var { animateOpacity: animateOpacity, startingHeight: startingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref;
        return $c93b6b1a78aaf16c$var$_extends({}, animateOpacity && {
            opacity: $c93b6b1a78aaf16c$var$isNumeric(startingHeight) ? 1 : 0
        }, {
            overflow: "hidden",
            height: startingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
            transition: (_transition$exit = transition == null ? void 0 : transition.exit) != null ? _transition$exit : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit($c93b6b1a78aaf16c$var$defaultTransitions.exit, delay)
        });
    },
    enter: (_ref2)=>{
        var _transition$enter;
        var { animateOpacity: animateOpacity, endingHeight: endingHeight, transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref2;
        return $c93b6b1a78aaf16c$var$_extends({}, animateOpacity && {
            opacity: 1
        }, {
            height: endingHeight,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
            transition: (_transition$enter = transition == null ? void 0 : transition.enter) != null ? _transition$enter : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).enter($c93b6b1a78aaf16c$var$defaultTransitions.enter, delay)
        });
    }
};
var $c93b6b1a78aaf16c$export$78768a9af065a7b = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { in: isOpen, unmountOnExit: unmountOnExit, animateOpacity: animateOpacity = true, startingHeight: startingHeight = 0, endingHeight: endingHeight = "auto", style: style, className: className, transition: transition, transitionEnd: transitionEnd } = props, rest = $c93b6b1a78aaf16c$var$_objectWithoutPropertiesLoose(props, [
        "in",
        "unmountOnExit",
        "animateOpacity",
        "startingHeight",
        "endingHeight",
        "style",
        "className",
        "transition",
        "transitionEnd"
    ]);
    var [mounted, setMounted] = $denZA.useState(false);
    $denZA.useEffect(()=>{
        var timeout = setTimeout(()=>{
            setMounted(true);
        });
        return ()=>clearTimeout(timeout);
    }, []);
    /**
   * Warn 🚨: `startingHeight` and `unmountOnExit` are mutually exclusive
   *
   * If you specify a starting height, the collapsed needs to be mounted
   * for the height to take effect.
   */ (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: Boolean(startingHeight > 0 && unmountOnExit),
        message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    var hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
    var custom = {
        startingHeight: startingHeight,
        endingHeight: endingHeight,
        animateOpacity: animateOpacity,
        transition: !mounted ? {
            enter: {
                duration: 0
            }
        } : transition,
        transitionEnd: (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(transitionEnd, {
            enter: {
                overflow: "initial"
            },
            exit: unmountOnExit ? undefined : {
                display: hasStartingHeight ? "block" : "none"
            }
        })
    };
    var show = unmountOnExit ? isOpen : true;
    var animate = isOpen || unmountOnExit ? "enter" : "exit";
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        initial: false,
        custom: custom
    }, show && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, $c93b6b1a78aaf16c$var$_extends({
        ref: ref
    }, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-collapse", className),
        style: $c93b6b1a78aaf16c$var$_extends({
            overflow: "hidden",
            display: "block"
        }, style),
        custom: custom,
        variants: $c93b6b1a78aaf16c$var$variants,
        initial: unmountOnExit ? "exit" : false,
        animate: animate,
        exit: "exit"
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c93b6b1a78aaf16c$export$78768a9af065a7b.displayName = "Collapse";





var $denZA = parcelRequire("denZA");


var $e5Q7j = parcelRequire("e5Q7j");

function $97104681d23a9855$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $97104681d23a9855$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $97104681d23a9855$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $97104681d23a9855$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $97104681d23a9855$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $97104681d23a9855$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $97104681d23a9855$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, idx) {
        return idx !== index;
    });
}
function $97104681d23a9855$export$fb9705de59d96855(array, item) {
    return [].concat(array, [
        item
    ]);
}
function $97104681d23a9855$export$fe2d9b4e03920b4c(array, item) {
    return array.filter(function(eachItem) {
        return eachItem !== item;
    });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */ function $97104681d23a9855$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */ function $97104681d23a9855$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $97104681d23a9855$export$c42e0e80904d519(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */ function $97104681d23a9855$export$5f7ec48d69707ddd(array, size) {
    return array.reduce(function(rows, currentValue, index) {
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */ function $97104681d23a9855$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find(function(item) {
            return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
        });
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter(function(item) {
        return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    }); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}
// Number assertions
function $97104681d23a9855$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $97104681d23a9855$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $97104681d23a9855$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $97104681d23a9855$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $97104681d23a9855$export$4c0262a4f954db45(value) {
    return $97104681d23a9855$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $97104681d23a9855$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $97104681d23a9855$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $97104681d23a9855$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $97104681d23a9855$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$97104681d23a9855$export$43bee75e5e14138e(value);
}
function $97104681d23a9855$export$83b788b1a3698c03(value) {
    return $97104681d23a9855$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $97104681d23a9855$export$e0287cc73292b477(value) {
    return value && !$97104681d23a9855$export$83b788b1a3698c03(value);
}
function $97104681d23a9855$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $97104681d23a9855$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $97104681d23a9855$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $97104681d23a9855$export$dd1bc94b04021eeb(value) {
    if ($97104681d23a9855$export$43bee75e5e14138e(value)) return $97104681d23a9855$export$4c0262a4f954db45(value);
    if ($97104681d23a9855$export$a6cdc56e425d0d0a(value)) return $97104681d23a9855$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $97104681d23a9855$export$a866f231438cc228 = false;
var $97104681d23a9855$export$61cb32cff9a99948 = false;
function $97104681d23a9855$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $97104681d23a9855$export$4215e022093e324e(value) {
    return value && $97104681d23a9855$export$a6cdc56e425d0d0a(value) && $97104681d23a9855$export$a6cdc56e425d0d0a(value.target);
}
function $97104681d23a9855$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $97104681d23a9855$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach(function(key) {
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $97104681d23a9855$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */ function $97104681d23a9855$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $97104681d23a9855$export$fc10aeed3a532e2a = function memoize(fn) {
    var cache = new WeakMap();
    var memoizedFn = function memoizedFn(obj, path, fallback, index) {
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $97104681d23a9855$export$1bb32d0c65da6059 = $97104681d23a9855$export$fc10aeed3a532e2a($97104681d23a9855$export$3988ae62b71be9a3);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */ function $97104681d23a9855$export$73b8ef55a37133c7(path, scale) {
    return $97104681d23a9855$export$1bb32d0c65da6059(scale, path, path);
}
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */ function $97104681d23a9855$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $97104681d23a9855$export$2458ce75c8ef9806 = function filterUndefined(object) {
    return $97104681d23a9855$export$3417cf6417437960(object, function(val) {
        return val !== null && val !== undefined;
    });
};
var $97104681d23a9855$export$259b4dd69e654a7a = function objectKeys(obj) {
    return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */ var $97104681d23a9855$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(carry, _ref) {
        var key = _ref[0], value = _ref[1];
        carry[key] = value;
        return carry;
    }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */ var $97104681d23a9855$export$93c8e06b7014dc33 = function getCSSVar(theme, scale, value) {
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};
function $97104681d23a9855$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $97104681d23a9855$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var _analyzeCSSValue = $97104681d23a9855$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
    return unitless || $97104681d23a9855$export$7e4aa119212bc614(value) ? value + "px" : value;
}
var $97104681d23a9855$var$sortByBreakpointValue = function sortByBreakpointValue(a, b) {
    return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var $97104681d23a9855$var$sortBps = function sortBps(breakpoints) {
    return $97104681d23a9855$export$5150077fc2e7c662(Object.entries(breakpoints).sort($97104681d23a9855$var$sortByBreakpointValue));
};
function $97104681d23a9855$var$normalize(breakpoints) {
    var sorted = $97104681d23a9855$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $97104681d23a9855$var$keys(breakpoints) {
    var value = Object.keys($97104681d23a9855$var$sortBps(breakpoints));
    return new Set(value);
}
function $97104681d23a9855$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $97104681d23a9855$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return $97104681d23a9855$export$7e4aa119212bc614(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function(m) {
        return "" + (parseFloat(m) + factor);
    });
}
function $97104681d23a9855$var$queryString(min, max) {
    var query = [
        "@media screen"
    ];
    if (min) query.push("and", "(min-width: " + $97104681d23a9855$export$91c0eda1d06bf008(min) + ")");
    if (max) query.push("and", "(max-width: " + $97104681d23a9855$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $97104681d23a9855$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $97104681d23a9855$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($97104681d23a9855$var$sortByBreakpointValue).map(function(_ref, index, entry) {
        var _entry;
        var breakpoint = _ref[0], minW = _ref[1];
        var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [], maxW = _ref2[1];
        maxW = parseFloat(maxW) > 0 ? $97104681d23a9855$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $97104681d23a9855$var$queryString(null, maxW),
            minWQuery: $97104681d23a9855$var$queryString(minW),
            minMaxQuery: $97104681d23a9855$var$queryString(minW, maxW)
        };
    });
    var _keys = $97104681d23a9855$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive: function isResponsive(test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every(function(key) {
                return _keys.has(key);
            });
        },
        asObject: $97104681d23a9855$var$sortBps(breakpoints),
        asArray: $97104681d23a9855$var$normalize(breakpoints),
        details: queries,
        media: [
            null
        ].concat(normalized.map(function(minW) {
            return $97104681d23a9855$var$queryString(minW);
        }).slice(1)),
        toArrayValue: function toArrayValue(test) {
            if (!$97104681d23a9855$export$a6cdc56e425d0d0a(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map(function(bp) {
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while($97104681d23a9855$export$7475b2c64539e4cf(result) === null)result.pop();
            return result;
        },
        toObjectValue: function toObjectValue(test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce(function(acc, value, index) {
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
function $97104681d23a9855$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $97104681d23a9855$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$97104681d23a9855$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $97104681d23a9855$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $97104681d23a9855$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $97104681d23a9855$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $97104681d23a9855$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $97104681d23a9855$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $97104681d23a9855$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $97104681d23a9855$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $97104681d23a9855$export$4e09c449d6c407f7 = $97104681d23a9855$export$71594e8a50f746f4();
var $97104681d23a9855$export$5cc3b7b83e34ade7 = function dataAttr(condition) {
    return condition ? "" : undefined;
};
var $97104681d23a9855$export$91a6105db3d4be7b = function ariaAttr(condition) {
    return condition ? true : undefined;
};
var $97104681d23a9855$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $97104681d23a9855$export$cd4e5573fbe2b576(node) {
    var doc = $97104681d23a9855$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $97104681d23a9855$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $97104681d23a9855$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */ function $97104681d23a9855$export$17948c8429b9b73a(event) {
    var key = event.key, keyCode = event.keyCode;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $97104681d23a9855$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $97104681d23a9855$export$cd4e5573fbe2b576(target);
    return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function $97104681d23a9855$export$189689d1febf0166(event) {
    return event.button !== 0;
}
// Really great work done by Diego Haz on this one
var $97104681d23a9855$export$f5f22eac728522fd = function hasDisplayNone(element) {
    return window.getComputedStyle(element).display === "none";
};
var $97104681d23a9855$export$54209d29bacd2cb9 = function hasTabIndex(element) {
    return element.hasAttribute("tabindex");
};
var $97104681d23a9855$export$87df0ed37d24dd13 = function hasNegativeTabIndex(element) {
    return $97104681d23a9855$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
};
function $97104681d23a9855$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $97104681d23a9855$export$63ed1d20cf8213cf(element) {
    return $97104681d23a9855$export$1b3bfaa9684536aa(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $97104681d23a9855$export$8a2eb51c14bb8899(element) {
    var doc = $97104681d23a9855$export$1b3bfaa9684536aa(element) ? $97104681d23a9855$export$b204af158042fbac(element) : document;
    return doc.activeElement === element;
}
function $97104681d23a9855$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $97104681d23a9855$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $97104681d23a9855$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $97104681d23a9855$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $97104681d23a9855$export$4c063cf1350e6fed(element) {
    if (!$97104681d23a9855$export$1b3bfaa9684536aa(element) || $97104681d23a9855$export$ee695c13482bb5dd(element) || $97104681d23a9855$export$30e0dc115df457ed(element)) return false;
    var localName = element.localName;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: function a() {
            return element.hasAttribute("href");
        },
        audio: function audio() {
            return element.hasAttribute("controls");
        },
        video: function video() {
            return element.hasAttribute("controls");
        }
    };
    if (localName in others) return others[localName]();
    if ($97104681d23a9855$export$3453cc819780f652(element)) return true;
    return $97104681d23a9855$export$54209d29bacd2cb9(element);
}
function $97104681d23a9855$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return $97104681d23a9855$export$1b3bfaa9684536aa(element) && $97104681d23a9855$export$4c063cf1350e6fed(element) && !$97104681d23a9855$export$87df0ed37d24dd13(element);
}
var $97104681d23a9855$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $97104681d23a9855$var$focusableElSelector = $97104681d23a9855$var$focusableElList.join();
function $97104681d23a9855$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($97104681d23a9855$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter($97104681d23a9855$export$4c063cf1350e6fed).filter(function(el) {
        return window.getComputedStyle(el).display !== "none";
    });
}
function $97104681d23a9855$export$748138f04a69bf21(container) {
    var allFocusable = $97104681d23a9855$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $97104681d23a9855$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($97104681d23a9855$var$focusableElSelector));
    var allTabbable = allFocusable.filter($97104681d23a9855$export$bebd5a1431fec25d);
    if ($97104681d23a9855$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $97104681d23a9855$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbable = $97104681d23a9855$export$f9ba66356f7359cf(container, fallbackToFocusable), first = _getAllTabbable[0];
    return first || null;
}
function $97104681d23a9855$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $97104681d23a9855$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $97104681d23a9855$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $97104681d23a9855$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($97104681d23a9855$export$bebd5a1431fec25d) || allFocusable.find($97104681d23a9855$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $97104681d23a9855$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $97104681d23a9855$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($97104681d23a9855$export$bebd5a1431fec25d) || allFocusable.find($97104681d23a9855$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $97104681d23a9855$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $97104681d23a9855$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && $97104681d23a9855$export$1b3bfaa9684536aa(nextTabbable)) nextTabbable.focus();
}
function $97104681d23a9855$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $97104681d23a9855$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && $97104681d23a9855$export$1b3bfaa9684536aa(previousTabbable)) previousTabbable.focus();
}
function $97104681d23a9855$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $97104681d23a9855$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($97104681d23a9855$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}
function $97104681d23a9855$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $97104681d23a9855$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $97104681d23a9855$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $97104681d23a9855$var$_arrayLikeToArray(o, minLen);
}
function $97104681d23a9855$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $97104681d23a9855$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable no-nested-ternary */ function $97104681d23a9855$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $97104681d23a9855$export$f6e2535fb5126e54(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function $97104681d23a9855$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some(function(fn) {
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $97104681d23a9855$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach(function(fn) {
            fn == null || fn(arg);
        });
    };
}
var $97104681d23a9855$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce(function(f1, f2) {
        return function() {
            return f1(f2.apply(void 0, arguments));
        };
    }, fn1);
};
function $97104681d23a9855$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $97104681d23a9855$export$8793edee2d425525 = function noop() {};
var $97104681d23a9855$export$c106dd0671a0fc2d = $97104681d23a9855$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $97104681d23a9855$export$a866f231438cc228) console.warn(message);
    };
});
var $97104681d23a9855$export$a3bc9b8ed74fc = $97104681d23a9855$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $97104681d23a9855$export$a866f231438cc228) console.error(message);
    };
});
var $97104681d23a9855$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return function(v) {
        return fns.reduce(function(a, b) {
            return b(a);
        }, v);
    };
};
var $97104681d23a9855$var$distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
};
var $97104681d23a9855$var$isPoint = function isPoint(point) {
    return "x" in point && "y" in point;
};
function $97104681d23a9855$export$9f17032d917177de(a, b) {
    if ($97104681d23a9855$export$7e4aa119212bc614(a) && $97104681d23a9855$export$7e4aa119212bc614(b)) return $97104681d23a9855$var$distance1D(a, b);
    if ($97104681d23a9855$var$isPoint(a) && $97104681d23a9855$var$isPoint(b)) {
        var xDelta = $97104681d23a9855$var$distance1D(a.x, b.x);
        var yDelta = $97104681d23a9855$var$distance1D(a.y, b.y);
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
    }
    return 0;
}
function $97104681d23a9855$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var _options = options, _options$isActive = _options.isActive, isActive = _options$isActive === void 0 ? $97104681d23a9855$export$8a2eb51c14bb8899 : _options$isActive, nextTick = _options.nextTick, _options$preventScrol = _options.preventScroll, preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol, _options$selectTextIf = _options.selectTextIfInput, selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            $97104681d23a9855$export$c106dd0671a0fc2d({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($97104681d23a9855$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $97104681d23a9855$var$getScrollableElements(element);
                $97104681d23a9855$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ($97104681d23a9855$export$63ed1d20cf8213cf(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $97104681d23a9855$var$supportsPreventScrollCached = null;
function $97104681d23a9855$var$supportsPreventScroll() {
    if ($97104681d23a9855$var$supportsPreventScrollCached == null) {
        $97104681d23a9855$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $97104681d23a9855$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $97104681d23a9855$var$supportsPreventScrollCached;
}
function $97104681d23a9855$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = $97104681d23a9855$export$b204af158042fbac(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $97104681d23a9855$var$restoreScrollPosition(scrollableElements) {
    for(var _iterator = $97104681d23a9855$var$_createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, element = _step$value.element, scrollTop = _step$value.scrollTop, scrollLeft = _step$value.scrollLeft;
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $97104681d23a9855$export$bffa455ba8c619a6(target, maxDepth) {
    if (maxDepth === void 0) maxDepth = Infinity;
    if (!$97104681d23a9855$export$a6cdc56e425d0d0a(target) && !Array.isArray(target) || !maxDepth) return target;
    return Object.entries(target).reduce(function(result, _ref) {
        var key = _ref[0], value = _ref[1];
        if ($97104681d23a9855$export$a6cdc56e425d0d0a(value) || $97104681d23a9855$export$43bee75e5e14138e(value)) Object.entries($97104681d23a9855$export$bffa455ba8c619a6(value, maxDepth - 1)).forEach(function(_ref2) {
            var childKey = _ref2[0], childValue = _ref2[1];
            // e.g. gray.500
            result[key + "." + childKey] = childValue;
        });
        else // e.g. transparent
        result[key] = value;
        return result;
    }, {});
}
/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $97104681d23a9855$export$1f16c1e83f5de19d(options) {
    var hasBeenSelected = options.hasBeenSelected, isLazy = options.isLazy, isSelected = options.isSelected, _options$lazyBehavior = options.lazyBehavior, lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}
var $97104681d23a9855$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $97104681d23a9855$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $97104681d23a9855$var$toNumber(value) {
    var num = parseFloat(value);
    return $97104681d23a9855$export$3f283ac14831e759(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */ function $97104681d23a9855$export$3e91a10e66078270(value, precision) {
    var nextValue = $97104681d23a9855$var$toNumber(value);
    var scaleFactor = Math.pow(10, precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */ function $97104681d23a9855$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */ function $97104681d23a9855$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */ function $97104681d23a9855$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */ function $97104681d23a9855$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $97104681d23a9855$export$a42544f265f8403(step);
    return $97104681d23a9855$export$3e91a10e66078270(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */ function $97104681d23a9855$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    $97104681d23a9855$export$c106dd0671a0fc2d({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}
function $97104681d23a9855$var$_extends() {
    $97104681d23a9855$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97104681d23a9855$var$_extends.apply(this, arguments);
}
/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ function $97104681d23a9855$export$764db16956f554f8(event) {
    var win = $97104681d23a9855$export$8d16348623687f6(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $97104681d23a9855$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $97104681d23a9855$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var win = $97104681d23a9855$export$8d16348623687f6(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $97104681d23a9855$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $97104681d23a9855$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $97104681d23a9855$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $97104681d23a9855$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $97104681d23a9855$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $97104681d23a9855$export$c4dfce035d43d1e0(event) ? $97104681d23a9855$var$pointFromTouch(event, pointType) : $97104681d23a9855$var$pointFromMouse(event, pointType)
    };
}
function $97104681d23a9855$export$750e59ed656e0503(event) {
    return $97104681d23a9855$export$12f84bb882d06e1a(event, "client");
}
var $97104681d23a9855$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function listener(event) {
        return handler(event, $97104681d23a9855$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $97104681d23a9855$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $97104681d23a9855$var$supportsPointerEvents = function supportsPointerEvents() {
    return $97104681d23a9855$export$4e09c449d6c407f7 && window.onpointerdown === null;
};
var $97104681d23a9855$var$supportsTouchEvents = function supportsTouchEvents() {
    return $97104681d23a9855$export$4e09c449d6c407f7 && window.ontouchstart === null;
};
var $97104681d23a9855$var$supportsMouseEvents = function supportsMouseEvents() {
    return $97104681d23a9855$export$4e09c449d6c407f7 && window.onmousedown === null;
};
var $97104681d23a9855$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $97104681d23a9855$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $97104681d23a9855$export$9fd5832907e02451(name) {
    if ($97104681d23a9855$var$supportsPointerEvents()) return name;
    if ($97104681d23a9855$var$supportsTouchEvents()) return $97104681d23a9855$var$touchEventNames[name];
    if ($97104681d23a9855$var$supportsMouseEvents()) return $97104681d23a9855$var$mouseEventNames[name];
    return name;
}
function $97104681d23a9855$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return $97104681d23a9855$export$b1d829ddf82884aa(target, $97104681d23a9855$export$9fd5832907e02451(eventName), $97104681d23a9855$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $97104681d23a9855$export$d06464d6b74eedc4(event) {
    return $97104681d23a9855$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */ /**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */ var $97104681d23a9855$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ function PanSession(_event, handlers, threshold) {
        var _this = this;
        this.history = [];
        this.startEvent = null;
        this.lastEvent = null;
        this.lastEventInfo = null;
        this.handlers = {};
        this.removeListeners = $97104681d23a9855$export$8793edee2d425525;
        this.threshold = 3;
        this.win = void 0;
        this.updatePoint = function() {
            if (!(_this.lastEvent && _this.lastEventInfo)) return;
            var info = $97104681d23a9855$var$getPanInfo(_this.lastEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = $97104681d23a9855$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= _this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var _getFrameData = (0, $74f0db85147db332$export$7244445918e670ed)(), timestamp = _getFrameData.timestamp;
            _this.history.push($97104681d23a9855$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var _this$handlers = _this.handlers, onStart = _this$handlers.onStart, onMove = _this$handlers.onMove;
            if (!isPanStarted) {
                onStart == null || onStart(_this.lastEvent, info);
                _this.startEvent = _this.lastEvent;
            }
            onMove == null || onMove(_this.lastEvent, info);
        };
        this.onPointerMove = function(event, info) {
            _this.lastEvent = event;
            _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ($97104681d23a9855$export$764db16956f554f8(event) && event.buttons === 0) {
                _this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.onPointerUp = function(event, info) {
            // notify pan session ended
            var panInfo = $97104681d23a9855$var$getPanInfo(info, _this.history);
            var _this$handlers2 = _this.handlers, onEnd = _this$handlers2.onEnd, onSessionEnd = _this$handlers2.onSessionEnd;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            _this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !_this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        };
        this.win = $97104681d23a9855$export$8d16348623687f6(_event); // If we have more than one touch, don't start detecting this gesture
        if ($97104681d23a9855$export$d06464d6b74eedc4(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = $97104681d23a9855$export$12f84bb882d06e1a(_event);
        var _getFrameData2 = (0, $74f0db85147db332$export$7244445918e670ed)(), _timestamp = _getFrameData2.timestamp;
        this.history = [
            $97104681d23a9855$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var onSessionStart = handlers.onSessionStart;
        onSessionStart == null || onSessionStart(_event, $97104681d23a9855$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = $97104681d23a9855$export$a4627e546088548d($97104681d23a9855$export$fcff2e64e6676b81(this.win, "pointermove", this.onPointerMove), $97104681d23a9855$export$fcff2e64e6676b81(this.win, "pointerup", this.onPointerUp), $97104681d23a9855$export$fcff2e64e6676b81(this.win, "pointercancel", this.onPointerUp));
    }
    var _proto = PanSession.prototype;
    _proto.updateHandlers = function updateHandlers(handlers) {
        this.handlers = handlers;
    };
    _proto.end = function end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $97104681d23a9855$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $97104681d23a9855$var$startPanPoint(history) {
    return history[0];
}
function $97104681d23a9855$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $97104681d23a9855$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $97104681d23a9855$var$subtractPoint(info.point, $97104681d23a9855$var$lastPanPoint(history)),
        offset: $97104681d23a9855$var$subtractPoint(info.point, $97104681d23a9855$var$startPanPoint(history)),
        velocity: $97104681d23a9855$var$getVelocity(history, 0.1)
    };
}
function $97104681d23a9855$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $97104681d23a9855$var$toMilliseconds = function toMilliseconds(seconds) {
    return seconds * 1000;
};
function $97104681d23a9855$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $97104681d23a9855$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $97104681d23a9855$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
var $97104681d23a9855$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $97104681d23a9855$export$eca1915781c2aaca(prop, mapper) {
    if ($97104681d23a9855$export$43bee75e5e14138e(prop)) return prop.map(function(item) {
        if (item === null) return null;
        return mapper(item);
    });
    if ($97104681d23a9855$export$a6cdc56e425d0d0a(prop)) return $97104681d23a9855$export$259b4dd69e654a7a(prop).reduce(function(result, key) {
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $97104681d23a9855$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $97104681d23a9855$export$d07517a676ce386f;
    var result = bps.map(function(br) {
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while($97104681d23a9855$export$7475b2c64539e4cf(result) === null)result.pop();
    return result;
}
function $97104681d23a9855$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $97104681d23a9855$export$d07517a676ce386f;
    var result = {};
    values.forEach(function(value, index) {
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $97104681d23a9855$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $97104681d23a9855$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every(function(key) {
        return bps.includes(key);
    });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */ var $97104681d23a9855$export$4cdfc817e07de39e = function isCustomBreakpoint(maybeBreakpoint) {
    return Number.isNaN(Number(maybeBreakpoint));
};
function $97104681d23a9855$var$getUserAgentBrowser(navigator) {
    var ua = navigator.userAgent, vendor = navigator.vendor;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $97104681d23a9855$var$getUserAgentOS(navigator) {
    var ua = navigator.userAgent, platform = navigator.platform;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $97104681d23a9855$export$568a7d21694b4b32(navigator) {
    var ua = navigator.userAgent;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $97104681d23a9855$export$3070bd282ec37ea8(os) {
    if (!$97104681d23a9855$export$4e09c449d6c407f7) return false;
    return $97104681d23a9855$var$getUserAgentOS(window.navigator) === os;
}
function $97104681d23a9855$export$2d31490a0c05f094(browser) {
    if (!$97104681d23a9855$export$4e09c449d6c407f7) return false;
    return $97104681d23a9855$var$getUserAgentBrowser(window.navigator) === browser;
}
function $97104681d23a9855$export$8d04c8cf4d9e22d8() {
    if (!$97104681d23a9855$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $97104681d23a9855$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ($97104681d23a9855$export$43bee75e5e14138e(value)) return value.map(function(item, index) {
            return inner(item, [].concat(path, [
                String(index)
            ]));
        });
        if ($97104681d23a9855$export$a6cdc56e425d0d0a(value)) return $97104681d23a9855$export$5150077fc2e7c662(Object.entries(value).map(function(_ref) {
            var key = _ref[0], child = _ref[1];
            return [
                key,
                inner(child, [].concat(path, [
                    key
                ]))
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}



var $denZA = parcelRequire("denZA");
/**
 * Assigns a value to a ref function or object
 *
 * @param ref the ref to assign to
 * @param value the value
 */ function $f1f14ed33f74b8fd$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $97104681d23a9855$export$f6e2535fb5126e54)(ref)) {
        ref(value);
        return;
    }
    try {
        // @ts-ignore
        ref.current = value;
    } catch (error) {
        throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
    }
}
/**
 * Combine multiple React refs into a single ref function.
 * This is used mostly when you need to allow consumers forward refs to
 * internal components
 *
 * @param refs refs to assign to value to
 */ function $f1f14ed33f74b8fd$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return function(node) {
        refs.forEach(function(ref) {
            return $f1f14ed33f74b8fd$export$d734136a7b018efe(ref, node);
        });
    };
}
/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */ function $f1f14ed33f74b8fd$export$fd42f52fd3ae1109(options) {
    if (options === void 0) options = {};
    var _options = options, _options$strict = _options.strict, strict = _options$strict === void 0 ? true : _options$strict, _options$errorMessage = _options.errorMessage, errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage, name = _options.name;
    var Context = /*#__PURE__*/ $denZA.createContext(undefined);
    Context.displayName = name;
    function useContext() {
        var context = $denZA.useContext(Context);
        if (!context && strict) {
            var error = new Error(errorMessage);
            error.name = "ContextError";
            Error.captureStackTrace == null || Error.captureStackTrace(error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */ function $f1f14ed33f74b8fd$export$b2c43d7d050b2e63(children) {
    return $denZA.Children.toArray(children).filter(function(child) {
        return /*#__PURE__*/ $denZA.isValidElement(child);
    });
}



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
function $495690303bb1d853$export$96d07f33920abf3e(nodes) {
    return nodes.sort((a, b)=>{
        var compare = a.compareDocumentPosition(b);
        if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) // a < b
        return -1;
        if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) // a > b
        return 1;
        if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) throw Error("Cannot sort the given nodes.");
        else return 0;
    });
}
var $495690303bb1d853$export$45a5e7f76e0caa8d = (el)=>typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function $495690303bb1d853$export$c42e0e80904d519(current, max, loop) {
    var next = current + 1;
    if (loop && next >= max) next = 0;
    return next;
}
function $495690303bb1d853$export$1081b7170ed6e343(current, max, loop) {
    var next = current - 1;
    if (loop && next < 0) next = max;
    return next;
}
var $495690303bb1d853$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $denZA.useLayoutEffect) : (0, $denZA.useEffect);
var $495690303bb1d853$export$f2db7d5238e1d23f = (value)=>value;


function $d549174ba65adb7b$var$_extends() {
    $d549174ba65adb7b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d549174ba65adb7b$var$_extends.apply(this, arguments);
}
function $d549174ba65adb7b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $d549174ba65adb7b$export$e6418ef1851accd {
    constructor(){
        var _this = this;
        $d549174ba65adb7b$var$_defineProperty(this, "descendants", new Map());
        $d549174ba65adb7b$var$_defineProperty(this, "register", (nodeOrOptions)=>{
            if (nodeOrOptions == null) return;
            if ((0, $495690303bb1d853$export$45a5e7f76e0caa8d)(nodeOrOptions)) return this.registerNode(nodeOrOptions);
            return (node)=>{
                this.registerNode(node, nodeOrOptions);
            };
        });
        $d549174ba65adb7b$var$_defineProperty(this, "unregister", (node)=>{
            this.descendants.delete(node);
            var sorted = (0, $495690303bb1d853$export$96d07f33920abf3e)(Array.from(this.descendants.keys()));
            this.assignIndex(sorted);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "destroy", ()=>{
            this.descendants.clear();
        });
        $d549174ba65adb7b$var$_defineProperty(this, "assignIndex", (descendants)=>{
            this.descendants.forEach((descendant)=>{
                var index = descendants.indexOf(descendant.node);
                descendant.index = index;
                descendant.node.dataset.index = descendant.index.toString();
            });
        });
        $d549174ba65adb7b$var$_defineProperty(this, "count", ()=>this.descendants.size);
        $d549174ba65adb7b$var$_defineProperty(this, "enabledCount", ()=>this.enabledValues().length);
        $d549174ba65adb7b$var$_defineProperty(this, "values", ()=>{
            var values = Array.from(this.descendants.values());
            return values.sort((a, b)=>a.index - b.index);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "enabledValues", ()=>{
            return this.values().filter((descendant)=>!descendant.disabled);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "item", (index)=>{
            if (this.count() === 0) return undefined;
            return this.values()[index];
        });
        $d549174ba65adb7b$var$_defineProperty(this, "enabledItem", (index)=>{
            if (this.enabledCount() === 0) return undefined;
            return this.enabledValues()[index];
        });
        $d549174ba65adb7b$var$_defineProperty(this, "first", ()=>this.item(0));
        $d549174ba65adb7b$var$_defineProperty(this, "firstEnabled", ()=>this.enabledItem(0));
        $d549174ba65adb7b$var$_defineProperty(this, "last", ()=>this.item(this.descendants.size - 1));
        $d549174ba65adb7b$var$_defineProperty(this, "lastEnabled", ()=>{
            var lastIndex = this.enabledValues().length - 1;
            return this.enabledItem(lastIndex);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "indexOf", (node)=>{
            var _this$descendants$get, _this$descendants$get2;
            if (!node) return -1;
            return (_this$descendants$get = (_this$descendants$get2 = this.descendants.get(node)) == null ? void 0 : _this$descendants$get2.index) != null ? _this$descendants$get : -1;
        });
        $d549174ba65adb7b$var$_defineProperty(this, "enabledIndexOf", (node)=>{
            if (node == null) return -1;
            return this.enabledValues().findIndex((i)=>i.node.isSameNode(node));
        });
        $d549174ba65adb7b$var$_defineProperty(this, "next", function(index, loop) {
            if (loop === void 0) loop = true;
            var next = (0, $495690303bb1d853$export$c42e0e80904d519)(index, _this.count(), loop);
            return _this.item(next);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "nextEnabled", function(index, loop) {
            if (loop === void 0) loop = true;
            var item = _this.item(index);
            if (!item) return;
            var enabledIndex = _this.enabledIndexOf(item.node);
            var nextEnabledIndex = (0, $495690303bb1d853$export$c42e0e80904d519)(enabledIndex, _this.enabledCount(), loop);
            return _this.enabledItem(nextEnabledIndex);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "prev", function(index, loop) {
            if (loop === void 0) loop = true;
            var prev = (0, $495690303bb1d853$export$1081b7170ed6e343)(index, _this.count() - 1, loop);
            return _this.item(prev);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "prevEnabled", function(index, loop) {
            if (loop === void 0) loop = true;
            var item = _this.item(index);
            if (!item) return;
            var enabledIndex = _this.enabledIndexOf(item.node);
            var prevEnabledIndex = (0, $495690303bb1d853$export$1081b7170ed6e343)(enabledIndex, _this.enabledCount() - 1, loop);
            return _this.enabledItem(prevEnabledIndex);
        });
        $d549174ba65adb7b$var$_defineProperty(this, "registerNode", (node, options)=>{
            if (!node || this.descendants.has(node)) return;
            var keys = Array.from(this.descendants.keys()).concat(node);
            var sorted = (0, $495690303bb1d853$export$96d07f33920abf3e)(keys);
            if (options != null && options.disabled) options.disabled = !!options.disabled;
            var descendant = $d549174ba65adb7b$var$_extends({
                node: node,
                index: -1
            }, options);
            this.descendants.set(node, descendant);
            this.assignIndex(sorted);
        });
    }
}



/**
 * @internal
 * React hook that initializes the DescendantsManager
 */ function $a709b5585b66f1e1$var$useDescendants() {
    var [descendants] = (0, $denZA.useState)(()=>new (0, $d549174ba65adb7b$export$e6418ef1851accd)());
    (0, $495690303bb1d853$export$deebe11a338de063)(()=>{
        return ()=>descendants.destroy();
    });
    return descendants;
}
/* -------------------------------------------------------------------------------------------------
 * Descendants context to be used in component-land.
  - Mount the `DescendantsContextProvider` at the root of the component
  - Call `useDescendantsContext` anywhere you need access to the descendants information

  NB:  I recommend using `createDescendantContext` below
 * -----------------------------------------------------------------------------------------------*/ var [$a709b5585b66f1e1$var$DescendantsContextProvider, $a709b5585b66f1e1$var$useDescendantsContext] = (0, $f1f14ed33f74b8fd$export$fd42f52fd3ae1109)({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
/**
 * @internal
 * This hook provides information a descendant such as:
 * - Its index compared to other descendants
 * - ref callback to register the descendant
 * - Its enabled index compared to other enabled descendants
 */ function $a709b5585b66f1e1$var$useDescendant(options) {
    var descendants = $a709b5585b66f1e1$var$useDescendantsContext();
    var [index, setIndex] = (0, $denZA.useState)(-1);
    var ref = (0, $denZA.useRef)(null);
    (0, $495690303bb1d853$export$deebe11a338de063)(()=>{
        return ()=>{
            if (!ref.current) return;
            descendants.unregister(ref.current);
        };
    }, []);
    (0, $495690303bb1d853$export$deebe11a338de063)(()=>{
        if (!ref.current) return;
        var dataIndex = Number(ref.current.dataset.index);
        if (index != dataIndex && !Number.isNaN(dataIndex)) setIndex(dataIndex);
    });
    var refCallback = options ? (0, $495690303bb1d853$export$f2db7d5238e1d23f)(descendants.register(options)) : (0, $495690303bb1d853$export$f2db7d5238e1d23f)(descendants.register);
    return {
        descendants: descendants,
        index: index,
        enabledIndex: descendants.enabledIndexOf(ref.current),
        register: (0, $f1f14ed33f74b8fd$export$c9058316764c140e)(refCallback, ref)
    };
}
function $a709b5585b66f1e1$export$126c4100f8947d7() {
    var ContextProvider = (0, $495690303bb1d853$export$f2db7d5238e1d23f)($a709b5585b66f1e1$var$DescendantsContextProvider);
    var _useDescendantsContext = ()=>(0, $495690303bb1d853$export$f2db7d5238e1d23f)($a709b5585b66f1e1$var$useDescendantsContext());
    var _useDescendant = (options)=>$a709b5585b66f1e1$var$useDescendant(options);
    var _useDescendants = ()=>$a709b5585b66f1e1$var$useDescendants();
    return [
        ContextProvider,
        _useDescendantsContext,
        _useDescendants,
        _useDescendant
    ];
}




var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

var $a54e4d92878f49b7$export$deebe11a338de063 = (0, $405775388fe7f58e$export$4e09c449d6c407f7) ? $denZA.useLayoutEffect : $denZA.useEffect;


function $ab5b0545a722351d$export$25bec8c6f54ee79a(fn, deps) {
    if (deps === void 0) deps = [];
    var ref = $denZA.useRef(fn);
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        ref.current = fn;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
    return $denZA.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, deps);
}


function $53a3d6ee771ef939$export$7301e09313e4cf1b(prop, state) {
    var isControlled = prop !== undefined;
    var value = isControlled && typeof prop !== "undefined" ? prop : state;
    return [
        isControlled,
        value
    ];
}
function $53a3d6ee771ef939$export$6f32135080cb4c3(props) {
    var { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    var onChangeProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChange);
    var shouldUpdateProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(shouldUpdate);
    var [valueState, setValue] = $denZA.useState(defaultValue);
    var isControlled = valueProp !== undefined;
    var value = isControlled ? valueProp : valueState;
    var updateValue = $denZA.useCallback((next)=>{
        var nextValue = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(next, value);
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!isControlled) setValue(nextValue);
        onChangeProp(nextValue);
    }, [
        isControlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        updateValue
    ];
}

// This implementation is heavily inspired by react-aria's implementation

var $denZA = parcelRequire("denZA");
var $63207b263e1aef60$var$defaultIdContext = {
    prefix: Math.round(Math.random() * 10000000000),
    current: 0
};
var $63207b263e1aef60$var$IdContext = /*#__PURE__*/ $denZA.createContext($63207b263e1aef60$var$defaultIdContext);
var $63207b263e1aef60$export$6be90bcb437e928f = /*#__PURE__*/ $denZA.memo((_ref)=>{
    var { children: children } = _ref;
    var currentContext = $denZA.useContext($63207b263e1aef60$var$IdContext);
    var isRoot = currentContext === $63207b263e1aef60$var$defaultIdContext;
    var context = $denZA.useMemo(()=>({
            prefix: isRoot ? 0 : ++currentContext.prefix,
            current: 0
        }), [
        isRoot,
        currentContext
    ]);
    return /*#__PURE__*/ $denZA.createElement($63207b263e1aef60$var$IdContext.Provider, {
        value: context
    }, children);
});
function $63207b263e1aef60$export$f680877a34711e37(idProp, prefix) {
    var context = $denZA.useContext($63207b263e1aef60$var$IdContext);
    return $denZA.useMemo(()=>idProp || [
            prefix,
            context.prefix,
            ++context.current
        ].filter(Boolean).join("-"), [
        idProp,
        prefix
    ]);
}
function $63207b263e1aef60$export$365c04e2f432779(idProp) {
    for(var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)prefixes[_key - 1] = arguments[_key];
    var id = $63207b263e1aef60$export$f680877a34711e37(idProp);
    return $denZA.useMemo(()=>{
        return prefixes.map((prefix)=>prefix + "-" + id);
    }, [
        id,
        prefixes
    ]);
}
function $63207b263e1aef60$export$bc294ecf36b44bfb(partId) {
    var [id, setId] = $denZA.useState(null);
    var ref = $denZA.useCallback((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


var $denZA = parcelRequire("denZA");
function $c29482a8d6079d59$export$f3a192d0cbd30b96(fn, deps) {
    if (deps === void 0) deps = [];
    return $denZA.useEffect(()=>()=>fn(), deps);
}




var $e5Q7j = parcelRequire("e5Q7j");

function $a3173ad6497990c9$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $a3173ad6497990c9$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $a3173ad6497990c9$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $a3173ad6497990c9$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $a3173ad6497990c9$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $a3173ad6497990c9$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $a3173ad6497990c9$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, idx) {
        return idx !== index;
    });
}
function $a3173ad6497990c9$export$fb9705de59d96855(array, item) {
    return [].concat(array, [
        item
    ]);
}
function $a3173ad6497990c9$export$fe2d9b4e03920b4c(array, item) {
    return array.filter(function(eachItem) {
        return eachItem !== item;
    });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */ function $a3173ad6497990c9$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */ function $a3173ad6497990c9$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $a3173ad6497990c9$export$c42e0e80904d519(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */ function $a3173ad6497990c9$export$5f7ec48d69707ddd(array, size) {
    return array.reduce(function(rows, currentValue, index) {
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */ function $a3173ad6497990c9$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find(function(item) {
            return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
        });
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter(function(item) {
        return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    }); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}
// Number assertions
function $a3173ad6497990c9$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $a3173ad6497990c9$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $a3173ad6497990c9$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $a3173ad6497990c9$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $a3173ad6497990c9$export$4c0262a4f954db45(value) {
    return $a3173ad6497990c9$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $a3173ad6497990c9$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $a3173ad6497990c9$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $a3173ad6497990c9$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $a3173ad6497990c9$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$a3173ad6497990c9$export$43bee75e5e14138e(value);
}
function $a3173ad6497990c9$export$83b788b1a3698c03(value) {
    return $a3173ad6497990c9$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $a3173ad6497990c9$export$e0287cc73292b477(value) {
    return value && !$a3173ad6497990c9$export$83b788b1a3698c03(value);
}
function $a3173ad6497990c9$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $a3173ad6497990c9$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $a3173ad6497990c9$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $a3173ad6497990c9$export$dd1bc94b04021eeb(value) {
    if ($a3173ad6497990c9$export$43bee75e5e14138e(value)) return $a3173ad6497990c9$export$4c0262a4f954db45(value);
    if ($a3173ad6497990c9$export$a6cdc56e425d0d0a(value)) return $a3173ad6497990c9$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $a3173ad6497990c9$export$a866f231438cc228 = false;
var $a3173ad6497990c9$export$61cb32cff9a99948 = false;
function $a3173ad6497990c9$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $a3173ad6497990c9$export$4215e022093e324e(value) {
    return value && $a3173ad6497990c9$export$a6cdc56e425d0d0a(value) && $a3173ad6497990c9$export$a6cdc56e425d0d0a(value.target);
}
function $a3173ad6497990c9$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $a3173ad6497990c9$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach(function(key) {
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $a3173ad6497990c9$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */ function $a3173ad6497990c9$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $a3173ad6497990c9$export$fc10aeed3a532e2a = function memoize(fn) {
    var cache = new WeakMap();
    var memoizedFn = function memoizedFn(obj, path, fallback, index) {
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $a3173ad6497990c9$export$1bb32d0c65da6059 = $a3173ad6497990c9$export$fc10aeed3a532e2a($a3173ad6497990c9$export$3988ae62b71be9a3);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */ function $a3173ad6497990c9$export$73b8ef55a37133c7(path, scale) {
    return $a3173ad6497990c9$export$1bb32d0c65da6059(scale, path, path);
}
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */ function $a3173ad6497990c9$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $a3173ad6497990c9$export$2458ce75c8ef9806 = function filterUndefined(object) {
    return $a3173ad6497990c9$export$3417cf6417437960(object, function(val) {
        return val !== null && val !== undefined;
    });
};
var $a3173ad6497990c9$export$259b4dd69e654a7a = function objectKeys(obj) {
    return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */ var $a3173ad6497990c9$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(carry, _ref) {
        var key = _ref[0], value = _ref[1];
        carry[key] = value;
        return carry;
    }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */ var $a3173ad6497990c9$export$93c8e06b7014dc33 = function getCSSVar(theme, scale, value) {
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};
function $a3173ad6497990c9$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $a3173ad6497990c9$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var _analyzeCSSValue = $a3173ad6497990c9$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
    return unitless || $a3173ad6497990c9$export$7e4aa119212bc614(value) ? value + "px" : value;
}
var $a3173ad6497990c9$var$sortByBreakpointValue = function sortByBreakpointValue(a, b) {
    return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var $a3173ad6497990c9$var$sortBps = function sortBps(breakpoints) {
    return $a3173ad6497990c9$export$5150077fc2e7c662(Object.entries(breakpoints).sort($a3173ad6497990c9$var$sortByBreakpointValue));
};
function $a3173ad6497990c9$var$normalize(breakpoints) {
    var sorted = $a3173ad6497990c9$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $a3173ad6497990c9$var$keys(breakpoints) {
    var value = Object.keys($a3173ad6497990c9$var$sortBps(breakpoints));
    return new Set(value);
}
function $a3173ad6497990c9$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $a3173ad6497990c9$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return $a3173ad6497990c9$export$7e4aa119212bc614(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function(m) {
        return "" + (parseFloat(m) + factor);
    });
}
function $a3173ad6497990c9$var$queryString(min, max) {
    var query = [
        "@media screen"
    ];
    if (min) query.push("and", "(min-width: " + $a3173ad6497990c9$export$91c0eda1d06bf008(min) + ")");
    if (max) query.push("and", "(max-width: " + $a3173ad6497990c9$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $a3173ad6497990c9$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $a3173ad6497990c9$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($a3173ad6497990c9$var$sortByBreakpointValue).map(function(_ref, index, entry) {
        var _entry;
        var breakpoint = _ref[0], minW = _ref[1];
        var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [], maxW = _ref2[1];
        maxW = parseFloat(maxW) > 0 ? $a3173ad6497990c9$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $a3173ad6497990c9$var$queryString(null, maxW),
            minWQuery: $a3173ad6497990c9$var$queryString(minW),
            minMaxQuery: $a3173ad6497990c9$var$queryString(minW, maxW)
        };
    });
    var _keys = $a3173ad6497990c9$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive: function isResponsive(test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every(function(key) {
                return _keys.has(key);
            });
        },
        asObject: $a3173ad6497990c9$var$sortBps(breakpoints),
        asArray: $a3173ad6497990c9$var$normalize(breakpoints),
        details: queries,
        media: [
            null
        ].concat(normalized.map(function(minW) {
            return $a3173ad6497990c9$var$queryString(minW);
        }).slice(1)),
        toArrayValue: function toArrayValue(test) {
            if (!$a3173ad6497990c9$export$a6cdc56e425d0d0a(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map(function(bp) {
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while($a3173ad6497990c9$export$7475b2c64539e4cf(result) === null)result.pop();
            return result;
        },
        toObjectValue: function toObjectValue(test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce(function(acc, value, index) {
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
function $a3173ad6497990c9$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $a3173ad6497990c9$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$a3173ad6497990c9$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $a3173ad6497990c9$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $a3173ad6497990c9$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $a3173ad6497990c9$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $a3173ad6497990c9$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $a3173ad6497990c9$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $a3173ad6497990c9$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $a3173ad6497990c9$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $a3173ad6497990c9$export$4e09c449d6c407f7 = $a3173ad6497990c9$export$71594e8a50f746f4();
var $a3173ad6497990c9$export$5cc3b7b83e34ade7 = function dataAttr(condition) {
    return condition ? "" : undefined;
};
var $a3173ad6497990c9$export$91a6105db3d4be7b = function ariaAttr(condition) {
    return condition ? true : undefined;
};
var $a3173ad6497990c9$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $a3173ad6497990c9$export$cd4e5573fbe2b576(node) {
    var doc = $a3173ad6497990c9$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $a3173ad6497990c9$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $a3173ad6497990c9$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */ function $a3173ad6497990c9$export$17948c8429b9b73a(event) {
    var key = event.key, keyCode = event.keyCode;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $a3173ad6497990c9$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $a3173ad6497990c9$export$cd4e5573fbe2b576(target);
    return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function $a3173ad6497990c9$export$189689d1febf0166(event) {
    return event.button !== 0;
}
// Really great work done by Diego Haz on this one
var $a3173ad6497990c9$export$f5f22eac728522fd = function hasDisplayNone(element) {
    return window.getComputedStyle(element).display === "none";
};
var $a3173ad6497990c9$export$54209d29bacd2cb9 = function hasTabIndex(element) {
    return element.hasAttribute("tabindex");
};
var $a3173ad6497990c9$export$87df0ed37d24dd13 = function hasNegativeTabIndex(element) {
    return $a3173ad6497990c9$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
};
function $a3173ad6497990c9$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $a3173ad6497990c9$export$63ed1d20cf8213cf(element) {
    return $a3173ad6497990c9$export$1b3bfaa9684536aa(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $a3173ad6497990c9$export$8a2eb51c14bb8899(element) {
    var doc = $a3173ad6497990c9$export$1b3bfaa9684536aa(element) ? $a3173ad6497990c9$export$b204af158042fbac(element) : document;
    return doc.activeElement === element;
}
function $a3173ad6497990c9$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $a3173ad6497990c9$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $a3173ad6497990c9$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $a3173ad6497990c9$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $a3173ad6497990c9$export$4c063cf1350e6fed(element) {
    if (!$a3173ad6497990c9$export$1b3bfaa9684536aa(element) || $a3173ad6497990c9$export$ee695c13482bb5dd(element) || $a3173ad6497990c9$export$30e0dc115df457ed(element)) return false;
    var localName = element.localName;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: function a() {
            return element.hasAttribute("href");
        },
        audio: function audio() {
            return element.hasAttribute("controls");
        },
        video: function video() {
            return element.hasAttribute("controls");
        }
    };
    if (localName in others) return others[localName]();
    if ($a3173ad6497990c9$export$3453cc819780f652(element)) return true;
    return $a3173ad6497990c9$export$54209d29bacd2cb9(element);
}
function $a3173ad6497990c9$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return $a3173ad6497990c9$export$1b3bfaa9684536aa(element) && $a3173ad6497990c9$export$4c063cf1350e6fed(element) && !$a3173ad6497990c9$export$87df0ed37d24dd13(element);
}
var $a3173ad6497990c9$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $a3173ad6497990c9$var$focusableElSelector = $a3173ad6497990c9$var$focusableElList.join();
function $a3173ad6497990c9$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($a3173ad6497990c9$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter($a3173ad6497990c9$export$4c063cf1350e6fed).filter(function(el) {
        return window.getComputedStyle(el).display !== "none";
    });
}
function $a3173ad6497990c9$export$748138f04a69bf21(container) {
    var allFocusable = $a3173ad6497990c9$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $a3173ad6497990c9$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($a3173ad6497990c9$var$focusableElSelector));
    var allTabbable = allFocusable.filter($a3173ad6497990c9$export$bebd5a1431fec25d);
    if ($a3173ad6497990c9$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $a3173ad6497990c9$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbable = $a3173ad6497990c9$export$f9ba66356f7359cf(container, fallbackToFocusable), first = _getAllTabbable[0];
    return first || null;
}
function $a3173ad6497990c9$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $a3173ad6497990c9$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $a3173ad6497990c9$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $a3173ad6497990c9$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($a3173ad6497990c9$export$bebd5a1431fec25d) || allFocusable.find($a3173ad6497990c9$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $a3173ad6497990c9$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $a3173ad6497990c9$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($a3173ad6497990c9$export$bebd5a1431fec25d) || allFocusable.find($a3173ad6497990c9$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $a3173ad6497990c9$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $a3173ad6497990c9$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && $a3173ad6497990c9$export$1b3bfaa9684536aa(nextTabbable)) nextTabbable.focus();
}
function $a3173ad6497990c9$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $a3173ad6497990c9$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && $a3173ad6497990c9$export$1b3bfaa9684536aa(previousTabbable)) previousTabbable.focus();
}
function $a3173ad6497990c9$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $a3173ad6497990c9$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($a3173ad6497990c9$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}
function $a3173ad6497990c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3173ad6497990c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a3173ad6497990c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3173ad6497990c9$var$_arrayLikeToArray(o, minLen);
}
function $a3173ad6497990c9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a3173ad6497990c9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable no-nested-ternary */ function $a3173ad6497990c9$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $a3173ad6497990c9$export$f6e2535fb5126e54(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function $a3173ad6497990c9$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some(function(fn) {
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $a3173ad6497990c9$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach(function(fn) {
            fn == null || fn(arg);
        });
    };
}
var $a3173ad6497990c9$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce(function(f1, f2) {
        return function() {
            return f1(f2.apply(void 0, arguments));
        };
    }, fn1);
};
function $a3173ad6497990c9$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $a3173ad6497990c9$export$8793edee2d425525 = function noop() {};
var $a3173ad6497990c9$export$c106dd0671a0fc2d = $a3173ad6497990c9$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $a3173ad6497990c9$export$a866f231438cc228) console.warn(message);
    };
});
var $a3173ad6497990c9$export$a3bc9b8ed74fc = $a3173ad6497990c9$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $a3173ad6497990c9$export$a866f231438cc228) console.error(message);
    };
});
var $a3173ad6497990c9$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return function(v) {
        return fns.reduce(function(a, b) {
            return b(a);
        }, v);
    };
};
var $a3173ad6497990c9$var$distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
};
var $a3173ad6497990c9$var$isPoint = function isPoint(point) {
    return "x" in point && "y" in point;
};
function $a3173ad6497990c9$export$9f17032d917177de(a, b) {
    if ($a3173ad6497990c9$export$7e4aa119212bc614(a) && $a3173ad6497990c9$export$7e4aa119212bc614(b)) return $a3173ad6497990c9$var$distance1D(a, b);
    if ($a3173ad6497990c9$var$isPoint(a) && $a3173ad6497990c9$var$isPoint(b)) {
        var xDelta = $a3173ad6497990c9$var$distance1D(a.x, b.x);
        var yDelta = $a3173ad6497990c9$var$distance1D(a.y, b.y);
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
    }
    return 0;
}
function $a3173ad6497990c9$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var _options = options, _options$isActive = _options.isActive, isActive = _options$isActive === void 0 ? $a3173ad6497990c9$export$8a2eb51c14bb8899 : _options$isActive, nextTick = _options.nextTick, _options$preventScrol = _options.preventScroll, preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol, _options$selectTextIf = _options.selectTextIfInput, selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            $a3173ad6497990c9$export$c106dd0671a0fc2d({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($a3173ad6497990c9$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $a3173ad6497990c9$var$getScrollableElements(element);
                $a3173ad6497990c9$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ($a3173ad6497990c9$export$63ed1d20cf8213cf(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $a3173ad6497990c9$var$supportsPreventScrollCached = null;
function $a3173ad6497990c9$var$supportsPreventScroll() {
    if ($a3173ad6497990c9$var$supportsPreventScrollCached == null) {
        $a3173ad6497990c9$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $a3173ad6497990c9$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $a3173ad6497990c9$var$supportsPreventScrollCached;
}
function $a3173ad6497990c9$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = $a3173ad6497990c9$export$b204af158042fbac(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $a3173ad6497990c9$var$restoreScrollPosition(scrollableElements) {
    for(var _iterator = $a3173ad6497990c9$var$_createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, element = _step$value.element, scrollTop = _step$value.scrollTop, scrollLeft = _step$value.scrollLeft;
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $a3173ad6497990c9$export$bffa455ba8c619a6(target, maxDepth) {
    if (maxDepth === void 0) maxDepth = Infinity;
    if (!$a3173ad6497990c9$export$a6cdc56e425d0d0a(target) && !Array.isArray(target) || !maxDepth) return target;
    return Object.entries(target).reduce(function(result, _ref) {
        var key = _ref[0], value = _ref[1];
        if ($a3173ad6497990c9$export$a6cdc56e425d0d0a(value) || $a3173ad6497990c9$export$43bee75e5e14138e(value)) Object.entries($a3173ad6497990c9$export$bffa455ba8c619a6(value, maxDepth - 1)).forEach(function(_ref2) {
            var childKey = _ref2[0], childValue = _ref2[1];
            // e.g. gray.500
            result[key + "." + childKey] = childValue;
        });
        else // e.g. transparent
        result[key] = value;
        return result;
    }, {});
}
/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $a3173ad6497990c9$export$1f16c1e83f5de19d(options) {
    var hasBeenSelected = options.hasBeenSelected, isLazy = options.isLazy, isSelected = options.isSelected, _options$lazyBehavior = options.lazyBehavior, lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}
var $a3173ad6497990c9$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $a3173ad6497990c9$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $a3173ad6497990c9$var$toNumber(value) {
    var num = parseFloat(value);
    return $a3173ad6497990c9$export$3f283ac14831e759(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */ function $a3173ad6497990c9$export$3e91a10e66078270(value, precision) {
    var nextValue = $a3173ad6497990c9$var$toNumber(value);
    var scaleFactor = Math.pow(10, precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */ function $a3173ad6497990c9$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */ function $a3173ad6497990c9$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */ function $a3173ad6497990c9$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */ function $a3173ad6497990c9$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $a3173ad6497990c9$export$a42544f265f8403(step);
    return $a3173ad6497990c9$export$3e91a10e66078270(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */ function $a3173ad6497990c9$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    $a3173ad6497990c9$export$c106dd0671a0fc2d({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}
function $a3173ad6497990c9$var$_extends() {
    $a3173ad6497990c9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3173ad6497990c9$var$_extends.apply(this, arguments);
}
/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ function $a3173ad6497990c9$export$764db16956f554f8(event) {
    var win = $a3173ad6497990c9$export$8d16348623687f6(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $a3173ad6497990c9$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $a3173ad6497990c9$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var win = $a3173ad6497990c9$export$8d16348623687f6(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $a3173ad6497990c9$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $a3173ad6497990c9$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $a3173ad6497990c9$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $a3173ad6497990c9$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $a3173ad6497990c9$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $a3173ad6497990c9$export$c4dfce035d43d1e0(event) ? $a3173ad6497990c9$var$pointFromTouch(event, pointType) : $a3173ad6497990c9$var$pointFromMouse(event, pointType)
    };
}
function $a3173ad6497990c9$export$750e59ed656e0503(event) {
    return $a3173ad6497990c9$export$12f84bb882d06e1a(event, "client");
}
var $a3173ad6497990c9$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function listener(event) {
        return handler(event, $a3173ad6497990c9$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $a3173ad6497990c9$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $a3173ad6497990c9$var$supportsPointerEvents = function supportsPointerEvents() {
    return $a3173ad6497990c9$export$4e09c449d6c407f7 && window.onpointerdown === null;
};
var $a3173ad6497990c9$var$supportsTouchEvents = function supportsTouchEvents() {
    return $a3173ad6497990c9$export$4e09c449d6c407f7 && window.ontouchstart === null;
};
var $a3173ad6497990c9$var$supportsMouseEvents = function supportsMouseEvents() {
    return $a3173ad6497990c9$export$4e09c449d6c407f7 && window.onmousedown === null;
};
var $a3173ad6497990c9$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $a3173ad6497990c9$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $a3173ad6497990c9$export$9fd5832907e02451(name) {
    if ($a3173ad6497990c9$var$supportsPointerEvents()) return name;
    if ($a3173ad6497990c9$var$supportsTouchEvents()) return $a3173ad6497990c9$var$touchEventNames[name];
    if ($a3173ad6497990c9$var$supportsMouseEvents()) return $a3173ad6497990c9$var$mouseEventNames[name];
    return name;
}
function $a3173ad6497990c9$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return $a3173ad6497990c9$export$b1d829ddf82884aa(target, $a3173ad6497990c9$export$9fd5832907e02451(eventName), $a3173ad6497990c9$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $a3173ad6497990c9$export$d06464d6b74eedc4(event) {
    return $a3173ad6497990c9$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */ /**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */ var $a3173ad6497990c9$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ function PanSession(_event, handlers, threshold) {
        var _this = this;
        this.history = [];
        this.startEvent = null;
        this.lastEvent = null;
        this.lastEventInfo = null;
        this.handlers = {};
        this.removeListeners = $a3173ad6497990c9$export$8793edee2d425525;
        this.threshold = 3;
        this.win = void 0;
        this.updatePoint = function() {
            if (!(_this.lastEvent && _this.lastEventInfo)) return;
            var info = $a3173ad6497990c9$var$getPanInfo(_this.lastEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = $a3173ad6497990c9$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= _this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var _getFrameData = (0, $74f0db85147db332$export$7244445918e670ed)(), timestamp = _getFrameData.timestamp;
            _this.history.push($a3173ad6497990c9$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var _this$handlers = _this.handlers, onStart = _this$handlers.onStart, onMove = _this$handlers.onMove;
            if (!isPanStarted) {
                onStart == null || onStart(_this.lastEvent, info);
                _this.startEvent = _this.lastEvent;
            }
            onMove == null || onMove(_this.lastEvent, info);
        };
        this.onPointerMove = function(event, info) {
            _this.lastEvent = event;
            _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ($a3173ad6497990c9$export$764db16956f554f8(event) && event.buttons === 0) {
                _this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.onPointerUp = function(event, info) {
            // notify pan session ended
            var panInfo = $a3173ad6497990c9$var$getPanInfo(info, _this.history);
            var _this$handlers2 = _this.handlers, onEnd = _this$handlers2.onEnd, onSessionEnd = _this$handlers2.onSessionEnd;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            _this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !_this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        };
        this.win = $a3173ad6497990c9$export$8d16348623687f6(_event); // If we have more than one touch, don't start detecting this gesture
        if ($a3173ad6497990c9$export$d06464d6b74eedc4(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = $a3173ad6497990c9$export$12f84bb882d06e1a(_event);
        var _getFrameData2 = (0, $74f0db85147db332$export$7244445918e670ed)(), _timestamp = _getFrameData2.timestamp;
        this.history = [
            $a3173ad6497990c9$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var onSessionStart = handlers.onSessionStart;
        onSessionStart == null || onSessionStart(_event, $a3173ad6497990c9$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = $a3173ad6497990c9$export$a4627e546088548d($a3173ad6497990c9$export$fcff2e64e6676b81(this.win, "pointermove", this.onPointerMove), $a3173ad6497990c9$export$fcff2e64e6676b81(this.win, "pointerup", this.onPointerUp), $a3173ad6497990c9$export$fcff2e64e6676b81(this.win, "pointercancel", this.onPointerUp));
    }
    var _proto = PanSession.prototype;
    _proto.updateHandlers = function updateHandlers(handlers) {
        this.handlers = handlers;
    };
    _proto.end = function end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $a3173ad6497990c9$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $a3173ad6497990c9$var$startPanPoint(history) {
    return history[0];
}
function $a3173ad6497990c9$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $a3173ad6497990c9$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $a3173ad6497990c9$var$subtractPoint(info.point, $a3173ad6497990c9$var$lastPanPoint(history)),
        offset: $a3173ad6497990c9$var$subtractPoint(info.point, $a3173ad6497990c9$var$startPanPoint(history)),
        velocity: $a3173ad6497990c9$var$getVelocity(history, 0.1)
    };
}
function $a3173ad6497990c9$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $a3173ad6497990c9$var$toMilliseconds = function toMilliseconds(seconds) {
    return seconds * 1000;
};
function $a3173ad6497990c9$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $a3173ad6497990c9$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $a3173ad6497990c9$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
var $a3173ad6497990c9$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $a3173ad6497990c9$export$eca1915781c2aaca(prop, mapper) {
    if ($a3173ad6497990c9$export$43bee75e5e14138e(prop)) return prop.map(function(item) {
        if (item === null) return null;
        return mapper(item);
    });
    if ($a3173ad6497990c9$export$a6cdc56e425d0d0a(prop)) return $a3173ad6497990c9$export$259b4dd69e654a7a(prop).reduce(function(result, key) {
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $a3173ad6497990c9$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $a3173ad6497990c9$export$d07517a676ce386f;
    var result = bps.map(function(br) {
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while($a3173ad6497990c9$export$7475b2c64539e4cf(result) === null)result.pop();
    return result;
}
function $a3173ad6497990c9$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $a3173ad6497990c9$export$d07517a676ce386f;
    var result = {};
    values.forEach(function(value, index) {
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $a3173ad6497990c9$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $a3173ad6497990c9$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every(function(key) {
        return bps.includes(key);
    });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */ var $a3173ad6497990c9$export$4cdfc817e07de39e = function isCustomBreakpoint(maybeBreakpoint) {
    return Number.isNaN(Number(maybeBreakpoint));
};
function $a3173ad6497990c9$var$getUserAgentBrowser(navigator) {
    var ua = navigator.userAgent, vendor = navigator.vendor;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $a3173ad6497990c9$var$getUserAgentOS(navigator) {
    var ua = navigator.userAgent, platform = navigator.platform;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $a3173ad6497990c9$export$568a7d21694b4b32(navigator) {
    var ua = navigator.userAgent;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $a3173ad6497990c9$export$3070bd282ec37ea8(os) {
    if (!$a3173ad6497990c9$export$4e09c449d6c407f7) return false;
    return $a3173ad6497990c9$var$getUserAgentOS(window.navigator) === os;
}
function $a3173ad6497990c9$export$2d31490a0c05f094(browser) {
    if (!$a3173ad6497990c9$export$4e09c449d6c407f7) return false;
    return $a3173ad6497990c9$var$getUserAgentBrowser(window.navigator) === browser;
}
function $a3173ad6497990c9$export$8d04c8cf4d9e22d8() {
    if (!$a3173ad6497990c9$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $a3173ad6497990c9$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ($a3173ad6497990c9$export$43bee75e5e14138e(value)) return value.map(function(item, index) {
            return inner(item, [].concat(path, [
                String(index)
            ]));
        });
        if ($a3173ad6497990c9$export$a6cdc56e425d0d0a(value)) return $a3173ad6497990c9$export$5150077fc2e7c662(Object.entries(value).map(function(_ref) {
            var key = _ref[0], child = _ref[1];
            return [
                key,
                inner(child, [].concat(path, [
                    key
                ]))
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}


function $c6a0fb14928c8c7b$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $a3173ad6497990c9$export$f6e2535fb5126e54)(ref)) {
        ref(value);
        return;
    }
    try {
        // @ts-ignore
        ref.current = value;
    } catch (error) {
        throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
    }
}
function $c6a0fb14928c8c7b$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (node)=>{
        refs.forEach((ref)=>$c6a0fb14928c8c7b$export$d734136a7b018efe(ref, node));
    };
}


// Original licensing for the following methods can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/calvellido/focus-options-polyfill
// See https://github.com/adobe/react-spectrum


// Really great work done by Diego Haz on this one
// https://github.com/reakit/reakit/blob/master/packages/reakit-utils/src/tabbable.ts

var $e8db4866fc051e33$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
var $e8db4866fc051e33$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
var $e8db4866fc051e33$export$87df0ed37d24dd13 = (element)=>$e8db4866fc051e33$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $e8db4866fc051e33$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $e8db4866fc051e33$export$63ed1d20cf8213cf(element) {
    return (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $e8db4866fc051e33$export$8a2eb51c14bb8899(element) {
    var doc = (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(element) ? (0, $405775388fe7f58e$export$b204af158042fbac)(element) : document;
    return doc.activeElement === element;
}
function $e8db4866fc051e33$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $e8db4866fc051e33$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $e8db4866fc051e33$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $e8db4866fc051e33$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $e8db4866fc051e33$export$4c063cf1350e6fed(element) {
    if (!(0, $405775388fe7f58e$export$1b3bfaa9684536aa)(element) || $e8db4866fc051e33$export$ee695c13482bb5dd(element) || $e8db4866fc051e33$export$30e0dc115df457ed(element)) return false;
    var { localName: localName } = element;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ($e8db4866fc051e33$export$3453cc819780f652(element)) return true;
    return $e8db4866fc051e33$export$54209d29bacd2cb9(element);
}
function $e8db4866fc051e33$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(element) && $e8db4866fc051e33$export$4c063cf1350e6fed(element) && !$e8db4866fc051e33$export$87df0ed37d24dd13(element);
}


function $05d433d46dbef2db$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var { isActive: isActive = (0, $e8db4866fc051e33$export$8a2eb51c14bb8899), nextTick: nextTick, preventScroll: preventScroll = true, selectTextIfInput: selectTextIfInput = true } = options;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($05d433d46dbef2db$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $05d433d46dbef2db$var$getScrollableElements(element);
                $05d433d46dbef2db$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ((0, $e8db4866fc051e33$export$63ed1d20cf8213cf)(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $05d433d46dbef2db$var$supportsPreventScrollCached = null;
function $05d433d46dbef2db$var$supportsPreventScroll() {
    if ($05d433d46dbef2db$var$supportsPreventScrollCached == null) {
        $05d433d46dbef2db$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $05d433d46dbef2db$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $05d433d46dbef2db$var$supportsPreventScrollCached;
}
function $05d433d46dbef2db$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = (0, $405775388fe7f58e$export$b204af158042fbac)(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $05d433d46dbef2db$var$restoreScrollPosition(scrollableElements) {
    for (var { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}



var $denZA = parcelRequire("denZA");
function $8b36ebdd90eaced7$var$_extends() {
    $8b36ebdd90eaced7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b36ebdd90eaced7$var$_extends.apply(this, arguments);
}
function $8b36ebdd90eaced7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$8b36ebdd90eaced7$export$295e8ce3a8defbe8, $8b36ebdd90eaced7$export$25d3c2eb37694077, $8b36ebdd90eaced7$export$ded2cc2705caf60e, $8b36ebdd90eaced7$export$1d828a1944f739d3] = (0, $a709b5585b66f1e1$export$126c4100f8947d7)();
function $8b36ebdd90eaced7$export$35e88b08325f7140(props) {
    var { onChange: onChange, defaultIndex: defaultIndex, index: indexProp, allowMultiple: allowMultiple, allowToggle: allowToggle } = props, htmlProps = $8b36ebdd90eaced7$var$_objectWithoutPropertiesLoose(props, [
        "onChange",
        "defaultIndex",
        "index",
        "allowMultiple",
        "allowToggle"
    ]); // validate the props and `warn` if used incorrectly
    $8b36ebdd90eaced7$var$allowMultipleWarning(props);
    $8b36ebdd90eaced7$var$allowMultipleAndAllowToggleWarning(props);
    /**
   * Think of this as the register to each accordion item.
   * We used to manage focus between accordion item buttons.
   *
   * Every accordion item, registers their button refs in this context
   */ var descendants = $8b36ebdd90eaced7$export$ded2cc2705caf60e();
    /**
   * This state is used to track the index focused accordion
   * button when click on the button, tab on the button, or
   * use the down/up arrow to navigate.
   */ var [focusedIndex, setFocusedIndex] = (0, $denZA.useState)(-1);
    /**
   * Reset focused index when accordion unmounts
   * or descendants change
   */ (0, $c29482a8d6079d59$export$f3a192d0cbd30b96)(()=>{
        setFocusedIndex(-1);
    });
    /**
   * Hook that manages the controlled and un-controlled state
   * for the accordion.
   */ var [index, setIndex] = (0, $53a3d6ee771ef939$export$6f32135080cb4c3)({
        value: indexProp,
        defaultValue () {
            if (allowMultiple) return defaultIndex != null ? defaultIndex : [];
            return defaultIndex != null ? defaultIndex : -1;
        },
        onChange: onChange
    });
    /**
   * Gets the `isOpen` and `onChange` props for a child accordion item based on
   * the child's index.
   *
   * @param idx {number} The index of the child accordion item
   */ var getAccordionItemProps = (idx)=>{
        var isOpen = false;
        if (idx !== null) isOpen = (0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(index) ? index.includes(idx) : index === idx;
        var onChange = (isOpen)=>{
            if (idx === null) return;
            if (allowMultiple && (0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(index)) {
                var nextState = isOpen ? (0, $4cb94e5c0fd5e9d1$export$fb9705de59d96855)(index, idx) : (0, $4cb94e5c0fd5e9d1$export$fe2d9b4e03920b4c)(index, idx);
                setIndex(nextState);
            } else if (isOpen) setIndex(idx);
            else if (allowToggle) setIndex(-1);
        };
        return {
            isOpen: isOpen,
            onChange: onChange
        };
    };
    return {
        index: index,
        setIndex: setIndex,
        htmlProps: htmlProps,
        getAccordionItemProps: getAccordionItemProps,
        focusedIndex: focusedIndex,
        setFocusedIndex: setFocusedIndex,
        descendants: descendants
    };
}
var [$8b36ebdd90eaced7$export$a7339cf504e447d7, $8b36ebdd90eaced7$export$33b38874135ce337] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "AccordionContext",
    errorMessage: "useAccordionContext: `context` is undefined. Seems you forgot to wrap the accordion components in `<Accordion />`"
});
function $8b36ebdd90eaced7$export$dfe72e7a237bd184(props) {
    var { isDisabled: isDisabled, isFocusable: isFocusable, id: id } = props, htmlProps = $8b36ebdd90eaced7$var$_objectWithoutPropertiesLoose(props, [
        "isDisabled",
        "isFocusable",
        "id"
    ]);
    var { getAccordionItemProps: getAccordionItemProps, setFocusedIndex: setFocusedIndex } = $8b36ebdd90eaced7$export$33b38874135ce337();
    var buttonRef = (0, $denZA.useRef)(null);
    /**
   * Generate unique ids for all accordion item components (button and panel)
   */ var [buttonId, panelId] = (0, $63207b263e1aef60$export$365c04e2f432779)(id, "accordion-button", "accordion-panel");
    $8b36ebdd90eaced7$var$focusableNotDisabledWarning(props);
    /**
   * Think of this as a way to register this accordion item
   * with its parent `useAccordion`
   */ var { register: register, index: index, descendants: descendants } = $8b36ebdd90eaced7$export$1d828a1944f739d3({
        disabled: isDisabled && !isFocusable
    });
    var { isOpen: isOpen, onChange: onChange } = getAccordionItemProps(index === -1 ? null : index);
    $8b36ebdd90eaced7$var$warnIfOpenAndDisabled({
        isOpen: isOpen,
        isDisabled: isDisabled
    });
    var onOpen = ()=>{
        onChange == null || onChange(true);
    };
    var onClose = ()=>{
        onChange == null || onChange(false);
    };
    /**
   * Toggle the visibility of the accordion item
   */ var onClick = (0, $denZA.useCallback)(()=>{
        onChange == null || onChange(!isOpen);
        setFocusedIndex(index);
    }, [
        index,
        setFocusedIndex,
        isOpen,
        onChange
    ]);
    /**
   * Manage keyboard navigation between accordion items.
   */ var onKeyDown = (0, $denZA.useCallback)((event)=>{
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var keyMap = {
            ArrowDown: ()=>{
                var next = descendants.nextEnabled(index);
                if (next) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(next.node);
            },
            ArrowUp: ()=>{
                var prev = descendants.prevEnabled(index);
                if (prev) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(prev.node);
            },
            Home: ()=>{
                var first = descendants.firstEnabled();
                if (first) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(first.node);
            },
            End: ()=>{
                var last = descendants.lastEnabled();
                if (last) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(last.node);
            }
        };
        var action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        descendants,
        index
    ]);
    /**
   * Since each accordion item's button still remains tabbable, let's
   * update the focusedIndex when it receives focus
   */ var onFocus = (0, $denZA.useCallback)(()=>{
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index
    ]);
    var getButtonProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $8b36ebdd90eaced7$var$_extends({}, props, {
            type: "button",
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(register, buttonRef, ref),
            id: buttonId,
            disabled: !!isDisabled,
            "aria-expanded": !!isOpen,
            "aria-controls": panelId,
            onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onClick),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, onFocus),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
        });
    }, [
        buttonId,
        isDisabled,
        isOpen,
        onClick,
        onFocus,
        onKeyDown,
        panelId,
        register
    ]);
    var getPanelProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $8b36ebdd90eaced7$var$_extends({}, props, {
            ref: ref,
            role: "region",
            id: panelId,
            "aria-labelledby": buttonId,
            hidden: !isOpen
        });
    }, [
        buttonId,
        isOpen,
        panelId
    ]);
    return {
        isOpen: isOpen,
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        onOpen: onOpen,
        onClose: onClose,
        getButtonProps: getButtonProps,
        getPanelProps: getPanelProps,
        htmlProps: htmlProps
    };
}
/* -------------------------------------------------------------------------------------------------
 * Validate accordion and accordion item props, and emit warnings.
 * -----------------------------------------------------------------------------------------------*/ function $8b36ebdd90eaced7$var$allowMultipleWarning(props) {
    var index = props.index || props.defaultIndex;
    var condition = !(0, $6b74ef5ae6a56e47$export$fce6876652108ab)(index) && !(0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(index) && props.allowMultiple;
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: !!condition,
        message: "If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: " + typeof index + ","
    });
}
function $8b36ebdd90eaced7$var$allowMultipleAndAllowToggleWarning(props) {
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: !!(props.allowMultiple && props.allowToggle),
        message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
    });
}
function $8b36ebdd90eaced7$var$focusableNotDisabledWarning(props) {
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: !!(props.isFocusable && !props.isDisabled),
        message: "Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.\n    "
    });
}
function $8b36ebdd90eaced7$var$warnIfOpenAndDisabled(props) {
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: props.isOpen && !!props.isDisabled,
        message: "Cannot open a disabled accordion item"
    });
}


function $ad355bde8fa6ee65$var$_extends() {
    $ad355bde8fa6ee65$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad355bde8fa6ee65$var$_extends.apply(this, arguments);
}
function $ad355bde8fa6ee65$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ad355bde8fa6ee65$export$a766cd26d0d69044 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((_ref, ref)=>{
    var { children: children, reduceMotion: reduceMotion } = _ref, props = $ad355bde8fa6ee65$var$_objectWithoutPropertiesLoose(_ref, [
        "children",
        "reduceMotion"
    ]);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Accordion", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var _useAccordion = (0, $8b36ebdd90eaced7$export$35e88b08325f7140)(ownProps), { htmlProps: htmlProps, descendants: descendants } = _useAccordion, context = $ad355bde8fa6ee65$var$_objectWithoutPropertiesLoose(_useAccordion, [
        "htmlProps",
        "descendants"
    ]);
    var ctx = $denZA.useMemo(()=>$ad355bde8fa6ee65$var$_extends({}, context, {
            reduceMotion: !!reduceMotion
        }), [
        context,
        reduceMotion
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $8b36ebdd90eaced7$export$295e8ce3a8defbe8), {
        value: descendants
    }, /*#__PURE__*/ $denZA.createElement((0, $8b36ebdd90eaced7$export$a7339cf504e447d7), {
        value: ctx
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $ad355bde8fa6ee65$var$_extends({
        ref: ref
    }, htmlProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-accordion", props.className)
    }), children))));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ad355bde8fa6ee65$export$a766cd26d0d69044.displayName = "Accordion";
/* -------------------------------------------------------------------------------------------------
 * Accordion Item
 * -----------------------------------------------------------------------------------------------*/ var [$ad355bde8fa6ee65$var$AccordionItemProvider, $ad355bde8fa6ee65$var$useAccordionItemContext] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "AccordionItemContext",
    errorMessage: "useAccordionItemContext: `context` is undefined. Seems you forgot to wrap the accordion item parts in `<AccordionItem />` "
});
var $ad355bde8fa6ee65$export$d99097c13d4dac9f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { children: children, className: className } = props;
    var _useAccordionItem = (0, $8b36ebdd90eaced7$export$dfe72e7a237bd184)(props), { htmlProps: htmlProps } = _useAccordionItem, context = $ad355bde8fa6ee65$var$_objectWithoutPropertiesLoose(_useAccordionItem, [
        "htmlProps"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var containerStyles = $ad355bde8fa6ee65$var$_extends({}, styles.container, {
        overflowAnchor: "none"
    });
    var ctx = $denZA.useMemo(()=>context, [
        context
    ]);
    return /*#__PURE__*/ $denZA.createElement($ad355bde8fa6ee65$var$AccordionItemProvider, {
        value: ctx
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $ad355bde8fa6ee65$var$_extends({
        ref: ref
    }, htmlProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-accordion__item", className),
        __css: containerStyles
    }), (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(children, {
        isExpanded: !!context.isOpen,
        isDisabled: !!context.isDisabled
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ad355bde8fa6ee65$export$d99097c13d4dac9f.displayName = "AccordionItem";
function $ad355bde8fa6ee65$export$3a07970fb79c0051() {
    var { isOpen: isOpen, isDisabled: isDisabled, onClose: onClose, onOpen: onOpen } = $ad355bde8fa6ee65$var$useAccordionItemContext();
    return {
        isOpen: isOpen,
        onClose: onClose,
        isDisabled: isDisabled,
        onOpen: onOpen
    };
}
var $ad355bde8fa6ee65$export$b9675c0bae9f505a = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getButtonProps: getButtonProps } = $ad355bde8fa6ee65$var$useAccordionItemContext();
    var buttonProps = getButtonProps(props, ref);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var buttonStyles = $ad355bde8fa6ee65$var$_extends({
        display: "flex",
        alignItems: "center",
        width: "100%",
        outline: 0
    }, styles.button);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $ad355bde8fa6ee65$var$_extends({}, buttonProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-accordion__button", props.className),
        __css: buttonStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ad355bde8fa6ee65$export$b9675c0bae9f505a.displayName = "AccordionButton";
var $ad355bde8fa6ee65$export$7cad6f17fd6e117b = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { reduceMotion: reduceMotion } = (0, $8b36ebdd90eaced7$export$33b38874135ce337)();
    var { getPanelProps: getPanelProps, isOpen: isOpen } = $ad355bde8fa6ee65$var$useAccordionItemContext(); // remove `hidden` prop, 'coz we're using height animation
    var panelProps = getPanelProps(props, ref);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-accordion__panel", props.className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    if (!reduceMotion) delete panelProps.hidden;
    var child = /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $ad355bde8fa6ee65$var$_extends({}, panelProps, {
        __css: styles.panel,
        className: _className
    }));
    if (!reduceMotion) return /*#__PURE__*/ $denZA.createElement((0, $c93b6b1a78aaf16c$export$78768a9af065a7b), {
        in: isOpen
    }, child);
    return child;
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ad355bde8fa6ee65$export$7cad6f17fd6e117b.displayName = "AccordionPanel";
var $ad355bde8fa6ee65$export$11c5044b59af4824 = (props)=>{
    var { isOpen: isOpen, isDisabled: isDisabled } = $ad355bde8fa6ee65$var$useAccordionItemContext();
    var { reduceMotion: reduceMotion } = (0, $8b36ebdd90eaced7$export$33b38874135ce337)();
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-accordion__icon", props.className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var iconStyles = $ad355bde8fa6ee65$var$_extends({
        opacity: isDisabled ? 0.4 : 1,
        transform: isOpen ? "rotate(-180deg)" : undefined,
        transition: reduceMotion ? undefined : "transform 0.2s",
        transformOrigin: "center"
    }, styles.icon);
    return /*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $ad355bde8fa6ee65$var$_extends({
        viewBox: "0 0 24 24",
        "aria-hidden": true,
        className: _className,
        __css: iconStyles
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ad355bde8fa6ee65$export$11c5044b59af4824.displayName = "AccordionIcon";




var $denZA = parcelRequire("denZA");
var $453392015bdf0bf5$var$__assign = undefined && undefined.__assign || function() {
    $453392015bdf0bf5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $453392015bdf0bf5$var$__assign.apply(this, arguments);
};
var $453392015bdf0bf5$export$b9675c0bae9f505a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $ad355bde8fa6ee65$export$b9675c0bae9f505a), $453392015bdf0bf5$var$__assign({}, props, {
        ref: ref
    }));
});



var $9a88cf76793c5638$export$11c5044b59af4824 = (0, $ad355bde8fa6ee65$export$11c5044b59af4824);





var $denZA = parcelRequire("denZA");
var $777edd3992d48c34$var$__assign = undefined && undefined.__assign || function() {
    $777edd3992d48c34$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $777edd3992d48c34$var$__assign.apply(this, arguments);
};
var $777edd3992d48c34$export$d99097c13d4dac9f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $ad355bde8fa6ee65$export$d99097c13d4dac9f), $777edd3992d48c34$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $eeb2f69ee8ee5a8f$var$__assign = undefined && undefined.__assign || function() {
    $eeb2f69ee8ee5a8f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eeb2f69ee8ee5a8f$var$__assign.apply(this, arguments);
};
var $eeb2f69ee8ee5a8f$export$7cad6f17fd6e117b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    // Accordion Panels should never be focusable by tabbing through them, form elements inside them
    // yes, but nothing else. You can still override it if you want.
    return $denZA.createElement((0, $ad355bde8fa6ee65$export$7cad6f17fd6e117b), $eeb2f69ee8ee5a8f$var$__assign({
        tabIndex: -1
    }, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");




var $38dd6f9105ac1772$var$__assign = undefined && undefined.__assign || function() {
    $38dd6f9105ac1772$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $38dd6f9105ac1772$var$__assign.apply(this, arguments);
};
var $38dd6f9105ac1772$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $38dd6f9105ac1772$export$a766cd26d0d69044 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.allowMultiple, allowMultiple = _b === void 0 ? true : _b, rest = $38dd6f9105ac1772$var$__rest(_a, [
        "allowMultiple"
    ]);
    return $denZA.createElement((0, $ad355bde8fa6ee65$export$a766cd26d0d69044), $38dd6f9105ac1772$var$__assign({
        allowMultiple: allowMultiple
    }, rest, {
        ref: ref
    }));
});
$38dd6f9105ac1772$export$a766cd26d0d69044.Button = (0, $453392015bdf0bf5$export$b9675c0bae9f505a);
$38dd6f9105ac1772$export$a766cd26d0d69044.Icon = (0, $9a88cf76793c5638$export$11c5044b59af4824);
$38dd6f9105ac1772$export$a766cd26d0d69044.Item = (0, $777edd3992d48c34$export$d99097c13d4dac9f);
$38dd6f9105ac1772$export$a766cd26d0d69044.Panel = (0, $eeb2f69ee8ee5a8f$export$7cad6f17fd6e117b);


var $2e19a4abe253c984$export$b9675c0bae9f505a = (0, $453392015bdf0bf5$export$b9675c0bae9f505a);
var $2e19a4abe253c984$export$11c5044b59af4824 = (0, $9a88cf76793c5638$export$11c5044b59af4824);
var $2e19a4abe253c984$export$d99097c13d4dac9f = (0, $777edd3992d48c34$export$d99097c13d4dac9f);
var $2e19a4abe253c984$export$7cad6f17fd6e117b = (0, $eeb2f69ee8ee5a8f$export$7cad6f17fd6e117b);






var $e9414c504ba55072$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $e9414c504ba55072$export$eca1915781c2aaca(prop, mapper) {
    if ((0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(prop)) return prop.map((item)=>{
        if (item === null) return null;
        return mapper(item);
    });
    if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(prop)) return (0, $dfe73229adf076fd$export$259b4dd69e654a7a)(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $e9414c504ba55072$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $e9414c504ba55072$export$d07517a676ce386f;
    var result = bps.map((br)=>{
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while((0, $4cb94e5c0fd5e9d1$export$7475b2c64539e4cf)(result) === null)result.pop();
    return result;
}
function $e9414c504ba55072$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $e9414c504ba55072$export$d07517a676ce386f;
    var result = {};
    values.forEach((value, index)=>{
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $e9414c504ba55072$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $e9414c504ba55072$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $e9414c504ba55072$export$4cdfc817e07de39e = (maybeBreakpoint)=>Number.isNaN(Number(maybeBreakpoint));



var $denZA = parcelRequire("denZA");
function $75893e43f3779b5e$var$_extends() {
    $75893e43f3779b5e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75893e43f3779b5e$var$_extends.apply(this, arguments);
}
function $75893e43f3779b5e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $75893e43f3779b5e$export$e840e8869344ca38 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { ratio: ratio = 4 / 3, children: children, className: className } = props, rest = $75893e43f3779b5e$var$_objectWithoutPropertiesLoose(props, [
        "ratio",
        "children",
        "className"
    ]); // enforce single child
    var child = $denZA.Children.only(children);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-aspect-ratio", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $75893e43f3779b5e$var$_extends({
        ref: ref,
        position: "relative",
        className: _className,
        _before: {
            height: 0,
            content: "\"\"",
            display: "block",
            paddingBottom: (0, $e9414c504ba55072$export$eca1915781c2aaca)(ratio, (r)=>1 / r * 100 + "%")
        },
        __css: {
            "& > *:not(style)": {
                overflow: "hidden",
                position: "absolute",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%"
            },
            "& > img, & > video": {
                objectFit: "cover"
            }
        }
    }, rest), child);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $75893e43f3779b5e$export$e840e8869344ca38.displayName = "AspectRatio";




var $denZA = parcelRequire("denZA");
var $88e70ab841d45384$var$__assign = undefined && undefined.__assign || function() {
    $88e70ab841d45384$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88e70ab841d45384$var$__assign.apply(this, arguments);
};
var $88e70ab841d45384$export$e840e8869344ca38 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $75893e43f3779b5e$export$e840e8869344ca38), $88e70ab841d45384$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
function $60af232ab8afcf31$export$e4da99f09da8b739(props) {
    var { src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    var [status, setStatus] = (0, $denZA.useState)("pending");
    (0, $denZA.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    var imageRef = (0, $denZA.useRef)();
    var load = (0, $denZA.useCallback)(()=>{
        if (!src) return;
        flush();
        var img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad == null || onLoad(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError == null || onError(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError
    ]);
    var flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        /**
     * If user opts out of the fallback/placeholder
     * logic, let's bail out.
     */ if (ignoreFallback) return undefined;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    /**
   * If user opts out of the fallback/placeholder
   * logic, let's just return 'loaded'
   */ return ignoreFallback ? "loaded" : status;
}





var $denZA = parcelRequire("denZA");
function $086ecb59c0419a39$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $086ecb59c0419a39$var$_extends() {
    $086ecb59c0419a39$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $086ecb59c0419a39$var$_extends.apply(this, arguments);
}
var $086ecb59c0419a39$export$e8a770fb79a026fe = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var badgeStyles = $086ecb59c0419a39$var$_extends({
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        insetEnd: "0",
        bottom: "0"
    }, styles.badge);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $086ecb59c0419a39$var$_extends({
        ref: ref
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-avatar__badge", props.className),
        __css: badgeStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $086ecb59c0419a39$export$e8a770fb79a026fe.displayName = "AvatarBadge";
function $086ecb59c0419a39$var$initials(name) {
    var [firstName, lastName] = name.split(" ");
    return firstName && lastName ? "" + firstName.charAt(0) + lastName.charAt(0) : firstName.charAt(0);
}
/**
 * The avatar name container
 */ var $086ecb59c0419a39$var$AvatarName = (props)=>{
    var { name: name, getInitials: getInitials } = props, rest = $086ecb59c0419a39$var$_objectWithoutPropertiesLoose(props, [
        "name",
        "getInitials"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $086ecb59c0419a39$var$_extends({
        role: "img",
        "aria-label": name
    }, rest, {
        __css: styles.label
    }), name ? getInitials == null ? void 0 : getInitials(name) : null);
};
/**
 * Fallback avatar react component.
 * This should be a generic svg used to represent an avatar
 */ var $086ecb59c0419a39$var$DefaultIcon = (props)=>/*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg, $086ecb59c0419a39$var$_extends({
        viewBox: "0 0 128 128",
        color: "#fff",
        width: "100%",
        height: "100%",
        className: "chakra-avatar__svg"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
    }), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
    }));
var $086ecb59c0419a39$export$360b744af11007ac = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "medium",
    position: "relative",
    flexShrink: 0
};
var $086ecb59c0419a39$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Avatar", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { src: src, name: name, showBorder: showBorder, borderRadius: borderRadius = "full", onError: onError, getInitials: getInitials = $086ecb59c0419a39$var$initials, icon: icon = /*#__PURE__*/ $denZA.createElement($086ecb59c0419a39$var$DefaultIcon, null), iconLabel: iconLabel = " avatar", loading: loading, children: children, borderColor: borderColor } = _omitThemingProps, rest = $086ecb59c0419a39$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "src",
        "name",
        "showBorder",
        "borderRadius",
        "onError",
        "getInitials",
        "icon",
        "iconLabel",
        "loading",
        "children",
        "borderColor"
    ]);
    var avatarStyles = $086ecb59c0419a39$var$_extends({
        borderRadius: borderRadius,
        borderWidth: showBorder ? "2px" : undefined
    }, $086ecb59c0419a39$export$360b744af11007ac, styles.container);
    if (borderColor) avatarStyles.borderColor = borderColor;
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $086ecb59c0419a39$var$_extends({
        ref: ref
    }, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-avatar", props.className),
        __css: avatarStyles
    }), /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement($086ecb59c0419a39$var$AvatarImage, {
        src: src,
        loading: loading,
        onError: onError,
        getInitials: getInitials,
        name: name,
        borderRadius: borderRadius,
        icon: icon,
        iconLabel: iconLabel
    }), children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $086ecb59c0419a39$export$e2255cf6045e8d47.displayName = "Avatar";
var $086ecb59c0419a39$var$AvatarImage = (props)=>{
    var { src: src, onError: onError, getInitials: getInitials, name: name, borderRadius: borderRadius, loading: loading, iconLabel: iconLabel, icon: icon = /*#__PURE__*/ $denZA.createElement($086ecb59c0419a39$var$DefaultIcon, null) } = props;
    /**
   * use the image hook to only show the image when it has loaded
   */ var status = (0, $60af232ab8afcf31$export$e4da99f09da8b739)({
        src: src,
        onError: onError
    });
    var hasLoaded = status === "loaded";
    /**
   * Fallback avatar applies under 2 conditions:
   * - If `src` was passed and the image has not loaded or failed to load
   * - If `src` wasn't passed
   *
   * In this case, we'll show either the name avatar or default avatar
   */ var showFallback = !src || !hasLoaded;
    if (showFallback) return name ? /*#__PURE__*/ $denZA.createElement($086ecb59c0419a39$var$AvatarName, {
        className: "chakra-avatar__initials",
        getInitials: getInitials,
        name: name
    }) : /*#__PURE__*/ $denZA.cloneElement(icon, {
        role: "img",
        "aria-label": iconLabel
    });
    /**
   * If `src` was passed and the image has loaded, we'll show it
   */ return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).img, {
        src: src,
        alt: name,
        className: "chakra-avatar__img",
        loading: loading,
        __css: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: borderRadius
        }
    });
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $086ecb59c0419a39$var$AvatarImage.displayName = "AvatarImage";




var $denZA = parcelRequire("denZA");
var $3739aa3aeb1acb76$var$__assign = undefined && undefined.__assign || function() {
    $3739aa3aeb1acb76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3739aa3aeb1acb76$var$__assign.apply(this, arguments);
};
var $3739aa3aeb1acb76$export$e8a770fb79a026fe = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $086ecb59c0419a39$export$e8a770fb79a026fe), $3739aa3aeb1acb76$var$__assign({}, props, {
        ref: ref
    }));
});








var $denZA = parcelRequire("denZA");
var $3b756bd9f7dda047$var$__assign = undefined && undefined.__assign || function() {
    $3b756bd9f7dda047$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b756bd9f7dda047$var$__assign.apply(this, arguments);
};
var $3b756bd9f7dda047$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3b756bd9f7dda047$export$f04a61298a47a40f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, _css = _a.css, rest = $3b756bd9f7dda047$var$__rest(_a, [
        "viewBox",
        "css"
    ]);
    return $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $3b756bd9f7dda047$var$__assign({
        viewBox: viewBox
    }, rest, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $b2905fb15d042d70$var$__assign = undefined && undefined.__assign || function() {
    $b2905fb15d042d70$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2905fb15d042d70$var$__assign.apply(this, arguments);
};
var $b2905fb15d042d70$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2905fb15d042d70$export$761e6d83b3265241 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b2905fb15d042d70$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b2905fb15d042d70$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.597 7.03a1.471 1.471 0 011.226.58.75.75 0 101.194-.908 2.97 2.97 0 00-1.705-1.099V5.25a.75.75 0 10-1.5 0v.363c-.43.095-.828.273-1.158.52-.515.387-.904.978-.904 1.695 0 .716.389 1.308.904 1.694.515.387 1.192.604 1.908.604.422 0 .775.13 1.006.303.23.172.303.354.303.493 0 .138-.073.32-.304.494-.232.173-.586.303-1.009.303h-.03a1.475 1.475 0 01-1.231-.58.75.75 0 10-1.194.91 2.974 2.974 0 001.709 1.098v.353a.75.75 0 001.5 0v-.363c.43-.097.825-.274 1.155-.521.515-.387.904-.978.904-1.694 0-.715-.388-1.306-.902-1.693-.515-.386-1.191-.603-1.907-.603-.422 0-.776-.13-1.008-.303-.23-.174-.304-.356-.304-.495 0-.138.073-.32.304-.494.231-.173.585-.303 1.006-.303h.037zM10.75 15a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm-4.5 3.75a.75.75 0 000 1.5H17.5a.75.75 0 000-1.5H6.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22 21.75V8.12a2.25 2.25 0 00-.659-1.59L15.47.659A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.25v19.5A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.75zM3.25 1.5a.75.75 0 00-.75.75v19.5a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75V9h-5.25A2.25 2.25 0 0113 6.75V1.5H3.25zm12 6h4.94L14.5 1.81v4.94a.75.75 0 00.75.75z",
        fillRule: "evenodd"
    })));
});
$b2905fb15d042d70$export$761e6d83b3265241.displayName = 'AccountingDocument';





var $denZA = parcelRequire("denZA");
var $d4ec132a11b2b5da$var$__assign = undefined && undefined.__assign || function() {
    $d4ec132a11b2b5da$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d4ec132a11b2b5da$var$__assign.apply(this, arguments);
};
var $d4ec132a11b2b5da$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d4ec132a11b2b5da$export$36f90dd5c5d5cc11 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d4ec132a11b2b5da$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d4ec132a11b2b5da$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.34 6.53L16.47.66A2.25 2.25 0 0014.88 0H4.22A2.25 2.25 0 002 2.25v19.5A2.25 2.25 0 004.22 24h16.5a2.25 2.25 0 002.25-2.25V8.12a2.25 2.25 0 00-.63-1.59zm-15.69-.4a3 3 0 011.16-.52v-.36a.75.75 0 011.5 0v.35a3 3 0 011.7 1.1.75.75 0 11-1.19.91A1.47 1.47 0 008.6 7a1.7 1.7 0 00-1 .3.64.64 0 00-.3.49.64.64 0 00.3.49 1.7 1.7 0 001 .3 3.18 3.18 0 011.91.6 2 2 0 010 3.39 3 3 0 01-1.15.52v.36a.75.75 0 11-1.5 0v-.35A3 3 0 016.1 12a.75.75 0 011.19-.91 1.47 1.47 0 001.23.58 1.7 1.7 0 001-.3.55.55 0 000-1 1.69 1.69 0 00-1-.3 3.19 3.19 0 01-1.91-.6 2.13 2.13 0 01-.9-1.69 2.13 2.13 0 01.94-1.65zM18.5 18.75a.75.75 0 110 1.5H7.22a.75.75 0 110-1.5H18.5zm0-3h-6a.75.75 0 110-1.5h6a.75.75 0 110 1.5z"
    })));
});
$d4ec132a11b2b5da$export$36f90dd5c5d5cc11.displayName = 'AccountingDocumentBold';





var $denZA = parcelRequire("denZA");
var $75326d34d42dc495$var$__assign = undefined && undefined.__assign || function() {
    $75326d34d42dc495$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75326d34d42dc495$var$__assign.apply(this, arguments);
};
var $75326d34d42dc495$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $75326d34d42dc495$export$aedfe175f49bfdc8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $75326d34d42dc495$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $75326d34d42dc495$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.06 3.63h13.63a.75.75 0 100-1.5H6.06a.75.75 0 000 1.5zm0 5.62h13.63a.75.75 0 100-1.5H6.06a.75.75 0 000 1.5zm2.75 4.06H6.06a.75.75 0 100 1.5h2.75a.75.75 0 100-1.5zM2.69 3.82a.94.94 0 100-1.88.94.94 0 000 1.88zm0 5.62a.94.94 0 100-1.88.94.94 0 000 1.88zm0 5.56a.94.94 0 100-1.88.94.94 0 000 1.88zm14.19-4.23a6 6 0 100 12 6 6 0 000-12zm0 10.57a4.54 4.54 0 114.54-4.54 4.54 4.54 0 01-4.54 4.55v-.01z"
    }), $denZA.createElement("path", {
        d: "M18.86 16.06h-1.23v-1.33a.75.75 0 10-1.5 0v1.33h-1.29a.75.75 0 100 1.5h1.29v1.36a.75.75 0 101.5 0v-1.36h1.23a.75.75 0 100-1.5z"
    })));
});
$75326d34d42dc495$export$aedfe175f49bfdc8.displayName = 'AddToList';





var $denZA = parcelRequire("denZA");
var $6d3ca313272a185e$var$__assign = undefined && undefined.__assign || function() {
    $6d3ca313272a185e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d3ca313272a185e$var$__assign.apply(this, arguments);
};
var $6d3ca313272a185e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d3ca313272a185e$export$6ebff605926cddee = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6d3ca313272a185e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6d3ca313272a185e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.41 3.86H20a1 1 0 100-2H6.41a1 1 0 000 2zm0 5.62H20a1 1 0 100-2H6.41a1 1 0 000 2zM9.16 13H6.41a1 1 0 000 2h2.75a1 1 0 000-2zM3.02 4.22a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72zm14.18 6.57a6 6 0 100 12 6 6 0 000-12zm2 6.76H18v1.36a.75.75 0 11-1.5 0v-1.37h-1.31a.75.75 0 110-1.5h1.29v-1.33a.75.75 0 111.5 0V16h1.23a.75.75 0 110 1.5l-.01.05zM3.02 9.84a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72zm0 5.56a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72z"
    })));
});
$6d3ca313272a185e$export$6ebff605926cddee.displayName = 'AddToListBold';





var $denZA = parcelRequire("denZA");
var $2a77f1ac5c124366$var$__assign = undefined && undefined.__assign || function() {
    $2a77f1ac5c124366$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a77f1ac5c124366$var$__assign.apply(this, arguments);
};
var $2a77f1ac5c124366$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2a77f1ac5c124366$export$4c2b5ab87db1a6be = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2a77f1ac5c124366$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2a77f1ac5c124366$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.926 11.583l.936-2.47a1.673 1.673 0 00-.647-1.99l-2.231-1.445-.687-2.549a1.673 1.673 0 00-1.693-1.235l-2.599.1-2.08-1.623a1.673 1.673 0 00-2.102 0L9.782 1.994l-2.639-.1A1.673 1.673 0 005.451 3.13l-.697 2.55-2.211 1.443a1.673 1.673 0 00-.647 1.992l.936 2.469-.349.906a.747.747 0 101.394.528l.448-1.165a.747.747 0 000-.528L3.33 8.596a.18.18 0 01.03-.23l2.449-1.592a.747.747 0 00.309-.429l.766-2.818a.18.18 0 01.16-.139l2.987.15a.747.747 0 00.508-.17l2.28-1.832a.18.18 0 01.22 0l2.28 1.832a.747.747 0 00.507.17l2.868-.15a.18.18 0 01.18.13l.766 2.817c.055.186.18.343.348.439l2.45 1.593a.18.18 0 01.07.209l-.996 2.728a.746.746 0 000 .528l.995 2.728a.179.179 0 01-.07.21l-2.449 1.612a.747.747 0 00-.308.428l-.767 2.819a.179.179 0 01-.18.129l-2.917-.15a.747.747 0 00-.508.17l-2.29 1.842a.748.748 0 00.936 1.165l2.051-1.653 2.639.13a1.673 1.673 0 001.693-1.235l.697-2.55 2.21-1.433a1.673 1.673 0 00.648-1.992l-.966-2.47z"
    }), $denZA.createElement("path", {
        d: "M15.557 18.354a.747.747 0 101.265-.797L10.529 7.71a.747.747 0 10-1.265.796v.07L1.14 19.01a.747.747 0 00-.996 1.076l.319.497.996 1.564.318.497a.747.747 0 001.374-.467l1.574-.498.557.856a2.778 2.778 0 003.983.826 2.987 2.987 0 001.076-3.425l5.217-1.583zm-6.522 2.898a1.504 1.504 0 01-.587.926 1.285 1.285 0 01-1.822-.389l-.339-.518 2.688-.836c.096.261.116.544.06.817zm.07-2.45l-.07.02-4.122 1.294h-.06l-2.39.797-.398-.657L10.2 9.96l4.52 7.12-5.615 1.722z"
    })));
});
$2a77f1ac5c124366$export$4c2b5ab87db1a6be.displayName = 'AdvertisingMegaphone';





var $denZA = parcelRequire("denZA");
var $ce83f81c59501297$var$__assign = undefined && undefined.__assign || function() {
    $ce83f81c59501297$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce83f81c59501297$var$__assign.apply(this, arguments);
};
var $ce83f81c59501297$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ce83f81c59501297$export$93d05658c51f49eb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ce83f81c59501297$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ce83f81c59501297$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.855 14.072l-2.163-3.709a.27.27 0 01-.035-.155l.334-4.327c.04-.51-.282-.975-.76-1.096l-4.048-1.028a.253.253 0 01-.13-.084l-2.7-3.306A.972.972 0 0013.07.152L9.51 2.405a.24.24 0 01-.15.037l-4.154-.348a1.03 1.03 0 00-1.052.791L3.071 7.517c-.13.56.198 1.123.735 1.26.537.136 1.078-.207 1.21-.766l.83-3.549a.251.251 0 01.263-.197l3.5.293c.21.016.42-.036.6-.149l3-1.895a.242.242 0 01.32.054l2.262 2.777c.137.166.32.284.524.336l3.407.866c.12.03.2.146.19.274l-.28 3.645a1.07 1.07 0 00.141.625l1.821 3.125a.27.27 0 01-.052.333l-2.67 2.358c-.16.142-.274.333-.324.546l-.83 3.548a.251.251 0 01-.264.198l-3.494-.293c-.551-.046-1.033.382-1.077.956-.044.573.366 1.075.917 1.121l4.555.381h.082c.46 0 .86-.328.97-.793l.988-4.218a.26.26 0 01.081-.136l3.173-2.812c.373-.332.46-.896.206-1.333z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.085 19.835a.538.538 0 01.031-.624l8.28-10.555a.268.268 0 00.015-.313l-.071-.11a.802.802 0 01.21-1.083.732.732 0 011.04.218l6.379 10.007a.802.802 0 01-.21 1.084.722.722 0 01-.414.13.744.744 0 01-.626-.35l-.078-.121a.244.244 0 00-.263-.104l-4.294 1.004a.25.25 0 00-.164.126.269.269 0 00-.018.211c.477 1.427-.142 3-1.444 3.667-1.301.667-2.876.217-3.669-1.048l-.6-.948a.244.244 0 00-.28-.104l-2.257.703a.49.49 0 01-.559-.208L.085 19.835zm5.961 1.273a1.34 1.34 0 001.906.401 1.466 1.466 0 00.496-1.764.248.248 0 00-.3-.145l-2.233.698a.256.256 0 00-.163.161.27.27 0 00.026.233l.268.416z",
        fillRule: "evenodd"
    })));
});
$ce83f81c59501297$export$93d05658c51f49eb.displayName = 'AdvertisingMegaphoneBold';





var $denZA = parcelRequire("denZA");
var $8ed3e5edf09d67cb$var$__assign = undefined && undefined.__assign || function() {
    $8ed3e5edf09d67cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ed3e5edf09d67cb$var$__assign.apply(this, arguments);
};
var $8ed3e5edf09d67cb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8ed3e5edf09d67cb$export$267633f7675997a1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8ed3e5edf09d67cb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8ed3e5edf09d67cb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.23 14.455h-2.022a.223.223 0 01-.223-.189V7.894a.223.223 0 01.223-.189h2.038A.76.76 0 0024 6.951c0-.41-.36-.753-.77-.753h-1.988a1.68 1.68 0 00-1.336.582l-4.368-1.593a3.12 3.12 0 00-2.45.137L10.672 6.54s-.017 0-.017-.017a2.863 2.863 0 00-1.696-.548c-.36 0-.72.069-1.062.206L4.454 7.568a1.708 1.708 0 00-1.679-1.353H.754A.735.735 0 000 6.95a.76.76 0 00.754.754h2.021c.103 0 .206.086.223.189v6.355a.243.243 0 00-.034.103.232.232 0 01-.189.103H.754a.76.76 0 00-.754.753.76.76 0 00.754.754h2.038c.531 0 1.028-.257 1.336-.65H5.79l3.272 3.665c.36.428.874.685 1.422.72h.154c.497 0 .977-.172 1.37-.514a2.14 2.14 0 00.703-1.268c.976.017 1.918-.548 2.295-1.508.018-.05.035-.102.052-.154h.051c.052 0 .086 0 .137-.017l4.66-.89c.308.36.77.582 1.285.582h2.038a.76.76 0 00.754-.754c0-.411-.343-.72-.754-.72zM13.755 6.66a1.56 1.56 0 011.268-.068l4.454 1.627v5.705l-2.365.445c.018-.103.035-.223.035-.325 0-.48-.154-.943-.446-1.337l-2.5-3.169.428-.137a.756.756 0 00.48-.942.756.756 0 00-.943-.48l-3.46 1.13c-.189.07-.412-.033-.497-.222a.406.406 0 01.188-.548l3.358-1.679zm-1.32 9.696l-.033-.017-.874-.874a.755.755 0 00-1.062 0 .755.755 0 000 1.063l.754.753v.309a.553.553 0 01-.206.445.564.564 0 01-.428.137.634.634 0 01-.411-.206L6.68 14.043a.764.764 0 00-.565-.256H4.488V9.16L8.48 7.568c.154-.068.325-.103.496-.103.052 0 .103 0 .155.017a1.9 1.9 0 001.456 3.135c.205 0 .394-.034.6-.102l1.524-.497 2.81 3.597c.085.12.136.274.136.428a.725.725 0 01-.205.514.697.697 0 01-.514.206h-.171l-1.25-1.25a.755.755 0 00-1.063 0 .755.755 0 000 1.062l1.2 1.199c0 .017-.018.051-.018.068-.206.48-.72.703-1.2.514z"
    })));
});
$8ed3e5edf09d67cb$export$267633f7675997a1.displayName = 'Agreement';





var $denZA = parcelRequire("denZA");
var $7a88921e0f7c2963$var$__assign = undefined && undefined.__assign || function() {
    $7a88921e0f7c2963$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a88921e0f7c2963$var$__assign.apply(this, arguments);
};
var $7a88921e0f7c2963$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a88921e0f7c2963$export$dfd6c0dab96dd991 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7a88921e0f7c2963$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7a88921e0f7c2963$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1 16.25h1.667a1.861 1.861 0 001.784-1.5c.033-.146.05-.295.049-.444V14a.25.25 0 01.25-.25H6a.5.5 0 01.373.167l3.59 4.023a.87.87 0 001.537-.561v-.318a.249.249 0 00-.073-.177l-.781-.78a.5.5 0 01.708-.708l.927.928.083.033a1.192 1.192 0 001.585-.764.249.249 0 00-.062-.249L12.646 14.1a.5.5 0 01.708-.708l1.28 1.281c.047.047.11.073.177.073H15a1 1 0 00.8-1.6l-2.874-3.678a.251.251 0 00-.276-.083l-1.56.515a1.686 1.686 0 01-1.8-2.712.251.251 0 00-.154-.413 1.668 1.668 0 00-.838.1L4.843 8.252A.25.25 0 014.5 8.02v-.326c0-.124-.011-.247-.034-.369a1.867 1.867 0 00-1.8-1.575H1a1 1 0 00-1 1v8.5a1 1 0 001 1z"
    }), $denZA.createElement("path", {
        d: "M14.656 8.726l-.49.161a.25.25 0 00-.166.164.248.248 0 00.043.226l2.557 3.266a2.027 2.027 0 01.374 1.526.25.25 0 00.294.286l1.935-.368a.255.255 0 01.206.053.249.249 0 01.091.193v.073c0 .212.035.423.1.625.23.77.931 1.303 1.735 1.319H23a1 1 0 001-1v-8.5a1 1 0 00-1-1h-1.667a1.794 1.794 0 00-1.442.747 1.969 1.969 0 00-.319.659.252.252 0 01-.327.17l-4.015-1.46a1.95 1.95 0 00-1.518.087l-3.455 1.728a.686.686 0 00.52 1.265l3.567-1.171a.5.5 0 01.312.951z"
    })));
});
$7a88921e0f7c2963$export$dfd6c0dab96dd991.displayName = 'AgreementBold';





var $denZA = parcelRequire("denZA");
var $7a54d2007fd269e6$var$__assign = undefined && undefined.__assign || function() {
    $7a54d2007fd269e6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a54d2007fd269e6$var$__assign.apply(this, arguments);
};
var $7a54d2007fd269e6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a54d2007fd269e6$export$caec2af78bcc877f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7a54d2007fd269e6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7a54d2007fd269e6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M13.934 21.021a.73.73 0 00-.924.514 1.34 1.34 0 01-.908.907 1.297 1.297 0 01-1.01-.102 1.265 1.265 0 01-.633-.788.764.764 0 00-.924-.514.764.764 0 00-.514.925c.205.719.702 1.318 1.352 1.695.428.222.89.342 1.353.342.274 0 .53-.034.804-.12a2.836 2.836 0 001.918-1.917.76.76 0 00-.514-.942zm7.258-2.858c-.137-.172-1.232-1.73-1.232-7.67 0-4.296-3.304-7.823-7.498-8.2V.754A.76.76 0 0011.709 0a.76.76 0 00-.754.753v1.54c-4.176.395-7.463 3.921-7.463 8.2 0 5.872-1.335 7.772-1.335 7.772a.769.769 0 00-.086.788c.12.257.394.428.668.428h17.974c.342 0 .668-.189.753-.514.086-.308 0-.616-.274-.804zM3.937 17.99c.48-1.232 1.044-3.543 1.044-7.497 0-3.715 3.03-6.745 6.745-6.745 3.714 0 6.744 3.03 6.744 6.745 0 4.04.497 6.282.959 7.497H3.937z"
    })));
});
$7a54d2007fd269e6$export$caec2af78bcc877f.displayName = 'Alert';





var $denZA = parcelRequire("denZA");
var $d75623978a264034$var$__assign = undefined && undefined.__assign || function() {
    $d75623978a264034$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d75623978a264034$var$__assign.apply(this, arguments);
};
var $d75623978a264034$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d75623978a264034$export$b064d7839e1e373e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d75623978a264034$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d75623978a264034$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M19.985 10.491c0-4.032-2.906-7.387-6.728-8.103V1.5a1.5 1.5 0 00-3 0v.879c-3.839.703-6.763 4.073-6.763 8.112 0 5.88-1.337 7.783-1.337 7.783a.77.77 0 00-.086.789c.12.257.394.428.669.428h18c.343 0 .668-.188.754-.514.086-.308 0-.617-.274-.806-.137-.171-1.235-1.731-1.235-7.68zM9.006 21.78a.762.762 0 01.54-.729l4.405-.017c.394.12.634.532.514.943 0 0-.208 2.023-2.708 2.023S9.03 21.977 9.03 21.977a.77.77 0 01-.025-.196z"
    })));
});
$d75623978a264034$export$b064d7839e1e373e.displayName = 'AlertBold';





var $denZA = parcelRequire("denZA");
var $bcd64c86b846f9eb$var$__assign = undefined && undefined.__assign || function() {
    $bcd64c86b846f9eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bcd64c86b846f9eb$var$__assign.apply(this, arguments);
};
var $bcd64c86b846f9eb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bcd64c86b846f9eb$export$2b3af6baec22bd98 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bcd64c86b846f9eb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bcd64c86b846f9eb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.75 0a.75.75 0 01.75.75v9.175L6.045 7.2a2.25 2.25 0 114.448-.273l2.874 1.277.042-.044a2.25 2.25 0 012.33-.534l3.837-4.796a2.25 2.25 0 11.9 1.276l-3.565 4.457a2.25 2.25 0 11-4.154 1.011L9.884 8.297a2.25 2.25 0 01-3.067.188L1.5 11.675v7.361l3.017-1.508A2.249 2.249 0 018.871 16.5h3.258a2.25 2.25 0 013.61-.936l3.761-2.09a2.25 2.25 0 11.5 1.44l-3.531 1.96a2.253 2.253 0 01-.628 1.967A2.25 2.25 0 0112.129 18H8.87a2.25 2.25 0 01-3.683.87L1.5 20.712V22.5h21.75a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0zM7.5 17.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM21.082 2.59l.016.031a.748.748 0 001.182.16.75.75 0 10-1.198-.19zM7.607 7.137l.004.006a.75.75 0 10-.007-.012l.003.006zM13.72 17.78a.75.75 0 111.06-1.06.75.75 0 01-1.06 1.06zm7.308-4.076a.75.75 0 10-.005-.02l.004.013.001.007zM14.47 9.22a.75.75 0 111.06 1.06.75.75 0 01-1.06-1.06z",
        fillRule: "evenodd"
    })));
});
$bcd64c86b846f9eb$export$2b3af6baec22bd98.displayName = 'Analytics';





var $denZA = parcelRequire("denZA");
var $ce82bdbec7116bef$var$__assign = undefined && undefined.__assign || function() {
    $ce82bdbec7116bef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce82bdbec7116bef$var$__assign.apply(this, arguments);
};
var $ce82bdbec7116bef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ce82bdbec7116bef$export$9049d419d18206b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ce82bdbec7116bef$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ce82bdbec7116bef$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.876 6.451A2.978 2.978 0 0118.5 5a.153.153 0 00-.06-.121.157.157 0 00-.133-.025l-5 1.4a.253.253 0 00-.154.357c.227.428.346.905.347 1.389a.208.208 0 00.263.2l4.961-1.386a.25.25 0 00.152-.363zm-.058 9.495a.248.248 0 00-.17-.136l-4.842-1.127a.248.248 0 00-.307.249V15c0 .445-.098.884-.29 1.285a.251.251 0 00.17.352l4.813 1.121a.255.255 0 00.213-.049.25.25 0 00.094-.2V17.5c0-.463.108-.92.315-1.335a.255.255 0 00.004-.219z"
    }), $denZA.createElement("path", {
        d: "M1 0a1 1 0 00-1 1v21.522c.004.819.67 1.48 1.489 1.478H23a1 1 0 100-2H2.25a.249.249 0 01-.25-.25v-.05a.25.25 0 01.119-.213l6.314-3.881a.25.25 0 00.039-.4 3 3 0 01-.778-1.147.25.25 0 00-.365-.124l-4.948 3.043A.251.251 0 012 18.765v-2.649a.25.25 0 01.1-.2l6.636-5.1a.25.25 0 000-.4 3.022 3.022 0 01-.9-1.056.25.25 0 00-.375-.084L2.4 13.162a.25.25 0 01-.4-.2V1a1 1 0 00-1-1z"
    }), $denZA.createElement("path", {
        d: "M12.5 8a2 2 0 11-4 0 2 2 0 014 0zm11-3a2 2 0 11-4 0 2 2 0 014 0zm0 12.5a2 2 0 11-4 0 2 2 0 014 0zm-11-2.5a2 2 0 11-4 0 2 2 0 014 0z"
    })));
});
$ce82bdbec7116bef$export$9049d419d18206b.displayName = 'AnalyticsBold';





var $denZA = parcelRequire("denZA");
var $16fe78cf12ccbc6e$var$__assign = undefined && undefined.__assign || function() {
    $16fe78cf12ccbc6e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16fe78cf12ccbc6e$var$__assign.apply(this, arguments);
};
var $16fe78cf12ccbc6e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16fe78cf12ccbc6e$export$c994623dcd067c12 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $16fe78cf12ccbc6e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $16fe78cf12ccbc6e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21 3.75a.75.75 0 00-1.166-.624l-1.134.756A21.55 21.55 0 016.751 7.5H4.5a4.5 4.5 0 000 9h1.535a7.988 7.988 0 002.448 5.043.75.75 0 101.034-1.086 6.49 6.49 0 01-1.972-3.942A21.55 21.55 0 0118.7 20.118l1.134.756A.75.75 0 0021 20.25V3.75zM7.5 15.012a23.05 23.05 0 0112 3.837V5.15a23.05 23.05 0 01-12 3.837v6.024zM6 9H4.5a3 3 0 100 6H6V9z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M23.25 9.75a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    })));
});
$16fe78cf12ccbc6e$export$c994623dcd067c12.displayName = 'Announcement';





var $denZA = parcelRequire("denZA");
var $9beedd73361c616e$var$__assign = undefined && undefined.__assign || function() {
    $9beedd73361c616e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9beedd73361c616e$var$__assign.apply(this, arguments);
};
var $9beedd73361c616e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9beedd73361c616e$export$4c30be745f22bee4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9beedd73361c616e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9beedd73361c616e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20.712 3.09a.754.754 0 01.398.664V20.34a.754.754 0 01-1.172.628l-1.14-.76a21.663 21.663 0 00-11.214-3.622 6.523 6.523 0 001.983 3.962.754.754 0 11-1.04 1.093 8.03 8.03 0 01-2.46-5.07V7.524h.72a21.672 21.672 0 0012.011-3.637l1.14-.76a.754.754 0 01.774-.038zM1.325 8.848a4.524 4.524 0 013.199-1.324v9.047a4.524 4.524 0 01-3.2-7.723zm21.545.56a1.13 1.13 0 00-1.132 1.131v3.016a1.13 1.13 0 002.262 0v-3.016a1.13 1.13 0 00-1.13-1.13z"
    })));
});
$9beedd73361c616e$export$4c30be745f22bee4.displayName = 'AnnouncementBold';





var $denZA = parcelRequire("denZA");
var $a0bbeb14f0b8dca1$var$__assign = undefined && undefined.__assign || function() {
    $a0bbeb14f0b8dca1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0bbeb14f0b8dca1$var$__assign.apply(this, arguments);
};
var $a0bbeb14f0b8dca1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a0bbeb14f0b8dca1$export$1fa5a43af950a186 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a0bbeb14f0b8dca1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a0bbeb14f0b8dca1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.445 8.495a.75.75 0 011.06-.05L12 17.986l10.495-9.541a.75.75 0 011.01 1.11l-11 10a.75.75 0 01-1.01 0l-11-10a.75.75 0 01-.05-1.06z",
        fillRule: "evenodd"
    })));
});
$a0bbeb14f0b8dca1$export$1fa5a43af950a186.displayName = 'ArrowDown';





var $denZA = parcelRequire("denZA");
var $bcdb91cd5aa62a89$var$__assign = undefined && undefined.__assign || function() {
    $bcdb91cd5aa62a89$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bcdb91cd5aa62a89$var$__assign.apply(this, arguments);
};
var $bcdb91cd5aa62a89$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bcdb91cd5aa62a89$export$2fbb36af09846aa0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bcdb91cd5aa62a89$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bcdb91cd5aa62a89$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2.506 7.888a1.5 1.5 0 00-2.012 2.224l10.5 9.5a1.5 1.5 0 002.012 0l10.5-9.5a1.5 1.5 0 10-2.012-2.224L12 16.478l-9.494-8.59z"
    })));
});
$bcdb91cd5aa62a89$export$2fbb36af09846aa0.displayName = 'ArrowDownBold';





var $denZA = parcelRequire("denZA");
var $35fc096efe109aee$var$__assign = undefined && undefined.__assign || function() {
    $35fc096efe109aee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35fc096efe109aee$var$__assign.apply(this, arguments);
};
var $35fc096efe109aee$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $35fc096efe109aee$export$e4c291d45fea4cd0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $35fc096efe109aee$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $35fc096efe109aee$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.505.445a.75.75 0 01.05 1.06L6.014 12l9.541 10.495a.75.75 0 01-1.11 1.01l-10-11a.75.75 0 010-1.01l10-11a.75.75 0 011.06-.05z",
        fillRule: "evenodd"
    })));
});
$35fc096efe109aee$export$e4c291d45fea4cd0.displayName = 'ArrowLeft';





var $denZA = parcelRequire("denZA");
var $e028bfb9028bef16$var$__assign = undefined && undefined.__assign || function() {
    $e028bfb9028bef16$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e028bfb9028bef16$var$__assign.apply(this, arguments);
};
var $e028bfb9028bef16$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e028bfb9028bef16$export$ea9a5c7ec18f8eaf = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e028bfb9028bef16$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e028bfb9028bef16$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M16.006.388a1.5 1.5 0 01.106 2.118L7.522 12l8.59 9.494a1.5 1.5 0 01-2.224 2.012l-9.5-10.5a1.5 1.5 0 010-2.012l9.5-10.5a1.5 1.5 0 012.118-.106z",
        fillRule: "evenodd"
    })));
});
$e028bfb9028bef16$export$ea9a5c7ec18f8eaf.displayName = 'ArrowLeftBold';





var $denZA = parcelRequire("denZA");
var $5d6bb6dce0d9dfc4$var$__assign = undefined && undefined.__assign || function() {
    $5d6bb6dce0d9dfc4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5d6bb6dce0d9dfc4$var$__assign.apply(this, arguments);
};
var $5d6bb6dce0d9dfc4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5d6bb6dce0d9dfc4$export$fb2824d245253d9b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5d6bb6dce0d9dfc4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5d6bb6dce0d9dfc4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a.75.75 0 01.75.75v19.305l6.747-6.132a.75.75 0 011.009 1.11l-8.002 7.272a.75.75 0 01-1.008 0l-8-7.27a.75.75 0 111.008-1.11l6.746 6.13V1.5A.75.75 0 0112 .75z",
        fillRule: "evenodd"
    })));
});
$5d6bb6dce0d9dfc4$export$fb2824d245253d9b.displayName = 'ArrowLongDown';





var $denZA = parcelRequire("denZA");
var $241b3ea152675b96$var$__assign = undefined && undefined.__assign || function() {
    $241b3ea152675b96$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $241b3ea152675b96$var$__assign.apply(this, arguments);
};
var $241b3ea152675b96$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $241b3ea152675b96$export$a2ec4c6969a7d302 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $241b3ea152675b96$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $241b3ea152675b96$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a1.5 1.5 0 011.5 1.5v17.61l5.493-4.992a1.5 1.5 0 012.017 2.22l-8 7.272a1.5 1.5 0 01-2.018 0l-8-7.27a1.5 1.5 0 012.018-2.22l5.491 4.99V1.5A1.5 1.5 0 0112 0z",
        fillRule: "evenodd"
    })));
});
$241b3ea152675b96$export$a2ec4c6969a7d302.displayName = 'ArrowLongDownBold';





var $denZA = parcelRequire("denZA");
var $44098a0a828e7c74$var$__assign = undefined && undefined.__assign || function() {
    $44098a0a828e7c74$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44098a0a828e7c74$var$__assign.apply(this, arguments);
};
var $44098a0a828e7c74$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $44098a0a828e7c74$export$5e0a9a0faf09e20c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $44098a0a828e7c74$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $44098a0a828e7c74$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.496.945a.75.75 0 011.008 0l8.002 7.272a.75.75 0 11-1.009 1.11L12.75 3.195V22.5a.75.75 0 01-1.5 0V3.195l-6.746 6.13a.75.75 0 01-1.008-1.11l8-7.27z",
        fillRule: "evenodd"
    })));
});
$44098a0a828e7c74$export$5e0a9a0faf09e20c.displayName = 'ArrowLongUp';





var $denZA = parcelRequire("denZA");
var $c9edd662d879216d$var$__assign = undefined && undefined.__assign || function() {
    $c9edd662d879216d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9edd662d879216d$var$__assign.apply(this, arguments);
};
var $c9edd662d879216d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c9edd662d879216d$export$469287007f7d4034 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c9edd662d879216d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c9edd662d879216d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.991.39a1.5 1.5 0 012.018 0l8.001 7.272a1.5 1.5 0 01-2.017 2.22L13.5 4.89V22.5a1.5 1.5 0 01-3 0V4.89L5.009 9.88A1.5 1.5 0 012.99 7.66l8-7.27z",
        fillRule: "evenodd"
    })));
});
$c9edd662d879216d$export$469287007f7d4034.displayName = 'ArrowLongUpBold';





var $denZA = parcelRequire("denZA");
var $975c747177676d86$var$__assign = undefined && undefined.__assign || function() {
    $975c747177676d86$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $975c747177676d86$var$__assign.apply(this, arguments);
};
var $975c747177676d86$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $975c747177676d86$export$acad20503ad73ac1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $975c747177676d86$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $975c747177676d86$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.495.445a.75.75 0 011.06.05l10 11a.75.75 0 010 1.01l-10 11a.75.75 0 11-1.11-1.01L17.986 12 8.445 1.505a.75.75 0 01.05-1.06z",
        fillRule: "evenodd"
    })));
});
$975c747177676d86$export$acad20503ad73ac1.displayName = 'ArrowRight';





var $denZA = parcelRequire("denZA");
var $bb6a2cf1a1123128$var$__assign = undefined && undefined.__assign || function() {
    $bb6a2cf1a1123128$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb6a2cf1a1123128$var$__assign.apply(this, arguments);
};
var $bb6a2cf1a1123128$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bb6a2cf1a1123128$export$d6d021d74f4bac76 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bb6a2cf1a1123128$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bb6a2cf1a1123128$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.112.494a1.5 1.5 0 10-2.224 2.012L16.478 12l-8.59 9.494a1.5 1.5 0 002.224 2.012l9.5-10.5a1.5 1.5 0 000-2.012l-9.5-10.5z"
    })));
});
$bb6a2cf1a1123128$export$d6d021d74f4bac76.displayName = 'ArrowRightBold';





var $denZA = parcelRequire("denZA");
var $2af4663cee72f702$var$__assign = undefined && undefined.__assign || function() {
    $2af4663cee72f702$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2af4663cee72f702$var$__assign.apply(this, arguments);
};
var $2af4663cee72f702$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2af4663cee72f702$export$2624c5890f1bbcf7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2af4663cee72f702$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2af4663cee72f702$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.495 4.445a.75.75 0 011.01 0l11 10a.75.75 0 01-1.01 1.11L12 6.014 1.505 15.555a.75.75 0 01-1.01-1.11l11-10z",
        fillRule: "evenodd"
    })));
});
$2af4663cee72f702$export$2624c5890f1bbcf7.displayName = 'ArrowUp';





var $denZA = parcelRequire("denZA");
var $f8f202c7fb24d141$var$__assign = undefined && undefined.__assign || function() {
    $f8f202c7fb24d141$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8f202c7fb24d141$var$__assign.apply(this, arguments);
};
var $f8f202c7fb24d141$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f8f202c7fb24d141$export$b524ae00c198b715 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f8f202c7fb24d141$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f8f202c7fb24d141$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.526 1.466a.75.75 0 00-1.052 0l-6.6 6.5a.75.75 0 101.052 1.068L12 3.053l6.074 5.981a.75.75 0 101.052-1.068l-6.6-6.5zm-6.6 13.5a.75.75 0 00-1.052 1.068l6.6 6.5a.75.75 0 001.052 0l6.6-6.5a.75.75 0 00-1.052-1.068L12 20.947l-6.074-5.981z"
    })));
});
$f8f202c7fb24d141$export$b524ae00c198b715.displayName = 'ArrowUpAndDown';





var $denZA = parcelRequire("denZA");
var $43e5b775b79357e9$var$__assign = undefined && undefined.__assign || function() {
    $43e5b775b79357e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43e5b775b79357e9$var$__assign.apply(this, arguments);
};
var $43e5b775b79357e9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $43e5b775b79357e9$export$61bdb2a1da0ccc8a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $43e5b775b79357e9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $43e5b775b79357e9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M13.053.931a1.5 1.5 0 00-2.106 0l-6.6 6.5A1.5 1.5 0 006.453 9.57L12 4.105l5.547 5.464a1.5 1.5 0 102.106-2.138l-6.6-6.5zm-6.6 13.5a1.5 1.5 0 10-2.106 2.138l6.6 6.5a1.5 1.5 0 002.106 0l6.6-6.5a1.5 1.5 0 00-2.105-2.138L12 19.895 6.453 14.43z"
    })));
});
$43e5b775b79357e9$export$61bdb2a1da0ccc8a.displayName = 'ArrowUpAndDownBold';





var $denZA = parcelRequire("denZA");
var $dbc4453014f5d175$var$__assign = undefined && undefined.__assign || function() {
    $dbc4453014f5d175$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dbc4453014f5d175$var$__assign.apply(this, arguments);
};
var $dbc4453014f5d175$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dbc4453014f5d175$export$928b9ecbfcbe86f4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $dbc4453014f5d175$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $dbc4453014f5d175$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.994 4.388a1.5 1.5 0 012.012 0l10.5 9.5a1.5 1.5 0 01-2.012 2.224L12 7.522l-9.494 8.59a1.5 1.5 0 11-2.012-2.224l10.5-9.5z",
        fillRule: "evenodd"
    })));
});
$dbc4453014f5d175$export$928b9ecbfcbe86f4.displayName = 'ArrowUpBold';





var $denZA = parcelRequire("denZA");
var $166add96fd07a523$var$__assign = undefined && undefined.__assign || function() {
    $166add96fd07a523$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $166add96fd07a523$var$__assign.apply(this, arguments);
};
var $166add96fd07a523$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $166add96fd07a523$export$650e18e4b9cea8d1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $166add96fd07a523$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $166add96fd07a523$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.323 2.525c-.985.11-1.817.55-2.177.91l-8 8c-1.78 1.78-2.567 5.373 0 7.94 2.566 2.566 6.158 1.78 7.939 0l8-8a.75.75 0 011.06 1.06l-8 8c-2.22 2.22-6.771 3.289-10.06 0-3.29-3.29-2.22-7.841 0-10.06l8-8c.64-.64 1.807-1.2 3.072-1.34 1.296-.145 2.791.142 3.989 1.34 1.197 1.196 1.484 2.692 1.34 3.987-.141 1.265-.7 2.433-1.34 3.073l-8 8a3.07 3.07 0 01-1.722.824c-.755.098-1.61-.096-2.34-.824-.734-.735-.913-1.603-.811-2.356.097-.715.448-1.34.812-1.705l8-8a.75.75 0 111.06 1.06l-8 8c-.135.137-.333.462-.386.847-.047.348.023.73.387 1.093.369.37.748.441 1.085.397.374-.048.7-.242.854-.397l8-8c.36-.36.8-1.193.91-2.177.106-.955-.107-1.96-.91-2.762-.803-.803-1.807-1.016-2.762-.91z"
    })));
});
$166add96fd07a523$export$650e18e4b9cea8d1.displayName = 'Attach';





var $denZA = parcelRequire("denZA");
var $fc74f82914d3e2a9$var$__assign = undefined && undefined.__assign || function() {
    $fc74f82914d3e2a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc74f82914d3e2a9$var$__assign.apply(this, arguments);
};
var $fc74f82914d3e2a9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fc74f82914d3e2a9$export$50809d59c9e8104e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fc74f82914d3e2a9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fc74f82914d3e2a9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.157 3.02c-.845.094-1.51.474-1.73.695l-8 8c-1.56 1.56-2.205 4.673 0 6.879 2.206 2.205 5.318 1.56 6.879 0l8-8a1.5 1.5 0 012.121 2.12l-8 8c-2.44 2.44-7.471 3.651-11.121 0-3.65-3.65-2.44-8.681 0-11.12l8-8c.779-.78 2.114-1.4 3.52-1.556 1.466-.162 3.207.161 4.601 1.556 1.394 1.394 1.718 3.135 1.555 4.6-.156 1.406-.776 2.742-1.555 3.521l-8 8a3.818 3.818 0 01-2.155 1.038c-.965.125-2.059-.13-2.966-1.038-.92-.92-1.155-2.032-1.025-2.987.12-.88.546-1.656 1.025-2.134l8-8a1.5 1.5 0 112.121 2.12l-8 8v.002a.93.93 0 00-.173.416.504.504 0 00.012.219.59.59 0 00.161.243.63.63 0 00.253.169.468.468 0 00.206.014.861.861 0 00.42-.183l8-8c.22-.221.6-.886.694-1.73.088-.785-.089-1.543-.694-2.15-.606-.605-1.365-.781-2.149-.694z"
    })));
});
$fc74f82914d3e2a9$export$50809d59c9e8104e.displayName = 'AttachBold';





var $denZA = parcelRequire("denZA");
var $f5b8841d1fe948db$var$__assign = undefined && undefined.__assign || function() {
    $f5b8841d1fe948db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5b8841d1fe948db$var$__assign.apply(this, arguments);
};
var $f5b8841d1fe948db$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f5b8841d1fe948db$export$3016537a1ffc38d5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f5b8841d1fe948db$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f5b8841d1fe948db$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M14.102 7.48a1.24 1.24 0 100-2.48 1.24 1.24 0 000 2.48zm-4.76.01a1.24 1.24 0 100-2.48 1.24 1.24 0 000 2.48z"
    }), $denZA.createElement("path", {
        d: "M20.002 23c-1-2.52-3.27-3.92-6.58-3.84-.77 0-1-.3-1.1-.4a2.6 2.6 0 01-.32-1.76c4.29-.07 7.76-3.84 7.76-8.46 0-4.62-3.54-8.54-7.89-8.54s-7.87 3.84-7.87 8.51a8.33 8.33 0 006.53 8.33 3.91 3.91 0 00.62 2.81 2.83 2.83 0 002.3 1c1.83 0 4.23.44 5.15 2.86a.76.76 0 00.7.49.86.86 0 00.27-.05.75.75 0 00.43-.95zM5.482 8.51a6.7 6.7 0 016.39-7 6.7 6.7 0 016.39 7 6.7 6.7 0 01-6.39 7 6.701 6.701 0 01-6.39-7z"
    }), $denZA.createElement("path", {
        d: "M11.832 12.75a5 5 0 01-3.41-1.67.754.754 0 111.13-1 3.58 3.58 0 002.28 1.15 2.8 2.8 0 002-1.15.74.74 0 011-.08.76.76 0 01.17 1.08 4.2 4.2 0 01-3.18 1.67h.01z"
    })));
});
$f5b8841d1fe948db$export$3016537a1ffc38d5.displayName = 'Balloon';





var $denZA = parcelRequire("denZA");
var $885f09eb9c44a729$var$__assign = undefined && undefined.__assign || function() {
    $885f09eb9c44a729$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $885f09eb9c44a729$var$__assign.apply(this, arguments);
};
var $885f09eb9c44a729$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $885f09eb9c44a729$export$22849e2928eb9556 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $885f09eb9c44a729$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $885f09eb9c44a729$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20.599 22.66c-.993-2.6-3.355-3.97-6.74-3.97-.615 0-.833-.219-.893-.298a1.768 1.768 0 01-.268-1.062 8.417 8.417 0 007.355-8.625C20.053 3.97 16.46 0 12.023 0c-4.437 0-8.02 3.97-8.02 8.715a8.496 8.496 0 006.71 8.546 3.772 3.772 0 00.695 2.372 3.107 3.107 0 002.481 1.052c2.531-.05 4.169.863 4.864 2.68a.993.993 0 00.923.635c.121 0 .242-.02.357-.06a.992.992 0 00.566-1.28zM14.445 4.963a1.29 1.29 0 11.02 2.58 1.29 1.29 0 01-.02-2.58zm-4.963 0a1.29 1.29 0 11-1.29 1.28 1.28 1.28 0 011.32-1.28h-.03zm-.903 6.332a.784.784 0 01.08-1.101.794.794 0 011.101.069 3.702 3.702 0 002.372 1.201 2.878 2.878 0 002.125-1.191.784.784 0 011.101-.09.776.776 0 01.169 1.102 4.367 4.367 0 01-3.305 1.747 5.271 5.271 0 01-3.643-1.737z"
    })));
});
$885f09eb9c44a729$export$22849e2928eb9556.displayName = 'BalloonBold';





var $denZA = parcelRequire("denZA");
var $589d43b6b0df1813$var$__assign = undefined && undefined.__assign || function() {
    $589d43b6b0df1813$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $589d43b6b0df1813$var$__assign.apply(this, arguments);
};
var $589d43b6b0df1813$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $589d43b6b0df1813$export$67e8020d92d2196d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $589d43b6b0df1813$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $589d43b6b0df1813$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.44 1.94a1.5 1.5 0 011.06-.44h3A1.5 1.5 0 0115 3v18h1.5V7.5A1.5 1.5 0 0118 6h3a1.5 1.5 0 011.5 1.5V21h.75a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h.75v-9A1.5 1.5 0 013 10.5h3A1.5 1.5 0 017.5 12v9H9V3c0-.398.158-.78.44-1.06zM21 21V7.5h-3V21h3zM10.5 3h3v18h-3V3zM6 21v-9H3v9h3z",
        fillRule: "evenodd"
    })));
});
$589d43b6b0df1813$export$67e8020d92d2196d.displayName = 'BarGraph';





var $denZA = parcelRequire("denZA");
var $a033fc9db7b7e8f1$var$__assign = undefined && undefined.__assign || function() {
    $a033fc9db7b7e8f1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a033fc9db7b7e8f1$var$__assign.apply(this, arguments);
};
var $a033fc9db7b7e8f1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a033fc9db7b7e8f1$export$d9a1a352ba187da6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a033fc9db7b7e8f1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a033fc9db7b7e8f1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1.25 17h3.5a.249.249 0 00.25-.25v-2a1 1 0 00-1-1H2a1 1 0 00-1 1v2a.25.25 0 00.25.25zM8 8.75a1 1 0 00-1 1v7a.25.25 0 00.25.25h3.5a.25.25 0 00.25-.25v-7a1 1 0 00-1-1H8zm6 2a1 1 0 00-1 1v5a.25.25 0 00.25.25h3.5a.25.25 0 00.25-.25v-5a1 1 0 00-1-1h-2zM19.25 17h3.5a.25.25 0 00.25-.25v-12a1 1 0 00-1-1h-2a1 1 0 00-1 1v12a.25.25 0 00.25.25zM1 20.25h22a1 1 0 100-2H1a1 1 0 100 2z"
    })));
});
$a033fc9db7b7e8f1$export$d9a1a352ba187da6.displayName = 'BarGraphBold';





var $denZA = parcelRequire("denZA");
var $71cea9caf5fef8af$var$__assign = undefined && undefined.__assign || function() {
    $71cea9caf5fef8af$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71cea9caf5fef8af$var$__assign.apply(this, arguments);
};
var $71cea9caf5fef8af$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $71cea9caf5fef8af$export$3f015ab66c3e5653 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $71cea9caf5fef8af$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $71cea9caf5fef8af$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.293.076a.755.755 0 01.793.082l6.774 5.25a.75.75 0 01.053 1.138l-6.002 5.63 5.984 5.262a.749.749 0 01-.035 1.154l-6.774 5.25a.755.755 0 01-1.215-.592v-9.161L6.12 18.546a.755.755 0 01-1.064-.032.748.748 0 01.032-1.06l5.59-5.243-5.572-4.899a.748.748 0 01-.067-1.058.754.754 0 011.063-.066l4.77 4.194V.75a.75.75 0 01.422-.674zm1.083 13.63l4.842 4.258-4.842 3.753v-8.01zm0-3.089V2.283l4.865 3.771-4.865 4.563z",
        fillRule: "evenodd"
    })));
});
$71cea9caf5fef8af$export$3f015ab66c3e5653.displayName = 'Bluetooth';





var $denZA = parcelRequire("denZA");
var $7138d8f9c1d0c45d$var$__assign = undefined && undefined.__assign || function() {
    $7138d8f9c1d0c45d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7138d8f9c1d0c45d$var$__assign.apply(this, arguments);
};
var $7138d8f9c1d0c45d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7138d8f9c1d0c45d$export$1580d3dda9c7bd02 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7138d8f9c1d0c45d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7138d8f9c1d0c45d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18.737 8.21a2.172 2.172 0 00.063-3.157L14.265.57a1.688 1.688 0 00-1.858-.462 1.68 1.68 0 00-.975 1.64v6.768a.25.25 0 01-.42.184L6.69 4.733a1.256 1.256 0 00-1.772.072c-.47.508-.437 1.3.072 1.768l5.712 5.233a.249.249 0 010 .369l-5.735 5.244a1.249 1.249 0 00.465 2.126c.431.133.901.025 1.23-.283l4.353-3.984a.251.251 0 01.42.184v6.782c-.047.697.341 1.35.976 1.642.181.076.375.114.572.114.488-.016.95-.224 1.283-.58l4.534-4.48a2.175 2.175 0 00-.06-3.156l-3.933-3.607a.25.25 0 010-.37l3.93-3.597zm-2.133 9.011a.253.253 0 01.006.362L14.37 19.8a.251.251 0 01-.427-.178v-4.27a.25.25 0 01.42-.184l2.241 2.054zm-2.511-8.36a.25.25 0 00.27-.043l2.24-2.048a.25.25 0 00.006-.362l-2.24-2.214a.251.251 0 00-.426.177v4.263c0 .1.06.188.15.228z",
        fillRule: "evenodd"
    })));
});
$7138d8f9c1d0c45d$export$1580d3dda9c7bd02.displayName = 'BluetoothBold';





var $denZA = parcelRequire("denZA");
var $d312f1fb3abd8e16$var$__assign = undefined && undefined.__assign || function() {
    $d312f1fb3abd8e16$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d312f1fb3abd8e16$var$__assign.apply(this, arguments);
};
var $d312f1fb3abd8e16$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d312f1fb3abd8e16$export$c959ddfb5bf9a14a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d312f1fb3abd8e16$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d312f1fb3abd8e16$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M14.262 11.668a.758.758 0 00.678.428.727.727 0 00.33-.08c1.7-.733 3.53-1.116 5.381-1.126a.758.758 0 000-1.505 15.15 15.15 0 00-6.04 1.276.758.758 0 00-.349 1.007zm6.389 1.953c-2.08 0-4.137.435-6.04 1.276a.758.758 0 00-.349.996.746.746 0 00.678.419.717.717 0 00.33-.07 13.953 13.953 0 015.381-1.126.758.758 0 000-1.505v.01zm-17.471-3.1c1.848.011 3.675.394 5.372 1.127a.758.758 0 00.658-1.365 15.129 15.129 0 00-6.03-1.277.757.757 0 000 1.515zm6.03 3.997a15.129 15.129 0 00-6.03-1.276.758.758 0 000 1.515c1.847.01 3.673.39 5.372 1.117.102.05.214.076.328.08a.757.757 0 00.33-1.436z"
    }), $denZA.createElement("path", {
        d: "M23.113 1.581c-1.186-.14-6.957-.397-11.153 2.085C7.774 1.184 1.993 1.442.827 1.58A.997.997 0 000 2.578v16.306a.997.997 0 00.997.996c3.475.07 6.894.885 10.026 2.392.31.152.652.23.997.23.315-.004.625-.079.907-.22a24.199 24.199 0 0110.076-2.422.997.997 0 00.997-.997V2.548a.997.997 0 00-.887-.967zM1.505 18.385V3.006c1.694-.209 6.359-.028 9.718 1.985v15.706a25.585 25.585 0 00-9.718-2.312zm20.93 0c-3.35.13-6.64.915-9.687 2.312V4.932c3.358-1.994 7.973-2.165 9.687-1.965v15.418z"
    })));
});
$d312f1fb3abd8e16$export$c959ddfb5bf9a14a.displayName = 'Book';





var $denZA = parcelRequire("denZA");
var $f79bfb236b99390c$var$__assign = undefined && undefined.__assign || function() {
    $f79bfb236b99390c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f79bfb236b99390c$var$__assign.apply(this, arguments);
};
var $f79bfb236b99390c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f79bfb236b99390c$export$40e61833fc3d637 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f79bfb236b99390c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f79bfb236b99390c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.29 1.586c-1.986-.23-7.45-.089-11.29 2.437C8.17 1.497 2.704 1.334.72 1.586a.861.861 0 00-.72.863v16.4a.865.865 0 00.84.853 26.428 26.428 0 0110.57 2.69c.41.144.856.144 1.266 0a26.82 26.82 0 0110.57-2.69.85.85 0 00.753-.82v-16.4a.865.865 0 00-.71-.896zM9.425 16.706a.83.83 0 01-.698.426.871.871 0 01-.404 0 15.144 15.144 0 00-5.88-1.224.828.828 0 01-.828-.831.832.832 0 01.829-.83c2.254.014 4.48.49 6.545 1.399a.83.83 0 01.436 1.06zm0-4.646a.83.83 0 01-1.102.393 15.035 15.035 0 00-5.88-1.235.828.828 0 01-.316-1.592c.1-.04.208-.06.317-.06 2.253.015 4.48.487 6.545 1.39a.841.841 0 01.436 1.104zm12.13 4.209a15.037 15.037 0 00-5.88 1.235.85.85 0 01-.36.077.818.818 0 01-.717-1.157.82.82 0 01.358-.385 16.332 16.332 0 016.6-1.4.826.826 0 01.85.486.833.833 0 01-.85 1.166v-.022zm0-4.647a14.904 14.904 0 00-5.88 1.236.872.872 0 01-.36.087.827.827 0 01-.797-.645.833.833 0 01.438-.93 16.527 16.527 0 016.6-1.399.827.827 0 01.923.826.833.833 0 01-.579.792.826.826 0 01-.345.033z"
    })));
});
$f79bfb236b99390c$export$40e61833fc3d637.displayName = 'BookBold';





var $denZA = parcelRequire("denZA");
var $cc29386958cf7d45$var$__assign = undefined && undefined.__assign || function() {
    $cc29386958cf7d45$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc29386958cf7d45$var$__assign.apply(this, arguments);
};
var $cc29386958cf7d45$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cc29386958cf7d45$export$acd2cbead02af9c1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $cc29386958cf7d45$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $cc29386958cf7d45$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75z"
    })));
});
$cc29386958cf7d45$export$acd2cbead02af9c1.displayName = 'BookmarkFavourite';





var $denZA = parcelRequire("denZA");
var $f14fc072b6be0e79$var$__assign = undefined && undefined.__assign || function() {
    $f14fc072b6be0e79$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f14fc072b6be0e79$var$__assign.apply(this, arguments);
};
var $f14fc072b6be0e79$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f14fc072b6be0e79$export$cea5fccc97fad67f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f14fc072b6be0e79$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f14fc072b6be0e79$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5z"
    })));
});
$f14fc072b6be0e79$export$cea5fccc97fad67f.displayName = 'BookmarkFavouriteBold';





var $denZA = parcelRequire("denZA");
var $792ba95f841ef67e$var$__assign = undefined && undefined.__assign || function() {
    $792ba95f841ef67e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $792ba95f841ef67e$var$__assign.apply(this, arguments);
};
var $792ba95f841ef67e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $792ba95f841ef67e$export$142047257e111cb6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $792ba95f841ef67e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $792ba95f841ef67e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.75 0A2.25 2.25 0 0121 2.25v20.252a1.5 1.5 0 01-2.382 1.21L12.44 19.22a.75.75 0 00-.882 0l-6.177 4.492A1.5 1.5 0 013 22.5V2.25A2.25 2.25 0 015.25 0h13.5zm0 1.5H5.25a.75.75 0 00-.75.75v20.248l6.177-4.492a2.25 2.25 0 012.646 0l6.177 4.492V2.25a.75.75 0 00-.75-.75zM12 4.715c.507 0 .97.285 1.199.736l1.039 2.047 1.65.001c.502-.012.965.26 1.202.694l.059.123a1.33 1.33 0 01-.298 1.468l-1.586 1.56.88 2.022a1.34 1.34 0 01-.249 1.424l-.102.1c-.432.38-1.058.44-1.548.156L12 13.778l-2.237 1.26a1.339 1.339 0 01-1.445-.064l-.111-.088a1.342 1.342 0 01-.348-1.533l.876-2.013-1.58-1.556a1.332 1.332 0 01-.349-1.344l.046-.128c.212-.506.713-.83 1.243-.817l1.667-.001 1.04-2.042c.208-.41.61-.684 1.062-.73L12 4.715zm-.001 1.688l-1.11 2.182a.75.75 0 01-.668.41L8.49 8.994l1.664 1.638a.75.75 0 01.2.726l-.038.108-.889 2.038 2.205-1.24a.75.75 0 01.636-.047l.1.048 2.203 1.242-.887-2.037a.75.75 0 01.086-.747l.076-.087 1.664-1.638-1.731.001a.75.75 0 01-.615-.32l-.054-.09L12 6.403z"
    })));
});
$792ba95f841ef67e$export$142047257e111cb6.displayName = 'BookmarkFavouriteStar';





var $denZA = parcelRequire("denZA");
var $ed7a6da5ec9adad7$var$__assign = undefined && undefined.__assign || function() {
    $ed7a6da5ec9adad7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed7a6da5ec9adad7$var$__assign.apply(this, arguments);
};
var $ed7a6da5ec9adad7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ed7a6da5ec9adad7$export$848b7e76934f1777 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ed7a6da5ec9adad7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ed7a6da5ec9adad7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21 2.25A2.25 2.25 0 0018.75 0H5.25A2.25 2.25 0 003 2.25V22.5a1.5 1.5 0 002.382 1.212l6.177-4.492a.75.75 0 01.882 0l6.177 4.492A1.5 1.5 0 0021 22.502V2.25zm-9.737 4.005c.232-.714 1.242-.714 1.474 0l.652 2.008c.004.01.013.017.024.017h2.111c.751 0 1.063.96.456 1.402l-1.708 1.24a.025.025 0 00-.01.029l.653 2.007c.232.714-.585 1.308-1.192.867l-1.708-1.241a.025.025 0 00-.03 0l-1.707 1.24c-.608.442-1.425-.152-1.193-.866l.652-2.007a.025.025 0 00-.009-.028L8.02 9.682c-.607-.441-.295-1.402.456-1.402h2.11a.026.026 0 00.025-.017l.652-2.008z",
        fillRule: "evenodd"
    })));
});
$ed7a6da5ec9adad7$export$848b7e76934f1777.displayName = 'BookmarkFavouriteStarBold';





var $denZA = parcelRequire("denZA");
var $e91451c7f171b90d$var$__assign = undefined && undefined.__assign || function() {
    $e91451c7f171b90d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e91451c7f171b90d$var$__assign.apply(this, arguments);
};
var $e91451c7f171b90d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e91451c7f171b90d$export$d763173d10f54f27 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e91451c7f171b90d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e91451c7f171b90d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.345 24H2.718A2.729 2.729 0 010 21.282V2.718A2.729 2.729 0 012.718 0h18.564A2.729 2.729 0 0124 2.718v18.627A2.655 2.655 0 0121.345 24zM2.718 1.58A1.148 1.148 0 001.58 2.718v18.564a1.149 1.149 0 001.138 1.138h18.627a1.053 1.053 0 001.054-1.054V2.718A1.149 1.149 0 0021.26 1.58H2.718z"
    }), $denZA.createElement("path", {
        d: "M6.943 10.483a3.382 3.382 0 110-6.765 3.382 3.382 0 010 6.765zm0-5.184a1.802 1.802 0 101.802 1.802 1.812 1.812 0 00-1.802-1.802zm9.935 5.184a3.382 3.382 0 110-6.764 3.382 3.382 0 010 6.764zm0-5.184a1.801 1.801 0 101.802 1.802 1.812 1.812 0 00-1.802-1.802zM7.122 20.28a3.382 3.382 0 110-6.763 3.382 3.382 0 010 6.764zm0-5.183a1.801 1.801 0 100 3.603 1.801 1.801 0 000-3.602zm9.935 5.184a3.382 3.382 0 11-.02-6.765 3.382 3.382 0 01.02 6.765zm0-5.183a1.802 1.802 0 101.791 1.801 1.812 1.812 0 00-1.79-1.802z"
    })));
});
$e91451c7f171b90d$export$d763173d10f54f27.displayName = 'Brick';





var $denZA = parcelRequire("denZA");
var $6ccc229f6f85594a$var$__assign = undefined && undefined.__assign || function() {
    $6ccc229f6f85594a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ccc229f6f85594a$var$__assign.apply(this, arguments);
};
var $6ccc229f6f85594a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6ccc229f6f85594a$export$2e631716c50ef3cb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6ccc229f6f85594a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6ccc229f6f85594a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.77 15.22a2 2 0 100 4 2 2 0 000-4zm-.18-6.44a2 2 0 100-4 2 2 0 000 4zm10.64 0a2 2 0 100-4 2 2 0 000 4z"
    }), $denZA.createElement("path", {
        d: "M22.17 0H1.83A1.83 1.83 0 000 1.83v20.34A1.83 1.83 0 001.83 24h20.4A1.772 1.772 0 0024 22.23V1.83A1.83 1.83 0 0022.17 0zM6.59 3.23a3.53 3.53 0 11.02 7.06 3.53 3.53 0 01-.02-7.06zm.18 17.54a3.53 3.53 0 110-7.06 3.53 3.53 0 010 7.06zM17.23 3.23a3.53 3.53 0 110 7.06 3.53 3.53 0 010-7.06zm.18 17.54a3.53 3.53 0 11-.02-7.06 3.53 3.53 0 01.02 7.06z"
    }), $denZA.createElement("path", {
        d: "M17.41 15.22a2 2 0 100 4 2 2 0 000-4z"
    })));
});
$6ccc229f6f85594a$export$2e631716c50ef3cb.displayName = 'BrickBold';





var $denZA = parcelRequire("denZA");
var $1d0c52c7f1789cbf$var$__assign = undefined && undefined.__assign || function() {
    $1d0c52c7f1789cbf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d0c52c7f1789cbf$var$__assign.apply(this, arguments);
};
var $1d0c52c7f1789cbf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1d0c52c7f1789cbf$export$97f112825f6d8cc2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1d0c52c7f1789cbf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1d0c52c7f1789cbf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.576 5.924h-1.323V4.417A1.448 1.448 0 0019.919 3h-5.394a1.424 1.424 0 00-1.242 1.417v1.507h-2.566V4.417A1.448 1.448 0 009.384 3H4a1.424 1.424 0 00-1.242 1.417v1.507H1.424A1.422 1.422 0 000 7.351v12.222A1.428 1.428 0 001.424 21h21.152A1.422 1.422 0 0024 19.573V7.351a1.428 1.428 0 00-1.424-1.427zm-7.778-1.396h4.94v1.416h-4.94V4.528zm-10.525 0h4.929v1.416h-4.93V4.528zm18.181 14.964H1.516V7.442h20.97l-.03 12.05z"
    })));
});
$1d0c52c7f1789cbf$export$97f112825f6d8cc2.displayName = 'BrickSideview';





var $denZA = parcelRequire("denZA");
var $43d1d205f6925960$var$__assign = undefined && undefined.__assign || function() {
    $43d1d205f6925960$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43d1d205f6925960$var$__assign.apply(this, arguments);
};
var $43d1d205f6925960$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $43d1d205f6925960$export$fb3f172e5449d1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $43d1d205f6925960$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $43d1d205f6925960$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.29 6.277h-2.23V4.021a1.037 1.037 0 00-.143-.611A1.006 1.006 0 0020.45 3H14.8a1.005 1.005 0 00-.473.408 1.038 1.038 0 00-.147.613v2.256H9.82V4.021a1.038 1.038 0 00-.143-.611A1.006 1.006 0 009.21 3H3.56a1.006 1.006 0 00-.473.408 1.038 1.038 0 00-.147.613v2.256H.71a.697.697 0 00-.502.213.726.726 0 00-.208.512v13.273c0 .192.075.377.208.513A.703.703 0 00.71 21h22.58a.703.703 0 00.502-.212.733.733 0 00.208-.513V7.002a.74.74 0 00-.208-.512.71.71 0 00-.502-.213z"
    })));
});
$43d1d205f6925960$export$fb3f172e5449d1.displayName = 'BrickSideviewBold';





var $denZA = parcelRequire("denZA");
var $57941dcee20a57fc$var$__assign = undefined && undefined.__assign || function() {
    $57941dcee20a57fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $57941dcee20a57fc$var$__assign.apply(this, arguments);
};
var $57941dcee20a57fc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $57941dcee20a57fc$export$6262ca71fb4fada9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $57941dcee20a57fc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $57941dcee20a57fc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M13.66 7.55H10.4a.752.752 0 00.1 1.5H12v.85a.75.75 0 001.49-.1v-.75h.32a2.09 2.09 0 00.61-3.999l-2.71-.84h-.07a.6.6 0 01-.24-.61.59.59 0 01.6-.55h2.73a.75.75 0 00-.1-1.49H13.5v-.86a.751.751 0 10-1.5.1v.75h-.17a2.09 2.09 0 00-.61 4l2.71.84H14a.6.6 0 01.24.61.59.59 0 01-.58.55zM6.33 20.589a3.37 3.37 0 10-3.409 0 5.209 5.209 0 00-2.82 2.34.75.75 0 001.3.74 3.71 3.71 0 016.45 0 .75.75 0 001.3-.74 5.209 5.209 0 00-2.82-2.34zm-1.709-1a1.88 1.88 0 111.88-1.92 1.88 1.88 0 01-1.87 1.88l-.01.04zm19.277 3.339a5.21 5.21 0 00-2.82-2.34 3.38 3.38 0 10-3.409 0 5.21 5.21 0 00-2.82 2.34.75.75 0 001.3.74 3.71 3.71 0 016.45 0 .75.75 0 001.3-.74zM19.37 19.55a1.88 1.88 0 110-3.76 1.88 1.88 0 010 3.76z"
    }), $denZA.createElement("path", {
        d: "M20.399 12.8a2.25 2.25 0 002.1-2.24V2.151a2.25 2.25 0 00-2.25-2.1h-2.35a.752.752 0 00.1 1.5h2.35a.75.75 0 01.65.74v8.36a.75.75 0 01-.74.65h-4.63a.75.75 0 00-.41.21L12 14.74v-2.79a.75.75 0 00-.74-.65H5.151a.75.75 0 01-.65-.74V2.201a.75.75 0 01.74-.65h3.1a.751.751 0 10-.09-1.5H5.1A2.25 2.25 0 003 2.301v8.4A2.25 2.25 0 005.24 12.8h5.26v3.85a.75.75 0 001.27.43l4.279-4.28h4.349z"
    })));
});
$57941dcee20a57fc$export$6262ca71fb4fada9.displayName = 'BusinessDeal';





var $denZA = parcelRequire("denZA");
var $e227f8ec32ef1638$var$__assign = undefined && undefined.__assign || function() {
    $e227f8ec32ef1638$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e227f8ec32ef1638$var$__assign.apply(this, arguments);
};
var $e227f8ec32ef1638$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e227f8ec32ef1638$export$1c86741c3cec44d4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e227f8ec32ef1638$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e227f8ec32ef1638$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.448 16.749c0 1.518-1.282 2.75-2.864 2.75-1.582 0-2.864-1.232-2.864-2.75 0-1.52 1.282-2.75 2.864-2.75 1.582 0 2.864 1.23 2.864 2.75zM.111 23.675a.242.242 0 00.04.222c.05.064.128.101.21.101h8.446c.082 0 .16-.038.209-.101a.242.242 0 00.04-.222c-.602-1.887-2.417-3.176-4.473-3.176-2.055 0-3.87 1.289-4.472 3.176zm22.169-6.926c0 1.518-1.282 2.75-2.864 2.75-1.582 0-2.864-1.232-2.864-2.75 0-1.52 1.282-2.75 2.864-2.75 1.582 0 2.864 1.23 2.864 2.75zm1.57 7.149a.241.241 0 00.039-.221c-.602-1.887-2.417-3.176-4.472-3.176-2.056 0-3.87 1.289-4.472 3.176a.242.242 0 00.04.222.263.263 0 00.209.101h8.446c.082 0 .16-.038.21-.102z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.147 10.5v-9c0-.828.7-1.5 1.562-1.5h14.582c.863 0 1.563.672 1.563 1.5v9c0 .828-.7 1.499-1.563 1.499H15.45a.265.265 0 00-.185.07l-2.895 2.784a.532.532 0 01-.568.108.5.5 0 01-.322-.462v-2.25a.255.255 0 00-.26-.25H4.71c-.863 0-1.562-.671-1.562-1.5zm5.815-5.667c0 .973.81 1.768 1.822 1.791h2.432c.311 0 .564.243.564.542 0 .3-.253.542-.564.542H9.57c-.36 0-.65.28-.65.625s.29.625.65.625h1.519c.069 0 .135.026.184.073.049.047.076.11.076.177V9.5c0 .345.291.625.651.625.36 0 .651-.28.651-.625v-.29c0-.067.027-.13.076-.178a.265.265 0 01.184-.073h.305c1.03 0 1.866-.802 1.866-1.792s-.836-1.791-1.866-1.791h-2.431a.552.552 0 01-.54-.542c0-.29.237-.529.54-.541h3.645c.36 0 .651-.28.651-.625a.638.638 0 00-.651-.625h-1.519a.255.255 0 01-.26-.25V2.5A.638.638 0 0012 1.875c-.36 0-.65.28-.65.625v.292c0 .138-.117.25-.261.25h-.305c-1.013.023-1.822.818-1.822 1.791z",
        fillRule: "evenodd"
    })));
});
$e227f8ec32ef1638$export$1c86741c3cec44d4.displayName = 'BusinessDealBold';





var $denZA = parcelRequire("denZA");
var $16e84abd153b5431$var$__assign = undefined && undefined.__assign || function() {
    $16e84abd153b5431$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16e84abd153b5431$var$__assign.apply(this, arguments);
};
var $16e84abd153b5431$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16e84abd153b5431$export$77cdf53c363a3886 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $16e84abd153b5431$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $16e84abd153b5431$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.03 4.97a.75.75 0 010 1.06l-13 13a.75.75 0 01-1.06 0l-6-6a.75.75 0 111.06-1.06l5.47 5.47L20.97 4.97a.75.75 0 011.06 0z",
        fillRule: "evenodd"
    })));
});
$16e84abd153b5431$export$77cdf53c363a3886.displayName = 'CheckTick';





var $denZA = parcelRequire("denZA");
var $a7d2f29d07be0efc$var$__assign = undefined && undefined.__assign || function() {
    $a7d2f29d07be0efc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a7d2f29d07be0efc$var$__assign.apply(this, arguments);
};
var $a7d2f29d07be0efc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a7d2f29d07be0efc$export$add807e002afa321 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a7d2f29d07be0efc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a7d2f29d07be0efc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.56 4.44a1.5 1.5 0 010 2.12l-13 13a1.5 1.5 0 01-2.12 0l-6-6a1.5 1.5 0 012.12-2.12l4.94 4.939 11.94-11.94a1.5 1.5 0 012.12 0z",
        fillRule: "evenodd"
    })));
});
$a7d2f29d07be0efc$export$add807e002afa321.displayName = 'CheckTickBold';





var $denZA = parcelRequire("denZA");
var $29b0f0c826b6cba1$var$__assign = undefined && undefined.__assign || function() {
    $29b0f0c826b6cba1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29b0f0c826b6cba1$var$__assign.apply(this, arguments);
};
var $29b0f0c826b6cba1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $29b0f0c826b6cba1$export$105b96a34d430ab0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $29b0f0c826b6cba1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $29b0f0c826b6cba1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M17.75 19.498H4.711c-1.564-.113-4.523-1.096-4.69-4.012a4.54 4.54 0 011.386-3.734 4.565 4.565 0 013.126-1.106A7.36 7.36 0 016.94 6.354a7.461 7.461 0 014.587-1.841c4.523-.218 6.577 2.42 7.17 3.878A6.04 6.04 0 0122.2 9.756a5.43 5.43 0 011.39 1.96c.31.748.447 1.556.403 2.363a4.982 4.982 0 01-.47 2.084 5.019 5.019 0 01-1.302 1.701 6.543 6.543 0 01-4.47 1.634zM5.753 12.021a.878.878 0 01-.72.217 3.776 3.776 0 00-.562 0 2.932 2.932 0 00-1.98.704 3.008 3.008 0 00-.907 2.461c.136 2.275 3.127 2.544 3.23 2.554H17.75a4.984 4.984 0 003.387-1.23 3.464 3.464 0 001.292-2.658 3.954 3.954 0 00-1.198-3.103 4.554 4.554 0 00-2.866-1.034.944.944 0 01-.66-.156.931.931 0 01-.382-.558S16.28 5.826 11.6 6.054c-5.054.258-5.586 5.233-5.586 5.284-.005.25-.097.492-.26.683z"
    })));
});
$29b0f0c826b6cba1$export$105b96a34d430ab0.displayName = 'CloudAvailable';





var $denZA = parcelRequire("denZA");
var $b1a35f44b69c67ff$var$__assign = undefined && undefined.__assign || function() {
    $b1a35f44b69c67ff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1a35f44b69c67ff$var$__assign.apply(this, arguments);
};
var $b1a35f44b69c67ff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b1a35f44b69c67ff$export$6e73e7f7b0ace1e9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b1a35f44b69c67ff$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b1a35f44b69c67ff$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.224 9.735A5.825 5.825 0 0124 13.908a5.819 5.819 0 01-5.185 5.783.938.938 0 01-.132.009H4.81a5.38 5.38 0 01-3.567-1.38 4.34 4.34 0 01-1.24-3.219 4.601 4.601 0 014.259-4.582.255.255 0 00.23-.204A7.69 7.69 0 0118.59 8.026c.042.07.114.115.194.123a5.72 5.72 0 013.44 1.586zM4.827 17.658h13.78a3.784 3.784 0 003.347-3.75 3.741 3.741 0 00-3.886-3.743.98.98 0 01-.96-.582 5.65 5.65 0 00-10.75 2.076 1.02 1.02 0 01-1.226.94 2.56 2.56 0 00-3.086 2.503c-.044.65.185 1.288.631 1.763a3.37 3.37 0 002.15.793z",
        fillRule: "evenodd"
    })));
});
$b1a35f44b69c67ff$export$6e73e7f7b0ace1e9.displayName = 'CloudAvailableBold';





var $denZA = parcelRequire("denZA");
var $193fc40adb9542cf$var$__assign = undefined && undefined.__assign || function() {
    $193fc40adb9542cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $193fc40adb9542cf$var$__assign.apply(this, arguments);
};
var $193fc40adb9542cf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $193fc40adb9542cf$export$3a083cd204da2316 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $193fc40adb9542cf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $193fc40adb9542cf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.185 12.194a.812.812 0 01.812.811v7.768l2.674-2.672a.812.812 0 011.148 1.147l-4.06 4.014a.812.812 0 01-.564.238.813.813 0 01-.53-.238l-4.114-4.014A.826.826 0 118.74 18.1l2.675 2.672v-7.768a.81.81 0 01.769-.811z"
    }), $denZA.createElement("path", {
        d: "M19.222 16.608a.813.813 0 01-.695-1.249.812.812 0 01.457-.341c.14 0 3.4-1.083 3.4-4.328a4.326 4.326 0 00-3.768-4.458 1.083 1.083 0 01-.953-.703 5.649 5.649 0 00-5.944-3.42c-4.396.25-5.413 4.329-5.717 5.692a1.147 1.147 0 01-1.082.93 3.023 3.023 0 00-3.248 2.965A2.746 2.746 0 002.3 13.86a4.138 4.138 0 002.62 1.082.812.812 0 01.79.833.865.865 0 01-.823.79 5.751 5.751 0 01-3.778-1.59 4.327 4.327 0 01-1.083-3.366 4.554 4.554 0 014.472-4.425C5.894 1.948 9.13.692 11.622.541a7.356 7.356 0 017.416 4.155 5.934 5.934 0 014.959 6.037 6.338 6.338 0 01-4.558 5.832.793.793 0 01-.217.043z"
    })));
});
$193fc40adb9542cf$export$3a083cd204da2316.displayName = 'CloudDownload';





var $denZA = parcelRequire("denZA");
var $0e417769d06cd808$var$__assign = undefined && undefined.__assign || function() {
    $0e417769d06cd808$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e417769d06cd808$var$__assign.apply(this, arguments);
};
var $0e417769d06cd808$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0e417769d06cd808$export$b57e613e214e0b93 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0e417769d06cd808$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0e417769d06cd808$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M24 10.606a6.184 6.184 0 00-1.772-4.336 5.613 5.613 0 00-3.446-1.651.248.248 0 01-.191-.125C16.974 1.678 13.87.175 10.763.702c-3.109.527-5.594 2.977-6.27 6.181a.255.255 0 01-.227.209C1.868 7.27.008 9.347.004 11.852a4.608 4.608 0 001.236 3.342 5.404 5.404 0 003.604 1.435.981.981 0 00.703-.317c.184-.198.286-.464.282-.74-.02-.57-.468-1.022-1.015-1.026a3.223 3.223 0 01-2.172-.834 2.535 2.535 0 01-.639-1.86 2.727 2.727 0 01.954-2.091 2.522 2.522 0 012.167-.549.97.97 0 00.81-.193c.23-.184.372-.463.39-.764.153-2.703 2.046-4.953 4.598-5.466 2.552-.513 5.113.842 6.22 3.291a.955.955 0 00.94.594 3.605 3.605 0 012.758 1.092 3.988 3.988 0 011.16 2.84c-.012 2.036-1.493 3.737-3.437 3.948-.525.07-.907.552-.872 1.102.035.55.475.976 1.004.973a.912.912 0 00.13-.01c2.946-.336 5.176-2.927 5.175-6.013z"
    }), $denZA.createElement("path", {
        d: "M15.501 17.67h-1.75a.255.255 0 01-.25-.26V9.859c0-.863-.67-1.562-1.5-1.562-.827 0-1.499.699-1.499 1.562v7.555c0 .144-.112.26-.25.26h-1.75a1 1 0 00-.923.643c-.155.39-.07.837.217 1.135l3.499 3.645a.972.972 0 001.414 0l3.5-3.645c.285-.298.37-.746.216-1.135a1 1 0 00-.924-.643v-.004z"
    })));
});
$0e417769d06cd808$export$b57e613e214e0b93.displayName = 'CloudDownloadBold';





var $denZA = parcelRequire("denZA");
var $612fb8b7c79a30ab$var$__assign = undefined && undefined.__assign || function() {
    $612fb8b7c79a30ab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $612fb8b7c79a30ab$var$__assign.apply(this, arguments);
};
var $612fb8b7c79a30ab$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $612fb8b7c79a30ab$export$a41884c08973b4dc = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $612fb8b7c79a30ab$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $612fb8b7c79a30ab$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.7 16.497a.744.744 0 00-.573-.27h-2.224V14.07a.734.734 0 00-.745-.733h-5.917v-.733a.732.732 0 00-.745-.733H6.324a.736.736 0 00-.745.733v9.111c.002.44.163.866.454 1.197a1.867 1.867 0 001.49.636h11.38a1.9 1.9 0 001.188-.41c.338-.272.571-.653.658-1.078l1.08-4.97a.732.732 0 00-.13-.593zm-14.037 5.53a.378.378 0 01-.162.055h-.118a.377.377 0 01-.227-.119.366.366 0 01-.087-.237v-8.432h3.704v.733a.732.732 0 00.745.734h5.917v1.466h-7.418a.735.735 0 00-.713.528l-1.511 5.068a.367.367 0 01-.162.205h.032zm11.672-.258a.4.4 0 01-.4.313H9.25l1.318-4.4h9.63l-.863 4.087z"
    }), $denZA.createElement("path", {
        d: "M3.884 16.108a.82.82 0 01-.27 0A5.192 5.192 0 01.02 10.717c.27-2.156 1.911-3.601 4.405-3.86.443-1.8 1.609-5.995 6.824-6.372a7.145 7.145 0 017.147 4.032 6.623 6.623 0 015.496 4.83 5.266 5.266 0 01-2.829 5.79.839.839 0 01-1.022-1.284.839.839 0 01.256-.203c.097 0 2.57-1.37 1.965-3.914a4.927 4.927 0 00-4.006-3.548 1.383 1.383 0 01-1.263-.808 5.394 5.394 0 00-5.582-3.235c-4.157.302-5.032 3.547-5.377 5.11A1.563 1.563 0 014.65 8.443c-1.242.108-2.753.625-2.98 2.405-.324 2.609 2.364 3.59 2.483 3.633a.841.841 0 01-.27 1.628z"
    })));
});
$612fb8b7c79a30ab$export$a41884c08973b4dc.displayName = 'CloudFolder';





var $denZA = parcelRequire("denZA");
var $3208fca247f0522b$var$__assign = undefined && undefined.__assign || function() {
    $3208fca247f0522b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3208fca247f0522b$var$__assign.apply(this, arguments);
};
var $3208fca247f0522b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3208fca247f0522b$export$90d6cdb8921d070a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $3208fca247f0522b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $3208fca247f0522b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#cloud-folder-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M18.773 4.698a.25.25 0 01-.195-.119A7.58 7.58 0 0010.752.8a7.802 7.802 0 00-6.257 6.153.25.25 0 01-.227.206A4.62 4.62 0 00.63 9.498a4.781 4.781 0 00-.628 2.546 4.552 4.552 0 001.234 3.25 4.837 4.837 0 002.565 1.322.973.973 0 00.834-.217 1.083 1.083 0 00.368-.802 1.008 1.008 0 00-.79-1.007 2.932 2.932 0 01-1.57-.759 2.525 2.525 0 01-.638-1.928 2.645 2.645 0 012.576-2.676c.178 0 .356.018.53.054a.962.962 0 00.812-.195 1.083 1.083 0 00.39-.812c.086-5.96 8.291-7.65 10.824-2.167a.975.975 0 00.942.596 3.678 3.678 0 013.01 1.419 4.14 4.14 0 01.887 2.914 3.588 3.588 0 01-1.559 2.817 1.019 1.019 0 00-.422.845 1.084 1.084 0 00.53.91.962.962 0 001.029-.054 5.676 5.676 0 002.435-4.637 5.919 5.919 0 00-1.374-4.147 5.909 5.909 0 00-3.843-2.072z"
    }), $denZA.createElement("path", {
        d: "M20.028 17.72H11.12c-.595 0-.931 0-1.083.402 0 .13-.097.281-.173.476l-.887 2.698a.271.271 0 01-.26.184h-.563a.27.27 0 01-.173-.347l.898-2.73c.076-.195.13-.346.173-.466.26-.769.433-1.224 1.58-1.224h7.372v-2.09a.672.672 0 00-.671-.673h-5.412v-.671a.672.672 0 00-.671-.672H6.584a.67.67 0 00-.67.672v8.374A1.67 1.67 0 007.406 23.3h10.695a1.73 1.73 0 001.688-1.343l.866-3.424a.662.662 0 00-.352-.74.681.681 0 00-.276-.072z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "cloud-folder-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$3208fca247f0522b$export$90d6cdb8921d070a.displayName = 'CloudFolderBold';





var $denZA = parcelRequire("denZA");
var $b9e587b9d0344680$var$__assign = undefined && undefined.__assign || function() {
    $b9e587b9d0344680$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9e587b9d0344680$var$__assign.apply(this, arguments);
};
var $b9e587b9d0344680$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b9e587b9d0344680$export$c984feb5da8d9e3b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b9e587b9d0344680$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b9e587b9d0344680$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.904 24a.796.796 0 01-.573-.244L.524 1.216A.798.798 0 011.67.153L23.478 22.65a.797.797 0 01-.574 1.35zM5.715 19.45a6.364 6.364 0 01-4.034-1.35 4.04 4.04 0 01-1.36-2.978 4.375 4.375 0 011.19-3.455 5.167 5.167 0 013.185-1.318v-.383a.766.766 0 01.934-.744.796.796 0 01.765.83L6.33 11.22a1.064 1.064 0 01-.881.744 4.062 4.062 0 00-2.729.882 2.85 2.85 0 00-.753 2.276 2.48 2.48 0 00.785 1.828 4.996 4.996 0 003.185.936h8.144a.796.796 0 01.563 1.361.796.796 0 01-.563.233H5.715v-.031zm15.841-1.67a.785.785 0 01-.435-.127.797.797 0 01-.234-1.063s1.476-2.286.977-4.04a4.051 4.051 0 00-3.833-2.935h-.276a.902.902 0 01-.658-.531A5.454 5.454 0 0011.98 5.45a5.44 5.44 0 00-2.167.443.797.797 0 01-1.039-1.047.798.798 0 01.433-.43 6.936 6.936 0 019.163 3.582 5.474 5.474 0 015 4.062c.712 2.466-1.061 5.241-1.178 5.315a.797.797 0 01-.637.404z"
    })));
});
$b9e587b9d0344680$export$c984feb5da8d9e3b.displayName = 'CloudUnavailable';





var $denZA = parcelRequire("denZA");
var $05086f350eec0b78$var$__assign = undefined && undefined.__assign || function() {
    $05086f350eec0b78$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05086f350eec0b78$var$__assign.apply(this, arguments);
};
var $05086f350eec0b78$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $05086f350eec0b78$export$c12922d9a33c3264 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $05086f350eec0b78$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $05086f350eec0b78$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.193 6.983a5.479 5.479 0 011.83 2.302.927.927 0 00.906.546 3.642 3.642 0 013.178 1.636c.427.63.65 1.383.64 2.15a3.6 3.6 0 01-.914 2.534c-.365.39-.36 1.01.012 1.393.19.192.447.296.713.29a.97.97 0 00.698-.325 5.508 5.508 0 001.441-3.733c.091-3.043-2.134-5.635-5.085-5.923a.245.245 0 01-.186-.12C17.066 5.42 14.63 4.002 12 3.992c-.742 0-1.479.114-2.187.34-.635.2-.787.845-.368 1.5a.885.885 0 001.055.374 5.608 5.608 0 014.693.777zM4.992 17.396a3.384 3.384 0 01-2.117-.8 2.416 2.416 0 01-.623-1.793c0-1.43 1.129-2.589 2.521-2.59.175 0 .35.019.522.054a.944.944 0 00.79-.184 1.01 1.01 0 00.38-.736 9.8 9.8 0 00.015-.725c-.009-.5.021-.734-.255-1.017a.905.905 0 00-.912-.24.937.937 0 00-.641.709v.019a.151.151 0 01-.14.123 4.514 4.514 0 00-3.62 2.255 4.56 4.56 0 00-.61 2.45 4.352 4.352 0 001.205 3.103 5.256 5.256 0 003.48 1.379h8.418c.394 0 .75-.244.9-.618a1.02 1.02 0 00-.211-1.091.962.962 0 00-.69-.293l-8.412-.005zm17.041 6.323c.383.38.99.374 1.367-.012a1.02 1.02 0 00.012-1.404L1.966.282A.957.957 0 00.6.293a1.02 1.02 0 00-.012 1.403L22.033 23.72z"
    })));
});
$05086f350eec0b78$export$c12922d9a33c3264.displayName = 'CloudUnavailableBold';





var $denZA = parcelRequire("denZA");
var $30b35361585cc6f9$var$__assign = undefined && undefined.__assign || function() {
    $30b35361585cc6f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30b35361585cc6f9$var$__assign.apply(this, arguments);
};
var $30b35361585cc6f9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $30b35361585cc6f9$export$613a29ed35edc9c6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $30b35361585cc6f9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $30b35361585cc6f9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.185 23.5a.813.813 0 00.812-.81v-7.765l2.674 2.668a.813.813 0 001.366-.578.81.81 0 00-.218-.567l-4.06-4.028a.813.813 0 00-.564-.238.813.813 0 00-.53.238l-4.114 4.028a.824.824 0 00.61 1.397.828.828 0 00.58-.252l2.675-2.668v7.754a.808.808 0 00.769.821z"
    }), $denZA.createElement("path", {
        d: "M19.222 16.578a.813.813 0 01-.814-.69.808.808 0 01.576-.898c.14 0 3.4-1.08 3.4-4.32a4.313 4.313 0 00-1.02-2.953 4.334 4.334 0 00-2.748-1.496 1.085 1.085 0 01-.953-.702 5.642 5.642 0 00-2.393-2.708 5.664 5.664 0 00-3.55-.704c-4.397.248-5.414 4.32-5.718 5.68a1.144 1.144 0 01-1.082.929 3.028 3.028 0 00-2.983 1.768c-.169.375-.26.78-.265 1.19a2.736 2.736 0 00.628 2.16 4.141 4.141 0 002.62 1.08.814.814 0 01.79.832.863.863 0 01-.823.789 5.757 5.757 0 01-3.778-1.588 4.317 4.317 0 01-1.083-3.358 4.54 4.54 0 011.349-3.102 4.564 4.564 0 013.123-1.315C5.894 1.945 9.13.692 11.622.54a7.368 7.368 0 014.37.895 7.34 7.34 0 013.046 3.252 5.937 5.937 0 013.615 2.083 5.909 5.909 0 011.344 3.943 6.318 6.318 0 01-1.34 3.642 6.345 6.345 0 01-3.218 2.179.79.79 0 01-.217.043z"
    })));
});
$30b35361585cc6f9$export$613a29ed35edc9c6.displayName = 'CloudUpload';





var $denZA = parcelRequire("denZA");
var $ff91e038dce3352a$var$__assign = undefined && undefined.__assign || function() {
    $ff91e038dce3352a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff91e038dce3352a$var$__assign.apply(this, arguments);
};
var $ff91e038dce3352a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ff91e038dce3352a$export$c737cff288ab896 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ff91e038dce3352a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ff91e038dce3352a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M24 10.35a6.172 6.172 0 00-1.772-4.335 5.616 5.616 0 00-3.446-1.649.248.248 0 01-.191-.125C16.974 1.43 13.87-.072 10.763.454 7.654.98 5.17 3.427 4.493 6.628a.255.255 0 01-.227.208c-2.4.178-4.26 2.254-4.262 4.757a4.6 4.6 0 001.236 3.34 5.398 5.398 0 003.604 1.436.995.995 0 00.858-.534 1.077 1.077 0 00-.015-1.04.992.992 0 00-.873-.507 3.213 3.213 0 01-2.172-.832 2.53 2.53 0 01-.639-1.863 2.728 2.728 0 01.954-2.09 2.525 2.525 0 012.167-.548.97.97 0 00.81-.193c.23-.183.372-.461.39-.762.153-2.7 2.046-4.947 4.598-5.46 2.552-.512 5.113.842 6.22 3.288.163.383.539.62.94.593a3.62 3.62 0 012.758 1.093A3.98 3.98 0 0122 10.349c-.014 2.033-1.494 3.73-3.437 3.94-.525.069-.907.551-.872 1.1.035.549.475.975 1.004.971a.927.927 0 00.13-.009C21.77 16.016 24 13.43 24 10.35z"
    }), $denZA.createElement("path", {
        d: "M12.709 8.868a.973.973 0 00-1.414 0l-3.5 3.64a1.07 1.07 0 00-.22 1.138 1 1 0 00.927.642h1.75c.066 0 .13.027.177.076a.264.264 0 01.073.184v7.542c0 .861.672 1.56 1.5 1.56s1.5-.699 1.5-1.56v-7.541a.27.27 0 01.072-.185.244.244 0 01.178-.076h1.75a1 1 0 00.923-.642c.155-.388.07-.836-.217-1.133l-3.5-3.645z"
    })));
});
$ff91e038dce3352a$export$c737cff288ab896.displayName = 'CloudUploadBold';





var $denZA = parcelRequire("denZA");
var $732fe53b7861f870$var$__assign = undefined && undefined.__assign || function() {
    $732fe53b7861f870$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $732fe53b7861f870$var$__assign.apply(this, arguments);
};
var $732fe53b7861f870$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $732fe53b7861f870$export$163fa6932802c5a0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $732fe53b7861f870$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $732fe53b7861f870$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.85 13.199v8.982a.779.779 0 001.094.804.78.78 0 00.455-.804V13.2l1.78 1.779a.78.78 0 101.1-1.098l-3.1-3.097a.77.77 0 00-.55-.285.77.77 0 00-.538.22l-3.11 3.162a.78.78 0 001.098 1.098l1.77-1.78zm7.045-2.207a.78.78 0 01.78.78v8.982l1.781-1.78a.779.779 0 011.151-.051.78.78 0 01-.052 1.15l-3.132 3.096a.77.77 0 01-.506.231.77.77 0 01-.539-.23l-3.1-3.097a.78.78 0 011.1-1.098l1.78 1.779V11.77a.78.78 0 01.737-.78z"
    }), $denZA.createElement("path", {
        d: "M3.958 16.438h-.22c-1.528-.45-4.265-2.075-3.65-5.303a4.764 4.764 0 014.386-3.932 8.486 8.486 0 012.704-4.886 7.523 7.523 0 018.794-.56 7.866 7.866 0 012.858 2.954 5.916 5.916 0 015.144 5.216 6.43 6.43 0 01-3.045 6.061.826.826 0 01-.846-1.416 4.789 4.789 0 002.198-4.459 4.39 4.39 0 00-4.023-3.821 1.034 1.034 0 01-.835-.604 6.03 6.03 0 00-2.352-2.536 5.951 5.951 0 00-6.837.395 6.97 6.97 0 00-2.199 4.392.966.966 0 01-.945.857 3.3 3.3 0 00-3.375 2.624c-.472 2.482 2.199 3.294 2.474 3.371a.824.824 0 01-.22 1.614l-.011.033z"
    })));
});
$732fe53b7861f870$export$163fa6932802c5a0.displayName = 'CloudUploadDownload';





var $denZA = parcelRequire("denZA");
var $ef33b0b027d613aa$var$__assign = undefined && undefined.__assign || function() {
    $ef33b0b027d613aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef33b0b027d613aa$var$__assign.apply(this, arguments);
};
var $ef33b0b027d613aa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ef33b0b027d613aa$export$a1f1705155c9f21b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ef33b0b027d613aa$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ef33b0b027d613aa$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.802 17.112a.953.953 0 00.83-.226c.232-.206.368-.512.37-.835.005-.515-.332-.96-.8-1.056a2.83 2.83 0 01-1.563-.794 2.687 2.687 0 01-.636-1.928c0-1.543 1.157-2.793 2.585-2.794.18 0 .359.02.534.06a.945.945 0 00.827-.216c.232-.202.369-.505.373-.826.084-6.214 8.297-7.953 10.818-2.21.165.397.539.642.94.618 1.148-.06 2.256.458 3 1.404a4.41 4.41 0 01.906 3.017c-.052 1.375-.796 2.608-1.94 3.214a1.099 1.099 0 00-.55.96 1.1 1.1 0 00.463.915c.291.198.656.22.964.057 1.863-.983 3.052-3.017 3.072-5.256.122-3.306-2.169-6.137-5.217-6.449a.249.249 0 01-.19-.13C16.968 1.718 13.866.161 10.757.71 7.65 1.257 5.166 3.8 4.491 7.123a.258.258 0 01-.227.216C2.758 7.457 1.4 8.36.623 9.76a5.146 5.146 0 00-.62 2.643c-.021 1.247.424 2.45 1.235 3.338a4.734 4.734 0 002.564 1.371z"
    }), $denZA.createElement("path", {
        d: "M10 11.522c0-.596-.448-1.08-1-1.08s-1 .484-1 1.08v6.207c0 .15-.111.27-.25.27H6.502a.495.495 0 00-.437.278.578.578 0 00.013.549l2.5 4.32c.089.154.244.25.412.254H9a.49.49 0 00.412-.234l2.748-4.321a.577.577 0 00.03-.557.496.496 0 00-.442-.289h-1.5c-.137 0-.248-.121-.248-.27v-6.207zm5.998 3.241c0-.15.112-.27.25-.27h1.5a.484.484 0 00.432-.27.566.566 0 00-.012-.54c-.009-.015-.008-.035-.018-.05l-2.752-4.05a.488.488 0 00-.414-.22.492.492 0 00-.405.24l-2.499 4.05c0 .01 0 .02-.009.03a.57.57 0 00-.008.54.488.488 0 00.433.27h1.25c.138 0 .25.12.25.27v6.481c0 .596.447 1.08 1 1.08.551 0 .999-.484.999-1.08l.003-6.481z"
    })));
});
$ef33b0b027d613aa$export$a1f1705155c9f21b.displayName = 'CloudUploadDownloadBold';





var $denZA = parcelRequire("denZA");
var $50b76e33b936815c$var$__assign = undefined && undefined.__assign || function() {
    $50b76e33b936815c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50b76e33b936815c$var$__assign.apply(this, arguments);
};
var $50b76e33b936815c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $50b76e33b936815c$export$52f0f02147b12c03 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $50b76e33b936815c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $50b76e33b936815c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.508 22.74H2.492A2.491 2.491 0 010 20.257V3.774A2.495 2.495 0 012.492 1.25h19.016A2.491 2.491 0 0124 3.774v16.483a2.494 2.494 0 01-2.492 2.493v-.01zM2.492 2.752a.96.96 0 00-.96 1.022v16.483a.96.96 0 00.96.96h19.016a.96.96 0 00.96-.96V3.774a.96.96 0 00-.96-1.022H2.492z"
    }), $denZA.createElement("path", {
        d: "M23.234 5.981H.766v1.533h22.468V5.981zM10.662 17.886a.766.766 0 01-.684-1.104l2.778-5.63a.768.768 0 111.378.674l-2.777 5.63a.766.766 0 01-.695.43zM7.435 17.6a.766.766 0 01-.51-.194l-2.309-2.044a1.778 1.778 0 010-2.493l2.043-2.044a.794.794 0 111.123 1.124L5.74 13.993a.225.225 0 000 .316l2.246 1.973a.767.767 0 01-.51 1.338l-.041-.02zm9.273.194a.766.766 0 01-.51-1.339l2.307-2.043a.297.297 0 00-.081-.256l-2.043-2.044a.766.766 0 011.072-1.093l2.043 2.044a1.769 1.769 0 01.082 2.422l-2.38 2.105a.766.766 0 01-.49.204z"
    })));
});
$50b76e33b936815c$export$52f0f02147b12c03.displayName = 'Code';





var $denZA = parcelRequire("denZA");
var $97abe2bba2a0a8d4$var$__assign = undefined && undefined.__assign || function() {
    $97abe2bba2a0a8d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97abe2bba2a0a8d4$var$__assign.apply(this, arguments);
};
var $97abe2bba2a0a8d4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $97abe2bba2a0a8d4$export$6d7e986e2641be95 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $97abe2bba2a0a8d4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $97abe2bba2a0a8d4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.19 2.039a2.692 2.692 0 00-1.9-.789H2.66a2.693 2.693 0 00-2.472 1.7c-.13.33-.194.682-.188 1.036v16.078a2.684 2.684 0 002.68 2.686h18.61a2.692 2.692 0 002.503-1.654A2.67 2.67 0 0024 20.064V3.986a2.683 2.683 0 00-.81-1.947zm-21 1.418a.68.68 0 01.5-.21h18.62a.691.691 0 01.69.74v2.885H2V3.876a.689.689 0 01.18-.42h.01zm5.98 12.512a1 1 0 11-1.3 1.478L4.52 15.4a1.995 1.995 0 01.09-2.716l2-1.997a1.001 1.001 0 011.613.742.998.998 0 01-.223.676l-2 1.997 2.17 1.867zm1.62.6l2.72-5.503a1.003 1.003 0 011.79.909l-2.72 5.502a1 1 0 01-1.79-.878v-.03zm6.3-4.344a.998.998 0 01.701-1.708 1.001 1.001 0 01.709.29l2 1.997a1.997 1.997 0 01.12 2.756l-.09.09-2.26 1.997a1.003 1.003 0 01-1.665-.809 1 1 0 01.335-.689l2.17-1.917-2.02-2.007z"
    })));
});
$97abe2bba2a0a8d4$export$6d7e986e2641be95.displayName = 'CodeBold';





var $denZA = parcelRequire("denZA");
var $752eb881c87af241$var$__assign = undefined && undefined.__assign || function() {
    $752eb881c87af241$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $752eb881c87af241$var$__assign.apply(this, arguments);
};
var $752eb881c87af241$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $752eb881c87af241$export$c7c44baae9d9f25f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $752eb881c87af241$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $752eb881c87af241$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.246 0H.754A.761.761 0 000 .754v22.492c0 .411.343.754.754.754h22.492a.761.761 0 00.754-.754V.754A.761.761 0 0023.246 0zM1.509 22.491V1.51h21v20.98h-21z"
    }), $denZA.createElement("path", {
        d: "M5.246 16.491h2.348c.343 1.286 1.509 2.246 2.897 2.246a3 3 0 002.898-2.246h5.348a.76.76 0 00.754-.754.76.76 0 00-.754-.754h-5.331a2.919 2.919 0 00-.789-1.372 2.981 2.981 0 00-2.126-.874 3 3 0 00-2.897 2.246H5.246a.76.76 0 00-.755.754.76.76 0 00.755.754zm5.245-2.245c.395 0 .772.154 1.063.445.292.292.446.652.446 1.063a1.51 1.51 0 01-1.509 1.509 1.5 1.5 0 01-1.508-1.509c.017-.823.686-1.508 1.508-1.508zM5.246 9h8.348c.343 1.286 1.509 2.246 2.897 2.246 1.646 0 3-1.337 3-3 0-1.646-1.354-3-3-3a3 3 0 00-2.897 2.245H5.246a.761.761 0 00-.755.755c0 .411.343.754.755.754zM16.49 6.754c.823 0 1.509.669 1.509 1.492a1.51 1.51 0 01-1.509 1.508A1.496 1.496 0 0115 8.246c0-.823.669-1.492 1.491-1.492z"
    })));
});
$752eb881c87af241$export$c7c44baae9d9f25f.displayName = 'Controls';





var $denZA = parcelRequire("denZA");
var $0196f237444407ac$var$__assign = undefined && undefined.__assign || function() {
    $0196f237444407ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0196f237444407ac$var$__assign.apply(this, arguments);
};
var $0196f237444407ac$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0196f237444407ac$export$281a0dedb095a201 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0196f237444407ac$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0196f237444407ac$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.754 0h22.492c.411 0 .754.343.754.754v22.492a.761.761 0 01-.754.754H.754A.761.761 0 010 23.246V.754C0 .343.343 0 .754 0zm12.652 7.241a3.25 3.25 0 013.085-2.245 3.264 3.264 0 013.25 3.25 3.253 3.253 0 01-3.25 3.25c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.455-1.005-1.004 0-.55.455-1.005 1.005-1.005h8.16zm-6 7.492a3.25 3.25 0 013.085-2.246c.87 0 1.688.334 2.3.946.383.366.645.818.801 1.3h5.145c.55 0 1.004.455 1.004 1.004a1.01 1.01 0 01-1.004 1.004h-5.16a3.25 3.25 0 01-3.086 2.246c-1.439 0-2.654-.95-3.083-2.246H5.246c-.55 0-1.005-.454-1.005-1.004s.455-1.004 1.005-1.004h2.16z",
        fillRule: "evenodd"
    })));
});
$0196f237444407ac$export$281a0dedb095a201.displayName = 'ControlsBold';





var $denZA = parcelRequire("denZA");
var $9c0815a4c25aa770$var$__assign = undefined && undefined.__assign || function() {
    $9c0815a4c25aa770$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9c0815a4c25aa770$var$__assign.apply(this, arguments);
};
var $9c0815a4c25aa770$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9c0815a4c25aa770$export$3c877bb842c36952 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9c0815a4c25aa770$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9c0815a4c25aa770$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2.53 1.47a.75.75 0 00-1.06 1.06L10.94 12l-9.47 9.47a.75.75 0 101.06 1.06L12 13.06l9.47 9.47a.75.75 0 101.06-1.06L13.06 12l9.47-9.47a.75.75 0 00-1.06-1.06L12 10.94 2.53 1.47z"
    })));
});
$9c0815a4c25aa770$export$3c877bb842c36952.displayName = 'Cross';





var $denZA = parcelRequire("denZA");
var $c51f9c86b88627ec$var$__assign = undefined && undefined.__assign || function() {
    $c51f9c86b88627ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c51f9c86b88627ec$var$__assign.apply(this, arguments);
};
var $c51f9c86b88627ec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c51f9c86b88627ec$export$44fbda67c66d275 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c51f9c86b88627ec$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c51f9c86b88627ec$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.06.94A1.5 1.5 0 10.94 3.06L9.878 12l-8.94 8.94a1.5 1.5 0 002.122 2.12L12 14.122l8.94 8.94a1.5 1.5 0 002.12-2.122L14.122 12l8.94-8.94A1.5 1.5 0 0020.939.94L12 9.878 3.06.939z"
    })));
});
$c51f9c86b88627ec$export$44fbda67c66d275.displayName = 'CrossBold';





var $denZA = parcelRequire("denZA");
var $263d42448a1a58ef$var$__assign = undefined && undefined.__assign || function() {
    $263d42448a1a58ef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $263d42448a1a58ef$var$__assign.apply(this, arguments);
};
var $263d42448a1a58ef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $263d42448a1a58ef$export$fe82a520fc33e5f4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $263d42448a1a58ef$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $263d42448a1a58ef$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm-2 .5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm4-.5a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-.5h7a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5zM15 0a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm7 1.5h-7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM11 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4zm-2 .5H2a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5z",
        fillRule: "evenodd"
    })));
});
$263d42448a1a58ef$export$fe82a520fc33e5f4.displayName = 'Dashboard';





var $denZA = parcelRequire("denZA");
var $bfc628203e585eff$var$__assign = undefined && undefined.__assign || function() {
    $bfc628203e585eff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bfc628203e585eff$var$__assign.apply(this, arguments);
};
var $bfc628203e585eff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bfc628203e585eff$export$735b4219f406972d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bfc628203e585eff$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bfc628203e585eff$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11 12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h7a2 2 0 012 2v10zm2 0a2 2 0 012-2h7a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V12zm2-12a2 2 0 00-2 2v4a2 2 0 002 2h7a2 2 0 002-2V2a2 2 0 00-2-2h-7zm-4 22a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2h7a2 2 0 012 2v4z",
        fillRule: "evenodd"
    })));
});
$bfc628203e585eff$export$735b4219f406972d.displayName = 'DashboardBold';





var $denZA = parcelRequire("denZA");
var $d73b682c38a2150f$var$__assign = undefined && undefined.__assign || function() {
    $d73b682c38a2150f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d73b682c38a2150f$var$__assign.apply(this, arguments);
};
var $d73b682c38a2150f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d73b682c38a2150f$export$6feb5ea51a7b0b47 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d73b682c38a2150f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d73b682c38a2150f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.767 1.373C5.987.484 8.949 0 12 0c3.05 0 6.012.483 8.233 1.372 1.11.444 2.029.986 2.682 1.616C23.569 3.62 24 4.388 24 5.25v13.5c0 .894-.456 1.67-1.119 2.296-.66.626-1.577 1.154-2.648 1.582C18.09 23.486 15.177 24 12 24c-3.178 0-6.089-.514-8.233-1.372-1.07-.428-1.987-.956-2.648-1.582C.456 20.42 0 19.644 0 18.75V5.251c0-.863.43-1.63 1.085-2.262.653-.63 1.571-1.172 2.682-1.616zM1.5 14.625v4.125c0 .349.174.756.65 1.206.477.452 1.208.893 2.174 1.28C6.25 22.005 8.964 22.5 12 22.5c3.036 0 5.75-.494 7.676-1.265.966-.386 1.697-.827 2.175-1.279.476-.45.649-.857.649-1.206v-4.125c-.615.484-1.389.903-2.267 1.254-2.144.857-5.056 1.371-8.233 1.371-3.178 0-6.089-.514-8.233-1.372-.878-.35-1.652-.77-2.267-1.253zM1.5 12V7.874c.606.478 1.374.898 2.267 1.255 2.22.889 5.182 1.372 8.233 1.372 3.05 0 6.012-.483 8.233-1.372.893-.357 1.661-.777 2.267-1.255V12c0 .349-.174.757-.65 1.207-.477.451-1.208.893-2.174 1.279-1.927.77-4.64 1.264-7.676 1.264-3.035 0-5.75-.494-7.676-1.264-.966-.387-1.697-.828-2.175-1.28-.475-.45-.649-.857-.649-1.206zm.627-5.566c-.465-.45-.627-.852-.627-1.183 0-.33.162-.733.627-1.183.468-.451 1.197-.903 2.197-1.303C6.322 1.966 9.084 1.501 12 1.501c2.917 0 5.678.465 7.676 1.264 1 .4 1.73.852 2.197 1.303.465.45.627.852.627 1.183 0 .33-.162.733-.627 1.183-.468.45-1.197.903-2.197 1.303C17.678 8.536 14.916 9 12 9c-2.917 0-5.678-.465-7.676-1.264-1-.4-1.73-.852-2.197-1.303z",
        fillRule: "evenodd"
    })));
});
$d73b682c38a2150f$export$6feb5ea51a7b0b47.displayName = 'Database';





var $denZA = parcelRequire("denZA");
var $d2dd83db5c97ffe6$var$__assign = undefined && undefined.__assign || function() {
    $d2dd83db5c97ffe6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d2dd83db5c97ffe6$var$__assign.apply(this, arguments);
};
var $d2dd83db5c97ffe6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d2dd83db5c97ffe6$export$e457f953b131f785 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d2dd83db5c97ffe6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d2dd83db5c97ffe6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.5 17.034a.25.25 0 00-.408-.194C19.155 18.417 15.5 19.25 12 19.25c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716z"
    }), $denZA.createElement("path", {
        d: "M2.5 14.25c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4v-1.716a.25.25 0 00-.408-.194C19.155 13.917 15.5 14.75 12 14.75c-3.5 0-7.156-.833-9.093-2.41a.249.249 0 00-.407.194v1.716z"
    }), $denZA.createElement("path", {
        d: "M12 10.25c-3.5 0-7.156-.833-9.093-2.411a.249.249 0 00-.407.194V9.75c0 2.21 4.254 4 9.5 4s9.5-1.79 9.5-4V8.034a.25.25 0 00-.408-.193C19.154 9.418 15.5 10.25 12 10.25z"
    }), $denZA.createElement("path", {
        d: "M21.5 5.25c0 2.21-4.253 4-9.5 4s-9.5-1.79-9.5-4 4.253-4 9.5-4 9.5 1.79 9.5 4z"
    })));
});
$d2dd83db5c97ffe6$export$e457f953b131f785.displayName = 'DatabaseBold';





var $denZA = parcelRequire("denZA");
var $8e51a8e55689b20e$var$__assign = undefined && undefined.__assign || function() {
    $8e51a8e55689b20e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e51a8e55689b20e$var$__assign.apply(this, arguments);
};
var $8e51a8e55689b20e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8e51a8e55689b20e$export$6341f9a885713487 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8e51a8e55689b20e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8e51a8e55689b20e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.427 3.813h-3.552V1.707A.713.713 0 0017.168 1a.713.713 0 00-.707.707v2.106H8.039V1.707A.713.713 0 007.332 1a.713.713 0 00-.707.707v2.106H3.073A2.078 2.078 0 001 5.886v15.557c0 1.14.932 2.073 2.073 2.073h18.354a2.078 2.078 0 002.073-2.073V5.886a2.078 2.078 0 00-2.073-2.074zM3.073 5.21h3.552v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h8.438v1.414c0 .386.321.707.707.707a.713.713 0 00.707-.707V5.211h3.552c.37 0 .659.305.659.659v3.55H2.414V5.886c0-.37.29-.675.66-.675zm18.354 16.875H3.073a.662.662 0 01-.659-.66v-10.59h19.688v10.59a.676.676 0 01-.675.66z"
    }), $denZA.createElement("path", {
        d: "M6.271 15.063a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.049 2.812h-.097a1.066 1.066 0 00-.996 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.084 1.084 0 00-1.028-1.045zm5.93-2.812a1.06 1.06 0 100-2.122 1.06 1.06 0 000 2.121zm.048 2.812h-.112a1.066 1.066 0 00-.997 1.045 1.06 1.06 0 102.122 0c0-.563-.45-1.013-1.013-1.045zm5.995-4.918h-.097a1.058 1.058 0 00-1.012 1.045c0 .578.466 1.06 1.06 1.06a1.05 1.05 0 001.061-1.06 1.081 1.081 0 00-1.012-1.045zm-.064 4.918h-.017c-.578 0-1.044.482-1.044 1.06 0 .58.466 1.061 1.06 1.061a1.05 1.05 0 001.061-1.06 1.07 1.07 0 00-1.06-1.061z"
    })));
});
$8e51a8e55689b20e$export$6341f9a885713487.displayName = 'Date';





var $denZA = parcelRequire("denZA");
var $f652fd921f37ce44$var$__assign = undefined && undefined.__assign || function() {
    $f652fd921f37ce44$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f652fd921f37ce44$var$__assign.apply(this, arguments);
};
var $f652fd921f37ce44$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f652fd921f37ce44$export$6cbcb5cd862c2b93 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f652fd921f37ce44$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f652fd921f37ce44$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.271 12.566a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm5.979 0a1.436 1.436 0 100 2.871 1.436 1.436 0 000-2.871zm6.054.016h-.128c-.75.043-1.367.646-1.367 1.42 0 .782.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.435v-.011a1.456 1.456 0 00-1.365-1.408h-.011zM6.33 17.5h-.128c-.74.044-1.35.67-1.35 1.42 0 .781.63 1.435 1.436 1.435.801 0 1.435-.634 1.435-1.436v-.01A1.459 1.459 0 006.341 17.5h-.01zm5.979 0h-.145c-.74.044-1.35.67-1.35 1.42a1.435 1.435 0 102.872 0c0-.774-.618-1.377-1.366-1.42h-.011zm5.903 0c-.793 0-1.42.657-1.42 1.436 0 .782.631 1.435 1.437 1.435.801 0 1.435-.634 1.435-1.435 0-.786-.65-1.436-1.435-1.436h-.017z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.332.625c-.593 0-1.082.49-1.082 1.082v1.73H3.073A2.453 2.453 0 00.625 5.886v15.557c0 1.348 1.1 2.448 2.448 2.448h18.354c1.348 0 2.448-1.1 2.448-2.448V5.886c0-1.348-1.1-2.449-2.448-2.449H18.25v-1.73c0-.593-.49-1.082-1.082-1.082-.593 0-1.082.49-1.082 1.082v1.73H8.414v-1.73c0-.593-.489-1.082-1.082-1.082zM2.79 21.427V11.21h18.938v10.206a.3.3 0 01-.3.294H3.073a.287.287 0 01-.284-.284z",
        fillRule: "evenodd"
    })));
});
$f652fd921f37ce44$export$6cbcb5cd862c2b93.displayName = 'DateBold';





var $denZA = parcelRequire("denZA");
var $d67d5c680050bc5d$var$__assign = undefined && undefined.__assign || function() {
    $d67d5c680050bc5d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d67d5c680050bc5d$var$__assign.apply(this, arguments);
};
var $d67d5c680050bc5d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d67d5c680050bc5d$export$bfadae053a633538 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d67d5c680050bc5d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d67d5c680050bc5d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.827 10.077a.75.75 0 01.75.75v6.461a.75.75 0 01-1.5 0v-6.461a.75.75 0 01.75-.75zm5.596.75a.75.75 0 00-1.5 0v6.461a.75.75 0 001.5 0v-6.461z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.827 2A2.365 2.365 0 007.46 4.365v.866H1.75a.75.75 0 000 1.5h2.481v13.788a2.365 2.365 0 002.365 2.366h11.308a2.365 2.365 0 002.365-2.366V6.731h2.481a.75.75 0 000-1.5h-5.712v-.866A2.365 2.365 0 0014.673 2H9.827zM8.198 6.73h8.09a.74.74 0 00.014 0h2.467v13.79a.866.866 0 01-.865.864H6.596a.865.865 0 01-.865-.865V6.731h2.467zm7.34-1.5v-.865a.865.865 0 00-.865-.865H9.827a.865.865 0 00-.866.865v.866h6.577z",
        fillRule: "evenodd"
    })));
});
$d67d5c680050bc5d$export$bfadae053a633538.displayName = 'Delete';





var $denZA = parcelRequire("denZA");
var $a24e34fe1a2c695e$var$__assign = undefined && undefined.__assign || function() {
    $a24e34fe1a2c695e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a24e34fe1a2c695e$var$__assign.apply(this, arguments);
};
var $a24e34fe1a2c695e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a24e34fe1a2c695e$export$8d5b5b936cb45ab2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a24e34fe1a2c695e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a24e34fe1a2c695e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.577 1A3.115 3.115 0 006.46 4.115v.116H1.5a1.5 1.5 0 000 3h1.731v13.038a3.116 3.116 0 003.115 3.116h11.308a3.115 3.115 0 003.115-3.116V7.231H22.5a1.5 1.5 0 000-3h-4.962v-.116A3.116 3.116 0 0014.423 1H9.577zm0 8.077a1.5 1.5 0 011.5 1.5v6.461a1.5 1.5 0 01-3 0v-6.461a1.5 1.5 0 011.5-1.5zm6.346 1.5a1.5 1.5 0 10-3 0v6.461a1.5 1.5 0 003 0v-6.461z",
        fillRule: "evenodd"
    })));
});
$a24e34fe1a2c695e$export$8d5b5b936cb45ab2.displayName = 'DeleteBold';





var $denZA = parcelRequire("denZA");
var $7e905a342104974c$var$__assign = undefined && undefined.__assign || function() {
    $7e905a342104974c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e905a342104974c$var$__assign.apply(this, arguments);
};
var $7e905a342104974c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e905a342104974c$export$46852f92ac6efad8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7e905a342104974c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7e905a342104974c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.238 2.464a.75.75 0 01.671-.414h8.182a.75.75 0 01.67.414L18.6 6.14h2.604A2.796 2.796 0 0124 8.933v10.223a2.794 2.794 0 01-2.796 2.794H2.796A2.796 2.796 0 010 19.156V8.933A2.794 2.794 0 012.795 6.14H5.4l1.838-3.675zM8.373 3.55L6.534 7.224a.75.75 0 01-.67.415H2.795A1.296 1.296 0 001.5 8.933v10.223a1.294 1.294 0 001.295 1.294h18.41a1.296 1.296 0 001.295-1.294V8.933a1.294 1.294 0 00-1.296-1.294h-3.068a.75.75 0 01-.67-.415L15.627 3.55H8.373zm.204 6.05a4.842 4.842 0 018.264 3.422 4.838 4.838 0 01-4.84 4.84 4.842 4.842 0 01-4.842-4.84A4.84 4.84 0 018.577 9.6zM12 9.683a3.342 3.342 0 00-3.34 3.34A3.338 3.338 0 0012 16.36a3.342 3.342 0 003.341-3.339 3.338 3.338 0 00-3.34-3.339z",
        fillRule: "evenodd"
    })));
});
$7e905a342104974c$export$46852f92ac6efad8.displayName = 'DevicesCamera';





var $denZA = parcelRequire("denZA");
var $a54b4f8661e3e092$var$__assign = undefined && undefined.__assign || function() {
    $a54b4f8661e3e092$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a54b4f8661e3e092$var$__assign.apply(this, arguments);
};
var $a54b4f8661e3e092$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a54b4f8661e3e092$export$66352a2ca763a212 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a54b4f8661e3e092$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a54b4f8661e3e092$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21 5.576h-2.786L16.03 2.664A1.286 1.286 0 0015 2.15H9a1.286 1.286 0 00-1.029.514L5.786 5.576H3a3.005 3.005 0 00-3 2.998v10.278a3 3 0 003 2.998h18a3.004 3.004 0 003-2.998V8.574a3 3 0 00-3-2.998zm-9 13.276a5.575 5.575 0 01-5.147-3.437 5.564 5.564 0 014.06-7.59 5.575 5.575 0 015.72 2.367c.612.915.938 1.992.938 3.093A5.572 5.572 0 0112 18.852z"
    }), $denZA.createElement("path", {
        d: "M9 13.285a2.997 2.997 0 003 2.998 3.001 3.001 0 003-2.998 2.997 2.997 0 00-3-2.998 3.001 3.001 0 00-3 2.998z"
    })));
});
$a54b4f8661e3e092$export$66352a2ca763a212.displayName = 'DevicesCameraBold';





var $denZA = parcelRequire("denZA");
var $538b441cc130b255$var$__assign = undefined && undefined.__assign || function() {
    $538b441cc130b255$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $538b441cc130b255$var$__assign.apply(this, arguments);
};
var $538b441cc130b255$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $538b441cc130b255$export$92da3e5df6c76b76 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $538b441cc130b255$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $538b441cc130b255$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.746 2A.746.746 0 000 2.746v14.92c0 .413.334.747.746.747h5.853a10.296 10.296 0 00-2.703 2.375.746.746 0 001.166.932 8.804 8.804 0 016.715-3.307h.325a8.802 8.802 0 016.715 3.307.746.746 0 101.166-.932 10.296 10.296 0 00-2.703-2.375h5.847a.746.746 0 00.746-.746V2.746A.746.746 0 0023.127 2H.746zm11.37 14.92H22.38V3.493H1.492v13.429h10.272a10.291 10.291 0 01.351 0z",
        fillRule: "evenodd"
    })));
});
$538b441cc130b255$export$92da3e5df6c76b76.displayName = 'DevicesExternalScreen';





var $denZA = parcelRequire("denZA");
var $81697f9f533f45ed$var$__assign = undefined && undefined.__assign || function() {
    $81697f9f533f45ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81697f9f533f45ed$var$__assign.apply(this, arguments);
};
var $81697f9f533f45ed$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $81697f9f533f45ed$export$c2cb3515656b7205 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $81697f9f533f45ed$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $81697f9f533f45ed$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.19 2H.81a.81.81 0 00-.81.81V17.6a.81.81 0 00.81.81h5.66a15.003 15.003 0 00-2.75 2.14 1 1 0 001.44 1.39s3.19-3.25 6.84-3.25 6.56 3.18 6.58 3.21a1 1 0 101.52-1.3 12.68 12.68 0 00-2.6-2.19h5.69a.81.81 0 00.81-.81V2.81a.81.81 0 00-.81-.81zM2.92 6.17a.9.9 0 01.9-.9h16.36a.9.9 0 01.9.9v8.09a.9.9 0 01-.264.636c-.168.17-.267.264-.506.264H3.95c-.239 0-.598-.095-.766-.264a.9.9 0 01-.264-.636V6.17z"
    })));
});
$81697f9f533f45ed$export$c2cb3515656b7205.displayName = 'DevicesExternalScreenBold';





var $denZA = parcelRequire("denZA");
var $af6989805c58523b$var$__assign = undefined && undefined.__assign || function() {
    $af6989805c58523b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af6989805c58523b$var$__assign.apply(this, arguments);
};
var $af6989805c58523b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $af6989805c58523b$export$2ab1c2ba66a64865 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $af6989805c58523b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $af6989805c58523b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.211 18.925l-2.005-4.378V5.19a2.197 2.197 0 00-2.19-2.189H4.396a2.2 2.2 0 00-2.206 2.19v9.34L.184 18.91a2.48 2.48 0 00-.184.902c0 .585.234 1.136.635 1.554.401.418.97.635 1.554.635h19.017c.3 0 .601-.067.886-.184a2.124 2.124 0 001.152-1.22 2.15 2.15 0 00-.033-1.67zM3.66 5.19c0-.401.334-.735.735-.735h14.622c.4 0 .735.334.735.735v8.773H3.66V5.19zm18.23 14.89a.653.653 0 01-.383.4c-.1.034-.2.067-.301.067H2.189a.733.733 0 01-.518-.217.733.733 0 01-.217-.518c0-.1.017-.2.067-.284l1.871-4.094h16.61l1.872 4.094a.78.78 0 01.017.551z"
    }), $denZA.createElement("path", {
        d: "M13.168 17.622h-2.924a.742.742 0 00-.736.735c0 .401.335.735.736.735h2.924a.742.742 0 00.735-.735.742.742 0 00-.735-.735z"
    })));
});
$af6989805c58523b$export$2ab1c2ba66a64865.displayName = 'DevicesLaptop';





var $denZA = parcelRequire("denZA");
var $5ad3e7b590c97d72$var$__assign = undefined && undefined.__assign || function() {
    $5ad3e7b590c97d72$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5ad3e7b590c97d72$var$__assign.apply(this, arguments);
};
var $5ad3e7b590c97d72$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5ad3e7b590c97d72$export$f87d7e42ebd1d48b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5ad3e7b590c97d72$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5ad3e7b590c97d72$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.53 20l-1.88-5H2.27L.45 19.85a2.29 2.29 0 002.13 3.26h19A2.19 2.19 0 0023.53 20zm-9.45 0h-3.92a1 1 0 010-2h3.92a1 1 0 010 2z"
    }), $denZA.createElement("path", {
        d: "M21.65 15.37H2.27V3.46A2.66 2.66 0 015 .89h13.92a2.66 2.66 0 012.74 2.58l-.01 11.9zM4.09 13.66h15.75V3.46a.9.9 0 00-.93-.87H5a.9.9 0 00-.93.87l.02 10.2z"
    })));
});
$5ad3e7b590c97d72$export$f87d7e42ebd1d48b.displayName = 'DevicesLaptopBold';





var $denZA = parcelRequire("denZA");
var $12fe4b0e508f0302$var$__assign = undefined && undefined.__assign || function() {
    $12fe4b0e508f0302$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12fe4b0e508f0302$var$__assign.apply(this, arguments);
};
var $12fe4b0e508f0302$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $12fe4b0e508f0302$export$b6d29e88abddfdd7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $12fe4b0e508f0302$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $12fe4b0e508f0302$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#devices-phone_svg__a)"
    }, $denZA.createElement("path", {
        d: "M16.465 23.598a6.222 6.222 0 01-3.33-.863 47.837 47.837 0 01-11.68-10.95 7.262 7.262 0 010-8.722l1.203-1.646A2.247 2.247 0 014.202.413a1.743 1.743 0 011.334.392l3.78 3.01a1.877 1.877 0 01.521 2.27l-.852 2.087a.884.884 0 00.15 1.003l6.016 5.65c.19.192.682 0 1.003-.21l1.323-.763a1.913 1.913 0 012.407.412l3.61 3.533a1.907 1.907 0 01-.191 2.77l-1.424 1.244a9.018 9.018 0 01-5.414 1.787zM4.423 1.939c-.223.07-.414.215-.542.412L2.618 3.946a5.815 5.815 0 000 6.956 46.47 46.47 0 0011.32 10.588c1.875 1.205 5.364.532 7.018-.823l1.474-1.214a.42.42 0 00.15-.301.392.392 0 00-.1-.312l-3.61-3.532a.461.461 0 00-.59-.14l-1.324.762c-1.554.893-2.436.381-2.827 0l-6.016-5.65a2.35 2.35 0 01-.482-2.69l.823-2.008a.432.432 0 00-.09-.522L4.613 1.94a.3.3 0 00-.191 0z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "devices-phone_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$12fe4b0e508f0302$export$b6d29e88abddfdd7.displayName = 'DevicesPhone';





var $denZA = parcelRequire("denZA");
var $1051f304cbe48f33$var$__assign = undefined && undefined.__assign || function() {
    $1051f304cbe48f33$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1051f304cbe48f33$var$__assign.apply(this, arguments);
};
var $1051f304cbe48f33$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1051f304cbe48f33$export$62a8189931995eda = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1051f304cbe48f33$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1051f304cbe48f33$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#devices-phone-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M5.48.642l4 3.331a1.2 1.2 0 01.31 1.47l-.942 2.241a1.728 1.728 0 00.301 2.001l5.562 5.362c.541.56 1.393.3 2.074-.07l1.443-.79a1.264 1.264 0 011.574.3l3.858 3.91a1.998 1.998 0 01-.07 2.332l-1.604 1.25c-2.114 1.67-6.363 2.47-8.598 1A50.736 50.736 0 011.261 11.176a7.343 7.343 0 01.27-8.603L2.876.833A2.006 2.006 0 015.48.642z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "devices-phone-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$1051f304cbe48f33$export$62a8189931995eda.displayName = 'DevicesPhoneBold';





var $denZA = parcelRequire("denZA");
var $26cb4329cf693f19$var$__assign = undefined && undefined.__assign || function() {
    $26cb4329cf693f19$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26cb4329cf693f19$var$__assign.apply(this, arguments);
};
var $26cb4329cf693f19$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $26cb4329cf693f19$export$13ffd9e444ebb4d9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $26cb4329cf693f19$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $26cb4329cf693f19$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h7.5A.75.75 0 019 .75v12a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-12zm1.5 9.75V12h6v-1.5h-6zm6-1.5h-6V1.5h6V9z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.5 5.25a.75.75 0 01.75-.75h10.5A2.25 2.25 0 0124 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-5.115l.5 3h1.615a.75.75 0 010 1.5H8.25a.75.75 0 010-1.5h1.615l.5-3H5.25A2.25 2.25 0 013 17.25v-1.5a.75.75 0 01.75-.75H22.5V6.75a.75.75 0 00-.75-.75h-10.5a.75.75 0 01-.75-.75zm12 11.25h-18v.75a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75v-.75zm-10.615 3h3.23l.5 3h-4.23l.5-3z",
        fillRule: "evenodd"
    })));
});
$26cb4329cf693f19$export$13ffd9e444ebb4d9.displayName = 'DevicesResponsiveWebSite';





var $denZA = parcelRequire("denZA");
var $d1e08ee792e796fd$var$__assign = undefined && undefined.__assign || function() {
    $d1e08ee792e796fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d1e08ee792e796fd$var$__assign.apply(this, arguments);
};
var $d1e08ee792e796fd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d1e08ee792e796fd$export$7a564e6549df712a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d1e08ee792e796fd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d1e08ee792e796fd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M5.15 19.6c-1.33 0-1.7-.37-1.83-.5a1.13 1.13 0 01-.32-.8v-1.46a1.13 1.13 0 011.1-1.12H22V6.48a.25.25 0 00-.25-.25h-10.4a1 1 0 110-2h10.42A2.25 2.25 0 0124 6.48v10.87a2.249 2.249 0 01-2.25 2.25H5.15z"
    }), $denZA.createElement("path", {
        d: "M13.5 24a1 1 0 01-1-1v-4.4a1 1 0 012 0V23a1 1 0 01-1 1z"
    }), $denZA.createElement("path", {
        d: "M18.86 24H8.08a1 1 0 010-2h10.78a1 1 0 010 2zM7 12.63H2.07a1.5 1.5 0 110-3H7a1.5 1.5 0 010 3z"
    }), $denZA.createElement("path", {
        d: "M7.8 13.64H1.44A1.45 1.45 0 010 12.19V1.45A1.45 1.45 0 011.44 0H7.8a1.45 1.45 0 011.45 1.45v10.74a1.46 1.46 0 01-.45 1.05 1.44 1.44 0 01-1 .4zm-5.8-2h5.25V2H2v9.64z"
    })));
});
$d1e08ee792e796fd$export$7a564e6549df712a.displayName = 'DevicesResponsiveWebSiteBold';





var $denZA = parcelRequire("denZA");
var $d0fe37054265b585$var$__assign = undefined && undefined.__assign || function() {
    $d0fe37054265b585$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0fe37054265b585$var$__assign.apply(this, arguments);
};
var $d0fe37054265b585$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d0fe37054265b585$export$9924e86c6f4ee998 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d0fe37054265b585$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d0fe37054265b585$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.373 4.488h-.994l-.428-2.62A2.26 2.26 0 0014.724 0H9.773a2.23 2.23 0 00-2.21 1.867l-.428 2.621H6.14c-1.18 0-2.14.96-2.14 2.124V17.37c0 1.165.96 2.125 2.124 2.125h.994l.428 2.62A2.242 2.242 0 009.756 24h4.95a2.229 2.229 0 002.21-1.884l.429-2.621h.993c1.165 0 2.124-.96 2.124-2.125V6.612a2.095 2.095 0 00-2.09-2.124zM9.019 2.124a.752.752 0 01.737-.617h4.95c.36 0 .686.257.737.617l.394 2.381H8.625l.394-2.38zM15.46 21.86a.766.766 0 01-.736.633H9.773a.738.738 0 01-.737-.633l-.41-2.364h7.228l-.394 2.364zm3.53-4.489a.614.614 0 01-.617.617H6.124a.614.614 0 01-.617-.617V6.612c0-.342.275-.616.617-.616h12.249c.342 0 .616.274.616.616V17.37z"
    }), $denZA.createElement("path", {
        d: "M12.24 13.122a1.508 1.508 0 100-3.015 1.508 1.508 0 000 3.015zm-1.867-2.998a1.13 1.13 0 001.13-1.13c0-.634-.497-1.131-1.13-1.131-.634 0-1.131.497-1.131 1.13a1.13 1.13 0 001.13 1.131zm-.377 1.867a1.13 1.13 0 00-1.13-1.13 1.12 1.12 0 00-1.132 1.13 1.13 1.13 0 102.262 0zm5.619-1.131a1.13 1.13 0 100 2.262c.633 0 1.13-.497 1.13-1.13a1.14 1.14 0 00-1.13-1.131zm-1.491-.736a1.13 1.13 0 001.13-1.13c0-.634-.496-1.131-1.13-1.131-.634 0-1.13.497-1.13 1.13 0 .634.496 1.131 1.13 1.131zm-3.751 3.735a1.13 1.13 0 00-1.131 1.13c0 .634.497 1.13 1.13 1.13.634 0 1.131-.496 1.131-1.13a1.13 1.13 0 00-1.13-1.13zm3.751 0a1.13 1.13 0 00-1.13 1.13c0 .634.496 1.13 1.13 1.13.634 0 1.13-.496 1.13-1.13a1.13 1.13 0 00-1.13-1.13z"
    })));
});
$d0fe37054265b585$export$9924e86c6f4ee998.displayName = 'DevicesSmartWatch';





var $denZA = parcelRequire("denZA");
var $2c773a1aba64c3f8$var$__assign = undefined && undefined.__assign || function() {
    $2c773a1aba64c3f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c773a1aba64c3f8$var$__assign.apply(this, arguments);
};
var $2c773a1aba64c3f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2c773a1aba64c3f8$export$c7dc63f73a2d7118 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2c773a1aba64c3f8$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2c773a1aba64c3f8$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M16.43 2.75a.248.248 0 00.2-.1.25.25 0 00.035-.225l-.69-2.083A.5.5 0 0015.5 0h-7a.5.5 0 00-.475.342l-.693 2.079a.251.251 0 00.035.225.25.25 0 00.2.1l8.863.004zm-8.86 18.5a.251.251 0 00-.238.329l.693 2.079A.5.5 0 008.5 24h7a.5.5 0 00.475-.342l.693-2.079a.25.25 0 00-.238-.329H7.57z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.5 4h11A2.5 2.5 0 0120 6.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.508 2.508 0 014 17.5v-11A2.5 2.5 0 016.5 4zm4.25 4a1 1 0 10-2 0 1 1 0 002 0zm-3.5 5a1 1 0 110-2 1 1 0 010 2zm1.5 3a1 1 0 102 0 1 1 0 00-2 0zM10 12.25a2 2 0 114 0 2 2 0 01-4 0zM13.25 16a1 1 0 102 0 1 1 0 00-2 0zm1-7a1 1 0 110-2 1 1 0 010 2zm1.5 3a1 1 0 102 0 1 1 0 00-2 0z",
        fillRule: "evenodd"
    })));
});
$2c773a1aba64c3f8$export$c7dc63f73a2d7118.displayName = 'DevicesSmartWatchBold';





var $denZA = parcelRequire("denZA");
var $473c9241be76f4ca$var$__assign = undefined && undefined.__assign || function() {
    $473c9241be76f4ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $473c9241be76f4ca$var$__assign.apply(this, arguments);
};
var $473c9241be76f4ca$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $473c9241be76f4ca$export$86ae6e8ac17a67c6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $473c9241be76f4ca$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $473c9241be76f4ca$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.28 4.183l-2.47-2.469a.752.752 0 00-.531-.223h-8.246V.754A.761.761 0 0011.28 0a.761.761 0 00-.754.754v.755H3.788a.761.761 0 00-.754.754v6c0 .411.343.754.754.754h6.755v1.509H3.788a.752.752 0 00-.53.223l-2.47 2.434a1.493 1.493 0 000 2.126l2.47 2.468a.752.752 0 00.53.223h6.755v5.246c0 .411.343.754.754.754a.761.761 0 00.754-.754V18h8.246a.761.761 0 00.754-.754v-6a.761.761 0 00-.754-.755h-8.263V8.983h8.246a.752.752 0 00.531-.223l2.469-2.469c.583-.565.583-1.525 0-2.108zM19.526 16.49H4.097l-2.246-2.245L4.097 12h15.446v4.491h-.017zm2.691-11.245L19.971 7.49H4.526V3H19.97l2.246 2.246z"
    })));
});
$473c9241be76f4ca$export$86ae6e8ac17a67c6.displayName = 'Directions';





var $denZA = parcelRequire("denZA");
var $5e76c5b3e9a23c2c$var$__assign = undefined && undefined.__assign || function() {
    $5e76c5b3e9a23c2c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e76c5b3e9a23c2c$var$__assign.apply(this, arguments);
};
var $5e76c5b3e9a23c2c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5e76c5b3e9a23c2c$export$8871f210e34a6755 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5e76c5b3e9a23c2c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5e76c5b3e9a23c2c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20.811 1.714l2.469 2.469c.583.583.583 1.543 0 2.108L20.81 8.76a.752.752 0 01-.531.223h-7.53v1.508h7.547a.76.76 0 01.754.755v6a.761.761 0 01-.754.754H12.75v4.5a1.5 1.5 0 01-3 0V18H3.788a.752.752 0 01-.53-.223L.787 15.31a1.493 1.493 0 010-2.126l2.47-2.434a.752.752 0 01.53-.223H9.75v-1.51H3.788a.761.761 0 01-.754-.754v-6a.76.76 0 01.754-.754H9.75V1.5a1.5 1.5 0 013-.009h7.53c.206 0 .394.086.531.223z"
    })));
});
$5e76c5b3e9a23c2c$export$8871f210e34a6755.displayName = 'DirectionsBold';





var $denZA = parcelRequire("denZA");
var $990c5696ef355e05$var$__assign = undefined && undefined.__assign || function() {
    $990c5696ef355e05$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $990c5696ef355e05$var$__assign.apply(this, arguments);
};
var $990c5696ef355e05$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $990c5696ef355e05$export$5f0fddd75cd8dcd7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $990c5696ef355e05$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $990c5696ef355e05$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5 1.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm13.5 12a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.726 2.22a.75.75 0 00-1.06 0L1.22 21.312l-.067.076a.75.75 0 001.127.984L21.726 3.28l.067-.076a.75.75 0 00-.067-.984z"
    })));
});
$990c5696ef355e05$export$5f0fddd75cd8dcd7.displayName = 'Discount';





var $denZA = parcelRequire("denZA");
var $cbaa238d9dbe9f62$var$__assign = undefined && undefined.__assign || function() {
    $cbaa238d9dbe9f62$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbaa238d9dbe9f62$var$__assign.apply(this, arguments);
};
var $cbaa238d9dbe9f62$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cbaa238d9dbe9f62$export$f4dcdf7799f12754 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $cbaa238d9dbe9f62$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $cbaa238d9dbe9f62$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.255 1.973a1.75 1.75 0 00-2.475-.035l-18 17.5a1.75 1.75 0 002.44 2.509l18-17.5a1.75 1.75 0 00.035-2.474zM5 8.558a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm17.5 10.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"
    })));
});
$cbaa238d9dbe9f62$export$f4dcdf7799f12754.displayName = 'DiscountBold';





var $denZA = parcelRequire("denZA");
var $6ef0069294a9d4e0$var$__assign = undefined && undefined.__assign || function() {
    $6ef0069294a9d4e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ef0069294a9d4e0$var$__assign.apply(this, arguments);
};
var $6ef0069294a9d4e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6ef0069294a9d4e0$export$a7aaed3e118dd255 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6ef0069294a9d4e0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6ef0069294a9d4e0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12 3a.75.75 0 01.75.75v10.19l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.748.748 0 01-1.058.003l-.002-.003-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3.75A.75.75 0 0112 3z"
    }), $denZA.createElement("path", {
        d: "M1.5 15.75a.75.75 0 00-1.5 0v1.5A3.75 3.75 0 003.75 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    })));
});
$6ef0069294a9d4e0$export$a7aaed3e118dd255.displayName = 'Download';





var $denZA = parcelRequire("denZA");
var $95da045237344c9f$var$__assign = undefined && undefined.__assign || function() {
    $95da045237344c9f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95da045237344c9f$var$__assign.apply(this, arguments);
};
var $95da045237344c9f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $95da045237344c9f$export$c11cb5f0ac38b435 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $95da045237344c9f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $95da045237344c9f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.77 16.79c-.675 0-1.223.527-1.223 1.177v1.8c-.001.842-.711 1.524-1.587 1.524H4.035c-.876 0-1.586-.682-1.587-1.524v-1.8c0-.65-.548-1.176-1.224-1.176-.676 0-1.224.526-1.224 1.176v1.8c0 2.143 1.806 3.88 4.035 3.883H19.96c2.231 0 4.04-1.738 4.04-3.883v-1.8c0-.313-.13-.613-.36-.834a1.25 1.25 0 00-.87-.342z"
    }), $denZA.createElement("path", {
        d: "M11.998.35c-1.082 0-1.959.843-1.959 1.882v8.8a.248.248 0 01-.252.242H7.1a.983.983 0 00-.89.552c-.16.335-.1.729.15 1.007l4.897 5.412a.996.996 0 00.74.325.996.996 0 00.739-.325l4.896-5.412a.913.913 0 00.152-1.008.983.983 0 00-.891-.55h-2.686a.248.248 0 01-.252-.243v-8.8c0-1.04-.877-1.882-1.958-1.882z"
    })));
});
$95da045237344c9f$export$c11cb5f0ac38b435.displayName = 'DownloadBold';





var $denZA = parcelRequire("denZA");
var $09555df5fad0a35f$var$__assign = undefined && undefined.__assign || function() {
    $09555df5fad0a35f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $09555df5fad0a35f$var$__assign.apply(this, arguments);
};
var $09555df5fad0a35f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $09555df5fad0a35f$export$81d26d25f3637d53 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $09555df5fad0a35f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $09555df5fad0a35f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.817.44A.75.75 0 014.81.067l14.42 6.549-.558-1.486a.75.75 0 011.404-.527l1.194 3.18.011.033a.747.747 0 01-.45.933l-3.18 1.194a.75.75 0 01-.528-1.404l1.486-.558L4.19 1.433A.75.75 0 013.818.44z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 9a1.5 1.5 0 00-1.5 1.5v12H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75V18a1.5 1.5 0 00-1.5-1.5h-3a1.5 1.5 0 00-1.5 1.5v4.5H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5v-12A1.5 1.5 0 006 9H3zm3 13.5v-12H3v12h3zm7.5-9v9h-3v-9h3zm7.5 9V18h-3v4.5h3z",
        fillRule: "evenodd"
    })));
});
$09555df5fad0a35f$export$81d26d25f3637d53.displayName = 'DownwardTrend';





var $denZA = parcelRequire("denZA");
var $83527827342ec544$var$__assign = undefined && undefined.__assign || function() {
    $83527827342ec544$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83527827342ec544$var$__assign.apply(this, arguments);
};
var $83527827342ec544$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $83527827342ec544$export$19ef125bf9110819 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $83527827342ec544$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $83527827342ec544$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20 18a1 1 0 00-1 1v1.5a.249.249 0 00.25.25h3.5a.25.25 0 00.25-.25V19a1 1 0 00-1-1h-2zm-4-3h-2a1 1 0 00-1 1v4.5a.249.249 0 00.25.25h3.5a.25.25 0 00.25-.25V16a1 1 0 00-1-1zm-8-3.5a1 1 0 00-1 1v8a.249.249 0 00.25.25h3.5a.25.25 0 00.25-.25v-8a1 1 0 00-1-1H8zm-6.75 9.25h3.5A.25.25 0 005 20.5v-12a1 1 0 00-1-1H2a1 1 0 00-1 1v12a.249.249 0 00.25.25zM21 13.751a.75.75 0 00.651-1.122l-2-3.5a.748.748 0 00-1.275-.044l-.307.46a.244.244 0 01-.159.106.247.247 0 01-.187-.037L3.555.169a1 1 0 00-1.11 1.664l14.168 9.445a.252.252 0 01.07.347l-.307.46a.75.75 0 00.531 1.16l4 .5c.03.004.062.006.093.006zM1 24h22a1 1 0 000-2H1a1 1 0 100 2z"
    })));
});
$83527827342ec544$export$19ef125bf9110819.displayName = 'DownwardTrendBold';





var $denZA = parcelRequire("denZA");
var $8ff5e903fbcd4a48$var$__assign = undefined && undefined.__assign || function() {
    $8ff5e903fbcd4a48$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ff5e903fbcd4a48$var$__assign.apply(this, arguments);
};
var $8ff5e903fbcd4a48$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8ff5e903fbcd4a48$export$4a82481d9e63c9e1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8ff5e903fbcd4a48$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8ff5e903fbcd4a48$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2 4.251A2.251 2.251 0 014.25 2H16.5a2 2 0 012 2A.75.75 0 0117 4a.5.5 0 00-.5-.5H4.25a.751.751 0 00-.75.751V16.5a.5.5 0 00.5.5.75.75 0 010 1.5 2 2 0 01-2-2V4.251z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20 7.5H8a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zM8 6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2H8z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14 10.45a.75.75 0 01.75.75v2.05h2.05a.75.75 0 010 1.5h-2.05v2.05a.75.75 0 11-1.5 0v-2.05H11.2a.75.75 0 110-1.5h2.05V11.2a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    })));
});
$8ff5e903fbcd4a48$export$4a82481d9e63c9e1.displayName = 'Duplicate';





var $denZA = parcelRequire("denZA");
var $6349a7a64f5111a3$var$__assign = undefined && undefined.__assign || function() {
    $6349a7a64f5111a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6349a7a64f5111a3$var$__assign.apply(this, arguments);
};
var $6349a7a64f5111a3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6349a7a64f5111a3$export$7791901baee658a0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6349a7a64f5111a3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6349a7a64f5111a3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.25 4.251a3.001 3.001 0 013-3.001H16.5A2.75 2.75 0 0119.25 4a1.5 1.5 0 01-2.98.25H4.25v12.021A1.5 1.5 0 014 19.25a2.75 2.75 0 01-2.75-2.75V4.251z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.5 6.5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-12a2 2 0 00-2-2h-12zm7 5.2a1 1 0 00-2 0v1.8h-1.8a1 1 0 000 2h1.8v1.8a1 1 0 102 0v-1.8h1.8a1 1 0 100-2h-1.8v-1.8z",
        fillRule: "evenodd"
    })));
});
$6349a7a64f5111a3$export$7791901baee658a0.displayName = 'DuplicateBold';





var $denZA = parcelRequire("denZA");
var $c95fddc75db29ea7$var$__assign = undefined && undefined.__assign || function() {
    $c95fddc75db29ea7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c95fddc75db29ea7$var$__assign.apply(this, arguments);
};
var $c95fddc75db29ea7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c95fddc75db29ea7$export$a8d7cb18a6ef9581 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c95fddc75db29ea7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c95fddc75db29ea7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 1.5C7.243 1.5 3.226 4.663 1.935 9H6.33c1.021 0 1.937.718 2.178 1.71l.748 2.992c.373 1.403-.753 2.802-2.177 2.798h-.463l-.79 3.993A10.453 10.453 0 0012 22.5c3.508 0 6.615-1.72 8.522-4.364-.279 0-.555-.003-.786-.012-.76-.029-1.26-.387-1.55-.853-.202-.323-.303-.73-.343-.89l-.015-.057c-.068-.227-.215-.92-.38-1.69-.068-.322-.14-.658-.21-.979a46.566 46.566 0 00-.369-1.592h-1.05c-.929 0-1.575-.385-1.906-.99a2.052 2.052 0 01-.176-1.465c.066-.24.223-.776.395-1.367.267-.913.572-1.955.637-2.237l.009-.041c.03-.15.11-.536.366-.845.335-.404.84-.571 1.45-.571h2.802A10.467 10.467 0 0012 1.5zm8.647 4.542a.757.757 0 01-.084.005h-3.97a.872.872 0 00-.294.036l-.003.002a1.41 1.41 0 00-.044.163l-.021.092c-.072.313-.427 1.53-.708 2.49v.001c-.157.538-.29.996-.338 1.17a.527.527 0 00-.009.156.492.492 0 00.053.196c.024.045.06.086.126.122.07.038.21.088.465.088h1.57c.358 0 .558.236.59.276l.002.001c.062.073.1.145.118.18.04.08.072.167.095.235.05.144.102.334.154.54.107.42.233.977.355 1.542.085.387.167.772.241 1.121.15.706.27 1.27.32 1.437.017.057.034.12.047.17l.005.02c.015.06.03.111.045.162a.975.975 0 00.096.23.26.26 0 00.09.093c.03.018.1.05.247.056.437.016 1.03.01 1.5.003l.133-.001A10.456 10.456 0 0022.5 12a10.45 10.45 0 00-1.853-5.958zM1.5 12c0-.51.036-1.01.106-1.5h4.725c.332 0 .642.243.72.566l.751 3.006.004.013c.123.455-.266.917-.723.915H6a.75.75 0 00-.736.604l-.745 3.764A10.466 10.466 0 011.5 12zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
        fillRule: "evenodd"
    })));
});
$c95fddc75db29ea7$export$a8d7cb18a6ef9581.displayName = 'Earth';





var $denZA = parcelRequire("denZA");
var $831bd861c7829611$var$__assign = undefined && undefined.__assign || function() {
    $831bd861c7829611$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $831bd861c7829611$var$__assign.apply(this, arguments);
};
var $831bd861c7829611$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $831bd861c7829611$export$fe16e501ff7c8331 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $831bd861c7829611$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $831bd861c7829611$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#earth-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm-1.971 20.349a.446.446 0 01-.343-.429v-3.171a4.029 4.029 0 00-4.012-4.029H3.857a.428.428 0 01-.428-.411V12a8.571 8.571 0 0113.234-7.183.412.412 0 01.188.48.428.428 0 01-.411.309h-2.074a4.054 4.054 0 000 8.108.719.719 0 01.737.72l.5 2.666s.115.923.506 1.267c.392.344 1.485.222 1.485.36 0 .137-.04.203-.04.203-.171.148-.843.533-1.773.906-1.129.453-2.226.744-3.781.735a9.253 9.253 0 01-1.971-.222z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "earth-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$831bd861c7829611$export$fe16e501ff7c8331.displayName = 'EarthBold';





var $denZA = parcelRequire("denZA");
var $1e93660dddd467dc$var$__assign = undefined && undefined.__assign || function() {
    $1e93660dddd467dc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e93660dddd467dc$var$__assign.apply(this, arguments);
};
var $1e93660dddd467dc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1e93660dddd467dc$export$6ed0965c9443aaa6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1e93660dddd467dc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1e93660dddd467dc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.592 0a4.39 4.39 0 013.128 1.28l.002.002a4.386 4.386 0 01-.04 6.231l-.41.411-.001.001-14.08 14.08-.005.005a.75.75 0 01-.344.196l-6.906 1.77a.75.75 0 01-.912-.913l1.77-6.904a.75.75 0 01.196-.344L16.486 1.318A4.388 4.388 0 0119.592 0zM2.921 17.802l-1.13 4.406 4.41-1.13-3.28-3.276zm4.738 2.612l-4.077-4.07L16.605 3.32l4.074 4.074-13.02 13.02zM22.27 5.507a2.85 2.85 0 01-.531.825l-4.07-4.07a2.89 2.89 0 013.991.079 2.887 2.887 0 01.61 3.166z",
        fillRule: "evenodd"
    })));
});
$1e93660dddd467dc$export$6ed0965c9443aaa6.displayName = 'Edit';





var $denZA = parcelRequire("denZA");
var $fe0e17dc79da5708$var$__assign = undefined && undefined.__assign || function() {
    $fe0e17dc79da5708$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe0e17dc79da5708$var$__assign.apply(this, arguments);
};
var $fe0e17dc79da5708$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fe0e17dc79da5708$export$680fa2622ca83bb7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fe0e17dc79da5708$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fe0e17dc79da5708$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M19.592 0a4.389 4.389 0 013.126 1.279l.002.002a4.386 4.386 0 01.076 6.115 1.005 1.005 0 00-.09-.103l-6-6a1.003 1.003 0 00-.103-.09A4.388 4.388 0 0119.592 0zm1.7 8.707a.971.971 0 00.104.09L9.304 20.89 3.11 14.695 15.201 2.603c.028.036.058.071.091.104l6 6zm-19.509 7.49l-1.76 6.866a.75.75 0 00.913.913l6.865-1.761-6.018-6.018z"
    })));
});
$fe0e17dc79da5708$export$680fa2622ca83bb7.displayName = 'EditBold';





var $denZA = parcelRequire("denZA");
var $2c6ad45b0a3c9054$var$__assign = undefined && undefined.__assign || function() {
    $2c6ad45b0a3c9054$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c6ad45b0a3c9054$var$__assign.apply(this, arguments);
};
var $2c6ad45b0a3c9054$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2c6ad45b0a3c9054$export$4c6ac753363de59f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2c6ad45b0a3c9054$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2c6ad45b0a3c9054$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.755 14.775l7.904-7.904a.812.812 0 00.032-.031l.974-.975a2.852 2.852 0 00-.924-4.648 2.85 2.85 0 00-3.107.618l-8.91 8.91a.75.75 0 00-.211.424l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212zM20.65 2.5a1.35 1.35 0 00-.955.395l-.46.46 1.91 1.91.46-.46A1.35 1.35 0 0020.65 2.5zm-9.688 9.128l7.213-7.212 1.909 1.909-7.213 7.213-2.227.318.318-2.228z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M2.69 6.892a.65.65 0 01.46-.19h7a.75.75 0 000-1.5h-7A2.15 2.15 0 001 7.351v14a2.15 2.15 0 002.15 2.15h14a2.15 2.15 0 002.15-2.15v-7a.75.75 0 00-1.5 0v7a.65.65 0 01-.65.65h-14a.65.65 0 01-.65-.65v-14a.65.65 0 01.19-.46z"
    })));
});
$2c6ad45b0a3c9054$export$4c6ac753363de59f.displayName = 'EditFile';





var $denZA = parcelRequire("denZA");
var $4d0fc1d40febbc42$var$__assign = undefined && undefined.__assign || function() {
    $4d0fc1d40febbc42$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d0fc1d40febbc42$var$__assign.apply(this, arguments);
};
var $4d0fc1d40febbc42$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d0fc1d40febbc42$export$b78ec286cc721c36 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4d0fc1d40febbc42$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4d0fc1d40febbc42$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 6.451h6.9a1.5 1.5 0 100-3h-7a2.9 2.9 0 00-2.9 2.9v14a2.9 2.9 0 002.9 2.9h14a2.9 2.9 0 002.9-2.9v-7a1.5 1.5 0 10-3 0v6.9H3v-13.8z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.722 5.558a.772.772 0 00-.015-.015l-4.015-4.015.692-.693a2.85 2.85 0 014.031 4.03l-.693.693zm-1.414 1.414a1.652 1.652 0 01-.015-.015l-4.015-4.015-6.803 6.802a.75.75 0 00-.212.425l-.495 3.465a.75.75 0 00.849.849l3.464-.496a.75.75 0 00.424-.212l6.803-6.803z"
    })));
});
$4d0fc1d40febbc42$export$b78ec286cc721c36.displayName = 'EditFileBold';





var $denZA = parcelRequire("denZA");
var $0e1ce20d7f28d919$var$__assign = undefined && undefined.__assign || function() {
    $0e1ce20d7f28d919$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e1ce20d7f28d919$var$__assign.apply(this, arguments);
};
var $0e1ce20d7f28d919$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0e1ce20d7f28d919$export$65259f2909ebaca1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0e1ce20d7f28d919$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0e1ce20d7f28d919$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.6 3.2H2.4A2.4 2.4 0 000 5.6v12.8a2.4 2.4 0 002.4 2.4h19.2a2.4 2.4 0 002.4-2.4V5.6a2.4 2.4 0 00-2.4-2.4zM2.4 4.8h19.2a.8.8 0 01.8.8v12.8a.8.8 0 01-.8.8H2.4a.8.8 0 01-.8-.8V5.6a.8.8 0 01.8-.8z"
    }), $denZA.createElement("path", {
        d: "M22.35 3.953a.8.8 0 011.065 1.189l-.089.079-8.687 6.681a4.329 4.329 0 01-5.089.138l-.19-.138L.675 5.221a.8.8 0 01.876-1.334l.1.066 8.686 6.681a2.729 2.729 0 003.16.119l.168-.119 8.687-6.681z"
    })));
});
$0e1ce20d7f28d919$export$65259f2909ebaca1.displayName = 'EmailUnread';





var $denZA = parcelRequire("denZA");
var $ad71b328e8ff9e91$var$__assign = undefined && undefined.__assign || function() {
    $ad71b328e8ff9e91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad71b328e8ff9e91$var$__assign.apply(this, arguments);
};
var $ad71b328e8ff9e91$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ad71b328e8ff9e91$export$7814126f72106a6c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ad71b328e8ff9e91$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ad71b328e8ff9e91$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.118 14.58a1.25 1.25 0 001.77 0l9.679-9.68a.5.5 0 00.12-.51c-.11-.33-.42-.39-.69-.39H2c-.27 0-.58 0-.69.36a.5.5 0 00.12.51l9.688 9.709z"
    }), $denZA.createElement("path", {
        d: "M23.997 5.93a.18.18 0 00-.28 0l-9.749 9.74a2.75 2.75 0 01-3.89 0L.31 5.9a.18.18 0 00-.2 0A.18.18 0 000 6v12a2 2 0 002 1.999h19.997a2 2 0 002-2V6.001a.183.183 0 000-.07z"
    })));
});
$ad71b328e8ff9e91$export$7814126f72106a6c.displayName = 'EmailUnreadBold';





var $denZA = parcelRequire("denZA");
var $e83fa272a194ced8$var$__assign = undefined && undefined.__assign || function() {
    $e83fa272a194ced8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e83fa272a194ced8$var$__assign.apply(this, arguments);
};
var $e83fa272a194ced8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e83fa272a194ced8$export$49bd1dfb0ad29c40 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e83fa272a194ced8$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e83fa272a194ced8$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.746 3.806v4.69a.75.75 0 001.5 0v-6.5a.747.747 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-7.22 7.22a.75.75 0 101.06 1.06l7.22-7.22zM1.996 14.974a.75.75 0 01.75.75v4.689l7.22-7.22a.75.75 0 011.06 1.061l-7.22 7.22h4.69a.75.75 0 110 1.5h-6.5a.746.746 0 01-.679-.43.747.747 0 01-.071-.32v-6.5a.75.75 0 01.75-.75z"
    })));
});
$e83fa272a194ced8$export$49bd1dfb0ad29c40.displayName = 'Expand';





var $denZA = parcelRequire("denZA");
var $d194382a680f387a$var$__assign = undefined && undefined.__assign || function() {
    $d194382a680f387a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d194382a680f387a$var$__assign.apply(this, arguments);
};
var $d194382a680f387a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d194382a680f387a$export$6b5ba4345fea866a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d194382a680f387a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d194382a680f387a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20.996 8.496a1.5 1.5 0 003 0v-6.5a1.496 1.496 0 00-1.5-1.5h-6.5a1.5 1.5 0 000 3h2.879l-5.94 5.94a1.5 1.5 0 102.121 2.12l5.94-5.939v2.879zm-19 5.728a1.5 1.5 0 011.5 1.5v2.878l5.94-5.939a1.5 1.5 0 112.12 2.121l-5.939 5.94h2.879a1.5 1.5 0 110 3h-6.5a1.494 1.494 0 01-1.374-.897 1.495 1.495 0 01-.126-.603v-6.5a1.5 1.5 0 011.5-1.5z"
    })));
});
$d194382a680f387a$export$6b5ba4345fea866a.displayName = 'ExpandBold';





var $denZA = parcelRequire("denZA");
var $7e88bf08caf76539$var$__assign = undefined && undefined.__assign || function() {
    $7e88bf08caf76539$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e88bf08caf76539$var$__assign.apply(this, arguments);
};
var $7e88bf08caf76539$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e88bf08caf76539$export$8d33be737d1dc763 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7e88bf08caf76539$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7e88bf08caf76539$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 14.5a.75.75 0 01.75-.75h10.5a.75.75 0 01.75.75v8.75a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V14.5zm1.5.75v7.25h9v-7.25h-9z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6 10a4.5 4.5 0 00-4.5 4.5.75.75 0 01-1.5 0 6 6 0 1112 0 .75.75 0 01-1.5 0A4.5 4.5 0 006 10zm4.5 7.25a.75.75 0 01.75-.75h12a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-12a.75.75 0 01-.75-.75v-6zM12 18v4.5h10.5V18H12zM14.5.727A.75.75 0 0115.25 0h5a.75.75 0 01.75.727l.5 15.773h-7.484L14.5.727zm1.478.773l-.455 15h4.454l-.455-15h-3.544z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 20.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.5 0a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm-2.075-17h3.65l.137 4.5h-3.924l.137-4.5zm-.046 1.5l-.045 1.5h3.832l-.045-1.5H15.88z",
        fillRule: "evenodd"
    })));
});
$7e88bf08caf76539$export$8d33be737d1dc763.displayName = 'FactoryBuilding';





var $denZA = parcelRequire("denZA");
var $a2b53a92b9550dce$var$__assign = undefined && undefined.__assign || function() {
    $a2b53a92b9550dce$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2b53a92b9550dce$var$__assign.apply(this, arguments);
};
var $a2b53a92b9550dce$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a2b53a92b9550dce$export$90f133a5fd68c67c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a2b53a92b9550dce$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a2b53a92b9550dce$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.437 3.679l-.082-2.637c0-.276-.108-.541-.3-.737a1.011 1.011 0 00-.72-.305H17.21c-.271 0-.531.11-.723.305-.191.196-.299.46-.299.737l-.102 2.637h5.352zm.337 11.463l-.286-9.9h-5.423l-.286 9.9h5.995zm-8.497 1.563h10.212c.136 0 .266.055.361.153.096.098.15.23.15.368v6.253c0 .138-.054.27-.15.368a.505.505 0 01-.36.153H13.204c.045-.17.069-.345.072-.521v-6.774zm2.297 4.43h1.532a.759.759 0 00.542-.23.79.79 0 000-1.105.758.758 0 00-.542-.229h-1.532a.758.758 0 00-.541.229.79.79 0 000 1.105.759.759 0 00.541.23zm4.596 0h1.532a.758.758 0 00.542-.23.79.79 0 000-1.105.758.758 0 00-.542-.229H20.17a.758.758 0 00-.541.229.79.79 0 000 1.105.759.759 0 00.541.23zm-8.936-6.514H.511a.506.506 0 00-.361.152.527.527 0 00-.15.369v8.337c0 .138.054.27.15.368A.506.506 0 00.51 24h3.412a.506.506 0 00.36-.153.527.527 0 00.15-.368v-5.43h2.87v5.43c0 .138.054.27.15.368a.506.506 0 00.36.153h3.422a.506.506 0 00.361-.153.527.527 0 00.15-.368v-8.337a.527.527 0 00-.15-.368.506.506 0 00-.36-.153zm.306-1.563H.194a.545.545 0 01-.112-.417 6.037 6.037 0 011.961-3.665 5.815 5.815 0 013.83-1.473 5.835 5.835 0 013.824 1.478 6.058 6.058 0 011.966 3.66.561.561 0 01-.123.417z",
        fillRule: "evenodd"
    })));
});
$a2b53a92b9550dce$export$90f133a5fd68c67c.displayName = 'FactoryBuildingBold';





var $denZA = parcelRequire("denZA");
var $5c3fcea48d8275ee$var$__assign = undefined && undefined.__assign || function() {
    $5c3fcea48d8275ee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c3fcea48d8275ee$var$__assign.apply(this, arguments);
};
var $5c3fcea48d8275ee$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5c3fcea48d8275ee$export$7562e752e5ef1fad = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5c3fcea48d8275ee$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5c3fcea48d8275ee$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M11.325 11.46h1.227c-.037-.166-.091-.367-.091-.587 0-.659.494-1.117 1.3-1.85 1.025-.915 1.739-1.738 1.739-2.965C15.5 4.263 14.053 3 12.277 3c-1.61 0-2.8.934-3.277 2.563l1.19.495c.366-1.172 1.117-1.758 2.05-1.758.99 0 1.795.75 1.795 1.85 0 .896-.512 1.39-1.428 2.251-.787.696-1.465 1.337-1.465 2.252 0 .293.074.586.183.806zm.696 4.027c.641 0 1.172-.476 1.172-1.153 0-.678-.531-1.154-1.172-1.154-.604 0-1.153.476-1.153 1.154 0 .677.549 1.153 1.153 1.153z"
    })));
});
$5c3fcea48d8275ee$export$7562e752e5ef1fad.displayName = 'Faq';





var $denZA = parcelRequire("denZA");
var $8b893a8afef5ebec$var$__assign = undefined && undefined.__assign || function() {
    $8b893a8afef5ebec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8b893a8afef5ebec$var$__assign.apply(this, arguments);
};
var $8b893a8afef5ebec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8b893a8afef5ebec$export$b995d600f3ba41d6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8b893a8afef5ebec$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8b893a8afef5ebec$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25zm10.759 11.094h-1.88a1.996 1.996 0 01-.182-.792c0-.66.495-1.22 1.303-1.864.676-.561.973-.858.973-1.386 0-.594-.462-1.006-1.039-1.006-.61 0-1.056.429-1.37 1.253L9 6.508C9.478 4.825 10.7 4 12.25 4c1.798 0 3.25 1.138 3.25 2.887 0 .973-.462 1.617-1.37 2.409l-.176.153c-.57.495-.978.849-.978 1.299 0 .131.016.247.033.346zm.66 2.656c0 .874-.66 1.534-1.535 1.534-.89 0-1.55-.66-1.55-1.534 0-.858.66-1.534 1.55-1.534a1.51 1.51 0 011.535 1.534z",
        fillRule: "evenodd"
    })));
});
$8b893a8afef5ebec$export$b995d600f3ba41d6.displayName = 'FaqBold';





var $denZA = parcelRequire("denZA");
var $96f107f85a8bef47$var$__assign = undefined && undefined.__assign || function() {
    $96f107f85a8bef47$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96f107f85a8bef47$var$__assign.apply(this, arguments);
};
var $96f107f85a8bef47$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $96f107f85a8bef47$export$f07d42f183ae8811 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $96f107f85a8bef47$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $96f107f85a8bef47$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2.25 2.25A.75.75 0 001.5 3v13.5a.75.75 0 00.75.75h5.253a.75.75 0 010 1.5H2.25A2.25 2.25 0 010 16.5V3A2.25 2.25 0 012.25.75h19.5A2.25 2.25 0 0124 3v12a.75.75 0 01-1.5 0V3a.75.75 0 00-.75-.75H19.5v8.25a.75.75 0 01-1.5 0V2.25H2.25z"
    }), $denZA.createElement("path", {
        d: "M5.25 5.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm9.223 6.97a.75.75 0 011.28.53v3c0 .367.265.68.627.74l1.993.332a2.25 2.25 0 011.88 2.22V22.5a.75.75 0 001.5 0v-3.46a3.75 3.75 0 00-3.134-3.698l-1.366-.227V12.75a2.25 2.25 0 10-4.5 0v4.039l-.094-.047a2.387 2.387 0 00-3.384 1.556v.002a2.387 2.387 0 00.831 2.442l.002.001 2.926 2.343a.75.75 0 00.938-1.172l-2.93-2.344-.002-.001a.886.886 0 01.948-1.485l1.18.587A.75.75 0 0014.254 18v-5.25a.75.75 0 01.22-.53zM4.5 9a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 014.5 9zm.75 2.25a.75.75 0 000 1.5H9a.75.75 0 000-1.5H5.25z"
    })));
});
$96f107f85a8bef47$export$f07d42f183ae8811.displayName = 'FeedScroll';





var $denZA = parcelRequire("denZA");
var $ef2d514dafcb3e2c$var$__assign = undefined && undefined.__assign || function() {
    $ef2d514dafcb3e2c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef2d514dafcb3e2c$var$__assign.apply(this, arguments);
};
var $ef2d514dafcb3e2c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ef2d514dafcb3e2c$export$51369d9fa2a33304 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ef2d514dafcb3e2c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ef2d514dafcb3e2c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M5.92 16.822a.253.253 0 00-.041-.22.248.248 0 00-.2-.1H5.5a1 1 0 01-1-1V3.5a1 1 0 011-1h14a1 1 0 011 1v10.68c0 .117.08.218.194.244 1.084.25 2.08.787 2.884 1.555A.25.25 0 0024 15.8V2.5A2.5 2.5 0 0021.5 0h-19A2.5 2.5 0 000 2.5v14.003a2.5 2.5 0 002.5 2.501h3.152a.251.251 0 00.242-.312 3.602 3.602 0 01.026-1.87z"
    }), $denZA.createElement("path", {
        d: "M23 24a.75.75 0 00.75-.75v-3A4.757 4.757 0 0019 15.497h-2a.25.25 0 01-.25-.25v-5.5a2.25 2.25 0 10-4.5 0v7.061a.25.25 0 01-.442.16l-.578-.7a2.25 2.25 0 00-3.46 2.878l3.806 4.58c.143.172.354.27.577.271L23 24z"
    })));
});
$ef2d514dafcb3e2c$export$51369d9fa2a33304.displayName = 'FeedScrollBold';





var $denZA = parcelRequire("denZA");
var $76355485a48d6872$var$__assign = undefined && undefined.__assign || function() {
    $76355485a48d6872$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76355485a48d6872$var$__assign.apply(this, arguments);
};
var $76355485a48d6872$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $76355485a48d6872$export$a83d48be731b444e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $76355485a48d6872$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $76355485a48d6872$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-ai_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24H14.8a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M19.24 14.914a2.21 2.21 0 00-2.2 2.2v6.06a.74.74 0 001.48 0v-3h1.45v3a.74.74 0 101.47 0v-6.03a2.21 2.21 0 00-2.2-2.23zm-.72 3.77v-1.54a.72.72 0 01.72-.72.73.73 0 01.73.72v1.57l-1.45-.03zm4.65 5.23a.78.78 0 01-.83-.72v-7.5a.84.84 0 011.66 0v7.5a.78.78 0 01-.83.72z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-ai_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$76355485a48d6872$export$a83d48be731b444e.displayName = 'FilesAi';





var $denZA = parcelRequire("denZA");
var $3d544dbe427a866e$var$__assign = undefined && undefined.__assign || function() {
    $3d544dbe427a866e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d544dbe427a866e$var$__assign.apply(this, arguments);
};
var $3d544dbe427a866e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3d544dbe427a866e$export$60f3d34ae19d5faa = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $3d544dbe427a866e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $3d544dbe427a866e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-ai-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M10.92 11.24a.61.61 0 00-.61.61v1.31h1.21v-1.31a.61.61 0 00-.6-.61z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zm-9 11.22a.62.62 0 01-1.24 0V14.4h-1.16v2.53a.62.62 0 11-1.24 0v-5.08a1.85 1.85 0 013.69 0l-.05 5.08zm2.17 0a.7.7 0 01-1.39 0v-6.3a.7.7 0 011.39 0v6.3z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-ai-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$3d544dbe427a866e$export$60f3d34ae19d5faa.displayName = 'FilesAiBold';





var $denZA = parcelRequire("denZA");
var $90739aadad2d1565$var$__assign = undefined && undefined.__assign || function() {
    $90739aadad2d1565$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90739aadad2d1565$var$__assign.apply(this, arguments);
};
var $90739aadad2d1565$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $90739aadad2d1565$export$2f3ad13cc6e1f36d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $90739aadad2d1565$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $90739aadad2d1565$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.85 6.59L15.97.71A2.25 2.25 0 0014.38 0H3.75A2.25 2.25 0 001.5 2.3v19.4A2.25 2.25 0 003.75 24h16.5a2.25 2.25 0 002.25-2.25V8.18a2.25 2.25 0 00-.65-1.59zM15 1.86l5.69 5.69h-4.94A.75.75 0 0115 6.8V1.86zm6 19.84a.75.75 0 01-.75.75H3.75A.75.75 0 013 21.7V2.3a.75.75 0 01.75-.75h9.75v5.26a2.25 2.25 0 002.25 2.25H21V21.7z"
    }), $denZA.createElement("path", {
        d: "M6.87 8.6a.64.64 0 01.64.64v5.58l1.8-1.68a2.33 2.33 0 013.13 0l.62.58a1 1 0 00.82.26 1 1 0 00.71-.43l1.34-2.09a.64.64 0 011.08.69l-1.34 2.1a2.261 2.261 0 01-1.64 1 2.32 2.32 0 01-1.83-.59l-.62-.58a1 1 0 00-1.4 0l-2.67 2.49v1.65h9.62a.64.64 0 110 1.28H6.87a.64.64 0 01-.64-.64V9.24a.64.64 0 01.64-.64z"
    })));
});
$90739aadad2d1565$export$2f3ad13cc6e1f36d.displayName = 'FilesAnalytics';





var $denZA = parcelRequire("denZA");
var $1dfb88eff46eeaa7$var$__assign = undefined && undefined.__assign || function() {
    $1dfb88eff46eeaa7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1dfb88eff46eeaa7$var$__assign.apply(this, arguments);
};
var $1dfb88eff46eeaa7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1dfb88eff46eeaa7$export$6350073ec8620ce7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1dfb88eff46eeaa7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1dfb88eff46eeaa7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-analytics-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M15.59 0a1 1 0 01.71.29l5.41 5.41a1 1 0 01.29.71V22a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h11.59zm3.91 22a.5.5 0 00.5-.5V7a.5.5 0 00-.15-.35l-4.53-4.5A.5.5 0 0015 2H4.5a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15z"
    }), $denZA.createElement("path", {
        d: "M20.06 5.68l-3.54-3.8-13.17-.46v21.23h17l-.29-16.97zM6.53 13.25L9.8 10a1 1 0 011.2-.17l1.66 1a.25.25 0 00.3 0l2.5-2.5a1 1 0 011.44 1.38l-3.2 3.19a1 1 0 01-1.22.15l-1.66-1a.25.25 0 00-.3 0l-2.58 2.61a1 1 0 01-1.41-1.41zm10.22 5.19H7a1 1 0 010-2h9.75a1 1 0 010 2z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-analytics-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$1dfb88eff46eeaa7$export$6350073ec8620ce7.displayName = 'FilesAnalyticsBold';





var $denZA = parcelRequire("denZA");
var $9f66825f284c8d17$var$__assign = undefined && undefined.__assign || function() {
    $9f66825f284c8d17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f66825f284c8d17$var$__assign.apply(this, arguments);
};
var $9f66825f284c8d17$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9f66825f284c8d17$export$2da06534dde49690 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9f66825f284c8d17$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9f66825f284c8d17$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.34 6.59L15.5.71A2.25 2.25 0 0013.88 0H3.25A2.25 2.25 0 001 2.3v19.4A2.25 2.25 0 003.25 24h16.5A2.25 2.25 0 0022 21.7V8.18a2.25 2.25 0 00-.66-1.59zM14.5 1.86l5.69 5.69h-4.94a.75.75 0 01-.75-.74V1.86zm6 19.84a.75.75 0 01-.75.75H3.25a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75H13v5.26a2.25 2.25 0 002.25 2.25h5.25V21.7z"
    }), $denZA.createElement("path", {
        d: "M13.5 10.32a.68.68 0 000 1l2.91 2.91-2.91 2.87a.68.68 0 000 1 .67.67 0 001 0l3.39-3.39a.681.681 0 000-1l-3.39-3.39a.68.68 0 00-1 0zm-3.12 0a.68.68 0 00-1 0l-3.35 3.39a.68.68 0 000 1l3.39 3.39a.67.67 0 001 0 .681.681 0 000-1L7.5 14.19l2.91-2.91a.68.68 0 00-.03-.96z"
    })));
});
$9f66825f284c8d17$export$2da06534dde49690.displayName = 'FilesCode';





var $denZA = parcelRequire("denZA");
var $4b49d85985aa87c9$var$__assign = undefined && undefined.__assign || function() {
    $4b49d85985aa87c9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4b49d85985aa87c9$var$__assign.apply(this, arguments);
};
var $4b49d85985aa87c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4b49d85985aa87c9$export$5c10fef69833723 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4b49d85985aa87c9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4b49d85985aa87c9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M16.297.29L21.71 5.7a1 1 0 01.29.71V22a2 2 0 01-2.001 2H4.001A2.001 2.001 0 012 22V2a2 2 0 012.001-2h11.596a1 1 0 01.7.29zM19.51 22a.5.5 0 00.5-.5V7a.5.5 0 00-.15-.35l-4.532-4.5a.5.5 0 00-.32-.15H4.5a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15.01z"
    }), $denZA.createElement("path", {
        d: "M15.577 1.43H2.9v21.41h18.28V7.26l-5.603-5.83zM8.573 13.31L11.065 16a1 1 0 010 1.39 1 1 0 01-1.411 0l-3.382-3.56a1 1 0 010-1.36l3.332-3.58a1 1 0 111.46 1.36L8.535 13a.25.25 0 000 .32l.04-.01zm9.215.51l-3.382 3.58a1.013 1.013 0 01-1.46-1.4l2.54-2.72a.25.25 0 000-.34l-2.54-2.72a.999.999 0 01.749-1.774 1.001 1.001 0 01.711.444l3.332 3.57a1 1 0 010 1.37l.05-.01z"
    })));
});
$4b49d85985aa87c9$export$5c10fef69833723.displayName = 'FilesCodeBold';





var $denZA = parcelRequire("denZA");
var $f94c0e91b59f39f2$var$__assign = undefined && undefined.__assign || function() {
    $f94c0e91b59f39f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f94c0e91b59f39f2$var$__assign.apply(this, arguments);
};
var $f94c0e91b59f39f2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f94c0e91b59f39f2$export$e3f95c4e98f5bc36 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f94c0e91b59f39f2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f94c0e91b59f39f2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.75 9.81a10 10 0 00-3.38.53 3.62 3.62 0 00-1.16.66 1.45 1.45 0 00-.53 1.06v4.5a1.45 1.45 0 00.54 1.08c.339.28.725.497 1.14.64a10 10 0 003.38.53 9.983 9.983 0 003.38-.53c.415-.143.802-.36 1.14-.64a1.45 1.45 0 00.54-1.08v-4.5a1.451 1.451 0 00-.51-1.06 3.62 3.62 0 00-1.16-.66 10 10 0 00-3.38-.53zm3.94 6.75s0 .1-.16.24a2.582 2.582 0 01-.79.43 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.181.095.368.179.56.25a10 10 0 003.38.53 10 10 0 003.4-.56 4.8 4.8 0 00.56-.25v.81zm0-2.25s0 .1-.16.24a2.58 2.58 0 01-.78.45 8.86 8.86 0 01-3 .46 8.86 8.86 0 01-3-.46 2.58 2.58 0 01-.79-.43c-.16-.14-.16-.22-.16-.24v-.78c.181.095.368.179.56.25a10 10 0 003.38.53 9.983 9.983 0 003.38-.53 4.76 4.76 0 00.56-.25l.01.76zm0-2.25s0 .09-.16.23a2.53 2.53 0 01-.8.44 8.909 8.909 0 01-3 .46 8.909 8.909 0 01-3-.46 2.528 2.528 0 01-.8-.44c-.15-.14-.16-.22-.16-.23 0-.01 0-.09.16-.23a2.53 2.53 0 01.82-.43 8.909 8.909 0 013-.46 8.909 8.909 0 013 .46c.291.097.562.246.8.44.14.16.14.21.14.22z"
    }), $denZA.createElement("path", {
        d: "M21.85 6.59L15.97.71A2.25 2.25 0 0014.38 0H3.75A2.25 2.25 0 001.5 2.3v19.4A2.25 2.25 0 003.75 24h16.5a2.25 2.25 0 002.25-2.25V8.18a2.25 2.25 0 00-.65-1.59zM15 1.86l5.69 5.69h-4.94A.75.75 0 0115 6.8V1.86zm6 19.84a.75.75 0 01-.75.75H3.75A.75.75 0 013 21.7V2.3a.75.75 0 01.75-.75h9.75v5.26a2.25 2.25 0 002.25 2.25H21V21.7z"
    })));
});
$f94c0e91b59f39f2$export$e3f95c4e98f5bc36.displayName = 'FilesDatabase';





var $denZA = parcelRequire("denZA");
var $d095f621189040e4$var$__assign = undefined && undefined.__assign || function() {
    $d095f621189040e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d095f621189040e4$var$__assign.apply(this, arguments);
};
var $d095f621189040e4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d095f621189040e4$export$f36b0dd859f5eae3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d095f621189040e4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d095f621189040e4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M17.086.587l4.328 4.328A2 2 0 0122 6.329V22a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h11.672a2 2 0 011.414.587zm-5.6 19.664c3.264 0 5.264-1.144 5.264-1.767v-1.46a.244.244 0 00-.358-.218 11.7 11.7 0 01-4.906.978 11.743 11.743 0 01-4.865-.938.244.244 0 00-.356.219v1.46c0 .586 1.842 1.726 5.221 1.726zm5.264-5.734c0 .623-2 1.767-5.264 1.767-3.379 0-5.221-1.141-5.221-1.727v-1.573a.243.243 0 01.356-.219c1.537.655 3.195.975 4.865.938a11.7 11.7 0 004.906-.978.244.244 0 01.358.219v1.573zM6.265 10.473c0 .586 1.842 1.727 5.221 1.727 3.266 0 5.264-1.14 5.264-1.766 0-.572-1.857-1.686-5.264-1.686-3.379 0-5.221 1.139-5.221 1.725z",
        fillRule: "evenodd"
    })));
});
$d095f621189040e4$export$f36b0dd859f5eae3.displayName = 'FilesDatabaseBold';





var $denZA = parcelRequire("denZA");
var $75aa904dc7cd0aa0$var$__assign = undefined && undefined.__assign || function() {
    $75aa904dc7cd0aa0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75aa904dc7cd0aa0$var$__assign.apply(this, arguments);
};
var $75aa904dc7cd0aa0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $75aa904dc7cd0aa0$export$dcec651c70bd68d8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $75aa904dc7cd0aa0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $75aa904dc7cd0aa0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.869 6.59L15.99.71A2.254 2.254 0 0014.399 0H3.723a2.256 2.256 0 00-2.07 1.43 2.25 2.25 0 00-.153.87v19.4a2.247 2.247 0 001.358 2.115c.273.118.567.181.865.185h16.523a2.255 2.255 0 002.253-2.25V8.18a2.248 2.248 0 00-.631-1.59zm-6.85-4.73l5.728 5.7H15.74a.752.752 0 01-.75-.75l.03-4.95zm6.009 19.84a.75.75 0 01-.751.75H3.724a.751.751 0 01-.751-.75V2.3a.75.75 0 01.75-.75h9.764v5.26a2.248 2.248 0 002.253 2.25h5.258l.03 12.64z"
    })));
});
$75aa904dc7cd0aa0$export$dcec651c70bd68d8.displayName = 'FilesDocument';





var $denZA = parcelRequire("denZA");
var $4c533c92437272b7$var$__assign = undefined && undefined.__assign || function() {
    $4c533c92437272b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4c533c92437272b7$var$__assign.apply(this, arguments);
};
var $4c533c92437272b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4c533c92437272b7$export$51d7f6074eec6912 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4c533c92437272b7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4c533c92437272b7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.71 5.7L16.297.29a1 1 0 00-.7-.29H4a2.002 2.002 0 00-2 2v20a2 2 0 002.001 2h15.998A2.001 2.001 0 0022 22V6.41a1 1 0 00-.29-.71zm-.7 1.86h-5.783a.75.75 0 01-.75-.75V1h-2.002v5.81c0 .597.338 1.568.76 1.99.423.422 1.395.76 1.992.76h5.782v-2z",
        fillRule: "evenodd"
    })));
});
$4c533c92437272b7$export$51d7f6074eec6912.displayName = 'FilesDocumentBold';





var $denZA = parcelRequire("denZA");
var $1bbcff1fbbedcda1$var$__assign = undefined && undefined.__assign || function() {
    $1bbcff1fbbedcda1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1bbcff1fbbedcda1$var$__assign.apply(this, arguments);
};
var $1bbcff1fbbedcda1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1bbcff1fbbedcda1$export$c3c7053906a07fe7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1bbcff1fbbedcda1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1bbcff1fbbedcda1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-eps_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h3.007a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.75 20.342a.75.75 0 000-1.499h-2.21v-2.069h2.21a.75.75 0 100-1.499h-3a.75.75 0 00-.75.75v7.146a.76.76 0 00.75.749h3a.75.75 0 100-1.499h-2.21v-2.079h2.21z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.51 15.195a.74.74 0 00-.74.74v7.325a.74.74 0 001.47 0v-2.198a2.942 2.942 0 003.111-2.933 2.936 2.936 0 00-3.111-2.934h-.73zm.73 1.47v2.928a1.46 1.46 0 001-.43 1.458 1.458 0 000-2.069 1.46 1.46 0 00-1-.43z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21 17.404c0 .69.42 1 1.18 1.61A3.38 3.38 0 0124 21.8a2.208 2.208 0 01-2.2 2.2h-1.5a.74.74 0 110-1.48h1.48a.74.74 0 00.74-.739c0-.68-.42-.999-1.18-1.609a3.368 3.368 0 01-1.76-2.788 2.208 2.208 0 012.2-2.199h1.48a.74.74 0 110 1.48h-1.48a.742.742 0 00-.78.74z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-eps_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$1bbcff1fbbedcda1$export$c3c7053906a07fe7.displayName = 'FilesEps';





var $denZA = parcelRequire("denZA");
var $e2ba0e4795a419d7$var$__assign = undefined && undefined.__assign || function() {
    $e2ba0e4795a419d7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2ba0e4795a419d7$var$__assign.apply(this, arguments);
};
var $e2ba0e4795a419d7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e2ba0e4795a419d7$export$b0b691beef3e0045 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e2ba0e4795a419d7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e2ba0e4795a419d7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-eps-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M11.77 11.37v2.5a1.25 1.25 0 000-2.5z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM8.79 13.23a.64.64 0 110 1.28H6.91v1.76h1.88a.64.64 0 110 1.28H6.27a.64.64 0 01-.64-.64v-6.09a.64.64 0 01.64-.64h2.52a.641.641 0 010 1.28H6.91v1.77h1.88zm4.75 1.15a2.52 2.52 0 01-1.77.74V17a.63.63 0 01-1.25 0v-6.25a.63.63 0 01.63-.63h.63a2.55 2.55 0 011.77.73c.468.47.73 1.107.73 1.77a2.47 2.47 0 01-.74 1.76zm3.31-1a2.86 2.86 0 011.47 2.35 1.88 1.88 0 01-1.87 1.88h-1.23a.64.64 0 01-.63-.63.63.63 0 01.63-.63h1.26a.64.64 0 00.63-.63c0-.59-.36-.89-1-1.38A2.879 2.879 0 0114.6 12a1.88 1.88 0 011.88-1.88h1.26a.63.63 0 010 1.26h-1.26a.64.64 0 00-.63.63c0 .58.36.88 1 1.36v.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-eps-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$e2ba0e4795a419d7$export$b0b691beef3e0045.displayName = 'FilesEpsBold';





var $denZA = parcelRequire("denZA");
var $fb68443d74b7b15a$var$__assign = undefined && undefined.__assign || function() {
    $fb68443d74b7b15a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb68443d74b7b15a$var$__assign.apply(this, arguments);
};
var $fb68443d74b7b15a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fb68443d74b7b15a$export$46b339aec3f7a591 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fb68443d74b7b15a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fb68443d74b7b15a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-gif_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h4a.75.75 0 000-1.5h-4a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M19.88 15.037h3.37a.749.749 0 01.75.751.753.753 0 01-.75.752h-2.63v2.957h1.78a.749.749 0 01.75.752.753.753 0 01-.75.752h-1.78v2.245a.753.753 0 01-.74.752.76.76 0 01-.76-.752v-7.458a.763.763 0 01.76-.751zm-3.01 8.961a.779.779 0 01-.83-.722v-7.518a.842.842 0 01.83-.712.839.839 0 01.83.712v7.518a.782.782 0 01-.83.722zm-4.44-.08a2.996 2.996 0 01-1.92-.621 4.18 4.18 0 01-1.27-3.509 4.812 4.812 0 011.55-4.01 3.806 3.806 0 013.05-.631.74.74 0 01.55.912.752.752 0 01-.9.551 2.304 2.304 0 00-1.79.361 3.44 3.44 0 00-1 2.797 3.015 3.015 0 00.7 2.316 2.095 2.095 0 001.72.2l-.05-1.744-.81.05a.749.749 0 01-.75-.752.753.753 0 01.75-.752h.86a1.448 1.448 0 011.45 1.454v1.794a1.457 1.457 0 01-1.1 1.414c-.34.096-.688.153-1.04.17z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-gif_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$fb68443d74b7b15a$export$46b339aec3f7a591.displayName = 'FilesGif';





var $denZA = parcelRequire("denZA");
var $d21f6681523bf26d$var$__assign = undefined && undefined.__assign || function() {
    $d21f6681523bf26d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d21f6681523bf26d$var$__assign.apply(this, arguments);
};
var $d21f6681523bf26d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d21f6681523bf26d$export$83390ff0c4275512 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d21f6681523bf26d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d21f6681523bf26d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM10.14 16.78a1.33 1.33 0 01-1 1.3 3.93 3.93 0 01-1 .13 2.82 2.82 0 01-1.77-.57 3.87 3.87 0 01-1.2-3.24 4.46 4.46 0 011.43-3.67 3.54 3.54 0 012.83-.58.69.69 0 01-.05 1.353.681.681 0 01-.27-.013 2.192 2.192 0 00-1.66.34 3.19 3.19 0 00-.89 2.58 2.8 2.8 0 00.65 2.14 1.909 1.909 0 001.59.18l-.05-1.61-.75.05a.7.7 0 010-1.39h.8a1.34 1.34 0 011.34 1.34v1.66zm2.86.83a.78.78 0 01-1.54 0v-6.95a.78.78 0 011.54 0v6.95zm5.14-6.22h-2.43v2.73h1.64a.69.69 0 010 1.38h-1.64v2.08a.7.7 0 01-1.39 0V10.7A.69.69 0 0115 10h3.13a.7.7 0 010 1.39h.01z"
    })));
});
$d21f6681523bf26d$export$83390ff0c4275512.displayName = 'FilesGifBold';





var $denZA = parcelRequire("denZA");
var $d993cb6f46d7a180$var$__assign = undefined && undefined.__assign || function() {
    $d993cb6f46d7a180$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d993cb6f46d7a180$var$__assign.apply(this, arguments);
};
var $d993cb6f46d7a180$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d993cb6f46d7a180$export$27cefa72e4e09a5b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d993cb6f46d7a180$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d993cb6f46d7a180$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.81 6.59L15.97.71a2.331 2.331 0 00-.72-.52 2.34 2.34 0 00-.87-.19H3.75c-.3 0-.595.061-.87.18a2.06 2.06 0 00-.74.5 2.15 2.15 0 00-.48.74 2.41 2.41 0 00-.16.88v19.4c-.002.3.052.6.16.88.107.277.27.53.48.74.207.219.46.39.74.5.275.119.57.18.87.18h16.5a2.25 2.25 0 002.25-2.25V8.18a2.243 2.243 0 00-.69-1.59zM15 1.86l5.69 5.69h-4.94A.75.75 0 0115 6.8V1.86zm6 19.84a.75.75 0 01-.75.75H3.75A.75.75 0 013 21.7V2.3a.75.75 0 01.75-.75h9.75v5.26a2.25 2.25 0 002.25 2.25H21V21.7z"
    }), $denZA.createElement("path", {
        d: "M9.12 13.54a2.52 2.52 0 01-1.78-.74A2.48 2.48 0 016.6 11a2.54 2.54 0 01.74-1.78 2.59 2.59 0 013.56 0 2.54 2.54 0 01.74 1.78 2.5 2.5 0 01-.74 1.78 2.54 2.54 0 01-1.78.76zm0-3.54a1 1 0 00-.923 1.39 1 1 0 00.223.33 1.05 1.05 0 001.44 0A1 1 0 009.12 10zm8.28 10.18a.73.73 0 01-.62-.33l-3.09-4.63-2.19 3a.71.71 0 01-.51.31.72.72 0 01-.57-.15l-1.31-1-1.73 2.5A.764.764 0 116.13 19l1.68-2.48a1.6 1.6 0 01.46-.44 1.56 1.56 0 01.6-.23 1.51 1.51 0 01.63 0c.208.056.402.155.57.29l.68.55 1.66-2.37a1.54 1.54 0 012.55.03L18.02 19a.75.75 0 01-.2 1 .81.81 0 01-.42.18z"
    })));
});
$d993cb6f46d7a180$export$27cefa72e4e09a5b.displayName = 'FilesImage';





var $denZA = parcelRequire("denZA");
var $8650c068c4c5f588$var$__assign = undefined && undefined.__assign || function() {
    $8650c068c4c5f588$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8650c068c4c5f588$var$__assign.apply(this, arguments);
};
var $8650c068c4c5f588$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8650c068c4c5f588$export$4a31f87bb830a4d1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8650c068c4c5f588$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8650c068c4c5f588$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.74 10.18a1 1 0 000-1.44 1 1 0 00-.74-.3 1 1 0 00-.72 1.74 1.06 1.06 0 001.46 0z"
    }), $denZA.createElement("path", {
        d: "M21.92 6.05a.998.998 0 00-.21-.32L16.29.32A.94.94 0 0015.6 0H4a2 2 0 00-1.41.61A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.44a.87.87 0 00-.08-.39zM7 7.45a3 3 0 014 0 2.85 2.85 0 010 4 2.84 2.84 0 01-4.84-2 2.86 2.86 0 01.84-2zm11.56 11.94a.9.9 0 01-1.26-.25l-3.37-5.05-2.24 3.3a1 1 0 01-.62.38.869.869 0 01-.69-.19L9 16.43l-1.81 2.71a.91.91 0 01-.75.41.85.85 0 01-.5-.16.91.91 0 01-.26-1.26l1.81-2.72A2 2 0 018 14.9a1.81 1.81 0 01.68-.26 2 2 0 01.73 0 1.9 1.9 0 01.65.33l.68.54 1.75-2.5a1.779 1.779 0 011.51-.72c.287.008.568.083.82.22.257.136.474.335.63.58l3.37 5a.899.899 0 01-.26 1.3z"
    })));
});
$8650c068c4c5f588$export$4a31f87bb830a4d1.displayName = 'FilesImageBold';





var $denZA = parcelRequire("denZA");
var $154db5fcdc877c85$var$__assign = undefined && undefined.__assign || function() {
    $154db5fcdc877c85$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $154db5fcdc877c85$var$__assign.apply(this, arguments);
};
var $154db5fcdc877c85$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $154db5fcdc877c85$export$71eab5da9b11e520 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $154db5fcdc877c85$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $154db5fcdc877c85$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-indd_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h-.005a.75.75 0 000-1.5h.005a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.16 15.012a.75.75 0 00-.75.749v7.451a.725.725 0 00.21.519.798.798 0 00.54.22 3.75 3.75 0 002.648-1.087 3.73 3.73 0 001.102-2.635v-1.486a3.746 3.746 0 00-1.105-2.635 3.765 3.765 0 00-2.645-1.096zm.75 7.322v-5.706a2.25 2.25 0 011.5 2.115v1.486a2.24 2.24 0 01-1.5 2.105z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M6.3 23.94a.782.782 0 01-.83-.718V15.74a.778.778 0 01.83-.709.782.782 0 01.83.709v7.48a.778.778 0 01-.83.72zm6.51 0a.761.761 0 01-.66-.379l-2.67-4.808v4.42a.747.747 0 01-.75.747.75.75 0 01-.75-.748V15.88a.747.747 0 01.563-.71.752.752 0 01.837.351l2.68 4.778V15.88a.747.747 0 01.75-.748.75.75 0 01.75.748v7.292a.747.747 0 01-.56.768.572.572 0 01-.19 0z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.25 15.052a.761.761 0 00-.75.748v7.452a.747.747 0 00.75.748 3.765 3.765 0 002.645-1.095A3.746 3.746 0 0024 20.269v-1.486a3.746 3.746 0 00-1.105-2.636 3.765 3.765 0 00-2.645-1.095zm.75 7.322v-5.696c.313.112.6.29.84.519.422.42.66.991.66 1.586v1.486c0 .595-.238 1.166-.66 1.586-.24.23-.527.407-.84.52z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-indd_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$154db5fcdc877c85$export$71eab5da9b11e520.displayName = 'FilesIndd';





var $denZA = parcelRequire("denZA");
var $b72e5a0bf31ff2f4$var$__assign = undefined && undefined.__assign || function() {
    $b72e5a0bf31ff2f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b72e5a0bf31ff2f4$var$__assign.apply(this, arguments);
};
var $b72e5a0bf31ff2f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b72e5a0bf31ff2f4$export$4baabbc45b2cb03a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b72e5a0bf31ff2f4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b72e5a0bf31ff2f4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-indd-bold_svg__a)",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }, $denZA.createElement("path", {
        d: "M17.25 11.52v4.79a1.89 1.89 0 001.26-1.77v-1.25A1.87 1.87 0 0018 12a2 2 0 00-.75-.48z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM5.62 17a.64.64 0 01-.69.59.64.64 0 01-.69-.59v-6.26a.65.65 0 01.69-.6.65.65 0 01.69.6V17zM11 17a.62.62 0 01-.47.61h-.16a.65.65 0 01-.55-.32l-2.24-4V17a.63.63 0 11-1.25 0v-6.14a.62.62 0 01.47-.61.61.61 0 01.7.3l2.24 4v-3.69a.63.63 0 011.26 0V17zm4.48-2.47a3.099 3.099 0 01-.92 2.21 3.14 3.14 0 01-2.22.92.63.63 0 01-.63-.63v-6.28a.63.63 0 01.63-.62c.83 0 1.628.327 2.22.91a3.14 3.14 0 01.92 2.22v1.27zm4.27 0a3.14 3.14 0 01-.92 2.22 3.17 3.17 0 01-2.22.91.589.589 0 01-.44-.18.63.63 0 01-.19-.44v-6.25a.63.63 0 01.63-.63 3.14 3.14 0 013.14 3.13v1.24z"
    }), $denZA.createElement("path", {
        d: "M13 11.49v4.79a1.85 1.85 0 00.7-.44 1.87 1.87 0 00.56-1.33v-1.25A1.89 1.89 0 0013 11.49z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-indd-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$b72e5a0bf31ff2f4$export$4baabbc45b2cb03a.displayName = 'FilesInddBold';





var $denZA = parcelRequire("denZA");
var $f34a64748c1db63c$var$__assign = undefined && undefined.__assign || function() {
    $f34a64748c1db63c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f34a64748c1db63c$var$__assign.apply(this, arguments);
};
var $f34a64748c1db63c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f34a64748c1db63c$export$35874c0d6efacc63 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f34a64748c1db63c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f34a64748c1db63c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-jpg_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.948a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.972 15.101a.743.743 0 00-.742.731v7.34a.738.738 0 00.433.763.744.744 0 001.042-.762V20.97c.78 0 1.528-.31 2.08-.86a2.93 2.93 0 000-4.15 2.947 2.947 0 00-2.08-.859h-.733zm.733 1.472v2.935a1.477 1.477 0 001.476-1.473 1.47 1.47 0 00-1.476-1.462z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.822 23.824a3.016 3.016 0 01-1.927-.621 4.195 4.195 0 01-1.265-3.505 4.757 4.757 0 011.556-4.006 3.828 3.828 0 013.061-.63.753.753 0 01.557.905.751.751 0 01-.908.556 2.324 2.324 0 00-1.817.38 3.434 3.434 0 00-1.004 2.795 2.996 2.996 0 00.703 2.313 2.092 2.092 0 001.716.2V20.47l-.813.05a.754.754 0 01-.753-.751.75.75 0 01.753-.751h.863A1.457 1.457 0 0124 20.469v1.793a1.43 1.43 0 01-1.104 1.402c-.35.099-.71.152-1.074.16zm-12.357.09h-.803a.703.703 0 01-.503-1.204.714.714 0 01.503-.208h.803a1.166 1.166 0 001.165-1.152v-5.628a.699.699 0 01.702-.711.715.715 0 01.713.711v5.598a2.57 2.57 0 01-1.588 2.396c-.314.13-.651.198-.992.198z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-jpg_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$f34a64748c1db63c$export$35874c0d6efacc63.displayName = 'FilesJpg';





var $denZA = parcelRequire("denZA");
var $74d31fc813bdcc91$var$__assign = undefined && undefined.__assign || function() {
    $74d31fc813bdcc91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74d31fc813bdcc91$var$__assign.apply(this, arguments);
};
var $74d31fc813bdcc91$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $74d31fc813bdcc91$export$2c1ea388e4a7e5ad = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $74d31fc813bdcc91$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $74d31fc813bdcc91$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.94 11.16v2.45a1.23 1.23 0 100-2.45z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zm-13 9.41a2.14 2.14 0 01-2.14 2.15H5.9a.6.6 0 01-.59-.59.59.59 0 01.59-.59h.68a1 1 0 001-1v-4.64a.6.6 0 01.55-.62.59.59 0 01.59.59l-.01 4.7zm4-1a2.47 2.47 0 01-1.74.72v1.83a.62.62 0 01-.856.573.611.611 0 01-.374-.573v-6.12a.61.61 0 01.61-.61h.62a2.45 2.45 0 011.74 4.18zm6 1.81a1.2 1.2 0 01-.92 1.17 3.742 3.742 0 01-.91.12 2.54 2.54 0 01-1.6-.52 3.47 3.47 0 01-1.06-2.93 4 4 0 011.29-3.31 3.22 3.22 0 012.56-.52.623.623 0 01-.3 1.21 2 2 0 00-1.5.31 2.879 2.879 0 00-.8 2.33 2.551 2.551 0 00.53 1.93 1.72 1.72 0 001.43.16v-1.45h-.68a.63.63 0 010-1.25h.73a1.21 1.21 0 011.21 1.21l.02 1.54z"
    })));
});
$74d31fc813bdcc91$export$2c1ea388e4a7e5ad.displayName = 'FilesJpgBold';





var $denZA = parcelRequire("denZA");
var $c717f5899250316d$var$__assign = undefined && undefined.__assign || function() {
    $c717f5899250316d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c717f5899250316d$var$__assign.apply(this, arguments);
};
var $c717f5899250316d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c717f5899250316d$export$d7d3d9e7477ef784 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c717f5899250316d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c717f5899250316d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-mov_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h.1a.75.75 0 000-1.5h-.1a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10.809 23.955a.75.75 0 01-.75-.751v-5.008l-.931 1.362a.71.71 0 01-.61.331.75.75 0 01-.621-.32l-1.001-1.412v5.007a.751.751 0 11-1.501 0v-7.401a.761.761 0 01.53-.721.75.75 0 01.84.29l1.742 2.484 1.681-2.484a.75.75 0 011.371.431v7.44a.742.742 0 01-.75.752z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.912 23.955c-1.571 0-2.802-1.943-2.802-4.416 0-2.474 1.231-4.417 2.802-4.417 1.572 0 2.803 1.943 2.803 4.416 0 2.474-1.231 4.417-2.803 4.417zm0-7.33c-.66 0-1.39 1.251-1.39 2.913 0 1.663.73 2.915 1.39 2.915.66 0 1.381-1.242 1.381-2.915 0-1.672-.73-2.914-1.38-2.914z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M20.775 23.766a.79.79 0 00.667.01.801.801 0 00.276-.202 12.644 12.644 0 002.272-7.76.76.76 0 00-1.512 0 12.715 12.715 0 01-1.37 6.008 15.091 15.091 0 01-1.332-6.009.731.731 0 00-.76-.69.73.73 0 00-.751.69c0 .2.03 4.937 2.242 7.741a.79.79 0 00.268.212z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-mov_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$c717f5899250316d$export$d7d3d9e7477ef784.displayName = 'FilesMov';





var $denZA = parcelRequire("denZA");
var $46dbdfcc67814bfa$var$__assign = undefined && undefined.__assign || function() {
    $46dbdfcc67814bfa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $46dbdfcc67814bfa$var$__assign.apply(this, arguments);
};
var $46dbdfcc67814bfa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $46dbdfcc67814bfa$export$7f156b2f0552a52d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $46dbdfcc67814bfa$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $46dbdfcc67814bfa$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.16 11.54c-.56 0-1.2 1.08-1.2 2.53 0 1.45.64 2.53 1.2 2.53.56 0 1.2-1.08 1.2-2.53 0-1.45-.63-2.53-1.2-2.53z"
    }), $denZA.createElement("path", {
        d: "M21.69 5.71L16.27.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.31-.7zM9.26 17.25a.65.65 0 01-.65.65.66.66 0 01-.61-.65V12.9l-.8 1.19a.64.64 0 01-.54.28.659.659 0 01-.54-.28l-.84-1.22v4.38a.65.65 0 01-.65.65.66.66 0 01-.66-.65v-6.46a.65.65 0 01.46-.62.64.64 0 01.73.25l1.44 2.15 1.47-2.15a.64.64 0 01.73-.25.65.65 0 01.46.62v6.46zm2.9.65c-1.36 0-2.43-1.68-2.43-3.83 0-2.15 1.07-3.83 2.43-3.83s2.44 1.68 2.44 3.83c0 2.15-1.07 3.83-2.44 3.83zm5.9-.33a.7.7 0 01-.81.166.65.65 0 01-.23-.186c-1.92-2.44-1.94-6.54-1.94-6.71a.63.63 0 01.65-.6.64.64 0 01.66.6c.023 1.78.41 3.536 1.14 5.16a11 11 0 001.19-5.17.64.64 0 01.66-.6.63.63 0 01.65.6 11 11 0 01-1.97 6.74z"
    })));
});
$46dbdfcc67814bfa$export$7f156b2f0552a52d.displayName = 'FilesMovBold';





var $denZA = parcelRequire("denZA");
var $8824f0a4027b3cca$var$__assign = undefined && undefined.__assign || function() {
    $8824f0a4027b3cca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8824f0a4027b3cca$var$__assign.apply(this, arguments);
};
var $8824f0a4027b3cca$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8824f0a4027b3cca$export$2bc7e35987cbedfc = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8824f0a4027b3cca$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8824f0a4027b3cca$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-mp4_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h.9c.555 0 .89-.336.89-.75s-.335-.75-.89-.75h-.9a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.743 14.98a.745.745 0 00-.529.22.755.755 0 00-.219.532v7.5c0 .2.079.391.22.532a.746.746 0 001.276-.532v-2.249c.794 0 1.555-.317 2.116-.882a3.022 3.022 0 000-4.26 2.983 2.983 0 00-2.116-.882l-.748.02zm.748 1.505v3.012a1.49 1.49 0 001.383-.93 1.516 1.516 0 00-.325-1.64 1.495 1.495 0 00-1.058-.442z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.29 23.945a.735.735 0 01-.694-.463.747.747 0 01-.054-.29v-5.02l-.928 1.365a.74.74 0 01-.618.332.744.744 0 01-.618-.322l-.998-1.415v5.02c0 .2-.079.39-.22.532a.746.746 0 01-1.276-.532v-7.4a.747.747 0 01.515-.735.734.734 0 01.841.304l1.716 2.48 1.686-2.48a.739.739 0 011.219-.017c.095.13.146.287.147.448v7.46a.746.746 0 01-.718.733z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.835 23.71c.129.14.307.224.496.235a.727.727 0 00.669-.753v-7.45a.777.777 0 00-.47-.723.654.654 0 00-.767.252l-3.99 5.491a.826.826 0 00-.09.803.702.702 0 00.629.432h3.331v1.195a.736.736 0 00.192.517zm-.192-3.229h-1.895l1.895-2.56v2.56z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-mp4_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$8824f0a4027b3cca$export$2bc7e35987cbedfc.displayName = 'FilesMp4';





var $denZA = parcelRequire("denZA");
var $93dd617848273d68$var$__assign = undefined && undefined.__assign || function() {
    $93dd617848273d68$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $93dd617848273d68$var$__assign.apply(this, arguments);
};
var $93dd617848273d68$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $93dd617848273d68$export$46e01cb543bc926a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $93dd617848273d68$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $93dd617848273d68$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.16 15.2v-2.19l-1.61 2.19h1.61z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM9.87 17.51a.64.64 0 01-.64.63.63.63 0 01-.63-.63v-4.25l-.79 1.16a.64.64 0 01-.52.28.63.63 0 01-.52-.28l-.83-1.19v4.28a.63.63 0 01-.63.63.64.64 0 01-.64-.63V11.2a.63.63 0 01.846-.6.64.64 0 01.314.24l1.46 2.1 1.43-2.1a.64.64 0 011.037-.02.63.63 0 01.123.38l-.01 6.31zm3.92-2.63a2.55 2.55 0 01-1.8.74v1.9a.64.64 0 01-1.27 0v-6.34a.63.63 0 01.63-.63H12a2.53 2.53 0 011.8 4.33h-.01zm5.55 2.6a.62.62 0 01-.59.64.61.61 0 01-.59-.64v-1h-2.83a.57.57 0 01-.53-.37.67.67 0 01.07-.67l3.42-4.65a.57.57 0 01.66-.2.64.64 0 01.39.6v6.29z"
    }), $denZA.createElement("path", {
        d: "M12 11.82v2.53a1.252 1.252 0 00.9-.37 1.24 1.24 0 000-1.79 1.251 1.251 0 00-.9-.37z"
    })));
});
$93dd617848273d68$export$46e01cb543bc926a.displayName = 'FilesMp4Bold';





var $denZA = parcelRequire("denZA");
var $632290b4cb58db76$var$__assign = undefined && undefined.__assign || function() {
    $632290b4cb58db76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $632290b4cb58db76$var$__assign.apply(this, arguments);
};
var $632290b4cb58db76$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $632290b4cb58db76$export$c1715d484b9fa172 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $632290b4cb58db76$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $632290b4cb58db76$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.25 14.998a.75.75 0 00-.75.75v7.5a.75.75 0 001.5 0v-2.25h.004a3 3 0 000-6H8.25zm.75 1.5v3h.004a1.5 1.5 0 000-3H9zm5.25-1.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75 3.75 3.75 0 003.75-3.75v-1.5a3.75 3.75 0 00-3.75-3.75zm.75 7.371v-5.742a2.25 2.25 0 011.5 2.121v1.5a2.25 2.25 0 01-1.5 2.121z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.22 16.718a.75.75 0 01.53-.22h1.5a.75.75 0 000-1.5h-1.5a2.25 2.25 0 00-2.25 2.25v6a.75.75 0 001.5 0v-2.25h1.5a.75.75 0 000-1.5H21v-2.25a.75.75 0 01.22-.53z"
    })));
});
$632290b4cb58db76$export$c1715d484b9fa172.displayName = 'FilesPdf';





var $denZA = parcelRequire("denZA");
var $d7b407e371a4b50f$var$__assign = undefined && undefined.__assign || function() {
    $d7b407e371a4b50f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7b407e371a4b50f$var$__assign.apply(this, arguments);
};
var $d7b407e371a4b50f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d7b407e371a4b50f$export$d5ee1a2adab756fa = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d7b407e371a4b50f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d7b407e371a4b50f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM7.5 14.62h-.62a.25.25 0 00-.25.25V17a.63.63 0 01-1.25 0v-6a.63.63 0 01.62-.63h1.5a2.125 2.125 0 010 4.25zm3.5 3a.62.62 0 01-.62-.62v-6a.63.63 0 01.63-.63 3.625 3.625 0 010 7.25H11zm8-6h-2a.38.38 0 00-.37.38v1.12a.25.25 0 00.25.25H18a.624.624 0 110 1.25h-1.12a.25.25 0 00-.25.25V17a.63.63 0 01-1.25 0v-5A1.63 1.63 0 0117 10.37h2a.624.624 0 110 1.25z"
    }), $denZA.createElement("path", {
        d: "M7.5 11.62h-.62a.25.25 0 00-.25.25v1.25a.25.25 0 00.25.25h.62a.88.88 0 000-1.75zm4.5.2c-.1 0-.33 0-.33.16v4a.241.241 0 00.218.227.241.241 0 00.112-.017 2.37 2.37 0 000-4.35v-.02z"
    })));
});
$d7b407e371a4b50f$export$d5ee1a2adab756fa.displayName = 'FilesPdfBold';





var $denZA = parcelRequire("denZA");
var $b6cc7cb4655e9456$var$__assign = undefined && undefined.__assign || function() {
    $b6cc7cb4655e9456$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6cc7cb4655e9456$var$__assign.apply(this, arguments);
};
var $b6cc7cb4655e9456$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6cc7cb4655e9456$export$b545e0abfd160057 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b6cc7cb4655e9456$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b6cc7cb4655e9456$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-png_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h.834a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.609 15.101a.742.742 0 00-.732.741v7.33a.74.74 0 001.291.58.74.74 0 00.183-.58V20.98a2.95 2.95 0 002.085-.861 2.915 2.915 0 000-4.157 2.947 2.947 0 00-2.085-.86h-.742zm.742 1.472v2.935a1.475 1.475 0 001.595-1.468 1.471 1.471 0 00-1.595-1.467z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M21.805 23.874a3.009 3.009 0 01-1.925-.621 4.206 4.206 0 01-1.047-1.604c-.22-.608-.233-1.235-.233-1.901 0-.78.04-1.491.31-2.187a4.798 4.798 0 011.25-1.819 3.85 3.85 0 013.068-.63.753.753 0 11-.35 1.461 2.338 2.338 0 00-1.805.36 3.494 3.494 0 00-1.003 2.795 3.071 3.071 0 00.702 2.313 2.107 2.107 0 001.724.2V20.5l-.822.05a.752.752 0 110-1.502h.872A1.456 1.456 0 0124 20.499v1.873a1.431 1.431 0 01-1.113 1.402 4.123 4.123 0 01-1.082.1zm-4.762.05a.742.742 0 01-.652-.39l-2.687-4.797v4.436a.75.75 0 01-1.504 0v-7.31a.76.76 0 01.562-.732.733.733 0 01.842.36l2.687 4.808v-4.437a.75.75 0 011.283-.53.75.75 0 01.22.53v7.31a.74.74 0 01-.56.722.632.632 0 01-.191.03z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-png_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$b6cc7cb4655e9456$export$b545e0abfd160057.displayName = 'FilesPng';





var $denZA = parcelRequire("denZA");
var $948117b6d1a4ca1f$var$__assign = undefined && undefined.__assign || function() {
    $948117b6d1a4ca1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $948117b6d1a4ca1f$var$__assign.apply(this, arguments);
};
var $948117b6d1a4ca1f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $948117b6d1a4ca1f$export$1689237b5e8cd4e0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $948117b6d1a4ca1f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $948117b6d1a4ca1f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-png-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M6 11.31v2.47a1.229 1.229 0 00.87-.36 1.22 1.22 0 000-1.75 1.229 1.229 0 00-.87-.36z"
    }), $denZA.createElement("path", {
        d: "M21.68 5.71L16.26.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.32-.7zM7.77 14.29A2.46 2.46 0 016 15v1.85a.61.61 0 01-.62.61.612.612 0 01-.62-.61v-6.16a.61.61 0 01.62-.61H6a2.49 2.49 0 012.29 1.52 2.45 2.45 0 01-.54 2.69h.02zm6.15 2.57a.63.63 0 01-.48.61.41.41 0 01-.16 0 .65.65 0 01-.55-.32l-2.25-4v3.73a.63.63 0 01-1.26 0V10.7a.62.62 0 01.47-.61.64.64 0 01.71.3l2.25 4V10.7a.64.64 0 011.27 0v6.16zm5.24-.67a1.21 1.21 0 01-.93 1.18 3.673 3.673 0 01-.91.12A2.6 2.6 0 0115.7 17a3.52 3.52 0 01-1.06-3 4 4 0 011.3-3.34 3.2 3.2 0 012.58-.53.63.63 0 01.46.76.63.63 0 01-.76.46 2 2 0 00-1.51.31A2.91 2.91 0 0015.9 14a2.55 2.55 0 00.59 2 1.77 1.77 0 001.45.16V14.7h-.69a.63.63 0 010-1.26h.73a1.22 1.22 0 011.22 1.22l-.04 1.53z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-png-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$948117b6d1a4ca1f$export$1689237b5e8cd4e0.displayName = 'FilesPngBold';





var $denZA = parcelRequire("denZA");
var $52ba8c27c79134ed$var$__assign = undefined && undefined.__assign || function() {
    $52ba8c27c79134ed$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52ba8c27c79134ed$var$__assign.apply(this, arguments);
};
var $52ba8c27c79134ed$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $52ba8c27c79134ed$export$5024d576be97f66 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $52ba8c27c79134ed$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $52ba8c27c79134ed$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.499 15.748a.75.75 0 01.75-.75H9a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5zm1.5 3.75v-3H9a1.5 1.5 0 110 3h-.001zm5.25-4.5H15a3 3 0 010 6h-.001v2.25a.75.75 0 01-1.5 0v-7.5a.75.75 0 01.75-.75zm.75 1.5H15a1.5 1.5 0 110 3h-.001v-3z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M22.499 16.498h.75a.75.75 0 000-1.5h-3a.75.75 0 000 1.5h.75v6.75a.75.75 0 001.5 0v-6.75z"
    })));
});
$52ba8c27c79134ed$export$5024d576be97f66.displayName = 'FilesPpt';





var $denZA = parcelRequire("denZA");
var $44a7b96be33fcab7$var$__assign = undefined && undefined.__assign || function() {
    $44a7b96be33fcab7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44a7b96be33fcab7$var$__assign.apply(this, arguments);
};
var $44a7b96be33fcab7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $44a7b96be33fcab7$export$ad5b131dbf55d577 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $44a7b96be33fcab7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $44a7b96be33fcab7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM7 14.62h-.62a.25.25 0 00-.25.25V17a.63.63 0 01-1.25 0v-6a.62.62 0 01.63-.62H7a2.125 2.125 0 010 4.25v-.01zm5 0h-.62a.25.25 0 00-.25.25V17a.63.63 0 01-1.25 0v-6a.62.62 0 01.63-.62H12a2.125 2.125 0 010 4.25v-.01zm7.5-3h-1.13a.25.25 0 00-.25.25V17a.63.63 0 01-1.25 0v-5.13a.25.25 0 00-.25-.25H15.5a.63.63 0 010-1.25h4a.63.63 0 010 1.25z"
    }), $denZA.createElement("path", {
        d: "M7 11.62h-.62a.25.25 0 00-.25.25v1.25a.25.25 0 00.25.25H7a.88.88 0 000-1.75zm5 0h-.62a.25.25 0 00-.25.25v1.25a.25.25 0 00.25.25H12a.88.88 0 000-1.75z"
    })));
});
$44a7b96be33fcab7$export$ad5b131dbf55d577.displayName = 'FilesPptBold';





var $denZA = parcelRequire("denZA");
var $869b8ef9f831c2b5$var$__assign = undefined && undefined.__assign || function() {
    $869b8ef9f831c2b5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $869b8ef9f831c2b5$var$__assign.apply(this, arguments);
};
var $869b8ef9f831c2b5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $869b8ef9f831c2b5$export$4c1d74adbdd74052 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $869b8ef9f831c2b5$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $869b8ef9f831c2b5$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-psd_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81zm5.25 13.171a.749.749 0 00-.75.742v7.475a.752.752 0 00.75.752 3.756 3.756 0 002.645-1.1A3.772 3.772 0 0024 20.202V18.71a3.752 3.752 0 00-1.106-2.64 3.736 3.736 0 00-2.644-1.088zm.75 7.345v-5.731a2.25 2.25 0 011.5 2.114v1.493a2.258 2.258 0 01-1.5 2.124z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.25 14.981a.75.75 0 00-.75.742v7.475a.752.752 0 00.75.752.75.75 0 00.75-.752v-2.204a2.994 2.994 0 002.13-.872 3.01 3.01 0 000-4.239A3 3 0 009 14.981h-.75zM9 16.464v3.007a1.498 1.498 0 001.06-.481 1.484 1.484 0 000-2.115 1.498 1.498 0 00-1.06-.41z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M16.2 18.87c-.77-.592-1.2-.953-1.2-1.654a.762.762 0 01.75-.722h1.51a.769.769 0 00.76-.761.762.762 0 00-.76-.752h-1.51a2.248 2.248 0 00-2.23 2.255 3.443 3.443 0 001.79 2.846c.77.581 1.2.942 1.2 1.643a.772.772 0 01-.76.762h-1.51a.759.759 0 00-.75.751.762.762 0 00.75.762h1.51a2.255 2.255 0 002.085-1.414 2.27 2.27 0 00.165-.87 3.473 3.473 0 00-1.8-2.847z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-psd_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$869b8ef9f831c2b5$export$4c1d74adbdd74052.displayName = 'FilesPsd';





var $denZA = parcelRequire("denZA");
var $497bccae51067b63$var$__assign = undefined && undefined.__assign || function() {
    $497bccae51067b63$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $497bccae51067b63$var$__assign.apply(this, arguments);
};
var $497bccae51067b63$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $497bccae51067b63$export$3b4689defab998b3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $497bccae51067b63$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $497bccae51067b63$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.29 12.11v2.53a1.31 1.31 0 00.9-.37 1.27 1.27 0 00-.9-2.16zm10.2.11v4.84a2.14 2.14 0 00.71-.45 1.92 1.92 0 00.56-1.34V14a1.94 1.94 0 00-.56-1.34 2 2 0 00-.71-.44z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM8.09 15.16a2.539 2.539 0 01-1.8.74v1.9a.64.64 0 01-.64.63.63.63 0 01-.63-.63v-6.32a.64.64 0 01.63-.64h.64a2.531 2.531 0 011.8 4.32zm4.29-1a2.91 2.91 0 011.49 2.39 1.91 1.91 0 01-1.9 1.9h-1.24a.64.64 0 110-1.28H12a.64.64 0 00.64-.64c0-.59-.36-.9-1-1.39a2.9 2.9 0 01-1.52-2.4 1.91 1.91 0 011.9-1.9h1.28a.64.64 0 110 1.27H12a.64.64 0 00-.64.64c0 .59.37.89 1.02 1.39v.02zm6.6 1.13a3.16 3.16 0 01-3.17 3.16.67.67 0 01-.45-.18.63.63 0 01-.18-.45v-6.34a.64.64 0 01.63-.64 3.22 3.22 0 012.25.93c.59.592.92 1.394.92 2.23v1.29z"
    })));
});
$497bccae51067b63$export$3b4689defab998b3.displayName = 'FilesPsdBold';





var $denZA = parcelRequire("denZA");
var $40276823bf794f58$var$__assign = undefined && undefined.__assign || function() {
    $40276823bf794f58$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40276823bf794f58$var$__assign.apply(this, arguments);
};
var $40276823bf794f58$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $40276823bf794f58$export$4f1e1e7a399aeb90 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $40276823bf794f58$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $40276823bf794f58$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.869 6.59L15.99.71A2.254 2.254 0 0014.399 0H3.723a2.256 2.256 0 00-2.07 1.43 2.25 2.25 0 00-.153.87v19.4a2.247 2.247 0 001.358 2.115c.273.118.567.181.865.185h16.523a2.255 2.255 0 002.253-2.25V8.18a2.248 2.248 0 00-.631-1.59zm-6.85-4.73l5.728 5.7H15.74a.752.752 0 01-.75-.75l.03-4.95zm6.009 19.84a.75.75 0 01-.751.75H3.724a.751.751 0 01-.751-.75V2.3a.75.75 0 01.75-.75h9.764v5.26a2.248 2.248 0 002.253 2.25h5.258l.03 12.64z"
    }), $denZA.createElement("path", {
        d: "M15.86 11.75a1.84 1.84 0 00-1.932-1.69h-.611a.641.641 0 00-.453 1.092c.12.12.283.188.453.188h.691a.581.581 0 01.6.5v1.05a1.729 1.729 0 00.892 1.46l.38.22-.39.2a1.701 1.701 0 00-.891 1.46v1.05a.57.57 0 01-.601.5h-.691a.641.641 0 100 1.28h.721a1.834 1.834 0 001.823-1.69v-1.09a.418.418 0 01.23-.36l1.342-.77a.63.63 0 00.32-.55.61.61 0 00-.31-.57l-1.342-.77a.461.461 0 01-.23-.37v-1.14zm-8.25-.057a1.84 1.84 0 011.933-1.69h.611a.641.641 0 110 1.28h-.691a.581.581 0 00-.6.5v1.05a1.728 1.728 0 01-.892 1.46l-.38.22.39.2a1.7 1.7 0 01.891 1.46v1.05a.57.57 0 00.601.5h.691a.641.641 0 01.453 1.092.642.642 0 01-.453.188h-.721a1.834 1.834 0 01-1.823-1.69v-1.09a.42.42 0 00-.23-.36l-1.342-.77a.63.63 0 01-.32-.55.61.61 0 01.31-.57l1.342-.77a.461.461 0 00.23-.37v-1.14z"
    })));
});
$40276823bf794f58$export$4f1e1e7a399aeb90.displayName = 'FilesQueryFile';





var $denZA = parcelRequire("denZA");
var $35dedf742208d3d1$var$__assign = undefined && undefined.__assign || function() {
    $35dedf742208d3d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35dedf742208d3d1$var$__assign.apply(this, arguments);
};
var $35dedf742208d3d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $35dedf742208d3d1$export$41a5aac396b4538a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $35dedf742208d3d1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $35dedf742208d3d1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M16.297.29L21.71 5.7a1 1 0 01.29.71V22a2 2 0 01-2.001 2H4.001A2.001 2.001 0 012 22V2a2 2 0 012.001-2h11.596a1 1 0 01.7.29zM19.51 22a.5.5 0 00.5-.5V7a.5.5 0 00-.15-.35l-4.532-4.5a.5.5 0 00-.32-.15H4.5a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15.01z"
    }), $denZA.createElement("path", {
        d: "M20.22 5.67l-3.953-3.88-12.896-.26v21.11h17.008l-.16-16.97zM8.072 13.19a2.08 2.08 0 01.93 1.67V16c0 .17.26.21.42.21h.581a1.001 1.001 0 010 2h-.6a2.282 2.282 0 01-2.4-2.21v-1a.25.25 0 00-.11-.21l-1.461-1a1 1 0 010-1.68l1.46-1a.24.24 0 00.11-.11v-1a2.279 2.279 0 012.382-2.25h.62a1.001 1.001 0 010 2h-.6c-.16 0-.42 0-.42.21v1.17a2.08 2.08 0 01-.881 1.67.24.24 0 000 .38l-.03.01zm10.495.68l-1.71 1c-.08.05-.11.09-.11.15v1a2.37 2.37 0 01-2.632 2.21h-.69a1.001 1.001 0 010-2h.69c.44 0 .63-.16.63-.21v-1.16a2 2 0 01.94-1.66.24.24 0 000-.39 2 2 0 01-.93-1.67V10c0-.05-.19-.21-.63-.21h-.69a1.001 1.001 0 010-2h.69A2.373 2.373 0 0116.757 10v1a.24.24 0 00.1.16l1.711.94a1 1 0 010 1.74v.03z"
    })));
});
$35dedf742208d3d1$export$41a5aac396b4538a.displayName = 'FilesQueryFileBold';





var $denZA = parcelRequire("denZA");
var $ae983f137b77c5b2$var$__assign = undefined && undefined.__assign || function() {
    $ae983f137b77c5b2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae983f137b77c5b2$var$__assign.apply(this, arguments);
};
var $ae983f137b77c5b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ae983f137b77c5b2$export$2ab7ede8c091988 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ae983f137b77c5b2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ae983f137b77c5b2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-svg_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.775a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M9.33 17.27c0 .704.43 1.065 1.2 1.648a3.457 3.457 0 011.76 2.832 2.265 2.265 0 01-.659 1.588c-.42.421-.988.66-1.581.662H8.58a.758.758 0 01-.76-.753.775.775 0 01.76-.764h1.51a.758.758 0 00.75-.753c0-.703-.43-1.065-1.2-1.647a3.476 3.476 0 01-1.8-2.832c.003-.6.24-1.172.662-1.596a2.255 2.255 0 011.588-.664h1.5a.768.768 0 01.76.763.765.765 0 01-.76.753h-1.5a.768.768 0 00-.76.764zm6.36 6.52a.68.68 0 01-.47-.212C13 21.308 13 16.156 13 15.945a.675.675 0 111.35 0s0 3.927 1.34 6.076A9.808 9.808 0 0017 15.945a.676.676 0 01.63-.713.655.655 0 01.656.373.69.69 0 01.064.26c.3 5.232-2.12 7.623-2.22 7.723a.699.699 0 01-.44.201zm6.12.19a3.04 3.04 0 01-1.91-.613c-.47-.448-.83-1-1.05-1.612-.22-.612-.26-1.19-.26-1.933.053-.83.074-1.475.343-2.173a4.822 4.822 0 011.247-1.825 3.802 3.802 0 013.05-.633.748.748 0 01.566.615.756.756 0 01-.623.863.746.746 0 01-.293-.011 2.299 2.299 0 00-1.79.361 3.447 3.447 0 00-.817 1.288c-.173.485-.22.958-.22 1.515 0 .459.024.834.144 1.234.12.399.323.769.593 1.086a2.075 2.075 0 001.71.2v-1.747l-.81.05a.748.748 0 01-.75-.753.755.755 0 01.75-.753h.86c.383 0 .75.152 1.022.423.271.27.425.639.428 1.023v1.798c0 .326-.107.642-.307.899a1.45 1.45 0 01-.793.517 4.67 4.67 0 01-1.09.18z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-svg_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$ae983f137b77c5b2$export$2ab7ede8c091988.displayName = 'FilesSvg';





var $denZA = parcelRequire("denZA");
var $fa1bdbbd2b027c5a$var$__assign = undefined && undefined.__assign || function() {
    $fa1bdbbd2b027c5a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa1bdbbd2b027c5a$var$__assign.apply(this, arguments);
};
var $fa1bdbbd2b027c5a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fa1bdbbd2b027c5a$export$ebed73e00da48246 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fa1bdbbd2b027c5a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fa1bdbbd2b027c5a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-svg-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM7.44 13.28A2.94 2.94 0 019 15.69a1.91 1.91 0 01-1.91 1.9H5.78a.64.64 0 110-1.27h1.28a.64.64 0 00.64-.64c0-.6-.36-.9-1-1.4a2.92 2.92 0 01-1.52-2.41A1.91 1.91 0 017.06 10h1.28a.64.64 0 01.64.64.65.65 0 01-.64.64H7.06a.64.64 0 00-.64.63c0 .57.37.88 1.02 1.37zm4.77 4a.59.59 0 01-.4.16.55.55 0 01-.4-.18C9.55 15.29 9.53 11 9.53 10.77a.57.57 0 01.57-.57.56.56 0 01.57.57s0 3.32 1.15 5.12A8.27 8.27 0 0013 10.78a.571.571 0 011.14-.07c.21 4.41-1.85 6.44-1.93 6.52v.05zm6.65-1a1.22 1.22 0 01-.94 1.19c-.3.078-.61.118-.92.12a2.58 2.58 0 01-1.62-.59 3.56 3.56 0 01-1.08-3 4.06 4.06 0 011.32-3.36 3.288 3.288 0 012.59-.54.64.64 0 01-.3 1.24 2 2 0 00-1.52.31 3 3 0 00-.82 2.35 2.61 2.61 0 00.6 2 1.78 1.78 0 001.45.17v-1.48l-.68.05a.641.641 0 01-.64-.64.64.64 0 01.64-.63h.73a1.23 1.23 0 011.23 1.22l-.04 1.59z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-svg-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$fa1bdbbd2b027c5a$export$ebed73e00da48246.displayName = 'FilesSvgBold';





var $denZA = parcelRequire("denZA");
var $ba3e737aec0a7ded$var$__assign = undefined && undefined.__assign || function() {
    $ba3e737aec0a7ded$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba3e737aec0a7ded$var$__assign.apply(this, arguments);
};
var $ba3e737aec0a7ded$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ba3e737aec0a7ded$export$9da53519c5fc3d22 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ba3e737aec0a7ded$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ba3e737aec0a7ded$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-tiff_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h.5a.75.75 0 000-1.5h-.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M7.362 16.516h.748a.748.748 0 000-1.497H5.117a.748.748 0 100 1.497h.748v6.736a.748.748 0 101.497 0v-6.736zm3.052 7.249a.778.778 0 00.559.185.768.768 0 00.817-.688v-7.495a.828.828 0 00-1.645 0v7.474a.778.778 0 00.269.524zm6.813-8.706h-3.362a.74.74 0 00-.748.748v7.415a.749.749 0 101.496 0v-2.266h1.766a.748.748 0 000-1.497h-1.766v-2.904h2.614a.748.748 0 000-1.496zm2.663 0h3.361a.748.748 0 110 1.496h-2.613v2.904h1.766a.748.748 0 010 1.497h-1.766v2.266a.749.749 0 11-1.496 0v-7.415a.749.749 0 01.748-.748z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-tiff_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$ba3e737aec0a7ded$export$9da53519c5fc3d22.displayName = 'FilesTiff';





var $denZA = parcelRequire("denZA");
var $200e36e083604999$var$__assign = undefined && undefined.__assign || function() {
    $200e36e083604999$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $200e36e083604999$var$__assign.apply(this, arguments);
};
var $200e36e083604999$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $200e36e083604999$export$4c2a727a534ececf = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $200e36e083604999$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $200e36e083604999$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM6.84 11.24H6.2v5.72a.64.64 0 01-.63.64.64.64 0 01-.64-.64v-5.72h-.64a.64.64 0 01-.445-1.085.63.63 0 01.445-.185h2.55a.63.63 0 01.63.63.64.64 0 01-.63.64zM10 16.96a.65.65 0 01-.7.6.65.65 0 01-.7-.6V10.6a.65.65 0 01.7-.6.65.65 0 01.7.6v6.36zm4.61-5.69h-2.25v2.49h1.5a.64.64 0 01.64.64.64.64 0 01-.64.63h-1.5v1.9a.64.64 0 11-1.27 0v-6.3a.64.64 0 01.63-.64h2.87a.64.64 0 110 1.28h.02zm5.12 0h-2.25v2.49H19a.64.64 0 01.64.64.64.64 0 01-.64.63h-1.5v1.9a.64.64 0 11-1.27 0v-6.3a.64.64 0 01.63-.64h2.87a.64.64 0 110 1.28z"
    })));
});
$200e36e083604999$export$4c2a727a534ececf.displayName = 'FilesTiffBold';





var $denZA = parcelRequire("denZA");
var $cafe15550c1ab2bc$var$__assign = undefined && undefined.__assign || function() {
    $cafe15550c1ab2bc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cafe15550c1ab2bc$var$__assign.apply(this, arguments);
};
var $cafe15550c1ab2bc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cafe15550c1ab2bc$export$7eb16584d50da272 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $cafe15550c1ab2bc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $cafe15550c1ab2bc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.12 9.053c.33.25.398.723.149 1.056l-2.132 2.856a1.503 1.503 0 01-1.094.599 1.49 1.49 0 01-1.166-.438L4.72 11.965a.756.756 0 010-1.066.747.747 0 011.06 0l1.157 1.161L9.07 9.204a.748.748 0 011.05-.15zm.149 7.84a.756.756 0 00-.15-1.056.748.748 0 00-1.05.151l-2.132 2.856-1.157-1.163a.747.747 0 00-1.06 0 .757.757 0 000 1.066l1.157 1.163a1.498 1.498 0 001.778.258c.188-.103.353-.246.482-.419l2.132-2.856zM12 12.814c0-.416.336-.754.75-.754h4.5c.414 0 .75.338.75.754a.752.752 0 01-.75.754h-4.5a.752.752 0 01-.75-.754zm.75 5.276a.752.752 0 00-.75.755c0 .416.336.753.75.753h4.5c.414 0 .75-.337.75-.753a.752.752 0 00-.75-.754h-4.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.5 21.739c0 .6-.237 1.175-.659 1.599A2.244 2.244 0 0120.25 24H3.75a2.244 2.244 0 01-1.591-.662c-.422-.424-.659-1-.659-1.6V2.262c0-.6.237-1.175.659-1.599A2.244 2.244 0 013.75 0h10.629c.596 0 1.168.238 1.59.662l5.873 5.902c.421.424.658.998.658 1.598v13.577zM3.22 1.729a.748.748 0 01.53-.221h9.75v5.276c0 .6.237 1.175.659 1.599.422.424.994.662 1.591.662H21V21.74a.756.756 0 01-.75.753H3.75A.748.748 0 013 21.74V2.26c0-.2.079-.391.22-.533zm17.47 5.809h-4.94a.748.748 0 01-.75-.754V1.82l5.69 5.718z",
        fillRule: "evenodd"
    })));
});
$cafe15550c1ab2bc$export$7eb16584d50da272.displayName = 'FilesToDo';





var $denZA = parcelRequire("denZA");
var $bd60c9699a1ff2d6$var$__assign = undefined && undefined.__assign || function() {
    $bd60c9699a1ff2d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd60c9699a1ff2d6$var$__assign.apply(this, arguments);
};
var $bd60c9699a1ff2d6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bd60c9699a1ff2d6$export$9782489aa46be6eb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bd60c9699a1ff2d6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bd60c9699a1ff2d6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.537 1.4H3.14v21.41h17.668V6.67L15.537 1.4zm-3.942 13.07l-2.001 2.5a.75.75 0 01-.54.28h-.05a.75.75 0 01-.53-.25l-1.471-1.47a.75.75 0 011-1.06l.78.78a.14.14 0 00.23 0l1.371-1.72a.75.75 0 011.17.94h.04zm0-5.5l-2.001 2.5a.75.75 0 01-.54.28h-.05a.75.75 0 01-.53-.22L7.002 10a.75.75 0 011-1l.78.78a.14.14 0 00.23 0L10.415 8a.773.773 0 011.18 1v-.03zm4.412 7.78h-2.501a.75.75 0 110-1.5h2.501a.75.75 0 110 1.5zm0-5.5h-2.501a.75.75 0 110-1.5h2.501a.75.75 0 110 1.5z"
    }), $denZA.createElement("path", {
        d: "M16.297.29L21.71 5.7a1 1 0 01.29.71V22a2 2 0 01-2.001 2H4.001A2.001 2.001 0 012 22V2a2 2 0 012.001-2h11.596a1 1 0 01.7.29zM19.51 22a.5.5 0 00.5-.5V7.25a.25.25 0 00-.25-.25h-2.752a2.001 2.001 0 01-2-2V2.25a.25.25 0 00-.25-.25H4.5a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15.01z"
    })));
});
$bd60c9699a1ff2d6$export$9782489aa46be6eb.displayName = 'FilesToDoBold';





var $denZA = parcelRequire("denZA");
var $72d2a1ae2103a8d4$var$__assign = undefined && undefined.__assign || function() {
    $72d2a1ae2103a8d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72d2a1ae2103a8d4$var$__assign.apply(this, arguments);
};
var $72d2a1ae2103a8d4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $72d2a1ae2103a8d4$export$4f3a2921405d8f4b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $72d2a1ae2103a8d4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $72d2a1ae2103a8d4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.85 6.59L15.97.71A2.18 2.18 0 0014.38 0H3.75a2.32 2.32 0 00-.87.17 2.36 2.36 0 00-.74.5 2.29 2.29 0 00-.48.75 2.22 2.22 0 00-.16.88v19.4a2.14 2.14 0 00.16.87c.107.28.27.535.48.75.207.219.46.39.74.5.275.12.57.181.87.18h16.5a2.25 2.25 0 002.25-2.25V8.18a2.24 2.24 0 00-.65-1.59zM15 1.82l5.69 5.73h-4.94a.75.75 0 01-.75-.73v-5zm6 19.84a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V2.3a.75.75 0 01.75-.75h9.75v5.27a2.25 2.25 0 002.25 2.25H21v12.59z"
    }), $denZA.createElement("path", {
        d: "M9.74 17.82h-.06a1.48 1.48 0 01-1.21-.75 1.4 1.4 0 01-.18-.7v-5.05c0-.248.061-.492.18-.71.125-.213.3-.391.51-.52a1.34 1.34 0 01.7-.22 1.38 1.38 0 01.71.15l5.06 2.53a1.41 1.41 0 01.8 1.3 1.44 1.44 0 01-.8 1.3l-5.06 2.53a1.44 1.44 0 01-.65.14zm0-6.55l-.06 5.1h.06l5.06-2.52-5.06-2.58z"
    })));
});
$72d2a1ae2103a8d4$export$4f3a2921405d8f4b.displayName = 'FilesVideo';





var $denZA = parcelRequire("denZA");
var $9741b119f8699e7d$var$__assign = undefined && undefined.__assign || function() {
    $9741b119f8699e7d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9741b119f8699e7d$var$__assign.apply(this, arguments);
};
var $9741b119f8699e7d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9741b119f8699e7d$export$1396ac4f1db3deb8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9741b119f8699e7d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9741b119f8699e7d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.91 6a.93.93 0 00-.21-.33L16.29.29a1 1 0 00-.66-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.09-.41zm-5.72 8.3L9.8 17.8a1.33 1.33 0 01-.66.17 1.36 1.36 0 01-1.37-1.37v-7a1.36 1.36 0 01.67-1.18 1.37 1.37 0 011.36 0l6.39 3.51a1.37 1.37 0 010 2.4v-.03z"
    }), $denZA.createElement("path", {
        d: "M9.77 15.57l4.45-2.44-4.45-2.44v4.88z"
    })));
});
$9741b119f8699e7d$export$1396ac4f1db3deb8.displayName = 'FilesVideoBold';





var $denZA = parcelRequire("denZA");
var $34b5d585af737f97$var$__assign = undefined && undefined.__assign || function() {
    $34b5d585af737f97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34b5d585af737f97$var$__assign.apply(this, arguments);
};
var $34b5d585af737f97$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $34b5d585af737f97$export$8abdae525e4fc7c0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $34b5d585af737f97$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $34b5d585af737f97$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-vtt_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h4.08a.75.75 0 000-1.5H3.75a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M11.916 23.916a.68.68 0 01-.47-.21c-2.18-2.26-2.2-7.39-2.2-7.6a.67.67 0 01.67-.67.67.67 0 01.68.67s0 3.91 1.34 6a9.73 9.73 0 001.34-6 .671.671 0 01.63-.71.66.66 0 01.72.63c.3 5.21-2.12 7.59-2.22 7.69a.7.7 0 01-.49.2zm6.84-7h-.69v6.3a.7.7 0 01-1.4 0v-6.3h-.7a.7.7 0 010-1.39h2.79a.7.7 0 110 1.39zm4.46 0h-.7v6.3a.7.7 0 11-1.39 0v-6.3h-.7a.7.7 0 110-1.39h2.79a.7.7 0 110 1.39z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-vtt_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$34b5d585af737f97$export$8abdae525e4fc7c0.displayName = 'FilesVtt';





var $denZA = parcelRequire("denZA");
var $9afdbf766a25e5f5$var$__assign = undefined && undefined.__assign || function() {
    $9afdbf766a25e5f5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9afdbf766a25e5f5$var$__assign.apply(this, arguments);
};
var $9afdbf766a25e5f5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9afdbf766a25e5f5$export$1a8c96d37afeb282 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9afdbf766a25e5f5$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9afdbf766a25e5f5$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM8.31 17.35a.57.57 0 01-.41.17.6.6 0 01-.41-.18c-1.92-2-1.94-6.49-1.94-6.68a.6.6 0 011.19 0s0 3.44 1.18 5.31a8.62 8.62 0 001.17-5.3.59.59 0 01.56-.62.57.57 0 01.62.55c.26 4.57-1.87 6.67-1.96 6.75zm5.62-6h-.61v5.55a.62.62 0 11-1.23 0v-5.51h-.61a.61.61 0 010-1.22h2.45a.61.61 0 010 1.22v-.04zm3.91 0h-.61v5.55a.61.61 0 01-1.22 0v-5.51h-.61a.61.61 0 010-1.22h2.44a.61.61 0 010 1.22v-.04z"
    })));
});
$9afdbf766a25e5f5$export$1a8c96d37afeb282.displayName = 'FilesVttBold';





var $denZA = parcelRequire("denZA");
var $3652c6bf0990f565$var$__assign = undefined && undefined.__assign || function() {
    $3652c6bf0990f565$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3652c6bf0990f565$var$__assign.apply(this, arguments);
};
var $3652c6bf0990f565$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3652c6bf0990f565$export$5010b49c6f8805c2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $3652c6bf0990f565$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $3652c6bf0990f565$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-wav_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h.5a.75.75 0 000-1.5h-.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M8.201 23.887a.668.668 0 01-.41-.13c-2.387-1.751-2.157-7.093-2.117-7.693a.7.7 0 011.183-.386.7.7 0 01.205.456 13.27 13.27 0 00.81 5.542l.838-3.251a.7.7 0 01.67-.52.708.708 0 01.679.51l.86 3.12c.609-1.74.83-3.594.648-5.43a.713.713 0 01.66-.76.71.71 0 01.759.66c.3 6.001-1.678 7.571-1.908 7.731a.668.668 0 01-.63.08.69.69 0 01-.439-.47l-.6-2.04-.529 2.06a.73.73 0 01-.44.48.67.67 0 01-.239.04z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.773 15.374a2.086 2.086 0 00-2.078 2.09v5.752a.701.701 0 00.981.722.7.7 0 00.408-.722v-2.87h1.378v2.87a.7.7 0 101.399 0v-5.751a2.103 2.103 0 00-2.088-2.09zm-.69 3.571v-1.48a.69.69 0 011.177-.488.69.69 0 01.202.488v1.48h-1.378z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M20.991 23.836a.61.61 0 00.256.05.64.64 0 00.51-.19c.1-.09 2.517-2.48 2.217-7.692a.65.65 0 00-.74-.59.679.679 0 00-.638.71 9.733 9.733 0 01-1.329 6.002c-1.348-2.13-1.348-6.052-1.348-6.052a.67.67 0 00-1.147-.474.68.68 0 00-.202.474c0 .22.02 5.342 2.207 7.612a.63.63 0 00.214.15z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-wav_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$3652c6bf0990f565$export$5010b49c6f8805c2.displayName = 'FilesWav';





var $denZA = parcelRequire("denZA");
var $df53efa03e1b634b$var$__assign = undefined && undefined.__assign || function() {
    $df53efa03e1b634b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $df53efa03e1b634b$var$__assign.apply(this, arguments);
};
var $df53efa03e1b634b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $df53efa03e1b634b$export$954c051c6cbefe55 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $df53efa03e1b634b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $df53efa03e1b634b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.89 11.52a.63.63 0 00-.63.63v1.35h1.26v-1.35a.63.63 0 00-.63-.63z"
    }), $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-1.41.59A2 2 0 002 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM8.57 17.89a.66.66 0 01-.58.07.62.62 0 01-.39-.43l-.53-1.89-.48 1.88a.61.61 0 01-.4.44.57.57 0 01-.22 0 .62.62 0 01-.38-.07c-2.18-1.59-2-6.46-1.93-7a.64.64 0 111.27.07 12 12 0 00.74 5.05l.76-3a.65.65 0 01.62-.48.64.64 0 01.62.47l.79 2.89a11.65 11.65 0 00.54-5 .655.655 0 011.31 0c.28 5.46-1.53 6.86-1.74 7zm6.22-.5a.64.64 0 01-1.27 0v-2.61h-1.26v2.62a.64.64 0 11-1.28 0v-5.25a1.91 1.91 0 113.81 0v5.24zm3.52.44a.61.61 0 01-.42.17.63.63 0 01-.43-.19c-2-2.07-2-6.74-2-6.94a.61.61 0 01.62-.61.61.61 0 01.61.61s0 3.57 1.23 5.52a8.88 8.88 0 001.19-5.5.61.61 0 01.58-.64.6.6 0 01.65.57c.27 4.75-1.93 6.93-2.03 7.07v-.06z"
    })));
});
$df53efa03e1b634b$export$954c051c6cbefe55.displayName = 'FilesWavBold';





var $denZA = parcelRequire("denZA");
var $7bcd628f0806119f$var$__assign = undefined && undefined.__assign || function() {
    $7bcd628f0806119f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7bcd628f0806119f$var$__assign.apply(this, arguments);
};
var $7bcd628f0806119f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7bcd628f0806119f$export$10b5cda80b0293f5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7bcd628f0806119f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7bcd628f0806119f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.247 14.998a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75 3.75 3.75 0 003.75-3.75v-1.5a3.75 3.75 0 00-3.75-3.75zm.75 7.371v-5.742a2.249 2.249 0 011.5 2.121v1.5a2.25 2.25 0 01-1.5 2.121zm5.159-6.712a2.25 2.25 0 013.841 1.591v4.5a2.25 2.25 0 01-4.5 0v-4.5c0-.597.237-1.169.66-1.591zm1.591.841a.75.75 0 00-.75.75v4.5a.75.75 0 101.5 0v-4.5a.75.75 0 00-.75-.75z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M23.247 14.998a3.75 3.75 0 00-3.75 3.75v1.5a3.75 3.75 0 003.75 3.75.75.75 0 000-1.5 2.25 2.25 0 01-2.25-2.25v-1.5a2.25 2.25 0 012.25-2.25.75.75 0 000-1.5z"
    })));
});
$7bcd628f0806119f$export$10b5cda80b0293f5.displayName = 'FilesWord';





var $denZA = parcelRequire("denZA");
var $4d1b74838534db0a$var$__assign = undefined && undefined.__assign || function() {
    $4d1b74838534db0a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d1b74838534db0a$var$__assign.apply(this, arguments);
};
var $4d1b74838534db0a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d1b74838534db0a$export$a28766d161aa0ee1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4d1b74838534db0a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4d1b74838534db0a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zM5.5 17.12a.62.62 0 01-.62-.62v-6a.63.63 0 01.63-.62 3.625 3.625 0 110 7.25l-.01-.01zM14.13 15a2.13 2.13 0 01-4.25 0v-3a2.125 2.125 0 014.25 0v3zm4.38.88a.624.624 0 110 1.25 3.625 3.625 0 010-7.25.625.625 0 110 1.25 2.38 2.38 0 000 4.75z"
    }), $denZA.createElement("path", {
        d: "M6.45 11.33c-.1 0-.33 0-.33.16v4a.24.24 0 00.33.21 2.37 2.37 0 000-4.35v-.02zm5.55-.21a.88.88 0 00-.87.88v3a.88.88 0 101.75 0v-3a.88.88 0 00-.88-.88z"
    })));
});
$4d1b74838534db0a$export$a28766d161aa0ee1.displayName = 'FilesWordBold';





var $denZA = parcelRequire("denZA");
var $4d8dcb27d34a01b0$var$__assign = undefined && undefined.__assign || function() {
    $4d8dcb27d34a01b0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d8dcb27d34a01b0$var$__assign.apply(this, arguments);
};
var $4d8dcb27d34a01b0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d8dcb27d34a01b0$export$7a3d1a91ed30f8c1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4d8dcb27d34a01b0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4d8dcb27d34a01b0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h1a.75.75 0 000-1.5h-1a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M16.74 22.491h-1.51a.761.761 0 01-.754-.754v-6a.761.761 0 00-.755-.754.761.761 0 00-.754.754v6a2.253 2.253 0 002.246 2.246h1.508a.76.76 0 00.755-.754.732.732 0 00-.737-.738zm-5.726-7.44a.758.758 0 00-.977.412l-.789 2.023-.805-2.006a.752.752 0 00-.978-.411.752.752 0 00-.411.977l1.389 3.463-1.389 3.462a.758.758 0 00.411.978.752.752 0 00.977-.429l.806-2.006.806 2.006a.76.76 0 00.977.429.752.752 0 00.412-.978l-1.389-3.462 1.389-3.463a.765.765 0 00-.429-.995zm10.68 3.84c-.771-.582-1.2-.942-1.2-1.645 0-.412.343-.755.754-.755h1.509a.76.76 0 00.754-.754.761.761 0 00-.754-.754h-1.509a2.254 2.254 0 00-2.245 2.246c0 1.505.99 2.242 1.794 2.841l.005.004c.772.583 1.2.943 1.2 1.646a.761.761 0 01-.754.754H19.74a.761.761 0 00-.755.755c0 .411.343.754.755.754h1.508a2.253 2.253 0 002.246-2.246c0-1.468-.963-2.205-1.762-2.816l-.038-.03z"
    })));
});
$4d8dcb27d34a01b0$export$7a3d1a91ed30f8c1.displayName = 'FilesXls';





var $denZA = parcelRequire("denZA");
var $b57b9bef1051ed22$var$__assign = undefined && undefined.__assign || function() {
    $b57b9bef1051ed22$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b57b9bef1051ed22$var$__assign.apply(this, arguments);
};
var $b57b9bef1051ed22$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b57b9bef1051ed22$export$4d589502956d7064 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b57b9bef1051ed22$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b57b9bef1051ed22$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.71 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.29-.7zm-12.65 11a.63.63 0 11-1.12.56s-.86-1.71-.88-1.76a.07.07 0 00-.12 0l-.88 1.76a.62.62 0 01-1.035.131.62.62 0 01-.085-.691l1.3-2.61a.25.25 0 000-.22l-1.3-2.61a.63.63 0 011.12-.56l.88 1.75a.07.07 0 00.104.032.07.07 0 00.026-.032l.88-1.75a.63.63 0 111.12.56l-1.3 2.61a.25.25 0 000 .22l1.29 2.61zm4.44.91h-2A1.63 1.63 0 019.87 16v-5a.63.63 0 011.25 0v5a.38.38 0 00.38.37h2a.63.63 0 010 1.25zm2.92-4.76l1.84 1.23a1.93 1.93 0 01-1.07 3.53H15.5a.63.63 0 110-1.25h1.7a.68.68 0 00.38-1.24l-1.84-1.23a1.93 1.93 0 011.07-3.53h1.7a.63.63 0 010 1.25H16.8a.68.68 0 00-.38 1.24z"
    })));
});
$b57b9bef1051ed22$export$4d589502956d7064.displayName = 'FilesXlsBold';





var $denZA = parcelRequire("denZA");
var $2bb09403f8ac264e$var$__assign = undefined && undefined.__assign || function() {
    $2bb09403f8ac264e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2bb09403f8ac264e$var$__assign.apply(this, arguments);
};
var $2bb09403f8ac264e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2bb09403f8ac264e$export$faaa588ac961c5ae = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2bb09403f8ac264e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2bb09403f8ac264e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#files-zip_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.22 1.72a.75.75 0 01.53-.22h9.75v5.25A2.25 2.25 0 0015.75 9H21v3.75a.75.75 0 001.5 0V8.122a2.25 2.25 0 00-.659-1.591L15.971.66A2.25 2.25 0 0014.379 0H3.75A2.25 2.25 0 001.5 2.25v19.5A2.25 2.25 0 003.75 24h3a.75.75 0 000-1.5h-3a.75.75 0 01-.75-.75V2.25a.75.75 0 01.22-.53zM15 1.81v4.94a.75.75 0 00.75.75h4.94L15 1.81zm5.228 13.209a.766.766 0 00-.755.75v7.48a.75.75 0 00.755.75.756.756 0 00.754-.75v-2.223c.8 0 1.568-.316 2.134-.88a2.997 2.997 0 000-4.248 3.025 3.025 0 00-2.134-.88h-.754zm.754 1.512v2.993a1.532 1.532 0 001.395-.924 1.477 1.477 0 00-.329-1.629 1.532 1.532 0 00-1.066-.44z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M17.26 23.96a.787.787 0 01-.835-.711v-7.51a.84.84 0 01.835-.711.847.847 0 01.835.712v7.509a.78.78 0 01-.835.71zm-7.956-.101c.11.065.235.1.362.1h4.547a.726.726 0 00.724-.72.72.72 0 00-.724-.721h-3.25l3.873-6.368a.71.71 0 000-.72.723.723 0 00-.633-.371H9.666a.726.726 0 00-.724.72.72.72 0 00.724.721h3.25l-3.863 6.368a.719.719 0 00.251.99z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "files-zip_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$2bb09403f8ac264e$export$faaa588ac961c5ae.displayName = 'FilesZip';





var $denZA = parcelRequire("denZA");
var $66bd9022f1babdb1$var$__assign = undefined && undefined.__assign || function() {
    $66bd9022f1babdb1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $66bd9022f1babdb1$var$__assign.apply(this, arguments);
};
var $66bd9022f1babdb1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $66bd9022f1babdb1$export$d6f34aaa7c8cc2aa = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $66bd9022f1babdb1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $66bd9022f1babdb1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.68 5.71L16.29.29a1 1 0 00-.7-.29H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.41a1 1 0 00-.32-.7zM10.08 16.9a.61.61 0 010 1.22H6.26a.61.61 0 01-.53-.31.6.6 0 010-.62l3.26-5.39H6.26a.62.62 0 010-1.23h3.82a.59.59 0 01.53.32.58.58 0 010 .61l-3.26 5.4h2.73zm3.28.62a.71.71 0 01-1.4 0v-6.38a.71.71 0 011.4 0v6.38zm4.25-2.62a2.539 2.539 0 01-1.8.74v1.91a.64.64 0 01-1.27 0v-6.38a.63.63 0 01.64-.63h.64a2.53 2.53 0 011.79 4.36z"
    }), $denZA.createElement("path", {
        d: "M15.81 11.8v2.54a1.32 1.32 0 00.9-.37 1.28 1.28 0 000-1.8 1.32 1.32 0 00-.9-.37z"
    })));
});
$66bd9022f1babdb1$export$d6f34aaa7c8cc2aa.displayName = 'FilesZipBold';





var $denZA = parcelRequire("denZA");
var $7ad1a86a8f49301e$var$__assign = undefined && undefined.__assign || function() {
    $7ad1a86a8f49301e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ad1a86a8f49301e$var$__assign.apply(this, arguments);
};
var $7ad1a86a8f49301e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7ad1a86a8f49301e$export$ec91da630f36d5ea = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7ad1a86a8f49301e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7ad1a86a8f49301e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08zm-9.497 10.525a.754.754 0 00-.6.737v7.372l-3 2.503V12.29a.754.754 0 00-.6-.737c-4.594-.943-8.04-4.868-8.383-9.531H22.44c-.326 4.663-3.771 8.588-8.366 9.531z"
    })));
});
$7ad1a86a8f49301e$export$ec91da630f36d5ea.displayName = 'Filter';





var $denZA = parcelRequire("denZA");
var $994b050ac90f2d3c$var$__assign = undefined && undefined.__assign || function() {
    $994b050ac90f2d3c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $994b050ac90f2d3c$var$__assign.apply(this, arguments);
};
var $994b050ac90f2d3c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $994b050ac90f2d3c$export$12f6556880dd4f70 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $994b050ac90f2d3c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $994b050ac90f2d3c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.571 1.029a1.495 1.495 0 00-1.028-.515H1.49C1.097.514.72.67.446.96A1.436 1.436 0 000 2.023v.103c.377 5.143 4.029 9.48 8.966 10.765v9.275c0 .394.154.771.445 1.063.292.291.652.445 1.063.445.343 0 .686-.12.96-.343l3-2.502c.343-.292.549-.703.549-1.149v-6.806c4.954-1.285 8.606-5.623 8.966-10.765a1.47 1.47 0 00-.378-1.08z"
    })));
});
$994b050ac90f2d3c$export$12f6556880dd4f70.displayName = 'FilterBold';





var $denZA = parcelRequire("denZA");
var $86d0c07c784a46a4$var$__assign = undefined && undefined.__assign || function() {
    $86d0c07c784a46a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86d0c07c784a46a4$var$__assign.apply(this, arguments);
};
var $86d0c07c784a46a4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $86d0c07c784a46a4$export$80729fed35a16515 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $86d0c07c784a46a4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $86d0c07c784a46a4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.659 2.159A2.25 2.25 0 012.25 1.5H7.5a2.25 2.25 0 011.8.9l1.575 2.1H21.75A2.25 2.25 0 0124 6.75v13.5a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 20.25V3.75c0-.597.237-1.169.659-1.591zM2.25 3a.75.75 0 00-.75.75v16.5a.75.75 0 00.75.75h19.5a.75.75 0 00.75-.75V6.75a.75.75 0 00-.75-.75H10.5a.75.75 0 01-.6-.3L8.1 3.3a.75.75 0 00-.6-.3H2.25z",
        fillRule: "evenodd"
    })));
});
$86d0c07c784a46a4$export$80729fed35a16515.displayName = 'Folder';





var $denZA = parcelRequire("denZA");
var $1ea2064b4012c414$var$__assign = undefined && undefined.__assign || function() {
    $1ea2064b4012c414$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1ea2064b4012c414$var$__assign.apply(this, arguments);
};
var $1ea2064b4012c414$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1ea2064b4012c414$export$307e8046db705ba2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1ea2064b4012c414$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1ea2064b4012c414$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.5 5H11.236a.5.5 0 01-.447-.276l-.947-1.9A1.494 1.494 0 008.5 2h-7A1.5 1.5 0 000 3.5v17A1.5 1.5 0 001.5 22h21a1.5 1.5 0 001.5-1.5v-14A1.5 1.5 0 0022.5 5z"
    })));
});
$1ea2064b4012c414$export$307e8046db705ba2.displayName = 'FolderBold';





var $denZA = parcelRequire("denZA");
var $5717cab82284d8ae$var$__assign = undefined && undefined.__assign || function() {
    $5717cab82284d8ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5717cab82284d8ae$var$__assign.apply(this, arguments);
};
var $5717cab82284d8ae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5717cab82284d8ae$export$985739bfa5723e08 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5717cab82284d8ae$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5717cab82284d8ae$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.542 5.469H12.51a5.612 5.612 0 00-1.785-3.928A7.536 7.536 0 005.333.046a.748.748 0 00-.648.837.738.738 0 00.828.648A6.11 6.11 0 019.73 2.667a4.197 4.197 0 011.275 2.802h-6.33A4.685 4.685 0 000 10.144v10.248a3.618 3.618 0 003.609 3.579 2.99 2.99 0 002.562-1.446l2.492-4.067h5.822l2.103 3.37a3.928 3.928 0 002.831 2.143 3.32 3.32 0 002.841-.997 4.984 4.984 0 00.997-2.99v-9.84a4.675 4.675 0 00-4.715-4.675zm3.15 14.514a3.84 3.84 0 01-.528 1.944 1.765 1.765 0 01-1.565.558 2.392 2.392 0 01-1.735-1.296l-2.333-3.748a.746.746 0 00-.638-.349l-6.649-.1a.738.738 0 00-.638.36l-2.711 4.425a1.515 1.515 0 01-1.286.728 2.114 2.114 0 01-2.114-2.113V10.144a3.18 3.18 0 013.18-3.18h13.867a3.18 3.18 0 013.15 3.18v9.84z"
    }), $denZA.createElement("path", {
        d: "M7.128 12.307H6v-1.126a.748.748 0 00-1.495 0v1.126H3.369a.748.748 0 000 1.495h1.137v1.137a.747.747 0 101.495 0v-1.137h1.127a.747.747 0 100-1.495zm9.699 2.433a1.446 1.446 0 100-2.892 1.446 1.446 0 000 2.891zm2.343-4.835a1.186 1.186 0 100 2.372 1.186 1.186 0 000-2.372z"
    })));
});
$5717cab82284d8ae$export$985739bfa5723e08.displayName = 'Game';





var $denZA = parcelRequire("denZA");
var $25c4e2b84e0e0240$var$__assign = undefined && undefined.__assign || function() {
    $25c4e2b84e0e0240$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25c4e2b84e0e0240$var$__assign.apply(this, arguments);
};
var $25c4e2b84e0e0240$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25c4e2b84e0e0240$export$55671b2c4eaaf5a8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $25c4e2b84e0e0240$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $25c4e2b84e0e0240$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M19.275 5.55h-6.061a5.842 5.842 0 00-1.88-3.942A7.842 7.842 0 005.711.048a1 1 0 00-.75 1.485 1 1 0 001 .505 5.772 5.772 0 014 1.07 3.8 3.8 0 011.181 2.441h-6.88A4.251 4.251 0 000 9.8v10.433a4.14 4.14 0 00.64 2.27c1.381 2.1 3.662 1.78 4.552.33l2.33-3.86a2 2 0 011.75-1h4.932a2 2 0 011.72 1l1.93 3.09c1.051 1.9 3.352 2.52 4.872 1a4.712 4.712 0 00.81-2.67V9.8a4.25 4.25 0 00-4.26-4.25zM7.142 13.84h-1.14v1.13a.76.76 0 11-1.51 0v-1.13h-1.15a.76.76 0 010-1.51h1.15v-1.14a.76.76 0 011.51 0v1.14h1.14a.76.76 0 010 1.51zm9.773.93a1.45 1.45 0 110-2.9 1.45 1.45 0 010 2.9zm2.36-2.47a1.2 1.2 0 111.2-1.19 1.189 1.189 0 01-1.2 1.19z"
    })));
});
$25c4e2b84e0e0240$export$55671b2c4eaaf5a8.displayName = 'GameBold';





var $denZA = parcelRequire("denZA");
var $2021d99236f023f6$var$__assign = undefined && undefined.__assign || function() {
    $2021d99236f023f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2021d99236f023f6$var$__assign.apply(this, arguments);
};
var $2021d99236f023f6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2021d99236f023f6$export$af880670b5567579 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2021d99236f023f6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2021d99236f023f6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.241 5.997h-4.87a3.648 3.648 0 002.02-1.614c.455-.926.203-1.992-.747-3.138a2.777 2.777 0 00-1.157-.988 2.824 2.824 0 00-1.51-.237c-2.416.358-4.306 4.304-4.831 5.529-.536-1.196-2.375-5.14-4.84-5.53a2.834 2.834 0 00-1.523.254 2.786 2.786 0 00-1.155 1.012c-.92 1.146-1.192 2.212-.748 3.138a3.69 3.69 0 002.031 1.574H.758c-.2 0-.39.078-.532.216A.742.742 0 000 6.735v5.41a.742.742 0 00.226.521.763.763 0 00.532.216h.93v10.37a.752.752 0 00.224.526.77.77 0 00.533.222h19.078a.763.763 0 00.536-.219.742.742 0 00.222-.528V12.97h.96a.757.757 0 00.535-.212.737.737 0 00.223-.525v-5.46a.727.727 0 00-.208-.55.75.75 0 00-.55-.227zm-9.367 5.4H10.62V7.522h3.254v3.875zm3.335-9.963h.14c.233 0 .627.1 1.133.708.505.607.778 1.106.555 1.574-.454.996-3.031 1.454-5.143 1.594.839-1.624 2.162-3.617 3.315-3.786v-.09zM5.244 3.786c-.222-.469.182-1.106.556-1.574.374-.469.91-.708 1.132-.708h.151c1.142.17 2.466 2.162 3.315 3.856-2.163-.12-4.669-.628-5.154-1.574zM1.516 7.522h7.599v3.915h-7.6V7.522zm1.718 5.45h5.88v9.583h-5.88v-9.584zm7.386 9.583v-9.584h3.254v9.584H10.62zm10.105 0h-5.346v-9.584h5.386l-.04 9.584zm1.728-11.068H15.38V7.522h7.073v3.965z"
    })));
});
$2021d99236f023f6$export$af880670b5567579.displayName = 'Gift';





var $denZA = parcelRequire("denZA");
var $121e9108006f1dae$var$__assign = undefined && undefined.__assign || function() {
    $121e9108006f1dae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $121e9108006f1dae$var$__assign.apply(this, arguments);
};
var $121e9108006f1dae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $121e9108006f1dae$export$cc8fab9d3c9e68bd = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $121e9108006f1dae$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $121e9108006f1dae$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.667 13.596h-8.903V24h8.903a.483.483 0 00.455-.274.47.47 0 00.044-.18V14.05a.47.47 0 00-.314-.426.483.483 0 00-.185-.028zm-19.334 0a.482.482 0 00-.455.274.47.47 0 00-.044.18v9.496a.47.47 0 00.314.425c.06.022.122.031.185.029h8.903V13.596H2.333zM23.5 6.63h-6.926c1.66-.333 3.341-1.008 3.922-2.167.448-.948.204-2.017-.754-3.186A2.864 2.864 0 0018.566.27a2.9 2.9 0 00-1.534-.253c-2.455.373-4.36 4.375-4.89 5.615C11.603 4.392 9.699.39 7.254.017A2.9 2.9 0 005.719.27c-.478.222-.885.57-1.176 1.007-.957 1.17-1.202 2.238-.754 3.186.581 1.2 2.252 1.834 3.922 2.167H.5a.493.493 0 00-.46.296.48.48 0 00-.039.188v4.788a.501.501 0 00.5.484h10.736V7.053h1.528v5.363h10.737a.492.492 0 00.5-.484V7.115a.48.48 0 00-.31-.45.494.494 0 00-.19-.034zM5.176 3.838c-.224-.464.173-1.12.56-1.583.51-.625.917-.726 1.141-.726h.143c1.16.171 2.505 2.198 3.35 3.921-2.18-.15-4.737-.675-5.195-1.612zm12.092-2.32h.142c.224 0 .632.102 1.141.727.377.463.784 1.119.56 1.582-.458 1.009-3.056 1.482-5.195 1.634.846-1.755 2.16-3.77 3.352-3.942z"
    })));
});
$121e9108006f1dae$export$cc8fab9d3c9e68bd.displayName = 'GiftBold';





var $denZA = parcelRequire("denZA");
var $3a6eaf59d27c4565$var$__assign = undefined && undefined.__assign || function() {
    $3a6eaf59d27c4565$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a6eaf59d27c4565$var$__assign.apply(this, arguments);
};
var $3a6eaf59d27c4565$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a6eaf59d27c4565$export$630b74b270eecb49 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $3a6eaf59d27c4565$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $3a6eaf59d27c4565$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.75 0a2.25 2.25 0 00-2.22 2.611l-2.74 2.143a2.25 2.25 0 00-2.871.69l-3.42-.915V4.5a2.25 2.25 0 10-4.462.406l-3.384 3.38a2.25 2.25 0 101.336.786L6.824 6.24a2.25 2.25 0 003.153-.299l3.527.943a2.25 2.25 0 104.311-1.03l2.45-1.915A2.25 2.25 0 1021.75 0zM2.542 9.81l.032.014a.75.75 0 11-.032-.014zM21.22 1.72a.75.75 0 111.06 1.06.75.75 0 01-1.06-1.06zM7.564 4.804l.006.014a.75.75 0 10-.006-.014zM15.75 6a.75.75 0 100 1.5.75.75 0 000-1.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9 22.5V10.25A1.25 1.25 0 0110.25 9H13a1.25 1.25 0 011.25 1.25V22.5h2.25v-7.75a1.25 1.25 0 011.248-1.25H20.5a1.25 1.25 0 011.25 1.25v7.75h.75a.75.75 0 110 1.499H.75a.75.75 0 010-1.5h.75v-3.25A1.25 1.25 0 012.75 18H5.5a1.25 1.25 0 011.25 1.25v3.25H9zm1.5 0v-12h2.25v12H10.5zm9.75 0H18V15h2.25v7.5zM3 19.5v3h2.25v-3H3z",
        fillRule: "evenodd"
    })));
});
$3a6eaf59d27c4565$export$630b74b270eecb49.displayName = 'GraphBar';





var $denZA = parcelRequire("denZA");
var $67f135456937ddbe$var$__assign = undefined && undefined.__assign || function() {
    $67f135456937ddbe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67f135456937ddbe$var$__assign.apply(this, arguments);
};
var $67f135456937ddbe$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $67f135456937ddbe$export$2a8b2f6b4dc2a926 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $67f135456937ddbe$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $67f135456937ddbe$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1.25 20.669h3.5c.066 0 .13-.025.177-.07a.236.236 0 00.073-.17v-1.927c0-.532-.448-.963-1-.963H2c-.552 0-1 .43-1 .963v1.926a.246.246 0 00.25.24zM8 12.722c-.552 0-1 .432-1 .964v6.742a.246.246 0 00.25.24h3.5a.248.248 0 00.177-.07.236.236 0 00.073-.17v-6.742c0-.532-.448-.964-1-.964H8zm6 1.927c-.552 0-1 .431-1 .963v4.816a.246.246 0 00.25.24h3.5a.248.248 0 00.177-.07.235.235 0 00.073-.17v-4.816c0-.532-.448-.963-1-.963h-2zm6-6.743c-.552 0-1 .432-1 .964v11.558a.246.246 0 00.25.24h3.5a.248.248 0 00.177-.07.236.236 0 00.073-.17V8.87c0-.532-.448-.964-1-.964h-2zM21 .2a2.03 2.03 0 00-1.568.732 1.872 1.872 0 00-.378 1.638.238.238 0 01-.054.213l-3.258 3.66c-.062.07-.16.1-.252.077-.16-.04-.325-.06-.49-.058a2.04 2.04 0 00-1.417.569.254.254 0 01-.256.058l-2.178-.699a.245.245 0 01-.169-.192c-.148-1-1.072-1.72-2.117-1.65-1.046.069-1.859.904-1.863 1.914 0 .15.018.3.055.446a.236.236 0 01-.084.241l-2.9 2.331a.263.263 0 01-.262.036 2.052 2.052 0 00-2.332.513 1.87 1.87 0 00-.153 2.3c.483.714 1.397 1.038 2.245.795C4.418 12.882 5 12.13 5 11.278c0-.15-.018-.3-.054-.446a.236.236 0 01.083-.241l2.9-2.331a.258.258 0 01.261-.036c.757.321 1.641.16 2.224-.405a.257.257 0 01.257-.058l2.177.697c.089.03.153.104.168.193.133 1.013 1.064 1.75 2.12 1.68 1.058-.07 1.875-.922 1.864-1.943a1.84 1.84 0 00-.16-.752.235.235 0 01.041-.252l3.044-3.421a.256.256 0 01.288-.065c.746.308 1.611.15 2.19-.398.578-.549.755-1.38.447-2.103C22.542.674 21.812.201 21 .201zM1 23.8h22c.552 0 1-.432 1-.964s-.448-.963-1-.963H1c-.552 0-1 .431-1 .963s.448.963 1 .963z"
    })));
});
$67f135456937ddbe$export$2a8b2f6b4dc2a926.displayName = 'GraphBarBold';





var $denZA = parcelRequire("denZA");
var $c487e74f74f92cd3$var$__assign = undefined && undefined.__assign || function() {
    $c487e74f74f92cd3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c487e74f74f92cd3$var$__assign.apply(this, arguments);
};
var $c487e74f74f92cd3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c487e74f74f92cd3$export$357400b174a17c2b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c487e74f74f92cd3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c487e74f74f92cd3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18.375 16.875a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zm.208 1.437a.378.378 0 01-.281.056.376.376 0 11.281-.056z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M5.25 17.25a.75.75 0 000 1.5H9a.75.75 0 000-1.5H5.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.878.75h10.245a3.75 3.75 0 013.65 2.894L23.85 16.75a5.249 5.249 0 01-5.099 6.5H5.25a5.25 5.25 0 01-5.1-6.5L3.228 3.645A3.75 3.75 0 016.878.75zm15.523 16.394l-.01-.042a3.75 3.75 0 00-3.641-2.852H5.25a3.75 3.75 0 00-3.64 2.852l-.01.042a3.75 3.75 0 003.65 4.606h13.5a3.75 3.75 0 003.655-4.589l-.004-.017zM19.313 3.986l2.248 9.58a5.25 5.25 0 00-2.811-.816H5.25a5.25 5.25 0 00-2.811.816l2.248-9.58A2.25 2.25 0 016.878 2.25h10.245a2.25 2.25 0 012.19 1.736z",
        fillRule: "evenodd"
    })));
});
$c487e74f74f92cd3$export$357400b174a17c2b.displayName = 'HardDrive';





var $denZA = parcelRequire("denZA");
var $d8d5eb515e2ae34c$var$__assign = undefined && undefined.__assign || function() {
    $d8d5eb515e2ae34c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d8d5eb515e2ae34c$var$__assign.apply(this, arguments);
};
var $d8d5eb515e2ae34c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d8d5eb515e2ae34c$export$e5ddf9eeef482b70 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d8d5eb515e2ae34c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d8d5eb515e2ae34c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.5 15.251v4a2.007 2.007 0 002 2h19a2.006 2.006 0 002-2v-4a2.005 2.005 0 00-2-2h-19a2.006 2.006 0 00-2 2zm19.5-1a1 1 0 110 2 1 1 0 010-2zm.5 3.249h-17a.75.75 0 000 1.5h17a.75.75 0 000-1.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M2.5 11.751h19c.46 0 .917.094 1.34.276a.25.25 0 00.34-.291l-1.69-6.673a3.213 3.213 0 00-2.99-2.312h-13a3.213 3.213 0 00-2.989 2.312L.82 11.736a.249.249 0 00.34.291c.423-.182.88-.276 1.34-.276z"
    })));
});
$d8d5eb515e2ae34c$export$e5ddf9eeef482b70.displayName = 'HardDriveBold';





var $denZA = parcelRequire("denZA");
var $291c79d430f98123$var$__assign = undefined && undefined.__assign || function() {
    $291c79d430f98123$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $291c79d430f98123$var$__assign.apply(this, arguments);
};
var $291c79d430f98123$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $291c79d430f98123$export$51def8c33e56fa36 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $291c79d430f98123$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $291c79d430f98123$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.632 22.5a1.115 1.115 0 01-.774-.322l-8.53-8.535a9.044 9.044 0 01-1.325-1.749A7.04 7.04 0 01.782 5.05a6.533 6.533 0 015.344-3.53h.231a5.944 5.944 0 015.676 3.016A6.03 6.03 0 0117.58 1.52h.19a6.607 6.607 0 015.426 3.62 6.93 6.93 0 01-.151 6.754 8.834 8.834 0 01-1.346 1.76l-9.323 8.574c-.203.183-.47.28-.743.271zM6.739 2.997h-.492a4.94 4.94 0 00-4.13 2.744 5.511 5.511 0 00.172 5.429c.311.52.678 1.006 1.095 1.447l8.268 8.263 8.97-8.273a7.59 7.59 0 001.086-1.438 5.41 5.41 0 00.15-5.327 5.025 5.025 0 00-4.169-2.775h-.05a4.609 4.609 0 00-4.792 3.308.875.875 0 01-.854.573.904.904 0 01-.854-.654 4.403 4.403 0 00-4.4-3.297z"
    })));
});
$291c79d430f98123$export$51def8c33e56fa36.displayName = 'Heart';





var $denZA = parcelRequire("denZA");
var $1dd0bdfe8709bdef$var$__assign = undefined && undefined.__assign || function() {
    $1dd0bdfe8709bdef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1dd0bdfe8709bdef$var$__assign.apply(this, arguments);
};
var $1dd0bdfe8709bdef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1dd0bdfe8709bdef$export$e9f132cc38a714f1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1dd0bdfe8709bdef$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1dd0bdfe8709bdef$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.76 13.284a8.787 8.787 0 001.301-1.699 6.478 6.478 0 00-1.886-8.709c-.906-.62-1.956-1-3.05-1.106h-.13a5.744 5.744 0 00-3.687 1.052 5.727 5.727 0 00-2.2 3.136.11.11 0 01-.22 0 5.587 5.587 0 00-2.184-3.177 5.604 5.604 0 00-3.724-1.01h-.21A6.465 6.465 0 00.654 5.353a6.437 6.437 0 00.32 6.231 8.996 8.996 0 001.292 1.7l8.72 8.705a.942.942 0 001.302 0l9.472-8.706z"
    })));
});
$1dd0bdfe8709bdef$export$e9f132cc38a714f1.displayName = 'HeartBold';





var $denZA = parcelRequire("denZA");
var $9e9201b80f29b957$var$__assign = undefined && undefined.__assign || function() {
    $9e9201b80f29b957$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9e9201b80f29b957$var$__assign.apply(this, arguments);
};
var $9e9201b80f29b957$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9e9201b80f29b957$export$84202caead5689ba = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9e9201b80f29b957$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9e9201b80f29b957$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M17.987 10.543v-.789h1.508A.76.76 0 0020.248 9a.76.76 0 00-.753-.754h-4.506a.76.76 0 00-.754.754.76.76 0 00.754.754h1.508v.789c-3.375.377-5.996 3.24-5.996 6.703 0 3.72 3.032 6.754 6.75 6.754C20.967 24 24 20.966 24 17.246a6.782 6.782 0 00-6.013-6.703zm-.754 11.948a5.244 5.244 0 01-5.242-5.245A5.244 5.244 0 0117.233 12a5.244 5.244 0 015.242 5.246 5.244 5.244 0 01-5.242 5.245z"
    }), $denZA.createElement("path", {
        d: "M19.272 17.246h-1.285v-3a.76.76 0 00-.754-.755.76.76 0 00-.753.755V18a.76.76 0 00.753.754h2.039a.76.76 0 00.754-.754.76.76 0 00-.754-.754zM8.24 15.754H1.884a.38.38 0 01-.377-.377V5.246h17.234V6a.76.76 0 00.754.754.76.76 0 00.753-.754V1.869C20.231.84 19.392 0 18.381 0H1.884A1.865 1.865 0 000 1.869v13.525a1.898 1.898 0 001.884 1.869h6.373a.76.76 0 00.754-.754c0-.412-.36-.755-.771-.755zM1.867 1.51h16.48c.205 0 .377.171.377.36v1.885H1.507V1.87c0-.206.155-.36.36-.36z"
    })));
});
$9e9201b80f29b957$export$84202caead5689ba.displayName = 'History';





var $denZA = parcelRequire("denZA");
var $61e750067bd7fc91$var$__assign = undefined && undefined.__assign || function() {
    $61e750067bd7fc91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61e750067bd7fc91$var$__assign.apply(this, arguments);
};
var $61e750067bd7fc91$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $61e750067bd7fc91$export$e3e58178368f2952 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $61e750067bd7fc91$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $61e750067bd7fc91$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.014 19.833A6.75 6.75 0 0017.25 24 6.758 6.758 0 0024 17.251a6.75 6.75 0 10-12.986 2.582zM12.5 17.25a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M19.25 18.251h-2a1 1 0 01-1-1v-2.5a1 1 0 112 0V16c0 .138.112.25.25.25h.75a1 1 0 110 2.001z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.3 18.5a.968.968 0 01.946.722l.004.022A1 1 0 018.3 20.5H3a3 3 0 01-3-3V3a3 3 0 013-3h18a3 3 0 013 3v7.049a.983.983 0 01-1.59.777l-.022-.018a1 1 0 01-.388-.777V5.25a.25.25 0 00-.25-.25H2.25a.25.25 0 00-.25.251V17.5a1 1 0 001 1h5.3zm2.2-17a.966.966 0 00-.846.5.969.969 0 00-.154.5c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.969.969 0 00-.154-.5.966.966 0 00-.846-.5zM6.154 2a.966.966 0 011.692 0A.97.97 0 018 2.5a.972.972 0 01-.154.5.966.966 0 01-1.692 0A.972.972 0 016 2.5a.969.969 0 01.154-.5zM3.5 1.5a1 1 0 00-.908.591.992.992 0 00-.092.409c.005.178.058.35.154.5a.966.966 0 001.692 0 .972.972 0 00.154-.5.97.97 0 00-.154-.5.983.983 0 00-.846-.5z",
        fillRule: "evenodd"
    })));
});
$61e750067bd7fc91$export$e3e58178368f2952.displayName = 'HistoryBold';





var $denZA = parcelRequire("denZA");
var $f40f920260f48c8f$var$__assign = undefined && undefined.__assign || function() {
    $f40f920260f48c8f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f40f920260f48c8f$var$__assign.apply(this, arguments);
};
var $f40f920260f48c8f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f40f920260f48c8f$export$b94310965bed44e6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f40f920260f48c8f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f40f920260f48c8f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.516 13.37c.388 0 .703.316.703.704v7.031h4.218v-4.922a2.11 2.11 0 012.11-2.11h1.406a2.11 2.11 0 012.11 2.11v4.922h4.218v-7.031a.703.703 0 011.407 0v7.734a.703.703 0 01-.704.703H14.36a.703.703 0 01-.703-.703v-5.625a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v5.625a.703.703 0 01-.703.703H4.516a.703.703 0 01-.704-.703v-7.734c0-.389.315-.703.704-.703z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.25 3.406a.703.703 0 00-.497.206L2.2 13.165a.703.703 0 11-.994-.995l9.552-9.552a2.11 2.11 0 012.984 0l9.552 9.552a.703.703 0 01-.994.995l-9.553-9.553a.703.703 0 00-.497-.206z",
        fillRule: "evenodd"
    })));
});
$f40f920260f48c8f$export$b94310965bed44e6.displayName = 'Home';





var $denZA = parcelRequire("denZA");
var $06f75fd1b4b6627c$var$__assign = undefined && undefined.__assign || function() {
    $06f75fd1b4b6627c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06f75fd1b4b6627c$var$__assign.apply(this, arguments);
};
var $06f75fd1b4b6627c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $06f75fd1b4b6627c$export$611e0072bc063769 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $06f75fd1b4b6627c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $06f75fd1b4b6627c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.933 11.288l-9.55-9.56a2.48 2.48 0 00-3.51 0l-9.56 9.56a1.08 1.08 0 00.76 1.84h1.73v8.06a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.11-1.08v-5.63a.33.33 0 01.33-.33h3.37a.33.33 0 01.33.33v5.63a1.08 1.08 0 001.08 1.08h4.63a1.08 1.08 0 001.08-1.08v-8.06h1.76a1.08 1.08 0 00.73-1.84z"
    })));
});
$06f75fd1b4b6627c$export$611e0072bc063769.displayName = 'HomeBold';





var $denZA = parcelRequire("denZA");
var $48f874ef4a60429f$var$__assign = undefined && undefined.__assign || function() {
    $48f874ef4a60429f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $48f874ef4a60429f$var$__assign.apply(this, arguments);
};
var $48f874ef4a60429f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $48f874ef4a60429f$export$25513f6e9c35561f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $48f874ef4a60429f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $48f874ef4a60429f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M16.827 9.764a4.867 4.867 0 004.503-3.016 4.89 4.89 0 00-1.06-5.322A4.87 4.87 0 0014.954.375a4.875 4.875 0 00-3.002 4.517 4.886 4.886 0 001.431 3.446 4.869 4.869 0 003.443 1.426zm0-8.253a3.37 3.37 0 013.125 2.08 3.387 3.387 0 01-.725 3.689 3.373 3.373 0 01-5.766-2.388 3.374 3.374 0 012.075-3.124 3.36 3.36 0 011.29-.257zm-4.105 16.507H9.647v-.22a3.752 3.752 0 00-3.685-2.781H1.488v-.85a.75.75 0 00-.79-.63.748.748 0 00-.698.73v9.103a.75.75 0 001.28.4.751.751 0 00.208-.5v-.75h14.33a.749.749 0 00.65-.74v-.2a3.754 3.754 0 00-1.162-2.531 3.741 3.741 0 00-2.584-1.031zM1.488 21.019v-4.502h4.644a2.244 2.244 0 011.997 1.49H5.882a.753.753 0 00-.714.796.757.757 0 00.794.715h6.89a2.245 2.245 0 011.918 1.371v.13H1.488z"
    }), $denZA.createElement("path", {
        d: "M23.937 14.766a7.502 7.502 0 00-2.738-3.623 7.48 7.48 0 00-8.645 0 7.502 7.502 0 00-2.738 3.623.751.751 0 001.02.888.75.75 0 00.389-.387 6 6 0 012.189-2.907 5.984 5.984 0 019.115 2.907.752.752 0 00.67.55.748.748 0 00.738-1.05z"
    })));
});
$48f874ef4a60429f$export$25513f6e9c35561f.displayName = 'HumanResourcesOfferMan';





var $denZA = parcelRequire("denZA");
var $585aaad7d0182419$var$__assign = undefined && undefined.__assign || function() {
    $585aaad7d0182419$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $585aaad7d0182419$var$__assign.apply(this, arguments);
};
var $585aaad7d0182419$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $585aaad7d0182419$export$a853083deadc2998 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $585aaad7d0182419$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $585aaad7d0182419$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.856 3.919c0 1.983-1.674 3.59-3.74 3.59-2.066 0-3.741-1.607-3.741-3.59 0-1.984 1.675-3.591 3.74-3.591 2.067 0 3.741 1.607 3.741 3.59zm-3.74 4.897c-2.73 0-5.129 1.74-5.877 4.26a.238.238 0 00.042.213.255.255 0 00.202.098h11.264c.08 0 .154-.037.202-.098a.235.235 0 00.041-.213c-.748-2.52-3.145-4.258-5.874-4.26zM1.013 14.675c-.56 0-1.013.436-1.013.973V22.7c0 .537.454.972 1.013.972.56 0 1.013-.435 1.013-.972v-7.052c0-.537-.453-.973-1.013-.973zm14.691 4.62H6.46a.621.621 0 01-.633-.608.62.62 0 01.633-.607h2.56c.34 0 .658-.164.846-.437a.94.94 0 00.085-.92c-.356-.8-1.176-1.32-2.084-1.318h-4.32a.497.497 0 00-.506.486v6.322c0 .269.226.487.506.487h10.906c1.25-.002 2.264-.975 2.266-2.176v-.256c0-.537-.454-.973-1.014-.973z"
    })));
});
$585aaad7d0182419$export$a853083deadc2998.displayName = 'HumanResourcesOfferManBold';





var $denZA = parcelRequire("denZA");
var $74516e38ccae2f20$var$__assign = undefined && undefined.__assign || function() {
    $74516e38ccae2f20$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $74516e38ccae2f20$var$__assign.apply(this, arguments);
};
var $74516e38ccae2f20$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $74516e38ccae2f20$export$ad52482257e413dd = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $74516e38ccae2f20$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $74516e38ccae2f20$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.75.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0V.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5.578 15.171a7.35 7.35 0 002.672 2.576V19.5a2.25 2.25 0 002.25 2.25h.75v1.5a.75.75 0 001.5 0v-1.5h.75a2.25 2.25 0 002.25-2.25v-1.753a7.35 7.35 0 003.75-6.507v-.003a7.624 7.624 0 00-7.513-7.487A7.623 7.623 0 004.5 11.241v.003a7.35 7.35 0 001.078 3.928zM13.5 20.25a.75.75 0 00.75-.75V18h-4.5v1.5a.75.75 0 00.75.75h3zM9.097 16.5h2.153v-2.69l-2.03-2.03a.75.75 0 111.06-1.06L12 12.44l1.72-1.72a.75.75 0 111.06 1.06l-2.03 2.03v2.69h2.153A5.85 5.85 0 0018 11.262a6.123 6.123 0 00-6-6.012 6.123 6.123 0 00-6 6.015A5.85 5.85 0 009.097 16.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M.75 11.25a.75.75 0 01.75-.75H3A.75.75 0 013 12H1.5a.75.75 0 01-.75-.75zm3.52-8.04a.75.75 0 00-1.04 1.08l1.1 1.058a.75.75 0 001.04-1.082L4.27 3.21zm15.98 8.04a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H21a.75.75 0 01-.75-.75zm.52-6.96a.75.75 0 10-1.04-1.08l-1.1 1.056a.75.75 0 001.04 1.082l1.1-1.057z"
    })));
});
$74516e38ccae2f20$export$ad52482257e413dd.displayName = 'Ideas';





var $denZA = parcelRequire("denZA");
var $0c37a4d964870631$var$__assign = undefined && undefined.__assign || function() {
    $0c37a4d964870631$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c37a4d964870631$var$__assign.apply(this, arguments);
};
var $0c37a4d964870631$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0c37a4d964870631$export$f7545e2d7d9761e3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0c37a4d964870631$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0c37a4d964870631$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.025 3.737a7.598 7.598 0 00-5.254 2.226 7.62 7.62 0 00-2.23 5.259 7.352 7.352 0 003.742 6.495h7.484a7.339 7.339 0 003.742-6.505 7.62 7.62 0 00-2.233-5.253 7.598 7.598 0 00-5.251-2.222zm-.748 12.74V13.86L9.56 12.08c-.389-.389-.758-.998-.369-1.378a.79.79 0 011.218.09l1.616 1.629 1.477-1.53c.389-.389.908-.579 1.297-.19.39.39.23.83-.16 1.22l-1.866 1.869v2.688h-1.496zm-2.994 1.989v1a2.25 2.25 0 002.245 2.247h.5v1.27a1 1 0 00.658.929.678.678 0 00.668 0 .998.998 0 00.669-.93v-1.258h.499a2.244 2.244 0 002.245-2.249v-.999H8.283v-.01zm3.742-15.129a.997.997 0 00.998-.999V1a1 1 0 00-.998-1 .997.997 0 00-.998 1v1.398a1 1 0 00.998.95v-.01zm8.9-.249a.997.997 0 00-1.406 0l-.998.999a.998.998 0 101.377 1.439l.998-1a.998.998 0 000-1.438h.03zM5.57 5.436a1 1 0 00-.03-1.439l-.999-1a1.03 1.03 0 10-1.396 1.52l.997.999a.997.997 0 001.407 0l.02-.08zm16.832 4.666h-1.397a.997.997 0 00-.997 1 1 1 0 00.997.999h1.397a.997.997 0 00.998-1 1 1 0 00-.998-.999zm-20.804.13a.997.997 0 00-.998 1 1 1 0 00.998.999h1.447a.997.997 0 00.998-1 1 1 0 00-.998-.999H1.598z"
    })));
});
$0c37a4d964870631$export$f7545e2d7d9761e3.displayName = 'IdeasBold';





var $denZA = parcelRequire("denZA");
var $06ef2ad6b1aafb38$var$__assign = undefined && undefined.__assign || function() {
    $06ef2ad6b1aafb38$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $06ef2ad6b1aafb38$var$__assign.apply(this, arguments);
};
var $06ef2ad6b1aafb38$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $06ef2ad6b1aafb38$export$3e431a229df88919 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $06ef2ad6b1aafb38$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $06ef2ad6b1aafb38$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.06 11.18a2.52 2.52 0 01-2.33-1.57c-.13-.3-.2-.63-.19-.97 0-.67.27-1.31.74-1.78.48-.45 1.12-.71 1.78-.71.66 0 1.3.25 1.78.71a2.52 2.52 0 01.55 2.74c-.13.3-.31.58-.55.82-.47.48-1.11.75-1.78.76zm0-3.54a.99.99 0 00-1 1 1.046 1.046 0 00.3.72c.19.18.45.28.72.28.27 0 .53-.1.72-.28.1-.09.17-.21.23-.33.05-.12.08-.26.08-.39 0-.14-.03-.27-.08-.39-.06-.12-.13-.23-.23-.33s-.21-.17-.34-.22c-.13-.04-.26-.06-.4-.06zm8.28 10.18a.73.73 0 01-.35-.09.78.78 0 01-.27-.24l-3.09-4.63-2.19 3c-.06.08-.13.16-.22.21-.09.05-.19.09-.29.1-.1.02-.2.01-.3-.01a.698.698 0 01-.27-.14l-1.31-1-1.73 2.5c-.12.17-.29.28-.49.31-.2.03-.41-.01-.57-.13a.726.726 0 01-.31-.49c-.03-.2.01-.4.13-.57l1.68-2.48c.12-.18.28-.33.46-.44.18-.12.39-.2.6-.23.21-.04.42-.04.63 0 .21.06.4.15.57.29l.68.55 1.66-2.37c.14-.21.34-.37.56-.49.22-.12.47-.17.72-.17s.5.07.72.19c.22.12.41.29.55.5l3.06 4.65c.1.16.13.35.1.54a.75.75 0 01-.3.46c-.13.1-.28.16-.43.18z"
    }), $denZA.createElement("path", {
        d: "M22.2 1.5c.17 0 .3.14.3.3v20.4a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h20.4zm0-1.5H1.8C.81 0 0 .81 0 1.8v20.4c0 1 .81 1.8 1.8 1.8h20.4c1 0 1.8-.81 1.8-1.8V1.8c0-.99-.81-1.8-1.8-1.8z"
    })));
});
$06ef2ad6b1aafb38$export$3e431a229df88919.displayName = 'Image';





var $denZA = parcelRequire("denZA");
var $449568e269e023fa$var$__assign = undefined && undefined.__assign || function() {
    $449568e269e023fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $449568e269e023fa$var$__assign.apply(this, arguments);
};
var $449568e269e023fa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $449568e269e023fa$export$80e446007408666a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $449568e269e023fa$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $449568e269e023fa$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.2 24H1.8c-1 0-1.8-.81-1.8-1.8V1.8C0 .81.81 0 1.8 0h20.4c1 0 1.8.81 1.8 1.8v20.4c0 .99-.81 1.8-1.8 1.8zM10.84 10.42c.24-.23.42-.51.55-.82a2.52 2.52 0 00-.55-2.74 2.57 2.57 0 00-1.78-.71c-.66 0-1.3.25-1.78.71a2.539 2.539 0 00-.55 2.75c.13.31.32.59.55.83.47.47 1.11.74 1.78.74a2.54 2.54 0 001.78-.76zM9.46 7.71c.13.04.24.12.34.21a.979.979 0 01.31.72.979.979 0 01-.31.72c-.2.19-.45.29-.72.29-.27 0-.53-.1-.72-.28a.911.911 0 01-.22-.33 1.033 1.033 0 01.21-1.11.99.99 0 01.71-.29c.14 0 .27.02.4.07zm8.3 9.93c.15-.11.26-.28.3-.46a.73.73 0 00-.1-.54l-3.06-4.65c-.14-.21-.33-.38-.55-.5-.22-.12-.47-.19-.72-.19s-.5.06-.72.17c-.22.11-.41.28-.56.49l-1.66 2.37-.68-.55c-.17-.14-.36-.23-.57-.29-.21-.04-.42-.04-.63 0-.21.03-.42.11-.6.23-.18.11-.34.26-.46.44l-1.68 2.48c-.12.16-.16.37-.13.57.03.2.15.38.31.49.17.12.37.16.57.13.2-.04.38-.15.49-.31l1.73-2.5 1.31 1c.08.06.17.11.27.14.1.02.2.03.3.01.1-.01.2-.05.29-.1.09-.05.16-.13.22-.21l2.19-3 3.09 4.63c.07.1.16.19.27.24.11.06.23.09.35.09.16-.02.31-.08.43-.18z"
    })));
});
$449568e269e023fa$export$80e446007408666a.displayName = 'ImageBold';





var $denZA = parcelRequire("denZA");
var $50ea40edf67a855a$var$__assign = undefined && undefined.__assign || function() {
    $50ea40edf67a855a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $50ea40edf67a855a$var$__assign.apply(this, arguments);
};
var $50ea40edf67a855a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $50ea40edf67a855a$export$8e490a61da06a81 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $50ea40edf67a855a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $50ea40edf67a855a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.1 10.05c-.67 0-1.31-.27-1.78-.74-.23-.24-.42-.52-.55-.83a2.52 2.52 0 01.55-2.75 2.57 2.57 0 011.78-.71c.66 0 1.3.25 1.78.71a2.52 2.52 0 01.55 2.74 2.583 2.583 0 01-2.33 1.58zm0-3.54c-.27 0-.52.1-.71.29-.18.19-.29.44-.29.71 0 .13.03.27.08.39s.13.23.22.33c.2.18.46.28.72.28.27 0 .53-.1.72-.28.1-.09.17-.21.23-.33.05-.12.08-.26.08-.39 0-.14-.03-.27-.08-.39s-.13-.23-.23-.33a.949.949 0 00-.74-.28zm8.28 10.18a.73.73 0 01-.35-.09.78.78 0 01-.27-.24l-3.09-4.63-2.19 3c-.06.08-.13.16-.22.21-.09.05-.19.09-.29.1-.1.02-.2.01-.3-.01a.698.698 0 01-.27-.14l-1.31-1-1.73 2.5c-.12.17-.29.28-.49.31-.2.03-.41-.01-.57-.13a.726.726 0 01-.31-.49c-.03-.2.01-.4.13-.57l1.68-2.48c.12-.18.28-.33.46-.44.18-.12.39-.2.6-.23.21-.04.42-.04.63 0 .21.06.4.15.57.29l.68.55 1.66-2.37c.14-.21.34-.37.56-.49.22-.12.47-.17.72-.17s.5.07.72.19c.22.12.41.29.55.5L17 15.51c.1.16.13.35.1.54a.75.75 0 01-.3.46c-.12.1-.26.16-.42.18z"
    }), $denZA.createElement("path", {
        d: "M19.92 1.5c.17 0 .3.14.3.3v18.12a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h18.12zm0-1.5H1.8C.81 0 0 .81 0 1.8v18.12c0 1 .81 1.8 1.8 1.8h18.12c1 0 1.8-.81 1.8-1.8V1.8c.01-.99-.8-1.8-1.8-1.8z"
    }), $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    })));
});
$50ea40edf67a855a$export$8e490a61da06a81.displayName = 'ImageMulti';





var $denZA = parcelRequire("denZA");
var $c7bb16165d295ca0$var$__assign = undefined && undefined.__assign || function() {
    $c7bb16165d295ca0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7bb16165d295ca0$var$__assign.apply(this, arguments);
};
var $c7bb16165d295ca0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c7bb16165d295ca0$export$8b255b05c5b33d0b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c7bb16165d295ca0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c7bb16165d295ca0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.1 10.05c-.67 0-1.31-.27-1.78-.74-.23-.24-.42-.52-.55-.83a2.52 2.52 0 01.55-2.75 2.57 2.57 0 011.78-.71c.66 0 1.3.25 1.78.71a2.52 2.52 0 01.55 2.74 2.583 2.583 0 01-2.33 1.58zm0-3.54c-.27 0-.52.1-.71.29-.18.19-.29.44-.29.71 0 .13.03.27.08.39s.13.23.22.33c.2.18.46.28.72.28.27 0 .53-.1.72-.28.1-.09.17-.21.23-.33.05-.12.08-.26.08-.39a1.006 1.006 0 00-.65-.94.887.887 0 00-.4-.06zm8.28 10.18a.73.73 0 01-.35-.09.78.78 0 01-.27-.24l-3.09-4.63-2.19 3c-.06.08-.13.16-.22.21-.09.05-.19.09-.29.1-.1.02-.2.01-.3-.01a.867.867 0 01-.27-.14l-1.31-1-1.73 2.5c-.12.17-.29.28-.49.31-.2.03-.41-.01-.57-.13a.726.726 0 01-.31-.49c-.03-.2.01-.4.13-.57l1.68-2.48c.12-.18.28-.33.46-.44.18-.12.39-.2.6-.23.21-.04.42-.04.63 0 .21.06.4.15.57.29l.68.55 1.66-2.37c.14-.21.34-.37.56-.49.22-.12.47-.17.72-.17s.5.07.72.19c.22.12.41.29.55.5L17 15.51c.1.16.13.35.1.54a.75.75 0 01-.3.46c-.12.1-.26.16-.42.18zM19.92 0H1.8C.81 0 0 .81 0 1.8v18.12c0 1 .81 1.8 1.8 1.8h18.12c1 0 1.8-.81 1.8-1.8V1.8c.01-.99-.8-1.8-1.8-1.8z"
    }), $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    })));
});
$c7bb16165d295ca0$export$8b255b05c5b33d0b.displayName = 'ImageMultiBold';





var $denZA = parcelRequire("denZA");
var $1c08c6b2f4a77b26$var$__assign = undefined && undefined.__assign || function() {
    $1c08c6b2f4a77b26$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c08c6b2f4a77b26$var$__assign.apply(this, arguments);
};
var $1c08c6b2f4a77b26$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1c08c6b2f4a77b26$export$ce4fe1c9e6520c1a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1c08c6b2f4a77b26$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1c08c6b2f4a77b26$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.893 10.354l-2.497 3.202v-2.745a.746.746 0 00-.746-.746H1.492V1.522h11.935v4.445a.745.745 0 001.422 0V.776A.756.756 0 0014.143 0H.746A.756.756 0 000 .776V10.81a.756.756 0 00.746.746h2.168v4.197a.746.746 0 00.508.706.67.67 0 00.238 0 .716.716 0 00.587-.288l3.8-4.973a.745.745 0 10-1.154-.845z"
    }), $denZA.createElement("path", {
        d: "M22.985 7.519H9.588a.756.756 0 00-.706.746V18.3a.756.756 0 00.746.746h6.335l3.56 4.655a.757.757 0 00.598.288c.079.015.16.015.238 0a.746.746 0 00.507-.706v-4.237h2.159a.756.756 0 00.746-.746V8.265a.756.756 0 00-.786-.746zm-.746 10.035h-2.158a.746.746 0 00-.746.746v2.745l-2.497-3.202a.748.748 0 00-.586-.289h-5.968V9.011H22.22l.02 8.543zM6.107 2.477a2.089 2.089 0 00-2.079 2.078V7.54a.746.746 0 101.492 0v-.507h1.184v.537a.746.746 0 001.492 0V4.585a2.089 2.089 0 00-2.089-2.108zM5.52 5.54v-.995a.577.577 0 01.587-.567.587.587 0 01.597.587v.995L5.52 5.54z"
    }), $denZA.createElement("path", {
        d: "M13.765 12.69h2.755a7.747 7.747 0 01-3.063 2.567.746.746 0 00.627 1.353 9.429 9.429 0 002.158-1.393 8.952 8.952 0 002.983 1.661.81.81 0 00.22 0 .756.756 0 00.715-.527.747.747 0 00-.497-.925 7.42 7.42 0 01-2.407-1.313 8.85 8.85 0 00.726-.995.796.796 0 00.1-.477h1.74a.746.746 0 000-1.492h-2.307v-.746a.746.746 0 00-1.492 0v.746h-2.258a.746.746 0 000 1.492v.05z"
    })));
});
$1c08c6b2f4a77b26$export$ce4fe1c9e6520c1a.displayName = 'Language';





var $denZA = parcelRequire("denZA");
var $c9f195b766709acb$var$__assign = undefined && undefined.__assign || function() {
    $c9f195b766709acb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9f195b766709acb$var$__assign.apply(this, arguments);
};
var $c9f195b766709acb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c9f195b766709acb$export$9e5b30e2ac09b04a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c9f195b766709acb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c9f195b766709acb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.571 3.538a.336.336 0 00-.24.103.356.356 0 00-.1.247v.692h.701v-.692a.37.37 0 00-.11-.252.35.35 0 00-.25-.098z"
    }), $denZA.createElement("path", {
        d: "M15.72 6.142V.67a.689.689 0 00-.195-.477.65.65 0 00-.467-.193H.34a.336.336 0 00-.238.1A.355.355 0 000 .34V11.8c0 .092.036.181.1.247s.15.103.24.103h2.738c.087 0 .172.036.234.1.062.063.097.15.097.24v3.775a.642.642 0 00.112.372c.075.108.182.19.304.232a.595.595 0 00.378.003.612.612 0 00.308-.225l3.008-4.023c.22-.297.342-.658.35-1.031V8.091c.003-.338.135-.662.368-.901.232-.24.547-.375.876-.378h5.945c.173 0 .34-.07.464-.195a.69.69 0 00.197-.475zm-9.294.284a.793.793 0 01-.22.547.75.75 0 01-.532.226.734.734 0 01-.531-.226.775.775 0 01-.22-.547v-.3H4.23v.3a.79.79 0 01-.22.547.741.741 0 01-.532.226.74.74 0 01-.532-.226.785.785 0 01-.22-.547V4.033a2.04 2.04 0 01.413-1.334 1.934 1.934 0 011.16-.729 1.812 1.812 0 011.498.449 1.909 1.909 0 01.628 1.469v2.538z"
    }), $denZA.createElement("path", {
        d: "M23.258 8.425H10.135a.731.731 0 00-.524.223.775.775 0 00-.218.54v9.726c0 .202.079.397.218.54a.731.731 0 00.524.223h6.426a.265.265 0 01.221.114l2.947 3.96a.605.605 0 00.707.21.625.625 0 00.304-.248.653.653 0 00.102-.385v-3.352a.297.297 0 01.079-.21.28.28 0 01.202-.089h2.135c.197 0 .386-.08.525-.223a.775.775 0 00.217-.54V9.188a.775.775 0 00-.217-.54.731.731 0 00-.525-.223zm-3.218 4.981h-1.674a.729.729 0 01-.1.495c-.22.36-.46.704-.722 1.032a7.282 7.282 0 002.426 1.33.747.747 0 01.447.378.789.789 0 01.054.592.764.764 0 01-.267.395.728.728 0 01-.445.151.815.815 0 01-.22 0 8.818 8.818 0 01-3.008-1.732 9.2 9.2 0 01-2.175 1.454.9.9 0 01-.32.072.738.738 0 01-.477-.155.776.776 0 01-.276-.428.794.794 0 01.045-.512.764.764 0 01.346-.37 7.948 7.948 0 003.088-2.66h-2.807c-.2 0-.39-.082-.532-.227a.785.785 0 010-1.094.742.742 0 01.532-.226h2.306v-.774c0-.205.079-.402.22-.547a.741.741 0 01.531-.227c.2 0 .391.082.532.227.141.145.22.342.22.547v.773h2.276c.2 0 .39.082.532.227a.785.785 0 010 1.094.741.741 0 01-.532.227v-.042z"
    })));
});
$c9f195b766709acb$export$9e5b30e2ac09b04a.displayName = 'LanguageBold';





var $denZA = parcelRequire("denZA");
var $a9b22d3022d08cb0$var$__assign = undefined && undefined.__assign || function() {
    $a9b22d3022d08cb0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a9b22d3022d08cb0$var$__assign.apply(this, arguments);
};
var $a9b22d3022d08cb0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a9b22d3022d08cb0$export$bf44615096563be0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a9b22d3022d08cb0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a9b22d3022d08cb0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#laptop-smiley_svg__a)"
    }, $denZA.createElement("path", {
        d: "M10.497 5.5a.75.75 0 00-1.5 0V7a.75.75 0 101.5 0V5.5zm-1.74 4a.75.75 0 10-1 1.11 6.32 6.32 0 008.51 0 .75.75 0 10-1-1.11 4.82 4.82 0 01-6.51 0zm5.49-4.75a.75.75 0 01.75.75V7a.75.75 0 01-1.5 0V5.5a.75.75 0 01.75-.75zm-3.75 12.75a.75.75 0 000 1.5h3a.75.75 0 100-1.5h-3z"
    }), $denZA.createElement("path", {
        d: "M4.497 1a2.25 2.25 0 00-2.25 2.25v11.09l-2.05 4.49A2.25 2.25 0 002.247 22h19.5a2.249 2.249 0 002.06-3.16l-2.06-4.5V3.25A2.25 2.25 0 0019.498 1h-15zm15.75 12.75h-16.5V3.25a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v10.5zm-18.69 5.7l1.92-4.2h17l1.92 4.2a.75.75 0 01-.65 1.05h-19.5a.75.75 0 01-.69-1.05z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "laptop-smiley_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$a9b22d3022d08cb0$export$bf44615096563be0.displayName = 'LaptopSmiley';





var $denZA = parcelRequire("denZA");
var $71e7ddd36fca2705$var$__assign = undefined && undefined.__assign || function() {
    $71e7ddd36fca2705$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71e7ddd36fca2705$var$__assign.apply(this, arguments);
};
var $71e7ddd36fca2705$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $71e7ddd36fca2705$export$c0ab56adda2ec52e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $71e7ddd36fca2705$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $71e7ddd36fca2705$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#laptop-smiley-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M23.793 20.519l-2.043-5.107H2.08L.22 20.366a2.339 2.339 0 002.176 3.33H21.8a2.237 2.237 0 001.992-3.177zm-9.652 0h-4.003a1.021 1.021 0 110-2.043h4.003a1.021 1.021 0 110 2.043z"
    }), $denZA.createElement("path", {
        d: "M21.873 15.79H2.079V3.626a2.717 2.717 0 012.789-2.625h14.217a2.717 2.717 0 012.798 2.635l-.01 12.154zM3.938 14.044h16.086V3.626a.92.92 0 00-.95-.888H4.868a.92.92 0 00-.95.888l.02 10.418z"
    }), $denZA.createElement("path", {
        d: "M9.668 7.773A1.021 1.021 0 018.647 6.75V5.444a1.021 1.021 0 012.042 0v1.307a1.021 1.021 0 01-1.021 1.022zm4.473 0A1.021 1.021 0 0113.12 6.75V5.444a1.021 1.021 0 012.043 0v1.307a1.021 1.021 0 01-1.022 1.022zm-2.635 4.575c-1.694-.102-2.907-.633-4.34-1.542a1.022 1.022 0 011.113-1.695 8.406 8.406 0 003.738 1.195 8.334 8.334 0 003.667-1.226 1.023 1.023 0 011.113 1.716c-1.441.904-2.572 1.437-4.27 1.552h-1.02z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "laptop-smiley-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$71e7ddd36fca2705$export$c0ab56adda2ec52e.displayName = 'LaptopSmileyBold';





var $denZA = parcelRequire("denZA");
var $989fd287f747f87a$var$__assign = undefined && undefined.__assign || function() {
    $989fd287f747f87a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $989fd287f747f87a$var$__assign.apply(this, arguments);
};
var $989fd287f747f87a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $989fd287f747f87a$export$4574c7fd55cd3f3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $989fd287f747f87a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $989fd287f747f87a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-3v3H18a2.25 2.25 0 012.25 2.25V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5a.75.75 0 01.75-.75h3v-.75a.75.75 0 00-.75-.75H6a.75.75 0 00-.75.75V15h3a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 01.75 15h3v-.75A2.25 2.25 0 016 12h5.25V9h-3a.75.75 0 01-.75-.75V.75zM15 7.5v-6H9v6h6zm-13.5 9h6v6h-6v-6zm15 6v-6h6v6h-6z",
        fillRule: "evenodd"
    })));
});
$989fd287f747f87a$export$4574c7fd55cd3f3.displayName = 'LayoutDiagram';





var $denZA = parcelRequire("denZA");
var $45b345375e4ac8cc$var$__assign = undefined && undefined.__assign || function() {
    $45b345375e4ac8cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $45b345375e4ac8cc$var$__assign.apply(this, arguments);
};
var $45b345375e4ac8cc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $45b345375e4ac8cc$export$24a3cfb04e7f826e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $45b345375e4ac8cc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $45b345375e4ac8cc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.25 0a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h2.625v2.625H6a2.625 2.625 0 00-2.625 2.625V15H.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H5.625v-.75A.375.375 0 016 13.875h12a.375.375 0 01.375.375V15H15.75a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-2.625v-.75A2.625 2.625 0 0018 11.625h-4.875V9h2.625a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-7.5z"
    })));
});
$45b345375e4ac8cc$export$24a3cfb04e7f826e.displayName = 'LayoutDiagramBold';





var $denZA = parcelRequire("denZA");
var $a3f3e1159b7e11dd$var$__assign = undefined && undefined.__assign || function() {
    $a3f3e1159b7e11dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a3f3e1159b7e11dd$var$__assign.apply(this, arguments);
};
var $a3f3e1159b7e11dd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a3f3e1159b7e11dd$export$f90ad0f3c590b2cb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a3f3e1159b7e11dd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a3f3e1159b7e11dd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9A.75.75 0 010 9.75v-9zm1.5.75V9H9V1.5H1.5zM0 14.25a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75v7.5H9V15H1.5zM13.5.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zm1.5.75V9h7.5V1.5H15zm-1.5 12.75a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM15 15v7.5h7.5V15H15z",
        fillRule: "evenodd"
    })));
});
$a3f3e1159b7e11dd$export$f90ad0f3c590b2cb.displayName = 'LayoutGridView';





var $denZA = parcelRequire("denZA");
var $93288988b573dec2$var$__assign = undefined && undefined.__assign || function() {
    $93288988b573dec2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $93288988b573dec2$var$__assign.apply(this, arguments);
};
var $93288988b573dec2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $93288988b573dec2$export$3eb98c9b2991c13c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $93288988b573dec2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $93288988b573dec2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9zM13.5.773a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v8.974a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75V.773zm0 13.474a.75.75 0 01.75-.75h9a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 01-.75-.75v-9z",
        fillRule: "evenodd"
    })));
});
$93288988b573dec2$export$3eb98c9b2991c13c.displayName = 'LayoutGridViewBold';





var $denZA = parcelRequire("denZA");
var $23170ea9cc06976f$var$__assign = undefined && undefined.__assign || function() {
    $23170ea9cc06976f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23170ea9cc06976f$var$__assign.apply(this, arguments);
};
var $23170ea9cc06976f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23170ea9cc06976f$export$b73dd58f0dc7b9ee = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $23170ea9cc06976f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $23170ea9cc06976f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.66 2a2.66 2.66 0 100 5.32 2.66 2.66 0 000-5.32zm-.482 1.496a1.26 1.26 0 11.964 2.328 1.26 1.26 0 01-.964-2.328zM3.66 9.84a2.66 2.66 0 100 5.318 2.66 2.66 0 000-5.318zm-.482 1.496a1.26 1.26 0 11.964 2.329 1.26 1.26 0 01-.964-2.33zm-.536 6.546a2.661 2.661 0 013.475 3.476 2.66 2.66 0 11-3.475-3.476zM3.66 19.08a1.258 1.258 0 00-.891 2.15 1.26 1.26 0 10.891-2.15z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M8.233 4.613a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233zm-.7 8.54a.7.7 0 01.7-.7H21.3a.7.7 0 110 1.4H8.233a.7.7 0 01-.7-.7zm.7 7.14a.7.7 0 100 1.4H21.3a.7.7 0 100-1.4H8.233z"
    })));
});
$23170ea9cc06976f$export$b73dd58f0dc7b9ee.displayName = 'LayoutList';





var $denZA = parcelRequire("denZA");
var $f243f16c3f722042$var$__assign = undefined && undefined.__assign || function() {
    $f243f16c3f722042$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f243f16c3f722042$var$__assign.apply(this, arguments);
};
var $f243f16c3f722042$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f243f16c3f722042$export$8c8aefe5a4ba5254 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f243f16c3f722042$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f243f16c3f722042$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.13 1a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm0 8.018a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26zm-1.198 8.256a3.13 3.13 0 013.41 5.105 3.13 3.13 0 11-3.41-5.105zM8.761 3.298a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761zm-1.5 9.518a1.5 1.5 0 011.5-1.5h13.364a1.5 1.5 0 110 3H8.761a1.5 1.5 0 01-1.5-1.5zm1.5 6.518a1.5 1.5 0 000 3h13.364a1.5 1.5 0 100-3H8.761z"
    })));
});
$f243f16c3f722042$export$8c8aefe5a4ba5254.displayName = 'LayoutListBold';





var $denZA = parcelRequire("denZA");
var $ab89c2383a97fd7d$var$__assign = undefined && undefined.__assign || function() {
    $ab89c2383a97fd7d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab89c2383a97fd7d$var$__assign.apply(this, arguments);
};
var $ab89c2383a97fd7d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ab89c2383a97fd7d$export$d57cd6dbf45f4bdf = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ab89c2383a97fd7d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ab89c2383a97fd7d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm1.5.75v3h21v-3h-21zM0 9.75A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21zM0 18.75A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm1.5.75v3h21v-3h-21z",
        fillRule: "evenodd"
    })));
});
$ab89c2383a97fd7d$export$d57cd6dbf45f4bdf.displayName = 'LayoutListView';





var $denZA = parcelRequire("denZA");
var $b63c792a6961457b$var$__assign = undefined && undefined.__assign || function() {
    $b63c792a6961457b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b63c792a6961457b$var$__assign.apply(this, arguments);
};
var $b63c792a6961457b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b63c792a6961457b$export$faa3c8ce2462319b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b63c792a6961457b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b63c792a6961457b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 .75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75A.75.75 0 010 5.25V.75zm0 9A.75.75 0 01.75 9h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5zm0 9A.75.75 0 01.75 18h22.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75v-4.5z",
        fillRule: "evenodd"
    })));
});
$b63c792a6961457b$export$faa3c8ce2462319b.displayName = 'LayoutListViewBold';





var $denZA = parcelRequire("denZA");
var $d27d4e5b73b66a2e$var$__assign = undefined && undefined.__assign || function() {
    $d27d4e5b73b66a2e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d27d4e5b73b66a2e$var$__assign.apply(this, arguments);
};
var $d27d4e5b73b66a2e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d27d4e5b73b66a2e$export$3c505bfe7119a36a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d27d4e5b73b66a2e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d27d4e5b73b66a2e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#learning-library_svg__a)"
    }, $denZA.createElement("path", {
        d: "M2.196 2.296h.18c3.694.19 6.689 1.049 8.535 2.336a.749.749 0 01-.858 1.228C8.466 4.762 5.73 3.994 2.286 3.794a.749.749 0 00-.799.649V17.88a.749.749 0 00.69.748c5.61.25 9.773 2.077 10.501 4.383a.748.748 0 01-1.387.55v-.1c-.49-1.528-4.103-3.115-9.155-3.335A2.246 2.246 0 010 18.029V4.553a2.246 2.246 0 012.196-2.257z"
    }), $denZA.createElement("path", {
        d: "M23.19 8.266a.749.749 0 01.74.65V17.9a2.246 2.246 0 01-2.117 2.256c-4.932.22-8.496 1.737-9.105 3.234v.11a.749.749 0 01-1.427-.45c.728-2.305 4.901-4.132 10.492-4.382a.749.749 0 00.699-.658V8.985a.749.749 0 01.718-.719zM3.823 6.749c1.96.22 3.886.668 5.74 1.338a.749.749 0 11-.508 1.407 23.65 23.65 0 00-5.391-1.258.75.75 0 01.07-1.497l.09.01zm.01 3.803c1.955.226 3.878.674 5.73 1.338a.75.75 0 11-.508 1.408 24.228 24.228 0 00-5.401-1.258.749.749 0 01.07-1.488h.11zm-.159 4.033h.1c1.976.24 3.92.705 5.79 1.388a.75.75 0 01-.5 1.408 24.459 24.459 0 00-5.45-1.258.75.75 0 11.07-1.498l-.01-.04z"
    }), $denZA.createElement("path", {
        d: "M11.98 9.764a.749.749 0 01.738.649V23.24a.749.749 0 01-1.487.1V10.511a.749.749 0 01.748-.748zM17.2 0a.749.749 0 01.77.68v1.596a.749.749 0 01-1.488.1V.78A.748.748 0 0117.2 0zm-5.33 2.716a.749.749 0 01.998-.07l.08.07 1.028 1.058a.753.753 0 11-.998 1.128v-.07L11.87 3.774a.749.749 0 010-1.058zm9.603 0a.753.753 0 011.128.998l-.07.08-1.058 1.038a.753.753 0 01-1.128-.998l.07-.08 1.058-1.038zM17.2 11.98a.749.749 0 01.74.649v1.597a.749.749 0 01-1.488.1v-1.597a.749.749 0 01.749-.75z"
    }), $denZA.createElement("path", {
        d: "M13.627 7.158a3.744 3.744 0 001.218 3.993l.12.09v1.518a.749.749 0 00.748.748h3.095a.749.749 0 00.649-.739v-1.517l.16-.13a3.744 3.744 0 10-5.93-4.133l-.06.17zM17.62 6.04a2.246 2.246 0 01.729 4.153l-.09.06a.749.749 0 00-.28.589v1.138h-1.497v-1.138a.749.749 0 00-.37-.65A2.246 2.246 0 0117.63 6.04h-.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "learning-library_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$d27d4e5b73b66a2e$export$3c505bfe7119a36a.displayName = 'LearningLibrary';





var $denZA = parcelRequire("denZA");
var $0b2a4f88d42fc65f$var$__assign = undefined && undefined.__assign || function() {
    $0b2a4f88d42fc65f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0b2a4f88d42fc65f$var$__assign.apply(this, arguments);
};
var $0b2a4f88d42fc65f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0b2a4f88d42fc65f$export$cccceed87933e06f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0b2a4f88d42fc65f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0b2a4f88d42fc65f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M17.38 3a1 1 0 001-1V1a1 1 0 00-2 0v1a1 1 0 001 1zm3.86 1.11a1 1 0 00.76-.35l.65-.77a1 1 0 00-1.52-1.28l-.65.76a1 1 0 00.76 1.65v-.01zm-8.48-.35a1 1 0 001.53-1.29l-.64-.76A1 1 0 1012.12 3l.64.76zM23 7.38a1 1 0 00-1 1v9.83a18.159 18.159 0 00-9 2.6V6.02a1.31 1.31 0 00-.64-1.1c-.95-.59-5.94-3.44-11.26-2.57A1.32 1.32 0 000 3.65v15a1.32 1.32 0 001.2 1.32c3.55.29 8.21 1.33 9.65 3.32a1.33 1.33 0 001 .55h.09a1.289 1.289 0 00.93-.4c.68-.71 3.39-3 9.83-3.29a1.32 1.32 0 001.3-1.3V8.38a1 1 0 00-1-1zm-12.88 5.48a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74 22.62 22.62 0 015.51 1.07.83.83 0 01.51 1.05zm0 4a.79.79 0 01-1 .52 20.926 20.926 0 00-5.17-1 .82.82 0 01-.71-.9.81.81 0 01.86-.74c1.879.162 3.73.558 5.51 1.18a.83.83 0 01.51 1v-.06zm-.23-7.69a.78.78 0 01-.78.16 20.88 20.88 0 00-5.17-1 .84.84 0 01-.43-1.46.77.77 0 01.59-.18 22.63 22.63 0 015.51 1.08.82.82 0 01.53.62.84.84 0 01-.25.78z"
    }), $denZA.createElement("path", {
        d: "M15.24 10.8v1.22a.75.75 0 00.75.75h.5v.67a1 1 0 002 0v-.67h.6a.75.75 0 00.65-.74v-1.2a4 4 0 10-4.5 0v-.03zm.3-3.24a2 2 0 114 0 2 2 0 01-4 0z"
    })));
});
$0b2a4f88d42fc65f$export$cccceed87933e06f.displayName = 'LearningLibraryBold';





var $denZA = parcelRequire("denZA");
var $f1ac97af9b34595c$var$__assign = undefined && undefined.__assign || function() {
    $f1ac97af9b34595c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1ac97af9b34595c$var$__assign.apply(this, arguments);
};
var $f1ac97af9b34595c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f1ac97af9b34595c$export$a5ec17cbd7381ca0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f1ac97af9b34595c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f1ac97af9b34595c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8 15.59h8a3.15 3.15 0 003.15-3.15V6A3.151 3.151 0 0016 2.83h-.3v-1.1a1.49 1.49 0 00-1.49-1.5H10a1.49 1.49 0 00-1.54 1.5v1.1H8A3.15 3.15 0 004.83 6v6.46A3.15 3.15 0 008 15.59zM10 1.7h4.27v1.13H9.94L10 1.7zM6.3 6A1.68 1.68 0 018 4.3h8A1.68 1.68 0 0117.7 6v6.46a1.681 1.681 0 01-1.7 1.66H8a1.682 1.682 0 01-1.7-1.68V6zm14.27 11.64a4.1 4.1 0 00-1.84-.42H5C1.23 17.38.23 21.09.23 23a.735.735 0 101.47 0c0-.17 0-4.2 3.35-4.34h13.68c.408-.006.812.083 1.18.26A4.25 4.25 0 0122.3 23a.73.73 0 101.46.01 5.721 5.721 0 00-3.19-5.37z"
    }), $denZA.createElement("path", {
        d: "M9.8 8.84a.72.72 0 100-1.44.72.72 0 000 1.44zm4.4 0a.72.72 0 100-1.44.72.72 0 000 1.44zm.26 1.5a.38.38 0 00-.49.21s-.37.86-2 .86c-1.6 0-1.89-.81-1.91-.85a.38.38 0 00-.72.22c0 .06.43 1.39 2.63 1.39 2.23 0 2.73-1.29 2.75-1.35a.37.37 0 00-.26-.48z"
    })));
});
$f1ac97af9b34595c$export$a5ec17cbd7381ca0.displayName = 'LegoUser';





var $denZA = parcelRequire("denZA");
var $845af495bec57d01$var$__assign = undefined && undefined.__assign || function() {
    $845af495bec57d01$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $845af495bec57d01$var$__assign.apply(this, arguments);
};
var $845af495bec57d01$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $845af495bec57d01$export$b54b5de32f76df39 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $845af495bec57d01$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $845af495bec57d01$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8 15.59h8a3.15 3.15 0 003.15-3.15V6A3.15 3.15 0 0016 2.83h-.33v-1.1A1.49 1.49 0 0014.2.23H9.94a1.49 1.49 0 00-1.49 1.5v1.1H8A3.15 3.15 0 004.82 6v6.46A3.15 3.15 0 008 15.59zm2-13.88h4.27v1.12H9.93L10 1.71zM6.29 6A1.68 1.68 0 018 4.3h8A1.68 1.68 0 0117.69 6v6.46A1.68 1.68 0 0116 14.12H8a1.68 1.68 0 01-1.68-1.68L6.29 6zm14.27 11.64a4.1 4.1 0 00-1.84-.42H5C1.22 17.38.22 21.09.22 23a.735.735 0 101.47 0c0-.17 0-4.2 3.35-4.34h13.68a2.64 2.64 0 011.18.26A4.25 4.25 0 0122.29 23a.73.73 0 00.73.74.74.74 0 00.74-.73 5.72 5.72 0 00-3.2-5.37z"
    })));
});
$845af495bec57d01$export$b54b5de32f76df39.displayName = 'LegoUserFaceless';





var $denZA = parcelRequire("denZA");
var $762006c8b714a7dd$var$__assign = undefined && undefined.__assign || function() {
    $762006c8b714a7dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $762006c8b714a7dd$var$__assign.apply(this, arguments);
};
var $762006c8b714a7dd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $762006c8b714a7dd$export$d92b3f15dbe60212 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $762006c8b714a7dd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $762006c8b714a7dd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.782 18.82c-.88-.89-2.05-1.34-3.47-1.34H5.472c-3.83 0-4.84 3.52-4.84 5.39 0 .55.45 1 1 1s1-.45 1-1c0-.14.03-3.38 2.84-3.38h12.84c2.95 0 3.04 3.04 3.04 3.38 0 .55.44 1 1 1 .55 0 1-.44 1-1 0-.1 0-2.48-1.57-4.05zm-13.6-2.5h7.63c1.91 0 3.46-1.55 3.46-3.46V6.52c0-1.86-1.49-3.38-3.33-3.45V1.9c-.01-.98-.8-1.77-1.78-1.77h-4.34c-.98 0-1.77.79-1.77 1.77v1.17a3.453 3.453 0 00-3.33 3.45v6.34c0 1.91 1.55 3.46 3.46 3.46zm1.87-14.19h3.88v.92h-3.88v-.92zm-3.33 4.39c0-.81.66-1.46 1.46-1.46h7.63c.81 0 1.46.66 1.46 1.46v6.34c0 .81-.66 1.46-1.46 1.46h-7.63c-.81 0-1.46-.66-1.46-1.46V6.52z"
    })));
});
$762006c8b714a7dd$export$d92b3f15dbe60212.displayName = 'LegoUserFacelessBold';





var $denZA = parcelRequire("denZA");
var $b948a2e484aaa94b$var$__assign = undefined && undefined.__assign || function() {
    $b948a2e484aaa94b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b948a2e484aaa94b$var$__assign.apply(this, arguments);
};
var $b948a2e484aaa94b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b948a2e484aaa94b$export$c56d1816e40a7be5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b948a2e484aaa94b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b948a2e484aaa94b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#lego-user-faceless-female-1_svg__a)"
    }, $denZA.createElement("path", {
        d: "M22.06 14.57a.71.71 0 000-1A3.52 3.52 0 0121 9.71c.59-2 1.11-5.89-.58-8.13A4.23 4.23 0 0016.84 0 5.16 5.16 0 0013 1.86c-1.34-.25-5-.7-7.09 1.42C4.33 4.83 4 7.36 4.86 10.8V12A3.77 3.77 0 006 14.7a3.72 3.72 0 002.65 1.1h5.68a3.71 3.71 0 002.2-.73s3.13 1.63 5.53-.5zm-7.77-.27H8.61A2.251 2.251 0 016.36 12V8.14c1.87-.12 6.59-.63 8.49-2.6a1.82 1.82 0 011 .55 3.5 3.5 0 01.7 1.91v4a2.25 2.25 0 01-.659 1.591c-.422.422-1.004.709-1.6.709zm3.27-.3c.29-.385.47-.841.52-1.32 0-.05.06-2.29.06-2.35V8.68c0-.68-.003-1.447-.26-2.123A4.46 4.46 0 0016.66 4.8a3.07 3.07 0 00-2.21-.8.75.75 0 00-.53.3C12.7 6 8 6.57 5.92 6.68a3.82 3.82 0 011-2.34c2-2 6.13-.93 6.17-.92a.75.75 0 00.84-.35l.11-.17a3.67 3.67 0 012.81-1.42 2.76 2.76 0 012.36 1c1.26 1.67.88 5 .32 6.87 0 0-1 2.92.94 4.65a3.5 3.5 0 01-2.91 0zm4.86 6a6.09 6.09 0 00-2.37-2.42 3.63 3.63 0 00-1.8-.44H5.09c-3.67.17-4.64 4.06-4.64 6.1a.75.75 0 001.49 0s0-4.46 3.18-4.61h13.14a2.29 2.29 0 011.07.26 4.6 4.6 0 012.31 4.3.75.75 0 00.69.79h.05a.75.75 0 00.74-.7 6.08 6.08 0 00-.7-3.28z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "lego-user-faceless-female-1_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$b948a2e484aaa94b$export$c56d1816e40a7be5.displayName = 'LegoUserFacelessFemale1';





var $denZA = parcelRequire("denZA");
var $36deec02b6047b6c$var$__assign = undefined && undefined.__assign || function() {
    $36deec02b6047b6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36deec02b6047b6c$var$__assign.apply(this, arguments);
};
var $36deec02b6047b6c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $36deec02b6047b6c$export$95884f6efdce686d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $36deec02b6047b6c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $36deec02b6047b6c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.928 12.14c0 1.01.39 1.95 1.1 2.66.71.71 1.66 1.1 2.66 1.1h5.24c.84 0 1.64-.29 2.29-.8.41.3.98.51 1.77.51h.21c.59.03 1.19-.09 1.72-.33.5-.22 1.45-.81 1.87-1.29.22-.25.3-.59.21-.91-.09-.32-.32-.58-.63-.69-.51-.18-.78-.48-.98-1.1-.12-.37-.07-.77-.01-1.28.02-.13.03-.27.05-.4.56-1.91 1.03-5.59-.6-7.75-.57-.75-1.68-1.62-3.55-1.6-.75.02-1.5.2-2.17.54-.16.08-.92.47-1.46.98-1.77-.68-4.95-.83-6.9.94-1.24 1.13-2.38 3.43-.82 7.92v1.5zm9.01 1.76h-5.25c-.47 0-.92-.18-1.25-.52-.33-.33-.52-.78-.52-1.25V8.4c1.63-.13 4.94-.54 6.88-1.77.32-.21.72-.25 1.07-.13.18.06.49.22.63.61.1.27.16.59.2.93v4.1c0 .47-.18.92-.52 1.25-.33.33-.77.51-1.24.51zm-6.84-9.69c1.32-1.2 3.8-1.04 5.02-.47.6.28 1.33.11 1.85-.44.21-.22.7-.53 1.04-.7.41-.21.86-.32 1.31-.33.9-.04 1.5.25 1.92.8 1.08 1.43.73 4.48.25 6.06-.02.07-.03.13-.04.2-.01.15-.03.3-.05.44-.08.64-.16 1.36.1 2.15.14.43.37.97.8 1.44-.06.03-.12.06-.17.08-.27.12-.56.18-.93.16-.38.01-.6-.04-.74-.09.12-.31.18-.62.24-.9l.05-.24c.02-.07.02-.14.02-.21V8.62c-.01-.21-.04-.4-.06-.6v-.27h-.03c-.06-.48-.15-.94-.29-1.33-.31-.86-.99-1.52-1.87-1.82-.92-.31-1.96-.19-2.79.34-1.65 1.05-5.07 1.43-6.56 1.51.04-.88.31-1.68.93-2.24zm14.1 14.41c-.84-.84-1.93-1.27-3.25-1.27H5.838c-3.65 0-4.62 3.53-4.62 5.39 0 .55.45 1 1 1s1-.45 1-1c0-.14.03-3.38 2.62-3.38h12.11c2.73 0 2.81 3.04 2.82 3.38 0 .55.44 1 1 1 .55 0 1-.44 1-1 0-.1-.01-2.55-1.57-4.12z"
    })));
});
$36deec02b6047b6c$export$95884f6efdce686d.displayName = 'LegoUserFacelessFemale1Bold';





var $denZA = parcelRequire("denZA");
var $a1112c98ff535e76$var$__assign = undefined && undefined.__assign || function() {
    $a1112c98ff535e76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1112c98ff535e76$var$__assign.apply(this, arguments);
};
var $a1112c98ff535e76$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a1112c98ff535e76$export$ab9db743b83c147c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a1112c98ff535e76$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a1112c98ff535e76$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.14 20.19A5.621 5.621 0 0019.91 18a3.721 3.721 0 00-1.69-.4H6c-3.46.15-4.37 3.68-4.37 5.52a.75.75 0 00.75.75.73.73 0 00.75-.75c0-.16.05-3.9 2.91-4h12.19a2.29 2.29 0 011 .22 4.1 4.1 0 011.62 1.59c.37.653.54 1.4.49 2.15a.749.749 0 00.7.8h.05a.75.75 0 00.75-.7 5.33 5.33 0 00-.7-2.99zM18.53 8A3.58 3.58 0 0015 4.37a.75.75 0 00-.28.05l-2.1.84a8.75 8.75 0 01-3.2.66C8.53 5.93 6 5.94 6 8v4a3.58 3.58 0 003.58 3.58H15A3.58 3.58 0 0018.53 12V8zM17 12a2.08 2.08 0 01-2 2.09H9.54A2.08 2.08 0 017.46 12V8c0-.43 1-.52 1.92-.53a10.24 10.24 0 003.75-.77l1.74-.7a.84.84 0 01.46-.06A2.09 2.09 0 0117 8v4z"
    }), $denZA.createElement("path", {
        d: "M5.73 15.87c.11.018.205.034.308.018a.75.75 0 00.256-1.396c-.09-.05-.184-.062-.294-.092l-1.885-.545S3.088 13.476 4 12.7a3.06 3.06 0 001.06-2.65l-.22-2.46a5.3 5.3 0 01.53-2.29 5.67 5.67 0 011.5-1.9 7.8 7.8 0 015-1.78c1.29 0 3.58.26 4.38 2a.75.75 0 001 .38 2.1 2.1 0 011.11-.16 1.46 1.46 0 011.06 1 6.44 6.44 0 01-.07 2.56s-.675 3.135 1.247 5.45c0 0 .38.648-.14.928 0 0-.907.402-2.057.662a.75.75 0 00.16 1.48h.16a11.75 11.75 0 002.28-.67c.506-.185.941-.466 1.172-.954.111-.241.148-.6.148-.866a2.43 2.43 0 00-.7-1.43c-1.43-1.69-.83-4.34-.83-4.34a6.82 6.82 0 000-3.38 2.89 2.89 0 00-2.17-1.9 3.25 3.25 0 00-1.31 0C16.3.93 14.4.11 11.86.11a9.31 9.31 0 00-6 2.13A7.16 7.16 0 004 4.65a6.84 6.84 0 00-.68 3l.24 2.46a2.34 2.34 0 01-.168 1.033c-.134.328-.252.647-.514.884-.263.236-.326.319-.563.57-.294.416-.3.541-.338.829-.001.27.031.511.144.755.234.47.577.784 1.074.955l2.535.734z"
    })));
});
$a1112c98ff535e76$export$ab9db743b83c147c.displayName = 'LegoUserFacelessFemale2';





var $denZA = parcelRequire("denZA");
var $13767e8d527e27f3$var$__assign = undefined && undefined.__assign || function() {
    $13767e8d527e27f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13767e8d527e27f3$var$__assign.apply(this, arguments);
};
var $13767e8d527e27f3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $13767e8d527e27f3$export$be5d330a35522bf9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $13767e8d527e27f3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $13767e8d527e27f3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.21 18.615c-.84-.84-1.93-1.27-3.25-1.27H5.85c-3.65.01-4.62 3.53-4.62 5.39 0 .55.45 1 1 1s1-.45 1-1c0-.35.1-3.39 2.62-3.39h12.11c2.73 0 2.81 3.04 2.81 3.38 0 .55.44 1 1 1 .55 0 1-.44 1-1 .01-.09 0-2.54-1.56-4.11zm-6.48-14.01h-.19l-2.25.9c-1.05.41-2.08.63-3.06.63-.9 0-3.63.02-3.63 2.26v4c0 2.09 1.7 3.79 3.79 3.79h5.34c2.09 0 3.79-1.7 3.79-3.79v-4c.01-2.09-1.7-3.79-3.79-3.79zm1.8 7.79c0 .99-.81 1.79-1.79 1.79H9.39c-.99 0-1.79-.81-1.79-1.79l-.01-4c.02-.03.27-.25 1.65-.26 1.24-.01 2.51-.27 3.79-.78l1.88-.75c.91.09 1.62.86 1.62 1.79v4z"
    }), $denZA.createElement("path", {
        d: "M2.9 17.225c.52.19 1.09-.07 1.29-.59.19-.52-.07-1.09-.59-1.29-.09-.03-.16-.09-.19-.23l1.25-2.6c.3-.59.46-1.25.46-1.91v-.1l-.26-2.5c.01-.75.19-1.47.52-2.16.34-.71.83-1.32 1.46-1.84 1.36-1.12 3.11-1.74 4.94-1.74 1.62 0 3.44.77 4.65 1.95.31.3.77.37 1.15.18.48-.25.92-.09 1.14.03.39.21.66.59.7.96.04.39-.05.9-.16 1.5-.11.61-.24 1.3-.25 2.07-.01.6-.02 2.64.46 3.58.4.8 1.09 2.2 1.2 2.45 0 .11-.12.34-.22.41a1 1 0 00-.49 1.31c.16.38.53.6.92.6.13 0 .27-.03.4-.08.92-.41 1.69-1.81 1.27-2.88-.21-.54-1.19-2.48-1.3-2.7-.09-.18-.28-1.1-.24-2.63.01-.63.12-1.21.22-1.78.13-.71.25-1.38.18-2.06-.1-1.02-.77-1.98-1.73-2.51-.74-.4-1.55-.51-2.33-.32-1.55-1.29-3.63-2.08-5.57-2.08-2.29 0-4.5.78-6.22 2.2-.84.7-1.51 1.54-1.98 2.51-.47.97-.72 2-.72 3.07v.11l.26 2.51c-.01.33-.09.66-.25.98l-1.27 2.63c-.13.28-.19.58-.19.88 0 .3.07.6.2.89.25.54.71.96 1.29 1.18z"
    })));
});
$13767e8d527e27f3$export$be5d330a35522bf9.displayName = 'LegoUserFacelessFemale2Bold';





var $denZA = parcelRequire("denZA");
var $3f113a066bff52c9$var$__assign = undefined && undefined.__assign || function() {
    $3f113a066bff52c9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f113a066bff52c9$var$__assign.apply(this, arguments);
};
var $3f113a066bff52c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3f113a066bff52c9$export$b7d31bdccccf8e25 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $3f113a066bff52c9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $3f113a066bff52c9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22 20.08a5.77 5.77 0 00-2.24-2.29 3.66 3.66 0 00-1.71-.42H5.68c-3.48.16-4.39 3.85-4.39 5.77a.73.73 0 00.73.73H2a.73.73 0 00.73-.73c0-.17 0-4.18 3-4.32h12.36a2 2 0 011 .24 4.31 4.31 0 012.16 4 .73.73 0 00.68.78H22a.73.73 0 00.73-.68 5.76 5.76 0 00-.73-3.08zM19.79 4.83l-.9-.29.74-1.41a.81.81 0 000-.91.83.83 0 00-.93-.33l-.64.15.38-.42a1 1 0 00.26-.74.83.83 0 00-.7-.64C14.57-.4 7.37 1.85 7 2a2.52 2.52 0 00-1.15 1l-.5.86A1.52 1.52 0 004.08 4a1 1 0 00-.45.76c-.29 3.24.06 5.54 1.07 6.7.252.304.58.535.95.67v.8A3.1 3.1 0 008.75 16h6.13a3.1 3.1 0 003.1-3.1v-.25c1.39-.93 2.09-3.54 2.64-6.22-.01.03.31-1.35-.83-1.6zm-3.28 8.1a1.64 1.64 0 01-1.64 1.64H8.75a1.64 1.64 0 01-1.64-1.64V8.64a17.61 17.61 0 007.09-1.52 5 5 0 002.31 1v4.81zM5.05 5.27l.27.11a.94.94 0 001-.43l.74-1.26a1.07 1.07 0 01.42-.35c.06 0 5.6-1.75 9-1.76l-.89 1a.88.88 0 00-.09.94.85.85 0 00.83.44l1.35-.31-.36.69a1 1 0 00-.13.85.88.88 0 00.61.56l1.34.43A21.125 21.125 0 0118 10.35V7.74a1 1 0 00-.9-1 3.45 3.45 0 01-2-.8.93.93 0 00-1.1-.26c-.76.32-4.45 1.86-7.41 1.46 0 0-.9-.13-.94.48v2.66c-.39-.61-.83-1.98-.6-5.01z"
    })));
});
$3f113a066bff52c9$export$b7d31bdccccf8e25.displayName = 'LegoUserFacelessMale1';





var $denZA = parcelRequire("denZA");
var $912398aa342bed8d$var$__assign = undefined && undefined.__assign || function() {
    $912398aa342bed8d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $912398aa342bed8d$var$__assign.apply(this, arguments);
};
var $912398aa342bed8d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $912398aa342bed8d$export$8fa745025b00443a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $912398aa342bed8d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $912398aa342bed8d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.202 18.82c-.84-.84-1.93-1.27-3.25-1.27H5.842c-3.65 0-4.62 3.52-4.62 5.39 0 .55.45 1 1 1s1-.45 1-1c0-.35.1-3.39 2.62-3.39h12.11c2.73 0 2.81 3.04 2.81 3.38 0 .55.44 1 1 1 .55 0 1-.44 1-1 .01-.09 0-2.54-1.56-4.11zm-15.97-6.71v.49c0 2.09 1.7 3.79 3.79 3.79h5.34c2.09 0 3.79-1.7 3.79-3.79v-.76c.68-.46 1.23-1.31 1.6-2.54.5-1.62.83-4.63-.39-5.85-.16-.16.09-.6.2-.78.31-.49.33-1.1.05-1.61s-.8-.83-1.38-.83c-.48 0-.99-.04-1.53-.07-2.18-.14-4.88-.32-8.1.9-1.14.41-2.76 1.94-3.25 2.59-.06.02-.18.06-.38.07h-.11c-1.32.06-2.04.61-2.13 1.64-.31 3.22.08 5.25 1.18 6.21.48.42.97.53 1.32.54zm10.93.49c0 .99-.81 1.79-1.79 1.79h-5.35c-.99 0-1.79-.8-1.79-1.79l-.01-4c.02-.03.27-.26 1.65-.26 1.24-.01 2.52-.27 3.79-.78l1.88-.75c.91.09 1.62.86 1.62 1.79v4zM4.702 5.74c.08-.01.18-.01.24-.01l.14-.01c.91-.05 1.6-.39 1.88-.89.25-.34 1.64-1.65 2.36-1.92 2.81-1.06 5.18-.91 7.26-.77l.98.06c-.61 1.41.05 2.32.39 2.66.24.27.37 1.54.12 2.93a3.795 3.795 0 00-3.7-2.98h-.19l-2.25.9c-1.06.41-2.09.62-3.07.63-.9 0-3.63.02-3.63 2.26v1.46c-.22-.2-.82-1.04-.53-4.32z"
    })));
});
$912398aa342bed8d$export$8fa745025b00443a.displayName = 'LegoUserFacelessMale1Bold';





var $denZA = parcelRequire("denZA");
var $955d1646fda1592c$var$__assign = undefined && undefined.__assign || function() {
    $955d1646fda1592c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $955d1646fda1592c$var$__assign.apply(this, arguments);
};
var $955d1646fda1592c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $955d1646fda1592c$export$8849cc0aba9b19d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $955d1646fda1592c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $955d1646fda1592c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#lego-user-faceless-male-2_svg__a)"
    }, $denZA.createElement("path", {
        d: "M22.34 20.08A5.93 5.93 0 0020 17.72a3.709 3.709 0 00-1.76-.43H5.49C1.9 17.46 1 21.25 1 23.24a.75.75 0 001.5 0c0-.18.05-4.31 3.06-4.45h12.72c.349.002.692.087 1 .25a4.44 4.44 0 012.23 4.15.75.75 0 00.7.8h.05a.75.75 0 00.75-.7 5.93 5.93 0 00-.67-3.21zM5.39 12.27a3.3 3.3 0 00.93 2.31 3.132 3.132 0 002.26 1h6.31a3.13 3.13 0 001.23-.25 3.17 3.17 0 001-.72 3.31 3.31 0 00.93-2.31v-1.2a7.5 7.5 0 001.16-2.8c.58-2.42.24-4.37-1-5.81C15.69-.44 10.32 0 10 .05 7.64.43 6.93 1.3 6.69 2.19a2.29 2.29 0 00-1.27.11A2.12 2.12 0 004.2 3.52C3.1 6.3 5 10.24 5.39 11.1v1.17zm10.69 1.26a1.681 1.681 0 01-.55.38 1.61 1.61 0 01-.64.13H8.58a1.643 1.643 0 01-1.19-.51 1.83 1.83 0 01-.5-1.26V7.43a1.54 1.54 0 01.28-.95c.06-.08.41-.46 1.28-.16l.45.16a38.361 38.361 0 007.65 2.07v4.08c-.02.113-.05.223-.09.33a1.8 1.8 0 01-.38.58v-.01zM5.59 4.06A.65.65 0 016 3.7a.77.77 0 01.62 0 1 1 0 001 .05 1.14 1.14 0 00.56-1c0-.38.13-1 2.14-1.27 0 0 4.82-.42 6.86 1.93a4.43 4.43 0 01.83 3.71l-.56-.05a33.77 33.77 0 01-8-2.07L9 4.84a3.35 3.35 0 00-1.1-.2 2.28 2.28 0 00-1.89.9 3 3 0 00-.48 1.08 5.09 5.09 0 01.06-2.56z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "lego-user-faceless-male-2_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$955d1646fda1592c$export$8849cc0aba9b19d.displayName = 'LegoUserFacelessMale2';





var $denZA = parcelRequire("denZA");
var $12f7a2d887e8079f$var$__assign = undefined && undefined.__assign || function() {
    $12f7a2d887e8079f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12f7a2d887e8079f$var$__assign.apply(this, arguments);
};
var $12f7a2d887e8079f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $12f7a2d887e8079f$export$4b5f8ea406e4df31 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $12f7a2d887e8079f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $12f7a2d887e8079f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.202 18.753c-.84-.84-1.93-1.27-3.25-1.27H5.842c-3.66 0-4.62 3.52-4.62 5.38 0 .55.45 1 1 1s1-.45 1-1c0-.35.1-3.39 2.62-3.39h12.11c2.73 0 2.81 3.04 2.81 3.38 0 .55.44 1 1 1 .55 0 1-.44 1-1 .01-.08 0-2.53-1.56-4.1zm-15.67-6.22c0 2.09 1.7 3.79 3.79 3.79h5.34c2.09 0 3.79-1.7 3.79-3.79v-1.3c.56-.94.89-1.81 1.03-2.73.63-2.52.3-4.54-.98-6-2.29-2.63-6.79-2.46-8.61-2.27-2.23.24-3.16 1.08-3.49 1.95-1.02-.04-2.06.48-2.5 1.69-1.01 2.78.98 6.34 1.63 7.38v1.28zm10.93 0c0 .99-.8 1.79-1.79 1.79h-5.34c-.99 0-1.79-.81-1.79-1.79v-4c0-.93.71-1.7 1.62-1.79l1.88.75c1.28.51 2.55.77 3.79.78 1.38.01 1.63.23 1.64.26v4h-.01zm-10.68-7.97c.19-.52.71-.37.82-.33.38.13.8.08 1.12-.15.32-.22.42-.6.52-.98.2-.74 1.02-.79 1.87-.88 2.44-.26 5.53.02 6.89 1.59.65.75.89 1.8.73 3.16-.87-.68-2.3-.69-2.9-.7-.99 0-2.02-.22-3.06-.64l-2.25-.9h-.19c-1.56 0-2.9.95-3.48 2.3-.24-.87-.33-1.76-.07-2.47z"
    })));
});
$12f7a2d887e8079f$export$4b5f8ea406e4df31.displayName = 'LegoUserFacelessMale2Bold';





var $denZA = parcelRequire("denZA");
var $bc71010a30d3e869$var$__assign = undefined && undefined.__assign || function() {
    $bc71010a30d3e869$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc71010a30d3e869$var$__assign.apply(this, arguments);
};
var $bc71010a30d3e869$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc71010a30d3e869$export$b19aa8eaafa3e7bf = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bc71010a30d3e869$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bc71010a30d3e869$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#lego-user-female-1_svg__a)"
    }, $denZA.createElement("path", {
        d: "M22.06 14.57a.72.72 0 000-1A5.341 5.341 0 0121 11.7a4.161 4.161 0 010-2c.59-2 1.11-5.89-.58-8.13A4.23 4.23 0 0016.84 0 5.16 5.16 0 0013 1.86c-1.34-.25-5-.7-7.09 1.42C4.33 4.83 4 7.36 4.86 10.8V12A3.77 3.77 0 006 14.7a3.722 3.722 0 002.65 1.1h5.68a3.71 3.71 0 002.2-.73 4.32 4.32 0 005.53-.5zm-7.77-.27H8.61A2.251 2.251 0 016.36 12V8.14c1.87-.12 6.59-.63 8.49-2.6a1.82 1.82 0 011 .55 3 3 0 01.7 1.91v4a2.25 2.25 0 01-.659 1.591c-.422.422-1.004.709-1.6.709zm3.27-.3a2.27 2.27 0 00.467-.846c.094-.313.073-.71.073-.964V8.71c0-3.06-1.35-3.93-1.35-3.93a3.18 3.18 0 00-2.3-.78.75.75 0 00-.53.3C12.7 6 8 6.57 5.92 6.68a3.82 3.82 0 011-2.34c2-2 6.13-.93 6.17-.92a.75.75 0 00.84-.35l.11-.17a3.67 3.67 0 012.81-1.42 2.76 2.76 0 012.36 1c1.26 1.67.88 5 .32 6.87a5.879 5.879 0 000 2.82 6.718 6.718 0 001 1.77c-1.22 1.06-2.97.06-2.97.06zm4.86 6a6.09 6.09 0 00-2.37-2.42 3.63 3.63 0 00-1.8-.44H5.09c-3.67.17-4.64 4.06-4.64 6.1a.75.75 0 001.49 0s0-4.46 3.18-4.61h13.14a2.29 2.29 0 011.07.26 4.6 4.6 0 012.31 4.3.75.75 0 00.69.79h.05a.75.75 0 00.74-.7 6.08 6.08 0 00-.7-3.28z"
    }), $denZA.createElement("path", {
        d: "M9.62 9.94a.6.6 0 100-1.2.6.6 0 000 1.2zm3.65 0a.6.6 0 100-1.2.6.6 0 000 1.2zm.22 1.24a.31.31 0 00-.4.18s-.31.71-1.69.71c-1.32 0-1.57-.67-1.58-.71a.314.314 0 00-.6.18s.36 1.15 2.18 1.15c1.85 0 2.26-1.07 2.28-1.12a.31.31 0 00-.19-.39z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "lego-user-female-1_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$bc71010a30d3e869$export$b19aa8eaafa3e7bf.displayName = 'LegoUserFemale1';





var $denZA = parcelRequire("denZA");
var $6ba41967632a206f$var$__assign = undefined && undefined.__assign || function() {
    $6ba41967632a206f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ba41967632a206f$var$__assign.apply(this, arguments);
};
var $6ba41967632a206f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6ba41967632a206f$export$1d25e17b2b722494 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6ba41967632a206f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6ba41967632a206f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.22 20.19A5.62 5.62 0 0020 18a3.72 3.72 0 00-1.69-.4H6c-3.46.15-4.37 3.68-4.37 5.52a.75.75 0 00.75.75.728.728 0 00.75-.75c0-.16.05-3.9 2.91-4h12.27a2.29 2.29 0 011 .22 4.1 4.1 0 011.62 1.59c.37.653.54 1.4.49 2.15a.749.749 0 00.7.8h.05a.75.75 0 00.75-.7 5.33 5.33 0 00-.7-2.99zM18.62 8A3.58 3.58 0 0015 4.37a.75.75 0 00-.28.05l-2.1.84a8.75 8.75 0 01-3.2.66C8.61 5.93 6 5.94 6 8v4a3.58 3.58 0 003.58 3.58H15A3.58 3.58 0 0018.62 12V8zm-1.5 4A2.078 2.078 0 0115 14.09H9.62A2.08 2.08 0 017.54 12V8c0-.43 1-.52 1.92-.53a10.24 10.24 0 003.75-.77l1.74-.7a.84.84 0 01.46-.06A2.09 2.09 0 0117.12 8v4z"
    }), $denZA.createElement("path", {
        d: "M3.3 15.24a9.72 9.72 0 001.9.51l.62.12a.75.75 0 00.3-1.47l-.65-.12a5.49 5.49 0 01-1.37-.34s-.89-.35 0-1.08a3.57 3.57 0 001.05-2.8l-.23-2.47a5.3 5.3 0 01.53-2.29A5.67 5.67 0 017 3.39a7.8 7.8 0 015-1.78c1.29 0 3.58.26 4.38 2a.75.75 0 001 .38 2.1 2.1 0 011.11-.16 1.46 1.46 0 011.06 1 6.44 6.44 0 01-.07 2.56s-.66 3.28 1.08 5.4c.104.127.187.206.221.342a.69.69 0 01-.024.413c-.1.264-.3.31-.657.455a11.88 11.88 0 01-1.66.44.75.75 0 00.16 1.48h.16c.81-.136 1.602-.364 2.36-.68 2.41-.93.26-3.68.26-3.68-.94-1.39-.45-4.25-.45-4.25a5.55 5.55 0 00-.08-3 2.89 2.89 0 00-2.17-1.9 3.25 3.25 0 00-1.31 0C16.38.93 14.48.11 11.95.11A9.31 9.31 0 006 2.24a7.16 7.16 0 00-1.9 2.41 6.84 6.84 0 00-.68 3l.24 2.46A2.83 2.83 0 012.88 12s-2.42 2.19.42 3.24z"
    }), $denZA.createElement("path", {
        d: "M10.46 9.5a.6.6 0 100-1.2.6.6 0 000 1.2zm3.65 0a.6.6 0 100-1.2.6.6 0 000 1.2zm.22 1.24a.31.31 0 00-.4.18s-.31.71-1.69.71c-1.32 0-1.57-.67-1.58-.71a.314.314 0 00-.6.18s.36 1.15 2.18 1.15c1.85 0 2.26-1.07 2.28-1.12a.31.31 0 00-.19-.39z"
    })));
});
$6ba41967632a206f$export$1d25e17b2b722494.displayName = 'LegoUserFemale2';





var $denZA = parcelRequire("denZA");
var $73bf0f6ffaaa9c8a$var$__assign = undefined && undefined.__assign || function() {
    $73bf0f6ffaaa9c8a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73bf0f6ffaaa9c8a$var$__assign.apply(this, arguments);
};
var $73bf0f6ffaaa9c8a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $73bf0f6ffaaa9c8a$export$7439bc7d574fe158 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $73bf0f6ffaaa9c8a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $73bf0f6ffaaa9c8a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#lego-user-male-1_svg__a)"
    }, $denZA.createElement("path", {
        d: "M22 20.21a5.769 5.769 0 00-2.24-2.29 3.659 3.659 0 00-1.71-.42H5.66c-3.48.16-4.39 3.85-4.39 5.77a.73.73 0 001.46 0c0-.17 0-4.18 3-4.32h12.35a2 2 0 011 .24 4.31 4.31 0 012.16 4 .729.729 0 00.68.78H22a.73.73 0 00.73-.68 5.76 5.76 0 00-.73-3.08zM19.77 5l-.9-.29.74-1.41a.81.81 0 000-.91.83.83 0 00-.93-.39l-.68.18.38-.42a1 1 0 00.3-.76.83.83 0 00-.68-.63C14.55-.27 7.36 2 7 2.11a2.52 2.52 0 00-1.15 1l-.5.86a1.52 1.52 0 00-1.21.22 1 1 0 00-.45.76c-.3 3.27.06 5.52 1.07 6.68.252.304.58.535.95.67v.8a3.1 3.1 0 003.1 3.1h6.13a3.1 3.1 0 003.1-3.1v-.25c1.39-.93 2.09-3.54 2.64-6.22 0 0 .32-1.35-.91-1.63zm-3.28 8.1a1.64 1.64 0 01-1.64 1.64H8.73a1.64 1.64 0 01-1.64-1.64V8.77a17.61 17.61 0 007.09-1.52 5 5 0 002.31 1v4.85zM5 5.4l.27.11a.94.94 0 001-.43l.74-1.26a1.07 1.07 0 01.42-.35c.06 0 5.6-1.75 9-1.76l-.89 1a.88.88 0 00-.09.94.85.85 0 00.83.44l1.35-.31-.36.69a1 1 0 00-.13.85.88.88 0 00.61.56l1.34.43A21.127 21.127 0 0118 10.47v-2.6a1 1 0 00-.9-1A3.45 3.45 0 0115 6a.93.93 0 00-1.1-.26c-.71.32-4.39 1.89-7.35 1.49 0 0-.9-.13-.94.48v2.66C5.24 9.8 4.8 8.43 5 5.4z"
    }), $denZA.createElement("path", {
        d: "M9.97 10.34a.6.6 0 100-1.2.6.6 0 000 1.2zm3.65 0a.6.6 0 100-1.2.6.6 0 000 1.2zm.22 1.24a.31.31 0 00-.4.18s-.31.71-1.69.71c-1.32 0-1.57-.67-1.58-.71a.313.313 0 10-.6.18s.36 1.15 2.18 1.15C13.59 13.09 14 12 14 12a.309.309 0 00-.16-.42z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "lego-user-male-1_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$73bf0f6ffaaa9c8a$export$7439bc7d574fe158.displayName = 'LegoUserMale1';





var $denZA = parcelRequire("denZA");
var $f9cb0fd9a8abf09e$var$__assign = undefined && undefined.__assign || function() {
    $f9cb0fd9a8abf09e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9cb0fd9a8abf09e$var$__assign.apply(this, arguments);
};
var $f9cb0fd9a8abf09e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f9cb0fd9a8abf09e$export$34456041984f8e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f9cb0fd9a8abf09e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f9cb0fd9a8abf09e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#lego-user-male-2_svg__a)"
    }, $denZA.createElement("path", {
        d: "M22.34 20.08A5.93 5.93 0 0020 17.72a3.709 3.709 0 00-1.76-.43H5.49C1.9 17.46 1 21.25 1 23.24a.75.75 0 001.5 0c0-.18.05-4.31 3.06-4.45h12.72c.349.002.692.087 1 .25a4.44 4.44 0 012.23 4.15.75.75 0 00.7.8h.05a.75.75 0 00.75-.7 5.93 5.93 0 00-.67-3.21zM5.39 12.27a3.3 3.3 0 00.93 2.31 3.132 3.132 0 002.26 1h6.31a3.13 3.13 0 001.23-.25 3.17 3.17 0 001-.72 3.31 3.31 0 00.93-2.31v-1.2a7.5 7.5 0 001.16-2.8c.58-2.42.24-4.37-1-5.81C15.69-.44 10.32 0 10 .05 7.64.43 6.93 1.3 6.69 2.19a2.29 2.29 0 00-1.27.11A2.12 2.12 0 004.2 3.52C3.1 6.3 5 10.24 5.39 11.1v1.17zm10.69 1.26a1.681 1.681 0 01-.55.38 1.61 1.61 0 01-.64.13H8.58a1.643 1.643 0 01-1.19-.51 1.83 1.83 0 01-.5-1.26V7.43a1.54 1.54 0 01.28-.95c.06-.08.41-.46 1.28-.16l.45.16a38.361 38.361 0 007.65 2.07v4.08c-.02.113-.05.223-.09.33a1.8 1.8 0 01-.38.58v-.01zM5.59 4.06A.65.65 0 016 3.7a.77.77 0 01.62 0 1 1 0 001 .05 1.14 1.14 0 00.56-1c0-.38.13-1 2.14-1.27 0 0 4.82-.42 6.86 1.93a4.43 4.43 0 01.83 3.71l-.56-.05a33.77 33.77 0 01-8-2.07L9 4.84a3.35 3.35 0 00-1.1-.2 2.28 2.28 0 00-1.89.9 3 3 0 00-.48 1.08 5.09 5.09 0 01.06-2.56z"
    }), $denZA.createElement("path", {
        d: "M9.86 9.63a.6.6 0 100-1.2.6.6 0 000 1.2zm3.64 0a.6.6 0 100-1.2.6.6 0 000 1.2zm.22 1.25a.31.31 0 00-.4.18s-.31.71-1.69.71c-1.32 0-1.57-.67-1.58-.71a.313.313 0 00-.6.18s.36 1.15 2.18 1.15c1.85 0 2.26-1.07 2.28-1.12a.31.31 0 00-.19-.39z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "lego-user-male-2_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$f9cb0fd9a8abf09e$export$34456041984f8e.displayName = 'LegoUserMale2';





var $denZA = parcelRequire("denZA");
var $777deb3ca0d33cd4$var$__assign = undefined && undefined.__assign || function() {
    $777deb3ca0d33cd4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $777deb3ca0d33cd4$var$__assign.apply(this, arguments);
};
var $777deb3ca0d33cd4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $777deb3ca0d33cd4$export$5047665d7d511e82 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $777deb3ca0d33cd4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $777deb3ca0d33cd4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12 4a11.961 11.961 0 00-8.52 3.6A12.054 12.054 0 000 16.17v2.074a2.253 2.253 0 002.246 2.246h19.508A2.253 2.253 0 0024 18.245v-2.074C24.05 9.52 18.668 4.051 12 4zm-.017 12.754h.034A2.25 2.25 0 0114.246 19H9.754a2.25 2.25 0 012.229-2.246zm10.525 1.491a.761.761 0 01-.754.755h-6c0-1.715-1.166-3.172-2.76-3.617l1.972-5.897a.736.736 0 00-.48-.943.736.736 0 00-.943.48l-2.092 6.274A3.76 3.76 0 008.263 19h-6a.761.761 0 01-.754-.755v-2.074A10.535 10.535 0 014.56 8.663 10.389 10.389 0 0112 5.509c5.828.034 10.543 4.817 10.508 10.662v2.074z"
    }), $denZA.createElement("path", {
        d: "M4.869 16.754a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm1.508-6a1.13 1.13 0 100 2.263 1.12 1.12 0 001.132-1.131 1.13 1.13 0 00-1.132-1.132zm12.754 6a1.131 1.131 0 100-2.263 1.131 1.131 0 000 2.263zm-.377-4.868c0-.6-.48-1.098-1.08-1.115h-.12a1.138 1.138 0 00-1.063 1.114 1.13 1.13 0 102.263 0zM9.429 7.754c-.018 0-.018 0 0 0h-.12a1.138 1.138 0 00-1.063 1.114A1.13 1.13 0 009.377 10a1.12 1.12 0 001.131-1.132c0-.6-.497-1.097-1.08-1.114z"
    })));
});
$777deb3ca0d33cd4$export$5047665d7d511e82.displayName = 'LevelIndicator';





var $denZA = parcelRequire("denZA");
var $b6c06cf6d43621fa$var$__assign = undefined && undefined.__assign || function() {
    $b6c06cf6d43621fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6c06cf6d43621fa$var$__assign.apply(this, arguments);
};
var $b6c06cf6d43621fa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6c06cf6d43621fa$export$b0288941685426f5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b6c06cf6d43621fa$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b6c06cf6d43621fa$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.047 4C8.835 4 5.723 5.305 3.514 7.614 1.204 9.924 0 12.935 0 16.248v2.109a2.228 2.228 0 002.209 2.208H7.83c.502 0 .401-1.004.401-1.506 0-1.907 1.406-3.413 3.213-3.714l2.108-6.325c.1-.402.502-.603.904-.502.402.1.602.502.502.903l-2.008 5.924c1.406.401 2.41 1.506 2.71 2.911 0 .201.101.502.101.703 0 .502-.301 1.506.502 1.506h5.522a2.228 2.228 0 002.209-2.209v-2.108C24.195 9.522 18.774 4.1 12.047 4zm7.028 7.931c0 .803-.602 1.406-1.405 1.406-.804 0-1.406-.603-1.406-1.406 0-.702.602-1.305 1.305-1.405h.1c.804 0 1.406.703 1.406 1.405zm.1 5.12c-.803 0-1.405-.602-1.405-1.405s.602-1.406 1.406-1.406c.803 0 1.405.603 1.405 1.406 0 .803-.602 1.405-1.405 1.405zM7.029 13.137c-.201.1-.402.2-.603.2-.803 0-1.405-.702-1.405-1.405 0-.803.602-1.405 1.405-1.405.201 0 .402.1.603.2.401.201.803.703.803 1.205 0 .502-.301 1.004-.803 1.205zm-2.11 1.103c.804 0 1.406.603 1.406 1.406 0 .803-.602 1.405-1.406 1.405-.803 0-1.405-.602-1.405-1.405 0-.703.602-1.406 1.405-1.406zm4.518-4.015c-.803 0-1.405-.603-1.405-1.306 0-.2.1-.401.2-.602a1.235 1.235 0 011.105-.703h.1c.502 0 .904.301 1.205.703.1.2.2.402.2.602 0 .703-.702 1.306-1.405 1.306z"
    })));
});
$b6c06cf6d43621fa$export$b0288941685426f5.displayName = 'LevelIndicatorBold';





var $denZA = parcelRequire("denZA");
var $b9ce7a764990ed94$var$__assign = undefined && undefined.__assign || function() {
    $b9ce7a764990ed94$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9ce7a764990ed94$var$__assign.apply(this, arguments);
};
var $b9ce7a764990ed94$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b9ce7a764990ed94$export$a6c7ac8248d6e38a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b9ce7a764990ed94$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b9ce7a764990ed94$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.2 4.3c-.9-.9-2-1.3-3.2-1.3-1.2 0-2.4.5-3.2 1.3-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0 1.2-1.2 3.2-1.2 4.4 0 .4.6.7 1.4.7 2.2 0 .8-.3 1.6-.9 2.2l-5.6 5.6c-.5.5-1.3.9-2.1.9s-1.5-.2-2.1-.7c-.6-.5-1-1.2-1.1-2 0-.8.2-1.6.6-2.2.2-.3.2-.8-.2-1-.3-.2-.8-.2-1 .2-.7.9-1 2.1-.8 3.2.1 1.1.7 2.2 1.6 2.9.8.7 1.9 1.1 3 1.1h.2c1.2 0 2.2-.5 3.1-1.3l5.6-5.6c.9-.9 1.3-2 1.3-3.2 0-1.2-.6-2.5-1.4-3.4z"
    }), $denZA.createElement("path", {
        d: "M7.8 17.8c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2L9 7.8c.5-.5 1.3-.8 2-.9.8 0 1.5.2 2.1.7.6.5 1 1.2 1.1 2 .1.8-.1 1.5-.6 2.2-.2.3-.2.8.2 1 .3.2.8.2 1-.2.7-.9 1-2.1.8-3.2-.1-1.1-.7-2.2-1.6-2.9-.9-.8-2-1.1-3.2-1.1-1 .1-2.1.6-2.9 1.4l-5.6 5.6c-.9.9-1.3 2-1.3 3.2 0 1.2.5 2.4 1.3 3.2.9.9 2 1.3 3.2 1.3 1.2 0 2.4-.5 3.2-1.3.3-.3.3-.8 0-1.1-.3-.3-.6-.2-.9.1z"
    })));
});
$b9ce7a764990ed94$export$a6c7ac8248d6e38a.displayName = 'Link';





var $denZA = parcelRequire("denZA");
var $6f247f6106754724$var$__assign = undefined && undefined.__assign || function() {
    $6f247f6106754724$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f247f6106754724$var$__assign.apply(this, arguments);
};
var $6f247f6106754724$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6f247f6106754724$export$6343830e6ea0f555 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6f247f6106754724$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6f247f6106754724$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M17.02 6.183a2.331 2.331 0 113.297 3.297l-5.588 5.588a2.332 2.332 0 01-3.536-3.018 1.5 1.5 0 00-2.426-1.764 5.332 5.332 0 008.085 6.902l5.586-5.586a5.331 5.331 0 10-7.54-7.54 1.5 1.5 0 102.122 2.12z"
    }), $denZA.createElement("path", {
        d: "M6.98 17.506a2.332 2.332 0 01-3.297-3.298L9.27 8.62a2.332 2.332 0 013.536 3.019 1.5 1.5 0 002.426 1.764A5.331 5.331 0 007.148 6.5l-5.586 5.587a5.332 5.332 0 007.54 7.54 1.5 1.5 0 10-2.122-2.121z"
    })));
});
$6f247f6106754724$export$6343830e6ea0f555.displayName = 'LinkBold';





var $denZA = parcelRequire("denZA");
var $2cc9f4ca7e315f1a$var$__assign = undefined && undefined.__assign || function() {
    $2cc9f4ca7e315f1a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2cc9f4ca7e315f1a$var$__assign.apply(this, arguments);
};
var $2cc9f4ca7e315f1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2cc9f4ca7e315f1a$export$633fe2b1e4202809 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2cc9f4ca7e315f1a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2cc9f4ca7e315f1a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.356 0h19.267a2.369 2.369 0 012.363 2.361v8.133a.75.75 0 01-1.5 0V5.997H1.5v12.625a.87.87 0 00.866.867H6.76a.75.75 0 010 1.499h-4.4A2.369 2.369 0 010 18.625V2.353A2.36 2.36 0 012.353 0h.003zm-.857 4.497h20.988V2.365a.87.87 0 00-.867-.866H2.357a.862.862 0 00-.858.858v2.14z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M17.643 12.835a.75.75 0 010 1.06l-2.998 2.998a.75.75 0 01-1.06 0l-1.5-1.499a.75.75 0 111.06-1.06l.97.97 2.468-2.469a.75.75 0 011.06 0z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.331 8.749a6.62 6.62 0 017.714 10.236l3.735 3.735a.75.75 0 11-1.06 1.06l-3.735-3.735a6.621 6.621 0 01-10.236-2.648 6.62 6.62 0 013.582-8.648zm2.533.995a5.121 5.121 0 100 10.242 5.121 5.121 0 000-10.242z",
        fillRule: "evenodd"
    })));
});
$2cc9f4ca7e315f1a$export$633fe2b1e4202809.displayName = 'ListSearch';





var $denZA = parcelRequire("denZA");
var $30188e823e59a3cd$var$__assign = undefined && undefined.__assign || function() {
    $30188e823e59a3cd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30188e823e59a3cd$var$__assign.apply(this, arguments);
};
var $30188e823e59a3cd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $30188e823e59a3cd$export$21cdcd57c45bce1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $30188e823e59a3cd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $30188e823e59a3cd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 17.5h6.25a1 1 0 110 2H3a3 3 0 01-3-3V3a3 3 0 013-3h15.5a3 3 0 013 3v6.75a1 1 0 11-2 0V7.5A.5.5 0 0019 7H2.5a.5.5 0 00-.5.5v9a1 1 0 001 1zm8-14a1 1 0 10-2 0 1 1 0 002 0zm-4-1a1 1 0 110 2 1 1 0 010-2zm-2 1a1 1 0 10-2 0 1 1 0 002 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.64 19.948a.25.25 0 00.034.311l2.033 2.033a1 1 0 01-1.414 1.415l-2.033-2.034a.251.251 0 00-.311-.033 5.5 5.5 0 111.69-1.692zM13.5 17a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10.528 9.059l-3.41 3.558a.25.25 0 01-.361 0l-.535-.558a1 1 0 10-1.444 1.383l1.438 1.5a1 1 0 001.443 0l4.313-4.5a1 1 0 10-1.444-1.383z"
    })));
});
$30188e823e59a3cd$export$21cdcd57c45bce1.displayName = 'ListSearchBold';





var $denZA = parcelRequire("denZA");
var $fccfd7ab03204944$var$__assign = undefined && undefined.__assign || function() {
    $fccfd7ab03204944$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fccfd7ab03204944$var$__assign.apply(this, arguments);
};
var $fccfd7ab03204944$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fccfd7ab03204944$export$18a2be9195644f38 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fccfd7ab03204944$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fccfd7ab03204944$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.43 5.063a4.5 4.5 0 10-6.36 6.368 4.5 4.5 0 006.36-6.368zm-1.06 5.3a3 3 0 11-4.24-4.246 3 3 0 014.24 4.246z"
    }), $denZA.createElement("path", {
        d: "M18.08 2.413A8.25 8.25 0 004 8.243a11.07 11.07 0 00.87 3.61 43.988 43.988 0 002 4.32c1.48 2.93 3.22 5.82 4.13 7.15a1.5 1.5 0 002.5 0c.91-1.38 2.65-4.22 4.15-7.14a43.99 43.99 0 002-4.32 11.07 11.07 0 00.87-3.61 8.251 8.251 0 00-2.44-5.84zm.17 8.91a42.57 42.57 0 01-1.91 4.17c-1.48 2.87-3.18 5.67-4.07 7-.89-1.34-2.59-4.13-4.07-7a42.557 42.557 0 01-1.95-4.17 9.75 9.75 0 01-.77-3.08 6.75 6.75 0 0113.5 0 9.748 9.748 0 01-.73 3.08z"
    })));
});
$fccfd7ab03204944$export$18a2be9195644f38.displayName = 'Location';





var $denZA = parcelRequire("denZA");
var $29ac7a9fd4625442$var$__assign = undefined && undefined.__assign || function() {
    $29ac7a9fd4625442$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $29ac7a9fd4625442$var$__assign.apply(this, arguments);
};
var $29ac7a9fd4625442$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $29ac7a9fd4625442$export$d63fce71f4dc7df5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $29ac7a9fd4625442$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $29ac7a9fd4625442$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.08 2.413A8.25 8.25 0 004 8.243a11.08 11.08 0 00.87 3.61 43.988 43.988 0 002 4.32c1.48 2.93 3.22 5.82 4.13 7.15a1.5 1.5 0 002.5 0c.91-1.38 2.65-4.22 4.15-7.14a43.99 43.99 0 002-4.32 11.09 11.09 0 00.87-3.61 8.251 8.251 0 00-2.44-5.84zm-3.53 8.13a3.25 3.25 0 11-4.499-4.69 3.25 3.25 0 014.499 4.69z"
    })));
});
$29ac7a9fd4625442$export$d63fce71f4dc7df5.displayName = 'LocationBold';





var $denZA = parcelRequire("denZA");
var $bc05220aaf65695e$var$__assign = undefined && undefined.__assign || function() {
    $bc05220aaf65695e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc05220aaf65695e$var$__assign.apply(this, arguments);
};
var $bc05220aaf65695e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc05220aaf65695e$export$5b9db7ce80343746 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bc05220aaf65695e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bc05220aaf65695e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.75 14a.75.75 0 00-1.5 0v3a.75.75 0 001.5 0v-3z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6 6v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V8.75a.75.75 0 00-.75-.75H18V6A6 6 0 106 6zm6-4.5A4.5 4.5 0 007.5 6v2h9V6A4.5 4.5 0 0012 1.5zm-7.5 8h15v12h-15v-12z",
        fillRule: "evenodd"
    })));
});
$bc05220aaf65695e$export$5b9db7ce80343746.displayName = 'Lock';





var $denZA = parcelRequire("denZA");
var $410ad557f334fe00$var$__assign = undefined && undefined.__assign || function() {
    $410ad557f334fe00$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $410ad557f334fe00$var$__assign.apply(this, arguments);
};
var $410ad557f334fe00$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $410ad557f334fe00$export$4038de8e7cd615d7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $410ad557f334fe00$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $410ad557f334fe00$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .62a6.375 6.375 0 00-6.375 6.375v2H3.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75v-13.5a.75.75 0 00-.75-.75h-1.875v-2A6.375 6.375 0 0012 .62zm4.125 6.375v2h-8.25v-2a4.125 4.125 0 018.25 0zm-5.25 8a1.125 1.125 0 012.25 0v3a1.125 1.125 0 01-2.25 0v-3z",
        fillRule: "evenodd"
    })));
});
$410ad557f334fe00$export$4038de8e7cd615d7.displayName = 'LockBold';





var $denZA = parcelRequire("denZA");
var $4fcbfe3644bb30fa$var$__assign = undefined && undefined.__assign || function() {
    $4fcbfe3644bb30fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fcbfe3644bb30fa$var$__assign.apply(this, arguments);
};
var $4fcbfe3644bb30fa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4fcbfe3644bb30fa$export$88195aaac9f90319 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4fcbfe3644bb30fa$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4fcbfe3644bb30fa$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.793 1l.04.001a2.324 2.324 0 011.574.711c.401.422.613.977.591 1.546v17.485a2.125 2.125 0 01-.59 1.545 2.325 2.325 0 01-1.615.712H9.297a2.325 2.325 0 01-1.615-.712 2.125 2.125 0 01-.592-1.546V16.38c0-.432.367-.782.819-.782.451 0 .818.35.818.782v4.38l-.001.035a.6.6 0 00.167.442.657.657 0 00.429.2h12.446a.656.656 0 00.428-.2.6.6 0 00.166-.478V3.242l.001-.036a.6.6 0 00-.167-.442.656.656 0 00-.428-.2H9.322a.657.657 0 00-.429.2.6.6 0 00-.166.478V7.62c0 .432-.367.782-.818.782-.452 0-.819-.35-.819-.782V3.257a2.125 2.125 0 01.592-1.545A2.325 2.325 0 019.297 1h12.496z"
    }), $denZA.createElement("path", {
        d: "M12.457 7.802c-.32.305-.32.8 0 1.106l2.421 2.314H.818c-.452 0-.818.35-.818.782 0 .432.366.782.818.782h14.06L12.457 15.1c-.32.306-.32.8 0 1.106a.845.845 0 001.157 0l3.814-3.646a.797.797 0 00.177-.246.751.751 0 00-.173-.863L13.614 7.8a.845.845 0 00-1.157 0z"
    })));
});
$4fcbfe3644bb30fa$export$88195aaac9f90319.displayName = 'LogIn';





var $denZA = parcelRequire("denZA");
var $417d2d4ed141c7fd$var$__assign = undefined && undefined.__assign || function() {
    $417d2d4ed141c7fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $417d2d4ed141c7fd$var$__assign.apply(this, arguments);
};
var $417d2d4ed141c7fd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $417d2d4ed141c7fd$export$c9b57264511cea21 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $417d2d4ed141c7fd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $417d2d4ed141c7fd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.168.5a2.905 2.905 0 012.079.945c.506.556.775 1.286.752 2.035v17.04a2.886 2.886 0 01-.753 2.035 2.906 2.906 0 01-2.078.945H9.47c-.026 0-.051 0-.076-.002a2.906 2.906 0 01-2.003-.943 2.886 2.886 0 01-.753-2.035v-2.21a1.53 1.53 0 011.532-1.526 1.53 1.53 0 011.532 1.527v2.136h11.233V3.553H9.702v2.545A1.53 1.53 0 018.17 7.624a1.53 1.53 0 01-1.532-1.526V3.479a2.888 2.888 0 01.752-2.034A2.906 2.906 0 019.47.5h11.697z"
    }), $denZA.createElement("path", {
        d: "M11.886 7.362a1.523 1.523 0 000 2.16l.96.955H1.531A1.53 1.53 0 000 12.004a1.53 1.53 0 001.532 1.526h11.313l-.959.956a1.523 1.523 0 000 2.16 1.536 1.536 0 002.167 0l3.569-3.558.048-.05a1.519 1.519 0 00-.043-2.114l-3.574-3.562a1.536 1.536 0 00-2.167 0z"
    })));
});
$417d2d4ed141c7fd$export$c9b57264511cea21.displayName = 'LogInBold';





var $denZA = parcelRequire("denZA");
var $1e6c75d714a88e65$var$__assign = undefined && undefined.__assign || function() {
    $1e6c75d714a88e65$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e6c75d714a88e65$var$__assign.apply(this, arguments);
};
var $1e6c75d714a88e65$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1e6c75d714a88e65$export$f292abd37582246c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1e6c75d714a88e65$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1e6c75d714a88e65$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.874 1l.04.001a2.196 2.196 0 012.084 2.272v17.454A2.195 2.195 0 0121.875 23H9.947l-.04-.001a2.197 2.197 0 01-2.085-2.272v-4.355a.8.8 0 011.6 0v4.371l-.001.036a.596.596 0 00.55.622H21.85a.597.597 0 00.55-.658V3.22a.595.595 0 00-.55-.62H9.972a.597.597 0 00-.55.657v4.371a.8.8 0 01-1.6 0V3.273A2.195 2.195 0 019.948 1h11.927z"
    }), $denZA.createElement("path", {
        d: "M5.01 7.795a.8.8 0 00-1.131 0L.242 11.431a.797.797 0 000 1.147l3.637 3.634a.8.8 0 001.131-1.13l-2.279-2.278h13.375a.8.8 0 100-1.6H2.73l2.28-2.278a.8.8 0 000-1.13z"
    })));
});
$1e6c75d714a88e65$export$f292abd37582246c.displayName = 'LogOut';





var $denZA = parcelRequire("denZA");
var $23bdd12c005c1a5b$var$__assign = undefined && undefined.__assign || function() {
    $23bdd12c005c1a5b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23bdd12c005c1a5b$var$__assign.apply(this, arguments);
};
var $23bdd12c005c1a5b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23bdd12c005c1a5b$export$e2c9b76f2918cc76 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $23bdd12c005c1a5b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $23bdd12c005c1a5b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.257.5a2.767 2.767 0 012.013.954c.49.561.751 1.298.729 2.054v16.984a2.987 2.987 0 01-.73 2.054 2.767 2.767 0 01-2.012.954H10.076c-.025 0-.05 0-.075-.002a2.768 2.768 0 01-1.939-.952 2.987 2.987 0 01-.73-2.053v-2.066c0-.861.672-1.56 1.5-1.56.83 0 1.5.699 1.5 1.56v1.955H21V3.618H10.333v1.818c0 .861-.672 1.56-1.5 1.56-.829 0-1.5-.699-1.5-1.56V3.508a2.987 2.987 0 01.73-2.054A2.768 2.768 0 0110.075.5h11.18z"
    }), $denZA.createElement("path", {
        d: "M5.977 7.351a1.46 1.46 0 00-2.121 0L.45 10.891a1.553 1.553 0 00-.283.398 1.602 1.602 0 00-.167.715 1.6 1.6 0 00.45 1.113l3.406 3.54a1.46 1.46 0 002.121 0 1.602 1.602 0 000-2.205l-.856-.89H15.85c.828 0 1.5-.697 1.5-1.558 0-.861-.672-1.56-1.5-1.56H5.121l.856-.888a1.602 1.602 0 000-2.205z"
    })));
});
$23bdd12c005c1a5b$export$e2c9b76f2918cc76.displayName = 'LogOutBold';





var $denZA = parcelRequire("denZA");
var $bb74813ab2db5cc9$var$__assign = undefined && undefined.__assign || function() {
    $bb74813ab2db5cc9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb74813ab2db5cc9$var$__assign.apply(this, arguments);
};
var $bb74813ab2db5cc9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bb74813ab2db5cc9$export$2a4143257785f953 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bb74813ab2db5cc9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bb74813ab2db5cc9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M5.5 12a2 2 0 11-4 0 2 2 0 014 0zm8.5 0a2 2 0 11-4 0 2 2 0 014 0zm6.5 2a2 2 0 100-4 2 2 0 000 4z"
    })));
});
$bb74813ab2db5cc9$export$2a4143257785f953.displayName = 'MenuNavigationHorizontal';





var $denZA = parcelRequire("denZA");
var $97787fa0c9c3b115$var$__assign = undefined && undefined.__assign || function() {
    $97787fa0c9c3b115$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $97787fa0c9c3b115$var$__assign.apply(this, arguments);
};
var $97787fa0c9c3b115$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $97787fa0c9c3b115$export$e01a035729e5e1c1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $97787fa0c9c3b115$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $97787fa0c9c3b115$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.5 12a3 3 0 11-6 0 3 3 0 016 0zm8.5 0a3 3 0 11-6 0 3 3 0 016 0zm5.5 3a3 3 0 100-6 3 3 0 000 6z"
    })));
});
$97787fa0c9c3b115$export$e01a035729e5e1c1.displayName = 'MenuNavigationHorizontalBold';





var $denZA = parcelRequire("denZA");
var $34fc13c552d17e23$var$__assign = undefined && undefined.__assign || function() {
    $34fc13c552d17e23$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34fc13c552d17e23$var$__assign.apply(this, arguments);
};
var $34fc13c552d17e23$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $34fc13c552d17e23$export$56dbed97f074c6e4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $34fc13c552d17e23$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $34fc13c552d17e23$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.75 16.903a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5zm0-6a1.1 1.1 0 01.12 2.194l-.12.006H2.25a1.1 1.1 0 01-.12-2.194l.12-.006h19.5z"
    })));
});
$34fc13c552d17e23$export$56dbed97f074c6e4.displayName = 'MenuNavigationVertical';





var $denZA = parcelRequire("denZA");
var $c7cecf26756dff5f$var$__assign = undefined && undefined.__assign || function() {
    $c7cecf26756dff5f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7cecf26756dff5f$var$__assign.apply(this, arguments);
};
var $c7cecf26756dff5f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c7cecf26756dff5f$export$e738f441fd7fb6d9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c7cecf26756dff5f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c7cecf26756dff5f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1 6.5A1.5 1.5 0 012.5 5h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 6.5zm0 6A1.5 1.5 0 012.5 11h19a1.5 1.5 0 010 3h-19A1.5 1.5 0 011 12.5zM2.5 17a1.5 1.5 0 000 3h19a1.5 1.5 0 000-3h-19z"
    })));
});
$c7cecf26756dff5f$export$e738f441fd7fb6d9.displayName = 'MenuNavigationVerticalBold';





var $denZA = parcelRequire("denZA");
var $b32c55afd2ea2fea$var$__assign = undefined && undefined.__assign || function() {
    $b32c55afd2ea2fea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b32c55afd2ea2fea$var$__assign.apply(this, arguments);
};
var $b32c55afd2ea2fea$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b32c55afd2ea2fea$export$7ea9ef770fb4c9ec = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b32c55afd2ea2fea$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b32c55afd2ea2fea$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 7.5a.75.75 0 01.75-.75h13.5a.75.75 0 010 1.5H5.25a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H5.25A.75.75 0 014.5 12z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 1.5a.75.75 0 00-.75.75v15a.75.75 0 00.75.75h3a.75.75 0 01.75.75v3l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25zM.659.659A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5H2.25A2.25 2.25 0 010 17.25v-15C0 1.653.237 1.081.659.659z",
        fillRule: "evenodd"
    })));
});
$b32c55afd2ea2fea$export$7ea9ef770fb4c9ec.displayName = 'MessageBubble';





var $denZA = parcelRequire("denZA");
var $54db6ff637c85488$var$__assign = undefined && undefined.__assign || function() {
    $54db6ff637c85488$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $54db6ff637c85488$var$__assign.apply(this, arguments);
};
var $54db6ff637c85488$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $54db6ff637c85488$export$d4ce8b96ad0e2e48 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $54db6ff637c85488$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $54db6ff637c85488$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2.25 0A2.25 2.25 0 000 2.25v15a2.25 2.25 0 002.25 2.25H4.5v3.75a.75.75 0 001.2.6l5.8-4.35h10.25A2.25 2.25 0 0024 17.25v-15A2.25 2.25 0 0021.75 0H2.25z"
    })));
});
$54db6ff637c85488$export$d4ce8b96ad0e2e48.displayName = 'MessageBubbleBold';





var $denZA = parcelRequire("denZA");
var $7f1580a371945f98$var$__assign = undefined && undefined.__assign || function() {
    $7f1580a371945f98$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7f1580a371945f98$var$__assign.apply(this, arguments);
};
var $7f1580a371945f98$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7f1580a371945f98$export$da45d96ed490d127 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7f1580a371945f98$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7f1580a371945f98$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.913 12a.75.75 0 01-.75.75H.837a.75.75 0 010-1.5h22.326a.75.75 0 01.75.75z",
        fillRule: "evenodd"
    })));
});
$7f1580a371945f98$export$da45d96ed490d127.displayName = 'Minus';





var $denZA = parcelRequire("denZA");
var $ad12d0e9373faad2$var$__assign = undefined && undefined.__assign || function() {
    $ad12d0e9373faad2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad12d0e9373faad2$var$__assign.apply(this, arguments);
};
var $ad12d0e9373faad2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ad12d0e9373faad2$export$b7a01a7ec68fd5c0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ad12d0e9373faad2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ad12d0e9373faad2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.935 12a1.5 1.5 0 01-1.5 1.5H1.565a1.5 1.5 0 010-3h20.87a1.5 1.5 0 011.5 1.5z",
        fillRule: "evenodd"
    })));
});
$ad12d0e9373faad2$export$b7a01a7ec68fd5c0.displayName = 'MinusBold';





var $denZA = parcelRequire("denZA");
var $4ac8f321f0c3babf$var$__assign = undefined && undefined.__assign || function() {
    $4ac8f321f0c3babf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ac8f321f0c3babf$var$__assign.apply(this, arguments);
};
var $4ac8f321f0c3babf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ac8f321f0c3babf$export$efb402128debec0d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4ac8f321f0c3babf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4ac8f321f0c3babf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#money-bag_svg__a)"
    }, $denZA.createElement("path", {
        d: "M12.905 17.868a.59.59 0 01-.38.14h-2a.75.75 0 000 1.5h.75a.75.75 0 001.5 0 2.09 2.09 0 00.56-4l-2.06-.831a.59.59 0 01.22-1.14h2a.75.75 0 000-1.5h-.75a.75.75 0 10-1.5 0 2.09 2.09 0 00-.56 4l2.06.83a.59.59 0 01.3.26.59.59 0 01-.14.741zM6.743 8.995h10.504a.75.75 0 100-1.5H6.743a.75.75 0 000 1.5zm1.001-3.681a.75.75 0 001.34-.67l-1.41-2.821 1.89.95a1.49 1.49 0 001.921-.51l.51-.77.5.77a1.5 1.5 0 001.921.51l1.9-.95-1.43 2.87a.75.75 0 001.34.67l1.441-2.88a1.5 1.5 0 00-2-2l-1.901 1-.5-.76a1.51 1.51 0 00-.56-.55 1.53 1.53 0 00-1.411 0 1.5 1.5 0 00-.54.49l-.51.76-1.901-.95A1.51 1.51 0 006.792.61a1.5 1.5 0 00-.459 1.882l1.41 2.82z"
    }), $denZA.createElement("path", {
        d: "M21.538 16.658a6.702 6.702 0 00-1.38-3.482l-2.761-3.17a.758.758 0 10-1.14 1l2.74 3.17a5.182 5.182 0 01-4.1 8.344H9.103a5.182 5.182 0 01-4.111-8.343l2.76-3.201a.758.758 0 10-1.14-1l-2.81 3.27A6.682 6.682 0 009.103 24h5.792a6.682 6.682 0 006.652-7.342h-.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "money-bag_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$4ac8f321f0c3babf$export$efb402128debec0d.displayName = 'MoneyBag';





var $denZA = parcelRequire("denZA");
var $eb75d697dfc83a30$var$__assign = undefined && undefined.__assign || function() {
    $eb75d697dfc83a30$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eb75d697dfc83a30$var$__assign.apply(this, arguments);
};
var $eb75d697dfc83a30$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $eb75d697dfc83a30$export$a58337d80e33a544 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $eb75d697dfc83a30$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $eb75d697dfc83a30$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#money-bag-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M7.736 6.76a.75.75 0 00.7.48h7.14a.75.75 0 00.71-.5l1.45-3.9a2 2 0 00.1-1 1.9 1.9 0 00-.41-.84 1.47 1.47 0 00-.86-.56 1.33 1.33 0 00-1 .22l-1.83 1.19-.5-1a1.63 1.63 0 00-.5-.6 1.4 1.4 0 00-.8-.25 1.35 1.35 0 00-.79.27 1.64 1.64 0 00-.5.61l-.48 1L8.396.72a1.33 1.33 0 00-1-.19 1.46 1.46 0 00-.84.58 1.9 1.9 0 00-.38.89 2.07 2.07 0 00.12 1l1.44 3.76zM21.546 16a7.659 7.659 0 00-1.36-3.73l-2.76-3.51a.75.75 0 00-.59-.29h-9.67a.75.75 0 00-.59.29l-2.79 3.56A7.64 7.64 0 002.456 16a7.84 7.84 0 00.64 3.9 7.1 7.1 0 002.45 3 6.28 6.28 0 003.56 1.1h5.79a6.28 6.28 0 003.56-1.12 7.1 7.1 0 002.45-3 7.84 7.84 0 00.64-3.88zm-6.71 2.85a2.33 2.33 0 01-1.87 1.86 1 1 0 01-1.91 0h-.55a1 1 0 010-2h2a.34.34 0 00.12-.66l-2.06-.82a2.34 2.34 0 01.45-4.47 1 1 0 011.91 0h.55a1 1 0 010 2h-2a.34.34 0 00-.22.08.34.34 0 00.09.58l2.06.82a2.34 2.34 0 011.43 2.62v-.01z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "money-bag-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$eb75d697dfc83a30$export$a58337d80e33a544.displayName = 'MoneyBagBold';





var $denZA = parcelRequire("denZA");
var $0a261d925d0f462f$var$__assign = undefined && undefined.__assign || function() {
    $0a261d925d0f462f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a261d925d0f462f$var$__assign.apply(this, arguments);
};
var $0a261d925d0f462f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0a261d925d0f462f$export$e49a5ad3dd6df925 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0a261d925d0f462f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0a261d925d0f462f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.47 5.532a.75.75 0 010-1.06l3-3a.75.75 0 011.06 0l3 3a.75.75 0 01-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06l-1.72 1.72h7.44v-7.44l-1.72 1.72a.75.75 0 01-1.06 0z"
    })));
});
$0a261d925d0f462f$export$e49a5ad3dd6df925.displayName = 'Move';





var $denZA = parcelRequire("denZA");
var $15c55fb11e173361$var$__assign = undefined && undefined.__assign || function() {
    $15c55fb11e173361$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15c55fb11e173361$var$__assign.apply(this, arguments);
};
var $15c55fb11e173361$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $15c55fb11e173361$export$a3c5fa6436f5d841 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $15c55fb11e173361$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $15c55fb11e173361$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.94 6.06a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 012.12 0l3 3a1.5 1.5 0 01-2.12 2.12l-.44-.439V10.5h4.879l-.44-.44a1.5 1.5 0 012.122-2.12l3 3a1.5 1.5 0 010 2.12l-3 3a1.5 1.5 0 01-2.122-2.12l.44-.44H13.5v4.879l.44-.44a1.5 1.5 0 012.12 2.122l-3 3a1.5 1.5 0 01-2.12 0l-3-3a1.5 1.5 0 012.12-2.122l.44.44V13.5H5.621l.44.44a1.5 1.5 0 01-2.122 2.12l-3-3a1.5 1.5 0 010-2.12l3-3a1.5 1.5 0 112.122 2.12l-.44.44H10.5V5.621l-.44.44a1.5 1.5 0 01-2.12 0z"
    })));
});
$15c55fb11e173361$export$a3c5fa6436f5d841.displayName = 'MoveBold';





var $denZA = parcelRequire("denZA");
var $ee80226f99d88ea7$var$__assign = undefined && undefined.__assign || function() {
    $ee80226f99d88ea7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ee80226f99d88ea7$var$__assign.apply(this, arguments);
};
var $ee80226f99d88ea7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ee80226f99d88ea7$export$8336555462a952f6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ee80226f99d88ea7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ee80226f99d88ea7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.71 19.03a3.104 3.104 0 003.1-3.1v-7.8l6.81-1.11v3.91a3.055 3.055 0 00-3.05.21c-.51.34-.91.82-1.14 1.39-.23.57-.3 1.19-.18 1.79.12.6.41 1.15.85 1.59.43.43.99.73 1.59.85.6.12 1.22.06 1.79-.18a3.04 3.04 0 001.39-1.14c.34-.51.52-1.11.52-1.72v-7.8a.865.865 0 00-.06-.39.938.938 0 00-.23-.33.801.801 0 00-.35-.19.772.772 0 00-.4-.02L9.77 6.5c-.2.03-.39.14-.52.3-.14.16-.21.36-.21.57v5.77c-.42-.2-.88-.3-1.34-.3-.46 0-.92.11-1.34.31a3.09 3.09 0 00-1.66 2.1c-.1.45-.1.92 0 1.38.11.45.31.88.6 1.24s.66.66 1.08.86c.41.2.87.3 1.33.3zm8.58-4.02a1.333 1.333 0 01-1.33-1.33 1.333 1.333 0 011.33-1.33 1.333 1.333 0 011.33 1.33 1.333 1.333 0 01-1.33 1.33zm-8.58-.44a1.333 1.333 0 011.33 1.33 1.333 1.333 0 01-1.33 1.33 1.333 1.333 0 01-1.33-1.33 1.333 1.333 0 011.33-1.33z"
    }), $denZA.createElement("path", {
        d: "M22.2 1.5c.17 0 .3.14.3.3v20.4a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h20.4zm0-1.5H1.8C.81 0 0 .81 0 1.8v20.4c0 1 .81 1.8 1.8 1.8h20.4c1 0 1.8-.81 1.8-1.8V1.8c0-.99-.81-1.8-1.8-1.8z"
    })));
});
$ee80226f99d88ea7$export$8336555462a952f6.displayName = 'Music';





var $denZA = parcelRequire("denZA");
var $bbf98c7c55eacbdb$var$__assign = undefined && undefined.__assign || function() {
    $bbf98c7c55eacbdb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbf98c7c55eacbdb$var$__assign.apply(this, arguments);
};
var $bbf98c7c55eacbdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bbf98c7c55eacbdb$export$a030be0b63868e45 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bbf98c7c55eacbdb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bbf98c7c55eacbdb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.71 19.03a3.104 3.104 0 003.1-3.1v-7.8l6.81-1.11v3.91a3.055 3.055 0 00-3.05.21c-.51.34-.91.82-1.14 1.39-.23.57-.3 1.19-.18 1.79.12.6.41 1.15.85 1.59.43.43.99.73 1.59.85.6.12 1.22.06 1.79-.18a3.04 3.04 0 001.39-1.14c.34-.51.52-1.11.52-1.72v-7.8a.865.865 0 00-.06-.39.938.938 0 00-.23-.33.801.801 0 00-.35-.19.772.772 0 00-.4-.02L9.77 6.5c-.2.03-.39.14-.52.3-.14.16-.21.36-.21.57v5.77c-.42-.2-.88-.3-1.34-.3-.46 0-.92.11-1.34.31a3.09 3.09 0 00-1.66 2.1c-.1.45-.1.92 0 1.38.11.45.31.88.6 1.24s.66.66 1.08.86c.41.2.87.3 1.33.3zm8.58-4.02a1.333 1.333 0 01-1.33-1.33 1.333 1.333 0 011.33-1.33 1.333 1.333 0 011.33 1.33 1.333 1.333 0 01-1.33 1.33zm-8.58-.44a1.333 1.333 0 011.33 1.33 1.333 1.333 0 01-1.33 1.34 1.333 1.333 0 01-1.33-1.33 1.333 1.333 0 011.33-1.33v-.01zM22.2 24H1.8c-1 0-1.8-.81-1.8-1.8V1.8C0 .81.81 0 1.8 0h20.4c1 0 1.8.81 1.8 1.8v20.4c0 .99-.81 1.8-1.8 1.8z"
    })));
});
$bbf98c7c55eacbdb$export$a030be0b63868e45.displayName = 'MusicBold';





var $denZA = parcelRequire("denZA");
var $6e8ce04f200066e2$var$__assign = undefined && undefined.__assign || function() {
    $6e8ce04f200066e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e8ce04f200066e2$var$__assign.apply(this, arguments);
};
var $6e8ce04f200066e2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6e8ce04f200066e2$export$8b041a66c49f4118 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6e8ce04f200066e2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6e8ce04f200066e2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.48 17.14c.36 0 .73-.07 1.06-.21.34-.14.65-.34.9-.6.26-.26.46-.57.6-.9.14-.34.21-.7.21-1.07v-7l6.11-1v3.51c-.37-.18-.78-.27-1.19-.27-.55 0-1.09.16-1.54.47-.46.31-.81.74-1.02 1.25a2.775 2.775 0 003.63 3.63c.51-.21.94-.57 1.25-1.02.31-.46.47-.99.47-1.54v-7c0-.12-.02-.23-.07-.34a.705.705 0 00-.21-.27.832.832 0 00-.66-.18l-7.7 1.3c-.18.03-.35.12-.47.27-.12.14-.18.33-.18.51v5.18c-.38-.18-.79-.28-1.21-.28-.42 0-.83.09-1.21.27-.38.18-.71.45-.97.77s-.44.71-.54 1.12c-.09.41-.09.83.01 1.24.1.41.28.79.54 1.12.26.33.6.59.98.77.37.19.79.28 1.21.27zm7.7-3.57a1.191 1.191 0 01-1.17-1.42 1.22 1.22 0 01.94-.94c.23-.05.47-.02.69.07.22.09.4.24.53.44s.2.43.2.66c0 .32-.12.62-.35.84-.23.23-.53.35-.84.35zm-7.7-.43a1.191 1.191 0 011.17 1.42 1.22 1.22 0 01-.94.94c-.23.05-.47.02-.69-.07-.22-.09-.4-.24-.53-.44s-.2-.43-.2-.66c0-.32.12-.62.35-.84.22-.22.52-.35.84-.35z"
    }), $denZA.createElement("path", {
        d: "M19.92 1.5c.17 0 .3.14.3.3v18.12a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h18.12zm0-1.5H1.8C.81 0 0 .81 0 1.8v18.12c0 1 .81 1.8 1.8 1.8h18.12c1 0 1.8-.81 1.8-1.8V1.8c.01-.99-.8-1.8-1.8-1.8z"
    }), $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    })));
});
$6e8ce04f200066e2$export$8b041a66c49f4118.displayName = 'MusicMulti';





var $denZA = parcelRequire("denZA");
var $8ec85d1c0bfd76d7$var$__assign = undefined && undefined.__assign || function() {
    $8ec85d1c0bfd76d7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ec85d1c0bfd76d7$var$__assign.apply(this, arguments);
};
var $8ec85d1c0bfd76d7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8ec85d1c0bfd76d7$export$adbb6d0a43ab11bf = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8ec85d1c0bfd76d7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8ec85d1c0bfd76d7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    }), $denZA.createElement("path", {
        d: "M13.52 13.37a1.181 1.181 0 001.5-.15c.23-.22.35-.52.35-.84 0-.23-.07-.46-.2-.66s-.31-.35-.53-.44a1.17 1.17 0 00-.69-.07 1.22 1.22 0 00-.94.94c-.04.23-.02.47.07.69.09.21.24.4.44.53zm-6.38-.03a1.188 1.188 0 00-1.5.15c-.23.22-.35.52-.35.84 0 .23.07.46.2.66s.31.35.53.44c.22.09.46.12.69.07a1.22 1.22 0 00.94-.94c.04-.23.02-.47-.07-.69-.09-.21-.24-.4-.44-.53z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M1.8 0h18.12c1 0 1.81.81 1.8 1.8v18.12c0 .99-.8 1.8-1.8 1.8H1.8c-.99 0-1.8-.8-1.8-1.8V1.8C0 .81.81 0 1.8 0zm5.74 16.93c-.33.14-.7.21-1.06.21-.42.01-.84-.08-1.21-.27-.38-.18-.72-.44-.98-.77s-.44-.71-.54-1.12c-.1-.41-.1-.83-.01-1.24.1-.41.28-.8.54-1.12.26-.32.59-.59.97-.77.38-.18.79-.27 1.21-.27.42 0 .83.1 1.21.28V6.68c0-.18.06-.37.18-.51.12-.15.29-.24.47-.27l7.7-1.3a.832.832 0 01.66.18c.09.07.16.16.21.27.05.11.07.22.07.34v7c0 .55-.16 1.08-.47 1.54-.31.45-.74.81-1.25 1.02a2.775 2.775 0 01-3.63-3.63c.21-.51.56-.94 1.02-1.25.45-.31.99-.47 1.54-.47.41 0 .82.09 1.19.27V6.36l-6.11 1v7c0 .37-.07.73-.21 1.07-.14.33-.34.64-.6.9-.25.26-.56.46-.9.6z",
        fillRule: "evenodd"
    })));
});
$8ec85d1c0bfd76d7$export$adbb6d0a43ab11bf.displayName = 'MusicMultiBold';





var $denZA = parcelRequire("denZA");
var $1266059b7464fee3$var$__assign = undefined && undefined.__assign || function() {
    $1266059b7464fee3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1266059b7464fee3$var$__assign.apply(this, arguments);
};
var $1266059b7464fee3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1266059b7464fee3$export$814afb5995e98181 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1266059b7464fee3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1266059b7464fee3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.125 0a.75.75 0 00-.75.75V7.5c0 .414.336.75.75.75h4.125v1.5H9.375a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H12.75v-1.5h4.125a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-9.75zm9 6.75V1.5h-8.25v5.25h8.25zM0 13.5a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75H6.375v1.5H8.25a.75.75 0 010 1.5H3a.75.75 0 010-1.5h1.875V21H.75a.75.75 0 01-.75-.75V13.5zm9.75 6v-5.25H1.5v5.25h8.25zm3-6a.75.75 0 01.75-.75h9.75a.75.75 0 01.75.75v6.75a.75.75 0 01-.75.75h-4.125v1.5H21a.75.75 0 010 1.5h-5.25a.75.75 0 010-1.5h1.875V21H13.5a.75.75 0 01-.75-.75V13.5zm9.75 6h-8.25v-5.25h8.25v5.25z",
        fillRule: "evenodd"
    })));
});
$1266059b7464fee3$export$814afb5995e98181.displayName = 'NetworkMonitor';





var $denZA = parcelRequire("denZA");
var $6929f801c0f4246a$var$__assign = undefined && undefined.__assign || function() {
    $6929f801c0f4246a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6929f801c0f4246a$var$__assign.apply(this, arguments);
};
var $6929f801c0f4246a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6929f801c0f4246a$export$4c36b904b711a8e1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6929f801c0f4246a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6929f801c0f4246a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M16.873 0H7.127a.751.751 0 00-.75.747v6.725a.746.746 0 00.75.747h3.868v1.176H9.506a1.001 1.001 0 00-1 .996.994.994 0 001 .996h4.998a1.001 1.001 0 001-.996.995.995 0 00-1-.996h-1.51V8.219h3.879a.751.751 0 00.75-.747V.747a.746.746 0 00-.75-.747zm-1.25 6.257H8.367V1.654h7.256v4.603zm-5.127 6.356H.75a.75.75 0 00-.75.747v6.725a.746.746 0 00.75.747h3.878v1.175h-1.49a1.001 1.001 0 00-.999.997.994.994 0 001 .996h4.998a1.001 1.001 0 001-.996.994.994 0 00-1-.997h-1.51v-1.175h3.869a.75.75 0 00.75-.747V13.36a.746.746 0 00-.75-.747zm-1.25 6.256H2v-4.592h7.247v4.592zm13.994-6.256h-9.746a.75.75 0 00-.75.747v6.725a.746.746 0 00.75.747h3.879v1.175h-1.49a1 1 0 00-1 .997.994.994 0 001 .996h4.998a1.001 1.001 0 001-.996.994.994 0 00-1-.997h-1.51v-1.175h3.88a.75.75 0 00.749-.747V13.36a.745.745 0 00-.76-.747zm-1.25 6.256h-7.246v-4.592h7.247v4.592z"
    })));
});
$6929f801c0f4246a$export$4c36b904b711a8e1.displayName = 'NetworkMonitorBold';





var $denZA = parcelRequire("denZA");
var $879cc734d4432776$var$__assign = undefined && undefined.__assign || function() {
    $879cc734d4432776$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $879cc734d4432776$var$__assign.apply(this, arguments);
};
var $879cc734d4432776$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $879cc734d4432776$export$aa45e342fa88404f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $879cc734d4432776$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $879cc734d4432776$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20.25 13.5a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-.75 2.25a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zM18 19.5a.75.75 0 00-.75-.75H13.5l-.102.007a.75.75 0 00.102 1.493h3.75l.102-.007A.75.75 0 0018 19.5zm-8.25-6.75a.75.75 0 01.102 1.493l-.102.007h-6a.75.75 0 01-.102-1.493l.102-.007h6zm.75 3.75a.75.75 0 00-.75-.75h-6l-.102.007a.75.75 0 00.102 1.493h6l.102-.007a.75.75 0 00.648-.743zm-3 2.25a.75.75 0 01.102 1.493l-.102.007H3.75a.75.75 0 01-.102-1.493l.102-.007H7.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 3h15A1.5 1.5 0 0121 4.5V9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 9V4.5A1.5 1.5 0 014.5 3zm15 1.5h-15V9h15V4.5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 0h19.5A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25A2.25 2.25 0 010 21.75V2.25A2.25 2.25 0 012.25 0zm19.5 1.5H2.25a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75z",
        fillRule: "evenodd"
    })));
});
$879cc734d4432776$export$aa45e342fa88404f.displayName = 'Newspaper';





var $denZA = parcelRequire("denZA");
var $dcc9dac8c595034d$var$__assign = undefined && undefined.__assign || function() {
    $dcc9dac8c595034d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dcc9dac8c595034d$var$__assign.apply(this, arguments);
};
var $dcc9dac8c595034d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dcc9dac8c595034d$export$b8dad214827a9937 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $dcc9dac8c595034d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $dcc9dac8c595034d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22 0H2a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2zm0 21.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19z"
    }), $denZA.createElement("path", {
        d: "M18.5 4h-13c-.69 0-1.25.56-1.25 1.25v2.5C4.25 8.44 4.81 9 5.5 9h13c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm-8 7H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm0 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75zm-2 3.5H5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h3.5a.75.75 0 00.75-.75v-.5A.75.75 0 008.5 18zm8.5 0h-3.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H17a.75.75 0 00.75-.75v-.5A.75.75 0 0017 18zm2-7h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5A.75.75 0 0019 11zm0 3.5h-5.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75H19a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z"
    })));
});
$dcc9dac8c595034d$export$b8dad214827a9937.displayName = 'NewspaperBold';





var $denZA = parcelRequire("denZA");
var $61abb7407cecbdfb$var$__assign = undefined && undefined.__assign || function() {
    $61abb7407cecbdfb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61abb7407cecbdfb$var$__assign.apply(this, arguments);
};
var $61abb7407cecbdfb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $61abb7407cecbdfb$export$b99d3348f709c998 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $61abb7407cecbdfb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $61abb7407cecbdfb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.894 3.856A9.75 9.75 0 0014 1a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h9a.75.75 0 00.75-.75 9.75 9.75 0 00-2.856-6.894zM14.75 2.534A8.249 8.249 0 0122.216 10H14.75V2.534z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M5.333 5.393A9.75 9.75 0 0110.75 3.75a.75.75 0 01.75.75v8.25h8.25a.75.75 0 01.75.75A9.75 9.75 0 115.333 5.393zM10 5.284a8.25 8.25 0 108.966 8.966H10.75a.75.75 0 01-.75-.75V5.284z",
        fillRule: "evenodd"
    })));
});
$61abb7407cecbdfb$export$b99d3348f709c998.displayName = 'PieChart';





var $denZA = parcelRequire("denZA");
var $90a6c7f42c21a68f$var$__assign = undefined && undefined.__assign || function() {
    $90a6c7f42c21a68f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90a6c7f42c21a68f$var$__assign.apply(this, arguments);
};
var $90a6c7f42c21a68f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $90a6c7f42c21a68f$export$85d8ff848df8e5b7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $90a6c7f42c21a68f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $90a6c7f42c21a68f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.5 24c5.796-.007 10.493-4.704 10.5-10.5a.5.5 0 00-.5-.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 00-.5-.5C4.701 3 0 7.701 0 13.5S4.701 24 10.5 24z"
    }), $denZA.createElement("path", {
        d: "M13.5 0a.5.5 0 00-.5.5V10a1 1 0 001 1h9.5a.5.5 0 00.5-.5C23.993 4.704 19.296.007 13.5 0z"
    })));
});
$90a6c7f42c21a68f$export$85d8ff848df8e5b7.displayName = 'PieChartBold';





var $denZA = parcelRequire("denZA");
var $8ab9d2894825db7e$var$__assign = undefined && undefined.__assign || function() {
    $8ab9d2894825db7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8ab9d2894825db7e$var$__assign.apply(this, arguments);
};
var $8ab9d2894825db7e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8ab9d2894825db7e$export$656559010049c8e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8ab9d2894825db7e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8ab9d2894825db7e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M16.654.127a2.25 2.25 0 00-2.644.914l-3.877 6.094a8.271 8.271 0 00-5.561 1l.377.649-.38-.647a2.25 2.25 0 00-.45 3.533l3.574 3.575L.22 22.718a.75.75 0 001.06 1.06l7.474-7.473 3.576 3.576a2.25 2.25 0 003.534-.45l.001-.002a8.271 8.271 0 001-5.561l6.093-3.878a2.251 2.251 0 00.384-3.488L17.498.659a2.25 2.25 0 00-.845-.532zM5.082 9.664a.75.75 0 01.245-.233 6.772 6.772 0 014.986-.728.75.75 0 00.808-.327l4.154-6.529a.75.75 0 011.163-.127l5.843 5.842a.75.75 0 01-.128 1.163l-6.529 4.155a.75.75 0 00-.327.808 6.771 6.771 0 01-.728 4.985.75.75 0 01-1.177.15l-8.213-8.214a.75.75 0 01-.097-.945z",
        fillRule: "evenodd"
    })));
});
$8ab9d2894825db7e$export$656559010049c8e.displayName = 'Pin';





var $denZA = parcelRequire("denZA");
var $dd36eaca1b0e350e$var$__assign = undefined && undefined.__assign || function() {
    $dd36eaca1b0e350e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd36eaca1b0e350e$var$__assign.apply(this, arguments);
};
var $dd36eaca1b0e350e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dd36eaca1b0e350e$export$88393934ec04748c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $dd36eaca1b0e350e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $dd36eaca1b0e350e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.663.013a2.25 2.25 0 011.836.646l5.843 5.843a2.25 2.25 0 01-.384 3.488l-6.093 3.877a8.271 8.271 0 01-1 5.562l-.001.002a2.25 2.25 0 01-3.534.45l-3.045-3.045L2.56 23.56a1.5 1.5 0 01-1.503.373.75.75 0 01-.991-.993 1.5 1.5 0 01.373-1.501l6.724-6.724L4.12 11.67a2.25 2.25 0 01.45-3.533l.38.647-.377-.649a8.271 8.271 0 015.56-1l3.878-6.094A2.249 2.249 0 0115.663.013z"
    })));
});
$dd36eaca1b0e350e$export$88393934ec04748c.displayName = 'PinBold';





var $denZA = parcelRequire("denZA");
var $4ace58193db83eec$var$__assign = undefined && undefined.__assign || function() {
    $4ace58193db83eec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ace58193db83eec$var$__assign.apply(this, arguments);
};
var $4ace58193db83eec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ace58193db83eec$export$2d9ac7aa84f97a08 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4ace58193db83eec$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4ace58193db83eec$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.75 1a.75.75 0 00-1.5 0v10.25H1a.75.75 0 000 1.5h10.25V23a.75.75 0 001.5 0V12.75H23a.75.75 0 000-1.5H12.75V1z"
    })));
});
$4ace58193db83eec$export$2d9ac7aa84f97a08.displayName = 'Plus';





var $denZA = parcelRequire("denZA");
var $0cb8cc7c0306e661$var$__assign = undefined && undefined.__assign || function() {
    $0cb8cc7c0306e661$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0cb8cc7c0306e661$var$__assign.apply(this, arguments);
};
var $0cb8cc7c0306e661$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0cb8cc7c0306e661$export$2ef3672ebfdfd8df = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0cb8cc7c0306e661$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0cb8cc7c0306e661$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M13.5 1.565a1.5 1.5 0 00-3 0V10.5H1.565a1.5 1.5 0 000 3H10.5v8.935a1.5 1.5 0 003 0V13.5h8.935a1.5 1.5 0 000-3H13.5V1.565z"
    })));
});
$0cb8cc7c0306e661$export$2ef3672ebfdfd8df.displayName = 'PlusBold';





var $denZA = parcelRequire("denZA");
var $a00f012f41b96132$var$__assign = undefined && undefined.__assign || function() {
    $a00f012f41b96132$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a00f012f41b96132$var$__assign.apply(this, arguments);
};
var $a00f012f41b96132$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a00f012f41b96132$export$531cef85654f2406 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a00f012f41b96132$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a00f012f41b96132$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.75 9a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm3.75 6.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h5.25a.75.75 0 000-1.5H8.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 6V2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25A2.25 2.25 0 0124 8.25v7.5A2.25 2.25 0 0121.75 18H19.5v5.25a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5zm1.72-4.28a.75.75 0 01.53-.22h10.5a.75.75 0 01.75.75V6H6V2.25a.75.75 0 01.22-.53zM2.25 7.5a.75.75 0 00-.75.75v7.5a.75.75 0 00.75.75H4.5v-3.75a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v3.75h2.25a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25zm15.75 6v9H6v-9h12z",
        fillRule: "evenodd"
    })));
});
$a00f012f41b96132$export$531cef85654f2406.displayName = 'Print';





var $denZA = parcelRequire("denZA");
var $b2db869f3c7cec6c$var$__assign = undefined && undefined.__assign || function() {
    $b2db869f3c7cec6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2db869f3c7cec6c$var$__assign.apply(this, arguments);
};
var $b2db869f3c7cec6c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2db869f3c7cec6c$export$3326d4c83d14f416 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b2db869f3c7cec6c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b2db869f3c7cec6c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 2.25A2.25 2.25 0 016.75 0h10.5a2.25 2.25 0 012.25 2.25V6h2.25a2.25 2.25 0 012.249 2.25v7.5a2.25 2.25 0 01-2.25 2.25H19.5v5.25a.75.75 0 01-.75.749H5.25a.75.75 0 01-.75-.75V18H2.25A2.25 2.25 0 010 15.75v-7.5A2.25 2.25 0 012.25 6H4.5V2.25zm13 11.25h-11V22h11v-8.5zm0-8V2.25a.25.25 0 00-.25-.25H6.75a.25.25 0 00-.25.25V5.5h11zM2.75 9.75a1 1 0 011-1h1.5a1 1 0 010 2h-1.5a1 1 0 01-1-1z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M8.25 14.75a1 1 0 000 2h7.5a1 1 0 000-2h-7.5zm0 3a1 1 0 100 2h5.25a1 1 0 000-2H8.25z"
    })));
});
$b2db869f3c7cec6c$export$3326d4c83d14f416.displayName = 'PrintBold';





var $denZA = parcelRequire("denZA");
var $4810c819db42aa34$var$__assign = undefined && undefined.__assign || function() {
    $4810c819db42aa34$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4810c819db42aa34$var$__assign.apply(this, arguments);
};
var $4810c819db42aa34$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4810c819db42aa34$export$21ae373ff9e70628 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4810c819db42aa34$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4810c819db42aa34$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15 10.38l2.08-2a.74.74 0 00-.4-1.26l-2.85-.44-1.25-2.59a.76.76 0 00-.67-.42.77.77 0 00-.66.41L10 6.66l-2.9.39a.75.75 0 00-.42 1.27l2.05 2-.5 2.84a.74.74 0 00.29.73.75.75 0 00.78.11l2.56-1.33L14.4 14a.731.731 0 00.78-.05.74.74 0 00.3-.72L15 10.38zm-1.31-.8a.8.8 0 00-.22.66l.3 1.76-1.56-.84a.73.73 0 00-.35-.09.722.722 0 00-.34.09L10 12l.31-1.74a.76.76 0 00-.21-.66L8.79 8.32l1.75-.25a.71.71 0 00.56-.4l.8-1.58.77 1.59a.76.76 0 00.56.41l1.77.27-1.31 1.22z"
    }), $denZA.createElement("path", {
        d: "M23.83 17.58l-4-4.9a8.518 8.518 0 00.71-3.43A8.681 8.681 0 004.08 5.333 8.68 8.68 0 004 12.86L.17 17.58a.73.73 0 00-.11.76.73.73 0 00.63.45l3.88.26 1 3.83a.73.73 0 00.59.54h.12a.74.74 0 00.62-.33l3.55-5.31c.466.083.937.127 1.41.13a8.532 8.532 0 001.61-.16l3.57 5.34a.74.74 0 00.62.33h.12a.76.76 0 00.6-.54l1-3.83 3.88-.26a.73.73 0 00.63-.45.73.73 0 00-.06-.76zM6.6 20.92l-.74-2.77a.74.74 0 00-.66-.54l-3-.2 2.6-3.18A8.69 8.69 0 009 17.4l-2.4 3.52zM4.7 9.25a7.19 7.19 0 117.19 7.19A7.2 7.2 0 014.7 9.25zm14.1 8.36a.74.74 0 00-.66.54l-.74 2.77-2.4-3.59a8.699 8.699 0 004.08-3.24l2.7 3.32-2.98.2z"
    })));
});
$4810c819db42aa34$export$21ae373ff9e70628.displayName = 'Prize';





var $denZA = parcelRequire("denZA");
var $aca97e2c97e40ceb$var$__assign = undefined && undefined.__assign || function() {
    $aca97e2c97e40ceb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aca97e2c97e40ceb$var$__assign.apply(this, arguments);
};
var $aca97e2c97e40ceb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aca97e2c97e40ceb$export$96e732d441c462a8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $aca97e2c97e40ceb$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $aca97e2c97e40ceb$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.59 18.46a9.52 9.52 0 01-5.68-4.05.43.43 0 00-.68 0L.1 18.19a.44.44 0 00.3.71l4.18.38a.44.44 0 01.39.31l1.21 3.94a.43.43 0 00.78.12l2.9-4.54a.43.43 0 00-.27-.65zm14.13-.27l-3.13-3.8a.44.44 0 00-.69 0 9.45 9.45 0 01-5.67 4.05.43.43 0 00-.27.65l2.9 4.54a.43.43 0 00.78-.12l1.21-3.94a.44.44 0 01.39-.31l4.17-.38a.44.44 0 00.31-.69z"
    }), $denZA.createElement("path", {
        d: "M20.42 9.12a8.61 8.61 0 10-17.221 0 8.61 8.61 0 0017.22 0zm-4.48-.62l-1.6 1.5a.45.45 0 00-.13.38l.36 2.19a.43.43 0 01-.63.45L12 12a.43.43 0 00-.41 0l-2 1a.43.43 0 01-.59-.42l.39-2.19a.44.44 0 00-.13-.39L7.68 8.45a.43.43 0 01.24-.73l2.2-.31a.46.46 0 00.33-.23l1-2a.44.44 0 01.78 0l1 2a.42.42 0 00.32.24l2.19.34a.43.43 0 01.2.74z"
    })));
});
$aca97e2c97e40ceb$export$96e732d441c462a8.displayName = 'PrizeBold';





var $denZA = parcelRequire("denZA");
var $864c9aa3d9f17cb1$var$__assign = undefined && undefined.__assign || function() {
    $864c9aa3d9f17cb1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $864c9aa3d9f17cb1$var$__assign.apply(this, arguments);
};
var $864c9aa3d9f17cb1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $864c9aa3d9f17cb1$export$3b87754677f810a3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $864c9aa3d9f17cb1$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $864c9aa3d9f17cb1$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.334 4.067l-3-3h-.09l-.12-.06h-.24a.75.75 0 00-.21 0h-.06a.749.749 0 00-.23.16l-3 3-.07.08a.75.75 0 00.07 1l.08.07a.75.75 0 001-.07l1.72-1.72v5.17a.75.75 0 001.37-.1v-5.19l1.72 1.72.08.07a.754.754 0 101-1.13h-.02zm-16.08 13.93a.75.75 0 00-1 .07l-1.7 1.72v-5.29a.75.75 0 00-1.49.1v5.19l-1.73-1.72-.08-.07a.754.754 0 10-1 1.13l3 3h.09l.12.06h.34c.07.01.14.01.21 0h.06a.75.75 0 00.23-.15l3-3 .07-.08a.75.75 0 00-.07-1l-.05.04zm5.86-6.68l-2.06-.83h-.08a.59.59 0 01.3-1.1h2.13a.75.75 0 00-.1-1.49h-.75v-.1a.75.75 0 00-1.49.1 2.09 2.09 0 00-.56 4l2.07.83h.08a.59.59 0 01-.3 1.1h-2.15a.75.75 0 00.1 1.49h.75v.1a.75.75 0 001.49-.1 2.09 2.09 0 00.56-4h.01z"
    }), $denZA.createElement("path", {
        d: "M11.805 4.847a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm0 12a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5z"
    })));
});
$864c9aa3d9f17cb1$export$3b87754677f810a3.displayName = 'ProfitAndLoss';





var $denZA = parcelRequire("denZA");
var $1e92bc76c03f101c$var$__assign = undefined && undefined.__assign || function() {
    $1e92bc76c03f101c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e92bc76c03f101c$var$__assign.apply(this, arguments);
};
var $1e92bc76c03f101c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1e92bc76c03f101c$export$c09363a928487262 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1e92bc76c03f101c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1e92bc76c03f101c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M20 1.25a.75.75 0 01.743.648L20.75 2v7a.75.75 0 01-1.493.102L19.25 9V2a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        d: "M19.47 1.47a.75.75 0 01.976-.073l.084.073 3 3a.75.75 0 01-.976 1.133l-.084-.073L20 3.061l-2.47 2.47a.75.75 0 01-.976.072l-.084-.073a.75.75 0 01-.073-.976l.073-.084 3-3zM4 22.75a.75.75 0 01-.743-.648L3.25 22v-7a.75.75 0 011.493-.102L4.75 15v7a.75.75 0 01-.75.75z"
    }), $denZA.createElement("path", {
        d: "M4.53 22.53a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L4 20.939l2.47-2.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3zM5 11.5A6.5 6.5 0 1011.5 5 6.508 6.508 0 005 11.5zm5.592-3.697l-.006-.008a.19.19 0 00.165-.2v-.35a.75.75 0 011.5 0v.335a.17.17 0 00.169.165h.581a.75.75 0 010 1.5h-2.035a.592.592 0 00-.219 1.141l2.062.826a2.078 2.078 0 01-.417 3.989.184.184 0 00-.137.2v.353a.75.75 0 01-1.5 0v-.334a.17.17 0 00-.164-.166H10a.75.75 0 010-1.5h2.033a.592.592 0 00.22-1.141l-2.061-.83a2.079 2.079 0 01.4-3.98z"
    })));
});
$1e92bc76c03f101c$export$c09363a928487262.displayName = 'ProfitAndLossBold';





var $denZA = parcelRequire("denZA");
var $aacb9e0709715b8f$var$__assign = undefined && undefined.__assign || function() {
    $aacb9e0709715b8f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aacb9e0709715b8f$var$__assign.apply(this, arguments);
};
var $aacb9e0709715b8f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aacb9e0709715b8f$export$323217037b764dc5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $aacb9e0709715b8f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $aacb9e0709715b8f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15.954 7.07a.75.75 0 10-1.06 1.061l2.404 2.405-2.404 2.405a.75.75 0 001.06 1.06l2.935-2.935a.75.75 0 000-1.06L15.954 7.07zm-6.848 0a.75.75 0 010 1.061l-2.404 2.405 2.404 2.405A.75.75 0 018.046 14L5.11 11.066a.75.75 0 010-1.06L8.046 7.07a.75.75 0 011.06 0zm4.584.768a.75.75 0 10-1.423-.474l-1.957 5.87a.75.75 0 101.423.474l1.957-5.87z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.75.003a.75.75 0 01.75.75v1.392l2.184-.672a10.364 10.364 0 018.477 1.078 8.862 8.862 0 007.076.974l2.37-.677a1.876 1.876 0 012.389 1.802v12.87a1.874 1.874 0 01-1.36 1.803l-2.987.854a10.367 10.367 0 01-8.278-1.138 8.859 8.859 0 00-7.25-.922l-2.621.81v4.26a.75.75 0 01-1.5 0V.754a.75.75 0 01.75-.75zm.75 17.353V3.714l2.625-.807a8.864 8.864 0 017.25.922 10.36 10.36 0 008.274 1.138l2.368-.677a.378.378 0 01.479.361v12.87a.375.375 0 01-.272.36l-2.987.854a8.864 8.864 0 01-7.08-.974 10.357 10.357 0 00-8.478-1.078l-2.179.673z",
        fillRule: "evenodd"
    })));
});
$aacb9e0709715b8f$export$323217037b764dc5.displayName = 'Programming';





var $denZA = parcelRequire("denZA");
var $ed8798acbd3e3595$var$__assign = undefined && undefined.__assign || function() {
    $ed8798acbd3e3595$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed8798acbd3e3595$var$__assign.apply(this, arguments);
};
var $ed8798acbd3e3595$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ed8798acbd3e3595$export$d5f8ac158b287764 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ed8798acbd3e3595$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ed8798acbd3e3595$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3 22.5a1.5 1.5 0 01-3 0v-21a1.5 1.5 0 013 0v.025a.25.25 0 00.335.236l.717-.261a9.779 9.779 0 018.226 1.067 9.36 9.36 0 007.45 1.025L21.9 2.9A1.652 1.652 0 0124 4.485v13.159a1.655 1.655 0 01-1.2 1.583L20 20.1a10.33 10.33 0 01-8.248-1.129A8.766 8.766 0 004.371 18l-1.206.435A.25.25 0 003 18.67v3.83zM15.005 7.297a.75.75 0 00.215.734l2.293 2.293a.252.252 0 010 .354l-2.293 2.293a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3a.75.75 0 00-1.275.326zm-3.992 6.916a.751.751 0 01-.475-.949l2-6a.75.75 0 011.424.474l-2 6a.751.751 0 01-.949.475zM5 10.501c0 .199.08.39.22.53l3 3a.75.75 0 101.06-1.06l-2.293-2.293a.252.252 0 010-.354L9.28 8.031a.75.75 0 00-1.06-1.06l-3 3a.749.749 0 00-.22.53z",
        fillRule: "evenodd"
    })));
});
$ed8798acbd3e3595$export$d5f8ac158b287764.displayName = 'ProgrammingBold';





var $denZA = parcelRequire("denZA");
var $c94ad5e0467ee7ff$var$__assign = undefined && undefined.__assign || function() {
    $c94ad5e0467ee7ff$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c94ad5e0467ee7ff$var$__assign.apply(this, arguments);
};
var $c94ad5e0467ee7ff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c94ad5e0467ee7ff$export$e3b6b80dd4f481c3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c94ad5e0467ee7ff$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c94ad5e0467ee7ff$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.5 5.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75v-3zM6 6v1.5h1.5V6H6zm-1.5 9.75a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75v-3zm1.5.75V18h1.5v-1.5H6zm9-11.25a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75v-3zm1.5.75v1.5H18V6h-1.5zm-12 6.75a.75.75 0 01.75-.75h6a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-.75H5.25a.75.75 0 01-.75-.75zm9.75.75a.75.75 0 01.75.75V18h3v-3h-.75a.75.75 0 010-1.5h1.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75zm-3 3a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75zm0-12a.75.75 0 01.75.75V9h.75a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75zM15 11.25a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM2.25 1.5a.75.75 0 00-.75.75V6A.75.75 0 010 6V2.25A2.25 2.25 0 012.25 0H6a.75.75 0 010 1.5H2.25zm15-.75A.75.75 0 0118 0h3.75A2.25 2.25 0 0124 2.25V6a.75.75 0 01-1.5 0V2.25a.75.75 0 00-.75-.75H18a.75.75 0 01-.75-.75zm6 16.5A.75.75 0 0124 18v3.75A2.25 2.25 0 0121.75 24H18a.75.75 0 010-1.5h3.75a.75.75 0 00.75-.75V18a.75.75 0 01.75-.75zm-22.5 0a.75.75 0 01.75.75v3.75a.75.75 0 00.75.75H6A.75.75 0 016 24H2.25A2.25 2.25 0 010 21.75V18a.75.75 0 01.75-.75z",
        fillRule: "evenodd"
    })));
});
$c94ad5e0467ee7ff$export$e3b6b80dd4f481c3.displayName = 'QrCode';





var $denZA = parcelRequire("denZA");
var $00ffb354b7b97b11$var$__assign = undefined && undefined.__assign || function() {
    $00ffb354b7b97b11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00ffb354b7b97b11$var$__assign.apply(this, arguments);
};
var $00ffb354b7b97b11$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $00ffb354b7b97b11$export$14d46feaedf96190 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $00ffb354b7b97b11$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $00ffb354b7b97b11$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.84 22l-2.584.037a.25.25 0 01-.236-.153.251.251 0 01-.02-.097V19.16a1 1 0 10-2 0v2.883A1.957 1.957 0 001.957 24H4.84a1 1 0 000-2zM1 5.84a1 1 0 001-1l-.038-2.584A.251.251 0 012.212 2H4.84a1 1 0 000-2H1.956A1.956 1.956 0 000 1.956V4.84a1 1 0 001 1zM22.043 0H19.16a1 1 0 100 2l2.584-.037a.251.251 0 01.256.25V4.84a1 1 0 002 0V1.957A1.957 1.957 0 0022.043 0zM23 18.16a1 1 0 00-1 1l.038 2.584a.25.25 0 01-.25.256H19.16a1 1 0 000 2h2.884A1.956 1.956 0 0024 22.044V19.16a1 1 0 00-1-1zM5 4.5h3.5V8H5V4.5zm10.5 0H19V8h-3.5V4.5zm0 11.5H19v3.5h-3.5V16zM5 16h3.5v3.5H5V16zm5.5-7.739a.75.75 0 00.75-.75V6.25A.25.25 0 0111.5 6h1.932a.75.75 0 100-1.5H10.5a.75.75 0 00-.75.75v2.261a.75.75 0 00.75.75zm3-1.13a.75.75 0 00-.75.75v3.348a.75.75 0 101.5 0V7.881a.75.75 0 00-.75-.75zm-3 7.369a.75.75 0 00.75-.75v-2.413a.75.75 0 10-1.5 0v1.413a.25.25 0 01-.25.25h-4a.75.75 0 100 1.5h5zm2.932 3.5H11.5a.25.25 0 01-.25-.25v-1.413a.75.75 0 10-1.5 0v2.413a.75.75 0 00.75.75h2.932a.75.75 0 100-1.5zM5.5 11h2a.75.75 0 100-1.5h-2a.75.75 0 000 1.5zM16 11h2.5a.75.75 0 100-1.5H16a.75.75 0 100 1.5zm2.5 2H13a.75.75 0 100 1.5h5.5a.75.75 0 100-1.5z"
    })));
});
$00ffb354b7b97b11$export$14d46feaedf96190.displayName = 'QrCodeBold';





var $denZA = parcelRequire("denZA");
var $f47f51437c69423e$var$__assign = undefined && undefined.__assign || function() {
    $f47f51437c69423e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f47f51437c69423e$var$__assign.apply(this, arguments);
};
var $f47f51437c69423e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f47f51437c69423e$export$f93ec6528f706bfe = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f47f51437c69423e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f47f51437c69423e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M19.378 10.056a.746.746 0 00-.825.159l-2.667 2.667a.75.75 0 001.06 1.06l1.368-1.367a6.583 6.583 0 01-11.352 4.02.75.75 0 10-1.09 1.03 8.084 8.084 0 0013.948-5.082l1.4 1.4a.75.75 0 001.06-1.061l-2.664-2.664a.763.763 0 00-.238-.162zm-11.7.811a.776.776 0 00-1.092 0l-1.39 1.398v-.2c0-1.397.397-2.695 1.191-3.793.795-1.099 1.887-1.897 3.178-2.396 1.291-.5 2.681-.5 3.973-.2 1.29.4 2.482 1.098 3.277 2.196.298.3.695.4 1.092.1.298-.3.397-.699.1-1.098-1.093-1.298-2.483-2.196-4.072-2.596-1.59-.399-3.277-.399-4.866.2a8.206 8.206 0 00-3.873 2.995c-.993 1.398-1.49 2.995-1.49 4.592v.2l-1.39-1.398a.776.776 0 00-1.093 0 .786.786 0 000 1.098l2.682 2.696c.099.1.298.2.496.2.199 0 .397-.1.497-.2l2.681-2.695c.397-.3.397-.8.1-1.099z"
    })));
});
$f47f51437c69423e$export$f93ec6528f706bfe.displayName = 'Refresh';





var $denZA = parcelRequire("denZA");
var $1efedf17309296bd$var$__assign = undefined && undefined.__assign || function() {
    $1efedf17309296bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1efedf17309296bd$var$__assign.apply(this, arguments);
};
var $1efedf17309296bd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1efedf17309296bd$export$af5e85d717d10540 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1efedf17309296bd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1efedf17309296bd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M14.339 3.815a8.834 8.834 0 00-11.044 7.02l-.234-.234a1.5 1.5 0 10-2.122 2.122l2.617 2.616a1.496 1.496 0 002.224-.002l2.614-2.614a1.5 1.5 0 00-1.905-2.301 5.833 5.833 0 018.995-2.767 1.5 1.5 0 101.792-2.406 8.832 8.832 0 00-2.937-1.434zm5.625 5.819a1.495 1.495 0 00-1.157-.044 1.495 1.495 0 00-.534.345L15.606 12.6a1.5 1.5 0 001.534 2.485 5.825 5.825 0 01-2.986 2.663 5.833 5.833 0 01-5.336-.532 1.5 1.5 0 10-1.636 2.514 8.833 8.833 0 0013.41-5.355l.347.347a1.5 1.5 0 102.122-2.122l-2.656-2.655a1.495 1.495 0 00-.44-.312z"
    })));
});
$1efedf17309296bd$export$af5e85d717d10540.displayName = 'RefreshBold';





var $denZA = parcelRequire("denZA");
var $55a57376ee6e0ba5$var$__assign = undefined && undefined.__assign || function() {
    $55a57376ee6e0ba5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55a57376ee6e0ba5$var$__assign.apply(this, arguments);
};
var $55a57376ee6e0ba5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $55a57376ee6e0ba5$export$491adc720f0ff5ec = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $55a57376ee6e0ba5$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $55a57376ee6e0ba5$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.11 3.61h13.62a.75.75 0 000-1.5H6.11a.75.75 0 000 1.5zm0 5.62h13.62a.75.75 0 000-1.5H6.11a.75.75 0 000 1.5zm2.75 4.06H6.11a.75.75 0 100 1.5h2.75a.75.75 0 100-1.5zM2.73 3.8a.94.94 0 100-1.88.94.94 0 000 1.88zm0 5.62a.94.94 0 100-1.88.94.94 0 000 1.88zm0 5.56a.94.94 0 100-1.88.94.94 0 000 1.88zm14.19-4.22a6 6 0 100 12 6 6 0 000-12zm0 10.57a4.54 4.54 0 110-9.08 4.54 4.54 0 010 9.08z"
    }), $denZA.createElement("path", {
        d: "M18.9 16h-4a.75.75 0 000 1.5h4a.75.75 0 100-1.5z"
    })));
});
$55a57376ee6e0ba5$export$491adc720f0ff5ec.displayName = 'RemoveFromList';





var $denZA = parcelRequire("denZA");
var $76eaf03fd6c461b8$var$__assign = undefined && undefined.__assign || function() {
    $76eaf03fd6c461b8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76eaf03fd6c461b8$var$__assign.apply(this, arguments);
};
var $76eaf03fd6c461b8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $76eaf03fd6c461b8$export$2bf4875b99076f6e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $76eaf03fd6c461b8$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $76eaf03fd6c461b8$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.41 3.86H20a1 1 0 100-2H6.41a1 1 0 000 2zm0 5.62H20a1 1 0 100-2H6.41a1 1 0 000 2zM9.16 13H6.41a1 1 0 000 2h2.75a1 1 0 000-2zM3.02 4.22a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72zm14.18 6.57a6 6 0 100 12 6 6 0 000-12zM19.23 16a.75.75 0 110 1.5h-4a.75.75 0 110-1.5h4zM3.02 9.84a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72zm0 5.56a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72z"
    })));
});
$76eaf03fd6c461b8$export$2bf4875b99076f6e.displayName = 'RemoveFromListBold';





var $denZA = parcelRequire("denZA");
var $dc01e8c3c5262b06$var$__assign = undefined && undefined.__assign || function() {
    $dc01e8c3c5262b06$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dc01e8c3c5262b06$var$__assign.apply(this, arguments);
};
var $dc01e8c3c5262b06$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dc01e8c3c5262b06$export$6d3b1b9014d6cc79 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $dc01e8c3c5262b06$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $dc01e8c3c5262b06$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.026 2.526a.75.75 0 10-1.06-1.06l-7.22 7.22v-4.69a.75.75 0 10-1.5 0v6.5a.747.747 0 00.75.75h6.5a.75.75 0 100-1.5h-4.69l7.22-7.22zm-12.53 18.448a.75.75 0 01-.75-.75v-4.69l-7.22 7.22a.75.75 0 11-1.06-1.06l7.22-7.22h-4.69a.75.75 0 010-1.5h6.5a.747.747 0 01.75.75v6.5a.75.75 0 01-.75.75z"
    })));
});
$dc01e8c3c5262b06$export$6d3b1b9014d6cc79.displayName = 'Retract';





var $denZA = parcelRequire("denZA");
var $37d4b668b47946d2$var$__assign = undefined && undefined.__assign || function() {
    $37d4b668b47946d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37d4b668b47946d2$var$__assign.apply(this, arguments);
};
var $37d4b668b47946d2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $37d4b668b47946d2$export$9515f4411b0668 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $37d4b668b47946d2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $37d4b668b47946d2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.56 3.06A1.5 1.5 0 0021.44.94L15.5 6.878V4a1.5 1.5 0 00-3 0v6.5a1.494 1.494 0 00.859 1.357c.194.092.412.143.641.143h6.5a1.5 1.5 0 000-3h-2.879l5.94-5.94zM10.5 21.728a1.5 1.5 0 01-1.5-1.5v-2.879l-5.94 5.94a1.5 1.5 0 11-2.12-2.122l5.939-5.939H4a1.5 1.5 0 010-3h6.5a1.494 1.494 0 011.374.896c.08.185.126.39.126.604v6.5a1.5 1.5 0 01-1.5 1.5z"
    })));
});
$37d4b668b47946d2$export$9515f4411b0668.displayName = 'RetractBold';





var $denZA = parcelRequire("denZA");
var $36bfb3f2fcf0dc8d$var$__assign = undefined && undefined.__assign || function() {
    $36bfb3f2fcf0dc8d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36bfb3f2fcf0dc8d$var$__assign.apply(this, arguments);
};
var $36bfb3f2fcf0dc8d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $36bfb3f2fcf0dc8d$export$91968ad3c1a9437b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $36bfb3f2fcf0dc8d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $36bfb3f2fcf0dc8d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#robot-arm_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10.974 2.052a1.75 1.75 0 012.555 2.392.76.76 0 00-.114.11 1.743 1.743 0 01-1.901.284 1.75 1.75 0 01-.54-2.786zm4.525 1.198c0 .638-.184 1.233-.502 1.735l1.363 1.393A2.75 2.75 0 0120.2 7.5a3.75 3.75 0 013.8 3.751.75.75 0 01-1.5-.002 2.25 2.25 0 00-2.013-2.239 2.75 2.75 0 01-2.476 2.478 2.254 2.254 0 001.282 1.799c.299.14.625.213.956.213a.75.75 0 010 1.5 3.75 3.75 0 01-3.75-3.8 2.75 2.75 0 01-1.179-3.74l-1.395-1.426a3.256 3.256 0 01-2.485.364l-4.906 4.778 4.444 3.295A3.75 3.75 0 0116 18v4.501h7a.75.75 0 010 1.5H1a.75.75 0 010-1.5h7.5v-3.24l-6.07-4.364a3.251 3.251 0 01-1.026-5.82l8.439-8.012a3.25 3.25 0 015.656 2.185zM10 18.892V18a2.25 2.25 0 011.164-1.97.75.75 0 00.12-.063A2.249 2.249 0 0114.5 18v4.501H10v-3.61zm-.383-3.563a3.75 3.75 0 00-1.076 2.114l-3.857-2.774a3.26 3.26 0 001.619-1.797l3.314 2.457zm7.858-5.358l-.012-.003a1.25 1.25 0 01-.648-2.046l.003-.004a1.246 1.246 0 01.931-.417 1.25 1.25 0 11-.274 2.47zM9.059 3.877l-4.982 4.73A3.253 3.253 0 015.83 9.771l4.23-4.12a3.245 3.245 0 01-1-1.774zm-6.72 6.38l-.532.505a1.75 1.75 0 001.019 2.687.754.754 0 01.13.027 1.75 1.75 0 10-.618-3.22z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "robot-arm_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$36bfb3f2fcf0dc8d$export$91968ad3c1a9437b.displayName = 'RobotArm';





var $denZA = parcelRequire("denZA");
var $376fadcb42939433$var$__assign = undefined && undefined.__assign || function() {
    $376fadcb42939433$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $376fadcb42939433$var$__assign.apply(this, arguments);
};
var $376fadcb42939433$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $376fadcb42939433$export$7279401af4607e04 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $376fadcb42939433$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $376fadcb42939433$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#robot-arm-bold_svg__a)"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.366 6.581A4.32 4.32 0 0123.92 8.81l.02-.03a1.25 1.25 0 11-2.39.7 1.81 1.81 0 10-2.2 2.26 1.25 1.25 0 01-.31 2.46 1.174 1.174 0 01-.32 0 4.31 4.31 0 01-3.21-4.17 4.188 4.188 0 01.45-1.9l-2.24-2.26a3 3 0 01-2.33-.27L6.52 9.45a3.25 3.25 0 010 1.55L10 14.52A4.54 4.54 0 008.39 18v.43l-4.76-4.89a3.29 3.29 0 01-1.84-6.19A3.2 3.2 0 013.72 7L10 2.17A3 3 0 0111.46.34a3 3 0 014.28 3.44L18 6.1a4.19 4.19 0 011.79-.38 4.32 4.32 0 012.576.861zM2.73 11.128c.171.117.373.18.58.182a1 1 0 001.06-1.05 1.05 1.05 0 10-1.64.868zm9.523-7.248c.174.127.382.2.598.21A1.09 1.09 0 0014 3a1.1 1.1 0 10-1.748.88zM16 20.44h.65a1.5 1.5 0 011.5 1.5v1.56a.5.5 0 01-.5.5H8.22a.5.5 0 01-.5-.5v-1.56a1.5 1.5 0 011.5-1.5h.64v-2.37a3.07 3.07 0 016.14 0v2.37zm-3.654-1.694c.168.193.4.319.654.354v.01A1.06 1.06 0 1013 17a1.06 1.06 0 00-.654 1.746z",
        fillRule: "evenodd"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "robot-arm-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$376fadcb42939433$export$7279401af4607e04.displayName = 'RobotArmBold';





var $denZA = parcelRequire("denZA");
var $76a6bf7476dad299$var$__assign = undefined && undefined.__assign || function() {
    $76a6bf7476dad299$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76a6bf7476dad299$var$__assign.apply(this, arguments);
};
var $76a6bf7476dad299$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $76a6bf7476dad299$export$b204c8549f010cd = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $76a6bf7476dad299$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $76a6bf7476dad299$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1 1.75a.75.75 0 011.5 0v4.714a10.997 10.997 0 119.497 16.53.75.75 0 010-1.5A9.497 9.497 0 103.47 7.832h5.11a.75.75 0 010 1.5h-6.2a.745.745 0 01-.077 0H1.75a.75.75 0 01-.75-.75V1.75z"
    })));
});
$76a6bf7476dad299$export$b204c8549f010cd.displayName = 'RotateLeft';





var $denZA = parcelRequire("denZA");
var $2f42242f3e41bf29$var$__assign = undefined && undefined.__assign || function() {
    $2f42242f3e41bf29$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f42242f3e41bf29$var$__assign.apply(this, arguments);
};
var $2f42242f3e41bf29$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2f42242f3e41bf29$export$7257def152302e45 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2f42242f3e41bf29$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2f42242f3e41bf29$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M0 2a1.5 1.5 0 113 0v2.414a11.746 11.746 0 118.746 19.58 1.5 1.5 0 01.002-3 8.747 8.747 0 10-7.23-13.663h3.813a1.5 1.5 0 110 3H2.152a1.2 1.2 0 01-.12 0H1.5a1.5 1.5 0 01-1.5-1.5V2z"
    })));
});
$2f42242f3e41bf29$export$7257def152302e45.displayName = 'RotateLeftBold';





var $denZA = parcelRequire("denZA");
var $0beeaa43ce47fec3$var$__assign = undefined && undefined.__assign || function() {
    $0beeaa43ce47fec3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0beeaa43ce47fec3$var$__assign.apply(this, arguments);
};
var $0beeaa43ce47fec3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0beeaa43ce47fec3$export$75099d76a78789f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0beeaa43ce47fec3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0beeaa43ce47fec3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.257 2.002a.75.75 0 00-1.5 0v4.714a10.999 10.999 0 00-18.484-.813 10.997 10.997 0 008.987 17.343.75.75 0 100-1.5 9.496 9.496 0 118.528-13.663h-5.113a.75.75 0 000 1.5h6.2a.744.744 0 00.078 0h.554a.75.75 0 00.75-.75V2.002z"
    })));
});
$0beeaa43ce47fec3$export$75099d76a78789f.displayName = 'RotateRight';





var $denZA = parcelRequire("denZA");
var $0d18529d759c2b9c$var$__assign = undefined && undefined.__assign || function() {
    $0d18529d759c2b9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d18529d759c2b9c$var$__assign.apply(this, arguments);
};
var $0d18529d759c2b9c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d18529d759c2b9c$export$1d157cf51c63a935 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0d18529d759c2b9c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0d18529d759c2b9c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M24 2a1.5 1.5 0 00-3 0v2.414A11.75 11.75 0 007.576 1.47a11.747 11.747 0 004.678 22.525 1.5 1.5 0 00-.002-3 8.747 8.747 0 117.23-13.664h-3.813a1.5 1.5 0 000 3h6.179c.04.002.08.002.12 0h.532a1.5 1.5 0 001.5-1.5V2z"
    })));
});
$0d18529d759c2b9c$export$1d157cf51c63a935.displayName = 'RotateRightBold';





var $denZA = parcelRequire("denZA");
var $ced9f3915d58a881$var$__assign = undefined && undefined.__assign || function() {
    $ced9f3915d58a881$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ced9f3915d58a881$var$__assign.apply(this, arguments);
};
var $ced9f3915d58a881$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ced9f3915d58a881$export$be11e187edb4cb0c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ced9f3915d58a881$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ced9f3915d58a881$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.5 15.75a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM8.25 18a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm7.5-15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.25 24A2.25 2.25 0 010 21.75V7.243a3.75 3.75 0 011.099-2.651L4.59 1.099A3.75 3.75 0 017.243 0H21.75A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25zM6.382 1.671a2.25 2.25 0 01.86-.171H7.5v5.25A2.25 2.25 0 009.75 9h7.5a2.25 2.25 0 002.25-2.25V1.5h2.25a.75.75 0 01.75.75v19.5a.75.75 0 01-.75.75H19.5v-8.25A2.25 2.25 0 0017.25 12H6.75a2.25 2.25 0 00-2.25 2.25v8.25H2.25a.75.75 0 01-.75-.75V7.243c0-.597.237-1.169.66-1.59l3.49-3.495a2.25 2.25 0 01.73-.488zM6 22.5h12v-8.25a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v8.25zm12-21v5.25a.75.75 0 01-.75.75h-7.5A.75.75 0 019 6.75V1.5h9z",
        fillRule: "evenodd"
    })));
});
$ced9f3915d58a881$export$be11e187edb4cb0c.displayName = 'Save';





var $denZA = parcelRequire("denZA");
var $bc386fbf365c9d5d$var$__assign = undefined && undefined.__assign || function() {
    $bc386fbf365c9d5d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc386fbf365c9d5d$var$__assign.apply(this, arguments);
};
var $bc386fbf365c9d5d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc386fbf365c9d5d$export$d66d9fc7eec08021 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bc386fbf365c9d5d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bc386fbf365c9d5d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22 0H5.914c-.53-.001-1.04.21-1.414.587L.586 4.5A2.009 2.009 0 000 5.915V22a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2zm-3.5 2a.5.5 0 01.5.5v4A1.5 1.5 0 0117.5 8h-10A1.5 1.5 0 016 6.5v-4a.5.5 0 01.5-.5h12zm-14 19.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-8A1.5 1.5 0 0019 12H6a1.5 1.5 0 00-1.5 1.5v8z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M15 4.251v1.5a.75.75 0 001.5 0v-1.5a.75.75 0 00-1.5 0zm-8 12h6.5a.75.75 0 000-1.5H7a.75.75 0 000 1.5zm0 4h11a.75.75 0 000-1.5H7a.75.75 0 000 1.5z"
    })));
});
$bc386fbf365c9d5d$export$d66d9fc7eec08021.displayName = 'SaveBold';





var $denZA = parcelRequire("denZA");
var $c59d4138e9d9dfb4$var$__assign = undefined && undefined.__assign || function() {
    $c59d4138e9d9dfb4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c59d4138e9d9dfb4$var$__assign.apply(this, arguments);
};
var $c59d4138e9d9dfb4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c59d4138e9d9dfb4$export$71dc135d99594e20 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c59d4138e9d9dfb4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c59d4138e9d9dfb4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.358 13.668a8 8 0 00-7.2-.11l-.1.06-.15.11c-1.68 1.24-2.18 3-.85 4.49a18.232 18.232 0 00-2.33 2.32l-.11.13v-7.21a6.75 6.75 0 10-1.5 0v7.21a18.004 18.004 0 00-2.42-2.45c1.37-1.49.8-3.36-1-4.6l-.1-.06a8 8 0 00-7.2.11.75.75 0 00-.17 1.2c.261.252.496.53.7.83.295.447.543.922.74 1.42l.09.21a6.84 6.84 0 001.29 2.17l.13.14c1.43 1.43 3.3 1.44 4.44-.38.905.74 1.73 1.575 2.46 2.49.332.415.63.857.89 1.32l.06.1.09.17.07.17 1.017-.04h.06l.09-.2.1-.2c.26-.463.573-.905.905-1.32.73-.915 1.554-1.75 2.46-2.49 1.16 2 3.348 1.798 4.828.178.75-.938.75-.938 1.25-1.858l.29-.66a6.89 6.89 0 01.66-1.24 5.19 5.19 0 01.69-.82.75.75 0 00-.18-1.19zm-15.85 3.61a26.92 26.92 0 00-1.54-1.05.753.753 0 00-.81 1.27c.44.28.856.563 1.25.85-.61 1.1-1.43 1.06-2.27.15a5.56 5.56 0 01-1-1.75l-.1-.23a8.85 8.85 0 00-.86-1.65l-.18-.25h.14a6.47 6.47 0 014.57.22l.2.09h-.01c1.08.72 1.38 1.57.61 2.35zm4.39-5.28a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm9.72 2.85c-.31.455-.571.941-.78 1.45l-.19.44a5.562 5.562 0 01-1 1.76c-.84.92-1.66.95-2.27-.15.393-.287.81-.57 1.25-.85a.753.753 0 00-.81-1.27 26.91 26.91 0 00-1.54 1.05c-.75-.76-.49-1.58.53-2.34l.08-.06a6.47 6.47 0 014.78-.32h.13l-.18.29z"
    }), $denZA.createElement("path", {
        d: "M13.188 6.468l-2.06-.83h-.08a.59.59 0 01.3-1.1h2.14a.771.771 0 10-.11-1.54h-.75v-.1a.75.75 0 00-1.49.1 2.09 2.09 0 00-.56 4l2.06.83h.08a.59.59 0 01-.3 1.1h-2.14a.75.75 0 00.1 1.49h.75v.1a.75.75 0 001.49-.1 2.09 2.09 0 00.56-4l.01.05z"
    })));
});
$c59d4138e9d9dfb4$export$71dc135d99594e20.displayName = 'SavingMoneyFlower';





var $denZA = parcelRequire("denZA");
var $5fae4f1efc923428$var$__assign = undefined && undefined.__assign || function() {
    $5fae4f1efc923428$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5fae4f1efc923428$var$__assign.apply(this, arguments);
};
var $5fae4f1efc923428$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5fae4f1efc923428$export$3cb7ee0299df8f39 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5fae4f1efc923428$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5fae4f1efc923428$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.589 13.325a.475.475 0 00-.319-.255.493.493 0 00-.406.08c-.672.462-1.44.78-2.25.93-.714.14-1.397.4-2.017.767a2.37 2.37 0 00-1.234 1.902 1.68 1.68 0 00.096.57.225.225 0 01-.077.254 14.71 14.71 0 00-1.62 1.452.246.246 0 01-.264.058.231.231 0 01-.152-.215v-4.107c0-.113.085-.21.2-.228 3.631-.581 6.193-3.747 5.89-7.28C19.134 3.718 16.07 1 12.388 1c-3.68 0-6.746 2.72-7.049 6.252-.302 3.534 2.26 6.7 5.89 7.28.116.02.2.116.2.229v3.192a.23.23 0 01-.136.208.247.247 0 01-.254-.03 10.423 10.423 0 00-1.829-1.144.132.132 0 01-.076-.125 2.56 2.56 0 00-1.314-2.078 6.242 6.242 0 00-5.606.069.452.452 0 00-.068.716 5.012 5.012 0 011.18 1.817c.234.607.577 1.17 1.014 1.661.43.501 1.06.805 1.734.838.087 0 .173-.005.26-.018a2.08 2.08 0 001.513-1.178.24.24 0 01.08-.083l.034-.022a.246.246 0 01.24-.016 7.342 7.342 0 013.197 2.701.222.222 0 01.033.117v.846a1 1 0 00.794.903c.443.098.9-.096 1.123-.478A13.173 13.173 0 0116.606 19a.093.093 0 01.134.022c.304.56.848.96 1.487 1.1.118.021.238.032.358.032a3.14 3.14 0 002.153-1.033 6.111 6.111 0 00.85-5.796zm-10.925-1.384c-.463 0-.839-.362-.839-.808 0-.446.376-.808.839-.808h2.338c.338 0 .63-.23.693-.55a.674.674 0 00-.431-.759l-2.372-.907c-.987-.38-1.592-1.343-1.485-2.361.107-1.019.901-1.845 1.947-2.027a.233.233 0 00.197-.227v-.111c0-.446.376-.808.839-.808.463 0 .838.362.838.808v.069c0 .127.107.23.24.23h.647c.463 0 .838.362.838.808 0 .446-.375.808-.838.808h-2.339a.698.698 0 00-.69.55.674.674 0 00.429.758l2.374.914c.986.38 1.592 1.344 1.484 2.362-.107 1.018-.902 1.844-1.947 2.025a.234.234 0 00-.198.227v.11c0 .446-.375.808-.838.808-.463 0-.839-.362-.839-.808v-.069a.235.235 0 00-.24-.23l-.647-.004z"
    })));
});
$5fae4f1efc923428$export$3cb7ee0299df8f39.displayName = 'SavingMoneyFlowerBold';





var $denZA = parcelRequire("denZA");
var $8f415ca0ee20d5ad$var$__assign = undefined && undefined.__assign || function() {
    $8f415ca0ee20d5ad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f415ca0ee20d5ad$var$__assign.apply(this, arguments);
};
var $8f415ca0ee20d5ad$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f415ca0ee20d5ad$export$4b85d3515bd863a5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8f415ca0ee20d5ad$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8f415ca0ee20d5ad$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 1.25a8.75 8.75 0 105.634 15.445l5.836 5.835a.75.75 0 001.06-1.06l-5.835-5.836A8.75 8.75 0 0010 1.25zM2.75 10a7.25 7.25 0 1114.5 0 7.25 7.25 0 01-14.5 0z",
        fillRule: "evenodd"
    })));
});
$8f415ca0ee20d5ad$export$4b85d3515bd863a5.displayName = 'Search';





var $denZA = parcelRequire("denZA");
var $05385ba2eb2e97e7$var$__assign = undefined && undefined.__assign || function() {
    $05385ba2eb2e97e7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $05385ba2eb2e97e7$var$__assign.apply(this, arguments);
};
var $05385ba2eb2e97e7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $05385ba2eb2e97e7$export$8278256c54fb93b2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $05385ba2eb2e97e7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $05385ba2eb2e97e7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    })));
});
$05385ba2eb2e97e7$export$8278256c54fb93b2.displayName = 'SearchBold';





var $denZA = parcelRequire("denZA");
var $def294327dca5302$var$__assign = undefined && undefined.__assign || function() {
    $def294327dca5302$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $def294327dca5302$var$__assign.apply(this, arguments);
};
var $def294327dca5302$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $def294327dca5302$export$9fb697de7778c436 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $def294327dca5302$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $def294327dca5302$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.182 1.874A22.45 22.45 0 0012 .001 22.45 22.45 0 002.806 1.88a2.237 2.237 0 00-1.305 2.046v7.611A12.657 12.657 0 009.613 23.35l1.04.4a3.751 3.751 0 002.693 0l1.041-.4A12.657 12.657 0 0022.5 11.537V3.926a2.238 2.238 0 00-1.318-2.052zM3 3.924v-.005a.737.737 0 01.426-.673 20.95 20.95 0 018.581-1.745 20.95 20.95 0 018.568 1.745.738.738 0 01.425.673v7.618a11.156 11.156 0 01-7.15 10.413l-1.042.4c-.52.2-1.096.2-1.616 0l-1.04-.4A11.156 11.156 0 013 11.538V3.923z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.746 12.917a.696.696 0 10-1.392 0V14.5a.696.696 0 101.392 0v-1.583z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M8.584 8.167v1.284h-.888a.696.696 0 00-.696.695v7.125c0 .384.312.696.696.696h8.708a.696.696 0 00.696-.696v-7.125a.696.696 0 00-.696-.695h-.887V8.167a3.467 3.467 0 10-6.933 0zM10.583 6.7a2.075 2.075 0 013.542 1.467v1.284h-4.15V8.167c0-.55.219-1.078.608-1.467zm-2.191 9.875v-5.733h7.316v5.733H8.392z",
        fillRule: "evenodd"
    })));
});
$def294327dca5302$export$9fb697de7778c436.displayName = 'Security';





var $denZA = parcelRequire("denZA");
var $d49068cb880d8195$var$__assign = undefined && undefined.__assign || function() {
    $d49068cb880d8195$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d49068cb880d8195$var$__assign.apply(this, arguments);
};
var $d49068cb880d8195$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d49068cb880d8195$export$ff3cf24dfc418321 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d49068cb880d8195$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d49068cb880d8195$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.15 2.71a2.24 2.24 0 00-1-.83A22.45 22.45 0 0012 0a22.45 22.45 0 00-9.18 1.91 2.24 2.24 0 00-1.32 2v7.61a12.66 12.66 0 008.11 11.83l1 .4a3.75 3.75 0 002.69 0l1-.4a12.66 12.66 0 008.2-11.82V3.91c0-.425-.122-.84-.35-1.2zm-5.2 14.06a.7.7 0 01-.49.2H7.7a.7.7 0 01-.7-.7V9.14a.7.7 0 01.7-.7h.89V7.16a3.47 3.47 0 116.93 0v1.29h.89a.7.7 0 01.7.7v7.12a.7.7 0 01-.16.5z"
    }), $denZA.createElement("path", {
        d: "M14.13 7.16a2.08 2.08 0 00-4.15 0v1.29h4.15V7.16zm-5.74 8.41h7.32V9.84H8.39v5.73zm3-3.66a.7.7 0 111.39 0v1.58a.7.7 0 11-1.39 0v-1.58z"
    })));
});
$d49068cb880d8195$export$ff3cf24dfc418321.displayName = 'SecurityBold';





var $denZA = parcelRequire("denZA");
var $16ce1ec042e23368$var$__assign = undefined && undefined.__assign || function() {
    $16ce1ec042e23368$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16ce1ec042e23368$var$__assign.apply(this, arguments);
};
var $16ce1ec042e23368$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16ce1ec042e23368$export$ef9b1a59e592288f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $16ce1ec042e23368$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $16ce1ec042e23368$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.608 24H9.983c-.191 0-.479-.096-.575-.288l-3.737-4.887c-.575-.767-.575-1.725-.096-2.492.67-.958 2.013-1.245 3.067-.575 0 0 .096 0 .096.096l.479.384v-8.05c0-1.15.958-2.109 2.204-2.109 1.246 0 2.204.958 2.204 2.109v5.175l3.45.766c1.725.383 2.97 2.013 2.78 3.833l-.48 5.367c0 .383-.383.671-.767.671zm-8.241-1.438h7.57l.384-4.695c.096-1.055-.671-2.109-1.725-2.3l-4.025-.863c-.288-.096-.575-.383-.575-.67v-5.75c0-.384-.288-.767-.671-.767-.287 0-.575.287-.575.67v9.296c0 .288-.192.48-.383.671-.288.096-.575.096-.767-.096l-1.63-1.245c-.382-.192-.766-.096-1.053.191-.192.288-.192.575 0 .863l3.45 4.695zm1.15-17.92a.756.756 0 01-.767-.767V1.767c0-.48.287-.767.767-.767.479 0 .766.288.766.767v2.108c-.095.383-.383.767-.766.767zm2.779.671a.732.732 0 01-.48-.192.752.752 0 010-1.054l1.438-1.438a.752.752 0 011.054 0 .752.752 0 010 1.054l-1.437 1.438c-.192.096-.383.191-.575.191zm-5.654 0a.732.732 0 01-.48-.192L6.63 3.683a.752.752 0 010-1.054.752.752 0 011.054 0l1.438 1.438a.752.752 0 010 1.054c-.192.096-.383.191-.48.191zm8.528 2.204h-2.108a.756.756 0 01-.766-.767c0-.48.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.288.767-.767.767zm-9.295 0H5.767A.756.756 0 015 6.75c0-.383.287-.767.767-.767h2.108c.383 0 .767.288.767.767 0 .48-.384.767-.767.767z"
    })));
});
$16ce1ec042e23368$export$ef9b1a59e592288f.displayName = 'Select';





var $denZA = parcelRequire("denZA");
var $6bd74d9a16703f48$var$__assign = undefined && undefined.__assign || function() {
    $6bd74d9a16703f48$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6bd74d9a16703f48$var$__assign.apply(this, arguments);
};
var $6bd74d9a16703f48$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6bd74d9a16703f48$export$603458ca8a362063 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6bd74d9a16703f48$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6bd74d9a16703f48$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.517.75c-.29 0-.551.088-.74.277-.19.189-.277.45-.277.74v2.108c0 .5.38 1.017 1.017 1.017.28 0 .51-.142.675-.321a1.49 1.49 0 00.334-.635l.007-.03v-2.14c0-.289-.088-.55-.276-.74-.19-.188-.45-.276-.74-.276zM7.86 2.452a1.002 1.002 0 00-1.408 0 1.002 1.002 0 000 1.408L7.99 5.3c.14.14.392.263.653.263a.56.56 0 00.16-.028c.047-.014.095-.033.142-.053.09-.038.192-.09.285-.136l.04-.02.029-.028a1.002 1.002 0 000-1.408L7.86 2.452zm7.217 0a1.002 1.002 0 011.408 0 1.002 1.002 0 010 1.408L15.02 5.326l-.058.03c-.175.087-.413.207-.665.207a.98.98 0 01-.656-.265 1.002 1.002 0 010-1.408l1.437-1.438zm-9.31 3.281c-.638 0-1.017.517-1.017 1.017 0 .5.38 1.017 1.017 1.017h2.108c.5 0 1.017-.38 1.017-1.017 0-.637-.517-1.017-1.017-1.017H5.767zm8.556.277c.189-.189.45-.277.74-.277h2.108c.5 0 1.017.38 1.017 1.017 0 .29-.088.55-.277.74-.19.189-.45.277-.74.277h-2.108c-.501 0-1.017-.38-1.017-1.017 0-.29.088-.55.277-.74zM9.983 24h8.625c.384 0 .767-.288.767-.67l.48-5.367c.19-1.821-1.055-3.45-2.78-3.834l-3.45-.766V8.188c0-1.15-.958-2.109-2.204-2.109-1.246 0-2.204.958-2.204 2.109v8.05l-.48-.384c0-.096-.095-.096-.095-.096-1.054-.67-2.396-.383-3.067.575-.48.767-.48 1.725.096 2.492l3.737 4.887c.096.192.384.288.575.288z"
    })));
});
$6bd74d9a16703f48$export$603458ca8a362063.displayName = 'SelectBold';





var $denZA = parcelRequire("denZA");
var $a2fac42c017563b6$var$__assign = undefined && undefined.__assign || function() {
    $a2fac42c017563b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a2fac42c017563b6$var$__assign.apply(this, arguments);
};
var $a2fac42c017563b6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a2fac42c017563b6$export$2b74fd7268b370b8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a2fac42c017563b6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a2fac42c017563b6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#seo-search_svg__a)",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }, $denZA.createElement("path", {
        d: "M18.821 2.274a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zm-3.916 2.4a3.916 3.916 0 117.832 0 3.916 3.916 0 01-7.832 0z"
    }), $denZA.createElement("path", {
        d: "M20.518 6.37a.758.758 0 011.072 0l2.188 2.189a.758.758 0 11-1.072 1.072l-2.188-2.19a.758.758 0 010-1.071zM2.274 3.537a.758.758 0 00-.758.758V5.81c0 .418.34.757.758.757h10.61a.758.758 0 110 1.516H2.274A2.274 2.274 0 010 5.811V4.295A2.274 2.274 0 012.274 2.02h10.61a.758.758 0 110 1.516H2.274zm-.758 7.958a1.137 1.137 0 112.273 0 1.137 1.137 0 01-2.273 0zm3.789.379c0-.419.34-.758.758-.758H18.19a.758.758 0 110 1.516H6.062a.758.758 0 01-.758-.758zM1.516 16.8a1.137 1.137 0 112.273 0 1.137 1.137 0 01-2.273 0zm3.789.379c0-.419.34-.758.758-.758H18.19a.758.758 0 110 1.516H6.062a.758.758 0 01-.758-.758zm-3.789 4.926a1.137 1.137 0 112.274 0 1.137 1.137 0 01-2.274 0zm3.789.379c0-.418.34-.758.758-.758H18.19a.758.758 0 010 1.516H6.062a.758.758 0 01-.758-.758z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "seo-search_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$a2fac42c017563b6$export$2b74fd7268b370b8.displayName = 'SeoSearch';





var $denZA = parcelRequire("denZA");
var $ebd0bf6790f055a0$var$__assign = undefined && undefined.__assign || function() {
    $ebd0bf6790f055a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ebd0bf6790f055a0$var$__assign.apply(this, arguments);
};
var $ebd0bf6790f055a0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ebd0bf6790f055a0$export$f249f61886f02153 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ebd0bf6790f055a0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ebd0bf6790f055a0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2.251 3.743h8.754a1 1 0 100-2H1.58c-.85-.02-1.557.65-1.581 1.5v3c.024.849.73 1.52 1.58 1.5h9.425a1 1 0 100-2H2.25a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.378 6.94a.249.249 0 00.043.3l2.298 2.299a1 1 0 01-1.414 1.414l-2.296-2.3a.251.251 0 00-.3-.042 4.185 4.185 0 01-5.354-1.162 4.18 4.18 0 01.387-5.462 4.186 4.186 0 015.464-.396 4.18 4.18 0 011.172 5.348zm-5.685-1.163a2.18 2.18 0 104.029-1.67 2.18 2.18 0 00-4.03 1.67z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M3.001 16.74a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0 5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11.505-5.999H5.002a1 1 0 100 2h9.504a1 1 0 100-2zM3.001 11.742a1.5 1.5 0 11-3-.001 1.5 1.5 0 013 0zm11.505-1H5.002a1 1 0 100 2h9.504a1 1 0 100-2zm0 9.998H5.002a1 1 0 100 2h9.504a1 1 0 100-2z"
    })));
});
$ebd0bf6790f055a0$export$f249f61886f02153.displayName = 'SeoSearchBold';





var $denZA = parcelRequire("denZA");
var $75a747b31eaec71f$var$__assign = undefined && undefined.__assign || function() {
    $75a747b31eaec71f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75a747b31eaec71f$var$__assign.apply(this, arguments);
};
var $75a747b31eaec71f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $75a747b31eaec71f$export$d59771a2e9612de9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $75a747b31eaec71f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $75a747b31eaec71f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M13.509 9H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6.737.754A.76.76 0 0019.49 9h-3a.761.761 0 00-.754.754c0 .412.343.755.754.755h3c.429-.018.755-.343.755-.755zM5.623 8.623c-.617 0-1.132.497-1.132 1.114 0 .617.498 1.132 1.115 1.132a1.13 1.13 0 001.131-1.132c.017-.6-.497-1.114-1.114-1.114zM13.509 18H12a.761.761 0 00-.754.754c0 .412.343.755.754.755h1.509a.761.761 0 00.754-.755.761.761 0 00-.754-.754zm6 0H16.49a.761.761 0 00-.754.754c0 .412.343.755.754.755h3a.761.761 0 00.755-.755.746.746 0 00-.737-.754z"
    }), $denZA.createElement("path", {
        d: "M21.446 14.246A5.235 5.235 0 0024 9.754a5.04 5.04 0 00-.497-2.211v-.017l-2.52-5.366A3.742 3.742 0 0017.589 0H6.41a3.76 3.76 0 00-3.394 2.16L.497 7.526v.017A5.04 5.04 0 000 9.754a5.235 5.235 0 002.554 4.492A5.264 5.264 0 000 18.754 5.246 5.246 0 005.246 24h13.508A5.246 5.246 0 0024 18.754c0-1.92-1.029-3.583-2.554-4.508zM4.37 2.794a2.27 2.27 0 012.04-1.303h11.195a2.27 2.27 0 012.04 1.303l.96 2.04a5.357 5.357 0 00-1.835-.325H5.246c-.652 0-1.269.12-1.835.325l.96-2.04zm-2.86 6.96A3.748 3.748 0 015.246 6h13.508a3.753 3.753 0 013.755 3.754 3.753 3.753 0 01-3.755 3.755H5.246c-2.057 0-3.737-1.698-3.737-3.755zm17.245 12.737H5.246a3.753 3.753 0 01-3.755-3.754 3.753 3.753 0 013.755-3.754h13.508a3.753 3.753 0 013.755 3.754 3.764 3.764 0 01-3.755 3.754z"
    }), $denZA.createElement("path", {
        d: "M5.623 17.623c-.617 0-1.132.497-1.132 1.114 0 .309.12.583.326.789a1.13 1.13 0 001.92-.806c.017-.583-.497-1.097-1.114-1.097z"
    })));
});
$75a747b31eaec71f$export$d59771a2e9612de9.displayName = 'Server';





var $denZA = parcelRequire("denZA");
var $f08149f3d9c787af$var$__assign = undefined && undefined.__assign || function() {
    $f08149f3d9c787af$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f08149f3d9c787af$var$__assign.apply(this, arguments);
};
var $f08149f3d9c787af$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f08149f3d9c787af$export$4ab572d6c7707b33 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f08149f3d9c787af$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f08149f3d9c787af$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.93 8.2a2.55 2.55 0 00-1.86-1.66 13.74 13.74 0 00-2.279-.28H6.174a6.577 6.577 0 00-2.54.38 2.19 2.19 0 00-1.249 1.29L.515 7.2a4.19 4.19 0 012.41-2.42 8.556 8.556 0 013.28-.51H17.81c.901.032 1.798.143 2.68.33a4.538 4.538 0 013.319 2.95l-1.88.65z"
    }), $denZA.createElement("path", {
        d: "M19.381 4.27H4.944C.516 4.24.006 7.83.006 9.8a5.09 5.09 0 004.779 5.32H19.24A5.619 5.619 0 0024 9.87c0-1.98-.19-5.63-4.619-5.6zM5.614 10.91a1.16 1.16 0 11.02-2.32 1.16 1.16 0 01-.02 2.32zm6.389-.16a1 1 0 010-2h1.4a1 1 0 010 2h-1.4zm4.419 0a1 1 0 010-2h3.149a1 1 0 110 2h-3.15z"
    }), $denZA.createElement("path", {
        d: "M19.291 14.88H5.464a3.789 3.789 0 00-2.679 6.47 3.79 3.79 0 002.68 1.11H19.29a3.789 3.789 0 002.68-6.47 3.789 3.789 0 00-2.68-1.11zM5.614 20a1.16 1.16 0 110-2.319 1.16 1.16 0 010 2.319zm6.389-.16a1 1 0 010-2h1.4a1 1 0 010 2h-1.4zm7.558 0h-3.15a1 1 0 010-2h3.15a1 1 0 010 2z"
    }), $denZA.createElement("path", {
        d: "M19.001 24H5.074a5.068 5.068 0 01-5.068-5v-.91A5.07 5.07 0 015.074 13h13.927A5.069 5.069 0 0124 18.06V19a5.07 5.07 0 01-4.999 5zM5.074 15a3.07 3.07 0 00-3.069 3.06V19a3.07 3.07 0 003.07 3H19a3.069 3.069 0 003-3v-.91A3.07 3.07 0 0019 15H5.074zM1.505 4s1.72-3.44 5-4h10.997C18.668.207 21.7 1.248 22.5 4c-1.618-.595-2.499-1-4.998-1H7.504c-1.9.05-4.839-.05-5.999 1z"
    })));
});
$f08149f3d9c787af$export$4ab572d6c7707b33.displayName = 'ServerBold';





var $denZA = parcelRequire("denZA");
var $4aac5e3099e039e9$var$__assign = undefined && undefined.__assign || function() {
    $4aac5e3099e039e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4aac5e3099e039e9$var$__assign.apply(this, arguments);
};
var $4aac5e3099e039e9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4aac5e3099e039e9$export$c72f6eaae7b9adff = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $4aac5e3099e039e9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $4aac5e3099e039e9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 7.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM8.75 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM18.717 3.87l1.415 1.413-.61.61c-.914.913-1.02 2.224-.6 3.24C19.343 10.15 20.346 11 21.635 11h.865v2.002h-.864c-1.29 0-2.293.852-2.713 1.866-.421 1.016-.316 2.328.597 3.24l.611.611-1.413 1.414-.613-.612c-.913-.912-2.224-1.018-3.24-.597C13.85 19.346 13 20.348 13 21.637v.863h-2v-.863c0-1.289-.85-2.291-1.866-2.713-1.016-.422-2.328-.316-3.24.597l-.587.585a.045.045 0 01-.052 0l-1.388-1.388.613-.613c.913-.913 1.018-2.224.597-3.24C4.657 13.852 3.655 13 2.365 13H1.5v-2h.866c1.29 0 2.29-.85 2.71-1.865.422-1.015.317-2.327-.597-3.24l-.612-.611L5.282 3.87l.613.612c.912.912 2.224 1.018 3.24.597C10.15 4.657 11 3.655 11 2.366V1.5h2v.866c0 1.29.85 2.291 1.865 2.712 1.015.421 2.326.316 3.239-.596l.613-.612z",
        fillRule: "evenodd"
    })));
});
$4aac5e3099e039e9$export$c72f6eaae7b9adff.displayName = 'Settings';





var $denZA = parcelRequire("denZA");
var $e6f315935e9437e0$var$__assign = undefined && undefined.__assign || function() {
    $e6f315935e9437e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e6f315935e9437e0$var$__assign.apply(this, arguments);
};
var $e6f315935e9437e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e6f315935e9437e0$export$18e4ef42d74628e8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e6f315935e9437e0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e6f315935e9437e0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M20.581 6.954l.611-.61a1.5 1.5 0 000-2.122l-1.415-1.413a1.5 1.5 0 00-2.121 0l-.612.612c-.418.417-1.059.498-1.604.272-.545-.227-.94-.736-.94-1.327V1.5A1.5 1.5 0 0013 0h-2a1.5 1.5 0 00-1.5 1.5v.866c0 .59-.395 1.1-.94 1.327-.546.227-1.187.145-1.605-.272l-.612-.612a1.5 1.5 0 00-2.121 0L2.807 4.223a1.5 1.5 0 000 2.122l.612.611c.418.418.499 1.059.272 1.604-.226.545-.735.94-1.325.94H1.5A1.5 1.5 0 000 11v2a1.5 1.5 0 001.5 1.5h.865c.59 0 1.1.395 1.327.94.226.546.145 1.187-.273 1.605l-.613.613a1.5 1.5 0 000 2.121l1.414 1.414a1.545 1.545 0 002.122 0l.611-.61c.419-.42 1.06-.5 1.606-.273.546.226.941.737.941 1.328v.862A1.5 1.5 0 0011 24h2a1.5 1.5 0 001.5-1.5v-.863c0-.59.395-1.1.94-1.327.546-.227 1.187-.145 1.605.272l.612.612a1.5 1.5 0 002.121 0l1.414-1.414a1.5 1.5 0 000-2.121l-.611-.611c-.418-.418-.5-1.059-.273-1.605.227-.546.737-.941 1.328-.941h.864A1.5 1.5 0 0024 13v-2a1.5 1.5 0 00-1.5-1.5h-.865c-.59 0-1.1-.395-1.327-.94-.226-.547-.145-1.188.273-1.606zM12 16a4 4 0 100-8 4 4 0 000 8z",
        fillRule: "evenodd"
    })));
});
$e6f315935e9437e0$export$18e4ef42d74628e8.displayName = 'SettingsBold';





var $denZA = parcelRequire("denZA");
var $ffd8760e009ee784$var$__assign = undefined && undefined.__assign || function() {
    $ffd8760e009ee784$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ffd8760e009ee784$var$__assign.apply(this, arguments);
};
var $ffd8760e009ee784$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ffd8760e009ee784$export$c9915453de10000b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ffd8760e009ee784$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ffd8760e009ee784$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.15 9.5a.65.65 0 00-.65.65v11.2a.65.65 0 00.65.65h12.6a.65.65 0 00.65-.65v-11.2a.65.65 0 00-.65-.65h-1.4a.75.75 0 010-1.5h1.4a2.15 2.15 0 012.15 2.15v11.2a2.15 2.15 0 01-2.15 2.15H6.15A2.15 2.15 0 014 21.35v-11.2A2.15 2.15 0 016.15 8h1.4a.75.75 0 010 1.5h-1.4z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M11.92 1.22a.748.748 0 011.06 0l3.5 3.5a.75.75 0 01-1.06 1.06L13.2 3.56v7.99a.75.75 0 01-1.5 0V3.56L9.48 5.78a.75.75 0 01-1.06-1.06l3.5-3.5z"
    })));
});
$ffd8760e009ee784$export$c9915453de10000b.displayName = 'Share';





var $denZA = parcelRequire("denZA");
var $e4a9e4d7000c6667$var$__assign = undefined && undefined.__assign || function() {
    $e4a9e4d7000c6667$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e4a9e4d7000c6667$var$__assign.apply(this, arguments);
};
var $e4a9e4d7000c6667$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e4a9e4d7000c6667$export$4781d373f2233cee = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e4a9e4d7000c6667$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e4a9e4d7000c6667$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M5.8 10h1.3a1.5 1.5 0 100-3H5.7a2.9 2.9 0 00-2.9 2.9v11.2A2.9 2.9 0 005.7 24h12.6a2.9 2.9 0 002.9-2.9V9.9A2.9 2.9 0 0018.3 7h-1.4a1.5 1.5 0 000 3h1.3v11H5.8V10z"
    }), $denZA.createElement("path", {
        d: "M10.99.43a1.401 1.401 0 012-.02l3.29 3.29a1.414 1.414 0 11-2 2l-.88-.88v5.8a1.41 1.41 0 11-2.82 0V4.81l-.88.88a1.414 1.414 0 01-2-2L10.99.43z"
    })));
});
$e4a9e4d7000c6667$export$4781d373f2233cee.displayName = 'ShareBold';





var $denZA = parcelRequire("denZA");
var $16f9d13b2aaed625$var$__assign = undefined && undefined.__assign || function() {
    $16f9d13b2aaed625$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16f9d13b2aaed625$var$__assign.apply(this, arguments);
};
var $16f9d13b2aaed625$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16f9d13b2aaed625$export$64f4d36820ccbbb3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $16f9d13b2aaed625$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $16f9d13b2aaed625$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.61 17H6.82a.08.08 0 01-.08-.07l-.44-2.36h5.33a.75.75 0 100-1.5H6L4.73 6.34H19.8v.08l-1.17 3.93a.75.75 0 00.5.93c.07.01.14.01.21 0a.75.75 0 00.72-.54l1.24-3.89a1.58 1.58 0 00-1.52-2H4.45l-.61-3.2A1.53 1.53 0 002.34.4H.8a.75.75 0 100 1.5h1.57l2.9 15.24a1.59 1.59 0 001.56 1.29h3.79a.75.75 0 00.53-1.28c-.14-.141-.341-.15-.54-.15zm-2.98 4.52a1.22 1.22 0 100-2.44 1.22 1.22 0 000 2.44z"
    }), $denZA.createElement("path", {
        d: "M17.92 11.52a6 6 0 100 12 6 6 0 000-12zm0 10.57a4.54 4.54 0 114.54-4.54 4.54 4.54 0 01-4.54 4.55v-.01z"
    }), $denZA.createElement("path", {
        d: "M19.93 16.8h-1.24v-1.34a.75.75 0 10-1.5 0v1.34h-1.28a.75.75 0 100 1.5h1.29v1.36a.75.75 0 101.5 0V18.3h1.23a.75.75 0 100-1.5z"
    })));
});
$16f9d13b2aaed625$export$64f4d36820ccbbb3.displayName = 'ShoppingCartAddItem';





var $denZA = parcelRequire("denZA");
var $25f0806fde3cdc00$var$__assign = undefined && undefined.__assign || function() {
    $25f0806fde3cdc00$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25f0806fde3cdc00$var$__assign.apply(this, arguments);
};
var $25f0806fde3cdc00$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25f0806fde3cdc00$export$9d77b3ceb9ec018e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $25f0806fde3cdc00$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $25f0806fde3cdc00$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#shopping-cart-add-item-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M18 11.67a6 6 0 100 12 6 6 0 000-12zm2 6.76h-1.19v1.36a.75.75 0 11-1.5 0v-1.37H16a.75.75 0 110-1.5h1.29v-1.33a.75.75 0 111.5 0v1.33H20a.75.75 0 110 1.5v.01zM8.12 22.62a1.76 1.76 0 100-3.52 1.76 1.76 0 000 3.52z"
    }), $denZA.createElement("path", {
        d: "M19.76 10.95h.09a1 1 0 001-.72l1-3.32A1.84 1.84 0 0020 4.56H4.88l-.57-3A1.78 1.78 0 002.59.15H1.05a1 1 0 000 2h1.36l2.86 15.06a1.84 1.84 0 001.8 1.49h3a1 1 0 100-2H7.21l-.36-1.88h4a1 1 0 00.83-.48 7.69 7.69 0 018.08-3.39z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "shopping-cart-add-item-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$25f0806fde3cdc00$export$9d77b3ceb9ec018e.displayName = 'ShoppingCartAddItemBold';





var $denZA = parcelRequire("denZA");
var $a0c0913ffb5b54b4$var$__assign = undefined && undefined.__assign || function() {
    $a0c0913ffb5b54b4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0c0913ffb5b54b4$var$__assign.apply(this, arguments);
};
var $a0c0913ffb5b54b4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a0c0913ffb5b54b4$export$da12aa22285df23e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a0c0913ffb5b54b4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a0c0913ffb5b54b4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.44 6.39a1.63 1.63 0 00-1.32-.68H5.63l-.67-3.42A1.58 1.58 0 003.37 1H1.75a.75.75 0 000 1.5h1.62a.08.08 0 01.08.07L6.6 18.92a1.65 1.65 0 001.62 1.34h10.56a.75.75 0 100-1.5H8.22a.15.15 0 01-.14-.12l-.48-2.55h11.13a3.27 3.27 0 003.15-2.32l1.82-5.92a1.631 1.631 0 00-.26-1.46zm-3 6.93a1.78 1.78 0 01-1.71 1.26H7.3L5.91 7.27h16.21a.14.14 0 01.12.06.14.14 0 010 .12l-1.8 5.87zM18.3 23.54a1.31 1.31 0 10-.825-2.488 1.31 1.31 0 00.825 2.487zm-9.22.06a1.31 1.31 0 100-2.62 1.31 1.31 0 000 2.62z"
    })));
});
$a0c0913ffb5b54b4$export$da12aa22285df23e.displayName = 'ShoppingCartEmpty';





var $denZA = parcelRequire("denZA");
var $d058379c039d1df7$var$__assign = undefined && undefined.__assign || function() {
    $d058379c039d1df7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d058379c039d1df7$var$__assign.apply(this, arguments);
};
var $d058379c039d1df7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d058379c039d1df7$export$d6491ee2f83d7f48 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d058379c039d1df7$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d058379c039d1df7$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.88 23.75a1.76 1.76 0 100-3.52 1.76 1.76 0 000 3.52zm9.12 0a1.76 1.76 0 100-3.52 1.76 1.76 0 000 3.52zM22.88 5.5a1.88 1.88 0 00-1.52-.76H5.08L4.46 1.5A1.83 1.83 0 002.63 0H1a1 1 0 100 2h1.52l3.11 16.22a1.9 1.9 0 001.86 1.54h10.54a1 1 0 100-2H7.55l-.41-2.17h10.83a3.52 3.52 0 003.38-2.5l1.82-5.92a1.88 1.88 0 00-.29-1.67z"
    })));
});
$d058379c039d1df7$export$d6491ee2f83d7f48.displayName = 'ShoppingCartEmptyBold';





var $denZA = parcelRequire("denZA");
var $d0471b993e93b8e5$var$__assign = undefined && undefined.__assign || function() {
    $d0471b993e93b8e5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0471b993e93b8e5$var$__assign.apply(this, arguments);
};
var $d0471b993e93b8e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d0471b993e93b8e5$export$5ad1f246db93943b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d0471b993e93b8e5$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d0471b993e93b8e5$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.66 16.6H6.77a.08.08 0 01-.08-.07l-.44-2.36h5.33a.75.75 0 100-1.5H5.95L4.68 5.94h15.07v.08l-1.17 3.93a.75.75 0 00.5.93c.07.01.14.01.21 0a.75.75 0 00.72-.54l1.24-3.89a1.58 1.58 0 00-1.52-2H4.4l-.61-3.2A1.53 1.53 0 002.29 0H.75a.75.75 0 100 1.5h1.57l2.9 15.24a1.59 1.59 0 001.56 1.29h3.88a.75.75 0 00.53-1.28c-.14-.141-.331-.15-.53-.15zm-3.08 4.52a1.22 1.22 0 100-2.44 1.22 1.22 0 000 2.44z"
    }), $denZA.createElement("path", {
        d: "M17.87 11.12a6 6 0 100 12 6 6 0 000-12zm0 10.57a4.54 4.54 0 114.54-4.54 4.54 4.54 0 01-4.54 4.55v-.01z"
    }), $denZA.createElement("path", {
        d: "M19.85 16.41h-4a.75.75 0 100 1.5h4a.75.75 0 100-1.5z"
    })));
});
$d0471b993e93b8e5$export$5ad1f246db93943b.displayName = 'ShoppingCartRemoveItem';





var $denZA = parcelRequire("denZA");
var $de26382110b721c9$var$__assign = undefined && undefined.__assign || function() {
    $de26382110b721c9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de26382110b721c9$var$__assign.apply(this, arguments);
};
var $de26382110b721c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $de26382110b721c9$export$758e2cc59886864 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $de26382110b721c9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $de26382110b721c9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18 11.72a6 6 0 100 12 6 6 0 000-12zm2 6.76h-4A.75.75 0 0116 17h4a.75.75 0 110 1.5v-.02zM8.06 22.67a1.76 1.76 0 100-3.52 1.76 1.76 0 000 3.52z"
    }), $denZA.createElement("path", {
        d: "M19.7 11h.09a1 1 0 001-.72l1-3.32A1.84 1.84 0 0020 4.62H4.88l-.57-3A1.78 1.78 0 002.53.21H1a1 1 0 000 2h1.34l2.87 15.06A1.84 1.84 0 007 18.76h3a1 1 0 100-2H7.15l-.36-1.88h4a1 1 0 00.83-.48A7.69 7.69 0 0119.7 11z"
    })));
});
$de26382110b721c9$export$758e2cc59886864.displayName = 'ShoppingCartRemoveItemBold';





var $denZA = parcelRequire("denZA");
var $ccc22e341c88d5ef$var$__assign = undefined && undefined.__assign || function() {
    $ccc22e341c88d5ef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccc22e341c88d5ef$var$__assign.apply(this, arguments);
};
var $ccc22e341c88d5ef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ccc22e341c88d5ef$export$694e0d28c7ffc90c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ccc22e341c88d5ef$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ccc22e341c88d5ef$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.581 11.991a.75.75 0 00-.38-.65l-3.252-1.832L23.2 7.67a.72.72 0 00.38-.681.75.75 0 00-.38-.65L11.813.092a.78.78 0 00-.74 0L.376 6.367a.76.76 0 00-.37.62.73.73 0 00.38.651L3.538 9.46.376 11.311a.74.74 0 00-.37.68.73.73 0 00.38.65l3.212 1.822-3.222 1.86a.75.75 0 000 1.302l11.007 6.254a.69.69 0 00.43.12.74.74 0 00.37-.1l11.008-6.254a.74.74 0 00.38-.66.75.75 0 00-.38-.651l-3.312-1.831 3.312-1.871a.73.73 0 00.39-.64zM11.483 1.614L21.3 6.988l-9.487 5.423-9.556-5.423 9.226-5.374zm9.817 15.38l-9.487 5.374-9.556-5.374 2.852-1.7 6.294 3.572a.69.69 0 00.41.13.74.74 0 00.37-.1l6.215-3.513 2.902 1.611zm-9.487.36l-9.556-5.363L5.05 10.36l6.354 3.602c.13.052.274.062.41.03a.74.74 0 00.37-.1l6.265-3.542 2.852 1.641-9.487 5.364z"
    })));
});
$ccc22e341c88d5ef$export$694e0d28c7ffc90c.displayName = 'Stack';





var $denZA = parcelRequire("denZA");
var $cb32efd6fb4f8f9c$var$__assign = undefined && undefined.__assign || function() {
    $cb32efd6fb4f8f9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cb32efd6fb4f8f9c$var$__assign.apply(this, arguments);
};
var $cb32efd6fb4f8f9c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cb32efd6fb4f8f9c$export$5e551eeb4f7ff8e7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $cb32efd6fb4f8f9c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $cb32efd6fb4f8f9c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1.337 7.074l10.63 6.01a.54.54 0 00.55 0l10.64-6.01a.551.551 0 000-1.002L12.217.071a.57.57 0 00-.551 0L1.356 6.082a.561.561 0 00-.02.992z"
    }), $denZA.createElement("path", {
        d: "M23.097 11.462l-2.144-1.182a.58.58 0 00-.571 0l-7.835 4.338a.601.601 0 01-.58 0l-7.765-4.459a.551.551 0 00-.581 0l-2.254 1.293a.59.59 0 000 1.002l10.57 6.01a.58.58 0 00.57 0l10.59-6.01a.582.582 0 000-.992z"
    }), $denZA.createElement("path", {
        d: "M23.007 16.912l-2.144-1.182a.611.611 0 00-.561 0l-7.845 4.348a.582.582 0 01-.57 0L4.081 15.61a.601.601 0 00-.581 0l-2.214 1.302a.58.58 0 000 1.002l10.57 6.011a.58.58 0 00.57 0l10.59-6.011a.58.58 0 00-.01-1.002z"
    })));
});
$cb32efd6fb4f8f9c$export$5e551eeb4f7ff8e7.displayName = 'StackBold';





var $denZA = parcelRequire("denZA");
var $b2ea9ceda536377f$var$__assign = undefined && undefined.__assign || function() {
    $b2ea9ceda536377f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2ea9ceda536377f$var$__assign.apply(this, arguments);
};
var $b2ea9ceda536377f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2ea9ceda536377f$export$1644ba17714857f1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $b2ea9ceda536377f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $b2ea9ceda536377f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.075 22.308L6.215 15 .477 10.14a1.31 1.31 0 01.82-2.32h6.996l2.49-6.96c.086-.25.25-.464.466-.619.217-.155.477-.24.743-.24s.526.085.742.24c.217.155.38.368.467.62l2.51 7.01h6.996a1.32 1.32 0 01.81 2.34l-5.898 4.839 2.29 7.19a1.29 1.29 0 01-.379 1.48 1.28 1.28 0 01-.753.28 1.285 1.285 0 01-.778-.21l-5.984-4.07-6.01 4.07a1.3 1.3 0 01-.754.21 1.294 1.294 0 01-.734-.27 1.288 1.288 0 01-.442-1.42zM2.185 9.46l5.139 4.34a1.59 1.59 0 01.47 1.56l-1.93 6.56 5.441-3.697a1.31 1.31 0 011.42 0l5.374 3.697-1.999-6.38a1.55 1.55 0 01.43-1.63l5.298-4.34H15.52a1.33 1.33 0 01-1.24-.89l-2.29-6.37-2.237 6.27a1.32 1.32 0 01-1.24.88H2.186z"
    })));
});
$b2ea9ceda536377f$export$1644ba17714857f1.displayName = 'Star';





var $denZA = parcelRequire("denZA");
var $79b218c3ac207ba4$var$__assign = undefined && undefined.__assign || function() {
    $79b218c3ac207ba4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $79b218c3ac207ba4$var$__assign.apply(this, arguments);
};
var $79b218c3ac207ba4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $79b218c3ac207ba4$export$cafc08b628953b29 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $79b218c3ac207ba4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $79b218c3ac207ba4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.075 22.308L6.215 15 .477 10.14a1.31 1.31 0 01.82-2.32h6.996l2.49-6.96c.086-.25.25-.464.466-.619.217-.155.477-.24.743-.24s.526.085.742.24c.217.155.38.368.467.62l2.51 7.01h6.996a1.32 1.32 0 01.81 2.34l-5.898 4.839 2.29 7.19a1.29 1.29 0 01-.379 1.48 1.28 1.28 0 01-.753.28 1.285 1.285 0 01-.778-.21l-5.984-4.07-6.01 4.07a1.3 1.3 0 01-.754.21 1.294 1.294 0 01-.734-.27 1.288 1.288 0 01-.442-1.42z"
    })));
});
$79b218c3ac207ba4$export$cafc08b628953b29.displayName = 'StarBold';





var $denZA = parcelRequire("denZA");
var $d051293c4daea501$var$__assign = undefined && undefined.__assign || function() {
    $d051293c4daea501$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d051293c4daea501$var$__assign.apply(this, arguments);
};
var $d051293c4daea501$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d051293c4daea501$export$6494e795a7a607ff = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d051293c4daea501$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d051293c4daea501$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.074 22.308L6.214 15 .476 10.14a1.31 1.31 0 01.82-2.32h6.996l2.49-6.96c.086-.25.25-.464.466-.619.217-.155.477-.24.743-.24s.526.085.742.24c.217.155.38.368.467.62l2.51 7.01h6.996a1.32 1.32 0 01.81 2.34l-5.897 4.839 2.289 7.19a1.289 1.289 0 01-.379 1.48 1.28 1.28 0 01-.753.28 1.285 1.285 0 01-.778-.21l-5.984-4.07-6.01 4.07a1.3 1.3 0 01-.754.21 1.294 1.294 0 01-.734-.27 1.288 1.288 0 01-.442-1.42zm7.94-4.295c.252 0 .498.073.71.21l5.374 3.696-1.999-6.38a1.55 1.55 0 01.43-1.63l5.298-4.34h-6.308a1.33 1.33 0 01-1.24-.89l-2.291-6.37c0 9.69.026 11.69.026 15.704z"
    })));
});
$d051293c4daea501$export$6494e795a7a607ff.displayName = 'StarHalf';





var $denZA = parcelRequire("denZA");
var $f7d88b3c2146cf60$var$__assign = undefined && undefined.__assign || function() {
    $f7d88b3c2146cf60$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f7d88b3c2146cf60$var$__assign.apply(this, arguments);
};
var $f7d88b3c2146cf60$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f7d88b3c2146cf60$export$4a37ae897f9e8014 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $f7d88b3c2146cf60$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f7d88b3c2146cf60$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.775 20.727L14.302 1.424C13.993.807 13.48.344 12.827.138a2.58 2.58 0 00-1.957.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.271 2.271 0 001.03 3.034c.309.154.652.24.995.24h19.477a2.262 2.262 0 002.265-2.263 2.035 2.035 0 00-.223-1.011zm-1.493 1.543a.794.794 0 01-.55.223H2.257a.79.79 0 01-.704-1.114L11.06 2.091c.103-.205.275-.377.48-.48.155-.068.31-.102.464-.102.395 0 .772.222.944.582l9.49 19.303a.781.781 0 01.085.343c-.017.206-.086.395-.24.532z"
    }), $denZA.createElement("path", {
        d: "M11.57 16.119h1.153l.252-8.118h-1.676l.27 8.118zm.576 3.96c.63 0 1.135-.468 1.135-1.134 0-.666-.504-1.134-1.135-1.134-.613 0-1.135.468-1.135 1.134 0 .666.523 1.134 1.135 1.134z"
    })));
});
$f7d88b3c2146cf60$export$4a37ae897f9e8014.displayName = 'StatusError';





var $denZA = parcelRequire("denZA");
var $9670145d9976863e$var$__assign = undefined && undefined.__assign || function() {
    $9670145d9976863e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9670145d9976863e$var$__assign.apply(this, arguments);
};
var $9670145d9976863e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9670145d9976863e$export$750f42de29e1826b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $9670145d9976863e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9670145d9976863e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.302 1.424l9.473 19.303c.154.308.24.651.223 1.011a2.262 2.262 0 01-2.265 2.263H2.256c-.343 0-.686-.086-.995-.24a2.271 2.271 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.87.258a2.58 2.58 0 011.957-.12c.652.206 1.166.669 1.475 1.286zM13.04 15.776h-2.05l-.484-7.775h2.998l-.465 7.775zm.726 2.995c0 .986-.745 1.73-1.713 1.73-1.024 0-1.75-.744-1.75-1.73 0-.967.726-1.73 1.75-1.73.968 0 1.713.763 1.713 1.73z",
        fillRule: "evenodd"
    })));
});
$9670145d9976863e$export$750f42de29e1826b.displayName = 'StatusErrorBold';





var $denZA = parcelRequire("denZA");
var $a30a7baef12eb221$var$__assign = undefined && undefined.__assign || function() {
    $a30a7baef12eb221$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a30a7baef12eb221$var$__assign.apply(this, arguments);
};
var $a30a7baef12eb221$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a30a7baef12eb221$export$e0c13b137c9285c0 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a30a7baef12eb221$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a30a7baef12eb221$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.825 14.11h-1.32a2.008 2.008 0 01-.198-.868c0-.986.73-1.676 1.577-2.425.986-.927 1.538-1.46 1.538-2.425 0-1.184-.867-1.992-1.932-1.992-1.005 0-1.814.631-2.208 1.893L9 7.761C9.513 6.006 10.794 5 12.53 5 14.442 5 16 6.36 16 8.293c0 1.321-.769 2.208-1.873 3.194-.868.79-1.4 1.282-1.4 1.992 0 .203.043.391.08.552l.018.079zm.69 3.096c0 .73-.571 1.242-1.261 1.242a1.237 1.237 0 01-1.243-1.242c0-.73.592-1.243 1.243-1.243.69 0 1.261.513 1.261 1.243z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm1.509 0c0 5.777 4.697 10.491 10.491 10.491S22.491 17.777 22.491 12c0-5.777-4.697-10.491-10.491-10.491S1.509 6.223 1.509 12z",
        fillRule: "evenodd"
    })));
});
$a30a7baef12eb221$export$e0c13b137c9285c0.displayName = 'StatusHelp';





var $denZA = parcelRequire("denZA");
var $aa0f05939319d824$var$__assign = undefined && undefined.__assign || function() {
    $aa0f05939319d824$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa0f05939319d824$var$__assign.apply(this, arguments);
};
var $aa0f05939319d824$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aa0f05939319d824$export$493d925eb43dfdfe = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $aa0f05939319d824$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $aa0f05939319d824$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12-5.383 12-12 12S0 18.617 0 12zm12.934 1.731h-2.315a2.457 2.457 0 01-.223-.975c0-.812.61-1.502 1.604-2.294.832-.69 1.198-1.056 1.198-1.706 0-.73-.569-1.238-1.28-1.238-.75 0-1.299.528-1.684 1.543L8 8.086C8.589 6.016 10.091 5 12 5c2.213 0 4 1.401 4 3.553 0 1.198-.569 1.99-1.685 2.965l-.218.189c-.7.608-1.204 1.044-1.204 1.598 0 .162.02.304.041.426zM13.746 17c0 1.076-.812 1.888-1.888 1.888-1.097 0-1.909-.812-1.909-1.888 0-1.056.812-1.888 1.909-1.888A1.86 1.86 0 0113.746 17z",
        fillRule: "evenodd"
    })));
});
$aa0f05939319d824$export$493d925eb43dfdfe.displayName = 'StatusHelpBold';





var $denZA = parcelRequire("denZA");
var $736627a50f72f0c4$var$__assign = undefined && undefined.__assign || function() {
    $736627a50f72f0c4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $736627a50f72f0c4$var$__assign.apply(this, arguments);
};
var $736627a50f72f0c4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $736627a50f72f0c4$export$390e0440e6f2b300 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $736627a50f72f0c4$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $736627a50f72f0c4$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.515 3.515a12 12 0 1116.97 16.97 12 12 0 01-16.97-16.97zM12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.044 7.016a1.01 1.01 0 001.026-1.008C13.07 5.45 12.602 5 12.044 5 11.468 5 11 5.45 11 6.008c0 .576.468 1.008 1.044 1.008zm-.702 11.106h1.386V9.356h-1.386v8.766z"
    })));
});
$736627a50f72f0c4$export$390e0440e6f2b300.displayName = 'StatusInformation';





var $denZA = parcelRequire("denZA");
var $7d70df2da146902d$var$__assign = undefined && undefined.__assign || function() {
    $7d70df2da146902d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d70df2da146902d$var$__assign.apply(this, arguments);
};
var $7d70df2da146902d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7d70df2da146902d$export$d8874184141c994a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7d70df2da146902d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7d70df2da146902d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 0a12 12 0 100 24 12 12 0 000-24zm1.57 6.008c0 .87-.71 1.508-1.526 1.508-.829 0-1.544-.633-1.544-1.508 0-.851.71-1.508 1.544-1.508.823 0 1.526.662 1.526 1.508zm-2.728 12.614V9.4h2.386v9.222h-2.386z",
        fillRule: "evenodd"
    })));
});
$7d70df2da146902d$export$d8874184141c994a.displayName = 'StatusInformationBold';





var $denZA = parcelRequire("denZA");
var $c062a91e4f97d076$var$__assign = undefined && undefined.__assign || function() {
    $c062a91e4f97d076$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c062a91e4f97d076$var$__assign.apply(this, arguments);
};
var $c062a91e4f97d076$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c062a91e4f97d076$export$785e45f1d8c03432 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $c062a91e4f97d076$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c062a91e4f97d076$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.53 8.531a.75.75 0 00-1.06-1.06L9 15.94l-3.47-3.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l9-9z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12zM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12z",
        fillRule: "evenodd"
    })));
});
$c062a91e4f97d076$export$785e45f1d8c03432.displayName = 'StatusSuccess';





var $denZA = parcelRequire("denZA");
var $5781f51d3324a667$var$__assign = undefined && undefined.__assign || function() {
    $5781f51d3324a667$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5781f51d3324a667$var$__assign.apply(this, arguments);
};
var $5781f51d3324a667$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5781f51d3324a667$export$17e1460061865da = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $5781f51d3324a667$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $5781f51d3324a667$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.94-2.94a1.5 1.5 0 00-2.12-2.12L9 14.878l-2.94-2.94a1.5 1.5 0 00-2.12 2.122l4 4a1.5 1.5 0 002.12 0l9-9z",
        fillRule: "evenodd"
    })));
});
$5781f51d3324a667$export$17e1460061865da.displayName = 'StatusSuccessBold';





var $denZA = parcelRequire("denZA");
var $fbd65944771dc7dc$var$__assign = undefined && undefined.__assign || function() {
    $fbd65944771dc7dc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fbd65944771dc7dc$var$__assign.apply(this, arguments);
};
var $fbd65944771dc7dc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fbd65944771dc7dc$export$a2518b5310db22ab = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $fbd65944771dc7dc$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fbd65944771dc7dc$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.775 20.727L14.302 1.424C13.993.807 13.48.344 12.827.138a2.58 2.58 0 00-1.957.12 2.56 2.56 0 00-1.166 1.166L.23 20.727a2.271 2.271 0 001.03 3.034c.309.154.652.24.995.24h19.477a2.262 2.262 0 002.265-2.263 2.035 2.035 0 00-.223-1.011zm-1.493 1.543a.794.794 0 01-.55.223H2.257a.79.79 0 01-.704-1.114L11.06 2.091c.103-.205.275-.377.48-.48.155-.068.31-.102.464-.102.395 0 .772.222.944.582l9.49 19.303a.781.781 0 01.085.343c-.017.206-.086.395-.24.532z"
    }), $denZA.createElement("path", {
        d: "M11.57 16.119h1.153l.252-8.118h-1.676l.27 8.118zm.576 3.96c.63 0 1.135-.468 1.135-1.134 0-.666-.504-1.134-1.135-1.134-.613 0-1.135.468-1.135 1.134 0 .666.523 1.134 1.135 1.134z"
    })));
});
$fbd65944771dc7dc$export$a2518b5310db22ab.displayName = 'StatusWarning';





var $denZA = parcelRequire("denZA");
var $2e0ba039f0839502$var$__assign = undefined && undefined.__assign || function() {
    $2e0ba039f0839502$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e0ba039f0839502$var$__assign.apply(this, arguments);
};
var $2e0ba039f0839502$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2e0ba039f0839502$export$f1b6053a528b50d9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $2e0ba039f0839502$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2e0ba039f0839502$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.302 1.424l9.473 19.303c.154.308.24.651.223 1.011a2.262 2.262 0 01-2.265 2.263H2.256c-.343 0-.686-.086-.995-.24a2.271 2.271 0 01-1.03-3.034L9.704 1.424A2.56 2.56 0 0110.87.258a2.58 2.58 0 011.957-.12c.652.206 1.166.669 1.475 1.286zM13.04 15.776h-2.05l-.484-7.775h2.998l-.465 7.775zm.726 2.995c0 .986-.745 1.73-1.713 1.73-1.024 0-1.75-.744-1.75-1.73 0-.967.726-1.73 1.75-1.73.968 0 1.713.763 1.713 1.73z",
        fillRule: "evenodd"
    })));
});
$2e0ba039f0839502$export$f1b6053a528b50d9.displayName = 'StatusWarningBold';





var $denZA = parcelRequire("denZA");
var $7a172c3403b43ec6$var$__assign = undefined && undefined.__assign || function() {
    $7a172c3403b43ec6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a172c3403b43ec6$var$__assign.apply(this, arguments);
};
var $7a172c3403b43ec6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a172c3403b43ec6$export$e16de4ea1abb52c8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7a172c3403b43ec6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7a172c3403b43ec6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.807 10.346a.75.75 0 00-1.114 1.006l3.75 4.15a.75.75 0 001.114-1.005l-3.75-4.15z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.751 9.751 0 015.18 1.981l.907-.908a.75.75 0 011.193-.882l.375.375.375.375a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    })));
});
$7a172c3403b43ec6$export$e16de4ea1abb52c8.displayName = 'Stopwatch';





var $denZA = parcelRequire("denZA");
var $81ca458135d52dfd$var$__assign = undefined && undefined.__assign || function() {
    $81ca458135d52dfd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81ca458135d52dfd$var$__assign.apply(this, arguments);
};
var $81ca458135d52dfd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $81ca458135d52dfd$export$da6e25dd6239a135 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $81ca458135d52dfd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $81ca458135d52dfd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M13.5 1.5h.75a.75.75 0 000-1.5h-4.5a.75.75 0 000 1.5h.75v3.116a9.75 9.75 0 108.901 3.287l1.32-1.319a.75.75 0 00.06-1.115l-.75-.75a.75.75 0 00-1.11.054l-1.424 1.424a9.755 9.755 0 00-3.997-1.58V1.5zM7.395 12.395l3.307 3.307c.484.484 1.351.402 1.937-.184.586-.586.668-1.453.184-1.938l-3.307-3.306c-.484-.484-1.351-.402-1.937.184-.586.586-.668 1.453-.184 1.937z",
        fillRule: "evenodd"
    })));
});
$81ca458135d52dfd$export$da6e25dd6239a135.displayName = 'StopwatchBold';





var $denZA = parcelRequire("denZA");
var $fbc37deeac474bd3$var$__assign = undefined && undefined.__assign || function() {
    $fbc37deeac474bd3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fbc37deeac474bd3$var$__assign.apply(this, arguments);
};
var $fbc37deeac474bd3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fbc37deeac474bd3$export$88a6666ae2487175 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fbc37deeac474bd3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fbc37deeac474bd3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.88.647a1.298 1.298 0 012.25 0l2.337 4.142a1.295 1.295 0 01-.448 1.824 1.3 1.3 0 01-.67.172h-1.6v9.72a9.732 9.732 0 014.867-3.502l-.73-1.747a1.306 1.306 0 011.39-1.786l4.596.648a1.301 1.301 0 011.03.79 1.296 1.296 0 01-.17 1.286l-2.788 3.703a1.3 1.3 0 01-2.249-.29l-.5-1.207c-3.587 1.297-5.356 3.553-5.446 7.275v1.597a.748.748 0 01-1.489.1v-1.388c0-3.892-1.758-6.237-5.446-7.564l-.5 1.217a1.307 1.307 0 01-1.711.703 1.31 1.31 0 01-.537-.413L.268 12.164a1.296 1.296 0 01.86-2.076l4.597-.648a1.31 1.31 0 011.467 1.125c.03.228 0 .46-.088.671l-.72 1.766a9.732 9.732 0 014.867 3.503v-9.74h-1.6a1.3 1.3 0 01-1.333-1.332c.007-.236.077-.465.205-.664L10.88.647zM14 5.268l-2-3.563-1.999 3.563H14zm-9.184 7.565l.78-1.826-3.928.548 2.339 3.134.81-1.856zm17.518-1.308l-3.928-.518.78 1.856.81 1.826 2.338-3.164z"
    })));
});
$fbc37deeac474bd3$export$88a6666ae2487175.displayName = 'Strategy';





var $denZA = parcelRequire("denZA");
var $c4281885d0adc6bf$var$__assign = undefined && undefined.__assign || function() {
    $c4281885d0adc6bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4281885d0adc6bf$var$__assign.apply(this, arguments);
};
var $c4281885d0adc6bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c4281885d0adc6bf$export$c058c71d1bbd656d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c4281885d0adc6bf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c4281885d0adc6bf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#strategy-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M12 24a1.25 1.25 0 001.25-1.25v-.42a10.314 10.314 0 015.713-9.254.252.252 0 01.343.128l.251.606a1 1 0 001.726.218l2.516-3.342a1 1 0 00-.66-1.591l-4.146-.583a1 1 0 00-1.061 1.372l.225.543a.25.25 0 01-.123.321 12.816 12.816 0 00-4.34 3.389.25.25 0 01-.444-.16V6.214a.249.249 0 01.25-.25h.807a1.042 1.042 0 00.9-1.572L12.9.477a1.087 1.087 0 00-1.8 0L8.796 4.392a1.043 1.043 0 00.9 1.572h.806a.249.249 0 01.25.25v7.763a.251.251 0 01-.443.16 12.816 12.816 0 00-4.34-3.389.25.25 0 01-.123-.32l.224-.544a1 1 0 00-1.062-1.372l-4.145.583a1 1 0 00-.66 1.592l2.52 3.343a1 1 0 001.725-.217l.251-.607a.251.251 0 01.344-.127 10.313 10.313 0 015.713 9.252v.421A1.25 1.25 0 0012 24z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "strategy-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$c4281885d0adc6bf$export$c058c71d1bbd656d.displayName = 'StrategyBold';





var $denZA = parcelRequire("denZA");
var $6f8e1ba7ab3a45a2$var$__assign = undefined && undefined.__assign || function() {
    $6f8e1ba7ab3a45a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f8e1ba7ab3a45a2$var$__assign.apply(this, arguments);
};
var $6f8e1ba7ab3a45a2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6f8e1ba7ab3a45a2$export$616b2c96b9b691e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6f8e1ba7ab3a45a2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6f8e1ba7ab3a45a2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 1.5a7.5 7.5 0 00-7.462 6.75A1.5 1.5 0 016 9.75v7.5a1.5 1.5 0 01-1.5 1.5h-.75A3.75 3.75 0 010 15v-3a3.75 3.75 0 013.026-3.68 9 9 0 0117.948 0A3.75 3.75 0 0124 12v3a3.75 3.75 0 01-3 3.674v.076a3.75 3.75 0 01-3.75 3.75h-1.629A2.25 2.25 0 0113.5 24H12a2.25 2.25 0 010-4.5h1.5a2.25 2.25 0 012.121 1.5h1.629a2.25 2.25 0 002.25-2.25 1.5 1.5 0 01-1.5-1.5v-7.5a1.5 1.5 0 011.462-1.5A7.5 7.5 0 0012 1.5zm2.03 19.72a.75.75 0 01-.53 1.28H12a.75.75 0 110-1.5h1.5a.75.75 0 01.53.22zm6.22-3.97A2.25 2.25 0 0022.5 15v-3a2.25 2.25 0 00-2.25-2.25h-.75v7.5h.75zM2.159 10.409A2.25 2.25 0 013.75 9.75h.75v7.5h-.75A2.25 2.25 0 011.5 15v-3c0-.597.237-1.169.659-1.591z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M9.505 14.888a.75.75 0 10-1.01 1.108 5.204 5.204 0 007.01 0 .75.75 0 00-1.01-1.108 3.704 3.704 0 01-4.99 0zM9 9.235a.75.75 0 01.75.75v1.312a.75.75 0 01-1.5 0V9.985a.75.75 0 01.75-.75zm6.75.75a.75.75 0 00-1.5 0v1.312a.75.75 0 001.5 0V9.985z"
    })));
});
$6f8e1ba7ab3a45a2$export$616b2c96b9b691e.displayName = 'SupportChat';





var $denZA = parcelRequire("denZA");
var $31ca76c8b3c16f2d$var$__assign = undefined && undefined.__assign || function() {
    $31ca76c8b3c16f2d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $31ca76c8b3c16f2d$var$__assign.apply(this, arguments);
};
var $31ca76c8b3c16f2d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $31ca76c8b3c16f2d$export$9c6a6487c263eb9c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $31ca76c8b3c16f2d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $31ca76c8b3c16f2d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.101.045a9.097 9.097 0 019.943 8.085A4.01 4.01 0 0124 12v2.905a4.01 4.01 0 01-2.912 3.857 4.01 4.01 0 01-4.004 3.785H15.76A2.558 2.558 0 0113.453 24H12a2.558 2.558 0 010-5.116h1.453a2.558 2.558 0 012.306 1.453h1.325a1.8 1.8 0 001.77-1.468 1.831 1.831 0 01-1.422-1.785V9.821a1.831 1.831 0 011.372-1.773 6.885 6.885 0 00-13.608 0A1.831 1.831 0 016.568 9.82v7.263a1.831 1.831 0 01-1.831 1.832H4.01A4.01 4.01 0 010 14.906V12a4.01 4.01 0 012.957-3.87A9.095 9.095 0 0111.1.045z"
    }), $denZA.createElement("path", {
        d: "M13.8 10.049a1.105 1.105 0 012.21 0v1.27a1.105 1.105 0 11-2.21 0v-1.27zm-5.522 4.54a1.105 1.105 0 011.561-.073 3.208 3.208 0 004.322 0 1.105 1.105 0 111.489 1.634 5.419 5.419 0 01-7.3 0 1.105 1.105 0 01-.072-1.561zm.817-5.646c-.61 0-1.106.495-1.106 1.106v1.27a1.105 1.105 0 002.211 0v-1.27c0-.61-.495-1.106-1.105-1.106z"
    })));
});
$31ca76c8b3c16f2d$export$9c6a6487c263eb9c.displayName = 'SupportChatBold';





var $denZA = parcelRequire("denZA");
var $d14af17bab38ff55$var$__assign = undefined && undefined.__assign || function() {
    $d14af17bab38ff55$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d14af17bab38ff55$var$__assign.apply(this, arguments);
};
var $d14af17bab38ff55$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d14af17bab38ff55$export$3288d34c523a1192 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $d14af17bab38ff55$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d14af17bab38ff55$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M17.84 3.85a2.31 2.31 0 110 4.619 2.31 2.31 0 010-4.62zm.295 1.598a.77.77 0 10-.59 1.424.77.77 0 00.59-1.424z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M21.69 0A2.31 2.31 0 0124 2.31v6.423c0 1.021-.405 2-1.127 2.722l-11.869 11.87a2.31 2.31 0 01-3.266 0L.676 16.262a2.31 2.31 0 010-3.267l11.87-11.868A3.85 3.85 0 0115.265 0h6.424zm.545 1.765a.77.77 0 00-.545-.225h-6.423c-.613 0-1.2.243-1.633.676L1.765 14.084a.77.77 0 000 1.089l7.062 7.063a.77.77 0 001.089 0l11.868-11.87a2.31 2.31 0 00.676-1.633V2.31a.77.77 0 00-.225-.545z",
        fillRule: "evenodd"
    })));
});
$d14af17bab38ff55$export$3288d34c523a1192.displayName = 'Tag';





var $denZA = parcelRequire("denZA");
var $0931334a743ee34e$var$__assign = undefined && undefined.__assign || function() {
    $0931334a743ee34e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0931334a743ee34e$var$__assign.apply(this, arguments);
};
var $0931334a743ee34e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0931334a743ee34e$export$eb1b14be98724170 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 25' : _b, rest = $0931334a743ee34e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0931334a743ee34e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.23.064A2.308 2.308 0 0021.69 0h-6.423a3.851 3.851 0 00-2.722 1.127L.676 12.995a2.31 2.31 0 000 3.267l7.062 7.063a2.31 2.31 0 003.266 0l11.87-11.87A3.85 3.85 0 0024 8.733V2.31A2.31 2.31 0 0022.23.064z"
    })));
});
$0931334a743ee34e$export$eb1b14be98724170.displayName = 'TagBold';





var $denZA = parcelRequire("denZA");
var $ab8b661cb2ba8334$var$__assign = undefined && undefined.__assign || function() {
    $ab8b661cb2ba8334$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ab8b661cb2ba8334$var$__assign.apply(this, arguments);
};
var $ab8b661cb2ba8334$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ab8b661cb2ba8334$export$a51f2b8e6ae258ea = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ab8b661cb2ba8334$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ab8b661cb2ba8334$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.824.61a.753.753 0 00-.52-.576.765.765 0 00-.757.181l-3.286 3.192a.747.747 0 00-.218.423l-.537 3.506-4.04 3.993a.744.744 0 000 1.06.765.765 0 001.074 0l4.039-3.992 3.547-.532a.762.762 0 00.427-.215l3.23-3.248a.744.744 0 00.182-.75.756.756 0 00-.581-.513l-2.149-.406-.411-2.124zm-3.701 6.188l.382-2.496L18.6 2.267l.241 1.248a.754.754 0 00.603.596l1.263.238-2.059 2.07-2.525.379z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.543 3.046a9.19 9.19 0 00-5.544 1.2A9.033 9.033 0 003.25 8.46a8.904 8.904 0 00-.494 5.59 8.984 8.984 0 003.86 5.468l.01.002.008.002a.755.755 0 01.405.255 9.187 9.187 0 009.424-.156 9.025 9.025 0 003.626-4.316 8.903 8.903 0 00.335-5.6.75.75 0 01.54-.917.76.76 0 01.927.534 10.39 10.39 0 01-.39 6.534 10.516 10.516 0 01-3.593 4.607l.659 2.605a.75.75 0 01-.552.91.76.76 0 01-.92-.546l-.54-2.134a10.726 10.726 0 01-9.62.125l-.508 2.009a.76.76 0 01-.92.545.75.75 0 01-.552-.91l.617-2.436a10.48 10.48 0 01-4.294-6.24 10.388 10.388 0 01.577-6.52 10.539 10.539 0 014.372-4.917 10.723 10.723 0 016.469-1.4c.416.042.72.41.678.822a.757.757 0 01-.832.67z"
    }), $denZA.createElement("path", {
        d: "M11.617 7.5a.754.754 0 00.758-.75c0-.415-.34-.75-.76-.75a6.119 6.119 0 00-3.523 1.117 6.007 6.007 0 00-2.213 2.931 5.935 5.935 0 00-.08 3.657 6 6 0 002.082 3.024 6.123 6.123 0 007.041.308 6.017 6.017 0 002.344-2.831 5.937 5.937 0 00.246-3.65.76.76 0 00-.92-.547.75.75 0 00-.553.909 4.446 4.446 0 01-.185 2.737 4.512 4.512 0 01-1.757 2.123 4.593 4.593 0 01-5.282-.231 4.5 4.5 0 01-1.561-2.268 4.452 4.452 0 01.06-2.743 4.506 4.506 0 011.66-2.198 4.59 4.59 0 012.643-.838z"
    })));
});
$ab8b661cb2ba8334$export$a51f2b8e6ae258ea.displayName = 'Target';





var $denZA = parcelRequire("denZA");
var $502e5d9edb7532ef$var$__assign = undefined && undefined.__assign || function() {
    $502e5d9edb7532ef$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $502e5d9edb7532ef$var$__assign.apply(this, arguments);
};
var $502e5d9edb7532ef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $502e5d9edb7532ef$export$789133e8ec70b6e2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $502e5d9edb7532ef$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $502e5d9edb7532ef$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.962 3.811a.5.5 0 00-.462-.308h-2.75a.249.249 0 01-.25-.25V.5a.5.5 0 00-.853-.354l-2.414 2.416a2.487 2.487 0 00-.733 1.77v1.685a.25.25 0 01-.117.212.488.488 0 00-.09.069l-5 5.004a1.001 1.001 0 101.414 1.415l5-5.004a.46.46 0 00.07-.09.253.253 0 01.212-.117h1.683c.664.002 1.3-.262 1.768-.734l2.414-2.416a.5.5 0 00.108-.545z"
    }), $denZA.createElement("path", {
        d: "M11 8.006a1 1 0 000-2.001c-3.313 0-6 2.688-6 6.005a6.002 6.002 0 006 6.005c3.314 0 6-2.689 6-6.005a1 1 0 10-2 0 4.002 4.002 0 01-4 4.003c-2.209 0-4-1.792-4-4.003a4.002 4.002 0 014-4.004z"
    }), $denZA.createElement("path", {
        d: "M21 12.01a1 1 0 10-2 0c0 4.422-3.582 8.006-8 8.006s-8-3.584-8-8.006c0-4.422 3.582-8.007 8-8.007a1 1 0 000-2.001 9.99 9.99 0 00-9.214 6.11A10.006 10.006 0 003.84 18.984a.25.25 0 01.01.338l-2.608 3.047A1.001 1.001 0 002.76 23.67l2.662-3.107a.249.249 0 01.32-.05 9.932 9.932 0 0010.514 0 .25.25 0 01.322.05l2.662 3.107a1 1 0 001.519-1.3l-2.609-3.05a.25.25 0 01.01-.337A9.974 9.974 0 0021 12.01z"
    })));
});
$502e5d9edb7532ef$export$789133e8ec70b6e2.displayName = 'TargetBold';





var $denZA = parcelRequire("denZA");
var $35cc490b4f378661$var$__assign = undefined && undefined.__assign || function() {
    $35cc490b4f378661$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35cc490b4f378661$var$__assign.apply(this, arguments);
};
var $35cc490b4f378661$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $35cc490b4f378661$export$290b33259d59609 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $35cc490b4f378661$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $35cc490b4f378661$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.543 4.262l1.714-1.713v4.18a.76.76 0 00.754.754.76.76 0 00.754-.754V2.531l1.713 1.714a.74.74 0 00.531.223.755.755 0 00.531-1.285L12.542.2h-.017a.452.452 0 00-.103-.085c-.017-.017-.034-.017-.052-.035a.13.13 0 00-.068-.034C12.285.03 12.251.03 12.233.03c-.017 0-.034-.017-.068-.017a.832.832 0 00-.291 0c-.018 0-.035.017-.069.017s-.051.017-.086.017c-.017.017-.051.017-.068.034-.017.018-.034.018-.069.035A.452.452 0 0011.48.2h-.018l-2.98 3a.755.755 0 000 1.062.755.755 0 001.061 0zM5.106 17.815l-3.598 3.598V20.23a.76.76 0 00-.754-.754.76.76 0 00-.754.754v2.998c0 .051 0 .103.017.154 0 .017.017.035.017.069s.017.051.017.085c.018.018.018.052.035.069.017.017.017.034.034.068a.416.416 0 00.086.103v.017h.017a.455.455 0 00.103.086c.017.017.034.017.068.034.017.017.051.017.069.035.017.017.051.017.085.017.017 0 .035.017.069.017C.668 24 .72 24 .77 24h2.998a.76.76 0 00.754-.754.76.76 0 00-.754-.754H2.587l3.598-3.598a.755.755 0 000-1.062.76.76 0 00-1.08-.017z"
    }), $denZA.createElement("path", {
        d: "M16.277 19.7l-3.53 1.593V13.96l6.751-3.067v4.831a.76.76 0 00.754.754.76.76 0 00.754-.754V9.728c0-.035 0-.069-.017-.12v-.035a.23.23 0 00-.035-.102v-.017c-.017-.035-.034-.069-.05-.12 0-.018-.018-.018-.018-.035a.374.374 0 00-.069-.085v-.018c-.034-.034-.068-.05-.085-.085-.017 0-.017-.017-.034-.017l-.018-.017c-.034-.018-.051-.035-.085-.052l-5.277-2.364a.753.753 0 00-.994.377.753.753 0 00.377.993l3.752 1.697-6.442 2.912-6.443-2.912L9.321 8.03a.752.752 0 00-.617-1.37L3.46 9.042a.374.374 0 00-.086.052l-.017.017c-.017 0-.017.017-.034.017-.034.034-.069.051-.103.086a.358.358 0 00-.068.102c0 .018-.018.018-.018.035a.835.835 0 00-.05.12v.017c-.018.034-.018.068-.035.103v.034c0 .034-.017.068-.017.12v5.997a.76.76 0 00.754.753.76.76 0 00.753-.753v-4.85l6.751 3.068v7.35l-3.51-1.593a.753.753 0 00-.994.377.753.753 0 00.377.993l4.575 2.09c.051.018.085.035.137.052h.034a.38.38 0 00.137.017c.051 0 .086 0 .137-.017h.034c.052-.017.086-.017.137-.051l4.575-2.074a.753.753 0 00.377-.993c-.206-.412-.651-.583-1.028-.412z"
    }), $denZA.createElement("path", {
        d: "M23.901 23.572a.13.13 0 00.035-.069c.017-.017.017-.051.017-.068 0-.017.017-.052.017-.069a.376.376 0 00.017-.137v-2.998a.76.76 0 00-.754-.754.76.76 0 00-.754.754v1.182l-3.598-3.598a.755.755 0 00-1.062 0 .755.755 0 000 1.062l3.598 3.598h-1.182a.76.76 0 00-.754.754.76.76 0 00.754.754h2.998c.052 0 .103 0 .154-.017.018 0 .035-.017.069-.017s.051-.018.086-.018c.017-.017.051-.017.068-.034.017-.017.035-.017.069-.034s.068-.052.103-.086h.017v-.017a.453.453 0 00.085-.103c0-.051.017-.068.017-.085z"
    })));
});
$35cc490b4f378661$export$290b33259d59609.displayName = 'ThreedPrinting';





var $denZA = parcelRequire("denZA");
var $499bdb91c3fecde6$var$__assign = undefined && undefined.__assign || function() {
    $499bdb91c3fecde6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $499bdb91c3fecde6$var$__assign.apply(this, arguments);
};
var $499bdb91c3fecde6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $499bdb91c3fecde6$export$75745cda8b35a66 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $499bdb91c3fecde6$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $499bdb91c3fecde6$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10 3.312h.75a.25.25 0 01.25.25v1a1 1 0 102 0v-1a.25.25 0 01.25-.25H14a.75.75 0 00.473-1.332l-2-1.625a.752.752 0 00-.946 0l-2 1.625A.75.75 0 0010 3.312z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M15.04 16.531a2 2 0 00.546 1.945l1.154 1.155a.25.25 0 01-.076.406L12.2 21.99a.5.5 0 01-.4 0l-4.47-1.947a.251.251 0 01-.077-.406l1.161-1.161a2 2 0 10-2.828-2.828l-.659.659a.25.25 0 01-.427-.176v-5.975a.75.75 0 01.449-.687L11.7 6.516a.75.75 0 01.6 0l6.751 2.953c.273.12.449.39.449.687v5.975a.25.25 0 01-.427.176l-.659-.659a2 2 0 00-3.373.883zm1.465-6.375a.25.25 0 00-.15-.229L12.1 8.066a.249.249 0 00-.2 0L7.645 9.927a.25.25 0 000 .458l4.255 1.862a.257.257 0 00.2 0l4.255-1.862a.25.25 0 00.15-.229z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M7.707 17.769a1 1 0 10-1.414-1.414L2.5 20.148a.25.25 0 01-.354 0l-.616-.616a.75.75 0 00-1.28.53v3c0 .414.336.75.75.75h3a.75.75 0 00.53-1.28l-.616-.616a.25.25 0 010-.354l3.793-3.793zm16.043 5.293v-3a.75.75 0 00-1.28-.53l-.616.616a.25.25 0 01-.354 0l-3.793-3.793a1 1 0 10-1.414 1.414l3.793 3.793a.25.25 0 010 .354l-.616.616a.75.75 0 00.53 1.28h3a.75.75 0 00.75-.75z"
    })));
});
$499bdb91c3fecde6$export$75745cda8b35a66.displayName = 'ThreedPrintingBold';





var $denZA = parcelRequire("denZA");
var $350e2b5c52408036$var$__assign = undefined && undefined.__assign || function() {
    $350e2b5c52408036$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $350e2b5c52408036$var$__assign.apply(this, arguments);
};
var $350e2b5c52408036$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $350e2b5c52408036$export$680ea196effce5f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $350e2b5c52408036$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $350e2b5c52408036$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12 7.5a.75.75 0 01.75.75v3.44l4.467 4.468a.75.75 0 01-1.06 1.06L11.47 12.53a.748.748 0 01-.22-.53V8.25A.75.75 0 0112 7.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M4.045 4.045a11.25 11.25 0 1115.91 15.91 11.25 11.25 0 01-15.91-15.91zM12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z",
        fillRule: "evenodd"
    })));
});
$350e2b5c52408036$export$680ea196effce5f.displayName = 'Time';





var $denZA = parcelRequire("denZA");
var $fa7c1e098f2e8d11$var$__assign = undefined && undefined.__assign || function() {
    $fa7c1e098f2e8d11$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa7c1e098f2e8d11$var$__assign.apply(this, arguments);
};
var $fa7c1e098f2e8d11$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fa7c1e098f2e8d11$export$cef7b1bbd85670df = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fa7c1e098f2e8d11$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fa7c1e098f2e8d11$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 .75a11.25 11.25 0 100 22.5 11.25 11.25 0 000-22.5zM13.5 8a1.5 1.5 0 00-3 0v4.621l4.94 4.94a1.5 1.5 0 002.12-2.122l-4.06-4.06V8z",
        fillRule: "evenodd"
    })));
});
$fa7c1e098f2e8d11$export$cef7b1bbd85670df.displayName = 'TimeBold';





var $denZA = parcelRequire("denZA");
var $c0a913abd24fb0ba$var$__assign = undefined && undefined.__assign || function() {
    $c0a913abd24fb0ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0a913abd24fb0ba$var$__assign.apply(this, arguments);
};
var $c0a913abd24fb0ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c0a913abd24fb0ba$export$3b24868212bc81a8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c0a913abd24fb0ba$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c0a913abd24fb0ba$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("mask", {
        id: "time-exceeded_svg__a"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.75 9.75 0 015.179 1.981l.908-.908a.75.75 0 011.193-.882l.75.75a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 110-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 8.6c.552 0 1 .492 1 1.1v5.5c0 .607-.448 1.1-1 1.1s-1-.493-1-1.1V9.7c0-.608.448-1.1 1-1.1z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M13.15 18.5a1.15 1.15 0 11-2.3 0 1.15 1.15 0 012.3 0z"
    })), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-1.5v3.029a9.75 9.75 0 015.179 1.981l.908-.908a.75.75 0 011.193-.882l.75.75a.75.75 0 01-.882 1.193l-.85.85a9.75 9.75 0 11-7.798-2.984V1.5h-1.5a.75.75 0 110-1.5h4.5a.75.75 0 010 1.5zM12 6a8.25 8.25 0 100 16.5A8.25 8.25 0 0012 6z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12 8.6c.552 0 1 .492 1 1.1v5.5c0 .607-.448 1.1-1 1.1s-1-.493-1-1.1V9.7c0-.608.448-1.1 1-1.1z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M13.15 18.5a1.15 1.15 0 11-2.3 0 1.15 1.15 0 012.3 0z"
    }), $denZA.createElement("path", {
        d: "M12.75 1.5v-1a1 1 0 00-1 1h1zm0 3.029h-1a1 1 0 00.923.997l.077-.997zm2.98.713l-.382.924.383-.924zm2.2 1.268l-.608.794a1 1 0 001.315-.087l-.707-.707zm.908-.908l.707.707a1 1 0 00.176-1.176l-.883.469zm.132-.882l.707.707-.707-.707zm1.061 0l-.707.707.707-.707zm.75.75l-.707.707.707-.707zm0 1.06l-.707-.707.707.707zm-.882.133l.47-.883a1 1 0 00-1.177.175l.707.708zm-.85.85l-.707-.707a1 1 0 00-.016 1.398l.723-.691zm1.96 3.006l-.924.383.924-.383zm0 7.462l-.924-.383.924.383zm-2.114 3.163l.707.707-.707-.707zm-3.163 2.114l-.383-.924.383.924zm-7.462 0l-.383.924.383-.924zm-3.164-2.114l-.707.707.707-.707zm-2.113-3.163l.924-.383-.924.383zm0-7.462l.924.383-.924-.383zm2.113-3.163l.708.707-.708-.707zM8.27 5.242l-.383-.924.383.924zm2.98-.713l.078.997a1 1 0 00.923-.997h-1zm0-3.029h1a1 1 0 00-1-1v1zM8.844 6.628l-.383-.924.383.924zm-4.465 4.465l-.924-.383.924.383zm1.788 8.99l.707-.706-.707.707zm2.677 1.789l.382-.924-.382.924zm6.314 0l-.383-.924.383.924zm2.676-1.788l-.707-.707.707.707zm1.789-2.677l-.924-.383.924.383zm0-6.314l-.924.383.924-.383zm-1.789-2.677l-.707.707.707-.707zM12.75 2.5h1.5v-2h-1.5v2zm1 2.029V1.5h-2v3.029h2zm2.364-.21a10.75 10.75 0 00-3.287-.787l-.154 1.994a8.75 8.75 0 012.675.64l.766-1.848zm2.423 1.397a10.749 10.749 0 00-2.423-1.398l-.766 1.848a8.75 8.75 0 011.973 1.138l1.216-1.588zm-.407-.821l-.908.908 1.414 1.414.908-.908-1.414-1.414zm.132-.882a1.75 1.75 0 00-.308 2.058l1.766-.938a.25.25 0 01-.043.294l-1.415-1.414zm2.475 0a1.75 1.75 0 00-2.475 0l1.415 1.414a.25.25 0 01-.354 0l1.414-1.414zm.75 3.224a1.75 1.75 0 000-2.474l-1.414 1.414a.25.25 0 010-.354l1.414 1.414zm-2.058.309c.66.35 1.5.25 2.058-.309l-1.414-1.414a.25.25 0 01.294-.043l-.939 1.766zm.326.674l.85-.85-1.414-1.415-.85.85 1.414 1.415zm2.177 1.916a10.751 10.751 0 00-2.162-3.314l-1.445 1.382a8.752 8.752 0 011.759 2.697l1.848-.765zm.818 4.114c0-1.412-.278-2.81-.819-4.114l-1.847.766a8.75 8.75 0 01.666 3.348h2zm-.819 4.114a10.75 10.75 0 00.819-4.114h-2a8.75 8.75 0 01-.666 3.349l1.848.765zm-2.33 3.487a10.75 10.75 0 002.33-3.487l-1.847-.765a8.748 8.748 0 01-1.897 2.838l1.414 1.414zm-3.487 2.33a10.75 10.75 0 003.487-2.33l-1.414-1.414a8.75 8.75 0 01-2.839 1.897l.766 1.848zM12 25c1.412 0 2.81-.278 4.114-.818l-.766-1.848c-1.061.44-2.2.666-3.348.666v2zm-4.114-.818A10.75 10.75 0 0012 25v-2a8.749 8.749 0 01-3.349-.666l-.765 1.848zm-3.488-2.33a10.75 10.75 0 003.488 2.33l.765-1.848a8.75 8.75 0 01-2.838-1.897l-1.415 1.414zm-2.33-3.488a10.75 10.75 0 002.33 3.487l1.415-1.414A8.75 8.75 0 013.916 17.6l-1.848.765zM1.25 14.25c0 1.412.278 2.81.818 4.114l1.848-.765a8.75 8.75 0 01-.666-3.349h-2zm.818-4.114a10.75 10.75 0 00-.818 4.114h2c0-1.15.226-2.287.666-3.348l-1.848-.766zm2.33-3.487a10.75 10.75 0 00-2.33 3.487l1.848.766a8.75 8.75 0 011.897-2.84L4.398 6.65zm3.488-2.33a10.75 10.75 0 00-3.488 2.33l1.415 1.414A8.75 8.75 0 018.65 6.166l-.765-1.848zm3.287-.787a10.75 10.75 0 00-3.287.786l.765 1.848a8.75 8.75 0 012.676-.64l-.154-1.994zM10.25 1.5v3.029h2V1.5h-2zm-.5 1h1.5v-2h-1.5v2zM8 .75c0 .966.783 1.75 1.75 1.75v-2a.25.25 0 01.25.25H8zM9.75-1A1.75 1.75 0 008 .75h2a.25.25 0 01-.25.25v-2zM16 .75A1.75 1.75 0 0014.25-1v2A.25.25 0 0114 .75h2zM14.25 2.5A1.75 1.75 0 0016 .75h-2a.25.25 0 01.25-.25v2zM9.225 7.552A7.25 7.25 0 0112 7V5a9.25 9.25 0 00-3.54.704l.765 1.848zM6.873 9.123a7.25 7.25 0 012.352-1.571L8.46 5.704A9.25 9.25 0 005.459 7.71l1.414 1.414zm-1.571 2.353a7.25 7.25 0 011.571-2.353L5.46 7.71a9.25 9.25 0 00-2.005 3.001l1.848.765zM4.75 14.25c0-.952.187-1.895.552-2.774l-1.848-.766a9.25 9.25 0 00-.704 3.54h2zm.552 2.774a7.25 7.25 0 01-.552-2.774h-2c0 1.215.239 2.418.704 3.54l1.848-.765zm1.571 2.352a7.25 7.25 0 01-1.571-2.352l-1.848.766a9.25 9.25 0 002.005 3l1.414-1.413zm2.352 1.572a7.248 7.248 0 01-2.352-1.572L5.46 20.791a9.25 9.25 0 003 2.005l.766-1.848zM12 21.5a7.25 7.25 0 01-2.775-.552l-.765 1.848A9.251 9.251 0 0012 23.5v-2zm2.774-.552A7.249 7.249 0 0112 21.5v2c1.214 0 2.417-.24 3.54-.704l-.766-1.848zm2.352-1.572a7.248 7.248 0 01-2.352 1.572l.766 1.848a9.25 9.25 0 003-2.005l-1.414-1.415zm1.572-2.352a7.25 7.25 0 01-1.572 2.352l1.415 1.415a9.249 9.249 0 002.005-3.001l-1.848-.765zm.552-2.774c0 .952-.188 1.895-.552 2.774l1.848.766a9.249 9.249 0 00.704-3.54h-2zm-.552-2.774c.364.88.552 1.822.552 2.774h2c0-1.215-.24-2.418-.704-3.54l-1.848.765zm-1.572-2.353a7.251 7.251 0 011.572 2.353l1.848-.766a9.25 9.25 0 00-2.005-3l-1.415 1.413zm-2.352-1.571a7.25 7.25 0 012.352 1.571l1.415-1.414a9.25 9.25 0 00-3.001-2.005l-.766 1.848zM12 7a7.25 7.25 0 012.774.552l.766-1.848A9.25 9.25 0 0012 5v2zm2.25-8h-4.5v2h4.5v-2zm7.237 5.763l-.75-.75-1.414 1.414.75.75 1.414-1.414zM14 9.7c0-1.068-.808-2.1-2-2.1v2a.08.08 0 01-.033-.007c-.007-.003-.006-.004 0 .002A.158.158 0 0112 9.7h2zm0 5.5V9.7h-2v5.5h2zm-2 2.1c1.192 0 2-1.032 2-2.1h-2a.156.156 0 01-.033.105c-.006.006-.007.005 0 .002A.08.08 0 0112 15.3v2zm-2-2.1c0 1.068.808 2.1 2 2.1v-2a.08.08 0 01.033.007c.006.003.005.004 0-.002A.158.158 0 0112 15.2h-2zm0-5.5v5.5h2V9.7h-2zm2-2.1c-1.192 0-2 1.032-2 2.1h2c0-.058.02-.092.033-.105.005-.006.006-.005 0-.002A.08.08 0 0112 9.6v-2zm.15 10.9a.15.15 0 01-.15.15v2a2.15 2.15 0 002.15-2.15h-2zm-.15.15a.15.15 0 01-.15-.15h-2A2.15 2.15 0 0012 20.65v-2zm-.15-.15a.15.15 0 01.15-.15v-2a2.15 2.15 0 00-2.15 2.15h2zm.15-.15a.15.15 0 01.15.15h2A2.15 2.15 0 0012 16.35v2z",
        mask: "url(#time-exceeded_svg__a)"
    })));
});
$c0a913abd24fb0ba$export$3b24868212bc81a8.displayName = 'TimeExceeded';





var $denZA = parcelRequire("denZA");
var $784e115ca41f369f$var$__assign = undefined && undefined.__assign || function() {
    $784e115ca41f369f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $784e115ca41f369f$var$__assign.apply(this, arguments);
};
var $784e115ca41f369f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $784e115ca41f369f$export$38f2b84b96e43b6c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $784e115ca41f369f$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $784e115ca41f369f$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M14.25 1.5h-.75v3.116a9.751 9.751 0 013.997 1.581l1.425-1.424a.75.75 0 011.109-.053l.75.75a.75.75 0 01-.06 1.114l-1.32 1.32A9.75 9.75 0 1110.5 4.615V1.5h-.75a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5zM12 8.15c.746 0 1.35.604 1.35 1.35v5.45a1.35 1.35 0 11-2.7 0V9.5c0-.746.604-1.35 1.35-1.35zm0 12.3a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fillRule: "evenodd"
    })));
});
$784e115ca41f369f$export$38f2b84b96e43b6c.displayName = 'TimeExceededBold';





var $denZA = parcelRequire("denZA");
var $fc1538388f8b0195$var$__assign = undefined && undefined.__assign || function() {
    $fc1538388f8b0195$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc1538388f8b0195$var$__assign.apply(this, arguments);
};
var $fc1538388f8b0195$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fc1538388f8b0195$export$cec4f96e18e205ef = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $fc1538388f8b0195$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $fc1538388f8b0195$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M4.28 6.53a.75.75 0 00-1.06-1.06l-3 3-.003.002A.748.748 0 00.22 9.53l3 3a.75.75 0 001.06-1.06L2.56 9.75H13.5a.75.75 0 000-1.5H2.56l1.72-1.72zm16.5 4.94a.75.75 0 10-1.06 1.06l1.72 1.72H10.5a.75.75 0 000 1.5h10.94l-1.72 1.72a.75.75 0 101.06 1.06l3-3A.746.746 0 0024 15v-.008a.748.748 0 00-.22-.522l-3-3z"
    })));
});
$fc1538388f8b0195$export$cec4f96e18e205ef.displayName = 'Transfer';





var $denZA = parcelRequire("denZA");
var $599fa763055ccfe9$var$__assign = undefined && undefined.__assign || function() {
    $599fa763055ccfe9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $599fa763055ccfe9$var$__assign.apply(this, arguments);
};
var $599fa763055ccfe9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $599fa763055ccfe9$export$ba106f444239d633 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $599fa763055ccfe9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $599fa763055ccfe9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6 10.153c.553 0 1-.468 1-1.044V7.804c0-.145.112-.261.25-.261h10.108c.828 0 1.5-.702 1.5-1.567s-.672-1.566-1.5-1.566H7.25A.256.256 0 017 4.15V2.843c0-.376-.194-.723-.507-.909a.964.964 0 00-1.008.014l-5 3.133A1.054 1.054 0 000 5.977c0 .367.184.707.485.895l5 3.133a.968.968 0 00.515.148zm17.515 6.975l-5-3.133a.963.963 0 00-1.008-.013 1.053 1.053 0 00-.507.91v1.304a.256.256 0 01-.25.261H6.642c-.828 0-1.5.702-1.5 1.567s.672 1.566 1.5 1.566H16.75c.066 0 .13.027.177.076a.27.27 0 01.073.185v1.305c0 .376.194.724.507.909a.963.963 0 001.008-.014l5-3.132c.3-.19.485-.53.485-.896 0-.367-.184-.706-.485-.895z"
    })));
});
$599fa763055ccfe9$export$ba106f444239d633.displayName = 'TransferBold';





var $denZA = parcelRequire("denZA");
var $f583f9582b2cdc85$var$__assign = undefined && undefined.__assign || function() {
    $f583f9582b2cdc85$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f583f9582b2cdc85$var$__assign.apply(this, arguments);
};
var $f583f9582b2cdc85$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f583f9582b2cdc85$export$a818bbe058f189e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $f583f9582b2cdc85$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $f583f9582b2cdc85$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M15 14.25a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M3.818 3.818A4.5 4.5 0 0111.5 7v2H6.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75H13V7A6 6 0 101 7v2.25a.75.75 0 001.5 0V7a4.5 4.5 0 011.318-3.182zM22.5 10.5h-15v12h15v-12z",
        fillRule: "evenodd"
    })));
});
$f583f9582b2cdc85$export$a818bbe058f189e.displayName = 'Unlock';





var $denZA = parcelRequire("denZA");
var $7382787b023d78f3$var$__assign = undefined && undefined.__assign || function() {
    $7382787b023d78f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7382787b023d78f3$var$__assign.apply(this, arguments);
};
var $7382787b023d78f3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7382787b023d78f3$export$cc1b5dff9a340610 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7382787b023d78f3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7382787b023d78f3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.177 2.487A6.375 6.375 0 0113.06 6.995v2h9.875a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75h-16.5a.75.75 0 01-.75-.75v-13.5a.75.75 0 01.75-.75h4.375v-2a4.125 4.125 0 10-8.25 0v2.25a1.125 1.125 0 01-2.25 0v-2.25a6.38 6.38 0 011.867-4.508zM14.685 13.87c-.621 0-1.125.504-1.125 1.125v3a1.125 1.125 0 102.25 0v-3c0-.621-.504-1.125-1.125-1.125z",
        fillRule: "evenodd"
    })));
});
$7382787b023d78f3$export$cc1b5dff9a340610.displayName = 'UnlockBold';





var $denZA = parcelRequire("denZA");
var $8b61c9734384db3c$var$__assign = undefined && undefined.__assign || function() {
    $8b61c9734384db3c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8b61c9734384db3c$var$__assign.apply(this, arguments);
};
var $8b61c9734384db3c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8b61c9734384db3c$export$c58532f0fb5faa97 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8b61c9734384db3c$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8b61c9734384db3c$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M12.52 3.21a.748.748 0 00-1.05.01l-4.5 4.5a.75.75 0 001.06 1.06l3.22-3.22v10.19a.75.75 0 001.5 0V5.56l3.22 3.22a.75.75 0 101.06-1.06l-4.5-4.5a1.298 1.298 0 00-.01-.01z"
    }), $denZA.createElement("path", {
        d: "M1.5 15.75a.75.75 0 00-1.5 0v1.5A3.75 3.75 0 003.75 21h16.5A3.75 3.75 0 0024 17.25v-1.5a.75.75 0 00-1.5 0v1.5a2.25 2.25 0 01-2.25 2.25H3.75a2.25 2.25 0 01-2.25-2.25v-1.5z"
    })));
});
$8b61c9734384db3c$export$c58532f0fb5faa97.displayName = 'Upload';





var $denZA = parcelRequire("denZA");
var $d4c571f5c7a42e30$var$__assign = undefined && undefined.__assign || function() {
    $d4c571f5c7a42e30$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d4c571f5c7a42e30$var$__assign.apply(this, arguments);
};
var $d4c571f5c7a42e30$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d4c571f5c7a42e30$export$ac013cbb07455357 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d4c571f5c7a42e30$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d4c571f5c7a42e30$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M.1 19.834c.003 2.3 1.793 4.164 4.002 4.166h15.796c2.21-.002 4-1.866 4.002-4.166V17.9a1.277 1.277 0 00-.597-1.125 1.174 1.174 0 00-1.235 0c-.38.234-.61.665-.597 1.125v1.935c-.001.904-.704 1.636-1.573 1.638H4.102c-.868-.002-1.572-.734-1.573-1.638V17.9a1.277 1.277 0 00-.597-1.125 1.174 1.174 0 00-1.235 0c-.38.234-.609.665-.596 1.125v1.935z"
    }), $denZA.createElement("path", {
        d: "M12 19.557c1.073 0 1.943-.905 1.943-2.022v-9.46c0-.143.11-.258.248-.258h2.668a.97.97 0 00.884-.592c.158-.36.099-.784-.151-1.083l-4.86-5.81A.984.984 0 0012 0a.984.984 0 00-.733.331L6.408 6.147c-.247.3-.305.72-.147 1.08a.97.97 0 00.88.59H9.81c.137 0 .247.116.247.259v9.459c0 1.117.87 2.022 1.943 2.022z"
    })));
});
$d4c571f5c7a42e30$export$ac013cbb07455357.displayName = 'UploadBold';





var $denZA = parcelRequire("denZA");
var $e60c1029106950c3$var$__assign = undefined && undefined.__assign || function() {
    $e60c1029106950c3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e60c1029106950c3$var$__assign.apply(this, arguments);
};
var $e60c1029106950c3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e60c1029106950c3$export$1f42c19cf267f1bb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e60c1029106950c3$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e60c1029106950c3$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M17.331.048a.75.75 0 00-.527 1.404l1.487.558L3.87 8.558a.75.75 0 00.621 1.366l14.42-6.548-.558 1.487a.75.75 0 001.404.527l1.194-3.182.002-.006a.747.747 0 00-.443-.961L17.33.048z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M18 9a1.5 1.5 0 00-1.5 1.5v12H15v-9a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 13.5v9H7.5V18A1.5 1.5 0 006 16.5H3A1.5 1.5 0 001.5 18v4.5H.75a.75.75 0 000 1.5h22.5a.75.75 0 000-1.5h-.75v-12A1.5 1.5 0 0021 9h-3zm3 1.5h-3v12h3v-12zm-10.5 3h3v9h-3v-9zm-4.5 9V18H3v4.5h3z",
        fillRule: "evenodd"
    })));
});
$e60c1029106950c3$export$1f42c19cf267f1bb.displayName = 'UpwardTrend';





var $denZA = parcelRequire("denZA");
var $6196172cf87b1f2b$var$__assign = undefined && undefined.__assign || function() {
    $6196172cf87b1f2b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6196172cf87b1f2b$var$__assign.apply(this, arguments);
};
var $6196172cf87b1f2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6196172cf87b1f2b$export$a9d005d0b7785e76 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6196172cf87b1f2b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6196172cf87b1f2b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M2 17.864a1 1 0 00-1 1v1.5a.25.25 0 00.25.25h3.5a.249.249 0 00.25-.25v-1.5a1 1 0 00-1-1H2zm6-3a1 1 0 00-1 1v4.5a.25.25 0 00.25.25h3.5a.25.25 0 00.25-.25v-4.5a1 1 0 00-1-1H8zm6-3.5a1 1 0 00-1 1v8a.25.25 0 00.25.25h3.5a.25.25 0 00.25-.25v-8a1 1 0 00-1-1h-2zm5.25 9.25h3.5a.25.25 0 00.25-.25v-12a1 1 0 00-1-1h-2a1 1 0 00-1 1v12a.25.25 0 00.25.25zM18.069 4.206l.307.46c.14.209.373.333.624.333h.025a.75.75 0 00.626-.377l2-3.5a.751.751 0 00-.744-1.116l-4 .5a.75.75 0 00-.531 1.16l.307.46a.251.251 0 01-.07.347L2.445 11.918a1 1 0 101.11 1.664l14.168-9.445a.249.249 0 01.346.07zM1 24h22a1 1 0 100-2H1a1 1 0 100 2z"
    })));
});
$6196172cf87b1f2b$export$a9d005d0b7785e76.displayName = 'UpwardTrendBold';





var $denZA = parcelRequire("denZA");
var $964f2fe839e418bf$var$__assign = undefined && undefined.__assign || function() {
    $964f2fe839e418bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $964f2fe839e418bf$var$__assign.apply(this, arguments);
};
var $964f2fe839e418bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $964f2fe839e418bf$export$d5ad65c4a4d4aa75 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $964f2fe839e418bf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $964f2fe839e418bf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.25 3a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M7.5.75A.75.75 0 018.25 0h7.5a.75.75 0 01.75.75v5.379A2.25 2.25 0 0118 8.25V18a6 6 0 11-12 0V8.25a2.25 2.25 0 011.5-2.121V.75zM9 1.5h6V6H9V1.5zM7.72 7.72a.75.75 0 01.53-.22h7.5a.75.75 0 01.75.75V18a4.5 4.5 0 11-9 0V8.25a.75.75 0 01.22-.53z",
        fillRule: "evenodd"
    })));
});
$964f2fe839e418bf$export$d5ad65c4a4d4aa75.displayName = 'UsbStick';





var $denZA = parcelRequire("denZA");
var $bf7131733091f678$var$__assign = undefined && undefined.__assign || function() {
    $bf7131733091f678$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf7131733091f678$var$__assign.apply(this, arguments);
};
var $bf7131733091f678$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bf7131733091f678$export$c1f5944f83552d69 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $bf7131733091f678$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $bf7131733091f678$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11 3a.5.5 0 00-.5.5v1a.5.5 0 001 0v-1A.5.5 0 0011 3zm2 0a.5.5 0 00-.5.5v1a.5.5 0 001 0v-1A.5.5 0 0013 3z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M16.643 6.652a.25.25 0 01-.143-.226V2a2 2 0 00-2-2h-5a2 2 0 00-2 2v4.426a.252.252 0 01-.143.226A1.5 1.5 0 006.5 8v11.5A4.505 4.505 0 0011 24h2a4.505 4.505 0 004.5-4.5V8a1.5 1.5 0 00-.857-1.348zM13.5 11.5h-3a1 1 0 110-2h3a1 1 0 110 2zM9.75 2a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h4.5a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25h-4.5z",
        fillRule: "evenodd"
    })));
});
$bf7131733091f678$export$c1f5944f83552d69.displayName = 'UsbStickBold';





var $denZA = parcelRequire("denZA");
var $0f234adc27b439d0$var$__assign = undefined && undefined.__assign || function() {
    $0f234adc27b439d0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0f234adc27b439d0$var$__assign.apply(this, arguments);
};
var $0f234adc27b439d0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0f234adc27b439d0$export$ae01dedf5c052bb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0f234adc27b439d0$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0f234adc27b439d0$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M9.41 17.39c-.14 0-.27-.03-.39-.1a.806.806 0 01-.4-.69V7.31c0-.14.04-.28.12-.41a.79.79 0 01.31-.29c.13-.07.27-.1.41-.09.14.01.28.05.4.13l7.18 4.9c.11.07.2.17.26.29.06.12.09.25.09.38s-.04.26-.11.38-.16.21-.27.28l-7.18 4.39c-.13.07-.27.11-.42.12zm.79-8.57v6.35l4.92-3-4.92-3.35z"
    }), $denZA.createElement("path", {
        d: "M22.2 1.5c.17 0 .3.14.3.3v20.4a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h20.4zm0-1.5H1.8C.81 0 0 .81 0 1.8v20.4c0 1 .81 1.8 1.8 1.8h20.4c1 0 1.8-.81 1.8-1.8V1.8c0-.99-.81-1.8-1.8-1.8z"
    })));
});
$0f234adc27b439d0$export$ae01dedf5c052bb.displayName = 'Video';





var $denZA = parcelRequire("denZA");
var $9c44869dfa58351a$var$__assign = undefined && undefined.__assign || function() {
    $9c44869dfa58351a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9c44869dfa58351a$var$__assign.apply(this, arguments);
};
var $9c44869dfa58351a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9c44869dfa58351a$export$6401bc1a346c7466 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $9c44869dfa58351a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $9c44869dfa58351a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M22.2 24H1.8c-1 0-1.8-.81-1.8-1.8V1.8C0 .81.81 0 1.8 0h20.4c1 0 1.8.81 1.8 1.8v20.4c0 .99-.81 1.8-1.8 1.8zM9.82 17.28L17 12.89c.11-.07.21-.17.27-.28.07-.12.1-.25.11-.38 0-.13-.03-.26-.09-.38a.73.73 0 00-.26-.29l-7.18-4.9a.802.802 0 00-.4-.14c-.14 0-.28.03-.41.1a.72.72 0 00-.31.29c-.07.12-.11.26-.12.4v9.28c0 .14.04.28.11.4s.18.22.3.29c.12.07.25.1.39.1.15 0 .29-.04.41-.1zm5.3-5.1l-4.92 3V8.82l4.92 3.36z"
    })));
});
$9c44869dfa58351a$export$6401bc1a346c7466.displayName = 'VideoBold';





var $denZA = parcelRequire("denZA");
var $0174807d354789ba$var$__assign = undefined && undefined.__assign || function() {
    $0174807d354789ba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0174807d354789ba$var$__assign.apply(this, arguments);
};
var $0174807d354789ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0174807d354789ba$export$993cbbcac07cae09 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0174807d354789ba$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0174807d354789ba$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M8.04 16.29c-.14 0-.27-.03-.39-.1a.834.834 0 01-.3-.29.802.802 0 01-.11-.4V6.22c0-.14.04-.28.12-.41a.79.79 0 01.31-.29c.13-.07.27-.1.41-.09.14.01.28.05.4.13l7.18 4.9c.11.07.2.17.26.29.06.12.09.25.09.38s-.04.26-.11.38-.16.21-.27.28l-7.18 4.39c-.13.07-.27.11-.41.11zm.79-8.56v6.35l4.92-3-4.92-3.35z"
    }), $denZA.createElement("path", {
        d: "M19.92 1.5c.17 0 .3.14.3.3v18.12a.3.3 0 01-.3.3H1.8a.3.3 0 01-.3-.3V1.8c0-.17.14-.3.3-.3h18.12zm0-1.5H1.8C.81 0 0 .81 0 1.8v18.12c0 1 .81 1.8 1.8 1.8h18.12c1 0 1.8-.81 1.8-1.8V1.8c.01-.99-.8-1.8-1.8-1.8z"
    }), $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    })));
});
$0174807d354789ba$export$993cbbcac07cae09.displayName = 'VideoMulti';





var $denZA = parcelRequire("denZA");
var $d25e121de3f4c117$var$__assign = undefined && undefined.__assign || function() {
    $d25e121de3f4c117$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d25e121de3f4c117$var$__assign.apply(this, arguments);
};
var $d25e121de3f4c117$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d25e121de3f4c117$export$175c6991f3efdc6b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $d25e121de3f4c117$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $d25e121de3f4c117$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M21.44 24H4.11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h17.33c.58 0 1.05-.47 1.05-1.05V4.11c0-.41.34-.75.75-.75s.76.34.76.75v17.33c0 1.41-1.15 2.56-2.56 2.56z"
    }), $denZA.createElement("path", {
        d: "M19.92 21.73H1.8c-1 0-1.8-.81-1.8-1.8V1.8C0 .81.81 0 1.8 0h18.12c1 0 1.8.81 1.8 1.8v18.12c.01 1-.8 1.81-1.8 1.81zM8.45 16.18l7.18-4.39c.11-.07.21-.17.27-.28.07-.12.1-.25.11-.38 0-.13-.03-.26-.09-.38a.73.73 0 00-.26-.29l-7.18-4.9a.824.824 0 00-.4-.13c-.15 0-.29.03-.42.1a.78.78 0 00-.42.69v9.28c0 .14.04.28.11.4s.18.22.3.29c.12.07.25.1.39.1s.28-.04.41-.11zm5.3-5.1l-4.92 3V7.73l4.92 3.35z"
    })));
});
$d25e121de3f4c117$export$175c6991f3efdc6b.displayName = 'VideoMultiBold';





var $denZA = parcelRequire("denZA");
var $1fedd568513a982a$var$__assign = undefined && undefined.__assign || function() {
    $1fedd568513a982a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1fedd568513a982a$var$__assign.apply(this, arguments);
};
var $1fedd568513a982a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1fedd568513a982a$export$cc3a325749da3826 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1fedd568513a982a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1fedd568513a982a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M6.808 21.998A1.794 1.794 0 015 20.178V3.828a1.829 1.829 0 01.887-1.572 1.8 1.8 0 011.796-.028l15.381 8.15a1.84 1.84 0 010 3.2l-15.381 8.15a1.83 1.83 0 01-.875.27zm0-18.43a.336.336 0 00-.159 0 .32.32 0 00-.149.27v16.3a.312.312 0 00.152.266.306.306 0 00.305.005l15.382-8.16a.3.3 0 00.159-.27.292.292 0 00-.16-.27l-15.38-8.15a.277.277 0 00-.15-.04v.05z"
    })));
});
$1fedd568513a982a$export$cc3a325749da3826.displayName = 'VideoPlay';





var $denZA = parcelRequire("denZA");
var $1b7919a336685076$var$__assign = undefined && undefined.__assign || function() {
    $1b7919a336685076$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b7919a336685076$var$__assign.apply(this, arguments);
};
var $1b7919a336685076$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1b7919a336685076$export$fdc0bd4ae10bd871 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $1b7919a336685076$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $1b7919a336685076$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M5 3.12v17.744a1.154 1.154 0 00.563.976 1.145 1.145 0 001.124.025l16.721-8.872a1.14 1.14 0 00.592-1 1.144 1.144 0 00-.591-1.002L6.657 2.12a1.145 1.145 0 00-1.501.452c-.097.167-.15.355-.156.549z"
    })));
});
$1b7919a336685076$export$fdc0bd4ae10bd871.displayName = 'VideoPlayBold';





var $denZA = parcelRequire("denZA");
var $ea2697e2f52015f2$var$__assign = undefined && undefined.__assign || function() {
    $ea2697e2f52015f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea2697e2f52015f2$var$__assign.apply(this, arguments);
};
var $ea2697e2f52015f2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ea2697e2f52015f2$export$67fadca628676d83 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $ea2697e2f52015f2$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $ea2697e2f52015f2$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M22.072 2.23a.75.75 0 01-.021 1.061l-18.75 18a.75.75 0 11-1.039-1.082l18.75-18a.75.75 0 011.06.022zm-2.929 5.958a.75.75 0 011.047-.164c1.156.843 2.223 1.8 3.187 2.858l.003.003a2.413 2.413 0 010 3.23l-.003.002C20.758 17 16.412 20.07 11.995 20a10.734 10.734 0 01-3.255-.483.75.75 0 01.445-1.432 9.236 9.236 0 002.826.415c3.779.064 7.744-2.627 10.255-5.39a.914.914 0 000-1.22 19.816 19.816 0 00-2.96-2.654.75.75 0 01-.163-1.048zM12 5c.874-.009 1.745.093 2.592.304a.75.75 0 01-.362 1.456 8.799 8.799 0 00-2.244-.26c-3.713-.062-7.69 2.57-10.252 5.388a.913.913 0 000 1.22c.767.84 1.605 1.613 2.503 2.31a.75.75 0 01-.92 1.185 21.553 21.553 0 01-2.693-2.486l-.004-.004a2.413 2.413 0 010-3.23l.002-.002C3.3 7.935 7.655 4.932 12 5z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998 9.5a3 3 0 00-3 3 .75.75 0 01-1.5 0 4.499 4.499 0 014.5-4.5.75.75 0 010 1.5zm3.75 2.249a.75.75 0 01.75.75 4.502 4.502 0 01-4.5 4.501.75.75 0 110-1.5 3 3 0 003-3 .75.75 0 01.75-.751z",
        fillRule: "evenodd"
    })));
});
$ea2697e2f52015f2$export$67fadca628676d83.displayName = 'ViewHide';





var $denZA = parcelRequire("denZA");
var $c2450d40d087e645$var$__assign = undefined && undefined.__assign || function() {
    $c2450d40d087e645$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2450d40d087e645$var$__assign.apply(this, arguments);
};
var $c2450d40d087e645$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2450d40d087e645$export$639d2a0e5f6e1492 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $c2450d40d087e645$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $c2450d40d087e645$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.967 19.978a1.365 1.365 0 00-.028 1.83 1.145 1.145 0 001.702.027l3.342-3.485c1.275.553 2.57.873 3.827.9h.31c3.597.065 7.577-2.369 10.525-5.858a2.54 2.54 0 00.002-3.219 19.969 19.969 0 00-3.61-3.35l2.973-3.1c.477-.498.49-1.318.028-1.83a1.145 1.145 0 00-1.702-.027L2.967 19.978zm12.253-9.175l-4.118 4.294a3.03 3.03 0 001.007.171c1.79 0 3.24-1.56 3.24-3.485 0-.34-.045-.669-.13-.98z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M12.109 8.298c.304 0 .598.045.878.13l3.126-3.26c-1.231-.521-2.475-.822-3.677-.851l-.315-.001C8.529 4.25 4.527 6.677 1.576 10.17a2.54 2.54 0 00-.002 3.218 20.048 20.048 0 003.506 3.283l3.883-4.049a3.744 3.744 0 01-.095-.84c0-1.925 1.451-3.485 3.24-3.485z"
    })));
});
$c2450d40d087e645$export$639d2a0e5f6e1492.displayName = 'ViewHideBold';





var $denZA = parcelRequire("denZA");
var $0d5e99ae88fea2f8$var$__assign = undefined && undefined.__assign || function() {
    $0d5e99ae88fea2f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0d5e99ae88fea2f8$var$__assign.apply(this, arguments);
};
var $0d5e99ae88fea2f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d5e99ae88fea2f8$export$153f7030970dae8f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $0d5e99ae88fea2f8$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $0d5e99ae88fea2f8$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M23.383 10.337c-2.606-2.863-6.909-5.88-11.246-5.88H12c-4.389-.068-8.76 3-11.383 5.88a2.435 2.435 0 000 3.24c2.589 2.863 6.892 5.88 11.229 5.88h.274c4.337 0 8.64-3.034 11.246-5.88.84-.926.84-2.314.017-3.24zm-1.114 2.229c-2.383 2.623-6.275 5.4-10.115 5.4H12c-3.891.051-7.851-2.743-10.251-5.383a.916.916 0 010-1.217c3.6-3.995 7.56-5.4 10.131-5.4h.137c2.554-.052 6.583 1.354 10.252 5.383a.916.916 0 010 1.217z"
    }), $denZA.createElement("path", {
        d: "M12 7.457c-2.486 0-4.509 2.023-4.509 4.492 0 1.2.463 2.331 1.32 3.188A4.444 4.444 0 0012 16.457c2.486 0 4.491-2.023 4.509-4.491 0-1.2-.463-2.332-1.32-3.189A4.474 4.474 0 0012 7.457zm3 4.509a2.981 2.981 0 01-3 3 2.981 2.981 0 01-3-3c0-1.646 1.354-3 3-3a2.981 2.981 0 013 3z"
    })));
});
$0d5e99ae88fea2f8$export$153f7030970dae8f.displayName = 'ViewShow';





var $denZA = parcelRequire("denZA");
var $6021adb0fbb2d43a$var$__assign = undefined && undefined.__assign || function() {
    $6021adb0fbb2d43a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6021adb0fbb2d43a$var$__assign.apply(this, arguments);
};
var $6021adb0fbb2d43a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6021adb0fbb2d43a$export$6d39d2f2d511d9a3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $6021adb0fbb2d43a$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $6021adb0fbb2d43a$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M12.436 4.502h-.315c-3.592-.066-7.594 2.36-10.545 5.854a2.54 2.54 0 00-.002 3.219c2.863 3.392 6.7 5.786 10.236 5.86h.31c3.597.066 7.577-2.368 10.525-5.858a2.54 2.54 0 00.002-3.218C19.79 6.98 15.935 4.586 12.436 4.502zM12.109 16c2.109 0 3.991-1.562 3.991-4.031 0-2.469-1.882-4.039-3.991-4.039S8.12 9.5 8.12 11.969C8.12 14.438 10 16 12.109 16z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M14.6 12a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
    })));
});
$6021adb0fbb2d43a$export$6d39d2f2d511d9a3.displayName = 'ViewShowBold';





var $denZA = parcelRequire("denZA");
var $99c0d553912487bd$var$__assign = undefined && undefined.__assign || function() {
    $99c0d553912487bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $99c0d553912487bd$var$__assign.apply(this, arguments);
};
var $99c0d553912487bd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $99c0d553912487bd$export$b5e8fd97b49d7a6e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $99c0d553912487bd$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $99c0d553912487bd$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.5 13.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M11.998.75A8.272 8.272 0 003.75 8.998v.019a4.125 4.125 0 00.375 8.233c.164 0 .326-.022.482-.063A2.25 2.25 0 006.75 18.75h3a.75.75 0 00.416-.126L12 17.401l1.833 1.223a.751.751 0 00.416.126h3a2.25 2.25 0 002.143-1.563c.156.041.318.063.483.063a4.125 4.125 0 00.375-8.233v-.019A8.272 8.272 0 0012.002.75h-.004zm6.232 9.225a1.875 1.875 0 01.52-.6v-.374A6.772 6.772 0 0012 2.25a6.772 6.772 0 00-6.75 6.751v.374a1.875 1.875 0 01.52.6 2.25 2.25 0 01.98-.225h10.5c.343 0 .677.079.98.225zM6 12v4.5a.75.75 0 00.75.75h2.773l2.061-1.374a.75.75 0 01.832 0l2.06 1.374h2.773a.75.75 0 00.75-.75V12a.75.75 0 00-.75-.75H6.75A.75.75 0 006 12zm-1.5-1.125a.375.375 0 00-.375-.375 2.625 2.625 0 000 5.25.375.375 0 00.375-.375v-4.5zm15.375-.375a.375.375 0 00-.375.375v4.5a.375.375 0 00.375.375 2.625 2.625 0 000-5.25z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M17.774 20.89a.75.75 0 00-1.05-1.072 6.75 6.75 0 01-8.774.582.75.75 0 10-.9 1.2 8.25 8.25 0 0010.724-.71z"
    })));
});
$99c0d553912487bd$export$b5e8fd97b49d7a6e.displayName = 'VirtualReality';





var $denZA = parcelRequire("denZA");
var $46f04efc6cb51e75$var$__assign = undefined && undefined.__assign || function() {
    $46f04efc6cb51e75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $46f04efc6cb51e75$var$__assign.apply(this, arguments);
};
var $46f04efc6cb51e75$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $46f04efc6cb51e75$export$d1389198cb17768a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $46f04efc6cb51e75$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $46f04efc6cb51e75$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M18.53 20.81a9.54 9.54 0 01-6.19 2.92 9.42 9.42 0 01-6.5-2 1 1 0 01-.18-1.31.861.861 0 011.24-.22 7.71 7.71 0 005.32 1.66 7.81 7.81 0 005.06-2.39.858.858 0 011.26 0 1 1 0 01-.01 1.34zM3.75 9.19A8.22 8.22 0 0111.1 1a10 10 0 011.74 0 8.34 8.34 0 017.41 8.22 4.06 4.06 0 013.65 3.22 4.582 4.582 0 01-.06 2 4 4 0 01-4.45 2.94 2.2 2.2 0 01-2.14 1.56h-3s-.33.06-2.25-1.35l-1.83 1.22s-.19.24-3.42.13a2.32 2.32 0 01-2.14-1.56S1.53 18 .16 14.44a8.13 8.13 0 01-.07-2 4.21 4.21 0 013.66-3.25zm.19 2.09a1.92 1.92 0 00-2 1.55 2.06 2.06 0 002 2.63.3.3 0 00.3-.3V11.5a.33.33 0 00-.3-.22zm13.51 1a.65.65 0 00-.68-.64H7.18a.62.62 0 00-.68.64v3.77a.61.61 0 00.44.66c.916.048 1.834.048 2.75 0l2-1.24a.58.58 0 01.62.07c1.35.89 1.88 1.17 1.88 1.17h2.53a.629.629 0 00.68-.64l.05-3.79zM17.81 9a6.58 6.58 0 00-.63-3 6.101 6.101 0 00-1.75-2.09 6 6 0 00-2.9-1.14c-.5-.03-1-.03-1.5 0a5.88 5.88 0 00-2.94 1.41 6.06 6.06 0 00-1.55 2.07A6.41 6.41 0 006 9c.173.152.324.327.45.52 0 0 .12-.14.77-.2h9.08a2.16 2.16 0 011 .21 1.4 1.4 0 01.51-.53zm2 2.51v3.66a.3.3 0 00.3.3 2.06 2.06 0 002-2.63 1.92 1.92 0 00-2-1.55.331.331 0 00-.29.2l-.01.02z"
    }), $denZA.createElement("path", {
        d: "M18 11l-11.94-.1H6l.21 6.21h12L18 11zm-2.25 3.4h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 010 1.5z"
    })));
});
$46f04efc6cb51e75$export$d1389198cb17768a.displayName = 'VirtualRealityBold';





var $denZA = parcelRequire("denZA");
var $49b315eb1cc2961e$var$__assign = undefined && undefined.__assign || function() {
    $49b315eb1cc2961e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $49b315eb1cc2961e$var$__assign.apply(this, arguments);
};
var $49b315eb1cc2961e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $49b315eb1cc2961e$export$6b41c506d6ea41ba = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $49b315eb1cc2961e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $49b315eb1cc2961e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M23.78.22a.75.75 0 010 1.06l-22.5 22.5a.75.75 0 01-1.06-1.06L22.72.22a.75.75 0 011.06 0zM9.348 17.598a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM12 18a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm2.361-4.904a.75.75 0 01.99-.382c.924.41 1.765.988 2.48 1.703a.75.75 0 01-1.061 1.06 6.726 6.726 0 00-2.027-1.392.75.75 0 01-.382-.99zM12 8.227a.75.75 0 01-.703.795 11.2 11.2 0 00-7.25 3.272.75.75 0 11-1.063-1.058 12.7 12.7 0 018.221-3.712.75.75 0 01.795.703zm5.304 1.229a.75.75 0 011.024-.278 12.768 12.768 0 012.688 2.057.75.75 0 11-1.062 1.06 11.271 11.271 0 00-2.372-1.815.75.75 0 01-.278-1.024zM7.146 3.695a17.234 17.234 0 017.94-.417.75.75 0 11-.268 1.476A15.734 15.734 0 001.262 8.729.75.75 0 01.238 7.633a17.234 17.234 0 016.908-3.938zM20.178 5.9a.75.75 0 011.035-.234 17.212 17.212 0 012.549 1.967.75.75 0 01-1.024 1.096 15.711 15.711 0 00-2.327-1.795.75.75 0 01-.233-1.035z",
        fillRule: "evenodd"
    })));
});
$49b315eb1cc2961e$export$6b41c506d6ea41ba.displayName = 'WifiOff';





var $denZA = parcelRequire("denZA");
var $7e08ceb79531c5cf$var$__assign = undefined && undefined.__assign || function() {
    $7e08ceb79531c5cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e08ceb79531c5cf$var$__assign.apply(this, arguments);
};
var $7e08ceb79531c5cf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e08ceb79531c5cf$export$a9eac14b6b23ec8b = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7e08ceb79531c5cf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7e08ceb79531c5cf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M1.016 6.39a.976.976 0 00-.282.973c.094.349.377.622.74.713a1.06 1.06 0 001.008-.272c3.079-2.963 7.453-4.31 11.744-3.616.356.061.72-.06.959-.322l.006-.007a.972.972 0 00.196-.987 1.026 1.026 0 00-.792-.652c-4.96-.81-10.02.744-13.579 4.17zm20.527 1.414a1.065 1.065 0 001.453-.012.974.974 0 00.013-1.401 16.256 16.256 0 00-.236-.221 1.065 1.065 0 00-1.466.034.975.975 0 00.036 1.414c.068.06.134.123.2.186zm-10.83 1.052a.971.971 0 00.114-1.154 1.051 1.051 0 00-1.095-.48 11.504 11.504 0 00-4.942 2.26c-.29.23-.57.476-.84.734a.976.976 0 00-.283.972c.095.35.378.622.74.714.363.091.749-.013 1.009-.273a9.367 9.367 0 014.709-2.441 1.04 1.04 0 00.577-.319l.011-.013zm7.349.971a.983.983 0 00.123 1.42c.146.122.288.25.426.382a1.065 1.065 0 001.453-.012.974.974 0 00.013-1.4 8.722 8.722 0 00-.566-.5 1.064 1.064 0 00-1.451.114l.002-.004zm-3.242 3.619a.975.975 0 00.195 1.47c.239.158.461.338.664.538.405.39 1.062.39 1.467 0a.974.974 0 000-1.414 7.291 7.291 0 00-.926-.753 1.076 1.076 0 00-1.4.159zm-.734 6.541c0 1.104-.928 1.999-2.074 1.999-1.145 0-2.073-.895-2.073-1.999s.928-1.998 2.073-1.998c1.146 0 2.074.894 2.074 1.998zM22.54.244a1.064 1.064 0 00-1.463.1L1.38 22.328a.973.973 0 00-.215.993c.12.344.426.598.796.663.37.065.749-.069.988-.35L22.646 1.65a.974.974 0 00-.107-1.406z"
    })));
});
$7e08ceb79531c5cf$export$a9eac14b6b23ec8b.displayName = 'WifiOffBold';





var $denZA = parcelRequire("denZA");
var $8798fa367c3589bf$var$__assign = undefined && undefined.__assign || function() {
    $8798fa367c3589bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8798fa367c3589bf$var$__assign.apply(this, arguments);
};
var $8798fa367c3589bf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8798fa367c3589bf$export$788829a381a1aca1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8798fa367c3589bf$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8798fa367c3589bf$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M9.348 16.098a3.75 3.75 0 115.304 5.303 3.75 3.75 0 01-5.304-5.303zM12 16.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-5.836-3.584a8.25 8.25 0 0111.666 0 .75.75 0 01-1.06 1.06 6.75 6.75 0 00-9.546 0 .75.75 0 01-1.06-1.06z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M2.985 9.734a12.75 12.75 0 0118.03 0 .75.75 0 01-1.06 1.06 11.25 11.25 0 00-15.91 0 .75.75 0 11-1.06-1.06z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M.239 6.132a17.25 17.25 0 0123.522 0 .75.75 0 11-1.022 1.097 15.75 15.75 0 00-21.478 0A.75.75 0 01.24 6.132z",
        fillRule: "evenodd"
    })));
});
$8798fa367c3589bf$export$788829a381a1aca1.displayName = 'WifiOn';





var $denZA = parcelRequire("denZA");
var $e69d167d1335adc8$var$__assign = undefined && undefined.__assign || function() {
    $e69d167d1335adc8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e69d167d1335adc8$var$__assign.apply(this, arguments);
};
var $e69d167d1335adc8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e69d167d1335adc8$export$672c1e46075ae959 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e69d167d1335adc8$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e69d167d1335adc8$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M3.44 9.76a1.343 1.343 0 00.017 1.885 1.347 1.347 0 001.886.016c3.68-3.667 9.636-3.667 13.317 0 .252.252.594.393.951.393a1.334 1.334 0 001.34-1.313v-.03c0-.357-.141-.699-.394-.95-4.731-4.712-12.386-4.712-17.117 0z"
    }), $denZA.createElement("path", {
        d: "M23.606 5.644C17.192-.748 6.808-.748.394 5.644a1.343 1.343 0 000 1.901 1.346 1.346 0 001.903 0c5.363-5.344 14.043-5.344 19.406 0a1.346 1.346 0 002.251-.603 1.343 1.343 0 00-.348-1.298zm-9.041 6.392a7.81 7.81 0 00-8.082 1.84 1.343 1.343 0 101.902 1.899 5.114 5.114 0 017.024-.167c.067.06.141.108.205.167a1.343 1.343 0 002.19-.44 1.344 1.344 0 00-.292-1.464 7.738 7.738 0 00-2.947-1.835zm.125 8.426A2.69 2.69 0 0112 23.15a2.69 2.69 0 01-2.69-2.688A2.69 2.69 0 0112 17.774a2.69 2.69 0 012.69 2.688z"
    })));
});
$e69d167d1335adc8$export$672c1e46075ae959.displayName = 'WifiOnBold';





var $denZA = parcelRequire("denZA");
var $84603ee77bd7b1b9$var$__assign = undefined && undefined.__assign || function() {
    $84603ee77bd7b1b9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84603ee77bd7b1b9$var$__assign.apply(this, arguments);
};
var $84603ee77bd7b1b9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $84603ee77bd7b1b9$export$6e5f9bb1ece75cb9 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $84603ee77bd7b1b9$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $84603ee77bd7b1b9$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M11.995 3.001a.761.761 0 00.755-.754V.755A.761.761 0 0011.995 0a.761.761 0 00-.754.755v1.509c0 .394.343.737.754.737zM4.484 9.003h1.612a.761.761 0 00.755-.754.761.761 0 00-.755-.755H4.484a.761.761 0 00-.754.755c0 .411.343.754.754.754zm12.656-.754c0 .411.343.754.755.754h1.612a.761.761 0 00.754-.754.761.761 0 00-.754-.755h-1.612c-.412.017-.755.343-.755.755zM6.645 5.248a.74.74 0 00.532.223.756.756 0 00.532-1.286L6.335 2.811a.756.756 0 00-1.063 0 .756.756 0 000 1.064l1.372 1.372zm10.169.222a.74.74 0 00.532-.222l1.372-1.372a.756.756 0 000-1.064.756.756 0 00-1.063 0l-1.372 1.372a.756.756 0 000 1.064.818.818 0 00.531.223zm-7.065 6.672v1.354c0 .412.343.755.755.755h3a.761.761 0 00.755-.755v-1.354a4.473 4.473 0 002.247-3.893c0-1.2-.463-2.333-1.32-3.19a4.446 4.446 0 00-3.19-1.32 4.497 4.497 0 00-4.494 4.493 4.445 4.445 0 002.247 3.91zm.12-6.02a2.982 2.982 0 012.126-.874 2.982 2.982 0 013.002 3 2.984 2.984 0 01-1.801 2.745.75.75 0 00-.446.686v1.063h-1.51v-1.063a.75.75 0 00-.445-.686 3.005 3.005 0 01-.926-4.87zm3.618 8.883h-3a.761.761 0 00-.755.755c0 .412.343.755.754.755h3.001a.761.761 0 00.755-.755.75.75 0 00-.755-.755zm10.478 8.009a5.184 5.184 0 00-2.658-2.984c-.188-.085-.377-.171-.566-.24a3.374 3.374 0 00-1.698-6.294 3.374 3.374 0 00-3.378 3.379c0 1.235.67 2.315 1.681 2.915h-.017c-1.51.532-2.693 1.698-3.207 3.207a.752.752 0 00.463.96.613.613 0 00.24.035c.309 0 .6-.189.703-.498a3.727 3.727 0 012.298-2.298 3.65 3.65 0 012.847.172 3.694 3.694 0 011.904 2.126c.137.395.565.6.96.463.343-.12.549-.548.428-.943zm-4.938-8.008c1.028 0 1.869.84 1.869 1.869s-.84 1.869-1.87 1.869a1.877 1.877 0 01-1.886-1.87c0-1.045.84-1.868 1.887-1.868zM7.245 20.03c-.189-.085-.377-.171-.566-.24a3.374 3.374 0 00-1.698-6.294c-1.869 0-3.395 1.527-3.395 3.379 0 1.235.669 2.332 1.68 2.915H3.25c-1.51.532-2.693 1.698-3.208 3.207a.752.752 0 00.464.96c.085.035.171.035.24.035.308 0 .6-.189.703-.498a3.727 3.727 0 012.298-2.298 3.651 3.651 0 012.846.172 3.694 3.694 0 011.904 2.126c.137.395.566.6.96.463a.752.752 0 00.463-.96 5.291 5.291 0 00-2.675-2.967zm-2.28-5.025c1.028 0 1.869.84 1.869 1.87 0 1.029-.84 1.886-1.87 1.886a1.873 1.873 0 01-1.869-1.87c0-1.028.84-1.885 1.87-1.885z"
    })));
});
$84603ee77bd7b1b9$export$6e5f9bb1ece75cb9.displayName = 'Workshop';





var $denZA = parcelRequire("denZA");
var $2a6361538ceee15b$var$__assign = undefined && undefined.__assign || function() {
    $2a6361538ceee15b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a6361538ceee15b$var$__assign.apply(this, arguments);
};
var $2a6361538ceee15b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2a6361538ceee15b$export$7da4007fe4a3162 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $2a6361538ceee15b$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $2a6361538ceee15b$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("g", {
        clipPath: "url(#workshop-bold_svg__a)"
    }, $denZA.createElement("path", {
        d: "M9.734 12.119v1.358a.76.76 0 00.746.748h2.982a.754.754 0 00.745-.748v-1.358A4.486 4.486 0 0016.1 9.947a4.51 4.51 0 00.185-2.881 4.494 4.494 0 00-1.598-2.4 4.46 4.46 0 00-5.443 0 4.51 4.51 0 00-1.412 5.28 4.486 4.486 0 001.892 2.173h.01zm3.718 2.855H10.47a.751.751 0 00-.776.443.762.762 0 00.461 1.034.751.751 0 00.315.03h2.982a.753.753 0 00.745-.748.751.751 0 00-.458-.701.742.742 0 00-.287-.058zm10.457 7.986a5.178 5.178 0 00-2.644-2.995 4.643 4.643 0 00-.567-.24 3.369 3.369 0 001.42-1.631 3.387 3.387 0 00-1.06-3.965 3.35 3.35 0 00-4.089 0 3.387 3.387 0 00-1.062 3.965c.282.686.782 1.26 1.421 1.632a5.146 5.146 0 00-2.008 1.233 5.176 5.176 0 00-1.252 2.001.751.751 0 00.457.998.571.571 0 00.229 0h8.26c.158.056.33.056.487 0a.765.765 0 00.499-.7.77.77 0 00-.052-.298h-.04zM7.25 19.965a5.733 5.733 0 00-.568-.24 3.38 3.38 0 001.422-1.637 3.398 3.398 0 00-1.067-3.974 3.36 3.36 0 00-4.098 0 3.398 3.398 0 00-1.067 3.974 3.38 3.38 0 001.42 1.638 5.145 5.145 0 00-1.996 1.236A5.174 5.174 0 00.052 22.96a.751.751 0 00.497.998c.08.016.16.016.239 0h8.31c.117.03.24.03.358 0a.745.745 0 00.514-.697.751.751 0 00-.057-.3 5.273 5.273 0 00-2.664-2.996z"
    }), $denZA.createElement("path", {
        d: "M11.98 3.464a.992.992 0 00.995-.998V.998a.992.992 0 10-1.988 0v1.468a.992.992 0 00.994.998zm4.97 2.066c.255.002.5-.094.686-.27l1.064-.997a1.02 1.02 0 00.24-1.108 1.02 1.02 0 00-.928-.646 1.012 1.012 0 00-.724.286l-1.063.998a1 1 0 00.726 1.737zM5.3 4.253l1.064.998A.994.994 0 007.96 4.122a.999.999 0 00-.224-.319l-1.063-.998a.992.992 0 00-1.193-.12.726.726 0 00-.19.13.997.997 0 00-.168.18 1.002 1.002 0 00.149 1.218l.03.04zm11.65 3.873a1 1 0 00.292.706.991.991 0 00.703.292h1.49a.992.992 0 00.703-.292 1 1 0 00-.703-1.704h-1.49a.992.992 0 00-.703.292 1 1 0 00-.291.706zM6.016 9.244a1 1 0 000-1.997h-1.5a.992.992 0 00-.703.293 1 1 0 00.703 1.704h1.5z"
    })), $denZA.createElement("defs", null, $denZA.createElement("clipPath", {
        id: "workshop-bold_svg__a"
    }, $denZA.createElement("path", {
        d: "M0 0h24v24H0z"
    })))));
});
$2a6361538ceee15b$export$7da4007fe4a3162.displayName = 'WorkshopBold';





var $denZA = parcelRequire("denZA");
var $7ee94af6f51846de$var$__assign = undefined && undefined.__assign || function() {
    $7ee94af6f51846de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ee94af6f51846de$var$__assign.apply(this, arguments);
};
var $7ee94af6f51846de$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7ee94af6f51846de$export$d13069184bfa0730 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $7ee94af6f51846de$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $7ee94af6f51846de$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M10.056 1a9.056 9.056 0 017.072 14.713l5.58 5.58a1 1 0 01-1.321 1.498l-.094-.084-5.58-5.58A9.056 9.056 0 1110.056 1zm0 2a7.056 7.056 0 100 14.112 7.056 7.056 0 000-14.112z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 6.833c.368 0 .666.299.666.667v1.834H12.5a.666.666 0 110 1.332h-1.834V12.5a.666.666 0 11-1.332 0v-1.834H7.5a.666.666 0 110-1.332h1.834V7.5c0-.368.298-.667.666-.667z",
        fillRule: "evenodd"
    })));
});
$7ee94af6f51846de$export$d13069184bfa0730.displayName = 'ZoomIn';





var $denZA = parcelRequire("denZA");
var $e5c8af0fce08538d$var$__assign = undefined && undefined.__assign || function() {
    $e5c8af0fce08538d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5c8af0fce08538d$var$__assign.apply(this, arguments);
};
var $e5c8af0fce08538d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e5c8af0fce08538d$export$52a27ea68a20ff47 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $e5c8af0fce08538d$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $e5c8af0fce08538d$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        d: "M10 6.75a.916.916 0 00-.916.917V9.25H7.5a.916.916 0 100 1.833h1.584v1.583a.916.916 0 101.832 0v-1.583H12.5a.916.916 0 100-1.833h-1.584V7.667A.916.916 0 0010 6.75z"
    })));
});
$e5c8af0fce08538d$export$52a27ea68a20ff47.displayName = 'ZoomInBold';





var $denZA = parcelRequire("denZA");
var $8e46693a2a042e8e$var$__assign = undefined && undefined.__assign || function() {
    $8e46693a2a042e8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e46693a2a042e8e$var$__assign.apply(this, arguments);
};
var $8e46693a2a042e8e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8e46693a2a042e8e$export$adc4acb67269225 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $8e46693a2a042e8e$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $8e46693a2a042e8e$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        d: "M7.5 9.334a.666.666 0 100 1.332h5a.666.666 0 100-1.332h-5z"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M19.112 10.056a9.056 9.056 0 10-3.399 7.072l5.58 5.58.094.083a1 1 0 001.32-1.498l-5.579-5.58a9.018 9.018 0 001.984-5.657zM3 10.056a7.056 7.056 0 1114.112 0 7.056 7.056 0 01-14.112 0z",
        fillRule: "evenodd"
    })));
});
$8e46693a2a042e8e$export$adc4acb67269225.displayName = 'ZoomOut';





var $denZA = parcelRequire("denZA");
var $a160771cae253356$var$__assign = undefined && undefined.__assign || function() {
    $a160771cae253356$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a160771cae253356$var$__assign.apply(this, arguments);
};
var $a160771cae253356$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a160771cae253356$export$d875a145579e27ff = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, rest = $a160771cae253356$var$__rest(_a, [
        "viewBox"
    ]);
    return $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), $a160771cae253356$var$__assign({
        viewBox: viewBox
    }, rest), ref, $denZA.createElement("g", {
        fill: "currentColor"
    }, $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M10 .5a9.5 9.5 0 100 19c2.082 0 4.008-.67 5.573-1.806l5.366 5.367a1.5 1.5 0 002.122-2.122l-5.367-5.366A9.458 9.458 0 0019.5 10 9.5 9.5 0 0010 .5zM3.5 10a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.833 10c0-.368.299-.666.667-.666h5a.666.666 0 110 1.332h-5A.666.666 0 016.833 10z",
        fillRule: "evenodd"
    }), $denZA.createElement("path", {
        clipRule: "evenodd",
        d: "M6.583 10c0-.506.41-.916.917-.916h5a.916.916 0 110 1.832h-5A.916.916 0 016.583 10zm.917-.416a.416.416 0 100 .832h5a.417.417 0 000-.832h-5z",
        fillRule: "evenodd"
    })));
});
$a160771cae253356$export$d875a145579e27ff.displayName = 'ZoomOutBold';





var $denZA = parcelRequire("denZA");

var $b0e775255462631b$var$__assign = undefined && undefined.__assign || function() {
    $b0e775255462631b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b0e775255462631b$var$__assign.apply(this, arguments);
};
var $b0e775255462631b$export$e2255cf6045e8d47 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $086ecb59c0419a39$export$e2255cf6045e8d47), $b0e775255462631b$var$__assign({
        icon: $denZA.createElement((0, $762006c8b714a7dd$export$d92b3f15dbe60212), null),
        showBorder: true
    }, props, {
        ref: ref
    }));
});
$b0e775255462631b$export$e2255cf6045e8d47.Badge = (0, $3739aa3aeb1acb76$export$e8a770fb79a026fe);


var $30e8993beebac45c$export$e8a770fb79a026fe = (0, $3739aa3aeb1acb76$export$e8a770fb79a026fe);





var $denZA = parcelRequire("denZA");
function $75c83302e8267e56$export$b2c43d7d050b2e63(children) {
    return $denZA.Children.toArray(children).filter((child)=>/*#__PURE__*/ $denZA.isValidElement(child));
}



var $denZA = parcelRequire("denZA");

function $c11e7ece5d4a6d8e$var$_extends() {
    $c11e7ece5d4a6d8e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c11e7ece5d4a6d8e$var$_extends.apply(this, arguments);
}
function $c11e7ece5d4a6d8e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c11e7ece5d4a6d8e$export$5b26ebaf2b105908 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Avatar", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children, borderColor: borderColor, max: max, spacing: spacing = "-0.75rem", borderRadius: borderRadius = "full" } = _omitThemingProps, rest = $c11e7ece5d4a6d8e$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children",
        "borderColor",
        "max",
        "spacing",
        "borderRadius"
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    /**
   * get the avatars within the max
   */ var childrenWithinMax = max ? validChildren.slice(0, max) : validChildren;
    /**
   * get the remaining avatar count
   */ var excess = max != null && validChildren.length - max;
    /**
   * Reversing the children is a great way to avoid using zIndex
   * to overlap the avatars
   */ var reversedChildren = childrenWithinMax.reverse();
    var clones = reversedChildren.map((child, index)=>{
        var _child$props$borderCo;
        var isFirstAvatar = index === 0;
        var childProps = {
            marginEnd: isFirstAvatar ? 0 : spacing,
            size: props.size,
            borderColor: (_child$props$borderCo = child.props.borderColor) != null ? _child$props$borderCo : borderColor,
            showBorder: true
        };
        return /*#__PURE__*/ $denZA.cloneElement(child, (0, $dfe73229adf076fd$export$2458ce75c8ef9806)(childProps));
    });
    var groupStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "row-reverse"
    };
    var excessStyles = $c11e7ece5d4a6d8e$var$_extends({
        borderRadius: borderRadius,
        marginStart: spacing
    }, (0, $086ecb59c0419a39$export$360b744af11007ac), styles.excessLabel);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c11e7ece5d4a6d8e$var$_extends({
        ref: ref,
        role: "group",
        __css: groupStyles
    }, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-avatar__group", props.className)
    }), excess > 0 && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, {
        className: "chakra-avatar__excess",
        __css: excessStyles
    }, "+" + excess), clones);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c11e7ece5d4a6d8e$export$5b26ebaf2b105908.displayName = "AvatarGroup";




var $denZA = parcelRequire("denZA");
var $7fb36a15e505e139$var$__assign = undefined && undefined.__assign || function() {
    $7fb36a15e505e139$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fb36a15e505e139$var$__assign.apply(this, arguments);
};
var $7fb36a15e505e139$export$5b26ebaf2b105908 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c11e7ece5d4a6d8e$export$5b26ebaf2b105908), $7fb36a15e505e139$var$__assign({}, props, {
        ref: ref
    }));
});







var $denZA = parcelRequire("denZA");
function $d435252b276092c6$var$_extends() {
    $d435252b276092c6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d435252b276092c6$var$_extends.apply(this, arguments);
}
function $d435252b276092c6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d435252b276092c6$export$e71c4d32a2263218 = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div");
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d435252b276092c6$export$e71c4d32a2263218.displayName = "Box";
var $d435252b276092c6$export$b09fb900337259de = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { size: size, centerContent: centerContent = true } = props, rest = $d435252b276092c6$var$_objectWithoutPropertiesLoose(props, [
        "size",
        "centerContent"
    ]);
    var styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /*#__PURE__*/ $denZA.createElement($d435252b276092c6$export$e71c4d32a2263218, $d435252b276092c6$var$_extends({
        ref: ref,
        boxSize: size,
        __css: $d435252b276092c6$var$_extends({}, styles, {
            flexShrink: 0,
            flexGrow: 0
        })
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d435252b276092c6$export$b09fb900337259de.displayName = "Square";
var $d435252b276092c6$export$c89a927ffc67e6fa = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { size: size } = props, rest = $d435252b276092c6$var$_objectWithoutPropertiesLoose(props, [
        "size"
    ]);
    return /*#__PURE__*/ $denZA.createElement($d435252b276092c6$export$b09fb900337259de, $d435252b276092c6$var$_extends({
        size: size,
        ref: ref,
        borderRadius: "9999px"
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d435252b276092c6$export$c89a927ffc67e6fa.displayName = "Circle";




var $denZA = parcelRequire("denZA");
var $194e5bd32d031ef3$var$__assign = undefined && undefined.__assign || function() {
    $194e5bd32d031ef3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $194e5bd32d031ef3$var$__assign.apply(this, arguments);
};
var $194e5bd32d031ef3$export$e71c4d32a2263218 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $d435252b276092c6$export$e71c4d32a2263218), $194e5bd32d031ef3$var$__assign({}, props, {
        ref: ref
    }));
});








var $denZA = parcelRequire("denZA");
function $6cc9da08fda88f6d$var$_extends() {
    $6cc9da08fda88f6d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cc9da08fda88f6d$var$_extends.apply(this, arguments);
}
function $6cc9da08fda88f6d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6cc9da08fda88f6d$export$10bb7d797ee5079f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { spacing: spacing } = props, rest = $6cc9da08fda88f6d$var$_objectWithoutPropertiesLoose(props, [
        "spacing"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var separatorStyles = $6cc9da08fda88f6d$var$_extends({
        mx: spacing
    }, styles.separator);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $6cc9da08fda88f6d$var$_extends({
        ref: ref,
        role: "presentation"
    }, rest, {
        __css: separatorStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6cc9da08fda88f6d$export$10bb7d797ee5079f.displayName = "BreadcrumbSeparator";
var $6cc9da08fda88f6d$export$ca871f5ef145e138 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { isCurrentPage: isCurrentPage, as: as, className: className } = props, rest = $6cc9da08fda88f6d$var$_objectWithoutPropertiesLoose(props, [
        "isCurrentPage",
        "as",
        "className"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var sharedProps = $6cc9da08fda88f6d$var$_extends({
        ref: ref,
        as: as,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-breadcrumb__link", className)
    }, rest);
    if (isCurrentPage) return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $6cc9da08fda88f6d$var$_extends({
        "aria-current": "page",
        __css: styles.link
    }, sharedProps));
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).a, $6cc9da08fda88f6d$var$_extends({
        __css: styles.link
    }, sharedProps));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6cc9da08fda88f6d$export$ca871f5ef145e138.displayName = "BreadcrumbLink";
var $6cc9da08fda88f6d$export$c13f210c706eb549 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { isCurrentPage: isCurrentPage, separator: separator, isLastChild: isLastChild, spacing: spacing, children: children, className: className } = props, rest = $6cc9da08fda88f6d$var$_objectWithoutPropertiesLoose(props, [
        "isCurrentPage",
        "separator",
        "isLastChild",
        "spacing",
        "children",
        "className"
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var clones = validChildren.map((child)=>{
        if (child.type === $6cc9da08fda88f6d$export$ca871f5ef145e138) return /*#__PURE__*/ $denZA.cloneElement(child, {
            isCurrentPage: isCurrentPage
        });
        if (child.type === $6cc9da08fda88f6d$export$10bb7d797ee5079f) return /*#__PURE__*/ $denZA.cloneElement(child, {
            spacing: spacing,
            children: child.props.children || separator
        });
        return child;
    });
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var itemStyles = $6cc9da08fda88f6d$var$_extends({
        display: "inline-flex",
        alignItems: "center"
    }, styles.item);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-breadcrumb__list-item", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).li, $6cc9da08fda88f6d$var$_extends({
        ref: ref,
        className: _className
    }, rest, {
        __css: itemStyles
    }), clones, !isLastChild && /*#__PURE__*/ $denZA.createElement($6cc9da08fda88f6d$export$10bb7d797ee5079f, {
        spacing: spacing
    }, separator));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6cc9da08fda88f6d$export$c13f210c706eb549.displayName = "BreadcrumbItem";
var $6cc9da08fda88f6d$export$dabcc1ec9dd9d1cc = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Breadcrumb", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var { children: children, spacing: spacing = "0.5rem", separator: separator = "/", className: className } = ownProps, rest = $6cc9da08fda88f6d$var$_objectWithoutPropertiesLoose(ownProps, [
        "children",
        "spacing",
        "separator",
        "className"
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var count = validChildren.length;
    var clones = validChildren.map((child, index)=>/*#__PURE__*/ $denZA.cloneElement(child, {
            separator: separator,
            spacing: spacing,
            isLastChild: count === index + 1
        }));
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-breadcrumb", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).nav, $6cc9da08fda88f6d$var$_extends({
        ref: ref,
        "aria-label": "breadcrumb",
        className: _className,
        __css: styles.container
    }, rest), /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).ol, {
        className: "chakra-breadcrumb__list"
    }, clones)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6cc9da08fda88f6d$export$dabcc1ec9dd9d1cc.displayName = "Breadcrumb";




var $denZA = parcelRequire("denZA");
var $1cf2634d2d98b14b$var$__assign = undefined && undefined.__assign || function() {
    $1cf2634d2d98b14b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1cf2634d2d98b14b$var$__assign.apply(this, arguments);
};
var $1cf2634d2d98b14b$export$c13f210c706eb549 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6cc9da08fda88f6d$export$c13f210c706eb549), $1cf2634d2d98b14b$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $6e9cb26a1327ed1b$var$__assign = undefined && undefined.__assign || function() {
    $6e9cb26a1327ed1b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e9cb26a1327ed1b$var$__assign.apply(this, arguments);
};
var $6e9cb26a1327ed1b$export$ca871f5ef145e138 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6cc9da08fda88f6d$export$ca871f5ef145e138), $6e9cb26a1327ed1b$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $7415c31126c342f3$var$__assign = undefined && undefined.__assign || function() {
    $7415c31126c342f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7415c31126c342f3$var$__assign.apply(this, arguments);
};
var $7415c31126c342f3$export$10bb7d797ee5079f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6cc9da08fda88f6d$export$10bb7d797ee5079f), $7415c31126c342f3$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");



var $25aa410c6dd1dc4f$var$__assign = undefined && undefined.__assign || function() {
    $25aa410c6dd1dc4f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25aa410c6dd1dc4f$var$__assign.apply(this, arguments);
};
var $25aa410c6dd1dc4f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25aa410c6dd1dc4f$export$dabcc1ec9dd9d1cc = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.separator, separator = _b === void 0 ? $denZA.createElement((0, $bb6a2cf1a1123128$export$d6d021d74f4bac76), {
        verticalAlign: "text-top"
    }) : _b, rest = $25aa410c6dd1dc4f$var$__rest(_a, [
        "separator"
    ]);
    return $denZA.createElement((0, $6cc9da08fda88f6d$export$dabcc1ec9dd9d1cc), $25aa410c6dd1dc4f$var$__assign({}, rest, {
        ref: ref,
        separator: separator
    }));
});
$25aa410c6dd1dc4f$export$dabcc1ec9dd9d1cc.Item = (0, $1cf2634d2d98b14b$export$c13f210c706eb549);
$25aa410c6dd1dc4f$export$dabcc1ec9dd9d1cc.Link = (0, $6e9cb26a1327ed1b$export$ca871f5ef145e138);
$25aa410c6dd1dc4f$export$dabcc1ec9dd9d1cc.Separator = (0, $7415c31126c342f3$export$10bb7d797ee5079f);


var $55f6942f78bce650$export$c13f210c706eb549 = (0, $1cf2634d2d98b14b$export$c13f210c706eb549);
var $55f6942f78bce650$export$ca871f5ef145e138 = (0, $6e9cb26a1327ed1b$export$ca871f5ef145e138);
var $55f6942f78bce650$export$10bb7d797ee5079f = (0, $7415c31126c342f3$export$10bb7d797ee5079f);





var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");




var $denZA = parcelRequire("denZA");
function $c6a52112c43a2626$var$_extends() {
    $c6a52112c43a2626$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6a52112c43a2626$var$_extends.apply(this, arguments);
}
function $c6a52112c43a2626$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$c6a52112c43a2626$var$ButtonGroupProvider, $c6a52112c43a2626$export$749e21be8b14b968] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});
var $c6a52112c43a2626$export$69b1032f2ecdf404 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { size: size, colorScheme: colorScheme, variant: variant, className: className, spacing: spacing = "0.5rem", isAttached: isAttached, isDisabled: isDisabled } = props, rest = $c6a52112c43a2626$var$_objectWithoutPropertiesLoose(props, [
        "size",
        "colorScheme",
        "variant",
        "className",
        "spacing",
        "isAttached",
        "isDisabled"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-button__group", className);
    var context = $denZA.useMemo(()=>({
            size: size,
            colorScheme: colorScheme,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        colorScheme,
        variant,
        isDisabled
    ]);
    var groupStyles = {
        display: "inline-flex"
    };
    if (isAttached) groupStyles = $c6a52112c43a2626$var$_extends({}, groupStyles, {
        "> *:first-of-type:not(:last-of-type)": {
            borderEndRadius: 0
        },
        "> *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0
        },
        "> *:not(:first-of-type):last-of-type": {
            borderStartRadius: 0
        }
    });
    else groupStyles = $c6a52112c43a2626$var$_extends({}, groupStyles, {
        "& > *:not(style) ~ *:not(style)": {
            marginStart: spacing
        }
    });
    return /*#__PURE__*/ $denZA.createElement($c6a52112c43a2626$var$ButtonGroupProvider, {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c6a52112c43a2626$var$_extends({
        ref: ref,
        role: "group",
        __css: groupStyles,
        className: _className
    }, rest)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c6a52112c43a2626$export$69b1032f2ecdf404.displayName = "ButtonGroup";






var $1c1cbb13148aec1f$export$8fecac46448b5689 = {
    border: "0px",
    clip: "rect(0px, 0px, 0px, 0px)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $1c1cbb13148aec1f$export$439d29a4e110a164 = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("span", {
    baseStyle: $1c1cbb13148aec1f$export$8fecac46448b5689
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $1c1cbb13148aec1f$export$439d29a4e110a164.displayName = "VisuallyHidden";
var $1c1cbb13148aec1f$export$43b83385b37b9ca0 = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("input", {
    baseStyle: $1c1cbb13148aec1f$export$8fecac46448b5689
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $1c1cbb13148aec1f$export$43b83385b37b9ca0.displayName = "VisuallyHiddenInput";
var $1c1cbb13148aec1f$export$2e2bcd8739ae039 = $1c1cbb13148aec1f$export$439d29a4e110a164;



var $denZA = parcelRequire("denZA");
function $623c60a64c605a2d$var$_extends() {
    $623c60a64c605a2d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $623c60a64c605a2d$var$_extends.apply(this, arguments);
}
function $623c60a64c605a2d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $623c60a64c605a2d$var$spin = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $623c60a64c605a2d$export$7f7cbe89f1eacd2 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Spinner", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className } = _omitThemingProps, rest = $623c60a64c605a2d$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "label",
        "thickness",
        "speed",
        "emptyColor",
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-spinner", className);
    var spinnerStyles = $623c60a64c605a2d$var$_extends({
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: $623c60a64c605a2d$var$spin + " " + speed + " linear infinite"
    }, styles);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $623c60a64c605a2d$var$_extends({
        ref: ref,
        __css: spinnerStyles,
        className: _className
    }, rest), label && /*#__PURE__*/ $denZA.createElement((0, $1c1cbb13148aec1f$export$439d29a4e110a164), null, label));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $623c60a64c605a2d$export$7f7cbe89f1eacd2.displayName = "Spinner";





var $denZA = parcelRequire("denZA");
function $83ea8ca29e8de6d1$var$_extends() {
    $83ea8ca29e8de6d1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83ea8ca29e8de6d1$var$_extends.apply(this, arguments);
}
function $83ea8ca29e8de6d1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $83ea8ca29e8de6d1$export$f2c034885dd3ba7b = (props)=>{
    var { label: label, placement: placement, children: children = /*#__PURE__*/ $denZA.createElement((0, $623c60a64c605a2d$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css } = props, rest = $83ea8ca29e8de6d1$var$_objectWithoutPropertiesLoose(props, [
        "label",
        "placement",
        "spacing",
        "children",
        "className",
        "__css"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-button__spinner", className);
    var marginProp = placement === "start" ? "marginEnd" : "marginStart";
    var spinnerStyles = $denZA.useMemo(()=>$83ea8ca29e8de6d1$var$_extends({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? "0.5rem" : 0,
            fontSize: "1em",
            lineHeight: "normal"
        }, __css), [
        __css,
        label,
        marginProp
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $83ea8ca29e8de6d1$var$_extends({
        className: _className
    }, rest, {
        __css: spinnerStyles
    }), children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $83ea8ca29e8de6d1$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";





var $denZA = parcelRequire("denZA");
function $fcc00c2373b55230$var$_extends() {
    $fcc00c2373b55230$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fcc00c2373b55230$var$_extends.apply(this, arguments);
}
function $fcc00c2373b55230$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fcc00c2373b55230$export$e1c22a2ee2645e36 = (props)=>{
    var { children: children, className: className } = props, rest = $fcc00c2373b55230$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "className"
    ]);
    var _children = /*#__PURE__*/ $denZA.isValidElement(children) ? /*#__PURE__*/ $denZA.cloneElement(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $fcc00c2373b55230$var$_extends({
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0
    }, rest, {
        className: _className
    }), _children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $fcc00c2373b55230$export$e1c22a2ee2645e36.displayName = "ButtonIcon";



var $denZA = parcelRequire("denZA");
function $6363e208ee606551$export$867b668ad7ef61e5(value) {
    var [isButton, setIsButton] = $denZA.useState(!value);
    var refCallback = $denZA.useCallback((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    var type = isButton ? "button" : undefined;
    return {
        ref: refCallback,
        type: type
    };
}


function $2af3240600c51a3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2af3240600c51a3d$var$_extends() {
    $2af3240600c51a3d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2af3240600c51a3d$var$_extends.apply(this, arguments);
}
var $2af3240600c51a3d$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var group = (0, $c6a52112c43a2626$export$749e21be8b14b968)();
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Button", $2af3240600c51a3d$var$_extends({}, group, props));
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isLoading: isLoading, isActive: isActive, isFullWidth: isFullWidth, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as } = _omitThemingProps, rest = $2af3240600c51a3d$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "isDisabled",
        "isLoading",
        "isActive",
        "isFullWidth",
        "children",
        "leftIcon",
        "rightIcon",
        "loadingText",
        "iconSpacing",
        "type",
        "spinner",
        "spinnerPlacement",
        "className",
        "as"
    ]);
    /**
   * When button is used within ButtonGroup (i.e flushed with sibling buttons),
   * it is important to add a `zIndex` on focus.
   *
   * So let's read the component styles and then add `zIndex` to it.
   */ var buttonStyles = $denZA.useMemo(()=>{
        var _styles$_focus;
        var _focus = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, (_styles$_focus = styles == null ? void 0 : styles["_focus"]) != null ? _styles$_focus : {}, {
            zIndex: 1
        });
        return $2af3240600c51a3d$var$_extends({
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            width: isFullWidth ? "100%" : "auto"
        }, styles, !!group && {
            _focus: _focus
        });
    }, [
        styles,
        group,
        isFullWidth
    ]);
    var { ref: _ref, type: defaultType } = (0, $6363e208ee606551$export$867b668ad7ef61e5)(as);
    var contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $2af3240600c51a3d$var$_extends({
        disabled: isDisabled || isLoading,
        ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, _ref),
        as: as,
        type: type != null ? type : defaultType,
        "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-button", className)
    }, rest), isLoading && spinnerPlacement === "start" && /*#__PURE__*/ $denZA.createElement((0, $83ea8ca29e8de6d1$export$f2c034885dd3ba7b), {
        className: "chakra-button__spinner--start",
        label: loadingText,
        placement: "start"
    }, spinner), isLoading ? loadingText || /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, {
        opacity: 0
    }, /*#__PURE__*/ $denZA.createElement($2af3240600c51a3d$var$ButtonContent, contentProps)) : /*#__PURE__*/ $denZA.createElement($2af3240600c51a3d$var$ButtonContent, contentProps), isLoading && spinnerPlacement === "end" && /*#__PURE__*/ $denZA.createElement((0, $83ea8ca29e8de6d1$export$f2c034885dd3ba7b), {
        className: "chakra-button__spinner--end",
        label: loadingText,
        placement: "end"
    }, spinner));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $2af3240600c51a3d$export$353f5b6fc5456de1.displayName = "Button";
function $2af3240600c51a3d$var$ButtonContent(props) {
    var { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing } = props;
    return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, null, leftIcon && /*#__PURE__*/ $denZA.createElement((0, $fcc00c2373b55230$export$e1c22a2ee2645e36), {
        marginEnd: iconSpacing
    }, leftIcon), children, rightIcon && /*#__PURE__*/ $denZA.createElement((0, $fcc00c2373b55230$export$e1c22a2ee2645e36), {
        marginStart: iconSpacing
    }, rightIcon));
}








var $denZA = parcelRequire("denZA");
var $de3b4e58b134f331$var$__assign = undefined && undefined.__assign || function() {
    $de3b4e58b134f331$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de3b4e58b134f331$var$__assign.apply(this, arguments);
};
var $de3b4e58b134f331$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $de3b4e58b134f331$var$Circle = function(props) {
    var radius = props.radius, posx = props.posx, posy = props.posy, animationDelayInMs = props.animationDelayInMs;
    var css = {
        '--spinner-inline-circle-posx': posx + "px",
        '--spinner-inline-circle-posy': posy + "px",
        '--animation-delay': animationDelayInMs + "ms"
    };
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).circle, {
        __css: css,
        r: radius
    });
};
var $de3b4e58b134f331$export$49432f82c08b3d30 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,  @typescript-eslint/naming-convention
    var className = props.className, _css = props.css, rest = $de3b4e58b134f331$var$__rest(props, [
        "className",
        "css"
    ]);
    var viewBoxSize = 36;
    var viewBoxCenter = viewBoxSize / 2;
    var svgViewBox = "0 0 " + viewBoxSize + " " + viewBoxSize;
    var circleRadius = 7;
    var circleCenterLeft = circleRadius;
    var circleCenterRight = viewBoxSize - circleRadius;
    var circleCenterTop = circleRadius;
    var circleCenterBottom = viewBoxSize - circleRadius;
    var circleAnimationDelayInMs = 200;
    var circleInitPosition = 'translate(var(--spinner-inline-circle-posx),var(--spinner-inline-circle-posy))';
    var circleAnim = function() {
        var circleCenterPosition = "translate(" + viewBoxCenter + "px, " + viewBoxCenter + "px)";
        var animationTimingFunction = 'cubic-bezier(1, 0.005, 0.52, 0.99)';
        var animationDuration = '1600ms';
        var frames = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
            '25%': {
                transform: circleCenterPosition + " scale(0.2)"
            },
            '60%': {
                transform: circleInitPosition
            }
        });
        return frames + " " + animationDuration + " " + animationTimingFunction + " infinite normal forwards";
    }();
    var spinnerStyles = {
        stroke: 'none',
        fill: 'currentColor',
        circle: {
            transform: circleInitPosition,
            animation: circleAnim,
            animationDelay: 'var(--animation-delay)'
        }
    };
    var circles = [
        {
            posx: circleCenterRight,
            posy: circleCenterBottom
        },
        {
            posx: circleCenterRight,
            posy: circleCenterTop
        },
        {
            posx: circleCenterLeft,
            posy: circleCenterTop
        },
        {
            posx: circleCenterLeft,
            posy: circleCenterBottom
        }
    ];
    return $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $de3b4e58b134f331$var$__assign({
        __css: spinnerStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-ui-spinner-inline', className),
        ref: ref,
        viewBox: svgViewBox
    }, rest), circles.map(function(circle, index) {
        return $denZA.createElement($de3b4e58b134f331$var$Circle, {
            animationDelayInMs: circleAnimationDelayInMs * index,
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            posx: circle.posx,
            posy: circle.posy,
            radius: circleRadius
        });
    }));
});
$de3b4e58b134f331$export$49432f82c08b3d30.displayName = 'SpinnerInline';





var $denZA = parcelRequire("denZA");
var $e032547b364b9976$var$__assign = undefined && undefined.__assign || function() {
    $e032547b364b9976$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e032547b364b9976$var$__assign.apply(this, arguments);
};
var $e032547b364b9976$export$353f5b6fc5456de1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var loadingText = props.loadingText;
    var isSpinnerOnly = !loadingText;
    return $denZA.createElement((0, $2af3240600c51a3d$export$353f5b6fc5456de1), $e032547b364b9976$var$__assign({
        tabIndex: 0
    }, props, {
        "data-spinneronly": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSpinnerOnly),
        ref: ref,
        spinner: $denZA.createElement((0, $de3b4e58b134f331$export$49432f82c08b3d30), null)
    }));
});









var $denZA = parcelRequire("denZA");
var $de3d8b63c73a46a5$var$__assign = undefined && undefined.__assign || function() {
    $de3d8b63c73a46a5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de3d8b63c73a46a5$var$__assign.apply(this, arguments);
};
var $de3d8b63c73a46a5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $de3d8b63c73a46a5$export$69b1032f2ecdf404 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var children = _a.children, _b = _a.spacing, spacing = _b === void 0 ? '1em' : _b, isAttached = _a.isAttached, variant = _a.variant, _c = _a.isRound, isRound = _c === void 0 ? false : _c, rest = $de3d8b63c73a46a5$var$__rest(_a, [
        "children",
        "spacing",
        "isAttached",
        "variant",
        "isRound"
    ]);
    var groupStyles = {
        display: 'inline-flex',
        flexWrap: 'wrap',
        '& > *:not(style) ~ *:not(style)': {
            marginStart: 0
        }
    };
    if (isAttached) groupStyles = $de3d8b63c73a46a5$var$__assign($de3d8b63c73a46a5$var$__assign({}, groupStyles), {
        '> *:first-of-type:not(:last-of-type)': {
            borderEndRadius: 0,
            borderEndWidth: 0
        },
        '> *:not(:first-of-type):not(:last-of-type)': {
            borderRadius: 0,
            borderEndWidth: 0
        },
        '> *:not(:first-of-type):last-of-type': {
            borderStartRadius: 0
        },
        gap: variant === 'outline' ? 'none' : '2px'
    });
    else groupStyles = $de3d8b63c73a46a5$var$__assign($de3d8b63c73a46a5$var$__assign({}, groupStyles), {
        gap: spacing
    });
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var modifiedVariant = variant ? variant : isAttached ? 'attached' : variant;
    return $denZA.createElement((0, $c6a52112c43a2626$export$69b1032f2ecdf404), $de3d8b63c73a46a5$var$__assign({
        variant: modifiedVariant
    }, rest, {
        ref: ref,
        sx: groupStyles
    }), $denZA.Children.map(validChildren, function(child) {
        return $denZA.cloneElement(child, $de3d8b63c73a46a5$var$__assign({}, child.type !== (0, $e032547b364b9976$export$353f5b6fc5456de1) ? {
            isRound: isRound
        } : {}));
    }));
});







var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");
function $b572a2169f87d5ed$var$_extends() {
    $b572a2169f87d5ed$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b572a2169f87d5ed$var$_extends.apply(this, arguments);
}
function $b572a2169f87d5ed$export$49ff6f28c54f1cbe(props) {
    if (props === void 0) props = {};
    var { defaultValue: defaultValue, value: valueProp, onChange: onChange, isDisabled: isDisabled, isNative: isNative } = props;
    var onChangeProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChange);
    var [value, setValue] = (0, $53a3d6ee771ef939$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue || [],
        onChange: onChangeProp
    });
    var handleChange = (0, $denZA.useCallback)((eventOrValue)=>{
        if (!value) return;
        var isChecked = (0, $6b74ef5ae6a56e47$export$4215e022093e324e)(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
        var selectedValue = (0, $6b74ef5ae6a56e47$export$4215e022093e324e)(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        var nextValue = isChecked ? (0, $4cb94e5c0fd5e9d1$export$fb9705de59d96855)(value, selectedValue) : (0, $4cb94e5c0fd5e9d1$export$fe2d9b4e03920b4c)(value, selectedValue);
        setValue(nextValue);
    }, [
        setValue,
        value
    ]);
    var getCheckboxProps = (0, $denZA.useCallback)(function(props) {
        if (props === void 0) props = {};
        var checkedKey = isNative ? "checked" : "isChecked";
        return $b572a2169f87d5ed$var$_extends({}, props, {
            [checkedKey]: value.includes(props.value),
            onChange: handleChange
        });
    }, [
        handleChange,
        isNative,
        value
    ]);
    return {
        value: value,
        isDisabled: isDisabled,
        onChange: handleChange,
        setValue: setValue,
        getCheckboxProps: getCheckboxProps
    };
}


var [$597e2a48604679f6$var$CheckboxGroupProvider, $597e2a48604679f6$export$5575526870d5c2ae] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    strict: false
});
var $597e2a48604679f6$export$4aa08d5625cb8ead = (props)=>{
    var { colorScheme: colorScheme, size: size, variant: variant, children: children, isDisabled: isDisabled } = props;
    var { value: value, onChange: onChange } = (0, $b572a2169f87d5ed$export$49ff6f28c54f1cbe)(props);
    var group = $denZA.useMemo(()=>({
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled
    ]);
    return /*#__PURE__*/ $denZA.createElement($597e2a48604679f6$var$CheckboxGroupProvider, {
        value: group
    }, children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $597e2a48604679f6$export$4aa08d5625cb8ead.displayName = "CheckboxGroup";





var $denZA = parcelRequire("denZA");
function $5b483de9b5932d5d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5b483de9b5932d5d$var$_extends() {
    $5b483de9b5932d5d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5b483de9b5932d5d$var$_extends.apply(this, arguments);
}
var $5b483de9b5932d5d$var$MotionSvg = "custom" in (0, $92af15db400e8627$export$e25e478948902b8b) ? (0, $92af15db400e8627$export$e25e478948902b8b).custom((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg) : (0, $92af15db400e8627$export$e25e478948902b8b)((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg);
var $5b483de9b5932d5d$var$CheckIcon = (props)=>/*#__PURE__*/ $denZA.createElement($5b483de9b5932d5d$var$MotionSvg, $5b483de9b5932d5d$var$_extends({
        width: "1.2em",
        viewBox: "0 0 12 10",
        variants: {
            unchecked: {
                opacity: 0,
                strokeDashoffset: 16
            },
            checked: {
                opacity: 1,
                strokeDashoffset: 0,
                transition: {
                    duration: 0.2
                }
            }
        },
        style: {
            fill: "none",
            strokeWidth: 2,
            stroke: "currentColor",
            strokeDasharray: 16
        }
    }, props), /*#__PURE__*/ $denZA.createElement("polyline", {
        points: "1.5 6 4.5 9 10.5 1"
    }));
var $5b483de9b5932d5d$var$IndeterminateIcon = (props)=>/*#__PURE__*/ $denZA.createElement($5b483de9b5932d5d$var$MotionSvg, $5b483de9b5932d5d$var$_extends({
        width: "1.2em",
        viewBox: "0 0 24 24",
        variants: {
            unchecked: {
                scaleX: 0.65,
                opacity: 0
            },
            checked: {
                scaleX: 1,
                opacity: 1,
                transition: {
                    scaleX: {
                        duration: 0
                    },
                    opacity: {
                        duration: 0.02
                    }
                }
            }
        },
        style: {
            stroke: "currentColor",
            strokeWidth: 4
        }
    }, props), /*#__PURE__*/ $denZA.createElement("line", {
        x1: "21",
        x2: "3",
        y1: "12",
        y2: "12"
    }));
var $5b483de9b5932d5d$var$CheckboxTransition = (_ref)=>{
    var { open: open, children: children } = _ref;
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        initial: false
    }, open && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, {
        variants: {
            unchecked: {
                scale: 0.5
            },
            checked: {
                scale: 1
            }
        },
        initial: "unchecked",
        animate: "checked",
        exit: "unchecked",
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        }
    }, children));
};
var $5b483de9b5932d5d$export$c0a1936901b0e55 = (props)=>{
    var { isIndeterminate: isIndeterminate, isChecked: isChecked } = props, rest = $5b483de9b5932d5d$var$_objectWithoutPropertiesLoose(props, [
        "isIndeterminate",
        "isChecked"
    ]);
    var IconEl = isIndeterminate ? $5b483de9b5932d5d$var$IndeterminateIcon : $5b483de9b5932d5d$var$CheckIcon;
    return /*#__PURE__*/ $denZA.createElement($5b483de9b5932d5d$var$CheckboxTransition, {
        open: isChecked || isIndeterminate
    }, /*#__PURE__*/ $denZA.createElement(IconEl, rest));
};



var $denZA = parcelRequire("denZA");
function $44643eda995a7329$export$c32275ecbd12948f(initialState) {
    if (initialState === void 0) initialState = false;
    var [value, setValue] = (0, $denZA.useState)(initialState);
    var on = (0, $denZA.useCallback)(()=>{
        setValue(true);
    }, []);
    var off = (0, $denZA.useCallback)(()=>{
        setValue(false);
    }, []);
    var toggle = (0, $denZA.useCallback)(()=>{
        setValue((prev)=>!prev);
    }, []);
    return [
        value,
        {
            on: on,
            off: off,
            toggle: toggle
        }
    ];
}






var $denZA = parcelRequire("denZA");
function $56620c7d12be8885$var$_extends() {
    $56620c7d12be8885$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56620c7d12be8885$var$_extends.apply(this, arguments);
}
function $56620c7d12be8885$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $56620c7d12be8885$export$e375f10ce42261c5(props) {
    if (props === void 0) props = {};
    var { defaultIsChecked: defaultIsChecked, defaultChecked: defaultChecked = defaultIsChecked, isChecked: checkedProp, isFocusable: isFocusable, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, onChange: onChange, isIndeterminate: isIndeterminate, isInvalid: isInvalid, name: name, value: value, id: id, onBlur: onBlur, onFocus: onFocus, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy } = props, htmlProps = $56620c7d12be8885$var$_objectWithoutPropertiesLoose(props, [
        "defaultIsChecked",
        "defaultChecked",
        "isChecked",
        "isFocusable",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "onChange",
        "isIndeterminate",
        "isInvalid",
        "name",
        "value",
        "id",
        "onBlur",
        "onFocus",
        "aria-label",
        "aria-labelledby",
        "aria-invalid",
        "aria-describedby"
    ]);
    var onChangeProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChange);
    var onBlurProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onBlur);
    var onFocusProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onFocus);
    var [isFocused, setFocused] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var [isHovered, setHovered] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var [isActive, setActive] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var inputRef = (0, $denZA.useRef)(null);
    var [rootIsLabelElement, setRootIsLabelElement] = (0, $denZA.useState)(true);
    var [checkedState, setCheckedState] = (0, $denZA.useState)(!!defaultChecked);
    var [isControlled, isChecked] = (0, $53a3d6ee771ef939$export$7301e09313e4cf1b)(checkedProp, checkedState);
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: !!defaultIsChecked,
        message: 'The "defaultIsChecked" prop has been deprecated and will be removed in a future version. Please use the "defaultChecked" prop instead, which mirrors default React checkbox behavior.'
    });
    var handleChange = (0, $denZA.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) {
            if (isChecked) setCheckedState(event.target.checked);
            else setCheckedState(isIndeterminate ? true : event.target.checked);
        }
        onChangeProp == null || onChangeProp(event);
    }, [
        isReadOnly,
        isDisabled,
        isChecked,
        isControlled,
        isIndeterminate,
        onChangeProp
    ]);
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = Boolean(isIndeterminate);
    }, [
        isIndeterminate
    ]);
    var trulyDisabled = isDisabled && !isFocusable;
    var onKeyDown = (0, $denZA.useCallback)((event)=>{
        if (event.key === " ") setActive.on();
    }, [
        setActive
    ]);
    var onKeyUp = (0, $denZA.useCallback)((event)=>{
        if (event.key === " ") setActive.off();
    }, [
        setActive
    ]);
    /**
   * Sync state with uncontrolled form libraries like `react-hook-form`.
   *
   * These libraries set the checked value for input fields
   * using their refs. For the checkbox, it sets `ref.current.checked = true | false` directly.
   *
   * This means the `isChecked` state will get out of sync with `ref.current.checked`,
   * even though the input validation with work, the UI will not be up to date.
   *
   * Let's correct that by checking and syncing the state accordingly.
   */ (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        var notInSync = inputRef.current.checked !== isChecked;
        if (notInSync) setCheckedState(inputRef.current.checked);
    }, [
        inputRef.current
    ]);
    var getCheckboxProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        var onPressDown = (event)=>{
            // On mousedown, the input blurs and returns focus to the `body`,
            // we need to prevent this. Native checkboxes keeps focus on `input`
            event.preventDefault();
            setActive.on();
        };
        return $56620c7d12be8885$var$_extends({}, props, {
            ref: forwardedRef,
            "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isFocused),
            "data-indeterminate": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, onPressDown),
            onMouseUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseUp, setActive.off),
            onMouseEnter: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseEnter, setHovered.on),
            onMouseLeave: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseLeave, setHovered.off)
        });
    }, [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly,
        setActive,
        setHovered.off,
        setHovered.on
    ]);
    var getRootProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $56620c7d12be8885$var$_extends({}, htmlProps, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setRootIsLabelElement(node.tagName === "LABEL");
            }),
            onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, ()=>{
                /**
         * Accessibility:
         *
         * Ideally, `getRootProps` should be spread unto a `label` element.
         *
         * If the element was changed using the `as` prop or changing
         * the dom node `getRootProps` is spread unto (to a `div` or `span`), we'll trigger
         * click on the input when the element is clicked.
         * @see Issue https://github.com/chakra-ui/chakra-ui/issues/3480
         */ if (!rootIsLabelElement) {
                    var _inputRef$current;
                    (_inputRef$current = inputRef.current) == null || _inputRef$current.click();
                    (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(inputRef.current, {
                        nextTick: true
                    });
                }
            }),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled)
        });
    }, [
        htmlProps,
        isDisabled,
        rootIsLabelElement
    ]);
    var getInputProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $56620c7d12be8885$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(inputRef, forwardedRef),
            type: "checkbox",
            name: name,
            value: value,
            id: id,
            onChange: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onChange, handleChange),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, onBlurProp, setFocused.off),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, onFocusProp, setFocused.on),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown),
            onKeyUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyUp, onKeyUp),
            required: isRequired,
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isDisabled,
            style: (0, $1c1cbb13148aec1f$export$8fecac46448b5689)
        });
    }, [
        name,
        value,
        id,
        handleChange,
        setFocused.off,
        setFocused.on,
        onBlurProp,
        onFocusProp,
        onKeyDown,
        onKeyUp,
        isRequired,
        isChecked,
        trulyDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        ariaInvalid,
        isInvalid,
        ariaDescribedBy,
        isDisabled
    ]);
    var getLabelProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $56620c7d12be8885$var$_extends({}, props, {
            ref: forwardedRef,
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, $56620c7d12be8885$var$stopEvent),
            onTouchStart: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onTouchStart, $56620c7d12be8885$var$stopEvent),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isInvalid)
        });
    }, [
        isChecked,
        isDisabled,
        isInvalid
    ]);
    return {
        state: {
            isInvalid: isInvalid,
            isFocused: isFocused,
            isChecked: isChecked,
            isActive: isActive,
            isHovered: isHovered,
            isIndeterminate: isIndeterminate,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        },
        getRootProps: getRootProps,
        getCheckboxProps: getCheckboxProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
/**
 * Prevent `onBlur` being fired when the checkbox label is touched
 */ function $56620c7d12be8885$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}


function $d6764b2be464e1ab$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d6764b2be464e1ab$var$_extends() {
    $d6764b2be464e1ab$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6764b2be464e1ab$var$_extends.apply(this, arguments);
}
var $d6764b2be464e1ab$var$CheckboxControl = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("span", {
    baseStyle: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "top",
        userSelect: "none",
        flexShrink: 0
    }
});
var $d6764b2be464e1ab$var$Label = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("label", {
    baseStyle: {
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "top",
        position: "relative",
        _disabled: {
            cursor: "not-allowed"
        }
    }
});
var $d6764b2be464e1ab$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var group = (0, $597e2a48604679f6$export$5575526870d5c2ae)();
    var mergedProps = $d6764b2be464e1ab$var$_extends({}, group, props);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Checkbox", mergedProps);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var { spacing: spacing = "0.5rem", className: className, children: children, iconColor: iconColor, iconSize: iconSize, icon: icon = /*#__PURE__*/ $denZA.createElement((0, $5b483de9b5932d5d$export$c0a1936901b0e55), null), isChecked: isCheckedProp, isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, onChange: onChangeProp } = ownProps, rest = $d6764b2be464e1ab$var$_objectWithoutPropertiesLoose(ownProps, [
        "spacing",
        "className",
        "children",
        "iconColor",
        "iconSize",
        "icon",
        "isChecked",
        "isDisabled",
        "onChange"
    ]);
    var isChecked = isCheckedProp;
    if (group != null && group.value && ownProps.value) isChecked = group.value.includes(ownProps.value);
    var onChange = onChangeProp;
    if (group != null && group.onChange && ownProps.value) onChange = (0, $da6e679e22b3b02c$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    var { state: state, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getRootProps: getRootProps } = (0, $56620c7d12be8885$export$e375f10ce42261c5)($d6764b2be464e1ab$var$_extends({}, rest, {
        isDisabled: isDisabled,
        isChecked: isChecked,
        onChange: onChange
    }));
    var iconStyles = $denZA.useMemo(()=>$d6764b2be464e1ab$var$_extends({
            opacity: state.isChecked || state.isIndeterminate ? 1 : 0,
            transform: state.isChecked || state.isIndeterminate ? "scale(1)" : "scale(0.95)",
            fontSize: iconSize,
            color: iconColor
        }, styles.icon), [
        iconColor,
        iconSize,
        state.isChecked,
        state.isIndeterminate,
        styles.icon
    ]);
    var clonedIcon = /*#__PURE__*/ $denZA.cloneElement(icon, {
        __css: iconStyles,
        isIndeterminate: state.isIndeterminate,
        isChecked: state.isChecked
    });
    return /*#__PURE__*/ $denZA.createElement($d6764b2be464e1ab$var$Label, $d6764b2be464e1ab$var$_extends({
        __css: styles.container,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-checkbox", className)
    }, getRootProps()), /*#__PURE__*/ $denZA.createElement("input", $d6764b2be464e1ab$var$_extends({
        className: "chakra-checkbox__input"
    }, getInputProps({}, ref))), /*#__PURE__*/ $denZA.createElement($d6764b2be464e1ab$var$CheckboxControl, $d6764b2be464e1ab$var$_extends({
        __css: styles.control,
        className: "chakra-checkbox__control"
    }, getCheckboxProps()), clonedIcon), children && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $d6764b2be464e1ab$var$_extends({
        className: "chakra-checkbox__label"
    }, getLabelProps(), {
        __css: $d6764b2be464e1ab$var$_extends({
            marginStart: spacing
        }, styles.label)
    }), children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d6764b2be464e1ab$export$48513f6b9f8ce62d.displayName = "Checkbox";





var $denZA = parcelRequire("denZA");
var $10b1c39056d8e5b7$var$__assign = undefined && undefined.__assign || function() {
    $10b1c39056d8e5b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10b1c39056d8e5b7$var$__assign.apply(this, arguments);
};
var $10b1c39056d8e5b7$var$CheckboxIcon = function(props) {
    var isIndeterminate = props.isIndeterminate;
    if (isIndeterminate) return $denZA.createElement((0, $ad12d0e9373faad2$export$b7a01a7ec68fd5c0), null);
    else return $denZA.createElement((0, $a7d2f29d07be0efc$export$add807e002afa321), null);
};
var $10b1c39056d8e5b7$export$48513f6b9f8ce62d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $d6764b2be464e1ab$export$48513f6b9f8ce62d), $10b1c39056d8e5b7$var$__assign({
        icon: $denZA.createElement($10b1c39056d8e5b7$var$CheckboxIcon, null)
    }, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $b708f46f8af37e2a$var$__assign = undefined && undefined.__assign || function() {
    $b708f46f8af37e2a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b708f46f8af37e2a$var$__assign.apply(this, arguments);
};
var $b708f46f8af37e2a$export$4aa08d5625cb8ead = function(props) {
    return $denZA.createElement((0, $597e2a48604679f6$export$4aa08d5625cb8ead), $b708f46f8af37e2a$var$__assign({}, props));
};







var $denZA = parcelRequire("denZA");

function $0e331232418d618b$var$_extends() {
    $0e331232418d618b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e331232418d618b$var$_extends.apply(this, arguments);
}
function $0e331232418d618b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e331232418d618b$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { icon: icon, children: children, isRound: isRound, "aria-label": ariaLabel } = props, rest = $0e331232418d618b$var$_objectWithoutPropertiesLoose(props, [
        "icon",
        "children",
        "isRound",
        "aria-label"
    ]);
    /**
   * Passing the icon as prop or children should work
   */ var element = icon || children;
    var _children = /*#__PURE__*/ $denZA.isValidElement(element) ? /*#__PURE__*/ $denZA.cloneElement(element, {
        "aria-hidden": true,
        focusable: false
    }) : null;
    return /*#__PURE__*/ $denZA.createElement((0, $2af3240600c51a3d$export$353f5b6fc5456de1), $0e331232418d618b$var$_extends({
        padding: "0",
        borderRadius: isRound ? "full" : undefined,
        ref: ref,
        "aria-label": ariaLabel
    }, rest), _children);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $0e331232418d618b$export$c25acd513dcc8062.displayName = "IconButton";






var $denZA = parcelRequire("denZA");
var $ff0be911914f8500$var$__assign = undefined && undefined.__assign || function() {
    $ff0be911914f8500$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff0be911914f8500$var$__assign.apply(this, arguments);
};
var $ff0be911914f8500$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ff0be911914f8500$export$c25acd513dcc8062 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.isRound, isRound = _b === void 0 ? true : _b, _c = _a.hasFixedIcon, hasFixedIcon = _c === void 0 ? false : _c, rest = $ff0be911914f8500$var$__rest(_a, [
        "isRound",
        "hasFixedIcon"
    ]);
    return $denZA.createElement((0, $0e331232418d618b$export$c25acd513dcc8062), $ff0be911914f8500$var$__assign({
        borderRadius: isRound ? 'full' : 'base',
        "data-icon-fixed": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(hasFixedIcon),
        "data-icononly": true,
        tabIndex: 0
    }, rest, {
        ref: ref,
        spinner: $denZA.createElement((0, $de3b4e58b134f331$export$49432f82c08b3d30), null)
    }));
});






var $denZA = parcelRequire("denZA");
var $be26eda9b41db083$var$__assign = undefined && undefined.__assign || function() {
    $be26eda9b41db083$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be26eda9b41db083$var$__assign.apply(this, arguments);
};
var $be26eda9b41db083$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $be26eda9b41db083$export$de65de8213222d10 = function(props) {
    var _a = props["aria-label"], ariaLabel = _a === void 0 ? 'Close' : _a, rest = $be26eda9b41db083$var$__rest(props, [
        'aria-label'
    ]);
    var icon = $denZA.createElement((0, $c51f9c86b88627ec$export$44fbda67c66d275), {
        color: "slate.500",
        height: "0.75rem",
        width: "0.75rem"
    });
    return $denZA.createElement((0, $ff0be911914f8500$export$c25acd513dcc8062), $be26eda9b41db083$var$__assign({
        "aria-label": ariaLabel,
        icon: icon,
        mr: "1",
        mt: "1",
        size: "md",
        variant: "ghost"
    }, rest));
};







var $denZA = parcelRequire("denZA");
function $3193c4679cc7e7b8$var$_extends() {
    $3193c4679cc7e7b8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3193c4679cc7e7b8$var$_extends.apply(this, arguments);
}
function $3193c4679cc7e7b8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3193c4679cc7e7b8$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { className: className, centerContent: centerContent } = _omitThemingProps, rest = $3193c4679cc7e7b8$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className",
        "centerContent"
    ]);
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Container", props);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $3193c4679cc7e7b8$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-container", className)
    }, rest, {
        __css: $3193c4679cc7e7b8$var$_extends({}, styles, centerContent && {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        })
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $3193c4679cc7e7b8$export$42a852a2b6b56249.displayName = "Container";




var $denZA = parcelRequire("denZA");
var $00264449fc63853c$var$__assign = undefined && undefined.__assign || function() {
    $00264449fc63853c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00264449fc63853c$var$__assign.apply(this, arguments);
};
var $00264449fc63853c$export$42a852a2b6b56249 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $3193c4679cc7e7b8$export$42a852a2b6b56249), $00264449fc63853c$var$__assign({}, props, {
        ref: ref
    }));
});







var $denZA = parcelRequire("denZA");
function $f520972e10047cfe$var$_extends() {
    $f520972e10047cfe$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f520972e10047cfe$var$_extends.apply(this, arguments);
}
function $f520972e10047cfe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f520972e10047cfe$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _useStyleConfig = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Divider", props), { borderLeftWidth: borderLeftWidth, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderWidth: borderWidth, borderStyle: borderStyle, borderColor: borderColor } = _useStyleConfig, styles = $f520972e10047cfe$var$_objectWithoutPropertiesLoose(_useStyleConfig, [
        "borderLeftWidth",
        "borderBottomWidth",
        "borderTopWidth",
        "borderRightWidth",
        "borderWidth",
        "borderStyle",
        "borderColor"
    ]);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { className: className, orientation: orientation = "horizontal", __css: __css } = _omitThemingProps, rest = $f520972e10047cfe$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className",
        "orientation",
        "__css"
    ]);
    var dividerStyles = {
        vertical: {
            borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
            height: "100%"
        },
        horizontal: {
            borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
            width: "100%"
        }
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).hr, $f520972e10047cfe$var$_extends({
        ref: ref,
        "aria-orientation": orientation
    }, rest, {
        __css: $f520972e10047cfe$var$_extends({}, styles, {
            border: "0",
            borderColor: borderColor,
            borderStyle: borderStyle
        }, dividerStyles[orientation], __css),
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-divider", className)
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f520972e10047cfe$export$2e0a83ec2e27ecbb.displayName = "Divider";




var $denZA = parcelRequire("denZA");
var $25153ec74a29a990$var$__assign = undefined && undefined.__assign || function() {
    $25153ec74a29a990$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25153ec74a29a990$var$__assign.apply(this, arguments);
};
var $25153ec74a29a990$export$2e0a83ec2e27ecbb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f520972e10047cfe$export$2e0a83ec2e27ecbb), $25153ec74a29a990$var$__assign({}, props, {
        ref: ref
    }));
});








var $denZA = parcelRequire("denZA");
function $16e5382b11479a26$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $16e5382b11479a26$var$_extends() {
    $16e5382b11479a26$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16e5382b11479a26$var$_extends.apply(this, arguments);
}
var $16e5382b11479a26$var$CloseIcon = (props)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $16e5382b11479a26$var$_extends({
        focusable: "false",
        "aria-hidden": true
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }));
var $16e5382b11479a26$export$de65de8213222d10 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("CloseButton", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children, isDisabled: isDisabled, __css: __css } = _omitThemingProps, rest = $16e5382b11479a26$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children",
        "isDisabled",
        "__css"
    ]);
    var baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $16e5382b11479a26$var$_extends({
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: $16e5382b11479a26$var$_extends({}, baseStyle, styles, __css)
    }, rest), children || /*#__PURE__*/ $denZA.createElement($16e5382b11479a26$var$CloseIcon, {
        width: "1em",
        height: "1em"
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $16e5382b11479a26$export$de65de8213222d10.displayName = "CloseButton";



var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

var $4ca5e22d17609d7e$export$4f9a06cb7441a087 = 'data-focus-lock';
var $4ca5e22d17609d7e$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $4ca5e22d17609d7e$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $4ca5e22d17609d7e$export$70e9b4a1820af101 = 'data-autofocus-inside';



var $denZA = parcelRequire("denZA");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $c940ac9607d4f0f9$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $denZA = parcelRequire("denZA");
function $c5a26c54c82a7061$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $denZA.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $69518c34e9d6aa07$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $denZA.useLayoutEffect : $denZA.useEffect;
var $69518c34e9d6aa07$var$currentValues = new WeakMap();
function $69518c34e9d6aa07$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $c5a26c54c82a7061$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $c940ac9607d4f0f9$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $69518c34e9d6aa07$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $69518c34e9d6aa07$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $c940ac9607d4f0f9$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $c940ac9607d4f0f9$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $69518c34e9d6aa07$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $denZA = parcelRequire("denZA");

var $9fcf59a1f05263db$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $9fcf59a1f05263db$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, null, /*#__PURE__*/ $denZA.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $9fcf59a1f05263db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $denZA.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $9fcf59a1f05263db$export$b8c7b07253306600
    }));
};
$9fcf59a1f05263db$var$InFocusGuard.propTypes = {};
$9fcf59a1f05263db$var$InFocusGuard.defaultProps = {
    children: null
};
var $9fcf59a1f05263db$export$2e2bcd8739ae039 = $9fcf59a1f05263db$var$InFocusGuard;



function $4dfa9206b2bbe134$var$ItoI(a) {
    return a;
}
function $4dfa9206b2bbe134$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $4dfa9206b2bbe134$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $4dfa9206b2bbe134$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $4dfa9206b2bbe134$var$ItoI;
    return $4dfa9206b2bbe134$var$innerCreateMedium(defaults, middleware);
}
function $4dfa9206b2bbe134$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $4dfa9206b2bbe134$var$innerCreateMedium(null);
    medium.options = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $256a6ab0b09059ff$export$5733e022b1d538cb = (0, $4dfa9206b2bbe134$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $256a6ab0b09059ff$export$b3e9a9312f73723c = (0, $4dfa9206b2bbe134$export$9ffbfcaf067b02c6)();
var $256a6ab0b09059ff$export$3a1d52767cbc07b8 = (0, $4dfa9206b2bbe134$export$9ffbfcaf067b02c6)();
var $256a6ab0b09059ff$export$892cbf28e5518020 = (0, $4dfa9206b2bbe134$export$e13ec7dd7a14088d)({
    async: true
});


var $76b2bc1f429bf2eb$var$emptyArray = [];
var $76b2bc1f429bf2eb$var$FocusLock = /*#__PURE__*/ $denZA.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $denZA.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $denZA.useRef();
    var isActive = $denZA.useRef(false);
    var originalFocusedElement = $denZA.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, _props$shards = props.shards, shards = _props$shards === void 0 ? $76b2bc1f429bf2eb$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $denZA.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $denZA.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $denZA.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $denZA.useCallback(function(allowDefer) {
        var current = originalFocusedElement.current;
        if (Boolean(shouldReturnFocus) && current && current.focus) {
            var focusOptions = typeof shouldReturnFocus === 'object' ? shouldReturnFocus : undefined;
            originalFocusedElement.current = null;
            if (allowDefer) // React might return focus after update
            // it's safer to defer the action
            Promise.resolve().then(function() {
                return current.focus(focusOptions);
            });
            else current.focus(focusOptions);
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $denZA.useCallback(function(event) {
        if (isActive.current) (0, $256a6ab0b09059ff$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $256a6ab0b09059ff$export$b3e9a9312f73723c).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $denZA.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$4ca5e22d17609d7e$export$aeda8252e54b50f7] = disabled && 'disabled', _extends2[$4ca5e22d17609d7e$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $69518c34e9d6aa07$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $denZA.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $9fcf59a1f05263db$export$b8c7b07253306600)
        }),
        /*#__PURE__*/ // nearest focus guard
        $denZA.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $9fcf59a1f05263db$export$b8c7b07253306600)
        }) // first tabbed element guard
    ], !disabled && /*#__PURE__*/ $denZA.createElement(SideCar, {
        id: id,
        sideCar: (0, $256a6ab0b09059ff$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus
    }), /*#__PURE__*/ $denZA.createElement(Container, (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $denZA.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $9fcf59a1f05263db$export$b8c7b07253306600)
    }));
});
$76b2bc1f429bf2eb$var$FocusLock.propTypes = {};
$76b2bc1f429bf2eb$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: 'div',
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $76b2bc1f429bf2eb$export$2e2bcd8739ae039 = $76b2bc1f429bf2eb$var$FocusLock;



var $denZA = parcelRequire("denZA");


function $8dbc287de73e99c5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8dbc287de73e99c5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8dbc287de73e99c5$export$2e2bcd8739ae039(o);
}



function $96b1240f665f69df$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8dbc287de73e99c5$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8dbc287de73e99c5$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a3797e63e9ae04e6$export$2e2bcd8739ae039(t) {
    var i = (0, $96b1240f665f69df$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8dbc287de73e99c5$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $4ec0142dc5e2554a$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a3797e63e9ae04e6$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $denZA = parcelRequire("denZA");
function $f9874dca3420722e$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $219455562f995e41$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $denZA.PureComponent));
        (0, $4ec0142dc5e2554a$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $f9874dca3420722e$export$2e2bcd8739ae039 = $f9874dca3420722e$var$withSideEffect;




var $c8564c7f53e933d9$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c8564c7f53e933d9$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};


var $a17906b9a60230ec$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
var $a17906b9a60230ec$var$getTopParent = function(node) {
    return node.parentNode ? $a17906b9a60230ec$var$getTopParent(node.parentNode) : node;
};
var $a17906b9a60230ec$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c8564c7f53e933d9$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $4ca5e22d17609d7e$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $a17906b9a60230ec$var$filterNested((0, $c8564c7f53e933d9$export$45b10814cc054894)($a17906b9a60230ec$var$getTopParent(currentNode).querySelectorAll("[" + (0, $4ca5e22d17609d7e$export$4f9a06cb7441a087) + "=\"" + group + "\"]:not([" + (0, $4ca5e22d17609d7e$export$aeda8252e54b50f7) + "=\"disabled\"])"))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



var $f32d8f97d12a62ab$var$isElementHidden = function(computedStyle) {
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $f32d8f97d12a62ab$export$795910f5f15a9633 = function(node) {
    return !node || node === document || node && node.nodeType === Node.DOCUMENT_NODE || !$f32d8f97d12a62ab$var$isElementHidden(window.getComputedStyle(node, null)) && $f32d8f97d12a62ab$export$795910f5f15a9633(node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode);
};
var $f32d8f97d12a62ab$export$8197b0ea56b3b055 = function(node) {
    return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};
var $f32d8f97d12a62ab$export$d94b8b58ec2f30eb = function(node) {
    return Boolean(node && node.dataset && node.dataset.focusGuard);
};
var $f32d8f97d12a62ab$export$602e5a0d338d7750 = function(node) {
    return !$f32d8f97d12a62ab$export$d94b8b58ec2f30eb(node);
};
var $f32d8f97d12a62ab$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $361f8b856bcbc7f8$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $361f8b856bcbc7f8$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c8564c7f53e933d9$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($361f8b856bcbc7f8$export$350ee6c095d98996);
};




var $ec8507a6a9af90f1$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];


var $22d1e2080bd08eb9$var$queryTabbables = (0, $ec8507a6a9af90f1$export$8555f4622e95784).join(',');
var $22d1e2080bd08eb9$var$queryGuardTabbables = $22d1e2080bd08eb9$var$queryTabbables + ", [data-focus-guard]";
var $22d1e2080bd08eb9$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        return acc.concat((0, $c8564c7f53e933d9$export$45b10814cc054894)(parent.querySelectorAll(withGuards ? $22d1e2080bd08eb9$var$queryGuardTabbables : $22d1e2080bd08eb9$var$queryTabbables)), parent.parentNode ? (0, $c8564c7f53e933d9$export$45b10814cc054894)(parent.parentNode.querySelectorAll($22d1e2080bd08eb9$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $22d1e2080bd08eb9$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[" + (0, $4ca5e22d17609d7e$export$70e9b4a1820af101) + "]");
    return (0, $c8564c7f53e933d9$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $22d1e2080bd08eb9$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $a16b5e81c818f839$export$6266a5cd5915dc33 = function(nodes) {
    return (0, $c8564c7f53e933d9$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $f32d8f97d12a62ab$export$795910f5f15a9633)(node);
    }).filter(function(node) {
        return (0, $f32d8f97d12a62ab$export$8197b0ea56b3b055)(node);
    });
};
var $a16b5e81c818f839$export$3738e313571e2ad2 = function(topNodes, withGuards) {
    return (0, $361f8b856bcbc7f8$export$cb40ee071f0d5226)($a16b5e81c818f839$export$6266a5cd5915dc33((0, $22d1e2080bd08eb9$export$f6768025e418420e)(topNodes, withGuards)), true, withGuards);
};
var $a16b5e81c818f839$export$23c79be8286a3b0c = function(topNodes) {
    return (0, $361f8b856bcbc7f8$export$cb40ee071f0d5226)($a16b5e81c818f839$export$6266a5cd5915dc33((0, $22d1e2080bd08eb9$export$f6768025e418420e)(topNodes)), false);
};
var $a16b5e81c818f839$export$dc26309a71d1ce47 = function(topNode) {
    return $a16b5e81c818f839$export$6266a5cd5915dc33((0, $22d1e2080bd08eb9$export$853fa94d922e78b9)(topNode));
};





var $549ac5b12529483f$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $549ac5b12529483f$var$getParents(node.parentNode, parents);
    return parents;
};
var $549ac5b12529483f$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $549ac5b12529483f$var$getParents(nodeA);
    var parentsB = $549ac5b12529483f$var$getParents(nodeB);
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $549ac5b12529483f$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c8564c7f53e933d9$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c8564c7f53e933d9$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $549ac5b12529483f$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $549ac5b12529483f$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || common.contains(topCommon)) topCommon = common;
                else topCommon = $549ac5b12529483f$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    return topCommon;
};
var $549ac5b12529483f$export$8f99714c70a37db1 = function(entries) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $a16b5e81c818f839$export$dc26309a71d1ce47)(node));
    }, []);
};


var $c283a590c77ad376$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $a17906b9a60230ec$export$7e87c4720b9b279b)(topNode).filter((0, $f32d8f97d12a62ab$export$602e5a0d338d7750));
    var commonParent = (0, $549ac5b12529483f$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var outerNodes = (0, $a16b5e81c818f839$export$3738e313571e2ad2)([
        commonParent
    ], true);
    var innerElements = (0, $a16b5e81c818f839$export$3738e313571e2ad2)(entries).filter(function(_a) {
        var node = _a.node;
        return (0, $f32d8f97d12a62ab$export$602e5a0d338d7750)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $f32d8f97d12a62ab$export$d94b8b58ec2f30eb)(node)
        };
    });
};




var $b743ea6074b8c6c8$var$focusInFrame = function(frame) {
    return frame === document.activeElement;
};
var $b743ea6074b8c6c8$var$focusInsideIframe = function(topNode) {
    return Boolean((0, $c8564c7f53e933d9$export$45b10814cc054894)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $b743ea6074b8c6c8$var$focusInFrame(node);
    }));
};
var $b743ea6074b8c6c8$export$20115f8da7baa6fa = function(topNode) {
    var activeElement = document && document.activeElement;
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $a17906b9a60230ec$export$7e87c4720b9b279b)(topNode).reduce(function(result, node) {
        return result || node.contains(activeElement) || $b743ea6074b8c6c8$var$focusInsideIframe(node);
    }, false);
};




var $09260c4e26ace3b0$export$be6b21806d3fd485 = function() {
    return document && (0, $c8564c7f53e933d9$export$45b10814cc054894)(document.querySelectorAll("[" + (0, $4ca5e22d17609d7e$export$54ecf528c58f9ef6) + "]")).some(function(node) {
        return node.contains(document.activeElement);
    });
};



var $897599608cd27c41$var$isRadio = function(node) {
    return node.tagName === 'INPUT' && node.type === 'radio';
};
var $897599608cd27c41$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter($897599608cd27c41$var$isRadio).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $897599608cd27c41$export$5261662167ad7ced = function(node, nodes) {
    if ($897599608cd27c41$var$isRadio(node) && node.name) return $897599608cd27c41$var$findSelectedRadio(node, nodes);
    return node;
};
var $897599608cd27c41$export$4a5a72a7124e45f9 = function(nodes) {
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($897599608cd27c41$export$5261662167ad7ced(node, nodes));
    });
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $cc338d11b16208e6$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $897599608cd27c41$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $cc338d11b16208e6$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $897599608cd27c41$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $93b2e567b3958806$export$85710b12cf912438 = 'NEW_FOCUS';
var $93b2e567b3958806$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $f32d8f97d12a62ab$export$d94b8b58ec2f30eb)(activeElement);
    if (innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = outerNodes.indexOf(activeElement);
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $897599608cd27c41$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndexDiff = correctedNodes.indexOf(activeElement) - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $cc338d11b16208e6$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $cc338d11b16208e6$export$e06728ee87c96122)(innerNodes, cnt - 1);
    if (activeIndex === -1 || lastNodeInside === -1) return $93b2e567b3958806$export$85710b12cf912438;
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    return undefined;
};







var $8f9db20e07d05831$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        return node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
    };
};
var $8f9db20e07d05831$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $f32d8f97d12a62ab$export$4e62c701997796c1));
};
var $8f9db20e07d05831$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = document && document.activeElement;
    var entries = (0, $a17906b9a60230ec$export$7e87c4720b9b279b)(topNode).filter((0, $f32d8f97d12a62ab$export$602e5a0d338d7750));
    var commonParent = (0, $549ac5b12529483f$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var anyFocusable = (0, $a16b5e81c818f839$export$23c79be8286a3b0c)(entries);
    var innerElements = (0, $a16b5e81c818f839$export$3738e313571e2ad2)(entries).filter(function(_a) {
        var node = _a.node;
        return (0, $f32d8f97d12a62ab$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $a16b5e81c818f839$export$23c79be8286a3b0c)([
        commonParent
    ]).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $8f9db20e07d05831$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $93b2e567b3958806$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $93b2e567b3958806$export$85710b12cf912438)) {
        var autoFocusable = anyFocusable.map(function(_a) {
            var node = _a.node;
            return node;
        }).filter($8f9db20e07d05831$var$findAutoFocused((0, $549ac5b12529483f$export$8f99714c70a37db1)(entries)));
        return {
            node: autoFocusable && autoFocusable.length ? (0, $cc338d11b16208e6$export$f4e86cfa0679b9cc)(autoFocusable) : (0, $cc338d11b16208e6$export$f4e86cfa0679b9cc)(innerNodes)
        };
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $1776152a96f99cf3$export$c12b3da842c43a8 = function(target) {
    target.focus();
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};
var $1776152a96f99cf3$var$guardCount = 0;
var $1776152a96f99cf3$var$lockDisabled = false;
var $1776152a96f99cf3$export$f06c444b0336b5d5 = function(topNode, lastNode) {
    var focusable = (0, $8f9db20e07d05831$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($1776152a96f99cf3$var$lockDisabled) return;
    if (focusable) {
        if ($1776152a96f99cf3$var$guardCount > 2) {
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $1776152a96f99cf3$var$lockDisabled = true;
            setTimeout(function() {
                $1776152a96f99cf3$var$lockDisabled = false;
            }, 1);
            return;
        }
        $1776152a96f99cf3$var$guardCount++;
        $1776152a96f99cf3$export$c12b3da842c43a8(focusable.node);
        $1776152a96f99cf3$var$guardCount--;
    }
};





var $584d64601d10fd6a$export$2e2bcd8739ae039 = (0, $1776152a96f99cf3$export$f06c444b0336b5d5);


function $ace98b4df06b49a0$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var _window = window, setImmediate = _window.setImmediate;
    if (typeof setImmediate !== 'undefined') setImmediate(action);
    else setTimeout(action, 1);
}
var $ace98b4df06b49a0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};



var $68af29d45799bc91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $68af29d45799bc91$var$isFreeFocus = function isFreeFocus() {
    return $68af29d45799bc91$var$focusOnBody() || (0, $09260c4e26ace3b0$export$be6b21806d3fd485)();
};
var $68af29d45799bc91$var$lastActiveTrap = null;
var $68af29d45799bc91$var$lastActiveFocus = null;
var $68af29d45799bc91$var$lastPortaledElement = null;
var $68af29d45799bc91$var$focusWasOutsideWindow = false;
var $68af29d45799bc91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $68af29d45799bc91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($68af29d45799bc91$var$lastActiveTrap.whiteList || $68af29d45799bc91$var$defaultWhitelist)(activeElement);
};
var $68af29d45799bc91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $68af29d45799bc91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $68af29d45799bc91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $68af29d45799bc91$var$lastPortaledElement && $68af29d45799bc91$var$lastPortaledElement.portaledElement === element;
};
function $68af29d45799bc91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $68af29d45799bc91$var$extractRef = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $68af29d45799bc91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($68af29d45799bc91$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $68af29d45799bc91$var$focusWasOutsideWindow === 'meanwhile';
};
var $68af29d45799bc91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($68af29d45799bc91$var$lastActiveTrap) {
        var _lastActiveTrap = $68af29d45799bc91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame;
        var workingNode = observed || $68af29d45799bc91$var$lastPortaledElement && $68af29d45799bc91$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($68af29d45799bc91$var$extractRef).filter(Boolean));
            if (!activeElement || $68af29d45799bc91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $68af29d45799bc91$var$focusWasOutside(crossFrame) || !$68af29d45799bc91$var$isFreeFocus() || !$68af29d45799bc91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $b743ea6074b8c6c8$export$20115f8da7baa6fa)(workingArea) || $68af29d45799bc91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$68af29d45799bc91$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $584d64601d10fd6a$export$2e2bcd8739ae039)(workingArea, $68af29d45799bc91$var$lastActiveFocus);
                            $68af29d45799bc91$var$lastPortaledElement = {};
                        }
                    }
                    $68af29d45799bc91$var$focusWasOutsideWindow = false;
                    $68af29d45799bc91$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $c283a590c77ad376$export$30d9c643899a8835)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $68af29d45799bc91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $68af29d45799bc91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $68af29d45799bc91$var$onTrap = function onTrap(event) {
    if ($68af29d45799bc91$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $68af29d45799bc91$var$onBlur = function onBlur() {
    return (0, $ace98b4df06b49a0$export$6523025722806278)($68af29d45799bc91$var$activateTrap);
};
var $68af29d45799bc91$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $68af29d45799bc91$var$recordPortal(currentNode, source);
};
var $68af29d45799bc91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $68af29d45799bc91$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $denZA.createElement("div", {
        onBlur: $68af29d45799bc91$var$onBlur,
        onFocus: $68af29d45799bc91$var$onFocus
    }, children);
};
$68af29d45799bc91$var$FocusTrap.propTypes = {};
var $68af29d45799bc91$var$onWindowBlur = function onWindowBlur() {
    $68af29d45799bc91$var$focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction
    setTimeout(function() {
        $68af29d45799bc91$var$focusWasOutsideWindow = 'meanwhile';
    }, 0);
};
var $68af29d45799bc91$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $68af29d45799bc91$var$onTrap, true);
    document.addEventListener('focusout', $68af29d45799bc91$var$onBlur);
    window.addEventListener('blur', $68af29d45799bc91$var$onWindowBlur);
};
var $68af29d45799bc91$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $68af29d45799bc91$var$onTrap, true);
    document.removeEventListener('focusout', $68af29d45799bc91$var$onBlur);
    window.removeEventListener('blur', $68af29d45799bc91$var$onWindowBlur);
};
function $68af29d45799bc91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $68af29d45799bc91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$68af29d45799bc91$var$lastActiveTrap) $68af29d45799bc91$var$attachHandler();
    var lastTrap = $68af29d45799bc91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $68af29d45799bc91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $68af29d45799bc91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $68af29d45799bc91$var$activateTrap(true);
        (0, $ace98b4df06b49a0$export$6523025722806278)($68af29d45799bc91$var$activateTrap);
    } else {
        $68af29d45799bc91$var$detachHandler();
        $68af29d45799bc91$var$lastActiveFocus = null;
    }
} // bind medium
(0, $256a6ab0b09059ff$export$5733e022b1d538cb).assignSyncMedium($68af29d45799bc91$var$onFocus);
(0, $256a6ab0b09059ff$export$b3e9a9312f73723c).assignMedium($68af29d45799bc91$var$onBlur);
(0, $256a6ab0b09059ff$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $584d64601d10fd6a$export$2e2bcd8739ae039),
        focusInside: (0, $b743ea6074b8c6c8$export$20115f8da7baa6fa)
    });
});
var $68af29d45799bc91$export$2e2bcd8739ae039 = (0, $f9874dca3420722e$export$2e2bcd8739ae039)($68af29d45799bc91$var$reducePropsToState, $68af29d45799bc91$var$handleStateChangeOnClient)($68af29d45799bc91$var$FocusWatcher);


/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $35c7e210cd40a3fb$var$FocusLockCombination = /*#__PURE__*/ $denZA.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $denZA.createElement((0, $76b2bc1f429bf2eb$export$2e2bcd8739ae039), (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({
        sideCar: (0, $68af29d45799bc91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $35c7e210cd40a3fb$var$_ref = (0, $76b2bc1f429bf2eb$export$2e2bcd8739ae039).propTypes || {}, $35c7e210cd40a3fb$var$sideCar = $35c7e210cd40a3fb$var$_ref.sideCar, $35c7e210cd40a3fb$var$propTypes = (0, $a3ddd36595e6b8f4$export$2e2bcd8739ae039)($35c7e210cd40a3fb$var$_ref, [
    "sideCar"
]);
$35c7e210cd40a3fb$var$FocusLockCombination.propTypes = {};
var $35c7e210cd40a3fb$export$2e2bcd8739ae039 = $35c7e210cd40a3fb$var$FocusLockCombination;



var $532ac85f065c86fa$export$2e2bcd8739ae039 = (0, $35c7e210cd40a3fb$export$2e2bcd8739ae039);




var $b09854f7e168ef4c$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $b09854f7e168ef4c$var$focusableElSelector = $b09854f7e168ef4c$var$focusableElList.join();
function $b09854f7e168ef4c$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($b09854f7e168ef4c$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((0, $e8db4866fc051e33$export$4c063cf1350e6fed)).filter((el)=>window.getComputedStyle(el).display !== "none");
}
function $b09854f7e168ef4c$export$748138f04a69bf21(container) {
    var allFocusable = $b09854f7e168ef4c$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $b09854f7e168ef4c$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($b09854f7e168ef4c$var$focusableElSelector));
    var allTabbable = allFocusable.filter((0, $e8db4866fc051e33$export$bebd5a1431fec25d));
    if ((0, $e8db4866fc051e33$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $b09854f7e168ef4c$export$168b663469d4c75e(container, fallbackToFocusable) {
    var [first] = $b09854f7e168ef4c$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $b09854f7e168ef4c$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $b09854f7e168ef4c$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $b09854f7e168ef4c$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $b09854f7e168ef4c$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find((0, $e8db4866fc051e33$export$bebd5a1431fec25d)) || allFocusable.find((0, $e8db4866fc051e33$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $b09854f7e168ef4c$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $b09854f7e168ef4c$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find((0, $e8db4866fc051e33$export$bebd5a1431fec25d)) || allFocusable.find((0, $e8db4866fc051e33$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $b09854f7e168ef4c$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $b09854f7e168ef4c$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(nextTabbable)) nextTabbable.focus();
}
function $b09854f7e168ef4c$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $b09854f7e168ef4c$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(previousTabbable)) previousTabbable.focus();
}
function $b09854f7e168ef4c$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $b09854f7e168ef4c$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($b09854f7e168ef4c$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}


var $5dc5772c85271349$export$ae70e1f3be7e1299 = (props)=>{
    var { initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, contentRef: contentRef, restoreFocus: restoreFocus, children: children, isDisabled: isDisabled, autoFocus: autoFocus, persistentFocus: persistentFocus, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    var onActivation = $denZA.useCallback(()=>{
        if (initialFocusRef != null && initialFocusRef.current) initialFocusRef.current.focus();
        else if (contentRef != null && contentRef.current) {
            var focusables = (0, $b09854f7e168ef4c$export$4ae682d253b556eb)(contentRef.current);
            if (focusables.length === 0) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(contentRef.current, {
                nextTick: true
            });
        }
    }, [
        initialFocusRef,
        contentRef
    ]);
    var onDeactivation = $denZA.useCallback(()=>{
        var _finalFocusRef$curren;
        finalFocusRef == null || (_finalFocusRef$curren = finalFocusRef.current) == null || _finalFocusRef$curren.focus();
    }, [
        finalFocusRef
    ]);
    var returnFocus = restoreFocus && !finalFocusRef;
    return /*#__PURE__*/ $denZA.createElement((0, $532ac85f065c86fa$export$2e2bcd8739ae039), {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus: persistentFocus,
        autoFocus: autoFocus,
        disabled: isDisabled,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus
    }, children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $5dc5772c85271349$export$ae70e1f3be7e1299.displayName = "FocusLock";
var $5dc5772c85271349$export$2e2bcd8739ae039 = $5dc5772c85271349$export$ae70e1f3be7e1299;



var $denZA = parcelRequire("denZA");

function $739674b42a6b4433$export$91db9bc4f8ac944a() {
    var unloadingRef = $denZA.useRef(false);
    var [count, setCount] = $denZA.useState(0);
    (0, $c29482a8d6079d59$export$f3a192d0cbd30b96)(()=>{
        unloadingRef.current = true;
    });
    return $denZA.useCallback(()=>{
        if (!unloadingRef.current) setCount(count + 1);
    }, [
        count
    ]);
}





var $denZA = parcelRequire("denZA");




var $denZA = parcelRequire("denZA");
var [$601bf1129b0e92c7$var$PortalManagerContextProvider, $601bf1129b0e92c7$export$ef203b29c2cc1f5d] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $601bf1129b0e92c7$export$52c7ef79917c2f38(props) {
    var { children: children, zIndex: zIndex } = props;
    return /*#__PURE__*/ $denZA.createElement($601bf1129b0e92c7$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        }
    }, children);
}
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $601bf1129b0e92c7$export$52c7ef79917c2f38.displayName = "PortalManager";


function $ca7b6815c1fde9de$var$_extends() {
    $ca7b6815c1fde9de$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ca7b6815c1fde9de$var$_extends.apply(this, arguments);
}
function $ca7b6815c1fde9de$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$ca7b6815c1fde9de$var$PortalContextProvider, $ca7b6815c1fde9de$var$usePortalContext] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $ca7b6815c1fde9de$var$PORTAL_CLASSNAME = "chakra-portal";
var $ca7b6815c1fde9de$var$PORTAL_SELECTOR = ".chakra-portal";
var $ca7b6815c1fde9de$var$Container = (props)=>/*#__PURE__*/ $denZA.createElement("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0 // NB: Don't add `bottom: 0`, it makes the entire app unusable
        }
    }, props.children);
/**
 * Portal that uses `document.body` as container
 */ var $ca7b6815c1fde9de$var$DefaultPortal = (props)=>{
    var { appendToParentPortal: appendToParentPortal, children: children } = props;
    var tempNode = $denZA.useRef(null);
    var portal = $denZA.useRef(null);
    var forceUpdate = (0, $739674b42a6b4433$export$91db9bc4f8ac944a)();
    var parentPortal = $ca7b6815c1fde9de$var$usePortalContext();
    var manager = (0, $601bf1129b0e92c7$export$ef203b29c2cc1f5d)();
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (!tempNode.current) return;
        var doc = tempNode.current.ownerDocument;
        var host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $ca7b6815c1fde9de$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate();
        var portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, []);
    var _children = manager != null && manager.zIndex ? /*#__PURE__*/ $denZA.createElement($ca7b6815c1fde9de$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex
    }, children) : children;
    return portal.current ? /*#__PURE__*/ (0, $d486a8928008256a$exports.createPortal)(/*#__PURE__*/ $denZA.createElement($ca7b6815c1fde9de$var$PortalContextProvider, {
        value: portal.current
    }, _children), portal.current) : /*#__PURE__*/ $denZA.createElement("span", {
        ref: tempNode
    });
};
/**
 * Portal that uses a custom container
 */ var $ca7b6815c1fde9de$var$ContainerPortal = (props)=>{
    var { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    var containerEl = containerRef.current;
    var host = containerEl != null ? containerEl : (0, $405775388fe7f58e$export$4e09c449d6c407f7) ? document.body : undefined;
    var portal = $denZA.useMemo(()=>{
        var node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $ca7b6815c1fde9de$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    var forceUpdate = (0, $739674b42a6b4433$export$91db9bc4f8ac944a)();
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        forceUpdate();
    }, []);
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return /*#__PURE__*/ (0, $d486a8928008256a$exports.createPortal)(/*#__PURE__*/ $denZA.createElement($ca7b6815c1fde9de$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null
    }, children), portal);
    return null;
};
function $ca7b6815c1fde9de$export$602eac185826482c(props) {
    var { containerRef: containerRef } = props, rest = $ca7b6815c1fde9de$var$_objectWithoutPropertiesLoose(props, [
        "containerRef"
    ]);
    return containerRef ? /*#__PURE__*/ $denZA.createElement($ca7b6815c1fde9de$var$ContainerPortal, $ca7b6815c1fde9de$var$_extends({
        containerRef: containerRef
    }, rest)) : /*#__PURE__*/ $denZA.createElement($ca7b6815c1fde9de$var$DefaultPortal, rest);
}
$ca7b6815c1fde9de$export$602eac185826482c.defaultProps = {
    appendToParentPortal: true
};
$ca7b6815c1fde9de$export$602eac185826482c.className = $ca7b6815c1fde9de$var$PORTAL_CLASSNAME;
$ca7b6815c1fde9de$export$602eac185826482c.selector = $ca7b6815c1fde9de$var$PORTAL_SELECTOR;
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ca7b6815c1fde9de$export$602eac185826482c.displayName = "Portal";






var $denZA = parcelRequire("denZA");

function $354a231a840f8497$var$_extends() {
    $354a231a840f8497$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $354a231a840f8497$var$_extends.apply(this, arguments);
}
function $354a231a840f8497$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $354a231a840f8497$var$variants = {
    enter: function enter(_temp) {
        var _transition$enter;
        var { transition: transition, transitionEnd: transitionEnd, delay: delay } = _temp === void 0 ? {} : _temp;
        return {
            opacity: 1,
            transition: (_transition$enter = transition == null ? void 0 : transition.enter) != null ? _transition$enter : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).enter((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: function exit(_temp2) {
        var _transition$exit;
        var { transition: transition, transitionEnd: transitionEnd, delay: delay } = _temp2 === void 0 ? {} : _temp2;
        return {
            opacity: 0,
            transition: (_transition$exit = transition == null ? void 0 : transition.exit) != null ? _transition$exit : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    }
};
var $354a231a840f8497$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $354a231a840f8497$var$variants
};
var $354a231a840f8497$export$c983850c6c9d8b0e = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay } = props, rest = $354a231a840f8497$var$_objectWithoutPropertiesLoose(props, [
        "unmountOnExit",
        "in",
        "className",
        "transition",
        "transitionEnd",
        "delay"
    ]);
    var animate = isOpen || unmountOnExit ? "enter" : "exit";
    var show = unmountOnExit ? isOpen && unmountOnExit : true;
    var custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        custom: custom
    }, show && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, $354a231a840f8497$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-fade", className),
        custom: custom
    }, $354a231a840f8497$export$4342735ea5c231d, {
        animate: animate
    }, rest)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $354a231a840f8497$export$c983850c6c9d8b0e.displayName = "Fade";






var $denZA = parcelRequire("denZA");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bc501997ab3ea9a8$var$extendStatics = function(d, b) {
    $bc501997ab3ea9a8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $bc501997ab3ea9a8$var$extendStatics(d, b);
};
function $bc501997ab3ea9a8$export$a8ba968b8961cb8a(d, b) {
    $bc501997ab3ea9a8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc501997ab3ea9a8$export$18ce0697a983be9b = function() {
    $bc501997ab3ea9a8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc501997ab3ea9a8$export$18ce0697a983be9b.apply(this, arguments);
};
function $bc501997ab3ea9a8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bc501997ab3ea9a8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bc501997ab3ea9a8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bc501997ab3ea9a8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bc501997ab3ea9a8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bc501997ab3ea9a8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $bc501997ab3ea9a8$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $bc501997ab3ea9a8$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $bc501997ab3ea9a8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bc501997ab3ea9a8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bc501997ab3ea9a8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bc501997ab3ea9a8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bc501997ab3ea9a8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bc501997ab3ea9a8$export$10c90e4f7922046c(v) {
    return this instanceof $bc501997ab3ea9a8$export$10c90e4f7922046c ? (this.v = v, this) : new $bc501997ab3ea9a8$export$10c90e4f7922046c(v);
}
function $bc501997ab3ea9a8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bc501997ab3ea9a8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bc501997ab3ea9a8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bc501997ab3ea9a8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $bc501997ab3ea9a8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bc501997ab3ea9a8$export$19a8beecd37a4c45 === "function" ? $bc501997ab3ea9a8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bc501997ab3ea9a8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $bc501997ab3ea9a8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $bc501997ab3ea9a8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bc501997ab3ea9a8$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $bc501997ab3ea9a8$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");
var $9171bdae475972c7$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $9171bdae475972c7$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $9171bdae475972c7$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $9171bdae475972c7$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $f27a15cba7acfd1a$export$e27363444bedfeac = (0, $4dfa9206b2bbe134$export$e13ec7dd7a14088d)();



var $4db3d6a0812cbd6a$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $4db3d6a0812cbd6a$export$22940b497e769dee = $denZA.forwardRef(function(props, parentRef) {
    var ref = $denZA.useRef(null);
    var _a = $denZA.useState({
        onScrollCapture: $4db3d6a0812cbd6a$var$nothing,
        onWheelCapture: $4db3d6a0812cbd6a$var$nothing,
        onTouchMoveCapture: $4db3d6a0812cbd6a$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = $bc501997ab3ea9a8$export$3c9a16f847548506(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $69518c34e9d6aa07$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = $bc501997ab3ea9a8$export$18ce0697a983be9b({}, rest, callbacks);
    return $denZA.createElement($denZA.Fragment, null, enabled && $denZA.createElement(SideCar, {
        sideCar: (0, $f27a15cba7acfd1a$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $denZA.cloneElement($denZA.Children.only(children), $bc501997ab3ea9a8$export$18ce0697a983be9b({}, containerProps, {
        ref: containerRef
    })) : $denZA.createElement(Container, $bc501997ab3ea9a8$export$18ce0697a983be9b({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$4db3d6a0812cbd6a$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$4db3d6a0812cbd6a$export$22940b497e769dee.classNames = {
    fullWidth: (0, $9171bdae475972c7$export$898e37bbd2a0ae4e),
    zeroRight: (0, $9171bdae475972c7$export$1da7500147d4bc3)
};




var $denZA = parcelRequire("denZA");
var $2860c6e294209cdc$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $denZA.createElement(Target, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, rest));
};
$2860c6e294209cdc$var$SideCar.isSideCarExport = true;
function $2860c6e294209cdc$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $2860c6e294209cdc$var$SideCar;
}



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
var $74f7744534ac45a0$var$currentNonce;
var $74f7744534ac45a0$export$c5f670b24c0ae95a = function(nonce) {
    $74f7744534ac45a0$var$currentNonce = nonce;
};
var $74f7744534ac45a0$export$2b85b721e524d74b = function() {
    if ($74f7744534ac45a0$var$currentNonce) return $74f7744534ac45a0$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $488fc188efde2f7f$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $74f7744534ac45a0$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $488fc188efde2f7f$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $488fc188efde2f7f$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $488fc188efde2f7f$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $488fc188efde2f7f$var$makeStyleTag()) {
                    $488fc188efde2f7f$var$injectStyles(stylesheet, style);
                    $488fc188efde2f7f$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $37ba543431446ce4$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $488fc188efde2f7f$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $denZA.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $996e45e8f5a87a39$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $37ba543431446ce4$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $7de099632eb38088$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $7de099632eb38088$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $7de099632eb38088$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $7de099632eb38088$var$parse(left),
        $7de099632eb38088$var$parse(top),
        $7de099632eb38088$var$parse(right)
    ];
};
var $7de099632eb38088$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $7de099632eb38088$export$efed13b5d0ca3386;
    var offsets = $7de099632eb38088$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $8f2b0eea63abe6d4$var$Style = (0, $996e45e8f5a87a39$export$c1248ee86ba532c8)();
var $8f2b0eea63abe6d4$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $8f2b0eea63abe6d4$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $9171bdae475972c7$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($8f2b0eea63abe6d4$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $9171bdae475972c7$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $9171bdae475972c7$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $9171bdae475972c7$export$1da7500147d4bc3), " .").concat((0, $9171bdae475972c7$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $9171bdae475972c7$export$898e37bbd2a0ae4e), " .").concat((0, $9171bdae475972c7$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($8f2b0eea63abe6d4$export$65254d5f26cb9564, "] {\n    ").concat((0, $9171bdae475972c7$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $8f2b0eea63abe6d4$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($8f2b0eea63abe6d4$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $8f2b0eea63abe6d4$export$a1939b1f9f9b02dc = function() {
    $denZA.useEffect(function() {
        document.body.setAttribute($8f2b0eea63abe6d4$export$65254d5f26cb9564, ($8f2b0eea63abe6d4$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $8f2b0eea63abe6d4$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($8f2b0eea63abe6d4$export$65254d5f26cb9564);
            else document.body.setAttribute($8f2b0eea63abe6d4$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $8f2b0eea63abe6d4$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $8f2b0eea63abe6d4$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $denZA.useMemo(function() {
        return (0, $7de099632eb38088$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $denZA.createElement($8f2b0eea63abe6d4$var$Style, {
        styles: $8f2b0eea63abe6d4$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $ec8f6ca6607a1055$var$elementCouldBeVScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowY !== 'hidden' && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowY === 'visible' // scrollable
    );
};
var $ec8f6ca6607a1055$var$elementCouldBeHScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowX !== 'hidden' && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowX === 'visible' // scrollable
    );
};
var $ec8f6ca6607a1055$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        var isScrollable = $ec8f6ca6607a1055$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $ec8f6ca6607a1055$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $ec8f6ca6607a1055$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $ec8f6ca6607a1055$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $ec8f6ca6607a1055$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $ec8f6ca6607a1055$var$elementCouldBeVScrolled(node) : $ec8f6ca6607a1055$var$elementCouldBeHScrolled(node);
};
var $ec8f6ca6607a1055$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $ec8f6ca6607a1055$var$getVScrollVariables(node) : $ec8f6ca6607a1055$var$getHScrollVariables(node);
};
var $ec8f6ca6607a1055$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var delta = sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $ec8f6ca6607a1055$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - position;
        if (position || elementScroll) {
            if ($ec8f6ca6607a1055$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $7fb59dd819869ab4$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $7fb59dd819869ab4$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $7fb59dd819869ab4$var$passiveSupported = true;
            return true;
        }
    });
    window.addEventListener('test', $7fb59dd819869ab4$var$options, $7fb59dd819869ab4$var$options);
    window.removeEventListener('test', $7fb59dd819869ab4$var$options, $7fb59dd819869ab4$var$options);
} catch (err) {
    $7fb59dd819869ab4$var$passiveSupported = false;
}
var $7fb59dd819869ab4$export$10a6e88623fa9454 = $7fb59dd819869ab4$var$passiveSupported ? {
    passive: false
} : false;


var $229b167caa0abf62$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $229b167caa0abf62$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $229b167caa0abf62$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $229b167caa0abf62$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $229b167caa0abf62$var$generateStyle = function(id) {
    return "\n  .block-interactivity-" + id + " {pointer-events: none;}\n  .allow-interactivity-" + id + " {pointer-events: all;}\n";
};
var $229b167caa0abf62$var$idCounter = 0;
var $229b167caa0abf62$var$lockStack = [];
function $229b167caa0abf62$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $denZA.useRef([]);
    var touchStartRef = $denZA.useRef([
        0,
        0
    ]);
    var activeAxis = $denZA.useRef();
    var id = $denZA.useState($229b167caa0abf62$var$idCounter++)[0];
    var Style = $denZA.useState(function() {
        return (0, $996e45e8f5a87a39$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $denZA.useRef(props);
    $denZA.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $denZA.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-" + id);
            var allow_1 = [
                props.lockRef.current
            ].concat((props.shards || []).map($229b167caa0abf62$var$extractRef)).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-" + id);
            });
            return function() {
                document.body.classList.remove("block-interactivity-" + id);
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-" + id);
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $denZA.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $229b167caa0abf62$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        var canBeScrolledInMainDirection = (0, $ec8f6ca6607a1055$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $ec8f6ca6607a1055$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $ec8f6ca6607a1055$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $denZA.useCallback(function(_event) {
        var event = _event;
        if (!$229b167caa0abf62$var$lockStack.length || $229b167caa0abf62$var$lockStack[$229b167caa0abf62$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $229b167caa0abf62$export$39efaa2ca254a28d(event) : $229b167caa0abf62$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $229b167caa0abf62$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($229b167caa0abf62$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) event.preventDefault();
        }
    }, []);
    var shouldCancel = $denZA.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $denZA.useCallback(function(event) {
        touchStartRef.current = $229b167caa0abf62$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $denZA.useCallback(function(event) {
        shouldCancel(event.type, $229b167caa0abf62$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $denZA.useCallback(function(event) {
        shouldCancel(event.type, $229b167caa0abf62$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $denZA.useEffect(function() {
        $229b167caa0abf62$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
        return function() {
            $229b167caa0abf62$var$lockStack = $229b167caa0abf62$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $7fb59dd819869ab4$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $denZA.createElement($denZA.Fragment, null, inert ? $denZA.createElement(Style, {
        styles: $229b167caa0abf62$var$generateStyle(id)
    }) : null, removeScrollBar ? $denZA.createElement((0, $8f2b0eea63abe6d4$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $c35376d10bfb4f7e$export$2e2bcd8739ae039 = (0, $2860c6e294209cdc$export$6cacc8fb0a9b94ce)((0, $f27a15cba7acfd1a$export$e27363444bedfeac), (0, $229b167caa0abf62$export$a09dbff87b5da2d));


var $38f45be6def0294b$var$ReactRemoveScroll = $denZA.forwardRef(function(props, ref) {
    return $denZA.createElement((0, $4db3d6a0812cbd6a$export$22940b497e769dee), $bc501997ab3ea9a8$export$18ce0697a983be9b({}, props, {
        ref: ref,
        sideCar: (0, $c35376d10bfb4f7e$export$2e2bcd8739ae039)
    }));
});
$38f45be6def0294b$var$ReactRemoveScroll.classNames = (0, $4db3d6a0812cbd6a$export$22940b497e769dee).classNames;
var $38f45be6def0294b$export$2e2bcd8739ae039 = $38f45be6def0294b$var$ReactRemoveScroll;






var $denZA = parcelRequire("denZA");

function $361e546156173473$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $361e546156173473$var$_extends() {
    $361e546156173473$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $361e546156173473$var$_extends.apply(this, arguments);
}
var $361e546156173473$var$variants = {
    exit: (_ref)=>{
        var _transition$exit;
        var { reverse: reverse, initialScale: initialScale, transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref;
        return $361e546156173473$var$_extends({
            opacity: 0
        }, reverse ? {
            scale: initialScale,
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        } : {
            transitionEnd: $361e546156173473$var$_extends({
                scale: initialScale
            }, transitionEnd == null ? void 0 : transitionEnd.exit)
        }, {
            transition: (_transition$exit = transition == null ? void 0 : transition.exit) != null ? _transition$exit : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).exit, delay)
        });
    },
    enter: (_ref2)=>{
        var _transition$enter;
        var { transitionEnd: transitionEnd, transition: transition, delay: delay } = _ref2;
        return {
            opacity: 1,
            scale: 1,
            transition: (_transition$enter = transition == null ? void 0 : transition.enter) != null ? _transition$enter : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).enter((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $361e546156173473$export$9f21bb05021be18d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $361e546156173473$var$variants
};
var $361e546156173473$export$c9ef45b298456c94 = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, initialScale: initialScale = 0.95, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay } = props, rest = $361e546156173473$var$_objectWithoutPropertiesLoose(props, [
        "unmountOnExit",
        "in",
        "reverse",
        "initialScale",
        "className",
        "transition",
        "transitionEnd",
        "delay"
    ]);
    var show = unmountOnExit ? isOpen && unmountOnExit : true;
    var animate = isOpen || unmountOnExit ? "enter" : "exit";
    var custom = {
        initialScale: initialScale,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        custom: custom
    }, show && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, $361e546156173473$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-offset-slide", className)
    }, $361e546156173473$export$9f21bb05021be18d, {
        animate: animate,
        custom: custom
    }, rest)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $361e546156173473$export$c9ef45b298456c94.displayName = "ScaleFade";




var $denZA = parcelRequire("denZA");

function $fc0af9dc54a1ef5f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fc0af9dc54a1ef5f$var$_extends() {
    $fc0af9dc54a1ef5f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc0af9dc54a1ef5f$var$_extends.apply(this, arguments);
}
var $fc0af9dc54a1ef5f$var$variants = {
    initial: (_ref)=>{
        var _transition$exit;
        var { offsetX: offsetX, offsetY: offsetY, transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref;
        return {
            opacity: 0,
            x: offsetX,
            y: offsetY,
            transition: (_transition$exit = transition == null ? void 0 : transition.exit) != null ? _transition$exit : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: (_ref2)=>{
        var _transition$enter;
        var { transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref2;
        return {
            opacity: 1,
            x: 0,
            y: 0,
            transition: (_transition$enter = transition == null ? void 0 : transition.enter) != null ? _transition$enter : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).enter((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: (_ref3)=>{
        var _transition$exit2;
        var { offsetY: offsetY, offsetX: offsetX, transition: transition, transitionEnd: transitionEnd, reverse: reverse, delay: delay } = _ref3;
        var offset = {
            x: offsetX,
            y: offsetY
        };
        return $fc0af9dc54a1ef5f$var$_extends({
            opacity: 0,
            transition: (_transition$exit2 = transition == null ? void 0 : transition.exit) != null ? _transition$exit2 : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit((0, $211c36bc7cb0eba9$export$77d40b8ffce6f841).exit, delay)
        }, reverse ? $fc0af9dc54a1ef5f$var$_extends({}, offset, {
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        }) : {
            transitionEnd: $fc0af9dc54a1ef5f$var$_extends({}, offset, transitionEnd == null ? void 0 : transitionEnd.exit)
        });
    }
};
var $fc0af9dc54a1ef5f$export$153404f46b1af630 = {
    initial: "initial",
    animate: "enter",
    exit: "exit",
    variants: $fc0af9dc54a1ef5f$var$variants
};
var $fc0af9dc54a1ef5f$export$2c57c541d078cf9c = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, className: className, offsetX: offsetX = 0, offsetY: offsetY = 8, transition: transition, transitionEnd: transitionEnd, delay: delay } = props, rest = $fc0af9dc54a1ef5f$var$_objectWithoutPropertiesLoose(props, [
        "unmountOnExit",
        "in",
        "reverse",
        "className",
        "offsetX",
        "offsetY",
        "transition",
        "transitionEnd",
        "delay"
    ]);
    var show = unmountOnExit ? isOpen && unmountOnExit : true;
    var animate = isOpen || unmountOnExit ? "enter" : "exit";
    var custom = {
        offsetX: offsetX,
        offsetY: offsetY,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        custom: custom
    }, show && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, $fc0af9dc54a1ef5f$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-offset-slide", className),
        custom: custom
    }, $fc0af9dc54a1ef5f$export$153404f46b1af630, {
        animate: animate
    }, rest)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $fc0af9dc54a1ef5f$export$2c57c541d078cf9c.displayName = "SlideFade";




var $denZA = parcelRequire("denZA");
function $7299392c3953452a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7299392c3953452a$var$_extends() {
    $7299392c3953452a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7299392c3953452a$var$_extends.apply(this, arguments);
}
var $7299392c3953452a$var$transitions = {
    slideInBottom: $7299392c3953452a$var$_extends({}, (0, $fc0af9dc54a1ef5f$export$153404f46b1af630), {
        custom: {
            offsetY: 16,
            reverse: true
        }
    }),
    slideInRight: $7299392c3953452a$var$_extends({}, (0, $fc0af9dc54a1ef5f$export$153404f46b1af630), {
        custom: {
            offsetX: 16,
            reverse: true
        }
    }),
    scale: $7299392c3953452a$var$_extends({}, (0, $361e546156173473$export$9f21bb05021be18d), {
        custom: {
            initialScale: 0.95,
            reverse: true
        }
    }),
    none: {}
};
var $7299392c3953452a$var$Motion = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)((0, $92af15db400e8627$export$e25e478948902b8b).section);
var $7299392c3953452a$export$f0a3ab1cc2e7e9a6 = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { preset: preset } = props, rest = $7299392c3953452a$var$_objectWithoutPropertiesLoose(props, [
        "preset"
    ]);
    var motionProps = $7299392c3953452a$var$transitions[preset];
    return /*#__PURE__*/ $denZA.createElement($7299392c3953452a$var$Motion, $7299392c3953452a$var$_extends({
        ref: ref
    }, motionProps, rest));
});





var $932dd355ce71c882$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $932dd355ce71c882$var$counterMap = new WeakMap();
var $932dd355ce71c882$var$uncontrolledNodes = new WeakMap();
var $932dd355ce71c882$var$markerMap = {};
var $932dd355ce71c882$var$lockCount = 0;
var $932dd355ce71c882$var$unwrapHost = function(node) {
    return node && (node.host || $932dd355ce71c882$var$unwrapHost(node.parentNode));
};
var $932dd355ce71c882$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $932dd355ce71c882$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $932dd355ce71c882$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $932dd355ce71c882$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$932dd355ce71c882$var$markerMap[markerName]) $932dd355ce71c882$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $932dd355ce71c882$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($932dd355ce71c882$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $932dd355ce71c882$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $932dd355ce71c882$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $932dd355ce71c882$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $932dd355ce71c882$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $932dd355ce71c882$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$932dd355ce71c882$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $932dd355ce71c882$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $932dd355ce71c882$var$lockCount--;
        if (!$932dd355ce71c882$var$lockCount) {
            // clear
            $932dd355ce71c882$var$counterMap = new WeakMap();
            $932dd355ce71c882$var$counterMap = new WeakMap();
            $932dd355ce71c882$var$uncontrolledNodes = new WeakMap();
            $932dd355ce71c882$var$markerMap = {};
        }
    };
};
var $932dd355ce71c882$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $932dd355ce71c882$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $932dd355ce71c882$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $932dd355ce71c882$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $932dd355ce71c882$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $932dd355ce71c882$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $932dd355ce71c882$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $932dd355ce71c882$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($932dd355ce71c882$export$cc95fea82d705fca() ? $932dd355ce71c882$export$59151cc8db999a24 : $932dd355ce71c882$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
function $54a3468e0e2c0751$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Proper state management for nested modals.
 * Simplified, but inspired by material-ui's ModalManager class.
 */ class $54a3468e0e2c0751$var$ModalManager {
    constructor(){
        $54a3468e0e2c0751$var$_defineProperty(this, "modals", void 0);
        this.modals = [];
    }
    add(modal) {
        this.modals.push(modal);
    }
    remove(modal) {
        this.modals = this.modals.filter((_modal)=>_modal !== modal);
    }
    isTopModal(modal) {
        var topmostModal = this.modals[this.modals.length - 1];
        return topmostModal === modal;
    }
}
var $54a3468e0e2c0751$export$a6385bddcc8e6b77 = new $54a3468e0e2c0751$var$ModalManager();
function $54a3468e0e2c0751$export$8557a94b9bb25060(ref, isOpen) {
    (0, $denZA.useEffect)(()=>{
        if (isOpen) $54a3468e0e2c0751$export$a6385bddcc8e6b77.add(ref);
        return ()=>{
            $54a3468e0e2c0751$export$a6385bddcc8e6b77.remove(ref);
        };
    }, [
        isOpen,
        ref
    ]);
}


function $074386e0141564ea$var$_extends() {
    $074386e0141564ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $074386e0141564ea$var$_extends.apply(this, arguments);
}
function $074386e0141564ea$export$33ffd74ebf07f060(props) {
    var { isOpen: isOpen, onClose: onClose, id: id, closeOnOverlayClick: closeOnOverlayClick = true, closeOnEsc: closeOnEsc = true, useInert: useInert = true, onOverlayClick: onOverlayClickProp, onEsc: onEsc } = props;
    var dialogRef = (0, $denZA.useRef)(null);
    var overlayRef = (0, $denZA.useRef)(null);
    var [dialogId, headerId, bodyId] = (0, $63207b263e1aef60$export$365c04e2f432779)(id, "chakra-modal", "chakra-modal--header", "chakra-modal--body");
    /**
   * Hook used to polyfill `aria-modal` for older browsers.
   * It uses `aria-hidden` to all other nodes.
   *
   * @see https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
   */ $074386e0141564ea$export$bf01aaa71a18e30b(dialogRef, isOpen && useInert);
    /**
   * Hook use to manage multiple or nested modals
   */ (0, $54a3468e0e2c0751$export$8557a94b9bb25060)(dialogRef, isOpen);
    var mouseDownTarget = (0, $denZA.useRef)(null);
    var onMouseDown = (0, $denZA.useCallback)((event)=>{
        mouseDownTarget.current = event.target;
    }, []);
    var onKeyDown = (0, $denZA.useCallback)((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            if (closeOnEsc) onClose == null || onClose();
            onEsc == null || onEsc();
        }
    }, [
        closeOnEsc,
        onClose,
        onEsc
    ]);
    var [headerMounted, setHeaderMounted] = (0, $denZA.useState)(false);
    var [bodyMounted, setBodyMounted] = (0, $denZA.useState)(false);
    var getDialogProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $074386e0141564ea$var$_extends({
            role: "dialog"
        }, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, dialogRef),
            id: dialogId,
            tabIndex: -1,
            "aria-modal": true,
            "aria-labelledby": headerMounted ? headerId : undefined,
            "aria-describedby": bodyMounted ? bodyId : undefined,
            onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, (event)=>event.stopPropagation())
        });
    }, [
        bodyId,
        bodyMounted,
        dialogId,
        headerId,
        headerMounted
    ]);
    var onOverlayClick = (0, $denZA.useCallback)((event)=>{
        event.stopPropagation();
        /**
     * Make sure the event starts and ends on the same DOM element.
     *
     * This is used to prevent the modal from closing when you
     * start dragging from the content, and release drag outside the content.
     *
     * We prevent this because it is technically not a considered "click outside"
     */ if (mouseDownTarget.current !== event.target) return;
        /**
     * When you click on the overlay, we want to remove only the topmost modal
     */ if (!(0, $54a3468e0e2c0751$export$a6385bddcc8e6b77).isTopModal(dialogRef)) return;
        if (closeOnOverlayClick) onClose == null || onClose();
        onOverlayClickProp == null || onOverlayClickProp();
    }, [
        onClose,
        closeOnOverlayClick,
        onOverlayClickProp
    ]);
    var getDialogContainerProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $074386e0141564ea$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, overlayRef),
            onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onOverlayClick),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown),
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, onMouseDown)
        });
    }, [
        onKeyDown,
        onMouseDown,
        onOverlayClick
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        headerId: headerId,
        bodyId: bodyId,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        dialogRef: dialogRef,
        overlayRef: overlayRef,
        getDialogProps: getDialogProps,
        getDialogContainerProps: getDialogContainerProps
    };
}
function $074386e0141564ea$export$bf01aaa71a18e30b(ref, shouldHide) {
    (0, $denZA.useEffect)(()=>{
        if (!ref.current) return undefined;
        var undo = null;
        if (shouldHide && ref.current) undo = (0, $932dd355ce71c882$export$6e33d16126ed003c)(ref.current);
        return ()=>{
            if (shouldHide) undo == null || undo();
        };
    }, [
        shouldHide,
        ref
    ]);
}


function $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f1dbd08245d68867$var$_extends() {
    $f1dbd08245d68867$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f1dbd08245d68867$var$_extends.apply(this, arguments);
}
var [$f1dbd08245d68867$export$7c9538f5f3c365e9, $f1dbd08245d68867$export$4cc1699d46f42cae] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
var $f1dbd08245d68867$export$2b77a92f1a5ad772 = (props)=>{
    var { portalProps: portalProps, children: children, autoFocus: autoFocus, trapFocus: trapFocus, initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, preserveScrollBarGap: preserveScrollBarGap, motionPreset: motionPreset, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Modal", props);
    var modal = (0, $074386e0141564ea$export$33ffd74ebf07f060)(props);
    var context = $f1dbd08245d68867$var$_extends({}, modal, {
        autoFocus: autoFocus,
        trapFocus: trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        returnFocusOnClose: returnFocusOnClose,
        blockScrollOnMount: blockScrollOnMount,
        allowPinchZoom: allowPinchZoom,
        preserveScrollBarGap: preserveScrollBarGap,
        motionPreset: motionPreset,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    });
    return /*#__PURE__*/ $denZA.createElement($f1dbd08245d68867$export$7c9538f5f3c365e9, {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), null, context.isOpen && /*#__PURE__*/ $denZA.createElement((0, $ca7b6815c1fde9de$export$602eac185826482c), portalProps, children))));
};
$f1dbd08245d68867$export$2b77a92f1a5ad772.defaultProps = {
    lockFocusAcrossFrames: true,
    returnFocusOnClose: true,
    scrollBehavior: "outside",
    trapFocus: true,
    autoFocus: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    motionPreset: "scale"
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$2b77a92f1a5ad772.displayName = "Modal";
var $f1dbd08245d68867$var$MotionDiv = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)((0, $92af15db400e8627$export$e25e478948902b8b).div);
var $f1dbd08245d68867$export$6da19a24bf249f17 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className, children: children, containerProps: rootProps } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "children",
        "containerProps"
    ]);
    var { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    var dialogProps = getDialogProps(rest, ref);
    var containerProps = getDialogContainerProps(rootProps);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__content", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var dialogStyles = $f1dbd08245d68867$var$_extends({
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0
    }, styles.dialog);
    var dialogContainerStyles = $f1dbd08245d68867$var$_extends({
        display: "flex",
        width: "100vw",
        height: "100vh",
        "@supports(height: -webkit-fill-available)": {
            height: "-webkit-fill-available"
        },
        position: "fixed",
        left: 0,
        top: 0
    }, styles.dialogContainer);
    var { motionPreset: motionPreset } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    return /*#__PURE__*/ $denZA.createElement($f1dbd08245d68867$export$ffa1d90344e68399, null, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f1dbd08245d68867$var$_extends({}, containerProps, {
        className: "chakra-modal__content-container",
        __css: dialogContainerStyles
    }), /*#__PURE__*/ $denZA.createElement((0, $7299392c3953452a$export$f0a3ab1cc2e7e9a6), $f1dbd08245d68867$var$_extends({
        preset: motionPreset,
        className: _className
    }, dialogProps, {
        __css: dialogStyles
    }), children)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$6da19a24bf249f17.displayName = "ModalContent";
function $f1dbd08245d68867$export$ffa1d90344e68399(props) {
    var { autoFocus: autoFocus, trapFocus: trapFocus, dialogRef: dialogRef, initialFocusRef: initialFocusRef, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, preserveScrollBarGap: preserveScrollBarGap, lockFocusAcrossFrames: lockFocusAcrossFrames } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    var [isPresent, safeToRemove] = (0, $fa7d48d3f8d00960$export$2a8c16d82a0a0e26)();
    $denZA.useEffect(()=>{
        if (!isPresent && safeToRemove) setTimeout(safeToRemove);
    }, [
        isPresent,
        safeToRemove
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $5dc5772c85271349$export$ae70e1f3be7e1299), {
        autoFocus: autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    }, /*#__PURE__*/ $denZA.createElement((0, $38f45be6def0294b$export$2e2bcd8739ae039), {
        removeScrollBar: !preserveScrollBarGap,
        allowPinchZoom: allowPinchZoom,
        enabled: blockScrollOnMount,
        forwardProps: true
    }, props.children));
}
var $f1dbd08245d68867$export$8948f78d83984c69 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "transition"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__overlay", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var overlayStyle = $f1dbd08245d68867$var$_extends({
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh"
    }, styles.overlay);
    var { motionPreset: motionPreset } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    var motionProps = motionPreset === "none" ? {} : (0, $354a231a840f8497$export$4342735ea5c231d);
    return /*#__PURE__*/ $denZA.createElement($f1dbd08245d68867$var$MotionDiv, $f1dbd08245d68867$var$_extends({}, motionProps, {
        __css: overlayStyle,
        ref: ref,
        className: _className
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$8948f78d83984c69.displayName = "ModalOverlay";
var $f1dbd08245d68867$export$f50a68e3694789ee = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var { headerId: headerId, setHeaderMounted: setHeaderMounted } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    /**
   * Notify us if this component was rendered or used
   * so we can append `aria-labelledby` automatically
   */ $denZA.useEffect(()=>{
        setHeaderMounted(true);
        return ()=>setHeaderMounted(false);
    }, [
        setHeaderMounted
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__header", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var headerStyles = $f1dbd08245d68867$var$_extends({
        flex: 0
    }, styles.header);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).header, $f1dbd08245d68867$var$_extends({
        ref: ref,
        className: _className,
        id: headerId
    }, rest, {
        __css: headerStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$f50a68e3694789ee.displayName = "ModalHeader";
var $f1dbd08245d68867$export$cb540d8b0ef7906c = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var { bodyId: bodyId, setBodyMounted: setBodyMounted } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    /**
   * Notify us if this component was rendered or used
   * so we can append `aria-describedby` automatically
   */ $denZA.useEffect(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__body", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f1dbd08245d68867$var$_extends({
        ref: ref,
        className: _className,
        id: bodyId
    }, rest, {
        __css: styles.body
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$cb540d8b0ef7906c.displayName = "ModalBody";
var $f1dbd08245d68867$export$519437715052e656 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__footer", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var footerStyles = $f1dbd08245d68867$var$_extends({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    }, styles.footer);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).footer, $f1dbd08245d68867$var$_extends({
        ref: ref
    }, rest, {
        __css: footerStyles,
        className: _className
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$519437715052e656.displayName = "ModalFooter";
var $f1dbd08245d68867$export$edf9108895ba774f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { onClick: onClick, className: className } = props, rest = $f1dbd08245d68867$var$_objectWithoutPropertiesLoose(props, [
        "onClick",
        "className"
    ]);
    var { onClose: onClose } = $f1dbd08245d68867$export$4cc1699d46f42cae();
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__close-btn", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $16e5382b11479a26$export$de65de8213222d10), $f1dbd08245d68867$var$_extends({
        ref: ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onClick, (event)=>{
            event.stopPropagation();
            onClose();
        })
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f1dbd08245d68867$export$edf9108895ba774f.displayName = "ModalCloseButton";




var $denZA = parcelRequire("denZA");
var $6751c3985a7461b7$var$__assign = undefined && undefined.__assign || function() {
    $6751c3985a7461b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6751c3985a7461b7$var$__assign.apply(this, arguments);
};
var $6751c3985a7461b7$export$4ed8420cdfcb2b8f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$cb540d8b0ef7906c), $6751c3985a7461b7$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $633ea0011145450b$var$__assign = undefined && undefined.__assign || function() {
    $633ea0011145450b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $633ea0011145450b$var$__assign.apply(this, arguments);
};
var $633ea0011145450b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $633ea0011145450b$export$d0c3a75c17ac0cab = function(_a) {
    var onClick = _a.onClick, rest = $633ea0011145450b$var$__rest(_a, [
        "onClick"
    ]);
    var onClose = (0, $f1dbd08245d68867$export$4cc1699d46f42cae)().onClose;
    return $denZA.createElement((0, $be26eda9b41db083$export$de65de8213222d10), $633ea0011145450b$var$__assign({
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onClick, function(event) {
            event.stopPropagation();
            onClose();
        }),
        position: "absolute",
        right: "0",
        top: "0"
    }, rest));
};






var $denZA = parcelRequire("denZA");

function $2851c06d7dd17f4f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2851c06d7dd17f4f$var$_extends() {
    $2851c06d7dd17f4f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2851c06d7dd17f4f$var$_extends.apply(this, arguments);
}
var $2851c06d7dd17f4f$var$defaultTransition = {
    exit: {
        duration: 0.15,
        ease: (0, $211c36bc7cb0eba9$export$f5b6cb31aedd80b0).easeInOut
    },
    enter: {
        type: "spring",
        damping: 25,
        stiffness: 180
    }
};
var $2851c06d7dd17f4f$var$variants = {
    exit: (_ref)=>{
        var _transition$exit;
        var { direction: direction, transition: transition, transitionEnd: transitionEnd, delay: delay } = _ref;
        var { exit: exitStyles } = (0, $211c36bc7cb0eba9$export$938a85570760a707)({
            direction: direction
        });
        return $2851c06d7dd17f4f$var$_extends({}, exitStyles, {
            transition: (_transition$exit = transition == null ? void 0 : transition.exit) != null ? _transition$exit : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).exit($2851c06d7dd17f4f$var$defaultTransition.exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        });
    },
    enter: (_ref2)=>{
        var _transition$enter;
        var { direction: direction, transitionEnd: transitionEnd, transition: transition, delay: delay } = _ref2;
        var { enter: enterStyles } = (0, $211c36bc7cb0eba9$export$938a85570760a707)({
            direction: direction
        });
        return $2851c06d7dd17f4f$var$_extends({}, enterStyles, {
            transition: (_transition$enter = transition == null ? void 0 : transition.enter) != null ? _transition$enter : (0, $211c36bc7cb0eba9$export$fc492bd0f1c91c).enter($2851c06d7dd17f4f$var$defaultTransition.enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        });
    }
};
var $2851c06d7dd17f4f$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { direction: direction = "right", style: style, unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay } = props, rest = $2851c06d7dd17f4f$var$_objectWithoutPropertiesLoose(props, [
        "direction",
        "style",
        "unmountOnExit",
        "in",
        "className",
        "transition",
        "transitionEnd",
        "delay"
    ]);
    var transitionStyles = (0, $211c36bc7cb0eba9$export$938a85570760a707)({
        direction: direction
    });
    var computedStyle = Object.assign({
        position: "fixed"
    }, transitionStyles.position, style);
    var show = unmountOnExit ? isOpen && unmountOnExit : true;
    var animate = isOpen || unmountOnExit ? "enter" : "exit";
    var custom = {
        transitionEnd: transitionEnd,
        transition: transition,
        direction: direction,
        delay: delay
    };
    return /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
        custom: custom
    }, show && /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).div, $2851c06d7dd17f4f$var$_extends({
        ref: ref,
        initial: "exit",
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-slide", className),
        animate: animate,
        exit: "exit",
        custom: custom,
        variants: $2851c06d7dd17f4f$var$variants,
        style: computedStyle
    }, rest)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $2851c06d7dd17f4f$export$d8dc01b5c85a37b9.displayName = "Slide";





var $denZA = parcelRequire("denZA");

function $eebf2a468d70ee91$var$_extends() {
    $eebf2a468d70ee91$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eebf2a468d70ee91$var$_extends.apply(this, arguments);
}
function $eebf2a468d70ee91$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$eebf2a468d70ee91$var$DrawerContextProvider, $eebf2a468d70ee91$var$useDrawerContext] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)();
function $eebf2a468d70ee91$export$4071300121a182f5(props) {
    var _theme$components;
    var { isOpen: isOpen, onClose: onClose, placement: placement = "right", children: children } = props, rest = $eebf2a468d70ee91$var$_objectWithoutPropertiesLoose(props, [
        "isOpen",
        "onClose",
        "placement",
        "children"
    ]);
    var theme = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    var drawerStyleConfig = (_theme$components = theme.components) == null ? void 0 : _theme$components.Drawer;
    return /*#__PURE__*/ $denZA.createElement($eebf2a468d70ee91$var$DrawerContextProvider, {
        value: {
            placement: placement
        }
    }, /*#__PURE__*/ $denZA.createElement((0, $f1dbd08245d68867$export$2b77a92f1a5ad772), $eebf2a468d70ee91$var$_extends({
        isOpen: isOpen,
        onClose: onClose,
        styleConfig: drawerStyleConfig
    }, rest), children));
}
var $eebf2a468d70ee91$var$StyleSlide = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)((0, $2851c06d7dd17f4f$export$d8dc01b5c85a37b9));
var $eebf2a468d70ee91$export$57ca055474bc0056 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className, children: children } = props, rest = $eebf2a468d70ee91$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "children"
    ]);
    var { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps, isOpen: isOpen } = (0, $f1dbd08245d68867$export$4cc1699d46f42cae)();
    var dialogProps = getDialogProps(rest, ref);
    var containerProps = getDialogContainerProps();
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-modal__content", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var dialogStyles = $eebf2a468d70ee91$var$_extends({
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0
    }, styles.dialog);
    var dialogContainerStyles = $eebf2a468d70ee91$var$_extends({
        display: "flex",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0
    }, styles.dialogContainer);
    var { placement: placement } = $eebf2a468d70ee91$var$useDrawerContext();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $eebf2a468d70ee91$var$_extends({}, containerProps, {
        className: "chakra-modal__content-container",
        __css: dialogContainerStyles
    }), /*#__PURE__*/ $denZA.createElement((0, $f1dbd08245d68867$export$ffa1d90344e68399), null, /*#__PURE__*/ $denZA.createElement($eebf2a468d70ee91$var$StyleSlide, $eebf2a468d70ee91$var$_extends({
        direction: placement,
        in: isOpen,
        className: _className
    }, dialogProps, {
        __css: dialogStyles
    }), children)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $eebf2a468d70ee91$export$57ca055474bc0056.displayName = "DrawerContent";




var $denZA = parcelRequire("denZA");
var $0133d820be70e8e4$var$__assign = undefined && undefined.__assign || function() {
    $0133d820be70e8e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0133d820be70e8e4$var$__assign.apply(this, arguments);
};
var $0133d820be70e8e4$export$57ca055474bc0056 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $eebf2a468d70ee91$export$57ca055474bc0056), $0133d820be70e8e4$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $3ebed3a37c8f5b75$var$__assign = undefined && undefined.__assign || function() {
    $3ebed3a37c8f5b75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3ebed3a37c8f5b75$var$__assign.apply(this, arguments);
};
var $3ebed3a37c8f5b75$export$d05a7d25ec5abf06 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$519437715052e656), $3ebed3a37c8f5b75$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $7301097f348dd8b1$var$__assign = undefined && undefined.__assign || function() {
    $7301097f348dd8b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7301097f348dd8b1$var$__assign.apply(this, arguments);
};
var $7301097f348dd8b1$export$bb68d554ded258ea = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$f50a68e3694789ee), $7301097f348dd8b1$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $90c60574b1d8f75f$var$__assign = undefined && undefined.__assign || function() {
    $90c60574b1d8f75f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90c60574b1d8f75f$var$__assign.apply(this, arguments);
};
var $90c60574b1d8f75f$export$ac2f3b6686941bb7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$8948f78d83984c69), $90c60574b1d8f75f$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");






var $8503f6733999b39f$var$__assign = undefined && undefined.__assign || function() {
    $8503f6733999b39f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8503f6733999b39f$var$__assign.apply(this, arguments);
};
var $8503f6733999b39f$export$4071300121a182f5 = function(props) {
    return $denZA.createElement((0, $eebf2a468d70ee91$export$4071300121a182f5), $8503f6733999b39f$var$__assign({}, props));
};
$8503f6733999b39f$export$4071300121a182f5.Body = (0, $6751c3985a7461b7$export$4ed8420cdfcb2b8f);
$8503f6733999b39f$export$4071300121a182f5.CloseButton = (0, $633ea0011145450b$export$d0c3a75c17ac0cab);
$8503f6733999b39f$export$4071300121a182f5.Content = (0, $0133d820be70e8e4$export$57ca055474bc0056);
$8503f6733999b39f$export$4071300121a182f5.Footer = (0, $3ebed3a37c8f5b75$export$d05a7d25ec5abf06);
$8503f6733999b39f$export$4071300121a182f5.Header = (0, $7301097f348dd8b1$export$bb68d554ded258ea);
$8503f6733999b39f$export$4071300121a182f5.Overlay = (0, $90c60574b1d8f75f$export$ac2f3b6686941bb7);


var $87194be60a95069d$export$4ed8420cdfcb2b8f = (0, $6751c3985a7461b7$export$4ed8420cdfcb2b8f);
var $87194be60a95069d$export$d0c3a75c17ac0cab = (0, $633ea0011145450b$export$d0c3a75c17ac0cab);
var $87194be60a95069d$export$57ca055474bc0056 = (0, $0133d820be70e8e4$export$57ca055474bc0056);
var $87194be60a95069d$export$d05a7d25ec5abf06 = (0, $3ebed3a37c8f5b75$export$d05a7d25ec5abf06);
var $87194be60a95069d$export$bb68d554ded258ea = (0, $7301097f348dd8b1$export$bb68d554ded258ea);
var $87194be60a95069d$export$ac2f3b6686941bb7 = (0, $90c60574b1d8f75f$export$ac2f3b6686941bb7);




var $denZA = parcelRequire("denZA");
var $8bcbd6d809014083$var$__assign = undefined && undefined.__assign || function() {
    $8bcbd6d809014083$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8bcbd6d809014083$var$__assign.apply(this, arguments);
};
var $8bcbd6d809014083$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8bcbd6d809014083$export$1a5cb5295a7d2749 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var rest = $8bcbd6d809014083$var$__rest((0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), []);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('FileUploader', rest);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $8bcbd6d809014083$var$__assign({
        ref: ref,
        sx: styles
    }, rest));
});







var $denZA = parcelRequire("denZA");
function $7aa7fb978b4f3801$var$_extends() {
    $7aa7fb978b4f3801$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7aa7fb978b4f3801$var$_extends.apply(this, arguments);
}
function $7aa7fb978b4f3801$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7aa7fb978b4f3801$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink } = props, rest = $7aa7fb978b4f3801$var$_objectWithoutPropertiesLoose(props, [
        "direction",
        "align",
        "justify",
        "wrap",
        "basis",
        "grow",
        "shrink"
    ]);
    var styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $7aa7fb978b4f3801$var$_extends({
        ref: ref,
        __css: styles
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7aa7fb978b4f3801$export$f51f4c4ede09e011.displayName = "Flex";




var $denZA = parcelRequire("denZA");
var $e8774d37179bb387$var$__assign = undefined && undefined.__assign || function() {
    $e8774d37179bb387$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8774d37179bb387$var$__assign.apply(this, arguments);
};
var $e8774d37179bb387$export$f51f4c4ede09e011 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $7aa7fb978b4f3801$export$f51f4c4ede09e011), $e8774d37179bb387$var$__assign({}, props, {
        ref: ref
    }));
});








var $denZA = parcelRequire("denZA");





var $denZA = parcelRequire("denZA");
function $e6d2b7519c1f29c8$var$_extends() {
    $e6d2b7519c1f29c8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6d2b7519c1f29c8$var$_extends.apply(this, arguments);
}
function $e6d2b7519c1f29c8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$e6d2b7519c1f29c8$var$FormControlProvider, $e6d2b7519c1f29c8$export$97a2352498389516] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: false,
    name: "FormControlContext"
});
function $e6d2b7519c1f29c8$var$useFormControlProvider(props) {
    var { id: idProp, isRequired: isRequired, isInvalid: isInvalid, isDisabled: isDisabled, isReadOnly: isReadOnly } = props, htmlProps = $e6d2b7519c1f29c8$var$_objectWithoutPropertiesLoose(props, [
        "id",
        "isRequired",
        "isInvalid",
        "isDisabled",
        "isReadOnly"
    ]); // Generate all the required ids
    var uuid = (0, $63207b263e1aef60$export$f680877a34711e37)();
    var id = idProp || "field-" + uuid;
    var labelId = id + "-label";
    var feedbackId = id + "-feedback";
    var helpTextId = id + "-helptext";
    /**
   * Track whether the `FormErrorMessage` has been rendered.
   * We use this to append its id the the `aria-describedby` of the `input`.
   */ var [hasFeedbackText, setHasFeedbackText] = $denZA.useState(false);
    /**
   * Track whether the `FormHelperText` has been rendered.
   * We use this to append its id the the `aria-describedby` of the `input`.
   */ var [hasHelpText, setHasHelpText] = $denZA.useState(false); // Track whether the form element (e.g, `input`) has focus.
    var [isFocused, setFocus] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var getHelpTextProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $e6d2b7519c1f29c8$var$_extends({
            id: helpTextId
        }, props, {
            /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasHelpText(true);
            })
        });
    }, [
        helpTextId
    ]);
    var getLabelProps = $denZA.useCallback(function(props, forwardedRef) {
        var _props$id, _props$htmlFor;
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $e6d2b7519c1f29c8$var$_extends({}, props, {
            ref: forwardedRef,
            "data-focus": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isReadOnly),
            id: (_props$id = props.id) != null ? _props$id : labelId,
            htmlFor: (_props$htmlFor = props.htmlFor) != null ? _props$htmlFor : id
        });
    }, [
        id,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly,
        labelId
    ]);
    var getErrorMessageProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $e6d2b7519c1f29c8$var$_extends({
            id: feedbackId
        }, props, {
            /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasFeedbackText(true);
            }),
            "aria-live": "polite"
        });
    }, [
        feedbackId
    ]);
    var getRootProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $e6d2b7519c1f29c8$var$_extends({}, props, htmlProps, {
            ref: forwardedRef,
            role: "group"
        });
    }, [
        htmlProps
    ]);
    var getRequiredIndicatorProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $e6d2b7519c1f29c8$var$_extends({}, props, {
            ref: forwardedRef,
            role: "presentation",
            "aria-hidden": true,
            children: props.children || "*"
        });
    }, []);
    return {
        isRequired: !!isRequired,
        isInvalid: !!isInvalid,
        isReadOnly: !!isReadOnly,
        isDisabled: !!isDisabled,
        isFocused: !!isFocused,
        onFocus: setFocus.on,
        onBlur: setFocus.off,
        hasFeedbackText: hasFeedbackText,
        setHasFeedbackText: setHasFeedbackText,
        hasHelpText: hasHelpText,
        setHasHelpText: setHasHelpText,
        id: id,
        labelId: labelId,
        feedbackId: feedbackId,
        helpTextId: helpTextId,
        htmlProps: htmlProps,
        getHelpTextProps: getHelpTextProps,
        getErrorMessageProps: getErrorMessageProps,
        getRootProps: getRootProps,
        getLabelProps: getLabelProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
}
var $e6d2b7519c1f29c8$export$fe5d99d8691b3f62 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Form", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var _useFormControlProvid = $e6d2b7519c1f29c8$var$useFormControlProvider(ownProps), { getRootProps: getRootProps } = _useFormControlProvid, context = $e6d2b7519c1f29c8$var$_objectWithoutPropertiesLoose(_useFormControlProvid, [
        "getRootProps",
        "htmlProps"
    ]);
    var className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form-control", props.className);
    var contextValue = $denZA.useMemo(()=>context, [
        context
    ]);
    return /*#__PURE__*/ $denZA.createElement($e6d2b7519c1f29c8$var$FormControlProvider, {
        value: contextValue
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $e6d2b7519c1f29c8$var$_extends({}, getRootProps({}, ref), {
        className: className,
        __css: styles["container"]
    }))));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e6d2b7519c1f29c8$export$fe5d99d8691b3f62.displayName = "FormControl";
var $e6d2b7519c1f29c8$export$75f9ed82f6172e27 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var field = $e6d2b7519c1f29c8$export$97a2352498389516();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form__helper-text", props.className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $e6d2b7519c1f29c8$var$_extends({}, field == null ? void 0 : field.getHelpTextProps(props, ref), {
        __css: styles.helperText,
        className: className
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e6d2b7519c1f29c8$export$75f9ed82f6172e27.displayName = "FormHelperText";


function $c5b559c563f5afd9$var$_extends() {
    $c5b559c563f5afd9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c5b559c563f5afd9$var$_extends.apply(this, arguments);
}
var $c5b559c563f5afd9$export$185a8afe504e8fca = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("FormError", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var field = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    if (!(field != null && field.isInvalid)) return null;
    return /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c5b559c563f5afd9$var$_extends({}, field == null ? void 0 : field.getErrorMessageProps(ownProps, ref), {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form__error-message", props.className),
        __css: $c5b559c563f5afd9$var$_extends({
            display: "flex",
            alignItems: "center"
        }, styles.text)
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c5b559c563f5afd9$export$185a8afe504e8fca.displayName = "FormErrorMessage";
var $c5b559c563f5afd9$export$67864f4c98b1437d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var field = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    if (!(field != null && field.isInvalid)) return null;
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form__error-icon", props.className);
    return /*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$2e2bcd8739ae039), $c5b559c563f5afd9$var$_extends({
        ref: ref,
        "aria-hidden": true
    }, props, {
        __css: styles.icon,
        className: _className
    }), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c5b559c563f5afd9$export$67864f4c98b1437d.displayName = "FormErrorIcon";


var $a487f78b4469ec2c$export$67864f4c98b1437d = (0, $c5b559c563f5afd9$export$67864f4c98b1437d);





var $denZA = parcelRequire("denZA");
var $163a85514d56ff0c$var$__assign = undefined && undefined.__assign || function() {
    $163a85514d56ff0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $163a85514d56ff0c$var$__assign.apply(this, arguments);
};
var $163a85514d56ff0c$export$185a8afe504e8fca = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c5b559c563f5afd9$export$185a8afe504e8fca), $163a85514d56ff0c$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $21876df99419295c$var$__assign = undefined && undefined.__assign || function() {
    $21876df99419295c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $21876df99419295c$var$__assign.apply(this, arguments);
};
var $21876df99419295c$export$75f9ed82f6172e27 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e6d2b7519c1f29c8$export$75f9ed82f6172e27), $21876df99419295c$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");

function $c6a8430fdc0e8e23$var$_extends() {
    $c6a8430fdc0e8e23$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6a8430fdc0e8e23$var$_extends.apply(this, arguments);
}
function $c6a8430fdc0e8e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c6a8430fdc0e8e23$export$842aba50ed0ce9d7 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((passedProps, ref)=>{
    var _field$getLabelProps;
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("FormLabel", passedProps);
    var props = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(passedProps);
    var { children: children, requiredIndicator: requiredIndicator = /*#__PURE__*/ $denZA.createElement($c6a8430fdc0e8e23$export$b36d93bade3250e4, null) } = props, rest = $c6a8430fdc0e8e23$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "children",
        "requiredIndicator"
    ]);
    var field = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    var ownProps = (_field$getLabelProps = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _field$getLabelProps : $c6a8430fdc0e8e23$var$_extends({
        ref: ref
    }, rest);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).label, $c6a8430fdc0e8e23$var$_extends({}, ownProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form__label", props.className),
        __css: $c6a8430fdc0e8e23$var$_extends({
            display: "block",
            textAlign: "start"
        }, styles)
    }), children, field != null && field.isRequired ? requiredIndicator : null);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c6a8430fdc0e8e23$export$842aba50ed0ce9d7.displayName = "FormLabel";
var $c6a8430fdc0e8e23$export$b36d93bade3250e4 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var field = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    if (!(field != null && field.isRequired)) return null;
    var className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-form__required-indicator", props.className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $c6a8430fdc0e8e23$var$_extends({}, field == null ? void 0 : field.getRequiredIndicatorProps(props, ref), {
        __css: styles.requiredIndicator,
        className: className
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c6a8430fdc0e8e23$export$b36d93bade3250e4.displayName = "RequiredIndicator";




var $denZA = parcelRequire("denZA");
var $addd9801e85f6b62$var$__assign = undefined && undefined.__assign || function() {
    $addd9801e85f6b62$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $addd9801e85f6b62$var$__assign.apply(this, arguments);
};
var $addd9801e85f6b62$export$842aba50ed0ce9d7 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c6a8430fdc0e8e23$export$842aba50ed0ce9d7), $addd9801e85f6b62$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");




var $c0b848ed89aca9f3$var$__assign = undefined && undefined.__assign || function() {
    $c0b848ed89aca9f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0b848ed89aca9f3$var$__assign.apply(this, arguments);
};
var $c0b848ed89aca9f3$export$fe5d99d8691b3f62 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e6d2b7519c1f29c8$export$fe5d99d8691b3f62), $c0b848ed89aca9f3$var$__assign({}, props, {
        ref: ref
    }));
});
$c0b848ed89aca9f3$export$fe5d99d8691b3f62.ErrorIcon = (0, $a487f78b4469ec2c$export$67864f4c98b1437d);
$c0b848ed89aca9f3$export$fe5d99d8691b3f62.ErrorMessage = (0, $163a85514d56ff0c$export$185a8afe504e8fca);
$c0b848ed89aca9f3$export$fe5d99d8691b3f62.HelperText = (0, $21876df99419295c$export$75f9ed82f6172e27);
$c0b848ed89aca9f3$export$fe5d99d8691b3f62.Label = (0, $addd9801e85f6b62$export$842aba50ed0ce9d7);


var $25cf7db786ec1aae$export$67864f4c98b1437d = (0, $a487f78b4469ec2c$export$67864f4c98b1437d);
var $25cf7db786ec1aae$export$185a8afe504e8fca = (0, $163a85514d56ff0c$export$185a8afe504e8fca);
var $25cf7db786ec1aae$export$75f9ed82f6172e27 = (0, $21876df99419295c$export$75f9ed82f6172e27);
var $25cf7db786ec1aae$export$842aba50ed0ce9d7 = (0, $addd9801e85f6b62$export$842aba50ed0ce9d7);





var $denZA = parcelRequire("denZA");
function $f119d9f7e38c56b7$var$_extends() {
    $f119d9f7e38c56b7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f119d9f7e38c56b7$var$_extends.apply(this, arguments);
}
function $f119d9f7e38c56b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f119d9f7e38c56b7$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { area: area, templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns } = props, rest = $f119d9f7e38c56b7$var$_objectWithoutPropertiesLoose(props, [
        "area",
        "templateAreas",
        "gap",
        "rowGap",
        "columnGap",
        "column",
        "row",
        "autoFlow",
        "autoRows",
        "templateRows",
        "autoColumns",
        "templateColumns"
    ]);
    var styles = {
        display: "grid",
        gridArea: area,
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f119d9f7e38c56b7$var$_extends({
        ref: ref,
        __css: styles
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f119d9f7e38c56b7$export$ef2184bd89960b14.displayName = "Grid";
function $f119d9f7e38c56b7$var$spanFn(span) {
    return (0, $e9414c504ba55072$export$eca1915781c2aaca)(span, (value)=>value === "auto" ? "auto" : "span " + value + "/span " + value);
}
var $f119d9f7e38c56b7$export$9eb849b9b922d396 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { colSpan: colSpan, colStart: colStart, colEnd: colEnd, rowEnd: rowEnd, rowSpan: rowSpan, rowStart: rowStart } = props, rest = $f119d9f7e38c56b7$var$_objectWithoutPropertiesLoose(props, [
        "colSpan",
        "colStart",
        "colEnd",
        "rowEnd",
        "rowSpan",
        "rowStart"
    ]);
    var styles = (0, $dfe73229adf076fd$export$2458ce75c8ef9806)({
        gridColumn: $f119d9f7e38c56b7$var$spanFn(colSpan),
        gridRow: $f119d9f7e38c56b7$var$spanFn(rowSpan),
        gridColumnStart: colStart,
        gridColumnEnd: colEnd,
        gridRowStart: rowStart,
        gridRowEnd: rowEnd
    });
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f119d9f7e38c56b7$var$_extends({
        ref: ref,
        __css: styles
    }, rest));
});




var $denZA = parcelRequire("denZA");
var $b174253420c42e4f$var$__assign = undefined && undefined.__assign || function() {
    $b174253420c42e4f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b174253420c42e4f$var$__assign.apply(this, arguments);
};
var $b174253420c42e4f$export$9eb849b9b922d396 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f119d9f7e38c56b7$export$9eb849b9b922d396), $b174253420c42e4f$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");

var $600fce241737f536$var$__assign = undefined && undefined.__assign || function() {
    $600fce241737f536$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $600fce241737f536$var$__assign.apply(this, arguments);
};
var $600fce241737f536$export$ef2184bd89960b14 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f119d9f7e38c56b7$export$ef2184bd89960b14), $600fce241737f536$var$__assign({}, props, {
        ref: ref
    }));
});
$600fce241737f536$export$ef2184bd89960b14.Item = (0, $b174253420c42e4f$export$9eb849b9b922d396);


var $3900a61357e44a3a$export$9eb849b9b922d396 = (0, $b174253420c42e4f$export$9eb849b9b922d396);







var $denZA = parcelRequire("denZA");

function $24c58d82814868c9$var$_extends() {
    $24c58d82814868c9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24c58d82814868c9$var$_extends.apply(this, arguments);
}
function $24c58d82814868c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $24c58d82814868c9$var$NativeImage = /*#__PURE__*/ $denZA.forwardRef((props, ref)=>{
    var { htmlWidth: htmlWidth, htmlHeight: htmlHeight, alt: alt } = props, rest = $24c58d82814868c9$var$_objectWithoutPropertiesLoose(props, [
        "htmlWidth",
        "htmlHeight",
        "alt"
    ]);
    return /*#__PURE__*/ $denZA.createElement("img", $24c58d82814868c9$var$_extends({
        width: htmlWidth,
        height: htmlHeight,
        ref: ref,
        alt: alt
    }, rest));
});
var $24c58d82814868c9$export$3e431a229df88919 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { fallbackSrc: fallbackSrc, fallback: fallback, src: src, align: align, fit: fit, loading: loading, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin } = props, rest = $24c58d82814868c9$var$_objectWithoutPropertiesLoose(props, [
        "fallbackSrc",
        "fallback",
        "src",
        "align",
        "fit",
        "loading",
        "ignoreFallback",
        "crossOrigin"
    ]);
    /**
   * Defer to native `img` tag if `loading` prop is passed
   * @see https://github.com/chakra-ui/chakra-ui/issues/1027
   */ var shouldIgnore = loading != null || ignoreFallback;
    var status = (0, $60af232ab8afcf31$export$e4da99f09da8b739)($24c58d82814868c9$var$_extends({}, props, {
        ignoreFallback: shouldIgnore
    }));
    var shared = $24c58d82814868c9$var$_extends({
        ref: ref,
        objectFit: fit,
        objectPosition: align
    }, shouldIgnore ? rest : (0, $dfe73229adf076fd$export$30a06c8d3562193f)(rest, [
        "onError",
        "onLoad"
    ]));
    if (status !== "loaded") {
        /**
     * If user passed a custom fallback component,
     * let's render it here.
     */ if (fallback) return fallback;
        return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).img, $24c58d82814868c9$var$_extends({
            as: $24c58d82814868c9$var$NativeImage,
            className: "chakra-image__placeholder",
            src: fallbackSrc
        }, shared));
    }
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).img, $24c58d82814868c9$var$_extends({
        as: $24c58d82814868c9$var$NativeImage,
        src: src,
        crossOrigin: crossOrigin,
        loading: loading,
        className: "chakra-image"
    }, shared));
});
var $24c58d82814868c9$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).img, $24c58d82814868c9$var$_extends({
        ref: ref,
        as: $24c58d82814868c9$var$NativeImage,
        className: "chakra-image"
    }, props)));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $24c58d82814868c9$export$3e431a229df88919.displayName = "Image";




var $denZA = parcelRequire("denZA");
var $6a36e4cc0cd2bdd8$var$__assign = undefined && undefined.__assign || function() {
    $6a36e4cc0cd2bdd8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6a36e4cc0cd2bdd8$var$__assign.apply(this, arguments);
};
var $6a36e4cc0cd2bdd8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6a36e4cc0cd2bdd8$var$FallbackImage = function(props) {
    return $denZA.createElement((0, $24c58d82814868c9$export$3e431a229df88919), $6a36e4cc0cd2bdd8$var$__assign({}, props, {
        src: "data:image/png;base64,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"
    }));
};
var $6a36e4cc0cd2bdd8$export$3e431a229df88919 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var fallbackSrc = _a.fallbackSrc, fallback = _a.fallback, rest = $6a36e4cc0cd2bdd8$var$__rest(_a, [
        "fallbackSrc",
        "fallback"
    ]);
    return $denZA.createElement((0, $24c58d82814868c9$export$3e431a229df88919), $6a36e4cc0cd2bdd8$var$__assign({}, !fallbackSrc ? {
        fallback: fallback !== null && fallback !== void 0 ? fallback : $denZA.createElement($6a36e4cc0cd2bdd8$var$FallbackImage, $6a36e4cc0cd2bdd8$var$__assign({}, rest))
    } : {
        fallbackSrc: fallbackSrc
    }, rest, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $4a80327f1d5cffac$var$__assign = undefined && undefined.__assign || function() {
    $4a80327f1d5cffac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4a80327f1d5cffac$var$__assign.apply(this, arguments);
};
var $4a80327f1d5cffac$export$cc7b5f925acc71d3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $24c58d82814868c9$export$cc7b5f925acc71d3), $4a80327f1d5cffac$var$__assign({}, props, {
        ref: ref
    }));
});







var $denZA = parcelRequire("denZA");
var $a1064900ad951468$var$__assign = undefined && undefined.__assign || function() {
    $a1064900ad951468$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1064900ad951468$var$__assign.apply(this, arguments);
};
var $a1064900ad951468$export$ed5a7a9c50541f68 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var contentStyles = $a1064900ad951468$var$__assign({
        display: 'inline'
    }, styles.content);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $a1064900ad951468$var$__assign({
        ref: ref,
        sx: {
            gap: '8px'
        }
    }, props, {
        __css: contentStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification__content', props.className)
    }));
});





var $denZA = parcelRequire("denZA");
var $bbb810ad3d1cf65f$var$__assign = undefined && undefined.__assign || function() {
    $bbb810ad3d1cf65f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbb810ad3d1cf65f$var$__assign.apply(this, arguments);
};
var $bbb810ad3d1cf65f$export$fa1ff4eec99b792d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var descriptionStyles = $bbb810ad3d1cf65f$var$__assign({
        display: 'inline'
    }, styles.description);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $bbb810ad3d1cf65f$var$__assign({
        ref: ref
    }, props, {
        __css: descriptionStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification__desc', props.className)
    }));
});





var $07999317a69b8340$export$591f21428120a6de = {
    plain: {},
    info: {
        icon: (0, $7d70df2da146902d$export$d8874184141c994a),
        colorScheme: 'information'
    },
    warning: {
        icon: (0, $2e0ba039f0839502$export$f1b6053a528b50d9),
        colorScheme: 'warning'
    },
    success: {
        icon: (0, $5781f51d3324a667$export$17e1460061865da),
        colorScheme: 'success'
    },
    error: {
        icon: (0, $9670145d9976863e$export$750f42de29e1826b),
        colorScheme: 'error'
    }
};





var $denZA = parcelRequire("denZA");

var $d3f57babb07449ff$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d3f57babb07449ff$var$_a;
var $d3f57babb07449ff$export$7d3195c92e938609 = ($d3f57babb07449ff$var$_a = $d3f57babb07449ff$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'InlineNotificationContext',
    errorMessage: 'useInlineNotificationContext: `context` is undefined. Seems you forgot to wrap InlineNotification components in `<InlineNotification />`'
}), 2), $d3f57babb07449ff$var$_a[0]), $d3f57babb07449ff$export$6afe91f0b722fb70 = $d3f57babb07449ff$var$_a[1];


var $1c6e7af2296953d5$var$__assign = undefined && undefined.__assign || function() {
    $1c6e7af2296953d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c6e7af2296953d5$var$__assign.apply(this, arguments);
};
var $1c6e7af2296953d5$export$db6f1bc342b639f = function(props) {
    var _a = (0, $d3f57babb07449ff$export$6afe91f0b722fb70)(), status = _a.status, hideIcon = _a.hideIcon;
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    if (status === 'plain' || status === undefined) return null;
    if (hideIcon) return null;
    var BaseIcon = (0, $07999317a69b8340$export$591f21428120a6de)[status].icon;
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $1c6e7af2296953d5$var$__assign({
        display: "inherit"
    }, props, {
        __css: styles.status,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification__status', props.className)
    }), $denZA.createElement(BaseIcon, null));
};





var $denZA = parcelRequire("denZA");
var $e9268b0d1cd0d56b$var$__assign = undefined && undefined.__assign || function() {
    $e9268b0d1cd0d56b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9268b0d1cd0d56b$var$__assign.apply(this, arguments);
};
var $e9268b0d1cd0d56b$export$dcda81e5736ad037 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $e9268b0d1cd0d56b$var$__assign({
        ref: ref
    }, props, {
        __css: styles.title,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification__title', props.className)
    }));
});






var $denZA = parcelRequire("denZA");








var $denZA = parcelRequire("denZA");
var $b3821a4a4aabfbcb$var$__assign = undefined && undefined.__assign || function() {
    $b3821a4a4aabfbcb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b3821a4a4aabfbcb$var$__assign.apply(this, arguments);
};
var $b3821a4a4aabfbcb$export$bce694d49e3f45f6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var wrapperStyles = $b3821a4a4aabfbcb$var$__assign({
        display: 'inline'
    }, styles.wrapper);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $b3821a4a4aabfbcb$var$__assign({
        ref: ref
    }, props, {
        __css: wrapperStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification__wrapper', props.className)
    }));
});


var $c5e1f2e7b048d148$var$__assign = undefined && undefined.__assign || function() {
    $c5e1f2e7b048d148$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5e1f2e7b048d148$var$__assign.apply(this, arguments);
};
var $c5e1f2e7b048d148$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c5e1f2e7b048d148$export$cae1c58733dbe1ed = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var _a = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), children = _a.children, _b = _a.isStandalone, isStandalone = _b === void 0 ? true : _b, rest = $c5e1f2e7b048d148$var$__rest(_a, [
        "children",
        "isStandalone"
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var childrenFiltered = validChildren.filter(function(childNode) {
        return childNode.type !== (0, $1c6e7af2296953d5$export$db6f1bc342b639f);
    });
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('InlineNotification', $c5e1f2e7b048d148$var$__assign($c5e1f2e7b048d148$var$__assign({}, props), {
        isStandalone: isStandalone,
        colorScheme: props.colorScheme
    }));
    var alertStyles = $c5e1f2e7b048d148$var$__assign({
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
    }, styles.container);
    return $denZA.createElement((0, $d3f57babb07449ff$export$7d3195c92e938609), {
        value: {
            isStandalone: isStandalone,
            status: props.variant,
            hideIcon: props.hideIcon || false
        }
    }, $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c5e1f2e7b048d148$var$__assign({
        ref: ref,
        role: "alert"
    }, rest, {
        __css: alertStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-inline-notification', props.className)
    }), $denZA.createElement((0, $b3821a4a4aabfbcb$export$bce694d49e3f45f6), null, $denZA.createElement((0, $1c6e7af2296953d5$export$db6f1bc342b639f), null), childrenFiltered))));
});
$c5e1f2e7b048d148$export$cae1c58733dbe1ed.Content = (0, $a1064900ad951468$export$ed5a7a9c50541f68);
$c5e1f2e7b048d148$export$cae1c58733dbe1ed.Description = (0, $bbb810ad3d1cf65f$export$fa1ff4eec99b792d);
$c5e1f2e7b048d148$export$cae1c58733dbe1ed.Status = (0, $1c6e7af2296953d5$export$db6f1bc342b639f);
$c5e1f2e7b048d148$export$cae1c58733dbe1ed.Title = (0, $e9268b0d1cd0d56b$export$dcda81e5736ad037);


var $a2235028de9fa3ad$export$ed5a7a9c50541f68 = (0, $a1064900ad951468$export$ed5a7a9c50541f68);
var $a2235028de9fa3ad$export$fa1ff4eec99b792d = (0, $bbb810ad3d1cf65f$export$fa1ff4eec99b792d);
var $a2235028de9fa3ad$export$db6f1bc342b639f = (0, $1c6e7af2296953d5$export$db6f1bc342b639f);
var $a2235028de9fa3ad$export$dcda81e5736ad037 = (0, $e9268b0d1cd0d56b$export$dcda81e5736ad037);





var $denZA = parcelRequire("denZA");
function $f79468edeb5355d6$var$_extends() {
    $f79468edeb5355d6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f79468edeb5355d6$var$_extends.apply(this, arguments);
}
function $f79468edeb5355d6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f79468edeb5355d6$var$placements = {
    left: {
        marginEnd: "-1px",
        borderEndRadius: 0,
        borderEndColor: "transparent"
    },
    right: {
        marginStart: "-1px",
        borderStartRadius: 0,
        borderStartColor: "transparent"
    }
};
var $f79468edeb5355d6$var$StyledAddon = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        flex: "0 0 auto",
        width: "auto",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap"
    }
});
var $f79468edeb5355d6$export$bc91d778bb7f4691 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _placements$placement;
    var { placement: placement = "left" } = props, rest = $f79468edeb5355d6$var$_objectWithoutPropertiesLoose(props, [
        "placement"
    ]);
    var placementStyles = (_placements$placement = $f79468edeb5355d6$var$placements[placement]) != null ? _placements$placement : {};
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement($f79468edeb5355d6$var$StyledAddon, $f79468edeb5355d6$var$_extends({
        ref: ref
    }, rest, {
        __css: $f79468edeb5355d6$var$_extends({}, styles.addon, placementStyles)
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f79468edeb5355d6$export$bc91d778bb7f4691.displayName = "InputAddon";
var $f79468edeb5355d6$export$53724606b3d75877 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement($f79468edeb5355d6$export$bc91d778bb7f4691, $f79468edeb5355d6$var$_extends({
        ref: ref,
        placement: "left"
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input__left-addon", props.className)
    })));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f79468edeb5355d6$export$53724606b3d75877.displayName = "InputLeftAddon";
 // This is used in `input-group.tsx`
$f79468edeb5355d6$export$53724606b3d75877.id = "InputLeftAddon";
var $f79468edeb5355d6$export$5c7aaffc7ec4d496 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement($f79468edeb5355d6$export$bc91d778bb7f4691, $f79468edeb5355d6$var$_extends({
        ref: ref,
        placement: "right"
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input__right-addon", props.className)
    })));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f79468edeb5355d6$export$5c7aaffc7ec4d496.displayName = "InputRightAddon";
 // This is used in `input-group.tsx`
$f79468edeb5355d6$export$5c7aaffc7ec4d496.id = "InputRightAddon";




var $denZA = parcelRequire("denZA");
var $5e5ec5bc76798ab6$var$__assign = undefined && undefined.__assign || function() {
    $5e5ec5bc76798ab6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5e5ec5bc76798ab6$var$__assign.apply(this, arguments);
};
var $5e5ec5bc76798ab6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5e5ec5bc76798ab6$export$53724606b3d75877 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $5e5ec5bc76798ab6$var$__rest(_a, []);
    return $denZA.createElement((0, $f79468edeb5355d6$export$53724606b3d75877), $5e5ec5bc76798ab6$var$__assign({}, rest, {
        ref: ref
    }));
});
$5e5ec5bc76798ab6$export$53724606b3d75877.id = 'InputLeftAddon';
var $5e5ec5bc76798ab6$export$5c7aaffc7ec4d496 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $5e5ec5bc76798ab6$var$__rest(_a, []);
    return $denZA.createElement((0, $f79468edeb5355d6$export$5c7aaffc7ec4d496), $5e5ec5bc76798ab6$var$__assign({}, rest, {
        ref: ref
    }));
});
$5e5ec5bc76798ab6$export$5c7aaffc7ec4d496.id = 'InputRightAddon';





var $denZA = parcelRequire("denZA");
function $c2d748c1b9d29ec7$var$_extends() {
    $c2d748c1b9d29ec7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c2d748c1b9d29ec7$var$_extends.apply(this, arguments);
}
function $c2d748c1b9d29ec7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c2d748c1b9d29ec7$var$StyledElement = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0",
        zIndex: 2
    }
});
var $c2d748c1b9d29ec7$var$InputElement = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _input$height, _input$height2;
    var { placement: placement = "left" } = props, rest = $c2d748c1b9d29ec7$var$_objectWithoutPropertiesLoose(props, [
        "placement"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var input = styles.field;
    var attr = placement === "left" ? "insetStart" : "insetEnd";
    var elementStyles = {
        [attr]: "0",
        width: (_input$height = input == null ? void 0 : input.height) != null ? _input$height : input == null ? void 0 : input.h,
        height: (_input$height2 = input == null ? void 0 : input.height) != null ? _input$height2 : input == null ? void 0 : input.h,
        fontSize: input == null ? void 0 : input.fontSize
    };
    return /*#__PURE__*/ $denZA.createElement($c2d748c1b9d29ec7$var$StyledElement, $c2d748c1b9d29ec7$var$_extends({
        ref: ref,
        __css: elementStyles
    }, rest));
}); // This is used in `input-group.tsx`
$c2d748c1b9d29ec7$var$InputElement.id = "InputElement";
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2d748c1b9d29ec7$var$InputElement.displayName = "InputElement";
var $c2d748c1b9d29ec7$export$b5cdbc34a3b65f4c = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $c2d748c1b9d29ec7$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input__left-element", className);
    return /*#__PURE__*/ $denZA.createElement($c2d748c1b9d29ec7$var$InputElement, $c2d748c1b9d29ec7$var$_extends({
        ref: ref,
        placement: "left",
        className: _className
    }, rest));
}); // This is used in `input-group.tsx`
$c2d748c1b9d29ec7$export$b5cdbc34a3b65f4c.id = "InputLeftElement";
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2d748c1b9d29ec7$export$b5cdbc34a3b65f4c.displayName = "InputLeftElement";
var $c2d748c1b9d29ec7$export$8a7b8bdd4608e7e3 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $c2d748c1b9d29ec7$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input__right-element", className);
    return /*#__PURE__*/ $denZA.createElement($c2d748c1b9d29ec7$var$InputElement, $c2d748c1b9d29ec7$var$_extends({
        ref: ref,
        placement: "right",
        className: _className
    }, rest));
}); // This is used in `input-group.tsx`
$c2d748c1b9d29ec7$export$8a7b8bdd4608e7e3.id = "InputRightElement";
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2d748c1b9d29ec7$export$8a7b8bdd4608e7e3.displayName = "InputRightElement";




var $denZA = parcelRequire("denZA");
var $c7b00ac65560b57e$var$__assign = undefined && undefined.__assign || function() {
    $c7b00ac65560b57e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c7b00ac65560b57e$var$__assign.apply(this, arguments);
};
var $c7b00ac65560b57e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c7b00ac65560b57e$export$b5cdbc34a3b65f4c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $c7b00ac65560b57e$var$__rest(_a, []);
    return $denZA.createElement((0, $c2d748c1b9d29ec7$export$b5cdbc34a3b65f4c), $c7b00ac65560b57e$var$__assign({}, rest, {
        ref: ref
    }));
});
$c7b00ac65560b57e$export$b5cdbc34a3b65f4c.id = 'InputLeftElement';
var $c7b00ac65560b57e$export$8a7b8bdd4608e7e3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $c7b00ac65560b57e$var$__rest(_a, []);
    return $denZA.createElement((0, $c2d748c1b9d29ec7$export$8a7b8bdd4608e7e3), $c7b00ac65560b57e$var$__assign({}, rest, {
        ref: ref
    }));
});
$c7b00ac65560b57e$export$8a7b8bdd4608e7e3.id = 'InputRightElement';






var $denZA = parcelRequire("denZA");
function $abe88efd04a9f64e$var$_extends() {
    $abe88efd04a9f64e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $abe88efd04a9f64e$var$_extends.apply(this, arguments);
}
function $abe88efd04a9f64e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $abe88efd04a9f64e$export$6e5a9cd40e0c9b97 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Input", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children, className: className } = _omitThemingProps, rest = $abe88efd04a9f64e$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children",
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input__group", className);
    var groupStyles = {};
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var input = styles.field;
    validChildren.forEach((child)=>{
        if (!styles) return;
        if (input && child.type.id === "InputLeftElement") {
            var _input$height;
            groupStyles.paddingStart = (_input$height = input.height) != null ? _input$height : input.h;
        }
        if (input && child.type.id === "InputRightElement") {
            var _input$height2;
            groupStyles.paddingEnd = (_input$height2 = input.height) != null ? _input$height2 : input.h;
        }
        if (child.type.id === "InputRightAddon") groupStyles.borderEndRadius = 0;
        if (child.type.id === "InputLeftAddon") groupStyles.borderStartRadius = 0;
    });
    var clones = validChildren.map((child)=>{
        var _child$props, _child$props2;
        /**
     * Make it possible to override the size and variant from `Input`
     */ var theming = {
            size: ((_child$props = child.props) == null ? void 0 : _child$props.size) || props.size,
            variant: ((_child$props2 = child.props) == null ? void 0 : _child$props2.variant) || props.variant
        };
        return child.type.id !== "Input" ? /*#__PURE__*/ $denZA.cloneElement(child, theming) : /*#__PURE__*/ $denZA.cloneElement(child, Object.assign(theming, groupStyles, child.props));
    });
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $abe88efd04a9f64e$var$_extends({
        className: _className,
        ref: ref,
        __css: {
            width: "100%",
            display: "flex",
            position: "relative"
        }
    }, rest), /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, clones));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $abe88efd04a9f64e$export$6e5a9cd40e0c9b97.displayName = "InputGroup";




var $denZA = parcelRequire("denZA");
var $effec324ccce6c3c$var$__assign = undefined && undefined.__assign || function() {
    $effec324ccce6c3c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $effec324ccce6c3c$var$__assign.apply(this, arguments);
};
var $effec324ccce6c3c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $effec324ccce6c3c$export$6e5a9cd40e0c9b97 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $effec324ccce6c3c$var$__rest(_a, []);
    return $denZA.createElement((0, $abe88efd04a9f64e$export$6e5a9cd40e0c9b97), $effec324ccce6c3c$var$__assign({}, rest, {
        ref: ref
    }));
});




function $a9ca37b5c0c19e69$var$_extends() {
    $a9ca37b5c0c19e69$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9ca37b5c0c19e69$var$_extends.apply(this, arguments);
}
function $a9ca37b5c0c19e69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a9ca37b5c0c19e69$export$62ecd8ad1bbe1a18(props) {
    var _useFormControlProps = $a9ca37b5c0c19e69$export$1819803dd567b95f(props), { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, isRequired: isRequired } = _useFormControlProps, rest = $a9ca37b5c0c19e69$var$_objectWithoutPropertiesLoose(_useFormControlProps, [
        "isDisabled",
        "isInvalid",
        "isReadOnly",
        "isRequired"
    ]);
    return $a9ca37b5c0c19e69$var$_extends({}, rest, {
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isInvalid),
        "aria-required": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isRequired),
        "aria-readonly": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isReadOnly)
    });
}
function $a9ca37b5c0c19e69$export$1819803dd567b95f(props) {
    var _ref, _ref2, _ref3;
    var field = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    var { id: id, disabled: disabled, readOnly: readOnly, required: required, isRequired: isRequired, isInvalid: isInvalid, isReadOnly: isReadOnly, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur } = props, rest = $a9ca37b5c0c19e69$var$_objectWithoutPropertiesLoose(props, [
        "id",
        "disabled",
        "readOnly",
        "required",
        "isRequired",
        "isInvalid",
        "isReadOnly",
        "isDisabled",
        "onFocus",
        "onBlur"
    ]);
    var labelIds = props["aria-describedby"] ? [
        props["aria-describedby"]
    ] : []; // Error message must be described first in all scenarios.
    if (field != null && field.hasFeedbackText && field != null && field.isInvalid) labelIds.push(field.feedbackId);
    if (field != null && field.hasHelpText) labelIds.push(field.helpTextId);
    return $a9ca37b5c0c19e69$var$_extends({}, rest, {
        "aria-describedby": labelIds.join(" ") || undefined,
        id: id != null ? id : field == null ? void 0 : field.id,
        isDisabled: (_ref = disabled != null ? disabled : isDisabled) != null ? _ref : field == null ? void 0 : field.isDisabled,
        isReadOnly: (_ref2 = readOnly != null ? readOnly : isReadOnly) != null ? _ref2 : field == null ? void 0 : field.isReadOnly,
        isRequired: (_ref3 = required != null ? required : isRequired) != null ? _ref3 : field == null ? void 0 : field.isRequired,
        isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
        onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onFocus, onFocus),
        onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onBlur, onBlur)
    });
}





var $denZA = parcelRequire("denZA");
function $49f165065d376a2b$var$_extends() {
    $49f165065d376a2b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49f165065d376a2b$var$_extends.apply(this, arguments);
}
var $49f165065d376a2b$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Input", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var input = (0, $a9ca37b5c0c19e69$export$62ecd8ad1bbe1a18)(ownProps);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-input", props.className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).input, $49f165065d376a2b$var$_extends({}, input, {
        __css: styles.field,
        ref: ref,
        className: _className
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $49f165065d376a2b$export$f5b8910cec6cf069.displayName = "Input";
 // This is used in `input-group.tsx`
$49f165065d376a2b$export$f5b8910cec6cf069.id = "Input";




var $denZA = parcelRequire("denZA");



var $eb05d11f12817009$var$__assign = undefined && undefined.__assign || function() {
    $eb05d11f12817009$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eb05d11f12817009$var$__assign.apply(this, arguments);
};
var $eb05d11f12817009$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $eb05d11f12817009$export$f5b8910cec6cf069 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var isReadOnly = _a.isReadOnly, rest = $eb05d11f12817009$var$__rest(_a, [
        "isReadOnly"
    ]);
    return $denZA.createElement((0, $49f165065d376a2b$export$f5b8910cec6cf069), $eb05d11f12817009$var$__assign({
        isReadOnly: isReadOnly,
        tabIndex: isReadOnly ? -1 : 0
    }, rest, {
        ref: ref
    }));
});
$eb05d11f12817009$export$f5b8910cec6cf069.id = 'Input';
$eb05d11f12817009$export$f5b8910cec6cf069.LeftAddon = (0, $5e5ec5bc76798ab6$export$53724606b3d75877);
$eb05d11f12817009$export$f5b8910cec6cf069.RightAddon = (0, $5e5ec5bc76798ab6$export$5c7aaffc7ec4d496);
$eb05d11f12817009$export$f5b8910cec6cf069.LeftElement = (0, $c7b00ac65560b57e$export$b5cdbc34a3b65f4c);
$eb05d11f12817009$export$f5b8910cec6cf069.RightElement = (0, $c7b00ac65560b57e$export$8a7b8bdd4608e7e3);
$eb05d11f12817009$export$f5b8910cec6cf069.Group = (0, $effec324ccce6c3c$export$6e5a9cd40e0c9b97);


var $65071eb8962c2626$export$53724606b3d75877 = (0, $5e5ec5bc76798ab6$export$53724606b3d75877);
var $65071eb8962c2626$export$5c7aaffc7ec4d496 = (0, $5e5ec5bc76798ab6$export$5c7aaffc7ec4d496);
var $65071eb8962c2626$export$b5cdbc34a3b65f4c = (0, $c7b00ac65560b57e$export$b5cdbc34a3b65f4c);
var $65071eb8962c2626$export$8a7b8bdd4608e7e3 = (0, $c7b00ac65560b57e$export$8a7b8bdd4608e7e3);
var $65071eb8962c2626$export$6e5a9cd40e0c9b97 = (0, $effec324ccce6c3c$export$6e5a9cd40e0c9b97);





var $denZA = parcelRequire("denZA");
function $254a85d5d4a63e05$var$_extends() {
    $254a85d5d4a63e05$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $254a85d5d4a63e05$var$_extends.apply(this, arguments);
}
function $254a85d5d4a63e05$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $254a85d5d4a63e05$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Link", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { className: className, isExternal: isExternal } = _omitThemingProps, rest = $254a85d5d4a63e05$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className",
        "isExternal"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).a, $254a85d5d4a63e05$var$_extends({
        target: isExternal ? "_blank" : undefined,
        rel: isExternal ? "noopener noreferrer" : undefined,
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-link", className)
    }, rest, {
        __css: styles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $254a85d5d4a63e05$export$a6c7ac8248d6e38a.displayName = "Link";




var $denZA = parcelRequire("denZA");
var $23076e5d058875b5$var$__assign = undefined && undefined.__assign || function() {
    $23076e5d058875b5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23076e5d058875b5$var$__assign.apply(this, arguments);
};
var $23076e5d058875b5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $23076e5d058875b5$export$a6c7ac8248d6e38a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.isInline, isInline = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'standalone' : _c, rest = $23076e5d058875b5$var$__rest(_a, [
        "isInline",
        "variant"
    ]);
    var variantOverride = isInline ? 'inline' : variant;
    return $denZA.createElement((0, $254a85d5d4a63e05$export$a6c7ac8248d6e38a), $23076e5d058875b5$var$__assign({
        variant: variantOverride
    }, rest, {
        ref: ref
    }));
});







var $denZA = parcelRequire("denZA");
function $f2afedcfddf3ca17$var$_extends() {
    $f2afedcfddf3ca17$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2afedcfddf3ca17$var$_extends.apply(this, arguments);
}
function $f2afedcfddf3ca17$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f2afedcfddf3ca17$export$155d86d4b6139452 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { isExternal: isExternal, target: target, rel: rel, className: className } = props, rest = $f2afedcfddf3ca17$var$_objectWithoutPropertiesLoose(props, [
        "isExternal",
        "target",
        "rel",
        "className"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).a, $f2afedcfddf3ca17$var$_extends({}, rest, {
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-linkbox__overlay", className),
        rel: isExternal ? "noopener noreferrer" : rel,
        target: isExternal ? "_blank" : target,
        __css: {
            position: "static",
            "&::before": {
                content: "''",
                cursor: "inherit",
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
                width: "100%",
                height: "100%"
            }
        }
    }));
});
var $f2afedcfddf3ca17$export$d79f4543fbc1d78a = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { className: className } = props, rest = $f2afedcfddf3ca17$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f2afedcfddf3ca17$var$_extends({
        ref: ref,
        position: "relative"
    }, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-linkbox", className),
        __css: {
            /* Elevate the links and abbreviations up */ "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
                position: "relative",
                zIndex: 1
            }
        }
    }));
});




var $denZA = parcelRequire("denZA");
var $bb5d2e5171603e90$var$__assign = undefined && undefined.__assign || function() {
    $bb5d2e5171603e90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb5d2e5171603e90$var$__assign.apply(this, arguments);
};
var $bb5d2e5171603e90$export$d79f4543fbc1d78a = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f2afedcfddf3ca17$export$d79f4543fbc1d78a), $bb5d2e5171603e90$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $d3080023e0346439$var$__assign = undefined && undefined.__assign || function() {
    $d3080023e0346439$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d3080023e0346439$var$__assign.apply(this, arguments);
};
var $d3080023e0346439$export$155d86d4b6139452 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f2afedcfddf3ca17$export$155d86d4b6139452), $d3080023e0346439$var$__assign({
        _focus: {
            outline: 'none',
            boxShadow: 'focusVisible'
        }
    }, props, {
        ref: ref
    }));
});









var $denZA = parcelRequire("denZA");
function $e09304807a42901c$var$_extends() {
    $e09304807a42901c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e09304807a42901c$var$_extends.apply(this, arguments);
}
function $e09304807a42901c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e09304807a42901c$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("List", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children, styleType: styleType = "none", stylePosition: stylePosition, spacing: spacing } = _omitThemingProps, rest = $e09304807a42901c$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children",
        "styleType",
        "stylePosition",
        "spacing"
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var selector = "& > *:not(style) ~ *:not(style)";
    var spacingStyle = spacing ? {
        [selector]: {
            mt: spacing
        }
    } : {};
    return /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).ul, $e09304807a42901c$var$_extends({
        ref: ref,
        listStyleType: styleType,
        listStylePosition: stylePosition,
        role: "list",
        __css: $e09304807a42901c$var$_extends({}, styles.container, spacingStyle)
    }, rest), validChildren));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e09304807a42901c$export$54c2e3dc7acea9f5.displayName = "List";
var $e09304807a42901c$export$547f885a1fca4e31 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var rest = $e09304807a42901c$var$_objectWithoutPropertiesLoose(props, [
        "as"
    ]);
    return /*#__PURE__*/ $denZA.createElement($e09304807a42901c$export$54c2e3dc7acea9f5, $e09304807a42901c$var$_extends({
        ref: ref,
        as: "ol",
        styleType: "decimal",
        marginStart: "1em"
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e09304807a42901c$export$547f885a1fca4e31.displayName = "OrderedList";
var $e09304807a42901c$export$30b2abb1ad323770 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var rest = $e09304807a42901c$var$_objectWithoutPropertiesLoose(props, [
        "as"
    ]);
    return /*#__PURE__*/ $denZA.createElement($e09304807a42901c$export$54c2e3dc7acea9f5, $e09304807a42901c$var$_extends({
        ref: ref,
        as: "ul",
        styleType: "initial",
        marginStart: "1em"
    }, rest));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e09304807a42901c$export$30b2abb1ad323770.displayName = "UnorderedList";
var $e09304807a42901c$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).li, $e09304807a42901c$var$_extends({
        ref: ref
    }, props, {
        __css: styles.item
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e09304807a42901c$export$a7b06bfba60a8a78.displayName = "ListItem";
var $e09304807a42901c$export$230671d7ba50d3c8 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $e09304807a42901c$var$_extends({
        ref: ref,
        role: "presentation"
    }, props, {
        __css: styles.icon
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $e09304807a42901c$export$230671d7ba50d3c8.displayName = "ListIcon";




var $denZA = parcelRequire("denZA");
var $498d34a800520491$var$__assign = undefined && undefined.__assign || function() {
    $498d34a800520491$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $498d34a800520491$var$__assign.apply(this, arguments);
};
var $498d34a800520491$export$a7b06bfba60a8a78 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e09304807a42901c$export$a7b06bfba60a8a78), $498d34a800520491$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");

var $cbfe2911f51d26f6$var$__assign = undefined && undefined.__assign || function() {
    $cbfe2911f51d26f6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbfe2911f51d26f6$var$__assign.apply(this, arguments);
};
var $cbfe2911f51d26f6$export$54c2e3dc7acea9f5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e09304807a42901c$export$54c2e3dc7acea9f5), $cbfe2911f51d26f6$var$__assign({}, props, {
        ref: ref
    }));
});
$cbfe2911f51d26f6$export$54c2e3dc7acea9f5.Item = (0, $498d34a800520491$export$a7b06bfba60a8a78);





var $denZA = parcelRequire("denZA");
var $6f9e4b73525e8529$var$__assign = undefined && undefined.__assign || function() {
    $6f9e4b73525e8529$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f9e4b73525e8529$var$__assign.apply(this, arguments);
};
var $6f9e4b73525e8529$export$547f885a1fca4e31 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e09304807a42901c$export$547f885a1fca4e31), $6f9e4b73525e8529$var$__assign({
        spacing: "3"
    }, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $d188244f354bdad1$var$__assign = undefined && undefined.__assign || function() {
    $d188244f354bdad1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d188244f354bdad1$var$__assign.apply(this, arguments);
};
var $d188244f354bdad1$export$30b2abb1ad323770 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $e09304807a42901c$export$30b2abb1ad323770), $d188244f354bdad1$var$__assign({
        spacing: "3"
    }, props, {
        ref: ref
    }));
});


var $9f39565db5648a25$export$a7b06bfba60a8a78 = (0, $498d34a800520491$export$a7b06bfba60a8a78);






var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");
function $40cde9f68c7af32b$export$43d26308f6d75a57() {
    var listeners = $denZA.useRef(new Map());
    var currentListeners = listeners.current;
    var add = $denZA.useCallback((el, type, listener, options)=>{
        listeners.current.set(listener, {
            type: type,
            el: el,
            options: options
        });
        el.addEventListener(type, listener, options);
    }, []);
    var remove = $denZA.useCallback((el, type, listener, options)=>{
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
    }, []);
    $denZA.useEffect(()=>()=>{
            currentListeners.forEach((value, key)=>{
                remove(value.el, value.type, key, value.options);
            });
        }, [
        remove,
        currentListeners
    ]);
    return {
        add: add,
        remove: remove
    };
}


function $7471193ff97457bc$var$_extends() {
    $7471193ff97457bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7471193ff97457bc$var$_extends.apply(this, arguments);
}
function $7471193ff97457bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7471193ff97457bc$var$isValidElement(event) {
    var element = event.target;
    var { tagName: tagName, isContentEditable: isContentEditable } = element;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function $7471193ff97457bc$export$ed213cc82e426b1a(props) {
    if (props === void 0) props = {};
    var { ref: htmlRef, isDisabled: isDisabled, isFocusable: isFocusable, clickOnEnter: clickOnEnter = true, clickOnSpace: clickOnSpace = true, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, tabIndex: tabIndexProp, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave } = props, htmlProps = $7471193ff97457bc$var$_objectWithoutPropertiesLoose(props, [
        "ref",
        "isDisabled",
        "isFocusable",
        "clickOnEnter",
        "clickOnSpace",
        "onMouseDown",
        "onMouseUp",
        "onClick",
        "onKeyDown",
        "onKeyUp",
        "tabIndex",
        "onMouseOver",
        "onMouseLeave"
    ]);
    /**
   * We'll use this to track if the element is a button element
   */ var [isButton, setIsButton] = $denZA.useState(true);
    /**
   * For custom button implementation, we'll use this to track when
   * we mouse down on the button, to enable use style its ":active" style
   */ var [isPressed, setIsPressed] = $denZA.useState(false);
    var listeners = (0, $40cde9f68c7af32b$export$43d26308f6d75a57)();
    /**
   * The ref callback that fires as soon as the dom node is ready
   */ var refCallback = (node)=>{
        if (!node) return;
        if (node.tagName !== "BUTTON") setIsButton(false);
    };
    var tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    var trulyDisabled = isDisabled && !isFocusable;
    var handleClick = $denZA.useCallback((event)=>{
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        var self = event.currentTarget;
        self.focus();
        onClick == null || onClick(event);
    }, [
        isDisabled,
        onClick
    ]);
    var onDocumentKeyUp = $denZA.useCallback((e)=>{
        if (isPressed && $7471193ff97457bc$var$isValidElement(e)) {
            e.preventDefault();
            e.stopPropagation();
            setIsPressed(false); // eslint-disable-next-line @typescript-eslint/no-unused-vars
            listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
    }, [
        isPressed,
        listeners
    ]);
    var handleKeyDown = $denZA.useCallback((event)=>{
        onKeyDown == null || onKeyDown(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$7471193ff97457bc$var$isValidElement(event.nativeEvent) || isButton) return;
        var shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        var shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(true);
        }
        if (shouldClickOnEnter) {
            event.preventDefault();
            var self = event.currentTarget;
            self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
    }, [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
    ]);
    var handleKeyUp = $denZA.useCallback((event)=>{
        onKeyUp == null || onKeyUp(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$7471193ff97457bc$var$isValidElement(event.nativeEvent) || isButton) return;
        var shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(false);
            var self = event.currentTarget;
            self.click();
        }
    }, [
        clickOnSpace,
        isButton,
        isDisabled,
        onKeyUp
    ]);
    var onDocumentMouseUp = $denZA.useCallback((event)=>{
        if (event.button !== 0) return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    }, [
        listeners
    ]);
    var handleMouseDown = $denZA.useCallback((event)=>{
        if ((0, $405775388fe7f58e$export$189689d1febf0166)(event)) return;
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!isButton) setIsPressed(true);
        var target = event.currentTarget;
        target.focus({
            preventScroll: true
        });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown == null || onMouseDown(event);
    }, [
        isDisabled,
        isButton,
        onMouseDown,
        listeners,
        onDocumentMouseUp
    ]);
    var handleMouseUp = $denZA.useCallback((event)=>{
        if ((0, $405775388fe7f58e$export$189689d1febf0166)(event)) return;
        if (!isButton) setIsPressed(false);
        onMouseUp == null || onMouseUp(event);
    }, [
        onMouseUp,
        isButton
    ]);
    var handleMouseOver = $denZA.useCallback((event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onMouseOver == null || onMouseOver(event);
    }, [
        isDisabled,
        onMouseOver
    ]);
    var handleMouseLeave = $denZA.useCallback((event)=>{
        if (isPressed) {
            event.preventDefault();
            setIsPressed(false);
        }
        onMouseLeave == null || onMouseLeave(event);
    }, [
        isPressed,
        onMouseLeave
    ]);
    var ref = (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(htmlRef, refCallback);
    if (isButton) return $7471193ff97457bc$var$_extends({}, htmlProps, {
        ref: ref,
        type: "button",
        "aria-disabled": trulyDisabled ? undefined : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    });
    return $7471193ff97457bc$var$_extends({}, htmlProps, {
        ref: ref,
        role: "button",
        "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isPressed),
        "aria-disabled": isDisabled ? "true" : undefined,
        tabIndex: trulyDisabled ? undefined : tabIndex,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave
    });
}





var $denZA = parcelRequire("denZA");


function $528efd7f0c9e3374$var$_extends() {
    $528efd7f0c9e3374$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $528efd7f0c9e3374$var$_extends.apply(this, arguments);
}
function $528efd7f0c9e3374$export$6e3e27031a30522f(props) {
    if (props === void 0) props = {};
    var { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    var [isOpenState, setIsOpen] = $denZA.useState(props.defaultIsOpen || false);
    var [isControlled, isOpen] = (0, $53a3d6ee771ef939$export$7301e09313e4cf1b)(isOpenProp, isOpenState);
    var id = (0, $63207b263e1aef60$export$f680877a34711e37)(idProp, "disclosure");
    var onClose = $denZA.useCallback(()=>{
        if (!isControlled) setIsOpen(false);
        onCloseProp == null || onCloseProp();
    }, [
        isControlled,
        onCloseProp
    ]);
    var onOpen = $denZA.useCallback(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenProp == null || onOpenProp();
    }, [
        isControlled,
        onOpenProp
    ]);
    var onToggle = $denZA.useCallback(()=>{
        var action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: function getButtonProps(props) {
            if (props === void 0) props = {};
            return $528efd7f0c9e3374$var$_extends({}, props, {
                "aria-expanded": "true",
                "aria-controls": id,
                onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onToggle)
            });
        },
        getDisclosureProps: function getDisclosureProps(props) {
            if (props === void 0) props = {};
            return $528efd7f0c9e3374$var$_extends({}, props, {
                hidden: !isOpen,
                id: id
            });
        }
    };
}



var $denZA = parcelRequire("denZA");
var $0f6504d34c391be4$export$496315a1608d9602 = (effect, deps)=>{
    var mounted = $denZA.useRef(false);
    $denZA.useEffect(()=>{
        if (mounted.current) return effect();
        mounted.current = true;
        return undefined; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return mounted.current;
};


function $24f8a6fb2f29f586$var$preventReturnFocus(containerRef) {
    var el = containerRef.current;
    if (!el) return false;
    var activeElement = (0, $405775388fe7f58e$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if ((0, $405775388fe7f58e$export$2344b14b097df817)(el, activeElement)) return false;
    if ((0, $e8db4866fc051e33$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $24f8a6fb2f29f586$export$68b323438c1fbb28(containerRef, options) {
    var { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    var shouldFocus = shouldFocusProp && !visible;
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($24f8a6fb2f29f586$var$preventReturnFocus(containerRef)) return;
        var el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
        if (el) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(el, {
            nextTick: true
        });
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}



var $denZA = parcelRequire("denZA");

function $7882820c20d771da$export$71b2224f1ce5e08e(props) {
    var { ref: ref, handler: handler, enabled: enabled = true } = props;
    var savedHandler = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(handler);
    var stateRef = (0, $denZA.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    var state = stateRef.current;
    (0, $denZA.useEffect)(()=>{
        if (!enabled) return;
        var onPointerDown = (e)=>{
            if ($7882820c20d771da$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        var onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $7882820c20d771da$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        var onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $7882820c20d771da$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        var doc = (0, $405775388fe7f58e$export$b204af158042fbac)(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $7882820c20d771da$var$isValidEvent(event, ref) {
    var _ref$current;
    var target = event.target;
    if (event.button > 0) return false; // if the event target is no longer in the document
    if (target) {
        var doc = (0, $405775388fe7f58e$export$b204af158042fbac)(target);
        if (!doc.body.contains(target)) return false;
    }
    return !((_ref$current = ref.current) != null && _ref$current.contains(target));
}


var $denZA = parcelRequire("denZA");
/**
 * Checks if the key pressed is a printable character
 * and can be used for shortcut navigation
 */ function $05a0e2fb4e1da0b9$var$isPrintableCharacter(event) {
    var { key: key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function $05a0e2fb4e1da0b9$export$b0ebbe7904d8d94a(props) {
    if (props === void 0) props = {};
    var { timeout: timeout = 300, preventDefault: preventDefault = ()=>true } = props;
    var [keys, setKeys] = $denZA.useState([]);
    var timeoutRef = $denZA.useRef();
    var flush = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    var clearKeysAfterDelay = ()=>{
        flush();
        timeoutRef.current = setTimeout(()=>{
            setKeys([]);
            timeoutRef.current = null;
        }, timeout);
    };
    $denZA.useEffect(()=>flush, []);
    function onKeyDown(fn) {
        return (event)=>{
            if (event.key === "Backspace") {
                var keysCopy = [
                    ...keys
                ];
                keysCopy.pop();
                setKeys(keysCopy);
                return;
            }
            if ($05a0e2fb4e1da0b9$var$isPrintableCharacter(event)) {
                var _keysCopy = keys.concat(event.key);
                if (preventDefault(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                setKeys(_keysCopy);
                fn(_keysCopy.join(""));
                clearKeysAfterDelay();
            }
        };
    }
    return onKeyDown;
}



function $c5a26f45c361af74$export$2e2bcd8739ae039(element) {
    var rect = element.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        x: rect.left,
        y: rect.top
    };
}


/*:: import type { Window } from '../types'; */ /*:: declare function getWindow(node: Node | Window): Window; */ function $aaf7467105586a86$export$2e2bcd8739ae039(node) {
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView : window;
    }
    return node;
}


function $6367186e3c6eccec$export$2e2bcd8739ae039(node) {
    var win = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */ function $345a465066cb1947$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */ function $345a465066cb1947$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}


function $99c4f2dd0d0c9e46$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $12f99e23a3c41280$export$2e2bcd8739ae039(node) {
    if (node === (0, $aaf7467105586a86$export$2e2bcd8739ae039)(node) || !(0, $345a465066cb1947$export$1b3bfaa9684536aa)(node)) return (0, $6367186e3c6eccec$export$2e2bcd8739ae039)(node);
    else return (0, $99c4f2dd0d0c9e46$export$2e2bcd8739ae039)(node);
}


function $39cb79e34e2847b0$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $21c2e5689044152f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe: assume body is always available
    return ((0, $345a465066cb1947$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document).documentElement;
}



function $0e33231b88c9bd44$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $c5a26f45c361af74$export$2e2bcd8739ae039)((0, $21c2e5689044152f$export$2e2bcd8739ae039)(element)).left + (0, $6367186e3c6eccec$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $626f843f8b0ac0f6$export$2e2bcd8739ae039(element) {
    return (0, $aaf7467105586a86$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $6cdf4b62d72d143b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}


function $ca6ffde5dc001448$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var documentElement = (0, $21c2e5689044152f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $c5a26f45c361af74$export$2e2bcd8739ae039)(elementOrVirtualElement);
    var isOffsetParentAnElement = (0, $345a465066cb1947$export$1b3bfaa9684536aa)(offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $6cdf4b62d72d143b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $12f99e23a3c41280$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $345a465066cb1947$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $c5a26f45c361af74$export$2e2bcd8739ae039)(offsetParent);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $0e33231b88c9bd44$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}


// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function $a6230ce030a33d71$export$2e2bcd8739ae039(element) {
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: element.offsetWidth,
        height: element.offsetHeight
    };
}




function $7e75def03d12fe60$export$2e2bcd8739ae039(element) {
    if ((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(element) === 'html') return element;
    return element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    (0, $21c2e5689044152f$export$2e2bcd8739ae039)(element) // fallback
    ;
}





function $53ee041ddb6aa00e$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe: assume body is always available
    return node.ownerDocument.body;
    if ((0, $345a465066cb1947$export$1b3bfaa9684536aa)(node) && (0, $6cdf4b62d72d143b$export$2e2bcd8739ae039)(node)) return node;
    return $53ee041ddb6aa00e$export$2e2bcd8739ae039((0, $7e75def03d12fe60$export$2e2bcd8739ae039)(node));
}






function $88cab8a4b0b9ad71$export$2e2bcd8739ae039(element, list) {
    if (list === void 0) list = [];
    var scrollParent = (0, $53ee041ddb6aa00e$export$2e2bcd8739ae039)(element);
    var isBody = (0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(scrollParent) === 'body';
    var win = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $6cdf4b62d72d143b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($88cab8a4b0b9ad71$export$2e2bcd8739ae039((0, $7e75def03d12fe60$export$2e2bcd8739ae039)(target)));
}







function $30b9d8c8b0a1ce5d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(element)) >= 0;
}




function $7cd37187e9d2658a$var$getTrueOffsetParent(element) {
    if (!(0, $345a465066cb1947$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    var offsetParent = element.offsetParent;
    if (offsetParent) {
        var html = (0, $21c2e5689044152f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(offsetParent).position === 'static' && (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(html).position !== 'static') return html;
    }
    return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cd37187e9d2658a$var$getContainingBlock(element) {
    var currentNode = (0, $7e75def03d12fe60$export$2e2bcd8739ae039)(element);
    while((0, $345a465066cb1947$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cd37187e9d2658a$export$2e2bcd8739ae039(element) {
    var window = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(element);
    var offsetParent = $7cd37187e9d2658a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $30b9d8c8b0a1ce5d$export$2e2bcd8739ae039)(offsetParent) && (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $7cd37187e9d2658a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && (0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(offsetParent).position === 'static') return window;
    return offsetParent || $7cd37187e9d2658a$var$getContainingBlock(element) || window;
}



var $25d70bd1609b2a87$export$1e95b668f3b82d = 'top';
var $25d70bd1609b2a87$export$40e543e69a8b3fbb = 'bottom';
var $25d70bd1609b2a87$export$79ffe56a765070d2 = 'right';
var $25d70bd1609b2a87$export$eabcd2c8791e7bf4 = 'left';
var $25d70bd1609b2a87$export$dfb5619354ba860 = 'auto';
var $25d70bd1609b2a87$export$aec2ce47c367b8c3 = [
    $25d70bd1609b2a87$export$1e95b668f3b82d,
    $25d70bd1609b2a87$export$40e543e69a8b3fbb,
    $25d70bd1609b2a87$export$79ffe56a765070d2,
    $25d70bd1609b2a87$export$eabcd2c8791e7bf4
];
var $25d70bd1609b2a87$export$b3571188c770cc5a = 'start';
var $25d70bd1609b2a87$export$bd5df0f255a350f8 = 'end';
var $25d70bd1609b2a87$export$390fd549c5303b4d = 'clippingParents';
var $25d70bd1609b2a87$export$d7b7311ec04a3e8f = 'viewport';
var $25d70bd1609b2a87$export$ae5ab1c730825774 = 'popper';
var $25d70bd1609b2a87$export$ca50aac9f3ba507f = 'reference';
var $25d70bd1609b2a87$export$368f9a87e87fa4e1 = /*#__PURE__*/ $25d70bd1609b2a87$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $25d70bd1609b2a87$export$b3571188c770cc5a,
        placement + "-" + $25d70bd1609b2a87$export$bd5df0f255a350f8
    ]);
}, []);
var $25d70bd1609b2a87$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($25d70bd1609b2a87$export$aec2ce47c367b8c3, [
    $25d70bd1609b2a87$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $25d70bd1609b2a87$export$b3571188c770cc5a,
        placement + "-" + $25d70bd1609b2a87$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $25d70bd1609b2a87$export$421679a7c3d56e = 'beforeRead';
var $25d70bd1609b2a87$export$aafa59e2e03f2942 = 'read';
var $25d70bd1609b2a87$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $25d70bd1609b2a87$export$c65e99957a05207c = 'beforeMain';
var $25d70bd1609b2a87$export$f22da7240b7add18 = 'main';
var $25d70bd1609b2a87$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $25d70bd1609b2a87$export$8d4d2d70e7d46032 = 'beforeWrite';
var $25d70bd1609b2a87$export$68d8715fc104d294 = 'write';
var $25d70bd1609b2a87$export$70a6e5159acce2e6 = 'afterWrite';
var $25d70bd1609b2a87$export$d087d3878fdf71d5 = [
    $25d70bd1609b2a87$export$421679a7c3d56e,
    $25d70bd1609b2a87$export$aafa59e2e03f2942,
    $25d70bd1609b2a87$export$6964f6c886723980,
    $25d70bd1609b2a87$export$c65e99957a05207c,
    $25d70bd1609b2a87$export$f22da7240b7add18,
    $25d70bd1609b2a87$export$bab79516f2d662fe,
    $25d70bd1609b2a87$export$8d4d2d70e7d46032,
    $25d70bd1609b2a87$export$68d8715fc104d294,
    $25d70bd1609b2a87$export$70a6e5159acce2e6
];


function $3198752cd986c00a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3198752cd986c00a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3198752cd986c00a$var$order(modifiers); // order based on phase
    return (0, $25d70bd1609b2a87$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $42cd88fa4413fe28$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $11dc37bc11ef3fcc$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
            options: Object.assign(Object.assign({}, existing.options), current.options),
            data: Object.assign(Object.assign({}, existing.data), current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $46af0323a6abcb1b$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $46af0323a6abcb1b$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $46af0323a6abcb1b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $46af0323a6abcb1b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $46af0323a6abcb1b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $46af0323a6abcb1b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign(Object.assign({}, $46af0323a6abcb1b$var$DEFAULT_OPTIONS), defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(options) {
                cleanupModifierEffects();
                state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
                state.scrollParents = {
                    reference: (0, $345a465066cb1947$export$45a5e7f76e0caa8d)(reference) ? (0, $88cab8a4b0b9ad71$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $88cab8a4b0b9ad71$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $88cab8a4b0b9ad71$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3198752cd986c00a$export$2e2bcd8739ae039)((0, $11dc37bc11ef3fcc$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$46af0323a6abcb1b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ca6ffde5dc001448$export$2e2bcd8739ae039)(reference, (0, $7cd37187e9d2658a$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $a6230ce030a33d71$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $42cd88fa4413fe28$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$46af0323a6abcb1b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $46af0323a6abcb1b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $46af0323a6abcb1b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $22ec0bd5d839885c$var$passive = {
    passive: true
};
function $22ec0bd5d839885c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $22ec0bd5d839885c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $22ec0bd5d839885c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $22ec0bd5d839885c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $22ec0bd5d839885c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $22ec0bd5d839885c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $22ec0bd5d839885c$var$effect,
    data: {}
};



function $f1aa7510072b8873$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $a5c2dcd0e0540941$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $dbea8679a192e896$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $216f4c4011d8fa4e$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $a5c2dcd0e0540941$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $25d70bd1609b2a87$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $25d70bd1609b2a87$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $25d70bd1609b2a87$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $dbea8679a192e896$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $25d70bd1609b2a87$export$b3571188c770cc5a:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
                break;
            case 0, $25d70bd1609b2a87$export$bd5df0f255a350f8:
                offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $dd159c66b60d9d9f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $216f4c4011d8fa4e$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dd159c66b60d9d9f$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dd159c66b60d9d9f$var$popperOffsets,
    data: {}
};








var $b9a36544935dbf9e$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $b9a36544935dbf9e$var$roundOffsets(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: Math.round(x * dpr) / dpr || 0,
        y: Math.round(y * dpr) / dpr || 0
    };
}
function $b9a36544935dbf9e$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive;
    var _roundOffsets = $b9a36544935dbf9e$var$roundOffsets(offsets), x = _roundOffsets.x, y = _roundOffsets.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4);
    var sideY = (0, $25d70bd1609b2a87$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7cd37187e9d2658a$export$2e2bcd8739ae039)(popper);
        if (offsetParent === (0, $aaf7467105586a86$export$2e2bcd8739ae039)(popper)) offsetParent = (0, $21c2e5689044152f$export$2e2bcd8739ae039)(popper);
         // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        /*:: offsetParent = (offsetParent: Element); */ if (placement === (0, $25d70bd1609b2a87$export$1e95b668f3b82d)) {
            sideY = (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb);
            y -= offsetParent.clientHeight - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4)) {
            sideX = (0, $25d70bd1609b2a87$export$79ffe56a765070d2);
            x -= offsetParent.clientWidth - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $b9a36544935dbf9e$var$unsetSides);
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $b9a36544935dbf9e$var$computeStyles(_ref3) {
    var state = _ref3.state, options = _ref3.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), $b9a36544935dbf9e$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), $b9a36544935dbf9e$export$378fa78a8fea596f(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false
    })));
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b9a36544935dbf9e$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $b9a36544935dbf9e$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $e91035a8dd89f800$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $345a465066cb1947$export$1b3bfaa9684536aa)(element) || !(0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $e91035a8dd89f800$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $345a465066cb1947$export$1b3bfaa9684536aa)(element) || !(0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(element)) return;
             // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $e91035a8dd89f800$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $e91035a8dd89f800$var$applyStyles,
    effect: $e91035a8dd89f800$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $11cdccfffc677917$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4),
        (0, $25d70bd1609b2a87$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4),
        (0, $25d70bd1609b2a87$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $11cdccfffc677917$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $25d70bd1609b2a87$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $11cdccfffc677917$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $11cdccfffc677917$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $11cdccfffc677917$var$offset
};


var $13039bb3ed5a7277$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $13039bb3ed5a7277$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $13039bb3ed5a7277$var$hash[matched];
    });
}



var $b8717e01429be84d$var$hash = {
    start: 'end',
    end: 'start'
};
function $b8717e01429be84d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b8717e01429be84d$var$hash[matched];
    });
}







function $c6adfffbeee782d0$export$2e2bcd8739ae039(element) {
    var win = (0, $aaf7467105586a86$export$2e2bcd8739ae039)(element);
    var html = (0, $21c2e5689044152f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $0e33231b88c9bd44$export$2e2bcd8739ae039)(element),
        y: y
    };
}






function $0d1c7b5303b31d42$export$2e2bcd8739ae039(element) {
    var html = (0, $21c2e5689044152f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $6367186e3c6eccec$export$2e2bcd8739ae039)(element);
    var body = element.ownerDocument.body;
    var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $0e33231b88c9bd44$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}









function $acceb1b09fdae508$export$2e2bcd8739ae039(parent, child) {
    // $FlowFixMe: hasOwnProperty doesn't seem to work in tests
    var isShadow = Boolean(child.getRootNode && child.getRootNode().host); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (isShadow) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $33bbbdde8bf86228$export$2e2bcd8739ae039(rect) {
    return Object.assign(Object.assign({}, rect), {}, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}


function $13f29a7f85b3308f$var$getInnerBoundingClientRect(element) {
    var rect = (0, $c5a26f45c361af74$export$2e2bcd8739ae039)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $13f29a7f85b3308f$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $25d70bd1609b2a87$export$d7b7311ec04a3e8f) ? (0, $33bbbdde8bf86228$export$2e2bcd8739ae039)((0, $c6adfffbeee782d0$export$2e2bcd8739ae039)(element)) : (0, $345a465066cb1947$export$1b3bfaa9684536aa)(clippingParent) ? $13f29a7f85b3308f$var$getInnerBoundingClientRect(clippingParent) : (0, $33bbbdde8bf86228$export$2e2bcd8739ae039)((0, $0d1c7b5303b31d42$export$2e2bcd8739ae039)((0, $21c2e5689044152f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $13f29a7f85b3308f$var$getClippingParents(element) {
    var clippingParents = (0, $88cab8a4b0b9ad71$export$2e2bcd8739ae039)((0, $7e75def03d12fe60$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $626f843f8b0ac0f6$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $345a465066cb1947$export$1b3bfaa9684536aa)(element) ? (0, $7cd37187e9d2658a$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $345a465066cb1947$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $345a465066cb1947$export$45a5e7f76e0caa8d)(clippingParent) && (0, $acceb1b09fdae508$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $39cb79e34e2847b0$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $13f29a7f85b3308f$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $13f29a7f85b3308f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $13f29a7f85b3308f$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = Math.max(rect.top, accRect.top);
        accRect.right = Math.min(rect.right, accRect.right);
        accRect.bottom = Math.min(rect.bottom, accRect.bottom);
        accRect.left = Math.max(rect.left, accRect.left);
        return accRect;
    }, $13f29a7f85b3308f$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}







function $06de027e65469280$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $708117178449ee6d$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign(Object.assign({}, (0, $06de027e65469280$export$2e2bcd8739ae039)()), paddingObject);
}


function $9fb8c26184fce244$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $7d05a083d311379b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $25d70bd1609b2a87$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $25d70bd1609b2a87$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $25d70bd1609b2a87$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $708117178449ee6d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $9fb8c26184fce244$export$2e2bcd8739ae039)(padding, (0, $25d70bd1609b2a87$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $25d70bd1609b2a87$export$ae5ab1c730825774) ? (0, $25d70bd1609b2a87$export$ca50aac9f3ba507f) : (0, $25d70bd1609b2a87$export$ae5ab1c730825774);
    var referenceElement = state.elements.reference;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $13f29a7f85b3308f$export$2e2bcd8739ae039)((0, $345a465066cb1947$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $21c2e5689044152f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $c5a26f45c361af74$export$2e2bcd8739ae039)(referenceElement);
    var popperOffsets = (0, $216f4c4011d8fa4e$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $33bbbdde8bf86228$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, popperRect), popperOffsets));
    var elementClientRect = elementContext === (0, $25d70bd1609b2a87$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $25d70bd1609b2a87$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $25d70bd1609b2a87$export$79ffe56a765070d2),
                (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $25d70bd1609b2a87$export$1e95b668f3b82d),
                (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $37af5be66514a271$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $25d70bd1609b2a87$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $a5c2dcd0e0540941$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $25d70bd1609b2a87$export$368f9a87e87fa4e1) : (0, $25d70bd1609b2a87$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $a5c2dcd0e0540941$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $25d70bd1609b2a87$export$aec2ce47c367b8c3); // $FlowFixMe
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7d05a083d311379b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $05cc67597f79dc0f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement) === (0, $25d70bd1609b2a87$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $13039bb3ed5a7277$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b8717e01429be84d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b8717e01429be84d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $05cc67597f79dc0f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $13039bb3ed5a7277$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $05cc67597f79dc0f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement) === (0, $25d70bd1609b2a87$export$dfb5619354ba860) ? (0, $37af5be66514a271$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $a5c2dcd0e0540941$export$2e2bcd8739ae039)(placement) === (0, $25d70bd1609b2a87$export$b3571188c770cc5a);
        var isVertical = [
            (0, $25d70bd1609b2a87$export$1e95b668f3b82d),
            (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $7d05a083d311379b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $25d70bd1609b2a87$export$79ffe56a765070d2) : (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb) : (0, $25d70bd1609b2a87$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $13039bb3ed5a7277$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $13039bb3ed5a7277$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $05cc67597f79dc0f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $05cc67597f79dc0f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $957f71ac6831c879$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}


function $31f897b690dbbb22$export$2e2bcd8739ae039(min, value, max) {
    return Math.max(min, Math.min(value, max));
}







function $ea9e7f21d17923ff$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7d05a083d311379b$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $a5c2dcd0e0540941$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $dbea8679a192e896$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $957f71ac6831c879$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
        placement: state.placement
    })) : tetherOffset;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var mainSide = mainAxis === 'y' ? (0, $25d70bd1609b2a87$export$1e95b668f3b82d) : (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb) : (0, $25d70bd1609b2a87$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = popperOffsets[mainAxis] + overflow[mainSide];
        var max = popperOffsets[mainAxis] - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $25d70bd1609b2a87$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $25d70bd1609b2a87$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $a6230ce030a33d71$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $06de027e65469280$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $31f897b690dbbb22$export$2e2bcd8739ae039)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
        var arrowOffsetParent = state.elements.arrow && (0, $7cd37187e9d2658a$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
        var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $31f897b690dbbb22$export$2e2bcd8739ae039)(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _mainSide = mainAxis === 'x' ? (0, $25d70bd1609b2a87$export$1e95b668f3b82d) : (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb) : (0, $25d70bd1609b2a87$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var _preventedOffset = (0, $31f897b690dbbb22$export$2e2bcd8739ae039)(_min, _offset, _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ea9e7f21d17923ff$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ea9e7f21d17923ff$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};












function $0225f00e75843466$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f1aa7510072b8873$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $dbea8679a192e896$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4),
        (0, $25d70bd1609b2a87$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = state.modifiersData[name + "#persistent"].padding;
    var arrowRect = (0, $a6230ce030a33d71$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $25d70bd1609b2a87$export$1e95b668f3b82d) : (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb) : (0, $25d70bd1609b2a87$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7cd37187e9d2658a$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $31f897b690dbbb22$export$2e2bcd8739ae039)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0225f00e75843466$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element, _options$padding = options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $acceb1b09fdae508$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
    state.modifiersData[name + "#persistent"] = {
        padding: (0, $708117178449ee6d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $9fb8c26184fce244$export$2e2bcd8739ae039)(padding, (0, $25d70bd1609b2a87$export$aec2ce47c367b8c3)))
    };
} // eslint-disable-next-line import/no-unused-modules
var $0225f00e75843466$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0225f00e75843466$var$arrow,
    effect: $0225f00e75843466$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $d032a9ffb8abf715$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d032a9ffb8abf715$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $25d70bd1609b2a87$export$1e95b668f3b82d),
        (0, $25d70bd1609b2a87$export$79ffe56a765070d2),
        (0, $25d70bd1609b2a87$export$40e543e69a8b3fbb),
        (0, $25d70bd1609b2a87$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d032a9ffb8abf715$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7d05a083d311379b$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $7d05a083d311379b$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d032a9ffb8abf715$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d032a9ffb8abf715$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d032a9ffb8abf715$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d032a9ffb8abf715$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d032a9ffb8abf715$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d032a9ffb8abf715$var$hide
};


var $930ac3ceabc616b9$export$d34966752335dd47 = [
    (0, $22ec0bd5d839885c$export$2e2bcd8739ae039),
    (0, $dd159c66b60d9d9f$export$2e2bcd8739ae039),
    (0, $b9a36544935dbf9e$export$2e2bcd8739ae039),
    (0, $e91035a8dd89f800$export$2e2bcd8739ae039),
    (0, $11cdccfffc677917$export$2e2bcd8739ae039),
    (0, $05cc67597f79dc0f$export$2e2bcd8739ae039),
    (0, $ea9e7f21d17923ff$export$2e2bcd8739ae039),
    (0, $0225f00e75843466$export$2e2bcd8739ae039),
    (0, $d032a9ffb8abf715$export$2e2bcd8739ae039)
];
var $930ac3ceabc616b9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $46af0323a6abcb1b$export$ed5e13716264f202)({
    defaultModifiers: $930ac3ceabc616b9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $denZA = parcelRequire("denZA");
function $c6107975fa403d0f$var$_extends() {
    $c6107975fa403d0f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6107975fa403d0f$var$_extends.apply(this, arguments);
}
var $c6107975fa403d0f$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? "var(" + value + ", " + fallback + ")" : "var(" + value + ")"
    });
var $c6107975fa403d0f$export$fd62969fb0b7081c = {
    arrowShadowColor: $c6107975fa403d0f$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $c6107975fa403d0f$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $c6107975fa403d0f$var$toVar("--popper-arrow-size-half"),
    arrowBg: $c6107975fa403d0f$var$toVar("--popper-arrow-bg"),
    transformOrigin: $c6107975fa403d0f$var$toVar("--popper-transform-origin"),
    arrowOffset: $c6107975fa403d0f$var$toVar("--popper-arrow-offset")
};
function $c6107975fa403d0f$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return "1px 1px 1px 0 var(--popper-arrow-shadow-color)";
    if (placement.includes("bottom")) return "-1px -1px 1px 0 var(--popper-arrow-shadow-color)";
    if (placement.includes("right")) return "-1px 1px 1px 0 var(--popper-arrow-shadow-color)";
    if (placement.includes("left")) return "1px -1px 1px 0 var(--popper-arrow-shadow-color)";
}
var $c6107975fa403d0f$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
var $c6107975fa403d0f$export$4b94194e48e4ec29 = (placement)=>$c6107975fa403d0f$var$transforms[placement];
var $c6107975fa403d0f$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $c6107975fa403d0f$export$fafd30a196ad8838(value) {
    var eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: $c6107975fa403d0f$var$_extends({}, $c6107975fa403d0f$var$defaultEventListeners, value)
    };
    else eventListeners = {
        enabled: value,
        options: $c6107975fa403d0f$var$defaultEventListeners
    };
    return eventListeners;
}


var $cbc2942d8e2d7788$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: (_ref)=>{
        var { state: state } = _ref;
        state.styles.popper.width = state.rects.reference.width + "px";
    },
    effect: (_ref2)=>{
        var { state: state } = _ref2;
        return ()=>{
            var reference = state.elements.reference;
            state.elements.popper.style.width = reference.offsetWidth + "px";
        };
    }
};
var $cbc2942d8e2d7788$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: (_ref3)=>{
        var { state: state } = _ref3;
        $cbc2942d8e2d7788$var$setTransformOrigin(state);
    },
    effect: (_ref4)=>{
        var { state: state } = _ref4;
        return ()=>{
            $cbc2942d8e2d7788$var$setTransformOrigin(state);
        };
    }
};
var $cbc2942d8e2d7788$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $c6107975fa403d0f$export$fd62969fb0b7081c).transformOrigin.var, (0, $c6107975fa403d0f$export$4b94194e48e4ec29)(state.placement));
};
var $cbc2942d8e2d7788$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: (_ref5)=>{
        var { state: state } = _ref5;
        $cbc2942d8e2d7788$var$setArrowStyles(state);
    }
};
var $cbc2942d8e2d7788$var$setArrowStyles = (state)=>{
    var _state$elements;
    if (!state.placement) return;
    var overrides = $cbc2942d8e2d7788$var$getArrowStyle(state.placement);
    if ((_state$elements = state.elements) != null && _state$elements.arrow && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        var vars = {
            [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSizeHalf.var]: "calc(" + (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSize.varRef + " / 2)",
            [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowOffset.var]: "calc(" + (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSizeHalf.varRef + " * -1)"
        };
        for(var property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
var $cbc2942d8e2d7788$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
var $cbc2942d8e2d7788$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: (_ref6)=>{
        var { state: state } = _ref6;
        $cbc2942d8e2d7788$var$setInnerArrowStyles(state);
    },
    effect: (_ref7)=>{
        var { state: state } = _ref7;
        return ()=>{
            $cbc2942d8e2d7788$var$setInnerArrowStyles(state);
        };
    }
};
var $cbc2942d8e2d7788$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    var inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: (0, $c6107975fa403d0f$export$bba5a971afe05444)(state.placement)
    });
};



function $e0cfb75a998fb7e2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0cfb75a998fb7e2$var$_extends() {
    $e0cfb75a998fb7e2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0cfb75a998fb7e2$var$_extends.apply(this, arguments);
}
function $e0cfb75a998fb7e2$export$f4d5bf230a36dd6e(props) {
    if (props === void 0) props = {};
    var { enabled: enabled = true, modifiers: modifiers = [], placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth } = props;
    var reference = (0, $denZA.useRef)(null);
    var popper = (0, $denZA.useRef)(null);
    var instance = (0, $denZA.useRef)(null);
    var cleanup = (0, $denZA.useRef)(()=>{});
    var setupPopper = (0, $denZA.useCallback)(()=>{
        if (!enabled || !reference.current || !popper.current) return; // If popper instance exists, destroy it so we can create a new one
        cleanup.current == null || cleanup.current();
        instance.current = (0, $930ac3ceabc616b9$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placementProp,
            modifiers: [
                $cbc2942d8e2d7788$export$616f7fc4ffce8510,
                $cbc2942d8e2d7788$export$36f2614d91c73bb6,
                $cbc2942d8e2d7788$export$bd7bb1bc943e0611,
                $e0cfb75a998fb7e2$var$_extends({}, $cbc2942d8e2d7788$export$45d38cc6268103c7, {
                    enabled: !!matchWidth
                }),
                $e0cfb75a998fb7e2$var$_extends({
                    name: "eventListeners"
                }, (0, $c6107975fa403d0f$export$fafd30a196ad8838)(eventListeners)),
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset != null ? offset : [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                ...modifiers
            ],
            strategy: strategy
        }); // force update one-time to fix any positioning issues
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        enabled,
        placementProp,
        modifiers,
        matchWidth,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $denZA.useEffect)(()=>{
        return ()=>{
            /**
       * Fast refresh might call this function and tear down the popper
       * even if the reference still exists. This checks against that
       */ if (!reference.current && !popper.current) {
                var _instance$current;
                (_instance$current = instance.current) == null || _instance$current.destroy();
                instance.current = null;
            }
        };
    }, []);
    var referenceRef = (0, $denZA.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    var getReferenceProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $e0cfb75a998fb7e2$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(referenceRef, ref)
        });
    }, [
        referenceRef
    ]);
    var popperRef = (0, $denZA.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    var getPopperProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $e0cfb75a998fb7e2$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(popperRef, ref),
            style: $e0cfb75a998fb7e2$var$_extends({}, props.style, {
                position: strategy,
                minWidth: "max-content",
                inset: "0 auto auto 0"
            })
        });
    }, [
        strategy,
        popperRef
    ]);
    var getArrowProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        var rest = $e0cfb75a998fb7e2$var$_objectWithoutPropertiesLoose(props, [
            "size",
            "shadowColor",
            "bg",
            "style"
        ]);
        return $e0cfb75a998fb7e2$var$_extends({}, rest, {
            ref: ref,
            "data-popper-arrow": "",
            style: $e0cfb75a998fb7e2$var$getArrowStyle(props)
        });
    }, []);
    var getArrowInnerProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $e0cfb75a998fb7e2$var$_extends({}, props, {
            ref: ref,
            "data-popper-arrow-inner": ""
        });
    }, []);
    return {
        update () {
            var _instance$current2;
            (_instance$current2 = instance.current) == null || _instance$current2.update();
        },
        forceUpdate () {
            var _instance$current3;
            (_instance$current3 = instance.current) == null || _instance$current3.forceUpdate();
        },
        transformOrigin: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $e0cfb75a998fb7e2$var$getArrowStyle(props) {
    var { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    var computedStyle = $e0cfb75a998fb7e2$var$_extends({}, style, {
        position: "absolute"
    });
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}



/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $5567c7a86419f354$export$1f16c1e83f5de19d(options) {
    var { hasBeenSelected: hasBeenSelected, isLazy: isLazy, isSelected: isSelected, lazyBehavior: lazyBehavior = "unmount" } = options; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}



var $denZA = parcelRequire("denZA");
function $bfd29e9600d94362$var$_extends() {
    $bfd29e9600d94362$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfd29e9600d94362$var$_extends.apply(this, arguments);
}
function $bfd29e9600d94362$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$bfd29e9600d94362$export$6bd12c048acae948, $bfd29e9600d94362$export$fb081774625c317c, $bfd29e9600d94362$export$c383d7d91778257e, $bfd29e9600d94362$export$e44adeffd1a0865c] = (0, $a709b5585b66f1e1$export$126c4100f8947d7)();
var [$bfd29e9600d94362$export$62b22d151866115d, $bfd29e9600d94362$export$21c7ab35b39f78ec] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    strict: false,
    name: "MenuContext"
});
function $bfd29e9600d94362$export$38eaa17faae8f579(props) {
    if (props === void 0) props = {};
    var { id: id, closeOnSelect: closeOnSelect = true, closeOnBlur: closeOnBlur = true, autoSelect: autoSelect = true, isLazy: isLazy, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, onClose: onCloseProp, onOpen: onOpenProp, placement: placement = "bottom-start", lazyBehavior: lazyBehavior = "unmount", computePositionOnMount: computePositionOnMount } = props, popperProps = $bfd29e9600d94362$var$_objectWithoutPropertiesLoose(props, [
        "id",
        "closeOnSelect",
        "closeOnBlur",
        "autoSelect",
        "isLazy",
        "isOpen",
        "defaultIsOpen",
        "onClose",
        "onOpen",
        "placement",
        "lazyBehavior",
        "computePositionOnMount"
    ]);
    var { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle } = (0, $528efd7f0c9e3374$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onClose: onCloseProp,
        onOpen: onOpenProp
    });
    /**
   * Prepare the reference to the menu and disclosure
   */ var menuRef = $denZA.useRef(null);
    var buttonRef = $denZA.useRef(null);
    (0, $7882820c20d771da$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: menuRef,
        handler: (event)=>{
            var _buttonRef$current;
            if (!((_buttonRef$current = buttonRef.current) != null && _buttonRef$current.contains(event.target))) onClose();
        }
    });
    /**
   * Add some popper.js for dynamic positioning
   */ var popper = (0, $e0cfb75a998fb7e2$export$f4d5bf230a36dd6e)($bfd29e9600d94362$var$_extends({}, popperProps, {
        enabled: isOpen || computePositionOnMount,
        placement: placement
    }));
    var [focusedIndex, setFocusedIndex] = $denZA.useState(-1);
    /**
   * Context to register all menu item nodes
   */ var descendants = $bfd29e9600d94362$export$c383d7d91778257e();
    /**
   * Focus the button when we close the menu
   */ (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        if (!isOpen) setFocusedIndex(-1);
    }, [
        isOpen
    ]);
    (0, $24f8a6fb2f29f586$export$68b323438c1fbb28)(menuRef, {
        focusRef: buttonRef,
        visible: isOpen,
        shouldFocus: true
    });
    /**
   * Generate unique ids for menu's list and button
   */ var [buttonId, menuId] = (0, $63207b263e1aef60$export$365c04e2f432779)(id, "menu-button", "menu-list");
    var openAndFocusMenu = $denZA.useCallback(()=>{
        onOpen();
        (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(menuRef.current, {
            nextTick: true,
            selectTextIfInput: false
        });
    }, [
        onOpen,
        menuRef
    ]);
    var timeoutIds = $denZA.useRef(new Set([]));
    (0, $c29482a8d6079d59$export$f3a192d0cbd30b96)(()=>{
        timeoutIds.current.forEach((id)=>clearTimeout(id));
        timeoutIds.current.clear();
    });
    var openAndFocusFirstItem = $denZA.useCallback(()=>{
        onOpen();
        var id = setTimeout(()=>{
            var first = descendants.firstEnabled();
            if (first) setFocusedIndex(first.index);
        });
        timeoutIds.current.add(id);
    }, [
        onOpen,
        setFocusedIndex,
        descendants
    ]);
    var openAndFocusLastItem = $denZA.useCallback(()=>{
        onOpen();
        var id = setTimeout(()=>{
            var last = descendants.lastEnabled();
            if (last) setFocusedIndex(last.index);
        });
        timeoutIds.current.add(id);
    }, [
        onOpen,
        setFocusedIndex,
        descendants
    ]);
    var refocus = $denZA.useCallback(()=>{
        var _menuRef$current, _descendants$item;
        var doc = (0, $405775388fe7f58e$export$b204af158042fbac)(menuRef.current);
        var hasFocusWithin = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(doc.activeElement);
        var shouldRefocus = isOpen && !hasFocusWithin;
        if (!shouldRefocus) return;
        var node = (_descendants$item = descendants.item(focusedIndex)) == null ? void 0 : _descendants$item.node;
        if (node) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(node, {
            selectTextIfInput: false,
            preventScroll: false
        });
    }, [
        isOpen,
        focusedIndex,
        descendants
    ]);
    return {
        openAndFocusMenu: openAndFocusMenu,
        openAndFocusFirstItem: openAndFocusFirstItem,
        openAndFocusLastItem: openAndFocusLastItem,
        onTransitionEnd: refocus,
        descendants: descendants,
        popper: popper,
        buttonId: buttonId,
        menuId: menuId,
        forceUpdate: popper.forceUpdate,
        orientation: "vertical",
        isOpen: isOpen,
        onToggle: onToggle,
        onOpen: onOpen,
        onClose: onClose,
        menuRef: menuRef,
        buttonRef: buttonRef,
        focusedIndex: focusedIndex,
        closeOnSelect: closeOnSelect,
        closeOnBlur: closeOnBlur,
        autoSelect: autoSelect,
        setFocusedIndex: setFocusedIndex,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior
    };
}
function $bfd29e9600d94362$export$660510f872408795(props, externalRef) {
    if (props === void 0) props = {};
    if (externalRef === void 0) externalRef = null;
    var menu = $bfd29e9600d94362$export$21c7ab35b39f78ec();
    var { isOpen: isOpen, onClose: onClose, autoSelect: autoSelect, popper: popper, openAndFocusFirstItem: openAndFocusFirstItem, openAndFocusLastItem: openAndFocusLastItem, openAndFocusMenu: openAndFocusMenu } = menu;
    var onClick = $denZA.useCallback(()=>{
        if (isOpen) onClose();
        else {
            var action = autoSelect ? openAndFocusFirstItem : openAndFocusMenu;
            action();
        }
    }, [
        autoSelect,
        isOpen,
        onClose,
        openAndFocusFirstItem,
        openAndFocusMenu
    ]);
    var onKeyDown = $denZA.useCallback((event)=>{
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var keyMap = {
            Enter: openAndFocusFirstItem,
            ArrowDown: openAndFocusFirstItem,
            ArrowUp: openAndFocusLastItem
        };
        var action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
        }
    }, [
        openAndFocusFirstItem,
        openAndFocusLastItem
    ]);
    return $bfd29e9600d94362$var$_extends({}, props, {
        ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(menu.buttonRef, externalRef, popper.referenceRef),
        id: menu.buttonId,
        "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(menu.isOpen),
        "aria-expanded": menu.isOpen,
        "aria-haspopup": "menu",
        "aria-controls": menu.menuId,
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onClick),
        onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    });
}
function $bfd29e9600d94362$var$isTargetMenuItem(target) {
    var _target$getAttribute;
    // this will catch `menuitem`, `menuitemradio`, `menuitemcheckbox`
    return (0, $405775388fe7f58e$export$1b3bfaa9684536aa)(target) && !!((_target$getAttribute = target.getAttribute("role")) != null && _target$getAttribute.startsWith("menuitem"));
}
function $bfd29e9600d94362$export$8dcac42583be8292(props, ref) {
    if (props === void 0) props = {};
    if (ref === void 0) ref = null;
    var menu = $bfd29e9600d94362$export$21c7ab35b39f78ec();
    if (!menu) throw new Error("useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>");
    var { focusedIndex: focusedIndex, setFocusedIndex: setFocusedIndex, menuRef: menuRef, isOpen: isOpen, onClose: onClose, menuId: menuId, isLazy: isLazy, lazyBehavior: lazyBehavior } = menu;
    var descendants = $bfd29e9600d94362$export$fb081774625c317c();
    /**
   * Hook that creates a keydown event handler that listens
   * to printable keyboard character press
   */ var createTypeaheadHandler = (0, $05a0e2fb4e1da0b9$export$b0ebbe7904d8d94a)({
        preventDefault: (event)=>event.key !== " " && $bfd29e9600d94362$var$isTargetMenuItem(event.target)
    });
    var onKeyDown = $denZA.useCallback((event)=>{
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var keyMap = {
            Tab: (event)=>event.preventDefault(),
            Escape: onClose,
            ArrowDown: ()=>{
                var next = descendants.nextEnabled(focusedIndex);
                if (next) setFocusedIndex(next.index);
            },
            ArrowUp: ()=>{
                var prev = descendants.prevEnabled(focusedIndex);
                if (prev) setFocusedIndex(prev.index);
            }
        };
        var fn = keyMap[eventKey];
        if (fn) {
            event.preventDefault();
            fn(event);
            return;
        }
        /**
     * Typeahead: Based on current character pressed,
     * find the next item to be selected
     */ var onTypeahead = createTypeaheadHandler((character)=>{
            var nextItem = (0, $4cb94e5c0fd5e9d1$export$18ed781d9da46f95)(descendants.values(), character, (item)=>{
                var _item$node$textConten, _item$node;
                return (_item$node$textConten = item == null ? void 0 : (_item$node = item.node) == null ? void 0 : _item$node.textContent) != null ? _item$node$textConten : "";
            }, descendants.item(focusedIndex));
            if (nextItem) {
                var index = descendants.indexOf(nextItem.node);
                setFocusedIndex(index);
            }
        });
        if ($bfd29e9600d94362$var$isTargetMenuItem(event.target)) onTypeahead(event);
    }, [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex
    ]);
    var hasBeenOpened = $denZA.useRef(false);
    if (isOpen) hasBeenOpened.current = true;
    var shouldRenderChildren = (0, $5567c7a86419f354$export$1f16c1e83f5de19d)({
        hasBeenSelected: hasBeenOpened.current,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        isSelected: isOpen
    });
    return $bfd29e9600d94362$var$_extends({}, props, {
        ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(menuRef, ref),
        children: shouldRenderChildren ? props.children : null,
        tabIndex: -1,
        role: "menu",
        id: menuId,
        style: $bfd29e9600d94362$var$_extends({}, props.style, {
            transformOrigin: "var(--popper-transform-origin)"
        }),
        "aria-orientation": "vertical",
        onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    });
}
function $bfd29e9600d94362$export$5149508ab5f84d86(props) {
    if (props === void 0) props = {};
    var { popper: popper, isOpen: isOpen } = $bfd29e9600d94362$export$21c7ab35b39f78ec();
    return popper.getPopperProps($bfd29e9600d94362$var$_extends({}, props, {
        style: $bfd29e9600d94362$var$_extends({
            visibility: isOpen ? "visible" : "hidden"
        }, props.style)
    }));
}
function $bfd29e9600d94362$export$9d32628fc2aea7da(props, externalRef) {
    if (props === void 0) props = {};
    if (externalRef === void 0) externalRef = null;
    var { onMouseEnter: onMouseEnterProp, onMouseMove: onMouseMoveProp, onMouseLeave: onMouseLeaveProp, onClick: onClickProp, isDisabled: isDisabled, isFocusable: isFocusable, closeOnSelect: closeOnSelect } = props, htmlProps = $bfd29e9600d94362$var$_objectWithoutPropertiesLoose(props, [
        "onMouseEnter",
        "onMouseMove",
        "onMouseLeave",
        "onClick",
        "isDisabled",
        "isFocusable",
        "closeOnSelect"
    ]);
    var menu = $bfd29e9600d94362$export$21c7ab35b39f78ec();
    var { setFocusedIndex: setFocusedIndex, focusedIndex: focusedIndex, closeOnSelect: menuCloseOnSelect, onClose: onClose, menuRef: menuRef, isOpen: isOpen, menuId: menuId } = menu;
    var ref = $denZA.useRef(null);
    var id = menuId + "-menuitem-" + (0, $63207b263e1aef60$export$f680877a34711e37)();
    /**
   * Register the menuitem's node into the domContext
   */ var { index: index, register: register } = $bfd29e9600d94362$export$e44adeffd1a0865c({
        disabled: isDisabled && !isFocusable
    });
    var onMouseEnter = $denZA.useCallback((event)=>{
        onMouseEnterProp == null || onMouseEnterProp(event);
        if (isDisabled) return;
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index,
        isDisabled,
        onMouseEnterProp
    ]);
    var onMouseMove = $denZA.useCallback((event)=>{
        onMouseMoveProp == null || onMouseMoveProp(event);
        if (ref.current && !(0, $e8db4866fc051e33$export$8a2eb51c14bb8899)(ref.current)) onMouseEnter(event);
    }, [
        onMouseEnter,
        onMouseMoveProp
    ]);
    var onMouseLeave = $denZA.useCallback((event)=>{
        onMouseLeaveProp == null || onMouseLeaveProp(event);
        if (isDisabled) return;
        setFocusedIndex(-1);
    }, [
        setFocusedIndex,
        isDisabled,
        onMouseLeaveProp
    ]);
    var onClick = $denZA.useCallback((event)=>{
        onClickProp == null || onClickProp(event);
        if (!$bfd29e9600d94362$var$isTargetMenuItem(event.currentTarget)) return;
        /**
     * Close menu and parent menus, allowing the MenuItem
     * to override its parent menu's `closeOnSelect` prop.
     */ if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) onClose();
    }, [
        onClose,
        onClickProp,
        menuCloseOnSelect,
        closeOnSelect
    ]);
    var isFocused = index === focusedIndex;
    var trulyDisabled = isDisabled && !isFocusable;
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        if (!isOpen) return;
        if (isFocused && !trulyDisabled && ref.current) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(ref.current, {
            nextTick: true,
            selectTextIfInput: false,
            preventScroll: false
        });
        else if (menuRef.current && !(0, $e8db4866fc051e33$export$8a2eb51c14bb8899)(menuRef.current)) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(menuRef.current, {
            preventScroll: false
        });
    }, [
        isFocused,
        trulyDisabled,
        menuRef,
        isOpen
    ]);
    var clickableProps = (0, $7471193ff97457bc$export$ed213cc82e426b1a)({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(register, ref, externalRef),
        isDisabled: isDisabled,
        isFocusable: isFocusable
    });
    return $bfd29e9600d94362$var$_extends({}, htmlProps, clickableProps, {
        id: id,
        role: "menuitem",
        tabIndex: isFocused ? 0 : -1
    });
}
function $bfd29e9600d94362$export$8ca3fd7c19c454af(props, ref) {
    if (props === void 0) props = {};
    if (ref === void 0) ref = null;
    var { type: type = "radio", isChecked: isChecked } = props, rest = $bfd29e9600d94362$var$_objectWithoutPropertiesLoose(props, [
        "type",
        "isChecked"
    ]);
    var ownProps = $bfd29e9600d94362$export$9d32628fc2aea7da(rest, ref);
    return $bfd29e9600d94362$var$_extends({}, ownProps, {
        role: "menuitem" + type,
        "aria-checked": isChecked
    });
}
function $bfd29e9600d94362$export$9dcb3089500f52be(props) {
    if (props === void 0) props = {};
    var { children: children, type: type = "radio", value: valueProp, defaultValue: defaultValue, onChange: onChangeProp } = props, htmlProps = $bfd29e9600d94362$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "type",
        "value",
        "defaultValue",
        "onChange"
    ]);
    var isRadio = type === "radio";
    var fallback = isRadio ? "" : [];
    var [value, setValue] = (0, $53a3d6ee771ef939$export$6f32135080cb4c3)({
        defaultValue: defaultValue != null ? defaultValue : fallback,
        value: valueProp,
        onChange: onChangeProp
    });
    var onChange = $denZA.useCallback((selectedValue)=>{
        if (type === "radio" && (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(value)) setValue(selectedValue);
        if (type === "checkbox" && (0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(value)) {
            var nextValue = value.includes(selectedValue) ? (0, $4cb94e5c0fd5e9d1$export$fe2d9b4e03920b4c)(value, selectedValue) : (0, $4cb94e5c0fd5e9d1$export$fb9705de59d96855)(value, selectedValue);
            setValue(nextValue);
        }
    }, [
        value,
        setValue,
        type
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var clones = validChildren.map((child)=>{
        /**
     * We've added an internal `id` to each `MenuItemOption`,
     * let's use that for type-checking.
     *
     * We can't rely on displayName or the element's type since
     * they can be changed by the user.
     */ if (child.type.id !== "MenuItemOption") return child;
        var onClick = (event)=>{
            onChange(child.props.value);
            child.props.onClick == null || child.props.onClick(event);
        };
        var isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
        return /*#__PURE__*/ $denZA.cloneElement(child, {
            type: type,
            onClick: onClick,
            isChecked: isChecked
        });
    });
    return $bfd29e9600d94362$var$_extends({}, htmlProps, {
        children: clones
    });
}
function $bfd29e9600d94362$export$8091e3849c182a6() {
    var { isOpen: isOpen, onClose: onClose } = $bfd29e9600d94362$export$21c7ab35b39f78ec();
    return {
        isOpen: isOpen,
        onClose: onClose
    };
}


function $7bbd5491a0dd17e7$var$_extends() {
    $7bbd5491a0dd17e7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7bbd5491a0dd17e7$var$_extends.apply(this, arguments);
}
function $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7bbd5491a0dd17e7$export$d9b273488cd8ce6f = (props)=>{
    var { children: children } = props;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Menu", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var _useMenu = (0, $bfd29e9600d94362$export$38eaa17faae8f579)(ownProps), { descendants: descendants } = _useMenu, ctx = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(_useMenu, [
        "descendants"
    ]);
    var context = $denZA.useMemo(()=>ctx, [
        ctx
    ]);
    var { isOpen: isOpen, onClose: onClose, forceUpdate: forceUpdate } = context;
    return /*#__PURE__*/ $denZA.createElement((0, $bfd29e9600d94362$export$6bd12c048acae948), {
        value: descendants
    }, /*#__PURE__*/ $denZA.createElement((0, $bfd29e9600d94362$export$62b22d151866115d), {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(children, {
        isOpen: isOpen,
        onClose: onClose,
        forceUpdate: forceUpdate
    }))));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$d9b273488cd8ce6f.displayName = "Menu";
var $7bbd5491a0dd17e7$var$StyledMenuButton = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $7bbd5491a0dd17e7$var$_extends({
        ref: ref
    }, props, {
        __css: $7bbd5491a0dd17e7$var$_extends({
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            outline: 0
        }, styles.button)
    }));
});
var $7bbd5491a0dd17e7$export$266a769812832828 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { as: As } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "as"
    ]);
    var buttonProps = (0, $bfd29e9600d94362$export$660510f872408795)(rest, ref);
    var Element = As || $7bbd5491a0dd17e7$var$StyledMenuButton;
    return /*#__PURE__*/ $denZA.createElement(Element, $7bbd5491a0dd17e7$var$_extends({}, buttonProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__menu-button", props.className)
    }), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, {
        __css: {
            pointerEvents: "none",
            flex: "1 1 auto",
            minW: 0
        }
    }, props.children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$266a769812832828.displayName = "MenuButton";
var $7bbd5491a0dd17e7$var$motionVariants = {
    enter: {
        visibility: "visible",
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        transitionEnd: {
            visibility: "hidden"
        },
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.1,
            easings: "easeOut"
        }
    }
}; // @future: only call `motion(chakra.div)` when we drop framer-motion v3 support
var $7bbd5491a0dd17e7$var$MotionDiv = "custom" in (0, $92af15db400e8627$export$e25e478948902b8b) ? (0, $92af15db400e8627$export$e25e478948902b8b).custom((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div) : (0, $92af15db400e8627$export$e25e478948902b8b)((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div);
var $7bbd5491a0dd17e7$export$d4c4e98c5044dc8 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _props$zIndex, _styles$list;
    var { rootProps: rootProps } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "rootProps"
    ]);
    var { isOpen: isOpen, onTransitionEnd: onTransitionEnd } = (0, $bfd29e9600d94362$export$21c7ab35b39f78ec)();
    var menulistProps = (0, $bfd29e9600d94362$export$8dcac42583be8292)(rest, ref);
    var positionerProps = (0, $bfd29e9600d94362$export$5149508ab5f84d86)(rootProps);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $7bbd5491a0dd17e7$var$_extends({}, positionerProps, {
        __css: {
            zIndex: (_props$zIndex = props.zIndex) != null ? _props$zIndex : (_styles$list = styles.list) == null ? void 0 : _styles$list.zIndex
        }
    }), /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$var$MotionDiv, $7bbd5491a0dd17e7$var$_extends({}, menulistProps, {
        /**
     * We could call this on either `onAnimationComplete` or `onUpdate`.
     * It seems the re-focusing works better with the `onUpdate`
     */ onUpdate: onTransitionEnd,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__menu-list", menulistProps.className),
        variants: $7bbd5491a0dd17e7$var$motionVariants,
        initial: false,
        animate: isOpen ? "enter" : "exit",
        __css: $7bbd5491a0dd17e7$var$_extends({
            outline: 0
        }, styles.list)
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$d4c4e98c5044dc8.displayName = "MenuList";
var $7bbd5491a0dd17e7$var$StyledMenuItem = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { type: type } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "type"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    /**
   * Given another component, use its type if present
   * Else, use no type to avoid invalid html, e.g. <a type="button" />
   * Else, fall back to "button"
   */ var btnType = rest.as ? type != null ? type : undefined : "button";
    var buttonStyles = $7bbd5491a0dd17e7$var$_extends({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0
    }, styles.item);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $7bbd5491a0dd17e7$var$_extends({
        ref: ref,
        type: btnType
    }, rest, {
        __css: buttonStyles
    }));
});
var $7bbd5491a0dd17e7$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { icon: icon, iconSpacing: iconSpacing = "0.75rem", command: command, commandSpacing: commandSpacing = "0.75rem", children: children } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "icon",
        "iconSpacing",
        "command",
        "commandSpacing",
        "children"
    ]);
    var menuitemProps = (0, $bfd29e9600d94362$export$9d32628fc2aea7da)(rest, ref);
    var shouldWrap = icon || command;
    var _children = shouldWrap ? /*#__PURE__*/ $denZA.createElement("span", {
        style: {
            pointerEvents: "none",
            flex: 1
        }
    }, children) : children;
    return /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$var$StyledMenuItem, $7bbd5491a0dd17e7$var$_extends({}, menuitemProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__menuitem", menuitemProps.className)
    }), icon && /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$export$46e1d66043f363e6, {
        fontSize: "0.8em",
        marginEnd: iconSpacing
    }, icon), _children, command && /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$export$1fab7891e4a3c1fd, {
        marginStart: commandSpacing
    }, command));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$2ce376c2cc3355c8.displayName = "MenuItem";
var $7bbd5491a0dd17e7$var$CheckIcon = (props)=>/*#__PURE__*/ $denZA.createElement("svg", $7bbd5491a0dd17e7$var$_extends({
        viewBox: "0 0 14 14",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ $denZA.createElement("polygon", {
        fill: "currentColor",
        points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }));
var $7bbd5491a0dd17e7$export$7641072b2544de08 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { icon: icon, iconSpacing: iconSpacing = "0.75rem" } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "icon",
        "iconSpacing"
    ]);
    var optionProps = (0, $bfd29e9600d94362$export$8ca3fd7c19c454af)(rest, ref);
    return /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$var$StyledMenuItem, $7bbd5491a0dd17e7$var$_extends({}, optionProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__menuitem-option", rest.className)
    }), /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$export$46e1d66043f363e6, {
        fontSize: "0.8em",
        marginEnd: iconSpacing,
        opacity: props.isChecked ? 1 : 0
    }, icon || /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$var$CheckIcon, null)), /*#__PURE__*/ $denZA.createElement("span", {
        style: {
            flex: 1
        }
    }, optionProps.children));
});
$7bbd5491a0dd17e7$export$7641072b2544de08.id = "MenuItemOption";
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$7641072b2544de08.displayName = "MenuItemOption";
var $7bbd5491a0dd17e7$export$61dcee7679107202 = (props)=>{
    var { className: className, title: title } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "title"
    ]);
    var ownProps = (0, $bfd29e9600d94362$export$9dcb3089500f52be)(rest);
    return /*#__PURE__*/ $denZA.createElement($7bbd5491a0dd17e7$export$22a631d1f72787bb, $7bbd5491a0dd17e7$var$_extends({
        title: title,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__option-group", className)
    }, ownProps));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$61dcee7679107202.displayName = "MenuOptionGroup";
var $7bbd5491a0dd17e7$export$22a631d1f72787bb = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { title: title, children: children, className: className } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "title",
        "children",
        "className"
    ]);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__group__title", className);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement("div", {
        ref: ref,
        className: "chakra-menu__group",
        role: "group"
    }, title && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).p, $7bbd5491a0dd17e7$var$_extends({
        className: _className
    }, rest, {
        __css: styles.groupTitle
    }), title), children);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$22a631d1f72787bb.displayName = "MenuGroup";
var $7bbd5491a0dd17e7$export$1fab7891e4a3c1fd = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $7bbd5491a0dd17e7$var$_extends({
        ref: ref
    }, props, {
        __css: styles.command,
        className: "chakra-menu__command"
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$1fab7891e4a3c1fd.displayName = "MenuCommand";
var $7bbd5491a0dd17e7$export$46e1d66043f363e6 = (props)=>{
    var { className: className, children: children } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "children"
    ]);
    var child = $denZA.Children.only(children);
    var clone = /*#__PURE__*/ $denZA.isValidElement(child) ? /*#__PURE__*/ $denZA.cloneElement(child, {
        focusable: "false",
        "aria-hidden": true,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__icon", child.props.className)
    }) : null;
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__icon-wrapper", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $7bbd5491a0dd17e7$var$_extends({
        className: _className
    }, rest, {
        __css: {
            flexShrink: 0
        }
    }), clone);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$46e1d66043f363e6.displayName = "MenuIcon";
var $7bbd5491a0dd17e7$export$acb07b4664ac227c = (props)=>{
    var { className: className } = props, rest = $7bbd5491a0dd17e7$var$_objectWithoutPropertiesLoose(props, [
        "className"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).hr, $7bbd5491a0dd17e7$var$_extends({
        role: "separator",
        "aria-orientation": "horizontal",
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-menu__divider", className)
    }, rest, {
        __css: styles.divider
    }));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $7bbd5491a0dd17e7$export$acb07b4664ac227c.displayName = "MenuDivider";





var $denZA = parcelRequire("denZA");
var $184da94528cec5db$var$__assign = undefined && undefined.__assign || function() {
    $184da94528cec5db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $184da94528cec5db$var$__assign.apply(this, arguments);
};
var $184da94528cec5db$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $184da94528cec5db$export$266a769812832828 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var className = _a.className, onClickProp = _a.onClick, rest = $184da94528cec5db$var$__rest(_a, [
        "className",
        "onClick"
    ]);
    var menu = (0, $bfd29e9600d94362$export$21c7ab35b39f78ec)();
    var isOpen = menu.isOpen, onToggle = menu.onToggle, onClose = menu.onClose;
    var handleClick = $denZA.useCallback(function(e) {
        e.preventDefault();
        onToggle();
    }, [
        onToggle
    ]);
    var handleKeyDown = $denZA.useCallback(function(e) {
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(e);
        var closeIfOpen = isOpen ? onClose : undefined;
        var keyMap = {
            Enter: onToggle,
            // TODO If MenuButton is rendered as <a> as in Breadcrumb overflow story the click event doesn't fire as it does for a <button> element
            // Should we handle Space key explicitly in that scenario?
            // Space: onToggle,
            // ' ': onToggle,
            Escape: closeIfOpen,
            Tab: closeIfOpen
        };
        var action = keyMap[eventKey];
        if (action) {
            e.preventDefault();
            e.stopPropagation();
            action(e);
        }
    }, [
        onToggle,
        onClose,
        isOpen
    ]);
    return(// eslint-disable-next-line react/jsx-no-bind
    $denZA.createElement((0, $7bbd5491a0dd17e7$export$266a769812832828), $184da94528cec5db$var$__assign({}, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('klik-ui-menu__button', className),
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onClickProp, handleClick),
        onKeyDown: handleKeyDown,
        ref: ref
    })));
});




var $denZA = parcelRequire("denZA");
var $cca1dcd9659695b4$var$__assign = undefined && undefined.__assign || function() {
    $cca1dcd9659695b4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cca1dcd9659695b4$var$__assign.apply(this, arguments);
};
var $cca1dcd9659695b4$export$acb07b4664ac227c = function(props) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$acb07b4664ac227c), $cca1dcd9659695b4$var$__assign({}, props));
};





var $denZA = parcelRequire("denZA");
var $f9b246c371c16e6d$var$__assign = undefined && undefined.__assign || function() {
    $f9b246c371c16e6d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9b246c371c16e6d$var$__assign.apply(this, arguments);
};
var $f9b246c371c16e6d$export$22a631d1f72787bb = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$22a631d1f72787bb), $f9b246c371c16e6d$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");
var $e9e40d7f25d35034$var$__assign = undefined && undefined.__assign || function() {
    $e9e40d7f25d35034$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9e40d7f25d35034$var$__assign.apply(this, arguments);
};
var $e9e40d7f25d35034$export$46e1d66043f363e6 = function(props) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$46e1d66043f363e6), $e9e40d7f25d35034$var$__assign({}, props));
};





var $denZA = parcelRequire("denZA");
var $62f1158d554483bd$var$__assign = undefined && undefined.__assign || function() {
    $62f1158d554483bd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $62f1158d554483bd$var$__assign.apply(this, arguments);
};
var $62f1158d554483bd$export$2ce376c2cc3355c8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$2ce376c2cc3355c8), $62f1158d554483bd$var$__assign({}, props, {
        ref: ref
    }));
});







var $denZA = parcelRequire("denZA");

var $b32fcd7aac29e9aa$var$__assign = undefined && undefined.__assign || function() {
    $b32fcd7aac29e9aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b32fcd7aac29e9aa$var$__assign.apply(this, arguments);
};
var $b32fcd7aac29e9aa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b32fcd7aac29e9aa$var$StyledMenuItem = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var type = props.type, rest = $b32fcd7aac29e9aa$var$__rest(props, [
        "type"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    /**
     * Given another component, use its type if present
     * Else, use no type to avoid invalid html, e.g. <a type="button" />
     * Else, fall back to "button"
     */ var btnType = rest.as ? type !== null && type !== void 0 ? type : undefined : 'button';
    var buttonStyles = $b32fcd7aac29e9aa$var$__assign({
        textDecoration: 'none',
        color: 'inherit',
        userSelect: 'none',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        textAlign: 'start',
        flex: '0 0 auto',
        outline: 0
    }, styles.item);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $b32fcd7aac29e9aa$var$__assign({
        ref: ref,
        type: btnType
    }, rest, {
        __css: buttonStyles
    }));
});
var $b32fcd7aac29e9aa$export$7641072b2544de08 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var icon = props.icon, _a = props.iconSpacing, iconSpacing = _a === void 0 ? '0.75rem' : _a, rest = $b32fcd7aac29e9aa$var$__rest(props, [
        "icon",
        "iconSpacing"
    ]);
    var optionProps = (0, $bfd29e9600d94362$export$8ca3fd7c19c454af)(rest, ref);
    var render = $denZA.useMemo(function() {
        var isChecked = props.isChecked, value = props.value, isDisabled = props.isDisabled, type = props.type;
        if ((0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(optionProps.children)) return optionProps.children({
            isChecked: isChecked,
            isDisabled: isDisabled,
            value: value,
            type: type
        });
        return $denZA.createElement($denZA.Fragment, null, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, {
            flex: "1"
        }, optionProps.children), $denZA.createElement((0, $e9e40d7f25d35034$export$46e1d66043f363e6), {
            fontSize: "0.8em",
            marginStart: iconSpacing,
            opacity: props.isChecked ? 1 : 0
        }, icon !== null && icon !== void 0 ? icon : $denZA.createElement((0, $a7d2f29d07be0efc$export$add807e002afa321), null)));
    }, [
        optionProps.children,
        props.isChecked,
        props.value,
        props.isDisabled,
        props.type
    ]);
    return $denZA.createElement($b32fcd7aac29e9aa$var$StyledMenuItem, $b32fcd7aac29e9aa$var$__assign({}, optionProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('chakra-menu__menuitem-option', rest.className)
    }), render);
});
$b32fcd7aac29e9aa$export$7641072b2544de08.id = 'MenuItemOption';





var $denZA = parcelRequire("denZA");
var $039c4a1d588c6953$var$__assign = undefined && undefined.__assign || function() {
    $039c4a1d588c6953$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $039c4a1d588c6953$var$__assign.apply(this, arguments);
};
var $039c4a1d588c6953$export$d4c4e98c5044dc8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$d4c4e98c5044dc8), $039c4a1d588c6953$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");
var $df1e2462deb947a0$var$__assign = undefined && undefined.__assign || function() {
    $df1e2462deb947a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $df1e2462deb947a0$var$__assign.apply(this, arguments);
};
var $df1e2462deb947a0$export$61dcee7679107202 = function(props) {
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$61dcee7679107202), $df1e2462deb947a0$var$__assign({}, props));
};




var $denZA = parcelRequire("denZA");








var $26c2d3fcb4afcaa4$var$__assign = undefined && undefined.__assign || function() {
    $26c2d3fcb4afcaa4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26c2d3fcb4afcaa4$var$__assign.apply(this, arguments);
};
var $26c2d3fcb4afcaa4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f = function(_a) {
    var _b = _a.autoSelect, autoSelect = _b === void 0 ? false : _b, _c = _a.gutter, gutter = _c === void 0 ? 4 : _c, props = $26c2d3fcb4afcaa4$var$__rest(_a, [
        "autoSelect",
        "gutter"
    ]);
    return $denZA.createElement((0, $7bbd5491a0dd17e7$export$d9b273488cd8ce6f), $26c2d3fcb4afcaa4$var$__assign({
        autoSelect: autoSelect,
        gutter: gutter
    }, props));
};
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.Button = (0, $184da94528cec5db$export$266a769812832828);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.Divider = (0, $cca1dcd9659695b4$export$acb07b4664ac227c);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.Group = (0, $f9b246c371c16e6d$export$22a631d1f72787bb);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.Icon = (0, $e9e40d7f25d35034$export$46e1d66043f363e6);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.Item = (0, $62f1158d554483bd$export$2ce376c2cc3355c8);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.ItemOption = (0, $b32fcd7aac29e9aa$export$7641072b2544de08);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.List = (0, $039c4a1d588c6953$export$d4c4e98c5044dc8);
$26c2d3fcb4afcaa4$export$d9b273488cd8ce6f.OptionGroup = (0, $df1e2462deb947a0$export$61dcee7679107202);


var $49f3683d2fab9ea0$export$266a769812832828 = (0, $184da94528cec5db$export$266a769812832828);
var $49f3683d2fab9ea0$export$acb07b4664ac227c = (0, $cca1dcd9659695b4$export$acb07b4664ac227c);
var $49f3683d2fab9ea0$export$22a631d1f72787bb = (0, $f9b246c371c16e6d$export$22a631d1f72787bb);
var $49f3683d2fab9ea0$export$46e1d66043f363e6 = (0, $e9e40d7f25d35034$export$46e1d66043f363e6);
var $49f3683d2fab9ea0$export$2ce376c2cc3355c8 = (0, $62f1158d554483bd$export$2ce376c2cc3355c8);
var $49f3683d2fab9ea0$export$7641072b2544de08 = (0, $b32fcd7aac29e9aa$export$7641072b2544de08);
var $49f3683d2fab9ea0$export$d4c4e98c5044dc8 = (0, $039c4a1d588c6953$export$d4c4e98c5044dc8);
var $49f3683d2fab9ea0$export$61dcee7679107202 = (0, $df1e2462deb947a0$export$61dcee7679107202);





var $denZA = parcelRequire("denZA");
var $e80e570af988fbd8$var$__assign = undefined && undefined.__assign || function() {
    $e80e570af988fbd8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e80e570af988fbd8$var$__assign.apply(this, arguments);
};
var $e80e570af988fbd8$export$cb540d8b0ef7906c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    // Getting error: Expression produces a union type that is too complex to represent
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return $denZA.createElement((0, $f1dbd08245d68867$export$cb540d8b0ef7906c), $e80e570af988fbd8$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $b9cfe88bd111956b$var$__assign = undefined && undefined.__assign || function() {
    $b9cfe88bd111956b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9cfe88bd111956b$var$__assign.apply(this, arguments);
};
var $b9cfe88bd111956b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b9cfe88bd111956b$export$edf9108895ba774f = function(_a) {
    var onClick = _a.onClick, rest = $b9cfe88bd111956b$var$__rest(_a, [
        "onClick"
    ]);
    var onClose = (0, $f1dbd08245d68867$export$4cc1699d46f42cae)().onClose;
    return $denZA.createElement((0, $be26eda9b41db083$export$de65de8213222d10), $b9cfe88bd111956b$var$__assign({
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onClick, function(event) {
            event.stopPropagation();
            onClose();
        }),
        position: "absolute",
        right: "0",
        top: "0"
    }, rest));
};





var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $bcf4c1510a8e0890$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bcf4c1510a8e0890$var$_a;
var $bcf4c1510a8e0890$export$178405afcd8c5eb = ($bcf4c1510a8e0890$var$_a = $bcf4c1510a8e0890$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'ModalContext',
    errorMessage: 'useModalContext: `context` is undefined. Seems you forgot to wrap Modal components in `<Modal />`'
}), 2), $bcf4c1510a8e0890$var$_a[0]), $bcf4c1510a8e0890$export$4cc1699d46f42cae = $bcf4c1510a8e0890$var$_a[1];


var $f4f8012f7bfb31d3$var$__assign = undefined && undefined.__assign || function() {
    $f4f8012f7bfb31d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4f8012f7bfb31d3$var$__assign.apply(this, arguments);
};
var $f4f8012f7bfb31d3$export$57446ea98ecb72cb = function(props) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _a = (0, $bcf4c1510a8e0890$export$4cc1699d46f42cae)(), status = _a.status, hideIcon = _a.hideIcon;
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    if (status === 'plain' || status === undefined) // eslint-disable-next-line no-null/no-null
    return null;
    if (hideIcon) // eslint-disable-next-line no-null/no-null
    return null;
    var BaseIcon = (0, $07999317a69b8340$export$591f21428120a6de)[status].icon;
    var colorIndex = status === 'error' ? '500' : '400';
    var colorName = status === 'info' ? 'information' : status;
    var wrapperStyles = $f4f8012f7bfb31d3$var$__assign({
        color: colorName + "." + colorIndex
    }, styles.status);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f4f8012f7bfb31d3$var$__assign({
        display: "inherit"
    }, props, {
        __css: wrapperStyles
    }), $denZA.createElement(BaseIcon, null));
};


var $be9dff9c3172aa4f$var$__assign = undefined && undefined.__assign || function() {
    $be9dff9c3172aa4f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be9dff9c3172aa4f$var$__assign.apply(this, arguments);
};
var $be9dff9c3172aa4f$export$6da19a24bf249f17 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var children = props.children;
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var outerwrapStyles = $be9dff9c3172aa4f$var$__assign({
        display: 'flex',
        flexDirection: 'row'
    }, styles.outer);
    var innerwrapStyles = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    };
    return $denZA.createElement((0, $f1dbd08245d68867$export$6da19a24bf249f17), $be9dff9c3172aa4f$var$__assign({}, props, {
        ref: ref
    }), $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        className: "klik-modal-content-outer",
        __css: outerwrapStyles
    }, $denZA.createElement((0, $f4f8012f7bfb31d3$export$57446ea98ecb72cb), null), $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        className: "klik-modal-content-inner",
        __css: innerwrapStyles
    }, children)));
});



var $93917dada858a7bc$exports = {};
$parcel$export($93917dada858a7bc$exports, "extendTheme", function () { return $e4d547fd9b80de1b$export$33a2b855d5b8731e; });
$parcel$export($93917dada858a7bc$exports, "useMediaQuery", function () { return $4e05a8ace4dadc1b$export$32d5543ab307c01; });
$parcel$export($93917dada858a7bc$exports, "isChakraTheme", function () { return $a77c364619ae316b$export$73a6ae01926a4f0e; });

/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $ec664c289f7aa301$export$b0e60b43d1d059f0(n, max) {
    if ($ec664c289f7aa301$export$7bf7d6849640691b(n)) n = '100%';
    var isPercent = $ec664c289f7aa301$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $ec664c289f7aa301$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $ec664c289f7aa301$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $ec664c289f7aa301$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $ec664c289f7aa301$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $ec664c289f7aa301$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $ec664c289f7aa301$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}


function $528e41da60d0f37c$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $528e41da60d0f37c$export$c85ca4f4753af384(r, g, b) {
    r = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $528e41da60d0f37c$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $528e41da60d0f37c$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $528e41da60d0f37c$var$hue2rgb(p, q, h + 1 / 3);
        g = $528e41da60d0f37c$var$hue2rgb(p, q, h);
        b = $528e41da60d0f37c$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $528e41da60d0f37c$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $528e41da60d0f37c$export$210753cfeec758a5(h, s, v) {
    h = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $528e41da60d0f37c$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $528e41da60d0f37c$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)($528e41da60d0f37c$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $528e41da60d0f37c$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)($528e41da60d0f37c$export$51dcdea396f3aff6(a)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $ec664c289f7aa301$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $528e41da60d0f37c$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $528e41da60d0f37c$export$616da979ad1c2414(h) {
    return $528e41da60d0f37c$export$262b3ba788b4d07c(h) / 255;
}
function $528e41da60d0f37c$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $528e41da60d0f37c$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $4743a98635608aad$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};


/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 


function $330fa75fcf2d9cb1$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') color = $330fa75fcf2d9cb1$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.r) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.g) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $528e41da60d0f37c$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.h) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.s) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.v)) {
            s = (0, $ec664c289f7aa301$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $ec664c289f7aa301$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $528e41da60d0f37c$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.h) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.s) && $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color.l)) {
            s = (0, $ec664c289f7aa301$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $ec664c289f7aa301$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $528e41da60d0f37c$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $ec664c289f7aa301$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $330fa75fcf2d9cb1$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var $330fa75fcf2d9cb1$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $330fa75fcf2d9cb1$var$CSS_UNIT = "(?:".concat($330fa75fcf2d9cb1$var$CSS_NUMBER, ")|(?:").concat($330fa75fcf2d9cb1$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")[,|\\s]+(").concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")[,|\\s]+(").concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")\\s*\\)?");
var $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")[,|\\s]+(").concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")[,|\\s]+(").concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")[,|\\s]+(").concat($330fa75fcf2d9cb1$var$CSS_UNIT, ")\\s*\\)?");
var $330fa75fcf2d9cb1$var$matchers = {
    CSS_UNIT: new RegExp($330fa75fcf2d9cb1$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $330fa75fcf2d9cb1$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $330fa75fcf2d9cb1$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $4743a98635608aad$export$e4b2ac9215619f8d)[color]) {
        color = (0, $4743a98635608aad$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $330fa75fcf2d9cb1$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $330fa75fcf2d9cb1$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $330fa75fcf2d9cb1$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $330fa75fcf2d9cb1$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $330fa75fcf2d9cb1$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $330fa75fcf2d9cb1$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $330fa75fcf2d9cb1$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[1]),
        g: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[2]),
        b: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[3]),
        a: (0, $528e41da60d0f37c$export$616da979ad1c2414)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $330fa75fcf2d9cb1$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[1]),
        g: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[2]),
        b: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $330fa75fcf2d9cb1$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $528e41da60d0f37c$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $330fa75fcf2d9cb1$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $528e41da60d0f37c$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $330fa75fcf2d9cb1$export$80d4d71a83d4526d(color) {
    return Boolean($330fa75fcf2d9cb1$var$matchers.CSS_UNIT.exec(String(color)));
}



var $9037ad6678b06e04$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = '';
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === 'number') color = (0, $528e41da60d0f37c$export$4076ec82b665900d)(color);
        this.originalInput = color;
        var rgb = (0, $330fa75fcf2d9cb1$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $ec664c289f7aa301$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $528e41da60d0f37c$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $528e41da60d0f37c$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $528e41da60d0f37c$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $528e41da60d0f37c$export$c85ca4f4753af384)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $528e41da60d0f37c$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return '#' + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $528e41da60d0f37c$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return '#' + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $ec664c289f7aa301$export$b0e60b43d1d059f0)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return 'transparent';
        if (this.a < 1) return false;
        var hex = '#' + (0, $528e41da60d0f37c$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $4743a98635608aad$export$e4b2ac9215619f8d)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith('hex') || format === 'name');
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === 'name' && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === 'rgb') formattedString = this.toRgbString();
        if (format === 'prgb') formattedString = this.toPercentageRgbString();
        if (format === 'hex' || format === 'hex6') formattedString = this.toHexString();
        if (format === 'hex3') formattedString = this.toHexString(true);
        if (format === 'hex4') formattedString = this.toHex8String(true);
        if (format === 'hex8') formattedString = this.toHex8String();
        if (format === 'name') formattedString = this.toName();
        if (format === 'hsl') formattedString = this.toHslString();
        if (format === 'hsv') formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $ec664c289f7aa301$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $ec664c289f7aa301$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('white', amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('black', amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $ec664c289f7aa301$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $ec664c289f7aa301$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $9037ad6678b06e04$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = '';
    if (opts === void 0) opts = {};
    return new $9037ad6678b06e04$export$d850312fc213f33e(color, opts);
}


function $2ee3749912db9e4a$export$b7b705aaad1c5b6a(color1, color2) {
    var c1 = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(color1);
    var c2 = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
}
function $2ee3749912db9e4a$export$3fe5b5ca1e6a6a28(color1, color2, wcag2) {
    var _a, _b;
    if (wcag2 === void 0) wcag2 = {
        level: 'AA',
        size: 'small'
    };
    var readabilityLevel = $2ee3749912db9e4a$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) !== null && _a !== void 0 ? _a : 'AA') + ((_b = wcag2.size) !== null && _b !== void 0 ? _b : 'small')){
        case 'AAsmall':
        case 'AAAlarge':
            return readabilityLevel >= 4.5;
        case 'AAlarge':
            return readabilityLevel >= 3;
        case 'AAAsmall':
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $2ee3749912db9e4a$export$b9c9f9c17d073e1a(baseColor, colorList, args) {
    if (args === void 0) args = {
        includeFallbackColors: false,
        level: 'AA',
        size: 'small'
    };
    var bestColor = null;
    var bestScore = 0;
    var includeFallbackColors = args.includeFallbackColors, level = args.level, size = args.size;
    for(var _i = 0, colorList_1 = colorList; _i < colorList_1.length; _i++){
        var color = colorList_1[_i];
        var score = $2ee3749912db9e4a$export$b7b705aaad1c5b6a(baseColor, color);
        if (score > bestScore) {
            bestScore = score;
            bestColor = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(color);
        }
    }
    if ($2ee3749912db9e4a$export$3fe5b5ca1e6a6a28(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    args.includeFallbackColors = false;
    return $2ee3749912db9e4a$export$b9c9f9c17d073e1a(baseColor, [
        '#fff',
        '#000'
    ], args);
}

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ // randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/

function $b453fcfe7cf8f74a$export$4385e60b38654f68(options) {
    if (options === void 0) options = {};
    // Check if we need to generate multiple colors
    if (options.count !== undefined && options.count !== null) {
        var totalColors = options.count;
        var colors = [];
        options.count = undefined;
        while(totalColors > colors.length){
            // Since we're generating multiple colors,
            // incremement the seed. Otherwise we'd just
            // generate the same color each time...
            options.count = null;
            if (options.seed) options.seed += 1;
            colors.push($b453fcfe7cf8f74a$export$4385e60b38654f68(options));
        }
        options.count = totalColors;
        return colors;
    }
    // First we pick a hue (H)
    var h = $b453fcfe7cf8f74a$var$pickHue(options.hue, options.seed);
    // Then use H to determine saturation (S)
    var s = $b453fcfe7cf8f74a$var$pickSaturation(h, options);
    // Then use S and H to determine brightness (B).
    var v = $b453fcfe7cf8f74a$var$pickBrightness(h, s, options);
    var res = {
        h: h,
        s: s,
        v: v
    };
    if (options.alpha !== undefined) res.a = options.alpha;
    // Then we return the HSB color in the desired format
    return new (0, $9037ad6678b06e04$export$d850312fc213f33e)(res);
}
function $b453fcfe7cf8f74a$var$pickHue(hue, seed) {
    var hueRange = $b453fcfe7cf8f74a$var$getHueRange(hue);
    var res = $b453fcfe7cf8f74a$var$randomWithin(hueRange, seed);
    // Instead of storing red as two seperate ranges,
    // we group them, using negative numbers
    if (res < 0) res = 360 + res;
    return res;
}
function $b453fcfe7cf8f74a$var$pickSaturation(hue, options) {
    if (options.hue === 'monochrome') return 0;
    if (options.luminosity === 'random') return $b453fcfe7cf8f74a$var$randomWithin([
        0,
        100
    ], options.seed);
    var saturationRange = $b453fcfe7cf8f74a$var$getColorInfo(hue).saturationRange;
    var sMin = saturationRange[0];
    var sMax = saturationRange[1];
    switch(options.luminosity){
        case 'bright':
            sMin = 55;
            break;
        case 'dark':
            sMin = sMax - 10;
            break;
        case 'light':
            sMax = 55;
            break;
        default:
            break;
    }
    return $b453fcfe7cf8f74a$var$randomWithin([
        sMin,
        sMax
    ], options.seed);
}
function $b453fcfe7cf8f74a$var$pickBrightness(H, S, options) {
    var bMin = $b453fcfe7cf8f74a$var$getMinimumBrightness(H, S);
    var bMax = 100;
    switch(options.luminosity){
        case 'dark':
            bMax = bMin + 20;
            break;
        case 'light':
            bMin = (bMax + bMin) / 2;
            break;
        case 'random':
            bMin = 0;
            bMax = 100;
            break;
        default:
            break;
    }
    return $b453fcfe7cf8f74a$var$randomWithin([
        bMin,
        bMax
    ], options.seed);
}
function $b453fcfe7cf8f74a$var$getMinimumBrightness(H, S) {
    var lowerBounds = $b453fcfe7cf8f74a$var$getColorInfo(H).lowerBounds;
    for(var i = 0; i < lowerBounds.length - 1; i++){
        var s1 = lowerBounds[i][0];
        var v1 = lowerBounds[i][1];
        var s2 = lowerBounds[i + 1][0];
        var v2 = lowerBounds[i + 1][1];
        if (S >= s1 && S <= s2) {
            var m = (v2 - v1) / (s2 - s1);
            var b = v1 - m * s1;
            return m * S + b;
        }
    }
    return 0;
}
function $b453fcfe7cf8f74a$var$getHueRange(colorInput) {
    var num = parseInt(colorInput, 10);
    if (!Number.isNaN(num) && num < 360 && num > 0) return [
        num,
        num
    ];
    if (typeof colorInput === 'string') {
        var namedColor = $b453fcfe7cf8f74a$export$40e55eae2f766967.find(function(n) {
            return n.name === colorInput;
        });
        if (namedColor) {
            var color = $b453fcfe7cf8f74a$var$defineColor(namedColor);
            if (color.hueRange) return color.hueRange;
        }
        var parsed = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(colorInput);
        if (parsed.isValid) {
            var hue = parsed.toHsv().h;
            return [
                hue,
                hue
            ];
        }
    }
    return [
        0,
        360
    ];
}
function $b453fcfe7cf8f74a$var$getColorInfo(hue) {
    // Maps red colors to make picking hue easier
    if (hue >= 334 && hue <= 360) hue -= 360;
    for(var _i = 0, bounds_1 = $b453fcfe7cf8f74a$export$40e55eae2f766967; _i < bounds_1.length; _i++){
        var bound = bounds_1[_i];
        var color = $b453fcfe7cf8f74a$var$defineColor(bound);
        if (color.hueRange && hue >= color.hueRange[0] && hue <= color.hueRange[1]) return color;
    }
    throw Error('Color not found');
}
function $b453fcfe7cf8f74a$var$randomWithin(range, seed) {
    if (seed === undefined) return Math.floor(range[0] + Math.random() * (range[1] + 1 - range[0]));
    // Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
    var max = range[1] || 1;
    var min = range[0] || 0;
    seed = (seed * 9301 + 49297) % 233280;
    var rnd = seed / 233280.0;
    return Math.floor(min + rnd * (max - min));
}
function $b453fcfe7cf8f74a$var$defineColor(bound) {
    var sMin = bound.lowerBounds[0][0];
    var sMax = bound.lowerBounds[bound.lowerBounds.length - 1][0];
    var bMin = bound.lowerBounds[bound.lowerBounds.length - 1][1];
    var bMax = bound.lowerBounds[0][1];
    return {
        name: bound.name,
        hueRange: bound.hueRange,
        lowerBounds: bound.lowerBounds,
        saturationRange: [
            sMin,
            sMax
        ],
        brightnessRange: [
            bMin,
            bMax
        ]
    };
}
var $b453fcfe7cf8f74a$export$40e55eae2f766967 = [
    {
        name: 'monochrome',
        hueRange: null,
        lowerBounds: [
            [
                0,
                0
            ],
            [
                100,
                0
            ]
        ]
    },
    {
        name: 'red',
        hueRange: [
            -26,
            18
        ],
        lowerBounds: [
            [
                20,
                100
            ],
            [
                30,
                92
            ],
            [
                40,
                89
            ],
            [
                50,
                85
            ],
            [
                60,
                78
            ],
            [
                70,
                70
            ],
            [
                80,
                60
            ],
            [
                90,
                55
            ],
            [
                100,
                50
            ]
        ]
    },
    {
        name: 'orange',
        hueRange: [
            19,
            46
        ],
        lowerBounds: [
            [
                20,
                100
            ],
            [
                30,
                93
            ],
            [
                40,
                88
            ],
            [
                50,
                86
            ],
            [
                60,
                85
            ],
            [
                70,
                70
            ],
            [
                100,
                70
            ]
        ]
    },
    {
        name: 'yellow',
        hueRange: [
            47,
            62
        ],
        lowerBounds: [
            [
                25,
                100
            ],
            [
                40,
                94
            ],
            [
                50,
                89
            ],
            [
                60,
                86
            ],
            [
                70,
                84
            ],
            [
                80,
                82
            ],
            [
                90,
                80
            ],
            [
                100,
                75
            ]
        ]
    },
    {
        name: 'green',
        hueRange: [
            63,
            178
        ],
        lowerBounds: [
            [
                30,
                100
            ],
            [
                40,
                90
            ],
            [
                50,
                85
            ],
            [
                60,
                81
            ],
            [
                70,
                74
            ],
            [
                80,
                64
            ],
            [
                90,
                50
            ],
            [
                100,
                40
            ]
        ]
    },
    {
        name: 'blue',
        hueRange: [
            179,
            257
        ],
        lowerBounds: [
            [
                20,
                100
            ],
            [
                30,
                86
            ],
            [
                40,
                80
            ],
            [
                50,
                74
            ],
            [
                60,
                60
            ],
            [
                70,
                52
            ],
            [
                80,
                44
            ],
            [
                90,
                39
            ],
            [
                100,
                35
            ]
        ]
    },
    {
        name: 'purple',
        hueRange: [
            258,
            282
        ],
        lowerBounds: [
            [
                20,
                100
            ],
            [
                30,
                87
            ],
            [
                40,
                79
            ],
            [
                50,
                70
            ],
            [
                60,
                65
            ],
            [
                70,
                59
            ],
            [
                80,
                52
            ],
            [
                90,
                45
            ],
            [
                100,
                42
            ]
        ]
    },
    {
        name: 'pink',
        hueRange: [
            283,
            334
        ],
        lowerBounds: [
            [
                20,
                100
            ],
            [
                30,
                90
            ],
            [
                40,
                86
            ],
            [
                60,
                84
            ],
            [
                80,
                80
            ],
            [
                90,
                75
            ],
            [
                100,
                73
            ]
        ]
    }
];




var $e5Q7j = parcelRequire("e5Q7j");

function $8633301efc9f8f20$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $8633301efc9f8f20$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $8633301efc9f8f20$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $8633301efc9f8f20$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $8633301efc9f8f20$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $8633301efc9f8f20$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $8633301efc9f8f20$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, idx) {
        return idx !== index;
    });
}
function $8633301efc9f8f20$export$fb9705de59d96855(array, item) {
    return [].concat(array, [
        item
    ]);
}
function $8633301efc9f8f20$export$fe2d9b4e03920b4c(array, item) {
    return array.filter(function(eachItem) {
        return eachItem !== item;
    });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */ function $8633301efc9f8f20$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */ function $8633301efc9f8f20$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $8633301efc9f8f20$export$c42e0e80904d519(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */ function $8633301efc9f8f20$export$5f7ec48d69707ddd(array, size) {
    return array.reduce(function(rows, currentValue, index) {
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */ function $8633301efc9f8f20$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find(function(item) {
            return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
        });
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter(function(item) {
        return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    }); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}
// Number assertions
function $8633301efc9f8f20$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $8633301efc9f8f20$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $8633301efc9f8f20$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $8633301efc9f8f20$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $8633301efc9f8f20$export$4c0262a4f954db45(value) {
    return $8633301efc9f8f20$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $8633301efc9f8f20$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $8633301efc9f8f20$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $8633301efc9f8f20$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $8633301efc9f8f20$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$8633301efc9f8f20$export$43bee75e5e14138e(value);
}
function $8633301efc9f8f20$export$83b788b1a3698c03(value) {
    return $8633301efc9f8f20$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $8633301efc9f8f20$export$e0287cc73292b477(value) {
    return value && !$8633301efc9f8f20$export$83b788b1a3698c03(value);
}
function $8633301efc9f8f20$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $8633301efc9f8f20$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $8633301efc9f8f20$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $8633301efc9f8f20$export$dd1bc94b04021eeb(value) {
    if ($8633301efc9f8f20$export$43bee75e5e14138e(value)) return $8633301efc9f8f20$export$4c0262a4f954db45(value);
    if ($8633301efc9f8f20$export$a6cdc56e425d0d0a(value)) return $8633301efc9f8f20$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $8633301efc9f8f20$export$a866f231438cc228 = false;
var $8633301efc9f8f20$export$61cb32cff9a99948 = false;
function $8633301efc9f8f20$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $8633301efc9f8f20$export$4215e022093e324e(value) {
    return value && $8633301efc9f8f20$export$a6cdc56e425d0d0a(value) && $8633301efc9f8f20$export$a6cdc56e425d0d0a(value.target);
}
function $8633301efc9f8f20$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $8633301efc9f8f20$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach(function(key) {
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $8633301efc9f8f20$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */ function $8633301efc9f8f20$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $8633301efc9f8f20$export$fc10aeed3a532e2a = function memoize(fn) {
    var cache = new WeakMap();
    var memoizedFn = function memoizedFn(obj, path, fallback, index) {
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $8633301efc9f8f20$export$1bb32d0c65da6059 = $8633301efc9f8f20$export$fc10aeed3a532e2a($8633301efc9f8f20$export$3988ae62b71be9a3);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */ function $8633301efc9f8f20$export$73b8ef55a37133c7(path, scale) {
    return $8633301efc9f8f20$export$1bb32d0c65da6059(scale, path, path);
}
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */ function $8633301efc9f8f20$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $8633301efc9f8f20$export$2458ce75c8ef9806 = function filterUndefined(object) {
    return $8633301efc9f8f20$export$3417cf6417437960(object, function(val) {
        return val !== null && val !== undefined;
    });
};
var $8633301efc9f8f20$export$259b4dd69e654a7a = function objectKeys(obj) {
    return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */ var $8633301efc9f8f20$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(carry, _ref) {
        var key = _ref[0], value = _ref[1];
        carry[key] = value;
        return carry;
    }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */ var $8633301efc9f8f20$export$93c8e06b7014dc33 = function getCSSVar(theme, scale, value) {
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};
function $8633301efc9f8f20$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $8633301efc9f8f20$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var _analyzeCSSValue = $8633301efc9f8f20$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
    return unitless || $8633301efc9f8f20$export$7e4aa119212bc614(value) ? value + "px" : value;
}
var $8633301efc9f8f20$var$sortByBreakpointValue = function sortByBreakpointValue(a, b) {
    return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var $8633301efc9f8f20$var$sortBps = function sortBps(breakpoints) {
    return $8633301efc9f8f20$export$5150077fc2e7c662(Object.entries(breakpoints).sort($8633301efc9f8f20$var$sortByBreakpointValue));
};
function $8633301efc9f8f20$var$normalize(breakpoints) {
    var sorted = $8633301efc9f8f20$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $8633301efc9f8f20$var$keys(breakpoints) {
    var value = Object.keys($8633301efc9f8f20$var$sortBps(breakpoints));
    return new Set(value);
}
function $8633301efc9f8f20$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $8633301efc9f8f20$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return $8633301efc9f8f20$export$7e4aa119212bc614(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function(m) {
        return "" + (parseFloat(m) + factor);
    });
}
function $8633301efc9f8f20$var$queryString(min, max) {
    var query = [
        "@media screen"
    ];
    if (min) query.push("and", "(min-width: " + $8633301efc9f8f20$export$91c0eda1d06bf008(min) + ")");
    if (max) query.push("and", "(max-width: " + $8633301efc9f8f20$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $8633301efc9f8f20$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $8633301efc9f8f20$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($8633301efc9f8f20$var$sortByBreakpointValue).map(function(_ref, index, entry) {
        var _entry;
        var breakpoint = _ref[0], minW = _ref[1];
        var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [], maxW = _ref2[1];
        maxW = parseFloat(maxW) > 0 ? $8633301efc9f8f20$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $8633301efc9f8f20$var$queryString(null, maxW),
            minWQuery: $8633301efc9f8f20$var$queryString(minW),
            minMaxQuery: $8633301efc9f8f20$var$queryString(minW, maxW)
        };
    });
    var _keys = $8633301efc9f8f20$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive: function isResponsive(test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every(function(key) {
                return _keys.has(key);
            });
        },
        asObject: $8633301efc9f8f20$var$sortBps(breakpoints),
        asArray: $8633301efc9f8f20$var$normalize(breakpoints),
        details: queries,
        media: [
            null
        ].concat(normalized.map(function(minW) {
            return $8633301efc9f8f20$var$queryString(minW);
        }).slice(1)),
        toArrayValue: function toArrayValue(test) {
            if (!$8633301efc9f8f20$export$a6cdc56e425d0d0a(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map(function(bp) {
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while($8633301efc9f8f20$export$7475b2c64539e4cf(result) === null)result.pop();
            return result;
        },
        toObjectValue: function toObjectValue(test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce(function(acc, value, index) {
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
function $8633301efc9f8f20$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $8633301efc9f8f20$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$8633301efc9f8f20$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $8633301efc9f8f20$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $8633301efc9f8f20$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $8633301efc9f8f20$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $8633301efc9f8f20$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $8633301efc9f8f20$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $8633301efc9f8f20$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $8633301efc9f8f20$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $8633301efc9f8f20$export$4e09c449d6c407f7 = $8633301efc9f8f20$export$71594e8a50f746f4();
var $8633301efc9f8f20$export$5cc3b7b83e34ade7 = function dataAttr(condition) {
    return condition ? "" : undefined;
};
var $8633301efc9f8f20$export$91a6105db3d4be7b = function ariaAttr(condition) {
    return condition ? true : undefined;
};
var $8633301efc9f8f20$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $8633301efc9f8f20$export$cd4e5573fbe2b576(node) {
    var doc = $8633301efc9f8f20$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $8633301efc9f8f20$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $8633301efc9f8f20$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */ function $8633301efc9f8f20$export$17948c8429b9b73a(event) {
    var key = event.key, keyCode = event.keyCode;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $8633301efc9f8f20$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $8633301efc9f8f20$export$cd4e5573fbe2b576(target);
    return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function $8633301efc9f8f20$export$189689d1febf0166(event) {
    return event.button !== 0;
}
// Really great work done by Diego Haz on this one
var $8633301efc9f8f20$export$f5f22eac728522fd = function hasDisplayNone(element) {
    return window.getComputedStyle(element).display === "none";
};
var $8633301efc9f8f20$export$54209d29bacd2cb9 = function hasTabIndex(element) {
    return element.hasAttribute("tabindex");
};
var $8633301efc9f8f20$export$87df0ed37d24dd13 = function hasNegativeTabIndex(element) {
    return $8633301efc9f8f20$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
};
function $8633301efc9f8f20$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $8633301efc9f8f20$export$63ed1d20cf8213cf(element) {
    return $8633301efc9f8f20$export$1b3bfaa9684536aa(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $8633301efc9f8f20$export$8a2eb51c14bb8899(element) {
    var doc = $8633301efc9f8f20$export$1b3bfaa9684536aa(element) ? $8633301efc9f8f20$export$b204af158042fbac(element) : document;
    return doc.activeElement === element;
}
function $8633301efc9f8f20$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $8633301efc9f8f20$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $8633301efc9f8f20$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $8633301efc9f8f20$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $8633301efc9f8f20$export$4c063cf1350e6fed(element) {
    if (!$8633301efc9f8f20$export$1b3bfaa9684536aa(element) || $8633301efc9f8f20$export$ee695c13482bb5dd(element) || $8633301efc9f8f20$export$30e0dc115df457ed(element)) return false;
    var localName = element.localName;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: function a() {
            return element.hasAttribute("href");
        },
        audio: function audio() {
            return element.hasAttribute("controls");
        },
        video: function video() {
            return element.hasAttribute("controls");
        }
    };
    if (localName in others) return others[localName]();
    if ($8633301efc9f8f20$export$3453cc819780f652(element)) return true;
    return $8633301efc9f8f20$export$54209d29bacd2cb9(element);
}
function $8633301efc9f8f20$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return $8633301efc9f8f20$export$1b3bfaa9684536aa(element) && $8633301efc9f8f20$export$4c063cf1350e6fed(element) && !$8633301efc9f8f20$export$87df0ed37d24dd13(element);
}
var $8633301efc9f8f20$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $8633301efc9f8f20$var$focusableElSelector = $8633301efc9f8f20$var$focusableElList.join();
function $8633301efc9f8f20$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($8633301efc9f8f20$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter($8633301efc9f8f20$export$4c063cf1350e6fed).filter(function(el) {
        return window.getComputedStyle(el).display !== "none";
    });
}
function $8633301efc9f8f20$export$748138f04a69bf21(container) {
    var allFocusable = $8633301efc9f8f20$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $8633301efc9f8f20$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($8633301efc9f8f20$var$focusableElSelector));
    var allTabbable = allFocusable.filter($8633301efc9f8f20$export$bebd5a1431fec25d);
    if ($8633301efc9f8f20$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $8633301efc9f8f20$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbable = $8633301efc9f8f20$export$f9ba66356f7359cf(container, fallbackToFocusable), first = _getAllTabbable[0];
    return first || null;
}
function $8633301efc9f8f20$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $8633301efc9f8f20$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $8633301efc9f8f20$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $8633301efc9f8f20$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($8633301efc9f8f20$export$bebd5a1431fec25d) || allFocusable.find($8633301efc9f8f20$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $8633301efc9f8f20$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $8633301efc9f8f20$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($8633301efc9f8f20$export$bebd5a1431fec25d) || allFocusable.find($8633301efc9f8f20$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $8633301efc9f8f20$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $8633301efc9f8f20$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && $8633301efc9f8f20$export$1b3bfaa9684536aa(nextTabbable)) nextTabbable.focus();
}
function $8633301efc9f8f20$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $8633301efc9f8f20$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && $8633301efc9f8f20$export$1b3bfaa9684536aa(previousTabbable)) previousTabbable.focus();
}
function $8633301efc9f8f20$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $8633301efc9f8f20$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($8633301efc9f8f20$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}
function $8633301efc9f8f20$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8633301efc9f8f20$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8633301efc9f8f20$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8633301efc9f8f20$var$_arrayLikeToArray(o, minLen);
}
function $8633301efc9f8f20$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8633301efc9f8f20$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable no-nested-ternary */ function $8633301efc9f8f20$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $8633301efc9f8f20$export$f6e2535fb5126e54(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function $8633301efc9f8f20$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some(function(fn) {
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $8633301efc9f8f20$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach(function(fn) {
            fn == null || fn(arg);
        });
    };
}
var $8633301efc9f8f20$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce(function(f1, f2) {
        return function() {
            return f1(f2.apply(void 0, arguments));
        };
    }, fn1);
};
function $8633301efc9f8f20$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $8633301efc9f8f20$export$8793edee2d425525 = function noop() {};
var $8633301efc9f8f20$export$c106dd0671a0fc2d = $8633301efc9f8f20$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $8633301efc9f8f20$export$a866f231438cc228) console.warn(message);
    };
});
var $8633301efc9f8f20$export$a3bc9b8ed74fc = $8633301efc9f8f20$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $8633301efc9f8f20$export$a866f231438cc228) console.error(message);
    };
});
var $8633301efc9f8f20$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return function(v) {
        return fns.reduce(function(a, b) {
            return b(a);
        }, v);
    };
};
var $8633301efc9f8f20$var$distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
};
var $8633301efc9f8f20$var$isPoint = function isPoint(point) {
    return "x" in point && "y" in point;
};
function $8633301efc9f8f20$export$9f17032d917177de(a, b) {
    if ($8633301efc9f8f20$export$7e4aa119212bc614(a) && $8633301efc9f8f20$export$7e4aa119212bc614(b)) return $8633301efc9f8f20$var$distance1D(a, b);
    if ($8633301efc9f8f20$var$isPoint(a) && $8633301efc9f8f20$var$isPoint(b)) {
        var xDelta = $8633301efc9f8f20$var$distance1D(a.x, b.x);
        var yDelta = $8633301efc9f8f20$var$distance1D(a.y, b.y);
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
    }
    return 0;
}
function $8633301efc9f8f20$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var _options = options, _options$isActive = _options.isActive, isActive = _options$isActive === void 0 ? $8633301efc9f8f20$export$8a2eb51c14bb8899 : _options$isActive, nextTick = _options.nextTick, _options$preventScrol = _options.preventScroll, preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol, _options$selectTextIf = _options.selectTextIfInput, selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            $8633301efc9f8f20$export$c106dd0671a0fc2d({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($8633301efc9f8f20$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $8633301efc9f8f20$var$getScrollableElements(element);
                $8633301efc9f8f20$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ($8633301efc9f8f20$export$63ed1d20cf8213cf(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $8633301efc9f8f20$var$supportsPreventScrollCached = null;
function $8633301efc9f8f20$var$supportsPreventScroll() {
    if ($8633301efc9f8f20$var$supportsPreventScrollCached == null) {
        $8633301efc9f8f20$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $8633301efc9f8f20$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $8633301efc9f8f20$var$supportsPreventScrollCached;
}
function $8633301efc9f8f20$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = $8633301efc9f8f20$export$b204af158042fbac(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $8633301efc9f8f20$var$restoreScrollPosition(scrollableElements) {
    for(var _iterator = $8633301efc9f8f20$var$_createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, element = _step$value.element, scrollTop = _step$value.scrollTop, scrollLeft = _step$value.scrollLeft;
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $8633301efc9f8f20$export$bffa455ba8c619a6(target, maxDepth) {
    if (maxDepth === void 0) maxDepth = Infinity;
    if (!$8633301efc9f8f20$export$a6cdc56e425d0d0a(target) && !Array.isArray(target) || !maxDepth) return target;
    return Object.entries(target).reduce(function(result, _ref) {
        var key = _ref[0], value = _ref[1];
        if ($8633301efc9f8f20$export$a6cdc56e425d0d0a(value) || $8633301efc9f8f20$export$43bee75e5e14138e(value)) Object.entries($8633301efc9f8f20$export$bffa455ba8c619a6(value, maxDepth - 1)).forEach(function(_ref2) {
            var childKey = _ref2[0], childValue = _ref2[1];
            // e.g. gray.500
            result[key + "." + childKey] = childValue;
        });
        else // e.g. transparent
        result[key] = value;
        return result;
    }, {});
}
/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $8633301efc9f8f20$export$1f16c1e83f5de19d(options) {
    var hasBeenSelected = options.hasBeenSelected, isLazy = options.isLazy, isSelected = options.isSelected, _options$lazyBehavior = options.lazyBehavior, lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}
var $8633301efc9f8f20$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $8633301efc9f8f20$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $8633301efc9f8f20$var$toNumber(value) {
    var num = parseFloat(value);
    return $8633301efc9f8f20$export$3f283ac14831e759(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */ function $8633301efc9f8f20$export$3e91a10e66078270(value, precision) {
    var nextValue = $8633301efc9f8f20$var$toNumber(value);
    var scaleFactor = Math.pow(10, precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */ function $8633301efc9f8f20$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */ function $8633301efc9f8f20$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */ function $8633301efc9f8f20$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */ function $8633301efc9f8f20$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $8633301efc9f8f20$export$a42544f265f8403(step);
    return $8633301efc9f8f20$export$3e91a10e66078270(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */ function $8633301efc9f8f20$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    $8633301efc9f8f20$export$c106dd0671a0fc2d({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}
function $8633301efc9f8f20$var$_extends() {
    $8633301efc9f8f20$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8633301efc9f8f20$var$_extends.apply(this, arguments);
}
/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ function $8633301efc9f8f20$export$764db16956f554f8(event) {
    var win = $8633301efc9f8f20$export$8d16348623687f6(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $8633301efc9f8f20$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $8633301efc9f8f20$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var win = $8633301efc9f8f20$export$8d16348623687f6(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $8633301efc9f8f20$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $8633301efc9f8f20$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $8633301efc9f8f20$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $8633301efc9f8f20$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $8633301efc9f8f20$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $8633301efc9f8f20$export$c4dfce035d43d1e0(event) ? $8633301efc9f8f20$var$pointFromTouch(event, pointType) : $8633301efc9f8f20$var$pointFromMouse(event, pointType)
    };
}
function $8633301efc9f8f20$export$750e59ed656e0503(event) {
    return $8633301efc9f8f20$export$12f84bb882d06e1a(event, "client");
}
var $8633301efc9f8f20$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function listener(event) {
        return handler(event, $8633301efc9f8f20$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $8633301efc9f8f20$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $8633301efc9f8f20$var$supportsPointerEvents = function supportsPointerEvents() {
    return $8633301efc9f8f20$export$4e09c449d6c407f7 && window.onpointerdown === null;
};
var $8633301efc9f8f20$var$supportsTouchEvents = function supportsTouchEvents() {
    return $8633301efc9f8f20$export$4e09c449d6c407f7 && window.ontouchstart === null;
};
var $8633301efc9f8f20$var$supportsMouseEvents = function supportsMouseEvents() {
    return $8633301efc9f8f20$export$4e09c449d6c407f7 && window.onmousedown === null;
};
var $8633301efc9f8f20$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $8633301efc9f8f20$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $8633301efc9f8f20$export$9fd5832907e02451(name) {
    if ($8633301efc9f8f20$var$supportsPointerEvents()) return name;
    if ($8633301efc9f8f20$var$supportsTouchEvents()) return $8633301efc9f8f20$var$touchEventNames[name];
    if ($8633301efc9f8f20$var$supportsMouseEvents()) return $8633301efc9f8f20$var$mouseEventNames[name];
    return name;
}
function $8633301efc9f8f20$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return $8633301efc9f8f20$export$b1d829ddf82884aa(target, $8633301efc9f8f20$export$9fd5832907e02451(eventName), $8633301efc9f8f20$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $8633301efc9f8f20$export$d06464d6b74eedc4(event) {
    return $8633301efc9f8f20$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */ /**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */ var $8633301efc9f8f20$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ function PanSession(_event, handlers, threshold) {
        var _this = this;
        this.history = [];
        this.startEvent = null;
        this.lastEvent = null;
        this.lastEventInfo = null;
        this.handlers = {};
        this.removeListeners = $8633301efc9f8f20$export$8793edee2d425525;
        this.threshold = 3;
        this.win = void 0;
        this.updatePoint = function() {
            if (!(_this.lastEvent && _this.lastEventInfo)) return;
            var info = $8633301efc9f8f20$var$getPanInfo(_this.lastEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = $8633301efc9f8f20$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= _this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var _getFrameData = (0, $74f0db85147db332$export$7244445918e670ed)(), timestamp = _getFrameData.timestamp;
            _this.history.push($8633301efc9f8f20$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var _this$handlers = _this.handlers, onStart = _this$handlers.onStart, onMove = _this$handlers.onMove;
            if (!isPanStarted) {
                onStart == null || onStart(_this.lastEvent, info);
                _this.startEvent = _this.lastEvent;
            }
            onMove == null || onMove(_this.lastEvent, info);
        };
        this.onPointerMove = function(event, info) {
            _this.lastEvent = event;
            _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ($8633301efc9f8f20$export$764db16956f554f8(event) && event.buttons === 0) {
                _this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.onPointerUp = function(event, info) {
            // notify pan session ended
            var panInfo = $8633301efc9f8f20$var$getPanInfo(info, _this.history);
            var _this$handlers2 = _this.handlers, onEnd = _this$handlers2.onEnd, onSessionEnd = _this$handlers2.onSessionEnd;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            _this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !_this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        };
        this.win = $8633301efc9f8f20$export$8d16348623687f6(_event); // If we have more than one touch, don't start detecting this gesture
        if ($8633301efc9f8f20$export$d06464d6b74eedc4(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = $8633301efc9f8f20$export$12f84bb882d06e1a(_event);
        var _getFrameData2 = (0, $74f0db85147db332$export$7244445918e670ed)(), _timestamp = _getFrameData2.timestamp;
        this.history = [
            $8633301efc9f8f20$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var onSessionStart = handlers.onSessionStart;
        onSessionStart == null || onSessionStart(_event, $8633301efc9f8f20$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = $8633301efc9f8f20$export$a4627e546088548d($8633301efc9f8f20$export$fcff2e64e6676b81(this.win, "pointermove", this.onPointerMove), $8633301efc9f8f20$export$fcff2e64e6676b81(this.win, "pointerup", this.onPointerUp), $8633301efc9f8f20$export$fcff2e64e6676b81(this.win, "pointercancel", this.onPointerUp));
    }
    var _proto = PanSession.prototype;
    _proto.updateHandlers = function updateHandlers(handlers) {
        this.handlers = handlers;
    };
    _proto.end = function end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $8633301efc9f8f20$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8633301efc9f8f20$var$startPanPoint(history) {
    return history[0];
}
function $8633301efc9f8f20$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $8633301efc9f8f20$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $8633301efc9f8f20$var$subtractPoint(info.point, $8633301efc9f8f20$var$lastPanPoint(history)),
        offset: $8633301efc9f8f20$var$subtractPoint(info.point, $8633301efc9f8f20$var$startPanPoint(history)),
        velocity: $8633301efc9f8f20$var$getVelocity(history, 0.1)
    };
}
function $8633301efc9f8f20$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $8633301efc9f8f20$var$toMilliseconds = function toMilliseconds(seconds) {
    return seconds * 1000;
};
function $8633301efc9f8f20$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $8633301efc9f8f20$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $8633301efc9f8f20$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
var $8633301efc9f8f20$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $8633301efc9f8f20$export$eca1915781c2aaca(prop, mapper) {
    if ($8633301efc9f8f20$export$43bee75e5e14138e(prop)) return prop.map(function(item) {
        if (item === null) return null;
        return mapper(item);
    });
    if ($8633301efc9f8f20$export$a6cdc56e425d0d0a(prop)) return $8633301efc9f8f20$export$259b4dd69e654a7a(prop).reduce(function(result, key) {
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $8633301efc9f8f20$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $8633301efc9f8f20$export$d07517a676ce386f;
    var result = bps.map(function(br) {
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while($8633301efc9f8f20$export$7475b2c64539e4cf(result) === null)result.pop();
    return result;
}
function $8633301efc9f8f20$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $8633301efc9f8f20$export$d07517a676ce386f;
    var result = {};
    values.forEach(function(value, index) {
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $8633301efc9f8f20$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $8633301efc9f8f20$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every(function(key) {
        return bps.includes(key);
    });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */ var $8633301efc9f8f20$export$4cdfc817e07de39e = function isCustomBreakpoint(maybeBreakpoint) {
    return Number.isNaN(Number(maybeBreakpoint));
};
function $8633301efc9f8f20$var$getUserAgentBrowser(navigator) {
    var ua = navigator.userAgent, vendor = navigator.vendor;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $8633301efc9f8f20$var$getUserAgentOS(navigator) {
    var ua = navigator.userAgent, platform = navigator.platform;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $8633301efc9f8f20$export$568a7d21694b4b32(navigator) {
    var ua = navigator.userAgent;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $8633301efc9f8f20$export$3070bd282ec37ea8(os) {
    if (!$8633301efc9f8f20$export$4e09c449d6c407f7) return false;
    return $8633301efc9f8f20$var$getUserAgentOS(window.navigator) === os;
}
function $8633301efc9f8f20$export$2d31490a0c05f094(browser) {
    if (!$8633301efc9f8f20$export$4e09c449d6c407f7) return false;
    return $8633301efc9f8f20$var$getUserAgentBrowser(window.navigator) === browser;
}
function $8633301efc9f8f20$export$8d04c8cf4d9e22d8() {
    if (!$8633301efc9f8f20$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $8633301efc9f8f20$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ($8633301efc9f8f20$export$43bee75e5e14138e(value)) return value.map(function(item, index) {
            return inner(item, [].concat(path, [
                String(index)
            ]));
        });
        if ($8633301efc9f8f20$export$a6cdc56e425d0d0a(value)) return $8633301efc9f8f20$export$5150077fc2e7c662(Object.entries(value).map(function(_ref) {
            var key = _ref[0], child = _ref[1];
            return [
                key,
                inner(child, [].concat(path, [
                    key
                ]))
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}


/**
 * Get the color raw value from theme
 * @param theme - the theme object
 * @param color - the color path ("green.200")
 * @param fallback - the fallback color
 */ var $d5f9fdb71638a7d2$export$5551a2d24ff40153 = function getColor(theme, color, fallback) {
    var hex = (0, $8633301efc9f8f20$export$1bb32d0c65da6059)(theme, "colors." + color, color);
    var _TinyColor = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(hex), isValid = _TinyColor.isValid;
    return isValid ? hex : fallback;
};
/**
 * Determines if the tone of given color is "light" or "dark"
 * @param color - the color in hex, rgb, or hsl
 */ var $d5f9fdb71638a7d2$export$7297c25227171a1f = function tone(color) {
    return function(theme) {
        var hex = $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color);
        var isDark = new (0, $9037ad6678b06e04$export$d850312fc213f33e)(hex).isDark();
        return isDark ? "dark" : "light";
    };
};
/**
 * Determines if a color tone is "dark"
 * @param color - the color in hex, rgb, or hsl
 */ var $d5f9fdb71638a7d2$export$a79ad82046afa44e = function isDark(color) {
    return function(theme) {
        return $d5f9fdb71638a7d2$export$7297c25227171a1f(color)(theme) === "dark";
    };
};
/**
 * Determines if a color tone is "light"
 * @param color - the color in hex, rgb, or hsl
 */ var $d5f9fdb71638a7d2$export$44af652f4cca9039 = function isLight(color) {
    return function(theme) {
        return $d5f9fdb71638a7d2$export$7297c25227171a1f(color)(theme) === "light";
    };
};
/**
 * Make a color transparent
 * @param color - the color in hex, rgb, or hsl
 * @param opacity - the amount of opacity the color should have (0-1)
 */ var $d5f9fdb71638a7d2$export$d11da87e55cc498f = function transparentize(color, opacity) {
    return function(theme) {
        var raw = $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color);
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)(raw).setAlpha(opacity).toRgbString();
    };
};
/**
 * Add white to a color
 * @param color - the color in hex, rgb, or hsl
 * @param amount - the amount white to add (0-100)
 */ var $d5f9fdb71638a7d2$export$81525e9955aa80e8 = function whiten(color, amount) {
    return function(theme) {
        var raw = $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color);
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)(raw).mix("#fff", amount).toHexString();
    };
};
/**
 * Add black to a color
 * @param color - the color in hex, rgb, or hsl
 * @param amount - the amount black to add (0-100)
 */ var $d5f9fdb71638a7d2$export$2b471577c483101c = function blacken(color, amount) {
    return function(theme) {
        var raw = $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color);
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)(raw).mix("#000", amount).toHexString();
    };
};
/**
 * Darken a specified color
 * @param color - the color in hex, rgb, or hsl
 * @param amount - the amount to darken (0-100)
 */ var $d5f9fdb71638a7d2$export$4b073707ff63303 = function darken(color, amount) {
    return function(theme) {
        var raw = $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color);
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)(raw).darken(amount).toHexString();
    };
};
/**
 * Lighten a specified color
 * @param color - the color in hex, rgb, or hsl
 * @param amount - the amount to lighten (0-100)
 */ var $d5f9fdb71638a7d2$export$c0816ed86df316af = function lighten(color, amount) {
    return function(theme) {
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)($d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color)).lighten(amount).toHexString();
    };
};
/**
 * Checks the contract ratio of between 2 colors,
 * based on the Web Content Accessibility Guidelines (Version 2.0).
 *
 * @param fg - the foreground or text color
 * @param bg - the background color
 */ var $d5f9fdb71638a7d2$export$1ec78ac20028ebd4 = function contrast(fg, bg) {
    return function(theme) {
        return (0, $2ee3749912db9e4a$export$b7b705aaad1c5b6a)($d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, bg), $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, fg));
    };
};
/**
 * Checks if a color meets the Web Content Accessibility
 * Guidelines (Version 2.0) for constract ratio.
 *
 * @param fg - the foreground or text color
 * @param bg - the background color
 */ var $d5f9fdb71638a7d2$export$cd41ae544cfc2a65 = function isAccessible(textColor, bgColor, options) {
    return function(theme) {
        return (0, $2ee3749912db9e4a$export$3fe5b5ca1e6a6a28)($d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, bgColor), $d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, textColor), options);
    };
};
var $d5f9fdb71638a7d2$export$504efcfbebdbcaf = function complementary(color) {
    return function(theme) {
        return new (0, $9037ad6678b06e04$export$d850312fc213f33e)($d5f9fdb71638a7d2$export$5551a2d24ff40153(theme, color)).complement().toHexString();
    };
};
function $d5f9fdb71638a7d2$export$db0ffb03ee9f3080(size, color) {
    if (size === void 0) size = "1rem";
    if (color === void 0) color = "rgba(255, 255, 255, 0.15)";
    return {
        backgroundImage: "linear-gradient(\n    45deg,\n    " + color + " 25%,\n    transparent 25%,\n    transparent 50%,\n    " + color + " 50%,\n    " + color + " 75%,\n    transparent 75%,\n    transparent\n  )",
        backgroundSize: size + " " + size
    };
}
function $d5f9fdb71638a7d2$export$f3c6ed4330abfc18(opts) {
    var fallback = (0, $b453fcfe7cf8f74a$export$4385e60b38654f68)().toHexString();
    if (!opts || (0, $8633301efc9f8f20$export$83b788b1a3698c03)(opts)) return fallback;
    if (opts.string && opts.colors) return $d5f9fdb71638a7d2$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $d5f9fdb71638a7d2$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $d5f9fdb71638a7d2$var$randomFromList(opts.colors);
    return fallback;
}
function $d5f9fdb71638a7d2$var$randomColorFromString(str) {
    var hash = 0;
    if (str.length === 0) return hash.toString();
    for(var i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    var color = "#";
    for(var j = 0; j < 3; j += 1){
        var value = hash >> j * 8 & 255;
        color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
}
function $d5f9fdb71638a7d2$var$randomColorFromList(str, list) {
    var index = 0;
    if (str.length === 0) return list[0];
    for(var i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $d5f9fdb71638a7d2$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}
function $d5f9fdb71638a7d2$export$549ff81930776885(light, dark) {
    return function(props) {
        return props.colorMode === "dark" ? dark : light;
    };
}
function $d5f9fdb71638a7d2$export$f3eec17ee6065eee(options) {
    var orientation = options.orientation, vertical = options.vertical, horizontal = options.horizontal;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}
function $d5f9fdb71638a7d2$var$_extends() {
    $d5f9fdb71638a7d2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5f9fdb71638a7d2$var$_extends.apply(this, arguments);
}
var $d5f9fdb71638a7d2$export$79e1df82cbbff4e9 = function createBreakpoints(config) {
    (0, $8633301efc9f8f20$export$c106dd0671a0fc2d)({
        condition: true,
        message: [
            "[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon",
            "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"
        ].join("")
    });
    return $d5f9fdb71638a7d2$var$_extends({
        base: "0em"
    }, config);
};
function $d5f9fdb71638a7d2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d5f9fdb71638a7d2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d5f9fdb71638a7d2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d5f9fdb71638a7d2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Used to define the anatomy/parts of a component in a way that provides
 * a consistent API for `className`, css selector and `theming`.
 */ var $d5f9fdb71638a7d2$export$e6a1266c2b44f52f = /*#__PURE__*/ function() {
    function Anatomy(name) {
        var _this = this;
        this.map = {};
        this.called = false;
        this.assert = function() {
            if (!_this.called) {
                _this.called = true;
                return;
            }
            throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
        };
        this.parts = function() {
            _this.assert();
            for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
            for(var _i = 0, _values = values; _i < _values.length; _i++){
                var part = _values[_i];
                _this.map[part] = _this.toPart(part);
            }
            return _this;
        };
        this.extend = function() {
            for(var _len2 = arguments.length, parts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)parts[_key2] = arguments[_key2];
            for(var _i2 = 0, _parts = parts; _i2 < _parts.length; _i2++){
                var part = _parts[_i2];
                if (part in _this.map) continue;
                _this.map[part] = _this.toPart(part);
            }
            return _this;
        };
        this.toPart = function(part) {
            var el = [
                "container",
                "root"
            ].includes(part != null ? part : "") ? [
                _this.name
            ] : [
                _this.name,
                part
            ];
            var attr = el.filter(Boolean).join("__");
            var className = "chakra-" + attr;
            var partObj = {
                className: className,
                selector: "." + className,
                toString: function toString() {
                    return part;
                }
            };
            return partObj;
        };
        this.__type = {};
    }
    /**
   * Prevents user from calling `.parts` multiple times.
   * It should only be called once.
   */ $d5f9fdb71638a7d2$var$_createClass(Anatomy, [
        {
            key: "selectors",
            get: /**
     * Get all selectors for the component anatomy
     */ function get() {
                var value = (0, $8633301efc9f8f20$export$5150077fc2e7c662)(Object.entries(this.map).map(function(_ref) {
                    var key = _ref[0], part = _ref[1];
                    return [
                        key,
                        part.selector
                    ];
                }));
                return value;
            }
        },
        {
            key: "classNames",
            get: function get() {
                var value = (0, $8633301efc9f8f20$export$5150077fc2e7c662)(Object.entries(this.map).map(function(_ref2) {
                    var key = _ref2[0], part = _ref2[1];
                    return [
                        key,
                        part.className
                    ];
                }));
                return value;
            }
        },
        {
            key: "keys",
            get: function get() {
                return Object.keys(this.map);
            }
        }
    ]);
    return Anatomy;
}();
function $d5f9fdb71638a7d2$export$477202748c7242bf(name) {
    return new $d5f9fdb71638a7d2$export$e6a1266c2b44f52f(name);
}
function $d5f9fdb71638a7d2$var$toRef(operand) {
    if ((0, $8633301efc9f8f20$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $d5f9fdb71638a7d2$var$toExpr = function toExpr(operator) {
    for(var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)operands[_key - 1] = arguments[_key];
    return operands.map($d5f9fdb71638a7d2$var$toRef).join(" " + operator + " ").replace(/calc/g, "");
};
var $d5f9fdb71638a7d2$var$_add = function add() {
    for(var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)operands[_key2] = arguments[_key2];
    return "calc(" + $d5f9fdb71638a7d2$var$toExpr.apply(void 0, [
        "+"
    ].concat(operands)) + ")";
};
var $d5f9fdb71638a7d2$var$_subtract = function subtract() {
    for(var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)operands[_key3] = arguments[_key3];
    return "calc(" + $d5f9fdb71638a7d2$var$toExpr.apply(void 0, [
        "-"
    ].concat(operands)) + ")";
};
var $d5f9fdb71638a7d2$var$_multiply = function multiply() {
    for(var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)operands[_key4] = arguments[_key4];
    return "calc(" + $d5f9fdb71638a7d2$var$toExpr.apply(void 0, [
        "*"
    ].concat(operands)) + ")";
};
var $d5f9fdb71638a7d2$var$_divide = function divide() {
    for(var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)operands[_key5] = arguments[_key5];
    return "calc(" + $d5f9fdb71638a7d2$var$toExpr.apply(void 0, [
        "/"
    ].concat(operands)) + ")";
};
var $d5f9fdb71638a7d2$var$_negate = function negate(x) {
    var value = $d5f9fdb71638a7d2$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
    return $d5f9fdb71638a7d2$var$_multiply(value, -1);
};
var $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a = Object.assign(function(x) {
    return {
        add: function add() {
            for(var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)operands[_key6] = arguments[_key6];
            return $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a($d5f9fdb71638a7d2$var$_add.apply(void 0, [
                x
            ].concat(operands)));
        },
        subtract: function subtract() {
            for(var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)operands[_key7] = arguments[_key7];
            return $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a($d5f9fdb71638a7d2$var$_subtract.apply(void 0, [
                x
            ].concat(operands)));
        },
        multiply: function multiply() {
            for(var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)operands[_key8] = arguments[_key8];
            return $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a($d5f9fdb71638a7d2$var$_multiply.apply(void 0, [
                x
            ].concat(operands)));
        },
        divide: function divide() {
            for(var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)operands[_key9] = arguments[_key9];
            return $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a($d5f9fdb71638a7d2$var$_divide.apply(void 0, [
                x
            ].concat(operands)));
        },
        negate: function negate() {
            return $d5f9fdb71638a7d2$export$42bfa9b2d4dad91a($d5f9fdb71638a7d2$var$_negate(x));
        },
        toString: function toString() {
            return x.toString();
        }
    };
}, {
    add: $d5f9fdb71638a7d2$var$_add,
    subtract: $d5f9fdb71638a7d2$var$_subtract,
    multiply: $d5f9fdb71638a7d2$var$_multiply,
    divide: $d5f9fdb71638a7d2$var$_divide,
    negate: $d5f9fdb71638a7d2$var$_negate
});
function $d5f9fdb71638a7d2$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $d5f9fdb71638a7d2$var$replaceWhiteSpace(value, replaceValue) {
    if (replaceValue === void 0) replaceValue = "-";
    return value.replace(/\s+/g, replaceValue);
}
function $d5f9fdb71638a7d2$var$escape(value) {
    var valueStr = $d5f9fdb71638a7d2$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $d5f9fdb71638a7d2$export$2ad0182371401ea4(value) ? valueStr.replace(".", "\\.") : value;
}
function $d5f9fdb71638a7d2$export$9748efee331ec573(value, prefix) {
    if (prefix === void 0) prefix = "";
    return [
        prefix,
        $d5f9fdb71638a7d2$var$escape(value)
    ].filter(Boolean).join("-");
}
function $d5f9fdb71638a7d2$export$44410db3a43190e8(name, fallback) {
    return "var(" + $d5f9fdb71638a7d2$var$escape(name) + (fallback ? ", " + fallback : "") + ")";
}
function $d5f9fdb71638a7d2$export$e2ffa342f278b3a3(value, prefix) {
    if (prefix === void 0) prefix = "";
    return "--" + $d5f9fdb71638a7d2$export$9748efee331ec573(value, prefix);
}
function $d5f9fdb71638a7d2$export$8b4981022bd80a4e(name, options) {
    var cssVariable = $d5f9fdb71638a7d2$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $d5f9fdb71638a7d2$export$44410db3a43190e8(cssVariable, $d5f9fdb71638a7d2$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $d5f9fdb71638a7d2$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


var $c9f2bd010a260619$export$377a77e99e7c73a5 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("accordion").parts("container", "item", "button", "panel").extend("icon");
var $c9f2bd010a260619$export$fc51889fa4de265a = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("alert").parts("title", "description", "container").extend("icon");
var $c9f2bd010a260619$export$60f8655d889e17c7 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $c9f2bd010a260619$export$2fb03f744a6ecf93 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("breadcrumb").parts("link", "item").extend("separator");
var $c9f2bd010a260619$export$1699c5cb20c07888 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("button").parts();
var $c9f2bd010a260619$export$21946b04497ed6ac = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("checkbox").parts("control", "icon").extend("label");
var $c9f2bd010a260619$export$2c953111278f3272 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("progress").parts("track", "filledTrack").extend("label");
var $c9f2bd010a260619$export$d3f4aaa4b0f2907a = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $c9f2bd010a260619$export$2813c9511eeab082 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("editable").parts("preview", "input");
var $c9f2bd010a260619$export$4b243e3f209a7e5e = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
var $c9f2bd010a260619$export$bb18c440c00e82d9 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("formError").parts("text", "icon");
var $c9f2bd010a260619$export$1ffeb100b532f46d = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("input").parts("addon", "field", "element");
var $c9f2bd010a260619$export$12b3a655a94374ed = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("list").parts("container", "item", "icon");
var $c9f2bd010a260619$export$e251092a5dcb1329 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var $c9f2bd010a260619$export$34e33beb8d992ac2 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $c9f2bd010a260619$export$859cc7ca3200df97 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $c9f2bd010a260619$export$12bb869d7991ac50 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("pininput").parts("field");
var $c9f2bd010a260619$export$afda07d12cd4337d = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow");
var $c9f2bd010a260619$export$ba6328c242bd649c = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
var $c9f2bd010a260619$export$d28d06d0e29ef022 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("radio").parts("container", "control", "label");
var $c9f2bd010a260619$export$17993f0be9538b5a = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("select").parts("field", "icon");
var $c9f2bd010a260619$export$c21b4b3f8b239f32 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack");
var $c9f2bd010a260619$export$2cfbad67ae6ee421 = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
var $c9f2bd010a260619$export$921c1a2d1ce1e86a = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("switch").parts("container", "track", "thumb");
var $c9f2bd010a260619$export$8b1b9cdd5db9f5fd = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $c9f2bd010a260619$export$97383552563be58d = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $c9f2bd010a260619$export$4c2f5f7f2ea94a8e = (0, $d5f9fdb71638a7d2$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");


var $a76ebe31696bdb5b$var$baseStyleContainer = {
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
};
var $a76ebe31696bdb5b$var$baseStyleButton = {
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "1rem",
    _focus: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: 4,
    py: 2
};
var $a76ebe31696bdb5b$var$baseStylePanel = {
    pt: 2,
    px: 4,
    pb: 5
};
var $a76ebe31696bdb5b$var$baseStyleIcon = {
    fontSize: "1.25em"
};
var $a76ebe31696bdb5b$var$baseStyle = {
    container: $a76ebe31696bdb5b$var$baseStyleContainer,
    button: $a76ebe31696bdb5b$var$baseStyleButton,
    panel: $a76ebe31696bdb5b$var$baseStylePanel,
    icon: $a76ebe31696bdb5b$var$baseStyleIcon
};
var $a76ebe31696bdb5b$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$377a77e99e7c73a5).keys,
    baseStyle: $a76ebe31696bdb5b$var$baseStyle
};



var $99de6a8b7ddaa6bc$exports = {};
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
(function(Math1) {
    var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math1.round, mathMin = Math1.min, mathMax = Math1.max, mathRandom = Math1.random;
    function tinycolor(color, opts) {
        color = color ? color : '';
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = mathRound(this._r);
        if (this._g < 1) this._g = mathRound(this._g);
        if (this._b < 1) this._b = mathRound(this._b);
        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    }
    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
            return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math1.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math1.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math1.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100 * this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function(allow4Char) {
            return '#' + this.toHex8(allow4Char);
        },
        toRgb: function() {
            return {
                r: mathRound(this._r),
                g: mathRound(this._g),
                b: mathRound(this._b),
                a: this._a
            };
        },
        toRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return {
                r: mathRound(bound01(this._r, 255) * 100) + "%",
                g: mathRound(bound01(this._g, 255) * 100) + "%",
                b: mathRound(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function() {
            return tinycolor(this.toString());
        },
        _applyModification: function(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },
        _applyCombination: function(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (typeof color == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math1.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 120) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 240) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 90) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 180) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 270) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math1.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math1.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            "level": level,
            "size": size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math1.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math1.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == 'transparent') return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            "level": "AA",
            "size": "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            "level": level,
            "size": size
        };
    }
    // Node: Export function
    if ($99de6a8b7ddaa6bc$exports) $99de6a8b7ddaa6bc$exports = tinycolor;
    else if (typeof define === 'function' && define.amd) define(function() {
        return tinycolor;
    });
    else window.tinycolor = tinycolor;
})(Math);



var $188d0d70c4460bfd$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    var hex = (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, "colors." + color, color);
    var isValid = (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))(hex).isValid();
    return isValid ? hex : fallback;
};
var $188d0d70c4460bfd$export$7297c25227171a1f = (color)=>(theme)=>{
        var hex = $188d0d70c4460bfd$export$5551a2d24ff40153(theme, color);
        var isDark = (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))(hex).isDark();
        return isDark ? "dark" : "light";
    };
var $188d0d70c4460bfd$export$a79ad82046afa44e = (color)=>(theme)=>$188d0d70c4460bfd$export$7297c25227171a1f(color)(theme) === "dark";
var $188d0d70c4460bfd$export$44af652f4cca9039 = (color)=>(theme)=>$188d0d70c4460bfd$export$7297c25227171a1f(color)(theme) === "light";
var $188d0d70c4460bfd$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        var raw = $188d0d70c4460bfd$export$5551a2d24ff40153(theme, color);
        return (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))(raw).setAlpha(opacity).toRgbString();
    };
var $188d0d70c4460bfd$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        var raw = $188d0d70c4460bfd$export$5551a2d24ff40153(theme, color);
        return (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports))).mix(raw, "#fff", amount).toHexString();
    };
var $188d0d70c4460bfd$export$2b471577c483101c = (color, amount)=>(theme)=>{
        var raw = $188d0d70c4460bfd$export$5551a2d24ff40153(theme, color);
        return (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports))).mix(raw, "#000", amount).toHexString();
    };
var $188d0d70c4460bfd$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        var raw = $188d0d70c4460bfd$export$5551a2d24ff40153(theme, color);
        return (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))(raw).darken(amount).toHexString();
    };
var $188d0d70c4460bfd$export$c0816ed86df316af = (color, amount)=>(theme)=>(0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))($188d0d70c4460bfd$export$5551a2d24ff40153(theme, color)).lighten(amount).toHexString();
var $188d0d70c4460bfd$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports))).readability($188d0d70c4460bfd$export$5551a2d24ff40153(theme, bg), $188d0d70c4460bfd$export$5551a2d24ff40153(theme, fg));
var $188d0d70c4460bfd$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>(0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports))).isReadable($188d0d70c4460bfd$export$5551a2d24ff40153(theme, bgColor), $188d0d70c4460bfd$export$5551a2d24ff40153(theme, textColor), options);
var $188d0d70c4460bfd$export$504efcfbebdbcaf = (color)=>(theme)=>(0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports)))($188d0d70c4460bfd$export$5551a2d24ff40153(theme, color)).complement().toHexString();
function $188d0d70c4460bfd$export$db0ffb03ee9f3080(size, color) {
    if (size === void 0) size = "1rem";
    if (color === void 0) color = "rgba(255, 255, 255, 0.15)";
    return {
        backgroundImage: "linear-gradient(\n    45deg,\n    " + color + " 25%,\n    transparent 25%,\n    transparent 50%,\n    " + color + " 50%,\n    " + color + " 75%,\n    transparent 75%,\n    transparent\n  )",
        backgroundSize: size + " " + size
    };
}
function $188d0d70c4460bfd$export$f3c6ed4330abfc18(opts) {
    var fallback = (0, (/*@__PURE__*/$parcel$interopDefault($99de6a8b7ddaa6bc$exports))).random().toHexString();
    if (!opts || (0, $6b74ef5ae6a56e47$export$83b788b1a3698c03)(opts)) return fallback;
    if (opts.string && opts.colors) return $188d0d70c4460bfd$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $188d0d70c4460bfd$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $188d0d70c4460bfd$var$randomFromList(opts.colors);
    return fallback;
}
function $188d0d70c4460bfd$var$randomColorFromString(str) {
    var hash = 0;
    if (str.length === 0) return hash.toString();
    for(var i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    var color = "#";
    for(var j = 0; j < 3; j += 1){
        var value = hash >> j * 8 & 255;
        color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
}
function $188d0d70c4460bfd$var$randomColorFromList(str, list) {
    var index = 0;
    if (str.length === 0) return list[0];
    for(var i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $188d0d70c4460bfd$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


function $f466d5c40b760069$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $f466d5c40b760069$export$f3eec17ee6065eee(options) {
    var { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}


var $82f8036bf4090350$var$baseStyle = {
    container: {
        px: 4,
        py: 3
    },
    title: {
        fontWeight: "bold",
        lineHeight: 6,
        marginEnd: 2
    },
    description: {
        lineHeight: 6
    },
    icon: {
        flexShrink: 0,
        marginEnd: 3,
        w: 5,
        h: 6
    }
};
function $82f8036bf4090350$var$getBg(props) {
    var { theme: theme, colorScheme: c } = props;
    var lightBg = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, c + ".100", c);
    var darkBg = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.16)(theme);
    return (0, $f466d5c40b760069$export$549ff81930776885)(lightBg, darkBg)(props);
}
var $82f8036bf4090350$var$variantSubtle = (props)=>{
    var { colorScheme: c } = props;
    return {
        container: {
            bg: $82f8036bf4090350$var$getBg(props)
        },
        icon: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
        }
    };
};
var $82f8036bf4090350$var$variantLeftAccent = (props)=>{
    var { colorScheme: c } = props;
    return {
        container: {
            paddingStart: 3,
            borderStartWidth: "4px",
            borderStartColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            bg: $82f8036bf4090350$var$getBg(props)
        },
        icon: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
        }
    };
};
var $82f8036bf4090350$var$variantTopAccent = (props)=>{
    var { colorScheme: c } = props;
    return {
        container: {
            pt: 2,
            borderTopWidth: "4px",
            borderTopColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            bg: $82f8036bf4090350$var$getBg(props)
        },
        icon: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
        }
    };
};
var $82f8036bf4090350$var$variantSolid = (props)=>{
    var { colorScheme: c } = props;
    return {
        container: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            color: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.900")(props)
        }
    };
};
var $82f8036bf4090350$var$variants = {
    subtle: $82f8036bf4090350$var$variantSubtle,
    "left-accent": $82f8036bf4090350$var$variantLeftAccent,
    "top-accent": $82f8036bf4090350$var$variantTopAccent,
    solid: $82f8036bf4090350$var$variantSolid
};
var $82f8036bf4090350$var$defaultProps = {
    variant: "subtle",
    colorScheme: "blue"
};
var $82f8036bf4090350$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$fc51889fa4de265a).keys,
    baseStyle: $82f8036bf4090350$var$baseStyle,
    variants: $82f8036bf4090350$var$variants,
    defaultProps: $82f8036bf4090350$var$defaultProps
};




var $54ff0d233c03fddc$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
}; /**
 * @deprecated
 * Spacing tokens are a part of DefaultChakraTheme['sizes']
 */ 


function $dade5440bdd7be94$var$_extends() {
    $dade5440bdd7be94$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dade5440bdd7be94$var$_extends.apply(this, arguments);
}
var $dade5440bdd7be94$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem"
};
var $dade5440bdd7be94$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $dade5440bdd7be94$var$sizes = $dade5440bdd7be94$var$_extends({}, (0, $54ff0d233c03fddc$export$5458b64234d1333c), $dade5440bdd7be94$var$largeSizes, {
    container: $dade5440bdd7be94$var$container
});
var /**
 * @deprecated
 * You can derive the Sizes type from the DefaultChakraTheme
 *
 * type Sizes = DefaultChakraTheme['sizes']
 */ $dade5440bdd7be94$export$2e2bcd8739ae039 = $dade5440bdd7be94$var$sizes;


var $d27c7905eb1344e6$var$baseStyleBadge = (props)=>{
    return {
        transform: "translate(25%, 25%)",
        borderRadius: "full",
        border: "0.2em solid",
        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.800")(props)
    };
};
var $d27c7905eb1344e6$var$baseStyleExcessLabel = (props)=>{
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.400")(props)
    };
};
var $d27c7905eb1344e6$var$baseStyleContainer = (props)=>{
    var { name: name, theme: theme } = props;
    var bg = name ? (0, $188d0d70c4460bfd$export$f3c6ed4330abfc18)({
        string: name
    }) : "gray.400";
    var isBgDark = (0, $188d0d70c4460bfd$export$a79ad82046afa44e)(bg)(theme);
    var color = "white";
    if (!isBgDark) color = "gray.800";
    var borderColor = (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.800")(props);
    return {
        bg: bg,
        color: color,
        borderColor: borderColor,
        verticalAlign: "top"
    };
};
var $d27c7905eb1344e6$var$baseStyle = (props)=>({
        badge: $d27c7905eb1344e6$var$baseStyleBadge(props),
        excessLabel: $d27c7905eb1344e6$var$baseStyleExcessLabel(props),
        container: $d27c7905eb1344e6$var$baseStyleContainer(props)
    });
function $d27c7905eb1344e6$var$getSize(size) {
    var themeSize = (0, $dade5440bdd7be94$export$2e2bcd8739ae039)[size];
    return {
        container: {
            width: size,
            height: size,
            fontSize: "calc(" + (themeSize != null ? themeSize : size) + " / 2.5)"
        },
        excessLabel: {
            width: size,
            height: size
        },
        label: {
            fontSize: "calc(" + (themeSize != null ? themeSize : size) + " / 2.5)",
            lineHeight: size !== "100%" ? themeSize != null ? themeSize : size : undefined
        }
    };
}
var $d27c7905eb1344e6$var$sizes = {
    "2xs": $d27c7905eb1344e6$var$getSize("4"),
    xs: $d27c7905eb1344e6$var$getSize("6"),
    sm: $d27c7905eb1344e6$var$getSize("8"),
    md: $d27c7905eb1344e6$var$getSize("12"),
    lg: $d27c7905eb1344e6$var$getSize("16"),
    xl: $d27c7905eb1344e6$var$getSize("24"),
    "2xl": $d27c7905eb1344e6$var$getSize("32"),
    full: $d27c7905eb1344e6$var$getSize("100%")
};
var $d27c7905eb1344e6$var$defaultProps = {
    size: "md"
};
var $d27c7905eb1344e6$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$60f8655d889e17c7).keys,
    baseStyle: $d27c7905eb1344e6$var$baseStyle,
    sizes: $d27c7905eb1344e6$var$sizes,
    defaultProps: $d27c7905eb1344e6$var$defaultProps
};



var $2c5b2081ece66e86$var$baseStyle = {
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold"
};
var $2c5b2081ece66e86$var$variantSolid = (props)=>{
    var { colorScheme: c, theme: theme } = props;
    var dark = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".500", 0.6)(theme);
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", dark)(props),
        color: (0, $f466d5c40b760069$export$549ff81930776885)("white", "whiteAlpha.800")(props)
    };
};
var $2c5b2081ece66e86$var$variantSubtle = (props)=>{
    var { colorScheme: c, theme: theme } = props;
    var darkBg = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.16)(theme);
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", darkBg)(props),
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".800", c + ".200")(props)
    };
};
var $2c5b2081ece66e86$var$variantOutline = (props)=>{
    var { colorScheme: c, theme: theme } = props;
    var darkColor = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.8)(theme);
    var lightColor = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, c + ".500");
    var color = (0, $f466d5c40b760069$export$549ff81930776885)(lightColor, darkColor)(props);
    return {
        color: color,
        boxShadow: "inset 0 0 0px 1px " + color
    };
};
var $2c5b2081ece66e86$var$variants = {
    solid: $2c5b2081ece66e86$var$variantSolid,
    subtle: $2c5b2081ece66e86$var$variantSubtle,
    outline: $2c5b2081ece66e86$var$variantOutline
};
var $2c5b2081ece66e86$var$defaultProps = {
    variant: "subtle",
    colorScheme: "gray"
};
var $2c5b2081ece66e86$export$2e2bcd8739ae039 = {
    baseStyle: $2c5b2081ece66e86$var$baseStyle,
    variants: $2c5b2081ece66e86$var$variants,
    defaultProps: $2c5b2081ece66e86$var$defaultProps
};



var $ce6db257809fff92$var$baseStyleLink = {
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focus: {
        boxShadow: "outline"
    }
};
var $ce6db257809fff92$var$baseStyle = {
    link: $ce6db257809fff92$var$baseStyleLink
};
var $ce6db257809fff92$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$2fb03f744a6ecf93).keys,
    baseStyle: $ce6db257809fff92$var$baseStyle
};



function $69d6f122b634382c$var$_extends() {
    $69d6f122b634382c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69d6f122b634382c$var$_extends.apply(this, arguments);
}
var $69d6f122b634382c$var$baseStyle = {
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
};
var $69d6f122b634382c$var$variantGhost = (props)=>{
    var { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)("inherit", "whiteAlpha.900")(props),
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.200")(props)
        },
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props)
        }
    };
    var darkHoverBg = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.12)(theme);
    var darkActiveBg = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.24)(theme);
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".200")(props),
        bg: "transparent",
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".50", darkHoverBg)(props)
        },
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", darkActiveBg)(props)
        }
    };
};
var $69d6f122b634382c$var$variantOutline = (props)=>{
    var { colorScheme: c } = props;
    var borderColor = (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props);
    return $69d6f122b634382c$var$_extends({
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor"
    }, $69d6f122b634382c$var$variantGhost(props));
};
/** Accessible color overrides for less accessible colors. */ var $69d6f122b634382c$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $69d6f122b634382c$var$variantSolid = (props)=>{
    var _accessibleColorMap$c;
    var { colorScheme: c } = props;
    if (c === "gray") {
        var _bg = (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.200")(props);
        return {
            bg: _bg,
            _hover: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                _disabled: {
                    bg: _bg
                }
            },
            _active: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            }
        };
    }
    var { bg: bg = c + ".500", color: color = "white", hoverBg: hoverBg = c + ".600", activeBg: activeBg = c + ".700" } = (_accessibleColorMap$c = $69d6f122b634382c$var$accessibleColorMap[c]) != null ? _accessibleColorMap$c : {};
    var background = (0, $f466d5c40b760069$export$549ff81930776885)(bg, c + ".200")(props);
    return {
        bg: background,
        color: (0, $f466d5c40b760069$export$549ff81930776885)(color, "gray.800")(props),
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(hoverBg, c + ".300")(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(activeBg, c + ".400")(props)
        }
    };
};
var $69d6f122b634382c$var$variantLink = (props)=>{
    var { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".700", c + ".500")(props)
        }
    };
};
var $69d6f122b634382c$var$variantUnstyled = {
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: 0,
    p: 0
};
var $69d6f122b634382c$var$variants = {
    ghost: $69d6f122b634382c$var$variantGhost,
    outline: $69d6f122b634382c$var$variantOutline,
    solid: $69d6f122b634382c$var$variantSolid,
    link: $69d6f122b634382c$var$variantLink,
    unstyled: $69d6f122b634382c$var$variantUnstyled
};
var $69d6f122b634382c$var$sizes = {
    lg: {
        h: 12,
        minW: 12,
        fontSize: "lg",
        px: 6
    },
    md: {
        h: 10,
        minW: 10,
        fontSize: "md",
        px: 4
    },
    sm: {
        h: 8,
        minW: 8,
        fontSize: "sm",
        px: 3
    },
    xs: {
        h: 6,
        minW: 6,
        fontSize: "xs",
        px: 2
    }
};
var $69d6f122b634382c$var$defaultProps = {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
};
var $69d6f122b634382c$export$2e2bcd8739ae039 = {
    baseStyle: $69d6f122b634382c$var$baseStyle,
    variants: $69d6f122b634382c$var$variants,
    sizes: $69d6f122b634382c$var$sizes,
    defaultProps: $69d6f122b634382c$var$defaultProps
};




var $d4f577d072848e75$var$baseStyleControl = (props)=>{
    var { colorScheme: c } = props;
    return {
        w: "100%",
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            color: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props),
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props)
            },
            _disabled: {
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            color: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focus: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
};
var $d4f577d072848e75$var$baseStyleLabel = {
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
};
var $d4f577d072848e75$var$baseStyleIcon = {
    transitionProperty: "transform",
    transitionDuration: "normal"
};
var $d4f577d072848e75$var$baseStyle = (props)=>({
        icon: $d4f577d072848e75$var$baseStyleIcon,
        control: $d4f577d072848e75$var$baseStyleControl(props),
        label: $d4f577d072848e75$var$baseStyleLabel
    });
var $d4f577d072848e75$var$sizes = {
    sm: {
        control: {
            h: 3,
            w: 3
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "0.45rem"
        }
    },
    md: {
        control: {
            w: 4,
            h: 4
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "0.625rem"
        }
    },
    lg: {
        control: {
            w: 5,
            h: 5
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "0.625rem"
        }
    }
};
var $d4f577d072848e75$var$defaultProps = {
    size: "md",
    colorScheme: "blue"
};
var $d4f577d072848e75$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$21946b04497ed6ac).keys,
    baseStyle: $d4f577d072848e75$var$baseStyle,
    sizes: $d4f577d072848e75$var$sizes,
    defaultProps: $d4f577d072848e75$var$defaultProps
};


function $e8dd38ff16de6a40$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $e8dd38ff16de6a40$var$replaceWhiteSpace(value, replaceValue) {
    if (replaceValue === void 0) replaceValue = "-";
    return value.replace(/\s+/g, replaceValue);
}
function $e8dd38ff16de6a40$var$escape(value) {
    var valueStr = $e8dd38ff16de6a40$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $e8dd38ff16de6a40$export$2ad0182371401ea4(value) ? valueStr.replace(".", "\\.") : value;
}
function $e8dd38ff16de6a40$export$9748efee331ec573(value, prefix) {
    if (prefix === void 0) prefix = "";
    return [
        prefix,
        $e8dd38ff16de6a40$var$escape(value)
    ].filter(Boolean).join("-");
}
function $e8dd38ff16de6a40$export$44410db3a43190e8(name, fallback) {
    return "var(" + $e8dd38ff16de6a40$var$escape(name) + (fallback ? ", " + fallback : "") + ")";
}
function $e8dd38ff16de6a40$export$e2ffa342f278b3a3(value, prefix) {
    if (prefix === void 0) prefix = "";
    return "--" + $e8dd38ff16de6a40$export$9748efee331ec573(value, prefix);
}
function $e8dd38ff16de6a40$export$8b4981022bd80a4e(name, options) {
    var cssVariable = $e8dd38ff16de6a40$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $e8dd38ff16de6a40$export$44410db3a43190e8(cssVariable, $e8dd38ff16de6a40$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $e8dd38ff16de6a40$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


var $8481c5189c69df39$var$$size = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("close-button-size");
var $8481c5189c69df39$var$baseStyle = (props)=>{
    var hoverBg = (0, $f466d5c40b760069$export$549ff81930776885)("blackAlpha.100", "whiteAlpha.100")(props);
    var activeBg = (0, $f466d5c40b760069$export$549ff81930776885)("blackAlpha.200", "whiteAlpha.200")(props);
    return {
        w: [
            $8481c5189c69df39$var$$size.reference
        ],
        h: [
            $8481c5189c69df39$var$$size.reference
        ],
        borderRadius: "md",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed",
            boxShadow: "none"
        },
        _hover: {
            bg: hoverBg
        },
        _active: {
            bg: activeBg
        },
        _focus: {
            boxShadow: "outline"
        }
    };
};
var $8481c5189c69df39$var$sizes = {
    lg: {
        [$8481c5189c69df39$var$$size.variable]: "40px",
        fontSize: "16px"
    },
    md: {
        [$8481c5189c69df39$var$$size.variable]: "32px",
        fontSize: "12px"
    },
    sm: {
        [$8481c5189c69df39$var$$size.variable]: "24px",
        fontSize: "10px"
    }
};
var $8481c5189c69df39$var$defaultProps = {
    size: "md"
};
var $8481c5189c69df39$export$2e2bcd8739ae039 = {
    baseStyle: $8481c5189c69df39$var$baseStyle,
    sizes: $8481c5189c69df39$var$sizes,
    defaultProps: $8481c5189c69df39$var$defaultProps
};



var { variants: $c5fdfec9105a9689$var$variants, defaultProps: $c5fdfec9105a9689$var$defaultProps } = (0, $2c5b2081ece66e86$export$2e2bcd8739ae039);
var $c5fdfec9105a9689$var$baseStyle = {
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm"
};
var $c5fdfec9105a9689$export$2e2bcd8739ae039 = {
    baseStyle: $c5fdfec9105a9689$var$baseStyle,
    variants: $c5fdfec9105a9689$var$variants,
    defaultProps: $c5fdfec9105a9689$var$defaultProps
};


var $6151210835d9f9b3$var$baseStyle = {
    w: "100%",
    mx: "auto",
    maxW: "60ch",
    px: "1rem"
};
var $6151210835d9f9b3$export$2e2bcd8739ae039 = {
    baseStyle: $6151210835d9f9b3$var$baseStyle
};


var $6d5b744f499a0384$var$baseStyle = {
    opacity: 0.6,
    borderColor: "inherit"
};
var $6d5b744f499a0384$var$variantSolid = {
    borderStyle: "solid"
};
var $6d5b744f499a0384$var$variantDashed = {
    borderStyle: "dashed"
};
var $6d5b744f499a0384$var$variants = {
    solid: $6d5b744f499a0384$var$variantSolid,
    dashed: $6d5b744f499a0384$var$variantDashed
};
var $6d5b744f499a0384$var$defaultProps = {
    variant: "solid"
};
var $6d5b744f499a0384$export$2e2bcd8739ae039 = {
    baseStyle: $6d5b744f499a0384$var$baseStyle,
    variants: $6d5b744f499a0384$var$variants,
    defaultProps: $6d5b744f499a0384$var$defaultProps
};




function $bc8e4abca8b352a4$var$_extends() {
    $bc8e4abca8b352a4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc8e4abca8b352a4$var$_extends.apply(this, arguments);
}
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */ function $bc8e4abca8b352a4$var$getSize(value) {
    if (value === "full") return {
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    };
    return {
        dialog: {
            maxW: value
        }
    };
}
var $bc8e4abca8b352a4$var$baseStyleOverlay = {
    bg: "blackAlpha.600",
    zIndex: "overlay"
};
var $bc8e4abca8b352a4$var$baseStyleDialogContainer = {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
};
var $bc8e4abca8b352a4$var$baseStyleDialog = (props)=>{
    var { isFullHeight: isFullHeight } = props;
    return $bc8e4abca8b352a4$var$_extends({}, isFullHeight && {
        height: "100vh"
    }, {
        zIndex: "modal",
        maxH: "100vh",
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props),
        color: "inherit",
        boxShadow: (0, $f466d5c40b760069$export$549ff81930776885)("lg", "dark-lg")(props)
    });
};
var $bc8e4abca8b352a4$var$baseStyleHeader = {
    px: 6,
    py: 4,
    fontSize: "xl",
    fontWeight: "semibold"
};
var $bc8e4abca8b352a4$var$baseStyleCloseButton = {
    position: "absolute",
    top: 2,
    insetEnd: 3
};
var $bc8e4abca8b352a4$var$baseStyleBody = {
    px: 6,
    py: 2,
    flex: 1,
    overflow: "auto"
};
var $bc8e4abca8b352a4$var$baseStyleFooter = {
    px: 6,
    py: 4
};
var $bc8e4abca8b352a4$var$baseStyle = (props)=>({
        overlay: $bc8e4abca8b352a4$var$baseStyleOverlay,
        dialogContainer: $bc8e4abca8b352a4$var$baseStyleDialogContainer,
        dialog: $bc8e4abca8b352a4$var$baseStyleDialog(props),
        header: $bc8e4abca8b352a4$var$baseStyleHeader,
        closeButton: $bc8e4abca8b352a4$var$baseStyleCloseButton,
        body: $bc8e4abca8b352a4$var$baseStyleBody,
        footer: $bc8e4abca8b352a4$var$baseStyleFooter
    });
var $bc8e4abca8b352a4$var$sizes = {
    xs: $bc8e4abca8b352a4$var$getSize("xs"),
    sm: $bc8e4abca8b352a4$var$getSize("md"),
    md: $bc8e4abca8b352a4$var$getSize("lg"),
    lg: $bc8e4abca8b352a4$var$getSize("2xl"),
    xl: $bc8e4abca8b352a4$var$getSize("4xl"),
    full: $bc8e4abca8b352a4$var$getSize("full")
};
var $bc8e4abca8b352a4$var$defaultProps = {
    size: "xs"
};
var $bc8e4abca8b352a4$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$d3f4aaa4b0f2907a).keys,
    baseStyle: $bc8e4abca8b352a4$var$baseStyle,
    sizes: $bc8e4abca8b352a4$var$sizes,
    defaultProps: $bc8e4abca8b352a4$var$defaultProps
};



var $94af17abb5b6ae5b$var$baseStylePreview = {
    borderRadius: "md",
    py: "3px",
    transitionProperty: "common",
    transitionDuration: "normal"
};
var $94af17abb5b6ae5b$var$baseStyleInput = {
    borderRadius: "md",
    py: "3px",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focus: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
};
var $94af17abb5b6ae5b$var$baseStyle = {
    preview: $94af17abb5b6ae5b$var$baseStylePreview,
    input: $94af17abb5b6ae5b$var$baseStyleInput
};
var $94af17abb5b6ae5b$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$2813c9511eeab082).keys,
    baseStyle: $94af17abb5b6ae5b$var$baseStyle
};




var $dffad7540d9e2a9a$var$baseStyleRequiredIndicator = (props)=>{
    return {
        marginStart: 1,
        color: (0, $f466d5c40b760069$export$549ff81930776885)("red.500", "red.300")(props)
    };
};
var $dffad7540d9e2a9a$var$baseStyleHelperText = (props)=>{
    return {
        mt: 2,
        color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.500", "whiteAlpha.600")(props),
        lineHeight: "normal",
        fontSize: "sm"
    };
};
var $dffad7540d9e2a9a$var$baseStyle = (props)=>({
        container: {
            width: "100%",
            position: "relative"
        },
        requiredIndicator: $dffad7540d9e2a9a$var$baseStyleRequiredIndicator(props),
        helperText: $dffad7540d9e2a9a$var$baseStyleHelperText(props)
    });
var $dffad7540d9e2a9a$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$4b243e3f209a7e5e).keys,
    baseStyle: $dffad7540d9e2a9a$var$baseStyle
};


var $8a9f955d98fa6132$var$baseStyle = {
    fontSize: "md",
    marginEnd: 3,
    mb: 2,
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
};
var $8a9f955d98fa6132$export$2e2bcd8739ae039 = {
    baseStyle: $8a9f955d98fa6132$var$baseStyle
};


var $70c64c4cec295be4$var$baseStyle = {
    fontFamily: "heading",
    fontWeight: "bold"
};
var $70c64c4cec295be4$var$sizes = {
    "4xl": {
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    },
    "3xl": {
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    },
    "2xl": {
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    },
    xl: {
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    },
    lg: {
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    },
    md: {
        fontSize: "xl",
        lineHeight: 1.2
    },
    sm: {
        fontSize: "md",
        lineHeight: 1.2
    },
    xs: {
        fontSize: "sm",
        lineHeight: 1.2
    }
};
var $70c64c4cec295be4$var$defaultProps = {
    size: "xl"
};
var $70c64c4cec295be4$export$2e2bcd8739ae039 = {
    baseStyle: $70c64c4cec295be4$var$baseStyle,
    sizes: $70c64c4cec295be4$var$sizes,
    defaultProps: $70c64c4cec295be4$var$defaultProps
};




var $1e7aa81b44bb39f6$var$baseStyle = {
    field: {
        width: "100%",
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal"
    }
};
var $1e7aa81b44bb39f6$var$size = {
    lg: {
        fontSize: "lg",
        px: 4,
        h: 12,
        borderRadius: "md"
    },
    md: {
        fontSize: "md",
        px: 4,
        h: 10,
        borderRadius: "md"
    },
    sm: {
        fontSize: "sm",
        px: 3,
        h: 8,
        borderRadius: "sm"
    },
    xs: {
        fontSize: "xs",
        px: 2,
        h: 6,
        borderRadius: "sm"
    }
};
var $1e7aa81b44bb39f6$var$sizes = {
    lg: {
        field: $1e7aa81b44bb39f6$var$size.lg,
        addon: $1e7aa81b44bb39f6$var$size.lg
    },
    md: {
        field: $1e7aa81b44bb39f6$var$size.md,
        addon: $1e7aa81b44bb39f6$var$size.md
    },
    sm: {
        field: $1e7aa81b44bb39f6$var$size.sm,
        addon: $1e7aa81b44bb39f6$var$size.sm
    },
    xs: {
        field: $1e7aa81b44bb39f6$var$size.xs,
        addon: $1e7aa81b44bb39f6$var$size.xs
    }
};
function $1e7aa81b44bb39f6$var$getDefaults(props) {
    var { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $f466d5c40b760069$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $f466d5c40b760069$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
var $1e7aa81b44bb39f6$var$variantOutline = (props)=>{
    var { theme: theme } = props;
    var { focusBorderColor: fc, errorBorderColor: ec } = $1e7aa81b44bb39f6$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _disabled: {
                opacity: 0.4,
                cursor: "not-allowed"
            },
            _invalid: {
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec),
                boxShadow: "0 0 0 1px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec)
            },
            _focus: {
                zIndex: 1,
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc),
                boxShadow: "0 0 0 1px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
};
var $1e7aa81b44bb39f6$var$variantFilled = (props)=>{
    var { theme: theme } = props;
    var { focusBorderColor: fc, errorBorderColor: ec } = $1e7aa81b44bb39f6$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _disabled: {
                opacity: 0.4,
                cursor: "not-allowed"
            },
            _invalid: {
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec)
            },
            _focus: {
                bg: "transparent",
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
};
var $1e7aa81b44bb39f6$var$variantFlushed = (props)=>{
    var { theme: theme } = props;
    var { focusBorderColor: fc, errorBorderColor: ec } = $1e7aa81b44bb39f6$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: 0,
            px: 0,
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec),
                boxShadow: "0px 1px 0px 0px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec)
            },
            _focus: {
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc),
                boxShadow: "0px 1px 0px 0px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: 0,
            px: 0,
            bg: "transparent"
        }
    };
};
var $1e7aa81b44bb39f6$var$variantUnstyled = {
    field: {
        bg: "transparent",
        px: 0,
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: 0,
        height: "auto"
    }
};
var $1e7aa81b44bb39f6$var$variants = {
    outline: $1e7aa81b44bb39f6$var$variantOutline,
    filled: $1e7aa81b44bb39f6$var$variantFilled,
    flushed: $1e7aa81b44bb39f6$var$variantFlushed,
    unstyled: $1e7aa81b44bb39f6$var$variantUnstyled
};
var $1e7aa81b44bb39f6$var$defaultProps = {
    size: "md",
    variant: "outline"
};
var $1e7aa81b44bb39f6$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$1ffeb100b532f46d).keys,
    baseStyle: $1e7aa81b44bb39f6$var$baseStyle,
    sizes: $1e7aa81b44bb39f6$var$sizes,
    variants: $1e7aa81b44bb39f6$var$variants,
    defaultProps: $1e7aa81b44bb39f6$var$defaultProps
};



var $3af1a8ec765ae7ad$var$baseStyle = (props)=>{
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha")(props),
        borderRadius: "md",
        borderWidth: "1px",
        borderBottomWidth: "3px",
        fontSize: "0.8em",
        fontWeight: "bold",
        lineHeight: "normal",
        px: "0.4em",
        whiteSpace: "nowrap"
    };
};
var $3af1a8ec765ae7ad$export$2e2bcd8739ae039 = {
    baseStyle: $3af1a8ec765ae7ad$var$baseStyle
};


var $5d5053c2e0f47ad1$var$baseStyle = {
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focus: {
        boxShadow: "outline"
    }
};
var $5d5053c2e0f47ad1$export$2e2bcd8739ae039 = {
    baseStyle: $5d5053c2e0f47ad1$var$baseStyle
};



var $675b3a7786049125$var$baseStyleIcon = {
    marginEnd: "0.5rem",
    display: "inline",
    verticalAlign: "text-bottom"
};
var $675b3a7786049125$var$baseStyle = {
    container: {},
    item: {},
    icon: $675b3a7786049125$var$baseStyleIcon
};
var $675b3a7786049125$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$12b3a655a94374ed).keys,
    baseStyle: $675b3a7786049125$var$baseStyle
};




var $9747f4fa4630d4b5$var$baseStyleList = (props)=>{
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("#fff", "gray.700")(props),
        boxShadow: (0, $f466d5c40b760069$export$549ff81930776885)("sm", "dark-lg")(props),
        color: "inherit",
        minW: "3xs",
        py: "2",
        zIndex: 1,
        borderRadius: "md",
        borderWidth: "1px"
    };
};
var $9747f4fa4630d4b5$var$baseStyleItem = (props)=>{
    return {
        py: "0.4rem",
        px: "0.8rem",
        transitionProperty: "background",
        transitionDuration: "ultra-fast",
        transitionTimingFunction: "ease-in",
        _focus: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props)
        },
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.200")(props)
        },
        _expanded: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props)
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    };
};
var $9747f4fa4630d4b5$var$baseStyleGroupTitle = {
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
};
var $9747f4fa4630d4b5$var$baseStyleCommand = {
    opacity: 0.6
};
var $9747f4fa4630d4b5$var$baseStyleDivider = {
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "0.5rem",
    opacity: 0.6
};
var $9747f4fa4630d4b5$var$baseStyleButton = {
    transitionProperty: "common",
    transitionDuration: "normal"
};
var $9747f4fa4630d4b5$var$baseStyle = (props)=>({
        button: $9747f4fa4630d4b5$var$baseStyleButton,
        list: $9747f4fa4630d4b5$var$baseStyleList(props),
        item: $9747f4fa4630d4b5$var$baseStyleItem(props),
        groupTitle: $9747f4fa4630d4b5$var$baseStyleGroupTitle,
        command: $9747f4fa4630d4b5$var$baseStyleCommand,
        divider: $9747f4fa4630d4b5$var$baseStyleDivider
    });
var $9747f4fa4630d4b5$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$e251092a5dcb1329).keys,
    baseStyle: $9747f4fa4630d4b5$var$baseStyle
};




var $aaac7f8f9035cda0$var$baseStyleOverlay = {
    bg: "blackAlpha.600",
    zIndex: "modal"
};
var $aaac7f8f9035cda0$var$baseStyleDialogContainer = (props)=>{
    var { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto"
    };
};
var $aaac7f8f9035cda0$var$baseStyleDialog = (props)=>{
    var { scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props),
        color: "inherit",
        my: "3.75rem",
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : undefined,
        boxShadow: (0, $f466d5c40b760069$export$549ff81930776885)("lg", "dark-lg")(props)
    };
};
var $aaac7f8f9035cda0$var$baseStyleHeader = {
    px: 6,
    py: 4,
    fontSize: "xl",
    fontWeight: "semibold"
};
var $aaac7f8f9035cda0$var$baseStyleCloseButton = {
    position: "absolute",
    top: 2,
    insetEnd: 3
};
var $aaac7f8f9035cda0$var$baseStyleBody = (props)=>{
    var { scrollBehavior: scrollBehavior } = props;
    return {
        px: 6,
        py: 2,
        flex: 1,
        overflow: scrollBehavior === "inside" ? "auto" : undefined
    };
};
var $aaac7f8f9035cda0$var$baseStyleFooter = {
    px: 6,
    py: 4
};
var $aaac7f8f9035cda0$var$baseStyle = (props)=>({
        overlay: $aaac7f8f9035cda0$var$baseStyleOverlay,
        dialogContainer: $aaac7f8f9035cda0$var$baseStyleDialogContainer(props),
        dialog: $aaac7f8f9035cda0$var$baseStyleDialog(props),
        header: $aaac7f8f9035cda0$var$baseStyleHeader,
        closeButton: $aaac7f8f9035cda0$var$baseStyleCloseButton,
        body: $aaac7f8f9035cda0$var$baseStyleBody(props),
        footer: $aaac7f8f9035cda0$var$baseStyleFooter
    });
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */ function $aaac7f8f9035cda0$var$getSize(value) {
    if (value === "full") return {
        dialog: {
            maxW: "100vw",
            minH: "100vh",
            my: 0
        }
    };
    return {
        dialog: {
            maxW: value
        }
    };
}
var $aaac7f8f9035cda0$var$sizes = {
    xs: $aaac7f8f9035cda0$var$getSize("xs"),
    sm: $aaac7f8f9035cda0$var$getSize("sm"),
    md: $aaac7f8f9035cda0$var$getSize("md"),
    lg: $aaac7f8f9035cda0$var$getSize("lg"),
    xl: $aaac7f8f9035cda0$var$getSize("xl"),
    "2xl": $aaac7f8f9035cda0$var$getSize("2xl"),
    "3xl": $aaac7f8f9035cda0$var$getSize("3xl"),
    "4xl": $aaac7f8f9035cda0$var$getSize("4xl"),
    "5xl": $aaac7f8f9035cda0$var$getSize("5xl"),
    "6xl": $aaac7f8f9035cda0$var$getSize("6xl"),
    full: $aaac7f8f9035cda0$var$getSize("full")
};
var $aaac7f8f9035cda0$var$defaultProps = {
    size: "md"
};
var $aaac7f8f9035cda0$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$34e33beb8d992ac2).keys,
    baseStyle: $aaac7f8f9035cda0$var$baseStyle,
    sizes: $aaac7f8f9035cda0$var$sizes,
    defaultProps: $aaac7f8f9035cda0$var$defaultProps
};




function $f28e59423f8bb230$var$toRef(operand) {
    if ((0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $f28e59423f8bb230$var$toExpr = function toExpr(operator) {
    for(var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)operands[_key - 1] = arguments[_key];
    return operands.map($f28e59423f8bb230$var$toRef).join(" " + operator + " ").replace(/calc/g, "");
};
var $f28e59423f8bb230$var$_add = function add() {
    for(var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)operands[_key2] = arguments[_key2];
    return "calc(" + $f28e59423f8bb230$var$toExpr("+", ...operands) + ")";
};
var $f28e59423f8bb230$var$_subtract = function subtract() {
    for(var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)operands[_key3] = arguments[_key3];
    return "calc(" + $f28e59423f8bb230$var$toExpr("-", ...operands) + ")";
};
var $f28e59423f8bb230$var$_multiply = function multiply() {
    for(var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)operands[_key4] = arguments[_key4];
    return "calc(" + $f28e59423f8bb230$var$toExpr("*", ...operands) + ")";
};
var $f28e59423f8bb230$var$_divide = function divide() {
    for(var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)operands[_key5] = arguments[_key5];
    return "calc(" + $f28e59423f8bb230$var$toExpr("/", ...operands) + ")";
};
var $f28e59423f8bb230$var$_negate = (x)=>{
    var value = $f28e59423f8bb230$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
    return $f28e59423f8bb230$var$_multiply(value, -1);
};
var $f28e59423f8bb230$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: function add() {
            for(var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)operands[_key6] = arguments[_key6];
            return $f28e59423f8bb230$export$42bfa9b2d4dad91a($f28e59423f8bb230$var$_add(x, ...operands));
        },
        subtract: function subtract() {
            for(var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)operands[_key7] = arguments[_key7];
            return $f28e59423f8bb230$export$42bfa9b2d4dad91a($f28e59423f8bb230$var$_subtract(x, ...operands));
        },
        multiply: function multiply() {
            for(var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)operands[_key8] = arguments[_key8];
            return $f28e59423f8bb230$export$42bfa9b2d4dad91a($f28e59423f8bb230$var$_multiply(x, ...operands));
        },
        divide: function divide() {
            for(var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)operands[_key9] = arguments[_key9];
            return $f28e59423f8bb230$export$42bfa9b2d4dad91a($f28e59423f8bb230$var$_divide(x, ...operands));
        },
        negate: ()=>$f28e59423f8bb230$export$42bfa9b2d4dad91a($f28e59423f8bb230$var$_negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $f28e59423f8bb230$var$_add,
    subtract: $f28e59423f8bb230$var$_subtract,
    multiply: $f28e59423f8bb230$var$_multiply,
    divide: $f28e59423f8bb230$var$_divide,
    negate: $f28e59423f8bb230$var$_negate
});


var $e95877dd22e3ca6f$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
        body: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
        mono: "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace"
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var /**
 * @deprecated
 * You can derive the Typography type from the DefaultChakraTheme
 *
 * type Typography = Pick<
 *   DefaultChakraTheme,
 *   | "letterSpacings"
 *   | "lineHeights"
 *   | "fontWeights"
 *   | "fonts"
 *   | "fontSizes"
 *  >
 */ $e95877dd22e3ca6f$export$2e2bcd8739ae039 = $e95877dd22e3ca6f$var$typography;



var $edcf76acb98a64ce$var$_Input$baseStyle$fiel, $edcf76acb98a64ce$var$_Input$baseStyle;
function $edcf76acb98a64ce$var$_extends() {
    $edcf76acb98a64ce$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $edcf76acb98a64ce$var$_extends.apply(this, arguments);
}
var { variants: $edcf76acb98a64ce$var$variants, defaultProps: $edcf76acb98a64ce$var$defaultProps } = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039);
var $edcf76acb98a64ce$var$$stepperWidth = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("number-input-stepper-width");
var $edcf76acb98a64ce$var$$inputPadding = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("number-input-input-padding");
var $edcf76acb98a64ce$var$inputPaddingValue = (0, $f28e59423f8bb230$export$42bfa9b2d4dad91a)($edcf76acb98a64ce$var$$stepperWidth).add("0.5rem").toString();
var $edcf76acb98a64ce$var$baseStyleRoot = {
    [$edcf76acb98a64ce$var$$stepperWidth.variable]: "24px",
    [$edcf76acb98a64ce$var$$inputPadding.variable]: $edcf76acb98a64ce$var$inputPaddingValue
};
var $edcf76acb98a64ce$var$baseStyleField = ($edcf76acb98a64ce$var$_Input$baseStyle$fiel = ($edcf76acb98a64ce$var$_Input$baseStyle = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).baseStyle) == null ? void 0 : $edcf76acb98a64ce$var$_Input$baseStyle.field) != null ? $edcf76acb98a64ce$var$_Input$baseStyle$fiel : {};
var $edcf76acb98a64ce$var$baseStyleStepperGroup = {
    width: [
        $edcf76acb98a64ce$var$$stepperWidth.reference
    ]
};
var $edcf76acb98a64ce$var$baseStyleStepper = (props)=>{
    return {
        borderStart: "1px solid",
        borderStartColor: (0, $f466d5c40b760069$export$549ff81930776885)("inherit", "whiteAlpha.300")(props),
        color: (0, $f466d5c40b760069$export$549ff81930776885)("inherit", "whiteAlpha.800")(props),
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props)
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    };
};
var $edcf76acb98a64ce$var$baseStyle = (props)=>({
        root: $edcf76acb98a64ce$var$baseStyleRoot,
        field: $edcf76acb98a64ce$var$baseStyleField,
        stepperGroup: $edcf76acb98a64ce$var$baseStyleStepperGroup,
        stepper: $edcf76acb98a64ce$var$baseStyleStepper(props)
    });
function $edcf76acb98a64ce$var$getSize(size) {
    var _sizeStyle$field$font, _sizeStyle$field;
    var sizeStyle = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes[size];
    var radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    var _fontSize = (_sizeStyle$field$font = (_sizeStyle$field = sizeStyle.field) == null ? void 0 : _sizeStyle$field.fontSize) != null ? _sizeStyle$field$font : "md";
    var fontSize = (0, $e95877dd22e3ca6f$export$2e2bcd8739ae039).fontSizes[_fontSize.toString()];
    return {
        field: $edcf76acb98a64ce$var$_extends({}, sizeStyle.field, {
            paddingInlineEnd: $edcf76acb98a64ce$var$$inputPadding.reference,
            verticalAlign: "top"
        }),
        stepper: {
            fontSize: (0, $f28e59423f8bb230$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    };
}
var $edcf76acb98a64ce$var$sizes = {
    xs: $edcf76acb98a64ce$var$getSize("xs"),
    sm: $edcf76acb98a64ce$var$getSize("sm"),
    md: $edcf76acb98a64ce$var$getSize("md"),
    lg: $edcf76acb98a64ce$var$getSize("lg")
};
var $edcf76acb98a64ce$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$859cc7ca3200df97).keys,
    baseStyle: $edcf76acb98a64ce$var$baseStyle,
    sizes: $edcf76acb98a64ce$var$sizes,
    variants: $edcf76acb98a64ce$var$variants,
    defaultProps: $edcf76acb98a64ce$var$defaultProps
};



var $026055e40aeb3962$var$_Input$variants$unsty;
function $026055e40aeb3962$var$_extends() {
    $026055e40aeb3962$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $026055e40aeb3962$var$_extends.apply(this, arguments);
}
var $026055e40aeb3962$var$baseStyle = $026055e40aeb3962$var$_extends({}, (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).baseStyle.field, {
    textAlign: "center"
});
var $026055e40aeb3962$var$sizes = {
    lg: {
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    },
    md: {
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    },
    sm: {
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    },
    xs: {
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    }
};
var $026055e40aeb3962$var$variants = {
    outline: (props)=>{
        var _Input$variants$outli;
        return (_Input$variants$outli = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.outline(props).field) != null ? _Input$variants$outli : {};
    },
    flushed: (props)=>{
        var _Input$variants$flush;
        return (_Input$variants$flush = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.flushed(props).field) != null ? _Input$variants$flush : {};
    },
    filled: (props)=>{
        var _Input$variants$fille;
        return (_Input$variants$fille = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.filled(props).field) != null ? _Input$variants$fille : {};
    },
    unstyled: ($026055e40aeb3962$var$_Input$variants$unsty = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.unstyled.field) != null ? $026055e40aeb3962$var$_Input$variants$unsty : {}
};
var $026055e40aeb3962$var$defaultProps = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).defaultProps;
var $026055e40aeb3962$export$2e2bcd8739ae039 = {
    baseStyle: $026055e40aeb3962$var$baseStyle,
    sizes: $026055e40aeb3962$var$sizes,
    variants: $026055e40aeb3962$var$variants,
    defaultProps: $026055e40aeb3962$var$defaultProps
};




var $286fdf29dd6ab241$var$$popperBg = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("popper-bg");
var $286fdf29dd6ab241$var$$arrowBg = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("popper-arrow-bg");
var $286fdf29dd6ab241$var$$arrowShadowColor = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
var $286fdf29dd6ab241$var$baseStylePopper = {
    zIndex: 10
};
var $286fdf29dd6ab241$var$baseStyleContent = (props)=>{
    var bg = (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props);
    var shadowColor = (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props);
    return {
        [$286fdf29dd6ab241$var$$popperBg.variable]: "colors." + bg,
        bg: $286fdf29dd6ab241$var$$popperBg.reference,
        [$286fdf29dd6ab241$var$$arrowBg.variable]: $286fdf29dd6ab241$var$$popperBg.reference,
        [$286fdf29dd6ab241$var$$arrowShadowColor.variable]: "colors." + shadowColor,
        width: "xs",
        border: "1px solid",
        borderColor: "inherit",
        borderRadius: "md",
        boxShadow: "sm",
        zIndex: "inherit",
        _focus: {
            outline: 0,
            boxShadow: "outline"
        }
    };
};
var $286fdf29dd6ab241$var$baseStyleHeader = {
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
};
var $286fdf29dd6ab241$var$baseStyleBody = {
    px: 3,
    py: 2
};
var $286fdf29dd6ab241$var$baseStyleFooter = {
    px: 3,
    py: 2,
    borderTopWidth: "1px"
};
var $286fdf29dd6ab241$var$baseStyle = (props)=>({
        popper: $286fdf29dd6ab241$var$baseStylePopper,
        content: $286fdf29dd6ab241$var$baseStyleContent(props),
        header: $286fdf29dd6ab241$var$baseStyleHeader,
        body: $286fdf29dd6ab241$var$baseStyleBody,
        footer: $286fdf29dd6ab241$var$baseStyleFooter,
        arrow: {}
    });
var $286fdf29dd6ab241$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$afda07d12cd4337d).keys,
    baseStyle: $286fdf29dd6ab241$var$baseStyle
};




function $76e1f1f04f0d8528$var$_extends() {
    $76e1f1f04f0d8528$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76e1f1f04f0d8528$var$_extends.apply(this, arguments);
}
function $76e1f1f04f0d8528$var$filledStyle(props) {
    var { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    var stripeStyle = (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$db0ffb03ee9f3080)(), (0, $188d0d70c4460bfd$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    var bgColor = (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props);
    var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(t, bgColor) + " 50%,\n    transparent 100%\n  )";
    var addStripe = !isIndeterminate && hasStripe;
    return $76e1f1f04f0d8528$var$_extends({}, addStripe && stripeStyle, isIndeterminate ? {
        bgImage: gradient
    } : {
        bgColor: bgColor
    });
}
var $76e1f1f04f0d8528$var$baseStyleLabel = {
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
};
var $76e1f1f04f0d8528$var$baseStyleTrack = (props)=>{
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
};
var $76e1f1f04f0d8528$var$baseStyleFilledTrack = (props)=>{
    return $76e1f1f04f0d8528$var$_extends({
        transitionProperty: "common",
        transitionDuration: "slow"
    }, $76e1f1f04f0d8528$var$filledStyle(props));
};
var $76e1f1f04f0d8528$var$baseStyle = (props)=>({
        label: $76e1f1f04f0d8528$var$baseStyleLabel,
        filledTrack: $76e1f1f04f0d8528$var$baseStyleFilledTrack(props),
        track: $76e1f1f04f0d8528$var$baseStyleTrack(props)
    });
var $76e1f1f04f0d8528$var$sizes = {
    xs: {
        track: {
            h: "0.25rem"
        }
    },
    sm: {
        track: {
            h: "0.5rem"
        }
    },
    md: {
        track: {
            h: "0.75rem"
        }
    },
    lg: {
        track: {
            h: "1rem"
        }
    }
};
var $76e1f1f04f0d8528$var$defaultProps = {
    size: "md",
    colorScheme: "blue"
};
var $76e1f1f04f0d8528$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$ba6328c242bd649c).keys,
    sizes: $76e1f1f04f0d8528$var$sizes,
    baseStyle: $76e1f1f04f0d8528$var$baseStyle,
    defaultProps: $76e1f1f04f0d8528$var$defaultProps
};




function $3e6f19121bee3bfa$var$_extends() {
    $3e6f19121bee3bfa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e6f19121bee3bfa$var$_extends.apply(this, arguments);
}
var $3e6f19121bee3bfa$var$baseStyleControl = (props)=>{
    var { control: control = {} } = (0, $d4f577d072848e75$export$2e2bcd8739ae039).baseStyle(props);
    return $3e6f19121bee3bfa$var$_extends({}, control, {
        borderRadius: "full",
        _checked: $3e6f19121bee3bfa$var$_extends({}, control["_checked"], {
            _before: {
                content: "\"\"",
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        })
    });
};
var $3e6f19121bee3bfa$var$baseStyle = (props)=>({
        label: (0, $d4f577d072848e75$export$2e2bcd8739ae039).baseStyle(props).label,
        control: $3e6f19121bee3bfa$var$baseStyleControl(props)
    });
var $3e6f19121bee3bfa$var$sizes = {
    md: {
        control: {
            w: 4,
            h: 4
        },
        label: {
            fontSize: "md"
        }
    },
    lg: {
        control: {
            w: 5,
            h: 5
        },
        label: {
            fontSize: "lg"
        }
    },
    sm: {
        control: {
            width: 3,
            height: 3
        },
        label: {
            fontSize: "sm"
        }
    }
};
var $3e6f19121bee3bfa$var$defaultProps = {
    size: "md",
    colorScheme: "blue"
};
var $3e6f19121bee3bfa$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$d28d06d0e29ef022).keys,
    baseStyle: $3e6f19121bee3bfa$var$baseStyle,
    sizes: $3e6f19121bee3bfa$var$sizes,
    defaultProps: $3e6f19121bee3bfa$var$defaultProps
};





function $83814f9f8b79506f$var$_extends() {
    $83814f9f8b79506f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83814f9f8b79506f$var$_extends.apply(this, arguments);
}
var $83814f9f8b79506f$var$baseStyleField = (props)=>{
    return $83814f9f8b79506f$var$_extends({}, (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).baseStyle.field, {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props),
        appearance: "none",
        paddingBottom: "1px",
        lineHeight: "normal",
        "> option, > optgroup": {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props)
        }
    });
};
var $83814f9f8b79506f$var$baseStyleIcon = {
    width: "1.5rem",
    height: "100%",
    insetEnd: "0.5rem",
    position: "relative",
    color: "currentColor",
    fontSize: "1.25rem",
    _disabled: {
        opacity: 0.5
    }
};
var $83814f9f8b79506f$var$baseStyle = (props)=>({
        field: $83814f9f8b79506f$var$baseStyleField(props),
        icon: $83814f9f8b79506f$var$baseStyleIcon
    });
var $83814f9f8b79506f$var$sizes = $83814f9f8b79506f$var$_extends({}, (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes, {
    xs: $83814f9f8b79506f$var$_extends({}, (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes.xs, {
        icon: {
            insetEnd: "0.25rem"
        }
    })
});
var $83814f9f8b79506f$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$17993f0be9538b5a).keys,
    baseStyle: $83814f9f8b79506f$var$baseStyle,
    sizes: $83814f9f8b79506f$var$sizes,
    variants: (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants,
    defaultProps: (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).defaultProps
};




var $0e96450d5a4650c1$var$fade = (startColor, endColor)=>(0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
        from: {
            borderColor: startColor,
            background: startColor
        },
        to: {
            borderColor: endColor,
            background: endColor
        }
    });
var $0e96450d5a4650c1$var$baseStyle = (props)=>{
    var defaultStartColor = (0, $f466d5c40b760069$export$549ff81930776885)("gray.100", "gray.800")(props);
    var defaultEndColor = (0, $f466d5c40b760069$export$549ff81930776885)("gray.400", "gray.600")(props);
    var { startColor: startColor = defaultStartColor, endColor: endColor = defaultEndColor, speed: speed, theme: theme } = props;
    var start = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, startColor);
    var end = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, endColor);
    return {
        opacity: 0.7,
        borderRadius: "2px",
        borderColor: start,
        background: end,
        animation: speed + "s linear infinite alternate " + $0e96450d5a4650c1$var$fade(start, end)
    };
};
var $0e96450d5a4650c1$export$2e2bcd8739ae039 = {
    baseStyle: $0e96450d5a4650c1$var$baseStyle
};



var $f1c13d8bc37886c5$var$baseStyle = (props)=>({
        borderRadius: "md",
        fontWeight: "semibold",
        _focus: {
            boxShadow: "outline",
            padding: "1rem",
            position: "fixed",
            top: "1.5rem",
            insetStart: "1.5rem",
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.700")(props)
        }
    });
var $f1c13d8bc37886c5$export$2e2bcd8739ae039 = {
    baseStyle: $f1c13d8bc37886c5$var$baseStyle
};




function $97a1a954f9d45008$var$_extends() {
    $97a1a954f9d45008$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97a1a954f9d45008$var$_extends.apply(this, arguments);
}
function $97a1a954f9d45008$var$thumbOrientation(props) {
    return (0, $f466d5c40b760069$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        vertical: {
            left: "50%",
            transform: "translateX(-50%)",
            _active: {
                transform: "translateX(-50%) scale(1.15)"
            }
        },
        horizontal: {
            top: "50%",
            transform: "translateY(-50%)",
            _active: {
                transform: "translateY(-50%) scale(1.15)"
            }
        }
    });
}
var $97a1a954f9d45008$var$baseStyleContainer = (props)=>{
    var { orientation: orientation } = props;
    return $97a1a954f9d45008$var$_extends({
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        }
    }, (0, $f466d5c40b760069$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            h: "100%"
        },
        horizontal: {
            w: "100%"
        }
    }));
};
var $97a1a954f9d45008$var$baseStyleTrack = (props)=>{
    return {
        borderRadius: "sm",
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.200")(props),
        _disabled: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.300", "whiteAlpha.300")(props)
        }
    };
};
var $97a1a954f9d45008$var$baseStyleThumb = (props)=>{
    return $97a1a954f9d45008$var$_extends({
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focus: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    }, $97a1a954f9d45008$var$thumbOrientation(props));
};
var $97a1a954f9d45008$var$baseStyleFilledTrack = (props)=>{
    var { colorScheme: c } = props;
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
    };
};
var $97a1a954f9d45008$var$baseStyle = (props)=>({
        container: $97a1a954f9d45008$var$baseStyleContainer(props),
        track: $97a1a954f9d45008$var$baseStyleTrack(props),
        thumb: $97a1a954f9d45008$var$baseStyleThumb(props),
        filledTrack: $97a1a954f9d45008$var$baseStyleFilledTrack(props)
    });
var $97a1a954f9d45008$var$sizeLg = (props)=>{
    return {
        thumb: {
            w: "16px",
            h: "16px"
        },
        track: (0, $f466d5c40b760069$export$f3eec17ee6065eee)({
            orientation: props.orientation,
            horizontal: {
                h: "4px"
            },
            vertical: {
                w: "4px"
            }
        })
    };
};
var $97a1a954f9d45008$var$sizeMd = (props)=>{
    return {
        thumb: {
            w: "14px",
            h: "14px"
        },
        track: (0, $f466d5c40b760069$export$f3eec17ee6065eee)({
            orientation: props.orientation,
            horizontal: {
                h: "4px"
            },
            vertical: {
                w: "4px"
            }
        })
    };
};
var $97a1a954f9d45008$var$sizeSm = (props)=>{
    return {
        thumb: {
            w: "10px",
            h: "10px"
        },
        track: (0, $f466d5c40b760069$export$f3eec17ee6065eee)({
            orientation: props.orientation,
            horizontal: {
                h: "2px"
            },
            vertical: {
                w: "2px"
            }
        })
    };
};
var $97a1a954f9d45008$var$sizes = {
    lg: $97a1a954f9d45008$var$sizeLg,
    md: $97a1a954f9d45008$var$sizeMd,
    sm: $97a1a954f9d45008$var$sizeSm
};
var $97a1a954f9d45008$var$defaultProps = {
    size: "md",
    colorScheme: "blue"
};
var $97a1a954f9d45008$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$c21b4b3f8b239f32).keys,
    sizes: $97a1a954f9d45008$var$sizes,
    baseStyle: $97a1a954f9d45008$var$baseStyle,
    defaultProps: $97a1a954f9d45008$var$defaultProps
};



var $a66a7684c97f93be$var$$size = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("spinner-size");
var $a66a7684c97f93be$var$baseStyle = {
    width: [
        $a66a7684c97f93be$var$$size.reference
    ],
    height: [
        $a66a7684c97f93be$var$$size.reference
    ]
};
var $a66a7684c97f93be$var$sizes = {
    xs: {
        [$a66a7684c97f93be$var$$size.variable]: "0.75rem"
    },
    sm: {
        [$a66a7684c97f93be$var$$size.variable]: "1rem"
    },
    md: {
        [$a66a7684c97f93be$var$$size.variable]: "1.5rem"
    },
    lg: {
        [$a66a7684c97f93be$var$$size.variable]: "2rem"
    },
    xl: {
        [$a66a7684c97f93be$var$$size.variable]: "3rem"
    }
};
var $a66a7684c97f93be$var$defaultProps = {
    size: "md"
};
var $a66a7684c97f93be$export$2e2bcd8739ae039 = {
    baseStyle: $a66a7684c97f93be$var$baseStyle,
    sizes: $a66a7684c97f93be$var$sizes,
    defaultProps: $a66a7684c97f93be$var$defaultProps
};



var $4bc5ace94ebdbb6f$var$baseStyleLabel = {
    fontWeight: "medium"
};
var $4bc5ace94ebdbb6f$var$baseStyleHelpText = {
    opacity: 0.8,
    marginBottom: 2
};
var $4bc5ace94ebdbb6f$var$baseStyleNumber = {
    verticalAlign: "baseline",
    fontWeight: "semibold"
};
var $4bc5ace94ebdbb6f$var$baseStyleIcon = {
    marginEnd: 1,
    w: "14px",
    h: "14px",
    verticalAlign: "middle"
};
var $4bc5ace94ebdbb6f$var$baseStyle = {
    container: {},
    label: $4bc5ace94ebdbb6f$var$baseStyleLabel,
    helpText: $4bc5ace94ebdbb6f$var$baseStyleHelpText,
    number: $4bc5ace94ebdbb6f$var$baseStyleNumber,
    icon: $4bc5ace94ebdbb6f$var$baseStyleIcon
};
var $4bc5ace94ebdbb6f$var$sizes = {
    md: {
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    }
};
var $4bc5ace94ebdbb6f$var$defaultProps = {
    size: "md"
};
var $4bc5ace94ebdbb6f$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$2cfbad67ae6ee421).keys,
    baseStyle: $4bc5ace94ebdbb6f$var$baseStyle,
    sizes: $4bc5ace94ebdbb6f$var$sizes,
    defaultProps: $4bc5ace94ebdbb6f$var$defaultProps
};




var $7a6abc391a681b1b$var$$width = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("switch-track-width");
var $7a6abc391a681b1b$var$$height = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("switch-track-height");
var $7a6abc391a681b1b$var$$diff = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("switch-track-diff");
var $7a6abc391a681b1b$var$diffValue = (0, $f28e59423f8bb230$export$42bfa9b2d4dad91a).subtract($7a6abc391a681b1b$var$$width, $7a6abc391a681b1b$var$$height);
var $7a6abc391a681b1b$var$$translateX = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("switch-thumb-x");
var $7a6abc391a681b1b$var$baseStyleTrack = (props)=>{
    var { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "2px",
        width: [
            $7a6abc391a681b1b$var$$width.reference
        ],
        height: [
            $7a6abc391a681b1b$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props),
        _focus: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
        }
    };
};
var $7a6abc391a681b1b$var$baseStyleThumb = {
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $7a6abc391a681b1b$var$$height.reference
    ],
    height: [
        $7a6abc391a681b1b$var$$height.reference
    ],
    _checked: {
        transform: "translateX(" + $7a6abc391a681b1b$var$$translateX.reference + ")"
    }
};
var $7a6abc391a681b1b$var$baseStyle = (props)=>({
        container: {
            [$7a6abc391a681b1b$var$$diff.variable]: $7a6abc391a681b1b$var$diffValue,
            [$7a6abc391a681b1b$var$$translateX.variable]: $7a6abc391a681b1b$var$$diff.reference,
            _rtl: {
                [$7a6abc391a681b1b$var$$translateX.variable]: (0, $f28e59423f8bb230$export$42bfa9b2d4dad91a)($7a6abc391a681b1b$var$$diff).negate().toString()
            }
        },
        track: $7a6abc391a681b1b$var$baseStyleTrack(props),
        thumb: $7a6abc391a681b1b$var$baseStyleThumb
    });
var $7a6abc391a681b1b$var$sizes = {
    sm: {
        container: {
            [$7a6abc391a681b1b$var$$width.variable]: "1.375rem",
            [$7a6abc391a681b1b$var$$height.variable]: "0.75rem"
        }
    },
    md: {
        container: {
            [$7a6abc391a681b1b$var$$width.variable]: "1.875rem",
            [$7a6abc391a681b1b$var$$height.variable]: "1rem"
        }
    },
    lg: {
        container: {
            [$7a6abc391a681b1b$var$$width.variable]: "2.875rem",
            [$7a6abc391a681b1b$var$$height.variable]: "1.5rem"
        }
    }
};
var $7a6abc391a681b1b$var$defaultProps = {
    size: "md",
    colorScheme: "blue"
};
var $7a6abc391a681b1b$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$921c1a2d1ce1e86a).keys,
    baseStyle: $7a6abc391a681b1b$var$baseStyle,
    sizes: $7a6abc391a681b1b$var$sizes,
    defaultProps: $7a6abc391a681b1b$var$defaultProps
};




function $59d695cb473a1023$var$_extends() {
    $59d695cb473a1023$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59d695cb473a1023$var$_extends.apply(this, arguments);
}
var $59d695cb473a1023$var$baseStyle = {
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
};
var $59d695cb473a1023$var$numericStyles = {
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
};
var $59d695cb473a1023$var$variantSimple = (props)=>{
    var { colorScheme: c } = props;
    return {
        th: $59d695cb473a1023$var$_extends({
            color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
        }, $59d695cb473a1023$var$numericStyles),
        td: $59d695cb473a1023$var$_extends({
            borderBottom: "1px",
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
        }, $59d695cb473a1023$var$numericStyles),
        caption: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
};
var $59d695cb473a1023$var$variantStripe = (props)=>{
    var { colorScheme: c } = props;
    return {
        th: $59d695cb473a1023$var$_extends({
            color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
        }, $59d695cb473a1023$var$numericStyles),
        td: $59d695cb473a1023$var$_extends({
            borderBottom: "1px",
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
        }, $59d695cb473a1023$var$numericStyles),
        caption: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
                    },
                    td: {
                        background: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".100", c + ".700")(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
};
var $59d695cb473a1023$var$variants = {
    simple: $59d695cb473a1023$var$variantSimple,
    striped: $59d695cb473a1023$var$variantStripe,
    unstyled: {}
};
var $59d695cb473a1023$var$sizes = {
    sm: {
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    },
    md: {
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    },
    lg: {
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    }
};
var $59d695cb473a1023$var$defaultProps = {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
};
var $59d695cb473a1023$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$8b1b9cdd5db9f5fd).keys,
    baseStyle: $59d695cb473a1023$var$baseStyle,
    variants: $59d695cb473a1023$var$variants,
    sizes: $59d695cb473a1023$var$sizes,
    defaultProps: $59d695cb473a1023$var$defaultProps
};




var $ec034e526f3660f5$var$baseStyleRoot = (props)=>{
    var { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
};
var $ec034e526f3660f5$var$baseStyleTab = (props)=>{
    var { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : undefined,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focus: {
            zIndex: 1,
            boxShadow: "outline"
        }
    };
};
var $ec034e526f3660f5$var$baseStyleTablist = (props)=>{
    var { align: align = "start", orientation: orientation } = props;
    var alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
};
var $ec034e526f3660f5$var$baseStyleTabpanel = {
    p: 4
};
var $ec034e526f3660f5$var$baseStyle = (props)=>({
        root: $ec034e526f3660f5$var$baseStyleRoot(props),
        tab: $ec034e526f3660f5$var$baseStyleTab(props),
        tablist: $ec034e526f3660f5$var$baseStyleTablist(props),
        tabpanel: $ec034e526f3660f5$var$baseStyleTabpanel
    });
var $ec034e526f3660f5$var$sizes = {
    sm: {
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    },
    md: {
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    },
    lg: {
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    }
};
var $ec034e526f3660f5$var$variantLine = (props)=>{
    var { colorScheme: c, orientation: orientation } = props;
    var isVertical = orientation === "vertical";
    var borderProp = orientation === "vertical" ? "borderStart" : "borderBottom";
    var marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props),
                borderColor: "currentColor"
            },
            _active: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props)
            },
            _disabled: {
                opacity: 0.4,
                cursor: "not-allowed"
            }
        }
    };
};
var $ec034e526f3660f5$var$variantEnclosed = (props)=>{
    var { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            _selected: {
                color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props),
                borderColor: "inherit",
                borderBottomColor: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.800")(props)
            }
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
};
var $ec034e526f3660f5$var$variantEnclosedColored = (props)=>{
    var { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("gray.50", "whiteAlpha.50")(props),
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("#fff", "gray.800")(props),
                color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props),
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            }
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
};
var $ec034e526f3660f5$var$variantSoftRounded = (props)=>{
    var { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, c + ".700"),
                bg: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, c + ".100")
            }
        }
    };
};
var $ec034e526f3660f5$var$variantSolidRounded = (props)=>{
    var { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.600", "inherit")(props),
            _selected: {
                color: (0, $f466d5c40b760069$export$549ff81930776885)("#fff", "gray.800")(props),
                bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props)
            }
        }
    };
};
var $ec034e526f3660f5$var$variantUnstyled = {};
var $ec034e526f3660f5$var$variants = {
    line: $ec034e526f3660f5$var$variantLine,
    enclosed: $ec034e526f3660f5$var$variantEnclosed,
    "enclosed-colored": $ec034e526f3660f5$var$variantEnclosedColored,
    "soft-rounded": $ec034e526f3660f5$var$variantSoftRounded,
    "solid-rounded": $ec034e526f3660f5$var$variantSolidRounded,
    unstyled: $ec034e526f3660f5$var$variantUnstyled
};
var $ec034e526f3660f5$var$defaultProps = {
    size: "md",
    variant: "line",
    colorScheme: "blue"
};
var $ec034e526f3660f5$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$97383552563be58d).keys,
    baseStyle: $ec034e526f3660f5$var$baseStyle,
    sizes: $ec034e526f3660f5$var$sizes,
    variants: $ec034e526f3660f5$var$variants,
    defaultProps: $ec034e526f3660f5$var$defaultProps
};




var $984c282b3ba16c14$var$baseStyleContainer = {
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    _focus: {
        boxShadow: "outline"
    }
};
var $984c282b3ba16c14$var$baseStyleLabel = {
    lineHeight: 1.2,
    overflow: "visible"
};
var $984c282b3ba16c14$var$baseStyleCloseButton = {
    fontSize: "18px",
    w: "1.25rem",
    h: "1.25rem",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "0.375rem",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focus: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
};
var $984c282b3ba16c14$var$baseStyle = {
    container: $984c282b3ba16c14$var$baseStyleContainer,
    label: $984c282b3ba16c14$var$baseStyleLabel,
    closeButton: $984c282b3ba16c14$var$baseStyleCloseButton
};
var $984c282b3ba16c14$var$sizes = {
    sm: {
        container: {
            minH: "1.25rem",
            minW: "1.25rem",
            fontSize: "xs",
            px: 2,
            borderRadius: "md"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    },
    md: {
        container: {
            minH: "1.5rem",
            minW: "1.5rem",
            fontSize: "sm",
            borderRadius: "md",
            px: 2
        }
    },
    lg: {
        container: {
            minH: 8,
            minW: 8,
            fontSize: "md",
            borderRadius: "md",
            px: 3
        }
    }
};
var $984c282b3ba16c14$var$variants = {
    subtle: (props)=>({
            container: (0, $2c5b2081ece66e86$export$2e2bcd8739ae039).variants.subtle(props)
        }),
    solid: (props)=>({
            container: (0, $2c5b2081ece66e86$export$2e2bcd8739ae039).variants.solid(props)
        }),
    outline: (props)=>({
            container: (0, $2c5b2081ece66e86$export$2e2bcd8739ae039).variants.outline(props)
        })
};
var $984c282b3ba16c14$var$defaultProps = {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
};
var $984c282b3ba16c14$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$4c2f5f7f2ea94a8e).keys,
    variants: $984c282b3ba16c14$var$variants,
    baseStyle: $984c282b3ba16c14$var$baseStyle,
    sizes: $984c282b3ba16c14$var$sizes,
    defaultProps: $984c282b3ba16c14$var$defaultProps
};



var $c7551c49516f2b5f$var$_Input$variants$unsty, $c7551c49516f2b5f$var$_Input$sizes$xs$field, $c7551c49516f2b5f$var$_Input$sizes$sm$field, $c7551c49516f2b5f$var$_Input$sizes$md$field, $c7551c49516f2b5f$var$_Input$sizes$lg$field;
function $c7551c49516f2b5f$var$_extends() {
    $c7551c49516f2b5f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7551c49516f2b5f$var$_extends.apply(this, arguments);
}
var $c7551c49516f2b5f$var$baseStyle = $c7551c49516f2b5f$var$_extends({}, (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).baseStyle.field, {
    paddingY: "8px",
    minHeight: "80px",
    lineHeight: "short",
    verticalAlign: "top"
});
var $c7551c49516f2b5f$var$variants = {
    outline: (props)=>{
        var _Input$variants$outli;
        return (_Input$variants$outli = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.outline(props).field) != null ? _Input$variants$outli : {};
    },
    flushed: (props)=>{
        var _Input$variants$flush;
        return (_Input$variants$flush = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.flushed(props).field) != null ? _Input$variants$flush : {};
    },
    filled: (props)=>{
        var _Input$variants$fille;
        return (_Input$variants$fille = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.filled(props).field) != null ? _Input$variants$fille : {};
    },
    unstyled: ($c7551c49516f2b5f$var$_Input$variants$unsty = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).variants.unstyled.field) != null ? $c7551c49516f2b5f$var$_Input$variants$unsty : {}
};
var $c7551c49516f2b5f$var$sizes = {
    xs: ($c7551c49516f2b5f$var$_Input$sizes$xs$field = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes.xs.field) != null ? $c7551c49516f2b5f$var$_Input$sizes$xs$field : {},
    sm: ($c7551c49516f2b5f$var$_Input$sizes$sm$field = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes.sm.field) != null ? $c7551c49516f2b5f$var$_Input$sizes$sm$field : {},
    md: ($c7551c49516f2b5f$var$_Input$sizes$md$field = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes.md.field) != null ? $c7551c49516f2b5f$var$_Input$sizes$md$field : {},
    lg: ($c7551c49516f2b5f$var$_Input$sizes$lg$field = (0, $1e7aa81b44bb39f6$export$2e2bcd8739ae039).sizes.lg.field) != null ? $c7551c49516f2b5f$var$_Input$sizes$lg$field : {}
};
var $c7551c49516f2b5f$var$defaultProps = {
    size: "md",
    variant: "outline"
};
var $c7551c49516f2b5f$export$2e2bcd8739ae039 = {
    baseStyle: $c7551c49516f2b5f$var$baseStyle,
    sizes: $c7551c49516f2b5f$var$sizes,
    variants: $c7551c49516f2b5f$var$variants,
    defaultProps: $c7551c49516f2b5f$var$defaultProps
};



var $747f81a43fb3e944$var$$bg = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("tooltip-bg");
var $747f81a43fb3e944$var$$arrowBg = (0, $e8dd38ff16de6a40$export$8b4981022bd80a4e)("popper-arrow-bg");
var $747f81a43fb3e944$var$baseStyle = (props)=>{
    var bg = (0, $f466d5c40b760069$export$549ff81930776885)("gray.700", "gray.300")(props);
    return {
        [$747f81a43fb3e944$var$$bg.variable]: "colors." + bg,
        px: "8px",
        py: "2px",
        bg: [
            $747f81a43fb3e944$var$$bg.reference
        ],
        [$747f81a43fb3e944$var$$arrowBg.variable]: [
            $747f81a43fb3e944$var$$bg.reference
        ],
        color: (0, $f466d5c40b760069$export$549ff81930776885)("whiteAlpha.900", "gray.900")(props),
        borderRadius: "sm",
        fontWeight: "medium",
        fontSize: "sm",
        boxShadow: "md",
        maxW: "320px",
        zIndex: "tooltip"
    };
};
var $747f81a43fb3e944$export$2e2bcd8739ae039 = {
    baseStyle: $747f81a43fb3e944$var$baseStyle
};




var $1ad18f3f0d75eeaa$var$baseStyleText = (props)=>{
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)("red.500", "red.300")(props),
        mt: 2,
        fontSize: "sm"
    };
};
var $1ad18f3f0d75eeaa$var$baseStyleIcon = (props)=>{
    return {
        marginEnd: "0.5em",
        color: (0, $f466d5c40b760069$export$549ff81930776885)("red.500", "red.300")(props)
    };
};
var $1ad18f3f0d75eeaa$var$baseStyle = (props)=>({
        text: $1ad18f3f0d75eeaa$var$baseStyleText(props),
        icon: $1ad18f3f0d75eeaa$var$baseStyleIcon(props)
    });
var $1ad18f3f0d75eeaa$export$2e2bcd8739ae039 = {
    parts: (0, $c9f2bd010a260619$export$bb18c440c00e82d9).keys,
    baseStyle: $1ad18f3f0d75eeaa$var$baseStyle
};


var $7c84082983d7318a$export$2e2bcd8739ae039 = {
    Accordion: $a76ebe31696bdb5b$export$2e2bcd8739ae039,
    Alert: $82f8036bf4090350$export$2e2bcd8739ae039,
    Avatar: $d27c7905eb1344e6$export$2e2bcd8739ae039,
    Badge: $2c5b2081ece66e86$export$2e2bcd8739ae039,
    Breadcrumb: $ce6db257809fff92$export$2e2bcd8739ae039,
    Button: $69d6f122b634382c$export$2e2bcd8739ae039,
    Checkbox: $d4f577d072848e75$export$2e2bcd8739ae039,
    CloseButton: $8481c5189c69df39$export$2e2bcd8739ae039,
    Code: $c5fdfec9105a9689$export$2e2bcd8739ae039,
    Container: $6151210835d9f9b3$export$2e2bcd8739ae039,
    Divider: $6d5b744f499a0384$export$2e2bcd8739ae039,
    Drawer: $bc8e4abca8b352a4$export$2e2bcd8739ae039,
    Editable: $94af17abb5b6ae5b$export$2e2bcd8739ae039,
    Form: $dffad7540d9e2a9a$export$2e2bcd8739ae039,
    FormLabel: $8a9f955d98fa6132$export$2e2bcd8739ae039,
    Heading: $70c64c4cec295be4$export$2e2bcd8739ae039,
    Input: $1e7aa81b44bb39f6$export$2e2bcd8739ae039,
    Kbd: $3af1a8ec765ae7ad$export$2e2bcd8739ae039,
    Link: $5d5053c2e0f47ad1$export$2e2bcd8739ae039,
    List: $675b3a7786049125$export$2e2bcd8739ae039,
    Menu: $9747f4fa4630d4b5$export$2e2bcd8739ae039,
    Modal: $aaac7f8f9035cda0$export$2e2bcd8739ae039,
    NumberInput: $edcf76acb98a64ce$export$2e2bcd8739ae039,
    PinInput: $026055e40aeb3962$export$2e2bcd8739ae039,
    Popover: $286fdf29dd6ab241$export$2e2bcd8739ae039,
    Progress: $76e1f1f04f0d8528$export$2e2bcd8739ae039,
    Radio: $3e6f19121bee3bfa$export$2e2bcd8739ae039,
    Select: $83814f9f8b79506f$export$2e2bcd8739ae039,
    Skeleton: $0e96450d5a4650c1$export$2e2bcd8739ae039,
    SkipLink: $f1c13d8bc37886c5$export$2e2bcd8739ae039,
    Slider: $97a1a954f9d45008$export$2e2bcd8739ae039,
    Spinner: $a66a7684c97f93be$export$2e2bcd8739ae039,
    Stat: $4bc5ace94ebdbb6f$export$2e2bcd8739ae039,
    Switch: $7a6abc391a681b1b$export$2e2bcd8739ae039,
    Table: $59d695cb473a1023$export$2e2bcd8739ae039,
    Tabs: $ec034e526f3660f5$export$2e2bcd8739ae039,
    Tag: $984c282b3ba16c14$export$2e2bcd8739ae039,
    Textarea: $c7551c49516f2b5f$export$2e2bcd8739ae039,
    Tooltip: $747f81a43fb3e944$export$2e2bcd8739ae039,
    FormError: $1ad18f3f0d75eeaa$export$2e2bcd8739ae039
};


var $7806ee6e8f342c90$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $7806ee6e8f342c90$export$2e2bcd8739ae039 = $7806ee6e8f342c90$var$borders;



function $859569b6ff2a5329$var$_extends() {
    $859569b6ff2a5329$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $859569b6ff2a5329$var$_extends.apply(this, arguments);
}
var $859569b6ff2a5329$export$79e1df82cbbff4e9 = (config)=>{
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: true,
        message: [
            "[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon",
            "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"
        ].join("")
    });
    return $859569b6ff2a5329$var$_extends({
        base: "0em"
    }, config);
};


/**
 * Breakpoints for responsive design
 */ var $8037dee4c21effec$var$breakpoints = (0, $859569b6ff2a5329$export$79e1df82cbbff4e9)({
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
});
var $8037dee4c21effec$export$2e2bcd8739ae039 = $8037dee4c21effec$var$breakpoints;


/**
 * @deprecated
 * You can derive the Colors type from the DefaultChakraTheme:
 *
 * type Colors = DefaultChakraTheme["colors"]
 */ var $7c4334699bf6274e$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $7c4334699bf6274e$export$2e2bcd8739ae039 = $7c4334699bf6274e$var$colors;


var $c56fdf7648694f2e$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var /**
 * @deprecated
 * You can derive the Radii type from the DefaultChakraTheme
 *
 * type Radii = DefaultChakraTheme['radii']
 */ $c56fdf7648694f2e$export$2e2bcd8739ae039 = $c56fdf7648694f2e$var$radii;


var $0afeca7a271c6e8d$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var /**
 * @deprecated
 * You can derive the Shadows type from the DefaultChakraTheme
 *
 * type Shadows = DefaultChakraTheme['shadows']
 */ $0afeca7a271c6e8d$export$2e2bcd8739ae039 = $0afeca7a271c6e8d$var$shadows;




var $22da35580894ab18$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $22da35580894ab18$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $22da35580894ab18$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $22da35580894ab18$var$transition = {
    property: $22da35580894ab18$var$transitionProperty,
    easing: $22da35580894ab18$var$transitionTimingFunction,
    duration: $22da35580894ab18$var$transitionDuration
};
var $22da35580894ab18$export$2e2bcd8739ae039 = $22da35580894ab18$var$transition;



var $9dacc0f8fb47f424$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var /**
 * @deprecated
 * You can derive the ZIndices type from the DefaultChakraTheme
 *
 * type ZIndices = DefaultChakraTheme['zIndices']
 */ $9dacc0f8fb47f424$export$2e2bcd8739ae039 = $9dacc0f8fb47f424$var$zIndices;


var $2b87c9fe7603bd13$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $2b87c9fe7603bd13$export$2e2bcd8739ae039 = $2b87c9fe7603bd13$var$blur;


function $2b65c18372a21089$var$_extends() {
    $2b65c18372a21089$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2b65c18372a21089$var$_extends.apply(this, arguments);
}
var $2b65c18372a21089$var$foundations = $2b65c18372a21089$var$_extends({
    breakpoints: $8037dee4c21effec$export$2e2bcd8739ae039,
    zIndices: $9dacc0f8fb47f424$export$2e2bcd8739ae039,
    radii: $c56fdf7648694f2e$export$2e2bcd8739ae039,
    blur: $2b87c9fe7603bd13$export$2e2bcd8739ae039,
    colors: $7c4334699bf6274e$export$2e2bcd8739ae039
}, (0, $e95877dd22e3ca6f$export$2e2bcd8739ae039), {
    sizes: $dade5440bdd7be94$export$2e2bcd8739ae039,
    shadows: $0afeca7a271c6e8d$export$2e2bcd8739ae039,
    space: (0, $54ff0d233c03fddc$export$5458b64234d1333c),
    borders: $7806ee6e8f342c90$export$2e2bcd8739ae039,
    transition: $22da35580894ab18$export$2e2bcd8739ae039
});
var $2b65c18372a21089$export$2e2bcd8739ae039 = $2b65c18372a21089$var$foundations;



var $ab3570e2f1a134ba$var$styles = {
    global: (props)=>({
            body: {
                fontFamily: "body",
                color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.800", "whiteAlpha.900")(props),
                bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "gray.800")(props),
                transitionProperty: "background-color",
                transitionDuration: "normal",
                lineHeight: "base"
            },
            "*::placeholder": {
                color: (0, $f466d5c40b760069$export$549ff81930776885)("gray.400", "whiteAlpha.400")(props)
            },
            "*, *::before, &::after": {
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                wordWrap: "break-word"
            }
        })
};
var $ab3570e2f1a134ba$export$2e2bcd8739ae039 = $ab3570e2f1a134ba$var$styles;




var $a77c364619ae316b$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $a77c364619ae316b$export$73a6ae01926a4f0e(unit) {
    if (!(0, $6b74ef5ae6a56e47$export$a6cdc56e425d0d0a)(unit)) return false;
    return $a77c364619ae316b$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


function $373c960dc38c4436$var$_extends() {
    $373c960dc38c4436$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $373c960dc38c4436$var$_extends.apply(this, arguments);
}
var $373c960dc38c4436$var$direction = "ltr";
var $373c960dc38c4436$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $373c960dc38c4436$export$bca14c5b3b88a9c9 = $373c960dc38c4436$var$_extends({
    direction: $373c960dc38c4436$var$direction
}, (0, $2b65c18372a21089$export$2e2bcd8739ae039), {
    components: $7c84082983d7318a$export$2e2bcd8739ae039,
    styles: $ab3570e2f1a134ba$export$2e2bcd8739ae039,
    config: $373c960dc38c4436$var$config
});
var $373c960dc38c4436$export$2e2bcd8739ae039 = $373c960dc38c4436$export$bca14c5b3b88a9c9;



var $e5Q7j = parcelRequire("e5Q7j");
function $e4d547fd9b80de1b$export$33a2b855d5b8731e() {
    for(var _len = arguments.length, extensions = new Array(_len), _key = 0; _key < _len; _key++)extensions[_key] = arguments[_key];
    var overrides = [
        ...extensions
    ];
    var baseTheme = extensions[extensions.length - 1];
    if ((0, $a77c364619ae316b$export$73a6ae01926a4f0e)(baseTheme) && // this ensures backward compatibility
    // previously only `extendTheme(override, baseTheme?)` was allowed
    overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
    else baseTheme = (0, $373c960dc38c4436$export$2e2bcd8739ae039);
    return (0, $da6e679e22b3b02c$export$a4627e546088548d)(...overrides.map((extension)=>(prevTheme)=>(0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(extension) ? extension(prevTheme) : $e4d547fd9b80de1b$export$c42236daa9a25fdd(prevTheme, extension)))(baseTheme);
}
function $e4d547fd9b80de1b$export$c42236daa9a25fdd() {
    for(var _len2 = arguments.length, overrides = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)overrides[_key2] = arguments[_key2];
    return (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, ...overrides, $e4d547fd9b80de1b$var$mergeThemeCustomizer);
}
function $e4d547fd9b80de1b$var$mergeThemeCustomizer(source, override, key, object) {
    if (((0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(source) || (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(override)) && Object.prototype.hasOwnProperty.call(object, key)) return function() {
        var sourceValue = (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(source) ? source(...arguments) : source;
        var overrideValue = (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(override) ? override(...arguments) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, sourceValue, overrideValue, $e4d547fd9b80de1b$var$mergeThemeCustomizer);
    };
     // fallback to default behaviour
    return undefined;
}

















var $denZA = parcelRequire("denZA");
function $a3947eb426bc3e9b$var$_extends() {
    $a3947eb426bc3e9b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3947eb426bc3e9b$var$_extends.apply(this, arguments);
}
function $a3947eb426bc3e9b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a3947eb426bc3e9b$export$a72b869850756453 = (props)=>{
    var { type: type = "checkbox", _hover: _hover, _invalid: _invalid, _disabled: _disabled, _focus: _focus, _checked: _checked, _child: _child = {
        opacity: 0
    }, _checkedAndChild: _checkedAndChild = {
        opacity: 1
    }, _checkedAndDisabled: _checkedAndDisabled, _checkedAndFocus: _checkedAndFocus, _checkedAndHover: _checkedAndHover, children: children } = props, rest = $a3947eb426bc3e9b$var$_objectWithoutPropertiesLoose(props, [
        "type",
        "_hover",
        "_invalid",
        "_disabled",
        "_focus",
        "_checked",
        "_child",
        "_checkedAndChild",
        "_checkedAndDisabled",
        "_checkedAndFocus",
        "_checkedAndHover",
        "children"
    ]);
    var checkedAndDisabled = "input[type=" + type + "]:checked:disabled + &";
    var checkedAndHover = "input[type=" + type + "]:checked:hover:not(:disabled) + &";
    var checkedAndFocus = "input[type=" + type + "]:checked:focus + &";
    var disabled = "input[type=" + type + "]:disabled + &";
    var focus = "input[type=" + type + "]:focus + &";
    var hover = "input[type=" + type + "]:hover:not(:disabled):not(:checked) + &";
    var checked = "input[type=" + type + "]:checked + &, input[type=" + type + "][aria-checked=mixed] + &";
    var invalid = "input[type=" + type + "][aria-invalid=true] + &";
    var child = "& > *";
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $a3947eb426bc3e9b$var$_extends({}, rest, {
        "aria-hidden": true,
        __css: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            transitionProperty: "common",
            transitionDuration: "fast",
            flexShrink: 0,
            [focus]: _focus,
            [hover]: _hover,
            [disabled]: _disabled,
            [invalid]: _invalid,
            [checkedAndDisabled]: _checkedAndDisabled,
            [checkedAndFocus]: _checkedAndFocus,
            [checkedAndHover]: _checkedAndHover,
            [child]: _child,
            [checked]: $a3947eb426bc3e9b$var$_extends({}, _checked, {
                [child]: _checkedAndChild
            })
        }
    }), children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $a3947eb426bc3e9b$export$a72b869850756453.displayName = "ControlBox";
var $a3947eb426bc3e9b$export$2e2bcd8739ae039 = $a3947eb426bc3e9b$export$a72b869850756453;











var $denZA = parcelRequire("denZA");
var $9b034455a2603589$var$doc = {
    body: {
        classList: {
            add () {},
            remove () {}
        }
    },
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    }
};
var $9b034455a2603589$export$3fdcb9b4d81368d8 = $9b034455a2603589$var$doc;



var $5e227f45788ff2c5$var$noop = ()=>{};
var $5e227f45788ff2c5$var$win = {
    document: (0, $9b034455a2603589$export$3fdcb9b4d81368d8),
    navigator: {
        userAgent: ""
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: $5e227f45788ff2c5$var$noop,
    removeEventListener: $5e227f45788ff2c5$var$noop,
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    matchMedia () {
        return {
            matches: false,
            addListener: $5e227f45788ff2c5$var$noop,
            removeListener: $5e227f45788ff2c5$var$noop
        };
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    },
    setTimeout: ()=>0,
    clearTimeout: $5e227f45788ff2c5$var$noop,
    setInterval: ()=>0,
    clearInterval: $5e227f45788ff2c5$var$noop
};
var $5e227f45788ff2c5$export$8582633f185c62bb = $5e227f45788ff2c5$var$win;


var $2b223d0121023643$var$mockEnv = {
    window: (0, $5e227f45788ff2c5$export$8582633f185c62bb),
    document: (0, $9b034455a2603589$export$3fdcb9b4d81368d8)
};
var $2b223d0121023643$var$defaultEnv = (0, $405775388fe7f58e$export$4e09c449d6c407f7) ? {
    window: window,
    document: document
} : $2b223d0121023643$var$mockEnv;
var $2b223d0121023643$var$EnvironmentContext = /*#__PURE__*/ (0, $denZA.createContext)($2b223d0121023643$var$defaultEnv);
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $2b223d0121023643$var$EnvironmentContext.displayName = "EnvironmentContext";
function $2b223d0121023643$export$ea7ed2425832167d() {
    return (0, $denZA.useContext)($2b223d0121023643$var$EnvironmentContext);
}
function $2b223d0121023643$export$29a4c0b32fc9db42(props) {
    var { children: children, environment: environmentProp } = props;
    var [node, setNode] = (0, $denZA.useState)(null);
    var context = (0, $denZA.useMemo)(()=>{
        var _ref;
        var doc = node == null ? void 0 : node.ownerDocument;
        var win = node == null ? void 0 : node.ownerDocument.defaultView;
        var nodeEnv = doc ? {
            document: doc,
            window: win
        } : undefined;
        var env = (_ref = environmentProp != null ? environmentProp : nodeEnv) != null ? _ref : $2b223d0121023643$var$defaultEnv;
        return env;
    }, [
        node,
        environmentProp
    ]);
    var showEnvGetter = !node && !environmentProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($2b223d0121023643$var$EnvironmentContext.Provider, {
        value: context
    }, children, showEnvGetter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement("span", {
        ref: (el)=>{
            if (el) setNode(el);
        }
    }));
}
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $2b223d0121023643$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";




var $denZA = parcelRequire("denZA");
var $4e05a8ace4dadc1b$var$useSafeLayoutEffect = (0, $405775388fe7f58e$export$4e09c449d6c407f7) ? $denZA.useLayoutEffect : $denZA.useEffect;
function $4e05a8ace4dadc1b$export$32d5543ab307c01(query) {
    var env = (0, $2b223d0121023643$export$ea7ed2425832167d)();
    var queries = Array.isArray(query) ? query : [
        query
    ];
    var isSupported = (0, $405775388fe7f58e$export$4e09c449d6c407f7) && "matchMedia" in env.window;
    var [matches, setMatches] = $denZA.useState(queries.map((query)=>isSupported ? !!env.window.matchMedia(query).matches : false));
    $4e05a8ace4dadc1b$var$useSafeLayoutEffect(()=>{
        if (!isSupported) return undefined;
        var mediaQueryList = queries.map((query)=>env.window.matchMedia(query));
        var listenerList = mediaQueryList.map((mediaQuery, index)=>{
            var listener = ()=>setMatches((prev)=>prev.map((prevValue, idx)=>index === idx ? !!mediaQuery.matches : prevValue));
            mediaQuery.addListener(listener);
            return listener;
        });
        return ()=>{
            mediaQueryList.forEach((mediaQuery, index)=>{
                mediaQuery.removeListener(listenerList[index]);
            });
        };
    }, [
        query
    ]);
    return matches;
}



























$parcel$exportWildcard($93917dada858a7bc$exports, $954a09018ee9d0a8$exports);




var $denZA = parcelRequire("denZA");

var $93d7f31bb199d2e9$var$__assign = undefined && undefined.__assign || function() {
    $93d7f31bb199d2e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $93d7f31bb199d2e9$var$__assign.apply(this, arguments);
};
var $93d7f31bb199d2e9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $93d7f31bb199d2e9$export$519437715052e656 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    // Responsive layout: put the buttons in the button-group (footer) _below_ each other when
    // - screen width <= 416px
    // - size-prop is 'sm' or 'xs'
    var size = (0, $bcf4c1510a8e0890$export$4cc1699d46f42cae)().size;
    var hasSmallProp = size === 'xs' || size === 'sm';
    var _a = $93d7f31bb199d2e9$var$__read((0, $4e05a8ace4dadc1b$export$32d5543ab307c01)('(max-width: 416px)'), 1), hasSmallScreen = _a[0]; // TRUE if EQUAL TO OR LESS than 416px
    var shouldRenderVertically = hasSmallScreen || hasSmallProp;
    var styles = {
        '[role=group]': {
            flexFlow: shouldRenderVertically ? 'column' : 'row-reverse',
            width: shouldRenderVertically ? '100%' : '',
            gap: shouldRenderVertically ? '0.5em' : ''
        },
        '[role=group] button': {
            width: shouldRenderVertically ? '100%' : ''
        }
    };
    return $denZA.createElement((0, $f1dbd08245d68867$export$519437715052e656), $93d7f31bb199d2e9$var$__assign({}, props, {
        ref: ref,
        sx: styles
    }));
});





var $denZA = parcelRequire("denZA");
var $a367257ac77bf4e8$var$__assign = undefined && undefined.__assign || function() {
    $a367257ac77bf4e8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a367257ac77bf4e8$var$__assign.apply(this, arguments);
};
var $a367257ac77bf4e8$export$f50a68e3694789ee = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$f50a68e3694789ee), $a367257ac77bf4e8$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $e1eef36fc1df4685$var$__assign = undefined && undefined.__assign || function() {
    $e1eef36fc1df4685$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e1eef36fc1df4685$var$__assign.apply(this, arguments);
};
var $e1eef36fc1df4685$export$8948f78d83984c69 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $f1dbd08245d68867$export$8948f78d83984c69), $e1eef36fc1df4685$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");







var $d1d1a3a7c7f3f8d3$var$__assign = undefined && undefined.__assign || function() {
    $d1d1a3a7c7f3f8d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d1d1a3a7c7f3f8d3$var$__assign.apply(this, arguments);
};
var $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772 = function(props) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _a = props.size, size = _a === void 0 ? '' : _a, variant = props.variant, _b = props.hideIcon, hideIcon = _b === void 0 ? false : _b;
    return $denZA.createElement((0, $bcf4c1510a8e0890$export$178405afcd8c5eb), {
        value: {
            size: size,
            status: variant,
            hideIcon: hideIcon
        }
    }, $denZA.createElement((0, $f1dbd08245d68867$export$2b77a92f1a5ad772), $d1d1a3a7c7f3f8d3$var$__assign({}, props)));
};
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.Body = (0, $e80e570af988fbd8$export$cb540d8b0ef7906c);
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.CloseButton = (0, $b9cfe88bd111956b$export$edf9108895ba774f);
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.Footer = (0, $93d7f31bb199d2e9$export$519437715052e656);
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.Header = (0, $a367257ac77bf4e8$export$f50a68e3694789ee);
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.Overlay = (0, $e1eef36fc1df4685$export$8948f78d83984c69);
$d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772.Content = (0, $be9dff9c3172aa4f$export$6da19a24bf249f17);


var $b4bbcc0569dd74db$export$cb540d8b0ef7906c = (0, $e80e570af988fbd8$export$cb540d8b0ef7906c);
var $b4bbcc0569dd74db$export$edf9108895ba774f = (0, $b9cfe88bd111956b$export$edf9108895ba774f);
var $b4bbcc0569dd74db$export$6da19a24bf249f17 = (0, $be9dff9c3172aa4f$export$6da19a24bf249f17);
var $b4bbcc0569dd74db$export$519437715052e656 = (0, $93d7f31bb199d2e9$export$519437715052e656);
var $b4bbcc0569dd74db$export$f50a68e3694789ee = (0, $a367257ac77bf4e8$export$f50a68e3694789ee);
var $b4bbcc0569dd74db$export$8948f78d83984c69 = (0, $e1eef36fc1df4685$export$8948f78d83984c69);




var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");
var $d2e756f3ce0dee5d$var$__assign = undefined && undefined.__assign || function() {
    $d2e756f3ce0dee5d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d2e756f3ce0dee5d$var$__assign.apply(this, arguments);
};
var $d2e756f3ce0dee5d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d2e756f3ce0dee5d$export$2df9f3e5f6d355f6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var rest = $d2e756f3ce0dee5d$var$__rest((0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), []);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var brandRef = $denZA.useRef(null);
    var handleKeyDown = function(e) {
        if (!brandRef.current) return;
        switch(e.key){
            case ' ':
            case 'Enter':
                e.preventDefault();
                brandRef.current.click();
        }
    };
    var finalRef = (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(brandRef, ref);
    // eslint-disable-next-line react/jsx-no-bind
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).a, $d2e756f3ce0dee5d$var$__assign({
        __css: styles.brand,
        onKeyDown: handleKeyDown,
        ref: finalRef
    }, rest));
});






var $denZA = parcelRequire("denZA");

var $33bd3e49511267d8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $33bd3e49511267d8$var$_a;
var $33bd3e49511267d8$export$12036bdca8898f9b = ($33bd3e49511267d8$var$_a = $33bd3e49511267d8$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'NavbarContext',
    errorMessage: 'useNavbarContext: `context` is undefined. Seems you forgot to wrap the navbar items in `<NavbarContext />` '
}), 2), $33bd3e49511267d8$var$_a[0]), $33bd3e49511267d8$export$d1a1b51809dfb828 = $33bd3e49511267d8$var$_a[1];


var $f20c898371d1f306$var$__assign = undefined && undefined.__assign || function() {
    $f20c898371d1f306$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f20c898371d1f306$var$__assign.apply(this, arguments);
};
var $f20c898371d1f306$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f20c898371d1f306$export$bd8b0b20f92f64e5 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var _a;
    var rest = $f20c898371d1f306$var$__rest((0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), []);
    var orientation = (0, $33bd3e49511267d8$export$d1a1b51809dfb828)().orientation;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Navbar', $f20c898371d1f306$var$__assign($f20c898371d1f306$var$__assign({}, props), {
        orientation: orientation
    })).burger;
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $f20c898371d1f306$var$__assign({
        __css: styles,
        ref: ref
    }, rest), $denZA.createElement((0, $ff0be911914f8500$export$c25acd513dcc8062), {
        "aria-label": "Menu",
        color: (_a = props.iconColor) !== null && _a !== void 0 ? _a : 'white',
        icon: $denZA.createElement((0, $34fc13c552d17e23$export$56dbed97f074c6e4), null),
        variant: "ghost"
    }));
});





var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

function $2dd9093c89b92ca1$export$7080b3e976bc91ab(event, handler, env, options) {
    var listener = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(handler);
    $denZA.useEffect(()=>{
        var _runIfFn;
        var node = (_runIfFn = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(env)) != null ? _runIfFn : document;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        env,
        options,
        listener
    ]);
    return ()=>{
        var _runIfFn2;
        var node = (_runIfFn2 = (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(env)) != null ? _runIfFn2 : document;
        node.removeEventListener(event, listener, options);
    };
}







var $denZA = parcelRequire("denZA");

var $01ebb600ffe47521$var$__assign = undefined && undefined.__assign || function() {
    $01ebb600ffe47521$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $01ebb600ffe47521$var$__assign.apply(this, arguments);
};
var $01ebb600ffe47521$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $01ebb600ffe47521$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $01ebb600ffe47521$var$_a;
var $01ebb600ffe47521$export$62b22d151866115d = ($01ebb600ffe47521$var$_a = $01ebb600ffe47521$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'MenuContext',
    errorMessage: 'useMenuContext: `context` is undefined. Seems you forgot to wrap the menu items in `<MenuContext />` '
}), 2), $01ebb600ffe47521$var$_a[0]), $01ebb600ffe47521$export$21c7ab35b39f78ec = $01ebb600ffe47521$var$_a[1];
var $01ebb600ffe47521$export$d9b273488cd8ce6f = function(_a) {
    var offset = _a.offset, closeOnBlur = _a.closeOnBlur, props = $01ebb600ffe47521$var$__rest(_a, [
        "offset",
        "closeOnBlur"
    ]);
    var children = props.children;
    var offsetOverride = offset ? offset : [
        0,
        0
    ];
    var disclosure = (0, $528efd7f0c9e3374$export$6e3e27031a30522f)();
    var popper = (0, $e0cfb75a998fb7e2$export$f4d5bf230a36dd6e)($01ebb600ffe47521$var$__assign({
        offset: offsetOverride
    }, props));
    var context = $denZA.useMemo(function() {
        return $01ebb600ffe47521$var$__assign($01ebb600ffe47521$var$__assign($01ebb600ffe47521$var$__assign({}, disclosure), popper), {
            closeOnBlur: closeOnBlur
        });
    }, [
        disclosure,
        popper,
        closeOnBlur
    ]);
    return $denZA.createElement($01ebb600ffe47521$export$62b22d151866115d, {
        value: context
    }, children);
};
var $01ebb600ffe47521$export$d4c4e98c5044dc8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var children = _a.children, render = _a.render;
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var _b = $01ebb600ffe47521$export$21c7ab35b39f78ec(), isOpen = _b.isOpen, onClose = _b.onClose, closeOnBlur = _b.closeOnBlur, popper = $01ebb600ffe47521$var$__rest(_b, [
        "isOpen",
        "onClose",
        "closeOnBlur"
    ]);
    var orientation = (0, $33bd3e49511267d8$export$d1a1b51809dfb828)().orientation;
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var menuRef = $denZA.useRef(null);
    (0, $7882820c20d771da$export$71b2224f1ce5e08e)({
        ref: menuRef,
        handler: function(event) {
            if (!menuRef.current) return;
            if (isOpen && closeOnBlur && !menuRef.current.contains(event.target)) onClose();
        }
    });
    var handleKeyDown = function(e) {
        switch(e.key){
            case 'Escape':
                e.preventDefault();
                onClose();
        }
    };
    (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)('keydown', handleKeyDown);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        display: "flex",
        height: orientation === 'vertical' ? 'auto' : '100%',
        justifyContent: "inherit",
        ref: menuRef,
        width: orientation === 'vertical' ? '100%' : 'auto'
    }, render && (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(render($01ebb600ffe47521$var$__assign({
        isOpen: isOpen,
        onClose: onClose,
        closeOnBlur: closeOnBlur
    }, popper))), isOpen && $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function() {
            onClose();
        },
        ref: popper.popperRef,
        sx: styles.menuList
    }, validChildren.map(function(child) {
        return $denZA.cloneElement(child, {
            onClick: function() {
                if (child.props.onClick) child.props.onClick();
                onClose();
            }
        });
    })));
});



var $990324db3633f68f$var$__assign = undefined && undefined.__assign || function() {
    $990324db3633f68f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $990324db3633f68f$var$__assign.apply(this, arguments);
};
var $990324db3633f68f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $990324db3633f68f$export$eaefe74989e4d0c1 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var hasMenu = _a.hasMenu, icon = _a.icon, children = _a.children, title = _a.title, isActive = _a.isActive, _b = _a.closeOnBlur, closeOnBlur = _b === void 0 ? true : _b, props = $990324db3633f68f$var$__rest(_a, [
        "hasMenu",
        "icon",
        "children",
        "title",
        "isActive",
        "closeOnBlur"
    ]);
    var rest = $990324db3633f68f$var$__rest((0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), []);
    var _c = (0, $33bd3e49511267d8$export$d1a1b51809dfb828)(), orientation = _c.orientation, isSecondary = _c.isSecondary, isFullWidth = _c.isFullWidth;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Navbar', $990324db3633f68f$var$__assign($990324db3633f68f$var$__assign({}, props), {
        orientation: orientation,
        isSecondary: isSecondary,
        isFullWidth: isFullWidth,
        isActive: isActive
    })).menuItem;
    var onKeyDown = function(e) {
        if (!props.onClick) return;
        switch(e.key){
            case ' ':
            case 'Enter':
                e.preventDefault();
                props.onClick();
        }
    };
    // This can be improved.
    // TODO: Use ContextProvider instead to pass down the properties from popper and disclosure
    // TODO: extract controls for Expand Menu buttons into their own hooks
    // TODO: fix the typing issues coming from chakra. (Could be resolved when we update to 1.6.4)
    if (hasMenu) return $denZA.createElement((0, $01ebb600ffe47521$export$d9b273488cd8ce6f), {
        closeOnBlur: closeOnBlur,
        offset: [
            0,
            1
        ],
        placement: orientation === 'vertical' ? 'right-start' : 'bottom-start'
    }, $denZA.createElement((0, $01ebb600ffe47521$export$d4c4e98c5044dc8), {
        // eslint-disable-next-line react/jsx-no-bind
        render: function(_a) {
            var getReferenceProps = _a.getReferenceProps, onToggle = _a.onToggle;
            return $denZA.createElement($990324db3633f68f$export$eaefe74989e4d0c1, $990324db3633f68f$var$__assign({
                as: "button",
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                onClick: onToggle,
                sx: styles
            }, getReferenceProps(), rest), title, icon && $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                as: icon,
                fontSize: title ? '0.75em' : '1em',
                ml: title ? 2 : 0
            }));
        }
    }, children));
    return(// eslint-disable-next-line react/jsx-no-bind
    $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).a, $990324db3633f68f$var$__assign({
        onKeyDown: onKeyDown,
        ref: ref,
        sx: styles,
        tabIndex: 0
    }, rest), children));
});
var $990324db3633f68f$export$44020656de05f2b4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var hasMenu = _a.hasMenu, title = _a.title, icon = _a.icon, _b = _a.closeOnBlur, closeOnBlur = _b === void 0 ? true : _b, isOpen = _a.isOpen, rest = $990324db3633f68f$var$__rest(_a, [
        "hasMenu",
        "title",
        "icon",
        "closeOnBlur",
        "isOpen"
    ]);
    var children = rest.children;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Navbar', {
        isOpen: isOpen
    }).menuOption;
    // This can be improved.
    // TODO: Use ContextProvider instead to pass down the properties from popper and disclosure
    // TODO: extract controls for Expand Menu buttons into their own hooks
    // TODO: fix the typing issues coming from chakra. (Could be resolved when we update to 1.6.4)
    if (hasMenu) return $denZA.createElement((0, $01ebb600ffe47521$export$d9b273488cd8ce6f), {
        closeOnBlur: closeOnBlur,
        offset: [
            0,
            1
        ],
        placement: "right-start"
    }, $denZA.createElement((0, $01ebb600ffe47521$export$d4c4e98c5044dc8), {
        // eslint-disable-next-line react/jsx-no-bind
        render: function(_a) {
            var onToggle = _a.onToggle, getReferenceProps = _a.getReferenceProps, isMenuOpen = _a.isOpen;
            return $denZA.createElement($990324db3633f68f$export$44020656de05f2b4, $990324db3633f68f$var$__assign({
                // eslint-disable-next-line react/jsx-no-bind
                onClick: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggle();
                }
            }, getReferenceProps(), {
                isOpen: isMenuOpen,
                w: "100%"
            }), title, icon && $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                as: icon,
                fontSize: "0.75em",
                ml: "2"
            }));
        }
    }, children));
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $990324db3633f68f$var$__assign({
        ref: ref,
        sx: styles,
        tabIndex: 0
    }, rest), children);
});





var $denZA = parcelRequire("denZA");

var $68850fba961c9ed3$var$__assign = undefined && undefined.__assign || function() {
    $68850fba961c9ed3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68850fba961c9ed3$var$__assign.apply(this, arguments);
};
var $68850fba961c9ed3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $68850fba961c9ed3$export$e76b02a213c7eb41 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var rest = $68850fba961c9ed3$var$__rest((0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), []);
    var orientation = (0, $33bd3e49511267d8$export$d1a1b51809dfb828)().orientation;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Navbar', $68850fba961c9ed3$var$__assign($68850fba961c9ed3$var$__assign({}, props), {
        orientation: orientation
    })).segment;
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $68850fba961c9ed3$var$__assign({
        __css: styles,
        ref: ref
    }, rest));
});


var $20cfa76b632e71e2$var$__assign = undefined && undefined.__assign || function() {
    $20cfa76b632e71e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20cfa76b632e71e2$var$__assign.apply(this, arguments);
};
var $20cfa76b632e71e2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $20cfa76b632e71e2$export$42cfbb80f7861e77 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var _a = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), isSecondary = _a.isSecondary, orientation = _a.orientation, isFullWidth = _a.isFullWidth, rest = $20cfa76b632e71e2$var$__rest(_a, [
        "isSecondary",
        "orientation",
        "isFullWidth"
    ]);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Navbar', props);
    return $denZA.createElement((0, $33bd3e49511267d8$export$12036bdca8898f9b), {
        value: {
            isSecondary: isSecondary,
            orientation: orientation,
            isFullWidth: isFullWidth
        }
    }, $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).nav, $20cfa76b632e71e2$var$__assign({
        __css: styles.container,
        ref: ref
    }, rest))));
});
$20cfa76b632e71e2$export$42cfbb80f7861e77.Brand = (0, $d2e756f3ce0dee5d$export$2df9f3e5f6d355f6);
$20cfa76b632e71e2$export$42cfbb80f7861e77.Burger = (0, $f20c898371d1f306$export$bd8b0b20f92f64e5);
$20cfa76b632e71e2$export$42cfbb80f7861e77.Item = (0, $990324db3633f68f$export$eaefe74989e4d0c1);
$20cfa76b632e71e2$export$42cfbb80f7861e77.Option = (0, $990324db3633f68f$export$44020656de05f2b4);
$20cfa76b632e71e2$export$42cfbb80f7861e77.Segment = (0, $68850fba961c9ed3$export$e76b02a213c7eb41);








var $denZA = parcelRequire("denZA");

var $e0fedb6c87db5ce1$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e0fedb6c87db5ce1$var$_a;
var $e0fedb6c87db5ce1$export$276476f8af208fda = ($e0fedb6c87db5ce1$var$_a = $e0fedb6c87db5ce1$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'NumberInputContext',
    errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
}), 2), $e0fedb6c87db5ce1$var$_a[0]), $e0fedb6c87db5ce1$export$8229e3ee43250f05 = $e0fedb6c87db5ce1$var$_a[1];


var $14d47333e9862f49$var$__assign = undefined && undefined.__assign || function() {
    $14d47333e9862f49$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $14d47333e9862f49$var$__assign.apply(this, arguments);
};
var $14d47333e9862f49$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $14d47333e9862f49$export$9ee95a8b1ce70b74 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'attached' : _b, rest = $14d47333e9862f49$var$__rest(_a, [
        "variant"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var _c = (0, $e0fedb6c87db5ce1$export$8229e3ee43250f05)(), getDecrementButtonProps = _c.getDecrementButtonProps, isDisabled = _c.isDisabled;
    var decrement = getDecrementButtonProps(rest, ref);
    return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $14d47333e9862f49$var$__assign({}, decrement, {
        ref: ref,
        sx: styles.button,
        tabIndex: isDisabled ? -1 : 0,
        variant: variant
    }), $denZA.createElement((0, $ad12d0e9373faad2$export$b7a01a7ec68fd5c0), {
        h: "3",
        w: "3"
    }));
});






var $denZA = parcelRequire("denZA");

var $b1138ec9c74892d8$var$__assign = undefined && undefined.__assign || function() {
    $b1138ec9c74892d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1138ec9c74892d8$var$__assign.apply(this, arguments);
};
var $b1138ec9c74892d8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b1138ec9c74892d8$export$dca82b6d540ba016 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'attached' : _b, rest = $b1138ec9c74892d8$var$__rest(_a, [
        "variant"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var _c = (0, $e0fedb6c87db5ce1$export$8229e3ee43250f05)(), getIncrementButtonProps = _c.getIncrementButtonProps, isDisabled = _c.isDisabled;
    var increment = $b1138ec9c74892d8$var$__rest(getIncrementButtonProps(rest, ref), []);
    return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b1138ec9c74892d8$var$__assign({}, increment, {
        ref: ref,
        sx: styles.button,
        tabIndex: isDisabled ? -1 : 0,
        variant: variant
    }), $denZA.createElement((0, $0cb8cc7c0306e661$export$2ef3672ebfdfd8df), {
        h: "3",
        w: "3"
    }));
});





var $denZA = parcelRequire("denZA");

var $2384a144d30b1924$var$__assign = undefined && undefined.__assign || function() {
    $2384a144d30b1924$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2384a144d30b1924$var$__assign.apply(this, arguments);
};
var $2384a144d30b1924$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2384a144d30b1924$export$8eabdd1cd59b4b71 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var size = _a.size, rest = $2384a144d30b1924$var$__rest(_a, [
        "size"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var getInputProps = (0, $e0fedb6c87db5ce1$export$8229e3ee43250f05)().getInputProps;
    var input = getInputProps(rest, ref);
    var styleOverrides = $2384a144d30b1924$var$__assign({}, styles.field);
    return $denZA.createElement((0, $eb05d11f12817009$export$f5b8910cec6cf069), $2384a144d30b1924$var$__assign({
        textAlign: "center"
    }, input, rest, {
        ref: ref,
        size: size,
        sx: styleOverrides
    }));
});






var $a2c5f30ccc79a99f$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $a2c5f30ccc79a99f$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $a2c5f30ccc79a99f$var$toNumber(value) {
    var num = parseFloat(value);
    return (0, $6b74ef5ae6a56e47$export$3f283ac14831e759)(num) ? 0 : num;
}
function $a2c5f30ccc79a99f$export$3e91a10e66078270(value, precision) {
    var nextValue = $a2c5f30ccc79a99f$var$toNumber(value);
    var scaleFactor = 10 ** (precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function $a2c5f30ccc79a99f$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
function $a2c5f30ccc79a99f$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $a2c5f30ccc79a99f$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
function $a2c5f30ccc79a99f$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $a2c5f30ccc79a99f$export$a42544f265f8403(step);
    return $a2c5f30ccc79a99f$export$3e91a10e66078270(nextValue, precision);
}
function $a2c5f30ccc79a99f$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}



var $denZA = parcelRequire("denZA");
function $fe4ba998a748d4ed$export$70c4067197c60e2d(props) {
    if (props === void 0) props = {};
    var { onChange: onChange, precision: precisionProp, defaultValue: defaultValue, value: valueProp, step: stepProp = 1, min: min = (0, $a2c5f30ccc79a99f$export$79f1df30fb36b5), max: max = (0, $a2c5f30ccc79a99f$export$ab0cdf6ed4011946), keepWithinRange: keepWithinRange = true } = props;
    var onChangeProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChange);
    var [valueState, setValue] = (0, $denZA.useState)(()=>{
        var _cast;
        if (defaultValue == null) return "";
        return (_cast = $fe4ba998a748d4ed$var$cast(defaultValue, stepProp, precisionProp)) != null ? _cast : "";
    });
    /**
   * Because the component that consumes this hook can be controlled or uncontrolled
   * we'll keep track of that
   */ var [isControlled, value] = (0, $53a3d6ee771ef939$export$7301e09313e4cf1b)(valueProp, valueState);
    var decimalPlaces = $fe4ba998a748d4ed$var$getDecimalPlaces($fe4ba998a748d4ed$var$parse(value), stepProp);
    var precision = precisionProp != null ? precisionProp : decimalPlaces;
    var update = (0, $denZA.useCallback)((next)=>{
        if (next === value) return;
        if (!isControlled) setValue(next.toString());
        onChangeProp == null || onChangeProp(next.toString(), $fe4ba998a748d4ed$var$parse(next));
    }, [
        onChangeProp,
        isControlled,
        value
    ]); // Function to clamp the value and round it to the precision
    var clamp = (0, $denZA.useCallback)((value)=>{
        var nextValue = value;
        if (keepWithinRange) nextValue = (0, $a2c5f30ccc79a99f$export$31ee16100cde6ce2)(nextValue, min, max);
        return (0, $a2c5f30ccc79a99f$export$3e91a10e66078270)(nextValue, precision);
    }, [
        precision,
        keepWithinRange,
        max,
        min
    ]);
    var increment = (0, $denZA.useCallback)(function(step) {
        if (step === void 0) step = stepProp;
        var next;
        /**
     * Let's follow the native browser behavior for
     * scenarios where the input starts empty ("")
     */ if (value === "") /**
       * If `min` is set, native input, starts at the `min`.
       * Else, it starts at `step`
       */ next = $fe4ba998a748d4ed$var$parse(step);
        else next = $fe4ba998a748d4ed$var$parse(value) + step;
        next = clamp(next);
        update(next);
    }, [
        clamp,
        stepProp,
        update,
        value
    ]);
    var decrement = (0, $denZA.useCallback)(function(step) {
        if (step === void 0) step = stepProp;
        var next; // Same thing here. We'll follow native implementation
        if (value === "") next = $fe4ba998a748d4ed$var$parse(-step);
        else next = $fe4ba998a748d4ed$var$parse(value) - step;
        next = clamp(next);
        update(next);
    }, [
        clamp,
        stepProp,
        update,
        value
    ]);
    var reset = (0, $denZA.useCallback)(()=>{
        var next;
        if (defaultValue == null) next = "";
        else {
            var _cast2;
            next = (_cast2 = $fe4ba998a748d4ed$var$cast(defaultValue, stepProp, precisionProp)) != null ? _cast2 : min;
        }
        update(next);
    }, [
        defaultValue,
        precisionProp,
        stepProp,
        update,
        min
    ]);
    var castValue = (0, $denZA.useCallback)((value)=>{
        var _cast3;
        var nextValue = (_cast3 = $fe4ba998a748d4ed$var$cast(value, stepProp, precision)) != null ? _cast3 : min;
        update(nextValue);
    }, [
        precision,
        stepProp,
        update,
        min
    ]);
    var valueAsNumber = $fe4ba998a748d4ed$var$parse(value);
    /**
   * Common range checks
   */ var isOutOfRange = valueAsNumber > max || valueAsNumber < min;
    var isAtMax = valueAsNumber === max;
    var isAtMin = valueAsNumber === min;
    return {
        isOutOfRange: isOutOfRange,
        isAtMax: isAtMax,
        isAtMin: isAtMin,
        precision: precision,
        value: value,
        valueAsNumber: valueAsNumber,
        update: update,
        reset: reset,
        increment: increment,
        decrement: decrement,
        clamp: clamp,
        cast: castValue,
        setValue: setValue
    };
}
function $fe4ba998a748d4ed$var$parse(value) {
    return parseFloat(value.toString().replace(/[^\w.-]+/g, ""));
}
function $fe4ba998a748d4ed$var$getDecimalPlaces(value, step) {
    return Math.max((0, $a2c5f30ccc79a99f$export$a42544f265f8403)(step), (0, $a2c5f30ccc79a99f$export$a42544f265f8403)(value));
}
function $fe4ba998a748d4ed$var$cast(value, step, precision) {
    var parsedValue = $fe4ba998a748d4ed$var$parse(value);
    if (Number.isNaN(parsedValue)) return undefined;
    var decimalPlaces = $fe4ba998a748d4ed$var$getDecimalPlaces(parsedValue, step);
    return (0, $a2c5f30ccc79a99f$export$3e91a10e66078270)(parsedValue, precision != null ? precision : decimalPlaces);
}






var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

function $025bbaad537bf795$export$f4b266cd2aae9cb1(callback, delay) {
    var fn = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(callback);
    $denZA.useEffect(()=>{
        var intervalId = null;
        var tick = ()=>fn();
        if (delay !== null) intervalId = window.setInterval(tick, delay);
        return ()=>{
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [
        delay,
        fn
    ]);
}



var $denZA = parcelRequire("denZA");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $4920b6964a8953cc$var$CONTINUOUS_CHANGE_INTERVAL = 50;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $4920b6964a8953cc$var$CONTINUOUS_CHANGE_DELAY = 300;
function $4920b6964a8953cc$export$21495182eeff761c(increment, decrement) {
    /**
   * To keep incrementing/decrementing on press, we call that `spinning`
   */ var [isSpinning, setIsSpinning] = (0, $denZA.useState)(false); // This state keeps track of the action ("increment" or "decrement")
    var [action, setAction] = (0, $denZA.useState)(null); // To increment the value the first time you mousedown, we call that `runOnce`
    var [runOnce, setRunOnce] = (0, $denZA.useState)(true); // Store the timeout instance id in a ref, so we can clear the timeout later
    var timeoutRef = (0, $denZA.useRef)(null); // Clears the timeout from memory
    var removeTimeout = ()=>clearTimeout(timeoutRef.current);
    /**
   * useInterval hook provides a performant way to
   * update the state value at specific interval
   */ (0, $025bbaad537bf795$export$f4b266cd2aae9cb1)(()=>{
        if (action === "increment") increment();
        if (action === "decrement") decrement();
    }, isSpinning ? $4920b6964a8953cc$var$CONTINUOUS_CHANGE_INTERVAL : null); // Function to activate the spinning and increment the value
    var up = (0, $denZA.useCallback)(()=>{
        // increment the first fime
        if (runOnce) increment();
         // after a delay, keep incrementing at interval ("spinning up")
        timeoutRef.current = setTimeout(()=>{
            setRunOnce(false);
            setIsSpinning(true);
            setAction("increment");
        }, $4920b6964a8953cc$var$CONTINUOUS_CHANGE_DELAY);
    }, [
        increment,
        runOnce
    ]); // Function to activate the spinning and increment the value
    var down = (0, $denZA.useCallback)(()=>{
        // decrement the first fime
        if (runOnce) decrement();
         // after a delay, keep decrementing at interval ("spinning down")
        timeoutRef.current = setTimeout(()=>{
            setRunOnce(false);
            setIsSpinning(true);
            setAction("decrement");
        }, $4920b6964a8953cc$var$CONTINUOUS_CHANGE_DELAY);
    }, [
        decrement,
        runOnce
    ]); // Function to stop spinng (useful for mouseup, keyup handlers)
    var stop = (0, $denZA.useCallback)(()=>{
        setRunOnce(true);
        setIsSpinning(false);
        removeTimeout();
    }, []);
    /**
   * If the component unmounts while spinning,
   * let's clear the timeout as well
   */ (0, $c29482a8d6079d59$export$f3a192d0cbd30b96)(removeTimeout);
    return {
        up: up,
        down: down,
        stop: stop
    };
}


var $dc5eb49a9b8e8e13$var$FLOATING_POINT_REGEX = /^[Ee0-9+\-.]$/;
function $dc5eb49a9b8e8e13$export$868f765f9ae08b3f(character) {
    return $dc5eb49a9b8e8e13$var$FLOATING_POINT_REGEX.test(character);
}
function $dc5eb49a9b8e8e13$export$f0391996ac5cc954(event) {
    if (event.key == null) return true;
    var isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
    if (isModifierKey) return true;
    var isSingleCharacterKey = event.key.length === 1;
    if (!isSingleCharacterKey) return true;
    return $dc5eb49a9b8e8e13$export$868f765f9ae08b3f(event.key);
}


function $5fb69da710f25218$var$_extends() {
    $5fb69da710f25218$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5fb69da710f25218$var$_extends.apply(this, arguments);
}
function $5fb69da710f25218$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5fb69da710f25218$var$sanitize = (value)=>value.split("").filter((0, $dc5eb49a9b8e8e13$export$868f765f9ae08b3f)).join("");
function $5fb69da710f25218$export$3456112c923afbf0(props) {
    if (props === void 0) props = {};
    var { focusInputOnChange: focusInputOnChange = true, clampValueOnBlur: clampValueOnBlur = true, keepWithinRange: keepWithinRange = true, min: min = (0, $a2c5f30ccc79a99f$export$79f1df30fb36b5), max: max = (0, $a2c5f30ccc79a99f$export$ab0cdf6ed4011946), step: stepProp = 1, isReadOnly: isReadOnly, isDisabled: isDisabled, isRequired: isRequired, getAriaValueText: getAriaValueText, isInvalid: isInvalid, pattern: pattern = "[0-9]*(.[0-9]+)?", inputMode: inputMode = "decimal", allowMouseWheel: allowMouseWheel, id: id, name: name, "aria-describedby": ariaDescBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, onFocus: onFocus, onBlur: onBlur } = props, htmlProps = $5fb69da710f25218$var$_objectWithoutPropertiesLoose(props, [
        "focusInputOnChange",
        "clampValueOnBlur",
        "keepWithinRange",
        "min",
        "max",
        "step",
        "isReadOnly",
        "isDisabled",
        "isRequired",
        "getAriaValueText",
        "isInvalid",
        "pattern",
        "inputMode",
        "allowMouseWheel",
        "id",
        "onChange",
        "precision",
        "name",
        "aria-describedby",
        "aria-label",
        "aria-labelledby",
        "onFocus",
        "onBlur"
    ]);
    var onFocusProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onFocus);
    var onBlurProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onBlur);
    var getAriaValueTextProp = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(getAriaValueText);
    /**
   * Leverage the `useCounter` hook since it provides
   * the functionality to `increment`, `decrement` and `update`
   * counter values
   */ var counter = (0, $fe4ba998a748d4ed$export$70c4067197c60e2d)(props);
    var { update: updateFn, increment: incrementFn, decrement: decrementFn } = counter;
    /**
   * Keep track of the focused state of the input,
   * so user can this to change the styles of the
   * `spinners`, maybe :)
   */ var [isFocused, setFocused] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var inputRef = $denZA.useRef(null);
    /**
   * Sync state with uncontrolled form libraries like `react-hook-form`.
   */ (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        var notInSync = inputRef.current.value != counter.value;
        if (notInSync) counter.setValue($5fb69da710f25218$var$sanitize(inputRef.current.value));
    }, []);
    var isInteractive = !(isReadOnly || isDisabled);
    var increment = $denZA.useCallback(function(step) {
        if (step === void 0) step = stepProp;
        if (isInteractive) incrementFn(step);
    }, [
        incrementFn,
        isInteractive,
        stepProp
    ]);
    var decrement = $denZA.useCallback(function(step) {
        if (step === void 0) step = stepProp;
        if (isInteractive) decrementFn(step);
    }, [
        decrementFn,
        isInteractive,
        stepProp
    ]);
    /**
   * Leverage the `useSpinner` hook to spin the input's value
   * when long press on the up and down buttons.
   *
   * This leverages `setInterval` internally
   */ var spinner = (0, $4920b6964a8953cc$export$21495182eeff761c)(increment, decrement);
    /**
   * The `onChange` handler filters out any character typed
   * that isn't floating point compatible.
   */ var onChange = $denZA.useCallback((event)=>{
        updateFn($5fb69da710f25218$var$sanitize(event.target.value));
    }, [
        updateFn
    ]);
    var onKeyDown = $denZA.useCallback((event)=>{
        /**
     * only allow valid numeric keys
     */ if (!(0, $dc5eb49a9b8e8e13$export$f0391996ac5cc954)(event)) event.preventDefault();
        /**
     * Keyboard Accessibility
     *
     * We want to increase or decrease the input's value
     * based on if the user the arrow keys.
     *
     * @see https://www.w3.org/TR/wai-aria-practices-1.1/#keyboard-interaction-17
     */ var stepFactor = getStepFactor(event) * stepProp;
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var keyMap = {
            ArrowUp: ()=>increment(stepFactor),
            ArrowDown: ()=>decrement(stepFactor),
            Home: ()=>updateFn(min),
            End: ()=>updateFn(max)
        };
        var action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        updateFn,
        decrement,
        increment,
        max,
        min,
        stepProp
    ]);
    var getStepFactor = (event)=>{
        var ratio = 1;
        if (event.metaKey || event.ctrlKey) ratio = 0.1;
        if (event.shiftKey) ratio = 10;
        return ratio;
    };
    /**
   * If user would like to use a human-readable representation
   * of the value, rather than the value itself they can pass `getAriaValueText`
   *
   * @see https://www.w3.org/TR/wai-aria-practices-1.1/#wai-aria-roles-states-and-properties-18
   * @see https://www.w3.org/TR/wai-aria-1.1/#aria-valuetext
   */ var ariaValueText = $denZA.useMemo(()=>{
        var text = getAriaValueTextProp == null ? void 0 : getAriaValueTextProp(counter.value);
        if (!(0, $6b74ef5ae6a56e47$export$630801d484da15df)(text)) return text;
        var defaultText = counter.value.toString(); // empty string is an invalid ARIA attribute value
        return !defaultText ? undefined : defaultText;
    }, [
        counter.value,
        getAriaValueTextProp
    ]);
    /**
   * Function that clamps the input's value on blur
   */ var validateAndClamp = $denZA.useCallback(()=>{
        var next = counter.value;
        if (next === "") return;
        if (counter.valueAsNumber < min) next = min;
        if (counter.valueAsNumber > max) next = max;
        /**
     * `counter.cast` does 2 things:
     *
     * - sanitize the value by using parseFloat and some Regex
     * - used to round value to computed precision or decimal points
     */ counter.cast(next);
    }, [
        counter,
        max,
        min
    ]);
    var onInputBlur = $denZA.useCallback(()=>{
        setFocused.off();
        if (clampValueOnBlur) validateAndClamp();
    }, [
        clampValueOnBlur,
        setFocused,
        validateAndClamp
    ]);
    var focusInput = $denZA.useCallback(()=>{
        if (focusInputOnChange) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(inputRef.current, {
            nextTick: true
        });
    }, [
        focusInputOnChange
    ]);
    var spinUp = $denZA.useCallback((event)=>{
        event.preventDefault();
        spinner.up();
        focusInput();
    }, [
        focusInput,
        spinner
    ]);
    var spinDown = $denZA.useCallback((event)=>{
        event.preventDefault();
        spinner.down();
        focusInput();
    }, [
        focusInput,
        spinner
    ]);
    var pointerDown = (0, $405775388fe7f58e$export$4e09c449d6c407f7) && !!document.documentElement.ontouchstart ? "onTouchStart" : "onMouseDown";
    (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)("wheel", (event)=>{
        var isInputFocused = document.activeElement === inputRef.current;
        if (!allowMouseWheel || !isInputFocused) return;
        event.preventDefault();
        var stepFactor = getStepFactor(event) * stepProp;
        var direction = Math.sign(event.deltaY);
        if (direction === -1) increment(stepFactor);
        else if (direction === 1) decrement(stepFactor);
    }, inputRef.current, {
        passive: false
    });
    var getIncrementButtonProps = $denZA.useCallback(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        var disabled = isDisabled || keepWithinRange && counter.isAtMax;
        return $5fb69da710f25218$var$_extends({}, props, {
            ref: ref,
            role: "button",
            tabIndex: -1,
            [pointerDown]: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props[pointerDown], spinUp),
            onMouseUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseUp, spinner.stop),
            onMouseLeave: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseUp, spinner.stop),
            onTouchEnd: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onTouchEnd, spinner.stop),
            disabled: disabled,
            "aria-disabled": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(disabled)
        });
    }, [
        pointerDown,
        counter.isAtMax,
        keepWithinRange,
        spinUp,
        spinner.stop,
        isDisabled
    ]);
    var getDecrementButtonProps = $denZA.useCallback(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        var disabled = isDisabled || keepWithinRange && counter.isAtMin;
        return $5fb69da710f25218$var$_extends({}, props, {
            ref: ref,
            role: "button",
            tabIndex: -1,
            [pointerDown]: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props[pointerDown], spinDown),
            onMouseLeave: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseLeave, spinner.stop),
            onMouseUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseUp, spinner.stop),
            onTouchEnd: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onTouchEnd, spinner.stop),
            disabled: disabled,
            "aria-disabled": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(disabled)
        });
    }, [
        pointerDown,
        counter.isAtMin,
        keepWithinRange,
        spinDown,
        spinner.stop,
        isDisabled
    ]);
    var getInputProps = $denZA.useCallback(function(props, ref) {
        var _props$readOnly, _props$readOnly2, _props$required, _props$required2;
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $5fb69da710f25218$var$_extends({
            name: name,
            inputMode: inputMode,
            type: "text",
            pattern: pattern,
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel,
            "aria-describedby": ariaDescBy,
            id: id,
            disabled: isDisabled
        }, props, {
            readOnly: (_props$readOnly = props.readOnly) != null ? _props$readOnly : isReadOnly,
            "aria-readonly": (_props$readOnly2 = props.readOnly) != null ? _props$readOnly2 : isReadOnly,
            "aria-required": (_props$required = props.required) != null ? _props$required : isRequired,
            required: (_props$required2 = props.required) != null ? _props$required2 : isRequired,
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(inputRef, ref),
            value: counter.value,
            role: "spinbutton",
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": Number.isNaN(counter.valueAsNumber) ? undefined : counter.valueAsNumber,
            "aria-invalid": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isInvalid != null ? isInvalid : counter.isOutOfRange),
            "aria-valuetext": ariaValueText,
            autoComplete: "off",
            autoCorrect: "off",
            onChange: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onChange, onChange),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, onFocusProp, setFocused.on),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, onBlurProp, onInputBlur)
        });
    }, [
        name,
        inputMode,
        pattern,
        ariaLabelledBy,
        ariaLabel,
        ariaDescBy,
        id,
        isDisabled,
        isRequired,
        isReadOnly,
        isInvalid,
        counter.value,
        counter.valueAsNumber,
        counter.isOutOfRange,
        min,
        max,
        ariaValueText,
        onChange,
        onKeyDown,
        onFocusProp,
        setFocused.on,
        onBlurProp,
        onInputBlur
    ]);
    return {
        value: counter.value,
        valueAsNumber: counter.valueAsNumber,
        isFocused: isFocused,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        getIncrementButtonProps: getIncrementButtonProps,
        getDecrementButtonProps: getDecrementButtonProps,
        getInputProps: getInputProps,
        htmlProps: htmlProps
    };
}






var $denZA = parcelRequire("denZA");




var $f221a8059129931c$var$__assign = undefined && undefined.__assign || function() {
    $f221a8059129931c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f221a8059129931c$var$__assign.apply(this, arguments);
};
var $f221a8059129931c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f221a8059129931c$export$6bf0cd3a219bbade = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'md' : _b, isFullWidth = _a.isFullWidth, isInvalid = _a.isInvalid, rest = $f221a8059129931c$var$__rest(_a, [
        "children",
        "size",
        "isFullWidth",
        "isInvalid"
    ]);
    var variant = isFullWidth ? 'full' : 'plain';
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('NumberInput', $f221a8059129931c$var$__assign({
        size: size,
        variant: variant
    }, rest));
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(rest);
    var controlProps = (0, $a9ca37b5c0c19e69$export$1819803dd567b95f)(ownProps);
    var context = (0, $5fb69da710f25218$export$3456112c923afbf0)(controlProps);
    var ctx = $denZA.useMemo(function() {
        return context;
    }, [
        context
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    return $denZA.createElement((0, $e0fedb6c87db5ce1$export$276476f8af208fda), {
        value: ctx
    }, $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        __css: $f221a8059129931c$var$__assign({
            zIndex: 0
        }, styles.container),
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('chakra-numberinput'),
        ref: ref
    }, validChildren.map(function(child) {
        return $denZA.cloneElement(child, $f221a8059129931c$var$__assign({
            size: size,
            isInvalid: isInvalid
        }, child.props));
    }))));
});
$f221a8059129931c$export$6bf0cd3a219bbade.Decrement = (0, $14d47333e9862f49$export$9ee95a8b1ce70b74);
$f221a8059129931c$export$6bf0cd3a219bbade.Increment = (0, $b1138ec9c74892d8$export$dca82b6d540ba016);
$f221a8059129931c$export$6bf0cd3a219bbade.Field = (0, $2384a144d30b1924$export$8eabdd1cd59b4b71);


var $96d91808b75ad817$export$9ee95a8b1ce70b74 = (0, $14d47333e9862f49$export$9ee95a8b1ce70b74);
var $96d91808b75ad817$export$dca82b6d540ba016 = (0, $b1138ec9c74892d8$export$dca82b6d540ba016);
var $96d91808b75ad817$export$8eabdd1cd59b4b71 = (0, $2384a144d30b1924$export$8eabdd1cd59b4b71);







var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");
var $37e898f96140355d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $37e898f96140355d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $37e898f96140355d$export$8302fb64fcdab778;
(function(PaginationAction) {
    PaginationAction["Next"] = "Next";
    PaginationAction["Prev"] = "Prev";
    PaginationAction["First"] = "First";
    PaginationAction["Last"] = "Last";
})($37e898f96140355d$export$8302fb64fcdab778 || ($37e898f96140355d$export$8302fb64fcdab778 = {}));
var $37e898f96140355d$var$itemsAmout = 7;
var $37e898f96140355d$var$startEndAmount = 4;
var $37e898f96140355d$export$f80c710216eae131 = function(_a) {
    var page = _a.page, totalPages = _a.totalPages, nextLabel = _a.nextLabel, prevLabel = _a.prevLabel, _b = _a.lastLabel, lastLabel = _b === void 0 ? 'Last' : _b, _c = _a.firstLabel, firstLabel = _c === void 0 ? 'First' : _c, _d = _a.showLabel, showLabel = _d === void 0 ? true : _d, onPageClick = _a.onPageClick, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e;
    var _f = $37e898f96140355d$var$__read($denZA.useState(page), 2), currentPage = _f[0], setCurrentPage = _f[1];
    var onClick = function(clickedPage) {
        setCurrentPage(clickedPage);
    };
    var onNavigationClick = function(action) {
        switch(action){
            case $37e898f96140355d$export$8302fb64fcdab778.First:
                setCurrentPage(1);
                break;
            case $37e898f96140355d$export$8302fb64fcdab778.Last:
                setCurrentPage(totalPages);
                break;
            case $37e898f96140355d$export$8302fb64fcdab778.Next:
                setCurrentPage(function(prev) {
                    return prev !== totalPages ? ++prev : prev;
                });
                break;
            case $37e898f96140355d$export$8302fb64fcdab778.Prev:
                setCurrentPage(function(prev) {
                    return prev !== 1 ? --prev : prev;
                });
                break;
        }
    };
    $denZA.useLayoutEffect(function() {
        onPageClick === null || onPageClick === void 0 || onPageClick(currentPage);
    }, [
        currentPage
    ]);
    var fullLayout = function() {
        var items = [];
        for(var index = 1; index <= totalPages; index++)items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page,
                isDisabled: isDisabled
            }
        ], false);
        return items;
    };
    var edgeLayout = function() {
        var items = [];
        if (page > totalPages - $37e898f96140355d$var$startEndAmount) {
            items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
                {
                    key: 1,
                    onClick: onClick,
                    page: 1,
                    isDisabled: isDisabled
                }
            ], false);
            items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0,
                    isDisabled: isDisabled
                }
            ], false);
        }
        for(var index = 1; index <= 5; index++){
            var itemPage = page <= 4 ? index : totalPages - 5 + index;
            var isSelected = itemPage === page;
            items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
                {
                    key: itemPage,
                    onClick: onClick,
                    page: itemPage,
                    isSelected: isSelected,
                    isDisabled: isDisabled
                }
            ], false);
        }
        if (page <= $37e898f96140355d$var$startEndAmount) {
            items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
                {
                    isEllipsis: true,
                    key: Math.random(),
                    page: 0,
                    isDisabled: isDisabled
                }
            ], false);
            items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
                {
                    key: totalPages,
                    onClick: onClick,
                    page: totalPages,
                    isDisabled: isDisabled
                }
            ], false);
        }
        return items;
    };
    var middleLayout = function() {
        var items = [];
        items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                key: 1,
                onClick: onClick,
                page: 1,
                isDisabled: isDisabled
            }
        ], false);
        items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0,
                isDisabled: isDisabled
            }
        ], false);
        for(var index = page - 1; index < page + 2; index++)items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                key: index,
                onClick: onClick,
                page: index,
                isSelected: index === page,
                isDisabled: isDisabled
            }
        ], false);
        items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                isEllipsis: true,
                key: Math.random(),
                page: 0,
                isDisabled: isDisabled
            }
        ], false);
        items = $37e898f96140355d$var$__spreadArray($37e898f96140355d$var$__spreadArray([], $37e898f96140355d$var$__read(items), false), [
            {
                key: totalPages,
                onClick: onClick,
                page: totalPages,
                isDisabled: isDisabled
            }
        ], false);
        return items;
    };
    var getPaginationItems = $denZA.useCallback(function() {
        if (totalPages <= $37e898f96140355d$var$itemsAmout) return fullLayout();
        if (page > $37e898f96140355d$var$startEndAmount && page <= totalPages - $37e898f96140355d$var$startEndAmount) return middleLayout();
        return edgeLayout();
    }, [
        page,
        totalPages
    ]);
    var getNavigation = function() {
        return {
            prev: function() {
                return {
                    'aria-label': prevLabel,
                    disabled: page === 1 || isDisabled,
                    icon: $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                        as: (0, $e028bfb9028bef16$export$ea9a5c7ec18f8eaf),
                        fontSize: '.75em'
                    }),
                    label: showLabel ? prevLabel : '',
                    navAction: $37e898f96140355d$export$8302fb64fcdab778.Prev,
                    onClick: onNavigationClick,
                    size: 'sm',
                    variant: 'ghost'
                };
            },
            next: function() {
                return {
                    'aria-label': nextLabel,
                    disabled: page === totalPages || isDisabled,
                    icon: $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                        as: (0, $bb6a2cf1a1123128$export$d6d021d74f4bac76),
                        fontSize: '.75em'
                    }),
                    label: showLabel ? nextLabel : '',
                    navAction: $37e898f96140355d$export$8302fb64fcdab778.Next,
                    onClick: onNavigationClick,
                    size: 'sm',
                    variant: 'ghost'
                };
            },
            first: function() {
                return {
                    'aria-label': firstLabel,
                    disabled: page === 1 || isDisabled,
                    icon: $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                        as: (0, $e028bfb9028bef16$export$ea9a5c7ec18f8eaf),
                        fontSize: '.75em'
                    }),
                    label: showLabel ? firstLabel : '',
                    navAction: $37e898f96140355d$export$8302fb64fcdab778.First,
                    onClick: onNavigationClick,
                    size: 'sm',
                    variant: 'ghost'
                };
            },
            last: function() {
                return {
                    'aria-label': lastLabel,
                    disabled: page === totalPages || isDisabled,
                    icon: $denZA.createElement((0, $3b756bd9f7dda047$export$f04a61298a47a40f), {
                        as: (0, $bb6a2cf1a1123128$export$d6d021d74f4bac76),
                        fontSize: '.75em'
                    }),
                    label: showLabel ? lastLabel : '',
                    navAction: $37e898f96140355d$export$8302fb64fcdab778.Last,
                    onClick: onNavigationClick,
                    size: 'sm',
                    variant: 'ghost'
                };
            }
        };
    };
    return {
        getPaginationItems: getPaginationItems,
        getNavigation: getNavigation
    };
};


var $b2b76623517a075d$var$__assign = undefined && undefined.__assign || function() {
    $b2b76623517a075d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2b76623517a075d$var$__assign.apply(this, arguments);
};
var $b2b76623517a075d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b2b76623517a075d$export$68f5e1453c188a82 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _a = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), showFirstLast = _a.showFirstLast, rest = $b2b76623517a075d$var$__rest(_a, [
        "showFirstLast"
    ]);
    var _b = (0, $37e898f96140355d$export$f80c710216eae131)($b2b76623517a075d$var$__assign({}, props)), getPaginationItems = _b.getPaginationItems, getNavigation = _b.getNavigation;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Pagination', props);
    var renderFirstButton = function() {
        var _a = getNavigation().first(), label = _a.label, onClick = _a.onClick, navAction = _a.navAction, restProps = $b2b76623517a075d$var$__rest(_a, [
            "label",
            "onClick",
            "navAction"
        ]);
        return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps), label);
    };
    var renderLastButton = function() {
        var _a = getNavigation().last(), label = _a.label, onClick = _a.onClick, navAction = _a.navAction, restProps = $b2b76623517a075d$var$__rest(_a, [
            "label",
            "onClick",
            "navAction"
        ]);
        return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps), label);
    };
    var renderPrevButton = function() {
        var _a = getNavigation().prev(), onClick = _a.onClick, navAction = _a.navAction, label = _a.label, restProps = $b2b76623517a075d$var$__rest(_a, [
            "onClick",
            "navAction",
            "label"
        ]);
        if (label) return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps), label);
        return $denZA.createElement((0, $ff0be911914f8500$export$c25acd513dcc8062), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps));
    };
    var renderNextButton = function() {
        var _a = getNavigation().next(), onClick = _a.onClick, navAction = _a.navAction, label = _a.label, restProps = $b2b76623517a075d$var$__rest(_a, [
            "onClick",
            "navAction",
            "label"
        ]);
        if (label) return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps), label);
        return $denZA.createElement((0, $ff0be911914f8500$export$c25acd513dcc8062), $b2b76623517a075d$var$__assign({
            onClick: function() {
                return void onClick(navAction);
            },
            sx: styles.buttons
        }, restProps));
    };
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).ol, $b2b76623517a075d$var$__assign({
        "aria-label": "pagination navigation",
        ref: ref,
        sx: styles.container
    }, rest), showFirstLast && renderFirstButton(), renderPrevButton(), getPaginationItems().map(function(_a) {
        var key = _a.key, page = _a.page, isEllipsis = _a.isEllipsis, isSelected = _a.isSelected, onClick = _a.onClick, item = $b2b76623517a075d$var$__rest(_a, [
            "key",
            "page",
            "isEllipsis",
            "isSelected",
            "onClick"
        ]);
        if (isEllipsis) return $denZA.createElement((0, $bb74813ab2db5cc9$export$2a4143257785f953), {
            key: key,
            verticalAlign: "-webkit-baseline-middle"
        });
        return $denZA.createElement((0, $e032547b364b9976$export$353f5b6fc5456de1), $b2b76623517a075d$var$__assign({
            borderRadius: "full",
            isActive: isSelected,
            key: key,
            onClick: function() {
                if (!onClick) return;
                onClick(page);
            },
            size: "sm",
            sx: styles.buttons,
            variant: "ghost"
        }, item), page);
    }), renderNextButton(), showFirstLast && renderLastButton());
});








var $denZA = parcelRequire("denZA");

var [$5bb47b18e0719d4a$export$bf694c7c431c162a, $5bb47b18e0719d4a$export$1468d0761b26e6c8] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});





var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");

function $5a37f3d0ded9a598$var$_extends() {
    $5a37f3d0ded9a598$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a37f3d0ded9a598$var$_extends.apply(this, arguments);
}
var $5a37f3d0ded9a598$var$mergeVariants = (variants)=>{
    if (!variants) return;
    return (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(variants, {
        enter: {
            visibility: "visible"
        },
        exit: {
            transitionEnd: {
                visibility: "hidden"
            }
        }
    });
};
var $5a37f3d0ded9a598$var$scaleFade = {
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: {
            duration: 0.1,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: 0.15,
            ease: [
                0,
                0,
                0.2,
                1
            ]
        }
    }
};
var $5a37f3d0ded9a598$var$Section = (0, $92af15db400e8627$export$e25e478948902b8b)((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).section);
var $5a37f3d0ded9a598$export$295130c75b678e2c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).forwardRef((props, ref)=>{
    var { isOpen: isOpen } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($5a37f3d0ded9a598$var$Section, $5a37f3d0ded9a598$var$_extends({
        ref: ref,
        variants: $5a37f3d0ded9a598$var$mergeVariants(props.variants)
    }, props, {
        initial: false,
        animate: isOpen ? "enter" : "exit"
    }));
});
$5a37f3d0ded9a598$export$295130c75b678e2c.defaultProps = {
    variants: $5a37f3d0ded9a598$var$scaleFade
};



function $e2625ba0d517c946$var$getUserAgentBrowser(navigator) {
    var { userAgent: ua, vendor: vendor } = navigator;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $e2625ba0d517c946$var$getUserAgentOS(navigator) {
    var { userAgent: ua, platform: platform } = navigator;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $e2625ba0d517c946$export$568a7d21694b4b32(navigator) {
    var { userAgent: ua } = navigator;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $e2625ba0d517c946$export$3070bd282ec37ea8(os) {
    if (!(0, $405775388fe7f58e$export$4e09c449d6c407f7)) return false;
    return $e2625ba0d517c946$var$getUserAgentOS(window.navigator) === os;
}
function $e2625ba0d517c946$export$2d31490a0c05f094(browser) {
    if (!(0, $405775388fe7f58e$export$4e09c449d6c407f7)) return false;
    return $e2625ba0d517c946$var$getUserAgentBrowser(window.navigator) === browser;
}
function $e2625ba0d517c946$export$8d04c8cf4d9e22d8() {
    if (!(0, $405775388fe7f58e$export$4e09c449d6c407f7)) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}


/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ /**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ 
function $0e5c6dfd5476a82a$export$764db16956f554f8(event) {
    var win = (0, $405775388fe7f58e$export$8d16348623687f6)(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $0e5c6dfd5476a82a$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $0e5c6dfd5476a82a$var$filterPrimaryPointer(eventHandler) {
    return (event)=>{
        var win = (0, $405775388fe7f58e$export$8d16348623687f6)(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $0e5c6dfd5476a82a$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $0e5c6dfd5476a82a$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $0e5c6dfd5476a82a$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $0e5c6dfd5476a82a$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $0e5c6dfd5476a82a$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $0e5c6dfd5476a82a$export$c4dfce035d43d1e0(event) ? $0e5c6dfd5476a82a$var$pointFromTouch(event, pointType) : $0e5c6dfd5476a82a$var$pointFromMouse(event, pointType)
    };
}
function $0e5c6dfd5476a82a$export$750e59ed656e0503(event) {
    return $0e5c6dfd5476a82a$export$12f84bb882d06e1a(event, "client");
}
var $0e5c6dfd5476a82a$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = (event)=>handler(event, $0e5c6dfd5476a82a$export$12f84bb882d06e1a(event));
    return shouldFilterPrimaryPointer ? $0e5c6dfd5476a82a$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $0e5c6dfd5476a82a$var$supportsPointerEvents = ()=>(0, $405775388fe7f58e$export$4e09c449d6c407f7) && window.onpointerdown === null;
var $0e5c6dfd5476a82a$var$supportsTouchEvents = ()=>(0, $405775388fe7f58e$export$4e09c449d6c407f7) && window.ontouchstart === null;
var $0e5c6dfd5476a82a$var$supportsMouseEvents = ()=>(0, $405775388fe7f58e$export$4e09c449d6c407f7) && window.onmousedown === null;
var $0e5c6dfd5476a82a$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $0e5c6dfd5476a82a$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $0e5c6dfd5476a82a$export$9fd5832907e02451(name) {
    if ($0e5c6dfd5476a82a$var$supportsPointerEvents()) return name;
    if ($0e5c6dfd5476a82a$var$supportsTouchEvents()) return $0e5c6dfd5476a82a$var$touchEventNames[name];
    if ($0e5c6dfd5476a82a$var$supportsMouseEvents()) return $0e5c6dfd5476a82a$var$mouseEventNames[name];
    return name;
}
function $0e5c6dfd5476a82a$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $405775388fe7f58e$export$b1d829ddf82884aa)(target, $0e5c6dfd5476a82a$export$9fd5832907e02451(eventName), $0e5c6dfd5476a82a$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $0e5c6dfd5476a82a$export$d06464d6b74eedc4(event) {
    return $0e5c6dfd5476a82a$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}



function $6e90b764fb6292b1$export$734d04395f5243cd(env, eventName, handler, options) {
    return (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)((0, $0e5c6dfd5476a82a$export$9fd5832907e02451)(eventName), (0, $0e5c6dfd5476a82a$export$bbdebe8fd38d1ea3)(handler, eventName === "pointerdown"), env, options);
}


function $f969e6bbe8e3ea1f$export$16a61b931588d888(props) {
    var { ref: ref, elements: elements, enabled: enabled } = props;
    var isSafari = (0, $e2625ba0d517c946$export$2d31490a0c05f094)("Safari");
    var doc = ()=>(0, $405775388fe7f58e$export$b204af158042fbac)(ref.current);
    (0, $6e90b764fb6292b1$export$734d04395f5243cd)(doc, "pointerdown", (event)=>{
        if (!isSafari || !enabled) return;
        var target = event.target;
        var els = elements != null ? elements : [
            ref
        ];
        var isValidTarget = els.some((elementOrRef)=>{
            var el = (0, $6b74ef5ae6a56e47$export$dedd81df7bc1307)(elementOrRef) ? elementOrRef.current : elementOrRef;
            return (0, $405775388fe7f58e$export$2344b14b097df817)(el, target);
        });
        if (!(0, $e8db4866fc051e33$export$8a2eb51c14bb8899)(target) && isValidTarget) {
            event.preventDefault();
            (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(target);
        }
    });
}



var $denZA = parcelRequire("denZA");


var $530f14fc4e49647e$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $530f14fc4e49647e$export$54b5c2a5755195e7(target, options) {
    if (options === void 0) options = $530f14fc4e49647e$var$defaultOptions;
    var { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    var element = (0, $6b74ef5ae6a56e47$export$dedd81df7bc1307)(target) ? target.current : target;
    var autoFocus = shouldFocus && visible;
    var onFocus = (0, $denZA.useCallback)(()=>{
        if (!element || !autoFocus) return;
        if ((0, $405775388fe7f58e$export$2344b14b097df817)(element, document.activeElement)) return;
        if (focusRef != null && focusRef.current) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(focusRef.current, {
            preventScroll: preventScroll,
            nextTick: true
        });
        else {
            var tabbableEls = (0, $b09854f7e168ef4c$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(tabbableEls[0], {
                preventScroll: preventScroll,
                nextTick: true
            });
        }
    }, [
        autoFocus,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)("transitionend", onFocus, element);
}






var $denZA = parcelRequire("denZA");
function $b56424e587fa1e99$var$_extends() {
    $b56424e587fa1e99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b56424e587fa1e99$var$_extends.apply(this, arguments);
}
function $b56424e587fa1e99$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b56424e587fa1e99$var$TRIGGER = {
    click: "click",
    hover: "hover"
};
function $b56424e587fa1e99$export$542a6fd13ac93354(props) {
    if (props === void 0) props = {};
    var { closeOnBlur: closeOnBlur = true, closeOnEsc: closeOnEsc = true, initialFocusRef: initialFocusRef, id: id, returnFocusOnClose: returnFocusOnClose = true, autoFocus: autoFocus = true, arrowSize: arrowSize, arrowShadowColor: arrowShadowColor, trigger: trigger = $b56424e587fa1e99$var$TRIGGER.click, openDelay: openDelay = 200, closeDelay: closeDelay = 200, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", computePositionOnMount: computePositionOnMount } = props, popperProps = $b56424e587fa1e99$var$_objectWithoutPropertiesLoose(props, [
        "closeOnBlur",
        "closeOnEsc",
        "initialFocusRef",
        "id",
        "returnFocusOnClose",
        "autoFocus",
        "arrowSize",
        "arrowShadowColor",
        "trigger",
        "openDelay",
        "closeDelay",
        "isLazy",
        "lazyBehavior",
        "computePositionOnMount"
    ]);
    var { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $528efd7f0c9e3374$export$6e3e27031a30522f)(props);
    var triggerRef = (0, $denZA.useRef)(null);
    var popoverRef = (0, $denZA.useRef)(null);
    var isHoveringRef = (0, $denZA.useRef)(false);
    var hasBeenOpened = (0, $denZA.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    var [hasHeader, setHasHeader] = (0, $denZA.useState)(false);
    var [hasBody, setHasBody] = (0, $denZA.useState)(false);
    var [triggerId, popoverId, headerId, bodyId] = (0, $63207b263e1aef60$export$365c04e2f432779)(id, "popover-trigger", "popover-content", "popover-header", "popover-body");
    var { referenceRef: referenceRef, getArrowProps: getArrowProps, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, forceUpdate: forceUpdate } = (0, $e0cfb75a998fb7e2$export$f4d5bf230a36dd6e)($b56424e587fa1e99$var$_extends({}, popperProps, {
        enabled: isOpen || computePositionOnMount
    }));
    (0, $f969e6bbe8e3ea1f$export$16a61b931588d888)({
        enabled: isOpen,
        ref: triggerRef
    });
    (0, $24f8a6fb2f29f586$export$68b323438c1fbb28)(popoverRef, {
        focusRef: triggerRef,
        visible: isOpen,
        shouldFocus: returnFocusOnClose && trigger === $b56424e587fa1e99$var$TRIGGER.click
    });
    (0, $530f14fc4e49647e$export$54b5c2a5755195e7)(popoverRef, {
        focusRef: initialFocusRef,
        visible: isOpen,
        shouldFocus: autoFocus && trigger === $b56424e587fa1e99$var$TRIGGER.click
    });
    var shouldRenderChildren = (0, $5567c7a86419f354$export$1f16c1e83f5de19d)({
        hasBeenSelected: hasBeenOpened.current,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        isSelected: isOpen
    });
    var getPopoverProps = (0, $denZA.useCallback)(function(props, _ref) {
        if (props === void 0) props = {};
        if (_ref === void 0) _ref = null;
        var popoverProps = $b56424e587fa1e99$var$_extends({}, props, {
            style: $b56424e587fa1e99$var$_extends({}, props.style, {
                transformOrigin: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).transformOrigin.varRef,
                [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? (0, $b0d64feb46216e43$export$91c0eda1d06bf008)(arrowSize) : undefined,
                [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            }),
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(popoverRef, _ref),
            children: shouldRenderChildren ? props.children : null,
            id: popoverId,
            tabIndex: -1,
            role: "dialog",
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, (event)=>{
                if (closeOnEsc && event.key === "Escape") onClose();
            }),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, (event)=>{
                var relatedTarget = (0, $405775388fe7f58e$export$a7a83d2a1d2d9e91)(event);
                var targetIsPopover = (0, $405775388fe7f58e$export$2344b14b097df817)(popoverRef.current, relatedTarget);
                var targetIsTrigger = (0, $405775388fe7f58e$export$2344b14b097df817)(triggerRef.current, relatedTarget);
                var isValidBlur = !targetIsPopover && !targetIsTrigger;
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            }),
            "aria-labelledby": hasHeader ? headerId : undefined,
            "aria-describedby": hasBody ? bodyId : undefined
        });
        if (trigger === $b56424e587fa1e99$var$TRIGGER.hover) {
            popoverProps.role = "tooltip";
            popoverProps.onMouseEnter = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseEnter, ()=>{
                isHoveringRef.current = true;
            });
            popoverProps.onMouseLeave = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseLeave, ()=>{
                isHoveringRef.current = false;
                setTimeout(onClose, closeDelay);
            });
        }
        return popoverProps;
    }, [
        shouldRenderChildren,
        popoverId,
        hasHeader,
        headerId,
        hasBody,
        bodyId,
        trigger,
        closeOnEsc,
        onClose,
        isOpen,
        closeOnBlur,
        closeDelay,
        arrowShadowColor,
        arrowSize
    ]);
    var getPopoverPositionerProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return getPopperProps($b56424e587fa1e99$var$_extends({}, props, {
            style: $b56424e587fa1e99$var$_extends({
                visibility: isOpen ? "visible" : "hidden"
            }, props.style)
        }), forwardedRef);
    }, [
        isOpen,
        getPopperProps
    ]);
    var openTimeout = (0, $denZA.useRef)();
    var closeTimeout = (0, $denZA.useRef)();
    var getTriggerProps = (0, $denZA.useCallback)(function(props, _ref) {
        if (props === void 0) props = {};
        if (_ref === void 0) _ref = null;
        var triggerProps = $b56424e587fa1e99$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(triggerRef, _ref, referenceRef),
            id: triggerId,
            "aria-haspopup": "dialog",
            "aria-expanded": isOpen,
            "aria-controls": popoverId
        });
        if (trigger === $b56424e587fa1e99$var$TRIGGER.click) triggerProps.onClick = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onToggle);
        if (trigger === $b56424e587fa1e99$var$TRIGGER.hover) {
            /**
       * Any content that shows on pointer hover should also show on keyboard focus.
       * Consider focus and blur to be the `hover` for keyboard users.
       *
       * @see https://www.w3.org/WAI/WCAG21/Understanding/content-on-hover-or-focus.html
       */ triggerProps.onFocus = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, onOpen);
            triggerProps.onBlur = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, onClose);
            /**
       * Any content that shows on hover or focus must be dismissible.
       * This case pressing `Escape` will dismiss the popover
       */ triggerProps.onKeyDown = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, (event)=>{
                if (event.key === "Escape") onClose();
            });
            triggerProps.onMouseEnter = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseEnter, ()=>{
                isHoveringRef.current = true;
                openTimeout.current = window.setTimeout(onOpen, openDelay);
            });
            triggerProps.onMouseLeave = (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseLeave, ()=>{
                isHoveringRef.current = false;
                if (openTimeout.current) {
                    clearTimeout(openTimeout.current);
                    openTimeout.current = undefined;
                }
                closeTimeout.current = window.setTimeout(()=>{
                    if (isHoveringRef.current === false) onClose();
                }, closeDelay);
            });
        }
        return triggerProps;
    }, [
        triggerId,
        isOpen,
        popoverId,
        trigger,
        referenceRef,
        onToggle,
        onOpen,
        onClose,
        openDelay,
        closeDelay
    ]);
    (0, $denZA.useEffect)(()=>{
        return ()=>{
            if (openTimeout.current) clearTimeout(openTimeout.current);
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
        };
    }, []);
    var getHeaderProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $b56424e587fa1e99$var$_extends({}, props, {
            id: headerId,
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, (node)=>{
                setHasHeader(!!node);
            })
        });
    }, [
        headerId
    ]);
    var getBodyProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $b56424e587fa1e99$var$_extends({}, props, {
            id: bodyId,
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, (node)=>{
                setHasBody(!!node);
            })
        });
    }, [
        bodyId
    ]);
    return {
        forceUpdate: forceUpdate,
        isOpen: isOpen,
        onClose: onClose,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getPopoverPositionerProps: getPopoverPositionerProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getHeaderProps: getHeaderProps,
        getBodyProps: getBodyProps
    };
}


function $6266b7002872936e$var$_extends() {
    $6266b7002872936e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6266b7002872936e$var$_extends.apply(this, arguments);
}
function $6266b7002872936e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6266b7002872936e$export$5b6b19405a83ff9d = (props)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Popover", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children } = _omitThemingProps, rest = $6266b7002872936e$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children"
    ]);
    var context = (0, $b56424e587fa1e99$export$542a6fd13ac93354)(rest);
    return /*#__PURE__*/ $denZA.createElement((0, $5bb47b18e0719d4a$export$bf694c7c431c162a), {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, (0, $da6e679e22b3b02c$export$624e501d81f5ffce)(children, {
        isOpen: context.isOpen,
        onClose: context.onClose,
        forceUpdate: context.forceUpdate
    })));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$5b6b19405a83ff9d.displayName = "Popover";
var $6266b7002872936e$export$7dacb05d26466c3 = (props)=>{
    // enforce a single child
    var child = $denZA.Children.only(props.children);
    var { getTriggerProps: getTriggerProps } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    return /*#__PURE__*/ $denZA.cloneElement(child, getTriggerProps(child.props, child.ref));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$7dacb05d26466c3.displayName = "PopoverTrigger";
var $6266b7002872936e$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { rootProps: rootProps } = props, contentProps = $6266b7002872936e$var$_objectWithoutPropertiesLoose(props, [
        "rootProps"
    ]);
    var { getPopoverProps: getPopoverProps, getPopoverPositionerProps: getPopoverPositionerProps } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var contentStyles = $6266b7002872936e$var$_extends({
        position: "relative",
        display: "flex",
        flexDirection: "column"
    }, styles.content);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $6266b7002872936e$var$_extends({}, getPopoverPositionerProps(rootProps), {
        __css: styles.popper,
        className: "chakra-popover__popper"
    }), /*#__PURE__*/ $denZA.createElement((0, $5a37f3d0ded9a598$export$295130c75b678e2c), $6266b7002872936e$var$_extends({}, getPopoverProps(contentProps, ref), {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-popover__content", props.className),
        __css: contentStyles
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$d7e1f420b25549ff.displayName = "PopoverContent";
var $6266b7002872936e$export$24cbcada8f546cfe = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getHeaderProps: getHeaderProps } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).header, $6266b7002872936e$var$_extends({}, getHeaderProps(props, ref), {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-popover__header", props.className),
        __css: styles.header
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$24cbcada8f546cfe.displayName = "PopoverHeader";
var $6266b7002872936e$export$472ec417bca1d382 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getBodyProps: getBodyProps } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $6266b7002872936e$var$_extends({}, getBodyProps(props, ref), {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-popover__body", props.className),
        __css: styles.body
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$472ec417bca1d382.displayName = "PopoverBody";
var $6266b7002872936e$export$18083345862c6206 = (props)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).footer, $6266b7002872936e$var$_extends({}, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-popover__footer", props.className),
        __css: styles.footer
    }));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$18083345862c6206.displayName = "PopoverFooter";
var $6266b7002872936e$export$4c88dacf86a15877 = (props)=>{
    var { onClose: onClose } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    return /*#__PURE__*/ $denZA.createElement((0, $16e5382b11479a26$export$de65de8213222d10), $6266b7002872936e$var$_extends({
        size: "sm",
        onClick: onClose,
        position: "absolute",
        borderRadius: "md",
        top: "0.25rem",
        insetEnd: "0.5rem",
        padding: "0.5rem"
    }, props));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$4c88dacf86a15877.displayName = "PopoverCloseButton";
var $6266b7002872936e$export$3152841115e061b2 = (props)=>{
    var _ref;
    var { bg: bg, bgColor: bgColor, backgroundColor: backgroundColor } = props;
    var { getArrowProps: getArrowProps, getArrowInnerProps: getArrowInnerProps } = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var arrowBg = (_ref = bg != null ? bg : bgColor) != null ? _ref : backgroundColor;
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $6266b7002872936e$var$_extends({}, getArrowProps(), {
        className: "chakra-popover__arrow-positioner"
    }), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $6266b7002872936e$var$_extends({
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-popover__arrow", props.className)
    }, getArrowInnerProps(props), {
        __css: $6266b7002872936e$var$_extends({}, styles.arrow, {
            "--popper-arrow-bg": arrowBg ? "colors." + arrowBg + ", " + arrowBg : undefined
        })
    })));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $6266b7002872936e$export$3152841115e061b2.displayName = "PopoverArrow";



var $denZA = parcelRequire("denZA");
var $90260531033b51de$var$__assign = undefined && undefined.__assign || function() {
    $90260531033b51de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90260531033b51de$var$__assign.apply(this, arguments);
};
var $90260531033b51de$export$3152841115e061b2 = function(props) {
    return $denZA.createElement((0, $6266b7002872936e$export$3152841115e061b2), $90260531033b51de$var$__assign({}, props));
};





var $denZA = parcelRequire("denZA");
var $7d8af7dc5d3b87e9$var$__assign = undefined && undefined.__assign || function() {
    $7d8af7dc5d3b87e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d8af7dc5d3b87e9$var$__assign.apply(this, arguments);
};
var $7d8af7dc5d3b87e9$export$472ec417bca1d382 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6266b7002872936e$export$472ec417bca1d382), $7d8af7dc5d3b87e9$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $b9952c2737ea2b25$var$__assign = undefined && undefined.__assign || function() {
    $b9952c2737ea2b25$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b9952c2737ea2b25$var$__assign.apply(this, arguments);
};
var $b9952c2737ea2b25$export$4c88dacf86a15877 = function(props) {
    var onClose = (0, $5bb47b18e0719d4a$export$1468d0761b26e6c8)().onClose;
    return $denZA.createElement((0, $be26eda9b41db083$export$de65de8213222d10), $b9952c2737ea2b25$var$__assign({
        onClick: onClose,
        position: "absolute",
        right: "0",
        size: "sm",
        top: "0"
    }, props));
};





var $denZA = parcelRequire("denZA");
var $abbea6b3ac0eb036$var$__assign = undefined && undefined.__assign || function() {
    $abbea6b3ac0eb036$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $abbea6b3ac0eb036$var$__assign.apply(this, arguments);
};
var $abbea6b3ac0eb036$export$d7e1f420b25549ff = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6266b7002872936e$export$d7e1f420b25549ff), $abbea6b3ac0eb036$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");
var $bf2e1c303b7f9681$var$__assign = undefined && undefined.__assign || function() {
    $bf2e1c303b7f9681$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf2e1c303b7f9681$var$__assign.apply(this, arguments);
};
var $bf2e1c303b7f9681$export$18083345862c6206 = function(props) {
    return $denZA.createElement((0, $6266b7002872936e$export$18083345862c6206), $bf2e1c303b7f9681$var$__assign({}, props));
};





var $denZA = parcelRequire("denZA");
var $bf2dbdf2fe0f82a4$var$__assign = undefined && undefined.__assign || function() {
    $bf2dbdf2fe0f82a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bf2dbdf2fe0f82a4$var$__assign.apply(this, arguments);
};
var $bf2dbdf2fe0f82a4$export$24cbcada8f546cfe = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $6266b7002872936e$export$24cbcada8f546cfe), $bf2dbdf2fe0f82a4$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");
var $d6782e55d41638a7$var$__assign = undefined && undefined.__assign || function() {
    $d6782e55d41638a7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6782e55d41638a7$var$__assign.apply(this, arguments);
};
var $d6782e55d41638a7$export$7dacb05d26466c3 = function(props) {
    return $denZA.createElement((0, $6266b7002872936e$export$7dacb05d26466c3), $d6782e55d41638a7$var$__assign({}, props));
};




var $denZA = parcelRequire("denZA");







var $82e14d45db013ca5$var$__assign = undefined && undefined.__assign || function() {
    $82e14d45db013ca5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82e14d45db013ca5$var$__assign.apply(this, arguments);
};
var $82e14d45db013ca5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $82e14d45db013ca5$export$5b6b19405a83ff9d = function(_a) {
    var _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, rest = $82e14d45db013ca5$var$__rest(_a, [
        "autoFocus"
    ]);
    return $denZA.createElement((0, $6266b7002872936e$export$5b6b19405a83ff9d), $82e14d45db013ca5$var$__assign({
        autoFocus: autoFocus
    }, rest));
};
$82e14d45db013ca5$export$5b6b19405a83ff9d.Arrow = (0, $90260531033b51de$export$3152841115e061b2);
$82e14d45db013ca5$export$5b6b19405a83ff9d.Body = (0, $7d8af7dc5d3b87e9$export$472ec417bca1d382);
$82e14d45db013ca5$export$5b6b19405a83ff9d.CloseButton = (0, $b9952c2737ea2b25$export$4c88dacf86a15877);
$82e14d45db013ca5$export$5b6b19405a83ff9d.Content = (0, $abbea6b3ac0eb036$export$d7e1f420b25549ff);
$82e14d45db013ca5$export$5b6b19405a83ff9d.Footer = (0, $bf2e1c303b7f9681$export$18083345862c6206);
$82e14d45db013ca5$export$5b6b19405a83ff9d.Header = (0, $bf2dbdf2fe0f82a4$export$24cbcada8f546cfe);
$82e14d45db013ca5$export$5b6b19405a83ff9d.Trigger = (0, $d6782e55d41638a7$export$7dacb05d26466c3);


var $86fa52a1c94824a7$export$3152841115e061b2 = (0, $90260531033b51de$export$3152841115e061b2);
var $86fa52a1c94824a7$export$472ec417bca1d382 = (0, $7d8af7dc5d3b87e9$export$472ec417bca1d382);
var $86fa52a1c94824a7$export$4c88dacf86a15877 = (0, $b9952c2737ea2b25$export$4c88dacf86a15877);
var $86fa52a1c94824a7$export$d7e1f420b25549ff = (0, $abbea6b3ac0eb036$export$d7e1f420b25549ff);
var $86fa52a1c94824a7$export$18083345862c6206 = (0, $bf2e1c303b7f9681$export$18083345862c6206);
var $86fa52a1c94824a7$export$24cbcada8f546cfe = (0, $bf2dbdf2fe0f82a4$export$24cbcada8f546cfe);
var $86fa52a1c94824a7$export$7dacb05d26466c3 = (0, $d6782e55d41638a7$export$7dacb05d26466c3);





var $denZA = parcelRequire("denZA");


var $b98c5b649b67a392$export$c82e186cf428d56d = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    "0%": {
        strokeDasharray: "1, 400",
        strokeDashoffset: "0"
    },
    "50%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-100"
    },
    "100%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-260"
    }
});
var $b98c5b649b67a392$export$bb628a54ab399bc9 = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $b98c5b649b67a392$export$504d7abb21fa8c9 = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    "0%": {
        left: "-40%"
    },
    "100%": {
        left: "100%"
    }
});
var $b98c5b649b67a392$export$735606310a3da449 = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    from: {
        backgroundPosition: "1rem 0"
    },
    to: {
        backgroundPosition: "0 0"
    }
});
function $b98c5b649b67a392$export$c5752331c2d05cd(options) {
    var { value: value = 0, min: min, max: max, valueText: valueText, getValueText: getValueText, isIndeterminate: isIndeterminate } = options;
    var percent = (0, $a2c5f30ccc79a99f$export$83ce4bc8280540e6)(value, min, max);
    var getAriaValueText = ()=>{
        if (value == null) return undefined;
        return (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(getValueText) ? getValueText(value, percent) : valueText;
    };
    return {
        bind: {
            "data-indeterminate": isIndeterminate ? "" : undefined,
            "aria-valuemax": max,
            "aria-valuemin": min,
            "aria-valuenow": isIndeterminate ? undefined : value,
            "aria-valuetext": getAriaValueText(),
            role: "progressbar"
        },
        percent: percent,
        value: value
    };
}


function $701778ba1997e8bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $701778ba1997e8bb$var$_extends() {
    $701778ba1997e8bb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $701778ba1997e8bb$var$_extends.apply(this, arguments);
}
var $701778ba1997e8bb$var$Circle = (props)=>/*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).circle, $701778ba1997e8bb$var$_extends({
        cx: 50,
        cy: 50,
        r: 42,
        fill: "transparent"
    }, props));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $701778ba1997e8bb$var$Circle.displayName = "Circle";
var $701778ba1997e8bb$var$Shape = (props)=>{
    var { size: size, isIndeterminate: isIndeterminate } = props, rest = $701778ba1997e8bb$var$_objectWithoutPropertiesLoose(props, [
        "size",
        "isIndeterminate"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg, $701778ba1997e8bb$var$_extends({
        viewBox: "0 0 100 100",
        __css: {
            width: size,
            height: size,
            animation: isIndeterminate ? (0, $b98c5b649b67a392$export$bb628a54ab399bc9) + " 2s linear infinite" : undefined
        }
    }, rest));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $701778ba1997e8bb$var$Shape.displayName = "Shape";
var $701778ba1997e8bb$export$9e72f56a493060bf = (props)=>{
    var _progress$percent;
    var { size: size = "48px", max: max = 100, min: min = 0, valueText: valueText, getValueText: getValueText, value: value, capIsRound: capIsRound, children: children, thickness: thickness = "10px", color: color = "#0078d4", trackColor: trackColor = "#edebe9", isIndeterminate: isIndeterminate } = props, rest = $701778ba1997e8bb$var$_objectWithoutPropertiesLoose(props, [
        "size",
        "max",
        "min",
        "valueText",
        "getValueText",
        "value",
        "capIsRound",
        "children",
        "thickness",
        "color",
        "trackColor",
        "isIndeterminate"
    ]);
    var progress = (0, $b98c5b649b67a392$export$c5752331c2d05cd)({
        min: min,
        max: max,
        value: value,
        valueText: valueText,
        getValueText: getValueText,
        isIndeterminate: isIndeterminate
    });
    var determinant = isIndeterminate ? undefined : ((_progress$percent = progress.percent) != null ? _progress$percent : 0) * 2.64;
    var strokeDasharray = (0, $6b74ef5ae6a56e47$export$fce6876652108ab)(determinant) ? undefined : determinant + " " + (264 - determinant);
    var indicatorProps = isIndeterminate ? {
        css: {
            animation: (0, $b98c5b649b67a392$export$c82e186cf428d56d) + " 1.5s linear infinite"
        }
    } : {
        strokeDashoffset: 66,
        strokeDasharray: strokeDasharray,
        transitionProperty: "stroke-dasharray, stroke",
        transitionDuration: "0.6s",
        transitionTimingFunction: "ease"
    };
    var rootStyles = {
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        fontSize: size
    };
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $701778ba1997e8bb$var$_extends({
        className: "chakra-progress"
    }, progress.bind, rest, {
        __css: rootStyles
    }), /*#__PURE__*/ $denZA.createElement($701778ba1997e8bb$var$Shape, {
        size: size,
        isIndeterminate: isIndeterminate
    }, /*#__PURE__*/ $denZA.createElement($701778ba1997e8bb$var$Circle, {
        stroke: trackColor,
        strokeWidth: thickness,
        className: "chakra-progress__track"
    }), /*#__PURE__*/ $denZA.createElement($701778ba1997e8bb$var$Circle, $701778ba1997e8bb$var$_extends({
        stroke: color,
        strokeWidth: thickness,
        className: "chakra-progress__indicator",
        strokeLinecap: capIsRound ? "round" : undefined,
        opacity: progress.value === 0 && !isIndeterminate ? 0 : undefined
    }, indicatorProps))), children);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $701778ba1997e8bb$export$9e72f56a493060bf.displayName = "CircularProgress";
var $701778ba1997e8bb$export$9a43740be2ad09b0 = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        fontSize: "0.24em",
        top: "50%",
        left: "50%",
        width: "100%",
        textAlign: "center",
        position: "absolute",
        transform: "translate(-50%, -50%)"
    }
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $701778ba1997e8bb$export$9a43740be2ad09b0.displayName = "CircularProgressLabel";



var $denZA = parcelRequire("denZA");
var $33576a70842fcda5$var$__assign = undefined && undefined.__assign || function() {
    $33576a70842fcda5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $33576a70842fcda5$var$__assign.apply(this, arguments);
};
var $33576a70842fcda5$export$9a43740be2ad09b0 = function(props) {
    return $denZA.createElement((0, $701778ba1997e8bb$export$9a43740be2ad09b0), $33576a70842fcda5$var$__assign({
        sx: {
            fontSize: 'inherit'
        }
    }, props));
};




var $denZA = parcelRequire("denZA");

var $c474c04fb5b046c8$var$__assign = undefined && undefined.__assign || function() {
    $c474c04fb5b046c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c474c04fb5b046c8$var$__assign.apply(this, arguments);
};
var $c474c04fb5b046c8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c474c04fb5b046c8$var$rotate = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    '0%': {
        transform: 'rotate(0deg)'
    },
    '100%': {
        transform: 'rotate(360deg)'
    }
});
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// return type here is Keyframes, which should come from @emotion/css, but it can't be imported
var $c474c04fb5b046c8$var$spin = function(pathLength) {
    return (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
        '0%': {
            strokeDasharray: "1 " + pathLength,
            strokeDashoffset: '0'
        },
        '50%': {
            strokeDasharray: pathLength + " " + pathLength,
            strokeDashoffset: "-" + pathLength / 2
        },
        '100%': {
            strokeDasharray: pathLength + " " + pathLength,
            strokeDashoffset: "-" + pathLength
        }
    });
};
var $c474c04fb5b046c8$var$CircularProgressContainer = function(_a) {
    var dimensions = _a.dimensions, fontSize = _a.fontSize, children = _a.children, rest = $c474c04fb5b046c8$var$__rest(_a, [
        "dimensions",
        "fontSize",
        "children"
    ]);
    var rootStyles = {
        display: 'inline-block',
        position: 'relative',
        verticalAlign: 'middle',
        fontSize: fontSize,
        width: dimensions,
        height: dimensions
    };
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c474c04fb5b046c8$var$__assign({
        __css: rootStyles,
        className: "chakra-progress"
    }, rest), children);
};
var $c474c04fb5b046c8$var$Shape = function(_a) {
    var dimensions = _a.dimensions, isIndeterminate = _a.isIndeterminate, children = _a.children;
    var styles = {
        // rotate 270deg in order to start at the top and continue clockwise
        transform: 'rotate(270deg)',
        height: dimensions,
        width: dimensions,
        animation: isIndeterminate ? $c474c04fb5b046c8$var$rotate + " 2s linear infinite" : undefined
    };
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).svg, {
        __css: styles,
        viewBox: "0 0 " + dimensions + " " + dimensions
    }, children);
};
var $c474c04fb5b046c8$var$Circle = function(_a) {
    var dimensions = _a.dimensions, _b = _a.thickness, thickness = _b === void 0 ? 4 : _b, rest = $c474c04fb5b046c8$var$__rest(_a, [
        "dimensions",
        "thickness"
    ]);
    var cx = dimensions / 2;
    var radius = cx - thickness;
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).circle, $c474c04fb5b046c8$var$__assign({
        cx: cx,
        cy: cx,
        fill: "transparent",
        r: radius
    }, rest, {
        strokeWidth: thickness
    }));
};
var $c474c04fb5b046c8$var$CircularProgressComponent = function(props) {
    var children = props.children, _a = props.value, value = _a === void 0 ? 0 : _a, _b = props.thickness, thickness = _b === void 0 ? '1px' : _b, color = props.color, trackColor = props.trackColor, // eslint-disable-next-line @typescript-eslint/naming-convention
    _c = props.capIsRound, // eslint-disable-next-line @typescript-eslint/naming-convention
    capIsRound = _c === void 0 ? true : _c, isIndeterminate = props.isIndeterminate, dimensions = props.dimensions, rest = $c474c04fb5b046c8$var$__rest(props, [
        "children",
        "value",
        "thickness",
        "color",
        "trackColor",
        "capIsRound",
        "isIndeterminate",
        "dimensions"
    ]);
    var themeStyles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('CircularProgress', props);
    var _d = themeStyles.track, trackStroke = _d.stroke, themeHeight = _d.height, themeWidth = _d.width, filledStroke = themeStyles.filledTrack.stroke, fontSize = themeStyles.label.fontSize;
    var bgColor = trackColor !== null && trackColor !== void 0 ? trackColor : trackStroke;
    var filledColor = color !== null && color !== void 0 ? color : filledStroke;
    var calcDimensions = dimensions !== null && dimensions !== void 0 ? dimensions : Math.max(themeHeight, themeWidth);
    var strokeLinecap = capIsRound ? 'round' : 'butt';
    var thicknessNumber = typeof thickness === 'number' ? thickness : parseInt(thickness, 10);
    var cx = calcDimensions / 2;
    var radius = cx - thicknessNumber;
    var pathLength = 2 * Math.PI * radius;
    var dashoffset = pathLength * ((100 - value) / 100);
    if (capIsRound) // need to add the thickness because of how the round linecap is drawn on the svg
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linecap
    dashoffset += thicknessNumber;
    var indicatorProps = isIndeterminate ? {
        css: {
            animation: $c474c04fb5b046c8$var$spin(pathLength) + " 1.5s linear infinite"
        }
    } : {
        strokeDashoffset: dashoffset,
        strokeDasharray: pathLength,
        transition: "stroke-dasharray 0.6s ease 0s, stroke 0.6s ease"
    };
    return $denZA.createElement($c474c04fb5b046c8$var$CircularProgressContainer, $c474c04fb5b046c8$var$__assign({
        dimensions: calcDimensions,
        fontSize: fontSize
    }, rest), $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: themeStyles
    }, $denZA.createElement($c474c04fb5b046c8$var$Shape, {
        dimensions: calcDimensions,
        isIndeterminate: isIndeterminate
    }, $denZA.createElement($c474c04fb5b046c8$var$Circle, {
        __css: themeStyles.track,
        className: "chakra-progress__track",
        dimensions: calcDimensions,
        stroke: bgColor,
        strokeWidth: thicknessNumber,
        thickness: thicknessNumber
    }), $denZA.createElement($c474c04fb5b046c8$var$Circle, $c474c04fb5b046c8$var$__assign({
        className: "chakra-progress__indicator"
    }, indicatorProps, {
        __css: themeStyles.filledTrack,
        dimensions: calcDimensions,
        stroke: filledColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: thicknessNumber,
        thickness: thicknessNumber
    }))), children));
};
var $c474c04fb5b046c8$export$9e72f56a493060bf = function(props) {
    return $denZA.createElement($c474c04fb5b046c8$var$CircularProgressComponent, $c474c04fb5b046c8$var$__assign({}, props));
};
$c474c04fb5b046c8$export$9e72f56a493060bf.Label = (0, $33576a70842fcda5$export$9a43740be2ad09b0);





var $denZA = parcelRequire("denZA");

function $d09ed2fddc7e1cb6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d09ed2fddc7e1cb6$var$_extends() {
    $d09ed2fddc7e1cb6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09ed2fddc7e1cb6$var$_extends.apply(this, arguments);
}
var $d09ed2fddc7e1cb6$export$94acce328a57f173 = (props)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var labelStyles = $d09ed2fddc7e1cb6$var$_extends({
        top: "50%",
        left: "50%",
        width: "100%",
        textAlign: "center",
        position: "absolute",
        transform: "translate(-50%, -50%)"
    }, styles.label);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $d09ed2fddc7e1cb6$var$_extends({}, props, {
        __css: labelStyles
    }));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d09ed2fddc7e1cb6$export$94acce328a57f173.displayName = "ProgressLabel";
/**
 * ProgressFilledTrack (Linear)
 *
 * The progress component that visually indicates the current level of the progress bar.
 * It applies `background-color` and changes its width.
 *
 * @see Docs https://chakra-ui.com/progress
 */ var $d09ed2fddc7e1cb6$var$ProgressFilledTrack = (props)=>{
    var { min: min, max: max, value: value, isIndeterminate: isIndeterminate } = props, rest = $d09ed2fddc7e1cb6$var$_objectWithoutPropertiesLoose(props, [
        "min",
        "max",
        "value",
        "isIndeterminate"
    ]);
    var progress = (0, $b98c5b649b67a392$export$c5752331c2d05cd)({
        value: value,
        min: min,
        max: max,
        isIndeterminate: isIndeterminate
    });
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var trackStyles = $d09ed2fddc7e1cb6$var$_extends({
        height: "100%"
    }, styles.filledTrack);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $d09ed2fddc7e1cb6$var$_extends({
        style: $d09ed2fddc7e1cb6$var$_extends({
            width: progress.percent + "%"
        }, rest.style)
    }, progress.bind, rest, {
        __css: trackStyles
    }));
};
var $d09ed2fddc7e1cb6$export$b25a304ec7d746bb = (props)=>{
    var _styles$track;
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { value: value, min: min = 0, max: max = 100, hasStripe: hasStripe, isAnimated: isAnimated, children: children, borderRadius: propBorderRadius, isIndeterminate: isIndeterminate, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy } = _omitThemingProps, rest = $d09ed2fddc7e1cb6$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "value",
        "min",
        "max",
        "hasStripe",
        "isAnimated",
        "children",
        "borderRadius",
        "isIndeterminate",
        "aria-label",
        "aria-labelledby"
    ]);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Progress", props);
    var borderRadius = propBorderRadius != null ? propBorderRadius : (_styles$track = styles.track) == null ? void 0 : _styles$track.borderRadius;
    var stripAnimation = {
        animation: (0, $b98c5b649b67a392$export$735606310a3da449) + " 1s linear infinite"
    };
    /**
   * We should not use stripe if it is `indeterminate`
   */ var shouldAddStripe = !isIndeterminate && hasStripe;
    var shouldAnimateStripe = shouldAddStripe && isAnimated;
    /**
   * Generate styles for stripe and stripe animation
   */ var css = $d09ed2fddc7e1cb6$var$_extends({}, shouldAnimateStripe && stripAnimation, isIndeterminate && {
        position: "absolute",
        willChange: "left",
        minWidth: "50%",
        animation: (0, $b98c5b649b67a392$export$504d7abb21fa8c9) + " 1s ease infinite normal none running"
    });
    var trackStyles = $d09ed2fddc7e1cb6$var$_extends({
        overflow: "hidden",
        position: "relative"
    }, styles.track);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $d09ed2fddc7e1cb6$var$_extends({
        borderRadius: borderRadius,
        __css: trackStyles
    }, rest), /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement($d09ed2fddc7e1cb6$var$ProgressFilledTrack, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        min: min,
        max: max,
        value: value,
        isIndeterminate: isIndeterminate,
        css: css,
        borderRadius: borderRadius
    }), children));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $d09ed2fddc7e1cb6$export$b25a304ec7d746bb.displayName = "Progress";



var $denZA = parcelRequire("denZA");
var $8937aa9891dbc2b0$var$__assign = undefined && undefined.__assign || function() {
    $8937aa9891dbc2b0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8937aa9891dbc2b0$var$__assign.apply(this, arguments);
};
var $8937aa9891dbc2b0$export$b25a304ec7d746bb = function(props) {
    return $denZA.createElement((0, $d09ed2fddc7e1cb6$export$b25a304ec7d746bb), $8937aa9891dbc2b0$var$__assign({}, props));
};


var $3f6e36a0d8486361$export$9a43740be2ad09b0 = (0, $33576a70842fcda5$export$9a43740be2ad09b0);





var $denZA = parcelRequire("denZA");




var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

function $3651887db3ec93be$var$_extends() {
    $3651887db3ec93be$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3651887db3ec93be$var$_extends.apply(this, arguments);
}
function $3651887db3ec93be$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3651887db3ec93be$export$62b9571f283ff5c2(props) {
    if (props === void 0) props = {};
    var { onChange: onChangeProp, value: valueProp, defaultValue: defaultValue, name: nameProp, isDisabled: isDisabled, isFocusable: isFocusable, isNative: isNative } = props, htmlProps = $3651887db3ec93be$var$_objectWithoutPropertiesLoose(props, [
        "onChange",
        "value",
        "defaultValue",
        "name",
        "isDisabled",
        "isFocusable",
        "isNative"
    ]);
    var [valueState, setValue] = $denZA.useState(defaultValue || "");
    var [isControlled, value] = (0, $53a3d6ee771ef939$export$7301e09313e4cf1b)(valueProp, valueState);
    var ref = $denZA.useRef(null);
    var focus = $denZA.useCallback(()=>{
        var rootNode = ref.current;
        if (!rootNode) return;
        var query = "input:not(:disabled):checked";
        var firstEnabledAndCheckedInput = rootNode.querySelector(query);
        if (firstEnabledAndCheckedInput) {
            firstEnabledAndCheckedInput.focus();
            return;
        }
        query = "input:not(:disabled)";
        var firstEnabledInput = rootNode.querySelector(query);
        firstEnabledInput == null || firstEnabledInput.focus();
    }, []);
    /**
   * All radio options must use the same name
   */ var fallbackName = (0, $63207b263e1aef60$export$f680877a34711e37)(undefined, "radio");
    var name = nameProp || fallbackName;
    var onChange = $denZA.useCallback((eventOrValue)=>{
        var nextValue = (0, $6b74ef5ae6a56e47$export$4215e022093e324e)(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        if (!isControlled) setValue(nextValue);
        onChangeProp == null || onChangeProp(String(nextValue));
    }, [
        onChangeProp,
        isControlled
    ]);
    var getRootProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return $3651887db3ec93be$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(forwardedRef, ref),
            role: "radiogroup"
        });
    }, []);
    var getRadioProps = $denZA.useCallback(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        var checkedKey = isNative ? "checked" : "isChecked";
        return $3651887db3ec93be$var$_extends({}, props, {
            ref: ref,
            name: name,
            [checkedKey]: value != null ? props.value === value : undefined,
            onChange: onChange,
            "data-radiogroup": true
        });
    }, [
        isNative,
        name,
        onChange,
        value
    ]);
    return {
        getRootProps: getRootProps,
        getRadioProps: getRadioProps,
        name: name,
        ref: ref,
        focus: focus,
        setValue: setValue,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        htmlProps: htmlProps
    };
}


function $95fc4e5bc5559608$var$_extends() {
    $95fc4e5bc5559608$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $95fc4e5bc5559608$var$_extends.apply(this, arguments);
}
function $95fc4e5bc5559608$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$95fc4e5bc5559608$var$RadioGroupProvider, $95fc4e5bc5559608$export$7bea016dc7ad2ddf] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "RadioGroupContext",
    strict: false
});
var $95fc4e5bc5559608$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { colorScheme: colorScheme, size: size, variant: variant, children: children, className: className, isDisabled: isDisabled, isFocusable: isFocusable } = props, rest = $95fc4e5bc5559608$var$_objectWithoutPropertiesLoose(props, [
        "colorScheme",
        "size",
        "variant",
        "children",
        "className",
        "isDisabled",
        "isFocusable"
    ]);
    var { value: value, onChange: onChange, getRootProps: getRootProps, name: name, htmlProps: htmlProps } = (0, $3651887db3ec93be$export$62b9571f283ff5c2)(rest);
    var group = $denZA.useMemo(()=>({
            name: name,
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled,
            isFocusable: isFocusable
        }), [
        name,
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled,
        isFocusable
    ]);
    var groupProps = getRootProps(htmlProps, ref);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-radio-group", className);
    return /*#__PURE__*/ $denZA.createElement($95fc4e5bc5559608$var$RadioGroupProvider, {
        value: group
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $95fc4e5bc5559608$var$_extends({}, groupProps, {
        className: _className
    }), children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $95fc4e5bc5559608$export$a98f0dcb43a68a25.displayName = "RadioGroup";








var $denZA = parcelRequire("denZA");

function $8e64b2232ab1759a$var$_extends() {
    $8e64b2232ab1759a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e64b2232ab1759a$var$_extends.apply(this, arguments);
}
function $8e64b2232ab1759a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8e64b2232ab1759a$export$37b0961d2f4751e2(props) {
    if (props === void 0) props = {};
    var { defaultIsChecked: defaultIsChecked, defaultChecked: defaultChecked = defaultIsChecked, isChecked: isCheckedProp, isFocusable: isFocusable, isDisabled: isDisabledProp, isReadOnly: isReadOnlyProp, isRequired: isRequiredProp, onChange: onChange, isInvalid: isInvalidProp, name: name, value: value, id: idProp, "data-radiogroup": dataRadioGroup } = props, htmlProps = $8e64b2232ab1759a$var$_objectWithoutPropertiesLoose(props, [
        "defaultIsChecked",
        "defaultChecked",
        "isChecked",
        "isFocusable",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "onChange",
        "isInvalid",
        "name",
        "value",
        "id",
        "data-radiogroup"
    ]);
    var uuid = (0, $63207b263e1aef60$export$f680877a34711e37)(undefined, "radio");
    var formControl = (0, $e6d2b7519c1f29c8$export$97a2352498389516)();
    var group = (0, $95fc4e5bc5559608$export$7bea016dc7ad2ddf)();
    var isWithinRadioGroup = !!group || !!dataRadioGroup;
    var isWithinFormControl = !!formControl;
    var id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
    id = idProp != null ? idProp : id;
    var isDisabled = isDisabledProp != null ? isDisabledProp : formControl == null ? void 0 : formControl.isDisabled;
    var isReadOnly = isReadOnlyProp != null ? isReadOnlyProp : formControl == null ? void 0 : formControl.isReadOnly;
    var isRequired = isRequiredProp != null ? isRequiredProp : formControl == null ? void 0 : formControl.isRequired;
    var isInvalid = isInvalidProp != null ? isInvalidProp : formControl == null ? void 0 : formControl.isInvalid;
    var [isFocused, setFocused] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var [isHovered, setHovering] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var [isActive, setActive] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var ref = (0, $denZA.useRef)(null);
    var [isCheckedState, setChecked] = (0, $denZA.useState)(Boolean(defaultChecked));
    var [isControlled, isChecked] = (0, $53a3d6ee771ef939$export$7301e09313e4cf1b)(isCheckedProp, isCheckedState);
    (0, $da6e679e22b3b02c$export$c106dd0671a0fc2d)({
        condition: !!defaultIsChecked,
        message: 'The "defaultIsChecked" prop has been deprecated and will be removed in a future version. Please use the "defaultChecked" prop instead, which mirrors default React checkbox behavior.'
    });
    var handleChange = (0, $denZA.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) setChecked(event.target.checked);
        onChange == null || onChange(event);
    }, [
        isControlled,
        isDisabled,
        isReadOnly,
        onChange
    ]);
    var onKeyDown = (0, $denZA.useCallback)((event)=>{
        if (event.key === " ") setActive.on();
    }, [
        setActive
    ]);
    var onKeyUp = (0, $denZA.useCallback)((event)=>{
        if (event.key === " ") setActive.off();
    }, [
        setActive
    ]);
    var getCheckboxProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $8e64b2232ab1759a$var$_extends({}, props, {
            ref: ref,
            "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isHovered),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isInvalid),
            "data-checked": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isFocused),
            "data-readonly": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, setActive.on),
            onMouseUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseUp, setActive.off),
            onMouseEnter: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseEnter, setHovering.on),
            onMouseLeave: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseLeave, setHovering.off)
        });
    }, [
        isActive,
        isHovered,
        isDisabled,
        isInvalid,
        isChecked,
        isFocused,
        isReadOnly,
        setActive.on,
        setActive.off,
        setHovering.on,
        setHovering.off
    ]);
    var { onFocus: onFocus, onBlur: onBlur } = formControl != null ? formControl : {};
    var getInputProps = (0, $denZA.useCallback)(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        var trulyDisabled = isDisabled && !isFocusable;
        return $8e64b2232ab1759a$var$_extends({}, props, {
            id: id,
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(forwardedRef, ref),
            type: "radio",
            name: name,
            value: value,
            onChange: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onChange, handleChange),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onBlur, props.onBlur, setFocused.off),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(onFocus, props.onFocus, setFocused.on),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown),
            onKeyUp: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyUp, onKeyUp),
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            "aria-invalid": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isInvalid),
            "aria-disabled": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(trulyDisabled),
            "aria-readonly": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isReadOnly),
            "aria-required": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isRequired),
            style: (0, $1c1cbb13148aec1f$export$8fecac46448b5689)
        });
    }, [
        isDisabled,
        isFocusable,
        id,
        name,
        value,
        handleChange,
        onBlur,
        setFocused,
        onFocus,
        onKeyDown,
        onKeyUp,
        isChecked,
        isReadOnly,
        isRequired,
        isInvalid
    ]);
    var getLabelProps = function getLabelProps(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $8e64b2232ab1759a$var$_extends({}, props, {
            ref: ref,
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, $8e64b2232ab1759a$var$stop),
            onTouchStart: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onTouchStart, $8e64b2232ab1759a$var$stop),
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isInvalid)
        });
    };
    return {
        state: {
            isInvalid: isInvalid,
            isFocused: isFocused,
            isChecked: isChecked,
            isActive: isActive,
            isHovered: isHovered,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isRequired: isRequired
        },
        getCheckboxProps: getCheckboxProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
/**
 * Prevent `onBlur` being fired when the checkbox label is touched
 */ function $8e64b2232ab1759a$var$stop(event) {
    event.preventDefault();
    event.stopPropagation();
}


function $4f8ab5d4afd5ad5b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4f8ab5d4afd5ad5b$var$_extends() {
    $4f8ab5d4afd5ad5b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f8ab5d4afd5ad5b$var$_extends.apply(this, arguments);
}
var $4f8ab5d4afd5ad5b$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _props$name;
    var group = (0, $95fc4e5bc5559608$export$7bea016dc7ad2ddf)();
    var { onChange: onChangeProp, value: valueProp } = props;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Radio", $4f8ab5d4afd5ad5b$var$_extends({}, group, props));
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var { spacing: spacing = "0.5rem", children: children, isFullWidth: isFullWidth, isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isFocusable: isFocusable = group == null ? void 0 : group.isFocusable } = ownProps, rest = $4f8ab5d4afd5ad5b$var$_objectWithoutPropertiesLoose(ownProps, [
        "spacing",
        "children",
        "isFullWidth",
        "isDisabled",
        "isFocusable"
    ]);
    var isChecked = props.isChecked;
    if ((group == null ? void 0 : group.value) != null && valueProp != null) isChecked = group.value === valueProp;
    var onChange = onChangeProp;
    if (group != null && group.onChange && valueProp != null) onChange = (0, $da6e679e22b3b02c$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    var name = (_props$name = props == null ? void 0 : props.name) != null ? _props$name : group == null ? void 0 : group.name;
    var { getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, htmlProps: htmlProps } = (0, $8e64b2232ab1759a$export$37b0961d2f4751e2)($4f8ab5d4afd5ad5b$var$_extends({}, rest, {
        isChecked: isChecked,
        isFocusable: isFocusable,
        isDisabled: isDisabled,
        onChange: onChange,
        name: name
    }));
    var [layoutProps, otherProps] = (0, $dfe73229adf076fd$export$65980d18b75784e2)(htmlProps, (0, $796ce8a66d67a463$export$bccb7c6ca2f4f912));
    var checkboxProps = getCheckboxProps(otherProps);
    var inputProps = getInputProps({}, ref);
    var labelProps = getLabelProps();
    var rootStyles = $4f8ab5d4afd5ad5b$var$_extends({
        width: isFullWidth ? "full" : undefined,
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "top"
    }, styles.container);
    var checkboxStyles = $4f8ab5d4afd5ad5b$var$_extends({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    }, styles.control);
    var labelStyles = $4f8ab5d4afd5ad5b$var$_extends({
        userSelect: "none",
        marginStart: spacing
    }, styles.label);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).label, $4f8ab5d4afd5ad5b$var$_extends({
        className: "chakra-radio"
    }, layoutProps, {
        __css: rootStyles
    }), /*#__PURE__*/ $denZA.createElement("input", $4f8ab5d4afd5ad5b$var$_extends({
        className: "chakra-radio__input"
    }, inputProps)), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $4f8ab5d4afd5ad5b$var$_extends({
        className: "chakra-radio__control"
    }, checkboxProps, {
        __css: checkboxStyles
    })), children && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $4f8ab5d4afd5ad5b$var$_extends({
        className: "chakra-radio__label"
    }, labelProps, {
        __css: labelStyles
    }), children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $4f8ab5d4afd5ad5b$export$d7b12c4107be0d61.displayName = "Radio";




var $denZA = parcelRequire("denZA");
var $64e7e30545a30d16$var$__assign = undefined && undefined.__assign || function() {
    $64e7e30545a30d16$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64e7e30545a30d16$var$__assign.apply(this, arguments);
};
var $64e7e30545a30d16$export$d7b12c4107be0d61 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $4f8ab5d4afd5ad5b$export$d7b12c4107be0d61), $64e7e30545a30d16$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $ba13e48b428965ac$var$__assign = undefined && undefined.__assign || function() {
    $ba13e48b428965ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba13e48b428965ac$var$__assign.apply(this, arguments);
};
var $ba13e48b428965ac$export$a98f0dcb43a68a25 = function(props) {
    return $denZA.createElement((0, $95fc4e5bc5559608$export$a98f0dcb43a68a25), $ba13e48b428965ac$var$__assign({}, props));
};







var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");
function $1e083a4f02e8927d$var$_extends() {
    $1e083a4f02e8927d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e083a4f02e8927d$var$_extends.apply(this, arguments);
}
function $1e083a4f02e8927d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1e083a4f02e8927d$export$d55b50a564d0b931 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { children: children, placeholder: placeholder, className: className } = props, rest = $1e083a4f02e8927d$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "placeholder",
        "className"
    ]);
    var ownProps = (0, $a9ca37b5c0c19e69$export$62ecd8ad1bbe1a18)(rest);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).select, $1e083a4f02e8927d$var$_extends({}, ownProps, {
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-select", className)
    }), placeholder && /*#__PURE__*/ $denZA.createElement("option", {
        value: ""
    }, placeholder), children);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $1e083a4f02e8927d$export$d55b50a564d0b931.displayName = "SelectField";
var $1e083a4f02e8927d$export$ef9b1a59e592288f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Select", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { rootProps: rootProps, placeholder: placeholder, icon: icon, color: color, height: height, h: h, minH: minH, minHeight: minHeight, iconColor: iconColor, iconSize: iconSize } = _omitThemingProps, rest = $1e083a4f02e8927d$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "rootProps",
        "placeholder",
        "icon",
        "color",
        "height",
        "h",
        "minH",
        "minHeight",
        "iconColor",
        "iconSize",
        "isFullWidth"
    ]);
    var [layoutProps, otherProps] = (0, $dfe73229adf076fd$export$65980d18b75784e2)(rest, (0, $796ce8a66d67a463$export$bccb7c6ca2f4f912));
    var rootStyles = {
        width: "100%",
        height: "fit-content",
        position: "relative",
        color: color
    };
    var fieldStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, styles.field, {
        paddingEnd: "2rem",
        _focus: {
            zIndex: "unset"
        }
    });
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $1e083a4f02e8927d$var$_extends({
        className: "chakra-select__wrapper",
        __css: rootStyles
    }, layoutProps, rootProps), /*#__PURE__*/ $denZA.createElement($1e083a4f02e8927d$export$d55b50a564d0b931, $1e083a4f02e8927d$var$_extends({
        ref: ref,
        height: h != null ? h : height,
        minH: minH != null ? minH : minHeight,
        placeholder: placeholder
    }, otherProps, {
        __css: fieldStyles
    }), props.children), /*#__PURE__*/ $denZA.createElement($1e083a4f02e8927d$var$SelectIcon, $1e083a4f02e8927d$var$_extends({
        "data-disabled": props.isDisabled
    }, (iconColor || color) && {
        color: iconColor || color
    }, {
        __css: styles.icon
    }, iconSize && {
        fontSize: iconSize
    }), icon));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $1e083a4f02e8927d$export$ef9b1a59e592288f.displayName = "Select";
var $1e083a4f02e8927d$export$d206ce4c12e8ddf6 = (props)=>/*#__PURE__*/ $denZA.createElement("svg", $1e083a4f02e8927d$var$_extends({
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }));
var $1e083a4f02e8927d$var$IconWrapper = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        top: "50%",
        transform: "translateY(-50%)"
    }
});
var $1e083a4f02e8927d$var$SelectIcon = (props)=>{
    var { children: children = /*#__PURE__*/ $denZA.createElement($1e083a4f02e8927d$export$d206ce4c12e8ddf6, null) } = props, rest = $1e083a4f02e8927d$var$_objectWithoutPropertiesLoose(props, [
        "children"
    ]);
    var clone = /*#__PURE__*/ $denZA.cloneElement(children, {
        role: "presentation",
        className: "chakra-select__icon",
        focusable: false,
        "aria-hidden": true,
        // force icon to adhere to `IconWrapper` styles
        style: {
            width: "1em",
            height: "1em",
            color: "currentColor"
        }
    });
    return /*#__PURE__*/ $denZA.createElement($1e083a4f02e8927d$var$IconWrapper, $1e083a4f02e8927d$var$_extends({}, rest, {
        className: "chakra-select__icon-wrapper"
    }), /*#__PURE__*/ $denZA.isValidElement(children) ? clone : null);
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $1e083a4f02e8927d$var$SelectIcon.displayName = "SelectIcon";





var $denZA = parcelRequire("denZA");
var $ad3b5be9711589c5$var$__assign = undefined && undefined.__assign || function() {
    $ad3b5be9711589c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ad3b5be9711589c5$var$__assign.apply(this, arguments);
};
var $ad3b5be9711589c5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ad3b5be9711589c5$export$ef9b1a59e592288f = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var icon = _a.icon, rest = $ad3b5be9711589c5$var$__rest(_a, [
        "icon"
    ]);
    var selectIcon = icon ? icon : $denZA.createElement((0, $bcdb91cd5aa62a89$export$2fbb36af09846aa0), {
        "data-icon-fixed": "true"
    });
    return $denZA.createElement((0, $1e083a4f02e8927d$export$ef9b1a59e592288f), $ad3b5be9711589c5$var$__assign({
        icon: selectIcon
    }, rest, {
        ref: ref
    }));
});







function $0297793568ddc532$export$4b9ea961bfd9be6e(values, breakpoint, breakpoints) {
    if (breakpoints === void 0) breakpoints = (0, $e9414c504ba55072$export$d07517a676ce386f);
    var index = Object.keys(values).indexOf(breakpoint);
    if (index !== -1) return values[breakpoint];
    var stopIndex = breakpoints.indexOf(breakpoint);
    while(stopIndex >= 0){
        var key = breakpoints[stopIndex];
        if (values[key] != null) {
            index = stopIndex;
            break;
        }
        stopIndex -= 1;
    }
    if (index !== -1) {
        var _key = breakpoints[index];
        return values[_key];
    }
    return undefined;
}





var $denZA = parcelRequire("denZA");

function $c93a506d5799452b$export$2e2bcd8739ae039(breakpoints) {
    return Object.entries(breakpoints) // sort css units in ascending order to ensure media queries are generated
    // in the correct order and reference to each other correctly aswell
    .sort((a, b)=>Number.parseInt(a[1], 10) > Number.parseInt(b[1], 10) ? 1 : -1).map((_ref, index, arr)=>{
        var [breakpoint, minWidth] = _ref;
        // given a following breakpoint
        var next = arr[index + 1]; // this breakpoint must end prior the threshold of the next
        var maxWidth = next ? next[1] : undefined;
        var query = $c93a506d5799452b$var$createMediaQueryString(minWidth, maxWidth);
        return {
            minWidth: minWidth,
            maxWidth: maxWidth,
            breakpoint: breakpoint,
            query: query
        };
    });
}
/**
 * Create a media query string from the breakpoints,
 * using a combination of `min-width` and `max-width`.
 */ function $c93a506d5799452b$var$createMediaQueryString(minWidth, maxWidth) {
    var hasMinWidth = parseInt(minWidth, 10) >= 0;
    if (!hasMinWidth && !maxWidth) return "";
    var query = "(min-width: " + $c93a506d5799452b$var$toMediaString(minWidth) + ")";
    if (!maxWidth) return query;
    if (query) query += " and ";
    query += "(max-width: " + $c93a506d5799452b$var$toMediaString($c93a506d5799452b$var$subtract(maxWidth)) + ")";
    return query;
}
var $c93a506d5799452b$var$measurementRegex = /([0-9]+\.?[0-9]*)/;
var $c93a506d5799452b$var$calculateMeasurement = (value, modifier)=>{
    if (typeof value === "number") return "" + (value + modifier);
    return value.replace($c93a506d5799452b$var$measurementRegex, (match)=>"" + (parseFloat(match) + modifier));
};
/**
 * 0.01 and 0.1 are too small of a difference for `px` breakpoint values
 *
 * @see https://github.com/chakra-ui/chakra-ui/issues/2188#issuecomment-712774785
 */ function $c93a506d5799452b$var$subtract(value) {
    return $c93a506d5799452b$var$calculateMeasurement(value, value.endsWith("px") ? -1 : -0.01);
}
/**
 * Convert media query value to string
 */ function $c93a506d5799452b$var$toMediaString(value) {
    return (0, $6b74ef5ae6a56e47$export$7e4aa119212bc614)(value) ? value + "px" : value;
}


function $f96fba0bb901796b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f96fba0bb901796b$var$_extends() {
    $f96fba0bb901796b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f96fba0bb901796b$var$_extends.apply(this, arguments);
}
function $f96fba0bb901796b$export$199d6754bdf4e1e3(defaultBreakpoint) {
    var { breakpoints: breakpoints } = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    var env = (0, $2b223d0121023643$export$ea7ed2425832167d)();
    var mediaQueries = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useMemo(()=>(0, $c93a506d5799452b$export$2e2bcd8739ae039)($f96fba0bb901796b$var$_extends({
            base: "0px"
        }, breakpoints)), [
        breakpoints
    ]);
    var [currentBreakpoint, setCurrentBreakpoint] = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useState(()=>{
        if (!defaultBreakpoint) return undefined;
        var mediaQuery = mediaQueries.find((_ref)=>{
            var { breakpoint: breakpoint } = _ref;
            return breakpoint === defaultBreakpoint;
        });
        if (mediaQuery) {
            var breakpoint = $f96fba0bb901796b$var$_objectWithoutPropertiesLoose(mediaQuery, [
                "query"
            ]);
            return breakpoint;
        }
        return undefined;
    });
    var current = currentBreakpoint == null ? void 0 : currentBreakpoint.breakpoint;
    var update = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useCallback((query, breakpoint)=>{
        if (query.matches && current !== breakpoint.breakpoint) setCurrentBreakpoint(breakpoint);
    }, [
        current
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useEffect(()=>{
        var listeners = new Set();
        mediaQueries.forEach((_ref2)=>{
            var { query: query } = _ref2, breakpoint = $f96fba0bb901796b$var$_objectWithoutPropertiesLoose(_ref2, [
                "query"
            ]);
            var mediaQuery = env.window.matchMedia(query); // trigger an initial update to determine media query
            update(mediaQuery, breakpoint);
            var handleChange = ()=>{
                update(mediaQuery, breakpoint);
            }; // add media query-listener
            mediaQuery.addListener(handleChange); // push the media query list handleChange
            // so we can use it to remove Listener
            listeners.add({
                mediaQuery: mediaQuery,
                handleChange: handleChange
            });
            return ()=>{
                // clean up 1
                mediaQuery.removeListener(handleChange);
            };
        });
        return ()=>{
            // clean up 2: for safety
            listeners.forEach((_ref3)=>{
                var { mediaQuery: mediaQuery, handleChange: handleChange } = _ref3;
                mediaQuery.removeListener(handleChange);
            });
            listeners.clear();
        };
    }, [
        mediaQueries,
        breakpoints,
        update,
        env.window
    ]);
    return current;
}


function $d85679cb7288a817$export$dc0946e21e709aff(values, defaultBreakpoint) {
    var breakpoint = (0, $f96fba0bb901796b$export$199d6754bdf4e1e3)(defaultBreakpoint);
    var theme = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    if (!breakpoint) return undefined;
    /**
   * Get the non-number breakpoint keys from the provided breakpoints
   */ var breakpoints = Object.keys(theme.breakpoints);
    var obj = (0, $6b74ef5ae6a56e47$export$43bee75e5e14138e)(values) ? (0, $dfe73229adf076fd$export$5150077fc2e7c662)(Object.entries((0, $e9414c504ba55072$export$60476530468641e7)(values, breakpoints)).map((_ref)=>{
        var [key, value] = _ref;
        return [
            key,
            value
        ];
    })) : values;
    return (0, $0297793568ddc532$export$4b9ea961bfd9be6e)(obj, breakpoint, breakpoints);
}




var $denZA = parcelRequire("denZA");
function $13fd9113db1879c0$export$5cae361ad82dce8b(value) {
    var ref = (0, $denZA.useRef)();
    (0, $denZA.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}




var $denZA = parcelRequire("denZA");
function $3e771e8e53ee39a1$var$_extends() {
    $3e771e8e53ee39a1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e771e8e53ee39a1$var$_extends.apply(this, arguments);
}
function $3e771e8e53ee39a1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3e771e8e53ee39a1$var$StyledSkeleton = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        "&::before, &::after, *": {
            visibility: "hidden"
        }
    }
});
var $3e771e8e53ee39a1$var$fade = (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $3e771e8e53ee39a1$var$useIsFirstRender = ()=>{
    var isFirstRender = $denZA.useRef(true);
    $denZA.useEffect(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
};
var $3e771e8e53ee39a1$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Skeleton", props);
    var isFirstRender = $3e771e8e53ee39a1$var$useIsFirstRender();
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { isLoaded: isLoaded, fadeDuration: fadeDuration, className: className } = _omitThemingProps, rest = $3e771e8e53ee39a1$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "startColor",
        "endColor",
        "isLoaded",
        "fadeDuration",
        "speed",
        "className"
    ]);
    var wasPreviouslyLoaded = (0, $13fd9113db1879c0$export$5cae361ad82dce8b)(isLoaded);
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-skeleton", className);
    if (isLoaded) {
        var animation = isFirstRender || wasPreviouslyLoaded ? "none" : $3e771e8e53ee39a1$var$fade + " " + fadeDuration + "s";
        return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $3e771e8e53ee39a1$var$_extends({
            ref: ref,
            className: _className,
            __css: {
                animation: animation
            }
        }, rest));
    }
    return /*#__PURE__*/ $denZA.createElement($3e771e8e53ee39a1$var$StyledSkeleton, $3e771e8e53ee39a1$var$_extends({
        ref: ref,
        className: _className
    }, rest, {
        __css: styles
    }));
});
$3e771e8e53ee39a1$export$8f31e4c4a37b8e9c.defaultProps = {
    fadeDuration: 0.4,
    speed: 0.8
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $3e771e8e53ee39a1$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
function $3e771e8e53ee39a1$var$range(count) {
    return Array(count).fill(1).map((_, index)=>index + 1);
}
var $3e771e8e53ee39a1$var$defaultNoOfLines = 3;
var $3e771e8e53ee39a1$export$cb6ddd830302c2a8 = (props)=>{
    var { noOfLines: noOfLines = $3e771e8e53ee39a1$var$defaultNoOfLines, spacing: spacing = "0.5rem", skeletonHeight: skeletonHeight = "0.5rem", className: className, startColor: startColor, endColor: endColor, isLoaded: isLoaded, fadeDuration: fadeDuration, speed: speed, children: children } = props, rest = $3e771e8e53ee39a1$var$_objectWithoutPropertiesLoose(props, [
        "noOfLines",
        "spacing",
        "skeletonHeight",
        "className",
        "startColor",
        "endColor",
        "isLoaded",
        "fadeDuration",
        "speed",
        "children"
    ]);
    var noOfLinesValue = (0, $d85679cb7288a817$export$dc0946e21e709aff)(typeof noOfLines === "number" ? [
        noOfLines
    ] : noOfLines) || $3e771e8e53ee39a1$var$defaultNoOfLines;
    var numbers = $3e771e8e53ee39a1$var$range(noOfLinesValue);
    var getWidth = (index)=>{
        if (noOfLinesValue > 1) return index === numbers.length ? "80%" : "100%";
        return "100%";
    };
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-skeleton__group", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $3e771e8e53ee39a1$var$_extends({
        className: _className
    }, rest), numbers.map((number, index)=>{
        if (isLoaded && index > 0) // skip other lines
        return null;
        var sizeProps = isLoaded ? null : {
            mb: number === numbers.length ? "0" : spacing,
            width: getWidth(number),
            height: skeletonHeight
        };
        return /*#__PURE__*/ $denZA.createElement($3e771e8e53ee39a1$export$8f31e4c4a37b8e9c, $3e771e8e53ee39a1$var$_extends({
            key: numbers.length.toString() + number,
            startColor: startColor,
            endColor: endColor,
            isLoaded: isLoaded,
            fadeDuration: fadeDuration,
            speed: speed
        }, sizeProps), index === 0 ? children : undefined);
    }));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $3e771e8e53ee39a1$export$cb6ddd830302c2a8.displayName = "SkeletonText";
var $3e771e8e53ee39a1$export$7d2444dbb58007d7 = (_ref)=>{
    var { size: size = "2rem" } = _ref, rest = $3e771e8e53ee39a1$var$_objectWithoutPropertiesLoose(_ref, [
        "size"
    ]);
    return /*#__PURE__*/ $denZA.createElement($3e771e8e53ee39a1$export$8f31e4c4a37b8e9c, $3e771e8e53ee39a1$var$_extends({
        borderRadius: "full",
        boxSize: size
    }, rest));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $3e771e8e53ee39a1$export$7d2444dbb58007d7.displayName = "SkeletonCircle";




var $denZA = parcelRequire("denZA");
var $28df89568e2273c2$var$__assign = undefined && undefined.__assign || function() {
    $28df89568e2273c2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28df89568e2273c2$var$__assign.apply(this, arguments);
};
var $28df89568e2273c2$export$8f31e4c4a37b8e9c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $3e771e8e53ee39a1$export$8f31e4c4a37b8e9c), $28df89568e2273c2$var$__assign({}, props, {
        ref: ref
    }));
});




var $denZA = parcelRequire("denZA");
var $e01aaac1cffaae4b$var$__assign = undefined && undefined.__assign || function() {
    $e01aaac1cffaae4b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e01aaac1cffaae4b$var$__assign.apply(this, arguments);
};
var $e01aaac1cffaae4b$export$7d2444dbb58007d7 = function(props) {
    return $denZA.createElement((0, $3e771e8e53ee39a1$export$7d2444dbb58007d7), $e01aaac1cffaae4b$var$__assign({}, props));
};




var $denZA = parcelRequire("denZA");
var $ed4850048ef65ffe$var$__assign = undefined && undefined.__assign || function() {
    $ed4850048ef65ffe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed4850048ef65ffe$var$__assign.apply(this, arguments);
};
var $ed4850048ef65ffe$export$cb6ddd830302c2a8 = function(props) {
    return $denZA.createElement((0, $3e771e8e53ee39a1$export$cb6ddd830302c2a8), $ed4850048ef65ffe$var$__assign({}, props));
};








var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

var $7dab81e6133f6b66$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $7dab81e6133f6b66$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $7dab81e6133f6b66$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $7dab81e6133f6b66$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $7dab81e6133f6b66$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $7dab81e6133f6b66$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $7dab81e6133f6b66$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $7dab81e6133f6b66$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $7dab81e6133f6b66$var$noSpacing : _ref2$padding;
    var marginBox = $7dab81e6133f6b66$export$4b834cebd9e5cebe($7dab81e6133f6b66$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $7dab81e6133f6b66$export$4b834cebd9e5cebe($7dab81e6133f6b66$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $7dab81e6133f6b66$export$4b834cebd9e5cebe($7dab81e6133f6b66$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $7dab81e6133f6b66$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $7dab81e6133f6b66$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $0c0a5d185b6e826c$export$2e2bcd8739ae039)(false);
    return result;
};
var $7dab81e6133f6b66$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $7dab81e6133f6b66$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $7dab81e6133f6b66$var$shift(borderBox, change);
    return $7dab81e6133f6b66$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $7dab81e6133f6b66$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $7dab81e6133f6b66$var$getWindowScroll();
    return $7dab81e6133f6b66$export$cc800923e997bb8(original, scroll);
};
var $7dab81e6133f6b66$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $7dab81e6133f6b66$var$parse(styles.marginTop),
        right: $7dab81e6133f6b66$var$parse(styles.marginRight),
        bottom: $7dab81e6133f6b66$var$parse(styles.marginBottom),
        left: $7dab81e6133f6b66$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $7dab81e6133f6b66$var$parse(styles.paddingTop),
        right: $7dab81e6133f6b66$var$parse(styles.paddingRight),
        bottom: $7dab81e6133f6b66$var$parse(styles.paddingBottom),
        left: $7dab81e6133f6b66$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $7dab81e6133f6b66$var$parse(styles.borderTopWidth),
        right: $7dab81e6133f6b66$var$parse(styles.borderRightWidth),
        bottom: $7dab81e6133f6b66$var$parse(styles.borderBottomWidth),
        left: $7dab81e6133f6b66$var$parse(styles.borderLeftWidth)
    };
    return $7dab81e6133f6b66$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $7dab81e6133f6b66$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $7dab81e6133f6b66$export$b8dfc5d4e552b8e1(borderBox, styles);
};



function $2a100eb4fa6daa1a$export$d04af0e501fb729f(ref, observe) {
    var [dimensions, setDimensions] = $denZA.useState(null);
    var rafId = $denZA.useRef();
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if (!ref.current) return undefined;
        var node = ref.current;
        function measure() {
            rafId.current = requestAnimationFrame(()=>{
                var boxModel = (0, $7dab81e6133f6b66$export$34928e660d2a8702)(node);
                setDimensions(boxModel);
            });
        }
        measure();
        if (observe) {
            window.addEventListener("resize", measure);
            window.addEventListener("scroll", measure);
        }
        return ()=>{
            if (observe) {
                window.removeEventListener("resize", measure);
                window.removeEventListener("scroll", measure);
            }
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        observe
    ]);
    return dimensions;
}


var $denZA = parcelRequire("denZA");
function $fb85e007841f276d$export$bcd07ba85a740103(value) {
    var ref = $denZA.useRef(null);
    ref.current = value;
    return ref;
}




function $d19e14b0e07a3db7$var$_extends() {
    $d19e14b0e07a3db7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d19e14b0e07a3db7$var$_extends.apply(this, arguments);
}
function $d19e14b0e07a3db7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $d19e14b0e07a3db7$export$d9c66232c9c4689c {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ constructor(_event, handlers, threshold){
        $d19e14b0e07a3db7$var$_defineProperty(this, "history", []);
        $d19e14b0e07a3db7$var$_defineProperty(this, "startEvent", null);
        $d19e14b0e07a3db7$var$_defineProperty(this, "lastEvent", null);
        $d19e14b0e07a3db7$var$_defineProperty(this, "lastEventInfo", null);
        $d19e14b0e07a3db7$var$_defineProperty(this, "handlers", {});
        $d19e14b0e07a3db7$var$_defineProperty(this, "removeListeners", (0, $da6e679e22b3b02c$export$8793edee2d425525));
        $d19e14b0e07a3db7$var$_defineProperty(this, "threshold", 3);
        $d19e14b0e07a3db7$var$_defineProperty(this, "updatePoint", ()=>{
            if (!(this.lastEvent && this.lastEventInfo)) return;
            var info = $d19e14b0e07a3db7$var$getPanInfo(this.lastEventInfo, this.history);
            var isPanStarted = this.startEvent !== null;
            var isDistancePastThreshold = (0, $da6e679e22b3b02c$export$9f17032d917177de)(info.offset, {
                x: 0,
                y: 0
            }) >= this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var { timestamp: timestamp } = (0, $74f0db85147db332$export$7244445918e670ed)();
            this.history.push($d19e14b0e07a3db7$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart == null || onStart(this.lastEvent, info);
                this.startEvent = this.lastEvent;
            }
            onMove == null || onMove(this.lastEvent, info);
        });
        $d19e14b0e07a3db7$var$_defineProperty(this, "onPointerMove", (event, info)=>{
            this.lastEvent = event;
            this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $0e5c6dfd5476a82a$export$764db16956f554f8)(event) && event.buttons === 0) {
                this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(this.updatePoint, true);
        });
        $d19e14b0e07a3db7$var$_defineProperty(this, "onPointerUp", (event, info)=>{
            // notify pan session ended
            var panInfo = $d19e14b0e07a3db7$var$getPanInfo(info, this.history);
            var { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        });
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $0e5c6dfd5476a82a$export$d06464d6b74eedc4)(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = (0, $0e5c6dfd5476a82a$export$12f84bb882d06e1a)(_event);
        var { timestamp: _timestamp } = (0, $74f0db85147db332$export$7244445918e670ed)();
        this.history = [
            $d19e14b0e07a3db7$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var { onSessionStart: onSessionStart } = handlers;
        onSessionStart == null || onSessionStart(_event, $d19e14b0e07a3db7$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = (0, $da6e679e22b3b02c$export$a4627e546088548d)((0, $0e5c6dfd5476a82a$export$fcff2e64e6676b81)(window, "pointermove", this.onPointerMove), (0, $0e5c6dfd5476a82a$export$fcff2e64e6676b81)(window, "pointerup", this.onPointerUp), (0, $0e5c6dfd5476a82a$export$fcff2e64e6676b81)(window, "pointercancel", this.onPointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $d19e14b0e07a3db7$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $d19e14b0e07a3db7$var$startPanPoint(history) {
    return history[0];
}
function $d19e14b0e07a3db7$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $d19e14b0e07a3db7$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $d19e14b0e07a3db7$var$subtractPoint(info.point, $d19e14b0e07a3db7$var$lastPanPoint(history)),
        offset: $d19e14b0e07a3db7$var$subtractPoint(info.point, $d19e14b0e07a3db7$var$startPanPoint(history)),
        velocity: $d19e14b0e07a3db7$var$getVelocity(history, 0.1)
    };
}
function $d19e14b0e07a3db7$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $d19e14b0e07a3db7$var$toMilliseconds = (seconds)=>seconds * 1000;
function $d19e14b0e07a3db7$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $d19e14b0e07a3db7$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $d19e14b0e07a3db7$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}



var $denZA = parcelRequire("denZA");


function $04ef3162998a9a7b$export$eb0f62174cac1aec(ref, props) {
    var { onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, onPanSessionEnd: onPanSessionEnd } = props;
    var hasPanEvents = Boolean(onPan || onPanStart || onPanEnd || onPanSessionStart || onPanSessionEnd);
    var panSession = (0, $denZA.useRef)(null);
    var handlers = {
        onSessionStart: onPanSessionStart,
        onSessionEnd: onPanSessionEnd,
        onStart: onPanStart,
        onMove: onPan,
        onEnd (event, info) {
            panSession.current = null;
            onPanEnd == null || onPanEnd(event, info);
        }
    };
    (0, $denZA.useEffect)(()=>{
        var _panSession$current;
        (_panSession$current = panSession.current) == null || _panSession$current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $d19e14b0e07a3db7$export$d9c66232c9c4689c)(event, handlers);
    }
    (0, $6e90b764fb6292b1$export$734d04395f5243cd)(()=>ref.current, "pointerdown", hasPanEvents ? onPointerDown : (0, $da6e679e22b3b02c$export$8793edee2d425525));
    (0, $c29482a8d6079d59$export$f3a192d0cbd30b96)(()=>{
        var _panSession$current2;
        (_panSession$current2 = panSession.current) == null || _panSession$current2.end();
        panSession.current = null;
    });
}





var $denZA = parcelRequire("denZA");
function $4d9cc3b069a44e09$var$_extends() {
    $4d9cc3b069a44e09$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4d9cc3b069a44e09$var$_extends.apply(this, arguments);
}
function $4d9cc3b069a44e09$var$orient(options) {
    var { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
function $4d9cc3b069a44e09$export$aef6aa8a3a8fc9f(options) {
    var { orientation: orientation, trackPercent: trackPercent, thumbRect: thumbRect, isReversed: isReversed } = options;
    var thumbStyle = $4d9cc3b069a44e09$var$_extends({
        position: "absolute",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        touchAction: "none"
    }, $4d9cc3b069a44e09$var$orient({
        orientation: orientation,
        vertical: {
            bottom: "calc(" + trackPercent + "% - " + thumbRect.height / 2 + "px)"
        },
        horizontal: {
            left: "calc(" + trackPercent + "% - " + thumbRect.width / 2 + "px)"
        }
    }));
    var rootStyle = $4d9cc3b069a44e09$var$_extends({
        position: "relative",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0,0,0,0)",
        userSelect: "none",
        outline: 0
    }, $4d9cc3b069a44e09$var$orient({
        orientation: orientation,
        vertical: {
            paddingLeft: thumbRect.width / 2,
            paddingRight: thumbRect.width / 2
        },
        horizontal: {
            paddingTop: thumbRect.height / 2,
            paddingBottom: thumbRect.height / 2
        }
    }));
    var trackStyle = $4d9cc3b069a44e09$var$_extends({
        position: "absolute"
    }, $4d9cc3b069a44e09$var$orient({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: "translateX(-50%)",
            height: "100%"
        },
        horizontal: {
            top: "50%",
            transform: "translateY(-50%)",
            width: "100%"
        }
    }));
    var innerTrackStyle = $4d9cc3b069a44e09$var$_extends({}, trackStyle, $4d9cc3b069a44e09$var$orient({
        orientation: orientation,
        vertical: isReversed ? {
            height: 100 - trackPercent + "%",
            top: 0
        } : {
            height: trackPercent + "%",
            bottom: 0
        },
        horizontal: isReversed ? {
            width: 100 - trackPercent + "%",
            right: 0
        } : {
            width: trackPercent + "%",
            left: 0
        }
    }));
    return {
        trackStyle: trackStyle,
        innerTrackStyle: innerTrackStyle,
        rootStyle: rootStyle,
        thumbStyle: thumbStyle
    };
}


function $c7c607ec7fb8c932$var$_extends() {
    $c7c607ec7fb8c932$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7c607ec7fb8c932$var$_extends.apply(this, arguments);
}
function $c7c607ec7fb8c932$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c7c607ec7fb8c932$export$56b2c08e277f365(props) {
    var _getAriaValueText;
    var { min: min = 0, max: max = 100, onChange: onChange, value: valueProp, defaultValue: defaultValue, isReversed: isReversed, orientation: orientation = "horizontal", id: idProp, isDisabled: isDisabled, isReadOnly: isReadOnly, onChangeStart: onChangeStartProp, onChangeEnd: onChangeEndProp, step: step = 1, getAriaValueText: getAriaValueTextProp, "aria-valuetext": ariaValueText, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, name: name, focusThumbOnChange: focusThumbOnChange = true } = props, htmlProps = $c7c607ec7fb8c932$var$_objectWithoutPropertiesLoose(props, [
        "min",
        "max",
        "onChange",
        "value",
        "defaultValue",
        "isReversed",
        "orientation",
        "id",
        "isDisabled",
        "isReadOnly",
        "onChangeStart",
        "onChangeEnd",
        "step",
        "getAriaValueText",
        "aria-valuetext",
        "aria-label",
        "aria-labelledby",
        "name",
        "focusThumbOnChange"
    ]);
    var onChangeStart = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChangeStartProp);
    var onChangeEnd = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(onChangeEndProp);
    var getAriaValueText = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(getAriaValueTextProp);
    /**
   * Enable the slider handle controlled and uncontrolled scenarios
   */ var [computedValue, setValue] = (0, $53a3d6ee771ef939$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue != null ? defaultValue : $c7c607ec7fb8c932$var$getDefaultValue(min, max),
        onChange: onChange
    });
    var [isDragging, setDragging] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var [isFocused, setFocused] = (0, $44643eda995a7329$export$c32275ecbd12948f)();
    var eventSourceRef = (0, $denZA.useRef)(null);
    var isInteractive = !(isDisabled || isReadOnly);
    /**
   * Constrain the value because it can't be less than min
   * or greater than max
   */ var value = (0, $a2c5f30ccc79a99f$export$31ee16100cde6ce2)(computedValue, min, max);
    var valueRef = (0, $fb85e007841f276d$export$bcd07ba85a740103)(value);
    var prevRef = (0, $denZA.useRef)(valueRef.current);
    var reversedValue = max - value + min;
    var trackValue = isReversed ? reversedValue : value;
    var trackPercent = (0, $a2c5f30ccc79a99f$export$83ce4bc8280540e6)(trackValue, min, max);
    var isVertical = orientation === "vertical";
    /**
   * Let's keep a reference to the slider track and thumb
   */ var trackRef = (0, $denZA.useRef)(null);
    var thumbRef = (0, $denZA.useRef)(null);
    var rootRef = (0, $denZA.useRef)(null);
    /**
   * Generate unique ids for component parts
   */ var [thumbId, trackId] = (0, $63207b263e1aef60$export$365c04e2f432779)(idProp, "slider-thumb", "slider-track");
    /**
   * Get relative value of slider from the event by tracking
   * how far you clicked within the track to determine the value
   *
   * @todo - Refactor this later on to use info from pan session
   */ var getValueFromPointer = (0, $denZA.useCallback)((event)=>{
        var _event$touches$, _event$touches;
        if (!trackRef.current) return;
        eventSourceRef.current = "pointer";
        var trackRect = (0, $7dab81e6133f6b66$export$34928e660d2a8702)(trackRef.current).borderBox;
        var { clientX: clientX, clientY: clientY } = (_event$touches$ = (_event$touches = event.touches) == null ? void 0 : _event$touches[0]) != null ? _event$touches$ : event;
        var diff = isVertical ? trackRect.bottom - clientY : clientX - trackRect.left;
        var length = isVertical ? trackRect.height : trackRect.width;
        var percent = diff / length;
        if (isReversed) percent = 1 - percent;
        var nextValue = (0, $a2c5f30ccc79a99f$export$7a6e99933c50b5b2)(percent, min, max);
        if (step) nextValue = parseFloat((0, $a2c5f30ccc79a99f$export$3e1fe053092824a3)(nextValue, min, step));
        nextValue = (0, $a2c5f30ccc79a99f$export$31ee16100cde6ce2)(nextValue, min, max);
        return nextValue;
    }, [
        isVertical,
        isReversed,
        max,
        min,
        step
    ]);
    var tenSteps = (max - min) / 10;
    var oneStep = step || (max - min) / 100;
    var constrain = (0, $denZA.useCallback)((value)=>{
        if (!isInteractive) return;
        value = parseFloat((0, $a2c5f30ccc79a99f$export$3e1fe053092824a3)(value, min, oneStep));
        value = (0, $a2c5f30ccc79a99f$export$31ee16100cde6ce2)(value, min, max);
        setValue(value);
    }, [
        oneStep,
        max,
        min,
        setValue,
        isInteractive
    ]);
    var actions = (0, $denZA.useMemo)(()=>({
            stepUp: function stepUp(step) {
                if (step === void 0) step = oneStep;
                var next = isReversed ? value - step : value + step;
                constrain(next);
            },
            stepDown: function stepDown(step) {
                if (step === void 0) step = oneStep;
                var next = isReversed ? value + step : value - step;
                constrain(next);
            },
            reset: ()=>constrain(defaultValue || 0),
            stepTo: (value)=>constrain(value)
        }), [
        constrain,
        isReversed,
        value,
        oneStep,
        defaultValue
    ]);
    /**
   * Keyboard interaction to ensure users can operate
   * the slider using only their keyboard.
   */ var onKeyDown = (0, $denZA.useCallback)((event)=>{
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var keyMap = {
            ArrowRight: ()=>actions.stepUp(),
            ArrowUp: ()=>actions.stepUp(),
            ArrowLeft: ()=>actions.stepDown(),
            ArrowDown: ()=>actions.stepDown(),
            PageUp: ()=>actions.stepUp(tenSteps),
            PageDown: ()=>actions.stepDown(tenSteps),
            Home: ()=>constrain(min),
            End: ()=>constrain(max)
        };
        var action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
            eventSourceRef.current = "keyboard";
        }
    }, [
        actions,
        constrain,
        max,
        min,
        tenSteps
    ]);
    /**
   * ARIA (Optional): To define a human readable representation of the value,
   * we allow users pass aria-valuetext.
   */ var valueText = (_getAriaValueText = getAriaValueText == null ? void 0 : getAriaValueText(value)) != null ? _getAriaValueText : ariaValueText;
    /**
   * Measure the dimensions of the thumb so
   * we can center it within the track properly
   */ var thumbBoxModel = (0, $2a100eb4fa6daa1a$export$d04af0e501fb729f)(thumbRef);
    /**
   * Compute styles for all component parts.
   */ var { thumbStyle: thumbStyle, rootStyle: rootStyle, trackStyle: trackStyle, innerTrackStyle: innerTrackStyle } = (0, $denZA.useMemo)(()=>{
        var _thumbBoxModel$border;
        var thumbRect = (_thumbBoxModel$border = thumbBoxModel == null ? void 0 : thumbBoxModel.borderBox) != null ? _thumbBoxModel$border : {
            width: 0,
            height: 0
        };
        return (0, $4d9cc3b069a44e09$export$aef6aa8a3a8fc9f)({
            isReversed: isReversed,
            orientation: orientation,
            thumbRect: thumbRect,
            trackPercent: trackPercent
        });
    }, [
        isReversed,
        orientation,
        thumbBoxModel == null ? void 0 : thumbBoxModel.borderBox,
        trackPercent
    ]);
    var focusThumb = (0, $denZA.useCallback)(()=>{
        if (thumbRef.current && focusThumbOnChange) setTimeout(()=>(0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(thumbRef.current));
    }, [
        focusThumbOnChange
    ]);
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        focusThumb();
        if (eventSourceRef.current === "keyboard") onChangeEnd == null || onChangeEnd(valueRef.current);
    }, [
        value,
        onChangeEnd
    ]);
    var setValueFromPointer = (event)=>{
        var nextValue = getValueFromPointer(event);
        if (nextValue != null && nextValue !== valueRef.current) setValue(nextValue);
    };
    (0, $04ef3162998a9a7b$export$eb0f62174cac1aec)(rootRef, {
        onPanSessionStart (event) {
            if (!isInteractive) return;
            setDragging.on();
            focusThumb();
            setValueFromPointer(event);
            onChangeStart == null || onChangeStart(valueRef.current);
        },
        onPanSessionEnd () {
            if (!isInteractive) return;
            setDragging.off();
            onChangeEnd == null || onChangeEnd(valueRef.current);
            prevRef.current = valueRef.current;
        },
        onPan (event) {
            if (!isInteractive) return;
            setValueFromPointer(event);
        }
    });
    var getRootProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $c7c607ec7fb8c932$var$_extends({}, props, htmlProps, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, rootRef),
            tabIndex: -1,
            "aria-disabled": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isDisabled),
            "data-focused": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isFocused),
            style: $c7c607ec7fb8c932$var$_extends({}, props.style, rootStyle)
        });
    }, [
        htmlProps,
        isDisabled,
        isFocused,
        rootStyle
    ]);
    var getTrackProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $c7c607ec7fb8c932$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, trackRef),
            id: trackId,
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            style: $c7c607ec7fb8c932$var$_extends({}, props.style, trackStyle)
        });
    }, [
        isDisabled,
        trackId,
        trackStyle
    ]);
    var getInnerTrackProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $c7c607ec7fb8c932$var$_extends({}, props, {
            ref: ref,
            style: $c7c607ec7fb8c932$var$_extends({}, props.style, innerTrackStyle)
        });
    }, [
        innerTrackStyle
    ]);
    var getThumbProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $c7c607ec7fb8c932$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, thumbRef),
            role: "slider",
            tabIndex: isInteractive ? 0 : undefined,
            id: thumbId,
            "data-active": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDragging),
            "aria-valuetext": valueText,
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-orientation": orientation,
            "aria-disabled": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isDisabled),
            "aria-readonly": (0, $405775388fe7f58e$export$91a6105db3d4be7b)(isReadOnly),
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabel ? undefined : ariaLabelledBy,
            style: $c7c607ec7fb8c932$var$_extends({}, props.style, thumbStyle),
            onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, setFocused.on),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, setFocused.off)
        });
    }, [
        ariaLabel,
        ariaLabelledBy,
        isDisabled,
        isDragging,
        isReadOnly,
        isInteractive,
        max,
        min,
        onKeyDown,
        orientation,
        setFocused.off,
        setFocused.on,
        thumbId,
        thumbStyle,
        value,
        valueText
    ]);
    var getMarkerProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        var isInRange = !(props.value < min || props.value > max);
        var isHighlighted = value >= props.value;
        var markerPercent = (0, $a2c5f30ccc79a99f$export$83ce4bc8280540e6)(props.value, min, max);
        var markerStyle = $c7c607ec7fb8c932$var$_extends({
            position: "absolute",
            pointerEvents: "none"
        }, $c7c607ec7fb8c932$var$orient({
            orientation: orientation,
            vertical: {
                bottom: isReversed ? 100 - markerPercent + "%" : markerPercent + "%"
            },
            horizontal: {
                left: isReversed ? 100 - markerPercent + "%" : markerPercent + "%"
            }
        }));
        return $c7c607ec7fb8c932$var$_extends({}, props, {
            ref: ref,
            role: "presentation",
            "aria-hidden": true,
            "data-disabled": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(!isInRange),
            "data-highlighted": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isHighlighted),
            style: $c7c607ec7fb8c932$var$_extends({}, props.style, markerStyle)
        });
    }, [
        isDisabled,
        isReversed,
        max,
        min,
        orientation,
        value
    ]);
    var getInputProps = (0, $denZA.useCallback)(function(props, ref) {
        if (props === void 0) props = {};
        if (ref === void 0) ref = null;
        return $c7c607ec7fb8c932$var$_extends({}, props, {
            ref: ref,
            type: "hidden",
            value: value,
            name: name
        });
    }, [
        name,
        value
    ]);
    return {
        state: {
            value: value,
            isFocused: isFocused,
            isDragging: isDragging
        },
        actions: actions,
        getRootProps: getRootProps,
        getTrackProps: getTrackProps,
        getInnerTrackProps: getInnerTrackProps,
        getThumbProps: getThumbProps,
        getMarkerProps: getMarkerProps,
        getInputProps: getInputProps
    };
}
function $c7c607ec7fb8c932$var$orient(options) {
    var { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    return orientation === "vertical" ? vertical : horizontal;
}
/**
 * The browser <input type="range" /> calculates
 * the default value of a slider by using mid-point
 * between the min and the max.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range
 */ function $c7c607ec7fb8c932$var$getDefaultValue(min, max) {
    return max < min ? min : min + (max - min) / 2;
}


function $c2703c157ff015ac$var$_extends() {
    $c2703c157ff015ac$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c2703c157ff015ac$var$_extends.apply(this, arguments);
}
function $c2703c157ff015ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$c2703c157ff015ac$export$d1709061ba4d965f, $c2703c157ff015ac$export$65ed0685dbd65652] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "SliderContext",
    errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <Slider />"
});
var $c2703c157ff015ac$export$472062a354075cee = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Slider", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var _useSlider = (0, $c7c607ec7fb8c932$export$56b2c08e277f365)(ownProps), { getInputProps: getInputProps, getRootProps: getRootProps } = _useSlider, context = $c2703c157ff015ac$var$_objectWithoutPropertiesLoose(_useSlider, [
        "getInputProps",
        "getRootProps"
    ]);
    var rootProps = getRootProps();
    var inputProps = getInputProps({}, ref);
    var rootStyles = $c2703c157ff015ac$var$_extends({
        display: "inline-block",
        position: "relative",
        cursor: "pointer"
    }, styles.container);
    return /*#__PURE__*/ $denZA.createElement($c2703c157ff015ac$export$d1709061ba4d965f, {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c2703c157ff015ac$var$_extends({}, rootProps, {
        className: "chakra-slider",
        __css: rootStyles
    }), props.children, /*#__PURE__*/ $denZA.createElement("input", inputProps))));
});
$c2703c157ff015ac$export$472062a354075cee.defaultProps = {
    orientation: "horizontal"
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2703c157ff015ac$export$472062a354075cee.displayName = "Slider";
var $c2703c157ff015ac$export$2c1b491743890dec = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getThumbProps: getThumbProps } = $c2703c157ff015ac$export$65ed0685dbd65652();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var thumbStyles = $c2703c157ff015ac$var$_extends({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0
    }, styles.thumb);
    var thumbProps = getThumbProps(props, ref);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c2703c157ff015ac$var$_extends({}, thumbProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-slider__thumb", props.className),
        __css: thumbStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2703c157ff015ac$export$2c1b491743890dec.displayName = "SliderThumb";
var $c2703c157ff015ac$export$105594979f116971 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getTrackProps: getTrackProps } = $c2703c157ff015ac$export$65ed0685dbd65652();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var trackStyles = $c2703c157ff015ac$var$_extends({
        overflow: "hidden"
    }, styles.track);
    var trackProps = getTrackProps(props, ref);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c2703c157ff015ac$var$_extends({}, trackProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-slider__track", props.className),
        __css: trackStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2703c157ff015ac$export$105594979f116971.displayName = "SliderTrack";
var $c2703c157ff015ac$export$73137d74280e0c3e = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getInnerTrackProps: getInnerTrackProps } = $c2703c157ff015ac$export$65ed0685dbd65652();
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var trackStyles = $c2703c157ff015ac$var$_extends({
        width: "inherit",
        height: "inherit"
    }, styles.filledTrack);
    var trackProps = getInnerTrackProps(props, ref);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c2703c157ff015ac$var$_extends({}, trackProps, {
        className: "chakra-slider__filled-track",
        __css: trackStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2703c157ff015ac$export$73137d74280e0c3e.displayName = "SliderFilledTrack";
var $c2703c157ff015ac$export$6f85f6a3c5da6f62 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { getMarkerProps: getMarkerProps } = $c2703c157ff015ac$export$65ed0685dbd65652();
    var markProps = getMarkerProps(props, ref);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c2703c157ff015ac$var$_extends({}, markProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-slider__marker", props.className)
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c2703c157ff015ac$export$6f85f6a3c5da6f62.displayName = "SliderMark";




var $denZA = parcelRequire("denZA");
var $fe71014fafdf11c5$var$__assign = undefined && undefined.__assign || function() {
    $fe71014fafdf11c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe71014fafdf11c5$var$__assign.apply(this, arguments);
};
var $fe71014fafdf11c5$export$73137d74280e0c3e = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c2703c157ff015ac$export$73137d74280e0c3e), $fe71014fafdf11c5$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $3d85c1ce80b5798e$var$__assign = undefined && undefined.__assign || function() {
    $3d85c1ce80b5798e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d85c1ce80b5798e$var$__assign.apply(this, arguments);
};
var $3d85c1ce80b5798e$export$2c1b491743890dec = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c2703c157ff015ac$export$2c1b491743890dec), $3d85c1ce80b5798e$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $da6a7840b940d7e0$var$__assign = undefined && undefined.__assign || function() {
    $da6a7840b940d7e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $da6a7840b940d7e0$var$__assign.apply(this, arguments);
};
var $da6a7840b940d7e0$export$105594979f116971 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c2703c157ff015ac$export$105594979f116971), $da6a7840b940d7e0$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");



var $9e2e23f68b2ba302$var$__assign = undefined && undefined.__assign || function() {
    $9e2e23f68b2ba302$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9e2e23f68b2ba302$var$__assign.apply(this, arguments);
};
var $9e2e23f68b2ba302$export$472062a354075cee = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c2703c157ff015ac$export$472062a354075cee), $9e2e23f68b2ba302$var$__assign({}, props, {
        ref: ref
    }), props.children);
});
$9e2e23f68b2ba302$export$472062a354075cee.FilledTrack = (0, $fe71014fafdf11c5$export$73137d74280e0c3e);
$9e2e23f68b2ba302$export$472062a354075cee.Track = (0, $da6a7840b940d7e0$export$105594979f116971);
$9e2e23f68b2ba302$export$472062a354075cee.Thumb = (0, $3d85c1ce80b5798e$export$2c1b491743890dec);


var $60479291d62a1655$export$73137d74280e0c3e = (0, $fe71014fafdf11c5$export$73137d74280e0c3e);
var $60479291d62a1655$export$2c1b491743890dec = (0, $3d85c1ce80b5798e$export$2c1b491743890dec);
var $60479291d62a1655$export$105594979f116971 = (0, $da6a7840b940d7e0$export$105594979f116971);






var $denZA = parcelRequire("denZA");

var $5ea4fe1d6843ece1$export$aea217a45095ce11 = "& > *:not(style) ~ *:not(style)";
function $5ea4fe1d6843ece1$export$91f95a2116eb2513(options) {
    var { spacing: spacing, direction: direction } = options;
    var directionStyles = {
        column: {
            marginTop: spacing,
            marginEnd: 0,
            marginBottom: 0,
            marginStart: 0
        },
        row: {
            marginTop: 0,
            marginEnd: 0,
            marginBottom: 0,
            marginStart: spacing
        },
        "column-reverse": {
            marginTop: 0,
            marginEnd: 0,
            marginBottom: spacing,
            marginStart: 0
        },
        "row-reverse": {
            marginTop: 0,
            marginEnd: spacing,
            marginBottom: 0,
            marginStart: 0
        }
    };
    return {
        flexDirection: direction,
        [$5ea4fe1d6843ece1$export$aea217a45095ce11]: (0, $e9414c504ba55072$export$eca1915781c2aaca)(direction, (value)=>directionStyles[value])
    };
}
function $5ea4fe1d6843ece1$export$d4a6a5cc582519a5(options) {
    var { spacing: spacing, direction: direction } = options;
    var dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $e9414c504ba55072$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}


function $56a3fbdb2781ebc8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $56a3fbdb2781ebc8$var$_extends() {
    $56a3fbdb2781ebc8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56a3fbdb2781ebc8$var$_extends.apply(this, arguments);
}
var $56a3fbdb2781ebc8$export$9a63e55aadfb342a = (props)=>/*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $56a3fbdb2781ebc8$var$_extends({
        className: "chakra-stack__divider"
    }, props, {
        __css: $56a3fbdb2781ebc8$var$_extends({}, props["__css"], {
            borderWidth: 0,
            alignSelf: "stretch",
            borderColor: "inherit",
            width: "auto",
            height: "auto"
        })
    }));
var $56a3fbdb2781ebc8$export$50d5391cd1a018c6 = (props)=>/*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $56a3fbdb2781ebc8$var$_extends({
        className: "chakra-stack__item"
    }, props, {
        __css: $56a3fbdb2781ebc8$var$_extends({
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0
        }, props["__css"])
    }));
var $56a3fbdb2781ebc8$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren } = props, rest = $56a3fbdb2781ebc8$var$_objectWithoutPropertiesLoose(props, [
        "isInline",
        "direction",
        "align",
        "justify",
        "spacing",
        "wrap",
        "children",
        "divider",
        "className",
        "shouldWrapChildren"
    ]);
    var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    var styles = $denZA.useMemo(()=>(0, $5ea4fe1d6843ece1$export$91f95a2116eb2513)({
            direction: direction,
            spacing: spacing
        }), [
        direction,
        spacing
    ]);
    var dividerStyle = $denZA.useMemo(()=>(0, $5ea4fe1d6843ece1$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    var hasDivider = !!divider;
    var shouldUseChildren = !shouldWrapChildren && !hasDivider;
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    var clones = shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
        // Prefer provided child key, fallback to index
        var key = typeof child.key !== "undefined" ? child.key : index;
        var isLast = index + 1 === validChildren.length;
        var wrappedChild = /*#__PURE__*/ $denZA.createElement($56a3fbdb2781ebc8$export$50d5391cd1a018c6, {
            key: key
        }, child);
        var _child = shouldWrapChildren ? wrappedChild : child;
        if (!hasDivider) return _child;
        var clonedDivider = /*#__PURE__*/ $denZA.cloneElement(divider, {
            __css: dividerStyle
        });
        var _divider = isLast ? null : clonedDivider;
        return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, {
            key: key
        }, _child, _divider);
    });
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-stack", className);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $56a3fbdb2781ebc8$var$_extends({
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: styles.flexDirection,
        flexWrap: wrap,
        className: _className,
        __css: hasDivider ? {} : {
            [(0, $5ea4fe1d6843ece1$export$aea217a45095ce11)]: styles[0, $5ea4fe1d6843ece1$export$aea217a45095ce11]
        }
    }, rest), clones);
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $56a3fbdb2781ebc8$export$694e0d28c7ffc90c.displayName = "Stack";
var $56a3fbdb2781ebc8$export$15e411dc07b9c834 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement($56a3fbdb2781ebc8$export$694e0d28c7ffc90c, $56a3fbdb2781ebc8$var$_extends({
        align: "center"
    }, props, {
        direction: "row",
        ref: ref
    })));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $56a3fbdb2781ebc8$export$15e411dc07b9c834.displayName = "HStack";
var $56a3fbdb2781ebc8$export$e6c02a6dccfa2120 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement($56a3fbdb2781ebc8$export$694e0d28c7ffc90c, $56a3fbdb2781ebc8$var$_extends({
        align: "center"
    }, props, {
        direction: "column",
        ref: ref
    })));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $56a3fbdb2781ebc8$export$e6c02a6dccfa2120.displayName = "VStack";





var $denZA = parcelRequire("denZA");
var $68dc535f267da397$var$__assign = undefined && undefined.__assign || function() {
    $68dc535f267da397$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68dc535f267da397$var$__assign.apply(this, arguments);
};
var $68dc535f267da397$export$9a63e55aadfb342a = function(props) {
    var borderColor = (0, $de2d1b30ad83f058$export$31dcd79391e423fe)('components', 'Divider.baseStyle.borderColor');
    // we pass borderColor here like this, because the chakra component has "borderColor: inherit"
    // baked in and doesn't use the theming engine
    return $denZA.createElement((0, $56a3fbdb2781ebc8$export$9a63e55aadfb342a), $68dc535f267da397$var$__assign({
        as: (0, $25153ec74a29a990$export$2e0a83ec2e27ecbb),
        borderColor: borderColor
    }, props));
};




var $denZA = parcelRequire("denZA");



var $denZA = parcelRequire("denZA");

var $4776636f99110dca$var$__assign = undefined && undefined.__assign || function() {
    $4776636f99110dca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4776636f99110dca$var$__assign.apply(this, arguments);
};
var $4776636f99110dca$export$694e0d28c7ffc90c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $56a3fbdb2781ebc8$export$694e0d28c7ffc90c), $4776636f99110dca$var$__assign({}, props, {
        ref: ref
    }));
});
$4776636f99110dca$export$694e0d28c7ffc90c.Divider = (0, $68dc535f267da397$export$9a63e55aadfb342a);


var $438367042194815a$var$__assign = undefined && undefined.__assign || function() {
    $438367042194815a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $438367042194815a$var$__assign.apply(this, arguments);
};
var $438367042194815a$export$5f024d39a73c65ba = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $4776636f99110dca$export$694e0d28c7ffc90c), $438367042194815a$var$__assign({
        align: "center"
    }, props, {
        direction: "row",
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");

var $e7a6ad68c3efa32e$var$__assign = undefined && undefined.__assign || function() {
    $e7a6ad68c3efa32e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e7a6ad68c3efa32e$var$__assign.apply(this, arguments);
};
var $e7a6ad68c3efa32e$export$2be7c0c81d9971e6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $4776636f99110dca$export$694e0d28c7ffc90c), $e7a6ad68c3efa32e$var$__assign({
        align: "center"
    }, props, {
        direction: "column",
        ref: ref
    }));
});


var $8d34f46df4bca7ea$export$9a63e55aadfb342a = (0, $68dc535f267da397$export$9a63e55aadfb342a);






var $denZA = parcelRequire("denZA");

var $5e1aaf078f716a99$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5e1aaf078f716a99$var$_a;
var $5e1aaf078f716a99$export$489784ff4388a558 = ($5e1aaf078f716a99$var$_a = $5e1aaf078f716a99$var$__read((0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: 'StepperContext',
    errorMessage: 'useStepperContext: `context` is undefined. Seems you forgot to wrap the stepper item parts in `<StepperContext  />` '
}), 2), $5e1aaf078f716a99$var$_a[0]), $5e1aaf078f716a99$export$1ff9b16b13b0447 = $5e1aaf078f716a99$var$_a[1];
var $5e1aaf078f716a99$export$7896576cb7635832 = function(props) {
    var getPanelProps = function() {
        return {
            role: 'region',
            id: props.panelId,
            'aria-labelledby': props.buttonId
        };
    };
    var getButtonProps = function() {
        return {
            id: props.panelId,
            'aria-expanded': props.isOpen,
            'aria-controls': props.panelId
        };
    };
    return {
        getPanelProps: getPanelProps,
        getButtonProps: getButtonProps
    };
};


var $02a1237d70982c28$var$__assign = undefined && undefined.__assign || function() {
    $02a1237d70982c28$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $02a1237d70982c28$var$__assign.apply(this, arguments);
};
var $02a1237d70982c28$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $02a1237d70982c28$var$nodeWrapperStyles = {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4'
};
var $02a1237d70982c28$export$fd55ce593607084a = function(_a) {
    var _b = _a.state, state = _b === void 0 ? 'incomplete' : _b, children = _a.children, isReadonly = _a.isReadonly, index = _a.index, props = $02a1237d70982c28$var$__rest(_a, [
        "state",
        "children",
        "isReadonly",
        "index"
    ]);
    var _c = (0, $5e1aaf078f716a99$export$1ff9b16b13b0447)(), orientation = _c.orientation, readonlySteps = _c.readonlySteps;
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var isReadonlyComputed = $denZA.useMemo(function() {
        var _a;
        return (_a = readonlySteps === null || readonlySteps === void 0 ? void 0 : readonlySteps.includes(index)) !== null && _a !== void 0 ? _a : isReadonly;
    }, [
        state,
        index,
        readonlySteps,
        isReadonly
    ]);
    var tabIndex = $denZA.useMemo(function() {
        if (isReadonlyComputed) return -1;
        return state === 'complete' || state === 'active' ? 0 : -1;
    }, [
        isReadonlyComputed,
        state
    ]);
    var linkAs = isReadonlyComputed ? 'span' : 'button';
    var childNodeWrapper = $denZA.useMemo(function() {
        var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children).map(function(child) {
            return $denZA.cloneElement(child, $02a1237d70982c28$var$__assign({
                index: index
            }, child.props));
        });
        if (orientation === 'vertical') return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
            __css: $02a1237d70982c28$var$nodeWrapperStyles
        }, validChildren);
        return validChildren;
    }, [
        orientation,
        children
    ]);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).li, {
        "aria-current": state === 'active',
        role: "presentation",
        sx: styles.step
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        className: "step-graph",
        "data-state": state,
        sx: styles.graph
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $02a1237d70982c28$var$__assign({
        "aria-readonly": isReadonlyComputed,
        as: linkAs,
        className: "step-link",
        "data-state": state,
        sx: styles.link,
        tabIndex: tabIndex
    }, props), state === 'complete' ? $denZA.createElement((0, $a7d2f29d07be0efc$export$add807e002afa321), null) : index)), childNodeWrapper);
};




var $denZA = parcelRequire("denZA");
var $51e75db3e08f1d28$var$__assign = undefined && undefined.__assign || function() {
    $51e75db3e08f1d28$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51e75db3e08f1d28$var$__assign.apply(this, arguments);
};
var $51e75db3e08f1d28$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $51e75db3e08f1d28$export$64aa61b1ef03133 = function(_a) {
    var index = _a.index, children = _a.children, props = $51e75db3e08f1d28$var$__rest(_a, [
        "index",
        "children"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).label, $51e75db3e08f1d28$var$__assign({
        __css: styles.label
    }, props), children);
};





var $denZA = parcelRequire("denZA");

var $cbaadbeb215a441c$var$__assign = undefined && undefined.__assign || function() {
    $cbaadbeb215a441c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cbaadbeb215a441c$var$__assign.apply(this, arguments);
};
var $cbaadbeb215a441c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cbaadbeb215a441c$export$1ab539cfa291f28b = function(_a) {
    var index = _a.index, children = _a.children, props = $cbaadbeb215a441c$var$__rest(_a, [
        "index",
        "children"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var activeStep = (0, $5e1aaf078f716a99$export$1ff9b16b13b0447)().activeStep;
    var getPanelProps = (0, $5e1aaf078f716a99$export$7896576cb7635832)({
        isOpen: index === activeStep
    }).getPanelProps;
    var isOpen = index === activeStep;
    return $denZA.createElement((0, $c93b6b1a78aaf16c$export$78768a9af065a7b), {
        in: isOpen
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $cbaadbeb215a441c$var$__assign({
        __css: styles.panel
    }, $cbaadbeb215a441c$var$__assign($cbaadbeb215a441c$var$__assign({}, getPanelProps()), props)), children));
};





var $denZA = parcelRequire("denZA");




var $819c85b95b564242$var$__assign = undefined && undefined.__assign || function() {
    $819c85b95b564242$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $819c85b95b564242$var$__assign.apply(this, arguments);
};
var $819c85b95b564242$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $819c85b95b564242$export$ed8ca599049e8881 = function(_a) {
    var children = _a.children, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, _c = _a.alignment, alignment = _c === void 0 ? 'center' : _c, _d = _a.activeStep, activeStep = _d === void 0 ? 1 : _d, _e = _a.completedSteps, completedSteps = _e === void 0 ? [] : _e, _f = _a.readonlySteps, readonlySteps = _f === void 0 ? [] : _f, colorScheme = _a.colorScheme, onChange = _a.onChange, props = $819c85b95b564242$var$__rest(_a, [
        "children",
        "orientation",
        "alignment",
        "activeStep",
        "completedSteps",
        "readonlySteps",
        "colorScheme",
        "onChange"
    ]);
    var derivedVariant = orientation === 'horizontal' ? alignment : orientation;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Stepper', {
        colorScheme: colorScheme,
        variant: derivedVariant
    });
    var state = $denZA.useCallback(function(index) {
        if (index === activeStep) return 'active';
        return completedSteps.includes(index) ? 'complete' : 'incomplete';
    }, [
        activeStep,
        completedSteps
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    return $denZA.createElement((0, $5e1aaf078f716a99$export$489784ff4388a558), {
        value: {
            activeStep: activeStep,
            completedSteps: completedSteps,
            alignment: alignment,
            orientation: orientation,
            readonlySteps: readonlySteps
        }
    }, $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).ul, $819c85b95b564242$var$__assign({
        __css: styles.container
    }, props), validChildren.map(function(child, index) {
        return $denZA.cloneElement(child, $819c85b95b564242$var$__assign({
            index: index + 1,
            onClick: function() {
                if (onChange && state(index + 1) === 'complete') onChange(index + 1);
            },
            state: state(index + 1)
        }, child.props));
    }))));
};
$819c85b95b564242$export$ed8ca599049e8881.Label = (0, $51e75db3e08f1d28$export$64aa61b1ef03133);
$819c85b95b564242$export$ed8ca599049e8881.Panel = (0, $cbaadbeb215a441c$export$1ab539cfa291f28b);
$819c85b95b564242$export$ed8ca599049e8881.Step = (0, $02a1237d70982c28$export$fd55ce593607084a);


var $79cb2c9861e6f2e6$export$fd55ce593607084a = (0, $02a1237d70982c28$export$fd55ce593607084a);
var $79cb2c9861e6f2e6$export$64aa61b1ef03133 = (0, $51e75db3e08f1d28$export$64aa61b1ef03133);
var $79cb2c9861e6f2e6$export$1ab539cfa291f28b = (0, $cbaadbeb215a441c$export$1ab539cfa291f28b);






var $denZA = parcelRequire("denZA");
function $f9221d2f70bb2d1d$var$_extends() {
    $f9221d2f70bb2d1d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9221d2f70bb2d1d$var$_extends.apply(this, arguments);
}
function $f9221d2f70bb2d1d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f9221d2f70bb2d1d$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Switch", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { spacing: spacing = "0.5rem", children: children } = _omitThemingProps, ownProps = $f9221d2f70bb2d1d$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "spacing",
        "children"
    ]);
    var { state: state, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getRootProps: getRootProps, getLabelProps: getLabelProps } = (0, $56620c7d12be8885$export$e375f10ce42261c5)(ownProps);
    var containerStyles = $denZA.useMemo(()=>$f9221d2f70bb2d1d$var$_extends({
            display: "inline-block",
            verticalAlign: "middle",
            lineHeight: "normal"
        }, styles.container), [
        styles.container
    ]);
    var trackStyles = $denZA.useMemo(()=>$f9221d2f70bb2d1d$var$_extends({
            display: "inline-flex",
            flexShrink: 0,
            justifyContent: "flex-start",
            boxSizing: "content-box",
            cursor: "pointer"
        }, styles.track), [
        styles.track
    ]);
    var labelStyles = $denZA.useMemo(()=>$f9221d2f70bb2d1d$var$_extends({
            userSelect: "none",
            marginStart: spacing
        }, styles.label), [
        spacing,
        styles.label
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).label, $f9221d2f70bb2d1d$var$_extends({}, getRootProps(), {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-switch", props.className),
        __css: containerStyles
    }), /*#__PURE__*/ $denZA.createElement("input", $f9221d2f70bb2d1d$var$_extends({
        className: "chakra-switch__input"
    }, getInputProps({}, ref))), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $f9221d2f70bb2d1d$var$_extends({}, getCheckboxProps(), {
        className: "chakra-switch__track",
        __css: trackStyles
    }), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, {
        __css: styles.thumb,
        className: "chakra-switch__thumb",
        "data-checked": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(state.isChecked),
        "data-hover": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(state.isHovered)
    })), children && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $f9221d2f70bb2d1d$var$_extends({
        className: "chakra-switch__label"
    }, getLabelProps(), {
        __css: labelStyles
    }), children));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $f9221d2f70bb2d1d$export$b5d5cf8927ab7262.displayName = "Switch";




var $denZA = parcelRequire("denZA");
var $039c31a804c3fb21$var$__assign = undefined && undefined.__assign || function() {
    $039c31a804c3fb21$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $039c31a804c3fb21$var$__assign.apply(this, arguments);
};
var $039c31a804c3fb21$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $039c31a804c3fb21$export$b5d5cf8927ab7262 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _children = _a.children, rest = $039c31a804c3fb21$var$__rest(_a, [
        "children"
    ]);
    return $denZA.createElement((0, $f9221d2f70bb2d1d$export$b5d5cf8927ab7262), $039c31a804c3fb21$var$__assign({}, rest, {
        ref: ref
    }));
});








var $denZA = parcelRequire("denZA");
function $44eca8ec83c737b1$var$_extends() {
    $44eca8ec83c737b1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44eca8ec83c737b1$var$_extends.apply(this, arguments);
}
function $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $44eca8ec83c737b1$export$f2c3aea42b2a048f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _ref;
    var { overflow: overflow, overflowX: overflowX, className: className } = props, rest = $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(props, [
        "overflow",
        "overflowX",
        "className"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $44eca8ec83c737b1$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-table__container", className)
    }, rest, {
        __css: {
            display: "block",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch",
            overflowX: (_ref = overflow != null ? overflow : overflowX) != null ? _ref : "auto",
            overflowY: "hidden",
            maxWidth: "100%"
        }
    }));
});
var $44eca8ec83c737b1$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Table", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { className: className } = _omitThemingProps, tableProps = $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).table, $44eca8ec83c737b1$var$_extends({
        role: "table",
        ref: ref,
        __css: styles.table,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-table", className)
    }, tableProps)));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $44eca8ec83c737b1$export$54ec01a60f47d33d.displayName = "Table";
var $44eca8ec83c737b1$export$35468a455d619eb3 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var { placement: placement = "bottom" } = props, rest = $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(props, [
        "placement"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).caption, $44eca8ec83c737b1$var$_extends({}, rest, {
        ref: ref,
        __css: $44eca8ec83c737b1$var$_extends({}, styles.caption, {
            captionSide: placement
        })
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $44eca8ec83c737b1$export$35468a455d619eb3.displayName = "TableCaption";
var $44eca8ec83c737b1$export$5de8fa06af5ae15a = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).thead, $44eca8ec83c737b1$var$_extends({}, props, {
        ref: ref,
        __css: styles.thead
    }));
});
var $44eca8ec83c737b1$export$e4d84274604d936d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).tbody, $44eca8ec83c737b1$var$_extends({}, props, {
        ref: ref,
        __css: styles.tbody
    }));
});
var $44eca8ec83c737b1$export$915a5a5ee2f1763d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).tfoot, $44eca8ec83c737b1$var$_extends({}, props, {
        ref: ref,
        __css: styles.tfoot
    }));
});
var $44eca8ec83c737b1$export$478f015b832c0fb2 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((_ref2, ref)=>{
    var { isNumeric: isNumeric } = _ref2, rest = $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(_ref2, [
        "isNumeric"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).th, $44eca8ec83c737b1$var$_extends({}, rest, {
        ref: ref,
        __css: styles.th,
        "data-is-numeric": isNumeric
    }));
});
var $44eca8ec83c737b1$export$3be148b8762ca608 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).tr, $44eca8ec83c737b1$var$_extends({
        role: "row"
    }, props, {
        ref: ref,
        __css: styles.tr
    }));
});
var $44eca8ec83c737b1$export$8f04ceab90eac988 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((_ref3, ref)=>{
    var { isNumeric: isNumeric } = _ref3, rest = $44eca8ec83c737b1$var$_objectWithoutPropertiesLoose(_ref3, [
        "isNumeric"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).td, $44eca8ec83c737b1$var$_extends({
        role: "gridcell"
    }, rest, {
        ref: ref,
        __css: styles.td,
        "data-is-numeric": isNumeric
    }));
});



var $denZA = parcelRequire("denZA");
var $ea1751561144cfe4$var$__assign = undefined && undefined.__assign || function() {
    $ea1751561144cfe4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea1751561144cfe4$var$__assign.apply(this, arguments);
};
var $ea1751561144cfe4$export$76ccd210b9029917 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $44eca8ec83c737b1$export$e4d84274604d936d), $ea1751561144cfe4$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $ffa1ad8b6eaabc0a$var$__assign = undefined && undefined.__assign || function() {
    $ffa1ad8b6eaabc0a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ffa1ad8b6eaabc0a$var$__assign.apply(this, arguments);
};
var $ffa1ad8b6eaabc0a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ffa1ad8b6eaabc0a$export$1e4baea7053fc0e3 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.isSortable, isSortable = _b === void 0 ? false : _b, _c = _a.isSorted, isSorted = _c === void 0 ? false : _c, _d = _a.isExpandable, isExpandable = _d === void 0 ? false : _d, _e = _a.isExpanded, isExpanded = _e === void 0 ? false : _e, _f = _a.rowDepth, rowDepth = _f === void 0 ? 0 : _f, rest = $ffa1ad8b6eaabc0a$var$__rest(_a, [
        "isSortable",
        "isSorted",
        "isExpandable",
        "isExpanded",
        "rowDepth"
    ]);
    return $denZA.createElement((0, $44eca8ec83c737b1$export$8f04ceab90eac988), $ffa1ad8b6eaabc0a$var$__assign({
        "data-expandable": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isExpandable),
        "data-expanded": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isExpanded),
        "data-row-depth": rowDepth,
        "data-sortable": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSortable),
        "data-sorted": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSorted)
    }, rest, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $edb9e95528d05b92$var$__assign = undefined && undefined.__assign || function() {
    $edb9e95528d05b92$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $edb9e95528d05b92$var$__assign.apply(this, arguments);
};
var $edb9e95528d05b92$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $edb9e95528d05b92$export$d9c82dce42546217 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.isTruncated, isTruncated = _b === void 0 ? true : _b, _c = _a.isSortable, isSortable = _c === void 0 ? false : _c, _d = _a.isSorted, isSorted = _d === void 0 ? false : _d, _e = _a.isExpandable, isExpandable = _e === void 0 ? false : _e, _f = _a.isExpanded, isExpanded = _f === void 0 ? false : _f, rest = $edb9e95528d05b92$var$__rest(_a, [
        "isTruncated",
        "isSortable",
        "isSorted",
        "isExpandable",
        "isExpanded"
    ]);
    return $denZA.createElement((0, $44eca8ec83c737b1$export$478f015b832c0fb2), $edb9e95528d05b92$var$__assign({
        "data-expandable": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isExpandable),
        "data-expanded": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isExpanded),
        "data-sortable": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSortable),
        "data-sorted": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSorted),
        isTruncated: isTruncated
    }, rest, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $aaf3cb364e75b79d$var$__assign = undefined && undefined.__assign || function() {
    $aaf3cb364e75b79d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aaf3cb364e75b79d$var$__assign.apply(this, arguments);
};
var $aaf3cb364e75b79d$export$1f116082bba1f9a8 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $44eca8ec83c737b1$export$915a5a5ee2f1763d), $aaf3cb364e75b79d$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $ba3880a799992cc6$var$__assign = undefined && undefined.__assign || function() {
    $ba3880a799992cc6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba3880a799992cc6$var$__assign.apply(this, arguments);
};
var $ba3880a799992cc6$export$2f4a7be4f0dcc2 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $44eca8ec83c737b1$export$5de8fa06af5ae15a), $ba3880a799992cc6$var$__assign({}, props, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $3182d8984e8d5eae$var$__assign = undefined && undefined.__assign || function() {
    $3182d8984e8d5eae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3182d8984e8d5eae$var$__assign.apply(this, arguments);
};
var $3182d8984e8d5eae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3182d8984e8d5eae$export$b05581f4e764e162 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.rowDepth, rowDepth = _c === void 0 ? 0 : _c, rest = $3182d8984e8d5eae$var$__rest(_a, [
        "isSelected",
        "rowDepth"
    ]);
    return $denZA.createElement((0, $44eca8ec83c737b1$export$3be148b8762ca608), $3182d8984e8d5eae$var$__assign({
        "data-row-depth": rowDepth,
        "data-selected": (0, $405775388fe7f58e$export$5cc3b7b83e34ade7)(isSelected)
    }, rest, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");






var $ed90153c01704be2$var$__assign = undefined && undefined.__assign || function() {
    $ed90153c01704be2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed90153c01704be2$var$__assign.apply(this, arguments);
};
var $ed90153c01704be2$export$54ec01a60f47d33d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $44eca8ec83c737b1$export$54ec01a60f47d33d), $ed90153c01704be2$var$__assign({}, props, {
        ref: ref
    }));
});
$ed90153c01704be2$export$54ec01a60f47d33d.Cell = (0, $ffa1ad8b6eaabc0a$export$1e4baea7053fc0e3);
$ed90153c01704be2$export$54ec01a60f47d33d.Body = (0, $ea1751561144cfe4$export$76ccd210b9029917);
$ed90153c01704be2$export$54ec01a60f47d33d.Head = (0, $ba3880a799992cc6$export$2f4a7be4f0dcc2);
$ed90153c01704be2$export$54ec01a60f47d33d.ColumnHeader = (0, $edb9e95528d05b92$export$d9c82dce42546217);
$ed90153c01704be2$export$54ec01a60f47d33d.Row = (0, $3182d8984e8d5eae$export$b05581f4e764e162);
$ed90153c01704be2$export$54ec01a60f47d33d.Footer = (0, $aaf3cb364e75b79d$export$1f116082bba1f9a8);


var $ffc8973b3fcd35cd$export$76ccd210b9029917 = (0, $ea1751561144cfe4$export$76ccd210b9029917);
var $ffc8973b3fcd35cd$export$1e4baea7053fc0e3 = (0, $ffa1ad8b6eaabc0a$export$1e4baea7053fc0e3);
var $ffc8973b3fcd35cd$export$d9c82dce42546217 = (0, $edb9e95528d05b92$export$d9c82dce42546217);
var $ffc8973b3fcd35cd$export$1f116082bba1f9a8 = (0, $aaf3cb364e75b79d$export$1f116082bba1f9a8);
var $ffc8973b3fcd35cd$export$2f4a7be4f0dcc2 = (0, $ba3880a799992cc6$export$2f4a7be4f0dcc2);
var $ffc8973b3fcd35cd$export$b05581f4e764e162 = (0, $3182d8984e8d5eae$export$b05581f4e764e162);









var $denZA = parcelRequire("denZA");
function $3222bb9a0c18e31a$var$_extends() {
    $3222bb9a0c18e31a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3222bb9a0c18e31a$var$_extends.apply(this, arguments);
}
function $3222bb9a0c18e31a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var [$3222bb9a0c18e31a$export$29ffb0a76b0529f5, $3222bb9a0c18e31a$export$41df96b51c5f5358, $3222bb9a0c18e31a$export$82af15abb0e12d09, $3222bb9a0c18e31a$export$48a1e112587310fb] = (0, $a709b5585b66f1e1$export$126c4100f8947d7)();
function $3222bb9a0c18e31a$export$d2589202ac9c89c3(props) {
    var { defaultIndex: defaultIndex, onChange: onChange, index: index, isManual: isManual, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", orientation: orientation = "horizontal", direction: direction = "ltr" } = props, htmlProps = $3222bb9a0c18e31a$var$_objectWithoutPropertiesLoose(props, [
        "defaultIndex",
        "onChange",
        "index",
        "isManual",
        "isLazy",
        "lazyBehavior",
        "orientation",
        "direction"
    ]);
    /**
   * We use this to keep track of the index of the focused tab.
   *
   * Tabs can be automatically activated, this means selection follows focus.
   * When we navigate with the arrow keys, we move focus and selection to next/prev tab
   *
   * Tabs can also be manually activated, this means selection does not follow focus.
   * When we navigate with the arrow keys, we only move focus NOT selection. The user
   * will need not manually activate the tab using `Enter` or `Space`.
   *
   * This is why we need to keep track of the `focusedIndex` and `selectedIndex`
   */ var [focusedIndex, setFocusedIndex] = $denZA.useState(defaultIndex != null ? defaultIndex : 0);
    var [selectedIndex, setSelectedIndex] = (0, $53a3d6ee771ef939$export$6f32135080cb4c3)({
        defaultValue: defaultIndex != null ? defaultIndex : 0,
        value: index,
        onChange: onChange
    });
    /**
   * Sync focused `index` with controlled `selectedIndex` (which is the `props.index`)
   */ $denZA.useEffect(()=>{
        if (index != null) setFocusedIndex(index);
    }, [
        index
    ]);
    /**
   * Think of `useDescendants` as a register for the tab nodes.
   */ var descendants = $3222bb9a0c18e31a$export$82af15abb0e12d09();
    /**
   * Generate a unique id or use user-provided id for the tabs widget
   */ var id = (0, $63207b263e1aef60$export$f680877a34711e37)(props.id, "tabs");
    return {
        id: id,
        selectedIndex: selectedIndex,
        focusedIndex: focusedIndex,
        setSelectedIndex: setSelectedIndex,
        setFocusedIndex: setFocusedIndex,
        isManual: isManual,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        orientation: orientation,
        descendants: descendants,
        direction: direction,
        htmlProps: htmlProps
    };
}
var [$3222bb9a0c18e31a$export$aea4e5437b3b752e, $3222bb9a0c18e31a$export$5c3d36c3adf0ba92] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "TabsContext",
    errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function $3222bb9a0c18e31a$export$773e389e644c5874(props) {
    var { focusedIndex: focusedIndex, orientation: orientation, direction: direction } = $3222bb9a0c18e31a$export$5c3d36c3adf0ba92();
    var descendants = $3222bb9a0c18e31a$export$41df96b51c5f5358();
    var onKeyDown = $denZA.useCallback((event)=>{
        var nextTab = ()=>{
            var next = descendants.nextEnabled(focusedIndex);
            if (next) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(next.node);
        };
        var prevTab = ()=>{
            var prev = descendants.prevEnabled(focusedIndex);
            if (prev) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(prev.node);
        };
        var firstTab = ()=>{
            var first = descendants.firstEnabled();
            if (first) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(first.node);
        };
        var lastTab = ()=>{
            var last = descendants.lastEnabled();
            if (last) (0, $05d433d46dbef2db$export$d7ddd398f22d79ef)(last.node);
        };
        var isHorizontal = orientation === "horizontal";
        var isVertical = orientation === "vertical";
        var eventKey = (0, $405775388fe7f58e$export$17948c8429b9b73a)(event);
        var ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
        var ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
        var keyMap = {
            [ArrowStart]: ()=>isHorizontal && prevTab(),
            [ArrowEnd]: ()=>isHorizontal && nextTab(),
            ArrowDown: ()=>isVertical && nextTab(),
            ArrowUp: ()=>isVertical && prevTab(),
            Home: firstTab,
            End: lastTab
        };
        var action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            action(event);
        }
    }, [
        descendants,
        focusedIndex,
        orientation,
        direction
    ]);
    return $3222bb9a0c18e31a$var$_extends({}, props, {
        role: "tablist",
        "aria-orientation": orientation,
        onKeyDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    });
}
function $3222bb9a0c18e31a$export$fdf4756d5b8ef90a(props) {
    var { isDisabled: isDisabled, isFocusable: isFocusable } = props, htmlProps = $3222bb9a0c18e31a$var$_objectWithoutPropertiesLoose(props, [
        "isDisabled",
        "isFocusable"
    ]);
    var { setSelectedIndex: setSelectedIndex, isManual: isManual, id: id, setFocusedIndex: setFocusedIndex, selectedIndex: selectedIndex } = $3222bb9a0c18e31a$export$5c3d36c3adf0ba92();
    var { index: index, register: register } = $3222bb9a0c18e31a$export$48a1e112587310fb({
        disabled: isDisabled && !isFocusable
    });
    var isSelected = index === selectedIndex;
    var onClick = ()=>{
        setSelectedIndex(index);
    };
    var onFocus = ()=>{
        setFocusedIndex(index);
        var isDisabledButFocusable = isDisabled && isFocusable;
        var shouldSelect = !isManual && !isDisabledButFocusable;
        if (shouldSelect) setSelectedIndex(index);
    };
    var clickableProps = (0, $7471193ff97457bc$export$ed213cc82e426b1a)($3222bb9a0c18e31a$var$_extends({}, htmlProps, {
        ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(register, props.ref),
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onClick)
    }));
    var type = "button";
    return $3222bb9a0c18e31a$var$_extends({}, clickableProps, {
        id: $3222bb9a0c18e31a$var$makeTabId(id, index),
        role: "tab",
        tabIndex: isSelected ? 0 : -1,
        type: type,
        "aria-selected": isSelected,
        "aria-controls": $3222bb9a0c18e31a$var$makeTabPanelId(id, index),
        onFocus: isDisabled ? undefined : (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, onFocus)
    });
}
function $3222bb9a0c18e31a$export$a7a84e09564ff6eb(props) {
    var context = $3222bb9a0c18e31a$export$5c3d36c3adf0ba92();
    var { id: id, selectedIndex: selectedIndex } = context;
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(props.children);
    var children = validChildren.map((child, index)=>/*#__PURE__*/ $denZA.cloneElement(child, {
            isSelected: index === selectedIndex,
            id: $3222bb9a0c18e31a$var$makeTabPanelId(id, index),
            // Refers to the associated tab element, and also provides an accessible name to the tab panel.
            "aria-labelledby": $3222bb9a0c18e31a$var$makeTabId(id, index)
        }));
    return $3222bb9a0c18e31a$var$_extends({}, props, {
        children: children
    });
}
function $3222bb9a0c18e31a$export$fae0121b5afe572d(props) {
    var { isSelected: isSelected, id: id, children: children } = props, htmlProps = $3222bb9a0c18e31a$var$_objectWithoutPropertiesLoose(props, [
        "isSelected",
        "id",
        "children"
    ]);
    var { isLazy: isLazy, lazyBehavior: lazyBehavior } = $3222bb9a0c18e31a$export$5c3d36c3adf0ba92();
    var hasBeenSelected = $denZA.useRef(false);
    if (isSelected) hasBeenSelected.current = true;
    var shouldRenderChildren = (0, $5567c7a86419f354$export$1f16c1e83f5de19d)({
        hasBeenSelected: hasBeenSelected.current,
        isSelected: isSelected,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior
    });
    return $3222bb9a0c18e31a$var$_extends({
        // Puts the tabpanel in the page `Tab` sequence.
        tabIndex: 0
    }, htmlProps, {
        children: shouldRenderChildren ? children : null,
        role: "tabpanel",
        hidden: !isSelected,
        id: id
    });
}
function $3222bb9a0c18e31a$export$99e5024a51e009d8() {
    var context = $3222bb9a0c18e31a$export$5c3d36c3adf0ba92();
    var descendants = $3222bb9a0c18e31a$export$41df96b51c5f5358();
    var { selectedIndex: selectedIndex, orientation: orientation } = context;
    var isHorizontal = orientation === "horizontal";
    var isVertical = orientation === "vertical"; // Get the clientRect of the selected tab
    var [rect, setRect] = $denZA.useState(()=>{
        if (isHorizontal) return {
            left: 0,
            width: 0
        };
        if (isVertical) return {
            top: 0,
            height: 0
        };
        return undefined;
    });
    var [hasMeasured, setHasMeasured] = $denZA.useState(false); // Update the selected tab rect when the selectedIndex changes
    (0, $a54e4d92878f49b7$export$deebe11a338de063)(()=>{
        if ((0, $6b74ef5ae6a56e47$export$fce6876652108ab)(selectedIndex)) return undefined;
        var tab = descendants.item(selectedIndex);
        if ((0, $6b74ef5ae6a56e47$export$fce6876652108ab)(tab)) return undefined; // Horizontal Tab: Calculate width and left distance
        if (isHorizontal) setRect({
            left: tab.node.offsetLeft,
            width: tab.node.offsetWidth
        });
         // Vertical Tab: Calculate height and top distance
        if (isVertical) setRect({
            top: tab.node.offsetTop,
            height: tab.node.offsetHeight
        });
         // Prevent unwanted transition from 0 to measured rect
        // by setting the measured state in the next tick
        var id = requestAnimationFrame(()=>{
            setHasMeasured(true);
        });
        return ()=>{
            if (id) cancelAnimationFrame(id);
        };
    }, [
        selectedIndex,
        isHorizontal,
        isVertical,
        descendants
    ]);
    return $3222bb9a0c18e31a$var$_extends({
        position: "absolute",
        transitionProperty: "left, right, top, bottom",
        transitionDuration: hasMeasured ? "200ms" : "0ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)"
    }, rect);
}
function $3222bb9a0c18e31a$var$makeTabId(id, index) {
    return id + "--tab-" + index;
}
function $3222bb9a0c18e31a$var$makeTabPanelId(id, index) {
    return id + "--tabpanel-" + index;
}




var $denZA = parcelRequire("denZA");
var $cb8151c5ea80ef78$var$__assign = undefined && undefined.__assign || function() {
    $cb8151c5ea80ef78$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cb8151c5ea80ef78$var$__assign.apply(this, arguments);
};
var $cb8151c5ea80ef78$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cb8151c5ea80ef78$var$TabIcon = function(props) {
    var children = props.children, className = props.className, rest = $cb8151c5ea80ef78$var$__rest(props, [
        "children",
        "className"
    ]);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _children = $denZA.isValidElement(children) ? $denZA.cloneElement(children, {
        'aria-hidden': true,
        focusable: false
    }) : children;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _className = (0, $405775388fe7f58e$export$a274e22fb40f762e)('chakra-tab__icon', className);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $cb8151c5ea80ef78$var$__assign({}, rest, {
        className: _className
    }), _children);
};
var $cb8151c5ea80ef78$export$3e41faf802a29e71 = $denZA.forwardRef(function(_a, ref) {
    var leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, _b = _a.iconSpacing, iconSpacing = _b === void 0 ? '0.5rem' : _b, props = $cb8151c5ea80ef78$var$__rest(_a, [
        "leftIcon",
        "rightIcon",
        "iconSpacing"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var tabProps = (0, $3222bb9a0c18e31a$export$fdf4756d5b8ef90a)($cb8151c5ea80ef78$var$__assign($cb8151c5ea80ef78$var$__assign({}, props), {
        ref: ref
    }));
    var tabStyles = $cb8151c5ea80ef78$var$__assign({
        outline: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }, styles.tab);
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $cb8151c5ea80ef78$var$__assign({}, tabProps, {
        __css: tabStyles,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)('chakra-tabs__tab', props.className)
    }), leftIcon && $denZA.createElement($cb8151c5ea80ef78$var$TabIcon, {
        marginEnd: iconSpacing
    }, leftIcon), tabProps.children, rightIcon && $denZA.createElement($cb8151c5ea80ef78$var$TabIcon, {
        marginStart: iconSpacing
    }, rightIcon));
});






var $denZA = parcelRequire("denZA");

function $c90ad350e8ab3af5$var$_extends() {
    $c90ad350e8ab3af5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c90ad350e8ab3af5$var$_extends.apply(this, arguments);
}
function $c90ad350e8ab3af5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c90ad350e8ab3af5$export$b2539bed5023c21c = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Tabs", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { children: children, className: className } = _omitThemingProps, rest = $c90ad350e8ab3af5$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "children",
        "className"
    ]);
    var _useTabs = (0, $3222bb9a0c18e31a$export$d2589202ac9c89c3)(rest), { htmlProps: htmlProps, descendants: descendants } = _useTabs, ctx = $c90ad350e8ab3af5$var$_objectWithoutPropertiesLoose(_useTabs, [
        "htmlProps",
        "descendants"
    ]);
    var context = $denZA.useMemo(()=>ctx, [
        ctx
    ]);
    var rootProps = (0, $dfe73229adf076fd$export$30a06c8d3562193f)(htmlProps, [
        "isFitted"
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $3222bb9a0c18e31a$export$29ffb0a76b0529f5), {
        value: descendants
    }, /*#__PURE__*/ $denZA.createElement((0, $3222bb9a0c18e31a$export$aea4e5437b3b752e), {
        value: context
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c90ad350e8ab3af5$var$_extends({
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs", className),
        ref: ref
    }, rootProps, {
        __css: styles.root
    }), children))));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$b2539bed5023c21c.displayName = "Tabs";
var $c90ad350e8ab3af5$export$3e41faf802a29e71 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var tabProps = (0, $3222bb9a0c18e31a$export$fdf4756d5b8ef90a)($c90ad350e8ab3af5$var$_extends({}, props, {
        ref: ref
    }));
    var tabStyles = $c90ad350e8ab3af5$var$_extends({
        outline: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, styles.tab);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $c90ad350e8ab3af5$var$_extends({}, tabProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs__tab", props.className),
        __css: tabStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$3e41faf802a29e71.displayName = "Tab";
var $c90ad350e8ab3af5$export$e51a686c67fdaa2d = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var tablistProps = (0, $3222bb9a0c18e31a$export$773e389e644c5874)($c90ad350e8ab3af5$var$_extends({}, props, {
        ref: ref
    }));
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var tablistStyles = $c90ad350e8ab3af5$var$_extends({
        display: "flex"
    }, styles.tablist);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c90ad350e8ab3af5$var$_extends({}, tablistProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs__tablist", props.className),
        __css: tablistStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$e51a686c67fdaa2d.displayName = "TabList";
var $c90ad350e8ab3af5$export$3d96ec278d3efce4 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var panelProps = (0, $3222bb9a0c18e31a$export$fae0121b5afe572d)($c90ad350e8ab3af5$var$_extends({}, props, {
        ref: ref
    }));
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c90ad350e8ab3af5$var$_extends({
        outline: "0"
    }, panelProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs__tab-panel", props.className),
        __css: styles.tabpanel
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$3d96ec278d3efce4.displayName = "TabPanel";
var $c90ad350e8ab3af5$export$5dae8d435677f210 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var panelsProps = (0, $3222bb9a0c18e31a$export$a7a84e09564ff6eb)(props);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c90ad350e8ab3af5$var$_extends({}, panelsProps, {
        width: "100%",
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs__tab-panels", props.className),
        __css: styles.tabpanels
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$5dae8d435677f210.displayName = "TabPanels";
var $c90ad350e8ab3af5$export$f770f8d0ca48f756 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var indicatorStyle = (0, $3222bb9a0c18e31a$export$99e5024a51e009d8)();
    var style = $c90ad350e8ab3af5$var$_extends({}, props.style, indicatorStyle);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $c90ad350e8ab3af5$var$_extends({
        ref: ref
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-tabs__tab-indicator", props.className),
        style: style,
        __css: styles.indicator
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $c90ad350e8ab3af5$export$f770f8d0ca48f756.displayName = "TabIndicator";



var $denZA = parcelRequire("denZA");
var $823640a7d46b0374$var$__assign = undefined && undefined.__assign || function() {
    $823640a7d46b0374$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $823640a7d46b0374$var$__assign.apply(this, arguments);
};
var $823640a7d46b0374$export$e51a686c67fdaa2d = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c90ad350e8ab3af5$export$e51a686c67fdaa2d), $823640a7d46b0374$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $1bda9a2dda0e4e8a$var$__assign = undefined && undefined.__assign || function() {
    $1bda9a2dda0e4e8a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1bda9a2dda0e4e8a$var$__assign.apply(this, arguments);
};
var $1bda9a2dda0e4e8a$export$3d96ec278d3efce4 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c90ad350e8ab3af5$export$3d96ec278d3efce4), $1bda9a2dda0e4e8a$var$__assign({
        tabIndex: -1
    }, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $730ff35f1502bf23$var$__assign = undefined && undefined.__assign || function() {
    $730ff35f1502bf23$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $730ff35f1502bf23$var$__assign.apply(this, arguments);
};
var $730ff35f1502bf23$export$5dae8d435677f210 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c90ad350e8ab3af5$export$5dae8d435677f210), $730ff35f1502bf23$var$__assign({}, props, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");




var $26ec4bb7561cb84e$var$__assign = undefined && undefined.__assign || function() {
    $26ec4bb7561cb84e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26ec4bb7561cb84e$var$__assign.apply(this, arguments);
};
var $26ec4bb7561cb84e$export$b2539bed5023c21c = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $c90ad350e8ab3af5$export$b2539bed5023c21c), $26ec4bb7561cb84e$var$__assign({}, props, {
        ref: ref
    }));
});
$26ec4bb7561cb84e$export$b2539bed5023c21c.Tab = (0, $cb8151c5ea80ef78$export$3e41faf802a29e71);
$26ec4bb7561cb84e$export$b2539bed5023c21c.TabList = (0, $823640a7d46b0374$export$e51a686c67fdaa2d);
$26ec4bb7561cb84e$export$b2539bed5023c21c.TabPanel = (0, $1bda9a2dda0e4e8a$export$3d96ec278d3efce4);
$26ec4bb7561cb84e$export$b2539bed5023c21c.TabPanels = (0, $730ff35f1502bf23$export$5dae8d435677f210);


var $c30430b8cb3854fd$export$3e41faf802a29e71 = (0, $cb8151c5ea80ef78$export$3e41faf802a29e71);
var $c30430b8cb3854fd$export$e51a686c67fdaa2d = (0, $823640a7d46b0374$export$e51a686c67fdaa2d);
var $c30430b8cb3854fd$export$3d96ec278d3efce4 = (0, $1bda9a2dda0e4e8a$export$3d96ec278d3efce4);
var $c30430b8cb3854fd$export$5dae8d435677f210 = (0, $730ff35f1502bf23$export$5dae8d435677f210);






var $denZA = parcelRequire("denZA");
function $10d55e7fd9a34d69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $10d55e7fd9a34d69$var$_extends() {
    $10d55e7fd9a34d69$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $10d55e7fd9a34d69$var$_extends.apply(this, arguments);
}
var $10d55e7fd9a34d69$export$3288d34c523a1192 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Tag", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var containerStyles = $10d55e7fd9a34d69$var$_extends({
        display: "inline-flex",
        verticalAlign: "top",
        alignItems: "center",
        maxWidth: "100%"
    }, styles.container);
    return /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $10d55e7fd9a34d69$var$_extends({
        ref: ref
    }, ownProps, {
        __css: containerStyles
    })));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$export$3288d34c523a1192.displayName = "Tag";
var $10d55e7fd9a34d69$export$f5486329f0fd0847 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $10d55e7fd9a34d69$var$_extends({
        ref: ref,
        isTruncated: true
    }, props, {
        __css: styles.label
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$export$f5486329f0fd0847.displayName = "TagLabel";
var $10d55e7fd9a34d69$export$1b1a9388acf57360 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $10d55e7fd9a34d69$var$_extends({
        ref: ref,
        verticalAlign: "top",
        marginEnd: "0.5rem"
    }, props)));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$export$1b1a9388acf57360.displayName = "TagLeftIcon";
var $10d55e7fd9a34d69$export$469b69b26b54518e = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $10d55e7fd9a34d69$var$_extends({
        ref: ref,
        verticalAlign: "top",
        marginStart: "0.5rem"
    }, props)));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$export$469b69b26b54518e.displayName = "TagRightIcon";
var $10d55e7fd9a34d69$var$TagCloseIcon = (props)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $10d55e7fd9a34d69$var$_extends({
        verticalAlign: "inherit",
        viewBox: "0 0 512 512"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
    }));
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$var$TagCloseIcon.displayName = "TagCloseIcon";
var $10d55e7fd9a34d69$export$2c1e51182f03e1ee = (props)=>{
    var { isDisabled: isDisabled, children: children } = props, rest = $10d55e7fd9a34d69$var$_objectWithoutPropertiesLoose(props, [
        "isDisabled",
        "children"
    ]);
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var btnStyles = $10d55e7fd9a34d69$var$_extends({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "0"
    }, styles.closeButton);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).button, $10d55e7fd9a34d69$var$_extends({}, rest, {
        type: "button",
        "aria-label": "close",
        disabled: isDisabled,
        __css: btnStyles
    }), children || /*#__PURE__*/ $denZA.createElement($10d55e7fd9a34d69$var$TagCloseIcon, null));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $10d55e7fd9a34d69$export$2c1e51182f03e1ee.displayName = "TagCloseButton";



var $denZA = parcelRequire("denZA");
var $6440cb9785158a6b$var$__assign = undefined && undefined.__assign || function() {
    $6440cb9785158a6b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6440cb9785158a6b$var$__assign.apply(this, arguments);
};
var $6440cb9785158a6b$export$2c1e51182f03e1ee = function(props) {
    return $denZA.createElement((0, $10d55e7fd9a34d69$export$2c1e51182f03e1ee), $6440cb9785158a6b$var$__assign({}, props));
};




var $denZA = parcelRequire("denZA");
var $2e4bc692ae9ad707$var$__assign = undefined && undefined.__assign || function() {
    $2e4bc692ae9ad707$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e4bc692ae9ad707$var$__assign.apply(this, arguments);
};
var $2e4bc692ae9ad707$export$f5486329f0fd0847 = function(props) {
    return $denZA.createElement((0, $10d55e7fd9a34d69$export$f5486329f0fd0847), $2e4bc692ae9ad707$var$__assign({}, props));
};





var $denZA = parcelRequire("denZA");


var $631fbf6cd923cd39$var$__assign = undefined && undefined.__assign || function() {
    $631fbf6cd923cd39$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $631fbf6cd923cd39$var$__assign.apply(this, arguments);
};
var $631fbf6cd923cd39$export$3288d34c523a1192 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    return $denZA.createElement((0, $10d55e7fd9a34d69$export$3288d34c523a1192), $631fbf6cd923cd39$var$__assign({}, props, {
        ref: ref
    }));
});
$631fbf6cd923cd39$export$3288d34c523a1192.Label = (0, $2e4bc692ae9ad707$export$f5486329f0fd0847);
$631fbf6cd923cd39$export$3288d34c523a1192.CloseButton = (0, $6440cb9785158a6b$export$2c1e51182f03e1ee);


var $83988d539cd985bb$export$2c1e51182f03e1ee = (0, $6440cb9785158a6b$export$2c1e51182f03e1ee);
var $83988d539cd985bb$export$f5486329f0fd0847 = (0, $2e4bc692ae9ad707$export$f5486329f0fd0847);





var $denZA = parcelRequire("denZA");
function $5adeae8cbe9cc9c1$var$_extends() {
    $5adeae8cbe9cc9c1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5adeae8cbe9cc9c1$var$_extends.apply(this, arguments);
}
function $5adeae8cbe9cc9c1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5adeae8cbe9cc9c1$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Text", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), rest = $5adeae8cbe9cc9c1$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className",
        "align",
        "decoration",
        "casing"
    ]);
    var aliasedProps = (0, $dfe73229adf076fd$export$2458ce75c8ef9806)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).p, $5adeae8cbe9cc9c1$var$_extends({
        ref: ref,
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-text", props.className)
    }, aliasedProps, rest, {
        __css: styles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $5adeae8cbe9cc9c1$export$5f1af8db9871e1d6.displayName = "Text";




var $denZA = parcelRequire("denZA");
var $a19c61bc3a46cfb9$var$__assign = undefined && undefined.__assign || function() {
    $a19c61bc3a46cfb9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a19c61bc3a46cfb9$var$__assign.apply(this, arguments);
};
var $a19c61bc3a46cfb9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a19c61bc3a46cfb9$export$5f1af8db9871e1d6 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var isTruncated = _a.isTruncated, noOfLines = _a.noOfLines, props = $a19c61bc3a46cfb9$var$__rest(_a, [
        "isTruncated",
        "noOfLines"
    ]);
    return $denZA.createElement((0, $5adeae8cbe9cc9c1$export$5f1af8db9871e1d6), $a19c61bc3a46cfb9$var$__assign({
        // always disable truncated if noOfLines is set
        isTruncated: noOfLines ? false : isTruncated,
        noOfLines: noOfLines
    }, props, {
        ref: ref
    }));
});









var $denZA = parcelRequire("denZA");
function $deafe962bb58118c$var$_extends() {
    $deafe962bb58118c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $deafe962bb58118c$var$_extends.apply(this, arguments);
}
function $deafe962bb58118c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $deafe962bb58118c$export$379139ebc1c2b235 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Textarea", props);
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { className: className, rows: rows } = _omitThemingProps, rest = $deafe962bb58118c$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "className",
        "rows"
    ]);
    var textareaProps = (0, $a9ca37b5c0c19e69$export$62ecd8ad1bbe1a18)(rest);
    var omitted = [
        "h",
        "minH",
        "height",
        "minHeight"
    ];
    var textareaStyles = rows ? (0, $dfe73229adf076fd$export$30a06c8d3562193f)(styles, omitted) : styles;
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).textarea, $deafe962bb58118c$var$_extends({
        ref: ref,
        rows: rows
    }, textareaProps, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-textarea", className),
        __css: textareaStyles
    }));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $deafe962bb58118c$export$379139ebc1c2b235.displayName = "Textarea";



var $denZA = parcelRequire("denZA");
var $8b808192b9672559$var$__assign = undefined && undefined.__assign || function() {
    $8b808192b9672559$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8b808192b9672559$var$__assign.apply(this, arguments);
};
var $8b808192b9672559$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8b808192b9672559$export$379139ebc1c2b235 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var rest = $8b808192b9672559$var$__rest(_a, []);
    return $denZA.createElement((0, $deafe962bb58118c$export$379139ebc1c2b235), $8b808192b9672559$var$__assign({}, rest, {
        ref: ref
    }));
});




var $6437acd995b5bada$exports = {};
var $7d3dedf070cf3fda$exports = {};

$parcel$export($7d3dedf070cf3fda$exports, "Accordion", function () { return $7d3dedf070cf3fda$export$a766cd26d0d69044; });

var $7d3dedf070cf3fda$var$parts = [
    'container',
    'button',
    'panel'
];
var $7d3dedf070cf3fda$var$baseStyleContainer = function(props) {
    return {
        boxSizing: 'border-box',
        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.400')(props),
        _first: {
            borderTopWidth: '2px'
        },
        borderBottomWidth: '2px'
    };
};
var $7d3dedf070cf3fda$var$baseStyleButton = function(props) {
    var theme = props.theme;
    return {
        textAlign: 'left',
        fontWeight: 'medium',
        _focusVisible: {
            boxShadow: 'focusVisible',
            zIndex: 'focus'
        },
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme), (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.400', 0.05)(theme))(props)
        },
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    };
};
var $7d3dedf070cf3fda$var$baseStylePanel = {
    _focus: {
        outline: 'none'
    },
    pt: 2,
    px: 2,
    pb: 5
};
var $7d3dedf070cf3fda$var$sizes = {
    sm: {
        button: {
            py: '1',
            px: '2',
            textStyle: 'md'
        },
        panel: {
            py: '1',
            px: '2',
            paddingBottom: '3',
            textStyle: 'sm'
        }
    },
    md: {
        button: {
            py: '2',
            px: '3',
            textStyle: 'xl'
        },
        panel: {
            py: '2',
            px: '3',
            paddingBottom: '4',
            textStyle: 'md'
        }
    },
    lg: {
        button: {
            py: '3',
            px: '4',
            textStyle: '2xl'
        },
        panel: {
            py: '3',
            px: '4',
            paddingBottom: '5',
            textStyle: 'lg'
        }
    }
};
var $7d3dedf070cf3fda$var$baseStyle = function(props) {
    return {
        container: $7d3dedf070cf3fda$var$baseStyleContainer(props),
        button: $7d3dedf070cf3fda$var$baseStyleButton(props),
        panel: $7d3dedf070cf3fda$var$baseStylePanel
    };
};
var $7d3dedf070cf3fda$var$defaultProps = {
    size: 'md'
};
var $7d3dedf070cf3fda$export$a766cd26d0d69044 = {
    parts: $7d3dedf070cf3fda$var$parts,
    sizes: $7d3dedf070cf3fda$var$sizes,
    baseStyle: $7d3dedf070cf3fda$var$baseStyle,
    defaultProps: $7d3dedf070cf3fda$var$defaultProps
};


var $e045a5ccb85754e2$exports = {};

$parcel$export($e045a5ccb85754e2$exports, "Avatar", function () { return $e045a5ccb85754e2$export$e2255cf6045e8d47; });

var $77e571de9afb463d$exports = {};

$parcel$export($77e571de9afb463d$exports, "sizes", function () { return $77e571de9afb463d$export$c647cb0ee6e282fe; });
var $ff3c8449b764055d$exports = {};

$parcel$export($ff3c8449b764055d$exports, "space", function () { return $ff3c8449b764055d$export$a941ed4b947d12f8; });
/**
 * Spaces are in scales of the equivalent of 4px.
 */ var $ff3c8449b764055d$export$a941ed4b947d12f8 = {
    0: '0',
    '0.5': '0.125rem',
    '1': '0.25rem',
    '1.5': '0.375rem',
    '2': '0.5rem',
    '2.5': '0.625rem',
    '3': '0.75rem',
    '3.5': '0.875rem',
    '4': '1rem',
    '4.5': '1.125rem',
    '5': '1.25rem',
    '5.5': '1.375rem',
    '6': '1.5rem',
    '6.5': '1.625rem',
    '7': '1.75rem',
    '7.5': '1.875rem',
    '8': '2rem',
    '8.5': '2.125rem',
    '9': '2.25rem',
    '9.5': '2.375rem',
    '10': '2.5rem',
    '10.5': '2.625rem',
    '11': '2.75rem',
    '11.5': '2.875rem',
    '12': '3rem',
    '12.5': '3.125rem',
    '13': '3.25rem',
    '13.5': '3.375rem',
    '14': '3.5rem',
    '14.5': '3.625rem',
    '15': '3.75rem',
    '15.5': '3.875rem',
    '16': '4rem',
    '16.5': '4.125rem',
    '17': '4.25rem',
    '17.5': '4.375rem',
    '18': '4.5rem',
    '18.5': '4.625rem',
    '19': '4.75rem',
    '19.5': '4.875rem',
    '20': '5rem',
    '20.5': '5.125rem',
    '21': '5.25rem',
    '21.5': '5.375rem',
    '22': '5.5rem',
    '22.5': '5.625rem',
    '23': '5.75rem',
    '23.5': '5.875rem',
    '24': '6rem',
    '24.5': '6.125rem',
    '25': '6.25rem',
    '25.5': '6.375rem',
    '26': '6.5rem',
    '26.5': '6.625rem',
    '27': '6.75rem',
    '27.5': '6.875rem',
    '28': '7rem',
    '28.5': '7.125rem',
    '29': '7.25rem',
    '29.5': '7.375rem',
    '30': '7.5rem',
    '30.5': '7.625rem',
    '31': '7.75rem',
    '31.5': '7.875rem',
    '32': '8rem',
    '32.5': '8.125rem',
    '33': '8.25rem',
    '33.5': '8.375rem',
    '34': '8.5rem',
    '34.5': '8.625rem',
    '35': '8.75rem',
    '35.5': '8.875rem',
    '36': '9rem',
    '36.5': '9.125rem',
    '37': '9.25rem',
    '37.5': '9.375rem',
    '38': '9.5rem',
    '38.5': '9.625rem',
    '39': '9.75rem',
    '39.5': '9.875rem',
    '40': '10rem'
};


var $77e571de9afb463d$var$__assign = undefined && undefined.__assign || function() {
    $77e571de9afb463d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $77e571de9afb463d$var$__assign.apply(this, arguments);
};
var $77e571de9afb463d$var$largeSizes = {
    max: 'max-content',
    min: 'min-content',
    full: '100%',
    '3xs': '14rem',
    '2xs': '16rem',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    '8xl': '90rem'
};
var $77e571de9afb463d$var$container = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
};
var $77e571de9afb463d$export$c647cb0ee6e282fe = $77e571de9afb463d$var$__assign($77e571de9afb463d$var$__assign($77e571de9afb463d$var$__assign({}, (0, $ff3c8449b764055d$export$a941ed4b947d12f8)), $77e571de9afb463d$var$largeSizes), {
    container: $77e571de9afb463d$var$container
});


var $e045a5ccb85754e2$var$parts = [
    'container',
    'excessLabel',
    'badge',
    'label'
];
var $e045a5ccb85754e2$var$baseStyleBadge = function(props) {
    return {
        transform: 'translate(25%, 25%)',
        borderRadius: 'full',
        borderStyle: 'solid',
        borderWidth: '0.125em',
        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.600')(props),
        backgroundColor: 'success.400'
    };
};
var $e045a5ccb85754e2$var$baseStyleExcessLabel = function(props) {
    return {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.600')(props),
        bg: (0, $f466d5c40b760069$export$549ff81930776885)('slate.200', 'slate.700')(props)
    };
};
var $e045a5ccb85754e2$var$baseStyleContainer = function(props) {
    var name = props.name, theme = props.theme;
    var bg = name ? (0, $188d0d70c4460bfd$export$f3c6ed4330abfc18)({
        string: name,
        colors: [
            'turquoise.600',
            'light-blue.600',
            'dark-blue.600',
            'copper.600',
            'teal.600',
            'purple.600',
            'magenta.600'
        ]
    }) : 'slate.100';
    var isBgDark = (0, $188d0d70c4460bfd$export$a79ad82046afa44e)(bg)(theme);
    var color = 'white';
    if (!isBgDark) color = 'slate.900';
    var borderColor = (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.600')(props);
    return {
        bg: bg,
        color: color,
        borderColor: borderColor,
        verticalAlign: 'top',
        boxSizing: 'border-box'
    };
};
var $e045a5ccb85754e2$var$baseStyle = function(props) {
    return {
        badge: $e045a5ccb85754e2$var$baseStyleBadge(props),
        excessLabel: $e045a5ccb85754e2$var$baseStyleExcessLabel(props),
        container: $e045a5ccb85754e2$var$baseStyleContainer(props)
    };
};
var $e045a5ccb85754e2$var$getSize = function(size) {
    var themeSize = (0, $77e571de9afb463d$export$c647cb0ee6e282fe)[size];
    return {
        container: {
            width: size,
            height: size,
            fontSize: "calc(" + themeSize + " / 2.5)"
        },
        excessLabel: {
            width: size,
            height: size
        },
        label: {
            fontSize: "calc(" + themeSize + " / 2.5)",
            lineHeight: size !== 'full' ? themeSize : undefined
        },
        badge: {
            width: '1.25em',
            height: '1.25em'
        }
    };
};
var $e045a5ccb85754e2$var$sizes = {
    '2xs': $e045a5ccb85754e2$var$getSize('4'),
    xs: $e045a5ccb85754e2$var$getSize('6'),
    sm: $e045a5ccb85754e2$var$getSize('8'),
    md: $e045a5ccb85754e2$var$getSize('12'),
    lg: $e045a5ccb85754e2$var$getSize('16'),
    xl: $e045a5ccb85754e2$var$getSize('24'),
    '2xl': $e045a5ccb85754e2$var$getSize('32'),
    full: $e045a5ccb85754e2$var$getSize('full')
};
var $e045a5ccb85754e2$var$defaultProps = {
    size: 'md'
};
var $e045a5ccb85754e2$export$e2255cf6045e8d47 = {
    parts: $e045a5ccb85754e2$var$parts,
    baseStyle: $e045a5ccb85754e2$var$baseStyle,
    sizes: $e045a5ccb85754e2$var$sizes,
    defaultProps: $e045a5ccb85754e2$var$defaultProps
};


var $f4510e75fd105402$exports = {};

$parcel$export($f4510e75fd105402$exports, "Breadcrumb", function () { return $f4510e75fd105402$export$dabcc1ec9dd9d1cc; });


var $e5Q7j = parcelRequire("e5Q7j");
var $0372a0fa0a68a42f$exports = {};

$parcel$export($0372a0fa0a68a42f$exports, "Link", function () { return $0372a0fa0a68a42f$export$a6c7ac8248d6e38a; });

var $0372a0fa0a68a42f$var$baseStyle = function(props) {
    var c = props.colorScheme;
    return {
        display: 'inline-block',
        transition: "all 0.15s ease-out",
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'white')(props),
        fontWeight: 'medium',
        _hover: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", 'white')(props),
            textDecoration: 'underline',
            textDecorationThickness: '1px'
        },
        _active: {
            color: c + ".600"
        },
        _focusVisible: {
            boxShadow: 'focusVisible'
        }
    };
};
var $0372a0fa0a68a42f$var$sizes = {
    sm: {
        textStyle: 'sm'
    },
    md: {
        textStyle: 'md'
    },
    lg: {
        textStyle: 'lg'
    }
};
var $0372a0fa0a68a42f$var$variantInline = {
    _hover: {
        textUnderlineOffset: '1px'
    }
};
var $0372a0fa0a68a42f$var$variantStandalone = {
    py: '1',
    _hover: {
        textUnderlineOffset: '4px'
    }
};
var $0372a0fa0a68a42f$var$variants = {
    inline: $0372a0fa0a68a42f$var$variantInline,
    standalone: $0372a0fa0a68a42f$var$variantStandalone
};
var $0372a0fa0a68a42f$var$defaultProps = {
    variant: 'standalone',
    colorScheme: 'light-blue',
    size: 'md'
};
var $0372a0fa0a68a42f$export$a6c7ac8248d6e38a = {
    baseStyle: $0372a0fa0a68a42f$var$baseStyle,
    sizes: $0372a0fa0a68a42f$var$sizes,
    variants: $0372a0fa0a68a42f$var$variants,
    defaultProps: $0372a0fa0a68a42f$var$defaultProps
};


var $f4510e75fd105402$var$__assign = undefined && undefined.__assign || function() {
    $f4510e75fd105402$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4510e75fd105402$var$__assign.apply(this, arguments);
};
var $f4510e75fd105402$var$parts = [
    'container',
    'item',
    'link',
    'separator'
];
var $f4510e75fd105402$var$baseStyleContainer = {
    display: 'block'
};
var $f4510e75fd105402$var$baseStyleLink = function(props) {
    var link = (0, $0372a0fa0a68a42f$export$a6c7ac8248d6e38a).baseStyle(props);
    return $f4510e75fd105402$var$__assign($f4510e75fd105402$var$__assign({}, (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(link, (0, $0372a0fa0a68a42f$export$a6c7ac8248d6e38a).variants.standalone)), {
        fontWeight: 'medium'
    });
};
var $f4510e75fd105402$var$baseStyleSeparator = function(props) {
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.400', 'slate.300')(props),
        fontSize: 'xs'
    };
};
var $f4510e75fd105402$var$sizes = {
    sm: {
        item: {
            textStyle: 'sm'
        },
        separator: {
            marginLeft: '0.5',
            marginRight: '1'
        }
    },
    md: {
        item: {
            textStyle: 'md'
        },
        separator: {
            marginLeft: '1',
            marginRight: '2'
        }
    },
    lg: {
        item: {
            textStyle: 'lg'
        },
        separator: {
            marginLeft: '2',
            marginRight: '3'
        }
    }
};
var $f4510e75fd105402$var$baseStyle = function(props) {
    return {
        link: $f4510e75fd105402$var$baseStyleLink(props),
        separator: $f4510e75fd105402$var$baseStyleSeparator(props),
        container: $f4510e75fd105402$var$baseStyleContainer
    };
};
var $f4510e75fd105402$var$defaultProps = {
    size: 'md'
};
var $f4510e75fd105402$export$dabcc1ec9dd9d1cc = {
    parts: $f4510e75fd105402$var$parts,
    sizes: $f4510e75fd105402$var$sizes,
    baseStyle: $f4510e75fd105402$var$baseStyle,
    defaultProps: $f4510e75fd105402$var$defaultProps
};


var $1d310453f0ac8eda$exports = {};

$parcel$export($1d310453f0ac8eda$exports, "Button", function () { return $1d310453f0ac8eda$export$353f5b6fc5456de1; });


var $e5Q7j = parcelRequire("e5Q7j");

var $1d310453f0ac8eda$var$__assign = undefined && undefined.__assign || function() {
    $1d310453f0ac8eda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d310453f0ac8eda$var$__assign.apply(this, arguments);
};
/**
 * BaseStyles, avoid colors or any value that we want to have our end-users theme. we need to
 * discuss this with the designers. also try to use fully-written css props (don't use bg, use
 * backgroundColor, don't use h or w, use height and width) however, if you really want to use the
 * shorthand notation, group them together in "base" and "magic" categories
 */ var $1d310453f0ac8eda$var$baseStyle = {
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-start',
    boxSizing: 'border-box',
    borderColor: 'transparent',
    borderRadius: '0.25rem',
    borderStyle: 'solid',
    borderWidth: '0',
    display: 'inline-flex',
    fontWeight: '500',
    paddingStart: '1rem',
    paddingEnd: '1rem',
    transition: 'all 0.05s ease-out',
    userSelect: 'none',
    _disabled: {
        opacity: 0.5,
        cursor: 'not-allowed'
    },
    _active: {
        ':enabled': {
            transform: 'translateY(1px)'
        },
        '&.klik-ui-menu__button': {
            transform: 'none'
        }
    },
    _focusVisible: {
        boxShadow: 'focusVisible'
    }
};
var $1d310453f0ac8eda$var$getSize = function(size) {
    return (0, $77e571de9afb463d$export$c647cb0ee6e282fe)[size];
};
var $1d310453f0ac8eda$var$iconAndSpinnerSize = function(size) {
    var iconAndSpinnerSizes = {
        sm: {
            iconOnly: $1d310453f0ac8eda$var$getSize('4'),
            spinner: $1d310453f0ac8eda$var$getSize('3.5'),
            spinnerOnly: $1d310453f0ac8eda$var$getSize('4')
        },
        md: {
            iconOnly: $1d310453f0ac8eda$var$getSize('5'),
            spinner: $1d310453f0ac8eda$var$getSize('4.5'),
            spinnerOnly: $1d310453f0ac8eda$var$getSize('7')
        },
        lg: {
            iconOnly: $1d310453f0ac8eda$var$getSize('6'),
            spinner: $1d310453f0ac8eda$var$getSize('5.5'),
            spinnerOnly: $1d310453f0ac8eda$var$getSize('9')
        }
    };
    var iconSize = iconAndSpinnerSizes[size];
    return {
        '&[data-icononly]': {
            fontSize: iconSize.iconOnly,
            '.klik-ui-spinner-inline': {
                fontSize: 'inherit'
            }
        },
        '.klik-ui-spinner-inline': {
            fontSize: iconSize.spinner
        },
        '&[data-spinneronly] .klik-ui-spinner-inline': {
            fontSize: iconSize.spinnerOnly
        }
    };
};
var $1d310453f0ac8eda$var$sizes = {
    sm: $1d310453f0ac8eda$var$__assign({
        textStyle: 'md',
        paddingStart: '0.75rem',
        paddingEnd: '0.75rem',
        minHeight: '2rem',
        minWidth: '2rem'
    }, $1d310453f0ac8eda$var$iconAndSpinnerSize('sm')),
    md: $1d310453f0ac8eda$var$__assign({
        textStyle: 'lg',
        minHeight: '3rem',
        minWidth: '3rem'
    }, $1d310453f0ac8eda$var$iconAndSpinnerSize('md')),
    lg: $1d310453f0ac8eda$var$__assign({
        textStyle: 'xl',
        paddingStart: '1.5rem',
        paddingEnd: '1.5rem',
        minHeight: '4rem',
        minWidth: '4rem'
    }, $1d310453f0ac8eda$var$iconAndSpinnerSize('lg'))
};
var $1d310453f0ac8eda$var$variantPlain = function(props) {
    var c = props.colorScheme;
    return {
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'white')(props),
        boxShadow: 'button',
        color: (0, $f466d5c40b760069$export$549ff81930776885)('white', c + ".500")(props),
        _hover: {
            ':enabled': {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", 'slate.50')(props)
            }
        },
        _active: {
            ':enabled': {
                boxShadow: 'none',
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", 'slate.50')(props)
            }
        }
    };
};
var $1d310453f0ac8eda$var$variantGhost = function(props) {
    var c = props.colorScheme, theme = props.theme;
    var backgroundColor = (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme), (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.4)(theme))(props);
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'white')(props),
        backgroundColor: 'transparent',
        _hover: {
            ':enabled': {
                backgroundColor: backgroundColor
            }
        },
        _active: {
            ':enabled': {
                boxShadow: '-1',
                backgroundColor: backgroundColor
            }
        },
        _focusVisible: {
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", 'slate.600')(props),
            backgroundColor: backgroundColor
        }
    };
};
var $1d310453f0ac8eda$var$variantOutline = function(props) {
    var c = props.colorScheme;
    var ghostStyles = $1d310453f0ac8eda$var$variantGhost(props);
    var outlineStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(ghostStyles, {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'white')(props),
        _active: {
            ':enabled': {
                boxShadow: 'none'
            }
        }
    });
    return outlineStyles;
};
var $1d310453f0ac8eda$var$variantAttached = function(props) {
    var plainStyles = $1d310453f0ac8eda$var$variantPlain(props);
    var attachedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(plainStyles, {
        fontWeight: 'normal',
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)("slate.50", 'slate.500')(props),
        boxShadow: 'button',
        color: 'inherit',
        _hover: {
            ':enabled': {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)("slate.50", 'slate.600')(props)
            }
        },
        _active: {
            ':enabled': {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)("slate.50", 'slate.600')(props)
            }
        }
    });
    return attachedStyles;
};
var $1d310453f0ac8eda$var$variantLink = function(props) {
    var c = props.colorScheme;
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'white')(props),
        backgroundColor: 'transparent',
        _hover: {
            ':enabled': {
                textDecoration: 'underline'
            }
        },
        _active: {
            ':enabled': {
                textDecoration: 'underline'
            }
        },
        _focusVisible: {
            textDecoration: 'underline'
        }
    };
};
var $1d310453f0ac8eda$var$variantAttachedActive = function(props) {
    var ghostStyles = $1d310453f0ac8eda$var$variantGhost(props);
    var c = props.colorScheme;
    var attachedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(ghostStyles, {
        fontWeight: 'normal',
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'slate.500')(props),
        boxShadow: 'none',
        color: 'white',
        _hover: {
            ':enabled': {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'slate.600')(props)
            }
        },
        _active: {
            ':enabled': {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'slate.600')(props)
            }
        },
        _focusVisible: {
            backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", 'slate.600')(props)
        }
    });
    return attachedStyles;
};
var $1d310453f0ac8eda$var$variants = {
    ghost: $1d310453f0ac8eda$var$variantGhost,
    outline: $1d310453f0ac8eda$var$variantOutline,
    plain: $1d310453f0ac8eda$var$variantPlain,
    attached: $1d310453f0ac8eda$var$variantAttached,
    'attached-active': $1d310453f0ac8eda$var$variantAttachedActive,
    link: $1d310453f0ac8eda$var$variantLink
};
var $1d310453f0ac8eda$var$defaultProps = {
    variant: 'plain',
    size: 'md',
    colorScheme: 'light-blue'
};
var $1d310453f0ac8eda$export$353f5b6fc5456de1 = {
    baseStyle: $1d310453f0ac8eda$var$baseStyle,
    variants: $1d310453f0ac8eda$var$variants,
    sizes: $1d310453f0ac8eda$var$sizes,
    defaultProps: $1d310453f0ac8eda$var$defaultProps
};


var $4f662729da9bf48d$exports = {};

$parcel$export($4f662729da9bf48d$exports, "Checkbox", function () { return $4f662729da9bf48d$export$48513f6b9f8ce62d; });

var $4f662729da9bf48d$var$parts = [
    'container',
    'control',
    'label',
    'icon'
];
var $4f662729da9bf48d$var$baseStyleControl = function(props) {
    var c = props.colorScheme;
    return {
        h: 4.5,
        w: 4.5,
        transition: 'box-shadow 250ms',
        border: '1px solid',
        borderRadius: 'base',
        borderColor: 'inherit',
        color: 'transparent',
        fontSize: '0.75rem',
        _checked: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            color: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.900')(props),
            _hover: {
                bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props),
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props)
            }
        },
        _indeterminate: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
            color: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.900')(props)
        },
        _focus: {
            boxShadow: 'focusVisible'
        },
        _invalid: {
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('error.500', 'error.300')(props)
        },
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    };
};
var $4f662729da9bf48d$var$baseStyleLabel = {
    userSelect: 'none',
    _disabled: {
        opacity: 0.5
    }
};
var $4f662729da9bf48d$var$baseStyle = function(props) {
    return {
        control: $4f662729da9bf48d$var$baseStyleControl(props),
        label: $4f662729da9bf48d$var$baseStyleLabel
    };
};
var $4f662729da9bf48d$var$sizes = {
    sm: {
        label: {
            textStyle: 'sm',
            marginStart: '0.5rem'
        }
    },
    md: {
        label: {
            textStyle: 'md',
            marginStart: '0.5rem'
        }
    },
    lg: {
        label: {
            textStyle: 'lg',
            marginStart: '0.75rem'
        }
    }
};
var $4f662729da9bf48d$var$defaultProps = {
    size: 'md',
    colorScheme: 'light-blue'
};
var $4f662729da9bf48d$export$48513f6b9f8ce62d = {
    parts: $4f662729da9bf48d$var$parts,
    baseStyle: $4f662729da9bf48d$var$baseStyle,
    sizes: $4f662729da9bf48d$var$sizes,
    defaultProps: $4f662729da9bf48d$var$defaultProps
};


var $73361a021f19e8e9$exports = {};

$parcel$export($73361a021f19e8e9$exports, "CircularProgress", function () { return $73361a021f19e8e9$export$9e72f56a493060bf; });
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ 
var $9df8cb6ea2ddc5ef$exports = {};
var $3c9a451d897cca9b$exports = {};

$parcel$export($3c9a451d897cca9b$exports, "borders", function () { return $3c9a451d897cca9b$export$5a5da632d18030b0; });
var $3c9a451d897cca9b$export$5a5da632d18030b0 = {
    none: 0,
    '1px': '1px solid',
    '2px': '2px solid',
    '4px': '4px solid',
    '8px': '8px solid'
};


var $39e3c502d7528af7$exports = {};

$parcel$export($39e3c502d7528af7$exports, "breakpoints", function () { return $39e3c502d7528af7$export$d07517a676ce386f; });

var $39e3c502d7528af7$export$d07517a676ce386f = (0, $859569b6ff2a5329$export$79e1df82cbbff4e9)({
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em'
});


var $137c00333ba75496$exports = {};

$parcel$export($137c00333ba75496$exports, "colors", function () { return $137c00333ba75496$export$8f45430ccf837300; });
var $f9babc27d7c820c0$export$6ad93df59e712c43 = {
    colors: {
        slate: {
            '10': '#fcfcfc',
            '30': '#f8f8f8',
            '50': '#f1f1f1',
            '100': '#e3e3e1',
            '200': '#cfcfcc',
            '300': '#b2b2b0',
            '400': '#969694',
            '500': '#767674',
            '600': '#61615f',
            '700': '#4d4d4b',
            '800': '#3b3b39',
            '900': '#292928'
        },
        turquoise: {
            '10': '#fafdfd',
            '30': '#f2fbfc',
            '50': '#dff2f5',
            '100': '#c2ecf2',
            '200': '#8bdce8',
            '300': '#51c4d6',
            '400': '#1fa3b8',
            '500': '#068294',
            '600': '#016978',
            '700': '#01525e',
            '800': '#043f47',
            '900': '#062d33'
        },
        teal: {
            '10': '#fafcfc',
            '30': '#f5f9fa',
            '50': '#e9f2f5',
            '100': '#d3e7ed',
            '200': '#b1d3de',
            '300': '#8dbac9',
            '400': '#6198ab',
            '500': '#467b8c',
            '600': '#376878',
            '700': '#294f5c',
            '800': '#203c45',
            '900': '#152429'
        },
        'light-blue': {
            '10': '#f9fbfc',
            '30': '#f5f8fa',
            '50': '#e8f2fa',
            '100': '#cae5fa',
            '200': '#a6d3f7',
            '300': '#79bcf2',
            '400': '#4599de',
            '500': '#247bbf',
            '600': '#1766a6',
            '700': '#0f538a',
            '800': '#0c416b',
            '900': '#0a2c47'
        },
        'dark-blue': {
            '10': '#fafbfc',
            '30': '#f2f6fc',
            '50': '#e8f0fc',
            '100': '#d2e1fc',
            '200': '#b1ccfa',
            '300': '#8ab1f2',
            '400': '#5f91e8',
            '500': '#346ed1',
            '600': '#1951b2',
            '700': '#0c3987',
            '800': '#0b2f6e',
            '900': '#0b2552'
        },
        purple: {
            '10': '#fbfafc',
            '30': '#f8f5fc',
            '50': '#f3edfc',
            '100': '#e8dcfa',
            '200': '#d4bff5',
            '300': '#bfa2eb',
            '400': '#a27ed9',
            '500': '#8a62c4',
            '600': '#734cad',
            '700': '#5b3a8c',
            '800': '#452b6b',
            '900': '#2e2042'
        },
        magenta: {
            '10': '#fcfafb',
            '30': '#fcf5f8',
            '50': '#fcebf3',
            '100': '#fcd4e7',
            '200': '#fab6d6',
            '300': '#f294c0',
            '400': '#e567a2',
            '500': '#cf3e81',
            '600': '#b22567',
            '700': '#8c164d',
            '800': '#611338',
            '900': '#40162a'
        },
        copper: {
            '10': '#fffdfa',
            '30': '#fcf7f0',
            '50': '#faefe1',
            '100': '#fbdcb7',
            '200': '#f3c48b',
            '300': '#e3a65b',
            '400': '#cc8a37',
            '500': '#a3681f',
            '600': '#855315',
            '700': '#654113',
            '800': '#4a3214',
            '900': '#332514'
        },
        information: {
            '50': '#e6f5fc',
            '100': '#c5eafc',
            '400': '#179fe3',
            '500': '#007cba',
            '600': '#056899'
        },
        success: {
            '50': '#e8f7e6',
            '100': '#d3f7d0',
            '400': '#1cb20c',
            '500': '#108a06',
            '600': '#116e09'
        },
        warning: {
            '50': '#fcf2db',
            '100': '#fce9c0',
            '400': '#f2a705',
            '500': '#9e6c00',
            '600': '#805700'
        },
        error: {
            '50': '#fff2f2',
            '100': '#ffdede',
            '400': '#f55b5b',
            '500': '#db1f1f',
            '600': '#b20707'
        }
    }
};


var $137c00333ba75496$var$__assign = undefined && undefined.__assign || function() {
    $137c00333ba75496$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $137c00333ba75496$var$__assign.apply(this, arguments);
};
var $137c00333ba75496$export$8f45430ccf837300 = $137c00333ba75496$var$__assign({
    // Special Cases for text-color
    transparent: 'transparent',
    currentColor: 'currentColor',
    white: '#ffffff',
    black: '#000000'
}, (0, $f9babc27d7c820c0$export$6ad93df59e712c43).colors);


var $38cee76b8bbdb4fb$exports = {};

$parcel$export($38cee76b8bbdb4fb$exports, "radii", function () { return $38cee76b8bbdb4fb$export$18f838d5aba6962a; });
var $38cee76b8bbdb4fb$export$18f838d5aba6962a = {
    none: '0',
    sm: '0.125rem',
    base: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px'
};


var $facea36a0c7c3bce$exports = {};

$parcel$export($facea36a0c7c3bce$exports, "shadows", function () { return $facea36a0c7c3bce$export$3eb26d38a832ce9a; });

var $facea36a0c7c3bce$export$3eb26d38a832ce9a = {
    '-2': 'inset 0px 1px 0px rgba(0, 0, 0, 0.1)',
    '-1': 'inset 0px 2px 0px rgba(0, 0, 0, 0.1)',
    '0': 'none',
    '1': '0px 1px 0px rgba(0, 0, 0, 0.1)',
    '2': '0px 2px 0px rgba(0, 0, 0, 0.1)',
    focusVisible: "0 0 0 2px " + (0, $f9babc27d7c820c0$export$6ad93df59e712c43).colors.information['400'],
    button: '0px 1px 0px rgba(0, 0, 0, 0.1), inset 0px -1px 0px rgba(0, 0, 0, 0.15)',
    xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    outline: "0 0 0 2px " + (0, $f9babc27d7c820c0$export$6ad93df59e712c43).colors.information['400'],
    inline: "inset 0 0 0 2px " + (0, $f9babc27d7c820c0$export$6ad93df59e712c43).colors.information['400'],
    inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
    none: 'none',
    'dark-lg': 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px'
};




var $f4fdeb0368cdd8ae$exports = {};

$parcel$export($f4fdeb0368cdd8ae$exports, "property", function () { return $f4fdeb0368cdd8ae$export$d541bacb2bda4494; });
$parcel$export($f4fdeb0368cdd8ae$exports, "easing", function () { return $f4fdeb0368cdd8ae$export$24c5ac7c37452e7d; });
$parcel$export($f4fdeb0368cdd8ae$exports, "duration", function () { return $f4fdeb0368cdd8ae$export$1f34108aa9eb96ab; });
var $f4fdeb0368cdd8ae$export$d541bacb2bda4494 = {
    common: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
    colors: 'background-color, border-color, color, fill, stroke',
    dimensions: 'width, height',
    position: 'left, right, top, bottom',
    background: 'background-color, background-image, background-position'
};
var $f4fdeb0368cdd8ae$export$24c5ac7c37452e7d = {
    'ease-in': 'cubic-bezier(0.4, 0, 1, 1)',
    'ease-out': 'cubic-bezier(0, 0, 0.2, 1)',
    'ease-in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
};
var $f4fdeb0368cdd8ae$export$1f34108aa9eb96ab = {
    'ultra-fast': '50ms',
    faster: '100ms',
    fast: '150ms',
    normal: '200ms',
    slow: '300ms',
    slower: '400ms',
    'ultra-slow': '500ms'
};


var $265c569e8c991105$exports = {};

$parcel$export($265c569e8c991105$exports, "fonts", function () { return $265c569e8c991105$export$f45fbea8fe20ca8a; });
$parcel$export($265c569e8c991105$exports, "fontWeights", function () { return $265c569e8c991105$export$59230918eb9bd861; });
$parcel$export($265c569e8c991105$exports, "fontSizes", function () { return $265c569e8c991105$export$67baea80019ff381; });
$parcel$export($265c569e8c991105$exports, "lineHeights", function () { return $265c569e8c991105$export$e646ed6b629bf51e; });
$parcel$export($265c569e8c991105$exports, "letterSpacings", function () { return $265c569e8c991105$export$b74e30ebb52682da; });
var $265c569e8c991105$export$f45fbea8fe20ca8a = {
    body: 'Cera Pro',
    heading: 'Cera Pro',
    mono: "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace"
};
var $265c569e8c991105$export$59230918eb9bd861 = {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
};
var $265c569e8c991105$export$67baea80019ff381 = {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5625rem',
    '3xl': '1.9375rem',
    '4xl': '2.4375rem',
    '5xl': '3.0625rem',
    '6xl': '3.8125rem',
    '7xl': '4.75rem',
    '8xl': '5.9375rem'
};
var $265c569e8c991105$export$e646ed6b629bf51e = {
    xs: '1rem',
    sm: '1.25rem',
    md: '1.5rem',
    lg: '1.75rem',
    xl: '2rem',
    '2xl': '2.25rem',
    '3xl': '2.5rem',
    '4xl': '3rem',
    '5xl': '3.75rem',
    '6xl': '4.5rem',
    '7xl': '5.5rem',
    '8xl': '6.75rem'
};
var $265c569e8c991105$export$b74e30ebb52682da = {};


var $73584a5a06292215$exports = {};

$parcel$export($73584a5a06292215$exports, "zIndices", function () { return $73584a5a06292215$export$a01878c2d95345c0; });
var $73584a5a06292215$export$a01878c2d95345c0 = {
    hide: -1,
    auto: 'auto',
    base: 0,
    focus: 1,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};


$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $3c9a451d897cca9b$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $39e3c502d7528af7$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $137c00333ba75496$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $38cee76b8bbdb4fb$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $facea36a0c7c3bce$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $77e571de9afb463d$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $ff3c8449b764055d$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $f4fdeb0368cdd8ae$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $265c569e8c991105$exports);
$parcel$exportWildcard($9df8cb6ea2ddc5ef$exports, $73584a5a06292215$exports);


var $73361a021f19e8e9$var$parts = [
    'track',
    'filledTrack'
];
var $73361a021f19e8e9$var$baseStyleTrack = function(props) {
    var theme = props.theme;
    return {
        stroke: (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.1)(theme), (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.500', 0.5)(theme))(props)
    };
};
var $73361a021f19e8e9$var$baseStyleFilledTrack = function(props) {
    var c = props.colorScheme;
    return {
        stroke: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", "white")(props)
    };
};
var $73361a021f19e8e9$var$baseStyle = function(props) {
    return {
        filledTrack: $73361a021f19e8e9$var$baseStyleFilledTrack(props),
        track: $73361a021f19e8e9$var$baseStyleTrack(props)
    };
};
var $73361a021f19e8e9$var$sizes = {
    sm: {
        track: {
            height: 10,
            width: 10
        },
        label: {
            fontSize: (0, $265c569e8c991105$export$67baea80019ff381).xs
        }
    },
    md: {
        track: {
            height: 15,
            width: 15
        },
        label: {
            fontSize: (0, $265c569e8c991105$export$67baea80019ff381).md
        }
    },
    lg: {
        track: {
            height: 25,
            width: 25
        },
        label: {
            fontSize: (0, $265c569e8c991105$export$67baea80019ff381)['2xl']
        }
    }
};
var $73361a021f19e8e9$var$defaultProps = {
    size: 'md',
    colorScheme: 'light-blue'
};
var $73361a021f19e8e9$export$9e72f56a493060bf = {
    parts: $73361a021f19e8e9$var$parts,
    sizes: $73361a021f19e8e9$var$sizes,
    baseStyle: $73361a021f19e8e9$var$baseStyle,
    defaultProps: $73361a021f19e8e9$var$defaultProps
};


var $cb001d63a8d70545$exports = {};

$parcel$export($cb001d63a8d70545$exports, "Container", function () { return $cb001d63a8d70545$export$42a852a2b6b56249; });
var $cb001d63a8d70545$var$baseStyle = {
    w: '100%',
    mx: 'auto',
    maxW: '60ch',
    px: '1rem'
};
var $cb001d63a8d70545$export$42a852a2b6b56249 = {
    baseStyle: $cb001d63a8d70545$var$baseStyle
};


var $8640ccd50c29e5c3$exports = {};

$parcel$export($8640ccd50c29e5c3$exports, "Divider", function () { return $8640ccd50c29e5c3$export$2e0a83ec2e27ecbb; });
var $8640ccd50c29e5c3$var$baseStyle = {
    borderWidth: '2px',
    borderColor: 'slate.100'
};
var $8640ccd50c29e5c3$var$variantSolid = {
    borderStyle: 'solid'
};
var $8640ccd50c29e5c3$var$variantDashed = {
    borderStyle: 'dashed'
};
var $8640ccd50c29e5c3$var$variants = {
    solid: $8640ccd50c29e5c3$var$variantSolid,
    dashed: $8640ccd50c29e5c3$var$variantDashed
};
var $8640ccd50c29e5c3$var$defaultProps = {
    variant: 'solid'
};
var $8640ccd50c29e5c3$export$2e0a83ec2e27ecbb = {
    baseStyle: $8640ccd50c29e5c3$var$baseStyle,
    variants: $8640ccd50c29e5c3$var$variants,
    defaultProps: $8640ccd50c29e5c3$var$defaultProps
};


var $de700ff798138d47$exports = {};

$parcel$export($de700ff798138d47$exports, "Drawer", function () { return $de700ff798138d47$export$4071300121a182f5; });

var $de700ff798138d47$var$__assign = undefined && undefined.__assign || function() {
    $de700ff798138d47$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de700ff798138d47$var$__assign.apply(this, arguments);
};
var $de700ff798138d47$var$parts = [
    'overlay',
    'dialogContainer',
    'dialog',
    'header',
    'closeButton',
    'body',
    'footer'
];
/**
 * TODO: refactor this
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */ var $de700ff798138d47$var$getSize = function(value) {
    if (value === 'full') return {
        dialog: {
            maxW: '100vw',
            h: '100vh'
        }
    };
    return {
        dialog: {
            maxW: value
        }
    };
};
var $de700ff798138d47$var$baseStyleOverlay = function(props) {
    var c = props.colorScheme, theme = props.theme;
    return {
        backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".900", 0.8)(theme),
        zIndex: 'overlay'
    };
};
var $de700ff798138d47$var$baseStyleDialogContainer = {
    display: 'flex',
    zIndex: 'modal',
    justifyContent: 'center'
};
var $de700ff798138d47$var$baseStyleDialog = function(props) {
    var isFullHeight = props.isFullHeight;
    var c = props.colorScheme;
    var baseBg = c === 'white' ? 'white' : c + ".500";
    var baseBgDark = c === 'white' ? 'slate.700' : c + ".500";
    return $de700ff798138d47$var$__assign($de700ff798138d47$var$__assign({}, isFullHeight && {
        height: '100vh'
    }), {
        zIndex: 'modal',
        maxH: '100vh',
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(baseBg, baseBgDark)(props),
        color: 'inherit',
        boxShadow: (0, $f466d5c40b760069$export$549ff81930776885)('lg', 'dark-lg')(props)
    });
};
var $de700ff798138d47$var$baseStyleHeader = {
    px: 6,
    py: 4,
    textStyle: 'h4'
};
var $de700ff798138d47$var$baseStyleCloseButton = {
    position: 'absolute',
    top: 6,
    insetEnd: 4
};
var $de700ff798138d47$var$baseStyleBody = {
    px: 6,
    py: 2,
    flex: 1,
    overflow: 'auto'
};
var $de700ff798138d47$var$baseStyleFooter = {
    px: 6,
    py: 4
};
var $de700ff798138d47$var$baseStyle = function(props) {
    return {
        overlay: $de700ff798138d47$var$baseStyleOverlay(props),
        dialogContainer: $de700ff798138d47$var$baseStyleDialogContainer,
        dialog: $de700ff798138d47$var$baseStyleDialog(props),
        header: $de700ff798138d47$var$baseStyleHeader,
        closeButton: $de700ff798138d47$var$baseStyleCloseButton,
        body: $de700ff798138d47$var$baseStyleBody,
        footer: $de700ff798138d47$var$baseStyleFooter
    };
};
var $de700ff798138d47$var$sizes = {
    xs: $de700ff798138d47$var$getSize('xs'),
    sm: $de700ff798138d47$var$getSize('md'),
    md: $de700ff798138d47$var$getSize('lg'),
    lg: $de700ff798138d47$var$getSize('2xl'),
    xl: $de700ff798138d47$var$getSize('4xl'),
    full: $de700ff798138d47$var$getSize('full')
};
var $de700ff798138d47$var$defaultProps = {
    size: 'xs',
    colorScheme: 'white'
};
var $de700ff798138d47$export$4071300121a182f5 = {
    parts: $de700ff798138d47$var$parts,
    baseStyle: $de700ff798138d47$var$baseStyle,
    sizes: $de700ff798138d47$var$sizes,
    defaultProps: $de700ff798138d47$var$defaultProps
};


var $e9f1f95a1a81a2eb$exports = {};

$parcel$export($e9f1f95a1a81a2eb$exports, "FileUploader", function () { return $e9f1f95a1a81a2eb$export$1a5cb5295a7d2749; });
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 
var $e5Q7j = parcelRequire("e5Q7j");
var $e9f1f95a1a81a2eb$var$baseStyle = function(props) {
    var isInDropArea = props.isInDropArea;
    var style = {
        alignItems: 'center',
        borderColor: 'slate.300',
        borderStyle: 'dashed',
        borderWidth: '2px',
        color: 'slate.500',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        height: '100px',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        '> input': {
            cursor: 'pointer',
            height: '100%',
            opacity: 0,
            position: 'absolute',
            width: '100%'
        }
    };
    if (isInDropArea) style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
        borderColor: 'information.400'
    });
    return style;
};
var $e9f1f95a1a81a2eb$var$defaultProps = {
    colorScheme: 'light-blue'
};
var $e9f1f95a1a81a2eb$export$1a5cb5295a7d2749 = {
    baseStyle: $e9f1f95a1a81a2eb$var$baseStyle,
    defaultProps: $e9f1f95a1a81a2eb$var$defaultProps
};


var $0b89ec6456068494$exports = {};

$parcel$export($0b89ec6456068494$exports, "Form", function () { return $0b89ec6456068494$export$a7fed597f4b8afd8; });

var $0b89ec6456068494$var$parts = [
    'requiredIndicator',
    'helperText'
];
var $0b89ec6456068494$var$baseStyleRequiredIndicator = function(props) {
    return {
        marginStart: 1,
        color: (0, $f466d5c40b760069$export$549ff81930776885)('error.400', 'error.300')(props)
    };
};
var $0b89ec6456068494$var$baseStyleHelperText = function(props) {
    return {
        mt: 2,
        color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.500', 'slate.600')(props),
        lineHeight: 'normal',
        fontSize: 'sm'
    };
};
var $0b89ec6456068494$var$baseStyle = function(props) {
    return {
        requiredIndicator: $0b89ec6456068494$var$baseStyleRequiredIndicator(props),
        helperText: $0b89ec6456068494$var$baseStyleHelperText(props)
    };
};
var $0b89ec6456068494$var$sizes = {
    sm: {
        helperText: {
            fontSize: 'xs'
        }
    },
    md: {
        helperText: {
            fontSize: 'sm'
        }
    },
    lg: {
        helperText: {
            fontSize: 'md'
        }
    }
};
var $0b89ec6456068494$export$a7fed597f4b8afd8 = {
    parts: $0b89ec6456068494$var$parts,
    baseStyle: $0b89ec6456068494$var$baseStyle,
    sizes: $0b89ec6456068494$var$sizes
};


var $e07b5d3f1aaf5a47$exports = {};

$parcel$export($e07b5d3f1aaf5a47$exports, "FormError", function () { return $e07b5d3f1aaf5a47$export$942b2219c902021e; });

var $e07b5d3f1aaf5a47$var$parts = [
    'text',
    'icon'
];
var $e07b5d3f1aaf5a47$var$baseStyleText = function(props) {
    return {
        color: (0, $f466d5c40b760069$export$549ff81930776885)('error.500', 'error.400')(props)
    };
};
var $e07b5d3f1aaf5a47$var$baseStyleIcon = function(props) {
    return {
        marginEnd: '0.5em',
        color: (0, $f466d5c40b760069$export$549ff81930776885)('error.500', 'error.400')(props)
    };
};
var $e07b5d3f1aaf5a47$var$baseStyle = function(props) {
    return {
        text: $e07b5d3f1aaf5a47$var$baseStyleText(props),
        icon: $e07b5d3f1aaf5a47$var$baseStyleIcon(props)
    };
};
var $e07b5d3f1aaf5a47$var$sizes = {
    sm: {
        text: {
            marginTop: '1',
            fontSize: 'xs'
        }
    },
    md: {
        text: {
            marginTop: '1',
            fontSize: 'sm'
        }
    },
    lg: {
        text: {
            marginTop: '2',
            fontSize: 'md'
        }
    }
};
var $e07b5d3f1aaf5a47$var$defaultProps = {
    size: 'md'
};
var $e07b5d3f1aaf5a47$export$942b2219c902021e = {
    parts: $e07b5d3f1aaf5a47$var$parts,
    sizes: $e07b5d3f1aaf5a47$var$sizes,
    defaultProps: $e07b5d3f1aaf5a47$var$defaultProps,
    baseStyle: $e07b5d3f1aaf5a47$var$baseStyle
};


var $595576f8c6a3bf69$exports = {};

$parcel$export($595576f8c6a3bf69$exports, "FormLabel", function () { return $595576f8c6a3bf69$export$842aba50ed0ce9d7; });
var $595576f8c6a3bf69$var$baseStyle = {
    marginEnd: 3,
    transition: 'all 0.2s'
};
var $595576f8c6a3bf69$var$sizes = {
    sm: {
        fontSize: 'sm',
        mb: 1
    },
    md: {
        fontSize: 'md',
        mb: 1
    },
    lg: {
        fontSize: 'lg',
        mb: 2
    }
};
var $595576f8c6a3bf69$var$defaultProps = {
    size: 'md'
};
var $595576f8c6a3bf69$export$842aba50ed0ce9d7 = {
    baseStyle: $595576f8c6a3bf69$var$baseStyle,
    defaultProps: $595576f8c6a3bf69$var$defaultProps,
    sizes: $595576f8c6a3bf69$var$sizes
};


var $ded906a98c3c049c$exports = {};

$parcel$export($ded906a98c3c049c$exports, "InlineNotification", function () { return $ded906a98c3c049c$export$cae1c58733dbe1ed; });


var $ded906a98c3c049c$var$__assign = undefined && undefined.__assign || function() {
    $ded906a98c3c049c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ded906a98c3c049c$var$__assign.apply(this, arguments);
};
var $ded906a98c3c049c$var$parts = [
    'container',
    'title',
    'description',
    'icon'
];
var $ded906a98c3c049c$var$baseStyle = function(props) {
    var isStandalone = props.isStandalone, theme = props.theme;
    return {
        container: {
            bg: 'white',
            borderRadius: isStandalone ? 'sm' : 'none',
            display: 'flex',
            minHeight: '3.5rem',
            justifyContent: 'flex-start',
            borderWidth: isStandalone ? '1px' : '0px',
            borderColor: 'slate.300'
        },
        content: {
            alignItems: 'flex-start',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            px: '3',
            py: '4'
        },
        title: {
            textStyle: 'h5',
            fontWeight: 'medium'
        },
        wrapper: {
            minHeight: isStandalone ? '3.5rem' : 'calc(3.5rem + 2px)',
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            flex: 1
        },
        description: {
            textStyle: 'body2'
        },
        status: {
            marginTop: isStandalone ? '5' : "calc(" + (0, $dfe73229adf076fd$export$1bb32d0c65da6059)(theme, 'space.5') + " + 1px)",
            alignSelf: 'flex-start',
            marginStart: '3'
        }
    };
};
var $ded906a98c3c049c$var$getBg = function(props) {
    var theme = props.theme, c = props.colorScheme;
    var lightBg = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, c + ".50", c);
    var darkBg = (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".200", 0.16)(theme);
    return (0, $f466d5c40b760069$export$549ff81930776885)(lightBg, darkBg)(props);
};
var $ded906a98c3c049c$var$getStatus = function(props) {
    var c = props.colorScheme;
    return {
        status: {
            color: c + ".400",
            height: '100%'
        },
        wrapper: {
            borderStartWidth: '0.75rem',
            borderColor: c + ".400"
        },
        container: {
            borderColor: c + ".400",
            backgroundColor: $ded906a98c3c049c$var$getBg(props)
        }
    };
};
var $ded906a98c3c049c$var$variantPlain = {};
var $ded906a98c3c049c$var$variantSuccess = function(props) {
    return $ded906a98c3c049c$var$getStatus($ded906a98c3c049c$var$__assign($ded906a98c3c049c$var$__assign({}, props), {
        colorScheme: 'success'
    }));
};
var $ded906a98c3c049c$var$variantInfo = function(props) {
    return $ded906a98c3c049c$var$getStatus($ded906a98c3c049c$var$__assign($ded906a98c3c049c$var$__assign({}, props), {
        colorScheme: 'information'
    }));
};
var $ded906a98c3c049c$var$variantWarning = function(props) {
    return $ded906a98c3c049c$var$getStatus($ded906a98c3c049c$var$__assign($ded906a98c3c049c$var$__assign({}, props), {
        colorScheme: 'warning'
    }));
};
var $ded906a98c3c049c$var$variantError = function(props) {
    return $ded906a98c3c049c$var$getStatus($ded906a98c3c049c$var$__assign($ded906a98c3c049c$var$__assign({}, props), {
        colorScheme: 'error'
    }));
};
var $ded906a98c3c049c$var$variants = {
    plain: $ded906a98c3c049c$var$variantPlain,
    success: $ded906a98c3c049c$var$variantSuccess,
    info: $ded906a98c3c049c$var$variantInfo,
    warning: $ded906a98c3c049c$var$variantWarning,
    error: $ded906a98c3c049c$var$variantError
};
var $ded906a98c3c049c$var$defaultProps = {
    variant: 'info'
};
var $ded906a98c3c049c$export$cae1c58733dbe1ed = {
    parts: $ded906a98c3c049c$var$parts,
    baseStyle: $ded906a98c3c049c$var$baseStyle,
    variants: $ded906a98c3c049c$var$variants,
    defaultProps: $ded906a98c3c049c$var$defaultProps
};


var $4f674d869a656e9f$exports = {};

$parcel$export($4f674d869a656e9f$exports, "Input", function () { return $4f674d869a656e9f$export$f5b8910cec6cf069; });

// from specifying responsiveSizes('3xl', )
var $4db67093e450c1f9$var$__assign = undefined && undefined.__assign || function() {
    $4db67093e450c1f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4db67093e450c1f9$var$__assign.apply(this, arguments);
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var $4db67093e450c1f9$var$responsiveSizes = function(sizes) {
    return {
        fontSize: sizes,
        lineHeight: sizes
    };
};
var $4db67093e450c1f9$export$6a54c24d15b0f6ba = {
    // Our Default Type Scale, fully applied
    xs: {
        fontSize: 'xs',
        lineHeight: 'xs'
    },
    sm: {
        fontSize: 'sm',
        lineHeight: 'sm'
    },
    md: {
        fontSize: 'md',
        lineHeight: 'md'
    },
    lg: {
        fontSize: 'lg',
        lineHeight: 'lg'
    },
    xl: {
        fontSize: 'xl',
        lineHeight: 'xl'
    },
    '2xl': {
        fontSize: '2xl',
        lineHeight: '2xl'
    },
    '3xl': {
        fontSize: '3xl',
        lineHeight: '3xl'
    },
    '4xl': {
        fontSize: '4xl',
        lineHeight: '4xl'
    },
    '5xl': {
        fontSize: '5xl',
        lineHeight: '5xl'
    },
    '6xl': {
        fontSize: '6xl',
        lineHeight: '6xl'
    },
    '7xl': {
        fontSize: '7xl',
        lineHeight: '7xl'
    },
    '8xl': {
        fontSize: '8xl',
        lineHeight: '8xl'
    },
    // The Same TypeScale, but applied only to typography sets
    h1: $4db67093e450c1f9$var$responsiveSizes([
        '3xl',
        undefined,
        '4xl'
    ]),
    h2: $4db67093e450c1f9$var$responsiveSizes([
        '2xl',
        undefined,
        '3xl'
    ]),
    h3: $4db67093e450c1f9$var$responsiveSizes([
        'xl',
        undefined,
        '2xl'
    ]),
    h4: $4db67093e450c1f9$var$responsiveSizes([
        'lg',
        undefined,
        'xl'
    ]),
    h5: $4db67093e450c1f9$var$__assign($4db67093e450c1f9$var$__assign({}, $4db67093e450c1f9$var$responsiveSizes([
        'md',
        undefined,
        'md'
    ])), {
        fontWeight: 'bold'
    }),
    h6: $4db67093e450c1f9$var$__assign($4db67093e450c1f9$var$__assign({}, $4db67093e450c1f9$var$responsiveSizes([
        'md',
        undefined,
        'md'
    ])), {
        letterSpacing: '0.1em',
        textTransform: 'uppercase'
    }),
    body1: $4db67093e450c1f9$var$responsiveSizes([
        'md',
        undefined,
        'md'
    ]),
    body2: $4db67093e450c1f9$var$responsiveSizes([
        'sm',
        undefined,
        'sm'
    ])
};


var $4f674d869a656e9f$var$__assign = undefined && undefined.__assign || function() {
    $4f674d869a656e9f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f674d869a656e9f$var$__assign.apply(this, arguments);
};
var $4f674d869a656e9f$var$parts = [
    'field',
    'addon'
];
var $4f674d869a656e9f$var$baseStyle = {
    field: {
        width: '100%',
        minWidth: 0,
        outline: 0,
        position: 'relative',
        appearance: 'none',
        transition: 'all 0.2s',
        borderRadius: 'base',
        boxShadow: '-2'
    }
};
var $4f674d869a656e9f$var$size = {
    lg: $4f674d869a656e9f$var$__assign($4f674d869a656e9f$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).lg), {
        paddingX: '4',
        h: '16'
    }),
    md: $4f674d869a656e9f$var$__assign($4f674d869a656e9f$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).md), {
        paddingX: '3',
        h: '12'
    }),
    sm: $4f674d869a656e9f$var$__assign($4f674d869a656e9f$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).sm), {
        paddingX: '2',
        h: '8'
    })
};
var $4f674d869a656e9f$var$sizes = {
    lg: {
        field: $4f674d869a656e9f$var$size.lg,
        addon: $4f674d869a656e9f$var$size.lg
    },
    md: {
        field: $4f674d869a656e9f$var$size.md,
        addon: $4f674d869a656e9f$var$size.md
    },
    sm: {
        field: $4f674d869a656e9f$var$size.sm,
        addon: $4f674d869a656e9f$var$size.sm
    }
};
var $4f674d869a656e9f$var$getDefaults = function(props) {
    var fc = props.focusBorderColor, ec = props.errorBorderColor;
    return {
        focusBorderColor: fc || (0, $f466d5c40b760069$export$549ff81930776885)('information.400', 'information.400')(props),
        errorBorderColor: ec || (0, $f466d5c40b760069$export$549ff81930776885)('error.400', 'error.400')(props)
    };
};
var $4f674d869a656e9f$var$variantOutline = function(props) {
    var theme = props.theme;
    var _a = $4f674d869a656e9f$var$getDefaults(props), fc = _a.focusBorderColor, ec = _a.errorBorderColor;
    return {
        field: {
            border: '1px solid',
            borderColor: 'inherit',
            bg: 'white',
            _disabled: {
                borderColor: 'inherit !important',
                opacity: 0.5,
                boxShadow: 'none !important',
                cursor: 'not-allowed',
                bg: 'slate.30'
            },
            _hover: {
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('slate.300', (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props))(props),
                boxShadow: "0 0 0 1px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, 'slate.300')
            },
            _readOnly: {
                boxShadow: 'none !important',
                userSelect: 'all'
            },
            _invalid: {
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec),
                boxShadow: "0 0 0 1px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, ec)
            },
            _focus: {
                zIndex: 1,
                borderColor: (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc),
                boxShadow: "0 0 0 1px " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: '1px solid',
            borderRadius: 'base',
            color: 'slate.500',
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('inherit', (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props))(props)
        }
    };
};
var $4f674d869a656e9f$var$variantUnstyled = {
    field: {
        bg: 'transparent',
        pl: 0,
        pr: 0,
        height: 'auto'
    },
    addon: {
        bg: 'transparent',
        pl: 0,
        pr: 0,
        height: 'auto'
    }
};
var $4f674d869a656e9f$var$variants = {
    outline: $4f674d869a656e9f$var$variantOutline,
    unstyled: $4f674d869a656e9f$var$variantUnstyled
};
var $4f674d869a656e9f$var$defaultProps = {
    size: 'md',
    variant: 'outline'
};
var $4f674d869a656e9f$export$f5b8910cec6cf069 = {
    parts: $4f674d869a656e9f$var$parts,
    baseStyle: $4f674d869a656e9f$var$baseStyle,
    sizes: $4f674d869a656e9f$var$sizes,
    variants: $4f674d869a656e9f$var$variants,
    defaultProps: $4f674d869a656e9f$var$defaultProps
};


var $299c6a6e8a648759$exports = {};

$parcel$export($299c6a6e8a648759$exports, "Kbd", function () { return $299c6a6e8a648759$export$5e66ad77b1eb2956; });

var $299c6a6e8a648759$var$baseStyle = function(props) {
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)('gray.100', 'whiteAlpha')(props),
        borderRadius: 'md',
        borderWidth: '1px',
        borderBottomWidth: '3px',
        fontSize: '0.8em',
        fontWeight: 'bold',
        lineHeight: 'normal',
        px: '0.4em',
        whiteSpace: 'nowrap'
    };
};
var $299c6a6e8a648759$export$5e66ad77b1eb2956 = {
    baseStyle: $299c6a6e8a648759$var$baseStyle
};



var $5cd9641e3301c22a$exports = {};

$parcel$export($5cd9641e3301c22a$exports, "List", function () { return $5cd9641e3301c22a$export$54c2e3dc7acea9f5; });

var $5cd9641e3301c22a$var$__assign = undefined && undefined.__assign || function() {
    $5cd9641e3301c22a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5cd9641e3301c22a$var$__assign.apply(this, arguments);
};
var $5cd9641e3301c22a$var$parts = [
    'container',
    'item',
    'icon',
    'content'
];
var $5cd9641e3301c22a$var$baseStyleContainer = {};
var $5cd9641e3301c22a$var$baseStyleItem = $5cd9641e3301c22a$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).lg);
var $5cd9641e3301c22a$var$baseStyleContent = {
    display: 'inline-flex'
};
var $5cd9641e3301c22a$var$baseStyleIcon = {
    marginEnd: '0.5rem',
    display: 'inline',
    verticalAlign: 'text-bottom'
};
var $5cd9641e3301c22a$var$baseStyle = {
    container: $5cd9641e3301c22a$var$baseStyleContainer,
    item: $5cd9641e3301c22a$var$baseStyleItem,
    icon: $5cd9641e3301c22a$var$baseStyleIcon,
    content: $5cd9641e3301c22a$var$baseStyleContent
};
var $5cd9641e3301c22a$export$54c2e3dc7acea9f5 = {
    parts: $5cd9641e3301c22a$var$parts,
    baseStyle: $5cd9641e3301c22a$var$baseStyle
};


var $806698958317d444$exports = {};

$parcel$export($806698958317d444$exports, "Menu", function () { return $806698958317d444$export$d9b273488cd8ce6f; });

var $806698958317d444$var$parts = [
    'item',
    'command',
    'list',
    'button',
    'groupTitle',
    'divider'
];
var $806698958317d444$var$baseStyleList = function() {
    return {
        minW: '3xs',
        zIndex: 1
    };
};
var $806698958317d444$var$baseStyleItem = function(props) {
    return {
        py: '2',
        px: '3',
        opacity: 1,
        transition: 'background 50ms ease-in 0s',
        _checked: {
            backgroundColor: 'light-blue.50'
        },
        _hover: {
            backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props)
        },
        _focus: {
            backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props)
        },
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    };
};
var $806698958317d444$var$baseStyleGroupTitle = {
    py: '2',
    px: '3',
    fontWeight: 'semibold',
    fontSize: 'sm',
    lineHeight: 'sm'
};
var $806698958317d444$var$baseStyleCommand = {
    opacity: 0.6
};
var $806698958317d444$var$baseStyleDivider = {
    borderColor: 'slate.100',
    borderTopWidth: '2px'
};
var $806698958317d444$var$plainVariant = function(props) {
    return {
        list: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)("white", "slate.900")(props),
            boxShadow: '2',
            color: 'inherit',
            borderRadius: 'base',
            borderWidth: '2px',
            borderColor: 'information.400'
        }
    };
};
var $806698958317d444$var$navVariant = function(props) {
    return {
        list: {
            bg: 'light-blue.50',
            borderRadius: '0',
            borderWidth: '0',
            boxShadow: '0',
            color: 'black'
        },
        item: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    };
};
var $806698958317d444$var$variants = {
    plain: $806698958317d444$var$plainVariant,
    nav: $806698958317d444$var$navVariant
};
var $806698958317d444$var$baseStyle = function(props) {
    return {
        list: $806698958317d444$var$baseStyleList(),
        item: $806698958317d444$var$baseStyleItem(props),
        groupTitle: $806698958317d444$var$baseStyleGroupTitle,
        command: $806698958317d444$var$baseStyleCommand,
        divider: $806698958317d444$var$baseStyleDivider
    };
};
var $806698958317d444$var$defaultProps = {
    variant: 'plain'
};
var $806698958317d444$export$d9b273488cd8ce6f = {
    parts: $806698958317d444$var$parts,
    defaultProps: $806698958317d444$var$defaultProps,
    variants: $806698958317d444$var$variants,
    baseStyle: $806698958317d444$var$baseStyle
};


var $be1f4e4dc4b3f46a$exports = {};

$parcel$export($be1f4e4dc4b3f46a$exports, "Modal", function () { return $be1f4e4dc4b3f46a$export$2b77a92f1a5ad772; });

var $be1f4e4dc4b3f46a$var$__assign = undefined && undefined.__assign || function() {
    $be1f4e4dc4b3f46a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be1f4e4dc4b3f46a$var$__assign.apply(this, arguments);
};
var $be1f4e4dc4b3f46a$var$parts = [
    'overlay',
    'dialogContainer',
    'dialog',
    'status',
    'header',
    'closeButton',
    'body',
    'footer',
    'icon',
    'outer'
];
var $be1f4e4dc4b3f46a$var$baseStyleOverlay = function(props) {
    var c = props.colorScheme, theme = props.theme;
    return {
        backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".900", 0.8)(theme),
        zIndex: 'modal'
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleDialogContainer = function(props) {
    var isCentered = props.isCentered, scrollBehavior = props.scrollBehavior;
    return {
        display: 'flex',
        zIndex: 'modal',
        justifyContent: 'center',
        alignItems: isCentered ? 'center' : 'flex-start',
        overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto'
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleDialog = function(props) {
    var c = props.colorScheme, theme = props.theme;
    return {
        borderColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)(c + ".900", 0.3)(theme),
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: 'sm',
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.600')(props),
        color: 'inherit',
        my: '3.75rem',
        mx: '1rem',
        zIndex: 'modal',
        boxShadow: '2'
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleHeader = function() {
    return {
        pl: 5,
        pt: 5,
        pr: 10,
        textStyle: 'h3',
        fontFamily: 'heading',
        fontWeight: 'medium'
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleCloseButton = function() {
    return {
        position: 'absolute',
        right: 0,
        top: 0
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleBody = function(props) {
    var scrollBehavior = props.scrollBehavior;
    return {
        px: 5,
        py: 3,
        flex: 1,
        textStyle: 'body1',
        overflow: scrollBehavior === 'inside' ? 'overlay' : undefined,
        // encapsulate content between horisontal lines if scroll=inside
        border: scrollBehavior === 'inside' ? '1px solid #ccc' : undefined,
        borderLeft: 'none',
        borderRight: 'none',
        marginRight: scrollBehavior === 'inside' ? '1rem' : undefined,
        marginLeft: scrollBehavior === 'inside' ? '1rem' : undefined,
        paddingLeft: scrollBehavior === 'inside' ? '0.3rem' : undefined,
        marginBottom: scrollBehavior === 'inside' ? '0.5rem' : undefined
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleFooter = function() {
    return {
        px: 5,
        pb: 5,
        pt: 3
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleStatus = function() {
    return {
        alignSelf: 'flex-start',
        marginStart: '3',
        display: 'inline',
        marginInlineStart: '5',
        marginTop: '6.5',
        // TODO: share a css var between this and ModalHeader to ensure equal fontSize
        fontSize: '1.25rem'
    };
};
var $be1f4e4dc4b3f46a$var$baseStyleOuter = function(props) {
    var scrollBehavior = props.scrollBehavior;
    return {
        maxH: scrollBehavior === 'inside' ? 'calc(100vh - 7.5rem)' : undefined
    };
};
var $be1f4e4dc4b3f46a$var$baseStyle = function(props) {
    return {
        overlay: $be1f4e4dc4b3f46a$var$baseStyleOverlay(props),
        dialogContainer: $be1f4e4dc4b3f46a$var$baseStyleDialogContainer(props),
        dialog: $be1f4e4dc4b3f46a$var$baseStyleDialog(props),
        header: $be1f4e4dc4b3f46a$var$baseStyleHeader(),
        closeButton: $be1f4e4dc4b3f46a$var$baseStyleCloseButton(),
        body: $be1f4e4dc4b3f46a$var$baseStyleBody(props),
        footer: $be1f4e4dc4b3f46a$var$baseStyleFooter(),
        status: $be1f4e4dc4b3f46a$var$baseStyleStatus(),
        outer: $be1f4e4dc4b3f46a$var$baseStyleOuter(props)
    };
};
var $be1f4e4dc4b3f46a$var$getSize = function(value) {
    if (value === 'full') return {
        dialog: {
            maxW: '100vw',
            h: '100vh',
            borderRadius: 'none',
            borderWidth: '0',
            my: 0,
            mx: 0
        }
    };
    return {
        dialog: {
            maxW: value
        }
    };
};
var $be1f4e4dc4b3f46a$var$sizes = {
    xs: $be1f4e4dc4b3f46a$var$getSize('xs'),
    sm: $be1f4e4dc4b3f46a$var$getSize('sm'),
    md: $be1f4e4dc4b3f46a$var$getSize('md'),
    lg: $be1f4e4dc4b3f46a$var$getSize('lg'),
    xl: $be1f4e4dc4b3f46a$var$getSize('xl'),
    '2xl': $be1f4e4dc4b3f46a$var$getSize('2xl'),
    '3xl': $be1f4e4dc4b3f46a$var$getSize('3xl'),
    '4xl': $be1f4e4dc4b3f46a$var$getSize('4xl'),
    '5xl': $be1f4e4dc4b3f46a$var$getSize('5xl'),
    '6xl': $be1f4e4dc4b3f46a$var$getSize('6xl'),
    full: $be1f4e4dc4b3f46a$var$getSize('full')
};
var $be1f4e4dc4b3f46a$var$getStatus = function(props) {
    var c = props.colorScheme;
    var colorIndex = c === 'error' ? '500' : '400';
    return $be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign({}, props), $be1f4e4dc4b3f46a$var$baseStyle), {
        status: {},
        dialog: {
            borderColor: c + "." + colorIndex,
            borderLeftWidth: '0.75rem'
        }
    });
};
var $be1f4e4dc4b3f46a$var$variantPlain = {};
var $be1f4e4dc4b3f46a$var$variantSuccess = function(props) {
    return $be1f4e4dc4b3f46a$var$getStatus($be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign({}, props), {
        colorScheme: 'success'
    }));
};
var $be1f4e4dc4b3f46a$var$variantInfo = function(props) {
    return $be1f4e4dc4b3f46a$var$getStatus($be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign({}, props), {
        colorScheme: 'information'
    }));
};
var $be1f4e4dc4b3f46a$var$variantWarning = function(props) {
    return $be1f4e4dc4b3f46a$var$getStatus($be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign({}, props), {
        colorScheme: 'warning'
    }));
};
var $be1f4e4dc4b3f46a$var$variantError = function(props) {
    return $be1f4e4dc4b3f46a$var$getStatus($be1f4e4dc4b3f46a$var$__assign($be1f4e4dc4b3f46a$var$__assign({}, props), {
        colorScheme: 'error'
    }));
};
var $be1f4e4dc4b3f46a$var$variants = {
    plain: $be1f4e4dc4b3f46a$var$variantPlain,
    success: $be1f4e4dc4b3f46a$var$variantSuccess,
    info: $be1f4e4dc4b3f46a$var$variantInfo,
    warning: $be1f4e4dc4b3f46a$var$variantWarning,
    error: $be1f4e4dc4b3f46a$var$variantError
};
var $be1f4e4dc4b3f46a$var$defaultProps = {
    size: 'md',
    variant: 'plain'
};
var $be1f4e4dc4b3f46a$export$2b77a92f1a5ad772 = {
    parts: $be1f4e4dc4b3f46a$var$parts,
    baseStyle: $be1f4e4dc4b3f46a$var$baseStyle,
    sizes: $be1f4e4dc4b3f46a$var$sizes,
    variants: $be1f4e4dc4b3f46a$var$variants,
    defaultProps: $be1f4e4dc4b3f46a$var$defaultProps
};


var $5e8a60ec22cbbaef$exports = {};

$parcel$export($5e8a60ec22cbbaef$exports, "Navbar", function () { return $5e8a60ec22cbbaef$export$42cfbb80f7861e77; });
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ 

var $e5Q7j = parcelRequire("e5Q7j");
var $5e8a60ec22cbbaef$var$parts = [
    'container',
    'brand',
    'segment',
    'menuItem',
    'burger',
    'menuList',
    'menuOption'
];
var $5e8a60ec22cbbaef$var$baseStyleList = function(props) {
    return {
        bg: 'light-blue.50',
        borderRadius: '0',
        borderWidth: '0',
        boxShadow: '0',
        color: 'black',
        minW: '2xs',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column'
    };
};
var $5e8a60ec22cbbaef$var$baseStyleOption = function(props) {
    var isOpen = props.isOpen;
    var style = {
        py: '2',
        px: '3',
        opacity: 1,
        transition: 'background 50ms ease-in 0s',
        textAlign: 'start',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        outline: 'none',
        _checked: {
            backgroundColor: 'light-blue.50'
        },
        _hover: {
            backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props)
        },
        _focusVisible: {
            backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props),
            boxShadow: 'focusVisible'
        },
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    };
    if (isOpen) style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
        backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(props)
    });
    return style;
};
var $5e8a60ec22cbbaef$var$baseStyleContainer = function(props) {
    var c = props.colorScheme, isSecondary = props.isSecondary, theme = props.theme, orientation = props.orientation, isFullWidth = props.isFullWidth;
    var style = {
        //TODO: remove the conditional here after the theme from storybook is fixed
        background: c + ".500",
        color: 'white',
        display: 'flex',
        height: '72px',
        pr: 4
    };
    if (orientation === 'vertical') style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
        flexDirection: 'column',
        height: '100%',
        pr: 0,
        pb: 4,
        width: isFullWidth ? '240px' : '72px'
    });
    if (isSecondary) style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
        background: 'slate.30',
        boxShadow: "inset " + (orientation === 'horizontal' ? '0px -1px' : '-1px 0px') + " 0px " + (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.1)(theme),
        color: 'slate.600'
    });
    return style;
};
var $5e8a60ec22cbbaef$var$baseStyleBrand = function(props) {
    var orientation = props.orientation, isFullWidth = props.isFullWidth;
    var style = {
        alignItems: 'center',
        display: 'flex',
        fontSize: 'lg',
        fontWeight: 'medium',
        pl: 4,
        pr: 8,
        _focus: {
            boxShadow: 'inline',
            outline: 'none'
        },
        _focusVisible: {
            boxShadow: 'inline',
            outline: 'none'
        }
    };
    if (orientation === 'vertical') {
        style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
            pl: 4,
            py: 4
        });
        if (!isFullWidth) style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
            alignSelf: 'center',
            px: 4
        });
    }
    return style;
};
var $5e8a60ec22cbbaef$var$baseStyleSegment = function(props) {
    var orientation = props.orientation;
    var style = {
        alignItems: 'center',
        display: 'flex'
    };
    if (orientation === 'vertical') style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
        alignItems: 'flex-start',
        flexDirection: 'column',
        px: 0,
        py: '16px'
    });
    return style;
};
var $5e8a60ec22cbbaef$var$baseStyleMenuItem = function(props) {
    var theme = props.theme, isActive = props.isActive, orientation = props.orientation, isSecondary = props.isSecondary, isFullWidth = props.isFullWidth;
    var style = {
        _hover: {
            background: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.1)(theme),
            cursor: 'pointer'
        },
        alignItems: 'center',
        display: 'flex',
        fontWeight: 'medium',
        height: '100%',
        justifyContent: 'inherit',
        position: 'relative',
        px: '12px',
        _focus: {
            background: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.1)(theme),
            boxShadow: 'inline',
            outline: 'none'
        },
        _focusVisible: {
            background: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.1)(theme),
            boxShadow: 'inline',
            outline: 'none'
        }
    };
    if (orientation === 'vertical') {
        style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
            height: '48px',
            px: '16px',
            py: '12px',
            width: '100%'
        });
        if (!isFullWidth) style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, {
            fontSize: '2xl',
            height: '64px'
        });
    }
    if (isActive) {
        var activeStyle = orientation === 'horizontal' ? {
            background: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('white', 0.1)(theme),
            '&::before': {
                content: '" "',
                position: 'absolute',
                backgroundColor: isSecondary ? 'slate.400' : 'white',
                width: '100%',
                height: '4px',
                left: '0',
                bottom: '0'
            }
        } : {
            background: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('white', 0.1)(theme),
            '&::before': {
                content: '" "',
                position: 'absolute',
                backgroundColor: isSecondary ? 'slate.400' : 'white',
                width: '4px',
                height: '100%',
                left: '0',
                bottom: '0'
            }
        };
        style = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(style, activeStyle);
    }
    return style;
};
var $5e8a60ec22cbbaef$var$baseStyleBurger = function() {
    return {
        alignSelf: 'center'
    };
};
var $5e8a60ec22cbbaef$var$baseStyle = function(props) {
    return {
        brand: $5e8a60ec22cbbaef$var$baseStyleBrand(props),
        burger: $5e8a60ec22cbbaef$var$baseStyleBurger(),
        container: $5e8a60ec22cbbaef$var$baseStyleContainer(props),
        menuItem: $5e8a60ec22cbbaef$var$baseStyleMenuItem(props),
        segment: $5e8a60ec22cbbaef$var$baseStyleSegment(props),
        menuList: $5e8a60ec22cbbaef$var$baseStyleList(props),
        menuOption: $5e8a60ec22cbbaef$var$baseStyleOption(props)
    };
};
var $5e8a60ec22cbbaef$var$defaultProps = {
    colorScheme: 'light-blue',
    isSecondary: false,
    isFullWidth: false,
    orientation: 'horizontal'
};
var $5e8a60ec22cbbaef$export$42cfbb80f7861e77 = {
    baseStyle: $5e8a60ec22cbbaef$var$baseStyle,
    defaultProps: $5e8a60ec22cbbaef$var$defaultProps,
    parts: $5e8a60ec22cbbaef$var$parts
};


var $df3c24a075dc36a6$exports = {};

$parcel$export($df3c24a075dc36a6$exports, "NumberInput", function () { return $df3c24a075dc36a6$export$6bf0cd3a219bbade; });
var $df3c24a075dc36a6$var$parts = [
    'container',
    'field',
    'button'
];
var $df3c24a075dc36a6$var$baseStyleContainer = {
    display: 'flex',
    alignItems: 'center'
};
var $df3c24a075dc36a6$var$baseStyleField = {
    mx: '1'
};
var $df3c24a075dc36a6$var$sizes = {
    sm: {
        field: {
            width: '10',
            px: '2'
        }
    },
    md: {
        field: {
            width: '14',
            px: '3.5',
            height: '48px'
        }
    },
    lg: {
        field: {
            width: '18',
            px: '5',
            height: '16'
        }
    }
};
var $df3c24a075dc36a6$var$baseStyle = {
    container: $df3c24a075dc36a6$var$baseStyleContainer,
    field: $df3c24a075dc36a6$var$baseStyleField
};
var $df3c24a075dc36a6$var$variants = {
    plain: {},
    full: {
        field: {
            flex: 1
        },
        button: {
            flex: 1
        }
    }
};
var $df3c24a075dc36a6$var$defaultProps = {
    size: 'md',
    variant: 'plain'
};
var $df3c24a075dc36a6$export$6bf0cd3a219bbade = {
    parts: $df3c24a075dc36a6$var$parts,
    baseStyle: $df3c24a075dc36a6$var$baseStyle,
    sizes: $df3c24a075dc36a6$var$sizes,
    variants: $df3c24a075dc36a6$var$variants,
    defaultProps: $df3c24a075dc36a6$var$defaultProps
};


var $13c5af53ded5e8c1$exports = {};

$parcel$export($13c5af53ded5e8c1$exports, "Pagination", function () { return $13c5af53ded5e8c1$export$68f5e1453c188a82; });

var $13c5af53ded5e8c1$var$parts = [
    'container',
    'buttons'
];
var $13c5af53ded5e8c1$var$baseStyleContainer = function(props) {
    return {};
};
var $13c5af53ded5e8c1$var$baseStyleButtons = function(props) {
    var c = props.colorScheme, theme = props.theme;
    return {
        _active: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".50", 'slate.800')(props)
        },
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme), (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.500', 0.5)(theme))(props)
        },
        color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.900', 'slate.100')(props)
    };
};
var $13c5af53ded5e8c1$var$baseStyle = function(props) {
    return {
        container: $13c5af53ded5e8c1$var$baseStyleContainer(props),
        buttons: $13c5af53ded5e8c1$var$baseStyleButtons(props)
    };
};
var $13c5af53ded5e8c1$var$defaultProps = {
    colorScheme: 'light-blue'
};
var $13c5af53ded5e8c1$export$68f5e1453c188a82 = {
    baseStyle: $13c5af53ded5e8c1$var$baseStyle,
    parts: $13c5af53ded5e8c1$var$parts,
    defaultProps: $13c5af53ded5e8c1$var$defaultProps
};


var $aa4e196612aeee14$exports = {};

$parcel$export($aa4e196612aeee14$exports, "Popover", function () { return $aa4e196612aeee14$export$5b6b19405a83ff9d; });

var $aa4e196612aeee14$var$parts = [
    'popper',
    'content',
    'header',
    'body',
    'footer',
    'arrow'
];
var $aa4e196612aeee14$var$baseStylePopper = {
    w: '100%',
    maxW: 'xs',
    zIndex: 10
};
var $aa4e196612aeee14$var$baseStyleContent = function(props) {
    var backgroundColor = (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.600')(props);
    var borderColor = (0, $f466d5c40b760069$export$549ff81930776885)('slate.300', 'slate.800')(props);
    /**
     * Note, ideally the box-shadow for the popper-arrow should have a 0 blur and a 1px spread (to
     * make it sharp, like the other borders on the popover), but that definition is buried deep in
     * chakra ( packages/popper/src/utils.ts #getBoxShadow ) with hardcoded values.
     */ return {
        backgroundColor: backgroundColor,
        '--popper-arrow-bg': "colors." + backgroundColor,
        '--popper-arrow-shadow-color': "colors." + borderColor,
        '--popper-arrow-size': '9px',
        p: '5',
        border: '1px solid',
        borderColor: borderColor,
        borderRadius: 'base',
        boxShadow: '2',
        zIndex: 'inherit',
        _focusVisible: {
            outline: 0,
            boxShadow: 'focusVisible'
        },
        _focus: {
            outline: 0
        }
    };
};
var $aa4e196612aeee14$var$baseStyleArrow = {
};
var $aa4e196612aeee14$var$baseStyleHeader = {
    textStyle: 'md',
    fontWeight: 'medium'
};
var $aa4e196612aeee14$var$baseStyleBody = {
    textStyle: 'sm',
    pt: 1
};
var $aa4e196612aeee14$var$baseStyleFooter = {
    pt: 4
};
var $aa4e196612aeee14$var$baseStyle = function(props) {
    return {
        popper: $aa4e196612aeee14$var$baseStylePopper,
        content: $aa4e196612aeee14$var$baseStyleContent(props),
        header: $aa4e196612aeee14$var$baseStyleHeader,
        body: $aa4e196612aeee14$var$baseStyleBody,
        footer: $aa4e196612aeee14$var$baseStyleFooter,
        arrow: $aa4e196612aeee14$var$baseStyleArrow
    };
};
var $aa4e196612aeee14$export$5b6b19405a83ff9d = {
    parts: $aa4e196612aeee14$var$parts,
    baseStyle: $aa4e196612aeee14$var$baseStyle
};


var $dfbe2e0280826813$exports = {};

$parcel$export($dfbe2e0280826813$exports, "Progress", function () { return $dfbe2e0280826813$export$b25a304ec7d746bb; });

var $dfbe2e0280826813$var$__assign = undefined && undefined.__assign || function() {
    $dfbe2e0280826813$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dfbe2e0280826813$var$__assign.apply(this, arguments);
};
var $dfbe2e0280826813$var$parts = [
    'track',
    'filledTrack',
    'panel'
];
var $dfbe2e0280826813$var$filledStyle = function(props) {
    var c = props.colorScheme, t = props.theme, isIndeterminate = props.isIndeterminate, hasStripe = props.hasStripe;
    var stripeStyle = (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$db0ffb03ee9f3080)(), (0, $188d0d70c4460bfd$export$db0ffb03ee9f3080)('1rem', 'rgba(0,0,0,0.1)'))(props);
    var bgColor = (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props);
    var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    " + (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(t, bgColor) + " 50%,\n    transparent 100%\n  )";
    var addStripe = !isIndeterminate && hasStripe;
    return $dfbe2e0280826813$var$__assign($dfbe2e0280826813$var$__assign({}, addStripe && stripeStyle), isIndeterminate ? {
        bgImage: gradient
    } : {
        bgColor: bgColor
    });
};
var $dfbe2e0280826813$var$baseStyleLabel = {
    lineHeight: '1',
    fontSize: '0.25em',
    fontWeight: 'bold',
    color: 'white'
};
var $dfbe2e0280826813$var$baseStyleTrack = function(props) {
    return {
        backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)("slate.100", "white")(props)
    };
};
var $dfbe2e0280826813$var$baseStyleFilledTrack = function(props) {
    return $dfbe2e0280826813$var$__assign({
        transition: 'all 0.3s'
    }, $dfbe2e0280826813$var$filledStyle(props));
};
var $dfbe2e0280826813$var$baseStyle = function(props) {
    return {
        label: $dfbe2e0280826813$var$baseStyleLabel,
        filledTrack: $dfbe2e0280826813$var$baseStyleFilledTrack(props),
        track: $dfbe2e0280826813$var$baseStyleTrack(props)
    };
};
var $dfbe2e0280826813$var$sizes = {
    xs: {
        track: {
            h: '0.25rem'
        }
    }
};
var $dfbe2e0280826813$var$defaultProps = {
    size: 'xs',
    colorScheme: 'light-blue'
};
var $dfbe2e0280826813$export$b25a304ec7d746bb = {
    parts: $dfbe2e0280826813$var$parts,
    sizes: $dfbe2e0280826813$var$sizes,
    baseStyle: $dfbe2e0280826813$var$baseStyle,
    defaultProps: $dfbe2e0280826813$var$defaultProps
};


var $241917528edef79e$exports = {};

$parcel$export($241917528edef79e$exports, "Radio", function () { return $241917528edef79e$export$d7b12c4107be0d61; });


var $241917528edef79e$var$__assign = undefined && undefined.__assign || function() {
    $241917528edef79e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $241917528edef79e$var$__assign.apply(this, arguments);
};
var $241917528edef79e$var$parts = [
    'container',
    'control',
    'label'
];
var $241917528edef79e$var$baseStyleControl = function(props) {
    var control = (0, $4f662729da9bf48d$export$48513f6b9f8ce62d).baseStyle(props).control;
    var c = props.colorScheme;
    return $241917528edef79e$var$__assign($241917528edef79e$var$__assign({}, control), {
        w: 4.5,
        h: 4.5,
        borderRadius: 'full',
        cursor: 'pointer',
        _checked: $241917528edef79e$var$__assign($241917528edef79e$var$__assign({}, control._checked), {
            borderWidth: '2px',
            backgroundColor: 'white',
            _before: {
                content: "\"\"",
                display: 'inline-block',
                pos: 'relative',
                w: 2.5,
                h: 2.5,
                borderRadius: '50%',
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
            },
            _hover: {
                backgroundColor: 'white',
                _before: {
                    backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".300")(props)
                }
            },
            _disabled: {
                cursor: 'not-allowed',
                backgroundColor: 'white',
                _before: {
                    backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
                }
            }
        })
    });
};
var $241917528edef79e$var$baseStyle = function(props) {
    return {
        label: (0, $4f662729da9bf48d$export$48513f6b9f8ce62d).baseStyle(props).label,
        control: $241917528edef79e$var$baseStyleControl(props)
    };
};
var $241917528edef79e$var$sizes = {
    sm: {
        label: {
            textStyle: 'sm'
        }
    },
    md: {
        label: {
            textStyle: 'md'
        }
    },
    lg: {
        label: {
            textStyle: 'lg'
        }
    }
};
var $241917528edef79e$var$defaultProps = {
    size: 'md',
    colorScheme: 'light-blue'
};
var $241917528edef79e$export$d7b12c4107be0d61 = {
    parts: $241917528edef79e$var$parts,
    baseStyle: $241917528edef79e$var$baseStyle,
    sizes: $241917528edef79e$var$sizes,
    defaultProps: $241917528edef79e$var$defaultProps
};


var $2f7d71d57c2a87b4$exports = {};

$parcel$export($2f7d71d57c2a87b4$exports, "Select", function () { return $2f7d71d57c2a87b4$export$ef9b1a59e592288f; });


var $e5Q7j = parcelRequire("e5Q7j");

var $2f7d71d57c2a87b4$var$parts = [
    'field',
    'icon'
];
var $2f7d71d57c2a87b4$var$baseStyleField = function(props) {
    return {
        appearance: 'none',
        paddingBottom: '1px',
        lineHeight: 'normal',
        width: '100%',
        minWidth: 0,
        outline: 0,
        position: 'relative',
        transition: 'all 0.2s',
        boxShadow: '1',
        borderRadius: 'base',
        '> option, > optgroup': {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.700')(props)
        }
    };
};
var $2f7d71d57c2a87b4$var$baseStyleIcon = {
    width: '1.5rem',
    height: '100%',
    insetEnd: '0.5rem',
    position: 'relative',
    color: 'currentColor',
    fontSize: '1.25rem',
    _disabled: {
        opacity: 0.5
    }
};
var $2f7d71d57c2a87b4$var$baseStyle = function(props) {
    return {
        field: $2f7d71d57c2a87b4$var$baseStyleField(props),
        icon: $2f7d71d57c2a87b4$var$baseStyleIcon
    };
};
var $2f7d71d57c2a87b4$var$sizes = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, (0, $4f674d869a656e9f$export$f5b8910cec6cf069).sizes, {
    xs: {
        icon: {
            insetEnd: '0.25rem'
        }
    }
});
var $2f7d71d57c2a87b4$export$ef9b1a59e592288f = {
    parts: $2f7d71d57c2a87b4$var$parts,
    baseStyle: $2f7d71d57c2a87b4$var$baseStyle,
    sizes: $2f7d71d57c2a87b4$var$sizes,
    variants: (0, $4f674d869a656e9f$export$f5b8910cec6cf069).variants,
    defaultProps: (0, $4f674d869a656e9f$export$f5b8910cec6cf069).defaultProps
};


var $3b2d34acb4b97e61$exports = {};

$parcel$export($3b2d34acb4b97e61$exports, "Skeleton", function () { return $3b2d34acb4b97e61$export$8f31e4c4a37b8e9c; });


var $3b2d34acb4b97e61$var$fade = function(startColor, endColor) {
    return (0, $803605a2d06b7a22$export$d25ddfdf17c3ad3e)({
        from: {
            borderColor: startColor,
            background: startColor
        },
        to: {
            borderColor: endColor,
            background: endColor
        }
    });
};
var $3b2d34acb4b97e61$var$baseStyle = function(props) {
    var defaultStartColor = (0, $f466d5c40b760069$export$549ff81930776885)('slate.50', 'slate.400')(props);
    var defaultEndColor = (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.500')(props);
    var _a = props.startColor, startColor = _a === void 0 ? defaultStartColor : _a, _b = props.endColor, endColor = _b === void 0 ? defaultEndColor : _b, speed = props.speed, theme = props.theme;
    var start = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, startColor);
    var end = (0, $188d0d70c4460bfd$export$5551a2d24ff40153)(theme, endColor);
    return {
        opacity: 0.7,
        borderRadius: '2px',
        borderColor: start,
        background: end,
        animation: speed + "s linear infinite alternate " + $3b2d34acb4b97e61$var$fade(start, end)
    };
};
var $3b2d34acb4b97e61$export$8f31e4c4a37b8e9c = {
    baseStyle: $3b2d34acb4b97e61$var$baseStyle
};


var $3a1840abb9d01876$exports = {};

$parcel$export($3a1840abb9d01876$exports, "Slider", function () { return $3a1840abb9d01876$export$472062a354075cee; });

var $3a1840abb9d01876$var$parts = [
    'container',
    'thumb',
    'track',
    'filledTrack'
];
var $3a1840abb9d01876$var$baseStyleContainer = function(props) {
    return {
        _disabled: {
            opacity: 0.5,
            cursor: 'default',
            pointerEvents: 'none'
        },
        w: '100%'
    };
};
var $3a1840abb9d01876$var$baseStyleTrack = function(props) {
    return {
        borderRadius: 'sm',
        bg: (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.200')(props),
        height: '4px'
    };
};
var $3a1840abb9d01876$var$baseStyleThumb = function(props) {
    var c = props.colorScheme;
    return {
        width: '6',
        height: '6',
        zIndex: 1,
        borderRadius: 'full',
        bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props),
        boxShadow: 'button',
        transition: 'transform 0.1s',
        top: '50%',
        _focus: {
            boxShadow: 'outline'
        },
        transform: "translateY(-50%)",
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".600", c + ".200")(props),
            transform: "translateY(-50%) scale(1.15)"
        }
    };
};
var $3a1840abb9d01876$var$baseStyleFilledTrack = function(props) {
    var c = props.colorScheme;
    return {
        bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".400", c + ".200")(props)
    };
};
var $3a1840abb9d01876$var$baseStyle = function(props) {
    return {
        container: $3a1840abb9d01876$var$baseStyleContainer(props),
        track: $3a1840abb9d01876$var$baseStyleTrack(props),
        thumb: $3a1840abb9d01876$var$baseStyleThumb(props),
        filledTrack: $3a1840abb9d01876$var$baseStyleFilledTrack(props)
    };
};
var $3a1840abb9d01876$var$defaultProps = {
    size: 'md',
    colorScheme: 'light-blue'
};
var $3a1840abb9d01876$export$472062a354075cee = {
    parts: $3a1840abb9d01876$var$parts,
    baseStyle: $3a1840abb9d01876$var$baseStyle,
    defaultProps: $3a1840abb9d01876$var$defaultProps
};


var $92d75bcc25e4dc07$exports = {};

$parcel$export($92d75bcc25e4dc07$exports, "Stepper", function () { return $92d75bcc25e4dc07$export$ed8ca599049e8881; });
var $92d75bcc25e4dc07$var$__assign = undefined && undefined.__assign || function() {
    $92d75bcc25e4dc07$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $92d75bcc25e4dc07$var$__assign.apply(this, arguments);
};
var $92d75bcc25e4dc07$var$parts = [
    'container',
    'step',
    'link',
    'graph',
    'panel',
    'label'
];
var $92d75bcc25e4dc07$var$hGraph = {
    content: '""',
    display: 'block',
    flexGrow: 1,
    height: '1'
};
var $92d75bcc25e4dc07$var$vGraph = {
    borderRadius: '10px',
    marginTop: '2',
    content: '""',
    display: 'block',
    flexGrow: 1,
    minHeight: '6',
    width: '1'
};
var $92d75bcc25e4dc07$var$containerAndLabelStyles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'center'
    },
    label: {
        marginTop: '4'
    }
};
var $92d75bcc25e4dc07$var$baseStyleContainer = function(props) {
    return {
        listStyleType: 'none',
        'li:first-child .step-graph::before': {
            visibility: 'hidden'
        },
        'li:last-child .step-graph::after': {
            visibility: 'hidden'
        }
    };
};
var $92d75bcc25e4dc07$var$baseStyleLink = function(props) {
    var c = props.colorScheme;
    return {
        alignItems: 'center',
        borderRadius: 'full',
        borderStyle: 'solid',
        borderWidth: '3px',
        boxShadow: 'none',
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        fontWeight: 'medium',
        height: '8',
        justifyContent: 'center',
        outline: 'none',
        textDecoration: 'none',
        width: '8',
        fontSize: 'xl',
        _focusVisible: {
            boxShadow: 'focusVisible'
        },
        '&[data-state="incomplete"]': {
            backgroundColor: 'white',
            borderColor: 'slate.100',
            color: 'slate.500'
        },
        '&[data-state="active"]': {
            backgroundColor: 'white',
            borderColor: c + ".500",
            color: c + ".500"
        },
        '&[data-state="complete"]': {
            backgroundColor: c + ".500",
            borderColor: c + ".500",
            color: 'white',
            '&:not([aria-readonly=true])': {
                _hover: {
                    backgroundColor: c + ".600",
                    borderColor: c + ".600"
                }
            }
        }
    };
};
var $92d75bcc25e4dc07$var$baseStyleGraph = function(props) {
    var c = props.colorScheme;
    return {
        alignItems: 'center',
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        '&[data-state="complete"]': {
            _before: {
                backgroundColor: c + ".500"
            },
            _after: {
                backgroundColor: c + ".500"
            }
        },
        '&[data-state="incomplete"]': {
            _before: {
                backgroundColor: 'slate.100'
            },
            _after: {
                backgroundColor: 'slate.100'
            }
        },
        '&[data-state="active"]': {
            _before: {
                backgroundColor: c + ".500"
            },
            _after: {
                backgroundColor: 'slate.100'
            }
        }
    };
};
var $92d75bcc25e4dc07$var$baseStyleLabel = function(props) {
    return {
        display: 'block',
        backgroundColor: 'none',
        color: 'slate.500',
        fontSize: 'xl'
    };
};
var $92d75bcc25e4dc07$var$baseStyleStep = function(props) {
    return {
        width: 'full'
    };
};
var $92d75bcc25e4dc07$var$baseStylePanel = function(props) {
    return {
        paddingTop: '4'
    };
};
var $92d75bcc25e4dc07$var$leftVariant = function(props) {
    return $92d75bcc25e4dc07$var$__assign($92d75bcc25e4dc07$var$__assign({}, $92d75bcc25e4dc07$var$containerAndLabelStyles), {
        step: {
            marginStart: '2'
        },
        label: {
            marginTop: '4',
            paddingEnd: '2',
            textAlign: 'left'
        },
        graph: {
            _after: $92d75bcc25e4dc07$var$__assign({
                borderRadius: '10px',
                marginLeft: '2'
            }, $92d75bcc25e4dc07$var$hGraph)
        }
    });
};
var $92d75bcc25e4dc07$var$rightVariant = function(props) {
    return $92d75bcc25e4dc07$var$__assign($92d75bcc25e4dc07$var$__assign({}, $92d75bcc25e4dc07$var$containerAndLabelStyles), {
        step: {
            marginEnd: '2'
        },
        label: {
            marginTop: '4',
            paddingStart: '2',
            textAlign: 'right'
        },
        graph: {
            _before: $92d75bcc25e4dc07$var$__assign({
                borderRadius: '10px',
                marginRight: '2'
            }, $92d75bcc25e4dc07$var$hGraph)
        }
    });
};
var $92d75bcc25e4dc07$var$horizontalCenterVariant = function(props) {
    return $92d75bcc25e4dc07$var$__assign($92d75bcc25e4dc07$var$__assign({}, $92d75bcc25e4dc07$var$containerAndLabelStyles), {
        label: {
            marginTop: '4',
            paddingX: '2',
            textAlign: 'center'
        },
        graph: {
            _before: $92d75bcc25e4dc07$var$__assign({
                borderRightRadius: '10px',
                marginRight: '2'
            }, $92d75bcc25e4dc07$var$hGraph),
            _after: $92d75bcc25e4dc07$var$__assign({
                borderLeftRadius: '10px',
                marginLeft: '2'
            }, $92d75bcc25e4dc07$var$hGraph)
        }
    });
};
var $92d75bcc25e4dc07$var$verticalVariant = function(props) {
    return {
        container: {
            display: 'block',
            textAlign: 'left'
        },
        step: {
            alignItems: 'stretch',
            display: 'flex',
            width: 'auto',
            marginTop: '2'
        },
        label: {
            paddingTop: '1.5'
        },
        graph: {
            display: 'flex',
            flexDirection: 'column',
            _after: $92d75bcc25e4dc07$var$__assign({}, $92d75bcc25e4dc07$var$vGraph)
        }
    };
};
var $92d75bcc25e4dc07$var$variants = {
    horizontal: $92d75bcc25e4dc07$var$horizontalCenterVariant,
    vertical: $92d75bcc25e4dc07$var$verticalVariant,
    left: $92d75bcc25e4dc07$var$leftVariant,
    right: $92d75bcc25e4dc07$var$rightVariant,
    center: $92d75bcc25e4dc07$var$horizontalCenterVariant
};
var $92d75bcc25e4dc07$var$baseStyle = function(props) {
    return {
        container: $92d75bcc25e4dc07$var$baseStyleContainer(props),
        panel: $92d75bcc25e4dc07$var$baseStylePanel(props),
        link: $92d75bcc25e4dc07$var$baseStyleLink(props),
        step: $92d75bcc25e4dc07$var$baseStyleStep(props),
        graph: $92d75bcc25e4dc07$var$baseStyleGraph(props),
        label: $92d75bcc25e4dc07$var$baseStyleLabel(props)
    };
};
var $92d75bcc25e4dc07$var$defaultProps = {
    colorScheme: 'light-blue',
    variant: 'horizontal'
};
var $92d75bcc25e4dc07$export$ed8ca599049e8881 = {
    parts: $92d75bcc25e4dc07$var$parts,
    baseStyle: $92d75bcc25e4dc07$var$baseStyle,
    variants: $92d75bcc25e4dc07$var$variants,
    defaultProps: $92d75bcc25e4dc07$var$defaultProps
};


var $e2ef2d2445362189$exports = {};

$parcel$export($e2ef2d2445362189$exports, "Switch", function () { return $e2ef2d2445362189$export$b5d5cf8927ab7262; });

var $e2ef2d2445362189$var$parts = [
    'container',
    'track',
    'thumb'
];
var $e2ef2d2445362189$var$baseStyleTrack = function(props) {
    var c = props.colorScheme;
    return {
        borderRadius: 'full',
        p: '1px',
        width: 'var(--slider-track-width)',
        height: 'var(--slider-track-height)',
        transition: 'all 120ms',
        border: '1px solid',
        borderColor: 'slate.300',
        boxShadow: 'inset 0px 1px 0px rgba(0, 0, 0, 0.1)',
        bg: (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.50')(props),
        _focus: {
            outline: 'none',
            boxShadow: 'focusVisible'
        },
        _disabled: {
            opacity: 0.5,
            cursor: 'not-allowed'
        },
        _checked: {
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".700", c + ".100")(props),
            bg: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".500", c + ".200")(props)
        }
    };
};
var $e2ef2d2445362189$var$baseStyleThumb = {
    bg: 'white',
    boxShadow: '1px 0px 0px rgba(0, 0, 0, 0.1)',
    transition: 'transform 250ms',
    borderRadius: 'inherit',
    width: 'var(--slider-track-height)',
    height: 'var(--slider-track-height)',
    _checked: {
        boxShadow: '-1px 0px 0px rgba(0, 0, 0, 0.1)',
        transform: 'translateX(var(--slider-thumb-x))'
    }
};
var $e2ef2d2445362189$var$baseStyle = function(props) {
    return {
        container: {
            height: '6',
            display: 'block',
            '--slider-track-diff': 'calc(var(--slider-track-width) - var(--slider-track-height))',
            '--slider-thumb-x': 'var(--slider-track-diff)',
            _rtl: {
                '--slider-thumb-x': 'calc(-1 * var(--slider-track-diff))'
            }
        },
        track: $e2ef2d2445362189$var$baseStyleTrack(props),
        thumb: $e2ef2d2445362189$var$baseStyleThumb
    };
};
var $e2ef2d2445362189$var$sizes = {
    md: {
        container: {
            '--slider-track-width': '2.75rem',
            '--slider-track-height': '1.25rem'
        }
    }
};
var $e2ef2d2445362189$var$defaultProps = {
    size: 'md',
    colorScheme: 'light-blue'
};
var $e2ef2d2445362189$export$b5d5cf8927ab7262 = {
    parts: $e2ef2d2445362189$var$parts,
    baseStyle: $e2ef2d2445362189$var$baseStyle,
    sizes: $e2ef2d2445362189$var$sizes,
    defaultProps: $e2ef2d2445362189$var$defaultProps
};


var $30fe38d2785cdb3f$exports = {};

$parcel$export($30fe38d2785cdb3f$exports, "Table", function () { return $30fe38d2785cdb3f$export$54ec01a60f47d33d; });

var $30fe38d2785cdb3f$var$__assign = undefined && undefined.__assign || function() {
    $30fe38d2785cdb3f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $30fe38d2785cdb3f$var$__assign.apply(this, arguments);
};
var $30fe38d2785cdb3f$var$parts = [
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'caption'
];
var $30fe38d2785cdb3f$var$baseStyle = function(props) {
    return {
        table: {
            fontVariantNumeric: 'lining-nums tabular-nums',
            borderCollapse: 'collapse',
            width: 'full',
            tableLayout: 'fixed'
        },
        th: {
            backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05), 'slate.800')(props),
            fontFamily: 'heading',
            fontWeight: 'bold',
            textAlign: 'left'
        },
        td: {
            textAlign: 'left'
        },
        caption: {
            mt: 4,
            fontFamily: 'heading',
            textAlign: 'center',
            fontWeight: 'medium'
        }
    };
};
var $30fe38d2785cdb3f$var$numericStyles = {
    '&[data-is-numeric=true]': {
        textAlign: 'right'
    }
};
var $30fe38d2785cdb3f$var$simpleVariant = function(props) {
    var c = props.colorScheme;
    return {
        th: $30fe38d2785cdb3f$var$__assign({
            color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.900', 'slate.200')(props),
            borderBottom: '2px',
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.400')(props)
        }, $30fe38d2785cdb3f$var$numericStyles),
        tr: {
            _selected: {
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".10", 'slate.200')(props)
            }
        },
        td: $30fe38d2785cdb3f$var$__assign({
            borderBottom: '1px',
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('slate.100', 'slate.400')(props)
        }, $30fe38d2785cdb3f$var$numericStyles),
        caption: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.900', 'slate.200')(props)
        },
        tfoot: {
            tr: {
                '&:last-of-type': {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
};
var $30fe38d2785cdb3f$var$variants = {
    simple: $30fe38d2785cdb3f$var$simpleVariant,
    unstyled: {}
};
var $30fe38d2785cdb3f$var$sizes = {
    sm: {
        th: {
            px: '0.75rem',
            py: '0.5rem',
            textStyle: 'h5'
        },
        td: {
            px: '0.75rem',
            py: '0.5rem',
            textStyle: 'body2'
        },
        caption: {
            px: '0.75rem',
            py: '0.5rem',
            textStyle: 'body2'
        }
    },
    md: {
        th: {
            px: '1rem',
            py: '0.75rem',
            textStyle: 'h5'
        },
        td: {
            px: '1rem',
            py: '0.75rem',
            textStyle: 'body1'
        },
        caption: {
            px: '1rem',
            py: '0.75rem',
            textStyle: 'body2'
        }
    }
};
var $30fe38d2785cdb3f$var$defaultProps = {
    variant: 'simple',
    size: 'md',
    colorScheme: 'slate'
};
var $30fe38d2785cdb3f$export$54ec01a60f47d33d = {
    parts: $30fe38d2785cdb3f$var$parts,
    baseStyle: $30fe38d2785cdb3f$var$baseStyle,
    variants: $30fe38d2785cdb3f$var$variants,
    sizes: $30fe38d2785cdb3f$var$sizes,
    defaultProps: $30fe38d2785cdb3f$var$defaultProps
};


var $21e8717d4589e738$exports = {};

$parcel$export($21e8717d4589e738$exports, "Tabs", function () { return $21e8717d4589e738$export$b2539bed5023c21c; });

/**
 * BaseStyles, avoid colors or any value that we want to have our end-users theme. we need to
 * discuss this with the designers. also try to use fully-written css props (don't use bg, use
 * backgroundColor, don't use h or w, use height and width) however, if you really want to use the
 * shorthand notation, group them together in "base" and "magic" categories
 */ var $21e8717d4589e738$var$parts = [
    'root',
    'tablist',
    'tab',
    'tabpanel',
    'indicator'
];
var $21e8717d4589e738$var$sizes = {
    md: {
        tab: {
            paddingStart: '4',
            paddingEnd: '4',
            height: '3rem',
            textStyle: 'lg'
        }
    },
    lg: {
        tab: {
            paddingStart: '8',
            paddingEnd: '8',
            height: '4rem',
            textStyle: 'xl'
        }
    }
};
var $21e8717d4589e738$var$baseStyleTab = function(props) {
    var isFitted = props.isFitted;
    return {
        fontWeight: 'regular',
        color: 'slate.600',
        flex: isFitted ? 1 : undefined,
        transition: 'colors normal',
        outline: 0,
        _focusVisible: {
            zIndex: 1,
            boxShadow: 'focusVisible'
        }
    };
};
var $21e8717d4589e738$var$baseStyleTablist = function(props) {
    var _a = props.align, align = _a === void 0 ? 'start' : _a, orientation = props.orientation;
    var alignments = {
        end: 'flex-end',
        center: 'center',
        start: 'flex-start'
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === 'vertical' ? 'column' : 'row'
    };
};
var $21e8717d4589e738$var$baseStyleTabpanel = {
    p: 4
};
var $21e8717d4589e738$var$variantPlain = function(props) {
    var _a, _b;
    var c = props.colorScheme, theme = props.theme, orientation = props.orientation;
    var isVertical = orientation === 'vertical';
    var borderProp = orientation === 'vertical' ? 'borderLeft' : 'borderBottom';
    var marginProp = isVertical ? 'ml' : 'mb';
    return {
        tablist: (_a = {}, _a[borderProp] = '4px solid', _a.borderColor = 'slate.100', _a),
        tab: (_b = {}, _b[borderProp] = '4px solid', _b.borderColor = 'transparent', _b[marginProp] = '-4px', _b._selected = {
            fontWeight: 'medium',
            color: c + ".500",
            borderColor: 'currentColor',
            backgroundColor: c + ".50"
        }, _b._active = {
            color: c + ".700"
        }, _b._hover = {
            ':enabled': {
                backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme)
            }
        }, _b._disabled = {
            opacity: 0.4,
            cursor: 'not-allowed'
        }, _b)
    };
};
var $21e8717d4589e738$var$baseStyleRoot = function(props) {
    var orientation = props.orientation;
    return {
        fontFamily: 'body',
        display: orientation === 'vertical' ? 'flex' : 'block'
    };
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $21e8717d4589e738$var$baseStyle = function(props) {
    return {
        root: $21e8717d4589e738$var$baseStyleRoot(props),
        tab: $21e8717d4589e738$var$baseStyleTab(props),
        tablist: $21e8717d4589e738$var$baseStyleTablist(props),
        tabpanel: $21e8717d4589e738$var$baseStyleTabpanel
    };
};
var $21e8717d4589e738$var$variants = {
    plain: $21e8717d4589e738$var$variantPlain
};
var $21e8717d4589e738$var$defaultProps = {
    variant: 'plain',
    size: 'md',
    colorScheme: 'light-blue'
};
var $21e8717d4589e738$export$b2539bed5023c21c = {
    parts: $21e8717d4589e738$var$parts,
    baseStyle: $21e8717d4589e738$var$baseStyle,
    variants: $21e8717d4589e738$var$variants,
    sizes: $21e8717d4589e738$var$sizes,
    defaultProps: $21e8717d4589e738$var$defaultProps
};


var $ceb0c1f432692480$exports = {};

$parcel$export($ceb0c1f432692480$exports, "Tag", function () { return $ceb0c1f432692480$export$3288d34c523a1192; });

var $ceb0c1f432692480$var$__assign = undefined && undefined.__assign || function() {
    $ceb0c1f432692480$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ceb0c1f432692480$var$__assign.apply(this, arguments);
};
var $ceb0c1f432692480$var$parts = [
    'container',
    'label',
    'closeButton'
];
var $ceb0c1f432692480$var$baseStylePart = {
    alignItems: 'center',
    display: 'flex',
    fontWeight: 'inherit',
    justifyContent: 'center',
    outline: 'none'
};
var $ceb0c1f432692480$var$disabledStyle = {
    _disabled: {
        opacity: '50%',
        pointerEvents: 'none'
    }
};
var $ceb0c1f432692480$var$baseStyleInteractive = $ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign({}, $ceb0c1f432692480$var$baseStylePart), {
    _hover: {
        zIndex: '1'
    },
    _focusVisible: {
        boxShadow: "focusVisible",
        zIndex: '2'
    }
});
var $ceb0c1f432692480$var$baseStyleContainer = {
    borderRadius: 'full',
    fontWeight: 'medium',
    '>*:first-child': {
        borderBottomLeftRadius: 'full',
        borderTopLeftRadius: 'full'
    },
    '>*:last-child': {
        borderBottomRightRadius: 'full',
        borderTopRightRadius: 'full'
    }
};
var $ceb0c1f432692480$var$baseStyleLabel = $ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign({}, $ceb0c1f432692480$var$baseStylePart), {
    fontSize: 'inherit'
});
var $ceb0c1f432692480$var$baseStyleCloseButton = $ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign({}, $ceb0c1f432692480$var$baseStyleInteractive), {
    transition: 'none'
});
var $ceb0c1f432692480$var$baseStyle = function(props) {
    return {
        part: $ceb0c1f432692480$var$baseStylePart,
        container: $ceb0c1f432692480$var$baseStyleContainer,
        label: $ceb0c1f432692480$var$baseStyleLabel,
        closeButton: $ceb0c1f432692480$var$baseStyleCloseButton
    };
};
var $ceb0c1f432692480$var$sizes = {
    sm: {
        label: {
            fontSize: 'sm',
            height: '1.5rem',
            px: 2,
            ':not(:first-child)': {
                pl: '0.125rem'
            },
            ':not(:last-child)': {
                pr: '0.125rem'
            }
        },
        closeButton: {
            height: '1.5rem',
            paddingLeft: 0,
            paddingRight: 1,
            svg: {
                height: '1em',
                width: '1em'
            }
        }
    },
    md: {
        label: {
            fontSize: 'md',
            height: '2rem',
            px: '0.625rem',
            ':not(:first-child)': {
                pl: 1
            },
            ':not(:last-child)': {
                pr: 1
            }
        },
        closeButton: {
            height: '2rem',
            paddingLeft: '1px',
            paddingRight: '5px',
            svg: {
                height: '1.125em',
                width: '1.125em'
            }
        }
    },
    lg: {
        label: {
            fontSize: 'lg',
            height: '2.375rem',
            px: 3,
            ':not(:first-child)': {
                pl: '0.375rem'
            },
            ':not(:last-child)': {
                pr: '0.375rem'
            }
        },
        closeButton: {
            height: '2.375rem',
            paddingLeft: '1px',
            paddingRight: '5px',
            svg: {
                height: '1.375em',
                width: '1.375em'
            }
        }
    }
};
var $ceb0c1f432692480$var$variantPlain = function(props) {
    var c = props.colorScheme;
    return {
        label: $ceb0c1f432692480$var$__assign({
            backgroundColor: c + ".50"
        }, $ceb0c1f432692480$var$disabledStyle),
        closeButton: {
            backgroundColor: c + ".50",
            _hover: {
                backgroundColor: c + ".100"
            }
        },
        container: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".700", c + ".700")(props),
            button: $ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign({}, $ceb0c1f432692480$var$baseStyleInteractive), {
                backgroundColor: c + ".50",
                _hover: {
                    backgroundColor: c + ".100"
                }
            }), $ceb0c1f432692480$var$disabledStyle)
        }
    };
};
var $ceb0c1f432692480$var$variantGhost = function(props) {
    var c = props.colorScheme, theme = props.theme;
    return {
        label: $ceb0c1f432692480$var$__assign({
            backgroundColor: 'transparent'
        }, $ceb0c1f432692480$var$disabledStyle),
        closeButton: {
            backgroundColor: 'transparent',
            _hover: {
                backgroundColor: 'slate.5'
            }
        },
        container: {
            color: (0, $f466d5c40b760069$export$549ff81930776885)(c + ".700", c + ".200")(props),
            button: $ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign($ceb0c1f432692480$var$__assign({}, $ceb0c1f432692480$var$baseStyleInteractive), {
                backgroundColor: 'transparent',
                _hover: {
                    backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme)
                },
                _focusVisible: {
                    boxShadow: "focusVisible",
                    backgroundColor: (0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.05)(theme)
                }
            }), $ceb0c1f432692480$var$disabledStyle)
        }
    };
};
var $ceb0c1f432692480$var$variants = {
    plain: $ceb0c1f432692480$var$variantPlain,
    ghost: $ceb0c1f432692480$var$variantGhost
};
var $ceb0c1f432692480$var$defaultProps = {
    size: 'md',
    variant: 'plain',
    colorScheme: 'light-blue'
};
var $ceb0c1f432692480$export$3288d34c523a1192 = {
    parts: $ceb0c1f432692480$var$parts,
    variants: $ceb0c1f432692480$var$variants,
    baseStyle: $ceb0c1f432692480$var$baseStyle,
    sizes: $ceb0c1f432692480$var$sizes,
    defaultProps: $ceb0c1f432692480$var$defaultProps
};


var $aa9101b27f774df8$exports = {};

$parcel$export($aa9101b27f774df8$exports, "Text", function () { return $aa9101b27f774df8$export$5f1af8db9871e1d6; });
var $aa9101b27f774df8$var$baseStyle = {
    fontFamily: 'body'
};
var $aa9101b27f774df8$var$variants = {
    normal: {},
    'high-density': {}
};
var $aa9101b27f774df8$var$defaultProps = {
    variant: 'normal'
};
var $aa9101b27f774df8$export$5f1af8db9871e1d6 = {
    baseStyle: $aa9101b27f774df8$var$baseStyle,
    variants: $aa9101b27f774df8$var$variants,
    defaultProps: $aa9101b27f774df8$var$defaultProps
};


var $e0580757b8029ee4$exports = {};

$parcel$export($e0580757b8029ee4$exports, "Textarea", function () { return $e0580757b8029ee4$export$379139ebc1c2b235; });


var $e0580757b8029ee4$var$__assign = undefined && undefined.__assign || function() {
    $e0580757b8029ee4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e0580757b8029ee4$var$__assign.apply(this, arguments);
};
var $e0580757b8029ee4$var$baseStyle = $e0580757b8029ee4$var$__assign({
    display: 'block'
}, (0, $4f674d869a656e9f$export$f5b8910cec6cf069).baseStyle.field);
var $e0580757b8029ee4$var$variants = {
    outline: function(props) {
        return (0, $4f674d869a656e9f$export$f5b8910cec6cf069).variants.outline(props).field;
    }
};
var $e0580757b8029ee4$var$sizes = {
    sm: $e0580757b8029ee4$var$__assign($e0580757b8029ee4$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).sm), {
        minHeight: '72px',
        padding: '2'
    }),
    md: $e0580757b8029ee4$var$__assign($e0580757b8029ee4$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).md), {
        padding: '3',
        minHeight: '92px'
    }),
    lg: $e0580757b8029ee4$var$__assign($e0580757b8029ee4$var$__assign({}, (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba).lg), {
        minHeight: '112px',
        padding: '4'
    })
};
var $e0580757b8029ee4$var$defaultProps = {
    size: 'md',
    variant: 'outline'
};
var $e0580757b8029ee4$export$379139ebc1c2b235 = {
    baseStyle: $e0580757b8029ee4$var$baseStyle,
    sizes: $e0580757b8029ee4$var$sizes,
    variants: $e0580757b8029ee4$var$variants,
    defaultProps: $e0580757b8029ee4$var$defaultProps
};


var $c875c37c9b280242$exports = {};

$parcel$export($c875c37c9b280242$exports, "Toast", function () { return $c875c37c9b280242$export$8d8dc7d5f743331b; });
var $c875c37c9b280242$export$8d8dc7d5f743331b = {};


var $e8643e21b212d690$exports = {};

$parcel$export($e8643e21b212d690$exports, "Tooltip", function () { return $e8643e21b212d690$export$28c660c63b792dea; });


var $e8643e21b212d690$var$baseStyle = function(props) {
    var theme = props.theme;
    var backgroundColor = (0, $f466d5c40b760069$export$549ff81930776885)('slate.800', 'slate.300')(props);
    return {
        px: '4',
        py: '3',
        backgroundColor: backgroundColor,
        '--popper-arrow-bg': (0, $dfe73229adf076fd$export$93c8e06b7014dc33)(theme, 'colors', backgroundColor),
        color: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.900')(props),
        borderRadius: 'base',
        textStyle: 'body2',
        fontWeight: 'medium',
        boxShadow: '2',
        maxW: '320px',
        zIndex: 'tooltip'
    };
};
var $e8643e21b212d690$export$28c660c63b792dea = {
    baseStyle: $e8643e21b212d690$var$baseStyle
};


var $9fd3f1848c929dee$exports = {};

$parcel$export($9fd3f1848c929dee$exports, "Well", function () { return $9fd3f1848c929dee$export$d89c679ee2f73242; });

var $9fd3f1848c929dee$var$baseStyle = function(props) {
    var theme = props.theme, hasBorder = props.hasBorder;
    return {
        _hover: {
            bg: (0, $f466d5c40b760069$export$549ff81930776885)('slate.30', 'slate.800')(props),
            borderColor: (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.3)(theme), 'slate.700')(props),
            boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)'
        },
        bg: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.800')(props),
        borderColor: hasBorder ? (0, $f466d5c40b760069$export$549ff81930776885)((0, $188d0d70c4460bfd$export$d11da87e55cc498f)('slate.900', 0.2)(theme), 'slate.700')(props) : 'transparent',
        borderRadius: 'base',
        borderWidth: 1,
        flexDirection: 'column'
    };
};
var $9fd3f1848c929dee$export$d89c679ee2f73242 = {
    baseStyle: $9fd3f1848c929dee$var$baseStyle
};


$parcel$exportWildcard($6437acd995b5bada$exports, $7d3dedf070cf3fda$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e045a5ccb85754e2$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $f4510e75fd105402$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $1d310453f0ac8eda$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $4f662729da9bf48d$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $73361a021f19e8e9$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $cb001d63a8d70545$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $8640ccd50c29e5c3$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $de700ff798138d47$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e9f1f95a1a81a2eb$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $0b89ec6456068494$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e07b5d3f1aaf5a47$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $595576f8c6a3bf69$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $ded906a98c3c049c$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $4f674d869a656e9f$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $299c6a6e8a648759$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $0372a0fa0a68a42f$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $5cd9641e3301c22a$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $806698958317d444$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $be1f4e4dc4b3f46a$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $5e8a60ec22cbbaef$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $df3c24a075dc36a6$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $13c5af53ded5e8c1$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $aa4e196612aeee14$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $dfbe2e0280826813$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $241917528edef79e$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $2f7d71d57c2a87b4$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $3b2d34acb4b97e61$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $3a1840abb9d01876$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $92d75bcc25e4dc07$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e2ef2d2445362189$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $30fe38d2785cdb3f$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $21e8717d4589e738$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $ceb0c1f432692480$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $aa9101b27f774df8$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e0580757b8029ee4$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $c875c37c9b280242$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $e8643e21b212d690$exports);
$parcel$exportWildcard($6437acd995b5bada$exports, $9fd3f1848c929dee$exports);




var $af223a647e4a6d90$export$aa0e86c7c0d2f400 = {
    global: function(props) {
        return {
            body: {
                position: 'static',
                fontFamily: 'body',
                color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.900', 'white')(props),
                backgroundColor: (0, $f466d5c40b760069$export$549ff81930776885)('white', 'slate.900')(props),
                transition: 'background-color 0.2s',
                textStyle: 'body1'
            },
            '*::placeholder': {
                color: (0, $f466d5c40b760069$export$549ff81930776885)('slate.400', 'white')(props)
            },
            '*, *::before, &::after': {
                borderColor: (0, $f466d5c40b760069$export$549ff81930776885)('slate.200', 'white')(props),
                wordWrap: 'break-word'
            },
            '.chakra-toast__inner > .klik-inline-notification': {
                width: {
                    base: '100%',
                    sm: '400px'
                },
                boxShadow: '2'
            },
            '.chakra-button__icon, .chakra-tab__icon': {
                alignItems: 'center',
                display: 'inline-flex',
                flexShrink: '0',
                justifyContent: 'center',
                position: 'relative'
            },
            '&[data-icon-fixed]': {
                fontSize: '0.75rem !important'
            },
            // custom scrollbar in modals
            '.chakra-modal__content &::-webkit-scrollbar': {
                width: '8px'
            },
            '.chakra-modal__content &::-webkit-scrollbar-track': {
                width: '8px',
                background: 'transparent'
            },
            '.chakra-modal__content &::-webkit-scrollbar-thumb': {
                backgroundColor: 'slate.200',
                borderRadius: '5px'
            },
            '.chakra-modal__content &::-webkit-scrollbar-thumb:hover': {
                backgroundColor: 'slate.500'
            }
        };
    }
};



var $812a5b751b26d61b$var$__assign = undefined && undefined.__assign || function() {
    $812a5b751b26d61b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $812a5b751b26d61b$var$__assign.apply(this, arguments);
};
var $812a5b751b26d61b$var$config = {
    // TODO: switch to true when darkmode is implemented
    useSystemColorMode: false,
    initialColorMode: 'light'
};
var $812a5b751b26d61b$var$direction = 'ltr';
var $812a5b751b26d61b$export$bca14c5b3b88a9c9 = $812a5b751b26d61b$var$__assign($812a5b751b26d61b$var$__assign({
    direction: $812a5b751b26d61b$var$direction,
    transition: {
        property: {},
        easing: {},
        duration: {}
    }
}, $9df8cb6ea2ddc5ef$exports), {
    components: $812a5b751b26d61b$var$__assign({}, $6437acd995b5bada$exports),
    styles: (0, $af223a647e4a6d90$export$aa0e86c7c0d2f400),
    textStyles: (0, $4db67093e450c1f9$export$6a54c24d15b0f6ba),
    config: $812a5b751b26d61b$var$config
});






var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

function $894d3e607cf19ab8$var$_extends() {
    $894d3e607cf19ab8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $894d3e607cf19ab8$var$_extends.apply(this, arguments);
}
var $894d3e607cf19ab8$export$7dd004358974b05d = (props)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $894d3e607cf19ab8$var$_extends({
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }));
var $894d3e607cf19ab8$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $894d3e607cf19ab8$var$_extends({
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }));
var $894d3e607cf19ab8$export$f7dc499a72baa103 = (props)=>/*#__PURE__*/ $denZA.createElement((0, $5a8ac46908ed925f$export$f04a61298a47a40f), $894d3e607cf19ab8$var$_extends({
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }));


function $730e73f1e242870a$var$_extends() {
    $730e73f1e242870a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $730e73f1e242870a$var$_extends.apply(this, arguments);
}
function $730e73f1e242870a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $730e73f1e242870a$var$STATUSES = {
    info: {
        icon: (0, $894d3e607cf19ab8$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $894d3e607cf19ab8$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $894d3e607cf19ab8$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $894d3e607cf19ab8$export$f7dc499a72baa103),
        colorScheme: "red"
    }
};
var [$730e73f1e242870a$var$AlertProvider, $730e73f1e242870a$var$useAlertContext] = (0, $030819e6d0340981$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    errorMessage: "useAlertContext: `context` is undefined. Seems you forgot to wrap alert components in `<Alert />`"
});
var $730e73f1e242870a$export$caec2af78bcc877f = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var _props$colorScheme;
    var _omitThemingProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), { status: status = "info" } = _omitThemingProps, rest = $730e73f1e242870a$var$_objectWithoutPropertiesLoose(_omitThemingProps, [
        "status"
    ]);
    var colorScheme = (_props$colorScheme = props.colorScheme) != null ? _props$colorScheme : $730e73f1e242870a$var$STATUSES[status].colorScheme;
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)("Alert", $730e73f1e242870a$var$_extends({}, props, {
        colorScheme: colorScheme
    }));
    var alertStyles = $730e73f1e242870a$var$_extends({
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden"
    }, styles.container);
    return /*#__PURE__*/ $denZA.createElement($730e73f1e242870a$var$AlertProvider, {
        value: {
            status: status
        }
    }, /*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$dc4c659861f00dbe), {
        value: styles
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $730e73f1e242870a$var$_extends({
        role: "alert",
        ref: ref
    }, rest, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-alert", props.className),
        __css: alertStyles
    }))));
});
var $730e73f1e242870a$export$4a7253439a300753 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $730e73f1e242870a$var$_extends({
        ref: ref
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    }));
});
var $730e73f1e242870a$export$d4feae172fccda11 = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    var descriptionStyles = $730e73f1e242870a$var$_extends({
        display: "inline"
    }, styles.description);
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $730e73f1e242870a$var$_extends({
        ref: ref
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    }));
});
var $730e73f1e242870a$export$4a143c8822a09fb4 = (props)=>{
    var { status: status } = $730e73f1e242870a$var$useAlertContext();
    var { icon: BaseIcon } = $730e73f1e242870a$var$STATUSES[status];
    var styles = (0, $77f2276a0a421ee3$export$28e6b9b82ee883c)();
    return /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $730e73f1e242870a$var$_extends({
        display: "inherit"
    }, props, {
        className: (0, $405775388fe7f58e$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: styles.icon
    }), /*#__PURE__*/ $denZA.createElement(BaseIcon, {
        w: "100%",
        h: "100%"
    }));
};







var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");




var $denZA = parcelRequire("denZA");

var $denZA = parcelRequire("denZA");

function $4665f2f892ba275e$export$d8e6abf214c9ec0f(callback, delay) {
    var fn = (0, $ab5b0545a722351d$export$25bec8c6f54ee79a)(callback);
    $denZA.useEffect(()=>{
        if (delay == null) return undefined;
        var timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}




var $denZA = parcelRequire("denZA");


var $denZA = parcelRequire("denZA");

function $e812e71d840d7593$var$_extends() {
    $e812e71d840d7593$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e812e71d840d7593$var$_extends.apply(this, arguments);
}
function $e812e71d840d7593$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * VisuallyHidden
 *
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the `aria-hidden` attribute.
 */ var $e812e71d840d7593$export$439d29a4e110a164 = /*#__PURE__*/ (0, $denZA.forwardRef)(function VisuallyHidden(_ref, ref) {
    var _ref$as = _ref.as, Comp = _ref$as === void 0 ? "span" : _ref$as, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, props = $e812e71d840d7593$var$_objectWithoutPropertiesLoose(_ref, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $denZA.createElement)(Comp, $e812e71d840d7593$var$_extends({
        ref: ref,
        style: $e812e71d840d7593$var$_extends({
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: "1px",
            // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
            whiteSpace: "nowrap",
            wordWrap: "normal"
        }, style)
    }, props));
});
var $e812e71d840d7593$export$2e2bcd8739ae039 = $e812e71d840d7593$export$439d29a4e110a164;



var $denZA = parcelRequire("denZA");
var $202165ede4d77460$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $202165ede4d77460$var$__DEV__ = false;
var $202165ede4d77460$var$warning = function() {};
if ($202165ede4d77460$var$__DEV__) {
    var $202165ede4d77460$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $202165ede4d77460$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $202165ede4d77460$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$202165ede4d77460$exports = $202165ede4d77460$var$warning;


/* eslint-disable no-restricted-globals, eqeqeq  */ /**
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * TODO: We are calling useLayoutEffect in a couple of places that will likely
 * cause some issues for SSR users, whether the warning shows or not. Audit and
 * fix these.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $30bb0dd822a25bb9$export$700979bc83e7db82 = /*#__PURE__*/ $30bb0dd822a25bb9$export$71594e8a50f746f4() ? (0, $denZA.useLayoutEffect) : (0, $denZA.useEffect);
var $30bb0dd822a25bb9$var$checkedPkgs = {};
/**
 * Copy of Facebook's warning package.
 *
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical paths.
 * Removing the logging code for production environments will keep the same
 * logic and follow the same code paths.
 *
 * @see https://github.com/BerkeleyTrue/warning/blob/master/warning.js
 */ var $30bb0dd822a25bb9$export$491112666e282270 = (0, (/*@__PURE__*/$parcel$interopDefault($202165ede4d77460$exports)));
/**
 * When in dev mode, checks that styles for a given @reach package are loaded.
 *
 * @param packageName Name of the package to check.
 * @example checkStyles("dialog") will check for styles for @reach/dialog
 */ var $30bb0dd822a25bb9$export$d63e6836ae4f5bf7 = $30bb0dd822a25bb9$export$8793edee2d425525;
var $30bb0dd822a25bb9$var$_ref, $30bb0dd822a25bb9$var$env;
/**
 * Ponyfill for the global object in some environments.
 *
 * @link https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $30bb0dd822a25bb9$export$916edb406b246d97 = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : /*#__PURE__*/ // eslint-disable-next-line no-new-func
Function("return this")();
/**
 * Passes or assigns an arbitrary value to a ref function or object.
 *
 * @param ref
 * @param value
 */ function $30bb0dd822a25bb9$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ($30bb0dd822a25bb9$export$f6e2535fb5126e54(ref)) ref(value);
    else try {
        ref.current = value;
    } catch (error) {
        throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
}
/**
 * Checks true|"true" vs false|"false"
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$c038473a27c16e32(value) {
    return value === "true" ? true : $30bb0dd822a25bb9$export$f9ce7b637dfbe238(value) ? value : false;
}
function $30bb0dd822a25bb9$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * Type-safe clone element
 *
 * @param element
 * @param props
 * @param children
 */ function $30bb0dd822a25bb9$export$7a79167773cd2033(element, props) {
    for(var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)children[_key - 2] = arguments[_key];
    return /*#__PURE__*/ (0, $denZA.isValidElement)(element) ? (0, $denZA.cloneElement).apply($denZA, [
        element,
        props
    ].concat(children)) : element;
}
function $30bb0dd822a25bb9$export$2938df5a49406bfa(name, defaultValue) {
    var Ctx = /*#__PURE__*/ (0, $denZA.createContext)(defaultValue);
    Ctx.displayName = name;
    return Ctx;
}
/**
 * This is a hack for sure. The thing is, getting a component to intelligently
 * infer props based on a component or JSX string passed into an `as` prop is
 * kind of a huge pain. Getting it to work and satisfy the constraints of
 * `forwardRef` seems dang near impossible. To avoid needing to do this awkward
 * type song-and-dance every time we want to forward a ref into a component
 * that accepts an `as` prop, we abstract all of that mess to this function for
 * the time time being.
 */ function $30bb0dd822a25bb9$export$e43f39796049410c(render) {
    return /*#__PURE__*/ (0, $denZA.forwardRef)(render);
}
function $30bb0dd822a25bb9$export$be9875366b8ab420(Component, propsAreEqual) {
    return /*#__PURE__*/ (0, $denZA.memo)(Component, propsAreEqual);
}
/**
 * Get the size of the working document minus the scrollbar offset.
 *
 * @param element
 */ function $30bb0dd822a25bb9$export$5b142dad5fbed97b(element) {
    var _ownerDocument$docume, _ownerDocument$docume2;
    var ownerDocument = $30bb0dd822a25bb9$export$b204af158042fbac(element);
    var ownerWindow = ownerDocument.defaultView || window;
    if (!ownerDocument) return {
        width: 0,
        height: 0
    };
    return {
        width: (_ownerDocument$docume = ownerDocument.documentElement.clientWidth) != null ? _ownerDocument$docume : ownerWindow.innerWidth,
        height: (_ownerDocument$docume2 = ownerDocument.documentElement.clientHeight) != null ? _ownerDocument$docume2 : ownerWindow.innerHeight
    };
}
/**
 * Get the scoll position of the global window object relative to a given node.
 *
 * @param element
 */ function $30bb0dd822a25bb9$export$3abe133d5501edeb(element) {
    var ownerDocument = $30bb0dd822a25bb9$export$b204af158042fbac(element);
    var ownerWindow = ownerDocument.defaultView || window;
    if (!ownerDocument) return {
        scrollX: 0,
        scrollY: 0
    };
    return {
        scrollX: ownerWindow.scrollX,
        scrollY: ownerWindow.scrollY
    };
}
/**
 * Get a computed style value by property.
 *
 * @param element
 * @param styleProp
 */ function $30bb0dd822a25bb9$export$b104a91700d03aff(element, styleProp) {
    var ownerDocument = $30bb0dd822a25bb9$export$b204af158042fbac(element);
    var ownerWindow = (ownerDocument == null ? void 0 : ownerDocument.defaultView) || window;
    if (ownerWindow) return ownerWindow.getComputedStyle(element, null).getPropertyValue(styleProp);
    return null;
}
/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */ function $30bb0dd822a25bb9$export$b204af158042fbac(element) {
    return $30bb0dd822a25bb9$export$71594e8a50f746f4() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */ function $30bb0dd822a25bb9$export$f21a1ffae260145a(element) {
    var ownerDocument = $30bb0dd822a25bb9$export$b204af158042fbac(element);
    return ownerDocument ? ownerDocument.defaultView || window : null;
}
/**
 * Get the scrollbar offset distance.
 *
 * TODO: Remove in 1.0 (we used this in public examples)
 */ function $30bb0dd822a25bb9$export$b870ddfc521070af() {
    try {
        if (window.innerWidth > document.documentElement.clientWidth) return window.innerWidth - document.documentElement.clientWidth;
    } catch (err) {}
    return 0;
}
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$f9ce7b637dfbe238(value) {
    return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$f6e2535fb5126e54(value) {
    return !!(value && ({}).toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$7e4aa119212bc614(value) {
    return typeof value === "number" && !isNaN(value);
}
/**
 * Detects right clicks
 *
 * @param nativeEvent
 */ function $30bb0dd822a25bb9$export$189689d1febf0166(nativeEvent) {
    return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
/**
 * Joins strings to format IDs for compound components.
 *
 * @param args
 */ function $30bb0dd822a25bb9$export$e641f6957555d732() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args.filter(function(val) {
        return val != null;
    }).join("--");
}
/**
 * No-op function.
 */ function $30bb0dd822a25bb9$export$8793edee2d425525() {}
/**
 * Convert our state strings for HTML data attributes.
 * No need for a fancy kebab-caser here, we know what our state strings are!
 *
 * @param state
 */ function $30bb0dd822a25bb9$export$258e8922501a0125(state) {
    return String(state).replace(/([\s_]+)/g, "-").toLowerCase();
}
/**
 * Check if a component is controlled or uncontrolled and return the correct
 * state value and setter accordingly. If the component state is controlled by
 * the app, the setter is a noop.
 *
 * @param controlledValue
 * @param defaultValue
 */ function $30bb0dd822a25bb9$export$40bfa8c7b0832715(controlledValue, defaultValue) {
    var controlledRef = (0, $denZA.useRef)(controlledValue != null);
    var _React$useState = (0, $denZA.useState)(defaultValue), valueState = _React$useState[0], setValue = _React$useState[1];
    var set = (0, $denZA.useCallback)(function(n) {
        if (!controlledRef.current) setValue(n);
    }, []);
    return [
        controlledRef.current ? controlledValue : valueState,
        set
    ];
}
/**
 * Logs a warning in dev mode when a component switches from controlled to
 * uncontrolled, or vice versa
 *
 * A single prop should typically be used to determine whether or not a
 * component is controlled or not.
 *
 * @param controlledValue
 * @param controlledPropName
 * @param componentName
 */ var $30bb0dd822a25bb9$export$c4642065381552e6 = $30bb0dd822a25bb9$export$8793edee2d425525;
var $30bb0dd822a25bb9$export$c21e4ec122662830 = $30bb0dd822a25bb9$export$8793edee2d425525;
/**
 * React hook for creating a value exactly once.
 * @see https://github.com/Andarist/use-constant
 */ function $30bb0dd822a25bb9$export$fe4300aa8eebea86(fn) {
    var ref = (0, $denZA.useRef)();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}
/**
 * @param callback
 */ function $30bb0dd822a25bb9$export$ee5b5d04074a389e(callback) {
    var ref = (0, $denZA.useRef)(callback);
    $30bb0dd822a25bb9$export$700979bc83e7db82(function() {
        ref.current = callback;
    });
    return (0, $denZA.useCallback)(function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return ref.current.apply(ref, [
            event
        ].concat(args));
    }, []);
}
function $30bb0dd822a25bb9$export$fd27aa36f007ec3d(fn) {
    var ref = (0, $denZA.useRef)({
        __internalSet: true
    });
    if (ref.current && ref.current.__internalSet === true) ref.current = fn();
    return ref;
}
/**
 * TODO: Remove in 1.0
 * @alias useStableCallback
 * @param callback
 */ var $30bb0dd822a25bb9$export$55bcb3c9dbcc3177 = $30bb0dd822a25bb9$export$1a8b1350915fe2e0;
/**
 * Adds a DOM event listener
 *
 * @param eventName
 * @param listener
 * @param element
 */ function $30bb0dd822a25bb9$export$7080b3e976bc91ab(eventName, listener, element) {
    if (element === void 0) element = window;
    var savedHandler = (0, $denZA.useRef)(listener);
    (0, $denZA.useEffect)(function() {
        savedHandler.current = listener;
    }, [
        listener
    ]);
    (0, $denZA.useEffect)(function() {
        var isSupported = element && element.addEventListener;
        if (!isSupported) return;
        function eventListener(event) {
            savedHandler.current(event);
        }
        element.addEventListener(eventName, eventListener);
        return function() {
            element.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
}
/**
 * Detect when focus changes in our document.
 *
 * @param handleChange
 * @param when
 * @param ownerDocument
 */ function $30bb0dd822a25bb9$export$73c610300f97b0af(handleChange, when, ownerDocument) {
    if (handleChange === void 0) handleChange = console.log;
    if (when === void 0) when = "focus";
    if (ownerDocument === void 0) ownerDocument = document;
    var lastActiveElement = (0, $denZA.useRef)(ownerDocument.activeElement);
    (0, $denZA.useEffect)(function() {
        lastActiveElement.current = ownerDocument.activeElement;
        function onChange(event) {
            if (lastActiveElement.current !== ownerDocument.activeElement) {
                handleChange(ownerDocument.activeElement, lastActiveElement.current, event);
                lastActiveElement.current = ownerDocument.activeElement;
            }
        }
        ownerDocument.addEventListener(when, onChange, true);
        return function() {
            ownerDocument.removeEventListener(when, onChange);
        };
    }, [
        when,
        handleChange,
        ownerDocument
    ]);
}
/**
 * Forces a re-render, similar to `forceUpdate` in class components.
 */ function $30bb0dd822a25bb9$export$91db9bc4f8ac944a() {
    var _React$useState2 = (0, $denZA.useState)(Object.create(null)), dispatch = _React$useState2[1];
    return (0, $denZA.useCallback)(function() {
        dispatch(Object.create(null));
    }, []);
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */ function $30bb0dd822a25bb9$export$d6cc46cab1d35d36() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return (0, $denZA.useMemo)(function() {
        if (refs.every(function(ref) {
            return ref == null;
        })) return null;
        return function(node) {
            refs.forEach(function(ref) {
                $30bb0dd822a25bb9$export$d734136a7b018efe(ref, node);
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [].concat(refs));
}
/**
 * Returns the previous value of a reference after a component update.
 *
 * @param value
 */ function $30bb0dd822a25bb9$export$5cae361ad82dce8b(value) {
    var ref = (0, $denZA.useRef)(null);
    (0, $denZA.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop and exposed as a stable function to avoid executing effects when
 * passed as a dependency.
 */ function $30bb0dd822a25bb9$export$1a8b1350915fe2e0(callback) {
    var callbackRef = (0, $denZA.useRef)(callback);
    (0, $denZA.useEffect)(function() {
        callbackRef.current = callback;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $denZA.useCallback)(function() {
        callbackRef.current && callbackRef.current.apply(callbackRef, arguments);
    }, []);
}
/**
 * Call an effect after a component update, skipping the initial mount.
 *
 * @param effect Effect to call
 * @param deps Effect dependency list
 */ function $30bb0dd822a25bb9$export$496315a1608d9602(effect, deps) {
    var mounted = (0, $denZA.useRef)(false);
    (0, $denZA.useEffect)(function() {
        if (mounted.current) effect();
        else mounted.current = true;
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/**
 * Just a lil state logger
 *
 * @param state
 * @param DEBUG
 */ var $30bb0dd822a25bb9$export$484a9276d59fed80 = $30bb0dd822a25bb9$export$8793edee2d425525;
/**
 * Wraps a lib-defined event handler and a user-defined event handler, returning
 * a single handler that allows a user to prevent lib-defined handlers from
 * firing.
 *
 * @param theirHandler User-supplied event handler
 * @param ourHandler Library-supplied event handler
 */ function $30bb0dd822a25bb9$export$1ee4ad9b50d5b82(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) return ourHandler(event);
    };
} // Export types



function $0cadea869faac262$var$_extends() {
    $0cadea869faac262$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0cadea869faac262$var$_extends.apply(this, arguments);
}
function $0cadea869faac262$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/*
 * Singleton state is fine because you don't server render
 * an alert (SRs don't read them on first load anyway)
 */ var $0cadea869faac262$var$keys = {
    polite: -1,
    assertive: -1
};
var $0cadea869faac262$var$elements = {
    polite: {},
    assertive: {}
};
var $0cadea869faac262$var$liveRegions = {
    polite: null,
    assertive: null
};
var $0cadea869faac262$var$renderTimer; ////////////////////////////////////////////////////////////////////////////////
/**
 * Alert
 *
 * Screen-reader-friendly alert messages. In many apps developers add "alert"
 * messages when network events or other things happen. Users with assistive
 * technologies may not know about the message unless you develop for it.
 *
 * @see Docs https://reach.tech/alert
 */ var $0cadea869faac262$export$caec2af78bcc877f = /*#__PURE__*/ (0, $30bb0dd822a25bb9$export$e43f39796049410c)(function Alert(_ref, forwardedRef) {
    var _ref$as = _ref.as, Comp = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, _ref$type = _ref.type, regionType = _ref$type === void 0 ? "polite" : _ref$type, props = $0cadea869faac262$var$_objectWithoutPropertiesLoose(_ref, [
        "as",
        "children",
        "type"
    ]);
    var ownRef = (0, $denZA.useRef)(null);
    var ref = (0, $30bb0dd822a25bb9$export$d6cc46cab1d35d36)(forwardedRef, ownRef);
    var child = (0, $denZA.useMemo)(function() {
        return /*#__PURE__*/ (0, $denZA.createElement)(Comp, $0cadea869faac262$var$_extends({}, props, {
            ref: ref,
            "data-reach-alert": true
        }), children);
    }, [
        children,
        props
    ]);
    $0cadea869faac262$var$useMirrorEffects(regionType, child, ownRef);
    return child;
});
function $0cadea869faac262$var$createMirror(type, doc) {
    var key = ++$0cadea869faac262$var$keys[type];
    var mount = function mount(element) {
        if ($0cadea869faac262$var$liveRegions[type]) {
            $0cadea869faac262$var$elements[type][key] = element;
            $0cadea869faac262$var$renderAlerts();
        } else {
            var node = doc.createElement("div");
            node.setAttribute("data-reach-live-" + type, "true");
            $0cadea869faac262$var$liveRegions[type] = node;
            doc.body.appendChild($0cadea869faac262$var$liveRegions[type]);
            mount(element);
        }
    };
    var update = function update(element) {
        $0cadea869faac262$var$elements[type][key] = element;
        $0cadea869faac262$var$renderAlerts();
    };
    var unmount = function unmount() {
        delete $0cadea869faac262$var$elements[type][key];
        $0cadea869faac262$var$renderAlerts();
    };
    return {
        mount: mount,
        update: update,
        unmount: unmount
    };
}
function $0cadea869faac262$var$renderAlerts() {
    if ($0cadea869faac262$var$renderTimer != null) window.clearTimeout($0cadea869faac262$var$renderTimer);
    $0cadea869faac262$var$renderTimer = window.setTimeout(function() {
        Object.keys($0cadea869faac262$var$elements).forEach(function(elementType) {
            var regionType = elementType;
            var container = $0cadea869faac262$var$liveRegions[regionType];
            if (container) (0, $d486a8928008256a$exports.render)(/*#__PURE__*/ (0, $denZA.createElement)((0, $e812e71d840d7593$export$439d29a4e110a164), {
                as: "div"
            }, /*#__PURE__*/ (0, $denZA.createElement)("div", {
                // The status role is a type of live region and a container whose
                // content is advisory information for the user that is not
                // important enough to justify an alert, and is often presented as
                // a status bar. When the role is added to an element, the browser
                // will send out an accessible status event to assistive
                // technology products which can then notify the user about it.
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_status_role
                role: regionType === "assertive" ? "alert" : "status",
                "aria-live": regionType
            }, Object.keys($0cadea869faac262$var$elements[regionType]).map(function(key) {
                return /*#__PURE__*/ (0, $denZA.cloneElement)($0cadea869faac262$var$elements[regionType][key], {
                    key: key,
                    ref: null
                });
            }))), $0cadea869faac262$var$liveRegions[regionType]);
        });
    }, 500);
}
function $0cadea869faac262$var$useMirrorEffects(regionType, element, ref) {
    var prevType = (0, $30bb0dd822a25bb9$export$5cae361ad82dce8b)(regionType);
    var mirror = (0, $denZA.useRef)(null);
    var mounted = (0, $denZA.useRef)(false);
    (0, $denZA.useEffect)(function() {
        var ownerDocument = (0, $30bb0dd822a25bb9$export$b204af158042fbac)(ref.current);
        if (!mounted.current) {
            mounted.current = true;
            mirror.current = $0cadea869faac262$var$createMirror(regionType, ownerDocument);
            mirror.current.mount(element);
        } else if (prevType !== regionType) {
            mirror.current && mirror.current.unmount();
            mirror.current = $0cadea869faac262$var$createMirror(regionType, ownerDocument);
            mirror.current.mount(element);
        } else mirror.current && mirror.current.update(element);
    }, [
        element,
        regionType,
        prevType,
        ref
    ]);
    (0, $denZA.useEffect)(function() {
        return function() {
            mirror.current && mirror.current.unmount();
        };
    }, []);
} ////////////////////////////////////////////////////////////////////////////////
var $0cadea869faac262$export$2e2bcd8739ae039 = $0cadea869faac262$export$caec2af78bcc877f;




var $denZA = parcelRequire("denZA");
/**
 * Given an array of toasts for a specific position.
 * It returns the toast that matches the `id` passed
 */ var $70c4e4624c76d251$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $70c4e4624c76d251$export$67080b9d5f0a62ea(toasts, id) {
    var position = $70c4e4624c76d251$export$500f52ac46324ec6(toasts, id);
    var index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
var $70c4e4624c76d251$export$500f52ac46324ec6 = (toasts, id)=>{
    var _Object$values$flat$f;
    return (_Object$values$flat$f = Object.values(toasts).flat().find((toast)=>toast.id === id)) == null ? void 0 : _Object$values$flat$f.position;
};
var $70c4e4624c76d251$export$795910f5f15a9633 = (toasts, id)=>!!$70c4e4624c76d251$export$500f52ac46324ec6(toasts, id);
function $70c4e4624c76d251$export$27777812cc6d52de(position) {
    var isRighty = position.includes("right");
    var isLefty = position.includes("left");
    var alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}


/**
 * @todo After Gerrit refactors this implementation,
 * allow users to change the toast transition direction from
 * a `ToastProvider` component.
 *
 * Here's an API example:
 *
 * ```jsx
 * <ToastProvider
 *   motion={customVariants}
 *   component={CustomToastComponent}
 *   autoCloseTimeout={3000}
 *   toastSpacing={32} // this will control the `margin` value applied
 * >
 * </ToastProvider>
 * ```
 */ var $0a751cc383ecbbd6$var$toastMotionVariants = {
    initial: (props)=>{
        var { position: position } = props;
        var dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        var factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $0a751cc383ecbbd6$export$8d8dc7d5f743331b = (props)=>{
    var { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5000 } = props;
    var [delay, setDelay] = $denZA.useState(duration);
    var isPresent = (0, $fa7d48d3f8d00960$export$8249053f690ea39a)();
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $0f6504d34c391be4$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    var onMouseEnter = ()=>setDelay(null);
    var onMouseLeave = ()=>setDelay(duration);
    var close = ()=>{
        if (isPresent) onRequestRemove();
    };
    $denZA.useEffect(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $4665f2f892ba275e$export$d8e6abf214c9ec0f)(close, delay);
    var style = $denZA.useMemo(()=>(0, $70c4e4624c76d251$export$27777812cc6d52de)(position), [
        position
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $92af15db400e8627$export$e25e478948902b8b).li, {
        layout: true,
        className: "chakra-toast",
        variants: $0a751cc383ecbbd6$var$toastMotionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: style
    }, /*#__PURE__*/ $denZA.createElement((0, $0cadea869faac262$export$2e2bcd8739ae039), {
        className: "chakra-toast__inner",
        style: {
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: "0.5rem"
        }
    }, (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(message) ? message({
        id: id,
        onClose: close
    }) : message));
};
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $0a751cc383ecbbd6$export$8d8dc7d5f743331b.displayName = "Toast";



function $2214589f001e4a0f$var$_extends() {
    $2214589f001e4a0f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2214589f001e4a0f$var$_extends.apply(this, arguments);
}
function $2214589f001e4a0f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $2214589f001e4a0f$export$51d32fc2dfa9b88b extends $denZA.Component {
    /**
   * Static id counter to create unique ids
   * for each toast
   */ /**
   * State to track all the toast across all positions
   */ constructor(props){
        var _this;
        super(props);
        _this = this;
        $2214589f001e4a0f$var$_defineProperty(this, "state", {
            top: [],
            "top-left": [],
            "top-right": [],
            "bottom-left": [],
            bottom: [],
            "bottom-right": []
        });
        $2214589f001e4a0f$var$_defineProperty(this, "notify", (message, options)=>{
            var toast = this.createToast(message, options);
            var { position: position, id: id } = toast;
            this.setState((prevToasts)=>{
                var isTop = position.includes("top");
                /**
         * - If the toast is positioned at the top edges, the
         * recent toast stacks on top of the other toasts.
         *
         * - If the toast is positioned at the bottom edges, the recent
         * toast stacks below the other toasts.
         */ var toasts = isTop ? [
                    toast,
                    ...prevToasts[position]
                ] : [
                    ...prevToasts[position],
                    toast
                ];
                return $2214589f001e4a0f$var$_extends({}, prevToasts, {
                    [position]: toasts
                });
            });
            return id;
        });
        $2214589f001e4a0f$var$_defineProperty(this, "updateToast", (id, options)=>{
            this.setState((prevState)=>{
                var nextState = $2214589f001e4a0f$var$_extends({}, prevState);
                var { position: position, index: index } = (0, $70c4e4624c76d251$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = $2214589f001e4a0f$var$_extends({}, nextState[position][index], options);
                return nextState;
            });
        });
        $2214589f001e4a0f$var$_defineProperty(this, "closeAll", function(_temp) {
            var { positions: positions } = _temp === void 0 ? {} : _temp;
            // only one setState here for perf reasons
            // instead of spamming this.closeToast
            _this.setState((prev)=>{
                var allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                var positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>$2214589f001e4a0f$var$_extends({}, toast, {
                            requestClose: true
                        }));
                    return acc;
                }, {});
            });
        });
        $2214589f001e4a0f$var$_defineProperty(this, "createToast", (message, options)=>{
            var _options$id, _options$position;
            $2214589f001e4a0f$export$51d32fc2dfa9b88b.counter += 1;
            var id = (_options$id = options.id) != null ? _options$id : $2214589f001e4a0f$export$51d32fc2dfa9b88b.counter;
            var position = (_options$position = options.position) != null ? _options$position : "top";
            return {
                id: id,
                message: message,
                position: position,
                duration: options.duration,
                onCloseComplete: options.onCloseComplete,
                onRequestRemove: ()=>this.removeToast(String(id), position),
                status: options.status,
                requestClose: false
            };
        });
        $2214589f001e4a0f$var$_defineProperty(this, "closeToast", (id)=>{
            this.setState((prevState)=>{
                var position = (0, $70c4e4624c76d251$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return $2214589f001e4a0f$var$_extends({}, prevState, {
                    [position]: prevState[position].map((toast)=>{
                        // id may be string or number
                        // eslint-disable-next-line eqeqeq
                        if (toast.id == id) return $2214589f001e4a0f$var$_extends({}, toast, {
                            requestClose: true
                        });
                        return toast;
                    })
                });
            });
        });
        $2214589f001e4a0f$var$_defineProperty(this, "removeToast", (id, position)=>{
            this.setState((prevState)=>$2214589f001e4a0f$var$_extends({}, prevState, {
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        });
        $2214589f001e4a0f$var$_defineProperty(this, "isVisible", (id)=>{
            var { position: position } = (0, $70c4e4624c76d251$export$67080b9d5f0a62ea)(this.state, id);
            return Boolean(position);
        });
        $2214589f001e4a0f$var$_defineProperty(this, "getStyle", (position)=>{
            var isTopOrBottom = position === "top" || position === "bottom";
            var margin = isTopOrBottom ? "0 auto" : undefined;
            var top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : undefined;
            var bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : undefined;
            var right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : undefined;
            var left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : undefined;
            return {
                position: "fixed",
                zIndex: 5500,
                pointerEvents: "none",
                display: "flex",
                flexDirection: "column",
                margin: margin,
                top: top,
                bottom: bottom,
                right: right,
                left: left
            };
        });
        var methods = {
            notify: this.notify,
            closeAll: this.closeAll,
            close: this.closeToast,
            update: this.updateToast,
            isActive: this.isVisible
        };
        props.notify(methods);
    }
    /**
   * Function to actually create a toast and add it
   * to state at the specified position
   */ render() {
        return (0, $dfe73229adf076fd$export$259b4dd69e654a7a)(this.state).map((position)=>{
            var toasts = this.state[position];
            return /*#__PURE__*/ $denZA.createElement("ul", {
                key: position,
                id: "chakra-toast-manager-" + position,
                style: this.getStyle(position)
            }, /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), {
                initial: false
            }, toasts.map((toast)=>/*#__PURE__*/ $denZA.createElement((0, $0a751cc383ecbbd6$export$8d8dc7d5f743331b), $2214589f001e4a0f$var$_extends({
                    key: toast.id
                }, toast)))));
        });
    }
}
$2214589f001e4a0f$var$_defineProperty($2214589f001e4a0f$export$51d32fc2dfa9b88b, "counter", 0);


function $a6b6a2a26c89f5cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a6b6a2a26c89f5cc$var$portalId = "chakra-toast-portal";
class $a6b6a2a26c89f5cc$var$Toaster {
    /**
   * Initialize the manager and mount it in the DOM
   * inside the portal node.
   *
   * @todo
   *
   * Update toast constructor to use `PortalManager`'s node or document.body.
   * Once done, we can remove the `zIndex` in `toast.manager.tsx`
   */ constructor(){
        var _this = this;
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "createToast", void 0);
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "removeAll", void 0);
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "closeToast", void 0);
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "updateToast", void 0);
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "isToastActive", void 0);
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "bindFunctions", (methods)=>{
            this.createToast = methods.notify;
            this.removeAll = methods.closeAll;
            this.closeToast = methods.close;
            this.updateToast = methods.update;
            this.isToastActive = methods.isActive;
        });
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "notify", function(message, options) {
            if (options === void 0) options = {};
            return _this.createToast == null ? void 0 : _this.createToast(message, options);
        });
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "close", (id)=>{
            var _this$closeToast;
            (_this$closeToast = this.closeToast) == null || _this$closeToast.call(this, id);
        });
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "closeAll", (options)=>{
            var _this$removeAll;
            (_this$removeAll = this.removeAll) == null || _this$removeAll.call(this, options);
        });
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "update", function(id, options) {
            if (options === void 0) options = {};
            _this.updateToast == null || _this.updateToast(id, options);
        });
        $a6b6a2a26c89f5cc$var$_defineProperty(this, "isActive", (id)=>{
            var _this$isToastActive;
            return (_this$isToastActive = this.isToastActive) == null ? void 0 : _this$isToastActive.call(this, id);
        });
        if (!(0, $405775388fe7f58e$export$4e09c449d6c407f7)) return;
        var portal;
        var existingPortal = document.getElementById($a6b6a2a26c89f5cc$var$portalId);
        if (existingPortal) portal = existingPortal;
        else {
            var _document$body;
            var div = document.createElement("div");
            div.id = $a6b6a2a26c89f5cc$var$portalId;
            (_document$body = document.body) == null || _document$body.appendChild(div);
            portal = div;
        }
        (0, $d486a8928008256a$exports.render)(/*#__PURE__*/ $denZA.createElement((0, $2214589f001e4a0f$export$51d32fc2dfa9b88b), {
            notify: this.bindFunctions
        }), portal);
    }
}
var $a6b6a2a26c89f5cc$export$b410431fab84fa58 = new $a6b6a2a26c89f5cc$var$Toaster();


function $5f051422d34ba329$var$_extends() {
    $5f051422d34ba329$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f051422d34ba329$var$_extends.apply(this, arguments);
}
var $5f051422d34ba329$var$Toast = (props)=>{
    var { status: status, variant: variant, id: id, title: title, isClosable: isClosable, onClose: onClose, description: description } = props;
    return /*#__PURE__*/ $denZA.createElement((0, $730e73f1e242870a$export$caec2af78bcc877f), {
        status: status,
        variant: variant,
        id: id,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto"
    }, /*#__PURE__*/ $denZA.createElement((0, $730e73f1e242870a$export$4a143c8822a09fb4), null), /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        flex: "1",
        maxWidth: "100%"
    }, title && /*#__PURE__*/ $denZA.createElement((0, $730e73f1e242870a$export$4a7253439a300753), null, title), description && /*#__PURE__*/ $denZA.createElement((0, $730e73f1e242870a$export$d4feae172fccda11), {
        display: "block"
    }, description)), isClosable && /*#__PURE__*/ $denZA.createElement((0, $16e5382b11479a26$export$de65de8213222d10), {
        size: "sm",
        onClick: onClose,
        position: "absolute",
        insetEnd: 1,
        top: 1
    }));
};
var $5f051422d34ba329$var$defaults = {
    duration: 5000,
    position: "bottom",
    variant: "solid"
};
var $5f051422d34ba329$export$2a82f214473ee92c = {
    theme: (0, $373c960dc38c4436$export$2e2bcd8739ae039),
    colorMode: "light",
    toggleColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525),
    setColorMode: (0, $da6e679e22b3b02c$export$8793edee2d425525),
    defaultOptions: $5f051422d34ba329$var$defaults
};
function $5f051422d34ba329$export$dc33ae34f96acd38(_temp) {
    var { theme: theme = $5f051422d34ba329$export$2a82f214473ee92c.theme, colorMode: colorMode = $5f051422d34ba329$export$2a82f214473ee92c.colorMode, toggleColorMode: toggleColorMode = $5f051422d34ba329$export$2a82f214473ee92c.toggleColorMode, setColorMode: setColorMode = $5f051422d34ba329$export$2a82f214473ee92c.setColorMode, defaultOptions: defaultOptions = $5f051422d34ba329$export$2a82f214473ee92c.defaultOptions } = _temp === void 0 ? $5f051422d34ba329$export$2a82f214473ee92c : _temp;
    var renderWithProviders = (props, options)=>/*#__PURE__*/ $denZA.createElement((0, $77f2276a0a421ee3$export$d8964aec282183a3), {
            theme: theme
        }, /*#__PURE__*/ $denZA.createElement((0, $cb7c335cf150f8d2$export$49ddd74a6729fdb0).Provider, {
            value: {
                colorMode: colorMode,
                setColorMode: setColorMode,
                toggleColorMode: toggleColorMode
            }
        }, (0, $6b74ef5ae6a56e47$export$f6e2535fb5126e54)(options.render) ? options.render(props) : /*#__PURE__*/ $denZA.createElement($5f051422d34ba329$var$Toast, $5f051422d34ba329$var$_extends({}, props, options))));
    var toastImpl = (options)=>{
        var opts = $5f051422d34ba329$var$_extends({}, defaultOptions, options);
        var Message = (props)=>renderWithProviders(props, opts);
        return (0, $a6b6a2a26c89f5cc$export$b410431fab84fa58).notify(Message, opts);
    };
    toastImpl.close = (0, $a6b6a2a26c89f5cc$export$b410431fab84fa58).close;
    toastImpl.closeAll = (0, $a6b6a2a26c89f5cc$export$b410431fab84fa58).closeAll; // toasts can only be updated if they have a valid id
    toastImpl.update = (id, options)=>{
        if (!id) return;
        var opts = $5f051422d34ba329$var$_extends({}, defaultOptions, options);
        (0, $a6b6a2a26c89f5cc$export$b410431fab84fa58).update(id, $5f051422d34ba329$var$_extends({}, opts, {
            message: (props)=>renderWithProviders(props, opts)
        }));
    };
    toastImpl.isActive = (0, $a6b6a2a26c89f5cc$export$b410431fab84fa58).isActive;
    return toastImpl;
}
function $5f051422d34ba329$export$a407b657d3044108(options) {
    var { theme: theme, setColorMode: setColorMode, toggleColorMode: toggleColorMode, colorMode: colorMode } = (0, $de2d1b30ad83f058$export$a513a93efd9ab8a7)();
    return $denZA.useMemo(()=>$5f051422d34ba329$export$dc33ae34f96acd38({
            theme: theme,
            colorMode: colorMode,
            setColorMode: setColorMode,
            toggleColorMode: toggleColorMode,
            defaultOptions: options
        }), [
        theme,
        setColorMode,
        toggleColorMode,
        colorMode,
        options
    ]);
}
var $5f051422d34ba329$export$2e2bcd8739ae039 = $5f051422d34ba329$export$a407b657d3044108;


var $47a7bf97b0a97950$export$a407b657d3044108 = (0, $5f051422d34ba329$export$a407b657d3044108);








var $denZA = parcelRequire("denZA");
var $b8604d9871872104$var$__assign = undefined && undefined.__assign || function() {
    $b8604d9871872104$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8604d9871872104$var$__assign.apply(this, arguments);
};
var $b8604d9871872104$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b8604d9871872104$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b8604d9871872104$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b8604d9871872104$export$40258cc1d95ff477 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var children = _a.children, _b = _a.spacing, spacing = _b === void 0 ? '2px' : _b, _c = _a.isAttached, isAttached = _c === void 0 ? true : _c, _d = _a.defaultActiveButtons, defaultActiveButtons = _d === void 0 ? [] : _d, _e = _a.multiple, multiple = _e === void 0 ? true : _e, _f = _a.isRound, isRound = _f === void 0 ? false : _f, onChangeProp = _a.onChange, rest = $b8604d9871872104$var$__rest(_a, [
        "children",
        "spacing",
        "isAttached",
        "defaultActiveButtons",
        "multiple",
        "isRound",
        "onChange"
    ]);
    // TODO: useControllableState // useControllableProp ?
    var _g = $b8604d9871872104$var$__read($denZA.useState(defaultActiveButtons), 2), activeButtons = _g[0], setActiveButtons = _g[1];
    var toggleButton = $denZA.useCallback(function(e, index) {
        var isActive = activeButtons.includes(index);
        var newActiveButtons;
        if (isActive) newActiveButtons = activeButtons.filter(function(i) {
            return i !== index;
        });
        else newActiveButtons = multiple ? $b8604d9871872104$var$__spreadArray($b8604d9871872104$var$__spreadArray([], $b8604d9871872104$var$__read(activeButtons), false), [
            index
        ], false) : [
            index
        ];
        onChangeProp === null || onChangeProp === void 0 || onChangeProp(newActiveButtons);
        setActiveButtons(newActiveButtons);
    }, [
        activeButtons,
        multiple
    ]);
    var validChildren = (0, $75c83302e8267e56$export$b2c43d7d050b2e63)(children);
    return(// Getting error: Expression produces a union type that is too complex to represent
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    $denZA.createElement((0, $de3d8b63c73a46a5$export$69b1032f2ecdf404), $b8604d9871872104$var$__assign({
        isAttached: isAttached,
        isRound: isRound,
        ref: ref,
        spacing: spacing
    }, rest), validChildren.map(function(child, index) {
        return $denZA.cloneElement(child, $b8604d9871872104$var$__assign($b8604d9871872104$var$__assign($b8604d9871872104$var$__assign({}, rest), child.props), {
            index: index,
            onClick: function(e) {
                return void toggleButton(e, index);
            },
            variant: activeButtons.includes(index) ? 'attached-active' : 'attached'
        }));
    })));
});












var $denZA = parcelRequire("denZA");
var $44bc614af98e6baa$export$dcdf75081b88279d = {
    exit: {
        scale: 0.85,
        opacity: 0,
        transition: {
            opacity: {
                duration: 0.15,
                easings: "easeInOut"
            },
            scale: {
                duration: 0.2,
                easings: "easeInOut"
            }
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            opacity: {
                easings: "easeOut",
                duration: 0.2
            },
            scale: {
                duration: 0.2,
                ease: [
                    0.175,
                    0.885,
                    0.4,
                    1.1
                ]
            }
        }
    }
};







var $denZA = parcelRequire("denZA");
function $0bf6a9dfb0f76931$var$_extends() {
    $0bf6a9dfb0f76931$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bf6a9dfb0f76931$var$_extends.apply(this, arguments);
}
function $0bf6a9dfb0f76931$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0bf6a9dfb0f76931$export$1c4b08e0eca38426(props) {
    if (props === void 0) props = {};
    var { openDelay: openDelay = 0, closeDelay: closeDelay = 0, closeOnClick: closeOnClick = true, closeOnMouseDown: closeOnMouseDown, onOpen: onOpenProp, onClose: onCloseProp, placement: placement, id: id, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, arrowSize: arrowSize = 10, arrowShadowColor: arrowShadowColor, arrowPadding: arrowPadding, modifiers: modifiers, isDisabled: isDisabled, gutter: gutter, offset: offset } = props, htmlProps = $0bf6a9dfb0f76931$var$_objectWithoutPropertiesLoose(props, [
        "openDelay",
        "closeDelay",
        "closeOnClick",
        "closeOnMouseDown",
        "onOpen",
        "onClose",
        "placement",
        "id",
        "isOpen",
        "defaultIsOpen",
        "arrowSize",
        "arrowShadowColor",
        "arrowPadding",
        "modifiers",
        "isDisabled",
        "gutter",
        "offset"
    ]);
    var { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $528efd7f0c9e3374$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onOpen: onOpenProp,
        onClose: onCloseProp
    });
    var { referenceRef: referenceRef, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, getArrowProps: getArrowProps } = (0, $e0cfb75a998fb7e2$export$f4d5bf230a36dd6e)({
        enabled: isOpen,
        placement: placement,
        arrowPadding: arrowPadding,
        modifiers: modifiers,
        gutter: gutter,
        offset: offset
    });
    var tooltipId = (0, $63207b263e1aef60$export$f680877a34711e37)(id, "tooltip");
    var ref = $denZA.useRef(null);
    var enterTimeout = $denZA.useRef();
    var exitTimeout = $denZA.useRef();
    var openWithDelay = $denZA.useCallback(()=>{
        if (!isDisabled) enterTimeout.current = window.setTimeout(onOpen, openDelay);
    }, [
        isDisabled,
        onOpen,
        openDelay
    ]);
    var closeWithDelay = $denZA.useCallback(()=>{
        if (enterTimeout.current) clearTimeout(enterTimeout.current);
        exitTimeout.current = window.setTimeout(onClose, closeDelay);
    }, [
        closeDelay,
        onClose
    ]);
    var onClick = $denZA.useCallback(()=>{
        if (closeOnClick) closeWithDelay();
    }, [
        closeOnClick,
        closeWithDelay
    ]);
    var onMouseDown = $denZA.useCallback(()=>{
        if (closeOnMouseDown) closeWithDelay();
    }, [
        closeOnMouseDown,
        closeWithDelay
    ]);
    var onKeyDown = (event)=>{
        if (isOpen && event.key === "Escape") closeWithDelay();
    };
    (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)("keydown", onKeyDown);
    $denZA.useEffect(()=>()=>{
            clearTimeout(enterTimeout.current);
            clearTimeout(exitTimeout.current);
        }, []);
    /**
   * This allows for catching mouseleave events when the tooltip
   * trigger is disabled. There's currently a known issue in
   * React regarding the onMouseLeave polyfill.
   * @see https://github.com/facebook/react/issues/11972
   */ (0, $2dd9093c89b92ca1$export$7080b3e976bc91ab)("mouseleave", closeWithDelay, ()=>ref.current);
    var getTriggerProps = $denZA.useCallback(function(props, _ref) {
        if (props === void 0) props = {};
        if (_ref === void 0) _ref = null;
        var triggerProps = $0bf6a9dfb0f76931$var$_extends({}, props, {
            ref: (0, $c6a0fb14928c8c7b$export$c9058316764c140e)(ref, _ref, referenceRef),
            onMouseEnter: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseEnter, openWithDelay),
            onClick: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onClick, onClick),
            onMouseDown: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onMouseDown, onMouseDown),
            onFocus: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onFocus, openWithDelay),
            onBlur: (0, $da6e679e22b3b02c$export$5bdd3f730ec2c47e)(props.onBlur, closeWithDelay),
            "aria-describedby": isOpen ? tooltipId : undefined
        });
        return triggerProps;
    }, [
        openWithDelay,
        closeWithDelay,
        onMouseDown,
        isOpen,
        tooltipId,
        onClick,
        referenceRef
    ]);
    var getTooltipPositionerProps = $denZA.useCallback(function(props, forwardedRef) {
        if (props === void 0) props = {};
        if (forwardedRef === void 0) forwardedRef = null;
        return getPopperProps($0bf6a9dfb0f76931$var$_extends({}, props, {
            style: $0bf6a9dfb0f76931$var$_extends({}, props.style, {
                [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? (0, $b0d64feb46216e43$export$91c0eda1d06bf008)(arrowSize) : undefined,
                [(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            })
        }), forwardedRef);
    }, [
        getPopperProps,
        arrowSize,
        arrowShadowColor
    ]);
    var getTooltipProps = $denZA.useCallback(function(props, _ref) {
        if (props === void 0) props = {};
        if (_ref === void 0) _ref = null;
        var tooltipProps = $0bf6a9dfb0f76931$var$_extends({
            ref: _ref
        }, htmlProps, props, {
            id: tooltipId,
            role: "tooltip",
            style: $0bf6a9dfb0f76931$var$_extends({}, props.style, {
                position: "relative",
                transformOrigin: (0, $c6107975fa403d0f$export$fd62969fb0b7081c).transformOrigin.varRef
            })
        });
        return tooltipProps;
    }, [
        htmlProps,
        tooltipId
    ]);
    return {
        isOpen: isOpen,
        show: openWithDelay,
        hide: closeWithDelay,
        getTriggerProps: getTriggerProps,
        getTooltipProps: getTooltipProps,
        getTooltipPositionerProps: getTooltipPositionerProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps
    };
}


function $ff0d4266827f9b30$var$_extends() {
    $ff0d4266827f9b30$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff0d4266827f9b30$var$_extends.apply(this, arguments);
}
function $ff0d4266827f9b30$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ff0d4266827f9b30$var$StyledTooltip = (0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4)((0, $92af15db400e8627$export$e25e478948902b8b).div);
var $ff0d4266827f9b30$export$28c660c63b792dea = /*#__PURE__*/ (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)((props, ref)=>{
    var styles = (0, $fb07eb4efac940d0$export$b863f77547fbcb03)("Tooltip", props);
    var ownProps = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props);
    var theme = (0, $77f2276a0a421ee3$export$93d4e7f90805808f)();
    var { children: children, label: label, shouldWrapChildren: shouldWrapChildren, "aria-label": ariaLabel, hasArrow: hasArrow, bg: bg, portalProps: portalProps } = ownProps, rest = $ff0d4266827f9b30$var$_objectWithoutPropertiesLoose(ownProps, [
        "children",
        "label",
        "shouldWrapChildren",
        "aria-label",
        "hasArrow",
        "bg",
        "portalProps"
    ]);
    if (bg) {
        styles.bg = bg;
        styles[(0, $c6107975fa403d0f$export$fd62969fb0b7081c).arrowBg.var] = (0, $dfe73229adf076fd$export$93c8e06b7014dc33)(theme, "colors", bg);
    }
    var tooltip = (0, $0bf6a9dfb0f76931$export$1c4b08e0eca38426)(rest);
    var shouldWrap = (0, $6b74ef5ae6a56e47$export$844ec244b1367d54)(children) || shouldWrapChildren;
    var trigger;
    if (shouldWrap) trigger = /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).span, $ff0d4266827f9b30$var$_extends({
        tabIndex: 0
    }, tooltip.getTriggerProps()), children);
    else {
        /**
     * Ensure tooltip has only one child node
     */ var child = $denZA.Children.only(children);
        trigger = /*#__PURE__*/ $denZA.cloneElement(child, tooltip.getTriggerProps(child.props, child.ref));
    }
    var hasAriaLabel = !!ariaLabel;
    var _tooltipProps = tooltip.getTooltipProps({}, ref);
    var tooltipProps = hasAriaLabel ? (0, $dfe73229adf076fd$export$30a06c8d3562193f)(_tooltipProps, [
        "role",
        "id"
    ]) : _tooltipProps;
    var hiddenProps = (0, $dfe73229adf076fd$export$357523c63a2253b9)(_tooltipProps, [
        "role",
        "id"
    ]);
    /**
   * If the `label` is empty, there's no
   * point showing the tooltip. Let's simply return back the children
   */ if (!label) return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, null, children);
    return /*#__PURE__*/ $denZA.createElement($denZA.Fragment, null, trigger, /*#__PURE__*/ $denZA.createElement((0, $6865f9da11d2ff76$export$3ae376d12526dd6f), null, tooltip.isOpen && /*#__PURE__*/ $denZA.createElement((0, $ca7b6815c1fde9de$export$602eac185826482c), portalProps, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $ff0d4266827f9b30$var$_extends({}, tooltip.getTooltipPositionerProps(), {
        __css: {
            zIndex: styles.zIndex,
            pointerEvents: "none"
        }
    }), /*#__PURE__*/ $denZA.createElement($ff0d4266827f9b30$var$StyledTooltip, $ff0d4266827f9b30$var$_extends({
        variants: (0, $44bc614af98e6baa$export$dcdf75081b88279d)
    }, tooltipProps, {
        initial: "exit",
        animate: "enter",
        exit: "exit",
        __css: styles
    }), label, hasAriaLabel && /*#__PURE__*/ $denZA.createElement((0, $1c1cbb13148aec1f$export$439d29a4e110a164), hiddenProps, ariaLabel), hasArrow && /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        "data-popper-arrow": true,
        className: "chakra-tooltip__arrow-wrapper"
    }, /*#__PURE__*/ $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, {
        "data-popper-arrow-inner": true,
        className: "chakra-tooltip__arrow",
        __css: {
            bg: styles.bg
        }
    })))))));
});
if (0, $6b74ef5ae6a56e47$export$a866f231438cc228) $ff0d4266827f9b30$export$28c660c63b792dea.displayName = "Tooltip";



var $denZA = parcelRequire("denZA");
var $5fb8df3d849869f7$var$__assign = undefined && undefined.__assign || function() {
    $5fb8df3d849869f7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5fb8df3d849869f7$var$__assign.apply(this, arguments);
};
var $5fb8df3d849869f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5fb8df3d849869f7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5fb8df3d849869f7$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5fb8df3d849869f7$export$28c660c63b792dea = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.modifiers, modifiers = _b === void 0 ? [] : _b, rest = $5fb8df3d849869f7$var$__rest(_a, [
        "modifiers"
    ]);
    var internalModifiers = $5fb8df3d849869f7$var$__spreadArray($5fb8df3d849869f7$var$__spreadArray([], $5fb8df3d849869f7$var$__read(modifiers), false), [
        {
            name: 'applyArrowHide',
            enabled: true,
            phase: 'write',
            fn: function(_a) {
                var state = _a.state;
                var arrow = state.elements.arrow;
                // we cannot style the arrow directly, we're changing the zIndex here like this because // of the box-shadow of the tooltip
                if (arrow) arrow.style.zIndex = '1';
            }
        }
    ], false);
    return $denZA.createElement((0, $ff0d4266827f9b30$export$28c660c63b792dea), $5fb8df3d849869f7$var$__assign({
        hasArrow: true,
        modifiers: internalModifiers
    }, rest, {
        ref: ref
    }));
});






var $denZA = parcelRequire("denZA");
var $830ebe276a8dc1ee$var$__assign = undefined && undefined.__assign || function() {
    $830ebe276a8dc1ee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $830ebe276a8dc1ee$var$__assign.apply(this, arguments);
};
var $830ebe276a8dc1ee$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $830ebe276a8dc1ee$export$d89c679ee2f73242 = (0, $f3563a42e5e5d5b1$export$257a8862b851cb5b)(function(props, ref) {
    var _a = (0, $7581331fc4faccf3$export$adfcf5a5e4d17785)(props), _b = _a.hasBorder, hasBorder = _b === void 0 ? true : _b, rest = $830ebe276a8dc1ee$var$__rest(_a, [
        "hasBorder"
    ]);
    var styles = (0, $fb07eb4efac940d0$export$31cdfe60c085d76f)('Well', {
        hasBorder: hasBorder
    });
    return $denZA.createElement((0, $fa3b5b33d58c73c3$export$7cd122d781af9fa4).div, $830ebe276a8dc1ee$var$__assign({
        __css: styles,
        ref: ref
    }, rest));
});






var $a40a8ef987ea0d8e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a40a8ef987ea0d8e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a40a8ef987ea0d8e$export$33a2b855d5b8731e = function() {
    var extensions = [];
    for(var _i = 0; _i < arguments.length; _i++)extensions[_i] = arguments[_i];
    var overrides = $a40a8ef987ea0d8e$var$__spreadArray([], $a40a8ef987ea0d8e$var$__read(extensions), false);
    var baseTheme = extensions[extensions.length - 1];
    if ((0, $a77c364619ae316b$export$73a6ae01926a4f0e)(baseTheme) && // this ensures backward compatibility
    // previously only `extendTheme(override, baseTheme?)` was allowed
    overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
    else baseTheme = (0, $812a5b751b26d61b$export$bca14c5b3b88a9c9);
    return (0, $e4d547fd9b80de1b$export$33a2b855d5b8731e).apply(void 0, $a40a8ef987ea0d8e$var$__spreadArray($a40a8ef987ea0d8e$var$__spreadArray([], $a40a8ef987ea0d8e$var$__read(overrides), false), [
        baseTheme
    ], false));
};


// eslint-disable-next-line import/no-named-as-default


var $denZA = parcelRequire("denZA");
var $996c22aaf6d14ac5$export$b751feffed387621 = ()=>/*#__PURE__*/ $denZA.createElement((0, $803605a2d06b7a22$export$98f03c5d19621d70), {
        styles: "\n      html {\n        line-height: 1.5;\n        -webkit-text-size-adjust: 100%;\n        font-family: system-ui, sans-serif;\n        -webkit-font-smoothing: antialiased;\n        text-rendering: optimizeLegibility;      \n        -moz-osx-font-smoothing: grayscale; \n        touch-action: manipulation; \n      }\n\n      body {\n        position: relative;\n        min-height: 100%;\n        font-feature-settings: 'kern';\n      }\n\n      *,\n      *::before,\n      *::after {\n        border-width: 0;\n        border-style: solid;\n        box-sizing: border-box;\n      }\n\n      main {\n        display: block;\n      }\n\n      hr {\n        border-top-width: 1px;\n        box-sizing: content-box;\n        height: 0;\n        overflow: visible;\n      }\n\n      pre,\n      code,\n      kbd,\n      samp {\n        font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;\n        font-size: 1em;\n      }\n\n      a {\n        background-color: transparent;\n        color: inherit;\n        text-decoration: inherit;\n      }\n\n      abbr[title] {\n        border-bottom: none;\n        text-decoration: underline;\n        -webkit-text-decoration: underline dotted;\n        text-decoration: underline dotted;\n      }\n\n      b,\n      strong {\n        font-weight: bold;\n      }\n\n      small {\n        font-size: 80%;\n      }\n\n      sub,\n      sup {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n        vertical-align: baseline;\n      }\n\n      sub {\n        bottom: -0.25em;\n      }\n\n      sup {\n        top: -0.5em;\n      }\n\n      img {\n        border-style: none;\n      }\n\n      button,\n      input,\n      optgroup,\n      select,\n      textarea {\n        font-family: inherit;\n        font-size: 100%;\n        line-height: 1.15;\n        margin: 0;\n      }\n\n      button,\n      input {\n        overflow: visible;\n      }\n\n      button,\n      select {\n        text-transform: none;\n      }\n\n      button::-moz-focus-inner,\n      [type=\"button\"]::-moz-focus-inner,\n      [type=\"reset\"]::-moz-focus-inner,\n      [type=\"submit\"]::-moz-focus-inner {\n        border-style: none;\n        padding: 0;\n      }\n\n      fieldset {\n        padding: 0.35em 0.75em 0.625em;\n      }\n\n      legend {\n        box-sizing: border-box;\n        color: inherit;\n        display: table;\n        max-width: 100%;\n        padding: 0;\n        white-space: normal;\n      }\n\n      progress {\n        vertical-align: baseline;\n      }\n\n      textarea {\n        overflow: auto;\n      }\n\n      [type=\"checkbox\"],\n      [type=\"radio\"] {\n        box-sizing: border-box;\n        padding: 0;\n      }\n\n      [type=\"number\"]::-webkit-inner-spin-button,\n      [type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none !important;\n      }\n\n      input[type=\"number\"] {\n        -moz-appearance: textfield;\n      }\n\n      [type=\"search\"] {\n        -webkit-appearance: textfield;\n        outline-offset: -2px;\n      }\n\n      [type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none !important;\n      }\n\n      ::-webkit-file-upload-button {\n        -webkit-appearance: button;\n        font: inherit;\n      }\n\n      details {\n        display: block;\n      }\n\n      summary {\n        display: list-item;\n      }\n\n      template {\n        display: none;\n      }\n\n      [hidden] {\n        display: none !important;\n      }\n\n      body,\n      blockquote,\n      dl,\n      dd,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      hr,\n      figure,\n      p,\n      pre {\n        margin: 0;\n      }\n\n      button {\n        background: transparent;\n        padding: 0;\n      }\n\n      fieldset {\n        margin: 0;\n        padding: 0;\n      }\n\n      ol,\n      ul {\n        margin: 0;\n        padding: 0;\n      }\n\n      textarea {\n        resize: vertical;\n      }\n\n      button,\n      [role=\"button\"] {\n        cursor: pointer;\n      }\n\n      button::-moz-focus-inner {\n        border: 0 !important;\n      }\n\n      table {\n        border-collapse: collapse;\n      }\n\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        font-size: inherit;\n        font-weight: inherit;\n      }\n\n      button,\n      input,\n      optgroup,\n      select,\n      textarea {\n        padding: 0;\n        line-height: inherit;\n        color: inherit;\n      }\n\n      img,\n      svg,\n      video,\n      canvas,\n      audio,\n      iframe,\n      embed,\n      object {\n        display: block;\n        vertical-align: middle;\n      }\n\n      img,\n      video {\n        max-width: 100%;\n        height: auto;\n      }\n\n      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {\n        outline: none;\n        box-shadow: none;\n      }\n\n      select::-ms-expand {\n        display: none;\n      }\n    "
    });
var $996c22aaf6d14ac5$export$2e2bcd8739ae039 = $996c22aaf6d14ac5$export$b751feffed387621;






var $denZA = parcelRequire("denZA");
var $f5559b6a89ee1e6c$export$c2fe1be989122f41 = function(_a) {
    var children = _a.children, colorModeManager = _a.colorModeManager, portalZIndex = _a.portalZIndex, _b = _a.resetCSS, shouldResetCSS = _b === void 0 ? true : _b, _c = _a.theme, theme = _c === void 0 ? (0, $812a5b751b26d61b$export$bca14c5b3b88a9c9) : _c;
    return $denZA.createElement((0, $77f2276a0a421ee3$export$d8964aec282183a3), {
        theme: theme
    }, $denZA.createElement((0, $cb7c335cf150f8d2$export$7a858aa3ff83dde7), {
        colorModeManager: colorModeManager,
        options: theme.config
    }, shouldResetCSS && $denZA.createElement((0, $996c22aaf6d14ac5$export$2e2bcd8739ae039), null), $denZA.createElement((0, $77f2276a0a421ee3$export$f05794e648629f6c), null), portalZIndex ? $denZA.createElement((0, $601bf1129b0e92c7$export$52c7ef79917c2f38), {
        zIndex: portalZIndex
    }, children) : children));
};








var $denZA = parcelRequire("denZA");






var $4806eb5e0561565b$exports = {};
var $4806eb5e0561565b$var$characterMap = {
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\u1EA4": "A",
    "\u1EAE": "A",
    "\u1EB2": "A",
    "\u1EB4": "A",
    "\u1EB6": "A",
    "\xc6": "AE",
    "\u1EA6": "A",
    "\u1EB0": "A",
    "\u0202": "A",
    "\xc7": "C",
    "\u1E08": "C",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\u1EBE": "E",
    "\u1E16": "E",
    "\u1EC0": "E",
    "\u1E14": "E",
    "\u1E1C": "E",
    "\u0206": "E",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\u1E2E": "I",
    "\u020A": "I",
    "\xd0": "D",
    "\xd1": "N",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\u1ED0": "O",
    "\u1E4C": "O",
    "\u1E52": "O",
    "\u020E": "O",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xdd": "Y",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\u1EA5": "a",
    "\u1EAF": "a",
    "\u1EB3": "a",
    "\u1EB5": "a",
    "\u1EB7": "a",
    "\xe6": "ae",
    "\u1EA7": "a",
    "\u1EB1": "a",
    "\u0203": "a",
    "\xe7": "c",
    "\u1E09": "c",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\u1EBF": "e",
    "\u1E17": "e",
    "\u1EC1": "e",
    "\u1E15": "e",
    "\u1E1D": "e",
    "\u0207": "e",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\u1E2F": "i",
    "\u020B": "i",
    "\xf0": "d",
    "\xf1": "n",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\u1ED1": "o",
    "\u1E4D": "o",
    "\u1E53": "o",
    "\u020F": "o",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xfd": "y",
    "\xff": "y",
    "\u0100": "A",
    "\u0101": "a",
    "\u0102": "A",
    "\u0103": "a",
    "\u0104": "A",
    "\u0105": "a",
    "\u0106": "C",
    "\u0107": "c",
    "\u0108": "C",
    "\u0109": "c",
    "\u010A": "C",
    "\u010B": "c",
    "\u010C": "C",
    "\u010D": "c",
    "C\u0306": "C",
    "c\u0306": "c",
    "\u010E": "D",
    "\u010F": "d",
    "\u0110": "D",
    "\u0111": "d",
    "\u0112": "E",
    "\u0113": "e",
    "\u0114": "E",
    "\u0115": "e",
    "\u0116": "E",
    "\u0117": "e",
    "\u0118": "E",
    "\u0119": "e",
    "\u011A": "E",
    "\u011B": "e",
    "\u011C": "G",
    "\u01F4": "G",
    "\u011D": "g",
    "\u01F5": "g",
    "\u011E": "G",
    "\u011F": "g",
    "\u0120": "G",
    "\u0121": "g",
    "\u0122": "G",
    "\u0123": "g",
    "\u0124": "H",
    "\u0125": "h",
    "\u0126": "H",
    "\u0127": "h",
    "\u1E2A": "H",
    "\u1E2B": "h",
    "\u0128": "I",
    "\u0129": "i",
    "\u012A": "I",
    "\u012B": "i",
    "\u012C": "I",
    "\u012D": "i",
    "\u012E": "I",
    "\u012F": "i",
    "\u0130": "I",
    "\u0131": "i",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u1E30": "K",
    "\u1E31": "k",
    "K\u0306": "K",
    "k\u0306": "k",
    "\u0139": "L",
    "\u013A": "l",
    "\u013B": "L",
    "\u013C": "l",
    "\u013D": "L",
    "\u013E": "l",
    "\u013F": "L",
    "\u0140": "l",
    "\u0141": "l",
    "\u0142": "l",
    "\u1E3E": "M",
    "\u1E3F": "m",
    "M\u0306": "M",
    "m\u0306": "m",
    "\u0143": "N",
    "\u0144": "n",
    "\u0145": "N",
    "\u0146": "n",
    "\u0147": "N",
    "\u0148": "n",
    "\u0149": "n",
    "N\u0306": "N",
    "n\u0306": "n",
    "\u014C": "O",
    "\u014D": "o",
    "\u014E": "O",
    "\u014F": "o",
    "\u0150": "O",
    "\u0151": "o",
    "\u0152": "OE",
    "\u0153": "oe",
    "P\u0306": "P",
    "p\u0306": "p",
    "\u0154": "R",
    "\u0155": "r",
    "\u0156": "R",
    "\u0157": "r",
    "\u0158": "R",
    "\u0159": "r",
    "R\u0306": "R",
    "r\u0306": "r",
    "\u0212": "R",
    "\u0213": "r",
    "\u015A": "S",
    "\u015B": "s",
    "\u015C": "S",
    "\u015D": "s",
    "\u015E": "S",
    "\u0218": "S",
    "\u0219": "s",
    "\u015F": "s",
    "\u0160": "S",
    "\u0161": "s",
    "\u0162": "T",
    "\u0163": "t",
    "\u021B": "t",
    "\u021A": "T",
    "\u0164": "T",
    "\u0165": "t",
    "\u0166": "T",
    "\u0167": "t",
    "T\u0306": "T",
    "t\u0306": "t",
    "\u0168": "U",
    "\u0169": "u",
    "\u016A": "U",
    "\u016B": "u",
    "\u016C": "U",
    "\u016D": "u",
    "\u016E": "U",
    "\u016F": "u",
    "\u0170": "U",
    "\u0171": "u",
    "\u0172": "U",
    "\u0173": "u",
    "\u0216": "U",
    "\u0217": "u",
    "V\u0306": "V",
    "v\u0306": "v",
    "\u0174": "W",
    "\u0175": "w",
    "\u1E82": "W",
    "\u1E83": "w",
    "X\u0306": "X",
    "x\u0306": "x",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "Y\u0306": "Y",
    "y\u0306": "y",
    "\u0179": "Z",
    "\u017A": "z",
    "\u017B": "Z",
    "\u017C": "z",
    "\u017D": "Z",
    "\u017E": "z",
    "\u017F": "s",
    "\u0192": "f",
    "\u01A0": "O",
    "\u01A1": "o",
    "\u01AF": "U",
    "\u01B0": "u",
    "\u01CD": "A",
    "\u01CE": "a",
    "\u01CF": "I",
    "\u01D0": "i",
    "\u01D1": "O",
    "\u01D2": "o",
    "\u01D3": "U",
    "\u01D4": "u",
    "\u01D5": "U",
    "\u01D6": "u",
    "\u01D7": "U",
    "\u01D8": "u",
    "\u01D9": "U",
    "\u01DA": "u",
    "\u01DB": "U",
    "\u01DC": "u",
    "\u1EE8": "U",
    "\u1EE9": "u",
    "\u1E78": "U",
    "\u1E79": "u",
    "\u01FA": "A",
    "\u01FB": "a",
    "\u01FC": "AE",
    "\u01FD": "ae",
    "\u01FE": "O",
    "\u01FF": "o",
    "\xde": "TH",
    "\xfe": "th",
    "\u1E54": "P",
    "\u1E55": "p",
    "\u1E64": "S",
    "\u1E65": "s",
    "X\u0301": "X",
    "x\u0301": "x",
    "\u0403": "\u0413",
    "\u0453": "\u0433",
    "\u040C": "\u041A",
    "\u045C": "\u043A",
    "A\u030B": "A",
    "a\u030B": "a",
    "E\u030B": "E",
    "e\u030B": "e",
    "I\u030B": "I",
    "i\u030B": "i",
    "\u01F8": "N",
    "\u01F9": "n",
    "\u1ED2": "O",
    "\u1ED3": "o",
    "\u1E50": "O",
    "\u1E51": "o",
    "\u1EEA": "U",
    "\u1EEB": "u",
    "\u1E80": "W",
    "\u1E81": "w",
    "\u1EF2": "Y",
    "\u1EF3": "y",
    "\u0200": "A",
    "\u0201": "a",
    "\u0204": "E",
    "\u0205": "e",
    "\u0208": "I",
    "\u0209": "i",
    "\u020C": "O",
    "\u020D": "o",
    "\u0210": "R",
    "\u0211": "r",
    "\u0214": "U",
    "\u0215": "u",
    "B\u030C": "B",
    "b\u030C": "b",
    "\u010C\u0323": "C",
    "\u010D\u0323": "c",
    "\xca\u030C": "E",
    "\xea\u030C": "e",
    "F\u030C": "F",
    "f\u030C": "f",
    "\u01E6": "G",
    "\u01E7": "g",
    "\u021E": "H",
    "\u021F": "h",
    "J\u030C": "J",
    "\u01F0": "j",
    "\u01E8": "K",
    "\u01E9": "k",
    "M\u030C": "M",
    "m\u030C": "m",
    "P\u030C": "P",
    "p\u030C": "p",
    "Q\u030C": "Q",
    "q\u030C": "q",
    "\u0158\u0329": "R",
    "\u0159\u0329": "r",
    "\u1E66": "S",
    "\u1E67": "s",
    "V\u030C": "V",
    "v\u030C": "v",
    "W\u030C": "W",
    "w\u030C": "w",
    "X\u030C": "X",
    "x\u030C": "x",
    "Y\u030C": "Y",
    "y\u030C": "y",
    "A\u0327": "A",
    "a\u0327": "a",
    "B\u0327": "B",
    "b\u0327": "b",
    "\u1E10": "D",
    "\u1E11": "d",
    "\u0228": "E",
    "\u0229": "e",
    "\u0190\u0327": "E",
    "\u025B\u0327": "e",
    "\u1E28": "H",
    "\u1E29": "h",
    "I\u0327": "I",
    "i\u0327": "i",
    "\u0197\u0327": "I",
    "\u0268\u0327": "i",
    "M\u0327": "M",
    "m\u0327": "m",
    "O\u0327": "O",
    "o\u0327": "o",
    "Q\u0327": "Q",
    "q\u0327": "q",
    "U\u0327": "U",
    "u\u0327": "u",
    "X\u0327": "X",
    "x\u0327": "x",
    "Z\u0327": "Z",
    "z\u0327": "z"
};
var $4806eb5e0561565b$var$chars = Object.keys($4806eb5e0561565b$var$characterMap).join('|');
var $4806eb5e0561565b$var$allAccents = new RegExp($4806eb5e0561565b$var$chars, 'g');
var $4806eb5e0561565b$var$firstAccent = new RegExp($4806eb5e0561565b$var$chars, '');
var $4806eb5e0561565b$var$removeAccents = function(string) {
    return string.replace($4806eb5e0561565b$var$allAccents, function(match) {
        return $4806eb5e0561565b$var$characterMap[match];
    });
};
var $4806eb5e0561565b$var$hasAccents = function(string) {
    return !!string.match($4806eb5e0561565b$var$firstAccent);
};
$4806eb5e0561565b$exports = $4806eb5e0561565b$var$removeAccents;
$4806eb5e0561565b$exports.has = $4806eb5e0561565b$var$hasAccents;
$4806eb5e0561565b$exports.remove = $4806eb5e0561565b$var$removeAccents;


var $ba6523c0c2363a02$export$809b0b82a3f0b8b5 = {
    CASE_SENSITIVE_EQUAL: 7,
    EQUAL: 6,
    STARTS_WITH: 5,
    WORD_STARTS_WITH: 4,
    CONTAINS: 3,
    ACRONYM: 2,
    MATCHES: 1,
    NO_MATCH: 0
};
$ba6523c0c2363a02$export$9e154eccb89349f0.rankings = $ba6523c0c2363a02$export$809b0b82a3f0b8b5;
var $ba6523c0c2363a02$export$dc3d084526f616f2 = function defaultBaseSortFn(a, b) {
    return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */ function $ba6523c0c2363a02$export$9e154eccb89349f0(items, value, options) {
    if (options === void 0) options = {};
    var _options = options, keys = _options.keys, _options$threshold = _options.threshold, threshold = _options$threshold === void 0 ? $ba6523c0c2363a02$export$809b0b82a3f0b8b5.MATCHES : _options$threshold, _options$baseSort = _options.baseSort, baseSort = _options$baseSort === void 0 ? $ba6523c0c2363a02$export$dc3d084526f616f2 : _options$baseSort, _options$sorter = _options.sorter, sorter = _options$sorter === void 0 ? function(matchedItems) {
        return matchedItems.sort(function(a, b) {
            return $ba6523c0c2363a02$var$sortRankedValues(a, b, baseSort);
        });
    } : _options$sorter;
    var matchedItems = items.reduce(reduceItemsToRanked, []);
    return sorter(matchedItems).map(function(_ref) {
        var item = _ref.item;
        return item;
    });
    function reduceItemsToRanked(matches, item, index) {
        var rankingInfo = $ba6523c0c2363a02$var$getHighestRanking(item, keys, value, options);
        var rank = rankingInfo.rank, _rankingInfo$keyThres = rankingInfo.keyThreshold, keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;
        if (rank >= keyThreshold) matches.push((0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, rankingInfo, {
            item: item,
            index: index
        }));
        return matches;
    }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */ function $ba6523c0c2363a02$var$getHighestRanking(item, keys, value, options) {
    if (!keys) {
        // if keys is not specified, then we assume the item given is ready to be matched
        var stringItem = item;
        return {
            // ends up being duplicate of 'item' in matches but consistent
            rankedValue: stringItem,
            rank: $ba6523c0c2363a02$var$getMatchRanking(stringItem, value, options),
            keyIndex: -1,
            keyThreshold: options.threshold
        };
    }
    var valuesToRank = $ba6523c0c2363a02$var$getAllValuesToRank(item, keys);
    return valuesToRank.reduce(function(_ref2, _ref3, i) {
        var rank = _ref2.rank, rankedValue = _ref2.rankedValue, keyIndex = _ref2.keyIndex, keyThreshold = _ref2.keyThreshold;
        var itemValue = _ref3.itemValue, attributes = _ref3.attributes;
        var newRank = $ba6523c0c2363a02$var$getMatchRanking(itemValue, value, options);
        var newRankedValue = rankedValue;
        var minRanking = attributes.minRanking, maxRanking = attributes.maxRanking, threshold = attributes.threshold;
        if (newRank < minRanking && newRank >= $ba6523c0c2363a02$export$809b0b82a3f0b8b5.MATCHES) newRank = minRanking;
        else if (newRank > maxRanking) newRank = maxRanking;
        if (newRank > rank) {
            rank = newRank;
            keyIndex = i;
            keyThreshold = threshold;
            newRankedValue = itemValue;
        }
        return {
            rankedValue: newRankedValue,
            rank: rank,
            keyIndex: keyIndex,
            keyThreshold: keyThreshold
        };
    }, {
        rankedValue: item,
        rank: $ba6523c0c2363a02$export$809b0b82a3f0b8b5.NO_MATCH,
        keyIndex: -1,
        keyThreshold: options.threshold
    });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */ function $ba6523c0c2363a02$var$getMatchRanking(testString, stringToRank, options) {
    testString = $ba6523c0c2363a02$var$prepareValueForComparison(testString, options);
    stringToRank = $ba6523c0c2363a02$var$prepareValueForComparison(stringToRank, options); // too long
    if (stringToRank.length > testString.length) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.NO_MATCH;
     // case sensitive equals
    if (testString === stringToRank) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.CASE_SENSITIVE_EQUAL;
     // Lower casing before further comparison
    testString = testString.toLowerCase();
    stringToRank = stringToRank.toLowerCase(); // case insensitive equals
    if (testString === stringToRank) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.EQUAL;
     // starts with
    if (testString.startsWith(stringToRank)) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.STARTS_WITH;
     // word starts with
    if (testString.includes(" " + stringToRank)) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.WORD_STARTS_WITH;
     // contains
    if (testString.includes(stringToRank)) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.CONTAINS;
    else if (stringToRank.length === 1) // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.NO_MATCH;
     // acronym
    if ($ba6523c0c2363a02$var$getAcronym(testString).includes(stringToRank)) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.ACRONYM;
     // will return a number between rankings.MATCHES and
    // rankings.MATCHES + 1 depending  on how close of a match it is.
    return $ba6523c0c2363a02$var$getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */ function $ba6523c0c2363a02$var$getAcronym(string) {
    var acronym = '';
    var wordsInString = string.split(' ');
    wordsInString.forEach(function(wordInString) {
        var splitByHyphenWords = wordInString.split('-');
        splitByHyphenWords.forEach(function(splitByHyphenWord) {
            acronym += splitByHyphenWord.substr(0, 1);
        });
    });
    return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */ function $ba6523c0c2363a02$var$getClosenessRanking(testString, stringToRank) {
    var matchingInOrderCharCount = 0;
    var charNumber = 0;
    function findMatchingCharacter(matchChar, string, index) {
        for(var j = index, J = string.length; j < J; j++){
            var stringChar = string[j];
            if (stringChar === matchChar) {
                matchingInOrderCharCount += 1;
                return j + 1;
            }
        }
        return -1;
    }
    function getRanking(spread) {
        var spreadPercentage = 1 / spread;
        var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
        var ranking = $ba6523c0c2363a02$export$809b0b82a3f0b8b5.MATCHES + inOrderPercentage * spreadPercentage;
        return ranking;
    }
    var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
    if (firstIndex < 0) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.NO_MATCH;
    charNumber = firstIndex;
    for(var i = 1, I = stringToRank.length; i < I; i++){
        var matchChar = stringToRank[i];
        charNumber = findMatchingCharacter(matchChar, testString, charNumber);
        var found = charNumber > -1;
        if (!found) return $ba6523c0c2363a02$export$809b0b82a3f0b8b5.NO_MATCH;
    }
    var spread = charNumber - firstIndex;
    return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */ function $ba6523c0c2363a02$var$sortRankedValues(a, b, baseSort) {
    var aFirst = -1;
    var bFirst = 1;
    var aRank = a.rank, aKeyIndex = a.keyIndex;
    var bRank = b.rank, bKeyIndex = b.keyIndex;
    var same = aRank === bRank;
    if (same) {
        if (aKeyIndex === bKeyIndex) // use the base sort function as a tie-breaker
        return baseSort(a, b);
        else return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    } else return aRank > bRank ? aFirst : bFirst;
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */ function $ba6523c0c2363a02$var$prepareValueForComparison(value, _ref4) {
    var keepDiacritics = _ref4.keepDiacritics;
    // value might not actually be a string at this point (we don't get to choose)
    // so part of preparing the value for comparison is ensure that it is a string
    value = "" + value; // toString
    if (!keepDiacritics) value = (0, (/*@__PURE__*/$parcel$interopDefault($4806eb5e0561565b$exports)))(value);
    return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */ function $ba6523c0c2363a02$var$getItemValues(item, key) {
    if (typeof key === 'object') key = key.key;
    var value;
    if (typeof key === 'function') value = key(item);
    else if (item == null) value = null;
    else if (Object.hasOwnProperty.call(item, key)) value = item[key];
    else if (key.includes('.')) // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return $ba6523c0c2363a02$var$getNestedValues(key, item);
    else value = null;
     // because `value` can also be undefined
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return [
        String(value)
    ];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */ function $ba6523c0c2363a02$var$getNestedValues(path, item) {
    var keys = path.split('.');
    var values = [
        item
    ];
    for(var i = 0, I = keys.length; i < I; i++){
        var nestedKey = keys[i];
        var nestedValues = [];
        for(var j = 0, J = values.length; j < J; j++){
            var nestedItem = values[j];
            if (nestedItem == null) continue;
            if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
                var nestedValue = nestedItem[nestedKey];
                if (nestedValue != null) nestedValues.push(nestedValue);
            } else if (nestedKey === '*') // ensure that values is an array
            nestedValues = nestedValues.concat(nestedItem);
        }
        values = nestedValues;
    }
    if (Array.isArray(values[0])) {
        // keep allowing the implicit wildcard for an array of strings at the end of
        // the path; don't use `.flat()` because that's not available in node.js v10
        var result = [];
        return result.concat.apply(result, values);
    } // Based on our logic it should be an array of strings by now...
    // assuming the user's path terminated in strings
    return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */ function $ba6523c0c2363a02$var$getAllValuesToRank(item, keys) {
    var allValues = [];
    for(var j = 0, J = keys.length; j < J; j++){
        var key = keys[j];
        var attributes = $ba6523c0c2363a02$var$getKeyAttributes(key);
        var itemValues = $ba6523c0c2363a02$var$getItemValues(item, key);
        for(var i = 0, I = itemValues.length; i < I; i++)allValues.push({
            itemValue: itemValues[i],
            attributes: attributes
        });
    }
    return allValues;
}
var $ba6523c0c2363a02$var$defaultKeyAttributes = {
    maxRanking: Infinity,
    minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */ function $ba6523c0c2363a02$var$getKeyAttributes(key) {
    if (typeof key === 'string') return $ba6523c0c2363a02$var$defaultKeyAttributes;
    return (0, $78dfc96d1f03aba0$export$2e2bcd8739ae039)({}, $ba6523c0c2363a02$var$defaultKeyAttributes, key);
}





var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");
var $81513bc3741e8bd2$exports = {};

$81513bc3741e8bd2$exports = (parcelRequire("cL3gO"));








var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");



var $denZA = parcelRequire("denZA");
const $cb12710efb9b11d0$export$d2862298b229cc1f = (focusedElement, clickOutsideCallback)=>{
    const detectClickOutside = (0, $denZA.useCallback)((event)=>{
        if (Array.isArray(focusedElement)) {
            const res = focusedElement.map((elm)=>{
                if (elm.current) {
                    if (elm.current.contains(event.target)) return true;
                }
                return false;
            });
            // If none of the elements were clicked call callback
            if (res.every((item)=>!item)) clickOutsideCallback(event);
            return;
        }
        if (focusedElement.current) {
            if (!focusedElement.current.contains(event.target)) clickOutsideCallback(event);
        }
    }, [
        focusedElement,
        clickOutsideCallback
    ]);
    (0, $denZA.useLayoutEffect)(()=>{
        document.addEventListener('mousedown', detectClickOutside);
        document.addEventListener('touchstart', detectClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', detectClickOutside);
            document.removeEventListener('touchstart', detectClickOutside);
        };
    }, [
        focusedElement,
        detectClickOutside
    ]);
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");


const $b19268d827afc530$var$dropDownStyle = (width)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        width: width || '100%',
        backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
        border: `1px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate30}`,
        borderRadius: 4,
        boxShadow: `0px 2px ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).shadows.boxShadow}`,
        zIndex: 999,
        position: 'relative',
        overflow: 'hidden'
    });
const $b19268d827afc530$export$e7fbc454eee05098 = /*#__PURE__*/ (0, $denZA.forwardRef)(({ width: width, onSelectHandler: onSelectHandler, children: children, selectedValue: selectedValue = null }, ref)=>{
    const providedChildren = (0, $denZA.useMemo)(()=>(0, $denZA.Children).map(children, (child)=>{
            const { value: value } = child.props;
            return /*#__PURE__*/ (0, $denZA.cloneElement)(child, {
                isSelected: value === selectedValue,
                onClick: onSelectHandler,
                ...child.props
            });
        }), [
        selectedValue,
        onSelectHandler,
        children
    ]);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        "aria-label": "Dropdown",
        ref: ref,
        css: $b19268d827afc530$var$dropDownStyle(width),
        children: providedChildren
    });
});
$b19268d827afc530$export$e7fbc454eee05098.displayName = 'DropDown';
$b19268d827afc530$export$e7fbc454eee05098.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired,
    onSelectHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    selectedValue: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
    ]),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
};



const $b0179fea72139c21$var$borderWidthHover = 2;
const $b0179fea72139c21$var$selectWrapperStyle = (width)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        width: width || '100%',
        position: 'relative'
    });
const $b0179fea72139c21$var$selectFieldStyle = (isOpen)=>{
    const borderWidth = isOpen ? 2 : 1;
    return (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        borderWidth: borderWidth,
        borderStyle: 'solid',
        borderColor: isOpen ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.information.base : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40,
        boxShadow: `0px 1px ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).shadows.boxShadow}`,
        borderRadius: (0, $16681adf0d4cc247$export$bcd6882dc7e615be).borderRadius,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1 - borderWidth}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size3 - borderWidth}px`,
        minHeight: 30,
        '&:hover': {
            borderWidth: 2,
            borderColor: isOpen ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.information.base : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60,
            padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1 - $b0179fea72139c21$var$borderWidthHover}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size3 - $b0179fea72139c21$var$borderWidthHover}px`
        }
    });
};
const $b0179fea72139c21$var$selectedValueStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    flexGrow: 1,
    flexShrink: 1
});
const $b0179fea72139c21$var$iconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 12,
    height: 12
});
const $b0179fea72139c21$var$dropDownWrapperStyle = (isOpen)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: isOpen ? 'block' : 'none',
        position: 'absolute',
        width: '100%',
        top: 32
    });
const $b0179fea72139c21$export$ef9b1a59e592288f = ({ value: value = '', onSelect: onSelect, children: children })=>{
    const selectFieldRef = (0, $denZA.useRef)(null);
    const dropdownRef = (0, $denZA.useRef)(null);
    const [isOpen, setIsOpen] = (0, $denZA.useState)(false);
    (0, $denZA.useEffect)(()=>{
        setIsOpen(false);
    }, [
        value
    ]);
    (0, $cb12710efb9b11d0$export$d2862298b229cc1f)([
        selectFieldRef,
        dropdownRef
    ], ()=>{
        setIsOpen(false);
    });
    const handleDropDownButtonClick = (event)=>{
        event.stopPropagation();
        setIsOpen(true);
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $b0179fea72139c21$var$selectWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                "aria-label": "Select",
                ref: selectFieldRef,
                css: $b0179fea72139c21$var$selectFieldStyle(isOpen),
                onClick: (event)=>handleDropDownButtonClick(event),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                        css: $b0179fea72139c21$var$selectedValueStyle,
                        children: value
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $a80fc6ca0fd09b79$export$1fa5a43af950a186), {
                        css: $b0179fea72139c21$var$iconStyle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $b0179fea72139c21$var$dropDownWrapperStyle(isOpen),
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b19268d827afc530$export$e7fbc454eee05098), {
                    onSelectHandler: onSelect,
                    selectedValue: value,
                    ref: dropdownRef,
                    children: children
                })
            })
        ]
    });
};
$b0179fea72139c21$export$ef9b1a59e592288f.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
    ]),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");



const $108abcf98aa8bc43$var$dropDownItemStyle = (isSelected)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        cursor: 'pointer',
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size3}px`,
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
        userSelect: 'none',
        backgroundColor: isSelected ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue05 : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
        '&:hover': {
            backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate05
        }
    });
const $108abcf98aa8bc43$var$isSelectedIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 12,
    height: 12
});
const $108abcf98aa8bc43$export$617cca870742ea6e = ({ label: label, value: value, isSelected: isSelected = false, onClick: onClick })=>{
    const onClickHandler = (0, $denZA.useCallback)((event)=>{
        event.stopPropagation();
        if (onClick) onClick(value);
    }, [
        value,
        onClick
    ]);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $108abcf98aa8bc43$var$dropDownItemStyle(isSelected),
        onClick: onClickHandler,
        children: [
            label,
            isSelected && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6892ac9a89282880$export$add807e002afa321), {
                css: $108abcf98aa8bc43$var$isSelectedIconStyle
            })
        ]
    });
};
$108abcf98aa8bc43$export$617cca870742ea6e.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
    ]),
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func
};




const $5505343c4d5bfadb$export$a8a28302b48950e6 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    display: 'block',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).xLarge]: {
        display: 'table'
    }
});
const $5505343c4d5bfadb$var$generalCellStyle = {
    borderBottom: `1px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20}`,
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    height: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    minWidth: 190,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).xLarge]: {
        minWidth: 0
    }
};
const $5505343c4d5bfadb$export$15c518144f297303 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)($5505343c4d5bfadb$var$generalCellStyle);
const $5505343c4d5bfadb$export$aa70f7bbadb680f2 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$5505343c4d5bfadb$var$generalCellStyle,
    textAlign: 'left',
    borderBottom: `2px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20}`
});



const $8a9497a467328348$export$1e3011a62dab913a = (numberOfAssessments)=>{
    // Aiming for a 10 page division of the assessments
    const preferredNumberOfPages = numberOfAssessments / 10;
    const pageSize = (0, $2b2f6d62e3d02216$export$fd7a298ee570483a).reduce((acc, next)=>{
        if (Math.abs(preferredNumberOfPages - acc) > Math.abs(preferredNumberOfPages - next)) return next;
        return acc;
    }, (0, $2b2f6d62e3d02216$export$fd7a298ee570483a)[(0, $2b2f6d62e3d02216$export$fd7a298ee570483a).length - 1]);
    return pageSize;
};
const $8a9497a467328348$export$653d991678529bd7 = (sortByFromState, localStorageSortByKey)=>{
    if (!sortByFromState.length) return window.localStorage.setItem(localStorageSortByKey, 'NOT_SORTED');
    const sortByObjectFromState = JSON.stringify(sortByFromState[0]);
    const sortByObjectFromLocalStorage = window.localStorage.getItem(localStorageSortByKey);
    if (sortByObjectFromState && sortByObjectFromState !== sortByObjectFromLocalStorage) window.localStorage.setItem(localStorageSortByKey, sortByObjectFromState);
};
const $8a9497a467328348$export$e823a7abff417acd = (localStorageSortByKey)=>{
    const savedSortByObject = window.localStorage.getItem(localStorageSortByKey);
    if (savedSortByObject === 'NOT_SORTED') return [];
    if (savedSortByObject) return [
        JSON.parse(savedSortByObject)
    ];
    return null;
};


const $518116b4be6dce8c$export$47e71af91d14c08f = 'overviewSortBy';
const $518116b4be6dce8c$var$tablePaginationWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    justifyContent: 'flex-end',
    flexDirection: 'column',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        flexDirection: 'row'
    }
});
const $518116b4be6dce8c$var$pageIndexButtonsWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexWrap: 'wrap',
    margin: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`
});
const $518116b4be6dce8c$var$tableRowStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.ligthBlue10
    }
});
const $518116b4be6dce8c$var$pageSizeSelectorContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'center',
    width: 200,
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $518116b4be6dce8c$var$pagerContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $518116b4be6dce8c$var$pageSizeSelectorTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1
});
const $518116b4be6dce8c$var$selectWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    flexGrow: 1
});
const $518116b4be6dce8c$var$emptyTableText = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    textAlign: 'center'
});
const $518116b4be6dce8c$export$264985b2d12e0d09 = ({ overviewTableData: overviewTableData, columns: columns, rowClick: rowClick, pageSizes: pageSizes })=>{
    const defaultSortByArray = [
        {
            id: 'status',
            desc: false
        }
    ];
    const sortByFromLocalStorage = (0, $denZA.useMemo)(()=>(0, $8a9497a467328348$export$e823a7abff417acd)($518116b4be6dce8c$export$47e71af91d14c08f), []);
    const { getTableProps: getTableProps, getTableBodyProps: getTableBodyProps, headerGroups: headerGroups, prepareRow: prepareRow, page: page, canPreviousPage: canPreviousPage, canNextPage: canNextPage, pageOptions: pageOptions, gotoPage: gotoPage, nextPage: nextPage, previousPage: previousPage, setPageSize: setPageSize, state: { pageIndex: pageIndex, pageSize: pageSize } } = (0, $81513bc3741e8bd2$exports.useTable)({
        columns: columns,
        data: overviewTableData,
        initialState: {
            pageIndex: 0,
            pageSize: (0, $8a9497a467328348$export$1e3011a62dab913a)(overviewTableData.length),
            sortBy: sortByFromLocalStorage || defaultSortByArray
        },
        useControlledState: (state)=>{
            const { sortBy: sortByFromState } = state;
            (0, $8a9497a467328348$export$653d991678529bd7)(sortByFromState, $518116b4be6dce8c$export$47e71af91d14c08f);
            return state;
        },
        autoResetSortBy: false
    }, (0, $81513bc3741e8bd2$exports.useSortBy), (0, $81513bc3741e8bd2$exports.usePagination));
    const getRowProps = (row)=>({
            onClick: rowClick ? ()=>rowClick(row.original) : ()=>{},
            css: $518116b4be6dce8c$var$tableRowStyle
        });
    if (!overviewTableData.length) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        css: $518116b4be6dce8c$var$emptyTableText,
        children: "There are no results with your applied filters."
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("table", {
                css: (0, $5505343c4d5bfadb$export$a8a28302b48950e6),
                ...getTableProps(),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("thead", {
                        children: headerGroups.map((headerGroup, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tr", {
                                ...headerGroup.getHeaderGroupProps(),
                                children: headerGroup.headers.map((column, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("th", {
                                        css: (0, $5505343c4d5bfadb$export$aa70f7bbadb680f2),
                                        ...column.getHeaderProps(column.getSortByToggleProps({
                                            title: undefined
                                        }) // remove default title tooltip
                                        ),
                                        children: column.render('Header', {
                                            column: column
                                        })
                                    }, `tableheader${index}`))
                            }, `tableheadergroup${index}`))
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tbody", {
                        ...getTableBodyProps(),
                        children: page.map((row, i)=>{
                            prepareRow(row);
                            return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tr", {
                                ...row.getRowProps(getRowProps(row)),
                                children: row.cells.map((cell, index)=>{
                                    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("td", {
                                        css: (0, $5505343c4d5bfadb$export$15c518144f297303),
                                        ...cell.getCellProps(),
                                        children: cell.render('Cell')
                                    }, `tablecell${index}`);
                                })
                            }, `tablerow${i}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $518116b4be6dce8c$var$tablePaginationWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $518116b4be6dce8c$var$pageSizeSelectorContainerStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $518116b4be6dce8c$var$pageSizeSelectorTextStyle,
                                children: "Rows per page: "
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: $518116b4be6dce8c$var$selectWrapperStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b0179fea72139c21$export$ef9b1a59e592288f), {
                                    value: pageSize,
                                    onSelect: setPageSize,
                                    children: pageSizes.map((pageSize)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $108abcf98aa8bc43$export$617cca870742ea6e), {
                                            label: String(pageSize),
                                            value: pageSize
                                        }, pageSize))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $518116b4be6dce8c$var$pagerContainerStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $2afa648b8e417cf2$export$ea9a5c7ec18f8eaf), {}),
                                size: "small",
                                variant: "ghost",
                                disabled: !canPreviousPage,
                                onClick: ()=>previousPage()
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: $518116b4be6dce8c$var$pageIndexButtonsWrapperStyle,
                                children: pageOptions.map((pageOptionIndex)=>{
                                    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                        label: pageOptionIndex + 1,
                                        variant: "ghost",
                                        size: "small",
                                        state: pageOptionIndex === pageIndex && 'hover',
                                        onClick: ()=>gotoPage(pageOptionIndex)
                                    }, `pagerButtonPage${pageOptionIndex}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c3105185e735c6e9$export$d6d021d74f4bac76), {}),
                                size: "small",
                                variant: "ghost",
                                disabled: !canNextPage,
                                onClick: ()=>nextPage()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$518116b4be6dce8c$export$264985b2d12e0d09.propTypes = {
    overviewTableData: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).array.isRequired,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).array.isRequired,
    rowClick: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    pageSizes: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number).isRequired
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");


var $56b6fd384c7a9f90$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($56b6fd384c7a9f90$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $56b6fd384c7a9f90$exports = g;
});


/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $dluwd = parcelRequire("dluwd");
var $f0c1d849407dfccd$require$Buffer = $dluwd.Buffer;
var $f0c1d849407dfccd$var$XLSX = {};
$f0c1d849407dfccd$var$XLSX.version = '0.20.3';
var $f0c1d849407dfccd$var$current_codepage = 1200, $f0c1d849407dfccd$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $f0c1d849407dfccd$var$$cptable;
var $f0c1d849407dfccd$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $f0c1d849407dfccd$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $f0c1d849407dfccd$var$set_ansi = function(cp /*:number*/ ) {
    if ($f0c1d849407dfccd$var$VALID_ANSI.indexOf(cp) == -1) return;
    $f0c1d849407dfccd$var$current_ansi = $f0c1d849407dfccd$var$CS2CP[0] = cp;
};
function $f0c1d849407dfccd$var$reset_ansi() {
    $f0c1d849407dfccd$var$set_ansi(1252);
}
var $f0c1d849407dfccd$var$set_cp = function(cp /*:number*/ ) {
    $f0c1d849407dfccd$var$current_codepage = cp;
    $f0c1d849407dfccd$var$set_ansi(cp);
};
function $f0c1d849407dfccd$var$reset_cp() {
    $f0c1d849407dfccd$var$set_cp(1200);
    $f0c1d849407dfccd$var$reset_ansi();
}
function $f0c1d849407dfccd$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $f0c1d849407dfccd$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $f0c1d849407dfccd$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $f0c1d849407dfccd$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $f0c1d849407dfccd$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $f0c1d849407dfccd$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $f0c1d849407dfccd$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $f0c1d849407dfccd$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $f0c1d849407dfccd$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $f0c1d849407dfccd$export$58f247d16f363b86(cptable) {
    $f0c1d849407dfccd$var$$cptable = cptable;
    $f0c1d849407dfccd$var$set_cp = function(cp /*:number*/ ) {
        $f0c1d849407dfccd$var$current_codepage = cp;
        $f0c1d849407dfccd$var$set_ansi(cp);
    };
    $f0c1d849407dfccd$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $f0c1d849407dfccd$var$$cptable.utils.decode(1200, $f0c1d849407dfccd$var$char_codes(data.slice(2)));
        return data;
    };
    $f0c1d849407dfccd$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($f0c1d849407dfccd$var$current_codepage === 1200) return String.fromCharCode(x);
        return $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $f0c1d849407dfccd$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_ansi, [
            x
        ])[0];
    };
    $f0c1d849407dfccd$var$cpdoit();
}
var $f0c1d849407dfccd$var$DENSE = null;
var $f0c1d849407dfccd$var$DIF_XL = true;
var $f0c1d849407dfccd$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $f0c1d849407dfccd$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $f0c1d849407dfccd$var$Base64_map.charAt(e1) + $f0c1d849407dfccd$var$Base64_map.charAt(e2) + $f0c1d849407dfccd$var$Base64_map.charAt(e3) + $f0c1d849407dfccd$var$Base64_map.charAt(e4);
    }
    return o;
}
function $f0c1d849407dfccd$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $f0c1d849407dfccd$var$Base64_map.charAt(e1) + $f0c1d849407dfccd$var$Base64_map.charAt(e2) + $f0c1d849407dfccd$var$Base64_map.charAt(e3) + $f0c1d849407dfccd$var$Base64_map.charAt(e4);
    }
    return o;
}
function $f0c1d849407dfccd$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $f0c1d849407dfccd$var$Base64_map.charAt(e1) + $f0c1d849407dfccd$var$Base64_map.charAt(e2) + $f0c1d849407dfccd$var$Base64_map.charAt(e3) + $f0c1d849407dfccd$var$Base64_map.charAt(e4);
    }
    return o;
}
function $f0c1d849407dfccd$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $f0c1d849407dfccd$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $f0c1d849407dfccd$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $f0c1d849407dfccd$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $f0c1d849407dfccd$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $f0c1d849407dfccd$var$has_buf = /*#__PURE__*/ function() {
    return typeof $f0c1d849407dfccd$require$Buffer !== 'undefined' && false;
}();
var $f0c1d849407dfccd$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $f0c1d849407dfccd$require$Buffer !== 'undefined') {
        var nbfs = !$f0c1d849407dfccd$require$Buffer.from;
        if (!nbfs) try {
            $f0c1d849407dfccd$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $f0c1d849407dfccd$require$Buffer(buf, enc) : new $f0c1d849407dfccd$require$Buffer(buf);
        } : $f0c1d849407dfccd$require$Buffer.from.bind($f0c1d849407dfccd$require$Buffer);
    }
    return function() {};
}();
var $f0c1d849407dfccd$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $f0c1d849407dfccd$require$Buffer === 'undefined') return false;
    var x = $f0c1d849407dfccd$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $f0c1d849407dfccd$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$require$Buffer.alloc ? $f0c1d849407dfccd$require$Buffer.alloc(len) : new $f0c1d849407dfccd$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $f0c1d849407dfccd$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$require$Buffer.allocUnsafe ? $f0c1d849407dfccd$require$Buffer.allocUnsafe(len) : new $f0c1d849407dfccd$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $f0c1d849407dfccd$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $f0c1d849407dfccd$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $f0c1d849407dfccd$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $f0c1d849407dfccd$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $f0c1d849407dfccd$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $f0c1d849407dfccd$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $f0c1d849407dfccd$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $f0c1d849407dfccd$var$bconcat = $f0c1d849407dfccd$var$has_buf ? function(bufs) {
    return $f0c1d849407dfccd$require$Buffer.concat(bufs.map(function(buf) {
        return $f0c1d849407dfccd$require$Buffer.isBuffer(buf) ? buf : $f0c1d849407dfccd$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($f0c1d849407dfccd$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $f0c1d849407dfccd$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $f0c1d849407dfccd$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $f0c1d849407dfccd$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $f0c1d849407dfccd$var$bconcat(out);
}
var $f0c1d849407dfccd$var$chr0 = /\u0000/g, $f0c1d849407dfccd$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $f0c1d849407dfccd$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $f0c1d849407dfccd$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $f0c1d849407dfccd$var$fill('0', d - t.length) + t;
}
function $f0c1d849407dfccd$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $f0c1d849407dfccd$var$fill(' ', d - t.length) + t;
}
function $f0c1d849407dfccd$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $f0c1d849407dfccd$var$fill(' ', d - t.length);
}
function $f0c1d849407dfccd$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $f0c1d849407dfccd$var$fill('0', d - t.length) + t;
}
function $f0c1d849407dfccd$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $f0c1d849407dfccd$var$fill('0', d - t.length) + t;
}
var $f0c1d849407dfccd$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $f0c1d849407dfccd$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $f0c1d849407dfccd$var$p2_32 || v < -$f0c1d849407dfccd$var$p2_32) return $f0c1d849407dfccd$var$pad0r1(v, d);
    var i = Math.round(v);
    return $f0c1d849407dfccd$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $f0c1d849407dfccd$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $f0c1d849407dfccd$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $f0c1d849407dfccd$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $f0c1d849407dfccd$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $f0c1d849407dfccd$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $f0c1d849407dfccd$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $f0c1d849407dfccd$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $f0c1d849407dfccd$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $f0c1d849407dfccd$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $f0c1d849407dfccd$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $f0c1d849407dfccd$var$fill("0", s.length - 15);
    return Number(n);
}
function $f0c1d849407dfccd$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $f0c1d849407dfccd$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $f0c1d849407dfccd$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $f0c1d849407dfccd$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $f0c1d849407dfccd$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $f0c1d849407dfccd$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $f0c1d849407dfccd$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $f0c1d849407dfccd$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $f0c1d849407dfccd$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $f0c1d849407dfccd$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $f0c1d849407dfccd$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $f0c1d849407dfccd$var$SSF_large_exp(v);
    return $f0c1d849407dfccd$var$SSF_strip_decimal($f0c1d849407dfccd$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $f0c1d849407dfccd$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $f0c1d849407dfccd$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $f0c1d849407dfccd$var$SSF_format(14, $f0c1d849407dfccd$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $f0c1d849407dfccd$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $f0c1d849407dfccd$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $f0c1d849407dfccd$var$months[val1.m - 1][1];
                case 5:
                    return $f0c1d849407dfccd$var$months[val1.m - 1][0];
                default:
                    return $f0c1d849407dfccd$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $f0c1d849407dfccd$var$days[val1.q][0];
                default:
                    return $f0c1d849407dfccd$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $f0c1d849407dfccd$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $f0c1d849407dfccd$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $f0c1d849407dfccd$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $f0c1d849407dfccd$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $f0c1d849407dfccd$var$pct1 = /%/g;
function $f0c1d849407dfccd$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($f0c1d849407dfccd$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $f0c1d849407dfccd$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $f0c1d849407dfccd$var$fill("%", mul);
}
function $f0c1d849407dfccd$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $f0c1d849407dfccd$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $f0c1d849407dfccd$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $f0c1d849407dfccd$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $f0c1d849407dfccd$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $f0c1d849407dfccd$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $f0c1d849407dfccd$var$fill(" ", r[1].length + 1 + r[4].length) : $f0c1d849407dfccd$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $f0c1d849407dfccd$var$pad0(myd, r[4].length));
}
function $f0c1d849407dfccd$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $f0c1d849407dfccd$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $f0c1d849407dfccd$var$dec1 = /^#*0*\.([0#]+)/;
var $f0c1d849407dfccd$var$closeparen = /\)[^)]*[0#]/;
var $f0c1d849407dfccd$var$phone = /\(###\) ###\\?-####/;
function $f0c1d849407dfccd$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $f0c1d849407dfccd$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $f0c1d849407dfccd$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $f0c1d849407dfccd$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $f0c1d849407dfccd$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $f0c1d849407dfccd$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($f0c1d849407dfccd$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $f0c1d849407dfccd$var$write_num_flt('n', ffmt, val1);
        return '(' + $f0c1d849407dfccd$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $f0c1d849407dfccd$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $f0c1d849407dfccd$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $f0c1d849407dfccd$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $f0c1d849407dfccd$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $f0c1d849407dfccd$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $f0c1d849407dfccd$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $f0c1d849407dfccd$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($f0c1d849407dfccd$var$frac1)) return $f0c1d849407dfccd$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $f0c1d849407dfccd$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($f0c1d849407dfccd$var$dec1)) {
        o = $f0c1d849407dfccd$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $f0c1d849407dfccd$var$hashq(r[1])).replace(/\.$/, "." + $f0c1d849407dfccd$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $f0c1d849407dfccd$var$fill("0", $f0c1d849407dfccd$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $f0c1d849407dfccd$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $f0c1d849407dfccd$var$commaify($f0c1d849407dfccd$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $f0c1d849407dfccd$var$write_num_flt(type, fmt, -val1) : $f0c1d849407dfccd$var$commaify("" + (Math.floor(val1) + $f0c1d849407dfccd$var$carry(val1, r[1].length))) + "." + $f0c1d849407dfccd$var$pad0($f0c1d849407dfccd$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $f0c1d849407dfccd$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $f0c1d849407dfccd$var$_strrev($f0c1d849407dfccd$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $f0c1d849407dfccd$var$_strrev($f0c1d849407dfccd$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($f0c1d849407dfccd$var$phone)) {
        o = $f0c1d849407dfccd$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $f0c1d849407dfccd$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $f0c1d849407dfccd$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $f0c1d849407dfccd$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $f0c1d849407dfccd$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $f0c1d849407dfccd$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $f0c1d849407dfccd$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $f0c1d849407dfccd$var$rpad_(ff[2], ri) : $f0c1d849407dfccd$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $f0c1d849407dfccd$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $f0c1d849407dfccd$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $f0c1d849407dfccd$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $f0c1d849407dfccd$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $f0c1d849407dfccd$var$write_num_flt(type, fmt, -val1) : $f0c1d849407dfccd$var$commaify($f0c1d849407dfccd$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $f0c1d849407dfccd$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $f0c1d849407dfccd$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $f0c1d849407dfccd$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $f0c1d849407dfccd$var$commaify($f0c1d849407dfccd$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $f0c1d849407dfccd$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $f0c1d849407dfccd$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $f0c1d849407dfccd$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $f0c1d849407dfccd$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $f0c1d849407dfccd$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($f0c1d849407dfccd$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $f0c1d849407dfccd$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $f0c1d849407dfccd$var$fill("%", mul);
}
function $f0c1d849407dfccd$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $f0c1d849407dfccd$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $f0c1d849407dfccd$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($f0c1d849407dfccd$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $f0c1d849407dfccd$var$write_num_int('n', ffmt, val1);
        return '(' + $f0c1d849407dfccd$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $f0c1d849407dfccd$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $f0c1d849407dfccd$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $f0c1d849407dfccd$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $f0c1d849407dfccd$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $f0c1d849407dfccd$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $f0c1d849407dfccd$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($f0c1d849407dfccd$var$frac1)) return $f0c1d849407dfccd$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $f0c1d849407dfccd$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($f0c1d849407dfccd$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $f0c1d849407dfccd$var$hashq(r[1])).replace(/\.$/, "." + $f0c1d849407dfccd$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $f0c1d849407dfccd$var$fill("0", $f0c1d849407dfccd$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $f0c1d849407dfccd$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $f0c1d849407dfccd$var$write_num_int(type, fmt, -val1) : $f0c1d849407dfccd$var$commaify("" + val1) + "." + $f0c1d849407dfccd$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $f0c1d849407dfccd$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $f0c1d849407dfccd$var$_strrev($f0c1d849407dfccd$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $f0c1d849407dfccd$var$_strrev($f0c1d849407dfccd$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($f0c1d849407dfccd$var$phone)) {
        o = $f0c1d849407dfccd$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $f0c1d849407dfccd$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $f0c1d849407dfccd$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $f0c1d849407dfccd$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $f0c1d849407dfccd$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $f0c1d849407dfccd$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $f0c1d849407dfccd$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $f0c1d849407dfccd$var$rpad_(ff[2], ri) : $f0c1d849407dfccd$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $f0c1d849407dfccd$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $f0c1d849407dfccd$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $f0c1d849407dfccd$var$write_num_int(type, fmt, -val1) : $f0c1d849407dfccd$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $f0c1d849407dfccd$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $f0c1d849407dfccd$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $f0c1d849407dfccd$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $f0c1d849407dfccd$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $f0c1d849407dfccd$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $f0c1d849407dfccd$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $f0c1d849407dfccd$var$write_num_int(type, fmt, val1) : $f0c1d849407dfccd$var$write_num_flt(type, fmt, val1);
}
function $f0c1d849407dfccd$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $f0c1d849407dfccd$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $f0c1d849407dfccd$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($f0c1d849407dfccd$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($f0c1d849407dfccd$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $f0c1d849407dfccd$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$f0c1d849407dfccd$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $f0c1d849407dfccd$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $f0c1d849407dfccd$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $f0c1d849407dfccd$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($f0c1d849407dfccd$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $f0c1d849407dfccd$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$f0c1d849407dfccd$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $f0c1d849407dfccd$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $f0c1d849407dfccd$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $f0c1d849407dfccd$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $f0c1d849407dfccd$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $f0c1d849407dfccd$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $f0c1d849407dfccd$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $f0c1d849407dfccd$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $f0c1d849407dfccd$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $f0c1d849407dfccd$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $f0c1d849407dfccd$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $f0c1d849407dfccd$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($f0c1d849407dfccd$var$cfregex2);
        var m2 = fmt[1].match($f0c1d849407dfccd$var$cfregex2);
        return $f0c1d849407dfccd$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $f0c1d849407dfccd$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $f0c1d849407dfccd$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $f0c1d849407dfccd$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$f0c1d849407dfccd$var$SSF_default_map[fmt]] || $f0c1d849407dfccd$var$table_fmt[$f0c1d849407dfccd$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $f0c1d849407dfccd$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($f0c1d849407dfccd$var$SSF_isgeneral(sfmt, 0)) return $f0c1d849407dfccd$var$SSF_general(v, o);
    if (v instanceof Date) v = $f0c1d849407dfccd$var$datenum(v, o.date1904);
    var f = $f0c1d849407dfccd$var$choose_fmt(sfmt, v);
    if ($f0c1d849407dfccd$var$SSF_isgeneral(f[1])) return $f0c1d849407dfccd$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $f0c1d849407dfccd$var$eval_fmt(f[1], v, o, f[0]);
}
function $f0c1d849407dfccd$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($f0c1d849407dfccd$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($f0c1d849407dfccd$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $f0c1d849407dfccd$var$table_fmt[idx] = fmt;
    return idx;
}
function $f0c1d849407dfccd$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $f0c1d849407dfccd$var$SSF_load(tbl[i], i);
}
function $f0c1d849407dfccd$var$make_ssf() {
    $f0c1d849407dfccd$var$table_fmt = $f0c1d849407dfccd$var$SSF_init_table();
}
var $f0c1d849407dfccd$export$40d8edd678456c2b = {
    format: $f0c1d849407dfccd$var$SSF_format,
    load: $f0c1d849407dfccd$var$SSF_load,
    _table: $f0c1d849407dfccd$var$table_fmt,
    load_table: $f0c1d849407dfccd$var$SSF_load_table,
    parse_date_code: $f0c1d849407dfccd$var$SSF_parse_date_code,
    is_date: $f0c1d849407dfccd$var$fmt_is_date,
    get_table: function get_table() {
        return $f0c1d849407dfccd$export$40d8edd678456c2b._table = $f0c1d849407dfccd$var$table_fmt;
    }
};
var $f0c1d849407dfccd$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $f0c1d849407dfccd$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $f0c1d849407dfccd$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $f0c1d849407dfccd$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($f0c1d849407dfccd$var$dateNFregex, "(\\d+)");
    $f0c1d849407dfccd$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $f0c1d849407dfccd$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($f0c1d849407dfccd$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $f0c1d849407dfccd$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $f0c1d849407dfccd$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $f0c1d849407dfccd$var$SSF__load(fmt, idx) {
    return $f0c1d849407dfccd$var$SSF_load($f0c1d849407dfccd$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $f0c1d849407dfccd$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $f0c1d849407dfccd$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $f0c1d849407dfccd$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $f0c1d849407dfccd$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $f0c1d849407dfccd$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $f0c1d849407dfccd$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $f0c1d849407dfccd$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $f0c1d849407dfccd$var$new_buf(0);
        return $f0c1d849407dfccd$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $f0c1d849407dfccd$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($f0c1d849407dfccd$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $f0c1d849407dfccd$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $f0c1d849407dfccd$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $f0c1d849407dfccd$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $f0c1d849407dfccd$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $f0c1d849407dfccd$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $f0c1d849407dfccd$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $f0c1d849407dfccd$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($f0c1d849407dfccd$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $f0c1d849407dfccd$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($f0c1d849407dfccd$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $f0c1d849407dfccd$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $f0c1d849407dfccd$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($f0c1d849407dfccd$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($f0c1d849407dfccd$var$chr1);
        UCPath = UCPath.replace($f0c1d849407dfccd$var$chr0, '');
        if (m) UCPath = UCPath.replace($f0c1d849407dfccd$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($f0c1d849407dfccd$var$chr1, '!') : UCFullPaths[w]).replace($f0c1d849407dfccd$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($f0c1d849407dfccd$var$chr1, '!') : UCPaths[w]).replace($f0c1d849407dfccd$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $f0c1d849407dfccd$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$require$Buffer.isBuffer(o) ? o : $f0c1d849407dfccd$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $f0c1d849407dfccd$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($f0c1d849407dfccd$var$has_buf) {
            var o = $f0c1d849407dfccd$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $f0c1d849407dfccd$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $f0c1d849407dfccd$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $f0c1d849407dfccd$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $f0c1d849407dfccd$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $f0c1d849407dfccd$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $f0c1d849407dfccd$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $f0c1d849407dfccd$var$CRC32.bstr(fi.content, 0) : $f0c1d849407dfccd$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $f0c1d849407dfccd$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $f0c1d849407dfccd$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $f0c1d849407dfccd$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $f0c1d849407dfccd$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $f0c1d849407dfccd$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $f0c1d849407dfccd$var$bconcat([
            $f0c1d849407dfccd$var$bconcat(out /*:any*/ ),
            $f0c1d849407dfccd$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $f0c1d849407dfccd$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $f0c1d849407dfccd$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $f0c1d849407dfccd$var$ReadShift,
        CheckField: $f0c1d849407dfccd$var$CheckField,
        prep_blob: $f0c1d849407dfccd$var$prep_blob,
        bconcat: $f0c1d849407dfccd$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $f0c1d849407dfccd$var$_fs;
function $f0c1d849407dfccd$export$a48eb669e1768bcf(fs) {
    $f0c1d849407dfccd$var$_fs = fs;
}
/* normalize data for blob ctor */ function $f0c1d849407dfccd$var$blobify(data) {
    if (typeof data === "string") return $f0c1d849407dfccd$var$s2ab(data);
    if (Array.isArray(data)) return $f0c1d849407dfccd$var$a2u(data);
    return data;
}
/* write or download file */ function $f0c1d849407dfccd$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $f0c1d849407dfccd$var$_fs !== 'undefined' && $f0c1d849407dfccd$var$_fs.writeFileSync) return enc ? $f0c1d849407dfccd$var$_fs.writeFileSync(fname, payload, enc) : $f0c1d849407dfccd$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $f0c1d849407dfccd$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $f0c1d849407dfccd$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $f0c1d849407dfccd$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $f0c1d849407dfccd$var$Base64_encode_arr(new Uint8Array($f0c1d849407dfccd$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $f0c1d849407dfccd$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $f0c1d849407dfccd$var$read_binary(path /*:string*/ ) {
    if (typeof $f0c1d849407dfccd$var$_fs !== 'undefined') return $f0c1d849407dfccd$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $f0c1d849407dfccd$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $f0c1d849407dfccd$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $f0c1d849407dfccd$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $f0c1d849407dfccd$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $f0c1d849407dfccd$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $f0c1d849407dfccd$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $f0c1d849407dfccd$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $f0c1d849407dfccd$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $f0c1d849407dfccd$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $f0c1d849407dfccd$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $f0c1d849407dfccd$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $f0c1d849407dfccd$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $f0c1d849407dfccd$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $f0c1d849407dfccd$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $f0c1d849407dfccd$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $f0c1d849407dfccd$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $f0c1d849407dfccd$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $f0c1d849407dfccd$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $f0c1d849407dfccd$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $f0c1d849407dfccd$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $f0c1d849407dfccd$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($f0c1d849407dfccd$var$pdre1);
    if (m) return new Date((date1904 ? $f0c1d849407dfccd$var$dnthresh2 : $f0c1d849407dfccd$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($f0c1d849407dfccd$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($f0c1d849407dfccd$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $f0c1d849407dfccd$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(arr)) {
        if (debomit && $f0c1d849407dfccd$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $f0c1d849407dfccd$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $f0c1d849407dfccd$var$utf8write($f0c1d849407dfccd$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $f0c1d849407dfccd$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $f0c1d849407dfccd$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $f0c1d849407dfccd$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $f0c1d849407dfccd$var$dup(o[k]);
    return out;
}
function $f0c1d849407dfccd$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $f0c1d849407dfccd$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $f0c1d849407dfccd$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $f0c1d849407dfccd$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $f0c1d849407dfccd$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $f0c1d849407dfccd$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $f0c1d849407dfccd$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $f0c1d849407dfccd$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $f0c1d849407dfccd$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $f0c1d849407dfccd$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($f0c1d849407dfccd$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $f0c1d849407dfccd$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($f0c1d849407dfccd$var$FDRE1);
    if (M) return $f0c1d849407dfccd$var$fuzzytime1(M);
    M = lnos.match($f0c1d849407dfccd$var$FDRE2);
    if (M) return $f0c1d849407dfccd$var$fuzzytime2(M);
    M = lnos.match($f0c1d849407dfccd$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($f0c1d849407dfccd$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $f0c1d849407dfccd$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $f0c1d849407dfccd$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $f0c1d849407dfccd$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $f0c1d849407dfccd$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $f0c1d849407dfccd$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $f0c1d849407dfccd$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $f0c1d849407dfccd$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $f0c1d849407dfccd$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $f0c1d849407dfccd$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$f0c1d849407dfccd$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $f0c1d849407dfccd$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $f0c1d849407dfccd$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $f0c1d849407dfccd$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $f0c1d849407dfccd$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $f0c1d849407dfccd$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $f0c1d849407dfccd$var$cc2str(data.content, true);
    if (data.data) return $f0c1d849407dfccd$var$debom(data.data);
    if (data.asNodeBuffer && $f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $f0c1d849407dfccd$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $f0c1d849407dfccd$var$debom($f0c1d849407dfccd$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $f0c1d849407dfccd$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $f0c1d849407dfccd$var$char_codes(data.data);
    if (data.asNodeBuffer && $f0c1d849407dfccd$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $f0c1d849407dfccd$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $f0c1d849407dfccd$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $f0c1d849407dfccd$var$getdatabin(data) : $f0c1d849407dfccd$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $f0c1d849407dfccd$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $f0c1d849407dfccd$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $f0c1d849407dfccd$var$getzipfile(zip, file /*:string*/ ) {
    var o = $f0c1d849407dfccd$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $f0c1d849407dfccd$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $f0c1d849407dfccd$var$getdata($f0c1d849407dfccd$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $f0c1d849407dfccd$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $f0c1d849407dfccd$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $f0c1d849407dfccd$var$getdatastr($f0c1d849407dfccd$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $f0c1d849407dfccd$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $f0c1d849407dfccd$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $f0c1d849407dfccd$var$getdatabin($f0c1d849407dfccd$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $f0c1d849407dfccd$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $f0c1d849407dfccd$var$zipentries(zip) {
    var k = zip.FullPaths || $f0c1d849407dfccd$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $f0c1d849407dfccd$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($f0c1d849407dfccd$var$has_buf) res = $f0c1d849407dfccd$var$Buffer_from(content);
            else res = $f0c1d849407dfccd$var$utf8decode(content);
            return $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $f0c1d849407dfccd$var$zip_new() {
    return $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_new();
}
function $f0c1d849407dfccd$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $f0c1d849407dfccd$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $f0c1d849407dfccd$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $f0c1d849407dfccd$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $f0c1d849407dfccd$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $f0c1d849407dfccd$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $f0c1d849407dfccd$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $f0c1d849407dfccd$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $f0c1d849407dfccd$var$tagregex2 = /<[^<>]*>/g;
var $f0c1d849407dfccd$var$tagregex = /*#__PURE__*/ $f0c1d849407dfccd$var$XML_HEADER.match($f0c1d849407dfccd$var$tagregex1) ? $f0c1d849407dfccd$var$tagregex1 : $f0c1d849407dfccd$var$tagregex2;
var $f0c1d849407dfccd$var$nsregex = /<\w*:/, $f0c1d849407dfccd$var$nsregex2 = /<(\/?)\w+:/;
function $f0c1d849407dfccd$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($f0c1d849407dfccd$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $f0c1d849407dfccd$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($f0c1d849407dfccd$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $f0c1d849407dfccd$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($f0c1d849407dfccd$var$nsregex2, "<$1");
}
var $f0c1d849407dfccd$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $f0c1d849407dfccd$var$rencoding = /*#__PURE__*/ $f0c1d849407dfccd$var$evert($f0c1d849407dfccd$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $f0c1d849407dfccd$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $f0c1d849407dfccd$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $f0c1d849407dfccd$var$decregex = /[&<>'"]/g, $f0c1d849407dfccd$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $f0c1d849407dfccd$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($f0c1d849407dfccd$var$decregex, function(y) {
        return $f0c1d849407dfccd$var$rencoding[y];
    }).replace($f0c1d849407dfccd$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $f0c1d849407dfccd$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $f0c1d849407dfccd$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $f0c1d849407dfccd$var$htmlcharegex = /[\u0000-\u001f]/g;
function $f0c1d849407dfccd$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($f0c1d849407dfccd$var$decregex, function(y) {
        return $f0c1d849407dfccd$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($f0c1d849407dfccd$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $f0c1d849407dfccd$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($f0c1d849407dfccd$var$decregex, function(y) {
        return $f0c1d849407dfccd$var$rencoding[y];
    }).replace($f0c1d849407dfccd$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $f0c1d849407dfccd$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $f0c1d849407dfccd$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $f0c1d849407dfccd$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $f0c1d849407dfccd$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $f0c1d849407dfccd$var$utf8readb(data) {
    var out = $f0c1d849407dfccd$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $f0c1d849407dfccd$var$utf8readc(data) {
    return $f0c1d849407dfccd$var$Buffer_from(data, 'binary').toString('utf8');
}
var $f0c1d849407dfccd$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $f0c1d849407dfccd$var$utf8read = $f0c1d849407dfccd$var$has_buf && /*#__PURE__*/ ($f0c1d849407dfccd$var$utf8readc($f0c1d849407dfccd$var$utf8corpus) == /*#__PURE__*/ $f0c1d849407dfccd$var$utf8reada($f0c1d849407dfccd$var$utf8corpus) && $f0c1d849407dfccd$var$utf8readc || /*#__PURE__*/ $f0c1d849407dfccd$var$utf8readb($f0c1d849407dfccd$var$utf8corpus) == /*#__PURE__*/ $f0c1d849407dfccd$var$utf8reada($f0c1d849407dfccd$var$utf8corpus) && $f0c1d849407dfccd$var$utf8readb) || $f0c1d849407dfccd$var$utf8reada;
var $f0c1d849407dfccd$var$utf8write /*:StringConv*/  = $f0c1d849407dfccd$var$has_buf ? function(data) {
    return $f0c1d849407dfccd$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $f0c1d849407dfccd$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $f0c1d849407dfccd$var$vtvregex = /<\/?(?:vt:)?variant>/g, $f0c1d849407dfccd$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $f0c1d849407dfccd$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $f0c1d849407dfccd$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $f0c1d849407dfccd$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($f0c1d849407dfccd$var$vtvregex, "").match($f0c1d849407dfccd$var$vtmregex);
        if (v) res.push({
            v: $f0c1d849407dfccd$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $f0c1d849407dfccd$var$wtregex = /(^\s|\s$|\n)/;
function $f0c1d849407dfccd$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($f0c1d849407dfccd$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $f0c1d849407dfccd$var$wxt_helper(h) /*:string*/ {
    return $f0c1d849407dfccd$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $f0c1d849407dfccd$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $f0c1d849407dfccd$var$wxt_helper(h) : "") + (g != null ? (g.match($f0c1d849407dfccd$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $f0c1d849407dfccd$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $f0c1d849407dfccd$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $f0c1d849407dfccd$var$writextag('vt:lpwstr', $f0c1d849407dfccd$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $f0c1d849407dfccd$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $f0c1d849407dfccd$var$escapexml(String(s)));
        case 'boolean':
            return $f0c1d849407dfccd$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $f0c1d849407dfccd$var$writextag('vt:filetime', $f0c1d849407dfccd$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $f0c1d849407dfccd$var$xlml_normalize(d) /*:string*/ {
    if ($f0c1d849407dfccd$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $f0c1d849407dfccd$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $f0c1d849407dfccd$var$utf8read($f0c1d849407dfccd$var$a2s($f0c1d849407dfccd$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $f0c1d849407dfccd$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $f0c1d849407dfccd$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $f0c1d849407dfccd$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $f0c1d849407dfccd$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $f0c1d849407dfccd$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $f0c1d849407dfccd$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $f0c1d849407dfccd$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $f0c1d849407dfccd$var$__toBuffer = $f0c1d849407dfccd$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $f0c1d849407dfccd$require$Buffer.isBuffer(bufs[0][0]) ? $f0c1d849407dfccd$require$Buffer.concat(bufs[0].map(function(x) {
        return $f0c1d849407dfccd$require$Buffer.isBuffer(x) ? x : $f0c1d849407dfccd$var$Buffer_from(x);
    })) : $f0c1d849407dfccd$var$___toBuffer(bufs);
} : $f0c1d849407dfccd$var$___toBuffer;
var $f0c1d849407dfccd$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($f0c1d849407dfccd$var$__readUInt16LE(b, i)));
    return ss.join("").replace($f0c1d849407dfccd$var$chr0, '');
};
var $f0c1d849407dfccd$var$__utf16le = $f0c1d849407dfccd$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b) || !$f0c1d849407dfccd$var$buf_utf16le) return $f0c1d849407dfccd$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($f0c1d849407dfccd$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $f0c1d849407dfccd$var$___utf16le;
var $f0c1d849407dfccd$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $f0c1d849407dfccd$var$__hexlify = $f0c1d849407dfccd$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $f0c1d849407dfccd$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $f0c1d849407dfccd$var$___hexlify(b, s, l);
} : $f0c1d849407dfccd$var$___hexlify;
var $f0c1d849407dfccd$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($f0c1d849407dfccd$var$__readUInt8(b, i)));
    return ss.join("");
};
var $f0c1d849407dfccd$var$__utf8 = $f0c1d849407dfccd$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $f0c1d849407dfccd$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $f0c1d849407dfccd$var$___utf8(b, s, e);
} : $f0c1d849407dfccd$var$___utf8;
var $f0c1d849407dfccd$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
    return len > 0 ? $f0c1d849407dfccd$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $f0c1d849407dfccd$var$__lpstr = $f0c1d849407dfccd$var$___lpstr;
var $f0c1d849407dfccd$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
    return len > 0 ? $f0c1d849407dfccd$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $f0c1d849407dfccd$var$__cpstr = $f0c1d849407dfccd$var$___cpstr;
var $f0c1d849407dfccd$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $f0c1d849407dfccd$var$__readUInt32LE(b, i);
    return len > 0 ? $f0c1d849407dfccd$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $f0c1d849407dfccd$var$__lpwstr = $f0c1d849407dfccd$var$___lpwstr;
var $f0c1d849407dfccd$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
    return len > 0 ? $f0c1d849407dfccd$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $f0c1d849407dfccd$var$__lpp4 = $f0c1d849407dfccd$var$___lpp4;
var $f0c1d849407dfccd$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
    return len > 0 ? $f0c1d849407dfccd$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $f0c1d849407dfccd$var$__8lpp4 = $f0c1d849407dfccd$var$___8lpp4;
var $f0c1d849407dfccd$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $f0c1d849407dfccd$var$read_double_le(b, idx);
};
var $f0c1d849407dfccd$var$__double = $f0c1d849407dfccd$var$___double;
var $f0c1d849407dfccd$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($f0c1d849407dfccd$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $f0c1d849407dfccd$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b)) return $f0c1d849407dfccd$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $f0c1d849407dfccd$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b)) return $f0c1d849407dfccd$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $f0c1d849407dfccd$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b) || !$f0c1d849407dfccd$var$buf_utf16le) return $f0c1d849407dfccd$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $f0c1d849407dfccd$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b) || !$f0c1d849407dfccd$var$buf_utf16le) return $f0c1d849407dfccd$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $f0c1d849407dfccd$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$f0c1d849407dfccd$require$Buffer.isBuffer(b)) return $f0c1d849407dfccd$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $f0c1d849407dfccd$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($f0c1d849407dfccd$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $f0c1d849407dfccd$var$___double(b, i);
    };
    $f0c1d849407dfccd$var$is_buf = function is_buf_b(a) {
        return $f0c1d849407dfccd$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $f0c1d849407dfccd$var$cpdoit() {
    $f0c1d849407dfccd$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $f0c1d849407dfccd$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($f0c1d849407dfccd$var$chr0, '');
    };
    $f0c1d849407dfccd$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $f0c1d849407dfccd$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $f0c1d849407dfccd$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
        return len > 0 ? $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $f0c1d849407dfccd$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
        return len > 0 ? $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $f0c1d849407dfccd$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $f0c1d849407dfccd$var$__readUInt32LE(b, i);
        return len > 0 ? $f0c1d849407dfccd$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $f0c1d849407dfccd$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
        return len > 0 ? $f0c1d849407dfccd$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $f0c1d849407dfccd$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $f0c1d849407dfccd$var$__readUInt32LE(b, i);
        return len > 0 ? $f0c1d849407dfccd$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') $f0c1d849407dfccd$var$cpdoit();
var $f0c1d849407dfccd$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $f0c1d849407dfccd$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $f0c1d849407dfccd$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $f0c1d849407dfccd$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $f0c1d849407dfccd$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $f0c1d849407dfccd$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $f0c1d849407dfccd$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(this) && $f0c1d849407dfccd$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($f0c1d849407dfccd$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $f0c1d849407dfccd$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $f0c1d849407dfccd$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') o = $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $f0c1d849407dfccd$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $f0c1d849407dfccd$var$__lpstr(this, this.l);
            size = 4 + $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $f0c1d849407dfccd$var$__cpstr(this, this.l);
            size = 4 + $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $f0c1d849407dfccd$var$__lpwstr(this, this.l);
            size = 4 + 2 * $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
            o = $f0c1d849407dfccd$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
            o = $f0c1d849407dfccd$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $f0c1d849407dfccd$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($f0c1d849407dfccd$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $f0c1d849407dfccd$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($f0c1d849407dfccd$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $f0c1d849407dfccd$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $f0c1d849407dfccd$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($f0c1d849407dfccd$var$_getchar($f0c1d849407dfccd$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') {
                o = $f0c1d849407dfccd$var$$cptable.utils.decode($f0c1d849407dfccd$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $f0c1d849407dfccd$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $f0c1d849407dfccd$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($f0c1d849407dfccd$var$_getchar($f0c1d849407dfccd$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $f0c1d849407dfccd$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $f0c1d849407dfccd$var$__readInt16LE : $f0c1d849407dfccd$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $f0c1d849407dfccd$var$__readInt32LE : $f0c1d849407dfccd$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $f0c1d849407dfccd$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $f0c1d849407dfccd$var$__double(this, this.l);
                        else oR = $f0c1d849407dfccd$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $f0c1d849407dfccd$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $f0c1d849407dfccd$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $f0c1d849407dfccd$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $f0c1d849407dfccd$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $f0c1d849407dfccd$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$f0c1d849407dfccd$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined' && $f0c1d849407dfccd$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $f0c1d849407dfccd$var$$cptable.utils.encode($f0c1d849407dfccd$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $f0c1d849407dfccd$var$$cptable.utils.encode($f0c1d849407dfccd$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $f0c1d849407dfccd$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $f0c1d849407dfccd$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $f0c1d849407dfccd$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $f0c1d849407dfccd$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $f0c1d849407dfccd$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $f0c1d849407dfccd$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $f0c1d849407dfccd$var$ReadShift /*:: :any)*/ ;
    blob.chk = $f0c1d849407dfccd$var$CheckField;
    blob.write_shift = $f0c1d849407dfccd$var$WriteShift;
}
function $f0c1d849407dfccd$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $f0c1d849407dfccd$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $f0c1d849407dfccd$var$new_raw_buf(sz);
    $f0c1d849407dfccd$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $f0c1d849407dfccd$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $f0c1d849407dfccd$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $f0c1d849407dfccd$var$XLSBRecordEnum[RT] || $f0c1d849407dfccd$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $f0c1d849407dfccd$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $f0c1d849407dfccd$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $f0c1d849407dfccd$var$has_buf && typeof $f0c1d849407dfccd$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $f0c1d849407dfccd$var$new_buf(sz);
        $f0c1d849407dfccd$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $f0c1d849407dfccd$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $f0c1d849407dfccd$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $f0c1d849407dfccd$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $f0c1d849407dfccd$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $f0c1d849407dfccd$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $f0c1d849407dfccd$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $f0c1d849407dfccd$var$shift_range_xls(cell, range, opts) {
    var out = $f0c1d849407dfccd$var$dup(cell);
    out.s = $f0c1d849407dfccd$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $f0c1d849407dfccd$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $f0c1d849407dfccd$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $f0c1d849407dfccd$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $f0c1d849407dfccd$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $f0c1d849407dfccd$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $f0c1d849407dfccd$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $f0c1d849407dfccd$var$fix_row(s);
    return s;
}
function $f0c1d849407dfccd$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $f0c1d849407dfccd$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $f0c1d849407dfccd$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $f0c1d849407dfccd$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $f0c1d849407dfccd$var$encode_row(r.e.r);
    }
    return $f0c1d849407dfccd$var$encode_cell_xls(r.s, opts.biff) + ":" + $f0c1d849407dfccd$var$encode_cell_xls(r.e, opts.biff);
}
function $f0c1d849407dfccd$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($f0c1d849407dfccd$var$unfix_row(rowstr), 10) - 1;
}
function $f0c1d849407dfccd$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $f0c1d849407dfccd$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $f0c1d849407dfccd$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $f0c1d849407dfccd$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $f0c1d849407dfccd$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $f0c1d849407dfccd$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $f0c1d849407dfccd$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $f0c1d849407dfccd$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $f0c1d849407dfccd$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $f0c1d849407dfccd$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $f0c1d849407dfccd$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $f0c1d849407dfccd$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $f0c1d849407dfccd$var$decode_cell(range),
        e: $f0c1d849407dfccd$var$decode_cell(range)
    };
    return {
        s: $f0c1d849407dfccd$var$decode_cell(range.slice(0, idx)),
        e: $f0c1d849407dfccd$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $f0c1d849407dfccd$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $f0c1d849407dfccd$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $f0c1d849407dfccd$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $f0c1d849407dfccd$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $f0c1d849407dfccd$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $f0c1d849407dfccd$var$decode_range(a1);
    return "$" + $f0c1d849407dfccd$var$encode_col(s.s.c) + "$" + $f0c1d849407dfccd$var$encode_row(s.s.r) + ":$" + $f0c1d849407dfccd$var$encode_col(s.e.c) + "$" + $f0c1d849407dfccd$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $f0c1d849407dfccd$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $f0c1d849407dfccd$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $f0c1d849407dfccd$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $f0c1d849407dfccd$var$SSF_format(cell.z, q ? $f0c1d849407dfccd$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $f0c1d849407dfccd$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $f0c1d849407dfccd$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $f0c1d849407dfccd$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $f0c1d849407dfccd$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $f0c1d849407dfccd$var$safe_format_cell(cell, cell.v);
    return $f0c1d849407dfccd$var$safe_format_cell(cell, v);
}
function $f0c1d849407dfccd$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $f0c1d849407dfccd$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $f0c1d849407dfccd$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($f0c1d849407dfccd$var$DENSE != null && dense == null) dense = $f0c1d849407dfccd$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $f0c1d849407dfccd$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $f0c1d849407dfccd$var$table_fmt[14];
                    if (!o.UTC) cell.v = $f0c1d849407dfccd$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $f0c1d849407dfccd$var$SSF_format(cell.z, $f0c1d849407dfccd$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $f0c1d849407dfccd$var$datenum(cell.v, o.date1904);
                        cell.w = $f0c1d849407dfccd$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $f0c1d849407dfccd$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
    return ws;
}
function $f0c1d849407dfccd$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $f0c1d849407dfccd$var$sheet_add_aoa(null, data, opts);
}
function $f0c1d849407dfccd$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $f0c1d849407dfccd$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $f0c1d849407dfccd$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $f0c1d849407dfccd$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $f0c1d849407dfccd$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $f0c1d849407dfccd$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $f0c1d849407dfccd$var$write_StrRun(run, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $f0c1d849407dfccd$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $f0c1d849407dfccd$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($f0c1d849407dfccd$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $f0c1d849407dfccd$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $f0c1d849407dfccd$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $f0c1d849407dfccd$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $f0c1d849407dfccd$var$parse_BrtCommentText = $f0c1d849407dfccd$var$parse_RichStr;
function $f0c1d849407dfccd$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $f0c1d849407dfccd$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $f0c1d849407dfccd$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $f0c1d849407dfccd$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $f0c1d849407dfccd$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $f0c1d849407dfccd$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $f0c1d849407dfccd$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $f0c1d849407dfccd$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $f0c1d849407dfccd$var$parse_XLSBCodeName = $f0c1d849407dfccd$var$parse_XLWideString;
var $f0c1d849407dfccd$var$write_XLSBCodeName = $f0c1d849407dfccd$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $f0c1d849407dfccd$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $f0c1d849407dfccd$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $f0c1d849407dfccd$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $f0c1d849407dfccd$var$parse_XLNameWideString = $f0c1d849407dfccd$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $f0c1d849407dfccd$var$parse_RelID = $f0c1d849407dfccd$var$parse_XLNullableWideString;
var $f0c1d849407dfccd$var$write_RelID = $f0c1d849407dfccd$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $f0c1d849407dfccd$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $f0c1d849407dfccd$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $f0c1d849407dfccd$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $f0c1d849407dfccd$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $f0c1d849407dfccd$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $f0c1d849407dfccd$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $f0c1d849407dfccd$var$parse_UncheckedRfX = $f0c1d849407dfccd$var$parse_RfX;
var $f0c1d849407dfccd$var$write_UncheckedRfX = $f0c1d849407dfccd$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $f0c1d849407dfccd$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $f0c1d849407dfccd$var$write_Xnum(data, o) {
    return (o || $f0c1d849407dfccd$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $f0c1d849407dfccd$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $f0c1d849407dfccd$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $f0c1d849407dfccd$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $f0c1d849407dfccd$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $f0c1d849407dfccd$var$write_BrtColor(color, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $f0c1d849407dfccd$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $f0c1d849407dfccd$var$write_FontFlags(font, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $f0c1d849407dfccd$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $f0c1d849407dfccd$var$parse_ClipboardFormatOrAnsiString(o) {
    return $f0c1d849407dfccd$var$parse_ClipboardFormatOrString(o, 1);
}
function $f0c1d849407dfccd$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $f0c1d849407dfccd$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $f0c1d849407dfccd$var$VT_I2 = 0x0002;
var $f0c1d849407dfccd$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $f0c1d849407dfccd$var$VT_BOOL = 0x000B;
var $f0c1d849407dfccd$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $f0c1d849407dfccd$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $f0c1d849407dfccd$var$VT_FILETIME = 0x0040;
var $f0c1d849407dfccd$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $f0c1d849407dfccd$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $f0c1d849407dfccd$var$VT_VECTOR_VARIANT = 0x100C;
var $f0c1d849407dfccd$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $f0c1d849407dfccd$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $f0c1d849407dfccd$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $f0c1d849407dfccd$var$VT_CUSTOM = [
    $f0c1d849407dfccd$var$VT_STRING,
    $f0c1d849407dfccd$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $f0c1d849407dfccd$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $f0c1d849407dfccd$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $f0c1d849407dfccd$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $f0c1d849407dfccd$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $f0c1d849407dfccd$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $f0c1d849407dfccd$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $f0c1d849407dfccd$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $f0c1d849407dfccd$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $f0c1d849407dfccd$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $f0c1d849407dfccd$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $f0c1d849407dfccd$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $f0c1d849407dfccd$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $f0c1d849407dfccd$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $f0c1d849407dfccd$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $f0c1d849407dfccd$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $f0c1d849407dfccd$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $f0c1d849407dfccd$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $f0c1d849407dfccd$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $f0c1d849407dfccd$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $f0c1d849407dfccd$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $f0c1d849407dfccd$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $f0c1d849407dfccd$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $f0c1d849407dfccd$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $f0c1d849407dfccd$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $f0c1d849407dfccd$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $f0c1d849407dfccd$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $f0c1d849407dfccd$var$_XLSIcv = /*#__PURE__*/ $f0c1d849407dfccd$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $f0c1d849407dfccd$var$XLSIcv = /*#__PURE__*/ $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $f0c1d849407dfccd$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $f0c1d849407dfccd$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $f0c1d849407dfccd$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $f0c1d849407dfccd$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $f0c1d849407dfccd$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $f0c1d849407dfccd$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $f0c1d849407dfccd$var$parse_ct(data /*:?string*/ ) {
    var ct = $f0c1d849407dfccd$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch(y[0].replace($f0c1d849407dfccd$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$f0c1d849407dfccd$var$ct2type[y.ContentType]] !== undefined) ct[$f0c1d849407dfccd$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $f0c1d849407dfccd$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $f0c1d849407dfccd$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $f0c1d849407dfccd$var$evert_arr($f0c1d849407dfccd$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $f0c1d849407dfccd$var$XML_HEADER;
        o[o.length] = $f0c1d849407dfccd$var$writextag('Types', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS.CT,
            'xmlns:xsd': $f0c1d849407dfccd$var$XMLNS.xsd,
            'xmlns:xsi': $f0c1d849407dfccd$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $f0c1d849407dfccd$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $f0c1d849407dfccd$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $f0c1d849407dfccd$var$CT_LIST[w][opts.bookType] || $f0c1d849407dfccd$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $f0c1d849407dfccd$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $f0c1d849407dfccd$var$CT_LIST[w][opts.bookType] || $f0c1d849407dfccd$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $f0c1d849407dfccd$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $f0c1d849407dfccd$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $f0c1d849407dfccd$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $f0c1d849407dfccd$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $f0c1d849407dfccd$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $f0c1d849407dfccd$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $f0c1d849407dfccd$var$write_rels(rels) /*:string*/ {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $f0c1d849407dfccd$var$XMLNS.RELS
        })
    ];
    $f0c1d849407dfccd$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $f0c1d849407dfccd$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $f0c1d849407dfccd$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $f0c1d849407dfccd$var$RELS.HLINK,
        $f0c1d849407dfccd$var$RELS.XPATH,
        $f0c1d849407dfccd$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $f0c1d849407dfccd$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $f0c1d849407dfccd$var$parse_manifest(d, opts) {
    var str = $f0c1d849407dfccd$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $f0c1d849407dfccd$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $f0c1d849407dfccd$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $f0c1d849407dfccd$var$write_manifest(manifest) {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $f0c1d849407dfccd$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $f0c1d849407dfccd$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $f0c1d849407dfccd$var$write_rdf(rdf) {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($f0c1d849407dfccd$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($f0c1d849407dfccd$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($f0c1d849407dfccd$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $f0c1d849407dfccd$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $f0c1d849407dfccd$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $f0c1d849407dfccd$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $f0c1d849407dfccd$var$parse_core_props(data) {
    var p = {};
    data = $f0c1d849407dfccd$var$utf8read(data);
    for(var i = 0; i < $f0c1d849407dfccd$var$CORE_PROPS.length; ++i){
        var f = $f0c1d849407dfccd$var$CORE_PROPS[i], cur = $f0c1d849407dfccd$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $f0c1d849407dfccd$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $f0c1d849407dfccd$var$parseDate(p[f[1]]);
    }
    return p;
}
function $f0c1d849407dfccd$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $f0c1d849407dfccd$var$escapexml(g);
    o[o.length] = h ? $f0c1d849407dfccd$var$writextag(f, g, h) : $f0c1d849407dfccd$var$writetag(f, g);
}
function $f0c1d849407dfccd$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $f0c1d849407dfccd$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $f0c1d849407dfccd$var$XMLNS.dc,
            'xmlns:dcterms': $f0c1d849407dfccd$var$XMLNS.dcterms,
            'xmlns:dcmitype': $f0c1d849407dfccd$var$XMLNS.dcmitype,
            'xmlns:xsi': $f0c1d849407dfccd$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $f0c1d849407dfccd$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $f0c1d849407dfccd$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $f0c1d849407dfccd$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $f0c1d849407dfccd$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $f0c1d849407dfccd$var$CORE_PROPS.length; ++i){
        var f = $f0c1d849407dfccd$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $f0c1d849407dfccd$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $f0c1d849407dfccd$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $f0c1d849407dfccd$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $f0c1d849407dfccd$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $f0c1d849407dfccd$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $f0c1d849407dfccd$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $f0c1d849407dfccd$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $f0c1d849407dfccd$var$utf8read(data);
    $f0c1d849407dfccd$var$EXT_PROPS.forEach(function(f) {
        var xml = ($f0c1d849407dfccd$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $f0c1d849407dfccd$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $f0c1d849407dfccd$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $f0c1d849407dfccd$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $f0c1d849407dfccd$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $f0c1d849407dfccd$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $f0c1d849407dfccd$var$XML_HEADER;
    o[o.length] = $f0c1d849407dfccd$var$writextag('Properties', null, {
        'xmlns': $f0c1d849407dfccd$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $f0c1d849407dfccd$var$XMLNS.vt
    });
    $f0c1d849407dfccd$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $f0c1d849407dfccd$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $f0c1d849407dfccd$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $f0c1d849407dfccd$var$custregex = /<[^<>]+>[^<]*/g;
function $f0c1d849407dfccd$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($f0c1d849407dfccd$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $f0c1d849407dfccd$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $f0c1d849407dfccd$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $f0c1d849407dfccd$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $f0c1d849407dfccd$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $f0c1d849407dfccd$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $f0c1d849407dfccd$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('Properties', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $f0c1d849407dfccd$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $f0c1d849407dfccd$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $f0c1d849407dfccd$var$writextag('property', $f0c1d849407dfccd$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $f0c1d849407dfccd$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $f0c1d849407dfccd$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $f0c1d849407dfccd$var$evert_XLMLDPM;
function $f0c1d849407dfccd$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$f0c1d849407dfccd$var$evert_XLMLDPM) $f0c1d849407dfccd$var$evert_XLMLDPM = $f0c1d849407dfccd$var$evert($f0c1d849407dfccd$var$XLMLDocPropsMap);
    tag = $f0c1d849407dfccd$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $f0c1d849407dfccd$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $f0c1d849407dfccd$var$keys($f0c1d849407dfccd$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $f0c1d849407dfccd$var$CORE_PROPS.length; ++i)if ($f0c1d849407dfccd$var$CORE_PROPS[i][1] == m) return $f0c1d849407dfccd$var$CORE_PROPS[i];
        for(i = 0; i < $f0c1d849407dfccd$var$EXT_PROPS.length; ++i)if ($f0c1d849407dfccd$var$EXT_PROPS[i][1] == m) return $f0c1d849407dfccd$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($f0c1d849407dfccd$var$writetag($f0c1d849407dfccd$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $f0c1d849407dfccd$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $f0c1d849407dfccd$var$XLMLNS.o
    });
}
function $f0c1d849407dfccd$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $f0c1d849407dfccd$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $f0c1d849407dfccd$var$CORE_PROPS.length; ++i)if (k == $f0c1d849407dfccd$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $f0c1d849407dfccd$var$EXT_PROPS.length; ++i)if (k == $f0c1d849407dfccd$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($f0c1d849407dfccd$var$writextag($f0c1d849407dfccd$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $f0c1d849407dfccd$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($f0c1d849407dfccd$var$writextag($f0c1d849407dfccd$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $f0c1d849407dfccd$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $f0c1d849407dfccd$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $f0c1d849407dfccd$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $f0c1d849407dfccd$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $f0c1d849407dfccd$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $f0c1d849407dfccd$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $f0c1d849407dfccd$var$parse_lpwstr(blob);
    return $f0c1d849407dfccd$var$parse_lpstr(blob, stringType, pad);
}
function $f0c1d849407dfccd$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $f0c1d849407dfccd$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $f0c1d849407dfccd$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $f0c1d849407dfccd$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $f0c1d849407dfccd$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($f0c1d849407dfccd$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $f0c1d849407dfccd$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($f0c1d849407dfccd$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $f0c1d849407dfccd$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $f0c1d849407dfccd$var$parse_TypedPropertyValue(blob, $f0c1d849407dfccd$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $f0c1d849407dfccd$var$parse_TypedPropertyValue(blob, $f0c1d849407dfccd$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $f0c1d849407dfccd$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($f0c1d849407dfccd$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $f0c1d849407dfccd$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($f0c1d849407dfccd$var$chr0, '').replace($f0c1d849407dfccd$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $f0c1d849407dfccd$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $f0c1d849407dfccd$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $f0c1d849407dfccd$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $f0c1d849407dfccd$var$VT_VARIANT) {
        if (t !== type && $f0c1d849407dfccd$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $f0c1d849407dfccd$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $f0c1d849407dfccd$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $f0c1d849407dfccd$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $f0c1d849407dfccd$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $f0c1d849407dfccd$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $f0c1d849407dfccd$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $f0c1d849407dfccd$var$parse_VtString(blob, t, !opts.raw).replace($f0c1d849407dfccd$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $f0c1d849407dfccd$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($f0c1d849407dfccd$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $f0c1d849407dfccd$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $f0c1d849407dfccd$var$parse_VtVecLpwstrValue(blob) : $f0c1d849407dfccd$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $f0c1d849407dfccd$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $f0c1d849407dfccd$var$new_buf(4), p = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $f0c1d849407dfccd$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $f0c1d849407dfccd$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $f0c1d849407dfccd$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $f0c1d849407dfccd$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $f0c1d849407dfccd$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $f0c1d849407dfccd$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $f0c1d849407dfccd$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $f0c1d849407dfccd$var$parse_TypedPropertyValue(blob, $f0c1d849407dfccd$var$VT_I2);
                $f0c1d849407dfccd$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $f0c1d849407dfccd$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $f0c1d849407dfccd$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $f0c1d849407dfccd$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $f0c1d849407dfccd$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $f0c1d849407dfccd$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $f0c1d849407dfccd$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $f0c1d849407dfccd$var$parseDate($f0c1d849407dfccd$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $f0c1d849407dfccd$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $f0c1d849407dfccd$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $f0c1d849407dfccd$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $f0c1d849407dfccd$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $f0c1d849407dfccd$var$new_buf(8), pio = $f0c1d849407dfccd$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $f0c1d849407dfccd$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $f0c1d849407dfccd$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $f0c1d849407dfccd$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $f0c1d849407dfccd$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($f0c1d849407dfccd$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $f0c1d849407dfccd$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $f0c1d849407dfccd$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $f0c1d849407dfccd$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $f0c1d849407dfccd$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $f0c1d849407dfccd$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $f0c1d849407dfccd$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $f0c1d849407dfccd$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $f0c1d849407dfccd$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $f0c1d849407dfccd$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $f0c1d849407dfccd$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $f0c1d849407dfccd$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $f0c1d849407dfccd$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $f0c1d849407dfccd$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $f0c1d849407dfccd$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $f0c1d849407dfccd$var$bconcat(bufs);
}
function $f0c1d849407dfccd$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $f0c1d849407dfccd$var$writezeroes(n, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $f0c1d849407dfccd$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $f0c1d849407dfccd$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $f0c1d849407dfccd$var$writebool(v /*:any*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $f0c1d849407dfccd$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $f0c1d849407dfccd$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $f0c1d849407dfccd$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $f0c1d849407dfccd$var$parslurp(blob, length, $f0c1d849407dfccd$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $f0c1d849407dfccd$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $f0c1d849407dfccd$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $f0c1d849407dfccd$var$current_codepage;
    if (opts && opts.biff >= 8) $f0c1d849407dfccd$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $f0c1d849407dfccd$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $f0c1d849407dfccd$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $f0c1d849407dfccd$var$current_codepage;
    $f0c1d849407dfccd$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $f0c1d849407dfccd$var$current_codepage = cp;
    return z;
}
function $f0c1d849407dfccd$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $f0c1d849407dfccd$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $f0c1d849407dfccd$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $f0c1d849407dfccd$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $f0c1d849407dfccd$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $f0c1d849407dfccd$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $f0c1d849407dfccd$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $f0c1d849407dfccd$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $f0c1d849407dfccd$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($f0c1d849407dfccd$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $f0c1d849407dfccd$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($f0c1d849407dfccd$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $f0c1d849407dfccd$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $f0c1d849407dfccd$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $f0c1d849407dfccd$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $f0c1d849407dfccd$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($f0c1d849407dfccd$var$chr0, "") : "";
    return o;
}
function $f0c1d849407dfccd$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $f0c1d849407dfccd$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $f0c1d849407dfccd$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $f0c1d849407dfccd$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $f0c1d849407dfccd$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $f0c1d849407dfccd$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $f0c1d849407dfccd$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $f0c1d849407dfccd$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $f0c1d849407dfccd$var$write_Hyperlink(hl) {
    var out = $f0c1d849407dfccd$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $f0c1d849407dfccd$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $f0c1d849407dfccd$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $f0c1d849407dfccd$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $f0c1d849407dfccd$var$parse_LongRGB(blob, length) {
    var x = $f0c1d849407dfccd$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $f0c1d849407dfccd$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $f0c1d849407dfccd$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $f0c1d849407dfccd$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $f0c1d849407dfccd$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $f0c1d849407dfccd$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $f0c1d849407dfccd$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $f0c1d849407dfccd$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $f0c1d849407dfccd$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $f0c1d849407dfccd$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $f0c1d849407dfccd$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $f0c1d849407dfccd$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $f0c1d849407dfccd$var$parse_Ref = $f0c1d849407dfccd$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $f0c1d849407dfccd$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $f0c1d849407dfccd$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $f0c1d849407dfccd$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $f0c1d849407dfccd$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $f0c1d849407dfccd$var$FtTab = {
    0x00: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtEnd */ 0x04: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtMacro */ 0x05: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtButton */ 0x06: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtGmo */ 0x07: $f0c1d849407dfccd$var$parse_FtCf,
    /* FtCf */ 0x08: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $f0c1d849407dfccd$var$parse_FtNts,
    /* FtNts */ 0x0E: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtGboData */ 0x10: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtRboData */ 0x12: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $f0c1d849407dfccd$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $f0c1d849407dfccd$var$parse_FtCmo
};
function $f0c1d849407dfccd$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $f0c1d849407dfccd$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $f0c1d849407dfccd$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $f0c1d849407dfccd$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $f0c1d849407dfccd$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $f0c1d849407dfccd$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $f0c1d849407dfccd$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $f0c1d849407dfccd$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $f0c1d849407dfccd$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $f0c1d849407dfccd$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $f0c1d849407dfccd$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $f0c1d849407dfccd$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $f0c1d849407dfccd$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $f0c1d849407dfccd$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($f0c1d849407dfccd$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $f0c1d849407dfccd$var$write_SST(sst, opts) {
    var header = $f0c1d849407dfccd$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $f0c1d849407dfccd$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $f0c1d849407dfccd$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $f0c1d849407dfccd$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $f0c1d849407dfccd$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $f0c1d849407dfccd$var$parse_ForceFullCalculation(blob) {
    var header = $f0c1d849407dfccd$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $f0c1d849407dfccd$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $f0c1d849407dfccd$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $f0c1d849407dfccd$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $f0c1d849407dfccd$var$write_Window1() {
    var o = $f0c1d849407dfccd$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $f0c1d849407dfccd$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $f0c1d849407dfccd$var$write_Window2(view) {
    var o = $f0c1d849407dfccd$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $f0c1d849407dfccd$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $f0c1d849407dfccd$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $f0c1d849407dfccd$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $f0c1d849407dfccd$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $f0c1d849407dfccd$var$parse_LabelSst(blob, length, opts) {
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $f0c1d849407dfccd$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(10);
    $f0c1d849407dfccd$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $f0c1d849407dfccd$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, length, opts);
    var str = $f0c1d849407dfccd$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $f0c1d849407dfccd$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $f0c1d849407dfccd$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $f0c1d849407dfccd$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $f0c1d849407dfccd$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $f0c1d849407dfccd$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $f0c1d849407dfccd$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $f0c1d849407dfccd$var$parse_BIFF2Format = $f0c1d849407dfccd$var$parse_XLUnicodeString2;
function $f0c1d849407dfccd$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $f0c1d849407dfccd$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $f0c1d849407dfccd$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $f0c1d849407dfccd$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $f0c1d849407dfccd$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $f0c1d849407dfccd$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $f0c1d849407dfccd$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $f0c1d849407dfccd$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($f0c1d849407dfccd$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $f0c1d849407dfccd$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $f0c1d849407dfccd$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $f0c1d849407dfccd$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $f0c1d849407dfccd$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $f0c1d849407dfccd$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $f0c1d849407dfccd$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $f0c1d849407dfccd$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $f0c1d849407dfccd$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $f0c1d849407dfccd$var$write_BIFF2XF(xf) {
    var o = $f0c1d849407dfccd$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $f0c1d849407dfccd$var$write_BIFF3XF(xf) {
    var o = $f0c1d849407dfccd$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $f0c1d849407dfccd$var$write_BIFF4XF = $f0c1d849407dfccd$var$write_BIFF3XF;
function $f0c1d849407dfccd$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $f0c1d849407dfccd$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $f0c1d849407dfccd$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $f0c1d849407dfccd$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $f0c1d849407dfccd$var$parse_BoolErr(blob, length, opts) {
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 6, opts);
    var val1 = $f0c1d849407dfccd$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $f0c1d849407dfccd$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(8);
    $f0c1d849407dfccd$var$write_XLSCell(R, C, os, o);
    $f0c1d849407dfccd$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $f0c1d849407dfccd$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 6, opts);
    var xnum = $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $f0c1d849407dfccd$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(14);
    $f0c1d849407dfccd$var$write_XLSCell(R, C, os, o);
    $f0c1d849407dfccd$var$write_Xnum(v, o);
    return o;
}
var $f0c1d849407dfccd$var$parse_XLHeaderFooter = $f0c1d849407dfccd$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $f0c1d849407dfccd$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($f0c1d849407dfccd$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $f0c1d849407dfccd$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $f0c1d849407dfccd$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $f0c1d849407dfccd$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $f0c1d849407dfccd$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $f0c1d849407dfccd$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $f0c1d849407dfccd$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $f0c1d849407dfccd$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $f0c1d849407dfccd$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($f0c1d849407dfccd$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $f0c1d849407dfccd$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $f0c1d849407dfccd$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $f0c1d849407dfccd$var$parse_ShrFmla(blob, length, opts) {
    var ref = $f0c1d849407dfccd$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $f0c1d849407dfccd$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $f0c1d849407dfccd$var$parse_Array(blob, length, opts) {
    var ref = $f0c1d849407dfccd$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $f0c1d849407dfccd$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $f0c1d849407dfccd$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $f0c1d849407dfccd$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $f0c1d849407dfccd$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $f0c1d849407dfccd$var$parse_NoteSh(blob, length, opts);
}
function $f0c1d849407dfccd$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $f0c1d849407dfccd$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($f0c1d849407dfccd$var$parse_Ref8U(blob, length));
    return merges;
}
function $f0c1d849407dfccd$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $f0c1d849407dfccd$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$f0c1d849407dfccd$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $f0c1d849407dfccd$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $f0c1d849407dfccd$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $f0c1d849407dfccd$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $f0c1d849407dfccd$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $f0c1d849407dfccd$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $f0c1d849407dfccd$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($f0c1d849407dfccd$var$parse_BIFF5OT[ot] || $f0c1d849407dfccd$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $f0c1d849407dfccd$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $f0c1d849407dfccd$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $f0c1d849407dfccd$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $f0c1d849407dfccd$var$parse_HLink(blob, length) {
    var ref = $f0c1d849407dfccd$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $f0c1d849407dfccd$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $f0c1d849407dfccd$var$write_HLink(hl) {
    var O = $f0c1d849407dfccd$var$new_buf(24);
    var ref = $f0c1d849407dfccd$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $f0c1d849407dfccd$var$bconcat([
        O,
        $f0c1d849407dfccd$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $f0c1d849407dfccd$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $f0c1d849407dfccd$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($f0c1d849407dfccd$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $f0c1d849407dfccd$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $f0c1d849407dfccd$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $f0c1d849407dfccd$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $f0c1d849407dfccd$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $f0c1d849407dfccd$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $f0c1d849407dfccd$var$CountryEnum[d] || d;
    return o;
}
function $f0c1d849407dfccd$var$write_Country(o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $f0c1d849407dfccd$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($f0c1d849407dfccd$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $f0c1d849407dfccd$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($f0c1d849407dfccd$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $f0c1d849407dfccd$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $f0c1d849407dfccd$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $f0c1d849407dfccd$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $f0c1d849407dfccd$var$write_ColInfo(col, idx) {
    var o = $f0c1d849407dfccd$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $f0c1d849407dfccd$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
    o.footer = $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $f0c1d849407dfccd$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $f0c1d849407dfccd$var$write_RRTabId(n /*:number*/ ) {
    var out = $f0c1d849407dfccd$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $f0c1d849407dfccd$var$parse_Blank = $f0c1d849407dfccd$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $f0c1d849407dfccd$var$parse_Scl = $f0c1d849407dfccd$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $f0c1d849407dfccd$var$parse_String = $f0c1d849407dfccd$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $f0c1d849407dfccd$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $f0c1d849407dfccd$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $f0c1d849407dfccd$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $f0c1d849407dfccd$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 7, opts);
    var str = $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $f0c1d849407dfccd$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 7, opts);
    var num = $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $f0c1d849407dfccd$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $f0c1d849407dfccd$var$new_buf(15);
    $f0c1d849407dfccd$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $f0c1d849407dfccd$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $f0c1d849407dfccd$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $f0c1d849407dfccd$var$new_buf(9);
    $f0c1d849407dfccd$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $f0c1d849407dfccd$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $f0c1d849407dfccd$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $f0c1d849407dfccd$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $f0c1d849407dfccd$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $f0c1d849407dfccd$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $f0c1d849407dfccd$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $f0c1d849407dfccd$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $f0c1d849407dfccd$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $f0c1d849407dfccd$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $f0c1d849407dfccd$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $f0c1d849407dfccd$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $f0c1d849407dfccd$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $f0c1d849407dfccd$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $f0c1d849407dfccd$var$$cptable !== "undefined" ? $f0c1d849407dfccd$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $f0c1d849407dfccd$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $f0c1d849407dfccd$var$prep_blob(dd, 0);
                var s = typeof $f0c1d849407dfccd$var$$cptable !== "undefined" ? $f0c1d849407dfccd$var$$cptable.utils.decode(current_cp, dd) : $f0c1d849407dfccd$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $f0c1d849407dfccd$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $f0c1d849407dfccd$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $f0c1d849407dfccd$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $f0c1d849407dfccd$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $f0c1d849407dfccd$var$current_codepage;
        if (+o.codepage >= 0) $f0c1d849407dfccd$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $f0c1d849407dfccd$var$buf_array();
        var aoa /*:AOA*/  = $f0c1d849407dfccd$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $f0c1d849407dfccd$var$$cptable !== "undefined" && typeof col[j] == "string" ? $f0c1d849407dfccd$var$$cptable.utils.encode($f0c1d849407dfccd$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $f0c1d849407dfccd$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $f0c1d849407dfccd$var$current_codepage + ", using 1252");
            $f0c1d849407dfccd$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $f0c1d849407dfccd$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $f0c1d849407dfccd$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $f0c1d849407dfccd$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $f0c1d849407dfccd$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $f0c1d849407dfccd$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $f0c1d849407dfccd$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($f0c1d849407dfccd$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(d) ? d.toString('binary') : $f0c1d849407dfccd$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($f0c1d849407dfccd$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $f0c1d849407dfccd$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $f0c1d849407dfccd$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $f0c1d849407dfccd$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $f0c1d849407dfccd$var$RBErr[val1];
                            } else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(val1))) {
                                val1 = $f0c1d849407dfccd$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $f0c1d849407dfccd$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $f0c1d849407dfccd$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $f0c1d849407dfccd$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $f0c1d849407dfccd$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $f0c1d849407dfccd$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $f0c1d849407dfccd$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $f0c1d849407dfccd$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $f0c1d849407dfccd$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $f0c1d849407dfccd$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $f0c1d849407dfccd$var$aoa_to_sheet(aoa, _opts);
        $f0c1d849407dfccd$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $f0c1d849407dfccd$var$sheet_to_workbook(o, opts);
        $f0c1d849407dfccd$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $f0c1d849407dfccd$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $f0c1d849407dfccd$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $f0c1d849407dfccd$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $f0c1d849407dfccd$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $f0c1d849407dfccd$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $f0c1d849407dfccd$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $f0c1d849407dfccd$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $f0c1d849407dfccd$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($f0c1d849407dfccd$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(d) ? d.toString('binary') : $f0c1d849407dfccd$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($f0c1d849407dfccd$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(value))) arr[R][C] = $f0c1d849407dfccd$var$fuzzynum(value);
                    else if (!isNaN($f0c1d849407dfccd$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $f0c1d849407dfccd$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $f0c1d849407dfccd$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($f0c1d849407dfccd$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $f0c1d849407dfccd$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $f0c1d849407dfccd$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $f0c1d849407dfccd$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$f0c1d849407dfccd$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $f0c1d849407dfccd$var$SSF_format(cell.z || $f0c1d849407dfccd$var$table_fmt[14], $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $f0c1d849407dfccd$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $f0c1d849407dfccd$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $f0c1d849407dfccd$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $f0c1d849407dfccd$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $f0c1d849407dfccd$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $f0c1d849407dfccd$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $f0c1d849407dfccd$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $f0c1d849407dfccd$var$SSF_format(cell.z || $f0c1d849407dfccd$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $f0c1d849407dfccd$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $f0c1d849407dfccd$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(data))) arr[R][C] = $f0c1d849407dfccd$var$fuzzynum(data);
        else if (!isNaN($f0c1d849407dfccd$var$fuzzydate(data).getDate())) arr[R][C] = $f0c1d849407dfccd$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $f0c1d849407dfccd$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $f0c1d849407dfccd$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($f0c1d849407dfccd$var$DENSE != null && o.dense == null) o.dense = $f0c1d849407dfccd$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $f0c1d849407dfccd$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($f0c1d849407dfccd$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $f0c1d849407dfccd$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $f0c1d849407dfccd$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $f0c1d849407dfccd$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $f0c1d849407dfccd$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $f0c1d849407dfccd$var$parseDate(news);
                    if (o && o.UTC === false) v = $f0c1d849407dfccd$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $f0c1d849407dfccd$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $f0c1d849407dfccd$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $f0c1d849407dfccd$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $f0c1d849407dfccd$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $f0c1d849407dfccd$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$f0c1d849407dfccd$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $f0c1d849407dfccd$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $f0c1d849407dfccd$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $f0c1d849407dfccd$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') str = $f0c1d849407dfccd$var$$cptable.utils.decode(opts.codepage, d);
                else str = $f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(d) ? d.toString('binary') : $f0c1d849407dfccd$var$a2s(d);
                break;
            case 'array':
                str = $f0c1d849407dfccd$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $f0c1d849407dfccd$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $f0c1d849407dfccd$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $f0c1d849407dfccd$var$$cptable !== 'undefined' && opts.codepage) str = $f0c1d849407dfccd$var$$cptable.utils.decode(opts.codepage, $f0c1d849407dfccd$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $f0c1d849407dfccd$var$ETH.to_sheet(opts.type == 'string' ? str : $f0c1d849407dfccd$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $f0c1d849407dfccd$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $f0c1d849407dfccd$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($f0c1d849407dfccd$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $f0c1d849407dfccd$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $f0c1d849407dfccd$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $f0c1d849407dfccd$var$PRN.to_workbook(d, opts);
    }
}
var $f0c1d849407dfccd$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $f0c1d849407dfccd$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($f0c1d849407dfccd$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($f0c1d849407dfccd$var$DENSE != null && o.dense == null) o.dense = $f0c1d849407dfccd$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $f0c1d849407dfccd$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $f0c1d849407dfccd$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$f0c1d849407dfccd$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$f0c1d849407dfccd$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $f0c1d849407dfccd$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$f0c1d849407dfccd$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $f0c1d849407dfccd$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $f0c1d849407dfccd$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $f0c1d849407dfccd$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $f0c1d849407dfccd$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $f0c1d849407dfccd$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $f0c1d849407dfccd$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $f0c1d849407dfccd$var$table_fmt[14]
                        }));
                        else $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $f0c1d849407dfccd$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $f0c1d849407dfccd$var$format_cell(cell);
                        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $f0c1d849407dfccd$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $f0c1d849407dfccd$var$buf_array();
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $f0c1d849407dfccd$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $f0c1d849407dfccd$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $f0c1d849407dfccd$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $f0c1d849407dfccd$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $f0c1d849407dfccd$var$format_cell(cell);
                        /* TODO: max len? */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $f0c1d849407dfccd$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $f0c1d849407dfccd$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $f0c1d849407dfccd$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $f0c1d849407dfccd$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $f0c1d849407dfccd$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $f0c1d849407dfccd$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $f0c1d849407dfccd$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $f0c1d849407dfccd$var$encode_col(V) : $f0c1d849407dfccd$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $f0c1d849407dfccd$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $f0c1d849407dfccd$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $f0c1d849407dfccd$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $f0c1d849407dfccd$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $f0c1d849407dfccd$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $f0c1d849407dfccd$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $f0c1d849407dfccd$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $f0c1d849407dfccd$var$prep_blob(d, 0);
        var o = opts || {};
        if ($f0c1d849407dfccd$var$DENSE != null && o.dense == null) o.dense = $f0c1d849407dfccd$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $f0c1d849407dfccd$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $f0c1d849407dfccd$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $f0c1d849407dfccd$var$encode_range(range);
                    $f0c1d849407dfccd$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $f0c1d849407dfccd$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $f0c1d849407dfccd$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $f0c1d849407dfccd$var$dup(cell);
                            if (cell.t == "n" && cell.z && $f0c1d849407dfccd$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $f0c1d849407dfccd$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $f0c1d849407dfccd$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $f0c1d849407dfccd$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $f0c1d849407dfccd$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($f0c1d849407dfccd$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $f0c1d849407dfccd$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $f0c1d849407dfccd$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $f0c1d849407dfccd$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $f0c1d849407dfccd$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $f0c1d849407dfccd$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $f0c1d849407dfccd$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $f0c1d849407dfccd$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $f0c1d849407dfccd$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $f0c1d849407dfccd$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $f0c1d849407dfccd$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $f0c1d849407dfccd$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $f0c1d849407dfccd$var$utf8read(x);
        if (html) z.h = $f0c1d849407dfccd$var$escapehtml(z.t);
    } else if (/*y = */ x.match($f0c1d849407dfccd$var$sirregex)) {
        z.r = $f0c1d849407dfccd$var$utf8read(x);
        z.t = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(($f0c1d849407dfccd$var$str_remove_xml_ns_g(x, "rPh").match($f0c1d849407dfccd$var$sitregex) || []).join("").replace($f0c1d849407dfccd$var$tagregex, "")), true);
        if (html) z.h = $f0c1d849407dfccd$var$rs_to_html($f0c1d849407dfccd$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $f0c1d849407dfccd$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $f0c1d849407dfccd$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $f0c1d849407dfccd$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $f0c1d849407dfccd$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($f0c1d849407dfccd$var$sstr1, "").split($f0c1d849407dfccd$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $f0c1d849407dfccd$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $f0c1d849407dfccd$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $f0c1d849407dfccd$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $f0c1d849407dfccd$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o[o.length] = $f0c1d849407dfccd$var$writextag('sst', null, {
        xmlns: $f0c1d849407dfccd$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($f0c1d849407dfccd$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $f0c1d849407dfccd$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $f0c1d849407dfccd$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $f0c1d849407dfccd$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $f0c1d849407dfccd$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $f0c1d849407dfccd$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $f0c1d849407dfccd$var$write_BrtSSTItem = $f0c1d849407dfccd$var$write_RichStr;
function $f0c1d849407dfccd$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    $f0c1d849407dfccd$var$write_record(ba, 0x009F /* BrtBeginSst */ , $f0c1d849407dfccd$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$f0c1d849407dfccd$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $f0c1d849407dfccd$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $f0c1d849407dfccd$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $f0c1d849407dfccd$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') return $f0c1d849407dfccd$var$$cptable.utils.encode($f0c1d849407dfccd$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $f0c1d849407dfccd$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    o.U = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    o.W = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $f0c1d849407dfccd$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $f0c1d849407dfccd$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($f0c1d849407dfccd$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $f0c1d849407dfccd$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $f0c1d849407dfccd$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    o.U = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    o.W = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $f0c1d849407dfccd$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $f0c1d849407dfccd$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $f0c1d849407dfccd$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $f0c1d849407dfccd$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $f0c1d849407dfccd$var$parse_EncryptionInfo(blob) {
    var vers = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $f0c1d849407dfccd$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $f0c1d849407dfccd$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $f0c1d849407dfccd$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $f0c1d849407dfccd$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $f0c1d849407dfccd$var$parse_EncryptionHeader(blob, sz);
    var verifier = $f0c1d849407dfccd$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $f0c1d849407dfccd$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $f0c1d849407dfccd$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($f0c1d849407dfccd$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $f0c1d849407dfccd$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $f0c1d849407dfccd$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $f0c1d849407dfccd$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $f0c1d849407dfccd$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $f0c1d849407dfccd$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $f0c1d849407dfccd$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $f0c1d849407dfccd$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $f0c1d849407dfccd$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $f0c1d849407dfccd$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $f0c1d849407dfccd$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $f0c1d849407dfccd$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $f0c1d849407dfccd$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $f0c1d849407dfccd$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $f0c1d849407dfccd$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $f0c1d849407dfccd$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $f0c1d849407dfccd$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $f0c1d849407dfccd$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $f0c1d849407dfccd$var$parseuint16(blob),
        verificationBytes: $f0c1d849407dfccd$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $f0c1d849407dfccd$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $f0c1d849407dfccd$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $f0c1d849407dfccd$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $f0c1d849407dfccd$var$parse_RC4Header(blob, length);
    else o.Data = $f0c1d849407dfccd$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $f0c1d849407dfccd$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $f0c1d849407dfccd$var$parse_FilePassHeader(blob, length - 2, o);
    else $f0c1d849407dfccd$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $f0c1d849407dfccd$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $f0c1d849407dfccd$var$rtf_to_sheet_str($f0c1d849407dfccd$var$Base64_decode(d), opts);
        case "binary":
            return $f0c1d849407dfccd$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $f0c1d849407dfccd$var$rtf_to_sheet_str($f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(d) ? d.toString("binary") : $f0c1d849407dfccd$var$a2s(d), opts);
        case "array":
            return $f0c1d849407dfccd$var$rtf_to_sheet_str($f0c1d849407dfccd$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $f0c1d849407dfccd$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $f0c1d849407dfccd$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $f0c1d849407dfccd$var$fuzzynum(cell.v);
                        } else if ($f0c1d849407dfccd$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $f0c1d849407dfccd$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$f0c1d849407dfccd$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $f0c1d849407dfccd$var$encode_range(range);
    return ws;
}
function $f0c1d849407dfccd$var$rtf_to_workbook(d, opts) {
    var wb = $f0c1d849407dfccd$var$sheet_to_workbook($f0c1d849407dfccd$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $f0c1d849407dfccd$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $f0c1d849407dfccd$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $f0c1d849407dfccd$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($f0c1d849407dfccd$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $f0c1d849407dfccd$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $f0c1d849407dfccd$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $f0c1d849407dfccd$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $f0c1d849407dfccd$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $f0c1d849407dfccd$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $f0c1d849407dfccd$var$rgb2HSL($f0c1d849407dfccd$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $f0c1d849407dfccd$var$rgb2Hex($f0c1d849407dfccd$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $f0c1d849407dfccd$var$DEF_MDW = 6, $f0c1d849407dfccd$var$MAX_MDW = 15, $f0c1d849407dfccd$var$MIN_MDW = 1, $f0c1d849407dfccd$var$MDW = $f0c1d849407dfccd$var$DEF_MDW;
function $f0c1d849407dfccd$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $f0c1d849407dfccd$var$MDW) / 256) * $f0c1d849407dfccd$var$MDW);
}
function $f0c1d849407dfccd$var$px2char(px) {
    return Math.floor((px - 5) / $f0c1d849407dfccd$var$MDW * 100 + 0.5) / 100;
}
function $f0c1d849407dfccd$var$char2width(chr) {
    return Math.round((chr * $f0c1d849407dfccd$var$MDW + 5) / $f0c1d849407dfccd$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $f0c1d849407dfccd$var$cycle_width(collw) {
    return $f0c1d849407dfccd$var$char2width($f0c1d849407dfccd$var$px2char($f0c1d849407dfccd$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $f0c1d849407dfccd$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $f0c1d849407dfccd$var$cycle_width(collw)), _MDW = $f0c1d849407dfccd$var$MDW;
    if (delta > 0.005) {
        for($f0c1d849407dfccd$var$MDW = $f0c1d849407dfccd$var$MIN_MDW; $f0c1d849407dfccd$var$MDW < $f0c1d849407dfccd$var$MAX_MDW; ++$f0c1d849407dfccd$var$MDW)if (Math.abs(collw - $f0c1d849407dfccd$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $f0c1d849407dfccd$var$cycle_width(collw));
            _MDW = $f0c1d849407dfccd$var$MDW;
        }
    }
    $f0c1d849407dfccd$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $f0c1d849407dfccd$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $f0c1d849407dfccd$var$width2px(coll.width);
        coll.wch = $f0c1d849407dfccd$var$px2char(coll.wpx);
        coll.MDW = $f0c1d849407dfccd$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $f0c1d849407dfccd$var$px2char(coll.wpx);
        coll.width = $f0c1d849407dfccd$var$char2width(coll.wch);
        coll.MDW = $f0c1d849407dfccd$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $f0c1d849407dfccd$var$char2width(coll.wch);
        coll.wpx = $f0c1d849407dfccd$var$width2px(coll.width);
        coll.MDW = $f0c1d849407dfccd$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $f0c1d849407dfccd$var$DEF_PPI = 96, $f0c1d849407dfccd$var$PPI = $f0c1d849407dfccd$var$DEF_PPI;
function $f0c1d849407dfccd$var$px2pt(px) {
    return px * 96 / $f0c1d849407dfccd$var$PPI;
}
function $f0c1d849407dfccd$var$pt2px(pt) {
    return pt * $f0c1d849407dfccd$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $f0c1d849407dfccd$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $f0c1d849407dfccd$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $f0c1d849407dfccd$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $f0c1d849407dfccd$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $f0c1d849407dfccd$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $f0c1d849407dfccd$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $f0c1d849407dfccd$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $f0c1d849407dfccd$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $f0c1d849407dfccd$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $f0c1d849407dfccd$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $f0c1d849407dfccd$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $f0c1d849407dfccd$var$XLSIcv[1];
                    if (!icv) icv = $f0c1d849407dfccd$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $f0c1d849407dfccd$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $f0c1d849407dfccd$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $f0c1d849407dfccd$var$keys($f0c1d849407dfccd$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $f0c1d849407dfccd$var$table_fmt[k[i]];
    var m = t.match($f0c1d849407dfccd$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $f0c1d849407dfccd$var$parsexmltag(m[i]);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $f0c1d849407dfccd$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $f0c1d849407dfccd$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $f0c1d849407dfccd$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $f0c1d849407dfccd$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $f0c1d849407dfccd$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $f0c1d849407dfccd$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $f0c1d849407dfccd$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $f0c1d849407dfccd$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x), i = 0;
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $f0c1d849407dfccd$var$cellXF_uint.length; ++i)if (xf[$f0c1d849407dfccd$var$cellXF_uint[i]]) xf[$f0c1d849407dfccd$var$cellXF_uint[i]] = parseInt(xf[$f0c1d849407dfccd$var$cellXF_uint[i]], 10);
                for(i = 0; i < $f0c1d849407dfccd$var$cellXF_bool.length; ++i)if (xf[$f0c1d849407dfccd$var$cellXF_bool[i]]) xf[$f0c1d849407dfccd$var$cellXF_bool[i]] = $f0c1d849407dfccd$var$parsexmlbool(xf[$f0c1d849407dfccd$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $f0c1d849407dfccd$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $f0c1d849407dfccd$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $f0c1d849407dfccd$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $f0c1d849407dfccd$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $f0c1d849407dfccd$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $f0c1d849407dfccd$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $f0c1d849407dfccd$var$remove_doctype($f0c1d849407dfccd$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $f0c1d849407dfccd$var$str_match_xml_ns(data, "numFmts")) $f0c1d849407dfccd$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $f0c1d849407dfccd$var$str_match_xml_ns(data, "fonts")) $f0c1d849407dfccd$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $f0c1d849407dfccd$var$str_match_xml_ns(data, "fills")) $f0c1d849407dfccd$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $f0c1d849407dfccd$var$str_match_xml_ns(data, "borders")) $f0c1d849407dfccd$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $f0c1d849407dfccd$var$str_match_xml_ns(data, "cellXfs")) $f0c1d849407dfccd$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $f0c1d849407dfccd$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('styleSheet', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS_main[0],
            'xmlns:vt': $f0c1d849407dfccd$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $f0c1d849407dfccd$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $f0c1d849407dfccd$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $f0c1d849407dfccd$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $f0c1d849407dfccd$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $f0c1d849407dfccd$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $f0c1d849407dfccd$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $f0c1d849407dfccd$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $f0c1d849407dfccd$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $f0c1d849407dfccd$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $f0c1d849407dfccd$var$parse_XLWideString(data, length - 21);
    return out;
}
function $f0c1d849407dfccd$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $f0c1d849407dfccd$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $f0c1d849407dfccd$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $f0c1d849407dfccd$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $f0c1d849407dfccd$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $f0c1d849407dfccd$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $f0c1d849407dfccd$var$parse_BrtFill = $f0c1d849407dfccd$var$parsenoop;
function $f0c1d849407dfccd$var$write_BrtFill(fill, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(84);
    if (!$f0c1d849407dfccd$var$rev_XLSBFillPTNames) $f0c1d849407dfccd$var$rev_XLSBFillPTNames = $f0c1d849407dfccd$var$evert($f0c1d849407dfccd$var$XLSBFillPTNames);
    var fls /*:number*/  = $f0c1d849407dfccd$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $f0c1d849407dfccd$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $f0c1d849407dfccd$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $f0c1d849407dfccd$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $f0c1d849407dfccd$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $f0c1d849407dfccd$var$write_Blxf(data, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $f0c1d849407dfccd$var$parse_BrtBorder = $f0c1d849407dfccd$var$parsenoop;
function $f0c1d849407dfccd$var$write_BrtBorder(border, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $f0c1d849407dfccd$var$write_Blxf(null, o); /* top */ 
    $f0c1d849407dfccd$var$write_Blxf(null, o); /* bottom */ 
    $f0c1d849407dfccd$var$write_Blxf(null, o); /* left */ 
    $f0c1d849407dfccd$var$write_Blxf(null, o); /* right */ 
    $f0c1d849407dfccd$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $f0c1d849407dfccd$var$write_BrtStyle(style, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $f0c1d849407dfccd$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $f0c1d849407dfccd$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $f0c1d849407dfccd$var$new_buf(2052);
    o.write_shift(4, cnt);
    $f0c1d849407dfccd$var$write_XLNullableWideString(defTableStyle, o);
    $f0c1d849407dfccd$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $f0c1d849407dfccd$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $f0c1d849407dfccd$var$table_fmt)styles.NumberFmt[y] = $f0c1d849407dfccd$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $f0c1d849407dfccd$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $f0c1d849407dfccd$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $f0c1d849407dfccd$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $f0c1d849407dfccd$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $f0c1d849407dfccd$var$write_record(ba, 0x002C /* BrtFmt */ , $f0c1d849407dfccd$var$write_BrtFmt(i, NF[i]));
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $f0c1d849407dfccd$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    $f0c1d849407dfccd$var$write_record(ba, 0x002B /* BrtFont */ , $f0c1d849407dfccd$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $f0c1d849407dfccd$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $f0c1d849407dfccd$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x025B /* BrtBeginFills */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    $f0c1d849407dfccd$var$write_record(ba, 0x002D /* BrtFill */ , $f0c1d849407dfccd$var$write_BrtFill({
        patternType: "none"
    }));
    $f0c1d849407dfccd$var$write_record(ba, 0x002D /* BrtFill */ , $f0c1d849407dfccd$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $f0c1d849407dfccd$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $f0c1d849407dfccd$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    $f0c1d849407dfccd$var$write_record(ba, 0x002E /* BrtBorder */ , $f0c1d849407dfccd$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $f0c1d849407dfccd$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $f0c1d849407dfccd$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $f0c1d849407dfccd$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    $f0c1d849407dfccd$var$write_record(ba, 0x002F /* BrtXF */ , $f0c1d849407dfccd$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $f0c1d849407dfccd$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $f0c1d849407dfccd$var$write_CELLXFS_bin(ba, data) {
    $f0c1d849407dfccd$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $f0c1d849407dfccd$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $f0c1d849407dfccd$var$write_record(ba, 0x002F /* BrtXF */ , $f0c1d849407dfccd$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $f0c1d849407dfccd$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $f0c1d849407dfccd$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $f0c1d849407dfccd$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    $f0c1d849407dfccd$var$write_record(ba, 0x0030 /* BrtStyle */ , $f0c1d849407dfccd$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $f0c1d849407dfccd$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $f0c1d849407dfccd$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $f0c1d849407dfccd$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $f0c1d849407dfccd$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $f0c1d849407dfccd$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $f0c1d849407dfccd$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $f0c1d849407dfccd$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $f0c1d849407dfccd$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $f0c1d849407dfccd$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $f0c1d849407dfccd$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $f0c1d849407dfccd$var$write_sty_bin(wb, opts) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    $f0c1d849407dfccd$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $f0c1d849407dfccd$var$write_FMTS_bin(ba, wb.SSF);
    $f0c1d849407dfccd$var$write_FONTS_bin(ba, wb);
    $f0c1d849407dfccd$var$write_FILLS_bin(ba, wb);
    $f0c1d849407dfccd$var$write_BORDERS_bin(ba, wb);
    $f0c1d849407dfccd$var$write_CELLSTYLEXFS_bin(ba, wb);
    $f0c1d849407dfccd$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $f0c1d849407dfccd$var$write_STYLES_bin(ba, wb);
    $f0c1d849407dfccd$var$write_DXFS_bin(ba, wb);
    $f0c1d849407dfccd$var$write_TABLESTYLES_bin(ba, wb);
    $f0c1d849407dfccd$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $f0c1d849407dfccd$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $f0c1d849407dfccd$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $f0c1d849407dfccd$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$f0c1d849407dfccd$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $f0c1d849407dfccd$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $f0c1d849407dfccd$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $f0c1d849407dfccd$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $f0c1d849407dfccd$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $f0c1d849407dfccd$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $f0c1d849407dfccd$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $f0c1d849407dfccd$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $f0c1d849407dfccd$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $f0c1d849407dfccd$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $f0c1d849407dfccd$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $f0c1d849407dfccd$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $f0c1d849407dfccd$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $f0c1d849407dfccd$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $f0c1d849407dfccd$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $f0c1d849407dfccd$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $f0c1d849407dfccd$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $f0c1d849407dfccd$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $f0c1d849407dfccd$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $f0c1d849407dfccd$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $f0c1d849407dfccd$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $f0c1d849407dfccd$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $f0c1d849407dfccd$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $f0c1d849407dfccd$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $f0c1d849407dfccd$var$parse_IcvXF(blob, length) {
    return $f0c1d849407dfccd$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $f0c1d849407dfccd$var$parse_XFExtGradient(blob, length) {
    return $f0c1d849407dfccd$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $f0c1d849407dfccd$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $f0c1d849407dfccd$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $f0c1d849407dfccd$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $f0c1d849407dfccd$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($f0c1d849407dfccd$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $f0c1d849407dfccd$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $f0c1d849407dfccd$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $f0c1d849407dfccd$var$parse_XLWideString(data, length - 8)
    };
}
function $f0c1d849407dfccd$var$write_BrtMdtinfo(data) {
    var o = $f0c1d849407dfccd$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $f0c1d849407dfccd$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $f0c1d849407dfccd$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $f0c1d849407dfccd$var$write_BrtMdb(mdb) {
    var o = $f0c1d849407dfccd$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $f0c1d849407dfccd$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $f0c1d849407dfccd$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $f0c1d849407dfccd$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $f0c1d849407dfccd$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $f0c1d849407dfccd$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $f0c1d849407dfccd$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $f0c1d849407dfccd$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $f0c1d849407dfccd$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $f0c1d849407dfccd$var$write_xlmeta_bin() {
    var ba = $f0c1d849407dfccd$var$buf_array();
    $f0c1d849407dfccd$var$write_record(ba, 332);
    $f0c1d849407dfccd$var$write_record(ba, 334, $f0c1d849407dfccd$var$write_UInt32LE(1));
    $f0c1d849407dfccd$var$write_record(ba, 335, $f0c1d849407dfccd$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $f0c1d849407dfccd$var$write_record(ba, 336);
    $f0c1d849407dfccd$var$write_record(ba, 339, $f0c1d849407dfccd$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $f0c1d849407dfccd$var$write_record(ba, 52);
    $f0c1d849407dfccd$var$write_record(ba, 35, $f0c1d849407dfccd$var$write_UInt32LE(514));
    $f0c1d849407dfccd$var$write_record(ba, 4096, $f0c1d849407dfccd$var$write_UInt32LE(0));
    $f0c1d849407dfccd$var$write_record(ba, 4097, $f0c1d849407dfccd$var$writeuint16(1));
    $f0c1d849407dfccd$var$write_record(ba, 36);
    $f0c1d849407dfccd$var$write_record(ba, 53);
    $f0c1d849407dfccd$var$write_record(ba, 340);
    $f0c1d849407dfccd$var$write_record(ba, 337, $f0c1d849407dfccd$var$write_BrtBeginEsmdb(1, true));
    $f0c1d849407dfccd$var$write_record(ba, 51, $f0c1d849407dfccd$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $f0c1d849407dfccd$var$write_record(ba, 338);
    $f0c1d849407dfccd$var$write_record(ba, 333);
    return ba.end();
}
function $f0c1d849407dfccd$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($f0c1d849407dfccd$var$tagregex, function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $f0c1d849407dfccd$var$write_xlmeta_xml() {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $f0c1d849407dfccd$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($f0c1d849407dfccd$var$tagregex) || []).forEach(function(x) {
        var y = $f0c1d849407dfccd$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $f0c1d849407dfccd$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $f0c1d849407dfccd$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $f0c1d849407dfccd$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $f0c1d849407dfccd$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $f0c1d849407dfccd$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $f0c1d849407dfccd$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $f0c1d849407dfccd$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $f0c1d849407dfccd$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $f0c1d849407dfccd$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($f0c1d849407dfccd$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($f0c1d849407dfccd$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $f0c1d849407dfccd$var$parsexmltag(x);
            switch($f0c1d849407dfccd$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $f0c1d849407dfccd$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $f0c1d849407dfccd$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $f0c1d849407dfccd$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $f0c1d849407dfccd$var$writextag("xml", null, {
            'xmlns:v': $f0c1d849407dfccd$var$XLMLNS.v,
            'xmlns:o': $f0c1d849407dfccd$var$XLMLNS.o,
            'xmlns:x': $f0c1d849407dfccd$var$XLMLNS.x,
            'xmlns:mv': $f0c1d849407dfccd$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $f0c1d849407dfccd$var$writextag("o:shapelayout", $f0c1d849407dfccd$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($f0c1d849407dfccd$var$writextag("v:shapetype", [
        $f0c1d849407dfccd$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $f0c1d849407dfccd$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($f0c1d849407dfccd$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $f0c1d849407dfccd$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $f0c1d849407dfccd$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $f0c1d849407dfccd$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $f0c1d849407dfccd$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $f0c1d849407dfccd$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $f0c1d849407dfccd$var$writextag("v:shadow", null, shadata),
        $f0c1d849407dfccd$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $f0c1d849407dfccd$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $f0c1d849407dfccd$var$writetag('x:AutoFill', "False"),
        $f0c1d849407dfccd$var$writetag('x:Row', String(c.r)),
        $f0c1d849407dfccd$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $f0c1d849407dfccd$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $f0c1d849407dfccd$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $f0c1d849407dfccd$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $f0c1d849407dfccd$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $f0c1d849407dfccd$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $f0c1d849407dfccd$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $f0c1d849407dfccd$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $f0c1d849407dfccd$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $f0c1d849407dfccd$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $f0c1d849407dfccd$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $f0c1d849407dfccd$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $f0c1d849407dfccd$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('comments', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $f0c1d849407dfccd$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($f0c1d849407dfccd$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $f0c1d849407dfccd$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($f0c1d849407dfccd$var$escapexml(c.a)) + '"><text>');
            o.push($f0c1d849407dfccd$var$writetag("t", c.t == null ? "" : $f0c1d849407dfccd$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($f0c1d849407dfccd$var$writetag("t", $f0c1d849407dfccd$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $f0c1d849407dfccd$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($f0c1d849407dfccd$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $f0c1d849407dfccd$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('ThreadedComments', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($f0c1d849407dfccd$var$writextag('threadedComment', $f0c1d849407dfccd$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $f0c1d849407dfccd$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($f0c1d849407dfccd$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $f0c1d849407dfccd$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('personList', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS.TCMNT,
            'xmlns:x': $f0c1d849407dfccd$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($f0c1d849407dfccd$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $f0c1d849407dfccd$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $f0c1d849407dfccd$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $f0c1d849407dfccd$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $f0c1d849407dfccd$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $f0c1d849407dfccd$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $f0c1d849407dfccd$var$parse_BrtCommentAuthor = $f0c1d849407dfccd$var$parse_XLWideString;
function $f0c1d849407dfccd$var$write_BrtCommentAuthor(data) {
    return $f0c1d849407dfccd$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $f0c1d849407dfccd$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $f0c1d849407dfccd$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $f0c1d849407dfccd$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $f0c1d849407dfccd$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $f0c1d849407dfccd$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $f0c1d849407dfccd$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $f0c1d849407dfccd$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $f0c1d849407dfccd$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $f0c1d849407dfccd$var$decode_cell(comment[0]),
                e: $f0c1d849407dfccd$var$decode_cell(comment[0])
            };
            $f0c1d849407dfccd$var$write_record(ba, 0x027B /* BrtBeginComment */ , $f0c1d849407dfccd$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $f0c1d849407dfccd$var$write_record(ba, 0x027D /* BrtCommentText */ , $f0c1d849407dfccd$var$write_BrtCommentText(c));
            $f0c1d849407dfccd$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $f0c1d849407dfccd$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $f0c1d849407dfccd$var$make_vba_xls(cfb) {
    var newcfb = $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $f0c1d849407dfccd$export$9f0e51cd97c572a.write(newcfb);
}
function $f0c1d849407dfccd$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $f0c1d849407dfccd$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $f0c1d849407dfccd$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $f0c1d849407dfccd$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $f0c1d849407dfccd$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $f0c1d849407dfccd$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $f0c1d849407dfccd$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $f0c1d849407dfccd$var$encode_col(C) + (rRel ? "" : "$") + $f0c1d849407dfccd$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $f0c1d849407dfccd$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $f0c1d849407dfccd$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $f0c1d849407dfccd$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($f0c1d849407dfccd$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $f0c1d849407dfccd$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $f0c1d849407dfccd$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $f0c1d849407dfccd$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($f0c1d849407dfccd$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $f0c1d849407dfccd$var$encode_col($f0c1d849407dfccd$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $f0c1d849407dfccd$var$encode_row($f0c1d849407dfccd$var$decode_row($5) + delta.r));
    });
}
function $f0c1d849407dfccd$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $f0c1d849407dfccd$var$decode_range(range), s = r.s, c = $f0c1d849407dfccd$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $f0c1d849407dfccd$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $f0c1d849407dfccd$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $f0c1d849407dfccd$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $f0c1d849407dfccd$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $f0c1d849407dfccd$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $f0c1d849407dfccd$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $f0c1d849407dfccd$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    var C = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $f0c1d849407dfccd$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2), R = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $f0c1d849407dfccd$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $f0c1d849407dfccd$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    var C = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $f0c1d849407dfccd$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $f0c1d849407dfccd$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $f0c1d849407dfccd$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $f0c1d849407dfccd$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $f0c1d849407dfccd$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $f0c1d849407dfccd$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $f0c1d849407dfccd$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $f0c1d849407dfccd$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $f0c1d849407dfccd$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $f0c1d849407dfccd$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $f0c1d849407dfccd$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $f0c1d849407dfccd$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $f0c1d849407dfccd$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $f0c1d849407dfccd$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $f0c1d849407dfccd$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $f0c1d849407dfccd$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $f0c1d849407dfccd$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $f0c1d849407dfccd$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $f0c1d849407dfccd$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $f0c1d849407dfccd$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $f0c1d849407dfccd$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $f0c1d849407dfccd$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $f0c1d849407dfccd$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $f0c1d849407dfccd$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $f0c1d849407dfccd$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $f0c1d849407dfccd$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $f0c1d849407dfccd$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $f0c1d849407dfccd$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $f0c1d849407dfccd$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $f0c1d849407dfccd$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $f0c1d849407dfccd$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $f0c1d849407dfccd$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $f0c1d849407dfccd$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $f0c1d849407dfccd$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $f0c1d849407dfccd$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $f0c1d849407dfccd$var$FtabArgc[iftab],
        $f0c1d849407dfccd$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $f0c1d849407dfccd$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $f0c1d849407dfccd$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $f0c1d849407dfccd$var$Ftab : $f0c1d849407dfccd$var$Cetab)[tab[1]]
    ];
}
function $f0c1d849407dfccd$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $f0c1d849407dfccd$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $f0c1d849407dfccd$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $f0c1d849407dfccd$var$parse_PtgErr(blob) {
    blob.l++;
    return $f0c1d849407dfccd$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $f0c1d849407dfccd$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $f0c1d849407dfccd$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $f0c1d849407dfccd$var$parse_PtgNum(blob) {
    blob.l++;
    return $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $f0c1d849407dfccd$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $f0c1d849407dfccd$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $f0c1d849407dfccd$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $f0c1d849407dfccd$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $f0c1d849407dfccd$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $f0c1d849407dfccd$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $f0c1d849407dfccd$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $f0c1d849407dfccd$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $f0c1d849407dfccd$var$parse_UncheckedRfX : $f0c1d849407dfccd$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $f0c1d849407dfccd$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $f0c1d849407dfccd$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $f0c1d849407dfccd$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $f0c1d849407dfccd$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $f0c1d849407dfccd$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $f0c1d849407dfccd$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $f0c1d849407dfccd$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $f0c1d849407dfccd$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $f0c1d849407dfccd$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $f0c1d849407dfccd$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $f0c1d849407dfccd$var$parse_PtgMemErr = $f0c1d849407dfccd$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $f0c1d849407dfccd$var$parse_PtgMemNoMem = $f0c1d849407dfccd$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $f0c1d849407dfccd$var$parse_PtgTbl = $f0c1d849407dfccd$var$parsenoop;
function $f0c1d849407dfccd$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $f0c1d849407dfccd$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $f0c1d849407dfccd$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $f0c1d849407dfccd$var$parse_PtgElfCol = $f0c1d849407dfccd$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $f0c1d849407dfccd$var$parse_PtgElfColS = $f0c1d849407dfccd$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $f0c1d849407dfccd$var$parse_PtgElfColSV = $f0c1d849407dfccd$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $f0c1d849407dfccd$var$parse_PtgElfColV = $f0c1d849407dfccd$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $f0c1d849407dfccd$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $f0c1d849407dfccd$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $f0c1d849407dfccd$var$parse_PtgElfRadical = $f0c1d849407dfccd$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $f0c1d849407dfccd$var$parse_PtgElfRadicalLel = $f0c1d849407dfccd$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $f0c1d849407dfccd$var$parse_PtgElfRadicalS = $f0c1d849407dfccd$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $f0c1d849407dfccd$var$parse_PtgElfRw = $f0c1d849407dfccd$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $f0c1d849407dfccd$var$parse_PtgElfRwV = $f0c1d849407dfccd$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $f0c1d849407dfccd$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $f0c1d849407dfccd$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $f0c1d849407dfccd$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $f0c1d849407dfccd$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $f0c1d849407dfccd$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $f0c1d849407dfccd$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $f0c1d849407dfccd$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $f0c1d849407dfccd$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $f0c1d849407dfccd$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $f0c1d849407dfccd$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $f0c1d849407dfccd$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $f0c1d849407dfccd$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $f0c1d849407dfccd$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $f0c1d849407dfccd$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $f0c1d849407dfccd$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $f0c1d849407dfccd$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $f0c1d849407dfccd$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $f0c1d849407dfccd$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $f0c1d849407dfccd$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $f0c1d849407dfccd$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $f0c1d849407dfccd$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $f0c1d849407dfccd$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $f0c1d849407dfccd$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $f0c1d849407dfccd$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $f0c1d849407dfccd$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $f0c1d849407dfccd$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $f0c1d849407dfccd$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $f0c1d849407dfccd$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $f0c1d849407dfccd$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $f0c1d849407dfccd$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $f0c1d849407dfccd$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $f0c1d849407dfccd$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $f0c1d849407dfccd$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $f0c1d849407dfccd$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $f0c1d849407dfccd$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $f0c1d849407dfccd$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $f0c1d849407dfccd$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $f0c1d849407dfccd$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $f0c1d849407dfccd$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $f0c1d849407dfccd$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $f0c1d849407dfccd$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $f0c1d849407dfccd$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $f0c1d849407dfccd$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $f0c1d849407dfccd$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $f0c1d849407dfccd$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $f0c1d849407dfccd$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $f0c1d849407dfccd$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $f0c1d849407dfccd$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $f0c1d849407dfccd$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $f0c1d849407dfccd$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $f0c1d849407dfccd$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $f0c1d849407dfccd$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $f0c1d849407dfccd$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $f0c1d849407dfccd$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $f0c1d849407dfccd$var$parse_PtgSxName
    },
    0xFF: {}
};
var $f0c1d849407dfccd$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $f0c1d849407dfccd$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $f0c1d849407dfccd$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $f0c1d849407dfccd$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $f0c1d849407dfccd$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $f0c1d849407dfccd$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $f0c1d849407dfccd$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $f0c1d849407dfccd$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $f0c1d849407dfccd$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $f0c1d849407dfccd$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $f0c1d849407dfccd$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $f0c1d849407dfccd$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $f0c1d849407dfccd$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $f0c1d849407dfccd$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $f0c1d849407dfccd$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $f0c1d849407dfccd$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($f0c1d849407dfccd$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $f0c1d849407dfccd$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $f0c1d849407dfccd$var$PtgTypes[id] || $f0c1d849407dfccd$var$PtgTypes[$f0c1d849407dfccd$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $f0c1d849407dfccd$var$Ptg18 : $f0c1d849407dfccd$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $f0c1d849407dfccd$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $f0c1d849407dfccd$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $f0c1d849407dfccd$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $f0c1d849407dfccd$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $f0c1d849407dfccd$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $f0c1d849407dfccd$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $f0c1d849407dfccd$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $f0c1d849407dfccd$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $f0c1d849407dfccd$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $f0c1d849407dfccd$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $f0c1d849407dfccd$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $f0c1d849407dfccd$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($f0c1d849407dfccd$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $f0c1d849407dfccd$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($f0c1d849407dfccd$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $f0c1d849407dfccd$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($f0c1d849407dfccd$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $f0c1d849407dfccd$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $f0c1d849407dfccd$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $f0c1d849407dfccd$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $f0c1d849407dfccd$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($f0c1d849407dfccd$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $f0c1d849407dfccd$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($f0c1d849407dfccd$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $f0c1d849407dfccd$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $f0c1d849407dfccd$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($f0c1d849407dfccd$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $f0c1d849407dfccd$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $f0c1d849407dfccd$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $f0c1d849407dfccd$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $f0c1d849407dfccd$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$f0c1d849407dfccd$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$f0c1d849407dfccd$var$encode_cell(c)];
                    stack.push($f0c1d849407dfccd$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($f0c1d849407dfccd$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $f0c1d849407dfccd$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $f0c1d849407dfccd$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $f0c1d849407dfccd$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $f0c1d849407dfccd$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $f0c1d849407dfccd$var$parsenoop(blob, length - 2)
    ];
    var rgce = $f0c1d849407dfccd$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $f0c1d849407dfccd$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $f0c1d849407dfccd$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $f0c1d849407dfccd$var$parsenoop(blob, length - 2)
    ];
    var rgce = $f0c1d849407dfccd$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $f0c1d849407dfccd$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $f0c1d849407dfccd$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $f0c1d849407dfccd$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $f0c1d849407dfccd$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $f0c1d849407dfccd$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $f0c1d849407dfccd$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $f0c1d849407dfccd$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $f0c1d849407dfccd$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $f0c1d849407dfccd$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($f0c1d849407dfccd$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $f0c1d849407dfccd$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $f0c1d849407dfccd$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $f0c1d849407dfccd$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $f0c1d849407dfccd$var$write_Xnum(value);
    return $f0c1d849407dfccd$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $f0c1d849407dfccd$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSCell(blob, 6, opts);
    var val1 = $f0c1d849407dfccd$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $f0c1d849407dfccd$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $f0c1d849407dfccd$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $f0c1d849407dfccd$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $f0c1d849407dfccd$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $f0c1d849407dfccd$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $f0c1d849407dfccd$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $f0c1d849407dfccd$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $f0c1d849407dfccd$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $f0c1d849407dfccd$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $f0c1d849407dfccd$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $f0c1d849407dfccd$var$parse_XLSBArrayParsedFormula = $f0c1d849407dfccd$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $f0c1d849407dfccd$var$parse_XLSBCellParsedFormula = $f0c1d849407dfccd$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $f0c1d849407dfccd$var$parse_XLSBNameParsedFormula = $f0c1d849407dfccd$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $f0c1d849407dfccd$var$parse_XLSBSharedParsedFormula = $f0c1d849407dfccd$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $f0c1d849407dfccd$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $f0c1d849407dfccd$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $f0c1d849407dfccd$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $f0c1d849407dfccd$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $f0c1d849407dfccd$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $f0c1d849407dfccd$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $f0c1d849407dfccd$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $f0c1d849407dfccd$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $f0c1d849407dfccd$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $f0c1d849407dfccd$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $f0c1d849407dfccd$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $f0c1d849407dfccd$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $f0c1d849407dfccd$var$write_XLSBFormulaRef(str) {
    var cell = $f0c1d849407dfccd$var$decode_cell(str);
    var out = $f0c1d849407dfccd$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $f0c1d849407dfccd$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $f0c1d849407dfccd$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $f0c1d849407dfccd$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $f0c1d849407dfccd$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $f0c1d849407dfccd$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $f0c1d849407dfccd$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $f0c1d849407dfccd$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $f0c1d849407dfccd$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $f0c1d849407dfccd$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $f0c1d849407dfccd$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $f0c1d849407dfccd$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $f0c1d849407dfccd$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $f0c1d849407dfccd$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $f0c1d849407dfccd$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $f0c1d849407dfccd$var$decode_range(_str);
    var out = $f0c1d849407dfccd$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $f0c1d849407dfccd$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $f0c1d849407dfccd$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $f0c1d849407dfccd$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $f0c1d849407dfccd$var$write_XLSBFormulaErr(+$f0c1d849407dfccd$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $f0c1d849407dfccd$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $f0c1d849407dfccd$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $f0c1d849407dfccd$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $f0c1d849407dfccd$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $f0c1d849407dfccd$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $f0c1d849407dfccd$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $f0c1d849407dfccd$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $f0c1d849407dfccd$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $f0c1d849407dfccd$var$write_XLSBNameParsedFormula = $f0c1d849407dfccd$var$write_XLSBFormula;
var $f0c1d849407dfccd$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $f0c1d849407dfccd$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $f0c1d849407dfccd$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $f0c1d849407dfccd$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $f0c1d849407dfccd$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($f0c1d849407dfccd$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $f0c1d849407dfccd$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $f0c1d849407dfccd$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $f0c1d849407dfccd$var$strs = {}; // shared strings
var $f0c1d849407dfccd$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $f0c1d849407dfccd$var$browser_has_Map = typeof Map !== 'undefined';
function $f0c1d849407dfccd$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($f0c1d849407dfccd$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $f0c1d849407dfccd$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($f0c1d849407dfccd$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $f0c1d849407dfccd$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $f0c1d849407dfccd$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $f0c1d849407dfccd$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $f0c1d849407dfccd$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $f0c1d849407dfccd$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $f0c1d849407dfccd$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $f0c1d849407dfccd$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $f0c1d849407dfccd$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $f0c1d849407dfccd$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $f0c1d849407dfccd$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($f0c1d849407dfccd$var$table_fmt[fmtid] == null) $f0c1d849407dfccd$var$SSF__load($f0c1d849407dfccd$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $f0c1d849407dfccd$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $f0c1d849407dfccd$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $f0c1d849407dfccd$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $f0c1d849407dfccd$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $f0c1d849407dfccd$var$SSF_general(p.v, $f0c1d849407dfccd$var$_ssfopts);
        } else if (p.t === 'd') p.w = $f0c1d849407dfccd$var$SSF_format(fmtid, $f0c1d849407dfccd$var$datenum(p.v, !!date1904), $f0c1d849407dfccd$var$_ssfopts);
        else p.w = $f0c1d849407dfccd$var$SSF_format(fmtid, p.v, $f0c1d849407dfccd$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $f0c1d849407dfccd$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $f0c1d849407dfccd$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $f0c1d849407dfccd$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $f0c1d849407dfccd$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $f0c1d849407dfccd$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $f0c1d849407dfccd$var$encode_range(d);
}
var $f0c1d849407dfccd$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $f0c1d849407dfccd$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $f0c1d849407dfccd$var$dimregex = /"(\w*:\w*)"/;
var $f0c1d849407dfccd$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $f0c1d849407dfccd$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $f0c1d849407dfccd$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $f0c1d849407dfccd$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $f0c1d849407dfccd$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($f0c1d849407dfccd$var$DENSE != null && opts.dense == null) opts.dense = $f0c1d849407dfccd$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $f0c1d849407dfccd$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($f0c1d849407dfccd$var$sheetprregex);
    if (sheetPr) $f0c1d849407dfccd$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $f0c1d849407dfccd$var$str_match_xml_ns(data1, "sheetPr")) $f0c1d849407dfccd$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($f0c1d849407dfccd$var$dimregex);
        if (ref && !(opts && opts.nodim)) $f0c1d849407dfccd$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $f0c1d849407dfccd$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $f0c1d849407dfccd$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($f0c1d849407dfccd$var$colregex);
        if (cols) $f0c1d849407dfccd$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $f0c1d849407dfccd$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($f0c1d849407dfccd$var$afregex);
    if (afilter) s['!autofilter'] = $f0c1d849407dfccd$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($f0c1d849407dfccd$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $f0c1d849407dfccd$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($f0c1d849407dfccd$var$hlinkregex);
    if (hlink) $f0c1d849407dfccd$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($f0c1d849407dfccd$var$marginregex);
    if (margins) s['!margins'] = $f0c1d849407dfccd$var$parse_ws_xml_margins($f0c1d849407dfccd$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $f0c1d849407dfccd$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $f0c1d849407dfccd$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $f0c1d849407dfccd$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $f0c1d849407dfccd$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $f0c1d849407dfccd$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $f0c1d849407dfccd$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(data.codeName));
}
function $f0c1d849407dfccd$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $f0c1d849407dfccd$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $f0c1d849407dfccd$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $f0c1d849407dfccd$var$utf8write($f0c1d849407dfccd$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $f0c1d849407dfccd$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $f0c1d849407dfccd$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $f0c1d849407dfccd$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $f0c1d849407dfccd$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $f0c1d849407dfccd$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $f0c1d849407dfccd$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $f0c1d849407dfccd$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $f0c1d849407dfccd$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $f0c1d849407dfccd$var$writextag('sheetProtection', null, o);
}
function $f0c1d849407dfccd$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $f0c1d849407dfccd$var$parsexmltag($f0c1d849407dfccd$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $f0c1d849407dfccd$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $f0c1d849407dfccd$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $f0c1d849407dfccd$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $f0c1d849407dfccd$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $f0c1d849407dfccd$var$write_ws_xml_margins(margin) /*:string*/ {
    $f0c1d849407dfccd$var$default_margins(margin);
    return $f0c1d849407dfccd$var$writextag('pageMargins', null, margin);
}
function $f0c1d849407dfccd$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $f0c1d849407dfccd$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $f0c1d849407dfccd$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $f0c1d849407dfccd$var$find_mdw_colw(coll.width);
        }
        $f0c1d849407dfccd$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $f0c1d849407dfccd$var$dup(coll);
    }
}
function $f0c1d849407dfccd$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $f0c1d849407dfccd$var$writextag('col', null, $f0c1d849407dfccd$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $f0c1d849407dfccd$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $f0c1d849407dfccd$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $f0c1d849407dfccd$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $f0c1d849407dfccd$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $f0c1d849407dfccd$var$decode_range(ws["!ref"]).e.r;
        ref = $f0c1d849407dfccd$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $f0c1d849407dfccd$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $f0c1d849407dfccd$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $f0c1d849407dfccd$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $f0c1d849407dfccd$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $f0c1d849407dfccd$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($f0c1d849407dfccd$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $f0c1d849407dfccd$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $f0c1d849407dfccd$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $f0c1d849407dfccd$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $f0c1d849407dfccd$var$writextag("sheetViews", $f0c1d849407dfccd$var$writextag("sheetView", null, sview), {});
}
function $f0c1d849407dfccd$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $f0c1d849407dfccd$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $f0c1d849407dfccd$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $f0c1d849407dfccd$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $f0c1d849407dfccd$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $f0c1d849407dfccd$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $f0c1d849407dfccd$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $f0c1d849407dfccd$var$writetag('v', $f0c1d849407dfccd$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $f0c1d849407dfccd$var$writetag('v', '' + $f0c1d849407dfccd$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $f0c1d849407dfccd$var$writextag('f', $f0c1d849407dfccd$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $f0c1d849407dfccd$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $f0c1d849407dfccd$var$writextag('c', v, o);
}
var $f0c1d849407dfccd$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $f0c1d849407dfccd$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $f0c1d849407dfccd$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $f0c1d849407dfccd$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $f0c1d849407dfccd$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $f0c1d849407dfccd$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $f0c1d849407dfccd$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $f0c1d849407dfccd$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $f0c1d849407dfccd$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $f0c1d849407dfccd$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $f0c1d849407dfccd$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $f0c1d849407dfccd$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $f0c1d849407dfccd$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $f0c1d849407dfccd$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $f0c1d849407dfccd$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $f0c1d849407dfccd$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $f0c1d849407dfccd$var$parsexmltag(cref[0]);
                                var ___f = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $f0c1d849407dfccd$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $f0c1d849407dfccd$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $f0c1d849407dfccd$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $f0c1d849407dfccd$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $f0c1d849407dfccd$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $f0c1d849407dfccd$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $f0c1d849407dfccd$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $f0c1d849407dfccd$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $f0c1d849407dfccd$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $f0c1d849407dfccd$var$parseDate(p.v, date1904);
                        else {
                            p.v = $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $f0c1d849407dfccd$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $f0c1d849407dfccd$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $f0c1d849407dfccd$var$fmt_is_date($f0c1d849407dfccd$var$table_fmt[fmtid])) {
                    p.v = $f0c1d849407dfccd$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $f0c1d849407dfccd$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $f0c1d849407dfccd$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $f0c1d849407dfccd$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $f0c1d849407dfccd$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $f0c1d849407dfccd$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $f0c1d849407dfccd$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $f0c1d849407dfccd$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $f0c1d849407dfccd$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $f0c1d849407dfccd$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $f0c1d849407dfccd$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER,
        $f0c1d849407dfccd$var$writextag('worksheet', null, {
            'xmlns': $f0c1d849407dfccd$var$XMLNS_main[0],
            'xmlns:r': $f0c1d849407dfccd$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $f0c1d849407dfccd$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $f0c1d849407dfccd$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $f0c1d849407dfccd$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $f0c1d849407dfccd$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $f0c1d849407dfccd$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $f0c1d849407dfccd$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $f0c1d849407dfccd$var$add_rels(rels, -1, $f0c1d849407dfccd$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $f0c1d849407dfccd$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $f0c1d849407dfccd$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $f0c1d849407dfccd$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $f0c1d849407dfccd$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $f0c1d849407dfccd$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $f0c1d849407dfccd$var$writetag("ignoredErrors", $f0c1d849407dfccd$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $f0c1d849407dfccd$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $f0c1d849407dfccd$var$RELS.DRAW);
        o[o.length] = $f0c1d849407dfccd$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $f0c1d849407dfccd$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $f0c1d849407dfccd$var$RELS.VML);
        o[o.length] = $f0c1d849407dfccd$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $f0c1d849407dfccd$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $f0c1d849407dfccd$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $f0c1d849407dfccd$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $f0c1d849407dfccd$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$f0c1d849407dfccd$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $f0c1d849407dfccd$var$write_row_header(ba, ws, range, R) {
    var o = $f0c1d849407dfccd$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $f0c1d849407dfccd$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $f0c1d849407dfccd$var$parse_BrtWsDim = $f0c1d849407dfccd$var$parse_UncheckedRfX;
var $f0c1d849407dfccd$var$write_BrtWsDim = $f0c1d849407dfccd$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $f0c1d849407dfccd$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $f0c1d849407dfccd$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $f0c1d849407dfccd$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $f0c1d849407dfccd$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $f0c1d849407dfccd$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $f0c1d849407dfccd$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $f0c1d849407dfccd$var$parse_BrtCellBlank(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8);
    return $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
}
function $f0c1d849407dfccd$var$parse_BrtShortBlank(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(4);
    return $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $f0c1d849407dfccd$var$parse_BrtCellBool(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(9);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtShortBool(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(5);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $f0c1d849407dfccd$var$parse_BrtCellError(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(9);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtShortError(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $f0c1d849407dfccd$var$parse_BrtCellIsst(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(12);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtShortIsst(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $f0c1d849407dfccd$var$parse_BrtCellReal(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var value = $f0c1d849407dfccd$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(16);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    $f0c1d849407dfccd$var$write_Xnum(cell.v, o);
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtShortReal(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var value = $f0c1d849407dfccd$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(12);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    $f0c1d849407dfccd$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $f0c1d849407dfccd$var$parse_BrtCellRk(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var value = $f0c1d849407dfccd$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(12);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    $f0c1d849407dfccd$var$write_RkNumber(cell.v, o);
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtShortRk(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var value = $f0c1d849407dfccd$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    $f0c1d849407dfccd$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $f0c1d849407dfccd$var$parse_BrtCellRString(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var value = $f0c1d849407dfccd$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $f0c1d849407dfccd$var$parse_BrtCellSt(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    var value = $f0c1d849407dfccd$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $f0c1d849407dfccd$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(12 + 4 * cell.v.length);
    $f0c1d849407dfccd$var$write_XLSBCell(ncell, o);
    $f0c1d849407dfccd$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $f0c1d849407dfccd$var$parse_BrtShortSt(data) {
    var cell = $f0c1d849407dfccd$var$parse_XLSBShortCell(data);
    var value = $f0c1d849407dfccd$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $f0c1d849407dfccd$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(8 + 4 * data.length);
    $f0c1d849407dfccd$var$write_XLSBShortCell(ncell, o);
    $f0c1d849407dfccd$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $f0c1d849407dfccd$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $f0c1d849407dfccd$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $f0c1d849407dfccd$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $f0c1d849407dfccd$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $f0c1d849407dfccd$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $f0c1d849407dfccd$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $f0c1d849407dfccd$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $f0c1d849407dfccd$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $f0c1d849407dfccd$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $f0c1d849407dfccd$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $f0c1d849407dfccd$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $f0c1d849407dfccd$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $f0c1d849407dfccd$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $f0c1d849407dfccd$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $f0c1d849407dfccd$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $f0c1d849407dfccd$var$parse_BrtMergeCell = $f0c1d849407dfccd$var$parse_UncheckedRfX;
var $f0c1d849407dfccd$var$write_BrtMergeCell = $f0c1d849407dfccd$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $f0c1d849407dfccd$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $f0c1d849407dfccd$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $f0c1d849407dfccd$var$parse_UncheckedRfX(data, 16);
    var relId = $f0c1d849407dfccd$var$parse_XLNullableWideString(data);
    var loc = $f0c1d849407dfccd$var$parse_XLWideString(data);
    var tooltip = $f0c1d849407dfccd$var$parse_XLWideString(data);
    var display = $f0c1d849407dfccd$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $f0c1d849407dfccd$var$write_BrtHLink(l, rId) {
    var o = $f0c1d849407dfccd$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $f0c1d849407dfccd$var$write_UncheckedRfX({
        s: $f0c1d849407dfccd$var$decode_cell(l[0]),
        e: $f0c1d849407dfccd$var$decode_cell(l[0])
    }, o);
    $f0c1d849407dfccd$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $f0c1d849407dfccd$var$write_XLWideString(loc || "", o);
    $f0c1d849407dfccd$var$write_XLWideString(l[1].Tooltip || "", o);
    $f0c1d849407dfccd$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $f0c1d849407dfccd$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $f0c1d849407dfccd$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $f0c1d849407dfccd$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $f0c1d849407dfccd$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $f0c1d849407dfccd$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $f0c1d849407dfccd$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $f0c1d849407dfccd$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $f0c1d849407dfccd$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(18);
    var p = $f0c1d849407dfccd$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $f0c1d849407dfccd$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $f0c1d849407dfccd$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $f0c1d849407dfccd$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $f0c1d849407dfccd$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $f0c1d849407dfccd$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(48);
    $f0c1d849407dfccd$var$default_margins(margins);
    $f0c1d849407dfccd$var$BrtMarginKeys.forEach(function(k) {
        $f0c1d849407dfccd$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $f0c1d849407dfccd$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $f0c1d849407dfccd$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $f0c1d849407dfccd$var$write_BrtCellIgnoreEC(ref) {
    var o = $f0c1d849407dfccd$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $f0c1d849407dfccd$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $f0c1d849407dfccd$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $f0c1d849407dfccd$var$new_buf(66);
    o.write_shift(2, sp.password ? $f0c1d849407dfccd$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $f0c1d849407dfccd$var$parse_BrtDVal() {}
function $f0c1d849407dfccd$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $f0c1d849407dfccd$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($f0c1d849407dfccd$var$DENSE != null && opts.dense == null) opts.dense = $f0c1d849407dfccd$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $f0c1d849407dfccd$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $f0c1d849407dfccd$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $f0c1d849407dfccd$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $f0c1d849407dfccd$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $f0c1d849407dfccd$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $f0c1d849407dfccd$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $f0c1d849407dfccd$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $f0c1d849407dfccd$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$f0c1d849407dfccd$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $f0c1d849407dfccd$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $f0c1d849407dfccd$var$fmt_is_date($f0c1d849407dfccd$var$table_fmt[cf.numFmtId])) {
                    var _d = $f0c1d849407dfccd$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$f0c1d849407dfccd$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$f0c1d849407dfccd$var$encode_col(C) + rr];
                cell.f = $f0c1d849407dfccd$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $f0c1d849407dfccd$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$f0c1d849407dfccd$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$f0c1d849407dfccd$var$encode_col(C) + rr];
                cell.f = $f0c1d849407dfccd$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $f0c1d849407dfccd$var$find_mdw_colw(val1.w / 256);
                    }
                    $f0c1d849407dfccd$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $f0c1d849407dfccd$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $f0c1d849407dfccd$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $f0c1d849407dfccd$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $f0c1d849407dfccd$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $f0c1d849407dfccd$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $f0c1d849407dfccd$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $f0c1d849407dfccd$var$dup(cell);
            cell.z = cell.z || $f0c1d849407dfccd$var$table_fmt[14];
            cell.v = $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $f0c1d849407dfccd$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $f0c1d849407dfccd$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $f0c1d849407dfccd$var$write_BrtShortIsst(cell, o));
                else $f0c1d849407dfccd$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $f0c1d849407dfccd$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x0011 /* BrtShortSt */ , $f0c1d849407dfccd$var$write_BrtShortSt(cell, o));
                else $f0c1d849407dfccd$var$write_record(ba, 0x0006 /* BrtCellSt */ , $f0c1d849407dfccd$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000D /* BrtShortRk */ , $f0c1d849407dfccd$var$write_BrtShortRk(cell, o));
                else $f0c1d849407dfccd$var$write_record(ba, 0x0002 /* BrtCellRk */ , $f0c1d849407dfccd$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000E /* BrtShortError */ , $f0c1d849407dfccd$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $f0c1d849407dfccd$var$write_record(ba, 0x0003 /* BrtCellError */ , $f0c1d849407dfccd$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000E /* BrtShortError */ , $f0c1d849407dfccd$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $f0c1d849407dfccd$var$write_record(ba, 0x0003 /* BrtCellError */ , $f0c1d849407dfccd$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x0010 /* BrtShortReal */ , $f0c1d849407dfccd$var$write_BrtShortReal(cell, o));
            else $f0c1d849407dfccd$var$write_record(ba, 0x0005 /* BrtCellReal */ , $f0c1d849407dfccd$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000F /* BrtShortBool */ , $f0c1d849407dfccd$var$write_BrtShortBool(cell, o));
            else $f0c1d849407dfccd$var$write_record(ba, 0x0004 /* BrtCellBool */ , $f0c1d849407dfccd$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000E /* BrtShortError */ , $f0c1d849407dfccd$var$write_BrtShortError(cell, o));
            else $f0c1d849407dfccd$var$write_record(ba, 0x0003 /* BrtCellError */ , $f0c1d849407dfccd$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $f0c1d849407dfccd$var$write_record(ba, 0x000C /* BrtShortBlank */ , $f0c1d849407dfccd$var$write_BrtShortBlank(cell, o));
    else $f0c1d849407dfccd$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $f0c1d849407dfccd$var$write_BrtCellBlank(cell, o));
    return true;
}
function $f0c1d849407dfccd$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $f0c1d849407dfccd$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $f0c1d849407dfccd$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $f0c1d849407dfccd$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $f0c1d849407dfccd$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $f0c1d849407dfccd$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $f0c1d849407dfccd$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $f0c1d849407dfccd$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $f0c1d849407dfccd$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $f0c1d849407dfccd$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $f0c1d849407dfccd$var$write_BrtMergeCell(m));
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $f0c1d849407dfccd$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $f0c1d849407dfccd$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $f0c1d849407dfccd$var$write_BrtColInfo(i, m));
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $f0c1d849407dfccd$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $f0c1d849407dfccd$var$write_BrtCellIgnoreEC($f0c1d849407dfccd$var$safe_decode_range(ws['!ref'])));
    $f0c1d849407dfccd$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $f0c1d849407dfccd$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $f0c1d849407dfccd$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $f0c1d849407dfccd$var$RELS.HLINK);
        $f0c1d849407dfccd$var$write_record(ba, 0x01EE /* BrtHLink */ , $f0c1d849407dfccd$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $f0c1d849407dfccd$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $f0c1d849407dfccd$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $f0c1d849407dfccd$var$RELS.VML);
        $f0c1d849407dfccd$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $f0c1d849407dfccd$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $f0c1d849407dfccd$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $f0c1d849407dfccd$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $f0c1d849407dfccd$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $f0c1d849407dfccd$var$decode_range(ws["!ref"]).e.r;
        ref = $f0c1d849407dfccd$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $f0c1d849407dfccd$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $f0c1d849407dfccd$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $f0c1d849407dfccd$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $f0c1d849407dfccd$var$fix_range(ref)
    });
    $f0c1d849407dfccd$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $f0c1d849407dfccd$var$write_UncheckedRfX($f0c1d849407dfccd$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $f0c1d849407dfccd$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $f0c1d849407dfccd$var$write_WSVIEWS2(ba, ws, Workbook) {
    $f0c1d849407dfccd$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $f0c1d849407dfccd$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $f0c1d849407dfccd$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $f0c1d849407dfccd$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $f0c1d849407dfccd$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $f0c1d849407dfccd$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $f0c1d849407dfccd$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $f0c1d849407dfccd$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $f0c1d849407dfccd$var$write_BrtSheetProtection(ws['!protect']));
}
function $f0c1d849407dfccd$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $f0c1d849407dfccd$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $f0c1d849407dfccd$var$write_record(ba, 0x0093 /* BrtWsProp */ , $f0c1d849407dfccd$var$write_BrtWsProp(c, ws['!outline']));
    $f0c1d849407dfccd$var$write_record(ba, 0x0094 /* BrtWsDim */ , $f0c1d849407dfccd$var$write_BrtWsDim(r));
    $f0c1d849407dfccd$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $f0c1d849407dfccd$var$write_WSFMTINFO(ba, ws);
    $f0c1d849407dfccd$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $f0c1d849407dfccd$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $f0c1d849407dfccd$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $f0c1d849407dfccd$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $f0c1d849407dfccd$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $f0c1d849407dfccd$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $f0c1d849407dfccd$var$write_record(ba, 0x01DC /* BrtMargins */ , $f0c1d849407dfccd$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $f0c1d849407dfccd$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $f0c1d849407dfccd$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $f0c1d849407dfccd$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $f0c1d849407dfccd$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $f0c1d849407dfccd$var$unescapexml(($f0c1d849407dfccd$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($f0c1d849407dfccd$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $f0c1d849407dfccd$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($f0c1d849407dfccd$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $f0c1d849407dfccd$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $f0c1d849407dfccd$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $f0c1d849407dfccd$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $f0c1d849407dfccd$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($f0c1d849407dfccd$var$sheetprregex);
    if (sheetPr) $f0c1d849407dfccd$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $f0c1d849407dfccd$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $f0c1d849407dfccd$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $f0c1d849407dfccd$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $f0c1d849407dfccd$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $f0c1d849407dfccd$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $f0c1d849407dfccd$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $f0c1d849407dfccd$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $f0c1d849407dfccd$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $f0c1d849407dfccd$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $f0c1d849407dfccd$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $f0c1d849407dfccd$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $f0c1d849407dfccd$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $f0c1d849407dfccd$var$parse_wb_defaults(wb) {
    $f0c1d849407dfccd$var$push_defaults(wb.WBProps, $f0c1d849407dfccd$var$WBPropsDef);
    $f0c1d849407dfccd$var$push_defaults(wb.CalcPr, $f0c1d849407dfccd$var$CalcPrDef);
    $f0c1d849407dfccd$var$push_defaults_array(wb.WBView, $f0c1d849407dfccd$var$WBViewDef);
    $f0c1d849407dfccd$var$push_defaults_array(wb.Sheets, $f0c1d849407dfccd$var$SheetDef);
    $f0c1d849407dfccd$var$_ssfopts.date1904 = $f0c1d849407dfccd$var$parsexmlbool(wb.WBProps.date1904);
}
function $f0c1d849407dfccd$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $f0c1d849407dfccd$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $f0c1d849407dfccd$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $f0c1d849407dfccd$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $f0c1d849407dfccd$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $f0c1d849407dfccd$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $f0c1d849407dfccd$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $f0c1d849407dfccd$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $f0c1d849407dfccd$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$f0c1d849407dfccd$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $f0c1d849407dfccd$var$formula_quote_sheet_name(n) + "!" + $f0c1d849407dfccd$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $f0c1d849407dfccd$var$wbnsregex = /<\w+:workbook/;
function $f0c1d849407dfccd$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($f0c1d849407dfccd$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $f0c1d849407dfccd$var$parsexmltag(x);
        switch($f0c1d849407dfccd$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($f0c1d849407dfccd$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $f0c1d849407dfccd$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $f0c1d849407dfccd$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $f0c1d849407dfccd$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $f0c1d849407dfccd$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($f0c1d849407dfccd$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($f0c1d849407dfccd$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $f0c1d849407dfccd$var$parse_wb_defaults(wb);
    return wb;
}
function $f0c1d849407dfccd$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $f0c1d849407dfccd$var$XML_HEADER
    ];
    o[o.length] = $f0c1d849407dfccd$var$writextag('workbook', null, {
        'xmlns': $f0c1d849407dfccd$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $f0c1d849407dfccd$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $f0c1d849407dfccd$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $f0c1d849407dfccd$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $f0c1d849407dfccd$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $f0c1d849407dfccd$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $f0c1d849407dfccd$var$writextag('definedName', $f0c1d849407dfccd$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $f0c1d849407dfccd$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $f0c1d849407dfccd$var$parse_RelID(data, length - 8);
    z.name = $f0c1d849407dfccd$var$parse_XLWideString(data);
    return z;
}
function $f0c1d849407dfccd$var$write_BrtBundleSh(data, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $f0c1d849407dfccd$var$write_RelID(data.strRelID, o);
    $f0c1d849407dfccd$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $f0c1d849407dfccd$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $f0c1d849407dfccd$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $f0c1d849407dfccd$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $f0c1d849407dfccd$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $f0c1d849407dfccd$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $f0c1d849407dfccd$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $f0c1d849407dfccd$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $f0c1d849407dfccd$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $f0c1d849407dfccd$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $f0c1d849407dfccd$var$write_BrtName(name, wb) {
    var o = $f0c1d849407dfccd$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($f0c1d849407dfccd$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $f0c1d849407dfccd$var$write_XLWideString(dname),
        $f0c1d849407dfccd$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($f0c1d849407dfccd$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $f0c1d849407dfccd$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $f0c1d849407dfccd$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $f0c1d849407dfccd$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $f0c1d849407dfccd$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $f0c1d849407dfccd$var$parse_BrtFRTArchID$
    };
    $f0c1d849407dfccd$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $f0c1d849407dfccd$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $f0c1d849407dfccd$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $f0c1d849407dfccd$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $f0c1d849407dfccd$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $f0c1d849407dfccd$var$write_record(ba, 0x009C /* BrtBundleSh */ , $f0c1d849407dfccd$var$write_BrtBundleSh(d));
    }
    $f0c1d849407dfccd$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $f0c1d849407dfccd$var$write_BrtFileVersion(data, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $f0c1d849407dfccd$var$write_XLWideString("SheetJS", o);
    $f0c1d849407dfccd$var$write_XLWideString($f0c1d849407dfccd$var$XLSX.version, o);
    $f0c1d849407dfccd$var$write_XLWideString($f0c1d849407dfccd$var$XLSX.version, o);
    $f0c1d849407dfccd$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $f0c1d849407dfccd$var$write_BrtBookView(idx, o) {
    if (!o) o = $f0c1d849407dfccd$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $f0c1d849407dfccd$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $f0c1d849407dfccd$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x009E /* BrtBookView */ , $f0c1d849407dfccd$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $f0c1d849407dfccd$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $f0c1d849407dfccd$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $f0c1d849407dfccd$var$write_record(ba, 0x0027 /* BrtName */ , $f0c1d849407dfccd$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $f0c1d849407dfccd$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $f0c1d849407dfccd$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $f0c1d849407dfccd$var$write_EXTERNALS_xlsb(ba, wb) {
    $f0c1d849407dfccd$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x016A /* BrtExternSheet */ , $f0c1d849407dfccd$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $f0c1d849407dfccd$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $f0c1d849407dfccd$var$write_wb_bin(wb, opts) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    $f0c1d849407dfccd$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $f0c1d849407dfccd$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $f0c1d849407dfccd$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $f0c1d849407dfccd$var$write_record(ba, 0x0099 /* BrtWbProp */ , $f0c1d849407dfccd$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $f0c1d849407dfccd$var$write_BOOKVIEWS(ba, wb, opts);
    $f0c1d849407dfccd$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $f0c1d849407dfccd$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $f0c1d849407dfccd$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $f0c1d849407dfccd$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $f0c1d849407dfccd$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_wb_bin(data /*:any*/ , opts);
    return $f0c1d849407dfccd$var$parse_wb_xml(data /*:any*/ , opts);
}
function $f0c1d849407dfccd$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $f0c1d849407dfccd$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $f0c1d849407dfccd$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $f0c1d849407dfccd$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $f0c1d849407dfccd$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $f0c1d849407dfccd$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $f0c1d849407dfccd$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $f0c1d849407dfccd$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $f0c1d849407dfccd$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $f0c1d849407dfccd$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $f0c1d849407dfccd$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_sst_bin(data /*:any*/ , opts);
    return $f0c1d849407dfccd$var$parse_sst_xml(data /*:any*/ , opts);
}
function $f0c1d849407dfccd$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_comments_bin(data /*:any*/ , opts);
    return $f0c1d849407dfccd$var$parse_comments_xml(data /*:any*/ , opts);
}
function $f0c1d849407dfccd$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $f0c1d849407dfccd$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $f0c1d849407dfccd$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $f0c1d849407dfccd$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $f0c1d849407dfccd$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $f0c1d849407dfccd$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $f0c1d849407dfccd$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $f0c1d849407dfccd$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $f0c1d849407dfccd$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $f0c1d849407dfccd$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($f0c1d849407dfccd$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($f0c1d849407dfccd$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $f0c1d849407dfccd$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($f0c1d849407dfccd$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($f0c1d849407dfccd$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $f0c1d849407dfccd$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $f0c1d849407dfccd$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $f0c1d849407dfccd$var$XLMLFormatMap[format] || $f0c1d849407dfccd$var$unescapexml(format);
    if (fmt === "General") return $f0c1d849407dfccd$var$SSF_general(value);
    return $f0c1d849407dfccd$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $f0c1d849407dfccd$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $f0c1d849407dfccd$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $f0c1d849407dfccd$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$f0c1d849407dfccd$var$unescapexml(key)] = oval;
}
function $f0c1d849407dfccd$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $f0c1d849407dfccd$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $f0c1d849407dfccd$var$SSF_general_num(cell.v);
            } else cell.w = $f0c1d849407dfccd$var$SSF_general(cell.v);
        } else cell.w = $f0c1d849407dfccd$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $f0c1d849407dfccd$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $f0c1d849407dfccd$var$fmt_is_date(z)) {
            var _d = $f0c1d849407dfccd$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $f0c1d849407dfccd$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $f0c1d849407dfccd$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $f0c1d849407dfccd$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $f0c1d849407dfccd$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $f0c1d849407dfccd$var$xlml_fixstr($f0c1d849407dfccd$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $f0c1d849407dfccd$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $f0c1d849407dfccd$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $f0c1d849407dfccd$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $f0c1d849407dfccd$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $f0c1d849407dfccd$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $f0c1d849407dfccd$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $f0c1d849407dfccd$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $f0c1d849407dfccd$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $f0c1d849407dfccd$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $f0c1d849407dfccd$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $f0c1d849407dfccd$var$xlml_prefix_dname(dname) {
    return $f0c1d849407dfccd$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $f0c1d849407dfccd$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $f0c1d849407dfccd$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $f0c1d849407dfccd$var$make_ssf();
    var str = $f0c1d849407dfccd$var$debom($f0c1d849407dfccd$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $f0c1d849407dfccd$var$$cptable !== 'undefined') str = $f0c1d849407dfccd$var$$cptable.utils.decode(65001, $f0c1d849407dfccd$var$char_codes(str));
        else str = $f0c1d849407dfccd$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $f0c1d849407dfccd$var$dup(opts);
        _o.type = "string";
        return $f0c1d849407dfccd$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $f0c1d849407dfccd$var$html_to_workbook(str, opts);
    $f0c1d849407dfccd$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $f0c1d849407dfccd$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $f0c1d849407dfccd$var$table_fmt[15],
        "Short Date": $f0c1d849407dfccd$var$table_fmt[14],
        "Long Time": $f0c1d849407dfccd$var$table_fmt[19],
        "Medium Time": $f0c1d849407dfccd$var$table_fmt[18],
        "Short Time": $f0c1d849407dfccd$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $f0c1d849407dfccd$var$table_fmt[2],
        "Standard": $f0c1d849407dfccd$var$table_fmt[4],
        "Percent": $f0c1d849407dfccd$var$table_fmt[10],
        "Scientific": $f0c1d849407dfccd$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($f0c1d849407dfccd$var$DENSE != null && opts.dense == null) opts.dense = $f0c1d849407dfccd$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $f0c1d849407dfccd$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $f0c1d849407dfccd$var$xlmlregex.lastIndex = 0;
    str = $f0c1d849407dfccd$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $f0c1d849407dfccd$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $f0c1d849407dfccd$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$f0c1d849407dfccd$var$encode_col(c) + $f0c1d849407dfccd$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $f0c1d849407dfccd$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$f0c1d849407dfccd$var$encode_col(cma) + $f0c1d849407dfccd$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $f0c1d849407dfccd$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $f0c1d849407dfccd$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $f0c1d849407dfccd$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                sheetname = $f0c1d849407dfccd$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $f0c1d849407dfccd$var$process_style_xlml(styles, stag, opts);
            else stag = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $f0c1d849407dfccd$var$unescapexml($f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($f0c1d849407dfccd$var$XLMLFormatMap[stag.nf]) stag.nf = $f0c1d849407dfccd$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($f0c1d849407dfccd$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($f0c1d849407dfccd$var$table_fmt[ssfidx] == null) {
                    $f0c1d849407dfccd$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $f0c1d849407dfccd$var$MDW = $f0c1d849407dfccd$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $f0c1d849407dfccd$var$process_col(cstys[_col]);
            }
            if (seencol) $f0c1d849407dfccd$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $f0c1d849407dfccd$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $f0c1d849407dfccd$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $f0c1d849407dfccd$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $f0c1d849407dfccd$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $f0c1d849407dfccd$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $f0c1d849407dfccd$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                if (!$f0c1d849407dfccd$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $f0c1d849407dfccd$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $f0c1d849407dfccd$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $f0c1d849407dfccd$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $f0c1d849407dfccd$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $f0c1d849407dfccd$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$f0c1d849407dfccd$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$f0c1d849407dfccd$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $f0c1d849407dfccd$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$f0c1d849407dfccd$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$f0c1d849407dfccd$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $f0c1d849407dfccd$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $f0c1d849407dfccd$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $f0c1d849407dfccd$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $f0c1d849407dfccd$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $f0c1d849407dfccd$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $f0c1d849407dfccd$var$parse_xlml_xml($f0c1d849407dfccd$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $f0c1d849407dfccd$var$parse_xlml_xml(data, opts);
        case "array":
            return $f0c1d849407dfccd$var$parse_xlml_xml($f0c1d849407dfccd$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $f0c1d849407dfccd$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($f0c1d849407dfccd$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($f0c1d849407dfccd$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $f0c1d849407dfccd$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $f0c1d849407dfccd$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($f0c1d849407dfccd$var$writextag('NumberFormat', null, {
            "ss:Format": $f0c1d849407dfccd$var$escapexml($f0c1d849407dfccd$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($f0c1d849407dfccd$var$writextag('Style', payload.join(""), o));
    });
    return $f0c1d849407dfccd$var$writextag("Styles", styles.join(""));
}
function $f0c1d849407dfccd$var$write_name_xlml(n) {
    return $f0c1d849407dfccd$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $f0c1d849407dfccd$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $f0c1d849407dfccd$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($f0c1d849407dfccd$var$write_name_xlml(n));
    }
    return $f0c1d849407dfccd$var$writextag("Names", out.join(""));
}
function $f0c1d849407dfccd$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($f0c1d849407dfccd$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $f0c1d849407dfccd$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($f0c1d849407dfccd$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($f0c1d849407dfccd$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($f0c1d849407dfccd$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($f0c1d849407dfccd$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($f0c1d849407dfccd$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($f0c1d849407dfccd$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($f0c1d849407dfccd$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($f0c1d849407dfccd$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($f0c1d849407dfccd$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $f0c1d849407dfccd$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $f0c1d849407dfccd$var$XLMLNS.x
    });
}
function $f0c1d849407dfccd$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $f0c1d849407dfccd$var$xlml_unfixstr(c.t || "");
        var d = $f0c1d849407dfccd$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $f0c1d849407dfccd$var$writextag("Comment", d, p);
    }).join("");
}
function $f0c1d849407dfccd$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $f0c1d849407dfccd$var$escapexml($f0c1d849407dfccd$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $f0c1d849407dfccd$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $f0c1d849407dfccd$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $f0c1d849407dfccd$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $f0c1d849407dfccd$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $f0c1d849407dfccd$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $f0c1d849407dfccd$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $f0c1d849407dfccd$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $f0c1d849407dfccd$var$write_ws_xlml_comment(cell.c);
    return $f0c1d849407dfccd$var$writextag("Cell", m, attr);
}
function $f0c1d849407dfccd$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $f0c1d849407dfccd$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $f0c1d849407dfccd$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $f0c1d849407dfccd$var$process_col(n);
        var w = !!n.width;
        var p = $f0c1d849407dfccd$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $f0c1d849407dfccd$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($f0c1d849407dfccd$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $f0c1d849407dfccd$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($f0c1d849407dfccd$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $f0c1d849407dfccd$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $f0c1d849407dfccd$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $f0c1d849407dfccd$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($f0c1d849407dfccd$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $f0c1d849407dfccd$var$a1_to_rc($f0c1d849407dfccd$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $f0c1d849407dfccd$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (wb.SSF) {
        $f0c1d849407dfccd$var$make_ssf();
        $f0c1d849407dfccd$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $f0c1d849407dfccd$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($f0c1d849407dfccd$var$write_props_xlml(wb, opts));
    d.push($f0c1d849407dfccd$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($f0c1d849407dfccd$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($f0c1d849407dfccd$var$writextag("Worksheet", $f0c1d849407dfccd$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $f0c1d849407dfccd$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $f0c1d849407dfccd$var$write_sty_xlml(wb, opts);
    return $f0c1d849407dfccd$var$XML_HEADER + $f0c1d849407dfccd$var$writextag("Workbook", d.join(""), {
        'xmlns': $f0c1d849407dfccd$var$XLMLNS.ss,
        'xmlns:o': $f0c1d849407dfccd$var$XLMLNS.o,
        'xmlns:x': $f0c1d849407dfccd$var$XLMLNS.x,
        'xmlns:ss': $f0c1d849407dfccd$var$XLMLNS.ss,
        'xmlns:dt': $f0c1d849407dfccd$var$XLMLNS.dt,
        'xmlns:html': $f0c1d849407dfccd$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $f0c1d849407dfccd$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $f0c1d849407dfccd$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $f0c1d849407dfccd$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $f0c1d849407dfccd$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $f0c1d849407dfccd$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $f0c1d849407dfccd$var$__readUInt16LE(blob, blob.l), next = $f0c1d849407dfccd$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $f0c1d849407dfccd$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $f0c1d849407dfccd$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $f0c1d849407dfccd$var$XLSRecordEnum[nextrt = $f0c1d849407dfccd$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $f0c1d849407dfccd$var$bconcat(bufs);
    $f0c1d849407dfccd$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $f0c1d849407dfccd$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $f0c1d849407dfccd$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $f0c1d849407dfccd$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $f0c1d849407dfccd$var$SSF_general_num(p.v);
            } else p.w = $f0c1d849407dfccd$var$SSF_general(p.v);
        } else p.w = $f0c1d849407dfccd$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $f0c1d849407dfccd$var$fmt_is_date($f0c1d849407dfccd$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $f0c1d849407dfccd$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $f0c1d849407dfccd$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $f0c1d849407dfccd$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($f0c1d849407dfccd$var$DENSE != null && options.dense == null) options.dense = $f0c1d849407dfccd$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $f0c1d849407dfccd$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $f0c1d849407dfccd$var$XLSIcv[icv];
        return $f0c1d849407dfccd$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $f0c1d849407dfccd$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $f0c1d849407dfccd$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $f0c1d849407dfccd$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $f0c1d849407dfccd$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $f0c1d849407dfccd$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $f0c1d849407dfccd$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $f0c1d849407dfccd$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $f0c1d849407dfccd$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $f0c1d849407dfccd$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $f0c1d849407dfccd$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $f0c1d849407dfccd$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $f0c1d849407dfccd$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $f0c1d849407dfccd$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $f0c1d849407dfccd$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $f0c1d849407dfccd$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$f0c1d849407dfccd$var$encode_col(val1.c) + $f0c1d849407dfccd$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $f0c1d849407dfccd$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $f0c1d849407dfccd$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $f0c1d849407dfccd$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $f0c1d849407dfccd$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $f0c1d849407dfccd$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $f0c1d849407dfccd$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $f0c1d849407dfccd$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $f0c1d849407dfccd$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $f0c1d849407dfccd$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$f0c1d849407dfccd$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$f0c1d849407dfccd$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $f0c1d849407dfccd$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $f0c1d849407dfccd$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $f0c1d849407dfccd$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $f0c1d849407dfccd$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($f0c1d849407dfccd$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $f0c1d849407dfccd$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $f0c1d849407dfccd$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($f0c1d849407dfccd$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $f0c1d849407dfccd$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$f0c1d849407dfccd$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$f0c1d849407dfccd$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$f0c1d849407dfccd$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$f0c1d849407dfccd$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $f0c1d849407dfccd$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $f0c1d849407dfccd$var$find_mdw_colw(val1.w / 256);
                        }
                        $f0c1d849407dfccd$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $f0c1d849407dfccd$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $f0c1d849407dfccd$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $f0c1d849407dfccd$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $f0c1d849407dfccd$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $f0c1d849407dfccd$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $f0c1d849407dfccd$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $f0c1d849407dfccd$var$parse_PropertySetStream(DSI, $f0c1d849407dfccd$var$DocSummaryPIDDSI, $f0c1d849407dfccd$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $f0c1d849407dfccd$var$parse_PropertySetStream(SI, $f0c1d849407dfccd$var$SummaryPIDSI, $f0c1d849407dfccd$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $f0c1d849407dfccd$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $f0c1d849407dfccd$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $f0c1d849407dfccd$var$evert_key($f0c1d849407dfccd$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $f0c1d849407dfccd$var$evert_key($f0c1d849407dfccd$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $f0c1d849407dfccd$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $f0c1d849407dfccd$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($f0c1d849407dfccd$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $f0c1d849407dfccd$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $f0c1d849407dfccd$var$write_PropertySetStream(SEntries, $f0c1d849407dfccd$var$PSCLSID.SI, SummaryRE, $f0c1d849407dfccd$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $f0c1d849407dfccd$var$write_PropertySetStream(DSEntries, $f0c1d849407dfccd$var$PSCLSID.DSI, DocSummaryRE, $f0c1d849407dfccd$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $f0c1d849407dfccd$var$PSCLSID.UDI));
}
function $f0c1d849407dfccd$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $f0c1d849407dfccd$var$fix_read_opts(options);
    $f0c1d849407dfccd$var$reset_cp();
    if (options.codepage) $f0c1d849407dfccd$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $f0c1d849407dfccd$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $f0c1d849407dfccd$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $f0c1d849407dfccd$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $f0c1d849407dfccd$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $f0c1d849407dfccd$var$parse_workbook(WB.content, options);
        else if ((_data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $f0c1d849407dfccd$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $f0c1d849407dfccd$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $f0c1d849407dfccd$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $f0c1d849407dfccd$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $f0c1d849407dfccd$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $f0c1d849407dfccd$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $f0c1d849407dfccd$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $f0c1d849407dfccd$var$fill_vba_xls(cfb, $f0c1d849407dfccd$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $f0c1d849407dfccd$var$XLSBRecordEnum = {
    0x0000: {
        f: $f0c1d849407dfccd$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $f0c1d849407dfccd$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $f0c1d849407dfccd$var$parse_BrtCellRk
    },
    0x0003: {
        f: $f0c1d849407dfccd$var$parse_BrtCellError
    },
    0x0004: {
        f: $f0c1d849407dfccd$var$parse_BrtCellBool
    },
    0x0005: {
        f: $f0c1d849407dfccd$var$parse_BrtCellReal
    },
    0x0006: {
        f: $f0c1d849407dfccd$var$parse_BrtCellSt
    },
    0x0007: {
        f: $f0c1d849407dfccd$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $f0c1d849407dfccd$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $f0c1d849407dfccd$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $f0c1d849407dfccd$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $f0c1d849407dfccd$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $f0c1d849407dfccd$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $f0c1d849407dfccd$var$parse_BrtShortRk
    },
    0x000E: {
        f: $f0c1d849407dfccd$var$parse_BrtShortError
    },
    0x000F: {
        f: $f0c1d849407dfccd$var$parse_BrtShortBool
    },
    0x0010: {
        f: $f0c1d849407dfccd$var$parse_BrtShortReal
    },
    0x0011: {
        f: $f0c1d849407dfccd$var$parse_BrtShortSt
    },
    0x0012: {
        f: $f0c1d849407dfccd$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $f0c1d849407dfccd$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $f0c1d849407dfccd$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $f0c1d849407dfccd$var$parse_BrtFont
    },
    0x002C: {
        f: $f0c1d849407dfccd$var$parse_BrtFmt
    },
    0x002D: {
        f: $f0c1d849407dfccd$var$parse_BrtFill
    },
    0x002E: {
        f: $f0c1d849407dfccd$var$parse_BrtBorder
    },
    0x002F: {
        f: $f0c1d849407dfccd$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $f0c1d849407dfccd$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $f0c1d849407dfccd$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $f0c1d849407dfccd$var$parse_ColInfo
    },
    0x003E: {
        f: $f0c1d849407dfccd$var$parse_BrtCellRString
    },
    0x003F: {
        f: $f0c1d849407dfccd$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $f0c1d849407dfccd$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $f0c1d849407dfccd$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $f0c1d849407dfccd$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $f0c1d849407dfccd$var$parse_BrtWsProp
    },
    0x0094: {
        f: $f0c1d849407dfccd$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $f0c1d849407dfccd$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $f0c1d849407dfccd$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $f0c1d849407dfccd$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $f0c1d849407dfccd$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $f0c1d849407dfccd$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $f0c1d849407dfccd$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $f0c1d849407dfccd$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $f0c1d849407dfccd$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $f0c1d849407dfccd$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $f0c1d849407dfccd$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $f0c1d849407dfccd$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $f0c1d849407dfccd$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $f0c1d849407dfccd$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $f0c1d849407dfccd$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $f0c1d849407dfccd$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $f0c1d849407dfccd$var$parse_RelID
    },
    0x0227: {
        f: $f0c1d849407dfccd$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $f0c1d849407dfccd$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $f0c1d849407dfccd$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $f0c1d849407dfccd$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $f0c1d849407dfccd$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $f0c1d849407dfccd$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $f0c1d849407dfccd$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $f0c1d849407dfccd$var$parse_Formula
    },
    0x000a: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x000c: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x000d: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x000e: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x000f: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0010: {
        f: $f0c1d849407dfccd$var$parse_Xnum
    },
    0x0011: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0012: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0013: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x0014: {
        f: $f0c1d849407dfccd$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $f0c1d849407dfccd$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $f0c1d849407dfccd$var$parse_ExternSheet
    },
    0x0018: {
        f: $f0c1d849407dfccd$var$parse_Lbl
    },
    0x0019: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $f0c1d849407dfccd$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0023: {
        f: $f0c1d849407dfccd$var$parse_ExternName
    },
    0x0026: {
        f: $f0c1d849407dfccd$var$parse_Xnum
    },
    0x0027: {
        f: $f0c1d849407dfccd$var$parse_Xnum
    },
    0x0028: {
        f: $f0c1d849407dfccd$var$parse_Xnum
    },
    0x0029: {
        f: $f0c1d849407dfccd$var$parse_Xnum
    },
    0x002a: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x002b: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x002f: {
        f: $f0c1d849407dfccd$var$parse_FilePass
    },
    0x0031: {
        f: $f0c1d849407dfccd$var$parse_Font
    },
    0x0033: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $f0c1d849407dfccd$var$parse_Window1
    },
    0x0040: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0041: {
        f: $f0c1d849407dfccd$var$parse_Pane
    },
    0x0042: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $f0c1d849407dfccd$var$parse_WriteAccess
    },
    0x005d: {
        f: $f0c1d849407dfccd$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x007d: {
        f: $f0c1d849407dfccd$var$parse_ColInfo
    },
    0x0080: {
        f: $f0c1d849407dfccd$var$parse_Guts
    },
    0x0081: {
        f: $f0c1d849407dfccd$var$parse_WsBool
    },
    0x0082: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x0083: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0084: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0085: {
        f: $f0c1d849407dfccd$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $f0c1d849407dfccd$var$parse_Country
    },
    0x008d: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $f0c1d849407dfccd$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $f0c1d849407dfccd$var$parse_Scl
    },
    0x00a1: {
        f: $f0c1d849407dfccd$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $f0c1d849407dfccd$var$parse_MulRk
    },
    0x00be: {
        f: $f0c1d849407dfccd$var$parse_MulBlank
    },
    0x00c1: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $f0c1d849407dfccd$var$parse_XF
    },
    0x00e1: {
        f: $f0c1d849407dfccd$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $f0c1d849407dfccd$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $f0c1d849407dfccd$var$parse_SST
    },
    0x00fd: {
        f: $f0c1d849407dfccd$var$parse_LabelSst
    },
    0x00ff: {
        f: $f0c1d849407dfccd$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $f0c1d849407dfccd$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x0161: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $f0c1d849407dfccd$var$parse_SupBook
    },
    0x01af: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $f0c1d849407dfccd$var$parse_TxO
    },
    0x01b7: {
        f: $f0c1d849407dfccd$var$parsebool
    },
    0x01b8: {
        f: $f0c1d849407dfccd$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $f0c1d849407dfccd$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x01c1: {
        f: $f0c1d849407dfccd$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x0200: {
        f: $f0c1d849407dfccd$var$parse_Dimensions
    },
    0x0201: {
        f: $f0c1d849407dfccd$var$parse_Blank
    },
    0x0203: {
        f: $f0c1d849407dfccd$var$parse_Number
    },
    0x0204: {
        f: $f0c1d849407dfccd$var$parse_Label
    },
    0x0205: {
        f: $f0c1d849407dfccd$var$parse_BoolErr
    },
    0x0207: {
        f: $f0c1d849407dfccd$var$parse_String
    },
    0x0208: {
        f: $f0c1d849407dfccd$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $f0c1d849407dfccd$var$parse_Array
    },
    0x0225: {
        f: $f0c1d849407dfccd$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $f0c1d849407dfccd$var$parse_Window2
    },
    0x027e: {
        f: $f0c1d849407dfccd$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $f0c1d849407dfccd$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $f0c1d849407dfccd$var$parse_ShrFmla
    },
    0x0800: {
        f: $f0c1d849407dfccd$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $f0c1d849407dfccd$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $f0c1d849407dfccd$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $f0c1d849407dfccd$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $f0c1d849407dfccd$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $f0c1d849407dfccd$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $f0c1d849407dfccd$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $f0c1d849407dfccd$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $f0c1d849407dfccd$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $f0c1d849407dfccd$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $f0c1d849407dfccd$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $f0c1d849407dfccd$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $f0c1d849407dfccd$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $f0c1d849407dfccd$var$parse_BIFF2INT
    },
    0x0003: {
        f: $f0c1d849407dfccd$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $f0c1d849407dfccd$var$parse_BIFF2STR
    },
    0x0005: {
        f: $f0c1d849407dfccd$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $f0c1d849407dfccd$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $f0c1d849407dfccd$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x001e: {
        f: $f0c1d849407dfccd$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $f0c1d849407dfccd$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $f0c1d849407dfccd$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $f0c1d849407dfccd$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $f0c1d849407dfccd$var$parse_BIFF2XF
    },
    0x0044: {
        f: $f0c1d849407dfccd$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $f0c1d849407dfccd$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $f0c1d849407dfccd$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $f0c1d849407dfccd$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $f0c1d849407dfccd$var$parse_Formula
    },
    0x0209: {
        f: $f0c1d849407dfccd$var$parse_BOF
    },
    0x0218: {
        f: $f0c1d849407dfccd$var$parse_Lbl
    },
    0x0223: {
        f: $f0c1d849407dfccd$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $f0c1d849407dfccd$var$parse_BIFF3XF
    },
    0x0406: {
        f: $f0c1d849407dfccd$var$parse_Formula
    },
    0x0409: {
        f: $f0c1d849407dfccd$var$parse_BOF
    },
    0x0443: {
        f: $f0c1d849407dfccd$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $f0c1d849407dfccd$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $f0c1d849407dfccd$var$is_buf(payload)) ba.push(payload);
}
function $f0c1d849407dfccd$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $f0c1d849407dfccd$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $f0c1d849407dfccd$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $f0c1d849407dfccd$var$new_buf(9);
    $f0c1d849407dfccd$var$write_BIFF2Cell(out, r, c);
    $f0c1d849407dfccd$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $f0c1d849407dfccd$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $f0c1d849407dfccd$var$new_buf(8 + 2 * val1.length);
    $f0c1d849407dfccd$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $f0c1d849407dfccd$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $f0c1d849407dfccd$var$write_biff_rec(ba, 0x001C, $f0c1d849407dfccd$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x001C, $f0c1d849407dfccd$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$f0c1d849407dfccd$var$write_biff_rec(ba, 0x001C, $f0c1d849407dfccd$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $f0c1d849407dfccd$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0002, $f0c1d849407dfccd$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0005, $f0c1d849407dfccd$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0005, $f0c1d849407dfccd$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0003, $f0c1d849407dfccd$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0005, $f0c1d849407dfccd$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0004, $f0c1d849407dfccd$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0001, $f0c1d849407dfccd$var$write_BIFF2Cell(null, R, C));
}
function $f0c1d849407dfccd$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $f0c1d849407dfccd$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $f0c1d849407dfccd$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $f0c1d849407dfccd$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $f0c1d849407dfccd$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $f0c1d849407dfccd$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $f0c1d849407dfccd$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $f0c1d849407dfccd$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0022, $f0c1d849407dfccd$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $f0c1d849407dfccd$var$buf_array();
    $f0c1d849407dfccd$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x001E, $f0c1d849407dfccd$var$write_BIFF2Format(f));
        else $f0c1d849407dfccd$var$write_biff_rec(ba, 0x041E, $f0c1d849407dfccd$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0043, $f0c1d849407dfccd$var$write_BIFF2XF(xf));
                break;
            case 3:
                $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0243, $f0c1d849407dfccd$var$write_BIFF3XF(xf));
                break;
            case 4:
                $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0443, $f0c1d849407dfccd$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $f0c1d849407dfccd$var$b8oid = 1, $f0c1d849407dfccd$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $f0c1d849407dfccd$var$write_MsoDrawingGroup() {
    var buf = $f0c1d849407dfccd$var$new_buf(82 + 8 * $f0c1d849407dfccd$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $f0c1d849407dfccd$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $f0c1d849407dfccd$var$b8ocnts.length);
    buf.write_shift(4, $f0c1d849407dfccd$var$b8oid);
    buf.write_shift(4, $f0c1d849407dfccd$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $f0c1d849407dfccd$var$b8ocnts.length; ++i)acc += $f0c1d849407dfccd$var$b8ocnts[i] && $f0c1d849407dfccd$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $f0c1d849407dfccd$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $f0c1d849407dfccd$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $f0c1d849407dfccd$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $f0c1d849407dfccd$var$buf_array(), baseid = $f0c1d849407dfccd$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$f0c1d849407dfccd$var$b8oid;
        var oasc = $f0c1d849407dfccd$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $f0c1d849407dfccd$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $f0c1d849407dfccd$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $f0c1d849407dfccd$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $f0c1d849407dfccd$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $f0c1d849407dfccd$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $f0c1d849407dfccd$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $f0c1d849407dfccd$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $f0c1d849407dfccd$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $f0c1d849407dfccd$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $f0c1d849407dfccd$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $f0c1d849407dfccd$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $f0c1d849407dfccd$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $f0c1d849407dfccd$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $f0c1d849407dfccd$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $f0c1d849407dfccd$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $f0c1d849407dfccd$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $f0c1d849407dfccd$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $f0c1d849407dfccd$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $f0c1d849407dfccd$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x001C, n);
    });
    $f0c1d849407dfccd$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $f0c1d849407dfccd$var$b8oid
    ]);
    ++$f0c1d849407dfccd$var$b8oid;
}
function $f0c1d849407dfccd$var$write_FONTS_biff8(ba, data, opts) {
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0031 /* Font */ , $f0c1d849407dfccd$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $f0c1d849407dfccd$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x041E /* Format */ , $f0c1d849407dfccd$var$write_Format(i, NF[i], opts));
    });
}
function $f0c1d849407dfccd$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $f0c1d849407dfccd$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $f0c1d849407dfccd$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $f0c1d849407dfccd$var$write_Ref8U($f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $f0c1d849407dfccd$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$f0c1d849407dfccd$var$write_biff_rec(ba, 0x00e0 /* XF */ , $f0c1d849407dfccd$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00e0 /* XF */ , $f0c1d849407dfccd$var$write_XF(c, 0, opts));
    });
}
function $f0c1d849407dfccd$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $f0c1d849407dfccd$var$write_HLink(HL));
        if (HL[1].Tooltip) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $f0c1d849407dfccd$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $f0c1d849407dfccd$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $f0c1d849407dfccd$var$write_ColInfo($f0c1d849407dfccd$var$col_obj_w(idx, col), idx));
    });
}
function $f0c1d849407dfccd$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0201 /* Blank */ , $f0c1d849407dfccd$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0006 /* Formula */ , $f0c1d849407dfccd$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $f0c1d849407dfccd$var$datenum($f0c1d849407dfccd$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $f0c1d849407dfccd$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $f0c1d849407dfccd$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0203 /* Number */ , $f0c1d849407dfccd$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $f0c1d849407dfccd$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $f0c1d849407dfccd$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $f0c1d849407dfccd$var$write_LabelSst(R, C, isst, os, opts));
            } else $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0204 /* Label */ , $f0c1d849407dfccd$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0201 /* Blank */ , $f0c1d849407dfccd$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $f0c1d849407dfccd$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $f0c1d849407dfccd$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0809, $f0c1d849407dfccd$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $f0c1d849407dfccd$var$writeuint16(1));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $f0c1d849407dfccd$var$writeuint16(100));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $f0c1d849407dfccd$var$writebool(true));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $f0c1d849407dfccd$var$write_Xnum(0.001));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $f0c1d849407dfccd$var$writebool(true));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $f0c1d849407dfccd$var$writeuint16(1));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0080 /* Guts */ , $f0c1d849407dfccd$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $f0c1d849407dfccd$var$writebool(false));
    /* ... */ if (b8) $f0c1d849407dfccd$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $f0c1d849407dfccd$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $f0c1d849407dfccd$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $f0c1d849407dfccd$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $f0c1d849407dfccd$var$write_comments_biff8(ba, comments);
    else $f0c1d849407dfccd$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x023e /* Window2 */ , $f0c1d849407dfccd$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $f0c1d849407dfccd$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $f0c1d849407dfccd$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $f0c1d849407dfccd$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $f0c1d849407dfccd$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $f0c1d849407dfccd$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $f0c1d849407dfccd$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $f0c1d849407dfccd$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $f0c1d849407dfccd$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x0809, $f0c1d849407dfccd$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $f0c1d849407dfccd$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $f0c1d849407dfccd$var$writeuint16(0x04b0) : null);
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x00c1 /* Mms */ , $f0c1d849407dfccd$var$writezeroes(2));
    if (b5) $f0c1d849407dfccd$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $f0c1d849407dfccd$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $f0c1d849407dfccd$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $f0c1d849407dfccd$var$write_biff_rec(A, 0x0042 /* CodePage */ , $f0c1d849407dfccd$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x0161 /* DSF */ , $f0c1d849407dfccd$var$writeuint16(0));
    if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x013d /* RRTabId */ , $f0c1d849407dfccd$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $f0c1d849407dfccd$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $f0c1d849407dfccd$var$write_biff_rec(A, 0x01ba /* CodeName */ , $f0c1d849407dfccd$var$write_XLUnicodeString(cname, opts));
    }
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $f0c1d849407dfccd$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $f0c1d849407dfccd$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x0012 /* Protect */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x0013 /* Password */ , $f0c1d849407dfccd$var$writeuint16(0));
    if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $f0c1d849407dfccd$var$writebool(false));
    if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $f0c1d849407dfccd$var$writeuint16(0));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x003d /* Window1 */ , $f0c1d849407dfccd$var$write_Window1(opts));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x0040 /* Backup */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x008d /* HideObj */ , $f0c1d849407dfccd$var$writeuint16(0));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $f0c1d849407dfccd$var$writebool($f0c1d849407dfccd$var$safe1904(wb) == "true"));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $f0c1d849407dfccd$var$writebool(true));
    if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $f0c1d849407dfccd$var$writebool(false));
    $f0c1d849407dfccd$var$write_biff_rec(A, 0x00DA /* BookBool */ , $f0c1d849407dfccd$var$writeuint16(0));
    /* ... */ $f0c1d849407dfccd$var$write_FONTS_biff8(A, wb, opts);
    $f0c1d849407dfccd$var$write_FMTS_biff8(A, wb.SSF, opts);
    $f0c1d849407dfccd$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $f0c1d849407dfccd$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $f0c1d849407dfccd$var$writebool(false));
    var a = A.end();
    var C = $f0c1d849407dfccd$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $f0c1d849407dfccd$var$write_biff_rec(C, 0x008C /* Country */ , $f0c1d849407dfccd$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $f0c1d849407dfccd$var$b8ocnts.length) $f0c1d849407dfccd$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $f0c1d849407dfccd$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $f0c1d849407dfccd$var$write_biff_continue(C, 0x00FC /* SST */ , $f0c1d849407dfccd$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $f0c1d849407dfccd$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $f0c1d849407dfccd$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $f0c1d849407dfccd$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $f0c1d849407dfccd$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $f0c1d849407dfccd$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $f0c1d849407dfccd$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (wb && wb.SSF) {
        $f0c1d849407dfccd$var$make_ssf();
        $f0c1d849407dfccd$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $f0c1d849407dfccd$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $f0c1d849407dfccd$var$b8oid = 1;
    $f0c1d849407dfccd$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $f0c1d849407dfccd$var$fix_write_opts(o);
    o.cellXfs = [];
    $f0c1d849407dfccd$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $f0c1d849407dfccd$var$write_ws_biff8(i, o, wb);
    bufs.unshift($f0c1d849407dfccd$var$write_biff8_global(wb, bufs, o));
    return $f0c1d849407dfccd$var$bconcat(bufs);
}
function $f0c1d849407dfccd$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $f0c1d849407dfccd$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $f0c1d849407dfccd$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $f0c1d849407dfccd$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $f0c1d849407dfccd$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $f0c1d849407dfccd$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $f0c1d849407dfccd$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $f0c1d849407dfccd$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $f0c1d849407dfccd$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(m))) o = {
                t: 'n',
                v: $f0c1d849407dfccd$var$fuzzynum(m)
            };
            else if (!isNaN($f0c1d849407dfccd$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $f0c1d849407dfccd$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $f0c1d849407dfccd$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $f0c1d849407dfccd$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $f0c1d849407dfccd$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $f0c1d849407dfccd$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $f0c1d849407dfccd$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$f0c1d849407dfccd$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $f0c1d849407dfccd$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $f0c1d849407dfccd$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $f0c1d849407dfccd$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $f0c1d849407dfccd$var$escapehtml(cell.w || ($f0c1d849407dfccd$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $f0c1d849407dfccd$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $f0c1d849407dfccd$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($f0c1d849407dfccd$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $f0c1d849407dfccd$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $f0c1d849407dfccd$var$HTML_END = '</body></html>';
function $f0c1d849407dfccd$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $f0c1d849407dfccd$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $f0c1d849407dfccd$var$sheet_to_workbook($f0c1d849407dfccd$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $f0c1d849407dfccd$var$book_new();
    mtch.forEach(function(s, idx) {
        $f0c1d849407dfccd$var$book_append_sheet(wb, $f0c1d849407dfccd$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $f0c1d849407dfccd$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $f0c1d849407dfccd$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $f0c1d849407dfccd$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $f0c1d849407dfccd$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $f0c1d849407dfccd$var$decode_range(ws['!ref'] || "A1");
    out.push($f0c1d849407dfccd$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($f0c1d849407dfccd$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $f0c1d849407dfccd$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $f0c1d849407dfccd$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($f0c1d849407dfccd$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $f0c1d849407dfccd$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $f0c1d849407dfccd$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $f0c1d849407dfccd$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $f0c1d849407dfccd$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($f0c1d849407dfccd$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $f0c1d849407dfccd$var$fuzzynum(v)
                };
                else if (!isNaN($f0c1d849407dfccd$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $f0c1d849407dfccd$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $f0c1d849407dfccd$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $f0c1d849407dfccd$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $f0c1d849407dfccd$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $f0c1d849407dfccd$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $f0c1d849407dfccd$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$f0c1d849407dfccd$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $f0c1d849407dfccd$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $f0c1d849407dfccd$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $f0c1d849407dfccd$var$sheet_add_dom(ws, table, _opts);
}
function $f0c1d849407dfccd$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $f0c1d849407dfccd$var$sheet_to_workbook($f0c1d849407dfccd$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $f0c1d849407dfccd$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $f0c1d849407dfccd$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $f0c1d849407dfccd$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $f0c1d849407dfccd$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $f0c1d849407dfccd$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $f0c1d849407dfccd$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $f0c1d849407dfccd$var$xlml_normalize(d);
    $f0c1d849407dfccd$var$xlmlregex.lastIndex = 0;
    str = $f0c1d849407dfccd$var$remove_doctype($f0c1d849407dfccd$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $f0c1d849407dfccd$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $f0c1d849407dfccd$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            NF += "0." + $f0c1d849407dfccd$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $f0c1d849407dfccd$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($f0c1d849407dfccd$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $f0c1d849407dfccd$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $f0c1d849407dfccd$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $f0c1d849407dfccd$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $f0c1d849407dfccd$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if ($f0c1d849407dfccd$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $f0c1d849407dfccd$var$fill("0", +y["min-integer-digits"] || 1);
            if ($f0c1d849407dfccd$var$parsexmlbool(y["grouping"])) tNF = $f0c1d849407dfccd$var$commaify($f0c1d849407dfccd$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $f0c1d849407dfccd$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $f0c1d849407dfccd$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex;
                etpos = -+$f0c1d849407dfccd$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $f0c1d849407dfccd$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($f0c1d849407dfccd$var$DENSE != null && opts.dense == null) opts.dense = $f0c1d849407dfccd$var$DENSE;
    var str = $f0c1d849407dfccd$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $f0c1d849407dfccd$var$xlmlregex.lastIndex = 0;
    str = $f0c1d849407dfccd$var$remove_doctype($f0c1d849407dfccd$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $f0c1d849407dfccd$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$f0c1d849407dfccd$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $f0c1d849407dfccd$var$ods_to_csf_formula($f0c1d849407dfccd$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $f0c1d849407dfccd$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                ctag2 = $f0c1d849407dfccd$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $f0c1d849407dfccd$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $f0c1d849407dfccd$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $f0c1d849407dfccd$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $f0c1d849407dfccd$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $f0c1d849407dfccd$var$fmt_is_date(q.z)) {
                            q.v = $f0c1d849407dfccd$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $f0c1d849407dfccd$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $f0c1d849407dfccd$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $f0c1d849407dfccd$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $f0c1d849407dfccd$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $f0c1d849407dfccd$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $f0c1d849407dfccd$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $f0c1d849407dfccd$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $f0c1d849407dfccd$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $f0c1d849407dfccd$var$dup(q);
                        } else {
                            ws[$f0c1d849407dfccd$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$f0c1d849407dfccd$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $f0c1d849407dfccd$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $f0c1d849407dfccd$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex;
                $f0c1d849407dfccd$var$parse_ods_styles(str.slice(nfidx, $f0c1d849407dfccd$var$xlmlregex.lastIndex), _opts, number_format_map);
                $f0c1d849407dfccd$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $f0c1d849407dfccd$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            _Ref = $f0c1d849407dfccd$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $f0c1d849407dfccd$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $f0c1d849407dfccd$var$ods_to_csf_3D($f0c1d849407dfccd$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $f0c1d849407dfccd$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $f0c1d849407dfccd$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $f0c1d849407dfccd$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $f0c1d849407dfccd$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $f0c1d849407dfccd$var$parse_manifest($f0c1d849407dfccd$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $f0c1d849407dfccd$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $f0c1d849407dfccd$var$parse_ods_styles($f0c1d849407dfccd$var$utf8read(styles), opts);
    var content = $f0c1d849407dfccd$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $f0c1d849407dfccd$var$parse_content_xml($f0c1d849407dfccd$var$utf8read(content), opts, Styles);
    if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $f0c1d849407dfccd$var$parse_core_props($f0c1d849407dfccd$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $f0c1d849407dfccd$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $f0c1d849407dfccd$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $f0c1d849407dfccd$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $f0c1d849407dfccd$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $f0c1d849407dfccd$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $f0c1d849407dfccd$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $f0c1d849407dfccd$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $f0c1d849407dfccd$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $f0c1d849407dfccd$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $f0c1d849407dfccd$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $f0c1d849407dfccd$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $f0c1d849407dfccd$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $f0c1d849407dfccd$var$writextag("number:" + type + "-style", payload, nopts);
}
function $f0c1d849407dfccd$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $f0c1d849407dfccd$var$csf_to_ods_3D(name.Ref);
        return "        " + $f0c1d849407dfccd$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $f0c1d849407dfccd$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $f0c1d849407dfccd$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $f0c1d849407dfccd$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $f0c1d849407dfccd$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $f0c1d849407dfccd$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $f0c1d849407dfccd$var$escapexml($f0c1d849407dfccd$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $f0c1d849407dfccd$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $f0c1d849407dfccd$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $f0c1d849407dfccd$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $f0c1d849407dfccd$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $f0c1d849407dfccd$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $f0c1d849407dfccd$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $f0c1d849407dfccd$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $f0c1d849407dfccd$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($f0c1d849407dfccd$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $f0c1d849407dfccd$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$f0c1d849407dfccd$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $f0c1d849407dfccd$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $f0c1d849407dfccd$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $f0c1d849407dfccd$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $f0c1d849407dfccd$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $f0c1d849407dfccd$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($f0c1d849407dfccd$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($f0c1d849407dfccd$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $f0c1d849407dfccd$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $f0c1d849407dfccd$var$write_content_ods(wb, opts);
    var zip = $f0c1d849407dfccd$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$XML_HEADER + $f0c1d849407dfccd$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $f0c1d849407dfccd$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $f0c1d849407dfccd$require$Buffer !== "undefined") {
            if (typeof $f0c1d849407dfccd$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $f0c1d849407dfccd$require$Buffer.from == "function" ? $f0c1d849407dfccd$require$Buffer.from([
                72,
                62
            ]) : new $f0c1d849407dfccd$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $f0c1d849407dfccd$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $f0c1d849407dfccd$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $f0c1d849407dfccd$var$utf8read($f0c1d849407dfccd$var$a2s(u8));
}
function $f0c1d849407dfccd$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $f0c1d849407dfccd$var$s2a($f0c1d849407dfccd$var$utf8write(str));
}
function $f0c1d849407dfccd$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $f0c1d849407dfccd$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $f0c1d849407dfccd$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $f0c1d849407dfccd$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $f0c1d849407dfccd$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $f0c1d849407dfccd$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$f0c1d849407dfccd$var$subarray](0, L);
}
function $f0c1d849407dfccd$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($f0c1d849407dfccd$var$parse_varint49(buf, ptr));
    return out;
}
function $f0c1d849407dfccd$var$write_packed_varints(nums) {
    return $f0c1d849407dfccd$var$u8concat(nums.map(function(x) {
        return $f0c1d849407dfccd$var$write_varint49(x);
    }));
}
function $f0c1d849407dfccd$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $f0c1d849407dfccd$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $f0c1d849407dfccd$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $f0c1d849407dfccd$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$f0c1d849407dfccd$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$f0c1d849407dfccd$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $f0c1d849407dfccd$var$parse_varint49(buf, ptr);
                data = buf[$f0c1d849407dfccd$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$f0c1d849407dfccd$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $f0c1d849407dfccd$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($f0c1d849407dfccd$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($f0c1d849407dfccd$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $f0c1d849407dfccd$var$u8concat(out);
}
function $f0c1d849407dfccd$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $f0c1d849407dfccd$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $f0c1d849407dfccd$var$parse_varint49(buf, ptr);
        var ai = $f0c1d849407dfccd$var$parse_shallow(buf[$f0c1d849407dfccd$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $f0c1d849407dfccd$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $f0c1d849407dfccd$var$parse_shallow(b.data);
            var fl = $f0c1d849407dfccd$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$f0c1d849407dfccd$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $f0c1d849407dfccd$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $f0c1d849407dfccd$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $f0c1d849407dfccd$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $f0c1d849407dfccd$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $f0c1d849407dfccd$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $f0c1d849407dfccd$var$write_shallow(ai);
        bufs.push($f0c1d849407dfccd$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $f0c1d849407dfccd$var$u8concat(bufs);
}
function $f0c1d849407dfccd$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $f0c1d849407dfccd$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$f0c1d849407dfccd$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$f0c1d849407dfccd$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$f0c1d849407dfccd$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$f0c1d849407dfccd$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $f0c1d849407dfccd$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $f0c1d849407dfccd$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $f0c1d849407dfccd$var$parse_snappy_chunk(t, buf[$f0c1d849407dfccd$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $f0c1d849407dfccd$var$u8concat(out);
}
function $f0c1d849407dfccd$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $f0c1d849407dfccd$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$f0c1d849407dfccd$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $f0c1d849407dfccd$var$u8concat(out);
}
var $f0c1d849407dfccd$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $f0c1d849407dfccd$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $f0c1d849407dfccd$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $f0c1d849407dfccd$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $f0c1d849407dfccd$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $f0c1d849407dfccd$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $f0c1d849407dfccd$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $f0c1d849407dfccd$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $f0c1d849407dfccd$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $f0c1d849407dfccd$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $f0c1d849407dfccd$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$f0c1d849407dfccd$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$f0c1d849407dfccd$var$subarray](0, 4)));
    }
    if (zidx > -1) $f0c1d849407dfccd$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $f0c1d849407dfccd$var$parse_new_storage(buf, lut, opts) {
    var dv = $f0c1d849407dfccd$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $f0c1d849407dfccd$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $f0c1d849407dfccd$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $f0c1d849407dfccd$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $f0c1d849407dfccd$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$f0c1d849407dfccd$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$f0c1d849407dfccd$var$subarray](0, 4)));
    }
    doff += $f0c1d849407dfccd$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $f0c1d849407dfccd$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $f0c1d849407dfccd$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $f0c1d849407dfccd$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $f0c1d849407dfccd$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $f0c1d849407dfccd$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($f0c1d849407dfccd$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $f0c1d849407dfccd$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($f0c1d849407dfccd$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$f0c1d849407dfccd$var$subarray](0, l);
}
function $f0c1d849407dfccd$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $f0c1d849407dfccd$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$f0c1d849407dfccd$var$subarray](0, l);
}
function $f0c1d849407dfccd$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $f0c1d849407dfccd$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $f0c1d849407dfccd$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $f0c1d849407dfccd$var$parse_TSP_Reference(buf) {
    var pb = $f0c1d849407dfccd$var$parse_shallow(buf);
    return $f0c1d849407dfccd$var$varint_to_i32(pb[1][0].data);
}
function $f0c1d849407dfccd$var$write_TSP_Reference(idx) {
    return $f0c1d849407dfccd$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(idx)
            }
        ]
    ]);
}
function $f0c1d849407dfccd$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $f0c1d849407dfccd$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $f0c1d849407dfccd$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $f0c1d849407dfccd$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $f0c1d849407dfccd$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $f0c1d849407dfccd$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $f0c1d849407dfccd$var$parse_TST_TableDataList(M, root) {
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    var type = $f0c1d849407dfccd$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $f0c1d849407dfccd$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $f0c1d849407dfccd$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $f0c1d849407dfccd$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$f0c1d849407dfccd$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $f0c1d849407dfccd$var$parse_shallow(rt.data);
                var rtpref = M[$f0c1d849407dfccd$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $f0c1d849407dfccd$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $f0c1d849407dfccd$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $f0c1d849407dfccd$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $f0c1d849407dfccd$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $f0c1d849407dfccd$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$f0c1d849407dfccd$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $f0c1d849407dfccd$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $f0c1d849407dfccd$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $f0c1d849407dfccd$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $f0c1d849407dfccd$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $f0c1d849407dfccd$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$f0c1d849407dfccd$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $f0c1d849407dfccd$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $f0c1d849407dfccd$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $f0c1d849407dfccd$var$parse_shallow(u8);
    var R = $f0c1d849407dfccd$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $f0c1d849407dfccd$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $f0c1d849407dfccd$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $f0c1d849407dfccd$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$f0c1d849407dfccd$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$f0c1d849407dfccd$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $f0c1d849407dfccd$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($f0c1d849407dfccd$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $f0c1d849407dfccd$var$mappa(pb[5], function(u8) {
        return $f0c1d849407dfccd$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $f0c1d849407dfccd$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $f0c1d849407dfccd$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $f0c1d849407dfccd$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $f0c1d849407dfccd$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$f0c1d849407dfccd$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $f0c1d849407dfccd$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $f0c1d849407dfccd$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$f0c1d849407dfccd$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($f0c1d849407dfccd$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $f0c1d849407dfccd$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $f0c1d849407dfccd$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $f0c1d849407dfccd$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($f0c1d849407dfccd$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($f0c1d849407dfccd$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $f0c1d849407dfccd$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $f0c1d849407dfccd$var$parse_shallow(pb[4][0].data);
    var lut = $f0c1d849407dfccd$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $f0c1d849407dfccd$var$parse_TST_TableDataList(M, M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $f0c1d849407dfccd$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $f0c1d849407dfccd$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $f0c1d849407dfccd$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $f0c1d849407dfccd$var$varint_to_i32(kv[1][0].data);
        var tidx = $f0c1d849407dfccd$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $f0c1d849407dfccd$var$parse_shallow(t.data);
        var ref2 = M[$f0c1d849407dfccd$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $f0c1d849407dfccd$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $f0c1d849407dfccd$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $f0c1d849407dfccd$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$f0c1d849407dfccd$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $f0c1d849407dfccd$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $f0c1d849407dfccd$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $f0c1d849407dfccd$var$parse_shallow(pi.data);
            var origin = $f0c1d849407dfccd$var$u8_to_dataview($f0c1d849407dfccd$var$parse_shallow(merge[1][0].data)[1][0].data), size = $f0c1d849407dfccd$var$u8_to_dataview($f0c1d849407dfccd$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $f0c1d849407dfccd$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $f0c1d849407dfccd$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $f0c1d849407dfccd$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $f0c1d849407dfccd$var$parse_shallow(u);
                var formula = $f0c1d849407dfccd$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $f0c1d849407dfccd$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $f0c1d849407dfccd$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $f0c1d849407dfccd$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $f0c1d849407dfccd$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $f0c1d849407dfccd$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $f0c1d849407dfccd$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $f0c1d849407dfccd$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $f0c1d849407dfccd$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $f0c1d849407dfccd$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $f0c1d849407dfccd$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $f0c1d849407dfccd$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$f0c1d849407dfccd$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $f0c1d849407dfccd$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $f0c1d849407dfccd$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $f0c1d849407dfccd$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $f0c1d849407dfccd$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $f0c1d849407dfccd$var$mappa(pb[2], $f0c1d849407dfccd$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $f0c1d849407dfccd$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($f0c1d849407dfccd$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $f0c1d849407dfccd$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $f0c1d849407dfccd$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $f0c1d849407dfccd$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $f0c1d849407dfccd$var$mappa(pb[1], $f0c1d849407dfccd$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $f0c1d849407dfccd$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $f0c1d849407dfccd$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $f0c1d849407dfccd$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $f0c1d849407dfccd$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $f0c1d849407dfccd$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $f0c1d849407dfccd$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $f0c1d849407dfccd$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $f0c1d849407dfccd$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $f0c1d849407dfccd$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $f0c1d849407dfccd$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $f0c1d849407dfccd$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $f0c1d849407dfccd$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $f0c1d849407dfccd$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $f0c1d849407dfccd$var$write_new_storage(data[C], lut);
                    _celload = $f0c1d849407dfccd$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $f0c1d849407dfccd$var$write_new_storage(data[C], lut);
                _celload = $f0c1d849407dfccd$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $f0c1d849407dfccd$var$write_new_storage(data[C], lut);
                _celload = $f0c1d849407dfccd$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $f0c1d849407dfccd$var$write_varint49(cnt);
    tri[5][0].data = $f0c1d849407dfccd$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $f0c1d849407dfccd$var$u8concat(cell_storage);
    tri[3][0].data = $f0c1d849407dfccd$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $f0c1d849407dfccd$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $f0c1d849407dfccd$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $f0c1d849407dfccd$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $f0c1d849407dfccd$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $f0c1d849407dfccd$var$parse_iwa_file($f0c1d849407dfccd$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $f0c1d849407dfccd$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $f0c1d849407dfccd$var$parse_iwa_file($f0c1d849407dfccd$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($f0c1d849407dfccd$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $f0c1d849407dfccd$var$write_TSP_Color_RGB(r, g, b) {
    return $f0c1d849407dfccd$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $f0c1d849407dfccd$var$write_varint49(1)
            }
        ]
    ]);
}
function $f0c1d849407dfccd$var$get_author_color(n) {
    switch(n){
        case 0:
            return $f0c1d849407dfccd$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $f0c1d849407dfccd$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $f0c1d849407dfccd$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $f0c1d849407dfccd$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $f0c1d849407dfccd$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $f0c1d849407dfccd$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $f0c1d849407dfccd$var$build_numbers_deps(cfb);
    var docroot = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $f0c1d849407dfccd$var$mappa($f0c1d849407dfccd$var$parse_shallow(docroot.messages[0].data)[1], $f0c1d849407dfccd$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $f0c1d849407dfccd$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $f0c1d849407dfccd$var$mappa($f0c1d849407dfccd$var$parse_shallow(docroot.messages[0].data)[1], $f0c1d849407dfccd$var$parse_TSP_Reference);
        }
        $f0c1d849407dfccd$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $f0c1d849407dfccd$var$parse_iwa_file($f0c1d849407dfccd$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $f0c1d849407dfccd$var$parse_iwa_file($f0c1d849407dfccd$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $f0c1d849407dfccd$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $f0c1d849407dfccd$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $f0c1d849407dfccd$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $f0c1d849407dfccd$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $f0c1d849407dfccd$var$write_varint49(Math.max(newid + 1, $f0c1d849407dfccd$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $f0c1d849407dfccd$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $f0c1d849407dfccd$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file([
        {
            id: id,
            messages: [
                $f0c1d849407dfccd$var$write_iwam(type, $f0c1d849407dfccd$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
        $f0c1d849407dfccd$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
    });
    return id;
}
function $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $f0c1d849407dfccd$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $f0c1d849407dfccd$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $f0c1d849407dfccd$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $f0c1d849407dfccd$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $f0c1d849407dfccd$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $f0c1d849407dfccd$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $f0c1d849407dfccd$var$write_shallow(parent);
}
function $f0c1d849407dfccd$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $f0c1d849407dfccd$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $f0c1d849407dfccd$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $f0c1d849407dfccd$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $f0c1d849407dfccd$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $f0c1d849407dfccd$var$varint_to_i32($f0c1d849407dfccd$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $f0c1d849407dfccd$var$write_shallow(parent);
}
function $f0c1d849407dfccd$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $f0c1d849407dfccd$var$parse_shallow(docroot.messages[0].data);
        sheetref = $f0c1d849407dfccd$var$parse_TSP_Reference($f0c1d849407dfccd$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $f0c1d849407dfccd$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $f0c1d849407dfccd$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $f0c1d849407dfccd$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(doc);
    });
    var tiaref = -1;
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $f0c1d849407dfccd$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $f0c1d849407dfccd$var$mappa(sa[2], $f0c1d849407dfccd$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $f0c1d849407dfccd$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $f0c1d849407dfccd$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $f0c1d849407dfccd$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $f0c1d849407dfccd$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
            });
            $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(sa);
    });
    var tmaref = -1;
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $f0c1d849407dfccd$var$parse_shallow(tiaroot.messages[0].data);
        var da = $f0c1d849407dfccd$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $f0c1d849407dfccd$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $f0c1d849407dfccd$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $f0c1d849407dfccd$var$write_shallow(da);
        var oldtmaref = $f0c1d849407dfccd$var$parse_TSP_Reference(tia[2][0].data);
        $f0c1d849407dfccd$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $f0c1d849407dfccd$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $f0c1d849407dfccd$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $f0c1d849407dfccd$var$write_TSP_Reference(tmaref);
        var tma = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(tia);
    });
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $f0c1d849407dfccd$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $f0c1d849407dfccd$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $f0c1d849407dfccd$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $f0c1d849407dfccd$var$parse_shallow(tma[45][0].data);
            var ref = $f0c1d849407dfccd$var$parse_TSP_Reference(srrta[1][0].data);
            $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $f0c1d849407dfccd$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $f0c1d849407dfccd$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $f0c1d849407dfccd$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $f0c1d849407dfccd$var$parse_TSP_Reference(hsea[8][0].data);
                    $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $f0c1d849407dfccd$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $f0c1d849407dfccd$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $f0c1d849407dfccd$var$parse_TSP_Reference(store[n][0].data);
            var newref = $f0c1d849407dfccd$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, oldref);
            $f0c1d849407dfccd$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                    $f0c1d849407dfccd$var$numbers_add_meta(mlist, newref, newloc);
                    $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $f0c1d849407dfccd$var$write_TSP_Reference(newref);
        });
        var row_headers = $f0c1d849407dfccd$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $f0c1d849407dfccd$var$parse_TSP_Reference(tspref.data);
            var newref = $f0c1d849407dfccd$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, oldref);
            $f0c1d849407dfccd$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                    $f0c1d849407dfccd$var$numbers_add_meta(mlist, newref, newloc);
                    $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
                });
            }
            tspref.data = $f0c1d849407dfccd$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $f0c1d849407dfccd$var$write_shallow(row_headers);
        var tiles = $f0c1d849407dfccd$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $f0c1d849407dfccd$var$parse_shallow(t.data);
            var oldtileref = $f0c1d849407dfccd$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $f0c1d849407dfccd$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, oldtileref);
                $f0c1d849407dfccd$var$numbers_add_oref(tmaroot, newtileref);
                $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file([
                    oldtile
                ])));
                $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $f0c1d849407dfccd$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $f0c1d849407dfccd$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $f0c1d849407dfccd$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $f0c1d849407dfccd$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $f0c1d849407dfccd$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $f0c1d849407dfccd$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(Math.max(newtileref + 1, $f0c1d849407dfccd$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $f0c1d849407dfccd$var$write_TSP_Reference(newtileref);
            t.data = $f0c1d849407dfccd$var$write_shallow(tst);
        });
        store[3][0].data = $f0c1d849407dfccd$var$write_shallow(tiles);
        tma[4][0].data = $f0c1d849407dfccd$var$write_shallow(store);
        tmaroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(tma);
    });
}
function $f0c1d849407dfccd$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $f0c1d849407dfccd$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $f0c1d849407dfccd$var$stru8(wsname)
            }
        ];
        drawables = $f0c1d849407dfccd$var$mappa(sheetref[2], $f0c1d849407dfccd$var$parse_TSP_Reference);
        docroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(sheetref);
    });
    var tia = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $f0c1d849407dfccd$var$parse_TSP_Reference($f0c1d849407dfccd$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $f0c1d849407dfccd$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $f0c1d849407dfccd$var$USE_WIDE_ROWS = true;
function $f0c1d849407dfccd$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($f0c1d849407dfccd$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $f0c1d849407dfccd$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $f0c1d849407dfccd$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $f0c1d849407dfccd$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $f0c1d849407dfccd$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $f0c1d849407dfccd$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $f0c1d849407dfccd$var$parse_TSP_Reference($f0c1d849407dfccd$var$parse_shallow(store[1][0].data)[2][0].data);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $f0c1d849407dfccd$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $f0c1d849407dfccd$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $f0c1d849407dfccd$var$write_varint49(R2);
            _bucket[4][0].data = $f0c1d849407dfccd$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $f0c1d849407dfccd$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $f0c1d849407dfccd$var$write_shallow(base_bucket);
    });
    var col_header_ref = $f0c1d849407dfccd$var$parse_TSP_Reference(store[2][0].data);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $f0c1d849407dfccd$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $f0c1d849407dfccd$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $f0c1d849407dfccd$var$write_varint49(C);
            _bucket[4][0].data = $f0c1d849407dfccd$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $f0c1d849407dfccd$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $f0c1d849407dfccd$var$write_shallow(base_bucket);
    });
    var rbtree = $f0c1d849407dfccd$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $f0c1d849407dfccd$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $f0c1d849407dfccd$var$write_varint49(tstride)
        }
    ];
    var tileref = $f0c1d849407dfccd$var$parse_TSP_Reference($f0c1d849407dfccd$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $f0c1d849407dfccd$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $f0c1d849407dfccd$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $f0c1d849407dfccd$var$varint_to_i32($f0c1d849407dfccd$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $f0c1d849407dfccd$var$varint_to_i32($f0c1d849407dfccd$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $f0c1d849407dfccd$var$varint_to_i32($f0c1d849407dfccd$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $f0c1d849407dfccd$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
    });
    $f0c1d849407dfccd$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $f0c1d849407dfccd$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49($f0c1d849407dfccd$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $f0c1d849407dfccd$var$write_TST_TileRowInfo(data[R], LUT, $f0c1d849407dfccd$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $f0c1d849407dfccd$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $f0c1d849407dfccd$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $f0c1d849407dfccd$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $f0c1d849407dfccd$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $f0c1d849407dfccd$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $f0c1d849407dfccd$var$write_iwam(6002, $f0c1d849407dfccd$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $f0c1d849407dfccd$var$compress_iwa_file($f0c1d849407dfccd$var$write_iwa_file([
            newtile
        ]));
        $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $f0c1d849407dfccd$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $f0c1d849407dfccd$var$write_varint49(Math.max(newtileid + 1, $f0c1d849407dfccd$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
        });
        $f0c1d849407dfccd$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $f0c1d849407dfccd$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $f0c1d849407dfccd$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $f0c1d849407dfccd$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $f0c1d849407dfccd$var$write_shallow(tilestore);
    store[9][0].data = $f0c1d849407dfccd$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $f0c1d849407dfccd$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $f0c1d849407dfccd$var$write_iwam(6144, $f0c1d849407dfccd$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $f0c1d849407dfccd$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $f0c1d849407dfccd$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $f0c1d849407dfccd$var$write_TSP_Reference(mergeid)
            }
        ];
        $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
            $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
        });
        $f0c1d849407dfccd$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $f0c1d849407dfccd$var$parse_TSP_Reference(store[4][0].data);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $f0c1d849407dfccd$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $f0c1d849407dfccd$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(sstdata);
    });
    var rsstref = $f0c1d849407dfccd$var$parse_TSP_Reference(store[17][0].data);
    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $f0c1d849407dfccd$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $f0c1d849407dfccd$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $f0c1d849407dfccd$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $f0c1d849407dfccd$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $f0c1d849407dfccd$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $f0c1d849407dfccd$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $f0c1d849407dfccd$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $f0c1d849407dfccd$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $f0c1d849407dfccd$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $f0c1d849407dfccd$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $f0c1d849407dfccd$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $f0c1d849407dfccd$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $f0c1d849407dfccd$var$numbers_add_oref(rsstroot, rtpaid);
            $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $f0c1d849407dfccd$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $f0c1d849407dfccd$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $f0c1d849407dfccd$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $f0c1d849407dfccd$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                        $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $f0c1d849407dfccd$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $f0c1d849407dfccd$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $f0c1d849407dfccd$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $f0c1d849407dfccd$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $f0c1d849407dfccd$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $f0c1d849407dfccd$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $f0c1d849407dfccd$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $f0c1d849407dfccd$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $f0c1d849407dfccd$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $f0c1d849407dfccd$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $f0c1d849407dfccd$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $f0c1d849407dfccd$var$numbers_add_oref(cmntroot, csaid);
                $f0c1d849407dfccd$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $f0c1d849407dfccd$var$parse_shallow(ai.messages[0].data);
                    $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $f0c1d849407dfccd$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $f0c1d849407dfccd$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $f0c1d849407dfccd$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $f0c1d849407dfccd$var$write_shallow(store);
    tmaroot.messages[0].data = $f0c1d849407dfccd$var$write_shallow(pb);
}
function $f0c1d849407dfccd$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $f0c1d849407dfccd$var$fix_read_opts(opts) {
    $f0c1d849407dfccd$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $f0c1d849407dfccd$var$fix_write_opts(opts) {
    $f0c1d849407dfccd$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $f0c1d849407dfccd$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($f0c1d849407dfccd$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($f0c1d849407dfccd$var$RELS.CS && n == $f0c1d849407dfccd$var$RELS.CS) return "chart";
    if ($f0c1d849407dfccd$var$RELS.DS && n == $f0c1d849407dfccd$var$RELS.DS) return "dialog";
    if ($f0c1d849407dfccd$var$RELS.MS && n == $f0c1d849407dfccd$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $f0c1d849407dfccd$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $f0c1d849407dfccd$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $f0c1d849407dfccd$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $f0c1d849407dfccd$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $f0c1d849407dfccd$var$getzipstr(zip, dfile, true);
    if (draw) $f0c1d849407dfccd$var$parse_vml($f0c1d849407dfccd$var$utf8read(draw), sheet, comments || []);
}
function $f0c1d849407dfccd$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $f0c1d849407dfccd$var$parse_rels($f0c1d849407dfccd$var$getzipstr(zip, relsPath, true), path);
        var data = $f0c1d849407dfccd$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $f0c1d849407dfccd$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $f0c1d849407dfccd$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $f0c1d849407dfccd$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $f0c1d849407dfccd$var$get_rels_path(dfile);
                var draw = $f0c1d849407dfccd$var$parse_drawing($f0c1d849407dfccd$var$getzipstr(zip, dfile, true), $f0c1d849407dfccd$var$parse_rels($f0c1d849407dfccd$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $f0c1d849407dfccd$var$resolve_path(draw, dfile);
                var crelsp = $f0c1d849407dfccd$var$get_rels_path(chartp);
                _ws = $f0c1d849407dfccd$var$parse_chart($f0c1d849407dfccd$var$getzipstr(zip, chartp, true), chartp, opts, $f0c1d849407dfccd$var$parse_rels($f0c1d849407dfccd$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $f0c1d849407dfccd$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $f0c1d849407dfccd$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $f0c1d849407dfccd$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $f0c1d849407dfccd$var$RELS.CMNT) {
                dfile = $f0c1d849407dfccd$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $f0c1d849407dfccd$var$parse_cmnt($f0c1d849407dfccd$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $f0c1d849407dfccd$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $f0c1d849407dfccd$var$RELS.TCMNT) {
                dfile = $f0c1d849407dfccd$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($f0c1d849407dfccd$var$parse_tcmnt_xml($f0c1d849407dfccd$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $f0c1d849407dfccd$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $f0c1d849407dfccd$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $f0c1d849407dfccd$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $f0c1d849407dfccd$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $f0c1d849407dfccd$var$make_ssf();
    opts = opts || {};
    $f0c1d849407dfccd$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $f0c1d849407dfccd$var$parse_ods(zip, opts);
    /* UOC */ if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'objectdata.xml')) return $f0c1d849407dfccd$var$parse_ods(zip, opts);
    /* Numbers */ if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $f0c1d849407dfccd$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $f0c1d849407dfccd$var$parse_numbers_iwa(zip, opts);
            var _zip = $f0c1d849407dfccd$export$9f0e51cd97c572a.utils.cfb_new();
            $f0c1d849407dfccd$var$zipentries(zip).forEach(function(e) {
                $f0c1d849407dfccd$var$zip_add_file(_zip, e, $f0c1d849407dfccd$var$getzipbin(zip, e));
            });
            return $f0c1d849407dfccd$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$f0c1d849407dfccd$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($f0c1d849407dfccd$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $f0c1d849407dfccd$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $f0c1d849407dfccd$require$Buffer.isBuffer(index_zip.content)) return $f0c1d849407dfccd$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $f0c1d849407dfccd$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $f0c1d849407dfccd$var$zipentries(zip);
    var dir = $f0c1d849407dfccd$var$parse_ct($f0c1d849407dfccd$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($f0c1d849407dfccd$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$f0c1d849407dfccd$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $f0c1d849407dfccd$var$strs = [];
        if (dir.sst) try {
            $f0c1d849407dfccd$var$strs = $f0c1d849407dfccd$var$parse_sst($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $f0c1d849407dfccd$var$parse_theme_xml($f0c1d849407dfccd$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $f0c1d849407dfccd$var$parse_sty($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $f0c1d849407dfccd$var$parse_rels($f0c1d849407dfccd$var$getzipstr(zip, $f0c1d849407dfccd$var$get_rels_path($f0c1d849407dfccd$var$strip_front_slash(link))), link);
            return $f0c1d849407dfccd$var$parse_xlink($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $f0c1d849407dfccd$var$parse_wb($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $f0c1d849407dfccd$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $f0c1d849407dfccd$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $f0c1d849407dfccd$var$getzipstr(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $f0c1d849407dfccd$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $f0c1d849407dfccd$var$parse_cc($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$f0c1d849407dfccd$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $f0c1d849407dfccd$var$parse_rels($f0c1d849407dfccd$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $f0c1d849407dfccd$var$parse_xlmeta($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $f0c1d849407dfccd$var$parse_people_xml($f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $f0c1d849407dfccd$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $f0c1d849407dfccd$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$f0c1d849407dfccd$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$f0c1d849407dfccd$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $f0c1d849407dfccd$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $f0c1d849407dfccd$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $f0c1d849407dfccd$var$getzipdata(zip, $f0c1d849407dfccd$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $f0c1d849407dfccd$var$CT_VBA) out.vbaraw = $f0c1d849407dfccd$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $f0c1d849407dfccd$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $f0c1d849407dfccd$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $f0c1d849407dfccd$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $f0c1d849407dfccd$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $f0c1d849407dfccd$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $f0c1d849407dfccd$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $f0c1d849407dfccd$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (wb && wb.SSF) {
        $f0c1d849407dfccd$var$make_ssf();
        $f0c1d849407dfccd$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $f0c1d849407dfccd$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($f0c1d849407dfccd$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $f0c1d849407dfccd$var$new_ct();
    $f0c1d849407dfccd$var$fix_write_opts(opts = opts || {});
    var zip = $f0c1d849407dfccd$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 2, f, $f0c1d849407dfccd$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 3, f, $f0c1d849407dfccd$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $f0c1d849407dfccd$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.rels, 4, f, $f0c1d849407dfccd$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $f0c1d849407dfccd$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $f0c1d849407dfccd$var$zip_add_file(zip, cf, $f0c1d849407dfccd$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $f0c1d849407dfccd$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $f0c1d849407dfccd$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $f0c1d849407dfccd$var$zip_add_file(zip, cf, $f0c1d849407dfccd$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $f0c1d849407dfccd$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $f0c1d849407dfccd$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $f0c1d849407dfccd$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $f0c1d849407dfccd$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $f0c1d849407dfccd$var$zip_add_file(zip, $f0c1d849407dfccd$var$get_rels_path(f), $f0c1d849407dfccd$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $f0c1d849407dfccd$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 1, f, $f0c1d849407dfccd$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $f0c1d849407dfccd$var$write_theme(wb.Themes, opts);
    $f0c1d849407dfccd$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $f0c1d849407dfccd$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "styles." + wbext, $f0c1d849407dfccd$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $f0c1d849407dfccd$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $f0c1d849407dfccd$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_people_xml(people, opts));
        ct.people.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "persons/person.xml", $f0c1d849407dfccd$var$RELS.PEOPLE);
    }
    $f0c1d849407dfccd$var$zip_add_file(zip, "[Content_Types].xml", $f0c1d849407dfccd$var$write_ct(ct, opts));
    $f0c1d849407dfccd$var$zip_add_file(zip, '_rels/.rels', $f0c1d849407dfccd$var$write_rels(opts.rels));
    $f0c1d849407dfccd$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $f0c1d849407dfccd$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $f0c1d849407dfccd$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (wb && wb.SSF) {
        $f0c1d849407dfccd$var$make_ssf();
        $f0c1d849407dfccd$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $f0c1d849407dfccd$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($f0c1d849407dfccd$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $f0c1d849407dfccd$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $f0c1d849407dfccd$var$new_ct();
    $f0c1d849407dfccd$var$fix_write_opts(opts = opts || {});
    var zip = $f0c1d849407dfccd$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 2, f, $f0c1d849407dfccd$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 3, f, $f0c1d849407dfccd$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $f0c1d849407dfccd$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.rels, 4, f, $f0c1d849407dfccd$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $f0c1d849407dfccd$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $f0c1d849407dfccd$var$zip_add_file(zip, cf, $f0c1d849407dfccd$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $f0c1d849407dfccd$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $f0c1d849407dfccd$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $f0c1d849407dfccd$var$zip_add_file(zip, cf, $f0c1d849407dfccd$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $f0c1d849407dfccd$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $f0c1d849407dfccd$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $f0c1d849407dfccd$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $f0c1d849407dfccd$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $f0c1d849407dfccd$var$zip_add_file(zip, $f0c1d849407dfccd$var$get_rels_path(f), $f0c1d849407dfccd$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $f0c1d849407dfccd$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.rels, 1, f, $f0c1d849407dfccd$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $f0c1d849407dfccd$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "styles." + wbext, $f0c1d849407dfccd$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $f0c1d849407dfccd$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $f0c1d849407dfccd$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $f0c1d849407dfccd$var$zip_add_file(zip, f, $f0c1d849407dfccd$var$write_people_xml(people, opts));
        ct.people.push(f);
        $f0c1d849407dfccd$var$add_rels(opts.wbrels, -1, "persons/person.xml", $f0c1d849407dfccd$var$RELS.PEOPLE);
    }
    $f0c1d849407dfccd$var$zip_add_file(zip, "[Content_Types].xml", $f0c1d849407dfccd$var$write_ct(ct, opts));
    $f0c1d849407dfccd$var$zip_add_file(zip, '_rels/.rels', $f0c1d849407dfccd$var$write_rels(opts.rels));
    $f0c1d849407dfccd$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $f0c1d849407dfccd$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $f0c1d849407dfccd$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $f0c1d849407dfccd$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $f0c1d849407dfccd$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($f0c1d849407dfccd$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $f0c1d849407dfccd$var$parse_xlsxcfb(cfb, opts);
    return $f0c1d849407dfccd$export$b41972a043aba84c(cfb, opts);
}
function $f0c1d849407dfccd$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $f0c1d849407dfccd$var$zip_read(d, o);
    return $f0c1d849407dfccd$export$b165387946f79a1(zip, o);
}
function $f0c1d849407dfccd$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $f0c1d849407dfccd$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $f0c1d849407dfccd$var$PRN.to_workbook(data, o);
}
function $f0c1d849407dfccd$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $f0c1d849407dfccd$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $f0c1d849407dfccd$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $f0c1d849407dfccd$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $f0c1d849407dfccd$var$utf8read(str);
    o.type = "binary";
    return $f0c1d849407dfccd$var$read_plaintext(str, o);
}
function $f0c1d849407dfccd$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $f0c1d849407dfccd$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $f0c1d849407dfccd$var$$cptable !== "undefined" ? $f0c1d849407dfccd$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $f0c1d849407dfccd$var$utf16lereadu(d.slice(2)) : $f0c1d849407dfccd$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $f0c1d849407dfccd$var$read_plaintext(d, o);
}
function $f0c1d849407dfccd$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $f0c1d849407dfccd$var$utf8write(data);
}
function $f0c1d849407dfccd$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $f0c1d849407dfccd$var$PRN.to_workbook(data, o);
    }
    return $f0c1d849407dfccd$var$PRN.to_workbook(d, o);
}
function $f0c1d849407dfccd$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $f0c1d849407dfccd$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $f0c1d849407dfccd$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $f0c1d849407dfccd$export$aafa59e2e03f2942(new Uint8Array(data), (o = $f0c1d849407dfccd$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $f0c1d849407dfccd$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $f0c1d849407dfccd$var$_ssfopts = {};
    if (o.dateNF) $f0c1d849407dfccd$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $f0c1d849407dfccd$var$has_buf && $f0c1d849407dfccd$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $f0c1d849407dfccd$var$has_buf ? "buffer" : "binary";
        d = $f0c1d849407dfccd$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$f0c1d849407dfccd$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $f0c1d849407dfccd$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $f0c1d849407dfccd$var$dup(o);
            o.type = 'array';
            return $f0c1d849407dfccd$export$aafa59e2e03f2942($f0c1d849407dfccd$var$ab2a(d), o);
        }
    }
    switch((n = $f0c1d849407dfccd$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $f0c1d849407dfccd$var$read_cfb($f0c1d849407dfccd$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $f0c1d849407dfccd$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $f0c1d849407dfccd$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $f0c1d849407dfccd$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $f0c1d849407dfccd$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $f0c1d849407dfccd$var$read_zip(d, o) : $f0c1d849407dfccd$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $f0c1d849407dfccd$var$parse_xlml(d, o) : $f0c1d849407dfccd$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $f0c1d849407dfccd$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $f0c1d849407dfccd$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $f0c1d849407dfccd$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $f0c1d849407dfccd$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $f0c1d849407dfccd$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $f0c1d849407dfccd$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $f0c1d849407dfccd$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($f0c1d849407dfccd$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $f0c1d849407dfccd$var$DBF.to_workbook(d, o);
    return $f0c1d849407dfccd$var$read_prn(data, d, o, str);
}
function $f0c1d849407dfccd$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $f0c1d849407dfccd$export$aafa59e2e03f2942(filename, o);
}
function $f0c1d849407dfccd$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $f0c1d849407dfccd$var$write_dl(o.file, $f0c1d849407dfccd$export$9f0e51cd97c572a.write(cfb, {
                type: $f0c1d849407dfccd$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $f0c1d849407dfccd$export$9f0e51cd97c572a.write(cfb, o);
}
function $f0c1d849407dfccd$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $f0c1d849407dfccd$var$write_ods(wb, opts);
        case "numbers":
            return $f0c1d849407dfccd$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $f0c1d849407dfccd$var$write_zip_xlsb(wb, opts);
        default:
            return $f0c1d849407dfccd$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $f0c1d849407dfccd$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $f0c1d849407dfccd$var$dup(opts || {});
    var z = $f0c1d849407dfccd$var$write_zip(wb, o);
    return $f0c1d849407dfccd$var$write_zip_denouement(z, o);
}
function $f0c1d849407dfccd$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $f0c1d849407dfccd$var$dup(opts || {});
    var z = $f0c1d849407dfccd$var$write_zip_xlsx(wb, o);
    return $f0c1d849407dfccd$var$write_zip_denouement(z, o);
}
function $f0c1d849407dfccd$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $f0c1d849407dfccd$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $f0c1d849407dfccd$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($f0c1d849407dfccd$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $f0c1d849407dfccd$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $f0c1d849407dfccd$var$write_dl(o.file, out);
    return o.type == "string" ? $f0c1d849407dfccd$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $f0c1d849407dfccd$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $f0c1d849407dfccd$var$write_xlscfb(wb, o);
    return $f0c1d849407dfccd$var$write_cfb_ctr(cfb, o);
}
function $f0c1d849407dfccd$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $f0c1d849407dfccd$var$Base64_encode($f0c1d849407dfccd$var$utf8write(o));
        case "binary":
            return $f0c1d849407dfccd$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $f0c1d849407dfccd$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $f0c1d849407dfccd$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $f0c1d849407dfccd$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $f0c1d849407dfccd$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $f0c1d849407dfccd$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($f0c1d849407dfccd$var$has_buf) return $f0c1d849407dfccd$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $f0c1d849407dfccd$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $f0c1d849407dfccd$var$Base64_encode(bstr) : opts.type == 'string' ? $f0c1d849407dfccd$var$utf8read(bstr) : bstr;
        case "file":
            return $f0c1d849407dfccd$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $f0c1d849407dfccd$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $f0c1d849407dfccd$var$reset_cp();
    $f0c1d849407dfccd$var$check_wb(wb);
    var o = $f0c1d849407dfccd$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $f0c1d849407dfccd$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $f0c1d849407dfccd$var$s2ab(out);
    }
    return $f0c1d849407dfccd$var$write_zip_typeXLSX(wb, o);
}
function $f0c1d849407dfccd$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $f0c1d849407dfccd$var$reset_cp();
    $f0c1d849407dfccd$var$check_wb(wb);
    var o = $f0c1d849407dfccd$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $f0c1d849407dfccd$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $f0c1d849407dfccd$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $f0c1d849407dfccd$var$write_stxt_type($f0c1d849407dfccd$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $f0c1d849407dfccd$var$write_binary_type($f0c1d849407dfccd$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $f0c1d849407dfccd$var$write_string_type($f0c1d849407dfccd$var$write_ods(wb, o), o);
        case 'wk1':
            return $f0c1d849407dfccd$var$write_binary_type($f0c1d849407dfccd$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $f0c1d849407dfccd$var$write_binary_type($f0c1d849407dfccd$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $f0c1d849407dfccd$var$write_binary_type($f0c1d849407dfccd$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $f0c1d849407dfccd$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $f0c1d849407dfccd$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $f0c1d849407dfccd$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $f0c1d849407dfccd$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $f0c1d849407dfccd$var$resolve_book_type(o);
    return $f0c1d849407dfccd$export$68d8715fc104d294(wb, o);
}
function $f0c1d849407dfccd$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $f0c1d849407dfccd$var$resolve_book_type(o);
    return $f0c1d849407dfccd$export$f6ca43591cb061b1(wb, o);
}
function $f0c1d849407dfccd$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $f0c1d849407dfccd$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $f0c1d849407dfccd$var$_fs.writeFile(filename, $f0c1d849407dfccd$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $f0c1d849407dfccd$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $f0c1d849407dfccd$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$f0c1d849407dfccd$var$fmt_is_date(val1.z)) break;
                v = $f0c1d849407dfccd$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $f0c1d849407dfccd$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $f0c1d849407dfccd$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $f0c1d849407dfccd$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $f0c1d849407dfccd$var$safe_decode_range(range);
            break;
        case 'number':
            r = $f0c1d849407dfccd$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $f0c1d849407dfccd$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $f0c1d849407dfccd$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $f0c1d849407dfccd$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $f0c1d849407dfccd$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $f0c1d849407dfccd$var$qreg = /"/g;
function $f0c1d849407dfccd$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $f0c1d849407dfccd$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $f0c1d849407dfccd$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($f0c1d849407dfccd$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($f0c1d849407dfccd$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $f0c1d849407dfccd$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $f0c1d849407dfccd$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $f0c1d849407dfccd$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $f0c1d849407dfccd$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $f0c1d849407dfccd$var$sheet_to_csv(sheet, opts);
    if (typeof $f0c1d849407dfccd$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $f0c1d849407dfccd$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $f0c1d849407dfccd$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $f0c1d849407dfccd$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $f0c1d849407dfccd$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $f0c1d849407dfccd$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($f0c1d849407dfccd$var$DENSE != null && dense == null) dense = $f0c1d849407dfccd$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $f0c1d849407dfccd$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $f0c1d849407dfccd$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $f0c1d849407dfccd$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $f0c1d849407dfccd$var$encode_col(_C + C) + $f0c1d849407dfccd$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $f0c1d849407dfccd$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $f0c1d849407dfccd$var$datenum(v);
                    }
                    z = cell != null && cell.z && $f0c1d849407dfccd$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $f0c1d849407dfccd$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $f0c1d849407dfccd$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$f0c1d849407dfccd$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $f0c1d849407dfccd$var$encode_range(range);
    return ws;
}
function $f0c1d849407dfccd$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $f0c1d849407dfccd$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $f0c1d849407dfccd$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $f0c1d849407dfccd$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $f0c1d849407dfccd$var$ws_get_cell_stub(ws, $f0c1d849407dfccd$var$encode_cell(R));
    /* R and C are 0-based indices */ return $f0c1d849407dfccd$var$ws_get_cell_stub(ws, $f0c1d849407dfccd$var$encode_col(C || 0) + $f0c1d849407dfccd$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $f0c1d849407dfccd$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $f0c1d849407dfccd$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $f0c1d849407dfccd$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $f0c1d849407dfccd$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $f0c1d849407dfccd$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $f0c1d849407dfccd$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $f0c1d849407dfccd$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $f0c1d849407dfccd$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $f0c1d849407dfccd$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $f0c1d849407dfccd$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $f0c1d849407dfccd$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $f0c1d849407dfccd$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $f0c1d849407dfccd$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $f0c1d849407dfccd$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $f0c1d849407dfccd$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $f0c1d849407dfccd$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $f0c1d849407dfccd$var$encode_range(wsr);
    return ws;
}
var $f0c1d849407dfccd$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $f0c1d849407dfccd$var$encode_col,
    encode_row: $f0c1d849407dfccd$var$encode_row,
    encode_cell: $f0c1d849407dfccd$var$encode_cell,
    encode_range: $f0c1d849407dfccd$var$encode_range,
    decode_col: $f0c1d849407dfccd$var$decode_col,
    decode_row: $f0c1d849407dfccd$var$decode_row,
    split_cell: $f0c1d849407dfccd$var$split_cell,
    decode_cell: $f0c1d849407dfccd$var$decode_cell,
    decode_range: $f0c1d849407dfccd$var$decode_range,
    format_cell: $f0c1d849407dfccd$var$format_cell,
    sheet_new: $f0c1d849407dfccd$var$sheet_new,
    sheet_add_aoa: $f0c1d849407dfccd$var$sheet_add_aoa,
    sheet_add_json: $f0c1d849407dfccd$var$sheet_add_json,
    sheet_add_dom: $f0c1d849407dfccd$var$sheet_add_dom,
    aoa_to_sheet: $f0c1d849407dfccd$var$aoa_to_sheet,
    json_to_sheet: $f0c1d849407dfccd$var$json_to_sheet,
    table_to_sheet: $f0c1d849407dfccd$var$parse_dom_table,
    table_to_book: $f0c1d849407dfccd$var$table_to_book,
    sheet_to_csv: $f0c1d849407dfccd$var$sheet_to_csv,
    sheet_to_txt: $f0c1d849407dfccd$var$sheet_to_txt,
    sheet_to_json: $f0c1d849407dfccd$var$sheet_to_json,
    sheet_to_html: $f0c1d849407dfccd$var$sheet_to_html,
    sheet_to_formulae: $f0c1d849407dfccd$var$sheet_to_formulae,
    sheet_to_row_object_array: $f0c1d849407dfccd$var$sheet_to_json,
    sheet_get_cell: $f0c1d849407dfccd$var$ws_get_cell_stub,
    book_new: $f0c1d849407dfccd$var$book_new,
    book_append_sheet: $f0c1d849407dfccd$var$book_append_sheet,
    book_set_sheet_visibility: $f0c1d849407dfccd$var$book_set_sheet_visibility,
    cell_set_number_format: $f0c1d849407dfccd$var$cell_set_number_format,
    cell_set_hyperlink: $f0c1d849407dfccd$var$cell_set_hyperlink,
    cell_set_internal_link: $f0c1d849407dfccd$var$cell_set_internal_link,
    cell_add_comment: $f0c1d849407dfccd$var$cell_add_comment,
    sheet_set_array_formula: $f0c1d849407dfccd$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $f0c1d849407dfccd$var$_Readable;
function $f0c1d849407dfccd$var$set_readable(R) {
    $f0c1d849407dfccd$var$_Readable = R;
}
function $f0c1d849407dfccd$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $f0c1d849407dfccd$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $f0c1d849407dfccd$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $f0c1d849407dfccd$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $f0c1d849407dfccd$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $f0c1d849407dfccd$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $f0c1d849407dfccd$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $f0c1d849407dfccd$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $f0c1d849407dfccd$var$HTML_END;
    stream.push(header);
    var r = $f0c1d849407dfccd$var$decode_range(ws['!ref']);
    stream.push($f0c1d849407dfccd$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($f0c1d849407dfccd$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $f0c1d849407dfccd$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $f0c1d849407dfccd$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $f0c1d849407dfccd$var$safe_decode_range(range);
            break;
        case 'number':
            r = $f0c1d849407dfccd$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $f0c1d849407dfccd$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $f0c1d849407dfccd$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $f0c1d849407dfccd$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $f0c1d849407dfccd$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $f0c1d849407dfccd$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $f0c1d849407dfccd$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $f0c1d849407dfccd$var$dup($f0c1d849407dfccd$var$table_fmt);
    if (wb.SSF) {
        $f0c1d849407dfccd$var$make_ssf();
        $f0c1d849407dfccd$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $f0c1d849407dfccd$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $f0c1d849407dfccd$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $f0c1d849407dfccd$var$dup(cell);
                    cell.z = $f0c1d849407dfccd$var$table_fmt[14];
                }
                $f0c1d849407dfccd$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $f0c1d849407dfccd$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $f0c1d849407dfccd$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($f0c1d849407dfccd$var$XML_HEADER);
                stream.push("<Workbook" + $f0c1d849407dfccd$var$wxt_helper({
                    'xmlns': $f0c1d849407dfccd$var$XLMLNS.ss,
                    'xmlns:o': $f0c1d849407dfccd$var$XLMLNS.o,
                    'xmlns:x': $f0c1d849407dfccd$var$XLMLNS.x,
                    'xmlns:ss': $f0c1d849407dfccd$var$XLMLNS.ss,
                    'xmlns:dt': $f0c1d849407dfccd$var$XLMLNS.dt,
                    'xmlns:html': $f0c1d849407dfccd$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($f0c1d849407dfccd$var$write_props_xlml(wb, opts));
                stream.push($f0c1d849407dfccd$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($f0c1d849407dfccd$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $f0c1d849407dfccd$var$wxt_helper({
                    "ss:Name": $f0c1d849407dfccd$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $f0c1d849407dfccd$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $f0c1d849407dfccd$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $f0c1d849407dfccd$var$process_col(n);
                        var w = !!n.width;
                        var p = $f0c1d849407dfccd$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $f0c1d849407dfccd$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($f0c1d849407dfccd$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $f0c1d849407dfccd$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $f0c1d849407dfccd$var$encode_col(C) + $f0c1d849407dfccd$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($f0c1d849407dfccd$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($f0c1d849407dfccd$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $f0c1d849407dfccd$var$a1_to_rc($f0c1d849407dfccd$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $f0c1d849407dfccd$export$4938110305e6185f = {
    to_json: $f0c1d849407dfccd$var$write_json_stream,
    to_html: $f0c1d849407dfccd$var$write_html_stream,
    to_csv: $f0c1d849407dfccd$var$write_csv_stream,
    to_xlml: $f0c1d849407dfccd$var$write_xlml_stream,
    set_readable: $f0c1d849407dfccd$var$set_readable
};
const $f0c1d849407dfccd$export$83d89fbfd8236492 = $f0c1d849407dfccd$var$XLSX.version;
var $f0c1d849407dfccd$export$2e2bcd8739ae039 = {
    parse_xlscfb: $f0c1d849407dfccd$export$b41972a043aba84c,
    parse_zip: $f0c1d849407dfccd$export$b165387946f79a1,
    read: $f0c1d849407dfccd$export$aafa59e2e03f2942,
    readFile: $f0c1d849407dfccd$export$72c04af63de9061a,
    readFileSync: $f0c1d849407dfccd$export$72c04af63de9061a,
    write: $f0c1d849407dfccd$export$68d8715fc104d294,
    writeFile: $f0c1d849407dfccd$export$552bfb764b5cd2b4,
    writeFileSync: $f0c1d849407dfccd$export$552bfb764b5cd2b4,
    writeFileAsync: $f0c1d849407dfccd$export$25469296c4b8ebda,
    writeXLSX: $f0c1d849407dfccd$export$f6ca43591cb061b1,
    writeFileXLSX: $f0c1d849407dfccd$export$40a06aea54ee074e,
    utils: $f0c1d849407dfccd$export$eab97d15b1788b8d,
    set_fs: $f0c1d849407dfccd$export$a48eb669e1768bcf,
    set_cptable: $f0c1d849407dfccd$export$58f247d16f363b86,
    stream: $f0c1d849407dfccd$export$4938110305e6185f,
    SSF: $f0c1d849407dfccd$export$40d8edd678456c2b,
    CFB: $f0c1d849407dfccd$export$9f0e51cd97c572a
};


const $045e393ea48844a5$export$1fa6c04dd35d59ff = {
    APPROVE: 'APPROVE',
    REJECT: 'REJECT',
    RESCORE: 'RESCORE',
    PERFORM: 'PERFORM',
    DELETE: 'DELETE',
    CHANNELUPDATE: 'CHANNELUPDATE',
    SOFTDELETE: 'SOFTDELETE'
};



const $ba993d96472d712a$export$a2757698bfab8d96 = {
    [(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).APPROVE]: 'Approve',
    [(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).REJECT]: 'Reject',
    [(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).RESCORE]: 'Rescore',
    [(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).PERFORM]: 'Fill in on behalf of customer'
};


const $d306a6c16d4d2f55$export$ec20f6c706ba3a34 = {
    ASSESSMENT: 'ASSESSMENT',
    SELF_ASSESSMENT: 'SELF_ASSESSMENT',
    RE_ASSESSMENT: 'RE_ASSESSMENT',
    REVIEW: 'REVIEW',
    APPROVAL: 'APPROVAL',
    COMPLETED: 'COMPLETED'
};
const $d306a6c16d4d2f55$export$da623606ae5dad1e = {
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.ASSESSMENT]: '1 - Assessment',
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.SELF_ASSESSMENT]: '1 - Self-assessment',
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.RE_ASSESSMENT]: '1 - Re-assessment',
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.REVIEW]: '2 - Review',
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.APPROVAL]: '3 - Approval',
    [$d306a6c16d4d2f55$export$ec20f6c706ba3a34.COMPLETED]: '4 - Complete'
};
const $d306a6c16d4d2f55$export$e71e4e95f4a82c = (assessmentStatus)=>{
    return assessmentStatus === 'REVIEW' || assessmentStatus === 'APPROVAL' || assessmentStatus === 'COMPLETED';
};


const $be4e7f9ce17f6c5f$export$e50882b81c62e311 = {
    BINARY_CHOICE: 'BINARY_CHOICE',
    NON_BINARY_SINGLE_CHOICE: 'NON_BINARY_SINGLE_CHOICE',
    NON_BINARY_MULTI_CHOICE: 'NON_BINARY_MULTI_CHOICE'
};


const $31252dd7ad7167e8$export$b7c2735e3cb0dd55 = {
    YEAR: 'Year',
    C6_ID: 'C6 ID',
    CUSTOMER_ID: 'Customer ID',
    CUSTOMER_NAME: 'Customer Name',
    C6_NAME: 'C6 Name',
    TIER: 'Tier',
    CHANNEL: 'Channel',
    SCORE: 'Score',
    YEAR_OVER_YEAR: 'YoY %',
    LAST_YEAR_SCORE: 'Last Year Score',
    STATUS: 'Status',
    PENDING_USER: 'Pending User',
    NEXT_ACTION_BY: 'Next Action By',
    BUSINESS_UNIT: 'Business Unit'
};
const $31252dd7ad7167e8$export$32b266158f847227 = {
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.YEAR]: 'year',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.C6_ID]: 'c6Id',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.CUSTOMER_ID]: 'customerId',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.CUSTOMER_NAME]: 'customerName',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.C6_NAME]: 'c6Name',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.BUSINESS_UNIT]: 'businessUnit',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.TIER]: 'tier',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.CHANNEL]: 'channel',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.SCORE]: 'score',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.LAST_YEAR_SCORE]: 'lastYearScore',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.STATUS]: 'status',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.PENDING_USER]: 'pendingUser',
    [$31252dd7ad7167e8$export$b7c2735e3cb0dd55.NEXT_ACTION_BY]: 'pendingUser'
};


const $c7ac1e8a1b8f5912$export$e58f05372adc177 = {
    YEAR: 'Year',
    MARKET_GROUP: 'MG (C2) Description (Reference)',
    BUSINESS_UNIT: 'BU (C3) Description (Reference)',
    C6_ID: 'C6 ID',
    C6_DESCRIPTION: 'C6 Description (Reference)',
    CUSTOMER_ID: 'Customer ID',
    CUSTOMER_DESCRIPTION: 'Customer Description (Reference)',
    CHANNEL: 'Channel',
    OMNI: 'Omni'
};
const $c7ac1e8a1b8f5912$export$b8d049f80fbf8093 = {
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.YEAR]: 'year',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.MARKET_GROUP]: 'marketGroup',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.BUSINESS_UNIT]: 'businessUnit',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.C6_ID]: 'c6Id',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.C6_DESCRIPTION]: 'c6Name',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.CUSTOMER_ID]: 'customerId',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.CUSTOMER_DESCRIPTION]: 'customerName',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.CHANNEL]: 'channel',
    [$c7ac1e8a1b8f5912$export$e58f05372adc177.OMNI]: 'omni'
};


const $6ccbfd9e6e2b1551$export$22c0d1c4538a5951 = {
    FILE_INVALID_TYPE: 'file-invalid-type',
    TOO_MANY_FILES: 'too-many-files',
    FILE_TOO_LARGE: 'file-too-large'
};




const $bf4d1a01ebfb74e1$var$optionsIncludingTime = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $bf4d1a01ebfb74e1$var$parseFormatDateOptions = (options)=>options.includeTime ? $bf4d1a01ebfb74e1$var$optionsIncludingTime : options;
const $bf4d1a01ebfb74e1$export$3ae94a2503e890a1 = (date, options = {})=>new Intl.DateTimeFormat('da', $bf4d1a01ebfb74e1$var$parseFormatDateOptions(options)).format(date);


const $e0ec7ea48617281a$export$fdbf68ac597032b3 = {
    SIMPLE: 'SIMPLE',
    UPLOAD_PREPARED: 'UPLOAD_PREPARED'
};


const $b01106eb8892e6c2$export$8ddf56c44523de2d = (channel)=>channel.startsWith('LT');


/**
 * Extracts the Sold-to ID from a joined customer ID
 * @param {string} customerId - The joined customer ID
 * @param {string} c6Id - The C6 ID
 * @returns {string} The Sold-to ID
 */ const $27f08597157dd295$export$46a04a9d5bcb989e = (customerId, c6Id)=>{
    if (customerId === c6Id) return '';
    return customerId.slice(c6Id.length);
};


const $2d047b1a9208cb87$var$uiFriendlyRoles = {
    performer: 'Performer',
    approver: 'Approver',
    reviewer: 'Reviewer',
    customer: 'Customer'
};
const $2d047b1a9208cb87$export$4d05fce67b78a97f = (role)=>{
    switch(role){
        case 'perform':
            return $2d047b1a9208cb87$var$uiFriendlyRoles.performer;
        case 'approve':
            return $2d047b1a9208cb87$var$uiFriendlyRoles.approver;
        case 'review':
            return $2d047b1a9208cb87$var$uiFriendlyRoles.reviewer;
        case 'customer':
            return $2d047b1a9208cb87$var$uiFriendlyRoles.customer;
        default:
            return $2d047b1a9208cb87$var$uiFriendlyRoles.customer;
    }
};



const $b571ea2e1852e598$var$fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const $b571ea2e1852e598$export$96812dd9af999b22 = '.xlsx';
const $b571ea2e1852e598$export$95facf87075ce8ea = 'Mcp_Overview';
const $b571ea2e1852e598$export$5b433e76503c5fc9 = 'Mcp_Overview_Ready_For_Upload';
const $b571ea2e1852e598$var$uploadPreparedAssessmentColumnHeadersArray = Object.values((0, $c7ac1e8a1b8f5912$export$e58f05372adc177));
const $b571ea2e1852e598$var$simpleExportWorkSheetHeadersArray = [
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).YEAR,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).C6_ID,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CUSTOMER_ID,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CUSTOMER_NAME,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).C6_NAME,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).BUSINESS_UNIT,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).TIER,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CHANNEL,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).STATUS,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).PENDING_USER,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).SCORE,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).LAST_YEAR_SCORE,
    (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).YEAR_OVER_YEAR
];
const $b571ea2e1852e598$var$mapDownloadDataToHeaders = (row, headersArray, headersAccessors)=>headersArray.reduce((rowObject, nextHeader)=>{
        const accessor = headersAccessors[nextHeader];
        if (nextHeader === (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).STATUS) {
            rowObject[nextHeader] = (0, $d306a6c16d4d2f55$export$da623606ae5dad1e)[row[accessor]];
            return rowObject;
        }
        if (nextHeader === (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).PENDING_USER) {
            rowObject[nextHeader] = (0, $2d047b1a9208cb87$export$4d05fce67b78a97f)(row[accessor]);
            return rowObject;
        }
        if (nextHeader === (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).YEAR_OVER_YEAR) {
            const yoyChange = row.lastYearScore !== null && row.lastYearScore !== undefined && (0, $d306a6c16d4d2f55$export$e71e4e95f4a82c)(row.status) ? row.score - row.lastYearScore : undefined;
            rowObject[nextHeader] = yoyChange !== undefined ? `${yoyChange > 0 ? '+' : ''}${yoyChange}%` : '';
            return rowObject;
        }
        rowObject[nextHeader] = row[accessor];
        return rowObject;
    }, {});
const $b571ea2e1852e598$var$getDateAndTimeString = ()=>{
    let dateString = (0, $bf4d1a01ebfb74e1$export$3ae94a2503e890a1)(new Date(), {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    });
    dateString = dateString.replace(',', '');
    return dateString.replace(' ', '_');
};
const $b571ea2e1852e598$var$exportConfigurations = {
    [(0, $e0ec7ea48617281a$export$fdbf68ac597032b3).SIMPLE]: {
        mapper: (assessment)=>$b571ea2e1852e598$var$mapDownloadDataToHeaders(assessment, $b571ea2e1852e598$var$simpleExportWorkSheetHeadersArray, (0, $31252dd7ad7167e8$export$32b266158f847227)),
        headers: $b571ea2e1852e598$var$simpleExportWorkSheetHeadersArray
    },
    [(0, $e0ec7ea48617281a$export$fdbf68ac597032b3).UPLOAD_PREPARED]: {
        mapper: (assessment)=>$b571ea2e1852e598$var$mapDownloadDataToHeaders(assessment, $b571ea2e1852e598$var$uploadPreparedAssessmentColumnHeadersArray, (0, $c7ac1e8a1b8f5912$export$b8d049f80fbf8093)),
        headers: $b571ea2e1852e598$var$uploadPreparedAssessmentColumnHeadersArray
    }
};
const $b571ea2e1852e598$export$d312e19bbaeee4b = (assessments, excelExportType)=>{
    const configuration = $b571ea2e1852e598$var$exportConfigurations[excelExportType];
    if (!configuration) throw new Error(`Unsupported excel export type: ${excelExportType}`);
    const assessmentsToBeExported = assessments.map((assessment)=>{
        return configuration.mapper(assessment);
    });
    return {
        assessmentsToBeExported: assessmentsToBeExported,
        workSheetHeadersArray: configuration.headers
    };
};
const $b571ea2e1852e598$var$prepareAssessmentsForDownload = (assessments)=>{
    return assessments.map((assessment)=>({
            ...assessment,
            customerId: (0, $b01106eb8892e6c2$export$8ddf56c44523de2d)(assessment.channel) ? assessment.customerId : (0, $27f08597157dd295$export$46a04a9d5bcb989e)(assessment.customerId, assessment.c6Id)
        }));
};
const $b571ea2e1852e598$export$445b39915a332cb3 = (assessmentsForDownload, excelExportType)=>{
    assessmentsForDownload = $b571ea2e1852e598$var$prepareAssessmentsForDownload(assessmentsForDownload);
    const { assessmentsToBeExported: assessmentsToBeExported, workSheetHeadersArray: workSheetHeadersArray } = $b571ea2e1852e598$export$d312e19bbaeee4b(assessmentsForDownload, excelExportType);
    const workSheet = $f0c1d849407dfccd$export$eab97d15b1788b8d.json_to_sheet(assessmentsToBeExported, {
        header: workSheetHeadersArray
    });
    const workBook = {
        Sheets: {
            data: workSheet
        },
        SheetNames: [
            'data'
        ]
    };
    const excelBuffer = $f0c1d849407dfccd$export$68d8715fc104d294(workBook, {
        bookType: 'xlsx',
        type: 'array'
    });
    const data = new Blob([
        excelBuffer
    ], {
        type: $b571ea2e1852e598$var$fileType
    });
    const fileName = excelExportType === (0, $e0ec7ea48617281a$export$fdbf68ac597032b3).UPLOAD_PREPARED ? $b571ea2e1852e598$export$5b433e76503c5fc9 : $b571ea2e1852e598$export$95facf87075ce8ea;
    $56b6fd384c7a9f90$exports.saveAs(data, `${fileName}_${$b571ea2e1852e598$var$getDateAndTimeString()}${$b571ea2e1852e598$export$96812dd9af999b22}`);
};


/* eslint-disable no-console */ 



var $76d06f59a1b84bcb$export$d10196e291075f95 = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};




var $a69364237f50b51d$export$125a23d36094c5de = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2,
                                next((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};


var $3df3fd5adbf9b435$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var $3df3fd5adbf9b435$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $3df3fd5adbf9b435$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, $76d06f59a1b84bcb$export$d10196e291075f95)(config, deserializer), $3df3fd5adbf9b435$export$f5d82b333b4f39c9);
            commandStack.add((0, $a69364237f50b51d$export$125a23d36094c5de)(config, serializer), $3df3fd5adbf9b435$export$1bd449976e9c484d);
        }
    };
}






var $91641f402de9c386$export$73604a93307363d8 = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return $91641f402de9c386$var$stepWeights[b.step] - $91641f402de9c386$var$stepWeights[a.step] || $91641f402de9c386$var$priorityWeights[b.priority || "normal"] - $91641f402de9c386$var$priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(expandRelativeMiddlewareList(entry))));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(expandRelativeMiddlewareList(entry))));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(expendedMiddlewareList)));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"" + name + "\" middleware with " + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"" + name + "\" middleware " + toOverride.relation + " \"" + toOverride.toMiddleware + "\" middleware cannot be overridden " + ("by same-name middleware " + entry.relation + " \"" + entry.toMiddleware + "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo($91641f402de9c386$export$73604a93307363d8());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo($91641f402de9c386$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var $91641f402de9c386$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var $91641f402de9c386$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




var $7b3b7173926ddf95$export$1f2bb630327ac4b6 = function() {
    function Client(config) {
        this.middlewareStack = (0, $91641f402de9c386$export$73604a93307363d8)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();



var $2248e4fb6d6fe346$export$cc7e12c76513e857 = function() {
    function Command() {
        this.middlewareStack = (0, $91641f402de9c386$export$73604a93307363d8)();
    }
    return Command;
}();


var $070d8fe31997500b$export$17127055dc9ac067 = "***SensitiveInformation***";



var $d373908f914b3142$export$3fb54149990fb5b5 = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error("Unable to parse boolean value \"" + value + "\"");
    }
};
var $d373908f914b3142$export$259b2ebfc29bf466 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got " + typeof value);
};
var $d373908f914b3142$export$f3945e48fdb5f9a = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got " + typeof value);
};
var $d373908f914b3142$var$MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var $d373908f914b3142$export$44880ec4d8d4909d = function(value) {
    var expected = $d373908f914b3142$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $d373908f914b3142$var$MAX_FLOAT) throw new TypeError("Expected 32-bit float, got " + value);
    }
    return expected;
};
var $d373908f914b3142$export$a883517a83c9c18 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got " + typeof value);
};
var $d373908f914b3142$export$dbec7593c34ded08 = $d373908f914b3142$export$a883517a83c9c18;
var $d373908f914b3142$export$99c64e845cdac9c1 = function(value) {
    return $d373908f914b3142$var$expectSizedInt(value, 32);
};
var $d373908f914b3142$export$d4f903340b146129 = function(value) {
    return $d373908f914b3142$var$expectSizedInt(value, 16);
};
var $d373908f914b3142$export$3e4c4435b3b19562 = function(value) {
    return $d373908f914b3142$var$expectSizedInt(value, 8);
};
var $d373908f914b3142$var$expectSizedInt = function(value, size) {
    var expected = $d373908f914b3142$export$a883517a83c9c18(value);
    if (expected !== undefined && $d373908f914b3142$var$castInt(expected, size) !== expected) throw new TypeError("Expected " + size + "-bit integer, got " + value);
    return expected;
};
var $d373908f914b3142$var$castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var $d373908f914b3142$export$8413a63dbe548a49 = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for " + location);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var $d373908f914b3142$export$cf825aadce530e7e = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    throw new TypeError("Expected object, got " + typeof value);
};
var $d373908f914b3142$export$7ed80f53fe336639 = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    throw new TypeError("Expected string, got " + typeof value);
};
var $d373908f914b3142$export$9ef77073e45b6301 = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = $d373908f914b3142$export$cf825aadce530e7e(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), _ = _b[0], v = _b[1];
        return v !== null && v !== undefined;
    }).map(function(_a) {
        var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), k = _b[0], _ = _b[1];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys " + setKeys + " were not null.");
    return asObject;
};
var $d373908f914b3142$export$89e17ed633a86621 = function(value) {
    if (typeof value == "string") return $d373908f914b3142$export$f3945e48fdb5f9a($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$f3945e48fdb5f9a(value);
};
var $d373908f914b3142$export$884f8e3b42a6cfbf = $d373908f914b3142$export$89e17ed633a86621;
var $d373908f914b3142$export$b15cbcea8b4c492f = function(value) {
    if (typeof value == "string") return $d373908f914b3142$export$44880ec4d8d4909d($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$44880ec4d8d4909d(value);
};
var $d373908f914b3142$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var $d373908f914b3142$var$parseNumber = function(value) {
    var matches = value.match($d373908f914b3142$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var $d373908f914b3142$export$11335e83c8af2784 = function(value) {
    if (typeof value == "string") return $d373908f914b3142$var$parseFloatString(value);
    return $d373908f914b3142$export$f3945e48fdb5f9a(value);
};
var $d373908f914b3142$export$b6a7906d2e4b31df = $d373908f914b3142$export$11335e83c8af2784;
var $d373908f914b3142$export$50b04c19f942a079 = $d373908f914b3142$export$11335e83c8af2784;
var $d373908f914b3142$export$f14938f3036dd492 = function(value) {
    if (typeof value == "string") return $d373908f914b3142$var$parseFloatString(value);
    return $d373908f914b3142$export$44880ec4d8d4909d(value);
};
var $d373908f914b3142$var$parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: " + value);
    }
};
var $d373908f914b3142$export$f90617f39a736d36 = function(value) {
    if (typeof value === "string") return $d373908f914b3142$export$a883517a83c9c18($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$a883517a83c9c18(value);
};
var $d373908f914b3142$export$39b7be5d28a09fe1 = $d373908f914b3142$export$f90617f39a736d36;
var $d373908f914b3142$export$c3c2f00b115709e6 = function(value) {
    if (typeof value === "string") return $d373908f914b3142$export$99c64e845cdac9c1($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$99c64e845cdac9c1(value);
};
var $d373908f914b3142$export$813d4a13f25c6b38 = function(value) {
    if (typeof value === "string") return $d373908f914b3142$export$d4f903340b146129($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$d4f903340b146129(value);
};
var $d373908f914b3142$export$f18d20ea3b6b353 = function(value) {
    if (typeof value === "string") return $d373908f914b3142$export$3e4c4435b3b19562($d373908f914b3142$var$parseNumber(value));
    return $d373908f914b3142$export$3e4c4435b3b19562(value);
};


var $371ecb836c361216$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var $371ecb836c361216$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $371ecb836c361216$export$5b50865171ed23a9(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return $371ecb836c361216$var$DAYS[dayOfWeek] + ", " + dayOfMonthString + " " + $371ecb836c361216$var$MONTHS[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}
var $371ecb836c361216$var$RFC3339 = new RegExp(/^(?<Y>\d{4})-(?<M>\d{2})-(?<D>\d{2})[tT](?<H>\d{2}):(?<m>\d{2}):(?<s>\d{2})(?:\.(?<frac>\d+))?[zZ]$/);
var $371ecb836c361216$export$202e14f4d6038b6c = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = $371ecb836c361216$var$RFC3339.exec(value);
    if (!match || !match.groups) throw new TypeError("Invalid RFC-3339 date-time value");
    var year = (0, $d373908f914b3142$export$813d4a13f25c6b38)($371ecb836c361216$var$stripLeadingZeroes(match.groups["Y"]));
    var month = $371ecb836c361216$var$parseDateValue(match.groups["M"], "month", 1, 12);
    var day = $371ecb836c361216$var$parseDateValue(match.groups["D"], "day", 1, 31);
    return $371ecb836c361216$var$buildDate(year, month, day, match);
};
var $371ecb836c361216$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (?<D>\d{2}) (?<M>Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (?<Y>\d{4}) (?<H>\d{2}):(?<m>\d{2}):(?<s>\d{2})(?:\.(?<frac>\d+))? GMT$/);
var $371ecb836c361216$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (?<D>\d{2})-(?<M>Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(?<Y>\d{2}) (?<H>\d{2}):(?<m>\d{2}):(?<s>\d{2})(?:\.(?<frac>\d+))? GMT$/);
var $371ecb836c361216$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (?<M>Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (?<D> [1-9]|\d{2}) (?<H>\d{2}):(?<m>\d{2}):(?<s>\d{2})(?:\.(?<frac>\d+))? (?<Y>\d{4})$/);
var $371ecb836c361216$export$cf3a566289648a1e = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var dayFn = function(value) {
        return $371ecb836c361216$var$parseDateValue(value, "day", 1, 31);
    };
    var yearFn = function(value) {
        return (0, $d373908f914b3142$export$813d4a13f25c6b38)($371ecb836c361216$var$stripLeadingZeroes(value));
    };
    var dateAdjustmentFn = function(value) {
        return value;
    };
    var match = $371ecb836c361216$var$IMF_FIXDATE.exec(value);
    if (!match || !match.groups) {
        match = $371ecb836c361216$var$RFC_850_DATE.exec(value);
        if (match && match.groups) {
            yearFn = $371ecb836c361216$var$parseTwoDigitYear;
            dateAdjustmentFn = $371ecb836c361216$var$adjustRfc850Year;
        } else {
            match = $371ecb836c361216$var$ASC_TIME.exec(value);
            if (match && match.groups) dayFn = function(value) {
                return $371ecb836c361216$var$parseDateValue(value.trimLeft(), "day", 1, 31);
            };
            else throw new TypeError("Invalid RFC-7231 date-time value");
        }
    }
    var year = yearFn(match.groups["Y"]);
    var month = $371ecb836c361216$var$parseMonthByShortName(match.groups["M"]);
    var day = dayFn(match.groups["D"]);
    return dateAdjustmentFn($371ecb836c361216$var$buildDate(year, month, day, match));
};
var $371ecb836c361216$export$685da212e4e79e10 = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $d373908f914b3142$export$89e17ed633a86621)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var $371ecb836c361216$var$buildDate = function(year, month, day, match) {
    var adjustedMonth = month - 1;
    $371ecb836c361216$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $371ecb836c361216$var$parseDateValue(match.groups["H"], "hour", 0, 23), $371ecb836c361216$var$parseDateValue(match.groups["m"], "minute", 0, 59), $371ecb836c361216$var$parseDateValue(match.groups["s"], "seconds", 0, 60), $371ecb836c361216$var$parseMilliseconds(match.groups["frac"])));
};
var $371ecb836c361216$var$parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $d373908f914b3142$export$813d4a13f25c6b38)($371ecb836c361216$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var $371ecb836c361216$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
var $371ecb836c361216$var$adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > $371ecb836c361216$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var $371ecb836c361216$var$parseMonthByShortName = function(value) {
    var monthIdx = $371ecb836c361216$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: " + value);
    return monthIdx + 1;
};
var $371ecb836c361216$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $371ecb836c361216$var$validateDayOfMonth = function(year, month, day) {
    var maxDays = $371ecb836c361216$var$DAYS_IN_MONTH[month];
    if (month === 1 && $371ecb836c361216$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for " + $371ecb836c361216$var$MONTHS[month] + " in " + year + ": " + day);
};
var $371ecb836c361216$var$isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var $371ecb836c361216$var$parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, $d373908f914b3142$export$f18d20ea3b6b353)($371ecb836c361216$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(type + " must be between " + lower + " and " + upper + ", inclusive");
    return dateVal;
};
var $371ecb836c361216$var$parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, $d373908f914b3142$export$b15cbcea8b4c492f)("0." + value) * 1000;
};
var $371ecb836c361216$var$stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};



var $89WEd = parcelRequire("89WEd");
var $8882276f98cc15d4$var$warningEmitted = false;
var $8882276f98cc15d4$export$96550b8fa3e6f65a = function(version) {
    if (version && !$8882276f98cc15d4$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 12) {
        $8882276f98cc15d4$var$warningEmitted = true;
        $89WEd.emitWarning("The AWS SDK for JavaScript (v3) will\n" + ("no longer support Node.js " + version + " as of January 1, 2022.\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 12.x or later.\n\n" + "More information can be found at: https://a.co/1l6FLnu", "NodeDeprecationWarning");
    }
};


function $7f077f65d077e2f2$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}


var $2742fa913003d912$export$52272e038712c64e = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};


var $f0378e5a2ae68b50$export$113d90026b452881 = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $f0378e5a2ae68b50$export$113d90026b452881(obj[key]);
    }
    return obj;
};



var $df7646f7889cfd06$export$40e2db4f1ce24b10 = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, $96998cfc8b9d4854$export$1216008129fb82ed)([
        null
    ], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(arguments)));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$df7646f7889cfd06$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $df7646f7889cfd06$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($df7646f7889cfd06$export$40e2db4f1ce24b10, String);
var $df7646f7889cfd06$export$494ed5148690ecaf = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}($df7646f7889cfd06$export$40e2db4f1ce24b10);



var $ff4f27ff02223c28$export$4a2bea4ecaa09ba7 = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};


function $c187f94db8d1959f$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}






var $21abd87643c491e1$export$fcee6736fd257b81;
(function(AccountLimit) {
    AccountLimit.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$fcee6736fd257b81 || ($21abd87643c491e1$export$fcee6736fd257b81 = {}));
var $21abd87643c491e1$export$6d95d2881769db9c;
(function(AccountUsage) {
    AccountUsage.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6d95d2881769db9c || ($21abd87643c491e1$export$6d95d2881769db9c = {}));
var $21abd87643c491e1$export$21bfd8a67506ea3f;
(function(AddLayerVersionPermissionRequest) {
    AddLayerVersionPermissionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$21bfd8a67506ea3f || ($21abd87643c491e1$export$21bfd8a67506ea3f = {}));
var $21abd87643c491e1$export$793511edc005a315;
(function(AddLayerVersionPermissionResponse) {
    AddLayerVersionPermissionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$793511edc005a315 || ($21abd87643c491e1$export$793511edc005a315 = {}));
var $21abd87643c491e1$export$dc68e798006b2b42;
(function(InvalidParameterValueException) {
    InvalidParameterValueException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$dc68e798006b2b42 || ($21abd87643c491e1$export$dc68e798006b2b42 = {}));
var $21abd87643c491e1$export$30438ad0b714cab1;
(function(PolicyLengthExceededException) {
    PolicyLengthExceededException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$30438ad0b714cab1 || ($21abd87643c491e1$export$30438ad0b714cab1 = {}));
var $21abd87643c491e1$export$6e9c0759ddd78f5;
(function(PreconditionFailedException) {
    PreconditionFailedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6e9c0759ddd78f5 || ($21abd87643c491e1$export$6e9c0759ddd78f5 = {}));
var $21abd87643c491e1$export$cbdaf31887dd0603;
(function(ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$cbdaf31887dd0603 || ($21abd87643c491e1$export$cbdaf31887dd0603 = {}));
var $21abd87643c491e1$export$ecba565262f8bb2;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ecba565262f8bb2 || ($21abd87643c491e1$export$ecba565262f8bb2 = {}));
var $21abd87643c491e1$export$29647f3b4097d3c0;
(function(ServiceException) {
    ServiceException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$29647f3b4097d3c0 || ($21abd87643c491e1$export$29647f3b4097d3c0 = {}));
var $21abd87643c491e1$export$3a12e43c059e0353;
(function(ThrottleReason) {
    ThrottleReason["CallerRateLimitExceeded"] = "CallerRateLimitExceeded";
    ThrottleReason["ConcurrentInvocationLimitExceeded"] = "ConcurrentInvocationLimitExceeded";
    ThrottleReason["FunctionInvocationRateLimitExceeded"] = "FunctionInvocationRateLimitExceeded";
    ThrottleReason["ReservedFunctionConcurrentInvocationLimitExceeded"] = "ReservedFunctionConcurrentInvocationLimitExceeded";
    ThrottleReason["ReservedFunctionInvocationRateLimitExceeded"] = "ReservedFunctionInvocationRateLimitExceeded";
})($21abd87643c491e1$export$3a12e43c059e0353 || ($21abd87643c491e1$export$3a12e43c059e0353 = {}));
var $21abd87643c491e1$export$4a67805ad445f61;
(function(TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$4a67805ad445f61 || ($21abd87643c491e1$export$4a67805ad445f61 = {}));
var $21abd87643c491e1$export$581b3b7a57ba467;
(function(AddPermissionRequest) {
    AddPermissionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$581b3b7a57ba467 || ($21abd87643c491e1$export$581b3b7a57ba467 = {}));
var $21abd87643c491e1$export$1d7437b794e76ce5;
(function(AddPermissionResponse) {
    AddPermissionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$1d7437b794e76ce5 || ($21abd87643c491e1$export$1d7437b794e76ce5 = {}));
var $21abd87643c491e1$export$bc732d294d46ebe5;
(function(AliasRoutingConfiguration) {
    AliasRoutingConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bc732d294d46ebe5 || ($21abd87643c491e1$export$bc732d294d46ebe5 = {}));
var $21abd87643c491e1$export$738661b98c29d5f3;
(function(AliasConfiguration) {
    AliasConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$738661b98c29d5f3 || ($21abd87643c491e1$export$738661b98c29d5f3 = {}));
var $21abd87643c491e1$export$c0ce678fba166b63;
(function(AllowedPublishers) {
    AllowedPublishers.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c0ce678fba166b63 || ($21abd87643c491e1$export$c0ce678fba166b63 = {}));
var $21abd87643c491e1$export$5dd33a8e9f080ec5;
(function(Architecture) {
    Architecture["arm64"] = "arm64";
    Architecture["x86_64"] = "x86_64";
})($21abd87643c491e1$export$5dd33a8e9f080ec5 || ($21abd87643c491e1$export$5dd33a8e9f080ec5 = {}));
var $21abd87643c491e1$export$c58af87b75ecf7a5;
(function(CreateAliasRequest) {
    CreateAliasRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c58af87b75ecf7a5 || ($21abd87643c491e1$export$c58af87b75ecf7a5 = {}));
var $21abd87643c491e1$export$2d1a82ecc7024379;
(function(CodeSigningPolicy) {
    CodeSigningPolicy["Enforce"] = "Enforce";
    CodeSigningPolicy["Warn"] = "Warn";
})($21abd87643c491e1$export$2d1a82ecc7024379 || ($21abd87643c491e1$export$2d1a82ecc7024379 = {}));
var $21abd87643c491e1$export$c6739a84245de44f;
(function(CodeSigningPolicies) {
    CodeSigningPolicies.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c6739a84245de44f || ($21abd87643c491e1$export$c6739a84245de44f = {}));
var $21abd87643c491e1$export$1f68b0e1065942fc;
(function(CreateCodeSigningConfigRequest) {
    CreateCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$1f68b0e1065942fc || ($21abd87643c491e1$export$1f68b0e1065942fc = {}));
var $21abd87643c491e1$export$45516889a20483af;
(function(CodeSigningConfig) {
    CodeSigningConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$45516889a20483af || ($21abd87643c491e1$export$45516889a20483af = {}));
var $21abd87643c491e1$export$ef627e338245be2a;
(function(CreateCodeSigningConfigResponse) {
    CreateCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ef627e338245be2a || ($21abd87643c491e1$export$ef627e338245be2a = {}));
var $21abd87643c491e1$export$51b16e9b8017ed01;
(function(OnFailure) {
    OnFailure.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$51b16e9b8017ed01 || ($21abd87643c491e1$export$51b16e9b8017ed01 = {}));
var $21abd87643c491e1$export$9ad51738fa831143;
(function(OnSuccess) {
    OnSuccess.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9ad51738fa831143 || ($21abd87643c491e1$export$9ad51738fa831143 = {}));
var $21abd87643c491e1$export$34a9c908c18deb26;
(function(DestinationConfig) {
    DestinationConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$34a9c908c18deb26 || ($21abd87643c491e1$export$34a9c908c18deb26 = {}));
var $21abd87643c491e1$export$1c5160dce20fb6ab;
(function(FunctionResponseType) {
    FunctionResponseType["ReportBatchItemFailures"] = "ReportBatchItemFailures";
})($21abd87643c491e1$export$1c5160dce20fb6ab || ($21abd87643c491e1$export$1c5160dce20fb6ab = {}));
var $21abd87643c491e1$export$59d72ec91b8ab770;
(function(EndPointType) {
    EndPointType["KAFKA_BOOTSTRAP_SERVERS"] = "KAFKA_BOOTSTRAP_SERVERS";
})($21abd87643c491e1$export$59d72ec91b8ab770 || ($21abd87643c491e1$export$59d72ec91b8ab770 = {}));
var $21abd87643c491e1$export$8fc87e7dc7b0050;
(function(SelfManagedEventSource) {
    SelfManagedEventSource.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$8fc87e7dc7b0050 || ($21abd87643c491e1$export$8fc87e7dc7b0050 = {}));
var $21abd87643c491e1$export$ceccb8bd715aebd6;
(function(SourceAccessType) {
    SourceAccessType["BASIC_AUTH"] = "BASIC_AUTH";
    SourceAccessType["SASL_SCRAM_256_AUTH"] = "SASL_SCRAM_256_AUTH";
    SourceAccessType["SASL_SCRAM_512_AUTH"] = "SASL_SCRAM_512_AUTH";
    SourceAccessType["VIRTUAL_HOST"] = "VIRTUAL_HOST";
    SourceAccessType["VPC_SECURITY_GROUP"] = "VPC_SECURITY_GROUP";
    SourceAccessType["VPC_SUBNET"] = "VPC_SUBNET";
})($21abd87643c491e1$export$ceccb8bd715aebd6 || ($21abd87643c491e1$export$ceccb8bd715aebd6 = {}));
var $21abd87643c491e1$export$7411ad2eacc549dc;
(function(SourceAccessConfiguration) {
    SourceAccessConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$7411ad2eacc549dc || ($21abd87643c491e1$export$7411ad2eacc549dc = {}));
var $21abd87643c491e1$export$a1f9a9c2079e9c98;
(function(EventSourcePosition) {
    EventSourcePosition["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    EventSourcePosition["LATEST"] = "LATEST";
    EventSourcePosition["TRIM_HORIZON"] = "TRIM_HORIZON";
})($21abd87643c491e1$export$a1f9a9c2079e9c98 || ($21abd87643c491e1$export$a1f9a9c2079e9c98 = {}));
var $21abd87643c491e1$export$4e544eb76d8399b6;
(function(CreateEventSourceMappingRequest) {
    CreateEventSourceMappingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$4e544eb76d8399b6 || ($21abd87643c491e1$export$4e544eb76d8399b6 = {}));
var $21abd87643c491e1$export$bea98d62d0f9352a;
(function(EventSourceMappingConfiguration) {
    EventSourceMappingConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bea98d62d0f9352a || ($21abd87643c491e1$export$bea98d62d0f9352a = {}));
var $21abd87643c491e1$export$e54c84aed2f2d286;
(function(CodeSigningConfigNotFoundException) {
    CodeSigningConfigNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e54c84aed2f2d286 || ($21abd87643c491e1$export$e54c84aed2f2d286 = {}));
var $21abd87643c491e1$export$55982acb701a1f26;
(function(CodeStorageExceededException) {
    CodeStorageExceededException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$55982acb701a1f26 || ($21abd87643c491e1$export$55982acb701a1f26 = {}));
var $21abd87643c491e1$export$32bd9a52058c5ef6;
(function(CodeVerificationFailedException) {
    CodeVerificationFailedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$32bd9a52058c5ef6 || ($21abd87643c491e1$export$32bd9a52058c5ef6 = {}));
var $21abd87643c491e1$export$29b6bd41458ccef4;
(function(FunctionCode) {
    FunctionCode.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ZipFile && {
            ZipFile: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$29b6bd41458ccef4 || ($21abd87643c491e1$export$29b6bd41458ccef4 = {}));
var $21abd87643c491e1$export$e40ef3aa17060376;
(function(DeadLetterConfig) {
    DeadLetterConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e40ef3aa17060376 || ($21abd87643c491e1$export$e40ef3aa17060376 = {}));
var $21abd87643c491e1$export$7dc6752a22ab011a;
(function(Environment) {
    Environment.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Variables && {
            Variables: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$7dc6752a22ab011a || ($21abd87643c491e1$export$7dc6752a22ab011a = {}));
var $21abd87643c491e1$export$540954557dd379be;
(function(FileSystemConfig) {
    FileSystemConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$540954557dd379be || ($21abd87643c491e1$export$540954557dd379be = {}));
var $21abd87643c491e1$export$59f479bcabb172c4;
(function(ImageConfig) {
    ImageConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$59f479bcabb172c4 || ($21abd87643c491e1$export$59f479bcabb172c4 = {}));
var $21abd87643c491e1$export$149747cda232f97c;
(function(PackageType) {
    PackageType["Image"] = "Image";
    PackageType["Zip"] = "Zip";
})($21abd87643c491e1$export$149747cda232f97c || ($21abd87643c491e1$export$149747cda232f97c = {}));
var $21abd87643c491e1$export$269330a1f1074312;
(function(Runtime) {
    Runtime["dotnetcore10"] = "dotnetcore1.0";
    Runtime["dotnetcore20"] = "dotnetcore2.0";
    Runtime["dotnetcore21"] = "dotnetcore2.1";
    Runtime["dotnetcore31"] = "dotnetcore3.1";
    Runtime["go1x"] = "go1.x";
    Runtime["java11"] = "java11";
    Runtime["java8"] = "java8";
    Runtime["java8al2"] = "java8.al2";
    Runtime["nodejs"] = "nodejs";
    Runtime["nodejs10x"] = "nodejs10.x";
    Runtime["nodejs12x"] = "nodejs12.x";
    Runtime["nodejs14x"] = "nodejs14.x";
    Runtime["nodejs43"] = "nodejs4.3";
    Runtime["nodejs43edge"] = "nodejs4.3-edge";
    Runtime["nodejs610"] = "nodejs6.10";
    Runtime["nodejs810"] = "nodejs8.10";
    Runtime["provided"] = "provided";
    Runtime["providedal2"] = "provided.al2";
    Runtime["python27"] = "python2.7";
    Runtime["python36"] = "python3.6";
    Runtime["python37"] = "python3.7";
    Runtime["python38"] = "python3.8";
    Runtime["python39"] = "python3.9";
    Runtime["ruby25"] = "ruby2.5";
    Runtime["ruby27"] = "ruby2.7";
})($21abd87643c491e1$export$269330a1f1074312 || ($21abd87643c491e1$export$269330a1f1074312 = {}));
var $21abd87643c491e1$export$6563fd3c982e04f5;
(function(TracingMode) {
    TracingMode["Active"] = "Active";
    TracingMode["PassThrough"] = "PassThrough";
})($21abd87643c491e1$export$6563fd3c982e04f5 || ($21abd87643c491e1$export$6563fd3c982e04f5 = {}));
var $21abd87643c491e1$export$c0a71f064b1b2b9e;
(function(TracingConfig) {
    TracingConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c0a71f064b1b2b9e || ($21abd87643c491e1$export$c0a71f064b1b2b9e = {}));
var $21abd87643c491e1$export$dd37005b706bd38f;
(function(VpcConfig) {
    VpcConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$dd37005b706bd38f || ($21abd87643c491e1$export$dd37005b706bd38f = {}));
var $21abd87643c491e1$export$6d7c9efbf53fb03;
(function(CreateFunctionRequest) {
    CreateFunctionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Code && {
            Code: $21abd87643c491e1$export$29b6bd41458ccef4.filterSensitiveLog(obj.Code)
        }), obj.Environment && {
            Environment: $21abd87643c491e1$export$7dc6752a22ab011a.filterSensitiveLog(obj.Environment)
        });
    };
})($21abd87643c491e1$export$6d7c9efbf53fb03 || ($21abd87643c491e1$export$6d7c9efbf53fb03 = {}));
var $21abd87643c491e1$export$1864243dbeda840;
(function(EnvironmentError) {
    EnvironmentError.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Message && {
            Message: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$1864243dbeda840 || ($21abd87643c491e1$export$1864243dbeda840 = {}));
var $21abd87643c491e1$export$c860f821dd50b5b6;
(function(EnvironmentResponse) {
    EnvironmentResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Variables && {
            Variables: (0, $070d8fe31997500b$export$17127055dc9ac067)
        }), obj.Error && {
            Error: $21abd87643c491e1$export$1864243dbeda840.filterSensitiveLog(obj.Error)
        });
    };
})($21abd87643c491e1$export$c860f821dd50b5b6 || ($21abd87643c491e1$export$c860f821dd50b5b6 = {}));
var $21abd87643c491e1$export$7fabae26b4598119;
(function(ImageConfigError) {
    ImageConfigError.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Message && {
            Message: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$7fabae26b4598119 || ($21abd87643c491e1$export$7fabae26b4598119 = {}));
var $21abd87643c491e1$export$270b93b891ba3c4e;
(function(ImageConfigResponse) {
    ImageConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Error && {
            Error: $21abd87643c491e1$export$7fabae26b4598119.filterSensitiveLog(obj.Error)
        });
    };
})($21abd87643c491e1$export$270b93b891ba3c4e || ($21abd87643c491e1$export$270b93b891ba3c4e = {}));
var $21abd87643c491e1$export$ce43f59a3818f297;
(function(LastUpdateStatus) {
    LastUpdateStatus["Failed"] = "Failed";
    LastUpdateStatus["InProgress"] = "InProgress";
    LastUpdateStatus["Successful"] = "Successful";
})($21abd87643c491e1$export$ce43f59a3818f297 || ($21abd87643c491e1$export$ce43f59a3818f297 = {}));
var $21abd87643c491e1$export$d8313105d53695e1;
(function(LastUpdateStatusReasonCode) {
    LastUpdateStatusReasonCode["EniLimitExceeded"] = "EniLimitExceeded";
    LastUpdateStatusReasonCode["ImageAccessDenied"] = "ImageAccessDenied";
    LastUpdateStatusReasonCode["ImageDeleted"] = "ImageDeleted";
    LastUpdateStatusReasonCode["InsufficientRolePermissions"] = "InsufficientRolePermissions";
    LastUpdateStatusReasonCode["InternalError"] = "InternalError";
    LastUpdateStatusReasonCode["InvalidConfiguration"] = "InvalidConfiguration";
    LastUpdateStatusReasonCode["InvalidImage"] = "InvalidImage";
    LastUpdateStatusReasonCode["InvalidSecurityGroup"] = "InvalidSecurityGroup";
    LastUpdateStatusReasonCode["InvalidSubnet"] = "InvalidSubnet";
    LastUpdateStatusReasonCode["SubnetOutOfIPAddresses"] = "SubnetOutOfIPAddresses";
})($21abd87643c491e1$export$d8313105d53695e1 || ($21abd87643c491e1$export$d8313105d53695e1 = {}));
var $21abd87643c491e1$export$936d0764594b6eb3;
(function(Layer) {
    Layer.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$936d0764594b6eb3 || ($21abd87643c491e1$export$936d0764594b6eb3 = {}));
var $21abd87643c491e1$export$7254cc27399e90bd;
(function(State) {
    State["Active"] = "Active";
    State["Failed"] = "Failed";
    State["Inactive"] = "Inactive";
    State["Pending"] = "Pending";
})($21abd87643c491e1$export$7254cc27399e90bd || ($21abd87643c491e1$export$7254cc27399e90bd = {}));
var $21abd87643c491e1$export$3864471891a4d805;
(function(StateReasonCode) {
    StateReasonCode["Creating"] = "Creating";
    StateReasonCode["EniLimitExceeded"] = "EniLimitExceeded";
    StateReasonCode["Idle"] = "Idle";
    StateReasonCode["ImageAccessDenied"] = "ImageAccessDenied";
    StateReasonCode["ImageDeleted"] = "ImageDeleted";
    StateReasonCode["InsufficientRolePermissions"] = "InsufficientRolePermissions";
    StateReasonCode["InternalError"] = "InternalError";
    StateReasonCode["InvalidConfiguration"] = "InvalidConfiguration";
    StateReasonCode["InvalidImage"] = "InvalidImage";
    StateReasonCode["InvalidSecurityGroup"] = "InvalidSecurityGroup";
    StateReasonCode["InvalidSubnet"] = "InvalidSubnet";
    StateReasonCode["Restoring"] = "Restoring";
    StateReasonCode["SubnetOutOfIPAddresses"] = "SubnetOutOfIPAddresses";
})($21abd87643c491e1$export$3864471891a4d805 || ($21abd87643c491e1$export$3864471891a4d805 = {}));
var $21abd87643c491e1$export$47262bdfe85f3a08;
(function(TracingConfigResponse) {
    TracingConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$47262bdfe85f3a08 || ($21abd87643c491e1$export$47262bdfe85f3a08 = {}));
var $21abd87643c491e1$export$431452b6243e51b7;
(function(VpcConfigResponse) {
    VpcConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$431452b6243e51b7 || ($21abd87643c491e1$export$431452b6243e51b7 = {}));
var $21abd87643c491e1$export$77c29ca1369b0424;
(function(FunctionConfiguration) {
    FunctionConfiguration.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Environment && {
            Environment: $21abd87643c491e1$export$c860f821dd50b5b6.filterSensitiveLog(obj.Environment)
        }), obj.ImageConfigResponse && {
            ImageConfigResponse: $21abd87643c491e1$export$270b93b891ba3c4e.filterSensitiveLog(obj.ImageConfigResponse)
        });
    };
})($21abd87643c491e1$export$77c29ca1369b0424 || ($21abd87643c491e1$export$77c29ca1369b0424 = {}));
var $21abd87643c491e1$export$284210ae39d402cb;
(function(InvalidCodeSignatureException) {
    InvalidCodeSignatureException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$284210ae39d402cb || ($21abd87643c491e1$export$284210ae39d402cb = {}));
var $21abd87643c491e1$export$5686e546a03159a4;
(function(DeleteAliasRequest) {
    DeleteAliasRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$5686e546a03159a4 || ($21abd87643c491e1$export$5686e546a03159a4 = {}));
var $21abd87643c491e1$export$714e1fd4257568b2;
(function(DeleteCodeSigningConfigRequest) {
    DeleteCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$714e1fd4257568b2 || ($21abd87643c491e1$export$714e1fd4257568b2 = {}));
var $21abd87643c491e1$export$cfe512564392d015;
(function(DeleteCodeSigningConfigResponse) {
    DeleteCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$cfe512564392d015 || ($21abd87643c491e1$export$cfe512564392d015 = {}));
var $21abd87643c491e1$export$ec78edb5283f5665;
(function(DeleteEventSourceMappingRequest) {
    DeleteEventSourceMappingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ec78edb5283f5665 || ($21abd87643c491e1$export$ec78edb5283f5665 = {}));
var $21abd87643c491e1$export$64af664cd17ac744;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$64af664cd17ac744 || ($21abd87643c491e1$export$64af664cd17ac744 = {}));
var $21abd87643c491e1$export$ff218600f6df7d42;
(function(DeleteFunctionRequest) {
    DeleteFunctionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ff218600f6df7d42 || ($21abd87643c491e1$export$ff218600f6df7d42 = {}));
var $21abd87643c491e1$export$3af73caf2ddfb7a5;
(function(DeleteFunctionCodeSigningConfigRequest) {
    DeleteFunctionCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$3af73caf2ddfb7a5 || ($21abd87643c491e1$export$3af73caf2ddfb7a5 = {}));
var $21abd87643c491e1$export$200898163a5d59ba;
(function(DeleteFunctionConcurrencyRequest) {
    DeleteFunctionConcurrencyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$200898163a5d59ba || ($21abd87643c491e1$export$200898163a5d59ba = {}));
var $21abd87643c491e1$export$b74d0d33cad61f21;
(function(DeleteFunctionEventInvokeConfigRequest) {
    DeleteFunctionEventInvokeConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b74d0d33cad61f21 || ($21abd87643c491e1$export$b74d0d33cad61f21 = {}));
var $21abd87643c491e1$export$8b64e9ac6fe57546;
(function(DeleteLayerVersionRequest) {
    DeleteLayerVersionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$8b64e9ac6fe57546 || ($21abd87643c491e1$export$8b64e9ac6fe57546 = {}));
var $21abd87643c491e1$export$c549984138db33a8;
(function(DeleteProvisionedConcurrencyConfigRequest) {
    DeleteProvisionedConcurrencyConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c549984138db33a8 || ($21abd87643c491e1$export$c549984138db33a8 = {}));
var $21abd87643c491e1$export$f5b9ce1e4b5d4889;
(function(GetAccountSettingsRequest) {
    GetAccountSettingsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$f5b9ce1e4b5d4889 || ($21abd87643c491e1$export$f5b9ce1e4b5d4889 = {}));
var $21abd87643c491e1$export$beb557a0c36f99e2;
(function(GetAccountSettingsResponse) {
    GetAccountSettingsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$beb557a0c36f99e2 || ($21abd87643c491e1$export$beb557a0c36f99e2 = {}));
var $21abd87643c491e1$export$9def75b8730f5e27;
(function(GetAliasRequest) {
    GetAliasRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9def75b8730f5e27 || ($21abd87643c491e1$export$9def75b8730f5e27 = {}));
var $21abd87643c491e1$export$c47eeeaa76be3ed6;
(function(GetCodeSigningConfigRequest) {
    GetCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c47eeeaa76be3ed6 || ($21abd87643c491e1$export$c47eeeaa76be3ed6 = {}));
var $21abd87643c491e1$export$6ceeafd017e5201;
(function(GetCodeSigningConfigResponse) {
    GetCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6ceeafd017e5201 || ($21abd87643c491e1$export$6ceeafd017e5201 = {}));
var $21abd87643c491e1$export$a55db64ba319d08e;
(function(GetEventSourceMappingRequest) {
    GetEventSourceMappingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$a55db64ba319d08e || ($21abd87643c491e1$export$a55db64ba319d08e = {}));
var $21abd87643c491e1$export$ffe50d3f579a2754;
(function(GetFunctionRequest) {
    GetFunctionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ffe50d3f579a2754 || ($21abd87643c491e1$export$ffe50d3f579a2754 = {}));
var $21abd87643c491e1$export$34adedbe3c03e1a4;
(function(FunctionCodeLocation) {
    FunctionCodeLocation.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$34adedbe3c03e1a4 || ($21abd87643c491e1$export$34adedbe3c03e1a4 = {}));
var $21abd87643c491e1$export$8d5e30ed7774012f;
(function(Concurrency) {
    Concurrency.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$8d5e30ed7774012f || ($21abd87643c491e1$export$8d5e30ed7774012f = {}));
var $21abd87643c491e1$export$403dd55007e7f3f0;
(function(GetFunctionResponse) {
    GetFunctionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Configuration && {
            Configuration: $21abd87643c491e1$export$77c29ca1369b0424.filterSensitiveLog(obj.Configuration)
        });
    };
})($21abd87643c491e1$export$403dd55007e7f3f0 || ($21abd87643c491e1$export$403dd55007e7f3f0 = {}));
var $21abd87643c491e1$export$6fafcb555a465d51;
(function(GetFunctionCodeSigningConfigRequest) {
    GetFunctionCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6fafcb555a465d51 || ($21abd87643c491e1$export$6fafcb555a465d51 = {}));
var $21abd87643c491e1$export$9cf101e81b899df2;
(function(GetFunctionCodeSigningConfigResponse) {
    GetFunctionCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9cf101e81b899df2 || ($21abd87643c491e1$export$9cf101e81b899df2 = {}));
var $21abd87643c491e1$export$bc80ae776629cd53;
(function(GetFunctionConcurrencyRequest) {
    GetFunctionConcurrencyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bc80ae776629cd53 || ($21abd87643c491e1$export$bc80ae776629cd53 = {}));
var $21abd87643c491e1$export$8019dfef0406d964;
(function(GetFunctionConcurrencyResponse) {
    GetFunctionConcurrencyResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$8019dfef0406d964 || ($21abd87643c491e1$export$8019dfef0406d964 = {}));
var $21abd87643c491e1$export$ac1c188610d95412;
(function(GetFunctionConfigurationRequest) {
    GetFunctionConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ac1c188610d95412 || ($21abd87643c491e1$export$ac1c188610d95412 = {}));
var $21abd87643c491e1$export$d6d46fb7021cad77;
(function(FunctionEventInvokeConfig) {
    FunctionEventInvokeConfig.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$d6d46fb7021cad77 || ($21abd87643c491e1$export$d6d46fb7021cad77 = {}));
var $21abd87643c491e1$export$894802e88e2ce146;
(function(GetFunctionEventInvokeConfigRequest) {
    GetFunctionEventInvokeConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$894802e88e2ce146 || ($21abd87643c491e1$export$894802e88e2ce146 = {}));
var $21abd87643c491e1$export$94c7817b9e35b3d4;
(function(GetLayerVersionRequest) {
    GetLayerVersionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$94c7817b9e35b3d4 || ($21abd87643c491e1$export$94c7817b9e35b3d4 = {}));
var $21abd87643c491e1$export$3996f33a57f407c0;
(function(LayerVersionContentOutput) {
    LayerVersionContentOutput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$3996f33a57f407c0 || ($21abd87643c491e1$export$3996f33a57f407c0 = {}));
var $21abd87643c491e1$export$74a59fd51236254f;
(function(GetLayerVersionResponse) {
    GetLayerVersionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$74a59fd51236254f || ($21abd87643c491e1$export$74a59fd51236254f = {}));
var $21abd87643c491e1$export$3c7298a8a5fe9a2a;
(function(GetLayerVersionByArnRequest) {
    GetLayerVersionByArnRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$3c7298a8a5fe9a2a || ($21abd87643c491e1$export$3c7298a8a5fe9a2a = {}));
var $21abd87643c491e1$export$9853d5835a690fec;
(function(GetLayerVersionPolicyRequest) {
    GetLayerVersionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9853d5835a690fec || ($21abd87643c491e1$export$9853d5835a690fec = {}));
var $21abd87643c491e1$export$f4a64cbb912de531;
(function(GetLayerVersionPolicyResponse) {
    GetLayerVersionPolicyResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$f4a64cbb912de531 || ($21abd87643c491e1$export$f4a64cbb912de531 = {}));
var $21abd87643c491e1$export$50137def283dfb47;
(function(GetPolicyRequest) {
    GetPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$50137def283dfb47 || ($21abd87643c491e1$export$50137def283dfb47 = {}));
var $21abd87643c491e1$export$486587a1f8559efb;
(function(GetPolicyResponse) {
    GetPolicyResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$486587a1f8559efb || ($21abd87643c491e1$export$486587a1f8559efb = {}));
var $21abd87643c491e1$export$30fb6ef013b81688;
(function(GetProvisionedConcurrencyConfigRequest) {
    GetProvisionedConcurrencyConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$30fb6ef013b81688 || ($21abd87643c491e1$export$30fb6ef013b81688 = {}));
var $21abd87643c491e1$export$351e79571b4991ef;
(function(ProvisionedConcurrencyStatusEnum) {
    ProvisionedConcurrencyStatusEnum["FAILED"] = "FAILED";
    ProvisionedConcurrencyStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    ProvisionedConcurrencyStatusEnum["READY"] = "READY";
})($21abd87643c491e1$export$351e79571b4991ef || ($21abd87643c491e1$export$351e79571b4991ef = {}));
var $21abd87643c491e1$export$e03070d72fb8c16b;
(function(GetProvisionedConcurrencyConfigResponse) {
    GetProvisionedConcurrencyConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e03070d72fb8c16b || ($21abd87643c491e1$export$e03070d72fb8c16b = {}));
var $21abd87643c491e1$export$c8808edc259a8151;
(function(ProvisionedConcurrencyConfigNotFoundException) {
    ProvisionedConcurrencyConfigNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c8808edc259a8151 || ($21abd87643c491e1$export$c8808edc259a8151 = {}));
var $21abd87643c491e1$export$e60da1d6e9b1678d;
(function(EC2AccessDeniedException) {
    EC2AccessDeniedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e60da1d6e9b1678d || ($21abd87643c491e1$export$e60da1d6e9b1678d = {}));
var $21abd87643c491e1$export$df7a39f6670cbc14;
(function(EC2ThrottledException) {
    EC2ThrottledException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$df7a39f6670cbc14 || ($21abd87643c491e1$export$df7a39f6670cbc14 = {}));
var $21abd87643c491e1$export$69149cd9888a524d;
(function(EC2UnexpectedException) {
    EC2UnexpectedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$69149cd9888a524d || ($21abd87643c491e1$export$69149cd9888a524d = {}));
var $21abd87643c491e1$export$a756b1a079ff13b8;
(function(EFSIOException) {
    EFSIOException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$a756b1a079ff13b8 || ($21abd87643c491e1$export$a756b1a079ff13b8 = {}));
var $21abd87643c491e1$export$4732f746cc45f2ab;
(function(EFSMountConnectivityException) {
    EFSMountConnectivityException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$4732f746cc45f2ab || ($21abd87643c491e1$export$4732f746cc45f2ab = {}));
var $21abd87643c491e1$export$7f2239e35f5ac1a8;
(function(EFSMountFailureException) {
    EFSMountFailureException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$7f2239e35f5ac1a8 || ($21abd87643c491e1$export$7f2239e35f5ac1a8 = {}));
var $21abd87643c491e1$export$30aeeecd87e735f4;
(function(EFSMountTimeoutException) {
    EFSMountTimeoutException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$30aeeecd87e735f4 || ($21abd87643c491e1$export$30aeeecd87e735f4 = {}));
var $21abd87643c491e1$export$720586a8d42089b6;
(function(ENILimitReachedException) {
    ENILimitReachedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$720586a8d42089b6 || ($21abd87643c491e1$export$720586a8d42089b6 = {}));
var $21abd87643c491e1$export$1be16b3a4a260ffa;
(function(InvalidRequestContentException) {
    InvalidRequestContentException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$1be16b3a4a260ffa || ($21abd87643c491e1$export$1be16b3a4a260ffa = {}));
var $21abd87643c491e1$export$2b86ebd67244f776;
(function(InvalidRuntimeException) {
    InvalidRuntimeException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$2b86ebd67244f776 || ($21abd87643c491e1$export$2b86ebd67244f776 = {}));
var $21abd87643c491e1$export$f2ce020773612d02;
(function(InvalidSecurityGroupIDException) {
    InvalidSecurityGroupIDException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$f2ce020773612d02 || ($21abd87643c491e1$export$f2ce020773612d02 = {}));
var $21abd87643c491e1$export$709d50cec5416abf;
(function(InvalidSubnetIDException) {
    InvalidSubnetIDException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$709d50cec5416abf || ($21abd87643c491e1$export$709d50cec5416abf = {}));
var $21abd87643c491e1$export$579dffd69d40832a;
(function(InvalidZipFileException) {
    InvalidZipFileException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$579dffd69d40832a || ($21abd87643c491e1$export$579dffd69d40832a = {}));
var $21abd87643c491e1$export$d23bded1f2d491d0;
(function(InvocationType) {
    InvocationType["DryRun"] = "DryRun";
    InvocationType["Event"] = "Event";
    InvocationType["RequestResponse"] = "RequestResponse";
})($21abd87643c491e1$export$d23bded1f2d491d0 || ($21abd87643c491e1$export$d23bded1f2d491d0 = {}));
var $21abd87643c491e1$export$a0472aa3a356446c;
(function(LogType) {
    LogType["None"] = "None";
    LogType["Tail"] = "Tail";
})($21abd87643c491e1$export$a0472aa3a356446c || ($21abd87643c491e1$export$a0472aa3a356446c = {}));
var $21abd87643c491e1$export$ec5d8117ba2cf562;
(function(InvocationRequest) {
    InvocationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Payload && {
            Payload: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$ec5d8117ba2cf562 || ($21abd87643c491e1$export$ec5d8117ba2cf562 = {}));
var $21abd87643c491e1$export$2a63c89905f1de62;
(function(InvocationResponse) {
    InvocationResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Payload && {
            Payload: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$2a63c89905f1de62 || ($21abd87643c491e1$export$2a63c89905f1de62 = {}));
var $21abd87643c491e1$export$94ad5f879b39c8eb;
(function(KMSAccessDeniedException) {
    KMSAccessDeniedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$94ad5f879b39c8eb || ($21abd87643c491e1$export$94ad5f879b39c8eb = {}));
var $21abd87643c491e1$export$bc1172aa6ec4fb7b;
(function(KMSDisabledException) {
    KMSDisabledException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bc1172aa6ec4fb7b || ($21abd87643c491e1$export$bc1172aa6ec4fb7b = {}));
var $21abd87643c491e1$export$16b76627a54694a8;
(function(KMSInvalidStateException) {
    KMSInvalidStateException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$16b76627a54694a8 || ($21abd87643c491e1$export$16b76627a54694a8 = {}));
var $21abd87643c491e1$export$38af9cf22646c616;
(function(KMSNotFoundException) {
    KMSNotFoundException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$38af9cf22646c616 || ($21abd87643c491e1$export$38af9cf22646c616 = {}));
var $21abd87643c491e1$export$6c882145b7588dbb;
(function(RequestTooLargeException) {
    RequestTooLargeException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6c882145b7588dbb || ($21abd87643c491e1$export$6c882145b7588dbb = {}));
var $21abd87643c491e1$export$274d3421adb04146;
(function(ResourceNotReadyException) {
    ResourceNotReadyException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$274d3421adb04146 || ($21abd87643c491e1$export$274d3421adb04146 = {}));
var $21abd87643c491e1$export$1a15863efea0079c;
(function(SubnetIPAddressLimitReachedException) {
    SubnetIPAddressLimitReachedException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$1a15863efea0079c || ($21abd87643c491e1$export$1a15863efea0079c = {}));
var $21abd87643c491e1$export$8343035491ff1aa5;
(function(UnsupportedMediaTypeException) {
    UnsupportedMediaTypeException.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$8343035491ff1aa5 || ($21abd87643c491e1$export$8343035491ff1aa5 = {}));
var $21abd87643c491e1$export$68aea02abc456157;
(function(InvokeAsyncRequest) {
    InvokeAsyncRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$68aea02abc456157 || ($21abd87643c491e1$export$68aea02abc456157 = {}));
var $21abd87643c491e1$export$a4addf28694a260;
(function(InvokeAsyncResponse) {
    InvokeAsyncResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$a4addf28694a260 || ($21abd87643c491e1$export$a4addf28694a260 = {}));
var $21abd87643c491e1$export$bf459c654ea6beba;
(function(ListAliasesRequest) {
    ListAliasesRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bf459c654ea6beba || ($21abd87643c491e1$export$bf459c654ea6beba = {}));
var $21abd87643c491e1$export$b7cda41660b182df;
(function(ListAliasesResponse) {
    ListAliasesResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b7cda41660b182df || ($21abd87643c491e1$export$b7cda41660b182df = {}));
var $21abd87643c491e1$export$b185406a9855801b;
(function(ListCodeSigningConfigsRequest) {
    ListCodeSigningConfigsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b185406a9855801b || ($21abd87643c491e1$export$b185406a9855801b = {}));
var $21abd87643c491e1$export$61dbda21c299e39a;
(function(ListCodeSigningConfigsResponse) {
    ListCodeSigningConfigsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$61dbda21c299e39a || ($21abd87643c491e1$export$61dbda21c299e39a = {}));
var $21abd87643c491e1$export$bb9861089d9eff87;
(function(ListEventSourceMappingsRequest) {
    ListEventSourceMappingsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bb9861089d9eff87 || ($21abd87643c491e1$export$bb9861089d9eff87 = {}));
var $21abd87643c491e1$export$bed4c84a74c02b99;
(function(ListEventSourceMappingsResponse) {
    ListEventSourceMappingsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bed4c84a74c02b99 || ($21abd87643c491e1$export$bed4c84a74c02b99 = {}));
var $21abd87643c491e1$export$b21750a41a3f49f8;
(function(ListFunctionEventInvokeConfigsRequest) {
    ListFunctionEventInvokeConfigsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b21750a41a3f49f8 || ($21abd87643c491e1$export$b21750a41a3f49f8 = {}));
var $21abd87643c491e1$export$c07c9da2ff1f4435;
(function(ListFunctionEventInvokeConfigsResponse) {
    ListFunctionEventInvokeConfigsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c07c9da2ff1f4435 || ($21abd87643c491e1$export$c07c9da2ff1f4435 = {}));
var $21abd87643c491e1$export$7b25618e83bd52a5;
(function(FunctionVersion) {
    FunctionVersion["ALL"] = "ALL";
})($21abd87643c491e1$export$7b25618e83bd52a5 || ($21abd87643c491e1$export$7b25618e83bd52a5 = {}));
var $21abd87643c491e1$export$9255ed105e8da54c;
(function(ListFunctionsRequest) {
    ListFunctionsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9255ed105e8da54c || ($21abd87643c491e1$export$9255ed105e8da54c = {}));
var $21abd87643c491e1$export$e3ada903b16e0858;
(function(ListFunctionsResponse) {
    ListFunctionsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Functions && {
            Functions: obj.Functions.map(function(item) {
                return $21abd87643c491e1$export$77c29ca1369b0424.filterSensitiveLog(item);
            })
        });
    };
})($21abd87643c491e1$export$e3ada903b16e0858 || ($21abd87643c491e1$export$e3ada903b16e0858 = {}));
var $21abd87643c491e1$export$96d969e7b42135e9;
(function(ListFunctionsByCodeSigningConfigRequest) {
    ListFunctionsByCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$96d969e7b42135e9 || ($21abd87643c491e1$export$96d969e7b42135e9 = {}));
var $21abd87643c491e1$export$ec3f293d1cb17e30;
(function(ListFunctionsByCodeSigningConfigResponse) {
    ListFunctionsByCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ec3f293d1cb17e30 || ($21abd87643c491e1$export$ec3f293d1cb17e30 = {}));
var $21abd87643c491e1$export$6cef31b601595b63;
(function(ListLayersRequest) {
    ListLayersRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6cef31b601595b63 || ($21abd87643c491e1$export$6cef31b601595b63 = {}));
var $21abd87643c491e1$export$e70b76da304dce;
(function(LayerVersionsListItem) {
    LayerVersionsListItem.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e70b76da304dce || ($21abd87643c491e1$export$e70b76da304dce = {}));
var $21abd87643c491e1$export$b79a22966bcfc06a;
(function(LayersListItem) {
    LayersListItem.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b79a22966bcfc06a || ($21abd87643c491e1$export$b79a22966bcfc06a = {}));
var $21abd87643c491e1$export$950bdac550b0a9a1;
(function(ListLayersResponse) {
    ListLayersResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$950bdac550b0a9a1 || ($21abd87643c491e1$export$950bdac550b0a9a1 = {}));
var $21abd87643c491e1$export$4c7e618b590a0470;
(function(ListLayerVersionsRequest) {
    ListLayerVersionsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$4c7e618b590a0470 || ($21abd87643c491e1$export$4c7e618b590a0470 = {}));
var $21abd87643c491e1$export$b079b2514f5405b9;
(function(ListLayerVersionsResponse) {
    ListLayerVersionsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$b079b2514f5405b9 || ($21abd87643c491e1$export$b079b2514f5405b9 = {}));
var $21abd87643c491e1$export$cc4ce11b74f7c237;
(function(ListProvisionedConcurrencyConfigsRequest) {
    ListProvisionedConcurrencyConfigsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$cc4ce11b74f7c237 || ($21abd87643c491e1$export$cc4ce11b74f7c237 = {}));
var $21abd87643c491e1$export$f58f812a08cb8454;
(function(ProvisionedConcurrencyConfigListItem) {
    ProvisionedConcurrencyConfigListItem.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$f58f812a08cb8454 || ($21abd87643c491e1$export$f58f812a08cb8454 = {}));
var $21abd87643c491e1$export$845673afc41a57b1;
(function(ListProvisionedConcurrencyConfigsResponse) {
    ListProvisionedConcurrencyConfigsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$845673afc41a57b1 || ($21abd87643c491e1$export$845673afc41a57b1 = {}));
var $21abd87643c491e1$export$85bf8bedf74a0bff;
(function(ListTagsRequest) {
    ListTagsRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$85bf8bedf74a0bff || ($21abd87643c491e1$export$85bf8bedf74a0bff = {}));
var $21abd87643c491e1$export$e78af42e582805d0;
(function(ListTagsResponse) {
    ListTagsResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e78af42e582805d0 || ($21abd87643c491e1$export$e78af42e582805d0 = {}));
var $21abd87643c491e1$export$2dba86d796da12e0;
(function(ListVersionsByFunctionRequest) {
    ListVersionsByFunctionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$2dba86d796da12e0 || ($21abd87643c491e1$export$2dba86d796da12e0 = {}));
var $21abd87643c491e1$export$9266539b0fb2643c;
(function(ListVersionsByFunctionResponse) {
    ListVersionsByFunctionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Versions && {
            Versions: obj.Versions.map(function(item) {
                return $21abd87643c491e1$export$77c29ca1369b0424.filterSensitiveLog(item);
            })
        });
    };
})($21abd87643c491e1$export$9266539b0fb2643c || ($21abd87643c491e1$export$9266539b0fb2643c = {}));
var $21abd87643c491e1$export$c49d7970f830656d;
(function(LayerVersionContentInput) {
    LayerVersionContentInput.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ZipFile && {
            ZipFile: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$c49d7970f830656d || ($21abd87643c491e1$export$c49d7970f830656d = {}));
var $21abd87643c491e1$export$7a91b3034908716e;
(function(PublishLayerVersionRequest) {
    PublishLayerVersionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Content && {
            Content: $21abd87643c491e1$export$c49d7970f830656d.filterSensitiveLog(obj.Content)
        });
    };
})($21abd87643c491e1$export$7a91b3034908716e || ($21abd87643c491e1$export$7a91b3034908716e = {}));
var $21abd87643c491e1$export$dc2f4218af5f3677;
(function(PublishLayerVersionResponse) {
    PublishLayerVersionResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$dc2f4218af5f3677 || ($21abd87643c491e1$export$dc2f4218af5f3677 = {}));
var $21abd87643c491e1$export$c7599fd2029ad5f9;
(function(PublishVersionRequest) {
    PublishVersionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$c7599fd2029ad5f9 || ($21abd87643c491e1$export$c7599fd2029ad5f9 = {}));
var $21abd87643c491e1$export$d9ee6767c4988e20;
(function(PutFunctionCodeSigningConfigRequest) {
    PutFunctionCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$d9ee6767c4988e20 || ($21abd87643c491e1$export$d9ee6767c4988e20 = {}));
var $21abd87643c491e1$export$13d16e7a97ce7527;
(function(PutFunctionCodeSigningConfigResponse) {
    PutFunctionCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$13d16e7a97ce7527 || ($21abd87643c491e1$export$13d16e7a97ce7527 = {}));
var $21abd87643c491e1$export$7c6fc4c9328cc4ca;
(function(PutFunctionConcurrencyRequest) {
    PutFunctionConcurrencyRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$7c6fc4c9328cc4ca || ($21abd87643c491e1$export$7c6fc4c9328cc4ca = {}));
var $21abd87643c491e1$export$a76c7573469f03e4;
(function(PutFunctionEventInvokeConfigRequest) {
    PutFunctionEventInvokeConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$a76c7573469f03e4 || ($21abd87643c491e1$export$a76c7573469f03e4 = {}));
var $21abd87643c491e1$export$d9ae93a0e1fcaaa2;
(function(PutProvisionedConcurrencyConfigRequest) {
    PutProvisionedConcurrencyConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$d9ae93a0e1fcaaa2 || ($21abd87643c491e1$export$d9ae93a0e1fcaaa2 = {}));
var $21abd87643c491e1$export$e04b0965a7594372;
(function(PutProvisionedConcurrencyConfigResponse) {
    PutProvisionedConcurrencyConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$e04b0965a7594372 || ($21abd87643c491e1$export$e04b0965a7594372 = {}));
var $21abd87643c491e1$export$ea612e71d74e701e;
(function(RemoveLayerVersionPermissionRequest) {
    RemoveLayerVersionPermissionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$ea612e71d74e701e || ($21abd87643c491e1$export$ea612e71d74e701e = {}));
var $21abd87643c491e1$export$6742908bdad17700;
(function(RemovePermissionRequest) {
    RemovePermissionRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$6742908bdad17700 || ($21abd87643c491e1$export$6742908bdad17700 = {}));
var $21abd87643c491e1$export$bf890a678e449fc2;
(function(TagResourceRequest) {
    TagResourceRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$bf890a678e449fc2 || ($21abd87643c491e1$export$bf890a678e449fc2 = {}));
var $21abd87643c491e1$export$7ebb14554e37eb78;
(function(UntagResourceRequest) {
    UntagResourceRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$7ebb14554e37eb78 || ($21abd87643c491e1$export$7ebb14554e37eb78 = {}));
var $21abd87643c491e1$export$9f2a49088d99d9c4;
(function(UpdateAliasRequest) {
    UpdateAliasRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$9f2a49088d99d9c4 || ($21abd87643c491e1$export$9f2a49088d99d9c4 = {}));
var $21abd87643c491e1$export$a7509f1cb2a520ce;
(function(UpdateCodeSigningConfigRequest) {
    UpdateCodeSigningConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$a7509f1cb2a520ce || ($21abd87643c491e1$export$a7509f1cb2a520ce = {}));
var $21abd87643c491e1$export$de8c903f7fb8f4e0;
(function(UpdateCodeSigningConfigResponse) {
    UpdateCodeSigningConfigResponse.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$de8c903f7fb8f4e0 || ($21abd87643c491e1$export$de8c903f7fb8f4e0 = {}));
var $21abd87643c491e1$export$76fcca36bf5a853a;
(function(UpdateEventSourceMappingRequest) {
    UpdateEventSourceMappingRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$76fcca36bf5a853a || ($21abd87643c491e1$export$76fcca36bf5a853a = {}));
var $21abd87643c491e1$export$7a1726fb2558bfff;
(function(UpdateFunctionCodeRequest) {
    UpdateFunctionCodeRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.ZipFile && {
            ZipFile: (0, $070d8fe31997500b$export$17127055dc9ac067)
        });
    };
})($21abd87643c491e1$export$7a1726fb2558bfff || ($21abd87643c491e1$export$7a1726fb2558bfff = {}));
var $21abd87643c491e1$export$e50ee5f4906afcc3;
(function(UpdateFunctionConfigurationRequest) {
    UpdateFunctionConfigurationRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj), obj.Environment && {
            Environment: $21abd87643c491e1$export$7dc6752a22ab011a.filterSensitiveLog(obj.Environment)
        });
    };
})($21abd87643c491e1$export$e50ee5f4906afcc3 || ($21abd87643c491e1$export$e50ee5f4906afcc3 = {}));
var $21abd87643c491e1$export$1f2bfd4d65d92927;
(function(UpdateFunctionEventInvokeConfigRequest) {
    UpdateFunctionEventInvokeConfigRequest.filterSensitiveLog = function(obj) {
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, obj);
    };
})($21abd87643c491e1$export$1f2bfd4d65d92927 || ($21abd87643c491e1$export$1f2bfd4d65d92927 = {}));






var $d0707dbdfb3e3b57$export$7587955500404ec3 = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, this), {
            headers: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $d0707dbdfb3e3b57$var$cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function $d0707dbdfb3e3b57$var$cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(param)) : param, _a));
    }, {});
}


var $600777a260ad8290$export$1d94dfe0d9d1f1e7 = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();


function $3a11c096f571b86a$export$e024c793399bdd01(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}





var $31426a0b6b5dd4d5$export$50ab8fc0130f057f = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    if (input.VersionNumber !== undefined) {
                        labelValue = input.VersionNumber.toString();
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: VersionNumber.");
                        resolvedPath = resolvedPath.replace("{VersionNumber}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: VersionNumber.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.RevisionId !== undefined && {
                        RevisionId: input.RevisionId
                    });
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Action !== undefined && input.Action !== null && {
                        Action: input.Action
                    }), input.OrganizationId !== undefined && input.OrganizationId !== null && {
                        OrganizationId: input.OrganizationId
                    }), input.Principal !== undefined && input.Principal !== null && {
                        Principal: input.Principal
                    }), input.StatementId !== undefined && input.StatementId !== null && {
                        StatementId: input.StatementId
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$fa7f0a80dacc84e3 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/policy";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Action !== undefined && input.Action !== null && {
                        Action: input.Action
                    }), input.EventSourceToken !== undefined && input.EventSourceToken !== null && {
                        EventSourceToken: input.EventSourceToken
                    }), input.Principal !== undefined && input.Principal !== null && {
                        Principal: input.Principal
                    }), input.RevisionId !== undefined && input.RevisionId !== null && {
                        RevisionId: input.RevisionId
                    }), input.SourceAccount !== undefined && input.SourceAccount !== null && {
                        SourceAccount: input.SourceAccount
                    }), input.SourceArn !== undefined && input.SourceArn !== null && {
                        SourceArn: input.SourceArn
                    }), input.StatementId !== undefined && input.StatementId !== null && {
                        StatementId: input.StatementId
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$9feab209c0beec = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/aliases";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.FunctionVersion !== undefined && input.FunctionVersion !== null && {
                        FunctionVersion: input.FunctionVersion
                    }), input.Name !== undefined && input.Name !== null && {
                        Name: input.Name
                    }), input.RoutingConfig !== undefined && input.RoutingConfig !== null && {
                        RoutingConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1AliasRoutingConfiguration(input.RoutingConfig, context)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$b089d0f0aa115e7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs";
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AllowedPublishers !== undefined && input.AllowedPublishers !== null && {
                        AllowedPublishers: $31426a0b6b5dd4d5$var$serializeAws_restJson1AllowedPublishers(input.AllowedPublishers, context)
                    }), input.CodeSigningPolicies !== undefined && input.CodeSigningPolicies !== null && {
                        CodeSigningPolicies: $31426a0b6b5dd4d5$var$serializeAws_restJson1CodeSigningPolicies(input.CodeSigningPolicies, context)
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$1f678d3a78ba68f7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/event-source-mappings";
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.BatchSize !== undefined && input.BatchSize !== null && {
                        BatchSize: input.BatchSize
                    }), input.BisectBatchOnFunctionError !== undefined && input.BisectBatchOnFunctionError !== null && {
                        BisectBatchOnFunctionError: input.BisectBatchOnFunctionError
                    }), input.DestinationConfig !== undefined && input.DestinationConfig !== null && {
                        DestinationConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DestinationConfig(input.DestinationConfig, context)
                    }), input.Enabled !== undefined && input.Enabled !== null && {
                        Enabled: input.Enabled
                    }), input.EventSourceArn !== undefined && input.EventSourceArn !== null && {
                        EventSourceArn: input.EventSourceArn
                    }), input.FunctionName !== undefined && input.FunctionName !== null && {
                        FunctionName: input.FunctionName
                    }), input.FunctionResponseTypes !== undefined && input.FunctionResponseTypes !== null && {
                        FunctionResponseTypes: $31426a0b6b5dd4d5$var$serializeAws_restJson1FunctionResponseTypeList(input.FunctionResponseTypes, context)
                    }), input.MaximumBatchingWindowInSeconds !== undefined && input.MaximumBatchingWindowInSeconds !== null && {
                        MaximumBatchingWindowInSeconds: input.MaximumBatchingWindowInSeconds
                    }), input.MaximumRecordAgeInSeconds !== undefined && input.MaximumRecordAgeInSeconds !== null && {
                        MaximumRecordAgeInSeconds: input.MaximumRecordAgeInSeconds
                    }), input.MaximumRetryAttempts !== undefined && input.MaximumRetryAttempts !== null && {
                        MaximumRetryAttempts: input.MaximumRetryAttempts
                    }), input.ParallelizationFactor !== undefined && input.ParallelizationFactor !== null && {
                        ParallelizationFactor: input.ParallelizationFactor
                    }), input.Queues !== undefined && input.Queues !== null && {
                        Queues: $31426a0b6b5dd4d5$var$serializeAws_restJson1Queues(input.Queues, context)
                    }), input.SelfManagedEventSource !== undefined && input.SelfManagedEventSource !== null && {
                        SelfManagedEventSource: $31426a0b6b5dd4d5$var$serializeAws_restJson1SelfManagedEventSource(input.SelfManagedEventSource, context)
                    }), input.SourceAccessConfigurations !== undefined && input.SourceAccessConfigurations !== null && {
                        SourceAccessConfigurations: $31426a0b6b5dd4d5$var$serializeAws_restJson1SourceAccessConfigurations(input.SourceAccessConfigurations, context)
                    }), input.StartingPosition !== undefined && input.StartingPosition !== null && {
                        StartingPosition: input.StartingPosition
                    }), input.StartingPositionTimestamp !== undefined && input.StartingPositionTimestamp !== null && {
                        StartingPositionTimestamp: Math.round(input.StartingPositionTimestamp.getTime() / 1000)
                    }), input.Topics !== undefined && input.Topics !== null && {
                        Topics: $31426a0b6b5dd4d5$var$serializeAws_restJson1Topics(input.Topics, context)
                    }), input.TumblingWindowInSeconds !== undefined && input.TumblingWindowInSeconds !== null && {
                        TumblingWindowInSeconds: input.TumblingWindowInSeconds
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ab6835b10ab5f84e = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions";
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Architectures !== undefined && input.Architectures !== null && {
                        Architectures: $31426a0b6b5dd4d5$var$serializeAws_restJson1ArchitecturesList(input.Architectures, context)
                    }), input.Code !== undefined && input.Code !== null && {
                        Code: $31426a0b6b5dd4d5$var$serializeAws_restJson1FunctionCode(input.Code, context)
                    }), input.CodeSigningConfigArn !== undefined && input.CodeSigningConfigArn !== null && {
                        CodeSigningConfigArn: input.CodeSigningConfigArn
                    }), input.DeadLetterConfig !== undefined && input.DeadLetterConfig !== null && {
                        DeadLetterConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DeadLetterConfig(input.DeadLetterConfig, context)
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.Environment !== undefined && input.Environment !== null && {
                        Environment: $31426a0b6b5dd4d5$var$serializeAws_restJson1Environment(input.Environment, context)
                    }), input.FileSystemConfigs !== undefined && input.FileSystemConfigs !== null && {
                        FileSystemConfigs: $31426a0b6b5dd4d5$var$serializeAws_restJson1FileSystemConfigList(input.FileSystemConfigs, context)
                    }), input.FunctionName !== undefined && input.FunctionName !== null && {
                        FunctionName: input.FunctionName
                    }), input.Handler !== undefined && input.Handler !== null && {
                        Handler: input.Handler
                    }), input.ImageConfig !== undefined && input.ImageConfig !== null && {
                        ImageConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1ImageConfig(input.ImageConfig, context)
                    }), input.KMSKeyArn !== undefined && input.KMSKeyArn !== null && {
                        KMSKeyArn: input.KMSKeyArn
                    }), input.Layers !== undefined && input.Layers !== null && {
                        Layers: $31426a0b6b5dd4d5$var$serializeAws_restJson1LayerList(input.Layers, context)
                    }), input.MemorySize !== undefined && input.MemorySize !== null && {
                        MemorySize: input.MemorySize
                    }), input.PackageType !== undefined && input.PackageType !== null && {
                        PackageType: input.PackageType
                    }), input.Publish !== undefined && input.Publish !== null && {
                        Publish: input.Publish
                    }), input.Role !== undefined && input.Role !== null && {
                        Role: input.Role
                    }), input.Runtime !== undefined && input.Runtime !== null && {
                        Runtime: input.Runtime
                    }), input.Tags !== undefined && input.Tags !== null && {
                        Tags: $31426a0b6b5dd4d5$var$serializeAws_restJson1Tags(input.Tags, context)
                    }), input.Timeout !== undefined && input.Timeout !== null && {
                        Timeout: input.Timeout
                    }), input.TracingConfig !== undefined && input.TracingConfig !== null && {
                        TracingConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1TracingConfig(input.TracingConfig, context)
                    }), input.VpcConfig !== undefined && input.VpcConfig !== null && {
                        VpcConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1VpcConfig(input.VpcConfig, context)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$69c976a7e7772be = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/aliases/{Name}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    if (input.Name !== undefined) {
                        labelValue = input.Name;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Name.");
                        resolvedPath = resolvedPath.replace("{Name}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Name.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$14618ec44c9fdb54 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}";
                    if (input.CodeSigningConfigArn !== undefined) {
                        labelValue = input.CodeSigningConfigArn;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: CodeSigningConfigArn.");
                        resolvedPath = resolvedPath.replace("{CodeSigningConfigArn}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: CodeSigningConfigArn.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$326cd5557d527201 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/event-source-mappings/{UUID}";
                    if (input.UUID !== undefined) {
                        labelValue = input.UUID;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: UUID.");
                        resolvedPath = resolvedPath.replace("{UUID}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: UUID.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$537cfb64330b1e33 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$6c4fa00e50223ed6 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-06-30/functions/{FunctionName}/code-signing-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$8e350abe9de9192a = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2017-10-31/functions/{FunctionName}/concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$4c7c676b470df533 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-25/functions/{FunctionName}/event-invoke-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$b5a3fa138e2aab71 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    if (input.VersionNumber !== undefined) {
                        labelValue = input.VersionNumber.toString();
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: VersionNumber.");
                        resolvedPath = resolvedPath.replace("{VersionNumber}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: VersionNumber.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ac0f1d2de92153e = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-30/functions/{FunctionName}/provisioned-concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a3ba9a54bc002e59 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2016-08-19/account-settings";
                    body = "";
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$3c51941544a32e62 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/aliases/{Name}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    if (input.Name !== undefined) {
                        labelValue = input.Name;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Name.");
                        resolvedPath = resolvedPath.replace("{Name}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Name.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7493fbbad579298c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}";
                    if (input.CodeSigningConfigArn !== undefined) {
                        labelValue = input.CodeSigningConfigArn;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: CodeSigningConfigArn.");
                        resolvedPath = resolvedPath.replace("{CodeSigningConfigArn}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: CodeSigningConfigArn.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c61dd1f3df4548ab = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/event-source-mappings/{UUID}";
                    if (input.UUID !== undefined) {
                        labelValue = input.UUID;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: UUID.");
                        resolvedPath = resolvedPath.replace("{UUID}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: UUID.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$8f396438c5c5fc10 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7ba60d67a4914fb2 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-06-30/functions/{FunctionName}/code-signing-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c1f2e92136d21c65 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-30/functions/{FunctionName}/concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$4c358f8ec33f718d = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/configuration";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$9dad1e5bfaafe04e = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-25/functions/{FunctionName}/event-invoke-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a0a3d3f07e9e5bc = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    if (input.VersionNumber !== undefined) {
                        labelValue = input.VersionNumber.toString();
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: VersionNumber.");
                        resolvedPath = resolvedPath.replace("{VersionNumber}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: VersionNumber.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$be87d424586b307b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers";
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        find: "LayerVersion"
                    }, input.Arn !== undefined && {
                        Arn: input.Arn
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ebf0bd6654eb032c = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    if (input.VersionNumber !== undefined) {
                        labelValue = input.VersionNumber.toString();
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: VersionNumber.");
                        resolvedPath = resolvedPath.replace("{VersionNumber}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: VersionNumber.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$13faeea1eea217dc = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/policy";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$d1a4a195ebd76669 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-30/functions/{FunctionName}/provisioned-concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$46f3d7ab2a840ae7 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        "content-type": "application/octet-stream"
                    }, $31426a0b6b5dd4d5$var$isSerializableHeaderValue(input.InvocationType) && {
                        "x-amz-invocation-type": input.InvocationType
                    }), $31426a0b6b5dd4d5$var$isSerializableHeaderValue(input.LogType) && {
                        "x-amz-log-type": input.LogType
                    }), $31426a0b6b5dd4d5$var$isSerializableHeaderValue(input.ClientContext) && {
                        "x-amz-client-context": input.ClientContext
                    });
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/invocations";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    if (input.Payload !== undefined) body = input.Payload;
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$37fcffccb08deb25 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/octet-stream"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2014-11-13/functions/{FunctionName}/invoke-async";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    if (input.InvokeArgs !== undefined) body = input.InvokeArgs;
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$aec3ffa32b6c9e1b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/aliases";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.FunctionVersion !== undefined && {
                        FunctionVersion: input.FunctionVersion
                    }), input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$589e7b4ab3731041 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs";
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$51ba9350940d1e4e = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/event-source-mappings";
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.EventSourceArn !== undefined && {
                        EventSourceArn: input.EventSourceArn
                    }), input.FunctionName !== undefined && {
                        FunctionName: input.FunctionName
                    }), input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$73d0272bcafba044 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-25/functions/{FunctionName}/event-invoke-config/list";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$da80a4c1645ae823 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions";
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.MasterRegion !== undefined && {
                        MasterRegion: input.MasterRegion
                    }), input.FunctionVersion !== undefined && {
                        FunctionVersion: input.FunctionVersion
                    }), input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$169c8f2b3b203677 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}/functions";
                    if (input.CodeSigningConfigArn !== undefined) {
                        labelValue = input.CodeSigningConfigArn;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: CodeSigningConfigArn.");
                        resolvedPath = resolvedPath.replace("{CodeSigningConfigArn}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: CodeSigningConfigArn.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$bb1f04de871cebd0 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers";
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CompatibleRuntime !== undefined && {
                        CompatibleRuntime: input.CompatibleRuntime
                    }), input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    }), input.CompatibleArchitecture !== undefined && {
                        CompatibleArchitecture: input.CompatibleArchitecture
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$2312a37b77fd3b21 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CompatibleRuntime !== undefined && {
                        CompatibleRuntime: input.CompatibleRuntime
                    }), input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    }), input.CompatibleArchitecture !== undefined && {
                        CompatibleArchitecture: input.CompatibleArchitecture
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$10ba5ac6551c8159 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-30/functions/{FunctionName}/provisioned-concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
                        List: "ALL"
                    }, input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$5ef66abcc7d53268 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2017-03-31/tags/{Resource}";
                    if (input.Resource !== undefined) {
                        labelValue = input.Resource;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Resource.");
                        resolvedPath = resolvedPath.replace("{Resource}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Resource.");
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$f535b568eed5a0ca = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/versions";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Marker !== undefined && {
                        Marker: input.Marker
                    }), input.MaxItems !== undefined && {
                        MaxItems: input.MaxItems.toString()
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$32a001ab47e4fa9 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CompatibleArchitectures !== undefined && input.CompatibleArchitectures !== null && {
                        CompatibleArchitectures: $31426a0b6b5dd4d5$var$serializeAws_restJson1CompatibleArchitectures(input.CompatibleArchitectures, context)
                    }), input.CompatibleRuntimes !== undefined && input.CompatibleRuntimes !== null && {
                        CompatibleRuntimes: $31426a0b6b5dd4d5$var$serializeAws_restJson1CompatibleRuntimes(input.CompatibleRuntimes, context)
                    }), input.Content !== undefined && input.Content !== null && {
                        Content: $31426a0b6b5dd4d5$var$serializeAws_restJson1LayerVersionContentInput(input.Content, context)
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.LicenseInfo !== undefined && input.LicenseInfo !== null && {
                        LicenseInfo: input.LicenseInfo
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$aaa845593e157cda = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/versions";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CodeSha256 !== undefined && input.CodeSha256 !== null && {
                        CodeSha256: input.CodeSha256
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.RevisionId !== undefined && input.RevisionId !== null && {
                        RevisionId: input.RevisionId
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a9c0ebf270686fec = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-06-30/functions/{FunctionName}/code-signing-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.CodeSigningConfigArn !== undefined && input.CodeSigningConfigArn !== null && {
                        CodeSigningConfigArn: input.CodeSigningConfigArn
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$8a865cdaa858929b = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2017-10-31/functions/{FunctionName}/concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ReservedConcurrentExecutions !== undefined && input.ReservedConcurrentExecutions !== null && {
                        ReservedConcurrentExecutions: input.ReservedConcurrentExecutions
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a045b899cf174599 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-25/functions/{FunctionName}/event-invoke-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DestinationConfig !== undefined && input.DestinationConfig !== null && {
                        DestinationConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DestinationConfig(input.DestinationConfig, context)
                    }), input.MaximumEventAgeInSeconds !== undefined && input.MaximumEventAgeInSeconds !== null && {
                        MaximumEventAgeInSeconds: input.MaximumEventAgeInSeconds
                    }), input.MaximumRetryAttempts !== undefined && input.MaximumRetryAttempts !== null && {
                        MaximumRetryAttempts: input.MaximumRetryAttempts
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$cad27f74846fb413 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-30/functions/{FunctionName}/provisioned-concurrency";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ProvisionedConcurrentExecutions !== undefined && input.ProvisionedConcurrentExecutions !== null && {
                        ProvisionedConcurrentExecutions: input.ProvisionedConcurrentExecutions
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$e7a5d4305b8fcdec = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}";
                    if (input.LayerName !== undefined) {
                        labelValue = input.LayerName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: LayerName.");
                        resolvedPath = resolvedPath.replace("{LayerName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: LayerName.");
                    if (input.VersionNumber !== undefined) {
                        labelValue = input.VersionNumber.toString();
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: VersionNumber.");
                        resolvedPath = resolvedPath.replace("{VersionNumber}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: VersionNumber.");
                    if (input.StatementId !== undefined) {
                        labelValue = input.StatementId;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: StatementId.");
                        resolvedPath = resolvedPath.replace("{StatementId}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: StatementId.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.RevisionId !== undefined && {
                        RevisionId: input.RevisionId
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$6e5dcb61a961cef6 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/policy/{StatementId}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    if (input.StatementId !== undefined) {
                        labelValue = input.StatementId;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: StatementId.");
                        resolvedPath = resolvedPath.replace("{StatementId}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: StatementId.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    }), input.RevisionId !== undefined && {
                        RevisionId: input.RevisionId
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$1c72a77624ba49d0 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2017-03-31/tags/{Resource}";
                    if (input.Resource !== undefined) {
                        labelValue = input.Resource;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Resource.");
                        resolvedPath = resolvedPath.replace("{Resource}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Resource.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Tags !== undefined && input.Tags !== null && {
                        Tags: $31426a0b6b5dd4d5$var$serializeAws_restJson1Tags(input.Tags, context)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$5ca231b23a53f7a6 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2017-03-31/tags/{Resource}";
                    if (input.Resource !== undefined) {
                        labelValue = input.Resource;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Resource.");
                        resolvedPath = resolvedPath.replace("{Resource}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Resource.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.TagKeys !== undefined && {
                        tagKeys: (input.TagKeys || []).map(function(_entry) {
                            return _entry;
                        })
                    });
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$12057f671f8dfb92 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/aliases/{Name}";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    if (input.Name !== undefined) {
                        labelValue = input.Name;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: Name.");
                        resolvedPath = resolvedPath.replace("{Name}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: Name.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.FunctionVersion !== undefined && input.FunctionVersion !== null && {
                        FunctionVersion: input.FunctionVersion
                    }), input.RevisionId !== undefined && input.RevisionId !== null && {
                        RevisionId: input.RevisionId
                    }), input.RoutingConfig !== undefined && input.RoutingConfig !== null && {
                        RoutingConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1AliasRoutingConfiguration(input.RoutingConfig, context)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$2f0674758dceed79 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}";
                    if (input.CodeSigningConfigArn !== undefined) {
                        labelValue = input.CodeSigningConfigArn;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: CodeSigningConfigArn.");
                        resolvedPath = resolvedPath.replace("{CodeSigningConfigArn}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: CodeSigningConfigArn.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AllowedPublishers !== undefined && input.AllowedPublishers !== null && {
                        AllowedPublishers: $31426a0b6b5dd4d5$var$serializeAws_restJson1AllowedPublishers(input.AllowedPublishers, context)
                    }), input.CodeSigningPolicies !== undefined && input.CodeSigningPolicies !== null && {
                        CodeSigningPolicies: $31426a0b6b5dd4d5$var$serializeAws_restJson1CodeSigningPolicies(input.CodeSigningPolicies, context)
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$1e31b973fa691bee = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/event-source-mappings/{UUID}";
                    if (input.UUID !== undefined) {
                        labelValue = input.UUID;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: UUID.");
                        resolvedPath = resolvedPath.replace("{UUID}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: UUID.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.BatchSize !== undefined && input.BatchSize !== null && {
                        BatchSize: input.BatchSize
                    }), input.BisectBatchOnFunctionError !== undefined && input.BisectBatchOnFunctionError !== null && {
                        BisectBatchOnFunctionError: input.BisectBatchOnFunctionError
                    }), input.DestinationConfig !== undefined && input.DestinationConfig !== null && {
                        DestinationConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DestinationConfig(input.DestinationConfig, context)
                    }), input.Enabled !== undefined && input.Enabled !== null && {
                        Enabled: input.Enabled
                    }), input.FunctionName !== undefined && input.FunctionName !== null && {
                        FunctionName: input.FunctionName
                    }), input.FunctionResponseTypes !== undefined && input.FunctionResponseTypes !== null && {
                        FunctionResponseTypes: $31426a0b6b5dd4d5$var$serializeAws_restJson1FunctionResponseTypeList(input.FunctionResponseTypes, context)
                    }), input.MaximumBatchingWindowInSeconds !== undefined && input.MaximumBatchingWindowInSeconds !== null && {
                        MaximumBatchingWindowInSeconds: input.MaximumBatchingWindowInSeconds
                    }), input.MaximumRecordAgeInSeconds !== undefined && input.MaximumRecordAgeInSeconds !== null && {
                        MaximumRecordAgeInSeconds: input.MaximumRecordAgeInSeconds
                    }), input.MaximumRetryAttempts !== undefined && input.MaximumRetryAttempts !== null && {
                        MaximumRetryAttempts: input.MaximumRetryAttempts
                    }), input.ParallelizationFactor !== undefined && input.ParallelizationFactor !== null && {
                        ParallelizationFactor: input.ParallelizationFactor
                    }), input.SourceAccessConfigurations !== undefined && input.SourceAccessConfigurations !== null && {
                        SourceAccessConfigurations: $31426a0b6b5dd4d5$var$serializeAws_restJson1SourceAccessConfigurations(input.SourceAccessConfigurations, context)
                    }), input.TumblingWindowInSeconds !== undefined && input.TumblingWindowInSeconds !== null && {
                        TumblingWindowInSeconds: input.TumblingWindowInSeconds
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c6072fe2e98661c5 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/code";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Architectures !== undefined && input.Architectures !== null && {
                        Architectures: $31426a0b6b5dd4d5$var$serializeAws_restJson1ArchitecturesList(input.Architectures, context)
                    }), input.DryRun !== undefined && input.DryRun !== null && {
                        DryRun: input.DryRun
                    }), input.ImageUri !== undefined && input.ImageUri !== null && {
                        ImageUri: input.ImageUri
                    }), input.Publish !== undefined && input.Publish !== null && {
                        Publish: input.Publish
                    }), input.RevisionId !== undefined && input.RevisionId !== null && {
                        RevisionId: input.RevisionId
                    }), input.S3Bucket !== undefined && input.S3Bucket !== null && {
                        S3Bucket: input.S3Bucket
                    }), input.S3Key !== undefined && input.S3Key !== null && {
                        S3Key: input.S3Key
                    }), input.S3ObjectVersion !== undefined && input.S3ObjectVersion !== null && {
                        S3ObjectVersion: input.S3ObjectVersion
                    }), input.ZipFile !== undefined && input.ZipFile !== null && {
                        ZipFile: context.base64Encoder(input.ZipFile)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$63ceba8eda3d9965 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2015-03-31/functions/{FunctionName}/configuration";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DeadLetterConfig !== undefined && input.DeadLetterConfig !== null && {
                        DeadLetterConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DeadLetterConfig(input.DeadLetterConfig, context)
                    }), input.Description !== undefined && input.Description !== null && {
                        Description: input.Description
                    }), input.Environment !== undefined && input.Environment !== null && {
                        Environment: $31426a0b6b5dd4d5$var$serializeAws_restJson1Environment(input.Environment, context)
                    }), input.FileSystemConfigs !== undefined && input.FileSystemConfigs !== null && {
                        FileSystemConfigs: $31426a0b6b5dd4d5$var$serializeAws_restJson1FileSystemConfigList(input.FileSystemConfigs, context)
                    }), input.Handler !== undefined && input.Handler !== null && {
                        Handler: input.Handler
                    }), input.ImageConfig !== undefined && input.ImageConfig !== null && {
                        ImageConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1ImageConfig(input.ImageConfig, context)
                    }), input.KMSKeyArn !== undefined && input.KMSKeyArn !== null && {
                        KMSKeyArn: input.KMSKeyArn
                    }), input.Layers !== undefined && input.Layers !== null && {
                        Layers: $31426a0b6b5dd4d5$var$serializeAws_restJson1LayerList(input.Layers, context)
                    }), input.MemorySize !== undefined && input.MemorySize !== null && {
                        MemorySize: input.MemorySize
                    }), input.RevisionId !== undefined && input.RevisionId !== null && {
                        RevisionId: input.RevisionId
                    }), input.Role !== undefined && input.Role !== null && {
                        Role: input.Role
                    }), input.Runtime !== undefined && input.Runtime !== null && {
                        Runtime: input.Runtime
                    }), input.Timeout !== undefined && input.Timeout !== null && {
                        Timeout: input.Timeout
                    }), input.TracingConfig !== undefined && input.TracingConfig !== null && {
                        TracingConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1TracingConfig(input.TracingConfig, context)
                    }), input.VpcConfig !== undefined && input.VpcConfig !== null && {
                        VpcConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1VpcConfig(input.VpcConfig, context)
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ac5ed6d6a6aab598 = function(input, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, labelValue, query, body;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "" + ((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/2019-09-25/functions/{FunctionName}/event-invoke-config";
                    if (input.FunctionName !== undefined) {
                        labelValue = input.FunctionName;
                        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: FunctionName.");
                        resolvedPath = resolvedPath.replace("{FunctionName}", (0, $7f077f65d077e2f2$export$7640f3c16fe7f54b)(labelValue));
                    } else throw new Error("No value provided for input HTTP label: FunctionName.");
                    query = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Qualifier !== undefined && {
                        Qualifier: input.Qualifier
                    });
                    body = JSON.stringify((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.DestinationConfig !== undefined && input.DestinationConfig !== null && {
                        DestinationConfig: $31426a0b6b5dd4d5$var$serializeAws_restJson1DestinationConfig(input.DestinationConfig, context)
                    }), input.MaximumEventAgeInSeconds !== undefined && input.MaximumEventAgeInSeconds !== null && {
                        MaximumEventAgeInSeconds: input.MaximumEventAgeInSeconds
                    }), input.MaximumRetryAttempts !== undefined && input.MaximumRetryAttempts !== null && {
                        MaximumRetryAttempts: input.MaximumRetryAttempts
                    }));
                    return [
                        2,
                        new (0, $d0707dbdfb3e3b57$export$7587955500404ec3)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$2d8302aa55d70656 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1AddLayerVersionPermissionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        RevisionId: undefined,
                        Statement: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Statement !== undefined && data.Statement !== null) contents.Statement = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Statement);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AddLayerVersionPermissionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "PolicyLengthExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#PolicyLengthExceededException":
                            return [
                                3,
                                4
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PolicyLengthExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$e3f5a82b6d9ab13 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1AddPermissionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Statement: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Statement !== undefined && data.Statement !== null) contents.Statement = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Statement);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AddPermissionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "PolicyLengthExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#PolicyLengthExceededException":
                            return [
                                3,
                                4
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PolicyLengthExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$f6394cff9f10654b = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateAliasCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AliasArn: undefined,
                        Description: undefined,
                        FunctionVersion: undefined,
                        Name: undefined,
                        RevisionId: undefined,
                        RoutingConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AliasArn !== undefined && data.AliasArn !== null) contents.AliasArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.AliasArn);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.FunctionVersion !== undefined && data.FunctionVersion !== null) contents.FunctionVersion = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionVersion);
                    if (data.Name !== undefined && data.Name !== null) contents.Name = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Name);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.RoutingConfig !== undefined && data.RoutingConfig !== null) contents.RoutingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasRoutingConfiguration(data.RoutingConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateAliasCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$9dff897d6e960ce1 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfig !== undefined && data.CodeSigningConfig !== null) contents.CodeSigningConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfig(data.CodeSigningConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ff666214b1cad020 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 202 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateEventSourceMappingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        BatchSize: undefined,
                        BisectBatchOnFunctionError: undefined,
                        DestinationConfig: undefined,
                        EventSourceArn: undefined,
                        FunctionArn: undefined,
                        FunctionResponseTypes: undefined,
                        LastModified: undefined,
                        LastProcessingResult: undefined,
                        MaximumBatchingWindowInSeconds: undefined,
                        MaximumRecordAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined,
                        ParallelizationFactor: undefined,
                        Queues: undefined,
                        SelfManagedEventSource: undefined,
                        SourceAccessConfigurations: undefined,
                        StartingPosition: undefined,
                        StartingPositionTimestamp: undefined,
                        State: undefined,
                        StateTransitionReason: undefined,
                        Topics: undefined,
                        TumblingWindowInSeconds: undefined,
                        UUID: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.BatchSize !== undefined && data.BatchSize !== null) contents.BatchSize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.BatchSize);
                    if (data.BisectBatchOnFunctionError !== undefined && data.BisectBatchOnFunctionError !== null) contents.BisectBatchOnFunctionError = (0, $d373908f914b3142$export$259b2ebfc29bf466)(data.BisectBatchOnFunctionError);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.EventSourceArn !== undefined && data.EventSourceArn !== null) contents.EventSourceArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.EventSourceArn);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionResponseTypes !== undefined && data.FunctionResponseTypes !== null) contents.FunctionResponseTypes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList(data.FunctionResponseTypes, context);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.LastProcessingResult !== undefined && data.LastProcessingResult !== null) contents.LastProcessingResult = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastProcessingResult);
                    if (data.MaximumBatchingWindowInSeconds !== undefined && data.MaximumBatchingWindowInSeconds !== null) contents.MaximumBatchingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumBatchingWindowInSeconds);
                    if (data.MaximumRecordAgeInSeconds !== undefined && data.MaximumRecordAgeInSeconds !== null) contents.MaximumRecordAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRecordAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    if (data.ParallelizationFactor !== undefined && data.ParallelizationFactor !== null) contents.ParallelizationFactor = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ParallelizationFactor);
                    if (data.Queues !== undefined && data.Queues !== null) contents.Queues = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues(data.Queues, context);
                    if (data.SelfManagedEventSource !== undefined && data.SelfManagedEventSource !== null) contents.SelfManagedEventSource = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource(data.SelfManagedEventSource, context);
                    if (data.SourceAccessConfigurations !== undefined && data.SourceAccessConfigurations !== null) contents.SourceAccessConfigurations = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations(data.SourceAccessConfigurations, context);
                    if (data.StartingPosition !== undefined && data.StartingPosition !== null) contents.StartingPosition = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StartingPosition);
                    if (data.StartingPositionTimestamp !== undefined && data.StartingPositionTimestamp !== null) contents.StartingPositionTimestamp = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.StartingPositionTimestamp)));
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateTransitionReason !== undefined && data.StateTransitionReason !== null) contents.StateTransitionReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateTransitionReason);
                    if (data.Topics !== undefined && data.Topics !== null) contents.Topics = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics(data.Topics, context);
                    if (data.TumblingWindowInSeconds !== undefined && data.TumblingWindowInSeconds !== null) contents.TumblingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.TumblingWindowInSeconds);
                    if (data.UUID !== undefined && data.UUID !== null) contents.UUID = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.UUID);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateEventSourceMappingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a5efaed75be5bb24 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateFunctionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Architectures: undefined,
                        CodeSha256: undefined,
                        CodeSize: undefined,
                        DeadLetterConfig: undefined,
                        Description: undefined,
                        Environment: undefined,
                        FileSystemConfigs: undefined,
                        FunctionArn: undefined,
                        FunctionName: undefined,
                        Handler: undefined,
                        ImageConfigResponse: undefined,
                        KMSKeyArn: undefined,
                        LastModified: undefined,
                        LastUpdateStatus: undefined,
                        LastUpdateStatusReason: undefined,
                        LastUpdateStatusReasonCode: undefined,
                        Layers: undefined,
                        MasterArn: undefined,
                        MemorySize: undefined,
                        PackageType: undefined,
                        RevisionId: undefined,
                        Role: undefined,
                        Runtime: undefined,
                        SigningJobArn: undefined,
                        SigningProfileVersionArn: undefined,
                        State: undefined,
                        StateReason: undefined,
                        StateReasonCode: undefined,
                        Timeout: undefined,
                        TracingConfig: undefined,
                        Version: undefined,
                        VpcConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Architectures !== undefined && data.Architectures !== null) contents.Architectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(data.Architectures, context);
                    if (data.CodeSha256 !== undefined && data.CodeSha256 !== null) contents.CodeSha256 = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSha256);
                    if (data.CodeSize !== undefined && data.CodeSize !== null) contents.CodeSize = (0, $d373908f914b3142$export$a883517a83c9c18)(data.CodeSize);
                    if (data.DeadLetterConfig !== undefined && data.DeadLetterConfig !== null) contents.DeadLetterConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(data.DeadLetterConfig, context);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.Environment !== undefined && data.Environment !== null) contents.Environment = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(data.Environment, context);
                    if (data.FileSystemConfigs !== undefined && data.FileSystemConfigs !== null) contents.FileSystemConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(data.FileSystemConfigs, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    if (data.Handler !== undefined && data.Handler !== null) contents.Handler = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Handler);
                    if (data.ImageConfigResponse !== undefined && data.ImageConfigResponse !== null) contents.ImageConfigResponse = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(data.ImageConfigResponse, context);
                    if (data.KMSKeyArn !== undefined && data.KMSKeyArn !== null) contents.KMSKeyArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.KMSKeyArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.LastUpdateStatus !== undefined && data.LastUpdateStatus !== null) contents.LastUpdateStatus = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatus);
                    if (data.LastUpdateStatusReason !== undefined && data.LastUpdateStatusReason !== null) contents.LastUpdateStatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReason);
                    if (data.LastUpdateStatusReasonCode !== undefined && data.LastUpdateStatusReasonCode !== null) contents.LastUpdateStatusReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReasonCode);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(data.Layers, context);
                    if (data.MasterArn !== undefined && data.MasterArn !== null) contents.MasterArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.MasterArn);
                    if (data.MemorySize !== undefined && data.MemorySize !== null) contents.MemorySize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MemorySize);
                    if (data.PackageType !== undefined && data.PackageType !== null) contents.PackageType = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.PackageType);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Role !== undefined && data.Role !== null) contents.Role = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Role);
                    if (data.Runtime !== undefined && data.Runtime !== null) contents.Runtime = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Runtime);
                    if (data.SigningJobArn !== undefined && data.SigningJobArn !== null) contents.SigningJobArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningJobArn);
                    if (data.SigningProfileVersionArn !== undefined && data.SigningProfileVersionArn !== null) contents.SigningProfileVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningProfileVersionArn);
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateReason !== undefined && data.StateReason !== null) contents.StateReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReason);
                    if (data.StateReasonCode !== undefined && data.StateReasonCode !== null) contents.StateReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReasonCode);
                    if (data.Timeout !== undefined && data.Timeout !== null) contents.Timeout = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.Timeout);
                    if (data.TracingConfig !== undefined && data.TracingConfig !== null) contents.TracingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(data.TracingConfig, context);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Version);
                    if (data.VpcConfig !== undefined && data.VpcConfig !== null) contents.VpcConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(data.VpcConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CreateFunctionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _m = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "CodeStorageExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#CodeStorageExceededException":
                            return [
                                3,
                                4
                            ];
                        case "CodeVerificationFailedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#CodeVerificationFailedException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidCodeSignatureException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#InvalidCodeSignatureException":
                            return [
                                3,
                                8
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "ServiceException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                16
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                18
                            ];
                    }
                    return [
                        3,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeStorageExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeVerificationFailedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidCodeSignatureExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$53dadd823dee4a9a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteAliasCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteAliasCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$d9fb105d3c695987 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$8a6770be1cb95bfb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 202 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteEventSourceMappingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        BatchSize: undefined,
                        BisectBatchOnFunctionError: undefined,
                        DestinationConfig: undefined,
                        EventSourceArn: undefined,
                        FunctionArn: undefined,
                        FunctionResponseTypes: undefined,
                        LastModified: undefined,
                        LastProcessingResult: undefined,
                        MaximumBatchingWindowInSeconds: undefined,
                        MaximumRecordAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined,
                        ParallelizationFactor: undefined,
                        Queues: undefined,
                        SelfManagedEventSource: undefined,
                        SourceAccessConfigurations: undefined,
                        StartingPosition: undefined,
                        StartingPositionTimestamp: undefined,
                        State: undefined,
                        StateTransitionReason: undefined,
                        Topics: undefined,
                        TumblingWindowInSeconds: undefined,
                        UUID: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.BatchSize !== undefined && data.BatchSize !== null) contents.BatchSize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.BatchSize);
                    if (data.BisectBatchOnFunctionError !== undefined && data.BisectBatchOnFunctionError !== null) contents.BisectBatchOnFunctionError = (0, $d373908f914b3142$export$259b2ebfc29bf466)(data.BisectBatchOnFunctionError);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.EventSourceArn !== undefined && data.EventSourceArn !== null) contents.EventSourceArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.EventSourceArn);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionResponseTypes !== undefined && data.FunctionResponseTypes !== null) contents.FunctionResponseTypes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList(data.FunctionResponseTypes, context);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.LastProcessingResult !== undefined && data.LastProcessingResult !== null) contents.LastProcessingResult = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastProcessingResult);
                    if (data.MaximumBatchingWindowInSeconds !== undefined && data.MaximumBatchingWindowInSeconds !== null) contents.MaximumBatchingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumBatchingWindowInSeconds);
                    if (data.MaximumRecordAgeInSeconds !== undefined && data.MaximumRecordAgeInSeconds !== null) contents.MaximumRecordAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRecordAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    if (data.ParallelizationFactor !== undefined && data.ParallelizationFactor !== null) contents.ParallelizationFactor = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ParallelizationFactor);
                    if (data.Queues !== undefined && data.Queues !== null) contents.Queues = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues(data.Queues, context);
                    if (data.SelfManagedEventSource !== undefined && data.SelfManagedEventSource !== null) contents.SelfManagedEventSource = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource(data.SelfManagedEventSource, context);
                    if (data.SourceAccessConfigurations !== undefined && data.SourceAccessConfigurations !== null) contents.SourceAccessConfigurations = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations(data.SourceAccessConfigurations, context);
                    if (data.StartingPosition !== undefined && data.StartingPosition !== null) contents.StartingPosition = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StartingPosition);
                    if (data.StartingPositionTimestamp !== undefined && data.StartingPositionTimestamp !== null) contents.StartingPositionTimestamp = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.StartingPositionTimestamp)));
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateTransitionReason !== undefined && data.StateTransitionReason !== null) contents.StateTransitionReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateTransitionReason);
                    if (data.Topics !== undefined && data.Topics !== null) contents.Topics = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics(data.Topics, context);
                    if (data.TumblingWindowInSeconds !== undefined && data.TumblingWindowInSeconds !== null) contents.TumblingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.TumblingWindowInSeconds);
                    if (data.UUID !== undefined && data.UUID !== null) contents.UUID = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.UUID);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteEventSourceMappingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceInUseException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceInUseException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ee4348941ed1475b = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$de76e87603541c41 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$37a9c651d3333554 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionConcurrencyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionConcurrencyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$a6e4ab2749924cdb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionEventInvokeConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteFunctionEventInvokeConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$94098d253ae99569 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteLayerVersionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteLayerVersionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                2
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$72dbbab778895ee6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteProvisionedConcurrencyConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeleteProvisionedConcurrencyConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$53d3725df2739baf = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetAccountSettingsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AccountLimit: undefined,
                        AccountUsage: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AccountLimit !== undefined && data.AccountLimit !== null) contents.AccountLimit = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AccountLimit(data.AccountLimit, context);
                    if (data.AccountUsage !== undefined && data.AccountUsage !== null) contents.AccountUsage = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AccountUsage(data.AccountUsage, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetAccountSettingsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ServiceException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                2
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$f85a9394759c2075 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetAliasCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AliasArn: undefined,
                        Description: undefined,
                        FunctionVersion: undefined,
                        Name: undefined,
                        RevisionId: undefined,
                        RoutingConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AliasArn !== undefined && data.AliasArn !== null) contents.AliasArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.AliasArn);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.FunctionVersion !== undefined && data.FunctionVersion !== null) contents.FunctionVersion = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionVersion);
                    if (data.Name !== undefined && data.Name !== null) contents.Name = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Name);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.RoutingConfig !== undefined && data.RoutingConfig !== null) contents.RoutingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasRoutingConfiguration(data.RoutingConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetAliasCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$da8dd98f84f758c3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfig !== undefined && data.CodeSigningConfig !== null) contents.CodeSigningConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfig(data.CodeSigningConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$b11f9cf6e196ea9d = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetEventSourceMappingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        BatchSize: undefined,
                        BisectBatchOnFunctionError: undefined,
                        DestinationConfig: undefined,
                        EventSourceArn: undefined,
                        FunctionArn: undefined,
                        FunctionResponseTypes: undefined,
                        LastModified: undefined,
                        LastProcessingResult: undefined,
                        MaximumBatchingWindowInSeconds: undefined,
                        MaximumRecordAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined,
                        ParallelizationFactor: undefined,
                        Queues: undefined,
                        SelfManagedEventSource: undefined,
                        SourceAccessConfigurations: undefined,
                        StartingPosition: undefined,
                        StartingPositionTimestamp: undefined,
                        State: undefined,
                        StateTransitionReason: undefined,
                        Topics: undefined,
                        TumblingWindowInSeconds: undefined,
                        UUID: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.BatchSize !== undefined && data.BatchSize !== null) contents.BatchSize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.BatchSize);
                    if (data.BisectBatchOnFunctionError !== undefined && data.BisectBatchOnFunctionError !== null) contents.BisectBatchOnFunctionError = (0, $d373908f914b3142$export$259b2ebfc29bf466)(data.BisectBatchOnFunctionError);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.EventSourceArn !== undefined && data.EventSourceArn !== null) contents.EventSourceArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.EventSourceArn);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionResponseTypes !== undefined && data.FunctionResponseTypes !== null) contents.FunctionResponseTypes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList(data.FunctionResponseTypes, context);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.LastProcessingResult !== undefined && data.LastProcessingResult !== null) contents.LastProcessingResult = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastProcessingResult);
                    if (data.MaximumBatchingWindowInSeconds !== undefined && data.MaximumBatchingWindowInSeconds !== null) contents.MaximumBatchingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumBatchingWindowInSeconds);
                    if (data.MaximumRecordAgeInSeconds !== undefined && data.MaximumRecordAgeInSeconds !== null) contents.MaximumRecordAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRecordAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    if (data.ParallelizationFactor !== undefined && data.ParallelizationFactor !== null) contents.ParallelizationFactor = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ParallelizationFactor);
                    if (data.Queues !== undefined && data.Queues !== null) contents.Queues = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues(data.Queues, context);
                    if (data.SelfManagedEventSource !== undefined && data.SelfManagedEventSource !== null) contents.SelfManagedEventSource = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource(data.SelfManagedEventSource, context);
                    if (data.SourceAccessConfigurations !== undefined && data.SourceAccessConfigurations !== null) contents.SourceAccessConfigurations = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations(data.SourceAccessConfigurations, context);
                    if (data.StartingPosition !== undefined && data.StartingPosition !== null) contents.StartingPosition = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StartingPosition);
                    if (data.StartingPositionTimestamp !== undefined && data.StartingPositionTimestamp !== null) contents.StartingPositionTimestamp = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.StartingPositionTimestamp)));
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateTransitionReason !== undefined && data.StateTransitionReason !== null) contents.StateTransitionReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateTransitionReason);
                    if (data.Topics !== undefined && data.Topics !== null) contents.Topics = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics(data.Topics, context);
                    if (data.TumblingWindowInSeconds !== undefined && data.TumblingWindowInSeconds !== null) contents.TumblingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.TumblingWindowInSeconds);
                    if (data.UUID !== undefined && data.UUID !== null) contents.UUID = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.UUID);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetEventSourceMappingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$b4168c00ac945891 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Code: undefined,
                        Concurrency: undefined,
                        Configuration: undefined,
                        Tags: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Code !== undefined && data.Code !== null) contents.Code = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionCodeLocation(data.Code, context);
                    if (data.Concurrency !== undefined && data.Concurrency !== null) contents.Concurrency = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Concurrency(data.Concurrency, context);
                    if (data.Configuration !== undefined && data.Configuration !== null) contents.Configuration = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionConfiguration(data.Configuration, context);
                    if (data.Tags !== undefined && data.Tags !== null) contents.Tags = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Tags(data.Tags, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$62601069b35f17e3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfigArn: undefined,
                        FunctionName: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfigArn !== undefined && data.CodeSigningConfigArn !== null) contents.CodeSigningConfigArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSigningConfigArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$dc395718a4a1096 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionConcurrencyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        ReservedConcurrentExecutions: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.ReservedConcurrentExecutions !== undefined && data.ReservedConcurrentExecutions !== null) contents.ReservedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ReservedConcurrentExecutions);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionConcurrencyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7c519ebcc9ba2705 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Architectures: undefined,
                        CodeSha256: undefined,
                        CodeSize: undefined,
                        DeadLetterConfig: undefined,
                        Description: undefined,
                        Environment: undefined,
                        FileSystemConfigs: undefined,
                        FunctionArn: undefined,
                        FunctionName: undefined,
                        Handler: undefined,
                        ImageConfigResponse: undefined,
                        KMSKeyArn: undefined,
                        LastModified: undefined,
                        LastUpdateStatus: undefined,
                        LastUpdateStatusReason: undefined,
                        LastUpdateStatusReasonCode: undefined,
                        Layers: undefined,
                        MasterArn: undefined,
                        MemorySize: undefined,
                        PackageType: undefined,
                        RevisionId: undefined,
                        Role: undefined,
                        Runtime: undefined,
                        SigningJobArn: undefined,
                        SigningProfileVersionArn: undefined,
                        State: undefined,
                        StateReason: undefined,
                        StateReasonCode: undefined,
                        Timeout: undefined,
                        TracingConfig: undefined,
                        Version: undefined,
                        VpcConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Architectures !== undefined && data.Architectures !== null) contents.Architectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(data.Architectures, context);
                    if (data.CodeSha256 !== undefined && data.CodeSha256 !== null) contents.CodeSha256 = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSha256);
                    if (data.CodeSize !== undefined && data.CodeSize !== null) contents.CodeSize = (0, $d373908f914b3142$export$a883517a83c9c18)(data.CodeSize);
                    if (data.DeadLetterConfig !== undefined && data.DeadLetterConfig !== null) contents.DeadLetterConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(data.DeadLetterConfig, context);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.Environment !== undefined && data.Environment !== null) contents.Environment = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(data.Environment, context);
                    if (data.FileSystemConfigs !== undefined && data.FileSystemConfigs !== null) contents.FileSystemConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(data.FileSystemConfigs, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    if (data.Handler !== undefined && data.Handler !== null) contents.Handler = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Handler);
                    if (data.ImageConfigResponse !== undefined && data.ImageConfigResponse !== null) contents.ImageConfigResponse = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(data.ImageConfigResponse, context);
                    if (data.KMSKeyArn !== undefined && data.KMSKeyArn !== null) contents.KMSKeyArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.KMSKeyArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.LastUpdateStatus !== undefined && data.LastUpdateStatus !== null) contents.LastUpdateStatus = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatus);
                    if (data.LastUpdateStatusReason !== undefined && data.LastUpdateStatusReason !== null) contents.LastUpdateStatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReason);
                    if (data.LastUpdateStatusReasonCode !== undefined && data.LastUpdateStatusReasonCode !== null) contents.LastUpdateStatusReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReasonCode);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(data.Layers, context);
                    if (data.MasterArn !== undefined && data.MasterArn !== null) contents.MasterArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.MasterArn);
                    if (data.MemorySize !== undefined && data.MemorySize !== null) contents.MemorySize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MemorySize);
                    if (data.PackageType !== undefined && data.PackageType !== null) contents.PackageType = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.PackageType);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Role !== undefined && data.Role !== null) contents.Role = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Role);
                    if (data.Runtime !== undefined && data.Runtime !== null) contents.Runtime = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Runtime);
                    if (data.SigningJobArn !== undefined && data.SigningJobArn !== null) contents.SigningJobArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningJobArn);
                    if (data.SigningProfileVersionArn !== undefined && data.SigningProfileVersionArn !== null) contents.SigningProfileVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningProfileVersionArn);
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateReason !== undefined && data.StateReason !== null) contents.StateReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReason);
                    if (data.StateReasonCode !== undefined && data.StateReasonCode !== null) contents.StateReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReasonCode);
                    if (data.Timeout !== undefined && data.Timeout !== null) contents.Timeout = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.Timeout);
                    if (data.TracingConfig !== undefined && data.TracingConfig !== null) contents.TracingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(data.TracingConfig, context);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Version);
                    if (data.VpcConfig !== undefined && data.VpcConfig !== null) contents.VpcConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(data.VpcConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7fc63f9bfcd6ff9c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionEventInvokeConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        DestinationConfig: undefined,
                        FunctionArn: undefined,
                        LastModified: undefined,
                        MaximumEventAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.MaximumEventAgeInSeconds !== undefined && data.MaximumEventAgeInSeconds !== null) contents.MaximumEventAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumEventAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetFunctionEventInvokeConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$eb5b766553c8e375 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CompatibleArchitectures: undefined,
                        CompatibleRuntimes: undefined,
                        Content: undefined,
                        CreatedDate: undefined,
                        Description: undefined,
                        LayerArn: undefined,
                        LayerVersionArn: undefined,
                        LicenseInfo: undefined,
                        Version: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CompatibleArchitectures !== undefined && data.CompatibleArchitectures !== null) contents.CompatibleArchitectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleArchitectures(data.CompatibleArchitectures, context);
                    if (data.CompatibleRuntimes !== undefined && data.CompatibleRuntimes !== null) contents.CompatibleRuntimes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleRuntimes(data.CompatibleRuntimes, context);
                    if (data.Content !== undefined && data.Content !== null) contents.Content = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionContentOutput(data.Content, context);
                    if (data.CreatedDate !== undefined && data.CreatedDate !== null) contents.CreatedDate = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CreatedDate);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.LayerArn !== undefined && data.LayerArn !== null) contents.LayerArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerArn);
                    if (data.LayerVersionArn !== undefined && data.LayerVersionArn !== null) contents.LayerVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerVersionArn);
                    if (data.LicenseInfo !== undefined && data.LicenseInfo !== null) contents.LicenseInfo = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LicenseInfo);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$a883517a83c9c18)(data.Version);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$df8b3ace918307f7 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionByArnCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CompatibleArchitectures: undefined,
                        CompatibleRuntimes: undefined,
                        Content: undefined,
                        CreatedDate: undefined,
                        Description: undefined,
                        LayerArn: undefined,
                        LayerVersionArn: undefined,
                        LicenseInfo: undefined,
                        Version: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CompatibleArchitectures !== undefined && data.CompatibleArchitectures !== null) contents.CompatibleArchitectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleArchitectures(data.CompatibleArchitectures, context);
                    if (data.CompatibleRuntimes !== undefined && data.CompatibleRuntimes !== null) contents.CompatibleRuntimes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleRuntimes(data.CompatibleRuntimes, context);
                    if (data.Content !== undefined && data.Content !== null) contents.Content = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionContentOutput(data.Content, context);
                    if (data.CreatedDate !== undefined && data.CreatedDate !== null) contents.CreatedDate = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CreatedDate);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.LayerArn !== undefined && data.LayerArn !== null) contents.LayerArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerArn);
                    if (data.LayerVersionArn !== undefined && data.LayerVersionArn !== null) contents.LayerVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerVersionArn);
                    if (data.LicenseInfo !== undefined && data.LicenseInfo !== null) contents.LicenseInfo = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LicenseInfo);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$a883517a83c9c18)(data.Version);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionByArnCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$631e1a1a637d3680 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Policy: undefined,
                        RevisionId: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Policy !== undefined && data.Policy !== null) contents.Policy = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Policy);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetLayerVersionPolicyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ac035227ff1f4ffa = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetPolicyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Policy: undefined,
                        RevisionId: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Policy !== undefined && data.Policy !== null) contents.Policy = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Policy);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetPolicyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$733d7d8229b9ebae = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetProvisionedConcurrencyConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AllocatedProvisionedConcurrentExecutions: undefined,
                        AvailableProvisionedConcurrentExecutions: undefined,
                        LastModified: undefined,
                        RequestedProvisionedConcurrentExecutions: undefined,
                        Status: undefined,
                        StatusReason: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AllocatedProvisionedConcurrentExecutions !== undefined && data.AllocatedProvisionedConcurrentExecutions !== null) contents.AllocatedProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.AllocatedProvisionedConcurrentExecutions);
                    if (data.AvailableProvisionedConcurrentExecutions !== undefined && data.AvailableProvisionedConcurrentExecutions !== null) contents.AvailableProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.AvailableProvisionedConcurrentExecutions);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.RequestedProvisionedConcurrentExecutions !== undefined && data.RequestedProvisionedConcurrentExecutions !== null) contents.RequestedProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.RequestedProvisionedConcurrentExecutions);
                    if (data.Status !== undefined && data.Status !== null) contents.Status = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Status);
                    if (data.StatusReason !== undefined && data.StatusReason !== null) contents.StatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StatusReason);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1GetProvisionedConcurrencyConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ProvisionedConcurrencyConfigNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ProvisionedConcurrencyConfigNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$cb13477dcc449611 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvokeCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        ExecutedVersion: undefined,
                        FunctionError: undefined,
                        LogResult: undefined,
                        Payload: undefined,
                        StatusCode: undefined
                    };
                    if (output.headers["x-amz-function-error"] !== undefined) contents.FunctionError = output.headers["x-amz-function-error"];
                    if (output.headers["x-amz-log-result"] !== undefined) contents.LogResult = output.headers["x-amz-log-result"];
                    if (output.headers["x-amz-executed-version"] !== undefined) contents.ExecutedVersion = output.headers["x-amz-executed-version"];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Payload = data;
                    if (contents.StatusCode === undefined) contents.StatusCode = output.statusCode;
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvokeCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, parsedBody, message;
        var _4;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_5) {
            switch(_5.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _4 = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_4.body = _5.sent(), _4)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "EC2AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#EC2AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "EC2ThrottledException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#EC2ThrottledException":
                            return [
                                3,
                                4
                            ];
                        case "EC2UnexpectedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#EC2UnexpectedException":
                            return [
                                3,
                                6
                            ];
                        case "EFSIOException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#EFSIOException":
                            return [
                                3,
                                8
                            ];
                        case "EFSMountConnectivityException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#EFSMountConnectivityException":
                            return [
                                3,
                                10
                            ];
                        case "EFSMountFailureException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#EFSMountFailureException":
                            return [
                                3,
                                12
                            ];
                        case "EFSMountTimeoutException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#EFSMountTimeoutException":
                            return [
                                3,
                                14
                            ];
                        case "ENILimitReachedException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lambda#ENILimitReachedException":
                            return [
                                3,
                                16
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                18
                            ];
                        case "InvalidRequestContentException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.lambda#InvalidRequestContentException":
                            return [
                                3,
                                20
                            ];
                        case "InvalidRuntimeException":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.lambda#InvalidRuntimeException":
                            return [
                                3,
                                22
                            ];
                        case "InvalidSecurityGroupIDException":
                            return [
                                3,
                                24
                            ];
                        case "com.amazonaws.lambda#InvalidSecurityGroupIDException":
                            return [
                                3,
                                24
                            ];
                        case "InvalidSubnetIDException":
                            return [
                                3,
                                26
                            ];
                        case "com.amazonaws.lambda#InvalidSubnetIDException":
                            return [
                                3,
                                26
                            ];
                        case "InvalidZipFileException":
                            return [
                                3,
                                28
                            ];
                        case "com.amazonaws.lambda#InvalidZipFileException":
                            return [
                                3,
                                28
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3,
                                30
                            ];
                        case "com.amazonaws.lambda#KMSAccessDeniedException":
                            return [
                                3,
                                30
                            ];
                        case "KMSDisabledException":
                            return [
                                3,
                                32
                            ];
                        case "com.amazonaws.lambda#KMSDisabledException":
                            return [
                                3,
                                32
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3,
                                34
                            ];
                        case "com.amazonaws.lambda#KMSInvalidStateException":
                            return [
                                3,
                                34
                            ];
                        case "KMSNotFoundException":
                            return [
                                3,
                                36
                            ];
                        case "com.amazonaws.lambda#KMSNotFoundException":
                            return [
                                3,
                                36
                            ];
                        case "RequestTooLargeException":
                            return [
                                3,
                                38
                            ];
                        case "com.amazonaws.lambda#RequestTooLargeException":
                            return [
                                3,
                                38
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                40
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                40
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                42
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                42
                            ];
                        case "ResourceNotReadyException":
                            return [
                                3,
                                44
                            ];
                        case "com.amazonaws.lambda#ResourceNotReadyException":
                            return [
                                3,
                                44
                            ];
                        case "ServiceException":
                            return [
                                3,
                                46
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                46
                            ];
                        case "SubnetIPAddressLimitReachedException":
                            return [
                                3,
                                48
                            ];
                        case "com.amazonaws.lambda#SubnetIPAddressLimitReachedException":
                            return [
                                3,
                                48
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                50
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                50
                            ];
                        case "UnsupportedMediaTypeException":
                            return [
                                3,
                                52
                            ];
                        case "com.amazonaws.lambda#UnsupportedMediaTypeException":
                            return [
                                3,
                                52
                            ];
                    }
                    return [
                        3,
                        54
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2ThrottledExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2UnexpectedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSIOExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountConnectivityExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountFailureExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountTimeoutExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ENILimitReachedExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _l.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRequestContentExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _m.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 22:
                    _o = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRuntimeExceptionResponse(parsedOutput, context)
                    ];
                case 23:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _o.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 24:
                    _p = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidSecurityGroupIDExceptionResponse(parsedOutput, context)
                    ];
                case 25:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _p.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 26:
                    _q = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidSubnetIDExceptionResponse(parsedOutput, context)
                    ];
                case 27:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _q.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 28:
                    _r = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidZipFileExceptionResponse(parsedOutput, context)
                    ];
                case 29:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _r.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 30:
                    _s = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 31:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _s.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 32:
                    _t = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 33:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _t.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 34:
                    _u = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 35:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _u.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 36:
                    _v = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 37:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _v.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 38:
                    _w = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1RequestTooLargeExceptionResponse(parsedOutput, context)
                    ];
                case 39:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _w.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 40:
                    _x = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 41:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _x.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 42:
                    _y = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 43:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _y.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 44:
                    _z = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotReadyExceptionResponse(parsedOutput, context)
                    ];
                case 45:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _z.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 46:
                    _0 = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 47:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _0.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 48:
                    _1 = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1SubnetIPAddressLimitReachedExceptionResponse(parsedOutput, context)
                    ];
                case 49:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _1.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 50:
                    _2 = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 51:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _2.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 52:
                    _3 = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context)
                    ];
                case 53:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _3.concat([
                            _5.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        55
                    ];
                case 54:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _5.label = 55;
                case 55:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$9ab24a5c56e40643 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 202 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvokeAsyncCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Status: undefined
                    };
                    if (contents.Status === undefined) contents.Status = output.statusCode;
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvokeAsyncCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidRequestContentException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidRequestContentException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidRuntimeException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#InvalidRuntimeException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRequestContentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRuntimeExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$6dc8096171e81942 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListAliasesCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Aliases: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Aliases !== undefined && data.Aliases !== null) contents.Aliases = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasList(data.Aliases, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListAliasesCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$60cfd8f781d40700 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListCodeSigningConfigsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfigs: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfigs !== undefined && data.CodeSigningConfigs !== null) contents.CodeSigningConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigList(data.CodeSigningConfigs, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListCodeSigningConfigsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _e = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$d38b889274af2c72 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListEventSourceMappingsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        EventSourceMappings: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.EventSourceMappings !== undefined && data.EventSourceMappings !== null) contents.EventSourceMappings = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EventSourceMappingsList(data.EventSourceMappings, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListEventSourceMappingsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7a4e3697c63f58c8 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionEventInvokeConfigsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        FunctionEventInvokeConfigs: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.FunctionEventInvokeConfigs !== undefined && data.FunctionEventInvokeConfigs !== null) contents.FunctionEventInvokeConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionEventInvokeConfigList(data.FunctionEventInvokeConfigs, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionEventInvokeConfigsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$67a1964f8539f1e6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Functions: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Functions !== undefined && data.Functions !== null) contents.Functions = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionList(data.Functions, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$72b86f759c715f1c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionsByCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        FunctionArns: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.FunctionArns !== undefined && data.FunctionArns !== null) contents.FunctionArns = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionArnList(data.FunctionArns, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListFunctionsByCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c88fb183f27eebdb = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListLayersCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Layers: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersList(data.Layers, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListLayersCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                4
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c4a5d8a3a4325dbd = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListLayerVersionsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        LayerVersions: undefined,
                        NextMarker: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.LayerVersions !== undefined && data.LayerVersions !== null) contents.LayerVersions = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionsList(data.LayerVersions, context);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListLayerVersionsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$799472bb62e1687c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListProvisionedConcurrencyConfigsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        NextMarker: undefined,
                        ProvisionedConcurrencyConfigs: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    if (data.ProvisionedConcurrencyConfigs !== undefined && data.ProvisionedConcurrencyConfigs !== null) contents.ProvisionedConcurrencyConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigList(data.ProvisionedConcurrencyConfigs, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListProvisionedConcurrencyConfigsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$62c68cf64814f5dd = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListTagsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Tags: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Tags !== undefined && data.Tags !== null) contents.Tags = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Tags(data.Tags, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListTagsCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$efa8329bd05197d9 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListVersionsByFunctionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        NextMarker: undefined,
                        Versions: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.NextMarker !== undefined && data.NextMarker !== null) contents.NextMarker = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.NextMarker);
                    if (data.Versions !== undefined && data.Versions !== null) contents.Versions = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionList(data.Versions, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ListVersionsByFunctionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _g = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$ee3b77b7dc7ccb1a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PublishLayerVersionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CompatibleArchitectures: undefined,
                        CompatibleRuntimes: undefined,
                        Content: undefined,
                        CreatedDate: undefined,
                        Description: undefined,
                        LayerArn: undefined,
                        LayerVersionArn: undefined,
                        LicenseInfo: undefined,
                        Version: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CompatibleArchitectures !== undefined && data.CompatibleArchitectures !== null) contents.CompatibleArchitectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleArchitectures(data.CompatibleArchitectures, context);
                    if (data.CompatibleRuntimes !== undefined && data.CompatibleRuntimes !== null) contents.CompatibleRuntimes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleRuntimes(data.CompatibleRuntimes, context);
                    if (data.Content !== undefined && data.Content !== null) contents.Content = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionContentOutput(data.Content, context);
                    if (data.CreatedDate !== undefined && data.CreatedDate !== null) contents.CreatedDate = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CreatedDate);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.LayerArn !== undefined && data.LayerArn !== null) contents.LayerArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerArn);
                    if (data.LayerVersionArn !== undefined && data.LayerVersionArn !== null) contents.LayerVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LayerVersionArn);
                    if (data.LicenseInfo !== undefined && data.LicenseInfo !== null) contents.LicenseInfo = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LicenseInfo);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$a883517a83c9c18)(data.Version);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PublishLayerVersionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeStorageExceededException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeStorageExceededException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeStorageExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c8619599bc1f97a9 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 201 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PublishVersionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Architectures: undefined,
                        CodeSha256: undefined,
                        CodeSize: undefined,
                        DeadLetterConfig: undefined,
                        Description: undefined,
                        Environment: undefined,
                        FileSystemConfigs: undefined,
                        FunctionArn: undefined,
                        FunctionName: undefined,
                        Handler: undefined,
                        ImageConfigResponse: undefined,
                        KMSKeyArn: undefined,
                        LastModified: undefined,
                        LastUpdateStatus: undefined,
                        LastUpdateStatusReason: undefined,
                        LastUpdateStatusReasonCode: undefined,
                        Layers: undefined,
                        MasterArn: undefined,
                        MemorySize: undefined,
                        PackageType: undefined,
                        RevisionId: undefined,
                        Role: undefined,
                        Runtime: undefined,
                        SigningJobArn: undefined,
                        SigningProfileVersionArn: undefined,
                        State: undefined,
                        StateReason: undefined,
                        StateReasonCode: undefined,
                        Timeout: undefined,
                        TracingConfig: undefined,
                        Version: undefined,
                        VpcConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Architectures !== undefined && data.Architectures !== null) contents.Architectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(data.Architectures, context);
                    if (data.CodeSha256 !== undefined && data.CodeSha256 !== null) contents.CodeSha256 = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSha256);
                    if (data.CodeSize !== undefined && data.CodeSize !== null) contents.CodeSize = (0, $d373908f914b3142$export$a883517a83c9c18)(data.CodeSize);
                    if (data.DeadLetterConfig !== undefined && data.DeadLetterConfig !== null) contents.DeadLetterConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(data.DeadLetterConfig, context);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.Environment !== undefined && data.Environment !== null) contents.Environment = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(data.Environment, context);
                    if (data.FileSystemConfigs !== undefined && data.FileSystemConfigs !== null) contents.FileSystemConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(data.FileSystemConfigs, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    if (data.Handler !== undefined && data.Handler !== null) contents.Handler = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Handler);
                    if (data.ImageConfigResponse !== undefined && data.ImageConfigResponse !== null) contents.ImageConfigResponse = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(data.ImageConfigResponse, context);
                    if (data.KMSKeyArn !== undefined && data.KMSKeyArn !== null) contents.KMSKeyArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.KMSKeyArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.LastUpdateStatus !== undefined && data.LastUpdateStatus !== null) contents.LastUpdateStatus = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatus);
                    if (data.LastUpdateStatusReason !== undefined && data.LastUpdateStatusReason !== null) contents.LastUpdateStatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReason);
                    if (data.LastUpdateStatusReasonCode !== undefined && data.LastUpdateStatusReasonCode !== null) contents.LastUpdateStatusReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReasonCode);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(data.Layers, context);
                    if (data.MasterArn !== undefined && data.MasterArn !== null) contents.MasterArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.MasterArn);
                    if (data.MemorySize !== undefined && data.MemorySize !== null) contents.MemorySize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MemorySize);
                    if (data.PackageType !== undefined && data.PackageType !== null) contents.PackageType = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.PackageType);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Role !== undefined && data.Role !== null) contents.Role = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Role);
                    if (data.Runtime !== undefined && data.Runtime !== null) contents.Runtime = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Runtime);
                    if (data.SigningJobArn !== undefined && data.SigningJobArn !== null) contents.SigningJobArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningJobArn);
                    if (data.SigningProfileVersionArn !== undefined && data.SigningProfileVersionArn !== null) contents.SigningProfileVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningProfileVersionArn);
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateReason !== undefined && data.StateReason !== null) contents.StateReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReason);
                    if (data.StateReasonCode !== undefined && data.StateReasonCode !== null) contents.StateReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReasonCode);
                    if (data.Timeout !== undefined && data.Timeout !== null) contents.Timeout = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.Timeout);
                    if (data.TracingConfig !== undefined && data.TracingConfig !== null) contents.TracingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(data.TracingConfig, context);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Version);
                    if (data.VpcConfig !== undefined && data.VpcConfig !== null) contents.VpcConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(data.VpcConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PublishVersionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
        var _k;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
            switch(_l.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _k = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_k.body = _l.sent(), _k)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeStorageExceededException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeStorageExceededException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                12
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeStorageExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _l.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        17
                    ];
                case 16:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _l.label = 17;
                case 17:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$b106259e75e5a744 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfigArn: undefined,
                        FunctionName: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfigArn !== undefined && data.CodeSigningConfigArn !== null) contents.CodeSigningConfigArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSigningConfigArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$bd67a03b6410d854 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionConcurrencyCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        ReservedConcurrentExecutions: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.ReservedConcurrentExecutions !== undefined && data.ReservedConcurrentExecutions !== null) contents.ReservedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ReservedConcurrentExecutions);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionConcurrencyCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$c9e7ac89588d3e99 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionEventInvokeConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        DestinationConfig: undefined,
                        FunctionArn: undefined,
                        LastModified: undefined,
                        MaximumEventAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.MaximumEventAgeInSeconds !== undefined && data.MaximumEventAgeInSeconds !== null) contents.MaximumEventAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumEventAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutFunctionEventInvokeConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$918326d3a4269f01 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 202 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutProvisionedConcurrencyConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AllocatedProvisionedConcurrentExecutions: undefined,
                        AvailableProvisionedConcurrentExecutions: undefined,
                        LastModified: undefined,
                        RequestedProvisionedConcurrentExecutions: undefined,
                        Status: undefined,
                        StatusReason: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AllocatedProvisionedConcurrentExecutions !== undefined && data.AllocatedProvisionedConcurrentExecutions !== null) contents.AllocatedProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.AllocatedProvisionedConcurrentExecutions);
                    if (data.AvailableProvisionedConcurrentExecutions !== undefined && data.AvailableProvisionedConcurrentExecutions !== null) contents.AvailableProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.AvailableProvisionedConcurrentExecutions);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.RequestedProvisionedConcurrentExecutions !== undefined && data.RequestedProvisionedConcurrentExecutions !== null) contents.RequestedProvisionedConcurrentExecutions = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.RequestedProvisionedConcurrentExecutions);
                    if (data.Status !== undefined && data.Status !== null) contents.Status = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Status);
                    if (data.StatusReason !== undefined && data.StatusReason !== null) contents.StatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StatusReason);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PutProvisionedConcurrencyConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$243198eaeb6cfcbf = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1RemoveLayerVersionPermissionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1RemoveLayerVersionPermissionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$8a9ec0a287c07a4c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1RemovePermissionCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1RemovePermissionCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$6af06c2db34dbab7 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TagResourceCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1TagResourceCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$fddea5ff3cc15b1a = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 204 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UntagResourceCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    };
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UntagResourceCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$e84afa5507fc90b3 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateAliasCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        AliasArn: undefined,
                        Description: undefined,
                        FunctionVersion: undefined,
                        Name: undefined,
                        RevisionId: undefined,
                        RoutingConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.AliasArn !== undefined && data.AliasArn !== null) contents.AliasArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.AliasArn);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.FunctionVersion !== undefined && data.FunctionVersion !== null) contents.FunctionVersion = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionVersion);
                    if (data.Name !== undefined && data.Name !== null) contents.Name = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Name);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.RoutingConfig !== undefined && data.RoutingConfig !== null) contents.RoutingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasRoutingConfiguration(data.RoutingConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateAliasCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$85a9f5c7539c25b6 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateCodeSigningConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        CodeSigningConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CodeSigningConfig !== undefined && data.CodeSigningConfig !== null) contents.CodeSigningConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfig(data.CodeSigningConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateCodeSigningConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _f = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                4
                            ];
                        case "ServiceException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$62ff613092b85e2c = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 202 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateEventSourceMappingCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        BatchSize: undefined,
                        BisectBatchOnFunctionError: undefined,
                        DestinationConfig: undefined,
                        EventSourceArn: undefined,
                        FunctionArn: undefined,
                        FunctionResponseTypes: undefined,
                        LastModified: undefined,
                        LastProcessingResult: undefined,
                        MaximumBatchingWindowInSeconds: undefined,
                        MaximumRecordAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined,
                        ParallelizationFactor: undefined,
                        Queues: undefined,
                        SelfManagedEventSource: undefined,
                        SourceAccessConfigurations: undefined,
                        StartingPosition: undefined,
                        StartingPositionTimestamp: undefined,
                        State: undefined,
                        StateTransitionReason: undefined,
                        Topics: undefined,
                        TumblingWindowInSeconds: undefined,
                        UUID: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.BatchSize !== undefined && data.BatchSize !== null) contents.BatchSize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.BatchSize);
                    if (data.BisectBatchOnFunctionError !== undefined && data.BisectBatchOnFunctionError !== null) contents.BisectBatchOnFunctionError = (0, $d373908f914b3142$export$259b2ebfc29bf466)(data.BisectBatchOnFunctionError);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.EventSourceArn !== undefined && data.EventSourceArn !== null) contents.EventSourceArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.EventSourceArn);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionResponseTypes !== undefined && data.FunctionResponseTypes !== null) contents.FunctionResponseTypes = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList(data.FunctionResponseTypes, context);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.LastProcessingResult !== undefined && data.LastProcessingResult !== null) contents.LastProcessingResult = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastProcessingResult);
                    if (data.MaximumBatchingWindowInSeconds !== undefined && data.MaximumBatchingWindowInSeconds !== null) contents.MaximumBatchingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumBatchingWindowInSeconds);
                    if (data.MaximumRecordAgeInSeconds !== undefined && data.MaximumRecordAgeInSeconds !== null) contents.MaximumRecordAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRecordAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    if (data.ParallelizationFactor !== undefined && data.ParallelizationFactor !== null) contents.ParallelizationFactor = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.ParallelizationFactor);
                    if (data.Queues !== undefined && data.Queues !== null) contents.Queues = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues(data.Queues, context);
                    if (data.SelfManagedEventSource !== undefined && data.SelfManagedEventSource !== null) contents.SelfManagedEventSource = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource(data.SelfManagedEventSource, context);
                    if (data.SourceAccessConfigurations !== undefined && data.SourceAccessConfigurations !== null) contents.SourceAccessConfigurations = $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations(data.SourceAccessConfigurations, context);
                    if (data.StartingPosition !== undefined && data.StartingPosition !== null) contents.StartingPosition = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StartingPosition);
                    if (data.StartingPositionTimestamp !== undefined && data.StartingPositionTimestamp !== null) contents.StartingPositionTimestamp = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.StartingPositionTimestamp)));
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateTransitionReason !== undefined && data.StateTransitionReason !== null) contents.StateTransitionReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateTransitionReason);
                    if (data.Topics !== undefined && data.Topics !== null) contents.Topics = $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics(data.Topics, context);
                    if (data.TumblingWindowInSeconds !== undefined && data.TumblingWindowInSeconds !== null) contents.TumblingWindowInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.TumblingWindowInSeconds);
                    if (data.UUID !== undefined && data.UUID !== null) contents.UUID = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.UUID);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateEventSourceMappingCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _j = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceInUseException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                10
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$d4cc2fb5514058ce = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionCodeCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Architectures: undefined,
                        CodeSha256: undefined,
                        CodeSize: undefined,
                        DeadLetterConfig: undefined,
                        Description: undefined,
                        Environment: undefined,
                        FileSystemConfigs: undefined,
                        FunctionArn: undefined,
                        FunctionName: undefined,
                        Handler: undefined,
                        ImageConfigResponse: undefined,
                        KMSKeyArn: undefined,
                        LastModified: undefined,
                        LastUpdateStatus: undefined,
                        LastUpdateStatusReason: undefined,
                        LastUpdateStatusReasonCode: undefined,
                        Layers: undefined,
                        MasterArn: undefined,
                        MemorySize: undefined,
                        PackageType: undefined,
                        RevisionId: undefined,
                        Role: undefined,
                        Runtime: undefined,
                        SigningJobArn: undefined,
                        SigningProfileVersionArn: undefined,
                        State: undefined,
                        StateReason: undefined,
                        StateReasonCode: undefined,
                        Timeout: undefined,
                        TracingConfig: undefined,
                        Version: undefined,
                        VpcConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Architectures !== undefined && data.Architectures !== null) contents.Architectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(data.Architectures, context);
                    if (data.CodeSha256 !== undefined && data.CodeSha256 !== null) contents.CodeSha256 = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSha256);
                    if (data.CodeSize !== undefined && data.CodeSize !== null) contents.CodeSize = (0, $d373908f914b3142$export$a883517a83c9c18)(data.CodeSize);
                    if (data.DeadLetterConfig !== undefined && data.DeadLetterConfig !== null) contents.DeadLetterConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(data.DeadLetterConfig, context);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.Environment !== undefined && data.Environment !== null) contents.Environment = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(data.Environment, context);
                    if (data.FileSystemConfigs !== undefined && data.FileSystemConfigs !== null) contents.FileSystemConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(data.FileSystemConfigs, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    if (data.Handler !== undefined && data.Handler !== null) contents.Handler = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Handler);
                    if (data.ImageConfigResponse !== undefined && data.ImageConfigResponse !== null) contents.ImageConfigResponse = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(data.ImageConfigResponse, context);
                    if (data.KMSKeyArn !== undefined && data.KMSKeyArn !== null) contents.KMSKeyArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.KMSKeyArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.LastUpdateStatus !== undefined && data.LastUpdateStatus !== null) contents.LastUpdateStatus = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatus);
                    if (data.LastUpdateStatusReason !== undefined && data.LastUpdateStatusReason !== null) contents.LastUpdateStatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReason);
                    if (data.LastUpdateStatusReasonCode !== undefined && data.LastUpdateStatusReasonCode !== null) contents.LastUpdateStatusReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReasonCode);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(data.Layers, context);
                    if (data.MasterArn !== undefined && data.MasterArn !== null) contents.MasterArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.MasterArn);
                    if (data.MemorySize !== undefined && data.MemorySize !== null) contents.MemorySize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MemorySize);
                    if (data.PackageType !== undefined && data.PackageType !== null) contents.PackageType = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.PackageType);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Role !== undefined && data.Role !== null) contents.Role = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Role);
                    if (data.Runtime !== undefined && data.Runtime !== null) contents.Runtime = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Runtime);
                    if (data.SigningJobArn !== undefined && data.SigningJobArn !== null) contents.SigningJobArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningJobArn);
                    if (data.SigningProfileVersionArn !== undefined && data.SigningProfileVersionArn !== null) contents.SigningProfileVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningProfileVersionArn);
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateReason !== undefined && data.StateReason !== null) contents.StateReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReason);
                    if (data.StateReasonCode !== undefined && data.StateReasonCode !== null) contents.StateReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReasonCode);
                    if (data.Timeout !== undefined && data.Timeout !== null) contents.Timeout = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.Timeout);
                    if (data.TracingConfig !== undefined && data.TracingConfig !== null) contents.TracingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(data.TracingConfig, context);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Version);
                    if (data.VpcConfig !== undefined && data.VpcConfig !== null) contents.VpcConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(data.VpcConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionCodeCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _o = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "CodeStorageExceededException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#CodeStorageExceededException":
                            return [
                                3,
                                4
                            ];
                        case "CodeVerificationFailedException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#CodeVerificationFailedException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidCodeSignatureException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#InvalidCodeSignatureException":
                            return [
                                3,
                                8
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                10
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                14
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "ServiceException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                18
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                20
                            ];
                    }
                    return [
                        3,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeStorageExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeVerificationFailedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidCodeSignatureExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$4d5280dd99946dd0 = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionConfigurationCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        Architectures: undefined,
                        CodeSha256: undefined,
                        CodeSize: undefined,
                        DeadLetterConfig: undefined,
                        Description: undefined,
                        Environment: undefined,
                        FileSystemConfigs: undefined,
                        FunctionArn: undefined,
                        FunctionName: undefined,
                        Handler: undefined,
                        ImageConfigResponse: undefined,
                        KMSKeyArn: undefined,
                        LastModified: undefined,
                        LastUpdateStatus: undefined,
                        LastUpdateStatusReason: undefined,
                        LastUpdateStatusReasonCode: undefined,
                        Layers: undefined,
                        MasterArn: undefined,
                        MemorySize: undefined,
                        PackageType: undefined,
                        RevisionId: undefined,
                        Role: undefined,
                        Runtime: undefined,
                        SigningJobArn: undefined,
                        SigningProfileVersionArn: undefined,
                        State: undefined,
                        StateReason: undefined,
                        StateReasonCode: undefined,
                        Timeout: undefined,
                        TracingConfig: undefined,
                        Version: undefined,
                        VpcConfig: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Architectures !== undefined && data.Architectures !== null) contents.Architectures = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(data.Architectures, context);
                    if (data.CodeSha256 !== undefined && data.CodeSha256 !== null) contents.CodeSha256 = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.CodeSha256);
                    if (data.CodeSize !== undefined && data.CodeSize !== null) contents.CodeSize = (0, $d373908f914b3142$export$a883517a83c9c18)(data.CodeSize);
                    if (data.DeadLetterConfig !== undefined && data.DeadLetterConfig !== null) contents.DeadLetterConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(data.DeadLetterConfig, context);
                    if (data.Description !== undefined && data.Description !== null) contents.Description = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Description);
                    if (data.Environment !== undefined && data.Environment !== null) contents.Environment = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(data.Environment, context);
                    if (data.FileSystemConfigs !== undefined && data.FileSystemConfigs !== null) contents.FileSystemConfigs = $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(data.FileSystemConfigs, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.FunctionName !== undefined && data.FunctionName !== null) contents.FunctionName = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionName);
                    if (data.Handler !== undefined && data.Handler !== null) contents.Handler = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Handler);
                    if (data.ImageConfigResponse !== undefined && data.ImageConfigResponse !== null) contents.ImageConfigResponse = $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(data.ImageConfigResponse, context);
                    if (data.KMSKeyArn !== undefined && data.KMSKeyArn !== null) contents.KMSKeyArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.KMSKeyArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastModified);
                    if (data.LastUpdateStatus !== undefined && data.LastUpdateStatus !== null) contents.LastUpdateStatus = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatus);
                    if (data.LastUpdateStatusReason !== undefined && data.LastUpdateStatusReason !== null) contents.LastUpdateStatusReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReason);
                    if (data.LastUpdateStatusReasonCode !== undefined && data.LastUpdateStatusReasonCode !== null) contents.LastUpdateStatusReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.LastUpdateStatusReasonCode);
                    if (data.Layers !== undefined && data.Layers !== null) contents.Layers = $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(data.Layers, context);
                    if (data.MasterArn !== undefined && data.MasterArn !== null) contents.MasterArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.MasterArn);
                    if (data.MemorySize !== undefined && data.MemorySize !== null) contents.MemorySize = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MemorySize);
                    if (data.PackageType !== undefined && data.PackageType !== null) contents.PackageType = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.PackageType);
                    if (data.RevisionId !== undefined && data.RevisionId !== null) contents.RevisionId = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.RevisionId);
                    if (data.Role !== undefined && data.Role !== null) contents.Role = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Role);
                    if (data.Runtime !== undefined && data.Runtime !== null) contents.Runtime = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Runtime);
                    if (data.SigningJobArn !== undefined && data.SigningJobArn !== null) contents.SigningJobArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningJobArn);
                    if (data.SigningProfileVersionArn !== undefined && data.SigningProfileVersionArn !== null) contents.SigningProfileVersionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.SigningProfileVersionArn);
                    if (data.State !== undefined && data.State !== null) contents.State = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.State);
                    if (data.StateReason !== undefined && data.StateReason !== null) contents.StateReason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReason);
                    if (data.StateReasonCode !== undefined && data.StateReasonCode !== null) contents.StateReasonCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.StateReasonCode);
                    if (data.Timeout !== undefined && data.Timeout !== null) contents.Timeout = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.Timeout);
                    if (data.TracingConfig !== undefined && data.TracingConfig !== null) contents.TracingConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(data.TracingConfig, context);
                    if (data.Version !== undefined && data.Version !== null) contents.Version = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Version);
                    if (data.VpcConfig !== undefined && data.VpcConfig !== null) contents.VpcConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(data.VpcConfig, context);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionConfigurationCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _m = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#CodeSigningConfigNotFoundException":
                            return [
                                3,
                                2
                            ];
                        case "CodeVerificationFailedException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#CodeVerificationFailedException":
                            return [
                                3,
                                4
                            ];
                        case "InvalidCodeSignatureException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#InvalidCodeSignatureException":
                            return [
                                3,
                                6
                            ];
                        case "InvalidParameterValueException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                8
                            ];
                        case "PreconditionFailedException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#PreconditionFailedException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                12
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                14
                            ];
                        case "ServiceException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                16
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                18
                            ];
                    }
                    return [
                        3,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeVerificationFailedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidCodeSignatureExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$export$7ac2ddaab57fa61e = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionEventInvokeConfigCommandError(output, context)
                    ];
                    contents = {
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output),
                        DestinationConfig: undefined,
                        FunctionArn: undefined,
                        LastModified: undefined,
                        MaximumEventAgeInSeconds: undefined,
                        MaximumRetryAttempts: undefined
                    };
                    _a = (0, $d373908f914b3142$export$8413a63dbe548a49);
                    _b = (0, $d373908f914b3142$export$cf825aadce530e7e);
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DestinationConfig !== undefined && data.DestinationConfig !== null) contents.DestinationConfig = $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(data.DestinationConfig, context);
                    if (data.FunctionArn !== undefined && data.FunctionArn !== null) contents.FunctionArn = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.FunctionArn);
                    if (data.LastModified !== undefined && data.LastModified !== null) contents.LastModified = (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(data.LastModified)));
                    if (data.MaximumEventAgeInSeconds !== undefined && data.MaximumEventAgeInSeconds !== null) contents.MaximumEventAgeInSeconds = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumEventAgeInSeconds);
                    if (data.MaximumRetryAttempts !== undefined && data.MaximumRetryAttempts !== null) contents.MaximumRetryAttempts = (0, $d373908f914b3142$export$99c64e845cdac9c1)(data.MaximumRetryAttempts);
                    return [
                        2,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UpdateFunctionEventInvokeConfigCommandError = function(output, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, output)
                    ];
                    _h = {};
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = $31426a0b6b5dd4d5$var$loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lambda#InvalidParameterValueException":
                            return [
                                3,
                                2
                            ];
                        case "ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lambda#ResourceConflictException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lambda#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lambda#ServiceException":
                            return [
                                3,
                                8
                            ];
                        case "TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lambda#TooManyRequestsException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4,
                        $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, [
                        (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "CodeSigningConfigNotFoundException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeStorageExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "CodeStorageExceededException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeVerificationFailedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "CodeVerificationFailedException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2AccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EC2AccessDeniedException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2ThrottledExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EC2ThrottledException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EC2UnexpectedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EC2UnexpectedException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                EC2ErrorCode: undefined,
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.EC2ErrorCode !== undefined && data.EC2ErrorCode !== null) contents.EC2ErrorCode = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.EC2ErrorCode);
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSIOExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EFSIOException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountConnectivityExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EFSMountConnectivityException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountFailureExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EFSMountFailureException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EFSMountTimeoutExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "EFSMountTimeoutException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ENILimitReachedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ENILimitReachedException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidCodeSignatureExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidCodeSignatureException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidParameterValueExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidParameterValueException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRequestContentExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidRequestContentException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidRuntimeExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidRuntimeException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidSecurityGroupIDExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidSecurityGroupIDException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidSubnetIDExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidSubnetIDException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1InvalidZipFileExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "InvalidZipFileException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSAccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "KMSAccessDeniedException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "KMSDisabledException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSInvalidStateExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "KMSInvalidStateException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1KMSNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "KMSNotFoundException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PolicyLengthExceededExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "PolicyLengthExceededException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1PreconditionFailedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "PreconditionFailedException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ProvisionedConcurrencyConfigNotFoundException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1RequestTooLargeExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "RequestTooLargeException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceConflictExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceInUseExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ResourceNotReadyExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ResourceNotReadyException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ServiceExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "ServiceException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SubnetIPAddressLimitReachedExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "SubnetIPAddressLimitReachedException",
                $fault: "server",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Message: undefined,
                Type: undefined
            };
            data = parsedOutput.body;
            if (data.Message !== undefined && data.Message !== null) contents.Message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Message);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1TooManyRequestsExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Reason: undefined,
                Type: undefined,
                message: undefined,
                retryAfterSeconds: undefined
            };
            if (parsedOutput.headers["retry-after"] !== undefined) contents.retryAfterSeconds = parsedOutput.headers["retry-after"];
            data = parsedOutput.body;
            if (data.Reason !== undefined && data.Reason !== null) contents.Reason = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Reason);
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse = function(parsedOutput, context) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            contents = {
                name: "UnsupportedMediaTypeException",
                $fault: "client",
                $metadata: $31426a0b6b5dd4d5$var$deserializeMetadata(parsedOutput),
                Type: undefined,
                message: undefined
            };
            data = parsedOutput.body;
            if (data.Type !== undefined && data.Type !== null) contents.Type = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.Type);
            if (data.message !== undefined && data.message !== null) contents.message = (0, $d373908f914b3142$export$7ed80f53fe336639)(data.message);
            return [
                2,
                contents
            ];
        });
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1AdditionalVersionWeights = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $ff4f27ff02223c28$export$4a2bea4ecaa09ba7)(value), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1AliasRoutingConfiguration = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.AdditionalVersionWeights !== undefined && input.AdditionalVersionWeights !== null && {
        AdditionalVersionWeights: $31426a0b6b5dd4d5$var$serializeAws_restJson1AdditionalVersionWeights(input.AdditionalVersionWeights, context)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1AllowedPublishers = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.SigningProfileVersionArns !== undefined && input.SigningProfileVersionArns !== null && {
        SigningProfileVersionArns: $31426a0b6b5dd4d5$var$serializeAws_restJson1SigningProfileVersionArns(input.SigningProfileVersionArns, context)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1ArchitecturesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1CodeSigningPolicies = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.UntrustedArtifactOnDeployment !== undefined && input.UntrustedArtifactOnDeployment !== null && {
        UntrustedArtifactOnDeployment: input.UntrustedArtifactOnDeployment
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1CompatibleArchitectures = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1CompatibleRuntimes = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1DeadLetterConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.TargetArn !== undefined && input.TargetArn !== null && {
        TargetArn: input.TargetArn
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1DestinationConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.OnFailure !== undefined && input.OnFailure !== null && {
        OnFailure: $31426a0b6b5dd4d5$var$serializeAws_restJson1OnFailure(input.OnFailure, context)
    }), input.OnSuccess !== undefined && input.OnSuccess !== null && {
        OnSuccess: $31426a0b6b5dd4d5$var$serializeAws_restJson1OnSuccess(input.OnSuccess, context)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1EndpointLists = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1Endpoints = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $31426a0b6b5dd4d5$var$serializeAws_restJson1EndpointLists(value, context), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1Environment = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Variables !== undefined && input.Variables !== null && {
        Variables: $31426a0b6b5dd4d5$var$serializeAws_restJson1EnvironmentVariables(input.Variables, context)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1EnvironmentVariables = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1FileSystemConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Arn !== undefined && input.Arn !== null && {
        Arn: input.Arn
    }), input.LocalMountPath !== undefined && input.LocalMountPath !== null && {
        LocalMountPath: input.LocalMountPath
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1FileSystemConfigList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$serializeAws_restJson1FileSystemConfig(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1FunctionCode = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.ImageUri !== undefined && input.ImageUri !== null && {
        ImageUri: input.ImageUri
    }), input.S3Bucket !== undefined && input.S3Bucket !== null && {
        S3Bucket: input.S3Bucket
    }), input.S3Key !== undefined && input.S3Key !== null && {
        S3Key: input.S3Key
    }), input.S3ObjectVersion !== undefined && input.S3ObjectVersion !== null && {
        S3ObjectVersion: input.S3ObjectVersion
    }), input.ZipFile !== undefined && input.ZipFile !== null && {
        ZipFile: context.base64Encoder(input.ZipFile)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1FunctionResponseTypeList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1ImageConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Command !== undefined && input.Command !== null && {
        Command: $31426a0b6b5dd4d5$var$serializeAws_restJson1StringList(input.Command, context)
    }), input.EntryPoint !== undefined && input.EntryPoint !== null && {
        EntryPoint: $31426a0b6b5dd4d5$var$serializeAws_restJson1StringList(input.EntryPoint, context)
    }), input.WorkingDirectory !== undefined && input.WorkingDirectory !== null && {
        WorkingDirectory: input.WorkingDirectory
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1LayerList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1LayerVersionContentInput = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.S3Bucket !== undefined && input.S3Bucket !== null && {
        S3Bucket: input.S3Bucket
    }), input.S3Key !== undefined && input.S3Key !== null && {
        S3Key: input.S3Key
    }), input.S3ObjectVersion !== undefined && input.S3ObjectVersion !== null && {
        S3ObjectVersion: input.S3ObjectVersion
    }), input.ZipFile !== undefined && input.ZipFile !== null && {
        ZipFile: context.base64Encoder(input.ZipFile)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1OnFailure = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Destination !== undefined && input.Destination !== null && {
        Destination: input.Destination
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1OnSuccess = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Destination !== undefined && input.Destination !== null && {
        Destination: input.Destination
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1Queues = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SecurityGroupIds = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SelfManagedEventSource = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Endpoints !== undefined && input.Endpoints !== null && {
        Endpoints: $31426a0b6b5dd4d5$var$serializeAws_restJson1Endpoints(input.Endpoints, context)
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SigningProfileVersionArns = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SourceAccessConfiguration = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    }), input.URI !== undefined && input.URI !== null && {
        URI: input.URI
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SourceAccessConfigurations = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$serializeAws_restJson1SourceAccessConfiguration(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1StringList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1SubnetIds = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1Tags = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1Topics = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1TracingConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.Mode !== undefined && input.Mode !== null && {
        Mode: input.Mode
    });
};
var $31426a0b6b5dd4d5$var$serializeAws_restJson1VpcConfig = function(input, context) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input.SecurityGroupIds !== undefined && input.SecurityGroupIds !== null && {
        SecurityGroupIds: $31426a0b6b5dd4d5$var$serializeAws_restJson1SecurityGroupIds(input.SecurityGroupIds, context)
    }), input.SubnetIds !== undefined && input.SubnetIds !== null && {
        SubnetIds: $31426a0b6b5dd4d5$var$serializeAws_restJson1SubnetIds(input.SubnetIds, context)
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AccountLimit = function(output, context) {
    return {
        CodeSizeUnzipped: (0, $d373908f914b3142$export$a883517a83c9c18)(output.CodeSizeUnzipped),
        CodeSizeZipped: (0, $d373908f914b3142$export$a883517a83c9c18)(output.CodeSizeZipped),
        ConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.ConcurrentExecutions),
        TotalCodeSize: (0, $d373908f914b3142$export$a883517a83c9c18)(output.TotalCodeSize),
        UnreservedConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.UnreservedConcurrentExecutions)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AccountUsage = function(output, context) {
    return {
        FunctionCount: (0, $d373908f914b3142$export$a883517a83c9c18)(output.FunctionCount),
        TotalCodeSize: (0, $d373908f914b3142$export$a883517a83c9c18)(output.TotalCodeSize)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AdditionalVersionWeights = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $d373908f914b3142$export$11335e83c8af2784)(value), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasConfiguration = function(output, context) {
    return {
        AliasArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.AliasArn),
        Description: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Description),
        FunctionVersion: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionVersion),
        Name: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Name),
        RevisionId: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.RevisionId),
        RoutingConfig: output.RoutingConfig !== undefined && output.RoutingConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasRoutingConfiguration(output.RoutingConfig, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasConfiguration(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AliasRoutingConfiguration = function(output, context) {
    return {
        AdditionalVersionWeights: output.AdditionalVersionWeights !== undefined && output.AdditionalVersionWeights !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1AdditionalVersionWeights(output.AdditionalVersionWeights, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1AllowedPublishers = function(output, context) {
    return {
        SigningProfileVersionArns: output.SigningProfileVersionArns !== undefined && output.SigningProfileVersionArns !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1SigningProfileVersionArns(output.SigningProfileVersionArns, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfig = function(output, context) {
    return {
        AllowedPublishers: output.AllowedPublishers !== undefined && output.AllowedPublishers !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1AllowedPublishers(output.AllowedPublishers, context) : undefined,
        CodeSigningConfigArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.CodeSigningConfigArn),
        CodeSigningConfigId: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.CodeSigningConfigId),
        CodeSigningPolicies: output.CodeSigningPolicies !== undefined && output.CodeSigningPolicies !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningPolicies(output.CodeSigningPolicies, context) : undefined,
        Description: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Description),
        LastModified: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastModified)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfigList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningConfig(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CodeSigningPolicies = function(output, context) {
    return {
        UntrustedArtifactOnDeployment: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.UntrustedArtifactOnDeployment)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleArchitectures = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleRuntimes = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Concurrency = function(output, context) {
    return {
        ReservedConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.ReservedConcurrentExecutions)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig = function(output, context) {
    return {
        TargetArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.TargetArn)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig = function(output, context) {
    return {
        OnFailure: output.OnFailure !== undefined && output.OnFailure !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1OnFailure(output.OnFailure, context) : undefined,
        OnSuccess: output.OnSuccess !== undefined && output.OnSuccess !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1OnSuccess(output.OnSuccess, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EndpointLists = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Endpoints = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = $31426a0b6b5dd4d5$var$deserializeAws_restJson1EndpointLists(value, context), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentError = function(output, context) {
    return {
        ErrorCode: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.ErrorCode),
        Message: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Message)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse = function(output, context) {
    return {
        Error: output.Error !== undefined && output.Error !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentError(output.Error, context) : undefined,
        Variables: output.Variables !== undefined && output.Variables !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentVariables(output.Variables, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentVariables = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $d373908f914b3142$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EventSourceMappingConfiguration = function(output, context) {
    return {
        BatchSize: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.BatchSize),
        BisectBatchOnFunctionError: (0, $d373908f914b3142$export$259b2ebfc29bf466)(output.BisectBatchOnFunctionError),
        DestinationConfig: output.DestinationConfig !== undefined && output.DestinationConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(output.DestinationConfig, context) : undefined,
        EventSourceArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.EventSourceArn),
        FunctionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionArn),
        FunctionResponseTypes: output.FunctionResponseTypes !== undefined && output.FunctionResponseTypes !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList(output.FunctionResponseTypes, context) : undefined,
        LastModified: output.LastModified !== undefined && output.LastModified !== null ? (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(output.LastModified))) : undefined,
        LastProcessingResult: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastProcessingResult),
        MaximumBatchingWindowInSeconds: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MaximumBatchingWindowInSeconds),
        MaximumRecordAgeInSeconds: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MaximumRecordAgeInSeconds),
        MaximumRetryAttempts: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MaximumRetryAttempts),
        ParallelizationFactor: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.ParallelizationFactor),
        Queues: output.Queues !== undefined && output.Queues !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues(output.Queues, context) : undefined,
        SelfManagedEventSource: output.SelfManagedEventSource !== undefined && output.SelfManagedEventSource !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource(output.SelfManagedEventSource, context) : undefined,
        SourceAccessConfigurations: output.SourceAccessConfigurations !== undefined && output.SourceAccessConfigurations !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations(output.SourceAccessConfigurations, context) : undefined,
        StartingPosition: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.StartingPosition),
        StartingPositionTimestamp: output.StartingPositionTimestamp !== undefined && output.StartingPositionTimestamp !== null ? (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(output.StartingPositionTimestamp))) : undefined,
        State: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.State),
        StateTransitionReason: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.StateTransitionReason),
        Topics: output.Topics !== undefined && output.Topics !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics(output.Topics, context) : undefined,
        TumblingWindowInSeconds: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.TumblingWindowInSeconds),
        UUID: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.UUID)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1EventSourceMappingsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1EventSourceMappingConfiguration(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfig = function(output, context) {
    return {
        Arn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Arn),
        LocalMountPath: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LocalMountPath)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfig(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionArnList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionCodeLocation = function(output, context) {
    return {
        ImageUri: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.ImageUri),
        Location: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Location),
        RepositoryType: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.RepositoryType),
        ResolvedImageUri: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.ResolvedImageUri)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionConfiguration = function(output, context) {
    return {
        Architectures: output.Architectures !== undefined && output.Architectures !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1ArchitecturesList(output.Architectures, context) : undefined,
        CodeSha256: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.CodeSha256),
        CodeSize: (0, $d373908f914b3142$export$a883517a83c9c18)(output.CodeSize),
        DeadLetterConfig: output.DeadLetterConfig !== undefined && output.DeadLetterConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1DeadLetterConfig(output.DeadLetterConfig, context) : undefined,
        Description: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Description),
        Environment: output.Environment !== undefined && output.Environment !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1EnvironmentResponse(output.Environment, context) : undefined,
        FileSystemConfigs: output.FileSystemConfigs !== undefined && output.FileSystemConfigs !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1FileSystemConfigList(output.FileSystemConfigs, context) : undefined,
        FunctionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionArn),
        FunctionName: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionName),
        Handler: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Handler),
        ImageConfigResponse: output.ImageConfigResponse !== undefined && output.ImageConfigResponse !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse(output.ImageConfigResponse, context) : undefined,
        KMSKeyArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.KMSKeyArn),
        LastModified: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastModified),
        LastUpdateStatus: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastUpdateStatus),
        LastUpdateStatusReason: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastUpdateStatusReason),
        LastUpdateStatusReasonCode: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastUpdateStatusReasonCode),
        Layers: output.Layers !== undefined && output.Layers !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList(output.Layers, context) : undefined,
        MasterArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.MasterArn),
        MemorySize: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MemorySize),
        PackageType: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.PackageType),
        RevisionId: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.RevisionId),
        Role: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Role),
        Runtime: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Runtime),
        SigningJobArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningJobArn),
        SigningProfileVersionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningProfileVersionArn),
        State: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.State),
        StateReason: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.StateReason),
        StateReasonCode: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.StateReasonCode),
        Timeout: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.Timeout),
        TracingConfig: output.TracingConfig !== undefined && output.TracingConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse(output.TracingConfig, context) : undefined,
        Version: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Version),
        VpcConfig: output.VpcConfig !== undefined && output.VpcConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse(output.VpcConfig, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionEventInvokeConfig = function(output, context) {
    return {
        DestinationConfig: output.DestinationConfig !== undefined && output.DestinationConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1DestinationConfig(output.DestinationConfig, context) : undefined,
        FunctionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionArn),
        LastModified: output.LastModified !== undefined && output.LastModified !== null ? (0, $d373908f914b3142$export$8413a63dbe548a49)((0, $371ecb836c361216$export$685da212e4e79e10)((0, $d373908f914b3142$export$f3945e48fdb5f9a)(output.LastModified))) : undefined,
        MaximumEventAgeInSeconds: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MaximumEventAgeInSeconds),
        MaximumRetryAttempts: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.MaximumRetryAttempts)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionEventInvokeConfigList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionEventInvokeConfig(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionConfiguration(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1FunctionResponseTypeList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfig = function(output, context) {
    return {
        Command: output.Command !== undefined && output.Command !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1StringList(output.Command, context) : undefined,
        EntryPoint: output.EntryPoint !== undefined && output.EntryPoint !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1StringList(output.EntryPoint, context) : undefined,
        WorkingDirectory: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.WorkingDirectory)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigError = function(output, context) {
    return {
        ErrorCode: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.ErrorCode),
        Message: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Message)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigResponse = function(output, context) {
    return {
        Error: output.Error !== undefined && output.Error !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfigError(output.Error, context) : undefined,
        ImageConfig: output.ImageConfig !== undefined && output.ImageConfig !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1ImageConfig(output.ImageConfig, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Layer = function(output, context) {
    return {
        Arn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Arn),
        CodeSize: (0, $d373908f914b3142$export$a883517a83c9c18)(output.CodeSize),
        SigningJobArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningJobArn),
        SigningProfileVersionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningProfileVersionArn)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersListItem(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersListItem = function(output, context) {
    return {
        LatestMatchingVersion: output.LatestMatchingVersion !== undefined && output.LatestMatchingVersion !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionsListItem(output.LatestMatchingVersion, context) : undefined,
        LayerArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LayerArn),
        LayerName: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LayerName)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayersReferenceList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1Layer(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionContentOutput = function(output, context) {
    return {
        CodeSha256: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.CodeSha256),
        CodeSize: (0, $d373908f914b3142$export$a883517a83c9c18)(output.CodeSize),
        Location: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Location),
        SigningJobArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningJobArn),
        SigningProfileVersionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.SigningProfileVersionArn)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionsList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionsListItem(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1LayerVersionsListItem = function(output, context) {
    return {
        CompatibleArchitectures: output.CompatibleArchitectures !== undefined && output.CompatibleArchitectures !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleArchitectures(output.CompatibleArchitectures, context) : undefined,
        CompatibleRuntimes: output.CompatibleRuntimes !== undefined && output.CompatibleRuntimes !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1CompatibleRuntimes(output.CompatibleRuntimes, context) : undefined,
        CreatedDate: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.CreatedDate),
        Description: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Description),
        LayerVersionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LayerVersionArn),
        LicenseInfo: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LicenseInfo),
        Version: (0, $d373908f914b3142$export$a883517a83c9c18)(output.Version)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1OnFailure = function(output, context) {
    return {
        Destination: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Destination)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1OnSuccess = function(output, context) {
    return {
        Destination: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Destination)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigListItem(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1ProvisionedConcurrencyConfigListItem = function(output, context) {
    return {
        AllocatedProvisionedConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.AllocatedProvisionedConcurrentExecutions),
        AvailableProvisionedConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.AvailableProvisionedConcurrentExecutions),
        FunctionArn: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.FunctionArn),
        LastModified: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.LastModified),
        RequestedProvisionedConcurrentExecutions: (0, $d373908f914b3142$export$99c64e845cdac9c1)(output.RequestedProvisionedConcurrentExecutions),
        Status: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Status),
        StatusReason: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.StatusReason)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Queues = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SecurityGroupIds = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SelfManagedEventSource = function(output, context) {
    return {
        Endpoints: output.Endpoints !== undefined && output.Endpoints !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1Endpoints(output.Endpoints, context) : undefined
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SigningProfileVersionArns = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfiguration = function(output, context) {
    return {
        Type: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Type),
        URI: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.URI)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfigurations = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return $31426a0b6b5dd4d5$var$deserializeAws_restJson1SourceAccessConfiguration(entry, context);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1StringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1SubnetIds = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Tags = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, acc), (_b = {}, _b[key] = (0, $d373908f914b3142$export$7ed80f53fe336639)(value), _b));
    }, {});
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1Topics = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, $d373908f914b3142$export$7ed80f53fe336639)(entry);
    });
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1TracingConfigResponse = function(output, context) {
    return {
        Mode: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.Mode)
    };
};
var $31426a0b6b5dd4d5$var$deserializeAws_restJson1VpcConfigResponse = function(output, context) {
    return {
        SecurityGroupIds: output.SecurityGroupIds !== undefined && output.SecurityGroupIds !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1SecurityGroupIds(output.SecurityGroupIds, context) : undefined,
        SubnetIds: output.SubnetIds !== undefined && output.SubnetIds !== null ? $31426a0b6b5dd4d5$var$deserializeAws_restJson1SubnetIds(output.SubnetIds, context) : undefined,
        VpcId: (0, $d373908f914b3142$export$7ed80f53fe336639)(output.VpcId)
    };
};
var $31426a0b6b5dd4d5$var$deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var $31426a0b6b5dd4d5$var$collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var $31426a0b6b5dd4d5$var$collectBodyString = function(streamBody, context) {
    return $31426a0b6b5dd4d5$var$collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var $31426a0b6b5dd4d5$var$isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var $31426a0b6b5dd4d5$var$parseBody = function(streamBody, context) {
    return $31426a0b6b5dd4d5$var$collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var $31426a0b6b5dd4d5$var$loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};


var $27326b8b1b9eeae1$export$6d4ded5fb4d98802 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(AddLayerVersionPermissionCommand, _super);
    function AddLayerVersionPermissionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    AddLayerVersionPermissionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "AddLayerVersionPermissionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$21bfd8a67506ea3f).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$793511edc005a315).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AddLayerVersionPermissionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$50ab8fc0130f057f)(input, context);
    };
    AddLayerVersionPermissionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$2d8302aa55d70656)(output, context);
    };
    return AddLayerVersionPermissionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $1ecfbada878804e8$export$479ba83b03cbef1 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(AddPermissionCommand, _super);
    function AddPermissionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    AddPermissionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "AddPermissionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$581b3b7a57ba467).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$1d7437b794e76ce5).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AddPermissionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$fa7f0a80dacc84e3)(input, context);
    };
    AddPermissionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$e3f5a82b6d9ab13)(output, context);
    };
    return AddPermissionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $14fc4a9e593f64ea$export$b263925caf9658c2 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CreateAliasCommand, _super);
    function CreateAliasCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    CreateAliasCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "CreateAliasCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$c58af87b75ecf7a5).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$738661b98c29d5f3).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateAliasCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$9feab209c0beec)(input, context);
    };
    CreateAliasCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$f6394cff9f10654b)(output, context);
    };
    return CreateAliasCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $634a5eca868b0d10$export$1122e0fa4be4ded = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CreateCodeSigningConfigCommand, _super);
    function CreateCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    CreateCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "CreateCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$1f68b0e1065942fc).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$ef627e338245be2a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$b089d0f0aa115e7)(input, context);
    };
    CreateCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$9dff897d6e960ce1)(output, context);
    };
    return CreateCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $efc13640e6bbe445$export$d87a16268be35ff4 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CreateEventSourceMappingCommand, _super);
    function CreateEventSourceMappingCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    CreateEventSourceMappingCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "CreateEventSourceMappingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$4e544eb76d8399b6).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$bea98d62d0f9352a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateEventSourceMappingCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$1f678d3a78ba68f7)(input, context);
    };
    CreateEventSourceMappingCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$ff666214b1cad020)(output, context);
    };
    return CreateEventSourceMappingCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $58d849f8fbc452a2$export$7cfaf28ab5c5858e = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CreateFunctionCommand, _super);
    function CreateFunctionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    CreateFunctionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "CreateFunctionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$6d7c9efbf53fb03).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$77c29ca1369b0424).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateFunctionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$ab6835b10ab5f84e)(input, context);
    };
    CreateFunctionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$a5efaed75be5bb24)(output, context);
    };
    return CreateFunctionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $86c2186271accbd5$export$18db2a2089aa2b51 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteAliasCommand, _super);
    function DeleteAliasCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteAliasCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteAliasCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$5686e546a03159a4).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteAliasCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$69c976a7e7772be)(input, context);
    };
    DeleteAliasCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$53dadd823dee4a9a)(output, context);
    };
    return DeleteAliasCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $9eb876fbfacb658c$export$d7be7ef06e2fa3a3 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteCodeSigningConfigCommand, _super);
    function DeleteCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$714e1fd4257568b2).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$cfe512564392d015).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$14618ec44c9fdb54)(input, context);
    };
    DeleteCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$d9fb105d3c695987)(output, context);
    };
    return DeleteCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $7b09bbabe75c4dc6$export$83586502c21f36a6 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteEventSourceMappingCommand, _super);
    function DeleteEventSourceMappingCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteEventSourceMappingCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteEventSourceMappingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ec78edb5283f5665).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$bea98d62d0f9352a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteEventSourceMappingCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$326cd5557d527201)(input, context);
    };
    DeleteEventSourceMappingCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$8a6770be1cb95bfb)(output, context);
    };
    return DeleteEventSourceMappingCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $78aa0eb7ce83d64c$export$9191e6e6797aa8b9 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteFunctionCodeSigningConfigCommand, _super);
    function DeleteFunctionCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteFunctionCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteFunctionCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$3af73caf2ddfb7a5).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteFunctionCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$6c4fa00e50223ed6)(input, context);
    };
    DeleteFunctionCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$de76e87603541c41)(output, context);
    };
    return DeleteFunctionCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $0f6b0ef347b1fc25$export$45f6e1f438773d4b = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteFunctionCommand, _super);
    function DeleteFunctionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteFunctionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteFunctionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ff218600f6df7d42).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteFunctionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$537cfb64330b1e33)(input, context);
    };
    DeleteFunctionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$ee4348941ed1475b)(output, context);
    };
    return DeleteFunctionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $268703dfa400bf53$export$e207b5529cb851cb = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteFunctionConcurrencyCommand, _super);
    function DeleteFunctionConcurrencyCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteFunctionConcurrencyCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteFunctionConcurrencyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$200898163a5d59ba).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteFunctionConcurrencyCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$8e350abe9de9192a)(input, context);
    };
    DeleteFunctionConcurrencyCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$37a9c651d3333554)(output, context);
    };
    return DeleteFunctionConcurrencyCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $62515c04cb5a498b$export$ef7330dcea336d30 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteFunctionEventInvokeConfigCommand, _super);
    function DeleteFunctionEventInvokeConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteFunctionEventInvokeConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteFunctionEventInvokeConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$b74d0d33cad61f21).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteFunctionEventInvokeConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$4c7c676b470df533)(input, context);
    };
    DeleteFunctionEventInvokeConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$a6e4ab2749924cdb)(output, context);
    };
    return DeleteFunctionEventInvokeConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $5b5831ef1ae568a0$export$80393674cd99c194 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteLayerVersionCommand, _super);
    function DeleteLayerVersionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteLayerVersionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteLayerVersionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$8b64e9ac6fe57546).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteLayerVersionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$b5a3fa138e2aab71)(input, context);
    };
    DeleteLayerVersionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$94098d253ae99569)(output, context);
    };
    return DeleteLayerVersionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $ac781fc805e7196b$export$8a0fc07fad2f970a = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(DeleteProvisionedConcurrencyConfigCommand, _super);
    function DeleteProvisionedConcurrencyConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    DeleteProvisionedConcurrencyConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "DeleteProvisionedConcurrencyConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$c549984138db33a8).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteProvisionedConcurrencyConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$ac0f1d2de92153e)(input, context);
    };
    DeleteProvisionedConcurrencyConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$72dbbab778895ee6)(output, context);
    };
    return DeleteProvisionedConcurrencyConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $1372a672b6b0264a$export$19c97e07b315ed82 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetAccountSettingsCommand, _super);
    function GetAccountSettingsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetAccountSettingsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetAccountSettingsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$f5b9ce1e4b5d4889).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$beb557a0c36f99e2).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetAccountSettingsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$a3ba9a54bc002e59)(input, context);
    };
    GetAccountSettingsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$53d3725df2739baf)(output, context);
    };
    return GetAccountSettingsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $4c812025b449711f$export$89f3e3fa58a580ca = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetAliasCommand, _super);
    function GetAliasCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetAliasCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetAliasCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$9def75b8730f5e27).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$738661b98c29d5f3).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetAliasCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$3c51941544a32e62)(input, context);
    };
    GetAliasCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$f85a9394759c2075)(output, context);
    };
    return GetAliasCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $9c9ce80d64037fa9$export$7fe2699f5ae33b3d = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetCodeSigningConfigCommand, _super);
    function GetCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$c47eeeaa76be3ed6).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$6ceeafd017e5201).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$7493fbbad579298c)(input, context);
    };
    GetCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$da8dd98f84f758c3)(output, context);
    };
    return GetCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $f237a2d2f0e9284d$export$f8ff3747bc31246a = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetEventSourceMappingCommand, _super);
    function GetEventSourceMappingCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetEventSourceMappingCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetEventSourceMappingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$a55db64ba319d08e).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$bea98d62d0f9352a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetEventSourceMappingCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$c61dd1f3df4548ab)(input, context);
    };
    GetEventSourceMappingCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$b11f9cf6e196ea9d)(output, context);
    };
    return GetEventSourceMappingCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $995c7ae1bb95769e$export$a63c49257d994f9e = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetFunctionCodeSigningConfigCommand, _super);
    function GetFunctionCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetFunctionCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetFunctionCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$6fafcb555a465d51).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$9cf101e81b899df2).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFunctionCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$7ba60d67a4914fb2)(input, context);
    };
    GetFunctionCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$62601069b35f17e3)(output, context);
    };
    return GetFunctionCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $8db88e707336ef9c$export$73dffa3bd10e5612 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetFunctionCommand, _super);
    function GetFunctionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetFunctionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetFunctionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ffe50d3f579a2754).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$403dd55007e7f3f0).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFunctionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$8f396438c5c5fc10)(input, context);
    };
    GetFunctionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$b4168c00ac945891)(output, context);
    };
    return GetFunctionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $68d174baae83bedd$export$df6f868d7bc1de49 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetFunctionConcurrencyCommand, _super);
    function GetFunctionConcurrencyCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetFunctionConcurrencyCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetFunctionConcurrencyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$bc80ae776629cd53).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$8019dfef0406d964).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFunctionConcurrencyCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$c1f2e92136d21c65)(input, context);
    };
    GetFunctionConcurrencyCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$dc395718a4a1096)(output, context);
    };
    return GetFunctionConcurrencyCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $e2efe58f777ae3f3$export$e8a6399e3916ed4f = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetFunctionConfigurationCommand, _super);
    function GetFunctionConfigurationCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetFunctionConfigurationCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetFunctionConfigurationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ac1c188610d95412).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$77c29ca1369b0424).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFunctionConfigurationCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$4c358f8ec33f718d)(input, context);
    };
    GetFunctionConfigurationCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$7c519ebcc9ba2705)(output, context);
    };
    return GetFunctionConfigurationCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $da40b9130bac0880$export$41b3813be9434493 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetFunctionEventInvokeConfigCommand, _super);
    function GetFunctionEventInvokeConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetFunctionEventInvokeConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetFunctionEventInvokeConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$894802e88e2ce146).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$d6d46fb7021cad77).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFunctionEventInvokeConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$9dad1e5bfaafe04e)(input, context);
    };
    GetFunctionEventInvokeConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$7fc63f9bfcd6ff9c)(output, context);
    };
    return GetFunctionEventInvokeConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $981f99e7e0acd88a$export$9a85e58df045c005 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetLayerVersionByArnCommand, _super);
    function GetLayerVersionByArnCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetLayerVersionByArnCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetLayerVersionByArnCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$3c7298a8a5fe9a2a).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$74a59fd51236254f).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLayerVersionByArnCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$be87d424586b307b)(input, context);
    };
    GetLayerVersionByArnCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$df8b3ace918307f7)(output, context);
    };
    return GetLayerVersionByArnCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $bd2453a88f99a83a$export$5f3db98d0a943d80 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetLayerVersionCommand, _super);
    function GetLayerVersionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetLayerVersionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetLayerVersionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$94c7817b9e35b3d4).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$74a59fd51236254f).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLayerVersionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$a0a3d3f07e9e5bc)(input, context);
    };
    GetLayerVersionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$eb5b766553c8e375)(output, context);
    };
    return GetLayerVersionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $f779aaa91c612c16$export$66f6f73b29b70e90 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetLayerVersionPolicyCommand, _super);
    function GetLayerVersionPolicyCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetLayerVersionPolicyCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetLayerVersionPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$9853d5835a690fec).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$f4a64cbb912de531).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLayerVersionPolicyCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$ebf0bd6654eb032c)(input, context);
    };
    GetLayerVersionPolicyCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$631e1a1a637d3680)(output, context);
    };
    return GetLayerVersionPolicyCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $85e68f0c782afd35$export$c646230d336e898 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetPolicyCommand, _super);
    function GetPolicyCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetPolicyCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$50137def283dfb47).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$486587a1f8559efb).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPolicyCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$13faeea1eea217dc)(input, context);
    };
    GetPolicyCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$ac035227ff1f4ffa)(output, context);
    };
    return GetPolicyCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $60a9384caea146ee$export$d2d27e48c226c354 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(GetProvisionedConcurrencyConfigCommand, _super);
    function GetProvisionedConcurrencyConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetProvisionedConcurrencyConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "GetProvisionedConcurrencyConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$30fb6ef013b81688).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$e03070d72fb8c16b).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetProvisionedConcurrencyConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$d1a4a195ebd76669)(input, context);
    };
    GetProvisionedConcurrencyConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$733d7d8229b9ebae)(output, context);
    };
    return GetProvisionedConcurrencyConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $dd80c8109957e769$export$2aef6052fd4cdddb = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(InvokeAsyncCommand, _super);
    function InvokeAsyncCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    InvokeAsyncCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "InvokeAsyncCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$68aea02abc456157).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$a4addf28694a260).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    InvokeAsyncCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$37fcffccb08deb25)(input, context);
    };
    InvokeAsyncCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$9ab24a5c56e40643)(output, context);
    };
    return InvokeAsyncCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $99531c6f261f8a07$export$67bdac3ca73971d3 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(InvokeCommand, _super);
    function InvokeCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    InvokeCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "InvokeCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ec5d8117ba2cf562).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$2a63c89905f1de62).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    InvokeCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$46f3d7ab2a840ae7)(input, context);
    };
    InvokeCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$cb13477dcc449611)(output, context);
    };
    return InvokeCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $b39aa3032c1956fe$export$edbfa2874c857910 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListAliasesCommand, _super);
    function ListAliasesCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListAliasesCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListAliasesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$bf459c654ea6beba).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$b7cda41660b182df).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListAliasesCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$aec3ffa32b6c9e1b)(input, context);
    };
    ListAliasesCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$6dc8096171e81942)(output, context);
    };
    return ListAliasesCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $2b206c65d98f24fc$export$79b71544a0374aab = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListCodeSigningConfigsCommand, _super);
    function ListCodeSigningConfigsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListCodeSigningConfigsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListCodeSigningConfigsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$b185406a9855801b).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$61dbda21c299e39a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListCodeSigningConfigsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$589e7b4ab3731041)(input, context);
    };
    ListCodeSigningConfigsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$60cfd8f781d40700)(output, context);
    };
    return ListCodeSigningConfigsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $d954adce5715f0c9$export$8558d0826a502b62 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListEventSourceMappingsCommand, _super);
    function ListEventSourceMappingsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListEventSourceMappingsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListEventSourceMappingsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$bb9861089d9eff87).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$bed4c84a74c02b99).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListEventSourceMappingsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$51ba9350940d1e4e)(input, context);
    };
    ListEventSourceMappingsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$d38b889274af2c72)(output, context);
    };
    return ListEventSourceMappingsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $a6e658f6147cc147$export$9bd8785598fc394b = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListFunctionEventInvokeConfigsCommand, _super);
    function ListFunctionEventInvokeConfigsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListFunctionEventInvokeConfigsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListFunctionEventInvokeConfigsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$b21750a41a3f49f8).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$c07c9da2ff1f4435).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListFunctionEventInvokeConfigsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$73d0272bcafba044)(input, context);
    };
    ListFunctionEventInvokeConfigsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$7a4e3697c63f58c8)(output, context);
    };
    return ListFunctionEventInvokeConfigsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $9e2d8a5d119e0ce3$export$fb1019bd3522403a = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListFunctionsByCodeSigningConfigCommand, _super);
    function ListFunctionsByCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListFunctionsByCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListFunctionsByCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$96d969e7b42135e9).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$ec3f293d1cb17e30).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListFunctionsByCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$169c8f2b3b203677)(input, context);
    };
    ListFunctionsByCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$72b86f759c715f1c)(output, context);
    };
    return ListFunctionsByCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $cfa20f8278232d78$export$4d04cd626f6c7d2b = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListFunctionsCommand, _super);
    function ListFunctionsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListFunctionsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListFunctionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$9255ed105e8da54c).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$e3ada903b16e0858).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListFunctionsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$da80a4c1645ae823)(input, context);
    };
    ListFunctionsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$67a1964f8539f1e6)(output, context);
    };
    return ListFunctionsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $ec7e67021c118a70$export$abe0e5d7c1ca7943 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListLayersCommand, _super);
    function ListLayersCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListLayersCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListLayersCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$6cef31b601595b63).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$950bdac550b0a9a1).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListLayersCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$bb1f04de871cebd0)(input, context);
    };
    ListLayersCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$c88fb183f27eebdb)(output, context);
    };
    return ListLayersCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $b5182c8e2a414ebf$export$1c1e8573126853e1 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListLayerVersionsCommand, _super);
    function ListLayerVersionsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListLayerVersionsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListLayerVersionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$4c7e618b590a0470).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$b079b2514f5405b9).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListLayerVersionsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$2312a37b77fd3b21)(input, context);
    };
    ListLayerVersionsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$c4a5d8a3a4325dbd)(output, context);
    };
    return ListLayerVersionsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $0a28ae9ebf82b0d1$export$dac8ddb0f6fb95a9 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListProvisionedConcurrencyConfigsCommand, _super);
    function ListProvisionedConcurrencyConfigsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListProvisionedConcurrencyConfigsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListProvisionedConcurrencyConfigsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$cc4ce11b74f7c237).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$845673afc41a57b1).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListProvisionedConcurrencyConfigsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$10ba5ac6551c8159)(input, context);
    };
    ListProvisionedConcurrencyConfigsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$799472bb62e1687c)(output, context);
    };
    return ListProvisionedConcurrencyConfigsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $f231298ba1a9c1b9$export$1748de84b49aa898 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListTagsCommand, _super);
    function ListTagsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListTagsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListTagsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$85bf8bedf74a0bff).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$e78af42e582805d0).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListTagsCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$5ef66abcc7d53268)(input, context);
    };
    ListTagsCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$62c68cf64814f5dd)(output, context);
    };
    return ListTagsCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $3aa462a7cfc256ea$export$f07cd5007db89e2f = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ListVersionsByFunctionCommand, _super);
    function ListVersionsByFunctionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListVersionsByFunctionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "ListVersionsByFunctionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$2dba86d796da12e0).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$9266539b0fb2643c).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListVersionsByFunctionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$f535b568eed5a0ca)(input, context);
    };
    ListVersionsByFunctionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$efa8329bd05197d9)(output, context);
    };
    return ListVersionsByFunctionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $3603f9e0bd0da21a$export$e00ed4a069494fe0 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PublishLayerVersionCommand, _super);
    function PublishLayerVersionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PublishLayerVersionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PublishLayerVersionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$7a91b3034908716e).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$dc2f4218af5f3677).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PublishLayerVersionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$32a001ab47e4fa9)(input, context);
    };
    PublishLayerVersionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$ee3b77b7dc7ccb1a)(output, context);
    };
    return PublishLayerVersionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $71c493eeb344483e$export$d4c2f9de5fbd4bf2 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PublishVersionCommand, _super);
    function PublishVersionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PublishVersionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PublishVersionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$c7599fd2029ad5f9).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$77c29ca1369b0424).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PublishVersionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$aaa845593e157cda)(input, context);
    };
    PublishVersionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$c8619599bc1f97a9)(output, context);
    };
    return PublishVersionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $6c4493f39b4fa7fa$export$56dffd0f4b2e455f = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PutFunctionCodeSigningConfigCommand, _super);
    function PutFunctionCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutFunctionCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PutFunctionCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$d9ee6767c4988e20).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$13d16e7a97ce7527).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutFunctionCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$a9c0ebf270686fec)(input, context);
    };
    PutFunctionCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$b106259e75e5a744)(output, context);
    };
    return PutFunctionCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $464f243fba7da85e$export$58cac2be30cc1455 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PutFunctionConcurrencyCommand, _super);
    function PutFunctionConcurrencyCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutFunctionConcurrencyCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PutFunctionConcurrencyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$7c6fc4c9328cc4ca).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$8d5e30ed7774012f).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutFunctionConcurrencyCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$8a865cdaa858929b)(input, context);
    };
    PutFunctionConcurrencyCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$bd67a03b6410d854)(output, context);
    };
    return PutFunctionConcurrencyCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $47f1b896cc2c3d36$export$83815fcc4fcf2f7e = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PutFunctionEventInvokeConfigCommand, _super);
    function PutFunctionEventInvokeConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutFunctionEventInvokeConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PutFunctionEventInvokeConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$a76c7573469f03e4).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$d6d46fb7021cad77).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutFunctionEventInvokeConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$a045b899cf174599)(input, context);
    };
    PutFunctionEventInvokeConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$c9e7ac89588d3e99)(output, context);
    };
    return PutFunctionEventInvokeConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $dd113369310f3ef6$export$7bae26f7d9f06082 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(PutProvisionedConcurrencyConfigCommand, _super);
    function PutProvisionedConcurrencyConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutProvisionedConcurrencyConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "PutProvisionedConcurrencyConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$d9ae93a0e1fcaaa2).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$e04b0965a7594372).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutProvisionedConcurrencyConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$cad27f74846fb413)(input, context);
    };
    PutProvisionedConcurrencyConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$918326d3a4269f01)(output, context);
    };
    return PutProvisionedConcurrencyConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $b69f3c369c122ab7$export$6f77f8d7c7a12ea4 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(RemoveLayerVersionPermissionCommand, _super);
    function RemoveLayerVersionPermissionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    RemoveLayerVersionPermissionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "RemoveLayerVersionPermissionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$ea612e71d74e701e).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RemoveLayerVersionPermissionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$e7a5d4305b8fcdec)(input, context);
    };
    RemoveLayerVersionPermissionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$243198eaeb6cfcbf)(output, context);
    };
    return RemoveLayerVersionPermissionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $38b389e988f504a5$export$c9673d05f69ca8cc = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(RemovePermissionCommand, _super);
    function RemovePermissionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    RemovePermissionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "RemovePermissionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$6742908bdad17700).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RemovePermissionCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$6e5dcb61a961cef6)(input, context);
    };
    RemovePermissionCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$8a9ec0a287c07a4c)(output, context);
    };
    return RemovePermissionCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $fe96cf3aad140d1a$export$9491ffa65c9235d8 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(TagResourceCommand, _super);
    function TagResourceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    TagResourceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "TagResourceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$bf890a678e449fc2).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    TagResourceCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$1c72a77624ba49d0)(input, context);
    };
    TagResourceCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$6af06c2db34dbab7)(output, context);
    };
    return TagResourceCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $e6e6132e33294a1c$export$ed311643165f836c = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UntagResourceCommand, _super);
    function UntagResourceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UntagResourceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UntagResourceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$7ebb14554e37eb78).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UntagResourceCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$5ca231b23a53f7a6)(input, context);
    };
    UntagResourceCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$fddea5ff3cc15b1a)(output, context);
    };
    return UntagResourceCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $31c68b794d40cfa1$export$e5f03d53bdebd5d6 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateAliasCommand, _super);
    function UpdateAliasCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateAliasCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateAliasCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$9f2a49088d99d9c4).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$738661b98c29d5f3).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateAliasCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$12057f671f8dfb92)(input, context);
    };
    UpdateAliasCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$e84afa5507fc90b3)(output, context);
    };
    return UpdateAliasCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $820c0606f9529ac8$export$c647e9817422a02f = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateCodeSigningConfigCommand, _super);
    function UpdateCodeSigningConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateCodeSigningConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateCodeSigningConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$a7509f1cb2a520ce).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$de8c903f7fb8f4e0).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateCodeSigningConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$2f0674758dceed79)(input, context);
    };
    UpdateCodeSigningConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$85a9f5c7539c25b6)(output, context);
    };
    return UpdateCodeSigningConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $662180b5b47d3d7f$export$531a44639889399c = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateEventSourceMappingCommand, _super);
    function UpdateEventSourceMappingCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateEventSourceMappingCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateEventSourceMappingCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$76fcca36bf5a853a).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$bea98d62d0f9352a).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateEventSourceMappingCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$1e31b973fa691bee)(input, context);
    };
    UpdateEventSourceMappingCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$62ff613092b85e2c)(output, context);
    };
    return UpdateEventSourceMappingCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $d4b5b94a12cdb368$export$a810d8e7173f6680 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateFunctionCodeCommand, _super);
    function UpdateFunctionCodeCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateFunctionCodeCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateFunctionCodeCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$7a1726fb2558bfff).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$77c29ca1369b0424).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateFunctionCodeCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$c6072fe2e98661c5)(input, context);
    };
    UpdateFunctionCodeCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$d4cc2fb5514058ce)(output, context);
    };
    return UpdateFunctionCodeCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $9770c5307e6e39ab$export$c5fcd08713383766 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateFunctionConfigurationCommand, _super);
    function UpdateFunctionConfigurationCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateFunctionConfigurationCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateFunctionConfigurationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$e50ee5f4906afcc3).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$77c29ca1369b0424).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateFunctionConfigurationCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$63ceba8eda3d9965)(input, context);
    };
    UpdateFunctionConfigurationCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$4d5280dd99946dd0)(output, context);
    };
    return UpdateFunctionConfigurationCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));







var $31f7b02edd208340$export$92e1f48f57caa6a = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(UpdateFunctionEventInvokeConfigCommand, _super);
    function UpdateFunctionEventInvokeConfigCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    UpdateFunctionEventInvokeConfigCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, $3df3fd5adbf9b435$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LambdaClient";
        var commandName = "UpdateFunctionEventInvokeConfigCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $21abd87643c491e1$export$1f2bfd4d65d92927).filterSensitiveLog,
            outputFilterSensitiveLog: (0, $21abd87643c491e1$export$d6d46fb7021cad77).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateFunctionEventInvokeConfigCommand.prototype.serialize = function(input, context) {
        return (0, $31426a0b6b5dd4d5$export$ac5ed6d6a6aab598)(input, context);
    };
    UpdateFunctionEventInvokeConfigCommand.prototype.deserialize = function(output, context) {
        return (0, $31426a0b6b5dd4d5$export$7ac2ddaab57fa61e)(output, context);
    };
    return UpdateFunctionEventInvokeConfigCommand;
}((0, $2248e4fb6d6fe346$export$cc7e12c76513e857));




var $4c032d4e8c022b9c$export$57470ceb5d0ada23 = function(_a) {
    var endpoint = _a.endpoint, urlParser = _a.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};


var $e46d9e8d01480687$export$6cd750975e36686c = function(input) {
    var _a;
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, $4c032d4e8c022b9c$export$57470ceb5d0ada23)(input),
        isCustomEndpoint: true
    });
};




var $c2469b786ae364ca$export$c69bd155af41e6f1 = function(input) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};



var $4eb1386dde5b735c$export$24f352b1bd1e2f8b = function(input) {
    var _a;
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? (0, $4c032d4e8c022b9c$export$57470ceb5d0ada23)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
            endpoint: input.endpoint
        })) : function() {
            return (0, $c2469b786ae364ca$export$c69bd155af41e6f1)(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};




var $6022049127c63550$export$26513716e2900bad = "AWS_REGION";
var $6022049127c63550$export$8afb1c306a7d01b = "region";
var $6022049127c63550$export$1509d3ea54119a08 = {
    environmentVariableSelector: function(env) {
        return env[$6022049127c63550$export$26513716e2900bad];
    },
    configFileSelector: function(profile) {
        return profile[$6022049127c63550$export$8afb1c306a7d01b];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var $6022049127c63550$export$9a37503ca194454d = {
    preferredFile: "credentials"
};



var $080a7074e4c19d2d$export$15694b6e9afb7349 = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};


var $464516bd441a29af$export$7696ef37558bd0ec = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        region: (0, $080a7074e4c19d2d$export$15694b6e9afb7349)(input.region)
    });
};





var $d089f28a48bc4157$export$2ba1c8e181ae49f8 = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};


var $4e7b375aa1e45dac$var$AWS_TEMPLATE = "{signingService}.{region}.amazonaws.com";
var $4e7b375aa1e45dac$export$eb6f47c311bb0b54 = function(region, _a) {
    var _b, _c;
    var signingService = _a.signingService, partitionHash = _a.partitionHash;
    return (_c = (_b = partitionHash[(0, $d089f28a48bc4157$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    })]) === null || _b === void 0 ? void 0 : _b.hostname) !== null && _c !== void 0 ? _c : $4e7b375aa1e45dac$var$AWS_TEMPLATE.replace("{signingService}", signingService);
};


var $3746e830c52d697c$export$d062b2a57a5d579b = function(region, _a) {
    var _b, _c;
    var signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    return (_c = (_b = regionHash[region]) === null || _b === void 0 ? void 0 : _b.hostname) !== null && _c !== void 0 ? _c : (0, $4e7b375aa1e45dac$export$eb6f47c311bb0b54)(region, {
        signingService: signingService,
        partitionHash: partitionHash
    }).replace("{region}", region);
};



var $93f7e604c69bfb04$export$2b789d827caebed0 = function(region, _a) {
    var _b, _c, _d, _e;
    var signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, $d089f28a48bc4157$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({
        partition: partition,
        signingService: signingService,
        hostname: (0, $3746e830c52d697c$export$d062b2a57a5d579b)(resolvedRegion, {
            signingService: signingService,
            regionHash: regionHash,
            partitionHash: partitionHash
        })
    }, ((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.signingRegion) && {
        signingRegion: regionHash[resolvedRegion].signingRegion
    }), ((_e = regionHash[resolvedRegion]) === null || _e === void 0 ? void 0 : _e.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};








var $1035a3c80ab33309$var$CONTENT_LENGTH_HEADER = "content-length";
function $1035a3c80ab33309$export$940b29eb2788b975(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
                    request = args.request;
                    if ((0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf($1035a3c80ab33309$var$CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, request.headers), (_a = {}, _a[$1035a3c80ab33309$var$CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2,
                        next((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var $1035a3c80ab33309$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var $1035a3c80ab33309$export$7e6ddf9365a30fe9 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($1035a3c80ab33309$export$940b29eb2788b975(options.bodyLengthChecker), $1035a3c80ab33309$export$1f7816f8f350b2f5);
        }
    };
};




function $8ca56bb2b455546f$export$c1625bf0b32b4481(input) {
    return input;
}
var $8ca56bb2b455546f$export$858685d7aeef192d = function(options) {
    return function(next) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
                    if (!(0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $8ca56bb2b455546f$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var $8ca56bb2b455546f$export$23d3b647211be53a = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($8ca56bb2b455546f$export$858685d7aeef192d(options), $8ca56bb2b455546f$export$696d244ba96181e8);
        }
    };
};



var $9296ba62fc209330$export$fe0e777ee4f58cde = function() {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var $9296ba62fc209330$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var $9296ba62fc209330$export$f6ef65d7766fc255 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($9296ba62fc209330$export$fe0e777ee4f58cde(), $9296ba62fc209330$export$877c148ab4ad0722);
        }
    };
};





var $c4a280001fe18458$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($c4a280001fe18458$export$6842199fccd474d3 || ($c4a280001fe18458$export$6842199fccd474d3 = {}));
var $c4a280001fe18458$export$2c7e51f38ba5a406 = 3;
var $c4a280001fe18458$export$41315747b7c5d042 = $c4a280001fe18458$export$6842199fccd474d3.STANDARD;



var $9df24a04fc7790ce$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var $9df24a04fc7790ce$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var $9df24a04fc7790ce$export$18bd3bfe89ded398 = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var $9df24a04fc7790ce$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];


var $20036f3ab583ac6b$export$46428803f4bd8a0c = function(error) {
    return error.$retryable !== undefined;
};
var $20036f3ab583ac6b$export$7b87435661177a94 = function(error) {
    return (0, $9df24a04fc7790ce$export$9fde012b8b2a10ca).includes(error.name);
};
var $20036f3ab583ac6b$export$cbecb89f6256ccc8 = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, $9df24a04fc7790ce$export$89cd1b0ccfcb99d).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var $20036f3ab583ac6b$export$31778435da988512 = function(error) {
    var _a;
    return (0, $9df24a04fc7790ce$export$18bd3bfe89ded398).includes(error.name) || (0, $9df24a04fc7790ce$export$38bf589d26009e4f).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};


var $4d7c8adc1ca36b4b$export$4d4bb1390e4746c4 = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var delay_1;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, $20036f3ab583ac6b$export$cbecb89f6256ccc8)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();





// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $46eeb1e02f1e5541$var$getRandomValues;
var $46eeb1e02f1e5541$var$rnds8 = new Uint8Array(16);
function $46eeb1e02f1e5541$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$46eeb1e02f1e5541$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $46eeb1e02f1e5541$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$46eeb1e02f1e5541$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $46eeb1e02f1e5541$var$getRandomValues($46eeb1e02f1e5541$var$rnds8);
}


var $c1b2e6f78b0e4998$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $9080356786fb0da7$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $c1b2e6f78b0e4998$export$2e2bcd8739ae039).test(uuid);
}
var $9080356786fb0da7$export$2e2bcd8739ae039 = $9080356786fb0da7$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $dfc2c0e9ab701411$var$byteToHex = [];
for(var $dfc2c0e9ab701411$var$i = 0; $dfc2c0e9ab701411$var$i < 256; ++$dfc2c0e9ab701411$var$i)$dfc2c0e9ab701411$var$byteToHex.push(($dfc2c0e9ab701411$var$i + 0x100).toString(16).substr(1));
function $dfc2c0e9ab701411$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($dfc2c0e9ab701411$var$byteToHex[arr[offset + 0]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 1]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 2]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 3]] + '-' + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 4]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 5]] + '-' + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 6]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 7]] + '-' + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 8]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 9]] + '-' + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 10]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 11]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 12]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 13]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 14]] + $dfc2c0e9ab701411$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $9080356786fb0da7$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $dfc2c0e9ab701411$export$2e2bcd8739ae039 = $dfc2c0e9ab701411$var$stringify;


function $1c229d3411f646c9$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $46eeb1e02f1e5541$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dfc2c0e9ab701411$export$2e2bcd8739ae039)(rnds);
}
var $1c229d3411f646c9$export$2e2bcd8739ae039 = $1c229d3411f646c9$var$v4;



var $bf2dd85221a0ed66$export$7067ba90effbd789 = 100;
var $bf2dd85221a0ed66$export$2412c80d04e902c6 = 20000;
var $bf2dd85221a0ed66$export$4af31f8250b48e23 = 500;
var $bf2dd85221a0ed66$export$f8c3d11675a1153 = 500;
var $bf2dd85221a0ed66$export$797febae1136bc84 = 5;
var $bf2dd85221a0ed66$export$b643545eaf9af837 = 10;
var $bf2dd85221a0ed66$export$a25da3406dc148e4 = 1;
var $bf2dd85221a0ed66$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
var $bf2dd85221a0ed66$export$d4f764f0ec4f52f = "amz-sdk-request";



var $bc37982bd1f18e91$export$2ebe7988802fc284 = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, $bf2dd85221a0ed66$export$a25da3406dc148e4);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, $bf2dd85221a0ed66$export$797febae1136bc84);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, $bf2dd85221a0ed66$export$b643545eaf9af837);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



var $f81f4179ce2c8596$export$1cddd42598a3b1f6 = function(delayBase, attempts) {
    return Math.floor(Math.min((0, $bf2dd85221a0ed66$export$2412c80d04e902c6), Math.random() * Math.pow(2, attempts) * delayBase));
};



var $0ac248ebad9696e9$export$3839fd261f89ec2 = function(error) {
    if (!error) return false;
    return (0, $20036f3ab583ac6b$export$46428803f4bd8a0c)(error) || (0, $20036f3ab583ac6b$export$7b87435661177a94)(error) || (0, $20036f3ab583ac6b$export$cbecb89f6256ccc8)(error) || (0, $20036f3ab583ac6b$export$31778435da988512)(error);
};


var $2965650888dceda0$export$64af437cce00eae8 = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $c4a280001fe18458$export$6842199fccd474d3).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, $0ac248ebad9696e9$export$3839fd261f89ec2);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, $f81f4179ce2c8596$export$1cddd42598a3b1f6);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, $bc37982bd1f18e91$export$2ebe7988802fc284)((0, $bf2dd85221a0ed66$export$f8c3d11675a1153));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, $c4a280001fe18458$export$2c7e51f38ba5a406);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(request)) request.headers[0, $bf2dd85221a0ed66$export$197fd517bf66ccb2] = (0, $1c229d3411f646c9$export$2e2bcd8739ae039)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delay_1;
                            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(request)) request.headers[0, $bf2dd85221a0ed66$export$d4f764f0ec4f52f] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = $2965650888dceda0$var$asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delay_1 = this_1.delayDecider((0, $20036f3ab583ac6b$export$cbecb89f6256ccc8)(err) ? (0, $bf2dd85221a0ed66$export$4af31f8250b48e23) : (0, $bf2dd85221a0ed66$export$7067ba90effbd789), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var $2965650888dceda0$var$asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for " + error);
};


var $0472ae4e2d1584eb$export$b6f3faf7501de8bc = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, $4d7c8adc1ca36b4b$export$4d4bb1390e4746c4)();
        _this.mode = (0, $c4a280001fe18458$export$6842199fccd474d3).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, $2965650888dceda0$export$64af437cce00eae8));









var $9429c32b51504164$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
var $9429c32b51504164$export$9ae8a04532f798bc = "max_attempts";
var $9429c32b51504164$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: function(env) {
        var value = env[$9429c32b51504164$export$a19952f9e421517c];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + $9429c32b51504164$export$a19952f9e421517c + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[$9429c32b51504164$export$9ae8a04532f798bc];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + $9429c32b51504164$export$9ae8a04532f798bc + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, $c4a280001fe18458$export$2c7e51f38ba5a406)
};
var $9429c32b51504164$export$ca7f6138f2c98476 = function(input) {
    var maxAttempts = $9429c32b51504164$var$normalizeMaxAttempts(input.maxAttempts);
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                $9429c32b51504164$var$getRetryMode(input.retryMode)
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, $c4a280001fe18458$export$6842199fccd474d3).ADAPTIVE) return [
                                2,
                                new (0, $0472ae4e2d1584eb$export$b6f3faf7501de8bc)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, $2965650888dceda0$export$64af437cce00eae8)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var $9429c32b51504164$var$getRetryMode = function(retryMode) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof retryMode === "string") return [
                        2,
                        retryMode
                    ];
                    return [
                        4,
                        retryMode()
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
            }
        });
    });
};
var $9429c32b51504164$var$normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, $c4a280001fe18458$export$2c7e51f38ba5a406);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var $9429c32b51504164$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
var $9429c32b51504164$export$c5c0171a17765aea = "retry_mode";
var $9429c32b51504164$export$972bf2bb01959ff5 = {
    environmentVariableSelector: function(env) {
        return env[$9429c32b51504164$export$4728af91ff39ef3b];
    },
    configFileSelector: function(profile) {
        return profile[$9429c32b51504164$export$c5c0171a17765aea];
    },
    default: (0, $c4a280001fe18458$export$41315747b7c5d042)
};






var $b80cf40ee6003ab8$export$536b11ee0b9c4a95 = function() {
    return function(next) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    request = args.request;
                    if ((0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(request)) {
                        delete request.headers[0, $bf2dd85221a0ed66$export$197fd517bf66ccb2];
                        delete request.headers[0, $bf2dd85221a0ed66$export$d4f764f0ec4f52f];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var $b80cf40ee6003ab8$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var $b80cf40ee6003ab8$export$fa165e6edc16c2a2 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($b80cf40ee6003ab8$export$536b11ee0b9c4a95(), $b80cf40ee6003ab8$export$3ec587d8f35e7a2c);
        }
    };
};




var $24b6d03405692463$export$a3922aa5f87bae85 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(context.userAgent || [])), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ]);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var $24b6d03405692463$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var $24b6d03405692463$export$c73199e2b1df9340 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($24b6d03405692463$export$a3922aa5f87bae85(options), $24b6d03405692463$export$44d3d03587957ce9);
        }
    };
};








var $6c26a34ac31852ce$export$478ec1fdae99aa79 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        Object.defineProperty(error, "tryNextLink", {
            value: tryNextLink,
            configurable: false,
            enumerable: false,
            writable: false
        });
        return error;
    };
    return ProviderError;
}(Error);
var $6c26a34ac31852ce$export$921076535eff0df5 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        return _this;
    }
    CredentialsProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        Object.defineProperty(error, "tryNextLink", {
            value: tryNextLink,
            configurable: false,
            enumerable: false,
            writable: false
        });
        return error;
    };
    return CredentialsProviderError;
}(Error);




function $8139ca863ba17b75$export$e08e3b67e392101e() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, $6c26a34ac31852ce$export$478ec1fdae99aa79)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}


var $39efa2127fbd8e38$export$294ab423a8f4a426 = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};



var $50d5a3eb3eb9f42b$export$fc10aeed3a532e2a = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var coalesceProvider = function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!hasResult) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    var isConstant = false;
    return function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!hasResult) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};





var $40c5b81461142d86$var$SHORT_TO_HEX = {};
var $40c5b81461142d86$var$HEX_TO_SHORT = {};
for(var $40c5b81461142d86$var$i = 0; $40c5b81461142d86$var$i < 256; $40c5b81461142d86$var$i++){
    var $40c5b81461142d86$var$encodedByte = $40c5b81461142d86$var$i.toString(16).toLowerCase();
    if ($40c5b81461142d86$var$encodedByte.length === 1) $40c5b81461142d86$var$encodedByte = "0" + $40c5b81461142d86$var$encodedByte;
    $40c5b81461142d86$var$SHORT_TO_HEX[$40c5b81461142d86$var$i] = $40c5b81461142d86$var$encodedByte;
    $40c5b81461142d86$var$HEX_TO_SHORT[$40c5b81461142d86$var$encodedByte] = $40c5b81461142d86$var$i;
}
function $40c5b81461142d86$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $40c5b81461142d86$var$HEX_TO_SHORT) out[i / 2] = $40c5b81461142d86$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function $40c5b81461142d86$export$7ea66e3774a60b67(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $40c5b81461142d86$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


var $ec91cf4047faf90e$export$186cd8495ba0377d = "X-Amz-Algorithm";
var $ec91cf4047faf90e$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
var $ec91cf4047faf90e$export$6e114beec37430d7 = "X-Amz-Date";
var $ec91cf4047faf90e$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
var $ec91cf4047faf90e$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
var $ec91cf4047faf90e$export$41ae838dc1e0f082 = "X-Amz-Signature";
var $ec91cf4047faf90e$export$8e1383b7eea7bee = "X-Amz-Security-Token";
var $ec91cf4047faf90e$export$296a4bada3fe6343 = "X-Amz-Region-Set";
var $ec91cf4047faf90e$export$9924a64a4b8b0d58 = "authorization";
var $ec91cf4047faf90e$export$acf4b8bdf24aab34 = $ec91cf4047faf90e$export$6e114beec37430d7.toLowerCase();
var $ec91cf4047faf90e$export$c65c8c9f514da472 = "date";
var $ec91cf4047faf90e$export$20d6a73fd0b10982 = [
    $ec91cf4047faf90e$export$9924a64a4b8b0d58,
    $ec91cf4047faf90e$export$acf4b8bdf24aab34,
    $ec91cf4047faf90e$export$c65c8c9f514da472
];
var $ec91cf4047faf90e$export$29961f34c719157e = $ec91cf4047faf90e$export$41ae838dc1e0f082.toLowerCase();
var $ec91cf4047faf90e$export$eaef12179141669a = "x-amz-content-sha256";
var $ec91cf4047faf90e$export$fdc81b663012a8d2 = $ec91cf4047faf90e$export$8e1383b7eea7bee.toLowerCase();
var $ec91cf4047faf90e$export$96307741595055fc = "host";
var $ec91cf4047faf90e$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var $ec91cf4047faf90e$export$8085db98abbe0597 = /^proxy-/;
var $ec91cf4047faf90e$export$758380400526c39 = /^sec-/;
var $ec91cf4047faf90e$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
var $ec91cf4047faf90e$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
var $ec91cf4047faf90e$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
var $ec91cf4047faf90e$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
var $ec91cf4047faf90e$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
var $ec91cf4047faf90e$export$bf665777b4a1722f = 50;
var $ec91cf4047faf90e$export$c4bf0942098f6bb = "aws4_request";
var $ec91cf4047faf90e$export$274df788bdcca184 = 604800;





var $1ed90aeb25d2ac2b$var$signingKeyCache = {};
var $1ed90aeb25d2ac2b$var$cacheQueue = [];
var $1ed90aeb25d2ac2b$export$41a9651decfe2bde = function(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, $ec91cf4047faf90e$export$c4bf0942098f6bb);
};
var $1ed90aeb25d2ac2b$export$8b95a069d16dd783 = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        $1ed90aeb25d2ac2b$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, $40c5b81461142d86$export$7ea66e3774a60b67)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in $1ed90aeb25d2ac2b$var$signingKeyCache) return [
                        2,
                        $1ed90aeb25d2ac2b$var$signingKeyCache[cacheKey]
                    ];
                    $1ed90aeb25d2ac2b$var$cacheQueue.push(cacheKey);
                    while($1ed90aeb25d2ac2b$var$cacheQueue.length > (0, $ec91cf4047faf90e$export$bf665777b4a1722f))delete $1ed90aeb25d2ac2b$var$signingKeyCache[$1ed90aeb25d2ac2b$var$cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)([
                        shortDate,
                        region,
                        service,
                        (0, $ec91cf4047faf90e$export$c4bf0942098f6bb)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        $1ed90aeb25d2ac2b$var$hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        $1ed90aeb25d2ac2b$var$signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var $1ed90aeb25d2ac2b$export$a31b95746ea0a30a = function() {
    $1ed90aeb25d2ac2b$var$cacheQueue.length = 0;
    Object.keys($1ed90aeb25d2ac2b$var$signingKeyCache).forEach(function(cacheKey) {
        delete $1ed90aeb25d2ac2b$var$signingKeyCache[cacheKey];
    });
};
var $1ed90aeb25d2ac2b$var$hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};




var $aa2d941ed4f3bf94$export$859d7f1bb55e2914 = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, $ec91cf4047faf90e$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $ec91cf4047faf90e$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $ec91cf4047faf90e$export$758380400526c39).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};



var $f4c821689df87243$export$c3b4775ad75a73db = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, $f4c821689df87243$var$hexEncode);
};
var $f4c821689df87243$var$hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};



var $205ee8c71fdc95d1$export$547c045505a754ef = function(uri) {
    return uri.split("/").map((0, $f4c821689df87243$export$c3b4775ad75a73db)).join("/");
};





var $e3d75194ac0d50ee$export$8fea7e63ecd1ddbb = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, $ec91cf4047faf90e$export$29961f34c719157e)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, $f4c821689df87243$export$c3b4775ad75a73db)(key) + "=" + (0, $f4c821689df87243$export$c3b4775ad75a73db)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, $f4c821689df87243$export$c3b4775ad75a73db)(key) + "=" + (0, $f4c821689df87243$export$c3b4775ad75a73db)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};



var $c8315cefd2570b92$export$9dd3754ae86f0017 = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};




var $a353fdd34301aeef$export$a46a74202b0efd71 = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, $ec91cf4047faf90e$export$eaef12179141669a)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, $c8315cefd2570b92$export$9dd3754ae86f0017)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, $40c5b81461142d86$export$7ea66e3774a60b67);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, $ec91cf4047faf90e$export$91f7321b40d9fd07)
                    ];
            }
        });
    });
};



var $b39f809ed981e0ed$export$17944590be865217 = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var $b39f809ed981e0ed$export$149b1181d497cd = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var $b39f809ed981e0ed$export$d3408eaf94074c90 = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};




var $22698025bc65d2e5$export$d043aa0bf7223286 = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, $96998cfc8b9d4854$export$3c9a16f847548506)(_a, [
        "headers",
        "query"
    ]);
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, rest), {
        headers: (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, headers),
        query: query ? $22698025bc65d2e5$export$4923819f93729b21(query) : undefined
    });
};
var $22698025bc65d2e5$export$4923819f93729b21 = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(param)) : param, _a));
    }, {});
};


var $8243b66f5b0dd942$export$bfc08a76d4bd60f6 = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, $22698025bc65d2e5$export$d043aa0bf7223286)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, request), {
        headers: headers,
        query: query
    });
};


var $138d3a5081b3294a$export$1bacfccae8c7ec22 = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var $138d3a5081b3294a$export$308dae6ab23ed7c9 = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};





var $f551062ae9b89f90$export$a7cfe9131aa06be4 = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, $22698025bc65d2e5$export$d043aa0bf7223286)(request);
    try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, $ec91cf4047faf90e$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};


var $e5783e3c999a794f$export$b65d57190c224ef2 = function(time) {
    return $e5783e3c999a794f$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var $e5783e3c999a794f$export$e67a095c620b86fe = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


var $20a93269c7c1b65c$export$20baf4d3f65eb30c = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $138d3a5081b3294a$export$1bacfccae8c7ec22)(region);
        this.credentialProvider = (0, $138d3a5081b3294a$export$308dae6ab23ed7c9)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = $20a93269c7c1b65c$var$formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, $ec91cf4047faf90e$export$274df788bdcca184)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, $1ed90aeb25d2ac2b$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, $8243b66f5b0dd942$export$bfc08a76d4bd60f6)((0, $f551062ae9b89f90$export$a7cfe9131aa06be4)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, $ec91cf4047faf90e$export$8e1383b7eea7bee] = credentials.sessionToken;
                        request.query[0, $ec91cf4047faf90e$export$186cd8495ba0377d] = (0, $ec91cf4047faf90e$export$863a63fba5b2ddf5);
                        request.query[0, $ec91cf4047faf90e$export$5c8e6dd7758f59d6] = credentials.accessKeyId + "/" + scope;
                        request.query[0, $ec91cf4047faf90e$export$6e114beec37430d7] = longDate;
                        request.query[0, $ec91cf4047faf90e$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
                        canonicalHeaders = (0, $aa2d941ed4f3bf94$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        request.query[0, $ec91cf4047faf90e$export$2dcbb254f883c238] = $20a93269c7c1b65c$var$getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, $ec91cf4047faf90e$export$41ae838dc1e0f082);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, $a353fdd34301aeef$export$a46a74202b0efd71)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = $20a93269c7c1b65c$var$formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, $1ed90aeb25d2ac2b$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, $a353fdd34301aeef$export$a46a74202b0efd71)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, $40c5b81461142d86$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, $ec91cf4047faf90e$export$9a1f6cf06ac56167),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = $20a93269c7c1b65c$var$formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, $40c5b81461142d86$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, $f551062ae9b89f90$export$a7cfe9131aa06be4)(requestToSign);
                        _e = $20a93269c7c1b65c$var$formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, $1ed90aeb25d2ac2b$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, $ec91cf4047faf90e$export$acf4b8bdf24aab34] = longDate;
                        if (credentials.sessionToken) request.headers[0, $ec91cf4047faf90e$export$fdc81b663012a8d2] = credentials.sessionToken;
                        return [
                            4,
                            (0, $a353fdd34301aeef$export$a46a74202b0efd71)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, $b39f809ed981e0ed$export$17944590be865217)((0, $ec91cf4047faf90e$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $ec91cf4047faf90e$export$eaef12179141669a] = payloadHash;
                        canonicalHeaders = (0, $aa2d941ed4f3bf94$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, $ec91cf4047faf90e$export$9924a64a4b8b0d58] = (0, $ec91cf4047faf90e$export$863a63fba5b2ddf5) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + $20a93269c7c1b65c$var$getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, $e3d75194ac0d50ee$export$8fea7e63ecd1ddbb)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            (0, $ec91cf4047faf90e$export$863a63fba5b2ddf5) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, $40c5b81461142d86$export$7ea66e3774a60b67)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, $40c5b81461142d86$export$7ea66e3774a60b67);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, $1ed90aeb25d2ac2b$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var $20a93269c7c1b65c$var$formatDate = function(now) {
    var longDate = (0, $e5783e3c999a794f$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var $20a93269c7c1b65c$var$getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};











var $c175c88f4444b500$var$CREDENTIAL_EXPIRE_WINDOW = 300000;
var $c175c88f4444b500$export$1dd62920de1feabb = function(input) {
    var normalizedCreds = input.credentials ? $c175c88f4444b500$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = $c175c88f4444b500$var$normalizeProvider(input.signer);
    else signer = function() {
        return $c175c88f4444b500$var$normalizeProvider(input.region)().then(function(region) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var signerConstructor = input.signerConstructor || (0, $20a93269c7c1b65c$export$20baf4d3f65eb30c);
            return new signerConstructor(params);
        });
    };
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var $c175c88f4444b500$export$578a43ebf7e4c675 = function(input) {
    var normalizedCreds = input.credentials ? $c175c88f4444b500$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = $c175c88f4444b500$var$normalizeProvider(input.signer);
    else signer = $c175c88f4444b500$var$normalizeProvider(new (0, $20a93269c7c1b65c$export$20baf4d3f65eb30c)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var $c175c88f4444b500$var$normalizeProvider = function(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
};
var $c175c88f4444b500$var$normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, $50d5a3eb3eb9f42b$export$fc10aeed3a532e2a)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < $c175c88f4444b500$var$CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return $c175c88f4444b500$var$normalizeProvider(credentials);
};




var $d4122525be65c74c$export$86d5c90340985ada = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};



var $826d39607aa469af$export$c162a01d4a03ea6f = function(clockTime, systemClockOffset) {
    return Math.abs((0, $d4122525be65c74c$export$86d5c90340985ada)(systemClockOffset).getTime() - clockTime) >= 300000;
};


var $31991d46a59601ee$export$1ed4d48b860b1348 = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, $826d39607aa469af$export$c162a01d4a03ea6f)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};


var $9853457fe0a473fd$export$78af9708f8cf3422 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
                var signer, output, _a, _b, headers, dateHeader;
                var _c;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_d) {
                    switch(_d.label){
                        case 0:
                            if (!(0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            return [
                                4,
                                options.signer()
                            ];
                        case 1:
                            signer = _d.sent();
                            _a = next;
                            _b = [
                                (0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, args)
                            ];
                            _c = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, $d4122525be65c74c$export$86d5c90340985ada)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _a.apply(void 0, [
                                    (0, $96998cfc8b9d4854$export$18ce0697a983be9b).apply(void 0, _b.concat([
                                        (_c.request = _d.sent(), _c)
                                    ]))
                                ]).catch(function(error) {
                                    if (error.ServerTime) options.systemClockOffset = (0, $31991d46a59601ee$export$1ed4d48b860b1348)(error.ServerTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _d.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) options.systemClockOffset = (0, $31991d46a59601ee$export$1ed4d48b860b1348)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var $9853457fe0a473fd$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var $9853457fe0a473fd$export$59c2b7ad30ed4046 = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo($9853457fe0a473fd$export$78af9708f8cf3422(options), $9853457fe0a473fd$export$29f4b3a6e94017d3);
        }
    };
};
var $9853457fe0a473fd$export$6255ccc0b84310b8 = $9853457fe0a473fd$export$59c2b7ad30ed4046;





function $ac53acb32ff7b4bd$export$ec9a2d5663958cb(input) {
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}




var $1ab9b5cba6aaa3d8$export$97a08a1bb7ee0545 = "user-agent";
var $1ab9b5cba6aaa3d8$export$e010e3d6246262a3 = "x-amz-user-agent";
var $1ab9b5cba6aaa3d8$export$27b7b95a5fde2b31 = " ";
var $1ab9b5cba6aaa3d8$export$92df4a8c4ea32a70 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;


var $b42bfd8572de09d3$export$62c460923941c0b0 = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, $d0707dbdfb3e3b57$export$7587955500404ec3).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map($b42bfd8572de09d3$var$escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map($b42bfd8572de09d3$var$escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map($b42bfd8572de09d3$var$escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(defaultUserAgent)), (0, $96998cfc8b9d4854$export$8d051b38c9118094)(userAgent)), (0, $96998cfc8b9d4854$export$8d051b38c9118094)(customUserAgent)).join((0, $1ab9b5cba6aaa3d8$export$27b7b95a5fde2b31));
                            normalUAValue = (0, $96998cfc8b9d4854$export$1216008129fb82ed)((0, $96998cfc8b9d4854$export$1216008129fb82ed)([], (0, $96998cfc8b9d4854$export$8d051b38c9118094)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }))), (0, $96998cfc8b9d4854$export$8d051b38c9118094)(customUserAgent)).join((0, $1ab9b5cba6aaa3d8$export$27b7b95a5fde2b31));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, $1ab9b5cba6aaa3d8$export$e010e3d6246262a3] = headers[0, $1ab9b5cba6aaa3d8$export$e010e3d6246262a3] ? headers[0, $1ab9b5cba6aaa3d8$export$97a08a1bb7ee0545] + " " + normalUAValue : normalUAValue;
                                headers[0, $1ab9b5cba6aaa3d8$export$97a08a1bb7ee0545] = sdkUserAgentValue;
                            } else headers[0, $1ab9b5cba6aaa3d8$export$e010e3d6246262a3] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var $b42bfd8572de09d3$var$escapeUserAgent = function(_a) {
    var _b = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, $1ab9b5cba6aaa3d8$export$92df4a8c4ea32a70), "_");
    }).join("/");
};
var $b42bfd8572de09d3$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var $b42bfd8572de09d3$export$5393c0d2d7f4f5f0 = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add($b42bfd8572de09d3$export$62c460923941c0b0(config), $b42bfd8572de09d3$export$29eb04da6afef73f);
        }
    };
};






var $3077ef3f1d6290d2$exports = {};
$3077ef3f1d6290d2$exports = JSON.parse("{\"name\":\"@aws-sdk/client-lambda\",\"description\":\"AWS SDK for JavaScript Lambda Client for Node.js, Browser and React Native\",\"version\":\"3.38.0\",\"scripts\":{\"build\":\"yarn build:cjs && yarn build:es && yarn build:types\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:docs\":\"yarn clean:docs && typedoc ./\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:types\":\"tsc -p tsconfig.types.json\",\"clean\":\"yarn clean:dist && yarn clean:docs\",\"clean:dist\":\"rimraf ./dist\",\"clean:docs\":\"rimraf ./docs\",\"downlevel-dts\":\"downlevel-dts dist-types dist-types/ts3.4\",\"test\":\"exit 0\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/client-sts\":\"3.38.0\",\"@aws-sdk/config-resolver\":\"3.38.0\",\"@aws-sdk/credential-provider-node\":\"3.38.0\",\"@aws-sdk/fetch-http-handler\":\"3.38.0\",\"@aws-sdk/hash-node\":\"3.38.0\",\"@aws-sdk/invalid-dependency\":\"3.38.0\",\"@aws-sdk/middleware-content-length\":\"3.38.0\",\"@aws-sdk/middleware-host-header\":\"3.38.0\",\"@aws-sdk/middleware-logger\":\"3.38.0\",\"@aws-sdk/middleware-retry\":\"3.38.0\",\"@aws-sdk/middleware-serde\":\"3.38.0\",\"@aws-sdk/middleware-signing\":\"3.38.0\",\"@aws-sdk/middleware-stack\":\"3.38.0\",\"@aws-sdk/middleware-user-agent\":\"3.38.0\",\"@aws-sdk/node-config-provider\":\"3.38.0\",\"@aws-sdk/node-http-handler\":\"3.38.0\",\"@aws-sdk/protocol-http\":\"3.38.0\",\"@aws-sdk/smithy-client\":\"3.38.0\",\"@aws-sdk/types\":\"3.38.0\",\"@aws-sdk/url-parser\":\"3.38.0\",\"@aws-sdk/util-base64-browser\":\"3.37.0\",\"@aws-sdk/util-base64-node\":\"3.37.0\",\"@aws-sdk/util-body-length-browser\":\"3.37.0\",\"@aws-sdk/util-body-length-node\":\"3.37.0\",\"@aws-sdk/util-user-agent-browser\":\"3.38.0\",\"@aws-sdk/util-user-agent-node\":\"3.38.0\",\"@aws-sdk/util-utf8-browser\":\"3.37.0\",\"@aws-sdk/util-utf8-node\":\"3.37.0\",\"@aws-sdk/util-waiter\":\"3.38.0\",\"tslib\":\"^2.3.0\"},\"devDependencies\":{\"@aws-sdk/service-client-documentation-generator\":\"3.38.0\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"ts-jest\":\"^26.4.1\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.3.5\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lambda\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-lambda\"}}");







function $1564352379cccb72$export$6b17a39e52c8ee53(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, $f4c821689df87243$export$c3b4775ad75a73db)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, $f4c821689df87243$export$c3b4775ad75a73db)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, $f4c821689df87243$export$c3b4775ad75a73db)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}


function $d7551b49f3737608$export$363ac302bdbd807b(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


var $10b1589a7bac016d$export$83588b87edbfa7e0 = function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $1564352379cccb72$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $600777a260ad8290$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                return {
                    response: new (0, $600777a260ad8290$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $d7551b49f3737608$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();



var $2edb6b1d01e33018$var$alphabetByEncoding = {};
var $2edb6b1d01e33018$var$alphabetByValue = new Array(64);
for(var $2edb6b1d01e33018$var$i = 0, $2edb6b1d01e33018$var$start = "A".charCodeAt(0), $2edb6b1d01e33018$var$limit = "Z".charCodeAt(0); $2edb6b1d01e33018$var$i + $2edb6b1d01e33018$var$start <= $2edb6b1d01e33018$var$limit; $2edb6b1d01e33018$var$i++){
    var $2edb6b1d01e33018$var$char = String.fromCharCode($2edb6b1d01e33018$var$i + $2edb6b1d01e33018$var$start);
    $2edb6b1d01e33018$var$alphabetByEncoding[$2edb6b1d01e33018$var$char] = $2edb6b1d01e33018$var$i;
    $2edb6b1d01e33018$var$alphabetByValue[$2edb6b1d01e33018$var$i] = $2edb6b1d01e33018$var$char;
}
for(var $2edb6b1d01e33018$var$i = 0, $2edb6b1d01e33018$var$start = "a".charCodeAt(0), $2edb6b1d01e33018$var$limit = "z".charCodeAt(0); $2edb6b1d01e33018$var$i + $2edb6b1d01e33018$var$start <= $2edb6b1d01e33018$var$limit; $2edb6b1d01e33018$var$i++){
    var $2edb6b1d01e33018$var$char = String.fromCharCode($2edb6b1d01e33018$var$i + $2edb6b1d01e33018$var$start);
    var $2edb6b1d01e33018$var$index = $2edb6b1d01e33018$var$i + 26;
    $2edb6b1d01e33018$var$alphabetByEncoding[$2edb6b1d01e33018$var$char] = $2edb6b1d01e33018$var$index;
    $2edb6b1d01e33018$var$alphabetByValue[$2edb6b1d01e33018$var$index] = $2edb6b1d01e33018$var$char;
}
for(var $2edb6b1d01e33018$var$i = 0; $2edb6b1d01e33018$var$i < 10; $2edb6b1d01e33018$var$i++){
    $2edb6b1d01e33018$var$alphabetByEncoding[$2edb6b1d01e33018$var$i.toString(10)] = $2edb6b1d01e33018$var$i + 52;
    var $2edb6b1d01e33018$var$char = $2edb6b1d01e33018$var$i.toString(10);
    var $2edb6b1d01e33018$var$index = $2edb6b1d01e33018$var$i + 52;
    $2edb6b1d01e33018$var$alphabetByEncoding[$2edb6b1d01e33018$var$char] = $2edb6b1d01e33018$var$index;
    $2edb6b1d01e33018$var$alphabetByValue[$2edb6b1d01e33018$var$index] = $2edb6b1d01e33018$var$char;
}
$2edb6b1d01e33018$var$alphabetByEncoding["+"] = 62;
$2edb6b1d01e33018$var$alphabetByValue[62] = "+";
$2edb6b1d01e33018$var$alphabetByEncoding["/"] = 63;
$2edb6b1d01e33018$var$alphabetByValue[63] = "/";
var $2edb6b1d01e33018$var$bitsPerLetter = 6;
var $2edb6b1d01e33018$var$bitsPerByte = 8;
var $2edb6b1d01e33018$var$maxLetterValue = 63;
function $2edb6b1d01e33018$export$c537b38001c583b7(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in $2edb6b1d01e33018$var$alphabetByEncoding)) throw new TypeError("Invalid character " + input[j] + " in base64 string.");
            bits |= $2edb6b1d01e33018$var$alphabetByEncoding[input[j]] << (limit - j) * $2edb6b1d01e33018$var$bitsPerLetter;
            bitLength += $2edb6b1d01e33018$var$bitsPerLetter;
        } else bits >>= $2edb6b1d01e33018$var$bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % $2edb6b1d01e33018$var$bitsPerByte;
        var byteLength = Math.floor(bitLength / $2edb6b1d01e33018$var$bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * $2edb6b1d01e33018$var$bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function $2edb6b1d01e33018$export$37cc283d8fbd3462(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * $2edb6b1d01e33018$var$bitsPerByte;
            bitLength += $2edb6b1d01e33018$var$bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / $2edb6b1d01e33018$var$bitsPerLetter);
        bits <<= bitClusterCount * $2edb6b1d01e33018$var$bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * $2edb6b1d01e33018$var$bitsPerLetter;
            str += $2edb6b1d01e33018$var$alphabetByValue[(bits & $2edb6b1d01e33018$var$maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}


var $f7f476bb6a51e7a1$export$17bf97b72e307d52 = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return $f7f476bb6a51e7a1$var$collectBlob(stream);
    return $f7f476bb6a51e7a1$var$collectStream(stream);
};
function $f7f476bb6a51e7a1$var$collectBlob(blob) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        $f7f476bb6a51e7a1$var$readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, $2edb6b1d01e33018$export$c537b38001c583b7)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function $f7f476bb6a51e7a1$var$collectStream(stream) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function $f7f476bb6a51e7a1$var$readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}




var $70a873ad85bfeefa$export$8b6362171c4dfa64 = function(message) {
    return function() {
        throw new Error(message);
    };
};


var $77d02972f90c68f9$export$d59dd53963f8f3d5 = function(message) {
    return function() {
        return Promise.reject(message);
    };
};






function $ee68304ee5a27b3c$export$967f3527bf233bc0(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
}



var $f656f1def83e0344$exports = {};
!function(e, t) {
    $f656f1def83e0344$exports = t();
}($f656f1def83e0344$exports, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    t.push(0);
                    var r = t[0], i = t[1];
                    if (10 === r) switch(i){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                    switch(r){
                        case 11:
                            return "Big Sur";
                        case 12:
                            return "Monterey";
                        case 13:
                            return "Ventura";
                        case 14:
                            return "Sonoma";
                        case 15:
                            return "Sequoia";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), a = e.getVersionPrecision(r), o = Math.max(n, a), s = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (s = o - Math.min(n, a)), o -= 1; o >= s;){
                        if (u[0][o] > u[1][o]) return 1;
                        if (u[0][o] === u[1][o]) {
                            if (o === s) return 0;
                            o -= 1;
                        } else if (u[0][o] < u[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.find = function(e, t) {
                    var r, i;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, i = e.length; r < i; r += 1){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                }, e.assign = function(e) {
                    for(var t, r, i = e, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)a[o - 1] = arguments[o];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(a));
                    var s = function() {
                        var e = a[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            i[t] = e[t];
                        });
                    };
                    for(t = 0, r = a.length; t < r; t += 1)s();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                AmazonBot: "amazonbot",
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                BaiduSpider: "baiduspider",
                Bada: "bada",
                BingCrawler: "bingcrawler",
                Brave: "brave",
                BlackBerry: "blackberry",
                "ChatGPT-User": "chatgpt_user",
                Chrome: "chrome",
                ClaudeBot: "claudebot",
                Chromium: "chromium",
                Diffbot: "diffbot",
                DuckDuckBot: "duckduckbot",
                DuckDuckGo: "duckduckgo",
                Electron: "electron",
                Epiphany: "epiphany",
                FacebookExternalHit: "facebookexternalhit",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                GPTBot: "gptbot",
                "Internet Explorer": "ie",
                InternetArchiveCrawler: "internetarchivecrawler",
                "K-Meleon": "k_meleon",
                LibreWolf: "librewolf",
                Linespider: "linespider",
                Maxthon: "maxthon",
                "Meta-ExternalAds": "meta_externalads",
                "Meta-ExternalAgent": "meta_externalagent",
                "Meta-ExternalFetcher": "meta_externalfetcher",
                "Meta-WebIndexer": "meta_webindexer",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                "OAI-SearchBot": "oai_searchbot",
                Omgilibot: "omgilibot",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                "Pale Moon": "pale_moon",
                PerplexityBot: "perplexitybot",
                "Perplexity-User": "perplexity_user",
                PhantomJS: "phantomjs",
                PingdomBot: "pingdombot",
                Puffin: "puffin",
                QQ: "qq",
                QQLite: "qqlite",
                QupZilla: "qupzilla",
                Roku: "roku",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SlackBot: "slackbot",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                "Sogou Browser": "sogou",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                YahooSlurp: "yahooslurp",
                "Yandex Browser": "yandex",
                YandexBot: "yandexbot",
                YouBot: "youbot"
            };
            t.BROWSER_MAP = {
                amazonbot: "AmazonBot",
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                baiduspider: "BaiduSpider",
                bada: "Bada",
                bingcrawler: "BingCrawler",
                blackberry: "BlackBerry",
                brave: "Brave",
                chatgpt_user: "ChatGPT-User",
                chrome: "Chrome",
                claudebot: "ClaudeBot",
                chromium: "Chromium",
                diffbot: "Diffbot",
                duckduckbot: "DuckDuckBot",
                duckduckgo: "DuckDuckGo",
                edge: "Microsoft Edge",
                electron: "Electron",
                epiphany: "Epiphany",
                facebookexternalhit: "FacebookExternalHit",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                google_search: "Google Search",
                googlebot: "Googlebot",
                gptbot: "GPTBot",
                ie: "Internet Explorer",
                internetarchivecrawler: "InternetArchiveCrawler",
                k_meleon: "K-Meleon",
                librewolf: "LibreWolf",
                linespider: "Linespider",
                maxthon: "Maxthon",
                meta_externalads: "Meta-ExternalAds",
                meta_externalagent: "Meta-ExternalAgent",
                meta_externalfetcher: "Meta-ExternalFetcher",
                meta_webindexer: "Meta-WebIndexer",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                oai_searchbot: "OAI-SearchBot",
                omgilibot: "Omgilibot",
                opera: "Opera",
                opera_coast: "Opera Coast",
                pale_moon: "Pale Moon",
                perplexitybot: "PerplexityBot",
                perplexity_user: "Perplexity-User",
                phantomjs: "PhantomJS",
                pingdombot: "PingdomBot",
                puffin: "Puffin",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                qupzilla: "QupZilla",
                roku: "Roku",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                slackbot: "SlackBot",
                sleipnir: "Sleipnir",
                sogou: "Sogou Browser",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yahooslurp: "YahooSlurp",
                yandex: "Yandex Browser",
                yandexbot: "YandexBot",
                youbot: "YouBot"
            };
            t.PLATFORMS_MAP = {
                bot: "bot",
                desktop: "desktop",
                mobile: "mobile",
                tablet: "tablet",
                tv: "tv"
            };
            t.OS_MAP = {
                Android: "Android",
                Bada: "Bada",
                BlackBerry: "BlackBerry",
                ChromeOS: "Chrome OS",
                HarmonyOS: "HarmonyOS",
                iOS: "iOS",
                Linux: "Linux",
                MacOS: "macOS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku",
                Tizen: "Tizen",
                WebOS: "WebOS",
                Windows: "Windows",
                WindowsPhone: "Windows Phone"
            };
            t.ENGINE_MAP = {
                Blink: "Blink",
                EdgeHTML: "EdgeHTML",
                Gecko: "Gecko",
                Presto: "Presto",
                Trident: "Trident",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            function o(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var s = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t, r);
                }, e.parse = function(e, t) {
                    return void 0 === t && (t = null), new n.default(e, t).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return a.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return a.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return a.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return a.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && o(t, i), e;
            }();
            t.default = s, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), a = u(r(94)), o = u(r(95)), s = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e;
                    var i = !1;
                    "boolean" == typeof t ? (i = t, this._hints = r) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== i && this.parse();
                }
                var t = e.prototype;
                return t.getHints = function() {
                    return this._hints;
                }, t.hasBrand = function(e) {
                    if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
                    var t = e.toLowerCase();
                    return this._hints.brands.some(function(e) {
                        return e.brand && e.brand.toLowerCase() === t;
                    });
                }, t.getBrandVersion = function(e) {
                    if (this._hints && Array.isArray(this._hints.brands)) {
                        var t = e.toLowerCase(), r = this._hints.brands.find(function(e) {
                            return e.brand && e.brand.toLowerCase() === t;
                        });
                        return r ? r.version : void 0;
                    }
                }, t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = s.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA(), this)), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = s.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = s.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = s.default.find(o.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return s.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, a = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (n[t] = o, a += 1) : "object" == typeof o && (r[t] = o, i += 1);
                    }), i > 0) {
                        var o = Object.keys(r), u = s.default.find(o, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = s.default.find(o, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (a > 0) {
                        var l = Object.keys(n), b = s.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== b) return this.compareVersion(n[b]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = s.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var a = /version\/(\d+(\.?_?\d+)+)/i, o = [
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "GPTBot"
                        }, r = n.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ChatGPT-User"
                        }, r = n.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "OAI-SearchBot"
                        }, r = n.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ClaudeBot"
                        }, r = n.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Omgilibot"
                        }, r = n.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Diffbot"
                        }, r = n.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PerplexityBot"
                        }, r = n.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Perplexity-User"
                        }, r = n.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "YouBot"
                        }, r = n.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-WebIndexer"
                        }, r = n.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAds"
                        }, r = n.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAgent"
                        }, r = n.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalFetcher"
                        }, r = n.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Linespider"
                        }, r = n.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "AmazonBot"
                        }, r = n.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BingCrawler"
                        }, r = n.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BaiduSpider"
                        }, r = n.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "DuckDuckBot"
                        }, r = n.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "InternetArchiveCrawler"
                        }, r = n.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            name: "FacebookExternalHit"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlackBot"
                        }, r = n.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yahoo!?[\s/]*slurp/i
                    ],
                    describe: function() {
                        return {
                            name: "YahooSlurp"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            name: "YandexBot"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            name: "PingdomBot"
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /PaleMoon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Pale Moon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /librewolf/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "LibreWolf"
                        }, r = n.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sogoumobilebrowser/i,
                        /metasr/i,
                        /se 2\.[x]/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sogou Browser"
                        }, r = n.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), i = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), a = n.default.getFirstMatch(/se ([\d.]+)x/i, e), o = r || i || a;
                        return o && (t.version = o), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return !!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i);
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "DuckDuckGo"
                        };
                        if (t) {
                            var i = t.getBrandVersion("DuckDuckGo");
                            if (i) return r.version = i, r;
                        }
                        var a = n.default.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
                        return a && (r.version = a), r;
                    }
                },
                {
                    test: function(e) {
                        return e.hasBrand("Brave");
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "Brave"
                        };
                        if (t) {
                            var i = t.getBrandVersion("Brave");
                            if (i) return r.version = i, r;
                        }
                        return r;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: a.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: a.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.OS_MAP.iOS
                        }, r = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: a.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: a.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /OpenHarmony/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.HarmonyOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: a.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: a.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: a.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Line"
                        };
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Baidu"
                        };
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Bing"
                        };
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "DuckDuckGo"
                        };
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Anthropic"
                        };
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Webz.io"
                        };
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Diffbot"
                        };
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "You.com"
                        };
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Internet Archive"
                        };
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Slack"
                        };
                    }
                },
                {
                    test: [
                        /yahoo/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yahoo"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yandex"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Pingdom"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /Nokia/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nokia"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: [
                        /smart-?tv|smarttv/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: [
                        /netcast/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: a.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: a.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: a.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        }
    });
});


var $dcf2dceeb55af974$export$69d579f32876892f = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, (/*@__PURE__*/$parcel$interopDefault($f656f1def83e0344$exports))).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};


var $d242a504810f64a5$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $d242a504810f64a5$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};


function $190b9a5843ed6761$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $190b9a5843ed6761$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}


var $b9073a30ed592cd6$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $190b9a5843ed6761$export$c7c5cef950a4d2fc)(input) : (0, $d242a504810f64a5$export$c7c5cef950a4d2fc)(input);
};
var $b9073a30ed592cd6$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $190b9a5843ed6761$export$b4b216764bb846eb)(input) : (0, $d242a504810f64a5$export$b4b216764bb846eb)(input);
};



function $b23090203607ec37$export$66256f83798e5415(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, $96998cfc8b9d4854$export$19a8beecd37a4c45)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, $96998cfc8b9d4854$export$8d051b38c9118094)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}


var $34ea8565d7d080c2$export$7a5253c0f62e0150 = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, $b23090203607ec37$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};




var $705ba9afdc41d022$var$regionHash = {
    "fips-us-east-1": {
        hostname: "lambda-fips.us-east-1.amazonaws.com",
        signingRegion: "us-east-1"
    },
    "fips-us-east-2": {
        hostname: "lambda-fips.us-east-2.amazonaws.com",
        signingRegion: "us-east-2"
    },
    "fips-us-gov-east-1": {
        hostname: "lambda-fips.us-gov-east-1.amazonaws.com",
        signingRegion: "us-gov-east-1"
    },
    "fips-us-gov-west-1": {
        hostname: "lambda-fips.us-gov-west-1.amazonaws.com",
        signingRegion: "us-gov-west-1"
    },
    "fips-us-west-1": {
        hostname: "lambda-fips.us-west-1.amazonaws.com",
        signingRegion: "us-west-1"
    },
    "fips-us-west-2": {
        hostname: "lambda-fips.us-west-2.amazonaws.com",
        signingRegion: "us-west-2"
    }
};
var $705ba9afdc41d022$var$partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "fips-us-east-1",
            "fips-us-east-2",
            "fips-us-west-1",
            "fips-us-west-2",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        hostname: "lambda.{region}.amazonaws.com"
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        hostname: "lambda.{region}.amazonaws.com.cn"
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        hostname: "lambda.{region}.c2s.ic.gov"
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        hostname: "lambda.{region}.sc2s.sgov.gov"
    },
    "aws-us-gov": {
        regions: [
            "fips-us-gov-east-1",
            "fips-us-gov-west-1",
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        hostname: "lambda.{region}.amazonaws.com"
    }
};
var $705ba9afdc41d022$export$2e4318bf13462aa2 = function(region, options) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(void 0, void 0, void 0, function() {
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2,
                (0, $93f7e604c69bfb04$export$2b789d827caebed0)(region, (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, options), {
                    signingService: "lambda",
                    regionHash: $705ba9afdc41d022$var$regionHash,
                    partitionHash: $705ba9afdc41d022$var$partitionHash
                }))
            ];
        });
    });
};


var $ec0666948efb052f$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2015-03-31",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, $705ba9afdc41d022$export$2e4318bf13462aa2),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lambda",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, $34ea8565d7d080c2$export$7a5253c0f62e0150)
    };
};


var $93a8b98fc8d8d5ed$export$ad0966540b0e71e5 = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var clientSharedValues = (0, $ec0666948efb052f$export$ad0966540b0e71e5)(config);
    return (0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)((0, $96998cfc8b9d4854$export$18ce0697a983be9b)({}, clientSharedValues), config), {
        runtime: "browser",
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, $2edb6b1d01e33018$export$c537b38001c583b7),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, $2edb6b1d01e33018$export$37cc283d8fbd3462),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, $ee68304ee5a27b3c$export$967f3527bf233bc0),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, $dcf2dceeb55af974$export$69d579f32876892f)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($3077ef3f1d6290d2$exports))).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, $c4a280001fe18458$export$2c7e51f38ba5a406),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, $77d02972f90c68f9$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, $10b1589a7bac016d$export$83588b87edbfa7e0)(),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return Promise.resolve((0, $c4a280001fe18458$export$41315747b7c5d042));
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, $ff311350cc9f0502$exports.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, $f7f476bb6a51e7a1$export$17bf97b72e307d52),
        utf8Decoder: (_m = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _m !== void 0 ? _m : (0, $b9073a30ed592cd6$export$c7c5cef950a4d2fc),
        utf8Encoder: (_o = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _o !== void 0 ? _o : (0, $b9073a30ed592cd6$export$b4b216764bb846eb)
    });
};


var $92c1adecb7994ff5$export$6d7e551cce9b8596 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(LambdaClient, _super);
    function LambdaClient(configuration) {
        var _this = this;
        var _config_0 = (0, $93a8b98fc8d8d5ed$export$ad0966540b0e71e5)(configuration);
        var _config_1 = (0, $464516bd441a29af$export$7696ef37558bd0ec)(_config_0);
        var _config_2 = (0, $4eb1386dde5b735c$export$24f352b1bd1e2f8b)(_config_1);
        var _config_3 = (0, $9429c32b51504164$export$ca7f6138f2c98476)(_config_2);
        var _config_4 = (0, $8ca56bb2b455546f$export$c1625bf0b32b4481)(_config_3);
        var _config_5 = (0, $c175c88f4444b500$export$1dd62920de1feabb)(_config_4);
        var _config_6 = (0, $ac53acb32ff7b4bd$export$ec9a2d5663958cb)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, $24b6d03405692463$export$c73199e2b1df9340)(_this.config));
        _this.middlewareStack.use((0, $1035a3c80ab33309$export$7e6ddf9365a30fe9)(_this.config));
        _this.middlewareStack.use((0, $8ca56bb2b455546f$export$23d3b647211be53a)(_this.config));
        _this.middlewareStack.use((0, $9296ba62fc209330$export$f6ef65d7766fc255)(_this.config));
        _this.middlewareStack.use((0, $9853457fe0a473fd$export$59c2b7ad30ed4046)(_this.config));
        _this.middlewareStack.use((0, $b42bfd8572de09d3$export$5393c0d2d7f4f5f0)(_this.config));
        return _this;
    }
    LambdaClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LambdaClient;
}((0, $7b3b7173926ddf95$export$1f2bb630327ac4b6));


var $0d8f96024bbaf0ac$export$4d5bd360b6390e98 = function(_super) {
    (0, $96998cfc8b9d4854$export$a8ba968b8961cb8a)(Lambda, _super);
    function Lambda() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lambda.prototype.addLayerVersionPermission = function(args, optionsOrCb, cb) {
        var command = new (0, $27326b8b1b9eeae1$export$6d4ded5fb4d98802)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.addPermission = function(args, optionsOrCb, cb) {
        var command = new (0, $1ecfbada878804e8$export$479ba83b03cbef1)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.createAlias = function(args, optionsOrCb, cb) {
        var command = new (0, $14fc4a9e593f64ea$export$b263925caf9658c2)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.createCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $634a5eca868b0d10$export$1122e0fa4be4ded)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.createEventSourceMapping = function(args, optionsOrCb, cb) {
        var command = new (0, $efc13640e6bbe445$export$d87a16268be35ff4)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.createFunction = function(args, optionsOrCb, cb) {
        var command = new (0, $58d849f8fbc452a2$export$7cfaf28ab5c5858e)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteAlias = function(args, optionsOrCb, cb) {
        var command = new (0, $86c2186271accbd5$export$18db2a2089aa2b51)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $9eb876fbfacb658c$export$d7be7ef06e2fa3a3)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteEventSourceMapping = function(args, optionsOrCb, cb) {
        var command = new (0, $7b09bbabe75c4dc6$export$83586502c21f36a6)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteFunction = function(args, optionsOrCb, cb) {
        var command = new (0, $0f6b0ef347b1fc25$export$45f6e1f438773d4b)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteFunctionCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $78aa0eb7ce83d64c$export$9191e6e6797aa8b9)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteFunctionConcurrency = function(args, optionsOrCb, cb) {
        var command = new (0, $268703dfa400bf53$export$e207b5529cb851cb)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteFunctionEventInvokeConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $62515c04cb5a498b$export$ef7330dcea336d30)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteLayerVersion = function(args, optionsOrCb, cb) {
        var command = new (0, $5b5831ef1ae568a0$export$80393674cd99c194)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.deleteProvisionedConcurrencyConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $ac781fc805e7196b$export$8a0fc07fad2f970a)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getAccountSettings = function(args, optionsOrCb, cb) {
        var command = new (0, $1372a672b6b0264a$export$19c97e07b315ed82)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getAlias = function(args, optionsOrCb, cb) {
        var command = new (0, $4c812025b449711f$export$89f3e3fa58a580ca)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $9c9ce80d64037fa9$export$7fe2699f5ae33b3d)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getEventSourceMapping = function(args, optionsOrCb, cb) {
        var command = new (0, $f237a2d2f0e9284d$export$f8ff3747bc31246a)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getFunction = function(args, optionsOrCb, cb) {
        var command = new (0, $8db88e707336ef9c$export$73dffa3bd10e5612)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getFunctionCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $995c7ae1bb95769e$export$a63c49257d994f9e)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getFunctionConcurrency = function(args, optionsOrCb, cb) {
        var command = new (0, $68d174baae83bedd$export$df6f868d7bc1de49)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getFunctionConfiguration = function(args, optionsOrCb, cb) {
        var command = new (0, $e2efe58f777ae3f3$export$e8a6399e3916ed4f)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getFunctionEventInvokeConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $da40b9130bac0880$export$41b3813be9434493)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getLayerVersion = function(args, optionsOrCb, cb) {
        var command = new (0, $bd2453a88f99a83a$export$5f3db98d0a943d80)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getLayerVersionByArn = function(args, optionsOrCb, cb) {
        var command = new (0, $981f99e7e0acd88a$export$9a85e58df045c005)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getLayerVersionPolicy = function(args, optionsOrCb, cb) {
        var command = new (0, $f779aaa91c612c16$export$66f6f73b29b70e90)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getPolicy = function(args, optionsOrCb, cb) {
        var command = new (0, $85e68f0c782afd35$export$c646230d336e898)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.getProvisionedConcurrencyConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $60a9384caea146ee$export$d2d27e48c226c354)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.invoke = function(args, optionsOrCb, cb) {
        var command = new (0, $99531c6f261f8a07$export$67bdac3ca73971d3)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.invokeAsync = function(args, optionsOrCb, cb) {
        var command = new (0, $dd80c8109957e769$export$2aef6052fd4cdddb)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listAliases = function(args, optionsOrCb, cb) {
        var command = new (0, $b39aa3032c1956fe$export$edbfa2874c857910)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listCodeSigningConfigs = function(args, optionsOrCb, cb) {
        var command = new (0, $2b206c65d98f24fc$export$79b71544a0374aab)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listEventSourceMappings = function(args, optionsOrCb, cb) {
        var command = new (0, $d954adce5715f0c9$export$8558d0826a502b62)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listFunctionEventInvokeConfigs = function(args, optionsOrCb, cb) {
        var command = new (0, $a6e658f6147cc147$export$9bd8785598fc394b)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listFunctions = function(args, optionsOrCb, cb) {
        var command = new (0, $cfa20f8278232d78$export$4d04cd626f6c7d2b)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listFunctionsByCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $9e2d8a5d119e0ce3$export$fb1019bd3522403a)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listLayers = function(args, optionsOrCb, cb) {
        var command = new (0, $ec7e67021c118a70$export$abe0e5d7c1ca7943)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listLayerVersions = function(args, optionsOrCb, cb) {
        var command = new (0, $b5182c8e2a414ebf$export$1c1e8573126853e1)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listProvisionedConcurrencyConfigs = function(args, optionsOrCb, cb) {
        var command = new (0, $0a28ae9ebf82b0d1$export$dac8ddb0f6fb95a9)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listTags = function(args, optionsOrCb, cb) {
        var command = new (0, $f231298ba1a9c1b9$export$1748de84b49aa898)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.listVersionsByFunction = function(args, optionsOrCb, cb) {
        var command = new (0, $3aa462a7cfc256ea$export$f07cd5007db89e2f)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.publishLayerVersion = function(args, optionsOrCb, cb) {
        var command = new (0, $3603f9e0bd0da21a$export$e00ed4a069494fe0)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.publishVersion = function(args, optionsOrCb, cb) {
        var command = new (0, $71c493eeb344483e$export$d4c2f9de5fbd4bf2)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.putFunctionCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $6c4493f39b4fa7fa$export$56dffd0f4b2e455f)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.putFunctionConcurrency = function(args, optionsOrCb, cb) {
        var command = new (0, $464f243fba7da85e$export$58cac2be30cc1455)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.putFunctionEventInvokeConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $47f1b896cc2c3d36$export$83815fcc4fcf2f7e)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.putProvisionedConcurrencyConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $dd113369310f3ef6$export$7bae26f7d9f06082)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.removeLayerVersionPermission = function(args, optionsOrCb, cb) {
        var command = new (0, $b69f3c369c122ab7$export$6f77f8d7c7a12ea4)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.removePermission = function(args, optionsOrCb, cb) {
        var command = new (0, $38b389e988f504a5$export$c9673d05f69ca8cc)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.tagResource = function(args, optionsOrCb, cb) {
        var command = new (0, $fe96cf3aad140d1a$export$9491ffa65c9235d8)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.untagResource = function(args, optionsOrCb, cb) {
        var command = new (0, $e6e6132e33294a1c$export$ed311643165f836c)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateAlias = function(args, optionsOrCb, cb) {
        var command = new (0, $31c68b794d40cfa1$export$e5f03d53bdebd5d6)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateCodeSigningConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $820c0606f9529ac8$export$c647e9817422a02f)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateEventSourceMapping = function(args, optionsOrCb, cb) {
        var command = new (0, $662180b5b47d3d7f$export$531a44639889399c)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateFunctionCode = function(args, optionsOrCb, cb) {
        var command = new (0, $d4b5b94a12cdb368$export$a810d8e7173f6680)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateFunctionConfiguration = function(args, optionsOrCb, cb) {
        var command = new (0, $9770c5307e6e39ab$export$c5fcd08713383766)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    Lambda.prototype.updateFunctionEventInvokeConfig = function(args, optionsOrCb, cb) {
        var command = new (0, $31f7b02edd208340$export$92e1f48f57caa6a)(args);
        if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object") throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        } else return this.send(command, optionsOrCb);
    };
    return Lambda;
}((0, $92c1adecb7994ff5$export$6d7e551cce9b8596));




const $efadcd99fe5a20d2$export$63fbcc50745c2a8 = async (year, detailed)=>{
    const credentials = await (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).currentCredentials();
    const lambda = new (0, $0d8f96024bbaf0ac$export$4d5bd360b6390e98)({
        credentials: (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).essentialCredentials(credentials),
        region: 'eu-west-1'
    });
    const session = await (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).currentSession();
    const payload = JSON.stringify({
        extractType: 'ongoing',
        includeDetail: detailed,
        includeAttachments: detailed,
        year: year,
        jwt: session.idToken.jwtToken
    });
    lambda.invoke({
        LogType: 'Tail',
        InvocationType: 'Event',
        Payload: payload,
        FunctionName: "staging-excel-extract-sta-lambdaexcelextractlambda-R9drAGEARgux"
    }).then(()=>{
        (0, $41263b671f20f58e$export$2791228263505492)({
            header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
            text: `The ${detailed ? 'detailed' : 'ongoing'} export will be by email to ${session.idToken.payload.email}.`,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
        });
    }).catch((error)=>{
        (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        (0, $41263b671f20f58e$export$2791228263505492)({
            header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
            text: `There was an error generating the ${detailed ? 'detailed' : 'ongoing'} export`,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
    });
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");




const $f5148f0b2790f77f$var$wrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'center'
});
const $f5148f0b2790f77f$var$contentStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 480,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    border: `1px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate30}`,
    borderRadius: 2,
    margin: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginTop: '5%',
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate100
});
const $f5148f0b2790f77f$var$headerWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $f5148f0b2790f77f$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.m
});
const $f5148f0b2790f77f$var$bodyWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: '5%',
    marginTop: '5%'
});
const $f5148f0b2790f77f$var$closeButtonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: -(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $f5148f0b2790f77f$var$closeModalButtonIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate100
});
const $f5148f0b2790f77f$var$actionButtonsWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    'button:first-of-type': {
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
    }
});
const $f5148f0b2790f77f$export$5ba39ac35b23aa9f = ({ header: header, onClose: onClose, onApprove: onApprove, onCancel: onCancel })=>{
    const [comment, setComment] = (0, $denZA.useState)('');
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
            css: $f5148f0b2790f77f$var$wrapperStyle,
            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $f5148f0b2790f77f$var$contentStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("header", {
                        css: $f5148f0b2790f77f$var$headerWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h4", {
                                css: $f5148f0b2790f77f$var$headerStyle,
                                children: header
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $f5148f0b2790f77f$var$closeButtonWrapperStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                    "aria-label": "Close modal button",
                                    icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $88a0171ecb792bad$export$3c877bb842c36952), {
                                        css: $f5148f0b2790f77f$var$closeModalButtonIconStyle
                                    }),
                                    variant: "ghost",
                                    size: "small",
                                    onClick: onClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $f5148f0b2790f77f$var$bodyWrapperStyle,
                        children: [
                            "Additional comments:",
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec), {
                                onChange: (event)=>setComment(event.target.value),
                                placeholder: "Add option comments for justification"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $f5148f0b2790f77f$var$actionButtonsWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Cancel",
                                variant: "ghost",
                                onClick: onCancel
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Yes, continue",
                                "data-transaction-name": header,
                                onClick: ()=>onApprove(comment)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
$f5148f0b2790f77f$export$5ba39ac35b23aa9f.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    onApprove: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};




var $cvFNP = parcelRequire("cvFNP");






var $cvFNP = parcelRequire("cvFNP");


const $37f5c9b0e46678fc$var$containerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex'
});
const $37f5c9b0e46678fc$var$dotStyle = (isActive)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'block',
        width: 10,
        height: 10,
        backgroundColor: isActive ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue80 : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40,
        borderRadius: 5,
        margin: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
    });
const $37f5c9b0e46678fc$export$4ad9c19502251d05 = ({ numberOfPages: numberOfPages, currentPageIndex: currentPageIndex })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        css: $37f5c9b0e46678fc$var$containerStyle,
        children: [
            ...Array(numberOfPages)
        ].map((_, index)=>{
            return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $37f5c9b0e46678fc$var$dotStyle(currentPageIndex === index + 1)
            }, `dot${index}`);
        })
    });
$37f5c9b0e46678fc$export$4ad9c19502251d05.propTypes = {
    numberOfPages: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number.isRequired,
    currentPageIndex: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
};


const $bfd14d090534ab1b$var$wrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'center'
});
const $bfd14d090534ab1b$var$contentStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 480,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    borderRadius: 2,
    margin: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginTop: '5%',
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate100,
    border: `1px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.error.error500}`,
    borderLeftWidth: 12
});
const $bfd14d090534ab1b$var$headerWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $bfd14d090534ab1b$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.m
});
const $bfd14d090534ab1b$var$bodyTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3
});
const $bfd14d090534ab1b$var$closeButtonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: -(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $bfd14d090534ab1b$var$closeModalButtonIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate100
});
const $bfd14d090534ab1b$var$pageIndicatorWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $bfd14d090534ab1b$export$a16bdbbbfa22bef2 = ({ header: header, bodyText: bodyText, onClose: onClose, pageIndicator: pageIndicator, children: children })=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
            css: $bfd14d090534ab1b$var$wrapperStyle,
            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $bfd14d090534ab1b$var$contentStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("header", {
                        css: $bfd14d090534ab1b$var$headerWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h4", {
                                css: $bfd14d090534ab1b$var$headerStyle,
                                children: header
                            }),
                            onClose && typeof onClose === 'function' && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $bfd14d090534ab1b$var$closeButtonWrapperStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                    "aria-label": "Close modal button",
                                    icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $88a0171ecb792bad$export$3c877bb842c36952), {
                                        css: $bfd14d090534ab1b$var$closeModalButtonIconStyle
                                    }),
                                    variant: "ghost",
                                    size: "small",
                                    onClick: onClose
                                })
                            })
                        ]
                    }),
                    bodyText && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                        css: $bfd14d090534ab1b$var$bodyTextStyle,
                        children: bodyText
                    }),
                    children,
                    pageIndicator && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $bfd14d090534ab1b$var$pageIndicatorWrapperStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $37f5c9b0e46678fc$export$4ad9c19502251d05), {
                            numberOfPages: pageIndicator[0],
                            currentPageIndex: pageIndicator[1]
                        })
                    })
                ]
            })
        })
    });
};
$bfd14d090534ab1b$export$a16bdbbbfa22bef2.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    bodyText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    pageIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired
};




var $cvFNP = parcelRequire("cvFNP");



const $9ca33e8fb814a3bb$var$bodyText = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6,
    '& > p': {
        marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
    }
});
const $9ca33e8fb814a3bb$export$fde4214a1c5284d3 = ({ header: header, body: body, onCloseText: onCloseText = 'Cancel', onConfirmText: onConfirmText = 'Yes, continue', onClose: onClose, onConfirm: onConfirm, onExitHandler: onExitHandler, status: status = 'information', icon: icon })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        onClick: onExitHandler ? onExitHandler : onClose,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772), {
            status: status,
            icon: icon,
            heading: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Heading, {
                children: header
            }),
            body: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Body, {
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $9ca33e8fb814a3bb$var$bodyText,
                    dangerouslySetInnerHTML: {
                        __html: body
                    }
                })
            }),
            action: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Action, {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "aria-label": "Confirm action",
                        "data-transaction-name": header,
                        label: onConfirmText,
                        onClick: ()=>onConfirm()
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "aria-label": "Close modal",
                        label: onCloseText,
                        variant: "outline",
                        onClick: onClose
                    })
                ]
            }),
            exitClickHandler: onExitHandler ? onExitHandler : onClose
        })
    });
$9ca33e8fb814a3bb$export$fde4214a1c5284d3.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    onCloseText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    onConfirmText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onExitHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    status: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).element
};




var $cvFNP = parcelRequire("cvFNP");

const $dca34716ff66b16c$export$88bb0e2c98b715ef = ({ header: header, onClose: onClose, onSave: onSave, status: status = 'warning', children: children, saveDisableCondition: saveDisableCondition = ()=>false })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772), {
        variant: status,
        isOpen: true,
        onClose: onClose,
        size: "3xl",
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).Overlay, {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).Content, {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).Header, {
                        children: header
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).CloseButton, {}),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).Body, {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d1d1a3a7c7f3f8d3$export$2b77a92f1a5ad772).Footer, {
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $de3d8b63c73a46a5$export$69b1032f2ecdf404), {
                            children: [
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e032547b364b9976$export$353f5b6fc5456de1), {
                                    isDisabled: saveDisableCondition(),
                                    colorScheme: status,
                                    onClick: onSave,
                                    "data-transaction-name": header,
                                    children: "Yes, make change(s)"
                                }),
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e032547b364b9976$export$353f5b6fc5456de1), {
                                    variant: "outline",
                                    onClick: onClose,
                                    children: "Cancel"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
$dca34716ff66b16c$export$88bb0e2c98b715ef.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onSave: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    status: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired,
    saveDisableCondition: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func
};




var $cvFNP = parcelRequire("cvFNP");






const $3583fd120271f7a3$export$8951c8a15d961cc6 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query GetAssessments($year: Int!) {
    getAssessments(year: $year) {
      customerId
      year
      version
      c6Id
      c6Name
      customerName
      customerEmail
      channel
      omni
      marketGroup
      approvers
      reviewers
      performers
      status
      pendingUser
      score
      lastYearScore
      actions
      businessUnit
    }
  }
`;
const $3583fd120271f7a3$export$ead77c084e8e01bb = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query GetAssessmentData($customerId: String!, $year: Int!, $version: Int!) {
    getAnswers(customerId: $customerId, year: $year, version: $version) {
      questionId
      isValid
      isComplete
      selectedAnswer
      comment
      images
    }
    getSurvey(customerId: $customerId, year: $year, version: $version) {
      surveyId
      questionId
      headline
      subHeader
      questionType
      conditions
      explanation
      answerOptions {
        answerId
        text
        score
        subAnswerHeader
        minimumSubAnswers
        subAnswerOptions {
          answerId
          text
        }
      }
      answersExemptFromAttachments {
        answerId
      }
      furtherDetails
      commentsTextBox
      commentsInTextBox
      uploadHeadline
      upload
    }
    getSurveyInfo(customerId: $customerId, year: $year, version: $version) {
      active
      email
      contactEmails
      version
      uploadId
      assessmentStatus
      actions
      reviewers
      approvers
      performers
      assessmentDate
      approvalDate
      pendingUser
      comments {
        text
        date
        userEmail
      }
      surveyState {
        isComplete
        isEditable
        score
      }
      lastYearScore
      customerDetail {
        id
        name
        businessUnit
        c6Id
        c6Name
        channel
        omni
      }
    }
  }
`;
const $3583fd120271f7a3$export$7a9caf0d41fdd5e4 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation ApproveAssessment(
    $customerId: String!
    $year: Int!
    $version: Int!
    $comment: String
  ) {
    approveAssessment(
      customerId: $customerId
      year: $year
      version: $version
      comment: $comment
    ) {
      customerName
      customerEmail
    }
  }
`;
const $3583fd120271f7a3$export$3494ca0ca620dcda = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation RejectAssessment(
    $customerId: String!
    $year: Int!
    $version: Int!
    $comment: String
  ) {
    rejectAssessment(
      customerId: $customerId
      year: $year
      version: $version
      comment: $comment
    ) {
      customerName
      customerEmail
    }
  }
`;
const $3583fd120271f7a3$export$e3d65cd701b10712 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation RescoreAssessment(
    $customerId: String!
    $year: Int!
    $version: Int!
    $comment: String
  ) {
    rescoreAssessment(
      customerId: $customerId
      year: $year
      version: $version
      comment: $comment
    ) {
      customerName
      customerEmail
    }
  }
`;
const $3583fd120271f7a3$export$665446046e211b61 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation UpdateAnswer(
    $customerId: String!
    $answer: AnswerInput!
    $year: Int!
    $version: Int!
  ) {
    updateAnswer(
      customerId: $customerId
      answer: $answer
      year: $year
      version: $version
    ) {
      questionId
    }
  }
`;
const $3583fd120271f7a3$export$42d41fcb8525466c = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation FinishSurvey($customerId: String!, $year: Int!, $version: Int!) {
    finishSurvey(customerId: $customerId, year: $year, version: $version)
  }
`;
const $3583fd120271f7a3$export$9565ea37c098d66 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation UpdateAllAnswers(
    $customerId: String!
    $answers: [AnswerInput!]!
    $year: Int!
    $version: Int!
  ) {
    updateAllAnswers(
      customerId: $customerId
      answers: $answers
      year: $year
      version: $version
    )
  }
`;
const $3583fd120271f7a3$export$8bee2847d9a36624 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation DeleteAssessment($customerId: String!, $year: Int!, $version: Int!) {
    deleteAssessment(customerId: $customerId, year: $year, version: $version)
  }
`;
const $3583fd120271f7a3$export$dfa36a32b5f79982 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation SoftDeleteAssessment(
    $customerId: String!
    $year: Int!
    $version: Int!
  ) {
    softDeleteAssessment(
      customerId: $customerId
      year: $year
      version: $version
    ) {
      customerId
      year
      version
    }
  }
`;
const $3583fd120271f7a3$export$c99b09d55436be15 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query getCompletePageData($customerId: String!, $year: Int!, $version: Int!) {
    getSurvey(customerId: $customerId, year: $year, version: $version) {
      headline
      questionId
      questionType
      commentsTextBox
      upload
      answersExemptFromAttachments {
        answerId
      }
    }
    getAnswers(customerId: $customerId, year: $year, version: $version) {
      questionId
      isComplete
      selectedAnswer
      comment
      images
    }
    getSurveyInfo(customerId: $customerId, year: $year, version: $version) {
      uploadId
      assessmentStatus
      actions
      assessmentDate
      approvalDate
      pendingUser
      approvers
      performers
      reviewers
      surveyState {
        isComplete
        isEditable
        score
      }
      customerDetail {
        id
        name
        businessUnit
        c6Id
        c6Name
        channel
        omni
      }
    }
  }
`;
const $3583fd120271f7a3$export$8356489b8b7b3ab3 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation AddComment(
    $customerId: String!
    $year: Int!
    $version: Int!
    $comment: String!
  ) {
    addComment(
      customerId: $customerId
      year: $year
      version: $version
      comment: $comment
    ) {
      text
      date
      userEmail
    }
  }
`;
const $3583fd120271f7a3$export$7ea9d230be24deb6 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation UpdateAssessmentChannel($input: AssessmentChannelUpdateInput!) {
    updateAssessmentChannel(input: $input) {
      customerId
      year
      version
      channel
      status
      actions
    }
  }
`;
const $3583fd120271f7a3$export$e3667debca12a4b2 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query GetAvailableChannels($year: Int!) {
    getAvailableChannelsForYear(year: $year)
  }
`;
const $3583fd120271f7a3$export$8a89622aaaff64a = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query GetUserConfirmationStatus($customerId: String!) {
    getUserConfirmationStatus(customerId: $customerId) {
      email
      reminderSentDate
    }
  }
`;
const $3583fd120271f7a3$export$ef036b5348d31a01 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation SendInvitationEmail(
    $customerId: String!
    $year: Int!
    $version: Int!
  ) {
    sendInvitationEmail(
      customerId: $customerId
      year: $year
      version: $version
    ) {
      wasEmailSent
      message
    }
  }
`;




const $bbc835f66a22fb9d$export$8d89fee11b80c3f9 = (error, errorMessage = (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorText)=>{
    (0, $41263b671f20f58e$export$2791228263505492)({
        header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
        text: errorMessage,
        type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
    });
    (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
};








// Variables
const $f94523ea9478e615$var$animationDuration = '5s';
const $f94523ea9478e615$var$spinnerColor = (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.base;
// Animations
const $f94523ea9478e615$var$circlesAnimation = (0, $e30926212b3658f1$export$d25ddfdf17c3ad3e)`
  100% {
    transform: rotate(1080deg);
  }
  20%,
  45%,
  70%,
  95% {
    width: 40px;
    height: 40px;
    margin-left: -20px;
    margin-top: -20px;
    opacity: 0;
  }

  0%,
  15%,
  50%,
  65%,
  100% {
    width: 100px;
    height: 100px;
    margin-left: -50px;
    margin-top: -50px;
    opacity: 1;
  }
`;
const $f94523ea9478e615$var$heartAnimation = (0, $e30926212b3658f1$export$d25ddfdf17c3ad3e)`
  70% {
    transform: scale(0) rotate(-40deg);
  }
  75%,
  90% {
    transform: scale(1) rotate(0deg);
  }
  95% {
    transform: scale(0) rotate(40deg);
  }
`;
const $f94523ea9478e615$var$headAnimation = (0, $e30926212b3658f1$export$d25ddfdf17c3ad3e)`
  20% {
    transform: scale(0) rotate(-40deg);
  }
  25%,
  40% {
    transform: scale(1) rotate(0deg);
  }
  45% {
    transform: scale(0) rotate(40deg);
  }
`;
const $f94523ea9478e615$var$generalCircleStyle = {
    width: 40,
    height: 40,
    borderRadius: 20,
    position: 'absolute',
    background: $f94523ea9478e615$var$spinnerColor
};
const $f94523ea9478e615$var$generalHeartTopPieceStyle = {
    width: 30,
    height: 30,
    background: $f94523ea9478e615$var$spinnerColor,
    borderRadius: 15,
    left: '50%',
    top: '50%',
    position: 'absolute'
};
const $f94523ea9478e615$var$generalEyeStyle = {
    position: 'absolute',
    background: 'black',
    width: 6,
    height: 6,
    borderRadius: 3,
    top: 14
};
const $f94523ea9478e615$export$1207849e90acaff2 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'relative',
    left: '50%',
    top: '50%',
    width: 300,
    height: 300,
    margin: '-150px auto auto -150px',
    transform: 'scale(0.5)'
});
const $f94523ea9478e615$export$fe1bdb9b45429a59 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    animationName: $f94523ea9478e615$var$circlesAnimation,
    animationDuration: $f94523ea9478e615$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    width: 120,
    height: 120,
    position: 'absolute',
    left: '50%',
    top: '50%',
    margin: '-60px auto auto -60px'
});
const $f94523ea9478e615$export$3cc0e757c9496f3d = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalCircleStyle,
    top: 0,
    left: 0
});
const $f94523ea9478e615$export$d774207aca4af861 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalCircleStyle,
    top: 0,
    right: 0
});
const $f94523ea9478e615$export$bef12586d2f0a092 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalCircleStyle,
    bottom: 0,
    right: 0
});
const $f94523ea9478e615$export$111bb31ab3dc8cb1 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalCircleStyle,
    bottom: 0,
    left: 0
});
const $f94523ea9478e615$export$decef80e1c8cbc76 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    animationName: $f94523ea9478e615$var$heartAnimation,
    animationDuration: $f94523ea9478e615$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    transform: 'scale(0)',
    position: 'absolute',
    width: 100,
    height: 100,
    left: '50%',
    top: '50%',
    margin: '-45px auto auto -50px'
});
const $f94523ea9478e615$export$85575e3b99b1c5c = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    width: 30,
    height: 30,
    background: $f94523ea9478e615$var$spinnerColor,
    transform: 'rotate(45deg)',
    left: '50%',
    top: '50%',
    margin: '-15px 0 0 -15px',
    borderRadius: '0 0 4px 0'
});
const $f94523ea9478e615$export$62b5797474f9bfc5 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalHeartTopPieceStyle,
    margin: '-26px auto auto -26px',
    background: $f94523ea9478e615$var$spinnerColor
});
const $f94523ea9478e615$export$ba5140f6e6c007dd = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalHeartTopPieceStyle,
    margin: '-26px auto auto -4px',
    background: $f94523ea9478e615$var$spinnerColor
});
const $f94523ea9478e615$export$5d928225ddb5beff = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    transform: 'scale(0)',
    animationName: $f94523ea9478e615$var$headAnimation,
    animationDuration: $f94523ea9478e615$var$animationDuration,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    position: 'absolute',
    width: 52,
    height: 52,
    left: '50%',
    top: '50%',
    margin: '-26px auto auto -26px'
});
const $f94523ea9478e615$export$257631f13bf5ae46 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    width: 26,
    height: 12,
    background: $f94523ea9478e615$var$spinnerColor,
    left: '50%',
    marginLeft: -13,
    borderRadius: '2px 2px 0 0'
});
const $f94523ea9478e615$export$6d51069bdefb697f = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    width: 48,
    height: 39,
    background: $f94523ea9478e615$var$spinnerColor,
    borderRadius: 9,
    left: 2,
    top: 8
});
const $f94523ea9478e615$export$73e3b6e07391b4e9 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    width: 30,
    height: 7,
    left: '50%',
    marginLeft: -15,
    bottom: 0,
    background: $f94523ea9478e615$var$spinnerColor
});
const $f94523ea9478e615$export$23ba3bb1531a31d6 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    width: 18,
    height: 7,
    background: 'transparent',
    left: '50%',
    top: 24,
    marginLeft: -9,
    borderRadius: '0 0 50% 50%',
    borderBottom: '2px solid black',
    boxSizing: 'border-box'
});
const $f94523ea9478e615$export$582c8c6777f090cb = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalEyeStyle,
    left: 14
});
const $f94523ea9478e615$export$3d98df5e586f7b0d = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    ...$f94523ea9478e615$var$generalEyeStyle,
    right: 14
});


const $97dcf9f609028572$export$7f7cbe89f1eacd2 = ()=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: (0, $f94523ea9478e615$export$1207849e90acaff2),
        role: "progressbar",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: (0, $f94523ea9478e615$export$fe1bdb9b45429a59),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$3cc0e757c9496f3d)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$d774207aca4af861)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$bef12586d2f0a092)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$111bb31ab3dc8cb1)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: (0, $f94523ea9478e615$export$decef80e1c8cbc76),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$85575e3b99b1c5c)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$62b5797474f9bfc5)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$ba5140f6e6c007dd)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: (0, $f94523ea9478e615$export$5d928225ddb5beff),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$257631f13bf5ae46)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: (0, $f94523ea9478e615$export$6d51069bdefb697f),
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: (0, $f94523ea9478e615$export$582c8c6777f090cb)
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: (0, $f94523ea9478e615$export$3d98df5e586f7b0d)
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: (0, $f94523ea9478e615$export$23ba3bb1531a31d6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: (0, $f94523ea9478e615$export$73e3b6e07391b4e9)
                    })
                ]
            })
        ]
    });
};



const $5f2ae4d0ed2682a3$var$modalHeaderStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    lineHeight: 'normal',
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium
});
const $5f2ae4d0ed2682a3$var$bodyStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    paddingTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8
});
const $5f2ae4d0ed2682a3$var$EmailInfoBody = ({ emails: emails })=>{
    if (emails.length === 0) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("p", {
        children: [
            "No email addresses found for this customer.",
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
            "Please check the customer in Contact Management."
        ]
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("p", {
        children: [
            "This will resend a reminder about this year",
            "'",
            "s assessment to",
            ' ',
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("b", {
                children: emails.join(', ')
            }),
            ".",
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
            "They can access the survey or reset their password by visiting the login page at",
            ' ',
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $23076e5d058875b5$export$a6c7ac8248d6e38a), {
                isExternal: true,
                isInline: true,
                href: "https://survey.mcp.b2b.lego.com",
                children: [
                    ' ',
                    "survey.mcp.b2b.lego.com"
                ]
            }),
            "."
        ]
    });
};
const $5f2ae4d0ed2682a3$export$269165b71d322095 = ({ customerId: customerId, onClose: onClose })=>{
    const { assessmentYear: assessmentYear, version: version } = (0, $32ee599feb5ae61e$export$99eaa27ddbbb95ef)();
    const { data: getUserConfirmationStatus, loading: isUserStatusLoading, error: getUserStatusError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$8a89622aaaff64a), {
        variables: {
            customerId: customerId
        },
        fetchPolicy: 'network-only',
        onError: ()=>{
            onClose();
        }
    });
    const confirmationStatuses = getUserConfirmationStatus?.getUserConfirmationStatus ?? [];
    const handleResendEmailResponse = (data)=>{
        const { sendInvitationEmail: sendInvitationEmail } = data;
        if (!sendInvitationEmail?.wasEmailSent) {
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError('Failed to send invitation email');
            showErrorSnackbar(`Failed to send invitation email to contacts of ${customerId}.`);
            return;
        }
        (0, $41263b671f20f58e$export$2791228263505492)({
            header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
            text: sendInvitationEmail.message,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
        });
        onClose();
    };
    const [resendEmail, { loading: isResendEmailLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$ef036b5348d31a01), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleResendEmailResponse,
        onError: (error)=>{
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error, error.message);
        }
    });
    const showErrorSnackbar = (text)=>{
        (0, $41263b671f20f58e$export$2791228263505492)({
            header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
            text: text,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
    };
    async function handleResendEmail() {
        if (confirmationStatuses.length === 0) {
            showErrorSnackbar(`No email addresses found for customer with id ${customerId}.`);
            return;
        }
        try {
            await resendEmail({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    version: Number(version)
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    if (isUserStatusLoading || isResendEmailLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772), {
            status: confirmationStatuses.length > 0 ? 'information' : 'error',
            icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0cb89df189895679$export$7814126f72106a6c), {}),
            heading: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Heading, {
                css: $5f2ae4d0ed2682a3$var$modalHeaderStyle,
                children: "Resend reminder email"
            }),
            body: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Body, {
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $5f2ae4d0ed2682a3$var$bodyStyle,
                    children: !isUserStatusLoading && !getUserStatusError && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)($5f2ae4d0ed2682a3$var$EmailInfoBody, {
                        emails: confirmationStatuses.map((status)=>status.email)
                    })
                })
            }),
            action: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Action, {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "aria-label": "Confirm action",
                        "data-transaction-name": "Send Reminder",
                        label: "Send reminder",
                        title: "Send reminder email to user",
                        onClick: ()=>{
                            handleResendEmail();
                        },
                        disabled: isUserStatusLoading || isResendEmailLoading || confirmationStatuses.length === 0
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "aria-label": "Close modal",
                        label: "Cancel",
                        variant: "outline",
                        onClick: onClose
                    })
                ]
            }),
            exitClickHandler: onClose
        })
    });
};
$5f2ae4d0ed2682a3$var$EmailInfoBody.propTypes = {
    emails: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};
$5f2ae4d0ed2682a3$export$269165b71d322095.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};





const $67f90a8960b70b46$export$4a5ede65b5ef2694 = ({ assessments: assessments, year: year })=>{
    const [detailConfirmModalVisibility, setDetailConfirmModalVisibility] = (0, $denZA.useState)(false);
    const [ongoingConfirmModalVisibility, setOngoingConfirmModalVisibility] = (0, $denZA.useState)(false);
    const confirmDetailedAssessmentExtract = ()=>{
        (0, $efadcd99fe5a20d2$export$63fbcc50745c2a8)(year, true);
        setDetailConfirmModalVisibility(false);
    };
    const confirmOngoingAssessmentExtract = ()=>{
        (0, $efadcd99fe5a20d2$export$63fbcc50745c2a8)(year, false);
        setOngoingConfirmModalVisibility(false);
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            detailConfirmModalVisibility && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
                header: "Detailed extract",
                body: "Are you sure you want to extract a detailed overview? It may take a few minutes and will be emailed to you.",
                onClose: ()=>setDetailConfirmModalVisibility(false),
                onConfirm: ()=>confirmDetailedAssessmentExtract()
            }),
            ongoingConfirmModalVisibility && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
                header: "Ongoing extract",
                body: "Are you sure you want to extract an ongoing overview? It may take a few minutes and will be emailed to you.",
                onClose: ()=>setOngoingConfirmModalVisibility(false),
                onConfirm: ()=>confirmOngoingAssessmentExtract()
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f), {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).Button, {
                        as: (0, $e032547b364b9976$export$353f5b6fc5456de1),
                        variant: "ghost",
                        leftIcon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6ef0069294a9d4e0$export$a7aaed3e118dd255), {}),
                        children: "Export..."
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).List, {
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).Item, {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ced9f3915d58a881$export$be11e187edb4cb0c), {}),
                                "aria-label": "Simple overview",
                                onClick: ()=>(0, $b571ea2e1852e598$export$445b39915a332cb3)(assessments, (0, $e0ec7ea48617281a$export$fdbf68ac597032b3).SIMPLE),
                                children: "Simple overview"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).Item, {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0e1ce20d7f28d919$export$65259f2909ebaca1), {}),
                                onClick: ()=>setOngoingConfirmModalVisibility(true),
                                children: "Ongoing overview"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).Item, {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0e1ce20d7f28d919$export$65259f2909ebaca1), {}),
                                onClick: ()=>setDetailConfirmModalVisibility(true),
                                children: "Detailed overview"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $26c2d3fcb4afcaa4$export$d9b273488cd8ce6f).Item, {
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4d8dcb27d34a01b0$export$7a3d1a91ed30f8c1), {}),
                                "aria-label": "Upload-ready overview",
                                onClick: ()=>(0, $b571ea2e1852e598$export$445b39915a332cb3)(assessments, (0, $e0ec7ea48617281a$export$fdbf68ac597032b3).UPLOAD_PREPARED),
                                children: "Upload-ready overview"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$67f90a8960b70b46$export$4a5ede65b5ef2694.propTypes = {
    assessments: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).array.isRequired,
    year: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number.isRequired
};




var $cvFNP = parcelRequire("cvFNP");


const $e015d19d07a0e9d5$var$rowCounterStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05
});
const $e015d19d07a0e9d5$export$878159a09675b041 = ({ numberOfFilteredRows: numberOfFilteredRows, searchText: searchText })=>{
    const filterString = searchText ? `${numberOfFilteredRows} result(s) for "${searchText}"` : `${numberOfFilteredRows} result(s)`;
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        css: $e015d19d07a0e9d5$var$rowCounterStyle,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
            "aria-label": "Table row count",
            children: filterString
        })
    });
};
$e015d19d07a0e9d5$export$878159a09675b041.propTypes = {
    numberOfFilteredRows: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number.isRequired,
    searchText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string
};




var $cvFNP = parcelRequire("cvFNP");



const $38742c9000cdba90$var$searchFieldWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'relative'
});
const $38742c9000cdba90$var$searchFieldStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 320,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40,
    boxShadow: `${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20} 0px 2px 0px 0px inset`,
    borderRadius: (0, $16681adf0d4cc247$export$bcd6882dc7e615be).borderRadius,
    cursor: 'pointer',
    color: 'inherit',
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3 - 1,
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10 - 1,
    '&:hover': {
        borderWidth: 2,
        borderColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60,
        padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3 - 2,
        paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10 - 2,
        boxShadow: 'none'
    },
    '&:focus': {
        borderWidth: 2,
        borderColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.information.base,
        padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3 - 2,
        paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10 - 2,
        boxShadow: 'none'
    },
    '&::placeholder': {
        color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase
    }
});
const $38742c9000cdba90$var$searchIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60,
    position: 'absolute',
    top: 14,
    left: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3,
    width: 20,
    height: 20
});
const $38742c9000cdba90$export$6a5f53a9c1177856 = ({ onChange: onChange, value: value })=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $38742c9000cdba90$var$searchFieldWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $95edb1f71c32a046$export$8278256c54fb93b2), {
                css: $38742c9000cdba90$var$searchIconStyle
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("input", {
                value: value,
                placeholder: "Customer Name, ID or C6 Name",
                css: $38742c9000cdba90$var$searchFieldStyle,
                onChange: (event)=>onChange(event.target.value)
            })
        ]
    });
};
$38742c9000cdba90$export$6a5f53a9c1177856.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string
};





const $b0459eaa6dae80b0$var$sectionDividerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    borderTop: `2px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20}`,
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none'
});
const $b0459eaa6dae80b0$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("hr", {
        css: $b0459eaa6dae80b0$var$sectionDividerStyle
    });




var $denZA = parcelRequire("denZA");


var $cvFNP = parcelRequire("cvFNP");


const $27593c6fdecfcced$var$overlayPortalStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    height: '80%',
    width: '100%',
    marginTop: 80,
    background: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    zIndex: 99
});
const $27593c6fdecfcced$export$2765eed43ca49790 = ({ children: children })=>{
    const overlayPortalRootDiv = document.getElementById('overlay');
    const overlayElement = document.createElement('div');
    (0, $denZA.useEffect)(()=>{
        overlayPortalRootDiv.appendChild(overlayElement);
        return ()=>overlayPortalRootDiv.removeChild(overlayElement);
    }, [
        overlayElement,
        overlayPortalRootDiv
    ]);
    return /*#__PURE__*/ (0, $d486a8928008256a$exports.createPortal)(/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        css: $27593c6fdecfcced$var$overlayPortalStyle,
        children: children
    }), overlayElement);
};
$27593c6fdecfcced$export$2765eed43ca49790.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired
};






var $cvFNP = parcelRequire("cvFNP");



var $cvFNP = parcelRequire("cvFNP");



const $5fcafb1845213d79$var$columnIndicatorIconStyle = (isSorted)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        color: isSorted ? 'inherit' : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate30,
        verticalAlign: 'middle',
        width: 14,
        height: 14
    });
const $5fcafb1845213d79$var$sortIndicatorStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
    marginLeft: -2,
    display: 'inline-block'
});
const $5fcafb1845213d79$export$3f662f979dcf35bd = ({ isSorted: isSorted, isSortedDesc: isSortedDesc, isSortDisabled: isSortDisabled })=>{
    if (isSortDisabled) return null;
    if (!isSorted) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
        css: $5fcafb1845213d79$var$sortIndicatorStyle,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $dea1de70a494ae92$export$61bdb2a1da0ccc8a), {
            css: $5fcafb1845213d79$var$columnIndicatorIconStyle(isSorted)
        })
    });
    if (isSortedDesc) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
        css: $5fcafb1845213d79$var$sortIndicatorStyle,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $59f86aa046643b08$export$a2ec4c6969a7d302), {
            css: $5fcafb1845213d79$var$columnIndicatorIconStyle(isSorted)
        })
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
        css: $5fcafb1845213d79$var$sortIndicatorStyle,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $7ff59cb23884fbb1$export$469287007f7d4034), {
            css: $5fcafb1845213d79$var$columnIndicatorIconStyle(isSorted)
        })
    });
};
$5fcafb1845213d79$export$3f662f979dcf35bd.propTypes = {
    isSorted: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    isSortedDesc: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    isSortDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};





var $cvFNP = parcelRequire("cvFNP");
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $277cd56d4262528f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2a7b365746ab9c66$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b52d557c67f70d48$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b52d557c67f70d48$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b52d557c67f70d48$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $82382837f5d1a6c6$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element) || !(0, $277cd56d4262528f$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $82382837f5d1a6c6$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element) || !(0, $277cd56d4262528f$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $82382837f5d1a6c6$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $82382837f5d1a6c6$var$applyStyles,
    effect: $82382837f5d1a6c6$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $f48e93490926663c$export$8960430cfd85939f = Math.max;
var $f48e93490926663c$export$96ec731ed4dcb222 = Math.min;
var $f48e93490926663c$export$2077e0241d6afd3c = Math.round;



function $fe9966722b97a02b$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $386b8515421d55ba$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fe9966722b97a02b$export$2e2bcd8739ae039)());
}


function $39105eae6943b862$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $f48e93490926663c$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $f48e93490926663c$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(element) ? (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $386b8515421d55ba$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $c30bfec733266966$export$2e2bcd8739ae039(node) {
    var win = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $8b03375bf11c395a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b710fd8a97e62b38$export$2e2bcd8739ae039(node) {
    if (node === (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(node) || !(0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(node)) return (0, $c30bfec733266966$export$2e2bcd8739ae039)(node);
    else return (0, $8b03375bf11c395a$export$2e2bcd8739ae039)(node);
}






function $785c6b222c65bef4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $fc59cb482ffd2688$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $39105eae6943b862$export$2e2bcd8739ae039)((0, $785c6b222c65bef4$export$2e2bcd8739ae039)(element)).left + (0, $c30bfec733266966$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $95e27b6e014cc04d$export$2e2bcd8739ae039(element) {
    return (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $2acf2445add8dd79$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $5778b7dd5bc5ecaa$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $f48e93490926663c$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $f48e93490926663c$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $5778b7dd5bc5ecaa$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(offsetParent) && $5778b7dd5bc5ecaa$var$isElementScaled(offsetParent);
    var documentElement = (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $39105eae6943b862$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $277cd56d4262528f$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2acf2445add8dd79$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b710fd8a97e62b38$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $39105eae6943b862$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $fc59cb482ffd2688$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $31f6fa6ed8273b72$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $39105eae6943b862$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $9bfeb54fa527c711$export$2e2bcd8739ae039(element) {
    if ((0, $277cd56d4262528f$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b52d557c67f70d48$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $d11fb36e0d438577$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $277cd56d4262528f$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(node) && (0, $2acf2445add8dd79$export$2e2bcd8739ae039)(node)) return node;
    return $d11fb36e0d438577$export$2e2bcd8739ae039((0, $9bfeb54fa527c711$export$2e2bcd8739ae039)(node));
}





function $f28515c7dbbe0b1f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $d11fb36e0d438577$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2acf2445add8dd79$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f28515c7dbbe0b1f$export$2e2bcd8739ae039((0, $9bfeb54fa527c711$export$2e2bcd8739ae039)(target)));
}







function $9c563672c55c56ad$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $277cd56d4262528f$export$2e2bcd8739ae039)(element)) >= 0;
}




function $e263a46b14a87585$var$getTrueOffsetParent(element) {
    if (!(0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e263a46b14a87585$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fe9966722b97a02b$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $fe9966722b97a02b$export$2e2bcd8739ae039)());
    if (isIE && (0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $9bfeb54fa527c711$export$2e2bcd8739ae039)(element);
    if ((0, $b52d557c67f70d48$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $277cd56d4262528f$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e263a46b14a87585$export$2e2bcd8739ae039(element) {
    var window = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(element);
    var offsetParent = $e263a46b14a87585$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $9c563672c55c56ad$export$2e2bcd8739ae039)(offsetParent) && (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $e263a46b14a87585$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $277cd56d4262528f$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $277cd56d4262528f$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $e263a46b14a87585$var$getContainingBlock(element) || window;
}


var $3ea948c6d29c5fd7$export$1e95b668f3b82d = 'top';
var $3ea948c6d29c5fd7$export$40e543e69a8b3fbb = 'bottom';
var $3ea948c6d29c5fd7$export$79ffe56a765070d2 = 'right';
var $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4 = 'left';
var $3ea948c6d29c5fd7$export$dfb5619354ba860 = 'auto';
var $3ea948c6d29c5fd7$export$aec2ce47c367b8c3 = [
    $3ea948c6d29c5fd7$export$1e95b668f3b82d,
    $3ea948c6d29c5fd7$export$40e543e69a8b3fbb,
    $3ea948c6d29c5fd7$export$79ffe56a765070d2,
    $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4
];
var $3ea948c6d29c5fd7$export$b3571188c770cc5a = 'start';
var $3ea948c6d29c5fd7$export$bd5df0f255a350f8 = 'end';
var $3ea948c6d29c5fd7$export$390fd549c5303b4d = 'clippingParents';
var $3ea948c6d29c5fd7$export$d7b7311ec04a3e8f = 'viewport';
var $3ea948c6d29c5fd7$export$ae5ab1c730825774 = 'popper';
var $3ea948c6d29c5fd7$export$ca50aac9f3ba507f = 'reference';
var $3ea948c6d29c5fd7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3ea948c6d29c5fd7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3ea948c6d29c5fd7$export$b3571188c770cc5a,
        placement + "-" + $3ea948c6d29c5fd7$export$bd5df0f255a350f8
    ]);
}, []);
var $3ea948c6d29c5fd7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3ea948c6d29c5fd7$export$aec2ce47c367b8c3, [
    $3ea948c6d29c5fd7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3ea948c6d29c5fd7$export$b3571188c770cc5a,
        placement + "-" + $3ea948c6d29c5fd7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3ea948c6d29c5fd7$export$421679a7c3d56e = 'beforeRead';
var $3ea948c6d29c5fd7$export$aafa59e2e03f2942 = 'read';
var $3ea948c6d29c5fd7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3ea948c6d29c5fd7$export$c65e99957a05207c = 'beforeMain';
var $3ea948c6d29c5fd7$export$f22da7240b7add18 = 'main';
var $3ea948c6d29c5fd7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3ea948c6d29c5fd7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3ea948c6d29c5fd7$export$68d8715fc104d294 = 'write';
var $3ea948c6d29c5fd7$export$70a6e5159acce2e6 = 'afterWrite';
var $3ea948c6d29c5fd7$export$d087d3878fdf71d5 = [
    $3ea948c6d29c5fd7$export$421679a7c3d56e,
    $3ea948c6d29c5fd7$export$aafa59e2e03f2942,
    $3ea948c6d29c5fd7$export$6964f6c886723980,
    $3ea948c6d29c5fd7$export$c65e99957a05207c,
    $3ea948c6d29c5fd7$export$f22da7240b7add18,
    $3ea948c6d29c5fd7$export$bab79516f2d662fe,
    $3ea948c6d29c5fd7$export$8d4d2d70e7d46032,
    $3ea948c6d29c5fd7$export$68d8715fc104d294,
    $3ea948c6d29c5fd7$export$70a6e5159acce2e6
];


function $341dc2f01f919e5c$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $341dc2f01f919e5c$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $341dc2f01f919e5c$var$order(modifiers); // order based on phase
    return (0, $3ea948c6d29c5fd7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $218627e5f0747a71$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $74c46e16d9c6e2a2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $08bb4ef319fd573a$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $08bb4ef319fd573a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $08bb4ef319fd573a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $08bb4ef319fd573a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $08bb4ef319fd573a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(reference) ? (0, $f28515c7dbbe0b1f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $f28515c7dbbe0b1f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $f28515c7dbbe0b1f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $341dc2f01f919e5c$export$2e2bcd8739ae039)((0, $74c46e16d9c6e2a2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$08bb4ef319fd573a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5778b7dd5bc5ecaa$export$2e2bcd8739ae039)(reference, (0, $e263a46b14a87585$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $31f6fa6ed8273b72$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $218627e5f0747a71$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$08bb4ef319fd573a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $08bb4ef319fd573a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $08bb4ef319fd573a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $24f7472f1f4a0901$var$passive = {
    passive: true
};
function $24f7472f1f4a0901$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $24f7472f1f4a0901$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $24f7472f1f4a0901$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $24f7472f1f4a0901$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $24f7472f1f4a0901$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $24f7472f1f4a0901$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $24f7472f1f4a0901$var$effect,
    data: {}
};



function $eab643d6691a7eda$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $950557caffdaffe4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ec0576d407e477eb$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $824193239d1164a6$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $950557caffdaffe4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $3ea948c6d29c5fd7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $3ea948c6d29c5fd7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ec0576d407e477eb$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $3ea948c6d29c5fd7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $3ea948c6d29c5fd7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $6cf68fe513ac41fc$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $824193239d1164a6$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6cf68fe513ac41fc$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $6cf68fe513ac41fc$var$popperOffsets,
    data: {}
};










var $87e26d2586943319$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $87e26d2586943319$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $f48e93490926663c$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $f48e93490926663c$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $87e26d2586943319$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4);
    var sideY = (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $e263a46b14a87585$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(popper);
            if ((0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d) || (placement === (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4) || placement === (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2)) && variation === (0, $3ea948c6d29c5fd7$export$bd5df0f255a350f8)) {
            sideY = (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4) || (placement === (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d) || placement === (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb)) && variation === (0, $3ea948c6d29c5fd7$export$bd5df0f255a350f8)) {
            sideX = (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $87e26d2586943319$var$unsetSides);
    var _ref4 = roundOffsets === true ? $87e26d2586943319$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $87e26d2586943319$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $950557caffdaffe4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $87e26d2586943319$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $87e26d2586943319$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $87e26d2586943319$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $87e26d2586943319$var$computeStyles,
    data: {}
};





function $dd3947560008ec48$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4),
        (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4),
        (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $dd3947560008ec48$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $3ea948c6d29c5fd7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $dd3947560008ec48$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $dd3947560008ec48$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $dd3947560008ec48$var$offset
};


var $ad5c6103a4e4b887$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $ad5c6103a4e4b887$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $ad5c6103a4e4b887$var$hash[matched];
    });
}



var $f7f7907efcb4fb72$var$hash = {
    start: 'end',
    end: 'start'
};
function $f7f7907efcb4fb72$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f7f7907efcb4fb72$var$hash[matched];
    });
}







function $64c3c36b95b20277$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2a7b365746ab9c66$export$2e2bcd8739ae039)(element);
    var html = (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $386b8515421d55ba$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $fc59cb482ffd2688$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $8589943bfea11bc9$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c30bfec733266966$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $f48e93490926663c$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $f48e93490926663c$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $fc59cb482ffd2688$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $f48e93490926663c$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $bd52adb0dfdcc480$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b52d557c67f70d48$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $15d00b07107ec2be$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $76fa0f07f21b73b1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $39105eae6943b862$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $76fa0f07f21b73b1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $3ea948c6d29c5fd7$export$d7b7311ec04a3e8f) ? (0, $15d00b07107ec2be$export$2e2bcd8739ae039)((0, $64c3c36b95b20277$export$2e2bcd8739ae039)(element, strategy)) : (0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(clippingParent) ? $76fa0f07f21b73b1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $15d00b07107ec2be$export$2e2bcd8739ae039)((0, $8589943bfea11bc9$export$2e2bcd8739ae039)((0, $785c6b222c65bef4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $76fa0f07f21b73b1$var$getClippingParents(element) {
    var clippingParents = (0, $f28515c7dbbe0b1f$export$2e2bcd8739ae039)((0, $9bfeb54fa527c711$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $95e27b6e014cc04d$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b52d557c67f70d48$export$1b3bfaa9684536aa)(element) ? (0, $e263a46b14a87585$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(clippingParent) && (0, $bd52adb0dfdcc480$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $277cd56d4262528f$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $76fa0f07f21b73b1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $76fa0f07f21b73b1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $76fa0f07f21b73b1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $f48e93490926663c$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f48e93490926663c$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f48e93490926663c$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f48e93490926663c$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $76fa0f07f21b73b1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $ab33f8902327541c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $59be6ef905d5db1d$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $ab33f8902327541c$export$2e2bcd8739ae039)(), paddingObject);
}


function $0bfef46debb293df$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f906e84820243ea9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $3ea948c6d29c5fd7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $3ea948c6d29c5fd7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $3ea948c6d29c5fd7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $59be6ef905d5db1d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0bfef46debb293df$export$2e2bcd8739ae039)(padding, (0, $3ea948c6d29c5fd7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $3ea948c6d29c5fd7$export$ae5ab1c730825774) ? (0, $3ea948c6d29c5fd7$export$ca50aac9f3ba507f) : (0, $3ea948c6d29c5fd7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $76fa0f07f21b73b1$export$2e2bcd8739ae039)((0, $b52d557c67f70d48$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $785c6b222c65bef4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $39105eae6943b862$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $824193239d1164a6$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $15d00b07107ec2be$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $3ea948c6d29c5fd7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $3ea948c6d29c5fd7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2),
                (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d),
                (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $55413bdac037c891$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $3ea948c6d29c5fd7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $950557caffdaffe4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $3ea948c6d29c5fd7$export$368f9a87e87fa4e1) : (0, $3ea948c6d29c5fd7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $950557caffdaffe4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $3ea948c6d29c5fd7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f906e84820243ea9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $0f0f06b2e94b8bd1$var$getExpandedFallbackPlacements(placement) {
    if ((0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement) === (0, $3ea948c6d29c5fd7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $ad5c6103a4e4b887$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f7f7907efcb4fb72$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f7f7907efcb4fb72$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $0f0f06b2e94b8bd1$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ad5c6103a4e4b887$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $0f0f06b2e94b8bd1$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement) === (0, $3ea948c6d29c5fd7$export$dfb5619354ba860) ? (0, $55413bdac037c891$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $950557caffdaffe4$export$2e2bcd8739ae039)(placement) === (0, $3ea948c6d29c5fd7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d),
            (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f906e84820243ea9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2) : (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb) : (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ad5c6103a4e4b887$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $ad5c6103a4e4b887$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $0f0f06b2e94b8bd1$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $0f0f06b2e94b8bd1$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $00b3a788dc8a7b39$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $2fc15534a7418623$export$f28d906d67a997f3(min, value, max) {
    return (0, $f48e93490926663c$export$8960430cfd85939f)(min, (0, $f48e93490926663c$export$96ec731ed4dcb222)(value, max));
}
function $2fc15534a7418623$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $2fc15534a7418623$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4a5a8662883fe79e$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f906e84820243ea9$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $950557caffdaffe4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ec0576d407e477eb$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $00b3a788dc8a7b39$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d) : (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb) : (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $3ea948c6d29c5fd7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $3ea948c6d29c5fd7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $31f6fa6ed8273b72$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $ab33f8902327541c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $2fc15534a7418623$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $e263a46b14a87585$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $2fc15534a7418623$export$f28d906d67a997f3)(tether ? (0, $f48e93490926663c$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $f48e93490926663c$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d) : (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb) : (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d),
            (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $2fc15534a7418623$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $2fc15534a7418623$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4a5a8662883fe79e$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4a5a8662883fe79e$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $16d609b05434c0bc$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $59be6ef905d5db1d$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $0bfef46debb293df$export$2e2bcd8739ae039)(padding, (0, $3ea948c6d29c5fd7$export$aec2ce47c367b8c3)));
};
function $16d609b05434c0bc$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $eab643d6691a7eda$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ec0576d407e477eb$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4),
        (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $16d609b05434c0bc$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $31f6fa6ed8273b72$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d) : (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb) : (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $e263a46b14a87585$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $2fc15534a7418623$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $16d609b05434c0bc$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $bd52adb0dfdcc480$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $16d609b05434c0bc$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $16d609b05434c0bc$var$arrow,
    effect: $16d609b05434c0bc$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $1f8ce72e9c90884e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $1f8ce72e9c90884e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $3ea948c6d29c5fd7$export$1e95b668f3b82d),
        (0, $3ea948c6d29c5fd7$export$79ffe56a765070d2),
        (0, $3ea948c6d29c5fd7$export$40e543e69a8b3fbb),
        (0, $3ea948c6d29c5fd7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $1f8ce72e9c90884e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f906e84820243ea9$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f906e84820243ea9$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $1f8ce72e9c90884e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $1f8ce72e9c90884e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $1f8ce72e9c90884e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $1f8ce72e9c90884e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $1f8ce72e9c90884e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $1f8ce72e9c90884e$var$hide
};




var $aef8cb85820460eb$export$d34966752335dd47 = [
    (0, $24f7472f1f4a0901$export$2e2bcd8739ae039),
    (0, $6cf68fe513ac41fc$export$2e2bcd8739ae039),
    (0, $87e26d2586943319$export$2e2bcd8739ae039),
    (0, $82382837f5d1a6c6$export$2e2bcd8739ae039),
    (0, $dd3947560008ec48$export$2e2bcd8739ae039),
    (0, $0f0f06b2e94b8bd1$export$2e2bcd8739ae039),
    (0, $4a5a8662883fe79e$export$2e2bcd8739ae039),
    (0, $16d609b05434c0bc$export$2e2bcd8739ae039),
    (0, $1f8ce72e9c90884e$export$2e2bcd8739ae039)
];
var $aef8cb85820460eb$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $08bb4ef319fd573a$export$ed5e13716264f202)({
    defaultModifiers: $aef8cb85820460eb$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $94e2b49e649ffc4e$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $94e2b49e649ffc4e$var$BOX_CLASS = "tippy-box";
var $94e2b49e649ffc4e$var$CONTENT_CLASS = "tippy-content";
var $94e2b49e649ffc4e$var$BACKDROP_CLASS = "tippy-backdrop";
var $94e2b49e649ffc4e$var$ARROW_CLASS = "tippy-arrow";
var $94e2b49e649ffc4e$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $94e2b49e649ffc4e$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $94e2b49e649ffc4e$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $94e2b49e649ffc4e$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $94e2b49e649ffc4e$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $94e2b49e649ffc4e$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $94e2b49e649ffc4e$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $94e2b49e649ffc4e$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $94e2b49e649ffc4e$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $94e2b49e649ffc4e$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $94e2b49e649ffc4e$var$normalizeToArray(value) {
    return [].concat(value);
}
function $94e2b49e649ffc4e$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $94e2b49e649ffc4e$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $94e2b49e649ffc4e$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $94e2b49e649ffc4e$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $94e2b49e649ffc4e$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $94e2b49e649ffc4e$var$div() {
    return document.createElement('div');
}
function $94e2b49e649ffc4e$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $94e2b49e649ffc4e$var$isType(value, type);
    });
}
function $94e2b49e649ffc4e$var$isNodeList(value) {
    return $94e2b49e649ffc4e$var$isType(value, 'NodeList');
}
function $94e2b49e649ffc4e$var$isMouseEvent(value) {
    return $94e2b49e649ffc4e$var$isType(value, 'MouseEvent');
}
function $94e2b49e649ffc4e$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $94e2b49e649ffc4e$var$getArrayOfElements(value) {
    if ($94e2b49e649ffc4e$var$isElement(value)) return [
        value
    ];
    if ($94e2b49e649ffc4e$var$isNodeList(value)) return $94e2b49e649ffc4e$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $94e2b49e649ffc4e$var$arrayFrom(document.querySelectorAll(value));
}
function $94e2b49e649ffc4e$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $94e2b49e649ffc4e$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $94e2b49e649ffc4e$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $94e2b49e649ffc4e$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $94e2b49e649ffc4e$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $94e2b49e649ffc4e$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $94e2b49e649ffc4e$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $94e2b49e649ffc4e$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $94e2b49e649ffc4e$var$currentInput = {
    isTouch: false
};
var $94e2b49e649ffc4e$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $94e2b49e649ffc4e$var$onDocumentTouchStart() {
    if ($94e2b49e649ffc4e$var$currentInput.isTouch) return;
    $94e2b49e649ffc4e$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $94e2b49e649ffc4e$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $94e2b49e649ffc4e$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $94e2b49e649ffc4e$var$lastMouseMoveTime < 20) {
        $94e2b49e649ffc4e$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $94e2b49e649ffc4e$var$onDocumentMouseMove);
    }
    $94e2b49e649ffc4e$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $94e2b49e649ffc4e$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($94e2b49e649ffc4e$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $94e2b49e649ffc4e$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $94e2b49e649ffc4e$var$onDocumentTouchStart, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $94e2b49e649ffc4e$var$onWindowBlur);
}
var $94e2b49e649ffc4e$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $94e2b49e649ffc4e$var$isIE11 = $94e2b49e649ffc4e$var$isBrowser ? !!window.msCrypto : false;
function $94e2b49e649ffc4e$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $94e2b49e649ffc4e$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $94e2b49e649ffc4e$var$getDevMessage(message) {
    return $94e2b49e649ffc4e$var$clean("\n  %ctippy.js\n\n  %c" + $94e2b49e649ffc4e$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $94e2b49e649ffc4e$var$getFormattedMessage(message) {
    return [
        $94e2b49e649ffc4e$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $94e2b49e649ffc4e$var$visitedMessages;
function $94e2b49e649ffc4e$var$resetVisitedMessages() {
    $94e2b49e649ffc4e$var$visitedMessages = new Set();
}
function $94e2b49e649ffc4e$var$warnWhen(condition, message) {
    if (condition && !$94e2b49e649ffc4e$var$visitedMessages.has(message)) {
        var _console;
        $94e2b49e649ffc4e$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $94e2b49e649ffc4e$var$getFormattedMessage(message));
    }
}
function $94e2b49e649ffc4e$var$errorWhen(condition, message) {
    if (condition && !$94e2b49e649ffc4e$var$visitedMessages.has(message)) {
        var _console2;
        $94e2b49e649ffc4e$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $94e2b49e649ffc4e$var$getFormattedMessage(message));
    }
}
function $94e2b49e649ffc4e$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $94e2b49e649ffc4e$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $94e2b49e649ffc4e$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $94e2b49e649ffc4e$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $94e2b49e649ffc4e$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $94e2b49e649ffc4e$var$defaultProps = Object.assign({
    appendTo: $94e2b49e649ffc4e$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $94e2b49e649ffc4e$var$pluginProps, $94e2b49e649ffc4e$var$renderProps);
var $94e2b49e649ffc4e$var$defaultKeys = Object.keys($94e2b49e649ffc4e$var$defaultProps);
var $94e2b49e649ffc4e$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $94e2b49e649ffc4e$var$defaultProps[key] = partialProps[key];
    });
};
function $94e2b49e649ffc4e$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $94e2b49e649ffc4e$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $94e2b49e649ffc4e$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($94e2b49e649ffc4e$var$getExtendedPassedProps(Object.assign({}, $94e2b49e649ffc4e$var$defaultProps, {
        plugins: plugins
    }))) : $94e2b49e649ffc4e$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $94e2b49e649ffc4e$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $94e2b49e649ffc4e$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $94e2b49e649ffc4e$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $94e2b49e649ffc4e$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $94e2b49e649ffc4e$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $94e2b49e649ffc4e$var$removeProperties($94e2b49e649ffc4e$var$defaultProps, Object.keys($94e2b49e649ffc4e$var$pluginProps));
        var didPassUnknownProp = !$94e2b49e649ffc4e$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $94e2b49e649ffc4e$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $94e2b49e649ffc4e$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $94e2b49e649ffc4e$var$dangerouslySetInnerHTML(element, html) {
    element[$94e2b49e649ffc4e$var$innerHTML()] = html;
}
function $94e2b49e649ffc4e$var$createArrowElement(value) {
    var arrow = $94e2b49e649ffc4e$var$div();
    if (value === true) arrow.className = $94e2b49e649ffc4e$var$ARROW_CLASS;
    else {
        arrow.className = $94e2b49e649ffc4e$var$SVG_ARROW_CLASS;
        if ($94e2b49e649ffc4e$var$isElement(value)) arrow.appendChild(value);
        else $94e2b49e649ffc4e$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $94e2b49e649ffc4e$var$setContent(content, props) {
    if ($94e2b49e649ffc4e$var$isElement(props.content)) {
        $94e2b49e649ffc4e$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $94e2b49e649ffc4e$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $94e2b49e649ffc4e$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $94e2b49e649ffc4e$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($94e2b49e649ffc4e$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($94e2b49e649ffc4e$var$ARROW_CLASS) || node.classList.contains($94e2b49e649ffc4e$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($94e2b49e649ffc4e$var$BACKDROP_CLASS);
        })
    };
}
function $94e2b49e649ffc4e$var$render(instance) {
    var popper = $94e2b49e649ffc4e$var$div();
    var box = $94e2b49e649ffc4e$var$div();
    box.className = $94e2b49e649ffc4e$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $94e2b49e649ffc4e$var$div();
    content.className = $94e2b49e649ffc4e$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $94e2b49e649ffc4e$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $94e2b49e649ffc4e$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $94e2b49e649ffc4e$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($94e2b49e649ffc4e$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($94e2b49e649ffc4e$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$94e2b49e649ffc4e$var$render.$$tippy = true;
var $94e2b49e649ffc4e$var$idCounter = 1;
var $94e2b49e649ffc4e$var$mouseMoveListeners = []; // Used by `hideAll()`
var $94e2b49e649ffc4e$var$mountedInstances = [];
function $94e2b49e649ffc4e$var$createTippy(reference, passedProps) {
    var props = $94e2b49e649ffc4e$var$evaluateProps(reference, Object.assign({}, $94e2b49e649ffc4e$var$defaultProps, $94e2b49e649ffc4e$var$getExtendedPassedProps($94e2b49e649ffc4e$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $94e2b49e649ffc4e$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $94e2b49e649ffc4e$var$idCounter++;
    var popperInstance = null;
    var plugins = $94e2b49e649ffc4e$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $94e2b49e649ffc4e$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $94e2b49e649ffc4e$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $94e2b49e649ffc4e$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $94e2b49e649ffc4e$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $94e2b49e649ffc4e$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $94e2b49e649ffc4e$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $94e2b49e649ffc4e$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $94e2b49e649ffc4e$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $94e2b49e649ffc4e$var$mouseMoveListeners = $94e2b49e649ffc4e$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($94e2b49e649ffc4e$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $94e2b49e649ffc4e$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($94e2b49e649ffc4e$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $94e2b49e649ffc4e$var$actualContains(el, actualTarget);
        })) {
            if ($94e2b49e649ffc4e$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $94e2b49e649ffc4e$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $94e2b49e649ffc4e$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $94e2b49e649ffc4e$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $94e2b49e649ffc4e$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $94e2b49e649ffc4e$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($94e2b49e649ffc4e$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $94e2b49e649ffc4e$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $94e2b49e649ffc4e$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($94e2b49e649ffc4e$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $94e2b49e649ffc4e$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $94e2b49e649ffc4e$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $aef8cb85820460eb$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $94e2b49e649ffc4e$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $94e2b49e649ffc4e$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $94e2b49e649ffc4e$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($94e2b49e649ffc4e$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $94e2b49e649ffc4e$var$evaluateProps(reference, Object.assign({}, prevProps, $94e2b49e649ffc4e$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $94e2b49e649ffc4e$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $94e2b49e649ffc4e$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $94e2b49e649ffc4e$var$currentInput.isTouch && !instance.props.touch;
        var duration = $94e2b49e649ffc4e$var$getValueAtIndexOrReturn(instance.props.duration, 0, $94e2b49e649ffc4e$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $94e2b49e649ffc4e$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $94e2b49e649ffc4e$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $94e2b49e649ffc4e$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $94e2b49e649ffc4e$var$pushIfUnique($94e2b49e649ffc4e$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $94e2b49e649ffc4e$var$getValueAtIndexOrReturn(instance.props.duration, 1, $94e2b49e649ffc4e$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $94e2b49e649ffc4e$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $94e2b49e649ffc4e$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $94e2b49e649ffc4e$var$pushIfUnique($94e2b49e649ffc4e$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $94e2b49e649ffc4e$var$mountedInstances = $94e2b49e649ffc4e$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $94e2b49e649ffc4e$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $94e2b49e649ffc4e$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $94e2b49e649ffc4e$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $94e2b49e649ffc4e$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $94e2b49e649ffc4e$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $94e2b49e649ffc4e$var$isElement(targets) ? instances[0] : instances;
}
$94e2b49e649ffc4e$var$tippy.defaultProps = $94e2b49e649ffc4e$var$defaultProps;
$94e2b49e649ffc4e$var$tippy.setDefaultProps = $94e2b49e649ffc4e$var$setDefaultProps;
$94e2b49e649ffc4e$var$tippy.currentInput = $94e2b49e649ffc4e$var$currentInput;
var $94e2b49e649ffc4e$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $94e2b49e649ffc4e$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $94e2b49e649ffc4e$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $94e2b49e649ffc4e$var$applyStylesModifier = Object.assign({}, (0, $82382837f5d1a6c6$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $94e2b49e649ffc4e$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $94e2b49e649ffc4e$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $94e2b49e649ffc4e$var$tippy($94e2b49e649ffc4e$var$div(), Object.assign({}, $94e2b49e649ffc4e$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $94e2b49e649ffc4e$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $94e2b49e649ffc4e$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $94e2b49e649ffc4e$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $94e2b49e649ffc4e$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $94e2b49e649ffc4e$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $94e2b49e649ffc4e$var$tippy(targets, parentProps);
    var normalizedReturnValue = $94e2b49e649ffc4e$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $94e2b49e649ffc4e$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($94e2b49e649ffc4e$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $94e2b49e649ffc4e$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $94e2b49e649ffc4e$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $94e2b49e649ffc4e$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $94e2b49e649ffc4e$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $94e2b49e649ffc4e$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $94e2b49e649ffc4e$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $94e2b49e649ffc4e$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $94e2b49e649ffc4e$var$createBackdropElement() {
    var backdrop = $94e2b49e649ffc4e$var$div();
    backdrop.className = $94e2b49e649ffc4e$var$BACKDROP_CLASS;
    $94e2b49e649ffc4e$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $94e2b49e649ffc4e$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $94e2b49e649ffc4e$var$activeInstances = [];
function $94e2b49e649ffc4e$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $94e2b49e649ffc4e$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $94e2b49e649ffc4e$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $94e2b49e649ffc4e$var$storeMouseCoords);
}
function $94e2b49e649ffc4e$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $94e2b49e649ffc4e$var$storeMouseCoords);
}
var $94e2b49e649ffc4e$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $94e2b49e649ffc4e$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $94e2b49e649ffc4e$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $94e2b49e649ffc4e$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $94e2b49e649ffc4e$var$activeInstances = $94e2b49e649ffc4e$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($94e2b49e649ffc4e$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $94e2b49e649ffc4e$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($94e2b49e649ffc4e$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($94e2b49e649ffc4e$var$isMouseEvent(event)) $94e2b49e649ffc4e$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $94e2b49e649ffc4e$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $94e2b49e649ffc4e$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $94e2b49e649ffc4e$var$getInlineBoundingClientRect($94e2b49e649ffc4e$var$getBasePlacement(placement), reference.getBoundingClientRect(), $94e2b49e649ffc4e$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($94e2b49e649ffc4e$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($94e2b49e649ffc4e$var$isMouseEvent(event)) {
                    var rects = $94e2b49e649ffc4e$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $94e2b49e649ffc4e$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $94e2b49e649ffc4e$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $94e2b49e649ffc4e$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $94e2b49e649ffc4e$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $94e2b49e649ffc4e$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$94e2b49e649ffc4e$var$tippy.setDefaultProps({
    render: $94e2b49e649ffc4e$var$render
});
var $94e2b49e649ffc4e$export$2e2bcd8739ae039 = $94e2b49e649ffc4e$var$tippy;



var $denZA = parcelRequire("denZA");

function $d7944433e945644a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d7944433e945644a$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function $d7944433e945644a$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === 'function') ref(node);
        if (({}).hasOwnProperty.call(ref, 'current')) ref.current = node;
    }
}
function $d7944433e945644a$var$ssrSafeCreateDiv() {
    return $d7944433e945644a$var$isBrowser && document.createElement('div');
}
function $d7944433e945644a$var$toDataAttributes(attrs) {
    var dataAttrs = {
        'data-placement': attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs['data-reference-hidden'] = '';
    if (attrs.escaped) dataAttrs['data-escaped'] = '';
    return dataAttrs;
}
function $d7944433e945644a$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$d7944433e945644a$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $d7944433e945644a$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $d7944433e945644a$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $d7944433e945644a$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $d7944433e945644a$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $d7944433e945644a$var$useIsomorphicLayoutEffect = $d7944433e945644a$var$isBrowser ? (0, $denZA.useLayoutEffect) : (0, $denZA.useEffect);
function $d7944433e945644a$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $denZA.useRef)();
    if (!ref.current) ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    return ref.current;
}
function $d7944433e945644a$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $d7944433e945644a$var$classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            $d7944433e945644a$var$updateClassName(box, 'add', instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $d7944433e945644a$var$updateClassName(box, 'remove', instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $d7944433e945644a$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $d7944433e945644a$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $denZA.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $denZA.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $denZA.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $d7944433e945644a$var$useMutableBox(function() {
            return {
                container: $d7944433e945644a$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = 'manual';
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(_, event) {
                                var _singleton$data$child = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                }), content = _singleton$data$child.content;
                                setSingletonContent(content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $d7944433e945644a$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty('current')) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $d7944433e945644a$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $d7944433e945644a$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $d7944433e945644a$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($d7944433e945644a$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps
            });
        });
        $d7944433e945644a$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== '$$tippyReact';
                    }), [
                        {
                            name: '$$tippyReact',
                            enabled: true,
                            phase: 'beforeWrite',
                            requires: [
                                'computeStyles'
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Fragment, null, children ? /*#__PURE__*/ (0, $denZA.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $d7944433e945644a$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $d486a8928008256a$exports.createPortal)(render ? render($d7944433e945644a$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $d7944433e945644a$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $denZA.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $d7944433e945644a$var$useMutableBox({
            children: [],
            renders: 1
        });
        $d7944433e945644a$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $d7944433e945644a$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $d7944433e945644a$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $d7944433e945644a$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($d7944433e945644a$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $denZA.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    if (!mutableBox.children.find(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance === instance;
                    })) {
                        mutableBox.children.push(data);
                        if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                            return child.instance;
                        }));
                    }
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $d7944433e945644a$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $denZA.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $d7944433e945644a$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $denZA.cloneElement)(children, {
            ref: function ref(node) {
                $d7944433e945644a$var$preserveRef(_ref2, node);
                $d7944433e945644a$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $d7944433e945644a$export$abf4268d2dd55708 = /*#__PURE__*/ $d7944433e945644a$var$useSingletonGenerator((0, $94e2b49e649ffc4e$export$374c483667c1ea9b));
var $d7944433e945644a$var$index = /*#__PURE__*/ $d7944433e945644a$var$forwardRef(/*#__PURE__*/ $d7944433e945644a$var$TippyGenerator((0, $94e2b49e649ffc4e$export$2e2bcd8739ae039)));
var $d7944433e945644a$export$2e2bcd8739ae039 = $d7944433e945644a$var$index;


const $019fe9963dbd4bd2$export$37fbedb22300720e = {
    theme: 'klik',
    delay: 2000,
    placement: 'bottom'
};




const $6c17e076bc3c1336$export$28c660c63b792dea = ({ children: children, ...props })=>{
    const tooltipProps = {
        ...(0, $019fe9963dbd4bd2$export$37fbedb22300720e),
        ...props
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d7944433e945644a$export$2e2bcd8739ae039), {
        ...tooltipProps,
        children: children
    });
};
$6c17e076bc3c1336$export$28c660c63b792dea.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired,
    rest: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object
};


const $9e1e626f3963028b$var$headerWrapperStyle = (isCentered, isSortable)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        textAlign: isCentered ? 'center' : 'left',
        marginLeft: isSortable ? -(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4 : 0
    });
const $9e1e626f3963028b$export$6b714dc14f6551e3 = ({ column: column })=>{
    const { headerText: headerText, isCentered: isCentered, canSort: canSort, tooltipText: tooltipText = '' } = column;
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $9e1e626f3963028b$var$headerWrapperStyle(isCentered, canSort),
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $5fcafb1845213d79$export$3f662f979dcf35bd), {
                isSorted: column.isSorted,
                isSortedDesc: column.isSortedDesc || false,
                isSortDisabled: column.disableSortBy
            }),
            tooltipText ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6c17e076bc3c1336$export$28c660c63b792dea), {
                content: tooltipText,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                    children: headerText
                })
            }) : headerText
        ]
    });
};
$9e1e626f3963028b$export$6b714dc14f6551e3.propTypes = {
    column: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};




var $cvFNP = parcelRequire("cvFNP");


const $7cd80050a7bba4bc$var$scoreWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    textAlign: 'center'
});
const $7cd80050a7bba4bc$var$negativeYoyChangeStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: 'red'
});
const $7cd80050a7bba4bc$var$positiveYoyChangeStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: 'green'
});
const $7cd80050a7bba4bc$var$neutralYoyChangeStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: 'black'
});
const $7cd80050a7bba4bc$var$getScoreCellStyle = (yoyChange)=>{
    if (yoyChange > 0) return $7cd80050a7bba4bc$var$positiveYoyChangeStyle;
    if (yoyChange < 0) return $7cd80050a7bba4bc$var$negativeYoyChangeStyle;
    return $7cd80050a7bba4bc$var$neutralYoyChangeStyle;
};
const $7cd80050a7bba4bc$export$f5b45ecebe02b894 = ({ cell: { value: value }, row: row })=>{
    const yoyChange = row.original.lastYearScore !== null && row.original.lastYearScore !== undefined ? value - row.original.lastYearScore : undefined;
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $7cd80050a7bba4bc$var$scoreWrapperStyle,
        children: [
            value && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                children: `${value}%`
            }),
            yoyChange !== undefined && (0, $d306a6c16d4d2f55$export$e71e4e95f4a82c)(row.original.status) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $7cd80050a7bba4bc$var$getScoreCellStyle(yoyChange),
                children: ` (${yoyChange > 0 ? '+' : ''}${yoyChange}%)`
            })
        ]
    });
};
$7cd80050a7bba4bc$export$f5b45ecebe02b894.propTypes = {
    cell: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
    }).isRequired,
    row: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).shape({
        original: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).shape({
            lastYearScore: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
            status: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string
        })
    }).isRequired
};




var $cvFNP = parcelRequire("cvFNP");


var $cvFNP = parcelRequire("cvFNP");



const $9cea4ea57bddd7f2$var$wrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'center'
});
const $9cea4ea57bddd7f2$var$getColor = (status)=>{
    switch(status){
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).ASSESSMENT:
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).SELF_ASSESSMENT:
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).RE_ASSESSMENT:
            return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate300;
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).REVIEW:
            return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.copper.copper200;
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).APPROVAL:
            return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.copper.copper400;
        case (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).COMPLETED:
            return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.success.success400;
        default:
            return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40;
    }
};
const $9cea4ea57bddd7f2$var$colorStyle = (color)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
        flexShrink: 0
    });
const $9cea4ea57bddd7f2$export$a17e6a3e41121fbb = ({ status: status })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $9cea4ea57bddd7f2$var$wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $9cea4ea57bddd7f2$var$colorStyle($9cea4ea57bddd7f2$var$getColor(status))
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                children: (0, $d306a6c16d4d2f55$export$da623606ae5dad1e)[status]
            })
        ]
    });
$9cea4ea57bddd7f2$export$a17e6a3e41121fbb.propTypes = {
    status: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};


const $6fd7ebeb50636927$export$f71dcd7f3896fe01 = ({ cell: { value: value } })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9cea4ea57bddd7f2$export$a17e6a3e41121fbb), {
        status: value
    });
$6fd7ebeb50636927$export$f71dcd7f3896fe01.propTypes = {
    cell: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};




var $cvFNP = parcelRequire("cvFNP");

const $723f65fff6004c0f$export$1d619f290abf5760 = ({ cell: { value: value } })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: value && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
            children: (0, $2d047b1a9208cb87$export$4d05fce67b78a97f)(value)
        })
    });
$723f65fff6004c0f$export$1d619f290abf5760.propTypes = {
    cell: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};






const $eb82deaf4ba6ca9a$export$2216345509a99ba0 = (rowA, rowB, id)=>{
    const rowAStatusTranslated = (0, $d306a6c16d4d2f55$export$da623606ae5dad1e)[rowA.original[id]];
    const rowBStatusTranslated = (0, $d306a6c16d4d2f55$export$da623606ae5dad1e)[rowB.original[id]];
    if (rowAStatusTranslated[0] > rowBStatusTranslated[0]) return 1;
    if (rowBStatusTranslated[0] > rowAStatusTranslated[0]) return -1;
    return 0;
};


const $7c1ece22f3461b0d$export$4799ea63767e181 = [
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).C6_NAME,
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).C6_NAME],
        sortType: 'string'
    },
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CUSTOMER_NAME,
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CUSTOMER_NAME],
        sortType: 'string'
    },
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CHANNEL,
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).CHANNEL],
        sortType: 'string'
    },
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        id: 'status',
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).STATUS,
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).STATUS],
        Cell: (0, $6fd7ebeb50636927$export$f71dcd7f3896fe01),
        sortType: (0, $eb82deaf4ba6ca9a$export$2216345509a99ba0)
    },
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).NEXT_ACTION_BY,
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).NEXT_ACTION_BY],
        sortType: 'string',
        Cell: (0, $723f65fff6004c0f$export$1d619f290abf5760),
        tooltipText: 'Next role to take action'
    },
    {
        Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
        headerText: (0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).SCORE + ' (YoY Change)',
        accessor: (0, $31252dd7ad7167e8$export$32b266158f847227)[(0, $31252dd7ad7167e8$export$b7c2735e3cb0dd55).SCORE],
        Cell: (0, $7cd80050a7bba4bc$export$f5b45ecebe02b894),
        isCentered: true
    }
];





var $cvFNP = parcelRequire("cvFNP");


const $17c85406e190f8b6$var$headingSizes = {
    h1: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size4,
        lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
        margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size16}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size8}px`,
        mobile: {
            margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px`,
            fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size3,
            lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s
        }
    },
    h2: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size3,
        lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
        margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px`,
        mobile: {
            margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size8}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`,
            fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size2,
            lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s
        }
    },
    h3: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
        lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
        margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`,
        mobile: {
            margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2}px`,
            fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
            lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s
        }
    }
};
const $17c85406e190f8b6$var$defaultHeaderMargin = `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size8}px`;
const $17c85406e190f8b6$var$headingStyle = (type, additionalStyles)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
        fontSize: $17c85406e190f8b6$var$headingSizes[type]?.mobile.fontSize || (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size3,
        lineHeight: $17c85406e190f8b6$var$headingSizes[type]?.mobile.lineHeight || (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
        margin: $17c85406e190f8b6$var$headingSizes[type]?.mobile.margin || $17c85406e190f8b6$var$defaultHeaderMargin,
        [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
            fontSize: $17c85406e190f8b6$var$headingSizes[type]?.fontSize || (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size4,
            lineHeight: $17c85406e190f8b6$var$headingSizes[type]?.lineHeight || (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
            margin: $17c85406e190f8b6$var$headingSizes[type]?.mobile.margin || $17c85406e190f8b6$var$defaultHeaderMargin
        }
    }, additionalStyles);
const $17c85406e190f8b6$export$a8a3e93435678ff9 = ({ type: type, text: text, additionalStyles: additionalStyles, ...props })=>{
    return (0, $e30926212b3658f1$export$34b9dba7ce09269b)(type, {
        css: $17c85406e190f8b6$var$headingStyle(type, additionalStyles),
        ...props
    }, text);
};
$17c85406e190f8b6$export$a8a3e93435678ff9.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    additionalStyles: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object
};




var $59f96692d36467c9$export$2e2bcd8739ae039 = function() {
    function ApmBase(serviceFactory, disable) {
        this._disable = disable;
        this.serviceFactory = serviceFactory;
        this._initialized = false;
    }
    var _proto = ApmBase.prototype;
    _proto.isEnabled = function isEnabled() {
        return !this._disable;
    };
    _proto.isActive = function isActive() {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        return this.isEnabled() && this._initialized && configService.get('active');
    };
    _proto.init = function init(config) {
        var _this = this;
        if (this.isEnabled() && !this._initialized) {
            this._initialized = true;
            var _this$serviceFactory$ = this.serviceFactory.getService([
                (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
                (0, $c898cf419eb79f2e$export$7d973190a36b8246),
                (0, $c898cf419eb79f2e$export$ab6389d1a16bebfe)
            ]), configService = _this$serviceFactory$[0], loggingService = _this$serviceFactory$[1], transactionService = _this$serviceFactory$[2];
            configService.setVersion('5.17.5');
            this.config(config);
            var logLevel = configService.get('logLevel');
            loggingService.setLevel(logLevel);
            var isConfigActive = configService.get('active');
            if (isConfigActive) {
                this.serviceFactory.init();
                var flags = (0, $247879c48c5f39e8$export$7852da8de47c1ce0)(configService.get('instrument'), configService.get('disableInstrumentations'));
                var performanceMonitoring = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$6a0f49a7699bafca));
                performanceMonitoring.init(flags);
                if (flags[0, $c898cf419eb79f2e$export$103bedf43ba882db]) {
                    var errorLogging = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$3bb4e88cf5c5fd65));
                    errorLogging.registerListeners();
                }
                if (configService.get('session')) {
                    var localConfig = configService.getLocalConfig();
                    if (localConfig && localConfig.session) configService.setConfig({
                        session: localConfig.session
                    });
                }
                var sendPageLoad = function sendPageLoad() {
                    return flags[0, $c898cf419eb79f2e$export$1502f4f8c48fa539] && _this._sendPageLoadMetrics();
                };
                if (configService.get('centralConfig')) this.fetchCentralConfig().then(sendPageLoad);
                else sendPageLoad();
                (0, $3bc8b32fdc9b2fad$export$469e44f8217c68b6)(configService, transactionService);
                if (flags[0, $c898cf419eb79f2e$export$2c4d7da089dce968] && flags[0, $c898cf419eb79f2e$export$cb5542418ddbb7ed]) (0, $3b23f4b50f745e9c$export$1f926008e0357783)(transactionService);
                (0, $ba6dda3f504fe70c$export$57066f288181694e)();
            } else {
                this._disable = true;
                loggingService.warn('RUM agent is inactive');
            }
        }
        return this;
    };
    _proto.fetchCentralConfig = function fetchCentralConfig() {
        var _this$serviceFactory$2 = this.serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$8f8a420bfb2d7e37),
            (0, $c898cf419eb79f2e$export$7d973190a36b8246),
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b)
        ]), apmServer = _this$serviceFactory$2[0], loggingService = _this$serviceFactory$2[1], configService = _this$serviceFactory$2[2];
        return apmServer.fetchConfig(configService.get('serviceName'), configService.get('environment')).then(function(config) {
            var transactionSampleRate = config['transaction_sample_rate'];
            if (transactionSampleRate) {
                transactionSampleRate = Number(transactionSampleRate);
                var _config2 = {
                    transactionSampleRate: transactionSampleRate
                };
                var _configService$valida = configService.validate(_config2), invalid = _configService$valida.invalid;
                if (invalid.length === 0) configService.setConfig(_config2);
                else {
                    var _invalid$ = invalid[0], key = _invalid$.key, value = _invalid$.value, allowed = _invalid$.allowed;
                    loggingService.warn("invalid value \"" + value + "\" for " + key + ". Allowed: " + allowed + ".");
                }
            }
            return config;
        }).catch(function(error) {
            loggingService.warn('failed fetching config:', error);
        });
    };
    _proto._sendPageLoadMetrics = function _sendPageLoadMetrics() {
        var tr = this.startTransaction(undefined, (0, $c898cf419eb79f2e$export$1502f4f8c48fa539), {
            managed: true,
            canReuse: true
        });
        if (!tr) return;
        tr.addTask((0, $c898cf419eb79f2e$export$1502f4f8c48fa539));
        var sendPageLoadMetrics = function sendPageLoadMetrics() {
            setTimeout(function() {
                return tr.removeTask((0, $c898cf419eb79f2e$export$1502f4f8c48fa539));
            }, (0, $c898cf419eb79f2e$export$b78d68e75d8e9dad));
        };
        if (document.readyState === 'complete') sendPageLoadMetrics();
        else window.addEventListener('load', sendPageLoadMetrics);
    };
    _proto.observe = function observe(name, fn) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.events.observe(name, fn);
    };
    _proto.config = function config(_config) {
        var _this$serviceFactory$3 = this.serviceFactory.getService([
            (0, $c898cf419eb79f2e$export$11170dadd5705a7b),
            (0, $c898cf419eb79f2e$export$7d973190a36b8246)
        ]), configService = _this$serviceFactory$3[0], loggingService = _this$serviceFactory$3[1];
        var _configService$valida2 = configService.validate(_config), missing = _configService$valida2.missing, invalid = _configService$valida2.invalid, unknown = _configService$valida2.unknown;
        if (unknown.length > 0) {
            var message = 'Unknown config options are specified for RUM agent: ' + unknown.join(', ');
            loggingService.warn(message);
        }
        if (missing.length === 0 && invalid.length === 0) configService.setConfig(_config);
        else {
            var separator = ', ';
            var _message = "RUM agent isn't correctly configured. ";
            if (missing.length > 0) {
                _message += missing.join(separator) + ' is missing';
                if (invalid.length > 0) _message += separator;
            }
            invalid.forEach(function(_ref, index) {
                var key = _ref.key, value = _ref.value, allowed = _ref.allowed;
                _message += key + " \"" + value + "\" contains invalid characters! (allowed: " + allowed + ")" + (index !== invalid.length - 1 ? separator : '');
            });
            loggingService.error(_message);
            configService.setConfig({
                active: false
            });
        }
    };
    _proto.setUserContext = function setUserContext(userContext) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setUserContext(userContext);
    };
    _proto.setCustomContext = function setCustomContext(customContext) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setCustomContext(customContext);
    };
    _proto.addLabels = function addLabels(labels) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.addLabels(labels);
    };
    _proto.setInitialPageLoadName = function setInitialPageLoadName(name) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.setConfig({
            pageLoadTransactionName: name
        });
    };
    _proto.startTransaction = function startTransaction(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.startTransaction(name, type, options);
        }
    };
    _proto.startSpan = function startSpan(name, type, options) {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.startSpan(name, type, options);
        }
    };
    _proto.getCurrentTransaction = function getCurrentTransaction() {
        if (this.isEnabled()) {
            var transactionService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$ab6389d1a16bebfe));
            return transactionService.getCurrentTransaction();
        }
    };
    _proto.captureError = function captureError(error, opts) {
        if (this.isEnabled()) {
            var errorLogging = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$3bb4e88cf5c5fd65));
            return errorLogging.logError(error, opts);
        }
    };
    _proto.addFilter = function addFilter(fn) {
        var configService = this.serviceFactory.getService((0, $c898cf419eb79f2e$export$11170dadd5705a7b));
        configService.addFilter(fn);
    };
    return ApmBase;
}();


function $3f39a533616cca00$var$getApmBase() {
    if ((0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) && window.elasticApm) return window.elasticApm;
    var enabled = (0, $770f7a375fe5760b$export$36aff1fbb4f5dfc6)();
    var serviceFactory = (0, $3464366cc857c1ff$export$791d8bdb130abda4)();
    var apmBase = new (0, $59f96692d36467c9$export$2e2bcd8739ae039)(serviceFactory, !enabled);
    if (0, $81ba5eca3c0826ee$export$4e09c449d6c407f7) window.elasticApm = apmBase;
    return apmBase;
}
var $3f39a533616cca00$export$66cd81c234b843ce = $3f39a533616cca00$var$getApmBase();
var $3f39a533616cca00$export$2cd8252107eb640b = $3f39a533616cca00$export$66cd81c234b843ce.init.bind($3f39a533616cca00$export$66cd81c234b843ce);
var $3f39a533616cca00$export$2e2bcd8739ae039 = $3f39a533616cca00$export$2cd8252107eb640b;



var $denZA = parcelRequire("denZA");


function $ef61c580367d2484$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ef61c580367d2484$var$_setPrototypeOf(subClass, superClass);
}
function $ef61c580367d2484$var$_setPrototypeOf(o, p) {
    $ef61c580367d2484$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ef61c580367d2484$var$_setPrototypeOf(o, p);
}
function $ef61c580367d2484$var$_extends() {
    $ef61c580367d2484$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef61c580367d2484$var$_extends.apply(this, arguments);
}
function $ef61c580367d2484$var$_slicedToArray(arr, i) {
    return $ef61c580367d2484$var$_arrayWithHoles(arr) || $ef61c580367d2484$var$_iterableToArrayLimit(arr, i) || $ef61c580367d2484$var$_unsupportedIterableToArray(arr, i) || $ef61c580367d2484$var$_nonIterableRest();
}
function $ef61c580367d2484$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef61c580367d2484$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ef61c580367d2484$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ef61c580367d2484$var$_arrayLikeToArray(o, minLen);
}
function $ef61c580367d2484$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ef61c580367d2484$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ef61c580367d2484$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ef61c580367d2484$var$isReactClassComponent(Component) {
    var prototype = Component.prototype;
    return !!(prototype && prototype.isReactComponent);
}
function $ef61c580367d2484$export$8968e64b6e3c0a85(apm) {
    return function withTransaction(name, type, callback) {
        if (callback === void 0) callback = function callback() {};
        return function(Component) {
            if (!apm.isActive()) return Component;
            if (!Component) {
                var loggingService = apm.serviceFactory.getService((0, $c898cf419eb79f2e$export$7d973190a36b8246));
                loggingService.warn(name + " is not instrumented since component property is not provided");
                return Component;
            }
            var ApmComponent = null;
            if (!$ef61c580367d2484$var$isReactClassComponent(Component) && typeof (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useEffect === 'function' && typeof (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useState === 'function') ApmComponent = function ApmComponent(props) {
                var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useState(function() {
                    var tr = apm.startTransaction(name, type, {
                        managed: true,
                        canReuse: true
                    });
                    callback(tr, props);
                    return tr;
                }), _React$useState2 = $ef61c580367d2484$var$_slicedToArray(_React$useState, 1), transaction = _React$useState2[0];
                (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).useEffect(function() {
                    (0, $9bc6b1e8af275af3$export$2e2bcd8739ae039)(function() {
                        return transaction && transaction.detectFinish();
                    });
                    return function() {
                        transaction && transaction.detectFinish();
                    };
                }, []);
                return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(Component, $ef61c580367d2484$var$_extends({
                    transaction: transaction
                }, props));
            };
            else ApmComponent = function(_React$Component) {
                $ef61c580367d2484$var$_inheritsLoose(ApmComponent, _React$Component);
                function ApmComponent(props) {
                    var _this;
                    _this = _React$Component.call(this, props) || this;
                    _this.transaction = apm.startTransaction(name, type, {
                        managed: true,
                        canReuse: true
                    });
                    callback(_this.transaction, props);
                    return _this;
                }
                var _proto = ApmComponent.prototype;
                _proto.componentDidMount = function componentDidMount() {
                    var _this2 = this;
                    (0, $9bc6b1e8af275af3$export$2e2bcd8739ae039)(function() {
                        return _this2.transaction && _this2.transaction.detectFinish();
                    });
                };
                _proto.componentWillUnmount = function componentWillUnmount() {
                    if (this.transaction) this.transaction.detectFinish();
                };
                _proto.render = function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement(Component, $ef61c580367d2484$var$_extends({
                        transaction: this.transaction
                    }, this.props));
                };
                return ApmComponent;
            }((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
            ApmComponent.displayName = "withTransaction(" + (Component.displayName || Component.name) + ")";
            ApmComponent.WrappedComponent = Component;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4080a25632a78fde$exports)))(ApmComponent, Component);
        };
    };
}



var $denZA = parcelRequire("denZA");


function $3c9baf3cd46d3037$var$_extends() {
    $3c9baf3cd46d3037$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c9baf3cd46d3037$var$_extends.apply(this, arguments);
}
function $3c9baf3cd46d3037$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $3c9baf3cd46d3037$var$_setPrototypeOf(subClass, superClass);
}
function $3c9baf3cd46d3037$var$_setPrototypeOf(o, p) {
    $3c9baf3cd46d3037$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c9baf3cd46d3037$var$_setPrototypeOf(o, p);
}
function $3c9baf3cd46d3037$var$getTransactionName(name, props) {
    var _props$match = props.match, match = _props$match === void 0 ? {} : _props$match;
    if (Array.isArray(name) && match.path) return match.path;
    return name;
}
function $3c9baf3cd46d3037$export$a820eaa04880dd2b(apm) {
    var withTransaction = (0, $ef61c580367d2484$export$8968e64b6e3c0a85)(apm);
    return function(_React$Component) {
        $3c9baf3cd46d3037$var$_inheritsLoose(ApmRoute, _React$Component);
        function ApmRoute(props) {
            var _this;
            _this = _React$Component.call(this, props) || this;
            _this.state = {};
            return _this;
        }
        ApmRoute.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var initial = prevState.apmComponent == null;
            var path = nextProps.path, component = nextProps.component;
            var pathChanged = path != prevState.path;
            if (initial || pathChanged) return {
                path: path,
                apmComponent: withTransaction(path, 'route-change', function(transaction, props) {
                    if (transaction) {
                        var name = $3c9baf3cd46d3037$var$getTransactionName(path, props);
                        name && (transaction.name = name);
                    }
                })(component)
            };
            return null;
        };
        var _proto = ApmRoute.prototype;
        _proto.render = function render() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $32ee599feb5ae61e$export$e7b0ac011bb776c6), $3c9baf3cd46d3037$var$_extends({}, this.props, {
                component: this.state.apmComponent
            }));
        };
        return ApmRoute;
    }((0, (/*@__PURE__*/$parcel$interopDefault($denZA))).Component);
}


var $202c0fb36afa19ba$export$c0b5558aa11175d9 = (0, $ef61c580367d2484$export$8968e64b6e3c0a85)((0, $3f39a533616cca00$export$66cd81c234b843ce));
var $202c0fb36afa19ba$export$e950e0dbcf10755d = (0, $3c9baf3cd46d3037$export$a820eaa04880dd2b)((0, $3f39a533616cca00$export$66cd81c234b843ce));



const $d99851fcb7e80ca8$export$a5cc09564839c18a = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  query GetEligibleAssessmentYears {
    getEligibleAssessmentYears {
      year
      businessUnits {
        businessUnitName
        active
        deadlineTimestamp
      }
    }
  }
`;
const $d99851fcb7e80ca8$export$a08a5b13f6e5e7f5 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation ActiveBusinessUnitForYear($businessUnit: String!, $year: Int!) {
    activateBusinessUnitForYear(businessUnit: $businessUnit, year: $year) {
      year
      businessUnits {
        businessUnitName
        active
      }
    }
  }
`;
const $d99851fcb7e80ca8$export$e06a19adcb99f5e8 = (0, $4530924e0b1e6e3c$export$2e2bcd8739ae039)`
  mutation UpdateBusinessUnitDeadlineForYear(
    $businessUnit: String!
    $year: Int!
    $deadlineTimestamp: String!
  ) {
    updateBusinessUnitDeadlineForYear(
      businessUnit: $businessUnit
      year: $year
      deadlineTimestamp: $deadlineTimestamp
    )
  }
`;



const $2b2f6d62e3d02216$export$c6a7cf7bab3a6b5c = 'pendingUserFilterIsChecked';
const $2b2f6d62e3d02216$var$selectedYearLocalStorageKey = 'selectedYear';
const $2b2f6d62e3d02216$var$overviewWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size32
});
const $2b2f6d62e3d02216$var$yearSelectStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '7%'
});
const $2b2f6d62e3d02216$var$headerHeadingStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'block',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        marginBottom: '-20px'
    }
});
const $2b2f6d62e3d02216$var$headerActionsStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'block',
    margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px 0`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between'
    }
});
const $2b2f6d62e3d02216$var$actionButtonsLeft = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'block',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        display: 'flex',
        alignItems: 'center'
    }
});
const $2b2f6d62e3d02216$var$resetButtonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'block',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        marginTop: 0
    }
});
const $2b2f6d62e3d02216$var$tableSearchWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $2b2f6d62e3d02216$var$tableInfoAndExportStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px 0`,
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $2b2f6d62e3d02216$var$channelSelectStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '180px',
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $2b2f6d62e3d02216$var$businessUnitSelectStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '180px',
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $2b2f6d62e3d02216$var$myActionCheckStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $2b2f6d62e3d02216$var$filterByPendingUser = (allAssessments, roles)=>{
    return allAssessments.filter((assessment)=>roles.some((role)=>role === assessment.pendingUser));
};
const $2b2f6d62e3d02216$var$hasActiveFilters = (initialFilterState, currentFilters)=>{
    const isPendingUserActive = currentFilters.pendingUser;
    const isSearchTextActive = currentFilters.searchText;
    const isChannelActive = currentFilters.channel !== $2b2f6d62e3d02216$var$defaultChannelFilter;
    const isBusinessUnitActive = currentFilters.businessUnit !== $2b2f6d62e3d02216$var$defaultBusinessUnitFilter;
    if (isPendingUserActive || isSearchTextActive || isChannelActive || isBusinessUnitActive) return true;
    return false;
};
const $2b2f6d62e3d02216$var$determineDefaultYear = ()=>{
    const currentDate = new Date();
    const defaultYear = currentDate.getFullYear();
    const monthOfYear = currentDate.getMonth() + 1;
    return monthOfYear < 8 ? defaultYear - 1 : defaultYear;
};
const $2b2f6d62e3d02216$export$fd7a298ee570483a = [
    15,
    25,
    50,
    100,
    200
];
const $2b2f6d62e3d02216$var$defaultChannelFilter = 'ALL_CHANNELS';
const $2b2f6d62e3d02216$var$defaultBusinessUnitFilter = 'ALL_BUs';
const $2b2f6d62e3d02216$var$Overview = ()=>{
    const pendingUserStatusFromLocalStorage = (0, $denZA.useMemo)(()=>{
        const pendingUserStatus = window.localStorage.getItem($2b2f6d62e3d02216$export$c6a7cf7bab3a6b5c);
        if (pendingUserStatus) return JSON.parse(pendingUserStatus);
        return false;
    }, []);
    const selectedYearForLocalStorage = (0, $denZA.useMemo)(()=>{
        const selectedYear = window.localStorage.getItem($2b2f6d62e3d02216$var$selectedYearLocalStorageKey);
        return selectedYear ? JSON.parse(selectedYear) : $2b2f6d62e3d02216$var$determineDefaultYear();
    }, []);
    const initialFilterState = {
        pendingUser: pendingUserStatusFromLocalStorage,
        searchText: '',
        channel: $2b2f6d62e3d02216$var$defaultChannelFilter,
        businessUnit: $2b2f6d62e3d02216$var$defaultBusinessUnitFilter,
        yoyDifference: false
    };
    (0, $denZA.useEffect)(()=>{
        window.addEventListener('beforeunload', ()=>{
            window.localStorage.removeItem($2b2f6d62e3d02216$var$selectedYearLocalStorageKey);
        });
    }, []);
    const [filters, updateFilters] = (0, $denZA.useState)(initialFilterState);
    const [queryYear, setQueryYear] = (0, $denZA.useState)(selectedYearForLocalStorage);
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const { isLoggedIn: isLoggedIn, roles: roles } = (0, $b92321121d608eea$export$23bbbc4533528f03)();
    const { data: overviewData, loading: isOverviewDataLoading, error: overviewDataError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$8951c8a15d961cc6), {
        variables: {
            year: queryYear
        },
        fetchPolicy: 'network-only',
        skip: !isLoggedIn
    });
    const { data: eligibleYears, loading: isEligibleYearsLoading, error: eligibleYearsError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $d99851fcb7e80ca8$export$a5cc09564839c18a), {
        skip: !isLoggedIn
    });
    if (eligibleYearsError) throw eligibleYearsError;
    // Extract unique channels from assessment data
    const uniqueChannels = (0, $denZA.useMemo)(()=>{
        if (!overviewData || !overviewData.getAssessments) return [];
        const channels = overviewData.getAssessments.map((assessment)=>assessment.channel).filter(Boolean) // Remove null/undefined values
        .reduce((unique, channel)=>{
            if (!unique.includes(channel)) unique.push(channel);
            return unique;
        }, []);
        return channels.sort();
    }, [
        overviewData
    ]);
    // Extract unique business units from assessment data
    const uniqueBusinessUnits = (0, $denZA.useMemo)(()=>{
        if (!overviewData || !overviewData.getAssessments) return [];
        const businessUnits = overviewData.getAssessments.map((assessment)=>assessment.businessUnit).filter(Boolean) // Remove null/undefined values
        .reduce((unique, businessUnit)=>{
            if (!unique.includes(businessUnit)) unique.push(businessUnit);
            return unique;
        }, []);
        return businessUnits.sort();
    }, [
        overviewData
    ]);
    const handleTableRowClick = (rowData)=>{
        const { customerId: customerId, year: year, version: version } = rowData;
        history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).details(customerId, year, version));
    };
    const handleTextSearchUpdate = (searchText)=>updateFilters((prevState)=>({
                ...prevState,
                searchText: searchText
            }));
    const handleChannelChange = (e)=>{
        updateFilters((prevState)=>({
                ...prevState,
                channel: e.target.value
            }));
    };
    const handleBusinessUnitChange = (e)=>{
        updateFilters((prevState)=>({
                ...prevState,
                businessUnit: e.target.value
            }));
    };
    const filter = (assessments, filters, roles)=>{
        const { pendingUser: pendingUser, searchText: searchText, channel: channel, businessUnit: businessUnit, yoyDifference: yoyDifference } = filters;
        let filteredData = [
            ...assessments
        ];
        if (pendingUser) filteredData = $2b2f6d62e3d02216$var$filterByPendingUser(assessments, roles);
        if (searchText) filteredData = (0, $ba6523c0c2363a02$export$9e154eccb89349f0)(filteredData, searchText, {
            keys: [
                'customerId',
                'customerName',
                'c6Name'
            ]
        });
        if (channel && channel !== $2b2f6d62e3d02216$var$defaultChannelFilter) filteredData = filteredData.filter((assessment)=>assessment.channel === channel);
        if (businessUnit && businessUnit !== $2b2f6d62e3d02216$var$defaultBusinessUnitFilter) filteredData = filteredData.filter((assessment)=>assessment.businessUnit === businessUnit);
        if (yoyDifference) filteredData = filteredData.filter((assessment)=>assessment.lastYearScore !== undefined && assessment.lastYearScore !== null && assessment.score - assessment.lastYearScore !== 0 && (0, $d306a6c16d4d2f55$export$e71e4e95f4a82c)(assessment.status));
        return filteredData;
    };
    const columns = (0, $denZA.useMemo)(()=>(0, $7c1ece22f3461b0d$export$4799ea63767e181), []);
    // Error boundary catches this error
    if (overviewDataError) throw overviewDataError;
    if (isOverviewDataLoading || !isLoggedIn) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    const filteredTableData = filter(overviewData.getAssessments, filters, roles);
    const handleYearSelect = (value)=>{
        window.localStorage.setItem($2b2f6d62e3d02216$var$selectedYearLocalStorageKey, value);
        setQueryYear(value);
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $2b2f6d62e3d02216$var$overviewWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $2b2f6d62e3d02216$var$headerHeadingStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                        type: "h1",
                        text: "Assessment Overview"
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $2b2f6d62e3d02216$var$yearSelectStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ad3b5be9711589c5$export$ef9b1a59e592288f), {
                            value: queryYear,
                            onChange: (value)=>handleYearSelect(parseInt(value.target.value)),
                            children: !isEligibleYearsLoading && eligibleYears?.getEligibleAssessmentYears && eligibleYears.getEligibleAssessmentYears.map(({ year: year })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                    value: year,
                                    children: year
                                }, year))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $2b2f6d62e3d02216$var$headerActionsStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $2b2f6d62e3d02216$var$actionButtonsLeft,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $2b2f6d62e3d02216$var$tableSearchWrapperStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $38742c9000cdba90$export$6a5f53a9c1177856), {
                                    onChange: handleTextSearchUpdate,
                                    value: filters.searchText
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $2b2f6d62e3d02216$var$channelSelectStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ad3b5be9711589c5$export$ef9b1a59e592288f), {
                                    value: filters.channel,
                                    onChange: handleChannelChange,
                                    children: [
                                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                            value: $2b2f6d62e3d02216$var$defaultChannelFilter,
                                            children: "All Channels"
                                        }),
                                        uniqueChannels.map((channel)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                                value: channel,
                                                children: channel
                                            }, channel))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $2b2f6d62e3d02216$var$businessUnitSelectStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ad3b5be9711589c5$export$ef9b1a59e592288f), {
                                    value: filters.businessUnit,
                                    onChange: handleBusinessUnitChange,
                                    children: [
                                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                            value: $2b2f6d62e3d02216$var$defaultBusinessUnitFilter,
                                            children: "All BUs"
                                        }),
                                        uniqueBusinessUnits.map((businessUnit)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                                value: businessUnit,
                                                children: businessUnit
                                            }, businessUnit))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $2b2f6d62e3d02216$var$myActionCheckStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $58724900fb07117e$export$48513f6b9f8ce62d), {
                                    label: "Show only my action required",
                                    checked: filters.pendingUser,
                                    onChange: ()=>updateFilters((prevState)=>{
                                            window.localStorage.setItem($2b2f6d62e3d02216$export$c6a7cf7bab3a6b5c, !prevState.pendingUser);
                                            return {
                                                ...prevState,
                                                pendingUser: !prevState.pendingUser
                                            };
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $58724900fb07117e$export$48513f6b9f8ce62d), {
                                label: "Show only YoY changes",
                                checked: filters.yoyDifference,
                                onChange: ()=>updateFilters((prevState)=>{
                                        return {
                                            ...prevState,
                                            yoyDifference: !prevState.yoyDifference
                                        };
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                        css: $2b2f6d62e3d02216$var$resetButtonWrapperStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                            label: "Reset filters",
                            variant: "ghost",
                            disabled: !$2b2f6d62e3d02216$var$hasActiveFilters(initialFilterState, filters),
                            onClick: ()=>{
                                window.localStorage.setItem($2b2f6d62e3d02216$export$c6a7cf7bab3a6b5c, false);
                                updateFilters({
                                    ...initialFilterState,
                                    pendingUser: false
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b0459eaa6dae80b0$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $2b2f6d62e3d02216$var$tableInfoAndExportStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e015d19d07a0e9d5$export$878159a09675b041), {
                        numberOfFilteredRows: filteredTableData.length,
                        searchText: filters.searchText
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $67f90a8960b70b46$export$4a5ede65b5ef2694), {
                        assessments: overviewData.getAssessments,
                        year: queryYear
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $518116b4be6dce8c$export$264985b2d12e0d09), {
                rowClick: handleTableRowClick,
                pageSizes: $2b2f6d62e3d02216$export$fd7a298ee570483a,
                overviewTableData: filteredTableData,
                columns: columns
            })
        ]
    });
};
const $2b2f6d62e3d02216$export$a43a16ae3610c20c = (0, $202c0fb36afa19ba$export$c0b5558aa11175d9)('OverviewPage', 'component')($2b2f6d62e3d02216$var$Overview);




var $denZA = parcelRequire("denZA");









var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");
const $3463068a6fe77df4$export$ed8ca599049e8881 = ({ activeColor: activeColor, activeStep: activeStep, shouldHideInactiveStepsContent: shouldHideInactiveStepsContent, children: children })=>{
    const childrenWithProps = (0, $denZA.Children).map(children, (child, index)=>{
        const stepNumber = index + 1;
        const props = {
            number: stepNumber,
            isActive: stepNumber === activeStep,
            isLast: index + 1 === children.length,
            activeColor: activeColor,
            shouldHideInactiveStepsContent: shouldHideInactiveStepsContent
        };
        return /*#__PURE__*/ (0, $denZA.cloneElement)(child, props);
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("ul", {
        children: childrenWithProps
    });
};
$3463068a6fe77df4$export$ed8ca599049e8881.propTypes = {
    activeColor: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    stepsCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    activeStep: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    shouldHideInactiveStepsContent: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node.isRequired
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");

var $30c377a99373539e$exports = {};
$30c377a99373539e$exports = $parcel$resolve("8RGfr");




const $259dc2f442630ef2$export$c4d4f06a25de97f = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'stretch',
    width: 'auto'
});
const $259dc2f442630ef2$export$11aaee185e8cb4cf = (activeColor, isLast, isValid)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 0,
        flexShrink: 0,
        '&::after': !isLast && {
            margin: `${0, $a8ddc88815af1a66$export$4738d597a47e577d}px 0`,
            borderRadius: 2,
            width: (0, $a8ddc88815af1a66$export$4738d597a47e577d),
            backgroundColor: isValid ? activeColor : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20,
            content: `''`,
            display: 'block',
            flexGrow: 1,
            height: (0, $a8ddc88815af1a66$export$4738d597a47e577d)
        }
    });
const $259dc2f442630ef2$export$6ab59c260daa2dd0 = (activeColor, isActive, isComplete, isValid, isWarning)=>{
    const numberSize = (0, $a8ddc88815af1a66$export$4738d597a47e577d) * 8;
    return (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        alignItems: 'center',
        backgroundColor: $259dc2f442630ef2$var$getBackgroundColor(activeColor, isActive, isComplete, isWarning),
        borderColor: $259dc2f442630ef2$var$getBorderColor(activeColor, isActive, isValid, isWarning),
        borderRadius: numberSize / 2,
        borderWidth: 3,
        borderStyle: 'solid',
        color: $259dc2f442630ef2$var$getNumberColor(activeColor, isActive, isComplete, isValid, isWarning),
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
        fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
        height: numberSize,
        justifyContent: 'center',
        outline: 'none',
        textDecoration: 'none',
        width: numberSize
    });
};
const $259dc2f442630ef2$export$682f2e27922bf3a2 = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    minHeight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size16
});
const $259dc2f442630ef2$export$5939e41228734fb7 = (activeColor, isActive, isValid, isWarning)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        padding: `${(0, $a8ddc88815af1a66$export$4738d597a47e577d) / 2}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px ${(0, $a8ddc88815af1a66$export$4738d597a47e577d) / 2}px 0`,
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
        color: $259dc2f442630ef2$var$getHeaderColor(activeColor, isActive, isValid, isWarning),
        fontWeight: !isActive ? (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.regular : (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium
    });
const $259dc2f442630ef2$export$a6a87d3faf1ce385 = (isActive, questionHeight)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'block',
        overflow: 'hidden',
        visibility: isActive ? 'visible' : 'hidden',
        height: $259dc2f442630ef2$var$getContentHeight(isActive, questionHeight),
        opacity: isActive ? 1 : 0,
        transition: 'height .5s ease, opacity .5s ease',
        paddingLeft: (0, $a8ddc88815af1a66$export$4738d597a47e577d) / 2
    });
// Helpers
function $259dc2f442630ef2$var$getBackgroundColor(activeColor, isActive, isComplete, isWarning) {
    if (isWarning && !isActive) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400;
    return isComplete && !isActive ? activeColor : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white;
}
function $259dc2f442630ef2$var$getBorderColor(activeColor, isActive, isValid, isWarning) {
    if (isWarning) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400;
    return !isActive && !isValid ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20 : activeColor;
}
function $259dc2f442630ef2$var$getHeaderColor(activeColor, isActive, isValid, isWarning) {
    if (isWarning) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400;
    !isActive && !isValid ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase : activeColor;
}
function $259dc2f442630ef2$var$getNumberColor(activeColor, isActive, isComplete, isValid, isWarning) {
    if (isWarning) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400;
    if (isActive || isValid) return activeColor;
    if (isComplete) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white;
    return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase;
}
function $259dc2f442630ef2$var$getContentHeight(isActive, questionHeight) {
    if (!questionHeight) return 'auto';
    if (questionHeight && isActive) return questionHeight;
    return 0;
}


const $72bcf3aff0a4f9bd$export$fd55ce593607084a = ({ activeColor: activeColor = (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.base, number: number, header: header, isLast: isLast, isActive: isActive, isValid: isValid, isComplete: isComplete, isWarning: isWarning, children: children, additionalHeight: additionalHeight, shouldHideInactiveStepsContent: shouldHideInactiveStepsContent })=>{
    // Ref to question so that we can scroll it into view if necessary
    const questionRef = (0, $denZA.useRef)(null);
    // Ref to question content wrapper so that we can measure height of content
    const questionContentRef = (0, $denZA.useRef)(null);
    // We need to get the actual height of each question in order to animate properly
    // We update the questionHeight state as soon as the question has been rendered to the DOM
    // and we can measure the height
    const [questionHeight, setQuestionHeight] = (0, $denZA.useState)(0);
    (0, $denZA.useEffect)(()=>{
        const el = questionContentRef.current;
        if (!el) return;
        const measure = ()=>setQuestionHeight(el.offsetHeight);
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    (0, $denZA.useEffect)(()=>{
        let timer;
        if (isActive) timer = setTimeout(()=>{
            const questionElement = questionRef?.current;
            if (typeof questionElement?.scrollIntoView === 'function') {
                questionElement.scrollIntoView({
                    block: 'nearest',
                    inline: 'nearest'
                });
                return;
            }
            if (typeof questionElement?.scrollIntoViewIfNeeded === 'function') questionElement.scrollIntoViewIfNeeded();
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("li", {
        ref: questionRef,
        css: (0, $259dc2f442630ef2$export$c4d4f06a25de97f),
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: (0, $259dc2f442630ef2$export$11aaee185e8cb4cf)(activeColor, isLast, isValid, isComplete),
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                    css: (0, $259dc2f442630ef2$export$6ab59c260daa2dd0)(activeColor, isActive, isComplete, isValid, isWarning),
                    "data-testid": "stepNumber",
                    children: isComplete && !isActive ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($30c377a99373539e$exports))),
                        alt: "Checkmark icon"
                    }) : number
                })
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: (0, $259dc2f442630ef2$export$682f2e27922bf3a2),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h3", {
                        css: (0, $259dc2f442630ef2$export$5939e41228734fb7)(activeColor, isActive, isValid, isWarning),
                        children: header
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: shouldHideInactiveStepsContent && (0, $259dc2f442630ef2$export$a6a87d3faf1ce385)(isActive, questionHeight + additionalHeight),
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            ref: questionContentRef,
                            children: children
                        })
                    })
                ]
            })
        ]
    });
};
$72bcf3aff0a4f9bd$export$fd55ce593607084a.propTypes = {
    activeColor: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    number: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    isLast: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    isValid: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    isComplete: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    isWarning: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node,
    stepId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    additionalHeight: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    shouldHideInactiveStepsContent: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};






var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");





const $ff397d5a0eee2c82$export$eac0f7ffa478154d = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    marginLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
    verticalAlign: 'text-top',
    cursor: 'pointer',
    display: 'inline-block'
});
const $ff397d5a0eee2c82$export$d781ca6d008ff44d = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.base
});
const $ff397d5a0eee2c82$export$7ad3b5f9b0722e2c = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    textAlign: 'center'
});




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $234546212c2d4b21$export$b7eef48498bbd53e = {
    de: {
        'Sign In': 'Anmelden',
        'Sign Up': 'Registrieren',
        'Sign Out': 'Abmelden',
        'Sign in to your account': 'Melden Sie sich mit Ihrem Account an',
        Username: 'Benutzername',
        Password: 'Passwort',
        'Enter your username': 'Geben Sie Ihren Benutzernamen ein',
        'Enter your password': 'Geben Sie Ihr Passwort ein',
        'No account? ': 'Kein Account? ',
        'Forgot your password? ': 'Passwort vergessen? ',
        'Reset password': "Passwort zur\xfccksetzen",
        'User does not exist': 'Dieser Benutzer existiert nicht',
        'User already exists': 'Dieser Benutzer existiert bereits',
        'Incorrect username or password': 'Falscher Benutzername oder falsches Passwort',
        'Invalid password format': "Ung\xfcltiges Passwort-Format",
        'Create account': 'Hier registrieren',
        'Forgot Password': 'Passwort vergessen',
        'Change Password': "Passwort \xe4ndern",
        'New Password': 'Neues Passwort',
        Email: 'Email',
        'Phone Number': 'Telefonnummer',
        'Confirm a Code': "Code best\xe4tigen",
        'Confirm Sign In': "Anmeldung best\xe4tigen",
        'Confirm Sign Up': "Registrierung best\xe4tigen",
        'Back to Sign In': "Zur\xfcck zur Anmeldung",
        'Send Code': 'Code senden',
        Confirm: "Best\xe4tigen",
        'Resend Code': 'Code erneut senden',
        Submit: 'Abschicken',
        Skip: "\xdcberspringen",
        Verify: 'Verifizieren',
        'Verify Contact': 'Kontakt verifizieren',
        Code: 'Code',
        'Confirmation Code': "Best\xe4tigungs-Code",
        'Lost your code? ': 'Code verloren? ',
        'Account recovery requires verified contact information': "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
        'Invalid phone number format': "Ung\u00FCltiges Telefonummern-Format.\n            Benutze eine Nummer im Format: +12345678900",
        'Create Account': 'Account erstellen',
        'Have an account? ': 'Schon registriert? ',
        'Sign in': 'Anmelden',
        'Create a new account': 'Erstelle einen neuen Account',
        'Reset your password': "Zur\xfccksetzen des Passworts",
        'An account with the given email already exists.': 'Ein Account mit dieser Email existiert bereits.',
        'Username cannot be empty': 'Benutzername darf nicht leer sein',
        'Password attempts exceeded': 'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht'
    },
    fr: {
        Hello: 'Bonjour',
        'Loading...': 'Chargement...',
        'Sign In': 'Se connecter',
        'Sign In with Amazon': 'Se connecter avec Amazon',
        'Sign In with Facebook': 'Se connecter avec Facebook',
        'Sign In with Google': 'Se connecter avec Google',
        'Sign in with AWS': 'Se connecter avec AWS',
        'Sign Up': "S'inscrire",
        'Sign Out': "D\xe9connexion",
        'Forgot Password': "Mot de passe oubli\xe9",
        Username: "Nom d'utilisateur",
        Password: 'Mot de passe',
        'Change Password': 'Modifier le mot de passe',
        Change: 'Modifier',
        'New Password': 'Nouveau mot de passe',
        Email: 'Email',
        'Phone Number': "Num\xe9ro de t\xe9l\xe9phone",
        'Confirm a Code': 'Confirmer un code',
        'Confirm Sign In': 'Confirmer la connexion',
        'Confirm Sign Up': "Confirmer l'inscription",
        'Back to Sign In': "Retour \xe0 la connexion",
        Send: 'Envoyer',
        'Send Code': "M'envoyer un code",
        Confirm: 'Confirmer',
        SMS: 'SMS',
        'Confirm SMS Code': 'Confirmer le code SMS',
        'Confirm TOTP Code': 'Confirmer le code TOTP',
        'Resend a Code': 'Renvoyer un code',
        Submit: 'Soumettre',
        Skip: 'Passer',
        Verify: "V\xe9rifier",
        'Verify Contact': "V\xe9rifier le contact",
        Code: 'Code',
        'Confirmation Code': 'Code de confirmation',
        'Account recovery requires verified contact information': "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
        'User does not exist': "L'utilisateur n'existe pas",
        'User already exists': "L'utilisateur existe d\xe9j\xe0",
        'Incorrect username or password': 'Identifiant ou mot de passe incorrect',
        'Invalid password format': 'Format de mot de passe invalide',
        'Invalid phone number format': "Format de num\u00E9ro de t\u00E9l\u00E9phone invalide. Veuillez utiliser un format +12345678900",
        'Username/client id combination not found.': "L'utilisateur n'existe pas",
        'Network error': "Erreur r\xe9seau",
        'Sign in to your account': "Connexion \xe0 votre compte",
        'Forgot your password? ': "Mot de passe oubli\xe9 ? ",
        'Reset password': "R\xe9initialisez votre mot de passe",
        'No account? ': 'Pas de compte ? ',
        'Create account': "Cr\xe9er un compte",
        'Create Account': "Cr\xe9er un compte",
        'Have an account? ': "D\xe9j\xe0 un compte ? ",
        'Sign in': 'Se connecter',
        'Create a new account': "Cr\xe9er un nouveau compte",
        'Reset your password': "R\xe9initialisez votre mot de passe",
        'Enter your username': "Saisissez votre nom d'utilisateur",
        'Enter your password': 'Saisissez votre mot de passe',
        'Enter your phone number': "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
        'Enter your email': 'Saisissez votre adresse email',
        'Enter your code': 'Saisissez cotre code de confirmation',
        'Lost your code? ': 'Vous avez perdu votre code ? ',
        'Resend Code': 'Renvoyer le code',
        or: 'ou',
        'An account with the given email already exists.': "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
        'Username cannot be empty': "Le nom d'utilisateur doit \xeatre renseign\xe9"
    },
    es: {
        'Sign In': 'Registrarse',
        'Sign Up': "Reg\xedstrate",
        'Sign Out': 'Desconectar',
        'Forgot Password': "Se te olvid\xf3 tu contrase\xf1a",
        Username: 'Nombre de usuario',
        Password: "Contrase\xf1a",
        'Change Password': "Cambia la contrase\xf1a",
        'New Password': "Nueva contrase\xf1a",
        Email: 'Email',
        'Phone Number': "N\xfamero de tel\xe9fono",
        'Confirm a Code': "Confirmar un c\xf3digo",
        'Confirm Sign In': "Confirmar inicio de sesi\xf3n",
        'Confirm Sign Up': 'Confirmar Registrarse',
        'Back to Sign In': "Volver a Iniciar sesi\xf3n",
        'Send Code': "Enviar c\xf3digo",
        Confirm: 'Confirmar',
        'Resend a Code': "Reenviar un c\xf3digo",
        Submit: 'Enviar',
        Skip: 'Omitir',
        Verify: 'Verificar',
        'Verify Contact': 'Verificar contacto',
        Code: "C\xf3digo",
        'Account recovery requires verified contact information': "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
        'User does not exist': 'el usuario no existe',
        'User already exists': 'El usuario ya existe',
        'Incorrect username or password': "Nombre de usuario o contrase\xf1a incorrecta",
        'Invalid password format': "Formato de contrase\xf1a inv\xe1lido",
        'Invalid phone number format': "Formato de n\u00FAmero de tel\u00E9fono inv\u00E1lido.\nUtilice el formato de n\u00FAmero de tel\u00E9fono +12345678900"
    },
    it: {
        'Account recovery requires verified contact information': 'Ripristino del conto richiede un account verificati',
        'An account with the given email already exists.': "Un account con questa email esiste gi\xe0.",
        'Back to Sign In': 'Torna alla Accesso',
        'Change Password': 'Cambia la password',
        Code: 'Codice',
        Confirm: 'Conferma',
        'Confirm Sign In': 'Conferma di applicazione',
        'Confirm Sign Up': 'Registrazione Conferma',
        'Confirm a Code': 'Codice Conferma',
        'Confirmation Code': 'Codice di verifica',
        'Create Account': 'Crea account',
        'Create a new account': 'Creare un nuovo account',
        'Create account': 'Registrati',
        Email: 'E-mail',
        'Enter your password': 'Inserire la password',
        'Enter your username': 'Inserisci il tuo nome utente',
        'Forgot your password?': 'Password dimenticata?',
        'Forgot Password': 'Password dimenticata',
        'Have an account? ': "Gi\xe0 registrato?",
        'Incorrect username or password': 'Nome utente o password errati',
        'Invalid password format': 'Formato della password non valido',
        'Invalid phone number format': 'Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille',
        'Lost your code?': 'Perso codice?',
        'New Password': 'Nuova password',
        'No account? ': 'Nessun account?',
        Password: 'Password',
        'Password attempts exceeded': "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
        'Phone Number': 'Numero di telefono',
        'Resend Code': 'Codice Rispedisci',
        'Reset password': 'Ripristina password',
        'Reset your password': 'Resetta password',
        'Send Code': 'Invia codice',
        'Sign In': 'Accesso',
        'Sign Out': 'Esci',
        'Sign Up': 'Iscriviti',
        'Sign in': 'Accesso',
        'Sign in to your account': 'Accedi con il tuo account a',
        Skip: 'Salta',
        Submit: 'Sottoscrivi',
        'User already exists': "Questo utente esiste gi\xe0",
        'User does not exist': 'Questo utente non esiste',
        Username: 'Nome utente',
        'Username cannot be empty': "Nome utente non pu\xf2 essere vuoto",
        Verify: 'Verifica',
        'Verify Contact': 'Contatto verifica'
    },
    zh: {
        'Sign In': "\u767B\u5F55",
        'Sign Up': "\u6CE8\u518C",
        'Sign Out': "\u9000\u51FA",
        'Forgot Password': "\u5FD8\u8BB0\u5BC6\u7801",
        Username: "\u7528\u6237\u540D",
        Password: "\u5BC6\u7801",
        'Change Password': "\u6539\u53D8\u5BC6\u7801",
        'New Password': "\u65B0\u5BC6\u7801",
        Email: "\u90AE\u7BB1",
        'Phone Number': "\u7535\u8BDD",
        'Confirm a Code': "\u786E\u8BA4\u7801",
        'Confirm Sign In': "\u786E\u8BA4\u767B\u5F55",
        'Confirm Sign Up': "\u786E\u8BA4\u6CE8\u518C",
        'Back to Sign In': "\u56DE\u5230\u767B\u5F55",
        'Send Code': "\u53D1\u9001\u786E\u8BA4\u7801",
        Confirm: "\u786E\u8BA4",
        'Resend a Code': "\u91CD\u53D1\u786E\u8BA4\u7801",
        Submit: "\u63D0\u4EA4",
        Skip: "\u8DF3\u8FC7",
        Verify: "\u9A8C\u8BC1",
        'Verify Contact': "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
        Code: "\u786E\u8BA4\u7801",
        'Account recovery requires verified contact information': "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
        'User does not exist': "\u7528\u6237\u4E0D\u5B58\u5728",
        'User already exists': "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
        'Incorrect username or password': "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
        'Invalid password format': "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
        'Invalid phone number format': "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900"
    },
    ja: {
        'Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
        'Sign Up': "\u767B\u9332 ",
        'Sign Out': "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
        'Sign in to your account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
        Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
        Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
        'Enter your username': "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
        'Enter your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
        'No account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
        'Forgot your password? ': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
        'Reset password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
        'User does not exist': "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
        'User already exists': "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
        'Incorrect username or password': "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
        'Invalid password format': "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
        'Create account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
        'Forgot Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
        'Change Password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
        'New Password': "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
        Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        'Phone Number': "\u96FB\u8A71\u756A\u53F7",
        'Confirm a Code': "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
        'Confirm Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
        'Confirm Sign Up': "\u767B\u9332\u3059\u308B",
        'Back to Sign In': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
        'Send Code': "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
        Confirm: "\u78BA\u5B9A",
        'Resend Code': "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
        Submit: "\u9001\u4FE1",
        Skip: "\u30B9\u30AD\u30C3\u30D7",
        Verify: "\u78BA\u8A8D",
        'Verify Contact': "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
        Code: "\u30B3\u30FC\u30C9",
        'Confirmation Code': "\u78BA\u8A8D\u30B3\u30FC\u30C9",
        'Lost your code? ': "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
        'Account recovery requires verified contact information': "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
        'Invalid phone number format': "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        'Create Account': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
        'Have an account? ': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
        'Sign in': "\u30B5\u30A4\u30F3\u30A4\u30F3",
        'Create a new account': "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
        'Reset your password': "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
        'An account with the given email already exists.': "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
        'Username cannot be empty': "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
        'Password attempts exceeded': "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
        'Sign In with Google': "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
        'Sign In with Facebook': "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3"
    }
};





/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");

/*
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $fbd753a9a9e4139c$export$42a852a2b6b56249 = {};
var $fbd753a9a9e4139c$export$f06621d9ad29af97 = {};
var $fbd753a9a9e4139c$export$b5ff61ac8b0a660f = {};
var $fbd753a9a9e4139c$export$56e87bf42978147a = {};
var $fbd753a9a9e4139c$export$8adb256d999cd5a0 = {};
var $fbd753a9a9e4139c$export$e7049d4e10b2bdab = {};
var $fbd753a9a9e4139c$export$a8acabc71ea42c7b = {};
var $fbd753a9a9e4139c$export$2db57ef01d117453 = {};
var $fbd753a9a9e4139c$export$4ba18d57fa1c43bf = {};
var $fbd753a9a9e4139c$export$f5b8910cec6cf069 = {};
var $fbd753a9a9e4139c$export$353f5b6fc5456de1 = {};
var $fbd753a9a9e4139c$export$aca09ff9e1db00bc = {};
var $fbd753a9a9e4139c$export$6436834aeb5748e7 = {};
var $fbd753a9a9e4139c$export$e4624626de9ce646 = {};
var $fbd753a9a9e4139c$export$23087661e44b23b9 = {};
var $fbd753a9a9e4139c$export$394d523ca5aad994 = {};
var $fbd753a9a9e4139c$export$97176b8d51d2058f = {};
var $fbd753a9a9e4139c$export$739e047b0f9d1090 = {};
var $fbd753a9a9e4139c$export$549b91d6da945c97 = {};
var $fbd753a9a9e4139c$export$b534bc812df080fd = {};
var $fbd753a9a9e4139c$export$ebd11618f299a286 = {};
var $fbd753a9a9e4139c$export$8d13340382210b65 = {};
var $fbd753a9a9e4139c$export$d7b12c4107be0d61 = {};
var $fbd753a9a9e4139c$export$b04be29aa201d4f5 = {};
var $fbd753a9a9e4139c$export$76d3231fec538b73 = {};
var $fbd753a9a9e4139c$export$fab7ef1f75f6339b = {};
var $fbd753a9a9e4139c$export$ed60c62da1945f68 = {};
var $fbd753a9a9e4139c$export$33f3f0a205996c11 = {};
var $fbd753a9a9e4139c$export$9b7553f1599f739f = {};
var $fbd753a9a9e4139c$export$8d8dc7d5f743331b = {};
var $fbd753a9a9e4139c$export$ef8da11641c635de = {};
var $fbd753a9a9e4139c$export$919d7ae8be750217 = {};
var $fbd753a9a9e4139c$export$39140c7d8b0ba7b3 = {};
var $fbd753a9a9e4139c$export$e3925dbaeffcc83f = {};
var $fbd753a9a9e4139c$export$3b0a9d598f613fa = {};
var $fbd753a9a9e4139c$var$AmplifyTheme = {
    container: $fbd753a9a9e4139c$export$42a852a2b6b56249,
    formContainer: $fbd753a9a9e4139c$export$f06621d9ad29af97,
    formSection: $fbd753a9a9e4139c$export$b5ff61ac8b0a660f,
    formField: $fbd753a9a9e4139c$export$56e87bf42978147a,
    sectionHeader: $fbd753a9a9e4139c$export$8adb256d999cd5a0,
    sectionBody: $fbd753a9a9e4139c$export$e7049d4e10b2bdab,
    sectionFooter: $fbd753a9a9e4139c$export$a8acabc71ea42c7b,
    sectionFooterPrimaryContent: $fbd753a9a9e4139c$export$2db57ef01d117453,
    sectionFooterSecondaryContent: $fbd753a9a9e4139c$export$4ba18d57fa1c43bf,
    input: $fbd753a9a9e4139c$export$f5b8910cec6cf069,
    button: $fbd753a9a9e4139c$export$353f5b6fc5456de1,
    photoPickerButton: $fbd753a9a9e4139c$export$aca09ff9e1db00bc,
    photoPlaceholder: $fbd753a9a9e4139c$export$6436834aeb5748e7,
    signInButton: $fbd753a9a9e4139c$export$e4624626de9ce646,
    signInButtonIcon: $fbd753a9a9e4139c$export$23087661e44b23b9,
    signInButtonContent: $fbd753a9a9e4139c$export$394d523ca5aad994,
    amazonSignInButton: $fbd753a9a9e4139c$export$fab7ef1f75f6339b,
    facebookSignInButton: $fbd753a9a9e4139c$export$ed60c62da1945f68,
    googleSignInButton: $fbd753a9a9e4139c$export$33f3f0a205996c11,
    oAuthSignInButton: $fbd753a9a9e4139c$export$9b7553f1599f739f,
    formRow: $fbd753a9a9e4139c$export$b534bc812df080fd,
    strike: $fbd753a9a9e4139c$export$97176b8d51d2058f,
    strikeContent: $fbd753a9a9e4139c$export$739e047b0f9d1090,
    actionRow: $fbd753a9a9e4139c$export$549b91d6da945c97,
    a: $fbd753a9a9e4139c$export$ebd11618f299a286,
    hint: $fbd753a9a9e4139c$export$8d13340382210b65,
    radio: $fbd753a9a9e4139c$export$d7b12c4107be0d61,
    label: $fbd753a9a9e4139c$export$b04be29aa201d4f5,
    inputLabel: $fbd753a9a9e4139c$export$76d3231fec538b73,
    toast: $fbd753a9a9e4139c$export$8d8dc7d5f743331b,
    navBar: $fbd753a9a9e4139c$export$ef8da11641c635de,
    nav: $fbd753a9a9e4139c$export$39140c7d8b0ba7b3,
    navRight: $fbd753a9a9e4139c$export$919d7ae8be750217,
    navItem: $fbd753a9a9e4139c$export$e3925dbaeffcc83f,
    navButton: $fbd753a9a9e4139c$export$3b0a9d598f613fa
};
var $fbd753a9a9e4139c$export$2e2bcd8739ae039 = $fbd753a9a9e4139c$var$AmplifyTheme;



var $denZA = parcelRequire("denZA");



var $d82b2daa6d3b54d5$var$__assign = undefined && undefined.__assign || function() {
    $d82b2daa6d3b54d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d82b2daa6d3b54d5$var$__assign.apply(this, arguments);
};
var $d82b2daa6d3b54d5$export$42a852a2b6b56249 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.container);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.container,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$f06621d9ad29af97 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: $3adece330e373730$exports.formContainer,
        style: theme.formContainer
    }, props.children));
};
var $d82b2daa6d3b54d5$export$b5ff61ac8b0a660f = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.formSection);
    return $denZA.createElement($d82b2daa6d3b54d5$export$f06621d9ad29af97, {
        theme: theme
    }, $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: $3adece330e373730$exports.formSection,
        style: style
    }, props.children)));
};
var $d82b2daa6d3b54d5$export$8adb256d999cd5a0 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionHeader);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.sectionHeader,
        style: style
    }), $denZA.createElement($d82b2daa6d3b54d5$export$3af67e6e31678076, {
        theme: theme
    }, props.children, props.hint && $denZA.createElement("div", {
        className: $3adece330e373730$exports.sectionHeaderHint
    }, props.hint))));
};
var $d82b2daa6d3b54d5$export$3af67e6e31678076 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionHeaderContent);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: $3adece330e373730$exports.sectionHeaderContent,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$a8acabc71ea42c7b = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionFooter);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.sectionFooter,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$2db57ef01d117453 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionFooterPrimaryContent);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: $3adece330e373730$exports.sectionFooterPrimaryContent,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$4ba18d57fa1c43bf = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionFooterSecondaryContent);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: $3adece330e373730$exports.sectionFooterSecondaryContent,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$e7049d4e10b2bdab = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.sectionBody);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.sectionBody,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$549b91d6da945c97 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.actionRow);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: "amplify-action-row",
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$97176b8d51d2058f = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.strike);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: $3adece330e373730$exports.strike,
        style: style
    }, $denZA.createElement($d82b2daa6d3b54d5$export$739e047b0f9d1090, {
        theme: theme
    }, props.children)));
};
var $d82b2daa6d3b54d5$export$739e047b0f9d1090 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: $3adece330e373730$exports.strikeContent,
        style: theme.strikeContent
    }, props.children));
};
var $d82b2daa6d3b54d5$export$b534bc812df080fd = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.formRow);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.formRow,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$a82e89996b85f9e6 = function(props) {
    var id = props.id || '_' + props.value;
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    return $denZA.createElement($d82b2daa6d3b54d5$export$b534bc812df080fd, {
        theme: theme
    }, $denZA.createElement($d82b2daa6d3b54d5$export$d7b12c4107be0d61, $d82b2daa6d3b54d5$var$__assign({}, props, {
        id: id
    })), $denZA.createElement($d82b2daa6d3b54d5$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $d82b2daa6d3b54d5$export$d7b12c4107be0d61 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.radio);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("input", $d82b2daa6d3b54d5$var$__assign({}, p, {
        type: "radio",
        className: $3adece330e373730$exports.radio,
        style: style
    })));
};
var $d82b2daa6d3b54d5$export$2fe4f0576c8a371 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $denZA.createElement($d82b2daa6d3b54d5$export$b534bc812df080fd, {
        theme: theme
    }, $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("input", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.input,
        style: style
    }))));
};
var $d82b2daa6d3b54d5$export$f5b8910cec6cf069 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $denZA.createElement("input", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.input,
        style: style
    }));
};
var $d82b2daa6d3b54d5$export$d6701e98ab1a6725 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.selectInput);
    return $denZA.createElement("div", {
        className: $3adece330e373730$exports.selectInput,
        style: style
    }, props.children);
};
var $d82b2daa6d3b54d5$export$56e87bf42978147a = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.formField);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.formField,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$353f5b6fc5456de1 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.button);
    var disabled = props.disabled || false;
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("button", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.button,
        style: style,
        disabled: disabled
    }), props.children));
};
var $d82b2daa6d3b54d5$export$aca09ff9e1db00bc = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.photoPickerButton);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $denZA.createElement("button", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: [
            $3adece330e373730$exports.photoPickerButton,
            $3adece330e373730$exports.button
        ].join(' '),
        style: style
    }), props.children);
};
var $d82b2daa6d3b54d5$export$e4624626de9ce646 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var styles = Object.assign({}, theme.signInButton, theme[props.variant]);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("button", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.signInButton,
        style: styles
    }), props.children));
};
var $d82b2daa6d3b54d5$export$23087661e44b23b9 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.signInButtonIcon);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.signInButtonIcon,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$394d523ca5aad994 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.signInButtonContent);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: $3adece330e373730$exports.signInButtonContent,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$a6c7ac8248d6e38a = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.a);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("a", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.a,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$b04be29aa201d4f5 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.label);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("label", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.label,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$8d13340382210b65 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.hint);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: $3adece330e373730$exports.hint,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$76d3231fec538b73 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.inputLabel);
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: $3adece330e373730$exports.inputLabel,
        style: style
    }, props.children));
};
var $d82b2daa6d3b54d5$export$ef8da11641c635de = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.navBar);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.navBar,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$39140c7d8b0ba7b3 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.nav);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.nav,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$919d7ae8be750217 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.navRight);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.navRight,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$e3925dbaeffcc83f = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.navItem);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.navItem,
        style: style
    }), props.children));
};
var $d82b2daa6d3b54d5$export$3b0a9d598f613fa = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.navButton);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("button", $d82b2daa6d3b54d5$var$__assign({}, p, {
        className: $3adece330e373730$exports.button,
        style: style
    }), $d82b2daa6d3b54d5$export$c730c7ea62823cdc($denZA.createElement("span", null, props.children))));
};
var $d82b2daa6d3b54d5$export$8d8dc7d5f743331b = function(props) {
    var onClose = props.onClose;
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    return $denZA.createElement("div", $d82b2daa6d3b54d5$var$__assign({}, props, {
        theme: theme,
        className: $3adece330e373730$exports.toast,
        style: theme.toast
    }), $denZA.createElement("span", null, props.children), $denZA.createElement("a", {
        className: $3adece330e373730$exports.toastClose,
        onClick: onClose
    }));
};
// @ts-ignore
$d82b2daa6d3b54d5$export$8d8dc7d5f743331b.defaultProps = {
    onClose: function() {
        return void 0;
    }
};
var $d82b2daa6d3b54d5$export$6436834aeb5748e7 = function(props) {
    var theme = props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
    var style = $d82b2daa6d3b54d5$export$3fef91f8d3f898a7(props, theme.photoPlaceholder);
    return $denZA.createElement("div", {
        className: $3adece330e373730$exports.photoPlaceholder,
        style: style
    }, $denZA.createElement("div", {
        className: $3adece330e373730$exports.photoPlaceholderIcon
    }, $denZA.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 24 24"
    }, $denZA.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3.2"
    }), $denZA.createElement("path", {
        d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }), $denZA.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }))));
};
var $d82b2daa6d3b54d5$export$c730c7ea62823cdc = function(el) {
    var style = el.props.style || {};
    var before = style.before, after = style.after;
    if (!before && !after) return el;
    return $denZA.createElement("span", {
        style: {
            position: 'relative'
        }
    }, before ? $denZA.createElement("span", {
        style: before
    }, before.content) : null, el, after ? $denZA.createElement("span", {
        style: after
    }, after.content) : null);
};
var $d82b2daa6d3b54d5$export$3fef91f8d3f898a7 = function(props, themeStyle) {
    var id = props.id, style = props.style;
    var styl = Object.assign({}, style, themeStyle);
    if (!id) return styl;
    var selector = '#' + id;
    Object.assign(styl, styl[selector]);
    return styl;
};


var $4dfa122de46601b8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4dfa122de46601b8$var$PickerInput = {
    width: '100%',
    height: '100%',
    display: 'inline-block',
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    cursor: 'pointer'
};
var $4dfa122de46601b8$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Picker');
var $4dfa122de46601b8$export$ba25329847403e11 = /** @class */ function(_super) {
    $4dfa122de46601b8$var$__extends(Picker, _super);
    function Picker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Picker.prototype.handleInput = function(e) {
        var that = this;
        var file = e.target.files[0];
        if (!file) return;
        var name = file.name, size = file.size, type = file.type;
        $4dfa122de46601b8$var$logger.debug(file);
        var onPick = this.props.onPick;
        if (onPick) onPick({
            file: file,
            name: name,
            size: size,
            type: type
        });
    };
    Picker.prototype.render = function() {
        var _this = this;
        var title = this.props.title || 'Pick a File';
        var accept = this.props.accept || '*/*';
        var theme = this.props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
        var pickerStyle = Object.assign({}, {
            position: 'relative'
        }, theme.pickerPicker);
        var inputStyle = Object.assign({}, $4dfa122de46601b8$var$PickerInput, theme.pickerInput);
        return $denZA.createElement("div", {
            style: pickerStyle
        }, $denZA.createElement((0, $d82b2daa6d3b54d5$export$aca09ff9e1db00bc), {
            theme: theme
        }, (0, $20154f355a8c1f05$export$dbe3113d60765c1a).get(title)), $denZA.createElement("input", {
            title: (0, $20154f355a8c1f05$export$dbe3113d60765c1a).get(title),
            type: "file",
            accept: accept,
            style: inputStyle,
            onChange: function(e) {
                return _this.handleInput(e);
            }
        }));
    };
    return Picker;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $4dfa122de46601b8$export$2e2bcd8739ae039 = $4dfa122de46601b8$export$ba25329847403e11;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $0c7e0060d27372e2$export$42a852a2b6b56249 = {
    fontFamily: "-apple-system,\n                BlinkMacSystemFont,\n                \"Segoe UI\",\n                Roboto,\n                \"Helvetica Neue\",\n                Arial,\n                sans-serif,\n                \"Apple Color Emoji\",\n                \"Segoe UI Emoji\",\n                \"Segoe UI Symbol\"",
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#212529',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px'
};
var $0c7e0060d27372e2$export$ef8da11641c635de = {
    position: 'relative',
    border: '1px solid transparent',
    borderColor: '#e7e7e7'
};
var $0c7e0060d27372e2$export$919d7ae8be750217 = {
    textAlign: 'right'
};
var $0c7e0060d27372e2$export$39140c7d8b0ba7b3 = {
    margin: '7.5px'
};
var $0c7e0060d27372e2$export$e3925dbaeffcc83f = {
    display: 'inline-block',
    padding: '10px 5px',
    lineHeight: '20px'
};
var $0c7e0060d27372e2$export$3b0a9d598f613fa = {
    display: 'inline-block',
    padding: '6px 12px',
    marginTop: '8px',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc'
};
var $0c7e0060d27372e2$export$f06621d9ad29af97 = {
    textAlign: 'center'
};
var $0c7e0060d27372e2$export$b5ff61ac8b0a660f = {
    marginBottom: '20px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    textAlign: 'left',
    width: '400px',
    display: 'inline-block'
};
var $0c7e0060d27372e2$export$b0bceea2ea86179a = {
    marginBottom: '20px',
    color: '#fff',
    backgroundColor: '#f0ad4e',
    border: '1px solid #eea236',
    borderRadius: '4px',
    textAlign: 'left'
};
var $0c7e0060d27372e2$export$8adb256d999cd5a0 = {
    color: '#fff',
    backgroundColor: '#337ab7',
    borderColor: '#337ab7',
    padding: '10px 15px',
    borderBottom: '1px solid transparent',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    textAlign: 'center'
};
var $0c7e0060d27372e2$export$a8acabc71ea42c7b = {
    color: '#333',
    backgroundColor: '#f5f5f5',
    padding: '10px 15px',
    borderTop: '1px solid #ddd',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px'
};
var $0c7e0060d27372e2$export$e7049d4e10b2bdab = {
    padding: '15px'
};
var $0c7e0060d27372e2$export$b534bc812df080fd = {
    marginBottom: '15px'
};
var $0c7e0060d27372e2$export$549b91d6da945c97 = {
    marginBottom: '15px'
};
var $0c7e0060d27372e2$export$f5b8910cec6cf069 = {
    display: 'block',
    width: '100%',
    height: '34px',
    padding: '6px 12px',
    fontSize: '14px',
    lineHeight: '1.42857143',
    color: '#555',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
    boxSizing: 'border-box',
    transition: 'border-color ease-in-out .15s,box-shadow ease-in-out .15s'
};
var $0c7e0060d27372e2$export$353f5b6fc5456de1 = {
    display: 'inline-block',
    padding: '6px 12px',
    marginBottom: '0',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc'
};
var $0c7e0060d27372e2$export$e4624626de9ce646 = {
    position: 'relative',
    padding: '6px 12px 6px 44px',
    fontSize: '14px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%',
    marginTop: '2px',
    '#google_signin_btn': {
        color: '#fff',
        backgroundColor: '#dd4b39',
        borderColor: 'rgba(0,0,0,0.2)'
    },
    '#facebook_signin_btn': {
        color: '#fff',
        backgroundColor: '#3b5998',
        borderColor: 'rgba(0,0,0,0.2)'
    }
};
var $0c7e0060d27372e2$export$eef1e68107c58ef2 = {
    display: 'inline-block',
    width: '20px'
};
var $0c7e0060d27372e2$export$ebd11618f299a286 = {
    color: '#007bff',
    cursor: 'pointer'
};
var $0c7e0060d27372e2$export$bba54bd7e8a0d398 = {
    overflow: 'auto',
    fontFamily: "Menlo,\n                Monaco,\n                Consolas,\n                \"Courier New\",\n                monospace",
    display: 'block',
    padding: '9.5px',
    margin: '0 0 10px',
    fontSize: '13px',
    lineHeight: '1.42857143',
    color: '#333',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
    borderRadius: '4px'
};
var $0c7e0060d27372e2$export$4f22f48eb31142b4 = {
    display: 'inline-block',
    width: '8.33333333%'
};
var $0c7e0060d27372e2$export$91e0dcaa1775f500 = {
    display: 'inline-block',
    width: '16.66666667%'
};
var $0c7e0060d27372e2$export$74947a8e25d4c355 = {
    display: 'inline-block',
    width: '25%'
};
var $0c7e0060d27372e2$export$3f1319121e89c6e2 = {
    display: 'inline-block',
    width: '33.33333333%'
};
var $0c7e0060d27372e2$export$6eda199a9225028b = {
    display: 'inline-block',
    width: '41.66666667%'
};
var $0c7e0060d27372e2$export$f09604f8c820321f = {
    display: 'inline-block',
    width: '50%'
};
var $0c7e0060d27372e2$export$48878381c2fa2cad = {
    display: 'inline-block',
    width: '58.33333333%'
};
var $0c7e0060d27372e2$export$d1a6c81260d13f5 = {
    display: 'inline-block',
    width: '66.66666667%'
};
var $0c7e0060d27372e2$export$6b5338870615cec6 = {
    display: 'inline-block',
    width: '75%'
};
var $0c7e0060d27372e2$export$dfe03fd20cdc8e46 = {
    display: 'inline-block',
    width: '83.33333333%'
};
var $0c7e0060d27372e2$export$93e2edefce39c88c = {
    display: 'inline-block',
    width: '91.66666667%'
};
var $0c7e0060d27372e2$export$a48df6afa5564db7 = {
    display: 'inline-block',
    width: '100%'
};
var $0c7e0060d27372e2$export$8dc98ba7eadeaa56 = {
    display: 'none'
};
var $0c7e0060d27372e2$export$f6a06b563a614935 = {
    container: $0c7e0060d27372e2$export$42a852a2b6b56249,
    navBar: $0c7e0060d27372e2$export$ef8da11641c635de,
    nav: $0c7e0060d27372e2$export$39140c7d8b0ba7b3,
    navRight: $0c7e0060d27372e2$export$919d7ae8be750217,
    navItem: $0c7e0060d27372e2$export$e3925dbaeffcc83f,
    navButton: $0c7e0060d27372e2$export$3b0a9d598f613fa,
    formContainer: $0c7e0060d27372e2$export$f06621d9ad29af97,
    formSection: $0c7e0060d27372e2$export$b5ff61ac8b0a660f,
    errorSection: $0c7e0060d27372e2$export$b0bceea2ea86179a,
    sectionHeader: $0c7e0060d27372e2$export$8adb256d999cd5a0,
    sectionBody: $0c7e0060d27372e2$export$e7049d4e10b2bdab,
    sectionFooter: $0c7e0060d27372e2$export$a8acabc71ea42c7b,
    formRow: $0c7e0060d27372e2$export$b534bc812df080fd,
    actionRow: $0c7e0060d27372e2$export$549b91d6da945c97,
    space: $0c7e0060d27372e2$export$eef1e68107c58ef2,
    signInButton: $0c7e0060d27372e2$export$e4624626de9ce646,
    input: $0c7e0060d27372e2$export$f5b8910cec6cf069,
    button: $0c7e0060d27372e2$export$353f5b6fc5456de1,
    a: $0c7e0060d27372e2$export$ebd11618f299a286,
    pre: $0c7e0060d27372e2$export$bba54bd7e8a0d398,
    col1: $0c7e0060d27372e2$export$4f22f48eb31142b4,
    col2: $0c7e0060d27372e2$export$91e0dcaa1775f500,
    col3: $0c7e0060d27372e2$export$74947a8e25d4c355,
    col4: $0c7e0060d27372e2$export$3f1319121e89c6e2,
    col5: $0c7e0060d27372e2$export$6eda199a9225028b,
    col6: $0c7e0060d27372e2$export$f09604f8c820321f,
    col7: $0c7e0060d27372e2$export$48878381c2fa2cad,
    col8: $0c7e0060d27372e2$export$d1a6c81260d13f5,
    col9: $0c7e0060d27372e2$export$6b5338870615cec6,
    col10: $0c7e0060d27372e2$export$dfe03fd20cdc8e46,
    col11: $0c7e0060d27372e2$export$93e2edefce39c88c,
    col12: $0c7e0060d27372e2$export$a48df6afa5564db7,
    hidden: $0c7e0060d27372e2$export$8dc98ba7eadeaa56
};
var /**
 * @deprecated use named import
 */ $0c7e0060d27372e2$export$2e2bcd8739ae039 = $0c7e0060d27372e2$export$f6a06b563a614935;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");


var $3a1c35d201873e49$var$__assign = undefined && undefined.__assign || function() {
    $3a1c35d201873e49$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a1c35d201873e49$var$__assign.apply(this, arguments);
};
var $3a1c35d201873e49$export$42a852a2b6b56249 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.container);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-container",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$f06621d9ad29af97 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.formContainer);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: "amplify-form-container",
        style: style
    }, props.children));
};
var $3a1c35d201873e49$export$b5ff61ac8b0a660f = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.formSection);
    return $denZA.createElement($3a1c35d201873e49$export$f06621d9ad29af97, {
        theme: theme
    }, $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: "amplify-form-section",
        style: style
    }, props.children)));
};
var $3a1c35d201873e49$export$b0bceea2ea86179a = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.errorSection);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-error-section",
        style: style
    }), $denZA.createElement($3a1c35d201873e49$export$b51bd3844c500926, null, props.children)));
};
var $3a1c35d201873e49$export$b51bd3844c500926 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.errorSectionContent);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: "amplify-error-section-content",
        style: style
    }, props.children));
};
var $3a1c35d201873e49$export$8adb256d999cd5a0 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.sectionHeader);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-section-header",
        style: style
    }), $denZA.createElement($3a1c35d201873e49$export$3af67e6e31678076, {
        theme: theme
    }, props.children)));
};
var $3a1c35d201873e49$export$3af67e6e31678076 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.sectionHeaderContent);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: "amplify-section-header-content",
        style: style
    }, props.children));
};
var $3a1c35d201873e49$export$a8acabc71ea42c7b = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.sectionFooter);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-section-footer",
        style: style
    }), $denZA.createElement($3a1c35d201873e49$export$8b3ad764eca5990d, {
        theme: theme
    }, props.children)));
};
var $3a1c35d201873e49$export$8b3ad764eca5990d = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.sectionFooterContent);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: "amplify-section-footer-content",
        style: style
    }, props.children));
};
var $3a1c35d201873e49$export$e7049d4e10b2bdab = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.sectionBody);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-section-body",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$549b91d6da945c97 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.actionRow);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-action-row",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$b534bc812df080fd = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.formRow);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-form-row",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$2fe4f0576c8a371 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.input);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $denZA.createElement($3a1c35d201873e49$export$b534bc812df080fd, {
        theme: theme
    }, $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("input", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-input",
        style: style
    }))));
};
var $3a1c35d201873e49$export$a82e89996b85f9e6 = function(props) {
    var id = props.id || '_' + props.value;
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $denZA.createElement($3a1c35d201873e49$export$b534bc812df080fd, {
        theme: theme
    }, $denZA.createElement($3a1c35d201873e49$export$d7b12c4107be0d61, $3a1c35d201873e49$var$__assign({}, props, {
        id: id
    })), $denZA.createElement($3a1c35d201873e49$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $3a1c35d201873e49$export$d7b12c4107be0d61 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.radio);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("input", $3a1c35d201873e49$var$__assign({}, p, {
        type: "radio",
        className: "amplify-radio",
        style: style
    })));
};
var $3a1c35d201873e49$export$90573f604378c4e2 = function(props) {
    var id = props.id || '_' + props.name;
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $denZA.createElement($3a1c35d201873e49$export$b534bc812df080fd, {
        theme: theme
    }, $denZA.createElement($3a1c35d201873e49$export$48513f6b9f8ce62d, $3a1c35d201873e49$var$__assign({}, props, {
        id: id
    })), $denZA.createElement($3a1c35d201873e49$export$b04be29aa201d4f5, {
        htmlFor: id,
        theme: theme
    }, props.placeholder));
};
var $3a1c35d201873e49$export$48513f6b9f8ce62d = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.checkbox);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("input", $3a1c35d201873e49$var$__assign({}, p, {
        type: "checkbox",
        className: "amplify-checkbox",
        style: style
    })));
};
var $3a1c35d201873e49$export$101e8bcd2ede0b61 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $denZA.createElement($3a1c35d201873e49$export$b534bc812df080fd, {
        theme: theme
    }, $denZA.createElement($3a1c35d201873e49$export$2e323b58d6467594, {
        theme: theme
    }, props.children));
};
var $3a1c35d201873e49$export$2e323b58d6467594 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: "amplify-message-content",
        style: theme.messageContent
    }, props.children));
};
var $3a1c35d201873e49$export$564cbe3426fc093a = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", {
        className: "amplify-action-row",
        style: theme.actionRow
    }, $denZA.createElement($3a1c35d201873e49$export$353f5b6fc5456de1, $3a1c35d201873e49$var$__assign({}, props))));
};
var $3a1c35d201873e49$export$353f5b6fc5456de1 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.button);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("button", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-button",
        style: style
    }), $denZA.createElement($3a1c35d201873e49$export$260bb228dedc7e4f, {
        theme: theme
    }, props.children)));
};
var $3a1c35d201873e49$export$260bb228dedc7e4f = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        className: "amplify-button-content",
        style: theme.buttonContent
    }, props.children));
};
var $3a1c35d201873e49$export$e4624626de9ce646 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.signInButton);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("button", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-signin-button",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$a6c7ac8248d6e38a = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.a);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("a", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-a",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$b04be29aa201d4f5 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.label);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("label", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-label",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$eef1e68107c58ef2 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.space);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-space",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$ef8da11641c635de = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.navBar);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-nav-bar",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$39140c7d8b0ba7b3 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.nav);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-nav",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$919d7ae8be750217 = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.navRight);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-nav-right",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$e3925dbaeffcc83f = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.navItem);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("div", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-nav-item",
        style: style
    }), props.children));
};
var $3a1c35d201873e49$export$3b0a9d598f613fa = function(props) {
    var theme = props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
    var style = $3a1c35d201873e49$export$3fef91f8d3f898a7(props, theme.navButton);
    var p = (0, $4635c76aed896f54$export$5e10ed067f63a9ea)(props, 'theme');
    return $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("button", $3a1c35d201873e49$var$__assign({}, p, {
        className: "amplify-nav-button",
        style: style
    }), $3a1c35d201873e49$export$c730c7ea62823cdc($denZA.createElement("span", {
        style: theme.navButtonContent
    }, props.children))));
};
var $3a1c35d201873e49$export$c730c7ea62823cdc = function(el) {
    var style = el.props.style || {};
    var before = style.before, after = style.after;
    if (!before && !after) return el;
    return $denZA.createElement("span", {
        style: {
            position: 'relative'
        }
    }, before ? $denZA.createElement("span", {
        style: before
    }, before.content) : null, el, after ? $denZA.createElement("span", {
        style: after
    }, after.content) : null);
};
var $3a1c35d201873e49$export$3fef91f8d3f898a7 = function(props, themeStyle) {
    var id = props.id, style = props.style;
    var styl = Object.assign({}, style, themeStyle);
    if (!id) return styl;
    var selector = '#' + id;
    Object.assign(styl, styl[selector]);
    return styl;
};
var $3a1c35d201873e49$export$f1e6604bf31fa1a6 = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
var $3a1c35d201873e49$export$b810853147c3ffeb = 'data:image/gif;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");




var $58a7b1935763e579$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $58a7b1935763e579$var$PickerPreview = {
    maxWidth: '100%'
};
var $58a7b1935763e579$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('PhotoPicker');
var $58a7b1935763e579$export$3384892c047819d2 = /** @class */ function(_super) {
    $58a7b1935763e579$var$__extends(PhotoPicker, _super);
    function PhotoPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.state = {
            previewSrc: props.previewSrc
        };
        return _this;
    }
    PhotoPicker.prototype.handlePick = function(data) {
        var that = this;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var _a = this.props, preview = _a.preview, onPick = _a.onPick, onLoad = _a.onLoad;
        if (onPick) onPick(data);
        if (preview) {
            var reader = new FileReader();
            reader.onload = function(e) {
                var url = e.target.result;
                // @ts-ignore
                that.setState({
                    previewSrc: url
                });
                if (onLoad) onLoad(url);
            };
            reader.readAsDataURL(file);
        }
    };
    PhotoPicker.prototype.render = function() {
        var preview = this.props.preview;
        var previewSrc = this.state.previewSrc;
        var headerText = this.props.headerText || 'Photos';
        var headerHint = this.props.headerHint || 'Add your photos by clicking below';
        var title = this.props.title || 'Select a Photo';
        var theme = this.props.theme || (0, $fbd753a9a9e4139c$export$2e2bcd8739ae039);
        var previewStyle = Object.assign({}, $58a7b1935763e579$var$PickerPreview, theme.pickerPreview);
        var previewHidden = !(preview && preview !== 'hidden');
        return $denZA.createElement((0, $d82b2daa6d3b54d5$export$b5ff61ac8b0a660f), {
            theme: theme
        }, $denZA.createElement((0, $d82b2daa6d3b54d5$export$8adb256d999cd5a0), {
            theme: theme,
            hint: headerHint
        }, (0, $20154f355a8c1f05$export$dbe3113d60765c1a).get(headerText)), $denZA.createElement((0, $d82b2daa6d3b54d5$export$e7049d4e10b2bdab), {
            theme: theme
        }, previewSrc ? previewHidden ? 'The image has been selected' : $denZA.createElement("img", {
            src: previewSrc,
            style: previewStyle
        }) : $denZA.createElement((0, $d82b2daa6d3b54d5$export$6436834aeb5748e7), {
            theme: theme
        })), $denZA.createElement((0, $4dfa122de46601b8$export$ba25329847403e11), {
            title: title,
            accept: "image/*",
            theme: theme,
            onPick: this.handlePick
        }));
    };
    return PhotoPicker;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $58a7b1935763e579$export$2e2bcd8739ae039 = $58a7b1935763e579$export$3384892c047819d2;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ function $bbaa84e7045ce9d1$export$5346f70488f1cd2(file, fileToKey) {
    var name = file.name, size = file.size, type = file.type;
    var key = encodeURI(name);
    if (fileToKey) {
        var callback_type = typeof fileToKey;
        if (callback_type === 'string') key = fileToKey;
        else if (callback_type === 'function') key = fileToKey({
            name: name,
            size: size,
            type: type
        });
        else key = encodeURI(JSON.stringify(fileToKey));
        if (!key) key = 'empty_key';
    }
    return key.replace(/\s/g, '_');
}


var $2803e3021040fc32$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2803e3021040fc32$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Storage.S3Image');
var $2803e3021040fc32$export$6400234c4a9a250 = /** @class */ function(_super) {
    $2803e3021040fc32$var$__extends(S3Image, _super);
    function S3Image(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handleOnLoad = _this.handleOnLoad.bind(_this);
        _this.handleOnError = _this.handleOnError.bind(_this);
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        var initSrc = _this.props.src || (0, $3a1c35d201873e49$export$f1e6604bf31fa1a6);
        _this.state = {
            src: initSrc
        };
        return _this;
    }
    S3Image.prototype.getImageSource = function(key, level, track, identityId) {
        var _this = this;
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get(key, {
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(url) {
            if (_this._isMounted) _this.setState({
                src: url
            });
        }).catch(function(err) {
            return $2803e3021040fc32$var$logger.debug(err);
        });
    };
    S3Image.prototype.load = function() {
        var _a = this.props, imgKey = _a.imgKey, path = _a.path, body = _a.body, contentType = _a.contentType, level = _a.level, track = _a.track, identityId = _a.identityId;
        if (!imgKey && !path) {
            $2803e3021040fc32$var$logger.debug('empty imgKey and path');
            return;
        }
        var that = this;
        var key = imgKey || path;
        $2803e3021040fc32$var$logger.debug('loading ' + key + '...');
        if (body) {
            var type = contentType || 'binary/octet-stream';
            if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
            var ret = (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(key, body, {
                contentType: type,
                level: level ? level : 'public',
                track: track
            });
            ret.then(function(data) {
                $2803e3021040fc32$var$logger.debug(data);
                that.getImageSource(key, level, track, identityId);
            }).catch(function(err) {
                return $2803e3021040fc32$var$logger.debug(err);
            });
        } else that.getImageSource(key, level, track, identityId);
    };
    S3Image.prototype.handleOnLoad = function(evt) {
        var onLoad = this.props.onLoad;
        if (onLoad) onLoad(this.state.src);
    };
    S3Image.prototype.handleOnError = function(evt) {
        var onError = this.props.onError;
        if (onError) onError(this.state.src);
    };
    S3Image.prototype.handlePick = function(data) {
        var that = this;
        var _a = this.props, imgKey = _a.imgKey, level = _a.level, fileToKey = _a.fileToKey, track = _a.track, identityId = _a.identityId, _b = _a.path, path = _b === void 0 ? '' : _b, onUploadSuccess = _a.onUploadSuccess;
        var file = data.file, type = data.type;
        var key = imgKey || path + (0, $bbaa84e7045ce9d1$export$5346f70488f1cd2)(data, fileToKey);
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $2803e3021040fc32$var$logger.debug('handle pick data', data);
            that.getImageSource(key, level, track, identityId);
            if (onUploadSuccess) onUploadSuccess();
        }).catch(function(err) {
            return $2803e3021040fc32$var$logger.debug('handle pick error', err);
        });
    };
    S3Image.prototype.handleClick = function(evt) {
        var onClick = this.props.onClick;
        if (onClick) onClick(evt);
    };
    S3Image.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.load();
    };
    S3Image.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Image.prototype.componentDidUpdate = function(prevProps) {
        var update = prevProps.path !== this.props.path || prevProps.imgKey !== this.props.imgKey || prevProps.body !== this.props.body || prevProps.level !== this.props.level;
        if (update) this.load();
    };
    S3Image.prototype.imageEl = function(src, theme) {
        if (!src) return null;
        var _a = this.props, className = _a.className, selected = _a.selected;
        var containerStyle = {
            position: 'relative'
        };
        return $denZA.createElement("div", {
            style: containerStyle,
            onClick: this.handleClick
        }, $denZA.createElement("img", {
            className: className,
            style: theme.photoImg,
            src: src,
            onLoad: this.handleOnLoad,
            onError: this.handleOnError
        }), $denZA.createElement("div", {
            style: selected ? theme.overlaySelected : theme.overlay
        }));
    };
    S3Image.prototype.render = function() {
        var _a = this.props, hidden = _a.hidden, style = _a.style, picker = _a.picker, translate = _a.translate, imgKey = _a.imgKey;
        var src = this.state.src;
        if (translate) src = typeof translate === 'string' ? translate : translate({
            type: 'image',
            key: imgKey,
            content: src
        });
        if (!src && !picker) return null;
        var theme = this.props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
        var photoStyle = hidden ? (0, $0c7e0060d27372e2$export$2e2bcd8739ae039).hidden : Object.assign({}, theme.photo, style);
        return $denZA.createElement("div", {
            style: photoStyle
        }, photoStyle ? this.imageEl(src, theme) : null, picker ? $denZA.createElement("div", null, $denZA.createElement((0, $58a7b1935763e579$export$3384892c047819d2), {
            key: "picker",
            onPick: this.handlePick,
            theme: theme
        })) : null);
    };
    return S3Image;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $2803e3021040fc32$export$2e2bcd8739ae039 = $2803e3021040fc32$export$6400234c4a9a250;


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");



/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $denZA = parcelRequire("denZA");



var $90b416300bcdf387$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $90b416300bcdf387$var$Container = {};
var $90b416300bcdf387$var$PickerPreview = {
    maxWidth: '100%'
};
var $90b416300bcdf387$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('TextPicker');
var $90b416300bcdf387$export$9300848523b4e1ae = /** @class */ function(_super) {
    $90b416300bcdf387$var$__extends(TextPicker, _super);
    function TextPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.state = {
            previewText: props.previewText
        };
        return _this;
    }
    TextPicker.prototype.handlePick = function(data) {
        var that = this;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var _a = this.props, preview = _a.preview, onPick = _a.onPick, onLoad = _a.onLoad;
        if (onPick) onPick(data);
        if (preview) {
            var reader = new FileReader();
            reader.onload = function(e) {
                var text = e.target.result;
                // @ts-ignore
                that.setState({
                    previewText: text
                });
                if (onLoad) onLoad(text);
            };
            reader.readAsText(file);
        }
    };
    TextPicker.prototype.render = function() {
        var preview = this.props.preview;
        var previewText = this.state.previewText;
        var title = this.props.title || 'Pick a File';
        var theme = this.props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
        var containerStyle = Object.assign({}, $90b416300bcdf387$var$Container, theme.picker);
        var previewStyle = Object.assign({}, $90b416300bcdf387$var$PickerPreview, theme.pickerPreview, theme.halfHeight, preview && preview !== 'hidden' ? {} : (0, $0c7e0060d27372e2$export$2e2bcd8739ae039).hidden);
        return $denZA.createElement("div", {
            style: containerStyle
        }, previewText ? $denZA.createElement("div", {
            style: previewStyle
        }, $denZA.createElement("pre", {
            style: theme.pre
        }, previewText)) : null, $denZA.createElement((0, $4dfa122de46601b8$export$ba25329847403e11), {
            title: title,
            accept: "text/*",
            theme: theme,
            onPick: this.handlePick
        }));
    };
    return TextPicker;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $90b416300bcdf387$export$2e2bcd8739ae039 = $90b416300bcdf387$export$9300848523b4e1ae;



var $8e0f21fa1b2977ec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8e0f21fa1b2977ec$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Storage.S3Text');
var $8e0f21fa1b2977ec$export$1006e13b82d657a0 = /** @class */ function(_super) {
    $8e0f21fa1b2977ec$var$__extends(S3Text, _super);
    function S3Text(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handleOnLoad = _this.handleOnLoad.bind(_this);
        _this.handleOnError = _this.handleOnError.bind(_this);
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        var text = props.text, textKey = props.textKey;
        _this.state = {
            text: text || '',
            textKey: textKey || ''
        };
        return _this;
    }
    S3Text.prototype.getText = function(key, level, track, identityId) {
        var _this = this;
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get(key, {
            download: true,
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(data) {
            $8e0f21fa1b2977ec$var$logger.debug(data);
            // @ts-ignore
            var text = data.Body.toString('utf8');
            if (_this._isMounted) _this.setState({
                text: text
            });
            _this.handleOnLoad(text);
        }).catch(function(err) {
            $8e0f21fa1b2977ec$var$logger.debug(err);
            _this.handleOnError(err);
        });
    };
    S3Text.prototype.load = function() {
        var _a = this.props, path = _a.path, textKey = _a.textKey, body = _a.body, contentType = _a.contentType, level = _a.level, track = _a.track, identityId = _a.identityId;
        if (!textKey && !path) {
            $8e0f21fa1b2977ec$var$logger.debug('empty textKey and path');
            return;
        }
        var that = this;
        var key = textKey || path;
        $8e0f21fa1b2977ec$var$logger.debug('loading ' + key + '...');
        if (body) {
            var type = contentType || 'text/*';
            if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
            var ret = (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(key, body, {
                contentType: type,
                level: level ? level : 'public',
                track: track
            });
            ret.then(function(data) {
                $8e0f21fa1b2977ec$var$logger.debug(data);
                that.getText(key, level, track, identityId);
            }).catch(function(err) {
                return $8e0f21fa1b2977ec$var$logger.debug(err);
            });
        } else that.getText(key, level, track, identityId);
    };
    S3Text.prototype.handleOnLoad = function(text) {
        var onLoad = this.props.onLoad;
        if (onLoad) onLoad(text);
    };
    S3Text.prototype.handleOnError = function(err) {
        var onError = this.props.onError;
        if (onError) onError(err);
    };
    S3Text.prototype.handlePick = function(data) {
        var that = this;
        var path = this.props.path || '';
        var _a = this.props, textKey = _a.textKey, level = _a.level, fileToKey = _a.fileToKey, track = _a.track, identityId = _a.identityId;
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var key = textKey || path + (0, $bbaa84e7045ce9d1$export$5346f70488f1cd2)(data, fileToKey);
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $8e0f21fa1b2977ec$var$logger.debug('handle pick data', data);
            that.getText(key, level, track, identityId);
        }).catch(function(err) {
            return $8e0f21fa1b2977ec$var$logger.debug('handle pick error', err);
        });
    };
    S3Text.prototype.handleClick = function(evt) {
        var onClick = this.props.onClick;
        if (onClick) onClick(evt);
    };
    S3Text.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.load();
    };
    S3Text.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Text.prototype.componentDidUpdate = function(prevProps) {
        var update = prevProps.path !== this.props.path || prevProps.textKey !== this.props.textKey || prevProps.body !== this.props.body;
        if (update) this.load();
    };
    S3Text.prototype.textEl = function(text, theme) {
        if (!text) return null;
        var selected = this.props.selected;
        var containerStyle = {
            position: 'relative'
        };
        return $denZA.createElement("div", {
            style: containerStyle,
            onClick: this.handleClick
        }, $denZA.createElement("pre", {
            style: theme.pre
        }, text), $denZA.createElement("div", {
            style: selected ? theme.overlaySelected : theme.overlay
        }));
    };
    S3Text.prototype.render = function() {
        var _a = this.props, hidden = _a.hidden, style = _a.style, picker = _a.picker, translate = _a.translate, textKey = _a.textKey;
        var text = this.state.text;
        if (translate) text = typeof translate === 'string' ? translate : translate({
            type: 'text',
            key: textKey,
            content: text
        });
        if (!text && !picker) return null;
        var theme = this.props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
        var textStyle = hidden ? (0, $0c7e0060d27372e2$export$2e2bcd8739ae039).hidden : Object.assign({}, theme.text, style);
        return $denZA.createElement("div", {
            style: textStyle
        }, textStyle ? this.textEl(text, theme) : null, picker ? $denZA.createElement("div", null, $denZA.createElement((0, $90b416300bcdf387$export$9300848523b4e1ae), {
            key: "picker",
            onPick: this.handlePick,
            theme: theme
        })) : null);
    };
    return S3Text;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $8e0f21fa1b2977ec$export$2e2bcd8739ae039 = $8e0f21fa1b2977ec$export$1006e13b82d657a0;


var $2ec7e8a1d7b5ac37$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2ec7e8a1d7b5ac37$var$logger = new (0, $1da0335809723f81$export$ba6a9c7ac8291f7f)('Storage.S3Album');
var $2ec7e8a1d7b5ac37$export$45095fab81dc21fc = /** @class */ function(_super) {
    $2ec7e8a1d7b5ac37$var$__extends(S3Album, _super);
    function S3Album(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.handlePick = _this.handlePick.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.list = _this.list.bind(_this);
        _this.marshal = _this.marshal.bind(_this);
        _this.state = {
            items: [],
            ts: new Date().getTime()
        };
        return _this;
    }
    S3Album.prototype.getKey = function(file) {
        var fileToKey = this.props.fileToKey;
        var name = file.name, size = file.size, type = file.type;
        var key = encodeURI(name);
        if (fileToKey) {
            var callback_type = typeof fileToKey;
            if (callback_type === 'string') key = fileToKey;
            else if (callback_type === 'function') key = fileToKey({
                name: name,
                size: size,
                type: type
            });
            else key = encodeURI(JSON.stringify(fileToKey));
            if (!key) {
                $2ec7e8a1d7b5ac37$var$logger.debug('key is empty');
                key = 'empty_key';
            }
        }
        return key.replace(/\s/g, '_');
    };
    S3Album.prototype.handlePick = function(data) {
        var _this = this;
        var _a = this.props, onPick = _a.onPick, onLoad = _a.onLoad, onError = _a.onError, track = _a.track, level = _a.level;
        if (onPick) onPick(data);
        var path = this.props.path || '';
        var file = data.file, name = data.name, size = data.size, type = data.type;
        var key = path + this.getKey(data);
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(key, file, {
            level: level ? level : 'public',
            contentType: type,
            track: track
        }).then(function(data) {
            $2ec7e8a1d7b5ac37$var$logger.debug('handle pick data', data);
            var items = _this.state.items;
            if (items.filter(function(item) {
                return item.key === key;
            }).length === 0) {
                var list = items.concat(data);
                _this.marshal(list);
            } else $2ec7e8a1d7b5ac37$var$logger.debug('update an item');
            if (onLoad) onLoad(data);
        }).catch(function(err) {
            $2ec7e8a1d7b5ac37$var$logger.debug('handle pick error', err);
            if (onError) onError(err);
        });
        if (this._isMounted) this.setState({
            ts: new Date().getTime()
        });
    };
    S3Album.prototype.handleClick = function(item) {
        var _a = this.props, onClickItem = _a.onClickItem, select = _a.select, onSelect = _a.onSelect;
        if (onClickItem) onClickItem(item);
        if (!select) return;
        item.selected = !item.selected;
        if (this._isMounted) this.setState({
            items: this.state.items.slice()
        });
        if (!onSelect) return;
        var selected_items = this.state.items.filter(function(item) {
            return item.selected;
        });
        onSelect(item, selected_items);
    };
    S3Album.prototype.componentDidMount = function() {
        this._isMounted = true;
        this.list();
    };
    S3Album.prototype.componentWillUnmount = function() {
        this._isMounted = false;
    };
    S3Album.prototype.componentDidUpdate = function(prevProps, prevState) {
        if (this.props.path === prevProps.path && this.props.ts === prevProps.ts && this.props.select === prevProps.select) return;
        if (!this.props.select) this.state.items.forEach(function(item) {
            return item.selected = false;
        });
        if (this.props.onSelect) this.props.onSelect(null, []);
        this.list();
    };
    S3Album.prototype.list = function() {
        var _this = this;
        var _a = this.props, path = _a.path, level = _a.level, track = _a.track, identityId = _a.identityId;
        $2ec7e8a1d7b5ac37$var$logger.debug('Album path: ' + path);
        if (!(0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c) || typeof (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).list !== 'function') throw new Error('No Storage module found, please ensure @aws-amplify/storage is imported');
        return (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).list(path, {
            level: level ? level : 'public',
            track: track,
            identityId: identityId
        }).then(function(data) {
            $2ec7e8a1d7b5ac37$var$logger.debug('album list', data);
            _this.marshal(data);
        }).catch(function(err) {
            $2ec7e8a1d7b5ac37$var$logger.warn(err);
            return [];
        });
    };
    S3Album.prototype.contentType = function(item) {
        return (0, $4635c76aed896f54$export$49cecb876bed446d)(item.key, 'image/*');
    };
    S3Album.prototype.marshal = function(list) {
        var _this = this;
        var contentType = this.props.contentType || '';
        list.forEach(function(item) {
            if (item.contentType) return;
            var isString = typeof contentType === 'string';
            item.contentType = isString ? contentType : contentType(item);
            if (!item.contentType) item.contentType = _this.contentType(item);
        });
        var items = this.filter(list);
        items = this.sort(items);
        if (this._isMounted) this.setState({
            items: items
        });
    };
    S3Album.prototype.filter = function(list) {
        var filter = this.props.filter;
        return filter ? filter(list) : list;
    };
    S3Album.prototype.sort = function(list) {
        var sort = this.props.sort;
        var typeof_sort = typeof sort;
        if (typeof_sort === 'function') return sort(list);
        // @ts-ignore
        if ([
            'string',
            'undefined'
        ].includes(typeof_sort)) {
            var sort_str = sort ? sort : 'lastModified';
            var parts = sort_str.split(/\s+/);
            var field = parts[0];
            var dir = parts.length > 1 ? parts[1] : '';
            if (field === 'lastModified') dir = dir === 'asc' ? 'asc' : 'desc';
            else dir = dir === 'desc' ? 'desc' : 'asc';
            (0, $4635c76aed896f54$export$756e1e7707954007)(list, field, dir);
            return list;
        }
        $2ec7e8a1d7b5ac37$var$logger.warn('invalid sort. done nothing. should be a string or function');
        return list;
    };
    S3Album.prototype.render = function() {
        var _this = this;
        var _a = this.props, picker = _a.picker, translateItem = _a.translateItem, level = _a.level, identityId = _a.identityId;
        var _b = this.state, items = _b.items, ts = _b.ts;
        var pickerTitle = this.props.pickerTitle || 'Pick';
        var theme = this.props.theme || (0, $0c7e0060d27372e2$export$2e2bcd8739ae039);
        var list = items.map(function(item) {
            var isText = item.contentType && (0, $4635c76aed896f54$export$689bea3eece53c0e)(item.contentType);
            return isText ? $denZA.createElement((0, $8e0f21fa1b2977ec$export$1006e13b82d657a0), {
                key: item.key,
                textKey: item.key,
                theme: theme,
                style: theme.albumText,
                selected: item.selected,
                translate: translateItem,
                level: level,
                identityId: identityId,
                onClick: function() {
                    return _this.handleClick(item);
                }
            }) : $denZA.createElement((0, $2803e3021040fc32$export$6400234c4a9a250), {
                key: item.key,
                imgKey: item.key,
                theme: theme,
                style: theme.albumPhoto,
                selected: item.selected,
                translate: translateItem,
                level: level,
                identityId: identityId,
                onClick: function() {
                    return _this.handleClick(item);
                }
            });
        });
        return $denZA.createElement("div", null, $denZA.createElement("div", {
            style: theme.album
        }, list), picker ? $denZA.createElement((0, $4dfa122de46601b8$export$ba25329847403e11), {
            key: ts,
            title: pickerTitle,
            accept: "image/*, text/*",
            onPick: this.handlePick,
            theme: theme
        }) : null);
    };
    return S3Album;
}($denZA.Component);
var /**
 * @deprecated use named import
 */ $2ec7e8a1d7b5ac37$export$2e2bcd8739ae039 = $2ec7e8a1d7b5ac37$export$45095fab81dc21fc;












(0, $20154f355a8c1f05$export$dbe3113d60765c1a).putVocabularies((0, $234546212c2d4b21$export$b7eef48498bbd53e));







/**
 * @typedef {'image' | 'pdf' | 'other'} FileCategory
 */ /**
 * Defines the possible file categories.
 * @enum {FileCategory}
 */ const $06ef78c2a99372ca$export$647511e89ebff2a7 = {
    IMAGE: 'image',
    PDF: 'pdf',
    OTHER: 'other'
};
function $06ef78c2a99372ca$export$284e6e76ba5e79b9(filename) {
    const lastDotIndex = filename.lastIndexOf('.');
    const ext = lastDotIndex === -1 || lastDotIndex === 0 ? '' : filename.substring(lastDotIndex + 1).toLowerCase();
    const imageExtensions = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        svg: 'image/svg+xml',
        webp: 'image/webp',
        bmp: 'image/bmp',
        ico: 'image/vnd.microsoft.icon',
        tif: 'image/tiff',
        tiff: 'image/tiff'
    };
    if (ext in imageExtensions) return {
        mimeType: imageExtensions[ext],
        category: $06ef78c2a99372ca$export$647511e89ebff2a7.IMAGE
    };
    if (ext === 'pdf') return {
        mimeType: 'application/pdf',
        category: $06ef78c2a99372ca$export$647511e89ebff2a7.PDF
    };
    // Generic fallback
    const mimeType = 'application/octet-stream';
    return {
        mimeType: mimeType,
        category: $06ef78c2a99372ca$export$647511e89ebff2a7.OTHER
    };
}



const $1c1c233087ac0505$var$imageViewerImageStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    height: 'auto',
    width: '100%',
    display: 'block'
});
const $1c1c233087ac0505$var$pdfViewerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '100%',
    height: 'calc(100vh - 160px)',
    border: 'none',
    marginTop: '60px'
});
const $1c1c233087ac0505$var$imageViewerContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: 1200,
    position: 'relative',
    margin: '0 auto',
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
});
const $1c1c233087ac0505$var$imageViewCloseButton = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    top: 30,
    right: 30,
    border: 'none',
    height: 40,
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 1,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate10,
    '&:hover': {
        backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20
    }
});
const $1c1c233087ac0505$var$imageViewerCloseIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 16,
    height: 16
});
const $1c1c233087ac0505$var$spinnerWrapperStyle = ()=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        position: 'absolute',
        zIndex: 1,
        left: 0,
        right: 0,
        top: '30%'
    });
const $1c1c233087ac0505$export$9e0b12df12385af6 = ({ imageId: imageId, closeImageModal: closeImageModal })=>{
    const fileCategory = (0, $06ef78c2a99372ca$export$284e6e76ba5e79b9)(imageId).category;
    const [isLoading, setIsLoading] = (0, $denZA.useState)(true);
    const [pdfUrl, setPdfUrl] = (0, $denZA.useState)(null);
    (0, $denZA.useEffect)(()=>{
        if (fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).PDF && imageId) (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get(imageId, {
            level: 'public'
        }).then((url)=>{
            setPdfUrl(url);
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
        });
    }, [
        imageId,
        fileCategory
    ]);
    const handleLoad = ()=>{
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        onClick: closeImageModal,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $1c1c233087ac0505$var$imageViewerContainerStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("button", {
                    "aria-label": "Close image modal",
                    css: $1c1c233087ac0505$var$imageViewCloseButton,
                    onClick: closeImageModal,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $88a0171ecb792bad$export$3c877bb842c36952), {
                        css: $1c1c233087ac0505$var$imageViewerCloseIconStyle
                    })
                }),
                isLoading && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $1c1c233087ac0505$var$spinnerWrapperStyle,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
                }),
                fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).IMAGE && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $2803e3021040fc32$export$6400234c4a9a250), {
                    css: $1c1c233087ac0505$var$imageViewerImageStyle,
                    level: "public",
                    imgKey: imageId,
                    onLoad: handleLoad,
                    style: {
                        display: isLoading ? 'none' : 'block'
                    }
                }),
                fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).PDF && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("iframe", {
                    css: $1c1c233087ac0505$var$pdfViewerStyle,
                    src: pdfUrl,
                    title: "PDF Viewer",
                    onLoad: handleLoad,
                    style: {
                        display: isLoading ? 'none' : 'block'
                    }
                }),
                fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).OTHER && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    children: "Unsuported file type."
                })
            ]
        })
    });
};
$1c1c233087ac0505$export$9e0b12df12385af6.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    closeImageModal: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};




var $cvFNP = parcelRequire("cvFNP");



const $dfe2cae5e4c44ee0$var$bodyText = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6,
    '& > p': {
        marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
    }
});
const $dfe2cae5e4c44ee0$export$4994368e0bfca573 = ({ header: header, body: body, closeInfoModal: closeInfoModal })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        onClick: closeInfoModal,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772), {
            heading: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Heading, {
                children: header
            }),
            body: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Body, {
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $dfe2cae5e4c44ee0$var$bodyText,
                    dangerouslySetInnerHTML: {
                        __html: body
                    }
                })
            }),
            status: "information",
            exitClickHandler: closeInfoModal
        })
    });
$dfe2cae5e4c44ee0$export$4994368e0bfca573.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    closeInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};




var $cvFNP = parcelRequire("cvFNP");


const $789a8415176b61ba$export$17bd6d70df17bc40 = ({ imageId: imageId, closeDeleteImageModal: closeDeleteImageModal, deleteImageHandler: deleteImageHandler })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
        isOpen: true,
        onClick: closeDeleteImageModal,
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772), {
            status: "error",
            icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6aa7e8776e67a2c8$export$bfadae053a633538), {}),
            heading: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Heading, {
                children: "Delete image?"
            }),
            body: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Body, {
                children: "Are you sure you want to delete the image?"
            }),
            action: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Action, {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "aria-label": "Confirm delete image button",
                        label: "Delete",
                        onClick: ()=>deleteImageHandler(imageId)
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        label: "Cancel",
                        variant: "outline",
                        onClick: closeDeleteImageModal
                    })
                ]
            }),
            exitClickHandler: closeDeleteImageModal
        })
    });
$789a8415176b61ba$export$17bd6d70df17bc40.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    closeDeleteImageModal: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    deleteImageHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};






var $cvFNP = parcelRequire("cvFNP");




var $cvFNP = parcelRequire("cvFNP");






const $89be9ed39893bc50$var$uploadImageExpandOverlayStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'none',
    position: 'absolute',
    background: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: 0.8
});
const $89be9ed39893bc50$var$uploadImageContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate10,
    position: 'relative',
    borderRadius: 4,
    overflow: 'hidden'
});
const $89be9ed39893bc50$var$uploadImageExpandIcon = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate50,
    width: 22,
    height: 22
});
const $89be9ed39893bc50$var$uploadImageWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    '&:last-child': {
        marginRight: 0
    }
});
const $89be9ed39893bc50$var$uploadImageStyle = {
    display: 'block',
    width: 77,
    height: 50,
    cursor: 'pointer',
    borderRadius: 4,
    objectFit: 'contain'
};
const $89be9ed39893bc50$export$94984c14ad3e5368 = ({ imageId: imageId, imageClickHandler: imageClickHandler, imageDeleteClickHandler: imageDeleteClickHandler, fileCategory: fileCategory, isEditable: isEditable = true })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $89be9ed39893bc50$var$uploadImageWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $89be9ed39893bc50$var$uploadImageContainerStyle,
                onClick: imageClickHandler,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $89be9ed39893bc50$var$uploadImageExpandOverlayStyle,
                        "data-css": "hover-overlay",
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ff1822b588ebfeef$export$6b5ba4345fea866a), {
                            css: $89be9ed39893bc50$var$uploadImageExpandIcon
                        })
                    }),
                    fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).IMAGE && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $2803e3021040fc32$export$6400234c4a9a250), {
                        css: $89be9ed39893bc50$var$uploadImageStyle,
                        level: "public",
                        imgKey: imageId
                    }),
                    (fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).PDF || fileCategory === (0, $06ef78c2a99372ca$export$647511e89ebff2a7).OTHER) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $089b7f87ab319191$export$c1715d484b9fa172), {
                        css: {
                            padding: 10,
                            ...$89be9ed39893bc50$var$uploadImageStyle
                        }
                    })
                ]
            }),
            isEditable && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                "aria-label": "Delete image bin icon button",
                "data-transaction-name": "Delete Image",
                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6aa7e8776e67a2c8$export$bfadae053a633538), {}),
                variant: "ghost",
                onClick: imageDeleteClickHandler
            })
        ]
    });
$89be9ed39893bc50$export$94984c14ad3e5368.propTypes = {
    imageId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    imageClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    imageDeleteClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    fileCategory: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOf(Object.values((0, $06ef78c2a99372ca$export$647511e89ebff2a7))),
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};



const $54d2d00c37640082$var$listWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    display: 'flex'
});
const $54d2d00c37640082$export$96b9b7524c25c919 = ({ uploadImageKeys: uploadImageKeys, imageClickHandler: imageClickHandler, imageDeleteClickHandler: imageDeleteClickHandler = ()=>{}, isEditable: isEditable = true })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        css: $54d2d00c37640082$var$listWrapperStyle,
        children: uploadImageKeys.map((imageId)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $89be9ed39893bc50$export$94984c14ad3e5368), {
                imageId: imageId,
                isEditable: isEditable,
                fileCategory: (0, $06ef78c2a99372ca$export$284e6e76ba5e79b9)(imageId).category,
                imageClickHandler: ()=>imageClickHandler(imageId),
                imageDeleteClickHandler: ()=>imageDeleteClickHandler(imageId)
            }, imageId))
    });
$54d2d00c37640082$export$96b9b7524c25c919.propTypes = {
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string).isRequired,
    imageClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    imageDeleteClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    fileCategory: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOf(Object.values((0, $06ef78c2a99372ca$export$647511e89ebff2a7))),
    isEditable: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");


const $cc929988d2a033e9$export$d8855409e79afbeb = {
    IF_OMNI: '#IF_OMNI#'
};
const $cc929988d2a033e9$export$266b8c04e00743cf = new Map([
    [
        $cc929988d2a033e9$export$d8855409e79afbeb.IF_OMNI,
        'If Omni'
    ]
]);



const $9194d4abb8cf2da6$export$3ec852545888aeb8 = (text, term)=>{
    const termReplacement = (0, $cc929988d2a033e9$export$266b8c04e00743cf).get(term);
    if (termReplacement === undefined) return text;
    return text.replaceAll(term, termReplacement);
};
const $9194d4abb8cf2da6$export$a18d1d0ba6f3fbc9 = (string)=>{
    let replacedString = string;
    for (const [term, replacement] of (0, $cc929988d2a033e9$export$266b8c04e00743cf))replacedString = replacedString.replaceAll(term, replacement);
    return replacedString;
};





var $cvFNP = parcelRequire("cvFNP");

const $eb78060ece465c72$var$highLightedTextCss = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.error.error600
});
const $eb78060ece465c72$export$190465bec6b893be = ({ text: text })=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
        css: $eb78060ece465c72$var$highLightedTextCss,
        children: text
    });
};
$eb78060ece465c72$export$190465bec6b893be.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};


const $094d9b0cf4faaefb$var$explanationFieldStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    whiteSpace: 'pre-wrap',
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
});
const $094d9b0cf4faaefb$var$conditionFieldStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05,
    whiteSpace: 'pre-wrap'
});
const $094d9b0cf4faaefb$var$termToHighlight = (0, $cc929988d2a033e9$export$d8855409e79afbeb).IF_OMNI;
const $094d9b0cf4faaefb$var$highLightSections = (text)=>{
    const restOfTheText = text.split($094d9b0cf4faaefb$var$termToHighlight);
    return restOfTheText.map((section, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $denZA.Fragment), {
            children: [
                section,
                index !== restOfTheText.length - 1 && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $eb78060ece465c72$export$190465bec6b893be), {
                    text: (0, $9194d4abb8cf2da6$export$3ec852545888aeb8)($094d9b0cf4faaefb$var$termToHighlight, $094d9b0cf4faaefb$var$termToHighlight)
                })
            ]
        }, index));
};
const $094d9b0cf4faaefb$export$7c0a16af240a6114 = ({ explanation: explanation, conditions: conditions })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $denZA.Fragment), {
        children: [
            explanation && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: $094d9b0cf4faaefb$var$explanationFieldStyle,
                children: $094d9b0cf4faaefb$var$highLightSections(explanation)
            }),
            conditions && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: $094d9b0cf4faaefb$var$conditionFieldStyle,
                children: conditions
            })
        ]
    });
$094d9b0cf4faaefb$export$7c0a16af240a6114.propTypes = {
    explanation: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    conditions: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string
};




const $f86acbd1c72b687f$export$1495774a44129127 = (isMultiSelect, answerValue)=>{
    if (isMultiSelect) return true;
    if (answerValue) return true;
    return false;
};
const $f86acbd1c72b687f$export$ddb7e08df9f16f51 = (answer, question, nrOfUploadedImages)=>{
    // debugger;
    const requiresComment = question.commentsTextBox === 'Open Text shown';
    const requiresUpload = question.upload;
    const result = {
        isCommentMissing: false,
        isUploadMissing: false,
        isProofMissing: false
    };
    if (!answer || !answer.selectedAnswer || answer.selectedAnswer.length === 0 || !requiresComment && !requiresUpload) return result;
    const { selectedAnswer: selectedAnswersIds, comment: comment } = answer;
    const { answersExemptFromAttachments: answersExemptFromAttachments } = question;
    const answerIdsExemptFromAttachments = answersExemptFromAttachments?.map((ans)=>ans.answerId) ?? [];
    // NON_BINARY_SINGLE_CHOICE stores sub-answer IDs at index [1+] in selectedAnswer.
    // Sub-answer IDs are not main answer options and must not influence the exempt check.
    // All other question types only have main answer IDs in selectedAnswer so every() is correct.
    const idsToCheckForExemption = question.questionType === (0, $be4e7f9ce17f6c5f$export$e50882b81c62e311).NON_BINARY_SINGLE_CHOICE ? selectedAnswersIds.slice(0, 1) : selectedAnswersIds;
    const allSelectedAreExempt = idsToCheckForExemption.length > 0 && idsToCheckForExemption.every((id)=>answerIdsExemptFromAttachments.includes(id));
    if (allSelectedAreExempt) return result;
    const didComment = comment && comment.length > 0;
    const didUploadImages = nrOfUploadedImages > 0;
    result.isCommentMissing = requiresComment && !didComment;
    result.isUploadMissing = requiresUpload && !didUploadImages;
    result.isProofMissing = result.isCommentMissing || result.isUploadMissing;
    return result;
};
const $f86acbd1c72b687f$export$3ac154c70d0babda = (questions, answers, uploadedImagesKeys)=>{
    return questions.map((question)=>{
        const savedAnswer = answers.find((answer)=>answer.questionId === question.questionId);
        let questionImageKeys;
        if (uploadedImagesKeys) questionImageKeys = $f86acbd1c72b687f$export$32f77b04f5436dc4(uploadedImagesKeys, question.questionId);
        else questionImageKeys = savedAnswer?.images?.map((imageKey)=>imageKey.replace('public/', ''));
        const proofRequirement = $f86acbd1c72b687f$export$ddb7e08df9f16f51(savedAnswer, question, questionImageKeys?.length ?? 0);
        return {
            ...question,
            savedAnswer: savedAnswer,
            questionImageKeys: questionImageKeys,
            proofRequirement: proofRequirement
        };
    });
};
const $f86acbd1c72b687f$export$22ec2e08ed58da59 = (surveyData)=>{
    const { year: year } = surveyData;
    const { requiredProof: requiredProof } = (0, $ae3efe89c6a10731$export$e62953d023125748);
    const isYearCovered = year >= requiredProof.startYear;
    return isYearCovered;
};
const $f86acbd1c72b687f$export$386fc8b17cd02a9b = (enhancedQuestionData, surveyData)=>{
    const shouldBeCheckedForProof = $f86acbd1c72b687f$export$22ec2e08ed58da59(surveyData);
    if (!shouldBeCheckedForProof) return enhancedQuestionData.map((question)=>{
        question.proofRequirement = {
            isCommentMissing: false,
            isUploadMissing: false,
            isProofMissing: false
        };
        return question;
    });
    return enhancedQuestionData;
};
const $f86acbd1c72b687f$export$fc089f4bb21eb8e6 = (answerArr)=>{
    return answerArr.map((answer)=>{
        const answerCopy = {
            ...answer
        };
        delete answerCopy['__typename'];
        return answerCopy;
    });
};
const $f86acbd1c72b687f$export$88afa644e87a15dc = (answerArr)=>{
    const answersCompleted = answerArr.filter((answer)=>answer.isComplete);
    return answersCompleted.length + 1;
};
const $f86acbd1c72b687f$export$93d8e6a03e666d10 = (answerValue, currentAnswerState)=>{
    if (currentAnswerState.includes(answerValue)) return currentAnswerState.filter((answerId)=>answerId !== answerValue);
    if (answerValue) return [
        ...currentAnswerState,
        answerValue
    ];
    return currentAnswerState;
};
const $f86acbd1c72b687f$export$32f77b04f5436dc4 = (imageKeysArr, questionId)=>{
    if (!imageKeysArr) return [];
    const regex = new RegExp(`${questionId}`);
    return imageKeysArr.filter((imageKey)=>imageKey.match(regex));
};
const $f86acbd1c72b687f$export$ce968a13e2c6e586 = (answers)=>{
    if (!answers) return null;
    return answers.every((answer)=>answer.isComplete);
};
const $f86acbd1c72b687f$export$3e14b0f9f411cc85 = (questions)=>questions.some((question)=>question.proofRequirement.isProofMissing);
const $f86acbd1c72b687f$export$19e7665dc25a3a35 = (selectedAnswer, answerOptions)=>{
    const unique = [
        ...new Set(selectedAnswer)
    ];
    if (!answerOptions?.length) return unique;
    const mainAnswerIds = answerOptions.map((opt)=>opt.answerId);
    const mainId = unique.find((id)=>mainAnswerIds.includes(id));
    if (!mainId || unique[0] === mainId) return unique;
    // Ensure main answer is first, sub-answers follow
    return [
        mainId,
        ...unique.filter((id)=>id !== mainId)
    ];
};
const $f86acbd1c72b687f$export$9fee1bbbe4aa216c = (answer, questions)=>{
    const question = questions.find((q)=>q.questionId === answer.questionId);
    return {
        ...answer,
        selectedAnswer: $f86acbd1c72b687f$export$19e7665dc25a3a35(answer.selectedAnswer, question?.answerOptions)
    };
};
const $f86acbd1c72b687f$export$e09e94e4e42c547d = (answerOptions, selectedParentId, selectedSubIds)=>{
    const selectedOption = answerOptions.find((o)=>o.answerId === selectedParentId);
    if (selectedOption?.score == null) return 0;
    if (!selectedOption.subAnswerOptions?.length) return selectedOption.score;
    const subOptionIds = new Set(selectedOption.subAnswerOptions.map((s)=>s.answerId));
    const selectedSubCount = selectedSubIds.filter((id)=>subOptionIds.has(id)).length;
    if (selectedSubCount >= (selectedOption.minimumSubAnswers ?? 0)) return selectedOption.score;
    return answerOptions.filter((o)=>o.score != null).filter((o)=>selectedSubCount >= (o.minimumSubAnswers ?? 0)).reduce((best, o)=>Math.max(best, o.score), 0);
};


const $726cdaf74220d6db$var$questionContentWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'relative',
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase,
    paddingBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
});
const $726cdaf74220d6db$var$headerWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex'
});
const $726cdaf74220d6db$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size2,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $726cdaf74220d6db$var$answerListStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    listStyle: 'none',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8,
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $726cdaf74220d6db$var$subAnswerListStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    listStyle: 'none',
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
    marginBottom: 0
});
const $726cdaf74220d6db$var$additionalFieldWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
});
const $726cdaf74220d6db$var$additionalFieldHeaderStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.regular,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05
});
const $726cdaf74220d6db$var$answerListItemIconStyle = (isSelected)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        width: 14,
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
        color: isSelected ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.success.base : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase,
        flexShrink: 0
    });
const $726cdaf74220d6db$var$answerListItemStyle = (isSelected)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size0,
        display: 'flex',
        marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size3,
        color: isSelected ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate900 : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase,
        fontWeight: isSelected ? (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium : (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.regular,
        whiteSpace: 'pre-wrap'
    });
const $726cdaf74220d6db$var$answerOptionScoreStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold,
    marginLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $726cdaf74220d6db$var$answerOptionScoreWarningStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold,
    marginLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning100,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.black
});
const $726cdaf74220d6db$var$commentStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'block',
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05,
    fontStyle: 'italic',
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate900,
    padding: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size6}px`
});
const $726cdaf74220d6db$export$bbe70a48ee7ad0f5 = ({ question: question, answer: answer, uploadImageKeys: uploadImageKeys })=>{
    const { subHeader: subHeader, conditions: conditions, answerOptions: answerOptions, explanation: explanation, furtherDetails: furtherDetails } = question;
    const mainAnswerIds = answerOptions.map((o)=>o.answerId);
    const selectedSubIds = answer.selectedAnswer.filter((id)=>!mainAnswerIds.includes(id));
    const [infoModalVisibility, setInfoModalVisibility] = (0, $denZA.useState)(false);
    const [imageModal, setImageModal] = (0, $denZA.useState)({
        isOpen: false,
        imageId: ''
    });
    const closeImageModal = ()=>{
        setImageModal((prevState)=>({
                ...prevState,
                isOpen: false
            }));
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        "data-testid": "questionReview",
        children: [
            imageModal.isOpen && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $1c1c233087ac0505$export$9e0b12df12385af6), {
                imageId: imageModal.imageId,
                closeImageModal: closeImageModal
            }),
            infoModalVisibility && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $dfe2cae5e4c44ee0$export$4994368e0bfca573), {
                header: subHeader,
                body: furtherDetails,
                closeInfoModal: ()=>setInfoModalVisibility(!infoModalVisibility)
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $726cdaf74220d6db$var$questionContentWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $726cdaf74220d6db$var$headerWrapperStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("h2", {
                            css: $726cdaf74220d6db$var$headerStyle,
                            children: [
                                subHeader,
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                    "data-testid": "questionInfoModalButton",
                                    onClick: ()=>setInfoModalVisibility(!infoModalVisibility),
                                    css: (0, $ff397d5a0eee2c82$export$eac0f7ffa478154d),
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $429b3d4e69163b2d$export$d8874184141c994a), {
                                        css: (0, $ff397d5a0eee2c82$export$d781ca6d008ff44d)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $094d9b0cf4faaefb$export$7c0a16af240a6114), {
                        explanation: explanation,
                        conditions: conditions
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("ul", {
                                css: $726cdaf74220d6db$var$answerListStyle,
                                children: answerOptions.map((answerOption)=>{
                                    const isSelected = answer.selectedAnswer.includes(answerOption.answerId);
                                    const displayScore = isSelected && answerOption.subAnswerOptions?.length > 0 ? (0, $f86acbd1c72b687f$export$e09e94e4e42c547d)(answerOptions, answerOption.answerId, selectedSubIds) : answerOption.score;
                                    const scoreWarning = isSelected && answerOption.subAnswerOptions?.length > 0 && displayScore !== answerOption.score;
                                    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("li", {
                                        css: $726cdaf74220d6db$var$answerListItemStyle(isSelected),
                                        children: [
                                            isSelected ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6892ac9a89282880$export$add807e002afa321), {
                                                css: $726cdaf74220d6db$var$answerListItemIconStyle(isSelected)
                                            }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97c13c2de352bd3a$export$b7a01a7ec68fd5c0), {
                                                css: $726cdaf74220d6db$var$answerListItemIconStyle(isSelected)
                                            }),
                                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("span", {
                                                children: [
                                                    `${answerOption.text}`,
                                                    displayScore !== null && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                                        css: scoreWarning ? $726cdaf74220d6db$var$answerOptionScoreWarningStyle : $726cdaf74220d6db$var$answerOptionScoreStyle,
                                                        children: `(${displayScore}%)`
                                                    })
                                                ]
                                            }),
                                            isSelected && answerOption.subAnswerOptions?.length > 0 && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("ul", {
                                                css: $726cdaf74220d6db$var$subAnswerListStyle,
                                                children: answerOption.subAnswerOptions.map((subOption)=>{
                                                    const isSubSelected = answer.selectedAnswer.includes(subOption.answerId);
                                                    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("li", {
                                                        css: $726cdaf74220d6db$var$answerListItemStyle(isSubSelected),
                                                        children: [
                                                            isSubSelected ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6892ac9a89282880$export$add807e002afa321), {
                                                                css: $726cdaf74220d6db$var$answerListItemIconStyle(isSubSelected)
                                                            }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97c13c2de352bd3a$export$b7a01a7ec68fd5c0), {
                                                                css: $726cdaf74220d6db$var$answerListItemIconStyle(isSubSelected)
                                                            }),
                                                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                                                children: subOption.text
                                                            })
                                                        ]
                                                    }, subOption.answerId);
                                                })
                                            })
                                        ]
                                    }, answerOption.answerId);
                                })
                            }),
                            answer.comment && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                                css: $726cdaf74220d6db$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h3", {
                                        css: $726cdaf74220d6db$var$additionalFieldHeaderStyle,
                                        children: "Additional comments:"
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("q", {
                                        css: $726cdaf74220d6db$var$commentStyle,
                                        children: answer.comment
                                    })
                                ]
                            }),
                            !!uploadImageKeys.length && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                                css: $726cdaf74220d6db$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h3", {
                                        css: $726cdaf74220d6db$var$additionalFieldHeaderStyle,
                                        children: "Attachments"
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $54d2d00c37640082$export$96b9b7524c25c919), {
                                        uploadImageKeys: uploadImageKeys,
                                        isEditable: false,
                                        imageClickHandler: (imageId)=>setImageModal((prevState)=>({
                                                    ...prevState,
                                                    imageId: imageId,
                                                    isOpen: true
                                                }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$726cdaf74220d6db$export$bbe70a48ee7ad0f5.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    answer: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string)
};




var $cvFNP = parcelRequire("cvFNP");


const $78b8667b7afe5597$var$scoreWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'flex-end'
});
const $78b8667b7afe5597$var$scoreTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
});
const $78b8667b7afe5597$var$scoreStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size3,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue80,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.ligthBlue10,
    display: 'inline',
    borderRadius: 100,
    padding: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`
});
const $78b8667b7afe5597$export$6addd58703e5f916 = ({ scoreText: scoreText, score: score })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $78b8667b7afe5597$var$scoreWrapperStyle,
        children: [
            scoreText && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: $78b8667b7afe5597$var$scoreTextStyle,
                children: scoreText
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $78b8667b7afe5597$var$scoreStyle,
                children: `${score}%`
            })
        ]
    });
$78b8667b7afe5597$export$6addd58703e5f916.propTypes = {
    scoreText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
    score: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number
    ])
};




var $cvFNP = parcelRequire("cvFNP");




var $cvFNP = parcelRequire("cvFNP");


const $28c3f81dfd8ffc2e$var$infoRowWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05
    }
});
const $28c3f81dfd8ffc2e$var$infoRowLabelStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    textAlign: 'left',
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    width: 90,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        minWidth: 210,
        textAlign: 'right',
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8
    }
});
const $28c3f81dfd8ffc2e$var$infoRowValueStyle = (bold, color)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        fontWeight: bold ? (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold : (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
        color: color ? color : 'inherit',
        width: 300,
        [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
            minWidth: 260
        }
    });
const $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3 = ({ label: label, value: value, bold: bold, color: color })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $28c3f81dfd8ffc2e$var$infoRowWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $28c3f81dfd8ffc2e$var$infoRowLabelStyle,
                children: label
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $28c3f81dfd8ffc2e$var$infoRowValueStyle(bold, color),
                children: value ? value : '-'
            })
        ]
    });
$28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).element
    ]).isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node
    ]),
    bold: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string
};





var $cvFNP = parcelRequire("cvFNP");


const $44e757b5b2fad7eb$var$dateFormatStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM2,
    verticalAlign: 'super',
    fontStyle: 'italic',
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60
});
const $44e757b5b2fad7eb$export$a6376e2c51f1d884 = ({ label: label, dateFormat: dateFormat })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("span", {
        children: [
            label,
            " ",
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                css: $44e757b5b2fad7eb$var$dateFormatStyle,
                children: ` ${dateFormat}`
            })
        ]
    });
$44e757b5b2fad7eb$export$a6376e2c51f1d884.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    dateFormat: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};






const $0fb6090404c8eff1$var$assessmentInfoContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate02,
    border: `1px solid ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate20}`,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size7,
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    flexWrap: 'wrap',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
    }
});
const $0fb6090404c8eff1$var$assessmentInfoColumnStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    flexGrow: 1
});
const $0fb6090404c8eff1$var$customerNameStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue80,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size2
});
const $0fb6090404c8eff1$var$assignmentInfoHeaderStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    width: '100%'
});
const $0fb6090404c8eff1$var$versionTagStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginLeft: 'auto'
});
const $0fb6090404c8eff1$export$bfe9facc54fa2d94 = ({ assessmentInfo: assessmentInfo })=>{
    const { contactEmails: contactEmails, version: version, assessmentDate: assessmentDate, approvalDate: approvalDate, assessmentStatus: assessmentStatus, reviewers: reviewers, approvers: approvers, pendingUser: pendingUser, performers: performers, customerDetail: { id: id, name: name, c6Id: c6Id, c6Name: c6Name, channel: channel, businessUnit: businessUnit, omni: omni }, surveyState: { score: score }, lastYearScore: previousAssessmentScore } = assessmentInfo;
    const yoyChange = previousAssessmentScore !== null && previousAssessmentScore !== undefined && (0, $d306a6c16d4d2f55$export$e71e4e95f4a82c)(assessmentStatus) ? score - previousAssessmentScore : undefined;
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $0fb6090404c8eff1$var$assessmentInfoContainerStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $0fb6090404c8eff1$var$assignmentInfoHeaderStyle,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h3", {
                            css: $0fb6090404c8eff1$var$customerNameStyle,
                            children: name
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $631fbf6cd923cd39$export$3288d34c523a1192), {
                            css: $0fb6090404c8eff1$var$versionTagStyle,
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $631fbf6cd923cd39$export$3288d34c523a1192).Label, {
                                children: [
                                    "v.",
                                    version
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $0fb6090404c8eff1$var$assessmentInfoColumnStyle,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "BU",
                            value: businessUnit
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "C6 ID",
                            value: c6Id
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "C6",
                            value: c6Name
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Customer ID",
                            value: id
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Customer Channel",
                            value: channel
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Omni",
                            value: omni
                        }),
                        contactEmails && contactEmails.length > 0 && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Emails",
                            value: contactEmails.join('\n')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $0fb6090404c8eff1$var$assessmentInfoColumnStyle,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Status",
                            value: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9cea4ea57bddd7f2$export$a17e6a3e41121fbb), {
                                status: assessmentStatus
                            })
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Score",
                            value: `${score}% ${yoyChange !== undefined ? `(YoY ${yoyChange > 0 ? '+' : ''}${yoyChange}%)` : ''}`,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Last Year Score",
                            value: `${previousAssessmentScore !== null && previousAssessmentScore !== undefined ? `${previousAssessmentScore}%` : 'Not available'}`,
                            bold: !!previousAssessmentScore
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Next Action By",
                            value: (0, $2d047b1a9208cb87$export$4d05fce67b78a97f)(pendingUser)
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Performers",
                            value: performers.join('\n')
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Reviewers",
                            value: reviewers.join('\n')
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: "Approvers",
                            value: approvers.join('\n')
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $44e757b5b2fad7eb$export$a6376e2c51f1d884), {
                                label: "Assessment Date",
                                dateFormat: "(dd.mm.yyyy)"
                            }),
                            value: assessmentDate ? (0, $bf4d1a01ebfb74e1$export$3ae94a2503e890a1)(new Date(assessmentDate)) : ''
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $28c3f81dfd8ffc2e$export$d1f74f9e6faf53d3), {
                            label: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $44e757b5b2fad7eb$export$a6376e2c51f1d884), {
                                label: "Approval Date",
                                dateFormat: "(dd.mm.yyyy)"
                            }),
                            value: approvalDate ? (0, $bf4d1a01ebfb74e1$export$3ae94a2503e890a1)(new Date(approvalDate)) : ''
                        })
                    ]
                })
            ]
        })
    });
};
$0fb6090404c8eff1$export$bfe9facc54fa2d94.propTypes = {
    assessmentInfo: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};















var $denZA = parcelRequire("denZA");



function $7b4991cbe8665793$export$7eed34e4e2038bc2({ uploadId: uploadId, skip: skip, onCompleted: onCompleted }) {
    const [imagesAreLoading, setImagesAreLoading] = (0, $denZA.useState)(false);
    const [uploadedImagesKeys, setUploadedImagesKeys] = (0, $denZA.useState)(null);
    const [imagesFetchError, setImagesFetchError] = (0, $denZA.useState)(false);
    (0, $denZA.useEffect)(()=>{
        if (!uploadId || skip) return;
        async function fetchUploadedImages() {
            let uploadedImagesFromS3 = [];
            try {
                setImagesAreLoading(true);
                uploadedImagesFromS3 = await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).list(uploadId);
                const uploadedImageKeysFromS3 = uploadedImagesFromS3.map((imageObject)=>imageObject.key);
                setUploadedImagesKeys(uploadedImageKeysFromS3);
                setImagesAreLoading(false);
                onCompleted && typeof onCompleted === 'function' && onCompleted(uploadedImageKeysFromS3);
            } catch (error) {
                setImagesAreLoading(false);
                setImagesFetchError(error);
                setUploadedImagesKeys([]);
                (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error, (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).imageUploadFetchError);
            }
        }
        fetchUploadedImages();
    }, [
        uploadId,
        skip,
        onCompleted
    ]);
    return {
        imagesAreLoading: imagesAreLoading,
        uploadedImagesKeys: uploadedImagesKeys,
        imagesFetchError: imagesFetchError
    };
}




var $denZA = parcelRequire("denZA");


var $cvFNP = parcelRequire("cvFNP");






const $01ba60bebb46830c$export$2e3e48291114b339 = ({ comments: comments, addCommentHandler: addCommentHandler })=>{
    const [isAddCommentModalVisible, setIsAddCommentModalVisible] = (0, $denZA.useState)(false);
    const [commentValue, setCommentValue] = (0, $denZA.useState)('');
    const columns = (0, $denZA.useMemo)(()=>[
            {
                Header: 'Comment',
                accessor: 'text',
                width: 1000
            },
            {
                id: 'dateAdded',
                Header: (0, $9e1e626f3963028b$export$6b714dc14f6551e3),
                headerText: 'Added',
                accessor: (row)=>new Date(row.date),
                Cell: ({ cell: { value: value } })=>(0, $bf4d1a01ebfb74e1$export$3ae94a2503e890a1)(value, {
                        includeTime: true
                    }),
                sortType: 'datetime'
            },
            {
                Header: 'User',
                accessor: 'userEmail'
            }
        ], []);
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps: getTableProps, getTableBodyProps: getTableBodyProps, headerGroups: headerGroups, rows: rows, prepareRow: prepareRow } = (0, $81513bc3741e8bd2$exports.useTable)({
        columns: columns,
        data: comments
    }, (0, $81513bc3741e8bd2$exports.useSortBy));
    const addComment = ()=>{
        setIsAddCommentModalVisible(false);
        addCommentHandler(commentValue);
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h2",
                text: "Comments"
            }),
            isAddCommentModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3a717be46ffbdf53$export$c6fdb837b070b4ff), {
                isOpen: true,
                onClick: ()=>setIsAddCommentModalVisible(false),
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772), {
                    heading: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Heading, {
                        children: "Add Comment"
                    }),
                    body: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Body, {
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec), {
                            value: commentValue,
                            onChange: (event)=>setCommentValue(event.target.value),
                            placeholder: "Write your comment here"
                        })
                    }),
                    action: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ca747c7cf976dab1$export$2b77a92f1a5ad772).Action, {
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                "aria-label": "Confirm action",
                                "data-transaction-name": "Add survey comment",
                                label: "Add",
                                onClick: addComment
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                "aria-label": "Close modal",
                                "data-transaction-name": "Cancel adding survey comment",
                                label: "Cancel",
                                variant: "outline",
                                onClick: ()=>setIsAddCommentModalVisible(false)
                            })
                        ]
                    }),
                    exitClickHandler: ()=>setIsAddCommentModalVisible(false)
                })
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("table", {
                css: (0, $5505343c4d5bfadb$export$a8a28302b48950e6),
                ...getTableProps(),
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("thead", {
                        children: headerGroups.map((headerGroup, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tr", {
                                ...headerGroup.getHeaderGroupProps(),
                                children: headerGroup.headers.map((column, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("th", {
                                        css: (0, $5505343c4d5bfadb$export$aa70f7bbadb680f2),
                                        ...column.getHeaderProps({
                                            ...column.getSortByToggleProps({
                                                title: undefined
                                            }),
                                            style: {
                                                width: column.width
                                            }
                                        }),
                                        children: column.render('Header')
                                    }, `tableheader${index}`))
                            }, `tableheadergroup${index}`))
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("tbody", {
                        ...getTableBodyProps(),
                        children: [
                            rows.map((row, i)=>{
                                prepareRow(row);
                                return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tr", {
                                    ...row.getRowProps(),
                                    children: row.cells.map((cell, index)=>{
                                        return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("td", {
                                            css: (0, $5505343c4d5bfadb$export$15c518144f297303),
                                            ...cell.getCellProps(),
                                            children: cell.render('Cell')
                                        }, `tablecell${index}`);
                                    })
                                }, `tablerow${i}`);
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("tr", {
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("td", {
                                    colSpan: 3,
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                        size: "small",
                                        variant: "ghost",
                                        label: "Add comment",
                                        iconPosition: "right",
                                        icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $2dba54b43697217b$export$2ef3672ebfdfd8df), {}),
                                        style: {
                                            width: '100%'
                                        },
                                        onClick: ()=>setIsAddCommentModalVisible(true)
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$01ba60bebb46830c$export$2e3e48291114b339.propTypes = {
    comments: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).array.isRequired,
    addCommentHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};





const $e0a384f5fee972ef$export$f68959556d5a9913 = ()=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        "data-testid": "missingProofExplainer",
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $72bcf3aff0a4f9bd$export$fd55ce593607084a), {
                header: "- Missing Attachments",
                stepId: "-1",
                isComplete: true,
                isLast: true,
                isWarning: true
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h1", {
                css: {
                    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400
                },
                children: "Some of the answers are missing attachments."
            })
        ]
    });



/**
 * Check if the user can trigger an email
 * @param {Array} roles - The roles of the user
 * @returns {Boolean}
 */ const $0a2745615fb550bd$export$7d9cc2f92b10f1f3 = (roles)=>{
    const rolesThatCanTriggerEmail = [
        'perform',
        'revenue',
        'admin'
    ];
    return roles && roles.some((role)=>rolesThatCanTriggerEmail.includes(role));
};
const $0a2745615fb550bd$export$6aede3d8913d44dd = (customerChannel)=>{
    return customerChannel && customerChannel.startsWith('LT');
};



const $f286198143a4010d$var$rejectModalCommentsStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: '5%',
    marginTop: '5%'
});
const $f286198143a4010d$var$detailsPageContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    paddingBottom: 70,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        paddingBottom: 0
    }
});
const $f286198143a4010d$var$assessmentDetailsStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: '768px',
    margin: 'auto',
    padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).small}px`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10 * 2}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).large}px`
    }
});
const $f286198143a4010d$var$sectionContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    paddingBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
});
const $f286198143a4010d$var$assessmentNotSubmittedTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size16}px 0`
});
const $f286198143a4010d$var$rejectModalactionButtonsWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    '& > button': {
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
    }
});
const $f286198143a4010d$var$rejectButtonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    button: {
        background: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.error.error500,
        '&:hover': {
            background: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.error.error600
        }
    }
});
const $f286198143a4010d$var$actionBarStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 70,
    background: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate02,
    boxShadow: '0px -2px 4px rgba(137, 150, 159, 0.2)',
    paddingLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    paddingRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12
});
const $f286198143a4010d$var$actionBarRightStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    button: {
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5
    },
    'button:last-child': {
        marginRight: 0
    },
    '&:empty': {
        display: 'none'
    }
});
const $f286198143a4010d$var$isReemeaLongTail = (channel)=>channel.startsWith('RLT');
// hide RLT channels to avoid confusion with LTs
const $f286198143a4010d$var$doesChannelTypeMatch = (currentChannel, desiredChannel)=>(0, $b01106eb8892e6c2$export$8ddf56c44523de2d)(currentChannel) === (0, $b01106eb8892e6c2$export$8ddf56c44523de2d)(desiredChannel) && !$f286198143a4010d$var$isReemeaLongTail(desiredChannel);
const $f286198143a4010d$export$ae2ad8b34c337c8c = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const { roles: roles } = (0, $b92321121d608eea$export$23bbbc4533528f03)();
    const { customerId: customerId, assessmentYear: assessmentYear, version: version } = (0, $32ee599feb5ae61e$export$99eaa27ddbbb95ef)();
    const [isApproveModalVisible, setIsApproveModalVisible] = (0, $denZA.useState)(false);
    const [isRescoreModalVisible, setIsRescoreModalVisible] = (0, $denZA.useState)(false);
    const [isRejectModalVisible, setIsRejectModalVisible] = (0, $denZA.useState)(false);
    const [rejectEmailState, setRejectEmailState] = (0, $denZA.useState)({
        isOpen: false,
        customerEmail: '',
        customerName: ''
    });
    const [rejectModalComment, setRejectModalComment] = (0, $denZA.useState)('');
    const [isDeleteModalVisible, setIsDeleteModalVisible] = (0, $denZA.useState)(false);
    const [isSoftDeleteModalVisible, setIsSoftDeleteModalVisible] = (0, $denZA.useState)(false);
    const [comments, setComments] = (0, $denZA.useState)([]);
    const [isEditChannelModalVisible, setIsEditChannelModalVisible] = (0, $denZA.useState)(false);
    const [isResendEmailModalVisible, setIsResendEmailModalVisible] = (0, $denZA.useState)(false);
    const [selectedChannel, setSelectedChannel] = (0, $denZA.useState)('');
    const [surveyDetails, setSurveyDetails] = (0, $denZA.useState)();
    const [actions, setActions] = (0, $denZA.useState)([]);
    const handleDetailsDataResponse = (response)=>{
        setComments(response.getSurveyInfo.comments);
        setSelectedChannel(response.getSurveyInfo.customerDetail.channel);
        setSurveyDetails(response.getSurveyInfo);
        setActions(response.getSurveyInfo.actions);
    };
    const [getDetailsData, { data: detailsData, loading: isDetailsPageLoading, error: detailsDataError }] = (0, $879159a57326e8fe$export$fd83eea6ecd2d8fa)((0, $3583fd120271f7a3$export$ead77c084e8e01bb), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        fetchPolicy: 'network-only',
        onCompleted: handleDetailsDataResponse
    });
    (0, $denZA.useEffect)(()=>{
        getDetailsData();
    }, [
        getDetailsData
    ]);
    const { data: availableChannels, loading: isAvailableChannelsLoading, error: getChannelsError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$e3667debca12a4b2), {
        variables: {
            year: Number(assessmentYear)
        },
        fetchPolicy: 'network-only'
    });
    const [approveAssessment, { loading: approveAssessmentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$7a9caf0d41fdd5e4), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleApproveAssessmentResponse
    });
    const [rescoreAssessment, { loading: rescoringAssessmentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$e3d65cd701b10712), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleRescoreAssessmentResponse
    });
    const [rejectAssessment, { loading: rejectAssessmentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$3494ca0ca620dcda), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleRejectAssessmentResponse
    });
    const [deleteAssessment, { loading: deleteAssessmentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$8bee2847d9a36624), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleDeleteAssessmentResponse
    });
    const [softDeleteAssessment, { loading: softDeleteAssessmentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$dfa36a32b5f79982), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleSoftDeleteAssessmentResponse
    });
    const [addAssessmentComment, { loading: addCommentLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$8356489b8b7b3ab3), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: (response)=>setComments(response.addComment)
    });
    const [updateCustomerChannel, { loading: updateChannelLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$7ea9d230be24deb6), {
        variables: {
            input: {
                customerId: customerId,
                year: Number(assessmentYear),
                version: Number(version),
                channel: selectedChannel
            }
        },
        onCompleted: handleUpdateChannelResponse
    });
    const { uploadedImagesKeys: uploadedImagesKeys } = (0, $7b4991cbe8665793$export$7eed34e4e2038bc2)({
        uploadId: detailsData?.getSurveyInfo?.uploadId,
        skip: !detailsData || !detailsData.getSurveyInfo.surveyState.isComplete
    });
    async function handleApproveAssessment(comment) {
        try {
            await approveAssessment({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    comment: comment
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    function handleApproveAssessmentResponse(response) {
        if (response.approveAssessment) {
            const { customerName: customerName } = response.approveAssessment;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: `${customerName}\u{2019}s assessment was approved.`,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    async function handleRescoreAssessment(comment) {
        try {
            await rescoreAssessment({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    comment: comment
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    function handleRescoreAssessmentResponse(response) {
        if (response.rescoreAssessment) {
            const { customerName: customerName } = response.rescoreAssessment;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: `${customerName}'s assessment rescoring has been requested.`,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    async function handleRejectAssessment(comment) {
        try {
            await rejectAssessment({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    comment: comment
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    async function handleDeleteAssessment() {
        try {
            await deleteAssessment({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    version: Number(version)
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    async function handleSoftDeleteAssessment() {
        try {
            await softDeleteAssessment({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    version: Number(version)
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    async function handleAddComment(comment) {
        try {
            await addAssessmentComment({
                variables: {
                    comment: comment
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    function handleRejectAssessmentResponse(response) {
        if (response.rejectAssessment) {
            const { customerName: customerName, customerEmail: customerEmail } = response.rejectAssessment;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: `${customerName}'s assessment has been rejected.`,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            if (detailsData.getSurveyInfo.assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).REVIEW && customerEmail) {
                const { customerName: customerName, customerEmail: customerEmail } = response.rejectAssessment;
                setIsRejectModalVisible(false);
                setRejectEmailState((prevState)=>({
                        ...prevState,
                        isOpen: true,
                        customerEmail: customerEmail,
                        customerName: customerName
                    }));
            } else history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    function handleDeleteAssessmentResponse(response) {
        if (response.deleteAssessment) {
            setIsDeleteModalVisible(false);
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: 'The assessment has been deleted.',
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    function handleSoftDeleteAssessmentResponse(response) {
        if (response.softDeleteAssessment) {
            setIsSoftDeleteModalVisible(false);
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: 'The assessment has been deleted.',
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    async function handleUpdateChannelResponse() {
        setIsEditChannelModalVisible(false);
        getDetailsData();
    }
    function handleRejectSendEmailAction() {
        const { customerName: customerName, customerEmail: customerEmail } = rejectEmailState;
        window.open(`mailto:${customerEmail}?subject=Assignment%20Rejected&body=Hi,%20${customerName}`);
        history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
    }
    async function handleSaveCustomerChannel() {
        try {
            await updateCustomerChannel();
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    // Error boundary catches this error
    if (detailsDataError) throw detailsDataError;
    if (isDetailsPageLoading || approveAssessmentLoading || rejectAssessmentLoading || rescoringAssessmentLoading || deleteAssessmentLoading || addCommentLoading || updateChannelLoading || softDeleteAssessmentLoading || !surveyDetails) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    const { getAnswers: savedAnswers, getSurvey: questions, getSurveyInfo: { surveyState: assessmentState, assessmentStatus: assessmentStatus } } = detailsData;
    const isInKAMReview = assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).REVIEW;
    const isCoreCustomer = assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).ASSESSMENT;
    const surveyDetailsForFeatureFlag = {
        year: Number(assessmentYear),
        channel: selectedChannel
    };
    let enhancedQuestions = (0, $f86acbd1c72b687f$export$3ac154c70d0babda)(questions, savedAnswers, uploadedImagesKeys);
    enhancedQuestions = (0, $f86acbd1c72b687f$export$386fc8b17cd02a9b)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $f286198143a4010d$var$detailsPageContainerStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Assessment details"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0fb6090404c8eff1$export$bfe9facc54fa2d94), {
                assessmentInfo: surveyDetails
            }),
            isEditChannelModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $dca34716ff66b16c$export$88bb0e2c98b715ef), {
                header: "Edit Customer Channel",
                onClose: ()=>setIsEditChannelModalVisible(false),
                onSave: handleSaveCustomerChannel,
                status: "error",
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    style: {
                        marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5
                    },
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                            children: "Please note that changing the customer channel could change the survey questions for the assessment and all questions already answered will be deleted."
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                            style: {
                                color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.information.information400,
                                marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
                            },
                            children: "You can only change the channel to another one of the same type (Long Tail to Long Tail and Core to Core). Please delete the assessment and upload a new one with the correct channel if you need to change the channel type."
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            style: {
                                marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
                            },
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ad3b5be9711589c5$export$ef9b1a59e592288f), {
                                value: selectedChannel,
                                onChange: (event)=>setSelectedChannel(event.target.value),
                                children: availableChannels.getAvailableChannelsForYear.filter((channel)=>$f286198143a4010d$var$doesChannelTypeMatch(selectedChannel, channel)).map((channel)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                        value: channel,
                                        children: channel
                                    }, channel))
                            })
                        })
                    ]
                })
            }),
            isDeleteModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
                header: "Customer Assessment Delete",
                body: "Are you sure you want to delete the customer assessment? All customer assessment data for this year will be deleted.",
                onClose: ()=>setIsDeleteModalVisible(false),
                onConfirm: ()=>handleDeleteAssessment(),
                status: "error",
                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d67d5c680050bc5d$export$bfadae053a633538), {})
            }),
            isSoftDeleteModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
                header: "Customer Assessment Delete",
                body: "Are you sure you want to delete the customer assessment? The assessment will be removed from the overview and if Long Tail will not be available to the customer in self-service",
                onClose: ()=>setIsSoftDeleteModalVisible(false),
                onConfirm: ()=>handleSoftDeleteAssessment(),
                status: "error",
                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d67d5c680050bc5d$export$bfadae053a633538), {})
            }),
            isApproveModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $f5148f0b2790f77f$export$5ba39ac35b23aa9f), {
                header: "Are you sure you want to approve the customer assesment?",
                onApprove: handleApproveAssessment,
                onCancel: ()=>setIsApproveModalVisible(false),
                onClose: ()=>setIsApproveModalVisible(false)
            }),
            isRejectModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $bfd14d090534ab1b$export$a16bdbbbfa22bef2), {
                header: "Are you sure you want to reject the customer assessment?",
                onClose: ()=>setIsRejectModalVisible(false),
                pageIndicator: isInKAMReview ? [
                    2,
                    1
                ] : false,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $f286198143a4010d$var$rejectModalCommentsStyle,
                        children: [
                            "Additional comments:",
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec), {
                                onChange: (event)=>setRejectModalComment(event.target.value),
                                placeholder: "Add option comments for justification"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $f286198143a4010d$var$rejectModalactionButtonsWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Cancel",
                                variant: "ghost",
                                onClick: ()=>setIsRejectModalVisible(false)
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                css: $f286198143a4010d$var$rejectButtonWrapperStyle,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                    label: "Yes, continue",
                                    "data-transaction-name": "Reject assessment",
                                    onClick: ()=>handleRejectAssessment(rejectModalComment)
                                })
                            })
                        ]
                    })
                ]
            }),
            rejectEmailState.isOpen && isInKAMReview && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $bfd14d090534ab1b$export$a16bdbbbfa22bef2), {
                header: "Send an email to customer",
                bodyText: "Send an email to customer notifying the assessment was rejected with the justification needed.",
                pageIndicator: [
                    2,
                    2
                ],
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $f286198143a4010d$var$rejectModalactionButtonsWrapperStyle,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                            label: "Back to overview",
                            onClick: ()=>history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview),
                            variant: "ghost"
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                            label: "Send an email",
                            "data-transaction-name": "Send rejection email",
                            onClick: handleRejectSendEmailAction,
                            variant: "outline"
                        })
                    ]
                })
            }),
            isRescoreModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $f5148f0b2790f77f$export$5ba39ac35b23aa9f), {
                header: "Are you sure you want to request a rescore of the customer assessment?",
                onApprove: handleRescoreAssessment,
                onCancel: ()=>setIsRescoreModalVisible(false),
                onClose: ()=>setIsRescoreModalVisible(false)
            }),
            isResendEmailModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $5f2ae4d0ed2682a3$export$269165b71d322095), {
                customerId: surveyDetails.customerDetail.id,
                onClose: ()=>setIsResendEmailModalVisible(false)
            }),
            (0, $f86acbd1c72b687f$export$ce968a13e2c6e586)(savedAnswers) ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $denZA.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $f286198143a4010d$var$assessmentDetailsStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3463068a6fe77df4$export$ed8ca599049e8881), {
                            activeColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60,
                            children: enhancedQuestions.map((question)=>{
                                const { questionId: questionId, headline: headline, savedAnswer: savedAnswer, questionImageKeys: questionImageKeys, proofRequirement: proofRequirement } = question;
                                return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $72bcf3aff0a4f9bd$export$fd55ce593607084a), {
                                    stepId: questionId,
                                    header: headline,
                                    isValid: savedAnswer.isValid,
                                    isWarning: proofRequirement.isProofMissing,
                                    isComplete: savedAnswer.isComplete,
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $726cdaf74220d6db$export$bbe70a48ee7ad0f5), {
                                        question: question,
                                        answer: savedAnswer,
                                        uploadImageKeys: questionImageKeys
                                    })
                                }, questionId);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b0459eaa6dae80b0$export$2e0a83ec2e27ecbb), {}),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $f286198143a4010d$var$sectionContainerStyle,
                        children: [
                            (0, $f86acbd1c72b687f$export$3e14b0f9f411cc85)(enhancedQuestions) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e0a384f5fee972ef$export$f68959556d5a9913), {}),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                                type: "h2",
                                text: "Score"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $78b8667b7afe5597$export$6addd58703e5f916), {
                                scoreText: "The calculated functional discount score is:",
                                score: assessmentState.score
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $01ba60bebb46830c$export$2e3e48291114b339), {
                                comments: comments,
                                addCommentHandler: (commentValue)=>handleAddComment(commentValue)
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $f286198143a4010d$var$assessmentNotSubmittedTextStyle,
                children: "The assessment has not been filled in yet."
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $f286198143a4010d$var$actionBarStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a), {
                            to: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview,
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Back to overview",
                                variant: "ghost"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("span", {
                        css: $f286198143a4010d$var$actionBarRightStyle,
                        children: [
                            surveyDetails?.active && (0, $0a2745615fb550bd$export$6aede3d8913d44dd)(surveyDetails?.customerDetail.channel) && (0, $0a2745615fb550bd$export$7d9cc2f92b10f1f3)(roles) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Resend Invitation",
                                "data-transaction-name": "Resend Invitation",
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e6ec74cde0a35f8f$export$65259f2909ebaca1), {}),
                                variant: "ghost",
                                onClick: ()=>setIsResendEmailModalVisible(true)
                            }),
                            !isAvailableChannelsLoading && !getChannelsError && actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).CHANNELUPDATE) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Change Channel",
                                "data-transaction-name": "Change Channel",
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $2c6ad45b0a3c9054$export$4c6ac753363de59f), {}),
                                variant: "ghost",
                                onClick: ()=>setIsEditChannelModalVisible(true)
                            }),
                            actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).SOFTDELETE) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Delete Assessment",
                                "data-transaction-name": "Soft delete assessment",
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d67d5c680050bc5d$export$bfadae053a633538), {}),
                                variant: "ghost",
                                onClick: ()=>setIsSoftDeleteModalVisible(true)
                            }),
                            actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).DELETE) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Delete Assessment",
                                "data-transaction-name": "Hard delete assessment",
                                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d67d5c680050bc5d$export$bfadae053a633538), {}),
                                variant: "ghost",
                                onClick: ()=>setIsDeleteModalVisible(true)
                            }),
                            (assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).ASSESSMENT || assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).SELF_ASSESSMENT || assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).RE_ASSESSMENT) && actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).PERFORM) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a), {
                                to: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoring(customerId, assessmentYear, version),
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                    label: isCoreCustomer ? 'Fill in assessment' : 'Fill in on behalf of customer',
                                    "data-transaction-name": isCoreCustomer ? 'Fill in assessment' : 'Fill in on behalf of customer',
                                    variant: isCoreCustomer ? '' : 'outline'
                                })
                            }),
                            assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).COMPLETED && actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).RESCORE) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Open rescoring",
                                "data-transaction-name": "Open rescoring",
                                variant: "outline",
                                onClick: ()=>setIsRescoreModalVisible(true)
                            }),
                            assessmentState.isComplete && actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).REJECT) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: (0, $ba993d96472d712a$export$a2757698bfab8d96)[(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).REJECT],
                                variant: "outline",
                                "data-transaction-name": "Reject assessment",
                                onClick: ()=>setIsRejectModalVisible((prevState)=>!prevState)
                            }),
                            assessmentState.isComplete && actions.includes((0, $045e393ea48844a5$export$1fa6c04dd35d59ff).APPROVE) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: (0, $ba993d96472d712a$export$a2757698bfab8d96)[(0, $045e393ea48844a5$export$1fa6c04dd35d59ff).APPROVE],
                                "data-transaction-name": "Approve assessment",
                                onClick: ()=>setIsApproveModalVisible((prevState)=>!prevState)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $denZA = parcelRequire("denZA");













var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");









var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");




var $denZA = parcelRequire("denZA");


const $e906eff0f880d44d$export$7ba7e16fa5af7c45 = /*#__PURE__*/ (0, $denZA.createContext)();
const $e906eff0f880d44d$export$663c2b064fc3c91e = /*#__PURE__*/ (0, $denZA.createContext)();
const $e906eff0f880d44d$export$665446046e211b61 = 'UPDATE_ANSWER';
const $e906eff0f880d44d$export$424409e47882d57e = 'UPDATE_SUB_ANSWER';
const $e906eff0f880d44d$export$e4c3b88d3098e3ee = 'UPDATE_COMMENT';
const $e906eff0f880d44d$export$bffc53fdec94e058 = 'STEP_BACK';
const $e906eff0f880d44d$export$c8fc4598c519ec37 = 'UPDATE_VALIDATION';
const $e906eff0f880d44d$export$4a991c87e640ef77 = 'RESET';
const $e906eff0f880d44d$export$f22e29cd098f571f = 'ANSWER_SAVED';
const $e906eff0f880d44d$export$855a5c0ee315c6e1 = 'SET_UPLOADED_IMAGES';
const $e906eff0f880d44d$export$9e9067a66918a482 = 'ADD_UPLOADED_IMAGE';
const $e906eff0f880d44d$export$992126a0fde689ec = 'DELETE_UPLOADED_IMAGE';
function $e906eff0f880d44d$export$62084e9522e5cab(state, action) {
    switch(action.type){
        case $e906eff0f880d44d$export$665446046e211b61:
            {
                const { questionId: questionId, questionType: questionType, value: value } = action.payload;
                const isMultiSelect = questionType === (0, $be4e7f9ce17f6c5f$export$e50882b81c62e311).NON_BINARY_MULTI_CHOICE;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        if (isMultiSelect) return {
                            ...answer,
                            isValid: (0, $f86acbd1c72b687f$export$1495774a44129127)(true, value),
                            selectedAnswer: (0, $f86acbd1c72b687f$export$93d8e6a03e666d10)(value, answer.selectedAnswer)
                        };
                        // For single choice: find which saved ID is the current main answer
                        // by cross-referencing against the question's answerOptions
                        const question = state.questions?.find((q)=>q.questionId === questionId);
                        const mainAnswerIds = question?.answerOptions?.map((opt)=>opt.answerId) ?? [];
                        const currentMainAnswerId = answer.selectedAnswer.find((id)=>mainAnswerIds.includes(id));
                        const isSameMainAnswer = currentMainAnswerId === value;
                        return {
                            ...answer,
                            isValid: (0, $f86acbd1c72b687f$export$1495774a44129127)(false, value),
                            // Preserve sub-answers when re-selecting the same main answer;
                            // clear them when switching to a different main answer
                            selectedAnswer: isSameMainAnswer ? answer.selectedAnswer : [
                                value
                            ]
                        };
                    })
                };
            }
        case $e906eff0f880d44d$export$424409e47882d57e:
            {
                const { questionId: questionId, subAnswerId: subAnswerId } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        const updated = answer.selectedAnswer.includes(subAnswerId) ? answer.selectedAnswer.filter((id)=>id !== subAnswerId) : [
                            ...answer.selectedAnswer,
                            subAnswerId
                        ];
                        return {
                            ...answer,
                            selectedAnswer: updated
                        };
                    })
                };
            }
        case $e906eff0f880d44d$export$e4c3b88d3098e3ee:
            {
                const { questionId: questionId, value: value } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        return {
                            ...answer,
                            comment: value
                        };
                    })
                };
            }
        case $e906eff0f880d44d$export$855a5c0ee315c6e1:
            {
                const { uploadedImages: uploadedImages } = action.payload;
                return {
                    ...state,
                    isFetchingUploadedImages: false,
                    uploadedImageKeys: uploadedImages
                };
            }
        case $e906eff0f880d44d$export$9e9067a66918a482:
            {
                const { imageKey: imageKey } = action.payload;
                return {
                    ...state,
                    uploadedImageKeys: [
                        ...state.uploadedImageKeys,
                        imageKey
                    ]
                };
            }
        case $e906eff0f880d44d$export$992126a0fde689ec:
            {
                const { imageKey: imageKey } = action.payload;
                return {
                    ...state,
                    uploadedImageKeys: state.uploadedImageKeys.filter((imageKeyFromState)=>imageKeyFromState !== imageKey)
                };
            }
        case $e906eff0f880d44d$export$bffc53fdec94e058:
            return {
                ...state,
                activeStep: state.activeStep - 1
            };
        case $e906eff0f880d44d$export$c8fc4598c519ec37:
            {
                const { questionId: questionId } = action.payload;
                return {
                    ...state,
                    answers: state.answers.map((answer)=>{
                        if (answer.questionId !== questionId) return answer;
                        return {
                            ...answer,
                            isValid: !answer.isValid
                        };
                    })
                };
            }
        case $e906eff0f880d44d$export$f22e29cd098f571f:
            {
                const { questionId: questionId } = action.payload;
                const updatedAnswersArray = state.answers.map((answer)=>{
                    if (answer.questionId !== questionId) return answer;
                    return {
                        ...answer,
                        isComplete: true
                    };
                });
                return {
                    ...state,
                    activeStep: state.activeStep + 1,
                    answers: updatedAnswersArray
                };
            }
        case $e906eff0f880d44d$export$4a991c87e640ef77:
            {
                const { surveyPageData: { getAnswers: getAnswers, getSurvey: getSurvey, getSurveyInfo: getSurveyInfo } } = action.payload;
                return {
                    activeStep: (0, $f86acbd1c72b687f$export$88afa644e87a15dc)(getAnswers),
                    isFetchingUploadedImages: false,
                    questions: getSurvey,
                    isSurveyComplete: getAnswers.every((answer)=>answer.isComplete),
                    isSurveyEditable: getSurveyInfo.surveyState.isEditable,
                    // Get rid of __typename property as it causes
                    // trouble when using the answer object for a mutation
                    answers: (0, $f86acbd1c72b687f$export$fc089f4bb21eb8e6)(getAnswers),
                    uploadedImageKeys: [],
                    assessmentStatus: getSurveyInfo.assessmentStatus,
                    surveyInfo: getSurveyInfo
                };
            }
        default:
            return state;
    }
}
function $e906eff0f880d44d$export$a5aa18497ac2449(questionId, questionType, value) {
    return {
        type: $e906eff0f880d44d$export$665446046e211b61,
        payload: {
            questionId: questionId,
            questionType: questionType,
            value: value
        }
    };
}
function $e906eff0f880d44d$export$5258cffe7b5660f2(questionId, subAnswerId) {
    return {
        type: $e906eff0f880d44d$export$424409e47882d57e,
        payload: {
            questionId: questionId,
            subAnswerId: subAnswerId
        }
    };
}
function $e906eff0f880d44d$export$b9fe65f7083ae815(questionId, value) {
    return {
        type: $e906eff0f880d44d$export$e4c3b88d3098e3ee,
        payload: {
            questionId: questionId,
            value: value
        }
    };
}
function $e906eff0f880d44d$export$9b541d9f1fcb7ba1() {
    return {
        type: $e906eff0f880d44d$export$bffc53fdec94e058
    };
}
function $e906eff0f880d44d$export$5c6e90ccb78f1afd(questionId) {
    return {
        type: $e906eff0f880d44d$export$c8fc4598c519ec37,
        payload: {
            questionId: questionId
        }
    };
}
function $e906eff0f880d44d$export$2e78289a93d130a3(surveyPageData, assessmentYear) {
    return {
        type: $e906eff0f880d44d$export$4a991c87e640ef77,
        payload: {
            surveyPageData: surveyPageData,
            assessmentYear: assessmentYear
        }
    };
}
function $e906eff0f880d44d$export$3e8f578fc1f6d087(questionId) {
    return {
        type: $e906eff0f880d44d$export$f22e29cd098f571f,
        payload: {
            questionId: questionId
        }
    };
}
function $e906eff0f880d44d$export$5a9723c1c1c2936c(uploadedImages) {
    return {
        type: $e906eff0f880d44d$export$855a5c0ee315c6e1,
        payload: {
            uploadedImages: uploadedImages
        }
    };
}
function $e906eff0f880d44d$export$584b5172b1334e18(imageKey) {
    return {
        type: $e906eff0f880d44d$export$9e9067a66918a482,
        payload: {
            imageKey: imageKey
        }
    };
}
function $e906eff0f880d44d$export$bbf1ccc913d6ed12(imageKey) {
    return {
        type: $e906eff0f880d44d$export$992126a0fde689ec,
        payload: {
            imageKey: imageKey
        }
    };
}




var $cvFNP = parcelRequire("cvFNP");


const $506b6ea46c19c3ff$var$answerLabelWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'baseline'
});
const $506b6ea46c19c3ff$var$answerLabelTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05,
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2,
    whiteSpace: 'pre-wrap'
});
const $506b6ea46c19c3ff$var$answerLabelScoreStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    fontStyle: 'italic'
});
const $506b6ea46c19c3ff$var$answerLabelScoreWarningStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.bold,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    fontStyle: 'italic',
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning100,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.black
});
const $506b6ea46c19c3ff$export$1be1c2a12d0f6cf8 = ({ labelText: labelText, score: score, scoreWarning: scoreWarning })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $506b6ea46c19c3ff$var$answerLabelWrapperStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                    css: $506b6ea46c19c3ff$var$answerLabelTextStyle,
                    children: labelText
                }),
                typeof score === 'number' && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                    css: scoreWarning ? $506b6ea46c19c3ff$var$answerLabelScoreWarningStyle : $506b6ea46c19c3ff$var$answerLabelScoreStyle,
                    children: `(${score}%)`
                })
            ]
        })
    });
$506b6ea46c19c3ff$export$1be1c2a12d0f6cf8.propTypes = {
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    score: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    scoreWarning: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};


const $88d7a13c158ad01d$var$multiChoiceWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8
});
const $88d7a13c158ad01d$export$70859b46811b52c1 = ({ question: question, questionState: questionState })=>{
    const { dispatch: dispatch } = (0, $denZA.useContext)((0, $e906eff0f880d44d$export$7ba7e16fa5af7c45));
    const { questionId: questionId, questionType: questionType, answerOptions: answerOptions } = question;
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: answerOptions.map((answer, index)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $88d7a13c158ad01d$var$multiChoiceWrapperStyle,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $58724900fb07117e$export$48513f6b9f8ce62d), {
                    checked: questionState.selectedAnswer.includes(answer.answerId),
                    onChange: (event)=>dispatch((0, $e906eff0f880d44d$export$a5aa18497ac2449)(questionId, questionType, event.target.value)),
                    label: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $506b6ea46c19c3ff$export$1be1c2a12d0f6cf8), {
                        labelText: answer.text,
                        score: answer.score
                    }),
                    value: answer.answerId
                })
            }, index))
    });
};
$88d7a13c158ad01d$export$70859b46811b52c1.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};




var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");






const $7af3f689f0c7deed$var$subAnswerWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginLeft: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8
});
const $7af3f689f0c7deed$var$subAnswerHeaderStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size05,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.regular,
    whiteSpace: 'pre-wrap',
    marginTop: 0,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginLeft: 0,
    color: 'inherit'
});
const $7af3f689f0c7deed$var$subAnswerItemStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
});
const $7af3f689f0c7deed$var$subAnswerWarningStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning100,
    padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2}px`,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginLeft: 0,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.black
});
const $7af3f689f0c7deed$export$518ee1f8a60ca514 = ({ question: question, questionState: questionState })=>{
    const { dispatch: dispatch } = (0, $denZA.useContext)((0, $e906eff0f880d44d$export$7ba7e16fa5af7c45));
    const { questionId: questionId, questionType: questionType, answerOptions: answerOptions } = question;
    const mainAnswerIds = answerOptions.map((o)=>o.answerId);
    const selectedSubIds = questionState.selectedAnswer.filter((id)=>!mainAnswerIds.includes(id));
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: answerOptions.map((answer)=>{
            const isSelected = questionState.selectedAnswer.includes(answer.answerId);
            const displayScore = isSelected && answer.subAnswerOptions?.length > 0 ? (0, $f86acbd1c72b687f$export$e09e94e4e42c547d)(answerOptions, answer.answerId, selectedSubIds) : answer.score;
            // Score is reduced when computeScore returns less than the answer's full score.
            const scoreWarning = isSelected && answer.subAnswerOptions?.length > 0 && displayScore !== answer.score;
            return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0b5f6e5af89b2bbe$export$d7b12c4107be0d61), {
                        name: questionId,
                        onChange: (event)=>dispatch((0, $e906eff0f880d44d$export$a5aa18497ac2449)(questionId, questionType, event.target.value)),
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0b5f6e5af89b2bbe$export$d7b12c4107be0d61).Button, {
                            checked: isSelected ? 'checked' : false,
                            label: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $506b6ea46c19c3ff$export$1be1c2a12d0f6cf8), {
                                labelText: answer.text,
                                score: displayScore,
                                scoreWarning: scoreWarning
                            }),
                            value: answer.answerId
                        })
                    }),
                    isSelected && answer.subAnswerOptions?.length > 0 && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $7af3f689f0c7deed$var$subAnswerWrapperStyle,
                        children: [
                            answer.subAnswerHeader && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: $7af3f689f0c7deed$var$subAnswerHeaderStyle,
                                children: answer.subAnswerHeader
                            }),
                            scoreWarning && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: $7af3f689f0c7deed$var$subAnswerWarningStyle,
                                children: "Discounts reduced due to minimum options not selected"
                            }),
                            answer.subAnswerOptions.map((subOption)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                    css: $7af3f689f0c7deed$var$subAnswerItemStyle,
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $58724900fb07117e$export$48513f6b9f8ce62d), {
                                        checked: questionState.selectedAnswer.includes(subOption.answerId),
                                        onChange: ()=>dispatch((0, $e906eff0f880d44d$export$5258cffe7b5660f2)(questionId, subOption.answerId)),
                                        label: subOption.text,
                                        value: subOption.answerId
                                    })
                                }, subOption.answerId))
                        ]
                    })
                ]
            }, answer.answerId);
        })
    });
};
$7af3f689f0c7deed$export$518ee1f8a60ca514.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired
};





var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");




var $cvFNP = parcelRequire("cvFNP");

var $denZA = parcelRequire("denZA");

var $cvFNP = parcelRequire("cvFNP");

var $5124ac16bad18061$export$db0345794bfc14ed = new Map([
    [
        'avi',
        'video/avi'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
]);
function $5124ac16bad18061$export$8cc09085015f0dc7(file, path) {
    var f = $5124ac16bad18061$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $5124ac16bad18061$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $5124ac16bad18061$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $647e91f650f101e1$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $647e91f650f101e1$export$a36e16046ae8f1bb(evt) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                $647e91f650f101e1$var$isDragEvt(evt) && evt.dataTransfer ? $647e91f650f101e1$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $647e91f650f101e1$var$getInputFiles(evt)
            ];
        });
    });
}
function $647e91f650f101e1$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $647e91f650f101e1$var$getInputFiles(evt) {
    var files = $647e91f650f101e1$var$isInput(evt.target) ? evt.target.files ? $647e91f650f101e1$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $5124ac16bad18061$export$8cc09085015f0dc7)(file);
    });
}
function $647e91f650f101e1$var$isInput(value) {
    return value !== null;
}
function $647e91f650f101e1$var$getDataTransferFiles(dt, type) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $647e91f650f101e1$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($647e91f650f101e1$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $647e91f650f101e1$var$noIgnoredFiles($647e91f650f101e1$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $647e91f650f101e1$var$noIgnoredFiles($647e91f650f101e1$var$fromList(dt.files).map(function(file) {
                            return (0, $5124ac16bad18061$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $647e91f650f101e1$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $647e91f650f101e1$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $647e91f650f101e1$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $647e91f650f101e1$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $647e91f650f101e1$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $647e91f650f101e1$var$fromDirEntry(entry);
    return $647e91f650f101e1$var$fromDataTransferItem(item);
}
function $647e91f650f101e1$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $96998cfc8b9d4854$export$afc72e2116322959)(acc, Array.isArray(files) ? $647e91f650f101e1$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $647e91f650f101e1$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $5124ac16bad18061$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $647e91f650f101e1$var$fromEntry(entry) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $647e91f650f101e1$var$fromDirEntry(entry) : $647e91f650f101e1$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $647e91f650f101e1$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($647e91f650f101e1$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $647e91f650f101e1$var$fromFileEntry(entry) {
    return (0, $96998cfc8b9d4854$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $96998cfc8b9d4854$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $5124ac16bad18061$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $d82f99824012940c$export$1e511d4a378977f5;
var $d82f99824012940c$export$2e2bcd8739ae039;
"use strict";
$d82f99824012940c$export$1e511d4a378977f5 = true;
$d82f99824012940c$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $d107b01830c4fda5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d107b01830c4fda5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d107b01830c4fda5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d107b01830c4fda5$var$_typeof(obj);
}
function $d107b01830c4fda5$var$_slicedToArray(arr, i) {
    return $d107b01830c4fda5$var$_arrayWithHoles(arr) || $d107b01830c4fda5$var$_iterableToArrayLimit(arr, i) || $d107b01830c4fda5$var$_unsupportedIterableToArray(arr, i) || $d107b01830c4fda5$var$_nonIterableRest();
}
function $d107b01830c4fda5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d107b01830c4fda5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d107b01830c4fda5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d107b01830c4fda5$var$_arrayLikeToArray(o, minLen);
}
function $d107b01830c4fda5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d107b01830c4fda5$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d107b01830c4fda5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d107b01830c4fda5$export$d2c35cc369247232 = 'file-invalid-type';
var $d107b01830c4fda5$export$d7bd1185abe1e87c = 'file-too-large';
var $d107b01830c4fda5$export$8bd5ec6ed990dc9 = 'file-too-small';
var $d107b01830c4fda5$export$3271ef1d2dd155f9 = 'too-many-files'; // File Errors
var $d107b01830c4fda5$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
    return {
        code: $d107b01830c4fda5$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $d107b01830c4fda5$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $d107b01830c4fda5$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " bytes")
    };
};
var $d107b01830c4fda5$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $d107b01830c4fda5$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " bytes")
    };
};
var $d107b01830c4fda5$export$1e1e1b6120329fe = {
    code: $d107b01830c4fda5$export$3271ef1d2dd155f9,
    message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $d107b01830c4fda5$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === 'application/x-moz-file' || (0, $d82f99824012940c$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $d107b01830c4fda5$export$bc0bbda045f09b5a(accept)
    ];
}
function $d107b01830c4fda5$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($d107b01830c4fda5$var$isDefined(file.size)) {
        if ($d107b01830c4fda5$var$isDefined(minSize) && $d107b01830c4fda5$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $d107b01830c4fda5$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $d107b01830c4fda5$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($d107b01830c4fda5$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $d107b01830c4fda5$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($d107b01830c4fda5$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $d107b01830c4fda5$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $d107b01830c4fda5$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $d107b01830c4fda5$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $d107b01830c4fda5$export$b511db3632effe58(file, accept), _fileAccepted2 = $d107b01830c4fda5$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $d107b01830c4fda5$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $d107b01830c4fda5$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $d107b01830c4fda5$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === 'function') return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== 'undefined') return event.cancelBubble;
    return false;
}
function $d107b01830c4fda5$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === 'Files' || type === 'application/x-moz-file';
    });
}
function $d107b01830c4fda5$export$f9006bf02b243736(item) {
    return $d107b01830c4fda5$var$_typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target
function $d107b01830c4fda5$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $d107b01830c4fda5$var$isIe(userAgent) {
    return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}
function $d107b01830c4fda5$var$isEdge(userAgent) {
    return userAgent.indexOf('Edge/') !== -1;
}
function $d107b01830c4fda5$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $d107b01830c4fda5$var$isIe(userAgent) || $d107b01830c4fda5$var$isEdge(userAgent);
}
function $d107b01830c4fda5$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$d107b01830c4fda5$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $d107b01830c4fda5$export$8d6d6472146de265(event);
        });
    };
}


function $15a44f288c6418f6$var$_toConsumableArray(arr) {
    return $15a44f288c6418f6$var$_arrayWithoutHoles(arr) || $15a44f288c6418f6$var$_iterableToArray(arr) || $15a44f288c6418f6$var$_unsupportedIterableToArray(arr) || $15a44f288c6418f6$var$_nonIterableSpread();
}
function $15a44f288c6418f6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $15a44f288c6418f6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $15a44f288c6418f6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $15a44f288c6418f6$var$_arrayLikeToArray(arr);
}
function $15a44f288c6418f6$var$_slicedToArray(arr, i) {
    return $15a44f288c6418f6$var$_arrayWithHoles(arr) || $15a44f288c6418f6$var$_iterableToArrayLimit(arr, i) || $15a44f288c6418f6$var$_unsupportedIterableToArray(arr, i) || $15a44f288c6418f6$var$_nonIterableRest();
}
function $15a44f288c6418f6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $15a44f288c6418f6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $15a44f288c6418f6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $15a44f288c6418f6$var$_arrayLikeToArray(o, minLen);
}
function $15a44f288c6418f6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $15a44f288c6418f6$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $15a44f288c6418f6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $15a44f288c6418f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $15a44f288c6418f6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $15a44f288c6418f6$var$ownKeys(Object(source), true).forEach(function(key) {
            $15a44f288c6418f6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $15a44f288c6418f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $15a44f288c6418f6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $15a44f288c6418f6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $15a44f288c6418f6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $15a44f288c6418f6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $15a44f288c6418f6$var$Dropzone = /*#__PURE__*/ (0, $denZA.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $15a44f288c6418f6$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _useDropzone = $15a44f288c6418f6$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $15a44f288c6418f6$var$_objectWithoutProperties(_useDropzone, [
        "open"
    ]);
    (0, $denZA.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement((0, $denZA.Fragment), null, children($15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$15a44f288c6418f6$var$Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen
var $15a44f288c6418f6$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $647e91f650f101e1$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false
};
$15a44f288c6418f6$var$Dropzone.defaultProps = $15a44f288c6418f6$var$defaultProps;
$15a44f288c6418f6$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func
};
var $15a44f288c6418f6$export$2e2bcd8739ae039 = $15a44f288c6418f6$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $15a44f288c6418f6$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $15a44f288c6418f6$export$cd49c0ecc5be9f36() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$options = $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, $15a44f288c6418f6$var$defaultProps), options), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling;
    var rootRef = (0, $denZA.useRef)(null);
    var inputRef = (0, $denZA.useRef)(null);
    var _useReducer = (0, $denZA.useReducer)($15a44f288c6418f6$var$reducer, $15a44f288c6418f6$var$initialState), _useReducer2 = $15a44f288c6418f6$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $denZA.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: 'openDialog'
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: 'closeDialog'
                    });
                    if (typeof onFileDialogCancel === 'function') onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $denZA.useEffect)(function() {
        window.addEventListener('focus', onWindowFocus, false);
        return function() {
            window.removeEventListener('focus', onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $denZA.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $denZA.useCallback)(function() {
        dispatch({
            type: 'focus'
        });
    }, []);
    var onBlurCb = (0, $denZA.useCallback)(function() {
        dispatch({
            type: 'blur'
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $denZA.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $d107b01830c4fda5$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $denZA.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $denZA.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener('dragover', (0, $d107b01830c4fda5$export$2ead263d6635cecc), false);
            document.addEventListener('drop', onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener('dragover', (0, $d107b01830c4fda5$export$2ead263d6635cecc));
                document.removeEventListener('drop', onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $denZA.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($15a44f288c6418f6$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $d107b01830c4fda5$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $d107b01830c4fda5$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: 'setDraggedFiles'
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $denZA.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        if (event.dataTransfer) try {
            event.dataTransfer.dropEffect = 'copy';
        } catch (_unused) {}
        if ((0, $d107b01830c4fda5$export$52f1fc875a1e5986)(event) && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $denZA.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: 'setDraggedFiles',
            draggedFiles: []
        });
        if ((0, $d107b01830c4fda5$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $denZA.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $d107b01830c4fda5$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $d107b01830c4fda5$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var fileRejections = [];
            files.forEach(function(file) {
                var _fileAccepted = (0, $d107b01830c4fda5$export$b511db3632effe58)(file, accept), _fileAccepted2 = $15a44f288c6418f6$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
                var _fileMatchSize = (0, $d107b01830c4fda5$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $15a44f288c6418f6$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
                if (accepted && sizeMatch) acceptedFiles.push(file);
                else {
                    var errors = [
                        acceptError,
                        sizeError
                    ].filter(function(e) {
                        return e;
                    });
                    fileRejections.push({
                        file: file,
                        errors: errors
                    });
                }
            });
            if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
                // Reject everything and empty accepted files
                acceptedFiles.forEach(function(file) {
                    fileRejections.push({
                        file: file,
                        errors: [
                            (0, $d107b01830c4fda5$export$1e1e1b6120329fe)
                        ]
                    });
                });
                acceptedFiles.splice(0);
            }
            dispatch({
                acceptedFiles: acceptedFiles,
                fileRejections: fileRejections,
                type: 'setFiles'
            });
            if (onDrop) onDrop(acceptedFiles, fileRejections, event);
            if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: 'reset'
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        maxFiles,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $denZA.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $15a44f288c6418f6$var$_objectWithoutProperties(_ref2, [
                "refKey",
                "onKeyDown",
                "onFocus",
                "onBlur",
                "onClick",
                "onDragEnter",
                "onDragOver",
                "onDragLeave",
                "onDrop"
            ]);
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $denZA.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $denZA.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $15a44f288c6418f6$var$_objectWithoutProperties(_ref3, [
                "refKey",
                "onChange",
                "onClick"
            ]);
            var inputProps = $15a44f288c6418f6$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: 'file',
                style: {
                    display: 'none'
                },
                onChange: composeHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $d107b01830c4fda5$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                autoComplete: 'off',
                tabIndex: -1
            }, refKey, inputRef);
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $d107b01830c4fda5$export$6a0bb4322c81a197)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple,
        maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $15a44f288c6418f6$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case 'focus':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case 'blur':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case 'openDialog':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                isFileDialogActive: true
            });
        case 'closeDialog':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case 'setDraggedFiles':
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case 'setFiles':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case 'reset':
            return $15a44f288c6418f6$var$_objectSpread($15a44f288c6418f6$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false,
                isDragActive: false,
                draggedFiles: [],
                acceptedFiles: [],
                fileRejections: []
            });
        default:
            return state;
    }
}





const { neutralColors: { white: $4620758787a8f8d2$var$white, slate02: $4620758787a8f8d2$var$slate02, slate20: $4620758787a8f8d2$var$slate20, slate40: $4620758787a8f8d2$var$slate40, slate50: $4620758787a8f8d2$var$slate50, slate60: $4620758787a8f8d2$var$slate60 }, boldColors: { lightBlue: { ligthBlue20: $4620758787a8f8d2$var$ligthBlue20 } }, utilityColors: { information: $4620758787a8f8d2$var$information, success: $4620758787a8f8d2$var$success, error: $4620758787a8f8d2$var$error } } = (0, $a8152c9d3f9ec984$export$8f45430ccf837300);
const $4620758787a8f8d2$var$getColor = (isDisabled, isDragAccept, isDragActive, isDragReject)=>{
    if (isDragAccept) return $4620758787a8f8d2$var$success.base;
    if (isDragReject) return $4620758787a8f8d2$var$error.error500;
    if (isDragActive) return $4620758787a8f8d2$var$information.base;
    if (isDisabled) return $4620758787a8f8d2$var$slate20;
    return $4620758787a8f8d2$var$slate60;
};
const $4620758787a8f8d2$var$DropzoneContainerStyle = (isDisabled, isDragAccept, isDragActive, isDragReject)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        padding: 20,
        borderWidth: 2,
        borderRadius: 4,
        borderColor: $4620758787a8f8d2$var$getColor(isDisabled, isDragAccept, isDragActive, isDragReject),
        borderStyle: 'dashed',
        backgroundColor: isDisabled ? $4620758787a8f8d2$var$slate02 : $4620758787a8f8d2$var$white,
        color: isDisabled ? $4620758787a8f8d2$var$slate40 : $4620758787a8f8d2$var$slate60,
        outline: 'none',
        transition: 'border 0.24s ease-in-out',
        height: 120,
        position: 'relative'
    });
const $4620758787a8f8d2$var$UploadIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    zIndex: 1,
    color: $4620758787a8f8d2$var$slate50
});
const $4620758787a8f8d2$var$UploadTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
    color: $4620758787a8f8d2$var$slate50,
    zIndex: 1
});
const $4620758787a8f8d2$var$UploadProgressbarStyle = (uploadProgress)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: $4620758787a8f8d2$var$ligthBlue20,
        width: `${uploadProgress}%`
    });
const $4620758787a8f8d2$export$47d4850b9fdf5af1 = ({ acceptedFiles: acceptedFiles, uploadProgress: uploadProgress, onDrop: onDrop, isDisabled: isDisabled, isMultipleFilesAllowed: isMultipleFilesAllowed = false, onDropRejected: onDropRejected })=>{
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive, isDragAccept: isDragAccept, isDragReject: isDragReject } = (0, $15a44f288c6418f6$export$cd49c0ecc5be9f36)({
        accept: acceptedFiles,
        disabled: isDisabled,
        onDrop: onDrop,
        multiple: isMultipleFilesAllowed,
        maxSize: 10000000,
        onDropRejected: onDropRejected
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("section", {
        className: "container",
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            "aria-label": "upload-drag-and-drop-area",
            css: $4620758787a8f8d2$var$DropzoneContainerStyle(isDisabled, isDragAccept, isDragActive, isDragReject),
            ...getRootProps({}),
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("input", {
                    "data-transaction-name": "Upload Image",
                    ...getInputProps()
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c8d44437ef5094ba$export$613a29ed35edc9c6), {
                    css: $4620758787a8f8d2$var$UploadIconStyle
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                    css: $4620758787a8f8d2$var$UploadTextStyle,
                    children: uploadProgress ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                        children: "Uploading file, please wait ..."
                    }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("span", {
                        children: [
                            "Drag and drop image/PDF files here,",
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("br", {}),
                            "or click to select from disk."
                        ]
                    })
                }),
                !!uploadProgress && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $4620758787a8f8d2$var$UploadProgressbarStyle(uploadProgress)
                })
            ]
        })
    });
};
$4620758787a8f8d2$export$47d4850b9fdf5af1.propTypes = {
    acceptedFiles: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string),
    uploadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).number.isRequired,
    onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    isMultipleFilesAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool
};





const $9623ba1aec62c5f3$export$6083e5dee0802eaa = ({ onSuccess: onSuccess, isDisabled: isDisabled, questionId: questionId, uploadId: uploadId })=>{
    const acceptedFiles = [
        'image/*',
        'application/pdf'
    ];
    const [uploadProgress, setUploadProgress] = (0, $denZA.useState)(0);
    const imageUploadErrorHandler = (errorsArray)=>{
        const error = errorsArray[0].errors[0];
        let errorMessage;
        switch(error.code){
            case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_INVALID_TYPE:
                errorMessage = 'Invalid file type. Only images and PDFs are allowed.';
                break;
            case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).TOO_MANY_FILES:
                errorMessage = 'Too many files. Please upload images/PDFs one by one.';
                break;
            case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_TOO_LARGE:
                errorMessage = 'Image is too large. Max size is 10 MB.';
                break;
            default:
                errorMessage = (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorText;
        }
        return (0, $41263b671f20f58e$export$2791228263505492)({
            header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
            text: errorMessage,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
    };
    const uploadToS3 = async (file)=>{
        if (!file) return false;
        const uuid = (0, $4fe67744bc7750d5$exports.v4)();
        const filePath = `${uploadId}/qid-${questionId}/${uuid}/${file.path}`;
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(filePath, file, {
                contentType: file.type,
                progressCallback (progress) {
                    const uploadProgressInPercent = Math.round(progress.loaded / progress.total * 100);
                    setUploadProgress(uploadProgressInPercent);
                }
            });
            setUploadProgress(0);
            onSuccess(filePath);
        } catch (error) {
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
                text: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorText,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
            });
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4620758787a8f8d2$export$47d4850b9fdf5af1), {
        acceptedFiles: acceptedFiles,
        uploadProgress: uploadProgress,
        onDrop: (acceptedFiles)=>uploadToS3(acceptedFiles[0]),
        onDropRejected: imageUploadErrorHandler,
        isDisabled: isDisabled || !!uploadProgress
    });
};
$9623ba1aec62c5f3$export$6083e5dee0802eaa.propTypes = {
    onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    questionId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired,
    uploadId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};







const $14db8d2843b04deb$var$questionWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
});
const $14db8d2843b04deb$var$buttonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    margin: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px 0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`
});
const $14db8d2843b04deb$var$headerWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex'
});
const $14db8d2843b04deb$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size2,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
});
const $14db8d2843b04deb$var$additionalFieldsWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 'auto',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        width: 450
    }
});
const $14db8d2843b04deb$var$justificationHelpTextColor = (isDisabled, shouldHighlight)=>{
    if (isDisabled) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40;
    if (shouldHighlight) return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.black;
    return (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slateBase;
};
const $14db8d2843b04deb$var$proofTitleStyle = (isDisabled, shouldHighlight)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        color: $14db8d2843b04deb$var$justificationHelpTextColor(isDisabled, shouldHighlight),
        background: shouldHighlight ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning100 : 'none',
        padding: shouldHighlight ? `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size1}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2}px` : 'inherit',
        marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size2
    });
const $14db8d2843b04deb$var$questionContentWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'relative'
});
const $14db8d2843b04deb$var$loadingOverlayStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    opacity: 0.8,
    zIndex: 999999
});
const $14db8d2843b04deb$var$additionalFieldsHeaderStyle = (isDisabled)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size1,
        marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
        color: isDisabled ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40 : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate100
    });
const $14db8d2843b04deb$var$dropzoneHelpTextStyle = (isDisabled)=>(0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM1,
        marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
        display: 'block',
        color: isDisabled ? (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate40 : (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate90
    });
const $14db8d2843b04deb$var$additionalFieldWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6
});
const $14db8d2843b04deb$export$38435c7d2fecd2f = ({ question: question, questionState: questionState, hasBackButton: hasBackButton, saveAnswer: saveAnswer, isSaving: isSaving, isActive: isActive, highlightProofRequirement: highlightProofRequirement, uploadImageKeys: uploadImageKeys = [], hideActionButton: hideActionButton = false, uploadId: uploadId })=>{
    const { questionId: questionId, subHeader: subHeader, explanation: explanation, conditions: conditions, questionType: questionType, uploadHeadline: uploadHeadline, furtherDetails: furtherDetails, commentsInTextBox: commentsInTextBox } = question;
    const { dispatch: dispatch } = (0, $denZA.useContext)((0, $e906eff0f880d44d$export$7ba7e16fa5af7c45));
    const [infoModalVisibility, setInfoModalVisibility] = (0, $denZA.useState)(false);
    const [deleteImageModal, setDeleteImageModal] = (0, $denZA.useState)({
        isOpen: false,
        imageId: ''
    });
    const [imageModal, setImageModal] = (0, $denZA.useState)({
        isOpen: false,
        imageId: ''
    });
    // Set multi select question to valid
    // as soon as it becomes active as no validation is needed for that question
    // but it looks weird if indicator is blue before reaching that question
    (0, $denZA.useEffect)(()=>{
        if (questionType === (0, $be4e7f9ce17f6c5f$export$e50882b81c62e311).NON_BINARY_MULTI_CHOICE && !questionState.isComplete) {
            if (isActive && !questionState.isValid) dispatch((0, $e906eff0f880d44d$export$5c6e90ccb78f1afd)(questionId));
        }
    }, [
        isActive,
        questionType,
        questionState.isValid,
        questionState.isComplete,
        questionId,
        dispatch
    ]);
    const shouldDisableImageUpload = !questionState.isValid || uploadImageKeys.length >= 5;
    const closeImageModal = ()=>{
        setImageModal(()=>({
                ...imageModal,
                isOpen: false
            }));
    };
    const deleteImageHandler = async (imageKey)=>{
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).remove(imageKey);
            setDeleteImageModal((prevState)=>({
                    ...prevState,
                    isOpen: false
                }));
            dispatch((0, $e906eff0f880d44d$export$bbf1ccc913d6ed12)(imageKey));
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $14db8d2843b04deb$var$questionWrapperStyle,
        children: [
            deleteImageModal.isOpen && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $789a8415176b61ba$export$17bd6d70df17bc40), {
                imageId: deleteImageModal.imageId,
                deleteImageHandler: deleteImageHandler,
                closeDeleteImageModal: ()=>setDeleteImageModal((prevState)=>({
                            ...prevState,
                            isOpen: false
                        }))
            }),
            infoModalVisibility && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $dfe2cae5e4c44ee0$export$4994368e0bfca573), {
                header: subHeader,
                body: furtherDetails,
                closeInfoModal: ()=>setInfoModalVisibility(!infoModalVisibility)
            }),
            imageModal.isOpen && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $1c1c233087ac0505$export$9e0b12df12385af6), {
                imageId: imageModal.imageId,
                closeImageModal: closeImageModal
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $14db8d2843b04deb$var$questionContentWrapperStyle,
                children: [
                    isSaving && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $14db8d2843b04deb$var$loadingOverlayStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $14db8d2843b04deb$var$headerWrapperStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("h2", {
                            css: $14db8d2843b04deb$var$headerStyle,
                            children: [
                                subHeader,
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "questionInfoModalButton",
                                    onClick: ()=>setInfoModalVisibility(!infoModalVisibility),
                                    css: (0, $ff397d5a0eee2c82$export$eac0f7ffa478154d),
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $429b3d4e69163b2d$export$d8874184141c994a), {
                                        css: (0, $ff397d5a0eee2c82$export$d781ca6d008ff44d)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $094d9b0cf4faaefb$export$7c0a16af240a6114), {
                        explanation: explanation,
                        conditions: conditions
                    }),
                    questionType === 'NON_BINARY_MULTI_CHOICE' ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $88d7a13c158ad01d$export$70859b46811b52c1), {
                        question: question,
                        questionState: questionState
                    }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $7af3f689f0c7deed$export$518ee1f8a60ca514), {
                        question: question,
                        questionState: questionState
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("section", {
                        css: $14db8d2843b04deb$var$additionalFieldsWrapperStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                                css: $14db8d2843b04deb$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h3", {
                                        css: $14db8d2843b04deb$var$additionalFieldsHeaderStyle(!questionState.isValid),
                                        children: "Justification"
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                                        css: $14db8d2843b04deb$var$proofTitleStyle(shouldDisableImageUpload, highlightProofRequirement.isCommentMissing),
                                        children: commentsInTextBox
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b2d7e56af1ad27ba$export$f5c9f3c2c4054eec), {
                                        onChange: (event)=>dispatch((0, $e906eff0f880d44d$export$b9fe65f7083ae815)(questionId, event.target.value)),
                                        value: questionState.comment,
                                        disabled: !questionState.isValid,
                                        isDisabled: !questionState.isValid,
                                        validationStatus: highlightProofRequirement.isCommentMissing ? 'warning' : '',
                                        placeholder: "Write here"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                                css: $14db8d2843b04deb$var$additionalFieldWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                                        css: $14db8d2843b04deb$var$proofTitleStyle(shouldDisableImageUpload, highlightProofRequirement.isUploadMissing),
                                        children: uploadHeadline
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9623ba1aec62c5f3$export$6083e5dee0802eaa), {
                                        questionId: questionId,
                                        uploadId: uploadId,
                                        isDisabled: shouldDisableImageUpload,
                                        onSuccess: (imageKey)=>dispatch((0, $e906eff0f880d44d$export$584b5172b1334e18)(imageKey))
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("span", {
                                        css: $14db8d2843b04deb$var$dropzoneHelpTextStyle(shouldDisableImageUpload),
                                        children: "Max. 5 images"
                                    }),
                                    !!uploadImageKeys.length && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $54d2d00c37640082$export$96b9b7524c25c919), {
                                        uploadImageKeys: uploadImageKeys,
                                        imageClickHandler: (imageId)=>setImageModal((prevState)=>({
                                                    ...prevState,
                                                    imageId: imageId,
                                                    isOpen: true
                                                })),
                                        imageDeleteClickHandler: (imageId)=>setDeleteImageModal((prevState)=>({
                                                    ...prevState,
                                                    isOpen: true,
                                                    imageId: imageId
                                                }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !hideActionButton && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $14db8d2843b04deb$var$buttonWrapperStyle,
                children: [
                    hasBackButton && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        disabled: isSaving,
                        isDisabled: isSaving,
                        onClick: ()=>dispatch((0, $e906eff0f880d44d$export$9b541d9f1fcb7ba1)()),
                        label: "Back",
                        "data-transaction-name": "Previous question",
                        variant: "outline",
                        style: {
                            marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4
                        }
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        label: "Next",
                        "data-transaction-name": "Save answer",
                        disabled: !questionState.isValid || isSaving,
                        isDisabled: !questionState.isValid || isSaving,
                        onClick: ()=>saveAnswer(questionId)
                    })
                ]
            })
        ]
    });
};
$14db8d2843b04deb$export$38435c7d2fecd2f.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    questionState: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    hasBackButton: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    saveAnswer: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    isSaving: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool.isRequired,
    highlightProofRequirement: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    hideActionButton: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).bool,
    uploadImageKeys: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string).isRequired,
    uploadId: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).string.isRequired
};








const $98aa489a161c70b9$var$assessmentSurveyContainer = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: '768px',
    margin: 'auto',
    padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px`
    }
});
const $98aa489a161c70b9$var$doneEditingButtonWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8
});
const $98aa489a161c70b9$export$e8189ed768572ea9 = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const location = (0, $32ee599feb5ae61e$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const { customerId: customerId, assessmentYear: assessmentYear, version: version } = (0, $32ee599feb5ae61e$export$99eaa27ddbbb95ef)();
    const [surveyReducerState, dispatch] = (0, $denZA.useReducer)((0, $e906eff0f880d44d$export$62084e9522e5cab), {});
    const { loading: isAssessmentDataLoading, error: assessmentDataError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$ead77c084e8e01bb), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        skip: surveyReducerState?.answers,
        onCompleted: (response)=>dispatch((0, $e906eff0f880d44d$export$2e78289a93d130a3)(response, assessmentYear)),
        fetchPolicy: 'network-only'
    });
    const [updateAnswer, { loading: updateAnswerLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$665446046e211b61), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleAnswerUpdate
    });
    const [updateAllAnswers, { loading: updateAllAnswersLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$9565ea37c098d66), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        onCompleted: handleAllAnswersUpdateCompleted
    });
    (0, $7b4991cbe8665793$export$7eed34e4e2038bc2)({
        uploadId: surveyReducerState?.surveyInfo?.uploadId,
        skip: isAssessmentDataLoading || !surveyReducerState.surveyInfo?.uploadId,
        onCompleted: (0, $denZA.useCallback)((uploadedImagesKeys)=>dispatch((0, $e906eff0f880d44d$export$5a9723c1c1c2936c)(uploadedImagesKeys)), [])
    });
    // The normalization step ensures that when we save an answer, we are sending the correct data format to the backend,
    // Primarily Needed to structure subAnswer data correctly.
    const normalizeAnswerWithQuestions = (answer)=>(0, $f86acbd1c72b687f$export$9fee1bbbe4aa216c)(answer, surveyReducerState.questions);
    function handleAnswerUpdate(response) {
        const { updateAnswer: { questionId: questionId } } = response;
        dispatch((0, $e906eff0f880d44d$export$3e8f578fc1f6d087)(questionId));
    }
    const handleAnswerSave = async (questionId)=>{
        const answerState = surveyReducerState.answers.find((answer)=>answer.questionId === questionId);
        const normalizedAnswer = normalizeAnswerWithQuestions(answerState);
        try {
            await updateAnswer({
                variables: {
                    answer: normalizedAnswer
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    };
    const handleAllAnswersUpdate = async (answers)=>{
        const normalizedAnswers = answers.map(normalizeAnswerWithQuestions);
        try {
            await updateAllAnswers({
                variables: {
                    customerId: customerId,
                    answers: normalizedAnswers
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    };
    function handleAllAnswersUpdateCompleted(response) {
        if (response.updateAllAnswers) history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoringReview(customerId, assessmentYear, version));
    }
    // Error boundary catches this error
    if (assessmentDataError) throw assessmentDataError;
    if (isAssessmentDataLoading || !surveyReducerState.answers?.length || !surveyReducerState.questions?.length) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    const isSurveyComplete = (0, $f86acbd1c72b687f$export$ce968a13e2c6e586)(surveyReducerState.answers);
    const isSurveyInEditMode = queryParams.get('mode') === 'edit';
    if (isSurveyComplete && !isSurveyInEditMode) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $32ee599feb5ae61e$export$2d8d895a0a0f636e), {
        to: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).complete(customerId, assessmentYear, version)
    });
    const surveyDetailsForFeatureFlag = {
        year: Number(assessmentYear),
        channel: surveyReducerState.surveyInfo.customerDetail.channel
    };
    let enhancedQuestions = (0, $f86acbd1c72b687f$export$3ac154c70d0babda)(surveyReducerState.questions, surveyReducerState.answers, surveyReducerState.uploadedImageKeys);
    enhancedQuestions = (0, $f86acbd1c72b687f$export$386fc8b17cd02a9b)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Complete Assessment Form"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0fb6090404c8eff1$export$bfe9facc54fa2d94), {
                assessmentInfo: surveyReducerState.surveyInfo
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $98aa489a161c70b9$var$assessmentSurveyContainer,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e906eff0f880d44d$export$663c2b064fc3c91e).Provider, {
                    value: surveyReducerState,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e906eff0f880d44d$export$7ba7e16fa5af7c45).Provider, {
                        value: {
                            dispatch: dispatch
                        },
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3463068a6fe77df4$export$ed8ca599049e8881), {
                            activeStep: surveyReducerState.activeStep,
                            stepperState: surveyReducerState,
                            shouldHideInactiveStepsContent: !isSurveyInEditMode,
                            children: enhancedQuestions.map((question, index)=>{
                                const { questionId: questionId, headline: headline, questionImageKeys: questionImageKeys, proofRequirement: proofRequirement } = question;
                                const questionState = surveyReducerState.answers.find((answer)=>answer.questionId === questionId);
                                return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $72bcf3aff0a4f9bd$export$fd55ce593607084a), {
                                    stepId: questionId,
                                    header: headline,
                                    isValid: questionState.isValid,
                                    isComplete: questionState.isComplete,
                                    isWarning: proofRequirement.isProofMissing,
                                    additionalHeight: questionImageKeys.length ? 100 : 0,
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $14db8d2843b04deb$export$38435c7d2fecd2f), {
                                        question: question,
                                        questionState: questionState,
                                        hasBackButton: index > 0,
                                        saveAnswer: handleAnswerSave,
                                        isSaving: updateAnswerLoading,
                                        isActive: surveyReducerState.activeStep === index + 1,
                                        uploadImageKeys: questionImageKeys,
                                        highlightProofRequirement: proofRequirement,
                                        hideActionButton: isSurveyInEditMode,
                                        uploadId: surveyReducerState.surveyInfo.uploadId
                                    })
                                }, questionId);
                            })
                        })
                    })
                })
            }),
            (surveyReducerState.assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).SELF_ASSESSMENT || surveyReducerState.assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).RE_ASSESSMENT || surveyReducerState.assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).ASSESSMENT) && isSurveyInEditMode && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $98aa489a161c70b9$var$doneEditingButtonWrapperStyle,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                    label: "Done editing",
                    "data-transaction-name": "Done editing assessment",
                    disabled: updateAllAnswersLoading,
                    isDisabled: updateAllAnswersLoading,
                    onClick: ()=>handleAllAnswersUpdate(surveyReducerState.answers)
                })
            })
        ]
    });
};





















var $denZA = parcelRequire("denZA");



var $cvFNP = parcelRequire("cvFNP");


const $c3084d40a40fb7e5$export$1de3a04236fd9c26 = ({ onClose: onClose, onConfirm: onConfirm, onExitHandler: onExitHandler })=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
        status: "warning",
        header: "Missing Attachments",
        onConfirmText: "Back To Edit",
        onCloseText: "Cancel",
        body: "Some of the answers that you have selected require proof of performance to be considered valid. </br>  Plese upload the corresponding attachments.",
        onClose: onClose,
        onConfirm: onConfirm,
        onExitHandler: onExitHandler,
        icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b94eea2085bb4e91$export$650e18e4b9cea8d1), {})
    });
$c3084d40a40fb7e5$export$1de3a04236fd9c26.propTypes = {
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired,
    onExitHandler: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func
};


const $af40da3327e4e3c0$var$assessmentSurveyContainer = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: '768px',
    margin: 'auto',
    padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px`
    }
});
const $af40da3327e4e3c0$var$sectionContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    paddingBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
});
const $af40da3327e4e3c0$var$actionButtonsWrapper = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size16,
    width: 306
});
const $af40da3327e4e3c0$export$1b4d0e655b136998 = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const { customerId: customerId, assessmentYear: assessmentYear, version: version } = (0, $32ee599feb5ae61e$export$99eaa27ddbbb95ef)();
    const [isProofWarningModalVisible, setIsProofWarningModalVisible] = (0, $denZA.useState)(false);
    const { data: getCompletePageData, loading: getCompletePageDataLoading, error: getCompletePageDataError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$c99b09d55436be15), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        fetchPolicy: 'network-only'
    });
    const [finishSurvey, { loading: finishSurveyLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$42d41fcb8525466c), {
        onCompleted: handleFinishSurveyResponse
    });
    async function submitSurvey() {
        try {
            await finishSurvey({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    version: Number(version)
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    async function handleFinishSurvey() {
        if ((0, $f86acbd1c72b687f$export$3e14b0f9f411cc85)(enhancedQuestions)) {
            setIsProofWarningModalVisible(true);
            return;
        }
        await submitSurvey();
    }
    function handleFinishSurveyResponse(response) {
        if (response.finishSurvey) {
            const { getSurveyInfo: { customerDetail: { name: name } } } = getCompletePageData;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: `${name}'s assessment was submitted.`,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    // Error boundary catches this error
    if (getCompletePageDataError) throw getCompletePageDataError;
    if (getCompletePageDataLoading || finishSurveyLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    const { getSurvey: questions, getSurveyInfo: surveyInfo, getAnswers: answers } = getCompletePageData;
    const surveyDetailsForFeatureFlag = {
        year: Number(assessmentYear),
        channel: surveyInfo.customerDetail.channel
    };
    let enhancedQuestions = (0, $f86acbd1c72b687f$export$3ac154c70d0babda)(questions, answers);
    enhancedQuestions = (0, $f86acbd1c72b687f$export$386fc8b17cd02a9b)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            isProofWarningModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c3084d40a40fb7e5$export$1de3a04236fd9c26), {
                onClose: ()=>{
                    setIsProofWarningModalVisible(false);
                },
                onConfirm: ()=>{
                    setIsProofWarningModalVisible(false);
                    history.push(`${(0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoring(customerId, assessmentYear, version)}?mode=edit`);
                }
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Complete Assessment Form"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0fb6090404c8eff1$export$bfe9facc54fa2d94), {
                assessmentInfo: surveyInfo
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $af40da3327e4e3c0$var$assessmentSurveyContainer,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3463068a6fe77df4$export$ed8ca599049e8881), {
                    children: enhancedQuestions.map((question)=>{
                        return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $72bcf3aff0a4f9bd$export$fd55ce593607084a), {
                            stepId: question.questionId,
                            header: question.headline,
                            isValid: true,
                            isWarning: question.proofRequirement.isProofMissing,
                            isComplete: true
                        }, question.questionId);
                    })
                })
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b0459eaa6dae80b0$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $af40da3327e4e3c0$var$sectionContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                        type: "h2",
                        text: "Score"
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $78b8667b7afe5597$export$6addd58703e5f916), {
                        scoreText: "The calculated functional discount score is:",
                        score: surveyInfo.surveyState.score
                    })
                ]
            }),
            (0, $f86acbd1c72b687f$export$3e14b0f9f411cc85)(enhancedQuestions) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e0a384f5fee972ef$export$f68959556d5a9913), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $af40da3327e4e3c0$var$actionButtonsWrapper,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a), {
                        to: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoringReview(customerId, assessmentYear, version),
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                            label: "Review",
                            "data-transaction-name": "Review assessment before submit",
                            variant: "outline"
                        })
                    }),
                    !surveyInfo.surveyState.isComplete && (0, $f86acbd1c72b687f$export$ce968a13e2c6e586)(answers) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        label: "Submit assessment",
                        "data-transaction-name": "Submit assessment - from complete",
                        onClick: handleFinishSurvey
                    })
                ]
            })
        ]
    });
};








var $denZA = parcelRequire("denZA");













const $da6349efb6d9a8ea$var$assessmentYearSelect = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    width: 150
});
const $da6349efb6d9a8ea$var$progressBarContainer = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        width: 400
    }
});
const $da6349efb6d9a8ea$export$74c276b46ce14ef3 = ()=>{
    const [eligibleYears, setEligibleYears] = (0, $denZA.useState)([]);
    const [selectedYear, setSelectedYear] = (0, $denZA.useState)();
    const [selectedBu, setSelectedBu] = (0, $denZA.useState)('');
    const [activateConfirmModalVisibility, setActivateConfirmModalVisibility] = (0, $denZA.useState)(false);
    const handleGetEligibleYearsResponse = (response)=>{
        setEligibleYears(response.getEligibleAssessmentYears);
    };
    const [getEligibleYears, { loading: eligibleYearsLoading, refetch: refetchEligibleYears }] = (0, $879159a57326e8fe$export$fd83eea6ecd2d8fa)((0, $d99851fcb7e80ca8$export$a5cc09564839c18a), {
        fetchPolicy: 'network-only',
        onCompleted: handleGetEligibleYearsResponse
    });
    const getAllBusinessUnitsForYear = (0, $denZA.useMemo)(()=>{
        return eligibleYears.filter((assessmentYear)=>assessmentYear.year === selectedYear).flatMap((assessmentYear)=>assessmentYear.businessUnits);
    }, [
        eligibleYears,
        selectedYear
    ]);
    const getEligibleYearOptions = ()=>eligibleYears.map((assessmentYear)=>assessmentYear.year);
    (0, $denZA.useEffect)(()=>{
        getEligibleYears();
        const handleCustomerDataUpdateEvent = ()=>{
            getEligibleYears();
        };
        document.addEventListener('customerDataGenerated', handleCustomerDataUpdateEvent);
        return ()=>{
            document.removeEventListener('customerDataGenerated', handleCustomerDataUpdateEvent);
        };
    }, [
        getEligibleYears
    ]);
    if (eligibleYears.length > 0 && !selectedYear) setSelectedYear(Math.max(...eligibleYears.map((assessmentYear)=>assessmentYear.year)));
    const showConfirmActivateModal = (buName)=>{
        setSelectedBu(buName);
        setActivateConfirmModalVisibility(true);
    };
    const [activateBuForYear, { loading: activateBusinessUnitLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $d99851fcb7e80ca8$export$a08a5b13f6e5e7f5), {
        onCompleted: handleActivateBuResponse
    });
    const [updateBuDeadlineForYear, { loading: updateBusinessUnitDeadlineLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $d99851fcb7e80ca8$export$e06a19adcb99f5e8), {
        onCompleted: (response)=>{
            if (response.updateBusinessUnitDeadlineForYear) (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: 'Business Unit deadline has been updated',
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
        }
    });
    async function handleBusinessUnitActivation() {
        try {
            await activateBuForYear({
                variables: {
                    businessUnit: selectedBu,
                    year: selectedYear
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
            setActivateConfirmModalVisibility(false);
        }
    }
    async function handleBusinessUnitUpdateDeadline(buName, deadline) {
        const deadlineDate = new Date(deadline);
        if (isNaN(deadlineDate.getTime())) {
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
                text: 'Invalid deadline date. Please select a valid date.',
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
            });
            return;
        }
        try {
            const utcDeadlineTimestamp = Date.UTC(deadlineDate.getUTCFullYear(), deadlineDate.getUTCMonth(), deadlineDate.getUTCDate());
            await updateBuDeadlineForYear({
                variables: {
                    businessUnit: buName,
                    year: selectedYear,
                    deadlineTimestamp: utcDeadlineTimestamp.toString()
                }
            });
            handleGetEligibleYearsResponse((await refetchEligibleYears()).data);
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    function handleActivateBuResponse(response) {
        if (response.activateBusinessUnitForYear) {
            const { year: year, businessUnits: businessUnits } = response.activateBusinessUnitForYear;
            let updatedEligibleYears = eligibleYears.map((eligibleYear)=>{
                if (eligibleYear.year === year) return {
                    deadlineTimestamp: eligibleYear.deadlineTimestamp,
                    year: year,
                    businessUnits: businessUnits
                };
                else return eligibleYear;
            });
            setEligibleYears([
                ...updatedEligibleYears
            ]);
            setActivateConfirmModalVisibility(false);
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: 'Business Unit has been activated',
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
        }
    }
    if (activateBusinessUnitLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: (0, $ff397d5a0eee2c82$export$7ad3b5f9b0722e2c),
                children: "Activating the business unit. This may take a few minutes."
            })
        ]
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            activateConfirmModalVisibility && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $9ca33e8fb814a3bb$export$fde4214a1c5284d3), {
                status: "warning",
                header: "Confirm activation",
                body: `Are you sure you want to activate the Business Unit: ${selectedBu} for year: ${selectedYear}? </br></br>
               This will activate all Long Tail assessments for ${selectedBu} and will allow customers to access the self-assessment scoring.`,
                onClose: ()=>setActivateConfirmModalVisibility(false),
                onConfirm: handleBusinessUnitActivation
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h2",
                text: "Active Year"
            }),
            "Determines which surveys are visible for long-tail customers and what MCP version will be flagged active.",
            eligibleYearsLoading ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $da6349efb6d9a8ea$var$progressBarContainer,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ead0a0bc4e3112f2$export$11f983dff6f48944), {}),
                    ' '
                ]
            }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                        type: "h3",
                        text: "Eligible years"
                    }),
                    eligibleYears.length === 0 ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                        "data-testid": "noResponseMessage",
                        children: "No eligible years are available. Please upload a customer/channel mapping first."
                    }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                css: $da6349efb6d9a8ea$var$assessmentYearSelect,
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ad3b5be9711589c5$export$ef9b1a59e592288f), {
                                    "data-testid": "eligibleYearSelect",
                                    size: "sm",
                                    value: selectedYear,
                                    onChange: (event)=>setSelectedYear(parseInt(event.target.value)),
                                    children: getEligibleYearOptions().map((yearOption, i)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("option", {
                                            children: yearOption
                                        }, i))
                                })
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ed90153c01704be2$export$54ec01a60f47d33d), {
                                variant: "simple",
                                "data-testid": "eligibleBuTable",
                                children: [
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Head, {
                                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Row, {
                                            children: [
                                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    paddingLeft: 0,
                                                    paddingBottom: 0,
                                                    children: "Eligible Business Unit"
                                                }),
                                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    paddingBottom: 0,
                                                    children: "Deadline"
                                                }),
                                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                    fontWeight: "bold",
                                                    borderBottom: "none",
                                                    paddingBottom: 0,
                                                    children: "Active?"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Body, {
                                        "data-testid": "eligibleBuTableBody",
                                        children: getAllBusinessUnitsForYear.map((bu)=>{
                                            const deadlineDate = new Date(Number(bu.deadlineTimestamp));
                                            return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Row, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                        borderBottom: "none",
                                                        paddingLeft: 0,
                                                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $631fbf6cd923cd39$export$3288d34c523a1192), {
                                                            colorScheme: "light-blue",
                                                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $631fbf6cd923cd39$export$3288d34c523a1192).Label, {
                                                                children: bu.businessUnitName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                        borderBottom: "none",
                                                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $eb05d11f12817009$export$f5b8910cec6cf069), {
                                                            type: "date",
                                                            size: "sm",
                                                            disabled: updateBusinessUnitDeadlineLoading,
                                                            value: bu.deadlineTimestamp ? deadlineDate.toISOString().split('T')[0] : '',
                                                            onChange: (event)=>handleBusinessUnitUpdateDeadline(bu.businessUnitName, event.target.value)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ed90153c01704be2$export$54ec01a60f47d33d).Cell, {
                                                        borderBottom: "none",
                                                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                                            className: `klik-switch ${bu.active ? 'klik-is-active' : ''} ${bu.active || updateBusinessUnitDeadlineLoading ? 'klik-is-disabled' : ''}`,
                                                            onClick: ()=>{
                                                                if (bu.deadlineTimestamp === undefined) {
                                                                    (0, $41263b671f20f58e$export$2791228263505492)({
                                                                        header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
                                                                        text: 'Please set a deadline for the Business Unit before activating it.',
                                                                        type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
                                                                    });
                                                                    return;
                                                                }
                                                                showConfirmActivateModal(bu.businessUnitName);
                                                            },
                                                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                                                                className: 'klik-switch-dot'
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, bu.businessUnitName);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $denZA = parcelRequire("denZA");








const $f8462361478713fd$var$uploadTypeConfig = {
    'customer-channel': {
        uploadPrefix: 'customer-mapping/upload/',
        messages: {
            timeout: {
                header: 'Data generation timed out',
                text: 'It is taking too long to process the uploaded customer list. Please try again or upload a smaller list.'
            },
            successWithFailures: {
                header: 'Data generation successful',
                text: 'One or more assessment mappings failed.\nPlease download the failure report for details.'
            },
            success: {
                header: 'Data generation successful',
                text: 'Assessment mappings have been updated.'
            },
            catchError: {
                header: 'Data generation failed',
                text: 'An error occurred while generating data'
            }
        }
    },
    'channel-survey': {
        uploadPrefix: 'channel-survey/upload/',
        messages: {
            timeout: {
                header: 'Upload timed out',
                text: 'It is taking too long to process the channel survey mapping file. Please try again or upload a smaller file.'
            },
            successWithFailures: {
                header: 'Upload successful',
                text: 'One or more channel survey mappings failed.\nPlease download the failure report for details.'
            },
            success: {
                header: 'Upload successful',
                text: 'Channel survey mappings have been updated.'
            },
            catchError: {
                header: 'Upload failed',
                text: 'An error occurred while processing the channel survey mapping file'
            }
        }
    }
};
const $f8462361478713fd$export$f1e036d9bfe12cb8 = async (filePath, uploadType = 'customer-channel')=>{
    const { uploadPrefix: uploadPrefix, messages: messages } = $f8462361478713fd$var$uploadTypeConfig[uploadType];
    const credentials = await (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).currentCredentials();
    const lambda = new (0, $0d8f96024bbaf0ac$export$4d5bd360b6390e98)({
        credentials: (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).essentialCredentials(credentials),
        region: 'eu-west-1'
    });
    const userBucketLocation = `private/${credentials.identityId}/`;
    const session = await (0, $e5a347d28ba453e7$export$2e2bcd8739ae039).currentSession();
    const payload = JSON.stringify({
        userBucketLocation: userBucketLocation,
        jwt: session.idToken.jwtToken,
        filePath: `${uploadPrefix}${filePath}`,
        uploadType: uploadType
    });
    return lambda.invoke({
        LogType: 'None',
        InvocationType: 'RequestResponse',
        Payload: payload,
        FunctionName: "arn:aws:lambda:eu-west-1:059214068209:function:staging-s3upload-stack-lambdauploadhandlerlambdaha-WiSDlizTM3tJ"
    }).then((response)=>{
        const stringResponse = new TextDecoder('utf-8').decode(response.Payload);
        const generateResponse = JSON.parse(stringResponse);
        if (generateResponse.errorMessage) {
            if (generateResponse.errorMessage.includes('Task timed out')) (0, $41263b671f20f58e$export$2791228263505492)({
                header: messages.timeout.header,
                text: messages.timeout.text,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
            });
        }
        if (generateResponse.complete) {
            if (generateResponse.failures && generateResponse.failures.length > 0) (0, $41263b671f20f58e$export$2791228263505492)({
                header: messages.successWithFailures.header,
                text: messages.successWithFailures.text,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).WARNING
            });
            else (0, $41263b671f20f58e$export$2791228263505492)({
                header: messages.success.header,
                text: messages.success.text,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
        } else if (generateResponse.failures && generateResponse.failures.length > 0) (0, $41263b671f20f58e$export$2791228263505492)({
            header: 'Something went wrong',
            text: generateResponse.failures[0].detail ?? 'Please contact support',
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
    }).catch((error)=>{
        (0, $41263b671f20f58e$export$2791228263505492)({
            header: messages.catchError.header,
            text: messages.catchError.text,
            type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
        });
        throw error;
    });
};











var $cvFNP = parcelRequire("cvFNP");




const $6142782857f8f355$var$exportIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    height: 14
});
const $6142782857f8f355$var$failureReportIconStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    height: 14,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).utilityColors.warning.warning400
});
const $6142782857f8f355$var$downloadLinkStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $6142782857f8f355$var$downloadLinkWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex'
});
const $6142782857f8f355$export$86c533d1776f4246 = ({ uploadedFiles: uploadedFiles })=>{
    if (uploadedFiles.length === 0) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: "No previous files uploaded..."
    });
    const groupedFiles = {};
    let latestGroup;
    for (const file of uploadedFiles){
        const keyMatch = file.key.match(/customer-mapping\/processed\/(\d+)\/(.+)/);
        if (keyMatch) {
            const group = keyMatch[1];
            const fileName = keyMatch[2];
            if (!groupedFiles[group]) groupedFiles[group] = {
                mappingFile: {},
                processLog: {},
                failureReport: {}
            };
            if (!latestGroup || group > latestGroup) latestGroup = group;
            switch(fileName){
                case 'process.log':
                    groupedFiles[group].processLog.fileName = fileName;
                    groupedFiles[group].processLog.lastModified = new Date(file.lastModified);
                    groupedFiles[group].processLog.downloadLink = file.downloadLink;
                    break;
                case 'FailureReport.xlsx':
                    groupedFiles[group].failureReport.fileName = fileName;
                    groupedFiles[group].failureReport.lastModified = new Date(file.lastModified);
                    groupedFiles[group].failureReport.downloadLink = file.downloadLink;
                    break;
                default:
                    groupedFiles[group].mappingFile.fileName = fileName;
                    groupedFiles[group].mappingFile.lastModified = new Date(file.lastModified);
                    groupedFiles[group].mappingFile.downloadLink = file.downloadLink;
            }
        }
    }
    const latestFile = groupedFiles[latestGroup];
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        "data-testid": "previousCustomerMapping",
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $4776636f99110dca$export$694e0d28c7ffc90c), {
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                    type: "h3",
                    text: `Last update: ${(0, $bf4d1a01ebfb74e1$export$3ae94a2503e890a1)(latestFile.mappingFile.lastModified)}`
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    css: $6142782857f8f355$var$downloadLinkWrapperStyle,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6c17e076bc3c1336$export$28c660c63b792dea), {
                        content: "Download last uploaded customer / mapping file",
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("a", {
                            href: latestFile.mappingFile.downloadLink,
                            target: "_blank",
                            rel: "noreferrer",
                            css: $6142782857f8f355$var$downloadLinkStyle,
                            children: [
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $01d26031ee31db8e$export$a7aaed3e118dd255), {
                                    css: $6142782857f8f355$var$exportIconStyle
                                }),
                                "Export customer list"
                            ]
                        })
                    })
                }),
                latestFile.failureReport.fileName && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                    "data-testid": "failureReport",
                    css: $6142782857f8f355$var$downloadLinkWrapperStyle,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6c17e076bc3c1336$export$28c660c63b792dea), {
                        content: "There were errors that occurred during this upload. Click to download the report.",
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: latestFile.failureReport.downloadLink,
                            css: $6142782857f8f355$var$downloadLinkStyle,
                            children: [
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $02f87be4862405c0$export$f1b6053a528b50d9), {
                                    css: $6142782857f8f355$var$failureReportIconStyle
                                }),
                                "Failure Report"
                            ]
                        })
                    })
                })
            ]
        })
    });
};
$6142782857f8f355$export$86c533d1776f4246.propTypes = {
    uploadedFiles: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).array.isRequired
};








var $cvFNP = parcelRequire("cvFNP");
const $49e1c1a3b0920a9c$var$formatSize = (bytes)=>{
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = [
        'Bytes',
        'KB',
        'MB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + ' ' + sizes[i];
};
const $49e1c1a3b0920a9c$var$uploadFileWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $49e1c1a3b0920a9c$export$8d35cce1f6ccfd6a = ({ uploadedFile: uploadedFile, onDelete: onDelete })=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        css: $49e1c1a3b0920a9c$var$uploadFileWrapperStyle,
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("h4", {
                children: [
                    uploadedFile.path,
                    " - ",
                    $49e1c1a3b0920a9c$var$formatSize(uploadedFile.size)
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                "aria-label": "Delete file bin icon button",
                "data-transaction-name": "Delete File",
                icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6aa7e8776e67a2c8$export$bfadae053a633538), {}),
                variant: "ghost",
                onClick: onDelete
            })
        ]
    });
};
$49e1c1a3b0920a9c$export$8d35cce1f6ccfd6a.propTypes = {
    uploadedFile: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object.isRequired,
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).func.isRequired
};




const $c9e00bb85fd8ec75$var$bucketName = "staging-mcp-customer-mapping-upload-bucket";
const $c9e00bb85fd8ec75$var$s3StorageOptions = {
    bucket: $c9e00bb85fd8ec75$var$bucketName,
    level: 'private'
};
const $c9e00bb85fd8ec75$var$processedLocation = 'customer-mapping/processed/';
const $c9e00bb85fd8ec75$var$acceptedFiles = [
    '.xlsx'
];
const $c9e00bb85fd8ec75$var$progressBarContainer = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        width: 400
    }
});
const $c9e00bb85fd8ec75$var$uploadDropzoneWrapperStyle = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    width: '50%'
});
const $c9e00bb85fd8ec75$var$uploadRejected = (errorsArray)=>{
    const error = errorsArray[0].errors[0];
    let errorMessage;
    switch(error.code){
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_INVALID_TYPE:
            errorMessage = 'Invalid file type. Only Excel worksheets are allowed.';
            break;
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).TOO_MANY_FILES:
            errorMessage = 'Too many files. Only one file at a time is allowed.';
            break;
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_TOO_LARGE:
            errorMessage = 'File is too large. Max size is 10 MB.';
            break;
        default:
            errorMessage = (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorText;
    }
    return (0, $41263b671f20f58e$export$2791228263505492)({
        header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
        text: errorMessage,
        type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
    });
};
const $c9e00bb85fd8ec75$export$1c81046a2dad8025 = ()=>{
    const [uploadProgress, setUploadProgress] = (0, $denZA.useState)(0);
    const [historicFiles, setHistoricFiles] = (0, $denZA.useState)([]);
    const [filesLoading, setFilesLoading] = (0, $denZA.useState)(false);
    const [currentFile, setCurrentFile] = (0, $denZA.useState)(null);
    const [generateLoading, setGenerateLoading] = (0, $denZA.useState)(false);
    const requestDataGenerate = async ()=>{
        setGenerateLoading(true);
        (0, $f8462361478713fd$export$f1e036d9bfe12cb8)(currentFile.path).then(()=>{
            setCurrentFile(null);
        }).catch((error)=>{
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }).finally(()=>{
            setGenerateLoading(false);
            retrieveHistoricFiles();
            document.dispatchEvent(new CustomEvent('customerDataGenerated'), {});
        });
    };
    const retrieveHistoricFiles = ()=>{
        setFilesLoading(true);
        const getFromS3 = async ()=>{
            const s3Files = await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).list($c9e00bb85fd8ec75$var$processedLocation, $c9e00bb85fd8ec75$var$s3StorageOptions);
            setHistoricFiles(await Promise.all(s3Files.map(async (file)=>{
                return {
                    key: file.key,
                    lastModified: file.lastModified,
                    downloadLink: await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get(file.key, {
                        bucket: $c9e00bb85fd8ec75$var$bucketName,
                        level: 'private'
                    })
                };
            })));
            setFilesLoading(false);
        };
        getFromS3();
    };
    (0, $denZA.useEffect)(()=>{
        retrieveHistoricFiles();
    }, []);
    const uploadCustomerMappingFile = async (file)=>{
        if (!file) return false;
        const filePath = 'customer-mapping/upload/' + file.path;
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(filePath, file, {
                bucket: $c9e00bb85fd8ec75$var$bucketName,
                level: 'private',
                contentType: file.type,
                progressCallback (progress) {
                    const uploadProgressInPercent = Math.round(progress.loaded / progress.total * 100);
                    setUploadProgress(uploadProgressInPercent);
                }
            });
            setCurrentFile(file);
            setUploadProgress(0);
        } catch (error) {
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }
    };
    const deleteFile = async ()=>{
        const filePath = 'customer-mapping/upload/' + currentFile.path;
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).remove(filePath, $c9e00bb85fd8ec75$var$s3StorageOptions);
            setCurrentFile(null);
        } catch (error) {
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }
    };
    const generateData = async ()=>{
        setGenerateLoading(true);
        await requestDataGenerate();
    };
    if (generateLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: (0, $ff397d5a0eee2c82$export$7ad3b5f9b0722e2c),
                children: "Generating data. This may take a few minutes."
            })
        ]
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h2",
                text: "Customer / Channel Mapping"
            }),
            filesLoading ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $c9e00bb85fd8ec75$var$progressBarContainer,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ead0a0bc4e3112f2$export$11f983dff6f48944), {}),
                    ' '
                ]
            }) : /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6142782857f8f355$export$86c533d1776f4246), {
                uploadedFiles: historicFiles
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $c9e00bb85fd8ec75$var$uploadDropzoneWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                        type: "h3",
                        text: "Upload new customer/channel mapping"
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4620758787a8f8d2$export$47d4850b9fdf5af1), {
                        acceptedFiles: $c9e00bb85fd8ec75$var$acceptedFiles,
                        uploadProgress: uploadProgress,
                        onDrop: (fileDropped)=>uploadCustomerMappingFile(fileDropped[0]),
                        onDropRejected: $c9e00bb85fd8ec75$var$uploadRejected,
                        isDisabled: !!uploadProgress
                    })
                ]
            }),
            currentFile && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $49e1c1a3b0920a9c$export$8d35cce1f6ccfd6a), {
                uploadedFile: currentFile,
                onDelete: deleteFile
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                style: {
                    marginTop: !currentFile ? '48px' : '0px'
                },
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                    label: "Generate Data",
                    "data-transaction-name": "Generate Data - Customer Channel Mapping",
                    disabled: !currentFile,
                    onClick: ()=>generateData()
                })
            })
        ]
    });
};



const $bfe2459e444ec9cb$var$assessmentManagementContainer = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    display: 'flex'
});
const $bfe2459e444ec9cb$var$assessmentManagementContent = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    width: '50%'
});
const $bfe2459e444ec9cb$var$AssessmentManagement = ()=>{
    const { roles: roles } = (0, $b92321121d608eea$export$23bbbc4533528f03)();
    if (!roles || !roles.includes('admin')) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: "You do not have access to the Assessment Management page. Please contact MCP Support."
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Assessment Management"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $bfe2459e444ec9cb$var$assessmentManagementContainer,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $bfe2459e444ec9cb$var$assessmentManagementContent,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c9e00bb85fd8ec75$export$1c81046a2dad8025), {})
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $bfe2459e444ec9cb$var$assessmentManagementContent,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $da6349efb6d9a8ea$export$74c276b46ce14ef3), {})
                    })
                ]
            })
        ]
    });
};
const $bfe2459e444ec9cb$export$43c12f6bb2f865a0 = (0, $202c0fb36afa19ba$export$c0b5558aa11175d9)('AssessmentManagementPage', 'component')($bfe2459e444ec9cb$var$AssessmentManagement);








var $denZA = parcelRequire("denZA");
















const $5d9f51cd340dc370$var$bucketName = "staging-mcp-customer-mapping-upload-bucket";
const $5d9f51cd340dc370$var$s3StorageOptions = {
    bucket: $5d9f51cd340dc370$var$bucketName,
    level: 'private'
};
const $5d9f51cd340dc370$var$acceptedFiles = [
    '.xlsx'
];
const $5d9f51cd340dc370$var$progressBarContainer = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        width: 400
    }
});
const $5d9f51cd340dc370$var$uploadDropzoneWrapperStyle = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    width: '50%'
});
const $5d9f51cd340dc370$var$exportIconStyle = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    height: 14
});
const $5d9f51cd340dc370$var$downloadLinkStyle = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $5d9f51cd340dc370$var$downloadLinkWrapperStyle = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    display: 'flex'
});
const $5d9f51cd340dc370$var$uploadRejected = (errorsArray)=>{
    const error = errorsArray[0].errors[0];
    let errorMessage;
    switch(error.code){
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_INVALID_TYPE:
            errorMessage = 'Invalid file type. Only Excel worksheets are allowed.';
            break;
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).TOO_MANY_FILES:
            errorMessage = 'Too many files. Only one file at a time is allowed.';
            break;
        case (0, $6ccbfd9e6e2b1551$export$22c0d1c4538a5951).FILE_TOO_LARGE:
            errorMessage = 'File is too large. Max size is 10 MB.';
            break;
        default:
            errorMessage = (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorText;
    }
    return (0, $41263b671f20f58e$export$2791228263505492)({
        header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).errorHeader,
        text: errorMessage,
        type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).ERROR
    });
};
const $5d9f51cd340dc370$export$a3b16ac40ed79448 = ()=>{
    const [uploadProgress, setUploadProgress] = (0, $denZA.useState)(0);
    const [latestFileUrl, setLatestFileUrl] = (0, $denZA.useState)(null);
    const [latestFileLoading, setLatestFileLoading] = (0, $denZA.useState)(false);
    const [currentFile, setCurrentFile] = (0, $denZA.useState)(null);
    const [generateLoading, setGenerateLoading] = (0, $denZA.useState)(false);
    const requestDataGenerate = async ()=>{
        setGenerateLoading(true);
        (0, $f8462361478713fd$export$f1e036d9bfe12cb8)(currentFile.path, 'channel-survey').then(()=>{
            setCurrentFile(null);
        }).catch((error)=>{
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }).finally(()=>{
            setGenerateLoading(false);
            fetchLatestFileUrl();
        });
    };
    const fetchLatestFileUrl = ()=>{
        setLatestFileLoading(true);
        (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).get('channel-survey/latest.xlsx', {
            bucket: $5d9f51cd340dc370$var$bucketName,
            level: 'public',
            customPrefix: {
                public: ''
            }
        }).then((url)=>setLatestFileUrl(url)).finally(()=>setLatestFileLoading(false));
    };
    (0, $denZA.useEffect)(()=>{
        fetchLatestFileUrl();
    }, []);
    const uploadChannelSurveyFile = async (file)=>{
        if (!file) return false;
        const filePath = 'channel-survey/upload/' + file.path;
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).put(filePath, file, {
                bucket: $5d9f51cd340dc370$var$bucketName,
                level: 'private',
                contentType: file.type,
                progressCallback (progress) {
                    const uploadProgressInPercent = Math.round(progress.loaded / progress.total * 100);
                    setUploadProgress(uploadProgressInPercent);
                }
            });
            setCurrentFile(file);
            setUploadProgress(0);
        } catch (error) {
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }
    };
    const deleteFile = async ()=>{
        const filePath = 'channel-survey/upload/' + currentFile.path;
        try {
            await (0, $8fb5583da54aaa9c$export$bf2a15d34f3c441c).remove(filePath, $5d9f51cd340dc370$var$s3StorageOptions);
            setCurrentFile(null);
        } catch (error) {
            (0, $701a617efab9f26c$export$af88d00dbe7f521).logError(error);
        }
    };
    const generateData = async ()=>{
        setGenerateLoading(true);
        await requestDataGenerate();
    };
    if (generateLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                css: (0, $ff397d5a0eee2c82$export$7ad3b5f9b0722e2c),
                children: "Processing channel survey mapping. This may take a few minutes."
            })
        ]
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            latestFileLoading ? /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $5d9f51cd340dc370$var$progressBarContainer,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ead0a0bc4e3112f2$export$11f983dff6f48944), {})
            }) : latestFileUrl && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $5d9f51cd340dc370$var$downloadLinkWrapperStyle,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6c17e076bc3c1336$export$28c660c63b792dea), {
                    content: "Download latest channel survey mapping file",
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("a", {
                        href: latestFileUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        css: $5d9f51cd340dc370$var$downloadLinkStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $01d26031ee31db8e$export$a7aaed3e118dd255), {
                                css: $5d9f51cd340dc370$var$exportIconStyle
                            }),
                            "Export channel survey mapping"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                css: $5d9f51cd340dc370$var$uploadDropzoneWrapperStyle,
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                        type: "h3",
                        text: "Upload new channel/survey mapping"
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4620758787a8f8d2$export$47d4850b9fdf5af1), {
                        acceptedFiles: $5d9f51cd340dc370$var$acceptedFiles,
                        uploadProgress: uploadProgress,
                        onDrop: (fileDropped)=>uploadChannelSurveyFile(fileDropped[0]),
                        onDropRejected: $5d9f51cd340dc370$var$uploadRejected,
                        isDisabled: !!uploadProgress
                    })
                ]
            }),
            currentFile && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $49e1c1a3b0920a9c$export$8d35cce1f6ccfd6a), {
                uploadedFile: currentFile,
                onDelete: deleteFile
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                style: {
                    marginTop: !currentFile ? '48px' : '0px'
                },
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                    label: "Process Upload",
                    "data-transaction-name": "Process Upload - Channel Survey Mapping",
                    disabled: !currentFile,
                    onClick: ()=>generateData()
                })
            })
        ]
    });
};



const $69d5ad048cd4edc0$var$channelSurveyUploadContent = (0, $803605a2d06b7a22$export$dbf350e5966cf602)({
    width: '50%'
});
const $69d5ad048cd4edc0$var$ChannelSurveyUpload = ()=>{
    const { roles: roles } = (0, $b92321121d608eea$export$23bbbc4533528f03)();
    if (!(0, $b92321121d608eea$export$17718da877d9c5f8)(roles)) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: "You do not have access to the Channel Survey Upload page. This page requires both Admin and Revenue Manager permissions. Please contact MCP Support."
    });
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Channel Survey Upload"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $69d5ad048cd4edc0$var$channelSurveyUploadContent,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $5d9f51cd340dc370$export$a3b16ac40ed79448), {})
            })
        ]
    });
};
const $69d5ad048cd4edc0$export$542eedeb52ec712b = (0, $202c0fb36afa19ba$export$c0b5558aa11175d9)('ChannelSurveyUploadPage', 'component')($69d5ad048cd4edc0$var$ChannelSurveyUpload);




var $cvFNP = parcelRequire("cvFNP");





var $31217920c6efbea3$exports = {};
$31217920c6efbea3$exports = $parcel$resolve("6ECCK");



const $ddb7f704ebbcf402$var$containerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.darkBlue.darkBlue80}, ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.darkBlue.base})`,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    textAlign: 'center',
    paddingBottom: 120,
    height: '100vh'
});
const $ddb7f704ebbcf402$var$imageWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 40,
    width: 200,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        marginTop: 80,
        width: 'auto'
    }
});
const $ddb7f704ebbcf402$var$svgStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: '100%',
    height: 'auto'
});
const $ddb7f704ebbcf402$var$svgWrapperLeftStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 120,
    marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
    '& > img': {
        transform: 'matrix(-1, 0, 0, 1, 0, 0);'
    }
});
const $ddb7f704ebbcf402$var$svgWrapperRightStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 220
});
const $ddb7f704ebbcf402$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size7,
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size3,
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.s,
    padding: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size5
    }
});
const $ddb7f704ebbcf402$var$bodyTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: 500,
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.m,
    padding: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px`,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12
});
const $ddb7f704ebbcf402$var$handleSignOut = async ()=>{
    await (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).signOut();
    $parcel$global.window.location.reload();
};
const $ddb7f704ebbcf402$export$c120a0e80fd44ca6 = ({ withBackToOverviewButton: withBackToOverviewButton, error: error })=>{
    const isAccessError = error?.message?.includes('missing application access');
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $ddb7f704ebbcf402$var$containerStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $ddb7f704ebbcf402$var$imageWrapperStyle,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            css: $ddb7f704ebbcf402$var$svgWrapperLeftStyle,
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($31217920c6efbea3$exports))),
                                css: $ddb7f704ebbcf402$var$svgStyle,
                                alt: "Error illustration"
                            })
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            css: $ddb7f704ebbcf402$var$svgWrapperRightStyle,
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($31217920c6efbea3$exports))),
                                css: $ddb7f704ebbcf402$var$svgStyle,
                                alt: "Error illustration"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h1", {
                    css: $ddb7f704ebbcf402$var$headerStyle,
                    children: "Oops, something went missing!"
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                    css: $ddb7f704ebbcf402$var$bodyTextStyle,
                    children: isAccessError ? 'It seems like you are missing access. This might be because of role misalignment. Please try logging in again. If the issue persists, reach out to the MCP team for support.' : 'This might be because of role misalignment. Please try logging in again, and if the issue persists reach out to the MCP team to get support.'
                }),
                error && !isAccessError && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                    css: $ddb7f704ebbcf402$var$bodyTextStyle,
                    children: error.message
                }),
                withBackToOverviewButton && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a), {
                    to: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                        "data-transaction-name": "Back to overview from error page",
                        label: "Back to overview"
                    })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                    variant: "plain",
                    "data-transaction-name": "Log in from error page",
                    label: "Log in",
                    onClick: $ddb7f704ebbcf402$var$handleSignOut
                })
            ]
        })
    });
};
$ddb7f704ebbcf402$export$c120a0e80fd44ca6.propTypes = {
    withBackToOverviewButton: (0, $cvFNP.PropTypes).bool,
    error: (0, $cvFNP.PropTypes).object
};





var $1c94ac36cd6a17d8$exports = {};
$1c94ac36cd6a17d8$exports = $parcel$resolve("5aLgo");


const $2bf02e14d5a6fd9c$var$containerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.darkBlue.darkBlue80}, ${(0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.darkBlue.base})`,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    textAlign: 'center',
    paddingBottom: 120
});
const $2bf02e14d5a6fd9c$var$svgStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    width: 250,
    height: 250,
    alignSelf: 'flex-start',
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        width: 500,
        height: 500
    },
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        width: 700,
        height: 700
    }
});
const $2bf02e14d5a6fd9c$var$headerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size5,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size7,
    marginTop: -60,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        marginTop: -100
    },
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        marginTop: -150
    }
});
const $2bf02e14d5a6fd9c$var$bodyTextStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: 500,
    lineHeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).lineHeight.m,
    padding: `0 ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size2}px`
});
const $2bf02e14d5a6fd9c$var$contactMailLinkStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    '&:link, &:hover, &:active, &:visited': {
        color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
        textDecoration: 'underline'
    }
});
const $2bf02e14d5a6fd9c$export$a65c2c055de52e1d = ()=>{
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $2bf02e14d5a6fd9c$var$containerStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1c94ac36cd6a17d8$exports))),
                    css: $2bf02e14d5a6fd9c$var$svgStyle
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("h1", {
                    css: $2bf02e14d5a6fd9c$var$headerStyle,
                    children: "404"
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("p", {
                    css: $2bf02e14d5a6fd9c$var$bodyTextStyle,
                    children: "Page was not found."
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("a", {
                    css: $2bf02e14d5a6fd9c$var$contactMailLinkStyle,
                    href: "mailto:something@here",
                    children: "contact@person.lego.com"
                })
            ]
        })
    });
};
















const $41a51eaa02a848ea$export$538041dc783f7abd = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const navigateToAssessmentManagement = ()=>{
        history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).assessmentMgmt);
    };
    const isActive = window.location.pathname.includes((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).assessmentMgmt);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77).Item, {
        isActive: isActive,
        hasMenu: true,
        title: "Admin",
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77).Option, {
            onClick: ()=>navigateToAssessmentManagement(),
            children: "Assessment Management"
        })
    });
};





var $e5Q7j = parcelRequire("e5Q7j");

function $17660d9d147d9725$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $17660d9d147d9725$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $17660d9d147d9725$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $17660d9d147d9725$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $17660d9d147d9725$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $17660d9d147d9725$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $17660d9d147d9725$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, idx) {
        return idx !== index;
    });
}
function $17660d9d147d9725$export$fb9705de59d96855(array, item) {
    return [].concat(array, [
        item
    ]);
}
function $17660d9d147d9725$export$fe2d9b4e03920b4c(array, item) {
    return array.filter(function(eachItem) {
        return eachItem !== item;
    });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */ function $17660d9d147d9725$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */ function $17660d9d147d9725$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $17660d9d147d9725$export$c42e0e80904d519(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */ function $17660d9d147d9725$export$5f7ec48d69707ddd(array, size) {
    return array.reduce(function(rows, currentValue, index) {
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */ function $17660d9d147d9725$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find(function(item) {
            return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
        });
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter(function(item) {
        return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    }); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}
// Number assertions
function $17660d9d147d9725$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $17660d9d147d9725$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $17660d9d147d9725$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $17660d9d147d9725$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $17660d9d147d9725$export$4c0262a4f954db45(value) {
    return $17660d9d147d9725$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $17660d9d147d9725$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $17660d9d147d9725$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $17660d9d147d9725$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $17660d9d147d9725$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$17660d9d147d9725$export$43bee75e5e14138e(value);
}
function $17660d9d147d9725$export$83b788b1a3698c03(value) {
    return $17660d9d147d9725$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $17660d9d147d9725$export$e0287cc73292b477(value) {
    return value && !$17660d9d147d9725$export$83b788b1a3698c03(value);
}
function $17660d9d147d9725$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $17660d9d147d9725$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $17660d9d147d9725$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $17660d9d147d9725$export$dd1bc94b04021eeb(value) {
    if ($17660d9d147d9725$export$43bee75e5e14138e(value)) return $17660d9d147d9725$export$4c0262a4f954db45(value);
    if ($17660d9d147d9725$export$a6cdc56e425d0d0a(value)) return $17660d9d147d9725$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $17660d9d147d9725$export$a866f231438cc228 = false;
var $17660d9d147d9725$export$61cb32cff9a99948 = false;
function $17660d9d147d9725$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $17660d9d147d9725$export$4215e022093e324e(value) {
    return value && $17660d9d147d9725$export$a6cdc56e425d0d0a(value) && $17660d9d147d9725$export$a6cdc56e425d0d0a(value.target);
}
function $17660d9d147d9725$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $17660d9d147d9725$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach(function(key) {
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $17660d9d147d9725$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */ function $17660d9d147d9725$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $17660d9d147d9725$export$fc10aeed3a532e2a = function memoize(fn) {
    var cache = new WeakMap();
    var memoizedFn = function memoizedFn(obj, path, fallback, index) {
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $17660d9d147d9725$export$1bb32d0c65da6059 = $17660d9d147d9725$export$fc10aeed3a532e2a($17660d9d147d9725$export$3988ae62b71be9a3);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */ function $17660d9d147d9725$export$73b8ef55a37133c7(path, scale) {
    return $17660d9d147d9725$export$1bb32d0c65da6059(scale, path, path);
}
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */ function $17660d9d147d9725$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $17660d9d147d9725$export$2458ce75c8ef9806 = function filterUndefined(object) {
    return $17660d9d147d9725$export$3417cf6417437960(object, function(val) {
        return val !== null && val !== undefined;
    });
};
var $17660d9d147d9725$export$259b4dd69e654a7a = function objectKeys(obj) {
    return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */ var $17660d9d147d9725$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(carry, _ref) {
        var key = _ref[0], value = _ref[1];
        carry[key] = value;
        return carry;
    }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */ var $17660d9d147d9725$export$93c8e06b7014dc33 = function getCSSVar(theme, scale, value) {
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};
function $17660d9d147d9725$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $17660d9d147d9725$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var _analyzeCSSValue = $17660d9d147d9725$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
    return unitless || $17660d9d147d9725$export$7e4aa119212bc614(value) ? value + "px" : value;
}
var $17660d9d147d9725$var$sortByBreakpointValue = function sortByBreakpointValue(a, b) {
    return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var $17660d9d147d9725$var$sortBps = function sortBps(breakpoints) {
    return $17660d9d147d9725$export$5150077fc2e7c662(Object.entries(breakpoints).sort($17660d9d147d9725$var$sortByBreakpointValue));
};
function $17660d9d147d9725$var$normalize(breakpoints) {
    var sorted = $17660d9d147d9725$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $17660d9d147d9725$var$keys(breakpoints) {
    var value = Object.keys($17660d9d147d9725$var$sortBps(breakpoints));
    return new Set(value);
}
function $17660d9d147d9725$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $17660d9d147d9725$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return $17660d9d147d9725$export$7e4aa119212bc614(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function(m) {
        return "" + (parseFloat(m) + factor);
    });
}
function $17660d9d147d9725$var$queryString(min, max) {
    var query = [];
    if (min) query.push("@media screen and (min-width: " + $17660d9d147d9725$export$91c0eda1d06bf008(min) + ")");
    if (query.length > 0 && max) query.push("and");
    if (max) query.push("@media screen and (max-width: " + $17660d9d147d9725$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $17660d9d147d9725$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $17660d9d147d9725$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($17660d9d147d9725$var$sortByBreakpointValue).map(function(_ref, index, entry) {
        var _entry;
        var breakpoint = _ref[0], minW = _ref[1];
        var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [], maxW = _ref2[1];
        maxW = parseFloat(maxW) > 0 ? $17660d9d147d9725$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $17660d9d147d9725$var$queryString(null, maxW),
            minWQuery: $17660d9d147d9725$var$queryString(minW),
            minMaxQuery: $17660d9d147d9725$var$queryString(minW, maxW)
        };
    });
    var _keys = $17660d9d147d9725$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive: function isResponsive(test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every(function(key) {
                return _keys.has(key);
            });
        },
        asObject: $17660d9d147d9725$var$sortBps(breakpoints),
        asArray: $17660d9d147d9725$var$normalize(breakpoints),
        details: queries,
        media: [
            null
        ].concat(normalized.map(function(minW) {
            return $17660d9d147d9725$var$queryString(minW);
        }).slice(1)),
        toArrayValue: function toArrayValue(test) {
            if (!$17660d9d147d9725$export$a6cdc56e425d0d0a(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map(function(bp) {
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while($17660d9d147d9725$export$7475b2c64539e4cf(result) === null)result.pop();
            return result;
        },
        toObjectValue: function toObjectValue(test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce(function(acc, value, index) {
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
function $17660d9d147d9725$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $17660d9d147d9725$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$17660d9d147d9725$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $17660d9d147d9725$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $17660d9d147d9725$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $17660d9d147d9725$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $17660d9d147d9725$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $17660d9d147d9725$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $17660d9d147d9725$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $17660d9d147d9725$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $17660d9d147d9725$export$4e09c449d6c407f7 = $17660d9d147d9725$export$71594e8a50f746f4();
var $17660d9d147d9725$export$5cc3b7b83e34ade7 = function dataAttr(condition) {
    return condition ? "" : undefined;
};
var $17660d9d147d9725$export$91a6105db3d4be7b = function ariaAttr(condition) {
    return condition ? true : undefined;
};
var $17660d9d147d9725$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $17660d9d147d9725$export$cd4e5573fbe2b576(node) {
    var doc = $17660d9d147d9725$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $17660d9d147d9725$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $17660d9d147d9725$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */ function $17660d9d147d9725$export$17948c8429b9b73a(event) {
    var key = event.key, keyCode = event.keyCode;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $17660d9d147d9725$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $17660d9d147d9725$export$cd4e5573fbe2b576(target);
    return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function $17660d9d147d9725$export$189689d1febf0166(event) {
    return event.button !== 0;
}
// Really great work done by Diego Haz on this one
var $17660d9d147d9725$export$f5f22eac728522fd = function hasDisplayNone(element) {
    return window.getComputedStyle(element).display === "none";
};
var $17660d9d147d9725$export$54209d29bacd2cb9 = function hasTabIndex(element) {
    return element.hasAttribute("tabindex");
};
var $17660d9d147d9725$export$87df0ed37d24dd13 = function hasNegativeTabIndex(element) {
    return $17660d9d147d9725$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
};
function $17660d9d147d9725$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $17660d9d147d9725$export$63ed1d20cf8213cf(element) {
    return $17660d9d147d9725$export$1b3bfaa9684536aa(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $17660d9d147d9725$export$8a2eb51c14bb8899(element) {
    var doc = $17660d9d147d9725$export$1b3bfaa9684536aa(element) ? $17660d9d147d9725$export$b204af158042fbac(element) : document;
    return doc.activeElement === element;
}
function $17660d9d147d9725$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $17660d9d147d9725$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $17660d9d147d9725$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $17660d9d147d9725$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $17660d9d147d9725$export$4c063cf1350e6fed(element) {
    if (!$17660d9d147d9725$export$1b3bfaa9684536aa(element) || $17660d9d147d9725$export$ee695c13482bb5dd(element) || $17660d9d147d9725$export$30e0dc115df457ed(element)) return false;
    var localName = element.localName;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: function a() {
            return element.hasAttribute("href");
        },
        audio: function audio() {
            return element.hasAttribute("controls");
        },
        video: function video() {
            return element.hasAttribute("controls");
        }
    };
    if (localName in others) return others[localName]();
    if ($17660d9d147d9725$export$3453cc819780f652(element)) return true;
    return $17660d9d147d9725$export$54209d29bacd2cb9(element);
}
function $17660d9d147d9725$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return $17660d9d147d9725$export$1b3bfaa9684536aa(element) && $17660d9d147d9725$export$4c063cf1350e6fed(element) && !$17660d9d147d9725$export$87df0ed37d24dd13(element);
}
var $17660d9d147d9725$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $17660d9d147d9725$var$focusableElSelector = $17660d9d147d9725$var$focusableElList.join();
function $17660d9d147d9725$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($17660d9d147d9725$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter($17660d9d147d9725$export$4c063cf1350e6fed).filter(function(el) {
        return window.getComputedStyle(el).display !== "none";
    });
}
function $17660d9d147d9725$export$748138f04a69bf21(container) {
    var allFocusable = $17660d9d147d9725$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $17660d9d147d9725$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($17660d9d147d9725$var$focusableElSelector));
    var allTabbable = allFocusable.filter($17660d9d147d9725$export$bebd5a1431fec25d);
    if ($17660d9d147d9725$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $17660d9d147d9725$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbable = $17660d9d147d9725$export$f9ba66356f7359cf(container, fallbackToFocusable), first = _getAllTabbable[0];
    return first || null;
}
function $17660d9d147d9725$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $17660d9d147d9725$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $17660d9d147d9725$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $17660d9d147d9725$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($17660d9d147d9725$export$bebd5a1431fec25d) || allFocusable.find($17660d9d147d9725$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $17660d9d147d9725$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $17660d9d147d9725$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($17660d9d147d9725$export$bebd5a1431fec25d) || allFocusable.find($17660d9d147d9725$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $17660d9d147d9725$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $17660d9d147d9725$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && $17660d9d147d9725$export$1b3bfaa9684536aa(nextTabbable)) nextTabbable.focus();
}
function $17660d9d147d9725$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $17660d9d147d9725$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && $17660d9d147d9725$export$1b3bfaa9684536aa(previousTabbable)) previousTabbable.focus();
}
function $17660d9d147d9725$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $17660d9d147d9725$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($17660d9d147d9725$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}
function $17660d9d147d9725$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $17660d9d147d9725$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $17660d9d147d9725$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $17660d9d147d9725$var$_arrayLikeToArray(o, minLen);
}
function $17660d9d147d9725$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $17660d9d147d9725$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable no-nested-ternary */ function $17660d9d147d9725$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $17660d9d147d9725$export$f6e2535fb5126e54(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function $17660d9d147d9725$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some(function(fn) {
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $17660d9d147d9725$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach(function(fn) {
            fn == null || fn(arg);
        });
    };
}
var $17660d9d147d9725$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce(function(f1, f2) {
        return function() {
            return f1(f2.apply(void 0, arguments));
        };
    }, fn1);
};
function $17660d9d147d9725$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $17660d9d147d9725$export$8793edee2d425525 = function noop() {};
var $17660d9d147d9725$export$c106dd0671a0fc2d = $17660d9d147d9725$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $17660d9d147d9725$export$a866f231438cc228) console.warn(message);
    };
});
var $17660d9d147d9725$export$a3bc9b8ed74fc = $17660d9d147d9725$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $17660d9d147d9725$export$a866f231438cc228) console.error(message);
    };
});
var $17660d9d147d9725$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return function(v) {
        return fns.reduce(function(a, b) {
            return b(a);
        }, v);
    };
};
var $17660d9d147d9725$var$distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
};
var $17660d9d147d9725$var$isPoint = function isPoint(point) {
    return "x" in point && "y" in point;
};
function $17660d9d147d9725$export$9f17032d917177de(a, b) {
    if ($17660d9d147d9725$export$7e4aa119212bc614(a) && $17660d9d147d9725$export$7e4aa119212bc614(b)) return $17660d9d147d9725$var$distance1D(a, b);
    if ($17660d9d147d9725$var$isPoint(a) && $17660d9d147d9725$var$isPoint(b)) {
        var xDelta = $17660d9d147d9725$var$distance1D(a.x, b.x);
        var yDelta = $17660d9d147d9725$var$distance1D(a.y, b.y);
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
    }
    return 0;
}
function $17660d9d147d9725$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var _options = options, _options$isActive = _options.isActive, isActive = _options$isActive === void 0 ? $17660d9d147d9725$export$8a2eb51c14bb8899 : _options$isActive, nextTick = _options.nextTick, _options$preventScrol = _options.preventScroll, preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol, _options$selectTextIf = _options.selectTextIfInput, selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            $17660d9d147d9725$export$c106dd0671a0fc2d({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($17660d9d147d9725$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $17660d9d147d9725$var$getScrollableElements(element);
                $17660d9d147d9725$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ($17660d9d147d9725$export$63ed1d20cf8213cf(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $17660d9d147d9725$var$supportsPreventScrollCached = null;
function $17660d9d147d9725$var$supportsPreventScroll() {
    if ($17660d9d147d9725$var$supportsPreventScrollCached == null) {
        $17660d9d147d9725$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $17660d9d147d9725$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $17660d9d147d9725$var$supportsPreventScrollCached;
}
function $17660d9d147d9725$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = $17660d9d147d9725$export$b204af158042fbac(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $17660d9d147d9725$var$restoreScrollPosition(scrollableElements) {
    for(var _iterator = $17660d9d147d9725$var$_createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, element = _step$value.element, scrollTop = _step$value.scrollTop, scrollLeft = _step$value.scrollLeft;
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $17660d9d147d9725$export$bffa455ba8c619a6(target, maxDepth) {
    if (maxDepth === void 0) maxDepth = Infinity;
    if (!$17660d9d147d9725$export$a6cdc56e425d0d0a(target) && !Array.isArray(target) || !maxDepth) return target;
    return Object.entries(target).reduce(function(result, _ref) {
        var key = _ref[0], value = _ref[1];
        if ($17660d9d147d9725$export$a6cdc56e425d0d0a(value) || $17660d9d147d9725$export$43bee75e5e14138e(value)) Object.entries($17660d9d147d9725$export$bffa455ba8c619a6(value, maxDepth - 1)).forEach(function(_ref2) {
            var childKey = _ref2[0], childValue = _ref2[1];
            // e.g. gray.500
            result[key + "." + childKey] = childValue;
        });
        else // e.g. transparent
        result[key] = value;
        return result;
    }, {});
}
/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $17660d9d147d9725$export$1f16c1e83f5de19d(options) {
    var hasBeenSelected = options.hasBeenSelected, isLazy = options.isLazy, isSelected = options.isSelected, _options$lazyBehavior = options.lazyBehavior, lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}
var $17660d9d147d9725$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $17660d9d147d9725$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $17660d9d147d9725$var$toNumber(value) {
    var num = parseFloat(value);
    return $17660d9d147d9725$export$3f283ac14831e759(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */ function $17660d9d147d9725$export$3e91a10e66078270(value, precision) {
    var nextValue = $17660d9d147d9725$var$toNumber(value);
    var scaleFactor = Math.pow(10, precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */ function $17660d9d147d9725$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */ function $17660d9d147d9725$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */ function $17660d9d147d9725$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */ function $17660d9d147d9725$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $17660d9d147d9725$export$a42544f265f8403(step);
    return $17660d9d147d9725$export$3e91a10e66078270(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */ function $17660d9d147d9725$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    $17660d9d147d9725$export$c106dd0671a0fc2d({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}
function $17660d9d147d9725$var$_extends() {
    $17660d9d147d9725$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17660d9d147d9725$var$_extends.apply(this, arguments);
}
/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ function $17660d9d147d9725$export$764db16956f554f8(event) {
    var win = $17660d9d147d9725$export$8d16348623687f6(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $17660d9d147d9725$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $17660d9d147d9725$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var win = $17660d9d147d9725$export$8d16348623687f6(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $17660d9d147d9725$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $17660d9d147d9725$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $17660d9d147d9725$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $17660d9d147d9725$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $17660d9d147d9725$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $17660d9d147d9725$export$c4dfce035d43d1e0(event) ? $17660d9d147d9725$var$pointFromTouch(event, pointType) : $17660d9d147d9725$var$pointFromMouse(event, pointType)
    };
}
function $17660d9d147d9725$export$750e59ed656e0503(event) {
    return $17660d9d147d9725$export$12f84bb882d06e1a(event, "client");
}
var $17660d9d147d9725$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function listener(event) {
        return handler(event, $17660d9d147d9725$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $17660d9d147d9725$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $17660d9d147d9725$var$supportsPointerEvents = function supportsPointerEvents() {
    return $17660d9d147d9725$export$4e09c449d6c407f7 && window.onpointerdown === null;
};
var $17660d9d147d9725$var$supportsTouchEvents = function supportsTouchEvents() {
    return $17660d9d147d9725$export$4e09c449d6c407f7 && window.ontouchstart === null;
};
var $17660d9d147d9725$var$supportsMouseEvents = function supportsMouseEvents() {
    return $17660d9d147d9725$export$4e09c449d6c407f7 && window.onmousedown === null;
};
var $17660d9d147d9725$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $17660d9d147d9725$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $17660d9d147d9725$export$9fd5832907e02451(name) {
    if ($17660d9d147d9725$var$supportsPointerEvents()) return name;
    if ($17660d9d147d9725$var$supportsTouchEvents()) return $17660d9d147d9725$var$touchEventNames[name];
    if ($17660d9d147d9725$var$supportsMouseEvents()) return $17660d9d147d9725$var$mouseEventNames[name];
    return name;
}
function $17660d9d147d9725$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return $17660d9d147d9725$export$b1d829ddf82884aa(target, $17660d9d147d9725$export$9fd5832907e02451(eventName), $17660d9d147d9725$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $17660d9d147d9725$export$d06464d6b74eedc4(event) {
    return $17660d9d147d9725$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */ /**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */ var $17660d9d147d9725$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ function PanSession(_event, handlers, threshold) {
        var _this = this;
        this.history = [];
        this.startEvent = null;
        this.lastEvent = null;
        this.lastEventInfo = null;
        this.handlers = {};
        this.removeListeners = $17660d9d147d9725$export$8793edee2d425525;
        this.threshold = 3;
        this.win = void 0;
        this.updatePoint = function() {
            if (!(_this.lastEvent && _this.lastEventInfo)) return;
            var info = $17660d9d147d9725$var$getPanInfo(_this.lastEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = $17660d9d147d9725$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= _this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var _getFrameData = (0, $74f0db85147db332$export$7244445918e670ed)(), timestamp = _getFrameData.timestamp;
            _this.history.push($17660d9d147d9725$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var _this$handlers = _this.handlers, onStart = _this$handlers.onStart, onMove = _this$handlers.onMove;
            if (!isPanStarted) {
                onStart == null || onStart(_this.lastEvent, info);
                _this.startEvent = _this.lastEvent;
            }
            onMove == null || onMove(_this.lastEvent, info);
        };
        this.onPointerMove = function(event, info) {
            _this.lastEvent = event;
            _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ($17660d9d147d9725$export$764db16956f554f8(event) && event.buttons === 0) {
                _this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.onPointerUp = function(event, info) {
            // notify pan session ended
            var panInfo = $17660d9d147d9725$var$getPanInfo(info, _this.history);
            var _this$handlers2 = _this.handlers, onEnd = _this$handlers2.onEnd, onSessionEnd = _this$handlers2.onSessionEnd;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            _this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !_this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        };
        this.win = $17660d9d147d9725$export$8d16348623687f6(_event); // If we have more than one touch, don't start detecting this gesture
        if ($17660d9d147d9725$export$d06464d6b74eedc4(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = $17660d9d147d9725$export$12f84bb882d06e1a(_event);
        var _getFrameData2 = (0, $74f0db85147db332$export$7244445918e670ed)(), _timestamp = _getFrameData2.timestamp;
        this.history = [
            $17660d9d147d9725$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var onSessionStart = handlers.onSessionStart;
        onSessionStart == null || onSessionStart(_event, $17660d9d147d9725$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = $17660d9d147d9725$export$a4627e546088548d($17660d9d147d9725$export$fcff2e64e6676b81(this.win, "pointermove", this.onPointerMove), $17660d9d147d9725$export$fcff2e64e6676b81(this.win, "pointerup", this.onPointerUp), $17660d9d147d9725$export$fcff2e64e6676b81(this.win, "pointercancel", this.onPointerUp));
    }
    var _proto = PanSession.prototype;
    _proto.updateHandlers = function updateHandlers(handlers) {
        this.handlers = handlers;
    };
    _proto.end = function end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $17660d9d147d9725$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $17660d9d147d9725$var$startPanPoint(history) {
    return history[0];
}
function $17660d9d147d9725$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $17660d9d147d9725$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $17660d9d147d9725$var$subtractPoint(info.point, $17660d9d147d9725$var$lastPanPoint(history)),
        offset: $17660d9d147d9725$var$subtractPoint(info.point, $17660d9d147d9725$var$startPanPoint(history)),
        velocity: $17660d9d147d9725$var$getVelocity(history, 0.1)
    };
}
function $17660d9d147d9725$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $17660d9d147d9725$var$toMilliseconds = function toMilliseconds(seconds) {
    return seconds * 1000;
};
function $17660d9d147d9725$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $17660d9d147d9725$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $17660d9d147d9725$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
var $17660d9d147d9725$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $17660d9d147d9725$export$eca1915781c2aaca(prop, mapper) {
    if ($17660d9d147d9725$export$43bee75e5e14138e(prop)) return prop.map(function(item) {
        if (item === null) return null;
        return mapper(item);
    });
    if ($17660d9d147d9725$export$a6cdc56e425d0d0a(prop)) return $17660d9d147d9725$export$259b4dd69e654a7a(prop).reduce(function(result, key) {
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $17660d9d147d9725$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $17660d9d147d9725$export$d07517a676ce386f;
    var result = bps.map(function(br) {
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while($17660d9d147d9725$export$7475b2c64539e4cf(result) === null)result.pop();
    return result;
}
function $17660d9d147d9725$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $17660d9d147d9725$export$d07517a676ce386f;
    var result = {};
    values.forEach(function(value, index) {
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $17660d9d147d9725$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $17660d9d147d9725$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every(function(key) {
        return bps.includes(key);
    });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */ var $17660d9d147d9725$export$4cdfc817e07de39e = function isCustomBreakpoint(maybeBreakpoint) {
    return Number.isNaN(Number(maybeBreakpoint));
};
function $17660d9d147d9725$var$getUserAgentBrowser(navigator) {
    var ua = navigator.userAgent, vendor = navigator.vendor;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $17660d9d147d9725$var$getUserAgentOS(navigator) {
    var ua = navigator.userAgent, platform = navigator.platform;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $17660d9d147d9725$export$568a7d21694b4b32(navigator) {
    var ua = navigator.userAgent;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $17660d9d147d9725$export$3070bd282ec37ea8(os) {
    if (!$17660d9d147d9725$export$4e09c449d6c407f7) return false;
    return $17660d9d147d9725$var$getUserAgentOS(window.navigator) === os;
}
function $17660d9d147d9725$export$2d31490a0c05f094(browser) {
    if (!$17660d9d147d9725$export$4e09c449d6c407f7) return false;
    return $17660d9d147d9725$var$getUserAgentBrowser(window.navigator) === browser;
}
function $17660d9d147d9725$export$8d04c8cf4d9e22d8() {
    if (!$17660d9d147d9725$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $17660d9d147d9725$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ($17660d9d147d9725$export$43bee75e5e14138e(value)) return value.map(function(item, index) {
            return inner(item, [].concat(path, [
                String(index)
            ]));
        });
        if ($17660d9d147d9725$export$a6cdc56e425d0d0a(value)) return $17660d9d147d9725$export$5150077fc2e7c662(Object.entries(value).map(function(_ref) {
            var key = _ref[0], child = _ref[1];
            return [
                key,
                inner(child, [].concat(path, [
                    key
                ]))
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}



var $denZA = parcelRequire("denZA");
var $24bc05e3cd473988$var$doc = {
    body: {
        classList: {
            add: function add() {},
            remove: function remove() {}
        }
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ""
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    }
};
var $24bc05e3cd473988$var$ssrDocument = $24bc05e3cd473988$var$doc;
var $24bc05e3cd473988$var$noop = function noop() {};
var $24bc05e3cd473988$var$win = {
    document: $24bc05e3cd473988$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: $24bc05e3cd473988$var$noop,
    removeEventListener: $24bc05e3cd473988$var$noop,
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return "";
            }
        };
    },
    matchMedia: function matchMedia() {
        return {
            matches: false,
            addListener: $24bc05e3cd473988$var$noop,
            removeListener: $24bc05e3cd473988$var$noop
        };
    },
    requestAnimationFrame: function requestAnimationFrame(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    },
    setTimeout: function setTimeout1() {
        return 0;
    },
    clearTimeout: $24bc05e3cd473988$var$noop,
    setInterval: function setInterval() {
        return 0;
    },
    clearInterval: $24bc05e3cd473988$var$noop
};
var $24bc05e3cd473988$var$ssrWindow = $24bc05e3cd473988$var$win;
var $24bc05e3cd473988$var$mockEnv = {
    window: $24bc05e3cd473988$var$ssrWindow,
    document: $24bc05e3cd473988$var$ssrDocument
};
var $24bc05e3cd473988$var$defaultEnv = (0, $17660d9d147d9725$export$4e09c449d6c407f7) ? {
    window: window,
    document: document
} : $24bc05e3cd473988$var$mockEnv;
var $24bc05e3cd473988$var$EnvironmentContext = /*#__PURE__*/ (0, $denZA.createContext)($24bc05e3cd473988$var$defaultEnv);
if (0, $17660d9d147d9725$export$a866f231438cc228) $24bc05e3cd473988$var$EnvironmentContext.displayName = "EnvironmentContext";
function $24bc05e3cd473988$export$ea7ed2425832167d() {
    return (0, $denZA.useContext)($24bc05e3cd473988$var$EnvironmentContext);
}
function $24bc05e3cd473988$export$29a4c0b32fc9db42(props) {
    var children = props.children, environmentProp = props.environment;
    var _useState = (0, $denZA.useState)(null), node = _useState[0], setNode = _useState[1];
    var context = (0, $denZA.useMemo)(function() {
        var _ref;
        var doc = node == null ? void 0 : node.ownerDocument;
        var win = node == null ? void 0 : node.ownerDocument.defaultView;
        var nodeEnv = doc ? {
            document: doc,
            window: win
        } : undefined;
        var env = (_ref = environmentProp != null ? environmentProp : nodeEnv) != null ? _ref : $24bc05e3cd473988$var$defaultEnv;
        return env;
    }, [
        node,
        environmentProp
    ]);
    var showEnvGetter = !node && !environmentProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement($24bc05e3cd473988$var$EnvironmentContext.Provider, {
        value: context
    }, children, showEnvGetter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createElement("span", {
        ref: function ref(el) {
            if (el) setNode(el);
        }
    }));
}
if (0, $17660d9d147d9725$export$a866f231438cc228) $24bc05e3cd473988$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";




var $denZA = parcelRequire("denZA");
function $b02ed1d6090fed4a$var$_extends() {
    $b02ed1d6090fed4a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b02ed1d6090fed4a$var$_extends.apply(this, arguments);
}
var $b02ed1d6090fed4a$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
/**
 * SSR: Graceful fallback for the `body` element
 */ var $b02ed1d6090fed4a$var$mockBody = {
    classList: {
        add: (0, $17660d9d147d9725$export$8793edee2d425525),
        remove: (0, $17660d9d147d9725$export$8793edee2d425525)
    }
};
var $b02ed1d6090fed4a$var$getBody = function getBody(document1) {
    return (0, $17660d9d147d9725$export$4e09c449d6c407f7) ? document1.body : $b02ed1d6090fed4a$var$mockBody;
};
/**
 * Function to add/remove class from `body` based on color mode
 */ function $b02ed1d6090fed4a$var$syncBodyClassName(isDark, document1) {
    var body = $b02ed1d6090fed4a$var$getBody(document1);
    body.classList.add(isDark ? $b02ed1d6090fed4a$var$classNames.dark : $b02ed1d6090fed4a$var$classNames.light);
    body.classList.remove(isDark ? $b02ed1d6090fed4a$var$classNames.light : $b02ed1d6090fed4a$var$classNames.dark);
}
/**
 * Check if JS media query matches the query string passed
 */ function $b02ed1d6090fed4a$var$getMediaQuery(query) {
    var mediaQueryList = window.matchMedia == null ? void 0 : window.matchMedia(query);
    if (!mediaQueryList) return undefined;
    return !!mediaQueryList.media === mediaQueryList.matches;
}
var $b02ed1d6090fed4a$var$queries = {
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)"
};
function $b02ed1d6090fed4a$var$getColorScheme(fallback) {
    var _getMediaQuery;
    var isDark = (_getMediaQuery = $b02ed1d6090fed4a$var$getMediaQuery($b02ed1d6090fed4a$var$queries.dark)) != null ? _getMediaQuery : fallback === "dark";
    return isDark ? "dark" : "light";
}
/**
 * Adds system os color mode listener, and run the callback
 * once preference changes
 */ function $b02ed1d6090fed4a$var$addListener(fn) {
    if (!("matchMedia" in window)) return 0, $17660d9d147d9725$export$8793edee2d425525;
    var mediaQueryList = window.matchMedia($b02ed1d6090fed4a$var$queries.dark);
    var listener = function listener() {
        fn(mediaQueryList.matches ? "dark" : "light", true);
    };
    mediaQueryList.addEventListener("change", listener);
    return function() {
        mediaQueryList.removeEventListener("change", listener);
    };
}
var $b02ed1d6090fed4a$var$root = {
    get: function get() {
        return document.documentElement.style.getPropertyValue("--chakra-ui-color-mode") || document.documentElement.dataset.theme;
    },
    set: function set(mode) {
        if (0, $17660d9d147d9725$export$4e09c449d6c407f7) {
            /**
       * @deprecated
       * The CSS variable `--chakra-ui-color-mode` will be removed in the next major release
       * Please use the `data-theme` attribute to determine the current color mode
       */ document.documentElement.style.setProperty("--chakra-ui-color-mode", mode);
            document.documentElement.setAttribute("data-theme", mode);
        }
    }
};
var $b02ed1d6090fed4a$var$hasSupport = function hasSupport() {
    return typeof Storage !== "undefined";
};
var $b02ed1d6090fed4a$export$7367158f2f597ab1 = "chakra-ui-color-mode";
/**
 * Simple object to handle read-write to localStorage
 */ var $b02ed1d6090fed4a$export$8e35886de8a54f45 = {
    get: function get(init) {
        if (!$b02ed1d6090fed4a$var$hasSupport()) return init;
        try {
            var _value = localStorage.getItem($b02ed1d6090fed4a$export$7367158f2f597ab1);
            return _value != null ? _value : init;
        } catch (error) {
            if (0, $17660d9d147d9725$export$a866f231438cc228) console.log(error);
            return init;
        }
    },
    set: function set(value) {
        if (!$b02ed1d6090fed4a$var$hasSupport()) return;
        try {
            localStorage.setItem($b02ed1d6090fed4a$export$7367158f2f597ab1, value);
        } catch (error) {
            if (0, $17660d9d147d9725$export$a866f231438cc228) console.log(error);
        }
    },
    type: "localStorage"
};
/**
 * Simple object to handle read-write to cookies
 */ var $b02ed1d6090fed4a$export$2e2b0158437077e3 = function cookieStorageManager(cookies) {
    if (cookies === void 0) cookies = "";
    return {
        get: function get(init) {
            var match = cookies.match(new RegExp("(^| )" + $b02ed1d6090fed4a$export$7367158f2f597ab1 + "=([^;]+)"));
            if (match) return match[2];
            return init;
        },
        set: function set(value) {
            document.cookie = $b02ed1d6090fed4a$export$7367158f2f597ab1 + "=" + value + "; max-age=31536000; path=/";
        },
        type: "cookie"
    };
};
var $b02ed1d6090fed4a$export$49ddd74a6729fdb0 = /*#__PURE__*/ $denZA.createContext({});
if (0, $17660d9d147d9725$export$a866f231438cc228) $b02ed1d6090fed4a$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
/**
 * React hook that reads from `ColorModeProvider` context
 * Returns the color mode and function to toggle it
 */ var $b02ed1d6090fed4a$export$20f3076712c8dfa = function useColorMode() {
    var context = $denZA.useContext($b02ed1d6090fed4a$export$49ddd74a6729fdb0);
    if (context === undefined) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
};
/**
 * Provides context for the color mode based on config in `theme`
 * Returns the color mode and function to toggle the color mode
 */ function $b02ed1d6090fed4a$export$7a858aa3ff83dde7(props) {
    var value = props.value, children = props.children, _props$options = props.options, useSystemColorMode = _props$options.useSystemColorMode, initialColorMode = _props$options.initialColorMode, _props$colorModeManag = props.colorModeManager, colorModeManager = _props$colorModeManag === void 0 ? $b02ed1d6090fed4a$export$8e35886de8a54f45 : _props$colorModeManag;
    var defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    /**
   * Only attempt to retrieve if we're on the server. Else this will result
   * in a hydration mismatch warning and partially invalid visuals.
   *
   * Else fallback safely to `theme.config.initialColormode` (default light)
   */ var _React$useState = $denZA.useState(colorModeManager.type === "cookie" ? colorModeManager.get(defaultColorMode) : defaultColorMode), colorMode = _React$useState[0], rawSetColorMode = _React$useState[1];
    var _useEnvironment = (0, $24bc05e3cd473988$export$ea7ed2425832167d)(), document1 = _useEnvironment.document;
    $denZA.useEffect(function() {
        /**
     * Since we cannot initially retrieve localStorage to due above mentioned
     * reasons, do so after hydration.
     *
     * Priority:
     * - if `useSystemColorMode` is true system-color will be used as default - initial
     * colormode is the fallback if system color mode isn't resolved
     *
     * - if `--chakra-ui-color-mode` is defined through e.g. `ColorModeScript` this
     * will be used
     *
     * - if `colorModeManager` = `localStorage` and a value is defined for
     * `chakra-ui-color-mode` this will be used
     *
     * - if `initialColorMode` = `system` system-color will be used as default -
     * initial colormode is the fallback if system color mode isn't resolved
     *
     * - if `initialColorMode` = `'light'|'dark'` the corresponding value will be used
     */ if ((0, $17660d9d147d9725$export$4e09c449d6c407f7) && colorModeManager.type === "localStorage") {
            var systemColorWithFallback = $b02ed1d6090fed4a$var$getColorScheme(defaultColorMode);
            if (useSystemColorMode) return rawSetColorMode(systemColorWithFallback);
            var rootGet = $b02ed1d6090fed4a$var$root.get();
            var colorManagerGet = colorModeManager.get();
            if (rootGet) return rawSetColorMode(rootGet);
            if (colorManagerGet) return rawSetColorMode(colorManagerGet);
            if (initialColorMode === "system") return rawSetColorMode(systemColorWithFallback);
            return rawSetColorMode(defaultColorMode);
        }
    }, [
        colorModeManager,
        useSystemColorMode,
        defaultColorMode,
        initialColorMode
    ]);
    $denZA.useEffect(function() {
        var isDark = colorMode === "dark";
        $b02ed1d6090fed4a$var$syncBodyClassName(isDark, document1);
        $b02ed1d6090fed4a$var$root.set(isDark ? "dark" : "light");
    }, [
        colorMode,
        document1
    ]);
    var setColorMode = $denZA.useCallback(function(value, isListenerEvent) {
        if (isListenerEvent === void 0) isListenerEvent = false;
        if (!isListenerEvent) colorModeManager.set(value);
        else if (colorModeManager.get() && !useSystemColorMode) return;
        rawSetColorMode(value);
    }, [
        colorModeManager,
        useSystemColorMode
    ]);
    var toggleColorMode = $denZA.useCallback(function() {
        setColorMode(colorMode === "light" ? "dark" : "light");
    }, [
        colorMode,
        setColorMode
    ]);
    $denZA.useEffect(function() {
        var shouldUseSystemListener = useSystemColorMode || initialColorMode === "system";
        var removeListener;
        if (shouldUseSystemListener) removeListener = $b02ed1d6090fed4a$var$addListener(setColorMode);
        return function() {
            if (removeListener && shouldUseSystemListener) removeListener();
        };
    }, [
        setColorMode,
        useSystemColorMode,
        initialColorMode
    ]); // presence of `value` indicates a controlled context
    var context = $denZA.useMemo(function() {
        return {
            colorMode: value != null ? value : colorMode,
            toggleColorMode: value ? (0, $17660d9d147d9725$export$8793edee2d425525) : toggleColorMode,
            setColorMode: value ? (0, $17660d9d147d9725$export$8793edee2d425525) : setColorMode
        };
    }, [
        colorMode,
        setColorMode,
        toggleColorMode,
        value
    ]);
    return /*#__PURE__*/ $denZA.createElement($b02ed1d6090fed4a$export$49ddd74a6729fdb0.Provider, {
        value: context
    }, children);
}
if (0, $17660d9d147d9725$export$a866f231438cc228) $b02ed1d6090fed4a$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
/**
 * Locks the color mode to `dark`, without any way to change it.
 */ var $b02ed1d6090fed4a$export$8b41b18ed1f3731e = function DarkMode(props) {
    var context = $denZA.useMemo(function() {
        return {
            colorMode: "dark",
            toggleColorMode: (0, $17660d9d147d9725$export$8793edee2d425525),
            setColorMode: (0, $17660d9d147d9725$export$8793edee2d425525)
        };
    }, []);
    return /*#__PURE__*/ $denZA.createElement($b02ed1d6090fed4a$export$49ddd74a6729fdb0.Provider, $b02ed1d6090fed4a$var$_extends({
        value: context
    }, props));
};
if (0, $17660d9d147d9725$export$a866f231438cc228) $b02ed1d6090fed4a$export$8b41b18ed1f3731e.displayName = "DarkMode";
/**
 * Locks the color mode to `light` without any way to change it.
 */ var $b02ed1d6090fed4a$export$cee2b1aa9166b2a3 = function LightMode(props) {
    var context = $denZA.useMemo(function() {
        return {
            colorMode: "light",
            toggleColorMode: (0, $17660d9d147d9725$export$8793edee2d425525),
            setColorMode: (0, $17660d9d147d9725$export$8793edee2d425525)
        };
    }, []);
    return /*#__PURE__*/ $denZA.createElement($b02ed1d6090fed4a$export$49ddd74a6729fdb0.Provider, $b02ed1d6090fed4a$var$_extends({
        value: context
    }, props));
};
if (0, $17660d9d147d9725$export$a866f231438cc228) $b02ed1d6090fed4a$export$cee2b1aa9166b2a3.displayName = "LightMode";
/**
 * Change value based on color mode.
 *
 * @param light the light mode value
 * @param dark the dark mode value
 *
 * @example
 *
 * ```js
 * const Icon = useColorModeValue(MoonIcon, SunIcon)
 * ```
 */ function $b02ed1d6090fed4a$export$d18f2ef57b0d7644(light, dark) {
    var _useColorMode = $b02ed1d6090fed4a$export$20f3076712c8dfa(), colorMode = _useColorMode.colorMode;
    return colorMode === "dark" ? dark : light;
}
function $b02ed1d6090fed4a$export$2b9643fc53d6469b(initialValue) {
    var mql = window.matchMedia("(prefers-color-scheme: dark)");
    var systemPreference = mql.matches ? "dark" : "light";
    var persistedPreference = systemPreference;
    try {
        persistedPreference = localStorage.getItem("chakra-ui-color-mode");
    } catch (error) {
        console.log("Chakra UI: localStorage is not available. Color mode persistence might not work as expected");
    }
    var colorMode;
    if (persistedPreference) colorMode = persistedPreference;
    else if (initialValue === "system") colorMode = systemPreference;
    else colorMode = initialValue != null ? initialValue : systemPreference;
    if (colorMode) {
        /**
     * Keep in sync with `root.set() {@file ./color-mode.utils.ts}
     */ document.documentElement.style.setProperty("--chakra-ui-color-mode", colorMode);
        document.documentElement.setAttribute("data-theme", colorMode);
    }
}
/**
 * Script to add to the root of your application when using localStorage,
 * to help prevent flash of color mode that can happen during page load.
 */ var $b02ed1d6090fed4a$export$7730ada0bba3cb70 = function ColorModeScript(props) {
    var _props$initialColorMo = props.initialColorMode, initialColorMode = _props$initialColorMo === void 0 ? "light" : _props$initialColorMo;
    var html = "(" + String($b02ed1d6090fed4a$export$2b9643fc53d6469b) + ")('" + initialColorMode + "')";
    return /*#__PURE__*/ $denZA.createElement("script", {
        nonce: props.nonce,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};



var $e5Q7j = parcelRequire("e5Q7j");
function $defb23c4cdf9a367$var$_extends() {
    $defb23c4cdf9a367$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $defb23c4cdf9a367$var$_extends.apply(this, arguments);
}
var $defb23c4cdf9a367$export$92f5bb613cffac78 = function tokenToCSSVar(scale, value) {
    return function(theme) {
        var valueStr = String(value);
        var key = scale ? scale + "." + valueStr : valueStr;
        return (0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    };
};
function $defb23c4cdf9a367$var$createTransform(options) {
    var scale = options.scale, transform = options.transform, compose = options.compose;
    var fn = function fn(value, theme) {
        var _transform;
        var _value = $defb23c4cdf9a367$export$92f5bb613cffac78(scale, value)(theme);
        var result = (_transform = transform == null ? void 0 : transform(_value, theme)) != null ? _transform : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
function $defb23c4cdf9a367$var$toConfig(scale, transform) {
    return function(property) {
        var result = {
            property: property,
            scale: scale
        };
        result.transform = $defb23c4cdf9a367$var$createTransform({
            scale: scale,
            transform: transform
        });
        return result;
    };
}
var $defb23c4cdf9a367$var$getRtl = function getRtl(_ref) {
    var rtl = _ref.rtl, ltr = _ref.ltr;
    return function(theme) {
        return theme.direction === "rtl" ? rtl : ltr;
    };
};
function $defb23c4cdf9a367$var$logical(options) {
    var property = options.property, scale = options.scale, transform = options.transform;
    return {
        scale: scale,
        property: $defb23c4cdf9a367$var$getRtl(property),
        transform: scale ? $defb23c4cdf9a367$var$createTransform({
            scale: scale,
            compose: transform
        }) : transform
    };
}
var $defb23c4cdf9a367$var$_spaceXTemplate, $defb23c4cdf9a367$var$_spaceYTemplate;
/**
 * The CSS transform order following the upcoming spec from CSSWG
 * translate => rotate => scale => skew
 * @see https://drafts.csswg.org/css-transforms-2/#ctm
 * @see https://www.stefanjudis.com/blog/order-in-css-transformation-transform-functions-vs-individual-transforms/
 */ var $defb23c4cdf9a367$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $defb23c4cdf9a367$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))"
    ].concat($defb23c4cdf9a367$var$transformTemplate).join(" ");
}
function $defb23c4cdf9a367$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"
    ].concat($defb23c4cdf9a367$var$transformTemplate).join(" ");
}
var $defb23c4cdf9a367$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $defb23c4cdf9a367$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $defb23c4cdf9a367$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
        "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
        "--chakra-ring-width": value,
        boxShadow: [
            "var(--chakra-ring-offset-shadow)",
            "var(--chakra-ring-shadow)",
            "var(--chakra-shadow, 0 0 #0000)"
        ].join(", ")
    };
}
var $defb23c4cdf9a367$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
var $defb23c4cdf9a367$var$owlSelector = "& > :not(style) ~ :not(style)";
var $defb23c4cdf9a367$var$spaceXTemplate = ($defb23c4cdf9a367$var$_spaceXTemplate = {}, $defb23c4cdf9a367$var$_spaceXTemplate[$defb23c4cdf9a367$var$owlSelector] = {
    marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
    marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, $defb23c4cdf9a367$var$_spaceXTemplate);
var $defb23c4cdf9a367$var$spaceYTemplate = ($defb23c4cdf9a367$var$_spaceYTemplate = {}, $defb23c4cdf9a367$var$_spaceYTemplate[$defb23c4cdf9a367$var$owlSelector] = {
    marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
    marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, $defb23c4cdf9a367$var$_spaceYTemplate);
function $defb23c4cdf9a367$var$_setPrototypeOf(o, p) {
    $defb23c4cdf9a367$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $defb23c4cdf9a367$var$_setPrototypeOf(o, p);
}
function $defb23c4cdf9a367$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $defb23c4cdf9a367$var$_setPrototypeOf(subClass, superClass);
}
function $defb23c4cdf9a367$var$_wrapRegExp() {
    $defb23c4cdf9a367$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, undefined, groups);
    };
    var _super = RegExp.prototype;
    var _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        _groups.set(_this, groups || _groups.get(re));
        return $defb23c4cdf9a367$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    $defb23c4cdf9a367$var$_inherits(BabelRegExp, RegExp);
    BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        if (result) result.groups = buildGroups(result, this);
        return result;
    };
    BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if (typeof substitution === "string") {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        } else if (typeof substitution === "function") {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                if (typeof args[args.length - 1] !== "object") {
                    args = [].slice.call(args);
                    args.push(buildGroups(args, _this));
                }
                return substitution.apply(this, args);
            });
        } else return _super[Symbol.replace].call(this, str, substitution);
    };
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            groups[name] = result[g[name]];
            return groups;
        }, Object.create(null));
    }
    return $defb23c4cdf9a367$var$_wrapRegExp.apply(this, arguments);
}
var $defb23c4cdf9a367$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $defb23c4cdf9a367$var$valueSet = new Set(Object.values($defb23c4cdf9a367$var$directionMap));
var $defb23c4cdf9a367$var$globalSet = new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $defb23c4cdf9a367$var$trimSpace = function trimSpace(str) {
    return str.trim();
};
function $defb23c4cdf9a367$var$parseGradient(value, theme) {
    var _regex$exec$groups, _regex$exec;
    if (value == null || $defb23c4cdf9a367$var$globalSet.has(value)) return value;
    var regex = /*#__PURE__*/ $defb23c4cdf9a367$var$_wrapRegExp(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
        type: 1,
        values: 2
    });
    var _ref = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {}, type = _ref.type, values = _ref.values;
    if (!type || !values) return value;
    var _type = type.includes("-gradient") ? type : type + "-gradient";
    var _values$split$map$fil = values.split(",").map($defb23c4cdf9a367$var$trimSpace).filter(Boolean), maybeDirection = _values$split$map$fil[0], stops = _values$split$map$fil.slice(1);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    var direction = maybeDirection in $defb23c4cdf9a367$var$directionMap ? $defb23c4cdf9a367$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    var _values = stops.map(function(stop) {
        // if stop is valid shorthand direction, return it
        if ($defb23c4cdf9a367$var$valueSet.has(stop)) return stop;
        var firstStop = stop.indexOf(" "); // color stop could be `red.200 20%` based on css gradient spec
        var _ref2 = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ], _color = _ref2[0], _stop = _ref2[1];
        var _stopOrFunc = $defb23c4cdf9a367$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" "); // else, get and transform the color token or css value
        var key = "colors." + _color;
        var color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color
        ].concat(Array.isArray(_stopOrFunc) ? _stopOrFunc : [
            _stopOrFunc
        ]).join(" ") : color;
    });
    return _type + "(" + _values.join(", ") + ")";
}
var $defb23c4cdf9a367$var$isCSSFunction = function isCSSFunction(value) {
    return (0, $17660d9d147d9725$export$844ec244b1367d54)(value) && value.includes("(") && value.includes(")");
};
var $defb23c4cdf9a367$var$gradientTransform = function gradientTransform(value, theme) {
    return $defb23c4cdf9a367$var$parseGradient(value, theme != null ? theme : {});
};
var $defb23c4cdf9a367$var$analyzeCSSValue = function analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $defb23c4cdf9a367$var$wrap = function wrap(str) {
    return function(value) {
        return str + "(" + value + ")";
    };
};
var $defb23c4cdf9a367$var$transformFunctions = {
    filter: function filter(value) {
        return value !== "auto" ? value : $defb23c4cdf9a367$var$filterTemplate;
    },
    backdropFilter: function backdropFilter(value) {
        return value !== "auto" ? value : $defb23c4cdf9a367$var$backdropFilterTemplate;
    },
    ring: function ring(value) {
        return $defb23c4cdf9a367$var$getRingTemplate($defb23c4cdf9a367$var$transformFunctions.px(value));
    },
    bgClip: function bgClip(value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform: function transform(value) {
        if (value === "auto") return $defb23c4cdf9a367$var$getTransformTemplate();
        if (value === "auto-gpu") return $defb23c4cdf9a367$var$getTransformGpuTemplate();
        return value;
    },
    px: function px(value) {
        if (value == null) return value;
        var _analyzeCSSValue = $defb23c4cdf9a367$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
        return unitless || (0, $17660d9d147d9725$export$7e4aa119212bc614)(value) ? value + "px" : value;
    },
    fraction: function fraction(value) {
        return !(0, $17660d9d147d9725$export$7e4aa119212bc614)(value) || value > 1 ? value : value * 100 + "%";
    },
    "float": function float(value, theme) {
        var map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree: function degree(value) {
        if ((0, $17660d9d147d9725$export$30a9abfd5fb9f5f6)(value) || value == null) return value;
        var unitless = (0, $17660d9d147d9725$export$844ec244b1367d54)(value) && !value.endsWith("deg");
        return (0, $17660d9d147d9725$export$7e4aa119212bc614)(value) || unitless ? value + "deg" : value;
    },
    gradient: $defb23c4cdf9a367$var$gradientTransform,
    blur: $defb23c4cdf9a367$var$wrap("blur"),
    opacity: $defb23c4cdf9a367$var$wrap("opacity"),
    brightness: $defb23c4cdf9a367$var$wrap("brightness"),
    contrast: $defb23c4cdf9a367$var$wrap("contrast"),
    dropShadow: $defb23c4cdf9a367$var$wrap("drop-shadow"),
    grayscale: $defb23c4cdf9a367$var$wrap("grayscale"),
    hueRotate: $defb23c4cdf9a367$var$wrap("hue-rotate"),
    invert: $defb23c4cdf9a367$var$wrap("invert"),
    saturate: $defb23c4cdf9a367$var$wrap("saturate"),
    sepia: $defb23c4cdf9a367$var$wrap("sepia"),
    bgImage: function bgImage(value) {
        if (value == null) return value;
        var prevent = $defb23c4cdf9a367$var$isCSSFunction(value) || $defb23c4cdf9a367$var$globalSet.has(value);
        return !prevent ? "url(" + value + ")" : value;
    },
    outline: function outline(value) {
        var isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection: function flexDirection(value) {
        var _flexDirectionTemplat;
        var _ref = (_flexDirectionTemplat = $defb23c4cdf9a367$var$flexDirectionTemplate[value]) != null ? _flexDirectionTemplat : {}, space = _ref.space, divide = _ref.divide;
        var result = {
            flexDirection: value
        };
        if (space) result[space] = 1;
        if (divide) result[divide] = 1;
        return result;
    }
};
var $defb23c4cdf9a367$var$t = {
    borderWidths: $defb23c4cdf9a367$var$toConfig("borderWidths"),
    borderStyles: $defb23c4cdf9a367$var$toConfig("borderStyles"),
    colors: $defb23c4cdf9a367$var$toConfig("colors"),
    borders: $defb23c4cdf9a367$var$toConfig("borders"),
    radii: $defb23c4cdf9a367$var$toConfig("radii", $defb23c4cdf9a367$var$transformFunctions.px),
    space: $defb23c4cdf9a367$var$toConfig("space", $defb23c4cdf9a367$var$transformFunctions.px),
    spaceT: $defb23c4cdf9a367$var$toConfig("space", $defb23c4cdf9a367$var$transformFunctions.px),
    degreeT: function degreeT(property) {
        return {
            property: property,
            transform: $defb23c4cdf9a367$var$transformFunctions.degree
        };
    },
    prop: function prop(property, scale, transform) {
        return $defb23c4cdf9a367$var$_extends({
            property: property,
            scale: scale
        }, scale && {
            transform: $defb23c4cdf9a367$var$createTransform({
                scale: scale,
                transform: transform
            })
        });
    },
    propT: function propT(property, transform) {
        return {
            property: property,
            transform: transform
        };
    },
    sizes: $defb23c4cdf9a367$var$toConfig("sizes", $defb23c4cdf9a367$var$transformFunctions.px),
    sizesT: $defb23c4cdf9a367$var$toConfig("sizes", $defb23c4cdf9a367$var$transformFunctions.fraction),
    shadows: $defb23c4cdf9a367$var$toConfig("shadows"),
    logical: $defb23c4cdf9a367$var$logical,
    blur: $defb23c4cdf9a367$var$toConfig("blur", $defb23c4cdf9a367$var$transformFunctions.blur)
};
var $defb23c4cdf9a367$export$8ce1fd94bee2f412 = {
    background: $defb23c4cdf9a367$var$t.colors("background"),
    backgroundColor: $defb23c4cdf9a367$var$t.colors("backgroundColor"),
    backgroundImage: $defb23c4cdf9a367$var$t.propT("backgroundImage", $defb23c4cdf9a367$var$transformFunctions.bgImage),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $defb23c4cdf9a367$var$transformFunctions.bgClip
    },
    bgSize: $defb23c4cdf9a367$var$t.prop("backgroundSize"),
    bgPosition: $defb23c4cdf9a367$var$t.prop("backgroundPosition"),
    bg: $defb23c4cdf9a367$var$t.colors("background"),
    bgColor: $defb23c4cdf9a367$var$t.colors("backgroundColor"),
    bgPos: $defb23c4cdf9a367$var$t.prop("backgroundPosition"),
    bgRepeat: $defb23c4cdf9a367$var$t.prop("backgroundRepeat"),
    bgAttachment: $defb23c4cdf9a367$var$t.prop("backgroundAttachment"),
    bgGradient: $defb23c4cdf9a367$var$t.propT("backgroundImage", $defb23c4cdf9a367$var$transformFunctions.gradient),
    bgClip: {
        transform: $defb23c4cdf9a367$var$transformFunctions.bgClip
    }
};
Object.assign($defb23c4cdf9a367$export$8ce1fd94bee2f412, {
    bgImage: $defb23c4cdf9a367$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $defb23c4cdf9a367$export$8ce1fd94bee2f412.backgroundImage
});
var $defb23c4cdf9a367$export$1edee58a52776cd9 = {
    border: $defb23c4cdf9a367$var$t.borders("border"),
    borderWidth: $defb23c4cdf9a367$var$t.borderWidths("borderWidth"),
    borderStyle: $defb23c4cdf9a367$var$t.borderStyles("borderStyle"),
    borderColor: $defb23c4cdf9a367$var$t.colors("borderColor"),
    borderRadius: $defb23c4cdf9a367$var$t.radii("borderRadius"),
    borderTop: $defb23c4cdf9a367$var$t.borders("borderTop"),
    borderBlockStart: $defb23c4cdf9a367$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $defb23c4cdf9a367$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $defb23c4cdf9a367$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $defb23c4cdf9a367$var$t.borders("borderRight"),
    borderInlineEnd: $defb23c4cdf9a367$var$t.borders("borderInlineEnd"),
    borderBottom: $defb23c4cdf9a367$var$t.borders("borderBottom"),
    borderBlockEnd: $defb23c4cdf9a367$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $defb23c4cdf9a367$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $defb23c4cdf9a367$var$t.radii("borderBottomRightRadius"),
    borderLeft: $defb23c4cdf9a367$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $defb23c4cdf9a367$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $defb23c4cdf9a367$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $defb23c4cdf9a367$var$t.borders("borderInline"),
    borderY: $defb23c4cdf9a367$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $defb23c4cdf9a367$var$t.borders("borderBlock"),
    borderTopWidth: $defb23c4cdf9a367$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $defb23c4cdf9a367$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $defb23c4cdf9a367$var$t.colors("borderTopColor"),
    borderBlockStartColor: $defb23c4cdf9a367$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $defb23c4cdf9a367$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $defb23c4cdf9a367$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $defb23c4cdf9a367$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $defb23c4cdf9a367$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $defb23c4cdf9a367$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $defb23c4cdf9a367$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $defb23c4cdf9a367$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $defb23c4cdf9a367$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $defb23c4cdf9a367$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $defb23c4cdf9a367$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $defb23c4cdf9a367$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $defb23c4cdf9a367$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $defb23c4cdf9a367$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $defb23c4cdf9a367$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $defb23c4cdf9a367$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $defb23c4cdf9a367$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $defb23c4cdf9a367$var$t.colors("borderRightColor"),
    borderInlineEndColor: $defb23c4cdf9a367$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $defb23c4cdf9a367$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $defb23c4cdf9a367$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $defb23c4cdf9a367$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $defb23c4cdf9a367$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $defb23c4cdf9a367$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $defb23c4cdf9a367$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($defb23c4cdf9a367$export$1edee58a52776cd9, {
    rounded: $defb23c4cdf9a367$export$1edee58a52776cd9.borderRadius,
    roundedTop: $defb23c4cdf9a367$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $defb23c4cdf9a367$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $defb23c4cdf9a367$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $defb23c4cdf9a367$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $defb23c4cdf9a367$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $defb23c4cdf9a367$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $defb23c4cdf9a367$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $defb23c4cdf9a367$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $defb23c4cdf9a367$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $defb23c4cdf9a367$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $defb23c4cdf9a367$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $defb23c4cdf9a367$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $defb23c4cdf9a367$export$1edee58a52776cd9.borderInlineEndStyle
});
/**
 * The prop types for border properties listed above
 */ var $defb23c4cdf9a367$export$35e9368ef982300f = {
    color: $defb23c4cdf9a367$var$t.colors("color"),
    textColor: $defb23c4cdf9a367$var$t.colors("color"),
    fill: $defb23c4cdf9a367$var$t.colors("fill"),
    stroke: $defb23c4cdf9a367$var$t.colors("stroke")
};
var $defb23c4cdf9a367$export$dc573d8a6576cdb3 = {
    boxShadow: $defb23c4cdf9a367$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $defb23c4cdf9a367$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $defb23c4cdf9a367$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($defb23c4cdf9a367$export$dc573d8a6576cdb3, {
    shadow: $defb23c4cdf9a367$export$dc573d8a6576cdb3.boxShadow
});
/**
 * Types for box and text shadow properties
 */ var $defb23c4cdf9a367$export$3dea766d36a8935f = {
    filter: {
        transform: $defb23c4cdf9a367$var$transformFunctions.filter
    },
    blur: $defb23c4cdf9a367$var$t.blur("--chakra-blur"),
    brightness: $defb23c4cdf9a367$var$t.propT("--chakra-brightness", $defb23c4cdf9a367$var$transformFunctions.brightness),
    contrast: $defb23c4cdf9a367$var$t.propT("--chakra-contrast", $defb23c4cdf9a367$var$transformFunctions.contrast),
    hueRotate: $defb23c4cdf9a367$var$t.degreeT("--chakra-hue-rotate"),
    invert: $defb23c4cdf9a367$var$t.propT("--chakra-invert", $defb23c4cdf9a367$var$transformFunctions.invert),
    saturate: $defb23c4cdf9a367$var$t.propT("--chakra-saturate", $defb23c4cdf9a367$var$transformFunctions.saturate),
    dropShadow: $defb23c4cdf9a367$var$t.propT("--chakra-drop-shadow", $defb23c4cdf9a367$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $defb23c4cdf9a367$var$transformFunctions.backdropFilter
    },
    backdropBlur: $defb23c4cdf9a367$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $defb23c4cdf9a367$var$t.propT("--chakra-backdrop-brightness", $defb23c4cdf9a367$var$transformFunctions.brightness),
    backdropContrast: $defb23c4cdf9a367$var$t.propT("--chakra-backdrop-contrast", $defb23c4cdf9a367$var$transformFunctions.contrast),
    backdropHueRotate: $defb23c4cdf9a367$var$t.degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: $defb23c4cdf9a367$var$t.propT("--chakra-backdrop-invert", $defb23c4cdf9a367$var$transformFunctions.invert),
    backdropSaturate: $defb23c4cdf9a367$var$t.propT("--chakra-backdrop-saturate", $defb23c4cdf9a367$var$transformFunctions.saturate)
};
var $defb23c4cdf9a367$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $defb23c4cdf9a367$var$transformFunctions.flexDirection
    },
    experimental_spaceX: {
        "static": $defb23c4cdf9a367$var$spaceXTemplate,
        transform: $defb23c4cdf9a367$var$createTransform({
            scale: "space",
            transform: function transform(value) {
                return value !== null ? {
                    "--chakra-space-x": value
                } : null;
            }
        })
    },
    experimental_spaceY: {
        "static": $defb23c4cdf9a367$var$spaceYTemplate,
        transform: $defb23c4cdf9a367$var$createTransform({
            scale: "space",
            transform: function transform(value) {
                return value != null ? {
                    "--chakra-space-y": value
                } : null;
            }
        })
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $defb23c4cdf9a367$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $defb23c4cdf9a367$var$t.space("gap"),
    rowGap: $defb23c4cdf9a367$var$t.space("rowGap"),
    columnGap: $defb23c4cdf9a367$var$t.space("columnGap")
};
Object.assign($defb23c4cdf9a367$export$feec61708a55c80e, {
    flexDir: $defb23c4cdf9a367$export$feec61708a55c80e.flexDirection
});
var $defb23c4cdf9a367$export$85fc379452d91af0 = {
    gridGap: $defb23c4cdf9a367$var$t.space("gridGap"),
    gridColumnGap: $defb23c4cdf9a367$var$t.space("gridColumnGap"),
    gridRowGap: $defb23c4cdf9a367$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
var $defb23c4cdf9a367$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $defb23c4cdf9a367$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $defb23c4cdf9a367$var$t.colors("outlineColor")
};
var $defb23c4cdf9a367$export$b3219800bda33a1f = {
    width: $defb23c4cdf9a367$var$t.sizesT("width"),
    inlineSize: $defb23c4cdf9a367$var$t.sizesT("inlineSize"),
    height: $defb23c4cdf9a367$var$t.sizes("height"),
    blockSize: $defb23c4cdf9a367$var$t.sizes("blockSize"),
    boxSize: $defb23c4cdf9a367$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $defb23c4cdf9a367$var$t.sizes("minWidth"),
    minInlineSize: $defb23c4cdf9a367$var$t.sizes("minInlineSize"),
    minHeight: $defb23c4cdf9a367$var$t.sizes("minHeight"),
    minBlockSize: $defb23c4cdf9a367$var$t.sizes("minBlockSize"),
    maxWidth: $defb23c4cdf9a367$var$t.sizes("maxWidth"),
    maxInlineSize: $defb23c4cdf9a367$var$t.sizes("maxInlineSize"),
    maxHeight: $defb23c4cdf9a367$var$t.sizes("maxHeight"),
    maxBlockSize: $defb23c4cdf9a367$var$t.sizes("maxBlockSize"),
    d: $defb23c4cdf9a367$var$t.prop("display"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    "float": $defb23c4cdf9a367$var$t.propT("float", $defb23c4cdf9a367$var$transformFunctions["float"]),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($defb23c4cdf9a367$export$b3219800bda33a1f, {
    w: $defb23c4cdf9a367$export$b3219800bda33a1f.width,
    h: $defb23c4cdf9a367$export$b3219800bda33a1f.height,
    minW: $defb23c4cdf9a367$export$b3219800bda33a1f.minWidth,
    maxW: $defb23c4cdf9a367$export$b3219800bda33a1f.maxWidth,
    minH: $defb23c4cdf9a367$export$b3219800bda33a1f.minHeight,
    maxH: $defb23c4cdf9a367$export$b3219800bda33a1f.maxHeight,
    overscroll: $defb23c4cdf9a367$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $defb23c4cdf9a367$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $defb23c4cdf9a367$export$b3219800bda33a1f.overscrollBehaviorY
});
/**
 * Types for layout related CSS properties
 */ var $defb23c4cdf9a367$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $defb23c4cdf9a367$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $defb23c4cdf9a367$var$t.prop("listStyleImage")
};
var $defb23c4cdf9a367$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $defb23c4cdf9a367$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $defb23c4cdf9a367$var$getWithPriority = function getWithPriority(theme, key, styles) {
    var result = {};
    var obj = (0, $17660d9d147d9725$export$1bb32d0c65da6059)(theme, key, {});
    for(var prop in obj){
        var isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $defb23c4cdf9a367$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform: function transform(value) {
            if (value === true) return $defb23c4cdf9a367$var$srOnly;
            if (value === "focusable") return $defb23c4cdf9a367$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: function transform(value, theme, styles) {
            return $defb23c4cdf9a367$var$getWithPriority(theme, "layerStyles." + value, styles);
        }
    },
    textStyle: {
        processResult: true,
        transform: function transform(value, theme, styles) {
            return $defb23c4cdf9a367$var$getWithPriority(theme, "textStyles." + value, styles);
        }
    },
    apply: {
        processResult: true,
        transform: function transform(value, theme, styles) {
            return $defb23c4cdf9a367$var$getWithPriority(theme, value, styles);
        }
    }
};
var $defb23c4cdf9a367$export$5880b8b5730aff45 = {
    position: true,
    pos: $defb23c4cdf9a367$var$t.prop("position"),
    zIndex: $defb23c4cdf9a367$var$t.prop("zIndex", "zIndices"),
    inset: $defb23c4cdf9a367$var$t.spaceT("inset"),
    insetX: $defb23c4cdf9a367$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $defb23c4cdf9a367$var$t.spaceT("insetInline"),
    insetY: $defb23c4cdf9a367$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $defb23c4cdf9a367$var$t.spaceT("insetBlock"),
    top: $defb23c4cdf9a367$var$t.spaceT("top"),
    insetBlockStart: $defb23c4cdf9a367$var$t.spaceT("insetBlockStart"),
    bottom: $defb23c4cdf9a367$var$t.spaceT("bottom"),
    insetBlockEnd: $defb23c4cdf9a367$var$t.spaceT("insetBlockEnd"),
    left: $defb23c4cdf9a367$var$t.spaceT("left"),
    insetInlineStart: $defb23c4cdf9a367$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $defb23c4cdf9a367$var$t.spaceT("right"),
    insetInlineEnd: $defb23c4cdf9a367$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($defb23c4cdf9a367$export$5880b8b5730aff45, {
    insetStart: $defb23c4cdf9a367$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $defb23c4cdf9a367$export$5880b8b5730aff45.insetInlineEnd
});
/**
 * Types for position CSS properties
 */ /**
 * The parser configuration for common outline properties
 */ var $defb23c4cdf9a367$export$e7d0da6968da5dd = {
    ring: {
        transform: $defb23c4cdf9a367$var$transformFunctions.ring
    },
    ringColor: $defb23c4cdf9a367$var$t.colors("--chakra-ring-color"),
    ringOffset: $defb23c4cdf9a367$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $defb23c4cdf9a367$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $defb23c4cdf9a367$var$t.prop("--chakra-ring-inset")
};
var $defb23c4cdf9a367$export$a941ed4b947d12f8 = {
    margin: $defb23c4cdf9a367$var$t.spaceT("margin"),
    marginTop: $defb23c4cdf9a367$var$t.spaceT("marginTop"),
    marginBlockStart: $defb23c4cdf9a367$var$t.spaceT("marginBlockStart"),
    marginRight: $defb23c4cdf9a367$var$t.spaceT("marginRight"),
    marginInlineEnd: $defb23c4cdf9a367$var$t.spaceT("marginInlineEnd"),
    marginBottom: $defb23c4cdf9a367$var$t.spaceT("marginBottom"),
    marginBlockEnd: $defb23c4cdf9a367$var$t.spaceT("marginBlockEnd"),
    marginLeft: $defb23c4cdf9a367$var$t.spaceT("marginLeft"),
    marginInlineStart: $defb23c4cdf9a367$var$t.spaceT("marginInlineStart"),
    marginX: $defb23c4cdf9a367$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $defb23c4cdf9a367$var$t.spaceT("marginInline"),
    marginY: $defb23c4cdf9a367$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $defb23c4cdf9a367$var$t.spaceT("marginBlock"),
    padding: $defb23c4cdf9a367$var$t.space("padding"),
    paddingTop: $defb23c4cdf9a367$var$t.space("paddingTop"),
    paddingBlockStart: $defb23c4cdf9a367$var$t.space("paddingBlockStart"),
    paddingRight: $defb23c4cdf9a367$var$t.space("paddingRight"),
    paddingBottom: $defb23c4cdf9a367$var$t.space("paddingBottom"),
    paddingBlockEnd: $defb23c4cdf9a367$var$t.space("paddingBlockEnd"),
    paddingLeft: $defb23c4cdf9a367$var$t.space("paddingLeft"),
    paddingInlineStart: $defb23c4cdf9a367$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $defb23c4cdf9a367$var$t.space("paddingInlineEnd"),
    paddingX: $defb23c4cdf9a367$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $defb23c4cdf9a367$var$t.space("paddingInline"),
    paddingY: $defb23c4cdf9a367$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $defb23c4cdf9a367$var$t.space("paddingBlock")
};
Object.assign($defb23c4cdf9a367$export$a941ed4b947d12f8, {
    m: $defb23c4cdf9a367$export$a941ed4b947d12f8.margin,
    mt: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginTop,
    mr: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginRight,
    me: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginBottom,
    ml: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginLeft,
    ms: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginInlineStart,
    mx: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginX,
    my: $defb23c4cdf9a367$export$a941ed4b947d12f8.marginY,
    p: $defb23c4cdf9a367$export$a941ed4b947d12f8.padding,
    pt: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingTop,
    py: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingY,
    px: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingX,
    pb: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingBottom,
    pl: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingLeft,
    ps: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingRight,
    pe: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $defb23c4cdf9a367$export$a941ed4b947d12f8.paddingInlineEnd
});
/**
 * Types for space related CSS properties
 */ var $defb23c4cdf9a367$export$6b7f9af9aa033040 = {
    textDecorationColor: $defb23c4cdf9a367$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $defb23c4cdf9a367$var$t.shadows("textShadow")
};
var $defb23c4cdf9a367$export$51186ad6e864892a = {
    clipPath: true,
    transform: $defb23c4cdf9a367$var$t.propT("transform", $defb23c4cdf9a367$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $defb23c4cdf9a367$var$t.spaceT("--chakra-translate-x"),
    translateY: $defb23c4cdf9a367$var$t.spaceT("--chakra-translate-y"),
    skewX: $defb23c4cdf9a367$var$t.degreeT("--chakra-skew-x"),
    skewY: $defb23c4cdf9a367$var$t.degreeT("--chakra-skew-y"),
    scaleX: $defb23c4cdf9a367$var$t.prop("--chakra-scale-x"),
    scaleY: $defb23c4cdf9a367$var$t.prop("--chakra-scale-y"),
    scale: $defb23c4cdf9a367$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $defb23c4cdf9a367$var$t.degreeT("--chakra-rotate")
};
var $defb23c4cdf9a367$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $defb23c4cdf9a367$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $defb23c4cdf9a367$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $defb23c4cdf9a367$var$t.prop("transitionTimingFunction", "transition.easing")
};
var $defb23c4cdf9a367$export$d846a084e680d8e = {
    fontFamily: $defb23c4cdf9a367$var$t.prop("fontFamily", "fonts"),
    fontSize: $defb23c4cdf9a367$var$t.prop("fontSize", "fontSizes", $defb23c4cdf9a367$var$transformFunctions.px),
    fontWeight: $defb23c4cdf9a367$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $defb23c4cdf9a367$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $defb23c4cdf9a367$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    noOfLines: {
        "static": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    },
    isTruncated: {
        transform: function transform(value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    }
};
/**
 * Types for typography related CSS properties
 */ var $defb23c4cdf9a367$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: $defb23c4cdf9a367$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $defb23c4cdf9a367$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $defb23c4cdf9a367$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $defb23c4cdf9a367$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $defb23c4cdf9a367$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $defb23c4cdf9a367$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $defb23c4cdf9a367$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: $defb23c4cdf9a367$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $defb23c4cdf9a367$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $defb23c4cdf9a367$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $defb23c4cdf9a367$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $defb23c4cdf9a367$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $defb23c4cdf9a367$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $defb23c4cdf9a367$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $defb23c4cdf9a367$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $defb23c4cdf9a367$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $defb23c4cdf9a367$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $defb23c4cdf9a367$var$_arrayLikeToArray(o, minLen);
}
function $defb23c4cdf9a367$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $defb23c4cdf9a367$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $defb23c4cdf9a367$var$state = {
    hover: function hover(str, post) {
        return str + ":hover " + post + ", " + str + "[data-hover] " + post;
    },
    focus: function focus(str, post) {
        return str + ":focus " + post + ", " + str + "[data-focus] " + post;
    },
    focusVisible: function focusVisible(str, post) {
        return str + ":focus-visible " + post;
    },
    focusWithin: function focusWithin(str, post) {
        return str + ":focus-within " + post;
    },
    active: function active(str, post) {
        return str + ":active " + post + ", " + str + "[data-active] " + post;
    },
    disabled: function disabled(str, post) {
        return str + ":disabled " + post + ", " + str + "[data-disabled] " + post;
    },
    invalid: function invalid(str, post) {
        return str + ":invalid " + post + ", " + str + "[data-invalid] " + post;
    },
    checked: function checked(str, post) {
        return str + ":checked " + post + ", " + str + "[data-checked] " + post;
    },
    indeterminate: function indeterminate(str, post) {
        return str + ":indeterminate " + post + ", " + str + "[aria-checked=mixed] " + post + ", " + str + "[data-indeterminate] " + post;
    },
    readOnly: function readOnly(str, post) {
        return str + ":read-only " + post + ", " + str + "[readonly] " + post + ", " + str + "[data-read-only] " + post;
    },
    expanded: function expanded(str, post) {
        return str + ":read-only " + post + ", " + str + "[aria-expanded=true] " + post + ", " + str + "[data-expanded] " + post;
    },
    placeholderShown: function placeholderShown(str, post) {
        return str + ":placeholder-shown " + post;
    }
};
var $defb23c4cdf9a367$var$toGroup = function toGroup(fn) {
    return $defb23c4cdf9a367$var$merge(function(v) {
        return fn(v, "&");
    }, "[role=group]", "[data-group]", ".group");
};
var $defb23c4cdf9a367$var$toPeer = function toPeer(fn) {
    return $defb23c4cdf9a367$var$merge(function(v) {
        return fn(v, "~ &");
    }, "[data-peer]", ".peer");
};
var $defb23c4cdf9a367$var$merge = function merge(fn) {
    for(var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)selectors[_key - 1] = arguments[_key];
    return selectors.map(fn).join(", ");
};
var $defb23c4cdf9a367$export$a36cf593fde2a546 = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */ _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $defb23c4cdf9a367$var$toGroup($defb23c4cdf9a367$var$state.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $defb23c4cdf9a367$var$toPeer($defb23c4cdf9a367$var$state.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &, [data-theme=dark] &, &[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &, [data-theme=light] &, &[data-theme=light]"
};
var $defb23c4cdf9a367$export$4ec9644154df43c2 = (0, $17660d9d147d9725$export$259b4dd69e654a7a)($defb23c4cdf9a367$export$a36cf593fde2a546);
var $defb23c4cdf9a367$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, $defb23c4cdf9a367$export$8ce1fd94bee2f412, $defb23c4cdf9a367$export$1edee58a52776cd9, $defb23c4cdf9a367$export$35e9368ef982300f, $defb23c4cdf9a367$export$feec61708a55c80e, $defb23c4cdf9a367$export$b3219800bda33a1f, $defb23c4cdf9a367$export$3dea766d36a8935f, $defb23c4cdf9a367$export$e7d0da6968da5dd, $defb23c4cdf9a367$export$2499a341a8256d68, $defb23c4cdf9a367$export$85fc379452d91af0, $defb23c4cdf9a367$export$36263e8f8d7ce3b1, $defb23c4cdf9a367$export$5880b8b5730aff45, $defb23c4cdf9a367$export$dc573d8a6576cdb3, $defb23c4cdf9a367$export$a941ed4b947d12f8, $defb23c4cdf9a367$export$209876d7b1ac8f3, $defb23c4cdf9a367$export$d846a084e680d8e, $defb23c4cdf9a367$export$6b7f9af9aa033040, $defb23c4cdf9a367$export$51186ad6e864892a, $defb23c4cdf9a367$export$8837f4fc672e936d, $defb23c4cdf9a367$export$66bb15e2994e6a26);
var $defb23c4cdf9a367$var$layoutSystem = Object.assign({}, $defb23c4cdf9a367$export$a941ed4b947d12f8, $defb23c4cdf9a367$export$b3219800bda33a1f, $defb23c4cdf9a367$export$feec61708a55c80e, $defb23c4cdf9a367$export$85fc379452d91af0, $defb23c4cdf9a367$export$5880b8b5730aff45);
var $defb23c4cdf9a367$export$bccb7c6ca2f4f912 = (0, $17660d9d147d9725$export$259b4dd69e654a7a)($defb23c4cdf9a367$var$layoutSystem);
var $defb23c4cdf9a367$export$332cc7004bcbb8b4 = [].concat((0, $17660d9d147d9725$export$259b4dd69e654a7a)($defb23c4cdf9a367$export$30cfa87a708babfc), $defb23c4cdf9a367$export$4ec9644154df43c2);
var $defb23c4cdf9a367$var$styleProps = $defb23c4cdf9a367$var$_extends({}, $defb23c4cdf9a367$export$30cfa87a708babfc, $defb23c4cdf9a367$export$a36cf593fde2a546);
var $defb23c4cdf9a367$export$95b76554d0cd12d6 = function isStyleProp(prop) {
    return prop in $defb23c4cdf9a367$var$styleProps;
};
/**
 * Expands an array or object syntax responsive style.
 *
 * @example
 * expandResponsive({ mx: [1, 2] })
 * // or
 * expandResponsive({ mx: { base: 1, sm: 2 } })
 *
 * // => { mx: 1, "@media(min-width:<sm>)": { mx: 2 } }
 */ var $defb23c4cdf9a367$var$expandResponsive = function expandResponsive(styles) {
    return function(theme) {
        /**
     * Before any style can be processed, the user needs to call `toCSSVar`
     * which analyzes the theme's breakpoint and appends a `__breakpoints` property
     * to the theme with more details of the breakpoints.
     *
     * To learn more, go here: packages/utils/src/responsive.ts #analyzeBreakpoints
     */ if (!theme.__breakpoints) return styles;
        var _theme$__breakpoints = theme.__breakpoints, isResponsive = _theme$__breakpoints.isResponsive, toArrayValue = _theme$__breakpoints.toArrayValue, medias = _theme$__breakpoints.media;
        var computedStyles = {};
        for(var key in styles){
            var value = (0, $17660d9d147d9725$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue; // converts the object responsive syntax to array syntax
            value = (0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            var queries = value.slice(0, medias.length).length;
            for(var index = 0; index < queries; index += 1){
                var media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
};
var $defb23c4cdf9a367$var$isCSSVariableTokenValue = function isCSSVariableTokenValue(key, value) {
    return key.startsWith("--") && (0, $17660d9d147d9725$export$844ec244b1367d54)(value) && !(0, $17660d9d147d9725$export$30a9abfd5fb9f5f6)(value);
};
var $defb23c4cdf9a367$var$resolveTokenValue = function resolveTokenValue(theme, value) {
    var _ref, _getVar2;
    if (value == null) return value;
    var getVar = function getVar(val) {
        var _theme$__cssMap, _theme$__cssMap$val;
        return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
    };
    var getValue = function getValue(val) {
        var _getVar;
        return (_getVar = getVar(val)) != null ? _getVar : val;
    };
    var valueSplit = value.split(",").map(function(v) {
        return v.trim();
    });
    var tokenValue = valueSplit[0], fallbackValue = valueSplit[1];
    value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
    return value;
};
function $defb23c4cdf9a367$export$955358618f994a11(options) {
    var _options$configs = options.configs, configs = _options$configs === void 0 ? {} : _options$configs, _options$pseudos = options.pseudos, pseudos = _options$pseudos === void 0 ? {} : _options$pseudos, theme = options.theme;
    var css = function css(stylesOrFn, nested) {
        if (nested === void 0) nested = false;
        var _styles = (0, $17660d9d147d9725$export$624e501d81f5ffce)(stylesOrFn, theme);
        var styles = $defb23c4cdf9a367$var$expandResponsive(_styles)(theme);
        var computedStyles = {};
        for(var key in styles){
            var _config$transform, _config, _config2, _config3, _config4;
            var valueOrFn = styles[key];
            /**
       * allows the user to pass functional values
       * boxShadow: theme => `0 2px 2px ${theme.colors.red}`
       */ var value = (0, $17660d9d147d9725$export$624e501d81f5ffce)(valueOrFn, theme);
            /**
       * converts pseudo shorthands to valid selector
       * "_hover" => "&:hover"
       */ if (key in pseudos) key = pseudos[key];
            /**
       * allows the user to use theme tokens in css vars
       * { --banner-height: "sizes.md" } => { --banner-height: "var(--chakra-sizes-md)" }
       *
       * You can also provide fallback values
       * { --banner-height: "sizes.no-exist, 40px" } => { --banner-height: "40px" }
       */ if ($defb23c4cdf9a367$var$isCSSVariableTokenValue(key, value)) value = $defb23c4cdf9a367$var$resolveTokenValue(theme, value);
            var config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(value)) {
                var _computedStyles$key;
                computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles[key], css(value, true));
                continue;
            }
            var rawValue = (_config$transform = (_config = config) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme, _styles)) != null ? _config$transform : value;
            /**
       * Used for `layerStyle`, `textStyle` and `apply`. After getting the
       * styles in the theme, we need to process them since they might
       * contain theme tokens.
       *
       * `processResult` is the config property we pass to `layerStyle`, `textStyle` and `apply`
       */ rawValue = (_config2 = config) != null && _config2.processResult ? css(rawValue, true) : rawValue;
            /**
       * allows us define css properties for RTL and LTR.
       *
       * const marginStart = {
       *   property: theme => theme.direction === "rtl" ? "marginRight": "marginLeft",
       * }
       */ var configProperty = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_config3 = config) == null ? void 0 : _config3.property, theme);
            if (!nested && (_config4 = config) != null && _config4["static"]) {
                var staticStyles = (0, $17660d9d147d9725$export$624e501d81f5ffce)(config["static"], theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for(var _iterator = $defb23c4cdf9a367$var$_createForOfIteratorHelperLoose(configProperty), _step; !(_step = _iterator()).done;){
                    var property = _step.value;
                    computedStyles[property] = rawValue;
                }
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css;
}
var $defb23c4cdf9a367$export$dbf350e5966cf602 = function css(styles) {
    return function(theme) {
        var cssFn = $defb23c4cdf9a367$export$955358618f994a11({
            theme: theme,
            pseudos: $defb23c4cdf9a367$export$a36cf593fde2a546,
            configs: $defb23c4cdf9a367$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
};
/**
 * Thank you @markdalgleish for this piece of art!
 */ function $defb23c4cdf9a367$var$resolveReference(operand) {
    if ((0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $defb23c4cdf9a367$var$toExpression = function toExpression(operator) {
    for(var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)operands[_key - 1] = arguments[_key];
    return operands.map($defb23c4cdf9a367$var$resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};
var $defb23c4cdf9a367$var$_add = function add() {
    for(var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)operands[_key2] = arguments[_key2];
    return "calc(" + $defb23c4cdf9a367$var$toExpression.apply(void 0, [
        "+"
    ].concat(operands)) + ")";
};
var $defb23c4cdf9a367$var$_subtract = function subtract() {
    for(var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)operands[_key3] = arguments[_key3];
    return "calc(" + $defb23c4cdf9a367$var$toExpression.apply(void 0, [
        "-"
    ].concat(operands)) + ")";
};
var $defb23c4cdf9a367$var$_multiply = function multiply() {
    for(var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)operands[_key4] = arguments[_key4];
    return "calc(" + $defb23c4cdf9a367$var$toExpression.apply(void 0, [
        "*"
    ].concat(operands)) + ")";
};
var $defb23c4cdf9a367$var$_divide = function divide() {
    for(var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)operands[_key5] = arguments[_key5];
    return "calc(" + $defb23c4cdf9a367$var$toExpression.apply(void 0, [
        "/"
    ].concat(operands)) + ")";
};
var $defb23c4cdf9a367$var$_negate = function negate(x) {
    var value = $defb23c4cdf9a367$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
    return $defb23c4cdf9a367$var$_multiply(value, -1);
};
var $defb23c4cdf9a367$export$42bfa9b2d4dad91a = Object.assign(function(x) {
    return {
        add: function add() {
            for(var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)operands[_key6] = arguments[_key6];
            return $defb23c4cdf9a367$export$42bfa9b2d4dad91a($defb23c4cdf9a367$var$_add.apply(void 0, [
                x
            ].concat(operands)));
        },
        subtract: function subtract() {
            for(var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)operands[_key7] = arguments[_key7];
            return $defb23c4cdf9a367$export$42bfa9b2d4dad91a($defb23c4cdf9a367$var$_subtract.apply(void 0, [
                x
            ].concat(operands)));
        },
        multiply: function multiply() {
            for(var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)operands[_key8] = arguments[_key8];
            return $defb23c4cdf9a367$export$42bfa9b2d4dad91a($defb23c4cdf9a367$var$_multiply.apply(void 0, [
                x
            ].concat(operands)));
        },
        divide: function divide() {
            for(var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)operands[_key9] = arguments[_key9];
            return $defb23c4cdf9a367$export$42bfa9b2d4dad91a($defb23c4cdf9a367$var$_divide.apply(void 0, [
                x
            ].concat(operands)));
        },
        negate: function negate() {
            return $defb23c4cdf9a367$export$42bfa9b2d4dad91a($defb23c4cdf9a367$var$_negate(x));
        },
        toString: function toString() {
            return x.toString();
        }
    };
}, {
    add: $defb23c4cdf9a367$var$_add,
    subtract: $defb23c4cdf9a367$var$_subtract,
    multiply: $defb23c4cdf9a367$var$_multiply,
    divide: $defb23c4cdf9a367$var$_divide,
    negate: $defb23c4cdf9a367$var$_negate
});
function $defb23c4cdf9a367$var$replaceWhiteSpace(value, replaceValue) {
    if (replaceValue === void 0) replaceValue = "-";
    return value.replace(/\s+/g, replaceValue);
}
function $defb23c4cdf9a367$var$escape(value) {
    var valueStr = $defb23c4cdf9a367$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    var isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? valueStr.replace(".", "\\.") : value;
}
function $defb23c4cdf9a367$export$9748efee331ec573(value, prefix) {
    if (prefix === void 0) prefix = "";
    return [
        prefix,
        $defb23c4cdf9a367$var$escape(value)
    ].filter(Boolean).join("-");
}
function $defb23c4cdf9a367$export$bb435e137b4b8e38(name, fallback) {
    return "var(" + $defb23c4cdf9a367$var$escape(name) + (fallback ? ", " + fallback : "") + ")";
}
function $defb23c4cdf9a367$export$3695bd65cc73dae9(value, prefix) {
    if (prefix === void 0) prefix = "";
    return "--" + $defb23c4cdf9a367$export$9748efee331ec573(value, prefix);
}
function $defb23c4cdf9a367$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    var cssVariable = $defb23c4cdf9a367$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $defb23c4cdf9a367$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
/**
 * Convert a token name to a css variable
 *
 * @example
 * tokenToCssVar('colors.red.500', 'chakra')
 * => {
 *   variable: '--chakra-colors-red-500',
 *   reference: 'var(--chakra-colors-red-500)'
 * }
 */ function $defb23c4cdf9a367$var$tokenToCssVar(token, prefix) {
    return $defb23c4cdf9a367$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), undefined, prefix);
}
function $defb23c4cdf9a367$var$createThemeVars(flatTokens, options) {
    var cssVars = {};
    var cssMap = {};
    var _loop = function _loop() {
        var _Object$entries$_i = _Object$entries[_i], token = _Object$entries$_i[0], tokenValue = _Object$entries$_i[1];
        var isSemantic = tokenValue.isSemantic, value = tokenValue.value;
        var _tokenToCssVar = $defb23c4cdf9a367$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix), variable = _tokenToCssVar.variable, reference = _tokenToCssVar.reference;
        if (!isSemantic) {
            if (token.startsWith("space")) {
                var keys = token.split(".");
                var firstKey = keys[0], referenceKeys = keys.slice(1);
                /** @example space.-4 */ var negativeLookupKey = firstKey + ".-" + referenceKeys.join(".");
                var negativeValue = $defb23c4cdf9a367$export$42bfa9b2d4dad91a.negate(value);
                var negatedReference = $defb23c4cdf9a367$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    "var": variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                "var": variable,
                varRef: reference
            };
            return "continue";
        }
        var lookupToken = function lookupToken(maybeToken) {
            var scale = String(token).split(".")[0];
            var withScale = [
                scale,
                maybeToken
            ].join(".");
            /** @example flatTokens['space.4'] === '16px' */ var resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            var _tokenToCssVar2 = $defb23c4cdf9a367$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix), reference = _tokenToCssVar2.reference;
            return reference;
        };
        var normalizedValue = (0, $17660d9d147d9725$export$a6cdc56e425d0d0a)(value) ? value : {
            "default": value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(cssVars, Object.entries(normalizedValue).reduce(function(acc, _ref) {
            var _pseudoSelectors$cond, _acc$conditionSelecto;
            var conditionAlias = _ref[0], conditionValue = _ref[1];
            var maybeReference = lookupToken(conditionValue);
            if (conditionAlias === "default") {
                acc[variable] = maybeReference;
                return acc;
            }
            /** @example { _dark: "#fff" } => { '.chakra-ui-dark': "#fff" } */ var conditionSelector = (_pseudoSelectors$cond = $defb23c4cdf9a367$export$a36cf593fde2a546 == null ? void 0 : $defb23c4cdf9a367$export$a36cf593fde2a546[conditionAlias]) != null ? _pseudoSelectors$cond : conditionAlias;
            acc[conditionSelector] = (_acc$conditionSelecto = {}, _acc$conditionSelecto[variable] = maybeReference, _acc$conditionSelecto);
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            "var": variable,
            varRef: reference
        };
    };
    for(var _i = 0, _Object$entries = Object.entries(flatTokens); _i < _Object$entries.length; _i++){
        var _ret = _loop();
        if (_ret === "continue") continue;
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
function $defb23c4cdf9a367$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $defb23c4cdf9a367$var$_excluded = [
    "__cssMap",
    "__cssVars",
    "__breakpoints"
];
var $defb23c4cdf9a367$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur"
];
function $defb23c4cdf9a367$var$extractTokens(theme) {
    var _tokens = $defb23c4cdf9a367$var$tokens;
    return (0, $17660d9d147d9725$export$357523c63a2253b9)(theme, _tokens);
}
function $defb23c4cdf9a367$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $defb23c4cdf9a367$var$omitVars(rawTheme) {
    rawTheme.__cssMap;
    rawTheme.__cssVars;
    rawTheme.__breakpoints;
    var cleanTheme = $defb23c4cdf9a367$var$_objectWithoutPropertiesLoose(rawTheme, $defb23c4cdf9a367$var$_excluded);
    return cleanTheme;
}
function $defb23c4cdf9a367$export$8f520cff3dbc4769(_ref) {
    var _flatten, _flatten2;
    var tokens = _ref.tokens, semanticTokens = _ref.semanticTokens;
    var tokenEntries = Object.entries((_flatten = (0, $17660d9d147d9725$export$bffa455ba8c619a6)(tokens)) != null ? _flatten : {}).map(function(_ref2) {
        var token = _ref2[0], value = _ref2[1];
        var enhancedToken = {
            isSemantic: false,
            value: value
        };
        return [
            token,
            enhancedToken
        ];
    });
    var semanticTokenEntries = Object.entries((_flatten2 = (0, $17660d9d147d9725$export$bffa455ba8c619a6)(semanticTokens, 1)) != null ? _flatten2 : {}).map(function(_ref3) {
        var token = _ref3[0], value = _ref3[1];
        var enhancedToken = {
            isSemantic: true,
            value: value
        };
        return [
            token,
            enhancedToken
        ];
    });
    return (0, $17660d9d147d9725$export$5150077fc2e7c662)([].concat(tokenEntries, semanticTokenEntries));
}
function $defb23c4cdf9a367$export$d4e5dc2a444c0164(rawTheme) {
    var _theme$config;
    /**
   * In the case the theme has already been converted to css-var (e.g extending the theme),
   * we can omit the computed css vars and recompute it for the extended theme.
   */ var theme = $defb23c4cdf9a367$var$omitVars(rawTheme); // omit components and breakpoints from css variable map
    var tokens = $defb23c4cdf9a367$var$extractTokens(theme);
    var semanticTokens = $defb23c4cdf9a367$var$extractSemanticTokens(theme);
    var flatTokens = $defb23c4cdf9a367$export$8f520cff3dbc4769({
        tokens: tokens,
        semanticTokens: semanticTokens
    });
    var cssVarPrefix = (_theme$config = theme.config) == null ? void 0 : _theme$config.cssVarPrefix;
    var _createThemeVars = $defb23c4cdf9a367$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    }), cssMap = _createThemeVars.cssMap, cssVars = _createThemeVars.cssVars;
    var defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: $defb23c4cdf9a367$var$_extends({}, defaultCssVars, cssVars),
        __cssMap: cssMap,
        __breakpoints: (0, $17660d9d147d9725$export$9aa97eb2b674b920)(theme.breakpoints)
    });
    return theme;
}




var $e5Q7j = parcelRequire("e5Q7j");

var $denZA = parcelRequire("denZA");



var $e5Q7j = parcelRequire("e5Q7j");

function $00baac66f147be6d$export$fbdeaa6a76694f71(array) {
    return array != null && array.length ? array[0] : undefined;
}
function $00baac66f147be6d$export$7475b2c64539e4cf(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function $00baac66f147be6d$export$a971dda06d2756f3(index, array, loop) {
    if (loop === void 0) loop = true;
    var prevIndex = $00baac66f147be6d$export$1081b7170ed6e343(index, array.length, loop);
    return array[prevIndex];
}
function $00baac66f147be6d$export$ecba5da5485e4ec5(index, array, loop) {
    if (loop === void 0) loop = true;
    var nextIndex = $00baac66f147be6d$export$c42e0e80904d519(index, array.length, 1, loop);
    return array[nextIndex];
}
function $00baac66f147be6d$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, idx) {
        return idx !== index;
    });
}
function $00baac66f147be6d$export$fb9705de59d96855(array, item) {
    return [].concat(array, [
        item
    ]);
}
function $00baac66f147be6d$export$fe2d9b4e03920b4c(array, item) {
    return array.filter(function(eachItem) {
        return eachItem !== item;
    });
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */ function $00baac66f147be6d$export$c42e0e80904d519(currentIndex, length, step, loop) {
    if (step === void 0) step = 1;
    if (loop === void 0) loop = true;
    var lastIndex = length - 1;
    if (currentIndex === -1) return step > 0 ? 0 : lastIndex;
    var nextIndex = currentIndex + step;
    if (nextIndex < 0) return loop ? lastIndex : 0;
    if (nextIndex >= length) {
        if (loop) return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param index - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */ function $00baac66f147be6d$export$1081b7170ed6e343(index, count, loop) {
    if (loop === void 0) loop = true;
    return $00baac66f147be6d$export$c42e0e80904d519(index, count, -1, loop);
}
/**
 * Converts an array into smaller chunks or groups.
 *
 * @param array the array to chunk into group
 * @param size the length of each chunk
 */ function $00baac66f147be6d$export$5f7ec48d69707ddd(array, size) {
    return array.reduce(function(rows, currentValue, index) {
        if (index % size === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
/**
 * Gets the next item based on a search string
 *
 * @param items array of items
 * @param searchString the search string
 * @param itemToString resolves an item to string
 * @param currentItem the current selected item
 */ function $00baac66f147be6d$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
     // If current item doesn't exist, find the item that matches the search string
    if (!currentItem) {
        var foundItem = items.find(function(item) {
            return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
        });
        return foundItem;
    } // Filter items for ones that match the search string (case insensitive)
    var matchingItems = items.filter(function(item) {
        return itemToString(item).toLowerCase().startsWith(searchString.toLowerCase());
    }); // If there's a match, let's get the next item to select
    if (matchingItems.length > 0) {
        var nextIndex; // If the currentItem is in the available items, we move to the next available option
        if (matchingItems.includes(currentItem)) {
            var currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        } // Else, we pick the first item in the available items
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    } // a decent fallback to the currentItem
    return currentItem;
}
// Number assertions
function $00baac66f147be6d$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $00baac66f147be6d$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $00baac66f147be6d$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions
function $00baac66f147be6d$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $00baac66f147be6d$export$4c0262a4f954db45(value) {
    return $00baac66f147be6d$export$43bee75e5e14138e(value) && value.length === 0;
} // Function assertions
function $00baac66f147be6d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
} // Generic assertions
function $00baac66f147be6d$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== undefined;
}
function $00baac66f147be6d$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === undefined;
} // Object assertions
function $00baac66f147be6d$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function") && !$00baac66f147be6d$export$43bee75e5e14138e(value);
}
function $00baac66f147be6d$export$83b788b1a3698c03(value) {
    return $00baac66f147be6d$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $00baac66f147be6d$export$e0287cc73292b477(value) {
    return value && !$00baac66f147be6d$export$83b788b1a3698c03(value);
}
function $00baac66f147be6d$export$630801d484da15df(value) {
    return value == null;
} // String assertions
function $00baac66f147be6d$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $00baac66f147be6d$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
} // Empty assertions
function $00baac66f147be6d$export$dd1bc94b04021eeb(value) {
    if ($00baac66f147be6d$export$43bee75e5e14138e(value)) return $00baac66f147be6d$export$4c0262a4f954db45(value);
    if ($00baac66f147be6d$export$a6cdc56e425d0d0a(value)) return $00baac66f147be6d$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $00baac66f147be6d$export$a866f231438cc228 = false;
var $00baac66f147be6d$export$61cb32cff9a99948 = false;
function $00baac66f147be6d$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $00baac66f147be6d$export$4215e022093e324e(value) {
    return value && $00baac66f147be6d$export$a6cdc56e425d0d0a(value) && $00baac66f147be6d$export$a6cdc56e425d0d0a(value.target);
}
function $00baac66f147be6d$export$30a06c8d3562193f(object, keys) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $00baac66f147be6d$export$357523c63a2253b9(object, keys) {
    var result = {};
    keys.forEach(function(key) {
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $00baac66f147be6d$export$65980d18b75784e2(object, keys) {
    var picked = {};
    var omitted = {};
    Object.keys(object).forEach(function(key) {
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
/**
 * Get value from a deeply nested object using a string path.
 * Memoizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param def  - the fallback value
 */ function $00baac66f147be6d$export$3988ae62b71be9a3(obj, path, fallback, index) {
    var key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
var $00baac66f147be6d$export$fc10aeed3a532e2a = function memoize(fn) {
    var cache = new WeakMap();
    var memoizedFn = function memoizedFn(obj, path, fallback, index) {
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, new Map());
        var map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        var value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $00baac66f147be6d$export$1bb32d0c65da6059 = $00baac66f147be6d$export$fc10aeed3a532e2a($00baac66f147be6d$export$3988ae62b71be9a3);
/**
 * Get value from deeply nested object, based on path
 * It returns the path value if not found in object
 *
 * @param path - the string path or value
 * @param scale - the string path or value
 */ function $00baac66f147be6d$export$73b8ef55a37133c7(path, scale) {
    return $00baac66f147be6d$export$1bb32d0c65da6059(scale, path, path);
}
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */ function $00baac66f147be6d$export$3417cf6417437960(object, fn) {
    var result = {};
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        var shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $00baac66f147be6d$export$2458ce75c8ef9806 = function filterUndefined(object) {
    return $00baac66f147be6d$export$3417cf6417437960(object, function(val) {
        return val !== null && val !== undefined;
    });
};
var $00baac66f147be6d$export$259b4dd69e654a7a = function objectKeys(obj) {
    return Object.keys(obj);
};
/**
 * Object.entries polyfill for Nodev10 compatibility
 */ var $00baac66f147be6d$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(carry, _ref) {
        var key = _ref[0], value = _ref[1];
        carry[key] = value;
        return carry;
    }, {});
};
/**
 * Get the CSS variable ref stored in the theme
 */ var $00baac66f147be6d$export$93c8e06b7014dc33 = function getCSSVar(theme, scale, value) {
    var _theme$__cssMap$$varR, _theme$__cssMap$;
    return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme.__cssMap[scale + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};
function $00baac66f147be6d$var$analyzeCSSValue(value) {
    var num = parseFloat(value.toString());
    var unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $00baac66f147be6d$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    var _analyzeCSSValue = $00baac66f147be6d$var$analyzeCSSValue(value), unitless = _analyzeCSSValue.unitless;
    return unitless || $00baac66f147be6d$export$7e4aa119212bc614(value) ? value + "px" : value;
}
var $00baac66f147be6d$var$sortByBreakpointValue = function sortByBreakpointValue(a, b) {
    return parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
};
var $00baac66f147be6d$var$sortBps = function sortBps(breakpoints) {
    return $00baac66f147be6d$export$5150077fc2e7c662(Object.entries(breakpoints).sort($00baac66f147be6d$var$sortByBreakpointValue));
};
function $00baac66f147be6d$var$normalize(breakpoints) {
    var sorted = $00baac66f147be6d$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $00baac66f147be6d$var$keys(breakpoints) {
    var value = Object.keys($00baac66f147be6d$var$sortBps(breakpoints));
    return new Set(value);
}
function $00baac66f147be6d$var$subtract(value) {
    var _px;
    if (!value) return value;
    value = (_px = $00baac66f147be6d$export$91c0eda1d06bf008(value)) != null ? _px : value;
    var factor = value.endsWith("px") ? -1 : -0.0635;
    return $00baac66f147be6d$export$7e4aa119212bc614(value) ? "" + (value + factor) : value.replace(/([0-9]+\.?[0-9]*)/, function(m) {
        return "" + (parseFloat(m) + factor);
    });
}
function $00baac66f147be6d$var$queryString(min, max) {
    var query = [
        "@media screen"
    ];
    if (min) query.push("and", "(min-width: " + $00baac66f147be6d$export$91c0eda1d06bf008(min) + ")");
    if (max) query.push("and", "(max-width: " + $00baac66f147be6d$export$91c0eda1d06bf008(max) + ")");
    return query.join(" ");
}
function $00baac66f147be6d$export$9aa97eb2b674b920(breakpoints) {
    var _breakpoints$base;
    if (!breakpoints) return null;
    breakpoints.base = (_breakpoints$base = breakpoints.base) != null ? _breakpoints$base : "0px";
    var normalized = $00baac66f147be6d$var$normalize(breakpoints);
    var queries = Object.entries(breakpoints).sort($00baac66f147be6d$var$sortByBreakpointValue).map(function(_ref, index, entry) {
        var _entry;
        var breakpoint = _ref[0], minW = _ref[1];
        var _ref2 = (_entry = entry[index + 1]) != null ? _entry : [], maxW = _ref2[1];
        maxW = parseFloat(maxW) > 0 ? $00baac66f147be6d$var$subtract(maxW) : undefined;
        return {
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $00baac66f147be6d$var$queryString(null, maxW),
            minWQuery: $00baac66f147be6d$var$queryString(minW),
            minMaxQuery: $00baac66f147be6d$var$queryString(minW, maxW)
        };
    });
    var _keys = $00baac66f147be6d$var$keys(breakpoints);
    var _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive: function isResponsive(test) {
            var keys = Object.keys(test);
            return keys.length > 0 && keys.every(function(key) {
                return _keys.has(key);
            });
        },
        asObject: $00baac66f147be6d$var$sortBps(breakpoints),
        asArray: $00baac66f147be6d$var$normalize(breakpoints),
        details: queries,
        media: [
            null
        ].concat(normalized.map(function(minW) {
            return $00baac66f147be6d$var$queryString(minW);
        }).slice(1)),
        toArrayValue: function toArrayValue(test) {
            if (!$00baac66f147be6d$export$a6cdc56e425d0d0a(test)) throw new Error("toArrayValue: value must be an object");
            var result = _keysArr.map(function(bp) {
                var _test$bp;
                return (_test$bp = test[bp]) != null ? _test$bp : null;
            });
            while($00baac66f147be6d$export$7475b2c64539e4cf(result) === null)result.pop();
            return result;
        },
        toObjectValue: function toObjectValue(test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce(function(acc, value, index) {
                var key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
function $00baac66f147be6d$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $00baac66f147be6d$export$1b3bfaa9684536aa(el) {
    var _el$ownerDocument$def;
    if (!$00baac66f147be6d$export$45a5e7f76e0caa8d(el)) return false;
    var win = (_el$ownerDocument$def = el.ownerDocument.defaultView) != null ? _el$ownerDocument$def : window;
    return el instanceof win.HTMLElement;
}
function $00baac66f147be6d$export$f21a1ffae260145a(node) {
    var _getOwnerDocument$def, _getOwnerDocument;
    return $00baac66f147be6d$export$45a5e7f76e0caa8d(node) ? (_getOwnerDocument$def = (_getOwnerDocument = $00baac66f147be6d$export$b204af158042fbac(node)) == null ? void 0 : _getOwnerDocument.defaultView) != null ? _getOwnerDocument$def : window : window;
}
function $00baac66f147be6d$export$b204af158042fbac(node) {
    var _node$ownerDocument;
    return $00baac66f147be6d$export$45a5e7f76e0caa8d(node) ? (_node$ownerDocument = node.ownerDocument) != null ? _node$ownerDocument : document : document;
}
function $00baac66f147be6d$export$8d16348623687f6(event) {
    var _view;
    return (_view = event.view) != null ? _view : window;
}
function $00baac66f147be6d$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $00baac66f147be6d$export$4e09c449d6c407f7 = $00baac66f147be6d$export$71594e8a50f746f4();
var $00baac66f147be6d$export$5cc3b7b83e34ade7 = function dataAttr(condition) {
    return condition ? "" : undefined;
};
var $00baac66f147be6d$export$91a6105db3d4be7b = function ariaAttr(condition) {
    return condition ? true : undefined;
};
var $00baac66f147be6d$export$a274e22fb40f762e = function cx() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(Boolean).join(" ");
};
function $00baac66f147be6d$export$cd4e5573fbe2b576(node) {
    var doc = $00baac66f147be6d$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $00baac66f147be6d$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $00baac66f147be6d$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Get the normalized event key across all browsers
 * @param event keyboard event
 */ function $00baac66f147be6d$export$17948c8429b9b73a(event) {
    var key = event.key, keyCode = event.keyCode;
    var isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    var eventKey = isArrowKey ? "Arrow" + key : key;
    return eventKey;
}
function $00baac66f147be6d$export$a7a83d2a1d2d9e91(event) {
    var _event$target, _event$relatedTarget;
    var target = (_event$target = event.target) != null ? _event$target : event.currentTarget;
    var activeElement = $00baac66f147be6d$export$cd4e5573fbe2b576(target);
    return (_event$relatedTarget = event.relatedTarget) != null ? _event$relatedTarget : activeElement;
}
function $00baac66f147be6d$export$189689d1febf0166(event) {
    return event.button !== 0;
}
// Really great work done by Diego Haz on this one
var $00baac66f147be6d$export$f5f22eac728522fd = function hasDisplayNone(element) {
    return window.getComputedStyle(element).display === "none";
};
var $00baac66f147be6d$export$54209d29bacd2cb9 = function hasTabIndex(element) {
    return element.hasAttribute("tabindex");
};
var $00baac66f147be6d$export$87df0ed37d24dd13 = function hasNegativeTabIndex(element) {
    return $00baac66f147be6d$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
};
function $00baac66f147be6d$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $00baac66f147be6d$export$63ed1d20cf8213cf(element) {
    return $00baac66f147be6d$export$1b3bfaa9684536aa(element) && element.tagName.toLowerCase() === "input" && "select" in element;
}
function $00baac66f147be6d$export$8a2eb51c14bb8899(element) {
    var doc = $00baac66f147be6d$export$1b3bfaa9684536aa(element) ? $00baac66f147be6d$export$b204af158042fbac(element) : document;
    return doc.activeElement === element;
}
function $00baac66f147be6d$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $00baac66f147be6d$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $00baac66f147be6d$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $00baac66f147be6d$export$3453cc819780f652(element) {
    var value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $00baac66f147be6d$export$4c063cf1350e6fed(element) {
    if (!$00baac66f147be6d$export$1b3bfaa9684536aa(element) || $00baac66f147be6d$export$ee695c13482bb5dd(element) || $00baac66f147be6d$export$30e0dc115df457ed(element)) return false;
    var localName = element.localName;
    var focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    var others = {
        a: function a() {
            return element.hasAttribute("href");
        },
        audio: function audio() {
            return element.hasAttribute("controls");
        },
        video: function video() {
            return element.hasAttribute("controls");
        }
    };
    if (localName in others) return others[localName]();
    if ($00baac66f147be6d$export$3453cc819780f652(element)) return true;
    return $00baac66f147be6d$export$54209d29bacd2cb9(element);
}
function $00baac66f147be6d$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return $00baac66f147be6d$export$1b3bfaa9684536aa(element) && $00baac66f147be6d$export$4c063cf1350e6fed(element) && !$00baac66f147be6d$export$87df0ed37d24dd13(element);
}
var $00baac66f147be6d$var$focusableElList = [
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $00baac66f147be6d$var$focusableElSelector = $00baac66f147be6d$var$focusableElList.join();
function $00baac66f147be6d$export$4ae682d253b556eb(container) {
    var focusableEls = Array.from(container.querySelectorAll($00baac66f147be6d$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter($00baac66f147be6d$export$4c063cf1350e6fed).filter(function(el) {
        return window.getComputedStyle(el).display !== "none";
    });
}
function $00baac66f147be6d$export$748138f04a69bf21(container) {
    var allFocusable = $00baac66f147be6d$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $00baac66f147be6d$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    var allFocusable = Array.from(container.querySelectorAll($00baac66f147be6d$var$focusableElSelector));
    var allTabbable = allFocusable.filter($00baac66f147be6d$export$bebd5a1431fec25d);
    if ($00baac66f147be6d$export$bebd5a1431fec25d(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $00baac66f147be6d$export$168b663469d4c75e(container, fallbackToFocusable) {
    var _getAllTabbable = $00baac66f147be6d$export$f9ba66356f7359cf(container, fallbackToFocusable), first = _getAllTabbable[0];
    return first || null;
}
function $00baac66f147be6d$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    var allTabbable = $00baac66f147be6d$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $00baac66f147be6d$export$28f33206776129a7(container, fallbackToFocusable) {
    var allFocusable = $00baac66f147be6d$export$4ae682d253b556eb(container);
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($00baac66f147be6d$export$bebd5a1431fec25d) || allFocusable.find($00baac66f147be6d$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $00baac66f147be6d$export$2e5518c3303f364a(container, fallbackToFocusable) {
    var allFocusable = $00baac66f147be6d$export$4ae682d253b556eb(container).reverse();
    var index = allFocusable.indexOf(document.activeElement);
    var slice = allFocusable.slice(index + 1);
    return slice.find($00baac66f147be6d$export$bebd5a1431fec25d) || allFocusable.find($00baac66f147be6d$export$bebd5a1431fec25d) || (fallbackToFocusable ? slice[0] : null);
}
function $00baac66f147be6d$export$97aa32237dffacc1(container, fallbackToFocusable) {
    var nextTabbable = $00baac66f147be6d$export$28f33206776129a7(container, fallbackToFocusable);
    if (nextTabbable && $00baac66f147be6d$export$1b3bfaa9684536aa(nextTabbable)) nextTabbable.focus();
}
function $00baac66f147be6d$export$745101df07bb37dc(container, fallbackToFocusable) {
    var previousTabbable = $00baac66f147be6d$export$2e5518c3303f364a(container, fallbackToFocusable);
    if (previousTabbable && $00baac66f147be6d$export$1b3bfaa9684536aa(previousTabbable)) previousTabbable.focus();
}
function $00baac66f147be6d$var$matches(element, selectors) {
    if ("matches" in element) return element.matches(selectors);
    if ("msMatchesSelector" in element) return element.msMatchesSelector(selectors);
    return element.webkitMatchesSelector(selectors);
}
function $00baac66f147be6d$export$ff7f7c97cdce86e(element, selectors) {
    if ("closest" in element) return element.closest(selectors);
    do {
        if ($00baac66f147be6d$var$matches(element, selectors)) return element;
        element = element.parentElement || element.parentNode;
    }while (element !== null && element.nodeType === 1);
    return null;
}
function $00baac66f147be6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $00baac66f147be6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $00baac66f147be6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $00baac66f147be6d$var$_arrayLikeToArray(o, minLen);
}
function $00baac66f147be6d$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $00baac66f147be6d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/* eslint-disable no-nested-ternary */ function $00baac66f147be6d$export$624e501d81f5ffce(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $00baac66f147be6d$export$f6e2535fb5126e54(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
function $00baac66f147be6d$export$5bdd3f730ec2c47e() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function func(event) {
        fns.some(function(fn) {
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $00baac66f147be6d$export$9dd9a52f2dd5b9ce() {
    for(var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fns[_key3] = arguments[_key3];
    return function mergedFn(arg) {
        fns.forEach(function(fn) {
            fn == null || fn(arg);
        });
    };
}
var $00baac66f147be6d$export$f672e0b6f7222cd7 = function compose(fn1) {
    for(var _len4 = arguments.length, fns = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fns[_key4 - 1] = arguments[_key4];
    return fns.reduce(function(f1, f2) {
        return function() {
            return f1(f2.apply(void 0, arguments));
        };
    }, fn1);
};
function $00baac66f147be6d$export$d2de3aaeafa91619(fn) {
    var result;
    return function func() {
        if (fn) {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $00baac66f147be6d$export$8793edee2d425525 = function noop() {};
var $00baac66f147be6d$export$c106dd0671a0fc2d = $00baac66f147be6d$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $00baac66f147be6d$export$a866f231438cc228) console.warn(message);
    };
});
var $00baac66f147be6d$export$a3bc9b8ed74fc = $00baac66f147be6d$export$d2de3aaeafa91619(function(options) {
    return function() {
        var condition = options.condition, message = options.message;
        if (condition && $00baac66f147be6d$export$a866f231438cc228) console.error(message);
    };
});
var $00baac66f147be6d$export$a4627e546088548d = function pipe() {
    for(var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)fns[_key6] = arguments[_key6];
    return function(v) {
        return fns.reduce(function(a, b) {
            return b(a);
        }, v);
    };
};
var $00baac66f147be6d$var$distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
};
var $00baac66f147be6d$var$isPoint = function isPoint(point) {
    return "x" in point && "y" in point;
};
function $00baac66f147be6d$export$9f17032d917177de(a, b) {
    if ($00baac66f147be6d$export$7e4aa119212bc614(a) && $00baac66f147be6d$export$7e4aa119212bc614(b)) return $00baac66f147be6d$var$distance1D(a, b);
    if ($00baac66f147be6d$var$isPoint(a) && $00baac66f147be6d$var$isPoint(b)) {
        var xDelta = $00baac66f147be6d$var$distance1D(a.x, b.x);
        var yDelta = $00baac66f147be6d$var$distance1D(a.y, b.y);
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
    }
    return 0;
}
function $00baac66f147be6d$export$d7ddd398f22d79ef(element, options) {
    if (options === void 0) options = {};
    var _options = options, _options$isActive = _options.isActive, isActive = _options$isActive === void 0 ? $00baac66f147be6d$export$8a2eb51c14bb8899 : _options$isActive, nextTick = _options.nextTick, _options$preventScrol = _options.preventScroll, preventScroll = _options$preventScrol === void 0 ? true : _options$preventScrol, _options$selectTextIf = _options.selectTextIfInput, selectTextIfInput = _options$selectTextIf === void 0 ? true : _options$selectTextIf;
    if (!element || isActive(element)) return -1;
    function triggerFocus() {
        if (!element) {
            $00baac66f147be6d$export$c106dd0671a0fc2d({
                condition: true,
                message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
            });
            return;
        }
        if ($00baac66f147be6d$var$supportsPreventScroll()) element.focus({
            preventScroll: preventScroll
        });
        else {
            element.focus();
            if (preventScroll) {
                var scrollableElements = $00baac66f147be6d$var$getScrollableElements(element);
                $00baac66f147be6d$var$restoreScrollPosition(scrollableElements);
            }
        }
        if ($00baac66f147be6d$export$63ed1d20cf8213cf(element) && selectTextIfInput) element.select();
    }
    if (nextTick) return requestAnimationFrame(triggerFocus);
    triggerFocus();
    return -1;
}
var $00baac66f147be6d$var$supportsPreventScrollCached = null;
function $00baac66f147be6d$var$supportsPreventScroll() {
    if ($00baac66f147be6d$var$supportsPreventScrollCached == null) {
        $00baac66f147be6d$var$supportsPreventScrollCached = false;
        try {
            var div = document.createElement("div");
            div.focus({
                get preventScroll () {
                    $00baac66f147be6d$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {}
    }
    return $00baac66f147be6d$var$supportsPreventScrollCached;
}
function $00baac66f147be6d$var$getScrollableElements(element) {
    var _doc$defaultView;
    var doc = $00baac66f147be6d$export$b204af158042fbac(element);
    var win = (_doc$defaultView = doc.defaultView) != null ? _doc$defaultView : window;
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = doc.scrollingElement || doc.documentElement;
    while(parent instanceof win.HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof win.HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $00baac66f147be6d$var$restoreScrollPosition(scrollableElements) {
    for(var _iterator = $00baac66f147be6d$var$_createForOfIteratorHelperLoose(scrollableElements), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, element = _step$value.element, scrollTop = _step$value.scrollTop, scrollLeft = _step$value.scrollLeft;
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}
function $00baac66f147be6d$export$bffa455ba8c619a6(target, maxDepth) {
    if (maxDepth === void 0) maxDepth = Infinity;
    if (!$00baac66f147be6d$export$a6cdc56e425d0d0a(target) && !Array.isArray(target) || !maxDepth) return target;
    return Object.entries(target).reduce(function(result, _ref) {
        var key = _ref[0], value = _ref[1];
        if ($00baac66f147be6d$export$a6cdc56e425d0d0a(value) || $00baac66f147be6d$export$43bee75e5e14138e(value)) Object.entries($00baac66f147be6d$export$bffa455ba8c619a6(value, maxDepth - 1)).forEach(function(_ref2) {
            var childKey = _ref2[0], childValue = _ref2[1];
            // e.g. gray.500
            result[key + "." + childKey] = childValue;
        });
        else // e.g. transparent
        result[key] = value;
        return result;
    }, {});
}
/**
 * Determines whether the children of a disclosure widget
 * should be rendered or not, depending on the lazy behavior.
 *
 * Used in accordion, tabs, popover, menu and other disclosure
 * widgets.
 */ function $00baac66f147be6d$export$1f16c1e83f5de19d(options) {
    var hasBeenSelected = options.hasBeenSelected, isLazy = options.isLazy, isSelected = options.isSelected, _options$lazyBehavior = options.lazyBehavior, lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior; // if not lazy, always render the disclosure's content
    if (!isLazy) return true; // if the diclosure is selected, render the disclosure's content
    if (isSelected) return true; // if the disclosure was selected but not active, keep its content active
    if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
    return false;
}
var $00baac66f147be6d$export$79f1df30fb36b5 = Number.MIN_SAFE_INTEGER || -9007199254740991;
var $00baac66f147be6d$export$ab0cdf6ed4011946 = Number.MAX_SAFE_INTEGER || 9007199254740991;
function $00baac66f147be6d$var$toNumber(value) {
    var num = parseFloat(value);
    return $00baac66f147be6d$export$3f283ac14831e759(num) ? 0 : num;
}
/**
 * Converts a value to a specific precision (or decimal points).
 *
 * Returns a string representing a number in fixed-point notation.
 *
 * @param value the value to convert
 * @param precision the precision or decimal points
 */ function $00baac66f147be6d$export$3e91a10e66078270(value, precision) {
    var nextValue = $00baac66f147be6d$var$toNumber(value);
    var scaleFactor = Math.pow(10, precision != null ? precision : 10);
    nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
    return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
/**
 * Counts the number of decimal places a number has
 *
 * @param value the decimal value to count
 */ function $00baac66f147be6d$export$a42544f265f8403(value) {
    if (!Number.isFinite(value)) return 0;
    var e = 1;
    var p = 0;
    while(Math.round(value * e) / e !== value){
        e *= 10;
        p += 1;
    }
    return p;
}
/**
 * Convert a value to percentage based on lower and upper bound values
 *
 * @param value the value in number
 * @param min the minimum value
 * @param max the maximum value
 */ function $00baac66f147be6d$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
/**
 * Calculate the value based on percentage, lower and upper bound values
 *
 * @param percent the percent value in decimals (e.g 0.6, 0.3)
 * @param min the minimum value
 * @param max the maximum value
 */ function $00baac66f147be6d$export$7a6e99933c50b5b2(percent, min, max) {
    return (max - min) * percent + min;
}
/**
 * Rounds a specific value to the next or previous step
 *
 * @param value the value to round
 * @param from the number that stepping started from
 * @param step the specified step
 */ function $00baac66f147be6d$export$3e1fe053092824a3(value, from, step) {
    var nextValue = Math.round((value - from) / step) * step + from;
    var precision = $00baac66f147be6d$export$a42544f265f8403(step);
    return $00baac66f147be6d$export$3e91a10e66078270(nextValue, precision);
}
/**
 * Clamps a value to ensure it stays within the min and max range.
 *
 * @param value the value to clamp
 * @param min the minimum value
 * @param max the maximum value
 */ function $00baac66f147be6d$export$31ee16100cde6ce2(value, min, max) {
    if (value == null) return value;
    $00baac66f147be6d$export$c106dd0671a0fc2d({
        condition: max < min,
        message: "clamp: max cannot be less than min"
    });
    return Math.min(Math.max(value, min), max);
}
function $00baac66f147be6d$var$_extends() {
    $00baac66f147be6d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $00baac66f147be6d$var$_extends.apply(this, arguments);
}
/**
 * Credit goes to `framer-motion` of this useful utilities.
 * License can be found here: https://github.com/framer/motion
 */ function $00baac66f147be6d$export$764db16956f554f8(event) {
    var win = $00baac66f147be6d$export$8d16348623687f6(event); // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof win.MouseEvent;
}
function $00baac66f147be6d$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $00baac66f147be6d$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var win = $00baac66f147be6d$export$8d16348623687f6(event);
        var isMouseEvent = event instanceof win.MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $00baac66f147be6d$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $00baac66f147be6d$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $00baac66f147be6d$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $00baac66f147be6d$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $00baac66f147be6d$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: $00baac66f147be6d$export$c4dfce035d43d1e0(event) ? $00baac66f147be6d$var$pointFromTouch(event, pointType) : $00baac66f147be6d$var$pointFromMouse(event, pointType)
    };
}
function $00baac66f147be6d$export$750e59ed656e0503(event) {
    return $00baac66f147be6d$export$12f84bb882d06e1a(event, "client");
}
var $00baac66f147be6d$export$bbdebe8fd38d1ea3 = function wrapPointerEventHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function listener(event) {
        return handler(event, $00baac66f147be6d$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $00baac66f147be6d$var$filterPrimaryPointer(listener) : listener;
}; // We check for event support via functions in case they've been mocked by a testing suite.
var $00baac66f147be6d$var$supportsPointerEvents = function supportsPointerEvents() {
    return $00baac66f147be6d$export$4e09c449d6c407f7 && window.onpointerdown === null;
};
var $00baac66f147be6d$var$supportsTouchEvents = function supportsTouchEvents() {
    return $00baac66f147be6d$export$4e09c449d6c407f7 && window.ontouchstart === null;
};
var $00baac66f147be6d$var$supportsMouseEvents = function supportsMouseEvents() {
    return $00baac66f147be6d$export$4e09c449d6c407f7 && window.onmousedown === null;
};
var $00baac66f147be6d$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $00baac66f147be6d$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $00baac66f147be6d$export$9fd5832907e02451(name) {
    if ($00baac66f147be6d$var$supportsPointerEvents()) return name;
    if ($00baac66f147be6d$var$supportsTouchEvents()) return $00baac66f147be6d$var$touchEventNames[name];
    if ($00baac66f147be6d$var$supportsMouseEvents()) return $00baac66f147be6d$var$mouseEventNames[name];
    return name;
}
function $00baac66f147be6d$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return $00baac66f147be6d$export$b1d829ddf82884aa(target, $00baac66f147be6d$export$9fd5832907e02451(eventName), $00baac66f147be6d$export$bbdebe8fd38d1ea3(handler, eventName === "pointerdown"), options);
}
function $00baac66f147be6d$export$d06464d6b74eedc4(event) {
    return $00baac66f147be6d$export$c4dfce035d43d1e0(event) && event.touches.length > 1;
}
/**
 * The event information passed to pan event handlers like `onPan`, `onPanStart`.
 *
 * It contains information about the current state of the tap gesture such as its
 * `point`, `delta`, and `offset`
 */ /**
 * @internal
 *
 * A Pan Session is recognized when the pointer is down
 * and moved in the allowed direction.
 */ var $00baac66f147be6d$export$d9c66232c9c4689c = /*#__PURE__*/ function() {
    /**
   * We use this to keep track of the `x` and `y` pan session history
   * as the pan event happens. It helps to calculate the `offset` and `delta`
   */ // The pointer event that started the pan session
    // The current pointer event for the pan session
    // The current pointer event info for the pan session
    /**
   * Minimal pan distance required before recognizing the pan.
   * @default "3px"
   */ function PanSession(_event, handlers, threshold) {
        var _this = this;
        this.history = [];
        this.startEvent = null;
        this.lastEvent = null;
        this.lastEventInfo = null;
        this.handlers = {};
        this.removeListeners = $00baac66f147be6d$export$8793edee2d425525;
        this.threshold = 3;
        this.win = void 0;
        this.updatePoint = function() {
            if (!(_this.lastEvent && _this.lastEventInfo)) return;
            var info = $00baac66f147be6d$var$getPanInfo(_this.lastEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = $00baac66f147be6d$export$9f17032d917177de(info.offset, {
                x: 0,
                y: 0
            }) >= _this.threshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var _getFrameData = (0, $74f0db85147db332$export$7244445918e670ed)(), timestamp = _getFrameData.timestamp;
            _this.history.push($00baac66f147be6d$var$_extends({}, info.point, {
                timestamp: timestamp
            }));
            var _this$handlers = _this.handlers, onStart = _this$handlers.onStart, onMove = _this$handlers.onMove;
            if (!isPanStarted) {
                onStart == null || onStart(_this.lastEvent, info);
                _this.startEvent = _this.lastEvent;
            }
            onMove == null || onMove(_this.lastEvent, info);
        };
        this.onPointerMove = function(event, info) {
            _this.lastEvent = event;
            _this.lastEventInfo = info; // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ($00baac66f147be6d$export$764db16956f554f8(event) && event.buttons === 0) {
                _this.onPointerUp(event, info);
                return;
            } // Throttle mouse move event to once per frame
            (0, $74f0db85147db332$export$2e2bcd8739ae039).update(_this.updatePoint, true);
        };
        this.onPointerUp = function(event, info) {
            // notify pan session ended
            var panInfo = $00baac66f147be6d$var$getPanInfo(info, _this.history);
            var _this$handlers2 = _this.handlers, onEnd = _this$handlers2.onEnd, onSessionEnd = _this$handlers2.onSessionEnd;
            onSessionEnd == null || onSessionEnd(event, panInfo);
            _this.end(); // if panning never started, no need to call `onEnd`
            // panning requires a pointermove of at least 3px
            if (!onEnd || !_this.startEvent) return;
            onEnd == null || onEnd(event, panInfo);
        };
        this.win = $00baac66f147be6d$export$8d16348623687f6(_event); // If we have more than one touch, don't start detecting this gesture
        if ($00baac66f147be6d$export$d06464d6b74eedc4(_event)) return;
        this.handlers = handlers;
        if (threshold) this.threshold = threshold;
         // stop default browser behavior
        _event.stopPropagation();
        _event.preventDefault(); // get and save the `pointerdown` event info in history
        // we'll use it to compute the `offset`
        var _info = $00baac66f147be6d$export$12f84bb882d06e1a(_event);
        var _getFrameData2 = (0, $74f0db85147db332$export$7244445918e670ed)(), _timestamp = _getFrameData2.timestamp;
        this.history = [
            $00baac66f147be6d$var$_extends({}, _info.point, {
                timestamp: _timestamp
            })
        ]; // notify pan session start
        var onSessionStart = handlers.onSessionStart;
        onSessionStart == null || onSessionStart(_event, $00baac66f147be6d$var$getPanInfo(_info, this.history)); // attach event listeners and return a single function to remove them all
        this.removeListeners = $00baac66f147be6d$export$a4627e546088548d($00baac66f147be6d$export$fcff2e64e6676b81(this.win, "pointermove", this.onPointerMove), $00baac66f147be6d$export$fcff2e64e6676b81(this.win, "pointerup", this.onPointerUp), $00baac66f147be6d$export$fcff2e64e6676b81(this.win, "pointercancel", this.onPointerUp));
    }
    var _proto = PanSession.prototype;
    _proto.updateHandlers = function updateHandlers(handlers) {
        this.handlers = handlers;
    };
    _proto.end = function end() {
        var _this$removeListeners;
        (_this$removeListeners = this.removeListeners) == null || _this$removeListeners.call(this);
        (0, $74f0db85147db332$export$d93e9c1fe0553512).update(this.updatePoint);
    };
    return PanSession;
}();
function $00baac66f147be6d$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $00baac66f147be6d$var$startPanPoint(history) {
    return history[0];
}
function $00baac66f147be6d$var$lastPanPoint(history) {
    return history[history.length - 1];
}
function $00baac66f147be6d$var$getPanInfo(info, history) {
    return {
        point: info.point,
        delta: $00baac66f147be6d$var$subtractPoint(info.point, $00baac66f147be6d$var$lastPanPoint(history)),
        offset: $00baac66f147be6d$var$subtractPoint(info.point, $00baac66f147be6d$var$startPanPoint(history)),
        velocity: $00baac66f147be6d$var$getVelocity(history, 0.1)
    };
}
function $00baac66f147be6d$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
var $00baac66f147be6d$var$toMilliseconds = function toMilliseconds(seconds) {
    return seconds * 1000;
};
function $00baac66f147be6d$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $00baac66f147be6d$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > $00baac66f147be6d$var$toMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
var $00baac66f147be6d$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $00baac66f147be6d$export$eca1915781c2aaca(prop, mapper) {
    if ($00baac66f147be6d$export$43bee75e5e14138e(prop)) return prop.map(function(item) {
        if (item === null) return null;
        return mapper(item);
    });
    if ($00baac66f147be6d$export$a6cdc56e425d0d0a(prop)) return $00baac66f147be6d$export$259b4dd69e654a7a(prop).reduce(function(result, key) {
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $00baac66f147be6d$export$d9dcf045f3ec145e(obj, bps) {
    if (bps === void 0) bps = $00baac66f147be6d$export$d07517a676ce386f;
    var result = bps.map(function(br) {
        var _obj$br;
        return (_obj$br = obj[br]) != null ? _obj$br : null;
    });
    while($00baac66f147be6d$export$7475b2c64539e4cf(result) === null)result.pop();
    return result;
}
function $00baac66f147be6d$export$60476530468641e7(values, bps) {
    if (bps === void 0) bps = $00baac66f147be6d$export$d07517a676ce386f;
    var result = {};
    values.forEach(function(value, index) {
        var key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $00baac66f147be6d$export$2f4b3062f5f33794(obj, bps) {
    if (bps === void 0) bps = $00baac66f147be6d$export$d07517a676ce386f;
    var keys = Object.keys(obj);
    return keys.length > 0 && keys.every(function(key) {
        return bps.includes(key);
    });
}
/**
 * since breakpoints are defined as custom properties on an array, you may
 * `Object.keys(theme.breakpoints)` to retrieve both regular numeric indices
 * and custom breakpoints as string.
 *
 * This function returns true given a custom array property.
 */ var $00baac66f147be6d$export$4cdfc817e07de39e = function isCustomBreakpoint(maybeBreakpoint) {
    return Number.isNaN(Number(maybeBreakpoint));
};
function $00baac66f147be6d$var$getUserAgentBrowser(navigator) {
    var ua = navigator.userAgent, vendor = navigator.vendor;
    var android = /(android)/i.test(ua);
    switch(true){
        case /CriOS/.test(ua):
            return "Chrome for iOS";
        case /Edg\//.test(ua):
            return "Edge";
        case android && /Silk\//.test(ua):
            return "Silk";
        case /Chrome/.test(ua) && /Google Inc/.test(vendor):
            return "Chrome";
        case /Firefox\/\d+\.\d+$/.test(ua):
            return "Firefox";
        case android:
            return "AOSP";
        case /MSIE|Trident/.test(ua):
            return "IE";
        case /Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua):
            return "Safari";
        case /AppleWebKit/.test(ua):
            return "WebKit";
        default:
            return null;
    }
}
function $00baac66f147be6d$var$getUserAgentOS(navigator) {
    var ua = navigator.userAgent, platform = navigator.platform;
    switch(true){
        case /Android/.test(ua):
            return "Android";
        case /iPhone|iPad|iPod/.test(platform):
            return "iOS";
        case /Win/.test(platform):
            return "Windows";
        case /Mac/.test(platform):
            return "Mac";
        case /CrOS/.test(ua):
            return "Chrome OS";
        case /Firefox/.test(ua):
            return "Firefox OS";
        default:
            return null;
    }
}
function $00baac66f147be6d$export$568a7d21694b4b32(navigator) {
    var ua = navigator.userAgent;
    if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua)) return "tablet";
    if (/(mobi)/i.test(ua)) return "phone";
    return "desktop";
}
function $00baac66f147be6d$export$3070bd282ec37ea8(os) {
    if (!$00baac66f147be6d$export$4e09c449d6c407f7) return false;
    return $00baac66f147be6d$var$getUserAgentOS(window.navigator) === os;
}
function $00baac66f147be6d$export$2d31490a0c05f094(browser) {
    if (!$00baac66f147be6d$export$4e09c449d6c407f7) return false;
    return $00baac66f147be6d$var$getUserAgentBrowser(window.navigator) === browser;
}
function $00baac66f147be6d$export$8d04c8cf4d9e22d8() {
    if (!$00baac66f147be6d$export$4e09c449d6c407f7) return false;
    return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}
function $00baac66f147be6d$export$915658b6215945a4(target, predicate) {
    function inner(value, path) {
        if (path === void 0) path = [];
        if ($00baac66f147be6d$export$43bee75e5e14138e(value)) return value.map(function(item, index) {
            return inner(item, [].concat(path, [
                String(index)
            ]));
        });
        if ($00baac66f147be6d$export$a6cdc56e425d0d0a(value)) return $00baac66f147be6d$export$5150077fc2e7c662(Object.entries(value).map(function(_ref) {
            var key = _ref[0], child = _ref[1];
            return [
                key,
                inner(child, [].concat(path, [
                    key
                ]))
            ];
        }));
        return predicate(value, path);
    }
    return inner(target);
}



var $denZA = parcelRequire("denZA");
/**
 * Assigns a value to a ref function or object
 *
 * @param ref the ref to assign to
 * @param value the value
 */ function $d08cb8898e601b72$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if ((0, $00baac66f147be6d$export$f6e2535fb5126e54)(ref)) {
        ref(value);
        return;
    }
    try {
        // @ts-ignore
        ref.current = value;
    } catch (error) {
        throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
    }
}
/**
 * Combine multiple React refs into a single ref function.
 * This is used mostly when you need to allow consumers forward refs to
 * internal components
 *
 * @param refs refs to assign to value to
 */ function $d08cb8898e601b72$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return function(node) {
        refs.forEach(function(ref) {
            return $d08cb8898e601b72$export$d734136a7b018efe(ref, node);
        });
    };
}
/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */ function $d08cb8898e601b72$export$fd42f52fd3ae1109(options) {
    if (options === void 0) options = {};
    var _options = options, _options$strict = _options.strict, strict = _options$strict === void 0 ? true : _options$strict, _options$errorMessage = _options.errorMessage, errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage, name = _options.name;
    var Context = /*#__PURE__*/ $denZA.createContext(undefined);
    Context.displayName = name;
    function useContext() {
        var context = $denZA.useContext(Context);
        if (!context && strict) {
            var error = new Error(errorMessage);
            error.name = "ContextError";
            Error.captureStackTrace == null || Error.captureStackTrace(error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */ function $d08cb8898e601b72$export$b2c43d7d050b2e63(children) {
    return $denZA.Children.toArray(children).filter(function(child) {
        return /*#__PURE__*/ $denZA.isValidElement(child);
    });
}



function $7266bd05a91441ea$var$_extends() {
    $7266bd05a91441ea$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7266bd05a91441ea$var$_extends.apply(this, arguments);
}
var $7266bd05a91441ea$export$d8964aec282183a3 = function ThemeProvider(props) {
    var cssVarsRoot = props.cssVarsRoot, theme = props.theme, children = props.children;
    var computedTheme = $denZA.useMemo(function() {
        return (0, $defb23c4cdf9a367$export$d4e5dc2a444c0164)(theme);
    }, [
        theme
    ]);
    return /*#__PURE__*/ $denZA.createElement((0, $b586a210f9df88c2$export$407448d2b89b1813), {
        theme: computedTheme
    }, /*#__PURE__*/ $denZA.createElement($7266bd05a91441ea$export$d767872124667db6, {
        root: cssVarsRoot
    }), children);
};
var $7266bd05a91441ea$export$d767872124667db6 = function CSSVars(_ref) {
    var _ref$root = _ref.root, root = _ref$root === void 0 ? ":host, :root" : _ref$root;
    return /*#__PURE__*/ $denZA.createElement((0, $803605a2d06b7a22$export$98f03c5d19621d70), {
        styles: function styles(theme) {
            var _ref2;
            return _ref2 = {}, _ref2[root] = theme.__cssVars, _ref2;
        }
    });
};
function $7266bd05a91441ea$export$93d4e7f90805808f() {
    var theme = $denZA.useContext((0, $b586a210f9df88c2$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}
var $7266bd05a91441ea$var$_createContext = (0, $d08cb8898e601b72$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}), $7266bd05a91441ea$export$dc4c659861f00dbe = $7266bd05a91441ea$var$_createContext[0], $7266bd05a91441ea$export$28e6b9b82ee883c = $7266bd05a91441ea$var$_createContext[1];
/**
 * Applies styles defined in `theme.styles.global` globally
 * using emotion's `Global` component
 */ var $7266bd05a91441ea$export$f05794e648629f6c = function GlobalStyle() {
    var _useColorMode = (0, $b02ed1d6090fed4a$export$20f3076712c8dfa)(), colorMode = _useColorMode.colorMode;
    return /*#__PURE__*/ $denZA.createElement((0, $803605a2d06b7a22$export$98f03c5d19621d70), {
        styles: function styles(theme) {
            var styleObjectOrFn = (0, $17660d9d147d9725$export$1bb32d0c65da6059)(theme, "styles.global");
            var globalStyles = (0, $17660d9d147d9725$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return undefined;
            var styles = (0, $defb23c4cdf9a367$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
};
/**
 * Carefully selected html elements for chakra components.
 * This is mostly for `chakra.<element>` syntax.
 */ var $7266bd05a91441ea$var$domElements = [
    "a",
    "b",
    "article",
    "aside",
    "blockquote",
    "button",
    "caption",
    "cite",
    "circle",
    "code",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hr",
    "img",
    "input",
    "kbd",
    "label",
    "li",
    "main",
    "mark",
    "nav",
    "ol",
    "p",
    "path",
    "pre",
    "q",
    "rect",
    "s",
    "svg",
    "section",
    "select",
    "strong",
    "small",
    "span",
    "sub",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "ul"
];
function $7266bd05a91441ea$export$adfcf5a5e4d17785(props) {
    return (0, $17660d9d147d9725$export$30a06c8d3562193f)(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}
function $7266bd05a91441ea$export$a513a93efd9ab8a7() {
    var colorModeResult = (0, $b02ed1d6090fed4a$export$20f3076712c8dfa)();
    var theme = $7266bd05a91441ea$export$93d4e7f90805808f();
    return $7266bd05a91441ea$var$_extends({}, colorModeResult, {
        theme: theme
    });
}
var $7266bd05a91441ea$var$resolveBreakpointValue = function resolveBreakpointValue(theme, tokenValue, fallbackValue) {
    var _ref, _getValue;
    if (tokenValue === null) return tokenValue;
    var getValue = function getValue(val) {
        var _theme$__breakpoints, _theme$__breakpoints$;
        return (_theme$__breakpoints = theme.__breakpoints) == null ? void 0 : (_theme$__breakpoints$ = _theme$__breakpoints.asArray) == null ? void 0 : _theme$__breakpoints$[val];
    };
    return (_ref = (_getValue = getValue(tokenValue)) != null ? _getValue : getValue(fallbackValue)) != null ? _ref : fallbackValue;
}; // inspired from ./css.ts : resolveTokenValue
var $7266bd05a91441ea$var$resolveTokenValue = function resolveTokenValue(theme, tokenValue, fallbackValue) {
    var _ref2, _getValue2;
    if (tokenValue == null) return tokenValue;
    var getValue = function getValue(val) {
        var _theme$__cssMap, _theme$__cssMap$val;
        return (_theme$__cssMap = theme.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.value;
    };
    return (_ref2 = (_getValue2 = getValue(tokenValue)) != null ? _getValue2 : getValue(fallbackValue)) != null ? _ref2 : fallbackValue;
};
function $7266bd05a91441ea$export$31dcd79391e423fe(scale, token, fallback) {
    var theme = $7266bd05a91441ea$export$93d4e7f90805808f();
    if (Array.isArray(token)) {
        var fallbackArr = [];
        if (fallback) fallbackArr = Array.isArray(fallback) ? fallback : [
            fallback
        ];
        return token.map(function(token, index) {
            var _fallbackArr$index2;
            if (scale === "breakpoints") {
                var _fallbackArr$index;
                return $7266bd05a91441ea$var$resolveBreakpointValue(theme, token, (_fallbackArr$index = fallbackArr[index]) != null ? _fallbackArr$index : token);
            }
            var path = scale + "." + token;
            return $7266bd05a91441ea$var$resolveTokenValue(theme, path, (_fallbackArr$index2 = fallbackArr[index]) != null ? _fallbackArr$index2 : token);
        });
    }
    if (scale === "breakpoints") return $7266bd05a91441ea$var$resolveBreakpointValue(theme, token, fallback);
    var path = scale + "." + token;
    return $7266bd05a91441ea$var$resolveTokenValue(theme, path, fallback);
}
function $7266bd05a91441ea$export$1f264be2c424fccf(themeKey, props) {
    var _theme$components, _styleConfig$defaultP;
    var _useChakra = $7266bd05a91441ea$export$a513a93efd9ab8a7(), theme = _useChakra.theme, colorMode = _useChakra.colorMode;
    var styleConfig = props.styleConfig || ((_theme$components = theme.components) == null ? void 0 : _theme$components[themeKey]);
    var defaultProps = (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {};
    var propsWithDefault = $7266bd05a91441ea$var$_extends({}, defaultProps, (0, $17660d9d147d9725$export$2458ce75c8ef9806)(props));
    var stylesRef = (0, $denZA.useRef)({});
    var mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, propsWithDefault, {
        theme: theme,
        colorMode: colorMode
    });
    var memoizedStyles = (0, $denZA.useMemo)(function() {
        if (styleConfig) {
            var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes, _styleConfig$sizes2;
            var baseStyles = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
            var variants = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
            var sizes = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$sizes = (_styleConfig$sizes2 = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes2[mergedProps.size]) != null ? _styleConfig$sizes : {}, mergedProps);
            var styles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))(baseStyles, sizes, variants);
            if (styleConfig.parts) styleConfig.parts.forEach(function(part) {
                var _styles$part;
                styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
            });
            var isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a1c31816786fd039$exports)))(stylesRef.current, styles);
            if (!isStyleEqual) stylesRef.current = styles;
        }
        return stylesRef.current;
    }, [
        styleConfig,
        mergedProps
    ]);
    return {
        styles: memoizedStyles,
        props: $7266bd05a91441ea$export$adfcf5a5e4d17785(propsWithDefault)
    };
}
function $7266bd05a91441ea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * List of props for emotion to omit from DOM.
 * It mostly consists of Chakra props
 */ var $7266bd05a91441ea$var$allPropNames = new Set([].concat((0, $defb23c4cdf9a367$export$332cc7004bcbb8b4), [
    "textStyle",
    "layerStyle",
    "apply",
    "isTruncated",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]));
/**
 * htmlWidth and htmlHeight is used in the <Image />
 * component to support the native `width` and `height` attributes
 *
 * https://github.com/chakra-ui/chakra-ui/issues/149
 */ var $7266bd05a91441ea$var$validHTMLProps = new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize"
]);
var $7266bd05a91441ea$export$3ba67b570e26eea0 = function shouldForwardProp(prop) {
    return $7266bd05a91441ea$var$validHTMLProps.has(prop) || !$7266bd05a91441ea$var$allPropNames.has(prop);
};
var $7266bd05a91441ea$var$_excluded$1 = [
    "theme",
    "css",
    "__css",
    "sx"
], $7266bd05a91441ea$var$_excluded2 = [
    "baseStyle"
];
/**
 * Style resolver function that manages how style props are merged
 * in combination with other possible ways of defining styles.
 *
 * For example, take a component defined this way:
 * ```jsx
 * <Box fontSize="24px" sx={{ fontSize: "40px" }}></Box>
 * ```
 *
 * We want to manage the priority of the styles properly to prevent unwanted
 * behaviors. Right now, the `sx` prop has the highest priority so the resolved
 * fontSize will be `40px`
 */ var $7266bd05a91441ea$export$9dba07f3d84163bb = function toCSSObject(_ref) {
    var baseStyle = _ref.baseStyle;
    return function(props) {
        props.theme;
        var cssProp = props.css, __css = props.__css, sx = props.sx, rest = $7266bd05a91441ea$var$_objectWithoutPropertiesLoose(props, $7266bd05a91441ea$var$_excluded$1);
        var styleProps = (0, $17660d9d147d9725$export$3417cf6417437960)(rest, function(_, prop) {
            return (0, $defb23c4cdf9a367$export$95b76554d0cd12d6)(prop);
        });
        var finalBaseStyle = (0, $17660d9d147d9725$export$624e501d81f5ffce)(baseStyle, props);
        var finalStyles = Object.assign({}, __css, finalBaseStyle, (0, $17660d9d147d9725$export$2458ce75c8ef9806)(styleProps), sx);
        var computedCSS = (0, $defb23c4cdf9a367$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
};
function $7266bd05a91441ea$export$3817b7a54a07cec7(component, options) {
    var _ref2 = options != null ? options : {}, baseStyle = _ref2.baseStyle, styledOptions = $7266bd05a91441ea$var$_objectWithoutPropertiesLoose(_ref2, $7266bd05a91441ea$var$_excluded2);
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = $7266bd05a91441ea$export$3ba67b570e26eea0;
    var styleObject = $7266bd05a91441ea$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    return (0, $c2147514e287c11e$export$2e2bcd8739ae039)(component, styledOptions)(styleObject);
}
var $7266bd05a91441ea$export$7cd122d781af9fa4 = $7266bd05a91441ea$export$3817b7a54a07cec7;
$7266bd05a91441ea$var$domElements.forEach(function(tag) {
    $7266bd05a91441ea$export$7cd122d781af9fa4[tag] = $7266bd05a91441ea$export$7cd122d781af9fa4(tag);
});
/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */ function $7266bd05a91441ea$export$257a8862b851cb5b(component) {
    return /*#__PURE__*/ $denZA.forwardRef(component);
}
var $7266bd05a91441ea$var$_excluded = [
    "styleConfig"
];
function $7266bd05a91441ea$export$b863f77547fbcb03(themeKey, props, opts) {
    var _styleConfig$defaultP;
    if (props === void 0) props = {};
    if (opts === void 0) opts = {};
    var _props = props, styleConfigProp = _props.styleConfig, rest = $7266bd05a91441ea$var$_objectWithoutPropertiesLoose(_props, $7266bd05a91441ea$var$_excluded);
    var _useChakra = $7266bd05a91441ea$export$a513a93efd9ab8a7(), theme = _useChakra.theme, colorMode = _useChakra.colorMode;
    var themeStyleConfig = (0, $17660d9d147d9725$export$1bb32d0c65da6059)(theme, "components." + themeKey);
    var styleConfig = styleConfigProp || themeStyleConfig;
    var mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({
        theme: theme,
        colorMode: colorMode
    }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, (0, $17660d9d147d9725$export$2458ce75c8ef9806)((0, $17660d9d147d9725$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    /**
   * Store the computed styles in a `ref` to avoid unneeded re-computation
   */ var stylesRef = (0, $denZA.useRef)({});
    if (styleConfig) {
        var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;
        var baseStyles = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
        var variants = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
        var sizes = (0, $17660d9d147d9725$export$624e501d81f5ffce)((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
        var styles = (0, (/*@__PURE__*/$parcel$interopDefault($e5Q7j)))({}, baseStyles, sizes, variants);
        if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) styleConfig.parts.forEach(function(part) {
            var _styles$part;
            styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
        });
        var isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a1c31816786fd039$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $7266bd05a91441ea$export$31cdfe60c085d76f(themeKey, props) {
    return $7266bd05a91441ea$export$b863f77547fbcb03(themeKey, props, {
        isMultiPart: true
    });
}





var $denZA = parcelRequire("denZA");
function $b0bcb0609f0eeaf7$var$_extends() {
    $b0bcb0609f0eeaf7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0bcb0609f0eeaf7$var$_extends.apply(this, arguments);
}
function $b0bcb0609f0eeaf7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b0bcb0609f0eeaf7$var$_excluded = [
    "as",
    "viewBox",
    "color",
    "focusable",
    "children",
    "className",
    "__css"
];
var $b0bcb0609f0eeaf7$var$fallbackIcon = {
    path: /*#__PURE__*/ $denZA.createElement("g", {
        stroke: "currentColor",
        strokeWidth: "1.5"
    }, /*#__PURE__*/ $denZA.createElement("path", {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
    }), /*#__PURE__*/ $denZA.createElement("path", {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
    }), /*#__PURE__*/ $denZA.createElement("circle", {
        fill: "none",
        strokeMiterlimit: "10",
        cx: "12",
        cy: "12",
        r: "11.25"
    })),
    viewBox: "0 0 24 24"
};
var $b0bcb0609f0eeaf7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $7266bd05a91441ea$export$257a8862b851cb5b)(function(props, ref) {
    var element = props.as, viewBox = props.viewBox, _props$color = props.color, color = _props$color === void 0 ? "currentColor" : _props$color, _props$focusable = props.focusable, focusable = _props$focusable === void 0 ? false : _props$focusable, children = props.children, className = props.className, __css = props.__css, rest = $b0bcb0609f0eeaf7$var$_objectWithoutPropertiesLoose(props, $b0bcb0609f0eeaf7$var$_excluded);
    var _className = (0, $17660d9d147d9725$export$a274e22fb40f762e)("chakra-icon", className);
    var styles = $b0bcb0609f0eeaf7$var$_extends({
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color
    }, __css);
    var shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    var _viewBox = viewBox != null ? viewBox : $b0bcb0609f0eeaf7$var$fallbackIcon.viewBox;
    /**
   * If you're using an icon library like `react-icons`.
   * Note: anyone passing the `as` prop, should manage the `viewBox` from the external component
   */ if (element && typeof element !== "string") return /*#__PURE__*/ $denZA.createElement((0, $7266bd05a91441ea$export$7cd122d781af9fa4).svg, $b0bcb0609f0eeaf7$var$_extends({
        as: element
    }, shared, rest));
    var _path = children != null ? children : $b0bcb0609f0eeaf7$var$fallbackIcon.path;
    return /*#__PURE__*/ $denZA.createElement((0, $7266bd05a91441ea$export$7cd122d781af9fa4).svg, $b0bcb0609f0eeaf7$var$_extends({
        verticalAlign: "middle",
        viewBox: _viewBox
    }, shared, rest), _path);
});
if (0, $17660d9d147d9725$export$a866f231438cc228) $b0bcb0609f0eeaf7$export$f04a61298a47a40f.displayName = "Icon";
var $b0bcb0609f0eeaf7$export$2e2bcd8739ae039 = $b0bcb0609f0eeaf7$export$f04a61298a47a40f;
function $b0bcb0609f0eeaf7$export$274edc73af1ae9c8(options) {
    var _options$viewBox = options.viewBox, viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox, pathDefinition = options.d, displayName = options.displayName, _options$defaultProps = options.defaultProps, defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
    var path = $denZA.Children.toArray(options.path);
    var Comp = /*#__PURE__*/ (0, $7266bd05a91441ea$export$257a8862b851cb5b)(function(props, ref) {
        return /*#__PURE__*/ $denZA.createElement($b0bcb0609f0eeaf7$export$f04a61298a47a40f, $b0bcb0609f0eeaf7$var$_extends({
            ref: ref,
            viewBox: viewBox
        }, defaultProps, props), path.length ? path : /*#__PURE__*/ $denZA.createElement("path", {
            fill: "currentColor",
            d: pathDefinition
        }));
    });
    if (0, $17660d9d147d9725$export$a866f231438cc228) Comp.displayName = displayName;
    return Comp;
}




var $denZA = parcelRequire("denZA");
var $64fb02cd5f518c2d$var$__assign = undefined && undefined.__assign || function() {
    $64fb02cd5f518c2d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64fb02cd5f518c2d$var$__assign.apply(this, arguments);
};
var $64fb02cd5f518c2d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $64fb02cd5f518c2d$export$f04a61298a47a40f = (0, $7266bd05a91441ea$export$257a8862b851cb5b)(function(_a, ref) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, _css = _a.css, rest = $64fb02cd5f518c2d$var$__rest(_a, [
        "viewBox",
        "css"
    ]);
    return $denZA.createElement((0, $b0bcb0609f0eeaf7$export$f04a61298a47a40f), $64fb02cd5f518c2d$var$__assign({
        viewBox: viewBox
    }, rest, {
        ref: ref
    }));
});





var $denZA = parcelRequire("denZA");
var $d5760e4a5c07a8be$var$__assign = undefined && undefined.__assign || function() {
    $d5760e4a5c07a8be$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5760e4a5c07a8be$var$__assign.apply(this, arguments);
};
var $d5760e4a5c07a8be$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d5760e4a5c07a8be$export$e3651bf6c44a974e = (0, $7266bd05a91441ea$export$257a8862b851cb5b)(function(props, ref) {
    var _a = props.boxSize, boxSize = _a === void 0 ? '3rem' : _a, _b = props.viewBox, viewBox = _b === void 0 ? "0 0 40 40" : _b, rest = $d5760e4a5c07a8be$var$__rest(props, [
        "boxSize",
        "viewBox"
    ]);
    return $denZA.createElement((0, $64fb02cd5f518c2d$export$f04a61298a47a40f), $d5760e4a5c07a8be$var$__assign($d5760e4a5c07a8be$var$__assign({
        viewBox: viewBox
    }, rest), {
        boxSize: boxSize
    }), ref, $denZA.createElement("g", null, $denZA.createElement("path", {
        d: "M0.270508 0.266479V39.7322H39.7363L39.736 0.266479H0.270508Z",
        fill: "white"
    }), $denZA.createElement("path", {
        d: "M0.270508 0.266479V39.7322H39.7363V0.266479H0.270508ZM37.1105 16.6715C37.0458 17.9012 36.6547 19.4331 36.3089 20.4567C34.9215 24.5803 33.3126 27.1363 29.587 27.1363C28.49 27.1358 26.5446 26.8448 25.8269 24.893L25.6564 24.4301L25.3511 24.817C24.1863 26.2928 22.4549 27.1448 20.6007 27.1531C19.1792 27.1589 18.037 26.6828 17.2979 25.7749L17.0952 25.5257L16.8796 25.7633C16.0902 26.6351 14.7155 27.1347 13.108 27.1347C11.8456 27.1347 10.7556 26.7057 10.0388 25.9276L9.84322 25.7159L9.63974 25.9217C8.84218 26.7266 7.58657 27.1318 6.00697 27.0937C4.09039 27.0494 2.92397 25.9798 2.88643 24.232C2.82886 21.5387 5.43547 15.8726 6.51384 14.1499C7.2146 12.999 8.17783 12.4402 9.45968 12.4402C10.3326 12.4396 10.9295 12.6225 11.2843 12.9987C11.6066 13.3399 11.6701 13.6278 11.6988 14.3212L11.7358 15.2175L12.2099 14.4566C13.3538 12.6129 15.2498 12.3578 17.1288 12.3575C18.4349 12.3575 19.5748 12.8384 20.0323 13.5818L20.2011 13.8566L20.4461 13.6484C21.4146 12.8254 22.7803 12.3724 24.2925 12.3724C25.9429 12.3721 27.1424 12.7825 27.8578 13.5919C28.0209 13.7756 28.1279 13.9043 28.2777 14.2184L28.4612 14.6037L28.7375 14.278C29.7842 13.0388 31.2145 12.4119 32.99 12.4119C34.3952 12.4119 35.4617 12.7842 36.1597 13.5216C37.0345 14.4448 37.1596 15.7439 37.1105 16.6715Z",
        fill: "#FFED00"
    }), $denZA.createElement("path", {
        d: "M0.270508 0.266479V39.7322H39.7363V0.266479H0.270508ZM38.2219 18.1854C38.0424 19.6219 37.0721 22.2827 36.5562 23.3458C35.1733 26.1968 33.3239 28.3869 29.7631 28.3866C27.8612 28.3863 26.2948 27.7804 25.3807 26.6145C24.0402 27.7877 22.381 28.4044 20.5951 28.4038C19.2187 28.4038 18.002 28.0064 17.0746 27.2712C16.051 27.9926 14.6706 28.3945 13.1404 28.3942C11.862 28.3942 10.7111 28.0437 9.81077 27.3949C8.8148 28.0558 7.51009 28.3838 5.97762 28.3479C3.42802 28.2873 1.66779 26.6701 1.61784 24.3229C1.55067 21.2046 4.1776 15.4964 5.41515 13.5197C6.34197 11.9982 7.75534 11.1786 9.48762 11.1786C11.3684 11.1786 12.0502 11.716 12.3855 12.4001C13.8364 11.1682 15.7595 11.0971 17.1294 11.0973C18.6404 11.0973 19.5889 11.4984 20.3969 12.1404C21.51 11.4721 22.7882 11.1239 24.3111 11.1239C26.2573 11.1236 27.7034 11.5766 28.7115 12.5742C29.8889 11.5952 31.3613 11.1484 33.01 11.1484C35.1911 11.1487 36.6248 11.935 37.4661 13.1071C38.6528 14.7612 38.4411 16.4257 38.2219 18.1854Z",
        fill: "#E3000B"
    }), $denZA.createElement("path", {
        d: "M0 0V40L39.9994 39.9994L40 0H0ZM39.4494 0.550617L39.4488 39.4491H0.550899L0.550334 0.550617H39.4494Z",
        fill: "black"
    }), $denZA.createElement("path", {
        d: "M38.0299 12.0024V11.7303L38.215 11.7298C38.3502 11.7298 38.4196 11.7774 38.4196 11.8649C38.4216 11.9349 38.3759 12.0024 38.2373 12.0024H38.0299ZM38.6931 12.5674L38.5785 12.3676C38.4783 12.1929 38.4501 12.1652 38.3652 12.1356L38.3646 12.1302C38.5322 12.1102 38.6336 12.0024 38.633 11.8522C38.633 11.695 38.5331 11.5759 38.32 11.5759H37.8256V12.5685H38.0302L38.0307 12.1621L38.0671 12.1618C38.1552 12.1618 38.191 12.172 38.2303 12.2126C38.2715 12.2527 38.331 12.3363 38.3654 12.4068L38.4447 12.5691L38.6931 12.5674ZM38.2051 11.2982C38.6313 11.2985 38.9779 11.6417 38.9767 12.0679C38.9779 12.494 38.6302 12.8383 38.2051 12.8383C37.7801 12.8383 37.4378 12.4929 37.4378 12.0679C37.4378 11.6417 37.779 11.2982 38.2051 11.2982ZM38.2051 11.1086C37.6754 11.1086 37.2476 11.5364 37.2476 12.067C37.2476 12.5979 37.6748 13.0249 38.2051 13.0252C38.736 13.0252 39.1641 12.5982 39.1641 12.067C39.1641 11.5367 38.736 11.1086 38.2051 11.1086Z",
        fill: "black"
    }), $denZA.createElement("path", {
        d: "M32.9891 12.1359C30.9215 12.1359 29.4918 12.9557 28.5255 14.1001C28.3623 13.7581 28.2382 13.6076 28.0635 13.4109C27.2715 12.5149 25.9993 12.0983 24.2915 12.098C22.623 12.098 21.2323 12.619 20.2665 13.4397C19.7647 12.6244 18.5686 12.0851 17.1279 12.0851C15.2446 12.0848 13.1923 12.3515 11.9745 14.3135C11.9451 13.6068 11.8814 13.2337 11.4843 12.8135C11.0014 12.3021 10.2202 12.1697 9.45961 12.1692C8.0739 12.1697 7.0308 12.7748 6.27953 14.0076C5.19127 15.7452 2.55136 21.4678 2.61035 24.2398C2.64986 26.0305 3.851 27.3206 6.00097 27.3719C7.67963 27.4114 8.99733 26.9624 9.8361 26.1166C10.5885 26.9339 11.7352 27.4126 13.1085 27.4134C14.6373 27.4129 16.1754 26.9537 17.0841 25.9504C17.8498 26.8907 19.0543 27.438 20.6029 27.4304C22.6295 27.4205 24.407 26.4601 25.5697 24.9886C26.2064 26.7239 27.8222 27.4129 29.5877 27.4126C33.4567 27.4129 35.1566 24.7526 36.5722 20.5458C36.8908 19.599 37.3173 18.0157 37.387 16.6867C37.5041 14.4758 36.568 12.1359 32.9891 12.1359ZM7.24501 22.7122C9.24795 22.3647 9.75002 23.0884 9.68652 23.7586C9.49771 25.7635 7.65734 26.2123 6.05939 26.175C4.9003 26.1479 3.85693 25.6168 3.82842 24.2711C3.7779 21.9168 6.17905 16.4702 7.30964 14.6646C7.83119 13.8083 8.4676 13.3838 9.48219 13.3841C10.4426 13.3838 10.6814 13.8775 10.6661 14.4698C10.6297 16.0458 8.08124 20.8393 7.24501 22.7122ZM13.7641 20.863C13.6309 21.2217 13.3803 21.973 13.1779 22.7677C13.8352 22.6038 14.3274 22.4903 15.171 22.5098C16.1331 22.5335 16.7486 22.9317 16.7483 23.7276C16.7483 25.6552 14.6164 26.2213 13.1392 26.2219C11.5159 26.2219 10.0895 25.2984 10.0895 23.5233C10.0895 21.4419 11.2176 18.2858 12.2762 16.1846C13.5758 13.6034 14.9045 13.2605 17.192 13.2605C18.1975 13.2605 19.3555 13.6898 19.3555 14.6392C19.3555 15.9552 18.2424 16.457 17.1369 16.5205C16.6642 16.5476 15.9383 16.5735 15.504 16.5425C15.504 16.5425 15.1348 17.1035 14.7448 18.1015C16.7912 17.8133 17.6596 18.2782 17.3142 19.4612C16.8468 21.0611 15.4605 21.1667 13.7641 20.863ZM23.8301 15.8869C23.2761 15.8866 22.9151 16.2371 22.6451 16.6156C22.0524 17.4487 20.7671 20.7868 20.5665 22.1596C20.4313 23.098 20.8349 23.2904 21.2785 23.2904C21.9892 23.2899 22.7867 22.5375 23.0591 21.2962C23.0591 21.2962 21.7053 21.2635 22.0784 20.0632C22.441 18.8979 23.1291 18.6462 24.2695 18.599C26.5163 18.5068 26.2948 20.1665 26.115 21.051C25.5308 23.9249 23.4869 26.2315 20.5941 26.2315C18.6132 26.2315 17.3841 25.1362 17.3844 23.1163C17.3841 21.6781 18.097 19.4195 18.6632 18.0981C19.868 15.2846 21.1309 13.3167 24.3488 13.3167C26.2792 13.3167 27.8021 14.0107 27.5783 15.8183C27.4146 17.1456 26.75 17.9251 25.5438 18.0191C25.2065 18.0459 23.8248 18.0114 24.2822 16.7048C24.4434 16.2459 24.5091 15.8869 23.8301 15.8869ZM35.9821 18.2615C35.6409 19.9551 34.8763 21.9595 34.0457 23.453C32.6902 25.8894 31.046 26.2306 29.6083 26.2126C28.1718 26.1953 26.5519 25.6656 26.5397 23.4482C26.531 21.8573 27.2171 19.61 27.7999 18.1387C28.8167 15.4698 29.8536 13.2932 33.1356 13.3322C36.9617 13.3768 36.2792 16.7801 35.9821 18.2615ZM33.253 16.5927C33.212 17.6146 31.7146 21.7021 31.1826 22.6032C30.9523 22.9949 30.6926 23.3175 30.2236 23.3172C29.8166 23.3172 29.6315 23.0277 29.621 22.6961C29.5923 21.7738 31.285 17.151 31.8633 16.3994C32.1207 16.0017 32.4069 15.938 32.7359 15.9428C33.216 15.9484 33.2651 16.295 33.253 16.5927Z",
        fill: "black"
    })));
});
$d5760e4a5c07a8be$export$e3651bf6c44a974e.displayName = 'LegoLogo';






const $8ba084a8754e871c$var$devMarkStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    left: '42%',
    top: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size1,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM2,
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue90,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.size2,
        top: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5,
        left: '48%'
    }
});
const $8ba084a8754e871c$var$logoWrapper = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    cursor: 'pointer',
    ':hover': {
        color: 'inherit'
    }
});
const $8ba084a8754e871c$var$userWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    right: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size6,
    textAlign: 'right',
    color: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).boldColors.lightBlue.lightBlue50,
    fontWeight: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).weight.medium
});
const $8ba084a8754e871c$var$rolesStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    position: 'absolute',
    right: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    top: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size12,
    fontSize: (0, $b274acb0dd1693ab$export$a74e2025f5286b02).size.sizeM2,
    fontStyle: 'italic'
});
const $8ba084a8754e871c$export$8b251419efc915eb = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const { name: name, roles: roles } = (0, $b92321121d608eea$export$23bbbc4533528f03)();
    const handleLogoClick = ()=>{
        history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
    };
    const handleSignOut = async ()=>{
        await (0, $bd4b1dc9807d6e1d$export$334c29725a78c21d).signOut();
        $parcel$global.window.location.reload();
    };
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $00264449fc63853c$export$42a852a2b6b56249), {
        maxW: "100%",
        bg: "#0A2C47",
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77), {
            isFullWidth: true,
            bg: "#0A2C47",
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $6c17e076bc3c1336$export$28c660c63b792dea), {
                    content: "Back to overview",
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77).Brand, {
                        "data-testid": "legoLogo",
                        onClick: handleLogoClick,
                        css: $8ba084a8754e871c$var$logoWrapper,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $d5760e4a5c07a8be$export$e3651bf6c44a974e), {
                                mr: "24px"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $a19c61bc3a46cfb9$export$5f1af8db9871e1d6), {
                                children: "MCP"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77).Segment, {
                    children: roles && roles.includes('admin') && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $41a51eaa02a848ea$export$538041dc783f7abd), {})
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $20cfa76b632e71e2$export$42cfbb80f7861e77).Segment, {
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            css: $8ba084a8754e871c$var$devMarkStyle,
                            children: "staging"
                        }),
                        name && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                            css: $8ba084a8754e871c$var$userWrapperStyle,
                            children: [
                                name,
                                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ff0be911914f8500$export$c25acd513dcc8062), {
                                    variant: "ghost",
                                    title: "Sign Out",
                                    icon: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0866d530aa5f91de$export$f292abd37582246c), {}),
                                    onClick: handleSignOut,
                                    alignSelf: "center",
                                    "aria-label": "Sign Out",
                                    color: "inherit"
                                })
                            ]
                        }),
                        roles && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                            css: $8ba084a8754e871c$var$rolesStyle,
                            children: roles.join(', ')
                        })
                    ]
                })
            ]
        })
    });
};


const $f6ab213034783aaf$var$layoutWrapperStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
});
const $f6ab213034783aaf$var$mainStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    flexGrow: 1,
    backgroundColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.white,
    padding: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size4,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).large]: {
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size4}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size12}px ${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size16 * 2}px`
    }
});
function $f6ab213034783aaf$export$5eefa8b5d1087514(Component) {
    function WithMainLayout({ ...props }) {
        return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
            css: $f6ab213034783aaf$var$layoutWrapperStyle,
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $8ba084a8754e871c$export$8b251419efc915eb), {}),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("main", {
                    css: $f6ab213034783aaf$var$mainStyle,
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)(Component, {
                        ...props
                    })
                })
            ]
        });
    }
    WithMainLayout.displayName = `WithMainLayout(${Component.displayName || Component.name || 'Component'})`;
    return WithMainLayout;
}




var $denZA = parcelRequire("denZA");






















const $4c8077ad4c979295$var$assessmentReviewStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    maxWidth: '768px',
    margin: 'auto',
    padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).small}px`,
    [(0, $afd4d1d9630ef27f$export$987d49ffe1b0900f).medium]: {
        padding: `${(0, $a8ddc88815af1a66$export$5458b64234d1333c).size10 * 2}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).medium}px ${(0, $eca06d1b9813a83c$export$6f98e8eaf0be1996).large}px`
    }
});
const $4c8077ad4c979295$var$sectionContainerStyle = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10,
    paddingBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size10
});
const $4c8077ad4c979295$var$actionButtonsWrapper = (0, $02d9e7d4bf2d70ef$export$2e2bcd8739ae039)({
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size8,
    marginBottom: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size16,
    'button:first-of-type': {
        marginRight: (0, $a8ddc88815af1a66$export$5458b64234d1333c).size5
    }
});
const $4c8077ad4c979295$export$62181a247fdd9443 = ()=>{
    const history = (0, $32ee599feb5ae61e$export$3420e1dc2c4a518c)();
    const { customerId: customerId, assessmentYear: assessmentYear, version: version } = (0, $32ee599feb5ae61e$export$99eaa27ddbbb95ef)();
    const [isProofWarningModalVisible, setIsProofWarningModalVisible] = (0, $denZA.useState)(false);
    const { data: reviewData, loading: isReviewPageLoading, error: reviewDataError } = (0, $367246b9cce32bfd$export$dd0a697e1782aedd)((0, $3583fd120271f7a3$export$ead77c084e8e01bb), {
        variables: {
            customerId: customerId,
            year: Number(assessmentYear),
            version: Number(version)
        },
        fetchPolicy: 'network-only'
    });
    const [finishSurvey, { loading: finishSurveyLoading }] = (0, $9c9f7b47eb4524c9$export$609860bf8b0084c)((0, $3583fd120271f7a3$export$42d41fcb8525466c), {
        onCompleted: handleFinishSurveyResponse
    });
    const { uploadedImagesKeys: uploadedImagesKeys } = (0, $7b4991cbe8665793$export$7eed34e4e2038bc2)({
        uploadId: reviewData?.getSurveyInfo?.uploadId,
        skip: !reviewData
    });
    async function submitSurvey() {
        try {
            await finishSurvey({
                variables: {
                    customerId: customerId,
                    year: Number(assessmentYear),
                    version: Number(version)
                }
            });
        } catch (error) {
            (0, $bbc835f66a22fb9d$export$8d89fee11b80c3f9)(error);
        }
    }
    async function handleFinishSurvey() {
        if ((0, $f86acbd1c72b687f$export$3e14b0f9f411cc85)(enhancedQuestions)) {
            setIsProofWarningModalVisible(true);
            return;
        }
        await submitSurvey();
    }
    function handleFinishSurveyResponse(response) {
        if (response.finishSurvey) {
            const { getSurveyInfo: { customerDetail: { name: name } } } = reviewData;
            (0, $41263b671f20f58e$export$2791228263505492)({
                header: (0, $bacbba0a13f46eeb$export$60d4ee6105aea05).successHeader,
                text: `${name}'s assessment was submitted.`,
                type: (0, $525afb211ce04815$export$628738c5f3e0b7f2).SUCCESS
            });
            history.push((0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).overview);
        }
    }
    // Error boundary catches this error
    if (reviewDataError) throw reviewDataError;
    if (isReviewPageLoading || finishSurveyLoading) return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $27593c6fdecfcced$export$2765eed43ca49790), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $97dcf9f609028572$export$7f7cbe89f1eacd2), {})
    });
    const { getAnswers: savedAnswers, getSurvey: questions, getSurveyInfo: { surveyState: assessmentState, assessmentStatus: assessmentStatus, customerDetail: customerDetail } } = reviewData;
    const surveyDetailsForFeatureFlag = {
        year: Number(assessmentYear),
        channel: customerDetail.channel
    };
    let enhancedQuestions = (0, $f86acbd1c72b687f$export$3ac154c70d0babda)(questions, savedAnswers, uploadedImagesKeys);
    enhancedQuestions = (0, $f86acbd1c72b687f$export$386fc8b17cd02a9b)(enhancedQuestions, surveyDetailsForFeatureFlag);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
        children: [
            isProofWarningModalVisible && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $c3084d40a40fb7e5$export$1de3a04236fd9c26), {
                onClose: ()=>{
                    setIsProofWarningModalVisible(false);
                },
                onConfirm: ()=>{
                    setIsProofWarningModalVisible(false);
                    history.push(`${(0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoring(customerId, assessmentYear, version)}?mode=edit`);
                }
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                type: "h1",
                text: "Review assessment"
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $0fb6090404c8eff1$export$bfe9facc54fa2d94), {
                assessmentInfo: reviewData.getSurveyInfo
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $denZA.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                        css: $4c8077ad4c979295$var$assessmentReviewStyle,
                        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3463068a6fe77df4$export$ed8ca599049e8881), {
                            activeColor: (0, $a8152c9d3f9ec984$export$8f45430ccf837300).neutralColors.slate60,
                            children: enhancedQuestions.map((question)=>{
                                const { questionId: questionId, headline: headline, savedAnswer: savedAnswer, questionImageKeys: questionImageKeys, proofRequirement: proofRequirement } = question;
                                return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $72bcf3aff0a4f9bd$export$fd55ce593607084a), {
                                    stepId: questionId,
                                    header: headline,
                                    isValid: savedAnswer.isValid,
                                    isWarning: proofRequirement.isProofMissing,
                                    isComplete: savedAnswer.isComplete,
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $726cdaf74220d6db$export$bbe70a48ee7ad0f5), {
                                        question: question,
                                        answer: savedAnswer,
                                        uploadImageKeys: questionImageKeys
                                    })
                                }, questionId);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b0459eaa6dae80b0$export$2e0a83ec2e27ecbb), {}),
                    /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                        css: $4c8077ad4c979295$var$sectionContainerStyle,
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $17c85406e190f8b6$export$a8a3e93435678ff9), {
                                type: "h2",
                                text: "Score"
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $78b8667b7afe5597$export$6addd58703e5f916), {
                                scoreText: "The calculated functional discount score is:",
                                score: assessmentState.score
                            })
                        ]
                    }),
                    (0, $f86acbd1c72b687f$export$3e14b0f9f411cc85)(enhancedQuestions) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e0a384f5fee972ef$export$f68959556d5a9913), {})
                ]
            }),
            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)("div", {
                css: $4c8077ad4c979295$var$sectionContainerStyle,
                children: (assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).ASSESSMENT || assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).SELF_ASSESSMENT || assessmentStatus === (0, $d306a6c16d4d2f55$export$ec20f6c706ba3a34).RE_ASSESSMENT) && (0, $f86acbd1c72b687f$export$ce968a13e2c6e586)(savedAnswers) && /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)("div", {
                    css: $4c8077ad4c979295$var$actionButtonsWrapper,
                    children: [
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$a6c7ac8248d6e38a), {
                            to: {
                                pathname: (0, $71104ed1755b5aaa$export$66b32f6f30eb4b4).scoring(customerId, assessmentYear, version),
                                search: '?mode=edit'
                            },
                            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                                label: "Edit",
                                "data-transaction-name": "Edit assessment",
                                variant: "outline"
                            })
                        }),
                        /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $42d1cd4b7ec0f526$export$353f5b6fc5456de1), {
                            label: "Submit assessment",
                            "data-transaction-name": "Submit assessment - from review",
                            onClick: handleFinishSurvey
                        })
                    ]
                })
            })
        ]
    });
};




var $denZA = parcelRequire("denZA");
'use client';
const $4db2dfb4b7f99a53$export$b16d9fb1a22de840 = (0, $denZA.createContext)(null);
const $4db2dfb4b7f99a53$var$initialState = {
    didCatch: false,
    error: null
};
class $4db2dfb4b7f99a53$export$e926676385687eaf extends (0, $denZA.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $4db2dfb4b7f99a53$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($4db2dfb4b7f99a53$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $4db2dfb4b7f99a53$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($4db2dfb4b7f99a53$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $denZA.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $denZA.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $denZA.createElement)($4db2dfb4b7f99a53$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $4db2dfb4b7f99a53$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $4db2dfb4b7f99a53$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $4db2dfb4b7f99a53$export$c052f6604b7d51fe() {
    const context = (0, $denZA.useContext)($4db2dfb4b7f99a53$export$b16d9fb1a22de840);
    $4db2dfb4b7f99a53$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $denZA.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $denZA.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $4db2dfb4b7f99a53$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $denZA.forwardRef)((props, ref)=>(0, $denZA.createElement)($4db2dfb4b7f99a53$export$e926676385687eaf, errorBoundaryProps, (0, $denZA.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}


const $71104ed1755b5aaa$export$66b32f6f30eb4b4 = {
    overview: '/overview',
    assessmentMgmt: '/admin/assessment-management',
    channelSurveyUpload: '/admin/channel-survey-upload',
    details: (customerId, assessmentYear, version)=>`/customer/${customerId}/assessment-details/${assessmentYear}/${version}`,
    scoring: (customerId, assessmentYear, version)=>`/customer/${customerId}/assessment-scoring/${assessmentYear}/${version}`,
    complete: (customerId, assessmentYear, version)=>`/customer/${customerId}/assessment-complete/${assessmentYear}/${version}`,
    scoringReview: (customerId, assessmentYear, version)=>`/customer/${customerId}/assessment-scoring/${assessmentYear}/${version}/review`
};
const $71104ed1755b5aaa$export$22b81d23ee288e7e = ()=>{
    const location = (0, $32ee599feb5ae61e$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4db2dfb4b7f99a53$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ddb7f704ebbcf402$export$c120a0e80fd44ca6), {
            withBackToOverviewButton: true
        }),
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $32ee599feb5ae61e$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    exact: true,
                    path: "/",
                    component: ()=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $32ee599feb5ae61e$export$2d8d895a0a0f636e), {
                            to: $71104ed1755b5aaa$export$66b32f6f30eb4b4.overview
                        })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $32ee599feb5ae61e$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: $71104ed1755b5aaa$export$66b32f6f30eb4b4.assessmentMgmt,
                    render: (props)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4db2dfb4b7f99a53$export$e926676385687eaf), {
                            fallback: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ddb7f704ebbcf402$export$c120a0e80fd44ca6), {}),
                            children: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $bfe2459e444ec9cb$export$43c12f6bb2f865a0))(props)
                        })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $32ee599feb5ae61e$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: $71104ed1755b5aaa$export$66b32f6f30eb4b4.channelSurveyUpload,
                    render: (props)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4db2dfb4b7f99a53$export$e926676385687eaf), {
                            fallback: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ddb7f704ebbcf402$export$c120a0e80fd44ca6), {}),
                            children: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $69d5ad048cd4edc0$export$542eedeb52ec712b))(props)
                        })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $32ee599feb5ae61e$export$e7b0ac011bb776c6), {
                    exact: true,
                    path: $71104ed1755b5aaa$export$66b32f6f30eb4b4.overview,
                    render: (props)=>/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4db2dfb4b7f99a53$export$e926676385687eaf), {
                            fallback: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ddb7f704ebbcf402$export$c120a0e80fd44ca6), {}),
                            children: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $2b2f6d62e3d02216$export$a43a16ae3610c20c))(props)
                        })
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    exact: true,
                    path: "/customer/:customerId/assessment-details/:assessmentYear/:version",
                    component: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $f286198143a4010d$export$ae2ad8b34c337c8c))
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    exact: true,
                    path: "/customer/:customerId/assessment-scoring/:assessmentYear/:version",
                    component: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $98aa489a161c70b9$export$e8189ed768572ea9))
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    exact: true,
                    path: "/customer/:customerId/assessment-scoring/:assessmentYear/:version/review",
                    component: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $4c8077ad4c979295$export$62181a247fdd9443))
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    exact: true,
                    path: "/customer/:customerId/assessment-complete/:assessmentYear/:version",
                    component: (0, $f6ab213034783aaf$export$5eefa8b5d1087514)((0, $af40da3327e4e3c0$export$1b4d0e655b136998))
                }),
                /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $202c0fb36afa19ba$export$e950e0dbcf10755d), {
                    path: "*",
                    component: (0, $2bf02e14d5a6fd9c$export$a65c2c055de52e1d)
                })
            ]
        })
    }, location.pathname);
};









var $denZA = parcelRequire("denZA");
function $a0a71f0e74b7a500$var$f() {
    return `usersnapCallback_${Math.random().toString().slice(2)}`;
}
function $a0a71f0e74b7a500$var$c(e, a, t) {
    return new Promise((n)=>{
        const o = $a0a71f0e74b7a500$var$f();
        if (e) {
            const d = t ? `&n=${t}` : "", w = `//widget.usersnap.com/${a}/load/${e}?onload=${o}${d}`;
            if (!window[o]) {
                window[o] = (l)=>(delete window[o], n(l));
                const r = document.createElement("script");
                r.defer = !0, r.nonce = t, r.onerror = ()=>{
                    throw new Error("Wrong api key or paused project");
                }, r.src = w, document.head.appendChild(r);
            }
        }
    });
}
const $a0a71f0e74b7a500$var$s = /* @__PURE__ */ new Map(), $a0a71f0e74b7a500$var$i = /* @__PURE__ */ new Map(), $a0a71f0e74b7a500$export$f7ac662e3dcd60ac = async (e, a)=>{
    if (!e) throw new Error("Missing api key");
    $a0a71f0e74b7a500$var$s.has(e) || $a0a71f0e74b7a500$var$s.set(e, $a0a71f0e74b7a500$var$c(e, "global", a));
    const t = await $a0a71f0e74b7a500$var$s.get(e);
    return {
        init: async (n)=>{
            await t.init(n);
        },
        logEvent: async (n)=>{
            await t.logEvent(n);
        },
        show: async (n)=>await t.show(n),
        hide: async (n)=>{
            await t.hide(n);
        },
        destroy: async ()=>{
            await t.destroy();
        },
        on: (n, o)=>{
            t.on(n, o);
        },
        off: (n, o)=>{
            t.off(n, o);
        }
    };
}, $a0a71f0e74b7a500$export$e699215886058999 = async (e, a)=>{
    if (!e) throw new Error("Missing api key");
    $a0a71f0e74b7a500$var$i.has(e) || $a0a71f0e74b7a500$var$i.set(e, $a0a71f0e74b7a500$var$c(e, "embed", a));
    const t = await $a0a71f0e74b7a500$var$i.get(e);
    return {
        init: async (n)=>{
            await t.init(n);
        },
        on: (n, o)=>{
            t.on(n, o);
        },
        off: (n, o)=>{
            t.off(n, o);
        }
    };
};



var $cvFNP = parcelRequire("cvFNP");
const $e3a60ef34bc9eaf1$var$USERSNAP_GLOBAL_API_KEY = "5157cfdb-7c51-4dfc-ad64-2edceffb08bd" ?? '';
const $e3a60ef34bc9eaf1$var$USERSNAP_PROJECT_API_KEY = "3d373f5c-5e8d-4f2e-9a46-8599f25c0c50" ?? '';
const $e3a60ef34bc9eaf1$export$28b248b721cb7b23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($denZA))).createContext(null);
const $e3a60ef34bc9eaf1$export$472eaa5d961027f3 = ({ initParams: initParams, children: children })=>{
    const [usersnapApi, setUsersnapApi] = (0, $denZA.useState)(null);
    (0, $denZA.useEffect)(()=>{
        (0, $a0a71f0e74b7a500$export$f7ac662e3dcd60ac)($e3a60ef34bc9eaf1$var$USERSNAP_GLOBAL_API_KEY).then((api)=>{
            api.init(initParams);
            api.show($e3a60ef34bc9eaf1$var$USERSNAP_PROJECT_API_KEY);
            setUsersnapApi(api);
        });
    }, [
        initParams
    ]);
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)($e3a60ef34bc9eaf1$export$28b248b721cb7b23.Provider, {
        value: usersnapApi,
        children: children
    });
};
function $e3a60ef34bc9eaf1$export$52a275d2f63a445a() {
    return (0, $denZA.useContext)($e3a60ef34bc9eaf1$export$28b248b721cb7b23);
}
$e3a60ef34bc9eaf1$export$472eaa5d961027f3.propTypes = {
    initParams: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cvFNP))).node
};




function $333510a4e593ef95$var$fallbackRender({ error: error }) {
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $ddb7f704ebbcf402$export$c120a0e80fd44ca6), {
        withBackToOverviewButton: false,
        error: error
    });
}
const $333510a4e593ef95$export$86fbec116b87613f = ()=>{
    // Init error logging to Elastic APM
    (0, $701a617efab9f26c$export$af88d00dbe7f521).init();
    return /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $a9513ca373e01b66$export$21c472c8a0d1544e), {
        children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $f5559b6a89ee1e6c$export$c2fe1be989122f41), {
            children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $4db2dfb4b7f99a53$export$e926676385687eaf), {
                fallbackRender: $333510a4e593ef95$var$fallbackRender,
                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $3612b1be3096e797$export$8e363dbef886ff17), {
                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$25062201e9e25d76)((0, $b92321121d608eea$export$88f24fd8fcfab6ca), {
                        children: [
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $b1500a705028f634$export$f2815235e76a62b9), {
                                ...(0, $d6b6ea7cd62267ef$export$d27e4189c1f0e8f4)
                            }),
                            /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $e3a60ef34bc9eaf1$export$472eaa5d961027f3), {
                                children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $53a8aaf8c02cd9f8$export$9ba4e89fdfa1fc54), {
                                    children: /*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $71104ed1755b5aaa$export$22b81d23ee288e7e), {})
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};


(0, $d486a8928008256a$exports.render)(/*#__PURE__*/ (0, $3065b8940bbf3845$export$34b9dba7ce09269b)((0, $333510a4e593ef95$export$86fbec116b87613f), {}), document.getElementById('root'));


//# sourceMappingURL=public.4b29d27a.js.map
